var Tme = Object.defineProperty;
var _me = (t, e, n) => e in t ? Tme(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var Xj = (t, e, n) => (_me(t, typeof e != "symbol" ? e + "" : e, n), n);
import * as On from "react";
import Ge, { createContext as s_, useContext as nc, forwardRef as bs, useCallback as Ei, useRef as dr, useState as kn, useImperativeHandle as Nl, useEffect as Vn, cloneElement as $I, useLayoutEffect as l_, Children as Wee, createElement as fu, Fragment as r0, useMemo as Mc, Component as Qee, PureComponent as jee, createRef as Cme } from "react";
var $b = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Pl(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function na(t) {
  if (t.__esModule)
    return t;
  var e = t.default;
  if (typeof e == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    n.prototype = e.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(t).forEach(function(r) {
    var a = Object.getOwnPropertyDescriptor(t, r);
    Object.defineProperty(n, r, a.get ? a : {
      enumerable: !0,
      get: function() {
        return t[r];
      }
    });
  }), n;
}
var dF = { exports: {} }, iw = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var qj;
function xme() {
  if (qj)
    return iw;
  qj = 1;
  var t = Ge, e = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, a = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(s, u, f) {
    var p, m = {}, v = null, O = null;
    f !== void 0 && (v = "" + f), u.key !== void 0 && (v = "" + u.key), u.ref !== void 0 && (O = u.ref);
    for (p in u)
      r.call(u, p) && !i.hasOwnProperty(p) && (m[p] = u[p]);
    if (s && s.defaultProps)
      for (p in u = s.defaultProps, u)
        m[p] === void 0 && (m[p] = u[p]);
    return { $$typeof: e, type: s, key: v, ref: O, props: m, _owner: a.current };
  }
  return iw.Fragment = n, iw.jsx = o, iw.jsxs = o, iw;
}
var ow = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Kj;
function Ame() {
  return Kj || (Kj = 1, process.env.NODE_ENV !== "production" && function() {
    var t = Ge, e = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), f = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), m = Symbol.for("react.memo"), v = Symbol.for("react.lazy"), O = Symbol.for("react.offscreen"), w = Symbol.iterator, _ = "@@iterator";
    function C(xe) {
      if (xe === null || typeof xe != "object")
        return null;
      var xt = w && xe[w] || xe[_];
      return typeof xt == "function" ? xt : null;
    }
    var A = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function N(xe) {
      {
        for (var xt = arguments.length, jt = new Array(xt > 1 ? xt - 1 : 0), Sn = 1; Sn < xt; Sn++)
          jt[Sn - 1] = arguments[Sn];
        P("error", xe, jt);
      }
    }
    function P(xe, xt, jt) {
      {
        var Sn = A.ReactDebugCurrentFrame, Yn = Sn.getStackAddendum();
        Yn !== "" && (xt += "%s", jt = jt.concat([Yn]));
        var ur = jt.map(function(qn) {
          return String(qn);
        });
        ur.unshift("Warning: " + xt), Function.prototype.apply.call(console[xe], console, ur);
      }
    }
    var I = !1, D = !1, M = !1, H = !1, Y = !1, q;
    q = Symbol.for("react.module.reference");
    function Q(xe) {
      return !!(typeof xe == "string" || typeof xe == "function" || xe === r || xe === i || Y || xe === a || xe === f || xe === p || H || xe === O || I || D || M || typeof xe == "object" && xe !== null && (xe.$$typeof === v || xe.$$typeof === m || xe.$$typeof === o || xe.$$typeof === s || xe.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      xe.$$typeof === q || xe.getModuleId !== void 0));
    }
    function ne(xe, xt, jt) {
      var Sn = xe.displayName;
      if (Sn)
        return Sn;
      var Yn = xt.displayName || xt.name || "";
      return Yn !== "" ? jt + "(" + Yn + ")" : jt;
    }
    function J(xe) {
      return xe.displayName || "Context";
    }
    function ue(xe) {
      if (xe == null)
        return null;
      if (typeof xe.tag == "number" && N("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof xe == "function")
        return xe.displayName || xe.name || null;
      if (typeof xe == "string")
        return xe;
      switch (xe) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case f:
          return "Suspense";
        case p:
          return "SuspenseList";
      }
      if (typeof xe == "object")
        switch (xe.$$typeof) {
          case s:
            var xt = xe;
            return J(xt) + ".Consumer";
          case o:
            var jt = xe;
            return J(jt._context) + ".Provider";
          case u:
            return ne(xe, xe.render, "ForwardRef");
          case m:
            var Sn = xe.displayName || null;
            return Sn !== null ? Sn : ue(xe.type) || "Memo";
          case v: {
            var Yn = xe, ur = Yn._payload, qn = Yn._init;
            try {
              return ue(qn(ur));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var ee = Object.assign, fe = 0, de, ie, le, ye, B, pe, _e;
    function Z() {
    }
    Z.__reactDisabledLog = !0;
    function ce() {
      {
        if (fe === 0) {
          de = console.log, ie = console.info, le = console.warn, ye = console.error, B = console.group, pe = console.groupCollapsed, _e = console.groupEnd;
          var xe = {
            configurable: !0,
            enumerable: !0,
            value: Z,
            writable: !0
          };
          Object.defineProperties(console, {
            info: xe,
            log: xe,
            warn: xe,
            error: xe,
            group: xe,
            groupCollapsed: xe,
            groupEnd: xe
          });
        }
        fe++;
      }
    }
    function j() {
      {
        if (fe--, fe === 0) {
          var xe = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: ee({}, xe, {
              value: de
            }),
            info: ee({}, xe, {
              value: ie
            }),
            warn: ee({}, xe, {
              value: le
            }),
            error: ee({}, xe, {
              value: ye
            }),
            group: ee({}, xe, {
              value: B
            }),
            groupCollapsed: ee({}, xe, {
              value: pe
            }),
            groupEnd: ee({}, xe, {
              value: _e
            })
          });
        }
        fe < 0 && N("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var K = A.ReactCurrentDispatcher, Ee;
    function he(xe, xt, jt) {
      {
        if (Ee === void 0)
          try {
            throw Error();
          } catch (Yn) {
            var Sn = Yn.stack.trim().match(/\n( *(at )?)/);
            Ee = Sn && Sn[1] || "";
          }
        return `
` + Ee + xe;
      }
    }
    var Ae = !1, Te;
    {
      var je = typeof WeakMap == "function" ? WeakMap : Map;
      Te = new je();
    }
    function we(xe, xt) {
      if (!xe || Ae)
        return "";
      {
        var jt = Te.get(xe);
        if (jt !== void 0)
          return jt;
      }
      var Sn;
      Ae = !0;
      var Yn = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ur;
      ur = K.current, K.current = null, ce();
      try {
        if (xt) {
          var qn = function() {
            throw Error();
          };
          if (Object.defineProperty(qn.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(qn, []);
            } catch (Lt) {
              Sn = Lt;
            }
            Reflect.construct(xe, [], qn);
          } else {
            try {
              qn.call();
            } catch (Lt) {
              Sn = Lt;
            }
            xe.call(qn.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Lt) {
            Sn = Lt;
          }
          xe();
        }
      } catch (Lt) {
        if (Lt && Sn && typeof Lt.stack == "string") {
          for (var Rn = Lt.stack.split(`
`), Ba = Sn.stack.split(`
`), ma = Rn.length - 1, ve = Ba.length - 1; ma >= 1 && ve >= 0 && Rn[ma] !== Ba[ve]; )
            ve--;
          for (; ma >= 1 && ve >= 0; ma--, ve--)
            if (Rn[ma] !== Ba[ve]) {
              if (ma !== 1 || ve !== 1)
                do
                  if (ma--, ve--, ve < 0 || Rn[ma] !== Ba[ve]) {
                    var Ye = `
` + Rn[ma].replace(" at new ", " at ");
                    return xe.displayName && Ye.includes("<anonymous>") && (Ye = Ye.replace("<anonymous>", xe.displayName)), typeof xe == "function" && Te.set(xe, Ye), Ye;
                  }
                while (ma >= 1 && ve >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, K.current = ur, j(), Error.prepareStackTrace = Yn;
      }
      var yt = xe ? xe.displayName || xe.name : "", Dt = yt ? he(yt) : "";
      return typeof xe == "function" && Te.set(xe, Dt), Dt;
    }
    function lt(xe, xt, jt) {
      return we(xe, !1);
    }
    function st(xe) {
      var xt = xe.prototype;
      return !!(xt && xt.isReactComponent);
    }
    function Oe(xe, xt, jt) {
      if (xe == null)
        return "";
      if (typeof xe == "function")
        return we(xe, st(xe));
      if (typeof xe == "string")
        return he(xe);
      switch (xe) {
        case f:
          return he("Suspense");
        case p:
          return he("SuspenseList");
      }
      if (typeof xe == "object")
        switch (xe.$$typeof) {
          case u:
            return lt(xe.render);
          case m:
            return Oe(xe.type, xt, jt);
          case v: {
            var Sn = xe, Yn = Sn._payload, ur = Sn._init;
            try {
              return Oe(ur(Yn), xt, jt);
            } catch {
            }
          }
        }
      return "";
    }
    var Re = Object.prototype.hasOwnProperty, Be = {}, mt = A.ReactDebugCurrentFrame;
    function Tt(xe) {
      if (xe) {
        var xt = xe._owner, jt = Oe(xe.type, xe._source, xt ? xt.type : null);
        mt.setExtraStackFrame(jt);
      } else
        mt.setExtraStackFrame(null);
    }
    function ut(xe, xt, jt, Sn, Yn) {
      {
        var ur = Function.call.bind(Re);
        for (var qn in xe)
          if (ur(xe, qn)) {
            var Rn = void 0;
            try {
              if (typeof xe[qn] != "function") {
                var Ba = Error((Sn || "React class") + ": " + jt + " type `" + qn + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof xe[qn] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Ba.name = "Invariant Violation", Ba;
              }
              Rn = xe[qn](xt, qn, Sn, jt, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ma) {
              Rn = ma;
            }
            Rn && !(Rn instanceof Error) && (Tt(Yn), N("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Sn || "React class", jt, qn, typeof Rn), Tt(null)), Rn instanceof Error && !(Rn.message in Be) && (Be[Rn.message] = !0, Tt(Yn), N("Failed %s type: %s", jt, Rn.message), Tt(null));
          }
      }
    }
    var wt = Array.isArray;
    function Yt(xe) {
      return wt(xe);
    }
    function Rt(xe) {
      {
        var xt = typeof Symbol == "function" && Symbol.toStringTag, jt = xt && xe[Symbol.toStringTag] || xe.constructor.name || "Object";
        return jt;
      }
    }
    function Ut(xe) {
      try {
        return He(xe), !1;
      } catch {
        return !0;
      }
    }
    function He(xe) {
      return "" + xe;
    }
    function Ve(xe) {
      if (Ut(xe))
        return N("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Rt(xe)), He(xe);
    }
    var Ie = A.ReactCurrentOwner, it = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, zt, Ht, bt;
    bt = {};
    function Mt(xe) {
      if (Re.call(xe, "ref")) {
        var xt = Object.getOwnPropertyDescriptor(xe, "ref").get;
        if (xt && xt.isReactWarning)
          return !1;
      }
      return xe.ref !== void 0;
    }
    function ln(xe) {
      if (Re.call(xe, "key")) {
        var xt = Object.getOwnPropertyDescriptor(xe, "key").get;
        if (xt && xt.isReactWarning)
          return !1;
      }
      return xe.key !== void 0;
    }
    function ze(xe, xt) {
      if (typeof xe.ref == "string" && Ie.current && xt && Ie.current.stateNode !== xt) {
        var jt = ue(Ie.current.type);
        bt[jt] || (N('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', ue(Ie.current.type), xe.ref), bt[jt] = !0);
      }
    }
    function gt(xe, xt) {
      {
        var jt = function() {
          zt || (zt = !0, N("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", xt));
        };
        jt.isReactWarning = !0, Object.defineProperty(xe, "key", {
          get: jt,
          configurable: !0
        });
      }
    }
    function Bt(xe, xt) {
      {
        var jt = function() {
          Ht || (Ht = !0, N("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", xt));
        };
        jt.isReactWarning = !0, Object.defineProperty(xe, "ref", {
          get: jt,
          configurable: !0
        });
      }
    }
    var Qt = function(xe, xt, jt, Sn, Yn, ur, qn) {
      var Rn = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: xe,
        key: xt,
        ref: jt,
        props: qn,
        // Record the component responsible for creating this element.
        _owner: ur
      };
      return Rn._store = {}, Object.defineProperty(Rn._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Rn, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Sn
      }), Object.defineProperty(Rn, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Yn
      }), Object.freeze && (Object.freeze(Rn.props), Object.freeze(Rn)), Rn;
    };
    function En(xe, xt, jt, Sn, Yn) {
      {
        var ur, qn = {}, Rn = null, Ba = null;
        jt !== void 0 && (Ve(jt), Rn = "" + jt), ln(xt) && (Ve(xt.key), Rn = "" + xt.key), Mt(xt) && (Ba = xt.ref, ze(xt, Yn));
        for (ur in xt)
          Re.call(xt, ur) && !it.hasOwnProperty(ur) && (qn[ur] = xt[ur]);
        if (xe && xe.defaultProps) {
          var ma = xe.defaultProps;
          for (ur in ma)
            qn[ur] === void 0 && (qn[ur] = ma[ur]);
        }
        if (Rn || Ba) {
          var ve = typeof xe == "function" ? xe.displayName || xe.name || "Unknown" : xe;
          Rn && gt(qn, ve), Ba && Bt(qn, ve);
        }
        return Qt(xe, Rn, Ba, Yn, Sn, Ie.current, qn);
      }
    }
    var Mn = A.ReactCurrentOwner, br = A.ReactDebugCurrentFrame;
    function sr(xe) {
      if (xe) {
        var xt = xe._owner, jt = Oe(xe.type, xe._source, xt ? xt.type : null);
        br.setExtraStackFrame(jt);
      } else
        br.setExtraStackFrame(null);
    }
    var Ar;
    Ar = !1;
    function Ji(xe) {
      return typeof xe == "object" && xe !== null && xe.$$typeof === e;
    }
    function po() {
      {
        if (Mn.current) {
          var xe = ue(Mn.current.type);
          if (xe)
            return `

Check the render method of \`` + xe + "`.";
        }
        return "";
      }
    }
    function Ni(xe) {
      {
        if (xe !== void 0) {
          var xt = xe.fileName.replace(/^.*[\\\/]/, ""), jt = xe.lineNumber;
          return `

Check your code at ` + xt + ":" + jt + ".";
        }
        return "";
      }
    }
    var oi = {};
    function gu(xe) {
      {
        var xt = po();
        if (!xt) {
          var jt = typeof xe == "string" ? xe : xe.displayName || xe.name;
          jt && (xt = `

Check the top-level render call using <` + jt + ">.");
        }
        return xt;
      }
    }
    function ho(xe, xt) {
      {
        if (!xe._store || xe._store.validated || xe.key != null)
          return;
        xe._store.validated = !0;
        var jt = gu(xt);
        if (oi[jt])
          return;
        oi[jt] = !0;
        var Sn = "";
        xe && xe._owner && xe._owner !== Mn.current && (Sn = " It was passed a child from " + ue(xe._owner.type) + "."), sr(xe), N('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', jt, Sn), sr(null);
      }
    }
    function Jo(xe, xt) {
      {
        if (typeof xe != "object")
          return;
        if (Yt(xe))
          for (var jt = 0; jt < xe.length; jt++) {
            var Sn = xe[jt];
            Ji(Sn) && ho(Sn, xt);
          }
        else if (Ji(xe))
          xe._store && (xe._store.validated = !0);
        else if (xe) {
          var Yn = C(xe);
          if (typeof Yn == "function" && Yn !== xe.entries)
            for (var ur = Yn.call(xe), qn; !(qn = ur.next()).done; )
              Ji(qn.value) && ho(qn.value, xt);
        }
      }
    }
    function bu(xe) {
      {
        var xt = xe.type;
        if (xt == null || typeof xt == "string")
          return;
        var jt;
        if (typeof xt == "function")
          jt = xt.propTypes;
        else if (typeof xt == "object" && (xt.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        xt.$$typeof === m))
          jt = xt.propTypes;
        else
          return;
        if (jt) {
          var Sn = ue(xt);
          ut(jt, xe.props, "prop", Sn, xe);
        } else if (xt.PropTypes !== void 0 && !Ar) {
          Ar = !0;
          var Yn = ue(xt);
          N("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Yn || "Unknown");
        }
        typeof xt.getDefaultProps == "function" && !xt.getDefaultProps.isReactClassApproved && N("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function vu(xe) {
      {
        for (var xt = Object.keys(xe.props), jt = 0; jt < xt.length; jt++) {
          var Sn = xt[jt];
          if (Sn !== "children" && Sn !== "key") {
            sr(xe), N("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Sn), sr(null);
            break;
          }
        }
        xe.ref !== null && (sr(xe), N("Invalid attribute `ref` supplied to `React.Fragment`."), sr(null));
      }
    }
    function Lo(xe, xt, jt, Sn, Yn, ur) {
      {
        var qn = Q(xe);
        if (!qn) {
          var Rn = "";
          (xe === void 0 || typeof xe == "object" && xe !== null && Object.keys(xe).length === 0) && (Rn += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Ba = Ni(Yn);
          Ba ? Rn += Ba : Rn += po();
          var ma;
          xe === null ? ma = "null" : Yt(xe) ? ma = "array" : xe !== void 0 && xe.$$typeof === e ? (ma = "<" + (ue(xe.type) || "Unknown") + " />", Rn = " Did you accidentally export a JSX literal instead of a component?") : ma = typeof xe, N("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ma, Rn);
        }
        var ve = En(xe, xt, jt, Yn, ur);
        if (ve == null)
          return ve;
        if (qn) {
          var Ye = xt.children;
          if (Ye !== void 0)
            if (Sn)
              if (Yt(Ye)) {
                for (var yt = 0; yt < Ye.length; yt++)
                  Jo(Ye[yt], xe);
                Object.freeze && Object.freeze(Ye);
              } else
                N("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Jo(Ye, xe);
        }
        return xe === r ? vu(ve) : bu(ve), ve;
      }
    }
    function Pi(xe, xt, jt) {
      return Lo(xe, xt, jt, !0);
    }
    function eo(xe, xt, jt) {
      return Lo(xe, xt, jt, !1);
    }
    var es = eo, Fl = Pi;
    ow.Fragment = r, ow.jsx = es, ow.jsxs = Fl;
  }()), ow;
}
process.env.NODE_ENV === "production" ? dF.exports = xme() : dF.exports = Ame();
var Ne = dF.exports;
var Gee = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(t) {
  (function() {
    var e = {}.hasOwnProperty;
    function n() {
      for (var r = [], a = 0; a < arguments.length; a++) {
        var i = arguments[a];
        if (i) {
          var o = typeof i;
          if (o === "string" || o === "number")
            r.push(i);
          else if (Array.isArray(i)) {
            if (i.length) {
              var s = n.apply(null, i);
              s && r.push(s);
            }
          } else if (o === "object") {
            if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]")) {
              r.push(i.toString());
              continue;
            }
            for (var u in i)
              e.call(i, u) && i[u] && r.push(u);
          }
        }
      }
      return r.join(" ");
    }
    t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
  })();
})(Gee);
var iv = Gee.exports;
const pn = /* @__PURE__ */ Pl(iv);
var cM = Ge, kme = function(t) {
  return typeof t == "function";
}, Rme = function(t) {
  var e = cM.useState(t), n = e[0], r = e[1], a = cM.useRef(n), i = cM.useCallback(function(o) {
    a.current = kme(o) ? o(a.current) : o, r(a.current);
  }, []);
  return [n, i, a];
}, Ime = Rme;
const zk = /* @__PURE__ */ Pl(Ime);
let Vee = (t = 21) => crypto.getRandomValues(new Uint8Array(t)).reduce((e, n) => (n &= 63, n < 36 ? e += n.toString(36) : n < 62 ? e += (n - 26).toString(36).toUpperCase() : n > 62 ? e += "-" : e += "_", e), "");
const S0 = s_({});
S0.displayName = "WizardContext";
const Dme = () => nc(S0), ov = s_({}), wXe = ov;
ov.displayName = "WizardStepContext";
const TXe = () => nc(ov);
const sw = "wizard-message", BI = () => {
  const { message: t, active: e, hideMessage: n } = nc(ov);
  return /* @__PURE__ */ Ne.jsxs("div", { className: pn(sw, {
    [`${sw}--with-type`]: t == null ? void 0 : t.type,
    [`${sw}--${t == null ? void 0 : t.type}`]: t == null ? void 0 : t.type
  }), children: [
    /* @__PURE__ */ Ne.jsx("div", { className: `${sw}__content`, children: t == null ? void 0 : t.content }),
    (t == null ? void 0 : t.dismissible) && /* @__PURE__ */ Ne.jsx("i", { className: `${sw}__close`, onClick: n })
  ] });
};
BI.displayName = "Wizard.Message";
const fM = "wizard-step", A5 = bs(
  ({
    className: t,
    children: e,
    onNext: n,
    header: r,
    title: a,
    summary: i,
    enabled: o = !1,
    id: s,
    disableNext: u = !1,
    status: f,
    message: p,
    exclude: m = !1,
    byzRef: v,
    ...O
  }, w) => {
    const _ = Ei((ee) => {
      ne((fe) => ({
        ...fe,
        summary: ee
      }));
    }, []), C = dr(s ?? Vee(5)), {
      activeUid: A,
      enabledUids: N,
      activateNextStep: P,
      activatePreviousStep: I,
      enableStep: D,
      disableStep: M,
      enableNextStep: H,
      enableKeyNavigation: Y,
      disableInactiveStepRendering: q
    } = Dme(), [Q, ne] = kn({
      uid: C.current,
      active: C.current === A,
      enabled: o,
      summary: i,
      setSummary: _,
      status: f,
      message: p,
      showMessage(ee, { type: fe = "info", dismissible: de = !1 } = {}) {
        ne((ie) => ({
          ...ie,
          message: ee
        }));
      },
      hideMessage() {
        ne((ee) => ({
          ...ee,
          message: void 0
        }));
      }
    }), J = dr(null);
    Nl(v, () => ({
      uid: C.current,
      title: a,
      exclude: m,
      set enabled(ee) {
        ee ? D(C.current) : M(C.current);
      },
      get enabled() {
        return Q.enabled;
      }
    }), [m, Q.enabled]), Nl(w, () => ({
      uid: C.current,
      title: a,
      exclude: m,
      set enabled(ee) {
        ee ? D(C.current) : M(C.current);
      },
      get enabled() {
        return Q.enabled;
      }
    }), [m, Q.enabled]), Vn(() => {
      const ee = N.includes(C.current);
      ne((fe) => ({
        ...fe,
        enabled: ee
      }));
    }, [N]), Vn(() => {
      ne((ee) => ({
        ...ee,
        active: C.current === A
      })), C.current === A && Y && J.current.focus();
    }, [A]), Vn(() => {
      ne((ee) => ({
        ...ee,
        status: f,
        message: p
      }));
    }, [f, p]);
    const ue = (ee) => {
      switch (ee.key) {
        case "ArrowDown":
          P();
          break;
        case "ArrowUp":
          I();
          break;
      }
    };
    return /* @__PURE__ */ Ne.jsx(
      "div",
      {
        className: pn(`${fM}`, t, {
          [`${fM}--active`]: C.current === A,
          [`${fM}--inactive`]: C.current !== A
        }),
        ref: J,
        tabIndex: Y ? -1 : void 0,
        onKeyDown: Y ? ue : void 0,
        ...O,
        children: (!q || Q.active) && /* @__PURE__ */ Ne.jsxs(ov.Provider, { value: Q, children: [
          Q.message && /* @__PURE__ */ Ne.jsx(BI, {}),
          e
        ] })
      }
    );
  }
);
A5.displayName = "WizardStep";
const lw = "wizard-header", k5 = ({ className: t, children: e, onClick: n, ...r }) => {
  const { uid: a, summary: i, active: o, enabled: s, status: u } = nc(ov), { mode: f, activateStep: p } = nc(S0), m = Ei((v) => {
    v.preventDefault(), v.stopPropagation(), s && (n == null || n(v), p(a));
  }, [s]);
  return /* @__PURE__ */ Ne.jsx(Ne.Fragment, { children: /* @__PURE__ */ Ne.jsxs(
    "div",
    {
      onClick: m,
      className: pn(lw, t, {
        [`${lw}--active`]: o,
        [`${lw}--disabled`]: !s,
        [`${lw}--${u}`]: u
      }),
      ...r,
      children: [
        e,
        i && /* @__PURE__ */ Ne.jsx("div", { className: `${lw}__summary`, children: i })
      ]
    }
  ) });
};
k5.displayName = "AccordionWizard.Header";
const Jj = "wizard-content", R5 = ({ className: t, children: e, ...n }) => {
  const { uid: r, active: a } = nc(ov), { activeUid: i, enabledUids: o } = nc(S0);
  return !a && !o.includes(r) ? null : /* @__PURE__ */ Ne.jsx("div", { className: pn(Jj, t, {
    [`${Jj}--active`]: i === r
  }), ...n, children: e });
};
R5.displayName = "AccordionWizard.Content";
var ec = "top", Vf = "bottom", Yf = "right", tc = "left", UI = "auto", u_ = [ec, Vf, Yf, tc], PE = "start", ST = "end", Nme = "clippingParents", Yee = "viewport", uw = "popper", Pme = "reference", eG = /* @__PURE__ */ u_.reduce(function(t, e) {
  return t.concat([e + "-" + PE, e + "-" + ST]);
}, []), Zee = /* @__PURE__ */ [].concat(u_, [UI]).reduce(function(t, e) {
  return t.concat([e, e + "-" + PE, e + "-" + ST]);
}, []), Lme = "beforeRead", Mme = "read", Fme = "afterRead", $me = "beforeMain", Bme = "main", Ume = "afterMain", zme = "beforeWrite", Hme = "write", Wme = "afterWrite", pF = [Lme, Mme, Fme, $me, Bme, Ume, zme, Hme, Wme];
function xh(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}
function Xf(t) {
  if (t == null)
    return window;
  if (t.toString() !== "[object Window]") {
    var e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function a0(t) {
  var e = Xf(t).Element;
  return t instanceof e || t instanceof Element;
}
function zc(t) {
  var e = Xf(t).HTMLElement;
  return t instanceof e || t instanceof HTMLElement;
}
function I5(t) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = Xf(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function Qme(t) {
  var e = t.state;
  Object.keys(e.elements).forEach(function(n) {
    var r = e.styles[n] || {}, a = e.attributes[n] || {}, i = e.elements[n];
    !zc(i) || !xh(i) || (Object.assign(i.style, r), Object.keys(a).forEach(function(o) {
      var s = a[o];
      s === !1 ? i.removeAttribute(o) : i.setAttribute(o, s === !0 ? "" : s);
    }));
  });
}
function jme(t) {
  var e = t.state, n = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, n.popper), e.styles = n, e.elements.arrow && Object.assign(e.elements.arrow.style, n.arrow), function() {
    Object.keys(e.elements).forEach(function(r) {
      var a = e.elements[r], i = e.attributes[r] || {}, o = Object.keys(e.styles.hasOwnProperty(r) ? e.styles[r] : n[r]), s = o.reduce(function(u, f) {
        return u[f] = "", u;
      }, {});
      !zc(a) || !xh(a) || (Object.assign(a.style, s), Object.keys(i).forEach(function(u) {
        a.removeAttribute(u);
      }));
    });
  };
}
const Xee = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Qme,
  effect: jme,
  requires: ["computeStyles"]
};
function Wd(t) {
  return t.split("-")[0];
}
var t0 = Math.max, Hk = Math.min, LE = Math.round;
function hF() {
  var t = navigator.userAgentData;
  return t != null && t.brands ? t.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function qee() {
  return !/^((?!chrome|android).)*safari/i.test(hF());
}
function ME(t, e, n) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  var r = t.getBoundingClientRect(), a = 1, i = 1;
  e && zc(t) && (a = t.offsetWidth > 0 && LE(r.width) / t.offsetWidth || 1, i = t.offsetHeight > 0 && LE(r.height) / t.offsetHeight || 1);
  var o = a0(t) ? Xf(t) : window, s = o.visualViewport, u = !qee() && n, f = (r.left + (u && s ? s.offsetLeft : 0)) / a, p = (r.top + (u && s ? s.offsetTop : 0)) / i, m = r.width / a, v = r.height / i;
  return {
    width: m,
    height: v,
    top: p,
    right: f + m,
    bottom: p + v,
    left: f,
    x: f,
    y: p
  };
}
function D5(t) {
  var e = ME(t), n = t.offsetWidth, r = t.offsetHeight;
  return Math.abs(e.width - n) <= 1 && (n = e.width), Math.abs(e.height - r) <= 1 && (r = e.height), {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: n,
    height: r
  };
}
function Kee(t, e) {
  var n = e.getRootNode && e.getRootNode();
  if (t.contains(e))
    return !0;
  if (n && I5(n)) {
    var r = e;
    do {
      if (r && t.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function Yd(t) {
  return Xf(t).getComputedStyle(t);
}
function Gme(t) {
  return ["table", "td", "th"].indexOf(xh(t)) >= 0;
}
function sv(t) {
  return ((a0(t) ? t.ownerDocument : (
    // $FlowFixMe[prop-missing]
    t.document
  )) || window.document).documentElement;
}
function zI(t) {
  return xh(t) === "html" ? t : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    t.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    t.parentNode || // DOM Element detected
    (I5(t) ? t.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    sv(t)
  );
}
function tG(t) {
  return !zc(t) || // https://github.com/popperjs/popper-core/issues/837
  Yd(t).position === "fixed" ? null : t.offsetParent;
}
function Vme(t) {
  var e = /firefox/i.test(hF()), n = /Trident/i.test(hF());
  if (n && zc(t)) {
    var r = Yd(t);
    if (r.position === "fixed")
      return null;
  }
  var a = zI(t);
  for (I5(a) && (a = a.host); zc(a) && ["html", "body"].indexOf(xh(a)) < 0; ) {
    var i = Yd(a);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || e && i.willChange === "filter" || e && i.filter && i.filter !== "none")
      return a;
    a = a.parentNode;
  }
  return null;
}
function c_(t) {
  for (var e = Xf(t), n = tG(t); n && Gme(n) && Yd(n).position === "static"; )
    n = tG(n);
  return n && (xh(n) === "html" || xh(n) === "body" && Yd(n).position === "static") ? e : n || Vme(t) || e;
}
function N5(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
function Ww(t, e, n) {
  return t0(t, Hk(e, n));
}
function Yme(t, e, n) {
  var r = Ww(t, e, n);
  return r > n ? n : r;
}
function Jee() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function ete(t) {
  return Object.assign({}, Jee(), t);
}
function tte(t, e) {
  return e.reduce(function(n, r) {
    return n[r] = t, n;
  }, {});
}
var Zme = function(e, n) {
  return e = typeof e == "function" ? e(Object.assign({}, n.rects, {
    placement: n.placement
  })) : e, ete(typeof e != "number" ? e : tte(e, u_));
};
function Xme(t) {
  var e, n = t.state, r = t.name, a = t.options, i = n.elements.arrow, o = n.modifiersData.popperOffsets, s = Wd(n.placement), u = N5(s), f = [tc, Yf].indexOf(s) >= 0, p = f ? "height" : "width";
  if (!(!i || !o)) {
    var m = Zme(a.padding, n), v = D5(i), O = u === "y" ? ec : tc, w = u === "y" ? Vf : Yf, _ = n.rects.reference[p] + n.rects.reference[u] - o[u] - n.rects.popper[p], C = o[u] - n.rects.reference[u], A = c_(i), N = A ? u === "y" ? A.clientHeight || 0 : A.clientWidth || 0 : 0, P = _ / 2 - C / 2, I = m[O], D = N - v[p] - m[w], M = N / 2 - v[p] / 2 + P, H = Ww(I, M, D), Y = u;
    n.modifiersData[r] = (e = {}, e[Y] = H, e.centerOffset = H - M, e);
  }
}
function qme(t) {
  var e = t.state, n = t.options, r = n.element, a = r === void 0 ? "[data-popper-arrow]" : r;
  if (a != null && !(typeof a == "string" && (a = e.elements.popper.querySelector(a), !a))) {
    if (process.env.NODE_ENV !== "production" && (zc(a) || console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', "To use an SVG arrow, wrap it in an HTMLElement that will be used as", "the arrow."].join(" "))), !Kee(e.elements.popper, a)) {
      process.env.NODE_ENV !== "production" && console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', "element."].join(" "));
      return;
    }
    e.elements.arrow = a;
  }
}
const Kme = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Xme,
  effect: qme,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function FE(t) {
  return t.split("-")[1];
}
var Jme = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function ege(t) {
  var e = t.x, n = t.y, r = window, a = r.devicePixelRatio || 1;
  return {
    x: LE(e * a) / a || 0,
    y: LE(n * a) / a || 0
  };
}
function nG(t) {
  var e, n = t.popper, r = t.popperRect, a = t.placement, i = t.variation, o = t.offsets, s = t.position, u = t.gpuAcceleration, f = t.adaptive, p = t.roundOffsets, m = t.isFixed, v = o.x, O = v === void 0 ? 0 : v, w = o.y, _ = w === void 0 ? 0 : w, C = typeof p == "function" ? p({
    x: O,
    y: _
  }) : {
    x: O,
    y: _
  };
  O = C.x, _ = C.y;
  var A = o.hasOwnProperty("x"), N = o.hasOwnProperty("y"), P = tc, I = ec, D = window;
  if (f) {
    var M = c_(n), H = "clientHeight", Y = "clientWidth";
    if (M === Xf(n) && (M = sv(n), Yd(M).position !== "static" && s === "absolute" && (H = "scrollHeight", Y = "scrollWidth")), M = M, a === ec || (a === tc || a === Yf) && i === ST) {
      I = Vf;
      var q = m && M === D && D.visualViewport ? D.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        M[H]
      );
      _ -= q - r.height, _ *= u ? 1 : -1;
    }
    if (a === tc || (a === ec || a === Vf) && i === ST) {
      P = Yf;
      var Q = m && M === D && D.visualViewport ? D.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        M[Y]
      );
      O -= Q - r.width, O *= u ? 1 : -1;
    }
  }
  var ne = Object.assign({
    position: s
  }, f && Jme), J = p === !0 ? ege({
    x: O,
    y: _
  }) : {
    x: O,
    y: _
  };
  if (O = J.x, _ = J.y, u) {
    var ue;
    return Object.assign({}, ne, (ue = {}, ue[I] = N ? "0" : "", ue[P] = A ? "0" : "", ue.transform = (D.devicePixelRatio || 1) <= 1 ? "translate(" + O + "px, " + _ + "px)" : "translate3d(" + O + "px, " + _ + "px, 0)", ue));
  }
  return Object.assign({}, ne, (e = {}, e[I] = N ? _ + "px" : "", e[P] = A ? O + "px" : "", e.transform = "", e));
}
function tge(t) {
  var e = t.state, n = t.options, r = n.gpuAcceleration, a = r === void 0 ? !0 : r, i = n.adaptive, o = i === void 0 ? !0 : i, s = n.roundOffsets, u = s === void 0 ? !0 : s;
  if (process.env.NODE_ENV !== "production") {
    var f = Yd(e.elements.popper).transitionProperty || "";
    o && ["transform", "top", "right", "bottom", "left"].some(function(m) {
      return f.indexOf(m) >= 0;
    }) && console.warn(["Popper: Detected CSS transitions on at least one of the following", 'CSS properties: "transform", "top", "right", "bottom", "left".', `

`, 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', "for smooth transitions, or remove these properties from the CSS", "transition declaration on the popper element if only transitioning", "opacity or background-color for example.", `

`, "We recommend using the popper element as a wrapper around an inner", "element that can have any CSS property transitioned for animations."].join(" "));
  }
  var p = {
    placement: Wd(e.placement),
    variation: FE(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: a,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, nG(Object.assign({}, p, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: o,
    roundOffsets: u
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, nG(Object.assign({}, p, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: u
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const nge = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: tge,
  data: {}
};
var Sx = {
  passive: !0
};
function rge(t) {
  var e = t.state, n = t.instance, r = t.options, a = r.scroll, i = a === void 0 ? !0 : a, o = r.resize, s = o === void 0 ? !0 : o, u = Xf(e.elements.popper), f = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return i && f.forEach(function(p) {
    p.addEventListener("scroll", n.update, Sx);
  }), s && u.addEventListener("resize", n.update, Sx), function() {
    i && f.forEach(function(p) {
      p.removeEventListener("scroll", n.update, Sx);
    }), s && u.removeEventListener("resize", n.update, Sx);
  };
}
const age = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: rge,
  data: {}
};
var ige = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function OA(t) {
  return t.replace(/left|right|bottom|top/g, function(e) {
    return ige[e];
  });
}
var oge = {
  start: "end",
  end: "start"
};
function rG(t) {
  return t.replace(/start|end/g, function(e) {
    return oge[e];
  });
}
function P5(t) {
  var e = Xf(t), n = e.pageXOffset, r = e.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function L5(t) {
  return ME(sv(t)).left + P5(t).scrollLeft;
}
function sge(t, e) {
  var n = Xf(t), r = sv(t), a = n.visualViewport, i = r.clientWidth, o = r.clientHeight, s = 0, u = 0;
  if (a) {
    i = a.width, o = a.height;
    var f = qee();
    (f || !f && e === "fixed") && (s = a.offsetLeft, u = a.offsetTop);
  }
  return {
    width: i,
    height: o,
    x: s + L5(t),
    y: u
  };
}
function lge(t) {
  var e, n = sv(t), r = P5(t), a = (e = t.ownerDocument) == null ? void 0 : e.body, i = t0(n.scrollWidth, n.clientWidth, a ? a.scrollWidth : 0, a ? a.clientWidth : 0), o = t0(n.scrollHeight, n.clientHeight, a ? a.scrollHeight : 0, a ? a.clientHeight : 0), s = -r.scrollLeft + L5(t), u = -r.scrollTop;
  return Yd(a || n).direction === "rtl" && (s += t0(n.clientWidth, a ? a.clientWidth : 0) - i), {
    width: i,
    height: o,
    x: s,
    y: u
  };
}
function M5(t) {
  var e = Yd(t), n = e.overflow, r = e.overflowX, a = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + a + r);
}
function nte(t) {
  return ["html", "body", "#document"].indexOf(xh(t)) >= 0 ? t.ownerDocument.body : zc(t) && M5(t) ? t : nte(zI(t));
}
function Qw(t, e) {
  var n;
  e === void 0 && (e = []);
  var r = nte(t), a = r === ((n = t.ownerDocument) == null ? void 0 : n.body), i = Xf(r), o = a ? [i].concat(i.visualViewport || [], M5(r) ? r : []) : r, s = e.concat(o);
  return a ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(Qw(zI(o)))
  );
}
function mF(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
function uge(t, e) {
  var n = ME(t, !1, e === "fixed");
  return n.top = n.top + t.clientTop, n.left = n.left + t.clientLeft, n.bottom = n.top + t.clientHeight, n.right = n.left + t.clientWidth, n.width = t.clientWidth, n.height = t.clientHeight, n.x = n.left, n.y = n.top, n;
}
function aG(t, e, n) {
  return e === Yee ? mF(sge(t, n)) : a0(e) ? uge(e, n) : mF(lge(sv(t)));
}
function cge(t) {
  var e = Qw(zI(t)), n = ["absolute", "fixed"].indexOf(Yd(t).position) >= 0, r = n && zc(t) ? c_(t) : t;
  return a0(r) ? e.filter(function(a) {
    return a0(a) && Kee(a, r) && xh(a) !== "body";
  }) : [];
}
function fge(t, e, n, r) {
  var a = e === "clippingParents" ? cge(t) : [].concat(e), i = [].concat(a, [n]), o = i[0], s = i.reduce(function(u, f) {
    var p = aG(t, f, r);
    return u.top = t0(p.top, u.top), u.right = Hk(p.right, u.right), u.bottom = Hk(p.bottom, u.bottom), u.left = t0(p.left, u.left), u;
  }, aG(t, o, r));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function rte(t) {
  var e = t.reference, n = t.element, r = t.placement, a = r ? Wd(r) : null, i = r ? FE(r) : null, o = e.x + e.width / 2 - n.width / 2, s = e.y + e.height / 2 - n.height / 2, u;
  switch (a) {
    case ec:
      u = {
        x: o,
        y: e.y - n.height
      };
      break;
    case Vf:
      u = {
        x: o,
        y: e.y + e.height
      };
      break;
    case Yf:
      u = {
        x: e.x + e.width,
        y: s
      };
      break;
    case tc:
      u = {
        x: e.x - n.width,
        y: s
      };
      break;
    default:
      u = {
        x: e.x,
        y: e.y
      };
  }
  var f = a ? N5(a) : null;
  if (f != null) {
    var p = f === "y" ? "height" : "width";
    switch (i) {
      case PE:
        u[f] = u[f] - (e[p] / 2 - n[p] / 2);
        break;
      case ST:
        u[f] = u[f] + (e[p] / 2 - n[p] / 2);
        break;
    }
  }
  return u;
}
function wT(t, e) {
  e === void 0 && (e = {});
  var n = e, r = n.placement, a = r === void 0 ? t.placement : r, i = n.strategy, o = i === void 0 ? t.strategy : i, s = n.boundary, u = s === void 0 ? Nme : s, f = n.rootBoundary, p = f === void 0 ? Yee : f, m = n.elementContext, v = m === void 0 ? uw : m, O = n.altBoundary, w = O === void 0 ? !1 : O, _ = n.padding, C = _ === void 0 ? 0 : _, A = ete(typeof C != "number" ? C : tte(C, u_)), N = v === uw ? Pme : uw, P = t.rects.popper, I = t.elements[w ? N : v], D = fge(a0(I) ? I : I.contextElement || sv(t.elements.popper), u, p, o), M = ME(t.elements.reference), H = rte({
    reference: M,
    element: P,
    strategy: "absolute",
    placement: a
  }), Y = mF(Object.assign({}, P, H)), q = v === uw ? Y : M, Q = {
    top: D.top - q.top + A.top,
    bottom: q.bottom - D.bottom + A.bottom,
    left: D.left - q.left + A.left,
    right: q.right - D.right + A.right
  }, ne = t.modifiersData.offset;
  if (v === uw && ne) {
    var J = ne[a];
    Object.keys(Q).forEach(function(ue) {
      var ee = [Yf, Vf].indexOf(ue) >= 0 ? 1 : -1, fe = [ec, Vf].indexOf(ue) >= 0 ? "y" : "x";
      Q[ue] += J[fe] * ee;
    });
  }
  return Q;
}
function dge(t, e) {
  e === void 0 && (e = {});
  var n = e, r = n.placement, a = n.boundary, i = n.rootBoundary, o = n.padding, s = n.flipVariations, u = n.allowedAutoPlacements, f = u === void 0 ? Zee : u, p = FE(r), m = p ? s ? eG : eG.filter(function(w) {
    return FE(w) === p;
  }) : u_, v = m.filter(function(w) {
    return f.indexOf(w) >= 0;
  });
  v.length === 0 && (v = m, process.env.NODE_ENV !== "production" && console.error(["Popper: The `allowedAutoPlacements` option did not allow any", "placements. Ensure the `placement` option matches the variation", "of the allowed placements.", 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(" ")));
  var O = v.reduce(function(w, _) {
    return w[_] = wT(t, {
      placement: _,
      boundary: a,
      rootBoundary: i,
      padding: o
    })[Wd(_)], w;
  }, {});
  return Object.keys(O).sort(function(w, _) {
    return O[w] - O[_];
  });
}
function pge(t) {
  if (Wd(t) === UI)
    return [];
  var e = OA(t);
  return [rG(t), e, rG(e)];
}
function hge(t) {
  var e = t.state, n = t.options, r = t.name;
  if (!e.modifiersData[r]._skip) {
    for (var a = n.mainAxis, i = a === void 0 ? !0 : a, o = n.altAxis, s = o === void 0 ? !0 : o, u = n.fallbackPlacements, f = n.padding, p = n.boundary, m = n.rootBoundary, v = n.altBoundary, O = n.flipVariations, w = O === void 0 ? !0 : O, _ = n.allowedAutoPlacements, C = e.options.placement, A = Wd(C), N = A === C, P = u || (N || !w ? [OA(C)] : pge(C)), I = [C].concat(P).reduce(function(ce, j) {
      return ce.concat(Wd(j) === UI ? dge(e, {
        placement: j,
        boundary: p,
        rootBoundary: m,
        padding: f,
        flipVariations: w,
        allowedAutoPlacements: _
      }) : j);
    }, []), D = e.rects.reference, M = e.rects.popper, H = /* @__PURE__ */ new Map(), Y = !0, q = I[0], Q = 0; Q < I.length; Q++) {
      var ne = I[Q], J = Wd(ne), ue = FE(ne) === PE, ee = [ec, Vf].indexOf(J) >= 0, fe = ee ? "width" : "height", de = wT(e, {
        placement: ne,
        boundary: p,
        rootBoundary: m,
        altBoundary: v,
        padding: f
      }), ie = ee ? ue ? Yf : tc : ue ? Vf : ec;
      D[fe] > M[fe] && (ie = OA(ie));
      var le = OA(ie), ye = [];
      if (i && ye.push(de[J] <= 0), s && ye.push(de[ie] <= 0, de[le] <= 0), ye.every(function(ce) {
        return ce;
      })) {
        q = ne, Y = !1;
        break;
      }
      H.set(ne, ye);
    }
    if (Y)
      for (var B = w ? 3 : 1, pe = function(j) {
        var K = I.find(function(Ee) {
          var he = H.get(Ee);
          if (he)
            return he.slice(0, j).every(function(Ae) {
              return Ae;
            });
        });
        if (K)
          return q = K, "break";
      }, _e = B; _e > 0; _e--) {
        var Z = pe(_e);
        if (Z === "break")
          break;
      }
    e.placement !== q && (e.modifiersData[r]._skip = !0, e.placement = q, e.reset = !0);
  }
}
const mge = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: hge,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function iG(t, e, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: t.top - e.height - n.y,
    right: t.right - e.width + n.x,
    bottom: t.bottom - e.height + n.y,
    left: t.left - e.width - n.x
  };
}
function oG(t) {
  return [ec, Yf, Vf, tc].some(function(e) {
    return t[e] >= 0;
  });
}
function gge(t) {
  var e = t.state, n = t.name, r = e.rects.reference, a = e.rects.popper, i = e.modifiersData.preventOverflow, o = wT(e, {
    elementContext: "reference"
  }), s = wT(e, {
    altBoundary: !0
  }), u = iG(o, r), f = iG(s, a, i), p = oG(u), m = oG(f);
  e.modifiersData[n] = {
    referenceClippingOffsets: u,
    popperEscapeOffsets: f,
    isReferenceHidden: p,
    hasPopperEscaped: m
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": p,
    "data-popper-escaped": m
  });
}
const bge = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: gge
};
function vge(t, e, n) {
  var r = Wd(t), a = [tc, ec].indexOf(r) >= 0 ? -1 : 1, i = typeof n == "function" ? n(Object.assign({}, e, {
    placement: t
  })) : n, o = i[0], s = i[1];
  return o = o || 0, s = (s || 0) * a, [tc, Yf].indexOf(r) >= 0 ? {
    x: s,
    y: o
  } : {
    x: o,
    y: s
  };
}
function yge(t) {
  var e = t.state, n = t.options, r = t.name, a = n.offset, i = a === void 0 ? [0, 0] : a, o = Zee.reduce(function(p, m) {
    return p[m] = vge(m, e.rects, i), p;
  }, {}), s = o[e.placement], u = s.x, f = s.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += u, e.modifiersData.popperOffsets.y += f), e.modifiersData[r] = o;
}
const Oge = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: yge
};
function Ege(t) {
  var e = t.state, n = t.name;
  e.modifiersData[n] = rte({
    reference: e.rects.reference,
    element: e.rects.popper,
    strategy: "absolute",
    placement: e.placement
  });
}
const Sge = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: Ege,
  data: {}
};
function wge(t) {
  return t === "x" ? "y" : "x";
}
function Tge(t) {
  var e = t.state, n = t.options, r = t.name, a = n.mainAxis, i = a === void 0 ? !0 : a, o = n.altAxis, s = o === void 0 ? !1 : o, u = n.boundary, f = n.rootBoundary, p = n.altBoundary, m = n.padding, v = n.tether, O = v === void 0 ? !0 : v, w = n.tetherOffset, _ = w === void 0 ? 0 : w, C = wT(e, {
    boundary: u,
    rootBoundary: f,
    padding: m,
    altBoundary: p
  }), A = Wd(e.placement), N = FE(e.placement), P = !N, I = N5(A), D = wge(I), M = e.modifiersData.popperOffsets, H = e.rects.reference, Y = e.rects.popper, q = typeof _ == "function" ? _(Object.assign({}, e.rects, {
    placement: e.placement
  })) : _, Q = typeof q == "number" ? {
    mainAxis: q,
    altAxis: q
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, q), ne = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, J = {
    x: 0,
    y: 0
  };
  if (M) {
    if (i) {
      var ue, ee = I === "y" ? ec : tc, fe = I === "y" ? Vf : Yf, de = I === "y" ? "height" : "width", ie = M[I], le = ie + C[ee], ye = ie - C[fe], B = O ? -Y[de] / 2 : 0, pe = N === PE ? H[de] : Y[de], _e = N === PE ? -Y[de] : -H[de], Z = e.elements.arrow, ce = O && Z ? D5(Z) : {
        width: 0,
        height: 0
      }, j = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : Jee(), K = j[ee], Ee = j[fe], he = Ww(0, H[de], ce[de]), Ae = P ? H[de] / 2 - B - he - K - Q.mainAxis : pe - he - K - Q.mainAxis, Te = P ? -H[de] / 2 + B + he + Ee + Q.mainAxis : _e + he + Ee + Q.mainAxis, je = e.elements.arrow && c_(e.elements.arrow), we = je ? I === "y" ? je.clientTop || 0 : je.clientLeft || 0 : 0, lt = (ue = ne == null ? void 0 : ne[I]) != null ? ue : 0, st = ie + Ae - lt - we, Oe = ie + Te - lt, Re = Ww(O ? Hk(le, st) : le, ie, O ? t0(ye, Oe) : ye);
      M[I] = Re, J[I] = Re - ie;
    }
    if (s) {
      var Be, mt = I === "x" ? ec : tc, Tt = I === "x" ? Vf : Yf, ut = M[D], wt = D === "y" ? "height" : "width", Yt = ut + C[mt], Rt = ut - C[Tt], Ut = [ec, tc].indexOf(A) !== -1, He = (Be = ne == null ? void 0 : ne[D]) != null ? Be : 0, Ve = Ut ? Yt : ut - H[wt] - Y[wt] - He + Q.altAxis, Ie = Ut ? ut + H[wt] + Y[wt] - He - Q.altAxis : Rt, it = O && Ut ? Yme(Ve, ut, Ie) : Ww(O ? Ve : Yt, ut, O ? Ie : Rt);
      M[D] = it, J[D] = it - ut;
    }
    e.modifiersData[r] = J;
  }
}
const _ge = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Tge,
  requiresIfExists: ["offset"]
};
function Cge(t) {
  return {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  };
}
function xge(t) {
  return t === Xf(t) || !zc(t) ? P5(t) : Cge(t);
}
function Age(t) {
  var e = t.getBoundingClientRect(), n = LE(e.width) / t.offsetWidth || 1, r = LE(e.height) / t.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function kge(t, e, n) {
  n === void 0 && (n = !1);
  var r = zc(e), a = zc(e) && Age(e), i = sv(e), o = ME(t, a, n), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((xh(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  M5(i)) && (s = xge(e)), zc(e) ? (u = ME(e, !0), u.x += e.clientLeft, u.y += e.clientTop) : i && (u.x = L5(i))), {
    x: o.left + s.scrollLeft - u.x,
    y: o.top + s.scrollTop - u.y,
    width: o.width,
    height: o.height
  };
}
function Rge(t) {
  var e = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  t.forEach(function(i) {
    e.set(i.name, i);
  });
  function a(i) {
    n.add(i.name);
    var o = [].concat(i.requires || [], i.requiresIfExists || []);
    o.forEach(function(s) {
      if (!n.has(s)) {
        var u = e.get(s);
        u && a(u);
      }
    }), r.push(i);
  }
  return t.forEach(function(i) {
    n.has(i.name) || a(i);
  }), r;
}
function Ige(t) {
  var e = Rge(t);
  return pF.reduce(function(n, r) {
    return n.concat(e.filter(function(a) {
      return a.phase === r;
    }));
  }, []);
}
function Dge(t) {
  var e;
  return function() {
    return e || (e = new Promise(function(n) {
      Promise.resolve().then(function() {
        e = void 0, n(t());
      });
    })), e;
  };
}
function xb(t) {
  for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++)
    n[r - 1] = arguments[r];
  return [].concat(n).reduce(function(a, i) {
    return a.replace(/%s/, i);
  }, t);
}
var My = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s', Nge = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available', sG = ["name", "enabled", "phase", "fn", "effect", "requires", "options"];
function Pge(t) {
  t.forEach(function(e) {
    [].concat(Object.keys(e), sG).filter(function(n, r, a) {
      return a.indexOf(n) === r;
    }).forEach(function(n) {
      switch (n) {
        case "name":
          typeof e.name != "string" && console.error(xb(My, String(e.name), '"name"', '"string"', '"' + String(e.name) + '"'));
          break;
        case "enabled":
          typeof e.enabled != "boolean" && console.error(xb(My, e.name, '"enabled"', '"boolean"', '"' + String(e.enabled) + '"'));
          break;
        case "phase":
          pF.indexOf(e.phase) < 0 && console.error(xb(My, e.name, '"phase"', "either " + pF.join(", "), '"' + String(e.phase) + '"'));
          break;
        case "fn":
          typeof e.fn != "function" && console.error(xb(My, e.name, '"fn"', '"function"', '"' + String(e.fn) + '"'));
          break;
        case "effect":
          e.effect != null && typeof e.effect != "function" && console.error(xb(My, e.name, '"effect"', '"function"', '"' + String(e.fn) + '"'));
          break;
        case "requires":
          e.requires != null && !Array.isArray(e.requires) && console.error(xb(My, e.name, '"requires"', '"array"', '"' + String(e.requires) + '"'));
          break;
        case "requiresIfExists":
          Array.isArray(e.requiresIfExists) || console.error(xb(My, e.name, '"requiresIfExists"', '"array"', '"' + String(e.requiresIfExists) + '"'));
          break;
        case "options":
        case "data":
          break;
        default:
          console.error('PopperJS: an invalid property has been provided to the "' + e.name + '" modifier, valid properties are ' + sG.map(function(r) {
            return '"' + r + '"';
          }).join(", ") + '; but "' + n + '" was provided.');
      }
      e.requires && e.requires.forEach(function(r) {
        t.find(function(a) {
          return a.name === r;
        }) == null && console.error(xb(Nge, String(e.name), r, r));
      });
    });
  });
}
function Lge(t, e) {
  var n = /* @__PURE__ */ new Set();
  return t.filter(function(r) {
    var a = e(r);
    if (!n.has(a))
      return n.add(a), !0;
  });
}
function Mge(t) {
  var e = t.reduce(function(n, r) {
    var a = n[r.name];
    return n[r.name] = a ? Object.assign({}, a, r, {
      options: Object.assign({}, a.options, r.options),
      data: Object.assign({}, a.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(e).map(function(n) {
    return e[n];
  });
}
var lG = "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.", Fge = "Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.", uG = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function cG() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return !e.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function $ge(t) {
  t === void 0 && (t = {});
  var e = t, n = e.defaultModifiers, r = n === void 0 ? [] : n, a = e.defaultOptions, i = a === void 0 ? uG : a;
  return function(s, u, f) {
    f === void 0 && (f = i);
    var p = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, uG, i),
      modifiersData: {},
      elements: {
        reference: s,
        popper: u
      },
      attributes: {},
      styles: {}
    }, m = [], v = !1, O = {
      state: p,
      setOptions: function(A) {
        var N = typeof A == "function" ? A(p.options) : A;
        _(), p.options = Object.assign({}, i, p.options, N), p.scrollParents = {
          reference: a0(s) ? Qw(s) : s.contextElement ? Qw(s.contextElement) : [],
          popper: Qw(u)
        };
        var P = Ige(Mge([].concat(r, p.options.modifiers)));
        if (p.orderedModifiers = P.filter(function(ne) {
          return ne.enabled;
        }), process.env.NODE_ENV !== "production") {
          var I = Lge([].concat(P, p.options.modifiers), function(ne) {
            var J = ne.name;
            return J;
          });
          if (Pge(I), Wd(p.options.placement) === UI) {
            var D = p.orderedModifiers.find(function(ne) {
              var J = ne.name;
              return J === "flip";
            });
            D || console.error(['Popper: "auto" placements require the "flip" modifier be', "present and enabled to work."].join(" "));
          }
          var M = Yd(u), H = M.marginTop, Y = M.marginRight, q = M.marginBottom, Q = M.marginLeft;
          [H, Y, q, Q].some(function(ne) {
            return parseFloat(ne);
          }) && console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', "between the popper and its reference element or boundary.", "To replicate margin, use the `offset` modifier, as well as", "the `padding` option in the `preventOverflow` and `flip`", "modifiers."].join(" "));
        }
        return w(), O.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!v) {
          var A = p.elements, N = A.reference, P = A.popper;
          if (!cG(N, P)) {
            process.env.NODE_ENV !== "production" && console.error(lG);
            return;
          }
          p.rects = {
            reference: kge(N, c_(P), p.options.strategy === "fixed"),
            popper: D5(P)
          }, p.reset = !1, p.placement = p.options.placement, p.orderedModifiers.forEach(function(ne) {
            return p.modifiersData[ne.name] = Object.assign({}, ne.data);
          });
          for (var I = 0, D = 0; D < p.orderedModifiers.length; D++) {
            if (process.env.NODE_ENV !== "production" && (I += 1, I > 100)) {
              console.error(Fge);
              break;
            }
            if (p.reset === !0) {
              p.reset = !1, D = -1;
              continue;
            }
            var M = p.orderedModifiers[D], H = M.fn, Y = M.options, q = Y === void 0 ? {} : Y, Q = M.name;
            typeof H == "function" && (p = H({
              state: p,
              options: q,
              name: Q,
              instance: O
            }) || p);
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Dge(function() {
        return new Promise(function(C) {
          O.forceUpdate(), C(p);
        });
      }),
      destroy: function() {
        _(), v = !0;
      }
    };
    if (!cG(s, u))
      return process.env.NODE_ENV !== "production" && console.error(lG), O;
    O.setOptions(f).then(function(C) {
      !v && f.onFirstUpdate && f.onFirstUpdate(C);
    });
    function w() {
      p.orderedModifiers.forEach(function(C) {
        var A = C.name, N = C.options, P = N === void 0 ? {} : N, I = C.effect;
        if (typeof I == "function") {
          var D = I({
            state: p,
            name: A,
            instance: O,
            options: P
          }), M = function() {
          };
          m.push(D || M);
        }
      });
    }
    function _() {
      m.forEach(function(C) {
        return C();
      }), m = [];
    }
    return O;
  };
}
var Bge = [age, Sge, nge, Xee, Oge, mge, _ge, Kme, bge], ate = /* @__PURE__ */ $ge({
  defaultModifiers: Bge
}), Uge = "tippy-box", ite = "tippy-content", zge = "tippy-backdrop", ote = "tippy-arrow", ste = "tippy-svg-arrow", Qy = {
  passive: !0,
  capture: !0
}, lte = function() {
  return document.body;
};
function Hge(t, e) {
  return {}.hasOwnProperty.call(t, e);
}
function dM(t, e, n) {
  if (Array.isArray(t)) {
    var r = t[e];
    return r ?? (Array.isArray(n) ? n[e] : n);
  }
  return t;
}
function F5(t, e) {
  var n = {}.toString.call(t);
  return n.indexOf("[object") === 0 && n.indexOf(e + "]") > -1;
}
function ute(t, e) {
  return typeof t == "function" ? t.apply(void 0, e) : t;
}
function fG(t, e) {
  if (e === 0)
    return t;
  var n;
  return function(r) {
    clearTimeout(n), n = setTimeout(function() {
      t(r);
    }, e);
  };
}
function Wge(t, e) {
  var n = Object.assign({}, t);
  return e.forEach(function(r) {
    delete n[r];
  }), n;
}
function Qge(t) {
  return t.split(/\s+/).filter(Boolean);
}
function iE(t) {
  return [].concat(t);
}
function dG(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function jge(t) {
  return t.filter(function(e, n) {
    return t.indexOf(e) === n;
  });
}
function Gge(t) {
  return t.split("-")[0];
}
function Wk(t) {
  return [].slice.call(t);
}
function pG(t) {
  return Object.keys(t).reduce(function(e, n) {
    return t[n] !== void 0 && (e[n] = t[n]), e;
  }, {});
}
function jw() {
  return document.createElement("div");
}
function TT(t) {
  return ["Element", "Fragment"].some(function(e) {
    return F5(t, e);
  });
}
function Vge(t) {
  return F5(t, "NodeList");
}
function Yge(t) {
  return F5(t, "MouseEvent");
}
function Zge(t) {
  return !!(t && t._tippy && t._tippy.reference === t);
}
function Xge(t) {
  return TT(t) ? [t] : Vge(t) ? Wk(t) : Array.isArray(t) ? t : Wk(document.querySelectorAll(t));
}
function pM(t, e) {
  t.forEach(function(n) {
    n && (n.style.transitionDuration = e + "ms");
  });
}
function hG(t, e) {
  t.forEach(function(n) {
    n && n.setAttribute("data-state", e);
  });
}
function qge(t) {
  var e, n = iE(t), r = n[0];
  return r != null && (e = r.ownerDocument) != null && e.body ? r.ownerDocument : document;
}
function Kge(t, e) {
  var n = e.clientX, r = e.clientY;
  return t.every(function(a) {
    var i = a.popperRect, o = a.popperState, s = a.props, u = s.interactiveBorder, f = Gge(o.placement), p = o.modifiersData.offset;
    if (!p)
      return !0;
    var m = f === "bottom" ? p.top.y : 0, v = f === "top" ? p.bottom.y : 0, O = f === "right" ? p.left.x : 0, w = f === "left" ? p.right.x : 0, _ = i.top - r + m > u, C = r - i.bottom - v > u, A = i.left - n + O > u, N = n - i.right - w > u;
    return _ || C || A || N;
  });
}
function hM(t, e, n) {
  var r = e + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(a) {
    t[r](a, n);
  });
}
function mG(t, e) {
  for (var n = e; n; ) {
    var r;
    if (t.contains(n))
      return !0;
    n = n.getRootNode == null || (r = n.getRootNode()) == null ? void 0 : r.host;
  }
  return !1;
}
var hh = {
  isTouch: !1
}, gG = 0;
function Jge() {
  hh.isTouch || (hh.isTouch = !0, window.performance && document.addEventListener("mousemove", cte));
}
function cte() {
  var t = performance.now();
  t - gG < 20 && (hh.isTouch = !1, document.removeEventListener("mousemove", cte)), gG = t;
}
function ebe() {
  var t = document.activeElement;
  if (Zge(t)) {
    var e = t._tippy;
    t.blur && !e.state.isVisible && t.blur();
  }
}
function tbe() {
  document.addEventListener("touchstart", Jge, Qy), window.addEventListener("blur", ebe);
}
var nbe = typeof window < "u" && typeof document < "u", rbe = nbe ? (
  // @ts-ignore
  !!window.msCrypto
) : !1;
function GO(t) {
  var e = t === "destroy" ? "n already-" : " ";
  return [t + "() was called on a" + e + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function bG(t) {
  var e = /[ \t]{2,}/g, n = /^[ \t]*/gm;
  return t.replace(e, " ").replace(n, "").trim();
}
function abe(t) {
  return bG(`
  %ctippy.js

  %c` + bG(t) + `

  %c👷‍ This is a development-only message. It will be removed in production.
  `);
}
function fte(t) {
  return [
    abe(t),
    // title
    "color: #00C584; font-size: 1.3em; font-weight: bold;",
    // message
    "line-height: 1.5",
    // footer
    "color: #a6a095;"
  ];
}
var _T;
process.env.NODE_ENV !== "production" && ibe();
function ibe() {
  _T = /* @__PURE__ */ new Set();
}
function Ym(t, e) {
  if (t && !_T.has(e)) {
    var n;
    _T.add(e), (n = console).warn.apply(n, fte(e));
  }
}
function gF(t, e) {
  if (t && !_T.has(e)) {
    var n;
    _T.add(e), (n = console).error.apply(n, fte(e));
  }
}
function obe(t) {
  var e = !t, n = Object.prototype.toString.call(t) === "[object Object]" && !t.addEventListener;
  gF(e, ["tippy() was passed", "`" + String(t) + "`", "as its targets (first) argument. Valid types are: String, Element,", "Element[], or NodeList."].join(" ")), gF(n, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
}
var dte = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, sbe = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, Fc = Object.assign({
  appendTo: lte,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, dte, sbe), lbe = Object.keys(Fc), ube = function(e) {
  process.env.NODE_ENV !== "production" && hte(e, []);
  var n = Object.keys(e);
  n.forEach(function(r) {
    Fc[r] = e[r];
  });
};
function pte(t) {
  var e = t.plugins || [], n = e.reduce(function(r, a) {
    var i = a.name, o = a.defaultValue;
    if (i) {
      var s;
      r[i] = t[i] !== void 0 ? t[i] : (s = Fc[i]) != null ? s : o;
    }
    return r;
  }, {});
  return Object.assign({}, t, n);
}
function cbe(t, e) {
  var n = e ? Object.keys(pte(Object.assign({}, Fc, {
    plugins: e
  }))) : lbe, r = n.reduce(function(a, i) {
    var o = (t.getAttribute("data-tippy-" + i) || "").trim();
    if (!o)
      return a;
    if (i === "content")
      a[i] = o;
    else
      try {
        a[i] = JSON.parse(o);
      } catch {
        a[i] = o;
      }
    return a;
  }, {});
  return r;
}
function vG(t, e) {
  var n = Object.assign({}, e, {
    content: ute(e.content, [t])
  }, e.ignoreAttributes ? {} : cbe(t, e.plugins));
  return n.aria = Object.assign({}, Fc.aria, n.aria), n.aria = {
    expanded: n.aria.expanded === "auto" ? e.interactive : n.aria.expanded,
    content: n.aria.content === "auto" ? e.interactive ? null : "describedby" : n.aria.content
  }, n;
}
function hte(t, e) {
  t === void 0 && (t = {}), e === void 0 && (e = []);
  var n = Object.keys(t);
  n.forEach(function(r) {
    var a = Wge(Fc, Object.keys(dte)), i = !Hge(a, r);
    i && (i = e.filter(function(o) {
      return o.name === r;
    }).length === 0), Ym(i, ["`" + r + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", "a plugin, forgot to pass it in an array as props.plugins.", `

`, `All props: https://atomiks.github.io/tippyjs/v6/all-props/
`, "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"].join(" "));
  });
}
var fbe = function() {
  return "innerHTML";
};
function bF(t, e) {
  t[fbe()] = e;
}
function yG(t) {
  var e = jw();
  return t === !0 ? e.className = ote : (e.className = ste, TT(t) ? e.appendChild(t) : bF(e, t)), e;
}
function OG(t, e) {
  TT(e.content) ? (bF(t, ""), t.appendChild(e.content)) : typeof e.content != "function" && (e.allowHTML ? bF(t, e.content) : t.textContent = e.content);
}
function vF(t) {
  var e = t.firstElementChild, n = Wk(e.children);
  return {
    box: e,
    content: n.find(function(r) {
      return r.classList.contains(ite);
    }),
    arrow: n.find(function(r) {
      return r.classList.contains(ote) || r.classList.contains(ste);
    }),
    backdrop: n.find(function(r) {
      return r.classList.contains(zge);
    })
  };
}
function mte(t) {
  var e = jw(), n = jw();
  n.className = Uge, n.setAttribute("data-state", "hidden"), n.setAttribute("tabindex", "-1");
  var r = jw();
  r.className = ite, r.setAttribute("data-state", "hidden"), OG(r, t.props), e.appendChild(n), n.appendChild(r), a(t.props, t.props);
  function a(i, o) {
    var s = vF(e), u = s.box, f = s.content, p = s.arrow;
    o.theme ? u.setAttribute("data-theme", o.theme) : u.removeAttribute("data-theme"), typeof o.animation == "string" ? u.setAttribute("data-animation", o.animation) : u.removeAttribute("data-animation"), o.inertia ? u.setAttribute("data-inertia", "") : u.removeAttribute("data-inertia"), u.style.maxWidth = typeof o.maxWidth == "number" ? o.maxWidth + "px" : o.maxWidth, o.role ? u.setAttribute("role", o.role) : u.removeAttribute("role"), (i.content !== o.content || i.allowHTML !== o.allowHTML) && OG(f, t.props), o.arrow ? p ? i.arrow !== o.arrow && (u.removeChild(p), u.appendChild(yG(o.arrow))) : u.appendChild(yG(o.arrow)) : p && u.removeChild(p);
  }
  return {
    popper: e,
    onUpdate: a
  };
}
mte.$$tippy = !0;
var dbe = 1, wx = [], mM = [];
function pbe(t, e) {
  var n = vG(t, Object.assign({}, Fc, pte(pG(e)))), r, a, i, o = !1, s = !1, u = !1, f = !1, p, m, v, O = [], w = fG(st, n.interactiveDebounce), _, C = dbe++, A = null, N = jge(n.plugins), P = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, I = {
    // properties
    id: C,
    reference: t,
    popper: jw(),
    popperInstance: A,
    props: n,
    state: P,
    plugins: N,
    // methods
    clearDelayTimeouts: Ve,
    setProps: Ie,
    setContent: it,
    show: zt,
    hide: Ht,
    hideWithInteractivity: bt,
    enable: Ut,
    disable: He,
    unmount: Mt,
    destroy: ln
  };
  if (!n.render)
    return process.env.NODE_ENV !== "production" && gF(!0, "render() function has not been supplied."), I;
  var D = n.render(I), M = D.popper, H = D.onUpdate;
  M.setAttribute("data-tippy-root", ""), M.id = "tippy-" + I.id, I.popper = M, t._tippy = I, M._tippy = I;
  var Y = N.map(function(ze) {
    return ze.fn(I);
  }), q = t.hasAttribute("aria-expanded");
  return je(), B(), ie(), le("onCreate", [I]), n.showOnCreate && Yt(), M.addEventListener("mouseenter", function() {
    I.props.interactive && I.state.isVisible && I.clearDelayTimeouts();
  }), M.addEventListener("mouseleave", function() {
    I.props.interactive && I.props.trigger.indexOf("mouseenter") >= 0 && ee().addEventListener("mousemove", w);
  }), I;
  function Q() {
    var ze = I.props.touch;
    return Array.isArray(ze) ? ze : [ze, 0];
  }
  function ne() {
    return Q()[0] === "hold";
  }
  function J() {
    var ze;
    return !!((ze = I.props.render) != null && ze.$$tippy);
  }
  function ue() {
    return _ || t;
  }
  function ee() {
    var ze = ue().parentNode;
    return ze ? qge(ze) : document;
  }
  function fe() {
    return vF(M);
  }
  function de(ze) {
    return I.state.isMounted && !I.state.isVisible || hh.isTouch || p && p.type === "focus" ? 0 : dM(I.props.delay, ze ? 0 : 1, Fc.delay);
  }
  function ie(ze) {
    ze === void 0 && (ze = !1), M.style.pointerEvents = I.props.interactive && !ze ? "" : "none", M.style.zIndex = "" + I.props.zIndex;
  }
  function le(ze, gt, Bt) {
    if (Bt === void 0 && (Bt = !0), Y.forEach(function(En) {
      En[ze] && En[ze].apply(En, gt);
    }), Bt) {
      var Qt;
      (Qt = I.props)[ze].apply(Qt, gt);
    }
  }
  function ye() {
    var ze = I.props.aria;
    if (ze.content) {
      var gt = "aria-" + ze.content, Bt = M.id, Qt = iE(I.props.triggerTarget || t);
      Qt.forEach(function(En) {
        var Mn = En.getAttribute(gt);
        if (I.state.isVisible)
          En.setAttribute(gt, Mn ? Mn + " " + Bt : Bt);
        else {
          var br = Mn && Mn.replace(Bt, "").trim();
          br ? En.setAttribute(gt, br) : En.removeAttribute(gt);
        }
      });
    }
  }
  function B() {
    if (!(q || !I.props.aria.expanded)) {
      var ze = iE(I.props.triggerTarget || t);
      ze.forEach(function(gt) {
        I.props.interactive ? gt.setAttribute("aria-expanded", I.state.isVisible && gt === ue() ? "true" : "false") : gt.removeAttribute("aria-expanded");
      });
    }
  }
  function pe() {
    ee().removeEventListener("mousemove", w), wx = wx.filter(function(ze) {
      return ze !== w;
    });
  }
  function _e(ze) {
    if (!(hh.isTouch && (u || ze.type === "mousedown"))) {
      var gt = ze.composedPath && ze.composedPath()[0] || ze.target;
      if (!(I.props.interactive && mG(M, gt))) {
        if (iE(I.props.triggerTarget || t).some(function(Bt) {
          return mG(Bt, gt);
        })) {
          if (hh.isTouch || I.state.isVisible && I.props.trigger.indexOf("click") >= 0)
            return;
        } else
          le("onClickOutside", [I, ze]);
        I.props.hideOnClick === !0 && (I.clearDelayTimeouts(), I.hide(), s = !0, setTimeout(function() {
          s = !1;
        }), I.state.isMounted || K());
      }
    }
  }
  function Z() {
    u = !0;
  }
  function ce() {
    u = !1;
  }
  function j() {
    var ze = ee();
    ze.addEventListener("mousedown", _e, !0), ze.addEventListener("touchend", _e, Qy), ze.addEventListener("touchstart", ce, Qy), ze.addEventListener("touchmove", Z, Qy);
  }
  function K() {
    var ze = ee();
    ze.removeEventListener("mousedown", _e, !0), ze.removeEventListener("touchend", _e, Qy), ze.removeEventListener("touchstart", ce, Qy), ze.removeEventListener("touchmove", Z, Qy);
  }
  function Ee(ze, gt) {
    Ae(ze, function() {
      !I.state.isVisible && M.parentNode && M.parentNode.contains(M) && gt();
    });
  }
  function he(ze, gt) {
    Ae(ze, gt);
  }
  function Ae(ze, gt) {
    var Bt = fe().box;
    function Qt(En) {
      En.target === Bt && (hM(Bt, "remove", Qt), gt());
    }
    if (ze === 0)
      return gt();
    hM(Bt, "remove", m), hM(Bt, "add", Qt), m = Qt;
  }
  function Te(ze, gt, Bt) {
    Bt === void 0 && (Bt = !1);
    var Qt = iE(I.props.triggerTarget || t);
    Qt.forEach(function(En) {
      En.addEventListener(ze, gt, Bt), O.push({
        node: En,
        eventType: ze,
        handler: gt,
        options: Bt
      });
    });
  }
  function je() {
    ne() && (Te("touchstart", lt, {
      passive: !0
    }), Te("touchend", Oe, {
      passive: !0
    })), Qge(I.props.trigger).forEach(function(ze) {
      if (ze !== "manual")
        switch (Te(ze, lt), ze) {
          case "mouseenter":
            Te("mouseleave", Oe);
            break;
          case "focus":
            Te(rbe ? "focusout" : "blur", Re);
            break;
          case "focusin":
            Te("focusout", Re);
            break;
        }
    });
  }
  function we() {
    O.forEach(function(ze) {
      var gt = ze.node, Bt = ze.eventType, Qt = ze.handler, En = ze.options;
      gt.removeEventListener(Bt, Qt, En);
    }), O = [];
  }
  function lt(ze) {
    var gt, Bt = !1;
    if (!(!I.state.isEnabled || Be(ze) || s)) {
      var Qt = ((gt = p) == null ? void 0 : gt.type) === "focus";
      p = ze, _ = ze.currentTarget, B(), !I.state.isVisible && Yge(ze) && wx.forEach(function(En) {
        return En(ze);
      }), ze.type === "click" && (I.props.trigger.indexOf("mouseenter") < 0 || o) && I.props.hideOnClick !== !1 && I.state.isVisible ? Bt = !0 : Yt(ze), ze.type === "click" && (o = !Bt), Bt && !Qt && Rt(ze);
    }
  }
  function st(ze) {
    var gt = ze.target, Bt = ue().contains(gt) || M.contains(gt);
    if (!(ze.type === "mousemove" && Bt)) {
      var Qt = wt().concat(M).map(function(En) {
        var Mn, br = En._tippy, sr = (Mn = br.popperInstance) == null ? void 0 : Mn.state;
        return sr ? {
          popperRect: En.getBoundingClientRect(),
          popperState: sr,
          props: n
        } : null;
      }).filter(Boolean);
      Kge(Qt, ze) && (pe(), Rt(ze));
    }
  }
  function Oe(ze) {
    var gt = Be(ze) || I.props.trigger.indexOf("click") >= 0 && o;
    if (!gt) {
      if (I.props.interactive) {
        I.hideWithInteractivity(ze);
        return;
      }
      Rt(ze);
    }
  }
  function Re(ze) {
    I.props.trigger.indexOf("focusin") < 0 && ze.target !== ue() || I.props.interactive && ze.relatedTarget && M.contains(ze.relatedTarget) || Rt(ze);
  }
  function Be(ze) {
    return hh.isTouch ? ne() !== ze.type.indexOf("touch") >= 0 : !1;
  }
  function mt() {
    Tt();
    var ze = I.props, gt = ze.popperOptions, Bt = ze.placement, Qt = ze.offset, En = ze.getReferenceClientRect, Mn = ze.moveTransition, br = J() ? vF(M).arrow : null, sr = En ? {
      getBoundingClientRect: En,
      contextElement: En.contextElement || ue()
    } : t, Ar = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(Ni) {
        var oi = Ni.state;
        if (J()) {
          var gu = fe(), ho = gu.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(Jo) {
            Jo === "placement" ? ho.setAttribute("data-placement", oi.placement) : oi.attributes.popper["data-popper-" + Jo] ? ho.setAttribute("data-" + Jo, "") : ho.removeAttribute("data-" + Jo);
          }), oi.attributes.popper = {};
        }
      }
    }, Ji = [{
      name: "offset",
      options: {
        offset: Qt
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !Mn
      }
    }, Ar];
    J() && br && Ji.push({
      name: "arrow",
      options: {
        element: br,
        padding: 3
      }
    }), Ji.push.apply(Ji, (gt == null ? void 0 : gt.modifiers) || []), I.popperInstance = ate(sr, M, Object.assign({}, gt, {
      placement: Bt,
      onFirstUpdate: v,
      modifiers: Ji
    }));
  }
  function Tt() {
    I.popperInstance && (I.popperInstance.destroy(), I.popperInstance = null);
  }
  function ut() {
    var ze = I.props.appendTo, gt, Bt = ue();
    I.props.interactive && ze === lte || ze === "parent" ? gt = Bt.parentNode : gt = ute(ze, [Bt]), gt.contains(M) || gt.appendChild(M), I.state.isMounted = !0, mt(), process.env.NODE_ENV !== "production" && Ym(I.props.interactive && ze === Fc.appendTo && Bt.nextElementSibling !== M, ["Interactive tippy element may not be accessible via keyboard", "navigation because it is not directly after the reference element", "in the DOM source order.", `

`, "Using a wrapper <div> or <span> tag around the reference element", "solves this by creating a new parentNode context.", `

`, "Specifying `appendTo: document.body` silences this warning, but it", "assumes you are using a focus management solution to handle", "keyboard navigation.", `

`, "See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"].join(" "));
  }
  function wt() {
    return Wk(M.querySelectorAll("[data-tippy-root]"));
  }
  function Yt(ze) {
    I.clearDelayTimeouts(), ze && le("onTrigger", [I, ze]), j();
    var gt = de(!0), Bt = Q(), Qt = Bt[0], En = Bt[1];
    hh.isTouch && Qt === "hold" && En && (gt = En), gt ? r = setTimeout(function() {
      I.show();
    }, gt) : I.show();
  }
  function Rt(ze) {
    if (I.clearDelayTimeouts(), le("onUntrigger", [I, ze]), !I.state.isVisible) {
      K();
      return;
    }
    if (!(I.props.trigger.indexOf("mouseenter") >= 0 && I.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(ze.type) >= 0 && o)) {
      var gt = de(!1);
      gt ? a = setTimeout(function() {
        I.state.isVisible && I.hide();
      }, gt) : i = requestAnimationFrame(function() {
        I.hide();
      });
    }
  }
  function Ut() {
    I.state.isEnabled = !0;
  }
  function He() {
    I.hide(), I.state.isEnabled = !1;
  }
  function Ve() {
    clearTimeout(r), clearTimeout(a), cancelAnimationFrame(i);
  }
  function Ie(ze) {
    if (process.env.NODE_ENV !== "production" && Ym(I.state.isDestroyed, GO("setProps")), !I.state.isDestroyed) {
      le("onBeforeUpdate", [I, ze]), we();
      var gt = I.props, Bt = vG(t, Object.assign({}, gt, pG(ze), {
        ignoreAttributes: !0
      }));
      I.props = Bt, je(), gt.interactiveDebounce !== Bt.interactiveDebounce && (pe(), w = fG(st, Bt.interactiveDebounce)), gt.triggerTarget && !Bt.triggerTarget ? iE(gt.triggerTarget).forEach(function(Qt) {
        Qt.removeAttribute("aria-expanded");
      }) : Bt.triggerTarget && t.removeAttribute("aria-expanded"), B(), ie(), H && H(gt, Bt), I.popperInstance && (mt(), wt().forEach(function(Qt) {
        requestAnimationFrame(Qt._tippy.popperInstance.forceUpdate);
      })), le("onAfterUpdate", [I, ze]);
    }
  }
  function it(ze) {
    I.setProps({
      content: ze
    });
  }
  function zt() {
    process.env.NODE_ENV !== "production" && Ym(I.state.isDestroyed, GO("show"));
    var ze = I.state.isVisible, gt = I.state.isDestroyed, Bt = !I.state.isEnabled, Qt = hh.isTouch && !I.props.touch, En = dM(I.props.duration, 0, Fc.duration);
    if (!(ze || gt || Bt || Qt) && !ue().hasAttribute("disabled") && (le("onShow", [I], !1), I.props.onShow(I) !== !1)) {
      if (I.state.isVisible = !0, J() && (M.style.visibility = "visible"), ie(), j(), I.state.isMounted || (M.style.transition = "none"), J()) {
        var Mn = fe(), br = Mn.box, sr = Mn.content;
        pM([br, sr], 0);
      }
      v = function() {
        var Ji;
        if (!(!I.state.isVisible || f)) {
          if (f = !0, M.offsetHeight, M.style.transition = I.props.moveTransition, J() && I.props.animation) {
            var po = fe(), Ni = po.box, oi = po.content;
            pM([Ni, oi], En), hG([Ni, oi], "visible");
          }
          ye(), B(), dG(mM, I), (Ji = I.popperInstance) == null || Ji.forceUpdate(), le("onMount", [I]), I.props.animation && J() && he(En, function() {
            I.state.isShown = !0, le("onShown", [I]);
          });
        }
      }, ut();
    }
  }
  function Ht() {
    process.env.NODE_ENV !== "production" && Ym(I.state.isDestroyed, GO("hide"));
    var ze = !I.state.isVisible, gt = I.state.isDestroyed, Bt = !I.state.isEnabled, Qt = dM(I.props.duration, 1, Fc.duration);
    if (!(ze || gt || Bt) && (le("onHide", [I], !1), I.props.onHide(I) !== !1)) {
      if (I.state.isVisible = !1, I.state.isShown = !1, f = !1, o = !1, J() && (M.style.visibility = "hidden"), pe(), K(), ie(!0), J()) {
        var En = fe(), Mn = En.box, br = En.content;
        I.props.animation && (pM([Mn, br], Qt), hG([Mn, br], "hidden"));
      }
      ye(), B(), I.props.animation ? J() && Ee(Qt, I.unmount) : I.unmount();
    }
  }
  function bt(ze) {
    process.env.NODE_ENV !== "production" && Ym(I.state.isDestroyed, GO("hideWithInteractivity")), ee().addEventListener("mousemove", w), dG(wx, w), w(ze);
  }
  function Mt() {
    process.env.NODE_ENV !== "production" && Ym(I.state.isDestroyed, GO("unmount")), I.state.isVisible && I.hide(), I.state.isMounted && (Tt(), wt().forEach(function(ze) {
      ze._tippy.unmount();
    }), M.parentNode && M.parentNode.removeChild(M), mM = mM.filter(function(ze) {
      return ze !== I;
    }), I.state.isMounted = !1, le("onHidden", [I]));
  }
  function ln() {
    process.env.NODE_ENV !== "production" && Ym(I.state.isDestroyed, GO("destroy")), !I.state.isDestroyed && (I.clearDelayTimeouts(), I.unmount(), we(), delete t._tippy, I.state.isDestroyed = !0, le("onDestroy", [I]));
  }
}
function f_(t, e) {
  e === void 0 && (e = {});
  var n = Fc.plugins.concat(e.plugins || []);
  process.env.NODE_ENV !== "production" && (obe(t), hte(e, n)), tbe();
  var r = Object.assign({}, e, {
    plugins: n
  }), a = Xge(t);
  if (process.env.NODE_ENV !== "production") {
    var i = TT(r.content), o = a.length > 1;
    Ym(i && o, ["tippy() was passed an Element as the `content` prop, but more than", "one tippy instance was created by this invocation. This means the", "content element will only be appended to the last tippy instance.", `

`, "Instead, pass the .innerHTML of the element, or use a function that", "returns a cloned version of the element instead.", `

`, `1) content: element.innerHTML
`, "2) content: () => element.cloneNode(true)"].join(" "));
  }
  var s = a.reduce(function(u, f) {
    var p = f && pbe(f, r);
    return p && u.push(p), u;
  }, []);
  return TT(t) ? s[0] : s;
}
f_.defaultProps = Fc;
f_.setDefaultProps = ube;
f_.currentInput = hh;
Object.assign({}, Xee, {
  effect: function(e) {
    var n = e.state, r = {
      popper: {
        position: n.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(n.elements.popper.style, r.popper), n.styles = r, n.elements.arrow && Object.assign(n.elements.arrow.style, r.arrow);
  }
});
f_.setDefaultProps({
  render: mte
});
var yF = { exports: {} }, Wu = {}, Tx = { exports: {} }, gM = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var EG;
function hbe() {
  return EG || (EG = 1, function(t) {
    function e(le, ye) {
      var B = le.length;
      le.push(ye);
      e:
        for (; 0 < B; ) {
          var pe = B - 1 >>> 1, _e = le[pe];
          if (0 < a(_e, ye))
            le[pe] = ye, le[B] = _e, B = pe;
          else
            break e;
        }
    }
    function n(le) {
      return le.length === 0 ? null : le[0];
    }
    function r(le) {
      if (le.length === 0)
        return null;
      var ye = le[0], B = le.pop();
      if (B !== ye) {
        le[0] = B;
        e:
          for (var pe = 0, _e = le.length, Z = _e >>> 1; pe < Z; ) {
            var ce = 2 * (pe + 1) - 1, j = le[ce], K = ce + 1, Ee = le[K];
            if (0 > a(j, B))
              K < _e && 0 > a(Ee, j) ? (le[pe] = Ee, le[K] = B, pe = K) : (le[pe] = j, le[ce] = B, pe = ce);
            else if (K < _e && 0 > a(Ee, B))
              le[pe] = Ee, le[K] = B, pe = K;
            else
              break e;
          }
      }
      return ye;
    }
    function a(le, ye) {
      var B = le.sortIndex - ye.sortIndex;
      return B !== 0 ? B : le.id - ye.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
      var i = performance;
      t.unstable_now = function() {
        return i.now();
      };
    } else {
      var o = Date, s = o.now();
      t.unstable_now = function() {
        return o.now() - s;
      };
    }
    var u = [], f = [], p = 1, m = null, v = 3, O = !1, w = !1, _ = !1, C = typeof setTimeout == "function" ? setTimeout : null, A = typeof clearTimeout == "function" ? clearTimeout : null, N = typeof setImmediate < "u" ? setImmediate : null;
    typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function P(le) {
      for (var ye = n(f); ye !== null; ) {
        if (ye.callback === null)
          r(f);
        else if (ye.startTime <= le)
          r(f), ye.sortIndex = ye.expirationTime, e(u, ye);
        else
          break;
        ye = n(f);
      }
    }
    function I(le) {
      if (_ = !1, P(le), !w)
        if (n(u) !== null)
          w = !0, de(D);
        else {
          var ye = n(f);
          ye !== null && ie(I, ye.startTime - le);
        }
    }
    function D(le, ye) {
      w = !1, _ && (_ = !1, A(Y), Y = -1), O = !0;
      var B = v;
      try {
        for (P(ye), m = n(u); m !== null && (!(m.expirationTime > ye) || le && !ne()); ) {
          var pe = m.callback;
          if (typeof pe == "function") {
            m.callback = null, v = m.priorityLevel;
            var _e = pe(m.expirationTime <= ye);
            ye = t.unstable_now(), typeof _e == "function" ? m.callback = _e : m === n(u) && r(u), P(ye);
          } else
            r(u);
          m = n(u);
        }
        if (m !== null)
          var Z = !0;
        else {
          var ce = n(f);
          ce !== null && ie(I, ce.startTime - ye), Z = !1;
        }
        return Z;
      } finally {
        m = null, v = B, O = !1;
      }
    }
    var M = !1, H = null, Y = -1, q = 5, Q = -1;
    function ne() {
      return !(t.unstable_now() - Q < q);
    }
    function J() {
      if (H !== null) {
        var le = t.unstable_now();
        Q = le;
        var ye = !0;
        try {
          ye = H(!0, le);
        } finally {
          ye ? ue() : (M = !1, H = null);
        }
      } else
        M = !1;
    }
    var ue;
    if (typeof N == "function")
      ue = function() {
        N(J);
      };
    else if (typeof MessageChannel < "u") {
      var ee = new MessageChannel(), fe = ee.port2;
      ee.port1.onmessage = J, ue = function() {
        fe.postMessage(null);
      };
    } else
      ue = function() {
        C(J, 0);
      };
    function de(le) {
      H = le, M || (M = !0, ue());
    }
    function ie(le, ye) {
      Y = C(function() {
        le(t.unstable_now());
      }, ye);
    }
    t.unstable_IdlePriority = 5, t.unstable_ImmediatePriority = 1, t.unstable_LowPriority = 4, t.unstable_NormalPriority = 3, t.unstable_Profiling = null, t.unstable_UserBlockingPriority = 2, t.unstable_cancelCallback = function(le) {
      le.callback = null;
    }, t.unstable_continueExecution = function() {
      w || O || (w = !0, de(D));
    }, t.unstable_forceFrameRate = function(le) {
      0 > le || 125 < le ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : q = 0 < le ? Math.floor(1e3 / le) : 5;
    }, t.unstable_getCurrentPriorityLevel = function() {
      return v;
    }, t.unstable_getFirstCallbackNode = function() {
      return n(u);
    }, t.unstable_next = function(le) {
      switch (v) {
        case 1:
        case 2:
        case 3:
          var ye = 3;
          break;
        default:
          ye = v;
      }
      var B = v;
      v = ye;
      try {
        return le();
      } finally {
        v = B;
      }
    }, t.unstable_pauseExecution = function() {
    }, t.unstable_requestPaint = function() {
    }, t.unstable_runWithPriority = function(le, ye) {
      switch (le) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          le = 3;
      }
      var B = v;
      v = le;
      try {
        return ye();
      } finally {
        v = B;
      }
    }, t.unstable_scheduleCallback = function(le, ye, B) {
      var pe = t.unstable_now();
      switch (typeof B == "object" && B !== null ? (B = B.delay, B = typeof B == "number" && 0 < B ? pe + B : pe) : B = pe, le) {
        case 1:
          var _e = -1;
          break;
        case 2:
          _e = 250;
          break;
        case 5:
          _e = 1073741823;
          break;
        case 4:
          _e = 1e4;
          break;
        default:
          _e = 5e3;
      }
      return _e = B + _e, le = { id: p++, callback: ye, priorityLevel: le, startTime: B, expirationTime: _e, sortIndex: -1 }, B > pe ? (le.sortIndex = B, e(f, le), n(u) === null && le === n(f) && (_ ? (A(Y), Y = -1) : _ = !0, ie(I, B - pe))) : (le.sortIndex = _e, e(u, le), w || O || (w = !0, de(D))), le;
    }, t.unstable_shouldYield = ne, t.unstable_wrapCallback = function(le) {
      var ye = v;
      return function() {
        var B = v;
        v = ye;
        try {
          return le.apply(this, arguments);
        } finally {
          v = B;
        }
      };
    };
  }(gM)), gM;
}
var bM = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var SG;
function mbe() {
  return SG || (SG = 1, function(t) {
    process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var e = !1, n = !1, r = 5;
      function a(bt, Mt) {
        var ln = bt.length;
        bt.push(Mt), s(bt, Mt, ln);
      }
      function i(bt) {
        return bt.length === 0 ? null : bt[0];
      }
      function o(bt) {
        if (bt.length === 0)
          return null;
        var Mt = bt[0], ln = bt.pop();
        return ln !== Mt && (bt[0] = ln, u(bt, ln, 0)), Mt;
      }
      function s(bt, Mt, ln) {
        for (var ze = ln; ze > 0; ) {
          var gt = ze - 1 >>> 1, Bt = bt[gt];
          if (f(Bt, Mt) > 0)
            bt[gt] = Mt, bt[ze] = Bt, ze = gt;
          else
            return;
        }
      }
      function u(bt, Mt, ln) {
        for (var ze = ln, gt = bt.length, Bt = gt >>> 1; ze < Bt; ) {
          var Qt = (ze + 1) * 2 - 1, En = bt[Qt], Mn = Qt + 1, br = bt[Mn];
          if (f(En, Mt) < 0)
            Mn < gt && f(br, En) < 0 ? (bt[ze] = br, bt[Mn] = Mt, ze = Mn) : (bt[ze] = En, bt[Qt] = Mt, ze = Qt);
          else if (Mn < gt && f(br, Mt) < 0)
            bt[ze] = br, bt[Mn] = Mt, ze = Mn;
          else
            return;
        }
      }
      function f(bt, Mt) {
        var ln = bt.sortIndex - Mt.sortIndex;
        return ln !== 0 ? ln : bt.id - Mt.id;
      }
      var p = 1, m = 2, v = 3, O = 4, w = 5;
      function _(bt, Mt) {
      }
      var C = typeof performance == "object" && typeof performance.now == "function";
      if (C) {
        var A = performance;
        t.unstable_now = function() {
          return A.now();
        };
      } else {
        var N = Date, P = N.now();
        t.unstable_now = function() {
          return N.now() - P;
        };
      }
      var I = 1073741823, D = -1, M = 250, H = 5e3, Y = 1e4, q = I, Q = [], ne = [], J = 1, ue = null, ee = v, fe = !1, de = !1, ie = !1, le = typeof setTimeout == "function" ? setTimeout : null, ye = typeof clearTimeout == "function" ? clearTimeout : null, B = typeof setImmediate < "u" ? setImmediate : null;
      typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
      function pe(bt) {
        for (var Mt = i(ne); Mt !== null; ) {
          if (Mt.callback === null)
            o(ne);
          else if (Mt.startTime <= bt)
            o(ne), Mt.sortIndex = Mt.expirationTime, a(Q, Mt);
          else
            return;
          Mt = i(ne);
        }
      }
      function _e(bt) {
        if (ie = !1, pe(bt), !de)
          if (i(Q) !== null)
            de = !0, Ve(Z);
          else {
            var Mt = i(ne);
            Mt !== null && Ie(_e, Mt.startTime - bt);
          }
      }
      function Z(bt, Mt) {
        de = !1, ie && (ie = !1, it()), fe = !0;
        var ln = ee;
        try {
          var ze;
          if (!n)
            return ce(bt, Mt);
        } finally {
          ue = null, ee = ln, fe = !1;
        }
      }
      function ce(bt, Mt) {
        var ln = Mt;
        for (pe(ln), ue = i(Q); ue !== null && !e && !(ue.expirationTime > ln && (!bt || Tt())); ) {
          var ze = ue.callback;
          if (typeof ze == "function") {
            ue.callback = null, ee = ue.priorityLevel;
            var gt = ue.expirationTime <= ln, Bt = ze(gt);
            ln = t.unstable_now(), typeof Bt == "function" ? ue.callback = Bt : ue === i(Q) && o(Q), pe(ln);
          } else
            o(Q);
          ue = i(Q);
        }
        if (ue !== null)
          return !0;
        var Qt = i(ne);
        return Qt !== null && Ie(_e, Qt.startTime - ln), !1;
      }
      function j(bt, Mt) {
        switch (bt) {
          case p:
          case m:
          case v:
          case O:
          case w:
            break;
          default:
            bt = v;
        }
        var ln = ee;
        ee = bt;
        try {
          return Mt();
        } finally {
          ee = ln;
        }
      }
      function K(bt) {
        var Mt;
        switch (ee) {
          case p:
          case m:
          case v:
            Mt = v;
            break;
          default:
            Mt = ee;
            break;
        }
        var ln = ee;
        ee = Mt;
        try {
          return bt();
        } finally {
          ee = ln;
        }
      }
      function Ee(bt) {
        var Mt = ee;
        return function() {
          var ln = ee;
          ee = Mt;
          try {
            return bt.apply(this, arguments);
          } finally {
            ee = ln;
          }
        };
      }
      function he(bt, Mt, ln) {
        var ze = t.unstable_now(), gt;
        if (typeof ln == "object" && ln !== null) {
          var Bt = ln.delay;
          typeof Bt == "number" && Bt > 0 ? gt = ze + Bt : gt = ze;
        } else
          gt = ze;
        var Qt;
        switch (bt) {
          case p:
            Qt = D;
            break;
          case m:
            Qt = M;
            break;
          case w:
            Qt = q;
            break;
          case O:
            Qt = Y;
            break;
          case v:
          default:
            Qt = H;
            break;
        }
        var En = gt + Qt, Mn = {
          id: J++,
          callback: Mt,
          priorityLevel: bt,
          startTime: gt,
          expirationTime: En,
          sortIndex: -1
        };
        return gt > ze ? (Mn.sortIndex = gt, a(ne, Mn), i(Q) === null && Mn === i(ne) && (ie ? it() : ie = !0, Ie(_e, gt - ze))) : (Mn.sortIndex = En, a(Q, Mn), !de && !fe && (de = !0, Ve(Z))), Mn;
      }
      function Ae() {
      }
      function Te() {
        !de && !fe && (de = !0, Ve(Z));
      }
      function je() {
        return i(Q);
      }
      function we(bt) {
        bt.callback = null;
      }
      function lt() {
        return ee;
      }
      var st = !1, Oe = null, Re = -1, Be = r, mt = -1;
      function Tt() {
        var bt = t.unstable_now() - mt;
        return !(bt < Be);
      }
      function ut() {
      }
      function wt(bt) {
        if (bt < 0 || bt > 125) {
          console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
          return;
        }
        bt > 0 ? Be = Math.floor(1e3 / bt) : Be = r;
      }
      var Yt = function() {
        if (Oe !== null) {
          var bt = t.unstable_now();
          mt = bt;
          var Mt = !0, ln = !0;
          try {
            ln = Oe(Mt, bt);
          } finally {
            ln ? Rt() : (st = !1, Oe = null);
          }
        } else
          st = !1;
      }, Rt;
      if (typeof B == "function")
        Rt = function() {
          B(Yt);
        };
      else if (typeof MessageChannel < "u") {
        var Ut = new MessageChannel(), He = Ut.port2;
        Ut.port1.onmessage = Yt, Rt = function() {
          He.postMessage(null);
        };
      } else
        Rt = function() {
          le(Yt, 0);
        };
      function Ve(bt) {
        Oe = bt, st || (st = !0, Rt());
      }
      function Ie(bt, Mt) {
        Re = le(function() {
          bt(t.unstable_now());
        }, Mt);
      }
      function it() {
        ye(Re), Re = -1;
      }
      var zt = ut, Ht = null;
      t.unstable_IdlePriority = w, t.unstable_ImmediatePriority = p, t.unstable_LowPriority = O, t.unstable_NormalPriority = v, t.unstable_Profiling = Ht, t.unstable_UserBlockingPriority = m, t.unstable_cancelCallback = we, t.unstable_continueExecution = Te, t.unstable_forceFrameRate = wt, t.unstable_getCurrentPriorityLevel = lt, t.unstable_getFirstCallbackNode = je, t.unstable_next = K, t.unstable_pauseExecution = Ae, t.unstable_requestPaint = zt, t.unstable_runWithPriority = j, t.unstable_scheduleCallback = he, t.unstable_shouldYield = Tt, t.unstable_wrapCallback = Ee, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(bM)), bM;
}
var wG;
function gte() {
  return wG || (wG = 1, process.env.NODE_ENV === "production" ? Tx.exports = hbe() : Tx.exports = mbe()), Tx.exports;
}
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var TG;
function gbe() {
  if (TG)
    return Wu;
  TG = 1;
  var t = Ge, e = gte();
  function n(d) {
    for (var h = "https://reactjs.org/docs/error-decoder.html?invariant=" + d, S = 1; S < arguments.length; S++)
      h += "&args[]=" + encodeURIComponent(arguments[S]);
    return "Minified React error #" + d + "; visit " + h + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var r = /* @__PURE__ */ new Set(), a = {};
  function i(d, h) {
    o(d, h), o(d + "Capture", h);
  }
  function o(d, h) {
    for (a[d] = h, d = 0; d < h.length; d++)
      r.add(h[d]);
  }
  var s = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), u = Object.prototype.hasOwnProperty, f = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, p = {}, m = {};
  function v(d) {
    return u.call(m, d) ? !0 : u.call(p, d) ? !1 : f.test(d) ? m[d] = !0 : (p[d] = !0, !1);
  }
  function O(d, h, S, x) {
    if (S !== null && S.type === 0)
      return !1;
    switch (typeof h) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return x ? !1 : S !== null ? !S.acceptsBooleans : (d = d.toLowerCase().slice(0, 5), d !== "data-" && d !== "aria-");
      default:
        return !1;
    }
  }
  function w(d, h, S, x) {
    if (h === null || typeof h > "u" || O(d, h, S, x))
      return !0;
    if (x)
      return !1;
    if (S !== null)
      switch (S.type) {
        case 3:
          return !h;
        case 4:
          return h === !1;
        case 5:
          return isNaN(h);
        case 6:
          return isNaN(h) || 1 > h;
      }
    return !1;
  }
  function _(d, h, S, x, F, U, X) {
    this.acceptsBooleans = h === 2 || h === 3 || h === 4, this.attributeName = x, this.attributeNamespace = F, this.mustUseProperty = S, this.propertyName = d, this.type = h, this.sanitizeURL = U, this.removeEmptyString = X;
  }
  var C = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(d) {
    C[d] = new _(d, 0, !1, d, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(d) {
    var h = d[0];
    C[h] = new _(h, 1, !1, d[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(d) {
    C[d] = new _(d, 2, !1, d.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(d) {
    C[d] = new _(d, 2, !1, d, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(d) {
    C[d] = new _(d, 3, !1, d.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(d) {
    C[d] = new _(d, 3, !0, d, null, !1, !1);
  }), ["capture", "download"].forEach(function(d) {
    C[d] = new _(d, 4, !1, d, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(d) {
    C[d] = new _(d, 6, !1, d, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(d) {
    C[d] = new _(d, 5, !1, d.toLowerCase(), null, !1, !1);
  });
  var A = /[\-:]([a-z])/g;
  function N(d) {
    return d[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(d) {
    var h = d.replace(
      A,
      N
    );
    C[h] = new _(h, 1, !1, d, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(d) {
    var h = d.replace(A, N);
    C[h] = new _(h, 1, !1, d, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(d) {
    var h = d.replace(A, N);
    C[h] = new _(h, 1, !1, d, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(d) {
    C[d] = new _(d, 1, !1, d.toLowerCase(), null, !1, !1);
  }), C.xlinkHref = new _("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(d) {
    C[d] = new _(d, 1, !1, d.toLowerCase(), null, !0, !0);
  });
  function P(d, h, S, x) {
    var F = C.hasOwnProperty(h) ? C[h] : null;
    (F !== null ? F.type !== 0 : x || !(2 < h.length) || h[0] !== "o" && h[0] !== "O" || h[1] !== "n" && h[1] !== "N") && (w(h, S, F, x) && (S = null), x || F === null ? v(h) && (S === null ? d.removeAttribute(h) : d.setAttribute(h, "" + S)) : F.mustUseProperty ? d[F.propertyName] = S === null ? F.type === 3 ? !1 : "" : S : (h = F.attributeName, x = F.attributeNamespace, S === null ? d.removeAttribute(h) : (F = F.type, S = F === 3 || F === 4 && S === !0 ? "" : "" + S, x ? d.setAttributeNS(x, h, S) : d.setAttribute(h, S))));
  }
  var I = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, D = Symbol.for("react.element"), M = Symbol.for("react.portal"), H = Symbol.for("react.fragment"), Y = Symbol.for("react.strict_mode"), q = Symbol.for("react.profiler"), Q = Symbol.for("react.provider"), ne = Symbol.for("react.context"), J = Symbol.for("react.forward_ref"), ue = Symbol.for("react.suspense"), ee = Symbol.for("react.suspense_list"), fe = Symbol.for("react.memo"), de = Symbol.for("react.lazy"), ie = Symbol.for("react.offscreen"), le = Symbol.iterator;
  function ye(d) {
    return d === null || typeof d != "object" ? null : (d = le && d[le] || d["@@iterator"], typeof d == "function" ? d : null);
  }
  var B = Object.assign, pe;
  function _e(d) {
    if (pe === void 0)
      try {
        throw Error();
      } catch (S) {
        var h = S.stack.trim().match(/\n( *(at )?)/);
        pe = h && h[1] || "";
      }
    return `
` + pe + d;
  }
  var Z = !1;
  function ce(d, h) {
    if (!d || Z)
      return "";
    Z = !0;
    var S = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (h)
        if (h = function() {
          throw Error();
        }, Object.defineProperty(h.prototype, "props", { set: function() {
          throw Error();
        } }), typeof Reflect == "object" && Reflect.construct) {
          try {
            Reflect.construct(h, []);
          } catch (nt) {
            var x = nt;
          }
          Reflect.construct(d, [], h);
        } else {
          try {
            h.call();
          } catch (nt) {
            x = nt;
          }
          d.call(h.prototype);
        }
      else {
        try {
          throw Error();
        } catch (nt) {
          x = nt;
        }
        d();
      }
    } catch (nt) {
      if (nt && x && typeof nt.stack == "string") {
        for (var F = nt.stack.split(`
`), U = x.stack.split(`
`), X = F.length - 1, Se = U.length - 1; 1 <= X && 0 <= Se && F[X] !== U[Se]; )
          Se--;
        for (; 1 <= X && 0 <= Se; X--, Se--)
          if (F[X] !== U[Se]) {
            if (X !== 1 || Se !== 1)
              do
                if (X--, Se--, 0 > Se || F[X] !== U[Se]) {
                  var Pe = `
` + F[X].replace(" at new ", " at ");
                  return d.displayName && Pe.includes("<anonymous>") && (Pe = Pe.replace("<anonymous>", d.displayName)), Pe;
                }
              while (1 <= X && 0 <= Se);
            break;
          }
      }
    } finally {
      Z = !1, Error.prepareStackTrace = S;
    }
    return (d = d ? d.displayName || d.name : "") ? _e(d) : "";
  }
  function j(d) {
    switch (d.tag) {
      case 5:
        return _e(d.type);
      case 16:
        return _e("Lazy");
      case 13:
        return _e("Suspense");
      case 19:
        return _e("SuspenseList");
      case 0:
      case 2:
      case 15:
        return d = ce(d.type, !1), d;
      case 11:
        return d = ce(d.type.render, !1), d;
      case 1:
        return d = ce(d.type, !0), d;
      default:
        return "";
    }
  }
  function K(d) {
    if (d == null)
      return null;
    if (typeof d == "function")
      return d.displayName || d.name || null;
    if (typeof d == "string")
      return d;
    switch (d) {
      case H:
        return "Fragment";
      case M:
        return "Portal";
      case q:
        return "Profiler";
      case Y:
        return "StrictMode";
      case ue:
        return "Suspense";
      case ee:
        return "SuspenseList";
    }
    if (typeof d == "object")
      switch (d.$$typeof) {
        case ne:
          return (d.displayName || "Context") + ".Consumer";
        case Q:
          return (d._context.displayName || "Context") + ".Provider";
        case J:
          var h = d.render;
          return d = d.displayName, d || (d = h.displayName || h.name || "", d = d !== "" ? "ForwardRef(" + d + ")" : "ForwardRef"), d;
        case fe:
          return h = d.displayName || null, h !== null ? h : K(d.type) || "Memo";
        case de:
          h = d._payload, d = d._init;
          try {
            return K(d(h));
          } catch {
          }
      }
    return null;
  }
  function Ee(d) {
    var h = d.type;
    switch (d.tag) {
      case 24:
        return "Cache";
      case 9:
        return (h.displayName || "Context") + ".Consumer";
      case 10:
        return (h._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return d = h.render, d = d.displayName || d.name || "", h.displayName || (d !== "" ? "ForwardRef(" + d + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return h;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return K(h);
      case 8:
        return h === Y ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if (typeof h == "function")
          return h.displayName || h.name || null;
        if (typeof h == "string")
          return h;
    }
    return null;
  }
  function he(d) {
    switch (typeof d) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return d;
      case "object":
        return d;
      default:
        return "";
    }
  }
  function Ae(d) {
    var h = d.type;
    return (d = d.nodeName) && d.toLowerCase() === "input" && (h === "checkbox" || h === "radio");
  }
  function Te(d) {
    var h = Ae(d) ? "checked" : "value", S = Object.getOwnPropertyDescriptor(d.constructor.prototype, h), x = "" + d[h];
    if (!d.hasOwnProperty(h) && typeof S < "u" && typeof S.get == "function" && typeof S.set == "function") {
      var F = S.get, U = S.set;
      return Object.defineProperty(d, h, { configurable: !0, get: function() {
        return F.call(this);
      }, set: function(X) {
        x = "" + X, U.call(this, X);
      } }), Object.defineProperty(d, h, { enumerable: S.enumerable }), { getValue: function() {
        return x;
      }, setValue: function(X) {
        x = "" + X;
      }, stopTracking: function() {
        d._valueTracker = null, delete d[h];
      } };
    }
  }
  function je(d) {
    d._valueTracker || (d._valueTracker = Te(d));
  }
  function we(d) {
    if (!d)
      return !1;
    var h = d._valueTracker;
    if (!h)
      return !0;
    var S = h.getValue(), x = "";
    return d && (x = Ae(d) ? d.checked ? "true" : "false" : d.value), d = x, d !== S ? (h.setValue(d), !0) : !1;
  }
  function lt(d) {
    if (d = d || (typeof document < "u" ? document : void 0), typeof d > "u")
      return null;
    try {
      return d.activeElement || d.body;
    } catch {
      return d.body;
    }
  }
  function st(d, h) {
    var S = h.checked;
    return B({}, h, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: S ?? d._wrapperState.initialChecked });
  }
  function Oe(d, h) {
    var S = h.defaultValue == null ? "" : h.defaultValue, x = h.checked != null ? h.checked : h.defaultChecked;
    S = he(h.value != null ? h.value : S), d._wrapperState = { initialChecked: x, initialValue: S, controlled: h.type === "checkbox" || h.type === "radio" ? h.checked != null : h.value != null };
  }
  function Re(d, h) {
    h = h.checked, h != null && P(d, "checked", h, !1);
  }
  function Be(d, h) {
    Re(d, h);
    var S = he(h.value), x = h.type;
    if (S != null)
      x === "number" ? (S === 0 && d.value === "" || d.value != S) && (d.value = "" + S) : d.value !== "" + S && (d.value = "" + S);
    else if (x === "submit" || x === "reset") {
      d.removeAttribute("value");
      return;
    }
    h.hasOwnProperty("value") ? Tt(d, h.type, S) : h.hasOwnProperty("defaultValue") && Tt(d, h.type, he(h.defaultValue)), h.checked == null && h.defaultChecked != null && (d.defaultChecked = !!h.defaultChecked);
  }
  function mt(d, h, S) {
    if (h.hasOwnProperty("value") || h.hasOwnProperty("defaultValue")) {
      var x = h.type;
      if (!(x !== "submit" && x !== "reset" || h.value !== void 0 && h.value !== null))
        return;
      h = "" + d._wrapperState.initialValue, S || h === d.value || (d.value = h), d.defaultValue = h;
    }
    S = d.name, S !== "" && (d.name = ""), d.defaultChecked = !!d._wrapperState.initialChecked, S !== "" && (d.name = S);
  }
  function Tt(d, h, S) {
    (h !== "number" || lt(d.ownerDocument) !== d) && (S == null ? d.defaultValue = "" + d._wrapperState.initialValue : d.defaultValue !== "" + S && (d.defaultValue = "" + S));
  }
  var ut = Array.isArray;
  function wt(d, h, S, x) {
    if (d = d.options, h) {
      h = {};
      for (var F = 0; F < S.length; F++)
        h["$" + S[F]] = !0;
      for (S = 0; S < d.length; S++)
        F = h.hasOwnProperty("$" + d[S].value), d[S].selected !== F && (d[S].selected = F), F && x && (d[S].defaultSelected = !0);
    } else {
      for (S = "" + he(S), h = null, F = 0; F < d.length; F++) {
        if (d[F].value === S) {
          d[F].selected = !0, x && (d[F].defaultSelected = !0);
          return;
        }
        h !== null || d[F].disabled || (h = d[F]);
      }
      h !== null && (h.selected = !0);
    }
  }
  function Yt(d, h) {
    if (h.dangerouslySetInnerHTML != null)
      throw Error(n(91));
    return B({}, h, { value: void 0, defaultValue: void 0, children: "" + d._wrapperState.initialValue });
  }
  function Rt(d, h) {
    var S = h.value;
    if (S == null) {
      if (S = h.children, h = h.defaultValue, S != null) {
        if (h != null)
          throw Error(n(92));
        if (ut(S)) {
          if (1 < S.length)
            throw Error(n(93));
          S = S[0];
        }
        h = S;
      }
      h == null && (h = ""), S = h;
    }
    d._wrapperState = { initialValue: he(S) };
  }
  function Ut(d, h) {
    var S = he(h.value), x = he(h.defaultValue);
    S != null && (S = "" + S, S !== d.value && (d.value = S), h.defaultValue == null && d.defaultValue !== S && (d.defaultValue = S)), x != null && (d.defaultValue = "" + x);
  }
  function He(d) {
    var h = d.textContent;
    h === d._wrapperState.initialValue && h !== "" && h !== null && (d.value = h);
  }
  function Ve(d) {
    switch (d) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function Ie(d, h) {
    return d == null || d === "http://www.w3.org/1999/xhtml" ? Ve(h) : d === "http://www.w3.org/2000/svg" && h === "foreignObject" ? "http://www.w3.org/1999/xhtml" : d;
  }
  var it, zt = function(d) {
    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(h, S, x, F) {
      MSApp.execUnsafeLocalFunction(function() {
        return d(h, S, x, F);
      });
    } : d;
  }(function(d, h) {
    if (d.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in d)
      d.innerHTML = h;
    else {
      for (it = it || document.createElement("div"), it.innerHTML = "<svg>" + h.valueOf().toString() + "</svg>", h = it.firstChild; d.firstChild; )
        d.removeChild(d.firstChild);
      for (; h.firstChild; )
        d.appendChild(h.firstChild);
    }
  });
  function Ht(d, h) {
    if (h) {
      var S = d.firstChild;
      if (S && S === d.lastChild && S.nodeType === 3) {
        S.nodeValue = h;
        return;
      }
    }
    d.textContent = h;
  }
  var bt = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, Mt = ["Webkit", "ms", "Moz", "O"];
  Object.keys(bt).forEach(function(d) {
    Mt.forEach(function(h) {
      h = h + d.charAt(0).toUpperCase() + d.substring(1), bt[h] = bt[d];
    });
  });
  function ln(d, h, S) {
    return h == null || typeof h == "boolean" || h === "" ? "" : S || typeof h != "number" || h === 0 || bt.hasOwnProperty(d) && bt[d] ? ("" + h).trim() : h + "px";
  }
  function ze(d, h) {
    d = d.style;
    for (var S in h)
      if (h.hasOwnProperty(S)) {
        var x = S.indexOf("--") === 0, F = ln(S, h[S], x);
        S === "float" && (S = "cssFloat"), x ? d.setProperty(S, F) : d[S] = F;
      }
  }
  var gt = B({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
  function Bt(d, h) {
    if (h) {
      if (gt[d] && (h.children != null || h.dangerouslySetInnerHTML != null))
        throw Error(n(137, d));
      if (h.dangerouslySetInnerHTML != null) {
        if (h.children != null)
          throw Error(n(60));
        if (typeof h.dangerouslySetInnerHTML != "object" || !("__html" in h.dangerouslySetInnerHTML))
          throw Error(n(61));
      }
      if (h.style != null && typeof h.style != "object")
        throw Error(n(62));
    }
  }
  function Qt(d, h) {
    if (d.indexOf("-") === -1)
      return typeof h.is == "string";
    switch (d) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var En = null;
  function Mn(d) {
    return d = d.target || d.srcElement || window, d.correspondingUseElement && (d = d.correspondingUseElement), d.nodeType === 3 ? d.parentNode : d;
  }
  var br = null, sr = null, Ar = null;
  function Ji(d) {
    if (d = Oo(d)) {
      if (typeof br != "function")
        throw Error(n(280));
      var h = d.stateNode;
      h && (h = xn(h), br(d.stateNode, d.type, h));
    }
  }
  function po(d) {
    sr ? Ar ? Ar.push(d) : Ar = [d] : sr = d;
  }
  function Ni() {
    if (sr) {
      var d = sr, h = Ar;
      if (Ar = sr = null, Ji(d), h)
        for (d = 0; d < h.length; d++)
          Ji(h[d]);
    }
  }
  function oi(d, h) {
    return d(h);
  }
  function gu() {
  }
  var ho = !1;
  function Jo(d, h, S) {
    if (ho)
      return d(h, S);
    ho = !0;
    try {
      return oi(d, h, S);
    } finally {
      ho = !1, (sr !== null || Ar !== null) && (gu(), Ni());
    }
  }
  function bu(d, h) {
    var S = d.stateNode;
    if (S === null)
      return null;
    var x = xn(S);
    if (x === null)
      return null;
    S = x[h];
    e:
      switch (h) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          (x = !x.disabled) || (d = d.type, x = !(d === "button" || d === "input" || d === "select" || d === "textarea")), d = !x;
          break e;
        default:
          d = !1;
      }
    if (d)
      return null;
    if (S && typeof S != "function")
      throw Error(n(231, h, typeof S));
    return S;
  }
  var vu = !1;
  if (s)
    try {
      var Lo = {};
      Object.defineProperty(Lo, "passive", { get: function() {
        vu = !0;
      } }), window.addEventListener("test", Lo, Lo), window.removeEventListener("test", Lo, Lo);
    } catch {
      vu = !1;
    }
  function Pi(d, h, S, x, F, U, X, Se, Pe) {
    var nt = Array.prototype.slice.call(arguments, 3);
    try {
      h.apply(S, nt);
    } catch (At) {
      this.onError(At);
    }
  }
  var eo = !1, es = null, Fl = !1, xe = null, xt = { onError: function(d) {
    eo = !0, es = d;
  } };
  function jt(d, h, S, x, F, U, X, Se, Pe) {
    eo = !1, es = null, Pi.apply(xt, arguments);
  }
  function Sn(d, h, S, x, F, U, X, Se, Pe) {
    if (jt.apply(this, arguments), eo) {
      if (eo) {
        var nt = es;
        eo = !1, es = null;
      } else
        throw Error(n(198));
      Fl || (Fl = !0, xe = nt);
    }
  }
  function Yn(d) {
    var h = d, S = d;
    if (d.alternate)
      for (; h.return; )
        h = h.return;
    else {
      d = h;
      do
        h = d, h.flags & 4098 && (S = h.return), d = h.return;
      while (d);
    }
    return h.tag === 3 ? S : null;
  }
  function ur(d) {
    if (d.tag === 13) {
      var h = d.memoizedState;
      if (h === null && (d = d.alternate, d !== null && (h = d.memoizedState)), h !== null)
        return h.dehydrated;
    }
    return null;
  }
  function qn(d) {
    if (Yn(d) !== d)
      throw Error(n(188));
  }
  function Rn(d) {
    var h = d.alternate;
    if (!h) {
      if (h = Yn(d), h === null)
        throw Error(n(188));
      return h !== d ? null : d;
    }
    for (var S = d, x = h; ; ) {
      var F = S.return;
      if (F === null)
        break;
      var U = F.alternate;
      if (U === null) {
        if (x = F.return, x !== null) {
          S = x;
          continue;
        }
        break;
      }
      if (F.child === U.child) {
        for (U = F.child; U; ) {
          if (U === S)
            return qn(F), d;
          if (U === x)
            return qn(F), h;
          U = U.sibling;
        }
        throw Error(n(188));
      }
      if (S.return !== x.return)
        S = F, x = U;
      else {
        for (var X = !1, Se = F.child; Se; ) {
          if (Se === S) {
            X = !0, S = F, x = U;
            break;
          }
          if (Se === x) {
            X = !0, x = F, S = U;
            break;
          }
          Se = Se.sibling;
        }
        if (!X) {
          for (Se = U.child; Se; ) {
            if (Se === S) {
              X = !0, S = U, x = F;
              break;
            }
            if (Se === x) {
              X = !0, x = U, S = F;
              break;
            }
            Se = Se.sibling;
          }
          if (!X)
            throw Error(n(189));
        }
      }
      if (S.alternate !== x)
        throw Error(n(190));
    }
    if (S.tag !== 3)
      throw Error(n(188));
    return S.stateNode.current === S ? d : h;
  }
  function Ba(d) {
    return d = Rn(d), d !== null ? ma(d) : null;
  }
  function ma(d) {
    if (d.tag === 5 || d.tag === 6)
      return d;
    for (d = d.child; d !== null; ) {
      var h = ma(d);
      if (h !== null)
        return h;
      d = d.sibling;
    }
    return null;
  }
  var ve = e.unstable_scheduleCallback, Ye = e.unstable_cancelCallback, yt = e.unstable_shouldYield, Dt = e.unstable_requestPaint, Lt = e.unstable_now, _n = e.unstable_getCurrentPriorityLevel, Nn = e.unstable_ImmediatePriority, fn = e.unstable_UserBlockingPriority, Or = e.unstable_NormalPriority, Er = e.unstable_LowPriority, pr = e.unstable_IdlePriority, Li = null, Aa = null;
  function ua(d) {
    if (Aa && typeof Aa.onCommitFiberRoot == "function")
      try {
        Aa.onCommitFiberRoot(Li, d, void 0, (d.current.flags & 128) === 128);
      } catch {
      }
  }
  var Mr = Math.clz32 ? Math.clz32 : Bl, to = Math.log, $l = Math.LN2;
  function Bl(d) {
    return d >>>= 0, d === 0 ? 32 : 31 - (to(d) / $l | 0) | 0;
  }
  var il = 64, ac = 4194304;
  function yu(d) {
    switch (d & -d) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return d & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return d & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return d;
    }
  }
  function mo(d, h) {
    var S = d.pendingLanes;
    if (S === 0)
      return 0;
    var x = 0, F = d.suspendedLanes, U = d.pingedLanes, X = S & 268435455;
    if (X !== 0) {
      var Se = X & ~F;
      Se !== 0 ? x = yu(Se) : (U &= X, U !== 0 && (x = yu(U)));
    } else
      X = S & ~F, X !== 0 ? x = yu(X) : U !== 0 && (x = yu(U));
    if (x === 0)
      return 0;
    if (h !== 0 && h !== x && !(h & F) && (F = x & -x, U = h & -h, F >= U || F === 16 && (U & 4194240) !== 0))
      return h;
    if (x & 4 && (x |= S & 16), h = d.entangledLanes, h !== 0)
      for (d = d.entanglements, h &= x; 0 < h; )
        S = 31 - Mr(h), F = 1 << S, x |= d[S], h &= ~F;
    return x;
  }
  function Fr(d, h) {
    switch (d) {
      case 1:
      case 2:
      case 4:
        return h + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return h + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function _r(d, h) {
    for (var S = d.suspendedLanes, x = d.pingedLanes, F = d.expirationTimes, U = d.pendingLanes; 0 < U; ) {
      var X = 31 - Mr(U), Se = 1 << X, Pe = F[X];
      Pe === -1 ? (!(Se & S) || Se & x) && (F[X] = Fr(Se, h)) : Pe <= h && (d.expiredLanes |= Se), U &= ~Se;
    }
  }
  function Qc(d) {
    return d = d.pendingLanes & -1073741825, d !== 0 ? d : d & 1073741824 ? 1073741824 : 0;
  }
  function Ts() {
    var d = il;
    return il <<= 1, !(il & 4194240) && (il = 64), d;
  }
  function Ou(d) {
    for (var h = [], S = 0; 31 > S; S++)
      h.push(d);
    return h;
  }
  function si(d, h, S) {
    d.pendingLanes |= h, h !== 536870912 && (d.suspendedLanes = 0, d.pingedLanes = 0), d = d.eventTimes, h = 31 - Mr(h), d[h] = S;
  }
  function ol(d, h) {
    var S = d.pendingLanes & ~h;
    d.pendingLanes = h, d.suspendedLanes = 0, d.pingedLanes = 0, d.expiredLanes &= h, d.mutableReadLanes &= h, d.entangledLanes &= h, h = d.entanglements;
    var x = d.eventTimes;
    for (d = d.expirationTimes; 0 < S; ) {
      var F = 31 - Mr(S), U = 1 << F;
      h[F] = 0, x[F] = -1, d[F] = -1, S &= ~U;
    }
  }
  function go(d, h) {
    var S = d.entangledLanes |= h;
    for (d = d.entanglements; S; ) {
      var x = 31 - Mr(S), F = 1 << x;
      F & h | d[x] & h && (d[x] |= h), S &= ~F;
    }
  }
  var hr = 0;
  function _s(d) {
    return d &= -d, 1 < d ? 4 < d ? d & 268435455 ? 16 : 536870912 : 4 : 1;
  }
  var Eu, ts, Qr, jc, Gc, Bn = !1, Ul = [], Ua = null, no = null, ro = null, rp = /* @__PURE__ */ new Map(), wi = /* @__PURE__ */ new Map(), ra = [], A1 = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function zl(d, h) {
    switch (d) {
      case "focusin":
      case "focusout":
        Ua = null;
        break;
      case "dragenter":
      case "dragleave":
        no = null;
        break;
      case "mouseover":
      case "mouseout":
        ro = null;
        break;
      case "pointerover":
      case "pointerout":
        rp.delete(h.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        wi.delete(h.pointerId);
    }
  }
  function Mi(d, h, S, x, F, U) {
    return d === null || d.nativeEvent !== U ? (d = { blockedOn: h, domEventName: S, eventSystemFlags: x, nativeEvent: U, targetContainers: [F] }, h !== null && (h = Oo(h), h !== null && ts(h)), d) : (d.eventSystemFlags |= x, h = d.targetContainers, F !== null && h.indexOf(F) === -1 && h.push(F), d);
  }
  function Vc(d, h, S, x, F) {
    switch (h) {
      case "focusin":
        return Ua = Mi(Ua, d, h, S, x, F), !0;
      case "dragenter":
        return no = Mi(no, d, h, S, x, F), !0;
      case "mouseover":
        return ro = Mi(ro, d, h, S, x, F), !0;
      case "pointerover":
        var U = F.pointerId;
        return rp.set(U, Mi(rp.get(U) || null, d, h, S, x, F)), !0;
      case "gotpointercapture":
        return U = F.pointerId, wi.set(U, Mi(wi.get(U) || null, d, h, S, x, F)), !0;
    }
    return !1;
  }
  function L0(d) {
    var h = Mo(d.target);
    if (h !== null) {
      var S = Yn(h);
      if (S !== null) {
        if (h = S.tag, h === 13) {
          if (h = ur(S), h !== null) {
            d.blockedOn = h, Gc(d.priority, function() {
              Qr(S);
            });
            return;
          }
        } else if (h === 3 && S.stateNode.current.memoizedState.isDehydrated) {
          d.blockedOn = S.tag === 3 ? S.stateNode.containerInfo : null;
          return;
        }
      }
    }
    d.blockedOn = null;
  }
  function ap(d) {
    if (d.blockedOn !== null)
      return !1;
    for (var h = d.targetContainers; 0 < h.length; ) {
      var S = Bh(d.domEventName, d.eventSystemFlags, h[0], d.nativeEvent);
      if (S === null) {
        S = d.nativeEvent;
        var x = new S.constructor(S.type, S);
        En = x, S.target.dispatchEvent(x), En = null;
      } else
        return h = Oo(S), h !== null && ts(h), d.blockedOn = S, !1;
      h.shift();
    }
    return !0;
  }
  function mv(d, h, S) {
    ap(d) && S.delete(h);
  }
  function M0() {
    Bn = !1, Ua !== null && ap(Ua) && (Ua = null), no !== null && ap(no) && (no = null), ro !== null && ap(ro) && (ro = null), rp.forEach(mv), wi.forEach(mv);
  }
  function Jr(d, h) {
    d.blockedOn === h && (d.blockedOn = null, Bn || (Bn = !0, e.unstable_scheduleCallback(e.unstable_NormalPriority, M0)));
  }
  function jr(d) {
    function h(F) {
      return Jr(F, d);
    }
    if (0 < Ul.length) {
      Jr(Ul[0], d);
      for (var S = 1; S < Ul.length; S++) {
        var x = Ul[S];
        x.blockedOn === d && (x.blockedOn = null);
      }
    }
    for (Ua !== null && Jr(Ua, d), no !== null && Jr(no, d), ro !== null && Jr(ro, d), rp.forEach(h), wi.forEach(h), S = 0; S < ra.length; S++)
      x = ra[S], x.blockedOn === d && (x.blockedOn = null);
    for (; 0 < ra.length && (S = ra[0], S.blockedOn === null); )
      L0(S), S.blockedOn === null && ra.shift();
  }
  var ip = I.ReactCurrentBatchConfig, nd = !0;
  function F0(d, h, S, x) {
    var F = hr, U = ip.transition;
    ip.transition = null;
    try {
      hr = 1, ug(d, h, S, x);
    } finally {
      hr = F, ip.transition = U;
    }
  }
  function lg(d, h, S, x) {
    var F = hr, U = ip.transition;
    ip.transition = null;
    try {
      hr = 4, ug(d, h, S, x);
    } finally {
      hr = F, ip.transition = U;
    }
  }
  function ug(d, h, S, x) {
    if (nd) {
      var F = Bh(d, h, S, x);
      if (F === null)
        Sg(d, h, x, $h, S), zl(d, x);
      else if (Vc(F, d, h, S, x))
        x.stopPropagation();
      else if (zl(d, x), h & 4 && -1 < A1.indexOf(d)) {
        for (; F !== null; ) {
          var U = Oo(F);
          if (U !== null && Eu(U), U = Bh(d, h, S, x), U === null && Sg(d, h, x, $h, S), U === F)
            break;
          F = U;
        }
        F !== null && x.stopPropagation();
      } else
        Sg(d, h, x, null, S);
    }
  }
  var $h = null;
  function Bh(d, h, S, x) {
    if ($h = null, d = Mn(x), d = Mo(d), d !== null)
      if (h = Yn(d), h === null)
        d = null;
      else if (S = h.tag, S === 13) {
        if (d = ur(h), d !== null)
          return d;
        d = null;
      } else if (S === 3) {
        if (h.stateNode.current.memoizedState.isDehydrated)
          return h.tag === 3 ? h.stateNode.containerInfo : null;
        d = null;
      } else
        h !== d && (d = null);
    return $h = d, null;
  }
  function gv(d) {
    switch (d) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (_n()) {
          case Nn:
            return 1;
          case fn:
            return 4;
          case Or:
          case Er:
            return 16;
          case pr:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var Ta = null, rd = null, Hl = null;
  function cg() {
    if (Hl)
      return Hl;
    var d, h = rd, S = h.length, x, F = "value" in Ta ? Ta.value : Ta.textContent, U = F.length;
    for (d = 0; d < S && h[d] === F[d]; d++)
      ;
    var X = S - d;
    for (x = 1; x <= X && h[S - x] === F[U - x]; x++)
      ;
    return Hl = F.slice(d, 1 < x ? 1 - x : void 0);
  }
  function Yc(d) {
    var h = d.keyCode;
    return "charCode" in d ? (d = d.charCode, d === 0 && h === 13 && (d = 13)) : d = h, d === 10 && (d = 13), 32 <= d || d === 13 ? d : 0;
  }
  function bo() {
    return !0;
  }
  function bv() {
    return !1;
  }
  function ns(d) {
    function h(S, x, F, U, X) {
      this._reactName = S, this._targetInst = F, this.type = x, this.nativeEvent = U, this.target = X, this.currentTarget = null;
      for (var Se in d)
        d.hasOwnProperty(Se) && (S = d[Se], this[Se] = S ? S(U) : U[Se]);
      return this.isDefaultPrevented = (U.defaultPrevented != null ? U.defaultPrevented : U.returnValue === !1) ? bo : bv, this.isPropagationStopped = bv, this;
    }
    return B(h.prototype, { preventDefault: function() {
      this.defaultPrevented = !0;
      var S = this.nativeEvent;
      S && (S.preventDefault ? S.preventDefault() : typeof S.returnValue != "unknown" && (S.returnValue = !1), this.isDefaultPrevented = bo);
    }, stopPropagation: function() {
      var S = this.nativeEvent;
      S && (S.stopPropagation ? S.stopPropagation() : typeof S.cancelBubble != "unknown" && (S.cancelBubble = !0), this.isPropagationStopped = bo);
    }, persist: function() {
    }, isPersistent: bo }), h;
  }
  var ic = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(d) {
    return d.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, Uh = ns(ic), ad = B({}, ic, { view: 0, detail: 0 }), vv = ns(ad), vo, yv, yo, Fi = B({}, ad, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: _v, button: 0, buttons: 0, relatedTarget: function(d) {
    return d.relatedTarget === void 0 ? d.fromElement === d.srcElement ? d.toElement : d.fromElement : d.relatedTarget;
  }, movementX: function(d) {
    return "movementX" in d ? d.movementX : (d !== yo && (yo && d.type === "mousemove" ? (vo = d.screenX - yo.screenX, yv = d.screenY - yo.screenY) : yv = vo = 0, yo = d), vo);
  }, movementY: function(d) {
    return "movementY" in d ? d.movementY : yv;
  } }), zh = ns(Fi), oc = B({}, Fi, { dataTransfer: 0 }), Hh = ns(oc), Ov = B({}, ad, { relatedTarget: 0 }), Hr = ns(Ov), Su = B({}, ic, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), fg = ns(Su), k1 = B({}, ic, { clipboardData: function(d) {
    return "clipboardData" in d ? d.clipboardData : window.clipboardData;
  } }), Ev = ns(k1), R1 = B({}, ic, { data: 0 }), Sv = ns(R1), wv = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, Tv = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, Wh = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function id(d) {
    var h = this.nativeEvent;
    return h.getModifierState ? h.getModifierState(d) : (d = Wh[d]) ? !!h[d] : !1;
  }
  function _v() {
    return id;
  }
  var wu = B({}, ad, { key: function(d) {
    if (d.key) {
      var h = wv[d.key] || d.key;
      if (h !== "Unidentified")
        return h;
    }
    return d.type === "keypress" ? (d = Yc(d), d === 13 ? "Enter" : String.fromCharCode(d)) : d.type === "keydown" || d.type === "keyup" ? Tv[d.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: _v, charCode: function(d) {
    return d.type === "keypress" ? Yc(d) : 0;
  }, keyCode: function(d) {
    return d.type === "keydown" || d.type === "keyup" ? d.keyCode : 0;
  }, which: function(d) {
    return d.type === "keypress" ? Yc(d) : d.type === "keydown" || d.type === "keyup" ? d.keyCode : 0;
  } }), $0 = ns(wu), Qh = B({}, Fi, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), op = ns(Qh), dg = B({}, ad, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: _v }), I1 = ns(dg), sp = B({}, ic, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), pg = ns(sp), rs = B({}, Fi, {
    deltaX: function(d) {
      return "deltaX" in d ? d.deltaX : "wheelDeltaX" in d ? -d.wheelDeltaX : 0;
    },
    deltaY: function(d) {
      return "deltaY" in d ? d.deltaY : "wheelDeltaY" in d ? -d.wheelDeltaY : "wheelDelta" in d ? -d.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), Tu = ns(rs), $r = [9, 13, 27, 32], Cs = s && "CompositionEvent" in window, Wl = null;
  s && "documentMode" in document && (Wl = document.documentMode);
  var jh = s && "TextEvent" in window && !Wl, Cv = s && (!Cs || Wl && 8 < Wl && 11 >= Wl), lp = String.fromCharCode(32), B0 = !1;
  function U0(d, h) {
    switch (d) {
      case "keyup":
        return $r.indexOf(h.keyCode) !== -1;
      case "keydown":
        return h.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function hg(d) {
    return d = d.detail, typeof d == "object" && "data" in d ? d.data : null;
  }
  var up = !1;
  function cp(d, h) {
    switch (d) {
      case "compositionend":
        return hg(h);
      case "keypress":
        return h.which !== 32 ? null : (B0 = !0, lp);
      case "textInput":
        return d = h.data, d === lp && B0 ? null : d;
      default:
        return null;
    }
  }
  function D1(d, h) {
    if (up)
      return d === "compositionend" || !Cs && U0(d, h) ? (d = cg(), Hl = rd = Ta = null, up = !1, d) : null;
    switch (d) {
      case "paste":
        return null;
      case "keypress":
        if (!(h.ctrlKey || h.altKey || h.metaKey) || h.ctrlKey && h.altKey) {
          if (h.char && 1 < h.char.length)
            return h.char;
          if (h.which)
            return String.fromCharCode(h.which);
        }
        return null;
      case "compositionend":
        return Cv && h.locale !== "ko" ? null : h.data;
      default:
        return null;
    }
  }
  var z0 = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
  function mg(d) {
    var h = d && d.nodeName && d.nodeName.toLowerCase();
    return h === "input" ? !!z0[d.type] : h === "textarea";
  }
  function xv(d, h, S, x) {
    po(x), h = Xh(h, "onChange"), 0 < h.length && (S = new Uh("onChange", "change", null, S, x), d.push({ event: S, listeners: h }));
  }
  var sl = null, sc = null;
  function fp(d) {
    Og(d, 0);
  }
  function dp(d) {
    var h = ar(d);
    if (we(h))
      return d;
  }
  function H0(d, h) {
    if (d === "change")
      return h;
  }
  var Zc = !1;
  if (s) {
    var xs;
    if (s) {
      var gg = "oninput" in document;
      if (!gg) {
        var W0 = document.createElement("div");
        W0.setAttribute("oninput", "return;"), gg = typeof W0.oninput == "function";
      }
      xs = gg;
    } else
      xs = !1;
    Zc = xs && (!document.documentMode || 9 < document.documentMode);
  }
  function Q0() {
    sl && (sl.detachEvent("onpropertychange", j0), sc = sl = null);
  }
  function j0(d) {
    if (d.propertyName === "value" && dp(sc)) {
      var h = [];
      xv(h, sc, d, Mn(d)), Jo(fp, h);
    }
  }
  function N1(d, h, S) {
    d === "focusin" ? (Q0(), sl = h, sc = S, sl.attachEvent("onpropertychange", j0)) : d === "focusout" && Q0();
  }
  function P1(d) {
    if (d === "selectionchange" || d === "keyup" || d === "keydown")
      return dp(sc);
  }
  function pp(d, h) {
    if (d === "click")
      return dp(h);
  }
  function We(d, h) {
    if (d === "input" || d === "change")
      return dp(h);
  }
  function dt(d, h) {
    return d === h && (d !== 0 || 1 / d === 1 / h) || d !== d && h !== h;
  }
  var et = typeof Object.is == "function" ? Object.is : dt;
  function Jt(d, h) {
    if (et(d, h))
      return !0;
    if (typeof d != "object" || d === null || typeof h != "object" || h === null)
      return !1;
    var S = Object.keys(d), x = Object.keys(h);
    if (S.length !== x.length)
      return !1;
    for (x = 0; x < S.length; x++) {
      var F = S[x];
      if (!u.call(h, F) || !et(d[F], h[F]))
        return !1;
    }
    return !0;
  }
  function Kn(d) {
    for (; d && d.firstChild; )
      d = d.firstChild;
    return d;
  }
  function Br(d, h) {
    var S = Kn(d);
    d = 0;
    for (var x; S; ) {
      if (S.nodeType === 3) {
        if (x = d + S.textContent.length, d <= h && x >= h)
          return { node: S, offset: h - d };
        d = x;
      }
      e: {
        for (; S; ) {
          if (S.nextSibling) {
            S = S.nextSibling;
            break e;
          }
          S = S.parentNode;
        }
        S = void 0;
      }
      S = Kn(S);
    }
  }
  function gi(d, h) {
    return d && h ? d === h ? !0 : d && d.nodeType === 3 ? !1 : h && h.nodeType === 3 ? gi(d, h.parentNode) : "contains" in d ? d.contains(h) : d.compareDocumentPosition ? !!(d.compareDocumentPosition(h) & 16) : !1 : !1;
  }
  function Gr() {
    for (var d = window, h = lt(); h instanceof d.HTMLIFrameElement; ) {
      try {
        var S = typeof h.contentWindow.location.href == "string";
      } catch {
        S = !1;
      }
      if (S)
        d = h.contentWindow;
      else
        break;
      h = lt(d.document);
    }
    return h;
  }
  function Ql(d) {
    var h = d && d.nodeName && d.nodeName.toLowerCase();
    return h && (h === "input" && (d.type === "text" || d.type === "search" || d.type === "tel" || d.type === "url" || d.type === "password") || h === "textarea" || d.contentEditable === "true");
  }
  function bg(d) {
    var h = Gr(), S = d.focusedElem, x = d.selectionRange;
    if (h !== S && S && S.ownerDocument && gi(S.ownerDocument.documentElement, S)) {
      if (x !== null && Ql(S)) {
        if (h = x.start, d = x.end, d === void 0 && (d = h), "selectionStart" in S)
          S.selectionStart = h, S.selectionEnd = Math.min(d, S.value.length);
        else if (d = (h = S.ownerDocument || document) && h.defaultView || window, d.getSelection) {
          d = d.getSelection();
          var F = S.textContent.length, U = Math.min(x.start, F);
          x = x.end === void 0 ? U : Math.min(x.end, F), !d.extend && U > x && (F = x, x = U, U = F), F = Br(S, U);
          var X = Br(
            S,
            x
          );
          F && X && (d.rangeCount !== 1 || d.anchorNode !== F.node || d.anchorOffset !== F.offset || d.focusNode !== X.node || d.focusOffset !== X.offset) && (h = h.createRange(), h.setStart(F.node, F.offset), d.removeAllRanges(), U > x ? (d.addRange(h), d.extend(X.node, X.offset)) : (h.setEnd(X.node, X.offset), d.addRange(h)));
        }
      }
      for (h = [], d = S; d = d.parentNode; )
        d.nodeType === 1 && h.push({ element: d, left: d.scrollLeft, top: d.scrollTop });
      for (typeof S.focus == "function" && S.focus(), S = 0; S < h.length; S++)
        d = h[S], d.element.scrollLeft = d.left, d.element.scrollTop = d.top;
    }
  }
  var As = s && "documentMode" in document && 11 >= document.documentMode, as = null, Av = null, _u = null, hp = !1;
  function Gh(d, h, S) {
    var x = S.window === S ? S.document : S.nodeType === 9 ? S : S.ownerDocument;
    hp || as == null || as !== lt(x) || (x = as, "selectionStart" in x && Ql(x) ? x = { start: x.selectionStart, end: x.selectionEnd } : (x = (x.ownerDocument && x.ownerDocument.defaultView || window).getSelection(), x = { anchorNode: x.anchorNode, anchorOffset: x.anchorOffset, focusNode: x.focusNode, focusOffset: x.focusOffset }), _u && Jt(_u, x) || (_u = x, x = Xh(Av, "onSelect"), 0 < x.length && (h = new Uh("onSelect", "select", null, h, S), d.push({ event: h, listeners: x }), h.target = as)));
  }
  function Ur(d, h) {
    var S = {};
    return S[d.toLowerCase()] = h.toLowerCase(), S["Webkit" + d] = "webkit" + h, S["Moz" + d] = "moz" + h, S;
  }
  var od = { animationend: Ur("Animation", "AnimationEnd"), animationiteration: Ur("Animation", "AnimationIteration"), animationstart: Ur("Animation", "AnimationStart"), transitionend: Ur("Transition", "TransitionEnd") }, vg = {}, mp = {};
  s && (mp = document.createElement("div").style, "AnimationEvent" in window || (delete od.animationend.animation, delete od.animationiteration.animation, delete od.animationstart.animation), "TransitionEvent" in window || delete od.transitionend.transition);
  function $i(d) {
    if (vg[d])
      return vg[d];
    if (!od[d])
      return d;
    var h = od[d], S;
    for (S in h)
      if (h.hasOwnProperty(S) && S in mp)
        return vg[d] = h[S];
    return d;
  }
  var kv = $i("animationend"), G0 = $i("animationiteration"), Vh = $i("animationstart"), lc = $i("transitionend"), Yh = /* @__PURE__ */ new Map(), Rv = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function ll(d, h) {
    Yh.set(d, h), i(h, [d]);
  }
  for (var gp = 0; gp < Rv.length; gp++) {
    var Xc = Rv[gp], yg = Xc.toLowerCase(), bp = Xc[0].toUpperCase() + Xc.slice(1);
    ll(yg, "on" + bp);
  }
  ll(kv, "onAnimationEnd"), ll(G0, "onAnimationIteration"), ll(Vh, "onAnimationStart"), ll("dblclick", "onDoubleClick"), ll("focusin", "onFocus"), ll("focusout", "onBlur"), ll(lc, "onTransitionEnd"), o("onMouseEnter", ["mouseout", "mouseover"]), o("onMouseLeave", ["mouseout", "mouseover"]), o("onPointerEnter", ["pointerout", "pointerover"]), o("onPointerLeave", ["pointerout", "pointerover"]), i("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), i("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), i("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), i("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), i("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), i("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var uc = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), sd = new Set("cancel close invalid load scroll toggle".split(" ").concat(uc));
  function Zh(d, h, S) {
    var x = d.type || "unknown-event";
    d.currentTarget = S, Sn(x, h, void 0, d), d.currentTarget = null;
  }
  function Og(d, h) {
    h = (h & 4) !== 0;
    for (var S = 0; S < d.length; S++) {
      var x = d[S], F = x.event;
      x = x.listeners;
      e: {
        var U = void 0;
        if (h)
          for (var X = x.length - 1; 0 <= X; X--) {
            var Se = x[X], Pe = Se.instance, nt = Se.currentTarget;
            if (Se = Se.listener, Pe !== U && F.isPropagationStopped())
              break e;
            Zh(F, Se, nt), U = Pe;
          }
        else
          for (X = 0; X < x.length; X++) {
            if (Se = x[X], Pe = Se.instance, nt = Se.currentTarget, Se = Se.listener, Pe !== U && F.isPropagationStopped())
              break e;
            Zh(F, Se, nt), U = Pe;
          }
      }
    }
    if (Fl)
      throw d = xe, Fl = !1, xe = null, d;
  }
  function ca(d, h) {
    var S = h[Tg];
    S === void 0 && (S = h[Tg] = /* @__PURE__ */ new Set());
    var x = d + "__bubble";
    S.has(x) || (Eg(h, d, 2, !1), S.add(x));
  }
  function qc(d, h, S) {
    var x = 0;
    h && (x |= 4), Eg(S, d, x, h);
  }
  var ul = "_reactListening" + Math.random().toString(36).slice(2);
  function cc(d) {
    if (!d[ul]) {
      d[ul] = !0, r.forEach(function(S) {
        S !== "selectionchange" && (sd.has(S) || qc(S, !1, d), qc(S, !0, d));
      });
      var h = d.nodeType === 9 ? d : d.ownerDocument;
      h === null || h[ul] || (h[ul] = !0, qc("selectionchange", !1, h));
    }
  }
  function Eg(d, h, S, x) {
    switch (gv(h)) {
      case 1:
        var F = F0;
        break;
      case 4:
        F = lg;
        break;
      default:
        F = ug;
    }
    S = F.bind(null, h, S, d), F = void 0, !vu || h !== "touchstart" && h !== "touchmove" && h !== "wheel" || (F = !0), x ? F !== void 0 ? d.addEventListener(h, S, { capture: !0, passive: F }) : d.addEventListener(h, S, !0) : F !== void 0 ? d.addEventListener(h, S, { passive: F }) : d.addEventListener(h, S, !1);
  }
  function Sg(d, h, S, x, F) {
    var U = x;
    if (!(h & 1) && !(h & 2) && x !== null)
      e:
        for (; ; ) {
          if (x === null)
            return;
          var X = x.tag;
          if (X === 3 || X === 4) {
            var Se = x.stateNode.containerInfo;
            if (Se === F || Se.nodeType === 8 && Se.parentNode === F)
              break;
            if (X === 4)
              for (X = x.return; X !== null; ) {
                var Pe = X.tag;
                if ((Pe === 3 || Pe === 4) && (Pe = X.stateNode.containerInfo, Pe === F || Pe.nodeType === 8 && Pe.parentNode === F))
                  return;
                X = X.return;
              }
            for (; Se !== null; ) {
              if (X = Mo(Se), X === null)
                return;
              if (Pe = X.tag, Pe === 5 || Pe === 6) {
                x = U = X;
                continue e;
              }
              Se = Se.parentNode;
            }
          }
          x = x.return;
        }
    Jo(function() {
      var nt = U, At = Mn(S), It = [];
      e: {
        var kt = Yh.get(d);
        if (kt !== void 0) {
          var en = Uh, dn = d;
          switch (d) {
            case "keypress":
              if (Yc(S) === 0)
                break e;
            case "keydown":
            case "keyup":
              en = $0;
              break;
            case "focusin":
              dn = "focus", en = Hr;
              break;
            case "focusout":
              dn = "blur", en = Hr;
              break;
            case "beforeblur":
            case "afterblur":
              en = Hr;
              break;
            case "click":
              if (S.button === 2)
                break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              en = zh;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              en = Hh;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              en = I1;
              break;
            case kv:
            case G0:
            case Vh:
              en = fg;
              break;
            case lc:
              en = pg;
              break;
            case "scroll":
              en = vv;
              break;
            case "wheel":
              en = Tu;
              break;
            case "copy":
            case "cut":
            case "paste":
              en = Ev;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              en = op;
          }
          var mn = (h & 4) !== 0, ci = !mn && d === "scroll", Ze = mn ? kt !== null ? kt + "Capture" : null : kt;
          mn = [];
          for (var Me = nt, Xe; Me !== null; ) {
            Xe = Me;
            var Ft = Xe.stateNode;
            if (Xe.tag === 5 && Ft !== null && (Xe = Ft, Ze !== null && (Ft = bu(Me, Ze), Ft != null && mn.push(vp(Me, Ft, Xe)))), ci)
              break;
            Me = Me.return;
          }
          0 < mn.length && (kt = new en(kt, dn, null, S, At), It.push({ event: kt, listeners: mn }));
        }
      }
      if (!(h & 7)) {
        e: {
          if (kt = d === "mouseover" || d === "pointerover", en = d === "mouseout" || d === "pointerout", kt && S !== En && (dn = S.relatedTarget || S.fromElement) && (Mo(dn) || dn[ks]))
            break e;
          if ((en || kt) && (kt = At.window === At ? At : (kt = At.ownerDocument) ? kt.defaultView || kt.parentWindow : window, en ? (dn = S.relatedTarget || S.toElement, en = nt, dn = dn ? Mo(dn) : null, dn !== null && (ci = Yn(dn), dn !== ci || dn.tag !== 5 && dn.tag !== 6) && (dn = null)) : (en = null, dn = nt), en !== dn)) {
            if (mn = zh, Ft = "onMouseLeave", Ze = "onMouseEnter", Me = "mouse", (d === "pointerout" || d === "pointerover") && (mn = op, Ft = "onPointerLeave", Ze = "onPointerEnter", Me = "pointer"), ci = en == null ? kt : ar(en), Xe = dn == null ? kt : ar(dn), kt = new mn(Ft, Me + "leave", en, S, At), kt.target = ci, kt.relatedTarget = Xe, Ft = null, Mo(At) === nt && (mn = new mn(Ze, Me + "enter", dn, S, At), mn.target = Xe, mn.relatedTarget = ci, Ft = mn), ci = Ft, en && dn)
              t: {
                for (mn = en, Ze = dn, Me = 0, Xe = mn; Xe; Xe = ld(Xe))
                  Me++;
                for (Xe = 0, Ft = Ze; Ft; Ft = ld(Ft))
                  Xe++;
                for (; 0 < Me - Xe; )
                  mn = ld(mn), Me--;
                for (; 0 < Xe - Me; )
                  Ze = ld(Ze), Xe--;
                for (; Me--; ) {
                  if (mn === Ze || Ze !== null && mn === Ze.alternate)
                    break t;
                  mn = ld(mn), Ze = ld(Ze);
                }
                mn = null;
              }
            else
              mn = null;
            en !== null && li(It, kt, en, mn, !1), dn !== null && ci !== null && li(It, ci, dn, mn, !0);
          }
        }
        e: {
          if (kt = nt ? ar(nt) : window, en = kt.nodeName && kt.nodeName.toLowerCase(), en === "select" || en === "input" && kt.type === "file")
            var yn = H0;
          else if (mg(kt))
            if (Zc)
              yn = We;
            else {
              yn = P1;
              var cn = N1;
            }
          else
            (en = kt.nodeName) && en.toLowerCase() === "input" && (kt.type === "checkbox" || kt.type === "radio") && (yn = pp);
          if (yn && (yn = yn(d, nt))) {
            xv(It, yn, S, At);
            break e;
          }
          cn && cn(d, kt, nt), d === "focusout" && (cn = kt._wrapperState) && cn.controlled && kt.type === "number" && Tt(kt, "number", kt.value);
        }
        switch (cn = nt ? ar(nt) : window, d) {
          case "focusin":
            (mg(cn) || cn.contentEditable === "true") && (as = cn, Av = nt, _u = null);
            break;
          case "focusout":
            _u = Av = as = null;
            break;
          case "mousedown":
            hp = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            hp = !1, Gh(It, S, At);
            break;
          case "selectionchange":
            if (As)
              break;
          case "keydown":
          case "keyup":
            Gh(It, S, At);
        }
        var wn;
        if (Cs)
          e: {
            switch (d) {
              case "compositionstart":
                var Qn = "onCompositionStart";
                break e;
              case "compositionend":
                Qn = "onCompositionEnd";
                break e;
              case "compositionupdate":
                Qn = "onCompositionUpdate";
                break e;
            }
            Qn = void 0;
          }
        else
          up ? U0(d, S) && (Qn = "onCompositionEnd") : d === "keydown" && S.keyCode === 229 && (Qn = "onCompositionStart");
        Qn && (Cv && S.locale !== "ko" && (up || Qn !== "onCompositionStart" ? Qn === "onCompositionEnd" && up && (wn = cg()) : (Ta = At, rd = "value" in Ta ? Ta.value : Ta.textContent, up = !0)), cn = Xh(nt, Qn), 0 < cn.length && (Qn = new Sv(Qn, d, null, S, At), It.push({ event: Qn, listeners: cn }), wn ? Qn.data = wn : (wn = hg(S), wn !== null && (Qn.data = wn)))), (wn = jh ? cp(d, S) : D1(d, S)) && (nt = Xh(nt, "onBeforeInput"), 0 < nt.length && (At = new Sv("onBeforeInput", "beforeinput", null, S, At), It.push({ event: At, listeners: nt }), At.data = wn));
      }
      Og(It, h);
    });
  }
  function vp(d, h, S) {
    return { instance: d, listener: h, currentTarget: S };
  }
  function Xh(d, h) {
    for (var S = h + "Capture", x = []; d !== null; ) {
      var F = d, U = F.stateNode;
      F.tag === 5 && U !== null && (F = U, U = bu(d, S), U != null && x.unshift(vp(d, U, F)), U = bu(d, h), U != null && x.push(vp(d, U, F))), d = d.return;
    }
    return x;
  }
  function ld(d) {
    if (d === null)
      return null;
    do
      d = d.return;
    while (d && d.tag !== 5);
    return d || null;
  }
  function li(d, h, S, x, F) {
    for (var U = h._reactName, X = []; S !== null && S !== x; ) {
      var Se = S, Pe = Se.alternate, nt = Se.stateNode;
      if (Pe !== null && Pe === x)
        break;
      Se.tag === 5 && nt !== null && (Se = nt, F ? (Pe = bu(S, U), Pe != null && X.unshift(vp(S, Pe, Se))) : F || (Pe = bu(S, U), Pe != null && X.push(vp(S, Pe, Se)))), S = S.return;
    }
    X.length !== 0 && d.push({ event: h, listeners: X });
  }
  var Bi = /\r\n?/g, L1 = /\u0000|\uFFFD/g;
  function Iv(d) {
    return (typeof d == "string" ? d : "" + d).replace(Bi, `
`).replace(L1, "");
  }
  function qh(d, h, S) {
    if (h = Iv(h), Iv(d) !== h && S)
      throw Error(n(425));
  }
  function wg() {
  }
  var Kh = null, jl = null;
  function ud(d, h) {
    return d === "textarea" || d === "noscript" || typeof h.children == "string" || typeof h.children == "number" || typeof h.dangerouslySetInnerHTML == "object" && h.dangerouslySetInnerHTML !== null && h.dangerouslySetInnerHTML.__html != null;
  }
  var cl = typeof setTimeout == "function" ? setTimeout : void 0, yp = typeof clearTimeout == "function" ? clearTimeout : void 0, cd = typeof Promise == "function" ? Promise : void 0, Op = typeof queueMicrotask == "function" ? queueMicrotask : typeof cd < "u" ? function(d) {
    return cd.resolve(null).then(d).catch(Ep);
  } : cl;
  function Ep(d) {
    setTimeout(function() {
      throw d;
    });
  }
  function Kc(d, h) {
    var S = h, x = 0;
    do {
      var F = S.nextSibling;
      if (d.removeChild(S), F && F.nodeType === 8)
        if (S = F.data, S === "/$") {
          if (x === 0) {
            d.removeChild(F), jr(h);
            return;
          }
          x--;
        } else
          S !== "$" && S !== "$?" && S !== "$!" || x++;
      S = F;
    } while (S);
    jr(h);
  }
  function Gl(d) {
    for (; d != null; d = d.nextSibling) {
      var h = d.nodeType;
      if (h === 1 || h === 3)
        break;
      if (h === 8) {
        if (h = d.data, h === "$" || h === "$!" || h === "$?")
          break;
        if (h === "/$")
          return null;
      }
    }
    return d;
  }
  function Jh(d) {
    d = d.previousSibling;
    for (var h = 0; d; ) {
      if (d.nodeType === 8) {
        var S = d.data;
        if (S === "$" || S === "$!" || S === "$?") {
          if (h === 0)
            return d;
          h--;
        } else
          S === "/$" && h++;
      }
      d = d.previousSibling;
    }
    return null;
  }
  var Jc = Math.random().toString(36).slice(2), Cu = "__reactFiber$" + Jc, xu = "__reactProps$" + Jc, ks = "__reactContainer$" + Jc, Tg = "__reactEvents$" + Jc, re = "__reactListeners$" + Jc, ef = "__reactHandles$" + Jc;
  function Mo(d) {
    var h = d[Cu];
    if (h)
      return h;
    for (var S = d.parentNode; S; ) {
      if (h = S[ks] || S[Cu]) {
        if (S = h.alternate, h.child !== null || S !== null && S.child !== null)
          for (d = Jh(d); d !== null; ) {
            if (S = d[Cu])
              return S;
            d = Jh(d);
          }
        return h;
      }
      d = S, S = d.parentNode;
    }
    return null;
  }
  function Oo(d) {
    return d = d[Cu] || d[ks], !d || d.tag !== 5 && d.tag !== 6 && d.tag !== 13 && d.tag !== 3 ? null : d;
  }
  function ar(d) {
    if (d.tag === 5 || d.tag === 6)
      return d.stateNode;
    throw Error(n(33));
  }
  function xn(d) {
    return d[xu] || null;
  }
  var tf = [], _a = -1;
  function Un(d) {
    return { current: d };
  }
  function Wr(d) {
    0 > _a || (d.current = tf[_a], tf[_a] = null, _a--);
  }
  function Vr(d, h) {
    _a++, tf[_a] = d.current, d.current = h;
  }
  var Au = {}, Wn = Un(Au), Xa = Un(!1), qa = Au;
  function fl(d, h) {
    var S = d.type.contextTypes;
    if (!S)
      return Au;
    var x = d.stateNode;
    if (x && x.__reactInternalMemoizedUnmaskedChildContext === h)
      return x.__reactInternalMemoizedMaskedChildContext;
    var F = {}, U;
    for (U in S)
      F[U] = h[U];
    return x && (d = d.stateNode, d.__reactInternalMemoizedUnmaskedChildContext = h, d.__reactInternalMemoizedMaskedChildContext = F), F;
  }
  function ka(d) {
    return d = d.childContextTypes, d != null;
  }
  function dl() {
    Wr(Xa), Wr(Wn);
  }
  function nf(d, h, S) {
    if (Wn.current !== Au)
      throw Error(n(168));
    Vr(Wn, h), Vr(Xa, S);
  }
  function em(d, h, S) {
    var x = d.stateNode;
    if (h = h.childContextTypes, typeof x.getChildContext != "function")
      return S;
    x = x.getChildContext();
    for (var F in x)
      if (!(F in h))
        throw Error(n(108, Ee(d) || "Unknown", F));
    return B({}, S, x);
  }
  function pl(d) {
    return d = (d = d.stateNode) && d.__reactInternalMemoizedMergedChildContext || Au, qa = Wn.current, Vr(Wn, d), Vr(Xa, Xa.current), !0;
  }
  function V0(d, h, S) {
    var x = d.stateNode;
    if (!x)
      throw Error(n(169));
    S ? (d = em(d, h, qa), x.__reactInternalMemoizedMergedChildContext = d, Wr(Xa), Wr(Wn), Vr(Wn, d)) : Wr(Xa), Vr(Xa, S);
  }
  var Rs = null, Ui = !1, tm = !1;
  function Dv(d) {
    Rs === null ? Rs = [d] : Rs.push(d);
  }
  function fc(d) {
    Ui = !0, Dv(d);
  }
  function is() {
    if (!tm && Rs !== null) {
      tm = !0;
      var d = 0, h = hr;
      try {
        var S = Rs;
        for (hr = 1; d < S.length; d++) {
          var x = S[d];
          do
            x = x(!0);
          while (x !== null);
        }
        Rs = null, Ui = !1;
      } catch (F) {
        throw Rs !== null && (Rs = Rs.slice(d + 1)), ve(Nn, is), F;
      } finally {
        hr = h, tm = !1;
      }
    }
    return null;
  }
  var rf = [], Ra = 0, fd = null, Sp = 0, os = [], Eo = 0, hl = null, zi = 1, ku = "";
  function Is(d, h) {
    rf[Ra++] = Sp, rf[Ra++] = fd, fd = d, Sp = h;
  }
  function Nv(d, h, S) {
    os[Eo++] = zi, os[Eo++] = ku, os[Eo++] = hl, hl = d;
    var x = zi;
    d = ku;
    var F = 32 - Mr(x) - 1;
    x &= ~(1 << F), S += 1;
    var U = 32 - Mr(h) + F;
    if (30 < U) {
      var X = F - F % 5;
      U = (x & (1 << X) - 1).toString(32), x >>= X, F -= X, zi = 1 << 32 - Mr(h) + F | S << F | x, ku = U + d;
    } else
      zi = 1 << U | S << F | x, ku = d;
  }
  function wp(d) {
    d.return !== null && (Is(d, 1), Nv(d, 1, 0));
  }
  function dd(d) {
    for (; d === fd; )
      fd = rf[--Ra], rf[Ra] = null, Sp = rf[--Ra], rf[Ra] = null;
    for (; d === hl; )
      hl = os[--Eo], os[Eo] = null, ku = os[--Eo], os[Eo] = null, zi = os[--Eo], os[Eo] = null;
  }
  var So = null, ss = null, ga = !1, ml = null;
  function Vl(d, h) {
    var S = Bs(5, null, null, 0);
    S.elementType = "DELETED", S.stateNode = h, S.return = d, h = d.deletions, h === null ? (d.deletions = [S], d.flags |= 16) : h.push(S);
  }
  function _g(d, h) {
    switch (d.tag) {
      case 5:
        var S = d.type;
        return h = h.nodeType !== 1 || S.toLowerCase() !== h.nodeName.toLowerCase() ? null : h, h !== null ? (d.stateNode = h, So = d, ss = Gl(h.firstChild), !0) : !1;
      case 6:
        return h = d.pendingProps === "" || h.nodeType !== 3 ? null : h, h !== null ? (d.stateNode = h, So = d, ss = null, !0) : !1;
      case 13:
        return h = h.nodeType !== 8 ? null : h, h !== null ? (S = hl !== null ? { id: zi, overflow: ku } : null, d.memoizedState = { dehydrated: h, treeContext: S, retryLane: 1073741824 }, S = Bs(18, null, null, 0), S.stateNode = h, S.return = d, d.child = S, So = d, ss = null, !0) : !1;
      default:
        return !1;
    }
  }
  function Ru(d) {
    return (d.mode & 1) !== 0 && (d.flags & 128) === 0;
  }
  function Fo(d) {
    if (ga) {
      var h = ss;
      if (h) {
        var S = h;
        if (!_g(d, h)) {
          if (Ru(d))
            throw Error(n(418));
          h = Gl(S.nextSibling);
          var x = So;
          h && _g(d, h) ? Vl(x, S) : (d.flags = d.flags & -4097 | 2, ga = !1, So = d);
        }
      } else {
        if (Ru(d))
          throw Error(n(418));
        d.flags = d.flags & -4097 | 2, ga = !1, So = d;
      }
    }
  }
  function Y0(d) {
    for (d = d.return; d !== null && d.tag !== 5 && d.tag !== 3 && d.tag !== 13; )
      d = d.return;
    So = d;
  }
  function nm(d) {
    if (d !== So)
      return !1;
    if (!ga)
      return Y0(d), ga = !0, !1;
    var h;
    if ((h = d.tag !== 3) && !(h = d.tag !== 5) && (h = d.type, h = h !== "head" && h !== "body" && !ud(d.type, d.memoizedProps)), h && (h = ss)) {
      if (Ru(d))
        throw Pv(), Error(n(418));
      for (; h; )
        Vl(d, h), h = Gl(h.nextSibling);
    }
    if (Y0(d), d.tag === 13) {
      if (d = d.memoizedState, d = d !== null ? d.dehydrated : null, !d)
        throw Error(n(317));
      e: {
        for (d = d.nextSibling, h = 0; d; ) {
          if (d.nodeType === 8) {
            var S = d.data;
            if (S === "/$") {
              if (h === 0) {
                ss = Gl(d.nextSibling);
                break e;
              }
              h--;
            } else
              S !== "$" && S !== "$!" && S !== "$?" || h++;
          }
          d = d.nextSibling;
        }
        ss = null;
      }
    } else
      ss = So ? Gl(d.stateNode.nextSibling) : null;
    return !0;
  }
  function Pv() {
    for (var d = ss; d; )
      d = Gl(d.nextSibling);
  }
  function fa() {
    ss = So = null, ga = !1;
  }
  function Iu(d) {
    ml === null ? ml = [d] : ml.push(d);
  }
  var rm = I.ReactCurrentBatchConfig;
  function Ds(d, h) {
    if (d && d.defaultProps) {
      h = B({}, h), d = d.defaultProps;
      for (var S in d)
        h[S] === void 0 && (h[S] = d[S]);
      return h;
    }
    return h;
  }
  var Ns = Un(null), Cg = null, dc = null, Ti = null;
  function am() {
    Ti = dc = Cg = null;
  }
  function pc(d) {
    var h = Ns.current;
    Wr(Ns), d._currentValue = h;
  }
  function da(d, h, S) {
    for (; d !== null; ) {
      var x = d.alternate;
      if ((d.childLanes & h) !== h ? (d.childLanes |= h, x !== null && (x.childLanes |= h)) : x !== null && (x.childLanes & h) !== h && (x.childLanes |= h), d === S)
        break;
      d = d.return;
    }
  }
  function Gt(d, h) {
    Cg = d, Ti = dc = null, d = d.dependencies, d !== null && d.firstContext !== null && (d.lanes & h && (Ka = !0), d.firstContext = null);
  }
  function Ia(d) {
    var h = d._currentValue;
    if (Ti !== d)
      if (d = { context: d, memoizedValue: h, next: null }, dc === null) {
        if (Cg === null)
          throw Error(n(308));
        dc = d, Cg.dependencies = { lanes: 0, firstContext: d };
      } else
        dc = dc.next = d;
    return h;
  }
  var za = null;
  function xg(d) {
    za === null ? za = [d] : za.push(d);
  }
  function wo(d, h, S, x) {
    var F = h.interleaved;
    return F === null ? (S.next = S, xg(h)) : (S.next = F.next, F.next = S), h.interleaved = S, Yl(d, x);
  }
  function Yl(d, h) {
    d.lanes |= h;
    var S = d.alternate;
    for (S !== null && (S.lanes |= h), S = d, d = d.return; d !== null; )
      d.childLanes |= h, S = d.alternate, S !== null && (S.childLanes |= h), S = d, d = d.return;
    return S.tag === 3 ? S.stateNode : null;
  }
  var af = !1;
  function Lv(d) {
    d.updateQueue = { baseState: d.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
  }
  function _i(d, h) {
    d = d.updateQueue, h.updateQueue === d && (h.updateQueue = { baseState: d.baseState, firstBaseUpdate: d.firstBaseUpdate, lastBaseUpdate: d.lastBaseUpdate, shared: d.shared, effects: d.effects });
  }
  function Zl(d, h) {
    return { eventTime: d, lane: h, tag: 0, payload: null, callback: null, next: null };
  }
  function of(d, h, S) {
    var x = d.updateQueue;
    if (x === null)
      return null;
    if (x = x.shared, mr & 2) {
      var F = x.pending;
      return F === null ? h.next = h : (h.next = F.next, F.next = h), x.pending = h, Yl(d, S);
    }
    return F = x.interleaved, F === null ? (h.next = h, xg(x)) : (h.next = F.next, F.next = h), x.interleaved = h, Yl(d, S);
  }
  function sf(d, h, S) {
    if (h = h.updateQueue, h !== null && (h = h.shared, (S & 4194240) !== 0)) {
      var x = h.lanes;
      x &= d.pendingLanes, S |= x, h.lanes = S, go(d, S);
    }
  }
  function Ag(d, h) {
    var S = d.updateQueue, x = d.alternate;
    if (x !== null && (x = x.updateQueue, S === x)) {
      var F = null, U = null;
      if (S = S.firstBaseUpdate, S !== null) {
        do {
          var X = { eventTime: S.eventTime, lane: S.lane, tag: S.tag, payload: S.payload, callback: S.callback, next: null };
          U === null ? F = U = X : U = U.next = X, S = S.next;
        } while (S !== null);
        U === null ? F = U = h : U = U.next = h;
      } else
        F = U = h;
      S = { baseState: x.baseState, firstBaseUpdate: F, lastBaseUpdate: U, shared: x.shared, effects: x.effects }, d.updateQueue = S;
      return;
    }
    d = S.lastBaseUpdate, d === null ? S.firstBaseUpdate = h : d.next = h, S.lastBaseUpdate = h;
  }
  function lf(d, h, S, x) {
    var F = d.updateQueue;
    af = !1;
    var U = F.firstBaseUpdate, X = F.lastBaseUpdate, Se = F.shared.pending;
    if (Se !== null) {
      F.shared.pending = null;
      var Pe = Se, nt = Pe.next;
      Pe.next = null, X === null ? U = nt : X.next = nt, X = Pe;
      var At = d.alternate;
      At !== null && (At = At.updateQueue, Se = At.lastBaseUpdate, Se !== X && (Se === null ? At.firstBaseUpdate = nt : Se.next = nt, At.lastBaseUpdate = Pe));
    }
    if (U !== null) {
      var It = F.baseState;
      X = 0, At = nt = Pe = null, Se = U;
      do {
        var kt = Se.lane, en = Se.eventTime;
        if ((x & kt) === kt) {
          At !== null && (At = At.next = {
            eventTime: en,
            lane: 0,
            tag: Se.tag,
            payload: Se.payload,
            callback: Se.callback,
            next: null
          });
          e: {
            var dn = d, mn = Se;
            switch (kt = h, en = S, mn.tag) {
              case 1:
                if (dn = mn.payload, typeof dn == "function") {
                  It = dn.call(en, It, kt);
                  break e;
                }
                It = dn;
                break e;
              case 3:
                dn.flags = dn.flags & -65537 | 128;
              case 0:
                if (dn = mn.payload, kt = typeof dn == "function" ? dn.call(en, It, kt) : dn, kt == null)
                  break e;
                It = B({}, It, kt);
                break e;
              case 2:
                af = !0;
            }
          }
          Se.callback !== null && Se.lane !== 0 && (d.flags |= 64, kt = F.effects, kt === null ? F.effects = [Se] : kt.push(Se));
        } else
          en = { eventTime: en, lane: kt, tag: Se.tag, payload: Se.payload, callback: Se.callback, next: null }, At === null ? (nt = At = en, Pe = It) : At = At.next = en, X |= kt;
        if (Se = Se.next, Se === null) {
          if (Se = F.shared.pending, Se === null)
            break;
          kt = Se, Se = kt.next, kt.next = null, F.lastBaseUpdate = kt, F.shared.pending = null;
        }
      } while (1);
      if (At === null && (Pe = It), F.baseState = Pe, F.firstBaseUpdate = nt, F.lastBaseUpdate = At, h = F.shared.interleaved, h !== null) {
        F = h;
        do
          X |= F.lane, F = F.next;
        while (F !== h);
      } else
        U === null && (F.shared.lanes = 0);
      Mu |= X, d.lanes = X, d.memoizedState = It;
    }
  }
  function pd(d, h, S) {
    if (d = h.effects, h.effects = null, d !== null)
      for (h = 0; h < d.length; h++) {
        var x = d[h], F = x.callback;
        if (F !== null) {
          if (x.callback = null, x = S, typeof F != "function")
            throw Error(n(191, F));
          F.call(x);
        }
      }
  }
  var Tp = new t.Component().refs;
  function Mv(d, h, S, x) {
    h = d.memoizedState, S = S(x, h), S = S == null ? h : B({}, h, S), d.memoizedState = S, d.lanes === 0 && (d.updateQueue.baseState = S);
  }
  var kg = { isMounted: function(d) {
    return (d = d._reactInternals) ? Yn(d) === d : !1;
  }, enqueueSetState: function(d, h, S) {
    d = d._reactInternals;
    var x = Co(), F = yi(d), U = Zl(x, F);
    U.payload = h, S != null && (U.callback = S), h = of(d, U, F), h !== null && (xo(h, d, F, x), sf(h, d, F));
  }, enqueueReplaceState: function(d, h, S) {
    d = d._reactInternals;
    var x = Co(), F = yi(d), U = Zl(x, F);
    U.tag = 1, U.payload = h, S != null && (U.callback = S), h = of(d, U, F), h !== null && (xo(h, d, F, x), sf(h, d, F));
  }, enqueueForceUpdate: function(d, h) {
    d = d._reactInternals;
    var S = Co(), x = yi(d), F = Zl(S, x);
    F.tag = 2, h != null && (F.callback = h), h = of(d, F, x), h !== null && (xo(h, d, x, S), sf(h, d, x));
  } };
  function Rg(d, h, S, x, F, U, X) {
    return d = d.stateNode, typeof d.shouldComponentUpdate == "function" ? d.shouldComponentUpdate(x, U, X) : h.prototype && h.prototype.isPureReactComponent ? !Jt(S, x) || !Jt(F, U) : !0;
  }
  function Fv(d, h, S) {
    var x = !1, F = Au, U = h.contextType;
    return typeof U == "object" && U !== null ? U = Ia(U) : (F = ka(h) ? qa : Wn.current, x = h.contextTypes, U = (x = x != null) ? fl(d, F) : Au), h = new h(S, U), d.memoizedState = h.state !== null && h.state !== void 0 ? h.state : null, h.updater = kg, d.stateNode = h, h._reactInternals = d, x && (d = d.stateNode, d.__reactInternalMemoizedUnmaskedChildContext = F, d.__reactInternalMemoizedMaskedChildContext = U), h;
  }
  function Z0(d, h, S, x) {
    d = h.state, typeof h.componentWillReceiveProps == "function" && h.componentWillReceiveProps(S, x), typeof h.UNSAFE_componentWillReceiveProps == "function" && h.UNSAFE_componentWillReceiveProps(S, x), h.state !== d && kg.enqueueReplaceState(h, h.state, null);
  }
  function Ig(d, h, S, x) {
    var F = d.stateNode;
    F.props = S, F.state = d.memoizedState, F.refs = Tp, Lv(d);
    var U = h.contextType;
    typeof U == "object" && U !== null ? F.context = Ia(U) : (U = ka(h) ? qa : Wn.current, F.context = fl(d, U)), F.state = d.memoizedState, U = h.getDerivedStateFromProps, typeof U == "function" && (Mv(d, h, U, S), F.state = d.memoizedState), typeof h.getDerivedStateFromProps == "function" || typeof F.getSnapshotBeforeUpdate == "function" || typeof F.UNSAFE_componentWillMount != "function" && typeof F.componentWillMount != "function" || (h = F.state, typeof F.componentWillMount == "function" && F.componentWillMount(), typeof F.UNSAFE_componentWillMount == "function" && F.UNSAFE_componentWillMount(), h !== F.state && kg.enqueueReplaceState(F, F.state, null), lf(d, S, F, x), F.state = d.memoizedState), typeof F.componentDidMount == "function" && (d.flags |= 4194308);
  }
  function _p(d, h, S) {
    if (d = S.ref, d !== null && typeof d != "function" && typeof d != "object") {
      if (S._owner) {
        if (S = S._owner, S) {
          if (S.tag !== 1)
            throw Error(n(309));
          var x = S.stateNode;
        }
        if (!x)
          throw Error(n(147, d));
        var F = x, U = "" + d;
        return h !== null && h.ref !== null && typeof h.ref == "function" && h.ref._stringRef === U ? h.ref : (h = function(X) {
          var Se = F.refs;
          Se === Tp && (Se = F.refs = {}), X === null ? delete Se[U] : Se[U] = X;
        }, h._stringRef = U, h);
      }
      if (typeof d != "string")
        throw Error(n(284));
      if (!S._owner)
        throw Error(n(290, d));
    }
    return d;
  }
  function im(d, h) {
    throw d = Object.prototype.toString.call(h), Error(n(31, d === "[object Object]" ? "object with keys {" + Object.keys(h).join(", ") + "}" : d));
  }
  function Dg(d) {
    var h = d._init;
    return h(d._payload);
  }
  function X0(d) {
    function h(Ze, Me) {
      if (d) {
        var Xe = Ze.deletions;
        Xe === null ? (Ze.deletions = [Me], Ze.flags |= 16) : Xe.push(Me);
      }
    }
    function S(Ze, Me) {
      if (!d)
        return null;
      for (; Me !== null; )
        h(Ze, Me), Me = Me.sibling;
      return null;
    }
    function x(Ze, Me) {
      for (Ze = /* @__PURE__ */ new Map(); Me !== null; )
        Me.key !== null ? Ze.set(Me.key, Me) : Ze.set(Me.index, Me), Me = Me.sibling;
      return Ze;
    }
    function F(Ze, Me) {
      return Ze = Cf(Ze, Me), Ze.index = 0, Ze.sibling = null, Ze;
    }
    function U(Ze, Me, Xe) {
      return Ze.index = Xe, d ? (Xe = Ze.alternate, Xe !== null ? (Xe = Xe.index, Xe < Me ? (Ze.flags |= 2, Me) : Xe) : (Ze.flags |= 2, Me)) : (Ze.flags |= 1048576, Me);
    }
    function X(Ze) {
      return d && Ze.alternate === null && (Ze.flags |= 2), Ze;
    }
    function Se(Ze, Me, Xe, Ft) {
      return Me === null || Me.tag !== 6 ? (Me = _m(Xe, Ze.mode, Ft), Me.return = Ze, Me) : (Me = F(Me, Xe), Me.return = Ze, Me);
    }
    function Pe(Ze, Me, Xe, Ft) {
      var yn = Xe.type;
      return yn === H ? At(Ze, Me, Xe.props.children, Ft, Xe.key) : Me !== null && (Me.elementType === yn || typeof yn == "object" && yn !== null && yn.$$typeof === de && Dg(yn) === Me.type) ? (Ft = F(Me, Xe.props), Ft.ref = _p(Ze, Me, Xe), Ft.return = Ze, Ft) : (Ft = Jg(Xe.type, Xe.key, Xe.props, null, Ze.mode, Ft), Ft.ref = _p(Ze, Me, Xe), Ft.return = Ze, Ft);
    }
    function nt(Ze, Me, Xe, Ft) {
      return Me === null || Me.tag !== 4 || Me.stateNode.containerInfo !== Xe.containerInfo || Me.stateNode.implementation !== Xe.implementation ? (Me = Ad(Xe, Ze.mode, Ft), Me.return = Ze, Me) : (Me = F(Me, Xe.children || []), Me.return = Ze, Me);
    }
    function At(Ze, Me, Xe, Ft, yn) {
      return Me === null || Me.tag !== 7 ? (Me = xd(Xe, Ze.mode, Ft, yn), Me.return = Ze, Me) : (Me = F(Me, Xe), Me.return = Ze, Me);
    }
    function It(Ze, Me, Xe) {
      if (typeof Me == "string" && Me !== "" || typeof Me == "number")
        return Me = _m("" + Me, Ze.mode, Xe), Me.return = Ze, Me;
      if (typeof Me == "object" && Me !== null) {
        switch (Me.$$typeof) {
          case D:
            return Xe = Jg(Me.type, Me.key, Me.props, null, Ze.mode, Xe), Xe.ref = _p(Ze, null, Me), Xe.return = Ze, Xe;
          case M:
            return Me = Ad(Me, Ze.mode, Xe), Me.return = Ze, Me;
          case de:
            var Ft = Me._init;
            return It(Ze, Ft(Me._payload), Xe);
        }
        if (ut(Me) || ye(Me))
          return Me = xd(Me, Ze.mode, Xe, null), Me.return = Ze, Me;
        im(Ze, Me);
      }
      return null;
    }
    function kt(Ze, Me, Xe, Ft) {
      var yn = Me !== null ? Me.key : null;
      if (typeof Xe == "string" && Xe !== "" || typeof Xe == "number")
        return yn !== null ? null : Se(Ze, Me, "" + Xe, Ft);
      if (typeof Xe == "object" && Xe !== null) {
        switch (Xe.$$typeof) {
          case D:
            return Xe.key === yn ? Pe(Ze, Me, Xe, Ft) : null;
          case M:
            return Xe.key === yn ? nt(Ze, Me, Xe, Ft) : null;
          case de:
            return yn = Xe._init, kt(
              Ze,
              Me,
              yn(Xe._payload),
              Ft
            );
        }
        if (ut(Xe) || ye(Xe))
          return yn !== null ? null : At(Ze, Me, Xe, Ft, null);
        im(Ze, Xe);
      }
      return null;
    }
    function en(Ze, Me, Xe, Ft, yn) {
      if (typeof Ft == "string" && Ft !== "" || typeof Ft == "number")
        return Ze = Ze.get(Xe) || null, Se(Me, Ze, "" + Ft, yn);
      if (typeof Ft == "object" && Ft !== null) {
        switch (Ft.$$typeof) {
          case D:
            return Ze = Ze.get(Ft.key === null ? Xe : Ft.key) || null, Pe(Me, Ze, Ft, yn);
          case M:
            return Ze = Ze.get(Ft.key === null ? Xe : Ft.key) || null, nt(Me, Ze, Ft, yn);
          case de:
            var cn = Ft._init;
            return en(Ze, Me, Xe, cn(Ft._payload), yn);
        }
        if (ut(Ft) || ye(Ft))
          return Ze = Ze.get(Xe) || null, At(Me, Ze, Ft, yn, null);
        im(Me, Ft);
      }
      return null;
    }
    function dn(Ze, Me, Xe, Ft) {
      for (var yn = null, cn = null, wn = Me, Qn = Me = 0, Gi = null; wn !== null && Qn < Xe.length; Qn++) {
        wn.index > Qn ? (Gi = wn, wn = null) : Gi = wn.sibling;
        var Rr = kt(Ze, wn, Xe[Qn], Ft);
        if (Rr === null) {
          wn === null && (wn = Gi);
          break;
        }
        d && wn && Rr.alternate === null && h(Ze, wn), Me = U(Rr, Me, Qn), cn === null ? yn = Rr : cn.sibling = Rr, cn = Rr, wn = Gi;
      }
      if (Qn === Xe.length)
        return S(Ze, wn), ga && Is(Ze, Qn), yn;
      if (wn === null) {
        for (; Qn < Xe.length; Qn++)
          wn = It(Ze, Xe[Qn], Ft), wn !== null && (Me = U(wn, Me, Qn), cn === null ? yn = wn : cn.sibling = wn, cn = wn);
        return ga && Is(Ze, Qn), yn;
      }
      for (wn = x(Ze, wn); Qn < Xe.length; Qn++)
        Gi = en(wn, Ze, Qn, Xe[Qn], Ft), Gi !== null && (d && Gi.alternate !== null && wn.delete(Gi.key === null ? Qn : Gi.key), Me = U(Gi, Me, Qn), cn === null ? yn = Gi : cn.sibling = Gi, cn = Gi);
      return d && wn.forEach(function(xf) {
        return h(Ze, xf);
      }), ga && Is(Ze, Qn), yn;
    }
    function mn(Ze, Me, Xe, Ft) {
      var yn = ye(Xe);
      if (typeof yn != "function")
        throw Error(n(150));
      if (Xe = yn.call(Xe), Xe == null)
        throw Error(n(151));
      for (var cn = yn = null, wn = Me, Qn = Me = 0, Gi = null, Rr = Xe.next(); wn !== null && !Rr.done; Qn++, Rr = Xe.next()) {
        wn.index > Qn ? (Gi = wn, wn = null) : Gi = wn.sibling;
        var xf = kt(Ze, wn, Rr.value, Ft);
        if (xf === null) {
          wn === null && (wn = Gi);
          break;
        }
        d && wn && xf.alternate === null && h(Ze, wn), Me = U(xf, Me, Qn), cn === null ? yn = xf : cn.sibling = xf, cn = xf, wn = Gi;
      }
      if (Rr.done)
        return S(
          Ze,
          wn
        ), ga && Is(Ze, Qn), yn;
      if (wn === null) {
        for (; !Rr.done; Qn++, Rr = Xe.next())
          Rr = It(Ze, Rr.value, Ft), Rr !== null && (Me = U(Rr, Me, Qn), cn === null ? yn = Rr : cn.sibling = Rr, cn = Rr);
        return ga && Is(Ze, Qn), yn;
      }
      for (wn = x(Ze, wn); !Rr.done; Qn++, Rr = Xe.next())
        Rr = en(wn, Ze, Qn, Rr.value, Ft), Rr !== null && (d && Rr.alternate !== null && wn.delete(Rr.key === null ? Qn : Rr.key), Me = U(Rr, Me, Qn), cn === null ? yn = Rr : cn.sibling = Rr, cn = Rr);
      return d && wn.forEach(function(Z1) {
        return h(Ze, Z1);
      }), ga && Is(Ze, Qn), yn;
    }
    function ci(Ze, Me, Xe, Ft) {
      if (typeof Xe == "object" && Xe !== null && Xe.type === H && Xe.key === null && (Xe = Xe.props.children), typeof Xe == "object" && Xe !== null) {
        switch (Xe.$$typeof) {
          case D:
            e: {
              for (var yn = Xe.key, cn = Me; cn !== null; ) {
                if (cn.key === yn) {
                  if (yn = Xe.type, yn === H) {
                    if (cn.tag === 7) {
                      S(Ze, cn.sibling), Me = F(cn, Xe.props.children), Me.return = Ze, Ze = Me;
                      break e;
                    }
                  } else if (cn.elementType === yn || typeof yn == "object" && yn !== null && yn.$$typeof === de && Dg(yn) === cn.type) {
                    S(Ze, cn.sibling), Me = F(cn, Xe.props), Me.ref = _p(Ze, cn, Xe), Me.return = Ze, Ze = Me;
                    break e;
                  }
                  S(Ze, cn);
                  break;
                } else
                  h(Ze, cn);
                cn = cn.sibling;
              }
              Xe.type === H ? (Me = xd(Xe.props.children, Ze.mode, Ft, Xe.key), Me.return = Ze, Ze = Me) : (Ft = Jg(Xe.type, Xe.key, Xe.props, null, Ze.mode, Ft), Ft.ref = _p(Ze, Me, Xe), Ft.return = Ze, Ze = Ft);
            }
            return X(Ze);
          case M:
            e: {
              for (cn = Xe.key; Me !== null; ) {
                if (Me.key === cn)
                  if (Me.tag === 4 && Me.stateNode.containerInfo === Xe.containerInfo && Me.stateNode.implementation === Xe.implementation) {
                    S(Ze, Me.sibling), Me = F(Me, Xe.children || []), Me.return = Ze, Ze = Me;
                    break e;
                  } else {
                    S(Ze, Me);
                    break;
                  }
                else
                  h(Ze, Me);
                Me = Me.sibling;
              }
              Me = Ad(Xe, Ze.mode, Ft), Me.return = Ze, Ze = Me;
            }
            return X(Ze);
          case de:
            return cn = Xe._init, ci(Ze, Me, cn(Xe._payload), Ft);
        }
        if (ut(Xe))
          return dn(Ze, Me, Xe, Ft);
        if (ye(Xe))
          return mn(Ze, Me, Xe, Ft);
        im(Ze, Xe);
      }
      return typeof Xe == "string" && Xe !== "" || typeof Xe == "number" ? (Xe = "" + Xe, Me !== null && Me.tag === 6 ? (S(Ze, Me.sibling), Me = F(Me, Xe), Me.return = Ze, Ze = Me) : (S(Ze, Me), Me = _m(Xe, Ze.mode, Ft), Me.return = Ze, Ze = Me), X(Ze)) : S(Ze, Me);
    }
    return ci;
  }
  var uf = X0(!0), $v = X0(!1), Cp = {}, gl = Un(Cp), cf = Un(Cp), xp = Un(Cp);
  function ff(d) {
    if (d === Cp)
      throw Error(n(174));
    return d;
  }
  function Ng(d, h) {
    switch (Vr(xp, h), Vr(cf, d), Vr(gl, Cp), d = h.nodeType, d) {
      case 9:
      case 11:
        h = (h = h.documentElement) ? h.namespaceURI : Ie(null, "");
        break;
      default:
        d = d === 8 ? h.parentNode : h, h = d.namespaceURI || null, d = d.tagName, h = Ie(h, d);
    }
    Wr(gl), Vr(gl, h);
  }
  function df() {
    Wr(gl), Wr(cf), Wr(xp);
  }
  function In(d) {
    ff(xp.current);
    var h = ff(gl.current), S = Ie(h, d.type);
    h !== S && (Vr(cf, d), Vr(gl, S));
  }
  function cr(d) {
    cf.current === d && (Wr(gl), Wr(cf));
  }
  var Dn = Un(0);
  function Da(d) {
    for (var h = d; h !== null; ) {
      if (h.tag === 13) {
        var S = h.memoizedState;
        if (S !== null && (S = S.dehydrated, S === null || S.data === "$?" || S.data === "$!"))
          return h;
      } else if (h.tag === 19 && h.memoizedProps.revealOrder !== void 0) {
        if (h.flags & 128)
          return h;
      } else if (h.child !== null) {
        h.child.return = h, h = h.child;
        continue;
      }
      if (h === d)
        break;
      for (; h.sibling === null; ) {
        if (h.return === null || h.return === d)
          return null;
        h = h.return;
      }
      h.sibling.return = h.return, h = h.sibling;
    }
    return null;
  }
  var ls = [];
  function Pg() {
    for (var d = 0; d < ls.length; d++)
      ls[d]._workInProgressVersionPrimary = null;
    ls.length = 0;
  }
  var Ap = I.ReactCurrentDispatcher, ir = I.ReactCurrentBatchConfig, hd = 0, Ca = null, ct = null, vr = null, Fn = !1, Du = !1, Na = 0, md = 0;
  function aa() {
    throw Error(n(321));
  }
  function hc(d, h) {
    if (h === null)
      return !1;
    for (var S = 0; S < h.length && S < d.length; S++)
      if (!et(d[S], h[S]))
        return !1;
    return !0;
  }
  function mc(d, h, S, x, F, U) {
    if (hd = U, Ca = h, h.memoizedState = null, h.updateQueue = null, h.lanes = 0, Ap.current = d === null || d.memoizedState === null ? mm : F1, d = S(x, F), Du) {
      U = 0;
      do {
        if (Du = !1, Na = 0, 25 <= U)
          throw Error(n(301));
        U += 1, vr = ct = null, h.updateQueue = null, Ap.current = Fg, d = S(x, F);
      } while (Du);
    }
    if (Ap.current = Oc, h = ct !== null && ct.next !== null, hd = 0, vr = ct = Ca = null, Fn = !1, h)
      throw Error(n(300));
    return d;
  }
  function pf() {
    var d = Na !== 0;
    return Na = 0, d;
  }
  function Pa() {
    var d = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    return vr === null ? Ca.memoizedState = vr = d : vr = vr.next = d, vr;
  }
  function ui() {
    if (ct === null) {
      var d = Ca.alternate;
      d = d !== null ? d.memoizedState : null;
    } else
      d = ct.next;
    var h = vr === null ? Ca.memoizedState : vr.next;
    if (h !== null)
      vr = h, ct = d;
    else {
      if (d === null)
        throw Error(n(310));
      ct = d, d = { memoizedState: ct.memoizedState, baseState: ct.baseState, baseQueue: ct.baseQueue, queue: ct.queue, next: null }, vr === null ? Ca.memoizedState = vr = d : vr = vr.next = d;
    }
    return vr;
  }
  function gc(d, h) {
    return typeof h == "function" ? h(d) : h;
  }
  function kp(d) {
    var h = ui(), S = h.queue;
    if (S === null)
      throw Error(n(311));
    S.lastRenderedReducer = d;
    var x = ct, F = x.baseQueue, U = S.pending;
    if (U !== null) {
      if (F !== null) {
        var X = F.next;
        F.next = U.next, U.next = X;
      }
      x.baseQueue = F = U, S.pending = null;
    }
    if (F !== null) {
      U = F.next, x = x.baseState;
      var Se = X = null, Pe = null, nt = U;
      do {
        var At = nt.lane;
        if ((hd & At) === At)
          Pe !== null && (Pe = Pe.next = { lane: 0, action: nt.action, hasEagerState: nt.hasEagerState, eagerState: nt.eagerState, next: null }), x = nt.hasEagerState ? nt.eagerState : d(x, nt.action);
        else {
          var It = {
            lane: At,
            action: nt.action,
            hasEagerState: nt.hasEagerState,
            eagerState: nt.eagerState,
            next: null
          };
          Pe === null ? (Se = Pe = It, X = x) : Pe = Pe.next = It, Ca.lanes |= At, Mu |= At;
        }
        nt = nt.next;
      } while (nt !== null && nt !== U);
      Pe === null ? X = x : Pe.next = Se, et(x, h.memoizedState) || (Ka = !0), h.memoizedState = x, h.baseState = X, h.baseQueue = Pe, S.lastRenderedState = x;
    }
    if (d = S.interleaved, d !== null) {
      F = d;
      do
        U = F.lane, Ca.lanes |= U, Mu |= U, F = F.next;
      while (F !== d);
    } else
      F === null && (S.lanes = 0);
    return [h.memoizedState, S.dispatch];
  }
  function hf(d) {
    var h = ui(), S = h.queue;
    if (S === null)
      throw Error(n(311));
    S.lastRenderedReducer = d;
    var x = S.dispatch, F = S.pending, U = h.memoizedState;
    if (F !== null) {
      S.pending = null;
      var X = F = F.next;
      do
        U = d(U, X.action), X = X.next;
      while (X !== F);
      et(U, h.memoizedState) || (Ka = !0), h.memoizedState = U, h.baseQueue === null && (h.baseState = U), S.lastRenderedState = U;
    }
    return [U, x];
  }
  function om() {
  }
  function Rp(d, h) {
    var S = Ca, x = ui(), F = h(), U = !et(x.memoizedState, F);
    if (U && (x.memoizedState = F, Ka = !0), x = x.queue, um(Dp.bind(null, S, x, d), [d]), x.getSnapshot !== h || U || vr !== null && vr.memoizedState.tag & 1) {
      if (S.flags |= 2048, mf(9, Ip.bind(null, S, x, F, h), void 0, null), Ha === null)
        throw Error(n(349));
      hd & 30 || sm(S, h, F);
    }
    return F;
  }
  function sm(d, h, S) {
    d.flags |= 16384, d = { getSnapshot: h, value: S }, h = Ca.updateQueue, h === null ? (h = { lastEffect: null, stores: null }, Ca.updateQueue = h, h.stores = [d]) : (S = h.stores, S === null ? h.stores = [d] : S.push(d));
  }
  function Ip(d, h, S, x) {
    h.value = S, h.getSnapshot = x, Xl(h) && Lg(d);
  }
  function Dp(d, h, S) {
    return S(function() {
      Xl(h) && Lg(d);
    });
  }
  function Xl(d) {
    var h = d.getSnapshot;
    d = d.value;
    try {
      var S = h();
      return !et(d, S);
    } catch {
      return !0;
    }
  }
  function Lg(d) {
    var h = Yl(d, 1);
    h !== null && xo(h, d, 1, -1);
  }
  function ql(d) {
    var h = Pa();
    return typeof d == "function" && (d = d()), h.memoizedState = h.baseState = d, d = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: gc, lastRenderedState: d }, h.queue = d, d = d.dispatch = pm.bind(null, Ca, d), [h.memoizedState, d];
  }
  function mf(d, h, S, x) {
    return d = { tag: d, create: h, destroy: S, deps: x, next: null }, h = Ca.updateQueue, h === null ? (h = { lastEffect: null, stores: null }, Ca.updateQueue = h, h.lastEffect = d.next = d) : (S = h.lastEffect, S === null ? h.lastEffect = d.next = d : (x = S.next, S.next = d, d.next = x, h.lastEffect = d)), d;
  }
  function lm() {
    return ui().memoizedState;
  }
  function bc(d, h, S, x) {
    var F = Pa();
    Ca.flags |= d, F.memoizedState = mf(1 | h, S, void 0, x === void 0 ? null : x);
  }
  function vc(d, h, S, x) {
    var F = ui();
    x = x === void 0 ? null : x;
    var U = void 0;
    if (ct !== null) {
      var X = ct.memoizedState;
      if (U = X.destroy, x !== null && hc(x, X.deps)) {
        F.memoizedState = mf(h, S, U, x);
        return;
      }
    }
    Ca.flags |= d, F.memoizedState = mf(1 | h, S, U, x);
  }
  function Mg(d, h) {
    return bc(8390656, 8, d, h);
  }
  function um(d, h) {
    return vc(2048, 8, d, h);
  }
  function cm(d, h) {
    return vc(4, 2, d, h);
  }
  function fm(d, h) {
    return vc(4, 4, d, h);
  }
  function Bv(d, h) {
    if (typeof h == "function")
      return d = d(), h(d), function() {
        h(null);
      };
    if (h != null)
      return d = d(), h.current = d, function() {
        h.current = null;
      };
  }
  function gd(d, h, S) {
    return S = S != null ? S.concat([d]) : null, vc(4, 4, Bv.bind(null, h, d), S);
  }
  function dm() {
  }
  function Ci(d, h) {
    var S = ui();
    h = h === void 0 ? null : h;
    var x = S.memoizedState;
    return x !== null && h !== null && hc(h, x[1]) ? x[0] : (S.memoizedState = [d, h], d);
  }
  function ao(d, h) {
    var S = ui();
    h = h === void 0 ? null : h;
    var x = S.memoizedState;
    return x !== null && h !== null && hc(h, x[1]) ? x[0] : (d = d(), S.memoizedState = [d, h], d);
  }
  function us(d, h, S) {
    return hd & 21 ? (et(S, h) || (S = Ts(), Ca.lanes |= S, Mu |= S, d.baseState = !0), h) : (d.baseState && (d.baseState = !1, Ka = !0), d.memoizedState = S);
  }
  function M1(d, h) {
    var S = hr;
    hr = S !== 0 && 4 > S ? S : 4, d(!0);
    var x = ir.transition;
    ir.transition = {};
    try {
      d(!1), h();
    } finally {
      hr = S, ir.transition = x;
    }
  }
  function Yr() {
    return ui().memoizedState;
  }
  function yc(d, h, S) {
    var x = yi(d);
    if (S = { lane: x, action: S, hasEagerState: !1, eagerState: null, next: null }, bd(d))
      hm(h, S);
    else if (S = wo(d, h, S, x), S !== null) {
      var F = Co();
      xo(S, d, x, F), Uv(S, h, x);
    }
  }
  function pm(d, h, S) {
    var x = yi(d), F = { lane: x, action: S, hasEagerState: !1, eagerState: null, next: null };
    if (bd(d))
      hm(h, F);
    else {
      var U = d.alternate;
      if (d.lanes === 0 && (U === null || U.lanes === 0) && (U = h.lastRenderedReducer, U !== null))
        try {
          var X = h.lastRenderedState, Se = U(X, S);
          if (F.hasEagerState = !0, F.eagerState = Se, et(Se, X)) {
            var Pe = h.interleaved;
            Pe === null ? (F.next = F, xg(h)) : (F.next = Pe.next, Pe.next = F), h.interleaved = F;
            return;
          }
        } catch {
        } finally {
        }
      S = wo(d, h, F, x), S !== null && (F = Co(), xo(S, d, x, F), Uv(S, h, x));
    }
  }
  function bd(d) {
    var h = d.alternate;
    return d === Ca || h !== null && h === Ca;
  }
  function hm(d, h) {
    Du = Fn = !0;
    var S = d.pending;
    S === null ? h.next = h : (h.next = S.next, S.next = h), d.pending = h;
  }
  function Uv(d, h, S) {
    if (S & 4194240) {
      var x = h.lanes;
      x &= d.pendingLanes, S |= x, h.lanes = S, go(d, S);
    }
  }
  var Oc = { readContext: Ia, useCallback: aa, useContext: aa, useEffect: aa, useImperativeHandle: aa, useInsertionEffect: aa, useLayoutEffect: aa, useMemo: aa, useReducer: aa, useRef: aa, useState: aa, useDebugValue: aa, useDeferredValue: aa, useTransition: aa, useMutableSource: aa, useSyncExternalStore: aa, useId: aa, unstable_isNewReconciler: !1 }, mm = { readContext: Ia, useCallback: function(d, h) {
    return Pa().memoizedState = [d, h === void 0 ? null : h], d;
  }, useContext: Ia, useEffect: Mg, useImperativeHandle: function(d, h, S) {
    return S = S != null ? S.concat([d]) : null, bc(
      4194308,
      4,
      Bv.bind(null, h, d),
      S
    );
  }, useLayoutEffect: function(d, h) {
    return bc(4194308, 4, d, h);
  }, useInsertionEffect: function(d, h) {
    return bc(4, 2, d, h);
  }, useMemo: function(d, h) {
    var S = Pa();
    return h = h === void 0 ? null : h, d = d(), S.memoizedState = [d, h], d;
  }, useReducer: function(d, h, S) {
    var x = Pa();
    return h = S !== void 0 ? S(h) : h, x.memoizedState = x.baseState = h, d = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: d, lastRenderedState: h }, x.queue = d, d = d.dispatch = yc.bind(null, Ca, d), [x.memoizedState, d];
  }, useRef: function(d) {
    var h = Pa();
    return d = { current: d }, h.memoizedState = d;
  }, useState: ql, useDebugValue: dm, useDeferredValue: function(d) {
    return Pa().memoizedState = d;
  }, useTransition: function() {
    var d = ql(!1), h = d[0];
    return d = M1.bind(null, d[1]), Pa().memoizedState = d, [h, d];
  }, useMutableSource: function() {
  }, useSyncExternalStore: function(d, h, S) {
    var x = Ca, F = Pa();
    if (ga) {
      if (S === void 0)
        throw Error(n(407));
      S = S();
    } else {
      if (S = h(), Ha === null)
        throw Error(n(349));
      hd & 30 || sm(x, h, S);
    }
    F.memoizedState = S;
    var U = { value: S, getSnapshot: h };
    return F.queue = U, Mg(Dp.bind(
      null,
      x,
      U,
      d
    ), [d]), x.flags |= 2048, mf(9, Ip.bind(null, x, U, S, h), void 0, null), S;
  }, useId: function() {
    var d = Pa(), h = Ha.identifierPrefix;
    if (ga) {
      var S = ku, x = zi;
      S = (x & ~(1 << 32 - Mr(x) - 1)).toString(32) + S, h = ":" + h + "R" + S, S = Na++, 0 < S && (h += "H" + S.toString(32)), h += ":";
    } else
      S = md++, h = ":" + h + "r" + S.toString(32) + ":";
    return d.memoizedState = h;
  }, unstable_isNewReconciler: !1 }, F1 = {
    readContext: Ia,
    useCallback: Ci,
    useContext: Ia,
    useEffect: um,
    useImperativeHandle: gd,
    useInsertionEffect: cm,
    useLayoutEffect: fm,
    useMemo: ao,
    useReducer: kp,
    useRef: lm,
    useState: function() {
      return kp(gc);
    },
    useDebugValue: dm,
    useDeferredValue: function(d) {
      var h = ui();
      return us(h, ct.memoizedState, d);
    },
    useTransition: function() {
      var d = kp(gc)[0], h = ui().memoizedState;
      return [d, h];
    },
    useMutableSource: om,
    useSyncExternalStore: Rp,
    useId: Yr,
    unstable_isNewReconciler: !1
  }, Fg = { readContext: Ia, useCallback: Ci, useContext: Ia, useEffect: um, useImperativeHandle: gd, useInsertionEffect: cm, useLayoutEffect: fm, useMemo: ao, useReducer: hf, useRef: lm, useState: function() {
    return hf(gc);
  }, useDebugValue: dm, useDeferredValue: function(d) {
    var h = ui();
    return ct === null ? h.memoizedState = d : us(h, ct.memoizedState, d);
  }, useTransition: function() {
    var d = hf(gc)[0], h = ui().memoizedState;
    return [d, h];
  }, useMutableSource: om, useSyncExternalStore: Rp, useId: Yr, unstable_isNewReconciler: !1 };
  function vd(d, h) {
    try {
      var S = "", x = h;
      do
        S += j(x), x = x.return;
      while (x);
      var F = S;
    } catch (U) {
      F = `
Error generating stack: ` + U.message + `
` + U.stack;
    }
    return { value: d, source: h, stack: F, digest: null };
  }
  function gf(d, h, S) {
    return { value: d, source: null, stack: S ?? null, digest: h ?? null };
  }
  function gm(d, h) {
    try {
      console.error(h.value);
    } catch (S) {
      setTimeout(function() {
        throw S;
      });
    }
  }
  var $g = typeof WeakMap == "function" ? WeakMap : Map;
  function Bg(d, h, S) {
    S = Zl(-1, S), S.tag = 3, S.payload = { element: null };
    var x = h.value;
    return S.callback = function() {
      Gg || (Gg = !0, wd = x), gm(d, h);
    }, S;
  }
  function bf(d, h, S) {
    S = Zl(-1, S), S.tag = 3;
    var x = d.type.getDerivedStateFromError;
    if (typeof x == "function") {
      var F = h.value;
      S.payload = function() {
        return x(F);
      }, S.callback = function() {
        gm(d, h);
      };
    }
    var U = d.stateNode;
    return U !== null && typeof U.componentDidCatch == "function" && (S.callback = function() {
      gm(d, h), typeof x != "function" && (Fu === null ? Fu = /* @__PURE__ */ new Set([this]) : Fu.add(this));
      var X = h.stack;
      this.componentDidCatch(h.value, { componentStack: X !== null ? X : "" });
    }), S;
  }
  function q0(d, h, S) {
    var x = d.pingCache;
    if (x === null) {
      x = d.pingCache = new $g();
      var F = /* @__PURE__ */ new Set();
      x.set(h, F);
    } else
      F = x.get(h), F === void 0 && (F = /* @__PURE__ */ new Set(), x.set(h, F));
    F.has(S) || (F.add(S), d = H1.bind(null, d, h, S), h.then(d, d));
  }
  function Ug(d) {
    do {
      var h;
      if ((h = d.tag === 13) && (h = d.memoizedState, h = h !== null ? h.dehydrated !== null : !0), h)
        return d;
      d = d.return;
    } while (d !== null);
    return null;
  }
  function Np(d, h, S, x, F) {
    return d.mode & 1 ? (d.flags |= 65536, d.lanes = F, d) : (d === h ? d.flags |= 65536 : (d.flags |= 128, S.flags |= 131072, S.flags &= -52805, S.tag === 1 && (S.alternate === null ? S.tag = 17 : (h = Zl(-1, 1), h.tag = 2, of(S, h, 1))), S.lanes |= 1), d);
  }
  var K0 = I.ReactCurrentOwner, Ka = !1;
  function xi(d, h, S, x) {
    h.child = d === null ? $v(h, null, S, x) : uf(h, d.child, S, x);
  }
  function Ec(d, h, S, x, F) {
    S = S.render;
    var U = h.ref;
    return Gt(h, F), x = mc(d, h, S, x, U, F), S = pf(), d !== null && !Ka ? (h.updateQueue = d.updateQueue, h.flags &= -2053, d.lanes &= ~F, Wi(d, h, F)) : (ga && S && wp(h), h.flags |= 1, xi(d, h, x, F), h.child);
  }
  function bl(d, h, S, x, F) {
    if (d === null) {
      var U = S.type;
      return typeof U == "function" && !ay(U) && U.defaultProps === void 0 && S.compare === null && S.defaultProps === void 0 ? (h.tag = 15, h.type = U, $o(d, h, U, x, F)) : (d = Jg(S.type, null, x, h, h.mode, F), d.ref = h.ref, d.return = h, h.child = d);
    }
    if (U = d.child, !(d.lanes & F)) {
      var X = U.memoizedProps;
      if (S = S.compare, S = S !== null ? S : Jt, S(X, x) && d.ref === h.ref)
        return Wi(d, h, F);
    }
    return h.flags |= 1, d = Cf(U, x), d.ref = h.ref, d.return = h, h.child = d;
  }
  function $o(d, h, S, x, F) {
    if (d !== null) {
      var U = d.memoizedProps;
      if (Jt(U, x) && d.ref === h.ref)
        if (Ka = !1, h.pendingProps = x = U, (d.lanes & F) !== 0)
          d.flags & 131072 && (Ka = !0);
        else
          return h.lanes = d.lanes, Wi(d, h, F);
    }
    return yd(d, h, S, x, F);
  }
  function vf(d, h, S) {
    var x = h.pendingProps, F = x.children, U = d !== null ? d.memoizedState : null;
    if (x.mode === "hidden")
      if (!(h.mode & 1))
        h.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, Vr(Up, $s), $s |= S;
      else {
        if (!(S & 1073741824))
          return d = U !== null ? U.baseLanes | S : S, h.lanes = h.childLanes = 1073741824, h.memoizedState = { baseLanes: d, cachePool: null, transitions: null }, h.updateQueue = null, Vr(Up, $s), $s |= d, null;
        h.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, x = U !== null ? U.baseLanes : S, Vr(Up, $s), $s |= x;
      }
    else
      U !== null ? (x = U.baseLanes | S, h.memoizedState = null) : x = S, Vr(Up, $s), $s |= x;
    return xi(d, h, F, S), h.child;
  }
  function er(d, h) {
    var S = h.ref;
    (d === null && S !== null || d !== null && d.ref !== S) && (h.flags |= 512, h.flags |= 2097152);
  }
  function yd(d, h, S, x, F) {
    var U = ka(S) ? qa : Wn.current;
    return U = fl(h, U), Gt(h, F), S = mc(d, h, S, x, U, F), x = pf(), d !== null && !Ka ? (h.updateQueue = d.updateQueue, h.flags &= -2053, d.lanes &= ~F, Wi(d, h, F)) : (ga && x && wp(h), h.flags |= 1, xi(d, h, S, F), h.child);
  }
  function zv(d, h, S, x, F) {
    if (ka(S)) {
      var U = !0;
      pl(h);
    } else
      U = !1;
    if (Gt(h, F), h.stateNode === null)
      Hi(d, h), Fv(h, S, x), Ig(h, S, x, F), x = !0;
    else if (d === null) {
      var X = h.stateNode, Se = h.memoizedProps;
      X.props = Se;
      var Pe = X.context, nt = S.contextType;
      typeof nt == "object" && nt !== null ? nt = Ia(nt) : (nt = ka(S) ? qa : Wn.current, nt = fl(h, nt));
      var At = S.getDerivedStateFromProps, It = typeof At == "function" || typeof X.getSnapshotBeforeUpdate == "function";
      It || typeof X.UNSAFE_componentWillReceiveProps != "function" && typeof X.componentWillReceiveProps != "function" || (Se !== x || Pe !== nt) && Z0(h, X, x, nt), af = !1;
      var kt = h.memoizedState;
      X.state = kt, lf(h, x, X, F), Pe = h.memoizedState, Se !== x || kt !== Pe || Xa.current || af ? (typeof At == "function" && (Mv(h, S, At, x), Pe = h.memoizedState), (Se = af || Rg(h, S, Se, x, kt, Pe, nt)) ? (It || typeof X.UNSAFE_componentWillMount != "function" && typeof X.componentWillMount != "function" || (typeof X.componentWillMount == "function" && X.componentWillMount(), typeof X.UNSAFE_componentWillMount == "function" && X.UNSAFE_componentWillMount()), typeof X.componentDidMount == "function" && (h.flags |= 4194308)) : (typeof X.componentDidMount == "function" && (h.flags |= 4194308), h.memoizedProps = x, h.memoizedState = Pe), X.props = x, X.state = Pe, X.context = nt, x = Se) : (typeof X.componentDidMount == "function" && (h.flags |= 4194308), x = !1);
    } else {
      X = h.stateNode, _i(d, h), Se = h.memoizedProps, nt = h.type === h.elementType ? Se : Ds(h.type, Se), X.props = nt, It = h.pendingProps, kt = X.context, Pe = S.contextType, typeof Pe == "object" && Pe !== null ? Pe = Ia(Pe) : (Pe = ka(S) ? qa : Wn.current, Pe = fl(h, Pe));
      var en = S.getDerivedStateFromProps;
      (At = typeof en == "function" || typeof X.getSnapshotBeforeUpdate == "function") || typeof X.UNSAFE_componentWillReceiveProps != "function" && typeof X.componentWillReceiveProps != "function" || (Se !== It || kt !== Pe) && Z0(h, X, x, Pe), af = !1, kt = h.memoizedState, X.state = kt, lf(h, x, X, F);
      var dn = h.memoizedState;
      Se !== It || kt !== dn || Xa.current || af ? (typeof en == "function" && (Mv(h, S, en, x), dn = h.memoizedState), (nt = af || Rg(h, S, nt, x, kt, dn, Pe) || !1) ? (At || typeof X.UNSAFE_componentWillUpdate != "function" && typeof X.componentWillUpdate != "function" || (typeof X.componentWillUpdate == "function" && X.componentWillUpdate(x, dn, Pe), typeof X.UNSAFE_componentWillUpdate == "function" && X.UNSAFE_componentWillUpdate(x, dn, Pe)), typeof X.componentDidUpdate == "function" && (h.flags |= 4), typeof X.getSnapshotBeforeUpdate == "function" && (h.flags |= 1024)) : (typeof X.componentDidUpdate != "function" || Se === d.memoizedProps && kt === d.memoizedState || (h.flags |= 4), typeof X.getSnapshotBeforeUpdate != "function" || Se === d.memoizedProps && kt === d.memoizedState || (h.flags |= 1024), h.memoizedProps = x, h.memoizedState = dn), X.props = x, X.state = dn, X.context = Pe, x = nt) : (typeof X.componentDidUpdate != "function" || Se === d.memoizedProps && kt === d.memoizedState || (h.flags |= 4), typeof X.getSnapshotBeforeUpdate != "function" || Se === d.memoizedProps && kt === d.memoizedState || (h.flags |= 1024), x = !1);
    }
    return J0(d, h, S, x, U, F);
  }
  function J0(d, h, S, x, F, U) {
    er(d, h);
    var X = (h.flags & 128) !== 0;
    if (!x && !X)
      return F && V0(h, S, !1), Wi(d, h, U);
    x = h.stateNode, K0.current = h;
    var Se = X && typeof S.getDerivedStateFromError != "function" ? null : x.render();
    return h.flags |= 1, d !== null && X ? (h.child = uf(h, d.child, null, U), h.child = uf(h, null, Se, U)) : xi(d, h, Se, U), h.memoizedState = x.state, F && V0(h, S, !0), h.child;
  }
  function Nu(d) {
    var h = d.stateNode;
    h.pendingContext ? nf(d, h.pendingContext, h.pendingContext !== h.context) : h.context && nf(d, h.context, !1), Ng(d, h.containerInfo);
  }
  function Pp(d, h, S, x, F) {
    return fa(), Iu(F), h.flags |= 256, xi(d, h, S, x), h.child;
  }
  var Sc = { dehydrated: null, treeContext: null, retryLane: 0 };
  function bm(d) {
    return { baseLanes: d, cachePool: null, transitions: null };
  }
  function Lp(d, h, S) {
    var x = h.pendingProps, F = Dn.current, U = !1, X = (h.flags & 128) !== 0, Se;
    if ((Se = X) || (Se = d !== null && d.memoizedState === null ? !1 : (F & 2) !== 0), Se ? (U = !0, h.flags &= -129) : (d === null || d.memoizedState !== null) && (F |= 1), Vr(Dn, F & 1), d === null)
      return Fo(h), d = h.memoizedState, d !== null && (d = d.dehydrated, d !== null) ? (h.mode & 1 ? d.data === "$!" ? h.lanes = 8 : h.lanes = 1073741824 : h.lanes = 1, null) : (X = x.children, d = x.fallback, U ? (x = h.mode, U = h.child, X = { mode: "hidden", children: X }, !(x & 1) && U !== null ? (U.childLanes = 0, U.pendingProps = X) : U = Tm(X, x, 0, null), d = xd(d, x, S, null), U.return = h, d.return = h, U.sibling = d, h.child = U, h.child.memoizedState = bm(S), h.memoizedState = Sc, d) : yf(h, X));
    if (F = d.memoizedState, F !== null && (Se = F.dehydrated, Se !== null))
      return zg(d, h, X, x, Se, F, S);
    if (U) {
      U = x.fallback, X = h.mode, F = d.child, Se = F.sibling;
      var Pe = { mode: "hidden", children: x.children };
      return !(X & 1) && h.child !== F ? (x = h.child, x.childLanes = 0, x.pendingProps = Pe, h.deletions = null) : (x = Cf(F, Pe), x.subtreeFlags = F.subtreeFlags & 14680064), Se !== null ? U = Cf(Se, U) : (U = xd(U, X, S, null), U.flags |= 2), U.return = h, x.return = h, x.sibling = U, h.child = x, x = U, U = h.child, X = d.child.memoizedState, X = X === null ? bm(S) : { baseLanes: X.baseLanes | S, cachePool: null, transitions: X.transitions }, U.memoizedState = X, U.childLanes = d.childLanes & ~S, h.memoizedState = Sc, x;
    }
    return U = d.child, d = U.sibling, x = Cf(U, { mode: "visible", children: x.children }), !(h.mode & 1) && (x.lanes = S), x.return = h, x.sibling = null, d !== null && (S = h.deletions, S === null ? (h.deletions = [d], h.flags |= 16) : S.push(d)), h.child = x, h.memoizedState = null, x;
  }
  function yf(d, h) {
    return h = Tm({ mode: "visible", children: h }, d.mode, 0, null), h.return = d, d.child = h;
  }
  function Cn(d, h, S, x) {
    return x !== null && Iu(x), uf(h, d.child, null, S), d = yf(h, h.pendingProps.children), d.flags |= 2, h.memoizedState = null, d;
  }
  function zg(d, h, S, x, F, U, X) {
    if (S)
      return h.flags & 256 ? (h.flags &= -257, x = gf(Error(n(422))), Cn(d, h, X, x)) : h.memoizedState !== null ? (h.child = d.child, h.flags |= 128, null) : (U = x.fallback, F = h.mode, x = Tm({ mode: "visible", children: x.children }, F, 0, null), U = xd(U, F, X, null), U.flags |= 2, x.return = h, U.return = h, x.sibling = U, h.child = x, h.mode & 1 && uf(h, d.child, null, X), h.child.memoizedState = bm(X), h.memoizedState = Sc, U);
    if (!(h.mode & 1))
      return Cn(d, h, X, null);
    if (F.data === "$!") {
      if (x = F.nextSibling && F.nextSibling.dataset, x)
        var Se = x.dgst;
      return x = Se, U = Error(n(419)), x = gf(U, x, void 0), Cn(d, h, X, x);
    }
    if (Se = (X & d.childLanes) !== 0, Ka || Se) {
      if (x = Ha, x !== null) {
        switch (X & -X) {
          case 4:
            F = 2;
            break;
          case 16:
            F = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            F = 32;
            break;
          case 536870912:
            F = 268435456;
            break;
          default:
            F = 0;
        }
        F = F & (x.suspendedLanes | X) ? 0 : F, F !== 0 && F !== U.retryLane && (U.retryLane = F, Yl(d, F), xo(x, d, F, -1));
      }
      return ey(), x = gf(Error(n(421))), Cn(d, h, X, x);
    }
    return F.data === "$?" ? (h.flags |= 128, h.child = d.child, h = W1.bind(null, d), F._reactRetry = h, null) : (d = U.treeContext, ss = Gl(F.nextSibling), So = h, ga = !0, ml = null, d !== null && (os[Eo++] = zi, os[Eo++] = ku, os[Eo++] = hl, zi = d.id, ku = d.overflow, hl = h), h = yf(h, x.children), h.flags |= 4096, h);
  }
  function vm(d, h, S) {
    d.lanes |= h;
    var x = d.alternate;
    x !== null && (x.lanes |= h), da(d.return, h, S);
  }
  function Pu(d, h, S, x, F) {
    var U = d.memoizedState;
    U === null ? d.memoizedState = { isBackwards: h, rendering: null, renderingStartTime: 0, last: x, tail: S, tailMode: F } : (U.isBackwards = h, U.rendering = null, U.renderingStartTime = 0, U.last = x, U.tail = S, U.tailMode = F);
  }
  function Hv(d, h, S) {
    var x = h.pendingProps, F = x.revealOrder, U = x.tail;
    if (xi(d, h, x.children, S), x = Dn.current, x & 2)
      x = x & 1 | 2, h.flags |= 128;
    else {
      if (d !== null && d.flags & 128)
        e:
          for (d = h.child; d !== null; ) {
            if (d.tag === 13)
              d.memoizedState !== null && vm(d, S, h);
            else if (d.tag === 19)
              vm(d, S, h);
            else if (d.child !== null) {
              d.child.return = d, d = d.child;
              continue;
            }
            if (d === h)
              break e;
            for (; d.sibling === null; ) {
              if (d.return === null || d.return === h)
                break e;
              d = d.return;
            }
            d.sibling.return = d.return, d = d.sibling;
          }
      x &= 1;
    }
    if (Vr(Dn, x), !(h.mode & 1))
      h.memoizedState = null;
    else
      switch (F) {
        case "forwards":
          for (S = h.child, F = null; S !== null; )
            d = S.alternate, d !== null && Da(d) === null && (F = S), S = S.sibling;
          S = F, S === null ? (F = h.child, h.child = null) : (F = S.sibling, S.sibling = null), Pu(h, !1, F, S, U);
          break;
        case "backwards":
          for (S = null, F = h.child, h.child = null; F !== null; ) {
            if (d = F.alternate, d !== null && Da(d) === null) {
              h.child = F;
              break;
            }
            d = F.sibling, F.sibling = S, S = F, F = d;
          }
          Pu(h, !0, S, null, U);
          break;
        case "together":
          Pu(h, !1, null, null, void 0);
          break;
        default:
          h.memoizedState = null;
      }
    return h.child;
  }
  function Hi(d, h) {
    !(h.mode & 1) && d !== null && (d.alternate = null, h.alternate = null, h.flags |= 2);
  }
  function Wi(d, h, S) {
    if (d !== null && (h.dependencies = d.dependencies), Mu |= h.lanes, !(S & h.childLanes))
      return null;
    if (d !== null && h.child !== d.child)
      throw Error(n(153));
    if (h.child !== null) {
      for (d = h.child, S = Cf(d, d.pendingProps), h.child = S, S.return = h; d.sibling !== null; )
        d = d.sibling, S = S.sibling = Cf(d, d.pendingProps), S.return = h;
      S.sibling = null;
    }
    return h.child;
  }
  function La(d, h, S) {
    switch (h.tag) {
      case 3:
        Nu(h), fa();
        break;
      case 5:
        In(h);
        break;
      case 1:
        ka(h.type) && pl(h);
        break;
      case 4:
        Ng(h, h.stateNode.containerInfo);
        break;
      case 10:
        var x = h.type._context, F = h.memoizedProps.value;
        Vr(Ns, x._currentValue), x._currentValue = F;
        break;
      case 13:
        if (x = h.memoizedState, x !== null)
          return x.dehydrated !== null ? (Vr(Dn, Dn.current & 1), h.flags |= 128, null) : S & h.child.childLanes ? Lp(d, h, S) : (Vr(Dn, Dn.current & 1), d = Wi(d, h, S), d !== null ? d.sibling : null);
        Vr(Dn, Dn.current & 1);
        break;
      case 19:
        if (x = (S & h.childLanes) !== 0, d.flags & 128) {
          if (x)
            return Hv(d, h, S);
          h.flags |= 128;
        }
        if (F = h.memoizedState, F !== null && (F.rendering = null, F.tail = null, F.lastEffect = null), Vr(Dn, Dn.current), x)
          break;
        return null;
      case 22:
      case 23:
        return h.lanes = 0, vf(d, h, S);
    }
    return Wi(d, h, S);
  }
  var ym, Od, Ps, Ai;
  ym = function(d, h) {
    for (var S = h.child; S !== null; ) {
      if (S.tag === 5 || S.tag === 6)
        d.appendChild(S.stateNode);
      else if (S.tag !== 4 && S.child !== null) {
        S.child.return = S, S = S.child;
        continue;
      }
      if (S === h)
        break;
      for (; S.sibling === null; ) {
        if (S.return === null || S.return === h)
          return;
        S = S.return;
      }
      S.sibling.return = S.return, S = S.sibling;
    }
  }, Od = function() {
  }, Ps = function(d, h, S, x) {
    var F = d.memoizedProps;
    if (F !== x) {
      d = h.stateNode, ff(gl.current);
      var U = null;
      switch (S) {
        case "input":
          F = st(d, F), x = st(d, x), U = [];
          break;
        case "select":
          F = B({}, F, { value: void 0 }), x = B({}, x, { value: void 0 }), U = [];
          break;
        case "textarea":
          F = Yt(d, F), x = Yt(d, x), U = [];
          break;
        default:
          typeof F.onClick != "function" && typeof x.onClick == "function" && (d.onclick = wg);
      }
      Bt(S, x);
      var X;
      S = null;
      for (nt in F)
        if (!x.hasOwnProperty(nt) && F.hasOwnProperty(nt) && F[nt] != null)
          if (nt === "style") {
            var Se = F[nt];
            for (X in Se)
              Se.hasOwnProperty(X) && (S || (S = {}), S[X] = "");
          } else
            nt !== "dangerouslySetInnerHTML" && nt !== "children" && nt !== "suppressContentEditableWarning" && nt !== "suppressHydrationWarning" && nt !== "autoFocus" && (a.hasOwnProperty(nt) ? U || (U = []) : (U = U || []).push(nt, null));
      for (nt in x) {
        var Pe = x[nt];
        if (Se = F != null ? F[nt] : void 0, x.hasOwnProperty(nt) && Pe !== Se && (Pe != null || Se != null))
          if (nt === "style")
            if (Se) {
              for (X in Se)
                !Se.hasOwnProperty(X) || Pe && Pe.hasOwnProperty(X) || (S || (S = {}), S[X] = "");
              for (X in Pe)
                Pe.hasOwnProperty(X) && Se[X] !== Pe[X] && (S || (S = {}), S[X] = Pe[X]);
            } else
              S || (U || (U = []), U.push(
                nt,
                S
              )), S = Pe;
          else
            nt === "dangerouslySetInnerHTML" ? (Pe = Pe ? Pe.__html : void 0, Se = Se ? Se.__html : void 0, Pe != null && Se !== Pe && (U = U || []).push(nt, Pe)) : nt === "children" ? typeof Pe != "string" && typeof Pe != "number" || (U = U || []).push(nt, "" + Pe) : nt !== "suppressContentEditableWarning" && nt !== "suppressHydrationWarning" && (a.hasOwnProperty(nt) ? (Pe != null && nt === "onScroll" && ca("scroll", d), U || Se === Pe || (U = [])) : (U = U || []).push(nt, Pe));
      }
      S && (U = U || []).push("style", S);
      var nt = U;
      (h.updateQueue = nt) && (h.flags |= 4);
    }
  }, Ai = function(d, h, S, x) {
    S !== x && (h.flags |= 4);
  };
  function Mp(d, h) {
    if (!ga)
      switch (d.tailMode) {
        case "hidden":
          h = d.tail;
          for (var S = null; h !== null; )
            h.alternate !== null && (S = h), h = h.sibling;
          S === null ? d.tail = null : S.sibling = null;
          break;
        case "collapsed":
          S = d.tail;
          for (var x = null; S !== null; )
            S.alternate !== null && (x = S), S = S.sibling;
          x === null ? h || d.tail === null ? d.tail = null : d.tail.sibling = null : x.sibling = null;
      }
  }
  function To(d) {
    var h = d.alternate !== null && d.alternate.child === d.child, S = 0, x = 0;
    if (h)
      for (var F = d.child; F !== null; )
        S |= F.lanes | F.childLanes, x |= F.subtreeFlags & 14680064, x |= F.flags & 14680064, F.return = d, F = F.sibling;
    else
      for (F = d.child; F !== null; )
        S |= F.lanes | F.childLanes, x |= F.subtreeFlags, x |= F.flags, F.return = d, F = F.sibling;
    return d.subtreeFlags |= x, d.childLanes = S, h;
  }
  function $1(d, h, S) {
    var x = h.pendingProps;
    switch (dd(h), h.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return To(h), null;
      case 1:
        return ka(h.type) && dl(), To(h), null;
      case 3:
        return x = h.stateNode, df(), Wr(Xa), Wr(Wn), Pg(), x.pendingContext && (x.context = x.pendingContext, x.pendingContext = null), (d === null || d.child === null) && (nm(h) ? h.flags |= 4 : d === null || d.memoizedState.isDehydrated && !(h.flags & 256) || (h.flags |= 1024, ml !== null && (wm(ml), ml = null))), Od(d, h), To(h), null;
      case 5:
        cr(h);
        var F = ff(xp.current);
        if (S = h.type, d !== null && h.stateNode != null)
          Ps(d, h, S, x, F), d.ref !== h.ref && (h.flags |= 512, h.flags |= 2097152);
        else {
          if (!x) {
            if (h.stateNode === null)
              throw Error(n(166));
            return To(h), null;
          }
          if (d = ff(gl.current), nm(h)) {
            x = h.stateNode, S = h.type;
            var U = h.memoizedProps;
            switch (x[Cu] = h, x[xu] = U, d = (h.mode & 1) !== 0, S) {
              case "dialog":
                ca("cancel", x), ca("close", x);
                break;
              case "iframe":
              case "object":
              case "embed":
                ca("load", x);
                break;
              case "video":
              case "audio":
                for (F = 0; F < uc.length; F++)
                  ca(uc[F], x);
                break;
              case "source":
                ca("error", x);
                break;
              case "img":
              case "image":
              case "link":
                ca(
                  "error",
                  x
                ), ca("load", x);
                break;
              case "details":
                ca("toggle", x);
                break;
              case "input":
                Oe(x, U), ca("invalid", x);
                break;
              case "select":
                x._wrapperState = { wasMultiple: !!U.multiple }, ca("invalid", x);
                break;
              case "textarea":
                Rt(x, U), ca("invalid", x);
            }
            Bt(S, U), F = null;
            for (var X in U)
              if (U.hasOwnProperty(X)) {
                var Se = U[X];
                X === "children" ? typeof Se == "string" ? x.textContent !== Se && (U.suppressHydrationWarning !== !0 && qh(x.textContent, Se, d), F = ["children", Se]) : typeof Se == "number" && x.textContent !== "" + Se && (U.suppressHydrationWarning !== !0 && qh(
                  x.textContent,
                  Se,
                  d
                ), F = ["children", "" + Se]) : a.hasOwnProperty(X) && Se != null && X === "onScroll" && ca("scroll", x);
              }
            switch (S) {
              case "input":
                je(x), mt(x, U, !0);
                break;
              case "textarea":
                je(x), He(x);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof U.onClick == "function" && (x.onclick = wg);
            }
            x = F, h.updateQueue = x, x !== null && (h.flags |= 4);
          } else {
            X = F.nodeType === 9 ? F : F.ownerDocument, d === "http://www.w3.org/1999/xhtml" && (d = Ve(S)), d === "http://www.w3.org/1999/xhtml" ? S === "script" ? (d = X.createElement("div"), d.innerHTML = "<script><\/script>", d = d.removeChild(d.firstChild)) : typeof x.is == "string" ? d = X.createElement(S, { is: x.is }) : (d = X.createElement(S), S === "select" && (X = d, x.multiple ? X.multiple = !0 : x.size && (X.size = x.size))) : d = X.createElementNS(d, S), d[Cu] = h, d[xu] = x, ym(d, h, !1, !1), h.stateNode = d;
            e: {
              switch (X = Qt(S, x), S) {
                case "dialog":
                  ca("cancel", d), ca("close", d), F = x;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  ca("load", d), F = x;
                  break;
                case "video":
                case "audio":
                  for (F = 0; F < uc.length; F++)
                    ca(uc[F], d);
                  F = x;
                  break;
                case "source":
                  ca("error", d), F = x;
                  break;
                case "img":
                case "image":
                case "link":
                  ca(
                    "error",
                    d
                  ), ca("load", d), F = x;
                  break;
                case "details":
                  ca("toggle", d), F = x;
                  break;
                case "input":
                  Oe(d, x), F = st(d, x), ca("invalid", d);
                  break;
                case "option":
                  F = x;
                  break;
                case "select":
                  d._wrapperState = { wasMultiple: !!x.multiple }, F = B({}, x, { value: void 0 }), ca("invalid", d);
                  break;
                case "textarea":
                  Rt(d, x), F = Yt(d, x), ca("invalid", d);
                  break;
                default:
                  F = x;
              }
              Bt(S, F), Se = F;
              for (U in Se)
                if (Se.hasOwnProperty(U)) {
                  var Pe = Se[U];
                  U === "style" ? ze(d, Pe) : U === "dangerouslySetInnerHTML" ? (Pe = Pe ? Pe.__html : void 0, Pe != null && zt(d, Pe)) : U === "children" ? typeof Pe == "string" ? (S !== "textarea" || Pe !== "") && Ht(d, Pe) : typeof Pe == "number" && Ht(d, "" + Pe) : U !== "suppressContentEditableWarning" && U !== "suppressHydrationWarning" && U !== "autoFocus" && (a.hasOwnProperty(U) ? Pe != null && U === "onScroll" && ca("scroll", d) : Pe != null && P(d, U, Pe, X));
                }
              switch (S) {
                case "input":
                  je(d), mt(d, x, !1);
                  break;
                case "textarea":
                  je(d), He(d);
                  break;
                case "option":
                  x.value != null && d.setAttribute("value", "" + he(x.value));
                  break;
                case "select":
                  d.multiple = !!x.multiple, U = x.value, U != null ? wt(d, !!x.multiple, U, !1) : x.defaultValue != null && wt(
                    d,
                    !!x.multiple,
                    x.defaultValue,
                    !0
                  );
                  break;
                default:
                  typeof F.onClick == "function" && (d.onclick = wg);
              }
              switch (S) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  x = !!x.autoFocus;
                  break e;
                case "img":
                  x = !0;
                  break e;
                default:
                  x = !1;
              }
            }
            x && (h.flags |= 4);
          }
          h.ref !== null && (h.flags |= 512, h.flags |= 2097152);
        }
        return To(h), null;
      case 6:
        if (d && h.stateNode != null)
          Ai(d, h, d.memoizedProps, x);
        else {
          if (typeof x != "string" && h.stateNode === null)
            throw Error(n(166));
          if (S = ff(xp.current), ff(gl.current), nm(h)) {
            if (x = h.stateNode, S = h.memoizedProps, x[Cu] = h, (U = x.nodeValue !== S) && (d = So, d !== null))
              switch (d.tag) {
                case 3:
                  qh(x.nodeValue, S, (d.mode & 1) !== 0);
                  break;
                case 5:
                  d.memoizedProps.suppressHydrationWarning !== !0 && qh(x.nodeValue, S, (d.mode & 1) !== 0);
              }
            U && (h.flags |= 4);
          } else
            x = (S.nodeType === 9 ? S : S.ownerDocument).createTextNode(x), x[Cu] = h, h.stateNode = x;
        }
        return To(h), null;
      case 13:
        if (Wr(Dn), x = h.memoizedState, d === null || d.memoizedState !== null && d.memoizedState.dehydrated !== null) {
          if (ga && ss !== null && h.mode & 1 && !(h.flags & 128))
            Pv(), fa(), h.flags |= 98560, U = !1;
          else if (U = nm(h), x !== null && x.dehydrated !== null) {
            if (d === null) {
              if (!U)
                throw Error(n(318));
              if (U = h.memoizedState, U = U !== null ? U.dehydrated : null, !U)
                throw Error(n(317));
              U[Cu] = h;
            } else
              fa(), !(h.flags & 128) && (h.memoizedState = null), h.flags |= 4;
            To(h), U = !1;
          } else
            ml !== null && (wm(ml), ml = null), U = !0;
          if (!U)
            return h.flags & 65536 ? h : null;
        }
        return h.flags & 128 ? (h.lanes = S, h) : (x = x !== null, x !== (d !== null && d.memoizedState !== null) && x && (h.child.flags |= 8192, h.mode & 1 && (d === null || Dn.current & 1 ? ki === 0 && (ki = 3) : ey())), h.updateQueue !== null && (h.flags |= 4), To(h), null);
      case 4:
        return df(), Od(d, h), d === null && cc(h.stateNode.containerInfo), To(h), null;
      case 10:
        return pc(h.type._context), To(h), null;
      case 17:
        return ka(h.type) && dl(), To(h), null;
      case 19:
        if (Wr(Dn), U = h.memoizedState, U === null)
          return To(h), null;
        if (x = (h.flags & 128) !== 0, X = U.rendering, X === null)
          if (x)
            Mp(U, !1);
          else {
            if (ki !== 0 || d !== null && d.flags & 128)
              for (d = h.child; d !== null; ) {
                if (X = Da(d), X !== null) {
                  for (h.flags |= 128, Mp(U, !1), x = X.updateQueue, x !== null && (h.updateQueue = x, h.flags |= 4), h.subtreeFlags = 0, x = S, S = h.child; S !== null; )
                    U = S, d = x, U.flags &= 14680066, X = U.alternate, X === null ? (U.childLanes = 0, U.lanes = d, U.child = null, U.subtreeFlags = 0, U.memoizedProps = null, U.memoizedState = null, U.updateQueue = null, U.dependencies = null, U.stateNode = null) : (U.childLanes = X.childLanes, U.lanes = X.lanes, U.child = X.child, U.subtreeFlags = 0, U.deletions = null, U.memoizedProps = X.memoizedProps, U.memoizedState = X.memoizedState, U.updateQueue = X.updateQueue, U.type = X.type, d = X.dependencies, U.dependencies = d === null ? null : { lanes: d.lanes, firstContext: d.firstContext }), S = S.sibling;
                  return Vr(Dn, Dn.current & 1 | 2), h.child;
                }
                d = d.sibling;
              }
            U.tail !== null && Lt() > Wp && (h.flags |= 128, x = !0, Mp(U, !1), h.lanes = 4194304);
          }
        else {
          if (!x)
            if (d = Da(X), d !== null) {
              if (h.flags |= 128, x = !0, S = d.updateQueue, S !== null && (h.updateQueue = S, h.flags |= 4), Mp(U, !0), U.tail === null && U.tailMode === "hidden" && !X.alternate && !ga)
                return To(h), null;
            } else
              2 * Lt() - U.renderingStartTime > Wp && S !== 1073741824 && (h.flags |= 128, x = !0, Mp(U, !1), h.lanes = 4194304);
          U.isBackwards ? (X.sibling = h.child, h.child = X) : (S = U.last, S !== null ? S.sibling = X : h.child = X, U.last = X);
        }
        return U.tail !== null ? (h = U.tail, U.rendering = h, U.tail = h.sibling, U.renderingStartTime = Lt(), h.sibling = null, S = Dn.current, Vr(Dn, x ? S & 1 | 2 : S & 1), h) : (To(h), null);
      case 22:
      case 23:
        return Jv(), x = h.memoizedState !== null, d !== null && d.memoizedState !== null !== x && (h.flags |= 8192), x && h.mode & 1 ? $s & 1073741824 && (To(h), h.subtreeFlags & 6 && (h.flags |= 8192)) : To(h), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(n(156, h.tag));
  }
  function Wv(d, h) {
    switch (dd(h), h.tag) {
      case 1:
        return ka(h.type) && dl(), d = h.flags, d & 65536 ? (h.flags = d & -65537 | 128, h) : null;
      case 3:
        return df(), Wr(Xa), Wr(Wn), Pg(), d = h.flags, d & 65536 && !(d & 128) ? (h.flags = d & -65537 | 128, h) : null;
      case 5:
        return cr(h), null;
      case 13:
        if (Wr(Dn), d = h.memoizedState, d !== null && d.dehydrated !== null) {
          if (h.alternate === null)
            throw Error(n(340));
          fa();
        }
        return d = h.flags, d & 65536 ? (h.flags = d & -65537 | 128, h) : null;
      case 19:
        return Wr(Dn), null;
      case 4:
        return df(), null;
      case 10:
        return pc(h.type._context), null;
      case 22:
      case 23:
        return Jv(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var Ls = !1, kr = !1, Hg = typeof WeakSet == "function" ? WeakSet : Set, un = null;
  function Of(d, h) {
    var S = d.ref;
    if (S !== null)
      if (typeof S == "function")
        try {
          S(null);
        } catch (x) {
          ei(d, h, x);
        }
      else
        S.current = null;
  }
  function Om(d, h, S) {
    try {
      S();
    } catch (x) {
      ei(d, h, x);
    }
  }
  var eO = !1;
  function Fp(d, h) {
    if (Kh = nd, d = Gr(), Ql(d)) {
      if ("selectionStart" in d)
        var S = { start: d.selectionStart, end: d.selectionEnd };
      else
        e: {
          S = (S = d.ownerDocument) && S.defaultView || window;
          var x = S.getSelection && S.getSelection();
          if (x && x.rangeCount !== 0) {
            S = x.anchorNode;
            var F = x.anchorOffset, U = x.focusNode;
            x = x.focusOffset;
            try {
              S.nodeType, U.nodeType;
            } catch {
              S = null;
              break e;
            }
            var X = 0, Se = -1, Pe = -1, nt = 0, At = 0, It = d, kt = null;
            t:
              for (; ; ) {
                for (var en; It !== S || F !== 0 && It.nodeType !== 3 || (Se = X + F), It !== U || x !== 0 && It.nodeType !== 3 || (Pe = X + x), It.nodeType === 3 && (X += It.nodeValue.length), (en = It.firstChild) !== null; )
                  kt = It, It = en;
                for (; ; ) {
                  if (It === d)
                    break t;
                  if (kt === S && ++nt === F && (Se = X), kt === U && ++At === x && (Pe = X), (en = It.nextSibling) !== null)
                    break;
                  It = kt, kt = It.parentNode;
                }
                It = en;
              }
            S = Se === -1 || Pe === -1 ? null : { start: Se, end: Pe };
          } else
            S = null;
        }
      S = S || { start: 0, end: 0 };
    } else
      S = null;
    for (jl = { focusedElem: d, selectionRange: S }, nd = !1, un = h; un !== null; )
      if (h = un, d = h.child, (h.subtreeFlags & 1028) !== 0 && d !== null)
        d.return = h, un = d;
      else
        for (; un !== null; ) {
          h = un;
          try {
            var dn = h.alternate;
            if (h.flags & 1024)
              switch (h.tag) {
                case 0:
                case 11:
                case 15:
                  break;
                case 1:
                  if (dn !== null) {
                    var mn = dn.memoizedProps, ci = dn.memoizedState, Ze = h.stateNode, Me = Ze.getSnapshotBeforeUpdate(h.elementType === h.type ? mn : Ds(h.type, mn), ci);
                    Ze.__reactInternalSnapshotBeforeUpdate = Me;
                  }
                  break;
                case 3:
                  var Xe = h.stateNode.containerInfo;
                  Xe.nodeType === 1 ? Xe.textContent = "" : Xe.nodeType === 9 && Xe.documentElement && Xe.removeChild(Xe.documentElement);
                  break;
                case 5:
                case 6:
                case 4:
                case 17:
                  break;
                default:
                  throw Error(n(163));
              }
          } catch (Ft) {
            ei(h, h.return, Ft);
          }
          if (d = h.sibling, d !== null) {
            d.return = h.return, un = d;
            break;
          }
          un = h.return;
        }
    return dn = eO, eO = !1, dn;
  }
  function $p(d, h, S) {
    var x = h.updateQueue;
    if (x = x !== null ? x.lastEffect : null, x !== null) {
      var F = x = x.next;
      do {
        if ((F.tag & d) === d) {
          var U = F.destroy;
          F.destroy = void 0, U !== void 0 && Om(h, S, U);
        }
        F = F.next;
      } while (F !== x);
    }
  }
  function Bp(d, h) {
    if (h = h.updateQueue, h = h !== null ? h.lastEffect : null, h !== null) {
      var S = h = h.next;
      do {
        if ((S.tag & d) === d) {
          var x = S.create;
          S.destroy = x();
        }
        S = S.next;
      } while (S !== h);
    }
  }
  function Qv(d) {
    var h = d.ref;
    if (h !== null) {
      var S = d.stateNode;
      switch (d.tag) {
        case 5:
          d = S;
          break;
        default:
          d = S;
      }
      typeof h == "function" ? h(d) : h.current = d;
    }
  }
  function jv(d) {
    var h = d.alternate;
    h !== null && (d.alternate = null, jv(h)), d.child = null, d.deletions = null, d.sibling = null, d.tag === 5 && (h = d.stateNode, h !== null && (delete h[Cu], delete h[xu], delete h[Tg], delete h[re], delete h[ef])), d.stateNode = null, d.return = null, d.dependencies = null, d.memoizedProps = null, d.memoizedState = null, d.pendingProps = null, d.stateNode = null, d.updateQueue = null;
  }
  function tO(d) {
    return d.tag === 5 || d.tag === 3 || d.tag === 4;
  }
  function Wg(d) {
    e:
      for (; ; ) {
        for (; d.sibling === null; ) {
          if (d.return === null || tO(d.return))
            return null;
          d = d.return;
        }
        for (d.sibling.return = d.return, d = d.sibling; d.tag !== 5 && d.tag !== 6 && d.tag !== 18; ) {
          if (d.flags & 2 || d.child === null || d.tag === 4)
            continue e;
          d.child.return = d, d = d.child;
        }
        if (!(d.flags & 2))
          return d.stateNode;
      }
  }
  function Ed(d, h, S) {
    var x = d.tag;
    if (x === 5 || x === 6)
      d = d.stateNode, h ? S.nodeType === 8 ? S.parentNode.insertBefore(d, h) : S.insertBefore(d, h) : (S.nodeType === 8 ? (h = S.parentNode, h.insertBefore(d, S)) : (h = S, h.appendChild(d)), S = S._reactRootContainer, S != null || h.onclick !== null || (h.onclick = wg));
    else if (x !== 4 && (d = d.child, d !== null))
      for (Ed(d, h, S), d = d.sibling; d !== null; )
        Ed(d, h, S), d = d.sibling;
  }
  function Kl(d, h, S) {
    var x = d.tag;
    if (x === 5 || x === 6)
      d = d.stateNode, h ? S.insertBefore(d, h) : S.appendChild(d);
    else if (x !== 4 && (d = d.child, d !== null))
      for (Kl(d, h, S), d = d.sibling; d !== null; )
        Kl(d, h, S), d = d.sibling;
  }
  var Ma = null, bi = !1;
  function Ms(d, h, S) {
    for (S = S.child; S !== null; )
      Lu(d, h, S), S = S.sibling;
  }
  function Lu(d, h, S) {
    if (Aa && typeof Aa.onCommitFiberUnmount == "function")
      try {
        Aa.onCommitFiberUnmount(Li, S);
      } catch {
      }
    switch (S.tag) {
      case 5:
        kr || Of(S, h);
      case 6:
        var x = Ma, F = bi;
        Ma = null, Ms(d, h, S), Ma = x, bi = F, Ma !== null && (bi ? (d = Ma, S = S.stateNode, d.nodeType === 8 ? d.parentNode.removeChild(S) : d.removeChild(S)) : Ma.removeChild(S.stateNode));
        break;
      case 18:
        Ma !== null && (bi ? (d = Ma, S = S.stateNode, d.nodeType === 8 ? Kc(d.parentNode, S) : d.nodeType === 1 && Kc(d, S), jr(d)) : Kc(Ma, S.stateNode));
        break;
      case 4:
        x = Ma, F = bi, Ma = S.stateNode.containerInfo, bi = !0, Ms(d, h, S), Ma = x, bi = F;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!kr && (x = S.updateQueue, x !== null && (x = x.lastEffect, x !== null))) {
          F = x = x.next;
          do {
            var U = F, X = U.destroy;
            U = U.tag, X !== void 0 && (U & 2 || U & 4) && Om(S, h, X), F = F.next;
          } while (F !== x);
        }
        Ms(d, h, S);
        break;
      case 1:
        if (!kr && (Of(S, h), x = S.stateNode, typeof x.componentWillUnmount == "function"))
          try {
            x.props = S.memoizedProps, x.state = S.memoizedState, x.componentWillUnmount();
          } catch (Se) {
            ei(S, h, Se);
          }
        Ms(d, h, S);
        break;
      case 21:
        Ms(d, h, S);
        break;
      case 22:
        S.mode & 1 ? (kr = (x = kr) || S.memoizedState !== null, Ms(d, h, S), kr = x) : Ms(d, h, S);
        break;
      default:
        Ms(d, h, S);
    }
  }
  function Jl(d) {
    var h = d.updateQueue;
    if (h !== null) {
      d.updateQueue = null;
      var S = d.stateNode;
      S === null && (S = d.stateNode = new Hg()), h.forEach(function(x) {
        var F = Q1.bind(null, d, x);
        S.has(x) || (S.add(x), x.then(F, F));
      });
    }
  }
  function vl(d, h) {
    var S = h.deletions;
    if (S !== null)
      for (var x = 0; x < S.length; x++) {
        var F = S[x];
        try {
          var U = d, X = h, Se = X;
          e:
            for (; Se !== null; ) {
              switch (Se.tag) {
                case 5:
                  Ma = Se.stateNode, bi = !1;
                  break e;
                case 3:
                  Ma = Se.stateNode.containerInfo, bi = !0;
                  break e;
                case 4:
                  Ma = Se.stateNode.containerInfo, bi = !0;
                  break e;
              }
              Se = Se.return;
            }
          if (Ma === null)
            throw Error(n(160));
          Lu(U, X, F), Ma = null, bi = !1;
          var Pe = F.alternate;
          Pe !== null && (Pe.return = null), F.return = null;
        } catch (nt) {
          ei(F, h, nt);
        }
      }
    if (h.subtreeFlags & 12854)
      for (h = h.child; h !== null; )
        Gv(h, d), h = h.sibling;
  }
  function Gv(d, h) {
    var S = d.alternate, x = d.flags;
    switch (d.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if (vl(h, d), Fs(d), x & 4) {
          try {
            $p(3, d, d.return), Bp(3, d);
          } catch (mn) {
            ei(d, d.return, mn);
          }
          try {
            $p(5, d, d.return);
          } catch (mn) {
            ei(d, d.return, mn);
          }
        }
        break;
      case 1:
        vl(h, d), Fs(d), x & 512 && S !== null && Of(S, S.return);
        break;
      case 5:
        if (vl(h, d), Fs(d), x & 512 && S !== null && Of(S, S.return), d.flags & 32) {
          var F = d.stateNode;
          try {
            Ht(F, "");
          } catch (mn) {
            ei(d, d.return, mn);
          }
        }
        if (x & 4 && (F = d.stateNode, F != null)) {
          var U = d.memoizedProps, X = S !== null ? S.memoizedProps : U, Se = d.type, Pe = d.updateQueue;
          if (d.updateQueue = null, Pe !== null)
            try {
              Se === "input" && U.type === "radio" && U.name != null && Re(F, U), Qt(Se, X);
              var nt = Qt(Se, U);
              for (X = 0; X < Pe.length; X += 2) {
                var At = Pe[X], It = Pe[X + 1];
                At === "style" ? ze(F, It) : At === "dangerouslySetInnerHTML" ? zt(F, It) : At === "children" ? Ht(F, It) : P(F, At, It, nt);
              }
              switch (Se) {
                case "input":
                  Be(F, U);
                  break;
                case "textarea":
                  Ut(F, U);
                  break;
                case "select":
                  var kt = F._wrapperState.wasMultiple;
                  F._wrapperState.wasMultiple = !!U.multiple;
                  var en = U.value;
                  en != null ? wt(F, !!U.multiple, en, !1) : kt !== !!U.multiple && (U.defaultValue != null ? wt(
                    F,
                    !!U.multiple,
                    U.defaultValue,
                    !0
                  ) : wt(F, !!U.multiple, U.multiple ? [] : "", !1));
              }
              F[xu] = U;
            } catch (mn) {
              ei(d, d.return, mn);
            }
        }
        break;
      case 6:
        if (vl(h, d), Fs(d), x & 4) {
          if (d.stateNode === null)
            throw Error(n(162));
          F = d.stateNode, U = d.memoizedProps;
          try {
            F.nodeValue = U;
          } catch (mn) {
            ei(d, d.return, mn);
          }
        }
        break;
      case 3:
        if (vl(h, d), Fs(d), x & 4 && S !== null && S.memoizedState.isDehydrated)
          try {
            jr(h.containerInfo);
          } catch (mn) {
            ei(d, d.return, mn);
          }
        break;
      case 4:
        vl(h, d), Fs(d);
        break;
      case 13:
        vl(h, d), Fs(d), F = d.child, F.flags & 8192 && (U = F.memoizedState !== null, F.stateNode.isHidden = U, !U || F.alternate !== null && F.alternate.memoizedState !== null || (jg = Lt())), x & 4 && Jl(d);
        break;
      case 22:
        if (At = S !== null && S.memoizedState !== null, d.mode & 1 ? (kr = (nt = kr) || At, vl(h, d), kr = nt) : vl(h, d), Fs(d), x & 8192) {
          if (nt = d.memoizedState !== null, (d.stateNode.isHidden = nt) && !At && d.mode & 1)
            for (un = d, At = d.child; At !== null; ) {
              for (It = un = At; un !== null; ) {
                switch (kt = un, en = kt.child, kt.tag) {
                  case 0:
                  case 11:
                  case 14:
                  case 15:
                    $p(4, kt, kt.return);
                    break;
                  case 1:
                    Of(kt, kt.return);
                    var dn = kt.stateNode;
                    if (typeof dn.componentWillUnmount == "function") {
                      x = kt, S = kt.return;
                      try {
                        h = x, dn.props = h.memoizedProps, dn.state = h.memoizedState, dn.componentWillUnmount();
                      } catch (mn) {
                        ei(x, S, mn);
                      }
                    }
                    break;
                  case 5:
                    Of(kt, kt.return);
                    break;
                  case 22:
                    if (kt.memoizedState !== null) {
                      Yv(It);
                      continue;
                    }
                }
                en !== null ? (en.return = kt, un = en) : Yv(It);
              }
              At = At.sibling;
            }
          e:
            for (At = null, It = d; ; ) {
              if (It.tag === 5) {
                if (At === null) {
                  At = It;
                  try {
                    F = It.stateNode, nt ? (U = F.style, typeof U.setProperty == "function" ? U.setProperty("display", "none", "important") : U.display = "none") : (Se = It.stateNode, Pe = It.memoizedProps.style, X = Pe != null && Pe.hasOwnProperty("display") ? Pe.display : null, Se.style.display = ln("display", X));
                  } catch (mn) {
                    ei(d, d.return, mn);
                  }
                }
              } else if (It.tag === 6) {
                if (At === null)
                  try {
                    It.stateNode.nodeValue = nt ? "" : It.memoizedProps;
                  } catch (mn) {
                    ei(d, d.return, mn);
                  }
              } else if ((It.tag !== 22 && It.tag !== 23 || It.memoizedState === null || It === d) && It.child !== null) {
                It.child.return = It, It = It.child;
                continue;
              }
              if (It === d)
                break e;
              for (; It.sibling === null; ) {
                if (It.return === null || It.return === d)
                  break e;
                At === It && (At = null), It = It.return;
              }
              At === It && (At = null), It.sibling.return = It.return, It = It.sibling;
            }
        }
        break;
      case 19:
        vl(h, d), Fs(d), x & 4 && Jl(d);
        break;
      case 21:
        break;
      default:
        vl(
          h,
          d
        ), Fs(d);
    }
  }
  function Fs(d) {
    var h = d.flags;
    if (h & 2) {
      try {
        e: {
          for (var S = d.return; S !== null; ) {
            if (tO(S)) {
              var x = S;
              break e;
            }
            S = S.return;
          }
          throw Error(n(160));
        }
        switch (x.tag) {
          case 5:
            var F = x.stateNode;
            x.flags & 32 && (Ht(F, ""), x.flags &= -33);
            var U = Wg(d);
            Kl(d, U, F);
            break;
          case 3:
          case 4:
            var X = x.stateNode.containerInfo, Se = Wg(d);
            Ed(d, Se, X);
            break;
          default:
            throw Error(n(161));
        }
      } catch (Pe) {
        ei(d, d.return, Pe);
      }
      d.flags &= -3;
    }
    h & 4096 && (d.flags &= -4097);
  }
  function Vv(d, h, S) {
    un = d, Bo(d);
  }
  function Bo(d, h, S) {
    for (var x = (d.mode & 1) !== 0; un !== null; ) {
      var F = un, U = F.child;
      if (F.tag === 22 && x) {
        var X = F.memoizedState !== null || Ls;
        if (!X) {
          var Se = F.alternate, Pe = Se !== null && Se.memoizedState !== null || kr;
          Se = Ls;
          var nt = kr;
          if (Ls = X, (kr = Pe) && !nt)
            for (un = F; un !== null; )
              X = un, Pe = X.child, X.tag === 22 && X.memoizedState !== null ? Zv(F) : Pe !== null ? (Pe.return = X, un = Pe) : Zv(F);
          for (; U !== null; )
            un = U, Bo(U), U = U.sibling;
          un = F, Ls = Se, kr = nt;
        }
        Ef(d);
      } else
        F.subtreeFlags & 8772 && U !== null ? (U.return = F, un = U) : Ef(d);
    }
  }
  function Ef(d) {
    for (; un !== null; ) {
      var h = un;
      if (h.flags & 8772) {
        var S = h.alternate;
        try {
          if (h.flags & 8772)
            switch (h.tag) {
              case 0:
              case 11:
              case 15:
                kr || Bp(5, h);
                break;
              case 1:
                var x = h.stateNode;
                if (h.flags & 4 && !kr)
                  if (S === null)
                    x.componentDidMount();
                  else {
                    var F = h.elementType === h.type ? S.memoizedProps : Ds(h.type, S.memoizedProps);
                    x.componentDidUpdate(F, S.memoizedState, x.__reactInternalSnapshotBeforeUpdate);
                  }
                var U = h.updateQueue;
                U !== null && pd(h, U, x);
                break;
              case 3:
                var X = h.updateQueue;
                if (X !== null) {
                  if (S = null, h.child !== null)
                    switch (h.child.tag) {
                      case 5:
                        S = h.child.stateNode;
                        break;
                      case 1:
                        S = h.child.stateNode;
                    }
                  pd(h, X, S);
                }
                break;
              case 5:
                var Se = h.stateNode;
                if (S === null && h.flags & 4) {
                  S = Se;
                  var Pe = h.memoizedProps;
                  switch (h.type) {
                    case "button":
                    case "input":
                    case "select":
                    case "textarea":
                      Pe.autoFocus && S.focus();
                      break;
                    case "img":
                      Pe.src && (S.src = Pe.src);
                  }
                }
                break;
              case 6:
                break;
              case 4:
                break;
              case 12:
                break;
              case 13:
                if (h.memoizedState === null) {
                  var nt = h.alternate;
                  if (nt !== null) {
                    var At = nt.memoizedState;
                    if (At !== null) {
                      var It = At.dehydrated;
                      It !== null && jr(It);
                    }
                  }
                }
                break;
              case 19:
              case 17:
              case 21:
              case 22:
              case 23:
              case 25:
                break;
              default:
                throw Error(n(163));
            }
          kr || h.flags & 512 && Qv(h);
        } catch (kt) {
          ei(h, h.return, kt);
        }
      }
      if (h === d) {
        un = null;
        break;
      }
      if (S = h.sibling, S !== null) {
        S.return = h.return, un = S;
        break;
      }
      un = h.return;
    }
  }
  function Yv(d) {
    for (; un !== null; ) {
      var h = un;
      if (h === d) {
        un = null;
        break;
      }
      var S = h.sibling;
      if (S !== null) {
        S.return = h.return, un = S;
        break;
      }
      un = h.return;
    }
  }
  function Zv(d) {
    for (; un !== null; ) {
      var h = un;
      try {
        switch (h.tag) {
          case 0:
          case 11:
          case 15:
            var S = h.return;
            try {
              Bp(4, h);
            } catch (Pe) {
              ei(h, S, Pe);
            }
            break;
          case 1:
            var x = h.stateNode;
            if (typeof x.componentDidMount == "function") {
              var F = h.return;
              try {
                x.componentDidMount();
              } catch (Pe) {
                ei(h, F, Pe);
              }
            }
            var U = h.return;
            try {
              Qv(h);
            } catch (Pe) {
              ei(h, U, Pe);
            }
            break;
          case 5:
            var X = h.return;
            try {
              Qv(h);
            } catch (Pe) {
              ei(h, X, Pe);
            }
        }
      } catch (Pe) {
        ei(h, h.return, Pe);
      }
      if (h === d) {
        un = null;
        break;
      }
      var Se = h.sibling;
      if (Se !== null) {
        Se.return = h.return, un = Se;
        break;
      }
      un = h.return;
    }
  }
  var Qg = Math.ceil, Em = I.ReactCurrentDispatcher, Xv = I.ReactCurrentOwner, _o = I.ReactCurrentBatchConfig, mr = 0, Ha = null, Ja = null, Qi = 0, $s = 0, Up = Un(0), ki = 0, zp = null, Mu = 0, Sm = 0, Hp = 0, Sd = null, Uo = null, jg = 0, Wp = 1 / 0, wc = null, Gg = !1, wd = null, Fu = null, Sf = !1, Ri = null, Vg = 0, Qp = 0, Yg = null, wf = -1, Td = 0;
  function Co() {
    return mr & 6 ? Lt() : wf !== -1 ? wf : wf = Lt();
  }
  function yi(d) {
    return d.mode & 1 ? mr & 2 && Qi !== 0 ? Qi & -Qi : rm.transition !== null ? (Td === 0 && (Td = Ts()), Td) : (d = hr, d !== 0 || (d = window.event, d = d === void 0 ? 16 : gv(d.type)), d) : 1;
  }
  function xo(d, h, S, x) {
    if (50 < Qp)
      throw Qp = 0, Yg = null, Error(n(185));
    si(d, S, x), (!(mr & 2) || d !== Ha) && (d === Ha && (!(mr & 2) && (Sm |= S), ki === 4 && yl(d, Qi)), ji(d, x), S === 1 && mr === 0 && !(h.mode & 1) && (Wp = Lt() + 500, Ui && is()));
  }
  function ji(d, h) {
    var S = d.callbackNode;
    _r(d, h);
    var x = mo(d, d === Ha ? Qi : 0);
    if (x === 0)
      S !== null && Ye(S), d.callbackNode = null, d.callbackPriority = 0;
    else if (h = x & -x, d.callbackPriority !== h) {
      if (S != null && Ye(S), h === 1)
        d.tag === 0 ? fc(nO.bind(null, d)) : Dv(nO.bind(null, d)), Op(function() {
          !(mr & 6) && is();
        }), S = null;
      else {
        switch (_s(x)) {
          case 1:
            S = Nn;
            break;
          case 4:
            S = fn;
            break;
          case 16:
            S = Or;
            break;
          case 536870912:
            S = pr;
            break;
          default:
            S = Or;
        }
        S = ry(S, jp.bind(null, d));
      }
      d.callbackPriority = h, d.callbackNode = S;
    }
  }
  function jp(d, h) {
    if (wf = -1, Td = 0, mr & 6)
      throw Error(n(327));
    var S = d.callbackNode;
    if (_f() && d.callbackNode !== S)
      return null;
    var x = mo(d, d === Ha ? Qi : 0);
    if (x === 0)
      return null;
    if (x & 30 || x & d.expiredLanes || h)
      h = Xg(d, x);
    else {
      h = x;
      var F = mr;
      mr |= 2;
      var U = Zg();
      (Ha !== d || Qi !== h) && (wc = null, Wp = Lt() + 500, _d(d, h));
      do
        try {
          U1();
          break;
        } catch (Se) {
          rO(d, Se);
        }
      while (1);
      am(), Em.current = U, mr = F, Ja !== null ? h = 0 : (Ha = null, Qi = 0, h = ki);
    }
    if (h !== 0) {
      if (h === 2 && (F = Qc(d), F !== 0 && (x = F, h = qv(d, F))), h === 1)
        throw S = zp, _d(d, 0), yl(d, x), ji(d, Lt()), S;
      if (h === 6)
        yl(d, x);
      else {
        if (F = d.current.alternate, !(x & 30) && !Kv(F) && (h = Xg(d, x), h === 2 && (U = Qc(d), U !== 0 && (x = U, h = qv(d, U))), h === 1))
          throw S = zp, _d(d, 0), yl(d, x), ji(d, Lt()), S;
        switch (d.finishedWork = F, d.finishedLanes = x, h) {
          case 0:
          case 1:
            throw Error(n(345));
          case 2:
            Cd(d, Uo, wc);
            break;
          case 3:
            if (yl(d, x), (x & 130023424) === x && (h = jg + 500 - Lt(), 10 < h)) {
              if (mo(d, 0) !== 0)
                break;
              if (F = d.suspendedLanes, (F & x) !== x) {
                Co(), d.pingedLanes |= d.suspendedLanes & F;
                break;
              }
              d.timeoutHandle = cl(Cd.bind(null, d, Uo, wc), h);
              break;
            }
            Cd(d, Uo, wc);
            break;
          case 4:
            if (yl(d, x), (x & 4194240) === x)
              break;
            for (h = d.eventTimes, F = -1; 0 < x; ) {
              var X = 31 - Mr(x);
              U = 1 << X, X = h[X], X > F && (F = X), x &= ~U;
            }
            if (x = F, x = Lt() - x, x = (120 > x ? 120 : 480 > x ? 480 : 1080 > x ? 1080 : 1920 > x ? 1920 : 3e3 > x ? 3e3 : 4320 > x ? 4320 : 1960 * Qg(x / 1960)) - x, 10 < x) {
              d.timeoutHandle = cl(Cd.bind(null, d, Uo, wc), x);
              break;
            }
            Cd(d, Uo, wc);
            break;
          case 5:
            Cd(d, Uo, wc);
            break;
          default:
            throw Error(n(329));
        }
      }
    }
    return ji(d, Lt()), d.callbackNode === S ? jp.bind(null, d) : null;
  }
  function qv(d, h) {
    var S = Sd;
    return d.current.memoizedState.isDehydrated && (_d(d, h).flags |= 256), d = Xg(d, h), d !== 2 && (h = Uo, Uo = S, h !== null && wm(h)), d;
  }
  function wm(d) {
    Uo === null ? Uo = d : Uo.push.apply(Uo, d);
  }
  function Kv(d) {
    for (var h = d; ; ) {
      if (h.flags & 16384) {
        var S = h.updateQueue;
        if (S !== null && (S = S.stores, S !== null))
          for (var x = 0; x < S.length; x++) {
            var F = S[x], U = F.getSnapshot;
            F = F.value;
            try {
              if (!et(U(), F))
                return !1;
            } catch {
              return !1;
            }
          }
      }
      if (S = h.child, h.subtreeFlags & 16384 && S !== null)
        S.return = h, h = S;
      else {
        if (h === d)
          break;
        for (; h.sibling === null; ) {
          if (h.return === null || h.return === d)
            return !0;
          h = h.return;
        }
        h.sibling.return = h.return, h = h.sibling;
      }
    }
    return !0;
  }
  function yl(d, h) {
    for (h &= ~Hp, h &= ~Sm, d.suspendedLanes |= h, d.pingedLanes &= ~h, d = d.expirationTimes; 0 < h; ) {
      var S = 31 - Mr(h), x = 1 << S;
      d[S] = -1, h &= ~x;
    }
  }
  function nO(d) {
    if (mr & 6)
      throw Error(n(327));
    _f();
    var h = mo(d, 0);
    if (!(h & 1))
      return ji(d, Lt()), null;
    var S = Xg(d, h);
    if (d.tag !== 0 && S === 2) {
      var x = Qc(d);
      x !== 0 && (h = x, S = qv(d, x));
    }
    if (S === 1)
      throw S = zp, _d(d, 0), yl(d, h), ji(d, Lt()), S;
    if (S === 6)
      throw Error(n(345));
    return d.finishedWork = d.current.alternate, d.finishedLanes = h, Cd(d, Uo, wc), ji(d, Lt()), null;
  }
  function Gp(d, h) {
    var S = mr;
    mr |= 1;
    try {
      return d(h);
    } finally {
      mr = S, mr === 0 && (Wp = Lt() + 500, Ui && is());
    }
  }
  function Tf(d) {
    Ri !== null && Ri.tag === 0 && !(mr & 6) && _f();
    var h = mr;
    mr |= 1;
    var S = _o.transition, x = hr;
    try {
      if (_o.transition = null, hr = 1, d)
        return d();
    } finally {
      hr = x, _o.transition = S, mr = h, !(mr & 6) && is();
    }
  }
  function Jv() {
    $s = Up.current, Wr(Up);
  }
  function _d(d, h) {
    d.finishedWork = null, d.finishedLanes = 0;
    var S = d.timeoutHandle;
    if (S !== -1 && (d.timeoutHandle = -1, yp(S)), Ja !== null)
      for (S = Ja.return; S !== null; ) {
        var x = S;
        switch (dd(x), x.tag) {
          case 1:
            x = x.type.childContextTypes, x != null && dl();
            break;
          case 3:
            df(), Wr(Xa), Wr(Wn), Pg();
            break;
          case 5:
            cr(x);
            break;
          case 4:
            df();
            break;
          case 13:
            Wr(Dn);
            break;
          case 19:
            Wr(Dn);
            break;
          case 10:
            pc(x.type._context);
            break;
          case 22:
          case 23:
            Jv();
        }
        S = S.return;
      }
    if (Ha = d, Ja = d = Cf(d.current, null), Qi = $s = h, ki = 0, zp = null, Hp = Sm = Mu = 0, Uo = Sd = null, za !== null) {
      for (h = 0; h < za.length; h++)
        if (S = za[h], x = S.interleaved, x !== null) {
          S.interleaved = null;
          var F = x.next, U = S.pending;
          if (U !== null) {
            var X = U.next;
            U.next = F, x.next = X;
          }
          S.pending = x;
        }
      za = null;
    }
    return d;
  }
  function rO(d, h) {
    do {
      var S = Ja;
      try {
        if (am(), Ap.current = Oc, Fn) {
          for (var x = Ca.memoizedState; x !== null; ) {
            var F = x.queue;
            F !== null && (F.pending = null), x = x.next;
          }
          Fn = !1;
        }
        if (hd = 0, vr = ct = Ca = null, Du = !1, Na = 0, Xv.current = null, S === null || S.return === null) {
          ki = 1, zp = h, Ja = null;
          break;
        }
        e: {
          var U = d, X = S.return, Se = S, Pe = h;
          if (h = Qi, Se.flags |= 32768, Pe !== null && typeof Pe == "object" && typeof Pe.then == "function") {
            var nt = Pe, At = Se, It = At.tag;
            if (!(At.mode & 1) && (It === 0 || It === 11 || It === 15)) {
              var kt = At.alternate;
              kt ? (At.updateQueue = kt.updateQueue, At.memoizedState = kt.memoizedState, At.lanes = kt.lanes) : (At.updateQueue = null, At.memoizedState = null);
            }
            var en = Ug(X);
            if (en !== null) {
              en.flags &= -257, Np(en, X, Se, U, h), en.mode & 1 && q0(U, nt, h), h = en, Pe = nt;
              var dn = h.updateQueue;
              if (dn === null) {
                var mn = /* @__PURE__ */ new Set();
                mn.add(Pe), h.updateQueue = mn;
              } else
                dn.add(Pe);
              break e;
            } else {
              if (!(h & 1)) {
                q0(U, nt, h), ey();
                break e;
              }
              Pe = Error(n(426));
            }
          } else if (ga && Se.mode & 1) {
            var ci = Ug(X);
            if (ci !== null) {
              !(ci.flags & 65536) && (ci.flags |= 256), Np(ci, X, Se, U, h), Iu(vd(Pe, Se));
              break e;
            }
          }
          U = Pe = vd(Pe, Se), ki !== 4 && (ki = 2), Sd === null ? Sd = [U] : Sd.push(U), U = X;
          do {
            switch (U.tag) {
              case 3:
                U.flags |= 65536, h &= -h, U.lanes |= h;
                var Ze = Bg(U, Pe, h);
                Ag(U, Ze);
                break e;
              case 1:
                Se = Pe;
                var Me = U.type, Xe = U.stateNode;
                if (!(U.flags & 128) && (typeof Me.getDerivedStateFromError == "function" || Xe !== null && typeof Xe.componentDidCatch == "function" && (Fu === null || !Fu.has(Xe)))) {
                  U.flags |= 65536, h &= -h, U.lanes |= h;
                  var Ft = bf(U, Se, h);
                  Ag(U, Ft);
                  break e;
                }
            }
            U = U.return;
          } while (U !== null);
        }
        ty(S);
      } catch (yn) {
        h = yn, Ja === S && S !== null && (Ja = S = S.return);
        continue;
      }
      break;
    } while (1);
  }
  function Zg() {
    var d = Em.current;
    return Em.current = Oc, d === null ? Oc : d;
  }
  function ey() {
    (ki === 0 || ki === 3 || ki === 2) && (ki = 4), Ha === null || !(Mu & 268435455) && !(Sm & 268435455) || yl(Ha, Qi);
  }
  function Xg(d, h) {
    var S = mr;
    mr |= 2;
    var x = Zg();
    (Ha !== d || Qi !== h) && (wc = null, _d(d, h));
    do
      try {
        B1();
        break;
      } catch (F) {
        rO(d, F);
      }
    while (1);
    if (am(), mr = S, Em.current = x, Ja !== null)
      throw Error(n(261));
    return Ha = null, Qi = 0, ki;
  }
  function B1() {
    for (; Ja !== null; )
      aO(Ja);
  }
  function U1() {
    for (; Ja !== null && !yt(); )
      aO(Ja);
  }
  function aO(d) {
    var h = iO(d.alternate, d, $s);
    d.memoizedProps = d.pendingProps, h === null ? ty(d) : Ja = h, Xv.current = null;
  }
  function ty(d) {
    var h = d;
    do {
      var S = h.alternate;
      if (d = h.return, h.flags & 32768) {
        if (S = Wv(S, h), S !== null) {
          S.flags &= 32767, Ja = S;
          return;
        }
        if (d !== null)
          d.flags |= 32768, d.subtreeFlags = 0, d.deletions = null;
        else {
          ki = 6, Ja = null;
          return;
        }
      } else if (S = $1(S, h, $s), S !== null) {
        Ja = S;
        return;
      }
      if (h = h.sibling, h !== null) {
        Ja = h;
        return;
      }
      Ja = h = d;
    } while (h !== null);
    ki === 0 && (ki = 5);
  }
  function Cd(d, h, S) {
    var x = hr, F = _o.transition;
    try {
      _o.transition = null, hr = 1, z1(d, h, S, x);
    } finally {
      _o.transition = F, hr = x;
    }
    return null;
  }
  function z1(d, h, S, x) {
    do
      _f();
    while (Ri !== null);
    if (mr & 6)
      throw Error(n(327));
    S = d.finishedWork;
    var F = d.finishedLanes;
    if (S === null)
      return null;
    if (d.finishedWork = null, d.finishedLanes = 0, S === d.current)
      throw Error(n(177));
    d.callbackNode = null, d.callbackPriority = 0;
    var U = S.lanes | S.childLanes;
    if (ol(d, U), d === Ha && (Ja = Ha = null, Qi = 0), !(S.subtreeFlags & 2064) && !(S.flags & 2064) || Sf || (Sf = !0, ry(Or, function() {
      return _f(), null;
    })), U = (S.flags & 15990) !== 0, S.subtreeFlags & 15990 || U) {
      U = _o.transition, _o.transition = null;
      var X = hr;
      hr = 1;
      var Se = mr;
      mr |= 4, Xv.current = null, Fp(d, S), Gv(S, d), bg(jl), nd = !!Kh, jl = Kh = null, d.current = S, Vv(S), Dt(), mr = Se, hr = X, _o.transition = U;
    } else
      d.current = S;
    if (Sf && (Sf = !1, Ri = d, Vg = F), U = d.pendingLanes, U === 0 && (Fu = null), ua(S.stateNode), ji(d, Lt()), h !== null)
      for (x = d.onRecoverableError, S = 0; S < h.length; S++)
        F = h[S], x(F.value, { componentStack: F.stack, digest: F.digest });
    if (Gg)
      throw Gg = !1, d = wd, wd = null, d;
    return Vg & 1 && d.tag !== 0 && _f(), U = d.pendingLanes, U & 1 ? d === Yg ? Qp++ : (Qp = 0, Yg = d) : Qp = 0, is(), null;
  }
  function _f() {
    if (Ri !== null) {
      var d = _s(Vg), h = _o.transition, S = hr;
      try {
        if (_o.transition = null, hr = 16 > d ? 16 : d, Ri === null)
          var x = !1;
        else {
          if (d = Ri, Ri = null, Vg = 0, mr & 6)
            throw Error(n(331));
          var F = mr;
          for (mr |= 4, un = d.current; un !== null; ) {
            var U = un, X = U.child;
            if (un.flags & 16) {
              var Se = U.deletions;
              if (Se !== null) {
                for (var Pe = 0; Pe < Se.length; Pe++) {
                  var nt = Se[Pe];
                  for (un = nt; un !== null; ) {
                    var At = un;
                    switch (At.tag) {
                      case 0:
                      case 11:
                      case 15:
                        $p(8, At, U);
                    }
                    var It = At.child;
                    if (It !== null)
                      It.return = At, un = It;
                    else
                      for (; un !== null; ) {
                        At = un;
                        var kt = At.sibling, en = At.return;
                        if (jv(At), At === nt) {
                          un = null;
                          break;
                        }
                        if (kt !== null) {
                          kt.return = en, un = kt;
                          break;
                        }
                        un = en;
                      }
                  }
                }
                var dn = U.alternate;
                if (dn !== null) {
                  var mn = dn.child;
                  if (mn !== null) {
                    dn.child = null;
                    do {
                      var ci = mn.sibling;
                      mn.sibling = null, mn = ci;
                    } while (mn !== null);
                  }
                }
                un = U;
              }
            }
            if (U.subtreeFlags & 2064 && X !== null)
              X.return = U, un = X;
            else
              e:
                for (; un !== null; ) {
                  if (U = un, U.flags & 2048)
                    switch (U.tag) {
                      case 0:
                      case 11:
                      case 15:
                        $p(9, U, U.return);
                    }
                  var Ze = U.sibling;
                  if (Ze !== null) {
                    Ze.return = U.return, un = Ze;
                    break e;
                  }
                  un = U.return;
                }
          }
          var Me = d.current;
          for (un = Me; un !== null; ) {
            X = un;
            var Xe = X.child;
            if (X.subtreeFlags & 2064 && Xe !== null)
              Xe.return = X, un = Xe;
            else
              e:
                for (X = Me; un !== null; ) {
                  if (Se = un, Se.flags & 2048)
                    try {
                      switch (Se.tag) {
                        case 0:
                        case 11:
                        case 15:
                          Bp(9, Se);
                      }
                    } catch (yn) {
                      ei(Se, Se.return, yn);
                    }
                  if (Se === X) {
                    un = null;
                    break e;
                  }
                  var Ft = Se.sibling;
                  if (Ft !== null) {
                    Ft.return = Se.return, un = Ft;
                    break e;
                  }
                  un = Se.return;
                }
          }
          if (mr = F, is(), Aa && typeof Aa.onPostCommitFiberRoot == "function")
            try {
              Aa.onPostCommitFiberRoot(Li, d);
            } catch {
            }
          x = !0;
        }
        return x;
      } finally {
        hr = S, _o.transition = h;
      }
    }
    return !1;
  }
  function ny(d, h, S) {
    h = vd(S, h), h = Bg(d, h, 1), d = of(d, h, 1), h = Co(), d !== null && (si(d, 1, h), ji(d, h));
  }
  function ei(d, h, S) {
    if (d.tag === 3)
      ny(d, d, S);
    else
      for (; h !== null; ) {
        if (h.tag === 3) {
          ny(h, d, S);
          break;
        } else if (h.tag === 1) {
          var x = h.stateNode;
          if (typeof h.type.getDerivedStateFromError == "function" || typeof x.componentDidCatch == "function" && (Fu === null || !Fu.has(x))) {
            d = vd(S, d), d = bf(h, d, 1), h = of(h, d, 1), d = Co(), h !== null && (si(h, 1, d), ji(h, d));
            break;
          }
        }
        h = h.return;
      }
  }
  function H1(d, h, S) {
    var x = d.pingCache;
    x !== null && x.delete(h), h = Co(), d.pingedLanes |= d.suspendedLanes & S, Ha === d && (Qi & S) === S && (ki === 4 || ki === 3 && (Qi & 130023424) === Qi && 500 > Lt() - jg ? _d(d, 0) : Hp |= S), ji(d, h);
  }
  function qg(d, h) {
    h === 0 && (d.mode & 1 ? (h = ac, ac <<= 1, !(ac & 130023424) && (ac = 4194304)) : h = 1);
    var S = Co();
    d = Yl(d, h), d !== null && (si(d, h, S), ji(d, S));
  }
  function W1(d) {
    var h = d.memoizedState, S = 0;
    h !== null && (S = h.retryLane), qg(d, S);
  }
  function Q1(d, h) {
    var S = 0;
    switch (d.tag) {
      case 13:
        var x = d.stateNode, F = d.memoizedState;
        F !== null && (S = F.retryLane);
        break;
      case 19:
        x = d.stateNode;
        break;
      default:
        throw Error(n(314));
    }
    x !== null && x.delete(h), qg(d, S);
  }
  var iO;
  iO = function(d, h, S) {
    if (d !== null)
      if (d.memoizedProps !== h.pendingProps || Xa.current)
        Ka = !0;
      else {
        if (!(d.lanes & S) && !(h.flags & 128))
          return Ka = !1, La(d, h, S);
        Ka = !!(d.flags & 131072);
      }
    else
      Ka = !1, ga && h.flags & 1048576 && Nv(h, Sp, h.index);
    switch (h.lanes = 0, h.tag) {
      case 2:
        var x = h.type;
        Hi(d, h), d = h.pendingProps;
        var F = fl(h, Wn.current);
        Gt(h, S), F = mc(null, h, x, d, F, S);
        var U = pf();
        return h.flags |= 1, typeof F == "object" && F !== null && typeof F.render == "function" && F.$$typeof === void 0 ? (h.tag = 1, h.memoizedState = null, h.updateQueue = null, ka(x) ? (U = !0, pl(h)) : U = !1, h.memoizedState = F.state !== null && F.state !== void 0 ? F.state : null, Lv(h), F.updater = kg, h.stateNode = F, F._reactInternals = h, Ig(h, x, d, S), h = J0(null, h, x, !0, U, S)) : (h.tag = 0, ga && U && wp(h), xi(null, h, F, S), h = h.child), h;
      case 16:
        x = h.elementType;
        e: {
          switch (Hi(d, h), d = h.pendingProps, F = x._init, x = F(x._payload), h.type = x, F = h.tag = Kg(x), d = Ds(x, d), F) {
            case 0:
              h = yd(null, h, x, d, S);
              break e;
            case 1:
              h = zv(null, h, x, d, S);
              break e;
            case 11:
              h = Ec(null, h, x, d, S);
              break e;
            case 14:
              h = bl(null, h, x, Ds(x.type, d), S);
              break e;
          }
          throw Error(n(
            306,
            x,
            ""
          ));
        }
        return h;
      case 0:
        return x = h.type, F = h.pendingProps, F = h.elementType === x ? F : Ds(x, F), yd(d, h, x, F, S);
      case 1:
        return x = h.type, F = h.pendingProps, F = h.elementType === x ? F : Ds(x, F), zv(d, h, x, F, S);
      case 3:
        e: {
          if (Nu(h), d === null)
            throw Error(n(387));
          x = h.pendingProps, U = h.memoizedState, F = U.element, _i(d, h), lf(h, x, null, S);
          var X = h.memoizedState;
          if (x = X.element, U.isDehydrated)
            if (U = { element: x, isDehydrated: !1, cache: X.cache, pendingSuspenseBoundaries: X.pendingSuspenseBoundaries, transitions: X.transitions }, h.updateQueue.baseState = U, h.memoizedState = U, h.flags & 256) {
              F = vd(Error(n(423)), h), h = Pp(d, h, x, S, F);
              break e;
            } else if (x !== F) {
              F = vd(Error(n(424)), h), h = Pp(d, h, x, S, F);
              break e;
            } else
              for (ss = Gl(h.stateNode.containerInfo.firstChild), So = h, ga = !0, ml = null, S = $v(h, null, x, S), h.child = S; S; )
                S.flags = S.flags & -3 | 4096, S = S.sibling;
          else {
            if (fa(), x === F) {
              h = Wi(d, h, S);
              break e;
            }
            xi(d, h, x, S);
          }
          h = h.child;
        }
        return h;
      case 5:
        return In(h), d === null && Fo(h), x = h.type, F = h.pendingProps, U = d !== null ? d.memoizedProps : null, X = F.children, ud(x, F) ? X = null : U !== null && ud(x, U) && (h.flags |= 32), er(d, h), xi(d, h, X, S), h.child;
      case 6:
        return d === null && Fo(h), null;
      case 13:
        return Lp(d, h, S);
      case 4:
        return Ng(h, h.stateNode.containerInfo), x = h.pendingProps, d === null ? h.child = uf(h, null, x, S) : xi(d, h, x, S), h.child;
      case 11:
        return x = h.type, F = h.pendingProps, F = h.elementType === x ? F : Ds(x, F), Ec(d, h, x, F, S);
      case 7:
        return xi(d, h, h.pendingProps, S), h.child;
      case 8:
        return xi(d, h, h.pendingProps.children, S), h.child;
      case 12:
        return xi(d, h, h.pendingProps.children, S), h.child;
      case 10:
        e: {
          if (x = h.type._context, F = h.pendingProps, U = h.memoizedProps, X = F.value, Vr(Ns, x._currentValue), x._currentValue = X, U !== null)
            if (et(U.value, X)) {
              if (U.children === F.children && !Xa.current) {
                h = Wi(d, h, S);
                break e;
              }
            } else
              for (U = h.child, U !== null && (U.return = h); U !== null; ) {
                var Se = U.dependencies;
                if (Se !== null) {
                  X = U.child;
                  for (var Pe = Se.firstContext; Pe !== null; ) {
                    if (Pe.context === x) {
                      if (U.tag === 1) {
                        Pe = Zl(-1, S & -S), Pe.tag = 2;
                        var nt = U.updateQueue;
                        if (nt !== null) {
                          nt = nt.shared;
                          var At = nt.pending;
                          At === null ? Pe.next = Pe : (Pe.next = At.next, At.next = Pe), nt.pending = Pe;
                        }
                      }
                      U.lanes |= S, Pe = U.alternate, Pe !== null && (Pe.lanes |= S), da(
                        U.return,
                        S,
                        h
                      ), Se.lanes |= S;
                      break;
                    }
                    Pe = Pe.next;
                  }
                } else if (U.tag === 10)
                  X = U.type === h.type ? null : U.child;
                else if (U.tag === 18) {
                  if (X = U.return, X === null)
                    throw Error(n(341));
                  X.lanes |= S, Se = X.alternate, Se !== null && (Se.lanes |= S), da(X, S, h), X = U.sibling;
                } else
                  X = U.child;
                if (X !== null)
                  X.return = U;
                else
                  for (X = U; X !== null; ) {
                    if (X === h) {
                      X = null;
                      break;
                    }
                    if (U = X.sibling, U !== null) {
                      U.return = X.return, X = U;
                      break;
                    }
                    X = X.return;
                  }
                U = X;
              }
          xi(d, h, F.children, S), h = h.child;
        }
        return h;
      case 9:
        return F = h.type, x = h.pendingProps.children, Gt(h, S), F = Ia(F), x = x(F), h.flags |= 1, xi(d, h, x, S), h.child;
      case 14:
        return x = h.type, F = Ds(x, h.pendingProps), F = Ds(x.type, F), bl(d, h, x, F, S);
      case 15:
        return $o(d, h, h.type, h.pendingProps, S);
      case 17:
        return x = h.type, F = h.pendingProps, F = h.elementType === x ? F : Ds(x, F), Hi(d, h), h.tag = 1, ka(x) ? (d = !0, pl(h)) : d = !1, Gt(h, S), Fv(h, x, F), Ig(h, x, F, S), J0(null, h, x, !0, d, S);
      case 19:
        return Hv(d, h, S);
      case 22:
        return vf(d, h, S);
    }
    throw Error(n(156, h.tag));
  };
  function ry(d, h) {
    return ve(d, h);
  }
  function j1(d, h, S, x) {
    this.tag = d, this.key = S, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = h, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = x, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function Bs(d, h, S, x) {
    return new j1(d, h, S, x);
  }
  function ay(d) {
    return d = d.prototype, !(!d || !d.isReactComponent);
  }
  function Kg(d) {
    if (typeof d == "function")
      return ay(d) ? 1 : 0;
    if (d != null) {
      if (d = d.$$typeof, d === J)
        return 11;
      if (d === fe)
        return 14;
    }
    return 2;
  }
  function Cf(d, h) {
    var S = d.alternate;
    return S === null ? (S = Bs(d.tag, h, d.key, d.mode), S.elementType = d.elementType, S.type = d.type, S.stateNode = d.stateNode, S.alternate = d, d.alternate = S) : (S.pendingProps = h, S.type = d.type, S.flags = 0, S.subtreeFlags = 0, S.deletions = null), S.flags = d.flags & 14680064, S.childLanes = d.childLanes, S.lanes = d.lanes, S.child = d.child, S.memoizedProps = d.memoizedProps, S.memoizedState = d.memoizedState, S.updateQueue = d.updateQueue, h = d.dependencies, S.dependencies = h === null ? null : { lanes: h.lanes, firstContext: h.firstContext }, S.sibling = d.sibling, S.index = d.index, S.ref = d.ref, S;
  }
  function Jg(d, h, S, x, F, U) {
    var X = 2;
    if (x = d, typeof d == "function")
      ay(d) && (X = 1);
    else if (typeof d == "string")
      X = 5;
    else
      e:
        switch (d) {
          case H:
            return xd(S.children, F, U, h);
          case Y:
            X = 8, F |= 8;
            break;
          case q:
            return d = Bs(12, S, h, F | 2), d.elementType = q, d.lanes = U, d;
          case ue:
            return d = Bs(13, S, h, F), d.elementType = ue, d.lanes = U, d;
          case ee:
            return d = Bs(19, S, h, F), d.elementType = ee, d.lanes = U, d;
          case ie:
            return Tm(S, F, U, h);
          default:
            if (typeof d == "object" && d !== null)
              switch (d.$$typeof) {
                case Q:
                  X = 10;
                  break e;
                case ne:
                  X = 9;
                  break e;
                case J:
                  X = 11;
                  break e;
                case fe:
                  X = 14;
                  break e;
                case de:
                  X = 16, x = null;
                  break e;
              }
            throw Error(n(130, d == null ? d : typeof d, ""));
        }
    return h = Bs(X, S, h, F), h.elementType = d, h.type = x, h.lanes = U, h;
  }
  function xd(d, h, S, x) {
    return d = Bs(7, d, x, h), d.lanes = S, d;
  }
  function Tm(d, h, S, x) {
    return d = Bs(22, d, x, h), d.elementType = ie, d.lanes = S, d.stateNode = { isHidden: !1 }, d;
  }
  function _m(d, h, S) {
    return d = Bs(6, d, null, h), d.lanes = S, d;
  }
  function Ad(d, h, S) {
    return h = Bs(4, d.children !== null ? d.children : [], d.key, h), h.lanes = S, h.stateNode = { containerInfo: d.containerInfo, pendingChildren: null, implementation: d.implementation }, h;
  }
  function G1(d, h, S, x, F) {
    this.tag = h, this.containerInfo = d, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = Ou(0), this.expirationTimes = Ou(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Ou(0), this.identifierPrefix = x, this.onRecoverableError = F, this.mutableSourceEagerHydrationData = null;
  }
  function eb(d, h, S, x, F, U, X, Se, Pe) {
    return d = new G1(d, h, S, Se, Pe), h === 1 ? (h = 1, U === !0 && (h |= 8)) : h = 0, U = Bs(3, null, null, h), d.current = U, U.stateNode = d, U.memoizedState = { element: x, isDehydrated: S, cache: null, transitions: null, pendingSuspenseBoundaries: null }, Lv(U), d;
  }
  function oO(d, h, S) {
    var x = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return { $$typeof: M, key: x == null ? null : "" + x, children: d, containerInfo: h, implementation: S };
  }
  function iy(d) {
    if (!d)
      return Au;
    d = d._reactInternals;
    e: {
      if (Yn(d) !== d || d.tag !== 1)
        throw Error(n(170));
      var h = d;
      do {
        switch (h.tag) {
          case 3:
            h = h.stateNode.context;
            break e;
          case 1:
            if (ka(h.type)) {
              h = h.stateNode.__reactInternalMemoizedMergedChildContext;
              break e;
            }
        }
        h = h.return;
      } while (h !== null);
      throw Error(n(171));
    }
    if (d.tag === 1) {
      var S = d.type;
      if (ka(S))
        return em(d, S, h);
    }
    return h;
  }
  function sO(d, h, S, x, F, U, X, Se, Pe) {
    return d = eb(S, x, !0, d, F, U, X, Se, Pe), d.context = iy(null), S = d.current, x = Co(), F = yi(S), U = Zl(x, F), U.callback = h ?? null, of(S, U, F), d.current.lanes = F, si(d, F, x), ji(d, x), d;
  }
  function Cm(d, h, S, x) {
    var F = h.current, U = Co(), X = yi(F);
    return S = iy(S), h.context === null ? h.context = S : h.pendingContext = S, h = Zl(U, X), h.payload = { element: d }, x = x === void 0 ? null : x, x !== null && (h.callback = x), d = of(F, h, X), d !== null && (xo(d, F, X, U), sf(d, F, X)), X;
  }
  function tb(d) {
    if (d = d.current, !d.child)
      return null;
    switch (d.child.tag) {
      case 5:
        return d.child.stateNode;
      default:
        return d.child.stateNode;
    }
  }
  function lO(d, h) {
    if (d = d.memoizedState, d !== null && d.dehydrated !== null) {
      var S = d.retryLane;
      d.retryLane = S !== 0 && S < h ? S : h;
    }
  }
  function oy(d, h) {
    lO(d, h), (d = d.alternate) && lO(d, h);
  }
  function uO() {
    return null;
  }
  var nb = typeof reportError == "function" ? reportError : function(d) {
    console.error(d);
  };
  function xm(d) {
    this._internalRoot = d;
  }
  Tc.prototype.render = xm.prototype.render = function(d) {
    var h = this._internalRoot;
    if (h === null)
      throw Error(n(409));
    Cm(d, h, null, null);
  }, Tc.prototype.unmount = xm.prototype.unmount = function() {
    var d = this._internalRoot;
    if (d !== null) {
      this._internalRoot = null;
      var h = d.containerInfo;
      Tf(function() {
        Cm(null, d, null, null);
      }), h[ks] = null;
    }
  };
  function Tc(d) {
    this._internalRoot = d;
  }
  Tc.prototype.unstable_scheduleHydration = function(d) {
    if (d) {
      var h = jc();
      d = { blockedOn: null, target: d, priority: h };
      for (var S = 0; S < ra.length && h !== 0 && h < ra[S].priority; S++)
        ;
      ra.splice(S, 0, d), S === 0 && L0(d);
    }
  };
  function sy(d) {
    return !(!d || d.nodeType !== 1 && d.nodeType !== 9 && d.nodeType !== 11);
  }
  function rb(d) {
    return !(!d || d.nodeType !== 1 && d.nodeType !== 9 && d.nodeType !== 11 && (d.nodeType !== 8 || d.nodeValue !== " react-mount-point-unstable "));
  }
  function cO() {
  }
  function ab(d, h, S, x, F) {
    if (F) {
      if (typeof x == "function") {
        var U = x;
        x = function() {
          var nt = tb(X);
          U.call(nt);
        };
      }
      var X = sO(h, x, d, 0, null, !1, !1, "", cO);
      return d._reactRootContainer = X, d[ks] = X.current, cc(d.nodeType === 8 ? d.parentNode : d), Tf(), X;
    }
    for (; F = d.lastChild; )
      d.removeChild(F);
    if (typeof x == "function") {
      var Se = x;
      x = function() {
        var nt = tb(Pe);
        Se.call(nt);
      };
    }
    var Pe = eb(d, 0, !1, null, null, !1, !1, "", cO);
    return d._reactRootContainer = Pe, d[ks] = Pe.current, cc(d.nodeType === 8 ? d.parentNode : d), Tf(function() {
      Cm(h, Pe, S, x);
    }), Pe;
  }
  function ib(d, h, S, x, F) {
    var U = S._reactRootContainer;
    if (U) {
      var X = U;
      if (typeof F == "function") {
        var Se = F;
        F = function() {
          var Pe = tb(X);
          Se.call(Pe);
        };
      }
      Cm(h, X, d, F);
    } else
      X = ab(S, h, d, F, x);
    return tb(X);
  }
  Eu = function(d) {
    switch (d.tag) {
      case 3:
        var h = d.stateNode;
        if (h.current.memoizedState.isDehydrated) {
          var S = yu(h.pendingLanes);
          S !== 0 && (go(h, S | 1), ji(h, Lt()), !(mr & 6) && (Wp = Lt() + 500, is()));
        }
        break;
      case 13:
        Tf(function() {
          var x = Yl(d, 1);
          if (x !== null) {
            var F = Co();
            xo(x, d, 1, F);
          }
        }), oy(d, 1);
    }
  }, ts = function(d) {
    if (d.tag === 13) {
      var h = Yl(d, 134217728);
      if (h !== null) {
        var S = Co();
        xo(h, d, 134217728, S);
      }
      oy(d, 134217728);
    }
  }, Qr = function(d) {
    if (d.tag === 13) {
      var h = yi(d), S = Yl(d, h);
      if (S !== null) {
        var x = Co();
        xo(S, d, h, x);
      }
      oy(d, h);
    }
  }, jc = function() {
    return hr;
  }, Gc = function(d, h) {
    var S = hr;
    try {
      return hr = d, h();
    } finally {
      hr = S;
    }
  }, br = function(d, h, S) {
    switch (h) {
      case "input":
        if (Be(d, S), h = S.name, S.type === "radio" && h != null) {
          for (S = d; S.parentNode; )
            S = S.parentNode;
          for (S = S.querySelectorAll("input[name=" + JSON.stringify("" + h) + '][type="radio"]'), h = 0; h < S.length; h++) {
            var x = S[h];
            if (x !== d && x.form === d.form) {
              var F = xn(x);
              if (!F)
                throw Error(n(90));
              we(x), Be(x, F);
            }
          }
        }
        break;
      case "textarea":
        Ut(d, S);
        break;
      case "select":
        h = S.value, h != null && wt(d, !!S.multiple, h, !1);
    }
  }, oi = Gp, gu = Tf;
  var V1 = { usingClientEntryPoint: !1, Events: [Oo, ar, xn, po, Ni, Gp] }, Vp = { findFiberByHostInstance: Mo, bundleType: 0, version: "18.2.0", rendererPackageName: "react-dom" }, Y1 = { bundleType: Vp.bundleType, version: Vp.version, rendererPackageName: Vp.rendererPackageName, rendererConfig: Vp.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: I.ReactCurrentDispatcher, findHostInstanceByFiber: function(d) {
    return d = Ba(d), d === null ? null : d.stateNode;
  }, findFiberByHostInstance: Vp.findFiberByHostInstance || uO, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.2.0-next-9e3b772b8-20220608" };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var ob = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!ob.isDisabled && ob.supportsFiber)
      try {
        Li = ob.inject(Y1), Aa = ob;
      } catch {
      }
  }
  return Wu.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = V1, Wu.createPortal = function(d, h) {
    var S = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!sy(h))
      throw Error(n(200));
    return oO(d, h, null, S);
  }, Wu.createRoot = function(d, h) {
    if (!sy(d))
      throw Error(n(299));
    var S = !1, x = "", F = nb;
    return h != null && (h.unstable_strictMode === !0 && (S = !0), h.identifierPrefix !== void 0 && (x = h.identifierPrefix), h.onRecoverableError !== void 0 && (F = h.onRecoverableError)), h = eb(d, 1, !1, null, null, S, !1, x, F), d[ks] = h.current, cc(d.nodeType === 8 ? d.parentNode : d), new xm(h);
  }, Wu.findDOMNode = function(d) {
    if (d == null)
      return null;
    if (d.nodeType === 1)
      return d;
    var h = d._reactInternals;
    if (h === void 0)
      throw typeof d.render == "function" ? Error(n(188)) : (d = Object.keys(d).join(","), Error(n(268, d)));
    return d = Ba(h), d = d === null ? null : d.stateNode, d;
  }, Wu.flushSync = function(d) {
    return Tf(d);
  }, Wu.hydrate = function(d, h, S) {
    if (!rb(h))
      throw Error(n(200));
    return ib(null, d, h, !0, S);
  }, Wu.hydrateRoot = function(d, h, S) {
    if (!sy(d))
      throw Error(n(405));
    var x = S != null && S.hydratedSources || null, F = !1, U = "", X = nb;
    if (S != null && (S.unstable_strictMode === !0 && (F = !0), S.identifierPrefix !== void 0 && (U = S.identifierPrefix), S.onRecoverableError !== void 0 && (X = S.onRecoverableError)), h = sO(h, null, d, 1, S ?? null, F, !1, U, X), d[ks] = h.current, cc(d), x)
      for (d = 0; d < x.length; d++)
        S = x[d], F = S._getVersion, F = F(S._source), h.mutableSourceEagerHydrationData == null ? h.mutableSourceEagerHydrationData = [S, F] : h.mutableSourceEagerHydrationData.push(
          S,
          F
        );
    return new Tc(h);
  }, Wu.render = function(d, h, S) {
    if (!rb(h))
      throw Error(n(200));
    return ib(null, d, h, !1, S);
  }, Wu.unmountComponentAtNode = function(d) {
    if (!rb(d))
      throw Error(n(40));
    return d._reactRootContainer ? (Tf(function() {
      ib(null, null, d, !1, function() {
        d._reactRootContainer = null, d[ks] = null;
      });
    }), !0) : !1;
  }, Wu.unstable_batchedUpdates = Gp, Wu.unstable_renderSubtreeIntoContainer = function(d, h, S, x) {
    if (!rb(S))
      throw Error(n(200));
    if (d == null || d._reactInternals === void 0)
      throw Error(n(38));
    return ib(d, h, S, !1, x);
  }, Wu.version = "18.2.0-next-9e3b772b8-20220608", Wu;
}
var Qu = {};
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _G;
function bbe() {
  return _G || (_G = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var t = Ge, e = gte(), n = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, r = !1;
    function a(l) {
      r = l;
    }
    function i(l) {
      if (!r) {
        for (var c = arguments.length, g = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          g[y - 1] = arguments[y];
        s("warn", l, g);
      }
    }
    function o(l) {
      if (!r) {
        for (var c = arguments.length, g = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          g[y - 1] = arguments[y];
        s("error", l, g);
      }
    }
    function s(l, c, g) {
      {
        var y = n.ReactDebugCurrentFrame, T = y.getStackAddendum();
        T !== "" && (c += "%s", g = g.concat([T]));
        var R = g.map(function($) {
          return String($);
        });
        R.unshift("Warning: " + c), Function.prototype.apply.call(console[l], console, R);
      }
    }
    var u = 0, f = 1, p = 2, m = 3, v = 4, O = 5, w = 6, _ = 7, C = 8, A = 9, N = 10, P = 11, I = 12, D = 13, M = 14, H = 15, Y = 16, q = 17, Q = 18, ne = 19, J = 21, ue = 22, ee = 23, fe = 24, de = 25, ie = !0, le = !1, ye = !1, B = !1, pe = !1, _e = !0, Z = !1, ce = !1, j = !0, K = !0, Ee = !0, he = /* @__PURE__ */ new Set(), Ae = {}, Te = {};
    function je(l, c) {
      we(l, c), we(l + "Capture", c);
    }
    function we(l, c) {
      Ae[l] && o("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", l), Ae[l] = c;
      {
        var g = l.toLowerCase();
        Te[g] = l, l === "onDoubleClick" && (Te.ondblclick = l);
      }
      for (var y = 0; y < c.length; y++)
        he.add(c[y]);
    }
    var lt = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", st = Object.prototype.hasOwnProperty;
    function Oe(l) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, g = c && l[Symbol.toStringTag] || l.constructor.name || "Object";
        return g;
      }
    }
    function Re(l) {
      try {
        return Be(l), !1;
      } catch {
        return !0;
      }
    }
    function Be(l) {
      return "" + l;
    }
    function mt(l, c) {
      if (Re(l))
        return o("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", c, Oe(l)), Be(l);
    }
    function Tt(l) {
      if (Re(l))
        return o("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Oe(l)), Be(l);
    }
    function ut(l, c) {
      if (Re(l))
        return o("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", c, Oe(l)), Be(l);
    }
    function wt(l, c) {
      if (Re(l))
        return o("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", c, Oe(l)), Be(l);
    }
    function Yt(l) {
      if (Re(l))
        return o("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", Oe(l)), Be(l);
    }
    function Rt(l) {
      if (Re(l))
        return o("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", Oe(l)), Be(l);
    }
    var Ut = 0, He = 1, Ve = 2, Ie = 3, it = 4, zt = 5, Ht = 6, bt = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", Mt = bt + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", ln = new RegExp("^[" + bt + "][" + Mt + "]*$"), ze = {}, gt = {};
    function Bt(l) {
      return st.call(gt, l) ? !0 : st.call(ze, l) ? !1 : ln.test(l) ? (gt[l] = !0, !0) : (ze[l] = !0, o("Invalid attribute name: `%s`", l), !1);
    }
    function Qt(l, c, g) {
      return c !== null ? c.type === Ut : g ? !1 : l.length > 2 && (l[0] === "o" || l[0] === "O") && (l[1] === "n" || l[1] === "N");
    }
    function En(l, c, g, y) {
      if (g !== null && g.type === Ut)
        return !1;
      switch (typeof c) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if (y)
            return !1;
          if (g !== null)
            return !g.acceptsBooleans;
          var T = l.toLowerCase().slice(0, 5);
          return T !== "data-" && T !== "aria-";
        }
        default:
          return !1;
      }
    }
    function Mn(l, c, g, y) {
      if (c === null || typeof c > "u" || En(l, c, g, y))
        return !0;
      if (y)
        return !1;
      if (g !== null)
        switch (g.type) {
          case Ie:
            return !c;
          case it:
            return c === !1;
          case zt:
            return isNaN(c);
          case Ht:
            return isNaN(c) || c < 1;
        }
      return !1;
    }
    function br(l) {
      return Ar.hasOwnProperty(l) ? Ar[l] : null;
    }
    function sr(l, c, g, y, T, R, $) {
      this.acceptsBooleans = c === Ve || c === Ie || c === it, this.attributeName = y, this.attributeNamespace = T, this.mustUseProperty = g, this.propertyName = l, this.type = c, this.sanitizeURL = R, this.removeEmptyString = $;
    }
    var Ar = {}, Ji = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    Ji.forEach(function(l) {
      Ar[l] = new sr(
        l,
        Ut,
        !1,
        // mustUseProperty
        l,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(l) {
      var c = l[0], g = l[1];
      Ar[c] = new sr(
        c,
        He,
        !1,
        // mustUseProperty
        g,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(l) {
      Ar[l] = new sr(
        l,
        Ve,
        !1,
        // mustUseProperty
        l.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(l) {
      Ar[l] = new sr(
        l,
        Ve,
        !1,
        // mustUseProperty
        l,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(l) {
      Ar[l] = new sr(
        l,
        Ie,
        !1,
        // mustUseProperty
        l.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(l) {
      Ar[l] = new sr(
        l,
        Ie,
        !0,
        // mustUseProperty
        l,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(l) {
      Ar[l] = new sr(
        l,
        it,
        !1,
        // mustUseProperty
        l,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(l) {
      Ar[l] = new sr(
        l,
        Ht,
        !1,
        // mustUseProperty
        l,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(l) {
      Ar[l] = new sr(
        l,
        zt,
        !1,
        // mustUseProperty
        l.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var po = /[\-\:]([a-z])/g, Ni = function(l) {
      return l[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(l) {
      var c = l.replace(po, Ni);
      Ar[c] = new sr(
        c,
        He,
        !1,
        // mustUseProperty
        l,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(l) {
      var c = l.replace(po, Ni);
      Ar[c] = new sr(
        c,
        He,
        !1,
        // mustUseProperty
        l,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(l) {
      var c = l.replace(po, Ni);
      Ar[c] = new sr(
        c,
        He,
        !1,
        // mustUseProperty
        l,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(l) {
      Ar[l] = new sr(
        l,
        He,
        !1,
        // mustUseProperty
        l.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var oi = "xlinkHref";
    Ar[oi] = new sr(
      "xlinkHref",
      He,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(l) {
      Ar[l] = new sr(
        l,
        He,
        !1,
        // mustUseProperty
        l.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var gu = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, ho = !1;
    function Jo(l) {
      !ho && gu.test(l) && (ho = !0, o("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(l)));
    }
    function bu(l, c, g, y) {
      if (y.mustUseProperty) {
        var T = y.propertyName;
        return l[T];
      } else {
        mt(g, c), y.sanitizeURL && Jo("" + g);
        var R = y.attributeName, $ = null;
        if (y.type === it) {
          if (l.hasAttribute(R)) {
            var W = l.getAttribute(R);
            return W === "" ? !0 : Mn(c, g, y, !1) ? W : W === "" + g ? g : W;
          }
        } else if (l.hasAttribute(R)) {
          if (Mn(c, g, y, !1))
            return l.getAttribute(R);
          if (y.type === Ie)
            return g;
          $ = l.getAttribute(R);
        }
        return Mn(c, g, y, !1) ? $ === null ? g : $ : $ === "" + g ? g : $;
      }
    }
    function vu(l, c, g, y) {
      {
        if (!Bt(c))
          return;
        if (!l.hasAttribute(c))
          return g === void 0 ? void 0 : null;
        var T = l.getAttribute(c);
        return mt(g, c), T === "" + g ? g : T;
      }
    }
    function Lo(l, c, g, y) {
      var T = br(c);
      if (!Qt(c, T, y)) {
        if (Mn(c, g, T, y) && (g = null), y || T === null) {
          if (Bt(c)) {
            var R = c;
            g === null ? l.removeAttribute(R) : (mt(g, c), l.setAttribute(R, "" + g));
          }
          return;
        }
        var $ = T.mustUseProperty;
        if ($) {
          var W = T.propertyName;
          if (g === null) {
            var G = T.type;
            l[W] = G === Ie ? !1 : "";
          } else
            l[W] = g;
          return;
        }
        var ae = T.attributeName, me = T.attributeNamespace;
        if (g === null)
          l.removeAttribute(ae);
        else {
          var Ue = T.type, $e;
          Ue === Ie || Ue === it && g === !0 ? $e = "" : (mt(g, ae), $e = "" + g, T.sanitizeURL && Jo($e.toString())), me ? l.setAttributeNS(me, ae, $e) : l.setAttribute(ae, $e);
        }
      }
    }
    var Pi = Symbol.for("react.element"), eo = Symbol.for("react.portal"), es = Symbol.for("react.fragment"), Fl = Symbol.for("react.strict_mode"), xe = Symbol.for("react.profiler"), xt = Symbol.for("react.provider"), jt = Symbol.for("react.context"), Sn = Symbol.for("react.forward_ref"), Yn = Symbol.for("react.suspense"), ur = Symbol.for("react.suspense_list"), qn = Symbol.for("react.memo"), Rn = Symbol.for("react.lazy"), Ba = Symbol.for("react.scope"), ma = Symbol.for("react.debug_trace_mode"), ve = Symbol.for("react.offscreen"), Ye = Symbol.for("react.legacy_hidden"), yt = Symbol.for("react.cache"), Dt = Symbol.for("react.tracing_marker"), Lt = Symbol.iterator, _n = "@@iterator";
    function Nn(l) {
      if (l === null || typeof l != "object")
        return null;
      var c = Lt && l[Lt] || l[_n];
      return typeof c == "function" ? c : null;
    }
    var fn = Object.assign, Or = 0, Er, pr, Li, Aa, ua, Mr, to;
    function $l() {
    }
    $l.__reactDisabledLog = !0;
    function Bl() {
      {
        if (Or === 0) {
          Er = console.log, pr = console.info, Li = console.warn, Aa = console.error, ua = console.group, Mr = console.groupCollapsed, to = console.groupEnd;
          var l = {
            configurable: !0,
            enumerable: !0,
            value: $l,
            writable: !0
          };
          Object.defineProperties(console, {
            info: l,
            log: l,
            warn: l,
            error: l,
            group: l,
            groupCollapsed: l,
            groupEnd: l
          });
        }
        Or++;
      }
    }
    function il() {
      {
        if (Or--, Or === 0) {
          var l = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: fn({}, l, {
              value: Er
            }),
            info: fn({}, l, {
              value: pr
            }),
            warn: fn({}, l, {
              value: Li
            }),
            error: fn({}, l, {
              value: Aa
            }),
            group: fn({}, l, {
              value: ua
            }),
            groupCollapsed: fn({}, l, {
              value: Mr
            }),
            groupEnd: fn({}, l, {
              value: to
            })
          });
        }
        Or < 0 && o("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ac = n.ReactCurrentDispatcher, yu;
    function mo(l, c, g) {
      {
        if (yu === void 0)
          try {
            throw Error();
          } catch (T) {
            var y = T.stack.trim().match(/\n( *(at )?)/);
            yu = y && y[1] || "";
          }
        return `
` + yu + l;
      }
    }
    var Fr = !1, _r;
    {
      var Qc = typeof WeakMap == "function" ? WeakMap : Map;
      _r = new Qc();
    }
    function Ts(l, c) {
      if (!l || Fr)
        return "";
      {
        var g = _r.get(l);
        if (g !== void 0)
          return g;
      }
      var y;
      Fr = !0;
      var T = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var R;
      R = ac.current, ac.current = null, Bl();
      try {
        if (c) {
          var $ = function() {
            throw Error();
          };
          if (Object.defineProperty($.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct($, []);
            } catch (rt) {
              y = rt;
            }
            Reflect.construct(l, [], $);
          } else {
            try {
              $.call();
            } catch (rt) {
              y = rt;
            }
            l.call($.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (rt) {
            y = rt;
          }
          l();
        }
      } catch (rt) {
        if (rt && y && typeof rt.stack == "string") {
          for (var W = rt.stack.split(`
`), G = y.stack.split(`
`), ae = W.length - 1, me = G.length - 1; ae >= 1 && me >= 0 && W[ae] !== G[me]; )
            me--;
          for (; ae >= 1 && me >= 0; ae--, me--)
            if (W[ae] !== G[me]) {
              if (ae !== 1 || me !== 1)
                do
                  if (ae--, me--, me < 0 || W[ae] !== G[me]) {
                    var Ue = `
` + W[ae].replace(" at new ", " at ");
                    return l.displayName && Ue.includes("<anonymous>") && (Ue = Ue.replace("<anonymous>", l.displayName)), typeof l == "function" && _r.set(l, Ue), Ue;
                  }
                while (ae >= 1 && me >= 0);
              break;
            }
        }
      } finally {
        Fr = !1, ac.current = R, il(), Error.prepareStackTrace = T;
      }
      var $e = l ? l.displayName || l.name : "", tt = $e ? mo($e) : "";
      return typeof l == "function" && _r.set(l, tt), tt;
    }
    function Ou(l, c, g) {
      return Ts(l, !0);
    }
    function si(l, c, g) {
      return Ts(l, !1);
    }
    function ol(l) {
      var c = l.prototype;
      return !!(c && c.isReactComponent);
    }
    function go(l, c, g) {
      if (l == null)
        return "";
      if (typeof l == "function")
        return Ts(l, ol(l));
      if (typeof l == "string")
        return mo(l);
      switch (l) {
        case Yn:
          return mo("Suspense");
        case ur:
          return mo("SuspenseList");
      }
      if (typeof l == "object")
        switch (l.$$typeof) {
          case Sn:
            return si(l.render);
          case qn:
            return go(l.type, c, g);
          case Rn: {
            var y = l, T = y._payload, R = y._init;
            try {
              return go(R(T), c, g);
            } catch {
            }
          }
        }
      return "";
    }
    function hr(l) {
      switch (l._debugOwner && l._debugOwner.type, l._debugSource, l.tag) {
        case O:
          return mo(l.type);
        case Y:
          return mo("Lazy");
        case D:
          return mo("Suspense");
        case ne:
          return mo("SuspenseList");
        case u:
        case p:
        case H:
          return si(l.type);
        case P:
          return si(l.type.render);
        case f:
          return Ou(l.type);
        default:
          return "";
      }
    }
    function _s(l) {
      try {
        var c = "", g = l;
        do
          c += hr(g), g = g.return;
        while (g);
        return c;
      } catch (y) {
        return `
Error generating stack: ` + y.message + `
` + y.stack;
      }
    }
    function Eu(l, c, g) {
      var y = l.displayName;
      if (y)
        return y;
      var T = c.displayName || c.name || "";
      return T !== "" ? g + "(" + T + ")" : g;
    }
    function ts(l) {
      return l.displayName || "Context";
    }
    function Qr(l) {
      if (l == null)
        return null;
      if (typeof l.tag == "number" && o("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof l == "function")
        return l.displayName || l.name || null;
      if (typeof l == "string")
        return l;
      switch (l) {
        case es:
          return "Fragment";
        case eo:
          return "Portal";
        case xe:
          return "Profiler";
        case Fl:
          return "StrictMode";
        case Yn:
          return "Suspense";
        case ur:
          return "SuspenseList";
      }
      if (typeof l == "object")
        switch (l.$$typeof) {
          case jt:
            var c = l;
            return ts(c) + ".Consumer";
          case xt:
            var g = l;
            return ts(g._context) + ".Provider";
          case Sn:
            return Eu(l, l.render, "ForwardRef");
          case qn:
            var y = l.displayName || null;
            return y !== null ? y : Qr(l.type) || "Memo";
          case Rn: {
            var T = l, R = T._payload, $ = T._init;
            try {
              return Qr($(R));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    function jc(l, c, g) {
      var y = c.displayName || c.name || "";
      return l.displayName || (y !== "" ? g + "(" + y + ")" : g);
    }
    function Gc(l) {
      return l.displayName || "Context";
    }
    function Bn(l) {
      var c = l.tag, g = l.type;
      switch (c) {
        case fe:
          return "Cache";
        case A:
          var y = g;
          return Gc(y) + ".Consumer";
        case N:
          var T = g;
          return Gc(T._context) + ".Provider";
        case Q:
          return "DehydratedFragment";
        case P:
          return jc(g, g.render, "ForwardRef");
        case _:
          return "Fragment";
        case O:
          return g;
        case v:
          return "Portal";
        case m:
          return "Root";
        case w:
          return "Text";
        case Y:
          return Qr(g);
        case C:
          return g === Fl ? "StrictMode" : "Mode";
        case ue:
          return "Offscreen";
        case I:
          return "Profiler";
        case J:
          return "Scope";
        case D:
          return "Suspense";
        case ne:
          return "SuspenseList";
        case de:
          return "TracingMarker";
        case f:
        case u:
        case q:
        case p:
        case M:
        case H:
          if (typeof g == "function")
            return g.displayName || g.name || null;
          if (typeof g == "string")
            return g;
          break;
      }
      return null;
    }
    var Ul = n.ReactDebugCurrentFrame, Ua = null, no = !1;
    function ro() {
      {
        if (Ua === null)
          return null;
        var l = Ua._debugOwner;
        if (l !== null && typeof l < "u")
          return Bn(l);
      }
      return null;
    }
    function rp() {
      return Ua === null ? "" : _s(Ua);
    }
    function wi() {
      Ul.getCurrentStack = null, Ua = null, no = !1;
    }
    function ra(l) {
      Ul.getCurrentStack = l === null ? null : rp, Ua = l, no = !1;
    }
    function A1() {
      return Ua;
    }
    function zl(l) {
      no = l;
    }
    function Mi(l) {
      return "" + l;
    }
    function Vc(l) {
      switch (typeof l) {
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return l;
        case "object":
          return Rt(l), l;
        default:
          return "";
      }
    }
    var L0 = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function ap(l, c) {
      L0[c.type] || c.onChange || c.onInput || c.readOnly || c.disabled || c.value == null || o("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), c.onChange || c.readOnly || c.disabled || c.checked == null || o("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function mv(l) {
      var c = l.type, g = l.nodeName;
      return g && g.toLowerCase() === "input" && (c === "checkbox" || c === "radio");
    }
    function M0(l) {
      return l._valueTracker;
    }
    function Jr(l) {
      l._valueTracker = null;
    }
    function jr(l) {
      var c = "";
      return l && (mv(l) ? c = l.checked ? "true" : "false" : c = l.value), c;
    }
    function ip(l) {
      var c = mv(l) ? "checked" : "value", g = Object.getOwnPropertyDescriptor(l.constructor.prototype, c);
      Rt(l[c]);
      var y = "" + l[c];
      if (!(l.hasOwnProperty(c) || typeof g > "u" || typeof g.get != "function" || typeof g.set != "function")) {
        var T = g.get, R = g.set;
        Object.defineProperty(l, c, {
          configurable: !0,
          get: function() {
            return T.call(this);
          },
          set: function(W) {
            Rt(W), y = "" + W, R.call(this, W);
          }
        }), Object.defineProperty(l, c, {
          enumerable: g.enumerable
        });
        var $ = {
          getValue: function() {
            return y;
          },
          setValue: function(W) {
            Rt(W), y = "" + W;
          },
          stopTracking: function() {
            Jr(l), delete l[c];
          }
        };
        return $;
      }
    }
    function nd(l) {
      M0(l) || (l._valueTracker = ip(l));
    }
    function F0(l) {
      if (!l)
        return !1;
      var c = M0(l);
      if (!c)
        return !0;
      var g = c.getValue(), y = jr(l);
      return y !== g ? (c.setValue(y), !0) : !1;
    }
    function lg(l) {
      if (l = l || (typeof document < "u" ? document : void 0), typeof l > "u")
        return null;
      try {
        return l.activeElement || l.body;
      } catch {
        return l.body;
      }
    }
    var ug = !1, $h = !1, Bh = !1, gv = !1;
    function Ta(l) {
      var c = l.type === "checkbox" || l.type === "radio";
      return c ? l.checked != null : l.value != null;
    }
    function rd(l, c) {
      var g = l, y = c.checked, T = fn({}, c, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: y ?? g._wrapperState.initialChecked
      });
      return T;
    }
    function Hl(l, c) {
      ap("input", c), c.checked !== void 0 && c.defaultChecked !== void 0 && !$h && (o("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", ro() || "A component", c.type), $h = !0), c.value !== void 0 && c.defaultValue !== void 0 && !ug && (o("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", ro() || "A component", c.type), ug = !0);
      var g = l, y = c.defaultValue == null ? "" : c.defaultValue;
      g._wrapperState = {
        initialChecked: c.checked != null ? c.checked : c.defaultChecked,
        initialValue: Vc(c.value != null ? c.value : y),
        controlled: Ta(c)
      };
    }
    function cg(l, c) {
      var g = l, y = c.checked;
      y != null && Lo(g, "checked", y, !1);
    }
    function Yc(l, c) {
      var g = l;
      {
        var y = Ta(c);
        !g._wrapperState.controlled && y && !gv && (o("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), gv = !0), g._wrapperState.controlled && !y && !Bh && (o("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), Bh = !0);
      }
      cg(l, c);
      var T = Vc(c.value), R = c.type;
      if (T != null)
        R === "number" ? (T === 0 && g.value === "" || // We explicitly want to coerce to number here if possible.
        // eslint-disable-next-line
        g.value != T) && (g.value = Mi(T)) : g.value !== Mi(T) && (g.value = Mi(T));
      else if (R === "submit" || R === "reset") {
        g.removeAttribute("value");
        return;
      }
      c.hasOwnProperty("value") ? ic(g, c.type, T) : c.hasOwnProperty("defaultValue") && ic(g, c.type, Vc(c.defaultValue)), c.checked == null && c.defaultChecked != null && (g.defaultChecked = !!c.defaultChecked);
    }
    function bo(l, c, g) {
      var y = l;
      if (c.hasOwnProperty("value") || c.hasOwnProperty("defaultValue")) {
        var T = c.type, R = T === "submit" || T === "reset";
        if (R && (c.value === void 0 || c.value === null))
          return;
        var $ = Mi(y._wrapperState.initialValue);
        g || $ !== y.value && (y.value = $), y.defaultValue = $;
      }
      var W = y.name;
      W !== "" && (y.name = ""), y.defaultChecked = !y.defaultChecked, y.defaultChecked = !!y._wrapperState.initialChecked, W !== "" && (y.name = W);
    }
    function bv(l, c) {
      var g = l;
      Yc(g, c), ns(g, c);
    }
    function ns(l, c) {
      var g = c.name;
      if (c.type === "radio" && g != null) {
        for (var y = l; y.parentNode; )
          y = y.parentNode;
        mt(g, "name");
        for (var T = y.querySelectorAll("input[name=" + JSON.stringify("" + g) + '][type="radio"]'), R = 0; R < T.length; R++) {
          var $ = T[R];
          if (!($ === l || $.form !== l.form)) {
            var W = $n($);
            if (!W)
              throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
            F0($), Yc($, W);
          }
        }
      }
    }
    function ic(l, c, g) {
      // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
      (c !== "number" || lg(l.ownerDocument) !== l) && (g == null ? l.defaultValue = Mi(l._wrapperState.initialValue) : l.defaultValue !== Mi(g) && (l.defaultValue = Mi(g)));
    }
    var Uh = !1, ad = !1, vv = !1;
    function vo(l, c) {
      c.value == null && (typeof c.children == "object" && c.children !== null ? t.Children.forEach(c.children, function(g) {
        g != null && (typeof g == "string" || typeof g == "number" || ad || (ad = !0, o("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }) : c.dangerouslySetInnerHTML != null && (vv || (vv = !0, o("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")))), c.selected != null && !Uh && (o("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), Uh = !0);
    }
    function yv(l, c) {
      c.value != null && l.setAttribute("value", Mi(Vc(c.value)));
    }
    var yo = Array.isArray;
    function Fi(l) {
      return yo(l);
    }
    var zh;
    zh = !1;
    function oc() {
      var l = ro();
      return l ? `

Check the render method of \`` + l + "`." : "";
    }
    var Hh = ["value", "defaultValue"];
    function Ov(l) {
      {
        ap("select", l);
        for (var c = 0; c < Hh.length; c++) {
          var g = Hh[c];
          if (l[g] != null) {
            var y = Fi(l[g]);
            l.multiple && !y ? o("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", g, oc()) : !l.multiple && y && o("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", g, oc());
          }
        }
      }
    }
    function Hr(l, c, g, y) {
      var T = l.options;
      if (c) {
        for (var R = g, $ = {}, W = 0; W < R.length; W++)
          $["$" + R[W]] = !0;
        for (var G = 0; G < T.length; G++) {
          var ae = $.hasOwnProperty("$" + T[G].value);
          T[G].selected !== ae && (T[G].selected = ae), ae && y && (T[G].defaultSelected = !0);
        }
      } else {
        for (var me = Mi(Vc(g)), Ue = null, $e = 0; $e < T.length; $e++) {
          if (T[$e].value === me) {
            T[$e].selected = !0, y && (T[$e].defaultSelected = !0);
            return;
          }
          Ue === null && !T[$e].disabled && (Ue = T[$e]);
        }
        Ue !== null && (Ue.selected = !0);
      }
    }
    function Su(l, c) {
      return fn({}, c, {
        value: void 0
      });
    }
    function fg(l, c) {
      var g = l;
      Ov(c), g._wrapperState = {
        wasMultiple: !!c.multiple
      }, c.value !== void 0 && c.defaultValue !== void 0 && !zh && (o("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), zh = !0);
    }
    function k1(l, c) {
      var g = l;
      g.multiple = !!c.multiple;
      var y = c.value;
      y != null ? Hr(g, !!c.multiple, y, !1) : c.defaultValue != null && Hr(g, !!c.multiple, c.defaultValue, !0);
    }
    function Ev(l, c) {
      var g = l, y = g._wrapperState.wasMultiple;
      g._wrapperState.wasMultiple = !!c.multiple;
      var T = c.value;
      T != null ? Hr(g, !!c.multiple, T, !1) : y !== !!c.multiple && (c.defaultValue != null ? Hr(g, !!c.multiple, c.defaultValue, !0) : Hr(g, !!c.multiple, c.multiple ? [] : "", !1));
    }
    function R1(l, c) {
      var g = l, y = c.value;
      y != null && Hr(g, !!c.multiple, y, !1);
    }
    var Sv = !1;
    function wv(l, c) {
      var g = l;
      if (c.dangerouslySetInnerHTML != null)
        throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
      var y = fn({}, c, {
        value: void 0,
        defaultValue: void 0,
        children: Mi(g._wrapperState.initialValue)
      });
      return y;
    }
    function Tv(l, c) {
      var g = l;
      ap("textarea", c), c.value !== void 0 && c.defaultValue !== void 0 && !Sv && (o("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", ro() || "A component"), Sv = !0);
      var y = c.value;
      if (y == null) {
        var T = c.children, R = c.defaultValue;
        if (T != null) {
          o("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
          {
            if (R != null)
              throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
            if (Fi(T)) {
              if (T.length > 1)
                throw new Error("<textarea> can only have at most one child.");
              T = T[0];
            }
            R = T;
          }
        }
        R == null && (R = ""), y = R;
      }
      g._wrapperState = {
        initialValue: Vc(y)
      };
    }
    function Wh(l, c) {
      var g = l, y = Vc(c.value), T = Vc(c.defaultValue);
      if (y != null) {
        var R = Mi(y);
        R !== g.value && (g.value = R), c.defaultValue == null && g.defaultValue !== R && (g.defaultValue = R);
      }
      T != null && (g.defaultValue = Mi(T));
    }
    function id(l, c) {
      var g = l, y = g.textContent;
      y === g._wrapperState.initialValue && y !== "" && y !== null && (g.value = y);
    }
    function _v(l, c) {
      Wh(l, c);
    }
    var wu = "http://www.w3.org/1999/xhtml", $0 = "http://www.w3.org/1998/Math/MathML", Qh = "http://www.w3.org/2000/svg";
    function op(l) {
      switch (l) {
        case "svg":
          return Qh;
        case "math":
          return $0;
        default:
          return wu;
      }
    }
    function dg(l, c) {
      return l == null || l === wu ? op(c) : l === Qh && c === "foreignObject" ? wu : l;
    }
    var I1 = function(l) {
      return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(c, g, y, T) {
        MSApp.execUnsafeLocalFunction(function() {
          return l(c, g, y, T);
        });
      } : l;
    }, sp, pg = I1(function(l, c) {
      if (l.namespaceURI === Qh && !("innerHTML" in l)) {
        sp = sp || document.createElement("div"), sp.innerHTML = "<svg>" + c.valueOf().toString() + "</svg>";
        for (var g = sp.firstChild; l.firstChild; )
          l.removeChild(l.firstChild);
        for (; g.firstChild; )
          l.appendChild(g.firstChild);
        return;
      }
      l.innerHTML = c;
    }), rs = 1, Tu = 3, $r = 8, Cs = 9, Wl = 11, jh = function(l, c) {
      if (c) {
        var g = l.firstChild;
        if (g && g === l.lastChild && g.nodeType === Tu) {
          g.nodeValue = c;
          return;
        }
      }
      l.textContent = c;
    }, Cv = {
      animation: ["animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationIterationCount", "animationName", "animationPlayState", "animationTimingFunction"],
      background: ["backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPositionX", "backgroundPositionY", "backgroundRepeat", "backgroundSize"],
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
      borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"],
      borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
      borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
      borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"],
      borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"],
      borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
      borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
      borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: ["fontFamily", "fontFeatureSettings", "fontKerning", "fontLanguageOverride", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition", "fontWeight", "lineHeight"],
      fontVariant: ["fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition"],
      gap: ["columnGap", "rowGap"],
      grid: ["gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: ["maskClip", "maskComposite", "maskImage", "maskMode", "maskOrigin", "maskPositionX", "maskPositionY", "maskRepeat", "maskSize"],
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"],
      wordWrap: ["overflowWrap"]
    }, lp = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function B0(l, c) {
      return l + c.charAt(0).toUpperCase() + c.substring(1);
    }
    var U0 = ["Webkit", "ms", "Moz", "O"];
    Object.keys(lp).forEach(function(l) {
      U0.forEach(function(c) {
        lp[B0(c, l)] = lp[l];
      });
    });
    function hg(l, c, g) {
      var y = c == null || typeof c == "boolean" || c === "";
      return y ? "" : !g && typeof c == "number" && c !== 0 && !(lp.hasOwnProperty(l) && lp[l]) ? c + "px" : (wt(c, l), ("" + c).trim());
    }
    var up = /([A-Z])/g, cp = /^ms-/;
    function D1(l) {
      return l.replace(up, "-$1").toLowerCase().replace(cp, "-ms-");
    }
    var z0 = function() {
    };
    {
      var mg = /^(?:webkit|moz|o)[A-Z]/, xv = /^-ms-/, sl = /-(.)/g, sc = /;\s*$/, fp = {}, dp = {}, H0 = !1, Zc = !1, xs = function(l) {
        return l.replace(sl, function(c, g) {
          return g.toUpperCase();
        });
      }, gg = function(l) {
        fp.hasOwnProperty(l) && fp[l] || (fp[l] = !0, o(
          "Unsupported style property %s. Did you mean %s?",
          l,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          xs(l.replace(xv, "ms-"))
        ));
      }, W0 = function(l) {
        fp.hasOwnProperty(l) && fp[l] || (fp[l] = !0, o("Unsupported vendor-prefixed style property %s. Did you mean %s?", l, l.charAt(0).toUpperCase() + l.slice(1)));
      }, Q0 = function(l, c) {
        dp.hasOwnProperty(c) && dp[c] || (dp[c] = !0, o(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, l, c.replace(sc, "")));
      }, j0 = function(l, c) {
        H0 || (H0 = !0, o("`NaN` is an invalid value for the `%s` css style property.", l));
      }, N1 = function(l, c) {
        Zc || (Zc = !0, o("`Infinity` is an invalid value for the `%s` css style property.", l));
      };
      z0 = function(l, c) {
        l.indexOf("-") > -1 ? gg(l) : mg.test(l) ? W0(l) : sc.test(c) && Q0(l, c), typeof c == "number" && (isNaN(c) ? j0(l, c) : isFinite(c) || N1(l, c));
      };
    }
    var P1 = z0;
    function pp(l) {
      {
        var c = "", g = "";
        for (var y in l)
          if (l.hasOwnProperty(y)) {
            var T = l[y];
            if (T != null) {
              var R = y.indexOf("--") === 0;
              c += g + (R ? y : D1(y)) + ":", c += hg(y, T, R), g = ";";
            }
          }
        return c || null;
      }
    }
    function We(l, c) {
      var g = l.style;
      for (var y in c)
        if (c.hasOwnProperty(y)) {
          var T = y.indexOf("--") === 0;
          T || P1(y, c[y]);
          var R = hg(y, c[y], T);
          y === "float" && (y = "cssFloat"), T ? g.setProperty(y, R) : g[y] = R;
        }
    }
    function dt(l) {
      return l == null || typeof l == "boolean" || l === "";
    }
    function et(l) {
      var c = {};
      for (var g in l)
        for (var y = Cv[g] || [g], T = 0; T < y.length; T++)
          c[y[T]] = g;
      return c;
    }
    function Jt(l, c) {
      {
        if (!c)
          return;
        var g = et(l), y = et(c), T = {};
        for (var R in g) {
          var $ = g[R], W = y[R];
          if (W && $ !== W) {
            var G = $ + "," + W;
            if (T[G])
              continue;
            T[G] = !0, o("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", dt(l[$]) ? "Removing" : "Updating", $, W);
          }
        }
      }
    }
    var Kn = {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
      // NOTE: menuitem's close tag should be omitted, but that causes problems.
    }, Br = fn({
      menuitem: !0
    }, Kn), gi = "__html";
    function Gr(l, c) {
      if (c) {
        if (Br[l] && (c.children != null || c.dangerouslySetInnerHTML != null))
          throw new Error(l + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        if (c.dangerouslySetInnerHTML != null) {
          if (c.children != null)
            throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          if (typeof c.dangerouslySetInnerHTML != "object" || !(gi in c.dangerouslySetInnerHTML))
            throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!c.suppressContentEditableWarning && c.contentEditable && c.children != null && o("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), c.style != null && typeof c.style != "object")
          throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      }
    }
    function Ql(l, c) {
      if (l.indexOf("-") === -1)
        return typeof c.is == "string";
      switch (l) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var bg = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, As = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, as = {}, Av = new RegExp("^(aria)-[" + Mt + "]*$"), _u = new RegExp("^(aria)[A-Z][" + Mt + "]*$");
    function hp(l, c) {
      {
        if (st.call(as, c) && as[c])
          return !0;
        if (_u.test(c)) {
          var g = "aria-" + c.slice(4).toLowerCase(), y = As.hasOwnProperty(g) ? g : null;
          if (y == null)
            return o("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", c), as[c] = !0, !0;
          if (c !== y)
            return o("Invalid ARIA attribute `%s`. Did you mean `%s`?", c, y), as[c] = !0, !0;
        }
        if (Av.test(c)) {
          var T = c.toLowerCase(), R = As.hasOwnProperty(T) ? T : null;
          if (R == null)
            return as[c] = !0, !1;
          if (c !== R)
            return o("Unknown ARIA attribute `%s`. Did you mean `%s`?", c, R), as[c] = !0, !0;
        }
      }
      return !0;
    }
    function Gh(l, c) {
      {
        var g = [];
        for (var y in c) {
          var T = hp(l, y);
          T || g.push(y);
        }
        var R = g.map(function($) {
          return "`" + $ + "`";
        }).join(", ");
        g.length === 1 ? o("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", R, l) : g.length > 1 && o("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", R, l);
      }
    }
    function Ur(l, c) {
      Ql(l, c) || Gh(l, c);
    }
    var od = !1;
    function vg(l, c) {
      {
        if (l !== "input" && l !== "textarea" && l !== "select")
          return;
        c != null && c.value === null && !od && (od = !0, l === "select" && c.multiple ? o("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", l) : o("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", l));
      }
    }
    var mp = function() {
    };
    {
      var $i = {}, kv = /^on./, G0 = /^on[^A-Z]/, Vh = new RegExp("^(aria)-[" + Mt + "]*$"), lc = new RegExp("^(aria)[A-Z][" + Mt + "]*$");
      mp = function(l, c, g, y) {
        if (st.call($i, c) && $i[c])
          return !0;
        var T = c.toLowerCase();
        if (T === "onfocusin" || T === "onfocusout")
          return o("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), $i[c] = !0, !0;
        if (y != null) {
          var R = y.registrationNameDependencies, $ = y.possibleRegistrationNames;
          if (R.hasOwnProperty(c))
            return !0;
          var W = $.hasOwnProperty(T) ? $[T] : null;
          if (W != null)
            return o("Invalid event handler property `%s`. Did you mean `%s`?", c, W), $i[c] = !0, !0;
          if (kv.test(c))
            return o("Unknown event handler property `%s`. It will be ignored.", c), $i[c] = !0, !0;
        } else if (kv.test(c))
          return G0.test(c) && o("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", c), $i[c] = !0, !0;
        if (Vh.test(c) || lc.test(c))
          return !0;
        if (T === "innerhtml")
          return o("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), $i[c] = !0, !0;
        if (T === "aria")
          return o("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), $i[c] = !0, !0;
        if (T === "is" && g !== null && g !== void 0 && typeof g != "string")
          return o("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof g), $i[c] = !0, !0;
        if (typeof g == "number" && isNaN(g))
          return o("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", c), $i[c] = !0, !0;
        var G = br(c), ae = G !== null && G.type === Ut;
        if (bg.hasOwnProperty(T)) {
          var me = bg[T];
          if (me !== c)
            return o("Invalid DOM property `%s`. Did you mean `%s`?", c, me), $i[c] = !0, !0;
        } else if (!ae && c !== T)
          return o("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", c, T), $i[c] = !0, !0;
        return typeof g == "boolean" && En(c, g, G, !1) ? (g ? o('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', g, c, c, g, c) : o('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', g, c, c, g, c, c, c), $i[c] = !0, !0) : ae ? !0 : En(c, g, G, !1) ? ($i[c] = !0, !1) : ((g === "false" || g === "true") && G !== null && G.type === Ie && (o("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", g, c, g === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', c, g), $i[c] = !0), !0);
      };
    }
    var Yh = function(l, c, g) {
      {
        var y = [];
        for (var T in c) {
          var R = mp(l, T, c[T], g);
          R || y.push(T);
        }
        var $ = y.map(function(W) {
          return "`" + W + "`";
        }).join(", ");
        y.length === 1 ? o("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", $, l) : y.length > 1 && o("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", $, l);
      }
    };
    function Rv(l, c, g) {
      Ql(l, c) || Yh(l, c, g);
    }
    var ll = 1, gp = 2, Xc = 4, yg = ll | gp | Xc, bp = null;
    function uc(l) {
      bp !== null && o("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."), bp = l;
    }
    function sd() {
      bp === null && o("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."), bp = null;
    }
    function Zh(l) {
      return l === bp;
    }
    function Og(l) {
      var c = l.target || l.srcElement || window;
      return c.correspondingUseElement && (c = c.correspondingUseElement), c.nodeType === Tu ? c.parentNode : c;
    }
    var ca = null, qc = null, ul = null;
    function cc(l) {
      var c = Vt(l);
      if (c) {
        if (typeof ca != "function")
          throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var g = c.stateNode;
        if (g) {
          var y = $n(g);
          ca(c.stateNode, c.type, y);
        }
      }
    }
    function Eg(l) {
      ca = l;
    }
    function Sg(l) {
      qc ? ul ? ul.push(l) : ul = [l] : qc = l;
    }
    function vp() {
      return qc !== null || ul !== null;
    }
    function Xh() {
      if (qc) {
        var l = qc, c = ul;
        if (qc = null, ul = null, cc(l), c)
          for (var g = 0; g < c.length; g++)
            cc(c[g]);
      }
    }
    var ld = function(l, c) {
      return l(c);
    }, li = function() {
    }, Bi = !1;
    function L1() {
      var l = vp();
      l && (li(), Xh());
    }
    function Iv(l, c, g) {
      if (Bi)
        return l(c, g);
      Bi = !0;
      try {
        return ld(l, c, g);
      } finally {
        Bi = !1, L1();
      }
    }
    function qh(l, c, g) {
      ld = l, li = g;
    }
    function wg(l) {
      return l === "button" || l === "input" || l === "select" || l === "textarea";
    }
    function Kh(l, c, g) {
      switch (l) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          return !!(g.disabled && wg(c));
        default:
          return !1;
      }
    }
    function jl(l, c) {
      var g = l.stateNode;
      if (g === null)
        return null;
      var y = $n(g);
      if (y === null)
        return null;
      var T = y[c];
      if (Kh(c, l.type, y))
        return null;
      if (T && typeof T != "function")
        throw new Error("Expected `" + c + "` listener to be a function, instead got a value of `" + typeof T + "` type.");
      return T;
    }
    var ud = !1;
    if (lt)
      try {
        var cl = {};
        Object.defineProperty(cl, "passive", {
          get: function() {
            ud = !0;
          }
        }), window.addEventListener("test", cl, cl), window.removeEventListener("test", cl, cl);
      } catch {
        ud = !1;
      }
    function yp(l, c, g, y, T, R, $, W, G) {
      var ae = Array.prototype.slice.call(arguments, 3);
      try {
        c.apply(g, ae);
      } catch (me) {
        this.onError(me);
      }
    }
    var cd = yp;
    if (typeof window < "u" && typeof window.dispatchEvent == "function" && typeof document < "u" && typeof document.createEvent == "function") {
      var Op = document.createElement("react");
      cd = function(c, g, y, T, R, $, W, G, ae) {
        if (typeof document > "u" || document === null)
          throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
        var me = document.createEvent("Event"), Ue = !1, $e = !0, tt = window.event, rt = Object.getOwnPropertyDescriptor(window, "event");
        function pt() {
          Op.removeEventListener(ht, Pn, !1), typeof window.event < "u" && window.hasOwnProperty("event") && (window.event = tt);
        }
        var on = Array.prototype.slice.call(arguments, 3);
        function Pn() {
          Ue = !0, pt(), g.apply(y, on), $e = !1;
        }
        var Tn, Dr = !1, wr = !1;
        function qe(Ke) {
          if (Tn = Ke.error, Dr = !0, Tn === null && Ke.colno === 0 && Ke.lineno === 0 && (wr = !0), Ke.defaultPrevented && Tn != null && typeof Tn == "object")
            try {
              Tn._suppressLogging = !0;
            } catch {
            }
        }
        var ht = "react-" + (c || "invokeguardedcallback");
        if (window.addEventListener("error", qe), Op.addEventListener(ht, Pn, !1), me.initEvent(ht, !1, !1), Op.dispatchEvent(me), rt && Object.defineProperty(window, "event", rt), Ue && $e && (Dr ? wr && (Tn = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : Tn = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError(Tn)), window.removeEventListener("error", qe), !Ue)
          return pt(), yp.apply(this, arguments);
      };
    }
    var Ep = cd, Kc = !1, Gl = null, Jh = !1, Jc = null, Cu = {
      onError: function(l) {
        Kc = !0, Gl = l;
      }
    };
    function xu(l, c, g, y, T, R, $, W, G) {
      Kc = !1, Gl = null, Ep.apply(Cu, arguments);
    }
    function ks(l, c, g, y, T, R, $, W, G) {
      if (xu.apply(this, arguments), Kc) {
        var ae = ef();
        Jh || (Jh = !0, Jc = ae);
      }
    }
    function Tg() {
      if (Jh) {
        var l = Jc;
        throw Jh = !1, Jc = null, l;
      }
    }
    function re() {
      return Kc;
    }
    function ef() {
      if (Kc) {
        var l = Gl;
        return Kc = !1, Gl = null, l;
      } else
        throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    function Mo(l) {
      return l._reactInternals;
    }
    function Oo(l) {
      return l._reactInternals !== void 0;
    }
    function ar(l, c) {
      l._reactInternals = c;
    }
    var xn = (
      /*                      */
      0
    ), tf = (
      /*                */
      1
    ), _a = (
      /*                    */
      2
    ), Un = (
      /*                       */
      4
    ), Wr = (
      /*                */
      16
    ), Vr = (
      /*                 */
      32
    ), Au = (
      /*                     */
      64
    ), Wn = (
      /*                   */
      128
    ), Xa = (
      /*            */
      256
    ), qa = (
      /*                          */
      512
    ), fl = (
      /*                     */
      1024
    ), ka = (
      /*                      */
      2048
    ), dl = (
      /*                    */
      4096
    ), nf = (
      /*                   */
      8192
    ), em = (
      /*             */
      16384
    ), pl = ka | Un | Au | qa | fl | em, V0 = (
      /*               */
      32767
    ), Rs = (
      /*                   */
      32768
    ), Ui = (
      /*                */
      65536
    ), tm = (
      /* */
      131072
    ), Dv = (
      /*                       */
      1048576
    ), fc = (
      /*                    */
      2097152
    ), is = (
      /*                 */
      4194304
    ), rf = (
      /*                */
      8388608
    ), Ra = (
      /*               */
      16777216
    ), fd = (
      /*              */
      33554432
    ), Sp = (
      // TODO: Remove Update flag from before mutation phase by re-landing Visibility
      // flag logic (see #20043)
      Un | fl | 0
    ), os = _a | Un | Wr | Vr | qa | dl | nf, Eo = Un | Au | qa | nf, hl = ka | Wr, zi = is | rf | fc, ku = n.ReactCurrentOwner;
    function Is(l) {
      var c = l, g = l;
      if (l.alternate)
        for (; c.return; )
          c = c.return;
      else {
        var y = c;
        do
          c = y, (c.flags & (_a | dl)) !== xn && (g = c.return), y = c.return;
        while (y);
      }
      return c.tag === m ? g : null;
    }
    function Nv(l) {
      if (l.tag === D) {
        var c = l.memoizedState;
        if (c === null) {
          var g = l.alternate;
          g !== null && (c = g.memoizedState);
        }
        if (c !== null)
          return c.dehydrated;
      }
      return null;
    }
    function wp(l) {
      return l.tag === m ? l.stateNode.containerInfo : null;
    }
    function dd(l) {
      return Is(l) === l;
    }
    function So(l) {
      {
        var c = ku.current;
        if (c !== null && c.tag === f) {
          var g = c, y = g.stateNode;
          y._warnedAboutRefsInRender || o("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", Bn(g) || "A component"), y._warnedAboutRefsInRender = !0;
        }
      }
      var T = Mo(l);
      return T ? Is(T) === T : !1;
    }
    function ss(l) {
      if (Is(l) !== l)
        throw new Error("Unable to find node on an unmounted component.");
    }
    function ga(l) {
      var c = l.alternate;
      if (!c) {
        var g = Is(l);
        if (g === null)
          throw new Error("Unable to find node on an unmounted component.");
        return g !== l ? null : l;
      }
      for (var y = l, T = c; ; ) {
        var R = y.return;
        if (R === null)
          break;
        var $ = R.alternate;
        if ($ === null) {
          var W = R.return;
          if (W !== null) {
            y = T = W;
            continue;
          }
          break;
        }
        if (R.child === $.child) {
          for (var G = R.child; G; ) {
            if (G === y)
              return ss(R), l;
            if (G === T)
              return ss(R), c;
            G = G.sibling;
          }
          throw new Error("Unable to find node on an unmounted component.");
        }
        if (y.return !== T.return)
          y = R, T = $;
        else {
          for (var ae = !1, me = R.child; me; ) {
            if (me === y) {
              ae = !0, y = R, T = $;
              break;
            }
            if (me === T) {
              ae = !0, T = R, y = $;
              break;
            }
            me = me.sibling;
          }
          if (!ae) {
            for (me = $.child; me; ) {
              if (me === y) {
                ae = !0, y = $, T = R;
                break;
              }
              if (me === T) {
                ae = !0, T = $, y = R;
                break;
              }
              me = me.sibling;
            }
            if (!ae)
              throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
          }
        }
        if (y.alternate !== T)
          throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
      }
      if (y.tag !== m)
        throw new Error("Unable to find node on an unmounted component.");
      return y.stateNode.current === y ? l : c;
    }
    function ml(l) {
      var c = ga(l);
      return c !== null ? Vl(c) : null;
    }
    function Vl(l) {
      if (l.tag === O || l.tag === w)
        return l;
      for (var c = l.child; c !== null; ) {
        var g = Vl(c);
        if (g !== null)
          return g;
        c = c.sibling;
      }
      return null;
    }
    function _g(l) {
      var c = ga(l);
      return c !== null ? Ru(c) : null;
    }
    function Ru(l) {
      if (l.tag === O || l.tag === w)
        return l;
      for (var c = l.child; c !== null; ) {
        if (c.tag !== v) {
          var g = Ru(c);
          if (g !== null)
            return g;
        }
        c = c.sibling;
      }
      return null;
    }
    var Fo = e.unstable_scheduleCallback, Y0 = e.unstable_cancelCallback, nm = e.unstable_shouldYield, Pv = e.unstable_requestPaint, fa = e.unstable_now, Iu = e.unstable_getCurrentPriorityLevel, rm = e.unstable_ImmediatePriority, Ds = e.unstable_UserBlockingPriority, Ns = e.unstable_NormalPriority, Cg = e.unstable_LowPriority, dc = e.unstable_IdlePriority, Ti = e.unstable_yieldValue, am = e.unstable_setDisableYieldValue, pc = null, da = null, Gt = null, Ia = !1, za = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u";
    function xg(l) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u")
        return !1;
      var c = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (c.isDisabled)
        return !0;
      if (!c.supportsFiber)
        return o("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools"), !0;
      try {
        j && (l = fn({}, l, {
          getLaneLabelMap: of,
          injectProfilingHooks: Zl
        })), pc = c.inject(l), da = c;
      } catch (g) {
        o("React instrumentation encountered an error: %s.", g);
      }
      return !!c.checkDCE;
    }
    function wo(l, c) {
      if (da && typeof da.onScheduleFiberRoot == "function")
        try {
          da.onScheduleFiberRoot(pc, l, c);
        } catch (g) {
          Ia || (Ia = !0, o("React instrumentation encountered an error: %s", g));
        }
    }
    function Yl(l, c) {
      if (da && typeof da.onCommitFiberRoot == "function")
        try {
          var g = (l.current.flags & Wn) === Wn;
          if (K) {
            var y;
            switch (c) {
              case Hi:
                y = rm;
                break;
              case Wi:
                y = Ds;
                break;
              case La:
                y = Ns;
                break;
              case ym:
                y = dc;
                break;
              default:
                y = Ns;
                break;
            }
            da.onCommitFiberRoot(pc, l, y, g);
          }
        } catch (T) {
          Ia || (Ia = !0, o("React instrumentation encountered an error: %s", T));
        }
    }
    function af(l) {
      if (da && typeof da.onPostCommitFiberRoot == "function")
        try {
          da.onPostCommitFiberRoot(pc, l);
        } catch (c) {
          Ia || (Ia = !0, o("React instrumentation encountered an error: %s", c));
        }
    }
    function Lv(l) {
      if (da && typeof da.onCommitFiberUnmount == "function")
        try {
          da.onCommitFiberUnmount(pc, l);
        } catch (c) {
          Ia || (Ia = !0, o("React instrumentation encountered an error: %s", c));
        }
    }
    function _i(l) {
      if (typeof Ti == "function" && (am(l), a(l)), da && typeof da.setStrictMode == "function")
        try {
          da.setStrictMode(pc, l);
        } catch (c) {
          Ia || (Ia = !0, o("React instrumentation encountered an error: %s", c));
        }
    }
    function Zl(l) {
      Gt = l;
    }
    function of() {
      {
        for (var l = /* @__PURE__ */ new Map(), c = 1, g = 0; g < Ca; g++) {
          var y = M1(c);
          l.set(c, y), c *= 2;
        }
        return l;
      }
    }
    function sf(l) {
      Gt !== null && typeof Gt.markCommitStarted == "function" && Gt.markCommitStarted(l);
    }
    function Ag() {
      Gt !== null && typeof Gt.markCommitStopped == "function" && Gt.markCommitStopped();
    }
    function lf(l) {
      Gt !== null && typeof Gt.markComponentRenderStarted == "function" && Gt.markComponentRenderStarted(l);
    }
    function pd() {
      Gt !== null && typeof Gt.markComponentRenderStopped == "function" && Gt.markComponentRenderStopped();
    }
    function Tp(l) {
      Gt !== null && typeof Gt.markComponentPassiveEffectMountStarted == "function" && Gt.markComponentPassiveEffectMountStarted(l);
    }
    function Mv() {
      Gt !== null && typeof Gt.markComponentPassiveEffectMountStopped == "function" && Gt.markComponentPassiveEffectMountStopped();
    }
    function kg(l) {
      Gt !== null && typeof Gt.markComponentPassiveEffectUnmountStarted == "function" && Gt.markComponentPassiveEffectUnmountStarted(l);
    }
    function Rg() {
      Gt !== null && typeof Gt.markComponentPassiveEffectUnmountStopped == "function" && Gt.markComponentPassiveEffectUnmountStopped();
    }
    function Fv(l) {
      Gt !== null && typeof Gt.markComponentLayoutEffectMountStarted == "function" && Gt.markComponentLayoutEffectMountStarted(l);
    }
    function Z0() {
      Gt !== null && typeof Gt.markComponentLayoutEffectMountStopped == "function" && Gt.markComponentLayoutEffectMountStopped();
    }
    function Ig(l) {
      Gt !== null && typeof Gt.markComponentLayoutEffectUnmountStarted == "function" && Gt.markComponentLayoutEffectUnmountStarted(l);
    }
    function _p() {
      Gt !== null && typeof Gt.markComponentLayoutEffectUnmountStopped == "function" && Gt.markComponentLayoutEffectUnmountStopped();
    }
    function im(l, c, g) {
      Gt !== null && typeof Gt.markComponentErrored == "function" && Gt.markComponentErrored(l, c, g);
    }
    function Dg(l, c, g) {
      Gt !== null && typeof Gt.markComponentSuspended == "function" && Gt.markComponentSuspended(l, c, g);
    }
    function X0(l) {
      Gt !== null && typeof Gt.markLayoutEffectsStarted == "function" && Gt.markLayoutEffectsStarted(l);
    }
    function uf() {
      Gt !== null && typeof Gt.markLayoutEffectsStopped == "function" && Gt.markLayoutEffectsStopped();
    }
    function $v(l) {
      Gt !== null && typeof Gt.markPassiveEffectsStarted == "function" && Gt.markPassiveEffectsStarted(l);
    }
    function Cp() {
      Gt !== null && typeof Gt.markPassiveEffectsStopped == "function" && Gt.markPassiveEffectsStopped();
    }
    function gl(l) {
      Gt !== null && typeof Gt.markRenderStarted == "function" && Gt.markRenderStarted(l);
    }
    function cf() {
      Gt !== null && typeof Gt.markRenderYielded == "function" && Gt.markRenderYielded();
    }
    function xp() {
      Gt !== null && typeof Gt.markRenderStopped == "function" && Gt.markRenderStopped();
    }
    function ff(l) {
      Gt !== null && typeof Gt.markRenderScheduled == "function" && Gt.markRenderScheduled(l);
    }
    function Ng(l, c) {
      Gt !== null && typeof Gt.markForceUpdateScheduled == "function" && Gt.markForceUpdateScheduled(l, c);
    }
    function df(l, c) {
      Gt !== null && typeof Gt.markStateUpdateScheduled == "function" && Gt.markStateUpdateScheduled(l, c);
    }
    var In = (
      /*                         */
      0
    ), cr = (
      /*                 */
      1
    ), Dn = (
      /*                    */
      2
    ), Da = (
      /*               */
      8
    ), ls = (
      /*              */
      16
    ), Pg = Math.clz32 ? Math.clz32 : hd, Ap = Math.log, ir = Math.LN2;
    function hd(l) {
      var c = l >>> 0;
      return c === 0 ? 32 : 31 - (Ap(c) / ir | 0) | 0;
    }
    var Ca = 31, ct = (
      /*                        */
      0
    ), vr = (
      /*                          */
      0
    ), Fn = (
      /*                        */
      1
    ), Du = (
      /*    */
      2
    ), Na = (
      /*             */
      4
    ), md = (
      /*            */
      8
    ), aa = (
      /*                     */
      16
    ), hc = (
      /*                */
      32
    ), mc = (
      /*                       */
      4194240
    ), pf = (
      /*                        */
      64
    ), Pa = (
      /*                        */
      128
    ), ui = (
      /*                        */
      256
    ), gc = (
      /*                        */
      512
    ), kp = (
      /*                        */
      1024
    ), hf = (
      /*                        */
      2048
    ), om = (
      /*                        */
      4096
    ), Rp = (
      /*                        */
      8192
    ), sm = (
      /*                        */
      16384
    ), Ip = (
      /*                       */
      32768
    ), Dp = (
      /*                       */
      65536
    ), Xl = (
      /*                       */
      131072
    ), Lg = (
      /*                       */
      262144
    ), ql = (
      /*                       */
      524288
    ), mf = (
      /*                       */
      1048576
    ), lm = (
      /*                       */
      2097152
    ), bc = (
      /*                            */
      130023424
    ), vc = (
      /*                             */
      4194304
    ), Mg = (
      /*                             */
      8388608
    ), um = (
      /*                             */
      16777216
    ), cm = (
      /*                             */
      33554432
    ), fm = (
      /*                             */
      67108864
    ), Bv = vc, gd = (
      /*          */
      134217728
    ), dm = (
      /*                          */
      268435455
    ), Ci = (
      /*               */
      268435456
    ), ao = (
      /*                        */
      536870912
    ), us = (
      /*                   */
      1073741824
    );
    function M1(l) {
      {
        if (l & Fn)
          return "Sync";
        if (l & Du)
          return "InputContinuousHydration";
        if (l & Na)
          return "InputContinuous";
        if (l & md)
          return "DefaultHydration";
        if (l & aa)
          return "Default";
        if (l & hc)
          return "TransitionHydration";
        if (l & mc)
          return "Transition";
        if (l & bc)
          return "Retry";
        if (l & gd)
          return "SelectiveHydration";
        if (l & Ci)
          return "IdleHydration";
        if (l & ao)
          return "Idle";
        if (l & us)
          return "Offscreen";
      }
    }
    var Yr = -1, yc = pf, pm = vc;
    function bd(l) {
      switch (Ka(l)) {
        case Fn:
          return Fn;
        case Du:
          return Du;
        case Na:
          return Na;
        case md:
          return md;
        case aa:
          return aa;
        case hc:
          return hc;
        case pf:
        case Pa:
        case ui:
        case gc:
        case kp:
        case hf:
        case om:
        case Rp:
        case sm:
        case Ip:
        case Dp:
        case Xl:
        case Lg:
        case ql:
        case mf:
        case lm:
          return l & mc;
        case vc:
        case Mg:
        case um:
        case cm:
        case fm:
          return l & bc;
        case gd:
          return gd;
        case Ci:
          return Ci;
        case ao:
          return ao;
        case us:
          return us;
        default:
          return o("Should have found matching lanes. This is a bug in React."), l;
      }
    }
    function hm(l, c) {
      var g = l.pendingLanes;
      if (g === ct)
        return ct;
      var y = ct, T = l.suspendedLanes, R = l.pingedLanes, $ = g & dm;
      if ($ !== ct) {
        var W = $ & ~T;
        if (W !== ct)
          y = bd(W);
        else {
          var G = $ & R;
          G !== ct && (y = bd(G));
        }
      } else {
        var ae = g & ~T;
        ae !== ct ? y = bd(ae) : R !== ct && (y = bd(R));
      }
      if (y === ct)
        return ct;
      if (c !== ct && c !== y && // If we already suspended with a delay, then interrupting is fine. Don't
      // bother waiting until the root is complete.
      (c & T) === ct) {
        var me = Ka(y), Ue = Ka(c);
        if (
          // Tests whether the next lane is equal or lower priority than the wip
          // one. This works because the bits decrease in priority as you go left.
          me >= Ue || // Default priority updates should not interrupt transition updates. The
          // only difference between default updates and transition updates is that
          // default updates do not support refresh transitions.
          me === aa && (Ue & mc) !== ct
        )
          return c;
      }
      (y & Na) !== ct && (y |= g & aa);
      var $e = l.entangledLanes;
      if ($e !== ct)
        for (var tt = l.entanglements, rt = y & $e; rt > 0; ) {
          var pt = Ec(rt), on = 1 << pt;
          y |= tt[pt], rt &= ~on;
        }
      return y;
    }
    function Uv(l, c) {
      for (var g = l.eventTimes, y = Yr; c > 0; ) {
        var T = Ec(c), R = 1 << T, $ = g[T];
        $ > y && (y = $), c &= ~R;
      }
      return y;
    }
    function Oc(l, c) {
      switch (l) {
        case Fn:
        case Du:
        case Na:
          return c + 250;
        case md:
        case aa:
        case hc:
        case pf:
        case Pa:
        case ui:
        case gc:
        case kp:
        case hf:
        case om:
        case Rp:
        case sm:
        case Ip:
        case Dp:
        case Xl:
        case Lg:
        case ql:
        case mf:
        case lm:
          return c + 5e3;
        case vc:
        case Mg:
        case um:
        case cm:
        case fm:
          return Yr;
        case gd:
        case Ci:
        case ao:
        case us:
          return Yr;
        default:
          return o("Should have found matching lanes. This is a bug in React."), Yr;
      }
    }
    function mm(l, c) {
      for (var g = l.pendingLanes, y = l.suspendedLanes, T = l.pingedLanes, R = l.expirationTimes, $ = g; $ > 0; ) {
        var W = Ec($), G = 1 << W, ae = R[W];
        ae === Yr ? ((G & y) === ct || (G & T) !== ct) && (R[W] = Oc(G, c)) : ae <= c && (l.expiredLanes |= G), $ &= ~G;
      }
    }
    function F1(l) {
      return bd(l.pendingLanes);
    }
    function Fg(l) {
      var c = l.pendingLanes & ~us;
      return c !== ct ? c : c & us ? us : ct;
    }
    function vd(l) {
      return (l & Fn) !== ct;
    }
    function gf(l) {
      return (l & dm) !== ct;
    }
    function gm(l) {
      return (l & bc) === l;
    }
    function $g(l) {
      var c = Fn | Na | aa;
      return (l & c) === ct;
    }
    function Bg(l) {
      return (l & mc) === l;
    }
    function bf(l, c) {
      var g = Du | Na | md | aa;
      return (c & g) !== ct;
    }
    function q0(l, c) {
      return (c & l.expiredLanes) !== ct;
    }
    function Ug(l) {
      return (l & mc) !== ct;
    }
    function Np() {
      var l = yc;
      return yc <<= 1, (yc & mc) === ct && (yc = pf), l;
    }
    function K0() {
      var l = pm;
      return pm <<= 1, (pm & bc) === ct && (pm = vc), l;
    }
    function Ka(l) {
      return l & -l;
    }
    function xi(l) {
      return Ka(l);
    }
    function Ec(l) {
      return 31 - Pg(l);
    }
    function bl(l) {
      return Ec(l);
    }
    function $o(l, c) {
      return (l & c) !== ct;
    }
    function vf(l, c) {
      return (l & c) === c;
    }
    function er(l, c) {
      return l | c;
    }
    function yd(l, c) {
      return l & ~c;
    }
    function zv(l, c) {
      return l & c;
    }
    function J0(l) {
      return l;
    }
    function Nu(l, c) {
      return l !== vr && l < c ? l : c;
    }
    function Pp(l) {
      for (var c = [], g = 0; g < Ca; g++)
        c.push(l);
      return c;
    }
    function Sc(l, c, g) {
      l.pendingLanes |= c, c !== ao && (l.suspendedLanes = ct, l.pingedLanes = ct);
      var y = l.eventTimes, T = bl(c);
      y[T] = g;
    }
    function bm(l, c) {
      l.suspendedLanes |= c, l.pingedLanes &= ~c;
      for (var g = l.expirationTimes, y = c; y > 0; ) {
        var T = Ec(y), R = 1 << T;
        g[T] = Yr, y &= ~R;
      }
    }
    function Lp(l, c, g) {
      l.pingedLanes |= l.suspendedLanes & c;
    }
    function yf(l, c) {
      var g = l.pendingLanes & ~c;
      l.pendingLanes = c, l.suspendedLanes = ct, l.pingedLanes = ct, l.expiredLanes &= c, l.mutableReadLanes &= c, l.entangledLanes &= c;
      for (var y = l.entanglements, T = l.eventTimes, R = l.expirationTimes, $ = g; $ > 0; ) {
        var W = Ec($), G = 1 << W;
        y[W] = ct, T[W] = Yr, R[W] = Yr, $ &= ~G;
      }
    }
    function Cn(l, c) {
      for (var g = l.entangledLanes |= c, y = l.entanglements, T = g; T; ) {
        var R = Ec(T), $ = 1 << R;
        // Is this one of the newly entangled lanes?
        $ & c | // Is this lane transitively entangled with the newly entangled lanes?
        y[R] & c && (y[R] |= c), T &= ~$;
      }
    }
    function zg(l, c) {
      var g = Ka(c), y;
      switch (g) {
        case Na:
          y = Du;
          break;
        case aa:
          y = md;
          break;
        case pf:
        case Pa:
        case ui:
        case gc:
        case kp:
        case hf:
        case om:
        case Rp:
        case sm:
        case Ip:
        case Dp:
        case Xl:
        case Lg:
        case ql:
        case mf:
        case lm:
        case vc:
        case Mg:
        case um:
        case cm:
        case fm:
          y = hc;
          break;
        case ao:
          y = Ci;
          break;
        default:
          y = vr;
          break;
      }
      return (y & (l.suspendedLanes | c)) !== vr ? vr : y;
    }
    function vm(l, c, g) {
      if (za)
        for (var y = l.pendingUpdatersLaneMap; g > 0; ) {
          var T = bl(g), R = 1 << T, $ = y[T];
          $.add(c), g &= ~R;
        }
    }
    function Pu(l, c) {
      if (za)
        for (var g = l.pendingUpdatersLaneMap, y = l.memoizedUpdaters; c > 0; ) {
          var T = bl(c), R = 1 << T, $ = g[T];
          $.size > 0 && ($.forEach(function(W) {
            var G = W.alternate;
            (G === null || !y.has(G)) && y.add(W);
          }), $.clear()), c &= ~R;
        }
    }
    function Hv(l, c) {
      return null;
    }
    var Hi = Fn, Wi = Na, La = aa, ym = ao, Od = vr;
    function Ps() {
      return Od;
    }
    function Ai(l) {
      Od = l;
    }
    function Mp(l, c) {
      var g = Od;
      try {
        return Od = l, c();
      } finally {
        Od = g;
      }
    }
    function To(l, c) {
      return l !== 0 && l < c ? l : c;
    }
    function $1(l, c) {
      return l === 0 || l > c ? l : c;
    }
    function Wv(l, c) {
      return l !== 0 && l < c;
    }
    function Ls(l) {
      var c = Ka(l);
      return Wv(Hi, c) ? Wv(Wi, c) ? gf(c) ? La : ym : Wi : Hi;
    }
    function kr(l) {
      var c = l.current.memoizedState;
      return c.isDehydrated;
    }
    var Hg;
    function un(l) {
      Hg = l;
    }
    function Of(l) {
      Hg(l);
    }
    var Om;
    function eO(l) {
      Om = l;
    }
    var Fp;
    function $p(l) {
      Fp = l;
    }
    var Bp;
    function Qv(l) {
      Bp = l;
    }
    var jv;
    function tO(l) {
      jv = l;
    }
    var Wg = !1, Ed = [], Kl = null, Ma = null, bi = null, Ms = /* @__PURE__ */ new Map(), Lu = /* @__PURE__ */ new Map(), Jl = [], vl = [
      "mousedown",
      "mouseup",
      "touchcancel",
      "touchend",
      "touchstart",
      "auxclick",
      "dblclick",
      "pointercancel",
      "pointerdown",
      "pointerup",
      "dragend",
      "dragstart",
      "drop",
      "compositionend",
      "compositionstart",
      "keydown",
      "keypress",
      "keyup",
      "input",
      "textInput",
      // Intentionally camelCase
      "copy",
      "cut",
      "paste",
      "click",
      "change",
      "contextmenu",
      "reset",
      "submit"
    ];
    function Gv(l) {
      return vl.indexOf(l) > -1;
    }
    function Fs(l, c, g, y, T) {
      return {
        blockedOn: l,
        domEventName: c,
        eventSystemFlags: g,
        nativeEvent: T,
        targetContainers: [y]
      };
    }
    function Vv(l, c) {
      switch (l) {
        case "focusin":
        case "focusout":
          Kl = null;
          break;
        case "dragenter":
        case "dragleave":
          Ma = null;
          break;
        case "mouseover":
        case "mouseout":
          bi = null;
          break;
        case "pointerover":
        case "pointerout": {
          var g = c.pointerId;
          Ms.delete(g);
          break;
        }
        case "gotpointercapture":
        case "lostpointercapture": {
          var y = c.pointerId;
          Lu.delete(y);
          break;
        }
      }
    }
    function Bo(l, c, g, y, T, R) {
      if (l === null || l.nativeEvent !== R) {
        var $ = Fs(c, g, y, T, R);
        if (c !== null) {
          var W = Vt(c);
          W !== null && Om(W);
        }
        return $;
      }
      l.eventSystemFlags |= y;
      var G = l.targetContainers;
      return T !== null && G.indexOf(T) === -1 && G.push(T), l;
    }
    function Ef(l, c, g, y, T) {
      switch (c) {
        case "focusin": {
          var R = T;
          return Kl = Bo(Kl, l, c, g, y, R), !0;
        }
        case "dragenter": {
          var $ = T;
          return Ma = Bo(Ma, l, c, g, y, $), !0;
        }
        case "mouseover": {
          var W = T;
          return bi = Bo(bi, l, c, g, y, W), !0;
        }
        case "pointerover": {
          var G = T, ae = G.pointerId;
          return Ms.set(ae, Bo(Ms.get(ae) || null, l, c, g, y, G)), !0;
        }
        case "gotpointercapture": {
          var me = T, Ue = me.pointerId;
          return Lu.set(Ue, Bo(Lu.get(Ue) || null, l, c, g, y, me)), !0;
        }
      }
      return !1;
    }
    function Yv(l) {
      var c = _t(l.target);
      if (c !== null) {
        var g = Is(c);
        if (g !== null) {
          var y = g.tag;
          if (y === D) {
            var T = Nv(g);
            if (T !== null) {
              l.blockedOn = T, jv(l.priority, function() {
                Fp(g);
              });
              return;
            }
          } else if (y === m) {
            var R = g.stateNode;
            if (kr(R)) {
              l.blockedOn = wp(g);
              return;
            }
          }
        }
      }
      l.blockedOn = null;
    }
    function Zv(l) {
      for (var c = Bp(), g = {
        blockedOn: null,
        target: l,
        priority: c
      }, y = 0; y < Jl.length && Wv(c, Jl[y].priority); y++)
        ;
      Jl.splice(y, 0, g), y === 0 && Yv(g);
    }
    function Qg(l) {
      if (l.blockedOn !== null)
        return !1;
      for (var c = l.targetContainers; c.length > 0; ) {
        var g = c[0], y = Sd(l.domEventName, l.eventSystemFlags, g, l.nativeEvent);
        if (y === null) {
          var T = l.nativeEvent, R = new T.constructor(T.type, T);
          uc(R), T.target.dispatchEvent(R), sd();
        } else {
          var $ = Vt(y);
          return $ !== null && Om($), l.blockedOn = y, !1;
        }
        c.shift();
      }
      return !0;
    }
    function Em(l, c, g) {
      Qg(l) && g.delete(c);
    }
    function Xv() {
      Wg = !1, Kl !== null && Qg(Kl) && (Kl = null), Ma !== null && Qg(Ma) && (Ma = null), bi !== null && Qg(bi) && (bi = null), Ms.forEach(Em), Lu.forEach(Em);
    }
    function _o(l, c) {
      l.blockedOn === c && (l.blockedOn = null, Wg || (Wg = !0, e.unstable_scheduleCallback(e.unstable_NormalPriority, Xv)));
    }
    function mr(l) {
      if (Ed.length > 0) {
        _o(Ed[0], l);
        for (var c = 1; c < Ed.length; c++) {
          var g = Ed[c];
          g.blockedOn === l && (g.blockedOn = null);
        }
      }
      Kl !== null && _o(Kl, l), Ma !== null && _o(Ma, l), bi !== null && _o(bi, l);
      var y = function(W) {
        return _o(W, l);
      };
      Ms.forEach(y), Lu.forEach(y);
      for (var T = 0; T < Jl.length; T++) {
        var R = Jl[T];
        R.blockedOn === l && (R.blockedOn = null);
      }
      for (; Jl.length > 0; ) {
        var $ = Jl[0];
        if ($.blockedOn !== null)
          break;
        Yv($), $.blockedOn === null && Jl.shift();
      }
    }
    var Ha = n.ReactCurrentBatchConfig, Ja = !0;
    function Qi(l) {
      Ja = !!l;
    }
    function $s() {
      return Ja;
    }
    function Up(l, c, g) {
      var y = Uo(c), T;
      switch (y) {
        case Hi:
          T = ki;
          break;
        case Wi:
          T = zp;
          break;
        case La:
        default:
          T = Mu;
          break;
      }
      return T.bind(null, c, g, l);
    }
    function ki(l, c, g, y) {
      var T = Ps(), R = Ha.transition;
      Ha.transition = null;
      try {
        Ai(Hi), Mu(l, c, g, y);
      } finally {
        Ai(T), Ha.transition = R;
      }
    }
    function zp(l, c, g, y) {
      var T = Ps(), R = Ha.transition;
      Ha.transition = null;
      try {
        Ai(Wi), Mu(l, c, g, y);
      } finally {
        Ai(T), Ha.transition = R;
      }
    }
    function Mu(l, c, g, y) {
      Ja && Sm(l, c, g, y);
    }
    function Sm(l, c, g, y) {
      var T = Sd(l, c, g, y);
      if (T === null) {
        eS(l, c, y, Hp, g), Vv(l, y);
        return;
      }
      if (Ef(T, l, c, g, y)) {
        y.stopPropagation();
        return;
      }
      if (Vv(l, y), c & Xc && Gv(l)) {
        for (; T !== null; ) {
          var R = Vt(T);
          R !== null && Of(R);
          var $ = Sd(l, c, g, y);
          if ($ === null && eS(l, c, y, Hp, g), $ === T)
            break;
          T = $;
        }
        T !== null && y.stopPropagation();
        return;
      }
      eS(l, c, y, null, g);
    }
    var Hp = null;
    function Sd(l, c, g, y) {
      Hp = null;
      var T = Og(y), R = _t(T);
      if (R !== null) {
        var $ = Is(R);
        if ($ === null)
          R = null;
        else {
          var W = $.tag;
          if (W === D) {
            var G = Nv($);
            if (G !== null)
              return G;
            R = null;
          } else if (W === m) {
            var ae = $.stateNode;
            if (kr(ae))
              return wp($);
            R = null;
          } else
            $ !== R && (R = null);
        }
      }
      return Hp = R, null;
    }
    function Uo(l) {
      switch (l) {
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return Hi;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return Wi;
        case "message": {
          var c = Iu();
          switch (c) {
            case rm:
              return Hi;
            case Ds:
              return Wi;
            case Ns:
            case Cg:
              return La;
            case dc:
              return ym;
            default:
              return La;
          }
        }
        default:
          return La;
      }
    }
    function jg(l, c, g) {
      return l.addEventListener(c, g, !1), g;
    }
    function Wp(l, c, g) {
      return l.addEventListener(c, g, !0), g;
    }
    function wc(l, c, g, y) {
      return l.addEventListener(c, g, {
        capture: !0,
        passive: y
      }), g;
    }
    function Gg(l, c, g, y) {
      return l.addEventListener(c, g, {
        passive: y
      }), g;
    }
    var wd = null, Fu = null, Sf = null;
    function Ri(l) {
      return wd = l, Fu = Yg(), !0;
    }
    function Vg() {
      wd = null, Fu = null, Sf = null;
    }
    function Qp() {
      if (Sf)
        return Sf;
      var l, c = Fu, g = c.length, y, T = Yg(), R = T.length;
      for (l = 0; l < g && c[l] === T[l]; l++)
        ;
      var $ = g - l;
      for (y = 1; y <= $ && c[g - y] === T[R - y]; y++)
        ;
      var W = y > 1 ? 1 - y : void 0;
      return Sf = T.slice(l, W), Sf;
    }
    function Yg() {
      return "value" in wd ? wd.value : wd.textContent;
    }
    function wf(l) {
      var c, g = l.keyCode;
      return "charCode" in l ? (c = l.charCode, c === 0 && g === 13 && (c = 13)) : c = g, c === 10 && (c = 13), c >= 32 || c === 13 ? c : 0;
    }
    function Td() {
      return !0;
    }
    function Co() {
      return !1;
    }
    function yi(l) {
      function c(g, y, T, R, $) {
        this._reactName = g, this._targetInst = T, this.type = y, this.nativeEvent = R, this.target = $, this.currentTarget = null;
        for (var W in l)
          if (l.hasOwnProperty(W)) {
            var G = l[W];
            G ? this[W] = G(R) : this[W] = R[W];
          }
        var ae = R.defaultPrevented != null ? R.defaultPrevented : R.returnValue === !1;
        return ae ? this.isDefaultPrevented = Td : this.isDefaultPrevented = Co, this.isPropagationStopped = Co, this;
      }
      return fn(c.prototype, {
        preventDefault: function() {
          this.defaultPrevented = !0;
          var g = this.nativeEvent;
          g && (g.preventDefault ? g.preventDefault() : typeof g.returnValue != "unknown" && (g.returnValue = !1), this.isDefaultPrevented = Td);
        },
        stopPropagation: function() {
          var g = this.nativeEvent;
          g && (g.stopPropagation ? g.stopPropagation() : typeof g.cancelBubble != "unknown" && (g.cancelBubble = !0), this.isPropagationStopped = Td);
        },
        /**
         * We release all dispatched `SyntheticEvent`s after each event loop, adding
         * them back into the pool. This allows a way to hold onto a reference that
         * won't be added back into the pool.
         */
        persist: function() {
        },
        /**
         * Checks if this event should be released back into the pool.
         *
         * @return {boolean} True if this should not be released, false otherwise.
         */
        isPersistent: Td
      }), c;
    }
    var xo = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(l) {
        return l.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, ji = yi(xo), jp = fn({}, xo, {
      view: 0,
      detail: 0
    }), qv = yi(jp), wm, Kv, yl;
    function nO(l) {
      l !== yl && (yl && l.type === "mousemove" ? (wm = l.screenX - yl.screenX, Kv = l.screenY - yl.screenY) : (wm = 0, Kv = 0), yl = l);
    }
    var Gp = fn({}, jp, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: qg,
      button: 0,
      buttons: 0,
      relatedTarget: function(l) {
        return l.relatedTarget === void 0 ? l.fromElement === l.srcElement ? l.toElement : l.fromElement : l.relatedTarget;
      },
      movementX: function(l) {
        return "movementX" in l ? l.movementX : (nO(l), wm);
      },
      movementY: function(l) {
        return "movementY" in l ? l.movementY : Kv;
      }
    }), Tf = yi(Gp), Jv = fn({}, Gp, {
      dataTransfer: 0
    }), _d = yi(Jv), rO = fn({}, jp, {
      relatedTarget: 0
    }), Zg = yi(rO), ey = fn({}, xo, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), Xg = yi(ey), B1 = fn({}, xo, {
      clipboardData: function(l) {
        return "clipboardData" in l ? l.clipboardData : window.clipboardData;
      }
    }), U1 = yi(B1), aO = fn({}, xo, {
      data: 0
    }), ty = yi(aO), Cd = ty, z1 = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, _f = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    };
    function ny(l) {
      if (l.key) {
        var c = z1[l.key] || l.key;
        if (c !== "Unidentified")
          return c;
      }
      if (l.type === "keypress") {
        var g = wf(l);
        return g === 13 ? "Enter" : String.fromCharCode(g);
      }
      return l.type === "keydown" || l.type === "keyup" ? _f[l.keyCode] || "Unidentified" : "";
    }
    var ei = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
    function H1(l) {
      var c = this, g = c.nativeEvent;
      if (g.getModifierState)
        return g.getModifierState(l);
      var y = ei[l];
      return y ? !!g[y] : !1;
    }
    function qg(l) {
      return H1;
    }
    var W1 = fn({}, jp, {
      key: ny,
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: qg,
      // Legacy Interface
      charCode: function(l) {
        return l.type === "keypress" ? wf(l) : 0;
      },
      keyCode: function(l) {
        return l.type === "keydown" || l.type === "keyup" ? l.keyCode : 0;
      },
      which: function(l) {
        return l.type === "keypress" ? wf(l) : l.type === "keydown" || l.type === "keyup" ? l.keyCode : 0;
      }
    }), Q1 = yi(W1), iO = fn({}, Gp, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), ry = yi(iO), j1 = fn({}, jp, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: qg
    }), Bs = yi(j1), ay = fn({}, xo, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), Kg = yi(ay), Cf = fn({}, Gp, {
      deltaX: function(l) {
        return "deltaX" in l ? l.deltaX : (
          // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
          "wheelDeltaX" in l ? -l.wheelDeltaX : 0
        );
      },
      deltaY: function(l) {
        return "deltaY" in l ? l.deltaY : (
          // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
          "wheelDeltaY" in l ? -l.wheelDeltaY : (
            // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
            "wheelDelta" in l ? -l.wheelDelta : 0
          )
        );
      },
      deltaZ: 0,
      // Browsers without "deltaMode" is reporting in raw wheel delta where one
      // notch on the scroll is always +/- 120, roughly equivalent to pixels.
      // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
      // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
      deltaMode: 0
    }), Jg = yi(Cf), xd = [9, 13, 27, 32], Tm = 229, _m = lt && "CompositionEvent" in window, Ad = null;
    lt && "documentMode" in document && (Ad = document.documentMode);
    var G1 = lt && "TextEvent" in window && !Ad, eb = lt && (!_m || Ad && Ad > 8 && Ad <= 11), oO = 32, iy = String.fromCharCode(oO);
    function sO() {
      je("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), je("onCompositionEnd", ["compositionend", "focusout", "keydown", "keypress", "keyup", "mousedown"]), je("onCompositionStart", ["compositionstart", "focusout", "keydown", "keypress", "keyup", "mousedown"]), je("onCompositionUpdate", ["compositionupdate", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
    }
    var Cm = !1;
    function tb(l) {
      return (l.ctrlKey || l.altKey || l.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
      !(l.ctrlKey && l.altKey);
    }
    function lO(l) {
      switch (l) {
        case "compositionstart":
          return "onCompositionStart";
        case "compositionend":
          return "onCompositionEnd";
        case "compositionupdate":
          return "onCompositionUpdate";
      }
    }
    function oy(l, c) {
      return l === "keydown" && c.keyCode === Tm;
    }
    function uO(l, c) {
      switch (l) {
        case "keyup":
          return xd.indexOf(c.keyCode) !== -1;
        case "keydown":
          return c.keyCode !== Tm;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function nb(l) {
      var c = l.detail;
      return typeof c == "object" && "data" in c ? c.data : null;
    }
    function xm(l) {
      return l.locale === "ko";
    }
    var Tc = !1;
    function sy(l, c, g, y, T) {
      var R, $;
      if (_m ? R = lO(c) : Tc ? uO(c, y) && (R = "onCompositionEnd") : oy(c, y) && (R = "onCompositionStart"), !R)
        return null;
      eb && !xm(y) && (!Tc && R === "onCompositionStart" ? Tc = Ri(T) : R === "onCompositionEnd" && Tc && ($ = Qp()));
      var W = rr(g, R);
      if (W.length > 0) {
        var G = new ty(R, c, null, y, T);
        if (l.push({
          event: G,
          listeners: W
        }), $)
          G.data = $;
        else {
          var ae = nb(y);
          ae !== null && (G.data = ae);
        }
      }
    }
    function rb(l, c) {
      switch (l) {
        case "compositionend":
          return nb(c);
        case "keypress":
          var g = c.which;
          return g !== oO ? null : (Cm = !0, iy);
        case "textInput":
          var y = c.data;
          return y === iy && Cm ? null : y;
        default:
          return null;
      }
    }
    function cO(l, c) {
      if (Tc) {
        if (l === "compositionend" || !_m && uO(l, c)) {
          var g = Qp();
          return Vg(), Tc = !1, g;
        }
        return null;
      }
      switch (l) {
        case "paste":
          return null;
        case "keypress":
          if (!tb(c)) {
            if (c.char && c.char.length > 1)
              return c.char;
            if (c.which)
              return String.fromCharCode(c.which);
          }
          return null;
        case "compositionend":
          return eb && !xm(c) ? null : c.data;
        default:
          return null;
      }
    }
    function ab(l, c, g, y, T) {
      var R;
      if (G1 ? R = rb(c, y) : R = cO(c, y), !R)
        return null;
      var $ = rr(g, "onBeforeInput");
      if ($.length > 0) {
        var W = new Cd("onBeforeInput", "beforeinput", null, y, T);
        l.push({
          event: W,
          listeners: $
        }), W.data = R;
      }
    }
    function ib(l, c, g, y, T, R, $) {
      sy(l, c, g, y, T), ab(l, c, g, y, T);
    }
    var V1 = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    };
    function Vp(l) {
      var c = l && l.nodeName && l.nodeName.toLowerCase();
      return c === "input" ? !!V1[l.type] : c === "textarea";
    }
    /**
     * Checks if an event is supported in the current execution environment.
     *
     * NOTE: This will not work correctly for non-generic events such as `change`,
     * `reset`, `load`, `error`, and `select`.
     *
     * Borrows from Modernizr.
     *
     * @param {string} eventNameSuffix Event name, e.g. "click".
     * @return {boolean} True if the event is supported.
     * @internal
     * @license Modernizr 3.0.0pre (Custom Build) | MIT
     */
    function Y1(l) {
      if (!lt)
        return !1;
      var c = "on" + l, g = c in document;
      if (!g) {
        var y = document.createElement("div");
        y.setAttribute(c, "return;"), g = typeof y[c] == "function";
      }
      return g;
    }
    function ob() {
      je("onChange", ["change", "click", "focusin", "focusout", "input", "keydown", "keyup", "selectionchange"]);
    }
    function d(l, c, g, y) {
      Sg(y);
      var T = rr(c, "onChange");
      if (T.length > 0) {
        var R = new ji("onChange", "change", null, g, y);
        l.push({
          event: R,
          listeners: T
        });
      }
    }
    var h = null, S = null;
    function x(l) {
      var c = l.nodeName && l.nodeName.toLowerCase();
      return c === "select" || c === "input" && l.type === "file";
    }
    function F(l) {
      var c = [];
      d(c, S, l, Og(l)), Iv(U, c);
    }
    function U(l) {
      J1(l, 0);
    }
    function X(l) {
      var c = hn(l);
      if (F0(c))
        return l;
    }
    function Se(l, c) {
      if (l === "change")
        return c;
    }
    var Pe = !1;
    lt && (Pe = Y1("input") && (!document.documentMode || document.documentMode > 9));
    function nt(l, c) {
      h = l, S = c, h.attachEvent("onpropertychange", It);
    }
    function At() {
      h && (h.detachEvent("onpropertychange", It), h = null, S = null);
    }
    function It(l) {
      l.propertyName === "value" && X(S) && F(l);
    }
    function kt(l, c, g) {
      l === "focusin" ? (At(), nt(c, g)) : l === "focusout" && At();
    }
    function en(l, c) {
      if (l === "selectionchange" || l === "keyup" || l === "keydown")
        return X(S);
    }
    function dn(l) {
      var c = l.nodeName;
      return c && c.toLowerCase() === "input" && (l.type === "checkbox" || l.type === "radio");
    }
    function mn(l, c) {
      if (l === "click")
        return X(c);
    }
    function ci(l, c) {
      if (l === "input" || l === "change")
        return X(c);
    }
    function Ze(l) {
      var c = l._wrapperState;
      !c || !c.controlled || l.type !== "number" || ic(l, "number", l.value);
    }
    function Me(l, c, g, y, T, R, $) {
      var W = g ? hn(g) : window, G, ae;
      if (x(W) ? G = Se : Vp(W) ? Pe ? G = ci : (G = en, ae = kt) : dn(W) && (G = mn), G) {
        var me = G(c, g);
        if (me) {
          d(l, me, y, T);
          return;
        }
      }
      ae && ae(c, W, g), c === "focusout" && Ze(W);
    }
    function Xe() {
      we("onMouseEnter", ["mouseout", "mouseover"]), we("onMouseLeave", ["mouseout", "mouseover"]), we("onPointerEnter", ["pointerout", "pointerover"]), we("onPointerLeave", ["pointerout", "pointerover"]);
    }
    function Ft(l, c, g, y, T, R, $) {
      var W = c === "mouseover" || c === "pointerover", G = c === "mouseout" || c === "pointerout";
      if (W && !Zh(y)) {
        var ae = y.relatedTarget || y.fromElement;
        if (ae && (_t(ae) || Ot(ae)))
          return;
      }
      if (!(!G && !W)) {
        var me;
        if (T.window === T)
          me = T;
        else {
          var Ue = T.ownerDocument;
          Ue ? me = Ue.defaultView || Ue.parentWindow : me = window;
        }
        var $e, tt;
        if (G) {
          var rt = y.relatedTarget || y.toElement;
          if ($e = g, tt = rt ? _t(rt) : null, tt !== null) {
            var pt = Is(tt);
            (tt !== pt || tt.tag !== O && tt.tag !== w) && (tt = null);
          }
        } else
          $e = null, tt = g;
        if ($e !== tt) {
          var on = Tf, Pn = "onMouseLeave", Tn = "onMouseEnter", Dr = "mouse";
          (c === "pointerout" || c === "pointerover") && (on = ry, Pn = "onPointerLeave", Tn = "onPointerEnter", Dr = "pointer");
          var wr = $e == null ? me : hn($e), qe = tt == null ? me : hn(tt), ht = new on(Pn, Dr + "leave", $e, y, T);
          ht.target = wr, ht.relatedTarget = qe;
          var Ke = null, Nt = _t(T);
          if (Nt === g) {
            var sn = new on(Tn, Dr + "enter", tt, y, T);
            sn.target = qe, sn.relatedTarget = wr, Ke = sn;
          }
          MN(l, ht, Ke, $e, tt);
        }
      }
    }
    function yn(l, c) {
      return l === c && (l !== 0 || 1 / l === 1 / c) || l !== l && c !== c;
    }
    var cn = typeof Object.is == "function" ? Object.is : yn;
    function wn(l, c) {
      if (cn(l, c))
        return !0;
      if (typeof l != "object" || l === null || typeof c != "object" || c === null)
        return !1;
      var g = Object.keys(l), y = Object.keys(c);
      if (g.length !== y.length)
        return !1;
      for (var T = 0; T < g.length; T++) {
        var R = g[T];
        if (!st.call(c, R) || !cn(l[R], c[R]))
          return !1;
      }
      return !0;
    }
    function Qn(l) {
      for (; l && l.firstChild; )
        l = l.firstChild;
      return l;
    }
    function Gi(l) {
      for (; l; ) {
        if (l.nextSibling)
          return l.nextSibling;
        l = l.parentNode;
      }
    }
    function Rr(l, c) {
      for (var g = Qn(l), y = 0, T = 0; g; ) {
        if (g.nodeType === Tu) {
          if (T = y + g.textContent.length, y <= c && T >= c)
            return {
              node: g,
              offset: c - y
            };
          y = T;
        }
        g = Qn(Gi(g));
      }
    }
    function xf(l) {
      var c = l.ownerDocument, g = c && c.defaultView || window, y = g.getSelection && g.getSelection();
      if (!y || y.rangeCount === 0)
        return null;
      var T = y.anchorNode, R = y.anchorOffset, $ = y.focusNode, W = y.focusOffset;
      try {
        T.nodeType, $.nodeType;
      } catch {
        return null;
      }
      return Z1(l, T, R, $, W);
    }
    function Z1(l, c, g, y, T) {
      var R = 0, $ = -1, W = -1, G = 0, ae = 0, me = l, Ue = null;
      e:
        for (; ; ) {
          for (var $e = null; me === c && (g === 0 || me.nodeType === Tu) && ($ = R + g), me === y && (T === 0 || me.nodeType === Tu) && (W = R + T), me.nodeType === Tu && (R += me.nodeValue.length), ($e = me.firstChild) !== null; )
            Ue = me, me = $e;
          for (; ; ) {
            if (me === l)
              break e;
            if (Ue === c && ++G === g && ($ = R), Ue === y && ++ae === T && (W = R), ($e = me.nextSibling) !== null)
              break;
            me = Ue, Ue = me.parentNode;
          }
          me = $e;
        }
      return $ === -1 || W === -1 ? null : {
        start: $,
        end: W
      };
    }
    function wN(l, c) {
      var g = l.ownerDocument || document, y = g && g.defaultView || window;
      if (y.getSelection) {
        var T = y.getSelection(), R = l.textContent.length, $ = Math.min(c.start, R), W = c.end === void 0 ? $ : Math.min(c.end, R);
        if (!T.extend && $ > W) {
          var G = W;
          W = $, $ = G;
        }
        var ae = Rr(l, $), me = Rr(l, W);
        if (ae && me) {
          if (T.rangeCount === 1 && T.anchorNode === ae.node && T.anchorOffset === ae.offset && T.focusNode === me.node && T.focusOffset === me.offset)
            return;
          var Ue = g.createRange();
          Ue.setStart(ae.node, ae.offset), T.removeAllRanges(), $ > W ? (T.addRange(Ue), T.extend(me.node, me.offset)) : (Ue.setEnd(me.node, me.offset), T.addRange(Ue));
        }
      }
    }
    function H_(l) {
      return l && l.nodeType === Tu;
    }
    function W_(l, c) {
      return !l || !c ? !1 : l === c ? !0 : H_(l) ? !1 : H_(c) ? W_(l, c.parentNode) : "contains" in l ? l.contains(c) : l.compareDocumentPosition ? !!(l.compareDocumentPosition(c) & 16) : !1;
    }
    function TN(l) {
      return l && l.ownerDocument && W_(l.ownerDocument.documentElement, l);
    }
    function _N(l) {
      try {
        return typeof l.contentWindow.location.href == "string";
      } catch {
        return !1;
      }
    }
    function Q_() {
      for (var l = window, c = lg(); c instanceof l.HTMLIFrameElement; ) {
        if (_N(c))
          l = c.contentWindow;
        else
          return c;
        c = lg(l.document);
      }
      return c;
    }
    function X1(l) {
      var c = l && l.nodeName && l.nodeName.toLowerCase();
      return c && (c === "input" && (l.type === "text" || l.type === "search" || l.type === "tel" || l.type === "url" || l.type === "password") || c === "textarea" || l.contentEditable === "true");
    }
    function _c() {
      var l = Q_();
      return {
        focusedElem: l,
        selectionRange: X1(l) ? xN(l) : null
      };
    }
    function CN(l) {
      var c = Q_(), g = l.focusedElem, y = l.selectionRange;
      if (c !== g && TN(g)) {
        y !== null && X1(g) && Am(g, y);
        for (var T = [], R = g; R = R.parentNode; )
          R.nodeType === rs && T.push({
            element: R,
            left: R.scrollLeft,
            top: R.scrollTop
          });
        typeof g.focus == "function" && g.focus();
        for (var $ = 0; $ < T.length; $++) {
          var W = T[$];
          W.element.scrollLeft = W.left, W.element.scrollTop = W.top;
        }
      }
    }
    function xN(l) {
      var c;
      return "selectionStart" in l ? c = {
        start: l.selectionStart,
        end: l.selectionEnd
      } : c = xf(l), c || {
        start: 0,
        end: 0
      };
    }
    function Am(l, c) {
      var g = c.start, y = c.end;
      y === void 0 && (y = g), "selectionStart" in l ? (l.selectionStart = g, l.selectionEnd = Math.min(y, l.value.length)) : wN(l, c);
    }
    var or = lt && "documentMode" in document && document.documentMode <= 11;
    function AN() {
      je("onSelect", ["focusout", "contextmenu", "dragend", "focusin", "keydown", "keyup", "mousedown", "mouseup", "selectionchange"]);
    }
    var io = null, fi = null, ly = null, Af = !1;
    function kN(l) {
      if ("selectionStart" in l && X1(l))
        return {
          start: l.selectionStart,
          end: l.selectionEnd
        };
      var c = l.ownerDocument && l.ownerDocument.defaultView || window, g = c.getSelection();
      return {
        anchorNode: g.anchorNode,
        anchorOffset: g.anchorOffset,
        focusNode: g.focusNode,
        focusOffset: g.focusOffset
      };
    }
    function RN(l) {
      return l.window === l ? l.document : l.nodeType === Cs ? l : l.ownerDocument;
    }
    function j_(l, c, g) {
      var y = RN(g);
      if (!(Af || io == null || io !== lg(y))) {
        var T = kN(io);
        if (!ly || !wn(ly, T)) {
          ly = T;
          var R = rr(fi, "onSelect");
          if (R.length > 0) {
            var $ = new ji("onSelect", "select", null, c, g);
            l.push({
              event: $,
              listeners: R
            }), $.target = io;
          }
        }
      }
    }
    function IN(l, c, g, y, T, R, $) {
      var W = g ? hn(g) : window;
      switch (c) {
        case "focusin":
          (Vp(W) || W.contentEditable === "true") && (io = W, fi = g, ly = null);
          break;
        case "focusout":
          io = null, fi = null, ly = null;
          break;
        case "mousedown":
          Af = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          Af = !1, j_(l, y, T);
          break;
        case "selectionchange":
          if (or)
            break;
        case "keydown":
        case "keyup":
          j_(l, y, T);
      }
    }
    function fO(l, c) {
      var g = {};
      return g[l.toLowerCase()] = c.toLowerCase(), g["Webkit" + l] = "webkit" + c, g["Moz" + l] = "moz" + c, g;
    }
    var Yp = {
      animationend: fO("Animation", "AnimationEnd"),
      animationiteration: fO("Animation", "AnimationIteration"),
      animationstart: fO("Animation", "AnimationStart"),
      transitionend: fO("Transition", "TransitionEnd")
    }, q1 = {}, kf = {};
    lt && (kf = document.createElement("div").style, "AnimationEvent" in window || (delete Yp.animationend.animation, delete Yp.animationiteration.animation, delete Yp.animationstart.animation), "TransitionEvent" in window || delete Yp.transitionend.transition);
    function uy(l) {
      if (q1[l])
        return q1[l];
      if (!Yp[l])
        return l;
      var c = Yp[l];
      for (var g in c)
        if (c.hasOwnProperty(g) && g in kf)
          return q1[l] = c[g];
      return l;
    }
    var cy = uy("animationend"), ti = uy("animationiteration"), di = uy("animationstart"), K1 = uy("transitionend"), G_ = /* @__PURE__ */ new Map(), V_ = ["abort", "auxClick", "cancel", "canPlay", "canPlayThrough", "click", "close", "contextMenu", "copy", "cut", "drag", "dragEnd", "dragEnter", "dragExit", "dragLeave", "dragOver", "dragStart", "drop", "durationChange", "emptied", "encrypted", "ended", "error", "gotPointerCapture", "input", "invalid", "keyDown", "keyPress", "keyUp", "load", "loadedData", "loadedMetadata", "loadStart", "lostPointerCapture", "mouseDown", "mouseMove", "mouseOut", "mouseOver", "mouseUp", "paste", "pause", "play", "playing", "pointerCancel", "pointerDown", "pointerMove", "pointerOut", "pointerOver", "pointerUp", "progress", "rateChange", "reset", "resize", "seeked", "seeking", "stalled", "submit", "suspend", "timeUpdate", "touchCancel", "touchEnd", "touchStart", "volumeChange", "scroll", "toggle", "touchMove", "waiting", "wheel"];
    function Zp(l, c) {
      G_.set(l, c), je(c, [l]);
    }
    function DN() {
      for (var l = 0; l < V_.length; l++) {
        var c = V_[l], g = c.toLowerCase(), y = c[0].toUpperCase() + c.slice(1);
        Zp(g, "on" + y);
      }
      Zp(cy, "onAnimationEnd"), Zp(ti, "onAnimationIteration"), Zp(di, "onAnimationStart"), Zp("dblclick", "onDoubleClick"), Zp("focusin", "onFocus"), Zp("focusout", "onBlur"), Zp(K1, "onTransitionEnd");
    }
    function NN(l, c, g, y, T, R, $) {
      var W = G_.get(c);
      if (W !== void 0) {
        var G = ji, ae = c;
        switch (c) {
          case "keypress":
            if (wf(y) === 0)
              return;
          case "keydown":
          case "keyup":
            G = Q1;
            break;
          case "focusin":
            ae = "focus", G = Zg;
            break;
          case "focusout":
            ae = "blur", G = Zg;
            break;
          case "beforeblur":
          case "afterblur":
            G = Zg;
            break;
          case "click":
            if (y.button === 2)
              return;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            G = Tf;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            G = _d;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            G = Bs;
            break;
          case cy:
          case ti:
          case di:
            G = Xg;
            break;
          case K1:
            G = Kg;
            break;
          case "scroll":
            G = qv;
            break;
          case "wheel":
            G = Jg;
            break;
          case "copy":
          case "cut":
          case "paste":
            G = U1;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            G = ry;
            break;
        }
        var me = (R & Xc) !== 0;
        {
          var Ue = !me && // TODO: ideally, we'd eventually add all events from
          // nonDelegatedEvents list in DOMPluginEventSystem.
          // Then we can remove this special list.
          // This is a breaking change that can wait until React 18.
          c === "scroll", $e = kd(g, W, y.type, me, Ue);
          if ($e.length > 0) {
            var tt = new G(W, ae, null, y, T);
            l.push({
              event: tt,
              listeners: $e
            });
          }
        }
      }
    }
    DN(), Xe(), ob(), AN(), sO();
    function PN(l, c, g, y, T, R, $) {
      NN(l, c, g, y, T, R);
      var W = (R & yg) === 0;
      W && (Ft(l, c, g, y, T), Me(l, c, g, y, T), IN(l, c, g, y, T), ib(l, c, g, y, T));
    }
    var sb = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "encrypted", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "resize", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"], km = new Set(["cancel", "close", "invalid", "load", "scroll", "toggle"].concat(sb));
    function dO(l, c, g) {
      var y = l.type || "unknown-event";
      l.currentTarget = g, ks(y, c, void 0, l), l.currentTarget = null;
    }
    function LN(l, c, g) {
      var y;
      if (g)
        for (var T = c.length - 1; T >= 0; T--) {
          var R = c[T], $ = R.instance, W = R.currentTarget, G = R.listener;
          if ($ !== y && l.isPropagationStopped())
            return;
          dO(l, G, W), y = $;
        }
      else
        for (var ae = 0; ae < c.length; ae++) {
          var me = c[ae], Ue = me.instance, $e = me.currentTarget, tt = me.listener;
          if (Ue !== y && l.isPropagationStopped())
            return;
          dO(l, tt, $e), y = Ue;
        }
    }
    function J1(l, c) {
      for (var g = (c & Xc) !== 0, y = 0; y < l.length; y++) {
        var T = l[y], R = T.event, $ = T.listeners;
        LN(R, $, g);
      }
      Tg();
    }
    function pO(l, c, g, y, T) {
      var R = Og(g), $ = [];
      PN($, l, y, g, R, c), J1($, c);
    }
    function Sr(l, c) {
      km.has(l) || o('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', l);
      var g = !1, y = jn(c), T = ia(l, g);
      y.has(T) || (Y_(c, l, gp, g), y.add(T));
    }
    function Xp(l, c, g) {
      km.has(l) && !c && o('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', l);
      var y = 0;
      c && (y |= Xc), Y_(g, l, y, c);
    }
    var hO = "_reactListening" + Math.random().toString(36).slice(2);
    function fy(l) {
      if (!l[hO]) {
        l[hO] = !0, he.forEach(function(g) {
          g !== "selectionchange" && (km.has(g) || Xp(g, !1, l), Xp(g, !0, l));
        });
        var c = l.nodeType === Cs ? l : l.ownerDocument;
        c !== null && (c[hO] || (c[hO] = !0, Xp("selectionchange", !1, c)));
      }
    }
    function Y_(l, c, g, y, T) {
      var R = Up(l, c, g), $ = void 0;
      ud && (c === "touchstart" || c === "touchmove" || c === "wheel") && ($ = !0), l = l, y ? $ !== void 0 ? wc(l, c, R, $) : Wp(l, c, R) : $ !== void 0 ? Gg(l, c, R, $) : jg(l, c, R);
    }
    function Z_(l, c) {
      return l === c || l.nodeType === $r && l.parentNode === c;
    }
    function eS(l, c, g, y, T) {
      var R = y;
      if (!(c & ll) && !(c & gp)) {
        var $ = T;
        if (y !== null) {
          var W = y;
          e:
            for (; ; ) {
              if (W === null)
                return;
              var G = W.tag;
              if (G === m || G === v) {
                var ae = W.stateNode.containerInfo;
                if (Z_(ae, $))
                  break;
                if (G === v)
                  for (var me = W.return; me !== null; ) {
                    var Ue = me.tag;
                    if (Ue === m || Ue === v) {
                      var $e = me.stateNode.containerInfo;
                      if (Z_($e, $))
                        return;
                    }
                    me = me.return;
                  }
                for (; ae !== null; ) {
                  var tt = _t(ae);
                  if (tt === null)
                    return;
                  var rt = tt.tag;
                  if (rt === O || rt === w) {
                    W = R = tt;
                    continue e;
                  }
                  ae = ae.parentNode;
                }
              }
              W = W.return;
            }
        }
      }
      Iv(function() {
        return pO(l, c, g, R);
      });
    }
    function lb(l, c, g) {
      return {
        instance: l,
        listener: c,
        currentTarget: g
      };
    }
    function kd(l, c, g, y, T, R) {
      for (var $ = c !== null ? c + "Capture" : null, W = y ? $ : c, G = [], ae = l, me = null; ae !== null; ) {
        var Ue = ae, $e = Ue.stateNode, tt = Ue.tag;
        if (tt === O && $e !== null && (me = $e, W !== null)) {
          var rt = jl(ae, W);
          rt != null && G.push(lb(ae, rt, me));
        }
        if (T)
          break;
        ae = ae.return;
      }
      return G;
    }
    function rr(l, c) {
      for (var g = c + "Capture", y = [], T = l; T !== null; ) {
        var R = T, $ = R.stateNode, W = R.tag;
        if (W === O && $ !== null) {
          var G = $, ae = jl(T, g);
          ae != null && y.unshift(lb(T, ae, G));
          var me = jl(T, c);
          me != null && y.push(lb(T, me, G));
        }
        T = T.return;
      }
      return y;
    }
    function Rm(l) {
      if (l === null)
        return null;
      do
        l = l.return;
      while (l && l.tag !== O);
      return l || null;
    }
    function $u(l, c) {
      for (var g = l, y = c, T = 0, R = g; R; R = Rm(R))
        T++;
      for (var $ = 0, W = y; W; W = Rm(W))
        $++;
      for (; T - $ > 0; )
        g = Rm(g), T--;
      for (; $ - T > 0; )
        y = Rm(y), $--;
      for (var G = T; G--; ) {
        if (g === y || y !== null && g === y.alternate)
          return g;
        g = Rm(g), y = Rm(y);
      }
      return null;
    }
    function tS(l, c, g, y, T) {
      for (var R = c._reactName, $ = [], W = g; W !== null && W !== y; ) {
        var G = W, ae = G.alternate, me = G.stateNode, Ue = G.tag;
        if (ae !== null && ae === y)
          break;
        if (Ue === O && me !== null) {
          var $e = me;
          if (T) {
            var tt = jl(W, R);
            tt != null && $.unshift(lb(W, tt, $e));
          } else if (!T) {
            var rt = jl(W, R);
            rt != null && $.push(lb(W, rt, $e));
          }
        }
        W = W.return;
      }
      $.length !== 0 && l.push({
        event: c,
        listeners: $
      });
    }
    function MN(l, c, g, y, T) {
      var R = y && T ? $u(y, T) : null;
      y !== null && tS(l, c, y, R, !1), T !== null && g !== null && tS(l, g, T, R, !0);
    }
    function ia(l, c) {
      return l + "__" + (c ? "capture" : "bubble");
    }
    var Ol = !1, ub = "dangerouslySetInnerHTML", Im = "suppressContentEditableWarning", qp = "suppressHydrationWarning", X_ = "autoFocus", Dm = "children", Nm = "style", mO = "__html", nS, gO, dy, q_, bO, K_, J_;
    nS = {
      // There are working polyfills for <dialog>. Let people use it.
      dialog: !0,
      // Electron ships a custom <webview> tag to display external web content in
      // an isolated frame and process.
      // This tag is not present in non Electron environments such as JSDom which
      // is often used for testing purposes.
      // @see https://electronjs.org/docs/api/webview-tag
      webview: !0
    }, gO = function(l, c) {
      Ur(l, c), vg(l, c), Rv(l, c, {
        registrationNameDependencies: Ae,
        possibleRegistrationNames: Te
      });
    }, K_ = lt && !document.documentMode, dy = function(l, c, g) {
      if (!Ol) {
        var y = vO(g), T = vO(c);
        T !== y && (Ol = !0, o("Prop `%s` did not match. Server: %s Client: %s", l, JSON.stringify(T), JSON.stringify(y)));
      }
    }, q_ = function(l) {
      if (!Ol) {
        Ol = !0;
        var c = [];
        l.forEach(function(g) {
          c.push(g);
        }), o("Extra attributes from the server: %s", c);
      }
    }, bO = function(l, c) {
      c === !1 ? o("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", l, l, l) : o("Expected `%s` listener to be a function, instead got a value of `%s` type.", l, typeof c);
    }, J_ = function(l, c) {
      var g = l.namespaceURI === wu ? l.ownerDocument.createElement(l.tagName) : l.ownerDocument.createElementNS(l.namespaceURI, l.tagName);
      return g.innerHTML = c, g.innerHTML;
    };
    var FN = /\r\n?/g, rS = /\u0000|\uFFFD/g;
    function vO(l) {
      Yt(l);
      var c = typeof l == "string" ? l : "" + l;
      return c.replace(FN, `
`).replace(rS, "");
    }
    function cb(l, c, g, y) {
      var T = vO(c), R = vO(l);
      if (R !== T && (y && (Ol || (Ol = !0, o('Text content did not match. Server: "%s" Client: "%s"', R, T))), g && ie))
        throw new Error("Text content does not match server-rendered HTML.");
    }
    function eC(l) {
      return l.nodeType === Cs ? l : l.ownerDocument;
    }
    function $N() {
    }
    function yO(l) {
      l.onclick = $N;
    }
    function Ao(l, c, g, y, T) {
      for (var R in y)
        if (y.hasOwnProperty(R)) {
          var $ = y[R];
          if (R === Nm)
            $ && Object.freeze($), We(c, $);
          else if (R === ub) {
            var W = $ ? $[mO] : void 0;
            W != null && pg(c, W);
          } else if (R === Dm)
            if (typeof $ == "string") {
              var G = l !== "textarea" || $ !== "";
              G && jh(c, $);
            } else
              typeof $ == "number" && jh(c, "" + $);
          else
            R === Im || R === qp || R === X_ || (Ae.hasOwnProperty(R) ? $ != null && (typeof $ != "function" && bO(R, $), R === "onScroll" && Sr("scroll", c)) : $ != null && Lo(c, R, $, T));
        }
    }
    function El(l, c, g, y) {
      for (var T = 0; T < c.length; T += 2) {
        var R = c[T], $ = c[T + 1];
        R === Nm ? We(l, $) : R === ub ? pg(l, $) : R === Dm ? jh(l, $) : Lo(l, R, $, y);
      }
    }
    function BN(l, c, g, y) {
      var T, R = eC(g), $, W = y;
      if (W === wu && (W = op(l)), W === wu) {
        if (T = Ql(l, c), !T && l !== l.toLowerCase() && o("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", l), l === "script") {
          var G = R.createElement("div");
          G.innerHTML = "<script><\/script>";
          var ae = G.firstChild;
          $ = G.removeChild(ae);
        } else if (typeof c.is == "string")
          $ = R.createElement(l, {
            is: c.is
          });
        else if ($ = R.createElement(l), l === "select") {
          var me = $;
          c.multiple ? me.multiple = !0 : c.size && (me.size = c.size);
        }
      } else
        $ = R.createElementNS(W, l);
      return W === wu && !T && Object.prototype.toString.call($) === "[object HTMLUnknownElement]" && !st.call(nS, l) && (nS[l] = !0, o("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", l)), $;
    }
    function UN(l, c) {
      return eC(c).createTextNode(l);
    }
    function zN(l, c, g, y) {
      var T = Ql(c, g);
      gO(c, g);
      var R;
      switch (c) {
        case "dialog":
          Sr("cancel", l), Sr("close", l), R = g;
          break;
        case "iframe":
        case "object":
        case "embed":
          Sr("load", l), R = g;
          break;
        case "video":
        case "audio":
          for (var $ = 0; $ < sb.length; $++)
            Sr(sb[$], l);
          R = g;
          break;
        case "source":
          Sr("error", l), R = g;
          break;
        case "img":
        case "image":
        case "link":
          Sr("error", l), Sr("load", l), R = g;
          break;
        case "details":
          Sr("toggle", l), R = g;
          break;
        case "input":
          Hl(l, g), R = rd(l, g), Sr("invalid", l);
          break;
        case "option":
          vo(l, g), R = g;
          break;
        case "select":
          fg(l, g), R = Su(l, g), Sr("invalid", l);
          break;
        case "textarea":
          Tv(l, g), R = wv(l, g), Sr("invalid", l);
          break;
        default:
          R = g;
      }
      switch (Gr(c, R), Ao(c, l, y, R, T), c) {
        case "input":
          nd(l), bo(l, g, !1);
          break;
        case "textarea":
          nd(l), id(l);
          break;
        case "option":
          yv(l, g);
          break;
        case "select":
          k1(l, g);
          break;
        default:
          typeof R.onClick == "function" && yO(l);
          break;
      }
    }
    function tC(l, c, g, y, T) {
      gO(c, y);
      var R = null, $, W;
      switch (c) {
        case "input":
          $ = rd(l, g), W = rd(l, y), R = [];
          break;
        case "select":
          $ = Su(l, g), W = Su(l, y), R = [];
          break;
        case "textarea":
          $ = wv(l, g), W = wv(l, y), R = [];
          break;
        default:
          $ = g, W = y, typeof $.onClick != "function" && typeof W.onClick == "function" && yO(l);
          break;
      }
      Gr(c, W);
      var G, ae, me = null;
      for (G in $)
        if (!(W.hasOwnProperty(G) || !$.hasOwnProperty(G) || $[G] == null))
          if (G === Nm) {
            var Ue = $[G];
            for (ae in Ue)
              Ue.hasOwnProperty(ae) && (me || (me = {}), me[ae] = "");
          } else
            G === ub || G === Dm || G === Im || G === qp || G === X_ || (Ae.hasOwnProperty(G) ? R || (R = []) : (R = R || []).push(G, null));
      for (G in W) {
        var $e = W[G], tt = $ != null ? $[G] : void 0;
        if (!(!W.hasOwnProperty(G) || $e === tt || $e == null && tt == null))
          if (G === Nm)
            if ($e && Object.freeze($e), tt) {
              for (ae in tt)
                tt.hasOwnProperty(ae) && (!$e || !$e.hasOwnProperty(ae)) && (me || (me = {}), me[ae] = "");
              for (ae in $e)
                $e.hasOwnProperty(ae) && tt[ae] !== $e[ae] && (me || (me = {}), me[ae] = $e[ae]);
            } else
              me || (R || (R = []), R.push(G, me)), me = $e;
          else if (G === ub) {
            var rt = $e ? $e[mO] : void 0, pt = tt ? tt[mO] : void 0;
            rt != null && pt !== rt && (R = R || []).push(G, rt);
          } else
            G === Dm ? (typeof $e == "string" || typeof $e == "number") && (R = R || []).push(G, "" + $e) : G === Im || G === qp || (Ae.hasOwnProperty(G) ? ($e != null && (typeof $e != "function" && bO(G, $e), G === "onScroll" && Sr("scroll", l)), !R && tt !== $e && (R = [])) : (R = R || []).push(G, $e));
      }
      return me && (Jt(me, W[Nm]), (R = R || []).push(Nm, me)), R;
    }
    function HN(l, c, g, y, T) {
      g === "input" && T.type === "radio" && T.name != null && cg(l, T);
      var R = Ql(g, y), $ = Ql(g, T);
      switch (El(l, c, R, $), g) {
        case "input":
          Yc(l, T);
          break;
        case "textarea":
          Wh(l, T);
          break;
        case "select":
          Ev(l, T);
          break;
      }
    }
    function WN(l) {
      {
        var c = l.toLowerCase();
        return bg.hasOwnProperty(c) && bg[c] || null;
      }
    }
    function QN(l, c, g, y, T, R, $) {
      var W, G;
      switch (W = Ql(c, g), gO(c, g), c) {
        case "dialog":
          Sr("cancel", l), Sr("close", l);
          break;
        case "iframe":
        case "object":
        case "embed":
          Sr("load", l);
          break;
        case "video":
        case "audio":
          for (var ae = 0; ae < sb.length; ae++)
            Sr(sb[ae], l);
          break;
        case "source":
          Sr("error", l);
          break;
        case "img":
        case "image":
        case "link":
          Sr("error", l), Sr("load", l);
          break;
        case "details":
          Sr("toggle", l);
          break;
        case "input":
          Hl(l, g), Sr("invalid", l);
          break;
        case "option":
          vo(l, g);
          break;
        case "select":
          fg(l, g), Sr("invalid", l);
          break;
        case "textarea":
          Tv(l, g), Sr("invalid", l);
          break;
      }
      Gr(c, g);
      {
        G = /* @__PURE__ */ new Set();
        for (var me = l.attributes, Ue = 0; Ue < me.length; Ue++) {
          var $e = me[Ue].name.toLowerCase();
          switch ($e) {
            case "value":
              break;
            case "checked":
              break;
            case "selected":
              break;
            default:
              G.add(me[Ue].name);
          }
        }
      }
      var tt = null;
      for (var rt in g)
        if (g.hasOwnProperty(rt)) {
          var pt = g[rt];
          if (rt === Dm)
            typeof pt == "string" ? l.textContent !== pt && (g[qp] !== !0 && cb(l.textContent, pt, R, $), tt = [Dm, pt]) : typeof pt == "number" && l.textContent !== "" + pt && (g[qp] !== !0 && cb(l.textContent, pt, R, $), tt = [Dm, "" + pt]);
          else if (Ae.hasOwnProperty(rt))
            pt != null && (typeof pt != "function" && bO(rt, pt), rt === "onScroll" && Sr("scroll", l));
          else if ($ && // Convince Flow we've calculated it (it's DEV-only in this method.)
          typeof W == "boolean") {
            var on = void 0, Pn = W && Z ? null : br(rt);
            if (g[qp] !== !0) {
              if (!(rt === Im || rt === qp || // Controlled attributes are not validated
              // TODO: Only ignore them on controlled tags.
              rt === "value" || rt === "checked" || rt === "selected")) {
                if (rt === ub) {
                  var Tn = l.innerHTML, Dr = pt ? pt[mO] : void 0;
                  if (Dr != null) {
                    var wr = J_(l, Dr);
                    wr !== Tn && dy(rt, Tn, wr);
                  }
                } else if (rt === Nm) {
                  if (G.delete(rt), K_) {
                    var qe = pp(pt);
                    on = l.getAttribute("style"), qe !== on && dy(rt, on, qe);
                  }
                } else if (W && !Z)
                  G.delete(rt.toLowerCase()), on = vu(l, rt, pt), pt !== on && dy(rt, on, pt);
                else if (!Qt(rt, Pn, W) && !Mn(rt, pt, Pn, W)) {
                  var ht = !1;
                  if (Pn !== null)
                    G.delete(Pn.attributeName), on = bu(l, rt, pt, Pn);
                  else {
                    var Ke = y;
                    if (Ke === wu && (Ke = op(c)), Ke === wu)
                      G.delete(rt.toLowerCase());
                    else {
                      var Nt = WN(rt);
                      Nt !== null && Nt !== rt && (ht = !0, G.delete(Nt)), G.delete(rt);
                    }
                    on = vu(l, rt, pt);
                  }
                  var sn = Z;
                  !sn && pt !== on && !ht && dy(rt, on, pt);
                }
              }
            }
          }
        }
      switch ($ && // $FlowFixMe - Should be inferred as not undefined.
      G.size > 0 && g[qp] !== !0 && q_(G), c) {
        case "input":
          nd(l), bo(l, g, !0);
          break;
        case "textarea":
          nd(l), id(l);
          break;
        case "select":
        case "option":
          break;
        default:
          typeof g.onClick == "function" && yO(l);
          break;
      }
      return tt;
    }
    function nC(l, c, g) {
      var y = l.nodeValue !== c;
      return y;
    }
    function aS(l, c) {
      {
        if (Ol)
          return;
        Ol = !0, o("Did not expect server HTML to contain a <%s> in <%s>.", c.nodeName.toLowerCase(), l.nodeName.toLowerCase());
      }
    }
    function iS(l, c) {
      {
        if (Ol)
          return;
        Ol = !0, o('Did not expect server HTML to contain the text node "%s" in <%s>.', c.nodeValue, l.nodeName.toLowerCase());
      }
    }
    function oS(l, c, g) {
      {
        if (Ol)
          return;
        Ol = !0, o("Expected server HTML to contain a matching <%s> in <%s>.", c, l.nodeName.toLowerCase());
      }
    }
    function OO(l, c) {
      {
        if (c === "" || Ol)
          return;
        Ol = !0, o('Expected server HTML to contain a matching text node for "%s" in <%s>.', c, l.nodeName.toLowerCase());
      }
    }
    function rC(l, c, g) {
      switch (c) {
        case "input":
          bv(l, g);
          return;
        case "textarea":
          _v(l, g);
          return;
        case "select":
          R1(l, g);
          return;
      }
    }
    var py = function() {
    }, hy = function() {
    };
    {
      var jN = ["address", "applet", "area", "article", "aside", "base", "basefont", "bgsound", "blockquote", "body", "br", "button", "caption", "center", "col", "colgroup", "dd", "details", "dir", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "isindex", "li", "link", "listing", "main", "marquee", "menu", "menuitem", "meta", "nav", "noembed", "noframes", "noscript", "object", "ol", "p", "param", "plaintext", "pre", "script", "section", "select", "source", "style", "summary", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "title", "tr", "track", "ul", "wbr", "xmp"], aC = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
      ], fb = aC.concat(["button"]), GN = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"], iC = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
      };
      hy = function(l, c) {
        var g = fn({}, l || iC), y = {
          tag: c
        };
        return aC.indexOf(c) !== -1 && (g.aTagInScope = null, g.buttonTagInScope = null, g.nobrTagInScope = null), fb.indexOf(c) !== -1 && (g.pTagInButtonScope = null), jN.indexOf(c) !== -1 && c !== "address" && c !== "div" && c !== "p" && (g.listItemTagAutoclosing = null, g.dlItemTagAutoclosing = null), g.current = y, c === "form" && (g.formTag = y), c === "a" && (g.aTagInScope = y), c === "button" && (g.buttonTagInScope = y), c === "nobr" && (g.nobrTagInScope = y), c === "p" && (g.pTagInButtonScope = y), c === "li" && (g.listItemTagAutoclosing = y), (c === "dd" || c === "dt") && (g.dlItemTagAutoclosing = y), g;
      };
      var VN = function(l, c) {
        switch (c) {
          case "select":
            return l === "option" || l === "optgroup" || l === "#text";
          case "optgroup":
            return l === "option" || l === "#text";
          case "option":
            return l === "#text";
          case "tr":
            return l === "th" || l === "td" || l === "style" || l === "script" || l === "template";
          case "tbody":
          case "thead":
          case "tfoot":
            return l === "tr" || l === "style" || l === "script" || l === "template";
          case "colgroup":
            return l === "col" || l === "template";
          case "table":
            return l === "caption" || l === "colgroup" || l === "tbody" || l === "tfoot" || l === "thead" || l === "style" || l === "script" || l === "template";
          case "head":
            return l === "base" || l === "basefont" || l === "bgsound" || l === "link" || l === "meta" || l === "title" || l === "noscript" || l === "noframes" || l === "style" || l === "script" || l === "template";
          case "html":
            return l === "head" || l === "body" || l === "frameset";
          case "frameset":
            return l === "frame";
          case "#document":
            return l === "html";
        }
        switch (l) {
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return c !== "h1" && c !== "h2" && c !== "h3" && c !== "h4" && c !== "h5" && c !== "h6";
          case "rp":
          case "rt":
            return GN.indexOf(c) === -1;
          case "body":
          case "caption":
          case "col":
          case "colgroup":
          case "frameset":
          case "frame":
          case "head":
          case "html":
          case "tbody":
          case "td":
          case "tfoot":
          case "th":
          case "thead":
          case "tr":
            return c == null;
        }
        return !0;
      }, YN = function(l, c) {
        switch (l) {
          case "address":
          case "article":
          case "aside":
          case "blockquote":
          case "center":
          case "details":
          case "dialog":
          case "dir":
          case "div":
          case "dl":
          case "fieldset":
          case "figcaption":
          case "figure":
          case "footer":
          case "header":
          case "hgroup":
          case "main":
          case "menu":
          case "nav":
          case "ol":
          case "p":
          case "section":
          case "summary":
          case "ul":
          case "pre":
          case "listing":
          case "table":
          case "hr":
          case "xmp":
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return c.pTagInButtonScope;
          case "form":
            return c.formTag || c.pTagInButtonScope;
          case "li":
            return c.listItemTagAutoclosing;
          case "dd":
          case "dt":
            return c.dlItemTagAutoclosing;
          case "button":
            return c.buttonTagInScope;
          case "a":
            return c.aTagInScope;
          case "nobr":
            return c.nobrTagInScope;
        }
        return null;
      }, oC = {};
      py = function(l, c, g) {
        g = g || iC;
        var y = g.current, T = y && y.tag;
        c != null && (l != null && o("validateDOMNesting: when childText is passed, childTag should be null"), l = "#text");
        var R = VN(l, T) ? null : y, $ = R ? null : YN(l, g), W = R || $;
        if (W) {
          var G = W.tag, ae = !!R + "|" + l + "|" + G;
          if (!oC[ae]) {
            oC[ae] = !0;
            var me = l, Ue = "";
            if (l === "#text" ? /\S/.test(c) ? me = "Text nodes" : (me = "Whitespace text nodes", Ue = " Make sure you don't have any extra whitespace between tags on each line of your source code.") : me = "<" + l + ">", R) {
              var $e = "";
              G === "table" && l === "tr" && ($e += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), o("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", me, G, Ue, $e);
            } else
              o("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", me, G);
          }
        }
      };
    }
    var my = "suppressHydrationWarning", gy = "$", EO = "/$", by = "$?", vy = "$!", ZN = "style", sS = null, lS = null;
    function XN(l) {
      var c, g, y = l.nodeType;
      switch (y) {
        case Cs:
        case Wl: {
          c = y === Cs ? "#document" : "#fragment";
          var T = l.documentElement;
          g = T ? T.namespaceURI : dg(null, "");
          break;
        }
        default: {
          var R = y === $r ? l.parentNode : l, $ = R.namespaceURI || null;
          c = R.tagName, g = dg($, c);
          break;
        }
      }
      {
        var W = c.toLowerCase(), G = hy(null, W);
        return {
          namespace: g,
          ancestorInfo: G
        };
      }
    }
    function qN(l, c, g) {
      {
        var y = l, T = dg(y.namespace, c), R = hy(y.ancestorInfo, c);
        return {
          namespace: T,
          ancestorInfo: R
        };
      }
    }
    function G7(l) {
      return l;
    }
    function KN(l) {
      sS = $s(), lS = _c();
      var c = null;
      return Qi(!1), c;
    }
    function JN(l) {
      CN(lS), Qi(sS), sS = null, lS = null;
    }
    function e2(l, c, g, y, T) {
      var R;
      {
        var $ = y;
        if (py(l, null, $.ancestorInfo), typeof c.children == "string" || typeof c.children == "number") {
          var W = "" + c.children, G = hy($.ancestorInfo, l);
          py(null, W, G);
        }
        R = $.namespace;
      }
      var ae = BN(l, c, g, R);
      return Le(T, ae), lr(ae, c), ae;
    }
    function t2(l, c) {
      l.appendChild(c);
    }
    function n2(l, c, g, y, T) {
      switch (zN(l, c, g, y), c) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          return !!g.autoFocus;
        case "img":
          return !0;
        default:
          return !1;
      }
    }
    function r2(l, c, g, y, T, R) {
      {
        var $ = R;
        if (typeof y.children != typeof g.children && (typeof y.children == "string" || typeof y.children == "number")) {
          var W = "" + y.children, G = hy($.ancestorInfo, c);
          py(null, W, G);
        }
      }
      return tC(l, c, g, y);
    }
    function uS(l, c) {
      return l === "textarea" || l === "noscript" || typeof c.children == "string" || typeof c.children == "number" || typeof c.dangerouslySetInnerHTML == "object" && c.dangerouslySetInnerHTML !== null && c.dangerouslySetInnerHTML.__html != null;
    }
    function a2(l, c, g, y) {
      {
        var T = g;
        py(null, l, T.ancestorInfo);
      }
      var R = UN(l, c);
      return Le(y, R), R;
    }
    function i2() {
      var l = window.event;
      return l === void 0 ? La : Uo(l.type);
    }
    var cS = typeof setTimeout == "function" ? setTimeout : void 0, o2 = typeof clearTimeout == "function" ? clearTimeout : void 0, fS = -1, sC = typeof Promise == "function" ? Promise : void 0, s2 = typeof queueMicrotask == "function" ? queueMicrotask : typeof sC < "u" ? function(l) {
      return sC.resolve(null).then(l).catch(l2);
    } : cS;
    function l2(l) {
      setTimeout(function() {
        throw l;
      });
    }
    function u2(l, c, g, y) {
      switch (c) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          g.autoFocus && l.focus();
          return;
        case "img": {
          g.src && (l.src = g.src);
          return;
        }
      }
    }
    function dS(l, c, g, y, T, R) {
      HN(l, c, g, y, T), lr(l, T);
    }
    function pS(l) {
      jh(l, "");
    }
    function lC(l, c, g) {
      l.nodeValue = g;
    }
    function c2(l, c) {
      l.appendChild(c);
    }
    function f2(l, c) {
      var g;
      l.nodeType === $r ? (g = l.parentNode, g.insertBefore(c, l)) : (g = l, g.appendChild(c));
      var y = l._reactRootContainer;
      y == null && g.onclick === null && yO(g);
    }
    function d2(l, c, g) {
      l.insertBefore(c, g);
    }
    function hS(l, c, g) {
      l.nodeType === $r ? l.parentNode.insertBefore(c, g) : l.insertBefore(c, g);
    }
    function p2(l, c) {
      l.removeChild(c);
    }
    function h2(l, c) {
      l.nodeType === $r ? l.parentNode.removeChild(c) : l.removeChild(c);
    }
    function mS(l, c) {
      var g = c, y = 0;
      do {
        var T = g.nextSibling;
        if (l.removeChild(g), T && T.nodeType === $r) {
          var R = T.data;
          if (R === EO)
            if (y === 0) {
              l.removeChild(T), mr(c);
              return;
            } else
              y--;
          else
            (R === gy || R === by || R === vy) && y++;
        }
        g = T;
      } while (g);
      mr(c);
    }
    function Sl(l, c) {
      l.nodeType === $r ? mS(l.parentNode, c) : l.nodeType === rs && mS(l, c), mr(l);
    }
    function gS(l) {
      l = l;
      var c = l.style;
      typeof c.setProperty == "function" ? c.setProperty("display", "none", "important") : c.display = "none";
    }
    function m2(l) {
      l.nodeValue = "";
    }
    function g2(l, c) {
      l = l;
      var g = c[ZN], y = g != null && g.hasOwnProperty("display") ? g.display : null;
      l.style.display = hg("display", y);
    }
    function b2(l, c) {
      l.nodeValue = c;
    }
    function v2(l) {
      l.nodeType === rs ? l.textContent = "" : l.nodeType === Cs && l.documentElement && l.removeChild(l.documentElement);
    }
    function bS(l, c, g) {
      return l.nodeType !== rs || c.toLowerCase() !== l.nodeName.toLowerCase() ? null : l;
    }
    function y2(l, c) {
      return c === "" || l.nodeType !== Tu ? null : l;
    }
    function vS(l) {
      return l.nodeType !== $r ? null : l;
    }
    function uC(l) {
      return l.data === by;
    }
    function yS(l) {
      return l.data === vy;
    }
    function O2(l) {
      var c = l.nextSibling && l.nextSibling.dataset, g, y, T;
      return c && (g = c.dgst, y = c.msg, T = c.stck), {
        message: y,
        digest: g,
        stack: T
      };
    }
    function E2(l, c) {
      l._reactRetry = c;
    }
    function yy(l) {
      for (; l != null; l = l.nextSibling) {
        var c = l.nodeType;
        if (c === rs || c === Tu)
          break;
        if (c === $r) {
          var g = l.data;
          if (g === gy || g === vy || g === by)
            break;
          if (g === EO)
            return null;
        }
      }
      return l;
    }
    function Oy(l) {
      return yy(l.nextSibling);
    }
    function S2(l) {
      return yy(l.firstChild);
    }
    function w2(l) {
      return yy(l.firstChild);
    }
    function OS(l) {
      return yy(l.nextSibling);
    }
    function ES(l, c, g, y, T, R, $) {
      Le(R, l), lr(l, g);
      var W;
      {
        var G = T;
        W = G.namespace;
      }
      var ae = (R.mode & cr) !== In;
      return QN(l, c, g, W, y, ae, $);
    }
    function T2(l, c, g, y) {
      return Le(g, l), g.mode & cr, nC(l, c);
    }
    function _2(l, c) {
      Le(c, l);
    }
    function C2(l) {
      for (var c = l.nextSibling, g = 0; c; ) {
        if (c.nodeType === $r) {
          var y = c.data;
          if (y === EO) {
            if (g === 0)
              return Oy(c);
            g--;
          } else
            (y === gy || y === vy || y === by) && g++;
        }
        c = c.nextSibling;
      }
      return null;
    }
    function cC(l) {
      for (var c = l.previousSibling, g = 0; c; ) {
        if (c.nodeType === $r) {
          var y = c.data;
          if (y === gy || y === vy || y === by) {
            if (g === 0)
              return c;
            g--;
          } else
            y === EO && g++;
        }
        c = c.previousSibling;
      }
      return null;
    }
    function x2(l) {
      mr(l);
    }
    function A2(l) {
      mr(l);
    }
    function k2(l) {
      return l !== "head" && l !== "body";
    }
    function R2(l, c, g, y) {
      var T = !0;
      cb(c.nodeValue, g, y, T);
    }
    function I2(l, c, g, y, T, R) {
      if (c[my] !== !0) {
        var $ = !0;
        cb(y.nodeValue, T, R, $);
      }
    }
    function D2(l, c) {
      c.nodeType === rs ? aS(l, c) : c.nodeType === $r || iS(l, c);
    }
    function N2(l, c) {
      {
        var g = l.parentNode;
        g !== null && (c.nodeType === rs ? aS(g, c) : c.nodeType === $r || iS(g, c));
      }
    }
    function P2(l, c, g, y, T) {
      (T || c[my] !== !0) && (y.nodeType === rs ? aS(g, y) : y.nodeType === $r || iS(g, y));
    }
    function L2(l, c, g) {
      oS(l, c);
    }
    function M2(l, c) {
      OO(l, c);
    }
    function F2(l, c, g) {
      {
        var y = l.parentNode;
        y !== null && oS(y, c);
      }
    }
    function $2(l, c) {
      {
        var g = l.parentNode;
        g !== null && OO(g, c);
      }
    }
    function B2(l, c, g, y, T, R) {
      (R || c[my] !== !0) && oS(g, y);
    }
    function U2(l, c, g, y, T) {
      (T || c[my] !== !0) && OO(g, y);
    }
    function z2(l) {
      o("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", l.nodeName.toLowerCase());
    }
    function H2(l) {
      fy(l);
    }
    var db = Math.random().toString(36).slice(2), b = "__reactFiber$" + db, E = "__reactProps$" + db, k = "__reactContainer$" + db, z = "__reactEvents$" + db, V = "__reactListeners$" + db, oe = "__reactHandles$" + db;
    function Ce(l) {
      delete l[b], delete l[E], delete l[z], delete l[V], delete l[oe];
    }
    function Le(l, c) {
      c[b] = l;
    }
    function Qe(l, c) {
      c[k] = l;
    }
    function St(l) {
      l[k] = null;
    }
    function Ot(l) {
      return !!l[k];
    }
    function _t(l) {
      var c = l[b];
      if (c)
        return c;
      for (var g = l.parentNode; g; ) {
        if (c = g[k] || g[b], c) {
          var y = c.alternate;
          if (c.child !== null || y !== null && y.child !== null)
            for (var T = cC(l); T !== null; ) {
              var R = T[b];
              if (R)
                return R;
              T = cC(T);
            }
          return c;
        }
        l = g, g = l.parentNode;
      }
      return null;
    }
    function Vt(l) {
      var c = l[b] || l[k];
      return c && (c.tag === O || c.tag === w || c.tag === D || c.tag === m) ? c : null;
    }
    function hn(l) {
      if (l.tag === O || l.tag === w)
        return l.stateNode;
      throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function $n(l) {
      return l[E] || null;
    }
    function lr(l, c) {
      l[E] = c;
    }
    function jn(l) {
      var c = l[z];
      return c === void 0 && (c = l[z] = /* @__PURE__ */ new Set()), c;
    }
    var yr = {}, Cr = n.ReactDebugCurrentFrame;
    function cs(l) {
      if (l) {
        var c = l._owner, g = go(l.type, l._source, c ? c.type : null);
        Cr.setExtraStackFrame(g);
      } else
        Cr.setExtraStackFrame(null);
    }
    function Wa(l, c, g, y, T) {
      {
        var R = Function.call.bind(st);
        for (var $ in l)
          if (R(l, $)) {
            var W = void 0;
            try {
              if (typeof l[$] != "function") {
                var G = Error((y || "React class") + ": " + g + " type `" + $ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof l[$] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw G.name = "Invariant Violation", G;
              }
              W = l[$](c, $, y, g, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ae) {
              W = ae;
            }
            W && !(W instanceof Error) && (cs(T), o("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", g, $, typeof W), cs(null)), W instanceof Error && !(W.message in yr) && (yr[W.message] = !0, cs(T), o("Failed %s type: %s", g, W.message), cs(null));
          }
      }
    }
    var Us = [], ni;
    ni = [];
    var oo = -1;
    function fs(l) {
      return {
        current: l
      };
    }
    function zo(l, c) {
      if (oo < 0) {
        o("Unexpected pop.");
        return;
      }
      c !== ni[oo] && o("Unexpected Fiber popped."), l.current = Us[oo], Us[oo] = null, ni[oo] = null, oo--;
    }
    function wl(l, c, g) {
      oo++, Us[oo] = l.current, ni[oo] = g, l.current = c;
    }
    var W2;
    W2 = {};
    var Cc = {};
    Object.freeze(Cc);
    var Pm = fs(Cc), Kp = fs(!1), Q2 = Cc;
    function SO(l, c, g) {
      return g && Jp(c) ? Q2 : Pm.current;
    }
    function V7(l, c, g) {
      {
        var y = l.stateNode;
        y.__reactInternalMemoizedUnmaskedChildContext = c, y.__reactInternalMemoizedMaskedChildContext = g;
      }
    }
    function wO(l, c) {
      {
        var g = l.type, y = g.contextTypes;
        if (!y)
          return Cc;
        var T = l.stateNode;
        if (T && T.__reactInternalMemoizedUnmaskedChildContext === c)
          return T.__reactInternalMemoizedMaskedChildContext;
        var R = {};
        for (var $ in y)
          R[$] = c[$];
        {
          var W = Bn(l) || "Unknown";
          Wa(y, R, "context", W);
        }
        return T && V7(l, c, R), R;
      }
    }
    function fC() {
      return Kp.current;
    }
    function Jp(l) {
      {
        var c = l.childContextTypes;
        return c != null;
      }
    }
    function dC(l) {
      zo(Kp, l), zo(Pm, l);
    }
    function j2(l) {
      zo(Kp, l), zo(Pm, l);
    }
    function Y7(l, c, g) {
      {
        if (Pm.current !== Cc)
          throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        wl(Pm, c, l), wl(Kp, g, l);
      }
    }
    function Z7(l, c, g) {
      {
        var y = l.stateNode, T = c.childContextTypes;
        if (typeof y.getChildContext != "function") {
          {
            var R = Bn(l) || "Unknown";
            W2[R] || (W2[R] = !0, o("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", R, R));
          }
          return g;
        }
        var $ = y.getChildContext();
        for (var W in $)
          if (!(W in T))
            throw new Error((Bn(l) || "Unknown") + '.getChildContext(): key "' + W + '" is not defined in childContextTypes.');
        {
          var G = Bn(l) || "Unknown";
          Wa(T, $, "child context", G);
        }
        return fn({}, g, $);
      }
    }
    function pC(l) {
      {
        var c = l.stateNode, g = c && c.__reactInternalMemoizedMergedChildContext || Cc;
        return Q2 = Pm.current, wl(Pm, g, l), wl(Kp, Kp.current, l), !0;
      }
    }
    function X7(l, c, g) {
      {
        var y = l.stateNode;
        if (!y)
          throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (g) {
          var T = Z7(l, c, Q2);
          y.__reactInternalMemoizedMergedChildContext = T, zo(Kp, l), zo(Pm, l), wl(Pm, T, l), wl(Kp, g, l);
        } else
          zo(Kp, l), wl(Kp, g, l);
      }
    }
    function Ife(l) {
      {
        if (!dd(l) || l.tag !== f)
          throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var c = l;
        do {
          switch (c.tag) {
            case m:
              return c.stateNode.context;
            case f: {
              var g = c.type;
              if (Jp(g))
                return c.stateNode.__reactInternalMemoizedMergedChildContext;
              break;
            }
          }
          c = c.return;
        } while (c !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    var pb = 0, hC = 1, Lm = null, G2 = !1, V2 = !1;
    function q7(l) {
      Lm === null ? Lm = [l] : Lm.push(l);
    }
    function Dfe(l) {
      G2 = !0, q7(l);
    }
    function K7() {
      G2 && hb();
    }
    function hb() {
      if (!V2 && Lm !== null) {
        V2 = !0;
        var l = 0, c = Ps();
        try {
          var g = !0, y = Lm;
          for (Ai(Hi); l < y.length; l++) {
            var T = y[l];
            do
              T = T(g);
            while (T !== null);
          }
          Lm = null, G2 = !1;
        } catch (R) {
          throw Lm !== null && (Lm = Lm.slice(l + 1)), Fo(rm, hb), R;
        } finally {
          Ai(c), V2 = !1;
        }
      }
      return null;
    }
    var TO = [], _O = 0, mC = null, gC = 0, Rf = [], If = 0, Ey = null, Mm = 1, Fm = "";
    function Nfe(l) {
      return wy(), (l.flags & Dv) !== xn;
    }
    function Pfe(l) {
      return wy(), gC;
    }
    function Lfe() {
      var l = Fm, c = Mm, g = c & ~Mfe(c);
      return g.toString(32) + l;
    }
    function Sy(l, c) {
      wy(), TO[_O++] = gC, TO[_O++] = mC, mC = l, gC = c;
    }
    function J7(l, c, g) {
      wy(), Rf[If++] = Mm, Rf[If++] = Fm, Rf[If++] = Ey, Ey = l;
      var y = Mm, T = Fm, R = bC(y) - 1, $ = y & ~(1 << R), W = g + 1, G = bC(c) + R;
      if (G > 30) {
        var ae = R - R % 5, me = (1 << ae) - 1, Ue = ($ & me).toString(32), $e = $ >> ae, tt = R - ae, rt = bC(c) + tt, pt = W << tt, on = pt | $e, Pn = Ue + T;
        Mm = 1 << rt | on, Fm = Pn;
      } else {
        var Tn = W << R, Dr = Tn | $, wr = T;
        Mm = 1 << G | Dr, Fm = wr;
      }
    }
    function Y2(l) {
      wy();
      var c = l.return;
      if (c !== null) {
        var g = 1, y = 0;
        Sy(l, g), J7(l, g, y);
      }
    }
    function bC(l) {
      return 32 - Pg(l);
    }
    function Mfe(l) {
      return 1 << bC(l) - 1;
    }
    function Z2(l) {
      for (; l === mC; )
        mC = TO[--_O], TO[_O] = null, gC = TO[--_O], TO[_O] = null;
      for (; l === Ey; )
        Ey = Rf[--If], Rf[If] = null, Fm = Rf[--If], Rf[If] = null, Mm = Rf[--If], Rf[If] = null;
    }
    function Ffe() {
      return wy(), Ey !== null ? {
        id: Mm,
        overflow: Fm
      } : null;
    }
    function $fe(l, c) {
      wy(), Rf[If++] = Mm, Rf[If++] = Fm, Rf[If++] = Ey, Mm = c.id, Fm = c.overflow, Ey = l;
    }
    function wy() {
      Hs() || o("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    var zs = null, Df = null, Rd = !1, Ty = !1, mb = null;
    function Bfe() {
      Rd && o("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function eW() {
      Ty = !0;
    }
    function Ufe() {
      return Ty;
    }
    function zfe(l) {
      var c = l.stateNode.containerInfo;
      return Df = w2(c), zs = l, Rd = !0, mb = null, Ty = !1, !0;
    }
    function Hfe(l, c, g) {
      return Df = OS(c), zs = l, Rd = !0, mb = null, Ty = !1, g !== null && $fe(l, g), !0;
    }
    function tW(l, c) {
      switch (l.tag) {
        case m: {
          D2(l.stateNode.containerInfo, c);
          break;
        }
        case O: {
          var g = (l.mode & cr) !== In;
          P2(
            l.type,
            l.memoizedProps,
            l.stateNode,
            c,
            // TODO: Delete this argument when we remove the legacy root API.
            g
          );
          break;
        }
        case D: {
          var y = l.memoizedState;
          y.dehydrated !== null && N2(y.dehydrated, c);
          break;
        }
      }
    }
    function nW(l, c) {
      tW(l, c);
      var g = jhe();
      g.stateNode = c, g.return = l;
      var y = l.deletions;
      y === null ? (l.deletions = [g], l.flags |= Wr) : y.push(g);
    }
    function X2(l, c) {
      {
        if (Ty)
          return;
        switch (l.tag) {
          case m: {
            var g = l.stateNode.containerInfo;
            switch (c.tag) {
              case O:
                var y = c.type;
                c.pendingProps, L2(g, y);
                break;
              case w:
                var T = c.pendingProps;
                M2(g, T);
                break;
            }
            break;
          }
          case O: {
            var R = l.type, $ = l.memoizedProps, W = l.stateNode;
            switch (c.tag) {
              case O: {
                var G = c.type, ae = c.pendingProps, me = (l.mode & cr) !== In;
                B2(
                  R,
                  $,
                  W,
                  G,
                  ae,
                  // TODO: Delete this argument when we remove the legacy root API.
                  me
                );
                break;
              }
              case w: {
                var Ue = c.pendingProps, $e = (l.mode & cr) !== In;
                U2(
                  R,
                  $,
                  W,
                  Ue,
                  // TODO: Delete this argument when we remove the legacy root API.
                  $e
                );
                break;
              }
            }
            break;
          }
          case D: {
            var tt = l.memoizedState, rt = tt.dehydrated;
            if (rt !== null)
              switch (c.tag) {
                case O:
                  var pt = c.type;
                  c.pendingProps, F2(rt, pt);
                  break;
                case w:
                  var on = c.pendingProps;
                  $2(rt, on);
                  break;
              }
            break;
          }
          default:
            return;
        }
      }
    }
    function rW(l, c) {
      c.flags = c.flags & ~dl | _a, X2(l, c);
    }
    function aW(l, c) {
      switch (l.tag) {
        case O: {
          var g = l.type;
          l.pendingProps;
          var y = bS(c, g);
          return y !== null ? (l.stateNode = y, zs = l, Df = S2(y), !0) : !1;
        }
        case w: {
          var T = l.pendingProps, R = y2(c, T);
          return R !== null ? (l.stateNode = R, zs = l, Df = null, !0) : !1;
        }
        case D: {
          var $ = vS(c);
          if ($ !== null) {
            var W = {
              dehydrated: $,
              treeContext: Ffe(),
              retryLane: us
            };
            l.memoizedState = W;
            var G = Ghe($);
            return G.return = l, l.child = G, zs = l, Df = null, !0;
          }
          return !1;
        }
        default:
          return !1;
      }
    }
    function q2(l) {
      return (l.mode & cr) !== In && (l.flags & Wn) === xn;
    }
    function K2(l) {
      throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function J2(l) {
      if (Rd) {
        var c = Df;
        if (!c) {
          q2(l) && (X2(zs, l), K2()), rW(zs, l), Rd = !1, zs = l;
          return;
        }
        var g = c;
        if (!aW(l, c)) {
          q2(l) && (X2(zs, l), K2()), c = Oy(g);
          var y = zs;
          if (!c || !aW(l, c)) {
            rW(zs, l), Rd = !1, zs = l;
            return;
          }
          nW(y, g);
        }
      }
    }
    function Wfe(l, c, g) {
      var y = l.stateNode, T = !Ty, R = ES(y, l.type, l.memoizedProps, c, g, l, T);
      return l.updateQueue = R, R !== null;
    }
    function Qfe(l) {
      var c = l.stateNode, g = l.memoizedProps, y = T2(c, g, l);
      if (y) {
        var T = zs;
        if (T !== null)
          switch (T.tag) {
            case m: {
              var R = T.stateNode.containerInfo, $ = (T.mode & cr) !== In;
              R2(
                R,
                c,
                g,
                // TODO: Delete this argument when we remove the legacy root API.
                $
              );
              break;
            }
            case O: {
              var W = T.type, G = T.memoizedProps, ae = T.stateNode, me = (T.mode & cr) !== In;
              I2(
                W,
                G,
                ae,
                c,
                g,
                // TODO: Delete this argument when we remove the legacy root API.
                me
              );
              break;
            }
          }
      }
      return y;
    }
    function jfe(l) {
      var c = l.memoizedState, g = c !== null ? c.dehydrated : null;
      if (!g)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      _2(g, l);
    }
    function Gfe(l) {
      var c = l.memoizedState, g = c !== null ? c.dehydrated : null;
      if (!g)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      return C2(g);
    }
    function iW(l) {
      for (var c = l.return; c !== null && c.tag !== O && c.tag !== m && c.tag !== D; )
        c = c.return;
      zs = c;
    }
    function vC(l) {
      if (l !== zs)
        return !1;
      if (!Rd)
        return iW(l), Rd = !0, !1;
      if (l.tag !== m && (l.tag !== O || k2(l.type) && !uS(l.type, l.memoizedProps))) {
        var c = Df;
        if (c)
          if (q2(l))
            oW(l), K2();
          else
            for (; c; )
              nW(l, c), c = Oy(c);
      }
      return iW(l), l.tag === D ? Df = Gfe(l) : Df = zs ? Oy(l.stateNode) : null, !0;
    }
    function Vfe() {
      return Rd && Df !== null;
    }
    function oW(l) {
      for (var c = Df; c; )
        tW(l, c), c = Oy(c);
    }
    function CO() {
      zs = null, Df = null, Rd = !1, Ty = !1;
    }
    function sW() {
      mb !== null && (tj(mb), mb = null);
    }
    function Hs() {
      return Rd;
    }
    function eP(l) {
      mb === null ? mb = [l] : mb.push(l);
    }
    var Yfe = n.ReactCurrentBatchConfig, Zfe = null;
    function Xfe() {
      return Yfe.transition;
    }
    var Id = {
      recordUnsafeLifecycleWarnings: function(l, c) {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function(l, c) {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    };
    {
      var qfe = function(l) {
        for (var c = null, g = l; g !== null; )
          g.mode & Da && (c = g), g = g.return;
        return c;
      }, _y = function(l) {
        var c = [];
        return l.forEach(function(g) {
          c.push(g);
        }), c.sort().join(", ");
      }, SS = [], wS = [], TS = [], _S = [], CS = [], xS = [], Cy = /* @__PURE__ */ new Set();
      Id.recordUnsafeLifecycleWarnings = function(l, c) {
        Cy.has(l.type) || (typeof c.componentWillMount == "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        c.componentWillMount.__suppressDeprecationWarning !== !0 && SS.push(l), l.mode & Da && typeof c.UNSAFE_componentWillMount == "function" && wS.push(l), typeof c.componentWillReceiveProps == "function" && c.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && TS.push(l), l.mode & Da && typeof c.UNSAFE_componentWillReceiveProps == "function" && _S.push(l), typeof c.componentWillUpdate == "function" && c.componentWillUpdate.__suppressDeprecationWarning !== !0 && CS.push(l), l.mode & Da && typeof c.UNSAFE_componentWillUpdate == "function" && xS.push(l));
      }, Id.flushPendingUnsafeLifecycleWarnings = function() {
        var l = /* @__PURE__ */ new Set();
        SS.length > 0 && (SS.forEach(function($e) {
          l.add(Bn($e) || "Component"), Cy.add($e.type);
        }), SS = []);
        var c = /* @__PURE__ */ new Set();
        wS.length > 0 && (wS.forEach(function($e) {
          c.add(Bn($e) || "Component"), Cy.add($e.type);
        }), wS = []);
        var g = /* @__PURE__ */ new Set();
        TS.length > 0 && (TS.forEach(function($e) {
          g.add(Bn($e) || "Component"), Cy.add($e.type);
        }), TS = []);
        var y = /* @__PURE__ */ new Set();
        _S.length > 0 && (_S.forEach(function($e) {
          y.add(Bn($e) || "Component"), Cy.add($e.type);
        }), _S = []);
        var T = /* @__PURE__ */ new Set();
        CS.length > 0 && (CS.forEach(function($e) {
          T.add(Bn($e) || "Component"), Cy.add($e.type);
        }), CS = []);
        var R = /* @__PURE__ */ new Set();
        if (xS.length > 0 && (xS.forEach(function($e) {
          R.add(Bn($e) || "Component"), Cy.add($e.type);
        }), xS = []), c.size > 0) {
          var $ = _y(c);
          o(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`, $);
        }
        if (y.size > 0) {
          var W = _y(y);
          o(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`, W);
        }
        if (R.size > 0) {
          var G = _y(R);
          o(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`, G);
        }
        if (l.size > 0) {
          var ae = _y(l);
          i(`componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, ae);
        }
        if (g.size > 0) {
          var me = _y(g);
          i(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, me);
        }
        if (T.size > 0) {
          var Ue = _y(T);
          i(`componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, Ue);
        }
      };
      var yC = /* @__PURE__ */ new Map(), lW = /* @__PURE__ */ new Set();
      Id.recordLegacyContextWarning = function(l, c) {
        var g = qfe(l);
        if (g === null) {
          o("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
          return;
        }
        if (!lW.has(l.type)) {
          var y = yC.get(g);
          (l.type.contextTypes != null || l.type.childContextTypes != null || c !== null && typeof c.getChildContext == "function") && (y === void 0 && (y = [], yC.set(g, y)), y.push(l));
        }
      }, Id.flushLegacyContextWarning = function() {
        yC.forEach(function(l, c) {
          if (l.length !== 0) {
            var g = l[0], y = /* @__PURE__ */ new Set();
            l.forEach(function(R) {
              y.add(Bn(R) || "Component"), lW.add(R.type);
            });
            var T = _y(y);
            try {
              ra(g), o(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`, T);
            } finally {
              wi();
            }
          }
        });
      }, Id.discardPendingWarnings = function() {
        SS = [], wS = [], TS = [], _S = [], CS = [], xS = [], yC = /* @__PURE__ */ new Map();
      };
    }
    function Dd(l, c) {
      if (l && l.defaultProps) {
        var g = fn({}, c), y = l.defaultProps;
        for (var T in y)
          g[T] === void 0 && (g[T] = y[T]);
        return g;
      }
      return c;
    }
    var tP = fs(null), nP;
    nP = {};
    var OC = null, xO = null, rP = null, EC = !1;
    function SC() {
      OC = null, xO = null, rP = null, EC = !1;
    }
    function uW() {
      EC = !0;
    }
    function cW() {
      EC = !1;
    }
    function fW(l, c, g) {
      wl(tP, c._currentValue, l), c._currentValue = g, c._currentRenderer !== void 0 && c._currentRenderer !== null && c._currentRenderer !== nP && o("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), c._currentRenderer = nP;
    }
    function aP(l, c) {
      var g = tP.current;
      zo(tP, c), l._currentValue = g;
    }
    function iP(l, c, g) {
      for (var y = l; y !== null; ) {
        var T = y.alternate;
        if (vf(y.childLanes, c) ? T !== null && !vf(T.childLanes, c) && (T.childLanes = er(T.childLanes, c)) : (y.childLanes = er(y.childLanes, c), T !== null && (T.childLanes = er(T.childLanes, c))), y === g)
          break;
        y = y.return;
      }
      y !== g && o("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function Kfe(l, c, g) {
      Jfe(l, c, g);
    }
    function Jfe(l, c, g) {
      var y = l.child;
      for (y !== null && (y.return = l); y !== null; ) {
        var T = void 0, R = y.dependencies;
        if (R !== null) {
          T = y.child;
          for (var $ = R.firstContext; $ !== null; ) {
            if ($.context === c) {
              if (y.tag === f) {
                var W = xi(g), G = $m(Yr, W);
                G.tag = TC;
                var ae = y.updateQueue;
                if (ae !== null) {
                  var me = ae.shared, Ue = me.pending;
                  Ue === null ? G.next = G : (G.next = Ue.next, Ue.next = G), me.pending = G;
                }
              }
              y.lanes = er(y.lanes, g);
              var $e = y.alternate;
              $e !== null && ($e.lanes = er($e.lanes, g)), iP(y.return, g, l), R.lanes = er(R.lanes, g);
              break;
            }
            $ = $.next;
          }
        } else if (y.tag === N)
          T = y.type === l.type ? null : y.child;
        else if (y.tag === Q) {
          var tt = y.return;
          if (tt === null)
            throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
          tt.lanes = er(tt.lanes, g);
          var rt = tt.alternate;
          rt !== null && (rt.lanes = er(rt.lanes, g)), iP(tt, g, l), T = y.sibling;
        } else
          T = y.child;
        if (T !== null)
          T.return = y;
        else
          for (T = y; T !== null; ) {
            if (T === l) {
              T = null;
              break;
            }
            var pt = T.sibling;
            if (pt !== null) {
              pt.return = T.return, T = pt;
              break;
            }
            T = T.return;
          }
        y = T;
      }
    }
    function AO(l, c) {
      OC = l, xO = null, rP = null;
      var g = l.dependencies;
      if (g !== null) {
        var y = g.firstContext;
        y !== null && ($o(g.lanes, c) && zS(), g.firstContext = null);
      }
    }
    function ko(l) {
      EC && o("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      var c = l._currentValue;
      if (rP !== l) {
        var g = {
          context: l,
          memoizedValue: c,
          next: null
        };
        if (xO === null) {
          if (OC === null)
            throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
          xO = g, OC.dependencies = {
            lanes: ct,
            firstContext: g
          };
        } else
          xO = xO.next = g;
      }
      return c;
    }
    var xy = null;
    function oP(l) {
      xy === null ? xy = [l] : xy.push(l);
    }
    function ede() {
      if (xy !== null) {
        for (var l = 0; l < xy.length; l++) {
          var c = xy[l], g = c.interleaved;
          if (g !== null) {
            c.interleaved = null;
            var y = g.next, T = c.pending;
            if (T !== null) {
              var R = T.next;
              T.next = y, g.next = R;
            }
            c.pending = g;
          }
        }
        xy = null;
      }
    }
    function dW(l, c, g, y) {
      var T = c.interleaved;
      return T === null ? (g.next = g, oP(c)) : (g.next = T.next, T.next = g), c.interleaved = g, wC(l, y);
    }
    function tde(l, c, g, y) {
      var T = c.interleaved;
      T === null ? (g.next = g, oP(c)) : (g.next = T.next, T.next = g), c.interleaved = g;
    }
    function nde(l, c, g, y) {
      var T = c.interleaved;
      return T === null ? (g.next = g, oP(c)) : (g.next = T.next, T.next = g), c.interleaved = g, wC(l, y);
    }
    function Bu(l, c) {
      return wC(l, c);
    }
    var rde = wC;
    function wC(l, c) {
      l.lanes = er(l.lanes, c);
      var g = l.alternate;
      g !== null && (g.lanes = er(g.lanes, c)), g === null && (l.flags & (_a | dl)) !== xn && pj(l);
      for (var y = l, T = l.return; T !== null; )
        T.childLanes = er(T.childLanes, c), g = T.alternate, g !== null ? g.childLanes = er(g.childLanes, c) : (T.flags & (_a | dl)) !== xn && pj(l), y = T, T = T.return;
      if (y.tag === m) {
        var R = y.stateNode;
        return R;
      } else
        return null;
    }
    var pW = 0, hW = 1, TC = 2, sP = 3, _C = !1, lP, CC;
    lP = !1, CC = null;
    function uP(l) {
      var c = {
        baseState: l.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
          pending: null,
          interleaved: null,
          lanes: ct
        },
        effects: null
      };
      l.updateQueue = c;
    }
    function mW(l, c) {
      var g = c.updateQueue, y = l.updateQueue;
      if (g === y) {
        var T = {
          baseState: y.baseState,
          firstBaseUpdate: y.firstBaseUpdate,
          lastBaseUpdate: y.lastBaseUpdate,
          shared: y.shared,
          effects: y.effects
        };
        c.updateQueue = T;
      }
    }
    function $m(l, c) {
      var g = {
        eventTime: l,
        lane: c,
        tag: pW,
        payload: null,
        callback: null,
        next: null
      };
      return g;
    }
    function gb(l, c, g) {
      var y = l.updateQueue;
      if (y === null)
        return null;
      var T = y.shared;
      if (CC === T && !lP && (o("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."), lP = !0), rhe()) {
        var R = T.pending;
        return R === null ? c.next = c : (c.next = R.next, R.next = c), T.pending = c, rde(l, g);
      } else
        return nde(l, T, c, g);
    }
    function xC(l, c, g) {
      var y = c.updateQueue;
      if (y !== null) {
        var T = y.shared;
        if (Ug(g)) {
          var R = T.lanes;
          R = zv(R, l.pendingLanes);
          var $ = er(R, g);
          T.lanes = $, Cn(l, $);
        }
      }
    }
    function cP(l, c) {
      var g = l.updateQueue, y = l.alternate;
      if (y !== null) {
        var T = y.updateQueue;
        if (g === T) {
          var R = null, $ = null, W = g.firstBaseUpdate;
          if (W !== null) {
            var G = W;
            do {
              var ae = {
                eventTime: G.eventTime,
                lane: G.lane,
                tag: G.tag,
                payload: G.payload,
                callback: G.callback,
                next: null
              };
              $ === null ? R = $ = ae : ($.next = ae, $ = ae), G = G.next;
            } while (G !== null);
            $ === null ? R = $ = c : ($.next = c, $ = c);
          } else
            R = $ = c;
          g = {
            baseState: T.baseState,
            firstBaseUpdate: R,
            lastBaseUpdate: $,
            shared: T.shared,
            effects: T.effects
          }, l.updateQueue = g;
          return;
        }
      }
      var me = g.lastBaseUpdate;
      me === null ? g.firstBaseUpdate = c : me.next = c, g.lastBaseUpdate = c;
    }
    function ade(l, c, g, y, T, R) {
      switch (g.tag) {
        case hW: {
          var $ = g.payload;
          if (typeof $ == "function") {
            uW();
            var W = $.call(R, y, T);
            {
              if (l.mode & Da) {
                _i(!0);
                try {
                  $.call(R, y, T);
                } finally {
                  _i(!1);
                }
              }
              cW();
            }
            return W;
          }
          return $;
        }
        case sP:
          l.flags = l.flags & ~Ui | Wn;
        case pW: {
          var G = g.payload, ae;
          if (typeof G == "function") {
            uW(), ae = G.call(R, y, T);
            {
              if (l.mode & Da) {
                _i(!0);
                try {
                  G.call(R, y, T);
                } finally {
                  _i(!1);
                }
              }
              cW();
            }
          } else
            ae = G;
          return ae == null ? y : fn({}, y, ae);
        }
        case TC:
          return _C = !0, y;
      }
      return y;
    }
    function AC(l, c, g, y) {
      var T = l.updateQueue;
      _C = !1, CC = T.shared;
      var R = T.firstBaseUpdate, $ = T.lastBaseUpdate, W = T.shared.pending;
      if (W !== null) {
        T.shared.pending = null;
        var G = W, ae = G.next;
        G.next = null, $ === null ? R = ae : $.next = ae, $ = G;
        var me = l.alternate;
        if (me !== null) {
          var Ue = me.updateQueue, $e = Ue.lastBaseUpdate;
          $e !== $ && ($e === null ? Ue.firstBaseUpdate = ae : $e.next = ae, Ue.lastBaseUpdate = G);
        }
      }
      if (R !== null) {
        var tt = T.baseState, rt = ct, pt = null, on = null, Pn = null, Tn = R;
        do {
          var Dr = Tn.lane, wr = Tn.eventTime;
          if (vf(y, Dr)) {
            if (Pn !== null) {
              var ht = {
                eventTime: wr,
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: vr,
                tag: Tn.tag,
                payload: Tn.payload,
                callback: Tn.callback,
                next: null
              };
              Pn = Pn.next = ht;
            }
            tt = ade(l, T, Tn, tt, c, g);
            var Ke = Tn.callback;
            if (Ke !== null && // If the update was already committed, we should not queue its
            // callback again.
            Tn.lane !== vr) {
              l.flags |= Au;
              var Nt = T.effects;
              Nt === null ? T.effects = [Tn] : Nt.push(Tn);
            }
          } else {
            var qe = {
              eventTime: wr,
              lane: Dr,
              tag: Tn.tag,
              payload: Tn.payload,
              callback: Tn.callback,
              next: null
            };
            Pn === null ? (on = Pn = qe, pt = tt) : Pn = Pn.next = qe, rt = er(rt, Dr);
          }
          if (Tn = Tn.next, Tn === null) {
            if (W = T.shared.pending, W === null)
              break;
            var sn = W, tn = sn.next;
            sn.next = null, Tn = tn, T.lastBaseUpdate = sn, T.shared.pending = null;
          }
        } while (!0);
        Pn === null && (pt = tt), T.baseState = pt, T.firstBaseUpdate = on, T.lastBaseUpdate = Pn;
        var Zn = T.shared.interleaved;
        if (Zn !== null) {
          var tr = Zn;
          do
            rt = er(rt, tr.lane), tr = tr.next;
          while (tr !== Zn);
        } else
          R === null && (T.shared.lanes = ct);
        JS(rt), l.lanes = rt, l.memoizedState = tt;
      }
      CC = null;
    }
    function ide(l, c) {
      if (typeof l != "function")
        throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + l));
      l.call(c);
    }
    function gW() {
      _C = !1;
    }
    function kC() {
      return _C;
    }
    function bW(l, c, g) {
      var y = c.effects;
      if (c.effects = null, y !== null)
        for (var T = 0; T < y.length; T++) {
          var R = y[T], $ = R.callback;
          $ !== null && (R.callback = null, ide($, g));
        }
    }
    var fP = {}, vW = new t.Component().refs, dP, pP, hP, mP, gP, yW, RC, bP, vP, yP;
    {
      dP = /* @__PURE__ */ new Set(), pP = /* @__PURE__ */ new Set(), hP = /* @__PURE__ */ new Set(), mP = /* @__PURE__ */ new Set(), bP = /* @__PURE__ */ new Set(), gP = /* @__PURE__ */ new Set(), vP = /* @__PURE__ */ new Set(), yP = /* @__PURE__ */ new Set();
      var OW = /* @__PURE__ */ new Set();
      RC = function(l, c) {
        if (!(l === null || typeof l == "function")) {
          var g = c + "_" + l;
          OW.has(g) || (OW.add(g), o("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", c, l));
        }
      }, yW = function(l, c) {
        if (c === void 0) {
          var g = Qr(l) || "Component";
          gP.has(g) || (gP.add(g), o("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", g));
        }
      }, Object.defineProperty(fP, "_processChildContext", {
        enumerable: !1,
        value: function() {
          throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
      }), Object.freeze(fP);
    }
    function OP(l, c, g, y) {
      var T = l.memoizedState, R = g(y, T);
      {
        if (l.mode & Da) {
          _i(!0);
          try {
            R = g(y, T);
          } finally {
            _i(!1);
          }
        }
        yW(c, R);
      }
      var $ = R == null ? T : fn({}, T, R);
      if (l.memoizedState = $, l.lanes === ct) {
        var W = l.updateQueue;
        W.baseState = $;
      }
    }
    var EP = {
      isMounted: So,
      enqueueSetState: function(l, c, g) {
        var y = Mo(l), T = nu(), R = Tb(y), $ = $m(T, R);
        $.payload = c, g != null && (RC(g, "setState"), $.callback = g);
        var W = gb(y, $, R);
        W !== null && (Zo(W, y, R, T), xC(W, y, R)), df(y, R);
      },
      enqueueReplaceState: function(l, c, g) {
        var y = Mo(l), T = nu(), R = Tb(y), $ = $m(T, R);
        $.tag = hW, $.payload = c, g != null && (RC(g, "replaceState"), $.callback = g);
        var W = gb(y, $, R);
        W !== null && (Zo(W, y, R, T), xC(W, y, R)), df(y, R);
      },
      enqueueForceUpdate: function(l, c) {
        var g = Mo(l), y = nu(), T = Tb(g), R = $m(y, T);
        R.tag = TC, c != null && (RC(c, "forceUpdate"), R.callback = c);
        var $ = gb(g, R, T);
        $ !== null && (Zo($, g, T, y), xC($, g, T)), Ng(g, T);
      }
    };
    function EW(l, c, g, y, T, R, $) {
      var W = l.stateNode;
      if (typeof W.shouldComponentUpdate == "function") {
        var G = W.shouldComponentUpdate(y, R, $);
        {
          if (l.mode & Da) {
            _i(!0);
            try {
              G = W.shouldComponentUpdate(y, R, $);
            } finally {
              _i(!1);
            }
          }
          G === void 0 && o("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", Qr(c) || "Component");
        }
        return G;
      }
      return c.prototype && c.prototype.isPureReactComponent ? !wn(g, y) || !wn(T, R) : !0;
    }
    function ode(l, c, g) {
      var y = l.stateNode;
      {
        var T = Qr(c) || "Component", R = y.render;
        R || (c.prototype && typeof c.prototype.render == "function" ? o("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", T) : o("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", T)), y.getInitialState && !y.getInitialState.isReactClassApproved && !y.state && o("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", T), y.getDefaultProps && !y.getDefaultProps.isReactClassApproved && o("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", T), y.propTypes && o("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", T), y.contextType && o("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", T), y.contextTypes && o("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", T), c.contextType && c.contextTypes && !vP.has(c) && (vP.add(c), o("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", T)), typeof y.componentShouldUpdate == "function" && o("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", T), c.prototype && c.prototype.isPureReactComponent && typeof y.shouldComponentUpdate < "u" && o("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", Qr(c) || "A pure component"), typeof y.componentDidUnmount == "function" && o("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", T), typeof y.componentDidReceiveProps == "function" && o("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", T), typeof y.componentWillRecieveProps == "function" && o("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", T), typeof y.UNSAFE_componentWillRecieveProps == "function" && o("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", T);
        var $ = y.props !== g;
        y.props !== void 0 && $ && o("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", T, T), y.defaultProps && o("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", T, T), typeof y.getSnapshotBeforeUpdate == "function" && typeof y.componentDidUpdate != "function" && !hP.has(c) && (hP.add(c), o("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", Qr(c))), typeof y.getDerivedStateFromProps == "function" && o("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", T), typeof y.getDerivedStateFromError == "function" && o("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", T), typeof c.getSnapshotBeforeUpdate == "function" && o("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", T);
        var W = y.state;
        W && (typeof W != "object" || Fi(W)) && o("%s.state: must be set to an object or null", T), typeof y.getChildContext == "function" && typeof c.childContextTypes != "object" && o("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", T);
      }
    }
    function SW(l, c) {
      c.updater = EP, l.stateNode = c, ar(c, l), c._reactInternalInstance = fP;
    }
    function wW(l, c, g) {
      var y = !1, T = Cc, R = Cc, $ = c.contextType;
      if ("contextType" in c) {
        var W = (
          // Allow null for conditional declaration
          $ === null || $ !== void 0 && $.$$typeof === jt && $._context === void 0
        );
        if (!W && !yP.has(c)) {
          yP.add(c);
          var G = "";
          $ === void 0 ? G = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof $ != "object" ? G = " However, it is set to a " + typeof $ + "." : $.$$typeof === xt ? G = " Did you accidentally pass the Context.Provider instead?" : $._context !== void 0 ? G = " Did you accidentally pass the Context.Consumer instead?" : G = " However, it is set to an object with keys {" + Object.keys($).join(", ") + "}.", o("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", Qr(c) || "Component", G);
        }
      }
      if (typeof $ == "object" && $ !== null)
        R = ko($);
      else {
        T = SO(l, c, !0);
        var ae = c.contextTypes;
        y = ae != null, R = y ? wO(l, T) : Cc;
      }
      var me = new c(g, R);
      if (l.mode & Da) {
        _i(!0);
        try {
          me = new c(g, R);
        } finally {
          _i(!1);
        }
      }
      var Ue = l.memoizedState = me.state !== null && me.state !== void 0 ? me.state : null;
      SW(l, me);
      {
        if (typeof c.getDerivedStateFromProps == "function" && Ue === null) {
          var $e = Qr(c) || "Component";
          pP.has($e) || (pP.add($e), o("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", $e, me.state === null ? "null" : "undefined", $e));
        }
        if (typeof c.getDerivedStateFromProps == "function" || typeof me.getSnapshotBeforeUpdate == "function") {
          var tt = null, rt = null, pt = null;
          if (typeof me.componentWillMount == "function" && me.componentWillMount.__suppressDeprecationWarning !== !0 ? tt = "componentWillMount" : typeof me.UNSAFE_componentWillMount == "function" && (tt = "UNSAFE_componentWillMount"), typeof me.componentWillReceiveProps == "function" && me.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? rt = "componentWillReceiveProps" : typeof me.UNSAFE_componentWillReceiveProps == "function" && (rt = "UNSAFE_componentWillReceiveProps"), typeof me.componentWillUpdate == "function" && me.componentWillUpdate.__suppressDeprecationWarning !== !0 ? pt = "componentWillUpdate" : typeof me.UNSAFE_componentWillUpdate == "function" && (pt = "UNSAFE_componentWillUpdate"), tt !== null || rt !== null || pt !== null) {
            var on = Qr(c) || "Component", Pn = typeof c.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            mP.has(on) || (mP.add(on), o(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, on, Pn, tt !== null ? `
  ` + tt : "", rt !== null ? `
  ` + rt : "", pt !== null ? `
  ` + pt : ""));
          }
        }
      }
      return y && V7(l, T, R), me;
    }
    function sde(l, c) {
      var g = c.state;
      typeof c.componentWillMount == "function" && c.componentWillMount(), typeof c.UNSAFE_componentWillMount == "function" && c.UNSAFE_componentWillMount(), g !== c.state && (o("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", Bn(l) || "Component"), EP.enqueueReplaceState(c, c.state, null));
    }
    function TW(l, c, g, y) {
      var T = c.state;
      if (typeof c.componentWillReceiveProps == "function" && c.componentWillReceiveProps(g, y), typeof c.UNSAFE_componentWillReceiveProps == "function" && c.UNSAFE_componentWillReceiveProps(g, y), c.state !== T) {
        {
          var R = Bn(l) || "Component";
          dP.has(R) || (dP.add(R), o("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", R));
        }
        EP.enqueueReplaceState(c, c.state, null);
      }
    }
    function SP(l, c, g, y) {
      ode(l, c, g);
      var T = l.stateNode;
      T.props = g, T.state = l.memoizedState, T.refs = vW, uP(l);
      var R = c.contextType;
      if (typeof R == "object" && R !== null)
        T.context = ko(R);
      else {
        var $ = SO(l, c, !0);
        T.context = wO(l, $);
      }
      {
        if (T.state === g) {
          var W = Qr(c) || "Component";
          bP.has(W) || (bP.add(W), o("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", W));
        }
        l.mode & Da && Id.recordLegacyContextWarning(l, T), Id.recordUnsafeLifecycleWarnings(l, T);
      }
      T.state = l.memoizedState;
      var G = c.getDerivedStateFromProps;
      if (typeof G == "function" && (OP(l, c, G, g), T.state = l.memoizedState), typeof c.getDerivedStateFromProps != "function" && typeof T.getSnapshotBeforeUpdate != "function" && (typeof T.UNSAFE_componentWillMount == "function" || typeof T.componentWillMount == "function") && (sde(l, T), AC(l, g, T, y), T.state = l.memoizedState), typeof T.componentDidMount == "function") {
        var ae = Un;
        ae |= is, (l.mode & ls) !== In && (ae |= Ra), l.flags |= ae;
      }
    }
    function lde(l, c, g, y) {
      var T = l.stateNode, R = l.memoizedProps;
      T.props = R;
      var $ = T.context, W = c.contextType, G = Cc;
      if (typeof W == "object" && W !== null)
        G = ko(W);
      else {
        var ae = SO(l, c, !0);
        G = wO(l, ae);
      }
      var me = c.getDerivedStateFromProps, Ue = typeof me == "function" || typeof T.getSnapshotBeforeUpdate == "function";
      !Ue && (typeof T.UNSAFE_componentWillReceiveProps == "function" || typeof T.componentWillReceiveProps == "function") && (R !== g || $ !== G) && TW(l, T, g, G), gW();
      var $e = l.memoizedState, tt = T.state = $e;
      if (AC(l, g, T, y), tt = l.memoizedState, R === g && $e === tt && !fC() && !kC()) {
        if (typeof T.componentDidMount == "function") {
          var rt = Un;
          rt |= is, (l.mode & ls) !== In && (rt |= Ra), l.flags |= rt;
        }
        return !1;
      }
      typeof me == "function" && (OP(l, c, me, g), tt = l.memoizedState);
      var pt = kC() || EW(l, c, R, g, $e, tt, G);
      if (pt) {
        if (!Ue && (typeof T.UNSAFE_componentWillMount == "function" || typeof T.componentWillMount == "function") && (typeof T.componentWillMount == "function" && T.componentWillMount(), typeof T.UNSAFE_componentWillMount == "function" && T.UNSAFE_componentWillMount()), typeof T.componentDidMount == "function") {
          var on = Un;
          on |= is, (l.mode & ls) !== In && (on |= Ra), l.flags |= on;
        }
      } else {
        if (typeof T.componentDidMount == "function") {
          var Pn = Un;
          Pn |= is, (l.mode & ls) !== In && (Pn |= Ra), l.flags |= Pn;
        }
        l.memoizedProps = g, l.memoizedState = tt;
      }
      return T.props = g, T.state = tt, T.context = G, pt;
    }
    function ude(l, c, g, y, T) {
      var R = c.stateNode;
      mW(l, c);
      var $ = c.memoizedProps, W = c.type === c.elementType ? $ : Dd(c.type, $);
      R.props = W;
      var G = c.pendingProps, ae = R.context, me = g.contextType, Ue = Cc;
      if (typeof me == "object" && me !== null)
        Ue = ko(me);
      else {
        var $e = SO(c, g, !0);
        Ue = wO(c, $e);
      }
      var tt = g.getDerivedStateFromProps, rt = typeof tt == "function" || typeof R.getSnapshotBeforeUpdate == "function";
      !rt && (typeof R.UNSAFE_componentWillReceiveProps == "function" || typeof R.componentWillReceiveProps == "function") && ($ !== G || ae !== Ue) && TW(c, R, y, Ue), gW();
      var pt = c.memoizedState, on = R.state = pt;
      if (AC(c, y, R, T), on = c.memoizedState, $ === G && pt === on && !fC() && !kC() && !ye)
        return typeof R.componentDidUpdate == "function" && ($ !== l.memoizedProps || pt !== l.memoizedState) && (c.flags |= Un), typeof R.getSnapshotBeforeUpdate == "function" && ($ !== l.memoizedProps || pt !== l.memoizedState) && (c.flags |= fl), !1;
      typeof tt == "function" && (OP(c, g, tt, y), on = c.memoizedState);
      var Pn = kC() || EW(c, g, W, y, pt, on, Ue) || // TODO: In some cases, we'll end up checking if context has changed twice,
      // both before and after `shouldComponentUpdate` has been called. Not ideal,
      // but I'm loath to refactor this function. This only happens for memoized
      // components so it's not that common.
      ye;
      return Pn ? (!rt && (typeof R.UNSAFE_componentWillUpdate == "function" || typeof R.componentWillUpdate == "function") && (typeof R.componentWillUpdate == "function" && R.componentWillUpdate(y, on, Ue), typeof R.UNSAFE_componentWillUpdate == "function" && R.UNSAFE_componentWillUpdate(y, on, Ue)), typeof R.componentDidUpdate == "function" && (c.flags |= Un), typeof R.getSnapshotBeforeUpdate == "function" && (c.flags |= fl)) : (typeof R.componentDidUpdate == "function" && ($ !== l.memoizedProps || pt !== l.memoizedState) && (c.flags |= Un), typeof R.getSnapshotBeforeUpdate == "function" && ($ !== l.memoizedProps || pt !== l.memoizedState) && (c.flags |= fl), c.memoizedProps = y, c.memoizedState = on), R.props = y, R.state = on, R.context = Ue, Pn;
    }
    var wP, TP, _P, CP, xP, _W = function(l, c) {
    };
    wP = !1, TP = !1, _P = {}, CP = {}, xP = {}, _W = function(l, c) {
      if (!(l === null || typeof l != "object") && !(!l._store || l._store.validated || l.key != null)) {
        if (typeof l._store != "object")
          throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        l._store.validated = !0;
        var g = Bn(c) || "Component";
        CP[g] || (CP[g] = !0, o('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));
      }
    };
    function AS(l, c, g) {
      var y = g.ref;
      if (y !== null && typeof y != "function" && typeof y != "object") {
        if ((l.mode & Da || ce) && // We warn in ReactElement.js if owner and self are equal for string refs
        // because these cannot be automatically converted to an arrow function
        // using a codemod. Therefore, we don't have to warn about string refs again.
        !(g._owner && g._self && g._owner.stateNode !== g._self)) {
          var T = Bn(l) || "Component";
          _P[T] || (o('A string ref, "%s", has been found within a strict mode tree. String refs are a source of potential bugs and should be avoided. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', y), _P[T] = !0);
        }
        if (g._owner) {
          var R = g._owner, $;
          if (R) {
            var W = R;
            if (W.tag !== f)
              throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
            $ = W.stateNode;
          }
          if (!$)
            throw new Error("Missing owner for string ref " + y + ". This error is likely caused by a bug in React. Please file an issue.");
          var G = $;
          ut(y, "ref");
          var ae = "" + y;
          if (c !== null && c.ref !== null && typeof c.ref == "function" && c.ref._stringRef === ae)
            return c.ref;
          var me = function(Ue) {
            var $e = G.refs;
            $e === vW && ($e = G.refs = {}), Ue === null ? delete $e[ae] : $e[ae] = Ue;
          };
          return me._stringRef = ae, me;
        } else {
          if (typeof y != "string")
            throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
          if (!g._owner)
            throw new Error("Element ref was specified as a string (" + y + `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`);
        }
      }
      return y;
    }
    function IC(l, c) {
      var g = Object.prototype.toString.call(c);
      throw new Error("Objects are not valid as a React child (found: " + (g === "[object Object]" ? "object with keys {" + Object.keys(c).join(", ") + "}" : g) + "). If you meant to render a collection of children, use an array instead.");
    }
    function DC(l) {
      {
        var c = Bn(l) || "Component";
        if (xP[c])
          return;
        xP[c] = !0, o("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
      }
    }
    function CW(l) {
      var c = l._payload, g = l._init;
      return g(c);
    }
    function xW(l) {
      function c(qe, ht) {
        if (l) {
          var Ke = qe.deletions;
          Ke === null ? (qe.deletions = [ht], qe.flags |= Wr) : Ke.push(ht);
        }
      }
      function g(qe, ht) {
        if (!l)
          return null;
        for (var Ke = ht; Ke !== null; )
          c(qe, Ke), Ke = Ke.sibling;
        return null;
      }
      function y(qe, ht) {
        for (var Ke = /* @__PURE__ */ new Map(), Nt = ht; Nt !== null; )
          Nt.key !== null ? Ke.set(Nt.key, Nt) : Ke.set(Nt.index, Nt), Nt = Nt.sibling;
        return Ke;
      }
      function T(qe, ht) {
        var Ke = Ly(qe, ht);
        return Ke.index = 0, Ke.sibling = null, Ke;
      }
      function R(qe, ht, Ke) {
        if (qe.index = Ke, !l)
          return qe.flags |= Dv, ht;
        var Nt = qe.alternate;
        if (Nt !== null) {
          var sn = Nt.index;
          return sn < ht ? (qe.flags |= _a, ht) : sn;
        } else
          return qe.flags |= _a, ht;
      }
      function $(qe) {
        return l && qe.alternate === null && (qe.flags |= _a), qe;
      }
      function W(qe, ht, Ke, Nt) {
        if (ht === null || ht.tag !== w) {
          var sn = eM(Ke, qe.mode, Nt);
          return sn.return = qe, sn;
        } else {
          var tn = T(ht, Ke);
          return tn.return = qe, tn;
        }
      }
      function G(qe, ht, Ke, Nt) {
        var sn = Ke.type;
        if (sn === es)
          return me(qe, ht, Ke.props.children, Nt, Ke.key);
        if (ht !== null && (ht.elementType === sn || // Keep this check inline so it only runs on the false path:
        bj(ht, Ke) || // Lazy types should reconcile their resolved type.
        // We need to do this after the Hot Reloading check above,
        // because hot reloading has different semantics than prod because
        // it doesn't resuspend. So we can't let the call below suspend.
        typeof sn == "object" && sn !== null && sn.$$typeof === Rn && CW(sn) === ht.type)) {
          var tn = T(ht, Ke.props);
          return tn.ref = AS(qe, ht, Ke), tn.return = qe, tn._debugSource = Ke._source, tn._debugOwner = Ke._owner, tn;
        }
        var Zn = JL(Ke, qe.mode, Nt);
        return Zn.ref = AS(qe, ht, Ke), Zn.return = qe, Zn;
      }
      function ae(qe, ht, Ke, Nt) {
        if (ht === null || ht.tag !== v || ht.stateNode.containerInfo !== Ke.containerInfo || ht.stateNode.implementation !== Ke.implementation) {
          var sn = tM(Ke, qe.mode, Nt);
          return sn.return = qe, sn;
        } else {
          var tn = T(ht, Ke.children || []);
          return tn.return = qe, tn;
        }
      }
      function me(qe, ht, Ke, Nt, sn) {
        if (ht === null || ht.tag !== _) {
          var tn = Cb(Ke, qe.mode, Nt, sn);
          return tn.return = qe, tn;
        } else {
          var Zn = T(ht, Ke);
          return Zn.return = qe, Zn;
        }
      }
      function Ue(qe, ht, Ke) {
        if (typeof ht == "string" && ht !== "" || typeof ht == "number") {
          var Nt = eM("" + ht, qe.mode, Ke);
          return Nt.return = qe, Nt;
        }
        if (typeof ht == "object" && ht !== null) {
          switch (ht.$$typeof) {
            case Pi: {
              var sn = JL(ht, qe.mode, Ke);
              return sn.ref = AS(qe, null, ht), sn.return = qe, sn;
            }
            case eo: {
              var tn = tM(ht, qe.mode, Ke);
              return tn.return = qe, tn;
            }
            case Rn: {
              var Zn = ht._payload, tr = ht._init;
              return Ue(qe, tr(Zn), Ke);
            }
          }
          if (Fi(ht) || Nn(ht)) {
            var va = Cb(ht, qe.mode, Ke, null);
            return va.return = qe, va;
          }
          IC(qe, ht);
        }
        return typeof ht == "function" && DC(qe), null;
      }
      function $e(qe, ht, Ke, Nt) {
        var sn = ht !== null ? ht.key : null;
        if (typeof Ke == "string" && Ke !== "" || typeof Ke == "number")
          return sn !== null ? null : W(qe, ht, "" + Ke, Nt);
        if (typeof Ke == "object" && Ke !== null) {
          switch (Ke.$$typeof) {
            case Pi:
              return Ke.key === sn ? G(qe, ht, Ke, Nt) : null;
            case eo:
              return Ke.key === sn ? ae(qe, ht, Ke, Nt) : null;
            case Rn: {
              var tn = Ke._payload, Zn = Ke._init;
              return $e(qe, ht, Zn(tn), Nt);
            }
          }
          if (Fi(Ke) || Nn(Ke))
            return sn !== null ? null : me(qe, ht, Ke, Nt, null);
          IC(qe, Ke);
        }
        return typeof Ke == "function" && DC(qe), null;
      }
      function tt(qe, ht, Ke, Nt, sn) {
        if (typeof Nt == "string" && Nt !== "" || typeof Nt == "number") {
          var tn = qe.get(Ke) || null;
          return W(ht, tn, "" + Nt, sn);
        }
        if (typeof Nt == "object" && Nt !== null) {
          switch (Nt.$$typeof) {
            case Pi: {
              var Zn = qe.get(Nt.key === null ? Ke : Nt.key) || null;
              return G(ht, Zn, Nt, sn);
            }
            case eo: {
              var tr = qe.get(Nt.key === null ? Ke : Nt.key) || null;
              return ae(ht, tr, Nt, sn);
            }
            case Rn:
              var va = Nt._payload, Zr = Nt._init;
              return tt(qe, ht, Ke, Zr(va), sn);
          }
          if (Fi(Nt) || Nn(Nt)) {
            var so = qe.get(Ke) || null;
            return me(ht, so, Nt, sn, null);
          }
          IC(ht, Nt);
        }
        return typeof Nt == "function" && DC(ht), null;
      }
      function rt(qe, ht, Ke) {
        {
          if (typeof qe != "object" || qe === null)
            return ht;
          switch (qe.$$typeof) {
            case Pi:
            case eo:
              _W(qe, Ke);
              var Nt = qe.key;
              if (typeof Nt != "string")
                break;
              if (ht === null) {
                ht = /* @__PURE__ */ new Set(), ht.add(Nt);
                break;
              }
              if (!ht.has(Nt)) {
                ht.add(Nt);
                break;
              }
              o("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", Nt);
              break;
            case Rn:
              var sn = qe._payload, tn = qe._init;
              rt(tn(sn), ht, Ke);
              break;
          }
        }
        return ht;
      }
      function pt(qe, ht, Ke, Nt) {
        for (var sn = null, tn = 0; tn < Ke.length; tn++) {
          var Zn = Ke[tn];
          sn = rt(Zn, sn, qe);
        }
        for (var tr = null, va = null, Zr = ht, so = 0, Xr = 0, Vi = null; Zr !== null && Xr < Ke.length; Xr++) {
          Zr.index > Xr ? (Vi = Zr, Zr = null) : Vi = Zr.sibling;
          var _l = $e(qe, Zr, Ke[Xr], Nt);
          if (_l === null) {
            Zr === null && (Zr = Vi);
            break;
          }
          l && Zr && _l.alternate === null && c(qe, Zr), so = R(_l, so, Xr), va === null ? tr = _l : va.sibling = _l, va = _l, Zr = Vi;
        }
        if (Xr === Ke.length) {
          if (g(qe, Zr), Hs()) {
            var Zs = Xr;
            Sy(qe, Zs);
          }
          return tr;
        }
        if (Zr === null) {
          for (; Xr < Ke.length; Xr++) {
            var Ac = Ue(qe, Ke[Xr], Nt);
            Ac !== null && (so = R(Ac, so, Xr), va === null ? tr = Ac : va.sibling = Ac, va = Ac);
          }
          if (Hs()) {
            var ru = Xr;
            Sy(qe, ru);
          }
          return tr;
        }
        for (var au = y(qe, Zr); Xr < Ke.length; Xr++) {
          var Cl = tt(au, qe, Xr, Ke[Xr], Nt);
          Cl !== null && (l && Cl.alternate !== null && au.delete(Cl.key === null ? Xr : Cl.key), so = R(Cl, so, Xr), va === null ? tr = Cl : va.sibling = Cl, va = Cl);
        }
        if (l && au.forEach(function(jO) {
          return c(qe, jO);
        }), Hs()) {
          var Qm = Xr;
          Sy(qe, Qm);
        }
        return tr;
      }
      function on(qe, ht, Ke, Nt) {
        var sn = Nn(Ke);
        if (typeof sn != "function")
          throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
        {
          typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
          Ke[Symbol.toStringTag] === "Generator" && (TP || o("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), TP = !0), Ke.entries === sn && (wP || o("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), wP = !0);
          var tn = sn.call(Ke);
          if (tn)
            for (var Zn = null, tr = tn.next(); !tr.done; tr = tn.next()) {
              var va = tr.value;
              Zn = rt(va, Zn, qe);
            }
        }
        var Zr = sn.call(Ke);
        if (Zr == null)
          throw new Error("An iterable object provided no iterator.");
        for (var so = null, Xr = null, Vi = ht, _l = 0, Zs = 0, Ac = null, ru = Zr.next(); Vi !== null && !ru.done; Zs++, ru = Zr.next()) {
          Vi.index > Zs ? (Ac = Vi, Vi = null) : Ac = Vi.sibling;
          var au = $e(qe, Vi, ru.value, Nt);
          if (au === null) {
            Vi === null && (Vi = Ac);
            break;
          }
          l && Vi && au.alternate === null && c(qe, Vi), _l = R(au, _l, Zs), Xr === null ? so = au : Xr.sibling = au, Xr = au, Vi = Ac;
        }
        if (ru.done) {
          if (g(qe, Vi), Hs()) {
            var Cl = Zs;
            Sy(qe, Cl);
          }
          return so;
        }
        if (Vi === null) {
          for (; !ru.done; Zs++, ru = Zr.next()) {
            var Qm = Ue(qe, ru.value, Nt);
            Qm !== null && (_l = R(Qm, _l, Zs), Xr === null ? so = Qm : Xr.sibling = Qm, Xr = Qm);
          }
          if (Hs()) {
            var jO = Zs;
            Sy(qe, jO);
          }
          return so;
        }
        for (var aw = y(qe, Vi); !ru.done; Zs++, ru = Zr.next()) {
          var sh = tt(aw, qe, Zs, ru.value, Nt);
          sh !== null && (l && sh.alternate !== null && aw.delete(sh.key === null ? Zs : sh.key), _l = R(sh, _l, Zs), Xr === null ? so = sh : Xr.sibling = sh, Xr = sh);
        }
        if (l && aw.forEach(function(wme) {
          return c(qe, wme);
        }), Hs()) {
          var Sme = Zs;
          Sy(qe, Sme);
        }
        return so;
      }
      function Pn(qe, ht, Ke, Nt) {
        if (ht !== null && ht.tag === w) {
          g(qe, ht.sibling);
          var sn = T(ht, Ke);
          return sn.return = qe, sn;
        }
        g(qe, ht);
        var tn = eM(Ke, qe.mode, Nt);
        return tn.return = qe, tn;
      }
      function Tn(qe, ht, Ke, Nt) {
        for (var sn = Ke.key, tn = ht; tn !== null; ) {
          if (tn.key === sn) {
            var Zn = Ke.type;
            if (Zn === es) {
              if (tn.tag === _) {
                g(qe, tn.sibling);
                var tr = T(tn, Ke.props.children);
                return tr.return = qe, tr._debugSource = Ke._source, tr._debugOwner = Ke._owner, tr;
              }
            } else if (tn.elementType === Zn || // Keep this check inline so it only runs on the false path:
            bj(tn, Ke) || // Lazy types should reconcile their resolved type.
            // We need to do this after the Hot Reloading check above,
            // because hot reloading has different semantics than prod because
            // it doesn't resuspend. So we can't let the call below suspend.
            typeof Zn == "object" && Zn !== null && Zn.$$typeof === Rn && CW(Zn) === tn.type) {
              g(qe, tn.sibling);
              var va = T(tn, Ke.props);
              return va.ref = AS(qe, tn, Ke), va.return = qe, va._debugSource = Ke._source, va._debugOwner = Ke._owner, va;
            }
            g(qe, tn);
            break;
          } else
            c(qe, tn);
          tn = tn.sibling;
        }
        if (Ke.type === es) {
          var Zr = Cb(Ke.props.children, qe.mode, Nt, Ke.key);
          return Zr.return = qe, Zr;
        } else {
          var so = JL(Ke, qe.mode, Nt);
          return so.ref = AS(qe, ht, Ke), so.return = qe, so;
        }
      }
      function Dr(qe, ht, Ke, Nt) {
        for (var sn = Ke.key, tn = ht; tn !== null; ) {
          if (tn.key === sn)
            if (tn.tag === v && tn.stateNode.containerInfo === Ke.containerInfo && tn.stateNode.implementation === Ke.implementation) {
              g(qe, tn.sibling);
              var Zn = T(tn, Ke.children || []);
              return Zn.return = qe, Zn;
            } else {
              g(qe, tn);
              break;
            }
          else
            c(qe, tn);
          tn = tn.sibling;
        }
        var tr = tM(Ke, qe.mode, Nt);
        return tr.return = qe, tr;
      }
      function wr(qe, ht, Ke, Nt) {
        var sn = typeof Ke == "object" && Ke !== null && Ke.type === es && Ke.key === null;
        if (sn && (Ke = Ke.props.children), typeof Ke == "object" && Ke !== null) {
          switch (Ke.$$typeof) {
            case Pi:
              return $(Tn(qe, ht, Ke, Nt));
            case eo:
              return $(Dr(qe, ht, Ke, Nt));
            case Rn:
              var tn = Ke._payload, Zn = Ke._init;
              return wr(qe, ht, Zn(tn), Nt);
          }
          if (Fi(Ke))
            return pt(qe, ht, Ke, Nt);
          if (Nn(Ke))
            return on(qe, ht, Ke, Nt);
          IC(qe, Ke);
        }
        return typeof Ke == "string" && Ke !== "" || typeof Ke == "number" ? $(Pn(qe, ht, "" + Ke, Nt)) : (typeof Ke == "function" && DC(qe), g(qe, ht));
      }
      return wr;
    }
    var kO = xW(!0), AW = xW(!1);
    function cde(l, c) {
      if (l !== null && c.child !== l.child)
        throw new Error("Resuming work not yet implemented.");
      if (c.child !== null) {
        var g = c.child, y = Ly(g, g.pendingProps);
        for (c.child = y, y.return = c; g.sibling !== null; )
          g = g.sibling, y = y.sibling = Ly(g, g.pendingProps), y.return = c;
        y.sibling = null;
      }
    }
    function fde(l, c) {
      for (var g = l.child; g !== null; )
        Uhe(g, c), g = g.sibling;
    }
    var kS = {}, bb = fs(kS), RS = fs(kS), NC = fs(kS);
    function PC(l) {
      if (l === kS)
        throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
      return l;
    }
    function kW() {
      var l = PC(NC.current);
      return l;
    }
    function AP(l, c) {
      wl(NC, c, l), wl(RS, l, l), wl(bb, kS, l);
      var g = XN(c);
      zo(bb, l), wl(bb, g, l);
    }
    function RO(l) {
      zo(bb, l), zo(RS, l), zo(NC, l);
    }
    function kP() {
      var l = PC(bb.current);
      return l;
    }
    function RW(l) {
      PC(NC.current);
      var c = PC(bb.current), g = qN(c, l.type);
      c !== g && (wl(RS, l, l), wl(bb, g, l));
    }
    function RP(l) {
      RS.current === l && (zo(bb, l), zo(RS, l));
    }
    var dde = 0, IW = 1, DW = 1, IS = 2, Nd = fs(dde);
    function IP(l, c) {
      return (l & c) !== 0;
    }
    function IO(l) {
      return l & IW;
    }
    function DP(l, c) {
      return l & IW | c;
    }
    function pde(l, c) {
      return l | c;
    }
    function vb(l, c) {
      wl(Nd, c, l);
    }
    function DO(l) {
      zo(Nd, l);
    }
    function hde(l, c) {
      var g = l.memoizedState;
      return g !== null ? g.dehydrated !== null : (l.memoizedProps, !0);
    }
    function LC(l) {
      for (var c = l; c !== null; ) {
        if (c.tag === D) {
          var g = c.memoizedState;
          if (g !== null) {
            var y = g.dehydrated;
            if (y === null || uC(y) || yS(y))
              return c;
          }
        } else if (c.tag === ne && // revealOrder undefined can't be trusted because it don't
        // keep track of whether it suspended or not.
        c.memoizedProps.revealOrder !== void 0) {
          var T = (c.flags & Wn) !== xn;
          if (T)
            return c;
        } else if (c.child !== null) {
          c.child.return = c, c = c.child;
          continue;
        }
        if (c === l)
          return null;
        for (; c.sibling === null; ) {
          if (c.return === null || c.return === l)
            return null;
          c = c.return;
        }
        c.sibling.return = c.return, c = c.sibling;
      }
      return null;
    }
    var Uu = (
      /*   */
      0
    ), Ho = (
      /* */
      1
    ), eh = (
      /*  */
      2
    ), Wo = (
      /*    */
      4
    ), Ws = (
      /*   */
      8
    ), NP = [];
    function PP() {
      for (var l = 0; l < NP.length; l++) {
        var c = NP[l];
        c._workInProgressVersionPrimary = null;
      }
      NP.length = 0;
    }
    function mde(l, c) {
      var g = c._getVersion, y = g(c._source);
      l.mutableSourceEagerHydrationData == null ? l.mutableSourceEagerHydrationData = [c, y] : l.mutableSourceEagerHydrationData.push(c, y);
    }
    var nn = n.ReactCurrentDispatcher, DS = n.ReactCurrentBatchConfig, LP, NO;
    LP = /* @__PURE__ */ new Set();
    var Ay = ct, ba = null, Qo = null, jo = null, MC = !1, NS = !1, PS = 0, gde = 0, bde = 25, Et = null, Nf = null, yb = -1, MP = !1;
    function oa() {
      {
        var l = Et;
        Nf === null ? Nf = [l] : Nf.push(l);
      }
    }
    function Zt() {
      {
        var l = Et;
        Nf !== null && (yb++, Nf[yb] !== l && vde(l));
      }
    }
    function PO(l) {
      l != null && !Fi(l) && o("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", Et, typeof l);
    }
    function vde(l) {
      {
        var c = Bn(ba);
        if (!LP.has(c) && (LP.add(c), Nf !== null)) {
          for (var g = "", y = 30, T = 0; T <= yb; T++) {
            for (var R = Nf[T], $ = T === yb ? l : R, W = T + 1 + ". " + R; W.length < y; )
              W += " ";
            W += $ + `
`, g += W;
          }
          o(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`, c, g);
        }
      }
    }
    function Tl() {
      throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
    }
    function FP(l, c) {
      if (MP)
        return !1;
      if (c === null)
        return o("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", Et), !1;
      l.length !== c.length && o(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, Et, "[" + c.join(", ") + "]", "[" + l.join(", ") + "]");
      for (var g = 0; g < c.length && g < l.length; g++)
        if (!cn(l[g], c[g]))
          return !1;
      return !0;
    }
    function LO(l, c, g, y, T, R) {
      Ay = R, ba = c, Nf = l !== null ? l._debugHookTypes : null, yb = -1, MP = l !== null && l.type !== c.type, c.memoizedState = null, c.updateQueue = null, c.lanes = ct, l !== null && l.memoizedState !== null ? nn.current = eQ : Nf !== null ? nn.current = JW : nn.current = KW;
      var $ = g(y, T);
      if (NS) {
        var W = 0;
        do {
          if (NS = !1, PS = 0, W >= bde)
            throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
          W += 1, MP = !1, Qo = null, jo = null, c.updateQueue = null, yb = -1, nn.current = tQ, $ = g(y, T);
        } while (NS);
      }
      nn.current = ZC, c._debugHookTypes = Nf;
      var G = Qo !== null && Qo.next !== null;
      if (Ay = ct, ba = null, Qo = null, jo = null, Et = null, Nf = null, yb = -1, l !== null && (l.flags & zi) !== (c.flags & zi) && // Disable this warning in legacy mode, because legacy Suspense is weird
      // and creates false positives. To make this work in legacy mode, we'd
      // need to mark fibers that commit in an incomplete state, somehow. For
      // now I'll disable the warning that most of the bugs that would trigger
      // it are either exclusive to concurrent mode or exist in both.
      (l.mode & cr) !== In && o("Internal React error: Expected static flag was missing. Please notify the React team."), MC = !1, G)
        throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
      return $;
    }
    function MO() {
      var l = PS !== 0;
      return PS = 0, l;
    }
    function NW(l, c, g) {
      c.updateQueue = l.updateQueue, (c.mode & ls) !== In ? c.flags &= ~(fd | Ra | ka | Un) : c.flags &= ~(ka | Un), l.lanes = yd(l.lanes, g);
    }
    function PW() {
      if (nn.current = ZC, MC) {
        for (var l = ba.memoizedState; l !== null; ) {
          var c = l.queue;
          c !== null && (c.pending = null), l = l.next;
        }
        MC = !1;
      }
      Ay = ct, ba = null, Qo = null, jo = null, Nf = null, yb = -1, Et = null, VW = !1, NS = !1, PS = 0;
    }
    function th() {
      var l = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return jo === null ? ba.memoizedState = jo = l : jo = jo.next = l, jo;
    }
    function Pf() {
      var l;
      if (Qo === null) {
        var c = ba.alternate;
        c !== null ? l = c.memoizedState : l = null;
      } else
        l = Qo.next;
      var g;
      if (jo === null ? g = ba.memoizedState : g = jo.next, g !== null)
        jo = g, g = jo.next, Qo = l;
      else {
        if (l === null)
          throw new Error("Rendered more hooks than during the previous render.");
        Qo = l;
        var y = {
          memoizedState: Qo.memoizedState,
          baseState: Qo.baseState,
          baseQueue: Qo.baseQueue,
          queue: Qo.queue,
          next: null
        };
        jo === null ? ba.memoizedState = jo = y : jo = jo.next = y;
      }
      return jo;
    }
    function LW() {
      return {
        lastEffect: null,
        stores: null
      };
    }
    function $P(l, c) {
      return typeof c == "function" ? c(l) : c;
    }
    function BP(l, c, g) {
      var y = th(), T;
      g !== void 0 ? T = g(c) : T = c, y.memoizedState = y.baseState = T;
      var R = {
        pending: null,
        interleaved: null,
        lanes: ct,
        dispatch: null,
        lastRenderedReducer: l,
        lastRenderedState: T
      };
      y.queue = R;
      var $ = R.dispatch = Sde.bind(null, ba, R);
      return [y.memoizedState, $];
    }
    function UP(l, c, g) {
      var y = Pf(), T = y.queue;
      if (T === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      T.lastRenderedReducer = l;
      var R = Qo, $ = R.baseQueue, W = T.pending;
      if (W !== null) {
        if ($ !== null) {
          var G = $.next, ae = W.next;
          $.next = ae, W.next = G;
        }
        R.baseQueue !== $ && o("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), R.baseQueue = $ = W, T.pending = null;
      }
      if ($ !== null) {
        var me = $.next, Ue = R.baseState, $e = null, tt = null, rt = null, pt = me;
        do {
          var on = pt.lane;
          if (vf(Ay, on)) {
            if (rt !== null) {
              var Tn = {
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: vr,
                action: pt.action,
                hasEagerState: pt.hasEagerState,
                eagerState: pt.eagerState,
                next: null
              };
              rt = rt.next = Tn;
            }
            if (pt.hasEagerState)
              Ue = pt.eagerState;
            else {
              var Dr = pt.action;
              Ue = l(Ue, Dr);
            }
          } else {
            var Pn = {
              lane: on,
              action: pt.action,
              hasEagerState: pt.hasEagerState,
              eagerState: pt.eagerState,
              next: null
            };
            rt === null ? (tt = rt = Pn, $e = Ue) : rt = rt.next = Pn, ba.lanes = er(ba.lanes, on), JS(on);
          }
          pt = pt.next;
        } while (pt !== null && pt !== me);
        rt === null ? $e = Ue : rt.next = tt, cn(Ue, y.memoizedState) || zS(), y.memoizedState = Ue, y.baseState = $e, y.baseQueue = rt, T.lastRenderedState = Ue;
      }
      var wr = T.interleaved;
      if (wr !== null) {
        var qe = wr;
        do {
          var ht = qe.lane;
          ba.lanes = er(ba.lanes, ht), JS(ht), qe = qe.next;
        } while (qe !== wr);
      } else
        $ === null && (T.lanes = ct);
      var Ke = T.dispatch;
      return [y.memoizedState, Ke];
    }
    function zP(l, c, g) {
      var y = Pf(), T = y.queue;
      if (T === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      T.lastRenderedReducer = l;
      var R = T.dispatch, $ = T.pending, W = y.memoizedState;
      if ($ !== null) {
        T.pending = null;
        var G = $.next, ae = G;
        do {
          var me = ae.action;
          W = l(W, me), ae = ae.next;
        } while (ae !== G);
        cn(W, y.memoizedState) || zS(), y.memoizedState = W, y.baseQueue === null && (y.baseState = W), T.lastRenderedState = W;
      }
      return [W, R];
    }
    function yXe(l, c, g) {
    }
    function OXe(l, c, g) {
    }
    function HP(l, c, g) {
      var y = ba, T = th(), R, $ = Hs();
      if ($) {
        if (g === void 0)
          throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
        R = g(), NO || R !== g() && (o("The result of getServerSnapshot should be cached to avoid an infinite loop"), NO = !0);
      } else {
        if (R = c(), !NO) {
          var W = c();
          cn(R, W) || (o("The result of getSnapshot should be cached to avoid an infinite loop"), NO = !0);
        }
        var G = px();
        if (G === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        bf(G, Ay) || MW(y, c, R);
      }
      T.memoizedState = R;
      var ae = {
        value: R,
        getSnapshot: c
      };
      return T.queue = ae, zC($W.bind(null, y, ae, l), [l]), y.flags |= ka, LS(Ho | Ws, FW.bind(null, y, ae, R, c), void 0, null), R;
    }
    function FC(l, c, g) {
      var y = ba, T = Pf(), R = c();
      if (!NO) {
        var $ = c();
        cn(R, $) || (o("The result of getSnapshot should be cached to avoid an infinite loop"), NO = !0);
      }
      var W = T.memoizedState, G = !cn(W, R);
      G && (T.memoizedState = R, zS());
      var ae = T.queue;
      if (FS($W.bind(null, y, ae, l), [l]), ae.getSnapshot !== c || G || // Check if the susbcribe function changed. We can save some memory by
      // checking whether we scheduled a subscription effect above.
      jo !== null && jo.memoizedState.tag & Ho) {
        y.flags |= ka, LS(Ho | Ws, FW.bind(null, y, ae, R, c), void 0, null);
        var me = px();
        if (me === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        bf(me, Ay) || MW(y, c, R);
      }
      return R;
    }
    function MW(l, c, g) {
      l.flags |= em;
      var y = {
        getSnapshot: c,
        value: g
      }, T = ba.updateQueue;
      if (T === null)
        T = LW(), ba.updateQueue = T, T.stores = [y];
      else {
        var R = T.stores;
        R === null ? T.stores = [y] : R.push(y);
      }
    }
    function FW(l, c, g, y) {
      c.value = g, c.getSnapshot = y, BW(c) && UW(l);
    }
    function $W(l, c, g) {
      var y = function() {
        BW(c) && UW(l);
      };
      return g(y);
    }
    function BW(l) {
      var c = l.getSnapshot, g = l.value;
      try {
        var y = c();
        return !cn(g, y);
      } catch {
        return !0;
      }
    }
    function UW(l) {
      var c = Bu(l, Fn);
      c !== null && Zo(c, l, Fn, Yr);
    }
    function $C(l) {
      var c = th();
      typeof l == "function" && (l = l()), c.memoizedState = c.baseState = l;
      var g = {
        pending: null,
        interleaved: null,
        lanes: ct,
        dispatch: null,
        lastRenderedReducer: $P,
        lastRenderedState: l
      };
      c.queue = g;
      var y = g.dispatch = wde.bind(null, ba, g);
      return [c.memoizedState, y];
    }
    function WP(l) {
      return UP($P);
    }
    function QP(l) {
      return zP($P);
    }
    function LS(l, c, g, y) {
      var T = {
        tag: l,
        create: c,
        destroy: g,
        deps: y,
        // Circular
        next: null
      }, R = ba.updateQueue;
      if (R === null)
        R = LW(), ba.updateQueue = R, R.lastEffect = T.next = T;
      else {
        var $ = R.lastEffect;
        if ($ === null)
          R.lastEffect = T.next = T;
        else {
          var W = $.next;
          $.next = T, T.next = W, R.lastEffect = T;
        }
      }
      return T;
    }
    function jP(l) {
      var c = th();
      {
        var g = {
          current: l
        };
        return c.memoizedState = g, g;
      }
    }
    function BC(l) {
      var c = Pf();
      return c.memoizedState;
    }
    function MS(l, c, g, y) {
      var T = th(), R = y === void 0 ? null : y;
      ba.flags |= l, T.memoizedState = LS(Ho | c, g, void 0, R);
    }
    function UC(l, c, g, y) {
      var T = Pf(), R = y === void 0 ? null : y, $ = void 0;
      if (Qo !== null) {
        var W = Qo.memoizedState;
        if ($ = W.destroy, R !== null) {
          var G = W.deps;
          if (FP(R, G)) {
            T.memoizedState = LS(c, g, $, R);
            return;
          }
        }
      }
      ba.flags |= l, T.memoizedState = LS(Ho | c, g, $, R);
    }
    function zC(l, c) {
      return (ba.mode & ls) !== In ? MS(fd | ka | rf, Ws, l, c) : MS(ka | rf, Ws, l, c);
    }
    function FS(l, c) {
      return UC(ka, Ws, l, c);
    }
    function GP(l, c) {
      return MS(Un, eh, l, c);
    }
    function HC(l, c) {
      return UC(Un, eh, l, c);
    }
    function VP(l, c) {
      var g = Un;
      return g |= is, (ba.mode & ls) !== In && (g |= Ra), MS(g, Wo, l, c);
    }
    function WC(l, c) {
      return UC(Un, Wo, l, c);
    }
    function zW(l, c) {
      if (typeof c == "function") {
        var g = c, y = l();
        return g(y), function() {
          g(null);
        };
      } else if (c != null) {
        var T = c;
        T.hasOwnProperty("current") || o("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(T).join(", ") + "}");
        var R = l();
        return T.current = R, function() {
          T.current = null;
        };
      }
    }
    function YP(l, c, g) {
      typeof c != "function" && o("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", c !== null ? typeof c : "null");
      var y = g != null ? g.concat([l]) : null, T = Un;
      return T |= is, (ba.mode & ls) !== In && (T |= Ra), MS(T, Wo, zW.bind(null, c, l), y);
    }
    function QC(l, c, g) {
      typeof c != "function" && o("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", c !== null ? typeof c : "null");
      var y = g != null ? g.concat([l]) : null;
      return UC(Un, Wo, zW.bind(null, c, l), y);
    }
    function yde(l, c) {
    }
    var jC = yde;
    function ZP(l, c) {
      var g = th(), y = c === void 0 ? null : c;
      return g.memoizedState = [l, y], l;
    }
    function GC(l, c) {
      var g = Pf(), y = c === void 0 ? null : c, T = g.memoizedState;
      if (T !== null && y !== null) {
        var R = T[1];
        if (FP(y, R))
          return T[0];
      }
      return g.memoizedState = [l, y], l;
    }
    function XP(l, c) {
      var g = th(), y = c === void 0 ? null : c, T = l();
      return g.memoizedState = [T, y], T;
    }
    function VC(l, c) {
      var g = Pf(), y = c === void 0 ? null : c, T = g.memoizedState;
      if (T !== null && y !== null) {
        var R = T[1];
        if (FP(y, R))
          return T[0];
      }
      var $ = l();
      return g.memoizedState = [$, y], $;
    }
    function qP(l) {
      var c = th();
      return c.memoizedState = l, l;
    }
    function HW(l) {
      var c = Pf(), g = Qo, y = g.memoizedState;
      return QW(c, y, l);
    }
    function WW(l) {
      var c = Pf();
      if (Qo === null)
        return c.memoizedState = l, l;
      var g = Qo.memoizedState;
      return QW(c, g, l);
    }
    function QW(l, c, g) {
      var y = !$g(Ay);
      if (y) {
        if (!cn(g, c)) {
          var T = Np();
          ba.lanes = er(ba.lanes, T), JS(T), l.baseState = !0;
        }
        return c;
      } else
        return l.baseState && (l.baseState = !1, zS()), l.memoizedState = g, g;
    }
    function Ode(l, c, g) {
      var y = Ps();
      Ai(To(y, Wi)), l(!0);
      var T = DS.transition;
      DS.transition = {};
      var R = DS.transition;
      DS.transition._updatedFibers = /* @__PURE__ */ new Set();
      try {
        l(!1), c();
      } finally {
        if (Ai(y), DS.transition = T, T === null && R._updatedFibers) {
          var $ = R._updatedFibers.size;
          $ > 10 && i("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), R._updatedFibers.clear();
        }
      }
    }
    function KP() {
      var l = $C(!1), c = l[0], g = l[1], y = Ode.bind(null, g), T = th();
      return T.memoizedState = y, [c, y];
    }
    function jW() {
      var l = WP(), c = l[0], g = Pf(), y = g.memoizedState;
      return [c, y];
    }
    function GW() {
      var l = QP(), c = l[0], g = Pf(), y = g.memoizedState;
      return [c, y];
    }
    var VW = !1;
    function Ede() {
      return VW;
    }
    function JP() {
      var l = th(), c = px(), g = c.identifierPrefix, y;
      if (Hs()) {
        var T = Lfe();
        y = ":" + g + "R" + T;
        var R = PS++;
        R > 0 && (y += "H" + R.toString(32)), y += ":";
      } else {
        var $ = gde++;
        y = ":" + g + "r" + $.toString(32) + ":";
      }
      return l.memoizedState = y, y;
    }
    function YC() {
      var l = Pf(), c = l.memoizedState;
      return c;
    }
    function Sde(l, c, g) {
      typeof arguments[3] == "function" && o("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var y = Tb(l), T = {
        lane: y,
        action: g,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (YW(l))
        ZW(c, T);
      else {
        var R = dW(l, c, T, y);
        if (R !== null) {
          var $ = nu();
          Zo(R, l, y, $), XW(R, c, y);
        }
      }
      qW(l, y);
    }
    function wde(l, c, g) {
      typeof arguments[3] == "function" && o("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var y = Tb(l), T = {
        lane: y,
        action: g,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (YW(l))
        ZW(c, T);
      else {
        var R = l.alternate;
        if (l.lanes === ct && (R === null || R.lanes === ct)) {
          var $ = c.lastRenderedReducer;
          if ($ !== null) {
            var W;
            W = nn.current, nn.current = Pd;
            try {
              var G = c.lastRenderedState, ae = $(G, g);
              if (T.hasEagerState = !0, T.eagerState = ae, cn(ae, G)) {
                tde(l, c, T, y);
                return;
              }
            } catch {
            } finally {
              nn.current = W;
            }
          }
        }
        var me = dW(l, c, T, y);
        if (me !== null) {
          var Ue = nu();
          Zo(me, l, y, Ue), XW(me, c, y);
        }
      }
      qW(l, y);
    }
    function YW(l) {
      var c = l.alternate;
      return l === ba || c !== null && c === ba;
    }
    function ZW(l, c) {
      NS = MC = !0;
      var g = l.pending;
      g === null ? c.next = c : (c.next = g.next, g.next = c), l.pending = c;
    }
    function XW(l, c, g) {
      if (Ug(g)) {
        var y = c.lanes;
        y = zv(y, l.pendingLanes);
        var T = er(y, g);
        c.lanes = T, Cn(l, T);
      }
    }
    function qW(l, c, g) {
      df(l, c);
    }
    var ZC = {
      readContext: ko,
      useCallback: Tl,
      useContext: Tl,
      useEffect: Tl,
      useImperativeHandle: Tl,
      useInsertionEffect: Tl,
      useLayoutEffect: Tl,
      useMemo: Tl,
      useReducer: Tl,
      useRef: Tl,
      useState: Tl,
      useDebugValue: Tl,
      useDeferredValue: Tl,
      useTransition: Tl,
      useMutableSource: Tl,
      useSyncExternalStore: Tl,
      useId: Tl,
      unstable_isNewReconciler: le
    }, KW = null, JW = null, eQ = null, tQ = null, nh = null, Pd = null, XC = null;
    {
      var eL = function() {
        o("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      }, Jn = function() {
        o("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
      };
      KW = {
        readContext: function(l) {
          return ko(l);
        },
        useCallback: function(l, c) {
          return Et = "useCallback", oa(), PO(c), ZP(l, c);
        },
        useContext: function(l) {
          return Et = "useContext", oa(), ko(l);
        },
        useEffect: function(l, c) {
          return Et = "useEffect", oa(), PO(c), zC(l, c);
        },
        useImperativeHandle: function(l, c, g) {
          return Et = "useImperativeHandle", oa(), PO(g), YP(l, c, g);
        },
        useInsertionEffect: function(l, c) {
          return Et = "useInsertionEffect", oa(), PO(c), GP(l, c);
        },
        useLayoutEffect: function(l, c) {
          return Et = "useLayoutEffect", oa(), PO(c), VP(l, c);
        },
        useMemo: function(l, c) {
          Et = "useMemo", oa(), PO(c);
          var g = nn.current;
          nn.current = nh;
          try {
            return XP(l, c);
          } finally {
            nn.current = g;
          }
        },
        useReducer: function(l, c, g) {
          Et = "useReducer", oa();
          var y = nn.current;
          nn.current = nh;
          try {
            return BP(l, c, g);
          } finally {
            nn.current = y;
          }
        },
        useRef: function(l) {
          return Et = "useRef", oa(), jP(l);
        },
        useState: function(l) {
          Et = "useState", oa();
          var c = nn.current;
          nn.current = nh;
          try {
            return $C(l);
          } finally {
            nn.current = c;
          }
        },
        useDebugValue: function(l, c) {
          return Et = "useDebugValue", oa(), void 0;
        },
        useDeferredValue: function(l) {
          return Et = "useDeferredValue", oa(), qP(l);
        },
        useTransition: function() {
          return Et = "useTransition", oa(), KP();
        },
        useMutableSource: function(l, c, g) {
          return Et = "useMutableSource", oa(), void 0;
        },
        useSyncExternalStore: function(l, c, g) {
          return Et = "useSyncExternalStore", oa(), HP(l, c, g);
        },
        useId: function() {
          return Et = "useId", oa(), JP();
        },
        unstable_isNewReconciler: le
      }, JW = {
        readContext: function(l) {
          return ko(l);
        },
        useCallback: function(l, c) {
          return Et = "useCallback", Zt(), ZP(l, c);
        },
        useContext: function(l) {
          return Et = "useContext", Zt(), ko(l);
        },
        useEffect: function(l, c) {
          return Et = "useEffect", Zt(), zC(l, c);
        },
        useImperativeHandle: function(l, c, g) {
          return Et = "useImperativeHandle", Zt(), YP(l, c, g);
        },
        useInsertionEffect: function(l, c) {
          return Et = "useInsertionEffect", Zt(), GP(l, c);
        },
        useLayoutEffect: function(l, c) {
          return Et = "useLayoutEffect", Zt(), VP(l, c);
        },
        useMemo: function(l, c) {
          Et = "useMemo", Zt();
          var g = nn.current;
          nn.current = nh;
          try {
            return XP(l, c);
          } finally {
            nn.current = g;
          }
        },
        useReducer: function(l, c, g) {
          Et = "useReducer", Zt();
          var y = nn.current;
          nn.current = nh;
          try {
            return BP(l, c, g);
          } finally {
            nn.current = y;
          }
        },
        useRef: function(l) {
          return Et = "useRef", Zt(), jP(l);
        },
        useState: function(l) {
          Et = "useState", Zt();
          var c = nn.current;
          nn.current = nh;
          try {
            return $C(l);
          } finally {
            nn.current = c;
          }
        },
        useDebugValue: function(l, c) {
          return Et = "useDebugValue", Zt(), void 0;
        },
        useDeferredValue: function(l) {
          return Et = "useDeferredValue", Zt(), qP(l);
        },
        useTransition: function() {
          return Et = "useTransition", Zt(), KP();
        },
        useMutableSource: function(l, c, g) {
          return Et = "useMutableSource", Zt(), void 0;
        },
        useSyncExternalStore: function(l, c, g) {
          return Et = "useSyncExternalStore", Zt(), HP(l, c, g);
        },
        useId: function() {
          return Et = "useId", Zt(), JP();
        },
        unstable_isNewReconciler: le
      }, eQ = {
        readContext: function(l) {
          return ko(l);
        },
        useCallback: function(l, c) {
          return Et = "useCallback", Zt(), GC(l, c);
        },
        useContext: function(l) {
          return Et = "useContext", Zt(), ko(l);
        },
        useEffect: function(l, c) {
          return Et = "useEffect", Zt(), FS(l, c);
        },
        useImperativeHandle: function(l, c, g) {
          return Et = "useImperativeHandle", Zt(), QC(l, c, g);
        },
        useInsertionEffect: function(l, c) {
          return Et = "useInsertionEffect", Zt(), HC(l, c);
        },
        useLayoutEffect: function(l, c) {
          return Et = "useLayoutEffect", Zt(), WC(l, c);
        },
        useMemo: function(l, c) {
          Et = "useMemo", Zt();
          var g = nn.current;
          nn.current = Pd;
          try {
            return VC(l, c);
          } finally {
            nn.current = g;
          }
        },
        useReducer: function(l, c, g) {
          Et = "useReducer", Zt();
          var y = nn.current;
          nn.current = Pd;
          try {
            return UP(l, c, g);
          } finally {
            nn.current = y;
          }
        },
        useRef: function(l) {
          return Et = "useRef", Zt(), BC();
        },
        useState: function(l) {
          Et = "useState", Zt();
          var c = nn.current;
          nn.current = Pd;
          try {
            return WP(l);
          } finally {
            nn.current = c;
          }
        },
        useDebugValue: function(l, c) {
          return Et = "useDebugValue", Zt(), jC();
        },
        useDeferredValue: function(l) {
          return Et = "useDeferredValue", Zt(), HW(l);
        },
        useTransition: function() {
          return Et = "useTransition", Zt(), jW();
        },
        useMutableSource: function(l, c, g) {
          return Et = "useMutableSource", Zt(), void 0;
        },
        useSyncExternalStore: function(l, c, g) {
          return Et = "useSyncExternalStore", Zt(), FC(l, c);
        },
        useId: function() {
          return Et = "useId", Zt(), YC();
        },
        unstable_isNewReconciler: le
      }, tQ = {
        readContext: function(l) {
          return ko(l);
        },
        useCallback: function(l, c) {
          return Et = "useCallback", Zt(), GC(l, c);
        },
        useContext: function(l) {
          return Et = "useContext", Zt(), ko(l);
        },
        useEffect: function(l, c) {
          return Et = "useEffect", Zt(), FS(l, c);
        },
        useImperativeHandle: function(l, c, g) {
          return Et = "useImperativeHandle", Zt(), QC(l, c, g);
        },
        useInsertionEffect: function(l, c) {
          return Et = "useInsertionEffect", Zt(), HC(l, c);
        },
        useLayoutEffect: function(l, c) {
          return Et = "useLayoutEffect", Zt(), WC(l, c);
        },
        useMemo: function(l, c) {
          Et = "useMemo", Zt();
          var g = nn.current;
          nn.current = XC;
          try {
            return VC(l, c);
          } finally {
            nn.current = g;
          }
        },
        useReducer: function(l, c, g) {
          Et = "useReducer", Zt();
          var y = nn.current;
          nn.current = XC;
          try {
            return zP(l, c, g);
          } finally {
            nn.current = y;
          }
        },
        useRef: function(l) {
          return Et = "useRef", Zt(), BC();
        },
        useState: function(l) {
          Et = "useState", Zt();
          var c = nn.current;
          nn.current = XC;
          try {
            return QP(l);
          } finally {
            nn.current = c;
          }
        },
        useDebugValue: function(l, c) {
          return Et = "useDebugValue", Zt(), jC();
        },
        useDeferredValue: function(l) {
          return Et = "useDeferredValue", Zt(), WW(l);
        },
        useTransition: function() {
          return Et = "useTransition", Zt(), GW();
        },
        useMutableSource: function(l, c, g) {
          return Et = "useMutableSource", Zt(), void 0;
        },
        useSyncExternalStore: function(l, c, g) {
          return Et = "useSyncExternalStore", Zt(), FC(l, c);
        },
        useId: function() {
          return Et = "useId", Zt(), YC();
        },
        unstable_isNewReconciler: le
      }, nh = {
        readContext: function(l) {
          return eL(), ko(l);
        },
        useCallback: function(l, c) {
          return Et = "useCallback", Jn(), oa(), ZP(l, c);
        },
        useContext: function(l) {
          return Et = "useContext", Jn(), oa(), ko(l);
        },
        useEffect: function(l, c) {
          return Et = "useEffect", Jn(), oa(), zC(l, c);
        },
        useImperativeHandle: function(l, c, g) {
          return Et = "useImperativeHandle", Jn(), oa(), YP(l, c, g);
        },
        useInsertionEffect: function(l, c) {
          return Et = "useInsertionEffect", Jn(), oa(), GP(l, c);
        },
        useLayoutEffect: function(l, c) {
          return Et = "useLayoutEffect", Jn(), oa(), VP(l, c);
        },
        useMemo: function(l, c) {
          Et = "useMemo", Jn(), oa();
          var g = nn.current;
          nn.current = nh;
          try {
            return XP(l, c);
          } finally {
            nn.current = g;
          }
        },
        useReducer: function(l, c, g) {
          Et = "useReducer", Jn(), oa();
          var y = nn.current;
          nn.current = nh;
          try {
            return BP(l, c, g);
          } finally {
            nn.current = y;
          }
        },
        useRef: function(l) {
          return Et = "useRef", Jn(), oa(), jP(l);
        },
        useState: function(l) {
          Et = "useState", Jn(), oa();
          var c = nn.current;
          nn.current = nh;
          try {
            return $C(l);
          } finally {
            nn.current = c;
          }
        },
        useDebugValue: function(l, c) {
          return Et = "useDebugValue", Jn(), oa(), void 0;
        },
        useDeferredValue: function(l) {
          return Et = "useDeferredValue", Jn(), oa(), qP(l);
        },
        useTransition: function() {
          return Et = "useTransition", Jn(), oa(), KP();
        },
        useMutableSource: function(l, c, g) {
          return Et = "useMutableSource", Jn(), oa(), void 0;
        },
        useSyncExternalStore: function(l, c, g) {
          return Et = "useSyncExternalStore", Jn(), oa(), HP(l, c, g);
        },
        useId: function() {
          return Et = "useId", Jn(), oa(), JP();
        },
        unstable_isNewReconciler: le
      }, Pd = {
        readContext: function(l) {
          return eL(), ko(l);
        },
        useCallback: function(l, c) {
          return Et = "useCallback", Jn(), Zt(), GC(l, c);
        },
        useContext: function(l) {
          return Et = "useContext", Jn(), Zt(), ko(l);
        },
        useEffect: function(l, c) {
          return Et = "useEffect", Jn(), Zt(), FS(l, c);
        },
        useImperativeHandle: function(l, c, g) {
          return Et = "useImperativeHandle", Jn(), Zt(), QC(l, c, g);
        },
        useInsertionEffect: function(l, c) {
          return Et = "useInsertionEffect", Jn(), Zt(), HC(l, c);
        },
        useLayoutEffect: function(l, c) {
          return Et = "useLayoutEffect", Jn(), Zt(), WC(l, c);
        },
        useMemo: function(l, c) {
          Et = "useMemo", Jn(), Zt();
          var g = nn.current;
          nn.current = Pd;
          try {
            return VC(l, c);
          } finally {
            nn.current = g;
          }
        },
        useReducer: function(l, c, g) {
          Et = "useReducer", Jn(), Zt();
          var y = nn.current;
          nn.current = Pd;
          try {
            return UP(l, c, g);
          } finally {
            nn.current = y;
          }
        },
        useRef: function(l) {
          return Et = "useRef", Jn(), Zt(), BC();
        },
        useState: function(l) {
          Et = "useState", Jn(), Zt();
          var c = nn.current;
          nn.current = Pd;
          try {
            return WP(l);
          } finally {
            nn.current = c;
          }
        },
        useDebugValue: function(l, c) {
          return Et = "useDebugValue", Jn(), Zt(), jC();
        },
        useDeferredValue: function(l) {
          return Et = "useDeferredValue", Jn(), Zt(), HW(l);
        },
        useTransition: function() {
          return Et = "useTransition", Jn(), Zt(), jW();
        },
        useMutableSource: function(l, c, g) {
          return Et = "useMutableSource", Jn(), Zt(), void 0;
        },
        useSyncExternalStore: function(l, c, g) {
          return Et = "useSyncExternalStore", Jn(), Zt(), FC(l, c);
        },
        useId: function() {
          return Et = "useId", Jn(), Zt(), YC();
        },
        unstable_isNewReconciler: le
      }, XC = {
        readContext: function(l) {
          return eL(), ko(l);
        },
        useCallback: function(l, c) {
          return Et = "useCallback", Jn(), Zt(), GC(l, c);
        },
        useContext: function(l) {
          return Et = "useContext", Jn(), Zt(), ko(l);
        },
        useEffect: function(l, c) {
          return Et = "useEffect", Jn(), Zt(), FS(l, c);
        },
        useImperativeHandle: function(l, c, g) {
          return Et = "useImperativeHandle", Jn(), Zt(), QC(l, c, g);
        },
        useInsertionEffect: function(l, c) {
          return Et = "useInsertionEffect", Jn(), Zt(), HC(l, c);
        },
        useLayoutEffect: function(l, c) {
          return Et = "useLayoutEffect", Jn(), Zt(), WC(l, c);
        },
        useMemo: function(l, c) {
          Et = "useMemo", Jn(), Zt();
          var g = nn.current;
          nn.current = Pd;
          try {
            return VC(l, c);
          } finally {
            nn.current = g;
          }
        },
        useReducer: function(l, c, g) {
          Et = "useReducer", Jn(), Zt();
          var y = nn.current;
          nn.current = Pd;
          try {
            return zP(l, c, g);
          } finally {
            nn.current = y;
          }
        },
        useRef: function(l) {
          return Et = "useRef", Jn(), Zt(), BC();
        },
        useState: function(l) {
          Et = "useState", Jn(), Zt();
          var c = nn.current;
          nn.current = Pd;
          try {
            return QP(l);
          } finally {
            nn.current = c;
          }
        },
        useDebugValue: function(l, c) {
          return Et = "useDebugValue", Jn(), Zt(), jC();
        },
        useDeferredValue: function(l) {
          return Et = "useDeferredValue", Jn(), Zt(), WW(l);
        },
        useTransition: function() {
          return Et = "useTransition", Jn(), Zt(), GW();
        },
        useMutableSource: function(l, c, g) {
          return Et = "useMutableSource", Jn(), Zt(), void 0;
        },
        useSyncExternalStore: function(l, c, g) {
          return Et = "useSyncExternalStore", Jn(), Zt(), FC(l, c);
        },
        useId: function() {
          return Et = "useId", Jn(), Zt(), YC();
        },
        unstable_isNewReconciler: le
      };
    }
    var Ob = e.unstable_now, nQ = 0, qC = -1, $S = -1, KC = -1, tL = !1, JC = !1;
    function rQ() {
      return tL;
    }
    function Tde() {
      JC = !0;
    }
    function _de() {
      tL = !1, JC = !1;
    }
    function Cde() {
      tL = JC, JC = !1;
    }
    function aQ() {
      return nQ;
    }
    function iQ() {
      nQ = Ob();
    }
    function nL(l) {
      $S = Ob(), l.actualStartTime < 0 && (l.actualStartTime = Ob());
    }
    function oQ(l) {
      $S = -1;
    }
    function ex(l, c) {
      if ($S >= 0) {
        var g = Ob() - $S;
        l.actualDuration += g, c && (l.selfBaseDuration = g), $S = -1;
      }
    }
    function rh(l) {
      if (qC >= 0) {
        var c = Ob() - qC;
        qC = -1;
        for (var g = l.return; g !== null; ) {
          switch (g.tag) {
            case m:
              var y = g.stateNode;
              y.effectDuration += c;
              return;
            case I:
              var T = g.stateNode;
              T.effectDuration += c;
              return;
          }
          g = g.return;
        }
      }
    }
    function rL(l) {
      if (KC >= 0) {
        var c = Ob() - KC;
        KC = -1;
        for (var g = l.return; g !== null; ) {
          switch (g.tag) {
            case m:
              var y = g.stateNode;
              y !== null && (y.passiveEffectDuration += c);
              return;
            case I:
              var T = g.stateNode;
              T !== null && (T.passiveEffectDuration += c);
              return;
          }
          g = g.return;
        }
      }
    }
    function ah() {
      qC = Ob();
    }
    function aL() {
      KC = Ob();
    }
    function iL(l) {
      for (var c = l.child; c; )
        l.actualDuration += c.actualDuration, c = c.sibling;
    }
    function ky(l, c) {
      return {
        value: l,
        source: c,
        stack: _s(c),
        digest: null
      };
    }
    function oL(l, c, g) {
      return {
        value: l,
        source: null,
        stack: g ?? null,
        digest: c ?? null
      };
    }
    function xde(l, c) {
      return !0;
    }
    function sL(l, c) {
      try {
        var g = xde(l, c);
        if (g === !1)
          return;
        var y = c.value, T = c.source, R = c.stack, $ = R !== null ? R : "";
        if (y != null && y._suppressLogging) {
          if (l.tag === f)
            return;
          console.error(y);
        }
        var W = T ? Bn(T) : null, G = W ? "The above error occurred in the <" + W + "> component:" : "The above error occurred in one of your React components:", ae;
        if (l.tag === m)
          ae = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`;
        else {
          var me = Bn(l) || "Anonymous";
          ae = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + me + ".");
        }
        var Ue = G + `
` + $ + `

` + ("" + ae);
        console.error(Ue);
      } catch ($e) {
        setTimeout(function() {
          throw $e;
        });
      }
    }
    var Ade = typeof WeakMap == "function" ? WeakMap : Map;
    function sQ(l, c, g) {
      var y = $m(Yr, g);
      y.tag = sP, y.payload = {
        element: null
      };
      var T = c.value;
      return y.callback = function() {
        Ohe(T), sL(l, c);
      }, y;
    }
    function lL(l, c, g) {
      var y = $m(Yr, g);
      y.tag = sP;
      var T = l.type.getDerivedStateFromError;
      if (typeof T == "function") {
        var R = c.value;
        y.payload = function() {
          return T(R);
        }, y.callback = function() {
          vj(l), sL(l, c);
        };
      }
      var $ = l.stateNode;
      return $ !== null && typeof $.componentDidCatch == "function" && (y.callback = function() {
        vj(l), sL(l, c), typeof T != "function" && vhe(this);
        var G = c.value, ae = c.stack;
        this.componentDidCatch(G, {
          componentStack: ae !== null ? ae : ""
        }), typeof T != "function" && ($o(l.lanes, Fn) || o("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", Bn(l) || "Unknown"));
      }), y;
    }
    function lQ(l, c, g) {
      var y = l.pingCache, T;
      if (y === null ? (y = l.pingCache = new Ade(), T = /* @__PURE__ */ new Set(), y.set(c, T)) : (T = y.get(c), T === void 0 && (T = /* @__PURE__ */ new Set(), y.set(c, T))), !T.has(g)) {
        T.add(g);
        var R = Ehe.bind(null, l, c, g);
        za && ew(l, g), c.then(R, R);
      }
    }
    function kde(l, c, g, y) {
      var T = l.updateQueue;
      if (T === null) {
        var R = /* @__PURE__ */ new Set();
        R.add(g), l.updateQueue = R;
      } else
        T.add(g);
    }
    function Rde(l, c) {
      var g = l.tag;
      if ((l.mode & cr) === In && (g === u || g === P || g === H)) {
        var y = l.alternate;
        y ? (l.updateQueue = y.updateQueue, l.memoizedState = y.memoizedState, l.lanes = y.lanes) : (l.updateQueue = null, l.memoizedState = null);
      }
    }
    function uQ(l) {
      var c = l;
      do {
        if (c.tag === D && hde(c))
          return c;
        c = c.return;
      } while (c !== null);
      return null;
    }
    function cQ(l, c, g, y, T) {
      if ((l.mode & cr) === In) {
        if (l === c)
          l.flags |= Ui;
        else {
          if (l.flags |= Wn, g.flags |= tm, g.flags &= ~(pl | Rs), g.tag === f) {
            var R = g.alternate;
            if (R === null)
              g.tag = q;
            else {
              var $ = $m(Yr, Fn);
              $.tag = TC, gb(g, $, Fn);
            }
          }
          g.lanes = er(g.lanes, Fn);
        }
        return l;
      }
      return l.flags |= Ui, l.lanes = T, l;
    }
    function Ide(l, c, g, y, T) {
      if (g.flags |= Rs, za && ew(l, T), y !== null && typeof y == "object" && typeof y.then == "function") {
        var R = y;
        Rde(g), Hs() && g.mode & cr && eW();
        var $ = uQ(c);
        if ($ !== null) {
          $.flags &= ~Xa, cQ($, c, g, l, T), $.mode & cr && lQ(l, R, T), kde($, l, R);
          return;
        } else {
          if (!vd(T)) {
            lQ(l, R, T), zL();
            return;
          }
          var W = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
          y = W;
        }
      } else if (Hs() && g.mode & cr) {
        eW();
        var G = uQ(c);
        if (G !== null) {
          (G.flags & Ui) === xn && (G.flags |= Xa), cQ(G, c, g, l, T), eP(ky(y, g));
          return;
        }
      }
      y = ky(y, g), che(y);
      var ae = c;
      do {
        switch (ae.tag) {
          case m: {
            var me = y;
            ae.flags |= Ui;
            var Ue = xi(T);
            ae.lanes = er(ae.lanes, Ue);
            var $e = sQ(ae, me, Ue);
            cP(ae, $e);
            return;
          }
          case f:
            var tt = y, rt = ae.type, pt = ae.stateNode;
            if ((ae.flags & Wn) === xn && (typeof rt.getDerivedStateFromError == "function" || pt !== null && typeof pt.componentDidCatch == "function" && !uj(pt))) {
              ae.flags |= Ui;
              var on = xi(T);
              ae.lanes = er(ae.lanes, on);
              var Pn = lL(ae, tt, on);
              cP(ae, Pn);
              return;
            }
            break;
        }
        ae = ae.return;
      } while (ae !== null);
    }
    function Dde() {
      return null;
    }
    var BS = n.ReactCurrentOwner, Ld = !1, uL, US, cL, fL, dL, Ry, pL, tx;
    uL = {}, US = {}, cL = {}, fL = {}, dL = {}, Ry = !1, pL = {}, tx = {};
    function eu(l, c, g, y) {
      l === null ? c.child = AW(c, null, g, y) : c.child = kO(c, l.child, g, y);
    }
    function Nde(l, c, g, y) {
      c.child = kO(c, l.child, null, y), c.child = kO(c, null, g, y);
    }
    function fQ(l, c, g, y, T) {
      if (c.type !== c.elementType) {
        var R = g.propTypes;
        R && Wa(
          R,
          y,
          // Resolved props
          "prop",
          Qr(g)
        );
      }
      var $ = g.render, W = c.ref, G, ae;
      AO(c, T), lf(c);
      {
        if (BS.current = c, zl(!0), G = LO(l, c, $, y, W, T), ae = MO(), c.mode & Da) {
          _i(!0);
          try {
            G = LO(l, c, $, y, W, T), ae = MO();
          } finally {
            _i(!1);
          }
        }
        zl(!1);
      }
      return pd(), l !== null && !Ld ? (NW(l, c, T), Bm(l, c, T)) : (Hs() && ae && Y2(c), c.flags |= tf, eu(l, c, G, T), c.child);
    }
    function dQ(l, c, g, y, T) {
      if (l === null) {
        var R = g.type;
        if ($he(R) && g.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
        g.defaultProps === void 0) {
          var $ = R;
          return $ = QO(R), c.tag = H, c.type = $, gL(c, R), pQ(l, c, $, y, T);
        }
        {
          var W = R.propTypes;
          W && Wa(
            W,
            y,
            // Resolved props
            "prop",
            Qr(R)
          );
        }
        var G = KL(g.type, null, y, c, c.mode, T);
        return G.ref = c.ref, G.return = c, c.child = G, G;
      }
      {
        var ae = g.type, me = ae.propTypes;
        me && Wa(
          me,
          y,
          // Resolved props
          "prop",
          Qr(ae)
        );
      }
      var Ue = l.child, $e = SL(l, T);
      if (!$e) {
        var tt = Ue.memoizedProps, rt = g.compare;
        if (rt = rt !== null ? rt : wn, rt(tt, y) && l.ref === c.ref)
          return Bm(l, c, T);
      }
      c.flags |= tf;
      var pt = Ly(Ue, y);
      return pt.ref = c.ref, pt.return = c, c.child = pt, pt;
    }
    function pQ(l, c, g, y, T) {
      if (c.type !== c.elementType) {
        var R = c.elementType;
        if (R.$$typeof === Rn) {
          var $ = R, W = $._payload, G = $._init;
          try {
            R = G(W);
          } catch {
            R = null;
          }
          var ae = R && R.propTypes;
          ae && Wa(
            ae,
            y,
            // Resolved (SimpleMemoComponent has no defaultProps)
            "prop",
            Qr(R)
          );
        }
      }
      if (l !== null) {
        var me = l.memoizedProps;
        if (wn(me, y) && l.ref === c.ref && // Prevent bailout if the implementation changed due to hot reload.
        c.type === l.type)
          if (Ld = !1, c.pendingProps = y = me, SL(l, T))
            (l.flags & tm) !== xn && (Ld = !0);
          else
            return c.lanes = l.lanes, Bm(l, c, T);
      }
      return hL(l, c, g, y, T);
    }
    function hQ(l, c, g) {
      var y = c.pendingProps, T = y.children, R = l !== null ? l.memoizedState : null;
      if (y.mode === "hidden" || B)
        if ((c.mode & cr) === In) {
          var $ = {
            baseLanes: ct,
            cachePool: null,
            transitions: null
          };
          c.memoizedState = $, hx(c, g);
        } else if ($o(g, us)) {
          var Ue = {
            baseLanes: ct,
            cachePool: null,
            transitions: null
          };
          c.memoizedState = Ue;
          var $e = R !== null ? R.baseLanes : g;
          hx(c, $e);
        } else {
          var W = null, G;
          if (R !== null) {
            var ae = R.baseLanes;
            G = er(ae, g);
          } else
            G = g;
          c.lanes = c.childLanes = us;
          var me = {
            baseLanes: G,
            cachePool: W,
            transitions: null
          };
          return c.memoizedState = me, c.updateQueue = null, hx(c, G), null;
        }
      else {
        var tt;
        R !== null ? (tt = er(R.baseLanes, g), c.memoizedState = null) : tt = g, hx(c, tt);
      }
      return eu(l, c, T, g), c.child;
    }
    function Pde(l, c, g) {
      var y = c.pendingProps;
      return eu(l, c, y, g), c.child;
    }
    function Lde(l, c, g) {
      var y = c.pendingProps.children;
      return eu(l, c, y, g), c.child;
    }
    function Mde(l, c, g) {
      {
        c.flags |= Un;
        {
          var y = c.stateNode;
          y.effectDuration = 0, y.passiveEffectDuration = 0;
        }
      }
      var T = c.pendingProps, R = T.children;
      return eu(l, c, R, g), c.child;
    }
    function mQ(l, c) {
      var g = c.ref;
      (l === null && g !== null || l !== null && l.ref !== g) && (c.flags |= qa, c.flags |= fc);
    }
    function hL(l, c, g, y, T) {
      if (c.type !== c.elementType) {
        var R = g.propTypes;
        R && Wa(
          R,
          y,
          // Resolved props
          "prop",
          Qr(g)
        );
      }
      var $;
      {
        var W = SO(c, g, !0);
        $ = wO(c, W);
      }
      var G, ae;
      AO(c, T), lf(c);
      {
        if (BS.current = c, zl(!0), G = LO(l, c, g, y, $, T), ae = MO(), c.mode & Da) {
          _i(!0);
          try {
            G = LO(l, c, g, y, $, T), ae = MO();
          } finally {
            _i(!1);
          }
        }
        zl(!1);
      }
      return pd(), l !== null && !Ld ? (NW(l, c, T), Bm(l, c, T)) : (Hs() && ae && Y2(c), c.flags |= tf, eu(l, c, G, T), c.child);
    }
    function gQ(l, c, g, y, T) {
      {
        switch (Jhe(c)) {
          case !1: {
            var R = c.stateNode, $ = c.type, W = new $(c.memoizedProps, R.context), G = W.state;
            R.updater.enqueueSetState(R, G, null);
            break;
          }
          case !0: {
            c.flags |= Wn, c.flags |= Ui;
            var ae = new Error("Simulated error coming from DevTools"), me = xi(T);
            c.lanes = er(c.lanes, me);
            var Ue = lL(c, ky(ae, c), me);
            cP(c, Ue);
            break;
          }
        }
        if (c.type !== c.elementType) {
          var $e = g.propTypes;
          $e && Wa(
            $e,
            y,
            // Resolved props
            "prop",
            Qr(g)
          );
        }
      }
      var tt;
      Jp(g) ? (tt = !0, pC(c)) : tt = !1, AO(c, T);
      var rt = c.stateNode, pt;
      rt === null ? (rx(l, c), wW(c, g, y), SP(c, g, y, T), pt = !0) : l === null ? pt = lde(c, g, y, T) : pt = ude(l, c, g, y, T);
      var on = mL(l, c, g, pt, tt, T);
      {
        var Pn = c.stateNode;
        pt && Pn.props !== y && (Ry || o("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", Bn(c) || "a component"), Ry = !0);
      }
      return on;
    }
    function mL(l, c, g, y, T, R) {
      mQ(l, c);
      var $ = (c.flags & Wn) !== xn;
      if (!y && !$)
        return T && X7(c, g, !1), Bm(l, c, R);
      var W = c.stateNode;
      BS.current = c;
      var G;
      if ($ && typeof g.getDerivedStateFromError != "function")
        G = null, oQ();
      else {
        lf(c);
        {
          if (zl(!0), G = W.render(), c.mode & Da) {
            _i(!0);
            try {
              W.render();
            } finally {
              _i(!1);
            }
          }
          zl(!1);
        }
        pd();
      }
      return c.flags |= tf, l !== null && $ ? Nde(l, c, G, R) : eu(l, c, G, R), c.memoizedState = W.state, T && X7(c, g, !0), c.child;
    }
    function bQ(l) {
      var c = l.stateNode;
      c.pendingContext ? Y7(l, c.pendingContext, c.pendingContext !== c.context) : c.context && Y7(l, c.context, !1), AP(l, c.containerInfo);
    }
    function Fde(l, c, g) {
      if (bQ(c), l === null)
        throw new Error("Should have a current fiber. This is a bug in React.");
      var y = c.pendingProps, T = c.memoizedState, R = T.element;
      mW(l, c), AC(c, y, null, g);
      var $ = c.memoizedState;
      c.stateNode;
      var W = $.element;
      if (T.isDehydrated) {
        var G = {
          element: W,
          isDehydrated: !1,
          cache: $.cache,
          pendingSuspenseBoundaries: $.pendingSuspenseBoundaries,
          transitions: $.transitions
        }, ae = c.updateQueue;
        if (ae.baseState = G, c.memoizedState = G, c.flags & Xa) {
          var me = ky(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), c);
          return vQ(l, c, W, g, me);
        } else if (W !== R) {
          var Ue = ky(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), c);
          return vQ(l, c, W, g, Ue);
        } else {
          zfe(c);
          var $e = AW(c, null, W, g);
          c.child = $e;
          for (var tt = $e; tt; )
            tt.flags = tt.flags & ~_a | dl, tt = tt.sibling;
        }
      } else {
        if (CO(), W === R)
          return Bm(l, c, g);
        eu(l, c, W, g);
      }
      return c.child;
    }
    function vQ(l, c, g, y, T) {
      return CO(), eP(T), c.flags |= Xa, eu(l, c, g, y), c.child;
    }
    function $de(l, c, g) {
      RW(c), l === null && J2(c);
      var y = c.type, T = c.pendingProps, R = l !== null ? l.memoizedProps : null, $ = T.children, W = uS(y, T);
      return W ? $ = null : R !== null && uS(y, R) && (c.flags |= Vr), mQ(l, c), eu(l, c, $, g), c.child;
    }
    function Bde(l, c) {
      return l === null && J2(c), null;
    }
    function Ude(l, c, g, y) {
      rx(l, c);
      var T = c.pendingProps, R = g, $ = R._payload, W = R._init, G = W($);
      c.type = G;
      var ae = c.tag = Bhe(G), me = Dd(G, T), Ue;
      switch (ae) {
        case u:
          return gL(c, G), c.type = G = QO(G), Ue = hL(null, c, G, me, y), Ue;
        case f:
          return c.type = G = GL(G), Ue = gQ(null, c, G, me, y), Ue;
        case P:
          return c.type = G = VL(G), Ue = fQ(null, c, G, me, y), Ue;
        case M: {
          if (c.type !== c.elementType) {
            var $e = G.propTypes;
            $e && Wa(
              $e,
              me,
              // Resolved for outer only
              "prop",
              Qr(G)
            );
          }
          return Ue = dQ(
            null,
            c,
            G,
            Dd(G.type, me),
            // The inner type can have defaults too
            y
          ), Ue;
        }
      }
      var tt = "";
      throw G !== null && typeof G == "object" && G.$$typeof === Rn && (tt = " Did you wrap a component in React.lazy() more than once?"), new Error("Element type is invalid. Received a promise that resolves to: " + G + ". " + ("Lazy element type must resolve to a class or function." + tt));
    }
    function zde(l, c, g, y, T) {
      rx(l, c), c.tag = f;
      var R;
      return Jp(g) ? (R = !0, pC(c)) : R = !1, AO(c, T), wW(c, g, y), SP(c, g, y, T), mL(null, c, g, !0, R, T);
    }
    function Hde(l, c, g, y) {
      rx(l, c);
      var T = c.pendingProps, R;
      {
        var $ = SO(c, g, !1);
        R = wO(c, $);
      }
      AO(c, y);
      var W, G;
      lf(c);
      {
        if (g.prototype && typeof g.prototype.render == "function") {
          var ae = Qr(g) || "Unknown";
          uL[ae] || (o("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", ae, ae), uL[ae] = !0);
        }
        c.mode & Da && Id.recordLegacyContextWarning(c, null), zl(!0), BS.current = c, W = LO(null, c, g, T, R, y), G = MO(), zl(!1);
      }
      if (pd(), c.flags |= tf, typeof W == "object" && W !== null && typeof W.render == "function" && W.$$typeof === void 0) {
        var me = Qr(g) || "Unknown";
        US[me] || (o("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", me, me, me), US[me] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof W == "object" && W !== null && typeof W.render == "function" && W.$$typeof === void 0
      ) {
        {
          var Ue = Qr(g) || "Unknown";
          US[Ue] || (o("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", Ue, Ue, Ue), US[Ue] = !0);
        }
        c.tag = f, c.memoizedState = null, c.updateQueue = null;
        var $e = !1;
        return Jp(g) ? ($e = !0, pC(c)) : $e = !1, c.memoizedState = W.state !== null && W.state !== void 0 ? W.state : null, uP(c), SW(c, W), SP(c, g, T, y), mL(null, c, g, !0, $e, y);
      } else {
        if (c.tag = u, c.mode & Da) {
          _i(!0);
          try {
            W = LO(null, c, g, T, R, y), G = MO();
          } finally {
            _i(!1);
          }
        }
        return Hs() && G && Y2(c), eu(null, c, W, y), gL(c, g), c.child;
      }
    }
    function gL(l, c) {
      {
        if (c && c.childContextTypes && o("%s(...): childContextTypes cannot be defined on a function component.", c.displayName || c.name || "Component"), l.ref !== null) {
          var g = "", y = ro();
          y && (g += `

Check the render method of \`` + y + "`.");
          var T = y || "", R = l._debugSource;
          R && (T = R.fileName + ":" + R.lineNumber), dL[T] || (dL[T] = !0, o("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", g));
        }
        if (typeof c.getDerivedStateFromProps == "function") {
          var $ = Qr(c) || "Unknown";
          fL[$] || (o("%s: Function components do not support getDerivedStateFromProps.", $), fL[$] = !0);
        }
        if (typeof c.contextType == "object" && c.contextType !== null) {
          var W = Qr(c) || "Unknown";
          cL[W] || (o("%s: Function components do not support contextType.", W), cL[W] = !0);
        }
      }
    }
    var bL = {
      dehydrated: null,
      treeContext: null,
      retryLane: vr
    };
    function vL(l) {
      return {
        baseLanes: l,
        cachePool: Dde(),
        transitions: null
      };
    }
    function Wde(l, c) {
      var g = null;
      return {
        baseLanes: er(l.baseLanes, c),
        cachePool: g,
        transitions: l.transitions
      };
    }
    function Qde(l, c, g, y) {
      if (c !== null) {
        var T = c.memoizedState;
        if (T === null)
          return !1;
      }
      return IP(l, IS);
    }
    function jde(l, c) {
      return yd(l.childLanes, c);
    }
    function yQ(l, c, g) {
      var y = c.pendingProps;
      eme(c) && (c.flags |= Wn);
      var T = Nd.current, R = !1, $ = (c.flags & Wn) !== xn;
      if ($ || Qde(T, l) ? (R = !0, c.flags &= ~Wn) : (l === null || l.memoizedState !== null) && (T = pde(T, DW)), T = IO(T), vb(c, T), l === null) {
        J2(c);
        var W = c.memoizedState;
        if (W !== null) {
          var G = W.dehydrated;
          if (G !== null)
            return Xde(c, G);
        }
        var ae = y.children, me = y.fallback;
        if (R) {
          var Ue = Gde(c, ae, me, g), $e = c.child;
          return $e.memoizedState = vL(g), c.memoizedState = bL, Ue;
        } else
          return yL(c, ae);
      } else {
        var tt = l.memoizedState;
        if (tt !== null) {
          var rt = tt.dehydrated;
          if (rt !== null)
            return qde(l, c, $, y, rt, tt, g);
        }
        if (R) {
          var pt = y.fallback, on = y.children, Pn = Yde(l, c, on, pt, g), Tn = c.child, Dr = l.child.memoizedState;
          return Tn.memoizedState = Dr === null ? vL(g) : Wde(Dr, g), Tn.childLanes = jde(l, g), c.memoizedState = bL, Pn;
        } else {
          var wr = y.children, qe = Vde(l, c, wr, g);
          return c.memoizedState = null, qe;
        }
      }
    }
    function yL(l, c, g) {
      var y = l.mode, T = {
        mode: "visible",
        children: c
      }, R = OL(T, y);
      return R.return = l, l.child = R, R;
    }
    function Gde(l, c, g, y) {
      var T = l.mode, R = l.child, $ = {
        mode: "hidden",
        children: c
      }, W, G;
      return (T & cr) === In && R !== null ? (W = R, W.childLanes = ct, W.pendingProps = $, l.mode & Dn && (W.actualDuration = 0, W.actualStartTime = -1, W.selfBaseDuration = 0, W.treeBaseDuration = 0), G = Cb(g, T, y, null)) : (W = OL($, T), G = Cb(g, T, y, null)), W.return = l, G.return = l, W.sibling = G, l.child = W, G;
    }
    function OL(l, c, g) {
      return Oj(l, c, ct, null);
    }
    function OQ(l, c) {
      return Ly(l, c);
    }
    function Vde(l, c, g, y) {
      var T = l.child, R = T.sibling, $ = OQ(T, {
        mode: "visible",
        children: g
      });
      if ((c.mode & cr) === In && ($.lanes = y), $.return = c, $.sibling = null, R !== null) {
        var W = c.deletions;
        W === null ? (c.deletions = [R], c.flags |= Wr) : W.push(R);
      }
      return c.child = $, $;
    }
    function Yde(l, c, g, y, T) {
      var R = c.mode, $ = l.child, W = $.sibling, G = {
        mode: "hidden",
        children: g
      }, ae;
      if (
        // In legacy mode, we commit the primary tree as if it successfully
        // completed, even though it's in an inconsistent state.
        (R & cr) === In && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        c.child !== $
      ) {
        var me = c.child;
        ae = me, ae.childLanes = ct, ae.pendingProps = G, c.mode & Dn && (ae.actualDuration = 0, ae.actualStartTime = -1, ae.selfBaseDuration = $.selfBaseDuration, ae.treeBaseDuration = $.treeBaseDuration), c.deletions = null;
      } else
        ae = OQ($, G), ae.subtreeFlags = $.subtreeFlags & zi;
      var Ue;
      return W !== null ? Ue = Ly(W, y) : (Ue = Cb(y, R, T, null), Ue.flags |= _a), Ue.return = c, ae.return = c, ae.sibling = Ue, c.child = ae, Ue;
    }
    function nx(l, c, g, y) {
      y !== null && eP(y), kO(c, l.child, null, g);
      var T = c.pendingProps, R = T.children, $ = yL(c, R);
      return $.flags |= _a, c.memoizedState = null, $;
    }
    function Zde(l, c, g, y, T) {
      var R = c.mode, $ = {
        mode: "visible",
        children: g
      }, W = OL($, R), G = Cb(y, R, T, null);
      return G.flags |= _a, W.return = c, G.return = c, W.sibling = G, c.child = W, (c.mode & cr) !== In && kO(c, l.child, null, T), G;
    }
    function Xde(l, c, g) {
      return (l.mode & cr) === In ? (o("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components."), l.lanes = Fn) : yS(c) ? l.lanes = md : l.lanes = us, null;
    }
    function qde(l, c, g, y, T, R, $) {
      if (g)
        if (c.flags & Xa) {
          c.flags &= ~Xa;
          var qe = oL(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
          return nx(l, c, $, qe);
        } else {
          if (c.memoizedState !== null)
            return c.child = l.child, c.flags |= Wn, null;
          var ht = y.children, Ke = y.fallback, Nt = Zde(l, c, ht, Ke, $), sn = c.child;
          return sn.memoizedState = vL($), c.memoizedState = bL, Nt;
        }
      else {
        if (Bfe(), (c.mode & cr) === In)
          return nx(
            l,
            c,
            $,
            // TODO: When we delete legacy mode, we should make this error argument
            // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null
          );
        if (yS(T)) {
          var W, G, ae;
          {
            var me = O2(T);
            W = me.digest, G = me.message, ae = me.stack;
          }
          var Ue;
          G ? Ue = new Error(G) : Ue = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
          var $e = oL(Ue, W, ae);
          return nx(l, c, $, $e);
        }
        var tt = $o($, l.childLanes);
        if (Ld || tt) {
          var rt = px();
          if (rt !== null) {
            var pt = zg(rt, $);
            if (pt !== vr && pt !== R.retryLane) {
              R.retryLane = pt;
              var on = Yr;
              Bu(l, pt), Zo(rt, l, pt, on);
            }
          }
          zL();
          var Pn = oL(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
          return nx(l, c, $, Pn);
        } else if (uC(T)) {
          c.flags |= Wn, c.child = l.child;
          var Tn = She.bind(null, l);
          return E2(T, Tn), null;
        } else {
          Hfe(c, T, R.treeContext);
          var Dr = y.children, wr = yL(c, Dr);
          return wr.flags |= dl, wr;
        }
      }
    }
    function EQ(l, c, g) {
      l.lanes = er(l.lanes, c);
      var y = l.alternate;
      y !== null && (y.lanes = er(y.lanes, c)), iP(l.return, c, g);
    }
    function Kde(l, c, g) {
      for (var y = c; y !== null; ) {
        if (y.tag === D) {
          var T = y.memoizedState;
          T !== null && EQ(y, g, l);
        } else if (y.tag === ne)
          EQ(y, g, l);
        else if (y.child !== null) {
          y.child.return = y, y = y.child;
          continue;
        }
        if (y === l)
          return;
        for (; y.sibling === null; ) {
          if (y.return === null || y.return === l)
            return;
          y = y.return;
        }
        y.sibling.return = y.return, y = y.sibling;
      }
    }
    function Jde(l) {
      for (var c = l, g = null; c !== null; ) {
        var y = c.alternate;
        y !== null && LC(y) === null && (g = c), c = c.sibling;
      }
      return g;
    }
    function epe(l) {
      if (l !== void 0 && l !== "forwards" && l !== "backwards" && l !== "together" && !pL[l])
        if (pL[l] = !0, typeof l == "string")
          switch (l.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards": {
              o('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', l, l.toLowerCase());
              break;
            }
            case "forward":
            case "backward": {
              o('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', l, l.toLowerCase());
              break;
            }
            default:
              o('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', l);
              break;
          }
        else
          o('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', l);
    }
    function tpe(l, c) {
      l !== void 0 && !tx[l] && (l !== "collapsed" && l !== "hidden" ? (tx[l] = !0, o('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', l)) : c !== "forwards" && c !== "backwards" && (tx[l] = !0, o('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', l)));
    }
    function SQ(l, c) {
      {
        var g = Fi(l), y = !g && typeof Nn(l) == "function";
        if (g || y) {
          var T = g ? "array" : "iterable";
          return o("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", T, c, T), !1;
        }
      }
      return !0;
    }
    function npe(l, c) {
      if ((c === "forwards" || c === "backwards") && l !== void 0 && l !== null && l !== !1)
        if (Fi(l)) {
          for (var g = 0; g < l.length; g++)
            if (!SQ(l[g], g))
              return;
        } else {
          var y = Nn(l);
          if (typeof y == "function") {
            var T = y.call(l);
            if (T)
              for (var R = T.next(), $ = 0; !R.done; R = T.next()) {
                if (!SQ(R.value, $))
                  return;
                $++;
              }
          } else
            o('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', c);
        }
    }
    function EL(l, c, g, y, T) {
      var R = l.memoizedState;
      R === null ? l.memoizedState = {
        isBackwards: c,
        rendering: null,
        renderingStartTime: 0,
        last: y,
        tail: g,
        tailMode: T
      } : (R.isBackwards = c, R.rendering = null, R.renderingStartTime = 0, R.last = y, R.tail = g, R.tailMode = T);
    }
    function wQ(l, c, g) {
      var y = c.pendingProps, T = y.revealOrder, R = y.tail, $ = y.children;
      epe(T), tpe(R, T), npe($, T), eu(l, c, $, g);
      var W = Nd.current, G = IP(W, IS);
      if (G)
        W = DP(W, IS), c.flags |= Wn;
      else {
        var ae = l !== null && (l.flags & Wn) !== xn;
        ae && Kde(c, c.child, g), W = IO(W);
      }
      if (vb(c, W), (c.mode & cr) === In)
        c.memoizedState = null;
      else
        switch (T) {
          case "forwards": {
            var me = Jde(c.child), Ue;
            me === null ? (Ue = c.child, c.child = null) : (Ue = me.sibling, me.sibling = null), EL(
              c,
              !1,
              // isBackwards
              Ue,
              me,
              R
            );
            break;
          }
          case "backwards": {
            var $e = null, tt = c.child;
            for (c.child = null; tt !== null; ) {
              var rt = tt.alternate;
              if (rt !== null && LC(rt) === null) {
                c.child = tt;
                break;
              }
              var pt = tt.sibling;
              tt.sibling = $e, $e = tt, tt = pt;
            }
            EL(
              c,
              !0,
              // isBackwards
              $e,
              null,
              // last
              R
            );
            break;
          }
          case "together": {
            EL(
              c,
              !1,
              // isBackwards
              null,
              // tail
              null,
              // last
              void 0
            );
            break;
          }
          default:
            c.memoizedState = null;
        }
      return c.child;
    }
    function rpe(l, c, g) {
      AP(c, c.stateNode.containerInfo);
      var y = c.pendingProps;
      return l === null ? c.child = kO(c, null, y, g) : eu(l, c, y, g), c.child;
    }
    var TQ = !1;
    function ape(l, c, g) {
      var y = c.type, T = y._context, R = c.pendingProps, $ = c.memoizedProps, W = R.value;
      {
        "value" in R || TQ || (TQ = !0, o("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
        var G = c.type.propTypes;
        G && Wa(G, R, "prop", "Context.Provider");
      }
      if (fW(c, T, W), $ !== null) {
        var ae = $.value;
        if (cn(ae, W)) {
          if ($.children === R.children && !fC())
            return Bm(l, c, g);
        } else
          Kfe(c, T, g);
      }
      var me = R.children;
      return eu(l, c, me, g), c.child;
    }
    var _Q = !1;
    function ipe(l, c, g) {
      var y = c.type;
      y._context === void 0 ? y !== y.Consumer && (_Q || (_Q = !0, o("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : y = y._context;
      var T = c.pendingProps, R = T.children;
      typeof R != "function" && o("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), AO(c, g);
      var $ = ko(y);
      lf(c);
      var W;
      return BS.current = c, zl(!0), W = R($), zl(!1), pd(), c.flags |= tf, eu(l, c, W, g), c.child;
    }
    function zS() {
      Ld = !0;
    }
    function rx(l, c) {
      (c.mode & cr) === In && l !== null && (l.alternate = null, c.alternate = null, c.flags |= _a);
    }
    function Bm(l, c, g) {
      return l !== null && (c.dependencies = l.dependencies), oQ(), JS(c.lanes), $o(g, c.childLanes) ? (cde(l, c), c.child) : null;
    }
    function ope(l, c, g) {
      {
        var y = c.return;
        if (y === null)
          throw new Error("Cannot swap the root fiber.");
        if (l.alternate = null, c.alternate = null, g.index = c.index, g.sibling = c.sibling, g.return = c.return, g.ref = c.ref, c === y.child)
          y.child = g;
        else {
          var T = y.child;
          if (T === null)
            throw new Error("Expected parent to have a child.");
          for (; T.sibling !== c; )
            if (T = T.sibling, T === null)
              throw new Error("Expected to find the previous sibling.");
          T.sibling = g;
        }
        var R = y.deletions;
        return R === null ? (y.deletions = [l], y.flags |= Wr) : R.push(l), g.flags |= _a, g;
      }
    }
    function SL(l, c) {
      var g = l.lanes;
      return !!$o(g, c);
    }
    function spe(l, c, g) {
      switch (c.tag) {
        case m:
          bQ(c), c.stateNode, CO();
          break;
        case O:
          RW(c);
          break;
        case f: {
          var y = c.type;
          Jp(y) && pC(c);
          break;
        }
        case v:
          AP(c, c.stateNode.containerInfo);
          break;
        case N: {
          var T = c.memoizedProps.value, R = c.type._context;
          fW(c, R, T);
          break;
        }
        case I:
          {
            var $ = $o(g, c.childLanes);
            $ && (c.flags |= Un);
            {
              var W = c.stateNode;
              W.effectDuration = 0, W.passiveEffectDuration = 0;
            }
          }
          break;
        case D: {
          var G = c.memoizedState;
          if (G !== null) {
            if (G.dehydrated !== null)
              return vb(c, IO(Nd.current)), c.flags |= Wn, null;
            var ae = c.child, me = ae.childLanes;
            if ($o(g, me))
              return yQ(l, c, g);
            vb(c, IO(Nd.current));
            var Ue = Bm(l, c, g);
            return Ue !== null ? Ue.sibling : null;
          } else
            vb(c, IO(Nd.current));
          break;
        }
        case ne: {
          var $e = (l.flags & Wn) !== xn, tt = $o(g, c.childLanes);
          if ($e) {
            if (tt)
              return wQ(l, c, g);
            c.flags |= Wn;
          }
          var rt = c.memoizedState;
          if (rt !== null && (rt.rendering = null, rt.tail = null, rt.lastEffect = null), vb(c, Nd.current), tt)
            break;
          return null;
        }
        case ue:
        case ee:
          return c.lanes = ct, hQ(l, c, g);
      }
      return Bm(l, c, g);
    }
    function CQ(l, c, g) {
      if (c._debugNeedsRemount && l !== null)
        return ope(l, c, KL(c.type, c.key, c.pendingProps, c._debugOwner || null, c.mode, c.lanes));
      if (l !== null) {
        var y = l.memoizedProps, T = c.pendingProps;
        if (y !== T || fC() || // Force a re-render if the implementation changed due to hot reload:
        c.type !== l.type)
          Ld = !0;
        else {
          var R = SL(l, g);
          if (!R && // If this is the second pass of an error or suspense boundary, there
          // may not be work scheduled on `current`, so we check for this flag.
          (c.flags & Wn) === xn)
            return Ld = !1, spe(l, c, g);
          (l.flags & tm) !== xn ? Ld = !0 : Ld = !1;
        }
      } else if (Ld = !1, Hs() && Nfe(c)) {
        var $ = c.index, W = Pfe();
        J7(c, W, $);
      }
      switch (c.lanes = ct, c.tag) {
        case p:
          return Hde(l, c, c.type, g);
        case Y: {
          var G = c.elementType;
          return Ude(l, c, G, g);
        }
        case u: {
          var ae = c.type, me = c.pendingProps, Ue = c.elementType === ae ? me : Dd(ae, me);
          return hL(l, c, ae, Ue, g);
        }
        case f: {
          var $e = c.type, tt = c.pendingProps, rt = c.elementType === $e ? tt : Dd($e, tt);
          return gQ(l, c, $e, rt, g);
        }
        case m:
          return Fde(l, c, g);
        case O:
          return $de(l, c, g);
        case w:
          return Bde(l, c);
        case D:
          return yQ(l, c, g);
        case v:
          return rpe(l, c, g);
        case P: {
          var pt = c.type, on = c.pendingProps, Pn = c.elementType === pt ? on : Dd(pt, on);
          return fQ(l, c, pt, Pn, g);
        }
        case _:
          return Pde(l, c, g);
        case C:
          return Lde(l, c, g);
        case I:
          return Mde(l, c, g);
        case N:
          return ape(l, c, g);
        case A:
          return ipe(l, c, g);
        case M: {
          var Tn = c.type, Dr = c.pendingProps, wr = Dd(Tn, Dr);
          if (c.type !== c.elementType) {
            var qe = Tn.propTypes;
            qe && Wa(
              qe,
              wr,
              // Resolved for outer only
              "prop",
              Qr(Tn)
            );
          }
          return wr = Dd(Tn.type, wr), dQ(l, c, Tn, wr, g);
        }
        case H:
          return pQ(l, c, c.type, c.pendingProps, g);
        case q: {
          var ht = c.type, Ke = c.pendingProps, Nt = c.elementType === ht ? Ke : Dd(ht, Ke);
          return zde(l, c, ht, Nt, g);
        }
        case ne:
          return wQ(l, c, g);
        case J:
          break;
        case ue:
          return hQ(l, c, g);
      }
      throw new Error("Unknown unit of work tag (" + c.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function FO(l) {
      l.flags |= Un;
    }
    function xQ(l) {
      l.flags |= qa, l.flags |= fc;
    }
    var AQ, wL, kQ, RQ;
    AQ = function(l, c, g, y) {
      for (var T = c.child; T !== null; ) {
        if (T.tag === O || T.tag === w)
          t2(l, T.stateNode);
        else if (T.tag !== v) {
          if (T.child !== null) {
            T.child.return = T, T = T.child;
            continue;
          }
        }
        if (T === c)
          return;
        for (; T.sibling === null; ) {
          if (T.return === null || T.return === c)
            return;
          T = T.return;
        }
        T.sibling.return = T.return, T = T.sibling;
      }
    }, wL = function(l, c) {
    }, kQ = function(l, c, g, y, T) {
      var R = l.memoizedProps;
      if (R !== y) {
        var $ = c.stateNode, W = kP(), G = r2($, g, R, y, T, W);
        c.updateQueue = G, G && FO(c);
      }
    }, RQ = function(l, c, g, y) {
      g !== y && FO(c);
    };
    function HS(l, c) {
      if (!Hs())
        switch (l.tailMode) {
          case "hidden": {
            for (var g = l.tail, y = null; g !== null; )
              g.alternate !== null && (y = g), g = g.sibling;
            y === null ? l.tail = null : y.sibling = null;
            break;
          }
          case "collapsed": {
            for (var T = l.tail, R = null; T !== null; )
              T.alternate !== null && (R = T), T = T.sibling;
            R === null ? !c && l.tail !== null ? l.tail.sibling = null : l.tail = null : R.sibling = null;
            break;
          }
        }
    }
    function Qs(l) {
      var c = l.alternate !== null && l.alternate.child === l.child, g = ct, y = xn;
      if (c) {
        if ((l.mode & Dn) !== In) {
          for (var G = l.selfBaseDuration, ae = l.child; ae !== null; )
            g = er(g, er(ae.lanes, ae.childLanes)), y |= ae.subtreeFlags & zi, y |= ae.flags & zi, G += ae.treeBaseDuration, ae = ae.sibling;
          l.treeBaseDuration = G;
        } else
          for (var me = l.child; me !== null; )
            g = er(g, er(me.lanes, me.childLanes)), y |= me.subtreeFlags & zi, y |= me.flags & zi, me.return = l, me = me.sibling;
        l.subtreeFlags |= y;
      } else {
        if ((l.mode & Dn) !== In) {
          for (var T = l.actualDuration, R = l.selfBaseDuration, $ = l.child; $ !== null; )
            g = er(g, er($.lanes, $.childLanes)), y |= $.subtreeFlags, y |= $.flags, T += $.actualDuration, R += $.treeBaseDuration, $ = $.sibling;
          l.actualDuration = T, l.treeBaseDuration = R;
        } else
          for (var W = l.child; W !== null; )
            g = er(g, er(W.lanes, W.childLanes)), y |= W.subtreeFlags, y |= W.flags, W.return = l, W = W.sibling;
        l.subtreeFlags |= y;
      }
      return l.childLanes = g, c;
    }
    function lpe(l, c, g) {
      if (Vfe() && (c.mode & cr) !== In && (c.flags & Wn) === xn)
        return oW(c), CO(), c.flags |= Xa | Rs | Ui, !1;
      var y = vC(c);
      if (g !== null && g.dehydrated !== null)
        if (l === null) {
          if (!y)
            throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
          if (jfe(c), Qs(c), (c.mode & Dn) !== In) {
            var T = g !== null;
            if (T) {
              var R = c.child;
              R !== null && (c.treeBaseDuration -= R.treeBaseDuration);
            }
          }
          return !1;
        } else {
          if (CO(), (c.flags & Wn) === xn && (c.memoizedState = null), c.flags |= Un, Qs(c), (c.mode & Dn) !== In) {
            var $ = g !== null;
            if ($) {
              var W = c.child;
              W !== null && (c.treeBaseDuration -= W.treeBaseDuration);
            }
          }
          return !1;
        }
      else
        return sW(), !0;
    }
    function IQ(l, c, g) {
      var y = c.pendingProps;
      switch (Z2(c), c.tag) {
        case p:
        case Y:
        case H:
        case u:
        case P:
        case _:
        case C:
        case I:
        case A:
        case M:
          return Qs(c), null;
        case f: {
          var T = c.type;
          return Jp(T) && dC(c), Qs(c), null;
        }
        case m: {
          var R = c.stateNode;
          if (RO(c), j2(c), PP(), R.pendingContext && (R.context = R.pendingContext, R.pendingContext = null), l === null || l.child === null) {
            var $ = vC(c);
            if ($)
              FO(c);
            else if (l !== null) {
              var W = l.memoizedState;
              // Check if this is a client root
              (!W.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
              (c.flags & Xa) !== xn) && (c.flags |= fl, sW());
            }
          }
          return wL(l, c), Qs(c), null;
        }
        case O: {
          RP(c);
          var G = kW(), ae = c.type;
          if (l !== null && c.stateNode != null)
            kQ(l, c, ae, y, G), l.ref !== c.ref && xQ(c);
          else {
            if (!y) {
              if (c.stateNode === null)
                throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              return Qs(c), null;
            }
            var me = kP(), Ue = vC(c);
            if (Ue)
              Wfe(c, G, me) && FO(c);
            else {
              var $e = e2(ae, y, G, me, c);
              AQ($e, c, !1, !1), c.stateNode = $e, n2($e, ae, y, G) && FO(c);
            }
            c.ref !== null && xQ(c);
          }
          return Qs(c), null;
        }
        case w: {
          var tt = y;
          if (l && c.stateNode != null) {
            var rt = l.memoizedProps;
            RQ(l, c, rt, tt);
          } else {
            if (typeof tt != "string" && c.stateNode === null)
              throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
            var pt = kW(), on = kP(), Pn = vC(c);
            Pn ? Qfe(c) && FO(c) : c.stateNode = a2(tt, pt, on, c);
          }
          return Qs(c), null;
        }
        case D: {
          DO(c);
          var Tn = c.memoizedState;
          if (l === null || l.memoizedState !== null && l.memoizedState.dehydrated !== null) {
            var Dr = lpe(l, c, Tn);
            if (!Dr)
              return c.flags & Ui ? c : null;
          }
          if ((c.flags & Wn) !== xn)
            return c.lanes = g, (c.mode & Dn) !== In && iL(c), c;
          var wr = Tn !== null, qe = l !== null && l.memoizedState !== null;
          if (wr !== qe && wr) {
            var ht = c.child;
            if (ht.flags |= nf, (c.mode & cr) !== In) {
              var Ke = l === null && (c.memoizedProps.unstable_avoidThisFallback !== !0 || !pe);
              Ke || IP(Nd.current, DW) ? uhe() : zL();
            }
          }
          var Nt = c.updateQueue;
          if (Nt !== null && (c.flags |= Un), Qs(c), (c.mode & Dn) !== In && wr) {
            var sn = c.child;
            sn !== null && (c.treeBaseDuration -= sn.treeBaseDuration);
          }
          return null;
        }
        case v:
          return RO(c), wL(l, c), l === null && H2(c.stateNode.containerInfo), Qs(c), null;
        case N:
          var tn = c.type._context;
          return aP(tn, c), Qs(c), null;
        case q: {
          var Zn = c.type;
          return Jp(Zn) && dC(c), Qs(c), null;
        }
        case ne: {
          DO(c);
          var tr = c.memoizedState;
          if (tr === null)
            return Qs(c), null;
          var va = (c.flags & Wn) !== xn, Zr = tr.rendering;
          if (Zr === null)
            if (va)
              HS(tr, !1);
            else {
              var so = fhe() && (l === null || (l.flags & Wn) === xn);
              if (!so)
                for (var Xr = c.child; Xr !== null; ) {
                  var Vi = LC(Xr);
                  if (Vi !== null) {
                    va = !0, c.flags |= Wn, HS(tr, !1);
                    var _l = Vi.updateQueue;
                    return _l !== null && (c.updateQueue = _l, c.flags |= Un), c.subtreeFlags = xn, fde(c, g), vb(c, DP(Nd.current, IS)), c.child;
                  }
                  Xr = Xr.sibling;
                }
              tr.tail !== null && fa() > KQ() && (c.flags |= Wn, va = !0, HS(tr, !1), c.lanes = Bv);
            }
          else {
            if (!va) {
              var Zs = LC(Zr);
              if (Zs !== null) {
                c.flags |= Wn, va = !0;
                var Ac = Zs.updateQueue;
                if (Ac !== null && (c.updateQueue = Ac, c.flags |= Un), HS(tr, !0), tr.tail === null && tr.tailMode === "hidden" && !Zr.alternate && !Hs())
                  return Qs(c), null;
              } else
                // The time it took to render last row is greater than the remaining
                // time we have to render. So rendering one more row would likely
                // exceed it.
                fa() * 2 - tr.renderingStartTime > KQ() && g !== us && (c.flags |= Wn, va = !0, HS(tr, !1), c.lanes = Bv);
            }
            if (tr.isBackwards)
              Zr.sibling = c.child, c.child = Zr;
            else {
              var ru = tr.last;
              ru !== null ? ru.sibling = Zr : c.child = Zr, tr.last = Zr;
            }
          }
          if (tr.tail !== null) {
            var au = tr.tail;
            tr.rendering = au, tr.tail = au.sibling, tr.renderingStartTime = fa(), au.sibling = null;
            var Cl = Nd.current;
            return va ? Cl = DP(Cl, IS) : Cl = IO(Cl), vb(c, Cl), au;
          }
          return Qs(c), null;
        }
        case J:
          break;
        case ue:
        case ee: {
          UL(c);
          var Qm = c.memoizedState, jO = Qm !== null;
          if (l !== null) {
            var aw = l.memoizedState, sh = aw !== null;
            sh !== jO && // LegacyHidden doesn't do any hiding — it only pre-renders.
            !B && (c.flags |= nf);
          }
          return !jO || (c.mode & cr) === In ? Qs(c) : $o(oh, us) && (Qs(c), c.subtreeFlags & (_a | Un) && (c.flags |= nf)), null;
        }
        case fe:
          return null;
        case de:
          return null;
      }
      throw new Error("Unknown unit of work tag (" + c.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function upe(l, c, g) {
      switch (Z2(c), c.tag) {
        case f: {
          var y = c.type;
          Jp(y) && dC(c);
          var T = c.flags;
          return T & Ui ? (c.flags = T & ~Ui | Wn, (c.mode & Dn) !== In && iL(c), c) : null;
        }
        case m: {
          c.stateNode, RO(c), j2(c), PP();
          var R = c.flags;
          return (R & Ui) !== xn && (R & Wn) === xn ? (c.flags = R & ~Ui | Wn, c) : null;
        }
        case O:
          return RP(c), null;
        case D: {
          DO(c);
          var $ = c.memoizedState;
          if ($ !== null && $.dehydrated !== null) {
            if (c.alternate === null)
              throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
            CO();
          }
          var W = c.flags;
          return W & Ui ? (c.flags = W & ~Ui | Wn, (c.mode & Dn) !== In && iL(c), c) : null;
        }
        case ne:
          return DO(c), null;
        case v:
          return RO(c), null;
        case N:
          var G = c.type._context;
          return aP(G, c), null;
        case ue:
        case ee:
          return UL(c), null;
        case fe:
          return null;
        default:
          return null;
      }
    }
    function DQ(l, c, g) {
      switch (Z2(c), c.tag) {
        case f: {
          var y = c.type.childContextTypes;
          y != null && dC(c);
          break;
        }
        case m: {
          c.stateNode, RO(c), j2(c), PP();
          break;
        }
        case O: {
          RP(c);
          break;
        }
        case v:
          RO(c);
          break;
        case D:
          DO(c);
          break;
        case ne:
          DO(c);
          break;
        case N:
          var T = c.type._context;
          aP(T, c);
          break;
        case ue:
        case ee:
          UL(c);
          break;
      }
    }
    var NQ = null;
    NQ = /* @__PURE__ */ new Set();
    var ax = !1, js = !1, cpe = typeof WeakSet == "function" ? WeakSet : Set, gn = null, $O = null, BO = null;
    function fpe(l) {
      xu(null, function() {
        throw l;
      }), ef();
    }
    var dpe = function(l, c) {
      if (c.props = l.memoizedProps, c.state = l.memoizedState, l.mode & Dn)
        try {
          ah(), c.componentWillUnmount();
        } finally {
          rh(l);
        }
      else
        c.componentWillUnmount();
    };
    function PQ(l, c) {
      try {
        Eb(Wo, l);
      } catch (g) {
        Qa(l, c, g);
      }
    }
    function TL(l, c, g) {
      try {
        dpe(l, g);
      } catch (y) {
        Qa(l, c, y);
      }
    }
    function ppe(l, c, g) {
      try {
        g.componentDidMount();
      } catch (y) {
        Qa(l, c, y);
      }
    }
    function LQ(l, c) {
      try {
        FQ(l);
      } catch (g) {
        Qa(l, c, g);
      }
    }
    function UO(l, c) {
      var g = l.ref;
      if (g !== null)
        if (typeof g == "function") {
          var y;
          try {
            if (K && Ee && l.mode & Dn)
              try {
                ah(), y = g(null);
              } finally {
                rh(l);
              }
            else
              y = g(null);
          } catch (T) {
            Qa(l, c, T);
          }
          typeof y == "function" && o("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", Bn(l));
        } else
          g.current = null;
    }
    function ix(l, c, g) {
      try {
        g();
      } catch (y) {
        Qa(l, c, y);
      }
    }
    var MQ = !1;
    function hpe(l, c) {
      KN(l.containerInfo), gn = c, mpe();
      var g = MQ;
      return MQ = !1, g;
    }
    function mpe() {
      for (; gn !== null; ) {
        var l = gn, c = l.child;
        (l.subtreeFlags & Sp) !== xn && c !== null ? (c.return = l, gn = c) : gpe();
      }
    }
    function gpe() {
      for (; gn !== null; ) {
        var l = gn;
        ra(l);
        try {
          bpe(l);
        } catch (g) {
          Qa(l, l.return, g);
        }
        wi();
        var c = l.sibling;
        if (c !== null) {
          c.return = l.return, gn = c;
          return;
        }
        gn = l.return;
      }
    }
    function bpe(l) {
      var c = l.alternate, g = l.flags;
      if ((g & fl) !== xn) {
        switch (ra(l), l.tag) {
          case u:
          case P:
          case H:
            break;
          case f: {
            if (c !== null) {
              var y = c.memoizedProps, T = c.memoizedState, R = l.stateNode;
              l.type === l.elementType && !Ry && (R.props !== l.memoizedProps && o("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Bn(l) || "instance"), R.state !== l.memoizedState && o("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Bn(l) || "instance"));
              var $ = R.getSnapshotBeforeUpdate(l.elementType === l.type ? y : Dd(l.type, y), T);
              {
                var W = NQ;
                $ === void 0 && !W.has(l.type) && (W.add(l.type), o("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", Bn(l)));
              }
              R.__reactInternalSnapshotBeforeUpdate = $;
            }
            break;
          }
          case m: {
            {
              var G = l.stateNode;
              v2(G.containerInfo);
            }
            break;
          }
          case O:
          case w:
          case v:
          case q:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        wi();
      }
    }
    function Md(l, c, g) {
      var y = c.updateQueue, T = y !== null ? y.lastEffect : null;
      if (T !== null) {
        var R = T.next, $ = R;
        do {
          if (($.tag & l) === l) {
            var W = $.destroy;
            $.destroy = void 0, W !== void 0 && ((l & Ws) !== Uu ? kg(c) : (l & Wo) !== Uu && Ig(c), (l & eh) !== Uu && tw(!0), ix(c, g, W), (l & eh) !== Uu && tw(!1), (l & Ws) !== Uu ? Rg() : (l & Wo) !== Uu && _p());
          }
          $ = $.next;
        } while ($ !== R);
      }
    }
    function Eb(l, c) {
      var g = c.updateQueue, y = g !== null ? g.lastEffect : null;
      if (y !== null) {
        var T = y.next, R = T;
        do {
          if ((R.tag & l) === l) {
            (l & Ws) !== Uu ? Tp(c) : (l & Wo) !== Uu && Fv(c);
            var $ = R.create;
            (l & eh) !== Uu && tw(!0), R.destroy = $(), (l & eh) !== Uu && tw(!1), (l & Ws) !== Uu ? Mv() : (l & Wo) !== Uu && Z0();
            {
              var W = R.destroy;
              if (W !== void 0 && typeof W != "function") {
                var G = void 0;
                (R.tag & Wo) !== xn ? G = "useLayoutEffect" : (R.tag & eh) !== xn ? G = "useInsertionEffect" : G = "useEffect";
                var ae = void 0;
                W === null ? ae = " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof W.then == "function" ? ae = `

It looks like you wrote ` + G + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + G + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching` : ae = " You returned: " + W, o("%s must not return anything besides a function, which is used for clean-up.%s", G, ae);
              }
            }
          }
          R = R.next;
        } while (R !== T);
      }
    }
    function vpe(l, c) {
      if ((c.flags & Un) !== xn)
        switch (c.tag) {
          case I: {
            var g = c.stateNode.passiveEffectDuration, y = c.memoizedProps, T = y.id, R = y.onPostCommit, $ = aQ(), W = c.alternate === null ? "mount" : "update";
            rQ() && (W = "nested-update"), typeof R == "function" && R(T, W, g, $);
            var G = c.return;
            e:
              for (; G !== null; ) {
                switch (G.tag) {
                  case m:
                    var ae = G.stateNode;
                    ae.passiveEffectDuration += g;
                    break e;
                  case I:
                    var me = G.stateNode;
                    me.passiveEffectDuration += g;
                    break e;
                }
                G = G.return;
              }
            break;
          }
        }
    }
    function ype(l, c, g, y) {
      if ((g.flags & Eo) !== xn)
        switch (g.tag) {
          case u:
          case P:
          case H: {
            if (!js)
              if (g.mode & Dn)
                try {
                  ah(), Eb(Wo | Ho, g);
                } finally {
                  rh(g);
                }
              else
                Eb(Wo | Ho, g);
            break;
          }
          case f: {
            var T = g.stateNode;
            if (g.flags & Un && !js)
              if (c === null)
                if (g.type === g.elementType && !Ry && (T.props !== g.memoizedProps && o("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Bn(g) || "instance"), T.state !== g.memoizedState && o("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Bn(g) || "instance")), g.mode & Dn)
                  try {
                    ah(), T.componentDidMount();
                  } finally {
                    rh(g);
                  }
                else
                  T.componentDidMount();
              else {
                var R = g.elementType === g.type ? c.memoizedProps : Dd(g.type, c.memoizedProps), $ = c.memoizedState;
                if (g.type === g.elementType && !Ry && (T.props !== g.memoizedProps && o("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Bn(g) || "instance"), T.state !== g.memoizedState && o("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Bn(g) || "instance")), g.mode & Dn)
                  try {
                    ah(), T.componentDidUpdate(R, $, T.__reactInternalSnapshotBeforeUpdate);
                  } finally {
                    rh(g);
                  }
                else
                  T.componentDidUpdate(R, $, T.__reactInternalSnapshotBeforeUpdate);
              }
            var W = g.updateQueue;
            W !== null && (g.type === g.elementType && !Ry && (T.props !== g.memoizedProps && o("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Bn(g) || "instance"), T.state !== g.memoizedState && o("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Bn(g) || "instance")), bW(g, W, T));
            break;
          }
          case m: {
            var G = g.updateQueue;
            if (G !== null) {
              var ae = null;
              if (g.child !== null)
                switch (g.child.tag) {
                  case O:
                    ae = g.child.stateNode;
                    break;
                  case f:
                    ae = g.child.stateNode;
                    break;
                }
              bW(g, G, ae);
            }
            break;
          }
          case O: {
            var me = g.stateNode;
            if (c === null && g.flags & Un) {
              var Ue = g.type, $e = g.memoizedProps;
              u2(me, Ue, $e);
            }
            break;
          }
          case w:
            break;
          case v:
            break;
          case I: {
            {
              var tt = g.memoizedProps, rt = tt.onCommit, pt = tt.onRender, on = g.stateNode.effectDuration, Pn = aQ(), Tn = c === null ? "mount" : "update";
              rQ() && (Tn = "nested-update"), typeof pt == "function" && pt(g.memoizedProps.id, Tn, g.actualDuration, g.treeBaseDuration, g.actualStartTime, Pn);
              {
                typeof rt == "function" && rt(g.memoizedProps.id, Tn, on, Pn), ghe(g);
                var Dr = g.return;
                e:
                  for (; Dr !== null; ) {
                    switch (Dr.tag) {
                      case m:
                        var wr = Dr.stateNode;
                        wr.effectDuration += on;
                        break e;
                      case I:
                        var qe = Dr.stateNode;
                        qe.effectDuration += on;
                        break e;
                    }
                    Dr = Dr.return;
                  }
              }
            }
            break;
          }
          case D: {
            xpe(l, g);
            break;
          }
          case ne:
          case q:
          case J:
          case ue:
          case ee:
          case de:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
      js || g.flags & qa && FQ(g);
    }
    function Ope(l) {
      switch (l.tag) {
        case u:
        case P:
        case H: {
          if (l.mode & Dn)
            try {
              ah(), PQ(l, l.return);
            } finally {
              rh(l);
            }
          else
            PQ(l, l.return);
          break;
        }
        case f: {
          var c = l.stateNode;
          typeof c.componentDidMount == "function" && ppe(l, l.return, c), LQ(l, l.return);
          break;
        }
        case O: {
          LQ(l, l.return);
          break;
        }
      }
    }
    function Epe(l, c) {
      for (var g = null, y = l; ; ) {
        if (y.tag === O) {
          if (g === null) {
            g = y;
            try {
              var T = y.stateNode;
              c ? gS(T) : g2(y.stateNode, y.memoizedProps);
            } catch ($) {
              Qa(l, l.return, $);
            }
          }
        } else if (y.tag === w) {
          if (g === null)
            try {
              var R = y.stateNode;
              c ? m2(R) : b2(R, y.memoizedProps);
            } catch ($) {
              Qa(l, l.return, $);
            }
        } else if (!((y.tag === ue || y.tag === ee) && y.memoizedState !== null && y !== l)) {
          if (y.child !== null) {
            y.child.return = y, y = y.child;
            continue;
          }
        }
        if (y === l)
          return;
        for (; y.sibling === null; ) {
          if (y.return === null || y.return === l)
            return;
          g === y && (g = null), y = y.return;
        }
        g === y && (g = null), y.sibling.return = y.return, y = y.sibling;
      }
    }
    function FQ(l) {
      var c = l.ref;
      if (c !== null) {
        var g = l.stateNode, y;
        switch (l.tag) {
          case O:
            y = g;
            break;
          default:
            y = g;
        }
        if (typeof c == "function") {
          var T;
          if (l.mode & Dn)
            try {
              ah(), T = c(y);
            } finally {
              rh(l);
            }
          else
            T = c(y);
          typeof T == "function" && o("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", Bn(l));
        } else
          c.hasOwnProperty("current") || o("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", Bn(l)), c.current = y;
      }
    }
    function Spe(l) {
      var c = l.alternate;
      c !== null && (c.return = null), l.return = null;
    }
    function $Q(l) {
      var c = l.alternate;
      c !== null && (l.alternate = null, $Q(c));
      {
        if (l.child = null, l.deletions = null, l.sibling = null, l.tag === O) {
          var g = l.stateNode;
          g !== null && Ce(g);
        }
        l.stateNode = null, l._debugOwner = null, l.return = null, l.dependencies = null, l.memoizedProps = null, l.memoizedState = null, l.pendingProps = null, l.stateNode = null, l.updateQueue = null;
      }
    }
    function wpe(l) {
      for (var c = l.return; c !== null; ) {
        if (BQ(c))
          return c;
        c = c.return;
      }
      throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function BQ(l) {
      return l.tag === O || l.tag === m || l.tag === v;
    }
    function UQ(l) {
      var c = l;
      e:
        for (; ; ) {
          for (; c.sibling === null; ) {
            if (c.return === null || BQ(c.return))
              return null;
            c = c.return;
          }
          for (c.sibling.return = c.return, c = c.sibling; c.tag !== O && c.tag !== w && c.tag !== Q; ) {
            if (c.flags & _a || c.child === null || c.tag === v)
              continue e;
            c.child.return = c, c = c.child;
          }
          if (!(c.flags & _a))
            return c.stateNode;
        }
    }
    function Tpe(l) {
      var c = wpe(l);
      switch (c.tag) {
        case O: {
          var g = c.stateNode;
          c.flags & Vr && (pS(g), c.flags &= ~Vr);
          var y = UQ(l);
          CL(l, y, g);
          break;
        }
        case m:
        case v: {
          var T = c.stateNode.containerInfo, R = UQ(l);
          _L(l, R, T);
          break;
        }
        default:
          throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    function _L(l, c, g) {
      var y = l.tag, T = y === O || y === w;
      if (T) {
        var R = l.stateNode;
        c ? hS(g, R, c) : f2(g, R);
      } else if (y !== v) {
        var $ = l.child;
        if ($ !== null) {
          _L($, c, g);
          for (var W = $.sibling; W !== null; )
            _L(W, c, g), W = W.sibling;
        }
      }
    }
    function CL(l, c, g) {
      var y = l.tag, T = y === O || y === w;
      if (T) {
        var R = l.stateNode;
        c ? d2(g, R, c) : c2(g, R);
      } else if (y !== v) {
        var $ = l.child;
        if ($ !== null) {
          CL($, c, g);
          for (var W = $.sibling; W !== null; )
            CL(W, c, g), W = W.sibling;
        }
      }
    }
    var Gs = null, Fd = !1;
    function _pe(l, c, g) {
      {
        var y = c;
        e:
          for (; y !== null; ) {
            switch (y.tag) {
              case O: {
                Gs = y.stateNode, Fd = !1;
                break e;
              }
              case m: {
                Gs = y.stateNode.containerInfo, Fd = !0;
                break e;
              }
              case v: {
                Gs = y.stateNode.containerInfo, Fd = !0;
                break e;
              }
            }
            y = y.return;
          }
        if (Gs === null)
          throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        zQ(l, c, g), Gs = null, Fd = !1;
      }
      Spe(g);
    }
    function Sb(l, c, g) {
      for (var y = g.child; y !== null; )
        zQ(l, c, y), y = y.sibling;
    }
    function zQ(l, c, g) {
      switch (Lv(g), g.tag) {
        case O:
          js || UO(g, c);
        case w: {
          {
            var y = Gs, T = Fd;
            Gs = null, Sb(l, c, g), Gs = y, Fd = T, Gs !== null && (Fd ? h2(Gs, g.stateNode) : p2(Gs, g.stateNode));
          }
          return;
        }
        case Q: {
          Gs !== null && (Fd ? Sl(Gs, g.stateNode) : mS(Gs, g.stateNode));
          return;
        }
        case v: {
          {
            var R = Gs, $ = Fd;
            Gs = g.stateNode.containerInfo, Fd = !0, Sb(l, c, g), Gs = R, Fd = $;
          }
          return;
        }
        case u:
        case P:
        case M:
        case H: {
          if (!js) {
            var W = g.updateQueue;
            if (W !== null) {
              var G = W.lastEffect;
              if (G !== null) {
                var ae = G.next, me = ae;
                do {
                  var Ue = me, $e = Ue.destroy, tt = Ue.tag;
                  $e !== void 0 && ((tt & eh) !== Uu ? ix(g, c, $e) : (tt & Wo) !== Uu && (Ig(g), g.mode & Dn ? (ah(), ix(g, c, $e), rh(g)) : ix(g, c, $e), _p())), me = me.next;
                } while (me !== ae);
              }
            }
          }
          Sb(l, c, g);
          return;
        }
        case f: {
          if (!js) {
            UO(g, c);
            var rt = g.stateNode;
            typeof rt.componentWillUnmount == "function" && TL(g, c, rt);
          }
          Sb(l, c, g);
          return;
        }
        case J: {
          Sb(l, c, g);
          return;
        }
        case ue: {
          if (
            // TODO: Remove this dead flag
            g.mode & cr
          ) {
            var pt = js;
            js = pt || g.memoizedState !== null, Sb(l, c, g), js = pt;
          } else
            Sb(l, c, g);
          break;
        }
        default: {
          Sb(l, c, g);
          return;
        }
      }
    }
    function Cpe(l) {
      l.memoizedState;
    }
    function xpe(l, c) {
      var g = c.memoizedState;
      if (g === null) {
        var y = c.alternate;
        if (y !== null) {
          var T = y.memoizedState;
          if (T !== null) {
            var R = T.dehydrated;
            R !== null && A2(R);
          }
        }
      }
    }
    function HQ(l) {
      var c = l.updateQueue;
      if (c !== null) {
        l.updateQueue = null;
        var g = l.stateNode;
        g === null && (g = l.stateNode = new cpe()), c.forEach(function(y) {
          var T = whe.bind(null, l, y);
          if (!g.has(y)) {
            if (g.add(y), za)
              if ($O !== null && BO !== null)
                ew(BO, $O);
              else
                throw Error("Expected finished root and lanes to be set. This is a bug in React.");
            y.then(T, T);
          }
        });
      }
    }
    function Ape(l, c, g) {
      $O = g, BO = l, ra(c), WQ(c, l), ra(c), $O = null, BO = null;
    }
    function $d(l, c, g) {
      var y = c.deletions;
      if (y !== null)
        for (var T = 0; T < y.length; T++) {
          var R = y[T];
          try {
            _pe(l, c, R);
          } catch (G) {
            Qa(R, c, G);
          }
        }
      var $ = A1();
      if (c.subtreeFlags & os)
        for (var W = c.child; W !== null; )
          ra(W), WQ(W, l), W = W.sibling;
      ra($);
    }
    function WQ(l, c, g) {
      var y = l.alternate, T = l.flags;
      switch (l.tag) {
        case u:
        case P:
        case M:
        case H: {
          if ($d(c, l), ih(l), T & Un) {
            try {
              Md(eh | Ho, l, l.return), Eb(eh | Ho, l);
            } catch (Zn) {
              Qa(l, l.return, Zn);
            }
            if (l.mode & Dn) {
              try {
                ah(), Md(Wo | Ho, l, l.return);
              } catch (Zn) {
                Qa(l, l.return, Zn);
              }
              rh(l);
            } else
              try {
                Md(Wo | Ho, l, l.return);
              } catch (Zn) {
                Qa(l, l.return, Zn);
              }
          }
          return;
        }
        case f: {
          $d(c, l), ih(l), T & qa && y !== null && UO(y, y.return);
          return;
        }
        case O: {
          $d(c, l), ih(l), T & qa && y !== null && UO(y, y.return);
          {
            if (l.flags & Vr) {
              var R = l.stateNode;
              try {
                pS(R);
              } catch (Zn) {
                Qa(l, l.return, Zn);
              }
            }
            if (T & Un) {
              var $ = l.stateNode;
              if ($ != null) {
                var W = l.memoizedProps, G = y !== null ? y.memoizedProps : W, ae = l.type, me = l.updateQueue;
                if (l.updateQueue = null, me !== null)
                  try {
                    dS($, me, ae, G, W, l);
                  } catch (Zn) {
                    Qa(l, l.return, Zn);
                  }
              }
            }
          }
          return;
        }
        case w: {
          if ($d(c, l), ih(l), T & Un) {
            if (l.stateNode === null)
              throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
            var Ue = l.stateNode, $e = l.memoizedProps, tt = y !== null ? y.memoizedProps : $e;
            try {
              lC(Ue, tt, $e);
            } catch (Zn) {
              Qa(l, l.return, Zn);
            }
          }
          return;
        }
        case m: {
          if ($d(c, l), ih(l), T & Un && y !== null) {
            var rt = y.memoizedState;
            if (rt.isDehydrated)
              try {
                x2(c.containerInfo);
              } catch (Zn) {
                Qa(l, l.return, Zn);
              }
          }
          return;
        }
        case v: {
          $d(c, l), ih(l);
          return;
        }
        case D: {
          $d(c, l), ih(l);
          var pt = l.child;
          if (pt.flags & nf) {
            var on = pt.stateNode, Pn = pt.memoizedState, Tn = Pn !== null;
            if (on.isHidden = Tn, Tn) {
              var Dr = pt.alternate !== null && pt.alternate.memoizedState !== null;
              Dr || lhe();
            }
          }
          if (T & Un) {
            try {
              Cpe(l);
            } catch (Zn) {
              Qa(l, l.return, Zn);
            }
            HQ(l);
          }
          return;
        }
        case ue: {
          var wr = y !== null && y.memoizedState !== null;
          if (
            // TODO: Remove this dead flag
            l.mode & cr
          ) {
            var qe = js;
            js = qe || wr, $d(c, l), js = qe;
          } else
            $d(c, l);
          if (ih(l), T & nf) {
            var ht = l.stateNode, Ke = l.memoizedState, Nt = Ke !== null, sn = l;
            if (ht.isHidden = Nt, Nt && !wr && (sn.mode & cr) !== In) {
              gn = sn;
              for (var tn = sn.child; tn !== null; )
                gn = tn, Rpe(tn), tn = tn.sibling;
            }
            Epe(sn, Nt);
          }
          return;
        }
        case ne: {
          $d(c, l), ih(l), T & Un && HQ(l);
          return;
        }
        case J:
          return;
        default: {
          $d(c, l), ih(l);
          return;
        }
      }
    }
    function ih(l) {
      var c = l.flags;
      if (c & _a) {
        try {
          Tpe(l);
        } catch (g) {
          Qa(l, l.return, g);
        }
        l.flags &= ~_a;
      }
      c & dl && (l.flags &= ~dl);
    }
    function kpe(l, c, g) {
      $O = g, BO = c, gn = l, QQ(l, c, g), $O = null, BO = null;
    }
    function QQ(l, c, g) {
      for (var y = (l.mode & cr) !== In; gn !== null; ) {
        var T = gn, R = T.child;
        if (T.tag === ue && y) {
          var $ = T.memoizedState !== null, W = $ || ax;
          if (W) {
            xL(l, c, g);
            continue;
          } else {
            var G = T.alternate, ae = G !== null && G.memoizedState !== null, me = ae || js, Ue = ax, $e = js;
            ax = W, js = me, js && !$e && (gn = T, Ipe(T));
            for (var tt = R; tt !== null; )
              gn = tt, QQ(
                tt,
                // New root; bubble back up to here and stop.
                c,
                g
              ), tt = tt.sibling;
            gn = T, ax = Ue, js = $e, xL(l, c, g);
            continue;
          }
        }
        (T.subtreeFlags & Eo) !== xn && R !== null ? (R.return = T, gn = R) : xL(l, c, g);
      }
    }
    function xL(l, c, g) {
      for (; gn !== null; ) {
        var y = gn;
        if ((y.flags & Eo) !== xn) {
          var T = y.alternate;
          ra(y);
          try {
            ype(c, T, y, g);
          } catch ($) {
            Qa(y, y.return, $);
          }
          wi();
        }
        if (y === l) {
          gn = null;
          return;
        }
        var R = y.sibling;
        if (R !== null) {
          R.return = y.return, gn = R;
          return;
        }
        gn = y.return;
      }
    }
    function Rpe(l) {
      for (; gn !== null; ) {
        var c = gn, g = c.child;
        switch (c.tag) {
          case u:
          case P:
          case M:
          case H: {
            if (c.mode & Dn)
              try {
                ah(), Md(Wo, c, c.return);
              } finally {
                rh(c);
              }
            else
              Md(Wo, c, c.return);
            break;
          }
          case f: {
            UO(c, c.return);
            var y = c.stateNode;
            typeof y.componentWillUnmount == "function" && TL(c, c.return, y);
            break;
          }
          case O: {
            UO(c, c.return);
            break;
          }
          case ue: {
            var T = c.memoizedState !== null;
            if (T) {
              jQ(l);
              continue;
            }
            break;
          }
        }
        g !== null ? (g.return = c, gn = g) : jQ(l);
      }
    }
    function jQ(l) {
      for (; gn !== null; ) {
        var c = gn;
        if (c === l) {
          gn = null;
          return;
        }
        var g = c.sibling;
        if (g !== null) {
          g.return = c.return, gn = g;
          return;
        }
        gn = c.return;
      }
    }
    function Ipe(l) {
      for (; gn !== null; ) {
        var c = gn, g = c.child;
        if (c.tag === ue) {
          var y = c.memoizedState !== null;
          if (y) {
            GQ(l);
            continue;
          }
        }
        g !== null ? (g.return = c, gn = g) : GQ(l);
      }
    }
    function GQ(l) {
      for (; gn !== null; ) {
        var c = gn;
        ra(c);
        try {
          Ope(c);
        } catch (y) {
          Qa(c, c.return, y);
        }
        if (wi(), c === l) {
          gn = null;
          return;
        }
        var g = c.sibling;
        if (g !== null) {
          g.return = c.return, gn = g;
          return;
        }
        gn = c.return;
      }
    }
    function Dpe(l, c, g, y) {
      gn = c, Npe(c, l, g, y);
    }
    function Npe(l, c, g, y) {
      for (; gn !== null; ) {
        var T = gn, R = T.child;
        (T.subtreeFlags & hl) !== xn && R !== null ? (R.return = T, gn = R) : Ppe(l, c, g, y);
      }
    }
    function Ppe(l, c, g, y) {
      for (; gn !== null; ) {
        var T = gn;
        if ((T.flags & ka) !== xn) {
          ra(T);
          try {
            Lpe(c, T, g, y);
          } catch ($) {
            Qa(T, T.return, $);
          }
          wi();
        }
        if (T === l) {
          gn = null;
          return;
        }
        var R = T.sibling;
        if (R !== null) {
          R.return = T.return, gn = R;
          return;
        }
        gn = T.return;
      }
    }
    function Lpe(l, c, g, y) {
      switch (c.tag) {
        case u:
        case P:
        case H: {
          if (c.mode & Dn) {
            aL();
            try {
              Eb(Ws | Ho, c);
            } finally {
              rL(c);
            }
          } else
            Eb(Ws | Ho, c);
          break;
        }
      }
    }
    function Mpe(l) {
      gn = l, Fpe();
    }
    function Fpe() {
      for (; gn !== null; ) {
        var l = gn, c = l.child;
        if ((gn.flags & Wr) !== xn) {
          var g = l.deletions;
          if (g !== null) {
            for (var y = 0; y < g.length; y++) {
              var T = g[y];
              gn = T, Upe(T, l);
            }
            {
              var R = l.alternate;
              if (R !== null) {
                var $ = R.child;
                if ($ !== null) {
                  R.child = null;
                  do {
                    var W = $.sibling;
                    $.sibling = null, $ = W;
                  } while ($ !== null);
                }
              }
            }
            gn = l;
          }
        }
        (l.subtreeFlags & hl) !== xn && c !== null ? (c.return = l, gn = c) : $pe();
      }
    }
    function $pe() {
      for (; gn !== null; ) {
        var l = gn;
        (l.flags & ka) !== xn && (ra(l), Bpe(l), wi());
        var c = l.sibling;
        if (c !== null) {
          c.return = l.return, gn = c;
          return;
        }
        gn = l.return;
      }
    }
    function Bpe(l) {
      switch (l.tag) {
        case u:
        case P:
        case H: {
          l.mode & Dn ? (aL(), Md(Ws | Ho, l, l.return), rL(l)) : Md(Ws | Ho, l, l.return);
          break;
        }
      }
    }
    function Upe(l, c) {
      for (; gn !== null; ) {
        var g = gn;
        ra(g), Hpe(g, c), wi();
        var y = g.child;
        y !== null ? (y.return = g, gn = y) : zpe(l);
      }
    }
    function zpe(l) {
      for (; gn !== null; ) {
        var c = gn, g = c.sibling, y = c.return;
        if ($Q(c), c === l) {
          gn = null;
          return;
        }
        if (g !== null) {
          g.return = y, gn = g;
          return;
        }
        gn = y;
      }
    }
    function Hpe(l, c) {
      switch (l.tag) {
        case u:
        case P:
        case H: {
          l.mode & Dn ? (aL(), Md(Ws, l, c), rL(l)) : Md(Ws, l, c);
          break;
        }
      }
    }
    function Wpe(l) {
      switch (l.tag) {
        case u:
        case P:
        case H: {
          try {
            Eb(Wo | Ho, l);
          } catch (g) {
            Qa(l, l.return, g);
          }
          break;
        }
        case f: {
          var c = l.stateNode;
          try {
            c.componentDidMount();
          } catch (g) {
            Qa(l, l.return, g);
          }
          break;
        }
      }
    }
    function Qpe(l) {
      switch (l.tag) {
        case u:
        case P:
        case H: {
          try {
            Eb(Ws | Ho, l);
          } catch (c) {
            Qa(l, l.return, c);
          }
          break;
        }
      }
    }
    function jpe(l) {
      switch (l.tag) {
        case u:
        case P:
        case H: {
          try {
            Md(Wo | Ho, l, l.return);
          } catch (g) {
            Qa(l, l.return, g);
          }
          break;
        }
        case f: {
          var c = l.stateNode;
          typeof c.componentWillUnmount == "function" && TL(l, l.return, c);
          break;
        }
      }
    }
    function Gpe(l) {
      switch (l.tag) {
        case u:
        case P:
        case H:
          try {
            Md(Ws | Ho, l, l.return);
          } catch (c) {
            Qa(l, l.return, c);
          }
      }
    }
    if (typeof Symbol == "function" && Symbol.for) {
      var WS = Symbol.for;
      WS("selector.component"), WS("selector.has_pseudo_class"), WS("selector.role"), WS("selector.test_id"), WS("selector.text");
    }
    var Vpe = [];
    function Ype() {
      Vpe.forEach(function(l) {
        return l();
      });
    }
    var Zpe = n.ReactCurrentActQueue;
    function Xpe(l) {
      {
        var c = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        ), g = typeof jest < "u";
        return g && c !== !1;
      }
    }
    function VQ() {
      {
        var l = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        );
        return !l && Zpe.current !== null && o("The current testing environment is not configured to support act(...)"), l;
      }
    }
    var qpe = Math.ceil, AL = n.ReactCurrentDispatcher, kL = n.ReactCurrentOwner, Vs = n.ReactCurrentBatchConfig, Bd = n.ReactCurrentActQueue, Go = (
      /*             */
      0
    ), YQ = (
      /*               */
      1
    ), Ys = (
      /*                */
      2
    ), Lf = (
      /*                */
      4
    ), Um = 0, QS = 1, Iy = 2, ox = 3, jS = 4, ZQ = 5, RL = 6, Ir = Go, tu = null, Ii = null, Vo = ct, oh = ct, IL = fs(ct), Yo = Um, GS = null, sx = ct, VS = ct, lx = ct, YS = null, zu = null, DL = 0, XQ = 500, qQ = 1 / 0, Kpe = 500, zm = null;
    function ZS() {
      qQ = fa() + Kpe;
    }
    function KQ() {
      return qQ;
    }
    var ux = !1, NL = null, zO = null, Dy = !1, wb = null, XS = ct, PL = [], LL = null, Jpe = 50, qS = 0, ML = null, FL = !1, cx = !1, ehe = 50, HO = 0, fx = null, KS = Yr, dx = ct, JQ = !1;
    function px() {
      return tu;
    }
    function nu() {
      return (Ir & (Ys | Lf)) !== Go ? fa() : (KS !== Yr || (KS = fa()), KS);
    }
    function Tb(l) {
      var c = l.mode;
      if ((c & cr) === In)
        return Fn;
      if ((Ir & Ys) !== Go && Vo !== ct)
        return xi(Vo);
      var g = Xfe() !== Zfe;
      if (g) {
        if (Vs.transition !== null) {
          var y = Vs.transition;
          y._updatedFibers || (y._updatedFibers = /* @__PURE__ */ new Set()), y._updatedFibers.add(l);
        }
        return dx === vr && (dx = Np()), dx;
      }
      var T = Ps();
      if (T !== vr)
        return T;
      var R = i2();
      return R;
    }
    function the(l) {
      var c = l.mode;
      return (c & cr) === In ? Fn : K0();
    }
    function Zo(l, c, g, y) {
      _he(), JQ && o("useInsertionEffect must not schedule updates."), FL && (cx = !0), Sc(l, g, y), (Ir & Ys) !== ct && l === tu ? Ahe(c) : (za && vm(l, c, g), khe(c), l === tu && ((Ir & Ys) === Go && (VS = er(VS, g)), Yo === jS && _b(l, Vo)), Hu(l, y), g === Fn && Ir === Go && (c.mode & cr) === In && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
      !Bd.isBatchingLegacy && (ZS(), K7()));
    }
    function nhe(l, c, g) {
      var y = l.current;
      y.lanes = c, Sc(l, c, g), Hu(l, g);
    }
    function rhe(l) {
      return (
        // TODO: Remove outdated deferRenderPhaseUpdateToNextBatch experiment. We
        // decided not to enable it.
        (Ir & Ys) !== Go
      );
    }
    function Hu(l, c) {
      var g = l.callbackNode;
      mm(l, c);
      var y = hm(l, l === tu ? Vo : ct);
      if (y === ct) {
        g !== null && mj(g), l.callbackNode = null, l.callbackPriority = vr;
        return;
      }
      var T = Ka(y), R = l.callbackPriority;
      if (R === T && // Special case related to `act`. If the currently scheduled task is a
      // Scheduler task, rather than an `act` task, cancel it and re-scheduled
      // on the `act` queue.
      !(Bd.current !== null && g !== QL)) {
        g == null && R !== Fn && o("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
        return;
      }
      g != null && mj(g);
      var $;
      if (T === Fn)
        l.tag === pb ? (Bd.isBatchingLegacy !== null && (Bd.didScheduleLegacyUpdate = !0), Dfe(nj.bind(null, l))) : q7(nj.bind(null, l)), Bd.current !== null ? Bd.current.push(hb) : s2(function() {
          (Ir & (Ys | Lf)) === Go && hb();
        }), $ = null;
      else {
        var W;
        switch (Ls(y)) {
          case Hi:
            W = rm;
            break;
          case Wi:
            W = Ds;
            break;
          case La:
            W = Ns;
            break;
          case ym:
            W = dc;
            break;
          default:
            W = Ns;
            break;
        }
        $ = jL(W, ej.bind(null, l));
      }
      l.callbackPriority = T, l.callbackNode = $;
    }
    function ej(l, c) {
      if (_de(), KS = Yr, dx = ct, (Ir & (Ys | Lf)) !== Go)
        throw new Error("Should not already be working.");
      var g = l.callbackNode, y = Wm();
      if (y && l.callbackNode !== g)
        return null;
      var T = hm(l, l === tu ? Vo : ct);
      if (T === ct)
        return null;
      var R = !bf(l, T) && !q0(l, T) && !c, $ = R ? phe(l, T) : mx(l, T);
      if ($ !== Um) {
        if ($ === Iy) {
          var W = Fg(l);
          W !== ct && (T = W, $ = $L(l, W));
        }
        if ($ === QS) {
          var G = GS;
          throw Ny(l, ct), _b(l, T), Hu(l, fa()), G;
        }
        if ($ === RL)
          _b(l, T);
        else {
          var ae = !bf(l, T), me = l.current.alternate;
          if (ae && !ihe(me)) {
            if ($ = mx(l, T), $ === Iy) {
              var Ue = Fg(l);
              Ue !== ct && (T = Ue, $ = $L(l, Ue));
            }
            if ($ === QS) {
              var $e = GS;
              throw Ny(l, ct), _b(l, T), Hu(l, fa()), $e;
            }
          }
          l.finishedWork = me, l.finishedLanes = T, ahe(l, $, T);
        }
      }
      return Hu(l, fa()), l.callbackNode === g ? ej.bind(null, l) : null;
    }
    function $L(l, c) {
      var g = YS;
      if (kr(l)) {
        var y = Ny(l, c);
        y.flags |= Xa, z2(l.containerInfo);
      }
      var T = mx(l, c);
      if (T !== Iy) {
        var R = zu;
        zu = g, R !== null && tj(R);
      }
      return T;
    }
    function tj(l) {
      zu === null ? zu = l : zu.push.apply(zu, l);
    }
    function ahe(l, c, g) {
      switch (c) {
        case Um:
        case QS:
          throw new Error("Root did not complete. This is a bug in React.");
        case Iy: {
          Py(l, zu, zm);
          break;
        }
        case ox: {
          if (_b(l, g), gm(g) && // do not delay if we're inside an act() scope
          !gj()) {
            var y = DL + XQ - fa();
            if (y > 10) {
              var T = hm(l, ct);
              if (T !== ct)
                break;
              var R = l.suspendedLanes;
              if (!vf(R, g)) {
                nu(), Lp(l, R);
                break;
              }
              l.timeoutHandle = cS(Py.bind(null, l, zu, zm), y);
              break;
            }
          }
          Py(l, zu, zm);
          break;
        }
        case jS: {
          if (_b(l, g), Bg(g))
            break;
          if (!gj()) {
            var $ = Uv(l, g), W = $, G = fa() - W, ae = The(G) - G;
            if (ae > 10) {
              l.timeoutHandle = cS(Py.bind(null, l, zu, zm), ae);
              break;
            }
          }
          Py(l, zu, zm);
          break;
        }
        case ZQ: {
          Py(l, zu, zm);
          break;
        }
        default:
          throw new Error("Unknown root exit status.");
      }
    }
    function ihe(l) {
      for (var c = l; ; ) {
        if (c.flags & em) {
          var g = c.updateQueue;
          if (g !== null) {
            var y = g.stores;
            if (y !== null)
              for (var T = 0; T < y.length; T++) {
                var R = y[T], $ = R.getSnapshot, W = R.value;
                try {
                  if (!cn($(), W))
                    return !1;
                } catch {
                  return !1;
                }
              }
          }
        }
        var G = c.child;
        if (c.subtreeFlags & em && G !== null) {
          G.return = c, c = G;
          continue;
        }
        if (c === l)
          return !0;
        for (; c.sibling === null; ) {
          if (c.return === null || c.return === l)
            return !0;
          c = c.return;
        }
        c.sibling.return = c.return, c = c.sibling;
      }
      return !0;
    }
    function _b(l, c) {
      c = yd(c, lx), c = yd(c, VS), bm(l, c);
    }
    function nj(l) {
      if (Cde(), (Ir & (Ys | Lf)) !== Go)
        throw new Error("Should not already be working.");
      Wm();
      var c = hm(l, ct);
      if (!$o(c, Fn))
        return Hu(l, fa()), null;
      var g = mx(l, c);
      if (l.tag !== pb && g === Iy) {
        var y = Fg(l);
        y !== ct && (c = y, g = $L(l, y));
      }
      if (g === QS) {
        var T = GS;
        throw Ny(l, ct), _b(l, c), Hu(l, fa()), T;
      }
      if (g === RL)
        throw new Error("Root did not complete. This is a bug in React.");
      var R = l.current.alternate;
      return l.finishedWork = R, l.finishedLanes = c, Py(l, zu, zm), Hu(l, fa()), null;
    }
    function ohe(l, c) {
      c !== ct && (Cn(l, er(c, Fn)), Hu(l, fa()), (Ir & (Ys | Lf)) === Go && (ZS(), hb()));
    }
    function BL(l, c) {
      var g = Ir;
      Ir |= YQ;
      try {
        return l(c);
      } finally {
        Ir = g, Ir === Go && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
        !Bd.isBatchingLegacy && (ZS(), K7());
      }
    }
    function she(l, c, g, y, T) {
      var R = Ps(), $ = Vs.transition;
      try {
        return Vs.transition = null, Ai(Hi), l(c, g, y, T);
      } finally {
        Ai(R), Vs.transition = $, Ir === Go && ZS();
      }
    }
    function Hm(l) {
      wb !== null && wb.tag === pb && (Ir & (Ys | Lf)) === Go && Wm();
      var c = Ir;
      Ir |= YQ;
      var g = Vs.transition, y = Ps();
      try {
        return Vs.transition = null, Ai(Hi), l ? l() : void 0;
      } finally {
        Ai(y), Vs.transition = g, Ir = c, (Ir & (Ys | Lf)) === Go && hb();
      }
    }
    function rj() {
      return (Ir & (Ys | Lf)) !== Go;
    }
    function hx(l, c) {
      wl(IL, oh, l), oh = er(oh, c);
    }
    function UL(l) {
      oh = IL.current, zo(IL, l);
    }
    function Ny(l, c) {
      l.finishedWork = null, l.finishedLanes = ct;
      var g = l.timeoutHandle;
      if (g !== fS && (l.timeoutHandle = fS, o2(g)), Ii !== null)
        for (var y = Ii.return; y !== null; ) {
          var T = y.alternate;
          DQ(T, y), y = y.return;
        }
      tu = l;
      var R = Ly(l.current, null);
      return Ii = R, Vo = oh = c, Yo = Um, GS = null, sx = ct, VS = ct, lx = ct, YS = null, zu = null, ede(), Id.discardPendingWarnings(), R;
    }
    function aj(l, c) {
      do {
        var g = Ii;
        try {
          if (SC(), PW(), wi(), kL.current = null, g === null || g.return === null) {
            Yo = QS, GS = c, Ii = null;
            return;
          }
          if (K && g.mode & Dn && ex(g, !0), j)
            if (pd(), c !== null && typeof c == "object" && typeof c.then == "function") {
              var y = c;
              Dg(g, y, Vo);
            } else
              im(g, c, Vo);
          Ide(l, g.return, g, c, Vo), lj(g);
        } catch (T) {
          c = T, Ii === g && g !== null ? (g = g.return, Ii = g) : g = Ii;
          continue;
        }
        return;
      } while (!0);
    }
    function ij() {
      var l = AL.current;
      return AL.current = ZC, l === null ? ZC : l;
    }
    function oj(l) {
      AL.current = l;
    }
    function lhe() {
      DL = fa();
    }
    function JS(l) {
      sx = er(l, sx);
    }
    function uhe() {
      Yo === Um && (Yo = ox);
    }
    function zL() {
      (Yo === Um || Yo === ox || Yo === Iy) && (Yo = jS), tu !== null && (gf(sx) || gf(VS)) && _b(tu, Vo);
    }
    function che(l) {
      Yo !== jS && (Yo = Iy), YS === null ? YS = [l] : YS.push(l);
    }
    function fhe() {
      return Yo === Um;
    }
    function mx(l, c) {
      var g = Ir;
      Ir |= Ys;
      var y = ij();
      if (tu !== l || Vo !== c) {
        if (za) {
          var T = l.memoizedUpdaters;
          T.size > 0 && (ew(l, Vo), T.clear()), Pu(l, c);
        }
        zm = Hv(), Ny(l, c);
      }
      gl(c);
      do
        try {
          dhe();
          break;
        } catch (R) {
          aj(l, R);
        }
      while (!0);
      if (SC(), Ir = g, oj(y), Ii !== null)
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
      return xp(), tu = null, Vo = ct, Yo;
    }
    function dhe() {
      for (; Ii !== null; )
        sj(Ii);
    }
    function phe(l, c) {
      var g = Ir;
      Ir |= Ys;
      var y = ij();
      if (tu !== l || Vo !== c) {
        if (za) {
          var T = l.memoizedUpdaters;
          T.size > 0 && (ew(l, Vo), T.clear()), Pu(l, c);
        }
        zm = Hv(), ZS(), Ny(l, c);
      }
      gl(c);
      do
        try {
          hhe();
          break;
        } catch (R) {
          aj(l, R);
        }
      while (!0);
      return SC(), oj(y), Ir = g, Ii !== null ? (cf(), Um) : (xp(), tu = null, Vo = ct, Yo);
    }
    function hhe() {
      for (; Ii !== null && !nm(); )
        sj(Ii);
    }
    function sj(l) {
      var c = l.alternate;
      ra(l);
      var g;
      (l.mode & Dn) !== In ? (nL(l), g = HL(c, l, oh), ex(l, !0)) : g = HL(c, l, oh), wi(), l.memoizedProps = l.pendingProps, g === null ? lj(l) : Ii = g, kL.current = null;
    }
    function lj(l) {
      var c = l;
      do {
        var g = c.alternate, y = c.return;
        if ((c.flags & Rs) === xn) {
          ra(c);
          var T = void 0;
          if ((c.mode & Dn) === In ? T = IQ(g, c, oh) : (nL(c), T = IQ(g, c, oh), ex(c, !1)), wi(), T !== null) {
            Ii = T;
            return;
          }
        } else {
          var R = upe(g, c);
          if (R !== null) {
            R.flags &= V0, Ii = R;
            return;
          }
          if ((c.mode & Dn) !== In) {
            ex(c, !1);
            for (var $ = c.actualDuration, W = c.child; W !== null; )
              $ += W.actualDuration, W = W.sibling;
            c.actualDuration = $;
          }
          if (y !== null)
            y.flags |= Rs, y.subtreeFlags = xn, y.deletions = null;
          else {
            Yo = RL, Ii = null;
            return;
          }
        }
        var G = c.sibling;
        if (G !== null) {
          Ii = G;
          return;
        }
        c = y, Ii = c;
      } while (c !== null);
      Yo === Um && (Yo = ZQ);
    }
    function Py(l, c, g) {
      var y = Ps(), T = Vs.transition;
      try {
        Vs.transition = null, Ai(Hi), mhe(l, c, g, y);
      } finally {
        Vs.transition = T, Ai(y);
      }
      return null;
    }
    function mhe(l, c, g, y) {
      do
        Wm();
      while (wb !== null);
      if (Che(), (Ir & (Ys | Lf)) !== Go)
        throw new Error("Should not already be working.");
      var T = l.finishedWork, R = l.finishedLanes;
      if (sf(R), T === null)
        return Ag(), null;
      if (R === ct && o("root.finishedLanes should not be empty during a commit. This is a bug in React."), l.finishedWork = null, l.finishedLanes = ct, T === l.current)
        throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
      l.callbackNode = null, l.callbackPriority = vr;
      var $ = er(T.lanes, T.childLanes);
      yf(l, $), l === tu && (tu = null, Ii = null, Vo = ct), ((T.subtreeFlags & hl) !== xn || (T.flags & hl) !== xn) && (Dy || (Dy = !0, LL = g, jL(Ns, function() {
        return Wm(), null;
      })));
      var W = (T.subtreeFlags & (Sp | os | Eo | hl)) !== xn, G = (T.flags & (Sp | os | Eo | hl)) !== xn;
      if (W || G) {
        var ae = Vs.transition;
        Vs.transition = null;
        var me = Ps();
        Ai(Hi);
        var Ue = Ir;
        Ir |= Lf, kL.current = null, hpe(l, T), iQ(), Ape(l, T, R), JN(l.containerInfo), l.current = T, X0(R), kpe(T, l, R), uf(), Pv(), Ir = Ue, Ai(me), Vs.transition = ae;
      } else
        l.current = T, iQ();
      var $e = Dy;
      if (Dy ? (Dy = !1, wb = l, XS = R) : (HO = 0, fx = null), $ = l.pendingLanes, $ === ct && (zO = null), $e || dj(l.current, !1), Yl(T.stateNode, y), za && l.memoizedUpdaters.clear(), Ype(), Hu(l, fa()), c !== null)
        for (var tt = l.onRecoverableError, rt = 0; rt < c.length; rt++) {
          var pt = c[rt], on = pt.stack, Pn = pt.digest;
          tt(pt.value, {
            componentStack: on,
            digest: Pn
          });
        }
      if (ux) {
        ux = !1;
        var Tn = NL;
        throw NL = null, Tn;
      }
      return $o(XS, Fn) && l.tag !== pb && Wm(), $ = l.pendingLanes, $o($, Fn) ? (Tde(), l === ML ? qS++ : (qS = 0, ML = l)) : qS = 0, hb(), Ag(), null;
    }
    function Wm() {
      if (wb !== null) {
        var l = Ls(XS), c = $1(La, l), g = Vs.transition, y = Ps();
        try {
          return Vs.transition = null, Ai(c), bhe();
        } finally {
          Ai(y), Vs.transition = g;
        }
      }
      return !1;
    }
    function ghe(l) {
      PL.push(l), Dy || (Dy = !0, jL(Ns, function() {
        return Wm(), null;
      }));
    }
    function bhe() {
      if (wb === null)
        return !1;
      var l = LL;
      LL = null;
      var c = wb, g = XS;
      if (wb = null, XS = ct, (Ir & (Ys | Lf)) !== Go)
        throw new Error("Cannot flush passive effects while already rendering.");
      FL = !0, cx = !1, $v(g);
      var y = Ir;
      Ir |= Lf, Mpe(c.current), Dpe(c, c.current, g, l);
      {
        var T = PL;
        PL = [];
        for (var R = 0; R < T.length; R++) {
          var $ = T[R];
          vpe(c, $);
        }
      }
      Cp(), dj(c.current, !0), Ir = y, hb(), cx ? c === fx ? HO++ : (HO = 0, fx = c) : HO = 0, FL = !1, cx = !1, af(c);
      {
        var W = c.current.stateNode;
        W.effectDuration = 0, W.passiveEffectDuration = 0;
      }
      return !0;
    }
    function uj(l) {
      return zO !== null && zO.has(l);
    }
    function vhe(l) {
      zO === null ? zO = /* @__PURE__ */ new Set([l]) : zO.add(l);
    }
    function yhe(l) {
      ux || (ux = !0, NL = l);
    }
    var Ohe = yhe;
    function cj(l, c, g) {
      var y = ky(g, c), T = sQ(l, y, Fn), R = gb(l, T, Fn), $ = nu();
      R !== null && (Sc(R, Fn, $), Hu(R, $));
    }
    function Qa(l, c, g) {
      if (fpe(g), tw(!1), l.tag === m) {
        cj(l, l, g);
        return;
      }
      var y = null;
      for (y = c; y !== null; ) {
        if (y.tag === m) {
          cj(y, l, g);
          return;
        } else if (y.tag === f) {
          var T = y.type, R = y.stateNode;
          if (typeof T.getDerivedStateFromError == "function" || typeof R.componentDidCatch == "function" && !uj(R)) {
            var $ = ky(g, l), W = lL(y, $, Fn), G = gb(y, W, Fn), ae = nu();
            G !== null && (Sc(G, Fn, ae), Hu(G, ae));
            return;
          }
        }
        y = y.return;
      }
      o(`Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`, g);
    }
    function Ehe(l, c, g) {
      var y = l.pingCache;
      y !== null && y.delete(c);
      var T = nu();
      Lp(l, g), Rhe(l), tu === l && vf(Vo, g) && (Yo === jS || Yo === ox && gm(Vo) && fa() - DL < XQ ? Ny(l, ct) : lx = er(lx, g)), Hu(l, T);
    }
    function fj(l, c) {
      c === vr && (c = the(l));
      var g = nu(), y = Bu(l, c);
      y !== null && (Sc(y, c, g), Hu(y, g));
    }
    function She(l) {
      var c = l.memoizedState, g = vr;
      c !== null && (g = c.retryLane), fj(l, g);
    }
    function whe(l, c) {
      var g = vr, y;
      switch (l.tag) {
        case D:
          y = l.stateNode;
          var T = l.memoizedState;
          T !== null && (g = T.retryLane);
          break;
        case ne:
          y = l.stateNode;
          break;
        default:
          throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
      }
      y !== null && y.delete(c), fj(l, g);
    }
    function The(l) {
      return l < 120 ? 120 : l < 480 ? 480 : l < 1080 ? 1080 : l < 1920 ? 1920 : l < 3e3 ? 3e3 : l < 4320 ? 4320 : qpe(l / 1960) * 1960;
    }
    function _he() {
      if (qS > Jpe)
        throw qS = 0, ML = null, new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
      HO > ehe && (HO = 0, fx = null, o("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
    }
    function Che() {
      Id.flushLegacyContextWarning(), Id.flushPendingUnsafeLifecycleWarnings();
    }
    function dj(l, c) {
      ra(l), gx(l, Ra, jpe), c && gx(l, fd, Gpe), gx(l, Ra, Wpe), c && gx(l, fd, Qpe), wi();
    }
    function gx(l, c, g) {
      for (var y = l, T = null; y !== null; ) {
        var R = y.subtreeFlags & c;
        y !== T && y.child !== null && R !== xn ? y = y.child : ((y.flags & c) !== xn && g(y), y.sibling !== null ? y = y.sibling : y = T = y.return);
      }
    }
    var bx = null;
    function pj(l) {
      {
        if ((Ir & Ys) !== Go || !(l.mode & cr))
          return;
        var c = l.tag;
        if (c !== p && c !== m && c !== f && c !== u && c !== P && c !== M && c !== H)
          return;
        var g = Bn(l) || "ReactComponent";
        if (bx !== null) {
          if (bx.has(g))
            return;
          bx.add(g);
        } else
          bx = /* @__PURE__ */ new Set([g]);
        var y = Ua;
        try {
          ra(l), o("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally {
          y ? ra(l) : wi();
        }
      }
    }
    var HL;
    {
      var xhe = null;
      HL = function(l, c, g) {
        var y = Ej(xhe, c);
        try {
          return CQ(l, c, g);
        } catch (R) {
          if (Ufe() || R !== null && typeof R == "object" && typeof R.then == "function")
            throw R;
          if (SC(), PW(), DQ(l, c), Ej(c, y), c.mode & Dn && nL(c), xu(null, CQ, null, l, c, g), re()) {
            var T = ef();
            typeof T == "object" && T !== null && T._suppressLogging && typeof R == "object" && R !== null && !R._suppressLogging && (R._suppressLogging = !0);
          }
          throw R;
        }
      };
    }
    var hj = !1, WL;
    WL = /* @__PURE__ */ new Set();
    function Ahe(l) {
      if (no && !Ede())
        switch (l.tag) {
          case u:
          case P:
          case H: {
            var c = Ii && Bn(Ii) || "Unknown", g = c;
            if (!WL.has(g)) {
              WL.add(g);
              var y = Bn(l) || "Unknown";
              o("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", y, c, c);
            }
            break;
          }
          case f: {
            hj || (o("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), hj = !0);
            break;
          }
        }
    }
    function ew(l, c) {
      if (za) {
        var g = l.memoizedUpdaters;
        g.forEach(function(y) {
          vm(l, y, c);
        });
      }
    }
    var QL = {};
    function jL(l, c) {
      {
        var g = Bd.current;
        return g !== null ? (g.push(c), QL) : Fo(l, c);
      }
    }
    function mj(l) {
      if (l !== QL)
        return Y0(l);
    }
    function gj() {
      return Bd.current !== null;
    }
    function khe(l) {
      {
        if (l.mode & cr) {
          if (!VQ())
            return;
        } else if (!Xpe() || Ir !== Go || l.tag !== u && l.tag !== P && l.tag !== H)
          return;
        if (Bd.current === null) {
          var c = Ua;
          try {
            ra(l), o(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, Bn(l));
          } finally {
            c ? ra(l) : wi();
          }
        }
      }
    }
    function Rhe(l) {
      l.tag !== pb && VQ() && Bd.current === null && o(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`);
    }
    function tw(l) {
      JQ = l;
    }
    var Mf = null, WO = null, Ihe = function(l) {
      Mf = l;
    };
    function QO(l) {
      {
        if (Mf === null)
          return l;
        var c = Mf(l);
        return c === void 0 ? l : c.current;
      }
    }
    function GL(l) {
      return QO(l);
    }
    function VL(l) {
      {
        if (Mf === null)
          return l;
        var c = Mf(l);
        if (c === void 0) {
          if (l != null && typeof l.render == "function") {
            var g = QO(l.render);
            if (l.render !== g) {
              var y = {
                $$typeof: Sn,
                render: g
              };
              return l.displayName !== void 0 && (y.displayName = l.displayName), y;
            }
          }
          return l;
        }
        return c.current;
      }
    }
    function bj(l, c) {
      {
        if (Mf === null)
          return !1;
        var g = l.elementType, y = c.type, T = !1, R = typeof y == "object" && y !== null ? y.$$typeof : null;
        switch (l.tag) {
          case f: {
            typeof y == "function" && (T = !0);
            break;
          }
          case u: {
            (typeof y == "function" || R === Rn) && (T = !0);
            break;
          }
          case P: {
            (R === Sn || R === Rn) && (T = !0);
            break;
          }
          case M:
          case H: {
            (R === qn || R === Rn) && (T = !0);
            break;
          }
          default:
            return !1;
        }
        if (T) {
          var $ = Mf(g);
          if ($ !== void 0 && $ === Mf(y))
            return !0;
        }
        return !1;
      }
    }
    function vj(l) {
      {
        if (Mf === null || typeof WeakSet != "function")
          return;
        WO === null && (WO = /* @__PURE__ */ new WeakSet()), WO.add(l);
      }
    }
    var Dhe = function(l, c) {
      {
        if (Mf === null)
          return;
        var g = c.staleFamilies, y = c.updatedFamilies;
        Wm(), Hm(function() {
          YL(l.current, y, g);
        });
      }
    }, Nhe = function(l, c) {
      {
        if (l.context !== Cc)
          return;
        Wm(), Hm(function() {
          nw(c, l, null, null);
        });
      }
    };
    function YL(l, c, g) {
      {
        var y = l.alternate, T = l.child, R = l.sibling, $ = l.tag, W = l.type, G = null;
        switch ($) {
          case u:
          case H:
          case f:
            G = W;
            break;
          case P:
            G = W.render;
            break;
        }
        if (Mf === null)
          throw new Error("Expected resolveFamily to be set during hot reload.");
        var ae = !1, me = !1;
        if (G !== null) {
          var Ue = Mf(G);
          Ue !== void 0 && (g.has(Ue) ? me = !0 : c.has(Ue) && ($ === f ? me = !0 : ae = !0));
        }
        if (WO !== null && (WO.has(l) || y !== null && WO.has(y)) && (me = !0), me && (l._debugNeedsRemount = !0), me || ae) {
          var $e = Bu(l, Fn);
          $e !== null && Zo($e, l, Fn, Yr);
        }
        T !== null && !me && YL(T, c, g), R !== null && YL(R, c, g);
      }
    }
    var Phe = function(l, c) {
      {
        var g = /* @__PURE__ */ new Set(), y = new Set(c.map(function(T) {
          return T.current;
        }));
        return ZL(l.current, y, g), g;
      }
    };
    function ZL(l, c, g) {
      {
        var y = l.child, T = l.sibling, R = l.tag, $ = l.type, W = null;
        switch (R) {
          case u:
          case H:
          case f:
            W = $;
            break;
          case P:
            W = $.render;
            break;
        }
        var G = !1;
        W !== null && c.has(W) && (G = !0), G ? Lhe(l, g) : y !== null && ZL(y, c, g), T !== null && ZL(T, c, g);
      }
    }
    function Lhe(l, c) {
      {
        var g = Mhe(l, c);
        if (g)
          return;
        for (var y = l; ; ) {
          switch (y.tag) {
            case O:
              c.add(y.stateNode);
              return;
            case v:
              c.add(y.stateNode.containerInfo);
              return;
            case m:
              c.add(y.stateNode.containerInfo);
              return;
          }
          if (y.return === null)
            throw new Error("Expected to reach root first.");
          y = y.return;
        }
      }
    }
    function Mhe(l, c) {
      for (var g = l, y = !1; ; ) {
        if (g.tag === O)
          y = !0, c.add(g.stateNode);
        else if (g.child !== null) {
          g.child.return = g, g = g.child;
          continue;
        }
        if (g === l)
          return y;
        for (; g.sibling === null; ) {
          if (g.return === null || g.return === l)
            return y;
          g = g.return;
        }
        g.sibling.return = g.return, g = g.sibling;
      }
      return !1;
    }
    var XL;
    {
      XL = !1;
      try {
        var yj = Object.preventExtensions({});
      } catch {
        XL = !0;
      }
    }
    function Fhe(l, c, g, y) {
      this.tag = l, this.key = g, this.elementType = null, this.type = null, this.stateNode = null, this.return = null, this.child = null, this.sibling = null, this.index = 0, this.ref = null, this.pendingProps = c, this.memoizedProps = null, this.updateQueue = null, this.memoizedState = null, this.dependencies = null, this.mode = y, this.flags = xn, this.subtreeFlags = xn, this.deletions = null, this.lanes = ct, this.childLanes = ct, this.alternate = null, this.actualDuration = Number.NaN, this.actualStartTime = Number.NaN, this.selfBaseDuration = Number.NaN, this.treeBaseDuration = Number.NaN, this.actualDuration = 0, this.actualStartTime = -1, this.selfBaseDuration = 0, this.treeBaseDuration = 0, this._debugSource = null, this._debugOwner = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, !XL && typeof Object.preventExtensions == "function" && Object.preventExtensions(this);
    }
    var xc = function(l, c, g, y) {
      return new Fhe(l, c, g, y);
    };
    function qL(l) {
      var c = l.prototype;
      return !!(c && c.isReactComponent);
    }
    function $he(l) {
      return typeof l == "function" && !qL(l) && l.defaultProps === void 0;
    }
    function Bhe(l) {
      if (typeof l == "function")
        return qL(l) ? f : u;
      if (l != null) {
        var c = l.$$typeof;
        if (c === Sn)
          return P;
        if (c === qn)
          return M;
      }
      return p;
    }
    function Ly(l, c) {
      var g = l.alternate;
      g === null ? (g = xc(l.tag, c, l.key, l.mode), g.elementType = l.elementType, g.type = l.type, g.stateNode = l.stateNode, g._debugSource = l._debugSource, g._debugOwner = l._debugOwner, g._debugHookTypes = l._debugHookTypes, g.alternate = l, l.alternate = g) : (g.pendingProps = c, g.type = l.type, g.flags = xn, g.subtreeFlags = xn, g.deletions = null, g.actualDuration = 0, g.actualStartTime = -1), g.flags = l.flags & zi, g.childLanes = l.childLanes, g.lanes = l.lanes, g.child = l.child, g.memoizedProps = l.memoizedProps, g.memoizedState = l.memoizedState, g.updateQueue = l.updateQueue;
      var y = l.dependencies;
      switch (g.dependencies = y === null ? null : {
        lanes: y.lanes,
        firstContext: y.firstContext
      }, g.sibling = l.sibling, g.index = l.index, g.ref = l.ref, g.selfBaseDuration = l.selfBaseDuration, g.treeBaseDuration = l.treeBaseDuration, g._debugNeedsRemount = l._debugNeedsRemount, g.tag) {
        case p:
        case u:
        case H:
          g.type = QO(l.type);
          break;
        case f:
          g.type = GL(l.type);
          break;
        case P:
          g.type = VL(l.type);
          break;
      }
      return g;
    }
    function Uhe(l, c) {
      l.flags &= zi | _a;
      var g = l.alternate;
      if (g === null)
        l.childLanes = ct, l.lanes = c, l.child = null, l.subtreeFlags = xn, l.memoizedProps = null, l.memoizedState = null, l.updateQueue = null, l.dependencies = null, l.stateNode = null, l.selfBaseDuration = 0, l.treeBaseDuration = 0;
      else {
        l.childLanes = g.childLanes, l.lanes = g.lanes, l.child = g.child, l.subtreeFlags = xn, l.deletions = null, l.memoizedProps = g.memoizedProps, l.memoizedState = g.memoizedState, l.updateQueue = g.updateQueue, l.type = g.type;
        var y = g.dependencies;
        l.dependencies = y === null ? null : {
          lanes: y.lanes,
          firstContext: y.firstContext
        }, l.selfBaseDuration = g.selfBaseDuration, l.treeBaseDuration = g.treeBaseDuration;
      }
      return l;
    }
    function zhe(l, c, g) {
      var y;
      return l === hC ? (y = cr, c === !0 && (y |= Da, y |= ls)) : y = In, za && (y |= Dn), xc(m, null, null, y);
    }
    function KL(l, c, g, y, T, R) {
      var $ = p, W = l;
      if (typeof l == "function")
        qL(l) ? ($ = f, W = GL(W)) : W = QO(W);
      else if (typeof l == "string")
        $ = O;
      else
        e:
          switch (l) {
            case es:
              return Cb(g.children, T, R, c);
            case Fl:
              $ = C, T |= Da, (T & cr) !== In && (T |= ls);
              break;
            case xe:
              return Hhe(g, T, R, c);
            case Yn:
              return Whe(g, T, R, c);
            case ur:
              return Qhe(g, T, R, c);
            case ve:
              return Oj(g, T, R, c);
            case Ye:
            case Ba:
            case yt:
            case Dt:
            case ma:
            default: {
              if (typeof l == "object" && l !== null)
                switch (l.$$typeof) {
                  case xt:
                    $ = N;
                    break e;
                  case jt:
                    $ = A;
                    break e;
                  case Sn:
                    $ = P, W = VL(W);
                    break e;
                  case qn:
                    $ = M;
                    break e;
                  case Rn:
                    $ = Y, W = null;
                    break e;
                }
              var G = "";
              {
                (l === void 0 || typeof l == "object" && l !== null && Object.keys(l).length === 0) && (G += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
                var ae = y ? Bn(y) : null;
                ae && (G += `

Check the render method of \`` + ae + "`.");
              }
              throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (l == null ? l : typeof l) + "." + G));
            }
          }
      var me = xc($, g, c, T);
      return me.elementType = l, me.type = W, me.lanes = R, me._debugOwner = y, me;
    }
    function JL(l, c, g) {
      var y = null;
      y = l._owner;
      var T = l.type, R = l.key, $ = l.props, W = KL(T, R, $, y, c, g);
      return W._debugSource = l._source, W._debugOwner = l._owner, W;
    }
    function Cb(l, c, g, y) {
      var T = xc(_, l, y, c);
      return T.lanes = g, T;
    }
    function Hhe(l, c, g, y) {
      typeof l.id != "string" && o('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof l.id);
      var T = xc(I, l, y, c | Dn);
      return T.elementType = xe, T.lanes = g, T.stateNode = {
        effectDuration: 0,
        passiveEffectDuration: 0
      }, T;
    }
    function Whe(l, c, g, y) {
      var T = xc(D, l, y, c);
      return T.elementType = Yn, T.lanes = g, T;
    }
    function Qhe(l, c, g, y) {
      var T = xc(ne, l, y, c);
      return T.elementType = ur, T.lanes = g, T;
    }
    function Oj(l, c, g, y) {
      var T = xc(ue, l, y, c);
      T.elementType = ve, T.lanes = g;
      var R = {
        isHidden: !1
      };
      return T.stateNode = R, T;
    }
    function eM(l, c, g) {
      var y = xc(w, l, null, c);
      return y.lanes = g, y;
    }
    function jhe() {
      var l = xc(O, null, null, In);
      return l.elementType = "DELETED", l;
    }
    function Ghe(l) {
      var c = xc(Q, null, null, In);
      return c.stateNode = l, c;
    }
    function tM(l, c, g) {
      var y = l.children !== null ? l.children : [], T = xc(v, y, l.key, c);
      return T.lanes = g, T.stateNode = {
        containerInfo: l.containerInfo,
        pendingChildren: null,
        // Used by persistent updates
        implementation: l.implementation
      }, T;
    }
    function Ej(l, c) {
      return l === null && (l = xc(p, null, null, In)), l.tag = c.tag, l.key = c.key, l.elementType = c.elementType, l.type = c.type, l.stateNode = c.stateNode, l.return = c.return, l.child = c.child, l.sibling = c.sibling, l.index = c.index, l.ref = c.ref, l.pendingProps = c.pendingProps, l.memoizedProps = c.memoizedProps, l.updateQueue = c.updateQueue, l.memoizedState = c.memoizedState, l.dependencies = c.dependencies, l.mode = c.mode, l.flags = c.flags, l.subtreeFlags = c.subtreeFlags, l.deletions = c.deletions, l.lanes = c.lanes, l.childLanes = c.childLanes, l.alternate = c.alternate, l.actualDuration = c.actualDuration, l.actualStartTime = c.actualStartTime, l.selfBaseDuration = c.selfBaseDuration, l.treeBaseDuration = c.treeBaseDuration, l._debugSource = c._debugSource, l._debugOwner = c._debugOwner, l._debugNeedsRemount = c._debugNeedsRemount, l._debugHookTypes = c._debugHookTypes, l;
    }
    function Vhe(l, c, g, y, T) {
      this.tag = c, this.containerInfo = l, this.pendingChildren = null, this.current = null, this.pingCache = null, this.finishedWork = null, this.timeoutHandle = fS, this.context = null, this.pendingContext = null, this.callbackNode = null, this.callbackPriority = vr, this.eventTimes = Pp(ct), this.expirationTimes = Pp(Yr), this.pendingLanes = ct, this.suspendedLanes = ct, this.pingedLanes = ct, this.expiredLanes = ct, this.mutableReadLanes = ct, this.finishedLanes = ct, this.entangledLanes = ct, this.entanglements = Pp(ct), this.identifierPrefix = y, this.onRecoverableError = T, this.mutableSourceEagerHydrationData = null, this.effectDuration = 0, this.passiveEffectDuration = 0;
      {
        this.memoizedUpdaters = /* @__PURE__ */ new Set();
        for (var R = this.pendingUpdatersLaneMap = [], $ = 0; $ < Ca; $++)
          R.push(/* @__PURE__ */ new Set());
      }
      switch (c) {
        case hC:
          this._debugRootType = g ? "hydrateRoot()" : "createRoot()";
          break;
        case pb:
          this._debugRootType = g ? "hydrate()" : "render()";
          break;
      }
    }
    function Sj(l, c, g, y, T, R, $, W, G, ae) {
      var me = new Vhe(l, c, g, W, G), Ue = zhe(c, R);
      me.current = Ue, Ue.stateNode = me;
      {
        var $e = {
          element: y,
          isDehydrated: g,
          cache: null,
          // not enabled yet
          transitions: null,
          pendingSuspenseBoundaries: null
        };
        Ue.memoizedState = $e;
      }
      return uP(Ue), me;
    }
    var nM = "18.2.0";
    function Yhe(l, c, g) {
      var y = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      return Tt(y), {
        // This tag allow us to uniquely identify this as a React Portal
        $$typeof: eo,
        key: y == null ? null : "" + y,
        children: l,
        containerInfo: c,
        implementation: g
      };
    }
    var rM, aM;
    rM = !1, aM = {};
    function wj(l) {
      if (!l)
        return Cc;
      var c = Mo(l), g = Ife(c);
      if (c.tag === f) {
        var y = c.type;
        if (Jp(y))
          return Z7(c, y, g);
      }
      return g;
    }
    function Zhe(l, c) {
      {
        var g = Mo(l);
        if (g === void 0) {
          if (typeof l.render == "function")
            throw new Error("Unable to find node on an unmounted component.");
          var y = Object.keys(l).join(",");
          throw new Error("Argument appears to not be a ReactComponent. Keys: " + y);
        }
        var T = ml(g);
        if (T === null)
          return null;
        if (T.mode & Da) {
          var R = Bn(g) || "Component";
          if (!aM[R]) {
            aM[R] = !0;
            var $ = Ua;
            try {
              ra(T), g.mode & Da ? o("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", c, c, R) : o("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", c, c, R);
            } finally {
              $ ? ra($) : wi();
            }
          }
        }
        return T.stateNode;
      }
    }
    function Tj(l, c, g, y, T, R, $, W) {
      var G = !1, ae = null;
      return Sj(l, c, G, ae, g, y, T, R, $);
    }
    function _j(l, c, g, y, T, R, $, W, G, ae) {
      var me = !0, Ue = Sj(g, y, me, l, T, R, $, W, G);
      Ue.context = wj(null);
      var $e = Ue.current, tt = nu(), rt = Tb($e), pt = $m(tt, rt);
      return pt.callback = c ?? null, gb($e, pt, rt), nhe(Ue, rt, tt), Ue;
    }
    function nw(l, c, g, y) {
      wo(c, l);
      var T = c.current, R = nu(), $ = Tb(T);
      ff($);
      var W = wj(g);
      c.context === null ? c.context = W : c.pendingContext = W, no && Ua !== null && !rM && (rM = !0, o(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`, Bn(Ua) || "Unknown"));
      var G = $m(R, $);
      G.payload = {
        element: l
      }, y = y === void 0 ? null : y, y !== null && (typeof y != "function" && o("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", y), G.callback = y);
      var ae = gb(T, G, $);
      return ae !== null && (Zo(ae, T, $, R), xC(ae, T, $)), $;
    }
    function vx(l) {
      var c = l.current;
      if (!c.child)
        return null;
      switch (c.child.tag) {
        case O:
          return c.child.stateNode;
        default:
          return c.child.stateNode;
      }
    }
    function Xhe(l) {
      switch (l.tag) {
        case m: {
          var c = l.stateNode;
          if (kr(c)) {
            var g = F1(c);
            ohe(c, g);
          }
          break;
        }
        case D: {
          Hm(function() {
            var T = Bu(l, Fn);
            if (T !== null) {
              var R = nu();
              Zo(T, l, Fn, R);
            }
          });
          var y = Fn;
          iM(l, y);
          break;
        }
      }
    }
    function Cj(l, c) {
      var g = l.memoizedState;
      g !== null && g.dehydrated !== null && (g.retryLane = Nu(g.retryLane, c));
    }
    function iM(l, c) {
      Cj(l, c);
      var g = l.alternate;
      g && Cj(g, c);
    }
    function qhe(l) {
      if (l.tag === D) {
        var c = gd, g = Bu(l, c);
        if (g !== null) {
          var y = nu();
          Zo(g, l, c, y);
        }
        iM(l, c);
      }
    }
    function Khe(l) {
      if (l.tag === D) {
        var c = Tb(l), g = Bu(l, c);
        if (g !== null) {
          var y = nu();
          Zo(g, l, c, y);
        }
        iM(l, c);
      }
    }
    function xj(l) {
      var c = _g(l);
      return c === null ? null : c.stateNode;
    }
    var Aj = function(l) {
      return null;
    };
    function Jhe(l) {
      return Aj(l);
    }
    var kj = function(l) {
      return !1;
    };
    function eme(l) {
      return kj(l);
    }
    var Rj = null, Ij = null, Dj = null, Nj = null, Pj = null, Lj = null, Mj = null, Fj = null, $j = null;
    {
      var Bj = function(l, c, g) {
        var y = c[g], T = Fi(l) ? l.slice() : fn({}, l);
        return g + 1 === c.length ? (Fi(T) ? T.splice(y, 1) : delete T[y], T) : (T[y] = Bj(l[y], c, g + 1), T);
      }, Uj = function(l, c) {
        return Bj(l, c, 0);
      }, zj = function(l, c, g, y) {
        var T = c[y], R = Fi(l) ? l.slice() : fn({}, l);
        if (y + 1 === c.length) {
          var $ = g[y];
          R[$] = R[T], Fi(R) ? R.splice(T, 1) : delete R[T];
        } else
          R[T] = zj(
            // $FlowFixMe number or string is fine here
            l[T],
            c,
            g,
            y + 1
          );
        return R;
      }, Hj = function(l, c, g) {
        if (c.length !== g.length) {
          i("copyWithRename() expects paths of the same length");
          return;
        } else
          for (var y = 0; y < g.length - 1; y++)
            if (c[y] !== g[y]) {
              i("copyWithRename() expects paths to be the same except for the deepest key");
              return;
            }
        return zj(l, c, g, 0);
      }, Wj = function(l, c, g, y) {
        if (g >= c.length)
          return y;
        var T = c[g], R = Fi(l) ? l.slice() : fn({}, l);
        return R[T] = Wj(l[T], c, g + 1, y), R;
      }, Qj = function(l, c, g) {
        return Wj(l, c, 0, g);
      }, oM = function(l, c) {
        for (var g = l.memoizedState; g !== null && c > 0; )
          g = g.next, c--;
        return g;
      };
      Rj = function(l, c, g, y) {
        var T = oM(l, c);
        if (T !== null) {
          var R = Qj(T.memoizedState, g, y);
          T.memoizedState = R, T.baseState = R, l.memoizedProps = fn({}, l.memoizedProps);
          var $ = Bu(l, Fn);
          $ !== null && Zo($, l, Fn, Yr);
        }
      }, Ij = function(l, c, g) {
        var y = oM(l, c);
        if (y !== null) {
          var T = Uj(y.memoizedState, g);
          y.memoizedState = T, y.baseState = T, l.memoizedProps = fn({}, l.memoizedProps);
          var R = Bu(l, Fn);
          R !== null && Zo(R, l, Fn, Yr);
        }
      }, Dj = function(l, c, g, y) {
        var T = oM(l, c);
        if (T !== null) {
          var R = Hj(T.memoizedState, g, y);
          T.memoizedState = R, T.baseState = R, l.memoizedProps = fn({}, l.memoizedProps);
          var $ = Bu(l, Fn);
          $ !== null && Zo($, l, Fn, Yr);
        }
      }, Nj = function(l, c, g) {
        l.pendingProps = Qj(l.memoizedProps, c, g), l.alternate && (l.alternate.pendingProps = l.pendingProps);
        var y = Bu(l, Fn);
        y !== null && Zo(y, l, Fn, Yr);
      }, Pj = function(l, c) {
        l.pendingProps = Uj(l.memoizedProps, c), l.alternate && (l.alternate.pendingProps = l.pendingProps);
        var g = Bu(l, Fn);
        g !== null && Zo(g, l, Fn, Yr);
      }, Lj = function(l, c, g) {
        l.pendingProps = Hj(l.memoizedProps, c, g), l.alternate && (l.alternate.pendingProps = l.pendingProps);
        var y = Bu(l, Fn);
        y !== null && Zo(y, l, Fn, Yr);
      }, Mj = function(l) {
        var c = Bu(l, Fn);
        c !== null && Zo(c, l, Fn, Yr);
      }, Fj = function(l) {
        Aj = l;
      }, $j = function(l) {
        kj = l;
      };
    }
    function tme(l) {
      var c = ml(l);
      return c === null ? null : c.stateNode;
    }
    function nme(l) {
      return null;
    }
    function rme() {
      return Ua;
    }
    function ame(l) {
      var c = l.findFiberByHostInstance, g = n.ReactCurrentDispatcher;
      return xg({
        bundleType: l.bundleType,
        version: l.version,
        rendererPackageName: l.rendererPackageName,
        rendererConfig: l.rendererConfig,
        overrideHookState: Rj,
        overrideHookStateDeletePath: Ij,
        overrideHookStateRenamePath: Dj,
        overrideProps: Nj,
        overridePropsDeletePath: Pj,
        overridePropsRenamePath: Lj,
        setErrorHandler: Fj,
        setSuspenseHandler: $j,
        scheduleUpdate: Mj,
        currentDispatcherRef: g,
        findHostInstanceByFiber: tme,
        findFiberByHostInstance: c || nme,
        // React Refresh
        findHostInstancesForRefresh: Phe,
        scheduleRefresh: Dhe,
        scheduleRoot: Nhe,
        setRefreshHandler: Ihe,
        // Enables DevTools to append owner stacks to error messages in DEV mode.
        getCurrentFiber: rme,
        // Enables DevTools to detect reconciler version rather than renderer version
        // which may not match for third party renderers.
        reconcilerVersion: nM
      });
    }
    var jj = typeof reportError == "function" ? (
      // In modern browsers, reportError will dispatch an error event,
      // emulating an uncaught JavaScript error.
      reportError
    ) : function(l) {
      console.error(l);
    };
    function sM(l) {
      this._internalRoot = l;
    }
    yx.prototype.render = sM.prototype.render = function(l) {
      var c = this._internalRoot;
      if (c === null)
        throw new Error("Cannot update an unmounted root.");
      {
        typeof arguments[1] == "function" ? o("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : Ox(arguments[1]) ? o("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : typeof arguments[1] < "u" && o("You passed a second argument to root.render(...) but it only accepts one argument.");
        var g = c.containerInfo;
        if (g.nodeType !== $r) {
          var y = xj(c.current);
          y && y.parentNode !== g && o("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
        }
      }
      nw(l, c, null, null);
    }, yx.prototype.unmount = sM.prototype.unmount = function() {
      typeof arguments[0] == "function" && o("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
      var l = this._internalRoot;
      if (l !== null) {
        this._internalRoot = null;
        var c = l.containerInfo;
        rj() && o("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."), Hm(function() {
          nw(null, l, null, null);
        }), St(c);
      }
    };
    function ime(l, c) {
      if (!Ox(l))
        throw new Error("createRoot(...): Target container is not a DOM element.");
      Gj(l);
      var g = !1, y = !1, T = "", R = jj;
      c != null && (c.hydrate ? i("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : typeof c == "object" && c !== null && c.$$typeof === Pi && o(`You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`), c.unstable_strictMode === !0 && (g = !0), c.identifierPrefix !== void 0 && (T = c.identifierPrefix), c.onRecoverableError !== void 0 && (R = c.onRecoverableError), c.transitionCallbacks !== void 0 && c.transitionCallbacks);
      var $ = Tj(l, hC, null, g, y, T, R);
      Qe($.current, l);
      var W = l.nodeType === $r ? l.parentNode : l;
      return fy(W), new sM($);
    }
    function yx(l) {
      this._internalRoot = l;
    }
    function ome(l) {
      l && Zv(l);
    }
    yx.prototype.unstable_scheduleHydration = ome;
    function sme(l, c, g) {
      if (!Ox(l))
        throw new Error("hydrateRoot(...): Target container is not a DOM element.");
      Gj(l), c === void 0 && o("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
      var y = g ?? null, T = g != null && g.hydratedSources || null, R = !1, $ = !1, W = "", G = jj;
      g != null && (g.unstable_strictMode === !0 && (R = !0), g.identifierPrefix !== void 0 && (W = g.identifierPrefix), g.onRecoverableError !== void 0 && (G = g.onRecoverableError));
      var ae = _j(c, null, l, hC, y, R, $, W, G);
      if (Qe(ae.current, l), fy(l), T)
        for (var me = 0; me < T.length; me++) {
          var Ue = T[me];
          mde(ae, Ue);
        }
      return new yx(ae);
    }
    function Ox(l) {
      return !!(l && (l.nodeType === rs || l.nodeType === Cs || l.nodeType === Wl || !_e));
    }
    function rw(l) {
      return !!(l && (l.nodeType === rs || l.nodeType === Cs || l.nodeType === Wl || l.nodeType === $r && l.nodeValue === " react-mount-point-unstable "));
    }
    function Gj(l) {
      l.nodeType === rs && l.tagName && l.tagName.toUpperCase() === "BODY" && o("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app."), Ot(l) && (l._reactRootContainer ? o("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : o("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
    }
    var lme = n.ReactCurrentOwner, Vj;
    Vj = function(l) {
      if (l._reactRootContainer && l.nodeType !== $r) {
        var c = xj(l._reactRootContainer.current);
        c && c.parentNode !== l && o("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
      }
      var g = !!l._reactRootContainer, y = lM(l), T = !!(y && Vt(y));
      T && !g && o("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render."), l.nodeType === rs && l.tagName && l.tagName.toUpperCase() === "BODY" && o("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function lM(l) {
      return l ? l.nodeType === Cs ? l.documentElement : l.firstChild : null;
    }
    function Yj() {
    }
    function ume(l, c, g, y, T) {
      if (T) {
        if (typeof y == "function") {
          var R = y;
          y = function() {
            var $e = vx($);
            R.call($e);
          };
        }
        var $ = _j(
          c,
          y,
          l,
          pb,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          Yj
        );
        l._reactRootContainer = $, Qe($.current, l);
        var W = l.nodeType === $r ? l.parentNode : l;
        return fy(W), Hm(), $;
      } else {
        for (var G; G = l.lastChild; )
          l.removeChild(G);
        if (typeof y == "function") {
          var ae = y;
          y = function() {
            var $e = vx(me);
            ae.call($e);
          };
        }
        var me = Tj(
          l,
          pb,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          Yj
        );
        l._reactRootContainer = me, Qe(me.current, l);
        var Ue = l.nodeType === $r ? l.parentNode : l;
        return fy(Ue), Hm(function() {
          nw(c, me, g, y);
        }), me;
      }
    }
    function cme(l, c) {
      l !== null && typeof l != "function" && o("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", c, l);
    }
    function Ex(l, c, g, y, T) {
      Vj(g), cme(T === void 0 ? null : T, "render");
      var R = g._reactRootContainer, $;
      if (!R)
        $ = ume(g, c, l, T, y);
      else {
        if ($ = R, typeof T == "function") {
          var W = T;
          T = function() {
            var G = vx($);
            W.call(G);
          };
        }
        nw(c, $, l, T);
      }
      return vx($);
    }
    function fme(l) {
      {
        var c = lme.current;
        if (c !== null && c.stateNode !== null) {
          var g = c.stateNode._warnedAboutRefsInRender;
          g || o("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", Qr(c.type) || "A component"), c.stateNode._warnedAboutRefsInRender = !0;
        }
      }
      return l == null ? null : l.nodeType === rs ? l : Zhe(l, "findDOMNode");
    }
    function dme(l, c, g) {
      if (o("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !rw(c))
        throw new Error("Target container is not a DOM element.");
      {
        var y = Ot(c) && c._reactRootContainer === void 0;
        y && o("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
      }
      return Ex(null, l, c, !0, g);
    }
    function pme(l, c, g) {
      if (o("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !rw(c))
        throw new Error("Target container is not a DOM element.");
      {
        var y = Ot(c) && c._reactRootContainer === void 0;
        y && o("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
      }
      return Ex(null, l, c, !1, g);
    }
    function hme(l, c, g, y) {
      if (o("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !rw(g))
        throw new Error("Target container is not a DOM element.");
      if (l == null || !Oo(l))
        throw new Error("parentComponent must be a valid React Component");
      return Ex(l, c, g, !1, y);
    }
    function mme(l) {
      if (!rw(l))
        throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
      {
        var c = Ot(l) && l._reactRootContainer === void 0;
        c && o("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
      }
      if (l._reactRootContainer) {
        {
          var g = lM(l), y = g && !Vt(g);
          y && o("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
        }
        return Hm(function() {
          Ex(null, null, l, !1, function() {
            l._reactRootContainer = null, St(l);
          });
        }), !0;
      } else {
        {
          var T = lM(l), R = !!(T && Vt(T)), $ = l.nodeType === rs && rw(l.parentNode) && !!l.parentNode._reactRootContainer;
          R && o("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", $ ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
        }
        return !1;
      }
    }
    un(Xhe), eO(qhe), $p(Khe), Qv(Ps), tO(Mp), (typeof Map != "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach != "function" || typeof Set != "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear != "function" || typeof Set.prototype.forEach != "function") && o("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), Eg(rC), qh(BL, she, Hm);
    function gme(l, c) {
      var g = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!Ox(c))
        throw new Error("Target container is not a DOM element.");
      return Yhe(l, c, null, g);
    }
    function bme(l, c, g, y) {
      return hme(l, c, g, y);
    }
    var uM = {
      usingClientEntryPoint: !1,
      // Keep in sync with ReactTestUtils.js.
      // This is an array for better minification.
      Events: [Vt, hn, $n, Sg, Xh, BL]
    };
    function vme(l, c) {
      return uM.usingClientEntryPoint || o('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), ime(l, c);
    }
    function yme(l, c, g) {
      return uM.usingClientEntryPoint || o('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), sme(l, c, g);
    }
    function Ome(l) {
      return rj() && o("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."), Hm(l);
    }
    var Eme = ame({
      findFiberByHostInstance: _t,
      bundleType: 1,
      version: nM,
      rendererPackageName: "react-dom"
    });
    if (!Eme && lt && window.top === window.self && (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1)) {
      var Zj = window.location.protocol;
      /^(https?|file):$/.test(Zj) && console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (Zj === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq` : ""), "font-weight:bold");
    }
    Qu.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = uM, Qu.createPortal = gme, Qu.createRoot = vme, Qu.findDOMNode = fme, Qu.flushSync = Ome, Qu.hydrate = dme, Qu.hydrateRoot = yme, Qu.render = pme, Qu.unmountComponentAtNode = mme, Qu.unstable_batchedUpdates = BL, Qu.unstable_renderSubtreeIntoContainer = bme, Qu.version = nM, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Qu;
}
function bte() {
  if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
    if (process.env.NODE_ENV !== "production")
      throw new Error("^_^");
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(bte);
    } catch (t) {
      console.error(t);
    }
  }
}
process.env.NODE_ENV === "production" ? (bte(), yF.exports = gbe()) : yF.exports = bbe();
var d_ = yF.exports;
const vbe = /* @__PURE__ */ Pl(d_);
function vte(t, e) {
  if (t == null)
    return {};
  var n = {}, r = Object.keys(t), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(e.indexOf(a) >= 0) && (n[a] = t[a]);
  return n;
}
var yte = typeof window < "u" && typeof document < "u";
function OF(t, e) {
  t && (typeof t == "function" && t(e), {}.hasOwnProperty.call(t, "current") && (t.current = e));
}
function CG() {
  return yte && document.createElement("div");
}
function ybe(t) {
  var e = {
    "data-placement": t.placement
  };
  return t.referenceHidden && (e["data-reference-hidden"] = ""), t.escaped && (e["data-escaped"] = ""), e;
}
function Ote(t, e) {
  if (t === e)
    return !0;
  if (typeof t == "object" && t != null && typeof e == "object" && e != null) {
    if (Object.keys(t).length !== Object.keys(e).length)
      return !1;
    for (var n in t)
      if (e.hasOwnProperty(n)) {
        if (!Ote(t[n], e[n]))
          return !1;
      } else
        return !1;
    return !0;
  } else
    return !1;
}
function Obe(t) {
  var e = [];
  return t.forEach(function(n) {
    e.find(function(r) {
      return Ote(n, r);
    }) || e.push(n);
  }), e;
}
function Ebe(t, e) {
  var n, r;
  return Object.assign({}, e, {
    popperOptions: Object.assign({}, t.popperOptions, e.popperOptions, {
      modifiers: Obe([].concat(((n = t.popperOptions) == null ? void 0 : n.modifiers) || [], ((r = e.popperOptions) == null ? void 0 : r.modifiers) || []))
    })
  });
}
var vM = yte ? l_ : Vn;
function Sbe(t) {
  var e = dr();
  return e.current || (e.current = typeof t == "function" ? t() : t), e.current;
}
function xG(t, e, n) {
  n.split(/\s+/).forEach(function(r) {
    r && t.classList[e](r);
  });
}
var wbe = {
  name: "className",
  defaultValue: "",
  fn: function(e) {
    var n = e.popper.firstElementChild, r = function() {
      var s;
      return !!((s = e.props.render) != null && s.$$tippy);
    };
    function a() {
      if (e.props.className && !r()) {
        process.env.NODE_ENV !== "production" && console.warn(["@tippyjs/react: Cannot use `className` prop in conjunction with", "`render` prop. Place the className on the element you are", "rendering."].join(" "));
        return;
      }
      xG(n, "add", e.props.className);
    }
    function i() {
      r() && xG(n, "remove", e.props.className);
    }
    return {
      onCreate: a,
      onBeforeUpdate: i,
      onAfterUpdate: a
    };
  }
};
function Tbe(t) {
  function e(n) {
    var r = n.children, a = n.content, i = n.visible, o = n.singleton, s = n.render, u = n.reference, f = n.disabled, p = f === void 0 ? !1 : f, m = n.ignoreAttributes, v = m === void 0 ? !0 : m;
    n.__source, n.__self;
    var O = vte(n, ["children", "content", "visible", "singleton", "render", "reference", "disabled", "ignoreAttributes", "__source", "__self"]), w = i !== void 0, _ = o !== void 0, C = kn(!1), A = C[0], N = C[1], P = kn({}), I = P[0], D = P[1], M = kn(), H = M[0], Y = M[1], q = Sbe(function() {
      return {
        container: CG(),
        renders: 1
      };
    }), Q = Object.assign({
      ignoreAttributes: v
    }, O, {
      content: q.container
    });
    w && (process.env.NODE_ENV !== "production" && ["trigger", "hideOnClick", "showOnCreate"].forEach(function(ee) {
      Q[ee] !== void 0 && console.warn(["@tippyjs/react: Cannot specify `" + ee + "` prop in", "controlled mode (`visible` prop)"].join(" "));
    }), Q.trigger = "manual", Q.hideOnClick = !1), _ && (p = !0);
    var ne = Q, J = Q.plugins || [];
    s && (ne = Object.assign({}, Q, {
      plugins: _ && o.data != null ? [].concat(J, [{
        fn: function() {
          return {
            onTrigger: function(de, ie) {
              var le = o.data.children.find(function(ye) {
                var B = ye.instance;
                return B.reference === ie.currentTarget;
              });
              de.state.$$activeSingletonInstance = le.instance, Y(le.content);
            }
          };
        }
      }]) : J,
      render: function() {
        return {
          popper: q.container
        };
      }
    }));
    var ue = [u].concat(r ? [r.type] : []);
    return vM(function() {
      var ee = u;
      u && u.hasOwnProperty("current") && (ee = u.current);
      var fe = t(ee || q.ref || CG(), Object.assign({}, ne, {
        plugins: [wbe].concat(Q.plugins || [])
      }));
      return q.instance = fe, p && fe.disable(), i && fe.show(), _ && o.hook({
        instance: fe,
        content: a,
        props: ne,
        setSingletonContent: Y
      }), N(!0), function() {
        fe.destroy(), o == null || o.cleanup(fe);
      };
    }, ue), vM(function() {
      var ee;
      if (q.renders === 1) {
        q.renders++;
        return;
      }
      var fe = q.instance;
      fe.setProps(Ebe(fe.props, ne)), (ee = fe.popperInstance) == null || ee.forceUpdate(), p ? fe.disable() : fe.enable(), w && (i ? fe.show() : fe.hide()), _ && o.hook({
        instance: fe,
        content: a,
        props: ne,
        setSingletonContent: Y
      });
    }), vM(function() {
      var ee;
      if (s) {
        var fe = q.instance;
        fe.setProps({
          popperOptions: Object.assign({}, fe.props.popperOptions, {
            modifiers: [].concat((((ee = fe.props.popperOptions) == null ? void 0 : ee.modifiers) || []).filter(function(de) {
              var ie = de.name;
              return ie !== "$$tippyReact";
            }), [{
              name: "$$tippyReact",
              enabled: !0,
              phase: "beforeWrite",
              requires: ["computeStyles"],
              fn: function(ie) {
                var le, ye = ie.state, B = (le = ye.modifiersData) == null ? void 0 : le.hide;
                (I.placement !== ye.placement || I.referenceHidden !== (B == null ? void 0 : B.isReferenceHidden) || I.escaped !== (B == null ? void 0 : B.hasPopperEscaped)) && D({
                  placement: ye.placement,
                  referenceHidden: B == null ? void 0 : B.isReferenceHidden,
                  escaped: B == null ? void 0 : B.hasPopperEscaped
                }), ye.attributes.popper = {};
              }
            }])
          })
        });
      }
    }, [I.placement, I.referenceHidden, I.escaped].concat(ue)), /* @__PURE__ */ Ge.createElement(Ge.Fragment, null, r ? /* @__PURE__ */ $I(r, {
      ref: function(fe) {
        q.ref = fe, OF(r.ref, fe);
      }
    }) : null, A && /* @__PURE__ */ d_.createPortal(s ? s(ybe(I), H, q.instance) : a, q.container));
  }
  return e;
}
var _be = function(t, e) {
  return /* @__PURE__ */ bs(function(r, a) {
    var i = r.children, o = vte(r, ["children"]);
    return (
      // If I spread them separately here, Babel adds the _extends ponyfill for
      // some reason
      /* @__PURE__ */ Ge.createElement(t, Object.assign({}, e, o), i ? /* @__PURE__ */ $I(i, {
        ref: function(u) {
          OF(a, u), OF(i.ref, u);
        }
      }) : null)
    );
  });
}, Cbe = /* @__PURE__ */ _be(/* @__PURE__ */ Tbe(f_));
const r1 = Cbe, Ab = "byz-button", xbe = ({
  className: t,
  type: e,
  disabled: n,
  onClick: r,
  onDisabledClick: a,
  iconType: i,
  tip: o,
  disabledTip: s,
  tipDelay: u,
  tipTrigger: f = "buttonHover",
  tipLocation: p,
  children: m,
  label: v = m,
  ...O
}) => {
  const w = dr(null), _ = dr(null), C = !!(n && s || !n && o), A = (N) => {
    if (N.preventDefault(), n) {
      a == null || a(N);
      return;
    }
    r == null || r(N);
  };
  return /* @__PURE__ */ Ne.jsxs(Ne.Fragment, { children: [
    /* @__PURE__ */ Ne.jsxs("button", { onClick: A, ref: w, className: pn(Ab, t, {
      [`${Ab}--disabled`]: n,
      [`${Ab}--type-${e}`]: e && !n,
      [`${Ab}--with-icon`]: i,
      [`${Ab}--sans-label`]: !v
    }), children: [
      !!v && /* @__PURE__ */ Ne.jsx("span", { children: v }),
      i && /* @__PURE__ */ Ne.jsx("i", { ref: _, className: pn(`${Ab}__icon`, {
        [`${Ab}__icon--${i}`]: !0
      }) })
    ] }),
    C && /* @__PURE__ */ Ne.jsx(
      r1,
      {
        content: n ? s : o,
        className: pn(`${Ab}__tippy-button-container`),
        reference: w,
        triggerTarget: f != null && f.startsWith("icon") ? _.current : w.current,
        placement: p,
        trigger: f === "iconClick" ? "click" : "mouseenter focus",
        delay: u,
        offset: [0, 15]
      }
    )
  ] });
}, AG = "wizard-actions", $5 = ({
  className: t,
  children: e,
  disableNext: n,
  nextDisabledTip: r,
  nextTip: a,
  beforeNext: i,
  nextIconType: o,
  nextText: s = "Next",
  nextButtonType: u,
  nextButtonClassname: f,
  ...p
}) => {
  const { uid: m } = nc(ov), { activateNextStep: v, enableNextStep: O, activeUid: w } = nc(S0), _ = Ei(() => {
    (i == null ? void 0 : i(m)) !== !1 && v();
  }, [m]);
  return /* @__PURE__ */ Ne.jsxs("div", { className: pn(AG, t, {
    [`${AG}--active`]: w === m
  }), ...p, children: [
    e,
    /* @__PURE__ */ Ne.jsx(
      xbe,
      {
        disabled: n,
        tip: a,
        iconType: o,
        disabledTip: r,
        type: u,
        className: f,
        onClick: () => _(),
        children: s
      }
    )
  ] });
};
$5.displayName = "WizardActions";
var Qk = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
Qk.exports;
(function(t, e) {
  (function() {
    var n, r = "4.17.21", a = 200, i = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", o = "Expected a function", s = "Invalid `variable` option passed into `_.template`", u = "__lodash_hash_undefined__", f = 500, p = "__lodash_placeholder__", m = 1, v = 2, O = 4, w = 1, _ = 2, C = 1, A = 2, N = 4, P = 8, I = 16, D = 32, M = 64, H = 128, Y = 256, q = 512, Q = 30, ne = "...", J = 800, ue = 16, ee = 1, fe = 2, de = 3, ie = 1 / 0, le = 9007199254740991, ye = 17976931348623157e292, B = 0 / 0, pe = 4294967295, _e = pe - 1, Z = pe >>> 1, ce = [
      ["ary", H],
      ["bind", C],
      ["bindKey", A],
      ["curry", P],
      ["curryRight", I],
      ["flip", q],
      ["partial", D],
      ["partialRight", M],
      ["rearg", Y]
    ], j = "[object Arguments]", K = "[object Array]", Ee = "[object AsyncFunction]", he = "[object Boolean]", Ae = "[object Date]", Te = "[object DOMException]", je = "[object Error]", we = "[object Function]", lt = "[object GeneratorFunction]", st = "[object Map]", Oe = "[object Number]", Re = "[object Null]", Be = "[object Object]", mt = "[object Promise]", Tt = "[object Proxy]", ut = "[object RegExp]", wt = "[object Set]", Yt = "[object String]", Rt = "[object Symbol]", Ut = "[object Undefined]", He = "[object WeakMap]", Ve = "[object WeakSet]", Ie = "[object ArrayBuffer]", it = "[object DataView]", zt = "[object Float32Array]", Ht = "[object Float64Array]", bt = "[object Int8Array]", Mt = "[object Int16Array]", ln = "[object Int32Array]", ze = "[object Uint8Array]", gt = "[object Uint8ClampedArray]", Bt = "[object Uint16Array]", Qt = "[object Uint32Array]", En = /\b__p \+= '';/g, Mn = /\b(__p \+=) '' \+/g, br = /(__e\(.*?\)|\b__t\)) \+\n'';/g, sr = /&(?:amp|lt|gt|quot|#39);/g, Ar = /[&<>"']/g, Ji = RegExp(sr.source), po = RegExp(Ar.source), Ni = /<%-([\s\S]+?)%>/g, oi = /<%([\s\S]+?)%>/g, gu = /<%=([\s\S]+?)%>/g, ho = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Jo = /^\w*$/, bu = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, vu = /[\\^$.*+?()[\]{}|]/g, Lo = RegExp(vu.source), Pi = /^\s+/, eo = /\s/, es = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Fl = /\{\n\/\* \[wrapped with (.+)\] \*/, xe = /,? & /, xt = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, jt = /[()=,{}\[\]\/\s]/, Sn = /\\(\\)?/g, Yn = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, ur = /\w*$/, qn = /^[-+]0x[0-9a-f]+$/i, Rn = /^0b[01]+$/i, Ba = /^\[object .+?Constructor\]$/, ma = /^0o[0-7]+$/i, ve = /^(?:0|[1-9]\d*)$/, Ye = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, yt = /($^)/, Dt = /['\n\r\u2028\u2029\\]/g, Lt = "\\ud800-\\udfff", _n = "\\u0300-\\u036f", Nn = "\\ufe20-\\ufe2f", fn = "\\u20d0-\\u20ff", Or = _n + Nn + fn, Er = "\\u2700-\\u27bf", pr = "a-z\\xdf-\\xf6\\xf8-\\xff", Li = "\\xac\\xb1\\xd7\\xf7", Aa = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", ua = "\\u2000-\\u206f", Mr = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", to = "A-Z\\xc0-\\xd6\\xd8-\\xde", $l = "\\ufe0e\\ufe0f", Bl = Li + Aa + ua + Mr, il = "['’]", ac = "[" + Lt + "]", yu = "[" + Bl + "]", mo = "[" + Or + "]", Fr = "\\d+", _r = "[" + Er + "]", Qc = "[" + pr + "]", Ts = "[^" + Lt + Bl + Fr + Er + pr + to + "]", Ou = "\\ud83c[\\udffb-\\udfff]", si = "(?:" + mo + "|" + Ou + ")", ol = "[^" + Lt + "]", go = "(?:\\ud83c[\\udde6-\\uddff]){2}", hr = "[\\ud800-\\udbff][\\udc00-\\udfff]", _s = "[" + to + "]", Eu = "\\u200d", ts = "(?:" + Qc + "|" + Ts + ")", Qr = "(?:" + _s + "|" + Ts + ")", jc = "(?:" + il + "(?:d|ll|m|re|s|t|ve))?", Gc = "(?:" + il + "(?:D|LL|M|RE|S|T|VE))?", Bn = si + "?", Ul = "[" + $l + "]?", Ua = "(?:" + Eu + "(?:" + [ol, go, hr].join("|") + ")" + Ul + Bn + ")*", no = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", ro = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rp = Ul + Bn + Ua, wi = "(?:" + [_r, go, hr].join("|") + ")" + rp, ra = "(?:" + [ol + mo + "?", mo, go, hr, ac].join("|") + ")", A1 = RegExp(il, "g"), zl = RegExp(mo, "g"), Mi = RegExp(Ou + "(?=" + Ou + ")|" + ra + rp, "g"), Vc = RegExp([
      _s + "?" + Qc + "+" + jc + "(?=" + [yu, _s, "$"].join("|") + ")",
      Qr + "+" + Gc + "(?=" + [yu, _s + ts, "$"].join("|") + ")",
      _s + "?" + ts + "+" + jc,
      _s + "+" + Gc,
      ro,
      no,
      Fr,
      wi
    ].join("|"), "g"), L0 = RegExp("[" + Eu + Lt + Or + $l + "]"), ap = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, mv = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], M0 = -1, Jr = {};
    Jr[zt] = Jr[Ht] = Jr[bt] = Jr[Mt] = Jr[ln] = Jr[ze] = Jr[gt] = Jr[Bt] = Jr[Qt] = !0, Jr[j] = Jr[K] = Jr[Ie] = Jr[he] = Jr[it] = Jr[Ae] = Jr[je] = Jr[we] = Jr[st] = Jr[Oe] = Jr[Be] = Jr[ut] = Jr[wt] = Jr[Yt] = Jr[He] = !1;
    var jr = {};
    jr[j] = jr[K] = jr[Ie] = jr[it] = jr[he] = jr[Ae] = jr[zt] = jr[Ht] = jr[bt] = jr[Mt] = jr[ln] = jr[st] = jr[Oe] = jr[Be] = jr[ut] = jr[wt] = jr[Yt] = jr[Rt] = jr[ze] = jr[gt] = jr[Bt] = jr[Qt] = !0, jr[je] = jr[we] = jr[He] = !1;
    var ip = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, nd = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, F0 = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, lg = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, ug = parseFloat, $h = parseInt, Bh = typeof $b == "object" && $b && $b.Object === Object && $b, gv = typeof self == "object" && self && self.Object === Object && self, Ta = Bh || gv || Function("return this")(), rd = e && !e.nodeType && e, Hl = rd && !0 && t && !t.nodeType && t, cg = Hl && Hl.exports === rd, Yc = cg && Bh.process, bo = function() {
      try {
        var We = Hl && Hl.require && Hl.require("util").types;
        return We || Yc && Yc.binding && Yc.binding("util");
      } catch {
      }
    }(), bv = bo && bo.isArrayBuffer, ns = bo && bo.isDate, ic = bo && bo.isMap, Uh = bo && bo.isRegExp, ad = bo && bo.isSet, vv = bo && bo.isTypedArray;
    function vo(We, dt, et) {
      switch (et.length) {
        case 0:
          return We.call(dt);
        case 1:
          return We.call(dt, et[0]);
        case 2:
          return We.call(dt, et[0], et[1]);
        case 3:
          return We.call(dt, et[0], et[1], et[2]);
      }
      return We.apply(dt, et);
    }
    function yv(We, dt, et, Jt) {
      for (var Kn = -1, Br = We == null ? 0 : We.length; ++Kn < Br; ) {
        var gi = We[Kn];
        dt(Jt, gi, et(gi), We);
      }
      return Jt;
    }
    function yo(We, dt) {
      for (var et = -1, Jt = We == null ? 0 : We.length; ++et < Jt && dt(We[et], et, We) !== !1; )
        ;
      return We;
    }
    function Fi(We, dt) {
      for (var et = We == null ? 0 : We.length; et-- && dt(We[et], et, We) !== !1; )
        ;
      return We;
    }
    function zh(We, dt) {
      for (var et = -1, Jt = We == null ? 0 : We.length; ++et < Jt; )
        if (!dt(We[et], et, We))
          return !1;
      return !0;
    }
    function oc(We, dt) {
      for (var et = -1, Jt = We == null ? 0 : We.length, Kn = 0, Br = []; ++et < Jt; ) {
        var gi = We[et];
        dt(gi, et, We) && (Br[Kn++] = gi);
      }
      return Br;
    }
    function Hh(We, dt) {
      var et = We == null ? 0 : We.length;
      return !!et && id(We, dt, 0) > -1;
    }
    function Ov(We, dt, et) {
      for (var Jt = -1, Kn = We == null ? 0 : We.length; ++Jt < Kn; )
        if (et(dt, We[Jt]))
          return !0;
      return !1;
    }
    function Hr(We, dt) {
      for (var et = -1, Jt = We == null ? 0 : We.length, Kn = Array(Jt); ++et < Jt; )
        Kn[et] = dt(We[et], et, We);
      return Kn;
    }
    function Su(We, dt) {
      for (var et = -1, Jt = dt.length, Kn = We.length; ++et < Jt; )
        We[Kn + et] = dt[et];
      return We;
    }
    function fg(We, dt, et, Jt) {
      var Kn = -1, Br = We == null ? 0 : We.length;
      for (Jt && Br && (et = We[++Kn]); ++Kn < Br; )
        et = dt(et, We[Kn], Kn, We);
      return et;
    }
    function k1(We, dt, et, Jt) {
      var Kn = We == null ? 0 : We.length;
      for (Jt && Kn && (et = We[--Kn]); Kn--; )
        et = dt(et, We[Kn], Kn, We);
      return et;
    }
    function Ev(We, dt) {
      for (var et = -1, Jt = We == null ? 0 : We.length; ++et < Jt; )
        if (dt(We[et], et, We))
          return !0;
      return !1;
    }
    var R1 = Qh("length");
    function Sv(We) {
      return We.split("");
    }
    function wv(We) {
      return We.match(xt) || [];
    }
    function Tv(We, dt, et) {
      var Jt;
      return et(We, function(Kn, Br, gi) {
        if (dt(Kn, Br, gi))
          return Jt = Br, !1;
      }), Jt;
    }
    function Wh(We, dt, et, Jt) {
      for (var Kn = We.length, Br = et + (Jt ? 1 : -1); Jt ? Br-- : ++Br < Kn; )
        if (dt(We[Br], Br, We))
          return Br;
      return -1;
    }
    function id(We, dt, et) {
      return dt === dt ? dp(We, dt, et) : Wh(We, wu, et);
    }
    function _v(We, dt, et, Jt) {
      for (var Kn = et - 1, Br = We.length; ++Kn < Br; )
        if (Jt(We[Kn], dt))
          return Kn;
      return -1;
    }
    function wu(We) {
      return We !== We;
    }
    function $0(We, dt) {
      var et = We == null ? 0 : We.length;
      return et ? sp(We, dt) / et : B;
    }
    function Qh(We) {
      return function(dt) {
        return dt == null ? n : dt[We];
      };
    }
    function op(We) {
      return function(dt) {
        return We == null ? n : We[dt];
      };
    }
    function dg(We, dt, et, Jt, Kn) {
      return Kn(We, function(Br, gi, Gr) {
        et = Jt ? (Jt = !1, Br) : dt(et, Br, gi, Gr);
      }), et;
    }
    function I1(We, dt) {
      var et = We.length;
      for (We.sort(dt); et--; )
        We[et] = We[et].value;
      return We;
    }
    function sp(We, dt) {
      for (var et, Jt = -1, Kn = We.length; ++Jt < Kn; ) {
        var Br = dt(We[Jt]);
        Br !== n && (et = et === n ? Br : et + Br);
      }
      return et;
    }
    function pg(We, dt) {
      for (var et = -1, Jt = Array(We); ++et < We; )
        Jt[et] = dt(et);
      return Jt;
    }
    function rs(We, dt) {
      return Hr(dt, function(et) {
        return [et, We[et]];
      });
    }
    function Tu(We) {
      return We && We.slice(0, gg(We) + 1).replace(Pi, "");
    }
    function $r(We) {
      return function(dt) {
        return We(dt);
      };
    }
    function Cs(We, dt) {
      return Hr(dt, function(et) {
        return We[et];
      });
    }
    function Wl(We, dt) {
      return We.has(dt);
    }
    function jh(We, dt) {
      for (var et = -1, Jt = We.length; ++et < Jt && id(dt, We[et], 0) > -1; )
        ;
      return et;
    }
    function Cv(We, dt) {
      for (var et = We.length; et-- && id(dt, We[et], 0) > -1; )
        ;
      return et;
    }
    function lp(We, dt) {
      for (var et = We.length, Jt = 0; et--; )
        We[et] === dt && ++Jt;
      return Jt;
    }
    var B0 = op(ip), U0 = op(nd);
    function hg(We) {
      return "\\" + lg[We];
    }
    function up(We, dt) {
      return We == null ? n : We[dt];
    }
    function cp(We) {
      return L0.test(We);
    }
    function D1(We) {
      return ap.test(We);
    }
    function z0(We) {
      for (var dt, et = []; !(dt = We.next()).done; )
        et.push(dt.value);
      return et;
    }
    function mg(We) {
      var dt = -1, et = Array(We.size);
      return We.forEach(function(Jt, Kn) {
        et[++dt] = [Kn, Jt];
      }), et;
    }
    function xv(We, dt) {
      return function(et) {
        return We(dt(et));
      };
    }
    function sl(We, dt) {
      for (var et = -1, Jt = We.length, Kn = 0, Br = []; ++et < Jt; ) {
        var gi = We[et];
        (gi === dt || gi === p) && (We[et] = p, Br[Kn++] = et);
      }
      return Br;
    }
    function sc(We) {
      var dt = -1, et = Array(We.size);
      return We.forEach(function(Jt) {
        et[++dt] = Jt;
      }), et;
    }
    function fp(We) {
      var dt = -1, et = Array(We.size);
      return We.forEach(function(Jt) {
        et[++dt] = [Jt, Jt];
      }), et;
    }
    function dp(We, dt, et) {
      for (var Jt = et - 1, Kn = We.length; ++Jt < Kn; )
        if (We[Jt] === dt)
          return Jt;
      return -1;
    }
    function H0(We, dt, et) {
      for (var Jt = et + 1; Jt--; )
        if (We[Jt] === dt)
          return Jt;
      return Jt;
    }
    function Zc(We) {
      return cp(We) ? Q0(We) : R1(We);
    }
    function xs(We) {
      return cp(We) ? j0(We) : Sv(We);
    }
    function gg(We) {
      for (var dt = We.length; dt-- && eo.test(We.charAt(dt)); )
        ;
      return dt;
    }
    var W0 = op(F0);
    function Q0(We) {
      for (var dt = Mi.lastIndex = 0; Mi.test(We); )
        ++dt;
      return dt;
    }
    function j0(We) {
      return We.match(Mi) || [];
    }
    function N1(We) {
      return We.match(Vc) || [];
    }
    var P1 = function We(dt) {
      dt = dt == null ? Ta : pp.defaults(Ta.Object(), dt, pp.pick(Ta, mv));
      var et = dt.Array, Jt = dt.Date, Kn = dt.Error, Br = dt.Function, gi = dt.Math, Gr = dt.Object, Ql = dt.RegExp, bg = dt.String, As = dt.TypeError, as = et.prototype, Av = Br.prototype, _u = Gr.prototype, hp = dt["__core-js_shared__"], Gh = Av.toString, Ur = _u.hasOwnProperty, od = 0, vg = function() {
        var b = /[^.]+$/.exec(hp && hp.keys && hp.keys.IE_PROTO || "");
        return b ? "Symbol(src)_1." + b : "";
      }(), mp = _u.toString, $i = Gh.call(Gr), kv = Ta._, G0 = Ql(
        "^" + Gh.call(Ur).replace(vu, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), Vh = cg ? dt.Buffer : n, lc = dt.Symbol, Yh = dt.Uint8Array, Rv = Vh ? Vh.allocUnsafe : n, ll = xv(Gr.getPrototypeOf, Gr), gp = Gr.create, Xc = _u.propertyIsEnumerable, yg = as.splice, bp = lc ? lc.isConcatSpreadable : n, uc = lc ? lc.iterator : n, sd = lc ? lc.toStringTag : n, Zh = function() {
        try {
          var b = Pu(Gr, "defineProperty");
          return b({}, "", {}), b;
        } catch {
        }
      }(), Og = dt.clearTimeout !== Ta.clearTimeout && dt.clearTimeout, ca = Jt && Jt.now !== Ta.Date.now && Jt.now, qc = dt.setTimeout !== Ta.setTimeout && dt.setTimeout, ul = gi.ceil, cc = gi.floor, Eg = Gr.getOwnPropertySymbols, Sg = Vh ? Vh.isBuffer : n, vp = dt.isFinite, Xh = as.join, ld = xv(Gr.keys, Gr), li = gi.max, Bi = gi.min, L1 = Jt.now, Iv = dt.parseInt, qh = gi.random, wg = as.reverse, Kh = Pu(dt, "DataView"), jl = Pu(dt, "Map"), ud = Pu(dt, "Promise"), cl = Pu(dt, "Set"), yp = Pu(dt, "WeakMap"), cd = Pu(Gr, "create"), Op = yp && new yp(), Ep = {}, Kc = Ef(Kh), Gl = Ef(jl), Jh = Ef(ud), Jc = Ef(cl), Cu = Ef(yp), xu = lc ? lc.prototype : n, ks = xu ? xu.valueOf : n, Tg = xu ? xu.toString : n;
      function re(b) {
        if (di(b) && !or(b) && !(b instanceof ar)) {
          if (b instanceof Oo)
            return b;
          if (Ur.call(b, "__wrapped__"))
            return Zv(b);
        }
        return new Oo(b);
      }
      var ef = function() {
        function b() {
        }
        return function(E) {
          if (!ti(E))
            return {};
          if (gp)
            return gp(E);
          b.prototype = E;
          var k = new b();
          return b.prototype = n, k;
        };
      }();
      function Mo() {
      }
      function Oo(b, E) {
        this.__wrapped__ = b, this.__actions__ = [], this.__chain__ = !!E, this.__index__ = 0, this.__values__ = n;
      }
      re.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: Ni,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: oi,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: gu,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: re
        }
      }, re.prototype = Mo.prototype, re.prototype.constructor = re, Oo.prototype = ef(Mo.prototype), Oo.prototype.constructor = Oo;
      function ar(b) {
        this.__wrapped__ = b, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = pe, this.__views__ = [];
      }
      function xn() {
        var b = new ar(this.__wrapped__);
        return b.__actions__ = Ci(this.__actions__), b.__dir__ = this.__dir__, b.__filtered__ = this.__filtered__, b.__iteratees__ = Ci(this.__iteratees__), b.__takeCount__ = this.__takeCount__, b.__views__ = Ci(this.__views__), b;
      }
      function tf() {
        if (this.__filtered__) {
          var b = new ar(this);
          b.__dir__ = -1, b.__filtered__ = !0;
        } else
          b = this.clone(), b.__dir__ *= -1;
        return b;
      }
      function _a() {
        var b = this.__wrapped__.value(), E = this.__dir__, k = or(b), z = E < 0, V = k ? b.length : 0, oe = ym(0, V, this.__views__), Ce = oe.start, Le = oe.end, Qe = Le - Ce, St = z ? Le : Ce - 1, Ot = this.__iteratees__, _t = Ot.length, Vt = 0, hn = Bi(Qe, this.__takeCount__);
        if (!k || !z && V == Qe && hn == Qe)
          return om(b, this.__actions__);
        var $n = [];
        e:
          for (; Qe-- && Vt < hn; ) {
            St += E;
            for (var lr = -1, jn = b[St]; ++lr < _t; ) {
              var yr = Ot[lr], Cr = yr.iteratee, cs = yr.type, Wa = Cr(jn);
              if (cs == fe)
                jn = Wa;
              else if (!Wa) {
                if (cs == ee)
                  continue e;
                break e;
              }
            }
            $n[Vt++] = jn;
          }
        return $n;
      }
      ar.prototype = ef(Mo.prototype), ar.prototype.constructor = ar;
      function Un(b) {
        var E = -1, k = b == null ? 0 : b.length;
        for (this.clear(); ++E < k; ) {
          var z = b[E];
          this.set(z[0], z[1]);
        }
      }
      function Wr() {
        this.__data__ = cd ? cd(null) : {}, this.size = 0;
      }
      function Vr(b) {
        var E = this.has(b) && delete this.__data__[b];
        return this.size -= E ? 1 : 0, E;
      }
      function Au(b) {
        var E = this.__data__;
        if (cd) {
          var k = E[b];
          return k === u ? n : k;
        }
        return Ur.call(E, b) ? E[b] : n;
      }
      function Wn(b) {
        var E = this.__data__;
        return cd ? E[b] !== n : Ur.call(E, b);
      }
      function Xa(b, E) {
        var k = this.__data__;
        return this.size += this.has(b) ? 0 : 1, k[b] = cd && E === n ? u : E, this;
      }
      Un.prototype.clear = Wr, Un.prototype.delete = Vr, Un.prototype.get = Au, Un.prototype.has = Wn, Un.prototype.set = Xa;
      function qa(b) {
        var E = -1, k = b == null ? 0 : b.length;
        for (this.clear(); ++E < k; ) {
          var z = b[E];
          this.set(z[0], z[1]);
        }
      }
      function fl() {
        this.__data__ = [], this.size = 0;
      }
      function ka(b) {
        var E = this.__data__, k = So(E, b);
        if (k < 0)
          return !1;
        var z = E.length - 1;
        return k == z ? E.pop() : yg.call(E, k, 1), --this.size, !0;
      }
      function dl(b) {
        var E = this.__data__, k = So(E, b);
        return k < 0 ? n : E[k][1];
      }
      function nf(b) {
        return So(this.__data__, b) > -1;
      }
      function em(b, E) {
        var k = this.__data__, z = So(k, b);
        return z < 0 ? (++this.size, k.push([b, E])) : k[z][1] = E, this;
      }
      qa.prototype.clear = fl, qa.prototype.delete = ka, qa.prototype.get = dl, qa.prototype.has = nf, qa.prototype.set = em;
      function pl(b) {
        var E = -1, k = b == null ? 0 : b.length;
        for (this.clear(); ++E < k; ) {
          var z = b[E];
          this.set(z[0], z[1]);
        }
      }
      function V0() {
        this.size = 0, this.__data__ = {
          hash: new Un(),
          map: new (jl || qa)(),
          string: new Un()
        };
      }
      function Rs(b) {
        var E = zg(this, b).delete(b);
        return this.size -= E ? 1 : 0, E;
      }
      function Ui(b) {
        return zg(this, b).get(b);
      }
      function tm(b) {
        return zg(this, b).has(b);
      }
      function Dv(b, E) {
        var k = zg(this, b), z = k.size;
        return k.set(b, E), this.size += k.size == z ? 0 : 1, this;
      }
      pl.prototype.clear = V0, pl.prototype.delete = Rs, pl.prototype.get = Ui, pl.prototype.has = tm, pl.prototype.set = Dv;
      function fc(b) {
        var E = -1, k = b == null ? 0 : b.length;
        for (this.__data__ = new pl(); ++E < k; )
          this.add(b[E]);
      }
      function is(b) {
        return this.__data__.set(b, u), this;
      }
      function rf(b) {
        return this.__data__.has(b);
      }
      fc.prototype.add = fc.prototype.push = is, fc.prototype.has = rf;
      function Ra(b) {
        var E = this.__data__ = new qa(b);
        this.size = E.size;
      }
      function fd() {
        this.__data__ = new qa(), this.size = 0;
      }
      function Sp(b) {
        var E = this.__data__, k = E.delete(b);
        return this.size = E.size, k;
      }
      function os(b) {
        return this.__data__.get(b);
      }
      function Eo(b) {
        return this.__data__.has(b);
      }
      function hl(b, E) {
        var k = this.__data__;
        if (k instanceof qa) {
          var z = k.__data__;
          if (!jl || z.length < a - 1)
            return z.push([b, E]), this.size = ++k.size, this;
          k = this.__data__ = new pl(z);
        }
        return k.set(b, E), this.size = k.size, this;
      }
      Ra.prototype.clear = fd, Ra.prototype.delete = Sp, Ra.prototype.get = os, Ra.prototype.has = Eo, Ra.prototype.set = hl;
      function zi(b, E) {
        var k = or(b), z = !k && Am(b), V = !k && !z && Af(b), oe = !k && !z && !V && Xp(b), Ce = k || z || V || oe, Le = Ce ? pg(b.length, bg) : [], Qe = Le.length;
        for (var St in b)
          (E || Ur.call(b, St)) && !(Ce && // Safari 9 has enumerable `arguments.length` in strict mode.
          (St == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          V && (St == "offset" || St == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          oe && (St == "buffer" || St == "byteLength" || St == "byteOffset") || // Skip index properties.
          Ls(St, Qe))) && Le.push(St);
        return Le;
      }
      function ku(b) {
        var E = b.length;
        return E ? b[ls(0, E - 1)] : n;
      }
      function Is(b, E) {
        return Fs(Ci(b), Ru(E, 0, b.length));
      }
      function Nv(b) {
        return Fs(Ci(b));
      }
      function wp(b, E, k) {
        (k !== n && !_c(b[E], k) || k === n && !(E in b)) && Vl(b, E, k);
      }
      function dd(b, E, k) {
        var z = b[E];
        (!(Ur.call(b, E) && _c(z, k)) || k === n && !(E in b)) && Vl(b, E, k);
      }
      function So(b, E) {
        for (var k = b.length; k--; )
          if (_c(b[k][0], E))
            return k;
        return -1;
      }
      function ss(b, E, k, z) {
        return Iu(b, function(V, oe, Ce) {
          E(z, V, k(V), Ce);
        }), z;
      }
      function ga(b, E) {
        return b && ao(E, Ao(E), b);
      }
      function ml(b, E) {
        return b && ao(E, El(E), b);
      }
      function Vl(b, E, k) {
        E == "__proto__" && Zh ? Zh(b, E, {
          configurable: !0,
          enumerable: !0,
          value: k,
          writable: !0
        }) : b[E] = k;
      }
      function _g(b, E) {
        for (var k = -1, z = E.length, V = et(z), oe = b == null; ++k < z; )
          V[k] = oe ? n : rS(b, E[k]);
        return V;
      }
      function Ru(b, E, k) {
        return b === b && (k !== n && (b = b <= k ? b : k), E !== n && (b = b >= E ? b : E)), b;
      }
      function Fo(b, E, k, z, V, oe) {
        var Ce, Le = E & m, Qe = E & v, St = E & O;
        if (k && (Ce = V ? k(b, z, V, oe) : k(b)), Ce !== n)
          return Ce;
        if (!ti(b))
          return b;
        var Ot = or(b);
        if (Ot) {
          if (Ce = Ai(b), !Le)
            return Ci(b, Ce);
        } else {
          var _t = La(b), Vt = _t == we || _t == lt;
          if (Af(b))
            return lm(b, Le);
          if (_t == Be || _t == j || Vt && !V) {
            if (Ce = Qe || Vt ? {} : Mp(b), !Le)
              return Qe ? M1(b, ml(Ce, b)) : us(b, ga(Ce, b));
          } else {
            if (!jr[_t])
              return V ? b : {};
            Ce = To(b, _t, Le);
          }
        }
        oe || (oe = new Ra());
        var hn = oe.get(b);
        if (hn)
          return hn;
        oe.set(b, Ce), J1(b) ? b.forEach(function(jn) {
          Ce.add(Fo(jn, E, k, jn, b, oe));
        }) : K1(b) && b.forEach(function(jn, yr) {
          Ce.set(yr, Fo(jn, E, k, yr, b, oe));
        });
        var $n = St ? Qe ? Sc : Pp : Qe ? El : Ao, lr = Ot ? n : $n(b);
        return yo(lr || b, function(jn, yr) {
          lr && (yr = jn, jn = b[yr]), dd(Ce, yr, Fo(jn, E, k, yr, b, oe));
        }), Ce;
      }
      function Y0(b) {
        var E = Ao(b);
        return function(k) {
          return nm(k, b, E);
        };
      }
      function nm(b, E, k) {
        var z = k.length;
        if (b == null)
          return !z;
        for (b = Gr(b); z--; ) {
          var V = k[z], oe = E[V], Ce = b[V];
          if (Ce === n && !(V in b) || !oe(Ce))
            return !1;
        }
        return !0;
      }
      function Pv(b, E, k) {
        if (typeof b != "function")
          throw new As(o);
        return Lu(function() {
          b.apply(n, k);
        }, E);
      }
      function fa(b, E, k, z) {
        var V = -1, oe = Hh, Ce = !0, Le = b.length, Qe = [], St = E.length;
        if (!Le)
          return Qe;
        k && (E = Hr(E, $r(k))), z ? (oe = Ov, Ce = !1) : E.length >= a && (oe = Wl, Ce = !1, E = new fc(E));
        e:
          for (; ++V < Le; ) {
            var Ot = b[V], _t = k == null ? Ot : k(Ot);
            if (Ot = z || Ot !== 0 ? Ot : 0, Ce && _t === _t) {
              for (var Vt = St; Vt--; )
                if (E[Vt] === _t)
                  continue e;
              Qe.push(Ot);
            } else
              oe(E, _t, z) || Qe.push(Ot);
          }
        return Qe;
      }
      var Iu = pm(da), rm = pm(Gt, !0);
      function Ds(b, E) {
        var k = !0;
        return Iu(b, function(z, V, oe) {
          return k = !!E(z, V, oe), k;
        }), k;
      }
      function Ns(b, E, k) {
        for (var z = -1, V = b.length; ++z < V; ) {
          var oe = b[z], Ce = E(oe);
          if (Ce != null && (Le === n ? Ce === Ce && !Sr(Ce) : k(Ce, Le)))
            var Le = Ce, Qe = oe;
        }
        return Qe;
      }
      function Cg(b, E, k, z) {
        var V = b.length;
        for (k = rr(k), k < 0 && (k = -k > V ? 0 : V + k), z = z === n || z > V ? V : rr(z), z < 0 && (z += V), z = k > z ? 0 : Rm(z); k < z; )
          b[k++] = E;
        return b;
      }
      function dc(b, E) {
        var k = [];
        return Iu(b, function(z, V, oe) {
          E(z, V, oe) && k.push(z);
        }), k;
      }
      function Ti(b, E, k, z, V) {
        var oe = -1, Ce = b.length;
        for (k || (k = Wv), V || (V = []); ++oe < Ce; ) {
          var Le = b[oe];
          E > 0 && k(Le) ? E > 1 ? Ti(Le, E - 1, k, z, V) : Su(V, Le) : z || (V[V.length] = Le);
        }
        return V;
      }
      var am = bd(), pc = bd(!0);
      function da(b, E) {
        return b && am(b, E, Ao);
      }
      function Gt(b, E) {
        return b && pc(b, E, Ao);
      }
      function Ia(b, E) {
        return oc(E, function(k) {
          return kf(b[k]);
        });
      }
      function za(b, E) {
        E = Xl(E, b);
        for (var k = 0, z = E.length; b != null && k < z; )
          b = b[Bo(E[k++])];
        return k && k == z ? b : n;
      }
      function xg(b, E, k) {
        var z = E(b);
        return or(b) ? z : Su(z, k(b));
      }
      function wo(b) {
        return b == null ? b === n ? Ut : Re : sd && sd in Gr(b) ? Hv(b) : Wg(b);
      }
      function Yl(b, E) {
        return b > E;
      }
      function af(b, E) {
        return b != null && Ur.call(b, E);
      }
      function Lv(b, E) {
        return b != null && E in Gr(b);
      }
      function _i(b, E, k) {
        return b >= Bi(E, k) && b < li(E, k);
      }
      function Zl(b, E, k) {
        for (var z = k ? Ov : Hh, V = b[0].length, oe = b.length, Ce = oe, Le = et(oe), Qe = 1 / 0, St = []; Ce--; ) {
          var Ot = b[Ce];
          Ce && E && (Ot = Hr(Ot, $r(E))), Qe = Bi(Ot.length, Qe), Le[Ce] = !k && (E || V >= 120 && Ot.length >= 120) ? new fc(Ce && Ot) : n;
        }
        Ot = b[0];
        var _t = -1, Vt = Le[0];
        e:
          for (; ++_t < V && St.length < Qe; ) {
            var hn = Ot[_t], $n = E ? E(hn) : hn;
            if (hn = k || hn !== 0 ? hn : 0, !(Vt ? Wl(Vt, $n) : z(St, $n, k))) {
              for (Ce = oe; --Ce; ) {
                var lr = Le[Ce];
                if (!(lr ? Wl(lr, $n) : z(b[Ce], $n, k)))
                  continue e;
              }
              Vt && Vt.push($n), St.push(hn);
            }
          }
        return St;
      }
      function of(b, E, k, z) {
        return da(b, function(V, oe, Ce) {
          E(z, k(V), oe, Ce);
        }), z;
      }
      function sf(b, E, k) {
        E = Xl(E, b), b = Kl(b, E);
        var z = b == null ? b : b[Bo(Ri(E))];
        return z == null ? n : vo(z, b, k);
      }
      function Ag(b) {
        return di(b) && wo(b) == j;
      }
      function lf(b) {
        return di(b) && wo(b) == Ie;
      }
      function pd(b) {
        return di(b) && wo(b) == Ae;
      }
      function Tp(b, E, k, z, V) {
        return b === E ? !0 : b == null || E == null || !di(b) && !di(E) ? b !== b && E !== E : Mv(b, E, k, z, Tp, V);
      }
      function Mv(b, E, k, z, V, oe) {
        var Ce = or(b), Le = or(E), Qe = Ce ? K : La(b), St = Le ? K : La(E);
        Qe = Qe == j ? Be : Qe, St = St == j ? Be : St;
        var Ot = Qe == Be, _t = St == Be, Vt = Qe == St;
        if (Vt && Af(b)) {
          if (!Af(E))
            return !1;
          Ce = !0, Ot = !1;
        }
        if (Vt && !Ot)
          return oe || (oe = new Ra()), Ce || Xp(b) ? yd(b, E, k, z, V, oe) : zv(b, E, Qe, k, z, V, oe);
        if (!(k & w)) {
          var hn = Ot && Ur.call(b, "__wrapped__"), $n = _t && Ur.call(E, "__wrapped__");
          if (hn || $n) {
            var lr = hn ? b.value() : b, jn = $n ? E.value() : E;
            return oe || (oe = new Ra()), V(lr, jn, k, z, oe);
          }
        }
        return Vt ? (oe || (oe = new Ra()), J0(b, E, k, z, V, oe)) : !1;
      }
      function kg(b) {
        return di(b) && La(b) == st;
      }
      function Rg(b, E, k, z) {
        var V = k.length, oe = V, Ce = !z;
        if (b == null)
          return !oe;
        for (b = Gr(b); V--; ) {
          var Le = k[V];
          if (Ce && Le[2] ? Le[1] !== b[Le[0]] : !(Le[0] in b))
            return !1;
        }
        for (; ++V < oe; ) {
          Le = k[V];
          var Qe = Le[0], St = b[Qe], Ot = Le[1];
          if (Ce && Le[2]) {
            if (St === n && !(Qe in b))
              return !1;
          } else {
            var _t = new Ra();
            if (z)
              var Vt = z(St, Ot, Qe, b, E, _t);
            if (!(Vt === n ? Tp(Ot, St, w | _, z, _t) : Vt))
              return !1;
          }
        }
        return !0;
      }
      function Fv(b) {
        if (!ti(b) || Om(b))
          return !1;
        var E = kf(b) ? G0 : Ba;
        return E.test(Ef(b));
      }
      function Z0(b) {
        return di(b) && wo(b) == ut;
      }
      function Ig(b) {
        return di(b) && La(b) == wt;
      }
      function _p(b) {
        return di(b) && cy(b.length) && !!Jr[wo(b)];
      }
      function im(b) {
        return typeof b == "function" ? b : b == null ? Sl : typeof b == "object" ? or(b) ? gl(b[0], b[1]) : Cp(b) : yy(b);
      }
      function Dg(b) {
        if (!Fp(b))
          return ld(b);
        var E = [];
        for (var k in Gr(b))
          Ur.call(b, k) && k != "constructor" && E.push(k);
        return E;
      }
      function X0(b) {
        if (!ti(b))
          return tO(b);
        var E = Fp(b), k = [];
        for (var z in b)
          z == "constructor" && (E || !Ur.call(b, z)) || k.push(z);
        return k;
      }
      function uf(b, E) {
        return b < E;
      }
      function $v(b, E) {
        var k = -1, z = io(b) ? et(b.length) : [];
        return Iu(b, function(V, oe, Ce) {
          z[++k] = E(V, oe, Ce);
        }), z;
      }
      function Cp(b) {
        var E = vm(b);
        return E.length == 1 && E[0][2] ? Bp(E[0][0], E[0][1]) : function(k) {
          return k === b || Rg(k, b, E);
        };
      }
      function gl(b, E) {
        return Hg(b) && $p(E) ? Bp(Bo(b), E) : function(k) {
          var z = rS(k, b);
          return z === n && z === E ? cb(k, b) : Tp(E, z, w | _);
        };
      }
      function cf(b, E, k, z, V) {
        b !== E && am(E, function(oe, Ce) {
          if (V || (V = new Ra()), ti(oe))
            xp(b, E, Ce, k, cf, z, V);
          else {
            var Le = z ? z(bi(b, Ce), oe, Ce + "", b, E, V) : n;
            Le === n && (Le = oe), wp(b, Ce, Le);
          }
        }, El);
      }
      function xp(b, E, k, z, V, oe, Ce) {
        var Le = bi(b, k), Qe = bi(E, k), St = Ce.get(Qe);
        if (St) {
          wp(b, k, St);
          return;
        }
        var Ot = oe ? oe(Le, Qe, k + "", b, E, Ce) : n, _t = Ot === n;
        if (_t) {
          var Vt = or(Qe), hn = !Vt && Af(Qe), $n = !Vt && !hn && Xp(Qe);
          Ot = Qe, Vt || hn || $n ? or(Le) ? Ot = Le : fi(Le) ? Ot = Ci(Le) : hn ? (_t = !1, Ot = lm(Qe, !0)) : $n ? (_t = !1, Ot = cm(Qe, !0)) : Ot = [] : km(Qe) || Am(Qe) ? (Ot = Le, Am(Le) ? Ot = tS(Le) : (!ti(Le) || kf(Le)) && (Ot = Mp(Qe))) : _t = !1;
        }
        _t && (Ce.set(Qe, Ot), V(Ot, Qe, z, oe, Ce), Ce.delete(Qe)), wp(b, k, Ot);
      }
      function ff(b, E) {
        var k = b.length;
        if (k)
          return E += E < 0 ? k : 0, Ls(E, k) ? b[E] : n;
      }
      function Ng(b, E, k) {
        E.length ? E = Hr(E, function(oe) {
          return or(oe) ? function(Ce) {
            return za(Ce, oe.length === 1 ? oe[0] : oe);
          } : oe;
        }) : E = [Sl];
        var z = -1;
        E = Hr(E, $r(Cn()));
        var V = $v(b, function(oe, Ce, Le) {
          var Qe = Hr(E, function(St) {
            return St(oe);
          });
          return { criteria: Qe, index: ++z, value: oe };
        });
        return I1(V, function(oe, Ce) {
          return Bv(oe, Ce, k);
        });
      }
      function df(b, E) {
        return In(b, E, function(k, z) {
          return cb(b, z);
        });
      }
      function In(b, E, k) {
        for (var z = -1, V = E.length, oe = {}; ++z < V; ) {
          var Ce = E[z], Le = za(b, Ce);
          k(Le, Ce) && ct(oe, Xl(Ce, b), Le);
        }
        return oe;
      }
      function cr(b) {
        return function(E) {
          return za(E, b);
        };
      }
      function Dn(b, E, k, z) {
        var V = z ? _v : id, oe = -1, Ce = E.length, Le = b;
        for (b === E && (E = Ci(E)), k && (Le = Hr(b, $r(k))); ++oe < Ce; )
          for (var Qe = 0, St = E[oe], Ot = k ? k(St) : St; (Qe = V(Le, Ot, Qe, z)) > -1; )
            Le !== b && yg.call(Le, Qe, 1), yg.call(b, Qe, 1);
        return b;
      }
      function Da(b, E) {
        for (var k = b ? E.length : 0, z = k - 1; k--; ) {
          var V = E[k];
          if (k == z || V !== oe) {
            var oe = V;
            Ls(V) ? yg.call(b, V, 1) : gc(b, V);
          }
        }
        return b;
      }
      function ls(b, E) {
        return b + cc(qh() * (E - b + 1));
      }
      function Pg(b, E, k, z) {
        for (var V = -1, oe = li(ul((E - b) / (k || 1)), 0), Ce = et(oe); oe--; )
          Ce[z ? oe : ++V] = b, b += k;
        return Ce;
      }
      function Ap(b, E) {
        var k = "";
        if (!b || E < 1 || E > le)
          return k;
        do
          E % 2 && (k += b), E = cc(E / 2), E && (b += b);
        while (E);
        return k;
      }
      function ir(b, E) {
        return Jl(Ed(b, E, Sl), b + "");
      }
      function hd(b) {
        return ku(fb(b));
      }
      function Ca(b, E) {
        var k = fb(b);
        return Fs(k, Ru(E, 0, k.length));
      }
      function ct(b, E, k, z) {
        if (!ti(b))
          return b;
        E = Xl(E, b);
        for (var V = -1, oe = E.length, Ce = oe - 1, Le = b; Le != null && ++V < oe; ) {
          var Qe = Bo(E[V]), St = k;
          if (Qe === "__proto__" || Qe === "constructor" || Qe === "prototype")
            return b;
          if (V != Ce) {
            var Ot = Le[Qe];
            St = z ? z(Ot, Qe, Le) : n, St === n && (St = ti(Ot) ? Ot : Ls(E[V + 1]) ? [] : {});
          }
          dd(Le, Qe, St), Le = Le[Qe];
        }
        return b;
      }
      var vr = Op ? function(b, E) {
        return Op.set(b, E), b;
      } : Sl, Fn = Zh ? function(b, E) {
        return Zh(b, "toString", {
          configurable: !0,
          enumerable: !1,
          value: hS(E),
          writable: !0
        });
      } : Sl;
      function Du(b) {
        return Fs(fb(b));
      }
      function Na(b, E, k) {
        var z = -1, V = b.length;
        E < 0 && (E = -E > V ? 0 : V + E), k = k > V ? V : k, k < 0 && (k += V), V = E > k ? 0 : k - E >>> 0, E >>>= 0;
        for (var oe = et(V); ++z < V; )
          oe[z] = b[z + E];
        return oe;
      }
      function md(b, E) {
        var k;
        return Iu(b, function(z, V, oe) {
          return k = E(z, V, oe), !k;
        }), !!k;
      }
      function aa(b, E, k) {
        var z = 0, V = b == null ? z : b.length;
        if (typeof E == "number" && E === E && V <= Z) {
          for (; z < V; ) {
            var oe = z + V >>> 1, Ce = b[oe];
            Ce !== null && !Sr(Ce) && (k ? Ce <= E : Ce < E) ? z = oe + 1 : V = oe;
          }
          return V;
        }
        return hc(b, E, Sl, k);
      }
      function hc(b, E, k, z) {
        var V = 0, oe = b == null ? 0 : b.length;
        if (oe === 0)
          return 0;
        E = k(E);
        for (var Ce = E !== E, Le = E === null, Qe = Sr(E), St = E === n; V < oe; ) {
          var Ot = cc((V + oe) / 2), _t = k(b[Ot]), Vt = _t !== n, hn = _t === null, $n = _t === _t, lr = Sr(_t);
          if (Ce)
            var jn = z || $n;
          else
            St ? jn = $n && (z || Vt) : Le ? jn = $n && Vt && (z || !hn) : Qe ? jn = $n && Vt && !hn && (z || !lr) : hn || lr ? jn = !1 : jn = z ? _t <= E : _t < E;
          jn ? V = Ot + 1 : oe = Ot;
        }
        return Bi(oe, _e);
      }
      function mc(b, E) {
        for (var k = -1, z = b.length, V = 0, oe = []; ++k < z; ) {
          var Ce = b[k], Le = E ? E(Ce) : Ce;
          if (!k || !_c(Le, Qe)) {
            var Qe = Le;
            oe[V++] = Ce === 0 ? 0 : Ce;
          }
        }
        return oe;
      }
      function pf(b) {
        return typeof b == "number" ? b : Sr(b) ? B : +b;
      }
      function Pa(b) {
        if (typeof b == "string")
          return b;
        if (or(b))
          return Hr(b, Pa) + "";
        if (Sr(b))
          return Tg ? Tg.call(b) : "";
        var E = b + "";
        return E == "0" && 1 / b == -ie ? "-0" : E;
      }
      function ui(b, E, k) {
        var z = -1, V = Hh, oe = b.length, Ce = !0, Le = [], Qe = Le;
        if (k)
          Ce = !1, V = Ov;
        else if (oe >= a) {
          var St = E ? null : xi(b);
          if (St)
            return sc(St);
          Ce = !1, V = Wl, Qe = new fc();
        } else
          Qe = E ? [] : Le;
        e:
          for (; ++z < oe; ) {
            var Ot = b[z], _t = E ? E(Ot) : Ot;
            if (Ot = k || Ot !== 0 ? Ot : 0, Ce && _t === _t) {
              for (var Vt = Qe.length; Vt--; )
                if (Qe[Vt] === _t)
                  continue e;
              E && Qe.push(_t), Le.push(Ot);
            } else
              V(Qe, _t, k) || (Qe !== Le && Qe.push(_t), Le.push(Ot));
          }
        return Le;
      }
      function gc(b, E) {
        return E = Xl(E, b), b = Kl(b, E), b == null || delete b[Bo(Ri(E))];
      }
      function kp(b, E, k, z) {
        return ct(b, E, k(za(b, E)), z);
      }
      function hf(b, E, k, z) {
        for (var V = b.length, oe = z ? V : -1; (z ? oe-- : ++oe < V) && E(b[oe], oe, b); )
          ;
        return k ? Na(b, z ? 0 : oe, z ? oe + 1 : V) : Na(b, z ? oe + 1 : 0, z ? V : oe);
      }
      function om(b, E) {
        var k = b;
        return k instanceof ar && (k = k.value()), fg(E, function(z, V) {
          return V.func.apply(V.thisArg, Su([z], V.args));
        }, k);
      }
      function Rp(b, E, k) {
        var z = b.length;
        if (z < 2)
          return z ? ui(b[0]) : [];
        for (var V = -1, oe = et(z); ++V < z; )
          for (var Ce = b[V], Le = -1; ++Le < z; )
            Le != V && (oe[V] = fa(oe[V] || Ce, b[Le], E, k));
        return ui(Ti(oe, 1), E, k);
      }
      function sm(b, E, k) {
        for (var z = -1, V = b.length, oe = E.length, Ce = {}; ++z < V; ) {
          var Le = z < oe ? E[z] : n;
          k(Ce, b[z], Le);
        }
        return Ce;
      }
      function Ip(b) {
        return fi(b) ? b : [];
      }
      function Dp(b) {
        return typeof b == "function" ? b : Sl;
      }
      function Xl(b, E) {
        return or(b) ? b : Hg(b, E) ? [b] : Vv(ia(b));
      }
      var Lg = ir;
      function ql(b, E, k) {
        var z = b.length;
        return k = k === n ? z : k, !E && k >= z ? b : Na(b, E, k);
      }
      var mf = Og || function(b) {
        return Ta.clearTimeout(b);
      };
      function lm(b, E) {
        if (E)
          return b.slice();
        var k = b.length, z = Rv ? Rv(k) : new b.constructor(k);
        return b.copy(z), z;
      }
      function bc(b) {
        var E = new b.constructor(b.byteLength);
        return new Yh(E).set(new Yh(b)), E;
      }
      function vc(b, E) {
        var k = E ? bc(b.buffer) : b.buffer;
        return new b.constructor(k, b.byteOffset, b.byteLength);
      }
      function Mg(b) {
        var E = new b.constructor(b.source, ur.exec(b));
        return E.lastIndex = b.lastIndex, E;
      }
      function um(b) {
        return ks ? Gr(ks.call(b)) : {};
      }
      function cm(b, E) {
        var k = E ? bc(b.buffer) : b.buffer;
        return new b.constructor(k, b.byteOffset, b.length);
      }
      function fm(b, E) {
        if (b !== E) {
          var k = b !== n, z = b === null, V = b === b, oe = Sr(b), Ce = E !== n, Le = E === null, Qe = E === E, St = Sr(E);
          if (!Le && !St && !oe && b > E || oe && Ce && Qe && !Le && !St || z && Ce && Qe || !k && Qe || !V)
            return 1;
          if (!z && !oe && !St && b < E || St && k && V && !z && !oe || Le && k && V || !Ce && V || !Qe)
            return -1;
        }
        return 0;
      }
      function Bv(b, E, k) {
        for (var z = -1, V = b.criteria, oe = E.criteria, Ce = V.length, Le = k.length; ++z < Ce; ) {
          var Qe = fm(V[z], oe[z]);
          if (Qe) {
            if (z >= Le)
              return Qe;
            var St = k[z];
            return Qe * (St == "desc" ? -1 : 1);
          }
        }
        return b.index - E.index;
      }
      function gd(b, E, k, z) {
        for (var V = -1, oe = b.length, Ce = k.length, Le = -1, Qe = E.length, St = li(oe - Ce, 0), Ot = et(Qe + St), _t = !z; ++Le < Qe; )
          Ot[Le] = E[Le];
        for (; ++V < Ce; )
          (_t || V < oe) && (Ot[k[V]] = b[V]);
        for (; St--; )
          Ot[Le++] = b[V++];
        return Ot;
      }
      function dm(b, E, k, z) {
        for (var V = -1, oe = b.length, Ce = -1, Le = k.length, Qe = -1, St = E.length, Ot = li(oe - Le, 0), _t = et(Ot + St), Vt = !z; ++V < Ot; )
          _t[V] = b[V];
        for (var hn = V; ++Qe < St; )
          _t[hn + Qe] = E[Qe];
        for (; ++Ce < Le; )
          (Vt || V < oe) && (_t[hn + k[Ce]] = b[V++]);
        return _t;
      }
      function Ci(b, E) {
        var k = -1, z = b.length;
        for (E || (E = et(z)); ++k < z; )
          E[k] = b[k];
        return E;
      }
      function ao(b, E, k, z) {
        var V = !k;
        k || (k = {});
        for (var oe = -1, Ce = E.length; ++oe < Ce; ) {
          var Le = E[oe], Qe = z ? z(k[Le], b[Le], Le, k, b) : n;
          Qe === n && (Qe = b[Le]), V ? Vl(k, Le, Qe) : dd(k, Le, Qe);
        }
        return k;
      }
      function us(b, E) {
        return ao(b, Hi(b), E);
      }
      function M1(b, E) {
        return ao(b, Wi(b), E);
      }
      function Yr(b, E) {
        return function(k, z) {
          var V = or(k) ? yv : ss, oe = E ? E() : {};
          return V(k, b, Cn(z, 2), oe);
        };
      }
      function yc(b) {
        return ir(function(E, k) {
          var z = -1, V = k.length, oe = V > 1 ? k[V - 1] : n, Ce = V > 2 ? k[2] : n;
          for (oe = b.length > 3 && typeof oe == "function" ? (V--, oe) : n, Ce && kr(k[0], k[1], Ce) && (oe = V < 3 ? n : oe, V = 1), E = Gr(E); ++z < V; ) {
            var Le = k[z];
            Le && b(E, Le, z, oe);
          }
          return E;
        });
      }
      function pm(b, E) {
        return function(k, z) {
          if (k == null)
            return k;
          if (!io(k))
            return b(k, z);
          for (var V = k.length, oe = E ? V : -1, Ce = Gr(k); (E ? oe-- : ++oe < V) && z(Ce[oe], oe, Ce) !== !1; )
            ;
          return k;
        };
      }
      function bd(b) {
        return function(E, k, z) {
          for (var V = -1, oe = Gr(E), Ce = z(E), Le = Ce.length; Le--; ) {
            var Qe = Ce[b ? Le : ++V];
            if (k(oe[Qe], Qe, oe) === !1)
              break;
          }
          return E;
        };
      }
      function hm(b, E, k) {
        var z = E & C, V = mm(b);
        function oe() {
          var Ce = this && this !== Ta && this instanceof oe ? V : b;
          return Ce.apply(z ? k : this, arguments);
        }
        return oe;
      }
      function Uv(b) {
        return function(E) {
          E = ia(E);
          var k = cp(E) ? xs(E) : n, z = k ? k[0] : E.charAt(0), V = k ? ql(k, 1).join("") : E.slice(1);
          return z[b]() + V;
        };
      }
      function Oc(b) {
        return function(E) {
          return fg(pS(gy(E).replace(A1, "")), b, "");
        };
      }
      function mm(b) {
        return function() {
          var E = arguments;
          switch (E.length) {
            case 0:
              return new b();
            case 1:
              return new b(E[0]);
            case 2:
              return new b(E[0], E[1]);
            case 3:
              return new b(E[0], E[1], E[2]);
            case 4:
              return new b(E[0], E[1], E[2], E[3]);
            case 5:
              return new b(E[0], E[1], E[2], E[3], E[4]);
            case 6:
              return new b(E[0], E[1], E[2], E[3], E[4], E[5]);
            case 7:
              return new b(E[0], E[1], E[2], E[3], E[4], E[5], E[6]);
          }
          var k = ef(b.prototype), z = b.apply(k, E);
          return ti(z) ? z : k;
        };
      }
      function F1(b, E, k) {
        var z = mm(b);
        function V() {
          for (var oe = arguments.length, Ce = et(oe), Le = oe, Qe = yf(V); Le--; )
            Ce[Le] = arguments[Le];
          var St = oe < 3 && Ce[0] !== Qe && Ce[oe - 1] !== Qe ? [] : sl(Ce, Qe);
          if (oe -= St.length, oe < k)
            return K0(
              b,
              E,
              gf,
              V.placeholder,
              n,
              Ce,
              St,
              n,
              n,
              k - oe
            );
          var Ot = this && this !== Ta && this instanceof V ? z : b;
          return vo(Ot, this, Ce);
        }
        return V;
      }
      function Fg(b) {
        return function(E, k, z) {
          var V = Gr(E);
          if (!io(E)) {
            var oe = Cn(k, 3);
            E = Ao(E), k = function(Le) {
              return oe(V[Le], Le, V);
            };
          }
          var Ce = b(E, k, z);
          return Ce > -1 ? V[oe ? E[Ce] : Ce] : n;
        };
      }
      function vd(b) {
        return Nu(function(E) {
          var k = E.length, z = k, V = Oo.prototype.thru;
          for (b && E.reverse(); z--; ) {
            var oe = E[z];
            if (typeof oe != "function")
              throw new As(o);
            if (V && !Ce && Lp(oe) == "wrapper")
              var Ce = new Oo([], !0);
          }
          for (z = Ce ? z : k; ++z < k; ) {
            oe = E[z];
            var Le = Lp(oe), Qe = Le == "wrapper" ? bm(oe) : n;
            Qe && Of(Qe[0]) && Qe[1] == (H | P | D | Y) && !Qe[4].length && Qe[9] == 1 ? Ce = Ce[Lp(Qe[0])].apply(Ce, Qe[3]) : Ce = oe.length == 1 && Of(oe) ? Ce[Le]() : Ce.thru(oe);
          }
          return function() {
            var St = arguments, Ot = St[0];
            if (Ce && St.length == 1 && or(Ot))
              return Ce.plant(Ot).value();
            for (var _t = 0, Vt = k ? E[_t].apply(this, St) : Ot; ++_t < k; )
              Vt = E[_t].call(this, Vt);
            return Vt;
          };
        });
      }
      function gf(b, E, k, z, V, oe, Ce, Le, Qe, St) {
        var Ot = E & H, _t = E & C, Vt = E & A, hn = E & (P | I), $n = E & q, lr = Vt ? n : mm(b);
        function jn() {
          for (var yr = arguments.length, Cr = et(yr), cs = yr; cs--; )
            Cr[cs] = arguments[cs];
          if (hn)
            var Wa = yf(jn), Us = lp(Cr, Wa);
          if (z && (Cr = gd(Cr, z, V, hn)), oe && (Cr = dm(Cr, oe, Ce, hn)), yr -= Us, hn && yr < St) {
            var ni = sl(Cr, Wa);
            return K0(
              b,
              E,
              gf,
              jn.placeholder,
              k,
              Cr,
              ni,
              Le,
              Qe,
              St - yr
            );
          }
          var oo = _t ? k : this, fs = Vt ? oo[b] : b;
          return yr = Cr.length, Le ? Cr = Ma(Cr, Le) : $n && yr > 1 && Cr.reverse(), Ot && Qe < yr && (Cr.length = Qe), this && this !== Ta && this instanceof jn && (fs = lr || mm(fs)), fs.apply(oo, Cr);
        }
        return jn;
      }
      function gm(b, E) {
        return function(k, z) {
          return of(k, b, E(z), {});
        };
      }
      function $g(b, E) {
        return function(k, z) {
          var V;
          if (k === n && z === n)
            return E;
          if (k !== n && (V = k), z !== n) {
            if (V === n)
              return z;
            typeof k == "string" || typeof z == "string" ? (k = Pa(k), z = Pa(z)) : (k = pf(k), z = pf(z)), V = b(k, z);
          }
          return V;
        };
      }
      function Bg(b) {
        return Nu(function(E) {
          return E = Hr(E, $r(Cn())), ir(function(k) {
            var z = this;
            return b(E, function(V) {
              return vo(V, z, k);
            });
          });
        });
      }
      function bf(b, E) {
        E = E === n ? " " : Pa(E);
        var k = E.length;
        if (k < 2)
          return k ? Ap(E, b) : E;
        var z = Ap(E, ul(b / Zc(E)));
        return cp(E) ? ql(xs(z), 0, b).join("") : z.slice(0, b);
      }
      function q0(b, E, k, z) {
        var V = E & C, oe = mm(b);
        function Ce() {
          for (var Le = -1, Qe = arguments.length, St = -1, Ot = z.length, _t = et(Ot + Qe), Vt = this && this !== Ta && this instanceof Ce ? oe : b; ++St < Ot; )
            _t[St] = z[St];
          for (; Qe--; )
            _t[St++] = arguments[++Le];
          return vo(Vt, V ? k : this, _t);
        }
        return Ce;
      }
      function Ug(b) {
        return function(E, k, z) {
          return z && typeof z != "number" && kr(E, k, z) && (k = z = n), E = kd(E), k === n ? (k = E, E = 0) : k = kd(k), z = z === n ? E < k ? 1 : -1 : kd(z), Pg(E, k, z, b);
        };
      }
      function Np(b) {
        return function(E, k) {
          return typeof E == "string" && typeof k == "string" || (E = $u(E), k = $u(k)), b(E, k);
        };
      }
      function K0(b, E, k, z, V, oe, Ce, Le, Qe, St) {
        var Ot = E & P, _t = Ot ? Ce : n, Vt = Ot ? n : Ce, hn = Ot ? oe : n, $n = Ot ? n : oe;
        E |= Ot ? D : M, E &= ~(Ot ? M : D), E & N || (E &= ~(C | A));
        var lr = [
          b,
          E,
          V,
          hn,
          _t,
          $n,
          Vt,
          Le,
          Qe,
          St
        ], jn = k.apply(n, lr);
        return Of(b) && Ms(jn, lr), jn.placeholder = z, vl(jn, b, E);
      }
      function Ka(b) {
        var E = gi[b];
        return function(k, z) {
          if (k = $u(k), z = z == null ? 0 : Bi(rr(z), 292), z && vp(k)) {
            var V = (ia(k) + "e").split("e"), oe = E(V[0] + "e" + (+V[1] + z));
            return V = (ia(oe) + "e").split("e"), +(V[0] + "e" + (+V[1] - z));
          }
          return E(k);
        };
      }
      var xi = cl && 1 / sc(new cl([, -0]))[1] == ie ? function(b) {
        return new cl(b);
      } : vS;
      function Ec(b) {
        return function(E) {
          var k = La(E);
          return k == st ? mg(E) : k == wt ? fp(E) : rs(E, b(E));
        };
      }
      function bl(b, E, k, z, V, oe, Ce, Le) {
        var Qe = E & A;
        if (!Qe && typeof b != "function")
          throw new As(o);
        var St = z ? z.length : 0;
        if (St || (E &= ~(D | M), z = V = n), Ce = Ce === n ? Ce : li(rr(Ce), 0), Le = Le === n ? Le : rr(Le), St -= V ? V.length : 0, E & M) {
          var Ot = z, _t = V;
          z = V = n;
        }
        var Vt = Qe ? n : bm(b), hn = [
          b,
          E,
          k,
          z,
          V,
          Ot,
          _t,
          oe,
          Ce,
          Le
        ];
        if (Vt && jv(hn, Vt), b = hn[0], E = hn[1], k = hn[2], z = hn[3], V = hn[4], Le = hn[9] = hn[9] === n ? Qe ? 0 : b.length : li(hn[9] - St, 0), !Le && E & (P | I) && (E &= ~(P | I)), !E || E == C)
          var $n = hm(b, E, k);
        else
          E == P || E == I ? $n = F1(b, E, Le) : (E == D || E == (C | D)) && !V.length ? $n = q0(b, E, k, z) : $n = gf.apply(n, hn);
        var lr = Vt ? vr : Ms;
        return vl(lr($n, hn), b, E);
      }
      function $o(b, E, k, z) {
        return b === n || _c(b, _u[k]) && !Ur.call(z, k) ? E : b;
      }
      function vf(b, E, k, z, V, oe) {
        return ti(b) && ti(E) && (oe.set(E, b), cf(b, E, n, vf, oe), oe.delete(E)), b;
      }
      function er(b) {
        return km(b) ? n : b;
      }
      function yd(b, E, k, z, V, oe) {
        var Ce = k & w, Le = b.length, Qe = E.length;
        if (Le != Qe && !(Ce && Qe > Le))
          return !1;
        var St = oe.get(b), Ot = oe.get(E);
        if (St && Ot)
          return St == E && Ot == b;
        var _t = -1, Vt = !0, hn = k & _ ? new fc() : n;
        for (oe.set(b, E), oe.set(E, b); ++_t < Le; ) {
          var $n = b[_t], lr = E[_t];
          if (z)
            var jn = Ce ? z(lr, $n, _t, E, b, oe) : z($n, lr, _t, b, E, oe);
          if (jn !== n) {
            if (jn)
              continue;
            Vt = !1;
            break;
          }
          if (hn) {
            if (!Ev(E, function(yr, Cr) {
              if (!Wl(hn, Cr) && ($n === yr || V($n, yr, k, z, oe)))
                return hn.push(Cr);
            })) {
              Vt = !1;
              break;
            }
          } else if (!($n === lr || V($n, lr, k, z, oe))) {
            Vt = !1;
            break;
          }
        }
        return oe.delete(b), oe.delete(E), Vt;
      }
      function zv(b, E, k, z, V, oe, Ce) {
        switch (k) {
          case it:
            if (b.byteLength != E.byteLength || b.byteOffset != E.byteOffset)
              return !1;
            b = b.buffer, E = E.buffer;
          case Ie:
            return !(b.byteLength != E.byteLength || !oe(new Yh(b), new Yh(E)));
          case he:
          case Ae:
          case Oe:
            return _c(+b, +E);
          case je:
            return b.name == E.name && b.message == E.message;
          case ut:
          case Yt:
            return b == E + "";
          case st:
            var Le = mg;
          case wt:
            var Qe = z & w;
            if (Le || (Le = sc), b.size != E.size && !Qe)
              return !1;
            var St = Ce.get(b);
            if (St)
              return St == E;
            z |= _, Ce.set(b, E);
            var Ot = yd(Le(b), Le(E), z, V, oe, Ce);
            return Ce.delete(b), Ot;
          case Rt:
            if (ks)
              return ks.call(b) == ks.call(E);
        }
        return !1;
      }
      function J0(b, E, k, z, V, oe) {
        var Ce = k & w, Le = Pp(b), Qe = Le.length, St = Pp(E), Ot = St.length;
        if (Qe != Ot && !Ce)
          return !1;
        for (var _t = Qe; _t--; ) {
          var Vt = Le[_t];
          if (!(Ce ? Vt in E : Ur.call(E, Vt)))
            return !1;
        }
        var hn = oe.get(b), $n = oe.get(E);
        if (hn && $n)
          return hn == E && $n == b;
        var lr = !0;
        oe.set(b, E), oe.set(E, b);
        for (var jn = Ce; ++_t < Qe; ) {
          Vt = Le[_t];
          var yr = b[Vt], Cr = E[Vt];
          if (z)
            var cs = Ce ? z(Cr, yr, Vt, E, b, oe) : z(yr, Cr, Vt, b, E, oe);
          if (!(cs === n ? yr === Cr || V(yr, Cr, k, z, oe) : cs)) {
            lr = !1;
            break;
          }
          jn || (jn = Vt == "constructor");
        }
        if (lr && !jn) {
          var Wa = b.constructor, Us = E.constructor;
          Wa != Us && "constructor" in b && "constructor" in E && !(typeof Wa == "function" && Wa instanceof Wa && typeof Us == "function" && Us instanceof Us) && (lr = !1);
        }
        return oe.delete(b), oe.delete(E), lr;
      }
      function Nu(b) {
        return Jl(Ed(b, n, Sm), b + "");
      }
      function Pp(b) {
        return xg(b, Ao, Hi);
      }
      function Sc(b) {
        return xg(b, El, Wi);
      }
      var bm = Op ? function(b) {
        return Op.get(b);
      } : vS;
      function Lp(b) {
        for (var E = b.name + "", k = Ep[E], z = Ur.call(Ep, E) ? k.length : 0; z--; ) {
          var V = k[z], oe = V.func;
          if (oe == null || oe == b)
            return V.name;
        }
        return E;
      }
      function yf(b) {
        var E = Ur.call(re, "placeholder") ? re : b;
        return E.placeholder;
      }
      function Cn() {
        var b = re.iteratee || gS;
        return b = b === gS ? im : b, arguments.length ? b(arguments[0], arguments[1]) : b;
      }
      function zg(b, E) {
        var k = b.__data__;
        return un(E) ? k[typeof E == "string" ? "string" : "hash"] : k.map;
      }
      function vm(b) {
        for (var E = Ao(b), k = E.length; k--; ) {
          var z = E[k], V = b[z];
          E[k] = [z, V, $p(V)];
        }
        return E;
      }
      function Pu(b, E) {
        var k = up(b, E);
        return Fv(k) ? k : n;
      }
      function Hv(b) {
        var E = Ur.call(b, sd), k = b[sd];
        try {
          b[sd] = n;
          var z = !0;
        } catch {
        }
        var V = mp.call(b);
        return z && (E ? b[sd] = k : delete b[sd]), V;
      }
      var Hi = Eg ? function(b) {
        return b == null ? [] : (b = Gr(b), oc(Eg(b), function(E) {
          return Xc.call(b, E);
        }));
      } : OS, Wi = Eg ? function(b) {
        for (var E = []; b; )
          Su(E, Hi(b)), b = ll(b);
        return E;
      } : OS, La = wo;
      (Kh && La(new Kh(new ArrayBuffer(1))) != it || jl && La(new jl()) != st || ud && La(ud.resolve()) != mt || cl && La(new cl()) != wt || yp && La(new yp()) != He) && (La = function(b) {
        var E = wo(b), k = E == Be ? b.constructor : n, z = k ? Ef(k) : "";
        if (z)
          switch (z) {
            case Kc:
              return it;
            case Gl:
              return st;
            case Jh:
              return mt;
            case Jc:
              return wt;
            case Cu:
              return He;
          }
        return E;
      });
      function ym(b, E, k) {
        for (var z = -1, V = k.length; ++z < V; ) {
          var oe = k[z], Ce = oe.size;
          switch (oe.type) {
            case "drop":
              b += Ce;
              break;
            case "dropRight":
              E -= Ce;
              break;
            case "take":
              E = Bi(E, b + Ce);
              break;
            case "takeRight":
              b = li(b, E - Ce);
              break;
          }
        }
        return { start: b, end: E };
      }
      function Od(b) {
        var E = b.match(Fl);
        return E ? E[1].split(xe) : [];
      }
      function Ps(b, E, k) {
        E = Xl(E, b);
        for (var z = -1, V = E.length, oe = !1; ++z < V; ) {
          var Ce = Bo(E[z]);
          if (!(oe = b != null && k(b, Ce)))
            break;
          b = b[Ce];
        }
        return oe || ++z != V ? oe : (V = b == null ? 0 : b.length, !!V && cy(V) && Ls(Ce, V) && (or(b) || Am(b)));
      }
      function Ai(b) {
        var E = b.length, k = new b.constructor(E);
        return E && typeof b[0] == "string" && Ur.call(b, "index") && (k.index = b.index, k.input = b.input), k;
      }
      function Mp(b) {
        return typeof b.constructor == "function" && !Fp(b) ? ef(ll(b)) : {};
      }
      function To(b, E, k) {
        var z = b.constructor;
        switch (E) {
          case Ie:
            return bc(b);
          case he:
          case Ae:
            return new z(+b);
          case it:
            return vc(b, k);
          case zt:
          case Ht:
          case bt:
          case Mt:
          case ln:
          case ze:
          case gt:
          case Bt:
          case Qt:
            return cm(b, k);
          case st:
            return new z();
          case Oe:
          case Yt:
            return new z(b);
          case ut:
            return Mg(b);
          case wt:
            return new z();
          case Rt:
            return um(b);
        }
      }
      function $1(b, E) {
        var k = E.length;
        if (!k)
          return b;
        var z = k - 1;
        return E[z] = (k > 1 ? "& " : "") + E[z], E = E.join(k > 2 ? ", " : " "), b.replace(es, `{
/* [wrapped with ` + E + `] */
`);
      }
      function Wv(b) {
        return or(b) || Am(b) || !!(bp && b && b[bp]);
      }
      function Ls(b, E) {
        var k = typeof b;
        return E = E ?? le, !!E && (k == "number" || k != "symbol" && ve.test(b)) && b > -1 && b % 1 == 0 && b < E;
      }
      function kr(b, E, k) {
        if (!ti(k))
          return !1;
        var z = typeof E;
        return (z == "number" ? io(k) && Ls(E, k.length) : z == "string" && E in k) ? _c(k[E], b) : !1;
      }
      function Hg(b, E) {
        if (or(b))
          return !1;
        var k = typeof b;
        return k == "number" || k == "symbol" || k == "boolean" || b == null || Sr(b) ? !0 : Jo.test(b) || !ho.test(b) || E != null && b in Gr(E);
      }
      function un(b) {
        var E = typeof b;
        return E == "string" || E == "number" || E == "symbol" || E == "boolean" ? b !== "__proto__" : b === null;
      }
      function Of(b) {
        var E = Lp(b), k = re[E];
        if (typeof k != "function" || !(E in ar.prototype))
          return !1;
        if (b === k)
          return !0;
        var z = bm(k);
        return !!z && b === z[0];
      }
      function Om(b) {
        return !!vg && vg in b;
      }
      var eO = hp ? kf : ES;
      function Fp(b) {
        var E = b && b.constructor, k = typeof E == "function" && E.prototype || _u;
        return b === k;
      }
      function $p(b) {
        return b === b && !ti(b);
      }
      function Bp(b, E) {
        return function(k) {
          return k == null ? !1 : k[b] === E && (E !== n || b in Gr(k));
        };
      }
      function Qv(b) {
        var E = Me(b, function(z) {
          return k.size === f && k.clear(), z;
        }), k = E.cache;
        return E;
      }
      function jv(b, E) {
        var k = b[1], z = E[1], V = k | z, oe = V < (C | A | H), Ce = z == H && k == P || z == H && k == Y && b[7].length <= E[8] || z == (H | Y) && E[7].length <= E[8] && k == P;
        if (!(oe || Ce))
          return b;
        z & C && (b[2] = E[2], V |= k & C ? 0 : N);
        var Le = E[3];
        if (Le) {
          var Qe = b[3];
          b[3] = Qe ? gd(Qe, Le, E[4]) : Le, b[4] = Qe ? sl(b[3], p) : E[4];
        }
        return Le = E[5], Le && (Qe = b[5], b[5] = Qe ? dm(Qe, Le, E[6]) : Le, b[6] = Qe ? sl(b[5], p) : E[6]), Le = E[7], Le && (b[7] = Le), z & H && (b[8] = b[8] == null ? E[8] : Bi(b[8], E[8])), b[9] == null && (b[9] = E[9]), b[0] = E[0], b[1] = V, b;
      }
      function tO(b) {
        var E = [];
        if (b != null)
          for (var k in Gr(b))
            E.push(k);
        return E;
      }
      function Wg(b) {
        return mp.call(b);
      }
      function Ed(b, E, k) {
        return E = li(E === n ? b.length - 1 : E, 0), function() {
          for (var z = arguments, V = -1, oe = li(z.length - E, 0), Ce = et(oe); ++V < oe; )
            Ce[V] = z[E + V];
          V = -1;
          for (var Le = et(E + 1); ++V < E; )
            Le[V] = z[V];
          return Le[E] = k(Ce), vo(b, this, Le);
        };
      }
      function Kl(b, E) {
        return E.length < 2 ? b : za(b, Na(E, 0, -1));
      }
      function Ma(b, E) {
        for (var k = b.length, z = Bi(E.length, k), V = Ci(b); z--; ) {
          var oe = E[z];
          b[z] = Ls(oe, k) ? V[oe] : n;
        }
        return b;
      }
      function bi(b, E) {
        if (!(E === "constructor" && typeof b[E] == "function") && E != "__proto__")
          return b[E];
      }
      var Ms = Gv(vr), Lu = qc || function(b, E) {
        return Ta.setTimeout(b, E);
      }, Jl = Gv(Fn);
      function vl(b, E, k) {
        var z = E + "";
        return Jl(b, $1(z, Yv(Od(z), k)));
      }
      function Gv(b) {
        var E = 0, k = 0;
        return function() {
          var z = L1(), V = ue - (z - k);
          if (k = z, V > 0) {
            if (++E >= J)
              return arguments[0];
          } else
            E = 0;
          return b.apply(n, arguments);
        };
      }
      function Fs(b, E) {
        var k = -1, z = b.length, V = z - 1;
        for (E = E === n ? z : E; ++k < E; ) {
          var oe = ls(k, V), Ce = b[oe];
          b[oe] = b[k], b[k] = Ce;
        }
        return b.length = E, b;
      }
      var Vv = Qv(function(b) {
        var E = [];
        return b.charCodeAt(0) === 46 && E.push(""), b.replace(bu, function(k, z, V, oe) {
          E.push(V ? oe.replace(Sn, "$1") : z || k);
        }), E;
      });
      function Bo(b) {
        if (typeof b == "string" || Sr(b))
          return b;
        var E = b + "";
        return E == "0" && 1 / b == -ie ? "-0" : E;
      }
      function Ef(b) {
        if (b != null) {
          try {
            return Gh.call(b);
          } catch {
          }
          try {
            return b + "";
          } catch {
          }
        }
        return "";
      }
      function Yv(b, E) {
        return yo(ce, function(k) {
          var z = "_." + k[0];
          E & k[1] && !Hh(b, z) && b.push(z);
        }), b.sort();
      }
      function Zv(b) {
        if (b instanceof ar)
          return b.clone();
        var E = new Oo(b.__wrapped__, b.__chain__);
        return E.__actions__ = Ci(b.__actions__), E.__index__ = b.__index__, E.__values__ = b.__values__, E;
      }
      function Qg(b, E, k) {
        (k ? kr(b, E, k) : E === n) ? E = 1 : E = li(rr(E), 0);
        var z = b == null ? 0 : b.length;
        if (!z || E < 1)
          return [];
        for (var V = 0, oe = 0, Ce = et(ul(z / E)); V < z; )
          Ce[oe++] = Na(b, V, V += E);
        return Ce;
      }
      function Em(b) {
        for (var E = -1, k = b == null ? 0 : b.length, z = 0, V = []; ++E < k; ) {
          var oe = b[E];
          oe && (V[z++] = oe);
        }
        return V;
      }
      function Xv() {
        var b = arguments.length;
        if (!b)
          return [];
        for (var E = et(b - 1), k = arguments[0], z = b; z--; )
          E[z - 1] = arguments[z];
        return Su(or(k) ? Ci(k) : [k], Ti(E, 1));
      }
      var _o = ir(function(b, E) {
        return fi(b) ? fa(b, Ti(E, 1, fi, !0)) : [];
      }), mr = ir(function(b, E) {
        var k = Ri(E);
        return fi(k) && (k = n), fi(b) ? fa(b, Ti(E, 1, fi, !0), Cn(k, 2)) : [];
      }), Ha = ir(function(b, E) {
        var k = Ri(E);
        return fi(k) && (k = n), fi(b) ? fa(b, Ti(E, 1, fi, !0), n, k) : [];
      });
      function Ja(b, E, k) {
        var z = b == null ? 0 : b.length;
        return z ? (E = k || E === n ? 1 : rr(E), Na(b, E < 0 ? 0 : E, z)) : [];
      }
      function Qi(b, E, k) {
        var z = b == null ? 0 : b.length;
        return z ? (E = k || E === n ? 1 : rr(E), E = z - E, Na(b, 0, E < 0 ? 0 : E)) : [];
      }
      function $s(b, E) {
        return b && b.length ? hf(b, Cn(E, 3), !0, !0) : [];
      }
      function Up(b, E) {
        return b && b.length ? hf(b, Cn(E, 3), !0) : [];
      }
      function ki(b, E, k, z) {
        var V = b == null ? 0 : b.length;
        return V ? (k && typeof k != "number" && kr(b, E, k) && (k = 0, z = V), Cg(b, E, k, z)) : [];
      }
      function zp(b, E, k) {
        var z = b == null ? 0 : b.length;
        if (!z)
          return -1;
        var V = k == null ? 0 : rr(k);
        return V < 0 && (V = li(z + V, 0)), Wh(b, Cn(E, 3), V);
      }
      function Mu(b, E, k) {
        var z = b == null ? 0 : b.length;
        if (!z)
          return -1;
        var V = z - 1;
        return k !== n && (V = rr(k), V = k < 0 ? li(z + V, 0) : Bi(V, z - 1)), Wh(b, Cn(E, 3), V, !0);
      }
      function Sm(b) {
        var E = b == null ? 0 : b.length;
        return E ? Ti(b, 1) : [];
      }
      function Hp(b) {
        var E = b == null ? 0 : b.length;
        return E ? Ti(b, ie) : [];
      }
      function Sd(b, E) {
        var k = b == null ? 0 : b.length;
        return k ? (E = E === n ? 1 : rr(E), Ti(b, E)) : [];
      }
      function Uo(b) {
        for (var E = -1, k = b == null ? 0 : b.length, z = {}; ++E < k; ) {
          var V = b[E];
          z[V[0]] = V[1];
        }
        return z;
      }
      function jg(b) {
        return b && b.length ? b[0] : n;
      }
      function Wp(b, E, k) {
        var z = b == null ? 0 : b.length;
        if (!z)
          return -1;
        var V = k == null ? 0 : rr(k);
        return V < 0 && (V = li(z + V, 0)), id(b, E, V);
      }
      function wc(b) {
        var E = b == null ? 0 : b.length;
        return E ? Na(b, 0, -1) : [];
      }
      var Gg = ir(function(b) {
        var E = Hr(b, Ip);
        return E.length && E[0] === b[0] ? Zl(E) : [];
      }), wd = ir(function(b) {
        var E = Ri(b), k = Hr(b, Ip);
        return E === Ri(k) ? E = n : k.pop(), k.length && k[0] === b[0] ? Zl(k, Cn(E, 2)) : [];
      }), Fu = ir(function(b) {
        var E = Ri(b), k = Hr(b, Ip);
        return E = typeof E == "function" ? E : n, E && k.pop(), k.length && k[0] === b[0] ? Zl(k, n, E) : [];
      });
      function Sf(b, E) {
        return b == null ? "" : Xh.call(b, E);
      }
      function Ri(b) {
        var E = b == null ? 0 : b.length;
        return E ? b[E - 1] : n;
      }
      function Vg(b, E, k) {
        var z = b == null ? 0 : b.length;
        if (!z)
          return -1;
        var V = z;
        return k !== n && (V = rr(k), V = V < 0 ? li(z + V, 0) : Bi(V, z - 1)), E === E ? H0(b, E, V) : Wh(b, wu, V, !0);
      }
      function Qp(b, E) {
        return b && b.length ? ff(b, rr(E)) : n;
      }
      var Yg = ir(wf);
      function wf(b, E) {
        return b && b.length && E && E.length ? Dn(b, E) : b;
      }
      function Td(b, E, k) {
        return b && b.length && E && E.length ? Dn(b, E, Cn(k, 2)) : b;
      }
      function Co(b, E, k) {
        return b && b.length && E && E.length ? Dn(b, E, n, k) : b;
      }
      var yi = Nu(function(b, E) {
        var k = b == null ? 0 : b.length, z = _g(b, E);
        return Da(b, Hr(E, function(V) {
          return Ls(V, k) ? +V : V;
        }).sort(fm)), z;
      });
      function xo(b, E) {
        var k = [];
        if (!(b && b.length))
          return k;
        var z = -1, V = [], oe = b.length;
        for (E = Cn(E, 3); ++z < oe; ) {
          var Ce = b[z];
          E(Ce, z, b) && (k.push(Ce), V.push(z));
        }
        return Da(b, V), k;
      }
      function ji(b) {
        return b == null ? b : wg.call(b);
      }
      function jp(b, E, k) {
        var z = b == null ? 0 : b.length;
        return z ? (k && typeof k != "number" && kr(b, E, k) ? (E = 0, k = z) : (E = E == null ? 0 : rr(E), k = k === n ? z : rr(k)), Na(b, E, k)) : [];
      }
      function qv(b, E) {
        return aa(b, E);
      }
      function wm(b, E, k) {
        return hc(b, E, Cn(k, 2));
      }
      function Kv(b, E) {
        var k = b == null ? 0 : b.length;
        if (k) {
          var z = aa(b, E);
          if (z < k && _c(b[z], E))
            return z;
        }
        return -1;
      }
      function yl(b, E) {
        return aa(b, E, !0);
      }
      function nO(b, E, k) {
        return hc(b, E, Cn(k, 2), !0);
      }
      function Gp(b, E) {
        var k = b == null ? 0 : b.length;
        if (k) {
          var z = aa(b, E, !0) - 1;
          if (_c(b[z], E))
            return z;
        }
        return -1;
      }
      function Tf(b) {
        return b && b.length ? mc(b) : [];
      }
      function Jv(b, E) {
        return b && b.length ? mc(b, Cn(E, 2)) : [];
      }
      function _d(b) {
        var E = b == null ? 0 : b.length;
        return E ? Na(b, 1, E) : [];
      }
      function rO(b, E, k) {
        return b && b.length ? (E = k || E === n ? 1 : rr(E), Na(b, 0, E < 0 ? 0 : E)) : [];
      }
      function Zg(b, E, k) {
        var z = b == null ? 0 : b.length;
        return z ? (E = k || E === n ? 1 : rr(E), E = z - E, Na(b, E < 0 ? 0 : E, z)) : [];
      }
      function ey(b, E) {
        return b && b.length ? hf(b, Cn(E, 3), !1, !0) : [];
      }
      function Xg(b, E) {
        return b && b.length ? hf(b, Cn(E, 3)) : [];
      }
      var B1 = ir(function(b) {
        return ui(Ti(b, 1, fi, !0));
      }), U1 = ir(function(b) {
        var E = Ri(b);
        return fi(E) && (E = n), ui(Ti(b, 1, fi, !0), Cn(E, 2));
      }), aO = ir(function(b) {
        var E = Ri(b);
        return E = typeof E == "function" ? E : n, ui(Ti(b, 1, fi, !0), n, E);
      });
      function ty(b) {
        return b && b.length ? ui(b) : [];
      }
      function Cd(b, E) {
        return b && b.length ? ui(b, Cn(E, 2)) : [];
      }
      function z1(b, E) {
        return E = typeof E == "function" ? E : n, b && b.length ? ui(b, n, E) : [];
      }
      function _f(b) {
        if (!(b && b.length))
          return [];
        var E = 0;
        return b = oc(b, function(k) {
          if (fi(k))
            return E = li(k.length, E), !0;
        }), pg(E, function(k) {
          return Hr(b, Qh(k));
        });
      }
      function ny(b, E) {
        if (!(b && b.length))
          return [];
        var k = _f(b);
        return E == null ? k : Hr(k, function(z) {
          return vo(E, n, z);
        });
      }
      var ei = ir(function(b, E) {
        return fi(b) ? fa(b, E) : [];
      }), H1 = ir(function(b) {
        return Rp(oc(b, fi));
      }), qg = ir(function(b) {
        var E = Ri(b);
        return fi(E) && (E = n), Rp(oc(b, fi), Cn(E, 2));
      }), W1 = ir(function(b) {
        var E = Ri(b);
        return E = typeof E == "function" ? E : n, Rp(oc(b, fi), n, E);
      }), Q1 = ir(_f);
      function iO(b, E) {
        return sm(b || [], E || [], dd);
      }
      function ry(b, E) {
        return sm(b || [], E || [], ct);
      }
      var j1 = ir(function(b) {
        var E = b.length, k = E > 1 ? b[E - 1] : n;
        return k = typeof k == "function" ? (b.pop(), k) : n, ny(b, k);
      });
      function Bs(b) {
        var E = re(b);
        return E.__chain__ = !0, E;
      }
      function ay(b, E) {
        return E(b), b;
      }
      function Kg(b, E) {
        return E(b);
      }
      var Cf = Nu(function(b) {
        var E = b.length, k = E ? b[0] : 0, z = this.__wrapped__, V = function(oe) {
          return _g(oe, b);
        };
        return E > 1 || this.__actions__.length || !(z instanceof ar) || !Ls(k) ? this.thru(V) : (z = z.slice(k, +k + (E ? 1 : 0)), z.__actions__.push({
          func: Kg,
          args: [V],
          thisArg: n
        }), new Oo(z, this.__chain__).thru(function(oe) {
          return E && !oe.length && oe.push(n), oe;
        }));
      });
      function Jg() {
        return Bs(this);
      }
      function xd() {
        return new Oo(this.value(), this.__chain__);
      }
      function Tm() {
        this.__values__ === n && (this.__values__ = lb(this.value()));
        var b = this.__index__ >= this.__values__.length, E = b ? n : this.__values__[this.__index__++];
        return { done: b, value: E };
      }
      function _m() {
        return this;
      }
      function Ad(b) {
        for (var E, k = this; k instanceof Mo; ) {
          var z = Zv(k);
          z.__index__ = 0, z.__values__ = n, E ? V.__wrapped__ = z : E = z;
          var V = z;
          k = k.__wrapped__;
        }
        return V.__wrapped__ = b, E;
      }
      function G1() {
        var b = this.__wrapped__;
        if (b instanceof ar) {
          var E = b;
          return this.__actions__.length && (E = new ar(this)), E = E.reverse(), E.__actions__.push({
            func: Kg,
            args: [ji],
            thisArg: n
          }), new Oo(E, this.__chain__);
        }
        return this.thru(ji);
      }
      function eb() {
        return om(this.__wrapped__, this.__actions__);
      }
      var oO = Yr(function(b, E, k) {
        Ur.call(b, k) ? ++b[k] : Vl(b, k, 1);
      });
      function iy(b, E, k) {
        var z = or(b) ? zh : Ds;
        return k && kr(b, E, k) && (E = n), z(b, Cn(E, 3));
      }
      function sO(b, E) {
        var k = or(b) ? oc : dc;
        return k(b, Cn(E, 3));
      }
      var Cm = Fg(zp), tb = Fg(Mu);
      function lO(b, E) {
        return Ti(ab(b, E), 1);
      }
      function oy(b, E) {
        return Ti(ab(b, E), ie);
      }
      function uO(b, E, k) {
        return k = k === n ? 1 : rr(k), Ti(ab(b, E), k);
      }
      function nb(b, E) {
        var k = or(b) ? yo : Iu;
        return k(b, Cn(E, 3));
      }
      function xm(b, E) {
        var k = or(b) ? Fi : rm;
        return k(b, Cn(E, 3));
      }
      var Tc = Yr(function(b, E, k) {
        Ur.call(b, k) ? b[k].push(E) : Vl(b, k, [E]);
      });
      function sy(b, E, k, z) {
        b = io(b) ? b : fb(b), k = k && !z ? rr(k) : 0;
        var V = b.length;
        return k < 0 && (k = li(V + k, 0)), pO(b) ? k <= V && b.indexOf(E, k) > -1 : !!V && id(b, E, k) > -1;
      }
      var rb = ir(function(b, E, k) {
        var z = -1, V = typeof E == "function", oe = io(b) ? et(b.length) : [];
        return Iu(b, function(Ce) {
          oe[++z] = V ? vo(E, Ce, k) : sf(Ce, E, k);
        }), oe;
      }), cO = Yr(function(b, E, k) {
        Vl(b, k, E);
      });
      function ab(b, E) {
        var k = or(b) ? Hr : $v;
        return k(b, Cn(E, 3));
      }
      function ib(b, E, k, z) {
        return b == null ? [] : (or(E) || (E = E == null ? [] : [E]), k = z ? n : k, or(k) || (k = k == null ? [] : [k]), Ng(b, E, k));
      }
      var V1 = Yr(function(b, E, k) {
        b[k ? 0 : 1].push(E);
      }, function() {
        return [[], []];
      });
      function Vp(b, E, k) {
        var z = or(b) ? fg : dg, V = arguments.length < 3;
        return z(b, Cn(E, 4), k, V, Iu);
      }
      function Y1(b, E, k) {
        var z = or(b) ? k1 : dg, V = arguments.length < 3;
        return z(b, Cn(E, 4), k, V, rm);
      }
      function ob(b, E) {
        var k = or(b) ? oc : dc;
        return k(b, Xe(Cn(E, 3)));
      }
      function d(b) {
        var E = or(b) ? ku : hd;
        return E(b);
      }
      function h(b, E, k) {
        (k ? kr(b, E, k) : E === n) ? E = 1 : E = rr(E);
        var z = or(b) ? Is : Ca;
        return z(b, E);
      }
      function S(b) {
        var E = or(b) ? Nv : Du;
        return E(b);
      }
      function x(b) {
        if (b == null)
          return 0;
        if (io(b))
          return pO(b) ? Zc(b) : b.length;
        var E = La(b);
        return E == st || E == wt ? b.size : Dg(b).length;
      }
      function F(b, E, k) {
        var z = or(b) ? Ev : md;
        return k && kr(b, E, k) && (E = n), z(b, Cn(E, 3));
      }
      var U = ir(function(b, E) {
        if (b == null)
          return [];
        var k = E.length;
        return k > 1 && kr(b, E[0], E[1]) ? E = [] : k > 2 && kr(E[0], E[1], E[2]) && (E = [E[0]]), Ng(b, Ti(E, 1), []);
      }), X = ca || function() {
        return Ta.Date.now();
      };
      function Se(b, E) {
        if (typeof E != "function")
          throw new As(o);
        return b = rr(b), function() {
          if (--b < 1)
            return E.apply(this, arguments);
        };
      }
      function Pe(b, E, k) {
        return E = k ? n : E, E = b && E == null ? b.length : E, bl(b, H, n, n, n, n, E);
      }
      function nt(b, E) {
        var k;
        if (typeof E != "function")
          throw new As(o);
        return b = rr(b), function() {
          return --b > 0 && (k = E.apply(this, arguments)), b <= 1 && (E = n), k;
        };
      }
      var At = ir(function(b, E, k) {
        var z = C;
        if (k.length) {
          var V = sl(k, yf(At));
          z |= D;
        }
        return bl(b, z, E, k, V);
      }), It = ir(function(b, E, k) {
        var z = C | A;
        if (k.length) {
          var V = sl(k, yf(It));
          z |= D;
        }
        return bl(E, z, b, k, V);
      });
      function kt(b, E, k) {
        E = k ? n : E;
        var z = bl(b, P, n, n, n, n, n, E);
        return z.placeholder = kt.placeholder, z;
      }
      function en(b, E, k) {
        E = k ? n : E;
        var z = bl(b, I, n, n, n, n, n, E);
        return z.placeholder = en.placeholder, z;
      }
      function dn(b, E, k) {
        var z, V, oe, Ce, Le, Qe, St = 0, Ot = !1, _t = !1, Vt = !0;
        if (typeof b != "function")
          throw new As(o);
        E = $u(E) || 0, ti(k) && (Ot = !!k.leading, _t = "maxWait" in k, oe = _t ? li($u(k.maxWait) || 0, E) : oe, Vt = "trailing" in k ? !!k.trailing : Vt);
        function hn(ni) {
          var oo = z, fs = V;
          return z = V = n, St = ni, Ce = b.apply(fs, oo), Ce;
        }
        function $n(ni) {
          return St = ni, Le = Lu(yr, E), Ot ? hn(ni) : Ce;
        }
        function lr(ni) {
          var oo = ni - Qe, fs = ni - St, zo = E - oo;
          return _t ? Bi(zo, oe - fs) : zo;
        }
        function jn(ni) {
          var oo = ni - Qe, fs = ni - St;
          return Qe === n || oo >= E || oo < 0 || _t && fs >= oe;
        }
        function yr() {
          var ni = X();
          if (jn(ni))
            return Cr(ni);
          Le = Lu(yr, lr(ni));
        }
        function Cr(ni) {
          return Le = n, Vt && z ? hn(ni) : (z = V = n, Ce);
        }
        function cs() {
          Le !== n && mf(Le), St = 0, z = Qe = V = Le = n;
        }
        function Wa() {
          return Le === n ? Ce : Cr(X());
        }
        function Us() {
          var ni = X(), oo = jn(ni);
          if (z = arguments, V = this, Qe = ni, oo) {
            if (Le === n)
              return $n(Qe);
            if (_t)
              return mf(Le), Le = Lu(yr, E), hn(Qe);
          }
          return Le === n && (Le = Lu(yr, E)), Ce;
        }
        return Us.cancel = cs, Us.flush = Wa, Us;
      }
      var mn = ir(function(b, E) {
        return Pv(b, 1, E);
      }), ci = ir(function(b, E, k) {
        return Pv(b, $u(E) || 0, k);
      });
      function Ze(b) {
        return bl(b, q);
      }
      function Me(b, E) {
        if (typeof b != "function" || E != null && typeof E != "function")
          throw new As(o);
        var k = function() {
          var z = arguments, V = E ? E.apply(this, z) : z[0], oe = k.cache;
          if (oe.has(V))
            return oe.get(V);
          var Ce = b.apply(this, z);
          return k.cache = oe.set(V, Ce) || oe, Ce;
        };
        return k.cache = new (Me.Cache || pl)(), k;
      }
      Me.Cache = pl;
      function Xe(b) {
        if (typeof b != "function")
          throw new As(o);
        return function() {
          var E = arguments;
          switch (E.length) {
            case 0:
              return !b.call(this);
            case 1:
              return !b.call(this, E[0]);
            case 2:
              return !b.call(this, E[0], E[1]);
            case 3:
              return !b.call(this, E[0], E[1], E[2]);
          }
          return !b.apply(this, E);
        };
      }
      function Ft(b) {
        return nt(2, b);
      }
      var yn = Lg(function(b, E) {
        E = E.length == 1 && or(E[0]) ? Hr(E[0], $r(Cn())) : Hr(Ti(E, 1), $r(Cn()));
        var k = E.length;
        return ir(function(z) {
          for (var V = -1, oe = Bi(z.length, k); ++V < oe; )
            z[V] = E[V].call(this, z[V]);
          return vo(b, this, z);
        });
      }), cn = ir(function(b, E) {
        var k = sl(E, yf(cn));
        return bl(b, D, n, E, k);
      }), wn = ir(function(b, E) {
        var k = sl(E, yf(wn));
        return bl(b, M, n, E, k);
      }), Qn = Nu(function(b, E) {
        return bl(b, Y, n, n, n, E);
      });
      function Gi(b, E) {
        if (typeof b != "function")
          throw new As(o);
        return E = E === n ? E : rr(E), ir(b, E);
      }
      function Rr(b, E) {
        if (typeof b != "function")
          throw new As(o);
        return E = E == null ? 0 : li(rr(E), 0), ir(function(k) {
          var z = k[E], V = ql(k, 0, E);
          return z && Su(V, z), vo(b, this, V);
        });
      }
      function xf(b, E, k) {
        var z = !0, V = !0;
        if (typeof b != "function")
          throw new As(o);
        return ti(k) && (z = "leading" in k ? !!k.leading : z, V = "trailing" in k ? !!k.trailing : V), dn(b, E, {
          leading: z,
          maxWait: E,
          trailing: V
        });
      }
      function Z1(b) {
        return Pe(b, 1);
      }
      function wN(b, E) {
        return cn(Dp(E), b);
      }
      function H_() {
        if (!arguments.length)
          return [];
        var b = arguments[0];
        return or(b) ? b : [b];
      }
      function W_(b) {
        return Fo(b, O);
      }
      function TN(b, E) {
        return E = typeof E == "function" ? E : n, Fo(b, O, E);
      }
      function _N(b) {
        return Fo(b, m | O);
      }
      function Q_(b, E) {
        return E = typeof E == "function" ? E : n, Fo(b, m | O, E);
      }
      function X1(b, E) {
        return E == null || nm(b, E, Ao(E));
      }
      function _c(b, E) {
        return b === E || b !== b && E !== E;
      }
      var CN = Np(Yl), xN = Np(function(b, E) {
        return b >= E;
      }), Am = Ag(function() {
        return arguments;
      }()) ? Ag : function(b) {
        return di(b) && Ur.call(b, "callee") && !Xc.call(b, "callee");
      }, or = et.isArray, AN = bv ? $r(bv) : lf;
      function io(b) {
        return b != null && cy(b.length) && !kf(b);
      }
      function fi(b) {
        return di(b) && io(b);
      }
      function ly(b) {
        return b === !0 || b === !1 || di(b) && wo(b) == he;
      }
      var Af = Sg || ES, kN = ns ? $r(ns) : pd;
      function RN(b) {
        return di(b) && b.nodeType === 1 && !km(b);
      }
      function j_(b) {
        if (b == null)
          return !0;
        if (io(b) && (or(b) || typeof b == "string" || typeof b.splice == "function" || Af(b) || Xp(b) || Am(b)))
          return !b.length;
        var E = La(b);
        if (E == st || E == wt)
          return !b.size;
        if (Fp(b))
          return !Dg(b).length;
        for (var k in b)
          if (Ur.call(b, k))
            return !1;
        return !0;
      }
      function IN(b, E) {
        return Tp(b, E);
      }
      function fO(b, E, k) {
        k = typeof k == "function" ? k : n;
        var z = k ? k(b, E) : n;
        return z === n ? Tp(b, E, n, k) : !!z;
      }
      function Yp(b) {
        if (!di(b))
          return !1;
        var E = wo(b);
        return E == je || E == Te || typeof b.message == "string" && typeof b.name == "string" && !km(b);
      }
      function q1(b) {
        return typeof b == "number" && vp(b);
      }
      function kf(b) {
        if (!ti(b))
          return !1;
        var E = wo(b);
        return E == we || E == lt || E == Ee || E == Tt;
      }
      function uy(b) {
        return typeof b == "number" && b == rr(b);
      }
      function cy(b) {
        return typeof b == "number" && b > -1 && b % 1 == 0 && b <= le;
      }
      function ti(b) {
        var E = typeof b;
        return b != null && (E == "object" || E == "function");
      }
      function di(b) {
        return b != null && typeof b == "object";
      }
      var K1 = ic ? $r(ic) : kg;
      function G_(b, E) {
        return b === E || Rg(b, E, vm(E));
      }
      function V_(b, E, k) {
        return k = typeof k == "function" ? k : n, Rg(b, E, vm(E), k);
      }
      function Zp(b) {
        return sb(b) && b != +b;
      }
      function DN(b) {
        if (eO(b))
          throw new Kn(i);
        return Fv(b);
      }
      function NN(b) {
        return b === null;
      }
      function PN(b) {
        return b == null;
      }
      function sb(b) {
        return typeof b == "number" || di(b) && wo(b) == Oe;
      }
      function km(b) {
        if (!di(b) || wo(b) != Be)
          return !1;
        var E = ll(b);
        if (E === null)
          return !0;
        var k = Ur.call(E, "constructor") && E.constructor;
        return typeof k == "function" && k instanceof k && Gh.call(k) == $i;
      }
      var dO = Uh ? $r(Uh) : Z0;
      function LN(b) {
        return uy(b) && b >= -le && b <= le;
      }
      var J1 = ad ? $r(ad) : Ig;
      function pO(b) {
        return typeof b == "string" || !or(b) && di(b) && wo(b) == Yt;
      }
      function Sr(b) {
        return typeof b == "symbol" || di(b) && wo(b) == Rt;
      }
      var Xp = vv ? $r(vv) : _p;
      function hO(b) {
        return b === n;
      }
      function fy(b) {
        return di(b) && La(b) == He;
      }
      function Y_(b) {
        return di(b) && wo(b) == Ve;
      }
      var Z_ = Np(uf), eS = Np(function(b, E) {
        return b <= E;
      });
      function lb(b) {
        if (!b)
          return [];
        if (io(b))
          return pO(b) ? xs(b) : Ci(b);
        if (uc && b[uc])
          return z0(b[uc]());
        var E = La(b), k = E == st ? mg : E == wt ? sc : fb;
        return k(b);
      }
      function kd(b) {
        if (!b)
          return b === 0 ? b : 0;
        if (b = $u(b), b === ie || b === -ie) {
          var E = b < 0 ? -1 : 1;
          return E * ye;
        }
        return b === b ? b : 0;
      }
      function rr(b) {
        var E = kd(b), k = E % 1;
        return E === E ? k ? E - k : E : 0;
      }
      function Rm(b) {
        return b ? Ru(rr(b), 0, pe) : 0;
      }
      function $u(b) {
        if (typeof b == "number")
          return b;
        if (Sr(b))
          return B;
        if (ti(b)) {
          var E = typeof b.valueOf == "function" ? b.valueOf() : b;
          b = ti(E) ? E + "" : E;
        }
        if (typeof b != "string")
          return b === 0 ? b : +b;
        b = Tu(b);
        var k = Rn.test(b);
        return k || ma.test(b) ? $h(b.slice(2), k ? 2 : 8) : qn.test(b) ? B : +b;
      }
      function tS(b) {
        return ao(b, El(b));
      }
      function MN(b) {
        return b ? Ru(rr(b), -le, le) : b === 0 ? b : 0;
      }
      function ia(b) {
        return b == null ? "" : Pa(b);
      }
      var Ol = yc(function(b, E) {
        if (Fp(E) || io(E)) {
          ao(E, Ao(E), b);
          return;
        }
        for (var k in E)
          Ur.call(E, k) && dd(b, k, E[k]);
      }), ub = yc(function(b, E) {
        ao(E, El(E), b);
      }), Im = yc(function(b, E, k, z) {
        ao(E, El(E), b, z);
      }), qp = yc(function(b, E, k, z) {
        ao(E, Ao(E), b, z);
      }), X_ = Nu(_g);
      function Dm(b, E) {
        var k = ef(b);
        return E == null ? k : ga(k, E);
      }
      var Nm = ir(function(b, E) {
        b = Gr(b);
        var k = -1, z = E.length, V = z > 2 ? E[2] : n;
        for (V && kr(E[0], E[1], V) && (z = 1); ++k < z; )
          for (var oe = E[k], Ce = El(oe), Le = -1, Qe = Ce.length; ++Le < Qe; ) {
            var St = Ce[Le], Ot = b[St];
            (Ot === n || _c(Ot, _u[St]) && !Ur.call(b, St)) && (b[St] = oe[St]);
          }
        return b;
      }), mO = ir(function(b) {
        return b.push(n, vf), vo(tC, n, b);
      });
      function nS(b, E) {
        return Tv(b, Cn(E, 3), da);
      }
      function gO(b, E) {
        return Tv(b, Cn(E, 3), Gt);
      }
      function dy(b, E) {
        return b == null ? b : am(b, Cn(E, 3), El);
      }
      function q_(b, E) {
        return b == null ? b : pc(b, Cn(E, 3), El);
      }
      function bO(b, E) {
        return b && da(b, Cn(E, 3));
      }
      function K_(b, E) {
        return b && Gt(b, Cn(E, 3));
      }
      function J_(b) {
        return b == null ? [] : Ia(b, Ao(b));
      }
      function FN(b) {
        return b == null ? [] : Ia(b, El(b));
      }
      function rS(b, E, k) {
        var z = b == null ? n : za(b, E);
        return z === n ? k : z;
      }
      function vO(b, E) {
        return b != null && Ps(b, E, af);
      }
      function cb(b, E) {
        return b != null && Ps(b, E, Lv);
      }
      var eC = gm(function(b, E, k) {
        E != null && typeof E.toString != "function" && (E = mp.call(E)), b[E] = k;
      }, hS(Sl)), $N = gm(function(b, E, k) {
        E != null && typeof E.toString != "function" && (E = mp.call(E)), Ur.call(b, E) ? b[E].push(k) : b[E] = [k];
      }, Cn), yO = ir(sf);
      function Ao(b) {
        return io(b) ? zi(b) : Dg(b);
      }
      function El(b) {
        return io(b) ? zi(b, !0) : X0(b);
      }
      function BN(b, E) {
        var k = {};
        return E = Cn(E, 3), da(b, function(z, V, oe) {
          Vl(k, E(z, V, oe), z);
        }), k;
      }
      function UN(b, E) {
        var k = {};
        return E = Cn(E, 3), da(b, function(z, V, oe) {
          Vl(k, V, E(z, V, oe));
        }), k;
      }
      var zN = yc(function(b, E, k) {
        cf(b, E, k);
      }), tC = yc(function(b, E, k, z) {
        cf(b, E, k, z);
      }), HN = Nu(function(b, E) {
        var k = {};
        if (b == null)
          return k;
        var z = !1;
        E = Hr(E, function(oe) {
          return oe = Xl(oe, b), z || (z = oe.length > 1), oe;
        }), ao(b, Sc(b), k), z && (k = Fo(k, m | v | O, er));
        for (var V = E.length; V--; )
          gc(k, E[V]);
        return k;
      });
      function WN(b, E) {
        return nC(b, Xe(Cn(E)));
      }
      var QN = Nu(function(b, E) {
        return b == null ? {} : df(b, E);
      });
      function nC(b, E) {
        if (b == null)
          return {};
        var k = Hr(Sc(b), function(z) {
          return [z];
        });
        return E = Cn(E), In(b, k, function(z, V) {
          return E(z, V[0]);
        });
      }
      function aS(b, E, k) {
        E = Xl(E, b);
        var z = -1, V = E.length;
        for (V || (V = 1, b = n); ++z < V; ) {
          var oe = b == null ? n : b[Bo(E[z])];
          oe === n && (z = V, oe = k), b = kf(oe) ? oe.call(b) : oe;
        }
        return b;
      }
      function iS(b, E, k) {
        return b == null ? b : ct(b, E, k);
      }
      function oS(b, E, k, z) {
        return z = typeof z == "function" ? z : n, b == null ? b : ct(b, E, k, z);
      }
      var OO = Ec(Ao), rC = Ec(El);
      function py(b, E, k) {
        var z = or(b), V = z || Af(b) || Xp(b);
        if (E = Cn(E, 4), k == null) {
          var oe = b && b.constructor;
          V ? k = z ? new oe() : [] : ti(b) ? k = kf(oe) ? ef(ll(b)) : {} : k = {};
        }
        return (V ? yo : da)(b, function(Ce, Le, Qe) {
          return E(k, Ce, Le, Qe);
        }), k;
      }
      function hy(b, E) {
        return b == null ? !0 : gc(b, E);
      }
      function jN(b, E, k) {
        return b == null ? b : kp(b, E, Dp(k));
      }
      function aC(b, E, k, z) {
        return z = typeof z == "function" ? z : n, b == null ? b : kp(b, E, Dp(k), z);
      }
      function fb(b) {
        return b == null ? [] : Cs(b, Ao(b));
      }
      function GN(b) {
        return b == null ? [] : Cs(b, El(b));
      }
      function iC(b, E, k) {
        return k === n && (k = E, E = n), k !== n && (k = $u(k), k = k === k ? k : 0), E !== n && (E = $u(E), E = E === E ? E : 0), Ru($u(b), E, k);
      }
      function VN(b, E, k) {
        return E = kd(E), k === n ? (k = E, E = 0) : k = kd(k), b = $u(b), _i(b, E, k);
      }
      function YN(b, E, k) {
        if (k && typeof k != "boolean" && kr(b, E, k) && (E = k = n), k === n && (typeof E == "boolean" ? (k = E, E = n) : typeof b == "boolean" && (k = b, b = n)), b === n && E === n ? (b = 0, E = 1) : (b = kd(b), E === n ? (E = b, b = 0) : E = kd(E)), b > E) {
          var z = b;
          b = E, E = z;
        }
        if (k || b % 1 || E % 1) {
          var V = qh();
          return Bi(b + V * (E - b + ug("1e-" + ((V + "").length - 1))), E);
        }
        return ls(b, E);
      }
      var oC = Oc(function(b, E, k) {
        return E = E.toLowerCase(), b + (k ? my(E) : E);
      });
      function my(b) {
        return dS(ia(b).toLowerCase());
      }
      function gy(b) {
        return b = ia(b), b && b.replace(Ye, B0).replace(zl, "");
      }
      function EO(b, E, k) {
        b = ia(b), E = Pa(E);
        var z = b.length;
        k = k === n ? z : Ru(rr(k), 0, z);
        var V = k;
        return k -= E.length, k >= 0 && b.slice(k, V) == E;
      }
      function by(b) {
        return b = ia(b), b && po.test(b) ? b.replace(Ar, U0) : b;
      }
      function vy(b) {
        return b = ia(b), b && Lo.test(b) ? b.replace(vu, "\\$&") : b;
      }
      var ZN = Oc(function(b, E, k) {
        return b + (k ? "-" : "") + E.toLowerCase();
      }), sS = Oc(function(b, E, k) {
        return b + (k ? " " : "") + E.toLowerCase();
      }), lS = Uv("toLowerCase");
      function XN(b, E, k) {
        b = ia(b), E = rr(E);
        var z = E ? Zc(b) : 0;
        if (!E || z >= E)
          return b;
        var V = (E - z) / 2;
        return bf(cc(V), k) + b + bf(ul(V), k);
      }
      function qN(b, E, k) {
        b = ia(b), E = rr(E);
        var z = E ? Zc(b) : 0;
        return E && z < E ? b + bf(E - z, k) : b;
      }
      function G7(b, E, k) {
        b = ia(b), E = rr(E);
        var z = E ? Zc(b) : 0;
        return E && z < E ? bf(E - z, k) + b : b;
      }
      function KN(b, E, k) {
        return k || E == null ? E = 0 : E && (E = +E), Iv(ia(b).replace(Pi, ""), E || 0);
      }
      function JN(b, E, k) {
        return (k ? kr(b, E, k) : E === n) ? E = 1 : E = rr(E), Ap(ia(b), E);
      }
      function e2() {
        var b = arguments, E = ia(b[0]);
        return b.length < 3 ? E : E.replace(b[1], b[2]);
      }
      var t2 = Oc(function(b, E, k) {
        return b + (k ? "_" : "") + E.toLowerCase();
      });
      function n2(b, E, k) {
        return k && typeof k != "number" && kr(b, E, k) && (E = k = n), k = k === n ? pe : k >>> 0, k ? (b = ia(b), b && (typeof E == "string" || E != null && !dO(E)) && (E = Pa(E), !E && cp(b)) ? ql(xs(b), 0, k) : b.split(E, k)) : [];
      }
      var r2 = Oc(function(b, E, k) {
        return b + (k ? " " : "") + dS(E);
      });
      function uS(b, E, k) {
        return b = ia(b), k = k == null ? 0 : Ru(rr(k), 0, b.length), E = Pa(E), b.slice(k, k + E.length) == E;
      }
      function a2(b, E, k) {
        var z = re.templateSettings;
        k && kr(b, E, k) && (E = n), b = ia(b), E = Im({}, E, z, $o);
        var V = Im({}, E.imports, z.imports, $o), oe = Ao(V), Ce = Cs(V, oe), Le, Qe, St = 0, Ot = E.interpolate || yt, _t = "__p += '", Vt = Ql(
          (E.escape || yt).source + "|" + Ot.source + "|" + (Ot === gu ? Yn : yt).source + "|" + (E.evaluate || yt).source + "|$",
          "g"
        ), hn = "//# sourceURL=" + (Ur.call(E, "sourceURL") ? (E.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++M0 + "]") + `
`;
        b.replace(Vt, function(jn, yr, Cr, cs, Wa, Us) {
          return Cr || (Cr = cs), _t += b.slice(St, Us).replace(Dt, hg), yr && (Le = !0, _t += `' +
__e(` + yr + `) +
'`), Wa && (Qe = !0, _t += `';
` + Wa + `;
__p += '`), Cr && (_t += `' +
((__t = (` + Cr + `)) == null ? '' : __t) +
'`), St = Us + jn.length, jn;
        }), _t += `';
`;
        var $n = Ur.call(E, "variable") && E.variable;
        if (!$n)
          _t = `with (obj) {
` + _t + `
}
`;
        else if (jt.test($n))
          throw new Kn(s);
        _t = (Qe ? _t.replace(En, "") : _t).replace(Mn, "$1").replace(br, "$1;"), _t = "function(" + ($n || "obj") + `) {
` + ($n ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (Le ? ", __e = _.escape" : "") + (Qe ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + _t + `return __p
}`;
        var lr = lC(function() {
          return Br(oe, hn + "return " + _t).apply(n, Ce);
        });
        if (lr.source = _t, Yp(lr))
          throw lr;
        return lr;
      }
      function i2(b) {
        return ia(b).toLowerCase();
      }
      function cS(b) {
        return ia(b).toUpperCase();
      }
      function o2(b, E, k) {
        if (b = ia(b), b && (k || E === n))
          return Tu(b);
        if (!b || !(E = Pa(E)))
          return b;
        var z = xs(b), V = xs(E), oe = jh(z, V), Ce = Cv(z, V) + 1;
        return ql(z, oe, Ce).join("");
      }
      function fS(b, E, k) {
        if (b = ia(b), b && (k || E === n))
          return b.slice(0, gg(b) + 1);
        if (!b || !(E = Pa(E)))
          return b;
        var z = xs(b), V = Cv(z, xs(E)) + 1;
        return ql(z, 0, V).join("");
      }
      function sC(b, E, k) {
        if (b = ia(b), b && (k || E === n))
          return b.replace(Pi, "");
        if (!b || !(E = Pa(E)))
          return b;
        var z = xs(b), V = jh(z, xs(E));
        return ql(z, V).join("");
      }
      function s2(b, E) {
        var k = Q, z = ne;
        if (ti(E)) {
          var V = "separator" in E ? E.separator : V;
          k = "length" in E ? rr(E.length) : k, z = "omission" in E ? Pa(E.omission) : z;
        }
        b = ia(b);
        var oe = b.length;
        if (cp(b)) {
          var Ce = xs(b);
          oe = Ce.length;
        }
        if (k >= oe)
          return b;
        var Le = k - Zc(z);
        if (Le < 1)
          return z;
        var Qe = Ce ? ql(Ce, 0, Le).join("") : b.slice(0, Le);
        if (V === n)
          return Qe + z;
        if (Ce && (Le += Qe.length - Le), dO(V)) {
          if (b.slice(Le).search(V)) {
            var St, Ot = Qe;
            for (V.global || (V = Ql(V.source, ia(ur.exec(V)) + "g")), V.lastIndex = 0; St = V.exec(Ot); )
              var _t = St.index;
            Qe = Qe.slice(0, _t === n ? Le : _t);
          }
        } else if (b.indexOf(Pa(V), Le) != Le) {
          var Vt = Qe.lastIndexOf(V);
          Vt > -1 && (Qe = Qe.slice(0, Vt));
        }
        return Qe + z;
      }
      function l2(b) {
        return b = ia(b), b && Ji.test(b) ? b.replace(sr, W0) : b;
      }
      var u2 = Oc(function(b, E, k) {
        return b + (k ? " " : "") + E.toUpperCase();
      }), dS = Uv("toUpperCase");
      function pS(b, E, k) {
        return b = ia(b), E = k ? n : E, E === n ? D1(b) ? N1(b) : wv(b) : b.match(E) || [];
      }
      var lC = ir(function(b, E) {
        try {
          return vo(b, n, E);
        } catch (k) {
          return Yp(k) ? k : new Kn(k);
        }
      }), c2 = Nu(function(b, E) {
        return yo(E, function(k) {
          k = Bo(k), Vl(b, k, At(b[k], b));
        }), b;
      });
      function f2(b) {
        var E = b == null ? 0 : b.length, k = Cn();
        return b = E ? Hr(b, function(z) {
          if (typeof z[1] != "function")
            throw new As(o);
          return [k(z[0]), z[1]];
        }) : [], ir(function(z) {
          for (var V = -1; ++V < E; ) {
            var oe = b[V];
            if (vo(oe[0], this, z))
              return vo(oe[1], this, z);
          }
        });
      }
      function d2(b) {
        return Y0(Fo(b, m));
      }
      function hS(b) {
        return function() {
          return b;
        };
      }
      function p2(b, E) {
        return b == null || b !== b ? E : b;
      }
      var h2 = vd(), mS = vd(!0);
      function Sl(b) {
        return b;
      }
      function gS(b) {
        return im(typeof b == "function" ? b : Fo(b, m));
      }
      function m2(b) {
        return Cp(Fo(b, m));
      }
      function g2(b, E) {
        return gl(b, Fo(E, m));
      }
      var b2 = ir(function(b, E) {
        return function(k) {
          return sf(k, b, E);
        };
      }), v2 = ir(function(b, E) {
        return function(k) {
          return sf(b, k, E);
        };
      });
      function bS(b, E, k) {
        var z = Ao(E), V = Ia(E, z);
        k == null && !(ti(E) && (V.length || !z.length)) && (k = E, E = b, b = this, V = Ia(E, Ao(E)));
        var oe = !(ti(k) && "chain" in k) || !!k.chain, Ce = kf(b);
        return yo(V, function(Le) {
          var Qe = E[Le];
          b[Le] = Qe, Ce && (b.prototype[Le] = function() {
            var St = this.__chain__;
            if (oe || St) {
              var Ot = b(this.__wrapped__), _t = Ot.__actions__ = Ci(this.__actions__);
              return _t.push({ func: Qe, args: arguments, thisArg: b }), Ot.__chain__ = St, Ot;
            }
            return Qe.apply(b, Su([this.value()], arguments));
          });
        }), b;
      }
      function y2() {
        return Ta._ === this && (Ta._ = kv), this;
      }
      function vS() {
      }
      function uC(b) {
        return b = rr(b), ir(function(E) {
          return ff(E, b);
        });
      }
      var yS = Bg(Hr), O2 = Bg(zh), E2 = Bg(Ev);
      function yy(b) {
        return Hg(b) ? Qh(Bo(b)) : cr(b);
      }
      function Oy(b) {
        return function(E) {
          return b == null ? n : za(b, E);
        };
      }
      var S2 = Ug(), w2 = Ug(!0);
      function OS() {
        return [];
      }
      function ES() {
        return !1;
      }
      function T2() {
        return {};
      }
      function _2() {
        return "";
      }
      function C2() {
        return !0;
      }
      function cC(b, E) {
        if (b = rr(b), b < 1 || b > le)
          return [];
        var k = pe, z = Bi(b, pe);
        E = Cn(E), b -= pe;
        for (var V = pg(z, E); ++k < b; )
          E(k);
        return V;
      }
      function x2(b) {
        return or(b) ? Hr(b, Bo) : Sr(b) ? [b] : Ci(Vv(ia(b)));
      }
      function A2(b) {
        var E = ++od;
        return ia(b) + E;
      }
      var k2 = $g(function(b, E) {
        return b + E;
      }, 0), R2 = Ka("ceil"), I2 = $g(function(b, E) {
        return b / E;
      }, 1), D2 = Ka("floor");
      function N2(b) {
        return b && b.length ? Ns(b, Sl, Yl) : n;
      }
      function P2(b, E) {
        return b && b.length ? Ns(b, Cn(E, 2), Yl) : n;
      }
      function L2(b) {
        return $0(b, Sl);
      }
      function M2(b, E) {
        return $0(b, Cn(E, 2));
      }
      function F2(b) {
        return b && b.length ? Ns(b, Sl, uf) : n;
      }
      function $2(b, E) {
        return b && b.length ? Ns(b, Cn(E, 2), uf) : n;
      }
      var B2 = $g(function(b, E) {
        return b * E;
      }, 1), U2 = Ka("round"), z2 = $g(function(b, E) {
        return b - E;
      }, 0);
      function H2(b) {
        return b && b.length ? sp(b, Sl) : 0;
      }
      function db(b, E) {
        return b && b.length ? sp(b, Cn(E, 2)) : 0;
      }
      return re.after = Se, re.ary = Pe, re.assign = Ol, re.assignIn = ub, re.assignInWith = Im, re.assignWith = qp, re.at = X_, re.before = nt, re.bind = At, re.bindAll = c2, re.bindKey = It, re.castArray = H_, re.chain = Bs, re.chunk = Qg, re.compact = Em, re.concat = Xv, re.cond = f2, re.conforms = d2, re.constant = hS, re.countBy = oO, re.create = Dm, re.curry = kt, re.curryRight = en, re.debounce = dn, re.defaults = Nm, re.defaultsDeep = mO, re.defer = mn, re.delay = ci, re.difference = _o, re.differenceBy = mr, re.differenceWith = Ha, re.drop = Ja, re.dropRight = Qi, re.dropRightWhile = $s, re.dropWhile = Up, re.fill = ki, re.filter = sO, re.flatMap = lO, re.flatMapDeep = oy, re.flatMapDepth = uO, re.flatten = Sm, re.flattenDeep = Hp, re.flattenDepth = Sd, re.flip = Ze, re.flow = h2, re.flowRight = mS, re.fromPairs = Uo, re.functions = J_, re.functionsIn = FN, re.groupBy = Tc, re.initial = wc, re.intersection = Gg, re.intersectionBy = wd, re.intersectionWith = Fu, re.invert = eC, re.invertBy = $N, re.invokeMap = rb, re.iteratee = gS, re.keyBy = cO, re.keys = Ao, re.keysIn = El, re.map = ab, re.mapKeys = BN, re.mapValues = UN, re.matches = m2, re.matchesProperty = g2, re.memoize = Me, re.merge = zN, re.mergeWith = tC, re.method = b2, re.methodOf = v2, re.mixin = bS, re.negate = Xe, re.nthArg = uC, re.omit = HN, re.omitBy = WN, re.once = Ft, re.orderBy = ib, re.over = yS, re.overArgs = yn, re.overEvery = O2, re.overSome = E2, re.partial = cn, re.partialRight = wn, re.partition = V1, re.pick = QN, re.pickBy = nC, re.property = yy, re.propertyOf = Oy, re.pull = Yg, re.pullAll = wf, re.pullAllBy = Td, re.pullAllWith = Co, re.pullAt = yi, re.range = S2, re.rangeRight = w2, re.rearg = Qn, re.reject = ob, re.remove = xo, re.rest = Gi, re.reverse = ji, re.sampleSize = h, re.set = iS, re.setWith = oS, re.shuffle = S, re.slice = jp, re.sortBy = U, re.sortedUniq = Tf, re.sortedUniqBy = Jv, re.split = n2, re.spread = Rr, re.tail = _d, re.take = rO, re.takeRight = Zg, re.takeRightWhile = ey, re.takeWhile = Xg, re.tap = ay, re.throttle = xf, re.thru = Kg, re.toArray = lb, re.toPairs = OO, re.toPairsIn = rC, re.toPath = x2, re.toPlainObject = tS, re.transform = py, re.unary = Z1, re.union = B1, re.unionBy = U1, re.unionWith = aO, re.uniq = ty, re.uniqBy = Cd, re.uniqWith = z1, re.unset = hy, re.unzip = _f, re.unzipWith = ny, re.update = jN, re.updateWith = aC, re.values = fb, re.valuesIn = GN, re.without = ei, re.words = pS, re.wrap = wN, re.xor = H1, re.xorBy = qg, re.xorWith = W1, re.zip = Q1, re.zipObject = iO, re.zipObjectDeep = ry, re.zipWith = j1, re.entries = OO, re.entriesIn = rC, re.extend = ub, re.extendWith = Im, bS(re, re), re.add = k2, re.attempt = lC, re.camelCase = oC, re.capitalize = my, re.ceil = R2, re.clamp = iC, re.clone = W_, re.cloneDeep = _N, re.cloneDeepWith = Q_, re.cloneWith = TN, re.conformsTo = X1, re.deburr = gy, re.defaultTo = p2, re.divide = I2, re.endsWith = EO, re.eq = _c, re.escape = by, re.escapeRegExp = vy, re.every = iy, re.find = Cm, re.findIndex = zp, re.findKey = nS, re.findLast = tb, re.findLastIndex = Mu, re.findLastKey = gO, re.floor = D2, re.forEach = nb, re.forEachRight = xm, re.forIn = dy, re.forInRight = q_, re.forOwn = bO, re.forOwnRight = K_, re.get = rS, re.gt = CN, re.gte = xN, re.has = vO, re.hasIn = cb, re.head = jg, re.identity = Sl, re.includes = sy, re.indexOf = Wp, re.inRange = VN, re.invoke = yO, re.isArguments = Am, re.isArray = or, re.isArrayBuffer = AN, re.isArrayLike = io, re.isArrayLikeObject = fi, re.isBoolean = ly, re.isBuffer = Af, re.isDate = kN, re.isElement = RN, re.isEmpty = j_, re.isEqual = IN, re.isEqualWith = fO, re.isError = Yp, re.isFinite = q1, re.isFunction = kf, re.isInteger = uy, re.isLength = cy, re.isMap = K1, re.isMatch = G_, re.isMatchWith = V_, re.isNaN = Zp, re.isNative = DN, re.isNil = PN, re.isNull = NN, re.isNumber = sb, re.isObject = ti, re.isObjectLike = di, re.isPlainObject = km, re.isRegExp = dO, re.isSafeInteger = LN, re.isSet = J1, re.isString = pO, re.isSymbol = Sr, re.isTypedArray = Xp, re.isUndefined = hO, re.isWeakMap = fy, re.isWeakSet = Y_, re.join = Sf, re.kebabCase = ZN, re.last = Ri, re.lastIndexOf = Vg, re.lowerCase = sS, re.lowerFirst = lS, re.lt = Z_, re.lte = eS, re.max = N2, re.maxBy = P2, re.mean = L2, re.meanBy = M2, re.min = F2, re.minBy = $2, re.stubArray = OS, re.stubFalse = ES, re.stubObject = T2, re.stubString = _2, re.stubTrue = C2, re.multiply = B2, re.nth = Qp, re.noConflict = y2, re.noop = vS, re.now = X, re.pad = XN, re.padEnd = qN, re.padStart = G7, re.parseInt = KN, re.random = YN, re.reduce = Vp, re.reduceRight = Y1, re.repeat = JN, re.replace = e2, re.result = aS, re.round = U2, re.runInContext = We, re.sample = d, re.size = x, re.snakeCase = t2, re.some = F, re.sortedIndex = qv, re.sortedIndexBy = wm, re.sortedIndexOf = Kv, re.sortedLastIndex = yl, re.sortedLastIndexBy = nO, re.sortedLastIndexOf = Gp, re.startCase = r2, re.startsWith = uS, re.subtract = z2, re.sum = H2, re.sumBy = db, re.template = a2, re.times = cC, re.toFinite = kd, re.toInteger = rr, re.toLength = Rm, re.toLower = i2, re.toNumber = $u, re.toSafeInteger = MN, re.toString = ia, re.toUpper = cS, re.trim = o2, re.trimEnd = fS, re.trimStart = sC, re.truncate = s2, re.unescape = l2, re.uniqueId = A2, re.upperCase = u2, re.upperFirst = dS, re.each = nb, re.eachRight = xm, re.first = jg, bS(re, function() {
        var b = {};
        return da(re, function(E, k) {
          Ur.call(re.prototype, k) || (b[k] = E);
        }), b;
      }(), { chain: !1 }), re.VERSION = r, yo(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(b) {
        re[b].placeholder = re;
      }), yo(["drop", "take"], function(b, E) {
        ar.prototype[b] = function(k) {
          k = k === n ? 1 : li(rr(k), 0);
          var z = this.__filtered__ && !E ? new ar(this) : this.clone();
          return z.__filtered__ ? z.__takeCount__ = Bi(k, z.__takeCount__) : z.__views__.push({
            size: Bi(k, pe),
            type: b + (z.__dir__ < 0 ? "Right" : "")
          }), z;
        }, ar.prototype[b + "Right"] = function(k) {
          return this.reverse()[b](k).reverse();
        };
      }), yo(["filter", "map", "takeWhile"], function(b, E) {
        var k = E + 1, z = k == ee || k == de;
        ar.prototype[b] = function(V) {
          var oe = this.clone();
          return oe.__iteratees__.push({
            iteratee: Cn(V, 3),
            type: k
          }), oe.__filtered__ = oe.__filtered__ || z, oe;
        };
      }), yo(["head", "last"], function(b, E) {
        var k = "take" + (E ? "Right" : "");
        ar.prototype[b] = function() {
          return this[k](1).value()[0];
        };
      }), yo(["initial", "tail"], function(b, E) {
        var k = "drop" + (E ? "" : "Right");
        ar.prototype[b] = function() {
          return this.__filtered__ ? new ar(this) : this[k](1);
        };
      }), ar.prototype.compact = function() {
        return this.filter(Sl);
      }, ar.prototype.find = function(b) {
        return this.filter(b).head();
      }, ar.prototype.findLast = function(b) {
        return this.reverse().find(b);
      }, ar.prototype.invokeMap = ir(function(b, E) {
        return typeof b == "function" ? new ar(this) : this.map(function(k) {
          return sf(k, b, E);
        });
      }), ar.prototype.reject = function(b) {
        return this.filter(Xe(Cn(b)));
      }, ar.prototype.slice = function(b, E) {
        b = rr(b);
        var k = this;
        return k.__filtered__ && (b > 0 || E < 0) ? new ar(k) : (b < 0 ? k = k.takeRight(-b) : b && (k = k.drop(b)), E !== n && (E = rr(E), k = E < 0 ? k.dropRight(-E) : k.take(E - b)), k);
      }, ar.prototype.takeRightWhile = function(b) {
        return this.reverse().takeWhile(b).reverse();
      }, ar.prototype.toArray = function() {
        return this.take(pe);
      }, da(ar.prototype, function(b, E) {
        var k = /^(?:filter|find|map|reject)|While$/.test(E), z = /^(?:head|last)$/.test(E), V = re[z ? "take" + (E == "last" ? "Right" : "") : E], oe = z || /^find/.test(E);
        V && (re.prototype[E] = function() {
          var Ce = this.__wrapped__, Le = z ? [1] : arguments, Qe = Ce instanceof ar, St = Le[0], Ot = Qe || or(Ce), _t = function(yr) {
            var Cr = V.apply(re, Su([yr], Le));
            return z && Vt ? Cr[0] : Cr;
          };
          Ot && k && typeof St == "function" && St.length != 1 && (Qe = Ot = !1);
          var Vt = this.__chain__, hn = !!this.__actions__.length, $n = oe && !Vt, lr = Qe && !hn;
          if (!oe && Ot) {
            Ce = lr ? Ce : new ar(this);
            var jn = b.apply(Ce, Le);
            return jn.__actions__.push({ func: Kg, args: [_t], thisArg: n }), new Oo(jn, Vt);
          }
          return $n && lr ? b.apply(this, Le) : (jn = this.thru(_t), $n ? z ? jn.value()[0] : jn.value() : jn);
        });
      }), yo(["pop", "push", "shift", "sort", "splice", "unshift"], function(b) {
        var E = as[b], k = /^(?:push|sort|unshift)$/.test(b) ? "tap" : "thru", z = /^(?:pop|shift)$/.test(b);
        re.prototype[b] = function() {
          var V = arguments;
          if (z && !this.__chain__) {
            var oe = this.value();
            return E.apply(or(oe) ? oe : [], V);
          }
          return this[k](function(Ce) {
            return E.apply(or(Ce) ? Ce : [], V);
          });
        };
      }), da(ar.prototype, function(b, E) {
        var k = re[E];
        if (k) {
          var z = k.name + "";
          Ur.call(Ep, z) || (Ep[z] = []), Ep[z].push({ name: E, func: k });
        }
      }), Ep[gf(n, A).name] = [{
        name: "wrapper",
        func: n
      }], ar.prototype.clone = xn, ar.prototype.reverse = tf, ar.prototype.value = _a, re.prototype.at = Cf, re.prototype.chain = Jg, re.prototype.commit = xd, re.prototype.next = Tm, re.prototype.plant = Ad, re.prototype.reverse = G1, re.prototype.toJSON = re.prototype.valueOf = re.prototype.value = eb, re.prototype.first = re.prototype.head, uc && (re.prototype[uc] = _m), re;
    }, pp = P1();
    Hl ? ((Hl.exports = pp)._ = pp, rd._ = pp) : Ta._ = pp;
  }).call($b);
})(Qk, Qk.exports);
var B5 = Qk.exports;
const Abe = "accordion-wizard", a1 = bs(
  ({
    autoExpanded: t = !0,
    enableKeyNavigation: e = !1,
    className: n,
    children: r,
    ...a
  }, i) => {
    const [o, s, u] = zk([]), f = dr(!1), p = Ei((N, P) => {
      s((I) => (I[P] = N, I)), P === 0 && !f.current && (f.current = !0, C((I) => ({
        ...I,
        enabledUids: [...I.enabledUids, N],
        activeUid: t ? N : void 0
      })));
    }, [r]);
    function m(N) {
      N && C((P) => ({
        ...P,
        enabledUids: B5.uniq([...P.enabledUids, N]),
        activeUid: N
      }));
    }
    function v(N) {
      N && C((P) => ({
        ...P,
        enabledUids: [...P.enabledUids, N]
      }));
    }
    function O(N) {
      return typeof N == "number" ? u.current[N] : N;
    }
    function w() {
      const N = u.current, P = A.current.activeUid === void 0 ? -1 : N.indexOf(A.current.activeUid);
      return N[P + 1];
    }
    const [_, C, A] = zk({
      disableInactiveStepRendering: !1,
      mode: "accordion",
      enableKeyNavigation: e,
      enabledUids: [],
      activateStep(N) {
        m(O(N));
      },
      activateNextStep() {
        m(w());
      },
      activatePreviousStep() {
        if (A.current.activeUid === void 0)
          return;
        const N = u.current, P = N.indexOf(A.current.activeUid), I = N[P - 1];
        m(I);
      },
      enableStep(N) {
        v(O(N));
      },
      disableStep(N) {
        let P = O(N);
        P && C((I) => ({
          ...I,
          enabledUids: I.enabledUids.filter((D) => D !== P)
        }));
      },
      enableNextStep() {
        v(w());
      }
    });
    return Nl(i, () => ({
      activateNextStep() {
        A.current.activateNextStep();
      },
      activatePreviousStep() {
        A.current.activatePreviousStep();
      },
      enableNextStep() {
        A.current.enableNextStep();
      },
      enableStep(N) {
        A.current.enableStep(N);
      },
      get activeStep() {
        return A.current.activeUid;
      },
      set activeStep(N) {
        u.current.includes(N) || (N = void 0), C((P) => ({
          ...P,
          activeUid: N
        }));
      },
      get activeStepIndex() {
        if (A.current.activeUid)
          return u.current.indexOf(A.current.activeUid);
      },
      set activeStepIndex(N) {
        const P = u.current[N];
        C((I) => ({
          ...I,
          activeUid: P
        }));
      }
    }), []), Vn(() => {
      s([]);
    }, [r]), /* @__PURE__ */ Ne.jsx("div", { className: pn(Abe, n), ...a, children: /* @__PURE__ */ Ne.jsx(S0.Provider, { value: _, children: Wee.map(r, (N, P) => $I(N, {
      ref: (I) => p(I == null ? void 0 : I.uid, P)
    })) }) });
  }
);
a1.displayName = "AccordionWizard";
a1.Header = k5;
a1.Content = R5;
a1.Actions = $5;
a1.Step = A5;
a1.Message = BI;
const kG = "tab-wizard", i1 = bs(
  ({
    autoExpanded: t = !0,
    enableKeyNavigation: e = !1,
    className: n,
    children: r,
    disableInactiveStepRendering: a = !1,
    ...i
  }, o) => {
    const [s, u, f] = zk([]), p = dr([]), m = dr(!1);
    Vn(() => {
      const M = Ge.Children.count(r);
      p.current = p.current.slice(0, M), u((H) => H.slice(0, M));
    }, [r]);
    function v(M, H) {
      H && (p.current[M] = H.uid, u((Y) => (Y[M] = H, [...Y])), N((Y) => Y.enabledUids.includes(H.uid) ? Y : (M === 0 && t && !m.current ? (Y.activeUid = H.uid, Y.enabledUids = [...Y.enabledUids, H.uid]) : H.enabled && (Y.enabledUids = [...Y.enabledUids, H.uid]), { ...Y })), M === 0 && !m.current && (m.current = !0));
    }
    function O(M) {
      M && N((H) => ({
        ...H,
        enabledUids: B5.uniq([...H.enabledUids, M]),
        activeUid: M
      }));
    }
    function w(M) {
      M && N((H) => ({
        ...H,
        enabledUids: [...H.enabledUids, M]
      }));
    }
    function _(M) {
      return typeof M == "number" ? p.current[M] : M;
    }
    function C() {
      var Y;
      let M = P.current.activeUid === void 0 ? -1 : p.current.indexOf(P.current.activeUid);
      for (; (Y = f.current[M + 1]) != null && Y.exclude; )
        M++;
      return p.current[M + 1];
    }
    const [A, N, P] = zk({
      mode: "tab",
      disableInactiveStepRendering: a,
      enableKeyNavigation: e,
      enabledUids: [],
      activateStep(M) {
        O(_(M));
      },
      activateNextStep() {
        O(C());
      },
      activatePreviousStep() {
        if (P.current.activeUid === void 0)
          return;
        const M = p.current.indexOf(P.current.activeUid), H = p.current[M - 1];
        O(H);
      },
      enableStep(M) {
        w(_(M));
      },
      disableStep(M) {
        let H = _(M);
        H && N((Y) => ({
          ...Y,
          enabledUids: Y.enabledUids.filter((q) => q !== H)
        }));
      },
      enableNextStep() {
        w(C());
      }
    }), I = (M, H = !1) => {
      const Y = p.current[M], q = H ? [Y] : p.current.slice(0, M + 1);
      N((Q) => ({
        ...Q,
        activeUid: Y,
        enabledUids: q
      }));
    };
    Vn(() => {
      N((M) => ({
        ...M,
        disableInactiveStepRendering: a
      }));
    }, [a]), Nl(o, () => ({
      activateNextStep() {
        P.current.activateNextStep();
      },
      activatePreviousStep() {
        P.current.activatePreviousStep();
      },
      enableNextStep() {
        P.current.enableNextStep();
      },
      enableStep(M) {
        P.current.enableStep(M);
      },
      disableStep(M) {
        P.current.disableStep(M);
      },
      get activeStep() {
        return P.current.activeUid;
      },
      set activeStep(M) {
        p.current.includes(M) || (M = void 0), N((H) => ({
          ...H,
          activeUid: M
        }));
      },
      get activeStepIndex() {
        if (P.current.activeUid)
          return p.current.indexOf(P.current.activeUid);
      },
      set activeStepIndex(M) {
        const H = p.current[M];
        N((Y) => ({
          ...Y,
          activeUid: H
        }));
      },
      goToStepByIndex: I
    }), []);
    const D = Ge.useMemo(() => Wee.map(r, (M, H) => M && $I(M, {
      ref: (Y) => v(H, Y)
    })), [r]);
    return /* @__PURE__ */ Ne.jsx("div", { className: pn(kG, n), ...i, children: /* @__PURE__ */ Ne.jsxs(S0.Provider, { value: A, children: [
      /* @__PURE__ */ Ne.jsx("div", { className: `${kG}__tabs`, children: s.filter((M) => !(M != null && M.exclude)).map((M, H) => /* @__PURE__ */ Ne.jsx(
        kbe,
        {
          active: A.activeUid === M.uid,
          disabled: !A.enabledUids.includes(M.uid),
          onClick: () => A.activateStep(M.uid),
          children: M.title ?? `Step ${H + 1}`
        },
        H
      )) }),
      D
    ] }) });
  }
);
function kbe({ title: t, active: e, disabled: n, onClick: r, children: a = t, disabledTip: i }) {
  const o = "tab-wizard-tab";
  function s() {
    n || r == null || r();
  }
  return /* @__PURE__ */ Ne.jsx("div", { className: pn(o, {
    [`${o}--active`]: e,
    [`${o}--disabled`]: n,
    [`${o}--enabled`]: !n
  }), onClick: s, children: /* @__PURE__ */ Ne.jsx("div", { className: `${o}__content`, children: a }) });
}
i1.displayName = "TabWizard";
i1.Header = k5;
i1.Content = R5;
i1.Actions = $5;
i1.Step = A5;
i1.Message = BI;
const Rbe = [750, 0];
function _Xe({
  onChange: t,
  name: e,
  label: n,
  value: r,
  className: a,
  disabled: i,
  checked: o,
  disabledTip: s,
  // the constant must be used instead of an inline value to prevent the component from rerendering
  tipDelay: u = Rbe,
  tipLocation: f = "bottom",
  labelRef: p,
  byzRef: m,
  inputRef: v = m,
  ...O
}) {
  const w = "byz-checkbox", [_, C] = kn(""), A = dr(null);
  Vn(() => {
    C(r ?? "");
  }, [r]);
  function N(P) {
    t ? t({
      value: P.target.value,
      checked: P.target.checked,
      sourceEvent: P,
      name: e
    }) : C(P.target.value);
  }
  return /* @__PURE__ */ Ne.jsxs(Ne.Fragment, { children: [
    /* @__PURE__ */ Ne.jsxs("label", { ref: A, className: pn(w, a, {
      [`${w}--disabled`]: i
    }), ...O, children: [
      /* @__PURE__ */ Ne.jsx(
        "input",
        {
          type: "checkbox",
          name: e,
          className: `${w}__input`,
          ref: v,
          onChange: N,
          value: _,
          disabled: i,
          checked: o
        }
      ),
      /* @__PURE__ */ Ne.jsx("div", { className: `${w}__toggle` }),
      n && /* @__PURE__ */ Ne.jsx("div", { className: `${w}__label`, children: n })
    ] }),
    !!(s && i) && /* @__PURE__ */ Ne.jsx(
      r1,
      {
        content: s,
        className: pn(`${w}__tippy-container`),
        reference: A,
        placement: f,
        delay: u
      }
    )
  ] });
}
function i0(t) {
  "@babel/helpers - typeof";
  return i0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, i0(t);
}
function Ibe(t, e) {
  if (i0(t) != "object" || !t)
    return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(t, e || "default");
    if (i0(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function Ete(t) {
  var e = Ibe(t, "string");
  return i0(e) == "symbol" ? e : e + "";
}
function hE(t, e, n) {
  return e = Ete(e), e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function RG(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Hn(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? RG(Object(n), !0).forEach(function(r) {
      hE(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : RG(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function Dbe(t) {
  if (Array.isArray(t))
    return t;
}
function Nbe(t, e) {
  var n = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n != null) {
    var r, a, i, o, s = [], u = !0, f = !1;
    try {
      if (i = (n = n.call(t)).next, e === 0) {
        if (Object(n) !== n)
          return;
        u = !1;
      } else
        for (; !(u = (r = i.call(n)).done) && (s.push(r.value), s.length !== e); u = !0)
          ;
    } catch (p) {
      f = !0, a = p;
    } finally {
      try {
        if (!u && n.return != null && (o = n.return(), Object(o) !== o))
          return;
      } finally {
        if (f)
          throw a;
      }
    }
    return s;
  }
}
function EF(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function Ste(t, e) {
  if (t) {
    if (typeof t == "string")
      return EF(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return EF(t, e);
  }
}
function Pbe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ms(t, e) {
  return Dbe(t) || Nbe(t, e) || Ste(t, e) || Pbe();
}
function qb(t, e) {
  if (t == null)
    return {};
  var n = {};
  for (var r in t)
    if (Object.prototype.hasOwnProperty.call(t, r)) {
      if (e.indexOf(r) >= 0)
        continue;
      n[r] = t[r];
    }
  return n;
}
function lv(t, e) {
  if (t == null)
    return {};
  var n = qb(t, e), r, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (a = 0; a < i.length; a++)
      r = i[a], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (n[r] = t[r]);
  }
  return n;
}
var Lbe = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function HI(t) {
  var e = t.defaultInputValue, n = e === void 0 ? "" : e, r = t.defaultMenuIsOpen, a = r === void 0 ? !1 : r, i = t.defaultValue, o = i === void 0 ? null : i, s = t.inputValue, u = t.menuIsOpen, f = t.onChange, p = t.onInputChange, m = t.onMenuClose, v = t.onMenuOpen, O = t.value, w = lv(t, Lbe), _ = kn(s !== void 0 ? s : n), C = ms(_, 2), A = C[0], N = C[1], P = kn(u !== void 0 ? u : a), I = ms(P, 2), D = I[0], M = I[1], H = kn(O !== void 0 ? O : o), Y = ms(H, 2), q = Y[0], Q = Y[1], ne = Ei(function(le, ye) {
    typeof f == "function" && f(le, ye), Q(le);
  }, [f]), J = Ei(function(le, ye) {
    var B;
    typeof p == "function" && (B = p(le, ye)), N(B !== void 0 ? B : le);
  }, [p]), ue = Ei(function() {
    typeof v == "function" && v(), M(!0);
  }, [v]), ee = Ei(function() {
    typeof m == "function" && m(), M(!1);
  }, [m]), fe = s !== void 0 ? s : A, de = u !== void 0 ? u : D, ie = O !== void 0 ? O : q;
  return Hn(Hn({}, w), {}, {
    inputValue: fe,
    menuIsOpen: de,
    onChange: ne,
    onInputChange: J,
    onMenuClose: ee,
    onMenuOpen: ue,
    value: ie
  });
}
function rn() {
  return rn = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, rn.apply(this, arguments);
}
function Mbe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function IG(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, Ete(r.key), r);
  }
}
function Fbe(t, e, n) {
  return e && IG(t.prototype, e), n && IG(t, n), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function jk(t, e) {
  return jk = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, a) {
    return r.__proto__ = a, r;
  }, jk(t, e);
}
function $be(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && jk(t, e);
}
function Gk(t) {
  return Gk = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Gk(t);
}
function wte() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (wte = function() {
    return !!t;
  })();
}
function CT(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Bbe(t, e) {
  if (e && (i0(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return CT(t);
}
function Ube(t) {
  var e = wte();
  return function() {
    var r = Gk(t), a;
    if (e) {
      var i = Gk(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return Bbe(this, a);
  };
}
function zbe(t) {
  if (Array.isArray(t))
    return EF(t);
}
function Hbe(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null)
    return Array.from(t);
}
function Wbe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Gw(t) {
  return zbe(t) || Hbe(t) || Ste(t) || Wbe();
}
function Qbe(t) {
  if (t.sheet)
    return t.sheet;
  for (var e = 0; e < document.styleSheets.length; e++)
    if (document.styleSheets[e].ownerNode === t)
      return document.styleSheets[e];
}
function jbe(t) {
  var e = document.createElement("style");
  return e.setAttribute("data-emotion", t.key), t.nonce !== void 0 && e.setAttribute("nonce", t.nonce), e.appendChild(document.createTextNode("")), e.setAttribute("data-s", ""), e;
}
var Gbe = /* @__PURE__ */ function() {
  function t(n) {
    var r = this;
    this._insertTag = function(a) {
      var i;
      r.tags.length === 0 ? r.insertionPoint ? i = r.insertionPoint.nextSibling : r.prepend ? i = r.container.firstChild : i = r.before : i = r.tags[r.tags.length - 1].nextSibling, r.container.insertBefore(a, i), r.tags.push(a);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var e = t.prototype;
  return e.hydrate = function(r) {
    r.forEach(this._insertTag);
  }, e.insert = function(r) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(jbe(this));
    var a = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var i = r.charCodeAt(0) === 64 && r.charCodeAt(1) === 105;
      i && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + r + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !i;
    }
    if (this.isSpeedy) {
      var o = Qbe(a);
      try {
        o.insertRule(r, o.cssRules.length);
      } catch (s) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(r) && console.error('There was a problem inserting the following rule: "' + r + '"', s);
      }
    } else
      a.appendChild(document.createTextNode(r));
    this.ctr++;
  }, e.flush = function() {
    this.tags.forEach(function(r) {
      return r.parentNode && r.parentNode.removeChild(r);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, t;
}(), Al = "-ms-", Vk = "-moz-", pa = "-webkit-", U5 = "comm", z5 = "rule", H5 = "decl", Vbe = "@import", Tte = "@keyframes", Ybe = Math.abs, WI = String.fromCharCode, Zbe = Object.assign;
function Xbe(t, e) {
  return qs(t, 0) ^ 45 ? (((e << 2 ^ qs(t, 0)) << 2 ^ qs(t, 1)) << 2 ^ qs(t, 2)) << 2 ^ qs(t, 3) : 0;
}
function _te(t) {
  return t.trim();
}
function qbe(t, e) {
  return (t = e.exec(t)) ? t[0] : t;
}
function wa(t, e, n) {
  return t.replace(e, n);
}
function SF(t, e) {
  return t.indexOf(e);
}
function qs(t, e) {
  return t.charCodeAt(e) | 0;
}
function xT(t, e, n) {
  return t.slice(e, n);
}
function mh(t) {
  return t.length;
}
function W5(t) {
  return t.length;
}
function _x(t, e) {
  return e.push(t), t;
}
function Kbe(t, e) {
  return t.map(e).join("");
}
var QI = 1, $E = 1, Cte = 0, rc = 0, Io = 0, o1 = "";
function jI(t, e, n, r, a, i, o) {
  return { value: t, root: e, parent: n, type: r, props: a, children: i, line: QI, column: $E, length: o, return: "" };
}
function cw(t, e) {
  return Zbe(jI("", null, null, "", null, null, 0), t, { length: -t.length }, e);
}
function Jbe() {
  return Io;
}
function eve() {
  return Io = rc > 0 ? qs(o1, --rc) : 0, $E--, Io === 10 && ($E = 1, QI--), Io;
}
function Hc() {
  return Io = rc < Cte ? qs(o1, rc++) : 0, $E++, Io === 10 && ($E = 1, QI++), Io;
}
function _h() {
  return qs(o1, rc);
}
function EA() {
  return rc;
}
function p_(t, e) {
  return xT(o1, t, e);
}
function AT(t) {
  switch (t) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function xte(t) {
  return QI = $E = 1, Cte = mh(o1 = t), rc = 0, [];
}
function Ate(t) {
  return o1 = "", t;
}
function SA(t) {
  return _te(p_(rc - 1, wF(t === 91 ? t + 2 : t === 40 ? t + 1 : t)));
}
function tve(t) {
  for (; (Io = _h()) && Io < 33; )
    Hc();
  return AT(t) > 2 || AT(Io) > 3 ? "" : " ";
}
function nve(t, e) {
  for (; --e && Hc() && !(Io < 48 || Io > 102 || Io > 57 && Io < 65 || Io > 70 && Io < 97); )
    ;
  return p_(t, EA() + (e < 6 && _h() == 32 && Hc() == 32));
}
function wF(t) {
  for (; Hc(); )
    switch (Io) {
      case t:
        return rc;
      case 34:
      case 39:
        t !== 34 && t !== 39 && wF(Io);
        break;
      case 40:
        t === 41 && wF(t);
        break;
      case 92:
        Hc();
        break;
    }
  return rc;
}
function rve(t, e) {
  for (; Hc() && t + Io !== 47 + 10; )
    if (t + Io === 42 + 42 && _h() === 47)
      break;
  return "/*" + p_(e, rc - 1) + "*" + WI(t === 47 ? t : Hc());
}
function ave(t) {
  for (; !AT(_h()); )
    Hc();
  return p_(t, rc);
}
function ive(t) {
  return Ate(wA("", null, null, null, [""], t = xte(t), 0, [0], t));
}
function wA(t, e, n, r, a, i, o, s, u) {
  for (var f = 0, p = 0, m = o, v = 0, O = 0, w = 0, _ = 1, C = 1, A = 1, N = 0, P = "", I = a, D = i, M = r, H = P; C; )
    switch (w = N, N = Hc()) {
      case 40:
        if (w != 108 && qs(H, m - 1) == 58) {
          SF(H += wa(SA(N), "&", "&\f"), "&\f") != -1 && (A = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        H += SA(N);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        H += tve(w);
        break;
      case 92:
        H += nve(EA() - 1, 7);
        continue;
      case 47:
        switch (_h()) {
          case 42:
          case 47:
            _x(ove(rve(Hc(), EA()), e, n), u);
            break;
          default:
            H += "/";
        }
        break;
      case 123 * _:
        s[f++] = mh(H) * A;
      case 125 * _:
      case 59:
      case 0:
        switch (N) {
          case 0:
          case 125:
            C = 0;
          case 59 + p:
            O > 0 && mh(H) - m && _x(O > 32 ? NG(H + ";", r, n, m - 1) : NG(wa(H, " ", "") + ";", r, n, m - 2), u);
            break;
          case 59:
            H += ";";
          default:
            if (_x(M = DG(H, e, n, f, p, a, s, P, I = [], D = [], m), i), N === 123)
              if (p === 0)
                wA(H, e, M, M, I, i, m, s, D);
              else
                switch (v === 99 && qs(H, 3) === 110 ? 100 : v) {
                  case 100:
                  case 109:
                  case 115:
                    wA(t, M, M, r && _x(DG(t, M, M, 0, 0, a, s, P, a, I = [], m), D), a, D, m, s, r ? I : D);
                    break;
                  default:
                    wA(H, M, M, M, [""], D, 0, s, D);
                }
        }
        f = p = O = 0, _ = A = 1, P = H = "", m = o;
        break;
      case 58:
        m = 1 + mh(H), O = w;
      default:
        if (_ < 1) {
          if (N == 123)
            --_;
          else if (N == 125 && _++ == 0 && eve() == 125)
            continue;
        }
        switch (H += WI(N), N * _) {
          case 38:
            A = p > 0 ? 1 : (H += "\f", -1);
            break;
          case 44:
            s[f++] = (mh(H) - 1) * A, A = 1;
            break;
          case 64:
            _h() === 45 && (H += SA(Hc())), v = _h(), p = m = mh(P = H += ave(EA())), N++;
            break;
          case 45:
            w === 45 && mh(H) == 2 && (_ = 0);
        }
    }
  return i;
}
function DG(t, e, n, r, a, i, o, s, u, f, p) {
  for (var m = a - 1, v = a === 0 ? i : [""], O = W5(v), w = 0, _ = 0, C = 0; w < r; ++w)
    for (var A = 0, N = xT(t, m + 1, m = Ybe(_ = o[w])), P = t; A < O; ++A)
      (P = _te(_ > 0 ? v[A] + " " + N : wa(N, /&\f/g, v[A]))) && (u[C++] = P);
  return jI(t, e, n, a === 0 ? z5 : s, u, f, p);
}
function ove(t, e, n) {
  return jI(t, e, n, U5, WI(Jbe()), xT(t, 2, -2), 0);
}
function NG(t, e, n, r) {
  return jI(t, e, n, H5, xT(t, 0, r), xT(t, r + 1, -1), r);
}
function SE(t, e) {
  for (var n = "", r = W5(t), a = 0; a < r; a++)
    n += e(t[a], a, t, e) || "";
  return n;
}
function sve(t, e, n, r) {
  switch (t.type) {
    case Vbe:
    case H5:
      return t.return = t.return || t.value;
    case U5:
      return "";
    case Tte:
      return t.return = t.value + "{" + SE(t.children, r) + "}";
    case z5:
      t.value = t.props.join(",");
  }
  return mh(n = SE(t.children, r)) ? t.return = t.value + "{" + n + "}" : "";
}
function lve(t) {
  var e = W5(t);
  return function(n, r, a, i) {
    for (var o = "", s = 0; s < e; s++)
      o += t[s](n, r, a, i) || "";
    return o;
  };
}
function uve(t) {
  return function(e) {
    e.root || (e = e.return) && t(e);
  };
}
function cve(t) {
  var e = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return e[n] === void 0 && (e[n] = t(n)), e[n];
  };
}
var fve = function(e, n, r) {
  for (var a = 0, i = 0; a = i, i = _h(), a === 38 && i === 12 && (n[r] = 1), !AT(i); )
    Hc();
  return p_(e, rc);
}, dve = function(e, n) {
  var r = -1, a = 44;
  do
    switch (AT(a)) {
      case 0:
        a === 38 && _h() === 12 && (n[r] = 1), e[r] += fve(rc - 1, n, r);
        break;
      case 2:
        e[r] += SA(a);
        break;
      case 4:
        if (a === 44) {
          e[++r] = _h() === 58 ? "&\f" : "", n[r] = e[r].length;
          break;
        }
      default:
        e[r] += WI(a);
    }
  while (a = Hc());
  return e;
}, pve = function(e, n) {
  return Ate(dve(xte(e), n));
}, PG = /* @__PURE__ */ new WeakMap(), hve = function(e) {
  if (!(e.type !== "rule" || !e.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  e.length < 1)) {
    for (var n = e.value, r = e.parent, a = e.column === r.column && e.line === r.line; r.type !== "rule"; )
      if (r = r.parent, !r)
        return;
    if (!(e.props.length === 1 && n.charCodeAt(0) !== 58 && !PG.get(r)) && !a) {
      PG.set(e, !0);
      for (var i = [], o = pve(n, i), s = r.props, u = 0, f = 0; u < o.length; u++)
        for (var p = 0; p < s.length; p++, f++)
          e.props[f] = i[u] ? o[u].replace(/&\f/g, s[p]) : s[p] + " " + o[u];
    }
  }
}, mve = function(e) {
  if (e.type === "decl") {
    var n = e.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (e.return = "", e.value = "");
  }
}, gve = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", bve = function(e) {
  return e.type === "comm" && e.children.indexOf(gve) > -1;
}, vve = function(e) {
  return function(n, r, a) {
    if (!(n.type !== "rule" || e.compat)) {
      var i = n.value.match(/(:first|:nth|:nth-last)-child/g);
      if (i) {
        for (var o = n.parent === a[0], s = o ? a[0].children : (
          // global rule at the root level
          a
        ), u = s.length - 1; u >= 0; u--) {
          var f = s[u];
          if (f.line < n.line)
            break;
          if (f.column < n.column) {
            if (bve(f))
              return;
            break;
          }
        }
        i.forEach(function(p) {
          console.error('The pseudo class "' + p + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + p.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, kte = function(e) {
  return e.type.charCodeAt(1) === 105 && e.type.charCodeAt(0) === 64;
}, yve = function(e, n) {
  for (var r = e - 1; r >= 0; r--)
    if (!kte(n[r]))
      return !0;
  return !1;
}, LG = function(e) {
  e.type = "", e.value = "", e.return = "", e.children = "", e.props = "";
}, Ove = function(e, n, r) {
  kte(e) && (e.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), LG(e)) : yve(n, r) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), LG(e)));
};
function Rte(t, e) {
  switch (Xbe(t, e)) {
    case 5103:
      return pa + "print-" + t + t;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return pa + t + t;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return pa + t + Vk + t + Al + t + t;
    case 6828:
    case 4268:
      return pa + t + Al + t + t;
    case 6165:
      return pa + t + Al + "flex-" + t + t;
    case 5187:
      return pa + t + wa(t, /(\w+).+(:[^]+)/, pa + "box-$1$2" + Al + "flex-$1$2") + t;
    case 5443:
      return pa + t + Al + "flex-item-" + wa(t, /flex-|-self/, "") + t;
    case 4675:
      return pa + t + Al + "flex-line-pack" + wa(t, /align-content|flex-|-self/, "") + t;
    case 5548:
      return pa + t + Al + wa(t, "shrink", "negative") + t;
    case 5292:
      return pa + t + Al + wa(t, "basis", "preferred-size") + t;
    case 6060:
      return pa + "box-" + wa(t, "-grow", "") + pa + t + Al + wa(t, "grow", "positive") + t;
    case 4554:
      return pa + wa(t, /([^-])(transform)/g, "$1" + pa + "$2") + t;
    case 6187:
      return wa(wa(wa(t, /(zoom-|grab)/, pa + "$1"), /(image-set)/, pa + "$1"), t, "") + t;
    case 5495:
    case 3959:
      return wa(t, /(image-set\([^]*)/, pa + "$1$`$1");
    case 4968:
      return wa(wa(t, /(.+:)(flex-)?(.*)/, pa + "box-pack:$3" + Al + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + pa + t + t;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return wa(t, /(.+)-inline(.+)/, pa + "$1$2") + t;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (mh(t) - 1 - e > 6)
        switch (qs(t, e + 1)) {
          case 109:
            if (qs(t, e + 4) !== 45)
              break;
          case 102:
            return wa(t, /(.+:)(.+)-([^]+)/, "$1" + pa + "$2-$3$1" + Vk + (qs(t, e + 3) == 108 ? "$3" : "$2-$3")) + t;
          case 115:
            return ~SF(t, "stretch") ? Rte(wa(t, "stretch", "fill-available"), e) + t : t;
        }
      break;
    case 4949:
      if (qs(t, e + 1) !== 115)
        break;
    case 6444:
      switch (qs(t, mh(t) - 3 - (~SF(t, "!important") && 10))) {
        case 107:
          return wa(t, ":", ":" + pa) + t;
        case 101:
          return wa(t, /(.+:)([^;!]+)(;|!.+)?/, "$1" + pa + (qs(t, 14) === 45 ? "inline-" : "") + "box$3$1" + pa + "$2$3$1" + Al + "$2box$3") + t;
      }
      break;
    case 5936:
      switch (qs(t, e + 11)) {
        case 114:
          return pa + t + Al + wa(t, /[svh]\w+-[tblr]{2}/, "tb") + t;
        case 108:
          return pa + t + Al + wa(t, /[svh]\w+-[tblr]{2}/, "tb-rl") + t;
        case 45:
          return pa + t + Al + wa(t, /[svh]\w+-[tblr]{2}/, "lr") + t;
      }
      return pa + t + Al + t + t;
  }
  return t;
}
var Eve = function(e, n, r, a) {
  if (e.length > -1 && !e.return)
    switch (e.type) {
      case H5:
        e.return = Rte(e.value, e.length);
        break;
      case Tte:
        return SE([cw(e, {
          value: wa(e.value, "@", "@" + pa)
        })], a);
      case z5:
        if (e.length)
          return Kbe(e.props, function(i) {
            switch (qbe(i, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return SE([cw(e, {
                  props: [wa(i, /:(read-\w+)/, ":" + Vk + "$1")]
                })], a);
              case "::placeholder":
                return SE([cw(e, {
                  props: [wa(i, /:(plac\w+)/, ":" + pa + "input-$1")]
                }), cw(e, {
                  props: [wa(i, /:(plac\w+)/, ":" + Vk + "$1")]
                }), cw(e, {
                  props: [wa(i, /:(plac\w+)/, Al + "input-$1")]
                })], a);
            }
            return "";
          });
    }
}, Sve = [Eve], Ite = function(e) {
  var n = e.key;
  if (process.env.NODE_ENV !== "production" && !n)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (n === "css") {
    var r = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(r, function(_) {
      var C = _.getAttribute("data-emotion");
      C.indexOf(" ") !== -1 && (document.head.appendChild(_), _.setAttribute("data-s", ""));
    });
  }
  var a = e.stylisPlugins || Sve;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(n))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var i = {}, o, s = [];
  o = e.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(_) {
      for (var C = _.getAttribute("data-emotion").split(" "), A = 1; A < C.length; A++)
        i[C[A]] = !0;
      s.push(_);
    }
  );
  var u, f = [hve, mve];
  process.env.NODE_ENV !== "production" && f.push(vve({
    get compat() {
      return w.compat;
    }
  }), Ove);
  {
    var p, m = [sve, process.env.NODE_ENV !== "production" ? function(_) {
      _.root || (_.return ? p.insert(_.return) : _.value && _.type !== U5 && p.insert(_.value + "{}"));
    } : uve(function(_) {
      p.insert(_);
    })], v = lve(f.concat(a, m)), O = function(C) {
      return SE(ive(C), v);
    };
    u = function(C, A, N, P) {
      p = N, process.env.NODE_ENV !== "production" && A.map !== void 0 && (p = {
        insert: function(D) {
          N.insert(D + A.map);
        }
      }), O(C ? C + "{" + A.styles + "}" : A.styles), P && (w.inserted[A.name] = !0);
    };
  }
  var w = {
    key: n,
    sheet: new Gbe({
      key: n,
      container: o,
      nonce: e.nonce,
      speedy: e.speedy,
      prepend: e.prepend,
      insertionPoint: e.insertionPoint
    }),
    nonce: e.nonce,
    inserted: i,
    registered: {},
    insert: u
  };
  return w.sheet.hydrate(s), w;
}, TF = { exports: {} }, ya = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var MG;
function wve() {
  if (MG)
    return ya;
  MG = 1;
  var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, i = t ? Symbol.for("react.profiler") : 60114, o = t ? Symbol.for("react.provider") : 60109, s = t ? Symbol.for("react.context") : 60110, u = t ? Symbol.for("react.async_mode") : 60111, f = t ? Symbol.for("react.concurrent_mode") : 60111, p = t ? Symbol.for("react.forward_ref") : 60112, m = t ? Symbol.for("react.suspense") : 60113, v = t ? Symbol.for("react.suspense_list") : 60120, O = t ? Symbol.for("react.memo") : 60115, w = t ? Symbol.for("react.lazy") : 60116, _ = t ? Symbol.for("react.block") : 60121, C = t ? Symbol.for("react.fundamental") : 60117, A = t ? Symbol.for("react.responder") : 60118, N = t ? Symbol.for("react.scope") : 60119;
  function P(D) {
    if (typeof D == "object" && D !== null) {
      var M = D.$$typeof;
      switch (M) {
        case e:
          switch (D = D.type, D) {
            case u:
            case f:
            case r:
            case i:
            case a:
            case m:
              return D;
            default:
              switch (D = D && D.$$typeof, D) {
                case s:
                case p:
                case w:
                case O:
                case o:
                  return D;
                default:
                  return M;
              }
          }
        case n:
          return M;
      }
    }
  }
  function I(D) {
    return P(D) === f;
  }
  return ya.AsyncMode = u, ya.ConcurrentMode = f, ya.ContextConsumer = s, ya.ContextProvider = o, ya.Element = e, ya.ForwardRef = p, ya.Fragment = r, ya.Lazy = w, ya.Memo = O, ya.Portal = n, ya.Profiler = i, ya.StrictMode = a, ya.Suspense = m, ya.isAsyncMode = function(D) {
    return I(D) || P(D) === u;
  }, ya.isConcurrentMode = I, ya.isContextConsumer = function(D) {
    return P(D) === s;
  }, ya.isContextProvider = function(D) {
    return P(D) === o;
  }, ya.isElement = function(D) {
    return typeof D == "object" && D !== null && D.$$typeof === e;
  }, ya.isForwardRef = function(D) {
    return P(D) === p;
  }, ya.isFragment = function(D) {
    return P(D) === r;
  }, ya.isLazy = function(D) {
    return P(D) === w;
  }, ya.isMemo = function(D) {
    return P(D) === O;
  }, ya.isPortal = function(D) {
    return P(D) === n;
  }, ya.isProfiler = function(D) {
    return P(D) === i;
  }, ya.isStrictMode = function(D) {
    return P(D) === a;
  }, ya.isSuspense = function(D) {
    return P(D) === m;
  }, ya.isValidElementType = function(D) {
    return typeof D == "string" || typeof D == "function" || D === r || D === f || D === i || D === a || D === m || D === v || typeof D == "object" && D !== null && (D.$$typeof === w || D.$$typeof === O || D.$$typeof === o || D.$$typeof === s || D.$$typeof === p || D.$$typeof === C || D.$$typeof === A || D.$$typeof === N || D.$$typeof === _);
  }, ya.typeOf = P, ya;
}
var Oa = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var FG;
function Tve() {
  return FG || (FG = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, i = t ? Symbol.for("react.profiler") : 60114, o = t ? Symbol.for("react.provider") : 60109, s = t ? Symbol.for("react.context") : 60110, u = t ? Symbol.for("react.async_mode") : 60111, f = t ? Symbol.for("react.concurrent_mode") : 60111, p = t ? Symbol.for("react.forward_ref") : 60112, m = t ? Symbol.for("react.suspense") : 60113, v = t ? Symbol.for("react.suspense_list") : 60120, O = t ? Symbol.for("react.memo") : 60115, w = t ? Symbol.for("react.lazy") : 60116, _ = t ? Symbol.for("react.block") : 60121, C = t ? Symbol.for("react.fundamental") : 60117, A = t ? Symbol.for("react.responder") : 60118, N = t ? Symbol.for("react.scope") : 60119;
    function P(we) {
      return typeof we == "string" || typeof we == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      we === r || we === f || we === i || we === a || we === m || we === v || typeof we == "object" && we !== null && (we.$$typeof === w || we.$$typeof === O || we.$$typeof === o || we.$$typeof === s || we.$$typeof === p || we.$$typeof === C || we.$$typeof === A || we.$$typeof === N || we.$$typeof === _);
    }
    function I(we) {
      if (typeof we == "object" && we !== null) {
        var lt = we.$$typeof;
        switch (lt) {
          case e:
            var st = we.type;
            switch (st) {
              case u:
              case f:
              case r:
              case i:
              case a:
              case m:
                return st;
              default:
                var Oe = st && st.$$typeof;
                switch (Oe) {
                  case s:
                  case p:
                  case w:
                  case O:
                  case o:
                    return Oe;
                  default:
                    return lt;
                }
            }
          case n:
            return lt;
        }
      }
    }
    var D = u, M = f, H = s, Y = o, q = e, Q = p, ne = r, J = w, ue = O, ee = n, fe = i, de = a, ie = m, le = !1;
    function ye(we) {
      return le || (le = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), B(we) || I(we) === u;
    }
    function B(we) {
      return I(we) === f;
    }
    function pe(we) {
      return I(we) === s;
    }
    function _e(we) {
      return I(we) === o;
    }
    function Z(we) {
      return typeof we == "object" && we !== null && we.$$typeof === e;
    }
    function ce(we) {
      return I(we) === p;
    }
    function j(we) {
      return I(we) === r;
    }
    function K(we) {
      return I(we) === w;
    }
    function Ee(we) {
      return I(we) === O;
    }
    function he(we) {
      return I(we) === n;
    }
    function Ae(we) {
      return I(we) === i;
    }
    function Te(we) {
      return I(we) === a;
    }
    function je(we) {
      return I(we) === m;
    }
    Oa.AsyncMode = D, Oa.ConcurrentMode = M, Oa.ContextConsumer = H, Oa.ContextProvider = Y, Oa.Element = q, Oa.ForwardRef = Q, Oa.Fragment = ne, Oa.Lazy = J, Oa.Memo = ue, Oa.Portal = ee, Oa.Profiler = fe, Oa.StrictMode = de, Oa.Suspense = ie, Oa.isAsyncMode = ye, Oa.isConcurrentMode = B, Oa.isContextConsumer = pe, Oa.isContextProvider = _e, Oa.isElement = Z, Oa.isForwardRef = ce, Oa.isFragment = j, Oa.isLazy = K, Oa.isMemo = Ee, Oa.isPortal = he, Oa.isProfiler = Ae, Oa.isStrictMode = Te, Oa.isSuspense = je, Oa.isValidElementType = P, Oa.typeOf = I;
  }()), Oa;
}
process.env.NODE_ENV === "production" ? TF.exports = wve() : TF.exports = Tve();
var _ve = TF.exports, Dte = _ve, Cve = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, xve = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, Nte = {};
Nte[Dte.ForwardRef] = Cve;
Nte[Dte.Memo] = xve;
var Ave = !0;
function Pte(t, e, n) {
  var r = "";
  return n.split(" ").forEach(function(a) {
    t[a] !== void 0 ? e.push(t[a] + ";") : r += a + " ";
  }), r;
}
var Q5 = function(e, n, r) {
  var a = e.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (r === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Ave === !1) && e.registered[a] === void 0 && (e.registered[a] = n.styles);
}, j5 = function(e, n, r) {
  Q5(e, n, r);
  var a = e.key + "-" + n.name;
  if (e.inserted[n.name] === void 0) {
    var i = n;
    do
      e.insert(n === i ? "." + a : "", i, e.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function kve(t) {
  for (var e = 0, n, r = 0, a = t.length; a >= 4; ++r, a -= 4)
    n = t.charCodeAt(r) & 255 | (t.charCodeAt(++r) & 255) << 8 | (t.charCodeAt(++r) & 255) << 16 | (t.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, e = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16);
  switch (a) {
    case 3:
      e ^= (t.charCodeAt(r + 2) & 255) << 16;
    case 2:
      e ^= (t.charCodeAt(r + 1) & 255) << 8;
    case 1:
      e ^= t.charCodeAt(r) & 255, e = /* Math.imul(h, m): */
      (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16);
  }
  return e ^= e >>> 13, e = /* Math.imul(h, m): */
  (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16), ((e ^ e >>> 15) >>> 0).toString(36);
}
var Rve = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, $G = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, Ive = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", Dve = /[A-Z]|^ms/g, Lte = /_EMO_([^_]+?)_([^]*?)_EMO_/g, G5 = function(e) {
  return e.charCodeAt(1) === 45;
}, BG = function(e) {
  return e != null && typeof e != "boolean";
}, yM = /* @__PURE__ */ cve(function(t) {
  return G5(t) ? t : t.replace(Dve, "-$&").toLowerCase();
}), Yk = function(e, n) {
  switch (e) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(Lte, function(r, a, i) {
          return Ud = {
            name: a,
            styles: i,
            next: Ud
          }, a;
        });
  }
  return Rve[e] !== 1 && !G5(e) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (process.env.NODE_ENV !== "production") {
  var Nve = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, Pve = ["normal", "none", "initial", "inherit", "unset"], Lve = Yk, Mve = /^-ms-/, Fve = /-(.)/g, UG = {};
  Yk = function(e, n) {
    if (e === "content" && (typeof n != "string" || Pve.indexOf(n) === -1 && !Nve.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var r = Lve(e, n);
    return r !== "" && !G5(e) && e.indexOf("-") !== -1 && UG[e] === void 0 && (UG[e] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + e.replace(Mve, "ms-").replace(Fve, function(a, i) {
      return i.toUpperCase();
    }) + "?")), r;
  };
}
var Mte = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function kT(t, e, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(Mte);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return Ud = {
          name: n.name,
          styles: n.styles,
          next: Ud
        }, n.name;
      if (n.styles !== void 0) {
        var r = n.next;
        if (r !== void 0)
          for (; r !== void 0; )
            Ud = {
              name: r.name,
              styles: r.styles,
              next: Ud
            }, r = r.next;
        var a = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (a += n.map), a;
      }
      return $ve(t, e, n);
    }
    case "function": {
      if (t !== void 0) {
        var i = Ud, o = n(t);
        return Ud = i, kT(t, e, o);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var s = [], u = n.replace(Lte, function(p, m, v) {
          var O = "animation" + s.length;
          return s.push("const " + O + " = keyframes`" + v.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + O + "}";
        });
        s.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(s, ["`" + u + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + u + "`"));
      }
      break;
  }
  if (e == null)
    return n;
  var f = e[n];
  return f !== void 0 ? f : n;
}
function $ve(t, e, n) {
  var r = "";
  if (Array.isArray(n))
    for (var a = 0; a < n.length; a++)
      r += kT(t, e, n[a]) + ";";
  else
    for (var i in n) {
      var o = n[i];
      if (typeof o != "object")
        e != null && e[o] !== void 0 ? r += i + "{" + e[o] + "}" : BG(o) && (r += yM(i) + ":" + Yk(i, o) + ";");
      else {
        if (i === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(Mte);
        if (Array.isArray(o) && typeof o[0] == "string" && (e == null || e[o[0]] === void 0))
          for (var s = 0; s < o.length; s++)
            BG(o[s]) && (r += yM(i) + ":" + Yk(i, o[s]) + ";");
        else {
          var u = kT(t, e, o);
          switch (i) {
            case "animation":
            case "animationName": {
              r += yM(i) + ":" + u + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && i === "undefined" && console.error(Ive), r += i + "{" + u + "}";
          }
        }
      }
    }
  return r;
}
var zG = /label:\s*([^\s;\n{]+)\s*(;|$)/g, Fte;
process.env.NODE_ENV !== "production" && (Fte = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var Ud, RT = function(e, n, r) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var a = !0, i = "";
  Ud = void 0;
  var o = e[0];
  o == null || o.raw === void 0 ? (a = !1, i += kT(r, n, o)) : (process.env.NODE_ENV !== "production" && o[0] === void 0 && console.error($G), i += o[0]);
  for (var s = 1; s < e.length; s++)
    i += kT(r, n, e[s]), a && (process.env.NODE_ENV !== "production" && o[s] === void 0 && console.error($G), i += o[s]);
  var u;
  process.env.NODE_ENV !== "production" && (i = i.replace(Fte, function(v) {
    return u = v, "";
  })), zG.lastIndex = 0;
  for (var f = "", p; (p = zG.exec(i)) !== null; )
    f += "-" + // $FlowFixMe we know it's not null
    p[1];
  var m = kve(i) + f;
  return process.env.NODE_ENV !== "production" ? {
    name: m,
    styles: i,
    map: u,
    next: Ud,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: m,
    styles: i,
    next: Ud
  };
}, Bve = function(e) {
  return e();
}, $te = On["useInsertionEffect"] ? On["useInsertionEffect"] : !1, Bte = $te || Bve, HG = $te || l_, V5 = {}.hasOwnProperty, Y5 = /* @__PURE__ */ s_(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ Ite({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (Y5.displayName = "EmotionCacheContext");
var Uve = Y5.Provider, Z5 = function(e) {
  return /* @__PURE__ */ bs(function(n, r) {
    var a = nc(Y5);
    return e(n, a, r);
  });
}, GI = /* @__PURE__ */ s_({});
process.env.NODE_ENV !== "production" && (GI.displayName = "EmotionThemeContext");
var WG = function(e) {
  var n = e.split(".");
  return n[n.length - 1];
}, zve = function(e) {
  var n = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(e);
  if (n || (n = /^([A-Za-z0-9$.]+)@/.exec(e), n))
    return WG(n[1]);
}, Hve = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), Wve = function(e) {
  return e.replace(/\$/g, "-");
}, Qve = function(e) {
  if (e)
    for (var n = e.split(`
`), r = 0; r < n.length; r++) {
      var a = zve(n[r]);
      if (a) {
        if (Hve.has(a))
          break;
        if (/^[A-Z]/.test(a))
          return Wve(a);
      }
    }
}, _F = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", CF = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", jve = function(e, n) {
  if (process.env.NODE_ENV !== "production" && typeof n.css == "string" && // check if there is a css declaration
  n.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + n.css + "`");
  var r = {};
  for (var a in n)
    V5.call(n, a) && (r[a] = n[a]);
  if (r[_F] = e, process.env.NODE_ENV !== "production" && n.css && (typeof n.css != "object" || typeof n.css.name != "string" || n.css.name.indexOf("-") === -1)) {
    var i = Qve(new Error().stack);
    i && (r[CF] = i);
  }
  return r;
}, Gve = function(e) {
  var n = e.cache, r = e.serialized, a = e.isStringTag;
  return Q5(n, r, a), Bte(function() {
    return j5(n, r, a);
  }), null;
}, Ute = /* @__PURE__ */ Z5(function(t, e, n) {
  var r = t.css;
  typeof r == "string" && e.registered[r] !== void 0 && (r = e.registered[r]);
  var a = t[_F], i = [r], o = "";
  typeof t.className == "string" ? o = Pte(e.registered, i, t.className) : t.className != null && (o = t.className + " ");
  var s = RT(i, void 0, nc(GI));
  if (process.env.NODE_ENV !== "production" && s.name.indexOf("-") === -1) {
    var u = t[CF];
    u && (s = RT([s, "label:" + u + ";"]));
  }
  o += e.key + "-" + s.name;
  var f = {};
  for (var p in t)
    V5.call(t, p) && p !== "css" && p !== _F && (process.env.NODE_ENV === "production" || p !== CF) && (f[p] = t[p]);
  return f.ref = n, f.className = o, /* @__PURE__ */ fu(r0, null, /* @__PURE__ */ fu(Gve, {
    cache: e,
    serialized: s,
    isStringTag: typeof a == "string"
  }), /* @__PURE__ */ fu(a, f));
});
process.env.NODE_ENV !== "production" && (Ute.displayName = "EmotionCssPropInternal");
var Vve = {
  name: "@emotion/react",
  version: "11.10.5",
  main: "dist/emotion-react.cjs.js",
  module: "dist/emotion-react.esm.js",
  browser: {
    "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
  },
  exports: {
    ".": {
      module: {
        worker: "./dist/emotion-react.worker.esm.js",
        browser: "./dist/emotion-react.browser.esm.js",
        default: "./dist/emotion-react.esm.js"
      },
      default: "./dist/emotion-react.cjs.js"
    },
    "./jsx-runtime": {
      module: {
        worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
        browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
        default: "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
      },
      default: "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
    },
    "./_isolated-hnrs": {
      module: {
        worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
        browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
        default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
      },
      default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
    },
    "./jsx-dev-runtime": {
      module: {
        worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
        browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
        default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
      },
      default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
    },
    "./package.json": "./package.json",
    "./types/css-prop": "./types/css-prop.d.ts",
    "./macro": "./macro.js"
  },
  types: "types/index.d.ts",
  files: [
    "src",
    "dist",
    "jsx-runtime",
    "jsx-dev-runtime",
    "_isolated-hnrs",
    "types/*.d.ts",
    "macro.js",
    "macro.d.ts",
    "macro.js.flow"
  ],
  sideEffects: !1,
  author: "Emotion Contributors",
  license: "MIT",
  scripts: {
    "test:typescript": "dtslint types"
  },
  dependencies: {
    "@babel/runtime": "^7.18.3",
    "@emotion/babel-plugin": "^11.10.5",
    "@emotion/cache": "^11.10.5",
    "@emotion/serialize": "^1.1.1",
    "@emotion/use-insertion-effect-with-fallbacks": "^1.0.0",
    "@emotion/utils": "^1.2.0",
    "@emotion/weak-memoize": "^0.3.0",
    "hoist-non-react-statics": "^3.3.1"
  },
  peerDependencies: {
    "@babel/core": "^7.0.0",
    react: ">=16.8.0"
  },
  peerDependenciesMeta: {
    "@babel/core": {
      optional: !0
    },
    "@types/react": {
      optional: !0
    }
  },
  devDependencies: {
    "@babel/core": "^7.18.5",
    "@definitelytyped/dtslint": "0.0.112",
    "@emotion/css": "11.10.5",
    "@emotion/css-prettifier": "1.1.1",
    "@emotion/server": "11.10.0",
    "@emotion/styled": "11.10.5",
    "html-tag-names": "^1.1.2",
    react: "16.14.0",
    "svg-tag-names": "^1.1.1",
    typescript: "^4.5.5"
  },
  repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
  publishConfig: {
    access: "public"
  },
  "umd:main": "dist/emotion-react.umd.min.js",
  preconstruct: {
    entrypoints: [
      "./index.js",
      "./jsx-runtime.js",
      "./jsx-dev-runtime.js",
      "./_isolated-hnrs.js"
    ],
    umdName: "emotionReact",
    exports: {
      envConditions: [
        "browser",
        "worker"
      ],
      extra: {
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": "./macro.js"
      }
    }
  }
}, Xn = function(e, n) {
  var r = arguments;
  if (n == null || !V5.call(n, "css"))
    return fu.apply(void 0, r);
  var a = r.length, i = new Array(a);
  i[0] = Ute, i[1] = jve(e, n);
  for (var o = 2; o < a; o++)
    i[o] = r[o];
  return fu.apply(null, i);
}, QG = !1, Yve = /* @__PURE__ */ Z5(function(t, e) {
  process.env.NODE_ENV !== "production" && !QG && // check for className as well since the user is
  // probably using the custom createElement which
  // means it will be turned into a className prop
  // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
  (t.className || t.css) && (console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?"), QG = !0);
  var n = t.styles, r = RT([n], void 0, nc(GI)), a = dr();
  return HG(function() {
    var i = e.key + "-global", o = new e.sheet.constructor({
      key: i,
      nonce: e.sheet.nonce,
      container: e.sheet.container,
      speedy: e.sheet.isSpeedy
    }), s = !1, u = document.querySelector('style[data-emotion="' + i + " " + r.name + '"]');
    return e.sheet.tags.length && (o.before = e.sheet.tags[0]), u !== null && (s = !0, u.setAttribute("data-emotion", i), o.hydrate([u])), a.current = [o, s], function() {
      o.flush();
    };
  }, [e]), HG(function() {
    var i = a.current, o = i[0], s = i[1];
    if (s) {
      i[1] = !1;
      return;
    }
    if (r.next !== void 0 && j5(e, r.next, !0), o.tags.length) {
      var u = o.tags[o.tags.length - 1].nextElementSibling;
      o.before = u, o.flush();
    }
    e.insert("", r, o, !1);
  }, [e, r.name]), null;
});
process.env.NODE_ENV !== "production" && (Yve.displayName = "EmotionGlobal");
function X5() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return RT(e);
}
var Zve = function() {
  var e = X5.apply(void 0, arguments), n = "animation-" + e.name;
  return {
    name: n,
    styles: "@keyframes " + n + "{" + e.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}, Xve = function t(e) {
  for (var n = e.length, r = 0, a = ""; r < n; r++) {
    var i = e[r];
    if (i != null) {
      var o = void 0;
      switch (typeof i) {
        case "boolean":
          break;
        case "object": {
          if (Array.isArray(i))
            o = t(i);
          else {
            process.env.NODE_ENV !== "production" && i.styles !== void 0 && i.name !== void 0 && console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component."), o = "";
            for (var s in i)
              i[s] && s && (o && (o += " "), o += s);
          }
          break;
        }
        default:
          o = i;
      }
      o && (a && (a += " "), a += o);
    }
  }
  return a;
};
function qve(t, e, n) {
  var r = [], a = Pte(t, r, n);
  return r.length < 2 ? n : a + e(r);
}
var Kve = function(e) {
  var n = e.cache, r = e.serializedArr;
  return Bte(function() {
    for (var a = 0; a < r.length; a++)
      j5(n, r[a], !1);
  }), null;
}, Jve = /* @__PURE__ */ Z5(function(t, e) {
  var n = !1, r = [], a = function() {
    if (n && process.env.NODE_ENV !== "production")
      throw new Error("css can only be used during render");
    for (var f = arguments.length, p = new Array(f), m = 0; m < f; m++)
      p[m] = arguments[m];
    var v = RT(p, e.registered);
    return r.push(v), Q5(e, v, !1), e.key + "-" + v.name;
  }, i = function() {
    if (n && process.env.NODE_ENV !== "production")
      throw new Error("cx can only be used during render");
    for (var f = arguments.length, p = new Array(f), m = 0; m < f; m++)
      p[m] = arguments[m];
    return qve(e.registered, a, Xve(p));
  }, o = {
    css: a,
    cx: i,
    theme: nc(GI)
  }, s = t.children(o);
  return n = !0, /* @__PURE__ */ fu(r0, null, /* @__PURE__ */ fu(Kve, {
    cache: e,
    serializedArr: r
  }), s);
});
process.env.NODE_ENV !== "production" && (Jve.displayName = "EmotionClassNames");
if (process.env.NODE_ENV !== "production") {
  var jG = !0, eye = typeof jest < "u" || typeof vi < "u";
  if (jG && !eye) {
    var GG = (
      // $FlowIgnore
      typeof globalThis < "u" ? globalThis : jG ? window : global
    ), VG = "__EMOTION_REACT_" + Vve.version.split(".")[0] + "__";
    GG[VG] && console.warn("You are loading @emotion/react when it is already loaded. Running multiple instances may cause problems. This can happen if multiple versions are used, or if multiple builds of the same version are used."), GG[VG] = !0;
  }
}
function tye(t, e) {
  return e || (e = t.slice(0)), Object.freeze(Object.defineProperties(t, {
    raw: {
      value: Object.freeze(e)
    }
  }));
}
const nye = Math.min, rye = Math.max, Zk = Math.round, Cx = Math.floor, Xk = (t) => ({
  x: t,
  y: t
});
function aye(t) {
  return {
    ...t,
    top: t.y,
    left: t.x,
    right: t.x + t.width,
    bottom: t.y + t.height
  };
}
function zte(t) {
  return Wte(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function Qd(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function Hte(t) {
  var e;
  return (e = (Wte(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function Wte(t) {
  return t instanceof Node || t instanceof Qd(t).Node;
}
function xF(t) {
  return t instanceof Element || t instanceof Qd(t).Element;
}
function q5(t) {
  return t instanceof HTMLElement || t instanceof Qd(t).HTMLElement;
}
function YG(t) {
  return typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof Qd(t).ShadowRoot;
}
function Qte(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: r,
    display: a
  } = K5(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + r + n) && !["inline", "contents"].includes(a);
}
function iye() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function oye(t) {
  return ["html", "body", "#document"].includes(zte(t));
}
function K5(t) {
  return Qd(t).getComputedStyle(t);
}
function sye(t) {
  if (zte(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    YG(t) && t.host || // Fallback.
    Hte(t)
  );
  return YG(e) ? e.host : e;
}
function jte(t) {
  const e = sye(t);
  return oye(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : q5(e) && Qte(e) ? e : jte(e);
}
function AF(t, e) {
  var n;
  e === void 0 && (e = []);
  const r = jte(t), a = r === ((n = t.ownerDocument) == null ? void 0 : n.body), i = Qd(r);
  return a ? e.concat(i, i.visualViewport || [], Qte(r) ? r : []) : e.concat(r, AF(r));
}
function lye(t) {
  const e = K5(t);
  let n = parseFloat(e.width) || 0, r = parseFloat(e.height) || 0;
  const a = q5(t), i = a ? t.offsetWidth : n, o = a ? t.offsetHeight : r, s = Zk(n) !== i || Zk(r) !== o;
  return s && (n = i, r = o), {
    width: n,
    height: r,
    $: s
  };
}
function J5(t) {
  return xF(t) ? t : t.contextElement;
}
function OM(t) {
  const e = J5(t);
  if (!q5(e))
    return Xk(1);
  const n = e.getBoundingClientRect(), {
    width: r,
    height: a,
    $: i
  } = lye(e);
  let o = (i ? Zk(n.width) : n.width) / r, s = (i ? Zk(n.height) : n.height) / a;
  return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: o,
    y: s
  };
}
const uye = /* @__PURE__ */ Xk(0);
function cye(t) {
  const e = Qd(t);
  return !iye() || !e.visualViewport ? uye : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function fye(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== Qd(t) ? !1 : e;
}
function ZG(t, e, n, r) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const a = t.getBoundingClientRect(), i = J5(t);
  let o = Xk(1);
  e && (r ? xF(r) && (o = OM(r)) : o = OM(t));
  const s = fye(i, n, r) ? cye(i) : Xk(0);
  let u = (a.left + s.x) / o.x, f = (a.top + s.y) / o.y, p = a.width / o.x, m = a.height / o.y;
  if (i) {
    const v = Qd(i), O = r && xF(r) ? Qd(r) : r;
    let w = v.frameElement;
    for (; w && r && O !== v; ) {
      const _ = OM(w), C = w.getBoundingClientRect(), A = K5(w), N = C.left + (w.clientLeft + parseFloat(A.paddingLeft)) * _.x, P = C.top + (w.clientTop + parseFloat(A.paddingTop)) * _.y;
      u *= _.x, f *= _.y, p *= _.x, m *= _.y, u += N, f += P, w = Qd(w).frameElement;
    }
  }
  return aye({
    width: p,
    height: m,
    x: u,
    y: f
  });
}
function dye(t, e) {
  let n = null, r;
  const a = Hte(t);
  function i() {
    clearTimeout(r), n && n.disconnect(), n = null;
  }
  function o(s, u) {
    s === void 0 && (s = !1), u === void 0 && (u = 1), i();
    const {
      left: f,
      top: p,
      width: m,
      height: v
    } = t.getBoundingClientRect();
    if (s || e(), !m || !v)
      return;
    const O = Cx(p), w = Cx(a.clientWidth - (f + m)), _ = Cx(a.clientHeight - (p + v)), C = Cx(f), N = {
      rootMargin: -O + "px " + -w + "px " + -_ + "px " + -C + "px",
      threshold: rye(0, nye(1, u)) || 1
    };
    let P = !0;
    function I(D) {
      const M = D[0].intersectionRatio;
      if (M !== u) {
        if (!P)
          return o();
        M ? o(!1, M) : r = setTimeout(() => {
          o(!1, 1e-7);
        }, 100);
      }
      P = !1;
    }
    try {
      n = new IntersectionObserver(I, {
        ...N,
        // Handle <iframe>s
        root: a.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(I, N);
    }
    n.observe(t);
  }
  return o(!0), i;
}
function pye(t, e, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: a = !0,
    ancestorResize: i = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: u = !1
  } = r, f = J5(t), p = a || i ? [...f ? AF(f) : [], ...AF(e)] : [];
  p.forEach((A) => {
    a && A.addEventListener("scroll", n, {
      passive: !0
    }), i && A.addEventListener("resize", n);
  });
  const m = f && s ? dye(f, n) : null;
  let v = -1, O = null;
  o && (O = new ResizeObserver((A) => {
    let [N] = A;
    N && N.target === f && O && (O.unobserve(e), cancelAnimationFrame(v), v = requestAnimationFrame(() => {
      O && O.observe(e);
    })), n();
  }), f && !u && O.observe(f), O.observe(e));
  let w, _ = u ? ZG(t) : null;
  u && C();
  function C() {
    const A = ZG(t);
    _ && (A.x !== _.x || A.y !== _.y || A.width !== _.width || A.height !== _.height) && n(), _ = A, w = requestAnimationFrame(C);
  }
  return n(), () => {
    p.forEach((A) => {
      a && A.removeEventListener("scroll", n), i && A.removeEventListener("resize", n);
    }), m && m(), O && O.disconnect(), O = null, u && cancelAnimationFrame(w);
  };
}
var kF = l_, hye = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"], qk = function() {
};
function mye(t, e) {
  return e ? e[0] === "-" ? t + e : t + "__" + e : t;
}
function gye(t, e) {
  for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), a = 2; a < n; a++)
    r[a - 2] = arguments[a];
  var i = [].concat(r);
  if (e && t)
    for (var o in e)
      e.hasOwnProperty(o) && e[o] && i.push("".concat(mye(t, o)));
  return i.filter(function(s) {
    return s;
  }).map(function(s) {
    return String(s).trim();
  }).join(" ");
}
var Kk = function(e) {
  return Cye(e) ? e.filter(Boolean) : i0(e) === "object" && e !== null ? [e] : [];
}, Gte = function(e) {
  e.className, e.clearValue, e.cx, e.getStyles, e.getClassNames, e.getValue, e.hasValue, e.isMulti, e.isRtl, e.options, e.selectOption, e.selectProps, e.setValue, e.theme;
  var n = lv(e, hye);
  return Hn({}, n);
}, Zi = function(e, n, r) {
  var a = e.cx, i = e.getStyles, o = e.getClassNames, s = e.className;
  return {
    css: i(n, e),
    className: a(r ?? {}, o(n, e), s)
  };
};
function bye(t, e, n) {
  if (n) {
    var r = n(t, e);
    if (typeof r == "string")
      return r;
  }
  return t;
}
function VI(t) {
  return [document.documentElement, document.body, window].indexOf(t) > -1;
}
function vye(t) {
  return VI(t) ? window.innerHeight : t.clientHeight;
}
function Vte(t) {
  return VI(t) ? window.pageYOffset : t.scrollTop;
}
function Jk(t, e) {
  if (VI(t)) {
    window.scrollTo(0, e);
    return;
  }
  t.scrollTop = e;
}
function yye(t) {
  var e = getComputedStyle(t), n = e.position === "absolute", r = /(auto|scroll)/;
  if (e.position === "fixed")
    return document.documentElement;
  for (var a = t; a = a.parentElement; )
    if (e = getComputedStyle(a), !(n && e.position === "static") && r.test(e.overflow + e.overflowY + e.overflowX))
      return a;
  return document.documentElement;
}
function Oye(t, e, n, r) {
  return n * ((t = t / r - 1) * t * t + 1) + e;
}
function xx(t, e) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : qk, a = Vte(t), i = e - a, o = 10, s = 0;
  function u() {
    s += o;
    var f = Oye(s, a, i, n);
    Jk(t, f), s < n ? window.requestAnimationFrame(u) : r(t);
  }
  u();
}
function XG(t, e) {
  var n = t.getBoundingClientRect(), r = e.getBoundingClientRect(), a = e.offsetHeight / 3;
  r.bottom + a > n.bottom ? Jk(t, Math.min(e.offsetTop + e.clientHeight - t.offsetHeight + a, t.scrollHeight)) : r.top - a < n.top && Jk(t, Math.max(e.offsetTop - a, 0));
}
function Eye(t) {
  var e = t.getBoundingClientRect();
  return {
    bottom: e.bottom,
    height: e.height,
    left: e.left,
    right: e.right,
    top: e.top,
    width: e.width
  };
}
function qG() {
  try {
    return document.createEvent("TouchEvent"), !0;
  } catch {
    return !1;
  }
}
function Sye() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch {
    return !1;
  }
}
var Yte = !1, wye = {
  get passive() {
    return Yte = !0;
  }
}, Ax = typeof window < "u" ? window : {};
Ax.addEventListener && Ax.removeEventListener && (Ax.addEventListener("p", qk, wye), Ax.removeEventListener("p", qk, !1));
var Tye = Yte;
function _ye(t) {
  return t != null;
}
function Cye(t) {
  return Array.isArray(t);
}
function Dw(t, e, n) {
  return t ? e : n;
}
var xye = function(e) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++)
    r[a - 1] = arguments[a];
  var i = Object.entries(e).filter(function(o) {
    var s = ms(o, 1), u = s[0];
    return !r.includes(u);
  });
  return i.reduce(function(o, s) {
    var u = ms(s, 2), f = u[0], p = u[1];
    return o[f] = p, o;
  }, {});
};
function Aye(t) {
  var e = t.maxHeight, n = t.menuEl, r = t.minHeight, a = t.placement, i = t.shouldScroll, o = t.isFixedPosition, s = t.controlHeight, u = yye(n), f = {
    placement: "bottom",
    maxHeight: e
  };
  if (!n || !n.offsetParent)
    return f;
  var p = u.getBoundingClientRect(), m = p.height, v = n.getBoundingClientRect(), O = v.bottom, w = v.height, _ = v.top, C = n.offsetParent.getBoundingClientRect(), A = C.top, N = o ? window.innerHeight : vye(u), P = Vte(u), I = parseInt(getComputedStyle(n).marginBottom, 10), D = parseInt(getComputedStyle(n).marginTop, 10), M = A - D, H = N - _, Y = M + P, q = m - P - _, Q = O - N + P + I, ne = P + _ - D, J = 160;
  switch (a) {
    case "auto":
    case "bottom":
      if (H >= w)
        return {
          placement: "bottom",
          maxHeight: e
        };
      if (q >= w && !o)
        return i && xx(u, Q, J), {
          placement: "bottom",
          maxHeight: e
        };
      if (!o && q >= r || o && H >= r) {
        i && xx(u, Q, J);
        var ue = o ? H - I : q - I;
        return {
          placement: "bottom",
          maxHeight: ue
        };
      }
      if (a === "auto" || o) {
        var ee = e, fe = o ? M : Y;
        return fe >= r && (ee = Math.min(fe - I - s, e)), {
          placement: "top",
          maxHeight: ee
        };
      }
      if (a === "bottom")
        return i && Jk(u, Q), {
          placement: "bottom",
          maxHeight: e
        };
      break;
    case "top":
      if (M >= w)
        return {
          placement: "top",
          maxHeight: e
        };
      if (Y >= w && !o)
        return i && xx(u, ne, J), {
          placement: "top",
          maxHeight: e
        };
      if (!o && Y >= r || o && M >= r) {
        var de = e;
        return (!o && Y >= r || o && M >= r) && (de = o ? M - D : Y - D), i && xx(u, ne, J), {
          placement: "top",
          maxHeight: de
        };
      }
      return {
        placement: "bottom",
        maxHeight: e
      };
    default:
      throw new Error('Invalid placement provided "'.concat(a, '".'));
  }
  return f;
}
function kye(t) {
  var e = {
    bottom: "top",
    top: "bottom"
  };
  return t ? e[t] : "bottom";
}
var Zte = function(e) {
  return e === "auto" ? "bottom" : e;
}, Rye = function(e, n) {
  var r, a = e.placement, i = e.theme, o = i.borderRadius, s = i.spacing, u = i.colors;
  return Hn((r = {
    label: "menu"
  }, hE(r, kye(a), "100%"), hE(r, "position", "absolute"), hE(r, "width", "100%"), hE(r, "zIndex", 1), r), n ? {} : {
    backgroundColor: u.neutral0,
    borderRadius: o,
    boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
    marginBottom: s.menuGutter,
    marginTop: s.menuGutter
  });
}, Xte = /* @__PURE__ */ s_(null), Iye = function(e) {
  var n = e.children, r = e.minMenuHeight, a = e.maxMenuHeight, i = e.menuPlacement, o = e.menuPosition, s = e.menuShouldScrollIntoView, u = e.theme, f = nc(Xte) || {}, p = f.setPortalPlacement, m = dr(null), v = kn(a), O = ms(v, 2), w = O[0], _ = O[1], C = kn(null), A = ms(C, 2), N = A[0], P = A[1], I = u.spacing.controlHeight;
  return kF(function() {
    var D = m.current;
    if (D) {
      var M = o === "fixed", H = s && !M, Y = Aye({
        maxHeight: a,
        menuEl: D,
        minHeight: r,
        placement: i,
        shouldScroll: H,
        isFixedPosition: M,
        controlHeight: I
      });
      _(Y.maxHeight), P(Y.placement), p == null || p(Y.placement);
    }
  }, [a, i, o, s, r, p, I]), n({
    ref: m,
    placerProps: Hn(Hn({}, e), {}, {
      placement: N || Zte(i),
      maxHeight: w
    })
  });
}, Dye = function(e) {
  var n = e.children, r = e.innerRef, a = e.innerProps;
  return Xn("div", rn({}, Zi(e, "menu", {
    menu: !0
  }), {
    ref: r
  }, a), n);
}, Nye = function(e, n) {
  var r = e.maxHeight, a = e.theme.spacing.baseUnit;
  return Hn({
    maxHeight: r,
    overflowY: "auto",
    position: "relative",
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: "touch"
  }, n ? {} : {
    paddingBottom: a,
    paddingTop: a
  });
}, Pye = function(e) {
  var n = e.children, r = e.innerProps, a = e.innerRef, i = e.isMulti;
  return Xn("div", rn({}, Zi(e, "menuList", {
    "menu-list": !0,
    "menu-list--is-multi": i
  }), {
    ref: a
  }, r), n);
}, qte = function(e, n) {
  var r = e.theme, a = r.spacing.baseUnit, i = r.colors;
  return Hn({
    textAlign: "center"
  }, n ? {} : {
    color: i.neutral40,
    padding: "".concat(a * 2, "px ").concat(a * 3, "px")
  });
}, Lye = qte, Mye = qte, Kte = function(e) {
  var n = e.children, r = e.innerProps;
  return Xn("div", rn({}, Zi(e, "noOptionsMessage", {
    "menu-notice": !0,
    "menu-notice--no-options": !0
  }), r), n);
};
Kte.defaultProps = {
  children: "No options"
};
var Jte = function(e) {
  var n = e.children, r = e.innerProps;
  return Xn("div", rn({}, Zi(e, "loadingMessage", {
    "menu-notice": !0,
    "menu-notice--loading": !0
  }), r), n);
};
Jte.defaultProps = {
  children: "Loading..."
};
var Fye = function(e) {
  var n = e.rect, r = e.offset, a = e.position;
  return {
    left: n.left,
    position: a,
    top: r,
    width: n.width,
    zIndex: 1
  };
}, $ye = function(e) {
  var n = e.appendTo, r = e.children, a = e.controlElement, i = e.innerProps, o = e.menuPlacement, s = e.menuPosition, u = dr(null), f = dr(null), p = kn(Zte(o)), m = ms(p, 2), v = m[0], O = m[1], w = Mc(function() {
    return {
      setPortalPlacement: O
    };
  }, []), _ = kn(null), C = ms(_, 2), A = C[0], N = C[1], P = Ei(function() {
    if (a) {
      var H = Eye(a), Y = s === "fixed" ? 0 : window.pageYOffset, q = H[v] + Y;
      (q !== (A == null ? void 0 : A.offset) || H.left !== (A == null ? void 0 : A.rect.left) || H.width !== (A == null ? void 0 : A.rect.width)) && N({
        offset: q,
        rect: H
      });
    }
  }, [a, s, v, A == null ? void 0 : A.offset, A == null ? void 0 : A.rect.left, A == null ? void 0 : A.rect.width]);
  kF(function() {
    P();
  }, [P]);
  var I = Ei(function() {
    typeof f.current == "function" && (f.current(), f.current = null), a && u.current && (f.current = pye(a, u.current, P, {
      elementResize: "ResizeObserver" in window
    }));
  }, [a, P]);
  kF(function() {
    I();
  }, [I]);
  var D = Ei(function(H) {
    u.current = H, I();
  }, [I]);
  if (!n && s !== "fixed" || !A)
    return null;
  var M = Xn("div", rn({
    ref: D
  }, Zi(Hn(Hn({}, e), {}, {
    offset: A.offset,
    position: s,
    rect: A.rect
  }), "menuPortal", {
    "menu-portal": !0
  }), i), r);
  return Xn(Xte.Provider, {
    value: w
  }, n ? /* @__PURE__ */ d_.createPortal(M, n) : M);
}, Bye = function(e) {
  var n = e.isDisabled, r = e.isRtl;
  return {
    label: "container",
    direction: r ? "rtl" : void 0,
    pointerEvents: n ? "none" : void 0,
    // cancel mouse events when disabled
    position: "relative"
  };
}, Uye = function(e) {
  var n = e.children, r = e.innerProps, a = e.isDisabled, i = e.isRtl;
  return Xn("div", rn({}, Zi(e, "container", {
    "--is-disabled": a,
    "--is-rtl": i
  }), r), n);
}, zye = function(e, n) {
  var r = e.theme.spacing, a = e.isMulti, i = e.hasValue, o = e.selectProps.controlShouldRenderValue;
  return Hn({
    alignItems: "center",
    display: a && i && o ? "flex" : "grid",
    flex: 1,
    flexWrap: "wrap",
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  }, n ? {} : {
    padding: "".concat(r.baseUnit / 2, "px ").concat(r.baseUnit * 2, "px")
  });
}, Hye = function(e) {
  var n = e.children, r = e.innerProps, a = e.isMulti, i = e.hasValue;
  return Xn("div", rn({}, Zi(e, "valueContainer", {
    "value-container": !0,
    "value-container--is-multi": a,
    "value-container--has-value": i
  }), r), n);
}, Wye = function() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
}, Qye = function(e) {
  var n = e.children, r = e.innerProps;
  return Xn("div", rn({}, Zi(e, "indicatorsContainer", {
    indicators: !0
  }), r), n);
}, KG, jye = ["size"];
function Gye() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var Vye = process.env.NODE_ENV === "production" ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : {
  name: "tj5bde-Svg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: Gye
}, ene = function(e) {
  var n = e.size, r = lv(e, jye);
  return Xn("svg", rn({
    height: n,
    width: n,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: Vye
  }, r));
}, eU = function(e) {
  return Xn(ene, rn({
    size: 20
  }, e), Xn("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
}, tne = function(e) {
  return Xn(ene, rn({
    size: 20
  }, e), Xn("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}, nne = function(e, n) {
  var r = e.isFocused, a = e.theme, i = a.spacing.baseUnit, o = a.colors;
  return Hn({
    label: "indicatorContainer",
    display: "flex",
    transition: "color 150ms"
  }, n ? {} : {
    color: r ? o.neutral60 : o.neutral20,
    padding: i * 2,
    ":hover": {
      color: r ? o.neutral80 : o.neutral40
    }
  });
}, Yye = nne, Zye = function(e) {
  var n = e.children, r = e.innerProps;
  return Xn("div", rn({}, Zi(e, "dropdownIndicator", {
    indicator: !0,
    "dropdown-indicator": !0
  }), r), n || Xn(tne, null));
}, Xye = nne, qye = function(e) {
  var n = e.children, r = e.innerProps;
  return Xn("div", rn({}, Zi(e, "clearIndicator", {
    indicator: !0,
    "clear-indicator": !0
  }), r), n || Xn(eU, null));
}, Kye = function(e, n) {
  var r = e.isDisabled, a = e.theme, i = a.spacing.baseUnit, o = a.colors;
  return Hn({
    label: "indicatorSeparator",
    alignSelf: "stretch",
    width: 1
  }, n ? {} : {
    backgroundColor: r ? o.neutral10 : o.neutral20,
    marginBottom: i * 2,
    marginTop: i * 2
  });
}, Jye = function(e) {
  var n = e.innerProps;
  return Xn("span", rn({}, n, Zi(e, "indicatorSeparator", {
    "indicator-separator": !0
  })));
}, e0e = Zve(KG || (KG = tye([`
  0%, 80%, 100% { opacity: 0; }
  40% { opacity: 1; }
`]))), t0e = function(e, n) {
  var r = e.isFocused, a = e.size, i = e.theme, o = i.colors, s = i.spacing.baseUnit;
  return Hn({
    label: "loadingIndicator",
    display: "flex",
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: a,
    lineHeight: 1,
    marginRight: a,
    textAlign: "center",
    verticalAlign: "middle"
  }, n ? {} : {
    color: r ? o.neutral60 : o.neutral20,
    padding: s * 2
  });
}, EM = function(e) {
  var n = e.delay, r = e.offset;
  return Xn("span", {
    css: /* @__PURE__ */ X5({
      animation: "".concat(e0e, " 1s ease-in-out ").concat(n, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: r ? "1em" : void 0,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, process.env.NODE_ENV === "production" ? "" : ";label:LoadingDot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
}, rne = function(e) {
  var n = e.innerProps, r = e.isRtl;
  return Xn("div", rn({}, Zi(e, "loadingIndicator", {
    indicator: !0,
    "loading-indicator": !0
  }), n), Xn(EM, {
    delay: 0,
    offset: r
  }), Xn(EM, {
    delay: 160,
    offset: !0
  }), Xn(EM, {
    delay: 320,
    offset: !r
  }));
};
rne.defaultProps = {
  size: 4
};
var n0e = function(e, n) {
  var r = e.isDisabled, a = e.isFocused, i = e.theme, o = i.colors, s = i.borderRadius, u = i.spacing;
  return Hn({
    label: "control",
    alignItems: "center",
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: u.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms"
  }, n ? {} : {
    backgroundColor: r ? o.neutral5 : o.neutral0,
    borderColor: r ? o.neutral10 : a ? o.primary : o.neutral20,
    borderRadius: s,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: a ? "0 0 0 1px ".concat(o.primary) : void 0,
    "&:hover": {
      borderColor: a ? o.primary : o.neutral30
    }
  });
}, r0e = function(e) {
  var n = e.children, r = e.isDisabled, a = e.isFocused, i = e.innerRef, o = e.innerProps, s = e.menuIsOpen;
  return Xn("div", rn({
    ref: i
  }, Zi(e, "control", {
    control: !0,
    "control--is-disabled": r,
    "control--is-focused": a,
    "control--menu-is-open": s
  }), o), n);
}, a0e = ["data"], i0e = function(e, n) {
  var r = e.theme.spacing;
  return n ? {} : {
    paddingBottom: r.baseUnit * 2,
    paddingTop: r.baseUnit * 2
  };
}, o0e = function(e) {
  var n = e.children, r = e.cx, a = e.getStyles, i = e.getClassNames, o = e.Heading, s = e.headingProps, u = e.innerProps, f = e.label, p = e.theme, m = e.selectProps;
  return Xn("div", rn({}, Zi(e, "group", {
    group: !0
  }), u), Xn(o, rn({}, s, {
    selectProps: m,
    theme: p,
    getStyles: a,
    getClassNames: i,
    cx: r
  }), f), Xn("div", null, n));
}, s0e = function(e, n) {
  var r = e.theme, a = r.colors, i = r.spacing;
  return Hn({
    label: "group",
    cursor: "default",
    display: "block"
  }, n ? {} : {
    color: a.neutral40,
    fontSize: "75%",
    fontWeight: 500,
    marginBottom: "0.25em",
    paddingLeft: i.baseUnit * 3,
    paddingRight: i.baseUnit * 3,
    textTransform: "uppercase"
  });
}, l0e = function(e) {
  var n = Gte(e);
  n.data;
  var r = lv(n, a0e);
  return Xn("div", rn({}, Zi(e, "groupHeading", {
    "group-heading": !0
  }), r));
}, u0e = ["innerRef", "isDisabled", "isHidden", "inputClassName"], c0e = function(e, n) {
  var r = e.isDisabled, a = e.value, i = e.theme, o = i.spacing, s = i.colors;
  return Hn(Hn({
    visibility: r ? "hidden" : "visible",
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: a ? "translateZ(0)" : ""
  }, f0e), n ? {} : {
    margin: o.baseUnit / 2,
    paddingBottom: o.baseUnit / 2,
    paddingTop: o.baseUnit / 2,
    color: s.neutral80
  });
}, ane = {
  gridArea: "1 / 2",
  font: "inherit",
  minWidth: "2px",
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
}, f0e = {
  flex: "1 1 auto",
  display: "inline-grid",
  gridArea: "1 / 1 / 2 / 3",
  gridTemplateColumns: "0 min-content",
  "&:after": Hn({
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre"
  }, ane)
}, d0e = function(e) {
  return Hn({
    label: "input",
    color: "inherit",
    background: 0,
    opacity: e ? 0 : 1,
    width: "100%"
  }, ane);
}, p0e = function(e) {
  var n = e.cx, r = e.value, a = Gte(e), i = a.innerRef, o = a.isDisabled, s = a.isHidden, u = a.inputClassName, f = lv(a, u0e);
  return Xn("div", rn({}, Zi(e, "input", {
    "input-container": !0
  }), {
    "data-value": r || ""
  }), Xn("input", rn({
    className: n({
      input: !0
    }, u),
    ref: i,
    style: d0e(s),
    disabled: o
  }, f)));
}, h0e = function(e, n) {
  var r = e.theme, a = r.spacing, i = r.borderRadius, o = r.colors;
  return Hn({
    label: "multiValue",
    display: "flex",
    minWidth: 0
  }, n ? {} : {
    backgroundColor: o.neutral10,
    borderRadius: i / 2,
    margin: a.baseUnit / 2
  });
}, m0e = function(e, n) {
  var r = e.theme, a = r.borderRadius, i = r.colors, o = e.cropWithEllipsis;
  return Hn({
    overflow: "hidden",
    textOverflow: o || o === void 0 ? "ellipsis" : void 0,
    whiteSpace: "nowrap"
  }, n ? {} : {
    borderRadius: a / 2,
    color: i.neutral80,
    fontSize: "85%",
    padding: 3,
    paddingLeft: 6
  });
}, g0e = function(e, n) {
  var r = e.theme, a = r.spacing, i = r.borderRadius, o = r.colors, s = e.isFocused;
  return Hn({
    alignItems: "center",
    display: "flex"
  }, n ? {} : {
    borderRadius: i / 2,
    backgroundColor: s ? o.dangerLight : void 0,
    paddingLeft: a.baseUnit,
    paddingRight: a.baseUnit,
    ":hover": {
      backgroundColor: o.dangerLight,
      color: o.danger
    }
  });
}, ine = function(e) {
  var n = e.children, r = e.innerProps;
  return Xn("div", r, n);
}, b0e = ine, v0e = ine;
function y0e(t) {
  var e = t.children, n = t.innerProps;
  return Xn("div", rn({
    role: "button"
  }, n), e || Xn(eU, {
    size: 14
  }));
}
var O0e = function(e) {
  var n = e.children, r = e.components, a = e.data, i = e.innerProps, o = e.isDisabled, s = e.removeProps, u = e.selectProps, f = r.Container, p = r.Label, m = r.Remove;
  return Xn(f, {
    data: a,
    innerProps: Hn(Hn({}, Zi(e, "multiValue", {
      "multi-value": !0,
      "multi-value--is-disabled": o
    })), i),
    selectProps: u
  }, Xn(p, {
    data: a,
    innerProps: Hn({}, Zi(e, "multiValueLabel", {
      "multi-value__label": !0
    })),
    selectProps: u
  }, n), Xn(m, {
    data: a,
    innerProps: Hn(Hn({}, Zi(e, "multiValueRemove", {
      "multi-value__remove": !0
    })), {}, {
      "aria-label": "Remove ".concat(n || "option")
    }, s),
    selectProps: u
  }));
}, E0e = function(e, n) {
  var r = e.isDisabled, a = e.isFocused, i = e.isSelected, o = e.theme, s = o.spacing, u = o.colors;
  return Hn({
    label: "option",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
  }, n ? {} : {
    backgroundColor: i ? u.primary : a ? u.primary25 : "transparent",
    color: r ? u.neutral20 : i ? u.neutral0 : "inherit",
    padding: "".concat(s.baseUnit * 2, "px ").concat(s.baseUnit * 3, "px"),
    // provide some affordance on touch devices
    ":active": {
      backgroundColor: r ? void 0 : i ? u.primary : u.primary50
    }
  });
}, S0e = function(e) {
  var n = e.children, r = e.isDisabled, a = e.isFocused, i = e.isSelected, o = e.innerRef, s = e.innerProps;
  return Xn("div", rn({}, Zi(e, "option", {
    option: !0,
    "option--is-disabled": r,
    "option--is-focused": a,
    "option--is-selected": i
  }), {
    ref: o,
    "aria-disabled": r
  }, s), n);
}, w0e = function(e, n) {
  var r = e.theme, a = r.spacing, i = r.colors;
  return Hn({
    label: "placeholder",
    gridArea: "1 / 1 / 2 / 3"
  }, n ? {} : {
    color: i.neutral50,
    marginLeft: a.baseUnit / 2,
    marginRight: a.baseUnit / 2
  });
}, T0e = function(e) {
  var n = e.children, r = e.innerProps;
  return Xn("div", rn({}, Zi(e, "placeholder", {
    placeholder: !0
  }), r), n);
}, _0e = function(e, n) {
  var r = e.isDisabled, a = e.theme, i = a.spacing, o = a.colors;
  return Hn({
    label: "singleValue",
    gridArea: "1 / 1 / 2 / 3",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }, n ? {} : {
    color: r ? o.neutral40 : o.neutral80,
    marginLeft: i.baseUnit / 2,
    marginRight: i.baseUnit / 2
  });
}, C0e = function(e) {
  var n = e.children, r = e.isDisabled, a = e.innerProps;
  return Xn("div", rn({}, Zi(e, "singleValue", {
    "single-value": !0,
    "single-value--is-disabled": r
  }), a), n);
}, jd = {
  ClearIndicator: qye,
  Control: r0e,
  DropdownIndicator: Zye,
  DownChevron: tne,
  CrossIcon: eU,
  Group: o0e,
  GroupHeading: l0e,
  IndicatorsContainer: Qye,
  IndicatorSeparator: Jye,
  Input: p0e,
  LoadingIndicator: rne,
  Menu: Dye,
  MenuList: Pye,
  MenuPortal: $ye,
  LoadingMessage: Jte,
  NoOptionsMessage: Kte,
  MultiValue: O0e,
  MultiValueContainer: b0e,
  MultiValueLabel: v0e,
  MultiValueRemove: y0e,
  Option: S0e,
  Placeholder: T0e,
  SelectContainer: Uye,
  SingleValue: C0e,
  ValueContainer: Hye
}, x0e = function(e) {
  return Hn(Hn({}, jd), e.components);
}, JG = Number.isNaN || function(e) {
  return typeof e == "number" && e !== e;
};
function A0e(t, e) {
  return !!(t === e || JG(t) && JG(e));
}
function k0e(t, e) {
  if (t.length !== e.length)
    return !1;
  for (var n = 0; n < t.length; n++)
    if (!A0e(t[n], e[n]))
      return !1;
  return !0;
}
function R0e(t, e) {
  e === void 0 && (e = k0e);
  var n = null;
  function r() {
    for (var a = [], i = 0; i < arguments.length; i++)
      a[i] = arguments[i];
    if (n && n.lastThis === this && e(a, n.lastArgs))
      return n.lastResult;
    var o = t.apply(this, a);
    return n = {
      lastResult: o,
      lastArgs: a,
      lastThis: this
    }, o;
  }
  return r.clear = function() {
    n = null;
  }, r;
}
function I0e() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var D0e = process.env.NODE_ENV === "production" ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : {
  name: "1f43avz-a11yText-A11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
  toString: I0e
}, eV = function(e) {
  return Xn("span", rn({
    css: D0e
  }, e));
}, N0e = {
  guidance: function(e) {
    var n = e.isSearchable, r = e.isMulti, a = e.isDisabled, i = e.tabSelectsValue, o = e.context;
    switch (o) {
      case "menu":
        return "Use Up and Down to choose options".concat(a ? "" : ", press Enter to select the currently focused option", ", press Escape to exit the menu").concat(i ? ", press Tab to select the option and exit the menu" : "", ".");
      case "input":
        return "".concat(e["aria-label"] || "Select", " is focused ").concat(n ? ",type to refine list" : "", ", press Down to open the menu, ").concat(r ? " press left to focus selected values" : "");
      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
      default:
        return "";
    }
  },
  onChange: function(e) {
    var n = e.action, r = e.label, a = r === void 0 ? "" : r, i = e.labels, o = e.isDisabled;
    switch (n) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(a, ", deselected.");
      case "clear":
        return "All selected options have been cleared.";
      case "initial-input-focus":
        return "option".concat(i.length > 1 ? "s" : "", " ").concat(i.join(","), ", selected.");
      case "select-option":
        return o ? "option ".concat(a, " is disabled. Select another option.") : "option ".concat(a, ", selected.");
      default:
        return "";
    }
  },
  onFocus: function(e) {
    var n = e.context, r = e.focused, a = e.options, i = e.label, o = i === void 0 ? "" : i, s = e.selectValue, u = e.isDisabled, f = e.isSelected, p = function(w, _) {
      return w && w.length ? "".concat(w.indexOf(_) + 1, " of ").concat(w.length) : "";
    };
    if (n === "value" && s)
      return "value ".concat(o, " focused, ").concat(p(s, r), ".");
    if (n === "menu") {
      var m = u ? " disabled" : "", v = "".concat(f ? "selected" : "focused").concat(m);
      return "option ".concat(o, " ").concat(v, ", ").concat(p(a, r), ".");
    }
    return "";
  },
  onFilter: function(e) {
    var n = e.inputValue, r = e.resultsMessage;
    return "".concat(r).concat(n ? " for search term " + n : "", ".");
  }
}, P0e = function(e) {
  var n = e.ariaSelection, r = e.focusedOption, a = e.focusedValue, i = e.focusableOptions, o = e.isFocused, s = e.selectValue, u = e.selectProps, f = e.id, p = u.ariaLiveMessages, m = u.getOptionLabel, v = u.inputValue, O = u.isMulti, w = u.isOptionDisabled, _ = u.isSearchable, C = u.menuIsOpen, A = u.options, N = u.screenReaderStatus, P = u.tabSelectsValue, I = u["aria-label"], D = u["aria-live"], M = Mc(function() {
    return Hn(Hn({}, N0e), p || {});
  }, [p]), H = Mc(function() {
    var ee = "";
    if (n && M.onChange) {
      var fe = n.option, de = n.options, ie = n.removedValue, le = n.removedValues, ye = n.value, B = function(Ee) {
        return Array.isArray(Ee) ? null : Ee;
      }, pe = ie || fe || B(ye), _e = pe ? m(pe) : "", Z = de || le || void 0, ce = Z ? Z.map(m) : [], j = Hn({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: pe && w(pe, s),
        label: _e,
        labels: ce
      }, n);
      ee = M.onChange(j);
    }
    return ee;
  }, [n, M, w, s, m]), Y = Mc(function() {
    var ee = "", fe = r || a, de = !!(r && s && s.includes(r));
    if (fe && M.onFocus) {
      var ie = {
        focused: fe,
        label: m(fe),
        isDisabled: w(fe, s),
        isSelected: de,
        options: i,
        context: fe === r ? "menu" : "value",
        selectValue: s
      };
      ee = M.onFocus(ie);
    }
    return ee;
  }, [r, a, m, w, M, i, s]), q = Mc(function() {
    var ee = "";
    if (C && A.length && M.onFilter) {
      var fe = N({
        count: i.length
      });
      ee = M.onFilter({
        inputValue: v,
        resultsMessage: fe
      });
    }
    return ee;
  }, [i, v, C, M, A, N]), Q = Mc(function() {
    var ee = "";
    if (M.guidance) {
      var fe = a ? "value" : C ? "menu" : "input";
      ee = M.guidance({
        "aria-label": I,
        context: fe,
        isDisabled: r && w(r, s),
        isMulti: O,
        isSearchable: _,
        tabSelectsValue: P
      });
    }
    return ee;
  }, [I, r, a, O, w, _, C, M, s, P]), ne = "".concat(Y, " ").concat(q, " ").concat(Q), J = Xn(r0, null, Xn("span", {
    id: "aria-selection"
  }, H), Xn("span", {
    id: "aria-context"
  }, ne)), ue = (n == null ? void 0 : n.action) === "initial-input-focus";
  return Xn(r0, null, Xn(eV, {
    id: f
  }, ue && J), Xn(eV, {
    "aria-live": D,
    "aria-atomic": "false",
    "aria-relevant": "additions text"
  }, o && !ue && J));
}, RF = [{
  base: "A",
  letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
}, {
  base: "AA",
  letters: "Ꜳ"
}, {
  base: "AE",
  letters: "ÆǼǢ"
}, {
  base: "AO",
  letters: "Ꜵ"
}, {
  base: "AU",
  letters: "Ꜷ"
}, {
  base: "AV",
  letters: "ꜸꜺ"
}, {
  base: "AY",
  letters: "Ꜽ"
}, {
  base: "B",
  letters: "BⒷＢḂḄḆɃƂƁ"
}, {
  base: "C",
  letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
}, {
  base: "D",
  letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
}, {
  base: "DZ",
  letters: "ǱǄ"
}, {
  base: "Dz",
  letters: "ǲǅ"
}, {
  base: "E",
  letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
}, {
  base: "F",
  letters: "FⒻＦḞƑꝻ"
}, {
  base: "G",
  letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
}, {
  base: "H",
  letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
}, {
  base: "I",
  letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
}, {
  base: "J",
  letters: "JⒿＪĴɈ"
}, {
  base: "K",
  letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
}, {
  base: "L",
  letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
}, {
  base: "LJ",
  letters: "Ǉ"
}, {
  base: "Lj",
  letters: "ǈ"
}, {
  base: "M",
  letters: "MⓂＭḾṀṂⱮƜ"
}, {
  base: "N",
  letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
}, {
  base: "NJ",
  letters: "Ǌ"
}, {
  base: "Nj",
  letters: "ǋ"
}, {
  base: "O",
  letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
}, {
  base: "OI",
  letters: "Ƣ"
}, {
  base: "OO",
  letters: "Ꝏ"
}, {
  base: "OU",
  letters: "Ȣ"
}, {
  base: "P",
  letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
}, {
  base: "Q",
  letters: "QⓆＱꝖꝘɊ"
}, {
  base: "R",
  letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
}, {
  base: "S",
  letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
}, {
  base: "T",
  letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
}, {
  base: "TZ",
  letters: "Ꜩ"
}, {
  base: "U",
  letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
}, {
  base: "V",
  letters: "VⓋＶṼṾƲꝞɅ"
}, {
  base: "VY",
  letters: "Ꝡ"
}, {
  base: "W",
  letters: "WⓌＷẀẂŴẆẄẈⱲ"
}, {
  base: "X",
  letters: "XⓍＸẊẌ"
}, {
  base: "Y",
  letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
}, {
  base: "Z",
  letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
}, {
  base: "a",
  letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
}, {
  base: "aa",
  letters: "ꜳ"
}, {
  base: "ae",
  letters: "æǽǣ"
}, {
  base: "ao",
  letters: "ꜵ"
}, {
  base: "au",
  letters: "ꜷ"
}, {
  base: "av",
  letters: "ꜹꜻ"
}, {
  base: "ay",
  letters: "ꜽ"
}, {
  base: "b",
  letters: "bⓑｂḃḅḇƀƃɓ"
}, {
  base: "c",
  letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
}, {
  base: "d",
  letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
}, {
  base: "dz",
  letters: "ǳǆ"
}, {
  base: "e",
  letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
}, {
  base: "f",
  letters: "fⓕｆḟƒꝼ"
}, {
  base: "g",
  letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
}, {
  base: "h",
  letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
}, {
  base: "hv",
  letters: "ƕ"
}, {
  base: "i",
  letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
}, {
  base: "j",
  letters: "jⓙｊĵǰɉ"
}, {
  base: "k",
  letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
}, {
  base: "l",
  letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
}, {
  base: "lj",
  letters: "ǉ"
}, {
  base: "m",
  letters: "mⓜｍḿṁṃɱɯ"
}, {
  base: "n",
  letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
}, {
  base: "nj",
  letters: "ǌ"
}, {
  base: "o",
  letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
}, {
  base: "oi",
  letters: "ƣ"
}, {
  base: "ou",
  letters: "ȣ"
}, {
  base: "oo",
  letters: "ꝏ"
}, {
  base: "p",
  letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
}, {
  base: "q",
  letters: "qⓠｑɋꝗꝙ"
}, {
  base: "r",
  letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
}, {
  base: "s",
  letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
}, {
  base: "t",
  letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
}, {
  base: "tz",
  letters: "ꜩ"
}, {
  base: "u",
  letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
}, {
  base: "v",
  letters: "vⓥｖṽṿʋꝟʌ"
}, {
  base: "vy",
  letters: "ꝡ"
}, {
  base: "w",
  letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
}, {
  base: "x",
  letters: "xⓧｘẋẍ"
}, {
  base: "y",
  letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
}, {
  base: "z",
  letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
}], L0e = new RegExp("[" + RF.map(function(t) {
  return t.letters;
}).join("") + "]", "g"), one = {};
for (var SM = 0; SM < RF.length; SM++)
  for (var wM = RF[SM], TM = 0; TM < wM.letters.length; TM++)
    one[wM.letters[TM]] = wM.base;
var sne = function(e) {
  return e.replace(L0e, function(n) {
    return one[n];
  });
}, M0e = R0e(sne), tV = function(e) {
  return e.replace(/^\s+|\s+$/g, "");
}, F0e = function(e) {
  return "".concat(e.label, " ").concat(e.value);
}, lne = function(e) {
  return function(n, r) {
    if (n.data.__isNew__)
      return !0;
    var a = Hn({
      ignoreCase: !0,
      ignoreAccents: !0,
      stringify: F0e,
      trim: !0,
      matchFrom: "any"
    }, e), i = a.ignoreCase, o = a.ignoreAccents, s = a.stringify, u = a.trim, f = a.matchFrom, p = u ? tV(r) : r, m = u ? tV(s(n)) : s(n);
    return i && (p = p.toLowerCase(), m = m.toLowerCase()), o && (p = M0e(p), m = sne(m)), f === "start" ? m.substr(0, p.length) === p : m.indexOf(p) > -1;
  };
}, $0e = ["innerRef"];
function B0e(t) {
  var e = t.innerRef, n = lv(t, $0e), r = xye(n, "onExited", "in", "enter", "exit", "appear");
  return Xn("input", rn({
    ref: e
  }, r, {
    css: /* @__PURE__ */ X5({
      label: "dummyInput",
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: "transparent",
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, process.env.NODE_ENV === "production" ? "" : ";label:DummyInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgcmVtb3ZlUHJvcHMgfSBmcm9tICcuLi91dGlscyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIER1bW15SW5wdXQoe1xuICBpbm5lclJlZixcbiAgLi4ucHJvcHNcbn06IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snaW5wdXQnXSAmIHtcbiAgcmVhZG9ubHkgaW5uZXJSZWY6IFJlZjxIVE1MSW5wdXRFbGVtZW50Pjtcbn0pIHtcbiAgLy8gUmVtb3ZlIGFuaW1hdGlvbiBwcm9wcyBub3QgbWVhbnQgZm9yIEhUTUwgZWxlbWVudHNcbiAgY29uc3QgZmlsdGVyZWRQcm9wcyA9IHJlbW92ZVByb3BzKFxuICAgIHByb3BzLFxuICAgICdvbkV4aXRlZCcsXG4gICAgJ2luJyxcbiAgICAnZW50ZXInLFxuICAgICdleGl0JyxcbiAgICAnYXBwZWFyJ1xuICApO1xuXG4gIHJldHVybiAoXG4gICAgPGlucHV0XG4gICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgey4uLmZpbHRlcmVkUHJvcHN9XG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdkdW1teUlucHV0JyxcbiAgICAgICAgLy8gZ2V0IHJpZCBvZiBhbnkgZGVmYXVsdCBzdHlsZXNcbiAgICAgICAgYmFja2dyb3VuZDogMCxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHRoaXMgaGlkZXMgdGhlIGZsYXNoaW5nIGN1cnNvclxuICAgICAgICBjYXJldENvbG9yOiAndHJhbnNwYXJlbnQnLFxuICAgICAgICBmb250U2l6ZTogJ2luaGVyaXQnLFxuICAgICAgICBncmlkQXJlYTogJzEgLyAxIC8gMiAvIDMnLFxuICAgICAgICBvdXRsaW5lOiAwLFxuICAgICAgICBwYWRkaW5nOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHdpdGhvdXQgYHdpZHRoYCBicm93c2VycyB3b24ndCBhbGxvdyBmb2N1c1xuICAgICAgICB3aWR0aDogMSxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIGRlc2t0b3BcbiAgICAgICAgY29sb3I6ICd0cmFuc3BhcmVudCcsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBtb2JpbGUgd2hpbHN0IG1haW50YWluaW5nIFwic2Nyb2xsIGludG8gdmlld1wiIGJlaGF2aW91clxuICAgICAgICBsZWZ0OiAtMTAwLFxuICAgICAgICBvcGFjaXR5OiAwLFxuICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgdHJhbnNmb3JtOiAnc2NhbGUoLjAxKScsXG4gICAgICB9fVxuICAgIC8+XG4gICk7XG59XG4iXX0= */")
  }));
}
var U0e = function(e) {
  e.preventDefault(), e.stopPropagation();
};
function z0e(t) {
  var e = t.isEnabled, n = t.onBottomArrive, r = t.onBottomLeave, a = t.onTopArrive, i = t.onTopLeave, o = dr(!1), s = dr(!1), u = dr(0), f = dr(null), p = Ei(function(C, A) {
    if (f.current !== null) {
      var N = f.current, P = N.scrollTop, I = N.scrollHeight, D = N.clientHeight, M = f.current, H = A > 0, Y = I - D - P, q = !1;
      Y > A && o.current && (r && r(C), o.current = !1), H && s.current && (i && i(C), s.current = !1), H && A > Y ? (n && !o.current && n(C), M.scrollTop = I, q = !0, o.current = !0) : !H && -A > P && (a && !s.current && a(C), M.scrollTop = 0, q = !0, s.current = !0), q && U0e(C);
    }
  }, [n, r, a, i]), m = Ei(function(C) {
    p(C, C.deltaY);
  }, [p]), v = Ei(function(C) {
    u.current = C.changedTouches[0].clientY;
  }, []), O = Ei(function(C) {
    var A = u.current - C.changedTouches[0].clientY;
    p(C, A);
  }, [p]), w = Ei(function(C) {
    if (C) {
      var A = Tye ? {
        passive: !1
      } : !1;
      C.addEventListener("wheel", m, A), C.addEventListener("touchstart", v, A), C.addEventListener("touchmove", O, A);
    }
  }, [O, v, m]), _ = Ei(function(C) {
    C && (C.removeEventListener("wheel", m, !1), C.removeEventListener("touchstart", v, !1), C.removeEventListener("touchmove", O, !1));
  }, [O, v, m]);
  return Vn(function() {
    if (e) {
      var C = f.current;
      return w(C), function() {
        _(C);
      };
    }
  }, [e, w, _]), function(C) {
    f.current = C;
  };
}
var nV = ["boxSizing", "height", "overflow", "paddingRight", "position"], rV = {
  boxSizing: "border-box",
  // account for possible declaration `width: 100%;` on body
  overflow: "hidden",
  position: "relative",
  height: "100%"
};
function aV(t) {
  t.preventDefault();
}
function iV(t) {
  t.stopPropagation();
}
function oV() {
  var t = this.scrollTop, e = this.scrollHeight, n = t + this.offsetHeight;
  t === 0 ? this.scrollTop = 1 : n === e && (this.scrollTop = t - 1);
}
function sV() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var lV = !!(typeof window < "u" && window.document && window.document.createElement), fw = 0, VO = {
  capture: !1,
  passive: !1
};
function H0e(t) {
  var e = t.isEnabled, n = t.accountForScrollbars, r = n === void 0 ? !0 : n, a = dr({}), i = dr(null), o = Ei(function(u) {
    if (lV) {
      var f = document.body, p = f && f.style;
      if (r && nV.forEach(function(w) {
        var _ = p && p[w];
        a.current[w] = _;
      }), r && fw < 1) {
        var m = parseInt(a.current.paddingRight, 10) || 0, v = document.body ? document.body.clientWidth : 0, O = window.innerWidth - v + m || 0;
        Object.keys(rV).forEach(function(w) {
          var _ = rV[w];
          p && (p[w] = _);
        }), p && (p.paddingRight = "".concat(O, "px"));
      }
      f && sV() && (f.addEventListener("touchmove", aV, VO), u && (u.addEventListener("touchstart", oV, VO), u.addEventListener("touchmove", iV, VO))), fw += 1;
    }
  }, [r]), s = Ei(function(u) {
    if (lV) {
      var f = document.body, p = f && f.style;
      fw = Math.max(fw - 1, 0), r && fw < 1 && nV.forEach(function(m) {
        var v = a.current[m];
        p && (p[m] = v);
      }), f && sV() && (f.removeEventListener("touchmove", aV, VO), u && (u.removeEventListener("touchstart", oV, VO), u.removeEventListener("touchmove", iV, VO)));
    }
  }, [r]);
  return Vn(function() {
    if (e) {
      var u = i.current;
      return o(u), function() {
        s(u);
      };
    }
  }, [e, o, s]), function(u) {
    i.current = u;
  };
}
function W0e() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var Q0e = function() {
  return document.activeElement && document.activeElement.blur();
}, j0e = process.env.NODE_ENV === "production" ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : {
  name: "bp8cua-ScrollManager",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: W0e
};
function G0e(t) {
  var e = t.children, n = t.lockEnabled, r = t.captureEnabled, a = r === void 0 ? !0 : r, i = t.onBottomArrive, o = t.onBottomLeave, s = t.onTopArrive, u = t.onTopLeave, f = z0e({
    isEnabled: a,
    onBottomArrive: i,
    onBottomLeave: o,
    onTopArrive: s,
    onTopLeave: u
  }), p = H0e({
    isEnabled: n
  }), m = function(O) {
    f(O), p(O);
  };
  return Xn(r0, null, n && Xn("div", {
    onClick: Q0e,
    css: j0e
  }), e(m));
}
function V0e() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var Y0e = process.env.NODE_ENV === "production" ? {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
} : {
  name: "5kkxb2-requiredInput-RequiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%;label:RequiredInput;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlcXVpcmVkSW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWFJIiwiZmlsZSI6IlJlcXVpcmVkSW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBGb2N1c0V2ZW50SGFuZGxlciwgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmNvbnN0IFJlcXVpcmVkSW5wdXQ6IEZ1bmN0aW9uQ29tcG9uZW50PHtcbiAgcmVhZG9ubHkgbmFtZTogc3RyaW5nO1xuICByZWFkb25seSBvbkZvY3VzOiBGb2N1c0V2ZW50SGFuZGxlcjxIVE1MSW5wdXRFbGVtZW50Pjtcbn0+ID0gKHsgbmFtZSwgb25Gb2N1cyB9KSA9PiAoXG4gIDxpbnB1dFxuICAgIHJlcXVpcmVkXG4gICAgbmFtZT17bmFtZX1cbiAgICB0YWJJbmRleD17LTF9XG4gICAgb25Gb2N1cz17b25Gb2N1c31cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAncmVxdWlyZWRJbnB1dCcsXG4gICAgICBvcGFjaXR5OiAwLFxuICAgICAgcG9pbnRlckV2ZW50czogJ25vbmUnLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBib3R0b206IDAsXG4gICAgICBsZWZ0OiAwLFxuICAgICAgcmlnaHQ6IDAsXG4gICAgICB3aWR0aDogJzEwMCUnLFxuICAgIH19XG4gICAgLy8gUHJldmVudCBgU3dpdGNoaW5nIGZyb20gdW5jb250cm9sbGVkIHRvIGNvbnRyb2xsZWRgIGVycm9yXG4gICAgdmFsdWU9XCJcIlxuICAgIG9uQ2hhbmdlPXsoKSA9PiB7fX1cbiAgLz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IFJlcXVpcmVkSW5wdXQ7XG4iXX0= */",
  toString: V0e
}, Z0e = function(e) {
  var n = e.name, r = e.onFocus;
  return Xn("input", {
    required: !0,
    name: n,
    tabIndex: -1,
    onFocus: r,
    css: Y0e,
    value: "",
    onChange: function() {
    }
  });
}, X0e = function(e) {
  return e.label;
}, une = function(e) {
  return e.label;
}, cne = function(e) {
  return e.value;
}, q0e = function(e) {
  return !!e.isDisabled;
}, K0e = {
  clearIndicator: Xye,
  container: Bye,
  control: n0e,
  dropdownIndicator: Yye,
  group: i0e,
  groupHeading: s0e,
  indicatorsContainer: Wye,
  indicatorSeparator: Kye,
  input: c0e,
  loadingIndicator: t0e,
  loadingMessage: Mye,
  menu: Rye,
  menuList: Nye,
  menuPortal: Fye,
  multiValue: h0e,
  multiValueLabel: m0e,
  multiValueRemove: g0e,
  noOptionsMessage: Lye,
  option: E0e,
  placeholder: w0e,
  singleValue: _0e,
  valueContainer: zye
};
function J0e(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = Hn({}, t);
  return Object.keys(e).forEach(function(r) {
    var a = r;
    t[a] ? n[a] = function(i, o) {
      return e[a](t[a](i, o), o);
    } : n[a] = e[a];
  }), n;
}
var eOe = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
}, tOe = 4, fne = 4, nOe = 38, rOe = fne * 2, aOe = {
  baseUnit: fne,
  controlHeight: nOe,
  menuGutter: rOe
}, TA = {
  borderRadius: tOe,
  colors: eOe,
  spacing: aOe
}, iOe = {
  "aria-live": "polite",
  backspaceRemovesValue: !0,
  blurInputOnSelect: qG(),
  captureMenuScroll: !qG(),
  classNames: {},
  closeMenuOnSelect: !0,
  closeMenuOnScroll: !1,
  components: {},
  controlShouldRenderValue: !0,
  escapeClearsValue: !1,
  filterOption: lne(),
  formatGroupLabel: X0e,
  getOptionLabel: une,
  getOptionValue: cne,
  isDisabled: !1,
  isLoading: !1,
  isMulti: !1,
  isRtl: !1,
  isSearchable: !0,
  isOptionDisabled: q0e,
  loadingMessage: function() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: !1,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: !1,
  menuShouldScrollIntoView: !Sye(),
  noOptionsMessage: function() {
    return "No options";
  },
  openMenuOnFocus: !1,
  openMenuOnClick: !0,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function(e) {
    var n = e.count;
    return "".concat(n, " result").concat(n !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: !0,
  unstyled: !1
};
function uV(t, e, n, r) {
  var a = mne(t, e, n), i = gne(t, e, n), o = hne(t, e), s = eR(t, e);
  return {
    type: "option",
    data: e,
    isDisabled: a,
    isSelected: i,
    label: o,
    value: s,
    index: r
  };
}
function dne(t, e) {
  return t.options.map(function(n, r) {
    if ("options" in n) {
      var a = n.options.map(function(o, s) {
        return uV(t, o, e, s);
      }).filter(function(o) {
        return cV(t, o);
      });
      return a.length > 0 ? {
        type: "group",
        data: n,
        options: a,
        index: r
      } : void 0;
    }
    var i = uV(t, n, e, r);
    return cV(t, i) ? i : void 0;
  }).filter(_ye);
}
function pne(t) {
  return t.reduce(function(e, n) {
    return n.type === "group" ? e.push.apply(e, Gw(n.options.map(function(r) {
      return r.data;
    }))) : e.push(n.data), e;
  }, []);
}
function oOe(t, e) {
  return pne(dne(t, e));
}
function cV(t, e) {
  var n = t.inputValue, r = n === void 0 ? "" : n, a = e.data, i = e.isSelected, o = e.label, s = e.value;
  return (!vne(t) || !i) && bne(t, {
    label: o,
    value: s,
    data: a
  }, r);
}
function sOe(t, e) {
  var n = t.focusedValue, r = t.selectValue, a = r.indexOf(n);
  if (a > -1) {
    var i = e.indexOf(n);
    if (i > -1)
      return n;
    if (a < e.length)
      return e[a];
  }
  return null;
}
function lOe(t, e) {
  var n = t.focusedOption;
  return n && e.indexOf(n) > -1 ? n : e[0];
}
var hne = function(e, n) {
  return e.getOptionLabel(n);
}, eR = function(e, n) {
  return e.getOptionValue(n);
};
function mne(t, e, n) {
  return typeof t.isOptionDisabled == "function" ? t.isOptionDisabled(e, n) : !1;
}
function gne(t, e, n) {
  if (n.indexOf(e) > -1)
    return !0;
  if (typeof t.isOptionSelected == "function")
    return t.isOptionSelected(e, n);
  var r = eR(t, e);
  return n.some(function(a) {
    return eR(t, a) === r;
  });
}
function bne(t, e, n) {
  return t.filterOption ? t.filterOption(e, n) : !0;
}
var vne = function(e) {
  var n = e.hideSelectedOptions, r = e.isMulti;
  return n === void 0 ? r : n;
}, uOe = 1, YI = /* @__PURE__ */ function(t) {
  $be(n, t);
  var e = Ube(n);
  function n(r) {
    var a;
    if (Mbe(this, n), a = e.call(this, r), a.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedValue: null,
      inputIsHidden: !1,
      isFocused: !1,
      selectValue: [],
      clearFocusValueOnUpdate: !1,
      prevWasFocused: !1,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0
    }, a.blockOptionHover = !1, a.isComposing = !1, a.commonProps = void 0, a.initialTouchX = 0, a.initialTouchY = 0, a.instancePrefix = "", a.openAfterFocus = !1, a.scrollToFocusedOptionOnUpdate = !1, a.userIsDragging = void 0, a.controlRef = null, a.getControlRef = function(s) {
      a.controlRef = s;
    }, a.focusedOptionRef = null, a.getFocusedOptionRef = function(s) {
      a.focusedOptionRef = s;
    }, a.menuListRef = null, a.getMenuListRef = function(s) {
      a.menuListRef = s;
    }, a.inputRef = null, a.getInputRef = function(s) {
      a.inputRef = s;
    }, a.focus = a.focusInput, a.blur = a.blurInput, a.onChange = function(s, u) {
      var f = a.props, p = f.onChange, m = f.name;
      u.name = m, a.ariaOnChange(s, u), p(s, u);
    }, a.setValue = function(s, u, f) {
      var p = a.props, m = p.closeMenuOnSelect, v = p.isMulti, O = p.inputValue;
      a.onInputChange("", {
        action: "set-value",
        prevInputValue: O
      }), m && (a.setState({
        inputIsHiddenAfterUpdate: !v
      }), a.onMenuClose()), a.setState({
        clearFocusValueOnUpdate: !0
      }), a.onChange(s, {
        action: u,
        option: f
      });
    }, a.selectOption = function(s) {
      var u = a.props, f = u.blurInputOnSelect, p = u.isMulti, m = u.name, v = a.state.selectValue, O = p && a.isOptionSelected(s, v), w = a.isOptionDisabled(s, v);
      if (O) {
        var _ = a.getOptionValue(s);
        a.setValue(v.filter(function(C) {
          return a.getOptionValue(C) !== _;
        }), "deselect-option", s);
      } else if (!w)
        p ? a.setValue([].concat(Gw(v), [s]), "select-option", s) : a.setValue(s, "select-option");
      else {
        a.ariaOnChange(s, {
          action: "select-option",
          option: s,
          name: m
        });
        return;
      }
      f && a.blurInput();
    }, a.removeValue = function(s) {
      var u = a.props.isMulti, f = a.state.selectValue, p = a.getOptionValue(s), m = f.filter(function(O) {
        return a.getOptionValue(O) !== p;
      }), v = Dw(u, m, m[0] || null);
      a.onChange(v, {
        action: "remove-value",
        removedValue: s
      }), a.focusInput();
    }, a.clearValue = function() {
      var s = a.state.selectValue;
      a.onChange(Dw(a.props.isMulti, [], null), {
        action: "clear",
        removedValues: s
      });
    }, a.popValue = function() {
      var s = a.props.isMulti, u = a.state.selectValue, f = u[u.length - 1], p = u.slice(0, u.length - 1), m = Dw(s, p, p[0] || null);
      a.onChange(m, {
        action: "pop-value",
        removedValue: f
      });
    }, a.getValue = function() {
      return a.state.selectValue;
    }, a.cx = function() {
      for (var s = arguments.length, u = new Array(s), f = 0; f < s; f++)
        u[f] = arguments[f];
      return gye.apply(void 0, [a.props.classNamePrefix].concat(u));
    }, a.getOptionLabel = function(s) {
      return hne(a.props, s);
    }, a.getOptionValue = function(s) {
      return eR(a.props, s);
    }, a.getStyles = function(s, u) {
      var f = a.props.unstyled, p = K0e[s](u, f);
      p.boxSizing = "border-box";
      var m = a.props.styles[s];
      return m ? m(p, u) : p;
    }, a.getClassNames = function(s, u) {
      var f, p;
      return (f = (p = a.props.classNames)[s]) === null || f === void 0 ? void 0 : f.call(p, u);
    }, a.getElementId = function(s) {
      return "".concat(a.instancePrefix, "-").concat(s);
    }, a.getComponents = function() {
      return x0e(a.props);
    }, a.buildCategorizedOptions = function() {
      return dne(a.props, a.state.selectValue);
    }, a.getCategorizedOptions = function() {
      return a.props.menuIsOpen ? a.buildCategorizedOptions() : [];
    }, a.buildFocusableOptions = function() {
      return pne(a.buildCategorizedOptions());
    }, a.getFocusableOptions = function() {
      return a.props.menuIsOpen ? a.buildFocusableOptions() : [];
    }, a.ariaOnChange = function(s, u) {
      a.setState({
        ariaSelection: Hn({
          value: s
        }, u)
      });
    }, a.onMenuMouseDown = function(s) {
      s.button === 0 && (s.stopPropagation(), s.preventDefault(), a.focusInput());
    }, a.onMenuMouseMove = function(s) {
      a.blockOptionHover = !1;
    }, a.onControlMouseDown = function(s) {
      if (!s.defaultPrevented) {
        var u = a.props.openMenuOnClick;
        a.state.isFocused ? a.props.menuIsOpen ? s.target.tagName !== "INPUT" && s.target.tagName !== "TEXTAREA" && a.onMenuClose() : u && a.openMenu("first") : (u && (a.openAfterFocus = !0), a.focusInput()), s.target.tagName !== "INPUT" && s.target.tagName !== "TEXTAREA" && s.preventDefault();
      }
    }, a.onDropdownIndicatorMouseDown = function(s) {
      if (!(s && s.type === "mousedown" && s.button !== 0) && !a.props.isDisabled) {
        var u = a.props, f = u.isMulti, p = u.menuIsOpen;
        a.focusInput(), p ? (a.setState({
          inputIsHiddenAfterUpdate: !f
        }), a.onMenuClose()) : a.openMenu("first"), s.preventDefault();
      }
    }, a.onClearIndicatorMouseDown = function(s) {
      s && s.type === "mousedown" && s.button !== 0 || (a.clearValue(), s.preventDefault(), a.openAfterFocus = !1, s.type === "touchend" ? a.focusInput() : setTimeout(function() {
        return a.focusInput();
      }));
    }, a.onScroll = function(s) {
      typeof a.props.closeMenuOnScroll == "boolean" ? s.target instanceof HTMLElement && VI(s.target) && a.props.onMenuClose() : typeof a.props.closeMenuOnScroll == "function" && a.props.closeMenuOnScroll(s) && a.props.onMenuClose();
    }, a.onCompositionStart = function() {
      a.isComposing = !0;
    }, a.onCompositionEnd = function() {
      a.isComposing = !1;
    }, a.onTouchStart = function(s) {
      var u = s.touches, f = u && u.item(0);
      f && (a.initialTouchX = f.clientX, a.initialTouchY = f.clientY, a.userIsDragging = !1);
    }, a.onTouchMove = function(s) {
      var u = s.touches, f = u && u.item(0);
      if (f) {
        var p = Math.abs(f.clientX - a.initialTouchX), m = Math.abs(f.clientY - a.initialTouchY), v = 5;
        a.userIsDragging = p > v || m > v;
      }
    }, a.onTouchEnd = function(s) {
      a.userIsDragging || (a.controlRef && !a.controlRef.contains(s.target) && a.menuListRef && !a.menuListRef.contains(s.target) && a.blurInput(), a.initialTouchX = 0, a.initialTouchY = 0);
    }, a.onControlTouchEnd = function(s) {
      a.userIsDragging || a.onControlMouseDown(s);
    }, a.onClearIndicatorTouchEnd = function(s) {
      a.userIsDragging || a.onClearIndicatorMouseDown(s);
    }, a.onDropdownIndicatorTouchEnd = function(s) {
      a.userIsDragging || a.onDropdownIndicatorMouseDown(s);
    }, a.handleInputChange = function(s) {
      var u = a.props.inputValue, f = s.currentTarget.value;
      a.setState({
        inputIsHiddenAfterUpdate: !1
      }), a.onInputChange(f, {
        action: "input-change",
        prevInputValue: u
      }), a.props.menuIsOpen || a.onMenuOpen();
    }, a.onInputFocus = function(s) {
      a.props.onFocus && a.props.onFocus(s), a.setState({
        inputIsHiddenAfterUpdate: !1,
        isFocused: !0
      }), (a.openAfterFocus || a.props.openMenuOnFocus) && a.openMenu("first"), a.openAfterFocus = !1;
    }, a.onInputBlur = function(s) {
      var u = a.props.inputValue;
      if (a.menuListRef && a.menuListRef.contains(document.activeElement)) {
        a.inputRef.focus();
        return;
      }
      a.props.onBlur && a.props.onBlur(s), a.onInputChange("", {
        action: "input-blur",
        prevInputValue: u
      }), a.onMenuClose(), a.setState({
        focusedValue: null,
        isFocused: !1
      });
    }, a.onOptionHover = function(s) {
      a.blockOptionHover || a.state.focusedOption === s || a.setState({
        focusedOption: s
      });
    }, a.shouldHideSelectedOptions = function() {
      return vne(a.props);
    }, a.onValueInputFocus = function(s) {
      s.preventDefault(), s.stopPropagation(), a.focus();
    }, a.onKeyDown = function(s) {
      var u = a.props, f = u.isMulti, p = u.backspaceRemovesValue, m = u.escapeClearsValue, v = u.inputValue, O = u.isClearable, w = u.isDisabled, _ = u.menuIsOpen, C = u.onKeyDown, A = u.tabSelectsValue, N = u.openMenuOnFocus, P = a.state, I = P.focusedOption, D = P.focusedValue, M = P.selectValue;
      if (!w && !(typeof C == "function" && (C(s), s.defaultPrevented))) {
        switch (a.blockOptionHover = !0, s.key) {
          case "ArrowLeft":
            if (!f || v)
              return;
            a.focusValue("previous");
            break;
          case "ArrowRight":
            if (!f || v)
              return;
            a.focusValue("next");
            break;
          case "Delete":
          case "Backspace":
            if (v)
              return;
            if (D)
              a.removeValue(D);
            else {
              if (!p)
                return;
              f ? a.popValue() : O && a.clearValue();
            }
            break;
          case "Tab":
            if (a.isComposing || s.shiftKey || !_ || !A || !I || // don't capture the event if the menu opens on focus and the focused
            // option is already selected; it breaks the flow of navigation
            N && a.isOptionSelected(I, M))
              return;
            a.selectOption(I);
            break;
          case "Enter":
            if (s.keyCode === 229)
              break;
            if (_) {
              if (!I || a.isComposing)
                return;
              a.selectOption(I);
              break;
            }
            return;
          case "Escape":
            _ ? (a.setState({
              inputIsHiddenAfterUpdate: !1
            }), a.onInputChange("", {
              action: "menu-close",
              prevInputValue: v
            }), a.onMenuClose()) : O && m && a.clearValue();
            break;
          case " ":
            if (v)
              return;
            if (!_) {
              a.openMenu("first");
              break;
            }
            if (!I)
              return;
            a.selectOption(I);
            break;
          case "ArrowUp":
            _ ? a.focusOption("up") : a.openMenu("last");
            break;
          case "ArrowDown":
            _ ? a.focusOption("down") : a.openMenu("first");
            break;
          case "PageUp":
            if (!_)
              return;
            a.focusOption("pageup");
            break;
          case "PageDown":
            if (!_)
              return;
            a.focusOption("pagedown");
            break;
          case "Home":
            if (!_)
              return;
            a.focusOption("first");
            break;
          case "End":
            if (!_)
              return;
            a.focusOption("last");
            break;
          default:
            return;
        }
        s.preventDefault();
      }
    }, a.instancePrefix = "react-select-" + (a.props.instanceId || ++uOe), a.state.selectValue = Kk(r.value), r.menuIsOpen && a.state.selectValue.length) {
      var i = a.buildFocusableOptions(), o = i.indexOf(a.state.selectValue[0]);
      a.state.focusedOption = i[o];
    }
    return a;
  }
  return Fbe(n, [{
    key: "componentDidMount",
    value: function() {
      this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput(), this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef && XG(this.menuListRef, this.focusedOptionRef);
    }
  }, {
    key: "componentDidUpdate",
    value: function(a) {
      var i = this.props, o = i.isDisabled, s = i.menuIsOpen, u = this.state.isFocused;
      // ensure focus is restored correctly when the control becomes enabled
      (u && !o && a.isDisabled || // ensure focus is on the Input when the menu opens
      u && s && !a.menuIsOpen) && this.focusInput(), u && o && !a.isDisabled ? this.setState({
        isFocused: !1
      }, this.onMenuClose) : !u && !o && a.isDisabled && this.inputRef === document.activeElement && this.setState({
        isFocused: !0
      }), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (XG(this.menuListRef, this.focusedOptionRef), this.scrollToFocusedOptionOnUpdate = !1);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      }), this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function(a, i) {
      this.props.onInputChange(a, i);
    }
    // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function() {
      this.inputRef && this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function() {
      this.inputRef && this.inputRef.blur();
    }
    // aliased for consumers
  }, {
    key: "openMenu",
    value: function(a) {
      var i = this, o = this.state, s = o.selectValue, u = o.isFocused, f = this.buildFocusableOptions(), p = a === "first" ? 0 : f.length - 1;
      if (!this.props.isMulti) {
        var m = f.indexOf(s[0]);
        m > -1 && (p = m);
      }
      this.scrollToFocusedOptionOnUpdate = !(u && this.menuListRef), this.setState({
        inputIsHiddenAfterUpdate: !1,
        focusedValue: null,
        focusedOption: f[p]
      }, function() {
        return i.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function(a) {
      var i = this.state, o = i.selectValue, s = i.focusedValue;
      if (this.props.isMulti) {
        this.setState({
          focusedOption: null
        });
        var u = o.indexOf(s);
        s || (u = -1);
        var f = o.length - 1, p = -1;
        if (o.length) {
          switch (a) {
            case "previous":
              u === 0 ? p = 0 : u === -1 ? p = f : p = u - 1;
              break;
            case "next":
              u > -1 && u < f && (p = u + 1);
              break;
          }
          this.setState({
            inputIsHidden: p !== -1,
            focusedValue: o[p]
          });
        }
      }
    }
  }, {
    key: "focusOption",
    value: function() {
      var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first", i = this.props.pageSize, o = this.state.focusedOption, s = this.getFocusableOptions();
      if (s.length) {
        var u = 0, f = s.indexOf(o);
        o || (f = -1), a === "up" ? u = f > 0 ? f - 1 : s.length - 1 : a === "down" ? u = (f + 1) % s.length : a === "pageup" ? (u = f - i, u < 0 && (u = 0)) : a === "pagedown" ? (u = f + i, u > s.length - 1 && (u = s.length - 1)) : a === "last" && (u = s.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({
          focusedOption: s[u],
          focusedValue: null
        });
      }
    }
  }, {
    key: "getTheme",
    value: (
      // ==============================
      // Getters
      // ==============================
      function() {
        return this.props.theme ? typeof this.props.theme == "function" ? this.props.theme(TA) : Hn(Hn({}, TA), this.props.theme) : TA;
      }
    )
  }, {
    key: "getCommonProps",
    value: function() {
      var a = this.clearValue, i = this.cx, o = this.getStyles, s = this.getClassNames, u = this.getValue, f = this.selectOption, p = this.setValue, m = this.props, v = m.isMulti, O = m.isRtl, w = m.options, _ = this.hasValue();
      return {
        clearValue: a,
        cx: i,
        getStyles: o,
        getClassNames: s,
        getValue: u,
        hasValue: _,
        isMulti: v,
        isRtl: O,
        options: w,
        selectOption: f,
        selectProps: m,
        setValue: p,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function() {
      var a = this.state.selectValue;
      return a.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function() {
      var a = this.props, i = a.isClearable, o = a.isMulti;
      return i === void 0 ? o : i;
    }
  }, {
    key: "isOptionDisabled",
    value: function(a, i) {
      return mne(this.props, a, i);
    }
  }, {
    key: "isOptionSelected",
    value: function(a, i) {
      return gne(this.props, a, i);
    }
  }, {
    key: "filterOption",
    value: function(a, i) {
      return bne(this.props, a, i);
    }
  }, {
    key: "formatOptionLabel",
    value: function(a, i) {
      if (typeof this.props.formatOptionLabel == "function") {
        var o = this.props.inputValue, s = this.state.selectValue;
        return this.props.formatOptionLabel(a, {
          context: i,
          inputValue: o,
          selectValue: s
        });
      } else
        return this.getOptionLabel(a);
    }
  }, {
    key: "formatGroupLabel",
    value: function(a) {
      return this.props.formatGroupLabel(a);
    }
    // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value: (
      // ==============================
      // Composition Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
      }
    )
  }, {
    key: "stopListeningComposition",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
    }
  }, {
    key: "startListeningToTouch",
    value: (
      // ==============================
      // Touch Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
      }
    )
  }, {
    key: "stopListeningToTouch",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
    }
  }, {
    key: "renderInput",
    value: (
      // ==============================
      // Renderers
      // ==============================
      function() {
        var a = this.props, i = a.isDisabled, o = a.isSearchable, s = a.inputId, u = a.inputValue, f = a.tabIndex, p = a.form, m = a.menuIsOpen, v = a.required, O = this.getComponents(), w = O.Input, _ = this.state, C = _.inputIsHidden, A = _.ariaSelection, N = this.commonProps, P = s || this.getElementId("input"), I = Hn(Hn(Hn({
          "aria-autocomplete": "list",
          "aria-expanded": m,
          "aria-haspopup": !0,
          "aria-errormessage": this.props["aria-errormessage"],
          "aria-invalid": this.props["aria-invalid"],
          "aria-label": this.props["aria-label"],
          "aria-labelledby": this.props["aria-labelledby"],
          "aria-required": v,
          role: "combobox"
        }, m && {
          "aria-controls": this.getElementId("listbox"),
          "aria-owns": this.getElementId("listbox")
        }), !o && {
          "aria-readonly": !0
        }), this.hasValue() ? (A == null ? void 0 : A.action) === "initial-input-focus" && {
          "aria-describedby": this.getElementId("live-region")
        } : {
          "aria-describedby": this.getElementId("placeholder")
        });
        return o ? /* @__PURE__ */ On.createElement(w, rn({}, N, {
          autoCapitalize: "none",
          autoComplete: "off",
          autoCorrect: "off",
          id: P,
          innerRef: this.getInputRef,
          isDisabled: i,
          isHidden: C,
          onBlur: this.onInputBlur,
          onChange: this.handleInputChange,
          onFocus: this.onInputFocus,
          spellCheck: "false",
          tabIndex: f,
          form: p,
          type: "text",
          value: u
        }, I)) : /* @__PURE__ */ On.createElement(B0e, rn({
          id: P,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: qk,
          onFocus: this.onInputFocus,
          disabled: i,
          tabIndex: f,
          inputMode: "none",
          form: p,
          value: ""
        }, I));
      }
    )
  }, {
    key: "renderPlaceholderOrValue",
    value: function() {
      var a = this, i = this.getComponents(), o = i.MultiValue, s = i.MultiValueContainer, u = i.MultiValueLabel, f = i.MultiValueRemove, p = i.SingleValue, m = i.Placeholder, v = this.commonProps, O = this.props, w = O.controlShouldRenderValue, _ = O.isDisabled, C = O.isMulti, A = O.inputValue, N = O.placeholder, P = this.state, I = P.selectValue, D = P.focusedValue, M = P.isFocused;
      if (!this.hasValue() || !w)
        return A ? null : /* @__PURE__ */ On.createElement(m, rn({}, v, {
          key: "placeholder",
          isDisabled: _,
          isFocused: M,
          innerProps: {
            id: this.getElementId("placeholder")
          }
        }), N);
      if (C)
        return I.map(function(Y, q) {
          var Q = Y === D, ne = "".concat(a.getOptionLabel(Y), "-").concat(a.getOptionValue(Y));
          return /* @__PURE__ */ On.createElement(o, rn({}, v, {
            components: {
              Container: s,
              Label: u,
              Remove: f
            },
            isFocused: Q,
            isDisabled: _,
            key: ne,
            index: q,
            removeProps: {
              onClick: function() {
                return a.removeValue(Y);
              },
              onTouchEnd: function() {
                return a.removeValue(Y);
              },
              onMouseDown: function(ue) {
                ue.preventDefault();
              }
            },
            data: Y
          }), a.formatOptionLabel(Y, "value"));
        });
      if (A)
        return null;
      var H = I[0];
      return /* @__PURE__ */ On.createElement(p, rn({}, v, {
        data: H,
        isDisabled: _
      }), this.formatOptionLabel(H, "value"));
    }
  }, {
    key: "renderClearIndicator",
    value: function() {
      var a = this.getComponents(), i = a.ClearIndicator, o = this.commonProps, s = this.props, u = s.isDisabled, f = s.isLoading, p = this.state.isFocused;
      if (!this.isClearable() || !i || u || !this.hasValue() || f)
        return null;
      var m = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ On.createElement(i, rn({}, o, {
        innerProps: m,
        isFocused: p
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function() {
      var a = this.getComponents(), i = a.LoadingIndicator, o = this.commonProps, s = this.props, u = s.isDisabled, f = s.isLoading, p = this.state.isFocused;
      if (!i || !f)
        return null;
      var m = {
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ On.createElement(i, rn({}, o, {
        innerProps: m,
        isDisabled: u,
        isFocused: p
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function() {
      var a = this.getComponents(), i = a.DropdownIndicator, o = a.IndicatorSeparator;
      if (!i || !o)
        return null;
      var s = this.commonProps, u = this.props.isDisabled, f = this.state.isFocused;
      return /* @__PURE__ */ On.createElement(o, rn({}, s, {
        isDisabled: u,
        isFocused: f
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function() {
      var a = this.getComponents(), i = a.DropdownIndicator;
      if (!i)
        return null;
      var o = this.commonProps, s = this.props.isDisabled, u = this.state.isFocused, f = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ On.createElement(i, rn({}, o, {
        innerProps: f,
        isDisabled: s,
        isFocused: u
      }));
    }
  }, {
    key: "renderMenu",
    value: function() {
      var a = this, i = this.getComponents(), o = i.Group, s = i.GroupHeading, u = i.Menu, f = i.MenuList, p = i.MenuPortal, m = i.LoadingMessage, v = i.NoOptionsMessage, O = i.Option, w = this.commonProps, _ = this.state.focusedOption, C = this.props, A = C.captureMenuScroll, N = C.inputValue, P = C.isLoading, I = C.loadingMessage, D = C.minMenuHeight, M = C.maxMenuHeight, H = C.menuIsOpen, Y = C.menuPlacement, q = C.menuPosition, Q = C.menuPortalTarget, ne = C.menuShouldBlockScroll, J = C.menuShouldScrollIntoView, ue = C.noOptionsMessage, ee = C.onMenuScrollToTop, fe = C.onMenuScrollToBottom;
      if (!H)
        return null;
      var de = function(Z, ce) {
        var j = Z.type, K = Z.data, Ee = Z.isDisabled, he = Z.isSelected, Ae = Z.label, Te = Z.value, je = _ === K, we = Ee ? void 0 : function() {
          return a.onOptionHover(K);
        }, lt = Ee ? void 0 : function() {
          return a.selectOption(K);
        }, st = "".concat(a.getElementId("option"), "-").concat(ce), Oe = {
          id: st,
          onClick: lt,
          onMouseMove: we,
          onMouseOver: we,
          tabIndex: -1
        };
        return /* @__PURE__ */ On.createElement(O, rn({}, w, {
          innerProps: Oe,
          data: K,
          isDisabled: Ee,
          isSelected: he,
          key: st,
          label: Ae,
          type: j,
          value: Te,
          isFocused: je,
          innerRef: je ? a.getFocusedOptionRef : void 0
        }), a.formatOptionLabel(Z.data, "menu"));
      }, ie;
      if (this.hasOptions())
        ie = this.getCategorizedOptions().map(function(_e) {
          if (_e.type === "group") {
            var Z = _e.data, ce = _e.options, j = _e.index, K = "".concat(a.getElementId("group"), "-").concat(j), Ee = "".concat(K, "-heading");
            return /* @__PURE__ */ On.createElement(o, rn({}, w, {
              key: K,
              data: Z,
              options: ce,
              Heading: s,
              headingProps: {
                id: Ee,
                data: _e.data
              },
              label: a.formatGroupLabel(_e.data)
            }), _e.options.map(function(he) {
              return de(he, "".concat(j, "-").concat(he.index));
            }));
          } else if (_e.type === "option")
            return de(_e, "".concat(_e.index));
        });
      else if (P) {
        var le = I({
          inputValue: N
        });
        if (le === null)
          return null;
        ie = /* @__PURE__ */ On.createElement(m, w, le);
      } else {
        var ye = ue({
          inputValue: N
        });
        if (ye === null)
          return null;
        ie = /* @__PURE__ */ On.createElement(v, w, ye);
      }
      var B = {
        minMenuHeight: D,
        maxMenuHeight: M,
        menuPlacement: Y,
        menuPosition: q,
        menuShouldScrollIntoView: J
      }, pe = /* @__PURE__ */ On.createElement(Iye, rn({}, w, B), function(_e) {
        var Z = _e.ref, ce = _e.placerProps, j = ce.placement, K = ce.maxHeight;
        return /* @__PURE__ */ On.createElement(u, rn({}, w, B, {
          innerRef: Z,
          innerProps: {
            onMouseDown: a.onMenuMouseDown,
            onMouseMove: a.onMenuMouseMove,
            id: a.getElementId("listbox")
          },
          isLoading: P,
          placement: j
        }), /* @__PURE__ */ On.createElement(G0e, {
          captureEnabled: A,
          onTopArrive: ee,
          onBottomArrive: fe,
          lockEnabled: ne
        }, function(Ee) {
          return /* @__PURE__ */ On.createElement(f, rn({}, w, {
            innerRef: function(Ae) {
              a.getMenuListRef(Ae), Ee(Ae);
            },
            isLoading: P,
            maxHeight: K,
            focusedOption: _
          }), ie);
        }));
      });
      return Q || q === "fixed" ? /* @__PURE__ */ On.createElement(p, rn({}, w, {
        appendTo: Q,
        controlElement: this.controlRef,
        menuPlacement: Y,
        menuPosition: q
      }), pe) : pe;
    }
  }, {
    key: "renderFormField",
    value: function() {
      var a = this, i = this.props, o = i.delimiter, s = i.isDisabled, u = i.isMulti, f = i.name, p = i.required, m = this.state.selectValue;
      if (!(!f || s)) {
        if (p && !this.hasValue())
          return /* @__PURE__ */ On.createElement(Z0e, {
            name: f,
            onFocus: this.onValueInputFocus
          });
        if (u)
          if (o) {
            var v = m.map(function(_) {
              return a.getOptionValue(_);
            }).join(o);
            return /* @__PURE__ */ On.createElement("input", {
              name: f,
              type: "hidden",
              value: v
            });
          } else {
            var O = m.length > 0 ? m.map(function(_, C) {
              return /* @__PURE__ */ On.createElement("input", {
                key: "i-".concat(C),
                name: f,
                type: "hidden",
                value: a.getOptionValue(_)
              });
            }) : /* @__PURE__ */ On.createElement("input", {
              name: f,
              type: "hidden",
              value: ""
            });
            return /* @__PURE__ */ On.createElement("div", null, O);
          }
        else {
          var w = m[0] ? this.getOptionValue(m[0]) : "";
          return /* @__PURE__ */ On.createElement("input", {
            name: f,
            type: "hidden",
            value: w
          });
        }
      }
    }
  }, {
    key: "renderLiveRegion",
    value: function() {
      var a = this.commonProps, i = this.state, o = i.ariaSelection, s = i.focusedOption, u = i.focusedValue, f = i.isFocused, p = i.selectValue, m = this.getFocusableOptions();
      return /* @__PURE__ */ On.createElement(P0e, rn({}, a, {
        id: this.getElementId("live-region"),
        ariaSelection: o,
        focusedOption: s,
        focusedValue: u,
        isFocused: f,
        selectValue: p,
        focusableOptions: m
      }));
    }
  }, {
    key: "render",
    value: function() {
      var a = this.getComponents(), i = a.Control, o = a.IndicatorsContainer, s = a.SelectContainer, u = a.ValueContainer, f = this.props, p = f.className, m = f.id, v = f.isDisabled, O = f.menuIsOpen, w = this.state.isFocused, _ = this.commonProps = this.getCommonProps();
      return /* @__PURE__ */ On.createElement(s, rn({}, _, {
        className: p,
        innerProps: {
          id: m,
          onKeyDown: this.onKeyDown
        },
        isDisabled: v,
        isFocused: w
      }), this.renderLiveRegion(), /* @__PURE__ */ On.createElement(i, rn({}, _, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: v,
        isFocused: w,
        menuIsOpen: O
      }), /* @__PURE__ */ On.createElement(u, rn({}, _, {
        isDisabled: v
      }), this.renderPlaceholderOrValue(), this.renderInput()), /* @__PURE__ */ On.createElement(o, rn({}, _, {
        isDisabled: v
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(a, i) {
      var o = i.prevProps, s = i.clearFocusValueOnUpdate, u = i.inputIsHiddenAfterUpdate, f = i.ariaSelection, p = i.isFocused, m = i.prevWasFocused, v = a.options, O = a.value, w = a.menuIsOpen, _ = a.inputValue, C = a.isMulti, A = Kk(O), N = {};
      if (o && (O !== o.value || v !== o.options || w !== o.menuIsOpen || _ !== o.inputValue)) {
        var P = w ? oOe(a, A) : [], I = s ? sOe(i, A) : null, D = lOe(i, P);
        N = {
          selectValue: A,
          focusedOption: D,
          focusedValue: I,
          clearFocusValueOnUpdate: !1
        };
      }
      var M = u != null && a !== o ? {
        inputIsHidden: u,
        inputIsHiddenAfterUpdate: void 0
      } : {}, H = f, Y = p && m;
      return p && !Y && (H = {
        value: Dw(C, A, A[0] || null),
        options: A,
        action: "initial-input-focus"
      }, Y = !m), (f == null ? void 0 : f.action) === "initial-input-focus" && (H = null), Hn(Hn(Hn({}, N), M), {}, {
        prevProps: a,
        ariaSelection: H,
        prevWasFocused: Y
      });
    }
  }]), n;
}(Qee);
YI.defaultProps = iOe;
var cOe = /* @__PURE__ */ bs(function(t, e) {
  var n = HI(t);
  return /* @__PURE__ */ On.createElement(YI, rn({
    ref: e
  }, n));
}), fOe = function(t) {
  var e = t.nonce, n = t.children, r = t.cacheKey, a = Mc(function() {
    return Ite({
      key: r,
      nonce: e
    });
  }, [r, e]);
  return /* @__PURE__ */ On.createElement(Uve, {
    value: a
  }, n);
};
const yne = cOe, dOe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NonceProvider: fOe,
  components: jd,
  createFilter: lne,
  default: yne,
  defaultTheme: TA,
  mergeStyles: J0e,
  useStateManager: HI
}, Symbol.toStringTag, { value: "Module" }));
var pOe = ["allowCreateWhileLoading", "createOptionPosition", "formatCreateLabel", "isValidNewOption", "getNewOptionData", "onCreateOption", "options", "onChange"], fV = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = arguments.length > 1 ? arguments[1] : void 0, r = arguments.length > 2 ? arguments[2] : void 0, a = String(e).toLowerCase(), i = String(r.getOptionValue(n)).toLowerCase(), o = String(r.getOptionLabel(n)).toLowerCase();
  return i === a || o === a;
}, _M = {
  formatCreateLabel: function(e) {
    return 'Create "'.concat(e, '"');
  },
  isValidNewOption: function(e, n, r, a) {
    return !(!e || n.some(function(i) {
      return fV(e, i, a);
    }) || r.some(function(i) {
      return fV(e, i, a);
    }));
  },
  getNewOptionData: function(e, n) {
    return {
      label: n,
      value: e,
      __isNew__: !0
    };
  }
};
function hOe(t) {
  var e = t.allowCreateWhileLoading, n = e === void 0 ? !1 : e, r = t.createOptionPosition, a = r === void 0 ? "last" : r, i = t.formatCreateLabel, o = i === void 0 ? _M.formatCreateLabel : i, s = t.isValidNewOption, u = s === void 0 ? _M.isValidNewOption : s, f = t.getNewOptionData, p = f === void 0 ? _M.getNewOptionData : f, m = t.onCreateOption, v = t.options, O = v === void 0 ? [] : v, w = t.onChange, _ = lv(t, pOe), C = _.getOptionValue, A = C === void 0 ? cne : C, N = _.getOptionLabel, P = N === void 0 ? une : N, I = _.inputValue, D = _.isLoading, M = _.isMulti, H = _.value, Y = _.name, q = Mc(function() {
    return u(I, Kk(H), O, {
      getOptionValue: A,
      getOptionLabel: P
    }) ? p(I, o(I)) : void 0;
  }, [o, p, P, A, I, u, O, H]), Q = Mc(function() {
    return (n || !D) && q ? a === "first" ? [q].concat(Gw(O)) : [].concat(Gw(O), [q]) : O;
  }, [n, a, D, q, O]), ne = Ei(function(J, ue) {
    if (ue.action !== "select-option")
      return w(J, ue);
    var ee = Array.isArray(J) ? J : [J];
    if (ee[ee.length - 1] === q) {
      if (m)
        m(I);
      else {
        var fe = p(I, I), de = {
          action: "create-option",
          name: Y,
          option: fe
        };
        w(Dw(M, [].concat(Gw(Kk(H)), [fe]), fe), de);
      }
      return;
    }
    w(J, ue);
  }, [p, I, M, Y, q, m, w, H]);
  return Hn(Hn({}, _), {}, {
    options: Q,
    onChange: ne
  });
}
var mOe = /* @__PURE__ */ bs(function(t, e) {
  var n = HI(t), r = hOe(n);
  return /* @__PURE__ */ On.createElement(YI, rn({
    ref: e
  }, r));
});
const gOe = mOe;
const bOe = "byz-clear-indicator", ZI = (t) => {
  const {
    innerProps: { ref: e, ...n }
  } = t;
  return /* @__PURE__ */ Ne.jsx(
    "div",
    {
      ...n,
      ref: e,
      className: pn(bOe),
      children: /* @__PURE__ */ Ne.jsx(jd.ClearIndicator, { ...t, children: /* @__PURE__ */ Ne.jsx("svg", { viewBox: "64 64 896 896", focusable: "false", "data-icon": "close", width: "1em", height: "1em", fill: "currentColor", "aria-hidden": "true", children: /* @__PURE__ */ Ne.jsx("path", { d: "M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 00203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z" }) }) })
    }
  );
};
ZI.displayName = "ClearIndicator";
const vOe = "byz-dropdown-indicator", tU = (t) => /* @__PURE__ */ Ne.jsx("div", { className: pn(vOe), children: /* @__PURE__ */ Ne.jsx(jd.DropdownIndicator, { ...t, className: t.selectProps.menuIsOpen ? "open" : "closed", children: t.children }) });
tU.displayName = "DropdownIndicator";
const yOe = (t, e) => {
  const [n, r] = On.useState(void 0);
  function a() {
    if (t.current) {
      const { scrollWidth: o, clientWidth: s, clientHeight: u } = t.current;
      r(o > s || u > e);
    }
  }
  const i = On.useRef(new ResizeObserver(a));
  return On.useLayoutEffect(a), On.useEffect(() => {
    const o = t.current;
    return o && i.current.observe(o), () => {
      i.current.unobserve(o);
    };
  }, [t, i]), n;
};
const XI = (t) => {
  const { children: e } = t, n = dr(), r = yOe(n, 50), [a, i] = kn(!1), o = "byz-value-container";
  return Vn(() => {
    r === !1 && i(!1);
  }, [r]), /* @__PURE__ */ Ne.jsx(Ne.Fragment, { children: /* @__PURE__ */ Ne.jsxs(jd.ValueContainer, { ...t, children: [
    /* @__PURE__ */ Ne.jsx(
      "div",
      {
        className: pn(`${o}`, {
          [`${o}--expanded`]: a
        }),
        ref: n,
        children: e
      }
    ),
    r ? /* @__PURE__ */ Ne.jsx("div", { className: `${o}__toggle`, onClick: () => i(!a), children: a ? "See less" : "See more" }) : void 0
  ] }) });
};
XI.displayName = "ValueContainer";
var IF = { exports: {} }, DF = { exports: {} }, NF = { exports: {} }, PF = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  function n(r, a) {
    if (a.length < r)
      throw new TypeError(r + " argument" + (r > 1 ? "s" : "") + " required, but only " + a.length + " present");
  }
  t.exports = e.default;
})(PF, PF.exports);
var hu = PF.exports;
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = i;
  var n = r(hu);
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function a(o) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? a = function(u) {
      return typeof u;
    } : a = function(u) {
      return u && typeof Symbol == "function" && u.constructor === Symbol && u !== Symbol.prototype ? "symbol" : typeof u;
    }, a(o);
  }
  function i(o) {
    return (0, n.default)(1, arguments), o instanceof Date || a(o) === "object" && Object.prototype.toString.call(o) === "[object Date]";
  }
  t.exports = e.default;
})(NF, NF.exports);
var OOe = NF.exports, LF = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = i;
  var n = r(hu);
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function a(o) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? a = function(u) {
      return typeof u;
    } : a = function(u) {
      return u && typeof Symbol == "function" && u.constructor === Symbol && u !== Symbol.prototype ? "symbol" : typeof u;
    }, a(o);
  }
  function i(o) {
    (0, n.default)(1, arguments);
    var s = Object.prototype.toString.call(o);
    return o instanceof Date || a(o) === "object" && s === "[object Date]" ? new Date(o.getTime()) : typeof o == "number" || s === "[object Number]" ? new Date(o) : ((typeof o == "string" || s === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
  }
  t.exports = e.default;
})(LF, LF.exports);
var Ah = LF.exports;
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = o;
  var n = i(OOe), r = i(Ah), a = i(hu);
  function i(s) {
    return s && s.__esModule ? s : { default: s };
  }
  function o(s) {
    if ((0, a.default)(1, arguments), !(0, n.default)(s) && typeof s != "number")
      return !1;
    var u = (0, r.default)(s);
    return !isNaN(Number(u));
  }
  t.exports = e.default;
})(DF, DF.exports);
var EOe = DF.exports, MF = { exports: {} }, FF = { exports: {} }, $F = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  function n(r) {
    if (r === null || r === !0 || r === !1)
      return NaN;
    var a = Number(r);
    return isNaN(a) ? a : a < 0 ? Math.ceil(a) : Math.floor(a);
  }
  t.exports = e.default;
})($F, $F.exports);
var w0 = $F.exports;
const SOe = /* @__PURE__ */ Pl(w0);
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = o;
  var n = i(w0), r = i(Ah), a = i(hu);
  function i(s) {
    return s && s.__esModule ? s : { default: s };
  }
  function o(s, u) {
    (0, a.default)(2, arguments);
    var f = (0, r.default)(s).getTime(), p = (0, n.default)(u);
    return new Date(f + p);
  }
  t.exports = e.default;
})(FF, FF.exports);
var wOe = FF.exports;
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = o;
  var n = i(wOe), r = i(hu), a = i(w0);
  function i(s) {
    return s && s.__esModule ? s : { default: s };
  }
  function o(s, u) {
    (0, r.default)(2, arguments);
    var f = (0, a.default)(u);
    return (0, n.default)(s, -f);
  }
  t.exports = e.default;
})(MF, MF.exports);
var TOe = MF.exports, BF = { exports: {} }, UF = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = o;
  var n = a(Ah), r = a(hu);
  function a(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var i = 864e5;
  function o(s) {
    (0, r.default)(1, arguments);
    var u = (0, n.default)(s), f = u.getTime();
    u.setUTCMonth(0, 1), u.setUTCHours(0, 0, 0, 0);
    var p = u.getTime(), m = f - p;
    return Math.floor(m / i) + 1;
  }
  t.exports = e.default;
})(UF, UF.exports);
var _Oe = UF.exports, zF = { exports: {} }, HF = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = i;
  var n = a(Ah), r = a(hu);
  function a(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function i(o) {
    (0, r.default)(1, arguments);
    var s = 1, u = (0, n.default)(o), f = u.getUTCDay(), p = (f < s ? 7 : 0) + f - s;
    return u.setUTCDate(u.getUTCDate() - p), u.setUTCHours(0, 0, 0, 0), u;
  }
  t.exports = e.default;
})(HF, HF.exports);
var nU = HF.exports, WF = { exports: {} }, QF = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = o;
  var n = i(Ah), r = i(hu), a = i(nU);
  function i(s) {
    return s && s.__esModule ? s : { default: s };
  }
  function o(s) {
    (0, r.default)(1, arguments);
    var u = (0, n.default)(s), f = u.getUTCFullYear(), p = /* @__PURE__ */ new Date(0);
    p.setUTCFullYear(f + 1, 0, 4), p.setUTCHours(0, 0, 0, 0);
    var m = (0, a.default)(p), v = /* @__PURE__ */ new Date(0);
    v.setUTCFullYear(f, 0, 4), v.setUTCHours(0, 0, 0, 0);
    var O = (0, a.default)(v);
    return u.getTime() >= m.getTime() ? f + 1 : u.getTime() >= O.getTime() ? f : f - 1;
  }
  t.exports = e.default;
})(QF, QF.exports);
var One = QF.exports;
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = o;
  var n = i(One), r = i(nU), a = i(hu);
  function i(s) {
    return s && s.__esModule ? s : { default: s };
  }
  function o(s) {
    (0, a.default)(1, arguments);
    var u = (0, n.default)(s), f = /* @__PURE__ */ new Date(0);
    f.setUTCFullYear(u, 0, 4), f.setUTCHours(0, 0, 0, 0);
    var p = (0, r.default)(f);
    return p;
  }
  t.exports = e.default;
})(WF, WF.exports);
var COe = WF.exports;
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = u;
  var n = o(Ah), r = o(nU), a = o(COe), i = o(hu);
  function o(f) {
    return f && f.__esModule ? f : { default: f };
  }
  var s = 6048e5;
  function u(f) {
    (0, i.default)(1, arguments);
    var p = (0, n.default)(f), m = (0, r.default)(p).getTime() - (0, a.default)(p).getTime();
    return Math.round(m / s) + 1;
  }
  t.exports = e.default;
})(zF, zF.exports);
var xOe = zF.exports, jF = { exports: {} }, GF = { exports: {} }, T0 = {};
Object.defineProperty(T0, "__esModule", {
  value: !0
});
T0.getDefaultOptions = AOe;
T0.setDefaultOptions = kOe;
var Ene = {};
function AOe() {
  return Ene;
}
function kOe(t) {
  Ene = t;
}
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = s;
  var n = o(Ah), r = o(hu), a = o(w0), i = T0;
  function o(u) {
    return u && u.__esModule ? u : { default: u };
  }
  function s(u, f) {
    var p, m, v, O, w, _, C, A;
    (0, r.default)(1, arguments);
    var N = (0, i.getDefaultOptions)(), P = (0, a.default)((p = (m = (v = (O = f == null ? void 0 : f.weekStartsOn) !== null && O !== void 0 ? O : f == null || (w = f.locale) === null || w === void 0 || (_ = w.options) === null || _ === void 0 ? void 0 : _.weekStartsOn) !== null && v !== void 0 ? v : N.weekStartsOn) !== null && m !== void 0 ? m : (C = N.locale) === null || C === void 0 || (A = C.options) === null || A === void 0 ? void 0 : A.weekStartsOn) !== null && p !== void 0 ? p : 0);
    if (!(P >= 0 && P <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var I = (0, n.default)(u), D = I.getUTCDay(), M = (D < P ? 7 : 0) + D - P;
    return I.setUTCDate(I.getUTCDate() - M), I.setUTCHours(0, 0, 0, 0), I;
  }
  t.exports = e.default;
})(GF, GF.exports);
var rU = GF.exports, VF = { exports: {} }, YF = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = u;
  var n = s(Ah), r = s(hu), a = s(rU), i = s(w0), o = T0;
  function s(f) {
    return f && f.__esModule ? f : { default: f };
  }
  function u(f, p) {
    var m, v, O, w, _, C, A, N;
    (0, r.default)(1, arguments);
    var P = (0, n.default)(f), I = P.getUTCFullYear(), D = (0, o.getDefaultOptions)(), M = (0, i.default)((m = (v = (O = (w = p == null ? void 0 : p.firstWeekContainsDate) !== null && w !== void 0 ? w : p == null || (_ = p.locale) === null || _ === void 0 || (C = _.options) === null || C === void 0 ? void 0 : C.firstWeekContainsDate) !== null && O !== void 0 ? O : D.firstWeekContainsDate) !== null && v !== void 0 ? v : (A = D.locale) === null || A === void 0 || (N = A.options) === null || N === void 0 ? void 0 : N.firstWeekContainsDate) !== null && m !== void 0 ? m : 1);
    if (!(M >= 1 && M <= 7))
      throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var H = /* @__PURE__ */ new Date(0);
    H.setUTCFullYear(I + 1, 0, M), H.setUTCHours(0, 0, 0, 0);
    var Y = (0, a.default)(H, p), q = /* @__PURE__ */ new Date(0);
    q.setUTCFullYear(I, 0, M), q.setUTCHours(0, 0, 0, 0);
    var Q = (0, a.default)(q, p);
    return P.getTime() >= Y.getTime() ? I + 1 : P.getTime() >= Q.getTime() ? I : I - 1;
  }
  t.exports = e.default;
})(YF, YF.exports);
var Sne = YF.exports;
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = u;
  var n = s(Sne), r = s(hu), a = s(rU), i = s(w0), o = T0;
  function s(f) {
    return f && f.__esModule ? f : { default: f };
  }
  function u(f, p) {
    var m, v, O, w, _, C, A, N;
    (0, r.default)(1, arguments);
    var P = (0, o.getDefaultOptions)(), I = (0, i.default)((m = (v = (O = (w = p == null ? void 0 : p.firstWeekContainsDate) !== null && w !== void 0 ? w : p == null || (_ = p.locale) === null || _ === void 0 || (C = _.options) === null || C === void 0 ? void 0 : C.firstWeekContainsDate) !== null && O !== void 0 ? O : P.firstWeekContainsDate) !== null && v !== void 0 ? v : (A = P.locale) === null || A === void 0 || (N = A.options) === null || N === void 0 ? void 0 : N.firstWeekContainsDate) !== null && m !== void 0 ? m : 1), D = (0, n.default)(f, p), M = /* @__PURE__ */ new Date(0);
    M.setUTCFullYear(D, 0, I), M.setUTCHours(0, 0, 0, 0);
    var H = (0, a.default)(M, p);
    return H;
  }
  t.exports = e.default;
})(VF, VF.exports);
var ROe = VF.exports;
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = u;
  var n = o(Ah), r = o(rU), a = o(ROe), i = o(hu);
  function o(f) {
    return f && f.__esModule ? f : { default: f };
  }
  var s = 6048e5;
  function u(f, p) {
    (0, i.default)(1, arguments);
    var m = (0, n.default)(f), v = (0, r.default)(m, p).getTime() - (0, a.default)(m, p).getTime();
    return Math.round(v / s) + 1;
  }
  t.exports = e.default;
})(jF, jF.exports);
var IOe = jF.exports, ZF = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  function n(r, a) {
    for (var i = r < 0 ? "-" : "", o = Math.abs(r).toString(); o.length < a; )
      o = "0" + o;
    return i + o;
  }
  t.exports = e.default;
})(ZF, ZF.exports);
var wne = ZF.exports, XF = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = r(wne);
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var a = {
    // Year
    y: function(s, u) {
      var f = s.getUTCFullYear(), p = f > 0 ? f : 1 - f;
      return (0, n.default)(u === "yy" ? p % 100 : p, u.length);
    },
    // Month
    M: function(s, u) {
      var f = s.getUTCMonth();
      return u === "M" ? String(f + 1) : (0, n.default)(f + 1, 2);
    },
    // Day of the month
    d: function(s, u) {
      return (0, n.default)(s.getUTCDate(), u.length);
    },
    // AM or PM
    a: function(s, u) {
      var f = s.getUTCHours() / 12 >= 1 ? "pm" : "am";
      switch (u) {
        case "a":
        case "aa":
          return f.toUpperCase();
        case "aaa":
          return f;
        case "aaaaa":
          return f[0];
        case "aaaa":
        default:
          return f === "am" ? "a.m." : "p.m.";
      }
    },
    // Hour [1-12]
    h: function(s, u) {
      return (0, n.default)(s.getUTCHours() % 12 || 12, u.length);
    },
    // Hour [0-23]
    H: function(s, u) {
      return (0, n.default)(s.getUTCHours(), u.length);
    },
    // Minute
    m: function(s, u) {
      return (0, n.default)(s.getUTCMinutes(), u.length);
    },
    // Second
    s: function(s, u) {
      return (0, n.default)(s.getUTCSeconds(), u.length);
    },
    // Fraction of second
    S: function(s, u) {
      var f = u.length, p = s.getUTCMilliseconds(), m = Math.floor(p * Math.pow(10, f - 3));
      return (0, n.default)(m, u.length);
    }
  }, i = a;
  e.default = i, t.exports = e.default;
})(XF, XF.exports);
var DOe = XF.exports;
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = f(_Oe), r = f(xOe), a = f(One), i = f(IOe), o = f(Sne), s = f(wne), u = f(DOe);
  function f(C) {
    return C && C.__esModule ? C : { default: C };
  }
  var p = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }, m = {
    // Era
    G: function(A, N, P) {
      var I = A.getUTCFullYear() > 0 ? 1 : 0;
      switch (N) {
        case "G":
        case "GG":
        case "GGG":
          return P.era(I, {
            width: "abbreviated"
          });
        case "GGGGG":
          return P.era(I, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return P.era(I, {
            width: "wide"
          });
      }
    },
    // Year
    y: function(A, N, P) {
      if (N === "yo") {
        var I = A.getUTCFullYear(), D = I > 0 ? I : 1 - I;
        return P.ordinalNumber(D, {
          unit: "year"
        });
      }
      return u.default.y(A, N);
    },
    // Local week-numbering year
    Y: function(A, N, P, I) {
      var D = (0, o.default)(A, I), M = D > 0 ? D : 1 - D;
      if (N === "YY") {
        var H = M % 100;
        return (0, s.default)(H, 2);
      }
      return N === "Yo" ? P.ordinalNumber(M, {
        unit: "year"
      }) : (0, s.default)(M, N.length);
    },
    // ISO week-numbering year
    R: function(A, N) {
      var P = (0, a.default)(A);
      return (0, s.default)(P, N.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(A, N) {
      var P = A.getUTCFullYear();
      return (0, s.default)(P, N.length);
    },
    // Quarter
    Q: function(A, N, P) {
      var I = Math.ceil((A.getUTCMonth() + 1) / 3);
      switch (N) {
        case "Q":
          return String(I);
        case "QQ":
          return (0, s.default)(I, 2);
        case "Qo":
          return P.ordinalNumber(I, {
            unit: "quarter"
          });
        case "QQQ":
          return P.quarter(I, {
            width: "abbreviated",
            context: "formatting"
          });
        case "QQQQQ":
          return P.quarter(I, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return P.quarter(I, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone quarter
    q: function(A, N, P) {
      var I = Math.ceil((A.getUTCMonth() + 1) / 3);
      switch (N) {
        case "q":
          return String(I);
        case "qq":
          return (0, s.default)(I, 2);
        case "qo":
          return P.ordinalNumber(I, {
            unit: "quarter"
          });
        case "qqq":
          return P.quarter(I, {
            width: "abbreviated",
            context: "standalone"
          });
        case "qqqqq":
          return P.quarter(I, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return P.quarter(I, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // Month
    M: function(A, N, P) {
      var I = A.getUTCMonth();
      switch (N) {
        case "M":
        case "MM":
          return u.default.M(A, N);
        case "Mo":
          return P.ordinalNumber(I + 1, {
            unit: "month"
          });
        case "MMM":
          return P.month(I, {
            width: "abbreviated",
            context: "formatting"
          });
        case "MMMMM":
          return P.month(I, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return P.month(I, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone month
    L: function(A, N, P) {
      var I = A.getUTCMonth();
      switch (N) {
        case "L":
          return String(I + 1);
        case "LL":
          return (0, s.default)(I + 1, 2);
        case "Lo":
          return P.ordinalNumber(I + 1, {
            unit: "month"
          });
        case "LLL":
          return P.month(I, {
            width: "abbreviated",
            context: "standalone"
          });
        case "LLLLL":
          return P.month(I, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return P.month(I, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // Local week of year
    w: function(A, N, P, I) {
      var D = (0, i.default)(A, I);
      return N === "wo" ? P.ordinalNumber(D, {
        unit: "week"
      }) : (0, s.default)(D, N.length);
    },
    // ISO week of year
    I: function(A, N, P) {
      var I = (0, r.default)(A);
      return N === "Io" ? P.ordinalNumber(I, {
        unit: "week"
      }) : (0, s.default)(I, N.length);
    },
    // Day of the month
    d: function(A, N, P) {
      return N === "do" ? P.ordinalNumber(A.getUTCDate(), {
        unit: "date"
      }) : u.default.d(A, N);
    },
    // Day of year
    D: function(A, N, P) {
      var I = (0, n.default)(A);
      return N === "Do" ? P.ordinalNumber(I, {
        unit: "dayOfYear"
      }) : (0, s.default)(I, N.length);
    },
    // Day of week
    E: function(A, N, P) {
      var I = A.getUTCDay();
      switch (N) {
        case "E":
        case "EE":
        case "EEE":
          return P.day(I, {
            width: "abbreviated",
            context: "formatting"
          });
        case "EEEEE":
          return P.day(I, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return P.day(I, {
            width: "short",
            context: "formatting"
          });
        case "EEEE":
        default:
          return P.day(I, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Local day of week
    e: function(A, N, P, I) {
      var D = A.getUTCDay(), M = (D - I.weekStartsOn + 8) % 7 || 7;
      switch (N) {
        case "e":
          return String(M);
        case "ee":
          return (0, s.default)(M, 2);
        case "eo":
          return P.ordinalNumber(M, {
            unit: "day"
          });
        case "eee":
          return P.day(D, {
            width: "abbreviated",
            context: "formatting"
          });
        case "eeeee":
          return P.day(D, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return P.day(D, {
            width: "short",
            context: "formatting"
          });
        case "eeee":
        default:
          return P.day(D, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone local day of week
    c: function(A, N, P, I) {
      var D = A.getUTCDay(), M = (D - I.weekStartsOn + 8) % 7 || 7;
      switch (N) {
        case "c":
          return String(M);
        case "cc":
          return (0, s.default)(M, N.length);
        case "co":
          return P.ordinalNumber(M, {
            unit: "day"
          });
        case "ccc":
          return P.day(D, {
            width: "abbreviated",
            context: "standalone"
          });
        case "ccccc":
          return P.day(D, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return P.day(D, {
            width: "short",
            context: "standalone"
          });
        case "cccc":
        default:
          return P.day(D, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // ISO day of week
    i: function(A, N, P) {
      var I = A.getUTCDay(), D = I === 0 ? 7 : I;
      switch (N) {
        case "i":
          return String(D);
        case "ii":
          return (0, s.default)(D, N.length);
        case "io":
          return P.ordinalNumber(D, {
            unit: "day"
          });
        case "iii":
          return P.day(I, {
            width: "abbreviated",
            context: "formatting"
          });
        case "iiiii":
          return P.day(I, {
            width: "narrow",
            context: "formatting"
          });
        case "iiiiii":
          return P.day(I, {
            width: "short",
            context: "formatting"
          });
        case "iiii":
        default:
          return P.day(I, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // AM or PM
    a: function(A, N, P) {
      var I = A.getUTCHours(), D = I / 12 >= 1 ? "pm" : "am";
      switch (N) {
        case "a":
        case "aa":
          return P.dayPeriod(D, {
            width: "abbreviated",
            context: "formatting"
          });
        case "aaa":
          return P.dayPeriod(D, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "aaaaa":
          return P.dayPeriod(D, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return P.dayPeriod(D, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // AM, PM, midnight, noon
    b: function(A, N, P) {
      var I = A.getUTCHours(), D;
      switch (I === 12 ? D = p.noon : I === 0 ? D = p.midnight : D = I / 12 >= 1 ? "pm" : "am", N) {
        case "b":
        case "bb":
          return P.dayPeriod(D, {
            width: "abbreviated",
            context: "formatting"
          });
        case "bbb":
          return P.dayPeriod(D, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "bbbbb":
          return P.dayPeriod(D, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return P.dayPeriod(D, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(A, N, P) {
      var I = A.getUTCHours(), D;
      switch (I >= 17 ? D = p.evening : I >= 12 ? D = p.afternoon : I >= 4 ? D = p.morning : D = p.night, N) {
        case "B":
        case "BB":
        case "BBB":
          return P.dayPeriod(D, {
            width: "abbreviated",
            context: "formatting"
          });
        case "BBBBB":
          return P.dayPeriod(D, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return P.dayPeriod(D, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Hour [1-12]
    h: function(A, N, P) {
      if (N === "ho") {
        var I = A.getUTCHours() % 12;
        return I === 0 && (I = 12), P.ordinalNumber(I, {
          unit: "hour"
        });
      }
      return u.default.h(A, N);
    },
    // Hour [0-23]
    H: function(A, N, P) {
      return N === "Ho" ? P.ordinalNumber(A.getUTCHours(), {
        unit: "hour"
      }) : u.default.H(A, N);
    },
    // Hour [0-11]
    K: function(A, N, P) {
      var I = A.getUTCHours() % 12;
      return N === "Ko" ? P.ordinalNumber(I, {
        unit: "hour"
      }) : (0, s.default)(I, N.length);
    },
    // Hour [1-24]
    k: function(A, N, P) {
      var I = A.getUTCHours();
      return I === 0 && (I = 24), N === "ko" ? P.ordinalNumber(I, {
        unit: "hour"
      }) : (0, s.default)(I, N.length);
    },
    // Minute
    m: function(A, N, P) {
      return N === "mo" ? P.ordinalNumber(A.getUTCMinutes(), {
        unit: "minute"
      }) : u.default.m(A, N);
    },
    // Second
    s: function(A, N, P) {
      return N === "so" ? P.ordinalNumber(A.getUTCSeconds(), {
        unit: "second"
      }) : u.default.s(A, N);
    },
    // Fraction of second
    S: function(A, N) {
      return u.default.S(A, N);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(A, N, P, I) {
      var D = I._originalDate || A, M = D.getTimezoneOffset();
      if (M === 0)
        return "Z";
      switch (N) {
        case "X":
          return O(M);
        case "XXXX":
        case "XX":
          return w(M);
        case "XXXXX":
        case "XXX":
        default:
          return w(M, ":");
      }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(A, N, P, I) {
      var D = I._originalDate || A, M = D.getTimezoneOffset();
      switch (N) {
        case "x":
          return O(M);
        case "xxxx":
        case "xx":
          return w(M);
        case "xxxxx":
        case "xxx":
        default:
          return w(M, ":");
      }
    },
    // Timezone (GMT)
    O: function(A, N, P, I) {
      var D = I._originalDate || A, M = D.getTimezoneOffset();
      switch (N) {
        case "O":
        case "OO":
        case "OOO":
          return "GMT" + v(M, ":");
        case "OOOO":
        default:
          return "GMT" + w(M, ":");
      }
    },
    // Timezone (specific non-location)
    z: function(A, N, P, I) {
      var D = I._originalDate || A, M = D.getTimezoneOffset();
      switch (N) {
        case "z":
        case "zz":
        case "zzz":
          return "GMT" + v(M, ":");
        case "zzzz":
        default:
          return "GMT" + w(M, ":");
      }
    },
    // Seconds timestamp
    t: function(A, N, P, I) {
      var D = I._originalDate || A, M = Math.floor(D.getTime() / 1e3);
      return (0, s.default)(M, N.length);
    },
    // Milliseconds timestamp
    T: function(A, N, P, I) {
      var D = I._originalDate || A, M = D.getTime();
      return (0, s.default)(M, N.length);
    }
  };
  function v(C, A) {
    var N = C > 0 ? "-" : "+", P = Math.abs(C), I = Math.floor(P / 60), D = P % 60;
    if (D === 0)
      return N + String(I);
    var M = A || "";
    return N + String(I) + M + (0, s.default)(D, 2);
  }
  function O(C, A) {
    if (C % 60 === 0) {
      var N = C > 0 ? "-" : "+";
      return N + (0, s.default)(Math.abs(C) / 60, 2);
    }
    return w(C, A);
  }
  function w(C, A) {
    var N = A || "", P = C > 0 ? "-" : "+", I = Math.abs(C), D = (0, s.default)(Math.floor(I / 60), 2), M = (0, s.default)(I % 60, 2);
    return P + D + N + M;
  }
  var _ = m;
  e.default = _, t.exports = e.default;
})(BF, BF.exports);
var NOe = BF.exports, qF = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = function(u, f) {
    switch (u) {
      case "P":
        return f.date({
          width: "short"
        });
      case "PP":
        return f.date({
          width: "medium"
        });
      case "PPP":
        return f.date({
          width: "long"
        });
      case "PPPP":
      default:
        return f.date({
          width: "full"
        });
    }
  }, r = function(u, f) {
    switch (u) {
      case "p":
        return f.time({
          width: "short"
        });
      case "pp":
        return f.time({
          width: "medium"
        });
      case "ppp":
        return f.time({
          width: "long"
        });
      case "pppp":
      default:
        return f.time({
          width: "full"
        });
    }
  }, a = function(u, f) {
    var p = u.match(/(P+)(p+)?/) || [], m = p[1], v = p[2];
    if (!v)
      return n(u, f);
    var O;
    switch (m) {
      case "P":
        O = f.dateTime({
          width: "short"
        });
        break;
      case "PP":
        O = f.dateTime({
          width: "medium"
        });
        break;
      case "PPP":
        O = f.dateTime({
          width: "long"
        });
        break;
      case "PPPP":
      default:
        O = f.dateTime({
          width: "full"
        });
        break;
    }
    return O.replace("{{date}}", n(m, f)).replace("{{time}}", r(v, f));
  }, i = {
    p: r,
    P: a
  }, o = i;
  e.default = o, t.exports = e.default;
})(qF, qF.exports);
var POe = qF.exports, KF = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  function n(r) {
    var a = new Date(Date.UTC(r.getFullYear(), r.getMonth(), r.getDate(), r.getHours(), r.getMinutes(), r.getSeconds(), r.getMilliseconds()));
    return a.setUTCFullYear(r.getFullYear()), r.getTime() - a.getTime();
  }
  t.exports = e.default;
})(KF, KF.exports);
var Tne = KF.exports;
const dV = /* @__PURE__ */ Pl(Tne);
var h_ = {};
Object.defineProperty(h_, "__esModule", {
  value: !0
});
h_.isProtectedDayOfYearToken = FOe;
h_.isProtectedWeekYearToken = $Oe;
h_.throwProtectedError = BOe;
var LOe = ["D", "DD"], MOe = ["YY", "YYYY"];
function FOe(t) {
  return LOe.indexOf(t) !== -1;
}
function $Oe(t) {
  return MOe.indexOf(t) !== -1;
}
function BOe(t, e, n) {
  if (t === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(e, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(e, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(e, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(e, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var JF = { exports: {} }, e$ = { exports: {} }, t$ = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = {
    lessThanXSeconds: {
      one: "less than a second",
      other: "less than {{count}} seconds"
    },
    xSeconds: {
      one: "1 second",
      other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
      one: "less than a minute",
      other: "less than {{count}} minutes"
    },
    xMinutes: {
      one: "1 minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "about 1 hour",
      other: "about {{count}} hours"
    },
    xHours: {
      one: "1 hour",
      other: "{{count}} hours"
    },
    xDays: {
      one: "1 day",
      other: "{{count}} days"
    },
    aboutXWeeks: {
      one: "about 1 week",
      other: "about {{count}} weeks"
    },
    xWeeks: {
      one: "1 week",
      other: "{{count}} weeks"
    },
    aboutXMonths: {
      one: "about 1 month",
      other: "about {{count}} months"
    },
    xMonths: {
      one: "1 month",
      other: "{{count}} months"
    },
    aboutXYears: {
      one: "about 1 year",
      other: "about {{count}} years"
    },
    xYears: {
      one: "1 year",
      other: "{{count}} years"
    },
    overXYears: {
      one: "over 1 year",
      other: "over {{count}} years"
    },
    almostXYears: {
      one: "almost 1 year",
      other: "almost {{count}} years"
    }
  }, r = function(o, s, u) {
    var f, p = n[o];
    return typeof p == "string" ? f = p : s === 1 ? f = p.one : f = p.other.replace("{{count}}", s.toString()), u != null && u.addSuffix ? u.comparison && u.comparison > 0 ? "in " + f : f + " ago" : f;
  }, a = r;
  e.default = a, t.exports = e.default;
})(t$, t$.exports);
var UOe = t$.exports, n$ = { exports: {} }, r$ = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  function n(r) {
    return function() {
      var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = a.width ? String(a.width) : r.defaultWidth, o = r.formats[i] || r.formats[r.defaultWidth];
      return o;
    };
  }
  t.exports = e.default;
})(r$, r$.exports);
var zOe = r$.exports;
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = r(zOe);
  function r(f) {
    return f && f.__esModule ? f : { default: f };
  }
  var a = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
  }, i = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, o = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, n.default)({
      formats: a,
      defaultWidth: "full"
    }),
    time: (0, n.default)({
      formats: i,
      defaultWidth: "full"
    }),
    dateTime: (0, n.default)({
      formats: o,
      defaultWidth: "full"
    })
  }, u = s;
  e.default = u, t.exports = e.default;
})(n$, n$.exports);
var HOe = n$.exports, a$ = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
  }, r = function(o, s, u, f) {
    return n[o];
  }, a = r;
  e.default = a, t.exports = e.default;
})(a$, a$.exports);
var WOe = a$.exports, i$ = { exports: {} }, o$ = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  function n(r) {
    return function(a, i) {
      var o = i != null && i.context ? String(i.context) : "standalone", s;
      if (o === "formatting" && r.formattingValues) {
        var u = r.defaultFormattingWidth || r.defaultWidth, f = i != null && i.width ? String(i.width) : u;
        s = r.formattingValues[f] || r.formattingValues[u];
      } else {
        var p = r.defaultWidth, m = i != null && i.width ? String(i.width) : r.defaultWidth;
        s = r.values[m] || r.values[p];
      }
      var v = r.argumentCallback ? r.argumentCallback(a) : a;
      return s[v];
    };
  }
  t.exports = e.default;
})(o$, o$.exports);
var QOe = o$.exports;
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = r(QOe);
  function r(O) {
    return O && O.__esModule ? O : { default: O };
  }
  var a = {
    narrow: ["B", "A"],
    abbreviated: ["BC", "AD"],
    wide: ["Before Christ", "Anno Domini"]
  }, i = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
  }, o = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  }, s = {
    narrow: ["S", "M", "T", "W", "T", "F", "S"],
    short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
  }, u = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    }
  }, f = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    }
  }, p = function(w, _) {
    var C = Number(w), A = C % 100;
    if (A > 20 || A < 10)
      switch (A % 10) {
        case 1:
          return C + "st";
        case 2:
          return C + "nd";
        case 3:
          return C + "rd";
      }
    return C + "th";
  }, m = {
    ordinalNumber: p,
    era: (0, n.default)({
      values: a,
      defaultWidth: "wide"
    }),
    quarter: (0, n.default)({
      values: i,
      defaultWidth: "wide",
      argumentCallback: function(w) {
        return w - 1;
      }
    }),
    month: (0, n.default)({
      values: o,
      defaultWidth: "wide"
    }),
    day: (0, n.default)({
      values: s,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, n.default)({
      values: u,
      defaultWidth: "wide",
      formattingValues: f,
      defaultFormattingWidth: "wide"
    })
  }, v = m;
  e.default = v, t.exports = e.default;
})(i$, i$.exports);
var jOe = i$.exports, s$ = { exports: {} }, l$ = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  function n(i) {
    return function(o) {
      var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, u = s.width, f = u && i.matchPatterns[u] || i.matchPatterns[i.defaultMatchWidth], p = o.match(f);
      if (!p)
        return null;
      var m = p[0], v = u && i.parsePatterns[u] || i.parsePatterns[i.defaultParseWidth], O = Array.isArray(v) ? a(v, function(C) {
        return C.test(m);
      }) : r(v, function(C) {
        return C.test(m);
      }), w;
      w = i.valueCallback ? i.valueCallback(O) : O, w = s.valueCallback ? s.valueCallback(w) : w;
      var _ = o.slice(m.length);
      return {
        value: w,
        rest: _
      };
    };
  }
  function r(i, o) {
    for (var s in i)
      if (i.hasOwnProperty(s) && o(i[s]))
        return s;
  }
  function a(i, o) {
    for (var s = 0; s < i.length; s++)
      if (o(i[s]))
        return s;
  }
  t.exports = e.default;
})(l$, l$.exports);
var GOe = l$.exports, u$ = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  function n(r) {
    return function(a) {
      var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = a.match(r.matchPattern);
      if (!o)
        return null;
      var s = o[0], u = a.match(r.parsePattern);
      if (!u)
        return null;
      var f = r.valueCallback ? r.valueCallback(u[0]) : u[0];
      f = i.valueCallback ? i.valueCallback(f) : f;
      var p = a.slice(s.length);
      return {
        value: f,
        rest: p
      };
    };
  }
  t.exports = e.default;
})(u$, u$.exports);
var VOe = u$.exports;
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = a(GOe), r = a(VOe);
  function a(P) {
    return P && P.__esModule ? P : { default: P };
  }
  var i = /^(\d+)(th|st|nd|rd)?/i, o = /\d+/i, s = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
  }, u = {
    any: [/^b/i, /^(a|c)/i]
  }, f = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
  }, p = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, m = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
  }, v = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, O = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
  }, w = {
    narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
    any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
  }, _ = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
  }, C = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mi/i,
      noon: /^no/i,
      morning: /morning/i,
      afternoon: /afternoon/i,
      evening: /evening/i,
      night: /night/i
    }
  }, A = {
    ordinalNumber: (0, r.default)({
      matchPattern: i,
      parsePattern: o,
      valueCallback: function(I) {
        return parseInt(I, 10);
      }
    }),
    era: (0, n.default)({
      matchPatterns: s,
      defaultMatchWidth: "wide",
      parsePatterns: u,
      defaultParseWidth: "any"
    }),
    quarter: (0, n.default)({
      matchPatterns: f,
      defaultMatchWidth: "wide",
      parsePatterns: p,
      defaultParseWidth: "any",
      valueCallback: function(I) {
        return I + 1;
      }
    }),
    month: (0, n.default)({
      matchPatterns: m,
      defaultMatchWidth: "wide",
      parsePatterns: v,
      defaultParseWidth: "any"
    }),
    day: (0, n.default)({
      matchPatterns: O,
      defaultMatchWidth: "wide",
      parsePatterns: w,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, n.default)({
      matchPatterns: _,
      defaultMatchWidth: "any",
      parsePatterns: C,
      defaultParseWidth: "any"
    })
  }, N = A;
  e.default = N, t.exports = e.default;
})(s$, s$.exports);
var YOe = s$.exports;
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = s(UOe), r = s(HOe), a = s(WOe), i = s(jOe), o = s(YOe);
  function s(p) {
    return p && p.__esModule ? p : { default: p };
  }
  var u = {
    code: "en-US",
    formatDistance: n.default,
    formatLong: r.default,
    formatRelative: a.default,
    localize: i.default,
    match: o.default,
    options: {
      weekStartsOn: 0,
      firstWeekContainsDate: 1
    }
  }, f = u;
  e.default = f, t.exports = e.default;
})(e$, e$.exports);
var ZOe = e$.exports;
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = r(ZOe);
  function r(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var a = n.default;
  e.default = a, t.exports = e.default;
})(JF, JF.exports);
var XOe = JF.exports;
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = P;
  var n = O(EOe), r = O(TOe), a = O(Ah), i = O(NOe), o = O(POe), s = O(Tne), u = h_, f = O(w0), p = O(hu), m = T0, v = O(XOe);
  function O(D) {
    return D && D.__esModule ? D : { default: D };
  }
  var w = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, _ = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, C = /^'([^]*?)'?$/, A = /''/g, N = /[a-zA-Z]/;
  function P(D, M, H) {
    var Y, q, Q, ne, J, ue, ee, fe, de, ie, le, ye, B, pe, _e, Z, ce, j;
    (0, p.default)(2, arguments);
    var K = String(M), Ee = (0, m.getDefaultOptions)(), he = (Y = (q = H == null ? void 0 : H.locale) !== null && q !== void 0 ? q : Ee.locale) !== null && Y !== void 0 ? Y : v.default, Ae = (0, f.default)((Q = (ne = (J = (ue = H == null ? void 0 : H.firstWeekContainsDate) !== null && ue !== void 0 ? ue : H == null || (ee = H.locale) === null || ee === void 0 || (fe = ee.options) === null || fe === void 0 ? void 0 : fe.firstWeekContainsDate) !== null && J !== void 0 ? J : Ee.firstWeekContainsDate) !== null && ne !== void 0 ? ne : (de = Ee.locale) === null || de === void 0 || (ie = de.options) === null || ie === void 0 ? void 0 : ie.firstWeekContainsDate) !== null && Q !== void 0 ? Q : 1);
    if (!(Ae >= 1 && Ae <= 7))
      throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var Te = (0, f.default)((le = (ye = (B = (pe = H == null ? void 0 : H.weekStartsOn) !== null && pe !== void 0 ? pe : H == null || (_e = H.locale) === null || _e === void 0 || (Z = _e.options) === null || Z === void 0 ? void 0 : Z.weekStartsOn) !== null && B !== void 0 ? B : Ee.weekStartsOn) !== null && ye !== void 0 ? ye : (ce = Ee.locale) === null || ce === void 0 || (j = ce.options) === null || j === void 0 ? void 0 : j.weekStartsOn) !== null && le !== void 0 ? le : 0);
    if (!(Te >= 0 && Te <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!he.localize)
      throw new RangeError("locale must contain localize property");
    if (!he.formatLong)
      throw new RangeError("locale must contain formatLong property");
    var je = (0, a.default)(D);
    if (!(0, n.default)(je))
      throw new RangeError("Invalid time value");
    var we = (0, s.default)(je), lt = (0, r.default)(je, we), st = {
      firstWeekContainsDate: Ae,
      weekStartsOn: Te,
      locale: he,
      _originalDate: je
    }, Oe = K.match(_).map(function(Re) {
      var Be = Re[0];
      if (Be === "p" || Be === "P") {
        var mt = o.default[Be];
        return mt(Re, he.formatLong);
      }
      return Re;
    }).join("").match(w).map(function(Re) {
      if (Re === "''")
        return "'";
      var Be = Re[0];
      if (Be === "'")
        return I(Re);
      var mt = i.default[Be];
      if (mt)
        return !(H != null && H.useAdditionalWeekYearTokens) && (0, u.isProtectedWeekYearToken)(Re) && (0, u.throwProtectedError)(Re, M, String(D)), !(H != null && H.useAdditionalDayOfYearTokens) && (0, u.isProtectedDayOfYearToken)(Re) && (0, u.throwProtectedError)(Re, M, String(D)), mt(lt, Re, he.localize, st);
      if (Be.match(N))
        throw new RangeError("Format string contains an unescaped latin alphabet character `" + Be + "`");
      return Re;
    }).join("");
    return Oe;
  }
  function I(D) {
    var M = D.match(C);
    return M ? M[1].replace(A, "'") : D;
  }
  t.exports = e.default;
})(IF, IF.exports);
var qOe = IF.exports;
const KOe = /* @__PURE__ */ Pl(qOe);
function pV(t, e, n) {
  var r = tEe(t, n.timeZone, n.locale);
  return r.formatToParts ? JOe(r, e) : eEe(r, e);
}
function JOe(t, e) {
  for (var n = t.formatToParts(e), r = n.length - 1; r >= 0; --r)
    if (n[r].type === "timeZoneName")
      return n[r].value;
}
function eEe(t, e) {
  var n = t.format(e).replace(/\u200E/g, ""), r = / [\w-+ ]+$/.exec(n);
  return r ? r[0].substr(1) : "";
}
function tEe(t, e, n) {
  if (n && !n.code)
    throw new Error(
      "date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`"
    );
  return new Intl.DateTimeFormat(n ? [n.code, "en-US"] : void 0, {
    timeZone: e,
    timeZoneName: t
  });
}
function nEe(t, e) {
  var n = oEe(e);
  return n.formatToParts ? aEe(n, t) : iEe(n, t);
}
var rEe = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function aEe(t, e) {
  try {
    for (var n = t.formatToParts(e), r = [], a = 0; a < n.length; a++) {
      var i = rEe[n[a].type];
      i >= 0 && (r[i] = parseInt(n[a].value, 10));
    }
    return r;
  } catch (o) {
    if (o instanceof RangeError)
      return [NaN];
    throw o;
  }
}
function iEe(t, e) {
  var n = t.format(e).replace(/\u200E/g, ""), r = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(n);
  return [r[3], r[1], r[2], r[4], r[5], r[6]];
}
var CM = {};
function oEe(t) {
  if (!CM[t]) {
    var e = new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: "America/New_York",
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), n = e === "06/25/2014, 00:00:00" || e === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    CM[t] = n ? new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: t,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: t,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return CM[t];
}
function _ne(t, e, n, r, a, i, o) {
  var s = /* @__PURE__ */ new Date(0);
  return s.setUTCFullYear(t, e, n), s.setUTCHours(r, a, i, o), s;
}
var hV = 36e5, sEe = 6e4, xM = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
};
function qI(t, e, n) {
  var r, a;
  if (!t || (r = xM.timezoneZ.exec(t), r))
    return 0;
  var i;
  if (r = xM.timezoneHH.exec(t), r)
    return i = parseInt(r[1], 10), mV(i) ? -(i * hV) : NaN;
  if (r = xM.timezoneHHMM.exec(t), r) {
    i = parseInt(r[1], 10);
    var o = parseInt(r[2], 10);
    return mV(i, o) ? (a = Math.abs(i) * hV + o * sEe, i > 0 ? -a : a) : NaN;
  }
  if (cEe(t)) {
    e = new Date(e || Date.now());
    var s = n ? e : lEe(e), u = c$(s, t), f = n ? u : uEe(e, u, t);
    return -f;
  }
  return NaN;
}
function lEe(t) {
  return _ne(
    t.getFullYear(),
    t.getMonth(),
    t.getDate(),
    t.getHours(),
    t.getMinutes(),
    t.getSeconds(),
    t.getMilliseconds()
  );
}
function c$(t, e) {
  var n = nEe(t, e), r = _ne(
    n[0],
    n[1] - 1,
    n[2],
    n[3] % 24,
    n[4],
    n[5],
    0
  ).getTime(), a = t.getTime(), i = a % 1e3;
  return a -= i >= 0 ? i : 1e3 + i, r - a;
}
function uEe(t, e, n) {
  var r = t.getTime(), a = r - e, i = c$(new Date(a), n);
  if (e === i)
    return e;
  a -= i - e;
  var o = c$(new Date(a), n);
  return i === o ? i : Math.max(i, o);
}
function mV(t, e) {
  return -23 <= t && t <= 23 && (e == null || 0 <= e && e <= 59);
}
var gV = {};
function cEe(t) {
  if (gV[t])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: t }), gV[t] = !0, !0;
  } catch {
    return !1;
  }
}
var fEe = 60 * 1e3, dEe = {
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, n, r) {
    var a = AM(r.timeZone, r._originalDate || t);
    if (a === 0)
      return "Z";
    switch (e) {
      case "X":
        return bV(a);
      case "XXXX":
      case "XX":
        return oE(a);
      case "XXXXX":
      case "XXX":
      default:
        return oE(a, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, n, r) {
    var a = AM(r.timeZone, r._originalDate || t);
    switch (e) {
      case "x":
        return bV(a);
      case "xxxx":
      case "xx":
        return oE(a);
      case "xxxxx":
      case "xxx":
      default:
        return oE(a, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, n, r) {
    var a = AM(r.timeZone, r._originalDate || t);
    switch (e) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + pEe(a, ":");
      case "OOOO":
      default:
        return "GMT" + oE(a, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, n, r) {
    var a = r._originalDate || t;
    switch (e) {
      case "z":
      case "zz":
      case "zzz":
        return pV("short", a, r);
      case "zzzz":
      default:
        return pV("long", a, r);
    }
  }
};
function AM(t, e) {
  var n = t ? qI(t, e, !0) / fEe : e.getTimezoneOffset();
  if (Number.isNaN(n))
    throw new RangeError("Invalid time zone specified: " + t);
  return n;
}
function tR(t, e) {
  for (var n = t < 0 ? "-" : "", r = Math.abs(t).toString(); r.length < e; )
    r = "0" + r;
  return n + r;
}
function oE(t, e) {
  var n = e || "", r = t > 0 ? "-" : "+", a = Math.abs(t), i = tR(Math.floor(a / 60), 2), o = tR(Math.floor(a % 60), 2);
  return r + i + n + o;
}
function bV(t, e) {
  if (t % 60 === 0) {
    var n = t > 0 ? "-" : "+";
    return n + tR(Math.abs(t) / 60, 2);
  }
  return oE(t, e);
}
function pEe(t, e) {
  var n = t > 0 ? "-" : "+", r = Math.abs(t), a = Math.floor(r / 60), i = r % 60;
  if (i === 0)
    return n + String(a);
  var o = e || "";
  return n + String(a) + o + tR(i, 2);
}
const hEe = dEe;
var mEe = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, kM = 36e5, vV = 6e4, gEe = 2, lu = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: mEe
};
function Cne(t, e) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (t === null)
    return /* @__PURE__ */ new Date(NaN);
  var n = e || {}, r = n.additionalDigits == null ? gEe : SOe(n.additionalDigits);
  if (r !== 2 && r !== 1 && r !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]")
    return new Date(t.getTime());
  if (typeof t == "number" || Object.prototype.toString.call(t) === "[object Number]")
    return new Date(t);
  if (!(typeof t == "string" || Object.prototype.toString.call(t) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var a = bEe(t), i = vEe(a.date, r), o = i.year, s = i.restDateString, u = yEe(s, o);
  if (isNaN(u))
    return /* @__PURE__ */ new Date(NaN);
  if (u) {
    var f = u.getTime(), p = 0, m;
    if (a.time && (p = OEe(a.time), isNaN(p)))
      return /* @__PURE__ */ new Date(NaN);
    if (a.timeZone || n.timeZone) {
      if (m = qI(a.timeZone || n.timeZone, new Date(f + p)), isNaN(m))
        return /* @__PURE__ */ new Date(NaN);
    } else
      m = dV(new Date(f + p)), m = dV(new Date(f + p + m));
    return new Date(f + p + m);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function bEe(t) {
  var e = {}, n = lu.dateTimePattern.exec(t), r;
  if (n ? (e.date = n[1], r = n[3]) : (n = lu.datePattern.exec(t), n ? (e.date = n[1], r = n[2]) : (e.date = null, r = t)), r) {
    var a = lu.timeZone.exec(r);
    a ? (e.time = r.replace(a[1], ""), e.timeZone = a[1].trim()) : e.time = r;
  }
  return e;
}
function vEe(t, e) {
  var n = lu.YYY[e], r = lu.YYYYY[e], a;
  if (a = lu.YYYY.exec(t) || r.exec(t), a) {
    var i = a[1];
    return {
      year: parseInt(i, 10),
      restDateString: t.slice(i.length)
    };
  }
  if (a = lu.YY.exec(t) || n.exec(t), a) {
    var o = a[1];
    return {
      year: parseInt(o, 10) * 100,
      restDateString: t.slice(o.length)
    };
  }
  return {
    year: null
  };
}
function yEe(t, e) {
  if (e === null)
    return null;
  var n, r, a, i;
  if (t.length === 0)
    return r = /* @__PURE__ */ new Date(0), r.setUTCFullYear(e), r;
  if (n = lu.MM.exec(t), n)
    return r = /* @__PURE__ */ new Date(0), a = parseInt(n[1], 10) - 1, OV(e, a) ? (r.setUTCFullYear(e, a), r) : /* @__PURE__ */ new Date(NaN);
  if (n = lu.DDD.exec(t), n) {
    r = /* @__PURE__ */ new Date(0);
    var o = parseInt(n[1], 10);
    return wEe(e, o) ? (r.setUTCFullYear(e, 0, o), r) : /* @__PURE__ */ new Date(NaN);
  }
  if (n = lu.MMDD.exec(t), n) {
    r = /* @__PURE__ */ new Date(0), a = parseInt(n[1], 10) - 1;
    var s = parseInt(n[2], 10);
    return OV(e, a, s) ? (r.setUTCFullYear(e, a, s), r) : /* @__PURE__ */ new Date(NaN);
  }
  if (n = lu.Www.exec(t), n)
    return i = parseInt(n[1], 10) - 1, EV(e, i) ? yV(e, i) : /* @__PURE__ */ new Date(NaN);
  if (n = lu.WwwD.exec(t), n) {
    i = parseInt(n[1], 10) - 1;
    var u = parseInt(n[2], 10) - 1;
    return EV(e, i, u) ? yV(e, i, u) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function OEe(t) {
  var e, n, r;
  if (e = lu.HH.exec(t), e)
    return n = parseFloat(e[1].replace(",", ".")), RM(n) ? n % 24 * kM : NaN;
  if (e = lu.HHMM.exec(t), e)
    return n = parseInt(e[1], 10), r = parseFloat(e[2].replace(",", ".")), RM(n, r) ? n % 24 * kM + r * vV : NaN;
  if (e = lu.HHMMSS.exec(t), e) {
    n = parseInt(e[1], 10), r = parseInt(e[2], 10);
    var a = parseFloat(e[3].replace(",", "."));
    return RM(n, r, a) ? n % 24 * kM + r * vV + a * 1e3 : NaN;
  }
  return null;
}
function yV(t, e, n) {
  e = e || 0, n = n || 0;
  var r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(t, 0, 4);
  var a = r.getUTCDay() || 7, i = e * 7 + n + 1 - a;
  return r.setUTCDate(r.getUTCDate() + i), r;
}
var EEe = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], SEe = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function xne(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function OV(t, e, n) {
  if (e < 0 || e > 11)
    return !1;
  if (n != null) {
    if (n < 1)
      return !1;
    var r = xne(t);
    if (r && n > SEe[e] || !r && n > EEe[e])
      return !1;
  }
  return !0;
}
function wEe(t, e) {
  if (e < 1)
    return !1;
  var n = xne(t);
  return !(n && e > 366 || !n && e > 365);
}
function EV(t, e, n) {
  return !(e < 0 || e > 52 || n != null && (n < 0 || n > 6));
}
function RM(t, e, n) {
  return !(t != null && (t < 0 || t >= 25) || e != null && (e < 0 || e >= 60) || n != null && (n < 0 || n >= 60));
}
var TEe = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function _Ee(t, e, n) {
  var r = String(e), a = n || {}, i = r.match(TEe);
  if (i) {
    var o = Cne(t, a);
    r = i.reduce(function(s, u) {
      if (u[0] === "'")
        return s;
      var f = s.indexOf(u), p = s[f - 1] === "'", m = s.replace(
        u,
        "'" + hEe[u[0]](o, u, null, a) + "'"
      );
      return p ? m.substring(0, f - 1) + m.substring(f + 1) : m;
    }, r);
  }
  return KOe(t, r, a);
}
var f$ = { exports: {} }, d$ = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  function n(r, a) {
    if (r == null)
      throw new TypeError("assign requires that input parameter not be null or undefined");
    for (var i in a)
      Object.prototype.hasOwnProperty.call(a, i) && (r[i] = a[i]);
    return r;
  }
  t.exports = e.default;
})(d$, d$.exports);
var CEe = d$.exports;
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = a;
  var n = r(CEe);
  function r(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function a(i) {
    return (0, n.default)({}, i);
  }
  t.exports = e.default;
})(f$, f$.exports);
var xEe = f$.exports;
const AEe = /* @__PURE__ */ Pl(xEe);
function kEe(t, e, n) {
  var r = Cne(t, n), a = qI(e, r, !0), i = new Date(r.getTime() - a), o = /* @__PURE__ */ new Date(0);
  return o.setFullYear(i.getUTCFullYear(), i.getUTCMonth(), i.getUTCDate()), o.setHours(i.getUTCHours(), i.getUTCMinutes(), i.getUTCSeconds(), i.getUTCMilliseconds()), o;
}
function REe(t, e, n, r) {
  var a = AEe(r);
  return a.timeZone = e, _Ee(kEe(t, e), n, a);
}
function p$(t, e) {
  return -qI(t, e);
}
const IEe = {
  "Asia/Calcutta": "Asia/Kolkata"
};
function KI() {
  let t = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return t = IEe[t] || t, t;
}
function CXe() {
  return p$(KI());
}
function Ane(t, e) {
  return p$(t) - p$(e);
}
function h$(t) {
  return Ane(KI(), t);
}
function DEe(t) {
  return new Date(t.toDateString());
}
class kne extends Date {
  constructor(n, r = kne.getLocalTimeZoneName()) {
    super(n);
    Xj(this, "timeZone");
    this.timeZone = r;
  }
  toJSON(n) {
    return new Date(this.getTime() - h$(this.timeZone)).toISOString();
  }
  translateToTimeZone(n) {
    return new Date(this.getTime() - Ane(this.timeZone, n));
  }
  static getLocalTimeZoneName() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  static truncateTime(n) {
    return new Date(n.toDateString());
  }
}
const BE = (t) => ["string", "number"].includes(typeof t) ? {
  display: t,
  value: t
} : t != null && t.options ? NEe(t) : t, NEe = (t) => {
  var e;
  return {
    label: t == null ? void 0 : t.label,
    options: (e = t == null ? void 0 : t.options) == null ? void 0 : e.map(BE)
  };
}, Vw = (t) => {
  var e;
  return ["string", "number"].includes(typeof t) ? {
    display: t,
    value: t
  } : t != null && t.options ? (e = t == null ? void 0 : t.options) == null ? void 0 : e.map(BE) : t;
}, { Option: PEe, MultiValueLabel: LEe } = jd, Zm = "byz-select", MEe = ({ inputValue: t }) => /* @__PURE__ */ Ne.jsxs("div", { className: pn(`${Zm}__create-option`), children: [
  t,
  " ",
  /* @__PURE__ */ Ne.jsx("span", { className: pn(`${Zm}__create-icon`) })
] }), wE = bs(
  ({
    // ref.current.value
    onChange: t,
    name: e,
    labelText: n,
    label: r = n,
    className: a,
    options: i,
    disabledOptions: o = [],
    placeholder: s = "",
    value: u,
    disabled: f,
    allowMultiple: p,
    maxSelections: m,
    defaultMenuIsOpen: v,
    allowClear: O = !0,
    optionComponent: w,
    multiValueComponent: _,
    noOptionsMessage: C,
    loadingMessage: A,
    reactSelectProps: N,
    disableSeeMore: P = !1,
    allowCreate: I = !1
  }, D) => {
    const [M, H] = kn(), [Y, q] = kn([]), [Q, ne] = kn([]), [J, ue] = kn([]), [ee, fe] = kn(""), de = w, ie = _, le = Mc(() => ({
      DropdownIndicator: tU,
      ClearIndicator: ZI,
      Option: (j) => /* @__PURE__ */ Ne.jsx(
        PEe,
        {
          ...j,
          className: de ? "customComponent" : void 0,
          children: de ? /* @__PURE__ */ Ne.jsx(de, { ...j, ...j.innerProps }) : /* @__PURE__ */ Ne.jsx(Ne.Fragment, { children: j.children })
        }
      ),
      MultiValueLabel: (j) => /* @__PURE__ */ Ne.jsx(LEe, { ...j, children: ie ? /* @__PURE__ */ Ne.jsx(ie, { ...j, ...j.innerProps }) : /* @__PURE__ */ Ne.jsx(Ne.Fragment, { children: j.children }) }),
      ValueContainer: P ? void 0 : XI
    }), [w]);
    Vn(() => {
      H(u);
    }, [u]), Vn(() => {
      M || _e();
    }, [M]), Vn(() => {
      var Ee;
      if (!i)
        return;
      let j, K;
      j = i == null ? void 0 : i.map(BE), q(j), K = (Ee = i == null ? void 0 : i.map(Vw)) == null ? void 0 : Ee.flat(), ne(K);
    }, [i]), Vn(() => {
      var K;
      if (!o || !(o != null && o.length))
        return;
      let j;
      j = (K = o == null ? void 0 : o.map(Vw)) == null ? void 0 : K.flat(), ue(j);
    }, [o]);
    function ye({ value: j }) {
      return (J == null ? void 0 : J.some((K) => j === (K == null ? void 0 : K.value) || j === K)) || (m ? Array.isArray(M) && (M == null ? void 0 : M.length) === m : !1);
    }
    const B = (j) => {
      const K = j != null && j.value ? j == null ? void 0 : j.value : j == null ? void 0 : j.map((Ee) => Ee == null ? void 0 : Ee.value);
      t ? t({
        value: K,
        // only return the unique code/value, user can use it however they want
        // sourceEvent: undefined,
        name: e,
        data: j
      }) : H(K);
    };
    function pe(j, K) {
      (K.action === "input-change" || K.action === "menu-close") && fe(j);
    }
    function _e() {
      fe("");
    }
    const Z = (j) => {
      const K = j.trim(), Ee = BE(K), he = (Te) => Te.value !== void 0, Ae = (Te) => he(Te) ? Te.value === K : Te.options.some((je) => je.value === K);
      Y.find(Ae) || (ne((Te) => [...Te, Vw(K)]), q((Te) => [...Te, Ee])), B(Ee);
    };
    Nl(
      D,
      () => ({
        value: M
      }),
      [M]
    );
    const ce = Mc(() => Q == null ? void 0 : Q.filter((j) => M === (j == null ? void 0 : j.value) || // handles primitives
    typeof M == "object" && (M == null ? void 0 : M.value) === (j == null ? void 0 : j.value) || // handles a single ByzzerSelectOption
    Array.isArray(M) && (M == null ? void 0 : M.some((K) => ((K == null ? void 0 : K.value) ?? K) === (j == null ? void 0 : j.value)))), [Q, M]);
    return /* @__PURE__ */ Ne.jsx("div", { className: pn(Zm, a), children: /* @__PURE__ */ Ne.jsxs(
      "label",
      {
        className: pn(Zm, a, {
          [`${Zm}--maxed-out`]: p && Array.isArray(M) && Math.max(1, m ?? 1 / 0) <= ((M == null ? void 0 : M.length) ?? 0),
          [`${Zm}--has-no-value`]: !M || !(M != null && M.length)
        }),
        children: [
          r ? /* @__PURE__ */ Ne.jsx("div", { className: pn(`${Zm}__label-text`), children: r }) : null,
          I ? /* @__PURE__ */ Ne.jsx(
            gOe,
            {
              ...N,
              classNamePrefix: Zm,
              options: Y,
              onCreateOption: Z,
              onChange: B,
              components: le,
              isOptionDisabled: ye,
              placeholder: s,
              menuPortalTarget: document.body,
              isClearable: O,
              menuPlacement: "auto",
              menuPosition: "absolute",
              isDisabled: f,
              onInputChange: pe,
              inputValue: ee,
              getOptionLabel: (j) => j.display,
              getOptionValue: (j) => j.value,
              value: ce,
              defaultMenuIsOpen: v,
              onBlur: _e,
              noOptionsMessage: () => C,
              loadingMessage: () => A,
              formatCreateLabel: (j) => /* @__PURE__ */ Ne.jsx(MEe, { inputValue: j }),
              getNewOptionData: (j, K) => ({
                display: K,
                value: j
              })
            }
          ) : /* @__PURE__ */ Ne.jsx(
            yne,
            {
              ...N,
              classNamePrefix: Zm,
              options: Y,
              onChange: B,
              components: le,
              isOptionDisabled: ye,
              placeholder: s,
              menuPortalTarget: document.body,
              isClearable: O,
              isMulti: p,
              closeMenuOnSelect: !p,
              menuPlacement: "auto",
              menuPosition: "absolute",
              isDisabled: f,
              onInputChange: pe,
              inputValue: ee,
              getOptionLabel: (j) => j.display,
              getOptionValue: (j) => j.value,
              value: ce,
              defaultMenuIsOpen: v,
              onBlur: _e,
              noOptionsMessage: ({ inputValue: j }) => C,
              loadingMessage: ({ inputValue: j }) => A
            }
          )
        ]
      }
    ) });
  }
);
wE.displayName = "ByzzerSelect";
const FEe = /* @__PURE__ */ na(dOe);
function Rne(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, jk(t, e);
}
var SV = Number.isNaN || function(e) {
  return typeof e == "number" && e !== e;
};
function $Ee(t, e) {
  return !!(t === e || SV(t) && SV(e));
}
function BEe(t, e) {
  if (t.length !== e.length)
    return !1;
  for (var n = 0; n < t.length; n++)
    if (!$Ee(t[n], e[n]))
      return !1;
  return !0;
}
function TE(t, e) {
  e === void 0 && (e = BEe);
  var n, r = [], a, i = !1;
  function o() {
    for (var s = [], u = 0; u < arguments.length; u++)
      s[u] = arguments[u];
    return i && n === this && e(s, r) || (a = t.apply(this, s), i = !0, n = this, r = s), a;
  }
  return o;
}
var UEe = typeof performance == "object" && typeof performance.now == "function", wV = UEe ? function() {
  return performance.now();
} : function() {
  return Date.now();
};
function nR(t) {
  cancelAnimationFrame(t.id);
}
function Ine(t, e) {
  var n = wV();
  function r() {
    wV() - n >= e ? t.call(null) : a.id = requestAnimationFrame(r);
  }
  var a = {
    id: requestAnimationFrame(r)
  };
  return a;
}
var IM = -1;
function m$(t) {
  if (t === void 0 && (t = !1), IM === -1 || t) {
    var e = document.createElement("div"), n = e.style;
    n.width = "50px", n.height = "50px", n.overflow = "scroll", document.body.appendChild(e), IM = e.offsetWidth - e.clientWidth, document.body.removeChild(e);
  }
  return IM;
}
var YO = null;
function rR(t) {
  if (t === void 0 && (t = !1), YO === null || t) {
    var e = document.createElement("div"), n = e.style;
    n.width = "50px", n.height = "50px", n.overflow = "scroll", n.direction = "rtl";
    var r = document.createElement("div"), a = r.style;
    return a.width = "100px", a.height = "100px", e.appendChild(r), document.body.appendChild(e), e.scrollLeft > 0 ? YO = "positive-descending" : (e.scrollLeft = 1, e.scrollLeft === 0 ? YO = "negative" : YO = "positive-ascending"), document.body.removeChild(e), YO;
  }
  return YO;
}
var zEe = 150, HEe = function(e) {
  var n = e.columnIndex;
  e.data;
  var r = e.rowIndex;
  return r + ":" + n;
}, _A = null, CA = null, xA = null;
process.env.NODE_ENV !== "production" && typeof window < "u" && typeof window.WeakSet < "u" && (_A = /* @__PURE__ */ new WeakSet(), CA = /* @__PURE__ */ new WeakSet(), xA = /* @__PURE__ */ new WeakSet());
function Dne(t) {
  var e, n = t.getColumnOffset, r = t.getColumnStartIndexForOffset, a = t.getColumnStopIndexForStartIndex, i = t.getColumnWidth, o = t.getEstimatedTotalHeight, s = t.getEstimatedTotalWidth, u = t.getOffsetForColumnAndAlignment, f = t.getOffsetForRowAndAlignment, p = t.getRowHeight, m = t.getRowOffset, v = t.getRowStartIndexForOffset, O = t.getRowStopIndexForStartIndex, w = t.initInstanceProps, _ = t.shouldResetStyleCacheOnItemSizeChange, C = t.validateProps;
  return e = /* @__PURE__ */ function(A) {
    Rne(N, A);
    function N(I) {
      var D;
      return D = A.call(this, I) || this, D._instanceProps = w(D.props, CT(D)), D._resetIsScrollingTimeoutId = null, D._outerRef = void 0, D.state = {
        instance: CT(D),
        isScrolling: !1,
        horizontalScrollDirection: "forward",
        scrollLeft: typeof D.props.initialScrollLeft == "number" ? D.props.initialScrollLeft : 0,
        scrollTop: typeof D.props.initialScrollTop == "number" ? D.props.initialScrollTop : 0,
        scrollUpdateWasRequested: !1,
        verticalScrollDirection: "forward"
      }, D._callOnItemsRendered = void 0, D._callOnItemsRendered = TE(function(M, H, Y, q, Q, ne, J, ue) {
        return D.props.onItemsRendered({
          overscanColumnStartIndex: M,
          overscanColumnStopIndex: H,
          overscanRowStartIndex: Y,
          overscanRowStopIndex: q,
          visibleColumnStartIndex: Q,
          visibleColumnStopIndex: ne,
          visibleRowStartIndex: J,
          visibleRowStopIndex: ue
        });
      }), D._callOnScroll = void 0, D._callOnScroll = TE(function(M, H, Y, q, Q) {
        return D.props.onScroll({
          horizontalScrollDirection: Y,
          scrollLeft: M,
          scrollTop: H,
          verticalScrollDirection: q,
          scrollUpdateWasRequested: Q
        });
      }), D._getItemStyle = void 0, D._getItemStyle = function(M, H) {
        var Y = D.props, q = Y.columnWidth, Q = Y.direction, ne = Y.rowHeight, J = D._getItemStyleCache(_ && q, _ && Q, _ && ne), ue = M + ":" + H, ee;
        if (J.hasOwnProperty(ue))
          ee = J[ue];
        else {
          var fe = n(D.props, H, D._instanceProps), de = Q === "rtl";
          J[ue] = ee = {
            position: "absolute",
            left: de ? void 0 : fe,
            right: de ? fe : void 0,
            top: m(D.props, M, D._instanceProps),
            height: p(D.props, M, D._instanceProps),
            width: i(D.props, H, D._instanceProps)
          };
        }
        return ee;
      }, D._getItemStyleCache = void 0, D._getItemStyleCache = TE(function(M, H, Y) {
        return {};
      }), D._onScroll = function(M) {
        var H = M.currentTarget, Y = H.clientHeight, q = H.clientWidth, Q = H.scrollLeft, ne = H.scrollTop, J = H.scrollHeight, ue = H.scrollWidth;
        D.setState(function(ee) {
          if (ee.scrollLeft === Q && ee.scrollTop === ne)
            return null;
          var fe = D.props.direction, de = Q;
          if (fe === "rtl")
            switch (rR()) {
              case "negative":
                de = -Q;
                break;
              case "positive-descending":
                de = ue - q - Q;
                break;
            }
          de = Math.max(0, Math.min(de, ue - q));
          var ie = Math.max(0, Math.min(ne, J - Y));
          return {
            isScrolling: !0,
            horizontalScrollDirection: ee.scrollLeft < Q ? "forward" : "backward",
            scrollLeft: de,
            scrollTop: ie,
            verticalScrollDirection: ee.scrollTop < ne ? "forward" : "backward",
            scrollUpdateWasRequested: !1
          };
        }, D._resetIsScrollingDebounced);
      }, D._outerRefSetter = function(M) {
        var H = D.props.outerRef;
        D._outerRef = M, typeof H == "function" ? H(M) : H != null && typeof H == "object" && H.hasOwnProperty("current") && (H.current = M);
      }, D._resetIsScrollingDebounced = function() {
        D._resetIsScrollingTimeoutId !== null && nR(D._resetIsScrollingTimeoutId), D._resetIsScrollingTimeoutId = Ine(D._resetIsScrolling, zEe);
      }, D._resetIsScrolling = function() {
        D._resetIsScrollingTimeoutId = null, D.setState({
          isScrolling: !1
        }, function() {
          D._getItemStyleCache(-1);
        });
      }, D;
    }
    N.getDerivedStateFromProps = function(D, M) {
      return WEe(D, M), C(D), null;
    };
    var P = N.prototype;
    return P.scrollTo = function(D) {
      var M = D.scrollLeft, H = D.scrollTop;
      M !== void 0 && (M = Math.max(0, M)), H !== void 0 && (H = Math.max(0, H)), this.setState(function(Y) {
        return M === void 0 && (M = Y.scrollLeft), H === void 0 && (H = Y.scrollTop), Y.scrollLeft === M && Y.scrollTop === H ? null : {
          horizontalScrollDirection: Y.scrollLeft < M ? "forward" : "backward",
          scrollLeft: M,
          scrollTop: H,
          scrollUpdateWasRequested: !0,
          verticalScrollDirection: Y.scrollTop < H ? "forward" : "backward"
        };
      }, this._resetIsScrollingDebounced);
    }, P.scrollToItem = function(D) {
      var M = D.align, H = M === void 0 ? "auto" : M, Y = D.columnIndex, q = D.rowIndex, Q = this.props, ne = Q.columnCount, J = Q.height, ue = Q.rowCount, ee = Q.width, fe = this.state, de = fe.scrollLeft, ie = fe.scrollTop, le = m$();
      Y !== void 0 && (Y = Math.max(0, Math.min(Y, ne - 1))), q !== void 0 && (q = Math.max(0, Math.min(q, ue - 1)));
      var ye = o(this.props, this._instanceProps), B = s(this.props, this._instanceProps), pe = B > ee ? le : 0, _e = ye > J ? le : 0;
      this.scrollTo({
        scrollLeft: Y !== void 0 ? u(this.props, Y, H, de, this._instanceProps, _e) : de,
        scrollTop: q !== void 0 ? f(this.props, q, H, ie, this._instanceProps, pe) : ie
      });
    }, P.componentDidMount = function() {
      var D = this.props, M = D.initialScrollLeft, H = D.initialScrollTop;
      if (this._outerRef != null) {
        var Y = this._outerRef;
        typeof M == "number" && (Y.scrollLeft = M), typeof H == "number" && (Y.scrollTop = H);
      }
      this._callPropsCallbacks();
    }, P.componentDidUpdate = function() {
      var D = this.props.direction, M = this.state, H = M.scrollLeft, Y = M.scrollTop, q = M.scrollUpdateWasRequested;
      if (q && this._outerRef != null) {
        var Q = this._outerRef;
        if (D === "rtl")
          switch (rR()) {
            case "negative":
              Q.scrollLeft = -H;
              break;
            case "positive-ascending":
              Q.scrollLeft = H;
              break;
            default:
              var ne = Q.clientWidth, J = Q.scrollWidth;
              Q.scrollLeft = J - ne - H;
              break;
          }
        else
          Q.scrollLeft = Math.max(0, H);
        Q.scrollTop = Math.max(0, Y);
      }
      this._callPropsCallbacks();
    }, P.componentWillUnmount = function() {
      this._resetIsScrollingTimeoutId !== null && nR(this._resetIsScrollingTimeoutId);
    }, P.render = function() {
      var D = this.props, M = D.children, H = D.className, Y = D.columnCount, q = D.direction, Q = D.height, ne = D.innerRef, J = D.innerElementType, ue = D.innerTagName, ee = D.itemData, fe = D.itemKey, de = fe === void 0 ? HEe : fe, ie = D.outerElementType, le = D.outerTagName, ye = D.rowCount, B = D.style, pe = D.useIsScrolling, _e = D.width, Z = this.state.isScrolling, ce = this._getHorizontalRangeToRender(), j = ce[0], K = ce[1], Ee = this._getVerticalRangeToRender(), he = Ee[0], Ae = Ee[1], Te = [];
      if (Y > 0 && ye)
        for (var je = he; je <= Ae; je++)
          for (var we = j; we <= K; we++)
            Te.push(fu(M, {
              columnIndex: we,
              data: ee,
              isScrolling: pe ? Z : void 0,
              key: de({
                columnIndex: we,
                data: ee,
                rowIndex: je
              }),
              rowIndex: je,
              style: this._getItemStyle(je, we)
            }));
      var lt = o(this.props, this._instanceProps), st = s(this.props, this._instanceProps);
      return fu(ie || le || "div", {
        className: H,
        onScroll: this._onScroll,
        ref: this._outerRefSetter,
        style: rn({
          position: "relative",
          height: Q,
          width: _e,
          overflow: "auto",
          WebkitOverflowScrolling: "touch",
          willChange: "transform",
          direction: q
        }, B)
      }, fu(J || ue || "div", {
        children: Te,
        ref: ne,
        style: {
          height: lt,
          pointerEvents: Z ? "none" : void 0,
          width: st
        }
      }));
    }, P._callPropsCallbacks = function() {
      var D = this.props, M = D.columnCount, H = D.onItemsRendered, Y = D.onScroll, q = D.rowCount;
      if (typeof H == "function" && M > 0 && q > 0) {
        var Q = this._getHorizontalRangeToRender(), ne = Q[0], J = Q[1], ue = Q[2], ee = Q[3], fe = this._getVerticalRangeToRender(), de = fe[0], ie = fe[1], le = fe[2], ye = fe[3];
        this._callOnItemsRendered(ne, J, de, ie, ue, ee, le, ye);
      }
      if (typeof Y == "function") {
        var B = this.state, pe = B.horizontalScrollDirection, _e = B.scrollLeft, Z = B.scrollTop, ce = B.scrollUpdateWasRequested, j = B.verticalScrollDirection;
        this._callOnScroll(_e, Z, pe, j, ce);
      }
    }, P._getHorizontalRangeToRender = function() {
      var D = this.props, M = D.columnCount, H = D.overscanColumnCount, Y = D.overscanColumnsCount, q = D.overscanCount, Q = D.rowCount, ne = this.state, J = ne.horizontalScrollDirection, ue = ne.isScrolling, ee = ne.scrollLeft, fe = H || Y || q || 1;
      if (M === 0 || Q === 0)
        return [0, 0, 0, 0];
      var de = r(this.props, ee, this._instanceProps), ie = a(this.props, de, ee, this._instanceProps), le = !ue || J === "backward" ? Math.max(1, fe) : 1, ye = !ue || J === "forward" ? Math.max(1, fe) : 1;
      return [Math.max(0, de - le), Math.max(0, Math.min(M - 1, ie + ye)), de, ie];
    }, P._getVerticalRangeToRender = function() {
      var D = this.props, M = D.columnCount, H = D.overscanCount, Y = D.overscanRowCount, q = D.overscanRowsCount, Q = D.rowCount, ne = this.state, J = ne.isScrolling, ue = ne.verticalScrollDirection, ee = ne.scrollTop, fe = Y || q || H || 1;
      if (M === 0 || Q === 0)
        return [0, 0, 0, 0];
      var de = v(this.props, ee, this._instanceProps), ie = O(this.props, de, ee, this._instanceProps), le = !J || ue === "backward" ? Math.max(1, fe) : 1, ye = !J || ue === "forward" ? Math.max(1, fe) : 1;
      return [Math.max(0, de - le), Math.max(0, Math.min(Q - 1, ie + ye)), de, ie];
    }, N;
  }(jee), e.defaultProps = {
    direction: "ltr",
    itemData: void 0,
    useIsScrolling: !1
  }, e;
}
var WEe = function(e, n) {
  var r = e.children, a = e.direction, i = e.height, o = e.innerTagName, s = e.outerTagName, u = e.overscanColumnsCount, f = e.overscanCount, p = e.overscanRowsCount, m = e.width, v = n.instance;
  if (process.env.NODE_ENV !== "production") {
    if (typeof f == "number" && _A && !_A.has(v) && (_A.add(v), console.warn("The overscanCount prop has been deprecated. Please use the overscanColumnCount and overscanRowCount props instead.")), (typeof u == "number" || typeof p == "number") && CA && !CA.has(v) && (CA.add(v), console.warn("The overscanColumnsCount and overscanRowsCount props have been deprecated. Please use the overscanColumnCount and overscanRowCount props instead.")), (o != null || s != null) && xA && !xA.has(v) && (xA.add(v), console.warn("The innerTagName and outerTagName props have been deprecated. Please use the innerElementType and outerElementType props instead.")), r == null)
      throw Error('An invalid "children" prop has been specified. Value should be a React component. ' + ('"' + (r === null ? "null" : typeof r) + '" was specified.'));
    switch (a) {
      case "ltr":
      case "rtl":
        break;
      default:
        throw Error('An invalid "direction" prop has been specified. Value should be either "ltr" or "rtl". ' + ('"' + a + '" was specified.'));
    }
    if (typeof m != "number")
      throw Error('An invalid "width" prop has been specified. Grids must specify a number for width. ' + ('"' + (m === null ? "null" : typeof m) + '" was specified.'));
    if (typeof i != "number")
      throw Error('An invalid "height" prop has been specified. Grids must specify a number for height. ' + ('"' + (i === null ? "null" : typeof i) + '" was specified.'));
  }
}, TV = 50, Nne = function(e, n) {
  var r = e.rowCount, a = n.rowMetadataMap, i = n.estimatedRowHeight, o = n.lastMeasuredRowIndex, s = 0;
  if (o >= r && (o = r - 1), o >= 0) {
    var u = a[o];
    s = u.offset + u.size;
  }
  var f = r - o - 1, p = f * i;
  return s + p;
}, Pne = function(e, n) {
  var r = e.columnCount, a = n.columnMetadataMap, i = n.estimatedColumnWidth, o = n.lastMeasuredColumnIndex, s = 0;
  if (o >= r && (o = r - 1), o >= 0) {
    var u = a[o];
    s = u.offset + u.size;
  }
  var f = r - o - 1, p = f * i;
  return s + p;
}, Xm = function(e, n, r, a) {
  var i, o, s;
  if (e === "column" ? (i = a.columnMetadataMap, o = n.columnWidth, s = a.lastMeasuredColumnIndex) : (i = a.rowMetadataMap, o = n.rowHeight, s = a.lastMeasuredRowIndex), r > s) {
    var u = 0;
    if (s >= 0) {
      var f = i[s];
      u = f.offset + f.size;
    }
    for (var p = s + 1; p <= r; p++) {
      var m = o(p);
      i[p] = {
        offset: u,
        size: m
      }, u += m;
    }
    e === "column" ? a.lastMeasuredColumnIndex = r : a.lastMeasuredRowIndex = r;
  }
  return i[r];
}, _V = function(e, n, r, a) {
  var i, o;
  e === "column" ? (i = r.columnMetadataMap, o = r.lastMeasuredColumnIndex) : (i = r.rowMetadataMap, o = r.lastMeasuredRowIndex);
  var s = o > 0 ? i[o].offset : 0;
  return s >= a ? Lne(e, n, r, o, 0, a) : QEe(e, n, r, Math.max(0, o), a);
}, Lne = function(e, n, r, a, i, o) {
  for (; i <= a; ) {
    var s = i + Math.floor((a - i) / 2), u = Xm(e, n, s, r).offset;
    if (u === o)
      return s;
    u < o ? i = s + 1 : u > o && (a = s - 1);
  }
  return i > 0 ? i - 1 : 0;
}, QEe = function(e, n, r, a, i) {
  for (var o = e === "column" ? n.columnCount : n.rowCount, s = 1; a < o && Xm(e, n, a, r).offset < i; )
    a += s, s *= 2;
  return Lne(e, n, r, Math.min(a, o - 1), Math.floor(a / 2), i);
}, CV = function(e, n, r, a, i, o, s) {
  var u = e === "column" ? n.width : n.height, f = Xm(e, n, r, o), p = e === "column" ? Pne(n, o) : Nne(n, o), m = Math.max(0, Math.min(p - u, f.offset)), v = Math.max(0, f.offset - u + s + f.size);
  switch (a === "smart" && (i >= v - u && i <= m + u ? a = "auto" : a = "center"), a) {
    case "start":
      return m;
    case "end":
      return v;
    case "center":
      return Math.round(v + (m - v) / 2);
    case "auto":
    default:
      return i >= v && i <= m ? i : v > m || i < v ? v : m;
  }
}, jEe = /* @__PURE__ */ Dne({
  getColumnOffset: function(e, n, r) {
    return Xm("column", e, n, r).offset;
  },
  getColumnStartIndexForOffset: function(e, n, r) {
    return _V("column", e, r, n);
  },
  getColumnStopIndexForStartIndex: function(e, n, r, a) {
    for (var i = e.columnCount, o = e.width, s = Xm("column", e, n, a), u = r + o, f = s.offset + s.size, p = n; p < i - 1 && f < u; )
      p++, f += Xm("column", e, p, a).size;
    return p;
  },
  getColumnWidth: function(e, n, r) {
    return r.columnMetadataMap[n].size;
  },
  getEstimatedTotalHeight: Nne,
  getEstimatedTotalWidth: Pne,
  getOffsetForColumnAndAlignment: function(e, n, r, a, i, o) {
    return CV("column", e, n, r, a, i, o);
  },
  getOffsetForRowAndAlignment: function(e, n, r, a, i, o) {
    return CV("row", e, n, r, a, i, o);
  },
  getRowOffset: function(e, n, r) {
    return Xm("row", e, n, r).offset;
  },
  getRowHeight: function(e, n, r) {
    return r.rowMetadataMap[n].size;
  },
  getRowStartIndexForOffset: function(e, n, r) {
    return _V("row", e, r, n);
  },
  getRowStopIndexForStartIndex: function(e, n, r, a) {
    for (var i = e.rowCount, o = e.height, s = Xm("row", e, n, a), u = r + o, f = s.offset + s.size, p = n; p < i - 1 && f < u; )
      p++, f += Xm("row", e, p, a).size;
    return p;
  },
  initInstanceProps: function(e, n) {
    var r = e, a = r.estimatedColumnWidth, i = r.estimatedRowHeight, o = {
      columnMetadataMap: {},
      estimatedColumnWidth: a || TV,
      estimatedRowHeight: i || TV,
      lastMeasuredColumnIndex: -1,
      lastMeasuredRowIndex: -1,
      rowMetadataMap: {}
    };
    return n.resetAfterColumnIndex = function(s, u) {
      u === void 0 && (u = !0), n.resetAfterIndices({
        columnIndex: s,
        shouldForceUpdate: u
      });
    }, n.resetAfterRowIndex = function(s, u) {
      u === void 0 && (u = !0), n.resetAfterIndices({
        rowIndex: s,
        shouldForceUpdate: u
      });
    }, n.resetAfterIndices = function(s) {
      var u = s.columnIndex, f = s.rowIndex, p = s.shouldForceUpdate, m = p === void 0 ? !0 : p;
      typeof u == "number" && (o.lastMeasuredColumnIndex = Math.min(o.lastMeasuredColumnIndex, u - 1)), typeof f == "number" && (o.lastMeasuredRowIndex = Math.min(o.lastMeasuredRowIndex, f - 1)), n._getItemStyleCache(-1), m && n.forceUpdate();
    }, o;
  },
  shouldResetStyleCacheOnItemSizeChange: !1,
  validateProps: function(e) {
    var n = e.columnWidth, r = e.rowHeight;
    if (process.env.NODE_ENV !== "production") {
      if (typeof n != "function")
        throw Error('An invalid "columnWidth" prop has been specified. Value should be a function. ' + ('"' + (n === null ? "null" : typeof n) + '" was specified.'));
      if (typeof r != "function")
        throw Error('An invalid "rowHeight" prop has been specified. Value should be a function. ' + ('"' + (r === null ? "null" : typeof r) + '" was specified.'));
    }
  }
}), GEe = 150, VEe = function(e, n) {
  return e;
}, AA = null, kA = null;
process.env.NODE_ENV !== "production" && typeof window < "u" && typeof window.WeakSet < "u" && (AA = /* @__PURE__ */ new WeakSet(), kA = /* @__PURE__ */ new WeakSet());
function Mne(t) {
  var e, n = t.getItemOffset, r = t.getEstimatedTotalSize, a = t.getItemSize, i = t.getOffsetForIndexAndAlignment, o = t.getStartIndexForOffset, s = t.getStopIndexForStartIndex, u = t.initInstanceProps, f = t.shouldResetStyleCacheOnItemSizeChange, p = t.validateProps;
  return e = /* @__PURE__ */ function(m) {
    Rne(v, m);
    function v(w) {
      var _;
      return _ = m.call(this, w) || this, _._instanceProps = u(_.props, CT(_)), _._outerRef = void 0, _._resetIsScrollingTimeoutId = null, _.state = {
        instance: CT(_),
        isScrolling: !1,
        scrollDirection: "forward",
        scrollOffset: typeof _.props.initialScrollOffset == "number" ? _.props.initialScrollOffset : 0,
        scrollUpdateWasRequested: !1
      }, _._callOnItemsRendered = void 0, _._callOnItemsRendered = TE(function(C, A, N, P) {
        return _.props.onItemsRendered({
          overscanStartIndex: C,
          overscanStopIndex: A,
          visibleStartIndex: N,
          visibleStopIndex: P
        });
      }), _._callOnScroll = void 0, _._callOnScroll = TE(function(C, A, N) {
        return _.props.onScroll({
          scrollDirection: C,
          scrollOffset: A,
          scrollUpdateWasRequested: N
        });
      }), _._getItemStyle = void 0, _._getItemStyle = function(C) {
        var A = _.props, N = A.direction, P = A.itemSize, I = A.layout, D = _._getItemStyleCache(f && P, f && I, f && N), M;
        if (D.hasOwnProperty(C))
          M = D[C];
        else {
          var H = n(_.props, C, _._instanceProps), Y = a(_.props, C, _._instanceProps), q = N === "horizontal" || I === "horizontal", Q = N === "rtl", ne = q ? H : 0;
          D[C] = M = {
            position: "absolute",
            left: Q ? void 0 : ne,
            right: Q ? ne : void 0,
            top: q ? 0 : H,
            height: q ? "100%" : Y,
            width: q ? Y : "100%"
          };
        }
        return M;
      }, _._getItemStyleCache = void 0, _._getItemStyleCache = TE(function(C, A, N) {
        return {};
      }), _._onScrollHorizontal = function(C) {
        var A = C.currentTarget, N = A.clientWidth, P = A.scrollLeft, I = A.scrollWidth;
        _.setState(function(D) {
          if (D.scrollOffset === P)
            return null;
          var M = _.props.direction, H = P;
          if (M === "rtl")
            switch (rR()) {
              case "negative":
                H = -P;
                break;
              case "positive-descending":
                H = I - N - P;
                break;
            }
          return H = Math.max(0, Math.min(H, I - N)), {
            isScrolling: !0,
            scrollDirection: D.scrollOffset < P ? "forward" : "backward",
            scrollOffset: H,
            scrollUpdateWasRequested: !1
          };
        }, _._resetIsScrollingDebounced);
      }, _._onScrollVertical = function(C) {
        var A = C.currentTarget, N = A.clientHeight, P = A.scrollHeight, I = A.scrollTop;
        _.setState(function(D) {
          if (D.scrollOffset === I)
            return null;
          var M = Math.max(0, Math.min(I, P - N));
          return {
            isScrolling: !0,
            scrollDirection: D.scrollOffset < M ? "forward" : "backward",
            scrollOffset: M,
            scrollUpdateWasRequested: !1
          };
        }, _._resetIsScrollingDebounced);
      }, _._outerRefSetter = function(C) {
        var A = _.props.outerRef;
        _._outerRef = C, typeof A == "function" ? A(C) : A != null && typeof A == "object" && A.hasOwnProperty("current") && (A.current = C);
      }, _._resetIsScrollingDebounced = function() {
        _._resetIsScrollingTimeoutId !== null && nR(_._resetIsScrollingTimeoutId), _._resetIsScrollingTimeoutId = Ine(_._resetIsScrolling, GEe);
      }, _._resetIsScrolling = function() {
        _._resetIsScrollingTimeoutId = null, _.setState({
          isScrolling: !1
        }, function() {
          _._getItemStyleCache(-1, null);
        });
      }, _;
    }
    v.getDerivedStateFromProps = function(_, C) {
      return YEe(_, C), p(_), null;
    };
    var O = v.prototype;
    return O.scrollTo = function(_) {
      _ = Math.max(0, _), this.setState(function(C) {
        return C.scrollOffset === _ ? null : {
          scrollDirection: C.scrollOffset < _ ? "forward" : "backward",
          scrollOffset: _,
          scrollUpdateWasRequested: !0
        };
      }, this._resetIsScrollingDebounced);
    }, O.scrollToItem = function(_, C) {
      C === void 0 && (C = "auto");
      var A = this.props, N = A.itemCount, P = A.layout, I = this.state.scrollOffset;
      _ = Math.max(0, Math.min(_, N - 1));
      var D = 0;
      if (this._outerRef) {
        var M = this._outerRef;
        P === "vertical" ? D = M.scrollWidth > M.clientWidth ? m$() : 0 : D = M.scrollHeight > M.clientHeight ? m$() : 0;
      }
      this.scrollTo(i(this.props, _, C, I, this._instanceProps, D));
    }, O.componentDidMount = function() {
      var _ = this.props, C = _.direction, A = _.initialScrollOffset, N = _.layout;
      if (typeof A == "number" && this._outerRef != null) {
        var P = this._outerRef;
        C === "horizontal" || N === "horizontal" ? P.scrollLeft = A : P.scrollTop = A;
      }
      this._callPropsCallbacks();
    }, O.componentDidUpdate = function() {
      var _ = this.props, C = _.direction, A = _.layout, N = this.state, P = N.scrollOffset, I = N.scrollUpdateWasRequested;
      if (I && this._outerRef != null) {
        var D = this._outerRef;
        if (C === "horizontal" || A === "horizontal")
          if (C === "rtl")
            switch (rR()) {
              case "negative":
                D.scrollLeft = -P;
                break;
              case "positive-ascending":
                D.scrollLeft = P;
                break;
              default:
                var M = D.clientWidth, H = D.scrollWidth;
                D.scrollLeft = H - M - P;
                break;
            }
          else
            D.scrollLeft = P;
        else
          D.scrollTop = P;
      }
      this._callPropsCallbacks();
    }, O.componentWillUnmount = function() {
      this._resetIsScrollingTimeoutId !== null && nR(this._resetIsScrollingTimeoutId);
    }, O.render = function() {
      var _ = this.props, C = _.children, A = _.className, N = _.direction, P = _.height, I = _.innerRef, D = _.innerElementType, M = _.innerTagName, H = _.itemCount, Y = _.itemData, q = _.itemKey, Q = q === void 0 ? VEe : q, ne = _.layout, J = _.outerElementType, ue = _.outerTagName, ee = _.style, fe = _.useIsScrolling, de = _.width, ie = this.state.isScrolling, le = N === "horizontal" || ne === "horizontal", ye = le ? this._onScrollHorizontal : this._onScrollVertical, B = this._getRangeToRender(), pe = B[0], _e = B[1], Z = [];
      if (H > 0)
        for (var ce = pe; ce <= _e; ce++)
          Z.push(fu(C, {
            data: Y,
            key: Q(ce, Y),
            index: ce,
            isScrolling: fe ? ie : void 0,
            style: this._getItemStyle(ce)
          }));
      var j = r(this.props, this._instanceProps);
      return fu(J || ue || "div", {
        className: A,
        onScroll: ye,
        ref: this._outerRefSetter,
        style: rn({
          position: "relative",
          height: P,
          width: de,
          overflow: "auto",
          WebkitOverflowScrolling: "touch",
          willChange: "transform",
          direction: N
        }, ee)
      }, fu(D || M || "div", {
        children: Z,
        ref: I,
        style: {
          height: le ? "100%" : j,
          pointerEvents: ie ? "none" : void 0,
          width: le ? j : "100%"
        }
      }));
    }, O._callPropsCallbacks = function() {
      if (typeof this.props.onItemsRendered == "function") {
        var _ = this.props.itemCount;
        if (_ > 0) {
          var C = this._getRangeToRender(), A = C[0], N = C[1], P = C[2], I = C[3];
          this._callOnItemsRendered(A, N, P, I);
        }
      }
      if (typeof this.props.onScroll == "function") {
        var D = this.state, M = D.scrollDirection, H = D.scrollOffset, Y = D.scrollUpdateWasRequested;
        this._callOnScroll(M, H, Y);
      }
    }, O._getRangeToRender = function() {
      var _ = this.props, C = _.itemCount, A = _.overscanCount, N = this.state, P = N.isScrolling, I = N.scrollDirection, D = N.scrollOffset;
      if (C === 0)
        return [0, 0, 0, 0];
      var M = o(this.props, D, this._instanceProps), H = s(this.props, M, D, this._instanceProps), Y = !P || I === "backward" ? Math.max(1, A) : 1, q = !P || I === "forward" ? Math.max(1, A) : 1;
      return [Math.max(0, M - Y), Math.max(0, Math.min(C - 1, H + q)), M, H];
    }, v;
  }(jee), e.defaultProps = {
    direction: "ltr",
    itemData: void 0,
    layout: "vertical",
    overscanCount: 2,
    useIsScrolling: !1
  }, e;
}
var YEe = function(e, n) {
  var r = e.children, a = e.direction, i = e.height, o = e.layout, s = e.innerTagName, u = e.outerTagName, f = e.width, p = n.instance;
  if (process.env.NODE_ENV !== "production") {
    (s != null || u != null) && kA && !kA.has(p) && (kA.add(p), console.warn("The innerTagName and outerTagName props have been deprecated. Please use the innerElementType and outerElementType props instead."));
    var m = a === "horizontal" || o === "horizontal";
    switch (a) {
      case "horizontal":
      case "vertical":
        AA && !AA.has(p) && (AA.add(p), console.warn('The direction prop should be either "ltr" (default) or "rtl". Please use the layout prop to specify "vertical" (default) or "horizontal" orientation.'));
        break;
      case "ltr":
      case "rtl":
        break;
      default:
        throw Error('An invalid "direction" prop has been specified. Value should be either "ltr" or "rtl". ' + ('"' + a + '" was specified.'));
    }
    switch (o) {
      case "horizontal":
      case "vertical":
        break;
      default:
        throw Error('An invalid "layout" prop has been specified. Value should be either "horizontal" or "vertical". ' + ('"' + o + '" was specified.'));
    }
    if (r == null)
      throw Error('An invalid "children" prop has been specified. Value should be a React component. ' + ('"' + (r === null ? "null" : typeof r) + '" was specified.'));
    if (m && typeof f != "number")
      throw Error('An invalid "width" prop has been specified. Horizontal lists must specify a number for width. ' + ('"' + (f === null ? "null" : typeof f) + '" was specified.'));
    if (!m && typeof i != "number")
      throw Error('An invalid "height" prop has been specified. Vertical lists must specify a number for height. ' + ('"' + (i === null ? "null" : typeof i) + '" was specified.'));
  }
}, ZEe = 50, mE = function(e, n, r) {
  var a = e, i = a.itemSize, o = r.itemMetadataMap, s = r.lastMeasuredIndex;
  if (n > s) {
    var u = 0;
    if (s >= 0) {
      var f = o[s];
      u = f.offset + f.size;
    }
    for (var p = s + 1; p <= n; p++) {
      var m = i(p);
      o[p] = {
        offset: u,
        size: m
      }, u += m;
    }
    r.lastMeasuredIndex = n;
  }
  return o[n];
}, XEe = function(e, n, r) {
  var a = n.itemMetadataMap, i = n.lastMeasuredIndex, o = i > 0 ? a[i].offset : 0;
  return o >= r ? Fne(e, n, i, 0, r) : qEe(e, n, Math.max(0, i), r);
}, Fne = function(e, n, r, a, i) {
  for (; a <= r; ) {
    var o = a + Math.floor((r - a) / 2), s = mE(e, o, n).offset;
    if (s === i)
      return o;
    s < i ? a = o + 1 : s > i && (r = o - 1);
  }
  return a > 0 ? a - 1 : 0;
}, qEe = function(e, n, r, a) {
  for (var i = e.itemCount, o = 1; r < i && mE(e, r, n).offset < a; )
    r += o, o *= 2;
  return Fne(e, n, Math.min(r, i - 1), Math.floor(r / 2), a);
}, xV = function(e, n) {
  var r = e.itemCount, a = n.itemMetadataMap, i = n.estimatedItemSize, o = n.lastMeasuredIndex, s = 0;
  if (o >= r && (o = r - 1), o >= 0) {
    var u = a[o];
    s = u.offset + u.size;
  }
  var f = r - o - 1, p = f * i;
  return s + p;
}, KEe = /* @__PURE__ */ Mne({
  getItemOffset: function(e, n, r) {
    return mE(e, n, r).offset;
  },
  getItemSize: function(e, n, r) {
    return r.itemMetadataMap[n].size;
  },
  getEstimatedTotalSize: xV,
  getOffsetForIndexAndAlignment: function(e, n, r, a, i, o) {
    var s = e.direction, u = e.height, f = e.layout, p = e.width, m = s === "horizontal" || f === "horizontal", v = m ? p : u, O = mE(e, n, i), w = xV(e, i), _ = Math.max(0, Math.min(w - v, O.offset)), C = Math.max(0, O.offset - v + O.size + o);
    switch (r === "smart" && (a >= C - v && a <= _ + v ? r = "auto" : r = "center"), r) {
      case "start":
        return _;
      case "end":
        return C;
      case "center":
        return Math.round(C + (_ - C) / 2);
      case "auto":
      default:
        return a >= C && a <= _ ? a : a < C ? C : _;
    }
  },
  getStartIndexForOffset: function(e, n, r) {
    return XEe(e, r, n);
  },
  getStopIndexForStartIndex: function(e, n, r, a) {
    for (var i = e.direction, o = e.height, s = e.itemCount, u = e.layout, f = e.width, p = i === "horizontal" || u === "horizontal", m = p ? f : o, v = mE(e, n, a), O = r + m, w = v.offset + v.size, _ = n; _ < s - 1 && w < O; )
      _++, w += mE(e, _, a).size;
    return _;
  },
  initInstanceProps: function(e, n) {
    var r = e, a = r.estimatedItemSize, i = {
      itemMetadataMap: {},
      estimatedItemSize: a || ZEe,
      lastMeasuredIndex: -1
    };
    return n.resetAfterIndex = function(o, s) {
      s === void 0 && (s = !0), i.lastMeasuredIndex = Math.min(i.lastMeasuredIndex, o - 1), n._getItemStyleCache(-1), s && n.forceUpdate();
    }, i;
  },
  shouldResetStyleCacheOnItemSizeChange: !1,
  validateProps: function(e) {
    var n = e.itemSize;
    if (process.env.NODE_ENV !== "production" && typeof n != "function")
      throw Error('An invalid "itemSize" prop has been specified. Value should be a function. ' + ('"' + (n === null ? "null" : typeof n) + '" was specified.'));
  }
}), JEe = /* @__PURE__ */ Dne({
  getColumnOffset: function(e, n) {
    var r = e.columnWidth;
    return n * r;
  },
  getColumnWidth: function(e, n) {
    var r = e.columnWidth;
    return r;
  },
  getRowOffset: function(e, n) {
    var r = e.rowHeight;
    return n * r;
  },
  getRowHeight: function(e, n) {
    var r = e.rowHeight;
    return r;
  },
  getEstimatedTotalHeight: function(e) {
    var n = e.rowCount, r = e.rowHeight;
    return r * n;
  },
  getEstimatedTotalWidth: function(e) {
    var n = e.columnCount, r = e.columnWidth;
    return r * n;
  },
  getOffsetForColumnAndAlignment: function(e, n, r, a, i, o) {
    var s = e.columnCount, u = e.columnWidth, f = e.width, p = Math.max(0, s * u - f), m = Math.min(p, n * u), v = Math.max(0, n * u - f + o + u);
    switch (r === "smart" && (a >= v - f && a <= m + f ? r = "auto" : r = "center"), r) {
      case "start":
        return m;
      case "end":
        return v;
      case "center":
        var O = Math.round(v + (m - v) / 2);
        return O < Math.ceil(f / 2) ? 0 : O > p + Math.floor(f / 2) ? p : O;
      case "auto":
      default:
        return a >= v && a <= m ? a : v > m || a < v ? v : m;
    }
  },
  getOffsetForRowAndAlignment: function(e, n, r, a, i, o) {
    var s = e.rowHeight, u = e.height, f = e.rowCount, p = Math.max(0, f * s - u), m = Math.min(p, n * s), v = Math.max(0, n * s - u + o + s);
    switch (r === "smart" && (a >= v - u && a <= m + u ? r = "auto" : r = "center"), r) {
      case "start":
        return m;
      case "end":
        return v;
      case "center":
        var O = Math.round(v + (m - v) / 2);
        return O < Math.ceil(u / 2) ? 0 : O > p + Math.floor(u / 2) ? p : O;
      case "auto":
      default:
        return a >= v && a <= m ? a : v > m || a < v ? v : m;
    }
  },
  getColumnStartIndexForOffset: function(e, n) {
    var r = e.columnWidth, a = e.columnCount;
    return Math.max(0, Math.min(a - 1, Math.floor(n / r)));
  },
  getColumnStopIndexForStartIndex: function(e, n, r) {
    var a = e.columnWidth, i = e.columnCount, o = e.width, s = n * a, u = Math.ceil((o + r - s) / a);
    return Math.max(0, Math.min(
      i - 1,
      n + u - 1
      // -1 is because stop index is inclusive
    ));
  },
  getRowStartIndexForOffset: function(e, n) {
    var r = e.rowHeight, a = e.rowCount;
    return Math.max(0, Math.min(a - 1, Math.floor(n / r)));
  },
  getRowStopIndexForStartIndex: function(e, n, r) {
    var a = e.rowHeight, i = e.rowCount, o = e.height, s = n * a, u = Math.ceil((o + r - s) / a);
    return Math.max(0, Math.min(
      i - 1,
      n + u - 1
      // -1 is because stop index is inclusive
    ));
  },
  initInstanceProps: function(e) {
  },
  shouldResetStyleCacheOnItemSizeChange: !0,
  validateProps: function(e) {
    var n = e.columnWidth, r = e.rowHeight;
    if (process.env.NODE_ENV !== "production") {
      if (typeof n != "number")
        throw Error('An invalid "columnWidth" prop has been specified. Value should be a number. ' + ('"' + (n === null ? "null" : typeof n) + '" was specified.'));
      if (typeof r != "number")
        throw Error('An invalid "rowHeight" prop has been specified. Value should be a number. ' + ('"' + (r === null ? "null" : typeof r) + '" was specified.'));
    }
  }
}), e1e = /* @__PURE__ */ Mne({
  getItemOffset: function(e, n) {
    var r = e.itemSize;
    return n * r;
  },
  getItemSize: function(e, n) {
    var r = e.itemSize;
    return r;
  },
  getEstimatedTotalSize: function(e) {
    var n = e.itemCount, r = e.itemSize;
    return r * n;
  },
  getOffsetForIndexAndAlignment: function(e, n, r, a, i, o) {
    var s = e.direction, u = e.height, f = e.itemCount, p = e.itemSize, m = e.layout, v = e.width, O = s === "horizontal" || m === "horizontal", w = O ? v : u, _ = Math.max(0, f * p - w), C = Math.min(_, n * p), A = Math.max(0, n * p - w + p + o);
    switch (r === "smart" && (a >= A - w && a <= C + w ? r = "auto" : r = "center"), r) {
      case "start":
        return C;
      case "end":
        return A;
      case "center": {
        var N = Math.round(A + (C - A) / 2);
        return N < Math.ceil(w / 2) ? 0 : N > _ + Math.floor(w / 2) ? _ : N;
      }
      case "auto":
      default:
        return a >= A && a <= C ? a : a < A ? A : C;
    }
  },
  getStartIndexForOffset: function(e, n) {
    var r = e.itemCount, a = e.itemSize;
    return Math.max(0, Math.min(r - 1, Math.floor(n / a)));
  },
  getStopIndexForStartIndex: function(e, n, r) {
    var a = e.direction, i = e.height, o = e.itemCount, s = e.itemSize, u = e.layout, f = e.width, p = a === "horizontal" || u === "horizontal", m = n * s, v = p ? f : i, O = Math.ceil((v + r - m) / s);
    return Math.max(0, Math.min(
      o - 1,
      n + O - 1
      // -1 is because stop index is inclusive
    ));
  },
  initInstanceProps: function(e) {
  },
  shouldResetStyleCacheOnItemSizeChange: !0,
  validateProps: function(e) {
    var n = e.itemSize;
    if (process.env.NODE_ENV !== "production" && typeof n != "number")
      throw Error('An invalid "itemSize" prop has been specified. Value should be a number. ' + ('"' + (n === null ? "null" : typeof n) + '" was specified.'));
  }
});
function g$(t, e) {
  for (var n in t)
    if (!(n in e))
      return !0;
  for (var r in e)
    if (t[r] !== e[r])
      return !0;
  return !1;
}
var t1e = ["style"], n1e = ["style"];
function $ne(t, e) {
  var n = t.style, r = qb(t, t1e), a = e.style, i = qb(e, n1e);
  return !g$(n, a) && !g$(r, i);
}
function r1e(t, e) {
  return !$ne(this.props, t) || g$(this.state, e);
}
const a1e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  FixedSizeGrid: JEe,
  FixedSizeList: e1e,
  VariableSizeGrid: jEe,
  VariableSizeList: KEe,
  areEqual: $ne,
  shouldComponentUpdate: r1e
}, Symbol.toStringTag, { value: "Module" })), i1e = /* @__PURE__ */ na(a1e);
var o1e = function(t) {
  var e = {};
  function n(r) {
    if (e[r])
      return e[r].exports;
    var a = e[r] = { i: r, l: !1, exports: {} };
    return t[r].call(a.exports, a, a.exports, n), a.l = !0, a.exports;
  }
  return n.m = t, n.c = e, n.d = function(r, a, i) {
    n.o(r, a) || Object.defineProperty(r, a, { enumerable: !0, get: i });
  }, n.r = function(r) {
    typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(r, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(r, "__esModule", { value: !0 });
  }, n.t = function(r, a) {
    if (1 & a && (r = n(r)), 8 & a || 4 & a && typeof r == "object" && r && r.__esModule)
      return r;
    var i = /* @__PURE__ */ Object.create(null);
    if (n.r(i), Object.defineProperty(i, "default", { enumerable: !0, value: r }), 2 & a && typeof r != "string")
      for (var o in r)
        n.d(i, o, (function(s) {
          return r[s];
        }).bind(null, o));
    return i;
  }, n.n = function(r) {
    var a = r && r.__esModule ? function() {
      return r.default;
    } : function() {
      return r;
    };
    return n.d(a, "a", a), a;
  }, n.o = function(r, a) {
    return Object.prototype.hasOwnProperty.call(r, a);
  }, n.p = "", n(n.s = 6);
}([function(t, e) {
  t.exports = Ge;
}, function(t, e, n) {
  n.d(e, "a", function() {
    return i;
  }), n.d(e, "c", function() {
    return o;
  }), n.d(e, "d", function() {
    return u;
  }), n.d(e, "b", function() {
    return f;
  });
  var r = n(0), a = function(p, m) {
    for (var v = 0, O = m.length, w = p.length; v < O; v++, w++)
      p[w] = m[v];
    return p;
  };
  function i(p) {
    return ((p = p || [])[0] || {}).options !== void 0 ? p.reduce(function(m, v) {
      return m + v.options.length;
    }, 0) : p.length;
  }
  function o(p) {
    return p.reduce(function(m, v) {
      var O = v.props.children, w = O === void 0 ? [] : O;
      return a(a(a([], m), [r.cloneElement(v, { type: "group" }, [])]), w);
    }, []);
  }
  function s(p) {
    return p.props.isFocused === !0;
  }
  function u(p) {
    return Math.max(p.findIndex(s), 0);
  }
  function f(p) {
    var m = p.groupHeadingStyles, v = p.noOptionsMsgStyles, O = p.optionStyles, w = p.loadingMsgStyles;
    return function(_) {
      var C = _.props, A = C.type, N = C.children, P = C.inputValue, I = C.selectProps, D = I.noOptionsMessage, M = I.loadingMessage;
      if (A === "group") {
        var H = m.height;
        return H === void 0 ? 25 : H;
      }
      if (A === "option") {
        var Y = O.height;
        return Y === void 0 ? 35 : Y;
      }
      if (typeof D == "function" && N === D({ inputValue: P })) {
        var q = v.height;
        return q === void 0 ? 35 : q;
      }
      if (typeof M == "function" && N === M({ inputValue: P })) {
        var Q = w.height;
        return Q === void 0 ? 35 : Q;
      }
      return 35;
    };
  }
}, function(t, e, n) {
  var r = n(1), a = n(0), i = n(5), o = function() {
    return (o = Object.assign || function(f) {
      for (var p, m = 1, v = arguments.length; m < v; m++)
        for (var O in p = arguments[m])
          Object.prototype.hasOwnProperty.call(p, O) && (f[O] = p[O]);
      return f;
    }).apply(this, arguments);
  }, s = function(f, p) {
    var m = {};
    for (var v in f)
      Object.prototype.hasOwnProperty.call(f, v) && p.indexOf(v) < 0 && (m[v] = f[v]);
    if (f != null && typeof Object.getOwnPropertySymbols == "function") {
      var O = 0;
      for (v = Object.getOwnPropertySymbols(f); O < v.length; O++)
        p.indexOf(v[O]) < 0 && Object.prototype.propertyIsEnumerable.call(f, v[O]) && (m[v[O]] = f[v[O]]);
    }
    return m;
  };
  function u(f) {
    var p = f.data, m = f.index, v = f.setMeasuredHeight, O = a.useRef(null);
    return a.useLayoutEffect(function() {
      if (O.current) {
        var w = O.current.getBoundingClientRect().height;
        v({ index: m, measuredHeight: w });
      }
    }, [O.current]), a.createElement("div", { key: "option-" + m, ref: O }, p);
  }
  e.a = function(f) {
    var p = a.useMemo(function() {
      var ce = a.Children.toArray(f.children), j = ce[0] || {};
      if (a.isValidElement(j)) {
        var K = j.props, Ee = (K === void 0 ? {} : K).data, he = (Ee === void 0 ? {} : Ee).options, Ae = (he === void 0 ? [] : he).length > 0, Te = Ae && Object(r.c)(ce);
        return Ae ? Te : ce;
      }
      return [];
    }, [f.children]), m = f.getStyles, v = m("groupHeading", f), O = m("loadingMessage", f), w = m("noOptionsMessage", f), _ = m("option", f), C = Object(r.b)({ groupHeadingStyles: v, noOptionsMsgStyles: w, optionStyles: _, loadingMsgStyles: O }), A = a.useMemo(function() {
      return p.map(C);
    }, [p]), N = a.useMemo(function() {
      return Object(r.d)(p);
    }, [p]), P = p.length, I = a.useState({}), D = I[0], M = I[1], H = m("menuList", f), Y = H.maxHeight, q = H.paddingBottom, Q = q === void 0 ? 0 : q, ne = H.paddingTop, J = ne === void 0 ? 0 : ne, ue = s(H, ["maxHeight", "paddingBottom", "paddingTop"]), ee = a.useMemo(function() {
      return A.reduce(function(ce, j, K) {
        return D[K] ? ce + D[K] : ce + j;
      }, 0);
    }, [A, D]), fe = ee + Q + J, de = Math.min(Y, fe), ie = Math.floor(ee / P), le = f.innerRef, ye = f.selectProps || {}, B = ye.classNamePrefix, pe = ye.isMulti, _e = a.useRef(null);
    a.useEffect(function() {
      M({});
    }, [f.children]);
    var Z = function(ce) {
      var j = ce.index, K = ce.measuredHeight;
      D[j] !== void 0 && D[j] === K || (M(function(Ee) {
        var he;
        return o(o({}, Ee), ((he = {})[j] = K, he));
      }), _e.current && _e.current.resetAfterIndex(j));
    };
    return a.useEffect(function() {
      N >= 0 && _e.current !== null && _e.current.scrollToItem(N);
    }, [N, p, _e]), a.createElement(i.VariableSizeList, { className: B ? B + "__menu-list" + (pe ? " " + B + "__menu-list--is-multi" : "") : "", style: ue, ref: _e, outerRef: le, estimatedItemSize: ie, innerElementType: a.forwardRef(function(ce, j) {
      var K = ce.style, Ee = s(ce, ["style"]);
      return a.createElement("div", o({ ref: j, style: o(o({}, K), { height: parseFloat(K.height) + Q + J + "px" }) }, Ee));
    }), height: de, width: "100%", itemCount: P, itemData: p, itemSize: function(ce) {
      return D[ce] || A[ce];
    } }, function(ce) {
      var j = ce.data, K = ce.index, Ee = ce.style;
      return a.createElement("div", { style: o(o({}, Ee), { top: parseFloat(Ee.top.toString()) + J + "px" }) }, a.createElement(u, { data: j[K], index: K, setMeasuredHeight: Z }));
    });
  };
}, function(t, e) {
  t.exports = FEe;
}, function(t, e, n) {
  var r = n(2), a = n(0), i = n(3), o = n.n(i), s = n(1), u = function() {
    return (u = Object.assign || function(p) {
      for (var m, v = 1, O = arguments.length; v < O; v++)
        for (var w in m = arguments[v])
          Object.prototype.hasOwnProperty.call(m, w) && (p[w] = m[w]);
      return p;
    }).apply(this, arguments);
  }, f = function(p, m) {
    var v = {};
    for (var O in p)
      Object.prototype.hasOwnProperty.call(p, O) && m.indexOf(O) < 0 && (v[O] = p[O]);
    if (p != null && typeof Object.getOwnPropertySymbols == "function") {
      var w = 0;
      for (O = Object.getOwnPropertySymbols(p); w < O.length; w++)
        m.indexOf(O[w]) < 0 && Object.prototype.propertyIsEnumerable.call(p, O[w]) && (v[O[w]] = p[O[w]]);
    }
    return v;
  };
  e.a = a.forwardRef(function(p, m) {
    var v = p.windowThreshold, O = v === void 0 ? 100 : v, w = f(p, ["windowThreshold"]), _ = a.useMemo(function() {
      return Object(s.a)(w.options);
    }, [w.options]) >= O;
    return a.createElement(o.a, u({}, w, { components: u(u({}, w.components), _ ? { MenuList: r.a } : {}), ref: m }));
  });
}, function(t, e) {
  t.exports = i1e;
}, function(t, e, n) {
  n.r(e);
  var r = n(4), a = n(3);
  for (var i in a)
    ["default", "WindowedMenuList"].indexOf(i) < 0 && function(s) {
      n.d(e, s, function() {
        return a[s];
      });
    }(i);
  var o = n(2);
  n.d(e, "WindowedMenuList", function() {
    return o.a;
  }), e.default = r.a;
}]);
const s1e = /* @__PURE__ */ Pl(o1e), ZO = "byz-select", Bne = bs(({
  // ref.current.value
  onChange: t,
  name: e,
  labelText: n,
  label: r = n,
  className: a,
  options: i,
  disabledOptions: o = [],
  placeholder: s = "",
  value: u,
  disabled: f,
  allowMultiple: p = !1,
  maxSelections: m,
  defaultMenuIsOpen: v,
  allowClear: O = !0,
  optionComponent: w,
  multiValueComponent: _,
  noOptionsMessage: C,
  loadingMessage: A,
  windowThreshold: N = 500
}, P) => {
  const [I, D] = kn(), [M, H] = kn([]), [Y, q] = kn([]), [Q, ne] = kn([]), J = w, ue = _;
  Vn(() => {
    D(u);
  }, [u]), Vn(() => {
    var ye;
    if (!i)
      return;
    let ie, le;
    ie = i == null ? void 0 : i.map(BE), H(ie), le = (ye = i == null ? void 0 : i.map(Vw)) == null ? void 0 : ye.flat(), q(le);
  }, [i]), Vn(() => {
    var le;
    if (!o || !(o != null && o.length))
      return;
    let ie;
    ie = (le = o == null ? void 0 : o.map(Vw)) == null ? void 0 : le.flat(), ne(ie);
  }, [o]);
  function ee({ value: ie }) {
    return (Q == null ? void 0 : Q.some((le) => ie === (le == null ? void 0 : le.value) || ie === le)) || (m ? Array.isArray(I) && (I == null ? void 0 : I.length) === m : !1);
  }
  const fe = (ie) => {
    const le = ie != null && ie.value ? ie == null ? void 0 : ie.value : ie == null ? void 0 : ie.map((ye) => ye == null ? void 0 : ye.value);
    t ? t({
      value: le,
      // only return the unique code/value, user can use it however they want
      // sourceEvent: undefined,
      name: e,
      data: ie
    }) : D(le);
  };
  Nl(
    P,
    () => ({
      value: I
    }),
    [I]
  );
  const de = Mc(() => Y == null ? void 0 : Y.filter((ie) => I === (ie == null ? void 0 : ie.value) || // handles primitives
  typeof I == "object" && (I == null ? void 0 : I.value) === (ie == null ? void 0 : ie.value) || // handles a single ByzzerSelectOption
  Array.isArray(I) && (I == null ? void 0 : I.some((le) => ((le == null ? void 0 : le.value) ?? le) === (ie == null ? void 0 : ie.value)))), [Y, I]);
  return /* @__PURE__ */ Ne.jsx("div", { className: pn(ZO, a), children: /* @__PURE__ */ Ne.jsxs("label", { className: pn(ZO, a, {
    [`${ZO}--maxed-out`]: p && Array.isArray(I) && Math.max(1, m ?? 1 / 0) <= ((I == null ? void 0 : I.length) ?? 0),
    [`${ZO}--has-no-value`]: !I || !(I != null && I.length)
  }), children: [
    r ? /* @__PURE__ */ Ne.jsx("div", { className: pn(`${ZO}__label-text`), children: r }) : null,
    /* @__PURE__ */ Ne.jsx(
      s1e,
      {
        windowThreshold: 400,
        classNamePrefix: ZO,
        options: M,
        onChange: fe,
        components: {
          DropdownIndicator: tU,
          ClearIndicator: ZI,
          Option: (ie) => /* @__PURE__ */ Ne.jsx(jd.Option, { ...ie, className: J ? "customComponent" : void 0, children: J ? /* @__PURE__ */ Ne.jsx(J, { ...ie, ...ie.innerProps }) : /* @__PURE__ */ Ne.jsx(Ne.Fragment, { children: ie.children }) }),
          MultiValueLabel: (ie) => /* @__PURE__ */ Ne.jsx(jd.MultiValueLabel, { ...ie, children: ue ? /* @__PURE__ */ Ne.jsx(ue, { ...ie, ...ie.innerProps }) : /* @__PURE__ */ Ne.jsx(Ne.Fragment, { children: ie.children }) }),
          ValueContainer: XI
        },
        isOptionDisabled: ee,
        hideSelectedOptions: !0,
        placeholder: s,
        menuPortalTarget: document.body,
        isClearable: O,
        isMulti: p,
        closeMenuOnSelect: !p,
        menuPlacement: "auto",
        menuPosition: "absolute",
        isDisabled: f,
        getOptionLabel: (ie) => ie.display,
        getOptionValue: (ie) => ie.value,
        value: de,
        defaultMenuIsOpen: v,
        styles: {
          option: (ie) => ({
            ...ie,
            height: 45
            // must be type number
            //   padding: '20px 12px',
          })
        },
        noOptionsMessage: ({ inputValue: ie }) => C,
        loadingMessage: ({ inputValue: ie }) => A
      }
    )
  ] }) });
});
Bne.displayName = "ByzzerWindowedSelect";
function Une(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(t); a < r.length; a++)
      e.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[a]) && (n[r[a]] = t[r[a]]);
  return n;
}
var IT;
(function(t) {
  t.event = "event", t.props = "prop";
})(IT || (IT = {}));
function Bb() {
}
function l1e(t) {
  var e, n = void 0;
  return function() {
    for (var r = [], a = arguments.length; a--; )
      r[a] = arguments[a];
    return e && r.length === e.length && r.every(function(i, o) {
      return i === e[o];
    }) || (e = r, n = t.apply(void 0, r)), n;
  };
}
function DT(t) {
  return !!(t || "").match(/\d/);
}
function _E(t) {
  return t == null;
}
function u1e(t) {
  return typeof t == "number" && isNaN(t);
}
function zne(t) {
  return _E(t) || u1e(t) || typeof t == "number" && !isFinite(t);
}
function Hne(t) {
  return t.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
}
function c1e(t) {
  switch (t) {
    case "lakh":
      return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;
    case "wan":
      return /(\d)(?=(\d{4})+(?!\d))/g;
    case "thousand":
    default:
      return /(\d)(?=(\d{3})+(?!\d))/g;
  }
}
function f1e(t, e, n) {
  var r = c1e(n), a = t.search(/[1-9]/);
  return a = a === -1 ? t.length : a, t.substring(0, a) + t.substring(a, t.length).replace(r, "$1" + e);
}
function d1e(t) {
  var e = dr(t);
  e.current = t;
  var n = dr(function() {
    for (var r = [], a = arguments.length; a--; )
      r[a] = arguments[a];
    return e.current.apply(e, r);
  });
  return n.current;
}
function aU(t, e) {
  e === void 0 && (e = !0);
  var n = t[0] === "-", r = n && e;
  t = t.replace("-", "");
  var a = t.split("."), i = a[0], o = a[1] || "";
  return {
    beforeDecimal: i,
    afterDecimal: o,
    hasNegation: n,
    addNegation: r
  };
}
function p1e(t) {
  if (!t)
    return t;
  var e = t[0] === "-";
  e && (t = t.substring(1, t.length));
  var n = t.split("."), r = n[0].replace(/^0+/, "") || "0", a = n[1] || "";
  return (e ? "-" : "") + r + (a ? "." + a : "");
}
function Wne(t, e, n) {
  for (var r = "", a = n ? "0" : "", i = 0; i <= e - 1; i++)
    r += t[i] || a;
  return r;
}
function AV(t, e) {
  return Array(e + 1).join(t);
}
function Qne(t) {
  var e = t + "", n = e[0] === "-" ? "-" : "";
  n && (e = e.substring(1));
  var r = e.split(/[eE]/g), a = r[0], i = r[1];
  if (i = Number(i), !i)
    return n + a;
  a = a.replace(".", "");
  var o = 1 + i, s = a.length;
  return o < 0 ? a = "0." + AV("0", Math.abs(o)) + a : o >= s ? a = a + AV("0", o - s) : a = (a.substring(0, o) || "0") + "." + a.substring(o), n + a;
}
function kV(t, e, n) {
  if (["", "-"].indexOf(t) !== -1)
    return t;
  var r = (t.indexOf(".") !== -1 || n) && e, a = aU(t), i = a.beforeDecimal, o = a.afterDecimal, s = a.hasNegation, u = parseFloat("0." + (o || "0")), f = o.length <= e ? "0." + o : u.toFixed(e), p = f.split("."), m = i;
  i && Number(p[0]) && (m = i.split("").reverse().reduce(function(_, C, A) {
    return _.length > A ? (Number(_[0]) + Number(C)).toString() + _.substring(1, _.length) : C + _;
  }, p[0]));
  var v = Wne(p[1] || "", e, n), O = s ? "-" : "", w = r ? "." : "";
  return "" + O + m + w + v;
}
function Gy(t, e) {
  if (t.value = t.value, t !== null) {
    if (t.createTextRange) {
      var n = t.createTextRange();
      return n.move("character", e), n.select(), !0;
    }
    return t.selectionStart || t.selectionStart === 0 ? (t.focus(), t.setSelectionRange(e, e), !0) : (t.focus(), !1);
  }
}
var jne = l1e(function(t, e) {
  for (var n = 0, r = 0, a = t.length, i = e.length; t[n] === e[n] && n < a; )
    n++;
  for (; t[a - 1 - r] === e[i - 1 - r] && i - r > n && a - r > n; )
    r++;
  return {
    from: { start: n, end: a - r },
    to: { start: n, end: i - r }
  };
});
function h1e(t, e, n) {
  return Math.min(Math.max(t, e), n);
}
function DM(t) {
  return Math.max(t.selectionStart, t.selectionEnd);
}
function m1e() {
  return typeof navigator < "u" && !(navigator.platform && /iPhone|iPod/.test(navigator.platform));
}
function g1e(t) {
  return {
    from: {
      start: 0,
      end: 0
    },
    to: {
      start: 0,
      end: t.length
    },
    lastValue: ""
  };
}
function b1e(t) {
  var e = t.currentValue, n = t.formattedValue, r = t.currentValueIndex, a = t.formattedValueIndex;
  return e[r] === n[a];
}
function v1e(t, e, n, r, a, i, o) {
  o === void 0 && (o = b1e);
  var s = a.findIndex(function(I) {
    return I;
  }), u = t.slice(0, s);
  !e && !n.startsWith(u) && (e = u, n = u + n, r = r + u.length);
  for (var f = n.length, p = t.length, m = {}, v = new Array(f), O = 0; O < f; O++) {
    v[O] = -1;
    for (var w = 0, _ = p; w < _; w++) {
      var C = o({
        currentValue: n,
        lastValue: e,
        formattedValue: t,
        currentValueIndex: O,
        formattedValueIndex: w
      });
      if (C && m[w] !== !0) {
        v[O] = w, m[w] = !0;
        break;
      }
    }
  }
  for (var A = r; A < f && (v[A] === -1 || !i(n[A])); )
    A++;
  var N = A === f || v[A] === -1 ? p : v[A];
  for (A = r - 1; A > 0 && v[A] === -1; )
    A--;
  var P = A === -1 || v[A] === -1 ? 0 : v[A] + 1;
  return P > N ? N : r - P < N - r ? P : N;
}
function RV(t, e, n, r) {
  var a = t.length;
  if (e = h1e(e, 0, a), r === "left") {
    for (; e >= 0 && !n[e]; )
      e--;
    e === -1 && (e = n.indexOf(!0));
  } else {
    for (; e <= a && !n[e]; )
      e++;
    e > a && (e = n.lastIndexOf(!0));
  }
  return e === -1 && (e = a), e;
}
function y1e(t) {
  for (var e = Array.from({ length: t.length + 1 }).map(function() {
    return !0;
  }), n = 0, r = e.length; n < r; n++)
    e[n] = !!(DT(t[n]) || DT(t[n - 1]));
  return e;
}
function Gne(t, e, n, r, a, i) {
  i === void 0 && (i = Bb);
  var o = d1e(function(w, _) {
    var C, A;
    return zne(w) ? (A = "", C = "") : typeof w == "number" || _ ? (A = typeof w == "number" ? Qne(w) : w, C = r(A)) : (A = a(w, void 0), C = r(A)), { formattedValue: C, numAsString: A };
  }), s = kn(function() {
    return o(_E(t) ? e : t, n);
  }), u = s[0], f = s[1], p = function(w, _) {
    w.formattedValue !== u.formattedValue && f({
      formattedValue: w.formattedValue,
      numAsString: w.value
    }), i(w, _);
  }, m = t, v = n;
  _E(t) && (m = u.numAsString, v = !0);
  var O = o(m, v);
  return Mc(function() {
    f(O);
  }, [O.formattedValue]), [u, p];
}
function O1e(t) {
  return t.replace(/[^0-9]/g, "");
}
function E1e(t) {
  return t;
}
function S1e(t) {
  var e = t.type;
  e === void 0 && (e = "text");
  var n = t.displayType;
  n === void 0 && (n = "input");
  var r = t.customInput, a = t.renderText, i = t.getInputRef, o = t.format;
  o === void 0 && (o = E1e);
  var s = t.removeFormatting;
  s === void 0 && (s = O1e);
  var u = t.defaultValue, f = t.valueIsNumericString, p = t.onValueChange, m = t.isAllowed, v = t.onChange;
  v === void 0 && (v = Bb);
  var O = t.onKeyDown;
  O === void 0 && (O = Bb);
  var w = t.onMouseUp;
  w === void 0 && (w = Bb);
  var _ = t.onFocus;
  _ === void 0 && (_ = Bb);
  var C = t.onBlur;
  C === void 0 && (C = Bb);
  var A = t.value, N = t.getCaretBoundary;
  N === void 0 && (N = y1e);
  var P = t.isValidInputCharacter;
  P === void 0 && (P = DT);
  var I = t.isCharacterSame, D = Une(t, ["type", "displayType", "customInput", "renderText", "getInputRef", "format", "removeFormatting", "defaultValue", "valueIsNumericString", "onValueChange", "isAllowed", "onChange", "onKeyDown", "onMouseUp", "onFocus", "onBlur", "value", "getCaretBoundary", "isValidInputCharacter", "isCharacterSame"]), M = Gne(A, u, !!f, o, s, p), H = M[0], Y = H.formattedValue, q = H.numAsString, Q = M[1], ne = dr({ formattedValue: Y, numAsString: q }), J = function(Oe, Re) {
    ne.current = { formattedValue: Oe.formattedValue, numAsString: Oe.value }, Q(Oe, Re);
  }, ue = kn(!1), ee = ue[0], fe = ue[1], de = dr(null), ie = dr({
    setCaretTimeout: null,
    focusTimeout: null
  });
  Vn(function() {
    return fe(!0), function() {
      clearTimeout(ie.current.setCaretTimeout), clearTimeout(ie.current.focusTimeout);
    };
  }, []);
  var le = o, ye = function(Oe, Re) {
    var Be = parseFloat(Re);
    return {
      formattedValue: Oe,
      value: Re,
      floatValue: isNaN(Be) ? void 0 : Be
    };
  }, B = function(Oe, Re, Be) {
    Oe.selectionStart === 0 && Oe.selectionEnd === Oe.value.length || (Gy(Oe, Re), ie.current.setCaretTimeout = setTimeout(function() {
      Oe.value === Be && Oe.selectionStart !== Re && Gy(Oe, Re);
    }, 0));
  }, pe = function(Oe, Re, Be) {
    return RV(Oe, Re, N(Oe), Be);
  }, _e = function(Oe, Re, Be) {
    var mt = N(Re), Tt = v1e(Re, Y, Oe, Be, mt, P, I);
    return Tt = RV(Re, Tt, mt), Tt;
  }, Z = function(Oe) {
    var Re = Oe.formattedValue;
    Re === void 0 && (Re = "");
    var Be = Oe.input, mt = Oe.source, Tt = Oe.event, ut = Oe.numAsString, wt;
    if (Be) {
      var Yt = Oe.inputValue || Be.value, Rt = DM(Be);
      Be.value = Re, wt = _e(Yt, Re, Rt), wt !== void 0 && B(Be, wt, Re);
    }
    Re !== Y && J(ye(Re, ut), { event: Tt, source: mt });
  };
  Vn(function() {
    var Oe = ne.current, Re = Oe.formattedValue, Be = Oe.numAsString;
    Y !== Re && (Y !== q || Re !== Be) && J(ye(Y, q), {
      event: void 0,
      source: IT.props
    });
  }, [Y, q]);
  var ce = de.current ? DM(de.current) : void 0, j = typeof window < "u" ? l_ : Vn;
  j(function() {
    var Oe = de.current;
    if (Y !== ne.current.formattedValue && Oe) {
      var Re = _e(ne.current.formattedValue, Y, ce);
      Oe.value = Y, B(Oe, Re, Y);
    }
  }, [Y]);
  var K = function(Oe, Re, Be) {
    var mt = jne(Y, Oe), Tt = Object.assign(Object.assign({}, mt), { lastValue: Y }), ut = s(Oe, Tt), wt = le(ut);
    if (ut = s(wt, void 0), m && !m(ye(wt, ut))) {
      var Yt = Re.target, Rt = DM(Yt), Ut = _e(Oe, Y, Rt);
      return Yt.value = Y, B(Yt, Ut, Y), !1;
    }
    return Z({
      formattedValue: wt,
      numAsString: ut,
      inputValue: Oe,
      event: Re,
      source: Be,
      input: Re.target
    }), !0;
  }, Ee = function(Oe) {
    var Re = Oe.target, Be = Re.value, mt = K(Be, Oe, IT.event);
    mt && v(Oe);
  }, he = function(Oe) {
    var Re = Oe.target, Be = Oe.key, mt = Re.selectionStart, Tt = Re.selectionEnd, ut = Re.value;
    ut === void 0 && (ut = "");
    var wt;
    if (Be === "ArrowLeft" || Be === "Backspace" ? wt = Math.max(mt - 1, 0) : Be === "ArrowRight" ? wt = Math.min(mt + 1, ut.length) : Be === "Delete" && (wt = mt), wt === void 0 || mt !== Tt) {
      O(Oe);
      return;
    }
    var Yt = wt;
    if (Be === "ArrowLeft" || Be === "ArrowRight") {
      var Rt = Be === "ArrowLeft" ? "left" : "right";
      Yt = pe(ut, wt, Rt), Yt !== wt && Oe.preventDefault();
    } else
      Be === "Delete" && !P(ut[wt]) ? Yt = pe(ut, wt, "right") : Be === "Backspace" && !P(ut[wt]) && (Yt = pe(ut, wt, "left"));
    Yt !== wt && B(Re, Yt, ut), Oe.isUnitTestRun && B(Re, Yt, ut), O(Oe);
  }, Ae = function(Oe) {
    var Re = Oe.target, Be = function() {
      var mt = Re.selectionStart, Tt = Re.selectionEnd, ut = Re.value;
      if (ut === void 0 && (ut = ""), mt === Tt) {
        var wt = pe(ut, mt);
        wt !== mt && B(Re, wt, ut);
      }
    };
    Be(), requestAnimationFrame(function() {
      Be();
    }), w(Oe);
  }, Te = function(Oe) {
    Oe.persist && Oe.persist();
    var Re = Oe.target, Be = Oe.currentTarget;
    de.current = Re, ie.current.focusTimeout = setTimeout(function() {
      var mt = Re.selectionStart, Tt = Re.selectionEnd, ut = Re.value;
      ut === void 0 && (ut = "");
      var wt = pe(ut, mt);
      wt !== mt && !(mt === 0 && Tt === ut.length) && B(Re, wt, ut), _(Object.assign(Object.assign({}, Oe), { currentTarget: Be }));
    }, 0);
  }, je = function(Oe) {
    de.current = null, clearTimeout(ie.current.focusTimeout), clearTimeout(ie.current.setCaretTimeout), C(Oe);
  }, we = ee && m1e() ? "numeric" : void 0, lt = Object.assign({ inputMode: we }, D, {
    type: e,
    value: Y,
    onChange: Ee,
    onKeyDown: he,
    onMouseUp: Ae,
    onFocus: Te,
    onBlur: je
  });
  if (n === "text")
    return a ? Ge.createElement(Ge.Fragment, null, a(Y, D) || null) : Ge.createElement("span", Object.assign({}, D, { ref: i }), Y);
  if (r) {
    var st = r;
    return Ge.createElement(st, Object.assign({}, lt, { ref: i }));
  }
  return Ge.createElement("input", Object.assign({}, lt, { ref: i }));
}
function IV(t, e) {
  var n = e.decimalScale, r = e.fixedDecimalScale, a = e.prefix;
  a === void 0 && (a = "");
  var i = e.suffix;
  i === void 0 && (i = "");
  var o = e.allowNegative, s = e.thousandsGroupStyle;
  if (s === void 0 && (s = "thousand"), t === "" || t === "-")
    return t;
  var u = JI(e), f = u.thousandSeparator, p = u.decimalSeparator, m = n !== 0 && t.indexOf(".") !== -1 || n && r, v = aU(t, o), O = v.beforeDecimal, w = v.afterDecimal, _ = v.addNegation;
  return n !== void 0 && (w = Wne(w, n, !!r)), f && (O = f1e(O, f, s)), a && (O = a + O), i && (w = w + i), _ && (O = "-" + O), t = O + (m && p || "") + w, t;
}
function JI(t) {
  var e = t.decimalSeparator;
  e === void 0 && (e = ".");
  var n = t.thousandSeparator, r = t.allowedDecimalSeparators;
  return n === !0 && (n = ","), r || (r = [e, "."]), {
    decimalSeparator: e,
    thousandSeparator: n,
    allowedDecimalSeparators: r
  };
}
function w1e(t, e) {
  t === void 0 && (t = "");
  var n = new RegExp("(-)"), r = new RegExp("(-)(.)*(-)"), a = n.test(t), i = r.test(t);
  return t = t.replace(/-/g, ""), a && !i && e && (t = "-" + t), t;
}
function T1e(t, e) {
  return new RegExp("(^-)|[0-9]|" + Hne(t), e ? "g" : void 0);
}
function _1e(t, e, n) {
  return t === "" ? !0 : !(e != null && e.match(/\d/)) && !(n != null && n.match(/\d/)) && typeof t == "string" && !isNaN(Number(t));
}
function C1e(t, e, n) {
  var r;
  e === void 0 && (e = g1e(t));
  var a = n.allowNegative, i = n.prefix;
  i === void 0 && (i = "");
  var o = n.suffix;
  o === void 0 && (o = "");
  var s = n.decimalScale, u = e.from, f = e.to, p = f.start, m = f.end, v = JI(n), O = v.allowedDecimalSeparators, w = v.decimalSeparator, _ = t[m] === w;
  if (DT(t) && (t === i || t === o) && e.lastValue === "")
    return t;
  if (m - p === 1 && O.indexOf(t[p]) !== -1) {
    var C = s === 0 ? "" : w;
    t = t.substring(0, p) + C + t.substring(p + 1, t.length);
  }
  var A = function(ie, le, ye) {
    var B = !1, pe = !1;
    i.startsWith("-") ? B = !1 : ie.startsWith("--") ? (B = !1, pe = !0) : o.startsWith("-") && ie.length === o.length ? B = !1 : ie[0] === "-" && (B = !0);
    var _e = B ? 1 : 0;
    return pe && (_e = 2), _e && (ie = ie.substring(_e), le -= _e, ye -= _e), { value: ie, start: le, end: ye, hasNegation: B };
  }, N = A(t, p, m), P = N.hasNegation;
  r = N, t = r.value, p = r.start, m = r.end;
  var I = A(e.lastValue, u.start, u.end), D = I.start, M = I.end, H = I.value, Y = t.substring(p, m);
  t.length && H.length && (D > H.length - o.length || M < i.length) && !(Y && o.startsWith(Y)) && (t = H);
  var q = 0;
  t.startsWith(i) ? q += i.length : p < i.length && (q = p), t = t.substring(q), m -= q;
  var Q = t.length, ne = t.length - o.length;
  t.endsWith(o) ? Q = ne : (m > ne || m > t.length - o.length) && (Q = m), t = t.substring(0, Q), t = w1e(P ? "-" + t : t, a), t = (t.match(T1e(w, !0)) || []).join("");
  var J = t.indexOf(w);
  t = t.replace(new RegExp(Hne(w), "g"), function(ie, le) {
    return le === J ? "." : "";
  });
  var ue = aU(t, a), ee = ue.beforeDecimal, fe = ue.afterDecimal, de = ue.addNegation;
  return f.end - f.start < u.end - u.start && ee === "" && _ && !parseFloat(fe) && (t = de ? "-" : ""), t;
}
function x1e(t, e) {
  var n = e.prefix;
  n === void 0 && (n = "");
  var r = e.suffix;
  r === void 0 && (r = "");
  var a = Array.from({ length: t.length + 1 }).map(function() {
    return !0;
  }), i = t[0] === "-";
  a.fill(!1, 0, n.length + (i ? 1 : 0));
  var o = t.length;
  return a.fill(!1, o - r.length + 1, o + 1), a;
}
function A1e(t) {
  var e = JI(t), n = e.thousandSeparator, r = e.decimalSeparator, a = t.prefix;
  a === void 0 && (a = "");
  var i = t.allowNegative;
  if (i === void 0 && (i = !0), n === r)
    throw new Error(`
        Decimal separator can't be same as thousand separator.
        thousandSeparator: ` + n + ` (thousandSeparator = {true} is same as thousandSeparator = ",")
        decimalSeparator: ` + r + ` (default value for decimalSeparator is .)
     `);
  return a.startsWith("-") && i && (console.error(`
      Prefix can't start with '-' when allowNegative is true.
      prefix: ` + a + `
      allowNegative: ` + i + `
    `), i = !1), Object.assign(Object.assign({}, t), { allowNegative: i });
}
function k1e(t) {
  t = A1e(t), t.decimalSeparator, t.allowedDecimalSeparators, t.thousandsGroupStyle;
  var e = t.suffix, n = t.allowNegative, r = t.allowLeadingZeros, a = t.onKeyDown;
  a === void 0 && (a = Bb);
  var i = t.onBlur;
  i === void 0 && (i = Bb);
  var o = t.thousandSeparator, s = t.decimalScale, u = t.fixedDecimalScale, f = t.prefix;
  f === void 0 && (f = "");
  var p = t.defaultValue, m = t.value, v = t.valueIsNumericString, O = t.onValueChange, w = Une(t, ["decimalSeparator", "allowedDecimalSeparators", "thousandsGroupStyle", "suffix", "allowNegative", "allowLeadingZeros", "onKeyDown", "onBlur", "thousandSeparator", "decimalScale", "fixedDecimalScale", "prefix", "defaultValue", "value", "valueIsNumericString", "onValueChange"]), _ = JI(t), C = _.decimalSeparator, A = _.allowedDecimalSeparators, N = function(de) {
    return IV(de, t);
  }, P = function(de, ie) {
    return C1e(de, ie, t);
  }, I = _E(m) ? p : m, D = v ?? _1e(I, f, e);
  _E(m) ? _E(p) || (D = D || typeof p == "number") : D = D || typeof m == "number";
  var M = function(de) {
    return zne(de) ? de : (typeof de == "number" && (de = Qne(de)), D && typeof s == "number" ? kV(de, s, !!u) : de);
  }, H = Gne(M(m), M(p), !!D, N, P, O), Y = H[0], q = Y.numAsString, Q = Y.formattedValue, ne = H[1], J = function(de) {
    var ie = de.target, le = de.key, ye = ie.selectionStart, B = ie.selectionEnd, pe = ie.value;
    if (pe === void 0 && (pe = ""), ye !== B) {
      a(de);
      return;
    }
    le === "Backspace" && pe[0] === "-" && ye === f.length + 1 && n && Gy(ie, 1), s && u && (le === "Backspace" && pe[ye - 1] === C ? (Gy(ie, ye - 1), de.preventDefault()) : le === "Delete" && pe[ye] === C && de.preventDefault()), A != null && A.includes(le) && pe[ye] === C && Gy(ie, ye + 1);
    var _e = o === !0 ? "," : o;
    le === "Backspace" && pe[ye - 1] === _e && Gy(ie, ye - 1), le === "Delete" && pe[ye] === _e && Gy(ie, ye + 1), a(de);
  }, ue = function(de) {
    var ie = q;
    if (ie.match(/\d/g) || (ie = ""), r || (ie = p1e(ie)), u && s && (ie = kV(ie, s, u)), ie !== q) {
      var le = IV(ie, t);
      ne({
        formattedValue: le,
        value: ie,
        floatValue: parseFloat(ie)
      }, {
        event: de,
        source: IT.event
      });
    }
    i(de);
  }, ee = function(de) {
    return de === C ? !0 : DT(de);
  }, fe = function(de) {
    var ie = de.currentValue, le = de.lastValue, ye = de.formattedValue, B = de.currentValueIndex, pe = de.formattedValueIndex, _e = ie[B], Z = ye[pe], ce = jne(le, ie), j = ce.to;
    return B >= j.start && B < j.end && A && A.includes(_e) && Z === C ? !0 : _e === Z;
  };
  return Object.assign(Object.assign({}, w), {
    value: Q,
    valueIsNumericString: !1,
    isValidInputCharacter: ee,
    isCharacterSame: fe,
    onValueChange: ne,
    format: N,
    removeFormatting: P,
    getCaretBoundary: function(de) {
      return x1e(de, t);
    },
    onKeyDown: J,
    onBlur: ue
  });
}
function R1e(t) {
  var e = k1e(t);
  return Ge.createElement(S1e, Object.assign({}, e));
}
const ju = "byz-condition-input", xXe = bs(
  ({
    value: t,
    actions: e,
    label: n,
    keyLabel: r,
    keyPlaceholder: a,
    keyOptions: i,
    disabledKeys: o,
    keyNoOptionsMessage: s,
    keyLoadingMessage: u,
    onKeyChange: f,
    operationLabel: p,
    operationPlaceholder: m,
    operationOptions: v,
    disabledOperations: O,
    onOperationChange: w,
    valueLabel: _,
    valuePlaceholder: C,
    valueOptions: A,
    disabledValues: N,
    valueNoOptionsMessage: P,
    valueLoadingMessage: I,
    allowMultipleValues: D = !0,
    maxAllowedValues: M,
    onValueChange: H,
    onChange: Y,
    name: q,
    className: Q,
    renderLargeList: ne,
    isValueTextInput: J = !1,
    valueSuffix: ue,
    valuePrefix: ee,
    valueDecimalScale: fe,
    valueFixedDecimalScale: de = !1,
    valueThousandSeperator: ie = !1,
    valueGroupStyle: le = "none",
    allowKeyClear: ye = !0,
    allowOperationClear: B = !0,
    allowValueClear: pe = !0,
    keyReactSelectOptions: _e,
    operationReactSelectOptions: Z,
    valueReactSelectOptions: ce
  }, j) => {
    const [K, Ee] = kn();
    Vn(() => {
      Ee(t);
    }, [t]);
    function he(Te) {
      const je = {
        ...K,
        key: Te == null ? void 0 : Te.value,
        data: Te == null ? void 0 : Te.data,
        value: []
      };
      Y ? Y({
        // if onChange is present
        value: je,
        name: q
      }) : Ee(je), f == null || f({
        value: Te == null ? void 0 : Te.value,
        name: q
      });
    }
    const Ae = (Te) => {
      switch (Y ? Y == null || Y({
        // if onChange is present
        value: {
          ...K,
          [Te == null ? void 0 : Te.name]: Te == null ? void 0 : Te.value
        },
        name: q
      }) : Ee((je) => ({
        // if onChange ISNT present
        ...je,
        [Te == null ? void 0 : Te.name]: Te == null ? void 0 : Te.value
      })), Te == null ? void 0 : Te.name) {
        case "operation":
          w == null || w({
            value: Te.value,
            name: q
          });
          break;
        case "value":
          H == null || H({
            value: Te == null ? void 0 : Te.value,
            name: q
          });
          break;
      }
    };
    return Nl(
      j,
      () => ({
        value: K
      }),
      [K]
    ), /* @__PURE__ */ Ne.jsxs("div", { className: pn(ju, Q), children: [
      n ? /* @__PURE__ */ Ne.jsx("div", { className: pn(`${ju}__label-text`), children: n }) : null,
      /* @__PURE__ */ Ne.jsxs(
        "div",
        {
          className: pn(
            `${ju}__selectors-and-actions-wrapper`
          ),
          children: [
            /* @__PURE__ */ Ne.jsxs("div", { className: pn(`${ju}__selectors`), children: [
              /* @__PURE__ */ Ne.jsx(
                wE,
                {
                  reactSelectProps: _e,
                  className: `${ju}__key`,
                  options: i,
                  onChange: (Te) => he(Te),
                  name: "key",
                  value: K == null ? void 0 : K.key,
                  label: r,
                  placeholder: a,
                  disabledOptions: o,
                  noOptionsMessage: s,
                  loadingMessage: u,
                  allowClear: ye
                }
              ),
              /* @__PURE__ */ Ne.jsx(
                wE,
                {
                  reactSelectProps: Z,
                  className: `${ju}__operation`,
                  options: v,
                  onChange: Ae,
                  name: "operation",
                  value: K == null ? void 0 : K.operation,
                  label: p,
                  placeholder: m,
                  disabledOptions: O,
                  allowClear: B
                }
              ),
              ne ? /* @__PURE__ */ Ne.jsx(
                Bne,
                {
                  reactSelectProps: ce,
                  className: `${ju}__value`,
                  options: A,
                  onChange: Ae,
                  name: "value",
                  value: K == null ? void 0 : K.value,
                  label: _,
                  placeholder: K != null && K.key ? C : "",
                  disabledOptions: N,
                  disabled: !(K != null && K.key),
                  allowMultiple: D,
                  maxSelections: M,
                  allowClear: pe,
                  noOptionsMessage: P,
                  loadingMessage: I
                }
              ) : J ? /* @__PURE__ */ Ne.jsxs("div", { className: `${ju}__text-box`, children: [
                /* @__PURE__ */ Ne.jsx("label", { className: `${ju}__text-box--label`, children: _ }),
                /* @__PURE__ */ Ne.jsx(
                  R1e,
                  {
                    name: "value",
                    type: "text",
                    className: pn(`${ju}__key`, `${ju}__text-box--input`),
                    onChange: (Te) => Ae({ value: Te.target.value, name: Te.target.name }),
                    thousandsGroupStyle: le,
                    thousandSeparator: ie,
                    value: String(K == null ? void 0 : K.value),
                    disabled: !(K != null && K.key),
                    placeholder: K != null && K.key ? C : "",
                    prefix: ee ?? "",
                    suffix: ue ?? "",
                    decimalScale: fe ?? 0,
                    fixedDecimalScale: de
                  }
                )
              ] }) : /* @__PURE__ */ Ne.jsx(
                wE,
                {
                  className: `${ju}__value`,
                  reactSelectProps: ce,
                  options: A,
                  onChange: Ae,
                  name: "value",
                  value: K == null ? void 0 : K.value,
                  label: _,
                  placeholder: K != null && K.key ? C : "",
                  disabledOptions: N,
                  disabled: !(K != null && K.key),
                  allowMultiple: D,
                  maxSelections: M,
                  allowClear: pe,
                  noOptionsMessage: P,
                  loadingMessage: I
                }
              )
            ] }),
            e ? /* @__PURE__ */ Ne.jsx(
              "div",
              {
                className: pn(`${ju}__actions`, {
                  [`${ju}__actions--align-with-selectors`]: r ?? p ?? _
                }),
                children: e
              }
            ) : null
          ]
        }
      )
    ] });
  }
);
var I1e = ["defaultOptions", "cacheOptions", "loadOptions", "options", "isLoading", "onInputChange", "filterOption"];
function D1e(t) {
  var e = t.defaultOptions, n = e === void 0 ? !1 : e, r = t.cacheOptions, a = r === void 0 ? !1 : r, i = t.loadOptions;
  t.options;
  var o = t.isLoading, s = o === void 0 ? !1 : o, u = t.onInputChange, f = t.filterOption, p = f === void 0 ? null : f, m = lv(t, I1e), v = m.inputValue, O = dr(void 0), w = dr(!1), _ = kn(Array.isArray(n) ? n : void 0), C = ms(_, 2), A = C[0], N = C[1], P = kn(typeof v < "u" ? v : ""), I = ms(P, 2), D = I[0], M = I[1], H = kn(n === !0), Y = ms(H, 2), q = Y[0], Q = Y[1], ne = kn(void 0), J = ms(ne, 2), ue = J[0], ee = J[1], fe = kn([]), de = ms(fe, 2), ie = de[0], le = de[1], ye = kn(!1), B = ms(ye, 2), pe = B[0], _e = B[1], Z = kn({}), ce = ms(Z, 2), j = ce[0], K = ce[1], Ee = kn(void 0), he = ms(Ee, 2), Ae = he[0], Te = he[1], je = kn(void 0), we = ms(je, 2), lt = we[0], st = we[1];
  a !== lt && (K({}), st(a)), n !== Ae && (N(Array.isArray(n) ? n : void 0), Te(n)), Vn(function() {
    return w.current = !0, function() {
      w.current = !1;
    };
  }, []);
  var Oe = Ei(function(mt, Tt) {
    if (!i)
      return Tt();
    var ut = i(mt, Tt);
    ut && typeof ut.then == "function" && ut.then(Tt, function() {
      return Tt();
    });
  }, [i]);
  Vn(function() {
    n === !0 && Oe(D, function(mt) {
      w.current && (N(mt || []), Q(!!O.current));
    });
  }, []);
  var Re = Ei(function(mt, Tt) {
    var ut = bye(mt, Tt, u);
    if (!ut) {
      O.current = void 0, M(""), ee(""), le([]), Q(!1), _e(!1);
      return;
    }
    if (a && j[ut])
      M(ut), ee(ut), le(j[ut]), Q(!1), _e(!1);
    else {
      var wt = O.current = {};
      M(ut), Q(!0), _e(!ue), Oe(ut, function(Yt) {
        w && wt === O.current && (O.current = void 0, Q(!1), ee(ut), le(Yt || []), _e(!1), K(Yt ? Hn(Hn({}, j), {}, hE({}, ut, Yt)) : j));
      });
    }
  }, [a, Oe, ue, j, u]), Be = pe ? [] : D && ue ? ie : A || [];
  return Hn(Hn({}, m), {}, {
    options: Be,
    isLoading: q || s,
    onInputChange: Re,
    filterOption: p
  });
}
var N1e = /* @__PURE__ */ bs(function(t, e) {
  var n = D1e(t), r = HI(n);
  return /* @__PURE__ */ On.createElement(YI, rn({
    ref: e
  }, r));
});
const P1e = N1e;
const L1e = (t) => ({
  display: t.display ?? t,
  value: t.value ?? t,
  data: (t == null ? void 0 : t.data) ?? t
}), M1e = (t, e) => e != null && e.length ? !(e != null && e.includes(t == null ? void 0 : t.value)) : !0, dw = "byz-search";
function F1e({ children: t }) {
  return t;
}
function $1e({ children: t }) {
  return t;
}
const B1e = bs(({
  search: t,
  converter: e = L1e,
  placeholder: n = "Search for a value",
  onChange: r,
  onMenuOpen: a,
  name: i,
  value: o,
  disabled: s,
  label: u,
  className: f,
  maxSelections: p,
  searchDelay: m = 1e3,
  minSearchCharacters: v = 2,
  loadingMessage: O = "Loading...",
  noOptionsMessage: w = "No results found",
  searchOptionRenderer: _ = F1e,
  chipRenderer: C = $1e,
  keepResultsMenuOpen: A,
  // RENAME THIS TO MAKE IT CLEAR IT'S ONLY FOR TESTING
  excludedOptions: N,
  // don't have a default empty array for a non-orimitive, at least not here.  anywhere this is used an would expect an array, provide a default there instead
  exclusionFilter: P = M1e,
  searchOptionsHeader: I,
  searchOptionsFooter: D,
  onlyShowSearchOptionsHeaderWithSearchResults: M = !0,
  onlyShowSearchOptionsFooterWithSearchResults: H = !0,
  clearInputTextAfterSelection: Y
}, q) => {
  const [Q, ne] = kn([]), [J, ue] = kn([]), [ee, fe] = kn(""), de = dr(""), ie = _, le = C, ye = I, B = D;
  Vn(() => {
    if (!o)
      return;
    const Ee = (o == null ? void 0 : o.map(BE)) ?? [];
    ne(Ee);
  }, [o]), Vn(() => {
    N != null && N.length && pe(N);
  }, [N]);
  const pe = (Ee = []) => {
    const he = J == null ? void 0 : J.filter((Ae) => P(Ae, Ee ?? []));
    ue(he);
  };
  Vn(() => {
    Q != null && Q.length || K();
  }, [Q]);
  const _e = Ei(B5.debounce(
    (Ee, he) => {
      (Ee == null ? void 0 : Ee.length) < v || t(Ee).then((Ae) => {
        const Te = Ae == null ? void 0 : Ae.map(e).sort((we, lt) => {
          var st;
          return (st = we == null ? void 0 : we.display) == null ? void 0 : st.localeCompare(lt == null ? void 0 : lt.display);
        }), je = Te == null ? void 0 : Te.filter((we) => P(we, N ?? []));
        de.current = Ee, ue(je), he(je ?? []);
      });
    },
    m
  ), [Q, e, t]), Z = (Ee) => {
    const he = Ee == null ? void 0 : Ee.map((Te) => Te), Ae = Ee == null ? void 0 : Ee.map((Te) => Te);
    r ? r({
      value: he,
      // only return the unique code/value, user can use it however they want
      data: Ae,
      // sourceEvent: undefined,
      name: i
    }) : ne(he), Y && K();
  }, ce = (Ee, he) => {
    he.action === "input-change" && fe(Ee);
  };
  function j() {
    a == null || a();
  }
  const K = () => {
    ue([]), fe("");
  };
  return Nl(
    q,
    () => ({
      value: Q
    }),
    [Q]
  ), /* @__PURE__ */ Ne.jsxs("label", { className: pn(dw, f, {
    [`${dw}--maxed-out`]: Math.max(1, p ?? 1 / 0) <= ((Q == null ? void 0 : Q.length) ?? 0),
    [`${dw}--has-no-value`]: !(Q != null && Q.length)
  }), children: [
    u ? /* @__PURE__ */ Ne.jsx("div", { className: pn(`${dw}__label-text`), children: u }) : null,
    /* @__PURE__ */ Ne.jsx(
      P1e,
      {
        classNamePrefix: dw,
        onChange: Z,
        components: {
          DropdownIndicator: () => null,
          ClearIndicator: ZI,
          ValueContainer: XI,
          Option: (Ee) => /* @__PURE__ */ Ne.jsx(jd.Option, { ...Ee, children: /* @__PURE__ */ Ne.jsx(ie, { ...Ee, ...Ee.innerProps }) }),
          MultiValueLabel: (Ee) => /* @__PURE__ */ Ne.jsx(jd.MultiValueLabel, { ...Ee, children: /* @__PURE__ */ Ne.jsx(le, { ...Ee, ...Ee.innerProps }) }),
          MenuList: (Ee) => {
            const { children: he, innerProps: Ae } = Ee;
            return /* @__PURE__ */ Ne.jsxs(jd.MenuList, { ...Ee, children: [
              ye && (!M || M && !!(J != null && J.length)) && /* @__PURE__ */ Ne.jsx(ye, { ...Ee, ...Ae }),
              he,
              B && (!H || H && !!(J != null && J.length)) && /* @__PURE__ */ Ne.jsx(B, { ...Ee, ...Ae })
            ] });
          }
        },
        placeholder: n,
        menuPortalTarget: document.body,
        isClearable: !0,
        isMulti: !0,
        closeMenuOnSelect: !1,
        menuPlacement: "auto",
        menuPosition: "absolute",
        isDisabled: s,
        getOptionLabel: (Ee) => Ee.display,
        getOptionValue: (Ee) => Ee.value,
        value: Q,
        loadOptions: _e,
        noOptionsMessage: () => w ?? null,
        loadingMessage: () => O,
        onInputChange: ce,
        inputValue: ee,
        defaultOptions: J,
        menuIsOpen: A ?? !!(ee != null && ee.length),
        onBlur: A ? void 0 : K,
        onMenuOpen: j
      }
    )
  ] });
}), XO = "byz-searchable-condition-input", AXe = bs(({
  value: t,
  actions: e,
  label: n,
  keyLabel: r,
  keyPlaceholder: a,
  keyOptions: i,
  disabledKeys: o,
  keyNoOptionsMessage: s,
  keyLoadingMessage: u,
  onKeyChange: f,
  onMenuOpen: p,
  operationLabel: m,
  operationPlaceholder: v,
  operationOptions: O,
  disabledOperations: w,
  onOperationChange: _,
  valueLabel: C,
  valuePlaceholder: A = "Search for a value",
  maxAllowedValues: N,
  valueNoOptionsMessage: P,
  valueLoadingMessage: I,
  onValueChange: D,
  onChange: M,
  name: H,
  className: Y,
  search: q,
  converter: Q,
  minSearchCharacters: ne,
  searchDelay: J
}, ue) => {
  const [ee, fe] = kn({ key: null, operation: "", value: [] });
  Vn(() => {
    fe(t ?? { key: null, operation: "", value: [] });
  }, [t]);
  function de(ye) {
    const B = {
      ...ee,
      key: (ye == null ? void 0 : ye.value) ?? null,
      value: []
    };
    M ? M({
      // if onChange is present
      value: B,
      name: H
    }) : fe(B), f == null || f({
      value: ye == null ? void 0 : ye.value,
      name: H
    });
  }
  function ie() {
    p == null || p();
  }
  const le = (ye) => {
    switch (M ? M == null || M({
      // if onChange is present
      value: {
        ...ee,
        [ye == null ? void 0 : ye.name]: ye == null ? void 0 : ye.value
      },
      name: H
    }) : fe((B) => ({
      // if onChange ISNT present
      ...B,
      [ye == null ? void 0 : ye.name]: ye == null ? void 0 : ye.value
    })), ye == null ? void 0 : ye.name) {
      case "operation":
        _ == null || _({
          value: ye.value,
          name: H
        });
        break;
      case "value":
        D == null || D({
          value: ye == null ? void 0 : ye.value,
          name: H
        });
        break;
    }
  };
  return Nl(
    ue,
    () => ({
      value: ee
    }),
    [ee]
  ), /* @__PURE__ */ Ne.jsxs("div", { className: pn(XO, Y), children: [
    n ? /* @__PURE__ */ Ne.jsx("div", { className: pn(`${XO}__label-text`), children: n }) : null,
    /* @__PURE__ */ Ne.jsxs("div", { className: pn(`${XO}__selectors-and-actions-wrapper`), children: [
      /* @__PURE__ */ Ne.jsxs("div", { className: pn(`${XO}__selectors`), children: [
        /* @__PURE__ */ Ne.jsx(
          wE,
          {
            options: i,
            onChange: (ye) => de(ye),
            name: "key",
            value: ee == null ? void 0 : ee.key,
            label: r,
            placeholder: a,
            disabledOptions: o,
            allowClear: !0,
            noOptionsMessage: s,
            loadingMessage: u
          }
        ),
        /* @__PURE__ */ Ne.jsx(
          wE,
          {
            options: O,
            onChange: le,
            name: "operation",
            value: ee == null ? void 0 : ee.operation,
            label: m,
            placeholder: v,
            disabledOptions: w,
            allowClear: !0
          }
        ),
        /* @__PURE__ */ Ne.jsx(
          B1e,
          {
            search: q,
            converter: Q,
            onChange: le,
            name: "value",
            value: ee == null ? void 0 : ee.value,
            label: C,
            placeholder: A,
            disabled: !(ee != null && ee.key),
            maxSelections: N,
            minSearchCharacters: ne,
            searchDelay: J,
            noOptionsMessage: P,
            loadingMessage: I,
            onMenuOpen: ie
          }
        )
      ] }),
      e ? /* @__PURE__ */ Ne.jsx("div", { className: pn(
        `${XO}__actions`,
        {
          [`${XO}__actions--align-with-selectors`]: r ?? m ?? C
        }
      ), children: e }) : null
    ] })
  ] });
});
const U1e = "byzzer-date";
function kXe({
  className: t,
  date: e,
  format: n,
  timeZone: r = KI(),
  ...a
}) {
  return /* @__PURE__ */ Ne.jsx("span", { className: pn(U1e, t), ...a, children: REe(e, r, n) });
}
var kx = { exports: {} }, Rx = { exports: {} }, Ea = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var DV;
function z1e() {
  if (DV)
    return Ea;
  DV = 1;
  var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, i = t ? Symbol.for("react.profiler") : 60114, o = t ? Symbol.for("react.provider") : 60109, s = t ? Symbol.for("react.context") : 60110, u = t ? Symbol.for("react.async_mode") : 60111, f = t ? Symbol.for("react.concurrent_mode") : 60111, p = t ? Symbol.for("react.forward_ref") : 60112, m = t ? Symbol.for("react.suspense") : 60113, v = t ? Symbol.for("react.suspense_list") : 60120, O = t ? Symbol.for("react.memo") : 60115, w = t ? Symbol.for("react.lazy") : 60116, _ = t ? Symbol.for("react.block") : 60121, C = t ? Symbol.for("react.fundamental") : 60117, A = t ? Symbol.for("react.responder") : 60118, N = t ? Symbol.for("react.scope") : 60119;
  function P(D) {
    if (typeof D == "object" && D !== null) {
      var M = D.$$typeof;
      switch (M) {
        case e:
          switch (D = D.type, D) {
            case u:
            case f:
            case r:
            case i:
            case a:
            case m:
              return D;
            default:
              switch (D = D && D.$$typeof, D) {
                case s:
                case p:
                case w:
                case O:
                case o:
                  return D;
                default:
                  return M;
              }
          }
        case n:
          return M;
      }
    }
  }
  function I(D) {
    return P(D) === f;
  }
  return Ea.AsyncMode = u, Ea.ConcurrentMode = f, Ea.ContextConsumer = s, Ea.ContextProvider = o, Ea.Element = e, Ea.ForwardRef = p, Ea.Fragment = r, Ea.Lazy = w, Ea.Memo = O, Ea.Portal = n, Ea.Profiler = i, Ea.StrictMode = a, Ea.Suspense = m, Ea.isAsyncMode = function(D) {
    return I(D) || P(D) === u;
  }, Ea.isConcurrentMode = I, Ea.isContextConsumer = function(D) {
    return P(D) === s;
  }, Ea.isContextProvider = function(D) {
    return P(D) === o;
  }, Ea.isElement = function(D) {
    return typeof D == "object" && D !== null && D.$$typeof === e;
  }, Ea.isForwardRef = function(D) {
    return P(D) === p;
  }, Ea.isFragment = function(D) {
    return P(D) === r;
  }, Ea.isLazy = function(D) {
    return P(D) === w;
  }, Ea.isMemo = function(D) {
    return P(D) === O;
  }, Ea.isPortal = function(D) {
    return P(D) === n;
  }, Ea.isProfiler = function(D) {
    return P(D) === i;
  }, Ea.isStrictMode = function(D) {
    return P(D) === a;
  }, Ea.isSuspense = function(D) {
    return P(D) === m;
  }, Ea.isValidElementType = function(D) {
    return typeof D == "string" || typeof D == "function" || D === r || D === f || D === i || D === a || D === m || D === v || typeof D == "object" && D !== null && (D.$$typeof === w || D.$$typeof === O || D.$$typeof === o || D.$$typeof === s || D.$$typeof === p || D.$$typeof === C || D.$$typeof === A || D.$$typeof === N || D.$$typeof === _);
  }, Ea.typeOf = P, Ea;
}
var Sa = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var NV;
function H1e() {
  return NV || (NV = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, i = t ? Symbol.for("react.profiler") : 60114, o = t ? Symbol.for("react.provider") : 60109, s = t ? Symbol.for("react.context") : 60110, u = t ? Symbol.for("react.async_mode") : 60111, f = t ? Symbol.for("react.concurrent_mode") : 60111, p = t ? Symbol.for("react.forward_ref") : 60112, m = t ? Symbol.for("react.suspense") : 60113, v = t ? Symbol.for("react.suspense_list") : 60120, O = t ? Symbol.for("react.memo") : 60115, w = t ? Symbol.for("react.lazy") : 60116, _ = t ? Symbol.for("react.block") : 60121, C = t ? Symbol.for("react.fundamental") : 60117, A = t ? Symbol.for("react.responder") : 60118, N = t ? Symbol.for("react.scope") : 60119;
    function P(we) {
      return typeof we == "string" || typeof we == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      we === r || we === f || we === i || we === a || we === m || we === v || typeof we == "object" && we !== null && (we.$$typeof === w || we.$$typeof === O || we.$$typeof === o || we.$$typeof === s || we.$$typeof === p || we.$$typeof === C || we.$$typeof === A || we.$$typeof === N || we.$$typeof === _);
    }
    function I(we) {
      if (typeof we == "object" && we !== null) {
        var lt = we.$$typeof;
        switch (lt) {
          case e:
            var st = we.type;
            switch (st) {
              case u:
              case f:
              case r:
              case i:
              case a:
              case m:
                return st;
              default:
                var Oe = st && st.$$typeof;
                switch (Oe) {
                  case s:
                  case p:
                  case w:
                  case O:
                  case o:
                    return Oe;
                  default:
                    return lt;
                }
            }
          case n:
            return lt;
        }
      }
    }
    var D = u, M = f, H = s, Y = o, q = e, Q = p, ne = r, J = w, ue = O, ee = n, fe = i, de = a, ie = m, le = !1;
    function ye(we) {
      return le || (le = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), B(we) || I(we) === u;
    }
    function B(we) {
      return I(we) === f;
    }
    function pe(we) {
      return I(we) === s;
    }
    function _e(we) {
      return I(we) === o;
    }
    function Z(we) {
      return typeof we == "object" && we !== null && we.$$typeof === e;
    }
    function ce(we) {
      return I(we) === p;
    }
    function j(we) {
      return I(we) === r;
    }
    function K(we) {
      return I(we) === w;
    }
    function Ee(we) {
      return I(we) === O;
    }
    function he(we) {
      return I(we) === n;
    }
    function Ae(we) {
      return I(we) === i;
    }
    function Te(we) {
      return I(we) === a;
    }
    function je(we) {
      return I(we) === m;
    }
    Sa.AsyncMode = D, Sa.ConcurrentMode = M, Sa.ContextConsumer = H, Sa.ContextProvider = Y, Sa.Element = q, Sa.ForwardRef = Q, Sa.Fragment = ne, Sa.Lazy = J, Sa.Memo = ue, Sa.Portal = ee, Sa.Profiler = fe, Sa.StrictMode = de, Sa.Suspense = ie, Sa.isAsyncMode = ye, Sa.isConcurrentMode = B, Sa.isContextConsumer = pe, Sa.isContextProvider = _e, Sa.isElement = Z, Sa.isForwardRef = ce, Sa.isFragment = j, Sa.isLazy = K, Sa.isMemo = Ee, Sa.isPortal = he, Sa.isProfiler = Ae, Sa.isStrictMode = Te, Sa.isSuspense = je, Sa.isValidElementType = P, Sa.typeOf = I;
  }()), Sa;
}
var PV;
function Vne() {
  return PV || (PV = 1, process.env.NODE_ENV === "production" ? Rx.exports = z1e() : Rx.exports = H1e()), Rx.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var NM, LV;
function W1e() {
  if (LV)
    return NM;
  LV = 1;
  var t = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var o = {}, s = 0; s < 10; s++)
        o["_" + String.fromCharCode(s)] = s;
      var u = Object.getOwnPropertyNames(o).map(function(p) {
        return o[p];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var f = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(p) {
        f[p] = p;
      }), Object.keys(Object.assign({}, f)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return NM = a() ? Object.assign : function(i, o) {
    for (var s, u = r(i), f, p = 1; p < arguments.length; p++) {
      s = Object(arguments[p]);
      for (var m in s)
        e.call(s, m) && (u[m] = s[m]);
      if (t) {
        f = t(s);
        for (var v = 0; v < f.length; v++)
          n.call(s, f[v]) && (u[f[v]] = s[f[v]]);
      }
    }
    return u;
  }, NM;
}
var PM, MV;
function iU() {
  if (MV)
    return PM;
  MV = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return PM = t, PM;
}
var LM, FV;
function Yne() {
  return FV || (FV = 1, LM = Function.call.bind(Object.prototype.hasOwnProperty)), LM;
}
var MM, $V;
function Q1e() {
  if ($V)
    return MM;
  $V = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = iU(), n = {}, r = Yne();
    t = function(i) {
      var o = "Warning: " + i;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function a(i, o, s, u, f) {
    if (process.env.NODE_ENV !== "production") {
      for (var p in i)
        if (r(i, p)) {
          var m;
          try {
            if (typeof i[p] != "function") {
              var v = Error(
                (u || "React class") + ": " + s + " type `" + p + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[p] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw v.name = "Invariant Violation", v;
            }
            m = i[p](o, p, u, s, null, e);
          } catch (w) {
            m = w;
          }
          if (m && !(m instanceof Error) && t(
            (u || "React class") + ": type specification of " + s + " `" + p + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof m + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), m instanceof Error && !(m.message in n)) {
            n[m.message] = !0;
            var O = f ? f() : "";
            t(
              "Failed " + s + " type: " + m.message + (O ?? "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, MM = a, MM;
}
var FM, BV;
function j1e() {
  if (BV)
    return FM;
  BV = 1;
  var t = Vne(), e = W1e(), n = iU(), r = Yne(), a = Q1e(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(s) {
    var u = "Warning: " + s;
    typeof console < "u" && console.error(u);
    try {
      throw new Error(u);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return FM = function(s, u) {
    var f = typeof Symbol == "function" && Symbol.iterator, p = "@@iterator";
    function m(B) {
      var pe = B && (f && B[f] || B[p]);
      if (typeof pe == "function")
        return pe;
    }
    var v = "<<anonymous>>", O = {
      array: A("array"),
      bigint: A("bigint"),
      bool: A("boolean"),
      func: A("function"),
      number: A("number"),
      object: A("object"),
      string: A("string"),
      symbol: A("symbol"),
      any: N(),
      arrayOf: P,
      element: I(),
      elementType: D(),
      instanceOf: M,
      node: Q(),
      objectOf: Y,
      oneOf: H,
      oneOfType: q,
      shape: J,
      exact: ue
    };
    function w(B, pe) {
      return B === pe ? B !== 0 || 1 / B === 1 / pe : B !== B && pe !== pe;
    }
    function _(B, pe) {
      this.message = B, this.data = pe && typeof pe == "object" ? pe : {}, this.stack = "";
    }
    _.prototype = Error.prototype;
    function C(B) {
      if (process.env.NODE_ENV !== "production")
        var pe = {}, _e = 0;
      function Z(j, K, Ee, he, Ae, Te, je) {
        if (he = he || v, Te = Te || Ee, je !== n) {
          if (u) {
            var we = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw we.name = "Invariant Violation", we;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var lt = he + ":" + Ee;
            !pe[lt] && // Avoid spamming the console because they are often not actionable except for lib authors
            _e < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + Te + "` prop on `" + he + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), pe[lt] = !0, _e++);
          }
        }
        return K[Ee] == null ? j ? K[Ee] === null ? new _("The " + Ae + " `" + Te + "` is marked as required " + ("in `" + he + "`, but its value is `null`.")) : new _("The " + Ae + " `" + Te + "` is marked as required in " + ("`" + he + "`, but its value is `undefined`.")) : null : B(K, Ee, he, Ae, Te);
      }
      var ce = Z.bind(null, !1);
      return ce.isRequired = Z.bind(null, !0), ce;
    }
    function A(B) {
      function pe(_e, Z, ce, j, K, Ee) {
        var he = _e[Z], Ae = de(he);
        if (Ae !== B) {
          var Te = ie(he);
          return new _(
            "Invalid " + j + " `" + K + "` of type " + ("`" + Te + "` supplied to `" + ce + "`, expected ") + ("`" + B + "`."),
            { expectedType: B }
          );
        }
        return null;
      }
      return C(pe);
    }
    function N() {
      return C(o);
    }
    function P(B) {
      function pe(_e, Z, ce, j, K) {
        if (typeof B != "function")
          return new _("Property `" + K + "` of component `" + ce + "` has invalid PropType notation inside arrayOf.");
        var Ee = _e[Z];
        if (!Array.isArray(Ee)) {
          var he = de(Ee);
          return new _("Invalid " + j + " `" + K + "` of type " + ("`" + he + "` supplied to `" + ce + "`, expected an array."));
        }
        for (var Ae = 0; Ae < Ee.length; Ae++) {
          var Te = B(Ee, Ae, ce, j, K + "[" + Ae + "]", n);
          if (Te instanceof Error)
            return Te;
        }
        return null;
      }
      return C(pe);
    }
    function I() {
      function B(pe, _e, Z, ce, j) {
        var K = pe[_e];
        if (!s(K)) {
          var Ee = de(K);
          return new _("Invalid " + ce + " `" + j + "` of type " + ("`" + Ee + "` supplied to `" + Z + "`, expected a single ReactElement."));
        }
        return null;
      }
      return C(B);
    }
    function D() {
      function B(pe, _e, Z, ce, j) {
        var K = pe[_e];
        if (!t.isValidElementType(K)) {
          var Ee = de(K);
          return new _("Invalid " + ce + " `" + j + "` of type " + ("`" + Ee + "` supplied to `" + Z + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return C(B);
    }
    function M(B) {
      function pe(_e, Z, ce, j, K) {
        if (!(_e[Z] instanceof B)) {
          var Ee = B.name || v, he = ye(_e[Z]);
          return new _("Invalid " + j + " `" + K + "` of type " + ("`" + he + "` supplied to `" + ce + "`, expected ") + ("instance of `" + Ee + "`."));
        }
        return null;
      }
      return C(pe);
    }
    function H(B) {
      if (!Array.isArray(B))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), o;
      function pe(_e, Z, ce, j, K) {
        for (var Ee = _e[Z], he = 0; he < B.length; he++)
          if (w(Ee, B[he]))
            return null;
        var Ae = JSON.stringify(B, function(je, we) {
          var lt = ie(we);
          return lt === "symbol" ? String(we) : we;
        });
        return new _("Invalid " + j + " `" + K + "` of value `" + String(Ee) + "` " + ("supplied to `" + ce + "`, expected one of " + Ae + "."));
      }
      return C(pe);
    }
    function Y(B) {
      function pe(_e, Z, ce, j, K) {
        if (typeof B != "function")
          return new _("Property `" + K + "` of component `" + ce + "` has invalid PropType notation inside objectOf.");
        var Ee = _e[Z], he = de(Ee);
        if (he !== "object")
          return new _("Invalid " + j + " `" + K + "` of type " + ("`" + he + "` supplied to `" + ce + "`, expected an object."));
        for (var Ae in Ee)
          if (r(Ee, Ae)) {
            var Te = B(Ee, Ae, ce, j, K + "." + Ae, n);
            if (Te instanceof Error)
              return Te;
          }
        return null;
      }
      return C(pe);
    }
    function q(B) {
      if (!Array.isArray(B))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var pe = 0; pe < B.length; pe++) {
        var _e = B[pe];
        if (typeof _e != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + le(_e) + " at index " + pe + "."
          ), o;
      }
      function Z(ce, j, K, Ee, he) {
        for (var Ae = [], Te = 0; Te < B.length; Te++) {
          var je = B[Te], we = je(ce, j, K, Ee, he, n);
          if (we == null)
            return null;
          we.data && r(we.data, "expectedType") && Ae.push(we.data.expectedType);
        }
        var lt = Ae.length > 0 ? ", expected one of type [" + Ae.join(", ") + "]" : "";
        return new _("Invalid " + Ee + " `" + he + "` supplied to " + ("`" + K + "`" + lt + "."));
      }
      return C(Z);
    }
    function Q() {
      function B(pe, _e, Z, ce, j) {
        return ee(pe[_e]) ? null : new _("Invalid " + ce + " `" + j + "` supplied to " + ("`" + Z + "`, expected a ReactNode."));
      }
      return C(B);
    }
    function ne(B, pe, _e, Z, ce) {
      return new _(
        (B || "React class") + ": " + pe + " type `" + _e + "." + Z + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + ce + "`."
      );
    }
    function J(B) {
      function pe(_e, Z, ce, j, K) {
        var Ee = _e[Z], he = de(Ee);
        if (he !== "object")
          return new _("Invalid " + j + " `" + K + "` of type `" + he + "` " + ("supplied to `" + ce + "`, expected `object`."));
        for (var Ae in B) {
          var Te = B[Ae];
          if (typeof Te != "function")
            return ne(ce, j, K, Ae, ie(Te));
          var je = Te(Ee, Ae, ce, j, K + "." + Ae, n);
          if (je)
            return je;
        }
        return null;
      }
      return C(pe);
    }
    function ue(B) {
      function pe(_e, Z, ce, j, K) {
        var Ee = _e[Z], he = de(Ee);
        if (he !== "object")
          return new _("Invalid " + j + " `" + K + "` of type `" + he + "` " + ("supplied to `" + ce + "`, expected `object`."));
        var Ae = e({}, _e[Z], B);
        for (var Te in Ae) {
          var je = B[Te];
          if (r(B, Te) && typeof je != "function")
            return ne(ce, j, K, Te, ie(je));
          if (!je)
            return new _(
              "Invalid " + j + " `" + K + "` key `" + Te + "` supplied to `" + ce + "`.\nBad object: " + JSON.stringify(_e[Z], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(B), null, "  ")
            );
          var we = je(Ee, Te, ce, j, K + "." + Te, n);
          if (we)
            return we;
        }
        return null;
      }
      return C(pe);
    }
    function ee(B) {
      switch (typeof B) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !B;
        case "object":
          if (Array.isArray(B))
            return B.every(ee);
          if (B === null || s(B))
            return !0;
          var pe = m(B);
          if (pe) {
            var _e = pe.call(B), Z;
            if (pe !== B.entries) {
              for (; !(Z = _e.next()).done; )
                if (!ee(Z.value))
                  return !1;
            } else
              for (; !(Z = _e.next()).done; ) {
                var ce = Z.value;
                if (ce && !ee(ce[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function fe(B, pe) {
      return B === "symbol" ? !0 : pe ? pe["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && pe instanceof Symbol : !1;
    }
    function de(B) {
      var pe = typeof B;
      return Array.isArray(B) ? "array" : B instanceof RegExp ? "object" : fe(pe, B) ? "symbol" : pe;
    }
    function ie(B) {
      if (typeof B > "u" || B === null)
        return "" + B;
      var pe = de(B);
      if (pe === "object") {
        if (B instanceof Date)
          return "date";
        if (B instanceof RegExp)
          return "regexp";
      }
      return pe;
    }
    function le(B) {
      var pe = ie(B);
      switch (pe) {
        case "array":
        case "object":
          return "an " + pe;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + pe;
        default:
          return pe;
      }
    }
    function ye(B) {
      return !B.constructor || !B.constructor.name ? v : B.constructor.name;
    }
    return O.checkPropTypes = a, O.resetWarningCache = a.resetWarningCache, O.PropTypes = O, O;
  }, FM;
}
var $M, UV;
function G1e() {
  if (UV)
    return $M;
  UV = 1;
  var t = iU();
  function e() {
  }
  function n() {
  }
  return n.resetWarningCache = e, $M = function() {
    function r(o, s, u, f, p, m) {
      if (m !== t) {
        var v = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw v.name = "Invariant Violation", v;
      }
    }
    r.isRequired = r;
    function a() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: a,
      element: r,
      elementType: r,
      instanceOf: a,
      node: r,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: n,
      resetWarningCache: e
    };
    return i.PropTypes = i, i;
  }, $M;
}
var zV;
function qf() {
  if (zV)
    return kx.exports;
  if (zV = 1, process.env.NODE_ENV !== "production") {
    var t = Vne(), e = !0;
    kx.exports = j1e()(t.isElement, e);
  } else
    kx.exports = G1e()();
  return kx.exports;
}
qf();
function Kt(t, e) {
  if (e.length < t)
    throw new TypeError(t + " argument" + (t > 1 ? "s" : "") + " required, but only " + e.length + " present");
}
function RA(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? RA = function(n) {
    return typeof n;
  } : RA = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, RA(t);
}
function oU(t) {
  return Kt(1, arguments), t instanceof Date || RA(t) === "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function IA(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? IA = function(n) {
    return typeof n;
  } : IA = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, IA(t);
}
function an(t) {
  Kt(1, arguments);
  var e = Object.prototype.toString.call(t);
  return t instanceof Date || IA(t) === "object" && e === "[object Date]" ? new Date(t.getTime()) : typeof t == "number" || e === "[object Number]" ? new Date(t) : ((typeof t == "string" || e === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function sU(t) {
  if (Kt(1, arguments), !oU(t) && typeof t != "number")
    return !1;
  var e = an(t);
  return !isNaN(Number(e));
}
const V1e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sU
}, Symbol.toStringTag, { value: "Module" }));
function xr(t) {
  if (t === null || t === !0 || t === !1)
    return NaN;
  var e = Number(t);
  return isNaN(e) ? e : e < 0 ? Math.ceil(e) : Math.floor(e);
}
function lU(t, e) {
  Kt(2, arguments);
  var n = an(t).getTime(), r = xr(e);
  return new Date(n + r);
}
function Zne(t, e) {
  Kt(2, arguments);
  var n = xr(e);
  return lU(t, -n);
}
var Y1e = 864e5;
function Z1e(t) {
  Kt(1, arguments);
  var e = an(t), n = e.getTime();
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
  var r = e.getTime(), a = n - r;
  return Math.floor(a / Y1e) + 1;
}
function UE(t) {
  Kt(1, arguments);
  var e = 1, n = an(t), r = n.getUTCDay(), a = (r < e ? 7 : 0) + r - e;
  return n.setUTCDate(n.getUTCDate() - a), n.setUTCHours(0, 0, 0, 0), n;
}
function Xne(t) {
  Kt(1, arguments);
  var e = an(t), n = e.getUTCFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var a = UE(r), i = /* @__PURE__ */ new Date(0);
  i.setUTCFullYear(n, 0, 4), i.setUTCHours(0, 0, 0, 0);
  var o = UE(i);
  return e.getTime() >= a.getTime() ? n + 1 : e.getTime() >= o.getTime() ? n : n - 1;
}
function X1e(t) {
  Kt(1, arguments);
  var e = Xne(t), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = UE(n);
  return r;
}
var q1e = 6048e5;
function qne(t) {
  Kt(1, arguments);
  var e = an(t), n = UE(e).getTime() - X1e(e).getTime();
  return Math.round(n / q1e) + 1;
}
var K1e = {};
function uv() {
  return K1e;
}
function o0(t, e) {
  var n, r, a, i, o, s, u, f;
  Kt(1, arguments);
  var p = uv(), m = xr((n = (r = (a = (i = e == null ? void 0 : e.weekStartsOn) !== null && i !== void 0 ? i : e == null || (o = e.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && a !== void 0 ? a : p.weekStartsOn) !== null && r !== void 0 ? r : (u = p.locale) === null || u === void 0 || (f = u.options) === null || f === void 0 ? void 0 : f.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(m >= 0 && m <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var v = an(t), O = v.getUTCDay(), w = (O < m ? 7 : 0) + O - m;
  return v.setUTCDate(v.getUTCDate() - w), v.setUTCHours(0, 0, 0, 0), v;
}
function uU(t, e) {
  var n, r, a, i, o, s, u, f;
  Kt(1, arguments);
  var p = an(t), m = p.getUTCFullYear(), v = uv(), O = xr((n = (r = (a = (i = e == null ? void 0 : e.firstWeekContainsDate) !== null && i !== void 0 ? i : e == null || (o = e.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && a !== void 0 ? a : v.firstWeekContainsDate) !== null && r !== void 0 ? r : (u = v.locale) === null || u === void 0 || (f = u.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(O >= 1 && O <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var w = /* @__PURE__ */ new Date(0);
  w.setUTCFullYear(m + 1, 0, O), w.setUTCHours(0, 0, 0, 0);
  var _ = o0(w, e), C = /* @__PURE__ */ new Date(0);
  C.setUTCFullYear(m, 0, O), C.setUTCHours(0, 0, 0, 0);
  var A = o0(C, e);
  return p.getTime() >= _.getTime() ? m + 1 : p.getTime() >= A.getTime() ? m : m - 1;
}
function J1e(t, e) {
  var n, r, a, i, o, s, u, f;
  Kt(1, arguments);
  var p = uv(), m = xr((n = (r = (a = (i = e == null ? void 0 : e.firstWeekContainsDate) !== null && i !== void 0 ? i : e == null || (o = e.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && a !== void 0 ? a : p.firstWeekContainsDate) !== null && r !== void 0 ? r : (u = p.locale) === null || u === void 0 || (f = u.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), v = uU(t, e), O = /* @__PURE__ */ new Date(0);
  O.setUTCFullYear(v, 0, m), O.setUTCHours(0, 0, 0, 0);
  var w = o0(O, e);
  return w;
}
var eSe = 6048e5;
function Kne(t, e) {
  Kt(1, arguments);
  var n = an(t), r = o0(n, e).getTime() - J1e(n, e).getTime();
  return Math.round(r / eSe) + 1;
}
function xa(t, e) {
  for (var n = t < 0 ? "-" : "", r = Math.abs(t).toString(); r.length < e; )
    r = "0" + r;
  return n + r;
}
var tSe = {
  // Year
  y: function(e, n) {
    var r = e.getUTCFullYear(), a = r > 0 ? r : 1 - r;
    return xa(n === "yy" ? a % 100 : a, n.length);
  },
  // Month
  M: function(e, n) {
    var r = e.getUTCMonth();
    return n === "M" ? String(r + 1) : xa(r + 1, 2);
  },
  // Day of the month
  d: function(e, n) {
    return xa(e.getUTCDate(), n.length);
  },
  // AM or PM
  a: function(e, n) {
    var r = e.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(e, n) {
    return xa(e.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function(e, n) {
    return xa(e.getUTCHours(), n.length);
  },
  // Minute
  m: function(e, n) {
    return xa(e.getUTCMinutes(), n.length);
  },
  // Second
  s: function(e, n) {
    return xa(e.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function(e, n) {
    var r = n.length, a = e.getUTCMilliseconds(), i = Math.floor(a * Math.pow(10, r - 3));
    return xa(i, n.length);
  }
};
const kb = tSe;
var qO = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, nSe = {
  // Era
  G: function(e, n, r) {
    var a = e.getUTCFullYear() > 0 ? 1 : 0;
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(a, {
          width: "abbreviated"
        });
      case "GGGGG":
        return r.era(a, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return r.era(a, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(e, n, r) {
    if (n === "yo") {
      var a = e.getUTCFullYear(), i = a > 0 ? a : 1 - a;
      return r.ordinalNumber(i, {
        unit: "year"
      });
    }
    return kb.y(e, n);
  },
  // Local week-numbering year
  Y: function(e, n, r, a) {
    var i = uU(e, a), o = i > 0 ? i : 1 - i;
    if (n === "YY") {
      var s = o % 100;
      return xa(s, 2);
    }
    return n === "Yo" ? r.ordinalNumber(o, {
      unit: "year"
    }) : xa(o, n.length);
  },
  // ISO week-numbering year
  R: function(e, n) {
    var r = Xne(e);
    return xa(r, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, n) {
    var r = e.getUTCFullYear();
    return xa(r, n.length);
  },
  // Quarter
  Q: function(e, n, r) {
    var a = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (n) {
      case "Q":
        return String(a);
      case "QQ":
        return xa(a, 2);
      case "Qo":
        return r.ordinalNumber(a, {
          unit: "quarter"
        });
      case "QQQ":
        return r.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, n, r) {
    var a = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (n) {
      case "q":
        return String(a);
      case "qq":
        return xa(a, 2);
      case "qo":
        return r.ordinalNumber(a, {
          unit: "quarter"
        });
      case "qqq":
        return r.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, n, r) {
    var a = e.getUTCMonth();
    switch (n) {
      case "M":
      case "MM":
        return kb.M(e, n);
      case "Mo":
        return r.ordinalNumber(a + 1, {
          unit: "month"
        });
      case "MMM":
        return r.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(a, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(e, n, r) {
    var a = e.getUTCMonth();
    switch (n) {
      case "L":
        return String(a + 1);
      case "LL":
        return xa(a + 1, 2);
      case "Lo":
        return r.ordinalNumber(a + 1, {
          unit: "month"
        });
      case "LLL":
        return r.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(a, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(e, n, r, a) {
    var i = Kne(e, a);
    return n === "wo" ? r.ordinalNumber(i, {
      unit: "week"
    }) : xa(i, n.length);
  },
  // ISO week of year
  I: function(e, n, r) {
    var a = qne(e);
    return n === "Io" ? r.ordinalNumber(a, {
      unit: "week"
    }) : xa(a, n.length);
  },
  // Day of the month
  d: function(e, n, r) {
    return n === "do" ? r.ordinalNumber(e.getUTCDate(), {
      unit: "date"
    }) : kb.d(e, n);
  },
  // Day of year
  D: function(e, n, r) {
    var a = Z1e(e);
    return n === "Do" ? r.ordinalNumber(a, {
      unit: "dayOfYear"
    }) : xa(a, n.length);
  },
  // Day of week
  E: function(e, n, r) {
    var a = e.getUTCDay();
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, n, r, a) {
    var i = e.getUTCDay(), o = (i - a.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "e":
        return String(o);
      case "ee":
        return xa(o, 2);
      case "eo":
        return r.ordinalNumber(o, {
          unit: "day"
        });
      case "eee":
        return r.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, n, r, a) {
    var i = e.getUTCDay(), o = (i - a.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "c":
        return String(o);
      case "cc":
        return xa(o, n.length);
      case "co":
        return r.ordinalNumber(o, {
          unit: "day"
        });
      case "ccc":
        return r.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, n, r) {
    var a = e.getUTCDay(), i = a === 0 ? 7 : a;
    switch (n) {
      case "i":
        return String(i);
      case "ii":
        return xa(i, n.length);
      case "io":
        return r.ordinalNumber(i, {
          unit: "day"
        });
      case "iii":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, n, r) {
    var a = e.getUTCHours(), i = a / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, n, r) {
    var a = e.getUTCHours(), i;
    switch (a === 12 ? i = qO.noon : a === 0 ? i = qO.midnight : i = a / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, n, r) {
    var a = e.getUTCHours(), i;
    switch (a >= 17 ? i = qO.evening : a >= 12 ? i = qO.afternoon : a >= 4 ? i = qO.morning : i = qO.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, n, r) {
    if (n === "ho") {
      var a = e.getUTCHours() % 12;
      return a === 0 && (a = 12), r.ordinalNumber(a, {
        unit: "hour"
      });
    }
    return kb.h(e, n);
  },
  // Hour [0-23]
  H: function(e, n, r) {
    return n === "Ho" ? r.ordinalNumber(e.getUTCHours(), {
      unit: "hour"
    }) : kb.H(e, n);
  },
  // Hour [0-11]
  K: function(e, n, r) {
    var a = e.getUTCHours() % 12;
    return n === "Ko" ? r.ordinalNumber(a, {
      unit: "hour"
    }) : xa(a, n.length);
  },
  // Hour [1-24]
  k: function(e, n, r) {
    var a = e.getUTCHours();
    return a === 0 && (a = 24), n === "ko" ? r.ordinalNumber(a, {
      unit: "hour"
    }) : xa(a, n.length);
  },
  // Minute
  m: function(e, n, r) {
    return n === "mo" ? r.ordinalNumber(e.getUTCMinutes(), {
      unit: "minute"
    }) : kb.m(e, n);
  },
  // Second
  s: function(e, n, r) {
    return n === "so" ? r.ordinalNumber(e.getUTCSeconds(), {
      unit: "second"
    }) : kb.s(e, n);
  },
  // Fraction of second
  S: function(e, n) {
    return kb.S(e, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, n, r, a) {
    var i = a._originalDate || e, o = i.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (n) {
      case "X":
        return WV(o);
      case "XXXX":
      case "XX":
        return jy(o);
      case "XXXXX":
      case "XXX":
      default:
        return jy(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, n, r, a) {
    var i = a._originalDate || e, o = i.getTimezoneOffset();
    switch (n) {
      case "x":
        return WV(o);
      case "xxxx":
      case "xx":
        return jy(o);
      case "xxxxx":
      case "xxx":
      default:
        return jy(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, n, r, a) {
    var i = a._originalDate || e, o = i.getTimezoneOffset();
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + HV(o, ":");
      case "OOOO":
      default:
        return "GMT" + jy(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, n, r, a) {
    var i = a._originalDate || e, o = i.getTimezoneOffset();
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + HV(o, ":");
      case "zzzz":
      default:
        return "GMT" + jy(o, ":");
    }
  },
  // Seconds timestamp
  t: function(e, n, r, a) {
    var i = a._originalDate || e, o = Math.floor(i.getTime() / 1e3);
    return xa(o, n.length);
  },
  // Milliseconds timestamp
  T: function(e, n, r, a) {
    var i = a._originalDate || e, o = i.getTime();
    return xa(o, n.length);
  }
};
function HV(t, e) {
  var n = t > 0 ? "-" : "+", r = Math.abs(t), a = Math.floor(r / 60), i = r % 60;
  if (i === 0)
    return n + String(a);
  var o = e || "";
  return n + String(a) + o + xa(i, 2);
}
function WV(t, e) {
  if (t % 60 === 0) {
    var n = t > 0 ? "-" : "+";
    return n + xa(Math.abs(t) / 60, 2);
  }
  return jy(t, e);
}
function jy(t, e) {
  var n = e || "", r = t > 0 ? "-" : "+", a = Math.abs(t), i = xa(Math.floor(a / 60), 2), o = xa(a % 60, 2);
  return r + i + n + o;
}
const rSe = nSe;
var QV = function(e, n) {
  switch (e) {
    case "P":
      return n.date({
        width: "short"
      });
    case "PP":
      return n.date({
        width: "medium"
      });
    case "PPP":
      return n.date({
        width: "long"
      });
    case "PPPP":
    default:
      return n.date({
        width: "full"
      });
  }
}, Jne = function(e, n) {
  switch (e) {
    case "p":
      return n.time({
        width: "short"
      });
    case "pp":
      return n.time({
        width: "medium"
      });
    case "ppp":
      return n.time({
        width: "long"
      });
    case "pppp":
    default:
      return n.time({
        width: "full"
      });
  }
}, aSe = function(e, n) {
  var r = e.match(/(P+)(p+)?/) || [], a = r[1], i = r[2];
  if (!i)
    return QV(e, n);
  var o;
  switch (a) {
    case "P":
      o = n.dateTime({
        width: "short"
      });
      break;
    case "PP":
      o = n.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      o = n.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      o = n.dateTime({
        width: "full"
      });
      break;
  }
  return o.replace("{{date}}", QV(a, n)).replace("{{time}}", Jne(i, n));
}, iSe = {
  p: Jne,
  P: aSe
};
const b$ = iSe;
function aR(t) {
  var e = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
  return e.setUTCFullYear(t.getFullYear()), t.getTime() - e.getTime();
}
var oSe = ["D", "DD"], sSe = ["YY", "YYYY"];
function ere(t) {
  return oSe.indexOf(t) !== -1;
}
function tre(t) {
  return sSe.indexOf(t) !== -1;
}
function iR(t, e, n) {
  if (t === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(e, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(e, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(e, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(e, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var lSe = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, uSe = function(e, n, r) {
  var a, i = lSe[e];
  return typeof i == "string" ? a = i : n === 1 ? a = i.one : a = i.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + a : a + " ago" : a;
};
const cSe = uSe;
function BM(t) {
  return function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.width ? String(e.width) : t.defaultWidth, r = t.formats[n] || t.formats[t.defaultWidth];
    return r;
  };
}
var fSe = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, dSe = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, pSe = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, hSe = {
  date: BM({
    formats: fSe,
    defaultWidth: "full"
  }),
  time: BM({
    formats: dSe,
    defaultWidth: "full"
  }),
  dateTime: BM({
    formats: pSe,
    defaultWidth: "full"
  })
};
const mSe = hSe;
var gSe = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, bSe = function(e, n, r, a) {
  return gSe[e];
};
const vSe = bSe;
function pw(t) {
  return function(e, n) {
    var r = n != null && n.context ? String(n.context) : "standalone", a;
    if (r === "formatting" && t.formattingValues) {
      var i = t.defaultFormattingWidth || t.defaultWidth, o = n != null && n.width ? String(n.width) : i;
      a = t.formattingValues[o] || t.formattingValues[i];
    } else {
      var s = t.defaultWidth, u = n != null && n.width ? String(n.width) : t.defaultWidth;
      a = t.values[u] || t.values[s];
    }
    var f = t.argumentCallback ? t.argumentCallback(e) : e;
    return a[f];
  };
}
var ySe = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, OSe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, ESe = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, SSe = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, wSe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, TSe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, _Se = function(e, n) {
  var r = Number(e), a = r % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, CSe = {
  ordinalNumber: _Se,
  era: pw({
    values: ySe,
    defaultWidth: "wide"
  }),
  quarter: pw({
    values: OSe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: pw({
    values: ESe,
    defaultWidth: "wide"
  }),
  day: pw({
    values: SSe,
    defaultWidth: "wide"
  }),
  dayPeriod: pw({
    values: wSe,
    defaultWidth: "wide",
    formattingValues: TSe,
    defaultFormattingWidth: "wide"
  })
};
const xSe = CSe;
function hw(t) {
  return function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.width, a = r && t.matchPatterns[r] || t.matchPatterns[t.defaultMatchWidth], i = e.match(a);
    if (!i)
      return null;
    var o = i[0], s = r && t.parsePatterns[r] || t.parsePatterns[t.defaultParseWidth], u = Array.isArray(s) ? kSe(s, function(m) {
      return m.test(o);
    }) : ASe(s, function(m) {
      return m.test(o);
    }), f;
    f = t.valueCallback ? t.valueCallback(u) : u, f = n.valueCallback ? n.valueCallback(f) : f;
    var p = e.slice(o.length);
    return {
      value: f,
      rest: p
    };
  };
}
function ASe(t, e) {
  for (var n in t)
    if (t.hasOwnProperty(n) && e(t[n]))
      return n;
}
function kSe(t, e) {
  for (var n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function RSe(t) {
  return function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = e.match(t.matchPattern);
    if (!r)
      return null;
    var a = r[0], i = e.match(t.parsePattern);
    if (!i)
      return null;
    var o = t.valueCallback ? t.valueCallback(i[0]) : i[0];
    o = n.valueCallback ? n.valueCallback(o) : o;
    var s = e.slice(a.length);
    return {
      value: o,
      rest: s
    };
  };
}
var ISe = /^(\d+)(th|st|nd|rd)?/i, DSe = /\d+/i, NSe = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, PSe = {
  any: [/^b/i, /^(a|c)/i]
}, LSe = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, MSe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, FSe = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, $Se = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, BSe = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, USe = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, zSe = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, HSe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, WSe = {
  ordinalNumber: RSe({
    matchPattern: ISe,
    parsePattern: DSe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: hw({
    matchPatterns: NSe,
    defaultMatchWidth: "wide",
    parsePatterns: PSe,
    defaultParseWidth: "any"
  }),
  quarter: hw({
    matchPatterns: LSe,
    defaultMatchWidth: "wide",
    parsePatterns: MSe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: hw({
    matchPatterns: FSe,
    defaultMatchWidth: "wide",
    parsePatterns: $Se,
    defaultParseWidth: "any"
  }),
  day: hw({
    matchPatterns: BSe,
    defaultMatchWidth: "wide",
    parsePatterns: USe,
    defaultParseWidth: "any"
  }),
  dayPeriod: hw({
    matchPatterns: zSe,
    defaultMatchWidth: "any",
    parsePatterns: HSe,
    defaultParseWidth: "any"
  })
};
const QSe = WSe;
var jSe = {
  code: "en-US",
  formatDistance: cSe,
  formatLong: mSe,
  formatRelative: vSe,
  localize: xSe,
  match: QSe,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const cU = jSe, GSe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: cU
}, Symbol.toStringTag, { value: "Module" }));
var VSe = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, YSe = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, ZSe = /^'([^]*?)'?$/, XSe = /''/g, qSe = /[a-zA-Z]/;
function NT(t, e, n) {
  var r, a, i, o, s, u, f, p, m, v, O, w, _, C, A, N, P, I;
  Kt(2, arguments);
  var D = String(e), M = uv(), H = (r = (a = n == null ? void 0 : n.locale) !== null && a !== void 0 ? a : M.locale) !== null && r !== void 0 ? r : cU, Y = xr((i = (o = (s = (u = n == null ? void 0 : n.firstWeekContainsDate) !== null && u !== void 0 ? u : n == null || (f = n.locale) === null || f === void 0 || (p = f.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && s !== void 0 ? s : M.firstWeekContainsDate) !== null && o !== void 0 ? o : (m = M.locale) === null || m === void 0 || (v = m.options) === null || v === void 0 ? void 0 : v.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(Y >= 1 && Y <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var q = xr((O = (w = (_ = (C = n == null ? void 0 : n.weekStartsOn) !== null && C !== void 0 ? C : n == null || (A = n.locale) === null || A === void 0 || (N = A.options) === null || N === void 0 ? void 0 : N.weekStartsOn) !== null && _ !== void 0 ? _ : M.weekStartsOn) !== null && w !== void 0 ? w : (P = M.locale) === null || P === void 0 || (I = P.options) === null || I === void 0 ? void 0 : I.weekStartsOn) !== null && O !== void 0 ? O : 0);
  if (!(q >= 0 && q <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!H.localize)
    throw new RangeError("locale must contain localize property");
  if (!H.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var Q = an(t);
  if (!sU(Q))
    throw new RangeError("Invalid time value");
  var ne = aR(Q), J = Zne(Q, ne), ue = {
    firstWeekContainsDate: Y,
    weekStartsOn: q,
    locale: H,
    _originalDate: Q
  }, ee = D.match(YSe).map(function(fe) {
    var de = fe[0];
    if (de === "p" || de === "P") {
      var ie = b$[de];
      return ie(fe, H.formatLong);
    }
    return fe;
  }).join("").match(VSe).map(function(fe) {
    if (fe === "''")
      return "'";
    var de = fe[0];
    if (de === "'")
      return KSe(fe);
    var ie = rSe[de];
    if (ie)
      return !(n != null && n.useAdditionalWeekYearTokens) && tre(fe) && iR(fe, e, String(t)), !(n != null && n.useAdditionalDayOfYearTokens) && ere(fe) && iR(fe, e, String(t)), ie(J, fe, H.localize, ue);
    if (de.match(qSe))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + de + "`");
    return fe;
  }).join("");
  return ee;
}
function KSe(t) {
  var e = t.match(ZSe);
  return e ? e[1].replace(XSe, "'") : t;
}
const JSe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: NT
}, Symbol.toStringTag, { value: "Module" }));
var ewe = 6e4;
function v$(t, e) {
  Kt(2, arguments);
  var n = xr(e);
  return lU(t, n * ewe);
}
var twe = 36e5;
function nwe(t, e) {
  Kt(2, arguments);
  var n = xr(e);
  return lU(t, n * twe);
}
function _0(t, e) {
  Kt(2, arguments);
  var n = an(t), r = xr(e);
  return isNaN(r) ? /* @__PURE__ */ new Date(NaN) : (r && n.setDate(n.getDate() + r), n);
}
const rwe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _0
}, Symbol.toStringTag, { value: "Module" }));
function fU(t, e) {
  Kt(2, arguments);
  var n = xr(e), r = n * 7;
  return _0(t, r);
}
function Zd(t, e) {
  Kt(2, arguments);
  var n = an(t), r = xr(e);
  if (isNaN(r))
    return /* @__PURE__ */ new Date(NaN);
  if (!r)
    return n;
  var a = n.getDate(), i = new Date(n.getTime());
  i.setMonth(n.getMonth() + r + 1, 0);
  var o = i.getDate();
  return a >= o ? i : (n.setFullYear(i.getFullYear(), i.getMonth(), a), n);
}
const awe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Zd
}, Symbol.toStringTag, { value: "Module" }));
function s0(t, e) {
  Kt(2, arguments);
  var n = xr(e);
  return Zd(t, n * 12);
}
const iwe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: s0
}, Symbol.toStringTag, { value: "Module" }));
function owe(t, e) {
  Kt(2, arguments);
  var n = xr(e);
  return _0(t, -n);
}
function swe(t, e) {
  Kt(2, arguments);
  var n = xr(e);
  return fU(t, -n);
}
function l0(t, e) {
  Kt(2, arguments);
  var n = xr(e);
  return Zd(t, -n);
}
const lwe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: l0
}, Symbol.toStringTag, { value: "Module" }));
function PT(t, e) {
  Kt(2, arguments);
  var n = xr(e);
  return s0(t, -n);
}
function jV(t) {
  Kt(1, arguments);
  var e = an(t), n = e.getSeconds();
  return n;
}
function Wf(t) {
  Kt(1, arguments);
  var e = an(t), n = e.getMinutes();
  return n;
}
function Qf(t) {
  Kt(1, arguments);
  var e = an(t), n = e.getHours();
  return n;
}
function uwe(t) {
  Kt(1, arguments);
  var e = an(t), n = e.getDay();
  return n;
}
function GV(t) {
  Kt(1, arguments);
  var e = an(t), n = e.getDate();
  return n;
}
function dU(t, e) {
  var n, r, a, i, o, s, u, f;
  Kt(1, arguments);
  var p = uv(), m = xr((n = (r = (a = (i = e == null ? void 0 : e.weekStartsOn) !== null && i !== void 0 ? i : e == null || (o = e.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && a !== void 0 ? a : p.weekStartsOn) !== null && r !== void 0 ? r : (u = p.locale) === null || u === void 0 || (f = u.options) === null || f === void 0 ? void 0 : f.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(m >= 0 && m <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var v = an(t), O = v.getDay(), w = (O < m ? 7 : 0) + O - m;
  return v.setDate(v.getDate() - w), v.setHours(0, 0, 0, 0), v;
}
const cwe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dU
}, Symbol.toStringTag, { value: "Module" }));
function oR(t) {
  return Kt(1, arguments), dU(t, {
    weekStartsOn: 1
  });
}
function fwe(t) {
  Kt(1, arguments);
  var e = an(t), n = e.getFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  var a = oR(r), i = /* @__PURE__ */ new Date(0);
  i.setFullYear(n, 0, 4), i.setHours(0, 0, 0, 0);
  var o = oR(i);
  return e.getTime() >= a.getTime() ? n + 1 : e.getTime() >= o.getTime() ? n : n - 1;
}
function dwe(t) {
  Kt(1, arguments);
  var e = fwe(t), n = /* @__PURE__ */ new Date(0);
  n.setFullYear(e, 0, 4), n.setHours(0, 0, 0, 0);
  var r = oR(n);
  return r;
}
var pwe = 6048e5;
function hwe(t) {
  Kt(1, arguments);
  var e = an(t), n = oR(e).getTime() - dwe(e).getTime();
  return Math.round(n / pwe) + 1;
}
function uu(t) {
  Kt(1, arguments);
  var e = an(t), n = e.getMonth();
  return n;
}
function y$(t) {
  Kt(1, arguments);
  var e = an(t), n = Math.floor(e.getMonth() / 3) + 1;
  return n;
}
function sa(t) {
  return Kt(1, arguments), an(t).getFullYear();
}
function O$(t) {
  Kt(1, arguments);
  var e = an(t), n = e.getTime();
  return n;
}
function mwe(t, e) {
  Kt(2, arguments);
  var n = an(t), r = xr(e);
  return n.setSeconds(r), n;
}
function Yw(t, e) {
  Kt(2, arguments);
  var n = an(t), r = xr(e);
  return n.setMinutes(r), n;
}
function Zw(t, e) {
  Kt(2, arguments);
  var n = an(t), r = xr(e);
  return n.setHours(r), n;
}
function gwe(t) {
  Kt(1, arguments);
  var e = an(t), n = e.getFullYear(), r = e.getMonth(), a = /* @__PURE__ */ new Date(0);
  return a.setFullYear(n, r + 1, 0), a.setHours(0, 0, 0, 0), a.getDate();
}
function Bf(t, e) {
  Kt(2, arguments);
  var n = an(t), r = xr(e), a = n.getFullYear(), i = n.getDate(), o = /* @__PURE__ */ new Date(0);
  o.setFullYear(a, r, 15), o.setHours(0, 0, 0, 0);
  var s = gwe(o);
  return n.setMonth(r, Math.min(i, s)), n;
}
const bwe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Bf
}, Symbol.toStringTag, { value: "Module" }));
function Nw(t, e) {
  Kt(2, arguments);
  var n = an(t), r = xr(e), a = Math.floor(n.getMonth() / 3) + 1, i = r - a;
  return Bf(n, n.getMonth() + i * 3);
}
function LT(t, e) {
  Kt(2, arguments);
  var n = an(t), r = xr(e);
  return isNaN(n.getTime()) ? /* @__PURE__ */ new Date(NaN) : (n.setFullYear(r), n);
}
const vwe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: LT
}, Symbol.toStringTag, { value: "Module" }));
function DA(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? DA = function(n) {
    return typeof n;
  } : DA = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, DA(t);
}
function E$(t) {
  Kt(1, arguments);
  var e;
  if (t && typeof t.forEach == "function")
    e = t;
  else if (DA(t) === "object" && t !== null)
    e = Array.prototype.slice.call(t);
  else
    return /* @__PURE__ */ new Date(NaN);
  var n;
  return e.forEach(function(r) {
    var a = an(r);
    (n === void 0 || n > a || isNaN(a.getDate())) && (n = a);
  }), n || /* @__PURE__ */ new Date(NaN);
}
const ywe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: E$
}, Symbol.toStringTag, { value: "Module" }));
function NA(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? NA = function(n) {
    return typeof n;
  } : NA = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, NA(t);
}
function S$(t) {
  Kt(1, arguments);
  var e;
  if (t && typeof t.forEach == "function")
    e = t;
  else if (NA(t) === "object" && t !== null)
    e = Array.prototype.slice.call(t);
  else
    return /* @__PURE__ */ new Date(NaN);
  var n;
  return e.forEach(function(r) {
    var a = an(r);
    (n === void 0 || n < a || isNaN(Number(a))) && (n = a);
  }), n || /* @__PURE__ */ new Date(NaN);
}
const Owe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: S$
}, Symbol.toStringTag, { value: "Module" }));
function Gd(t) {
  Kt(1, arguments);
  var e = an(t);
  return e.setHours(0, 0, 0, 0), e;
}
const Ewe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Gd
}, Symbol.toStringTag, { value: "Module" }));
var Swe = 864e5;
function zE(t, e) {
  Kt(2, arguments);
  var n = Gd(t), r = Gd(e), a = n.getTime() - aR(n), i = r.getTime() - aR(r);
  return Math.round((a - i) / Swe);
}
const wwe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: zE
}, Symbol.toStringTag, { value: "Module" }));
function MT(t, e) {
  Kt(2, arguments);
  var n = an(t), r = an(e), a = n.getFullYear() - r.getFullYear(), i = n.getMonth() - r.getMonth();
  return a * 12 + i;
}
const Twe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: MT
}, Symbol.toStringTag, { value: "Module" }));
function sR(t, e) {
  Kt(2, arguments);
  var n = an(t), r = an(e);
  return n.getFullYear() - r.getFullYear();
}
function pU(t) {
  Kt(1, arguments);
  var e = an(t);
  return e.setDate(1), e.setHours(0, 0, 0, 0), e;
}
const _we = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: pU
}, Symbol.toStringTag, { value: "Module" }));
function w$(t) {
  Kt(1, arguments);
  var e = an(t), n = e.getMonth(), r = n - n % 3;
  return e.setMonth(r, 1), e.setHours(0, 0, 0, 0), e;
}
function nre(t) {
  Kt(1, arguments);
  var e = an(t), n = /* @__PURE__ */ new Date(0);
  return n.setFullYear(e.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function lR(t) {
  Kt(1, arguments);
  var e = an(t);
  return e.setHours(23, 59, 59, 999), e;
}
const Cwe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lR
}, Symbol.toStringTag, { value: "Module" }));
function xwe(t, e) {
  var n, r, a, i, o, s, u, f;
  Kt(1, arguments);
  var p = uv(), m = xr((n = (r = (a = (i = e == null ? void 0 : e.weekStartsOn) !== null && i !== void 0 ? i : e == null || (o = e.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && a !== void 0 ? a : p.weekStartsOn) !== null && r !== void 0 ? r : (u = p.locale) === null || u === void 0 || (f = u.options) === null || f === void 0 ? void 0 : f.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(m >= 0 && m <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var v = an(t), O = v.getDay(), w = (O < m ? -7 : 0) + 6 - (O - m);
  return v.setDate(v.getDate() + w), v.setHours(23, 59, 59, 999), v;
}
const Awe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: xwe
}, Symbol.toStringTag, { value: "Module" }));
function rre(t) {
  Kt(1, arguments);
  var e = an(t), n = e.getMonth();
  return e.setFullYear(e.getFullYear(), n + 1, 0), e.setHours(23, 59, 59, 999), e;
}
const kwe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: rre
}, Symbol.toStringTag, { value: "Module" }));
function Rwe(t) {
  Kt(1, arguments);
  var e = an(t), n = e.getFullYear();
  return e.setFullYear(n + 1, 0, 0), e.setHours(23, 59, 59, 999), e;
}
function are(t, e) {
  Kt(2, arguments);
  var n = an(t), r = an(e);
  return n.getTime() === r.getTime();
}
const Iwe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: are
}, Symbol.toStringTag, { value: "Module" }));
function ire(t, e) {
  Kt(2, arguments);
  var n = Gd(t), r = Gd(e);
  return n.getTime() === r.getTime();
}
const Dwe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ire
}, Symbol.toStringTag, { value: "Module" }));
function ore(t, e) {
  Kt(2, arguments);
  var n = an(t), r = an(e);
  return n.getFullYear() === r.getFullYear() && n.getMonth() === r.getMonth();
}
const Nwe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ore
}, Symbol.toStringTag, { value: "Module" }));
function Pwe(t, e) {
  Kt(2, arguments);
  var n = an(t), r = an(e);
  return n.getFullYear() === r.getFullYear();
}
function Lwe(t, e) {
  Kt(2, arguments);
  var n = w$(t), r = w$(e);
  return n.getTime() === r.getTime();
}
function Jm(t, e) {
  Kt(2, arguments);
  var n = an(t), r = an(e);
  return n.getTime() > r.getTime();
}
const Mwe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Jm
}, Symbol.toStringTag, { value: "Module" }));
function Oh(t, e) {
  Kt(2, arguments);
  var n = an(t), r = an(e);
  return n.getTime() < r.getTime();
}
const Fwe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Oh
}, Symbol.toStringTag, { value: "Module" }));
function HE(t, e) {
  Kt(2, arguments);
  var n = an(t).getTime(), r = an(e.start).getTime(), a = an(e.end).getTime();
  if (!(r <= a))
    throw new RangeError("Invalid interval");
  return n >= r && n <= a;
}
const $we = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: HE
}, Symbol.toStringTag, { value: "Module" }));
function Bwe(t, e) {
  if (t == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
  return t;
}
function PA(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? PA = function(n) {
    return typeof n;
  } : PA = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, PA(t);
}
function sre(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && T$(t, e);
}
function T$(t, e) {
  return T$ = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, T$(t, e);
}
function lre(t) {
  var e = zwe();
  return function() {
    var r = uR(t), a;
    if (e) {
      var i = uR(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return Uwe(this, a);
  };
}
function Uwe(t, e) {
  return e && (PA(e) === "object" || typeof e == "function") ? e : _$(t);
}
function _$(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function zwe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function uR(t) {
  return uR = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, uR(t);
}
function hU(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function VV(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function mU(t, e, n) {
  return e && VV(t.prototype, e), n && VV(t, n), t;
}
function C$(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var Hwe = 10, ure = /* @__PURE__ */ function() {
  function t() {
    hU(this, t), C$(this, "subPriority", 0);
  }
  return mU(t, [{
    key: "validate",
    value: function(n, r) {
      return !0;
    }
  }]), t;
}(), Wwe = /* @__PURE__ */ function(t) {
  sre(n, t);
  var e = lre(n);
  function n(r, a, i, o, s) {
    var u;
    return hU(this, n), u = e.call(this), u.value = r, u.validateValue = a, u.setValue = i, u.priority = o, s && (u.subPriority = s), u;
  }
  return mU(n, [{
    key: "validate",
    value: function(a, i) {
      return this.validateValue(a, this.value, i);
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return this.setValue(a, i, this.value, o);
    }
  }]), n;
}(ure), Qwe = /* @__PURE__ */ function(t) {
  sre(n, t);
  var e = lre(n);
  function n() {
    var r;
    hU(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), C$(_$(r), "priority", Hwe), C$(_$(r), "subPriority", -1), r;
  }
  return mU(n, [{
    key: "set",
    value: function(a, i) {
      if (i.timestampIsSet)
        return a;
      var o = /* @__PURE__ */ new Date(0);
      return o.setFullYear(a.getUTCFullYear(), a.getUTCMonth(), a.getUTCDate()), o.setHours(a.getUTCHours(), a.getUTCMinutes(), a.getUTCSeconds(), a.getUTCMilliseconds()), o;
    }
  }]), n;
}(ure);
function jwe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function YV(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function Gwe(t, e, n) {
  return e && YV(t.prototype, e), n && YV(t, n), t;
}
var ha = /* @__PURE__ */ function() {
  function t() {
    jwe(this, t);
  }
  return Gwe(t, [{
    key: "run",
    value: function(n, r, a, i) {
      var o = this.parse(n, r, a, i);
      return o ? {
        setter: new Wwe(o.value, this.validate, this.set, this.priority, this.subPriority),
        rest: o.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(n, r, a) {
      return !0;
    }
  }]), t;
}();
function LA(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? LA = function(n) {
    return typeof n;
  } : LA = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, LA(t);
}
function Vwe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function ZV(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function Ywe(t, e, n) {
  return e && ZV(t.prototype, e), n && ZV(t, n), t;
}
function Zwe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && x$(t, e);
}
function x$(t, e) {
  return x$ = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, x$(t, e);
}
function Xwe(t) {
  var e = Kwe();
  return function() {
    var r = cR(t), a;
    if (e) {
      var i = cR(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return qwe(this, a);
  };
}
function qwe(t, e) {
  return e && (LA(e) === "object" || typeof e == "function") ? e : A$(t);
}
function A$(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Kwe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function cR(t) {
  return cR = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, cR(t);
}
function XV(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var Jwe = /* @__PURE__ */ function(t) {
  Zwe(n, t);
  var e = Xwe(n);
  function n() {
    var r;
    Vwe(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), XV(A$(r), "priority", 140), XV(A$(r), "incompatibleTokens", ["R", "u", "t", "T"]), r;
  }
  return Ywe(n, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "G":
        case "GG":
        case "GGG":
          return o.era(a, {
            width: "abbreviated"
          }) || o.era(a, {
            width: "narrow"
          });
        case "GGGGG":
          return o.era(a, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return o.era(a, {
            width: "wide"
          }) || o.era(a, {
            width: "abbreviated"
          }) || o.era(a, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return i.era = o, a.setUTCFullYear(o, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(ha), gU = 6e4, bU = 36e5, eTe = 1e3, co = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, gh = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function fo(t, e) {
  return t && {
    value: e(t.value),
    rest: t.rest
  };
}
function Di(t, e) {
  var n = e.match(t);
  return n ? {
    value: parseInt(n[0], 10),
    rest: e.slice(n[0].length)
  } : null;
}
function bh(t, e) {
  var n = e.match(t);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: e.slice(1)
    };
  var r = n[1] === "+" ? 1 : -1, a = n[2] ? parseInt(n[2], 10) : 0, i = n[3] ? parseInt(n[3], 10) : 0, o = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: r * (a * bU + i * gU + o * eTe),
    rest: e.slice(n[0].length)
  };
}
function cre(t) {
  return Di(co.anyDigitsSigned, t);
}
function qi(t, e) {
  switch (t) {
    case 1:
      return Di(co.singleDigit, e);
    case 2:
      return Di(co.twoDigits, e);
    case 3:
      return Di(co.threeDigits, e);
    case 4:
      return Di(co.fourDigits, e);
    default:
      return Di(new RegExp("^\\d{1," + t + "}"), e);
  }
}
function fR(t, e) {
  switch (t) {
    case 1:
      return Di(co.singleDigitSigned, e);
    case 2:
      return Di(co.twoDigitsSigned, e);
    case 3:
      return Di(co.threeDigitsSigned, e);
    case 4:
      return Di(co.fourDigitsSigned, e);
    default:
      return Di(new RegExp("^-?\\d{1," + t + "}"), e);
  }
}
function vU(t) {
  switch (t) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function fre(t, e) {
  var n = e > 0, r = n ? e : 1 - e, a;
  if (r <= 50)
    a = t || 100;
  else {
    var i = r + 50, o = Math.floor(i / 100) * 100, s = t >= i % 100;
    a = t + o - (s ? 100 : 0);
  }
  return n ? a : 1 - a;
}
function dre(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function MA(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? MA = function(n) {
    return typeof n;
  } : MA = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, MA(t);
}
function tTe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function qV(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function nTe(t, e, n) {
  return e && qV(t.prototype, e), n && qV(t, n), t;
}
function rTe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && k$(t, e);
}
function k$(t, e) {
  return k$ = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, k$(t, e);
}
function aTe(t) {
  var e = oTe();
  return function() {
    var r = dR(t), a;
    if (e) {
      var i = dR(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return iTe(this, a);
  };
}
function iTe(t, e) {
  return e && (MA(e) === "object" || typeof e == "function") ? e : R$(t);
}
function R$(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function oTe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function dR(t) {
  return dR = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, dR(t);
}
function KV(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var sTe = /* @__PURE__ */ function(t) {
  rTe(n, t);
  var e = aTe(n);
  function n() {
    var r;
    tTe(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), KV(R$(r), "priority", 130), KV(R$(r), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), r;
  }
  return nTe(n, [{
    key: "parse",
    value: function(a, i, o) {
      var s = function(f) {
        return {
          year: f,
          isTwoDigitYear: i === "yy"
        };
      };
      switch (i) {
        case "y":
          return fo(qi(4, a), s);
        case "yo":
          return fo(o.ordinalNumber(a, {
            unit: "year"
          }), s);
        default:
          return fo(qi(i.length, a), s);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      var s = a.getUTCFullYear();
      if (o.isTwoDigitYear) {
        var u = fre(o.year, s);
        return a.setUTCFullYear(u, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
      }
      var f = !("era" in i) || i.era === 1 ? o.year : 1 - o.year;
      return a.setUTCFullYear(f, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(ha);
function FA(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? FA = function(n) {
    return typeof n;
  } : FA = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, FA(t);
}
function lTe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function JV(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function uTe(t, e, n) {
  return e && JV(t.prototype, e), n && JV(t, n), t;
}
function cTe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && I$(t, e);
}
function I$(t, e) {
  return I$ = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, I$(t, e);
}
function fTe(t) {
  var e = pTe();
  return function() {
    var r = pR(t), a;
    if (e) {
      var i = pR(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return dTe(this, a);
  };
}
function dTe(t, e) {
  return e && (FA(e) === "object" || typeof e == "function") ? e : D$(t);
}
function D$(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function pTe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function pR(t) {
  return pR = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, pR(t);
}
function eY(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var hTe = /* @__PURE__ */ function(t) {
  cTe(n, t);
  var e = fTe(n);
  function n() {
    var r;
    lTe(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), eY(D$(r), "priority", 130), eY(D$(r), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), r;
  }
  return uTe(n, [{
    key: "parse",
    value: function(a, i, o) {
      var s = function(f) {
        return {
          year: f,
          isTwoDigitYear: i === "YY"
        };
      };
      switch (i) {
        case "Y":
          return fo(qi(4, a), s);
        case "Yo":
          return fo(o.ordinalNumber(a, {
            unit: "year"
          }), s);
        default:
          return fo(qi(i.length, a), s);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function(a, i, o, s) {
      var u = uU(a, s);
      if (o.isTwoDigitYear) {
        var f = fre(o.year, u);
        return a.setUTCFullYear(f, 0, s.firstWeekContainsDate), a.setUTCHours(0, 0, 0, 0), o0(a, s);
      }
      var p = !("era" in i) || i.era === 1 ? o.year : 1 - o.year;
      return a.setUTCFullYear(p, 0, s.firstWeekContainsDate), a.setUTCHours(0, 0, 0, 0), o0(a, s);
    }
  }]), n;
}(ha);
function $A(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? $A = function(n) {
    return typeof n;
  } : $A = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, $A(t);
}
function mTe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function tY(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function gTe(t, e, n) {
  return e && tY(t.prototype, e), n && tY(t, n), t;
}
function bTe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && N$(t, e);
}
function N$(t, e) {
  return N$ = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, N$(t, e);
}
function vTe(t) {
  var e = OTe();
  return function() {
    var r = hR(t), a;
    if (e) {
      var i = hR(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return yTe(this, a);
  };
}
function yTe(t, e) {
  return e && ($A(e) === "object" || typeof e == "function") ? e : P$(t);
}
function P$(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function OTe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function hR(t) {
  return hR = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, hR(t);
}
function nY(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var ETe = /* @__PURE__ */ function(t) {
  bTe(n, t);
  var e = vTe(n);
  function n() {
    var r;
    mTe(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), nY(P$(r), "priority", 130), nY(P$(r), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
  }
  return gTe(n, [{
    key: "parse",
    value: function(a, i) {
      return fR(i === "R" ? 4 : i.length, a);
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      var s = /* @__PURE__ */ new Date(0);
      return s.setUTCFullYear(o, 0, 4), s.setUTCHours(0, 0, 0, 0), UE(s);
    }
  }]), n;
}(ha);
function BA(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? BA = function(n) {
    return typeof n;
  } : BA = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, BA(t);
}
function STe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function rY(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function wTe(t, e, n) {
  return e && rY(t.prototype, e), n && rY(t, n), t;
}
function TTe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && L$(t, e);
}
function L$(t, e) {
  return L$ = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, L$(t, e);
}
function _Te(t) {
  var e = xTe();
  return function() {
    var r = mR(t), a;
    if (e) {
      var i = mR(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return CTe(this, a);
  };
}
function CTe(t, e) {
  return e && (BA(e) === "object" || typeof e == "function") ? e : M$(t);
}
function M$(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function xTe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function mR(t) {
  return mR = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, mR(t);
}
function aY(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var ATe = /* @__PURE__ */ function(t) {
  TTe(n, t);
  var e = _Te(n);
  function n() {
    var r;
    STe(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), aY(M$(r), "priority", 130), aY(M$(r), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), r;
  }
  return wTe(n, [{
    key: "parse",
    value: function(a, i) {
      return fR(i === "u" ? 4 : i.length, a);
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCFullYear(o, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(ha);
function UA(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? UA = function(n) {
    return typeof n;
  } : UA = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, UA(t);
}
function kTe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function iY(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function RTe(t, e, n) {
  return e && iY(t.prototype, e), n && iY(t, n), t;
}
function ITe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && F$(t, e);
}
function F$(t, e) {
  return F$ = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, F$(t, e);
}
function DTe(t) {
  var e = PTe();
  return function() {
    var r = gR(t), a;
    if (e) {
      var i = gR(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return NTe(this, a);
  };
}
function NTe(t, e) {
  return e && (UA(e) === "object" || typeof e == "function") ? e : $$(t);
}
function $$(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function PTe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function gR(t) {
  return gR = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, gR(t);
}
function oY(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var LTe = /* @__PURE__ */ function(t) {
  ITe(n, t);
  var e = DTe(n);
  function n() {
    var r;
    kTe(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), oY($$(r), "priority", 120), oY($$(r), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), r;
  }
  return RTe(n, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "Q":
        case "QQ":
          return qi(i.length, a);
        case "Qo":
          return o.ordinalNumber(a, {
            unit: "quarter"
          });
        case "QQQ":
          return o.quarter(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(a, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return o.quarter(a, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return o.quarter(a, {
            width: "wide",
            context: "formatting"
          }) || o.quarter(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCMonth((o - 1) * 3, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(ha);
function zA(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? zA = function(n) {
    return typeof n;
  } : zA = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, zA(t);
}
function MTe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function sY(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function FTe(t, e, n) {
  return e && sY(t.prototype, e), n && sY(t, n), t;
}
function $Te(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && B$(t, e);
}
function B$(t, e) {
  return B$ = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, B$(t, e);
}
function BTe(t) {
  var e = zTe();
  return function() {
    var r = bR(t), a;
    if (e) {
      var i = bR(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return UTe(this, a);
  };
}
function UTe(t, e) {
  return e && (zA(e) === "object" || typeof e == "function") ? e : U$(t);
}
function U$(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function zTe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function bR(t) {
  return bR = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, bR(t);
}
function lY(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var HTe = /* @__PURE__ */ function(t) {
  $Te(n, t);
  var e = BTe(n);
  function n() {
    var r;
    MTe(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), lY(U$(r), "priority", 120), lY(U$(r), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), r;
  }
  return FTe(n, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "q":
        case "qq":
          return qi(i.length, a);
        case "qo":
          return o.ordinalNumber(a, {
            unit: "quarter"
          });
        case "qqq":
          return o.quarter(a, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(a, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return o.quarter(a, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return o.quarter(a, {
            width: "wide",
            context: "standalone"
          }) || o.quarter(a, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(a, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCMonth((o - 1) * 3, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(ha);
function HA(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? HA = function(n) {
    return typeof n;
  } : HA = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, HA(t);
}
function WTe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function uY(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function QTe(t, e, n) {
  return e && uY(t.prototype, e), n && uY(t, n), t;
}
function jTe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && z$(t, e);
}
function z$(t, e) {
  return z$ = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, z$(t, e);
}
function GTe(t) {
  var e = YTe();
  return function() {
    var r = vR(t), a;
    if (e) {
      var i = vR(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return VTe(this, a);
  };
}
function VTe(t, e) {
  return e && (HA(e) === "object" || typeof e == "function") ? e : H$(t);
}
function H$(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function YTe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function vR(t) {
  return vR = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, vR(t);
}
function cY(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var ZTe = /* @__PURE__ */ function(t) {
  jTe(n, t);
  var e = GTe(n);
  function n() {
    var r;
    WTe(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), cY(H$(r), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), cY(H$(r), "priority", 110), r;
  }
  return QTe(n, [{
    key: "parse",
    value: function(a, i, o) {
      var s = function(f) {
        return f - 1;
      };
      switch (i) {
        case "M":
          return fo(Di(co.month, a), s);
        case "MM":
          return fo(qi(2, a), s);
        case "Mo":
          return fo(o.ordinalNumber(a, {
            unit: "month"
          }), s);
        case "MMM":
          return o.month(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(a, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return o.month(a, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return o.month(a, {
            width: "wide",
            context: "formatting"
          }) || o.month(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCMonth(o, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(ha);
function WA(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? WA = function(n) {
    return typeof n;
  } : WA = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, WA(t);
}
function XTe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function fY(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function qTe(t, e, n) {
  return e && fY(t.prototype, e), n && fY(t, n), t;
}
function KTe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && W$(t, e);
}
function W$(t, e) {
  return W$ = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, W$(t, e);
}
function JTe(t) {
  var e = t_e();
  return function() {
    var r = yR(t), a;
    if (e) {
      var i = yR(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return e_e(this, a);
  };
}
function e_e(t, e) {
  return e && (WA(e) === "object" || typeof e == "function") ? e : Q$(t);
}
function Q$(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function t_e() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function yR(t) {
  return yR = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, yR(t);
}
function dY(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var n_e = /* @__PURE__ */ function(t) {
  KTe(n, t);
  var e = JTe(n);
  function n() {
    var r;
    XTe(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), dY(Q$(r), "priority", 110), dY(Q$(r), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), r;
  }
  return qTe(n, [{
    key: "parse",
    value: function(a, i, o) {
      var s = function(f) {
        return f - 1;
      };
      switch (i) {
        case "L":
          return fo(Di(co.month, a), s);
        case "LL":
          return fo(qi(2, a), s);
        case "Lo":
          return fo(o.ordinalNumber(a, {
            unit: "month"
          }), s);
        case "LLL":
          return o.month(a, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(a, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return o.month(a, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return o.month(a, {
            width: "wide",
            context: "standalone"
          }) || o.month(a, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(a, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCMonth(o, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(ha);
function r_e(t, e, n) {
  Kt(2, arguments);
  var r = an(t), a = xr(e), i = Kne(r, n) - a;
  return r.setUTCDate(r.getUTCDate() - i * 7), r;
}
function QA(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? QA = function(n) {
    return typeof n;
  } : QA = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, QA(t);
}
function a_e(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function pY(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function i_e(t, e, n) {
  return e && pY(t.prototype, e), n && pY(t, n), t;
}
function o_e(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && j$(t, e);
}
function j$(t, e) {
  return j$ = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, j$(t, e);
}
function s_e(t) {
  var e = u_e();
  return function() {
    var r = OR(t), a;
    if (e) {
      var i = OR(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return l_e(this, a);
  };
}
function l_e(t, e) {
  return e && (QA(e) === "object" || typeof e == "function") ? e : G$(t);
}
function G$(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function u_e() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function OR(t) {
  return OR = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, OR(t);
}
function hY(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var c_e = /* @__PURE__ */ function(t) {
  o_e(n, t);
  var e = s_e(n);
  function n() {
    var r;
    a_e(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), hY(G$(r), "priority", 100), hY(G$(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), r;
  }
  return i_e(n, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "w":
          return Di(co.week, a);
        case "wo":
          return o.ordinalNumber(a, {
            unit: "week"
          });
        default:
          return qi(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function(a, i, o, s) {
      return o0(r_e(a, o, s), s);
    }
  }]), n;
}(ha);
function f_e(t, e) {
  Kt(2, arguments);
  var n = an(t), r = xr(e), a = qne(n) - r;
  return n.setUTCDate(n.getUTCDate() - a * 7), n;
}
function jA(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? jA = function(n) {
    return typeof n;
  } : jA = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, jA(t);
}
function d_e(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function mY(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function p_e(t, e, n) {
  return e && mY(t.prototype, e), n && mY(t, n), t;
}
function h_e(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && V$(t, e);
}
function V$(t, e) {
  return V$ = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, V$(t, e);
}
function m_e(t) {
  var e = b_e();
  return function() {
    var r = ER(t), a;
    if (e) {
      var i = ER(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return g_e(this, a);
  };
}
function g_e(t, e) {
  return e && (jA(e) === "object" || typeof e == "function") ? e : Y$(t);
}
function Y$(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function b_e() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function ER(t) {
  return ER = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, ER(t);
}
function gY(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var v_e = /* @__PURE__ */ function(t) {
  h_e(n, t);
  var e = m_e(n);
  function n() {
    var r;
    d_e(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), gY(Y$(r), "priority", 100), gY(Y$(r), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
  }
  return p_e(n, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "I":
          return Di(co.week, a);
        case "Io":
          return o.ordinalNumber(a, {
            unit: "week"
          });
        default:
          return qi(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return UE(f_e(a, o));
    }
  }]), n;
}(ha);
function GA(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? GA = function(n) {
    return typeof n;
  } : GA = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, GA(t);
}
function y_e(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function bY(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function O_e(t, e, n) {
  return e && bY(t.prototype, e), n && bY(t, n), t;
}
function E_e(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Z$(t, e);
}
function Z$(t, e) {
  return Z$ = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, Z$(t, e);
}
function S_e(t) {
  var e = T_e();
  return function() {
    var r = SR(t), a;
    if (e) {
      var i = SR(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return w_e(this, a);
  };
}
function w_e(t, e) {
  return e && (GA(e) === "object" || typeof e == "function") ? e : VA(t);
}
function VA(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function T_e() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function SR(t) {
  return SR = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, SR(t);
}
function UM(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var __e = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], C_e = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], x_e = /* @__PURE__ */ function(t) {
  E_e(n, t);
  var e = S_e(n);
  function n() {
    var r;
    y_e(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), UM(VA(r), "priority", 90), UM(VA(r), "subPriority", 1), UM(VA(r), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), r;
  }
  return O_e(n, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "d":
          return Di(co.date, a);
        case "do":
          return o.ordinalNumber(a, {
            unit: "date"
          });
        default:
          return qi(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      var o = a.getUTCFullYear(), s = dre(o), u = a.getUTCMonth();
      return s ? i >= 1 && i <= C_e[u] : i >= 1 && i <= __e[u];
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCDate(o), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(ha);
function YA(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? YA = function(n) {
    return typeof n;
  } : YA = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, YA(t);
}
function A_e(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function vY(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function k_e(t, e, n) {
  return e && vY(t.prototype, e), n && vY(t, n), t;
}
function R_e(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && X$(t, e);
}
function X$(t, e) {
  return X$ = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, X$(t, e);
}
function I_e(t) {
  var e = N_e();
  return function() {
    var r = wR(t), a;
    if (e) {
      var i = wR(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return D_e(this, a);
  };
}
function D_e(t, e) {
  return e && (YA(e) === "object" || typeof e == "function") ? e : ZA(t);
}
function ZA(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function N_e() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function wR(t) {
  return wR = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, wR(t);
}
function zM(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var P_e = /* @__PURE__ */ function(t) {
  R_e(n, t);
  var e = I_e(n);
  function n() {
    var r;
    A_e(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), zM(ZA(r), "priority", 90), zM(ZA(r), "subpriority", 1), zM(ZA(r), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), r;
  }
  return k_e(n, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "D":
        case "DD":
          return Di(co.dayOfYear, a);
        case "Do":
          return o.ordinalNumber(a, {
            unit: "date"
          });
        default:
          return qi(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      var o = a.getUTCFullYear(), s = dre(o);
      return s ? i >= 1 && i <= 366 : i >= 1 && i <= 365;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCMonth(0, o), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(ha);
function yU(t, e, n) {
  var r, a, i, o, s, u, f, p;
  Kt(2, arguments);
  var m = uv(), v = xr((r = (a = (i = (o = n == null ? void 0 : n.weekStartsOn) !== null && o !== void 0 ? o : n == null || (s = n.locale) === null || s === void 0 || (u = s.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && i !== void 0 ? i : m.weekStartsOn) !== null && a !== void 0 ? a : (f = m.locale) === null || f === void 0 || (p = f.options) === null || p === void 0 ? void 0 : p.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(v >= 0 && v <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var O = an(t), w = xr(e), _ = O.getUTCDay(), C = w % 7, A = (C + 7) % 7, N = (A < v ? 7 : 0) + w - _;
  return O.setUTCDate(O.getUTCDate() + N), O;
}
function XA(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? XA = function(n) {
    return typeof n;
  } : XA = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, XA(t);
}
function L_e(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function yY(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function M_e(t, e, n) {
  return e && yY(t.prototype, e), n && yY(t, n), t;
}
function F_e(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && q$(t, e);
}
function q$(t, e) {
  return q$ = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, q$(t, e);
}
function $_e(t) {
  var e = U_e();
  return function() {
    var r = TR(t), a;
    if (e) {
      var i = TR(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return B_e(this, a);
  };
}
function B_e(t, e) {
  return e && (XA(e) === "object" || typeof e == "function") ? e : K$(t);
}
function K$(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function U_e() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function TR(t) {
  return TR = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, TR(t);
}
function OY(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var z_e = /* @__PURE__ */ function(t) {
  F_e(n, t);
  var e = $_e(n);
  function n() {
    var r;
    L_e(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), OY(K$(r), "priority", 90), OY(K$(r), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), r;
  }
  return M_e(n, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "E":
        case "EE":
        case "EEE":
          return o.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return o.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return o.day(a, {
            width: "wide",
            context: "formatting"
          }) || o.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(a, i, o, s) {
      return a = yU(a, o, s), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(ha);
function qA(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? qA = function(n) {
    return typeof n;
  } : qA = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, qA(t);
}
function H_e(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function EY(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function W_e(t, e, n) {
  return e && EY(t.prototype, e), n && EY(t, n), t;
}
function Q_e(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && J$(t, e);
}
function J$(t, e) {
  return J$ = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, J$(t, e);
}
function j_e(t) {
  var e = V_e();
  return function() {
    var r = _R(t), a;
    if (e) {
      var i = _R(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return G_e(this, a);
  };
}
function G_e(t, e) {
  return e && (qA(e) === "object" || typeof e == "function") ? e : eB(t);
}
function eB(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function V_e() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _R(t) {
  return _R = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, _R(t);
}
function SY(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var Y_e = /* @__PURE__ */ function(t) {
  Q_e(n, t);
  var e = j_e(n);
  function n() {
    var r;
    H_e(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), SY(eB(r), "priority", 90), SY(eB(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), r;
  }
  return W_e(n, [{
    key: "parse",
    value: function(a, i, o, s) {
      var u = function(p) {
        var m = Math.floor((p - 1) / 7) * 7;
        return (p + s.weekStartsOn + 6) % 7 + m;
      };
      switch (i) {
        case "e":
        case "ee":
          return fo(qi(i.length, a), u);
        case "eo":
          return fo(o.ordinalNumber(a, {
            unit: "day"
          }), u);
        case "eee":
          return o.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return o.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return o.day(a, {
            width: "wide",
            context: "formatting"
          }) || o.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(a, i, o, s) {
      return a = yU(a, o, s), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(ha);
function KA(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? KA = function(n) {
    return typeof n;
  } : KA = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, KA(t);
}
function Z_e(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function wY(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function X_e(t, e, n) {
  return e && wY(t.prototype, e), n && wY(t, n), t;
}
function q_e(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && tB(t, e);
}
function tB(t, e) {
  return tB = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, tB(t, e);
}
function K_e(t) {
  var e = eCe();
  return function() {
    var r = CR(t), a;
    if (e) {
      var i = CR(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return J_e(this, a);
  };
}
function J_e(t, e) {
  return e && (KA(e) === "object" || typeof e == "function") ? e : nB(t);
}
function nB(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function eCe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function CR(t) {
  return CR = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, CR(t);
}
function TY(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var tCe = /* @__PURE__ */ function(t) {
  q_e(n, t);
  var e = K_e(n);
  function n() {
    var r;
    Z_e(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), TY(nB(r), "priority", 90), TY(nB(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), r;
  }
  return X_e(n, [{
    key: "parse",
    value: function(a, i, o, s) {
      var u = function(p) {
        var m = Math.floor((p - 1) / 7) * 7;
        return (p + s.weekStartsOn + 6) % 7 + m;
      };
      switch (i) {
        case "c":
        case "cc":
          return fo(qi(i.length, a), u);
        case "co":
          return fo(o.ordinalNumber(a, {
            unit: "day"
          }), u);
        case "ccc":
          return o.day(a, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(a, {
            width: "short",
            context: "standalone"
          }) || o.day(a, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return o.day(a, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return o.day(a, {
            width: "short",
            context: "standalone"
          }) || o.day(a, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return o.day(a, {
            width: "wide",
            context: "standalone"
          }) || o.day(a, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(a, {
            width: "short",
            context: "standalone"
          }) || o.day(a, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(a, i, o, s) {
      return a = yU(a, o, s), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(ha);
function nCe(t, e) {
  Kt(2, arguments);
  var n = xr(e);
  n % 7 === 0 && (n = n - 7);
  var r = 1, a = an(t), i = a.getUTCDay(), o = n % 7, s = (o + 7) % 7, u = (s < r ? 7 : 0) + n - i;
  return a.setUTCDate(a.getUTCDate() + u), a;
}
function JA(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? JA = function(n) {
    return typeof n;
  } : JA = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, JA(t);
}
function rCe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function _Y(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function aCe(t, e, n) {
  return e && _Y(t.prototype, e), n && _Y(t, n), t;
}
function iCe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && rB(t, e);
}
function rB(t, e) {
  return rB = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, rB(t, e);
}
function oCe(t) {
  var e = lCe();
  return function() {
    var r = xR(t), a;
    if (e) {
      var i = xR(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return sCe(this, a);
  };
}
function sCe(t, e) {
  return e && (JA(e) === "object" || typeof e == "function") ? e : aB(t);
}
function aB(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function lCe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function xR(t) {
  return xR = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, xR(t);
}
function CY(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var uCe = /* @__PURE__ */ function(t) {
  iCe(n, t);
  var e = oCe(n);
  function n() {
    var r;
    rCe(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), CY(aB(r), "priority", 90), CY(aB(r), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), r;
  }
  return aCe(n, [{
    key: "parse",
    value: function(a, i, o) {
      var s = function(f) {
        return f === 0 ? 7 : f;
      };
      switch (i) {
        case "i":
        case "ii":
          return qi(i.length, a);
        case "io":
          return o.ordinalNumber(a, {
            unit: "day"
          });
        case "iii":
          return fo(o.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          }), s);
        case "iiiii":
          return fo(o.day(a, {
            width: "narrow",
            context: "formatting"
          }), s);
        case "iiiiii":
          return fo(o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          }), s);
        case "iiii":
        default:
          return fo(o.day(a, {
            width: "wide",
            context: "formatting"
          }) || o.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          }), s);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 7;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a = nCe(a, o), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(ha);
function ek(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? ek = function(n) {
    return typeof n;
  } : ek = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, ek(t);
}
function cCe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function xY(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function fCe(t, e, n) {
  return e && xY(t.prototype, e), n && xY(t, n), t;
}
function dCe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && iB(t, e);
}
function iB(t, e) {
  return iB = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, iB(t, e);
}
function pCe(t) {
  var e = mCe();
  return function() {
    var r = AR(t), a;
    if (e) {
      var i = AR(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return hCe(this, a);
  };
}
function hCe(t, e) {
  return e && (ek(e) === "object" || typeof e == "function") ? e : oB(t);
}
function oB(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function mCe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function AR(t) {
  return AR = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, AR(t);
}
function AY(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var gCe = /* @__PURE__ */ function(t) {
  dCe(n, t);
  var e = pCe(n);
  function n() {
    var r;
    cCe(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), AY(oB(r), "priority", 80), AY(oB(r), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), r;
  }
  return fCe(n, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "a":
        case "aa":
        case "aaa":
          return o.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return o.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCHours(vU(o), 0, 0, 0), a;
    }
  }]), n;
}(ha);
function tk(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? tk = function(n) {
    return typeof n;
  } : tk = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, tk(t);
}
function bCe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function kY(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function vCe(t, e, n) {
  return e && kY(t.prototype, e), n && kY(t, n), t;
}
function yCe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && sB(t, e);
}
function sB(t, e) {
  return sB = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, sB(t, e);
}
function OCe(t) {
  var e = SCe();
  return function() {
    var r = kR(t), a;
    if (e) {
      var i = kR(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return ECe(this, a);
  };
}
function ECe(t, e) {
  return e && (tk(e) === "object" || typeof e == "function") ? e : lB(t);
}
function lB(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function SCe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function kR(t) {
  return kR = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, kR(t);
}
function RY(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var wCe = /* @__PURE__ */ function(t) {
  yCe(n, t);
  var e = OCe(n);
  function n() {
    var r;
    bCe(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), RY(lB(r), "priority", 80), RY(lB(r), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), r;
  }
  return vCe(n, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "b":
        case "bb":
        case "bbb":
          return o.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return o.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCHours(vU(o), 0, 0, 0), a;
    }
  }]), n;
}(ha);
function nk(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? nk = function(n) {
    return typeof n;
  } : nk = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, nk(t);
}
function TCe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function IY(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function _Ce(t, e, n) {
  return e && IY(t.prototype, e), n && IY(t, n), t;
}
function CCe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && uB(t, e);
}
function uB(t, e) {
  return uB = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, uB(t, e);
}
function xCe(t) {
  var e = kCe();
  return function() {
    var r = RR(t), a;
    if (e) {
      var i = RR(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return ACe(this, a);
  };
}
function ACe(t, e) {
  return e && (nk(e) === "object" || typeof e == "function") ? e : cB(t);
}
function cB(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function kCe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function RR(t) {
  return RR = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, RR(t);
}
function DY(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var RCe = /* @__PURE__ */ function(t) {
  CCe(n, t);
  var e = xCe(n);
  function n() {
    var r;
    TCe(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), DY(cB(r), "priority", 80), DY(cB(r), "incompatibleTokens", ["a", "b", "t", "T"]), r;
  }
  return _Ce(n, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "B":
        case "BB":
        case "BBB":
          return o.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return o.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCHours(vU(o), 0, 0, 0), a;
    }
  }]), n;
}(ha);
function rk(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? rk = function(n) {
    return typeof n;
  } : rk = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, rk(t);
}
function ICe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function NY(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function DCe(t, e, n) {
  return e && NY(t.prototype, e), n && NY(t, n), t;
}
function NCe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && fB(t, e);
}
function fB(t, e) {
  return fB = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, fB(t, e);
}
function PCe(t) {
  var e = MCe();
  return function() {
    var r = IR(t), a;
    if (e) {
      var i = IR(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return LCe(this, a);
  };
}
function LCe(t, e) {
  return e && (rk(e) === "object" || typeof e == "function") ? e : dB(t);
}
function dB(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function MCe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function IR(t) {
  return IR = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, IR(t);
}
function PY(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var FCe = /* @__PURE__ */ function(t) {
  NCe(n, t);
  var e = PCe(n);
  function n() {
    var r;
    ICe(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), PY(dB(r), "priority", 70), PY(dB(r), "incompatibleTokens", ["H", "K", "k", "t", "T"]), r;
  }
  return DCe(n, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "h":
          return Di(co.hour12h, a);
        case "ho":
          return o.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return qi(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 12;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      var s = a.getUTCHours() >= 12;
      return s && o < 12 ? a.setUTCHours(o + 12, 0, 0, 0) : !s && o === 12 ? a.setUTCHours(0, 0, 0, 0) : a.setUTCHours(o, 0, 0, 0), a;
    }
  }]), n;
}(ha);
function ak(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? ak = function(n) {
    return typeof n;
  } : ak = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, ak(t);
}
function $Ce(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function LY(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function BCe(t, e, n) {
  return e && LY(t.prototype, e), n && LY(t, n), t;
}
function UCe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && pB(t, e);
}
function pB(t, e) {
  return pB = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, pB(t, e);
}
function zCe(t) {
  var e = WCe();
  return function() {
    var r = DR(t), a;
    if (e) {
      var i = DR(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return HCe(this, a);
  };
}
function HCe(t, e) {
  return e && (ak(e) === "object" || typeof e == "function") ? e : hB(t);
}
function hB(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function WCe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function DR(t) {
  return DR = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, DR(t);
}
function MY(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var QCe = /* @__PURE__ */ function(t) {
  UCe(n, t);
  var e = zCe(n);
  function n() {
    var r;
    $Ce(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), MY(hB(r), "priority", 70), MY(hB(r), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), r;
  }
  return BCe(n, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "H":
          return Di(co.hour23h, a);
        case "Ho":
          return o.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return qi(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 23;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCHours(o, 0, 0, 0), a;
    }
  }]), n;
}(ha);
function ik(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? ik = function(n) {
    return typeof n;
  } : ik = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, ik(t);
}
function jCe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function FY(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function GCe(t, e, n) {
  return e && FY(t.prototype, e), n && FY(t, n), t;
}
function VCe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && mB(t, e);
}
function mB(t, e) {
  return mB = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, mB(t, e);
}
function YCe(t) {
  var e = XCe();
  return function() {
    var r = NR(t), a;
    if (e) {
      var i = NR(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return ZCe(this, a);
  };
}
function ZCe(t, e) {
  return e && (ik(e) === "object" || typeof e == "function") ? e : gB(t);
}
function gB(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function XCe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function NR(t) {
  return NR = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, NR(t);
}
function $Y(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var qCe = /* @__PURE__ */ function(t) {
  VCe(n, t);
  var e = YCe(n);
  function n() {
    var r;
    jCe(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), $Y(gB(r), "priority", 70), $Y(gB(r), "incompatibleTokens", ["h", "H", "k", "t", "T"]), r;
  }
  return GCe(n, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "K":
          return Di(co.hour11h, a);
        case "Ko":
          return o.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return qi(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      var s = a.getUTCHours() >= 12;
      return s && o < 12 ? a.setUTCHours(o + 12, 0, 0, 0) : a.setUTCHours(o, 0, 0, 0), a;
    }
  }]), n;
}(ha);
function ok(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? ok = function(n) {
    return typeof n;
  } : ok = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, ok(t);
}
function KCe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function BY(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function JCe(t, e, n) {
  return e && BY(t.prototype, e), n && BY(t, n), t;
}
function exe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && bB(t, e);
}
function bB(t, e) {
  return bB = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, bB(t, e);
}
function txe(t) {
  var e = rxe();
  return function() {
    var r = PR(t), a;
    if (e) {
      var i = PR(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return nxe(this, a);
  };
}
function nxe(t, e) {
  return e && (ok(e) === "object" || typeof e == "function") ? e : vB(t);
}
function vB(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function rxe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function PR(t) {
  return PR = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, PR(t);
}
function UY(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var axe = /* @__PURE__ */ function(t) {
  exe(n, t);
  var e = txe(n);
  function n() {
    var r;
    KCe(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), UY(vB(r), "priority", 70), UY(vB(r), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), r;
  }
  return JCe(n, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "k":
          return Di(co.hour24h, a);
        case "ko":
          return o.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return qi(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 24;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      var s = o <= 24 ? o % 24 : o;
      return a.setUTCHours(s, 0, 0, 0), a;
    }
  }]), n;
}(ha);
function sk(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? sk = function(n) {
    return typeof n;
  } : sk = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, sk(t);
}
function ixe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function zY(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function oxe(t, e, n) {
  return e && zY(t.prototype, e), n && zY(t, n), t;
}
function sxe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && yB(t, e);
}
function yB(t, e) {
  return yB = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, yB(t, e);
}
function lxe(t) {
  var e = cxe();
  return function() {
    var r = LR(t), a;
    if (e) {
      var i = LR(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return uxe(this, a);
  };
}
function uxe(t, e) {
  return e && (sk(e) === "object" || typeof e == "function") ? e : OB(t);
}
function OB(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function cxe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function LR(t) {
  return LR = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, LR(t);
}
function HY(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var fxe = /* @__PURE__ */ function(t) {
  sxe(n, t);
  var e = lxe(n);
  function n() {
    var r;
    ixe(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), HY(OB(r), "priority", 60), HY(OB(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return oxe(n, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "m":
          return Di(co.minute, a);
        case "mo":
          return o.ordinalNumber(a, {
            unit: "minute"
          });
        default:
          return qi(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCMinutes(o, 0, 0), a;
    }
  }]), n;
}(ha);
function lk(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? lk = function(n) {
    return typeof n;
  } : lk = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, lk(t);
}
function dxe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function WY(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function pxe(t, e, n) {
  return e && WY(t.prototype, e), n && WY(t, n), t;
}
function hxe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && EB(t, e);
}
function EB(t, e) {
  return EB = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, EB(t, e);
}
function mxe(t) {
  var e = bxe();
  return function() {
    var r = MR(t), a;
    if (e) {
      var i = MR(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return gxe(this, a);
  };
}
function gxe(t, e) {
  return e && (lk(e) === "object" || typeof e == "function") ? e : SB(t);
}
function SB(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function bxe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function MR(t) {
  return MR = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, MR(t);
}
function QY(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var vxe = /* @__PURE__ */ function(t) {
  hxe(n, t);
  var e = mxe(n);
  function n() {
    var r;
    dxe(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), QY(SB(r), "priority", 50), QY(SB(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return pxe(n, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "s":
          return Di(co.second, a);
        case "so":
          return o.ordinalNumber(a, {
            unit: "second"
          });
        default:
          return qi(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCSeconds(o, 0), a;
    }
  }]), n;
}(ha);
function uk(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? uk = function(n) {
    return typeof n;
  } : uk = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, uk(t);
}
function yxe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function jY(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function Oxe(t, e, n) {
  return e && jY(t.prototype, e), n && jY(t, n), t;
}
function Exe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && wB(t, e);
}
function wB(t, e) {
  return wB = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, wB(t, e);
}
function Sxe(t) {
  var e = Txe();
  return function() {
    var r = FR(t), a;
    if (e) {
      var i = FR(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return wxe(this, a);
  };
}
function wxe(t, e) {
  return e && (uk(e) === "object" || typeof e == "function") ? e : TB(t);
}
function TB(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Txe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function FR(t) {
  return FR = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, FR(t);
}
function GY(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var _xe = /* @__PURE__ */ function(t) {
  Exe(n, t);
  var e = Sxe(n);
  function n() {
    var r;
    yxe(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), GY(TB(r), "priority", 30), GY(TB(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return Oxe(n, [{
    key: "parse",
    value: function(a, i) {
      var o = function(u) {
        return Math.floor(u * Math.pow(10, -i.length + 3));
      };
      return fo(qi(i.length, a), o);
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCMilliseconds(o), a;
    }
  }]), n;
}(ha);
function ck(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? ck = function(n) {
    return typeof n;
  } : ck = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, ck(t);
}
function Cxe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function VY(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function xxe(t, e, n) {
  return e && VY(t.prototype, e), n && VY(t, n), t;
}
function Axe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && _B(t, e);
}
function _B(t, e) {
  return _B = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, _B(t, e);
}
function kxe(t) {
  var e = Ixe();
  return function() {
    var r = $R(t), a;
    if (e) {
      var i = $R(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return Rxe(this, a);
  };
}
function Rxe(t, e) {
  return e && (ck(e) === "object" || typeof e == "function") ? e : CB(t);
}
function CB(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Ixe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function $R(t) {
  return $R = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, $R(t);
}
function YY(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var Dxe = /* @__PURE__ */ function(t) {
  Axe(n, t);
  var e = kxe(n);
  function n() {
    var r;
    Cxe(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), YY(CB(r), "priority", 10), YY(CB(r), "incompatibleTokens", ["t", "T", "x"]), r;
  }
  return xxe(n, [{
    key: "parse",
    value: function(a, i) {
      switch (i) {
        case "X":
          return bh(gh.basicOptionalMinutes, a);
        case "XX":
          return bh(gh.basic, a);
        case "XXXX":
          return bh(gh.basicOptionalSeconds, a);
        case "XXXXX":
          return bh(gh.extendedOptionalSeconds, a);
        case "XXX":
        default:
          return bh(gh.extended, a);
      }
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return i.timestampIsSet ? a : new Date(a.getTime() - o);
    }
  }]), n;
}(ha);
function fk(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? fk = function(n) {
    return typeof n;
  } : fk = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, fk(t);
}
function Nxe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function ZY(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function Pxe(t, e, n) {
  return e && ZY(t.prototype, e), n && ZY(t, n), t;
}
function Lxe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && xB(t, e);
}
function xB(t, e) {
  return xB = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, xB(t, e);
}
function Mxe(t) {
  var e = $xe();
  return function() {
    var r = BR(t), a;
    if (e) {
      var i = BR(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return Fxe(this, a);
  };
}
function Fxe(t, e) {
  return e && (fk(e) === "object" || typeof e == "function") ? e : AB(t);
}
function AB(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function $xe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function BR(t) {
  return BR = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, BR(t);
}
function XY(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var Bxe = /* @__PURE__ */ function(t) {
  Lxe(n, t);
  var e = Mxe(n);
  function n() {
    var r;
    Nxe(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), XY(AB(r), "priority", 10), XY(AB(r), "incompatibleTokens", ["t", "T", "X"]), r;
  }
  return Pxe(n, [{
    key: "parse",
    value: function(a, i) {
      switch (i) {
        case "x":
          return bh(gh.basicOptionalMinutes, a);
        case "xx":
          return bh(gh.basic, a);
        case "xxxx":
          return bh(gh.basicOptionalSeconds, a);
        case "xxxxx":
          return bh(gh.extendedOptionalSeconds, a);
        case "xxx":
        default:
          return bh(gh.extended, a);
      }
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return i.timestampIsSet ? a : new Date(a.getTime() - o);
    }
  }]), n;
}(ha);
function dk(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? dk = function(n) {
    return typeof n;
  } : dk = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, dk(t);
}
function Uxe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function qY(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function zxe(t, e, n) {
  return e && qY(t.prototype, e), n && qY(t, n), t;
}
function Hxe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && kB(t, e);
}
function kB(t, e) {
  return kB = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, kB(t, e);
}
function Wxe(t) {
  var e = jxe();
  return function() {
    var r = UR(t), a;
    if (e) {
      var i = UR(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return Qxe(this, a);
  };
}
function Qxe(t, e) {
  return e && (dk(e) === "object" || typeof e == "function") ? e : RB(t);
}
function RB(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function jxe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function UR(t) {
  return UR = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, UR(t);
}
function KY(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var Gxe = /* @__PURE__ */ function(t) {
  Hxe(n, t);
  var e = Wxe(n);
  function n() {
    var r;
    Uxe(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), KY(RB(r), "priority", 40), KY(RB(r), "incompatibleTokens", "*"), r;
  }
  return zxe(n, [{
    key: "parse",
    value: function(a) {
      return cre(a);
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return [new Date(o * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), n;
}(ha);
function pk(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? pk = function(n) {
    return typeof n;
  } : pk = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, pk(t);
}
function Vxe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function JY(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function Yxe(t, e, n) {
  return e && JY(t.prototype, e), n && JY(t, n), t;
}
function Zxe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && IB(t, e);
}
function IB(t, e) {
  return IB = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, IB(t, e);
}
function Xxe(t) {
  var e = Kxe();
  return function() {
    var r = zR(t), a;
    if (e) {
      var i = zR(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return qxe(this, a);
  };
}
function qxe(t, e) {
  return e && (pk(e) === "object" || typeof e == "function") ? e : DB(t);
}
function DB(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Kxe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function zR(t) {
  return zR = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, zR(t);
}
function eZ(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var Jxe = /* @__PURE__ */ function(t) {
  Zxe(n, t);
  var e = Xxe(n);
  function n() {
    var r;
    Vxe(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), eZ(DB(r), "priority", 20), eZ(DB(r), "incompatibleTokens", "*"), r;
  }
  return Yxe(n, [{
    key: "parse",
    value: function(a) {
      return cre(a);
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return [new Date(o), {
        timestampIsSet: !0
      }];
    }
  }]), n;
}(ha), eAe = {
  G: new Jwe(),
  y: new sTe(),
  Y: new hTe(),
  R: new ETe(),
  u: new ATe(),
  Q: new LTe(),
  q: new HTe(),
  M: new ZTe(),
  L: new n_e(),
  w: new c_e(),
  I: new v_e(),
  d: new x_e(),
  D: new P_e(),
  E: new z_e(),
  e: new Y_e(),
  c: new tCe(),
  i: new uCe(),
  a: new gCe(),
  b: new wCe(),
  B: new RCe(),
  h: new FCe(),
  H: new QCe(),
  K: new qCe(),
  k: new axe(),
  m: new fxe(),
  s: new vxe(),
  S: new _xe(),
  X: new Dxe(),
  x: new Bxe(),
  t: new Gxe(),
  T: new Jxe()
};
function hk(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? hk = function(n) {
    return typeof n;
  } : hk = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, hk(t);
}
function tZ(t, e) {
  var n;
  if (typeof Symbol > "u" || t[Symbol.iterator] == null) {
    if (Array.isArray(t) || (n = tAe(t)) || e && t && typeof t.length == "number") {
      n && (t = n);
      var r = 0, a = function() {
      };
      return { s: a, n: function() {
        return r >= t.length ? { done: !0 } : { done: !1, value: t[r++] };
      }, e: function(f) {
        throw f;
      }, f: a };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i = !0, o = !1, s;
  return { s: function() {
    n = t[Symbol.iterator]();
  }, n: function() {
    var f = n.next();
    return i = f.done, f;
  }, e: function(f) {
    o = !0, s = f;
  }, f: function() {
    try {
      !i && n.return != null && n.return();
    } finally {
      if (o)
        throw s;
    }
  } };
}
function tAe(t, e) {
  if (t) {
    if (typeof t == "string")
      return nZ(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return nZ(t, e);
  }
}
function nZ(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
var nAe = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, rAe = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, aAe = /^'([^]*?)'?$/, iAe = /''/g, oAe = /\S/, sAe = /[a-zA-Z]/;
function pre(t, e, n, r) {
  var a, i, o, s, u, f, p, m, v, O, w, _, C, A, N, P, I, D;
  Kt(3, arguments);
  var M = String(t), H = String(e), Y = uv(), q = (a = (i = r == null ? void 0 : r.locale) !== null && i !== void 0 ? i : Y.locale) !== null && a !== void 0 ? a : cU;
  if (!q.match)
    throw new RangeError("locale must contain match property");
  var Q = xr((o = (s = (u = (f = r == null ? void 0 : r.firstWeekContainsDate) !== null && f !== void 0 ? f : r == null || (p = r.locale) === null || p === void 0 || (m = p.options) === null || m === void 0 ? void 0 : m.firstWeekContainsDate) !== null && u !== void 0 ? u : Y.firstWeekContainsDate) !== null && s !== void 0 ? s : (v = Y.locale) === null || v === void 0 || (O = v.options) === null || O === void 0 ? void 0 : O.firstWeekContainsDate) !== null && o !== void 0 ? o : 1);
  if (!(Q >= 1 && Q <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var ne = xr((w = (_ = (C = (A = r == null ? void 0 : r.weekStartsOn) !== null && A !== void 0 ? A : r == null || (N = r.locale) === null || N === void 0 || (P = N.options) === null || P === void 0 ? void 0 : P.weekStartsOn) !== null && C !== void 0 ? C : Y.weekStartsOn) !== null && _ !== void 0 ? _ : (I = Y.locale) === null || I === void 0 || (D = I.options) === null || D === void 0 ? void 0 : D.weekStartsOn) !== null && w !== void 0 ? w : 0);
  if (!(ne >= 0 && ne <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (H === "")
    return M === "" ? an(n) : /* @__PURE__ */ new Date(NaN);
  var J = {
    firstWeekContainsDate: Q,
    weekStartsOn: ne,
    locale: q
  }, ue = [new Qwe()], ee = H.match(rAe).map(function(he) {
    var Ae = he[0];
    if (Ae in b$) {
      var Te = b$[Ae];
      return Te(he, q.formatLong);
    }
    return he;
  }).join("").match(nAe), fe = [], de = tZ(ee), ie;
  try {
    var le = function() {
      var Ae = ie.value;
      !(r != null && r.useAdditionalWeekYearTokens) && tre(Ae) && iR(Ae, H, t), !(r != null && r.useAdditionalDayOfYearTokens) && ere(Ae) && iR(Ae, H, t);
      var Te = Ae[0], je = eAe[Te];
      if (je) {
        var we = je.incompatibleTokens;
        if (Array.isArray(we)) {
          var lt = fe.find(function(Oe) {
            return we.includes(Oe.token) || Oe.token === Te;
          });
          if (lt)
            throw new RangeError("The format string mustn't contain `".concat(lt.fullToken, "` and `").concat(Ae, "` at the same time"));
        } else if (je.incompatibleTokens === "*" && fe.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(Ae, "` and any other token at the same time"));
        fe.push({
          token: Te,
          fullToken: Ae
        });
        var st = je.run(M, Ae, q.match, J);
        if (!st)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        ue.push(st.setter), M = st.rest;
      } else {
        if (Te.match(sAe))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + Te + "`");
        if (Ae === "''" ? Ae = "'" : Te === "'" && (Ae = lAe(Ae)), M.indexOf(Ae) === 0)
          M = M.slice(Ae.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (de.s(); !(ie = de.n()).done; ) {
      var ye = le();
      if (hk(ye) === "object")
        return ye.v;
    }
  } catch (he) {
    de.e(he);
  } finally {
    de.f();
  }
  if (M.length > 0 && oAe.test(M))
    return /* @__PURE__ */ new Date(NaN);
  var B = ue.map(function(he) {
    return he.priority;
  }).sort(function(he, Ae) {
    return Ae - he;
  }).filter(function(he, Ae, Te) {
    return Te.indexOf(he) === Ae;
  }).map(function(he) {
    return ue.filter(function(Ae) {
      return Ae.priority === he;
    }).sort(function(Ae, Te) {
      return Te.subPriority - Ae.subPriority;
    });
  }).map(function(he) {
    return he[0];
  }), pe = an(n);
  if (isNaN(pe.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var _e = Zne(pe, aR(pe)), Z = {}, ce = tZ(B), j;
  try {
    for (ce.s(); !(j = ce.n()).done; ) {
      var K = j.value;
      if (!K.validate(_e, J))
        return /* @__PURE__ */ new Date(NaN);
      var Ee = K.set(_e, Z, J);
      Array.isArray(Ee) ? (_e = Ee[0], Bwe(Z, Ee[1])) : _e = Ee;
    }
  } catch (he) {
    ce.e(he);
  } finally {
    ce.f();
  }
  return _e;
}
function lAe(t) {
  return t.match(aAe)[1].replace(iAe, "'");
}
const uAe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: pre
}, Symbol.toStringTag, { value: "Module" }));
function cAe(t, e) {
  var n;
  Kt(1, arguments);
  var r = xr((n = e == null ? void 0 : e.additionalDigits) !== null && n !== void 0 ? n : 2);
  if (r !== 2 && r !== 1 && r !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (!(typeof t == "string" || Object.prototype.toString.call(t) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var a = hAe(t), i;
  if (a.date) {
    var o = mAe(a.date, r);
    i = gAe(o.restDateString, o.year);
  }
  if (!i || isNaN(i.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var s = i.getTime(), u = 0, f;
  if (a.time && (u = bAe(a.time), isNaN(u)))
    return /* @__PURE__ */ new Date(NaN);
  if (a.timezone) {
    if (f = vAe(a.timezone), isNaN(f))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    var p = new Date(s + u), m = /* @__PURE__ */ new Date(0);
    return m.setFullYear(p.getUTCFullYear(), p.getUTCMonth(), p.getUTCDate()), m.setHours(p.getUTCHours(), p.getUTCMinutes(), p.getUTCSeconds(), p.getUTCMilliseconds()), m;
  }
  return new Date(s + u + f);
}
var Ix = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, fAe = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, dAe = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, pAe = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function hAe(t) {
  var e = {}, n = t.split(Ix.dateTimeDelimiter), r;
  if (n.length > 2)
    return e;
  if (/:/.test(n[0]) ? r = n[0] : (e.date = n[0], r = n[1], Ix.timeZoneDelimiter.test(e.date) && (e.date = t.split(Ix.timeZoneDelimiter)[0], r = t.substr(e.date.length, t.length))), r) {
    var a = Ix.timezone.exec(r);
    a ? (e.time = r.replace(a[1], ""), e.timezone = a[1]) : e.time = r;
  }
  return e;
}
function mAe(t, e) {
  var n = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + e) + "})|(\\d{2}|[+-]\\d{" + (2 + e) + "})$)"), r = t.match(n);
  if (!r)
    return {
      year: NaN,
      restDateString: ""
    };
  var a = r[1] ? parseInt(r[1]) : null, i = r[2] ? parseInt(r[2]) : null;
  return {
    year: i === null ? a : i * 100,
    restDateString: t.slice((r[1] || r[2]).length)
  };
}
function gAe(t, e) {
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  var n = t.match(fAe);
  if (!n)
    return /* @__PURE__ */ new Date(NaN);
  var r = !!n[4], a = mw(n[1]), i = mw(n[2]) - 1, o = mw(n[3]), s = mw(n[4]), u = mw(n[5]) - 1;
  if (r)
    return wAe(e, s, u) ? yAe(e, s, u) : /* @__PURE__ */ new Date(NaN);
  var f = /* @__PURE__ */ new Date(0);
  return !EAe(e, i, o) || !SAe(e, a) ? /* @__PURE__ */ new Date(NaN) : (f.setUTCFullYear(e, i, Math.max(a, o)), f);
}
function mw(t) {
  return t ? parseInt(t) : 1;
}
function bAe(t) {
  var e = t.match(dAe);
  if (!e)
    return NaN;
  var n = HM(e[1]), r = HM(e[2]), a = HM(e[3]);
  return TAe(n, r, a) ? n * bU + r * gU + a * 1e3 : NaN;
}
function HM(t) {
  return t && parseFloat(t.replace(",", ".")) || 0;
}
function vAe(t) {
  if (t === "Z")
    return 0;
  var e = t.match(pAe);
  if (!e)
    return 0;
  var n = e[1] === "+" ? -1 : 1, r = parseInt(e[2]), a = e[3] && parseInt(e[3]) || 0;
  return _Ae(r, a) ? n * (r * bU + a * gU) : NaN;
}
function yAe(t, e, n) {
  var r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(t, 0, 4);
  var a = r.getUTCDay() || 7, i = (e - 1) * 7 + n + 1 - a;
  return r.setUTCDate(r.getUTCDate() + i), r;
}
var OAe = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function hre(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function EAe(t, e, n) {
  return e >= 0 && e <= 11 && n >= 1 && n <= (OAe[e] || (hre(t) ? 29 : 28));
}
function SAe(t, e) {
  return e >= 1 && e <= (hre(t) ? 366 : 365);
}
function wAe(t, e, n) {
  return e >= 1 && e <= 53 && n >= 0 && n <= 6;
}
function TAe(t, e, n) {
  return t === 24 ? e === 0 && n === 0 : n >= 0 && n < 60 && e >= 0 && e < 60 && t >= 0 && t < 25;
}
function _Ae(t, e) {
  return e >= 0 && e <= 59;
}
function CAe(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, NB(t, e);
}
function NB(t, e) {
  return NB = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, NB(t, e);
}
function xAe(t, e) {
  if (t == null)
    return {};
  var n = {}, r = Object.keys(t), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(e.indexOf(a) >= 0) && (n[a] = t[a]);
  return n;
}
function rZ(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function AAe(t, e, n) {
  return t === e ? !0 : t.correspondingElement ? t.correspondingElement.classList.contains(n) : t.classList.contains(n);
}
function kAe(t, e, n) {
  if (t === e)
    return !0;
  for (; t.parentNode || t.host; ) {
    if (t.parentNode && AAe(t, e, n))
      return !0;
    t = t.parentNode || t.host;
  }
  return t;
}
function RAe(t) {
  return document.documentElement.clientWidth <= t.clientX || document.documentElement.clientHeight <= t.clientY;
}
var IAe = function() {
  if (!(typeof window > "u" || typeof window.addEventListener != "function")) {
    var e = !1, n = Object.defineProperty({}, "passive", {
      get: function() {
        e = !0;
      }
    }), r = function() {
    };
    return window.addEventListener("testPassiveEventSupport", r, n), window.removeEventListener("testPassiveEventSupport", r, n), e;
  }
};
function DAe(t) {
  return t === void 0 && (t = 0), function() {
    return ++t;
  };
}
var NAe = DAe(), PB, Dx = {}, WM = {}, PAe = ["touchstart", "touchmove"], LAe = "ignore-react-onclickoutside";
function aZ(t, e) {
  var n = null, r = PAe.indexOf(e) !== -1;
  return r && PB && (n = {
    passive: !t.props.preventDefault
  }), n;
}
function eD(t, e) {
  var n, r, a = t.displayName || t.name || "Component";
  return r = n = /* @__PURE__ */ function(i) {
    CAe(o, i);
    function o(u) {
      var f;
      return f = i.call(this, u) || this, f.__outsideClickHandler = function(p) {
        if (typeof f.__clickOutsideHandlerProp == "function") {
          f.__clickOutsideHandlerProp(p);
          return;
        }
        var m = f.getInstance();
        if (typeof m.props.handleClickOutside == "function") {
          m.props.handleClickOutside(p);
          return;
        }
        if (typeof m.handleClickOutside == "function") {
          m.handleClickOutside(p);
          return;
        }
        throw new Error("WrappedComponent: " + a + " lacks a handleClickOutside(event) function for processing outside click events.");
      }, f.__getComponentNode = function() {
        var p = f.getInstance();
        return e && typeof e.setClickOutsideRef == "function" ? e.setClickOutsideRef()(p) : typeof p.setClickOutsideRef == "function" ? p.setClickOutsideRef() : d_.findDOMNode(p);
      }, f.enableOnClickOutside = function() {
        if (!(typeof document > "u" || WM[f._uid])) {
          typeof PB > "u" && (PB = IAe()), WM[f._uid] = !0;
          var p = f.props.eventTypes;
          p.forEach || (p = [p]), Dx[f._uid] = function(m) {
            if (f.componentNode !== null && (f.props.preventDefault && m.preventDefault(), f.props.stopPropagation && m.stopPropagation(), !(f.props.excludeScrollbar && RAe(m)))) {
              var v = m.composed && m.composedPath && m.composedPath().shift() || m.target;
              kAe(v, f.componentNode, f.props.outsideClickIgnoreClass) === document && f.__outsideClickHandler(m);
            }
          }, p.forEach(function(m) {
            document.addEventListener(m, Dx[f._uid], aZ(rZ(f), m));
          });
        }
      }, f.disableOnClickOutside = function() {
        delete WM[f._uid];
        var p = Dx[f._uid];
        if (p && typeof document < "u") {
          var m = f.props.eventTypes;
          m.forEach || (m = [m]), m.forEach(function(v) {
            return document.removeEventListener(v, p, aZ(rZ(f), v));
          }), delete Dx[f._uid];
        }
      }, f.getRef = function(p) {
        return f.instanceRef = p;
      }, f._uid = NAe(), f;
    }
    var s = o.prototype;
    return s.getInstance = function() {
      if (t.prototype && !t.prototype.isReactComponent)
        return this;
      var f = this.instanceRef;
      return f.getInstance ? f.getInstance() : f;
    }, s.componentDidMount = function() {
      if (!(typeof document > "u" || !document.createElement)) {
        var f = this.getInstance();
        if (e && typeof e.handleClickOutside == "function" && (this.__clickOutsideHandlerProp = e.handleClickOutside(f), typeof this.__clickOutsideHandlerProp != "function"))
          throw new Error("WrappedComponent: " + a + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        this.componentNode = this.__getComponentNode(), !this.props.disableOnClickOutside && this.enableOnClickOutside();
      }
    }, s.componentDidUpdate = function() {
      this.componentNode = this.__getComponentNode();
    }, s.componentWillUnmount = function() {
      this.disableOnClickOutside();
    }, s.render = function() {
      var f = this.props;
      f.excludeScrollbar;
      var p = xAe(f, ["excludeScrollbar"]);
      return t.prototype && t.prototype.isReactComponent ? p.ref = this.getRef : p.wrappedRef = this.getRef, p.disableOnClickOutside = this.disableOnClickOutside, p.enableOnClickOutside = this.enableOnClickOutside, fu(t, p);
    }, o;
  }(Qee), n.displayName = "OnClickOutside(" + a + ")", n.defaultProps = {
    eventTypes: ["mousedown", "touchstart"],
    excludeScrollbar: e && e.excludeScrollbar || !1,
    outsideClickIgnoreClass: LAe,
    preventDefault: !1,
    stopPropagation: !1
  }, n.getClass = function() {
    return t.getClass ? t.getClass() : t;
  }, r;
}
var mre = On.createContext(), gre = On.createContext();
function MAe(t) {
  var e = t.children, n = On.useState(null), r = n[0], a = n[1], i = On.useRef(!1);
  On.useEffect(function() {
    return function() {
      i.current = !0;
    };
  }, []);
  var o = On.useCallback(function(s) {
    i.current || a(s);
  }, []);
  return /* @__PURE__ */ On.createElement(mre.Provider, {
    value: r
  }, /* @__PURE__ */ On.createElement(gre.Provider, {
    value: o
  }, e));
}
var bre = function(e) {
  return Array.isArray(e) ? e[0] : e;
}, vre = function(e) {
  if (typeof e == "function") {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++)
      r[a - 1] = arguments[a];
    return e.apply(void 0, r);
  }
}, LB = function(e, n) {
  if (typeof e == "function")
    return vre(e, n);
  e != null && (e.current = n);
}, iZ = function(e) {
  return e.reduce(function(n, r) {
    var a = r[0], i = r[1];
    return n[a] = i, n;
  }, {});
}, oZ = typeof window < "u" && window.document && window.document.createElement ? On.useLayoutEffect : On.useEffect, FAe = typeof Element < "u", $Ae = typeof Map == "function", BAe = typeof Set == "function", UAe = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function mk(t, e) {
  if (t === e)
    return !0;
  if (t && e && typeof t == "object" && typeof e == "object") {
    if (t.constructor !== e.constructor)
      return !1;
    var n, r, a;
    if (Array.isArray(t)) {
      if (n = t.length, n != e.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!mk(t[r], e[r]))
          return !1;
      return !0;
    }
    var i;
    if ($Ae && t instanceof Map && e instanceof Map) {
      if (t.size !== e.size)
        return !1;
      for (i = t.entries(); !(r = i.next()).done; )
        if (!e.has(r.value[0]))
          return !1;
      for (i = t.entries(); !(r = i.next()).done; )
        if (!mk(r.value[1], e.get(r.value[0])))
          return !1;
      return !0;
    }
    if (BAe && t instanceof Set && e instanceof Set) {
      if (t.size !== e.size)
        return !1;
      for (i = t.entries(); !(r = i.next()).done; )
        if (!e.has(r.value[0]))
          return !1;
      return !0;
    }
    if (UAe && ArrayBuffer.isView(t) && ArrayBuffer.isView(e)) {
      if (n = t.length, n != e.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (t[r] !== e[r])
          return !1;
      return !0;
    }
    if (t.constructor === RegExp)
      return t.source === e.source && t.flags === e.flags;
    if (t.valueOf !== Object.prototype.valueOf)
      return t.valueOf() === e.valueOf();
    if (t.toString !== Object.prototype.toString)
      return t.toString() === e.toString();
    if (a = Object.keys(t), n = a.length, n !== Object.keys(e).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(e, a[r]))
        return !1;
    if (FAe && t instanceof Element)
      return !1;
    for (r = n; r-- !== 0; )
      if (!((a[r] === "_owner" || a[r] === "__v" || a[r] === "__o") && t.$$typeof) && !mk(t[a[r]], e[a[r]]))
        return !1;
    return !0;
  }
  return t !== t && e !== e;
}
var zAe = function(e, n) {
  try {
    return mk(e, n);
  } catch (r) {
    if ((r.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw r;
  }
};
const HAe = /* @__PURE__ */ Pl(zAe);
var WAe = [], QAe = function(e, n, r) {
  r === void 0 && (r = {});
  var a = On.useRef(null), i = {
    onFirstUpdate: r.onFirstUpdate,
    placement: r.placement || "bottom",
    strategy: r.strategy || "absolute",
    modifiers: r.modifiers || WAe
  }, o = On.useState({
    styles: {
      popper: {
        position: i.strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), s = o[0], u = o[1], f = On.useMemo(function() {
    return {
      name: "updateState",
      enabled: !0,
      phase: "write",
      fn: function(O) {
        var w = O.state, _ = Object.keys(w.elements);
        d_.flushSync(function() {
          u({
            styles: iZ(_.map(function(C) {
              return [C, w.styles[C] || {}];
            })),
            attributes: iZ(_.map(function(C) {
              return [C, w.attributes[C]];
            }))
          });
        });
      },
      requires: ["computeStyles"]
    };
  }, []), p = On.useMemo(function() {
    var v = {
      onFirstUpdate: i.onFirstUpdate,
      placement: i.placement,
      strategy: i.strategy,
      modifiers: [].concat(i.modifiers, [f, {
        name: "applyStyles",
        enabled: !1
      }])
    };
    return HAe(a.current, v) ? a.current || v : (a.current = v, v);
  }, [i.onFirstUpdate, i.placement, i.strategy, i.modifiers, f]), m = On.useRef();
  return oZ(function() {
    m.current && m.current.setOptions(p);
  }, [p]), oZ(function() {
    if (!(e == null || n == null)) {
      var v = r.createPopper || ate, O = v(e, n, p);
      return m.current = O, function() {
        O.destroy(), m.current = null;
      };
    }
  }, [e, n, r.createPopper]), {
    state: m.current ? m.current.state : null,
    styles: s.styles,
    attributes: s.attributes,
    update: m.current ? m.current.update : null,
    forceUpdate: m.current ? m.current.forceUpdate : null
  };
}, jAe = function() {
}, GAe = function() {
  return Promise.resolve(null);
}, VAe = [];
function YAe(t) {
  var e = t.placement, n = e === void 0 ? "bottom" : e, r = t.strategy, a = r === void 0 ? "absolute" : r, i = t.modifiers, o = i === void 0 ? VAe : i, s = t.referenceElement, u = t.onFirstUpdate, f = t.innerRef, p = t.children, m = On.useContext(mre), v = On.useState(null), O = v[0], w = v[1], _ = On.useState(null), C = _[0], A = _[1];
  On.useEffect(function() {
    LB(f, O);
  }, [f, O]);
  var N = On.useMemo(function() {
    return {
      placement: n,
      strategy: a,
      onFirstUpdate: u,
      modifiers: [].concat(o, [{
        name: "arrow",
        enabled: C != null,
        options: {
          element: C
        }
      }])
    };
  }, [n, a, u, o, C]), P = QAe(s || m, O, N), I = P.state, D = P.styles, M = P.forceUpdate, H = P.update, Y = On.useMemo(function() {
    return {
      ref: w,
      style: D.popper,
      placement: I ? I.placement : n,
      hasPopperEscaped: I && I.modifiersData.hide ? I.modifiersData.hide.hasPopperEscaped : null,
      isReferenceHidden: I && I.modifiersData.hide ? I.modifiersData.hide.isReferenceHidden : null,
      arrowProps: {
        style: D.arrow,
        ref: A
      },
      forceUpdate: M || jAe,
      update: H || GAe
    };
  }, [w, A, n, I, D, H, M]);
  return bre(p)(Y);
}
var ZAe = process.env.NODE_ENV !== "production", yre = function() {
};
if (ZAe) {
  var XAe = function(e, n) {
    var r = arguments.length;
    n = new Array(r > 1 ? r - 1 : 0);
    for (var a = 1; a < r; a++)
      n[a - 1] = arguments[a];
    var i = 0, o = "Warning: " + e.replace(/%s/g, function() {
      return n[i++];
    });
    typeof console < "u" && console.error(o);
    try {
      throw new Error(o);
    } catch {
    }
  };
  yre = function(t, e, n) {
    var r = arguments.length;
    n = new Array(r > 2 ? r - 2 : 0);
    for (var a = 2; a < r; a++)
      n[a - 2] = arguments[a];
    if (e === void 0)
      throw new Error(
        "`warning(condition, format, ...args)` requires a warning message argument"
      );
    t || XAe.apply(null, [e].concat(n));
  };
}
var qAe = yre;
const KAe = /* @__PURE__ */ Pl(qAe);
function JAe(t) {
  var e = t.children, n = t.innerRef, r = On.useContext(gre), a = On.useCallback(function(i) {
    LB(n, i), vre(r, i);
  }, [n, r]);
  return On.useEffect(function() {
    return function() {
      return LB(n, null);
    };
  }, []), On.useEffect(function() {
    KAe(!!r, "`Reference` should not be used outside of a `Manager` component.");
  }, [r]), bre(e)({
    ref: a
  });
}
function gk(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? gk = function(n) {
    return typeof n;
  } : gk = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, gk(t);
}
function eke(t, e) {
  if (Kt(2, arguments), gk(e) !== "object" || e === null)
    throw new RangeError("values parameter must be an object");
  var n = an(t);
  return isNaN(n.getTime()) ? /* @__PURE__ */ new Date(NaN) : (e.year != null && n.setFullYear(e.year), e.month != null && (n = Bf(n, e.month)), e.date != null && n.setDate(xr(e.date)), e.hours != null && n.setHours(xr(e.hours)), e.minutes != null && n.setMinutes(xr(e.minutes)), e.seconds != null && n.setSeconds(xr(e.seconds)), e.milliseconds != null && n.setMilliseconds(xr(e.milliseconds)), n);
}
function sZ(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function lZ(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? sZ(Object(n), !0).forEach(function(r) {
      De(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : sZ(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function Ore(t) {
  return (Ore = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  })(t);
}
function vs(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function uZ(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, wre(r.key), r);
  }
}
function ys(t, e, n) {
  return e && uZ(t.prototype, e), n && uZ(t, n), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function De(t, e, n) {
  return (e = wre(e)) in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function tD() {
  return (tD = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }).apply(this, arguments);
}
function Os(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && Ere(t, e);
}
function MB(t) {
  return (MB = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(t);
}
function Ere(t, e) {
  return (Ere = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  })(t, e);
}
function Fe(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function tke(t, e) {
  if (e && (typeof e == "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Fe(t);
}
function Es(t) {
  var e = function() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }();
  return function() {
    var n, r = MB(t);
    if (e) {
      var a = MB(this).constructor;
      n = Reflect.construct(r, arguments, a);
    } else
      n = r.apply(this, arguments);
    return tke(this, n);
  };
}
function Sre(t) {
  return function(e) {
    if (Array.isArray(e))
      return QM(e);
  }(t) || function(e) {
    if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
      return Array.from(e);
  }(t) || function(e, n) {
    if (e) {
      if (typeof e == "string")
        return QM(e, n);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
        return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
        return QM(e, n);
    }
  }(t) || function() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function QM(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function wre(t) {
  var e = function(n, r) {
    if (typeof n != "object" || n === null)
      return n;
    var a = n[Symbol.toPrimitive];
    if (a !== void 0) {
      var i = a.call(n, r || "default");
      if (typeof i != "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(t, "string");
  return typeof e == "symbol" ? e : String(e);
}
function Xi(t) {
  var e = t ? typeof t == "string" || t instanceof String ? cAe(t) : an(t) : /* @__PURE__ */ new Date();
  return OU(e) ? e : null;
}
function nke(t, e, n, r, a) {
  var i = u0(n) || u0(FT()), o = Array.isArray(e) ? e : [e];
  a = a || Xi();
  for (var s = 0, u = o.length; s < u; s++) {
    var f = o[s], p = pre(t, f, a, { locale: i });
    if (OU(p) && (!r || t === Do(p, f, n)))
      return p;
  }
  return null;
}
function OU(t, e) {
  return e = e || /* @__PURE__ */ new Date("1/1/1000"), sU(t) && !Oh(t, e);
}
function Do(t, e, n) {
  if (n === "en")
    return NT(t, e, { awareOfUnicodeTokens: !0 });
  var r = u0(n) || u0(FT()) || null;
  return n && !r && console.warn('A locale object was not found for the provided string ["'.concat(n, '"].')), NT(t, e, { locale: r, awareOfUnicodeTokens: !0 });
}
function jM(t, e) {
  var n = e.dateFormat, r = e.locale;
  return t && Do(t, Array.isArray(n) ? n[0] : n, r) || "";
}
function cZ(t, e) {
  var n = e.hour, r = n === void 0 ? 0 : n, a = e.minute, i = a === void 0 ? 0 : a, o = e.second;
  return Zw(Yw(mwe(t, o === void 0 ? 0 : o), i), r);
}
function rke(t, e) {
  var n = e && u0(e) || FT() && u0(FT());
  return hwe(t, n ? { locale: n } : null);
}
function ake(t, e) {
  return Do(t, "ddd", e);
}
function ike(t) {
  return Gd(t);
}
function EU(t, e, n) {
  var r = u0(e || FT());
  return dU(t, { locale: r, weekStartsOn: n });
}
function n0(t) {
  return pU(t);
}
function Pw(t) {
  return nre(t);
}
function oke(t) {
  return w$(t);
}
function fZ() {
  return Gd(Xi());
}
function HR(t, e) {
  return t && e ? Pwe(t, e) : !t && !e;
}
function zb(t, e) {
  return t && e ? ore(t, e) : !t && !e;
}
function WR(t, e) {
  return t && e ? Lwe(t, e) : !t && !e;
}
function ou(t, e) {
  return t && e ? ire(t, e) : !t && !e;
}
function Hb(t, e) {
  return t && e ? are(t, e) : !t && !e;
}
function bk(t, e, n) {
  var r, a = Gd(e), i = lR(n);
  try {
    r = HE(t, { start: a, end: i });
  } catch {
    r = !1;
  }
  return r;
}
function FT() {
  return (typeof window < "u" ? window : globalThis).__localeId__;
}
function u0(t) {
  if (typeof t == "string") {
    var e = typeof window < "u" ? window : globalThis;
    return e.__localeData__ ? e.__localeData__[t] : null;
  }
  return t;
}
function Tre(t, e) {
  return Do(Bf(Xi(), t), "LLLL", e);
}
function _re(t, e) {
  return Do(Bf(Xi(), t), "LLL", e);
}
function ske(t, e) {
  return Do(Nw(Xi(), t), "QQQ", e);
}
function nD(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = e.minDate, r = e.maxDate, a = e.excludeDates, i = e.excludeDateIntervals, o = e.includeDates, s = e.includeDateIntervals, u = e.filterDate;
  return rD(t, { minDate: n, maxDate: r }) || a && a.some(function(f) {
    return ou(t, f);
  }) || i && i.some(function(f) {
    var p = f.start, m = f.end;
    return HE(t, { start: p, end: m });
  }) || o && !o.some(function(f) {
    return ou(t, f);
  }) || s && !s.some(function(f) {
    var p = f.start, m = f.end;
    return HE(t, { start: p, end: m });
  }) || u && !u(Xi(t)) || !1;
}
function SU(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = e.excludeDates, r = e.excludeDateIntervals;
  return r && r.length > 0 ? r.some(function(a) {
    var i = a.start, o = a.end;
    return HE(t, { start: i, end: o });
  }) : n && n.some(function(a) {
    return ou(t, a);
  }) || !1;
}
function Cre(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = e.minDate, r = e.maxDate, a = e.excludeDates, i = e.includeDates, o = e.filterDate;
  return rD(t, { minDate: pU(n), maxDate: rre(r) }) || a && a.some(function(s) {
    return zb(t, s);
  }) || i && !i.some(function(s) {
    return zb(t, s);
  }) || o && !o(Xi(t)) || !1;
}
function lke(t, e, n, r) {
  var a = sa(t), i = uu(t), o = sa(e), s = uu(e), u = sa(r);
  return a === o && a === u ? i <= n && n <= s : a < o ? u === a && i <= n || u === o && s >= n || u < o && u > a : void 0;
}
function uke(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = e.minDate, r = e.maxDate, a = e.excludeDates, i = e.includeDates, o = e.filterDate;
  return rD(t, { minDate: n, maxDate: r }) || a && a.some(function(s) {
    return WR(t, s);
  }) || i && !i.some(function(s) {
    return WR(t, s);
  }) || o && !o(Xi(t)) || !1;
}
function xre(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = e.minDate, r = e.maxDate, a = e.excludeDates, i = e.includeDates, o = e.filterDate, s = new Date(t, 0, 1);
  return rD(s, { minDate: nre(n), maxDate: Rwe(r) }) || a && a.some(function(u) {
    return HR(s, u);
  }) || i && !i.some(function(u) {
    return HR(s, u);
  }) || o && !o(Xi(s)) || !1;
}
function cke(t, e, n, r) {
  var a = sa(t), i = y$(t), o = sa(e), s = y$(e), u = sa(r);
  return a === o && a === u ? i <= n && n <= s : a < o ? u === a && i <= n || u === o && s >= n || u < o && u > a : void 0;
}
function rD(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = e.minDate, r = e.maxDate;
  return n && zE(t, n) < 0 || r && zE(t, r) > 0;
}
function dZ(t, e) {
  return e.some(function(n) {
    return Qf(n) === Qf(t) && Wf(n) === Wf(t);
  });
}
function pZ(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = e.excludeTimes, r = e.includeTimes, a = e.filterTime;
  return n && dZ(t, n) || r && !dZ(t, r) || a && !a(t) || !1;
}
function hZ(t, e) {
  var n = e.minTime, r = e.maxTime;
  if (!n || !r)
    throw new Error("Both minTime and maxTime props required");
  var a, i = Xi(), o = Zw(Yw(i, Wf(t)), Qf(t)), s = Zw(Yw(i, Wf(n)), Qf(n)), u = Zw(Yw(i, Wf(r)), Qf(r));
  try {
    a = !HE(o, { start: s, end: u });
  } catch {
    a = !1;
  }
  return a;
}
function mZ(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = e.minDate, r = e.includeDates, a = l0(t, 1);
  return n && MT(n, a) > 0 || r && r.every(function(i) {
    return MT(i, a) > 0;
  }) || !1;
}
function gZ(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = e.maxDate, r = e.includeDates, a = Zd(t, 1);
  return n && MT(a, n) > 0 || r && r.every(function(i) {
    return MT(a, i) > 0;
  }) || !1;
}
function bZ(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = e.minDate, r = e.includeDates, a = PT(t, 1);
  return n && sR(n, a) > 0 || r && r.every(function(i) {
    return sR(i, a) > 0;
  }) || !1;
}
function vZ(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = e.maxDate, r = e.includeDates, a = s0(t, 1);
  return n && sR(a, n) > 0 || r && r.every(function(i) {
    return sR(a, i) > 0;
  }) || !1;
}
function Are(t) {
  var e = t.minDate, n = t.includeDates;
  if (n && e) {
    var r = n.filter(function(a) {
      return zE(a, e) >= 0;
    });
    return E$(r);
  }
  return n ? E$(n) : e;
}
function kre(t) {
  var e = t.maxDate, n = t.includeDates;
  if (n && e) {
    var r = n.filter(function(a) {
      return zE(a, e) <= 0;
    });
    return S$(r);
  }
  return n ? S$(n) : e;
}
function yZ() {
  for (var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "react-datepicker__day--highlighted", n = /* @__PURE__ */ new Map(), r = 0, a = t.length; r < a; r++) {
    var i = t[r];
    if (oU(i)) {
      var o = Do(i, "MM.dd.yyyy"), s = n.get(o) || [];
      s.includes(e) || (s.push(e), n.set(o, s));
    } else if (Ore(i) === "object") {
      var u = Object.keys(i), f = u[0], p = i[u[0]];
      if (typeof f == "string" && p.constructor === Array)
        for (var m = 0, v = p.length; m < v; m++) {
          var O = Do(p[m], "MM.dd.yyyy"), w = n.get(O) || [];
          w.includes(f) || (w.push(f), n.set(O, w));
        }
    }
  }
  return n;
}
function fke(t, e, n, r, a) {
  for (var i = a.length, o = [], s = 0; s < i; s++) {
    var u = v$(nwe(t, Qf(a[s])), Wf(a[s])), f = v$(t, (n + 1) * r);
    Jm(u, e) && Oh(u, f) && o.push(a[s]);
  }
  return o;
}
function OZ(t) {
  return t < 10 ? "0".concat(t) : "".concat(t);
}
function Xw(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 12, n = Math.ceil(sa(t) / e) * e, r = n - (e - 1);
  return { startPeriod: r, endPeriod: n };
}
function dke(t, e, n, r) {
  for (var a = [], i = 0; i < 2 * e + 1; i++) {
    var o = t + e - i, s = !0;
    n && (s = sa(n) <= o), r && s && (s = sa(r) >= o), s && a.push(o);
  }
  return a;
}
var pke = eD(function(t) {
  Os(n, Ge.Component);
  var e = Es(n);
  function n(r) {
    var a;
    vs(this, n), De(Fe(a = e.call(this, r)), "renderOptions", function() {
      var u = a.props.year, f = a.state.yearsList.map(function(v) {
        return Ge.createElement("div", { className: u === v ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option", key: v, onClick: a.onChange.bind(Fe(a), v), "aria-selected": u === v ? "true" : void 0 }, u === v ? Ge.createElement("span", { className: "react-datepicker__year-option--selected" }, "✓") : "", v);
      }), p = a.props.minDate ? sa(a.props.minDate) : null, m = a.props.maxDate ? sa(a.props.maxDate) : null;
      return m && a.state.yearsList.find(function(v) {
        return v === m;
      }) || f.unshift(Ge.createElement("div", { className: "react-datepicker__year-option", key: "upcoming", onClick: a.incrementYears }, Ge.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" }))), p && a.state.yearsList.find(function(v) {
        return v === p;
      }) || f.push(Ge.createElement("div", { className: "react-datepicker__year-option", key: "previous", onClick: a.decrementYears }, Ge.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" }))), f;
    }), De(Fe(a), "onChange", function(u) {
      a.props.onChange(u);
    }), De(Fe(a), "handleClickOutside", function() {
      a.props.onCancel();
    }), De(Fe(a), "shiftYears", function(u) {
      var f = a.state.yearsList.map(function(p) {
        return p + u;
      });
      a.setState({ yearsList: f });
    }), De(Fe(a), "incrementYears", function() {
      return a.shiftYears(1);
    }), De(Fe(a), "decrementYears", function() {
      return a.shiftYears(-1);
    });
    var i = r.yearDropdownItemNumber, o = r.scrollableYearDropdown, s = i || (o ? 10 : 5);
    return a.state = { yearsList: dke(a.props.year, s, a.props.minDate, a.props.maxDate) }, a.dropdownRef = Cme(), a;
  }
  return ys(n, [{ key: "componentDidMount", value: function() {
    var r = this.dropdownRef.current;
    r && (r.scrollTop = r.scrollHeight / 2 - r.clientHeight / 2);
  } }, { key: "render", value: function() {
    var r = pn({ "react-datepicker__year-dropdown": !0, "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown });
    return Ge.createElement("div", { className: r, ref: this.dropdownRef }, this.renderOptions());
  } }]), n;
}()), hke = function(t) {
  Os(n, Ge.Component);
  var e = Es(n);
  function n() {
    var r;
    vs(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return De(Fe(r = e.call.apply(e, [this].concat(i))), "state", { dropdownVisible: !1 }), De(Fe(r), "renderSelectOptions", function() {
      for (var s = r.props.minDate ? sa(r.props.minDate) : 1900, u = r.props.maxDate ? sa(r.props.maxDate) : 2100, f = [], p = s; p <= u; p++)
        f.push(Ge.createElement("option", { key: p, value: p }, p));
      return f;
    }), De(Fe(r), "onSelectChange", function(s) {
      r.onChange(s.target.value);
    }), De(Fe(r), "renderSelectMode", function() {
      return Ge.createElement("select", { value: r.props.year, className: "react-datepicker__year-select", onChange: r.onSelectChange }, r.renderSelectOptions());
    }), De(Fe(r), "renderReadView", function(s) {
      return Ge.createElement("div", { key: "read", style: { visibility: s ? "visible" : "hidden" }, className: "react-datepicker__year-read-view", onClick: function(u) {
        return r.toggleDropdown(u);
      } }, Ge.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }), Ge.createElement("span", { className: "react-datepicker__year-read-view--selected-year" }, r.props.year));
    }), De(Fe(r), "renderDropdown", function() {
      return Ge.createElement(pke, { key: "dropdown", year: r.props.year, onChange: r.onChange, onCancel: r.toggleDropdown, minDate: r.props.minDate, maxDate: r.props.maxDate, scrollableYearDropdown: r.props.scrollableYearDropdown, yearDropdownItemNumber: r.props.yearDropdownItemNumber });
    }), De(Fe(r), "renderScrollMode", function() {
      var s = r.state.dropdownVisible, u = [r.renderReadView(!s)];
      return s && u.unshift(r.renderDropdown()), u;
    }), De(Fe(r), "onChange", function(s) {
      r.toggleDropdown(), s !== r.props.year && r.props.onChange(s);
    }), De(Fe(r), "toggleDropdown", function(s) {
      r.setState({ dropdownVisible: !r.state.dropdownVisible }, function() {
        r.props.adjustDateOnChange && r.handleYearChange(r.props.date, s);
      });
    }), De(Fe(r), "handleYearChange", function(s, u) {
      r.onSelect(s, u), r.setOpen();
    }), De(Fe(r), "onSelect", function(s, u) {
      r.props.onSelect && r.props.onSelect(s, u);
    }), De(Fe(r), "setOpen", function() {
      r.props.setOpen && r.props.setOpen(!0);
    }), r;
  }
  return ys(n, [{ key: "render", value: function() {
    var r;
    switch (this.props.dropdownMode) {
      case "scroll":
        r = this.renderScrollMode();
        break;
      case "select":
        r = this.renderSelectMode();
    }
    return Ge.createElement("div", { className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode) }, r);
  } }]), n;
}(), mke = eD(function(t) {
  Os(n, Ge.Component);
  var e = Es(n);
  function n() {
    var r;
    vs(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return De(Fe(r = e.call.apply(e, [this].concat(i))), "isSelectedMonth", function(s) {
      return r.props.month === s;
    }), De(Fe(r), "renderOptions", function() {
      return r.props.monthNames.map(function(s, u) {
        return Ge.createElement("div", { className: r.isSelectedMonth(u) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option", key: s, onClick: r.onChange.bind(Fe(r), u), "aria-selected": r.isSelectedMonth(u) ? "true" : void 0 }, r.isSelectedMonth(u) ? Ge.createElement("span", { className: "react-datepicker__month-option--selected" }, "✓") : "", s);
      });
    }), De(Fe(r), "onChange", function(s) {
      return r.props.onChange(s);
    }), De(Fe(r), "handleClickOutside", function() {
      return r.props.onCancel();
    }), r;
  }
  return ys(n, [{ key: "render", value: function() {
    return Ge.createElement("div", { className: "react-datepicker__month-dropdown" }, this.renderOptions());
  } }]), n;
}()), gke = function(t) {
  Os(n, Ge.Component);
  var e = Es(n);
  function n() {
    var r;
    vs(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return De(Fe(r = e.call.apply(e, [this].concat(i))), "state", { dropdownVisible: !1 }), De(Fe(r), "renderSelectOptions", function(s) {
      return s.map(function(u, f) {
        return Ge.createElement("option", { key: f, value: f }, u);
      });
    }), De(Fe(r), "renderSelectMode", function(s) {
      return Ge.createElement("select", { value: r.props.month, className: "react-datepicker__month-select", onChange: function(u) {
        return r.onChange(u.target.value);
      } }, r.renderSelectOptions(s));
    }), De(Fe(r), "renderReadView", function(s, u) {
      return Ge.createElement("div", { key: "read", style: { visibility: s ? "visible" : "hidden" }, className: "react-datepicker__month-read-view", onClick: r.toggleDropdown }, Ge.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }), Ge.createElement("span", { className: "react-datepicker__month-read-view--selected-month" }, u[r.props.month]));
    }), De(Fe(r), "renderDropdown", function(s) {
      return Ge.createElement(mke, { key: "dropdown", month: r.props.month, monthNames: s, onChange: r.onChange, onCancel: r.toggleDropdown });
    }), De(Fe(r), "renderScrollMode", function(s) {
      var u = r.state.dropdownVisible, f = [r.renderReadView(!u, s)];
      return u && f.unshift(r.renderDropdown(s)), f;
    }), De(Fe(r), "onChange", function(s) {
      r.toggleDropdown(), s !== r.props.month && r.props.onChange(s);
    }), De(Fe(r), "toggleDropdown", function() {
      return r.setState({ dropdownVisible: !r.state.dropdownVisible });
    }), r;
  }
  return ys(n, [{ key: "render", value: function() {
    var r, a = this, i = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function(o) {
      return _re(o, a.props.locale);
    } : function(o) {
      return Tre(o, a.props.locale);
    });
    switch (this.props.dropdownMode) {
      case "scroll":
        r = this.renderScrollMode(i);
        break;
      case "select":
        r = this.renderSelectMode(i);
    }
    return Ge.createElement("div", { className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode) }, r);
  } }]), n;
}();
function bke(t, e) {
  for (var n = [], r = n0(t), a = n0(e); !Jm(r, a); )
    n.push(Xi(r)), r = Zd(r, 1);
  return n;
}
var vke = eD(function(t) {
  Os(n, Ge.Component);
  var e = Es(n);
  function n(r) {
    var a;
    return vs(this, n), De(Fe(a = e.call(this, r)), "renderOptions", function() {
      return a.state.monthYearsList.map(function(i) {
        var o = O$(i), s = HR(a.props.date, i) && zb(a.props.date, i);
        return Ge.createElement("div", { className: s ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option", key: o, onClick: a.onChange.bind(Fe(a), o), "aria-selected": s ? "true" : void 0 }, s ? Ge.createElement("span", { className: "react-datepicker__month-year-option--selected" }, "✓") : "", Do(i, a.props.dateFormat, a.props.locale));
      });
    }), De(Fe(a), "onChange", function(i) {
      return a.props.onChange(i);
    }), De(Fe(a), "handleClickOutside", function() {
      a.props.onCancel();
    }), a.state = { monthYearsList: bke(a.props.minDate, a.props.maxDate) }, a;
  }
  return ys(n, [{ key: "render", value: function() {
    var r = pn({ "react-datepicker__month-year-dropdown": !0, "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown });
    return Ge.createElement("div", { className: r }, this.renderOptions());
  } }]), n;
}()), yke = function(t) {
  Os(n, Ge.Component);
  var e = Es(n);
  function n() {
    var r;
    vs(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return De(Fe(r = e.call.apply(e, [this].concat(i))), "state", { dropdownVisible: !1 }), De(Fe(r), "renderSelectOptions", function() {
      for (var s = n0(r.props.minDate), u = n0(r.props.maxDate), f = []; !Jm(s, u); ) {
        var p = O$(s);
        f.push(Ge.createElement("option", { key: p, value: p }, Do(s, r.props.dateFormat, r.props.locale))), s = Zd(s, 1);
      }
      return f;
    }), De(Fe(r), "onSelectChange", function(s) {
      r.onChange(s.target.value);
    }), De(Fe(r), "renderSelectMode", function() {
      return Ge.createElement("select", { value: O$(n0(r.props.date)), className: "react-datepicker__month-year-select", onChange: r.onSelectChange }, r.renderSelectOptions());
    }), De(Fe(r), "renderReadView", function(s) {
      var u = Do(r.props.date, r.props.dateFormat, r.props.locale);
      return Ge.createElement("div", { key: "read", style: { visibility: s ? "visible" : "hidden" }, className: "react-datepicker__month-year-read-view", onClick: function(f) {
        return r.toggleDropdown(f);
      } }, Ge.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }), Ge.createElement("span", { className: "react-datepicker__month-year-read-view--selected-month-year" }, u));
    }), De(Fe(r), "renderDropdown", function() {
      return Ge.createElement(vke, { key: "dropdown", date: r.props.date, dateFormat: r.props.dateFormat, onChange: r.onChange, onCancel: r.toggleDropdown, minDate: r.props.minDate, maxDate: r.props.maxDate, scrollableMonthYearDropdown: r.props.scrollableMonthYearDropdown, locale: r.props.locale });
    }), De(Fe(r), "renderScrollMode", function() {
      var s = r.state.dropdownVisible, u = [r.renderReadView(!s)];
      return s && u.unshift(r.renderDropdown()), u;
    }), De(Fe(r), "onChange", function(s) {
      r.toggleDropdown();
      var u = Xi(parseInt(s));
      HR(r.props.date, u) && zb(r.props.date, u) || r.props.onChange(u);
    }), De(Fe(r), "toggleDropdown", function() {
      return r.setState({ dropdownVisible: !r.state.dropdownVisible });
    }), r;
  }
  return ys(n, [{ key: "render", value: function() {
    var r;
    switch (this.props.dropdownMode) {
      case "scroll":
        r = this.renderScrollMode();
        break;
      case "select":
        r = this.renderSelectMode();
    }
    return Ge.createElement("div", { className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode) }, r);
  } }]), n;
}(), Oke = function(t) {
  Os(n, Ge.Component);
  var e = Es(n);
  function n() {
    var r;
    vs(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return De(Fe(r = e.call.apply(e, [this].concat(i))), "dayEl", Ge.createRef()), De(Fe(r), "handleClick", function(s) {
      !r.isDisabled() && r.props.onClick && r.props.onClick(s);
    }), De(Fe(r), "handleMouseEnter", function(s) {
      !r.isDisabled() && r.props.onMouseEnter && r.props.onMouseEnter(s);
    }), De(Fe(r), "handleOnKeyDown", function(s) {
      s.key === " " && (s.preventDefault(), s.key = "Enter"), r.props.handleOnKeyDown(s);
    }), De(Fe(r), "isSameDay", function(s) {
      return ou(r.props.day, s);
    }), De(Fe(r), "isKeyboardSelected", function() {
      return !r.props.disabledKeyboardNavigation && !r.isSameDay(r.props.selected) && r.isSameDay(r.props.preSelection);
    }), De(Fe(r), "isDisabled", function() {
      return nD(r.props.day, r.props);
    }), De(Fe(r), "isExcluded", function() {
      return SU(r.props.day, r.props);
    }), De(Fe(r), "getHighLightedClass", function(s) {
      var u = r.props, f = u.day, p = u.highlightDates;
      if (!p)
        return !1;
      var m = Do(f, "MM.dd.yyyy");
      return p.get(m);
    }), De(Fe(r), "isInRange", function() {
      var s = r.props, u = s.day, f = s.startDate, p = s.endDate;
      return !(!f || !p) && bk(u, f, p);
    }), De(Fe(r), "isInSelectingRange", function() {
      var s, u = r.props, f = u.day, p = u.selectsStart, m = u.selectsEnd, v = u.selectsRange, O = u.selectsDisabledDaysInRange, w = u.startDate, _ = u.endDate, C = (s = r.props.selectingDate) !== null && s !== void 0 ? s : r.props.preSelection;
      return !(!(p || m || v) || !C || !O && r.isDisabled()) && (p && _ && (Oh(C, _) || Hb(C, _)) ? bk(f, C, _) : (m && w && (Jm(C, w) || Hb(C, w)) || !(!v || !w || _ || !Jm(C, w) && !Hb(C, w))) && bk(f, w, C));
    }), De(Fe(r), "isSelectingRangeStart", function() {
      var s;
      if (!r.isInSelectingRange())
        return !1;
      var u = r.props, f = u.day, p = u.startDate, m = u.selectsStart, v = (s = r.props.selectingDate) !== null && s !== void 0 ? s : r.props.preSelection;
      return ou(f, m ? v : p);
    }), De(Fe(r), "isSelectingRangeEnd", function() {
      var s;
      if (!r.isInSelectingRange())
        return !1;
      var u = r.props, f = u.day, p = u.endDate, m = u.selectsEnd, v = u.selectsRange, O = (s = r.props.selectingDate) !== null && s !== void 0 ? s : r.props.preSelection;
      return ou(f, m || v ? O : p);
    }), De(Fe(r), "isRangeStart", function() {
      var s = r.props, u = s.day, f = s.startDate, p = s.endDate;
      return !(!f || !p) && ou(f, u);
    }), De(Fe(r), "isRangeEnd", function() {
      var s = r.props, u = s.day, f = s.startDate, p = s.endDate;
      return !(!f || !p) && ou(p, u);
    }), De(Fe(r), "isWeekend", function() {
      var s = uwe(r.props.day);
      return s === 0 || s === 6;
    }), De(Fe(r), "isAfterMonth", function() {
      return r.props.month !== void 0 && (r.props.month + 1) % 12 === uu(r.props.day);
    }), De(Fe(r), "isBeforeMonth", function() {
      return r.props.month !== void 0 && (uu(r.props.day) + 1) % 12 === r.props.month;
    }), De(Fe(r), "isCurrentDay", function() {
      return r.isSameDay(Xi());
    }), De(Fe(r), "isSelected", function() {
      return r.isSameDay(r.props.selected);
    }), De(Fe(r), "getClassNames", function(s) {
      var u = r.props.dayClassName ? r.props.dayClassName(s) : void 0;
      return pn("react-datepicker__day", u, "react-datepicker__day--" + ake(r.props.day), { "react-datepicker__day--disabled": r.isDisabled(), "react-datepicker__day--excluded": r.isExcluded(), "react-datepicker__day--selected": r.isSelected(), "react-datepicker__day--keyboard-selected": r.isKeyboardSelected(), "react-datepicker__day--range-start": r.isRangeStart(), "react-datepicker__day--range-end": r.isRangeEnd(), "react-datepicker__day--in-range": r.isInRange(), "react-datepicker__day--in-selecting-range": r.isInSelectingRange(), "react-datepicker__day--selecting-range-start": r.isSelectingRangeStart(), "react-datepicker__day--selecting-range-end": r.isSelectingRangeEnd(), "react-datepicker__day--today": r.isCurrentDay(), "react-datepicker__day--weekend": r.isWeekend(), "react-datepicker__day--outside-month": r.isAfterMonth() || r.isBeforeMonth() }, r.getHighLightedClass("react-datepicker__day--highlighted"));
    }), De(Fe(r), "getAriaLabel", function() {
      var s = r.props, u = s.day, f = s.ariaLabelPrefixWhenEnabled, p = f === void 0 ? "Choose" : f, m = s.ariaLabelPrefixWhenDisabled, v = m === void 0 ? "Not available" : m, O = r.isDisabled() || r.isExcluded() ? v : p;
      return "".concat(O, " ").concat(Do(u, "PPPP", r.props.locale));
    }), De(Fe(r), "getTabIndex", function(s, u) {
      var f = s || r.props.selected, p = u || r.props.preSelection;
      return r.isKeyboardSelected() || r.isSameDay(f) && ou(p, f) ? 0 : -1;
    }), De(Fe(r), "handleFocusDay", function() {
      var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, u = !1;
      r.getTabIndex() === 0 && !s.isInputFocused && r.isSameDay(r.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (u = !0), r.props.inline && !r.props.shouldFocusDayInline && (u = !1), r.props.containerRef && r.props.containerRef.current && r.props.containerRef.current.contains(document.activeElement) && document.activeElement.classList.contains("react-datepicker__day") && (u = !0)), u && r.dayEl.current.focus({ preventScroll: !0 });
    }), De(Fe(r), "renderDayContents", function() {
      return r.props.monthShowsDuplicateDaysEnd && r.isAfterMonth() || r.props.monthShowsDuplicateDaysStart && r.isBeforeMonth() ? null : r.props.renderDayContents ? r.props.renderDayContents(GV(r.props.day), r.props.day) : GV(r.props.day);
    }), De(Fe(r), "render", function() {
      return Ge.createElement("div", { ref: r.dayEl, className: r.getClassNames(r.props.day), onKeyDown: r.handleOnKeyDown, onClick: r.handleClick, onMouseEnter: r.handleMouseEnter, tabIndex: r.getTabIndex(), "aria-label": r.getAriaLabel(), role: "option", "aria-disabled": r.isDisabled(), "aria-current": r.isCurrentDay() ? "date" : void 0, "aria-selected": r.isSelected() }, r.renderDayContents());
    }), r;
  }
  return ys(n, [{ key: "componentDidMount", value: function() {
    this.handleFocusDay();
  } }, { key: "componentDidUpdate", value: function(r) {
    this.handleFocusDay(r);
  } }]), n;
}(), Eke = function(t) {
  Os(n, Ge.Component);
  var e = Es(n);
  function n() {
    var r;
    vs(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return De(Fe(r = e.call.apply(e, [this].concat(i))), "handleClick", function(s) {
      r.props.onClick && r.props.onClick(s);
    }), r;
  }
  return ys(n, [{ key: "render", value: function() {
    var r = this.props, a = r.weekNumber, i = r.ariaLabelPrefix, o = i === void 0 ? "week " : i, s = { "react-datepicker__week-number": !0, "react-datepicker__week-number--clickable": !!r.onClick };
    return Ge.createElement("div", { className: pn(s), "aria-label": "".concat(o, " ").concat(this.props.weekNumber), onClick: this.handleClick }, a);
  } }]), n;
}(), Ske = function(t) {
  Os(n, Ge.Component);
  var e = Es(n);
  function n() {
    var r;
    vs(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return De(Fe(r = e.call.apply(e, [this].concat(i))), "handleDayClick", function(s, u) {
      r.props.onDayClick && r.props.onDayClick(s, u);
    }), De(Fe(r), "handleDayMouseEnter", function(s) {
      r.props.onDayMouseEnter && r.props.onDayMouseEnter(s);
    }), De(Fe(r), "handleWeekClick", function(s, u, f) {
      typeof r.props.onWeekSelect == "function" && r.props.onWeekSelect(s, u, f), r.props.shouldCloseOnSelect && r.props.setOpen(!1);
    }), De(Fe(r), "formatWeekNumber", function(s) {
      return r.props.formatWeekNumber ? r.props.formatWeekNumber(s) : rke(s);
    }), De(Fe(r), "renderDays", function() {
      var s = EU(r.props.day, r.props.locale, r.props.calendarStartDay), u = [], f = r.formatWeekNumber(s);
      if (r.props.showWeekNumber) {
        var p = r.props.onWeekSelect ? r.handleWeekClick.bind(Fe(r), s, f) : void 0;
        u.push(Ge.createElement(Eke, { key: "W", weekNumber: f, onClick: p, ariaLabelPrefix: r.props.ariaLabelPrefix }));
      }
      return u.concat([0, 1, 2, 3, 4, 5, 6].map(function(m) {
        var v = _0(s, m);
        return Ge.createElement(Oke, { ariaLabelPrefixWhenEnabled: r.props.chooseDayAriaLabelPrefix, ariaLabelPrefixWhenDisabled: r.props.disabledDayAriaLabelPrefix, key: v.valueOf(), day: v, month: r.props.month, onClick: r.handleDayClick.bind(Fe(r), v), onMouseEnter: r.handleDayMouseEnter.bind(Fe(r), v), minDate: r.props.minDate, maxDate: r.props.maxDate, excludeDates: r.props.excludeDates, excludeDateIntervals: r.props.excludeDateIntervals, includeDates: r.props.includeDates, includeDateIntervals: r.props.includeDateIntervals, highlightDates: r.props.highlightDates, selectingDate: r.props.selectingDate, filterDate: r.props.filterDate, preSelection: r.props.preSelection, selected: r.props.selected, selectsStart: r.props.selectsStart, selectsEnd: r.props.selectsEnd, selectsRange: r.props.selectsRange, selectsDisabledDaysInRange: r.props.selectsDisabledDaysInRange, startDate: r.props.startDate, endDate: r.props.endDate, dayClassName: r.props.dayClassName, renderDayContents: r.props.renderDayContents, disabledKeyboardNavigation: r.props.disabledKeyboardNavigation, handleOnKeyDown: r.props.handleOnKeyDown, isInputFocused: r.props.isInputFocused, containerRef: r.props.containerRef, inline: r.props.inline, shouldFocusDayInline: r.props.shouldFocusDayInline, monthShowsDuplicateDaysEnd: r.props.monthShowsDuplicateDaysEnd, monthShowsDuplicateDaysStart: r.props.monthShowsDuplicateDaysStart, locale: r.props.locale });
      }));
    }), r;
  }
  return ys(n, [{ key: "render", value: function() {
    return Ge.createElement("div", { className: "react-datepicker__week" }, this.renderDays());
  } }], [{ key: "defaultProps", get: function() {
    return { shouldCloseOnSelect: !0 };
  } }]), n;
}(), wke = function(t) {
  Os(n, Ge.Component);
  var e = Es(n);
  function n() {
    var r;
    vs(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return De(Fe(r = e.call.apply(e, [this].concat(i))), "MONTH_REFS", Sre(Array(12)).map(function() {
      return Ge.createRef();
    })), De(Fe(r), "isDisabled", function(s) {
      return nD(s, r.props);
    }), De(Fe(r), "isExcluded", function(s) {
      return SU(s, r.props);
    }), De(Fe(r), "handleDayClick", function(s, u) {
      r.props.onDayClick && r.props.onDayClick(s, u, r.props.orderInDisplay);
    }), De(Fe(r), "handleDayMouseEnter", function(s) {
      r.props.onDayMouseEnter && r.props.onDayMouseEnter(s);
    }), De(Fe(r), "handleMouseLeave", function() {
      r.props.onMouseLeave && r.props.onMouseLeave();
    }), De(Fe(r), "isRangeStartMonth", function(s) {
      var u = r.props, f = u.day, p = u.startDate, m = u.endDate;
      return !(!p || !m) && zb(Bf(f, s), p);
    }), De(Fe(r), "isRangeStartQuarter", function(s) {
      var u = r.props, f = u.day, p = u.startDate, m = u.endDate;
      return !(!p || !m) && WR(Nw(f, s), p);
    }), De(Fe(r), "isRangeEndMonth", function(s) {
      var u = r.props, f = u.day, p = u.startDate, m = u.endDate;
      return !(!p || !m) && zb(Bf(f, s), m);
    }), De(Fe(r), "isRangeEndQuarter", function(s) {
      var u = r.props, f = u.day, p = u.startDate, m = u.endDate;
      return !(!p || !m) && WR(Nw(f, s), m);
    }), De(Fe(r), "isWeekInMonth", function(s) {
      var u = r.props.day, f = _0(s, 6);
      return zb(s, u) || zb(f, u);
    }), De(Fe(r), "isCurrentMonth", function(s, u) {
      return sa(s) === sa(Xi()) && u === uu(Xi());
    }), De(Fe(r), "isSelectedMonth", function(s, u, f) {
      return uu(s) === u && sa(s) === sa(f);
    }), De(Fe(r), "isSelectedQuarter", function(s, u, f) {
      return y$(s) === u && sa(s) === sa(f);
    }), De(Fe(r), "renderWeeks", function() {
      for (var s = [], u = r.props.fixedHeight, f = 0, p = !1, m = EU(n0(r.props.day), r.props.locale, r.props.calendarStartDay); s.push(Ge.createElement(Ske, { ariaLabelPrefix: r.props.weekAriaLabelPrefix, chooseDayAriaLabelPrefix: r.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: r.props.disabledDayAriaLabelPrefix, key: f, day: m, month: uu(r.props.day), onDayClick: r.handleDayClick, onDayMouseEnter: r.handleDayMouseEnter, onWeekSelect: r.props.onWeekSelect, formatWeekNumber: r.props.formatWeekNumber, locale: r.props.locale, minDate: r.props.minDate, maxDate: r.props.maxDate, excludeDates: r.props.excludeDates, excludeDateIntervals: r.props.excludeDateIntervals, includeDates: r.props.includeDates, includeDateIntervals: r.props.includeDateIntervals, inline: r.props.inline, shouldFocusDayInline: r.props.shouldFocusDayInline, highlightDates: r.props.highlightDates, selectingDate: r.props.selectingDate, filterDate: r.props.filterDate, preSelection: r.props.preSelection, selected: r.props.selected, selectsStart: r.props.selectsStart, selectsEnd: r.props.selectsEnd, selectsRange: r.props.selectsRange, selectsDisabledDaysInRange: r.props.selectsDisabledDaysInRange, showWeekNumber: r.props.showWeekNumbers, startDate: r.props.startDate, endDate: r.props.endDate, dayClassName: r.props.dayClassName, setOpen: r.props.setOpen, shouldCloseOnSelect: r.props.shouldCloseOnSelect, disabledKeyboardNavigation: r.props.disabledKeyboardNavigation, renderDayContents: r.props.renderDayContents, handleOnKeyDown: r.props.handleOnKeyDown, isInputFocused: r.props.isInputFocused, containerRef: r.props.containerRef, calendarStartDay: r.props.calendarStartDay, monthShowsDuplicateDaysEnd: r.props.monthShowsDuplicateDaysEnd, monthShowsDuplicateDaysStart: r.props.monthShowsDuplicateDaysStart })), !p; ) {
        f++, m = fU(m, 1);
        var v = u && f >= 6, O = !u && !r.isWeekInMonth(m);
        if (v || O) {
          if (!r.props.peekNextMonth)
            break;
          p = !0;
        }
      }
      return s;
    }), De(Fe(r), "onMonthClick", function(s, u) {
      r.handleDayClick(n0(Bf(r.props.day, u)), s);
    }), De(Fe(r), "handleMonthNavigation", function(s, u) {
      r.isDisabled(u) || r.isExcluded(u) || (r.props.setPreSelection(u), r.MONTH_REFS[s].current && r.MONTH_REFS[s].current.focus());
    }), De(Fe(r), "onMonthKeyDown", function(s, u) {
      s.preventDefault();
      var f = s.key;
      if (!r.props.disabledKeyboardNavigation)
        switch (f) {
          case "Enter":
            r.onMonthClick(s, u), r.props.setPreSelection(r.props.selected);
            break;
          case "ArrowRight":
            r.handleMonthNavigation(u === 11 ? 0 : u + 1, Zd(r.props.preSelection, 1));
            break;
          case "ArrowLeft":
            r.handleMonthNavigation(u === 0 ? 11 : u - 1, l0(r.props.preSelection, 1));
            break;
          case "ArrowUp":
            r.handleMonthNavigation(u >= 0 && u <= 2 ? u + 9 : u - 3, l0(r.props.preSelection, 3));
            break;
          case "ArrowDown":
            r.handleMonthNavigation(u >= 9 && u <= 11 ? u - 9 : u + 3, Zd(r.props.preSelection, 3));
        }
    }), De(Fe(r), "onQuarterClick", function(s, u) {
      r.handleDayClick(oke(Nw(r.props.day, u)), s);
    }), De(Fe(r), "getMonthClassNames", function(s) {
      var u = r.props, f = u.day, p = u.startDate, m = u.endDate, v = u.selected, O = u.minDate, w = u.maxDate, _ = u.preSelection, C = u.monthClassName, A = u.excludeDates, N = u.includeDates, P = C ? C(f) : void 0, I = Bf(f, s);
      return pn("react-datepicker__month-text", "react-datepicker__month-".concat(s), P, { "react-datepicker__month--disabled": (O || w || A || N) && Cre(I, r.props), "react-datepicker__month--selected": r.isSelectedMonth(f, s, v), "react-datepicker__month-text--keyboard-selected": !r.props.disabledKeyboardNavigation && uu(_) === s, "react-datepicker__month--in-range": lke(p, m, s, f), "react-datepicker__month--range-start": r.isRangeStartMonth(s), "react-datepicker__month--range-end": r.isRangeEndMonth(s), "react-datepicker__month-text--today": r.isCurrentMonth(f, s) });
    }), De(Fe(r), "getTabIndex", function(s) {
      var u = uu(r.props.preSelection);
      return r.props.disabledKeyboardNavigation || s !== u ? "-1" : "0";
    }), De(Fe(r), "getAriaLabel", function(s) {
      var u = r.props, f = u.chooseDayAriaLabelPrefix, p = f === void 0 ? "Choose" : f, m = u.disabledDayAriaLabelPrefix, v = m === void 0 ? "Not available" : m, O = u.day, w = Bf(O, s), _ = r.isDisabled(w) || r.isExcluded(w) ? v : p;
      return "".concat(_, " ").concat(Do(w, "MMMM yyyy"));
    }), De(Fe(r), "getQuarterClassNames", function(s) {
      var u = r.props, f = u.day, p = u.startDate, m = u.endDate, v = u.selected, O = u.minDate, w = u.maxDate;
      return pn("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(s), { "react-datepicker__quarter--disabled": (O || w) && uke(Nw(f, s), r.props), "react-datepicker__quarter--selected": r.isSelectedQuarter(f, s, v), "react-datepicker__quarter--in-range": cke(p, m, s, f), "react-datepicker__quarter--range-start": r.isRangeStartQuarter(s), "react-datepicker__quarter--range-end": r.isRangeEndQuarter(s) });
    }), De(Fe(r), "renderMonths", function() {
      var s = r.props, u = s.showFullMonthYearPicker, f = s.showTwoColumnMonthYearPicker, p = s.showFourColumnMonthYearPicker, m = s.locale, v = s.day, O = s.selected;
      return (p ? [[0, 1, 2, 3], [4, 5, 6, 7], [8, 9, 10, 11]] : f ? [[0, 1], [2, 3], [4, 5], [6, 7], [8, 9], [10, 11]] : [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11]]).map(function(w, _) {
        return Ge.createElement("div", { className: "react-datepicker__month-wrapper", key: _ }, w.map(function(C, A) {
          return Ge.createElement("div", { ref: r.MONTH_REFS[C], key: A, onClick: function(N) {
            r.onMonthClick(N, C);
          }, onKeyDown: function(N) {
            r.onMonthKeyDown(N, C);
          }, tabIndex: r.getTabIndex(C), className: r.getMonthClassNames(C), role: "option", "aria-label": r.getAriaLabel(C), "aria-current": r.isCurrentMonth(v, C) ? "date" : void 0, "aria-selected": r.isSelectedMonth(v, C, O) }, u ? Tre(C, m) : _re(C, m));
        }));
      });
    }), De(Fe(r), "renderQuarters", function() {
      var s = r.props, u = s.day, f = s.selected;
      return Ge.createElement("div", { className: "react-datepicker__quarter-wrapper" }, [1, 2, 3, 4].map(function(p, m) {
        return Ge.createElement("div", { key: m, role: "option", onClick: function(v) {
          r.onQuarterClick(v, p);
        }, className: r.getQuarterClassNames(p), "aria-selected": r.isSelectedQuarter(u, p, f) }, ske(p, r.props.locale));
      }));
    }), De(Fe(r), "getClassNames", function() {
      var s = r.props;
      s.day;
      var u = s.selectingDate, f = s.selectsStart, p = s.selectsEnd, m = s.showMonthYearPicker, v = s.showQuarterYearPicker;
      return pn("react-datepicker__month", { "react-datepicker__month--selecting-range": u && (f || p) }, { "react-datepicker__monthPicker": m }, { "react-datepicker__quarterPicker": v });
    }), r;
  }
  return ys(n, [{ key: "render", value: function() {
    var r = this.props, a = r.showMonthYearPicker, i = r.showQuarterYearPicker, o = r.day, s = r.ariaLabelPrefix, u = s === void 0 ? "month " : s;
    return Ge.createElement("div", { className: this.getClassNames(), onMouseLeave: this.handleMouseLeave, "aria-label": "".concat(u, " ").concat(Do(o, "yyyy-MM")), role: "listbox" }, a ? this.renderMonths() : i ? this.renderQuarters() : this.renderWeeks());
  } }]), n;
}(), Rre = function(t) {
  Os(n, Ge.Component);
  var e = Es(n);
  function n() {
    var r;
    vs(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return De(Fe(r = e.call.apply(e, [this].concat(i))), "state", { height: null }), De(Fe(r), "handleClick", function(s) {
      (r.props.minTime || r.props.maxTime) && hZ(s, r.props) || (r.props.excludeTimes || r.props.includeTimes || r.props.filterTime) && pZ(s, r.props) || r.props.onChange(s);
    }), De(Fe(r), "isSelectedTime", function(s, u, f) {
      return r.props.selected && u === Qf(s) && f === Wf(s);
    }), De(Fe(r), "liClasses", function(s, u, f) {
      var p = ["react-datepicker__time-list-item", r.props.timeClassName ? r.props.timeClassName(s, u, f) : void 0];
      return r.isSelectedTime(s, u, f) && p.push("react-datepicker__time-list-item--selected"), ((r.props.minTime || r.props.maxTime) && hZ(s, r.props) || (r.props.excludeTimes || r.props.includeTimes || r.props.filterTime) && pZ(s, r.props)) && p.push("react-datepicker__time-list-item--disabled"), r.props.injectTimes && (60 * Qf(s) + Wf(s)) % r.props.intervals != 0 && p.push("react-datepicker__time-list-item--injected"), p.join(" ");
    }), De(Fe(r), "handleOnKeyDown", function(s, u) {
      s.key === " " && (s.preventDefault(), s.key = "Enter"), s.key === "Enter" && r.handleClick(u), r.props.handleOnKeyDown(s);
    }), De(Fe(r), "renderTimes", function() {
      for (var s = [], u = r.props.format ? r.props.format : "p", f = r.props.intervals, p = ike(Xi(r.props.selected)), m = 1440 / f, v = r.props.injectTimes && r.props.injectTimes.sort(function(I, D) {
        return I - D;
      }), O = r.props.selected || r.props.openToDate || Xi(), w = Qf(O), _ = Wf(O), C = Zw(Yw(p, _), w), A = 0; A < m; A++) {
        var N = v$(p, A * f);
        if (s.push(N), v) {
          var P = fke(p, N, A, f, v);
          s = s.concat(P);
        }
      }
      return s.map(function(I, D) {
        return Ge.createElement("li", { key: D, onClick: r.handleClick.bind(Fe(r), I), className: r.liClasses(I, w, _), ref: function(M) {
          (Oh(I, C) || Hb(I, C)) && (r.centerLi = M);
        }, onKeyDown: function(M) {
          r.handleOnKeyDown(M, I);
        }, tabIndex: "0", "aria-selected": r.isSelectedTime(I, w, _) ? "true" : void 0 }, Do(I, u, r.props.locale));
      });
    }), r;
  }
  return ys(n, [{ key: "componentDidMount", value: function() {
    this.list.scrollTop = this.centerLi && n.calcCenterPosition(this.props.monthRef ? this.props.monthRef.clientHeight - this.header.clientHeight : this.list.clientHeight, this.centerLi), this.props.monthRef && this.header && this.setState({ height: this.props.monthRef.clientHeight - this.header.clientHeight });
  } }, { key: "render", value: function() {
    var r = this, a = this.state.height;
    return Ge.createElement("div", { className: "react-datepicker__time-container ".concat(this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "") }, Ge.createElement("div", { className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""), ref: function(i) {
      r.header = i;
    } }, Ge.createElement("div", { className: "react-datepicker-time__header" }, this.props.timeCaption)), Ge.createElement("div", { className: "react-datepicker__time" }, Ge.createElement("div", { className: "react-datepicker__time-box" }, Ge.createElement("ul", { className: "react-datepicker__time-list", ref: function(i) {
      r.list = i;
    }, style: a ? { height: a } : {}, tabIndex: "0" }, this.renderTimes()))));
  } }], [{ key: "defaultProps", get: function() {
    return { intervals: 30, onTimeChange: function() {
    }, todayButton: null, timeCaption: "Time" };
  } }]), n;
}();
De(Rre, "calcCenterPosition", function(t, e) {
  return e.offsetTop - (t / 2 - e.clientHeight / 2);
});
var Tke = function(t) {
  Os(n, Ge.Component);
  var e = Es(n);
  function n(r) {
    var a;
    return vs(this, n), De(Fe(a = e.call(this, r)), "YEAR_REFS", Sre(Array(a.props.yearItemNumber)).map(function() {
      return Ge.createRef();
    })), De(Fe(a), "isDisabled", function(i) {
      return nD(i, a.props);
    }), De(Fe(a), "isExcluded", function(i) {
      return SU(i, a.props);
    }), De(Fe(a), "updateFocusOnPaginate", function(i) {
      var o = (function() {
        this.YEAR_REFS[i].current.focus();
      }).bind(Fe(a));
      window.requestAnimationFrame(o);
    }), De(Fe(a), "handleYearClick", function(i, o) {
      a.props.onDayClick && a.props.onDayClick(i, o);
    }), De(Fe(a), "handleYearNavigation", function(i, o) {
      var s = a.props, u = s.date, f = s.yearItemNumber, p = Xw(u, f).startPeriod;
      a.isDisabled(o) || a.isExcluded(o) || (a.props.setPreSelection(o), i - p == -1 ? a.updateFocusOnPaginate(f - 1) : i - p === f ? a.updateFocusOnPaginate(0) : a.YEAR_REFS[i - p].current.focus());
    }), De(Fe(a), "isSameDay", function(i, o) {
      return ou(i, o);
    }), De(Fe(a), "isCurrentYear", function(i) {
      return i === sa(Xi());
    }), De(Fe(a), "isKeyboardSelected", function(i) {
      var o = Pw(LT(a.props.date, i));
      return !a.props.disabledKeyboardNavigation && !a.props.inline && !ou(o, Pw(a.props.selected)) && ou(o, Pw(a.props.preSelection));
    }), De(Fe(a), "onYearClick", function(i, o) {
      var s = a.props.date;
      a.handleYearClick(Pw(LT(s, o)), i);
    }), De(Fe(a), "onYearKeyDown", function(i, o) {
      var s = i.key;
      if (!a.props.disabledKeyboardNavigation)
        switch (s) {
          case "Enter":
            a.onYearClick(i, o), a.props.setPreSelection(a.props.selected);
            break;
          case "ArrowRight":
            a.handleYearNavigation(o + 1, s0(a.props.preSelection, 1));
            break;
          case "ArrowLeft":
            a.handleYearNavigation(o - 1, PT(a.props.preSelection, 1));
        }
    }), De(Fe(a), "getYearClassNames", function(i) {
      var o = a.props, s = o.minDate, u = o.maxDate, f = o.selected, p = o.excludeDates, m = o.includeDates, v = o.filterDate;
      return pn("react-datepicker__year-text", { "react-datepicker__year-text--selected": i === sa(f), "react-datepicker__year-text--disabled": (s || u || p || m || v) && xre(i, a.props), "react-datepicker__year-text--keyboard-selected": a.isKeyboardSelected(i), "react-datepicker__year-text--today": a.isCurrentYear(i) });
    }), De(Fe(a), "getYearTabIndex", function(i) {
      return a.props.disabledKeyboardNavigation ? "-1" : i === sa(a.props.preSelection) ? "0" : "-1";
    }), a;
  }
  return ys(n, [{ key: "render", value: function() {
    for (var r = this, a = [], i = this.props, o = Xw(i.date, i.yearItemNumber), s = o.startPeriod, u = o.endPeriod, f = function(m) {
      a.push(Ge.createElement("div", { ref: r.YEAR_REFS[m - s], onClick: function(v) {
        r.onYearClick(v, m);
      }, onKeyDown: function(v) {
        r.onYearKeyDown(v, m);
      }, tabIndex: r.getYearTabIndex(m), className: r.getYearClassNames(m), key: m, "aria-current": r.isCurrentYear(m) ? "date" : void 0 }, m));
    }, p = s; p <= u; p++)
      f(p);
    return Ge.createElement("div", { className: "react-datepicker__year" }, Ge.createElement("div", { className: "react-datepicker__year-wrapper" }, a));
  } }]), n;
}(), _ke = function(t) {
  Os(n, Ge.Component);
  var e = Es(n);
  function n(r) {
    var a;
    return vs(this, n), De(Fe(a = e.call(this, r)), "onTimeChange", function(i) {
      a.setState({ time: i });
      var o = /* @__PURE__ */ new Date();
      o.setHours(i.split(":")[0]), o.setMinutes(i.split(":")[1]), a.props.onChange(o);
    }), De(Fe(a), "renderTimeInput", function() {
      var i = a.state.time, o = a.props, s = o.date, u = o.timeString, f = o.customTimeInput;
      return f ? Ge.cloneElement(f, { date: s, value: i, onChange: a.onTimeChange }) : Ge.createElement("input", { type: "time", className: "react-datepicker-time__input", placeholder: "Time", name: "time-input", required: !0, value: i, onChange: function(p) {
        a.onTimeChange(p.target.value || u);
      } });
    }), a.state = { time: a.props.timeString }, a;
  }
  return ys(n, [{ key: "render", value: function() {
    return Ge.createElement("div", { className: "react-datepicker__input-time-container" }, Ge.createElement("div", { className: "react-datepicker-time__caption" }, this.props.timeInputLabel), Ge.createElement("div", { className: "react-datepicker-time__input-container" }, Ge.createElement("div", { className: "react-datepicker-time__input" }, this.renderTimeInput())));
  } }], [{ key: "getDerivedStateFromProps", value: function(r, a) {
    return r.timeString !== a.time ? { time: r.timeString } : null;
  } }]), n;
}();
function Cke(t) {
  var e = t.className, n = t.children, r = t.showPopperArrow, a = t.arrowProps, i = a === void 0 ? {} : a;
  return Ge.createElement("div", { className: e }, r && Ge.createElement("div", tD({ className: "react-datepicker__triangle" }, i)), n);
}
var xke = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"], Ake = function(t) {
  Os(n, Ge.Component);
  var e = Es(n);
  function n(r) {
    var a;
    return vs(this, n), De(Fe(a = e.call(this, r)), "handleClickOutside", function(i) {
      a.props.onClickOutside(i);
    }), De(Fe(a), "setClickOutsideRef", function() {
      return a.containerRef.current;
    }), De(Fe(a), "handleDropdownFocus", function(i) {
      (function() {
        var o = ((arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).className || "").split(/\s+/);
        return xke.some(function(s) {
          return o.indexOf(s) >= 0;
        });
      })(i.target) && a.props.onDropdownFocus();
    }), De(Fe(a), "getDateInView", function() {
      var i = a.props, o = i.preSelection, s = i.selected, u = i.openToDate, f = Are(a.props), p = kre(a.props), m = Xi(), v = u || s || o;
      return v || (f && Oh(m, f) ? f : p && Jm(m, p) ? p : m);
    }), De(Fe(a), "increaseMonth", function() {
      a.setState(function(i) {
        var o = i.date;
        return { date: Zd(o, 1) };
      }, function() {
        return a.handleMonthChange(a.state.date);
      });
    }), De(Fe(a), "decreaseMonth", function() {
      a.setState(function(i) {
        var o = i.date;
        return { date: l0(o, 1) };
      }, function() {
        return a.handleMonthChange(a.state.date);
      });
    }), De(Fe(a), "handleDayClick", function(i, o, s) {
      a.props.onSelect(i, o, s), a.props.setPreSelection && a.props.setPreSelection(i);
    }), De(Fe(a), "handleDayMouseEnter", function(i) {
      a.setState({ selectingDate: i }), a.props.onDayMouseEnter && a.props.onDayMouseEnter(i);
    }), De(Fe(a), "handleMonthMouseLeave", function() {
      a.setState({ selectingDate: null }), a.props.onMonthMouseLeave && a.props.onMonthMouseLeave();
    }), De(Fe(a), "handleYearChange", function(i) {
      a.props.onYearChange && a.props.onYearChange(i), a.props.adjustDateOnChange && (a.props.onSelect && a.props.onSelect(i), a.props.setOpen && a.props.setOpen(!0)), a.props.setPreSelection && a.props.setPreSelection(i);
    }), De(Fe(a), "handleMonthChange", function(i) {
      a.props.onMonthChange && a.props.onMonthChange(i), a.props.adjustDateOnChange && (a.props.onSelect && a.props.onSelect(i), a.props.setOpen && a.props.setOpen(!0)), a.props.setPreSelection && a.props.setPreSelection(i);
    }), De(Fe(a), "handleMonthYearChange", function(i) {
      a.handleYearChange(i), a.handleMonthChange(i);
    }), De(Fe(a), "changeYear", function(i) {
      a.setState(function(o) {
        var s = o.date;
        return { date: LT(s, i) };
      }, function() {
        return a.handleYearChange(a.state.date);
      });
    }), De(Fe(a), "changeMonth", function(i) {
      a.setState(function(o) {
        var s = o.date;
        return { date: Bf(s, i) };
      }, function() {
        return a.handleMonthChange(a.state.date);
      });
    }), De(Fe(a), "changeMonthYear", function(i) {
      a.setState(function(o) {
        var s = o.date;
        return { date: LT(Bf(s, uu(i)), sa(i)) };
      }, function() {
        return a.handleMonthYearChange(a.state.date);
      });
    }), De(Fe(a), "header", function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : a.state.date, o = EU(i, a.props.locale, a.props.calendarStartDay), s = [];
      return a.props.showWeekNumbers && s.push(Ge.createElement("div", { key: "W", className: "react-datepicker__day-name" }, a.props.weekLabel || "#")), s.concat([0, 1, 2, 3, 4, 5, 6].map(function(u) {
        var f = _0(o, u), p = a.formatWeekday(f, a.props.locale), m = a.props.weekDayClassName ? a.props.weekDayClassName(f) : void 0;
        return Ge.createElement("div", { key: u, className: pn("react-datepicker__day-name", m) }, p);
      }));
    }), De(Fe(a), "formatWeekday", function(i, o) {
      return a.props.formatWeekDay ? function(s, u, f) {
        return typeof u == "function" ? u(s, f) : Do(s, "EEEE", f);
      }(i, a.props.formatWeekDay, o) : a.props.useWeekdaysShort ? function(s, u) {
        return Do(s, "EEE", u);
      }(i, o) : function(s, u) {
        return Do(s, "EEEEEE", u);
      }(i, o);
    }), De(Fe(a), "decreaseYear", function() {
      a.setState(function(i) {
        var o = i.date;
        return { date: PT(o, a.props.showYearPicker ? a.props.yearItemNumber : 1) };
      }, function() {
        return a.handleYearChange(a.state.date);
      });
    }), De(Fe(a), "renderPreviousButton", function() {
      if (!a.props.renderCustomHeader) {
        var i;
        switch (!0) {
          case a.props.showMonthYearPicker:
            i = bZ(a.state.date, a.props);
            break;
          case a.props.showYearPicker:
            i = function(A) {
              var N = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, P = N.minDate, I = N.yearItemNumber, D = I === void 0 ? 12 : I, M = Xw(Pw(PT(A, D)), D).endPeriod, H = P && sa(P);
              return H && H > M || !1;
            }(a.state.date, a.props);
            break;
          default:
            i = mZ(a.state.date, a.props);
        }
        if ((a.props.forceShowMonthNavigation || a.props.showDisabledMonthNavigation || !i) && !a.props.showTimeSelectOnly) {
          var o = ["react-datepicker__navigation", "react-datepicker__navigation--previous"], s = a.decreaseMonth;
          (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker) && (s = a.decreaseYear), i && a.props.showDisabledMonthNavigation && (o.push("react-datepicker__navigation--previous--disabled"), s = null);
          var u = a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker, f = a.props, p = f.previousMonthButtonLabel, m = f.previousYearButtonLabel, v = a.props, O = v.previousMonthAriaLabel, w = O === void 0 ? typeof p == "string" ? p : "Previous Month" : O, _ = v.previousYearAriaLabel, C = _ === void 0 ? typeof m == "string" ? m : "Previous Year" : _;
          return Ge.createElement("button", { type: "button", className: o.join(" "), onClick: s, onKeyDown: a.props.handleOnKeyDown, "aria-label": u ? C : w }, Ge.createElement("span", { className: ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--previous"].join(" ") }, u ? a.props.previousYearButtonLabel : a.props.previousMonthButtonLabel));
        }
      }
    }), De(Fe(a), "increaseYear", function() {
      a.setState(function(i) {
        var o = i.date;
        return { date: s0(o, a.props.showYearPicker ? a.props.yearItemNumber : 1) };
      }, function() {
        return a.handleYearChange(a.state.date);
      });
    }), De(Fe(a), "renderNextButton", function() {
      if (!a.props.renderCustomHeader) {
        var i;
        switch (!0) {
          case a.props.showMonthYearPicker:
            i = vZ(a.state.date, a.props);
            break;
          case a.props.showYearPicker:
            i = function(A) {
              var N = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, P = N.maxDate, I = N.yearItemNumber, D = I === void 0 ? 12 : I, M = Xw(s0(A, D), D).startPeriod, H = P && sa(P);
              return H && H < M || !1;
            }(a.state.date, a.props);
            break;
          default:
            i = gZ(a.state.date, a.props);
        }
        if ((a.props.forceShowMonthNavigation || a.props.showDisabledMonthNavigation || !i) && !a.props.showTimeSelectOnly) {
          var o = ["react-datepicker__navigation", "react-datepicker__navigation--next"];
          a.props.showTimeSelect && o.push("react-datepicker__navigation--next--with-time"), a.props.todayButton && o.push("react-datepicker__navigation--next--with-today-button");
          var s = a.increaseMonth;
          (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker) && (s = a.increaseYear), i && a.props.showDisabledMonthNavigation && (o.push("react-datepicker__navigation--next--disabled"), s = null);
          var u = a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker, f = a.props, p = f.nextMonthButtonLabel, m = f.nextYearButtonLabel, v = a.props, O = v.nextMonthAriaLabel, w = O === void 0 ? typeof p == "string" ? p : "Next Month" : O, _ = v.nextYearAriaLabel, C = _ === void 0 ? typeof m == "string" ? m : "Next Year" : _;
          return Ge.createElement("button", { type: "button", className: o.join(" "), onClick: s, onKeyDown: a.props.handleOnKeyDown, "aria-label": u ? C : w }, Ge.createElement("span", { className: ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--next"].join(" ") }, u ? a.props.nextYearButtonLabel : a.props.nextMonthButtonLabel));
        }
      }
    }), De(Fe(a), "renderCurrentMonth", function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : a.state.date, o = ["react-datepicker__current-month"];
      return a.props.showYearDropdown && o.push("react-datepicker__current-month--hasYearDropdown"), a.props.showMonthDropdown && o.push("react-datepicker__current-month--hasMonthDropdown"), a.props.showMonthYearDropdown && o.push("react-datepicker__current-month--hasMonthYearDropdown"), Ge.createElement("div", { className: o.join(" ") }, Do(i, a.props.dateFormat, a.props.locale));
    }), De(Fe(a), "renderYearDropdown", function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      if (a.props.showYearDropdown && !i)
        return Ge.createElement(hke, { adjustDateOnChange: a.props.adjustDateOnChange, date: a.state.date, onSelect: a.props.onSelect, setOpen: a.props.setOpen, dropdownMode: a.props.dropdownMode, onChange: a.changeYear, minDate: a.props.minDate, maxDate: a.props.maxDate, year: sa(a.state.date), scrollableYearDropdown: a.props.scrollableYearDropdown, yearDropdownItemNumber: a.props.yearDropdownItemNumber });
    }), De(Fe(a), "renderMonthDropdown", function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      if (a.props.showMonthDropdown && !i)
        return Ge.createElement(gke, { dropdownMode: a.props.dropdownMode, locale: a.props.locale, onChange: a.changeMonth, month: uu(a.state.date), useShortMonthInDropdown: a.props.useShortMonthInDropdown });
    }), De(Fe(a), "renderMonthYearDropdown", function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      if (a.props.showMonthYearDropdown && !i)
        return Ge.createElement(yke, { dropdownMode: a.props.dropdownMode, locale: a.props.locale, dateFormat: a.props.dateFormat, onChange: a.changeMonthYear, minDate: a.props.minDate, maxDate: a.props.maxDate, date: a.state.date, scrollableMonthYearDropdown: a.props.scrollableMonthYearDropdown });
    }), De(Fe(a), "handleTodayButtonClick", function(i) {
      a.props.onSelect(fZ(), i), a.props.setPreSelection && a.props.setPreSelection(fZ());
    }), De(Fe(a), "renderTodayButton", function() {
      if (a.props.todayButton && !a.props.showTimeSelectOnly)
        return Ge.createElement("div", { className: "react-datepicker__today-button", onClick: function(i) {
          return a.handleTodayButtonClick(i);
        } }, a.props.todayButton);
    }), De(Fe(a), "renderDefaultHeader", function(i) {
      var o = i.monthDate, s = i.i;
      return Ge.createElement("div", { className: "react-datepicker__header ".concat(a.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "") }, a.renderCurrentMonth(o), Ge.createElement("div", { className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(a.props.dropdownMode), onFocus: a.handleDropdownFocus }, a.renderMonthDropdown(s !== 0), a.renderMonthYearDropdown(s !== 0), a.renderYearDropdown(s !== 0)), Ge.createElement("div", { className: "react-datepicker__day-names" }, a.header(o)));
    }), De(Fe(a), "renderCustomHeader", function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = i.monthDate, s = i.i;
      if (a.props.showTimeSelect && !a.state.monthContainer || a.props.showTimeSelectOnly)
        return null;
      var u = mZ(a.state.date, a.props), f = gZ(a.state.date, a.props), p = bZ(a.state.date, a.props), m = vZ(a.state.date, a.props), v = !a.props.showMonthYearPicker && !a.props.showQuarterYearPicker && !a.props.showYearPicker;
      return Ge.createElement("div", { className: "react-datepicker__header react-datepicker__header--custom", onFocus: a.props.onDropdownFocus }, a.props.renderCustomHeader(lZ(lZ({}, a.state), {}, { customHeaderCount: s, monthDate: o, changeMonth: a.changeMonth, changeYear: a.changeYear, decreaseMonth: a.decreaseMonth, increaseMonth: a.increaseMonth, decreaseYear: a.decreaseYear, increaseYear: a.increaseYear, prevMonthButtonDisabled: u, nextMonthButtonDisabled: f, prevYearButtonDisabled: p, nextYearButtonDisabled: m })), v && Ge.createElement("div", { className: "react-datepicker__day-names" }, a.header(o)));
    }), De(Fe(a), "renderYearHeader", function() {
      var i = a.state.date, o = a.props, s = o.showYearPicker, u = Xw(i, o.yearItemNumber), f = u.startPeriod, p = u.endPeriod;
      return Ge.createElement("div", { className: "react-datepicker__header react-datepicker-year-header" }, s ? "".concat(f, " - ").concat(p) : sa(i));
    }), De(Fe(a), "renderHeader", function(i) {
      switch (!0) {
        case a.props.renderCustomHeader !== void 0:
          return a.renderCustomHeader(i);
        case (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker):
          return a.renderYearHeader(i);
        default:
          return a.renderDefaultHeader(i);
      }
    }), De(Fe(a), "renderMonths", function() {
      if (!a.props.showTimeSelectOnly && !a.props.showYearPicker) {
        for (var i = [], o = a.props.showPreviousMonths ? a.props.monthsShown - 1 : 0, s = l0(a.state.date, o), u = 0; u < a.props.monthsShown; ++u) {
          var f = u - a.props.monthSelectedIn, p = Zd(s, f), m = "month-".concat(u), v = u < a.props.monthsShown - 1, O = u > 0;
          i.push(Ge.createElement("div", { key: m, ref: function(w) {
            a.monthContainer = w;
          }, className: "react-datepicker__month-container" }, a.renderHeader({ monthDate: p, i: u }), Ge.createElement(wke, { chooseDayAriaLabelPrefix: a.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: a.props.disabledDayAriaLabelPrefix, weekAriaLabelPrefix: a.props.weekAriaLabelPrefix, ariaLabelPrefix: a.props.monthAriaLabelPrefix, onChange: a.changeMonthYear, day: p, dayClassName: a.props.dayClassName, calendarStartDay: a.props.calendarStartDay, monthClassName: a.props.monthClassName, onDayClick: a.handleDayClick, handleOnKeyDown: a.props.handleOnDayKeyDown, onDayMouseEnter: a.handleDayMouseEnter, onMouseLeave: a.handleMonthMouseLeave, onWeekSelect: a.props.onWeekSelect, orderInDisplay: u, formatWeekNumber: a.props.formatWeekNumber, locale: a.props.locale, minDate: a.props.minDate, maxDate: a.props.maxDate, excludeDates: a.props.excludeDates, excludeDateIntervals: a.props.excludeDateIntervals, highlightDates: a.props.highlightDates, selectingDate: a.state.selectingDate, includeDates: a.props.includeDates, includeDateIntervals: a.props.includeDateIntervals, inline: a.props.inline, shouldFocusDayInline: a.props.shouldFocusDayInline, fixedHeight: a.props.fixedHeight, filterDate: a.props.filterDate, preSelection: a.props.preSelection, setPreSelection: a.props.setPreSelection, selected: a.props.selected, selectsStart: a.props.selectsStart, selectsEnd: a.props.selectsEnd, selectsRange: a.props.selectsRange, selectsDisabledDaysInRange: a.props.selectsDisabledDaysInRange, showWeekNumbers: a.props.showWeekNumbers, startDate: a.props.startDate, endDate: a.props.endDate, peekNextMonth: a.props.peekNextMonth, setOpen: a.props.setOpen, shouldCloseOnSelect: a.props.shouldCloseOnSelect, renderDayContents: a.props.renderDayContents, disabledKeyboardNavigation: a.props.disabledKeyboardNavigation, showMonthYearPicker: a.props.showMonthYearPicker, showFullMonthYearPicker: a.props.showFullMonthYearPicker, showTwoColumnMonthYearPicker: a.props.showTwoColumnMonthYearPicker, showFourColumnMonthYearPicker: a.props.showFourColumnMonthYearPicker, showYearPicker: a.props.showYearPicker, showQuarterYearPicker: a.props.showQuarterYearPicker, isInputFocused: a.props.isInputFocused, containerRef: a.containerRef, monthShowsDuplicateDaysEnd: v, monthShowsDuplicateDaysStart: O })));
        }
        return i;
      }
    }), De(Fe(a), "renderYears", function() {
      if (!a.props.showTimeSelectOnly)
        return a.props.showYearPicker ? Ge.createElement("div", { className: "react-datepicker__year--container" }, a.renderHeader(), Ge.createElement(Tke, tD({ onDayClick: a.handleDayClick, date: a.state.date }, a.props))) : void 0;
    }), De(Fe(a), "renderTimeSection", function() {
      if (a.props.showTimeSelect && (a.state.monthContainer || a.props.showTimeSelectOnly))
        return Ge.createElement(Rre, { selected: a.props.selected, openToDate: a.props.openToDate, onChange: a.props.onTimeChange, timeClassName: a.props.timeClassName, format: a.props.timeFormat, includeTimes: a.props.includeTimes, intervals: a.props.timeIntervals, minTime: a.props.minTime, maxTime: a.props.maxTime, excludeTimes: a.props.excludeTimes, filterTime: a.props.filterTime, timeCaption: a.props.timeCaption, todayButton: a.props.todayButton, showMonthDropdown: a.props.showMonthDropdown, showMonthYearDropdown: a.props.showMonthYearDropdown, showYearDropdown: a.props.showYearDropdown, withPortal: a.props.withPortal, monthRef: a.state.monthContainer, injectTimes: a.props.injectTimes, locale: a.props.locale, handleOnKeyDown: a.props.handleOnKeyDown, showTimeSelectOnly: a.props.showTimeSelectOnly });
    }), De(Fe(a), "renderInputTimeSection", function() {
      var i = new Date(a.props.selected), o = OU(i) && a.props.selected ? "".concat(OZ(i.getHours()), ":").concat(OZ(i.getMinutes())) : "";
      if (a.props.showTimeInput)
        return Ge.createElement(_ke, { date: i, timeString: o, timeInputLabel: a.props.timeInputLabel, onChange: a.props.onTimeChange, customTimeInput: a.props.customTimeInput });
    }), De(Fe(a), "renderChildren", function() {
      if (a.props.children)
        return Ge.createElement("div", { className: "react-datepicker__children-container" }, a.props.children);
    }), a.containerRef = Ge.createRef(), a.state = { date: a.getDateInView(), selectingDate: null, monthContainer: null }, a;
  }
  return ys(n, [{ key: "componentDidMount", value: function() {
    var r = this;
    this.props.showTimeSelect && (this.assignMonthContainer = void r.setState({ monthContainer: r.monthContainer }));
  } }, { key: "componentDidUpdate", value: function(r) {
    this.props.preSelection && !ou(this.props.preSelection, r.preSelection) ? this.setState({ date: this.props.preSelection }) : this.props.openToDate && !ou(this.props.openToDate, r.openToDate) && this.setState({ date: this.props.openToDate });
  } }, { key: "render", value: function() {
    var r = this.props.container || Cke;
    return Ge.createElement("div", { ref: this.containerRef }, Ge.createElement(r, { className: pn("react-datepicker", this.props.className, { "react-datepicker--time-only": this.props.showTimeSelectOnly }), showPopperArrow: this.props.showPopperArrow, arrowProps: this.props.arrowProps }, this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren()));
  } }], [{ key: "defaultProps", get: function() {
    return { onDropdownFocus: function() {
    }, monthsShown: 1, monthSelectedIn: 0, forceShowMonthNavigation: !1, timeCaption: "Time", previousYearButtonLabel: "Previous Year", nextYearButtonLabel: "Next Year", previousMonthButtonLabel: "Previous Month", nextMonthButtonLabel: "Next Month", customTimeInput: null, yearItemNumber: 12 };
  } }]), n;
}(), Ire = function(t) {
  Os(n, Ge.Component);
  var e = Es(n);
  function n(r) {
    var a;
    return vs(this, n), (a = e.call(this, r)).el = document.createElement("div"), a;
  }
  return ys(n, [{ key: "componentDidMount", value: function() {
    this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
  } }, { key: "componentWillUnmount", value: function() {
    this.portalRoot.removeChild(this.el);
  } }, { key: "render", value: function() {
    return vbe.createPortal(this.props.children, this.el);
  } }]), n;
}(), kke = function(t) {
  return !t.disabled && t.tabIndex !== -1;
}, Dre = function(t) {
  Os(n, Ge.Component);
  var e = Es(n);
  function n(r) {
    var a;
    return vs(this, n), De(Fe(a = e.call(this, r)), "getTabChildren", function() {
      return Array.prototype.slice.call(a.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"), 1, -1).filter(kke);
    }), De(Fe(a), "handleFocusStart", function(i) {
      var o = a.getTabChildren();
      o && o.length > 1 && o[o.length - 1].focus();
    }), De(Fe(a), "handleFocusEnd", function(i) {
      var o = a.getTabChildren();
      o && o.length > 1 && o[0].focus();
    }), a.tabLoopRef = Ge.createRef(), a;
  }
  return ys(n, [{ key: "render", value: function() {
    return this.props.enableTabLoop ? Ge.createElement("div", { className: "react-datepicker__tab-loop", ref: this.tabLoopRef }, Ge.createElement("div", { className: "react-datepicker__tab-loop__start", tabIndex: "0", onFocus: this.handleFocusStart }), this.props.children, Ge.createElement("div", { className: "react-datepicker__tab-loop__end", tabIndex: "0", onFocus: this.handleFocusEnd })) : this.props.children;
  } }], [{ key: "defaultProps", get: function() {
    return { enableTabLoop: !0 };
  } }]), n;
}(), Rke = function(t) {
  Os(n, Ge.Component);
  var e = Es(n);
  function n() {
    return vs(this, n), e.apply(this, arguments);
  }
  return ys(n, [{ key: "render", value: function() {
    var r, a = this.props, i = a.className, o = a.wrapperClassName, s = a.hidePopper, u = a.popperComponent, f = a.popperModifiers, p = a.popperPlacement, m = a.popperProps, v = a.targetComponent, O = a.enableTabLoop, w = a.popperOnKeyDown, _ = a.portalId, C = a.portalHost;
    if (!s) {
      var A = pn("react-datepicker-popper", i);
      r = Ge.createElement(YAe, tD({ modifiers: f, placement: p }, m), function(P) {
        var I = P.ref, D = P.style, M = P.placement, H = P.arrowProps;
        return Ge.createElement(Dre, { enableTabLoop: O }, Ge.createElement("div", { ref: I, style: D, className: A, "data-placement": M, onKeyDown: w }, Ge.cloneElement(u, { arrowProps: H })));
      });
    }
    this.props.popperContainer && (r = Ge.createElement(this.props.popperContainer, {}, r)), _ && !s && (r = Ge.createElement(Ire, { portalId: _, portalHost: C }, r));
    var N = pn("react-datepicker-wrapper", o);
    return Ge.createElement(MAe, { className: "react-datepicker-manager" }, Ge.createElement(JAe, null, function(P) {
      var I = P.ref;
      return Ge.createElement("div", { ref: I, className: N }, v);
    }), r);
  } }], [{ key: "defaultProps", get: function() {
    return { hidePopper: !0, popperModifiers: [], popperProps: {}, popperPlacement: "bottom-start" };
  } }]), n;
}(), Ike = eD(Ake), Dke = function(t) {
  Os(n, Ge.Component);
  var e = Es(n);
  function n(r) {
    var a;
    return vs(this, n), De(Fe(a = e.call(this, r)), "getPreSelection", function() {
      return a.props.openToDate ? a.props.openToDate : a.props.selectsEnd && a.props.startDate ? a.props.startDate : a.props.selectsStart && a.props.endDate ? a.props.endDate : Xi();
    }), De(Fe(a), "calcInitialState", function() {
      var i, o = a.getPreSelection(), s = Are(a.props), u = kre(a.props), f = s && Oh(o, Gd(s)) ? s : u && Jm(o, lR(u)) ? u : o;
      return { open: a.props.startOpen || !1, preventFocus: !1, preSelection: (i = a.props.selectsRange ? a.props.startDate : a.props.selected) !== null && i !== void 0 ? i : f, highlightDates: yZ(a.props.highlightDates), focused: !1, shouldFocusDayInline: !1 };
    }), De(Fe(a), "clearPreventFocusTimeout", function() {
      a.preventFocusTimeout && clearTimeout(a.preventFocusTimeout);
    }), De(Fe(a), "setFocus", function() {
      a.input && a.input.focus && a.input.focus({ preventScroll: !0 });
    }), De(Fe(a), "setBlur", function() {
      a.input && a.input.blur && a.input.blur(), a.cancelFocusInput();
    }), De(Fe(a), "setOpen", function(i) {
      var o = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
      a.setState({ open: i, preSelection: i && a.state.open ? a.state.preSelection : a.calcInitialState().preSelection, lastPreSelectChange: GM }, function() {
        i || a.setState(function(s) {
          return { focused: !!o && s.focused };
        }, function() {
          !o && a.setBlur(), a.setState({ inputValue: null });
        });
      });
    }), De(Fe(a), "inputOk", function() {
      return oU(a.state.preSelection);
    }), De(Fe(a), "isCalendarOpen", function() {
      return a.props.open === void 0 ? a.state.open && !a.props.disabled && !a.props.readOnly : a.props.open;
    }), De(Fe(a), "handleFocus", function(i) {
      a.state.preventFocus || (a.props.onFocus(i), a.props.preventOpenOnFocus || a.props.readOnly || a.setOpen(!0)), a.setState({ focused: !0 });
    }), De(Fe(a), "cancelFocusInput", function() {
      clearTimeout(a.inputFocusTimeout), a.inputFocusTimeout = null;
    }), De(Fe(a), "deferFocusInput", function() {
      a.cancelFocusInput(), a.inputFocusTimeout = setTimeout(function() {
        return a.setFocus();
      }, 1);
    }), De(Fe(a), "handleDropdownFocus", function() {
      a.cancelFocusInput();
    }), De(Fe(a), "handleBlur", function(i) {
      (!a.state.open || a.props.withPortal || a.props.showTimeInput) && a.props.onBlur(i), a.setState({ focused: !1 });
    }), De(Fe(a), "handleCalendarClickOutside", function(i) {
      a.props.inline || a.setOpen(!1), a.props.onClickOutside(i), a.props.withPortal && i.preventDefault();
    }), De(Fe(a), "handleChange", function() {
      for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++)
        o[s] = arguments[s];
      var u = o[0];
      if (!a.props.onChangeRaw || (a.props.onChangeRaw.apply(Fe(a), o), typeof u.isDefaultPrevented == "function" && !u.isDefaultPrevented())) {
        a.setState({ inputValue: u.target.value, lastPreSelectChange: Nke });
        var f = nke(u.target.value, a.props.dateFormat, a.props.locale, a.props.strictParsing, a.props.selected, a.props.minDate);
        a.props.showTimeSelectOnly && !ou(f, a.props.selected) && (f = eke(a.props.selected, { hours: Qf(f), minutes: Wf(f), seconds: jV(f) })), !f && u.target.value || a.setSelected(f, u, !0);
      }
    }), De(Fe(a), "handleSelect", function(i, o, s) {
      if (a.setState({ preventFocus: !0 }, function() {
        return a.preventFocusTimeout = setTimeout(function() {
          return a.setState({ preventFocus: !1 });
        }, 50), a.preventFocusTimeout;
      }), a.props.onChangeRaw && a.props.onChangeRaw(o), a.setSelected(i, o, !1, s), !a.props.shouldCloseOnSelect || a.props.showTimeSelect)
        a.setPreSelection(i);
      else if (!a.props.inline) {
        a.props.selectsRange || a.setOpen(!1);
        var u = a.props, f = u.startDate, p = u.endDate;
        !f || p || Oh(i, f) || a.setOpen(!1);
      }
    }), De(Fe(a), "setSelected", function(i, o, s, u) {
      var f = i;
      if (a.props.showYearPicker) {
        if (f !== null && xre(sa(f), a.props))
          return;
      } else if (a.props.showMonthYearPicker) {
        if (f !== null && Cre(f, a.props))
          return;
      } else if (f !== null && nD(f, a.props))
        return;
      var p = a.props, m = p.onChange, v = p.selectsRange, O = p.startDate, w = p.endDate;
      if (!Hb(a.props.selected, f) || a.props.allowSameDay || v)
        if (f !== null && (!a.props.selected || s && (a.props.showTimeSelect || a.props.showTimeSelectOnly || a.props.showTimeInput) || (f = cZ(f, { hour: Qf(a.props.selected), minute: Wf(a.props.selected), second: jV(a.props.selected) })), a.props.inline || a.setState({ preSelection: f }), a.props.focusSelectedMonth || a.setState({ monthSelectedIn: u })), v) {
          var _ = O && !w, C = O && w;
          !O && !w ? m([f, null], o) : _ && (Oh(f, O) ? m([f, null], o) : m([O, f], o)), C && m([f, null], o);
        } else
          m(f, o);
      s || (a.props.onSelect(f, o), a.setState({ inputValue: null }));
    }), De(Fe(a), "setPreSelection", function(i) {
      var o = a.props.minDate !== void 0, s = a.props.maxDate !== void 0, u = !0;
      if (i) {
        var f = Gd(i);
        if (o && s)
          u = bk(i, a.props.minDate, a.props.maxDate);
        else if (o) {
          var p = Gd(a.props.minDate);
          u = Jm(i, p) || Hb(f, p);
        } else if (s) {
          var m = lR(a.props.maxDate);
          u = Oh(i, m) || Hb(f, m);
        }
      }
      u && a.setState({ preSelection: i });
    }), De(Fe(a), "handleTimeChange", function(i) {
      var o = cZ(a.props.selected ? a.props.selected : a.getPreSelection(), { hour: Qf(i), minute: Wf(i) });
      a.setState({ preSelection: o }), a.props.onChange(o), a.props.shouldCloseOnSelect && a.setOpen(!1), a.props.showTimeInput && a.setOpen(!0), a.setState({ inputValue: null });
    }), De(Fe(a), "onInputClick", function() {
      a.props.disabled || a.props.readOnly || a.setOpen(!0), a.props.onInputClick();
    }), De(Fe(a), "onInputKeyDown", function(i) {
      a.props.onKeyDown(i);
      var o = i.key;
      if (a.state.open || a.props.inline || a.props.preventOpenOnFocus) {
        if (a.state.open) {
          if (o === "ArrowDown" || o === "ArrowUp") {
            i.preventDefault();
            var s = a.calendar.componentNode && a.calendar.componentNode.querySelector('.react-datepicker__day[tabindex="0"]');
            return void (s && s.focus({ preventScroll: !0 }));
          }
          var u = Xi(a.state.preSelection);
          o === "Enter" ? (i.preventDefault(), a.inputOk() && a.state.lastPreSelectChange === GM ? (a.handleSelect(u, i), !a.props.shouldCloseOnSelect && a.setPreSelection(u)) : a.setOpen(!1)) : o === "Escape" && (i.preventDefault(), a.setOpen(!1)), a.inputOk() || a.props.onInputError({ code: 1, msg: "Date input not valid." });
        }
      } else
        o !== "ArrowDown" && o !== "ArrowUp" && o !== "Enter" || a.onInputClick();
    }), De(Fe(a), "onPortalKeyDown", function(i) {
      i.key === "Escape" && (i.preventDefault(), a.setState({ preventFocus: !0 }, function() {
        a.setOpen(!1), setTimeout(function() {
          a.setFocus(), a.setState({ preventFocus: !1 });
        });
      }));
    }), De(Fe(a), "onDayKeyDown", function(i) {
      a.props.onKeyDown(i);
      var o = i.key, s = Xi(a.state.preSelection);
      if (o === "Enter")
        i.preventDefault(), a.handleSelect(s, i), !a.props.shouldCloseOnSelect && a.setPreSelection(s);
      else if (o === "Escape")
        i.preventDefault(), a.setOpen(!1), a.inputOk() || a.props.onInputError({ code: 1, msg: "Date input not valid." });
      else if (!a.props.disabledKeyboardNavigation) {
        var u;
        switch (o) {
          case "ArrowLeft":
            u = owe(s, 1);
            break;
          case "ArrowRight":
            u = _0(s, 1);
            break;
          case "ArrowUp":
            u = swe(s, 1);
            break;
          case "ArrowDown":
            u = fU(s, 1);
            break;
          case "PageUp":
            u = l0(s, 1);
            break;
          case "PageDown":
            u = Zd(s, 1);
            break;
          case "Home":
            u = PT(s, 1);
            break;
          case "End":
            u = s0(s, 1);
        }
        if (!u)
          return void (a.props.onInputError && a.props.onInputError({ code: 1, msg: "Date input not valid." }));
        if (i.preventDefault(), a.setState({ lastPreSelectChange: GM }), a.props.adjustDateOnChange && a.setSelected(u), a.setPreSelection(u), a.props.inline) {
          var f = uu(s), p = uu(u), m = sa(s), v = sa(u);
          f !== p || m !== v ? a.setState({ shouldFocusDayInline: !0 }) : a.setState({ shouldFocusDayInline: !1 });
        }
      }
    }), De(Fe(a), "onPopperKeyDown", function(i) {
      i.key === "Escape" && (i.preventDefault(), a.setState({ preventFocus: !0 }, function() {
        a.setOpen(!1), setTimeout(function() {
          a.setFocus(), a.setState({ preventFocus: !1 });
        });
      }));
    }), De(Fe(a), "onClearClick", function(i) {
      i && i.preventDefault && i.preventDefault(), a.props.selectsRange ? a.props.onChange([null, null], i) : a.props.onChange(null, i), a.setState({ inputValue: null });
    }), De(Fe(a), "clear", function() {
      a.onClearClick();
    }), De(Fe(a), "onScroll", function(i) {
      typeof a.props.closeOnScroll == "boolean" && a.props.closeOnScroll ? i.target !== document && i.target !== document.documentElement && i.target !== document.body || a.setOpen(!1) : typeof a.props.closeOnScroll == "function" && a.props.closeOnScroll(i) && a.setOpen(!1);
    }), De(Fe(a), "renderCalendar", function() {
      return a.props.inline || a.isCalendarOpen() ? Ge.createElement(Ike, { ref: function(i) {
        a.calendar = i;
      }, locale: a.props.locale, calendarStartDay: a.props.calendarStartDay, chooseDayAriaLabelPrefix: a.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: a.props.disabledDayAriaLabelPrefix, weekAriaLabelPrefix: a.props.weekAriaLabelPrefix, monthAriaLabelPrefix: a.props.monthAriaLabelPrefix, adjustDateOnChange: a.props.adjustDateOnChange, setOpen: a.setOpen, shouldCloseOnSelect: a.props.shouldCloseOnSelect, dateFormat: a.props.dateFormatCalendar, useWeekdaysShort: a.props.useWeekdaysShort, formatWeekDay: a.props.formatWeekDay, dropdownMode: a.props.dropdownMode, selected: a.props.selected, preSelection: a.state.preSelection, onSelect: a.handleSelect, onWeekSelect: a.props.onWeekSelect, openToDate: a.props.openToDate, minDate: a.props.minDate, maxDate: a.props.maxDate, selectsStart: a.props.selectsStart, selectsEnd: a.props.selectsEnd, selectsRange: a.props.selectsRange, startDate: a.props.startDate, endDate: a.props.endDate, excludeDates: a.props.excludeDates, excludeDateIntervals: a.props.excludeDateIntervals, filterDate: a.props.filterDate, onClickOutside: a.handleCalendarClickOutside, formatWeekNumber: a.props.formatWeekNumber, highlightDates: a.state.highlightDates, includeDates: a.props.includeDates, includeDateIntervals: a.props.includeDateIntervals, includeTimes: a.props.includeTimes, injectTimes: a.props.injectTimes, inline: a.props.inline, shouldFocusDayInline: a.state.shouldFocusDayInline, peekNextMonth: a.props.peekNextMonth, showMonthDropdown: a.props.showMonthDropdown, showPreviousMonths: a.props.showPreviousMonths, useShortMonthInDropdown: a.props.useShortMonthInDropdown, showMonthYearDropdown: a.props.showMonthYearDropdown, showWeekNumbers: a.props.showWeekNumbers, showYearDropdown: a.props.showYearDropdown, withPortal: a.props.withPortal, forceShowMonthNavigation: a.props.forceShowMonthNavigation, showDisabledMonthNavigation: a.props.showDisabledMonthNavigation, scrollableYearDropdown: a.props.scrollableYearDropdown, scrollableMonthYearDropdown: a.props.scrollableMonthYearDropdown, todayButton: a.props.todayButton, weekLabel: a.props.weekLabel, outsideClickIgnoreClass: "react-datepicker-ignore-onclickoutside", fixedHeight: a.props.fixedHeight, monthsShown: a.props.monthsShown, monthSelectedIn: a.state.monthSelectedIn, onDropdownFocus: a.handleDropdownFocus, onMonthChange: a.props.onMonthChange, onYearChange: a.props.onYearChange, dayClassName: a.props.dayClassName, weekDayClassName: a.props.weekDayClassName, monthClassName: a.props.monthClassName, timeClassName: a.props.timeClassName, showTimeSelect: a.props.showTimeSelect, showTimeSelectOnly: a.props.showTimeSelectOnly, onTimeChange: a.handleTimeChange, timeFormat: a.props.timeFormat, timeIntervals: a.props.timeIntervals, minTime: a.props.minTime, maxTime: a.props.maxTime, excludeTimes: a.props.excludeTimes, filterTime: a.props.filterTime, timeCaption: a.props.timeCaption, className: a.props.calendarClassName, container: a.props.calendarContainer, yearItemNumber: a.props.yearItemNumber, yearDropdownItemNumber: a.props.yearDropdownItemNumber, previousMonthAriaLabel: a.props.previousMonthAriaLabel, previousMonthButtonLabel: a.props.previousMonthButtonLabel, nextMonthAriaLabel: a.props.nextMonthAriaLabel, nextMonthButtonLabel: a.props.nextMonthButtonLabel, previousYearAriaLabel: a.props.previousYearAriaLabel, previousYearButtonLabel: a.props.previousYearButtonLabel, nextYearAriaLabel: a.props.nextYearAriaLabel, nextYearButtonLabel: a.props.nextYearButtonLabel, timeInputLabel: a.props.timeInputLabel, disabledKeyboardNavigation: a.props.disabledKeyboardNavigation, renderCustomHeader: a.props.renderCustomHeader, popperProps: a.props.popperProps, renderDayContents: a.props.renderDayContents, onDayMouseEnter: a.props.onDayMouseEnter, onMonthMouseLeave: a.props.onMonthMouseLeave, selectsDisabledDaysInRange: a.props.selectsDisabledDaysInRange, showTimeInput: a.props.showTimeInput, showMonthYearPicker: a.props.showMonthYearPicker, showFullMonthYearPicker: a.props.showFullMonthYearPicker, showTwoColumnMonthYearPicker: a.props.showTwoColumnMonthYearPicker, showFourColumnMonthYearPicker: a.props.showFourColumnMonthYearPicker, showYearPicker: a.props.showYearPicker, showQuarterYearPicker: a.props.showQuarterYearPicker, showPopperArrow: a.props.showPopperArrow, excludeScrollbar: a.props.excludeScrollbar, handleOnKeyDown: a.props.onKeyDown, handleOnDayKeyDown: a.onDayKeyDown, isInputFocused: a.state.focused, customTimeInput: a.props.customTimeInput, setPreSelection: a.setPreSelection }, a.props.children) : null;
    }), De(Fe(a), "renderDateInput", function() {
      var i, o = pn(a.props.className, De({}, "react-datepicker-ignore-onclickoutside", a.state.open)), s = a.props.customInput || Ge.createElement("input", { type: "text" }), u = a.props.customInputRef || "ref", f = typeof a.props.value == "string" ? a.props.value : typeof a.state.inputValue == "string" ? a.state.inputValue : a.props.selectsRange ? function(p, m, v) {
        if (!p)
          return "";
        var O = jM(p, v), w = m ? jM(m, v) : "";
        return "".concat(O, " - ").concat(w);
      }(a.props.startDate, a.props.endDate, a.props) : jM(a.props.selected, a.props);
      return Ge.cloneElement(s, (De(i = {}, u, function(p) {
        a.input = p;
      }), De(i, "value", f), De(i, "onBlur", a.handleBlur), De(i, "onChange", a.handleChange), De(i, "onClick", a.onInputClick), De(i, "onFocus", a.handleFocus), De(i, "onKeyDown", a.onInputKeyDown), De(i, "id", a.props.id), De(i, "name", a.props.name), De(i, "form", a.props.form), De(i, "autoFocus", a.props.autoFocus), De(i, "placeholder", a.props.placeholderText), De(i, "disabled", a.props.disabled), De(i, "autoComplete", a.props.autoComplete), De(i, "className", pn(s.props.className, o)), De(i, "title", a.props.title), De(i, "readOnly", a.props.readOnly), De(i, "required", a.props.required), De(i, "tabIndex", a.props.tabIndex), De(i, "aria-describedby", a.props.ariaDescribedBy), De(i, "aria-invalid", a.props.ariaInvalid), De(i, "aria-labelledby", a.props.ariaLabelledBy), De(i, "aria-required", a.props.ariaRequired), i));
    }), De(Fe(a), "renderClearButton", function() {
      var i = a.props, o = i.isClearable, s = i.selected, u = i.startDate, f = i.endDate, p = i.clearButtonTitle, m = i.clearButtonClassName, v = m === void 0 ? "" : m, O = i.ariaLabelClose, w = O === void 0 ? "Close" : O;
      return !o || s == null && u == null && f == null ? null : Ge.createElement("button", { type: "button", className: "react-datepicker__close-icon ".concat(v).trim(), "aria-label": w, onClick: a.onClearClick, title: p, tabIndex: -1 });
    }), a.state = a.calcInitialState(), a;
  }
  return ys(n, [{ key: "componentDidMount", value: function() {
    window.addEventListener("scroll", this.onScroll, !0);
  } }, { key: "componentDidUpdate", value: function(r, a) {
    var i, o;
    r.inline && (i = r.selected, o = this.props.selected, i && o ? uu(i) !== uu(o) || sa(i) !== sa(o) : i !== o) && this.setPreSelection(this.props.selected), this.state.monthSelectedIn !== void 0 && r.monthsShown !== this.props.monthsShown && this.setState({ monthSelectedIn: 0 }), r.highlightDates !== this.props.highlightDates && this.setState({ highlightDates: yZ(this.props.highlightDates) }), a.focused || Hb(r.selected, this.props.selected) || this.setState({ inputValue: null }), a.open !== this.state.open && (a.open === !1 && this.state.open === !0 && this.props.onCalendarOpen(), a.open === !0 && this.state.open === !1 && this.props.onCalendarClose());
  } }, { key: "componentWillUnmount", value: function() {
    this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0);
  } }, { key: "renderInputContainer", value: function() {
    return Ge.createElement("div", { className: "react-datepicker__input-container" }, this.renderDateInput(), this.renderClearButton());
  } }, { key: "render", value: function() {
    var r = this.renderCalendar();
    if (this.props.inline)
      return r;
    if (this.props.withPortal) {
      var a = this.state.open ? Ge.createElement(Dre, { enableTabLoop: this.props.enableTabLoop }, Ge.createElement("div", { className: "react-datepicker__portal", tabIndex: -1, onKeyDown: this.onPortalKeyDown }, r)) : null;
      return this.state.open && this.props.portalId && (a = Ge.createElement(Ire, { portalId: this.props.portalId, portalHost: this.props.portalHost }, a)), Ge.createElement("div", null, this.renderInputContainer(), a);
    }
    return Ge.createElement(Rke, { className: this.props.popperClassName, wrapperClassName: this.props.wrapperClassName, hidePopper: !this.isCalendarOpen(), portalId: this.props.portalId, portalHost: this.props.portalHost, popperModifiers: this.props.popperModifiers, targetComponent: this.renderInputContainer(), popperContainer: this.props.popperContainer, popperComponent: r, popperPlacement: this.props.popperPlacement, popperProps: this.props.popperProps, popperOnKeyDown: this.onPopperKeyDown, enableTabLoop: this.props.enableTabLoop });
  } }], [{ key: "defaultProps", get: function() {
    return { allowSameDay: !1, dateFormat: "MM/dd/yyyy", dateFormatCalendar: "LLLL yyyy", onChange: function() {
    }, disabled: !1, disabledKeyboardNavigation: !1, dropdownMode: "scroll", onFocus: function() {
    }, onBlur: function() {
    }, onKeyDown: function() {
    }, onInputClick: function() {
    }, onSelect: function() {
    }, onClickOutside: function() {
    }, onMonthChange: function() {
    }, onCalendarOpen: function() {
    }, onCalendarClose: function() {
    }, preventOpenOnFocus: !1, onYearChange: function() {
    }, onInputError: function() {
    }, monthsShown: 1, readOnly: !1, withPortal: !1, selectsDisabledDaysInRange: !1, shouldCloseOnSelect: !0, showTimeSelect: !1, showTimeInput: !1, showPreviousMonths: !1, showMonthYearPicker: !1, showFullMonthYearPicker: !1, showTwoColumnMonthYearPicker: !1, showFourColumnMonthYearPicker: !1, showYearPicker: !1, showQuarterYearPicker: !1, strictParsing: !1, timeIntervals: 30, timeCaption: "Time", previousMonthAriaLabel: "Previous Month", previousMonthButtonLabel: "Previous Month", nextMonthAriaLabel: "Next Month", nextMonthButtonLabel: "Next Month", previousYearAriaLabel: "Previous Year", previousYearButtonLabel: "Previous Year", nextYearAriaLabel: "Next Year", nextYearButtonLabel: "Next Year", timeInputLabel: "Time", enableTabLoop: !0, yearItemNumber: 12, renderDayContents: function(r) {
      return r;
    }, focusSelectedMonth: !1, showPopperArrow: !0, excludeScrollbar: !0, customTimeInput: null, calendarStartDay: void 0 };
  } }]), n;
}(), Nke = "input", GM = "navigate";
const RXe = bs(({
  onChange: t,
  name: e,
  label: n,
  className: r,
  value: a,
  readOnly: i,
  placeholder: o,
  disabled: s,
  // todo: remove this isShowTime, replaced with showTimeSelect
  isShowTime: u,
  showTimeSelect: f = u,
  calenderIcon: p,
  startDate: m,
  endDate: v,
  inline: O,
  selectRange: w,
  filterDate: _,
  pickerPlacement: C = "bottom",
  popperClassName: A = "",
  timeZone: N = KI(),
  truncateTime: P
}, I) => {
  const [D, M] = kn(null);
  Vn(() => {
    M(a ? new Date(new Date(a).getTime() - h$(N)) : null);
  }, [a]);
  const H = "byz-date-picker", Y = (Q = null) => {
    let ne = null;
    Q && (P && (Q = DEe(Q)), ne = new Date(Q.getTime() + h$(N))), t ? t({
      value: ne,
      name: e
    }) : M(Q);
  };
  Nl(
    I,
    () => ({
      get value() {
        return D;
      },
      set value(Q) {
        M(Q);
      }
    }),
    [D]
  );
  const q = [{
    name: "preventOverflow",
    options: {
      rootBoundary: "document",
      tether: !1,
      altAxis: !0
    }
  }];
  return /* @__PURE__ */ Ne.jsx(Ne.Fragment, { children: /* @__PURE__ */ Ne.jsxs("div", { className: pn(H, r), children: [
    /* @__PURE__ */ Ne.jsx("div", { className: pn(`${H}__label`), children: n }),
    /* @__PURE__ */ Ne.jsx(
      Dke,
      {
        portalId: "root-portal",
        placeholderText: o,
        disabled: s,
        className: `${H}__input`,
        dateFormat: "yyyy-MM-dd",
        isClearable: !1,
        onChange: Y,
        selected: D,
        todayButton: "Today",
        filterDate: _,
        showTimeSelect: u,
        readOnly: i,
        popperModifiers: q,
        popperPlacement: C,
        inline: O,
        showPopperArrow: !1,
        popperClassName: A
      }
    ),
    p && /* @__PURE__ */ Ne.jsx("span", { className: pn(`${H}__calendar`) })
  ] }) });
});
var Nre = {}, m_ = {}, g_ = {}, eg = {};
const wU = /* @__PURE__ */ na(Cwe), TU = /* @__PURE__ */ na(Fwe), Pre = /* @__PURE__ */ na(Mwe), aD = /* @__PURE__ */ na(Dwe), iD = /* @__PURE__ */ na(JSe), _U = /* @__PURE__ */ na(Ewe);
function qw(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? qw = function(n) {
    return typeof n;
  } : qw = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, qw(t);
}
Object.defineProperty(eg, "__esModule", {
  value: !0
});
eg.default = eg.rangeShape = void 0;
var Fy = Lke(Ge), ea = cv(qf()), VM = cv(iv), EZ = cv(wU), YM = cv(TU), SZ = cv(Pre), gw = cv(aD), Pke = cv(iD), wZ = cv(_U);
function cv(t) {
  return t && t.__esModule ? t : { default: t };
}
function Lre(t) {
  if (typeof WeakMap != "function")
    return null;
  var e = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (Lre = function(a) {
    return a ? n : e;
  })(t);
}
function Lke(t, e) {
  if (!e && t && t.__esModule)
    return t;
  if (t === null || qw(t) !== "object" && typeof t != "function")
    return { default: t };
  var n = Lre(e);
  if (n && n.has(t))
    return n.get(t);
  var r = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in t)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(t, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(t, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(r, i, o) : r[i] = t[i];
    }
  return r.default = t, n && n.set(t, r), r;
}
function FB() {
  return FB = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, FB.apply(this, arguments);
}
function TZ(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Mke(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? TZ(Object(n), !0).forEach(function(r) {
      Yi(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : TZ(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function Fke(t) {
  return zke(t) || Uke(t) || Bke(t) || $ke();
}
function $ke() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Bke(t, e) {
  if (t) {
    if (typeof t == "string")
      return $B(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return $B(t, e);
  }
}
function Uke(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null)
    return Array.from(t);
}
function zke(t) {
  if (Array.isArray(t))
    return $B(t);
}
function $B(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function Hke(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function _Z(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function Wke(t, e, n) {
  return e && _Z(t.prototype, e), n && _Z(t, n), t;
}
function Qke(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && BB(t, e);
}
function BB(t, e) {
  return BB = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, BB(t, e);
}
function jke(t) {
  var e = Vke();
  return function() {
    var r = QR(t), a;
    if (e) {
      var i = QR(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return Gke(this, a);
  };
}
function Gke(t, e) {
  return e && (qw(e) === "object" || typeof e == "function") ? e : sE(t);
}
function sE(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Vke() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function QR(t) {
  return QR = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, QR(t);
}
function Yi(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var CU = /* @__PURE__ */ function(t) {
  Qke(n, t);
  var e = jke(n);
  function n(r, a) {
    var i;
    return Hke(this, n), i = e.call(this, r, a), Yi(sE(i), "handleKeyEvent", function(o) {
      var s = i.props, u = s.day, f = s.onMouseDown, p = s.onMouseUp;
      [
        13,
        32
        /* enter */
      ].includes(o.keyCode) && (o.type === "keydown" ? f(u) : p(u));
    }), Yi(sE(i), "handleMouseEvent", function(o) {
      var s = i.props, u = s.day, f = s.disabled, p = s.onPreviewChange, m = s.onMouseEnter, v = s.onMouseDown, O = s.onMouseUp, w = {};
      if (f) {
        p();
        return;
      }
      switch (o.type) {
        case "mouseenter":
          m(u), p(u), w.hover = !0;
          break;
        case "blur":
        case "mouseleave":
          w.hover = !1;
          break;
        case "mousedown":
          w.active = !0, v(u);
          break;
        case "mouseup":
          o.stopPropagation(), w.active = !1, O(u);
          break;
        case "focus":
          p(u);
          break;
      }
      Object.keys(w).length && i.setState(w);
    }), Yi(sE(i), "getClassNames", function() {
      var o, s = i.props, u = s.isPassive, f = s.isToday, p = s.isWeekend, m = s.isStartOfWeek, v = s.isEndOfWeek, O = s.isStartOfMonth, w = s.isEndOfMonth, _ = s.disabled, C = s.styles;
      return (0, VM.default)(C.day, (o = {}, Yi(o, C.dayPassive, u), Yi(o, C.dayDisabled, _), Yi(o, C.dayToday, f), Yi(o, C.dayWeekend, p), Yi(o, C.dayStartOfWeek, m), Yi(o, C.dayEndOfWeek, v), Yi(o, C.dayStartOfMonth, O), Yi(o, C.dayEndOfMonth, w), Yi(o, C.dayHovered, i.state.hover), Yi(o, C.dayActive, i.state.active), o));
    }), Yi(sE(i), "renderPreviewPlaceholder", function() {
      var o, s = i.props, u = s.preview, f = s.day, p = s.styles;
      if (!u)
        return null;
      var m = u.startDate ? (0, EZ.default)(u.startDate) : null, v = u.endDate ? (0, wZ.default)(u.endDate) : null, O = (!m || (0, SZ.default)(f, m)) && (!v || (0, YM.default)(f, v)), w = !O && (0, gw.default)(f, m), _ = !O && (0, gw.default)(f, v);
      return /* @__PURE__ */ Fy.default.createElement("span", {
        className: (0, VM.default)((o = {}, Yi(o, p.dayStartPreview, w), Yi(o, p.dayInPreview, O), Yi(o, p.dayEndPreview, _), o)),
        style: {
          color: u.color
        }
      });
    }), Yi(sE(i), "renderSelectionPlaceholders", function() {
      var o = i.props, s = o.styles, u = o.ranges, f = o.day;
      if (i.props.displayMode === "date") {
        var p = (0, gw.default)(i.props.day, i.props.date);
        return p ? /* @__PURE__ */ Fy.default.createElement("span", {
          className: s.selected,
          style: {
            color: i.props.color
          }
        }) : null;
      }
      var m = u.reduce(function(v, O) {
        var w = O.startDate, _ = O.endDate;
        if (w && _ && (0, YM.default)(_, w)) {
          var C = [_, w];
          w = C[0], _ = C[1];
        }
        w = w ? (0, EZ.default)(w) : null, _ = _ ? (0, wZ.default)(_) : null;
        var A = (!w || (0, SZ.default)(f, w)) && (!_ || (0, YM.default)(f, _)), N = !A && (0, gw.default)(f, w), P = !A && (0, gw.default)(f, _);
        return A || N || P ? [].concat(Fke(v), [Mke({
          isStartEdge: N,
          isEndEdge: P,
          isInRange: A
        }, O)]) : v;
      }, []);
      return m.map(function(v, O) {
        var w;
        return /* @__PURE__ */ Fy.default.createElement("span", {
          key: O,
          className: (0, VM.default)((w = {}, Yi(w, s.startEdge, v.isStartEdge), Yi(w, s.endEdge, v.isEndEdge), Yi(w, s.inRange, v.isInRange), w)),
          style: {
            color: v.color || i.props.color
          }
        });
      });
    }), i.state = {
      hover: !1,
      active: !1
    }, i;
  }
  return Wke(n, [{
    key: "render",
    value: function() {
      var a = this.props.dayContentRenderer;
      return /* @__PURE__ */ Fy.default.createElement("button", FB({
        type: "button",
        onMouseEnter: this.handleMouseEvent,
        onMouseLeave: this.handleMouseEvent,
        onFocus: this.handleMouseEvent,
        onMouseDown: this.handleMouseEvent,
        onMouseUp: this.handleMouseEvent,
        onBlur: this.handleMouseEvent,
        onPauseCapture: this.handleMouseEvent,
        onKeyDown: this.handleKeyEvent,
        onKeyUp: this.handleKeyEvent,
        className: this.getClassNames(this.props.styles)
      }, this.props.disabled || this.props.isPassive ? {
        tabIndex: -1
      } : {}, {
        style: {
          color: this.props.color
        }
      }), this.renderSelectionPlaceholders(), this.renderPreviewPlaceholder(), /* @__PURE__ */ Fy.default.createElement("span", {
        className: this.props.styles.dayNumber
      }, (a == null ? void 0 : a(this.props.day)) || /* @__PURE__ */ Fy.default.createElement("span", null, (0, Pke.default)(this.props.day, this.props.dayDisplayFormat))));
    }
  }]), n;
}(Fy.Component);
CU.defaultProps = {};
var Mre = ea.default.shape({
  startDate: ea.default.object,
  endDate: ea.default.object,
  color: ea.default.string,
  key: ea.default.string,
  autoFocus: ea.default.bool,
  disabled: ea.default.bool,
  showDateDisplay: ea.default.bool
});
eg.rangeShape = Mre;
CU.propTypes = {
  day: ea.default.object.isRequired,
  dayDisplayFormat: ea.default.string,
  date: ea.default.object,
  ranges: ea.default.arrayOf(Mre),
  preview: ea.default.shape({
    startDate: ea.default.object,
    endDate: ea.default.object,
    color: ea.default.string
  }),
  onPreviewChange: ea.default.func,
  previewColor: ea.default.string,
  disabled: ea.default.bool,
  isPassive: ea.default.bool,
  isToday: ea.default.bool,
  isWeekend: ea.default.bool,
  isStartOfWeek: ea.default.bool,
  isEndOfWeek: ea.default.bool,
  isStartOfMonth: ea.default.bool,
  isEndOfMonth: ea.default.bool,
  color: ea.default.string,
  displayMode: ea.default.oneOf(["dateRange", "date"]),
  styles: ea.default.object,
  onMouseDown: ea.default.func,
  onMouseUp: ea.default.func,
  onMouseEnter: ea.default.func,
  dayContentRenderer: ea.default.func
};
var Yke = CU;
eg.default = Yke;
var oD = {};
function Zke(t, e) {
  var n;
  Kt(1, arguments);
  var r = t || {}, a = an(r.start), i = an(r.end), o = i.getTime();
  if (!(a.getTime() <= o))
    throw new RangeError("Invalid interval");
  var s = [], u = a;
  u.setHours(0, 0, 0, 0);
  var f = Number((n = e == null ? void 0 : e.step) !== null && n !== void 0 ? n : 1);
  if (f < 1 || isNaN(f))
    throw new RangeError("`options.step` must be a number greater than 1");
  for (; u.getTime() <= o; )
    s.push(an(u)), u.setDate(u.getDate() + f), u.setHours(0, 0, 0, 0);
  return s;
}
const Xke = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Zke
}, Symbol.toStringTag, { value: "Module" })), Fre = /* @__PURE__ */ na(Xke), $re = /* @__PURE__ */ na($we);
function qke(t) {
  Kt(1, arguments);
  var e = an(t), n = e.getDay();
  return n === 0 || n === 6;
}
const Kke = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qke
}, Symbol.toStringTag, { value: "Module" })), Jke = /* @__PURE__ */ na(Kke), sD = /* @__PURE__ */ na(Awe), lD = /* @__PURE__ */ na(cwe);
var ag = {};
const uD = /* @__PURE__ */ na(rwe), Bre = /* @__PURE__ */ na(Twe), xU = /* @__PURE__ */ na(wwe), AU = /* @__PURE__ */ na(kwe), kU = /* @__PURE__ */ na(_we);
Object.defineProperty(ag, "__esModule", {
  value: !0
});
ag.calcFocusDate = oRe;
ag.findNextRangeIndex = sRe;
ag.getMonthDisplayRange = lRe;
ag.generateStyles = uRe;
var eRe = fv(iv), tRe = fv(uD), nRe = fv(Bre), rRe = fv(xU), aRe = fv(sD), iRe = fv(lD), Ure = fv(AU), zre = fv(kU);
function fv(t) {
  return t && t.__esModule ? t : { default: t };
}
function oRe(t, e) {
  var n = e.shownDate, r = e.date, a = e.months, i = e.ranges, o = e.focusedRange, s = e.displayMode, u;
  if (s === "dateRange") {
    var f = i[o[0]] || {};
    u = {
      start: f.startDate,
      end: f.endDate
    };
  } else
    u = {
      start: r,
      end: r
    };
  u.start = (0, zre.default)(u.start || /* @__PURE__ */ new Date()), u.end = (0, Ure.default)(u.end || u.start);
  var p = u.start || u.end || n || /* @__PURE__ */ new Date();
  return t ? (0, nRe.default)(u.start, u.end) > a ? t : p : n || p;
}
function sRe(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1, n = t.findIndex(function(r, a) {
    return a > e && r.autoFocus !== !1 && !r.disabled;
  });
  return n !== -1 ? n : t.findIndex(function(r) {
    return r.autoFocus !== !1 && !r.disabled;
  });
}
function lRe(t, e, n) {
  var r = (0, zre.default)(t, e), a = (0, Ure.default)(t, e), i = (0, iRe.default)(r, e), o = (0, aRe.default)(a, e);
  return n && (0, rRe.default)(o, i) <= 34 && (o = (0, tRe.default)(o, 7)), {
    start: i,
    end: o,
    startDateOfMonth: r,
    endDateOfMonth: a
  };
}
function uRe(t) {
  if (!t.length)
    return {};
  var e = t.filter(function(n) {
    return !!n;
  }).reduce(function(n, r) {
    return Object.keys(r).forEach(function(a) {
      n[a] = (0, eRe.default)(n[a], r[a]);
    }), n;
  }, {});
  return e;
}
function Kw(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Kw = function(n) {
    return typeof n;
  } : Kw = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Kw(t);
}
Object.defineProperty(oD, "__esModule", {
  value: !0
});
oD.default = void 0;
var Vy = Yre(Ge), ja = Kf(qf()), Hre = Yre(eg), Wre = Kf(Fre), cRe = Kf($re), fRe = Kf(Jke), dRe = Kf(Pre), KO = Kf(aD), pRe = Kf(TU), Qre = Kf(sD), jre = Kf(lD), hRe = Kf(wU), mRe = Kf(_U), Gre = Kf(iD), gRe = ag;
function Kf(t) {
  return t && t.__esModule ? t : { default: t };
}
function Vre(t) {
  if (typeof WeakMap != "function")
    return null;
  var e = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (Vre = function(a) {
    return a ? n : e;
  })(t);
}
function Yre(t, e) {
  if (!e && t && t.__esModule)
    return t;
  if (t === null || Kw(t) !== "object" && typeof t != "function")
    return { default: t };
  var n = Vre(e);
  if (n && n.has(t))
    return n.get(t);
  var r = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in t)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(t, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(t, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(r, i, o) : r[i] = t[i];
    }
  return r.default = t, n && n.set(t, r), r;
}
function UB() {
  return UB = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, UB.apply(this, arguments);
}
function CZ(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function xZ(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? CZ(Object(n), !0).forEach(function(r) {
      bRe(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : CZ(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function bRe(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function vRe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function AZ(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function yRe(t, e, n) {
  return e && AZ(t.prototype, e), n && AZ(t, n), t;
}
function ORe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && zB(t, e);
}
function zB(t, e) {
  return zB = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, zB(t, e);
}
function ERe(t) {
  var e = TRe();
  return function() {
    var r = jR(t), a;
    if (e) {
      var i = jR(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return SRe(this, a);
  };
}
function SRe(t, e) {
  return e && (Kw(e) === "object" || typeof e == "function") ? e : wRe(t);
}
function wRe(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function TRe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function jR(t) {
  return jR = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, jR(t);
}
function _Re(t, e, n) {
  var r = /* @__PURE__ */ new Date();
  return /* @__PURE__ */ Vy.default.createElement("div", {
    className: t.weekDays
  }, (0, Wre.default)({
    start: (0, jre.default)(r, e),
    end: (0, Qre.default)(r, e)
  }).map(function(a, i) {
    return /* @__PURE__ */ Vy.default.createElement("span", {
      className: t.weekDay,
      key: i
    }, (0, Gre.default)(a, n, e));
  }));
}
var RU = /* @__PURE__ */ function(t) {
  ORe(n, t);
  var e = ERe(n);
  function n() {
    return vRe(this, n), e.apply(this, arguments);
  }
  return yRe(n, [{
    key: "render",
    value: function() {
      var a = this, i = /* @__PURE__ */ new Date(), o = this.props, s = o.displayMode, u = o.focusedRange, f = o.drag, p = o.styles, m = o.disabledDates, v = o.disabledDay, O = this.props.minDate && (0, mRe.default)(this.props.minDate), w = this.props.maxDate && (0, hRe.default)(this.props.maxDate), _ = (0, gRe.getMonthDisplayRange)(this.props.month, this.props.dateOptions, this.props.fixedHeight), C = this.props.ranges;
      if (s === "dateRange" && f.status) {
        var A = f.range, N = A.startDate, P = A.endDate;
        C = C.map(function(D, M) {
          return M !== u[0] ? D : xZ(xZ({}, D), {}, {
            startDate: N,
            endDate: P
          });
        });
      }
      var I = this.props.showPreview && !f.disablePreview;
      return /* @__PURE__ */ Vy.default.createElement("div", {
        className: p.month,
        style: this.props.style
      }, this.props.showMonthName ? /* @__PURE__ */ Vy.default.createElement("div", {
        className: p.monthName
      }, (0, Gre.default)(this.props.month, this.props.monthDisplayFormat, this.props.dateOptions)) : null, this.props.showWeekDays && _Re(p, this.props.dateOptions, this.props.weekdayDisplayFormat), /* @__PURE__ */ Vy.default.createElement("div", {
        className: p.days,
        onMouseLeave: this.props.onMouseLeave
      }, (0, Wre.default)({
        start: _.start,
        end: _.end
      }).map(function(D, M) {
        var H = (0, KO.default)(D, _.startDateOfMonth), Y = (0, KO.default)(D, _.endDateOfMonth), q = O && (0, pRe.default)(D, O) || w && (0, dRe.default)(D, w), Q = m.some(function(J) {
          return (0, KO.default)(J, D);
        }), ne = v(D);
        return /* @__PURE__ */ Vy.default.createElement(Hre.default, UB({}, a.props, {
          ranges: C,
          day: D,
          preview: I ? a.props.preview : null,
          isWeekend: (0, fRe.default)(D, a.props.dateOptions),
          isToday: (0, KO.default)(D, i),
          isStartOfWeek: (0, KO.default)(D, (0, jre.default)(D, a.props.dateOptions)),
          isEndOfWeek: (0, KO.default)(D, (0, Qre.default)(D, a.props.dateOptions)),
          isStartOfMonth: H,
          isEndOfMonth: Y,
          key: M,
          disabled: q || Q || ne,
          isPassive: !(0, cRe.default)(D, {
            start: _.startDateOfMonth,
            end: _.endDateOfMonth
          }),
          styles: p,
          onMouseDown: a.props.onDragSelectionStart,
          onMouseUp: a.props.onDragSelectionEnd,
          onMouseEnter: a.props.onDragSelectionMove,
          dragRange: f.range,
          drag: f.status
        }));
      })));
    }
  }]), n;
}(Vy.PureComponent);
RU.defaultProps = {};
RU.propTypes = {
  style: ja.default.object,
  styles: ja.default.object,
  month: ja.default.object,
  drag: ja.default.object,
  dateOptions: ja.default.object,
  disabledDates: ja.default.array,
  disabledDay: ja.default.func,
  preview: ja.default.shape({
    startDate: ja.default.object,
    endDate: ja.default.object
  }),
  showPreview: ja.default.bool,
  displayMode: ja.default.oneOf(["dateRange", "date"]),
  minDate: ja.default.object,
  maxDate: ja.default.object,
  ranges: ja.default.arrayOf(Hre.rangeShape),
  focusedRange: ja.default.arrayOf(ja.default.number),
  onDragSelectionStart: ja.default.func,
  onDragSelectionEnd: ja.default.func,
  onDragSelectionMove: ja.default.func,
  onMouseLeave: ja.default.func,
  monthDisplayFormat: ja.default.string,
  weekdayDisplayFormat: ja.default.string,
  dayDisplayFormat: ja.default.string,
  showWeekDays: ja.default.bool,
  showMonthName: ja.default.bool,
  fixedHeight: ja.default.bool
};
var CRe = RU;
oD.default = CRe;
var cD = {};
const xRe = /* @__PURE__ */ na(Iwe), ARe = /* @__PURE__ */ na(V1e), kRe = /* @__PURE__ */ na(uAe);
function Jw(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Jw = function(n) {
    return typeof n;
  } : Jw = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Jw(t);
}
Object.defineProperty(cD, "__esModule", {
  value: !0
});
cD.default = void 0;
var Nx = PRe(Ge), lh = s1(qf()), RRe = s1(iv), IRe = s1(xRe), kZ = s1(ARe), DRe = s1(kRe), NRe = s1(iD);
function s1(t) {
  return t && t.__esModule ? t : { default: t };
}
function Zre(t) {
  if (typeof WeakMap != "function")
    return null;
  var e = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (Zre = function(a) {
    return a ? n : e;
  })(t);
}
function PRe(t, e) {
  if (!e && t && t.__esModule)
    return t;
  if (t === null || Jw(t) !== "object" && typeof t != "function")
    return { default: t };
  var n = Zre(e);
  if (n && n.has(t))
    return n.get(t);
  var r = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in t)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(t, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(t, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(r, i, o) : r[i] = t[i];
    }
  return r.default = t, n && n.set(t, r), r;
}
function LRe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function RZ(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function MRe(t, e, n) {
  return e && RZ(t.prototype, e), n && RZ(t, n), t;
}
function FRe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && HB(t, e);
}
function HB(t, e) {
  return HB = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, HB(t, e);
}
function $Re(t) {
  var e = URe();
  return function() {
    var r = GR(t), a;
    if (e) {
      var i = GR(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return BRe(this, a);
  };
}
function BRe(t, e) {
  return e && (Jw(e) === "object" || typeof e == "function") ? e : vk(t);
}
function vk(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function URe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function GR(t) {
  return GR = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, GR(t);
}
function ZM(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var IU = /* @__PURE__ */ function(t) {
  FRe(n, t);
  var e = $Re(n);
  function n(r, a) {
    var i;
    return LRe(this, n), i = e.call(this, r, a), ZM(vk(i), "onKeyDown", function(o) {
      var s = i.state.value;
      o.key === "Enter" && i.update(s);
    }), ZM(vk(i), "onChange", function(o) {
      i.setState({
        value: o.target.value,
        changed: !0,
        invalid: !1
      });
    }), ZM(vk(i), "onBlur", function() {
      var o = i.state.value;
      i.update(o);
    }), i.state = {
      invalid: !1,
      changed: !1,
      value: i.formatDate(r)
    }, i;
  }
  return MRe(n, [{
    key: "componentDidUpdate",
    value: function(a) {
      var i = a.value;
      (0, IRe.default)(i, this.props.value) || this.setState({
        value: this.formatDate(this.props)
      });
    }
  }, {
    key: "formatDate",
    value: function(a) {
      var i = a.value, o = a.dateDisplayFormat, s = a.dateOptions;
      return i && (0, kZ.default)(i) ? (0, NRe.default)(i, o, s) : "";
    }
  }, {
    key: "update",
    value: function(a) {
      var i = this.state, o = i.invalid, s = i.changed;
      if (!(o || !s || !a)) {
        var u = this.props, f = u.onChange, p = u.dateDisplayFormat, m = u.dateOptions, v = (0, DRe.default)(a, p, /* @__PURE__ */ new Date(), m);
        (0, kZ.default)(v) ? this.setState({
          changed: !1
        }, function() {
          return f(v);
        }) : this.setState({
          invalid: !0
        });
      }
    }
  }, {
    key: "render",
    value: function() {
      var a = this.props, i = a.className, o = a.readOnly, s = a.placeholder, u = a.ariaLabel, f = a.disabled, p = a.onFocus, m = this.state, v = m.value, O = m.invalid;
      return /* @__PURE__ */ Nx.default.createElement("span", {
        className: (0, RRe.default)("rdrDateInput", i)
      }, /* @__PURE__ */ Nx.default.createElement("input", {
        readOnly: o,
        disabled: f,
        value: v,
        placeholder: s,
        "aria-label": u,
        onKeyDown: this.onKeyDown,
        onChange: this.onChange,
        onBlur: this.onBlur,
        onFocus: p
      }), O && /* @__PURE__ */ Nx.default.createElement("span", {
        className: "rdrWarning"
      }, "⚠"));
    }
  }]), n;
}(Nx.PureComponent);
IU.propTypes = {
  value: lh.default.object,
  placeholder: lh.default.string,
  disabled: lh.default.bool,
  readOnly: lh.default.bool,
  dateOptions: lh.default.object,
  dateDisplayFormat: lh.default.string,
  ariaLabel: lh.default.string,
  className: lh.default.string,
  onFocus: lh.default.func.isRequired,
  onChange: lh.default.func.isRequired
};
IU.defaultProps = {
  readOnly: !0,
  disabled: !1,
  dateDisplayFormat: "MMM D, YYYY"
};
var zRe = IU;
cD.default = zRe;
var Xre = { exports: {} };
(function(t, e) {
  (function(n, r) {
    r(qf(), Ge);
  })(typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : $b, function(n, r) {
    n = u(n), r = s(r);
    var a, i;
    function o() {
      if (typeof WeakMap != "function")
        return null;
      var ce = /* @__PURE__ */ new WeakMap();
      return o = function() {
        return ce;
      }, ce;
    }
    function s(ce) {
      if (ce && ce.__esModule)
        return ce;
      if (ce === null || f(ce) !== "object" && typeof ce != "function")
        return { default: ce };
      var j = o();
      if (j && j.has(ce))
        return j.get(ce);
      var K = {}, Ee = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var he in ce)
        if (Object.prototype.hasOwnProperty.call(ce, he)) {
          var Ae = Ee ? Object.getOwnPropertyDescriptor(ce, he) : null;
          Ae && (Ae.get || Ae.set) ? Object.defineProperty(K, he, Ae) : K[he] = ce[he];
        }
      return K.default = ce, j && j.set(ce, K), K;
    }
    function u(ce) {
      return ce && ce.__esModule ? ce : { default: ce };
    }
    function f(ce) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? f = function(K) {
        return typeof K;
      } : f = function(K) {
        return K && typeof Symbol == "function" && K.constructor === Symbol && K !== Symbol.prototype ? "symbol" : typeof K;
      }, f(ce);
    }
    function p(ce, j) {
      if (!(ce instanceof j))
        throw new TypeError("Cannot call a class as a function");
    }
    function m(ce, j) {
      for (var K = 0; K < j.length; K++) {
        var Ee = j[K];
        Ee.enumerable = Ee.enumerable || !1, Ee.configurable = !0, "value" in Ee && (Ee.writable = !0), Object.defineProperty(ce, Ee.key, Ee);
      }
    }
    function v(ce, j, K) {
      return j && m(ce.prototype, j), K && m(ce, K), ce;
    }
    function O(ce, j) {
      if (typeof j != "function" && j !== null)
        throw new TypeError("Super expression must either be null or a function");
      ce.prototype = Object.create(j && j.prototype, { constructor: { value: ce, writable: !0, configurable: !0 } }), j && w(ce, j);
    }
    function w(ce, j) {
      return w = Object.setPrototypeOf || function(Ee, he) {
        return Ee.__proto__ = he, Ee;
      }, w(ce, j);
    }
    function _(ce) {
      var j = N();
      return function() {
        var Ee = P(ce), he;
        if (j) {
          var Ae = P(this).constructor;
          he = Reflect.construct(Ee, arguments, Ae);
        } else
          he = Ee.apply(this, arguments);
        return C(this, he);
      };
    }
    function C(ce, j) {
      return j && (f(j) === "object" || typeof j == "function") ? j : A(ce);
    }
    function A(ce) {
      if (ce === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return ce;
    }
    function N() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function P(ce) {
      return P = Object.setPrototypeOf ? Object.getPrototypeOf : function(K) {
        return K.__proto__ || Object.getPrototypeOf(K);
      }, P(ce);
    }
    function I(ce, j) {
      var K = Object.keys(ce);
      if (Object.getOwnPropertySymbols) {
        var Ee = Object.getOwnPropertySymbols(ce);
        j && (Ee = Ee.filter(function(he) {
          return Object.getOwnPropertyDescriptor(ce, he).enumerable;
        })), K.push.apply(K, Ee);
      }
      return K;
    }
    function D(ce) {
      for (var j = 1; j < arguments.length; j++) {
        var K = arguments[j] != null ? arguments[j] : {};
        j % 2 ? I(Object(K), !0).forEach(function(Ee) {
          M(ce, Ee, K[Ee]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(ce, Object.getOwnPropertyDescriptors(K)) : I(Object(K)).forEach(function(Ee) {
          Object.defineProperty(ce, Ee, Object.getOwnPropertyDescriptor(K, Ee));
        });
      }
      return ce;
    }
    function M(ce, j, K) {
      return j in ce ? Object.defineProperty(ce, j, { value: K, enumerable: !0, configurable: !0, writable: !0 }) : ce[j] = K, ce;
    }
    var H = {
      x: "clientWidth",
      y: "clientHeight"
    }, Y = {
      x: "clientTop",
      y: "clientLeft"
    }, q = {
      x: "innerWidth",
      y: "innerHeight"
    }, Q = {
      x: "offsetWidth",
      y: "offsetHeight"
    }, ne = {
      x: "offsetLeft",
      y: "offsetTop"
    }, J = {
      x: "overflowX",
      y: "overflowY"
    }, ue = {
      x: "scrollWidth",
      y: "scrollHeight"
    }, ee = {
      x: "scrollLeft",
      y: "scrollTop"
    }, fe = {
      x: "width",
      y: "height"
    }, de = function() {
    }, ie = function() {
      if (typeof window > "u")
        return !1;
      var ce = !1;
      try {
        document.createElement("div").addEventListener("test", de, {
          get passive() {
            return ce = !0, !1;
          }
        });
      } catch {
      }
      return ce;
    }() ? {
      passive: !0
    } : !1, le = "ReactList failed to reach a stable state.", ye = 40, B = function(j, K) {
      for (var Ee in K)
        if (j[Ee] !== K[Ee])
          return !1;
      return !0;
    }, pe = function(j) {
      for (var K = j.props.axis, Ee = j.getEl(), he = J[K]; Ee = Ee.parentElement; )
        switch (window.getComputedStyle(Ee)[he]) {
          case "auto":
          case "scroll":
          case "overlay":
            return Ee;
        }
      return window;
    }, _e = function(j) {
      var K = j.props.axis, Ee = j.scrollParent;
      return Ee === window ? window[q[K]] : Ee[H[K]];
    }, Z = function(j, K) {
      var Ee = j.length, he = j.minSize, Ae = j.type, Te = K.from, je = K.size, we = K.itemsPerRow;
      je = Math.max(je, he);
      var lt = je % we;
      return lt && (je += we - lt), je > Ee && (je = Ee), Te = Ae === "simple" || !Te ? 0 : Math.max(Math.min(Te, Ee - je), 0), (lt = Te % we) && (Te -= lt, je += lt), Te === K.from && je == K.size ? K : D(D({}, K), {}, {
        from: Te,
        size: je
      });
    };
    t.exports = (i = a = /* @__PURE__ */ function(ce) {
      O(K, ce);
      var j = _(K);
      v(K, null, [{
        key: "getDerivedStateFromProps",
        value: function(he, Ae) {
          var Te = Z(he, Ae);
          return Te === Ae ? null : Te;
        }
      }]);
      function K(Ee) {
        var he;
        return p(this, K), he = j.call(this, Ee), he.state = Z(Ee, {
          itemsPerRow: 1,
          from: Ee.initialIndex,
          size: 0
        }), he.cache = {}, he.cachedScrollPosition = null, he.prevPrevState = {}, he.unstable = !1, he.updateCounter = 0, he;
      }
      return v(K, [{
        key: "componentDidMount",
        value: function() {
          this.updateFrameAndClearCache = this.updateFrameAndClearCache.bind(this), window.addEventListener("resize", this.updateFrameAndClearCache), this.updateFrame(this.scrollTo.bind(this, this.props.initialIndex));
        }
      }, {
        key: "componentDidUpdate",
        value: function(he) {
          var Ae = this;
          if (this.props.axis !== he.axis && this.clearSizeCache(), !this.unstable) {
            if (++this.updateCounter > ye)
              return this.unstable = !0, console.error(le);
            this.updateCounterTimeoutId || (this.updateCounterTimeoutId = setTimeout(function() {
              Ae.updateCounter = 0, delete Ae.updateCounterTimeoutId;
            }, 0)), this.updateFrame();
          }
        }
      }, {
        key: "maybeSetState",
        value: function(he, Ae) {
          if (B(this.state, he))
            return Ae();
          this.setState(he, Ae);
        }
      }, {
        key: "componentWillUnmount",
        value: function() {
          window.removeEventListener("resize", this.updateFrameAndClearCache), this.scrollParent.removeEventListener("scroll", this.updateFrameAndClearCache, ie), this.scrollParent.removeEventListener("mousewheel", de, ie);
        }
      }, {
        key: "getOffset",
        value: function(he) {
          var Ae = this.props.axis, Te = he[Y[Ae]] || 0, je = ne[Ae];
          do
            Te += he[je] || 0;
          while (he = he.offsetParent);
          return Te;
        }
      }, {
        key: "getEl",
        value: function() {
          return this.el || this.items;
        }
      }, {
        key: "getScrollPosition",
        value: function() {
          if (typeof this.cachedScrollPosition == "number")
            return this.cachedScrollPosition;
          var he = this.scrollParent, Ae = this.props.axis, Te = ee[Ae], je = he === window ? (
            // Firefox always returns document.body[scrollKey] as 0 and Chrome/Safari
            // always return document.documentElement[scrollKey] as 0, so take
            // whichever has a value.
            document.body[Te] || document.documentElement[Te]
          ) : he[Te], we = this.getScrollSize() - this.props.scrollParentViewportSizeGetter(this), lt = Math.max(0, Math.min(je, we)), st = this.getEl();
          return this.cachedScrollPosition = this.getOffset(he) + lt - this.getOffset(st), this.cachedScrollPosition;
        }
      }, {
        key: "setScroll",
        value: function(he) {
          var Ae = this.scrollParent, Te = this.props.axis;
          if (he += this.getOffset(this.getEl()), Ae === window)
            return window.scrollTo(0, he);
          he -= this.getOffset(this.scrollParent), Ae[ee[Te]] = he;
        }
      }, {
        key: "getScrollSize",
        value: function() {
          var he = this.scrollParent, Ae = document, Te = Ae.body, je = Ae.documentElement, we = ue[this.props.axis];
          return he === window ? Math.max(Te[we], je[we]) : he[we];
        }
      }, {
        key: "hasDeterminateSize",
        value: function() {
          var he = this.props, Ae = he.itemSizeGetter, Te = he.type;
          return Te === "uniform" || Ae;
        }
      }, {
        key: "getStartAndEnd",
        value: function() {
          var he = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props.threshold, Ae = this.getScrollPosition(), Te = Math.max(0, Ae - he), je = Ae + this.props.scrollParentViewportSizeGetter(this) + he;
          return this.hasDeterminateSize() && (je = Math.min(je, this.getSpaceBefore(this.props.length))), {
            start: Te,
            end: je
          };
        }
      }, {
        key: "getItemSizeAndItemsPerRow",
        value: function() {
          var he = this.props, Ae = he.axis, Te = he.useStaticSize, je = this.state, we = je.itemSize, lt = je.itemsPerRow;
          if (Te && we && lt)
            return {
              itemSize: we,
              itemsPerRow: lt
            };
          var st = this.items.children;
          if (!st.length)
            return {};
          var Oe = st[0], Re = Oe[Q[Ae]], Be = Math.abs(Re - we);
          if ((isNaN(Be) || Be >= 1) && (we = Re), !we)
            return {};
          var mt = ne[Ae], Tt = Oe[mt];
          lt = 1;
          for (var ut = st[lt]; ut && ut[mt] === Tt; ut = st[lt])
            ++lt;
          return {
            itemSize: we,
            itemsPerRow: lt
          };
        }
      }, {
        key: "clearSizeCache",
        value: function() {
          this.cachedScrollPosition = null;
        }
        // Called by 'scroll' and 'resize' events, clears scroll position cache.
      }, {
        key: "updateFrameAndClearCache",
        value: function(he) {
          return this.clearSizeCache(), this.updateFrame(he);
        }
      }, {
        key: "updateFrame",
        value: function(he) {
          switch (this.updateScrollParent(), typeof he != "function" && (he = de), this.props.type) {
            case "simple":
              return this.updateSimpleFrame(he);
            case "variable":
              return this.updateVariableFrame(he);
            case "uniform":
              return this.updateUniformFrame(he);
          }
        }
      }, {
        key: "updateScrollParent",
        value: function() {
          var he = this.scrollParent;
          this.scrollParent = this.props.scrollParentGetter(this), he !== this.scrollParent && (he && (he.removeEventListener("scroll", this.updateFrameAndClearCache), he.removeEventListener("mousewheel", de)), this.clearSizeCache(), this.scrollParent.addEventListener("scroll", this.updateFrameAndClearCache, ie), this.scrollParent.addEventListener("mousewheel", de, ie));
        }
      }, {
        key: "updateSimpleFrame",
        value: function(he) {
          var Ae = this.getStartAndEnd(), Te = Ae.end, je = this.items.children, we = 0;
          if (je.length) {
            var lt = this.props.axis, st = je[0], Oe = je[je.length - 1];
            we = this.getOffset(Oe) + Oe[Q[lt]] - this.getOffset(st);
          }
          if (we > Te)
            return he();
          var Re = this.props, Be = Re.pageSize, mt = Re.length, Tt = Math.min(this.state.size + Be, mt);
          this.maybeSetState({
            size: Tt
          }, he);
        }
      }, {
        key: "updateVariableFrame",
        value: function(he) {
          this.props.itemSizeGetter || this.cacheSizes();
          for (var Ae = this.getStartAndEnd(), Te = Ae.start, je = Ae.end, we = this.props, lt = we.length, st = we.pageSize, Oe = 0, Re = 0, Be = 0, mt = lt - 1; Re < mt; ) {
            var Tt = this.getSizeOfItem(Re);
            if (Tt == null || Oe + Tt > Te)
              break;
            Oe += Tt, ++Re;
          }
          for (var ut = lt - Re; Be < ut && Oe < je; ) {
            var wt = this.getSizeOfItem(Re + Be);
            if (wt == null) {
              Be = Math.min(Be + st, ut);
              break;
            }
            Oe += wt, ++Be;
          }
          this.maybeSetState(Z(this.props, {
            from: Re,
            itemsPerRow: 1,
            size: Be
          }), he);
        }
      }, {
        key: "updateUniformFrame",
        value: function(he) {
          var Ae = this.getItemSizeAndItemsPerRow(), Te = Ae.itemSize, je = Ae.itemsPerRow;
          if (!Te || !je)
            return he();
          var we = this.getStartAndEnd(), lt = we.start, st = we.end, Oe = Z(this.props, {
            from: Math.floor(lt / Te) * je,
            size: (Math.ceil((st - lt) / Te) + 1) * je,
            itemsPerRow: je
          }), Re = Oe.from, Be = Oe.size;
          return this.maybeSetState({
            itemsPerRow: je,
            from: Re,
            itemSize: Te,
            size: Be
          }, he);
        }
      }, {
        key: "getSpaceBefore",
        value: function(he) {
          var Ae = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          if (Ae[he] != null)
            return Ae[he];
          var Te = this.state, je = Te.itemSize, we = Te.itemsPerRow;
          if (je)
            return Ae[he] = Math.floor(he / we) * je;
          for (var lt = he; lt > 0 && Ae[--lt] == null; )
            ;
          for (var st = Ae[lt] || 0, Oe = lt; Oe < he; ++Oe) {
            Ae[Oe] = st;
            var Re = this.getSizeOfItem(Oe);
            if (Re == null)
              break;
            st += Re;
          }
          return Ae[he] = st;
        }
      }, {
        key: "cacheSizes",
        value: function() {
          for (var he = this.cache, Ae = this.state.from, Te = this.items.children, je = Q[this.props.axis], we = 0, lt = Te.length; we < lt; ++we)
            he[Ae + we] = Te[we][je];
        }
      }, {
        key: "getSizeOfItem",
        value: function(he) {
          var Ae = this.cache, Te = this.items, je = this.props, we = je.axis, lt = je.itemSizeGetter, st = je.itemSizeEstimator, Oe = je.type, Re = this.state, Be = Re.from, mt = Re.itemSize, Tt = Re.size;
          if (mt)
            return mt;
          if (lt)
            return lt(he);
          if (he in Ae)
            return Ae[he];
          if (Oe === "simple" && he >= Be && he < Be + Tt && Te) {
            var ut = Te.children[he - Be];
            if (ut)
              return ut[Q[we]];
          }
          if (st)
            return st(he, Ae);
        }
      }, {
        key: "scrollTo",
        value: function(he) {
          he != null && this.setScroll(this.getSpaceBefore(he));
        }
      }, {
        key: "scrollAround",
        value: function(he) {
          var Ae = this.getScrollPosition(), Te = this.getSpaceBefore(he), je = Te - this.props.scrollParentViewportSizeGetter(this) + this.getSizeOfItem(he), we = Math.min(je, Te), lt = Math.max(je, Te);
          if (Ae <= we)
            return this.setScroll(we);
          if (Ae > lt)
            return this.setScroll(lt);
        }
      }, {
        key: "getVisibleRange",
        value: function() {
          for (var he = this.state, Ae = he.from, Te = he.size, je = this.getStartAndEnd(0), we = je.start, lt = je.end, st = {}, Oe, Re, Be = Ae; Be < Ae + Te; ++Be) {
            var mt = this.getSpaceBefore(Be, st), Tt = mt + this.getSizeOfItem(Be);
            Oe == null && Tt > we && (Oe = Be), Oe != null && mt < lt && (Re = Be);
          }
          return [Oe, Re];
        }
      }, {
        key: "renderItems",
        value: function() {
          for (var he = this, Ae = this.props, Te = Ae.itemRenderer, je = Ae.itemsRenderer, we = this.state, lt = we.from, st = we.size, Oe = [], Re = 0; Re < st; ++Re)
            Oe.push(Te(lt + Re, Re));
          return je(Oe, function(Be) {
            return he.items = Be;
          });
        }
      }, {
        key: "render",
        value: function() {
          var he = this, Ae = this.props, Te = Ae.axis, je = Ae.length, we = Ae.type, lt = Ae.useTranslate3d, st = this.state, Oe = st.from, Re = st.itemsPerRow, Be = this.renderItems();
          if (we === "simple")
            return Be;
          var mt = {
            position: "relative"
          }, Tt = {}, ut = Math.ceil(je / Re) * Re, wt = this.getSpaceBefore(ut, Tt);
          wt && (mt[fe[Te]] = wt, Te === "x" && (mt.overflowX = "hidden"));
          var Yt = this.getSpaceBefore(Oe, Tt), Rt = Te === "x" ? Yt : 0, Ut = Te === "y" ? Yt : 0, He = lt ? "translate3d(".concat(Rt, "px, ").concat(Ut, "px, 0)") : "translate(".concat(Rt, "px, ").concat(Ut, "px)"), Ve = {
            msTransform: He,
            WebkitTransform: He,
            transform: He
          };
          return /* @__PURE__ */ r.default.createElement("div", {
            style: mt,
            ref: function(it) {
              return he.el = it;
            }
          }, /* @__PURE__ */ r.default.createElement("div", {
            style: Ve
          }, Be));
        }
      }]), K;
    }(r.Component), M(a, "displayName", "ReactList"), M(a, "propTypes", {
      axis: n.default.oneOf(["x", "y"]),
      initialIndex: n.default.number,
      itemRenderer: n.default.func,
      itemSizeEstimator: n.default.func,
      itemSizeGetter: n.default.func,
      itemsRenderer: n.default.func,
      length: n.default.number,
      minSize: n.default.number,
      pageSize: n.default.number,
      scrollParentGetter: n.default.func,
      scrollParentViewportSizeGetter: n.default.func,
      threshold: n.default.number,
      type: n.default.oneOf(["simple", "variable", "uniform"]),
      useStaticSize: n.default.bool,
      useTranslate3d: n.default.bool
    }), M(a, "defaultProps", {
      axis: "y",
      itemRenderer: function(j, K) {
        return /* @__PURE__ */ r.default.createElement("div", {
          key: K
        }, j);
      },
      itemsRenderer: function(j, K) {
        return /* @__PURE__ */ r.default.createElement("div", {
          ref: K
        }, j);
      },
      length: 0,
      minSize: 1,
      pageSize: 10,
      scrollParentGetter: pe,
      scrollParentViewportSizeGetter: _e,
      threshold: 100,
      type: "simple",
      useStaticSize: !1,
      useTranslate3d: !1
    }), i);
  });
})(Xre);
var HRe = Xre.exports;
function WRe(t, e) {
  if (t === e)
    return !0;
  if (!t || !e)
    return !1;
  var n = Object.keys(t), r = Object.keys(e), a = n.length;
  if (r.length !== a)
    return !1;
  for (var i = 0; i < a; i++) {
    var o = n[i];
    if (t[o] !== e[o] || !Object.prototype.hasOwnProperty.call(e, o))
      return !1;
  }
  return !0;
}
function QRe(t, e) {
  if (t === e)
    return !0;
  if (!t || !e)
    return !1;
  var n = t.length;
  if (e.length !== n)
    return !1;
  for (var r = 0; r < n; r++)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
const jRe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  shallowEqualArrays: QRe,
  shallowEqualObjects: WRe
}, Symbol.toStringTag, { value: "Module" })), GRe = /* @__PURE__ */ na(jRe), qre = /* @__PURE__ */ na(Owe), Kre = /* @__PURE__ */ na(ywe);
function IZ(t, e) {
  var n = t.getFullYear() - e.getFullYear() || t.getMonth() - e.getMonth() || t.getDate() - e.getDate() || t.getHours() - e.getHours() || t.getMinutes() - e.getMinutes() || t.getSeconds() - e.getSeconds() || t.getMilliseconds() - e.getMilliseconds();
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function VRe(t, e) {
  Kt(2, arguments);
  var n = an(t), r = an(e), a = IZ(n, r), i = Math.abs(zE(n, r));
  n.setDate(n.getDate() - a * i);
  var o = +(IZ(n, r) === -a), s = a * (i - o);
  return s === 0 ? 0 : s;
}
const YRe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: VRe
}, Symbol.toStringTag, { value: "Module" })), ZRe = /* @__PURE__ */ na(YRe), XRe = /* @__PURE__ */ na(Nwe), qRe = /* @__PURE__ */ na(bwe), KRe = /* @__PURE__ */ na(vwe), JRe = /* @__PURE__ */ na(iwe), eIe = /* @__PURE__ */ na(lwe), Jre = /* @__PURE__ */ na(awe), tIe = /* @__PURE__ */ na(GSe);
var C0 = {};
Object.defineProperty(C0, "__esModule", {
  value: !0
});
C0.default = void 0;
var nIe = {
  dateRangeWrapper: "rdrDateRangeWrapper",
  calendarWrapper: "rdrCalendarWrapper",
  dateDisplay: "rdrDateDisplay",
  dateDisplayItem: "rdrDateDisplayItem",
  dateDisplayItemActive: "rdrDateDisplayItemActive",
  monthAndYearWrapper: "rdrMonthAndYearWrapper",
  monthAndYearPickers: "rdrMonthAndYearPickers",
  nextPrevButton: "rdrNextPrevButton",
  month: "rdrMonth",
  weekDays: "rdrWeekDays",
  weekDay: "rdrWeekDay",
  days: "rdrDays",
  day: "rdrDay",
  dayNumber: "rdrDayNumber",
  dayPassive: "rdrDayPassive",
  dayToday: "rdrDayToday",
  dayStartOfWeek: "rdrDayStartOfWeek",
  dayEndOfWeek: "rdrDayEndOfWeek",
  daySelected: "rdrDaySelected",
  dayDisabled: "rdrDayDisabled",
  dayStartOfMonth: "rdrDayStartOfMonth",
  dayEndOfMonth: "rdrDayEndOfMonth",
  dayWeekend: "rdrDayWeekend",
  dayStartPreview: "rdrDayStartPreview",
  dayInPreview: "rdrDayInPreview",
  dayEndPreview: "rdrDayEndPreview",
  dayHovered: "rdrDayHovered",
  dayActive: "rdrDayActive",
  inRange: "rdrInRange",
  endEdge: "rdrEndEdge",
  startEdge: "rdrStartEdge",
  prevButton: "rdrPprevButton",
  nextButton: "rdrNextButton",
  selected: "rdrSelected",
  months: "rdrMonths",
  monthPicker: "rdrMonthPicker",
  yearPicker: "rdrYearPicker",
  dateDisplayWrapper: "rdrDateDisplayWrapper",
  definedRangesWrapper: "rdrDefinedRangesWrapper",
  staticRanges: "rdrStaticRanges",
  staticRange: "rdrStaticRange",
  inputRanges: "rdrInputRanges",
  inputRange: "rdrInputRange",
  inputRangeInput: "rdrInputRangeInput",
  dateRangePickerWrapper: "rdrDateRangePickerWrapper",
  staticRangeLabel: "rdrStaticRangeLabel",
  staticRangeSelected: "rdrStaticRangeSelected",
  monthName: "rdrMonthName",
  infiniteMonths: "rdrInfiniteMonths",
  monthsVertical: "rdrMonthsVertical",
  monthsHorizontal: "rdrMonthsHorizontal"
};
C0.default = nIe;
var fD = {};
Object.defineProperty(fD, "__esModule", {
  value: !0
});
fD.ariaLabelsShape = void 0;
var jm = rIe(qf());
function rIe(t) {
  return t && t.__esModule ? t : { default: t };
}
var aIe = jm.default.shape({
  dateInput: jm.default.objectOf(jm.default.shape({
    startDate: jm.default.string,
    endDate: jm.default.string
  })),
  monthPicker: jm.default.string,
  yearPicker: jm.default.string,
  prevButton: jm.default.string,
  nextButton: jm.default.string
});
fD.ariaLabelsShape = aIe;
function eT(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? eT = function(n) {
    return typeof n;
  } : eT = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, eT(t);
}
Object.defineProperty(g_, "__esModule", {
  value: !0
});
g_.default = void 0;
var Fa = CIe(Ge), zn = mi(qf()), iIe = eg, DZ = mi(oD), NZ = mi(cD), Px = ag, $y = mi(iv), oIe = mi(HRe), sIe = GRe, lIe = mi(qre), uIe = mi(Kre), cIe = mi(ZRe), fIe = mi(XRe), dIe = mi(uD), pIe = mi(AU), hIe = mi(kU), XM = mi(Bre), mIe = mi(qRe), gIe = mi(KRe), PZ = mi(JRe), bIe = mi(aD), vIe = mi(sD), yIe = mi(lD), OIe = mi(Fre), EIe = mi(iD), SIe = mi(eIe), bw = mi(Jre), wIe = mi(tIe), TIe = mi(C0), _Ie = fD;
function mi(t) {
  return t && t.__esModule ? t : { default: t };
}
function eae(t) {
  if (typeof WeakMap != "function")
    return null;
  var e = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (eae = function(a) {
    return a ? n : e;
  })(t);
}
function CIe(t, e) {
  if (!e && t && t.__esModule)
    return t;
  if (t === null || eT(t) !== "object" && typeof t != "function")
    return { default: t };
  var n = eae(e);
  if (n && n.has(t))
    return n.get(t);
  var r = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in t)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(t, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(t, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(r, i, o) : r[i] = t[i];
    }
  return r.default = t, n && n.set(t, r), r;
}
function VR() {
  return VR = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, VR.apply(this, arguments);
}
function xIe(t) {
  return IIe(t) || RIe(t) || kIe(t) || AIe();
}
function AIe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function kIe(t, e) {
  if (t) {
    if (typeof t == "string")
      return WB(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return WB(t, e);
  }
}
function RIe(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null)
    return Array.from(t);
}
function IIe(t) {
  if (Array.isArray(t))
    return WB(t);
}
function WB(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function LZ(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Lx(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? LZ(Object(n), !0).forEach(function(r) {
      iu(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : LZ(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function DIe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function MZ(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function NIe(t, e, n) {
  return e && MZ(t.prototype, e), n && MZ(t, n), t;
}
function PIe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && QB(t, e);
}
function QB(t, e) {
  return QB = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, QB(t, e);
}
function LIe(t) {
  var e = FIe();
  return function() {
    var r = YR(t), a;
    if (e) {
      var i = YR(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return MIe(this, a);
  };
}
function MIe(t, e) {
  return e && (eT(e) === "object" || typeof e == "function") ? e : Yu(t);
}
function Yu(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function FIe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function YR(t) {
  return YR = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, YR(t);
}
function iu(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var DU = /* @__PURE__ */ function(t) {
  PIe(n, t);
  var e = LIe(n);
  function n(r, a) {
    var i;
    return DIe(this, n), i = e.call(this, r, a), iu(Yu(i), "focusToDate", function(o) {
      var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : i.props, u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
      if (!s.scroll.enabled) {
        if (u && s.preventSnapRefocus) {
          var f = (0, XM.default)(o, i.state.focusedDate), p = s.calendarFocus === "forwards" && f >= 0, m = s.calendarFocus === "backwards" && f <= 0;
          if ((p || m) && Math.abs(f) < s.months)
            return;
        }
        i.setState({
          focusedDate: o
        });
        return;
      }
      var v = (0, XM.default)(o, s.minDate, i.dateOptions), O = i.list.getVisibleRange();
      u && O.includes(v) || (i.isFirstRender = !0, i.list.scrollTo(v), i.setState({
        focusedDate: o
      }));
    }), iu(Yu(i), "updateShownDate", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i.props, s = o.scroll.enabled ? Lx(Lx({}, o), {}, {
        months: i.list.getVisibleRange().length
      }) : o, u = (0, Px.calcFocusDate)(i.state.focusedDate, s);
      i.focusToDate(u, s);
    }), iu(Yu(i), "updatePreview", function(o) {
      if (!o) {
        i.setState({
          preview: null
        });
        return;
      }
      var s = {
        startDate: o,
        endDate: o,
        color: i.props.color
      };
      i.setState({
        preview: s
      });
    }), iu(Yu(i), "changeShownDate", function(o) {
      var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "set", u = i.state.focusedDate, f = i.props, p = f.onShownDateChange, m = f.minDate, v = f.maxDate, O = {
        monthOffset: function() {
          return (0, bw.default)(u, o);
        },
        setMonth: function(_) {
          function C() {
            return _.apply(this, arguments);
          }
          return C.toString = function() {
            return _.toString();
          }, C;
        }(function() {
          return (0, mIe.default)(u, o);
        }),
        setYear: function(_) {
          function C() {
            return _.apply(this, arguments);
          }
          return C.toString = function() {
            return _.toString();
          }, C;
        }(function() {
          return (0, gIe.default)(u, o);
        }),
        set: function() {
          return o;
        }
      }, w = (0, uIe.default)([(0, lIe.default)([O[s](), m]), v]);
      i.focusToDate(w, i.props, !1), p && p(w);
    }), iu(Yu(i), "handleRangeFocusChange", function(o, s) {
      i.props.onRangeFocusChange && i.props.onRangeFocusChange([o, s]);
    }), iu(Yu(i), "handleScroll", function() {
      var o = i.props, s = o.onShownDateChange, u = o.minDate, f = i.state.focusedDate, p = Yu(i), m = p.isFirstRender, v = i.list.getVisibleRange();
      if (v[0] !== void 0) {
        var O = (0, bw.default)(u, v[0] || 0), w = !(0, fIe.default)(O, f);
        w && !m && (i.setState({
          focusedDate: O
        }), s && s(O)), i.isFirstRender = !1;
      }
    }), iu(Yu(i), "renderMonthAndYear", function(o, s, u) {
      var f = u.showMonthArrow, p = u.minDate, m = u.maxDate, v = u.showMonthAndYearPickers, O = u.ariaLabels, w = (m || n.defaultProps.maxDate).getFullYear(), _ = (p || n.defaultProps.minDate).getFullYear(), C = i.styles;
      return /* @__PURE__ */ Fa.default.createElement("div", {
        onMouseUp: function(N) {
          return N.stopPropagation();
        },
        className: C.monthAndYearWrapper
      }, f ? /* @__PURE__ */ Fa.default.createElement("button", {
        type: "button",
        className: (0, $y.default)(C.nextPrevButton, C.prevButton),
        onClick: function() {
          return s(-1, "monthOffset");
        },
        "aria-label": O.prevButton
      }, /* @__PURE__ */ Fa.default.createElement("i", null)) : null, v ? /* @__PURE__ */ Fa.default.createElement("span", {
        className: C.monthAndYearPickers
      }, /* @__PURE__ */ Fa.default.createElement("span", {
        className: C.monthPicker
      }, /* @__PURE__ */ Fa.default.createElement("select", {
        value: o.getMonth(),
        onChange: function(N) {
          return s(N.target.value, "setMonth");
        },
        "aria-label": O.monthPicker
      }, i.state.monthNames.map(function(A, N) {
        return /* @__PURE__ */ Fa.default.createElement("option", {
          key: N,
          value: N
        }, A);
      }))), /* @__PURE__ */ Fa.default.createElement("span", {
        className: C.monthAndYearDivider
      }), /* @__PURE__ */ Fa.default.createElement("span", {
        className: C.yearPicker
      }, /* @__PURE__ */ Fa.default.createElement("select", {
        value: o.getFullYear(),
        onChange: function(N) {
          return s(N.target.value, "setYear");
        },
        "aria-label": O.yearPicker
      }, new Array(w - _ + 1).fill(w).map(function(A, N) {
        var P = A - N;
        return /* @__PURE__ */ Fa.default.createElement("option", {
          key: P,
          value: P
        }, P);
      })))) : /* @__PURE__ */ Fa.default.createElement("span", {
        className: C.monthAndYearPickers
      }, i.state.monthNames[o.getMonth()], " ", o.getFullYear()), f ? /* @__PURE__ */ Fa.default.createElement("button", {
        type: "button",
        className: (0, $y.default)(C.nextPrevButton, C.nextButton),
        onClick: function() {
          return s(1, "monthOffset");
        },
        "aria-label": O.nextButton
      }, /* @__PURE__ */ Fa.default.createElement("i", null)) : null);
    }), iu(Yu(i), "renderDateDisplay", function() {
      var o = i.props, s = o.focusedRange, u = o.color, f = o.ranges, p = o.rangeColors, m = o.dateDisplayFormat, v = o.editableDateInputs, O = o.startDatePlaceholder, w = o.endDatePlaceholder, _ = o.ariaLabels, C = p[s[0]] || u, A = i.styles;
      return /* @__PURE__ */ Fa.default.createElement("div", {
        className: A.dateDisplayWrapper
      }, f.map(function(N, P) {
        return N.showDateDisplay === !1 || N.disabled && !N.showDateDisplay ? null : /* @__PURE__ */ Fa.default.createElement("div", {
          className: A.dateDisplay,
          key: P,
          style: {
            color: N.color || C
          }
        }, /* @__PURE__ */ Fa.default.createElement(NZ.default, {
          className: (0, $y.default)(A.dateDisplayItem, iu({}, A.dateDisplayItemActive, s[0] === P && s[1] === 0)),
          readOnly: !v,
          disabled: N.disabled,
          value: N.startDate,
          placeholder: O,
          dateOptions: i.dateOptions,
          dateDisplayFormat: m,
          ariaLabel: _.dateInput && _.dateInput[N.key] && _.dateInput[N.key].startDate,
          onChange: i.onDragSelectionEnd,
          onFocus: function() {
            return i.handleRangeFocusChange(P, 0);
          }
        }), /* @__PURE__ */ Fa.default.createElement(NZ.default, {
          className: (0, $y.default)(A.dateDisplayItem, iu({}, A.dateDisplayItemActive, s[0] === P && s[1] === 1)),
          readOnly: !v,
          disabled: N.disabled,
          value: N.endDate,
          placeholder: w,
          dateOptions: i.dateOptions,
          dateDisplayFormat: m,
          ariaLabel: _.dateInput && _.dateInput[N.key] && _.dateInput[N.key].endDate,
          onChange: i.onDragSelectionEnd,
          onFocus: function() {
            return i.handleRangeFocusChange(P, 1);
          }
        }));
      }));
    }), iu(Yu(i), "onDragSelectionStart", function(o) {
      var s = i.props, u = s.onChange, f = s.dragSelectionEnabled;
      f ? i.setState({
        drag: {
          status: !0,
          range: {
            startDate: o,
            endDate: o
          },
          disablePreview: !0
        }
      }) : u && u(o);
    }), iu(Yu(i), "onDragSelectionEnd", function(o) {
      var s = i.props, u = s.updateRange, f = s.displayMode, p = s.onChange, m = s.dragSelectionEnabled;
      if (m) {
        if (f === "date" || !i.state.drag.status) {
          p && p(o);
          return;
        }
        var v = {
          startDate: i.state.drag.range.startDate,
          endDate: o
        };
        f !== "dateRange" || (0, bIe.default)(v.startDate, o) ? i.setState({
          drag: {
            status: !1,
            range: {}
          }
        }, function() {
          return p && p(o);
        }) : i.setState({
          drag: {
            status: !1,
            range: {}
          }
        }, function() {
          u && u(v);
        });
      }
    }), iu(Yu(i), "onDragSelectionMove", function(o) {
      var s = i.state.drag;
      !s.status || !i.props.dragSelectionEnabled || i.setState({
        drag: {
          status: s.status,
          range: {
            startDate: s.range.startDate,
            endDate: o
          },
          disablePreview: !0
        }
      });
    }), iu(Yu(i), "estimateMonthSize", function(o, s) {
      var u = i.props, f = u.direction, p = u.minDate, m = i.state.scrollArea;
      if (s && (i.listSizeCache = s, s[o]))
        return s[o];
      if (f === "horizontal")
        return m.monthWidth;
      var v = (0, bw.default)(p, o), O = (0, Px.getMonthDisplayRange)(v, i.dateOptions), w = O.start, _ = O.end, C = (0, cIe.default)(_, w, i.dateOptions) + 1 > 7 * 5;
      return C ? m.longMonthHeight : m.monthHeight;
    }), i.dateOptions = {
      locale: r.locale
    }, r.weekStartsOn !== void 0 && (i.dateOptions.weekStartsOn = r.weekStartsOn), i.styles = (0, Px.generateStyles)([TIe.default, r.classNames]), i.listSizeCache = {}, i.isFirstRender = !0, i.state = {
      monthNames: i.getMonthNames(),
      focusedDate: (0, Px.calcFocusDate)(null, r),
      drag: {
        status: !1,
        range: {
          startDate: null,
          endDate: null
        },
        disablePreview: !1
      },
      scrollArea: i.calcScrollArea(r)
    }, i;
  }
  return NIe(n, [{
    key: "getMonthNames",
    value: function() {
      var a = this;
      return xIe(Array(12).keys()).map(function(i) {
        return a.props.locale.localize.month(i);
      });
    }
  }, {
    key: "calcScrollArea",
    value: function(a) {
      var i = a.direction, o = a.months, s = a.scroll;
      if (!s.enabled)
        return {
          enabled: !1
        };
      var u = s.longMonthHeight || s.monthHeight;
      return i === "vertical" ? {
        enabled: !0,
        monthHeight: s.monthHeight || 220,
        longMonthHeight: u || 260,
        calendarWidth: "auto",
        calendarHeight: (s.calendarHeight || u || 240) * o
      } : {
        enabled: !0,
        monthWidth: s.monthWidth || 332,
        calendarWidth: (s.calendarWidth || s.monthWidth || 332) * o,
        monthHeight: u || 300,
        calendarHeight: u || 300
      };
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var a = this;
      this.props.scroll.enabled && setTimeout(function() {
        return a.focusToDate(a.state.focusedDate);
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function(a) {
      var i = {
        dateRange: "ranges",
        date: "date"
      }, o = i[this.props.displayMode];
      this.props[o] !== a[o] && this.updateShownDate(this.props), (a.locale !== this.props.locale || a.weekStartsOn !== this.props.weekStartsOn) && (this.dateOptions = {
        locale: this.props.locale
      }, this.props.weekStartsOn !== void 0 && (this.dateOptions.weekStartsOn = this.props.weekStartsOn), this.setState({
        monthNames: this.getMonthNames()
      })), (0, sIe.shallowEqualObjects)(a.scroll, this.props.scroll) || this.setState({
        scrollArea: this.calcScrollArea(this.props)
      });
    }
  }, {
    key: "renderWeekdays",
    value: function() {
      var a = this, i = /* @__PURE__ */ new Date();
      return /* @__PURE__ */ Fa.default.createElement("div", {
        className: this.styles.weekDays
      }, (0, OIe.default)({
        start: (0, yIe.default)(i, this.dateOptions),
        end: (0, vIe.default)(i, this.dateOptions)
      }).map(function(o, s) {
        return /* @__PURE__ */ Fa.default.createElement("span", {
          className: a.styles.weekDay,
          key: s
        }, (0, EIe.default)(o, a.props.weekdayDisplayFormat, a.dateOptions));
      }));
    }
  }, {
    key: "render",
    value: function() {
      var a = this, i = this.props, o = i.showDateDisplay, s = i.onPreviewChange, u = i.scroll, f = i.direction, p = i.disabledDates, m = i.disabledDay, v = i.maxDate, O = i.minDate, w = i.rangeColors, _ = i.color, C = i.navigatorRenderer, A = i.className, N = i.preview, P = this.state, I = P.scrollArea, D = P.focusedDate, M = f === "vertical", H = C || this.renderMonthAndYear, Y = this.props.ranges.map(function(q, Q) {
        return Lx(Lx({}, q), {}, {
          color: q.color || w[Q] || _
        });
      });
      return /* @__PURE__ */ Fa.default.createElement("div", {
        className: (0, $y.default)(this.styles.calendarWrapper, A),
        onMouseUp: function() {
          return a.setState({
            drag: {
              status: !1,
              range: {}
            }
          });
        },
        onMouseLeave: function() {
          a.setState({
            drag: {
              status: !1,
              range: {}
            }
          });
        }
      }, o && this.renderDateDisplay(), H(D, this.changeShownDate, this.props), u.enabled ? /* @__PURE__ */ Fa.default.createElement("div", null, M && this.renderWeekdays(this.dateOptions), /* @__PURE__ */ Fa.default.createElement("div", {
        className: (0, $y.default)(this.styles.infiniteMonths, M ? this.styles.monthsVertical : this.styles.monthsHorizontal),
        onMouseLeave: function() {
          return s && s();
        },
        style: {
          width: I.calendarWidth + 11,
          height: I.calendarHeight + 11
        },
        onScroll: this.handleScroll
      }, /* @__PURE__ */ Fa.default.createElement(oIe.default, {
        length: (0, XM.default)((0, pIe.default)(v), (0, dIe.default)((0, hIe.default)(O), -1), this.dateOptions),
        treshold: 500,
        type: "variable",
        ref: function(Q) {
          return a.list = Q;
        },
        itemSizeEstimator: this.estimateMonthSize,
        axis: M ? "y" : "x",
        itemRenderer: function(Q, ne) {
          var J = (0, bw.default)(O, Q);
          return /* @__PURE__ */ Fa.default.createElement(DZ.default, VR({}, a.props, {
            onPreviewChange: s || a.updatePreview,
            preview: N || a.state.preview,
            ranges: Y,
            key: ne,
            drag: a.state.drag,
            dateOptions: a.dateOptions,
            disabledDates: p,
            disabledDay: m,
            month: J,
            onDragSelectionStart: a.onDragSelectionStart,
            onDragSelectionEnd: a.onDragSelectionEnd,
            onDragSelectionMove: a.onDragSelectionMove,
            onMouseLeave: function() {
              return s && s();
            },
            styles: a.styles,
            style: M ? {
              height: a.estimateMonthSize(Q)
            } : {
              height: I.monthHeight,
              width: a.estimateMonthSize(Q)
            },
            showMonthName: !0,
            showWeekDays: !M
          }));
        }
      }))) : /* @__PURE__ */ Fa.default.createElement("div", {
        className: (0, $y.default)(this.styles.months, M ? this.styles.monthsVertical : this.styles.monthsHorizontal)
      }, new Array(this.props.months).fill(null).map(function(q, Q) {
        var ne = (0, bw.default)(a.state.focusedDate, Q);
        return a.props.calendarFocus === "backwards" && (ne = (0, SIe.default)(a.state.focusedDate, a.props.months - 1 - Q)), /* @__PURE__ */ Fa.default.createElement(DZ.default, VR({}, a.props, {
          onPreviewChange: s || a.updatePreview,
          preview: N || a.state.preview,
          ranges: Y,
          key: Q,
          drag: a.state.drag,
          dateOptions: a.dateOptions,
          disabledDates: p,
          disabledDay: m,
          month: ne,
          onDragSelectionStart: a.onDragSelectionStart,
          onDragSelectionEnd: a.onDragSelectionEnd,
          onDragSelectionMove: a.onDragSelectionMove,
          onMouseLeave: function() {
            return s && s();
          },
          styles: a.styles,
          showWeekDays: !M || Q === 0,
          showMonthName: !M || Q > 0
        }));
      })));
    }
  }]), n;
}(Fa.PureComponent);
DU.defaultProps = {
  showMonthArrow: !0,
  showMonthAndYearPickers: !0,
  disabledDates: [],
  disabledDay: function() {
  },
  classNames: {},
  locale: wIe.default,
  ranges: [],
  focusedRange: [0, 0],
  dateDisplayFormat: "MMM d, yyyy",
  monthDisplayFormat: "MMM yyyy",
  weekdayDisplayFormat: "E",
  dayDisplayFormat: "d",
  showDateDisplay: !0,
  showPreview: !0,
  displayMode: "date",
  months: 1,
  color: "#3d91ff",
  scroll: {
    enabled: !1
  },
  direction: "vertical",
  maxDate: (0, PZ.default)(/* @__PURE__ */ new Date(), 20),
  minDate: (0, PZ.default)(/* @__PURE__ */ new Date(), -100),
  rangeColors: ["#3d91ff", "#3ecf8e", "#fed14c"],
  startDatePlaceholder: "Early",
  endDatePlaceholder: "Continuous",
  editableDateInputs: !1,
  dragSelectionEnabled: !0,
  fixedHeight: !1,
  calendarFocus: "forwards",
  preventSnapRefocus: !1,
  ariaLabels: {}
};
DU.propTypes = {
  showMonthArrow: zn.default.bool,
  showMonthAndYearPickers: zn.default.bool,
  disabledDates: zn.default.array,
  disabledDay: zn.default.func,
  minDate: zn.default.object,
  maxDate: zn.default.object,
  date: zn.default.object,
  onChange: zn.default.func,
  onPreviewChange: zn.default.func,
  onRangeFocusChange: zn.default.func,
  classNames: zn.default.object,
  locale: zn.default.object,
  shownDate: zn.default.object,
  onShownDateChange: zn.default.func,
  ranges: zn.default.arrayOf(iIe.rangeShape),
  preview: zn.default.shape({
    startDate: zn.default.object,
    endDate: zn.default.object,
    color: zn.default.string
  }),
  dateDisplayFormat: zn.default.string,
  monthDisplayFormat: zn.default.string,
  weekdayDisplayFormat: zn.default.string,
  weekStartsOn: zn.default.number,
  dayDisplayFormat: zn.default.string,
  focusedRange: zn.default.arrayOf(zn.default.number),
  initialFocusedRange: zn.default.arrayOf(zn.default.number),
  months: zn.default.number,
  className: zn.default.string,
  showDateDisplay: zn.default.bool,
  showPreview: zn.default.bool,
  displayMode: zn.default.oneOf(["dateRange", "date"]),
  color: zn.default.string,
  updateRange: zn.default.func,
  scroll: zn.default.shape({
    enabled: zn.default.bool,
    monthHeight: zn.default.number,
    longMonthHeight: zn.default.number,
    monthWidth: zn.default.number,
    calendarWidth: zn.default.number,
    calendarHeight: zn.default.number
  }),
  direction: zn.default.oneOf(["vertical", "horizontal"]),
  startDatePlaceholder: zn.default.string,
  endDatePlaceholder: zn.default.string,
  navigatorRenderer: zn.default.func,
  rangeColors: zn.default.arrayOf(zn.default.string),
  editableDateInputs: zn.default.bool,
  dragSelectionEnabled: zn.default.bool,
  fixedHeight: zn.default.bool,
  calendarFocus: zn.default.string,
  preventSnapRefocus: zn.default.bool,
  ariaLabels: _Ie.ariaLabelsShape
};
var $Ie = DU;
g_.default = $Ie;
function tT(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? tT = function(n) {
    return typeof n;
  } : tT = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, tT(t);
}
Object.defineProperty(m_, "__esModule", {
  value: !0
});
m_.default = void 0;
var FZ = jIe(Ge), JO = kh(qf()), tae = kh(g_), BIe = eg, qM = ag, UIe = kh(qre), zIe = kh($re), $Z = kh(Kre), KM = kh(uD), HIe = kh(xU), BZ = kh(TU), WIe = kh(iv), QIe = kh(C0);
function kh(t) {
  return t && t.__esModule ? t : { default: t };
}
function nae(t) {
  if (typeof WeakMap != "function")
    return null;
  var e = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (nae = function(a) {
    return a ? n : e;
  })(t);
}
function jIe(t, e) {
  if (!e && t && t.__esModule)
    return t;
  if (t === null || tT(t) !== "object" && typeof t != "function")
    return { default: t };
  var n = nae(e);
  if (n && n.has(t))
    return n.get(t);
  var r = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in t)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(t, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(t, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(r, i, o) : r[i] = t[i];
    }
  return r.default = t, n && n.set(t, r), r;
}
function jB() {
  return jB = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, jB.apply(this, arguments);
}
function UZ(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function gE(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? UZ(Object(n), !0).forEach(function(r) {
      lE(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : UZ(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function GIe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function zZ(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function VIe(t, e, n) {
  return e && zZ(t.prototype, e), n && zZ(t, n), t;
}
function YIe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && GB(t, e);
}
function GB(t, e) {
  return GB = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, GB(t, e);
}
function ZIe(t) {
  var e = qIe();
  return function() {
    var r = ZR(t), a;
    if (e) {
      var i = ZR(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return XIe(this, a);
  };
}
function XIe(t, e) {
  return e && (tT(e) === "object" || typeof e == "function") ? e : Lw(t);
}
function Lw(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function qIe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function ZR(t) {
  return ZR = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, ZR(t);
}
function lE(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var NU = /* @__PURE__ */ function(t) {
  YIe(n, t);
  var e = ZIe(n);
  function n(r, a) {
    var i;
    return GIe(this, n), i = e.call(this, r, a), lE(Lw(i), "calcNewSelection", function(o) {
      var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, u = i.props.focusedRange || i.state.focusedRange, f = i.props, p = f.ranges, m = f.onChange, v = f.maxDate, O = f.moveRangeOnFirstSelection, w = f.retainEndDateOnFirstSelection, _ = f.disabledDates, C = u[0], A = p[C];
      if (!A || !m)
        return {};
      var N = A.startDate, P = A.endDate, I = /* @__PURE__ */ new Date(), D;
      if (!s)
        N = o.startDate, P = o.endDate;
      else if (u[1] === 0) {
        var M = (0, HIe.default)(P || I, N), H = function() {
          return O ? (0, KM.default)(o, M) : w ? !P || (0, BZ.default)(o, P) ? P : o : o || I;
        };
        N = o, P = H(), v && (P = (0, $Z.default)([P, v])), D = [u[0], 1];
      } else
        P = o;
      var Y = u[1] === 0;
      if ((0, BZ.default)(P, N)) {
        Y = !Y;
        var q = [P, N];
        N = q[0], P = q[1];
      }
      var Q = _.filter(function(J) {
        return (0, zIe.default)(J, {
          start: N,
          end: P
        });
      });
      if (Q.length > 0 && (Y ? N = (0, KM.default)((0, UIe.default)(Q), 1) : P = (0, KM.default)((0, $Z.default)(Q), -1)), !D) {
        var ne = (0, qM.findNextRangeIndex)(i.props.ranges, u[0]);
        D = [ne, 0];
      }
      return {
        wasValid: !(Q.length > 0),
        range: {
          startDate: N,
          endDate: P
        },
        nextFocusRange: D
      };
    }), lE(Lw(i), "setSelection", function(o, s) {
      var u = i.props, f = u.onChange, p = u.ranges, m = u.onRangeFocusChange, v = i.props.focusedRange || i.state.focusedRange, O = v[0], w = p[O];
      if (w) {
        var _ = i.calcNewSelection(o, s);
        f(lE({}, w.key || "range".concat(O + 1), gE(gE({}, w), _.range))), i.setState({
          focusedRange: _.nextFocusRange,
          preview: null
        }), m && m(_.nextFocusRange);
      }
    }), lE(Lw(i), "handleRangeFocusChange", function(o) {
      i.setState({
        focusedRange: o
      }), i.props.onRangeFocusChange && i.props.onRangeFocusChange(o);
    }), lE(Lw(i), "updatePreview", function(o) {
      var s;
      if (!o) {
        i.setState({
          preview: null
        });
        return;
      }
      var u = i.props, f = u.rangeColors, p = u.ranges, m = i.props.focusedRange || i.state.focusedRange, v = ((s = p[m[0]]) === null || s === void 0 ? void 0 : s.color) || f[m[0]] || v;
      i.setState({
        preview: gE(gE({}, o.range), {}, {
          color: v
        })
      });
    }), i.state = {
      focusedRange: r.initialFocusedRange || [(0, qM.findNextRangeIndex)(r.ranges), 0],
      preview: null
    }, i.styles = (0, qM.generateStyles)([QIe.default, r.classNames]), i;
  }
  return VIe(n, [{
    key: "render",
    value: function() {
      var a = this;
      return /* @__PURE__ */ FZ.default.createElement(tae.default, jB({
        focusedRange: this.state.focusedRange,
        onRangeFocusChange: this.handleRangeFocusChange,
        preview: this.state.preview,
        onPreviewChange: function(o) {
          a.updatePreview(o ? a.calcNewSelection(o) : null);
        }
      }, this.props, {
        displayMode: "dateRange",
        className: (0, WIe.default)(this.styles.dateRangeWrapper, this.props.className),
        onChange: this.setSelection,
        updateRange: function(o) {
          return a.setSelection(o, !1);
        },
        ref: function(o) {
          a.calendar = o;
        }
      }));
    }
  }]), n;
}(FZ.Component);
NU.defaultProps = {
  classNames: {},
  ranges: [],
  moveRangeOnFirstSelection: !1,
  retainEndDateOnFirstSelection: !1,
  rangeColors: ["#3d91ff", "#3ecf8e", "#fed14c"],
  disabledDates: []
};
NU.propTypes = gE(gE({}, tae.default.propTypes), {}, {
  onChange: JO.default.func,
  onRangeFocusChange: JO.default.func,
  className: JO.default.string,
  ranges: JO.default.arrayOf(BIe.rangeShape),
  moveRangeOnFirstSelection: JO.default.bool,
  retainEndDateOnFirstSelection: JO.default.bool
});
var KIe = NU;
m_.default = KIe;
var dD = {}, b_ = {}, Kb = {};
Object.defineProperty(Kb, "__esModule", {
  value: !0
});
Kb.createStaticRanges = rae;
Kb.defaultInputRanges = Kb.defaultStaticRanges = void 0;
var HZ = Rh(xU), XR = Rh(aD), WZ = Rh(sD), QZ = Rh(lD), jZ = Rh(Jre), GZ = Rh(AU), VZ = Rh(kU), YZ = Rh(_U), ZZ = Rh(wU), bE = Rh(uD);
function Rh(t) {
  return t && t.__esModule ? t : { default: t };
}
function XZ(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function qZ(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? XZ(Object(n), !0).forEach(function(r) {
      JIe(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : XZ(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function JIe(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var hs = {
  startOfWeek: (0, QZ.default)(/* @__PURE__ */ new Date()),
  endOfWeek: (0, WZ.default)(/* @__PURE__ */ new Date()),
  startOfLastWeek: (0, QZ.default)((0, bE.default)(/* @__PURE__ */ new Date(), -7)),
  endOfLastWeek: (0, WZ.default)((0, bE.default)(/* @__PURE__ */ new Date(), -7)),
  startOfToday: (0, YZ.default)(/* @__PURE__ */ new Date()),
  endOfToday: (0, ZZ.default)(/* @__PURE__ */ new Date()),
  startOfYesterday: (0, YZ.default)((0, bE.default)(/* @__PURE__ */ new Date(), -1)),
  endOfYesterday: (0, ZZ.default)((0, bE.default)(/* @__PURE__ */ new Date(), -1)),
  startOfMonth: (0, VZ.default)(/* @__PURE__ */ new Date()),
  endOfMonth: (0, GZ.default)(/* @__PURE__ */ new Date()),
  startOfLastMonth: (0, VZ.default)((0, jZ.default)(/* @__PURE__ */ new Date(), -1)),
  endOfLastMonth: (0, GZ.default)((0, jZ.default)(/* @__PURE__ */ new Date(), -1))
}, eDe = {
  range: {},
  isSelected: function(e) {
    var n = this.range();
    return (0, XR.default)(e.startDate, n.startDate) && (0, XR.default)(e.endDate, n.endDate);
  }
};
function rae(t) {
  return t.map(function(e) {
    return qZ(qZ({}, eDe), e);
  });
}
var tDe = rae([{
  label: "Today",
  range: function() {
    return {
      startDate: hs.startOfToday,
      endDate: hs.endOfToday
    };
  }
}, {
  label: "Yesterday",
  range: function() {
    return {
      startDate: hs.startOfYesterday,
      endDate: hs.endOfYesterday
    };
  }
}, {
  label: "This Week",
  range: function() {
    return {
      startDate: hs.startOfWeek,
      endDate: hs.endOfWeek
    };
  }
}, {
  label: "Last Week",
  range: function() {
    return {
      startDate: hs.startOfLastWeek,
      endDate: hs.endOfLastWeek
    };
  }
}, {
  label: "This Month",
  range: function() {
    return {
      startDate: hs.startOfMonth,
      endDate: hs.endOfMonth
    };
  }
}, {
  label: "Last Month",
  range: function() {
    return {
      startDate: hs.startOfLastMonth,
      endDate: hs.endOfLastMonth
    };
  }
}]);
Kb.defaultStaticRanges = tDe;
var nDe = [{
  label: "days up to today",
  range: function(e) {
    return {
      startDate: (0, bE.default)(hs.startOfToday, (Math.max(Number(e), 1) - 1) * -1),
      endDate: hs.endOfToday
    };
  },
  getCurrentValue: function(e) {
    return (0, XR.default)(e.endDate, hs.endOfToday) ? e.startDate ? (0, HZ.default)(hs.endOfToday, e.startDate) + 1 : "∞" : "-";
  }
}, {
  label: "days starting today",
  range: function(e) {
    var n = /* @__PURE__ */ new Date();
    return {
      startDate: n,
      endDate: (0, bE.default)(n, Math.max(Number(e), 1) - 1)
    };
  },
  getCurrentValue: function(e) {
    return (0, XR.default)(e.startDate, hs.startOfToday) ? e.endDate ? (0, HZ.default)(e.endDate, hs.startOfToday) + 1 : "∞" : "-";
  }
}];
Kb.defaultInputRanges = nDe;
var pD = {};
function nT(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? nT = function(n) {
    return typeof n;
  } : nT = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, nT(t);
}
Object.defineProperty(pD, "__esModule", {
  value: !0
});
pD.default = void 0;
var Mx = aDe(Ge), Gu = rDe(qf());
function rDe(t) {
  return t && t.__esModule ? t : { default: t };
}
function aae(t) {
  if (typeof WeakMap != "function")
    return null;
  var e = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (aae = function(a) {
    return a ? n : e;
  })(t);
}
function aDe(t, e) {
  if (!e && t && t.__esModule)
    return t;
  if (t === null || nT(t) !== "object" && typeof t != "function")
    return { default: t };
  var n = aae(e);
  if (n && n.has(t))
    return n.get(t);
  var r = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in t)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(t, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(t, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(r, i, o) : r[i] = t[i];
    }
  return r.default = t, n && n.set(t, r), r;
}
function iDe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function KZ(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function oDe(t, e, n) {
  return e && KZ(t.prototype, e), n && KZ(t, n), t;
}
function sDe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && VB(t, e);
}
function VB(t, e) {
  return VB = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, VB(t, e);
}
function lDe(t) {
  var e = cDe();
  return function() {
    var r = qR(t), a;
    if (e) {
      var i = qR(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return uDe(this, a);
  };
}
function uDe(t, e) {
  return e && (nT(e) === "object" || typeof e == "function") ? e : iae(t);
}
function iae(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function cDe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function qR(t) {
  return qR = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, qR(t);
}
function fDe(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var JZ = 0, eX = 99999, PU = /* @__PURE__ */ function(t) {
  sDe(n, t);
  var e = lDe(n);
  function n(r, a) {
    var i;
    return iDe(this, n), i = e.call(this, r, a), fDe(iae(i), "onChange", function(o) {
      var s = i.props.onChange, u = parseInt(o.target.value, 10);
      u = isNaN(u) ? 0 : Math.max(Math.min(eX, u), JZ), s(u);
    }), i;
  }
  return oDe(n, [{
    key: "shouldComponentUpdate",
    value: function(a) {
      var i = this.props, o = i.value, s = i.label, u = i.placeholder;
      return o !== a.value || s !== a.label || u !== a.placeholder;
    }
  }, {
    key: "render",
    value: function() {
      var a = this.props, i = a.label, o = a.placeholder, s = a.value, u = a.styles, f = a.onBlur, p = a.onFocus;
      return /* @__PURE__ */ Mx.default.createElement("div", {
        className: u.inputRange
      }, /* @__PURE__ */ Mx.default.createElement("input", {
        className: u.inputRangeInput,
        placeholder: o,
        value: s,
        min: JZ,
        max: eX,
        onChange: this.onChange,
        onFocus: p,
        onBlur: f
      }), /* @__PURE__ */ Mx.default.createElement("span", {
        className: u.inputRangeLabel
      }, i));
    }
  }]), n;
}(Mx.Component);
PU.propTypes = {
  value: Gu.default.oneOfType([Gu.default.string, Gu.default.number]),
  label: Gu.default.oneOfType([Gu.default.element, Gu.default.node]).isRequired,
  placeholder: Gu.default.string,
  styles: Gu.default.shape({
    inputRange: Gu.default.string,
    inputRangeInput: Gu.default.string,
    inputRangeLabel: Gu.default.string
  }).isRequired,
  onBlur: Gu.default.func.isRequired,
  onFocus: Gu.default.func.isRequired,
  onChange: Gu.default.func.isRequired
};
PU.defaultProps = {
  value: "",
  placeholder: "-"
};
var dDe = PU;
pD.default = dDe;
function rT(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? rT = function(n) {
    return typeof n;
  } : rT = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, rT(t);
}
Object.defineProperty(b_, "__esModule", {
  value: !0
});
b_.default = void 0;
var By = mDe(Ge), kc = hD(qf()), Uy = hD(C0), tX = Kb, pDe = eg, hDe = hD(pD), nX = hD(iv);
function hD(t) {
  return t && t.__esModule ? t : { default: t };
}
function oae(t) {
  if (typeof WeakMap != "function")
    return null;
  var e = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (oae = function(a) {
    return a ? n : e;
  })(t);
}
function mDe(t, e) {
  if (!e && t && t.__esModule)
    return t;
  if (t === null || rT(t) !== "object" && typeof t != "function")
    return { default: t };
  var n = oae(e);
  if (n && n.has(t))
    return n.get(t);
  var r = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in t)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(t, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(t, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(r, i, o) : r[i] = t[i];
    }
  return r.default = t, n && n.set(t, r), r;
}
function rX(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function aX(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? rX(Object(n), !0).forEach(function(r) {
      yk(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : rX(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function gDe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function iX(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function bDe(t, e, n) {
  return e && iX(t.prototype, e), n && iX(t, n), t;
}
function vDe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && YB(t, e);
}
function YB(t, e) {
  return YB = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, YB(t, e);
}
function yDe(t) {
  var e = EDe();
  return function() {
    var r = KR(t), a;
    if (e) {
      var i = KR(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return ODe(this, a);
  };
}
function ODe(t, e) {
  return e && (rT(e) === "object" || typeof e == "function") ? e : sae(t);
}
function sae(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function EDe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function KR(t) {
  return KR = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, KR(t);
}
function yk(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var LU = /* @__PURE__ */ function(t) {
  vDe(n, t);
  var e = yDe(n);
  function n(r) {
    var a;
    return gDe(this, n), a = e.call(this, r), yk(sae(a), "handleRangeChange", function(i) {
      var o = a.props, s = o.onChange, u = o.ranges, f = o.focusedRange, p = u[f[0]];
      !s || !p || s(yk({}, p.key || "range".concat(f[0] + 1), aX(aX({}, p), i)));
    }), a.state = {
      rangeOffset: 0,
      focusedInput: -1
    }, a;
  }
  return bDe(n, [{
    key: "getRangeOptionValue",
    value: function(a) {
      var i = this.props, o = i.ranges, s = o === void 0 ? [] : o, u = i.focusedRange, f = u === void 0 ? [] : u;
      if (typeof a.getCurrentValue != "function")
        return "";
      var p = s[f[0]] || {};
      return a.getCurrentValue(p) || "";
    }
  }, {
    key: "getSelectedRange",
    value: function(a, i) {
      var o = a.findIndex(function(u) {
        return !u.startDate || !u.endDate || u.disabled ? !1 : i.isSelected(u);
      }), s = a[o];
      return {
        selectedRange: s,
        focusedRangeIndex: o
      };
    }
  }, {
    key: "render",
    value: function() {
      var a = this, i = this.props, o = i.headerContent, s = i.footerContent, u = i.onPreviewChange, f = i.inputRanges, p = i.staticRanges, m = i.ranges, v = i.renderStaticRangeLabel, O = i.rangeColors, w = i.className;
      return /* @__PURE__ */ By.default.createElement("div", {
        className: (0, nX.default)(Uy.default.definedRangesWrapper, w)
      }, o, /* @__PURE__ */ By.default.createElement("div", {
        className: Uy.default.staticRanges
      }, p.map(function(_, C) {
        var A = a.getSelectedRange(m, _), N = A.selectedRange, P = A.focusedRangeIndex, I;
        return _.hasCustomRendering ? I = v(_) : I = _.label, /* @__PURE__ */ By.default.createElement("button", {
          type: "button",
          className: (0, nX.default)(Uy.default.staticRange, yk({}, Uy.default.staticRangeSelected, !!N)),
          style: {
            color: N ? N.color || O[P] : null
          },
          key: C,
          onClick: function() {
            return a.handleRangeChange(_.range(a.props));
          },
          onFocus: function() {
            return u && u(_.range(a.props));
          },
          onMouseOver: function() {
            return u && u(_.range(a.props));
          },
          onMouseLeave: function() {
            u && u();
          }
        }, /* @__PURE__ */ By.default.createElement("span", {
          tabIndex: -1,
          className: Uy.default.staticRangeLabel
        }, I));
      })), /* @__PURE__ */ By.default.createElement("div", {
        className: Uy.default.inputRanges
      }, f.map(function(_, C) {
        return /* @__PURE__ */ By.default.createElement(hDe.default, {
          key: C,
          styles: Uy.default,
          label: _.label,
          onFocus: function() {
            return a.setState({
              focusedInput: C,
              rangeOffset: 0
            });
          },
          onBlur: function() {
            return a.setState({
              rangeOffset: 0
            });
          },
          onChange: function(N) {
            return a.handleRangeChange(_.range(N, a.props));
          },
          value: a.getRangeOptionValue(_)
        });
      })), s);
    }
  }]), n;
}(By.Component);
LU.propTypes = {
  inputRanges: kc.default.array,
  staticRanges: kc.default.array,
  ranges: kc.default.arrayOf(pDe.rangeShape),
  focusedRange: kc.default.arrayOf(kc.default.number),
  onPreviewChange: kc.default.func,
  onChange: kc.default.func,
  footerContent: kc.default.any,
  headerContent: kc.default.any,
  rangeColors: kc.default.arrayOf(kc.default.string),
  className: kc.default.string,
  renderStaticRangeLabel: kc.default.func
};
LU.defaultProps = {
  inputRanges: tX.defaultInputRanges,
  staticRanges: tX.defaultStaticRanges,
  ranges: [],
  rangeColors: ["#3d91ff", "#3ecf8e", "#fed14c"],
  focusedRange: [0, 0]
};
var SDe = LU;
b_.default = SDe;
function aT(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? aT = function(n) {
    return typeof n;
  } : aT = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, aT(t);
}
Object.defineProperty(dD, "__esModule", {
  value: !0
});
dD.default = void 0;
var Fx = CDe(Ge), wDe = v_(qf()), lae = v_(m_), uae = v_(b_), oX = ag, TDe = v_(iv), _De = v_(C0);
function v_(t) {
  return t && t.__esModule ? t : { default: t };
}
function cae(t) {
  if (typeof WeakMap != "function")
    return null;
  var e = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (cae = function(a) {
    return a ? n : e;
  })(t);
}
function CDe(t, e) {
  if (!e && t && t.__esModule)
    return t;
  if (t === null || aT(t) !== "object" && typeof t != "function")
    return { default: t };
  var n = cae(e);
  if (n && n.has(t))
    return n.get(t);
  var r = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in t)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(t, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(t, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(r, i, o) : r[i] = t[i];
    }
  return r.default = t, n && n.set(t, r), r;
}
function sX(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function JM(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? sX(Object(n), !0).forEach(function(r) {
      xDe(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : sX(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function xDe(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function JR() {
  return JR = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, JR.apply(this, arguments);
}
function ADe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function lX(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function kDe(t, e, n) {
  return e && lX(t.prototype, e), n && lX(t, n), t;
}
function RDe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && ZB(t, e);
}
function ZB(t, e) {
  return ZB = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, ZB(t, e);
}
function IDe(t) {
  var e = PDe();
  return function() {
    var r = eI(t), a;
    if (e) {
      var i = eI(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return DDe(this, a);
  };
}
function DDe(t, e) {
  return e && (aT(e) === "object" || typeof e == "function") ? e : NDe(t);
}
function NDe(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function PDe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function eI(t) {
  return eI = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, eI(t);
}
var MU = /* @__PURE__ */ function(t) {
  RDe(n, t);
  var e = IDe(n);
  function n(r) {
    var a;
    return ADe(this, n), a = e.call(this, r), a.state = {
      focusedRange: [(0, oX.findNextRangeIndex)(r.ranges), 0]
    }, a.styles = (0, oX.generateStyles)([_De.default, r.classNames]), a;
  }
  return kDe(n, [{
    key: "render",
    value: function() {
      var a = this, i = this.state.focusedRange;
      return /* @__PURE__ */ Fx.default.createElement("div", {
        className: (0, TDe.default)(this.styles.dateRangePickerWrapper, this.props.className)
      }, /* @__PURE__ */ Fx.default.createElement(uae.default, JR({
        focusedRange: i,
        onPreviewChange: function(s) {
          return a.dateRange.updatePreview(s ? a.dateRange.calcNewSelection(s, typeof s == "string") : null);
        }
      }, this.props, {
        range: this.props.ranges[i[0]],
        className: void 0
      })), /* @__PURE__ */ Fx.default.createElement(lae.default, JR({
        onRangeFocusChange: function(s) {
          return a.setState({
            focusedRange: s
          });
        },
        focusedRange: i
      }, this.props, {
        ref: function(s) {
          return a.dateRange = s;
        },
        className: void 0
      })));
    }
  }]), n;
}(Fx.Component);
MU.defaultProps = {};
MU.propTypes = JM(JM(JM({}, lae.default.propTypes), uae.default.propTypes), {}, {
  className: wDe.default.string
});
var LDe = MU;
dD.default = LDe;
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "DateRange", {
    enumerable: !0,
    get: function() {
      return e.default;
    }
  }), Object.defineProperty(t, "Calendar", {
    enumerable: !0,
    get: function() {
      return n.default;
    }
  }), Object.defineProperty(t, "DateRangePicker", {
    enumerable: !0,
    get: function() {
      return r.default;
    }
  }), Object.defineProperty(t, "DefinedRange", {
    enumerable: !0,
    get: function() {
      return a.default;
    }
  }), Object.defineProperty(t, "defaultInputRanges", {
    enumerable: !0,
    get: function() {
      return i.defaultInputRanges;
    }
  }), Object.defineProperty(t, "defaultStaticRanges", {
    enumerable: !0,
    get: function() {
      return i.defaultStaticRanges;
    }
  }), Object.defineProperty(t, "createStaticRanges", {
    enumerable: !0,
    get: function() {
      return i.createStaticRanges;
    }
  });
  var e = o(m_), n = o(g_), r = o(dD), a = o(b_), i = Kb;
  function o(s) {
    return s && s.__esModule ? s : { default: s };
  }
})(Nre);
const Gm = "byz-date-range", IXe = bs(({
  onChange: t,
  name: e,
  label: n,
  value: r,
  className: a,
  placeholder: i,
  clearText: o = "ALL",
  clearDateRange: s,
  initialMonths: u,
  minDate: f,
  maxDate: p,
  dateFormat: m = "MM/dd/yyyy"
}, v) => {
  const [O, w] = kn(null), [_, C] = kn(!1), [A, N] = kn(""), P = [
    {
      startDate: /* @__PURE__ */ new Date(),
      endDate: /* @__PURE__ */ new Date(),
      key: "selection"
    }
  ], [I, D] = kn(P);
  Vn(() => {
    O ? (D([{
      ...O,
      key: "selection"
    }]), N(`${NT(O.startDate, m)} - ${NT(O.endDate, m)}`)) : (D(P), N(""));
  }, [O]), Vn(() => {
    s && w(null);
  }, [s]), Vn(() => {
    w(r ?? null);
  }, [r]), Nl(v, () => ({
    value: O
  }));
  const M = (Q) => {
    const { startDate: ne, endDate: J } = Q.selection, ue = { startDate: ne, endDate: J };
    t ? t({ value: ue, name: e }) : w(ue);
  }, H = () => {
    w(null), D(P);
  }, Y = (Q) => {
    Q.stopPropagation(), H();
  };
  function q() {
    C((Q) => !Q);
  }
  return /* @__PURE__ */ Ne.jsxs("div", { className: pn(Gm, a), children: [
    n && /* @__PURE__ */ Ne.jsx("div", { className: `${Gm}__label`, children: n }),
    /* @__PURE__ */ Ne.jsxs("div", { className: `${Gm}__container`, children: [
      /* @__PURE__ */ Ne.jsxs("div", { className: `${Gm}__header`, onClick: q, children: [
        !O && /* @__PURE__ */ Ne.jsx("div", { className: pn(`${Gm}__placeholder`, {
          [`${Gm}__placeholder--expanded`]: _
        }), children: i }),
        !!O && /* @__PURE__ */ Ne.jsxs(Ne.Fragment, { children: [
          /* @__PURE__ */ Ne.jsx("div", { className: `${Gm}__value`, children: A }),
          /* @__PURE__ */ Ne.jsx("div", { className: `${Gm}__clear`, onClick: Y, children: o })
        ] })
      ] }),
      _ && /* @__PURE__ */ Ne.jsx(
        Nre.DateRangePicker,
        {
          className: `${Gm}__date-range-picker`,
          onChange: (Q) => M(Q),
          moveRangeOnFirstSelection: !1,
          months: u ?? 2,
          ranges: I,
          direction: "horizontal",
          showMonthAndYearPickers: !0,
          showDateDisplay: !1,
          showPreview: !0,
          dragSelectionEnabled: !0,
          maxDate: p,
          minDate: f
        }
      )
    ] })
  ] });
});
var MDe = function(t) {
  var e = {};
  function n(r) {
    if (e[r])
      return e[r].exports;
    var a = e[r] = { i: r, l: !1, exports: {} };
    return t[r].call(a.exports, a, a.exports, n), a.l = !0, a.exports;
  }
  return n.m = t, n.c = e, n.d = function(r, a, i) {
    n.o(r, a) || Object.defineProperty(r, a, { enumerable: !0, get: i });
  }, n.r = function(r) {
    typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(r, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(r, "__esModule", { value: !0 });
  }, n.t = function(r, a) {
    if (1 & a && (r = n(r)), 8 & a || 4 & a && typeof r == "object" && r && r.__esModule)
      return r;
    var i = /* @__PURE__ */ Object.create(null);
    if (n.r(i), Object.defineProperty(i, "default", { enumerable: !0, value: r }), 2 & a && typeof r != "string")
      for (var o in r)
        n.d(i, o, (function(s) {
          return r[s];
        }).bind(null, o));
    return i;
  }, n.n = function(r) {
    var a = r && r.__esModule ? function() {
      return r.default;
    } : function() {
      return r;
    };
    return n.d(a, "a", a), a;
  }, n.o = function(r, a) {
    return Object.prototype.hasOwnProperty.call(r, a);
  }, n.p = "", n(n.s = 9);
}([function(t, e) {
  t.exports = Ge;
}, function(t, e, n) {
  var r;
  /*!
    Copyright (c) 2017 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */
  (function() {
    var a = {}.hasOwnProperty;
    function i() {
      for (var o = [], s = 0; s < arguments.length; s++) {
        var u = arguments[s];
        if (u) {
          var f = typeof u;
          if (f === "string" || f === "number")
            o.push(u);
          else if (Array.isArray(u) && u.length) {
            var p = i.apply(null, u);
            p && o.push(p);
          } else if (f === "object")
            for (var m in u)
              a.call(u, m) && u[m] && o.push(m);
        }
      }
      return o.join(" ");
    }
    t.exports ? (i.default = i, t.exports = i) : (r = (function() {
      return i;
    }).apply(e, [])) === void 0 || (t.exports = r);
  })();
}, function(t, e, n) {
  (function(r) {
    var a = /^\s+|\s+$/g, i = /^[-+]0x[0-9a-f]+$/i, o = /^0b[01]+$/i, s = /^0o[0-7]+$/i, u = parseInt, f = typeof r == "object" && r && r.Object === Object && r, p = typeof self == "object" && self && self.Object === Object && self, m = f || p || Function("return this")(), v = Object.prototype.toString, O = m.Symbol, w = O ? O.prototype : void 0, _ = w ? w.toString : void 0;
    function C(I) {
      if (typeof I == "string")
        return I;
      if (N(I))
        return _ ? _.call(I) : "";
      var D = I + "";
      return D == "0" && 1 / I == -1 / 0 ? "-0" : D;
    }
    function A(I) {
      var D = typeof I;
      return !!I && (D == "object" || D == "function");
    }
    function N(I) {
      return typeof I == "symbol" || function(D) {
        return !!D && typeof D == "object";
      }(I) && v.call(I) == "[object Symbol]";
    }
    function P(I) {
      return I ? (I = function(D) {
        if (typeof D == "number")
          return D;
        if (N(D))
          return NaN;
        if (A(D)) {
          var M = typeof D.valueOf == "function" ? D.valueOf() : D;
          D = A(M) ? M + "" : M;
        }
        if (typeof D != "string")
          return D === 0 ? D : +D;
        D = D.replace(a, "");
        var H = o.test(D);
        return H || s.test(D) ? u(D.slice(2), H ? 2 : 8) : i.test(D) ? NaN : +D;
      }(I)) === 1 / 0 || I === -1 / 0 ? 17976931348623157e292 * (I < 0 ? -1 : 1) : I == I ? I : 0 : I === 0 ? I : 0;
    }
    t.exports = function(I, D, M) {
      var H, Y, q, Q;
      return I = (H = I) == null ? "" : C(H), Y = function(ne) {
        var J = P(ne), ue = J % 1;
        return J == J ? ue ? J - ue : J : 0;
      }(M), q = 0, Q = I.length, Y == Y && (Q !== void 0 && (Y = Y <= Q ? Y : Q), q !== void 0 && (Y = Y >= q ? Y : q)), M = Y, D = C(D), I.slice(M, M + D.length) == D;
    };
  }).call(this, n(3));
}, function(t, e) {
  var n;
  n = function() {
    return this;
  }();
  try {
    n = n || new Function("return this")();
  } catch {
    typeof window == "object" && (n = window);
  }
  t.exports = n;
}, function(t, e, n) {
  (function(r) {
    var a = /^\[object .+?Constructor\]$/, i = typeof r == "object" && r && r.Object === Object && r, o = typeof self == "object" && self && self.Object === Object && self, s = i || o || Function("return this")(), u, f = Array.prototype, p = Function.prototype, m = Object.prototype, v = s["__core-js_shared__"], O = (u = /[^.]+$/.exec(v && v.keys && v.keys.IE_PROTO || "")) ? "Symbol(src)_1." + u : "", w = p.toString, _ = m.hasOwnProperty, C = m.toString, A = RegExp("^" + w.call(_).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), N = f.splice, P = ne(s, "Map"), I = ne(Object, "create");
    function D(ee) {
      var fe = -1, de = ee ? ee.length : 0;
      for (this.clear(); ++fe < de; ) {
        var ie = ee[fe];
        this.set(ie[0], ie[1]);
      }
    }
    function M(ee) {
      var fe = -1, de = ee ? ee.length : 0;
      for (this.clear(); ++fe < de; ) {
        var ie = ee[fe];
        this.set(ie[0], ie[1]);
      }
    }
    function H(ee) {
      var fe = -1, de = ee ? ee.length : 0;
      for (this.clear(); ++fe < de; ) {
        var ie = ee[fe];
        this.set(ie[0], ie[1]);
      }
    }
    function Y(ee, fe) {
      for (var de, ie, le = ee.length; le--; )
        if ((de = ee[le][0]) === (ie = fe) || de != de && ie != ie)
          return le;
      return -1;
    }
    function q(ee) {
      return !(!ue(ee) || (fe = ee, O && O in fe)) && (function(de) {
        var ie = ue(de) ? C.call(de) : "";
        return ie == "[object Function]" || ie == "[object GeneratorFunction]";
      }(ee) || function(de) {
        var ie = !1;
        if (de != null && typeof de.toString != "function")
          try {
            ie = !!(de + "");
          } catch {
          }
        return ie;
      }(ee) ? A : a).test(function(de) {
        if (de != null) {
          try {
            return w.call(de);
          } catch {
          }
          try {
            return de + "";
          } catch {
          }
        }
        return "";
      }(ee));
      var fe;
    }
    function Q(ee, fe) {
      var de, ie, le = ee.__data__;
      return ((ie = typeof (de = fe)) == "string" || ie == "number" || ie == "symbol" || ie == "boolean" ? de !== "__proto__" : de === null) ? le[typeof fe == "string" ? "string" : "hash"] : le.map;
    }
    function ne(ee, fe) {
      var de = function(ie, le) {
        return ie == null ? void 0 : ie[le];
      }(ee, fe);
      return q(de) ? de : void 0;
    }
    function J(ee, fe) {
      if (typeof ee != "function" || fe && typeof fe != "function")
        throw new TypeError("Expected a function");
      var de = function() {
        var ie = arguments, le = fe ? fe.apply(this, ie) : ie[0], ye = de.cache;
        if (ye.has(le))
          return ye.get(le);
        var B = ee.apply(this, ie);
        return de.cache = ye.set(le, B), B;
      };
      return de.cache = new (J.Cache || H)(), de;
    }
    function ue(ee) {
      var fe = typeof ee;
      return !!ee && (fe == "object" || fe == "function");
    }
    D.prototype.clear = function() {
      this.__data__ = I ? I(null) : {};
    }, D.prototype.delete = function(ee) {
      return this.has(ee) && delete this.__data__[ee];
    }, D.prototype.get = function(ee) {
      var fe = this.__data__;
      if (I) {
        var de = fe[ee];
        return de === "__lodash_hash_undefined__" ? void 0 : de;
      }
      return _.call(fe, ee) ? fe[ee] : void 0;
    }, D.prototype.has = function(ee) {
      var fe = this.__data__;
      return I ? fe[ee] !== void 0 : _.call(fe, ee);
    }, D.prototype.set = function(ee, fe) {
      return this.__data__[ee] = I && fe === void 0 ? "__lodash_hash_undefined__" : fe, this;
    }, M.prototype.clear = function() {
      this.__data__ = [];
    }, M.prototype.delete = function(ee) {
      var fe = this.__data__, de = Y(fe, ee);
      return !(de < 0) && (de == fe.length - 1 ? fe.pop() : N.call(fe, de, 1), !0);
    }, M.prototype.get = function(ee) {
      var fe = this.__data__, de = Y(fe, ee);
      return de < 0 ? void 0 : fe[de][1];
    }, M.prototype.has = function(ee) {
      return Y(this.__data__, ee) > -1;
    }, M.prototype.set = function(ee, fe) {
      var de = this.__data__, ie = Y(de, ee);
      return ie < 0 ? de.push([ee, fe]) : de[ie][1] = fe, this;
    }, H.prototype.clear = function() {
      this.__data__ = { hash: new D(), map: new (P || M)(), string: new D() };
    }, H.prototype.delete = function(ee) {
      return Q(this, ee).delete(ee);
    }, H.prototype.get = function(ee) {
      return Q(this, ee).get(ee);
    }, H.prototype.has = function(ee) {
      return Q(this, ee).has(ee);
    }, H.prototype.set = function(ee, fe) {
      return Q(this, ee).set(ee, fe), this;
    }, J.Cache = H, t.exports = J;
  }).call(this, n(3));
}, function(t, e, n) {
  (function(r) {
    var a = /^\s+|\s+$/g, i = /^[-+]0x[0-9a-f]+$/i, o = /^0b[01]+$/i, s = /^0o[0-7]+$/i, u = parseInt, f = typeof r == "object" && r && r.Object === Object && r, p = typeof self == "object" && self && self.Object === Object && self, m = f || p || Function("return this")(), v = Object.prototype.toString, O = Math.max, w = Math.min, _ = function() {
      return m.Date.now();
    };
    function C(N) {
      var P = typeof N;
      return !!N && (P == "object" || P == "function");
    }
    function A(N) {
      if (typeof N == "number")
        return N;
      if (function(D) {
        return typeof D == "symbol" || function(M) {
          return !!M && typeof M == "object";
        }(D) && v.call(D) == "[object Symbol]";
      }(N))
        return NaN;
      if (C(N)) {
        var P = typeof N.valueOf == "function" ? N.valueOf() : N;
        N = C(P) ? P + "" : P;
      }
      if (typeof N != "string")
        return N === 0 ? N : +N;
      N = N.replace(a, "");
      var I = o.test(N);
      return I || s.test(N) ? u(N.slice(2), I ? 2 : 8) : i.test(N) ? NaN : +N;
    }
    t.exports = function(N, P, I) {
      var D, M, H, Y, q, Q, ne = 0, J = !1, ue = !1, ee = !0;
      if (typeof N != "function")
        throw new TypeError("Expected a function");
      function fe(pe) {
        var _e = D, Z = M;
        return D = M = void 0, ne = pe, Y = N.apply(Z, _e);
      }
      function de(pe) {
        return ne = pe, q = setTimeout(le, P), J ? fe(pe) : Y;
      }
      function ie(pe) {
        var _e = pe - Q;
        return Q === void 0 || _e >= P || _e < 0 || ue && pe - ne >= H;
      }
      function le() {
        var pe = _();
        if (ie(pe))
          return ye(pe);
        q = setTimeout(le, function(_e) {
          var Z = P - (_e - Q);
          return ue ? w(Z, H - (_e - ne)) : Z;
        }(pe));
      }
      function ye(pe) {
        return q = void 0, ee && D ? fe(pe) : (D = M = void 0, Y);
      }
      function B() {
        var pe = _(), _e = ie(pe);
        if (D = arguments, M = this, Q = pe, _e) {
          if (q === void 0)
            return de(Q);
          if (ue)
            return q = setTimeout(le, P), fe(Q);
        }
        return q === void 0 && (q = setTimeout(le, P)), Y;
      }
      return P = A(P) || 0, C(I) && (J = !!I.leading, H = (ue = "maxWait" in I) ? O(A(I.maxWait) || 0, P) : H, ee = "trailing" in I ? !!I.trailing : ee), B.cancel = function() {
        q !== void 0 && clearTimeout(q), ne = 0, D = Q = M = q = void 0;
      }, B.flush = function() {
        return q === void 0 ? Y : ye(_());
      }, B;
    };
  }).call(this, n(3));
}, function(t, e, n) {
  (function(r, a) {
    var i = "[object Arguments]", o = "[object Map]", s = "[object Object]", u = "[object Set]", f = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, p = /^\w*$/, m = /^\./, v = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, O = /\\(\\)?/g, w = /^\[object .+?Constructor\]$/, _ = /^(?:0|[1-9]\d*)$/, C = {};
    C["[object Float32Array]"] = C["[object Float64Array]"] = C["[object Int8Array]"] = C["[object Int16Array]"] = C["[object Int32Array]"] = C["[object Uint8Array]"] = C["[object Uint8ClampedArray]"] = C["[object Uint16Array]"] = C["[object Uint32Array]"] = !0, C[i] = C["[object Array]"] = C["[object ArrayBuffer]"] = C["[object Boolean]"] = C["[object DataView]"] = C["[object Date]"] = C["[object Error]"] = C["[object Function]"] = C[o] = C["[object Number]"] = C[s] = C["[object RegExp]"] = C[u] = C["[object String]"] = C["[object WeakMap]"] = !1;
    var A = typeof r == "object" && r && r.Object === Object && r, N = typeof self == "object" && self && self.Object === Object && self, P = A || N || Function("return this")(), I = e && !e.nodeType && e, D = I && typeof a == "object" && a && !a.nodeType && a, M = D && D.exports === I && A.process, H = function() {
      try {
        return M && M.binding("util");
      } catch {
      }
    }(), Y = H && H.isTypedArray;
    function q(ve, Ye, yt, Dt) {
      var Lt = -1, _n = ve ? ve.length : 0;
      for (Dt && _n && (yt = ve[++Lt]); ++Lt < _n; )
        yt = Ye(yt, ve[Lt], Lt, ve);
      return yt;
    }
    function Q(ve, Ye) {
      for (var yt = -1, Dt = ve ? ve.length : 0; ++yt < Dt; )
        if (Ye(ve[yt], yt, ve))
          return !0;
      return !1;
    }
    function ne(ve, Ye, yt, Dt, Lt) {
      return Lt(ve, function(_n, Nn, fn) {
        yt = Dt ? (Dt = !1, _n) : Ye(yt, _n, Nn, fn);
      }), yt;
    }
    function J(ve) {
      var Ye = !1;
      if (ve != null && typeof ve.toString != "function")
        try {
          Ye = !!(ve + "");
        } catch {
        }
      return Ye;
    }
    function ue(ve) {
      var Ye = -1, yt = Array(ve.size);
      return ve.forEach(function(Dt, Lt) {
        yt[++Ye] = [Lt, Dt];
      }), yt;
    }
    function ee(ve) {
      var Ye = -1, yt = Array(ve.size);
      return ve.forEach(function(Dt) {
        yt[++Ye] = Dt;
      }), yt;
    }
    var fe, de, ie, le = Array.prototype, ye = Function.prototype, B = Object.prototype, pe = P["__core-js_shared__"], _e = (fe = /[^.]+$/.exec(pe && pe.keys && pe.keys.IE_PROTO || "")) ? "Symbol(src)_1." + fe : "", Z = ye.toString, ce = B.hasOwnProperty, j = B.toString, K = RegExp("^" + Z.call(ce).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), Ee = P.Symbol, he = P.Uint8Array, Ae = B.propertyIsEnumerable, Te = le.splice, je = (de = Object.keys, ie = Object, function(ve) {
      return de(ie(ve));
    }), we = Ni(P, "DataView"), lt = Ni(P, "Map"), st = Ni(P, "Promise"), Oe = Ni(P, "Set"), Re = Ni(P, "WeakMap"), Be = Ni(Object, "create"), mt = Pi(we), Tt = Pi(lt), ut = Pi(st), wt = Pi(Oe), Yt = Pi(Re), Rt = Ee ? Ee.prototype : void 0, Ut = Rt ? Rt.valueOf : void 0, He = Rt ? Rt.toString : void 0;
    function Ve(ve) {
      var Ye = -1, yt = ve ? ve.length : 0;
      for (this.clear(); ++Ye < yt; ) {
        var Dt = ve[Ye];
        this.set(Dt[0], Dt[1]);
      }
    }
    function Ie(ve) {
      var Ye = -1, yt = ve ? ve.length : 0;
      for (this.clear(); ++Ye < yt; ) {
        var Dt = ve[Ye];
        this.set(Dt[0], Dt[1]);
      }
    }
    function it(ve) {
      var Ye = -1, yt = ve ? ve.length : 0;
      for (this.clear(); ++Ye < yt; ) {
        var Dt = ve[Ye];
        this.set(Dt[0], Dt[1]);
      }
    }
    function zt(ve) {
      var Ye = -1, yt = ve ? ve.length : 0;
      for (this.__data__ = new it(); ++Ye < yt; )
        this.add(ve[Ye]);
    }
    function Ht(ve) {
      this.__data__ = new Ie(ve);
    }
    function bt(ve, Ye) {
      var yt = xe(ve) || Fl(ve) ? function(Nn, fn) {
        for (var Or = -1, Er = Array(Nn); ++Or < Nn; )
          Er[Or] = fn(Or);
        return Er;
      }(ve.length, String) : [], Dt = yt.length, Lt = !!Dt;
      for (var _n in ve)
        !Ye && !ce.call(ve, _n) || Lt && (_n == "length" || gu(_n, Dt)) || yt.push(_n);
      return yt;
    }
    function Mt(ve, Ye) {
      for (var yt = ve.length; yt--; )
        if (es(ve[yt][0], Ye))
          return yt;
      return -1;
    }
    Ve.prototype.clear = function() {
      this.__data__ = Be ? Be(null) : {};
    }, Ve.prototype.delete = function(ve) {
      return this.has(ve) && delete this.__data__[ve];
    }, Ve.prototype.get = function(ve) {
      var Ye = this.__data__;
      if (Be) {
        var yt = Ye[ve];
        return yt === "__lodash_hash_undefined__" ? void 0 : yt;
      }
      return ce.call(Ye, ve) ? Ye[ve] : void 0;
    }, Ve.prototype.has = function(ve) {
      var Ye = this.__data__;
      return Be ? Ye[ve] !== void 0 : ce.call(Ye, ve);
    }, Ve.prototype.set = function(ve, Ye) {
      return this.__data__[ve] = Be && Ye === void 0 ? "__lodash_hash_undefined__" : Ye, this;
    }, Ie.prototype.clear = function() {
      this.__data__ = [];
    }, Ie.prototype.delete = function(ve) {
      var Ye = this.__data__, yt = Mt(Ye, ve);
      return !(yt < 0) && (yt == Ye.length - 1 ? Ye.pop() : Te.call(Ye, yt, 1), !0);
    }, Ie.prototype.get = function(ve) {
      var Ye = this.__data__, yt = Mt(Ye, ve);
      return yt < 0 ? void 0 : Ye[yt][1];
    }, Ie.prototype.has = function(ve) {
      return Mt(this.__data__, ve) > -1;
    }, Ie.prototype.set = function(ve, Ye) {
      var yt = this.__data__, Dt = Mt(yt, ve);
      return Dt < 0 ? yt.push([ve, Ye]) : yt[Dt][1] = Ye, this;
    }, it.prototype.clear = function() {
      this.__data__ = { hash: new Ve(), map: new (lt || Ie)(), string: new Ve() };
    }, it.prototype.delete = function(ve) {
      return po(this, ve).delete(ve);
    }, it.prototype.get = function(ve) {
      return po(this, ve).get(ve);
    }, it.prototype.has = function(ve) {
      return po(this, ve).has(ve);
    }, it.prototype.set = function(ve, Ye) {
      return po(this, ve).set(ve, Ye), this;
    }, zt.prototype.add = zt.prototype.push = function(ve) {
      return this.__data__.set(ve, "__lodash_hash_undefined__"), this;
    }, zt.prototype.has = function(ve) {
      return this.__data__.has(ve);
    }, Ht.prototype.clear = function() {
      this.__data__ = new Ie();
    }, Ht.prototype.delete = function(ve) {
      return this.__data__.delete(ve);
    }, Ht.prototype.get = function(ve) {
      return this.__data__.get(ve);
    }, Ht.prototype.has = function(ve) {
      return this.__data__.has(ve);
    }, Ht.prototype.set = function(ve, Ye) {
      var yt = this.__data__;
      if (yt instanceof Ie) {
        var Dt = yt.__data__;
        if (!lt || Dt.length < 199)
          return Dt.push([ve, Ye]), this;
        yt = this.__data__ = new it(Dt);
      }
      return yt.set(ve, Ye), this;
    };
    var ln, ze = (ln = function(ve, Ye) {
      return ve && gt(ve, Ye, Ba);
    }, function(ve, Ye) {
      if (ve == null)
        return ve;
      if (!xt(ve))
        return ln(ve, Ye);
      for (var yt = ve.length, Dt = -1, Lt = Object(ve); ++Dt < yt && Ye(Lt[Dt], Dt, Lt) !== !1; )
        ;
      return ve;
    }), gt = function(ve) {
      return function(Ye, yt, Dt) {
        for (var Lt = -1, _n = Object(Ye), Nn = Dt(Ye), fn = Nn.length; fn--; ) {
          var Or = Nn[ve ? fn : ++Lt];
          if (yt(_n[Or], Or, _n) === !1)
            break;
        }
        return Ye;
      };
    }();
    function Bt(ve, Ye) {
      for (var yt = 0, Dt = (Ye = ho(Ye, ve) ? [Ye] : Ar(Ye)).length; ve != null && yt < Dt; )
        ve = ve[Lo(Ye[yt++])];
      return yt && yt == Dt ? ve : void 0;
    }
    function Qt(ve, Ye) {
      return ve != null && Ye in Object(ve);
    }
    function En(ve, Ye, yt, Dt, Lt) {
      return ve === Ye || (ve == null || Ye == null || !Yn(ve) && !ur(Ye) ? ve != ve && Ye != Ye : function(_n, Nn, fn, Or, Er, pr) {
        var Li = xe(_n), Aa = xe(Nn), ua = "[object Array]", Mr = "[object Array]";
        Li || (ua = (ua = oi(_n)) == i ? s : ua), Aa || (Mr = (Mr = oi(Nn)) == i ? s : Mr);
        var to = ua == s && !J(_n), $l = Mr == s && !J(Nn), Bl = ua == Mr;
        if (Bl && !to)
          return pr || (pr = new Ht()), Li || Rn(_n) ? Ji(_n, Nn, fn, Or, Er, pr) : function(Fr, _r, Qc, Ts, Ou, si, ol) {
            switch (Qc) {
              case "[object DataView]":
                if (Fr.byteLength != _r.byteLength || Fr.byteOffset != _r.byteOffset)
                  return !1;
                Fr = Fr.buffer, _r = _r.buffer;
              case "[object ArrayBuffer]":
                return !(Fr.byteLength != _r.byteLength || !Ts(new he(Fr), new he(_r)));
              case "[object Boolean]":
              case "[object Date]":
              case "[object Number]":
                return es(+Fr, +_r);
              case "[object Error]":
                return Fr.name == _r.name && Fr.message == _r.message;
              case "[object RegExp]":
              case "[object String]":
                return Fr == _r + "";
              case o:
                var go = ue;
              case u:
                var hr = 2 & si;
                if (go || (go = ee), Fr.size != _r.size && !hr)
                  return !1;
                var _s = ol.get(Fr);
                if (_s)
                  return _s == _r;
                si |= 1, ol.set(Fr, _r);
                var Eu = Ji(go(Fr), go(_r), Ts, Ou, si, ol);
                return ol.delete(Fr), Eu;
              case "[object Symbol]":
                if (Ut)
                  return Ut.call(Fr) == Ut.call(_r);
            }
            return !1;
          }(_n, Nn, ua, fn, Or, Er, pr);
        if (!(2 & Er)) {
          var il = to && ce.call(_n, "__wrapped__"), ac = $l && ce.call(Nn, "__wrapped__");
          if (il || ac) {
            var yu = il ? _n.value() : _n, mo = ac ? Nn.value() : Nn;
            return pr || (pr = new Ht()), fn(yu, mo, Or, Er, pr);
          }
        }
        return Bl ? (pr || (pr = new Ht()), function(Fr, _r, Qc, Ts, Ou, si) {
          var ol = 2 & Ou, go = Ba(Fr), hr = go.length, _s = Ba(_r).length;
          if (hr != _s && !ol)
            return !1;
          for (var Eu = hr; Eu--; ) {
            var ts = go[Eu];
            if (!(ol ? ts in _r : ce.call(_r, ts)))
              return !1;
          }
          var Qr = si.get(Fr);
          if (Qr && si.get(_r))
            return Qr == _r;
          var jc = !0;
          si.set(Fr, _r), si.set(_r, Fr);
          for (var Gc = ol; ++Eu < hr; ) {
            ts = go[Eu];
            var Bn = Fr[ts], Ul = _r[ts];
            if (Ts)
              var Ua = ol ? Ts(Ul, Bn, ts, _r, Fr, si) : Ts(Bn, Ul, ts, Fr, _r, si);
            if (!(Ua === void 0 ? Bn === Ul || Qc(Bn, Ul, Ts, Ou, si) : Ua)) {
              jc = !1;
              break;
            }
            Gc || (Gc = ts == "constructor");
          }
          if (jc && !Gc) {
            var no = Fr.constructor, ro = _r.constructor;
            no == ro || !("constructor" in Fr) || !("constructor" in _r) || typeof no == "function" && no instanceof no && typeof ro == "function" && ro instanceof ro || (jc = !1);
          }
          return si.delete(Fr), si.delete(_r), jc;
        }(_n, Nn, fn, Or, Er, pr)) : !1;
      }(ve, Ye, En, yt, Dt, Lt));
    }
    function Mn(ve) {
      return !(!Yn(ve) || function(Ye) {
        return !!_e && _e in Ye;
      }(ve)) && (jt(ve) || J(ve) ? K : w).test(Pi(ve));
    }
    function br(ve) {
      return typeof ve == "function" ? ve : ve == null ? ma : typeof ve == "object" ? xe(ve) ? function(Dt, Lt) {
        return ho(Dt) && Jo(Lt) ? bu(Lo(Dt), Lt) : function(_n) {
          var Nn = function(fn, Or, Er) {
            var pr = fn == null ? void 0 : Bt(fn, Or);
            return pr === void 0 ? Er : pr;
          }(_n, Dt);
          return Nn === void 0 && Nn === Lt ? function(fn, Or) {
            return fn != null && function(Er, pr, Li) {
              pr = ho(pr, Er) ? [pr] : Ar(pr);
              for (var Aa, ua = -1, Mr = pr.length; ++ua < Mr; ) {
                var to = Lo(pr[ua]);
                if (!(Aa = Er != null && Li(Er, to)))
                  break;
                Er = Er[to];
              }
              return Aa || !!(Mr = Er ? Er.length : 0) && Sn(Mr) && gu(to, Mr) && (xe(Er) || Fl(Er));
            }(fn, Or, Qt);
          }(_n, Dt) : En(Lt, Nn, void 0, 3);
        };
      }(ve[0], ve[1]) : function(Dt) {
        var Lt = function(_n) {
          for (var Nn = Ba(_n), fn = Nn.length; fn--; ) {
            var Or = Nn[fn], Er = _n[Or];
            Nn[fn] = [Or, Er, Jo(Er)];
          }
          return Nn;
        }(Dt);
        return Lt.length == 1 && Lt[0][2] ? bu(Lt[0][0], Lt[0][1]) : function(_n) {
          return _n === Dt || function(Nn, fn, Or, Er) {
            var pr = Or.length, Li = pr, Aa = !Er;
            if (Nn == null)
              return !Li;
            for (Nn = Object(Nn); pr--; ) {
              var ua = Or[pr];
              if (Aa && ua[2] ? ua[1] !== Nn[ua[0]] : !(ua[0] in Nn))
                return !1;
            }
            for (; ++pr < Li; ) {
              var Mr = (ua = Or[pr])[0], to = Nn[Mr], $l = ua[1];
              if (Aa && ua[2]) {
                if (to === void 0 && !(Mr in Nn))
                  return !1;
              } else {
                var Bl = new Ht();
                if (Er)
                  var il = Er(to, $l, Mr, Nn, fn, Bl);
                if (!(il === void 0 ? En($l, to, Er, 3, Bl) : il))
                  return !1;
              }
            }
            return !0;
          }(_n, Dt, Lt);
        };
      }(ve) : ho(Ye = ve) ? (yt = Lo(Ye), function(Dt) {
        return Dt == null ? void 0 : Dt[yt];
      }) : function(Dt) {
        return function(Lt) {
          return Bt(Lt, Dt);
        };
      }(Ye);
      var Ye, yt;
    }
    function sr(ve) {
      if (yt = (Ye = ve) && Ye.constructor, Dt = typeof yt == "function" && yt.prototype || B, Ye !== Dt)
        return je(ve);
      var Ye, yt, Dt, Lt = [];
      for (var _n in Object(ve))
        ce.call(ve, _n) && _n != "constructor" && Lt.push(_n);
      return Lt;
    }
    function Ar(ve) {
      return xe(ve) ? ve : vu(ve);
    }
    function Ji(ve, Ye, yt, Dt, Lt, _n) {
      var Nn = 2 & Lt, fn = ve.length, Or = Ye.length;
      if (fn != Or && !(Nn && Or > fn))
        return !1;
      var Er = _n.get(ve);
      if (Er && _n.get(Ye))
        return Er == Ye;
      var pr = -1, Li = !0, Aa = 1 & Lt ? new zt() : void 0;
      for (_n.set(ve, Ye), _n.set(Ye, ve); ++pr < fn; ) {
        var ua = ve[pr], Mr = Ye[pr];
        if (Dt)
          var to = Nn ? Dt(Mr, ua, pr, Ye, ve, _n) : Dt(ua, Mr, pr, ve, Ye, _n);
        if (to !== void 0) {
          if (to)
            continue;
          Li = !1;
          break;
        }
        if (Aa) {
          if (!Q(Ye, function($l, Bl) {
            if (!Aa.has(Bl) && (ua === $l || yt(ua, $l, Dt, Lt, _n)))
              return Aa.add(Bl);
          })) {
            Li = !1;
            break;
          }
        } else if (ua !== Mr && !yt(ua, Mr, Dt, Lt, _n)) {
          Li = !1;
          break;
        }
      }
      return _n.delete(ve), _n.delete(Ye), Li;
    }
    function po(ve, Ye) {
      var yt, Dt, Lt = ve.__data__;
      return ((Dt = typeof (yt = Ye)) == "string" || Dt == "number" || Dt == "symbol" || Dt == "boolean" ? yt !== "__proto__" : yt === null) ? Lt[typeof Ye == "string" ? "string" : "hash"] : Lt.map;
    }
    function Ni(ve, Ye) {
      var yt = function(Dt, Lt) {
        return Dt == null ? void 0 : Dt[Lt];
      }(ve, Ye);
      return Mn(yt) ? yt : void 0;
    }
    var oi = function(ve) {
      return j.call(ve);
    };
    function gu(ve, Ye) {
      return !!(Ye = Ye ?? 9007199254740991) && (typeof ve == "number" || _.test(ve)) && ve > -1 && ve % 1 == 0 && ve < Ye;
    }
    function ho(ve, Ye) {
      if (xe(ve))
        return !1;
      var yt = typeof ve;
      return !(yt != "number" && yt != "symbol" && yt != "boolean" && ve != null && !qn(ve)) || p.test(ve) || !f.test(ve) || Ye != null && ve in Object(Ye);
    }
    function Jo(ve) {
      return ve == ve && !Yn(ve);
    }
    function bu(ve, Ye) {
      return function(yt) {
        return yt != null && yt[ve] === Ye && (Ye !== void 0 || ve in Object(yt));
      };
    }
    (we && oi(new we(new ArrayBuffer(1))) != "[object DataView]" || lt && oi(new lt()) != o || st && oi(st.resolve()) != "[object Promise]" || Oe && oi(new Oe()) != u || Re && oi(new Re()) != "[object WeakMap]") && (oi = function(ve) {
      var Ye = j.call(ve), yt = Ye == s ? ve.constructor : void 0, Dt = yt ? Pi(yt) : void 0;
      if (Dt)
        switch (Dt) {
          case mt:
            return "[object DataView]";
          case Tt:
            return o;
          case ut:
            return "[object Promise]";
          case wt:
            return u;
          case Yt:
            return "[object WeakMap]";
        }
      return Ye;
    });
    var vu = eo(function(ve) {
      var Ye;
      ve = (Ye = ve) == null ? "" : function(Dt) {
        if (typeof Dt == "string")
          return Dt;
        if (qn(Dt))
          return He ? He.call(Dt) : "";
        var Lt = Dt + "";
        return Lt == "0" && 1 / Dt == -1 / 0 ? "-0" : Lt;
      }(Ye);
      var yt = [];
      return m.test(ve) && yt.push(""), ve.replace(v, function(Dt, Lt, _n, Nn) {
        yt.push(_n ? Nn.replace(O, "$1") : Lt || Dt);
      }), yt;
    });
    function Lo(ve) {
      if (typeof ve == "string" || qn(ve))
        return ve;
      var Ye = ve + "";
      return Ye == "0" && 1 / ve == -1 / 0 ? "-0" : Ye;
    }
    function Pi(ve) {
      if (ve != null) {
        try {
          return Z.call(ve);
        } catch {
        }
        try {
          return ve + "";
        } catch {
        }
      }
      return "";
    }
    function eo(ve, Ye) {
      if (typeof ve != "function" || Ye && typeof Ye != "function")
        throw new TypeError("Expected a function");
      var yt = function() {
        var Dt = arguments, Lt = Ye ? Ye.apply(this, Dt) : Dt[0], _n = yt.cache;
        if (_n.has(Lt))
          return _n.get(Lt);
        var Nn = ve.apply(this, Dt);
        return yt.cache = _n.set(Lt, Nn), Nn;
      };
      return yt.cache = new (eo.Cache || it)(), yt;
    }
    function es(ve, Ye) {
      return ve === Ye || ve != ve && Ye != Ye;
    }
    function Fl(ve) {
      return function(Ye) {
        return ur(Ye) && xt(Ye);
      }(ve) && ce.call(ve, "callee") && (!Ae.call(ve, "callee") || j.call(ve) == i);
    }
    eo.Cache = it;
    var xe = Array.isArray;
    function xt(ve) {
      return ve != null && Sn(ve.length) && !jt(ve);
    }
    function jt(ve) {
      var Ye = Yn(ve) ? j.call(ve) : "";
      return Ye == "[object Function]" || Ye == "[object GeneratorFunction]";
    }
    function Sn(ve) {
      return typeof ve == "number" && ve > -1 && ve % 1 == 0 && ve <= 9007199254740991;
    }
    function Yn(ve) {
      var Ye = typeof ve;
      return !!ve && (Ye == "object" || Ye == "function");
    }
    function ur(ve) {
      return !!ve && typeof ve == "object";
    }
    function qn(ve) {
      return typeof ve == "symbol" || ur(ve) && j.call(ve) == "[object Symbol]";
    }
    var Rn = Y ? function(ve) {
      return function(Ye) {
        return ve(Ye);
      };
    }(Y) : function(ve) {
      return ur(ve) && Sn(ve.length) && !!C[j.call(ve)];
    };
    function Ba(ve) {
      return xt(ve) ? bt(ve) : sr(ve);
    }
    function ma(ve) {
      return ve;
    }
    a.exports = function(ve, Ye, yt) {
      var Dt = xe(ve) ? q : ne, Lt = arguments.length < 3;
      return Dt(ve, br(Ye), yt, Lt, ze);
    };
  }).call(this, n(3), n(7)(t));
}, function(t, e) {
  t.exports = function(n) {
    return n.webpackPolyfill || (n.deprecate = function() {
    }, n.paths = [], n.children || (n.children = []), Object.defineProperty(n, "loaded", { enumerable: !0, get: function() {
      return n.l;
    } }), Object.defineProperty(n, "id", { enumerable: !0, get: function() {
      return n.i;
    } }), n.webpackPolyfill = 1), n;
  };
}, function(t, e) {
  String.prototype.padEnd || (String.prototype.padEnd = function(n, r) {
    return n >>= 0, r = String(r !== void 0 ? r : " "), this.length > n ? String(this) : ((n -= this.length) > r.length && (r += r.repeat(n / r.length)), String(this) + r.slice(0, n));
  });
}, function(t, e, n) {
  function r(B, pe, _e) {
    return pe in B ? Object.defineProperty(B, pe, { value: _e, enumerable: !0, configurable: !0, writable: !0 }) : B[pe] = _e, B;
  }
  function a(B) {
    if (Symbol.iterator in Object(B) || Object.prototype.toString.call(B) === "[object Arguments]")
      return Array.from(B);
  }
  function i(B) {
    return function(pe) {
      if (Array.isArray(pe)) {
        for (var _e = 0, Z = new Array(pe.length); _e < pe.length; _e++)
          Z[_e] = pe[_e];
        return Z;
      }
    }(B) || a(B) || function() {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    }();
  }
  function o(B) {
    if (Array.isArray(B))
      return B;
  }
  function s() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }
  function u(B, pe) {
    if (!(B instanceof pe))
      throw new TypeError("Cannot call a class as a function");
  }
  function f(B, pe) {
    for (var _e = 0; _e < pe.length; _e++) {
      var Z = pe[_e];
      Z.enumerable = Z.enumerable || !1, Z.configurable = !0, "value" in Z && (Z.writable = !0), Object.defineProperty(B, Z.key, Z);
    }
  }
  function p(B) {
    return (p = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(pe) {
      return typeof pe;
    } : function(pe) {
      return pe && typeof Symbol == "function" && pe.constructor === Symbol && pe !== Symbol.prototype ? "symbol" : typeof pe;
    })(B);
  }
  function m(B) {
    return (m = typeof Symbol == "function" && p(Symbol.iterator) === "symbol" ? function(pe) {
      return p(pe);
    } : function(pe) {
      return pe && typeof Symbol == "function" && pe.constructor === Symbol && pe !== Symbol.prototype ? "symbol" : p(pe);
    })(B);
  }
  function v(B) {
    if (B === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return B;
  }
  function O(B) {
    return (O = Object.setPrototypeOf ? Object.getPrototypeOf : function(pe) {
      return pe.__proto__ || Object.getPrototypeOf(pe);
    })(B);
  }
  function w(B, pe) {
    return (w = Object.setPrototypeOf || function(_e, Z) {
      return _e.__proto__ = Z, _e;
    })(B, pe);
  }
  n.r(e);
  var _ = n(0), C = n.n(_), A = n(5), N = n.n(A), P = n(4), I = n.n(P), D = n(6), M = n.n(D), H = n(2), Y = n.n(H), q = n(1), Q = n.n(q);
  n(8);
  function ne(B, pe) {
    return o(B) || function(_e, Z) {
      var ce = [], j = !0, K = !1, Ee = void 0;
      try {
        for (var he, Ae = _e[Symbol.iterator](); !(j = (he = Ae.next()).done) && (ce.push(he.value), !Z || ce.length !== Z); j = !0)
          ;
      } catch (Te) {
        K = !0, Ee = Te;
      } finally {
        try {
          j || Ae.return == null || Ae.return();
        } finally {
          if (K)
            throw Ee;
        }
      }
      return ce;
    }(B, pe) || s();
  }
  var J = [["Afghanistan", ["asia"], "af", "93"], ["Albania", ["europe"], "al", "355"], ["Algeria", ["africa", "north-africa"], "dz", "213"], ["Andorra", ["europe"], "ad", "376"], ["Angola", ["africa"], "ao", "244"], ["Antigua and Barbuda", ["america", "carribean"], "ag", "1268"], ["Argentina", ["america", "south-america"], "ar", "54", "(..) ........", 0, ["11", "221", "223", "261", "264", "2652", "280", "2905", "291", "2920", "2966", "299", "341", "342", "343", "351", "376", "379", "381", "3833", "385", "387", "388"]], ["Armenia", ["asia", "ex-ussr"], "am", "374", ".. ......"], ["Aruba", ["america", "carribean"], "aw", "297"], ["Australia", ["oceania"], "au", "61", "(..) .... ....", 0, ["2", "3", "4", "7", "8", "02", "03", "04", "07", "08"]], ["Austria", ["europe", "eu-union"], "at", "43"], ["Azerbaijan", ["asia", "ex-ussr"], "az", "994", "(..) ... .. .."], ["Bahamas", ["america", "carribean"], "bs", "1242"], ["Bahrain", ["middle-east"], "bh", "973"], ["Bangladesh", ["asia"], "bd", "880"], ["Barbados", ["america", "carribean"], "bb", "1246"], ["Belarus", ["europe", "ex-ussr"], "by", "375", "(..) ... .. .."], ["Belgium", ["europe", "eu-union"], "be", "32", "... .. .. .."], ["Belize", ["america", "central-america"], "bz", "501"], ["Benin", ["africa"], "bj", "229"], ["Bhutan", ["asia"], "bt", "975"], ["Bolivia", ["america", "south-america"], "bo", "591"], ["Bosnia and Herzegovina", ["europe", "ex-yugos"], "ba", "387"], ["Botswana", ["africa"], "bw", "267"], ["Brazil", ["america", "south-america"], "br", "55", "(..) ........."], ["British Indian Ocean Territory", ["asia"], "io", "246"], ["Brunei", ["asia"], "bn", "673"], ["Bulgaria", ["europe", "eu-union"], "bg", "359"], ["Burkina Faso", ["africa"], "bf", "226"], ["Burundi", ["africa"], "bi", "257"], ["Cambodia", ["asia"], "kh", "855"], ["Cameroon", ["africa"], "cm", "237"], ["Canada", ["america", "north-america"], "ca", "1", "(...) ...-....", 1, ["204", "226", "236", "249", "250", "289", "306", "343", "365", "387", "403", "416", "418", "431", "437", "438", "450", "506", "514", "519", "548", "579", "581", "587", "604", "613", "639", "647", "672", "705", "709", "742", "778", "780", "782", "807", "819", "825", "867", "873", "902", "905"]], ["Cape Verde", ["africa"], "cv", "238"], ["Caribbean Netherlands", ["america", "carribean"], "bq", "599", "", 1], ["Central African Republic", ["africa"], "cf", "236"], ["Chad", ["africa"], "td", "235"], ["Chile", ["america", "south-america"], "cl", "56"], ["China", ["asia"], "cn", "86", "..-........."], ["Colombia", ["america", "south-america"], "co", "57", "... ... ...."], ["Comoros", ["africa"], "km", "269"], ["Congo", ["africa"], "cd", "243"], ["Congo", ["africa"], "cg", "242"], ["Costa Rica", ["america", "central-america"], "cr", "506", "....-...."], ["Côte d’Ivoire", ["africa"], "ci", "225", ".. .. .. .."], ["Croatia", ["europe", "eu-union", "ex-yugos"], "hr", "385"], ["Cuba", ["america", "carribean"], "cu", "53"], ["Curaçao", ["america", "carribean"], "cw", "599", "", 0], ["Cyprus", ["europe", "eu-union"], "cy", "357", ".. ......"], ["Czech Republic", ["europe", "eu-union"], "cz", "420", "... ... ..."], ["Denmark", ["europe", "eu-union", "baltic"], "dk", "45", ".. .. .. .."], ["Djibouti", ["africa"], "dj", "253"], ["Dominica", ["america", "carribean"], "dm", "1767"], ["Dominican Republic", ["america", "carribean"], "do", "1", "", 2, ["809", "829", "849"]], ["Ecuador", ["america", "south-america"], "ec", "593"], ["Egypt", ["africa", "north-africa"], "eg", "20"], ["El Salvador", ["america", "central-america"], "sv", "503", "....-...."], ["Equatorial Guinea", ["africa"], "gq", "240"], ["Eritrea", ["africa"], "er", "291"], ["Estonia", ["europe", "eu-union", "ex-ussr", "baltic"], "ee", "372", ".... ......"], ["Ethiopia", ["africa"], "et", "251"], ["Fiji", ["oceania"], "fj", "679"], ["Finland", ["europe", "eu-union", "baltic"], "fi", "358", ".. ... .. .."], ["France", ["europe", "eu-union"], "fr", "33", ". .. .. .. .."], ["French Guiana", ["america", "south-america"], "gf", "594"], ["French Polynesia", ["oceania"], "pf", "689"], ["Gabon", ["africa"], "ga", "241"], ["Gambia", ["africa"], "gm", "220"], ["Georgia", ["asia", "ex-ussr"], "ge", "995"], ["Germany", ["europe", "eu-union", "baltic"], "de", "49", ".... ........"], ["Ghana", ["africa"], "gh", "233"], ["Greece", ["europe", "eu-union"], "gr", "30"], ["Grenada", ["america", "carribean"], "gd", "1473"], ["Guadeloupe", ["america", "carribean"], "gp", "590", "", 0], ["Guam", ["oceania"], "gu", "1671"], ["Guatemala", ["america", "central-america"], "gt", "502", "....-...."], ["Guinea", ["africa"], "gn", "224"], ["Guinea-Bissau", ["africa"], "gw", "245"], ["Guyana", ["america", "south-america"], "gy", "592"], ["Haiti", ["america", "carribean"], "ht", "509", "....-...."], ["Honduras", ["america", "central-america"], "hn", "504"], ["Hong Kong", ["asia"], "hk", "852", ".... ...."], ["Hungary", ["europe", "eu-union"], "hu", "36"], ["Iceland", ["europe"], "is", "354", "... ...."], ["India", ["asia"], "in", "91", ".....-....."], ["Indonesia", ["asia"], "id", "62"], ["Iran", ["middle-east"], "ir", "98", "... ... ...."], ["Iraq", ["middle-east"], "iq", "964"], ["Ireland", ["europe", "eu-union"], "ie", "353", ".. ......."], ["Israel", ["middle-east"], "il", "972", "... ... ...."], ["Italy", ["europe", "eu-union"], "it", "39", "... .......", 0], ["Jamaica", ["america", "carribean"], "jm", "1876"], ["Japan", ["asia"], "jp", "81", ".. .... ...."], ["Jordan", ["middle-east"], "jo", "962"], ["Kazakhstan", ["asia", "ex-ussr"], "kz", "7", "... ...-..-..", 1, ["310", "311", "312", "313", "315", "318", "321", "324", "325", "326", "327", "336", "7172", "73622"]], ["Kenya", ["africa"], "ke", "254"], ["Kiribati", ["oceania"], "ki", "686"], ["Kosovo", ["europe", "ex-yugos"], "xk", "383"], ["Kuwait", ["middle-east"], "kw", "965"], ["Kyrgyzstan", ["asia", "ex-ussr"], "kg", "996", "... ... ..."], ["Laos", ["asia"], "la", "856"], ["Latvia", ["europe", "eu-union", "ex-ussr", "baltic"], "lv", "371", ".. ... ..."], ["Lebanon", ["middle-east"], "lb", "961"], ["Lesotho", ["africa"], "ls", "266"], ["Liberia", ["africa"], "lr", "231"], ["Libya", ["africa", "north-africa"], "ly", "218"], ["Liechtenstein", ["europe"], "li", "423"], ["Lithuania", ["europe", "eu-union", "ex-ussr", "baltic"], "lt", "370"], ["Luxembourg", ["europe", "eu-union"], "lu", "352"], ["Macau", ["asia"], "mo", "853"], ["Macedonia", ["europe", "ex-yugos"], "mk", "389"], ["Madagascar", ["africa"], "mg", "261"], ["Malawi", ["africa"], "mw", "265"], ["Malaysia", ["asia"], "my", "60", "..-....-...."], ["Maldives", ["asia"], "mv", "960"], ["Mali", ["africa"], "ml", "223"], ["Malta", ["europe", "eu-union"], "mt", "356"], ["Marshall Islands", ["oceania"], "mh", "692"], ["Martinique", ["america", "carribean"], "mq", "596"], ["Mauritania", ["africa"], "mr", "222"], ["Mauritius", ["africa"], "mu", "230"], ["Mexico", ["america", "central-america"], "mx", "52", "... ... ....", 0, ["55", "81", "33", "656", "664", "998", "774", "229"]], ["Micronesia", ["oceania"], "fm", "691"], ["Moldova", ["europe"], "md", "373", "(..) ..-..-.."], ["Monaco", ["europe"], "mc", "377"], ["Mongolia", ["asia"], "mn", "976"], ["Montenegro", ["europe", "ex-yugos"], "me", "382"], ["Morocco", ["africa", "north-africa"], "ma", "212"], ["Mozambique", ["africa"], "mz", "258"], ["Myanmar", ["asia"], "mm", "95"], ["Namibia", ["africa"], "na", "264"], ["Nauru", ["africa"], "nr", "674"], ["Nepal", ["asia"], "np", "977"], ["Netherlands", ["europe", "eu-union"], "nl", "31", ".. ........"], ["New Caledonia", ["oceania"], "nc", "687"], ["New Zealand", ["oceania"], "nz", "64", "...-...-...."], ["Nicaragua", ["america", "central-america"], "ni", "505"], ["Niger", ["africa"], "ne", "227"], ["Nigeria", ["africa"], "ng", "234"], ["North Korea", ["asia"], "kp", "850"], ["Norway", ["europe", "baltic"], "no", "47", "... .. ..."], ["Oman", ["middle-east"], "om", "968"], ["Pakistan", ["asia"], "pk", "92", "...-......."], ["Palau", ["oceania"], "pw", "680"], ["Palestine", ["middle-east"], "ps", "970"], ["Panama", ["america", "central-america"], "pa", "507"], ["Papua New Guinea", ["oceania"], "pg", "675"], ["Paraguay", ["america", "south-america"], "py", "595"], ["Peru", ["america", "south-america"], "pe", "51"], ["Philippines", ["asia"], "ph", "63", ".... ......."], ["Poland", ["europe", "eu-union", "baltic"], "pl", "48", "...-...-..."], ["Portugal", ["europe", "eu-union"], "pt", "351"], ["Puerto Rico", ["america", "carribean"], "pr", "1", "", 3, ["787", "939"]], ["Qatar", ["middle-east"], "qa", "974"], ["Réunion", ["africa"], "re", "262"], ["Romania", ["europe", "eu-union"], "ro", "40"], ["Russia", ["europe", "asia", "ex-ussr", "baltic"], "ru", "7", "(...) ...-..-..", 0], ["Rwanda", ["africa"], "rw", "250"], ["Saint Kitts and Nevis", ["america", "carribean"], "kn", "1869"], ["Saint Lucia", ["america", "carribean"], "lc", "1758"], ["Saint Vincent and the Grenadines", ["america", "carribean"], "vc", "1784"], ["Samoa", ["oceania"], "ws", "685"], ["San Marino", ["europe"], "sm", "378"], ["São Tomé and Príncipe", ["africa"], "st", "239"], ["Saudi Arabia", ["middle-east"], "sa", "966"], ["Senegal", ["africa"], "sn", "221"], ["Serbia", ["europe", "ex-yugos"], "rs", "381"], ["Seychelles", ["africa"], "sc", "248"], ["Sierra Leone", ["africa"], "sl", "232"], ["Singapore", ["asia"], "sg", "65", "....-...."], ["Slovakia", ["europe", "eu-union"], "sk", "421"], ["Slovenia", ["europe", "eu-union", "ex-yugos"], "si", "386"], ["Solomon Islands", ["oceania"], "sb", "677"], ["Somalia", ["africa"], "so", "252"], ["South Africa", ["africa"], "za", "27"], ["South Korea", ["asia"], "kr", "82", "... .... ...."], ["South Sudan", ["africa", "north-africa"], "ss", "211"], ["Spain", ["europe", "eu-union"], "es", "34", "... ... ..."], ["Sri Lanka", ["asia"], "lk", "94"], ["Sudan", ["africa"], "sd", "249"], ["Suriname", ["america", "south-america"], "sr", "597"], ["Swaziland", ["africa"], "sz", "268"], ["Sweden", ["europe", "eu-union", "baltic"], "se", "46", "(...) ...-..."], ["Switzerland", ["europe"], "ch", "41", ".. ... .. .."], ["Syria", ["middle-east"], "sy", "963"], ["Taiwan", ["asia"], "tw", "886"], ["Tajikistan", ["asia", "ex-ussr"], "tj", "992"], ["Tanzania", ["africa"], "tz", "255"], ["Thailand", ["asia"], "th", "66"], ["Timor-Leste", ["asia"], "tl", "670"], ["Togo", ["africa"], "tg", "228"], ["Tonga", ["oceania"], "to", "676"], ["Trinidad and Tobago", ["america", "carribean"], "tt", "1868"], ["Tunisia", ["africa", "north-africa"], "tn", "216"], ["Turkey", ["europe"], "tr", "90", "... ... .. .."], ["Turkmenistan", ["asia", "ex-ussr"], "tm", "993"], ["Tuvalu", ["asia"], "tv", "688"], ["Uganda", ["africa"], "ug", "256"], ["Ukraine", ["europe", "ex-ussr"], "ua", "380", "(..) ... .. .."], ["United Arab Emirates", ["middle-east"], "ae", "971"], ["United Kingdom", ["europe", "eu-union"], "gb", "44", ".... ......"], ["United States", ["america", "north-america"], "us", "1", "(...) ...-....", 0, ["907", "205", "251", "256", "334", "479", "501", "870", "480", "520", "602", "623", "928", "209", "213", "310", "323", "408", "415", "510", "530", "559", "562", "619", "626", "650", "661", "707", "714", "760", "805", "818", "831", "858", "909", "916", "925", "949", "951", "303", "719", "970", "203", "860", "202", "302", "239", "305", "321", "352", "386", "407", "561", "727", "772", "813", "850", "863", "904", "941", "954", "229", "404", "478", "706", "770", "912", "808", "319", "515", "563", "641", "712", "208", "217", "309", "312", "618", "630", "708", "773", "815", "847", "219", "260", "317", "574", "765", "812", "316", "620", "785", "913", "270", "502", "606", "859", "225", "318", "337", "504", "985", "413", "508", "617", "781", "978", "301", "410", "207", "231", "248", "269", "313", "517", "586", "616", "734", "810", "906", "989", "218", "320", "507", "612", "651", "763", "952", "314", "417", "573", "636", "660", "816", "228", "601", "662", "406", "252", "336", "704", "828", "910", "919", "701", "308", "402", "603", "201", "609", "732", "856", "908", "973", "505", "575", "702", "775", "212", "315", "516", "518", "585", "607", "631", "716", "718", "845", "914", "216", "330", "419", "440", "513", "614", "740", "937", "405", "580", "918", "503", "541", "215", "412", "570", "610", "717", "724", "814", "401", "803", "843", "864", "605", "423", "615", "731", "865", "901", "931", "210", "214", "254", "281", "325", "361", "409", "432", "512", "713", "806", "817", "830", "903", "915", "936", "940", "956", "972", "979", "435", "801", "276", "434", "540", "703", "757", "804", "802", "206", "253", "360", "425", "509", "262", "414", "608", "715", "920", "304", "307"]], ["Uruguay", ["america", "south-america"], "uy", "598"], ["Uzbekistan", ["asia", "ex-ussr"], "uz", "998", ".. ... .. .."], ["Vanuatu", ["oceania"], "vu", "678"], ["Vatican City", ["europe"], "va", "39", ".. .... ....", 1], ["Venezuela", ["america", "south-america"], "ve", "58"], ["Vietnam", ["asia"], "vn", "84"], ["Yemen", ["middle-east"], "ye", "967"], ["Zambia", ["africa"], "zm", "260"], ["Zimbabwe", ["africa"], "zw", "263"]], ue = [["American Samoa", ["oceania"], "as", "1684"], ["Anguilla", ["america", "carribean"], "ai", "1264"], ["Bermuda", ["america", "north-america"], "bm", "1441"], ["British Virgin Islands", ["america", "carribean"], "vg", "1284"], ["Cayman Islands", ["america", "carribean"], "ky", "1345"], ["Cook Islands", ["oceania"], "ck", "682"], ["Falkland Islands", ["america", "south-america"], "fk", "500"], ["Faroe Islands", ["europe"], "fo", "298"], ["Gibraltar", ["europe"], "gi", "350"], ["Greenland", ["america"], "gl", "299"], ["Jersey", ["europe", "eu-union"], "je", "44", ".... ......"], ["Montserrat", ["america", "carribean"], "ms", "1664"], ["Niue", ["asia"], "nu", "683"], ["Norfolk Island", ["oceania"], "nf", "672"], ["Northern Mariana Islands", ["oceania"], "mp", "1670"], ["Saint Barthélemy", ["america", "carribean"], "bl", "590", "", 1], ["Saint Helena", ["africa"], "sh", "290"], ["Saint Martin", ["america", "carribean"], "mf", "590", "", 2], ["Saint Pierre and Miquelon", ["america", "north-america"], "pm", "508"], ["Sint Maarten", ["america", "carribean"], "sx", "1721"], ["Tokelau", ["oceania"], "tk", "690"], ["Turks and Caicos Islands", ["america", "carribean"], "tc", "1649"], ["U.S. Virgin Islands", ["america", "carribean"], "vi", "1340"], ["Wallis and Futuna", ["oceania"], "wf", "681"]];
  function ee(B, pe, _e, Z, ce) {
    return !_e || ce ? B + "".padEnd(pe.length, ".") + " " + Z : B + "".padEnd(pe.length, ".") + " " + _e;
  }
  function fe(B, pe, _e, Z, ce) {
    var j, K, Ee = [];
    return K = pe === !0, [(j = []).concat.apply(j, i(B.map(function(he) {
      var Ae = { name: he[0], regions: he[1], iso2: he[2], countryCode: he[3], dialCode: he[3], format: ee(_e, he[3], he[4], Z, ce), priority: he[5] || 0 }, Te = [];
      return he[6] && he[6].map(function(je) {
        var we = function(lt) {
          for (var st = 1; st < arguments.length; st++) {
            var Oe = arguments[st] != null ? arguments[st] : {}, Re = Object.keys(Oe);
            typeof Object.getOwnPropertySymbols == "function" && (Re = Re.concat(Object.getOwnPropertySymbols(Oe).filter(function(Be) {
              return Object.getOwnPropertyDescriptor(Oe, Be).enumerable;
            }))), Re.forEach(function(Be) {
              r(lt, Be, Oe[Be]);
            });
          }
          return lt;
        }({}, Ae);
        we.dialCode = he[3] + je, we.isAreaCode = !0, we.areaCodeLength = je.length, Te.push(we);
      }), Te.length > 0 ? (Ae.mainCode = !0, K || pe.constructor.name === "Array" && pe.includes(he[2]) ? (Ae.hasAreaCodes = !0, [Ae].concat(Te)) : (Ee = Ee.concat(Te), [Ae])) : [Ae];
    }))), Ee];
  }
  function de(B, pe, _e, Z) {
    if (_e !== null) {
      var ce = Object.keys(_e), j = Object.values(_e);
      ce.forEach(function(K, Ee) {
        if (Z)
          return B.push([K, j[Ee]]);
        var he = B.findIndex(function(Te) {
          return Te[0] === K;
        });
        if (he === -1) {
          var Ae = [K];
          Ae[pe] = j[Ee], B.push(Ae);
        } else
          B[he][pe] = j[Ee];
      });
    }
  }
  function ie(B, pe) {
    return pe.length === 0 ? B : B.map(function(_e) {
      var Z = pe.findIndex(function(j) {
        return j[0] === _e[2];
      });
      if (Z === -1)
        return _e;
      var ce = pe[Z];
      return ce[1] && (_e[4] = ce[1]), ce[3] && (_e[5] = ce[3]), ce[2] && (_e[6] = ce[2]), _e;
    });
  }
  var le = function B(pe, _e, Z, ce, j, K, Ee, he, Ae, Te, je, we, lt, st) {
    u(this, B), this.filterRegions = function(Rt, Ut) {
      if (typeof Rt == "string") {
        var He = Rt;
        return Ut.filter(function(Ve) {
          return Ve.regions.some(function(Ie) {
            return Ie === He;
          });
        });
      }
      return Ut.filter(function(Ve) {
        return Rt.map(function(Ie) {
          return Ve.regions.some(function(it) {
            return it === Ie;
          });
        }).some(function(Ie) {
          return Ie;
        });
      });
    }, this.sortTerritories = function(Rt, Ut) {
      var He = [].concat(i(Rt), i(Ut));
      return He.sort(function(Ve, Ie) {
        return Ve.name < Ie.name ? -1 : Ve.name > Ie.name ? 1 : 0;
      }), He;
    }, this.getFilteredCountryList = function(Rt, Ut, He) {
      return Rt.length === 0 ? Ut : He ? Rt.map(function(Ve) {
        var Ie = Ut.find(function(it) {
          return it.iso2 === Ve;
        });
        if (Ie)
          return Ie;
      }).filter(function(Ve) {
        return Ve;
      }) : Ut.filter(function(Ve) {
        return Rt.some(function(Ie) {
          return Ie === Ve.iso2;
        });
      });
    }, this.localizeCountries = function(Rt, Ut, He) {
      for (var Ve = 0; Ve < Rt.length; Ve++)
        Ut[Rt[Ve].iso2] !== void 0 ? Rt[Ve].localName = Ut[Rt[Ve].iso2] : Ut[Rt[Ve].name] !== void 0 && (Rt[Ve].localName = Ut[Rt[Ve].name]);
      return He || Rt.sort(function(Ie, it) {
        return Ie.localName < it.localName ? -1 : Ie.localName > it.localName ? 1 : 0;
      }), Rt;
    }, this.getCustomAreas = function(Rt, Ut) {
      for (var He = [], Ve = 0; Ve < Ut.length; Ve++) {
        var Ie = JSON.parse(JSON.stringify(Rt));
        Ie.dialCode += Ut[Ve], He.push(Ie);
      }
      return He;
    }, this.excludeCountries = function(Rt, Ut) {
      return Ut.length === 0 ? Rt : Rt.filter(function(He) {
        return !Ut.includes(He.iso2);
      });
    };
    var Oe = function(Rt, Ut, He) {
      var Ve = [];
      return de(Ve, 1, Rt, !0), de(Ve, 3, Ut), de(Ve, 2, He), Ve;
    }(he, Ae, Te), Re = ie(JSON.parse(JSON.stringify(J)), Oe), Be = ie(JSON.parse(JSON.stringify(ue)), Oe), mt = ne(fe(Re, pe, we, lt, st), 2), Tt = mt[0], ut = mt[1];
    if (_e) {
      var wt = ne(fe(Be, pe, we, lt, st), 2), Yt = wt[0];
      wt[1], Tt = this.sortTerritories(Yt, Tt);
    }
    Z && (Tt = this.filterRegions(Z, Tt)), this.onlyCountries = this.localizeCountries(this.excludeCountries(this.getFilteredCountryList(ce, Tt, Ee.includes("onlyCountries")), K), je, Ee.includes("onlyCountries")), this.preferredCountries = j.length === 0 ? [] : this.localizeCountries(this.getFilteredCountryList(j, Tt, Ee.includes("preferredCountries")), je, Ee.includes("preferredCountries")), this.hiddenAreaCodes = this.excludeCountries(this.getFilteredCountryList(ce, ut), K);
  }, ye = function(B) {
    function pe(ce) {
      var j;
      u(this, pe), (j = function(Oe, Re) {
        return !Re || m(Re) !== "object" && typeof Re != "function" ? v(Oe) : Re;
      }(this, O(pe).call(this, ce))).getProbableCandidate = I()(function(Oe) {
        return Oe && Oe.length !== 0 ? j.state.onlyCountries.filter(function(Re) {
          return Y()(Re.name.toLowerCase(), Oe.toLowerCase());
        }, v(v(j)))[0] : null;
      }), j.guessSelectedCountry = I()(function(Oe, Re, Be, mt) {
        var Tt;
        if (j.props.enableAreaCodes === !1 && (mt.some(function(Yt) {
          if (Y()(Oe, Yt.dialCode))
            return Be.some(function(Rt) {
              if (Yt.iso2 === Rt.iso2 && Rt.mainCode)
                return Tt = Rt, !0;
            }), !0;
        }), Tt))
          return Tt;
        var ut = Be.find(function(Yt) {
          return Yt.iso2 == Re;
        });
        if (Oe.trim() === "")
          return ut;
        var wt = Be.reduce(function(Yt, Rt) {
          return Y()(Oe, Rt.dialCode) && (Rt.dialCode.length > Yt.dialCode.length || Rt.dialCode.length === Yt.dialCode.length && Rt.priority < Yt.priority) ? Rt : Yt;
        }, { dialCode: "", priority: 10001 }, v(v(j)));
        return wt.name ? wt : ut;
      }), j.updateCountry = function(Oe) {
        var Re, Be = j.state.onlyCountries;
        (Re = Oe.indexOf(0) >= "0" && Oe.indexOf(0) <= "9" ? Be.find(function(mt) {
          return mt.dialCode == +Oe;
        }) : Be.find(function(mt) {
          return mt.iso2 == Oe;
        })) && Re.dialCode && j.setState({ selectedCountry: Re, formattedNumber: j.props.disableCountryCode ? "" : j.formatNumber(Re.dialCode, Re) });
      }, j.scrollTo = function(Oe, Re) {
        if (Oe) {
          var Be = j.dropdownRef;
          if (Be && document.body) {
            var mt = Be.offsetHeight, Tt = Be.getBoundingClientRect().top + document.body.scrollTop, ut = Tt + mt, wt = Oe, Yt = wt.getBoundingClientRect(), Rt = wt.offsetHeight, Ut = Yt.top + document.body.scrollTop, He = Ut + Rt, Ve = Ut - Tt + Be.scrollTop, Ie = mt / 2 - Rt / 2;
            if (j.props.enableSearch ? Ut < Tt + 32 : Ut < Tt)
              Re && (Ve -= Ie), Be.scrollTop = Ve;
            else if (He > ut) {
              Re && (Ve += Ie);
              var it = mt - Rt;
              Be.scrollTop = Ve - it;
            }
          }
        }
      }, j.scrollToTop = function() {
        var Oe = j.dropdownRef;
        Oe && document.body && (Oe.scrollTop = 0);
      }, j.formatNumber = function(Oe, Re) {
        if (!Re)
          return Oe;
        var Be, mt = Re.format, Tt = j.props, ut = Tt.disableCountryCode, wt = Tt.enableAreaCodeStretch, Yt = Tt.enableLongNumbers, Rt = Tt.autoFormat;
        if (ut ? ((Be = mt.split(" ")).shift(), Be = Be.join(" ")) : wt && Re.isAreaCode ? ((Be = mt.split(" "))[1] = Be[1].replace(/\.+/, "".padEnd(Re.areaCodeLength, ".")), Be = Be.join(" ")) : Be = mt, !Oe || Oe.length === 0)
          return ut ? "" : j.props.prefix;
        if (Oe && Oe.length < 2 || !Be || !Rt)
          return ut ? Oe : j.props.prefix + Oe;
        var Ut, He = M()(Be, function(Ve, Ie) {
          if (Ve.remainingText.length === 0)
            return Ve;
          if (Ie !== ".")
            return { formattedText: Ve.formattedText + Ie, remainingText: Ve.remainingText };
          var it, zt = o(it = Ve.remainingText) || a(it) || s(), Ht = zt[0], bt = zt.slice(1);
          return { formattedText: Ve.formattedText + Ht, remainingText: bt };
        }, { formattedText: "", remainingText: Oe.split("") });
        return (Ut = Yt ? He.formattedText + He.remainingText.join("") : He.formattedText).includes("(") && !Ut.includes(")") && (Ut += ")"), Ut;
      }, j.cursorToEnd = function() {
        var Oe = j.numberInputRef;
        if (document.activeElement === Oe) {
          Oe.focus();
          var Re = Oe.value.length;
          Oe.value.charAt(Re - 1) === ")" && (Re -= 1), Oe.setSelectionRange(Re, Re);
        }
      }, j.getElement = function(Oe) {
        return j["flag_no_".concat(Oe)];
      }, j.getCountryData = function() {
        return j.state.selectedCountry ? { name: j.state.selectedCountry.name || "", dialCode: j.state.selectedCountry.dialCode || "", countryCode: j.state.selectedCountry.iso2 || "", format: j.state.selectedCountry.format || "" } : {};
      }, j.handleFlagDropdownClick = function(Oe) {
        if (Oe.preventDefault(), j.state.showDropdown || !j.props.disabled) {
          var Re = j.state, Be = Re.preferredCountries, mt = Re.onlyCountries, Tt = Re.selectedCountry, ut = j.concatPreferredCountries(Be, mt).findIndex(function(wt) {
            return wt.dialCode === Tt.dialCode && wt.iso2 === Tt.iso2;
          });
          j.setState({ showDropdown: !j.state.showDropdown, highlightCountryIndex: ut }, function() {
            j.state.showDropdown && j.scrollTo(j.getElement(j.state.highlightCountryIndex));
          });
        }
      }, j.handleInput = function(Oe) {
        var Re = Oe.target.value, Be = j.props, mt = Be.prefix, Tt = Be.onChange, ut = j.props.disableCountryCode ? "" : mt, wt = j.state.selectedCountry, Yt = j.state.freezeSelection;
        if (!j.props.countryCodeEditable) {
          var Rt = mt + (wt.hasAreaCodes ? j.state.onlyCountries.find(function(ze) {
            return ze.iso2 === wt.iso2 && ze.mainCode;
          }).dialCode : wt.dialCode);
          if (Re.slice(0, Rt.length) !== Rt)
            return;
        }
        if (Re === mt)
          return Tt && Tt("", j.getCountryData(), Oe, ""), j.setState({ formattedNumber: "" });
        if (!(Re.replace(/\D/g, "").length > 15 && (j.props.enableLongNumbers === !1 || typeof j.props.enableLongNumbers == "number" && Re.replace(/\D/g, "").length > j.props.enableLongNumbers)) && Re !== j.state.formattedNumber) {
          Oe.preventDefault ? Oe.preventDefault() : Oe.returnValue = !1;
          var Ut = j.props.country, He = j.state, Ve = He.onlyCountries, Ie = He.selectedCountry, it = He.hiddenAreaCodes;
          if (Tt && Oe.persist(), Re.length > 0) {
            var zt = Re.replace(/\D/g, "");
            (!j.state.freezeSelection || Ie && Ie.dialCode.length > zt.length) && (wt = j.props.disableCountryGuess ? Ie : j.guessSelectedCountry(zt.substring(0, 6), Ut, Ve, it) || Ie, Yt = !1), ut = j.formatNumber(zt, wt), wt = wt.dialCode ? wt : Ie;
          }
          var Ht = Oe.target.selectionStart, bt = Oe.target.selectionStart, Mt = j.state.formattedNumber, ln = ut.length - Mt.length;
          j.setState({ formattedNumber: ut, freezeSelection: Yt, selectedCountry: wt }, function() {
            ln > 0 && (bt -= ln), ut.charAt(ut.length - 1) == ")" ? j.numberInputRef.setSelectionRange(ut.length - 1, ut.length - 1) : bt > 0 && Mt.length >= ut.length ? j.numberInputRef.setSelectionRange(bt, bt) : Ht < Mt.length && j.numberInputRef.setSelectionRange(Ht, Ht), Tt && Tt(ut.replace(/[^0-9]+/g, ""), j.getCountryData(), Oe, ut);
          });
        }
      }, j.handleInputClick = function(Oe) {
        j.setState({ showDropdown: !1 }), j.props.onClick && j.props.onClick(Oe, j.getCountryData());
      }, j.handleDoubleClick = function(Oe) {
        var Re = Oe.target.value.length;
        Oe.target.setSelectionRange(0, Re);
      }, j.handleFlagItemClick = function(Oe, Re) {
        var Be = j.state.selectedCountry, mt = j.state.onlyCountries.find(function(Yt) {
          return Yt == Oe;
        });
        if (mt) {
          var Tt = j.state.formattedNumber.replace(" ", "").replace("(", "").replace(")", "").replace("-", ""), ut = Tt.length > 1 ? Tt.replace(Be.dialCode, mt.dialCode) : mt.dialCode, wt = j.formatNumber(ut.replace(/\D/g, ""), mt);
          j.setState({ showDropdown: !1, selectedCountry: mt, freezeSelection: !0, formattedNumber: wt, searchValue: "" }, function() {
            j.cursorToEnd(), j.props.onChange && j.props.onChange(wt.replace(/[^0-9]+/g, ""), j.getCountryData(), Re, wt);
          });
        }
      }, j.handleInputFocus = function(Oe) {
        j.numberInputRef && j.numberInputRef.value === j.props.prefix && j.state.selectedCountry && !j.props.disableCountryCode && j.setState({ formattedNumber: j.props.prefix + j.state.selectedCountry.dialCode }, function() {
          j.props.jumpCursorToEnd && setTimeout(j.cursorToEnd, 0);
        }), j.setState({ placeholder: "" }), j.props.onFocus && j.props.onFocus(Oe, j.getCountryData()), j.props.jumpCursorToEnd && setTimeout(j.cursorToEnd, 0);
      }, j.handleInputBlur = function(Oe) {
        Oe.target.value || j.setState({ placeholder: j.props.placeholder }), j.props.onBlur && j.props.onBlur(Oe, j.getCountryData());
      }, j.handleInputCopy = function(Oe) {
        if (j.props.copyNumbersOnly) {
          var Re = window.getSelection().toString().replace(/[^0-9]+/g, "");
          Oe.clipboardData.setData("text/plain", Re), Oe.preventDefault();
        }
      }, j.getHighlightCountryIndex = function(Oe) {
        var Re = j.state.highlightCountryIndex + Oe;
        return Re < 0 || Re >= j.state.onlyCountries.length + j.state.preferredCountries.length ? Re - Oe : j.props.enableSearch && Re > j.getSearchFilteredCountries().length ? 0 : Re;
      }, j.searchCountry = function() {
        var Oe = j.getProbableCandidate(j.state.queryString) || j.state.onlyCountries[0], Re = j.state.onlyCountries.findIndex(function(Be) {
          return Be == Oe;
        }) + j.state.preferredCountries.length;
        j.scrollTo(j.getElement(Re), !0), j.setState({ queryString: "", highlightCountryIndex: Re });
      }, j.handleKeydown = function(Oe) {
        var Re = j.props.keys, Be = Oe.target.className;
        if (Be.includes("selected-flag") && Oe.which === Re.ENTER && !j.state.showDropdown)
          return j.handleFlagDropdownClick(Oe);
        if (Be.includes("form-control") && (Oe.which === Re.ENTER || Oe.which === Re.ESC))
          return Oe.target.blur();
        if (j.state.showDropdown && !j.props.disabled && (!Be.includes("search-box") || Oe.which === Re.UP || Oe.which === Re.DOWN || Oe.which === Re.ENTER || Oe.which === Re.ESC && Oe.target.value === "")) {
          Oe.preventDefault ? Oe.preventDefault() : Oe.returnValue = !1;
          var mt = function(Tt) {
            j.setState({ highlightCountryIndex: j.getHighlightCountryIndex(Tt) }, function() {
              j.scrollTo(j.getElement(j.state.highlightCountryIndex), !0);
            });
          };
          switch (Oe.which) {
            case Re.DOWN:
              mt(1);
              break;
            case Re.UP:
              mt(-1);
              break;
            case Re.ENTER:
              j.props.enableSearch ? j.handleFlagItemClick(j.getSearchFilteredCountries()[j.state.highlightCountryIndex] || j.getSearchFilteredCountries()[0], Oe) : j.handleFlagItemClick([].concat(i(j.state.preferredCountries), i(j.state.onlyCountries))[j.state.highlightCountryIndex], Oe);
              break;
            case Re.ESC:
            case Re.TAB:
              j.setState({ showDropdown: !1 }, j.cursorToEnd);
              break;
            default:
              (Oe.which >= Re.A && Oe.which <= Re.Z || Oe.which === Re.SPACE) && j.setState({ queryString: j.state.queryString + String.fromCharCode(Oe.which) }, j.state.debouncedQueryStingSearcher);
          }
        }
      }, j.handleInputKeyDown = function(Oe) {
        var Re = j.props, Be = Re.keys, mt = Re.onEnterKeyPress, Tt = Re.onKeyDown;
        Oe.which === Be.ENTER && mt && mt(Oe), Tt && Tt(Oe);
      }, j.handleClickOutside = function(Oe) {
        j.dropdownRef && !j.dropdownContainerRef.contains(Oe.target) && j.state.showDropdown && j.setState({ showDropdown: !1 });
      }, j.handleSearchChange = function(Oe) {
        var Re = Oe.currentTarget.value, Be = j.state, mt = Be.preferredCountries, Tt = Be.selectedCountry, ut = 0;
        if (Re === "" && Tt) {
          var wt = j.state.onlyCountries;
          ut = j.concatPreferredCountries(mt, wt).findIndex(function(Yt) {
            return Yt == Tt;
          }), setTimeout(function() {
            return j.scrollTo(j.getElement(ut));
          }, 100);
        }
        j.setState({ searchValue: Re, highlightCountryIndex: ut });
      }, j.concatPreferredCountries = function(Oe, Re) {
        return Oe.length > 0 ? i(new Set(Oe.concat(Re))) : Re;
      }, j.getDropdownCountryName = function(Oe) {
        return Oe.localName || Oe.name;
      }, j.getSearchFilteredCountries = function() {
        var Oe = j.state, Re = Oe.preferredCountries, Be = Oe.onlyCountries, mt = Oe.searchValue, Tt = j.props.enableSearch, ut = j.concatPreferredCountries(Re, Be), wt = mt.trim().toLowerCase().replace("+", "");
        if (Tt && wt) {
          if (/^\d+$/.test(wt))
            return ut.filter(function(Ut) {
              var He = Ut.dialCode;
              return ["".concat(He)].some(function(Ve) {
                return Ve.toLowerCase().includes(wt);
              });
            });
          var Yt = ut.filter(function(Ut) {
            var He = Ut.iso2;
            return ["".concat(He)].some(function(Ve) {
              return Ve.toLowerCase().includes(wt);
            });
          }), Rt = ut.filter(function(Ut) {
            var He = Ut.name, Ve = Ut.localName;
            return Ut.iso2, ["".concat(He), "".concat(Ve || "")].some(function(Ie) {
              return Ie.toLowerCase().includes(wt);
            });
          });
          return j.scrollToTop(), i(new Set([].concat(Yt, Rt)));
        }
        return ut;
      }, j.getCountryDropdownList = function() {
        var Oe = j.state, Re = Oe.preferredCountries, Be = Oe.highlightCountryIndex, mt = Oe.showDropdown, Tt = Oe.searchValue, ut = j.props, wt = ut.disableDropdown, Yt = ut.prefix, Rt = j.props, Ut = Rt.enableSearch, He = Rt.searchNotFound, Ve = Rt.disableSearchIcon, Ie = Rt.searchClass, it = Rt.searchStyle, zt = Rt.searchPlaceholder, Ht = Rt.autocompleteSearch, bt = j.getSearchFilteredCountries().map(function(ze, gt) {
          var Bt = Be === gt, Qt = Q()({ country: !0, preferred: ze.iso2 === "us" || ze.iso2 === "gb", active: ze.iso2 === "us", highlight: Bt }), En = "flag ".concat(ze.iso2);
          return C.a.createElement("li", Object.assign({ ref: function(Mn) {
            return j["flag_no_".concat(gt)] = Mn;
          }, key: "flag_no_".concat(gt), "data-flag-key": "flag_no_".concat(gt), className: Qt, "data-dial-code": "1", tabIndex: wt ? "-1" : "0", "data-country-code": ze.iso2, onClick: function(Mn) {
            return j.handleFlagItemClick(ze, Mn);
          }, role: "option" }, Bt ? { "aria-selected": !0 } : {}), C.a.createElement("div", { className: En }), C.a.createElement("span", { className: "country-name" }, j.getDropdownCountryName(ze)), C.a.createElement("span", { className: "dial-code" }, ze.format ? j.formatNumber(ze.dialCode, ze) : Yt + ze.dialCode));
        }), Mt = C.a.createElement("li", { key: "dashes", className: "divider" });
        Re.length > 0 && (!Ut || Ut && !Tt.trim()) && bt.splice(Re.length, 0, Mt);
        var ln = Q()(r({ "country-list": !0, hide: !mt }, j.props.dropdownClass, !0));
        return C.a.createElement("ul", { ref: function(ze) {
          return !Ut && ze && ze.focus(), j.dropdownRef = ze;
        }, className: ln, style: j.props.dropdownStyle, role: "listbox", tabIndex: "0" }, Ut && C.a.createElement("li", { className: Q()(r({ search: !0 }, Ie, Ie)) }, !Ve && C.a.createElement("span", { className: Q()(r({ "search-emoji": !0 }, "".concat(Ie, "-emoji"), Ie)), role: "img", "aria-label": "Magnifying glass" }, "🔎"), C.a.createElement("input", { className: Q()(r({ "search-box": !0 }, "".concat(Ie, "-box"), Ie)), style: it, type: "search", placeholder: zt, autoFocus: !0, autoComplete: Ht ? "on" : "off", value: Tt, onChange: j.handleSearchChange })), bt.length > 0 ? bt : C.a.createElement("li", { className: "no-entries-message" }, C.a.createElement("span", null, He)));
      };
      var K, Ee = new le(ce.enableAreaCodes, ce.enableTerritories, ce.regions, ce.onlyCountries, ce.preferredCountries, ce.excludeCountries, ce.preserveOrder, ce.masks, ce.priority, ce.areaCodes, ce.localization, ce.prefix, ce.defaultMask, ce.alwaysDefaultMask), he = Ee.onlyCountries, Ae = Ee.preferredCountries, Te = Ee.hiddenAreaCodes, je = ce.value ? ce.value.replace(/\D/g, "") : "";
      K = ce.disableInitialCountryGuess ? 0 : je.length > 1 ? j.guessSelectedCountry(je.substring(0, 6), ce.country, he, Te) || 0 : ce.country && he.find(function(Oe) {
        return Oe.iso2 == ce.country;
      }) || 0;
      var we, lt = je.length < 2 && K && !Y()(je, K.dialCode) ? K.dialCode : "";
      we = je === "" && K === 0 ? "" : j.formatNumber((ce.disableCountryCode ? "" : lt) + je, K.name ? K : void 0);
      var st = he.findIndex(function(Oe) {
        return Oe == K;
      });
      return j.state = { showDropdown: ce.showDropdown, formattedNumber: we, onlyCountries: he, preferredCountries: Ae, hiddenAreaCodes: Te, selectedCountry: K, highlightCountryIndex: st, queryString: "", freezeSelection: !1, debouncedQueryStingSearcher: N()(j.searchCountry, 250), searchValue: "" }, j;
    }
    var _e, Z;
    return function(ce, j) {
      if (typeof j != "function" && j !== null)
        throw new TypeError("Super expression must either be null or a function");
      ce.prototype = Object.create(j && j.prototype, { constructor: { value: ce, writable: !0, configurable: !0 } }), j && w(ce, j);
    }(pe, B), _e = pe, (Z = [{ key: "componentDidMount", value: function() {
      document.addEventListener && this.props.enableClickOutside && document.addEventListener("mousedown", this.handleClickOutside), this.props.onMount && this.props.onMount(this.state.formattedNumber.replace(/[^0-9]+/g, ""), this.getCountryData(), this.state.formattedNumber);
    } }, { key: "componentWillUnmount", value: function() {
      document.removeEventListener && this.props.enableClickOutside && document.removeEventListener("mousedown", this.handleClickOutside);
    } }, { key: "componentDidUpdate", value: function(ce, j, K) {
      ce.country !== this.props.country ? this.updateCountry(this.props.country) : ce.value !== this.props.value && this.updateFormattedNumber(this.props.value);
    } }, { key: "updateFormattedNumber", value: function(ce) {
      if (ce === null)
        return this.setState({ selectedCountry: 0, formattedNumber: "" });
      var j = this.state, K = j.onlyCountries, Ee = j.selectedCountry, he = j.hiddenAreaCodes, Ae = this.props, Te = Ae.country, je = Ae.prefix;
      if (ce === "")
        return this.setState({ selectedCountry: Ee, formattedNumber: "" });
      var we, lt, st = ce.replace(/\D/g, "");
      if (Ee && Y()(ce, je + Ee.dialCode))
        lt = this.formatNumber(st, Ee), this.setState({ formattedNumber: lt });
      else {
        var Oe = (we = this.props.disableCountryGuess ? Ee : this.guessSelectedCountry(st.substring(0, 6), Te, K, he) || Ee) && Y()(st, je + we.dialCode) ? we.dialCode : "";
        lt = this.formatNumber((this.props.disableCountryCode ? "" : Oe) + st, we || void 0), this.setState({ selectedCountry: we, formattedNumber: lt });
      }
    } }, { key: "render", value: function() {
      var ce, j, K, Ee = this, he = this.state, Ae = he.onlyCountries, Te = he.selectedCountry, je = he.showDropdown, we = he.formattedNumber, lt = he.hiddenAreaCodes, st = this.props, Oe = st.disableDropdown, Re = st.renderStringAsFlag, Be = st.isValid, mt = st.defaultErrorMessage, Tt = st.specialLabel;
      if (typeof Be == "boolean")
        j = Be;
      else {
        var ut = Be(we.replace(/\D/g, ""), Te, Ae, lt);
        typeof ut == "boolean" ? (j = ut) === !1 && (K = mt) : (j = !1, K = ut);
      }
      var wt = Q()((r(ce = {}, this.props.containerClass, !0), r(ce, "react-tel-input", !0), ce)), Yt = Q()({ arrow: !0, up: je }), Rt = Q()(r({ "form-control": !0, "invalid-number": !j, open: je }, this.props.inputClass, !0)), Ut = Q()({ "selected-flag": !0, open: je }), He = Q()(r({ "flag-dropdown": !0, "invalid-number": !j, open: je }, this.props.buttonClass, !0)), Ve = "flag ".concat(Te && Te.iso2);
      return C.a.createElement("div", { className: "".concat(wt, " ").concat(this.props.className), style: this.props.style || this.props.containerStyle, onKeyDown: this.handleKeydown }, Tt && C.a.createElement("div", { className: "special-label" }, Tt), K && C.a.createElement("div", { className: "invalid-number-message" }, K), C.a.createElement("input", Object.assign({ className: Rt, style: this.props.inputStyle, onChange: this.handleInput, onClick: this.handleInputClick, onDoubleClick: this.handleDoubleClick, onFocus: this.handleInputFocus, onBlur: this.handleInputBlur, onCopy: this.handleInputCopy, value: we, onKeyDown: this.handleInputKeyDown, placeholder: this.props.placeholder, disabled: this.props.disabled, type: "tel" }, this.props.inputProps, { ref: function(Ie) {
        Ee.numberInputRef = Ie, typeof Ee.props.inputProps.ref == "function" ? Ee.props.inputProps.ref(Ie) : typeof Ee.props.inputProps.ref == "object" && (Ee.props.inputProps.ref.current = Ie);
      } })), C.a.createElement("div", { className: He, style: this.props.buttonStyle, ref: function(Ie) {
        return Ee.dropdownContainerRef = Ie;
      } }, Re ? C.a.createElement("div", { className: Ut }, Re) : C.a.createElement("div", { onClick: Oe ? void 0 : this.handleFlagDropdownClick, className: Ut, title: Te ? "".concat(Te.localName || Te.name, ": + ").concat(Te.dialCode) : "", tabIndex: Oe ? "-1" : "0", role: "button", "aria-haspopup": "listbox", "aria-expanded": !!je || void 0 }, C.a.createElement("div", { className: Ve }, !Oe && C.a.createElement("div", { className: Yt }))), je && this.getCountryDropdownList()));
    } }]) && f(_e.prototype, Z), pe;
  }(C.a.Component);
  ye.defaultProps = { country: "", value: "", onlyCountries: [], preferredCountries: [], excludeCountries: [], placeholder: "1 (702) 123-4567", searchPlaceholder: "search", searchNotFound: "No entries to show", flagsImagePath: "./flags.png", disabled: !1, containerStyle: {}, inputStyle: {}, buttonStyle: {}, dropdownStyle: {}, searchStyle: {}, containerClass: "", inputClass: "", buttonClass: "", dropdownClass: "", searchClass: "", className: "", autoFormat: !0, enableAreaCodes: !1, enableTerritories: !1, disableCountryCode: !1, disableDropdown: !1, enableLongNumbers: !1, countryCodeEditable: !0, enableSearch: !1, disableSearchIcon: !1, disableInitialCountryGuess: !1, disableCountryGuess: !1, regions: "", inputProps: {}, localization: {}, masks: null, priority: null, areaCodes: null, preserveOrder: [], defaultMask: "... ... ... ... ..", alwaysDefaultMask: !1, prefix: "+", copyNumbersOnly: !0, renderStringAsFlag: "", autocompleteSearch: !1, jumpCursorToEnd: !0, enableAreaCodeStretch: !1, enableClickOutside: !0, showDropdown: !1, isValid: !0, defaultErrorMessage: "", specialLabel: "Phone", onEnterKeyPress: null, keys: { UP: 38, DOWN: 40, RIGHT: 39, LEFT: 37, ENTER: 13, ESC: 27, PLUS: 43, A: 65, Z: 90, SPACE: 32, TAB: 9 } }, e.default = ye;
}]);
const FDe = /* @__PURE__ */ Pl(MDe), DXe = bs(({
  onChange: t,
  name: e,
  label: n,
  value: r,
  className: a,
  placeholder: i,
  phone: o,
  regions: s,
  ...u
}, f) => {
  const p = "byz-phone-input", [m, v] = kn("");
  function O(w, _, C, A) {
    if (t) {
      debugger;
      t({
        value: A,
        name: e
      });
    } else
      v(A);
  }
  return Nl(f, () => ({
    value: m == null ? void 0 : m.toString()
  })), /* @__PURE__ */ Ne.jsxs("label", { className: pn(p, a), ...u, children: [
    n && /* @__PURE__ */ Ne.jsx("div", { className: `${p}__label`, children: n }),
    /* @__PURE__ */ Ne.jsx(
      FDe,
      {
        inputClass: `${p}__input`,
        country: "us",
        placeholder: i,
        value: m,
        inputProps: {
          name: "phone",
          required: !0,
          autoFocus: !0
        },
        onChange: O
      }
    )
  ] });
});
const $De = bs(
  ({
    onChange: t,
    name: e,
    label: n,
    value: r,
    description: a,
    className: i,
    placeholder: o,
    iconType: s,
    iconPosition: u = "left",
    disableFocusFix: f = !1,
    ...p
  }, m) => {
    const v = "byz-text-input", [O, w] = kn(null), _ = dr();
    l_(() => {
      var N;
      f || (N = _.current) == null || N.setSelectionRange(O, O);
    }, [_, O, r]);
    function C(N) {
      w(N.target.selectionStart), t == null || t({
        value: N.target.value,
        sourceEvent: N,
        name: e
      });
    }
    function A(N) {
      typeof m == "function" ? m(N) : m && (m.current = N), _.current = N;
    }
    return /* @__PURE__ */ Ne.jsxs(
      "label",
      {
        className: pn(v, i, {
          [`${v}--with-icon`]: s
        }),
        ...p,
        children: [
          n && /* @__PURE__ */ Ne.jsx("div", { className: `${v}__label`, children: n }),
          a && /* @__PURE__ */ Ne.jsx("div", { className: `${v}__description`, children: a }),
          /* @__PURE__ */ Ne.jsxs("div", { className: `${v}__input-wrapper`, children: [
            s && /* @__PURE__ */ Ne.jsx("i", { className: pn(`${v}__icon`, `${v}__icon--type-${s}`, {
              [`${v}__icon--pos-${u}`]: u
            }) }),
            /* @__PURE__ */ Ne.jsx(
              "input",
              {
                type: "text",
                className: `${v}__input`,
                ref: A,
                onChange: C,
                value: r,
                placeholder: o
              }
            )
          ] })
        ]
      }
    );
  }
), BDe = Ge.memo($De);
BDe.displayName = "ByzzerTextInput";
class la {
  /**
  Get the line description around the given position.
  */
  lineAt(e) {
    if (e < 0 || e > this.length)
      throw new RangeError(`Invalid position ${e} in document of length ${this.length}`);
    return this.lineInner(e, !1, 1, 0);
  }
  /**
  Get the description for the given (1-based) line number.
  */
  line(e) {
    if (e < 1 || e > this.lines)
      throw new RangeError(`Invalid line number ${e} in ${this.lines}-line document`);
    return this.lineInner(e, !0, 1, 0);
  }
  /**
  Replace a range of the text with the given content.
  */
  replace(e, n, r) {
    [e, n] = WE(this, e, n);
    let a = [];
    return this.decompose(
      0,
      e,
      a,
      2
      /* Open.To */
    ), r.length && r.decompose(
      0,
      r.length,
      a,
      3
      /* Open.To */
    ), this.decompose(
      n,
      this.length,
      a,
      1
      /* Open.From */
    ), vh.from(a, this.length - (n - e) + r.length);
  }
  /**
  Append another document to this one.
  */
  append(e) {
    return this.replace(this.length, this.length, e);
  }
  /**
  Retrieve the text between the given points.
  */
  slice(e, n = this.length) {
    [e, n] = WE(this, e, n);
    let r = [];
    return this.decompose(e, n, r, 0), vh.from(r, n - e);
  }
  /**
  Test whether this text is equal to another instance.
  */
  eq(e) {
    if (e == this)
      return !0;
    if (e.length != this.length || e.lines != this.lines)
      return !1;
    let n = this.scanIdentical(e, 1), r = this.length - this.scanIdentical(e, -1), a = new iT(this), i = new iT(e);
    for (let o = n, s = n; ; ) {
      if (a.next(o), i.next(o), o = 0, a.lineBreak != i.lineBreak || a.done != i.done || a.value != i.value)
        return !1;
      if (s += a.value.length, a.done || s >= r)
        return !0;
    }
  }
  /**
  Iterate over the text. When `dir` is `-1`, iteration happens
  from end to start. This will return lines and the breaks between
  them as separate strings.
  */
  iter(e = 1) {
    return new iT(this, e);
  }
  /**
  Iterate over a range of the text. When `from` > `to`, the
  iterator will run in reverse.
  */
  iterRange(e, n = this.length) {
    return new fae(this, e, n);
  }
  /**
  Return a cursor that iterates over the given range of lines,
  _without_ returning the line breaks between, and yielding empty
  strings for empty lines.
  
  When `from` and `to` are given, they should be 1-based line numbers.
  */
  iterLines(e, n) {
    let r;
    if (e == null)
      r = this.iter();
    else {
      n == null && (n = this.lines + 1);
      let a = this.line(e).from;
      r = this.iterRange(a, Math.max(a, n == this.lines + 1 ? this.length : n <= 1 ? 0 : this.line(n - 1).to));
    }
    return new dae(r);
  }
  /**
  Return the document as a string, using newline characters to
  separate lines.
  */
  toString() {
    return this.sliceString(0);
  }
  /**
  Convert the document to an array of lines (which can be
  deserialized again via [`Text.of`](https://codemirror.net/6/docs/ref/#state.Text^of)).
  */
  toJSON() {
    let e = [];
    return this.flatten(e), e;
  }
  /**
  @internal
  */
  constructor() {
  }
  /**
  Create a `Text` instance for the given array of lines.
  */
  static of(e) {
    if (e.length == 0)
      throw new RangeError("A document must have at least one line");
    return e.length == 1 && !e[0] ? la.empty : e.length <= 32 ? new lo(e) : vh.from(lo.split(e, []));
  }
}
class lo extends la {
  constructor(e, n = UDe(e)) {
    super(), this.text = e, this.length = n;
  }
  get lines() {
    return this.text.length;
  }
  get children() {
    return null;
  }
  lineInner(e, n, r, a) {
    for (let i = 0; ; i++) {
      let o = this.text[i], s = a + o.length;
      if ((n ? r : s) >= e)
        return new zDe(a, s, r, o);
      a = s + 1, r++;
    }
  }
  decompose(e, n, r, a) {
    let i = e <= 0 && n >= this.length ? this : new lo(uX(this.text, e, n), Math.min(n, this.length) - Math.max(0, e));
    if (a & 1) {
      let o = r.pop(), s = Ok(i.text, o.text.slice(), 0, i.length);
      if (s.length <= 32)
        r.push(new lo(s, o.length + i.length));
      else {
        let u = s.length >> 1;
        r.push(new lo(s.slice(0, u)), new lo(s.slice(u)));
      }
    } else
      r.push(i);
  }
  replace(e, n, r) {
    if (!(r instanceof lo))
      return super.replace(e, n, r);
    [e, n] = WE(this, e, n);
    let a = Ok(this.text, Ok(r.text, uX(this.text, 0, e)), n), i = this.length + r.length - (n - e);
    return a.length <= 32 ? new lo(a, i) : vh.from(lo.split(a, []), i);
  }
  sliceString(e, n = this.length, r = `
`) {
    [e, n] = WE(this, e, n);
    let a = "";
    for (let i = 0, o = 0; i <= n && o < this.text.length; o++) {
      let s = this.text[o], u = i + s.length;
      i > e && o && (a += r), e < u && n > i && (a += s.slice(Math.max(0, e - i), n - i)), i = u + 1;
    }
    return a;
  }
  flatten(e) {
    for (let n of this.text)
      e.push(n);
  }
  scanIdentical() {
    return 0;
  }
  static split(e, n) {
    let r = [], a = -1;
    for (let i of e)
      r.push(i), a += i.length + 1, r.length == 32 && (n.push(new lo(r, a)), r = [], a = -1);
    return a > -1 && n.push(new lo(r, a)), n;
  }
}
class vh extends la {
  constructor(e, n) {
    super(), this.children = e, this.length = n, this.lines = 0;
    for (let r of e)
      this.lines += r.lines;
  }
  lineInner(e, n, r, a) {
    for (let i = 0; ; i++) {
      let o = this.children[i], s = a + o.length, u = r + o.lines - 1;
      if ((n ? u : s) >= e)
        return o.lineInner(e, n, r, a);
      a = s + 1, r = u + 1;
    }
  }
  decompose(e, n, r, a) {
    for (let i = 0, o = 0; o <= n && i < this.children.length; i++) {
      let s = this.children[i], u = o + s.length;
      if (e <= u && n >= o) {
        let f = a & ((o <= e ? 1 : 0) | (u >= n ? 2 : 0));
        o >= e && u <= n && !f ? r.push(s) : s.decompose(e - o, n - o, r, f);
      }
      o = u + 1;
    }
  }
  replace(e, n, r) {
    if ([e, n] = WE(this, e, n), r.lines < this.lines)
      for (let a = 0, i = 0; a < this.children.length; a++) {
        let o = this.children[a], s = i + o.length;
        if (e >= i && n <= s) {
          let u = o.replace(e - i, n - i, r), f = this.lines - o.lines + u.lines;
          if (u.lines < f >> 5 - 1 && u.lines > f >> 5 + 1) {
            let p = this.children.slice();
            return p[a] = u, new vh(p, this.length - (n - e) + r.length);
          }
          return super.replace(i, s, u);
        }
        i = s + 1;
      }
    return super.replace(e, n, r);
  }
  sliceString(e, n = this.length, r = `
`) {
    [e, n] = WE(this, e, n);
    let a = "";
    for (let i = 0, o = 0; i < this.children.length && o <= n; i++) {
      let s = this.children[i], u = o + s.length;
      o > e && i && (a += r), e < u && n > o && (a += s.sliceString(e - o, n - o, r)), o = u + 1;
    }
    return a;
  }
  flatten(e) {
    for (let n of this.children)
      n.flatten(e);
  }
  scanIdentical(e, n) {
    if (!(e instanceof vh))
      return 0;
    let r = 0, [a, i, o, s] = n > 0 ? [0, 0, this.children.length, e.children.length] : [this.children.length - 1, e.children.length - 1, -1, -1];
    for (; ; a += n, i += n) {
      if (a == o || i == s)
        return r;
      let u = this.children[a], f = e.children[i];
      if (u != f)
        return r + u.scanIdentical(f, n);
      r += u.length + 1;
    }
  }
  static from(e, n = e.reduce((r, a) => r + a.length + 1, -1)) {
    let r = 0;
    for (let O of e)
      r += O.lines;
    if (r < 32) {
      let O = [];
      for (let w of e)
        w.flatten(O);
      return new lo(O, n);
    }
    let a = Math.max(
      32,
      r >> 5
      /* Tree.BranchShift */
    ), i = a << 1, o = a >> 1, s = [], u = 0, f = -1, p = [];
    function m(O) {
      let w;
      if (O.lines > i && O instanceof vh)
        for (let _ of O.children)
          m(_);
      else
        O.lines > o && (u > o || !u) ? (v(), s.push(O)) : O instanceof lo && u && (w = p[p.length - 1]) instanceof lo && O.lines + w.lines <= 32 ? (u += O.lines, f += O.length + 1, p[p.length - 1] = new lo(w.text.concat(O.text), w.length + 1 + O.length)) : (u + O.lines > a && v(), u += O.lines, f += O.length + 1, p.push(O));
    }
    function v() {
      u != 0 && (s.push(p.length == 1 ? p[0] : vh.from(p, f)), f = -1, u = p.length = 0);
    }
    for (let O of e)
      m(O);
    return v(), s.length == 1 ? s[0] : new vh(s, n);
  }
}
la.empty = /* @__PURE__ */ new lo([""], 0);
function UDe(t) {
  let e = -1;
  for (let n of t)
    e += n.length + 1;
  return e;
}
function Ok(t, e, n = 0, r = 1e9) {
  for (let a = 0, i = 0, o = !0; i < t.length && a <= r; i++) {
    let s = t[i], u = a + s.length;
    u >= n && (u > r && (s = s.slice(0, r - a)), a < n && (s = s.slice(n - a)), o ? (e[e.length - 1] += s, o = !1) : e.push(s)), a = u + 1;
  }
  return e;
}
function uX(t, e, n) {
  return Ok(t, [""], e, n);
}
class iT {
  constructor(e, n = 1) {
    this.dir = n, this.done = !1, this.lineBreak = !1, this.value = "", this.nodes = [e], this.offsets = [n > 0 ? 1 : (e instanceof lo ? e.text.length : e.children.length) << 1];
  }
  nextInner(e, n) {
    for (this.done = this.lineBreak = !1; ; ) {
      let r = this.nodes.length - 1, a = this.nodes[r], i = this.offsets[r], o = i >> 1, s = a instanceof lo ? a.text.length : a.children.length;
      if (o == (n > 0 ? s : 0)) {
        if (r == 0)
          return this.done = !0, this.value = "", this;
        n > 0 && this.offsets[r - 1]++, this.nodes.pop(), this.offsets.pop();
      } else if ((i & 1) == (n > 0 ? 0 : 1)) {
        if (this.offsets[r] += n, e == 0)
          return this.lineBreak = !0, this.value = `
`, this;
        e--;
      } else if (a instanceof lo) {
        let u = a.text[o + (n < 0 ? -1 : 0)];
        if (this.offsets[r] += n, u.length > Math.max(0, e))
          return this.value = e == 0 ? u : n > 0 ? u.slice(e) : u.slice(0, u.length - e), this;
        e -= u.length;
      } else {
        let u = a.children[o + (n < 0 ? -1 : 0)];
        e > u.length ? (e -= u.length, this.offsets[r] += n) : (n < 0 && this.offsets[r]--, this.nodes.push(u), this.offsets.push(n > 0 ? 1 : (u instanceof lo ? u.text.length : u.children.length) << 1));
      }
    }
  }
  next(e = 0) {
    return e < 0 && (this.nextInner(-e, -this.dir), e = this.value.length), this.nextInner(e, this.dir);
  }
}
class fae {
  constructor(e, n, r) {
    this.value = "", this.done = !1, this.cursor = new iT(e, n > r ? -1 : 1), this.pos = n > r ? e.length : 0, this.from = Math.min(n, r), this.to = Math.max(n, r);
  }
  nextInner(e, n) {
    if (n < 0 ? this.pos <= this.from : this.pos >= this.to)
      return this.value = "", this.done = !0, this;
    e += Math.max(0, n < 0 ? this.pos - this.to : this.from - this.pos);
    let r = n < 0 ? this.pos - this.from : this.to - this.pos;
    e > r && (e = r), r -= e;
    let { value: a } = this.cursor.next(e);
    return this.pos += (a.length + e) * n, this.value = a.length <= r ? a : n < 0 ? a.slice(a.length - r) : a.slice(0, r), this.done = !this.value, this;
  }
  next(e = 0) {
    return e < 0 ? e = Math.max(e, this.from - this.pos) : e > 0 && (e = Math.min(e, this.to - this.pos)), this.nextInner(e, this.cursor.dir);
  }
  get lineBreak() {
    return this.cursor.lineBreak && this.value != "";
  }
}
class dae {
  constructor(e) {
    this.inner = e, this.afterBreak = !0, this.value = "", this.done = !1;
  }
  next(e = 0) {
    let { done: n, lineBreak: r, value: a } = this.inner.next(e);
    return n && this.afterBreak ? (this.value = "", this.afterBreak = !1) : n ? (this.done = !0, this.value = "") : r ? this.afterBreak ? this.value = "" : (this.afterBreak = !0, this.next()) : (this.value = a, this.afterBreak = !1), this;
  }
  get lineBreak() {
    return !1;
  }
}
typeof Symbol < "u" && (la.prototype[Symbol.iterator] = function() {
  return this.iter();
}, iT.prototype[Symbol.iterator] = fae.prototype[Symbol.iterator] = dae.prototype[Symbol.iterator] = function() {
  return this;
});
let zDe = class {
  /**
  @internal
  */
  constructor(e, n, r, a) {
    this.from = e, this.to = n, this.number = r, this.text = a;
  }
  /**
  The length of the line (not including any line break after it).
  */
  get length() {
    return this.to - this.from;
  }
};
function WE(t, e, n) {
  return e = Math.max(0, Math.min(t.length, e)), [e, Math.max(e, Math.min(t.length, n))];
}
let CE = /* @__PURE__ */ "lc,34,7n,7,7b,19,,,,2,,2,,,20,b,1c,l,g,,2t,7,2,6,2,2,,4,z,,u,r,2j,b,1m,9,9,,o,4,,9,,3,,5,17,3,3b,f,,w,1j,,,,4,8,4,,3,7,a,2,t,,1m,,,,2,4,8,,9,,a,2,q,,2,2,1l,,4,2,4,2,2,3,3,,u,2,3,,b,2,1l,,4,5,,2,4,,k,2,m,6,,,1m,,,2,,4,8,,7,3,a,2,u,,1n,,,,c,,9,,14,,3,,1l,3,5,3,,4,7,2,b,2,t,,1m,,2,,2,,3,,5,2,7,2,b,2,s,2,1l,2,,,2,4,8,,9,,a,2,t,,20,,4,,2,3,,,8,,29,,2,7,c,8,2q,,2,9,b,6,22,2,r,,,,,,1j,e,,5,,2,5,b,,10,9,,2u,4,,6,,2,2,2,p,2,4,3,g,4,d,,2,2,6,,f,,jj,3,qa,3,t,3,t,2,u,2,1s,2,,7,8,,2,b,9,,19,3,3b,2,y,,3a,3,4,2,9,,6,3,63,2,2,,1m,,,7,,,,,2,8,6,a,2,,1c,h,1r,4,1c,7,,,5,,14,9,c,2,w,4,2,2,,3,1k,,,2,3,,,3,1m,8,2,2,48,3,,d,,7,4,,6,,3,2,5i,1m,,5,ek,,5f,x,2da,3,3x,,2o,w,fe,6,2x,2,n9w,4,,a,w,2,28,2,7k,,3,,4,,p,2,5,,47,2,q,i,d,,12,8,p,b,1a,3,1c,,2,4,2,2,13,,1v,6,2,2,2,2,c,,8,,1b,,1f,,,3,2,2,5,2,,,16,2,8,,6m,,2,,4,,fn4,,kh,g,g,g,a6,2,gt,,6a,,45,5,1ae,3,,2,5,4,14,3,4,,4l,2,fx,4,ar,2,49,b,4w,,1i,f,1k,3,1d,4,2,2,1x,3,10,5,,8,1q,,c,2,1g,9,a,4,2,,2n,3,2,,,2,6,,4g,,3,8,l,2,1l,2,,,,,m,,e,7,3,5,5f,8,2,3,,,n,,29,,2,6,,,2,,,2,,2,6j,,2,4,6,2,,2,r,2,2d,8,2,,,2,2y,,,,2,6,,,2t,3,2,4,,5,77,9,,2,6t,,a,2,,,4,,40,4,2,2,4,,w,a,14,6,2,4,8,,9,6,2,3,1a,d,,2,ba,7,,6,,,2a,m,2,7,,2,,2,3e,6,3,,,2,,7,,,20,2,3,,,,9n,2,f0b,5,1n,7,t4,,1r,4,29,,f5k,2,43q,,,3,4,5,8,8,2,7,u,4,44,3,1iz,1j,4,1e,8,,e,,m,5,,f,11s,7,,h,2,7,,2,,5,79,7,c5,4,15s,7,31,7,240,5,gx7k,2o,3k,6o".split(",").map((t) => t ? parseInt(t, 36) : 1);
for (let t = 1; t < CE.length; t++)
  CE[t] += CE[t - 1];
function HDe(t) {
  for (let e = 1; e < CE.length; e += 2)
    if (CE[e] > t)
      return CE[e - 1] <= t;
  return !1;
}
function cX(t) {
  return t >= 127462 && t <= 127487;
}
const fX = 8205;
function nl(t, e, n = !0, r = !0) {
  return (n ? pae : WDe)(t, e, r);
}
function pae(t, e, n) {
  if (e == t.length)
    return e;
  e && hae(t.charCodeAt(e)) && mae(t.charCodeAt(e - 1)) && e--;
  let r = Ks(t, e);
  for (e += Uf(r); e < t.length; ) {
    let a = Ks(t, e);
    if (r == fX || a == fX || n && HDe(a))
      e += Uf(a), r = a;
    else if (cX(a)) {
      let i = 0, o = e - 2;
      for (; o >= 0 && cX(Ks(t, o)); )
        i++, o -= 2;
      if (i % 2 == 0)
        break;
      e += 2;
    } else
      break;
  }
  return e;
}
function WDe(t, e, n) {
  for (; e > 0; ) {
    let r = pae(t, e - 2, n);
    if (r < e)
      return r;
    e--;
  }
  return 0;
}
function hae(t) {
  return t >= 56320 && t < 57344;
}
function mae(t) {
  return t >= 55296 && t < 56320;
}
function Ks(t, e) {
  let n = t.charCodeAt(e);
  if (!mae(n) || e + 1 == t.length)
    return n;
  let r = t.charCodeAt(e + 1);
  return hae(r) ? (n - 55296 << 10) + (r - 56320) + 65536 : n;
}
function FU(t) {
  return t <= 65535 ? String.fromCharCode(t) : (t -= 65536, String.fromCharCode((t >> 10) + 55296, (t & 1023) + 56320));
}
function Uf(t) {
  return t < 65536 ? 1 : 2;
}
const XB = /\r\n?|\n/;
var el = /* @__PURE__ */ function(t) {
  return t[t.Simple = 0] = "Simple", t[t.TrackDel = 1] = "TrackDel", t[t.TrackBefore = 2] = "TrackBefore", t[t.TrackAfter = 3] = "TrackAfter", t;
}(el || (el = {}));
class Ch {
  // Sections are encoded as pairs of integers. The first is the
  // length in the current document, and the second is -1 for
  // unaffected sections, and the length of the replacement content
  // otherwise. So an insertion would be (0, n>0), a deletion (n>0,
  // 0), and a replacement two positive numbers.
  /**
  @internal
  */
  constructor(e) {
    this.sections = e;
  }
  /**
  The length of the document before the change.
  */
  get length() {
    let e = 0;
    for (let n = 0; n < this.sections.length; n += 2)
      e += this.sections[n];
    return e;
  }
  /**
  The length of the document after the change.
  */
  get newLength() {
    let e = 0;
    for (let n = 0; n < this.sections.length; n += 2) {
      let r = this.sections[n + 1];
      e += r < 0 ? this.sections[n] : r;
    }
    return e;
  }
  /**
  False when there are actual changes in this set.
  */
  get empty() {
    return this.sections.length == 0 || this.sections.length == 2 && this.sections[1] < 0;
  }
  /**
  Iterate over the unchanged parts left by these changes. `posA`
  provides the position of the range in the old document, `posB`
  the new position in the changed document.
  */
  iterGaps(e) {
    for (let n = 0, r = 0, a = 0; n < this.sections.length; ) {
      let i = this.sections[n++], o = this.sections[n++];
      o < 0 ? (e(r, a, i), a += i) : a += o, r += i;
    }
  }
  /**
  Iterate over the ranges changed by these changes. (See
  [`ChangeSet.iterChanges`](https://codemirror.net/6/docs/ref/#state.ChangeSet.iterChanges) for a
  variant that also provides you with the inserted text.)
  `fromA`/`toA` provides the extent of the change in the starting
  document, `fromB`/`toB` the extent of the replacement in the
  changed document.
  
  When `individual` is true, adjacent changes (which are kept
  separate for [position mapping](https://codemirror.net/6/docs/ref/#state.ChangeDesc.mapPos)) are
  reported separately.
  */
  iterChangedRanges(e, n = !1) {
    qB(this, e, n);
  }
  /**
  Get a description of the inverted form of these changes.
  */
  get invertedDesc() {
    let e = [];
    for (let n = 0; n < this.sections.length; ) {
      let r = this.sections[n++], a = this.sections[n++];
      a < 0 ? e.push(r, a) : e.push(a, r);
    }
    return new Ch(e);
  }
  /**
  Compute the combined effect of applying another set of changes
  after this one. The length of the document after this set should
  match the length before `other`.
  */
  composeDesc(e) {
    return this.empty ? e : e.empty ? this : gae(this, e);
  }
  /**
  Map this description, which should start with the same document
  as `other`, over another set of changes, so that it can be
  applied after it. When `before` is true, map as if the changes
  in `other` happened before the ones in `this`.
  */
  mapDesc(e, n = !1) {
    return e.empty ? this : KB(this, e, n);
  }
  mapPos(e, n = -1, r = el.Simple) {
    let a = 0, i = 0;
    for (let o = 0; o < this.sections.length; ) {
      let s = this.sections[o++], u = this.sections[o++], f = a + s;
      if (u < 0) {
        if (f > e)
          return i + (e - a);
        i += s;
      } else {
        if (r != el.Simple && f >= e && (r == el.TrackDel && a < e && f > e || r == el.TrackBefore && a < e || r == el.TrackAfter && f > e))
          return null;
        if (f > e || f == e && n < 0 && !s)
          return e == a || n < 0 ? i : i + u;
        i += u;
      }
      a = f;
    }
    if (e > a)
      throw new RangeError(`Position ${e} is out of range for changeset of length ${a}`);
    return i;
  }
  /**
  Check whether these changes touch a given range. When one of the
  changes entirely covers the range, the string `"cover"` is
  returned.
  */
  touchesRange(e, n = e) {
    for (let r = 0, a = 0; r < this.sections.length && a <= n; ) {
      let i = this.sections[r++], o = this.sections[r++], s = a + i;
      if (o >= 0 && a <= n && s >= e)
        return a < e && s > n ? "cover" : !0;
      a = s;
    }
    return !1;
  }
  /**
  @internal
  */
  toString() {
    let e = "";
    for (let n = 0; n < this.sections.length; ) {
      let r = this.sections[n++], a = this.sections[n++];
      e += (e ? " " : "") + r + (a >= 0 ? ":" + a : "");
    }
    return e;
  }
  /**
  Serialize this change desc to a JSON-representable value.
  */
  toJSON() {
    return this.sections;
  }
  /**
  Create a change desc from its JSON representation (as produced
  by [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeDesc.toJSON).
  */
  static fromJSON(e) {
    if (!Array.isArray(e) || e.length % 2 || e.some((n) => typeof n != "number"))
      throw new RangeError("Invalid JSON representation of ChangeDesc");
    return new Ch(e);
  }
  /**
  @internal
  */
  static create(e) {
    return new Ch(e);
  }
}
class Ko extends Ch {
  constructor(e, n) {
    super(e), this.inserted = n;
  }
  /**
  Apply the changes to a document, returning the modified
  document.
  */
  apply(e) {
    if (this.length != e.length)
      throw new RangeError("Applying change set to a document with the wrong length");
    return qB(this, (n, r, a, i, o) => e = e.replace(a, a + (r - n), o), !1), e;
  }
  mapDesc(e, n = !1) {
    return KB(this, e, n, !0);
  }
  /**
  Given the document as it existed _before_ the changes, return a
  change set that represents the inverse of this set, which could
  be used to go from the document created by the changes back to
  the document as it existed before the changes.
  */
  invert(e) {
    let n = this.sections.slice(), r = [];
    for (let a = 0, i = 0; a < n.length; a += 2) {
      let o = n[a], s = n[a + 1];
      if (s >= 0) {
        n[a] = s, n[a + 1] = o;
        let u = a >> 1;
        for (; r.length < u; )
          r.push(la.empty);
        r.push(o ? e.slice(i, i + o) : la.empty);
      }
      i += o;
    }
    return new Ko(n, r);
  }
  /**
  Combine two subsequent change sets into a single set. `other`
  must start in the document produced by `this`. If `this` goes
  `docA` → `docB` and `other` represents `docB` → `docC`, the
  returned value will represent the change `docA` → `docC`.
  */
  compose(e) {
    return this.empty ? e : e.empty ? this : gae(this, e, !0);
  }
  /**
  Given another change set starting in the same document, maps this
  change set over the other, producing a new change set that can be
  applied to the document produced by applying `other`. When
  `before` is `true`, order changes as if `this` comes before
  `other`, otherwise (the default) treat `other` as coming first.
  
  Given two changes `A` and `B`, `A.compose(B.map(A))` and
  `B.compose(A.map(B, true))` will produce the same document. This
  provides a basic form of [operational
  transformation](https://en.wikipedia.org/wiki/Operational_transformation),
  and can be used for collaborative editing.
  */
  map(e, n = !1) {
    return e.empty ? this : KB(this, e, n, !0);
  }
  /**
  Iterate over the changed ranges in the document, calling `f` for
  each, with the range in the original document (`fromA`-`toA`)
  and the range that replaces it in the new document
  (`fromB`-`toB`).
  
  When `individual` is true, adjacent changes are reported
  separately.
  */
  iterChanges(e, n = !1) {
    qB(this, e, n);
  }
  /**
  Get a [change description](https://codemirror.net/6/docs/ref/#state.ChangeDesc) for this change
  set.
  */
  get desc() {
    return Ch.create(this.sections);
  }
  /**
  @internal
  */
  filter(e) {
    let n = [], r = [], a = [], i = new $T(this);
    e:
      for (let o = 0, s = 0; ; ) {
        let u = o == e.length ? 1e9 : e[o++];
        for (; s < u || s == u && i.len == 0; ) {
          if (i.done)
            break e;
          let p = Math.min(i.len, u - s);
          kl(a, p, -1);
          let m = i.ins == -1 ? -1 : i.off == 0 ? i.ins : 0;
          kl(n, p, m), m > 0 && Wb(r, n, i.text), i.forward(p), s += p;
        }
        let f = e[o++];
        for (; s < f; ) {
          if (i.done)
            break e;
          let p = Math.min(i.len, f - s);
          kl(n, p, -1), kl(a, p, i.ins == -1 ? -1 : i.off == 0 ? i.ins : 0), i.forward(p), s += p;
        }
      }
    return {
      changes: new Ko(n, r),
      filtered: Ch.create(a)
    };
  }
  /**
  Serialize this change set to a JSON-representable value.
  */
  toJSON() {
    let e = [];
    for (let n = 0; n < this.sections.length; n += 2) {
      let r = this.sections[n], a = this.sections[n + 1];
      a < 0 ? e.push(r) : a == 0 ? e.push([r]) : e.push([r].concat(this.inserted[n >> 1].toJSON()));
    }
    return e;
  }
  /**
  Create a change set for the given changes, for a document of the
  given length, using `lineSep` as line separator.
  */
  static of(e, n, r) {
    let a = [], i = [], o = 0, s = null;
    function u(p = !1) {
      if (!p && !a.length)
        return;
      o < n && kl(a, n - o, -1);
      let m = new Ko(a, i);
      s = s ? s.compose(m.map(s)) : m, a = [], i = [], o = 0;
    }
    function f(p) {
      if (Array.isArray(p))
        for (let m of p)
          f(m);
      else if (p instanceof Ko) {
        if (p.length != n)
          throw new RangeError(`Mismatched change set length (got ${p.length}, expected ${n})`);
        u(), s = s ? s.compose(p.map(s)) : p;
      } else {
        let { from: m, to: v = m, insert: O } = p;
        if (m > v || m < 0 || v > n)
          throw new RangeError(`Invalid change range ${m} to ${v} (in doc of length ${n})`);
        let w = O ? typeof O == "string" ? la.of(O.split(r || XB)) : O : la.empty, _ = w.length;
        if (m == v && _ == 0)
          return;
        m < o && u(), m > o && kl(a, m - o, -1), kl(a, v - m, _), Wb(i, a, w), o = v;
      }
    }
    return f(e), u(!s), s;
  }
  /**
  Create an empty changeset of the given length.
  */
  static empty(e) {
    return new Ko(e ? [e, -1] : [], []);
  }
  /**
  Create a changeset from its JSON representation (as produced by
  [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeSet.toJSON).
  */
  static fromJSON(e) {
    if (!Array.isArray(e))
      throw new RangeError("Invalid JSON representation of ChangeSet");
    let n = [], r = [];
    for (let a = 0; a < e.length; a++) {
      let i = e[a];
      if (typeof i == "number")
        n.push(i, -1);
      else {
        if (!Array.isArray(i) || typeof i[0] != "number" || i.some((o, s) => s && typeof o != "string"))
          throw new RangeError("Invalid JSON representation of ChangeSet");
        if (i.length == 1)
          n.push(i[0], 0);
        else {
          for (; r.length < a; )
            r.push(la.empty);
          r[a] = la.of(i.slice(1)), n.push(i[0], r[a].length);
        }
      }
    }
    return new Ko(n, r);
  }
  /**
  @internal
  */
  static createSet(e, n) {
    return new Ko(e, n);
  }
}
function kl(t, e, n, r = !1) {
  if (e == 0 && n <= 0)
    return;
  let a = t.length - 2;
  a >= 0 && n <= 0 && n == t[a + 1] ? t[a] += e : e == 0 && t[a] == 0 ? t[a + 1] += n : r ? (t[a] += e, t[a + 1] += n) : t.push(e, n);
}
function Wb(t, e, n) {
  if (n.length == 0)
    return;
  let r = e.length - 2 >> 1;
  if (r < t.length)
    t[t.length - 1] = t[t.length - 1].append(n);
  else {
    for (; t.length < r; )
      t.push(la.empty);
    t.push(n);
  }
}
function qB(t, e, n) {
  let r = t.inserted;
  for (let a = 0, i = 0, o = 0; o < t.sections.length; ) {
    let s = t.sections[o++], u = t.sections[o++];
    if (u < 0)
      a += s, i += s;
    else {
      let f = a, p = i, m = la.empty;
      for (; f += s, p += u, u && r && (m = m.append(r[o - 2 >> 1])), !(n || o == t.sections.length || t.sections[o + 1] < 0); )
        s = t.sections[o++], u = t.sections[o++];
      e(a, f, i, p, m), a = f, i = p;
    }
  }
}
function KB(t, e, n, r = !1) {
  let a = [], i = r ? [] : null, o = new $T(t), s = new $T(e);
  for (let u = -1; ; )
    if (o.ins == -1 && s.ins == -1) {
      let f = Math.min(o.len, s.len);
      kl(a, f, -1), o.forward(f), s.forward(f);
    } else if (s.ins >= 0 && (o.ins < 0 || u == o.i || o.off == 0 && (s.len < o.len || s.len == o.len && !n))) {
      let f = s.len;
      for (kl(a, s.ins, -1); f; ) {
        let p = Math.min(o.len, f);
        o.ins >= 0 && u < o.i && o.len <= p && (kl(a, 0, o.ins), i && Wb(i, a, o.text), u = o.i), o.forward(p), f -= p;
      }
      s.next();
    } else if (o.ins >= 0) {
      let f = 0, p = o.len;
      for (; p; )
        if (s.ins == -1) {
          let m = Math.min(p, s.len);
          f += m, p -= m, s.forward(m);
        } else if (s.ins == 0 && s.len < p)
          p -= s.len, s.next();
        else
          break;
      kl(a, f, u < o.i ? o.ins : 0), i && u < o.i && Wb(i, a, o.text), u = o.i, o.forward(o.len - p);
    } else {
      if (o.done && s.done)
        return i ? Ko.createSet(a, i) : Ch.create(a);
      throw new Error("Mismatched change set lengths");
    }
}
function gae(t, e, n = !1) {
  let r = [], a = n ? [] : null, i = new $T(t), o = new $T(e);
  for (let s = !1; ; ) {
    if (i.done && o.done)
      return a ? Ko.createSet(r, a) : Ch.create(r);
    if (i.ins == 0)
      kl(r, i.len, 0, s), i.next();
    else if (o.len == 0 && !o.done)
      kl(r, 0, o.ins, s), a && Wb(a, r, o.text), o.next();
    else {
      if (i.done || o.done)
        throw new Error("Mismatched change set lengths");
      {
        let u = Math.min(i.len2, o.len), f = r.length;
        if (i.ins == -1) {
          let p = o.ins == -1 ? -1 : o.off ? 0 : o.ins;
          kl(r, u, p, s), a && p && Wb(a, r, o.text);
        } else
          o.ins == -1 ? (kl(r, i.off ? 0 : i.len, u, s), a && Wb(a, r, i.textBit(u))) : (kl(r, i.off ? 0 : i.len, o.off ? 0 : o.ins, s), a && !o.off && Wb(a, r, o.text));
        s = (i.ins > u || o.ins >= 0 && o.len > u) && (s || r.length > f), i.forward2(u), o.forward(u);
      }
    }
  }
}
class $T {
  constructor(e) {
    this.set = e, this.i = 0, this.next();
  }
  next() {
    let { sections: e } = this.set;
    this.i < e.length ? (this.len = e[this.i++], this.ins = e[this.i++]) : (this.len = 0, this.ins = -2), this.off = 0;
  }
  get done() {
    return this.ins == -2;
  }
  get len2() {
    return this.ins < 0 ? this.len : this.ins;
  }
  get text() {
    let { inserted: e } = this.set, n = this.i - 2 >> 1;
    return n >= e.length ? la.empty : e[n];
  }
  textBit(e) {
    let { inserted: n } = this.set, r = this.i - 2 >> 1;
    return r >= n.length && !e ? la.empty : n[r].slice(this.off, e == null ? void 0 : this.off + e);
  }
  forward(e) {
    e == this.len ? this.next() : (this.len -= e, this.off += e);
  }
  forward2(e) {
    this.ins == -1 ? this.forward(e) : e == this.ins ? this.next() : (this.ins -= e, this.off += e);
  }
}
class Ky {
  constructor(e, n, r) {
    this.from = e, this.to = n, this.flags = r;
  }
  /**
  The anchor of the range—the side that doesn't move when you
  extend it.
  */
  get anchor() {
    return this.flags & 32 ? this.to : this.from;
  }
  /**
  The head of the range, which is moved when the range is
  [extended](https://codemirror.net/6/docs/ref/#state.SelectionRange.extend).
  */
  get head() {
    return this.flags & 32 ? this.from : this.to;
  }
  /**
  True when `anchor` and `head` are at the same position.
  */
  get empty() {
    return this.from == this.to;
  }
  /**
  If this is a cursor that is explicitly associated with the
  character on one of its sides, this returns the side. -1 means
  the character before its position, 1 the character after, and 0
  means no association.
  */
  get assoc() {
    return this.flags & 8 ? -1 : this.flags & 16 ? 1 : 0;
  }
  /**
  The bidirectional text level associated with this cursor, if
  any.
  */
  get bidiLevel() {
    let e = this.flags & 7;
    return e == 7 ? null : e;
  }
  /**
  The goal column (stored vertical offset) associated with a
  cursor. This is used to preserve the vertical position when
  [moving](https://codemirror.net/6/docs/ref/#view.EditorView.moveVertically) across
  lines of different length.
  */
  get goalColumn() {
    let e = this.flags >> 6;
    return e == 16777215 ? void 0 : e;
  }
  /**
  Map this range through a change, producing a valid range in the
  updated document.
  */
  map(e, n = -1) {
    let r, a;
    return this.empty ? r = a = e.mapPos(this.from, n) : (r = e.mapPos(this.from, 1), a = e.mapPos(this.to, -1)), r == this.from && a == this.to ? this : new Ky(r, a, this.flags);
  }
  /**
  Extend this range to cover at least `from` to `to`.
  */
  extend(e, n = e) {
    if (e <= this.anchor && n >= this.anchor)
      return ft.range(e, n);
    let r = Math.abs(e - this.anchor) > Math.abs(n - this.anchor) ? e : n;
    return ft.range(this.anchor, r);
  }
  /**
  Compare this range to another range.
  */
  eq(e, n = !1) {
    return this.anchor == e.anchor && this.head == e.head && (!n || !this.empty || this.assoc == e.assoc);
  }
  /**
  Return a JSON-serializable object representing the range.
  */
  toJSON() {
    return { anchor: this.anchor, head: this.head };
  }
  /**
  Convert a JSON representation of a range to a `SelectionRange`
  instance.
  */
  static fromJSON(e) {
    if (!e || typeof e.anchor != "number" || typeof e.head != "number")
      throw new RangeError("Invalid JSON representation for SelectionRange");
    return ft.range(e.anchor, e.head);
  }
  /**
  @internal
  */
  static create(e, n, r) {
    return new Ky(e, n, r);
  }
}
class ft {
  constructor(e, n) {
    this.ranges = e, this.mainIndex = n;
  }
  /**
  Map a selection through a change. Used to adjust the selection
  position for changes.
  */
  map(e, n = -1) {
    return e.empty ? this : ft.create(this.ranges.map((r) => r.map(e, n)), this.mainIndex);
  }
  /**
  Compare this selection to another selection. By default, ranges
  are compared only by position. When `includeAssoc` is true,
  cursor ranges must also have the same
  [`assoc`](https://codemirror.net/6/docs/ref/#state.SelectionRange.assoc) value.
  */
  eq(e, n = !1) {
    if (this.ranges.length != e.ranges.length || this.mainIndex != e.mainIndex)
      return !1;
    for (let r = 0; r < this.ranges.length; r++)
      if (!this.ranges[r].eq(e.ranges[r], n))
        return !1;
    return !0;
  }
  /**
  Get the primary selection range. Usually, you should make sure
  your code applies to _all_ ranges, by using methods like
  [`changeByRange`](https://codemirror.net/6/docs/ref/#state.EditorState.changeByRange).
  */
  get main() {
    return this.ranges[this.mainIndex];
  }
  /**
  Make sure the selection only has one range. Returns a selection
  holding only the main range from this selection.
  */
  asSingle() {
    return this.ranges.length == 1 ? this : new ft([this.main], 0);
  }
  /**
  Extend this selection with an extra range.
  */
  addRange(e, n = !0) {
    return ft.create([e].concat(this.ranges), n ? 0 : this.mainIndex + 1);
  }
  /**
  Replace a given range with another range, and then normalize the
  selection to merge and sort ranges if necessary.
  */
  replaceRange(e, n = this.mainIndex) {
    let r = this.ranges.slice();
    return r[n] = e, ft.create(r, this.mainIndex);
  }
  /**
  Convert this selection to an object that can be serialized to
  JSON.
  */
  toJSON() {
    return { ranges: this.ranges.map((e) => e.toJSON()), main: this.mainIndex };
  }
  /**
  Create a selection from a JSON representation.
  */
  static fromJSON(e) {
    if (!e || !Array.isArray(e.ranges) || typeof e.main != "number" || e.main >= e.ranges.length)
      throw new RangeError("Invalid JSON representation for EditorSelection");
    return new ft(e.ranges.map((n) => Ky.fromJSON(n)), e.main);
  }
  /**
  Create a selection holding a single range.
  */
  static single(e, n = e) {
    return new ft([ft.range(e, n)], 0);
  }
  /**
  Sort and merge the given set of ranges, creating a valid
  selection.
  */
  static create(e, n = 0) {
    if (e.length == 0)
      throw new RangeError("A selection needs at least one range");
    for (let r = 0, a = 0; a < e.length; a++) {
      let i = e[a];
      if (i.empty ? i.from <= r : i.from < r)
        return ft.normalized(e.slice(), n);
      r = i.to;
    }
    return new ft(e, n);
  }
  /**
  Create a cursor selection range at the given position. You can
  safely ignore the optional arguments in most situations.
  */
  static cursor(e, n = 0, r, a) {
    return Ky.create(e, e, (n == 0 ? 0 : n < 0 ? 8 : 16) | (r == null ? 7 : Math.min(6, r)) | (a ?? 16777215) << 6);
  }
  /**
  Create a selection range.
  */
  static range(e, n, r, a) {
    let i = (r ?? 16777215) << 6 | (a == null ? 7 : Math.min(6, a));
    return n < e ? Ky.create(n, e, 48 | i) : Ky.create(e, n, (n > e ? 8 : 0) | i);
  }
  /**
  @internal
  */
  static normalized(e, n = 0) {
    let r = e[n];
    e.sort((a, i) => a.from - i.from), n = e.indexOf(r);
    for (let a = 1; a < e.length; a++) {
      let i = e[a], o = e[a - 1];
      if (i.empty ? i.from <= o.to : i.from < o.to) {
        let s = o.from, u = Math.max(i.to, o.to);
        a <= n && n--, e.splice(--a, 2, i.anchor > i.head ? ft.range(u, s) : ft.range(s, u));
      }
    }
    return new ft(e, n);
  }
}
function bae(t, e) {
  for (let n of t.ranges)
    if (n.to > e)
      throw new RangeError("Selection points outside of document");
}
let $U = 0;
class bn {
  constructor(e, n, r, a, i) {
    this.combine = e, this.compareInput = n, this.compare = r, this.isStatic = a, this.id = $U++, this.default = e([]), this.extensions = typeof i == "function" ? i(this) : i;
  }
  /**
  Returns a facet reader for this facet, which can be used to
  [read](https://codemirror.net/6/docs/ref/#state.EditorState.facet) it but not to define values for it.
  */
  get reader() {
    return this;
  }
  /**
  Define a new facet.
  */
  static define(e = {}) {
    return new bn(e.combine || ((n) => n), e.compareInput || ((n, r) => n === r), e.compare || (e.combine ? (n, r) => n === r : BU), !!e.static, e.enables);
  }
  /**
  Returns an extension that adds the given value to this facet.
  */
  of(e) {
    return new Ek([], this, 0, e);
  }
  /**
  Create an extension that computes a value for the facet from a
  state. You must take care to declare the parts of the state that
  this value depends on, since your function is only called again
  for a new state when one of those parts changed.
  
  In cases where your value depends only on a single field, you'll
  want to use the [`from`](https://codemirror.net/6/docs/ref/#state.Facet.from) method instead.
  */
  compute(e, n) {
    if (this.isStatic)
      throw new Error("Can't compute a static facet");
    return new Ek(e, this, 1, n);
  }
  /**
  Create an extension that computes zero or more values for this
  facet from a state.
  */
  computeN(e, n) {
    if (this.isStatic)
      throw new Error("Can't compute a static facet");
    return new Ek(e, this, 2, n);
  }
  from(e, n) {
    return n || (n = (r) => r), this.compute([e], (r) => n(r.field(e)));
  }
}
function BU(t, e) {
  return t == e || t.length == e.length && t.every((n, r) => n === e[r]);
}
class Ek {
  constructor(e, n, r, a) {
    this.dependencies = e, this.facet = n, this.type = r, this.value = a, this.id = $U++;
  }
  dynamicSlot(e) {
    var n;
    let r = this.value, a = this.facet.compareInput, i = this.id, o = e[i] >> 1, s = this.type == 2, u = !1, f = !1, p = [];
    for (let m of this.dependencies)
      m == "doc" ? u = !0 : m == "selection" ? f = !0 : ((n = e[m.id]) !== null && n !== void 0 ? n : 1) & 1 || p.push(e[m.id]);
    return {
      create(m) {
        return m.values[o] = r(m), 1;
      },
      update(m, v) {
        if (u && v.docChanged || f && (v.docChanged || v.selection) || JB(m, p)) {
          let O = r(m);
          if (s ? !dX(O, m.values[o], a) : !a(O, m.values[o]))
            return m.values[o] = O, 1;
        }
        return 0;
      },
      reconfigure: (m, v) => {
        let O, w = v.config.address[i];
        if (w != null) {
          let _ = nI(v, w);
          if (this.dependencies.every((C) => C instanceof bn ? v.facet(C) === m.facet(C) : C instanceof Ss ? v.field(C, !1) == m.field(C, !1) : !0) || (s ? dX(O = r(m), _, a) : a(O = r(m), _)))
            return m.values[o] = _, 0;
        } else
          O = r(m);
        return m.values[o] = O, 1;
      }
    };
  }
}
function dX(t, e, n) {
  if (t.length != e.length)
    return !1;
  for (let r = 0; r < t.length; r++)
    if (!n(t[r], e[r]))
      return !1;
  return !0;
}
function JB(t, e) {
  let n = !1;
  for (let r of e)
    oT(t, r) & 1 && (n = !0);
  return n;
}
function QDe(t, e, n) {
  let r = n.map((u) => t[u.id]), a = n.map((u) => u.type), i = r.filter((u) => !(u & 1)), o = t[e.id] >> 1;
  function s(u) {
    let f = [];
    for (let p = 0; p < r.length; p++) {
      let m = nI(u, r[p]);
      if (a[p] == 2)
        for (let v of m)
          f.push(v);
      else
        f.push(m);
    }
    return e.combine(f);
  }
  return {
    create(u) {
      for (let f of r)
        oT(u, f);
      return u.values[o] = s(u), 1;
    },
    update(u, f) {
      if (!JB(u, i))
        return 0;
      let p = s(u);
      return e.compare(p, u.values[o]) ? 0 : (u.values[o] = p, 1);
    },
    reconfigure(u, f) {
      let p = JB(u, r), m = f.config.facets[e.id], v = f.facet(e);
      if (m && !p && BU(n, m))
        return u.values[o] = v, 0;
      let O = s(u);
      return e.compare(O, v) ? (u.values[o] = v, 0) : (u.values[o] = O, 1);
    }
  };
}
const pX = /* @__PURE__ */ bn.define({ static: !0 });
class Ss {
  constructor(e, n, r, a, i) {
    this.id = e, this.createF = n, this.updateF = r, this.compareF = a, this.spec = i, this.provides = void 0;
  }
  /**
  Define a state field.
  */
  static define(e) {
    let n = new Ss($U++, e.create, e.update, e.compare || ((r, a) => r === a), e);
    return e.provide && (n.provides = e.provide(n)), n;
  }
  create(e) {
    let n = e.facet(pX).find((r) => r.field == this);
    return ((n == null ? void 0 : n.create) || this.createF)(e);
  }
  /**
  @internal
  */
  slot(e) {
    let n = e[this.id] >> 1;
    return {
      create: (r) => (r.values[n] = this.create(r), 1),
      update: (r, a) => {
        let i = r.values[n], o = this.updateF(i, a);
        return this.compareF(i, o) ? 0 : (r.values[n] = o, 1);
      },
      reconfigure: (r, a) => a.config.address[this.id] != null ? (r.values[n] = a.field(this), 0) : (r.values[n] = this.create(r), 1)
    };
  }
  /**
  Returns an extension that enables this field and overrides the
  way it is initialized. Can be useful when you need to provide a
  non-default starting value for the field.
  */
  init(e) {
    return [this, pX.of({ field: this, create: e })];
  }
  /**
  State field instances can be used as
  [`Extension`](https://codemirror.net/6/docs/ref/#state.Extension) values to enable the field in a
  given state.
  */
  get extension() {
    return this;
  }
}
const Yy = { lowest: 4, low: 3, default: 2, high: 1, highest: 0 };
function vw(t) {
  return (e) => new vae(e, t);
}
const ig = {
  /**
  The highest precedence level, for extensions that should end up
  near the start of the precedence ordering.
  */
  highest: /* @__PURE__ */ vw(Yy.highest),
  /**
  A higher-than-default precedence, for extensions that should
  come before those with default precedence.
  */
  high: /* @__PURE__ */ vw(Yy.high),
  /**
  The default precedence, which is also used for extensions
  without an explicit precedence.
  */
  default: /* @__PURE__ */ vw(Yy.default),
  /**
  A lower-than-default precedence.
  */
  low: /* @__PURE__ */ vw(Yy.low),
  /**
  The lowest precedence level. Meant for things that should end up
  near the end of the extension order.
  */
  lowest: /* @__PURE__ */ vw(Yy.lowest)
};
class vae {
  constructor(e, n) {
    this.inner = e, this.prec = n;
  }
}
class mD {
  /**
  Create an instance of this compartment to add to your [state
  configuration](https://codemirror.net/6/docs/ref/#state.EditorStateConfig.extensions).
  */
  of(e) {
    return new e4(this, e);
  }
  /**
  Create an [effect](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) that
  reconfigures this compartment.
  */
  reconfigure(e) {
    return mD.reconfigure.of({ compartment: this, extension: e });
  }
  /**
  Get the current content of the compartment in the state, or
  `undefined` if it isn't present.
  */
  get(e) {
    return e.config.compartments.get(this);
  }
}
class e4 {
  constructor(e, n) {
    this.compartment = e, this.inner = n;
  }
}
class tI {
  constructor(e, n, r, a, i, o) {
    for (this.base = e, this.compartments = n, this.dynamicSlots = r, this.address = a, this.staticValues = i, this.facets = o, this.statusTemplate = []; this.statusTemplate.length < r.length; )
      this.statusTemplate.push(
        0
        /* SlotStatus.Unresolved */
      );
  }
  staticFacet(e) {
    let n = this.address[e.id];
    return n == null ? e.default : this.staticValues[n >> 1];
  }
  static resolve(e, n, r) {
    let a = [], i = /* @__PURE__ */ Object.create(null), o = /* @__PURE__ */ new Map();
    for (let v of jDe(e, n, o))
      v instanceof Ss ? a.push(v) : (i[v.facet.id] || (i[v.facet.id] = [])).push(v);
    let s = /* @__PURE__ */ Object.create(null), u = [], f = [];
    for (let v of a)
      s[v.id] = f.length << 1, f.push((O) => v.slot(O));
    let p = r == null ? void 0 : r.config.facets;
    for (let v in i) {
      let O = i[v], w = O[0].facet, _ = p && p[v] || [];
      if (O.every(
        (C) => C.type == 0
        /* Provider.Static */
      ))
        if (s[w.id] = u.length << 1 | 1, BU(_, O))
          u.push(r.facet(w));
        else {
          let C = w.combine(O.map((A) => A.value));
          u.push(r && w.compare(C, r.facet(w)) ? r.facet(w) : C);
        }
      else {
        for (let C of O)
          C.type == 0 ? (s[C.id] = u.length << 1 | 1, u.push(C.value)) : (s[C.id] = f.length << 1, f.push((A) => C.dynamicSlot(A)));
        s[w.id] = f.length << 1, f.push((C) => QDe(C, w, O));
      }
    }
    let m = f.map((v) => v(s));
    return new tI(e, o, m, s, u, i);
  }
}
function jDe(t, e, n) {
  let r = [[], [], [], [], []], a = /* @__PURE__ */ new Map();
  function i(o, s) {
    let u = a.get(o);
    if (u != null) {
      if (u <= s)
        return;
      let f = r[u].indexOf(o);
      f > -1 && r[u].splice(f, 1), o instanceof e4 && n.delete(o.compartment);
    }
    if (a.set(o, s), Array.isArray(o))
      for (let f of o)
        i(f, s);
    else if (o instanceof e4) {
      if (n.has(o.compartment))
        throw new RangeError("Duplicate use of compartment in extensions");
      let f = e.get(o.compartment) || o.inner;
      n.set(o.compartment, f), i(f, s);
    } else if (o instanceof vae)
      i(o.inner, o.prec);
    else if (o instanceof Ss)
      r[s].push(o), o.provides && i(o.provides, s);
    else if (o instanceof Ek)
      r[s].push(o), o.facet.extensions && i(o.facet.extensions, Yy.default);
    else {
      let f = o.extension;
      if (!f)
        throw new Error(`Unrecognized extension value in extension set (${o}). This sometimes happens because multiple instances of @codemirror/state are loaded, breaking instanceof checks.`);
      i(f, s);
    }
  }
  return i(t, Yy.default), r.reduce((o, s) => o.concat(s));
}
function oT(t, e) {
  if (e & 1)
    return 2;
  let n = e >> 1, r = t.status[n];
  if (r == 4)
    throw new Error("Cyclic dependency between fields and/or facets");
  if (r & 2)
    return r;
  t.status[n] = 4;
  let a = t.computeSlot(t, t.config.dynamicSlots[n]);
  return t.status[n] = 2 | a;
}
function nI(t, e) {
  return e & 1 ? t.config.staticValues[e >> 1] : t.values[e >> 1];
}
const yae = /* @__PURE__ */ bn.define(), t4 = /* @__PURE__ */ bn.define({
  combine: (t) => t.some((e) => e),
  static: !0
}), Oae = /* @__PURE__ */ bn.define({
  combine: (t) => t.length ? t[0] : void 0,
  static: !0
}), Eae = /* @__PURE__ */ bn.define(), Sae = /* @__PURE__ */ bn.define(), wae = /* @__PURE__ */ bn.define(), Tae = /* @__PURE__ */ bn.define({
  combine: (t) => t.length ? t[0] : !1
});
class Ih {
  /**
  @internal
  */
  constructor(e, n) {
    this.type = e, this.value = n;
  }
  /**
  Define a new type of annotation.
  */
  static define() {
    return new GDe();
  }
}
class GDe {
  /**
  Create an instance of this annotation.
  */
  of(e) {
    return new Ih(this, e);
  }
}
class VDe {
  /**
  @internal
  */
  constructor(e) {
    this.map = e;
  }
  /**
  Create a [state effect](https://codemirror.net/6/docs/ref/#state.StateEffect) instance of this
  type.
  */
  of(e) {
    return new fr(this, e);
  }
}
class fr {
  /**
  @internal
  */
  constructor(e, n) {
    this.type = e, this.value = n;
  }
  /**
  Map this effect through a position mapping. Will return
  `undefined` when that ends up deleting the effect.
  */
  map(e) {
    let n = this.type.map(this.value, e);
    return n === void 0 ? void 0 : n == this.value ? this : new fr(this.type, n);
  }
  /**
  Tells you whether this effect object is of a given
  [type](https://codemirror.net/6/docs/ref/#state.StateEffectType).
  */
  is(e) {
    return this.type == e;
  }
  /**
  Define a new effect type. The type parameter indicates the type
  of values that his effect holds. It should be a type that
  doesn't include `undefined`, since that is used in
  [mapping](https://codemirror.net/6/docs/ref/#state.StateEffect.map) to indicate that an effect is
  removed.
  */
  static define(e = {}) {
    return new VDe(e.map || ((n) => n));
  }
  /**
  Map an array of effects through a change set.
  */
  static mapEffects(e, n) {
    if (!e.length)
      return e;
    let r = [];
    for (let a of e) {
      let i = a.map(n);
      i && r.push(i);
    }
    return r;
  }
}
fr.reconfigure = /* @__PURE__ */ fr.define();
fr.appendConfig = /* @__PURE__ */ fr.define();
class No {
  constructor(e, n, r, a, i, o) {
    this.startState = e, this.changes = n, this.selection = r, this.effects = a, this.annotations = i, this.scrollIntoView = o, this._doc = null, this._state = null, r && bae(r, n.newLength), i.some((s) => s.type == No.time) || (this.annotations = i.concat(No.time.of(Date.now())));
  }
  /**
  @internal
  */
  static create(e, n, r, a, i, o) {
    return new No(e, n, r, a, i, o);
  }
  /**
  The new document produced by the transaction. Contrary to
  [`.state`](https://codemirror.net/6/docs/ref/#state.Transaction.state)`.doc`, accessing this won't
  force the entire new state to be computed right away, so it is
  recommended that [transaction
  filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) use this getter
  when they need to look at the new document.
  */
  get newDoc() {
    return this._doc || (this._doc = this.changes.apply(this.startState.doc));
  }
  /**
  The new selection produced by the transaction. If
  [`this.selection`](https://codemirror.net/6/docs/ref/#state.Transaction.selection) is undefined,
  this will [map](https://codemirror.net/6/docs/ref/#state.EditorSelection.map) the start state's
  current selection through the changes made by the transaction.
  */
  get newSelection() {
    return this.selection || this.startState.selection.map(this.changes);
  }
  /**
  The new state created by the transaction. Computed on demand
  (but retained for subsequent access), so it is recommended not to
  access it in [transaction
  filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) when possible.
  */
  get state() {
    return this._state || this.startState.applyTransaction(this), this._state;
  }
  /**
  Get the value of the given annotation type, if any.
  */
  annotation(e) {
    for (let n of this.annotations)
      if (n.type == e)
        return n.value;
  }
  /**
  Indicates whether the transaction changed the document.
  */
  get docChanged() {
    return !this.changes.empty;
  }
  /**
  Indicates whether this transaction reconfigures the state
  (through a [configuration compartment](https://codemirror.net/6/docs/ref/#state.Compartment) or
  with a top-level configuration
  [effect](https://codemirror.net/6/docs/ref/#state.StateEffect^reconfigure).
  */
  get reconfigured() {
    return this.startState.config != this.state.config;
  }
  /**
  Returns true if the transaction has a [user
  event](https://codemirror.net/6/docs/ref/#state.Transaction^userEvent) annotation that is equal to
  or more specific than `event`. For example, if the transaction
  has `"select.pointer"` as user event, `"select"` and
  `"select.pointer"` will match it.
  */
  isUserEvent(e) {
    let n = this.annotation(No.userEvent);
    return !!(n && (n == e || n.length > e.length && n.slice(0, e.length) == e && n[e.length] == "."));
  }
}
No.time = /* @__PURE__ */ Ih.define();
No.userEvent = /* @__PURE__ */ Ih.define();
No.addToHistory = /* @__PURE__ */ Ih.define();
No.remote = /* @__PURE__ */ Ih.define();
function YDe(t, e) {
  let n = [];
  for (let r = 0, a = 0; ; ) {
    let i, o;
    if (r < t.length && (a == e.length || e[a] >= t[r]))
      i = t[r++], o = t[r++];
    else if (a < e.length)
      i = e[a++], o = e[a++];
    else
      return n;
    !n.length || n[n.length - 1] < i ? n.push(i, o) : n[n.length - 1] < o && (n[n.length - 1] = o);
  }
}
function _ae(t, e, n) {
  var r;
  let a, i, o;
  return n ? (a = e.changes, i = Ko.empty(e.changes.length), o = t.changes.compose(e.changes)) : (a = e.changes.map(t.changes), i = t.changes.mapDesc(e.changes, !0), o = t.changes.compose(a)), {
    changes: o,
    selection: e.selection ? e.selection.map(i) : (r = t.selection) === null || r === void 0 ? void 0 : r.map(a),
    effects: fr.mapEffects(t.effects, a).concat(fr.mapEffects(e.effects, i)),
    annotations: t.annotations.length ? t.annotations.concat(e.annotations) : e.annotations,
    scrollIntoView: t.scrollIntoView || e.scrollIntoView
  };
}
function n4(t, e, n) {
  let r = e.selection, a = xE(e.annotations);
  return e.userEvent && (a = a.concat(No.userEvent.of(e.userEvent))), {
    changes: e.changes instanceof Ko ? e.changes : Ko.of(e.changes || [], n, t.facet(Oae)),
    selection: r && (r instanceof ft ? r : ft.single(r.anchor, r.head)),
    effects: xE(e.effects),
    annotations: a,
    scrollIntoView: !!e.scrollIntoView
  };
}
function Cae(t, e, n) {
  let r = n4(t, e.length ? e[0] : {}, t.doc.length);
  e.length && e[0].filter === !1 && (n = !1);
  for (let i = 1; i < e.length; i++) {
    e[i].filter === !1 && (n = !1);
    let o = !!e[i].sequential;
    r = _ae(r, n4(t, e[i], o ? r.changes.newLength : t.doc.length), o);
  }
  let a = No.create(t, r.changes, r.selection, r.effects, r.annotations, r.scrollIntoView);
  return XDe(n ? ZDe(a) : a);
}
function ZDe(t) {
  let e = t.startState, n = !0;
  for (let a of e.facet(Eae)) {
    let i = a(t);
    if (i === !1) {
      n = !1;
      break;
    }
    Array.isArray(i) && (n = n === !0 ? i : YDe(n, i));
  }
  if (n !== !0) {
    let a, i;
    if (n === !1)
      i = t.changes.invertedDesc, a = Ko.empty(e.doc.length);
    else {
      let o = t.changes.filter(n);
      a = o.changes, i = o.filtered.mapDesc(o.changes).invertedDesc;
    }
    t = No.create(e, a, t.selection && t.selection.map(i), fr.mapEffects(t.effects, i), t.annotations, t.scrollIntoView);
  }
  let r = e.facet(Sae);
  for (let a = r.length - 1; a >= 0; a--) {
    let i = r[a](t);
    i instanceof No ? t = i : Array.isArray(i) && i.length == 1 && i[0] instanceof No ? t = i[0] : t = Cae(e, xE(i), !1);
  }
  return t;
}
function XDe(t) {
  let e = t.startState, n = e.facet(wae), r = t;
  for (let a = n.length - 1; a >= 0; a--) {
    let i = n[a](t);
    i && Object.keys(i).length && (r = _ae(r, n4(e, i, t.changes.newLength), !0));
  }
  return r == t ? t : No.create(e, t.changes, t.selection, r.effects, r.annotations, r.scrollIntoView);
}
const qDe = [];
function xE(t) {
  return t == null ? qDe : Array.isArray(t) ? t : [t];
}
var Si = /* @__PURE__ */ function(t) {
  return t[t.Word = 0] = "Word", t[t.Space = 1] = "Space", t[t.Other = 2] = "Other", t;
}(Si || (Si = {}));
const KDe = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
let r4;
try {
  r4 = /* @__PURE__ */ new RegExp("[\\p{Alphabetic}\\p{Number}_]", "u");
} catch {
}
function JDe(t) {
  if (r4)
    return r4.test(t);
  for (let e = 0; e < t.length; e++) {
    let n = t[e];
    if (/\w/.test(n) || n > "" && (n.toUpperCase() != n.toLowerCase() || KDe.test(n)))
      return !0;
  }
  return !1;
}
function eNe(t) {
  return (e) => {
    if (!/\S/.test(e))
      return Si.Space;
    if (JDe(e))
      return Si.Word;
    for (let n = 0; n < t.length; n++)
      if (e.indexOf(t[n]) > -1)
        return Si.Word;
    return Si.Other;
  };
}
class zr {
  constructor(e, n, r, a, i, o) {
    this.config = e, this.doc = n, this.selection = r, this.values = a, this.status = e.statusTemplate.slice(), this.computeSlot = i, o && (o._state = this);
    for (let s = 0; s < this.config.dynamicSlots.length; s++)
      oT(this, s << 1);
    this.computeSlot = null;
  }
  field(e, n = !0) {
    let r = this.config.address[e.id];
    if (r == null) {
      if (n)
        throw new RangeError("Field is not present in this state");
      return;
    }
    return oT(this, r), nI(this, r);
  }
  /**
  Create a [transaction](https://codemirror.net/6/docs/ref/#state.Transaction) that updates this
  state. Any number of [transaction specs](https://codemirror.net/6/docs/ref/#state.TransactionSpec)
  can be passed. Unless
  [`sequential`](https://codemirror.net/6/docs/ref/#state.TransactionSpec.sequential) is set, the
  [changes](https://codemirror.net/6/docs/ref/#state.TransactionSpec.changes) (if any) of each spec
  are assumed to start in the _current_ document (not the document
  produced by previous specs), and its
  [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection) and
  [effects](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) are assumed to refer
  to the document created by its _own_ changes. The resulting
  transaction contains the combined effect of all the different
  specs. For [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection), later
  specs take precedence over earlier ones.
  */
  update(...e) {
    return Cae(this, e, !0);
  }
  /**
  @internal
  */
  applyTransaction(e) {
    let n = this.config, { base: r, compartments: a } = n;
    for (let s of e.effects)
      s.is(mD.reconfigure) ? (n && (a = /* @__PURE__ */ new Map(), n.compartments.forEach((u, f) => a.set(f, u)), n = null), a.set(s.value.compartment, s.value.extension)) : s.is(fr.reconfigure) ? (n = null, r = s.value) : s.is(fr.appendConfig) && (n = null, r = xE(r).concat(s.value));
    let i;
    n ? i = e.startState.values.slice() : (n = tI.resolve(r, a, this), i = new zr(n, this.doc, this.selection, n.dynamicSlots.map(() => null), (u, f) => f.reconfigure(u, this), null).values);
    let o = e.startState.facet(t4) ? e.newSelection : e.newSelection.asSingle();
    new zr(n, e.newDoc, o, i, (s, u) => u.update(s, e), e);
  }
  /**
  Create a [transaction spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec) that
  replaces every selection range with the given content.
  */
  replaceSelection(e) {
    return typeof e == "string" && (e = this.toText(e)), this.changeByRange((n) => ({
      changes: { from: n.from, to: n.to, insert: e },
      range: ft.cursor(n.from + e.length)
    }));
  }
  /**
  Create a set of changes and a new selection by running the given
  function for each range in the active selection. The function
  can return an optional set of changes (in the coordinate space
  of the start document), plus an updated range (in the coordinate
  space of the document produced by the call's own changes). This
  method will merge all the changes and ranges into a single
  changeset and selection, and return it as a [transaction
  spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec), which can be passed to
  [`update`](https://codemirror.net/6/docs/ref/#state.EditorState.update).
  */
  changeByRange(e) {
    let n = this.selection, r = e(n.ranges[0]), a = this.changes(r.changes), i = [r.range], o = xE(r.effects);
    for (let s = 1; s < n.ranges.length; s++) {
      let u = e(n.ranges[s]), f = this.changes(u.changes), p = f.map(a);
      for (let v = 0; v < s; v++)
        i[v] = i[v].map(p);
      let m = a.mapDesc(f, !0);
      i.push(u.range.map(m)), a = a.compose(p), o = fr.mapEffects(o, p).concat(fr.mapEffects(xE(u.effects), m));
    }
    return {
      changes: a,
      selection: ft.create(i, n.mainIndex),
      effects: o
    };
  }
  /**
  Create a [change set](https://codemirror.net/6/docs/ref/#state.ChangeSet) from the given change
  description, taking the state's document length and line
  separator into account.
  */
  changes(e = []) {
    return e instanceof Ko ? e : Ko.of(e, this.doc.length, this.facet(zr.lineSeparator));
  }
  /**
  Using the state's [line
  separator](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator), create a
  [`Text`](https://codemirror.net/6/docs/ref/#state.Text) instance from the given string.
  */
  toText(e) {
    return la.of(e.split(this.facet(zr.lineSeparator) || XB));
  }
  /**
  Return the given range of the document as a string.
  */
  sliceDoc(e = 0, n = this.doc.length) {
    return this.doc.sliceString(e, n, this.lineBreak);
  }
  /**
  Get the value of a state [facet](https://codemirror.net/6/docs/ref/#state.Facet).
  */
  facet(e) {
    let n = this.config.address[e.id];
    return n == null ? e.default : (oT(this, n), nI(this, n));
  }
  /**
  Convert this state to a JSON-serializable object. When custom
  fields should be serialized, you can pass them in as an object
  mapping property names (in the resulting object, which should
  not use `doc` or `selection`) to fields.
  */
  toJSON(e) {
    let n = {
      doc: this.sliceDoc(),
      selection: this.selection.toJSON()
    };
    if (e)
      for (let r in e) {
        let a = e[r];
        a instanceof Ss && this.config.address[a.id] != null && (n[r] = a.spec.toJSON(this.field(e[r]), this));
      }
    return n;
  }
  /**
  Deserialize a state from its JSON representation. When custom
  fields should be deserialized, pass the same object you passed
  to [`toJSON`](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) when serializing as
  third argument.
  */
  static fromJSON(e, n = {}, r) {
    if (!e || typeof e.doc != "string")
      throw new RangeError("Invalid JSON representation for EditorState");
    let a = [];
    if (r) {
      for (let i in r)
        if (Object.prototype.hasOwnProperty.call(e, i)) {
          let o = r[i], s = e[i];
          a.push(o.init((u) => o.spec.fromJSON(s, u)));
        }
    }
    return zr.create({
      doc: e.doc,
      selection: ft.fromJSON(e.selection),
      extensions: n.extensions ? a.concat([n.extensions]) : a
    });
  }
  /**
  Create a new state. You'll usually only need this when
  initializing an editor—updated states are created by applying
  transactions.
  */
  static create(e = {}) {
    let n = tI.resolve(e.extensions || [], /* @__PURE__ */ new Map()), r = e.doc instanceof la ? e.doc : la.of((e.doc || "").split(n.staticFacet(zr.lineSeparator) || XB)), a = e.selection ? e.selection instanceof ft ? e.selection : ft.single(e.selection.anchor, e.selection.head) : ft.single(0);
    return bae(a, r.length), n.staticFacet(t4) || (a = a.asSingle()), new zr(n, r, a, n.dynamicSlots.map(() => null), (i, o) => o.create(i), null);
  }
  /**
  The size (in columns) of a tab in the document, determined by
  the [`tabSize`](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize) facet.
  */
  get tabSize() {
    return this.facet(zr.tabSize);
  }
  /**
  Get the proper [line-break](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator)
  string for this state.
  */
  get lineBreak() {
    return this.facet(zr.lineSeparator) || `
`;
  }
  /**
  Returns true when the editor is
  [configured](https://codemirror.net/6/docs/ref/#state.EditorState^readOnly) to be read-only.
  */
  get readOnly() {
    return this.facet(Tae);
  }
  /**
  Look up a translation for the given phrase (via the
  [`phrases`](https://codemirror.net/6/docs/ref/#state.EditorState^phrases) facet), or return the
  original string if no translation is found.
  
  If additional arguments are passed, they will be inserted in
  place of markers like `$1` (for the first value) and `$2`, etc.
  A single `$` is equivalent to `$1`, and `$$` will produce a
  literal dollar sign.
  */
  phrase(e, ...n) {
    for (let r of this.facet(zr.phrases))
      if (Object.prototype.hasOwnProperty.call(r, e)) {
        e = r[e];
        break;
      }
    return n.length && (e = e.replace(/\$(\$|\d*)/g, (r, a) => {
      if (a == "$")
        return "$";
      let i = +(a || 1);
      return !i || i > n.length ? r : n[i - 1];
    })), e;
  }
  /**
  Find the values for a given language data field, provided by the
  the [`languageData`](https://codemirror.net/6/docs/ref/#state.EditorState^languageData) facet.
  
  Examples of language data fields are...
  
  - [`"commentTokens"`](https://codemirror.net/6/docs/ref/#commands.CommentTokens) for specifying
    comment syntax.
  - [`"autocomplete"`](https://codemirror.net/6/docs/ref/#autocomplete.autocompletion^config.override)
    for providing language-specific completion sources.
  - [`"wordChars"`](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) for adding
    characters that should be considered part of words in this
    language.
  - [`"closeBrackets"`](https://codemirror.net/6/docs/ref/#autocomplete.CloseBracketConfig) controls
    bracket closing behavior.
  */
  languageDataAt(e, n, r = -1) {
    let a = [];
    for (let i of this.facet(yae))
      for (let o of i(this, n, r))
        Object.prototype.hasOwnProperty.call(o, e) && a.push(o[e]);
    return a;
  }
  /**
  Return a function that can categorize strings (expected to
  represent a single [grapheme cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak))
  into one of:
  
   - Word (contains an alphanumeric character or a character
     explicitly listed in the local language's `"wordChars"`
     language data, which should be a string)
   - Space (contains only whitespace)
   - Other (anything else)
  */
  charCategorizer(e) {
    return eNe(this.languageDataAt("wordChars", e).join(""));
  }
  /**
  Find the word at the given position, meaning the range
  containing all [word](https://codemirror.net/6/docs/ref/#state.CharCategory.Word) characters
  around it. If no word characters are adjacent to the position,
  this returns null.
  */
  wordAt(e) {
    let { text: n, from: r, length: a } = this.doc.lineAt(e), i = this.charCategorizer(e), o = e - r, s = e - r;
    for (; o > 0; ) {
      let u = nl(n, o, !1);
      if (i(n.slice(u, o)) != Si.Word)
        break;
      o = u;
    }
    for (; s < a; ) {
      let u = nl(n, s);
      if (i(n.slice(s, u)) != Si.Word)
        break;
      s = u;
    }
    return o == s ? null : ft.range(o + r, s + r);
  }
}
zr.allowMultipleSelections = t4;
zr.tabSize = /* @__PURE__ */ bn.define({
  combine: (t) => t.length ? t[0] : 4
});
zr.lineSeparator = Oae;
zr.readOnly = Tae;
zr.phrases = /* @__PURE__ */ bn.define({
  compare(t, e) {
    let n = Object.keys(t), r = Object.keys(e);
    return n.length == r.length && n.every((a) => t[a] == e[a]);
  }
});
zr.languageData = yae;
zr.changeFilter = Eae;
zr.transactionFilter = Sae;
zr.transactionExtender = wae;
mD.reconfigure = /* @__PURE__ */ fr.define();
function Dh(t, e, n = {}) {
  let r = {};
  for (let a of t)
    for (let i of Object.keys(a)) {
      let o = a[i], s = r[i];
      if (s === void 0)
        r[i] = o;
      else if (!(s === o || o === void 0))
        if (Object.hasOwnProperty.call(n, i))
          r[i] = n[i](s, o);
        else
          throw new Error("Config merge conflict for field " + i);
    }
  for (let a in e)
    r[a] === void 0 && (r[a] = e[a]);
  return r;
}
class c0 {
  /**
  Compare this value with another value. Used when comparing
  rangesets. The default implementation compares by identity.
  Unless you are only creating a fixed number of unique instances
  of your value type, it is a good idea to implement this
  properly.
  */
  eq(e) {
    return this == e;
  }
  /**
  Create a [range](https://codemirror.net/6/docs/ref/#state.Range) with this value.
  */
  range(e, n = e) {
    return a4.create(e, n, this);
  }
}
c0.prototype.startSide = c0.prototype.endSide = 0;
c0.prototype.point = !1;
c0.prototype.mapMode = el.TrackDel;
let a4 = class xae {
  constructor(e, n, r) {
    this.from = e, this.to = n, this.value = r;
  }
  /**
  @internal
  */
  static create(e, n, r) {
    return new xae(e, n, r);
  }
};
function i4(t, e) {
  return t.from - e.from || t.value.startSide - e.value.startSide;
}
class UU {
  constructor(e, n, r, a) {
    this.from = e, this.to = n, this.value = r, this.maxPoint = a;
  }
  get length() {
    return this.to[this.to.length - 1];
  }
  // Find the index of the given position and side. Use the ranges'
  // `from` pos when `end == false`, `to` when `end == true`.
  findIndex(e, n, r, a = 0) {
    let i = r ? this.to : this.from;
    for (let o = a, s = i.length; ; ) {
      if (o == s)
        return o;
      let u = o + s >> 1, f = i[u] - e || (r ? this.value[u].endSide : this.value[u].startSide) - n;
      if (u == o)
        return f >= 0 ? o : s;
      f >= 0 ? s = u : o = u + 1;
    }
  }
  between(e, n, r, a) {
    for (let i = this.findIndex(n, -1e9, !0), o = this.findIndex(r, 1e9, !1, i); i < o; i++)
      if (a(this.from[i] + e, this.to[i] + e, this.value[i]) === !1)
        return !1;
  }
  map(e, n) {
    let r = [], a = [], i = [], o = -1, s = -1;
    for (let u = 0; u < this.value.length; u++) {
      let f = this.value[u], p = this.from[u] + e, m = this.to[u] + e, v, O;
      if (p == m) {
        let w = n.mapPos(p, f.startSide, f.mapMode);
        if (w == null || (v = O = w, f.startSide != f.endSide && (O = n.mapPos(p, f.endSide), O < v)))
          continue;
      } else if (v = n.mapPos(p, f.startSide), O = n.mapPos(m, f.endSide), v > O || v == O && f.startSide > 0 && f.endSide <= 0)
        continue;
      (O - v || f.endSide - f.startSide) < 0 || (o < 0 && (o = v), f.point && (s = Math.max(s, O - v)), r.push(f), a.push(v - o), i.push(O - o));
    }
    return { mapped: r.length ? new UU(a, i, r, s) : null, pos: o };
  }
}
class ta {
  constructor(e, n, r, a) {
    this.chunkPos = e, this.chunk = n, this.nextLayer = r, this.maxPoint = a;
  }
  /**
  @internal
  */
  static create(e, n, r, a) {
    return new ta(e, n, r, a);
  }
  /**
  @internal
  */
  get length() {
    let e = this.chunk.length - 1;
    return e < 0 ? 0 : Math.max(this.chunkEnd(e), this.nextLayer.length);
  }
  /**
  The number of ranges in the set.
  */
  get size() {
    if (this.isEmpty)
      return 0;
    let e = this.nextLayer.size;
    for (let n of this.chunk)
      e += n.value.length;
    return e;
  }
  /**
  @internal
  */
  chunkEnd(e) {
    return this.chunkPos[e] + this.chunk[e].length;
  }
  /**
  Update the range set, optionally adding new ranges or filtering
  out existing ones.
  
  (Note: The type parameter is just there as a kludge to work
  around TypeScript variance issues that prevented `RangeSet<X>`
  from being a subtype of `RangeSet<Y>` when `X` is a subtype of
  `Y`.)
  */
  update(e) {
    let { add: n = [], sort: r = !1, filterFrom: a = 0, filterTo: i = this.length } = e, o = e.filter;
    if (n.length == 0 && !o)
      return this;
    if (r && (n = n.slice().sort(i4)), this.isEmpty)
      return n.length ? ta.of(n) : this;
    let s = new Aae(this, null, -1).goto(0), u = 0, f = [], p = new Jb();
    for (; s.value || u < n.length; )
      if (u < n.length && (s.from - n[u].from || s.startSide - n[u].value.startSide) >= 0) {
        let m = n[u++];
        p.addInner(m.from, m.to, m.value) || f.push(m);
      } else
        s.rangeIndex == 1 && s.chunkIndex < this.chunk.length && (u == n.length || this.chunkEnd(s.chunkIndex) < n[u].from) && (!o || a > this.chunkEnd(s.chunkIndex) || i < this.chunkPos[s.chunkIndex]) && p.addChunk(this.chunkPos[s.chunkIndex], this.chunk[s.chunkIndex]) ? s.nextChunk() : ((!o || a > s.to || i < s.from || o(s.from, s.to, s.value)) && (p.addInner(s.from, s.to, s.value) || f.push(a4.create(s.from, s.to, s.value))), s.next());
    return p.finishInner(this.nextLayer.isEmpty && !f.length ? ta.empty : this.nextLayer.update({ add: f, filter: o, filterFrom: a, filterTo: i }));
  }
  /**
  Map this range set through a set of changes, return the new set.
  */
  map(e) {
    if (e.empty || this.isEmpty)
      return this;
    let n = [], r = [], a = -1;
    for (let o = 0; o < this.chunk.length; o++) {
      let s = this.chunkPos[o], u = this.chunk[o], f = e.touchesRange(s, s + u.length);
      if (f === !1)
        a = Math.max(a, u.maxPoint), n.push(u), r.push(e.mapPos(s));
      else if (f === !0) {
        let { mapped: p, pos: m } = u.map(s, e);
        p && (a = Math.max(a, p.maxPoint), n.push(p), r.push(m));
      }
    }
    let i = this.nextLayer.map(e);
    return n.length == 0 ? i : new ta(r, n, i || ta.empty, a);
  }
  /**
  Iterate over the ranges that touch the region `from` to `to`,
  calling `f` for each. There is no guarantee that the ranges will
  be reported in any specific order. When the callback returns
  `false`, iteration stops.
  */
  between(e, n, r) {
    if (!this.isEmpty) {
      for (let a = 0; a < this.chunk.length; a++) {
        let i = this.chunkPos[a], o = this.chunk[a];
        if (n >= i && e <= i + o.length && o.between(i, e - i, n - i, r) === !1)
          return;
      }
      this.nextLayer.between(e, n, r);
    }
  }
  /**
  Iterate over the ranges in this set, in order, including all
  ranges that end at or after `from`.
  */
  iter(e = 0) {
    return BT.from([this]).goto(e);
  }
  /**
  @internal
  */
  get isEmpty() {
    return this.nextLayer == this;
  }
  /**
  Iterate over the ranges in a collection of sets, in order,
  starting from `from`.
  */
  static iter(e, n = 0) {
    return BT.from(e).goto(n);
  }
  /**
  Iterate over two groups of sets, calling methods on `comparator`
  to notify it of possible differences.
  */
  static compare(e, n, r, a, i = -1) {
    let o = e.filter((m) => m.maxPoint > 0 || !m.isEmpty && m.maxPoint >= i), s = n.filter((m) => m.maxPoint > 0 || !m.isEmpty && m.maxPoint >= i), u = hX(o, s, r), f = new yw(o, u, i), p = new yw(s, u, i);
    r.iterGaps((m, v, O) => mX(f, m, p, v, O, a)), r.empty && r.length == 0 && mX(f, 0, p, 0, 0, a);
  }
  /**
  Compare the contents of two groups of range sets, returning true
  if they are equivalent in the given range.
  */
  static eq(e, n, r = 0, a) {
    a == null && (a = 1e9 - 1);
    let i = e.filter((p) => !p.isEmpty && n.indexOf(p) < 0), o = n.filter((p) => !p.isEmpty && e.indexOf(p) < 0);
    if (i.length != o.length)
      return !1;
    if (!i.length)
      return !0;
    let s = hX(i, o), u = new yw(i, s, 0).goto(r), f = new yw(o, s, 0).goto(r);
    for (; ; ) {
      if (u.to != f.to || !o4(u.active, f.active) || u.point && (!f.point || !u.point.eq(f.point)))
        return !1;
      if (u.to > a)
        return !0;
      u.next(), f.next();
    }
  }
  /**
  Iterate over a group of range sets at the same time, notifying
  the iterator about the ranges covering every given piece of
  content. Returns the open count (see
  [`SpanIterator.span`](https://codemirror.net/6/docs/ref/#state.SpanIterator.span)) at the end
  of the iteration.
  */
  static spans(e, n, r, a, i = -1) {
    let o = new yw(e, null, i).goto(n), s = n, u = o.openStart;
    for (; ; ) {
      let f = Math.min(o.to, r);
      if (o.point) {
        let p = o.activeForPoint(o.to), m = o.pointFrom < n ? p.length + 1 : o.point.startSide < 0 ? p.length : Math.min(p.length, u);
        a.point(s, f, o.point, p, m, o.pointRank), u = Math.min(o.openEnd(f), p.length);
      } else
        f > s && (a.span(s, f, o.active, u), u = o.openEnd(f));
      if (o.to > r)
        return u + (o.point && o.to > r ? 1 : 0);
      s = o.to, o.next();
    }
  }
  /**
  Create a range set for the given range or array of ranges. By
  default, this expects the ranges to be _sorted_ (by start
  position and, if two start at the same position,
  `value.startSide`). You can pass `true` as second argument to
  cause the method to sort them.
  */
  static of(e, n = !1) {
    let r = new Jb();
    for (let a of e instanceof a4 ? [e] : n ? tNe(e) : e)
      r.add(a.from, a.to, a.value);
    return r.finish();
  }
  /**
  Join an array of range sets into a single set.
  */
  static join(e) {
    if (!e.length)
      return ta.empty;
    let n = e[e.length - 1];
    for (let r = e.length - 2; r >= 0; r--)
      for (let a = e[r]; a != ta.empty; a = a.nextLayer)
        n = new ta(a.chunkPos, a.chunk, n, Math.max(a.maxPoint, n.maxPoint));
    return n;
  }
}
ta.empty = /* @__PURE__ */ new ta([], [], null, -1);
function tNe(t) {
  if (t.length > 1)
    for (let e = t[0], n = 1; n < t.length; n++) {
      let r = t[n];
      if (i4(e, r) > 0)
        return t.slice().sort(i4);
      e = r;
    }
  return t;
}
ta.empty.nextLayer = ta.empty;
class Jb {
  finishChunk(e) {
    this.chunks.push(new UU(this.from, this.to, this.value, this.maxPoint)), this.chunkPos.push(this.chunkStart), this.chunkStart = -1, this.setMaxPoint = Math.max(this.setMaxPoint, this.maxPoint), this.maxPoint = -1, e && (this.from = [], this.to = [], this.value = []);
  }
  /**
  Create an empty builder.
  */
  constructor() {
    this.chunks = [], this.chunkPos = [], this.chunkStart = -1, this.last = null, this.lastFrom = -1e9, this.lastTo = -1e9, this.from = [], this.to = [], this.value = [], this.maxPoint = -1, this.setMaxPoint = -1, this.nextLayer = null;
  }
  /**
  Add a range. Ranges should be added in sorted (by `from` and
  `value.startSide`) order.
  */
  add(e, n, r) {
    this.addInner(e, n, r) || (this.nextLayer || (this.nextLayer = new Jb())).add(e, n, r);
  }
  /**
  @internal
  */
  addInner(e, n, r) {
    let a = e - this.lastTo || r.startSide - this.last.endSide;
    if (a <= 0 && (e - this.lastFrom || r.startSide - this.last.startSide) < 0)
      throw new Error("Ranges must be added sorted by `from` position and `startSide`");
    return a < 0 ? !1 : (this.from.length == 250 && this.finishChunk(!0), this.chunkStart < 0 && (this.chunkStart = e), this.from.push(e - this.chunkStart), this.to.push(n - this.chunkStart), this.last = r, this.lastFrom = e, this.lastTo = n, this.value.push(r), r.point && (this.maxPoint = Math.max(this.maxPoint, n - e)), !0);
  }
  /**
  @internal
  */
  addChunk(e, n) {
    if ((e - this.lastTo || n.value[0].startSide - this.last.endSide) < 0)
      return !1;
    this.from.length && this.finishChunk(!0), this.setMaxPoint = Math.max(this.setMaxPoint, n.maxPoint), this.chunks.push(n), this.chunkPos.push(e);
    let r = n.value.length - 1;
    return this.last = n.value[r], this.lastFrom = n.from[r] + e, this.lastTo = n.to[r] + e, !0;
  }
  /**
  Finish the range set. Returns the new set. The builder can't be
  used anymore after this has been called.
  */
  finish() {
    return this.finishInner(ta.empty);
  }
  /**
  @internal
  */
  finishInner(e) {
    if (this.from.length && this.finishChunk(!1), this.chunks.length == 0)
      return e;
    let n = ta.create(this.chunkPos, this.chunks, this.nextLayer ? this.nextLayer.finishInner(e) : e, this.setMaxPoint);
    return this.from = null, n;
  }
}
function hX(t, e, n) {
  let r = /* @__PURE__ */ new Map();
  for (let i of t)
    for (let o = 0; o < i.chunk.length; o++)
      i.chunk[o].maxPoint <= 0 && r.set(i.chunk[o], i.chunkPos[o]);
  let a = /* @__PURE__ */ new Set();
  for (let i of e)
    for (let o = 0; o < i.chunk.length; o++) {
      let s = r.get(i.chunk[o]);
      s != null && (n ? n.mapPos(s) : s) == i.chunkPos[o] && !(n != null && n.touchesRange(s, s + i.chunk[o].length)) && a.add(i.chunk[o]);
    }
  return a;
}
class Aae {
  constructor(e, n, r, a = 0) {
    this.layer = e, this.skip = n, this.minPoint = r, this.rank = a;
  }
  get startSide() {
    return this.value ? this.value.startSide : 0;
  }
  get endSide() {
    return this.value ? this.value.endSide : 0;
  }
  goto(e, n = -1e9) {
    return this.chunkIndex = this.rangeIndex = 0, this.gotoInner(e, n, !1), this;
  }
  gotoInner(e, n, r) {
    for (; this.chunkIndex < this.layer.chunk.length; ) {
      let a = this.layer.chunk[this.chunkIndex];
      if (!(this.skip && this.skip.has(a) || this.layer.chunkEnd(this.chunkIndex) < e || a.maxPoint < this.minPoint))
        break;
      this.chunkIndex++, r = !1;
    }
    if (this.chunkIndex < this.layer.chunk.length) {
      let a = this.layer.chunk[this.chunkIndex].findIndex(e - this.layer.chunkPos[this.chunkIndex], n, !0);
      (!r || this.rangeIndex < a) && this.setRangeIndex(a);
    }
    this.next();
  }
  forward(e, n) {
    (this.to - e || this.endSide - n) < 0 && this.gotoInner(e, n, !0);
  }
  next() {
    for (; ; )
      if (this.chunkIndex == this.layer.chunk.length) {
        this.from = this.to = 1e9, this.value = null;
        break;
      } else {
        let e = this.layer.chunkPos[this.chunkIndex], n = this.layer.chunk[this.chunkIndex], r = e + n.from[this.rangeIndex];
        if (this.from = r, this.to = e + n.to[this.rangeIndex], this.value = n.value[this.rangeIndex], this.setRangeIndex(this.rangeIndex + 1), this.minPoint < 0 || this.value.point && this.to - this.from >= this.minPoint)
          break;
      }
  }
  setRangeIndex(e) {
    if (e == this.layer.chunk[this.chunkIndex].value.length) {
      if (this.chunkIndex++, this.skip)
        for (; this.chunkIndex < this.layer.chunk.length && this.skip.has(this.layer.chunk[this.chunkIndex]); )
          this.chunkIndex++;
      this.rangeIndex = 0;
    } else
      this.rangeIndex = e;
  }
  nextChunk() {
    this.chunkIndex++, this.rangeIndex = 0, this.next();
  }
  compare(e) {
    return this.from - e.from || this.startSide - e.startSide || this.rank - e.rank || this.to - e.to || this.endSide - e.endSide;
  }
}
class BT {
  constructor(e) {
    this.heap = e;
  }
  static from(e, n = null, r = -1) {
    let a = [];
    for (let i = 0; i < e.length; i++)
      for (let o = e[i]; !o.isEmpty; o = o.nextLayer)
        o.maxPoint >= r && a.push(new Aae(o, n, r, i));
    return a.length == 1 ? a[0] : new BT(a);
  }
  get startSide() {
    return this.value ? this.value.startSide : 0;
  }
  goto(e, n = -1e9) {
    for (let r of this.heap)
      r.goto(e, n);
    for (let r = this.heap.length >> 1; r >= 0; r--)
      e3(this.heap, r);
    return this.next(), this;
  }
  forward(e, n) {
    for (let r of this.heap)
      r.forward(e, n);
    for (let r = this.heap.length >> 1; r >= 0; r--)
      e3(this.heap, r);
    (this.to - e || this.value.endSide - n) < 0 && this.next();
  }
  next() {
    if (this.heap.length == 0)
      this.from = this.to = 1e9, this.value = null, this.rank = -1;
    else {
      let e = this.heap[0];
      this.from = e.from, this.to = e.to, this.value = e.value, this.rank = e.rank, e.value && e.next(), e3(this.heap, 0);
    }
  }
}
function e3(t, e) {
  for (let n = t[e]; ; ) {
    let r = (e << 1) + 1;
    if (r >= t.length)
      break;
    let a = t[r];
    if (r + 1 < t.length && a.compare(t[r + 1]) >= 0 && (a = t[r + 1], r++), n.compare(a) < 0)
      break;
    t[r] = n, t[e] = a, e = r;
  }
}
class yw {
  constructor(e, n, r) {
    this.minPoint = r, this.active = [], this.activeTo = [], this.activeRank = [], this.minActive = -1, this.point = null, this.pointFrom = 0, this.pointRank = 0, this.to = -1e9, this.endSide = 0, this.openStart = -1, this.cursor = BT.from(e, n, r);
  }
  goto(e, n = -1e9) {
    return this.cursor.goto(e, n), this.active.length = this.activeTo.length = this.activeRank.length = 0, this.minActive = -1, this.to = e, this.endSide = n, this.openStart = -1, this.next(), this;
  }
  forward(e, n) {
    for (; this.minActive > -1 && (this.activeTo[this.minActive] - e || this.active[this.minActive].endSide - n) < 0; )
      this.removeActive(this.minActive);
    this.cursor.forward(e, n);
  }
  removeActive(e) {
    $x(this.active, e), $x(this.activeTo, e), $x(this.activeRank, e), this.minActive = gX(this.active, this.activeTo);
  }
  addActive(e) {
    let n = 0, { value: r, to: a, rank: i } = this.cursor;
    for (; n < this.activeRank.length && (i - this.activeRank[n] || a - this.activeTo[n]) > 0; )
      n++;
    Bx(this.active, n, r), Bx(this.activeTo, n, a), Bx(this.activeRank, n, i), e && Bx(e, n, this.cursor.from), this.minActive = gX(this.active, this.activeTo);
  }
  // After calling this, if `this.point` != null, the next range is a
  // point. Otherwise, it's a regular range, covered by `this.active`.
  next() {
    let e = this.to, n = this.point;
    this.point = null;
    let r = this.openStart < 0 ? [] : null;
    for (; ; ) {
      let a = this.minActive;
      if (a > -1 && (this.activeTo[a] - this.cursor.from || this.active[a].endSide - this.cursor.startSide) < 0) {
        if (this.activeTo[a] > e) {
          this.to = this.activeTo[a], this.endSide = this.active[a].endSide;
          break;
        }
        this.removeActive(a), r && $x(r, a);
      } else if (this.cursor.value)
        if (this.cursor.from > e) {
          this.to = this.cursor.from, this.endSide = this.cursor.startSide;
          break;
        } else {
          let i = this.cursor.value;
          if (!i.point)
            this.addActive(r), this.cursor.next();
          else if (n && this.cursor.to == this.to && this.cursor.from < this.cursor.to)
            this.cursor.next();
          else {
            this.point = i, this.pointFrom = this.cursor.from, this.pointRank = this.cursor.rank, this.to = this.cursor.to, this.endSide = i.endSide, this.cursor.next(), this.forward(this.to, this.endSide);
            break;
          }
        }
      else {
        this.to = this.endSide = 1e9;
        break;
      }
    }
    if (r) {
      this.openStart = 0;
      for (let a = r.length - 1; a >= 0 && r[a] < e; a--)
        this.openStart++;
    }
  }
  activeForPoint(e) {
    if (!this.active.length)
      return this.active;
    let n = [];
    for (let r = this.active.length - 1; r >= 0 && !(this.activeRank[r] < this.pointRank); r--)
      (this.activeTo[r] > e || this.activeTo[r] == e && this.active[r].endSide >= this.point.endSide) && n.push(this.active[r]);
    return n.reverse();
  }
  openEnd(e) {
    let n = 0;
    for (let r = this.activeTo.length - 1; r >= 0 && this.activeTo[r] > e; r--)
      n++;
    return n;
  }
}
function mX(t, e, n, r, a, i) {
  t.goto(e), n.goto(r);
  let o = r + a, s = r, u = r - e;
  for (; ; ) {
    let f = t.to + u - n.to || t.endSide - n.endSide, p = f < 0 ? t.to + u : n.to, m = Math.min(p, o);
    if (t.point || n.point ? t.point && n.point && (t.point == n.point || t.point.eq(n.point)) && o4(t.activeForPoint(t.to), n.activeForPoint(n.to)) || i.comparePoint(s, m, t.point, n.point) : m > s && !o4(t.active, n.active) && i.compareRange(s, m, t.active, n.active), p > o)
      break;
    s = p, f <= 0 && t.next(), f >= 0 && n.next();
  }
}
function o4(t, e) {
  if (t.length != e.length)
    return !1;
  for (let n = 0; n < t.length; n++)
    if (t[n] != e[n] && !t[n].eq(e[n]))
      return !1;
  return !0;
}
function $x(t, e) {
  for (let n = e, r = t.length - 1; n < r; n++)
    t[n] = t[n + 1];
  t.pop();
}
function Bx(t, e, n) {
  for (let r = t.length - 1; r >= e; r--)
    t[r + 1] = t[r];
  t[e] = n;
}
function gX(t, e) {
  let n = -1, r = 1e9;
  for (let a = 0; a < e.length; a++)
    (e[a] - r || t[a].endSide - t[n].endSide) < 0 && (n = a, r = e[a]);
  return n;
}
function Xd(t, e, n = t.length) {
  let r = 0;
  for (let a = 0; a < n; )
    t.charCodeAt(a) == 9 ? (r += e - r % e, a++) : (r++, a = nl(t, a));
  return r;
}
function s4(t, e, n, r) {
  for (let a = 0, i = 0; ; ) {
    if (i >= e)
      return a;
    if (a == t.length)
      break;
    i += t.charCodeAt(a) == 9 ? n - i % n : 1, a = nl(t, a);
  }
  return r === !0 ? -1 : t.length;
}
const l4 = "ͼ", bX = typeof Symbol > "u" ? "__" + l4 : Symbol.for(l4), u4 = typeof Symbol > "u" ? "__styleSet" + Math.floor(Math.random() * 1e8) : Symbol("styleSet"), vX = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : {};
class ev {
  // :: (Object<Style>, ?{finish: ?(string) → string})
  // Create a style module from the given spec.
  //
  // When `finish` is given, it is called on regular (non-`@`)
  // selectors (after `&` expansion) to compute the final selector.
  constructor(e, n) {
    this.rules = [];
    let { finish: r } = n || {};
    function a(o) {
      return /^@/.test(o) ? [o] : o.split(/,\s*/);
    }
    function i(o, s, u, f) {
      let p = [], m = /^@(\w+)\b/.exec(o[0]), v = m && m[1] == "keyframes";
      if (m && s == null)
        return u.push(o[0] + ";");
      for (let O in s) {
        let w = s[O];
        if (/&/.test(O))
          i(
            O.split(/,\s*/).map((_) => o.map((C) => _.replace(/&/, C))).reduce((_, C) => _.concat(C)),
            w,
            u
          );
        else if (w && typeof w == "object") {
          if (!m)
            throw new RangeError("The value of a property (" + O + ") should be a primitive value.");
          i(a(O), w, p, v);
        } else
          w != null && p.push(O.replace(/_.*/, "").replace(/[A-Z]/g, (_) => "-" + _.toLowerCase()) + ": " + w + ";");
      }
      (p.length || v) && u.push((r && !m && !f ? o.map(r) : o).join(", ") + " {" + p.join(" ") + "}");
    }
    for (let o in e)
      i(a(o), e[o], this.rules);
  }
  // :: () → string
  // Returns a string containing the module's CSS rules.
  getRules() {
    return this.rules.join(`
`);
  }
  // :: () → string
  // Generate a new unique CSS class name.
  static newName() {
    let e = vX[bX] || 1;
    return vX[bX] = e + 1, l4 + e.toString(36);
  }
  // :: (union<Document, ShadowRoot>, union<[StyleModule], StyleModule>, ?{nonce: ?string})
  //
  // Mount the given set of modules in the given DOM root, which ensures
  // that the CSS rules defined by the module are available in that
  // context.
  //
  // Rules are only added to the document once per root.
  //
  // Rule order will follow the order of the modules, so that rules from
  // modules later in the array take precedence of those from earlier
  // modules. If you call this function multiple times for the same root
  // in a way that changes the order of already mounted modules, the old
  // order will be changed.
  //
  // If a Content Security Policy nonce is provided, it is added to
  // the `<style>` tag generated by the library.
  static mount(e, n, r) {
    let a = e[u4], i = r && r.nonce;
    a ? i && a.setNonce(i) : a = new nNe(e, i), a.mount(Array.isArray(n) ? n : [n], e);
  }
}
let yX = /* @__PURE__ */ new Map();
class nNe {
  constructor(e, n) {
    let r = e.ownerDocument || e, a = r.defaultView;
    if (!e.head && e.adoptedStyleSheets && a.CSSStyleSheet) {
      let i = yX.get(r);
      if (i)
        return e[u4] = i;
      this.sheet = new a.CSSStyleSheet(), yX.set(r, this);
    } else
      this.styleTag = r.createElement("style"), n && this.styleTag.setAttribute("nonce", n);
    this.modules = [], e[u4] = this;
  }
  mount(e, n) {
    let r = this.sheet, a = 0, i = 0;
    for (let o = 0; o < e.length; o++) {
      let s = e[o], u = this.modules.indexOf(s);
      if (u < i && u > -1 && (this.modules.splice(u, 1), i--, u = -1), u == -1) {
        if (this.modules.splice(i++, 0, s), r)
          for (let f = 0; f < s.rules.length; f++)
            r.insertRule(s.rules[f], a++);
      } else {
        for (; i < u; )
          a += this.modules[i++].rules.length;
        a += s.rules.length, i++;
      }
    }
    if (r)
      n.adoptedStyleSheets.indexOf(this.sheet) < 0 && (n.adoptedStyleSheets = [this.sheet, ...n.adoptedStyleSheets]);
    else {
      let o = "";
      for (let u = 0; u < this.modules.length; u++)
        o += this.modules[u].getRules() + `
`;
      this.styleTag.textContent = o;
      let s = n.head || n;
      this.styleTag.parentNode != s && s.insertBefore(this.styleTag, s.firstChild);
    }
  }
  setNonce(e) {
    this.styleTag && this.styleTag.getAttribute("nonce") != e && this.styleTag.setAttribute("nonce", e);
  }
}
var tv = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, UT = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, rNe = typeof navigator < "u" && /Mac/.test(navigator.platform), aNe = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var Js = 0; Js < 10; Js++)
  tv[48 + Js] = tv[96 + Js] = String(Js);
for (var Js = 1; Js <= 24; Js++)
  tv[Js + 111] = "F" + Js;
for (var Js = 65; Js <= 90; Js++)
  tv[Js] = String.fromCharCode(Js + 32), UT[Js] = String.fromCharCode(Js);
for (var t3 in tv)
  UT.hasOwnProperty(t3) || (UT[t3] = tv[t3]);
function iNe(t) {
  var e = rNe && t.metaKey && t.shiftKey && !t.ctrlKey && !t.altKey || aNe && t.shiftKey && t.key && t.key.length == 1 || t.key == "Unidentified", n = !e && t.key || (t.shiftKey ? UT : tv)[t.keyCode] || t.key || "Unidentified";
  return n == "Esc" && (n = "Escape"), n == "Del" && (n = "Delete"), n == "Left" && (n = "ArrowLeft"), n == "Up" && (n = "ArrowUp"), n == "Right" && (n = "ArrowRight"), n == "Down" && (n = "ArrowDown"), n;
}
function rI(t) {
  let e;
  return t.nodeType == 11 ? e = t.getSelection ? t : t.ownerDocument : e = t, e.getSelection();
}
function c4(t, e) {
  return e ? t == e || t.contains(e.nodeType != 1 ? e.parentNode : e) : !1;
}
function oNe(t) {
  let e = t.activeElement;
  for (; e && e.shadowRoot; )
    e = e.shadowRoot.activeElement;
  return e;
}
function Sk(t, e) {
  if (!e.anchorNode)
    return !1;
  try {
    return c4(t, e.anchorNode);
  } catch {
    return !1;
  }
}
function QE(t) {
  return t.nodeType == 3 ? d0(t, 0, t.nodeValue.length).getClientRects() : t.nodeType == 1 ? t.getClientRects() : [];
}
function sT(t, e, n, r) {
  return n ? OX(t, e, n, r, -1) || OX(t, e, n, r, 1) : !1;
}
function f0(t) {
  for (var e = 0; ; e++)
    if (t = t.previousSibling, !t)
      return e;
}
function aI(t) {
  return t.nodeType == 1 && /^(DIV|P|LI|UL|OL|BLOCKQUOTE|DD|DT|H\d|SECTION|PRE)$/.test(t.nodeName);
}
function OX(t, e, n, r, a) {
  for (; ; ) {
    if (t == n && e == r)
      return !0;
    if (e == (a < 0 ? 0 : tg(t))) {
      if (t.nodeName == "DIV")
        return !1;
      let i = t.parentNode;
      if (!i || i.nodeType != 1)
        return !1;
      e = f0(t) + (a < 0 ? 0 : 1), t = i;
    } else if (t.nodeType == 1) {
      if (t = t.childNodes[e + (a < 0 ? -1 : 0)], t.nodeType == 1 && t.contentEditable == "false")
        return !1;
      e = a < 0 ? tg(t) : 0;
    } else
      return !1;
  }
}
function tg(t) {
  return t.nodeType == 3 ? t.nodeValue.length : t.childNodes.length;
}
function gD(t, e) {
  let n = e ? t.left : t.right;
  return { left: n, right: n, top: t.top, bottom: t.bottom };
}
function sNe(t) {
  let e = t.visualViewport;
  return e ? {
    left: 0,
    right: e.width,
    top: 0,
    bottom: e.height
  } : {
    left: 0,
    right: t.innerWidth,
    top: 0,
    bottom: t.innerHeight
  };
}
function kae(t, e) {
  let n = e.width / t.offsetWidth, r = e.height / t.offsetHeight;
  return (n > 0.995 && n < 1.005 || !isFinite(n) || Math.abs(e.width - t.offsetWidth) < 1) && (n = 1), (r > 0.995 && r < 1.005 || !isFinite(r) || Math.abs(e.height - t.offsetHeight) < 1) && (r = 1), { scaleX: n, scaleY: r };
}
function lNe(t, e, n, r, a, i, o, s) {
  let u = t.ownerDocument, f = u.defaultView || window;
  for (let p = t, m = !1; p && !m; )
    if (p.nodeType == 1) {
      let v, O = p == u.body, w = 1, _ = 1;
      if (O)
        v = sNe(f);
      else {
        if (/^(fixed|sticky)$/.test(getComputedStyle(p).position) && (m = !0), p.scrollHeight <= p.clientHeight && p.scrollWidth <= p.clientWidth) {
          p = p.assignedSlot || p.parentNode;
          continue;
        }
        let N = p.getBoundingClientRect();
        ({ scaleX: w, scaleY: _ } = kae(p, N)), v = {
          left: N.left,
          right: N.left + p.clientWidth * w,
          top: N.top,
          bottom: N.top + p.clientHeight * _
        };
      }
      let C = 0, A = 0;
      if (a == "nearest")
        e.top < v.top ? (A = -(v.top - e.top + o), n > 0 && e.bottom > v.bottom + A && (A = e.bottom - v.bottom + A + o)) : e.bottom > v.bottom && (A = e.bottom - v.bottom + o, n < 0 && e.top - A < v.top && (A = -(v.top + A - e.top + o)));
      else {
        let N = e.bottom - e.top, P = v.bottom - v.top;
        A = (a == "center" && N <= P ? e.top + N / 2 - P / 2 : a == "start" || a == "center" && n < 0 ? e.top - o : e.bottom - P + o) - v.top;
      }
      if (r == "nearest" ? e.left < v.left ? (C = -(v.left - e.left + i), n > 0 && e.right > v.right + C && (C = e.right - v.right + C + i)) : e.right > v.right && (C = e.right - v.right + i, n < 0 && e.left < v.left + C && (C = -(v.left + C - e.left + i))) : C = (r == "center" ? e.left + (e.right - e.left) / 2 - (v.right - v.left) / 2 : r == "start" == s ? e.left - i : e.right - (v.right - v.left) + i) - v.left, C || A)
        if (O)
          f.scrollBy(C, A);
        else {
          let N = 0, P = 0;
          if (A) {
            let I = p.scrollTop;
            p.scrollTop += A / _, P = (p.scrollTop - I) * _;
          }
          if (C) {
            let I = p.scrollLeft;
            p.scrollLeft += C / w, N = (p.scrollLeft - I) * w;
          }
          e = {
            left: e.left - N,
            top: e.top - P,
            right: e.right - N,
            bottom: e.bottom - P
          }, N && Math.abs(N - C) < 1 && (r = "nearest"), P && Math.abs(P - A) < 1 && (a = "nearest");
        }
      if (O)
        break;
      p = p.assignedSlot || p.parentNode;
    } else if (p.nodeType == 11)
      p = p.host;
    else
      break;
}
function uNe(t) {
  let e = t.ownerDocument;
  for (let n = t.parentNode; n && n != e.body; )
    if (n.nodeType == 1) {
      if (n.scrollHeight > n.clientHeight || n.scrollWidth > n.clientWidth)
        return n;
      n = n.assignedSlot || n.parentNode;
    } else if (n.nodeType == 11)
      n = n.host;
    else
      break;
  return null;
}
class cNe {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  eq(e) {
    return this.anchorNode == e.anchorNode && this.anchorOffset == e.anchorOffset && this.focusNode == e.focusNode && this.focusOffset == e.focusOffset;
  }
  setRange(e) {
    let { anchorNode: n, focusNode: r } = e;
    this.set(n, Math.min(e.anchorOffset, n ? tg(n) : 0), r, Math.min(e.focusOffset, r ? tg(r) : 0));
  }
  set(e, n, r, a) {
    this.anchorNode = e, this.anchorOffset = n, this.focusNode = r, this.focusOffset = a;
  }
}
let eE = null;
function Rae(t) {
  if (t.setActive)
    return t.setActive();
  if (eE)
    return t.focus(eE);
  let e = [];
  for (let n = t; n && (e.push(n, n.scrollTop, n.scrollLeft), n != n.ownerDocument); n = n.parentNode)
    ;
  if (t.focus(eE == null ? {
    get preventScroll() {
      return eE = { preventScroll: !0 }, !0;
    }
  } : void 0), !eE) {
    eE = !1;
    for (let n = 0; n < e.length; ) {
      let r = e[n++], a = e[n++], i = e[n++];
      r.scrollTop != a && (r.scrollTop = a), r.scrollLeft != i && (r.scrollLeft = i);
    }
  }
}
let EX;
function d0(t, e, n = e) {
  let r = EX || (EX = document.createRange());
  return r.setEnd(t, n), r.setStart(t, e), r;
}
function AE(t, e, n, r) {
  let a = { key: e, code: e, keyCode: n, which: n, cancelable: !0 };
  r && ({ altKey: a.altKey, ctrlKey: a.ctrlKey, shiftKey: a.shiftKey, metaKey: a.metaKey } = r);
  let i = new KeyboardEvent("keydown", a);
  i.synthetic = !0, t.dispatchEvent(i);
  let o = new KeyboardEvent("keyup", a);
  return o.synthetic = !0, t.dispatchEvent(o), i.defaultPrevented || o.defaultPrevented;
}
function fNe(t) {
  for (; t; ) {
    if (t && (t.nodeType == 9 || t.nodeType == 11 && t.host))
      return t;
    t = t.assignedSlot || t.parentNode;
  }
  return null;
}
function Iae(t) {
  for (; t.attributes.length; )
    t.removeAttributeNode(t.attributes[0]);
}
function dNe(t, e) {
  let n = e.focusNode, r = e.focusOffset;
  if (!n || e.anchorNode != n || e.anchorOffset != r)
    return !1;
  for (r = Math.min(r, tg(n)); ; )
    if (r) {
      if (n.nodeType != 1)
        return !1;
      let a = n.childNodes[r - 1];
      a.contentEditable == "false" ? r-- : (n = a, r = tg(n));
    } else {
      if (n == t)
        return !0;
      r = f0(n), n = n.parentNode;
    }
}
function Dae(t) {
  return t.scrollTop > Math.max(1, t.scrollHeight - t.clientHeight - 4);
}
function Nae(t, e) {
  for (let n = t, r = e; ; ) {
    if (n.nodeType == 3 && r > 0)
      return { node: n, offset: r };
    if (n.nodeType == 1 && r > 0) {
      if (n.contentEditable == "false")
        return null;
      n = n.childNodes[r - 1], r = tg(n);
    } else if (n.parentNode && !aI(n))
      r = f0(n), n = n.parentNode;
    else
      return null;
  }
}
function Pae(t, e) {
  for (let n = t, r = e; ; ) {
    if (n.nodeType == 3 && r < n.nodeValue.length)
      return { node: n, offset: r };
    if (n.nodeType == 1 && r < n.childNodes.length) {
      if (n.contentEditable == "false")
        return null;
      n = n.childNodes[r], r = 0;
    } else if (n.parentNode && !aI(n))
      r = f0(n) + 1, n = n.parentNode;
    else
      return null;
  }
}
class Rl {
  constructor(e, n, r = !0) {
    this.node = e, this.offset = n, this.precise = r;
  }
  static before(e, n) {
    return new Rl(e.parentNode, f0(e), n);
  }
  static after(e, n) {
    return new Rl(e.parentNode, f0(e) + 1, n);
  }
}
const zU = [];
class Va {
  constructor() {
    this.parent = null, this.dom = null, this.flags = 2;
  }
  get overrideDOMText() {
    return null;
  }
  get posAtStart() {
    return this.parent ? this.parent.posBefore(this) : 0;
  }
  get posAtEnd() {
    return this.posAtStart + this.length;
  }
  posBefore(e) {
    let n = this.posAtStart;
    for (let r of this.children) {
      if (r == e)
        return n;
      n += r.length + r.breakAfter;
    }
    throw new RangeError("Invalid child in posBefore");
  }
  posAfter(e) {
    return this.posBefore(e) + e.length;
  }
  sync(e, n) {
    if (this.flags & 2) {
      let r = this.dom, a = null, i;
      for (let o of this.children) {
        if (o.flags & 7) {
          if (!o.dom && (i = a ? a.nextSibling : r.firstChild)) {
            let s = Va.get(i);
            (!s || !s.parent && s.canReuseDOM(o)) && o.reuseDOM(i);
          }
          o.sync(e, n), o.flags &= -8;
        }
        if (i = a ? a.nextSibling : r.firstChild, n && !n.written && n.node == r && i != o.dom && (n.written = !0), o.dom.parentNode == r)
          for (; i && i != o.dom; )
            i = SX(i);
        else
          r.insertBefore(o.dom, i);
        a = o.dom;
      }
      for (i = a ? a.nextSibling : r.firstChild, i && n && n.node == r && (n.written = !0); i; )
        i = SX(i);
    } else if (this.flags & 1)
      for (let r of this.children)
        r.flags & 7 && (r.sync(e, n), r.flags &= -8);
  }
  reuseDOM(e) {
  }
  localPosFromDOM(e, n) {
    let r;
    if (e == this.dom)
      r = this.dom.childNodes[n];
    else {
      let a = tg(e) == 0 ? 0 : n == 0 ? -1 : 1;
      for (; ; ) {
        let i = e.parentNode;
        if (i == this.dom)
          break;
        a == 0 && i.firstChild != i.lastChild && (e == i.firstChild ? a = -1 : a = 1), e = i;
      }
      a < 0 ? r = e : r = e.nextSibling;
    }
    if (r == this.dom.firstChild)
      return 0;
    for (; r && !Va.get(r); )
      r = r.nextSibling;
    if (!r)
      return this.length;
    for (let a = 0, i = 0; ; a++) {
      let o = this.children[a];
      if (o.dom == r)
        return i;
      i += o.length + o.breakAfter;
    }
  }
  domBoundsAround(e, n, r = 0) {
    let a = -1, i = -1, o = -1, s = -1;
    for (let u = 0, f = r, p = r; u < this.children.length; u++) {
      let m = this.children[u], v = f + m.length;
      if (f < e && v > n)
        return m.domBoundsAround(e, n, f);
      if (v >= e && a == -1 && (a = u, i = f), f > n && m.dom.parentNode == this.dom) {
        o = u, s = p;
        break;
      }
      p = v, f = v + m.breakAfter;
    }
    return {
      from: i,
      to: s < 0 ? r + this.length : s,
      startDOM: (a ? this.children[a - 1].dom.nextSibling : null) || this.dom.firstChild,
      endDOM: o < this.children.length && o >= 0 ? this.children[o].dom : null
    };
  }
  markDirty(e = !1) {
    this.flags |= 2, this.markParentsDirty(e);
  }
  markParentsDirty(e) {
    for (let n = this.parent; n; n = n.parent) {
      if (e && (n.flags |= 2), n.flags & 1)
        return;
      n.flags |= 1, e = !1;
    }
  }
  setParent(e) {
    this.parent != e && (this.parent = e, this.flags & 7 && this.markParentsDirty(!0));
  }
  setDOM(e) {
    this.dom != e && (this.dom && (this.dom.cmView = null), this.dom = e, e.cmView = this);
  }
  get rootView() {
    for (let e = this; ; ) {
      let n = e.parent;
      if (!n)
        return e;
      e = n;
    }
  }
  replaceChildren(e, n, r = zU) {
    this.markDirty();
    for (let a = e; a < n; a++) {
      let i = this.children[a];
      i.parent == this && r.indexOf(i) < 0 && i.destroy();
    }
    this.children.splice(e, n - e, ...r);
    for (let a = 0; a < r.length; a++)
      r[a].setParent(this);
  }
  ignoreMutation(e) {
    return !1;
  }
  ignoreEvent(e) {
    return !1;
  }
  childCursor(e = this.length) {
    return new Lae(this.children, e, this.children.length);
  }
  childPos(e, n = 1) {
    return this.childCursor().findPos(e, n);
  }
  toString() {
    let e = this.constructor.name.replace("View", "");
    return e + (this.children.length ? "(" + this.children.join() + ")" : this.length ? "[" + (e == "Text" ? this.text : this.length) + "]" : "") + (this.breakAfter ? "#" : "");
  }
  static get(e) {
    return e.cmView;
  }
  get isEditable() {
    return !0;
  }
  get isWidget() {
    return !1;
  }
  get isHidden() {
    return !1;
  }
  merge(e, n, r, a, i, o) {
    return !1;
  }
  become(e) {
    return !1;
  }
  canReuseDOM(e) {
    return e.constructor == this.constructor && !((this.flags | e.flags) & 8);
  }
  // When this is a zero-length view with a side, this should return a
  // number <= 0 to indicate it is before its position, or a
  // number > 0 when after its position.
  getSide() {
    return 0;
  }
  destroy() {
    for (let e of this.children)
      e.parent == this && e.destroy();
    this.parent = null;
  }
}
Va.prototype.breakAfter = 0;
function SX(t) {
  let e = t.nextSibling;
  return t.parentNode.removeChild(t), e;
}
class Lae {
  constructor(e, n, r) {
    this.children = e, this.pos = n, this.i = r, this.off = 0;
  }
  findPos(e, n = 1) {
    for (; ; ) {
      if (e > this.pos || e == this.pos && (n > 0 || this.i == 0 || this.children[this.i - 1].breakAfter))
        return this.off = e - this.pos, this;
      let r = this.children[--this.i];
      this.pos -= r.length + r.breakAfter;
    }
  }
}
function Mae(t, e, n, r, a, i, o, s, u) {
  let { children: f } = t, p = f.length ? f[e] : null, m = i.length ? i[i.length - 1] : null, v = m ? m.breakAfter : o;
  if (!(e == r && p && !o && !v && i.length < 2 && p.merge(n, a, i.length ? m : null, n == 0, s, u))) {
    if (r < f.length) {
      let O = f[r];
      O && (a < O.length || O.breakAfter && (m != null && m.breakAfter)) ? (e == r && (O = O.split(a), a = 0), !v && m && O.merge(0, a, m, !0, 0, u) ? i[i.length - 1] = O : ((a || O.children.length && !O.children[0].length) && O.merge(0, a, null, !1, 0, u), i.push(O))) : O != null && O.breakAfter && (m ? m.breakAfter = 1 : o = 1), r++;
    }
    for (p && (p.breakAfter = o, n > 0 && (!o && i.length && p.merge(n, p.length, i[0], !1, s, 0) ? p.breakAfter = i.shift().breakAfter : (n < p.length || p.children.length && p.children[p.children.length - 1].length == 0) && p.merge(n, p.length, null, !1, s, 0), e++)); e < r && i.length; )
      if (f[r - 1].become(i[i.length - 1]))
        r--, i.pop(), u = i.length ? 0 : s;
      else if (f[e].become(i[0]))
        e++, i.shift(), s = i.length ? 0 : u;
      else
        break;
    !i.length && e && r < f.length && !f[e - 1].breakAfter && f[r].merge(0, 0, f[e - 1], !1, s, u) && e--, (e < r || i.length) && t.replaceChildren(e, r, i);
  }
}
function Fae(t, e, n, r, a, i) {
  let o = t.childCursor(), { i: s, off: u } = o.findPos(n, 1), { i: f, off: p } = o.findPos(e, -1), m = e - n;
  for (let v of r)
    m += v.length;
  t.length += m, Mae(t, f, p, s, u, r, 0, a, i);
}
let $c = typeof navigator < "u" ? navigator : { userAgent: "", vendor: "", platform: "" }, f4 = typeof document < "u" ? document : { documentElement: { style: {} } };
const d4 = /* @__PURE__ */ /Edge\/(\d+)/.exec($c.userAgent), $ae = /* @__PURE__ */ /MSIE \d/.test($c.userAgent), p4 = /* @__PURE__ */ /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec($c.userAgent), bD = !!($ae || p4 || d4), wX = !bD && /* @__PURE__ */ /gecko\/(\d+)/i.test($c.userAgent), n3 = !bD && /* @__PURE__ */ /Chrome\/(\d+)/.exec($c.userAgent), TX = "webkitFontSmoothing" in f4.documentElement.style, Bae = !bD && /* @__PURE__ */ /Apple Computer/.test($c.vendor), _X = Bae && (/* @__PURE__ */ /Mobile\/\w+/.test($c.userAgent) || $c.maxTouchPoints > 2);
var vn = {
  mac: _X || /* @__PURE__ */ /Mac/.test($c.platform),
  windows: /* @__PURE__ */ /Win/.test($c.platform),
  linux: /* @__PURE__ */ /Linux|X11/.test($c.platform),
  ie: bD,
  ie_version: $ae ? f4.documentMode || 6 : p4 ? +p4[1] : d4 ? +d4[1] : 0,
  gecko: wX,
  gecko_version: wX ? +(/* @__PURE__ */ /Firefox\/(\d+)/.exec($c.userAgent) || [0, 0])[1] : 0,
  chrome: !!n3,
  chrome_version: n3 ? +n3[1] : 0,
  ios: _X,
  android: /* @__PURE__ */ /Android\b/.test($c.userAgent),
  webkit: TX,
  safari: Bae,
  webkit_version: TX ? +(/* @__PURE__ */ /\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0,
  tabSize: f4.documentElement.style.tabSize != null ? "tab-size" : "-moz-tab-size"
};
const pNe = 256;
class qd extends Va {
  constructor(e) {
    super(), this.text = e;
  }
  get length() {
    return this.text.length;
  }
  createDOM(e) {
    this.setDOM(e || document.createTextNode(this.text));
  }
  sync(e, n) {
    this.dom || this.createDOM(), this.dom.nodeValue != this.text && (n && n.node == this.dom && (n.written = !0), this.dom.nodeValue = this.text);
  }
  reuseDOM(e) {
    e.nodeType == 3 && this.createDOM(e);
  }
  merge(e, n, r) {
    return this.flags & 8 || r && (!(r instanceof qd) || this.length - (n - e) + r.length > pNe || r.flags & 8) ? !1 : (this.text = this.text.slice(0, e) + (r ? r.text : "") + this.text.slice(n), this.markDirty(), !0);
  }
  split(e) {
    let n = new qd(this.text.slice(e));
    return this.text = this.text.slice(0, e), this.markDirty(), n.flags |= this.flags & 8, n;
  }
  localPosFromDOM(e, n) {
    return e == this.dom ? n : n ? this.text.length : 0;
  }
  domAtPos(e) {
    return new Rl(this.dom, e);
  }
  domBoundsAround(e, n, r) {
    return { from: r, to: r + this.length, startDOM: this.dom, endDOM: this.dom.nextSibling };
  }
  coordsAt(e, n) {
    return hNe(this.dom, e, n);
  }
}
class ng extends Va {
  constructor(e, n = [], r = 0) {
    super(), this.mark = e, this.children = n, this.length = r;
    for (let a of n)
      a.setParent(this);
  }
  setAttrs(e) {
    if (Iae(e), this.mark.class && (e.className = this.mark.class), this.mark.attrs)
      for (let n in this.mark.attrs)
        e.setAttribute(n, this.mark.attrs[n]);
    return e;
  }
  canReuseDOM(e) {
    return super.canReuseDOM(e) && !((this.flags | e.flags) & 8);
  }
  reuseDOM(e) {
    e.nodeName == this.mark.tagName.toUpperCase() && (this.setDOM(e), this.flags |= 6);
  }
  sync(e, n) {
    this.dom ? this.flags & 4 && this.setAttrs(this.dom) : this.setDOM(this.setAttrs(document.createElement(this.mark.tagName))), super.sync(e, n);
  }
  merge(e, n, r, a, i, o) {
    return r && (!(r instanceof ng && r.mark.eq(this.mark)) || e && i <= 0 || n < this.length && o <= 0) ? !1 : (Fae(this, e, n, r ? r.children.slice() : [], i - 1, o - 1), this.markDirty(), !0);
  }
  split(e) {
    let n = [], r = 0, a = -1, i = 0;
    for (let s of this.children) {
      let u = r + s.length;
      u > e && n.push(r < e ? s.split(e - r) : s), a < 0 && r >= e && (a = i), r = u, i++;
    }
    let o = this.length - e;
    return this.length = e, a > -1 && (this.children.length = a, this.markDirty()), new ng(this.mark, n, o);
  }
  domAtPos(e) {
    return Uae(this, e);
  }
  coordsAt(e, n) {
    return Hae(this, e, n);
  }
}
function hNe(t, e, n) {
  let r = t.nodeValue.length;
  e > r && (e = r);
  let a = e, i = e, o = 0;
  e == 0 && n < 0 || e == r && n >= 0 ? vn.chrome || vn.gecko || (e ? (a--, o = 1) : i < r && (i++, o = -1)) : n < 0 ? a-- : i < r && i++;
  let s = d0(t, a, i).getClientRects();
  if (!s.length)
    return null;
  let u = s[(o ? o < 0 : n >= 0) ? 0 : s.length - 1];
  return vn.safari && !o && u.width == 0 && (u = Array.prototype.find.call(s, (f) => f.width) || u), o ? gD(u, o < 0) : u || null;
}
class Qb extends Va {
  static create(e, n, r) {
    return new Qb(e, n, r);
  }
  constructor(e, n, r) {
    super(), this.widget = e, this.length = n, this.side = r, this.prevWidget = null;
  }
  split(e) {
    let n = Qb.create(this.widget, this.length - e, this.side);
    return this.length -= e, n;
  }
  sync(e) {
    (!this.dom || !this.widget.updateDOM(this.dom, e)) && (this.dom && this.prevWidget && this.prevWidget.destroy(this.dom), this.prevWidget = null, this.setDOM(this.widget.toDOM(e)), this.widget.editable || (this.dom.contentEditable = "false"));
  }
  getSide() {
    return this.side;
  }
  merge(e, n, r, a, i, o) {
    return r && (!(r instanceof Qb) || !this.widget.compare(r.widget) || e > 0 && i <= 0 || n < this.length && o <= 0) ? !1 : (this.length = e + (r ? r.length : 0) + (this.length - n), !0);
  }
  become(e) {
    return e instanceof Qb && e.side == this.side && this.widget.constructor == e.widget.constructor ? (this.widget.compare(e.widget) || this.markDirty(!0), this.dom && !this.prevWidget && (this.prevWidget = this.widget), this.widget = e.widget, this.length = e.length, !0) : !1;
  }
  ignoreMutation() {
    return !0;
  }
  ignoreEvent(e) {
    return this.widget.ignoreEvent(e);
  }
  get overrideDOMText() {
    if (this.length == 0)
      return la.empty;
    let e = this;
    for (; e.parent; )
      e = e.parent;
    let { view: n } = e, r = n && n.state.doc, a = this.posAtStart;
    return r ? r.slice(a, a + this.length) : la.empty;
  }
  domAtPos(e) {
    return (this.length ? e == 0 : this.side > 0) ? Rl.before(this.dom) : Rl.after(this.dom, e == this.length);
  }
  domBoundsAround() {
    return null;
  }
  coordsAt(e, n) {
    let r = this.widget.coordsAt(this.dom, e, n);
    if (r)
      return r;
    let a = this.dom.getClientRects(), i = null;
    if (!a.length)
      return null;
    let o = this.side ? this.side < 0 : e > 0;
    for (let s = o ? a.length - 1 : 0; i = a[s], !(e > 0 ? s == 0 : s == a.length - 1 || i.top < i.bottom); s += o ? -1 : 1)
      ;
    return gD(i, !o);
  }
  get isEditable() {
    return !1;
  }
  get isWidget() {
    return !0;
  }
  get isHidden() {
    return this.widget.isHidden;
  }
  destroy() {
    super.destroy(), this.dom && this.widget.destroy(this.dom);
  }
}
class jE extends Va {
  constructor(e) {
    super(), this.side = e;
  }
  get length() {
    return 0;
  }
  merge() {
    return !1;
  }
  become(e) {
    return e instanceof jE && e.side == this.side;
  }
  split() {
    return new jE(this.side);
  }
  sync() {
    if (!this.dom) {
      let e = document.createElement("img");
      e.className = "cm-widgetBuffer", e.setAttribute("aria-hidden", "true"), this.setDOM(e);
    }
  }
  getSide() {
    return this.side;
  }
  domAtPos(e) {
    return this.side > 0 ? Rl.before(this.dom) : Rl.after(this.dom);
  }
  localPosFromDOM() {
    return 0;
  }
  domBoundsAround() {
    return null;
  }
  coordsAt(e) {
    return this.dom.getBoundingClientRect();
  }
  get overrideDOMText() {
    return la.empty;
  }
  get isHidden() {
    return !0;
  }
}
qd.prototype.children = Qb.prototype.children = jE.prototype.children = zU;
function Uae(t, e) {
  let n = t.dom, { children: r } = t, a = 0;
  for (let i = 0; a < r.length; a++) {
    let o = r[a], s = i + o.length;
    if (!(s == i && o.getSide() <= 0)) {
      if (e > i && e < s && o.dom.parentNode == n)
        return o.domAtPos(e - i);
      if (e <= i)
        break;
      i = s;
    }
  }
  for (let i = a; i > 0; i--) {
    let o = r[i - 1];
    if (o.dom.parentNode == n)
      return o.domAtPos(o.length);
  }
  for (let i = a; i < r.length; i++) {
    let o = r[i];
    if (o.dom.parentNode == n)
      return o.domAtPos(0);
  }
  return new Rl(n, 0);
}
function zae(t, e, n) {
  let r, { children: a } = t;
  n > 0 && e instanceof ng && a.length && (r = a[a.length - 1]) instanceof ng && r.mark.eq(e.mark) ? zae(r, e.children[0], n - 1) : (a.push(e), e.setParent(t)), t.length += e.length;
}
function Hae(t, e, n) {
  let r = null, a = -1, i = null, o = -1;
  function s(f, p) {
    for (let m = 0, v = 0; m < f.children.length && v <= p; m++) {
      let O = f.children[m], w = v + O.length;
      w >= p && (O.children.length ? s(O, p - v) : (!i || i.isHidden && n > 0) && (w > p || v == w && O.getSide() > 0) ? (i = O, o = p - v) : (v < p || v == w && O.getSide() < 0 && !O.isHidden) && (r = O, a = p - v)), v = w;
    }
  }
  s(t, e);
  let u = (n < 0 ? r : i) || r || i;
  return u ? u.coordsAt(Math.max(0, u == r ? a : o), n) : mNe(t);
}
function mNe(t) {
  let e = t.dom.lastChild;
  if (!e)
    return t.dom.getBoundingClientRect();
  let n = QE(e);
  return n[n.length - 1] || null;
}
function h4(t, e) {
  for (let n in t)
    n == "class" && e.class ? e.class += " " + t.class : n == "style" && e.style ? e.style += ";" + t.style : e[n] = t[n];
  return e;
}
const CX = /* @__PURE__ */ Object.create(null);
function HU(t, e, n) {
  if (t == e)
    return !0;
  t || (t = CX), e || (e = CX);
  let r = Object.keys(t), a = Object.keys(e);
  if (r.length - (n && r.indexOf(n) > -1 ? 1 : 0) != a.length - (n && a.indexOf(n) > -1 ? 1 : 0))
    return !1;
  for (let i of r)
    if (i != n && (a.indexOf(i) == -1 || t[i] !== e[i]))
      return !1;
  return !0;
}
function m4(t, e, n) {
  let r = !1;
  if (e)
    for (let a in e)
      n && a in n || (r = !0, a == "style" ? t.style.cssText = "" : t.removeAttribute(a));
  if (n)
    for (let a in n)
      e && e[a] == n[a] || (r = !0, a == "style" ? t.style.cssText = n[a] : t.setAttribute(a, n[a]));
  return r;
}
function gNe(t) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let n = 0; n < t.attributes.length; n++) {
    let r = t.attributes[n];
    e[r.name] = r.value;
  }
  return e;
}
class qo extends Va {
  constructor() {
    super(...arguments), this.children = [], this.length = 0, this.prevAttrs = void 0, this.attrs = null, this.breakAfter = 0;
  }
  // Consumes source
  merge(e, n, r, a, i, o) {
    if (r) {
      if (!(r instanceof qo))
        return !1;
      this.dom || r.transferDOM(this);
    }
    return a && this.setDeco(r ? r.attrs : null), Fae(this, e, n, r ? r.children.slice() : [], i, o), !0;
  }
  split(e) {
    let n = new qo();
    if (n.breakAfter = this.breakAfter, this.length == 0)
      return n;
    let { i: r, off: a } = this.childPos(e);
    a && (n.append(this.children[r].split(a), 0), this.children[r].merge(a, this.children[r].length, null, !1, 0, 0), r++);
    for (let i = r; i < this.children.length; i++)
      n.append(this.children[i], 0);
    for (; r > 0 && this.children[r - 1].length == 0; )
      this.children[--r].destroy();
    return this.children.length = r, this.markDirty(), this.length = e, n;
  }
  transferDOM(e) {
    this.dom && (this.markDirty(), e.setDOM(this.dom), e.prevAttrs = this.prevAttrs === void 0 ? this.attrs : this.prevAttrs, this.prevAttrs = void 0, this.dom = null);
  }
  setDeco(e) {
    HU(this.attrs, e) || (this.dom && (this.prevAttrs = this.attrs, this.markDirty()), this.attrs = e);
  }
  append(e, n) {
    zae(this, e, n);
  }
  // Only called when building a line view in ContentBuilder
  addLineDeco(e) {
    let n = e.spec.attributes, r = e.spec.class;
    n && (this.attrs = h4(n, this.attrs || {})), r && (this.attrs = h4({ class: r }, this.attrs || {}));
  }
  domAtPos(e) {
    return Uae(this, e);
  }
  reuseDOM(e) {
    e.nodeName == "DIV" && (this.setDOM(e), this.flags |= 6);
  }
  sync(e, n) {
    var r;
    this.dom ? this.flags & 4 && (Iae(this.dom), this.dom.className = "cm-line", this.prevAttrs = this.attrs ? null : void 0) : (this.setDOM(document.createElement("div")), this.dom.className = "cm-line", this.prevAttrs = this.attrs ? null : void 0), this.prevAttrs !== void 0 && (m4(this.dom, this.prevAttrs, this.attrs), this.dom.classList.add("cm-line"), this.prevAttrs = void 0), super.sync(e, n);
    let a = this.dom.lastChild;
    for (; a && Va.get(a) instanceof ng; )
      a = a.lastChild;
    if (!a || !this.length || a.nodeName != "BR" && ((r = Va.get(a)) === null || r === void 0 ? void 0 : r.isEditable) == !1 && (!vn.ios || !this.children.some((i) => i instanceof qd))) {
      let i = document.createElement("BR");
      i.cmIgnore = !0, this.dom.appendChild(i);
    }
  }
  measureTextSize() {
    if (this.children.length == 0 || this.length > 20)
      return null;
    let e = 0, n;
    for (let r of this.children) {
      if (!(r instanceof qd) || /[^ -~]/.test(r.text))
        return null;
      let a = QE(r.dom);
      if (a.length != 1)
        return null;
      e += a[0].width, n = a[0].height;
    }
    return e ? {
      lineHeight: this.dom.getBoundingClientRect().height,
      charWidth: e / this.length,
      textHeight: n
    } : null;
  }
  coordsAt(e, n) {
    let r = Hae(this, e, n);
    if (!this.children.length && r && this.parent) {
      let { heightOracle: a } = this.parent.view.viewState, i = r.bottom - r.top;
      if (Math.abs(i - a.lineHeight) < 2 && a.textHeight < i) {
        let o = (i - a.textHeight) / 2;
        return { top: r.top + o, bottom: r.bottom - o, left: r.left, right: r.left };
      }
    }
    return r;
  }
  become(e) {
    return !1;
  }
  covers() {
    return !0;
  }
  static find(e, n) {
    for (let r = 0, a = 0; r < e.children.length; r++) {
      let i = e.children[r], o = a + i.length;
      if (o >= n) {
        if (i instanceof qo)
          return i;
        if (o > n)
          break;
      }
      a = o + i.breakAfter;
    }
    return null;
  }
}
class Vb extends Va {
  constructor(e, n, r) {
    super(), this.widget = e, this.length = n, this.deco = r, this.breakAfter = 0, this.prevWidget = null;
  }
  merge(e, n, r, a, i, o) {
    return r && (!(r instanceof Vb) || !this.widget.compare(r.widget) || e > 0 && i <= 0 || n < this.length && o <= 0) ? !1 : (this.length = e + (r ? r.length : 0) + (this.length - n), !0);
  }
  domAtPos(e) {
    return e == 0 ? Rl.before(this.dom) : Rl.after(this.dom, e == this.length);
  }
  split(e) {
    let n = this.length - e;
    this.length = e;
    let r = new Vb(this.widget, n, this.deco);
    return r.breakAfter = this.breakAfter, r;
  }
  get children() {
    return zU;
  }
  sync(e) {
    (!this.dom || !this.widget.updateDOM(this.dom, e)) && (this.dom && this.prevWidget && this.prevWidget.destroy(this.dom), this.prevWidget = null, this.setDOM(this.widget.toDOM(e)), this.widget.editable || (this.dom.contentEditable = "false"));
  }
  get overrideDOMText() {
    return this.parent ? this.parent.view.state.doc.slice(this.posAtStart, this.posAtEnd) : la.empty;
  }
  domBoundsAround() {
    return null;
  }
  become(e) {
    return e instanceof Vb && e.widget.constructor == this.widget.constructor ? (e.widget.compare(this.widget) || this.markDirty(!0), this.dom && !this.prevWidget && (this.prevWidget = this.widget), this.widget = e.widget, this.length = e.length, this.deco = e.deco, this.breakAfter = e.breakAfter, !0) : !1;
  }
  ignoreMutation() {
    return !0;
  }
  ignoreEvent(e) {
    return this.widget.ignoreEvent(e);
  }
  get isEditable() {
    return !1;
  }
  get isWidget() {
    return !0;
  }
  coordsAt(e, n) {
    return this.widget.coordsAt(this.dom, e, n);
  }
  destroy() {
    super.destroy(), this.dom && this.widget.destroy(this.dom);
  }
  covers(e) {
    let { startSide: n, endSide: r } = this.deco;
    return n == r ? !1 : e < 0 ? n < 0 : r > 0;
  }
}
class Nh {
  /**
  Compare this instance to another instance of the same type.
  (TypeScript can't express this, but only instances of the same
  specific class will be passed to this method.) This is used to
  avoid redrawing widgets when they are replaced by a new
  decoration of the same type. The default implementation just
  returns `false`, which will cause new instances of the widget to
  always be redrawn.
  */
  eq(e) {
    return !1;
  }
  /**
  Update a DOM element created by a widget of the same type (but
  different, non-`eq` content) to reflect this widget. May return
  true to indicate that it could update, false to indicate it
  couldn't (in which case the widget will be redrawn). The default
  implementation just returns false.
  */
  updateDOM(e, n) {
    return !1;
  }
  /**
  @internal
  */
  compare(e) {
    return this == e || this.constructor == e.constructor && this.eq(e);
  }
  /**
  The estimated height this widget will have, to be used when
  estimating the height of content that hasn't been drawn. May
  return -1 to indicate you don't know. The default implementation
  returns -1.
  */
  get estimatedHeight() {
    return -1;
  }
  /**
  For inline widgets that are displayed inline (as opposed to
  `inline-block`) and introduce line breaks (through `<br>` tags
  or textual newlines), this must indicate the amount of line
  breaks they introduce. Defaults to 0.
  */
  get lineBreaks() {
    return 0;
  }
  /**
  Can be used to configure which kinds of events inside the widget
  should be ignored by the editor. The default is to ignore all
  events.
  */
  ignoreEvent(e) {
    return !0;
  }
  /**
  Override the way screen coordinates for positions at/in the
  widget are found. `pos` will be the offset into the widget, and
  `side` the side of the position that is being queried—less than
  zero for before, greater than zero for after, and zero for
  directly at that position.
  */
  coordsAt(e, n, r) {
    return null;
  }
  /**
  @internal
  */
  get isHidden() {
    return !1;
  }
  /**
  @internal
  */
  get editable() {
    return !1;
  }
  /**
  This is called when the an instance of the widget is removed
  from the editor view.
  */
  destroy(e) {
  }
}
var du = /* @__PURE__ */ function(t) {
  return t[t.Text = 0] = "Text", t[t.WidgetBefore = 1] = "WidgetBefore", t[t.WidgetAfter = 2] = "WidgetAfter", t[t.WidgetRange = 3] = "WidgetRange", t;
}(du || (du = {}));
class Ln extends c0 {
  constructor(e, n, r, a) {
    super(), this.startSide = e, this.endSide = n, this.widget = r, this.spec = a;
  }
  /**
  @internal
  */
  get heightRelevant() {
    return !1;
  }
  /**
  Create a mark decoration, which influences the styling of the
  content in its range. Nested mark decorations will cause nested
  DOM elements to be created. Nesting order is determined by
  precedence of the [facet](https://codemirror.net/6/docs/ref/#view.EditorView^decorations), with
  the higher-precedence decorations creating the inner DOM nodes.
  Such elements are split on line boundaries and on the boundaries
  of lower-precedence decorations.
  */
  static mark(e) {
    return new y_(e);
  }
  /**
  Create a widget decoration, which displays a DOM element at the
  given position.
  */
  static widget(e) {
    let n = Math.max(-1e4, Math.min(1e4, e.side || 0)), r = !!e.block;
    return n += r && !e.inlineOrder ? n > 0 ? 3e8 : -4e8 : n > 0 ? 1e8 : -1e8, new nv(e, n, n, r, e.widget || null, !1);
  }
  /**
  Create a replace decoration which replaces the given range with
  a widget, or simply hides it.
  */
  static replace(e) {
    let n = !!e.block, r, a;
    if (e.isBlockGap)
      r = -5e8, a = 4e8;
    else {
      let { start: i, end: o } = Wae(e, n);
      r = (i ? n ? -3e8 : -1 : 5e8) - 1, a = (o ? n ? 2e8 : 1 : -6e8) + 1;
    }
    return new nv(e, r, a, n, e.widget || null, !0);
  }
  /**
  Create a line decoration, which can add DOM attributes to the
  line starting at the given position.
  */
  static line(e) {
    return new O_(e);
  }
  /**
  Build a [`DecorationSet`](https://codemirror.net/6/docs/ref/#view.DecorationSet) from the given
  decorated range or ranges. If the ranges aren't already sorted,
  pass `true` for `sort` to make the library sort them for you.
  */
  static set(e, n = !1) {
    return ta.of(e, n);
  }
  /**
  @internal
  */
  hasHeight() {
    return this.widget ? this.widget.estimatedHeight > -1 : !1;
  }
}
Ln.none = ta.empty;
class y_ extends Ln {
  constructor(e) {
    let { start: n, end: r } = Wae(e);
    super(n ? -1 : 5e8, r ? 1 : -6e8, null, e), this.tagName = e.tagName || "span", this.class = e.class || "", this.attrs = e.attributes || null;
  }
  eq(e) {
    var n, r;
    return this == e || e instanceof y_ && this.tagName == e.tagName && (this.class || ((n = this.attrs) === null || n === void 0 ? void 0 : n.class)) == (e.class || ((r = e.attrs) === null || r === void 0 ? void 0 : r.class)) && HU(this.attrs, e.attrs, "class");
  }
  range(e, n = e) {
    if (e >= n)
      throw new RangeError("Mark decorations may not be empty");
    return super.range(e, n);
  }
}
y_.prototype.point = !1;
class O_ extends Ln {
  constructor(e) {
    super(-2e8, -2e8, null, e);
  }
  eq(e) {
    return e instanceof O_ && this.spec.class == e.spec.class && HU(this.spec.attributes, e.spec.attributes);
  }
  range(e, n = e) {
    if (n != e)
      throw new RangeError("Line decoration ranges must be zero-length");
    return super.range(e, n);
  }
}
O_.prototype.mapMode = el.TrackBefore;
O_.prototype.point = !0;
class nv extends Ln {
  constructor(e, n, r, a, i, o) {
    super(n, r, i, e), this.block = a, this.isReplace = o, this.mapMode = a ? n <= 0 ? el.TrackBefore : el.TrackAfter : el.TrackDel;
  }
  // Only relevant when this.block == true
  get type() {
    return this.startSide != this.endSide ? du.WidgetRange : this.startSide <= 0 ? du.WidgetBefore : du.WidgetAfter;
  }
  get heightRelevant() {
    return this.block || !!this.widget && (this.widget.estimatedHeight >= 5 || this.widget.lineBreaks > 0);
  }
  eq(e) {
    return e instanceof nv && bNe(this.widget, e.widget) && this.block == e.block && this.startSide == e.startSide && this.endSide == e.endSide;
  }
  range(e, n = e) {
    if (this.isReplace && (e > n || e == n && this.startSide > 0 && this.endSide <= 0))
      throw new RangeError("Invalid range for replacement decoration");
    if (!this.isReplace && n != e)
      throw new RangeError("Widget decorations can only have zero-length ranges");
    return super.range(e, n);
  }
}
nv.prototype.point = !0;
function Wae(t, e = !1) {
  let { inclusiveStart: n, inclusiveEnd: r } = t;
  return n == null && (n = t.inclusive), r == null && (r = t.inclusive), { start: n ?? e, end: r ?? e };
}
function bNe(t, e) {
  return t == e || !!(t && e && t.compare(e));
}
function g4(t, e, n, r = 0) {
  let a = n.length - 1;
  a >= 0 && n[a] + r >= t ? n[a] = Math.max(n[a], e) : n.push(t, e);
}
class lT {
  constructor(e, n, r, a) {
    this.doc = e, this.pos = n, this.end = r, this.disallowBlockEffectsFor = a, this.content = [], this.curLine = null, this.breakAtStart = 0, this.pendingBuffer = 0, this.bufferMarks = [], this.atCursorPos = !0, this.openStart = -1, this.openEnd = -1, this.text = "", this.textOff = 0, this.cursor = e.iter(), this.skip = n;
  }
  posCovered() {
    if (this.content.length == 0)
      return !this.breakAtStart && this.doc.lineAt(this.pos).from != this.pos;
    let e = this.content[this.content.length - 1];
    return !(e.breakAfter || e instanceof Vb && e.deco.endSide < 0);
  }
  getLine() {
    return this.curLine || (this.content.push(this.curLine = new qo()), this.atCursorPos = !0), this.curLine;
  }
  flushBuffer(e = this.bufferMarks) {
    this.pendingBuffer && (this.curLine.append(Ux(new jE(-1), e), e.length), this.pendingBuffer = 0);
  }
  addBlockWidget(e) {
    this.flushBuffer(), this.curLine = null, this.content.push(e);
  }
  finish(e) {
    this.pendingBuffer && e <= this.bufferMarks.length ? this.flushBuffer() : this.pendingBuffer = 0, !this.posCovered() && !(e && this.content.length && this.content[this.content.length - 1] instanceof Vb) && this.getLine();
  }
  buildText(e, n, r) {
    for (; e > 0; ) {
      if (this.textOff == this.text.length) {
        let { value: i, lineBreak: o, done: s } = this.cursor.next(this.skip);
        if (this.skip = 0, s)
          throw new Error("Ran out of text content when drawing inline views");
        if (o) {
          this.posCovered() || this.getLine(), this.content.length ? this.content[this.content.length - 1].breakAfter = 1 : this.breakAtStart = 1, this.flushBuffer(), this.curLine = null, this.atCursorPos = !0, e--;
          continue;
        } else
          this.text = i, this.textOff = 0;
      }
      let a = Math.min(
        this.text.length - this.textOff,
        e,
        512
        /* T.Chunk */
      );
      this.flushBuffer(n.slice(n.length - r)), this.getLine().append(Ux(new qd(this.text.slice(this.textOff, this.textOff + a)), n), r), this.atCursorPos = !0, this.textOff += a, e -= a, r = 0;
    }
  }
  span(e, n, r, a) {
    this.buildText(n - e, r, a), this.pos = n, this.openStart < 0 && (this.openStart = a);
  }
  point(e, n, r, a, i, o) {
    if (this.disallowBlockEffectsFor[o] && r instanceof nv) {
      if (r.block)
        throw new RangeError("Block decorations may not be specified via plugins");
      if (n > this.doc.lineAt(this.pos).to)
        throw new RangeError("Decorations that replace line breaks may not be specified via plugins");
    }
    let s = n - e;
    if (r instanceof nv)
      if (r.block)
        r.startSide > 0 && !this.posCovered() && this.getLine(), this.addBlockWidget(new Vb(r.widget || GE.block, s, r));
      else {
        let u = Qb.create(r.widget || GE.inline, s, s ? 0 : r.startSide), f = this.atCursorPos && !u.isEditable && i <= a.length && (e < n || r.startSide > 0), p = !u.isEditable && (e < n || i > a.length || r.startSide <= 0), m = this.getLine();
        this.pendingBuffer == 2 && !f && !u.isEditable && (this.pendingBuffer = 0), this.flushBuffer(a), f && (m.append(Ux(new jE(1), a), i), i = a.length + Math.max(0, i - a.length)), m.append(Ux(u, a), i), this.atCursorPos = p, this.pendingBuffer = p ? e < n || i > a.length ? 1 : 2 : 0, this.pendingBuffer && (this.bufferMarks = a.slice());
      }
    else
      this.doc.lineAt(this.pos).from == this.pos && this.getLine().addLineDeco(r);
    s && (this.textOff + s <= this.text.length ? this.textOff += s : (this.skip += s - (this.text.length - this.textOff), this.text = "", this.textOff = 0), this.pos = n), this.openStart < 0 && (this.openStart = i);
  }
  static build(e, n, r, a, i) {
    let o = new lT(e, n, r, i);
    return o.openEnd = ta.spans(a, n, r, o), o.openStart < 0 && (o.openStart = o.openEnd), o.finish(o.openEnd), o;
  }
}
function Ux(t, e) {
  for (let n of e)
    t = new ng(n, [t], t.length);
  return t;
}
class GE extends Nh {
  constructor(e) {
    super(), this.tag = e;
  }
  eq(e) {
    return e.tag == this.tag;
  }
  toDOM() {
    return document.createElement(this.tag);
  }
  updateDOM(e) {
    return e.nodeName.toLowerCase() == this.tag;
  }
  get isHidden() {
    return !0;
  }
}
GE.inline = /* @__PURE__ */ new GE("span");
GE.block = /* @__PURE__ */ new GE("div");
var hi = /* @__PURE__ */ function(t) {
  return t[t.LTR = 0] = "LTR", t[t.RTL = 1] = "RTL", t;
}(hi || (hi = {}));
const p0 = hi.LTR, WU = hi.RTL;
function Qae(t) {
  let e = [];
  for (let n = 0; n < t.length; n++)
    e.push(1 << +t[n]);
  return e;
}
const vNe = /* @__PURE__ */ Qae("88888888888888888888888888888888888666888888787833333333337888888000000000000000000000000008888880000000000000000000000000088888888888888888888888888888888888887866668888088888663380888308888800000000000000000000000800000000000000000000000000000008"), yNe = /* @__PURE__ */ Qae("4444448826627288999999999992222222222222222222222222222222222222222222222229999999999999999999994444444444644222822222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222999999949999999229989999223333333333"), b4 = /* @__PURE__ */ Object.create(null), uh = [];
for (let t of ["()", "[]", "{}"]) {
  let e = /* @__PURE__ */ t.charCodeAt(0), n = /* @__PURE__ */ t.charCodeAt(1);
  b4[e] = n, b4[n] = -e;
}
function jae(t) {
  return t <= 247 ? vNe[t] : 1424 <= t && t <= 1524 ? 2 : 1536 <= t && t <= 1785 ? yNe[t - 1536] : 1774 <= t && t <= 2220 ? 4 : 8192 <= t && t <= 8204 ? 256 : 64336 <= t && t <= 65023 ? 4 : 1;
}
const ONe = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\ufb50-\ufdff]/;
class jb {
  /**
  The direction of this span.
  */
  get dir() {
    return this.level % 2 ? WU : p0;
  }
  /**
  @internal
  */
  constructor(e, n, r) {
    this.from = e, this.to = n, this.level = r;
  }
  /**
  @internal
  */
  side(e, n) {
    return this.dir == n == e ? this.to : this.from;
  }
  /**
  @internal
  */
  forward(e, n) {
    return e == (this.dir == n);
  }
  /**
  @internal
  */
  static find(e, n, r, a) {
    let i = -1;
    for (let o = 0; o < e.length; o++) {
      let s = e[o];
      if (s.from <= n && s.to >= n) {
        if (s.level == r)
          return o;
        (i < 0 || (a != 0 ? a < 0 ? s.from < n : s.to > n : e[i].level > s.level)) && (i = o);
      }
    }
    if (i < 0)
      throw new RangeError("Index out of range");
    return i;
  }
}
function Gae(t, e) {
  if (t.length != e.length)
    return !1;
  for (let n = 0; n < t.length; n++) {
    let r = t[n], a = e[n];
    if (r.from != a.from || r.to != a.to || r.direction != a.direction || !Gae(r.inner, a.inner))
      return !1;
  }
  return !0;
}
const Ga = [];
function ENe(t, e, n, r, a) {
  for (let i = 0; i <= r.length; i++) {
    let o = i ? r[i - 1].to : e, s = i < r.length ? r[i].from : n, u = i ? 256 : a;
    for (let f = o, p = u, m = u; f < s; f++) {
      let v = jae(t.charCodeAt(f));
      v == 512 ? v = p : v == 8 && m == 4 && (v = 16), Ga[f] = v == 4 ? 2 : v, v & 7 && (m = v), p = v;
    }
    for (let f = o, p = u, m = u; f < s; f++) {
      let v = Ga[f];
      if (v == 128)
        f < s - 1 && p == Ga[f + 1] && p & 24 ? v = Ga[f] = p : Ga[f] = 256;
      else if (v == 64) {
        let O = f + 1;
        for (; O < s && Ga[O] == 64; )
          O++;
        let w = f && p == 8 || O < n && Ga[O] == 8 ? m == 1 ? 1 : 8 : 256;
        for (let _ = f; _ < O; _++)
          Ga[_] = w;
        f = O - 1;
      } else
        v == 8 && m == 1 && (Ga[f] = 1);
      p = v, v & 7 && (m = v);
    }
  }
}
function SNe(t, e, n, r, a) {
  let i = a == 1 ? 2 : 1;
  for (let o = 0, s = 0, u = 0; o <= r.length; o++) {
    let f = o ? r[o - 1].to : e, p = o < r.length ? r[o].from : n;
    for (let m = f, v, O, w; m < p; m++)
      if (O = b4[v = t.charCodeAt(m)])
        if (O < 0) {
          for (let _ = s - 3; _ >= 0; _ -= 3)
            if (uh[_ + 1] == -O) {
              let C = uh[_ + 2], A = C & 2 ? a : C & 4 ? C & 1 ? i : a : 0;
              A && (Ga[m] = Ga[uh[_]] = A), s = _;
              break;
            }
        } else {
          if (uh.length == 189)
            break;
          uh[s++] = m, uh[s++] = v, uh[s++] = u;
        }
      else if ((w = Ga[m]) == 2 || w == 1) {
        let _ = w == a;
        u = _ ? 0 : 1;
        for (let C = s - 3; C >= 0; C -= 3) {
          let A = uh[C + 2];
          if (A & 2)
            break;
          if (_)
            uh[C + 2] |= 2;
          else {
            if (A & 4)
              break;
            uh[C + 2] |= 4;
          }
        }
      }
  }
}
function wNe(t, e, n, r) {
  for (let a = 0, i = r; a <= n.length; a++) {
    let o = a ? n[a - 1].to : t, s = a < n.length ? n[a].from : e;
    for (let u = o; u < s; ) {
      let f = Ga[u];
      if (f == 256) {
        let p = u + 1;
        for (; ; )
          if (p == s) {
            if (a == n.length)
              break;
            p = n[a++].to, s = a < n.length ? n[a].from : e;
          } else if (Ga[p] == 256)
            p++;
          else
            break;
        let m = i == 1, v = (p < e ? Ga[p] : r) == 1, O = m == v ? m ? 1 : 2 : r;
        for (let w = p, _ = a, C = _ ? n[_ - 1].to : t; w > u; )
          w == C && (w = n[--_].from, C = _ ? n[_ - 1].to : t), Ga[--w] = O;
        u = p;
      } else
        i = f, u++;
    }
  }
}
function v4(t, e, n, r, a, i, o) {
  let s = r % 2 ? 2 : 1;
  if (r % 2 == a % 2)
    for (let u = e, f = 0; u < n; ) {
      let p = !0, m = !1;
      if (f == i.length || u < i[f].from) {
        let _ = Ga[u];
        _ != s && (p = !1, m = _ == 16);
      }
      let v = !p && s == 1 ? [] : null, O = p ? r : r + 1, w = u;
      e:
        for (; ; )
          if (f < i.length && w == i[f].from) {
            if (m)
              break e;
            let _ = i[f];
            if (!p)
              for (let C = _.to, A = f + 1; ; ) {
                if (C == n)
                  break e;
                if (A < i.length && i[A].from == C)
                  C = i[A++].to;
                else {
                  if (Ga[C] == s)
                    break e;
                  break;
                }
              }
            if (f++, v)
              v.push(_);
            else {
              _.from > u && o.push(new jb(u, _.from, O));
              let C = _.direction == p0 != !(O % 2);
              y4(t, C ? r + 1 : r, a, _.inner, _.from, _.to, o), u = _.to;
            }
            w = _.to;
          } else {
            if (w == n || (p ? Ga[w] != s : Ga[w] == s))
              break;
            w++;
          }
      v ? v4(t, u, w, r + 1, a, v, o) : u < w && o.push(new jb(u, w, O)), u = w;
    }
  else
    for (let u = n, f = i.length; u > e; ) {
      let p = !0, m = !1;
      if (!f || u > i[f - 1].to) {
        let _ = Ga[u - 1];
        _ != s && (p = !1, m = _ == 16);
      }
      let v = !p && s == 1 ? [] : null, O = p ? r : r + 1, w = u;
      e:
        for (; ; )
          if (f && w == i[f - 1].to) {
            if (m)
              break e;
            let _ = i[--f];
            if (!p)
              for (let C = _.from, A = f; ; ) {
                if (C == e)
                  break e;
                if (A && i[A - 1].to == C)
                  C = i[--A].from;
                else {
                  if (Ga[C - 1] == s)
                    break e;
                  break;
                }
              }
            if (v)
              v.push(_);
            else {
              _.to < u && o.push(new jb(_.to, u, O));
              let C = _.direction == p0 != !(O % 2);
              y4(t, C ? r + 1 : r, a, _.inner, _.from, _.to, o), u = _.from;
            }
            w = _.from;
          } else {
            if (w == e || (p ? Ga[w - 1] != s : Ga[w - 1] == s))
              break;
            w--;
          }
      v ? v4(t, w, u, r + 1, a, v, o) : w < u && o.push(new jb(w, u, O)), u = w;
    }
}
function y4(t, e, n, r, a, i, o) {
  let s = e % 2 ? 2 : 1;
  ENe(t, a, i, r, s), SNe(t, a, i, r, s), wNe(a, i, r, s), v4(t, a, i, e, n, r, o);
}
function TNe(t, e, n) {
  if (!t)
    return [new jb(0, 0, e == WU ? 1 : 0)];
  if (e == p0 && !n.length && !ONe.test(t))
    return Vae(t.length);
  if (n.length)
    for (; t.length > Ga.length; )
      Ga[Ga.length] = 256;
  let r = [], a = e == p0 ? 0 : 1;
  return y4(t, a, a, n, 0, t.length, r), r;
}
function Vae(t) {
  return [new jb(0, t, 0)];
}
let Yae = "";
function _Ne(t, e, n, r, a) {
  var i;
  let o = r.head - t.from, s = jb.find(e, o, (i = r.bidiLevel) !== null && i !== void 0 ? i : -1, r.assoc), u = e[s], f = u.side(a, n);
  if (o == f) {
    let v = s += a ? 1 : -1;
    if (v < 0 || v >= e.length)
      return null;
    u = e[s = v], o = u.side(!a, n), f = u.side(a, n);
  }
  let p = nl(t.text, o, u.forward(a, n));
  (p < u.from || p > u.to) && (p = f), Yae = t.text.slice(Math.min(o, p), Math.max(o, p));
  let m = s == (a ? e.length - 1 : 0) ? null : e[s + (a ? 1 : -1)];
  return m && p == f && m.level + (a ? 0 : 1) < u.level ? ft.cursor(m.side(!a, n) + t.from, m.forward(a, n) ? 1 : -1, m.level) : ft.cursor(p + t.from, u.forward(a, n) ? -1 : 1, u.level);
}
function CNe(t, e, n) {
  for (let r = e; r < n; r++) {
    let a = jae(t.charCodeAt(r));
    if (a == 1)
      return p0;
    if (a == 2 || a == 4)
      return WU;
  }
  return p0;
}
const Zae = /* @__PURE__ */ bn.define(), Xae = /* @__PURE__ */ bn.define(), qae = /* @__PURE__ */ bn.define(), Kae = /* @__PURE__ */ bn.define(), O4 = /* @__PURE__ */ bn.define(), Jae = /* @__PURE__ */ bn.define(), eie = /* @__PURE__ */ bn.define(), tie = /* @__PURE__ */ bn.define({
  combine: (t) => t.some((e) => e)
}), nie = /* @__PURE__ */ bn.define({
  combine: (t) => t.some((e) => e)
}), rie = /* @__PURE__ */ bn.define();
class kE {
  constructor(e, n = "nearest", r = "nearest", a = 5, i = 5, o = !1) {
    this.range = e, this.y = n, this.x = r, this.yMargin = a, this.xMargin = i, this.isSnapshot = o;
  }
  map(e) {
    return e.empty ? this : new kE(this.range.map(e), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
  }
  clip(e) {
    return this.range.to <= e.doc.length ? this : new kE(ft.cursor(e.doc.length), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
  }
}
const zx = /* @__PURE__ */ fr.define({ map: (t, e) => t.map(e) });
function Ku(t, e, n) {
  let r = t.facet(Kae);
  r.length ? r[0](e) : window.onerror ? window.onerror(String(e), n, void 0, void 0, e) : n ? console.error(n + ":", e) : console.error(e);
}
const vD = /* @__PURE__ */ bn.define({ combine: (t) => t.length ? t[0] : !0 });
let xNe = 0;
const Mw = /* @__PURE__ */ bn.define();
class Ki {
  constructor(e, n, r, a, i) {
    this.id = e, this.create = n, this.domEventHandlers = r, this.domEventObservers = a, this.extension = i(this);
  }
  /**
  Define a plugin from a constructor function that creates the
  plugin's value, given an editor view.
  */
  static define(e, n) {
    const { eventHandlers: r, eventObservers: a, provide: i, decorations: o } = n || {};
    return new Ki(xNe++, e, r, a, (s) => {
      let u = [Mw.of(s)];
      return o && u.push(zT.of((f) => {
        let p = f.plugin(s);
        return p ? o(p) : Ln.none;
      })), i && u.push(i(s)), u;
    });
  }
  /**
  Create a plugin for a class whose constructor takes a single
  editor view as argument.
  */
  static fromClass(e, n) {
    return Ki.define((r) => new e(r), n);
  }
}
class r3 {
  constructor(e) {
    this.spec = e, this.mustUpdate = null, this.value = null;
  }
  update(e) {
    if (this.value) {
      if (this.mustUpdate) {
        let n = this.mustUpdate;
        if (this.mustUpdate = null, this.value.update)
          try {
            this.value.update(n);
          } catch (r) {
            if (Ku(n.state, r, "CodeMirror plugin crashed"), this.value.destroy)
              try {
                this.value.destroy();
              } catch {
              }
            this.deactivate();
          }
      }
    } else if (this.spec)
      try {
        this.value = this.spec.create(e);
      } catch (n) {
        Ku(e.state, n, "CodeMirror plugin crashed"), this.deactivate();
      }
    return this;
  }
  destroy(e) {
    var n;
    if (!((n = this.value) === null || n === void 0) && n.destroy)
      try {
        this.value.destroy();
      } catch (r) {
        Ku(e.state, r, "CodeMirror plugin crashed");
      }
  }
  deactivate() {
    this.spec = this.value = null;
  }
}
const aie = /* @__PURE__ */ bn.define(), QU = /* @__PURE__ */ bn.define(), zT = /* @__PURE__ */ bn.define(), iie = /* @__PURE__ */ bn.define(), jU = /* @__PURE__ */ bn.define(), oie = /* @__PURE__ */ bn.define();
function xX(t, e) {
  let n = t.state.facet(oie);
  if (!n.length)
    return n;
  let r = n.map((i) => i instanceof Function ? i(t) : i), a = [];
  return ta.spans(r, e.from, e.to, {
    point() {
    },
    span(i, o, s, u) {
      let f = i - e.from, p = o - e.from, m = a;
      for (let v = s.length - 1; v >= 0; v--, u--) {
        let O = s[v].spec.bidiIsolate, w;
        if (O == null && (O = CNe(e.text, f, p)), u > 0 && m.length && (w = m[m.length - 1]).to == f && w.direction == O)
          w.to = p, m = w.inner;
        else {
          let _ = { from: f, to: p, direction: O, inner: [] };
          m.push(_), m = _.inner;
        }
      }
    }
  }), a;
}
const sie = /* @__PURE__ */ bn.define();
function lie(t) {
  let e = 0, n = 0, r = 0, a = 0;
  for (let i of t.state.facet(sie)) {
    let o = i(t);
    o && (o.left != null && (e = Math.max(e, o.left)), o.right != null && (n = Math.max(n, o.right)), o.top != null && (r = Math.max(r, o.top)), o.bottom != null && (a = Math.max(a, o.bottom)));
  }
  return { left: e, right: n, top: r, bottom: a };
}
const Fw = /* @__PURE__ */ bn.define();
class jf {
  constructor(e, n, r, a) {
    this.fromA = e, this.toA = n, this.fromB = r, this.toB = a;
  }
  join(e) {
    return new jf(Math.min(this.fromA, e.fromA), Math.max(this.toA, e.toA), Math.min(this.fromB, e.fromB), Math.max(this.toB, e.toB));
  }
  addToSet(e) {
    let n = e.length, r = this;
    for (; n > 0; n--) {
      let a = e[n - 1];
      if (!(a.fromA > r.toA)) {
        if (a.toA < r.fromA)
          break;
        r = r.join(a), e.splice(n - 1, 1);
      }
    }
    return e.splice(n, 0, r), e;
  }
  static extendWithRanges(e, n) {
    if (n.length == 0)
      return e;
    let r = [];
    for (let a = 0, i = 0, o = 0, s = 0; ; a++) {
      let u = a == e.length ? null : e[a], f = o - s, p = u ? u.fromB : 1e9;
      for (; i < n.length && n[i] < p; ) {
        let m = n[i], v = n[i + 1], O = Math.max(s, m), w = Math.min(p, v);
        if (O <= w && new jf(O + f, w + f, O, w).addToSet(r), v > p)
          break;
        i += 2;
      }
      if (!u)
        return r;
      new jf(u.fromA, u.toA, u.fromB, u.toB).addToSet(r), o = u.toA, s = u.toB;
    }
  }
}
class iI {
  constructor(e, n, r) {
    this.view = e, this.state = n, this.transactions = r, this.flags = 0, this.startState = e.state, this.changes = Ko.empty(this.startState.doc.length);
    for (let i of r)
      this.changes = this.changes.compose(i.changes);
    let a = [];
    this.changes.iterChangedRanges((i, o, s, u) => a.push(new jf(i, o, s, u))), this.changedRanges = a;
  }
  /**
  @internal
  */
  static create(e, n, r) {
    return new iI(e, n, r);
  }
  /**
  Tells you whether the [viewport](https://codemirror.net/6/docs/ref/#view.EditorView.viewport) or
  [visible ranges](https://codemirror.net/6/docs/ref/#view.EditorView.visibleRanges) changed in this
  update.
  */
  get viewportChanged() {
    return (this.flags & 4) > 0;
  }
  /**
  Indicates whether the height of a block element in the editor
  changed in this update.
  */
  get heightChanged() {
    return (this.flags & 2) > 0;
  }
  /**
  Returns true when the document was modified or the size of the
  editor, or elements within the editor, changed.
  */
  get geometryChanged() {
    return this.docChanged || (this.flags & 10) > 0;
  }
  /**
  True when this update indicates a focus change.
  */
  get focusChanged() {
    return (this.flags & 1) > 0;
  }
  /**
  Whether the document changed in this update.
  */
  get docChanged() {
    return !this.changes.empty;
  }
  /**
  Whether the selection was explicitly set in this update.
  */
  get selectionSet() {
    return this.transactions.some((e) => e.selection);
  }
  /**
  @internal
  */
  get empty() {
    return this.flags == 0 && this.transactions.length == 0;
  }
}
class AX extends Va {
  get length() {
    return this.view.state.doc.length;
  }
  constructor(e) {
    super(), this.view = e, this.decorations = [], this.dynamicDecorationMap = [], this.domChanged = null, this.hasComposition = null, this.markedForComposition = /* @__PURE__ */ new Set(), this.lastCompositionAfterCursor = !1, this.minWidth = 0, this.minWidthFrom = 0, this.minWidthTo = 0, this.impreciseAnchor = null, this.impreciseHead = null, this.forceSelection = !1, this.lastUpdate = Date.now(), this.setDOM(e.contentDOM), this.children = [new qo()], this.children[0].setParent(this), this.updateDeco(), this.updateInner([new jf(0, 0, 0, e.state.doc.length)], 0, null);
  }
  // Update the document view to a given state.
  update(e) {
    var n;
    let r = e.changedRanges;
    this.minWidth > 0 && r.length && (r.every(({ fromA: f, toA: p }) => p < this.minWidthFrom || f > this.minWidthTo) ? (this.minWidthFrom = e.changes.mapPos(this.minWidthFrom, 1), this.minWidthTo = e.changes.mapPos(this.minWidthTo, 1)) : this.minWidth = this.minWidthFrom = this.minWidthTo = 0);
    let a = -1;
    this.view.inputState.composing >= 0 && (!((n = this.domChanged) === null || n === void 0) && n.newSel ? a = this.domChanged.newSel.head : !PNe(e.changes, this.hasComposition) && !e.selectionSet && (a = e.state.selection.main.head));
    let i = a > -1 ? kNe(this.view, e.changes, a) : null;
    if (this.domChanged = null, this.hasComposition) {
      this.markedForComposition.clear();
      let { from: f, to: p } = this.hasComposition;
      r = new jf(f, p, e.changes.mapPos(f, -1), e.changes.mapPos(p, 1)).addToSet(r.slice());
    }
    this.hasComposition = i ? { from: i.range.fromB, to: i.range.toB } : null, (vn.ie || vn.chrome) && !i && e && e.state.doc.lines != e.startState.doc.lines && (this.forceSelection = !0);
    let o = this.decorations, s = this.updateDeco(), u = DNe(o, s, e.changes);
    return r = jf.extendWithRanges(r, u), !(this.flags & 7) && r.length == 0 ? !1 : (this.updateInner(r, e.startState.doc.length, i), e.transactions.length && (this.lastUpdate = Date.now()), !0);
  }
  // Used by update and the constructor do perform the actual DOM
  // update
  updateInner(e, n, r) {
    this.view.viewState.mustMeasureContent = !0, this.updateChildren(e, n, r);
    let { observer: a } = this.view;
    a.ignore(() => {
      this.dom.style.height = this.view.viewState.contentHeight / this.view.scaleY + "px", this.dom.style.flexBasis = this.minWidth ? this.minWidth + "px" : "";
      let o = vn.chrome || vn.ios ? { node: a.selectionRange.focusNode, written: !1 } : void 0;
      this.sync(this.view, o), this.flags &= -8, o && (o.written || a.selectionRange.focusNode != o.node) && (this.forceSelection = !0), this.dom.style.height = "";
    }), this.markedForComposition.forEach(
      (o) => o.flags &= -9
      /* ViewFlag.Composition */
    );
    let i = [];
    if (this.view.viewport.from || this.view.viewport.to < this.view.state.doc.length)
      for (let o of this.children)
        o instanceof Vb && o.widget instanceof kX && i.push(o.dom);
    a.updateGaps(i);
  }
  updateChildren(e, n, r) {
    let a = r ? r.range.addToSet(e.slice()) : e, i = this.childCursor(n);
    for (let o = a.length - 1; ; o--) {
      let s = o >= 0 ? a[o] : null;
      if (!s)
        break;
      let { fromA: u, toA: f, fromB: p, toB: m } = s, v, O, w, _;
      if (r && r.range.fromB < m && r.range.toB > p) {
        let I = lT.build(this.view.state.doc, p, r.range.fromB, this.decorations, this.dynamicDecorationMap), D = lT.build(this.view.state.doc, r.range.toB, m, this.decorations, this.dynamicDecorationMap);
        O = I.breakAtStart, w = I.openStart, _ = D.openEnd;
        let M = this.compositionView(r);
        D.breakAtStart ? M.breakAfter = 1 : D.content.length && M.merge(M.length, M.length, D.content[0], !1, D.openStart, 0) && (M.breakAfter = D.content[0].breakAfter, D.content.shift()), I.content.length && M.merge(0, 0, I.content[I.content.length - 1], !0, 0, I.openEnd) && I.content.pop(), v = I.content.concat(M).concat(D.content);
      } else
        ({ content: v, breakAtStart: O, openStart: w, openEnd: _ } = lT.build(this.view.state.doc, p, m, this.decorations, this.dynamicDecorationMap));
      let { i: C, off: A } = i.findPos(f, 1), { i: N, off: P } = i.findPos(u, -1);
      Mae(this, N, P, C, A, v, O, w, _);
    }
    r && this.fixCompositionDOM(r);
  }
  compositionView(e) {
    let n = new qd(e.text.nodeValue);
    n.flags |= 8;
    for (let { deco: a } of e.marks)
      n = new ng(a, [n], n.length);
    let r = new qo();
    return r.append(n, 0), r;
  }
  fixCompositionDOM(e) {
    let n = (i, o) => {
      o.flags |= 8 | (o.children.some(
        (u) => u.flags & 7
        /* ViewFlag.Dirty */
      ) ? 1 : 0), this.markedForComposition.add(o);
      let s = Va.get(i);
      s && s != o && (s.dom = null), o.setDOM(i);
    }, r = this.childPos(e.range.fromB, 1), a = this.children[r.i];
    n(e.line, a);
    for (let i = e.marks.length - 1; i >= -1; i--)
      r = a.childPos(r.off, 1), a = a.children[r.i], n(i >= 0 ? e.marks[i].node : e.text, a);
  }
  // Sync the DOM selection to this.state.selection
  updateSelection(e = !1, n = !1) {
    (e || !this.view.observer.selectionRange.focusNode) && this.view.observer.readSelectionRange();
    let r = this.view.root.activeElement, a = r == this.dom, i = !a && Sk(this.dom, this.view.observer.selectionRange) && !(r && this.dom.contains(r));
    if (!(a || n || i))
      return;
    let o = this.forceSelection;
    this.forceSelection = !1;
    let s = this.view.state.selection.main, u = this.moveToLine(this.domAtPos(s.anchor)), f = s.empty ? u : this.moveToLine(this.domAtPos(s.head));
    if (vn.gecko && s.empty && !this.hasComposition && ANe(u)) {
      let m = document.createTextNode("");
      this.view.observer.ignore(() => u.node.insertBefore(m, u.node.childNodes[u.offset] || null)), u = f = new Rl(m, 0), o = !0;
    }
    let p = this.view.observer.selectionRange;
    (o || !p.focusNode || (!sT(u.node, u.offset, p.anchorNode, p.anchorOffset) || !sT(f.node, f.offset, p.focusNode, p.focusOffset)) && !this.suppressWidgetCursorChange(p, s)) && (this.view.observer.ignore(() => {
      vn.android && vn.chrome && this.dom.contains(p.focusNode) && NNe(p.focusNode, this.dom) && (this.dom.blur(), this.dom.focus({ preventScroll: !0 }));
      let m = rI(this.view.root);
      if (m)
        if (s.empty) {
          if (vn.gecko) {
            let v = RNe(u.node, u.offset);
            if (v && v != 3) {
              let O = (v == 1 ? Nae : Pae)(u.node, u.offset);
              O && (u = new Rl(O.node, O.offset));
            }
          }
          m.collapse(u.node, u.offset), s.bidiLevel != null && m.caretBidiLevel !== void 0 && (m.caretBidiLevel = s.bidiLevel);
        } else if (m.extend) {
          m.collapse(u.node, u.offset);
          try {
            m.extend(f.node, f.offset);
          } catch {
          }
        } else {
          let v = document.createRange();
          s.anchor > s.head && ([u, f] = [f, u]), v.setEnd(f.node, f.offset), v.setStart(u.node, u.offset), m.removeAllRanges(), m.addRange(v);
        }
      i && this.view.root.activeElement == this.dom && (this.dom.blur(), r && r.focus());
    }), this.view.observer.setSelectionRange(u, f)), this.impreciseAnchor = u.precise ? null : new Rl(p.anchorNode, p.anchorOffset), this.impreciseHead = f.precise ? null : new Rl(p.focusNode, p.focusOffset);
  }
  // If a zero-length widget is inserted next to the cursor during
  // composition, avoid moving it across it and disrupting the
  // composition.
  suppressWidgetCursorChange(e, n) {
    return this.hasComposition && n.empty && sT(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset) && this.posFromDOM(e.focusNode, e.focusOffset) == n.head;
  }
  enforceCursorAssoc() {
    if (this.hasComposition)
      return;
    let { view: e } = this, n = e.state.selection.main, r = rI(e.root), { anchorNode: a, anchorOffset: i } = e.observer.selectionRange;
    if (!r || !n.empty || !n.assoc || !r.modify)
      return;
    let o = qo.find(this, n.head);
    if (!o)
      return;
    let s = o.posAtStart;
    if (n.head == s || n.head == s + o.length)
      return;
    let u = this.coordsAt(n.head, -1), f = this.coordsAt(n.head, 1);
    if (!u || !f || u.bottom > f.top)
      return;
    let p = this.domAtPos(n.head + n.assoc);
    r.collapse(p.node, p.offset), r.modify("move", n.assoc < 0 ? "forward" : "backward", "lineboundary"), e.observer.readSelectionRange();
    let m = e.observer.selectionRange;
    e.docView.posFromDOM(m.anchorNode, m.anchorOffset) != n.from && r.collapse(a, i);
  }
  // If a position is in/near a block widget, move it to a nearby text
  // line, since we don't want the cursor inside a block widget.
  moveToLine(e) {
    let n = this.dom, r;
    if (e.node != n)
      return e;
    for (let a = e.offset; !r && a < n.childNodes.length; a++) {
      let i = Va.get(n.childNodes[a]);
      i instanceof qo && (r = i.domAtPos(0));
    }
    for (let a = e.offset - 1; !r && a >= 0; a--) {
      let i = Va.get(n.childNodes[a]);
      i instanceof qo && (r = i.domAtPos(i.length));
    }
    return r ? new Rl(r.node, r.offset, !0) : e;
  }
  nearest(e) {
    for (let n = e; n; ) {
      let r = Va.get(n);
      if (r && r.rootView == this)
        return r;
      n = n.parentNode;
    }
    return null;
  }
  posFromDOM(e, n) {
    let r = this.nearest(e);
    if (!r)
      throw new RangeError("Trying to find position for a DOM position outside of the document");
    return r.localPosFromDOM(e, n) + r.posAtStart;
  }
  domAtPos(e) {
    let { i: n, off: r } = this.childCursor().findPos(e, -1);
    for (; n < this.children.length - 1; ) {
      let a = this.children[n];
      if (r < a.length || a instanceof qo)
        break;
      n++, r = 0;
    }
    return this.children[n].domAtPos(r);
  }
  coordsAt(e, n) {
    let r = null, a = 0;
    for (let i = this.length, o = this.children.length - 1; o >= 0; o--) {
      let s = this.children[o], u = i - s.breakAfter, f = u - s.length;
      if (u < e)
        break;
      f <= e && (f < e || s.covers(-1)) && (u > e || s.covers(1)) && (!r || s instanceof qo && !(r instanceof qo && n >= 0)) && (r = s, a = f), i = f;
    }
    return r ? r.coordsAt(e - a, n) : null;
  }
  coordsForChar(e) {
    let { i: n, off: r } = this.childPos(e, 1), a = this.children[n];
    if (!(a instanceof qo))
      return null;
    for (; a.children.length; ) {
      let { i: s, off: u } = a.childPos(r, 1);
      for (; ; s++) {
        if (s == a.children.length)
          return null;
        if ((a = a.children[s]).length)
          break;
      }
      r = u;
    }
    if (!(a instanceof qd))
      return null;
    let i = nl(a.text, r);
    if (i == r)
      return null;
    let o = d0(a.dom, r, i).getClientRects();
    for (let s = 0; s < o.length; s++) {
      let u = o[s];
      if (s == o.length - 1 || u.top < u.bottom && u.left < u.right)
        return u;
    }
    return null;
  }
  measureVisibleLineHeights(e) {
    let n = [], { from: r, to: a } = e, i = this.view.contentDOM.clientWidth, o = i > Math.max(this.view.scrollDOM.clientWidth, this.minWidth) + 1, s = -1, u = this.view.textDirection == hi.LTR;
    for (let f = 0, p = 0; p < this.children.length; p++) {
      let m = this.children[p], v = f + m.length;
      if (v > a)
        break;
      if (f >= r) {
        let O = m.dom.getBoundingClientRect();
        if (n.push(O.height), o) {
          let w = m.dom.lastChild, _ = w ? QE(w) : [];
          if (_.length) {
            let C = _[_.length - 1], A = u ? C.right - O.left : O.right - C.left;
            A > s && (s = A, this.minWidth = i, this.minWidthFrom = f, this.minWidthTo = v);
          }
        }
      }
      f = v + m.breakAfter;
    }
    return n;
  }
  textDirectionAt(e) {
    let { i: n } = this.childPos(e, 1);
    return getComputedStyle(this.children[n].dom).direction == "rtl" ? hi.RTL : hi.LTR;
  }
  measureTextSize() {
    for (let i of this.children)
      if (i instanceof qo) {
        let o = i.measureTextSize();
        if (o)
          return o;
      }
    let e = document.createElement("div"), n, r, a;
    return e.className = "cm-line", e.style.width = "99999px", e.style.position = "absolute", e.textContent = "abc def ghi jkl mno pqr stu", this.view.observer.ignore(() => {
      this.dom.appendChild(e);
      let i = QE(e.firstChild)[0];
      n = e.getBoundingClientRect().height, r = i ? i.width / 27 : 7, a = i ? i.height : n, e.remove();
    }), { lineHeight: n, charWidth: r, textHeight: a };
  }
  childCursor(e = this.length) {
    let n = this.children.length;
    return n && (e -= this.children[--n].length), new Lae(this.children, e, n);
  }
  computeBlockGapDeco() {
    let e = [], n = this.view.viewState;
    for (let r = 0, a = 0; ; a++) {
      let i = a == n.viewports.length ? null : n.viewports[a], o = i ? i.from - 1 : this.length;
      if (o > r) {
        let s = (n.lineBlockAt(o).bottom - n.lineBlockAt(r).top) / this.view.scaleY;
        e.push(Ln.replace({
          widget: new kX(s),
          block: !0,
          inclusive: !0,
          isBlockGap: !0
        }).range(r, o));
      }
      if (!i)
        break;
      r = i.to + 1;
    }
    return Ln.set(e);
  }
  updateDeco() {
    let e = 0, n = this.view.state.facet(zT).map((i) => (this.dynamicDecorationMap[e++] = typeof i == "function") ? i(this.view) : i), r = !1, a = this.view.state.facet(iie).map((i, o) => {
      let s = typeof i == "function";
      return s && (r = !0), s ? i(this.view) : i;
    });
    for (a.length && (this.dynamicDecorationMap[e++] = r, n.push(ta.join(a))), this.decorations = [
      ...n,
      this.computeBlockGapDeco(),
      this.view.viewState.lineGapDeco
    ]; e < this.decorations.length; )
      this.dynamicDecorationMap[e++] = !1;
    return this.decorations;
  }
  scrollIntoView(e) {
    if (e.isSnapshot) {
      let f = this.view.viewState.lineBlockAt(e.range.head);
      this.view.scrollDOM.scrollTop = f.top - e.yMargin, this.view.scrollDOM.scrollLeft = e.xMargin;
      return;
    }
    for (let f of this.view.state.facet(rie))
      try {
        if (f(this.view, e.range, e))
          return !0;
      } catch (p) {
        Ku(this.view.state, p, "scroll handler");
      }
    let { range: n } = e, r = this.coordsAt(n.head, n.empty ? n.assoc : n.head > n.anchor ? -1 : 1), a;
    if (!r)
      return;
    !n.empty && (a = this.coordsAt(n.anchor, n.anchor > n.head ? -1 : 1)) && (r = {
      left: Math.min(r.left, a.left),
      top: Math.min(r.top, a.top),
      right: Math.max(r.right, a.right),
      bottom: Math.max(r.bottom, a.bottom)
    });
    let i = lie(this.view), o = {
      left: r.left - i.left,
      top: r.top - i.top,
      right: r.right + i.right,
      bottom: r.bottom + i.bottom
    }, { offsetWidth: s, offsetHeight: u } = this.view.scrollDOM;
    lNe(this.view.scrollDOM, o, n.head < n.anchor ? -1 : 1, e.x, e.y, Math.max(Math.min(e.xMargin, s), -s), Math.max(Math.min(e.yMargin, u), -u), this.view.textDirection == hi.LTR);
  }
}
function ANe(t) {
  return t.node.nodeType == 1 && t.node.firstChild && (t.offset == 0 || t.node.childNodes[t.offset - 1].contentEditable == "false") && (t.offset == t.node.childNodes.length || t.node.childNodes[t.offset].contentEditable == "false");
}
class kX extends Nh {
  constructor(e) {
    super(), this.height = e;
  }
  toDOM() {
    let e = document.createElement("div");
    return e.className = "cm-gap", this.updateDOM(e), e;
  }
  eq(e) {
    return e.height == this.height;
  }
  updateDOM(e) {
    return e.style.height = this.height + "px", !0;
  }
  get editable() {
    return !0;
  }
  get estimatedHeight() {
    return this.height;
  }
  ignoreEvent() {
    return !1;
  }
}
function uie(t, e) {
  let n = t.observer.selectionRange;
  if (!n.focusNode)
    return null;
  let r = Nae(n.focusNode, n.focusOffset), a = Pae(n.focusNode, n.focusOffset), i = r || a;
  if (a && r && a.node != r.node) {
    let s = Va.get(a.node);
    if (!s || s instanceof qd && s.text != a.node.nodeValue)
      i = a;
    else if (t.docView.lastCompositionAfterCursor) {
      let u = Va.get(r.node);
      !u || u instanceof qd && u.text != r.node.nodeValue || (i = a);
    }
  }
  if (t.docView.lastCompositionAfterCursor = i != r, !i)
    return null;
  let o = e - i.offset;
  return { from: o, to: o + i.node.nodeValue.length, node: i.node };
}
function kNe(t, e, n) {
  let r = uie(t, n);
  if (!r)
    return null;
  let { node: a, from: i, to: o } = r, s = a.nodeValue;
  if (/[\n\r]/.test(s) || t.state.doc.sliceString(r.from, r.to) != s)
    return null;
  let u = e.invertedDesc, f = new jf(u.mapPos(i), u.mapPos(o), i, o), p = [];
  for (let m = a.parentNode; ; m = m.parentNode) {
    let v = Va.get(m);
    if (v instanceof ng)
      p.push({ node: m, deco: v.mark });
    else {
      if (v instanceof qo || m.nodeName == "DIV" && m.parentNode == t.contentDOM)
        return { range: f, text: a, marks: p, line: m };
      if (m != t.contentDOM)
        p.push({ node: m, deco: new y_({
          inclusive: !0,
          attributes: gNe(m),
          tagName: m.tagName.toLowerCase()
        }) });
      else
        return null;
    }
  }
}
function RNe(t, e) {
  return t.nodeType != 1 ? 0 : (e && t.childNodes[e - 1].contentEditable == "false" ? 1 : 0) | (e < t.childNodes.length && t.childNodes[e].contentEditable == "false" ? 2 : 0);
}
let INe = class {
  constructor() {
    this.changes = [];
  }
  compareRange(e, n) {
    g4(e, n, this.changes);
  }
  comparePoint(e, n) {
    g4(e, n, this.changes);
  }
};
function DNe(t, e, n) {
  let r = new INe();
  return ta.compare(t, e, n, r), r.changes;
}
function NNe(t, e) {
  for (let n = t; n && n != e; n = n.assignedSlot || n.parentNode)
    if (n.nodeType == 1 && n.contentEditable == "false")
      return !0;
  return !1;
}
function PNe(t, e) {
  let n = !1;
  return e && t.iterChangedRanges((r, a) => {
    r < e.to && a > e.from && (n = !0);
  }), n;
}
function LNe(t, e, n = 1) {
  let r = t.charCategorizer(e), a = t.doc.lineAt(e), i = e - a.from;
  if (a.length == 0)
    return ft.cursor(e);
  i == 0 ? n = 1 : i == a.length && (n = -1);
  let o = i, s = i;
  n < 0 ? o = nl(a.text, i, !1) : s = nl(a.text, i);
  let u = r(a.text.slice(o, s));
  for (; o > 0; ) {
    let f = nl(a.text, o, !1);
    if (r(a.text.slice(f, o)) != u)
      break;
    o = f;
  }
  for (; s < a.length; ) {
    let f = nl(a.text, s);
    if (r(a.text.slice(s, f)) != u)
      break;
    s = f;
  }
  return ft.range(o + a.from, s + a.from);
}
function MNe(t, e) {
  return e.left > t ? e.left - t : Math.max(0, t - e.right);
}
function FNe(t, e) {
  return e.top > t ? e.top - t : Math.max(0, t - e.bottom);
}
function a3(t, e) {
  return t.top < e.bottom - 1 && t.bottom > e.top + 1;
}
function RX(t, e) {
  return e < t.top ? { top: e, left: t.left, right: t.right, bottom: t.bottom } : t;
}
function IX(t, e) {
  return e > t.bottom ? { top: t.top, left: t.left, right: t.right, bottom: e } : t;
}
function E4(t, e, n) {
  let r, a, i, o, s = !1, u, f, p, m;
  for (let w = t.firstChild; w; w = w.nextSibling) {
    let _ = QE(w);
    for (let C = 0; C < _.length; C++) {
      let A = _[C];
      a && a3(a, A) && (A = RX(IX(A, a.bottom), a.top));
      let N = MNe(e, A), P = FNe(n, A);
      if (N == 0 && P == 0)
        return w.nodeType == 3 ? DX(w, e, n) : E4(w, e, n);
      if (!r || o > P || o == P && i > N) {
        r = w, a = A, i = N, o = P;
        let I = P ? n < A.top ? -1 : 1 : N ? e < A.left ? -1 : 1 : 0;
        s = !I || (I > 0 ? C < _.length - 1 : C > 0);
      }
      N == 0 ? n > A.bottom && (!p || p.bottom < A.bottom) ? (u = w, p = A) : n < A.top && (!m || m.top > A.top) && (f = w, m = A) : p && a3(p, A) ? p = IX(p, A.bottom) : m && a3(m, A) && (m = RX(m, A.top));
    }
  }
  if (p && p.bottom >= n ? (r = u, a = p) : m && m.top <= n && (r = f, a = m), !r)
    return { node: t, offset: 0 };
  let v = Math.max(a.left, Math.min(a.right, e));
  if (r.nodeType == 3)
    return DX(r, v, n);
  if (s && r.contentEditable != "false")
    return E4(r, v, n);
  let O = Array.prototype.indexOf.call(t.childNodes, r) + (e >= (a.left + a.right) / 2 ? 1 : 0);
  return { node: t, offset: O };
}
function DX(t, e, n) {
  let r = t.nodeValue.length, a = -1, i = 1e9, o = 0;
  for (let s = 0; s < r; s++) {
    let u = d0(t, s, s + 1).getClientRects();
    for (let f = 0; f < u.length; f++) {
      let p = u[f];
      if (p.top == p.bottom)
        continue;
      o || (o = e - p.left);
      let m = (p.top > n ? p.top - n : n - p.bottom) - 1;
      if (p.left - 1 <= e && p.right + 1 >= e && m < i) {
        let v = e >= (p.left + p.right) / 2, O = v;
        if ((vn.chrome || vn.gecko) && d0(t, s).getBoundingClientRect().left == p.right && (O = !v), m <= 0)
          return { node: t, offset: s + (O ? 1 : 0) };
        a = s + (O ? 1 : 0), i = m;
      }
    }
  }
  return { node: t, offset: a > -1 ? a : o > 0 ? t.nodeValue.length : 0 };
}
function cie(t, e, n, r = -1) {
  var a, i;
  let o = t.contentDOM.getBoundingClientRect(), s = o.top + t.viewState.paddingTop, u, { docHeight: f } = t.viewState, { x: p, y: m } = e, v = m - s;
  if (v < 0)
    return 0;
  if (v > f)
    return t.state.doc.length;
  for (let I = t.viewState.heightOracle.textHeight / 2, D = !1; u = t.elementAtHeight(v), u.type != du.Text; )
    for (; v = r > 0 ? u.bottom + I : u.top - I, !(v >= 0 && v <= f); ) {
      if (D)
        return n ? null : 0;
      D = !0, r = -r;
    }
  m = s + v;
  let O = u.from;
  if (O < t.viewport.from)
    return t.viewport.from == 0 ? 0 : n ? null : NX(t, o, u, p, m);
  if (O > t.viewport.to)
    return t.viewport.to == t.state.doc.length ? t.state.doc.length : n ? null : NX(t, o, u, p, m);
  let w = t.dom.ownerDocument, _ = t.root.elementFromPoint ? t.root : w, C = _.elementFromPoint(p, m);
  C && !t.contentDOM.contains(C) && (C = null), C || (p = Math.max(o.left + 1, Math.min(o.right - 1, p)), C = _.elementFromPoint(p, m), C && !t.contentDOM.contains(C) && (C = null));
  let A, N = -1;
  if (C && ((a = t.docView.nearest(C)) === null || a === void 0 ? void 0 : a.isEditable) != !1) {
    if (w.caretPositionFromPoint) {
      let I = w.caretPositionFromPoint(p, m);
      I && ({ offsetNode: A, offset: N } = I);
    } else if (w.caretRangeFromPoint) {
      let I = w.caretRangeFromPoint(p, m);
      I && ({ startContainer: A, startOffset: N } = I, (!t.contentDOM.contains(A) || vn.safari && $Ne(A, N, p) || vn.chrome && BNe(A, N, p)) && (A = void 0));
    }
  }
  if (!A || !t.docView.dom.contains(A)) {
    let I = qo.find(t.docView, O);
    if (!I)
      return v > u.top + u.height / 2 ? u.to : u.from;
    ({ node: A, offset: N } = E4(I.dom, p, m));
  }
  let P = t.docView.nearest(A);
  if (!P)
    return null;
  if (P.isWidget && ((i = P.dom) === null || i === void 0 ? void 0 : i.nodeType) == 1) {
    let I = P.dom.getBoundingClientRect();
    return e.y < I.top || e.y <= I.bottom && e.x <= (I.left + I.right) / 2 ? P.posAtStart : P.posAtEnd;
  } else
    return P.localPosFromDOM(A, N) + P.posAtStart;
}
function NX(t, e, n, r, a) {
  let i = Math.round((r - e.left) * t.defaultCharacterWidth);
  if (t.lineWrapping && n.height > t.defaultLineHeight * 1.5) {
    let s = t.viewState.heightOracle.textHeight, u = Math.floor((a - n.top - (t.defaultLineHeight - s) * 0.5) / s);
    i += u * t.viewState.heightOracle.lineLength;
  }
  let o = t.state.sliceDoc(n.from, n.to);
  return n.from + s4(o, i, t.state.tabSize);
}
function $Ne(t, e, n) {
  let r;
  if (t.nodeType != 3 || e != (r = t.nodeValue.length))
    return !1;
  for (let a = t.nextSibling; a; a = a.nextSibling)
    if (a.nodeType != 1 || a.nodeName != "BR")
      return !1;
  return d0(t, r - 1, r).getBoundingClientRect().left > n;
}
function BNe(t, e, n) {
  if (e != 0)
    return !1;
  for (let a = t; ; ) {
    let i = a.parentNode;
    if (!i || i.nodeType != 1 || i.firstChild != a)
      return !1;
    if (i.classList.contains("cm-line"))
      break;
    a = i;
  }
  let r = t.nodeType == 1 ? t.getBoundingClientRect() : d0(t, 0, Math.max(t.nodeValue.length, 1)).getBoundingClientRect();
  return n - r.left > 5;
}
function S4(t, e) {
  let n = t.lineBlockAt(e);
  if (Array.isArray(n.type)) {
    for (let r of n.type)
      if (r.to > e || r.to == e && (r.to == n.to || r.type == du.Text))
        return r;
  }
  return n;
}
function UNe(t, e, n, r) {
  let a = S4(t, e.head), i = !r || a.type != du.Text || !(t.lineWrapping || a.widgetLineBreaks) ? null : t.coordsAtPos(e.assoc < 0 && e.head > a.from ? e.head - 1 : e.head);
  if (i) {
    let o = t.dom.getBoundingClientRect(), s = t.textDirectionAt(a.from), u = t.posAtCoords({
      x: n == (s == hi.LTR) ? o.right - 1 : o.left + 1,
      y: (i.top + i.bottom) / 2
    });
    if (u != null)
      return ft.cursor(u, n ? -1 : 1);
  }
  return ft.cursor(n ? a.to : a.from, n ? -1 : 1);
}
function PX(t, e, n, r) {
  let a = t.state.doc.lineAt(e.head), i = t.bidiSpans(a), o = t.textDirectionAt(a.from);
  for (let s = e, u = null; ; ) {
    let f = _Ne(a, i, o, s, n), p = Yae;
    if (!f) {
      if (a.number == (n ? t.state.doc.lines : 1))
        return s;
      p = `
`, a = t.state.doc.line(a.number + (n ? 1 : -1)), i = t.bidiSpans(a), f = t.visualLineSide(a, !n);
    }
    if (u) {
      if (!u(p))
        return s;
    } else {
      if (!r)
        return f;
      u = r(p);
    }
    s = f;
  }
}
function zNe(t, e, n) {
  let r = t.state.charCategorizer(e), a = r(n);
  return (i) => {
    let o = r(i);
    return a == Si.Space && (a = o), a == o;
  };
}
function HNe(t, e, n, r) {
  let a = e.head, i = n ? 1 : -1;
  if (a == (n ? t.state.doc.length : 0))
    return ft.cursor(a, e.assoc);
  let o = e.goalColumn, s, u = t.contentDOM.getBoundingClientRect(), f = t.coordsAtPos(a, e.assoc || -1), p = t.documentTop;
  if (f)
    o == null && (o = f.left - u.left), s = i < 0 ? f.top : f.bottom;
  else {
    let O = t.viewState.lineBlockAt(a);
    o == null && (o = Math.min(u.right - u.left, t.defaultCharacterWidth * (a - O.from))), s = (i < 0 ? O.top : O.bottom) + p;
  }
  let m = u.left + o, v = r ?? t.viewState.heightOracle.textHeight >> 1;
  for (let O = 0; ; O += 10) {
    let w = s + (v + O) * i, _ = cie(t, { x: m, y: w }, !1, i);
    if (w < u.top || w > u.bottom || (i < 0 ? _ < a : _ > a)) {
      let C = t.docView.coordsForChar(_), A = !C || w < C.top ? -1 : 1;
      return ft.cursor(_, A, void 0, o);
    }
  }
}
function wk(t, e, n) {
  for (; ; ) {
    let r = 0;
    for (let a of t)
      a.between(e - 1, e + 1, (i, o, s) => {
        if (e > i && e < o) {
          let u = r || n || (e - i < o - e ? -1 : 1);
          e = u < 0 ? i : o, r = u;
        }
      });
    if (!r)
      return e;
  }
}
function i3(t, e, n) {
  let r = wk(t.state.facet(jU).map((a) => a(t)), n.from, e.head > n.from ? -1 : 1);
  return r == n.from ? n : ft.cursor(r, r < n.from ? 1 : -1);
}
class WNe {
  setSelectionOrigin(e) {
    this.lastSelectionOrigin = e, this.lastSelectionTime = Date.now();
  }
  constructor(e) {
    this.view = e, this.lastKeyCode = 0, this.lastKeyTime = 0, this.lastTouchTime = 0, this.lastFocusTime = 0, this.lastScrollTop = 0, this.lastScrollLeft = 0, this.pendingIOSKey = void 0, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastEscPress = 0, this.lastContextMenu = 0, this.scrollHandlers = [], this.handlers = /* @__PURE__ */ Object.create(null), this.composing = -1, this.compositionFirstChange = null, this.compositionEndedAt = 0, this.compositionPendingKey = !1, this.compositionPendingChange = !1, this.mouseSelection = null, this.draggedContent = null, this.handleEvent = this.handleEvent.bind(this), this.notifiedFocused = e.hasFocus, vn.safari && e.contentDOM.addEventListener("input", () => null), vn.gecko && i2e(e.contentDOM.ownerDocument);
  }
  handleEvent(e) {
    !qNe(this.view, e) || this.ignoreDuringComposition(e) || e.type == "keydown" && this.keydown(e) || this.runHandlers(e.type, e);
  }
  runHandlers(e, n) {
    let r = this.handlers[e];
    if (r) {
      for (let a of r.observers)
        a(this.view, n);
      for (let a of r.handlers) {
        if (n.defaultPrevented)
          break;
        if (a(this.view, n)) {
          n.preventDefault();
          break;
        }
      }
    }
  }
  ensureHandlers(e) {
    let n = QNe(e), r = this.handlers, a = this.view.contentDOM;
    for (let i in n)
      if (i != "scroll") {
        let o = !n[i].handlers.length, s = r[i];
        s && o != !s.handlers.length && (a.removeEventListener(i, this.handleEvent), s = null), s || a.addEventListener(i, this.handleEvent, { passive: o });
      }
    for (let i in r)
      i != "scroll" && !n[i] && a.removeEventListener(i, this.handleEvent);
    this.handlers = n;
  }
  keydown(e) {
    if (this.lastKeyCode = e.keyCode, this.lastKeyTime = Date.now(), e.keyCode == 9 && Date.now() < this.lastEscPress + 2e3)
      return !0;
    if (e.keyCode != 27 && die.indexOf(e.keyCode) < 0 && (this.view.inputState.lastEscPress = 0), vn.android && vn.chrome && !e.synthetic && (e.keyCode == 13 || e.keyCode == 8))
      return this.view.observer.delayAndroidKey(e.key, e.keyCode), !0;
    let n;
    return vn.ios && !e.synthetic && !e.altKey && !e.metaKey && ((n = fie.find((r) => r.keyCode == e.keyCode)) && !e.ctrlKey || jNe.indexOf(e.key) > -1 && e.ctrlKey && !e.shiftKey) ? (this.pendingIOSKey = n || e, setTimeout(() => this.flushIOSKey(), 250), !0) : (e.keyCode != 229 && this.view.observer.forceFlush(), !1);
  }
  flushIOSKey(e) {
    let n = this.pendingIOSKey;
    return !n || n.key == "Enter" && e && e.from < e.to && /^\S+$/.test(e.insert.toString()) ? !1 : (this.pendingIOSKey = void 0, AE(this.view.contentDOM, n.key, n.keyCode, n instanceof KeyboardEvent ? n : void 0));
  }
  ignoreDuringComposition(e) {
    return /^key/.test(e.type) ? this.composing > 0 ? !0 : vn.safari && !vn.ios && this.compositionPendingKey && Date.now() - this.compositionEndedAt < 100 ? (this.compositionPendingKey = !1, !0) : !1 : !1;
  }
  startMouseSelection(e) {
    this.mouseSelection && this.mouseSelection.destroy(), this.mouseSelection = e;
  }
  update(e) {
    this.mouseSelection && this.mouseSelection.update(e), this.draggedContent && e.docChanged && (this.draggedContent = this.draggedContent.map(e.changes)), e.transactions.length && (this.lastKeyCode = this.lastSelectionTime = 0);
  }
  destroy() {
    this.mouseSelection && this.mouseSelection.destroy();
  }
}
function LX(t, e) {
  return (n, r) => {
    try {
      return e.call(t, r, n);
    } catch (a) {
      Ku(n.state, a);
    }
  };
}
function QNe(t) {
  let e = /* @__PURE__ */ Object.create(null);
  function n(r) {
    return e[r] || (e[r] = { observers: [], handlers: [] });
  }
  for (let r of t) {
    let a = r.spec;
    if (a && a.domEventHandlers)
      for (let i in a.domEventHandlers) {
        let o = a.domEventHandlers[i];
        o && n(i).handlers.push(LX(r.value, o));
      }
    if (a && a.domEventObservers)
      for (let i in a.domEventObservers) {
        let o = a.domEventObservers[i];
        o && n(i).observers.push(LX(r.value, o));
      }
  }
  for (let r in Kd)
    n(r).handlers.push(Kd[r]);
  for (let r in Zf)
    n(r).observers.push(Zf[r]);
  return e;
}
const fie = [
  { key: "Backspace", keyCode: 8, inputType: "deleteContentBackward" },
  { key: "Enter", keyCode: 13, inputType: "insertParagraph" },
  { key: "Enter", keyCode: 13, inputType: "insertLineBreak" },
  { key: "Delete", keyCode: 46, inputType: "deleteContentForward" }
], jNe = "dthko", die = [16, 17, 18, 20, 91, 92, 224, 225], Hx = 6;
function Wx(t) {
  return Math.max(0, t) * 0.7 + 8;
}
function GNe(t, e) {
  return Math.max(Math.abs(t.clientX - e.clientX), Math.abs(t.clientY - e.clientY));
}
class VNe {
  constructor(e, n, r, a) {
    this.view = e, this.startEvent = n, this.style = r, this.mustSelect = a, this.scrollSpeed = { x: 0, y: 0 }, this.scrolling = -1, this.lastEvent = n, this.scrollParent = uNe(e.contentDOM), this.atoms = e.state.facet(jU).map((o) => o(e));
    let i = e.contentDOM.ownerDocument;
    i.addEventListener("mousemove", this.move = this.move.bind(this)), i.addEventListener("mouseup", this.up = this.up.bind(this)), this.extend = n.shiftKey, this.multiple = e.state.facet(zr.allowMultipleSelections) && YNe(e, n), this.dragging = XNe(e, n) && gie(n) == 1 ? null : !1;
  }
  start(e) {
    this.dragging === !1 && this.select(e);
  }
  move(e) {
    var n;
    if (e.buttons == 0)
      return this.destroy();
    if (this.dragging || this.dragging == null && GNe(this.startEvent, e) < 10)
      return;
    this.select(this.lastEvent = e);
    let r = 0, a = 0, i = ((n = this.scrollParent) === null || n === void 0 ? void 0 : n.getBoundingClientRect()) || { left: 0, top: 0, right: this.view.win.innerWidth, bottom: this.view.win.innerHeight }, o = lie(this.view);
    e.clientX - o.left <= i.left + Hx ? r = -Wx(i.left - e.clientX) : e.clientX + o.right >= i.right - Hx && (r = Wx(e.clientX - i.right)), e.clientY - o.top <= i.top + Hx ? a = -Wx(i.top - e.clientY) : e.clientY + o.bottom >= i.bottom - Hx && (a = Wx(e.clientY - i.bottom)), this.setScrollSpeed(r, a);
  }
  up(e) {
    this.dragging == null && this.select(this.lastEvent), this.dragging || e.preventDefault(), this.destroy();
  }
  destroy() {
    this.setScrollSpeed(0, 0);
    let e = this.view.contentDOM.ownerDocument;
    e.removeEventListener("mousemove", this.move), e.removeEventListener("mouseup", this.up), this.view.inputState.mouseSelection = this.view.inputState.draggedContent = null;
  }
  setScrollSpeed(e, n) {
    this.scrollSpeed = { x: e, y: n }, e || n ? this.scrolling < 0 && (this.scrolling = setInterval(() => this.scroll(), 50)) : this.scrolling > -1 && (clearInterval(this.scrolling), this.scrolling = -1);
  }
  scroll() {
    this.scrollParent ? (this.scrollParent.scrollLeft += this.scrollSpeed.x, this.scrollParent.scrollTop += this.scrollSpeed.y) : this.view.win.scrollBy(this.scrollSpeed.x, this.scrollSpeed.y), this.dragging === !1 && this.select(this.lastEvent);
  }
  skipAtoms(e) {
    let n = null;
    for (let r = 0; r < e.ranges.length; r++) {
      let a = e.ranges[r], i = null;
      if (a.empty) {
        let o = wk(this.atoms, a.from, 0);
        o != a.from && (i = ft.cursor(o, -1));
      } else {
        let o = wk(this.atoms, a.from, -1), s = wk(this.atoms, a.to, 1);
        (o != a.from || s != a.to) && (i = ft.range(a.from == a.anchor ? o : s, a.from == a.head ? o : s));
      }
      i && (n || (n = e.ranges.slice()), n[r] = i);
    }
    return n ? ft.create(n, e.mainIndex) : e;
  }
  select(e) {
    let { view: n } = this, r = this.skipAtoms(this.style.get(e, this.extend, this.multiple));
    (this.mustSelect || !r.eq(n.state.selection, this.dragging === !1)) && this.view.dispatch({
      selection: r,
      userEvent: "select.pointer"
    }), this.mustSelect = !1;
  }
  update(e) {
    this.style.update(e) && setTimeout(() => this.select(this.lastEvent), 20);
  }
}
function YNe(t, e) {
  let n = t.state.facet(Zae);
  return n.length ? n[0](e) : vn.mac ? e.metaKey : e.ctrlKey;
}
function ZNe(t, e) {
  let n = t.state.facet(Xae);
  return n.length ? n[0](e) : vn.mac ? !e.altKey : !e.ctrlKey;
}
function XNe(t, e) {
  let { main: n } = t.state.selection;
  if (n.empty)
    return !1;
  let r = rI(t.root);
  if (!r || r.rangeCount == 0)
    return !0;
  let a = r.getRangeAt(0).getClientRects();
  for (let i = 0; i < a.length; i++) {
    let o = a[i];
    if (o.left <= e.clientX && o.right >= e.clientX && o.top <= e.clientY && o.bottom >= e.clientY)
      return !0;
  }
  return !1;
}
function qNe(t, e) {
  if (!e.bubbles)
    return !0;
  if (e.defaultPrevented)
    return !1;
  for (let n = e.target, r; n != t.contentDOM; n = n.parentNode)
    if (!n || n.nodeType == 11 || (r = Va.get(n)) && r.ignoreEvent(e))
      return !1;
  return !0;
}
const Kd = /* @__PURE__ */ Object.create(null), Zf = /* @__PURE__ */ Object.create(null), pie = vn.ie && vn.ie_version < 15 || vn.ios && vn.webkit_version < 604;
function KNe(t) {
  let e = t.dom.parentNode;
  if (!e)
    return;
  let n = e.appendChild(document.createElement("textarea"));
  n.style.cssText = "position: fixed; left: -10000px; top: 10px", n.focus(), setTimeout(() => {
    t.focus(), n.remove(), hie(t, n.value);
  }, 50);
}
function hie(t, e) {
  let { state: n } = t, r, a = 1, i = n.toText(e), o = i.lines == n.selection.ranges.length;
  if (w4 != null && n.selection.ranges.every((u) => u.empty) && w4 == i.toString()) {
    let u = -1;
    r = n.changeByRange((f) => {
      let p = n.doc.lineAt(f.from);
      if (p.from == u)
        return { range: f };
      u = p.from;
      let m = n.toText((o ? i.line(a++).text : e) + n.lineBreak);
      return {
        changes: { from: p.from, insert: m },
        range: ft.cursor(f.from + m.length)
      };
    });
  } else
    o ? r = n.changeByRange((u) => {
      let f = i.line(a++);
      return {
        changes: { from: u.from, to: u.to, insert: f.text },
        range: ft.cursor(u.from + f.length)
      };
    }) : r = n.replaceSelection(i);
  t.dispatch(r, {
    userEvent: "input.paste",
    scrollIntoView: !0
  });
}
Zf.scroll = (t) => {
  t.inputState.lastScrollTop = t.scrollDOM.scrollTop, t.inputState.lastScrollLeft = t.scrollDOM.scrollLeft;
};
Kd.keydown = (t, e) => (t.inputState.setSelectionOrigin("select"), e.keyCode == 27 && (t.inputState.lastEscPress = Date.now()), !1);
Zf.touchstart = (t, e) => {
  t.inputState.lastTouchTime = Date.now(), t.inputState.setSelectionOrigin("select.pointer");
};
Zf.touchmove = (t) => {
  t.inputState.setSelectionOrigin("select.pointer");
};
Kd.mousedown = (t, e) => {
  if (t.observer.flush(), t.inputState.lastTouchTime > Date.now() - 2e3)
    return !1;
  let n = null;
  for (let r of t.state.facet(qae))
    if (n = r(t, e), n)
      break;
  if (!n && e.button == 0 && (n = t2e(t, e)), n) {
    let r = !t.hasFocus;
    t.inputState.startMouseSelection(new VNe(t, e, n, r)), r && t.observer.ignore(() => Rae(t.contentDOM));
    let a = t.inputState.mouseSelection;
    if (a)
      return a.start(e), a.dragging === !1;
  }
  return !1;
};
function MX(t, e, n, r) {
  if (r == 1)
    return ft.cursor(e, n);
  if (r == 2)
    return LNe(t.state, e, n);
  {
    let a = qo.find(t.docView, e), i = t.state.doc.lineAt(a ? a.posAtEnd : e), o = a ? a.posAtStart : i.from, s = a ? a.posAtEnd : i.to;
    return s < t.state.doc.length && s == i.to && s++, ft.range(o, s);
  }
}
let mie = (t, e) => t >= e.top && t <= e.bottom, FX = (t, e, n) => mie(e, n) && t >= n.left && t <= n.right;
function JNe(t, e, n, r) {
  let a = qo.find(t.docView, e);
  if (!a)
    return 1;
  let i = e - a.posAtStart;
  if (i == 0)
    return 1;
  if (i == a.length)
    return -1;
  let o = a.coordsAt(i, -1);
  if (o && FX(n, r, o))
    return -1;
  let s = a.coordsAt(i, 1);
  return s && FX(n, r, s) ? 1 : o && mie(r, o) ? -1 : 1;
}
function $X(t, e) {
  let n = t.posAtCoords({ x: e.clientX, y: e.clientY }, !1);
  return { pos: n, bias: JNe(t, n, e.clientX, e.clientY) };
}
const e2e = vn.ie && vn.ie_version <= 11;
let BX = null, UX = 0, zX = 0;
function gie(t) {
  if (!e2e)
    return t.detail;
  let e = BX, n = zX;
  return BX = t, zX = Date.now(), UX = !e || n > Date.now() - 400 && Math.abs(e.clientX - t.clientX) < 2 && Math.abs(e.clientY - t.clientY) < 2 ? (UX + 1) % 3 : 1;
}
function t2e(t, e) {
  let n = $X(t, e), r = gie(e), a = t.state.selection;
  return {
    update(i) {
      i.docChanged && (n.pos = i.changes.mapPos(n.pos), a = a.map(i.changes));
    },
    get(i, o, s) {
      let u = $X(t, i), f, p = MX(t, u.pos, u.bias, r);
      if (n.pos != u.pos && !o) {
        let m = MX(t, n.pos, n.bias, r), v = Math.min(m.from, p.from), O = Math.max(m.to, p.to);
        p = v < p.from ? ft.range(v, O) : ft.range(O, v);
      }
      return o ? a.replaceRange(a.main.extend(p.from, p.to)) : s && r == 1 && a.ranges.length > 1 && (f = n2e(a, u.pos)) ? f : s ? a.addRange(p) : ft.create([p]);
    }
  };
}
function n2e(t, e) {
  for (let n = 0; n < t.ranges.length; n++) {
    let { from: r, to: a } = t.ranges[n];
    if (r <= e && a >= e)
      return ft.create(t.ranges.slice(0, n).concat(t.ranges.slice(n + 1)), t.mainIndex == n ? 0 : t.mainIndex - (t.mainIndex > n ? 1 : 0));
  }
  return null;
}
Kd.dragstart = (t, e) => {
  let { selection: { main: n } } = t.state;
  if (e.target.draggable) {
    let a = t.docView.nearest(e.target);
    if (a && a.isWidget) {
      let i = a.posAtStart, o = i + a.length;
      (i >= n.to || o <= n.from) && (n = ft.range(i, o));
    }
  }
  let { inputState: r } = t;
  return r.mouseSelection && (r.mouseSelection.dragging = !0), r.draggedContent = n, e.dataTransfer && (e.dataTransfer.setData("Text", t.state.sliceDoc(n.from, n.to)), e.dataTransfer.effectAllowed = "copyMove"), !1;
};
Kd.dragend = (t) => (t.inputState.draggedContent = null, !1);
function HX(t, e, n, r) {
  if (!n)
    return;
  let a = t.posAtCoords({ x: e.clientX, y: e.clientY }, !1), { draggedContent: i } = t.inputState, o = r && i && ZNe(t, e) ? { from: i.from, to: i.to } : null, s = { from: a, insert: n }, u = t.state.changes(o ? [o, s] : s);
  t.focus(), t.dispatch({
    changes: u,
    selection: { anchor: u.mapPos(a, -1), head: u.mapPos(a, 1) },
    userEvent: o ? "move.drop" : "input.drop"
  }), t.inputState.draggedContent = null;
}
Kd.drop = (t, e) => {
  if (!e.dataTransfer)
    return !1;
  if (t.state.readOnly)
    return !0;
  let n = e.dataTransfer.files;
  if (n && n.length) {
    let r = Array(n.length), a = 0, i = () => {
      ++a == n.length && HX(t, e, r.filter((o) => o != null).join(t.state.lineBreak), !1);
    };
    for (let o = 0; o < n.length; o++) {
      let s = new FileReader();
      s.onerror = i, s.onload = () => {
        /[\x00-\x08\x0e-\x1f]{2}/.test(s.result) || (r[o] = s.result), i();
      }, s.readAsText(n[o]);
    }
    return !0;
  } else {
    let r = e.dataTransfer.getData("Text");
    if (r)
      return HX(t, e, r, !0), !0;
  }
  return !1;
};
Kd.paste = (t, e) => {
  if (t.state.readOnly)
    return !0;
  t.observer.flush();
  let n = pie ? null : e.clipboardData;
  return n ? (hie(t, n.getData("text/plain") || n.getData("text/uri-list")), !0) : (KNe(t), !1);
};
function r2e(t, e) {
  let n = t.dom.parentNode;
  if (!n)
    return;
  let r = n.appendChild(document.createElement("textarea"));
  r.style.cssText = "position: fixed; left: -10000px; top: 10px", r.value = e, r.focus(), r.selectionEnd = e.length, r.selectionStart = 0, setTimeout(() => {
    r.remove(), t.focus();
  }, 50);
}
function a2e(t) {
  let e = [], n = [], r = !1;
  for (let a of t.selection.ranges)
    a.empty || (e.push(t.sliceDoc(a.from, a.to)), n.push(a));
  if (!e.length) {
    let a = -1;
    for (let { from: i } of t.selection.ranges) {
      let o = t.doc.lineAt(i);
      o.number > a && (e.push(o.text), n.push({ from: o.from, to: Math.min(t.doc.length, o.to + 1) })), a = o.number;
    }
    r = !0;
  }
  return { text: e.join(t.lineBreak), ranges: n, linewise: r };
}
let w4 = null;
Kd.copy = Kd.cut = (t, e) => {
  let { text: n, ranges: r, linewise: a } = a2e(t.state);
  if (!n && !a)
    return !1;
  w4 = a ? n : null, e.type == "cut" && !t.state.readOnly && t.dispatch({
    changes: r,
    scrollIntoView: !0,
    userEvent: "delete.cut"
  });
  let i = pie ? null : e.clipboardData;
  return i ? (i.clearData(), i.setData("text/plain", n), !0) : (r2e(t, n), !1);
};
const bie = /* @__PURE__ */ Ih.define();
function vie(t, e) {
  let n = [];
  for (let r of t.facet(eie)) {
    let a = r(t, e);
    a && n.push(a);
  }
  return n ? t.update({ effects: n, annotations: bie.of(!0) }) : null;
}
function yie(t) {
  setTimeout(() => {
    let e = t.hasFocus;
    if (e != t.inputState.notifiedFocused) {
      let n = vie(t.state, e);
      n ? t.dispatch(n) : t.update([]);
    }
  }, 10);
}
Zf.focus = (t) => {
  t.inputState.lastFocusTime = Date.now(), !t.scrollDOM.scrollTop && (t.inputState.lastScrollTop || t.inputState.lastScrollLeft) && (t.scrollDOM.scrollTop = t.inputState.lastScrollTop, t.scrollDOM.scrollLeft = t.inputState.lastScrollLeft), yie(t);
};
Zf.blur = (t) => {
  t.observer.clearSelectionRange(), yie(t);
};
Zf.compositionstart = Zf.compositionupdate = (t) => {
  t.inputState.compositionFirstChange == null && (t.inputState.compositionFirstChange = !0), t.inputState.composing < 0 && (t.inputState.composing = 0);
};
Zf.compositionend = (t) => {
  t.inputState.composing = -1, t.inputState.compositionEndedAt = Date.now(), t.inputState.compositionPendingKey = !0, t.inputState.compositionPendingChange = t.observer.pendingRecords().length > 0, t.inputState.compositionFirstChange = null, vn.chrome && vn.android ? t.observer.flushSoon() : t.inputState.compositionPendingChange ? Promise.resolve().then(() => t.observer.flush()) : setTimeout(() => {
    t.inputState.composing < 0 && t.docView.hasComposition && t.update([]);
  }, 50);
};
Zf.contextmenu = (t) => {
  t.inputState.lastContextMenu = Date.now();
};
Kd.beforeinput = (t, e) => {
  var n;
  let r;
  if (vn.chrome && vn.android && (r = fie.find((a) => a.inputType == e.inputType)) && (t.observer.delayAndroidKey(r.key, r.keyCode), r.key == "Backspace" || r.key == "Delete")) {
    let a = ((n = window.visualViewport) === null || n === void 0 ? void 0 : n.height) || 0;
    setTimeout(() => {
      var i;
      (((i = window.visualViewport) === null || i === void 0 ? void 0 : i.height) || 0) > a + 10 && t.hasFocus && (t.contentDOM.blur(), t.focus());
    }, 100);
  }
  return vn.ios && e.inputType == "deleteContentForward" && t.observer.flushSoon(), vn.safari && e.inputType == "insertText" && t.inputState.composing >= 0 && setTimeout(() => Zf.compositionend(t, e), 20), !1;
};
const WX = /* @__PURE__ */ new Set();
function i2e(t) {
  WX.has(t) || (WX.add(t), t.addEventListener("copy", () => {
  }), t.addEventListener("cut", () => {
  }));
}
const QX = ["pre-wrap", "normal", "pre-line", "break-spaces"];
class o2e {
  constructor(e) {
    this.lineWrapping = e, this.doc = la.empty, this.heightSamples = {}, this.lineHeight = 14, this.charWidth = 7, this.textHeight = 14, this.lineLength = 30, this.heightChanged = !1;
  }
  heightForGap(e, n) {
    let r = this.doc.lineAt(n).number - this.doc.lineAt(e).number + 1;
    return this.lineWrapping && (r += Math.max(0, Math.ceil((n - e - r * this.lineLength * 0.5) / this.lineLength))), this.lineHeight * r;
  }
  heightForLine(e) {
    return this.lineWrapping ? (1 + Math.max(0, Math.ceil((e - this.lineLength) / (this.lineLength - 5)))) * this.lineHeight : this.lineHeight;
  }
  setDoc(e) {
    return this.doc = e, this;
  }
  mustRefreshForWrapping(e) {
    return QX.indexOf(e) > -1 != this.lineWrapping;
  }
  mustRefreshForHeights(e) {
    let n = !1;
    for (let r = 0; r < e.length; r++) {
      let a = e[r];
      a < 0 ? r++ : this.heightSamples[Math.floor(a * 10)] || (n = !0, this.heightSamples[Math.floor(a * 10)] = !0);
    }
    return n;
  }
  refresh(e, n, r, a, i, o) {
    let s = QX.indexOf(e) > -1, u = Math.round(n) != Math.round(this.lineHeight) || this.lineWrapping != s;
    if (this.lineWrapping = s, this.lineHeight = n, this.charWidth = r, this.textHeight = a, this.lineLength = i, u) {
      this.heightSamples = {};
      for (let f = 0; f < o.length; f++) {
        let p = o[f];
        p < 0 ? f++ : this.heightSamples[Math.floor(p * 10)] = !0;
      }
    }
    return u;
  }
}
class s2e {
  constructor(e, n) {
    this.from = e, this.heights = n, this.index = 0;
  }
  get more() {
    return this.index < this.heights.length;
  }
}
class yh {
  /**
  @internal
  */
  constructor(e, n, r, a, i) {
    this.from = e, this.length = n, this.top = r, this.height = a, this._content = i;
  }
  /**
  The type of element this is. When querying lines, this may be
  an array of all the blocks that make up the line.
  */
  get type() {
    return typeof this._content == "number" ? du.Text : Array.isArray(this._content) ? this._content : this._content.type;
  }
  /**
  The end of the element as a document position.
  */
  get to() {
    return this.from + this.length;
  }
  /**
  The bottom position of the element.
  */
  get bottom() {
    return this.top + this.height;
  }
  /**
  If this is a widget block, this will return the widget
  associated with it.
  */
  get widget() {
    return this._content instanceof nv ? this._content.widget : null;
  }
  /**
  If this is a textblock, this holds the number of line breaks
  that appear in widgets inside the block.
  */
  get widgetLineBreaks() {
    return typeof this._content == "number" ? this._content : 0;
  }
  /**
  @internal
  */
  join(e) {
    let n = (Array.isArray(this._content) ? this._content : [this]).concat(Array.isArray(e._content) ? e._content : [e]);
    return new yh(this.from, this.length + e.length, this.top, this.height + e.height, n);
  }
}
var pi = /* @__PURE__ */ function(t) {
  return t[t.ByPos = 0] = "ByPos", t[t.ByHeight = 1] = "ByHeight", t[t.ByPosNoHeight = 2] = "ByPosNoHeight", t;
}(pi || (pi = {}));
const Tk = 1e-3;
class pu {
  constructor(e, n, r = 2) {
    this.length = e, this.height = n, this.flags = r;
  }
  get outdated() {
    return (this.flags & 2) > 0;
  }
  set outdated(e) {
    this.flags = (e ? 2 : 0) | this.flags & -3;
  }
  setHeight(e, n) {
    this.height != n && (Math.abs(this.height - n) > Tk && (e.heightChanged = !0), this.height = n);
  }
  // Base case is to replace a leaf node, which simply builds a tree
  // from the new nodes and returns that (HeightMapBranch and
  // HeightMapGap override this to actually use from/to)
  replace(e, n, r) {
    return pu.of(r);
  }
  // Again, these are base cases, and are overridden for branch and gap nodes.
  decomposeLeft(e, n) {
    n.push(this);
  }
  decomposeRight(e, n) {
    n.push(this);
  }
  applyChanges(e, n, r, a) {
    let i = this, o = r.doc;
    for (let s = a.length - 1; s >= 0; s--) {
      let { fromA: u, toA: f, fromB: p, toB: m } = a[s], v = i.lineAt(u, pi.ByPosNoHeight, r.setDoc(n), 0, 0), O = v.to >= f ? v : i.lineAt(f, pi.ByPosNoHeight, r, 0, 0);
      for (m += O.to - f, f = O.to; s > 0 && v.from <= a[s - 1].toA; )
        u = a[s - 1].fromA, p = a[s - 1].fromB, s--, u < v.from && (v = i.lineAt(u, pi.ByPosNoHeight, r, 0, 0));
      p += v.from - u, u = v.from;
      let w = GU.build(r.setDoc(o), e, p, m);
      i = i.replace(u, f, w);
    }
    return i.updateHeight(r, 0);
  }
  static empty() {
    return new Pc(0, 0);
  }
  // nodes uses null values to indicate the position of line breaks.
  // There are never line breaks at the start or end of the array, or
  // two line breaks next to each other, and the array isn't allowed
  // to be empty (same restrictions as return value from the builder).
  static of(e) {
    if (e.length == 1)
      return e[0];
    let n = 0, r = e.length, a = 0, i = 0;
    for (; ; )
      if (n == r)
        if (a > i * 2) {
          let s = e[n - 1];
          s.break ? e.splice(--n, 1, s.left, null, s.right) : e.splice(--n, 1, s.left, s.right), r += 1 + s.break, a -= s.size;
        } else if (i > a * 2) {
          let s = e[r];
          s.break ? e.splice(r, 1, s.left, null, s.right) : e.splice(r, 1, s.left, s.right), r += 2 + s.break, i -= s.size;
        } else
          break;
      else if (a < i) {
        let s = e[n++];
        s && (a += s.size);
      } else {
        let s = e[--r];
        s && (i += s.size);
      }
    let o = 0;
    return e[n - 1] == null ? (o = 1, n--) : e[n] == null && (o = 1, r++), new l2e(pu.of(e.slice(0, n)), o, pu.of(e.slice(r)));
  }
}
pu.prototype.size = 1;
class Oie extends pu {
  constructor(e, n, r) {
    super(e, n), this.deco = r;
  }
  blockAt(e, n, r, a) {
    return new yh(a, this.length, r, this.height, this.deco || 0);
  }
  lineAt(e, n, r, a, i) {
    return this.blockAt(0, r, a, i);
  }
  forEachLine(e, n, r, a, i, o) {
    e <= i + this.length && n >= i && o(this.blockAt(0, r, a, i));
  }
  updateHeight(e, n = 0, r = !1, a) {
    return a && a.from <= n && a.more && this.setHeight(e, a.heights[a.index++]), this.outdated = !1, this;
  }
  toString() {
    return `block(${this.length})`;
  }
}
class Pc extends Oie {
  constructor(e, n) {
    super(e, n, null), this.collapsed = 0, this.widgetHeight = 0, this.breaks = 0;
  }
  blockAt(e, n, r, a) {
    return new yh(a, this.length, r, this.height, this.breaks);
  }
  replace(e, n, r) {
    let a = r[0];
    return r.length == 1 && (a instanceof Pc || a instanceof Xs && a.flags & 4) && Math.abs(this.length - a.length) < 10 ? (a instanceof Xs ? a = new Pc(a.length, this.height) : a.height = this.height, this.outdated || (a.outdated = !1), a) : pu.of(r);
  }
  updateHeight(e, n = 0, r = !1, a) {
    return a && a.from <= n && a.more ? this.setHeight(e, a.heights[a.index++]) : (r || this.outdated) && this.setHeight(e, Math.max(this.widgetHeight, e.heightForLine(this.length - this.collapsed)) + this.breaks * e.lineHeight), this.outdated = !1, this;
  }
  toString() {
    return `line(${this.length}${this.collapsed ? -this.collapsed : ""}${this.widgetHeight ? ":" + this.widgetHeight : ""})`;
  }
}
class Xs extends pu {
  constructor(e) {
    super(e, 0);
  }
  heightMetrics(e, n) {
    let r = e.doc.lineAt(n).number, a = e.doc.lineAt(n + this.length).number, i = a - r + 1, o, s = 0;
    if (e.lineWrapping) {
      let u = Math.min(this.height, e.lineHeight * i);
      o = u / i, this.length > i + 1 && (s = (this.height - u) / (this.length - i - 1));
    } else
      o = this.height / i;
    return { firstLine: r, lastLine: a, perLine: o, perChar: s };
  }
  blockAt(e, n, r, a) {
    let { firstLine: i, lastLine: o, perLine: s, perChar: u } = this.heightMetrics(n, a);
    if (n.lineWrapping) {
      let f = a + (e < n.lineHeight ? 0 : Math.round(Math.max(0, Math.min(1, (e - r) / this.height)) * this.length)), p = n.doc.lineAt(f), m = s + p.length * u, v = Math.max(r, e - m / 2);
      return new yh(p.from, p.length, v, m, 0);
    } else {
      let f = Math.max(0, Math.min(o - i, Math.floor((e - r) / s))), { from: p, length: m } = n.doc.line(i + f);
      return new yh(p, m, r + s * f, s, 0);
    }
  }
  lineAt(e, n, r, a, i) {
    if (n == pi.ByHeight)
      return this.blockAt(e, r, a, i);
    if (n == pi.ByPosNoHeight) {
      let { from: O, to: w } = r.doc.lineAt(e);
      return new yh(O, w - O, 0, 0, 0);
    }
    let { firstLine: o, perLine: s, perChar: u } = this.heightMetrics(r, i), f = r.doc.lineAt(e), p = s + f.length * u, m = f.number - o, v = a + s * m + u * (f.from - i - m);
    return new yh(f.from, f.length, Math.max(a, Math.min(v, a + this.height - p)), p, 0);
  }
  forEachLine(e, n, r, a, i, o) {
    e = Math.max(e, i), n = Math.min(n, i + this.length);
    let { firstLine: s, perLine: u, perChar: f } = this.heightMetrics(r, i);
    for (let p = e, m = a; p <= n; ) {
      let v = r.doc.lineAt(p);
      if (p == e) {
        let w = v.number - s;
        m += u * w + f * (e - i - w);
      }
      let O = u + f * v.length;
      o(new yh(v.from, v.length, m, O, 0)), m += O, p = v.to + 1;
    }
  }
  replace(e, n, r) {
    let a = this.length - n;
    if (a > 0) {
      let i = r[r.length - 1];
      i instanceof Xs ? r[r.length - 1] = new Xs(i.length + a) : r.push(null, new Xs(a - 1));
    }
    if (e > 0) {
      let i = r[0];
      i instanceof Xs ? r[0] = new Xs(e + i.length) : r.unshift(new Xs(e - 1), null);
    }
    return pu.of(r);
  }
  decomposeLeft(e, n) {
    n.push(new Xs(e - 1), null);
  }
  decomposeRight(e, n) {
    n.push(null, new Xs(this.length - e - 1));
  }
  updateHeight(e, n = 0, r = !1, a) {
    let i = n + this.length;
    if (a && a.from <= n + this.length && a.more) {
      let o = [], s = Math.max(n, a.from), u = -1;
      for (a.from > n && o.push(new Xs(a.from - n - 1).updateHeight(e, n)); s <= i && a.more; ) {
        let p = e.doc.lineAt(s).length;
        o.length && o.push(null);
        let m = a.heights[a.index++];
        u == -1 ? u = m : Math.abs(m - u) >= Tk && (u = -2);
        let v = new Pc(p, m);
        v.outdated = !1, o.push(v), s += p + 1;
      }
      s <= i && o.push(null, new Xs(i - s).updateHeight(e, s));
      let f = pu.of(o);
      return (u < 0 || Math.abs(f.height - this.height) >= Tk || Math.abs(u - this.heightMetrics(e, n).perLine) >= Tk) && (e.heightChanged = !0), f;
    } else
      (r || this.outdated) && (this.setHeight(e, e.heightForGap(n, n + this.length)), this.outdated = !1);
    return this;
  }
  toString() {
    return `gap(${this.length})`;
  }
}
class l2e extends pu {
  constructor(e, n, r) {
    super(e.length + n + r.length, e.height + r.height, n | (e.outdated || r.outdated ? 2 : 0)), this.left = e, this.right = r, this.size = e.size + r.size;
  }
  get break() {
    return this.flags & 1;
  }
  blockAt(e, n, r, a) {
    let i = r + this.left.height;
    return e < i ? this.left.blockAt(e, n, r, a) : this.right.blockAt(e, n, i, a + this.left.length + this.break);
  }
  lineAt(e, n, r, a, i) {
    let o = a + this.left.height, s = i + this.left.length + this.break, u = n == pi.ByHeight ? e < o : e < s, f = u ? this.left.lineAt(e, n, r, a, i) : this.right.lineAt(e, n, r, o, s);
    if (this.break || (u ? f.to < s : f.from > s))
      return f;
    let p = n == pi.ByPosNoHeight ? pi.ByPosNoHeight : pi.ByPos;
    return u ? f.join(this.right.lineAt(s, p, r, o, s)) : this.left.lineAt(s, p, r, a, i).join(f);
  }
  forEachLine(e, n, r, a, i, o) {
    let s = a + this.left.height, u = i + this.left.length + this.break;
    if (this.break)
      e < u && this.left.forEachLine(e, n, r, a, i, o), n >= u && this.right.forEachLine(e, n, r, s, u, o);
    else {
      let f = this.lineAt(u, pi.ByPos, r, a, i);
      e < f.from && this.left.forEachLine(e, f.from - 1, r, a, i, o), f.to >= e && f.from <= n && o(f), n > f.to && this.right.forEachLine(f.to + 1, n, r, s, u, o);
    }
  }
  replace(e, n, r) {
    let a = this.left.length + this.break;
    if (n < a)
      return this.balanced(this.left.replace(e, n, r), this.right);
    if (e > this.left.length)
      return this.balanced(this.left, this.right.replace(e - a, n - a, r));
    let i = [];
    e > 0 && this.decomposeLeft(e, i);
    let o = i.length;
    for (let s of r)
      i.push(s);
    if (e > 0 && jX(i, o - 1), n < this.length) {
      let s = i.length;
      this.decomposeRight(n, i), jX(i, s);
    }
    return pu.of(i);
  }
  decomposeLeft(e, n) {
    let r = this.left.length;
    if (e <= r)
      return this.left.decomposeLeft(e, n);
    n.push(this.left), this.break && (r++, e >= r && n.push(null)), e > r && this.right.decomposeLeft(e - r, n);
  }
  decomposeRight(e, n) {
    let r = this.left.length, a = r + this.break;
    if (e >= a)
      return this.right.decomposeRight(e - a, n);
    e < r && this.left.decomposeRight(e, n), this.break && e < a && n.push(null), n.push(this.right);
  }
  balanced(e, n) {
    return e.size > 2 * n.size || n.size > 2 * e.size ? pu.of(this.break ? [e, null, n] : [e, n]) : (this.left = e, this.right = n, this.height = e.height + n.height, this.outdated = e.outdated || n.outdated, this.size = e.size + n.size, this.length = e.length + this.break + n.length, this);
  }
  updateHeight(e, n = 0, r = !1, a) {
    let { left: i, right: o } = this, s = n + i.length + this.break, u = null;
    return a && a.from <= n + i.length && a.more ? u = i = i.updateHeight(e, n, r, a) : i.updateHeight(e, n, r), a && a.from <= s + o.length && a.more ? u = o = o.updateHeight(e, s, r, a) : o.updateHeight(e, s, r), u ? this.balanced(i, o) : (this.height = this.left.height + this.right.height, this.outdated = !1, this);
  }
  toString() {
    return this.left + (this.break ? " " : "-") + this.right;
  }
}
function jX(t, e) {
  let n, r;
  t[e] == null && (n = t[e - 1]) instanceof Xs && (r = t[e + 1]) instanceof Xs && t.splice(e - 1, 3, new Xs(n.length + 1 + r.length));
}
const u2e = 5;
class GU {
  constructor(e, n) {
    this.pos = e, this.oracle = n, this.nodes = [], this.lineStart = -1, this.lineEnd = -1, this.covering = null, this.writtenTo = e;
  }
  get isCovered() {
    return this.covering && this.nodes[this.nodes.length - 1] == this.covering;
  }
  span(e, n) {
    if (this.lineStart > -1) {
      let r = Math.min(n, this.lineEnd), a = this.nodes[this.nodes.length - 1];
      a instanceof Pc ? a.length += r - this.pos : (r > this.pos || !this.isCovered) && this.nodes.push(new Pc(r - this.pos, -1)), this.writtenTo = r, n > r && (this.nodes.push(null), this.writtenTo++, this.lineStart = -1);
    }
    this.pos = n;
  }
  point(e, n, r) {
    if (e < n || r.heightRelevant) {
      let a = r.widget ? r.widget.estimatedHeight : 0, i = r.widget ? r.widget.lineBreaks : 0;
      a < 0 && (a = this.oracle.lineHeight);
      let o = n - e;
      r.block ? this.addBlock(new Oie(o, a, r)) : (o || i || a >= u2e) && this.addLineDeco(a, i, o);
    } else
      n > e && this.span(e, n);
    this.lineEnd > -1 && this.lineEnd < this.pos && (this.lineEnd = this.oracle.doc.lineAt(this.pos).to);
  }
  enterLine() {
    if (this.lineStart > -1)
      return;
    let { from: e, to: n } = this.oracle.doc.lineAt(this.pos);
    this.lineStart = e, this.lineEnd = n, this.writtenTo < e && ((this.writtenTo < e - 1 || this.nodes[this.nodes.length - 1] == null) && this.nodes.push(this.blankContent(this.writtenTo, e - 1)), this.nodes.push(null)), this.pos > e && this.nodes.push(new Pc(this.pos - e, -1)), this.writtenTo = this.pos;
  }
  blankContent(e, n) {
    let r = new Xs(n - e);
    return this.oracle.doc.lineAt(e).to == n && (r.flags |= 4), r;
  }
  ensureLine() {
    this.enterLine();
    let e = this.nodes.length ? this.nodes[this.nodes.length - 1] : null;
    if (e instanceof Pc)
      return e;
    let n = new Pc(0, -1);
    return this.nodes.push(n), n;
  }
  addBlock(e) {
    this.enterLine();
    let n = e.deco;
    n && n.startSide > 0 && !this.isCovered && this.ensureLine(), this.nodes.push(e), this.writtenTo = this.pos = this.pos + e.length, n && n.endSide > 0 && (this.covering = e);
  }
  addLineDeco(e, n, r) {
    let a = this.ensureLine();
    a.length += r, a.collapsed += r, a.widgetHeight = Math.max(a.widgetHeight, e), a.breaks += n, this.writtenTo = this.pos = this.pos + r;
  }
  finish(e) {
    let n = this.nodes.length == 0 ? null : this.nodes[this.nodes.length - 1];
    this.lineStart > -1 && !(n instanceof Pc) && !this.isCovered ? this.nodes.push(new Pc(0, -1)) : (this.writtenTo < this.pos || n == null) && this.nodes.push(this.blankContent(this.writtenTo, this.pos));
    let r = e;
    for (let a of this.nodes)
      a instanceof Pc && a.updateHeight(this.oracle, r), r += a ? a.length : 1;
    return this.nodes;
  }
  // Always called with a region that on both sides either stretches
  // to a line break or the end of the document.
  // The returned array uses null to indicate line breaks, but never
  // starts or ends in a line break, or has multiple line breaks next
  // to each other.
  static build(e, n, r, a) {
    let i = new GU(r, e);
    return ta.spans(n, r, a, i, 0), i.finish(r);
  }
}
function c2e(t, e, n) {
  let r = new f2e();
  return ta.compare(t, e, n, r, 0), r.changes;
}
class f2e {
  constructor() {
    this.changes = [];
  }
  compareRange() {
  }
  comparePoint(e, n, r, a) {
    (e < n || r && r.heightRelevant || a && a.heightRelevant) && g4(e, n, this.changes, 5);
  }
}
function d2e(t, e) {
  let n = t.getBoundingClientRect(), r = t.ownerDocument, a = r.defaultView || window, i = Math.max(0, n.left), o = Math.min(a.innerWidth, n.right), s = Math.max(0, n.top), u = Math.min(a.innerHeight, n.bottom);
  for (let f = t.parentNode; f && f != r.body; )
    if (f.nodeType == 1) {
      let p = f, m = window.getComputedStyle(p);
      if ((p.scrollHeight > p.clientHeight || p.scrollWidth > p.clientWidth) && m.overflow != "visible") {
        let v = p.getBoundingClientRect();
        i = Math.max(i, v.left), o = Math.min(o, v.right), s = Math.max(s, v.top), u = f == t.parentNode ? v.bottom : Math.min(u, v.bottom);
      }
      f = m.position == "absolute" || m.position == "fixed" ? p.offsetParent : p.parentNode;
    } else if (f.nodeType == 11)
      f = f.host;
    else
      break;
  return {
    left: i - n.left,
    right: Math.max(i, o) - n.left,
    top: s - (n.top + e),
    bottom: Math.max(s, u) - (n.top + e)
  };
}
function p2e(t, e) {
  let n = t.getBoundingClientRect();
  return {
    left: 0,
    right: n.right - n.left,
    top: e,
    bottom: n.bottom - (n.top + e)
  };
}
class o3 {
  constructor(e, n, r) {
    this.from = e, this.to = n, this.size = r;
  }
  static same(e, n) {
    if (e.length != n.length)
      return !1;
    for (let r = 0; r < e.length; r++) {
      let a = e[r], i = n[r];
      if (a.from != i.from || a.to != i.to || a.size != i.size)
        return !1;
    }
    return !0;
  }
  draw(e, n) {
    return Ln.replace({
      widget: new h2e(this.size * (n ? e.scaleY : e.scaleX), n)
    }).range(this.from, this.to);
  }
}
class h2e extends Nh {
  constructor(e, n) {
    super(), this.size = e, this.vertical = n;
  }
  eq(e) {
    return e.size == this.size && e.vertical == this.vertical;
  }
  toDOM() {
    let e = document.createElement("div");
    return this.vertical ? e.style.height = this.size + "px" : (e.style.width = this.size + "px", e.style.height = "2px", e.style.display = "inline-block"), e;
  }
  get estimatedHeight() {
    return this.vertical ? this.size : -1;
  }
}
class GX {
  constructor(e) {
    this.state = e, this.pixelViewport = { left: 0, right: window.innerWidth, top: 0, bottom: 0 }, this.inView = !0, this.paddingTop = 0, this.paddingBottom = 0, this.contentDOMWidth = 0, this.contentDOMHeight = 0, this.editorHeight = 0, this.editorWidth = 0, this.scrollTop = 0, this.scrolledToBottom = !1, this.scaleX = 1, this.scaleY = 1, this.scrollAnchorPos = 0, this.scrollAnchorHeight = -1, this.scaler = VX, this.scrollTarget = null, this.printing = !1, this.mustMeasureContent = !0, this.defaultTextDirection = hi.LTR, this.visibleRanges = [], this.mustEnforceCursorAssoc = !1;
    let n = e.facet(QU).some((r) => typeof r != "function" && r.class == "cm-lineWrapping");
    this.heightOracle = new o2e(n), this.stateDeco = e.facet(zT).filter((r) => typeof r != "function"), this.heightMap = pu.empty().applyChanges(this.stateDeco, la.empty, this.heightOracle.setDoc(e.doc), [new jf(0, 0, 0, e.doc.length)]), this.viewport = this.getViewport(0, null), this.updateViewportLines(), this.updateForViewport(), this.lineGaps = this.ensureLineGaps([]), this.lineGapDeco = Ln.set(this.lineGaps.map((r) => r.draw(this, !1))), this.computeVisibleRanges();
  }
  updateForViewport() {
    let e = [this.viewport], { main: n } = this.state.selection;
    for (let r = 0; r <= 1; r++) {
      let a = r ? n.head : n.anchor;
      if (!e.some(({ from: i, to: o }) => a >= i && a <= o)) {
        let { from: i, to: o } = this.lineBlockAt(a);
        e.push(new Qx(i, o));
      }
    }
    this.viewports = e.sort((r, a) => r.from - a.from), this.scaler = this.heightMap.height <= 7e6 ? VX : new b2e(this.heightOracle, this.heightMap, this.viewports);
  }
  updateViewportLines() {
    this.viewportLines = [], this.heightMap.forEachLine(this.viewport.from, this.viewport.to, this.heightOracle.setDoc(this.state.doc), 0, 0, (e) => {
      this.viewportLines.push(this.scaler.scale == 1 ? e : $w(e, this.scaler));
    });
  }
  update(e, n = null) {
    this.state = e.state;
    let r = this.stateDeco;
    this.stateDeco = this.state.facet(zT).filter((p) => typeof p != "function");
    let a = e.changedRanges, i = jf.extendWithRanges(a, c2e(r, this.stateDeco, e ? e.changes : Ko.empty(this.state.doc.length))), o = this.heightMap.height, s = this.scrolledToBottom ? null : this.scrollAnchorAt(this.scrollTop);
    this.heightMap = this.heightMap.applyChanges(this.stateDeco, e.startState.doc, this.heightOracle.setDoc(this.state.doc), i), this.heightMap.height != o && (e.flags |= 2), s ? (this.scrollAnchorPos = e.changes.mapPos(s.from, -1), this.scrollAnchorHeight = s.top) : (this.scrollAnchorPos = -1, this.scrollAnchorHeight = this.heightMap.height);
    let u = i.length ? this.mapViewport(this.viewport, e.changes) : this.viewport;
    (n && (n.range.head < u.from || n.range.head > u.to) || !this.viewportIsAppropriate(u)) && (u = this.getViewport(0, n));
    let f = !e.changes.empty || e.flags & 2 || u.from != this.viewport.from || u.to != this.viewport.to;
    this.viewport = u, this.updateForViewport(), f && this.updateViewportLines(), (this.lineGaps.length || this.viewport.to - this.viewport.from > 4e3) && this.updateLineGaps(this.ensureLineGaps(this.mapLineGaps(this.lineGaps, e.changes))), e.flags |= this.computeVisibleRanges(), n && (this.scrollTarget = n), !this.mustEnforceCursorAssoc && e.selectionSet && e.view.lineWrapping && e.state.selection.main.empty && e.state.selection.main.assoc && !e.state.facet(nie) && (this.mustEnforceCursorAssoc = !0);
  }
  measure(e) {
    let n = e.contentDOM, r = window.getComputedStyle(n), a = this.heightOracle, i = r.whiteSpace;
    this.defaultTextDirection = r.direction == "rtl" ? hi.RTL : hi.LTR;
    let o = this.heightOracle.mustRefreshForWrapping(i), s = n.getBoundingClientRect(), u = o || this.mustMeasureContent || this.contentDOMHeight != s.height;
    this.contentDOMHeight = s.height, this.mustMeasureContent = !1;
    let f = 0, p = 0;
    if (s.width && s.height) {
      let { scaleX: I, scaleY: D } = kae(n, s);
      (I > 5e-3 && Math.abs(this.scaleX - I) > 5e-3 || D > 5e-3 && Math.abs(this.scaleY - D) > 5e-3) && (this.scaleX = I, this.scaleY = D, f |= 8, o = u = !0);
    }
    let m = (parseInt(r.paddingTop) || 0) * this.scaleY, v = (parseInt(r.paddingBottom) || 0) * this.scaleY;
    (this.paddingTop != m || this.paddingBottom != v) && (this.paddingTop = m, this.paddingBottom = v, f |= 10), this.editorWidth != e.scrollDOM.clientWidth && (a.lineWrapping && (u = !0), this.editorWidth = e.scrollDOM.clientWidth, f |= 8);
    let O = e.scrollDOM.scrollTop * this.scaleY;
    this.scrollTop != O && (this.scrollAnchorHeight = -1, this.scrollTop = O), this.scrolledToBottom = Dae(e.scrollDOM);
    let w = (this.printing ? p2e : d2e)(n, this.paddingTop), _ = w.top - this.pixelViewport.top, C = w.bottom - this.pixelViewport.bottom;
    this.pixelViewport = w;
    let A = this.pixelViewport.bottom > this.pixelViewport.top && this.pixelViewport.right > this.pixelViewport.left;
    if (A != this.inView && (this.inView = A, A && (u = !0)), !this.inView && !this.scrollTarget)
      return 0;
    let N = s.width;
    if ((this.contentDOMWidth != N || this.editorHeight != e.scrollDOM.clientHeight) && (this.contentDOMWidth = s.width, this.editorHeight = e.scrollDOM.clientHeight, f |= 8), u) {
      let I = e.docView.measureVisibleLineHeights(this.viewport);
      if (a.mustRefreshForHeights(I) && (o = !0), o || a.lineWrapping && Math.abs(N - this.contentDOMWidth) > a.charWidth) {
        let { lineHeight: D, charWidth: M, textHeight: H } = e.docView.measureTextSize();
        o = D > 0 && a.refresh(i, D, M, H, N / M, I), o && (e.docView.minWidth = 0, f |= 8);
      }
      _ > 0 && C > 0 ? p = Math.max(_, C) : _ < 0 && C < 0 && (p = Math.min(_, C)), a.heightChanged = !1;
      for (let D of this.viewports) {
        let M = D.from == this.viewport.from ? I : e.docView.measureVisibleLineHeights(D);
        this.heightMap = (o ? pu.empty().applyChanges(this.stateDeco, la.empty, this.heightOracle, [new jf(0, 0, 0, e.state.doc.length)]) : this.heightMap).updateHeight(a, 0, o, new s2e(D.from, M));
      }
      a.heightChanged && (f |= 2);
    }
    let P = !this.viewportIsAppropriate(this.viewport, p) || this.scrollTarget && (this.scrollTarget.range.head < this.viewport.from || this.scrollTarget.range.head > this.viewport.to);
    return P && (this.viewport = this.getViewport(p, this.scrollTarget)), this.updateForViewport(), (f & 2 || P) && this.updateViewportLines(), (this.lineGaps.length || this.viewport.to - this.viewport.from > 4e3) && this.updateLineGaps(this.ensureLineGaps(o ? [] : this.lineGaps, e)), f |= this.computeVisibleRanges(), this.mustEnforceCursorAssoc && (this.mustEnforceCursorAssoc = !1, e.docView.enforceCursorAssoc()), f;
  }
  get visibleTop() {
    return this.scaler.fromDOM(this.pixelViewport.top);
  }
  get visibleBottom() {
    return this.scaler.fromDOM(this.pixelViewport.bottom);
  }
  getViewport(e, n) {
    let r = 0.5 - Math.max(-0.5, Math.min(0.5, e / 1e3 / 2)), a = this.heightMap, i = this.heightOracle, { visibleTop: o, visibleBottom: s } = this, u = new Qx(a.lineAt(o - r * 1e3, pi.ByHeight, i, 0, 0).from, a.lineAt(s + (1 - r) * 1e3, pi.ByHeight, i, 0, 0).to);
    if (n) {
      let { head: f } = n.range;
      if (f < u.from || f > u.to) {
        let p = Math.min(this.editorHeight, this.pixelViewport.bottom - this.pixelViewport.top), m = a.lineAt(f, pi.ByPos, i, 0, 0), v;
        n.y == "center" ? v = (m.top + m.bottom) / 2 - p / 2 : n.y == "start" || n.y == "nearest" && f < u.from ? v = m.top : v = m.bottom - p, u = new Qx(a.lineAt(v - 1e3 / 2, pi.ByHeight, i, 0, 0).from, a.lineAt(v + p + 1e3 / 2, pi.ByHeight, i, 0, 0).to);
      }
    }
    return u;
  }
  mapViewport(e, n) {
    let r = n.mapPos(e.from, -1), a = n.mapPos(e.to, 1);
    return new Qx(this.heightMap.lineAt(r, pi.ByPos, this.heightOracle, 0, 0).from, this.heightMap.lineAt(a, pi.ByPos, this.heightOracle, 0, 0).to);
  }
  // Checks if a given viewport covers the visible part of the
  // document and not too much beyond that.
  viewportIsAppropriate({ from: e, to: n }, r = 0) {
    if (!this.inView)
      return !0;
    let { top: a } = this.heightMap.lineAt(e, pi.ByPos, this.heightOracle, 0, 0), { bottom: i } = this.heightMap.lineAt(n, pi.ByPos, this.heightOracle, 0, 0), { visibleTop: o, visibleBottom: s } = this;
    return (e == 0 || a <= o - Math.max(10, Math.min(
      -r,
      250
      /* VP.MaxCoverMargin */
    ))) && (n == this.state.doc.length || i >= s + Math.max(10, Math.min(
      r,
      250
      /* VP.MaxCoverMargin */
    ))) && a > o - 2 * 1e3 && i < s + 2 * 1e3;
  }
  mapLineGaps(e, n) {
    if (!e.length || n.empty)
      return e;
    let r = [];
    for (let a of e)
      n.touchesRange(a.from, a.to) || r.push(new o3(n.mapPos(a.from), n.mapPos(a.to), a.size));
    return r;
  }
  // Computes positions in the viewport where the start or end of a
  // line should be hidden, trying to reuse existing line gaps when
  // appropriate to avoid unneccesary redraws.
  // Uses crude character-counting for the positioning and sizing,
  // since actual DOM coordinates aren't always available and
  // predictable. Relies on generous margins (see LG.Margin) to hide
  // the artifacts this might produce from the user.
  ensureLineGaps(e, n) {
    let r = this.heightOracle.lineWrapping, a = r ? 1e4 : 2e3, i = a >> 1, o = a << 1;
    if (this.defaultTextDirection != hi.LTR && !r)
      return [];
    let s = [], u = (f, p, m, v) => {
      if (p - f < i)
        return;
      let O = this.state.selection.main, w = [O.from];
      O.empty || w.push(O.to);
      for (let C of w)
        if (C > f && C < p) {
          u(f, C - 10, m, v), u(C + 10, p, m, v);
          return;
        }
      let _ = g2e(e, (C) => C.from >= m.from && C.to <= m.to && Math.abs(C.from - f) < i && Math.abs(C.to - p) < i && !w.some((A) => C.from < A && C.to > A));
      if (!_) {
        if (p < m.to && n && r && n.visibleRanges.some((C) => C.from <= p && C.to >= p)) {
          let C = n.moveToLineBoundary(ft.cursor(p), !1, !0).head;
          C > f && (p = C);
        }
        _ = new o3(f, p, this.gapSize(m, f, p, v));
      }
      s.push(_);
    };
    for (let f of this.viewportLines) {
      if (f.length < o)
        continue;
      let p = m2e(f.from, f.to, this.stateDeco);
      if (p.total < o)
        continue;
      let m = this.scrollTarget ? this.scrollTarget.range.head : null, v, O;
      if (r) {
        let w = a / this.heightOracle.lineLength * this.heightOracle.lineHeight, _, C;
        if (m != null) {
          let A = Gx(p, m), N = ((this.visibleBottom - this.visibleTop) / 2 + w) / f.height;
          _ = A - N, C = A + N;
        } else
          _ = (this.visibleTop - f.top - w) / f.height, C = (this.visibleBottom - f.top + w) / f.height;
        v = jx(p, _), O = jx(p, C);
      } else {
        let w = p.total * this.heightOracle.charWidth, _ = a * this.heightOracle.charWidth, C, A;
        if (m != null) {
          let N = Gx(p, m), P = ((this.pixelViewport.right - this.pixelViewport.left) / 2 + _) / w;
          C = N - P, A = N + P;
        } else
          C = (this.pixelViewport.left - _) / w, A = (this.pixelViewport.right + _) / w;
        v = jx(p, C), O = jx(p, A);
      }
      v > f.from && u(f.from, v, f, p), O < f.to && u(O, f.to, f, p);
    }
    return s;
  }
  gapSize(e, n, r, a) {
    let i = Gx(a, r) - Gx(a, n);
    return this.heightOracle.lineWrapping ? e.height * i : a.total * this.heightOracle.charWidth * i;
  }
  updateLineGaps(e) {
    o3.same(e, this.lineGaps) || (this.lineGaps = e, this.lineGapDeco = Ln.set(e.map((n) => n.draw(this, this.heightOracle.lineWrapping))));
  }
  computeVisibleRanges() {
    let e = this.stateDeco;
    this.lineGaps.length && (e = e.concat(this.lineGapDeco));
    let n = [];
    ta.spans(e, this.viewport.from, this.viewport.to, {
      span(a, i) {
        n.push({ from: a, to: i });
      },
      point() {
      }
    }, 20);
    let r = n.length != this.visibleRanges.length || this.visibleRanges.some((a, i) => a.from != n[i].from || a.to != n[i].to);
    return this.visibleRanges = n, r ? 4 : 0;
  }
  lineBlockAt(e) {
    return e >= this.viewport.from && e <= this.viewport.to && this.viewportLines.find((n) => n.from <= e && n.to >= e) || $w(this.heightMap.lineAt(e, pi.ByPos, this.heightOracle, 0, 0), this.scaler);
  }
  lineBlockAtHeight(e) {
    return $w(this.heightMap.lineAt(this.scaler.fromDOM(e), pi.ByHeight, this.heightOracle, 0, 0), this.scaler);
  }
  scrollAnchorAt(e) {
    let n = this.lineBlockAtHeight(e + 8);
    return n.from >= this.viewport.from || this.viewportLines[0].top - e > 200 ? n : this.viewportLines[0];
  }
  elementAtHeight(e) {
    return $w(this.heightMap.blockAt(this.scaler.fromDOM(e), this.heightOracle, 0, 0), this.scaler);
  }
  get docHeight() {
    return this.scaler.toDOM(this.heightMap.height);
  }
  get contentHeight() {
    return this.docHeight + this.paddingTop + this.paddingBottom;
  }
}
class Qx {
  constructor(e, n) {
    this.from = e, this.to = n;
  }
}
function m2e(t, e, n) {
  let r = [], a = t, i = 0;
  return ta.spans(n, t, e, {
    span() {
    },
    point(o, s) {
      o > a && (r.push({ from: a, to: o }), i += o - a), a = s;
    }
  }, 20), a < e && (r.push({ from: a, to: e }), i += e - a), { total: i, ranges: r };
}
function jx({ total: t, ranges: e }, n) {
  if (n <= 0)
    return e[0].from;
  if (n >= 1)
    return e[e.length - 1].to;
  let r = Math.floor(t * n);
  for (let a = 0; ; a++) {
    let { from: i, to: o } = e[a], s = o - i;
    if (r <= s)
      return i + r;
    r -= s;
  }
}
function Gx(t, e) {
  let n = 0;
  for (let { from: r, to: a } of t.ranges) {
    if (e <= a) {
      n += e - r;
      break;
    }
    n += a - r;
  }
  return n / t.total;
}
function g2e(t, e) {
  for (let n of t)
    if (e(n))
      return n;
}
const VX = {
  toDOM(t) {
    return t;
  },
  fromDOM(t) {
    return t;
  },
  scale: 1
};
class b2e {
  constructor(e, n, r) {
    let a = 0, i = 0, o = 0;
    this.viewports = r.map(({ from: s, to: u }) => {
      let f = n.lineAt(s, pi.ByPos, e, 0, 0).top, p = n.lineAt(u, pi.ByPos, e, 0, 0).bottom;
      return a += p - f, { from: s, to: u, top: f, bottom: p, domTop: 0, domBottom: 0 };
    }), this.scale = (7e6 - a) / (n.height - a);
    for (let s of this.viewports)
      s.domTop = o + (s.top - i) * this.scale, o = s.domBottom = s.domTop + (s.bottom - s.top), i = s.bottom;
  }
  toDOM(e) {
    for (let n = 0, r = 0, a = 0; ; n++) {
      let i = n < this.viewports.length ? this.viewports[n] : null;
      if (!i || e < i.top)
        return a + (e - r) * this.scale;
      if (e <= i.bottom)
        return i.domTop + (e - i.top);
      r = i.bottom, a = i.domBottom;
    }
  }
  fromDOM(e) {
    for (let n = 0, r = 0, a = 0; ; n++) {
      let i = n < this.viewports.length ? this.viewports[n] : null;
      if (!i || e < i.domTop)
        return r + (e - a) / this.scale;
      if (e <= i.domBottom)
        return i.top + (e - i.domTop);
      r = i.bottom, a = i.domBottom;
    }
  }
}
function $w(t, e) {
  if (e.scale == 1)
    return t;
  let n = e.toDOM(t.top), r = e.toDOM(t.bottom);
  return new yh(t.from, t.length, n, r - n, Array.isArray(t._content) ? t._content.map((a) => $w(a, e)) : t._content);
}
const Vx = /* @__PURE__ */ bn.define({ combine: (t) => t.join(" ") }), T4 = /* @__PURE__ */ bn.define({ combine: (t) => t.indexOf(!0) > -1 }), _4 = /* @__PURE__ */ ev.newName(), Eie = /* @__PURE__ */ ev.newName(), Sie = /* @__PURE__ */ ev.newName(), wie = { "&light": "." + Eie, "&dark": "." + Sie };
function C4(t, e, n) {
  return new ev(e, {
    finish(r) {
      return /&/.test(r) ? r.replace(/&\w*/, (a) => {
        if (a == "&")
          return t;
        if (!n || !n[a])
          throw new RangeError(`Unsupported selector: ${a}`);
        return n[a];
      }) : t + " " + r;
    }
  });
}
const v2e = /* @__PURE__ */ C4("." + _4, {
  "&": {
    position: "relative !important",
    boxSizing: "border-box",
    "&.cm-focused": {
      // Provide a simple default outline to make sure a focused
      // editor is visually distinct. Can't leave the default behavior
      // because that will apply to the content element, which is
      // inside the scrollable container and doesn't include the
      // gutters. We also can't use an 'auto' outline, since those
      // are, for some reason, drawn behind the element content, which
      // will cause things like the active line background to cover
      // the outline (#297).
      outline: "1px dotted #212121"
    },
    display: "flex !important",
    flexDirection: "column"
  },
  ".cm-scroller": {
    display: "flex !important",
    alignItems: "flex-start !important",
    fontFamily: "monospace",
    lineHeight: 1.4,
    height: "100%",
    overflowX: "auto",
    position: "relative",
    zIndex: 0
  },
  ".cm-content": {
    margin: 0,
    flexGrow: 2,
    flexShrink: 0,
    display: "block",
    whiteSpace: "pre",
    wordWrap: "normal",
    // https://github.com/codemirror/dev/issues/456
    boxSizing: "border-box",
    minHeight: "100%",
    padding: "4px 0",
    outline: "none",
    "&[contenteditable=true]": {
      WebkitUserModify: "read-write-plaintext-only"
    }
  },
  ".cm-lineWrapping": {
    whiteSpace_fallback: "pre-wrap",
    // For IE
    whiteSpace: "break-spaces",
    wordBreak: "break-word",
    // For Safari, which doesn't support overflow-wrap: anywhere
    overflowWrap: "anywhere",
    flexShrink: 1
  },
  "&light .cm-content": { caretColor: "black" },
  "&dark .cm-content": { caretColor: "white" },
  ".cm-line": {
    display: "block",
    padding: "0 2px 0 6px"
  },
  ".cm-layer": {
    position: "absolute",
    left: 0,
    top: 0,
    contain: "size style",
    "& > *": {
      position: "absolute"
    }
  },
  "&light .cm-selectionBackground": {
    background: "#d9d9d9"
  },
  "&dark .cm-selectionBackground": {
    background: "#222"
  },
  "&light.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
    background: "#d7d4f0"
  },
  "&dark.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
    background: "#233"
  },
  ".cm-cursorLayer": {
    pointerEvents: "none"
  },
  "&.cm-focused > .cm-scroller > .cm-cursorLayer": {
    animation: "steps(1) cm-blink 1.2s infinite"
  },
  // Two animations defined so that we can switch between them to
  // restart the animation without forcing another style
  // recomputation.
  "@keyframes cm-blink": { "0%": {}, "50%": { opacity: 0 }, "100%": {} },
  "@keyframes cm-blink2": { "0%": {}, "50%": { opacity: 0 }, "100%": {} },
  ".cm-cursor, .cm-dropCursor": {
    borderLeft: "1.2px solid black",
    marginLeft: "-0.6px",
    pointerEvents: "none"
  },
  ".cm-cursor": {
    display: "none"
  },
  "&dark .cm-cursor": {
    borderLeftColor: "#444"
  },
  ".cm-dropCursor": {
    position: "absolute"
  },
  "&.cm-focused > .cm-scroller > .cm-cursorLayer .cm-cursor": {
    display: "block"
  },
  ".cm-iso": {
    unicodeBidi: "isolate"
  },
  ".cm-announced": {
    position: "fixed",
    top: "-10000px"
  },
  "@media print": {
    ".cm-announced": { display: "none" }
  },
  "&light .cm-activeLine": { backgroundColor: "#cceeff44" },
  "&dark .cm-activeLine": { backgroundColor: "#99eeff33" },
  "&light .cm-specialChar": { color: "red" },
  "&dark .cm-specialChar": { color: "#f78" },
  ".cm-gutters": {
    flexShrink: 0,
    display: "flex",
    height: "100%",
    boxSizing: "border-box",
    insetInlineStart: 0,
    zIndex: 200
  },
  "&light .cm-gutters": {
    backgroundColor: "#f5f5f5",
    color: "#6c6c6c",
    borderRight: "1px solid #ddd"
  },
  "&dark .cm-gutters": {
    backgroundColor: "#333338",
    color: "#ccc"
  },
  ".cm-gutter": {
    display: "flex !important",
    // Necessary -- prevents margin collapsing
    flexDirection: "column",
    flexShrink: 0,
    boxSizing: "border-box",
    minHeight: "100%",
    overflow: "hidden"
  },
  ".cm-gutterElement": {
    boxSizing: "border-box"
  },
  ".cm-lineNumbers .cm-gutterElement": {
    padding: "0 3px 0 5px",
    minWidth: "20px",
    textAlign: "right",
    whiteSpace: "nowrap"
  },
  "&light .cm-activeLineGutter": {
    backgroundColor: "#e2f2ff"
  },
  "&dark .cm-activeLineGutter": {
    backgroundColor: "#222227"
  },
  ".cm-panels": {
    boxSizing: "border-box",
    position: "sticky",
    left: 0,
    right: 0
  },
  "&light .cm-panels": {
    backgroundColor: "#f5f5f5",
    color: "black"
  },
  "&light .cm-panels-top": {
    borderBottom: "1px solid #ddd"
  },
  "&light .cm-panels-bottom": {
    borderTop: "1px solid #ddd"
  },
  "&dark .cm-panels": {
    backgroundColor: "#333338",
    color: "white"
  },
  ".cm-tab": {
    display: "inline-block",
    overflow: "hidden",
    verticalAlign: "bottom"
  },
  ".cm-widgetBuffer": {
    verticalAlign: "text-top",
    height: "1em",
    width: 0,
    display: "inline"
  },
  ".cm-placeholder": {
    color: "#888",
    display: "inline-block",
    verticalAlign: "top"
  },
  ".cm-highlightSpace:before": {
    content: "attr(data-display)",
    position: "absolute",
    pointerEvents: "none",
    color: "#888"
  },
  ".cm-highlightTab": {
    backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="20"><path stroke="%23888" stroke-width="1" fill="none" d="M1 10H196L190 5M190 15L196 10M197 4L197 16"/></svg>')`,
    backgroundSize: "auto 100%",
    backgroundPosition: "right 90%",
    backgroundRepeat: "no-repeat"
  },
  ".cm-trailingSpace": {
    backgroundColor: "#ff332255"
  },
  ".cm-button": {
    verticalAlign: "middle",
    color: "inherit",
    fontSize: "70%",
    padding: ".2em 1em",
    borderRadius: "1px"
  },
  "&light .cm-button": {
    backgroundImage: "linear-gradient(#eff1f5, #d9d9df)",
    border: "1px solid #888",
    "&:active": {
      backgroundImage: "linear-gradient(#b4b4b4, #d0d3d6)"
    }
  },
  "&dark .cm-button": {
    backgroundImage: "linear-gradient(#393939, #111)",
    border: "1px solid #888",
    "&:active": {
      backgroundImage: "linear-gradient(#111, #333)"
    }
  },
  ".cm-textfield": {
    verticalAlign: "middle",
    color: "inherit",
    fontSize: "70%",
    border: "1px solid silver",
    padding: ".2em .5em"
  },
  "&light .cm-textfield": {
    backgroundColor: "white"
  },
  "&dark .cm-textfield": {
    border: "1px solid #555",
    backgroundColor: "inherit"
  }
}, wie), Bw = "￿";
class y2e {
  constructor(e, n) {
    this.points = e, this.text = "", this.lineSeparator = n.facet(zr.lineSeparator);
  }
  append(e) {
    this.text += e;
  }
  lineBreak() {
    this.text += Bw;
  }
  readRange(e, n) {
    if (!e)
      return this;
    let r = e.parentNode;
    for (let a = e; ; ) {
      this.findPointBefore(r, a);
      let i = this.text.length;
      this.readNode(a);
      let o = a.nextSibling;
      if (o == n)
        break;
      let s = Va.get(a), u = Va.get(o);
      (s && u ? s.breakAfter : (s ? s.breakAfter : aI(a)) || aI(o) && (a.nodeName != "BR" || a.cmIgnore) && this.text.length > i) && this.lineBreak(), a = o;
    }
    return this.findPointBefore(r, n), this;
  }
  readTextNode(e) {
    let n = e.nodeValue;
    for (let r of this.points)
      r.node == e && (r.pos = this.text.length + Math.min(r.offset, n.length));
    for (let r = 0, a = this.lineSeparator ? null : /\r\n?|\n/g; ; ) {
      let i = -1, o = 1, s;
      if (this.lineSeparator ? (i = n.indexOf(this.lineSeparator, r), o = this.lineSeparator.length) : (s = a.exec(n)) && (i = s.index, o = s[0].length), this.append(n.slice(r, i < 0 ? n.length : i)), i < 0)
        break;
      if (this.lineBreak(), o > 1)
        for (let u of this.points)
          u.node == e && u.pos > this.text.length && (u.pos -= o - 1);
      r = i + o;
    }
  }
  readNode(e) {
    if (e.cmIgnore)
      return;
    let n = Va.get(e), r = n && n.overrideDOMText;
    if (r != null) {
      this.findPointInside(e, r.length);
      for (let a = r.iter(); !a.next().done; )
        a.lineBreak ? this.lineBreak() : this.append(a.value);
    } else
      e.nodeType == 3 ? this.readTextNode(e) : e.nodeName == "BR" ? e.nextSibling && this.lineBreak() : e.nodeType == 1 && this.readRange(e.firstChild, null);
  }
  findPointBefore(e, n) {
    for (let r of this.points)
      r.node == e && e.childNodes[r.offset] == n && (r.pos = this.text.length);
  }
  findPointInside(e, n) {
    for (let r of this.points)
      (e.nodeType == 3 ? r.node == e : e.contains(r.node)) && (r.pos = this.text.length + (O2e(e, r.node, r.offset) ? n : 0));
  }
}
function O2e(t, e, n) {
  for (; ; ) {
    if (!e || n < tg(e))
      return !1;
    if (e == t)
      return !0;
    n = f0(e) + 1, e = e.parentNode;
  }
}
class YX {
  constructor(e, n) {
    this.node = e, this.offset = n, this.pos = -1;
  }
}
class E2e {
  constructor(e, n, r, a) {
    this.typeOver = a, this.bounds = null, this.text = "";
    let { impreciseHead: i, impreciseAnchor: o } = e.docView;
    if (e.state.readOnly && n > -1)
      this.newSel = null;
    else if (n > -1 && (this.bounds = e.docView.domBoundsAround(n, r, 0))) {
      let s = i || o ? [] : T2e(e), u = new y2e(s, e.state);
      u.readRange(this.bounds.startDOM, this.bounds.endDOM), this.text = u.text, this.newSel = _2e(s, this.bounds.from);
    } else {
      let s = e.observer.selectionRange, u = i && i.node == s.focusNode && i.offset == s.focusOffset || !c4(e.contentDOM, s.focusNode) ? e.state.selection.main.head : e.docView.posFromDOM(s.focusNode, s.focusOffset), f = o && o.node == s.anchorNode && o.offset == s.anchorOffset || !c4(e.contentDOM, s.anchorNode) ? e.state.selection.main.anchor : e.docView.posFromDOM(s.anchorNode, s.anchorOffset), p = e.viewport;
      if ((vn.ios || vn.chrome) && e.state.selection.main.empty && u != f && (p.from > 0 || p.to < e.state.doc.length)) {
        let m = Math.min(u, f), v = Math.max(u, f), O = p.from - m, w = p.to - v;
        (O == 0 || O == 1 || m == 0) && (w == 0 || w == -1 || v == e.state.doc.length) && (u = 0, f = e.state.doc.length);
      }
      this.newSel = ft.single(f, u);
    }
  }
}
function Tie(t, e) {
  let n, { newSel: r } = e, a = t.state.selection.main, i = t.inputState.lastKeyTime > Date.now() - 100 ? t.inputState.lastKeyCode : -1;
  if (e.bounds) {
    let { from: o, to: s } = e.bounds, u = a.from, f = null;
    (i === 8 || vn.android && e.text.length < s - o) && (u = a.to, f = "end");
    let p = w2e(t.state.doc.sliceString(o, s, Bw), e.text, u - o, f);
    p && (vn.chrome && i == 13 && p.toB == p.from + 2 && e.text.slice(p.from, p.toB) == Bw + Bw && p.toB--, n = {
      from: o + p.from,
      to: o + p.toA,
      insert: la.of(e.text.slice(p.from, p.toB).split(Bw))
    });
  } else
    r && (!t.hasFocus && t.state.facet(vD) || r.main.eq(a)) && (r = null);
  if (!n && !r)
    return !1;
  if (!n && e.typeOver && !a.empty && r && r.main.empty ? n = { from: a.from, to: a.to, insert: t.state.doc.slice(a.from, a.to) } : n && n.from >= a.from && n.to <= a.to && (n.from != a.from || n.to != a.to) && a.to - a.from - (n.to - n.from) <= 4 ? n = {
    from: a.from,
    to: a.to,
    insert: t.state.doc.slice(a.from, n.from).append(n.insert).append(t.state.doc.slice(n.to, a.to))
  } : (vn.mac || vn.android) && n && n.from == n.to && n.from == a.head - 1 && /^\. ?$/.test(n.insert.toString()) && t.contentDOM.getAttribute("autocorrect") == "off" ? (r && n.insert.length == 2 && (r = ft.single(r.main.anchor - 1, r.main.head - 1)), n = { from: a.from, to: a.to, insert: la.of([" "]) }) : vn.chrome && n && n.from == n.to && n.from == a.head && n.insert.toString() == `
 ` && t.lineWrapping && (r && (r = ft.single(r.main.anchor - 1, r.main.head - 1)), n = { from: a.from, to: a.to, insert: la.of([" "]) }), n) {
    if (vn.ios && t.inputState.flushIOSKey(n) || vn.android && (n.to == a.to && // GBoard will sometimes remove a space it just inserted
    // after a completion when you press enter
    (n.from == a.from || n.from == a.from - 1 && t.state.sliceDoc(n.from, a.from) == " ") && n.insert.length == 1 && n.insert.lines == 2 && AE(t.contentDOM, "Enter", 13) || (n.from == a.from - 1 && n.to == a.to && n.insert.length == 0 || i == 8 && n.insert.length < n.to - n.from && n.to > a.head) && AE(t.contentDOM, "Backspace", 8) || n.from == a.from && n.to == a.to + 1 && n.insert.length == 0 && AE(t.contentDOM, "Delete", 46)))
      return !0;
    let o = n.insert.toString();
    t.inputState.composing >= 0 && t.inputState.composing++;
    let s, u = () => s || (s = S2e(t, n, r));
    return t.state.facet(Jae).some((f) => f(t, n.from, n.to, o, u)) || t.dispatch(u()), !0;
  } else if (r && !r.main.eq(a)) {
    let o = !1, s = "select";
    return t.inputState.lastSelectionTime > Date.now() - 50 && (t.inputState.lastSelectionOrigin == "select" && (o = !0), s = t.inputState.lastSelectionOrigin), t.dispatch({ selection: r, scrollIntoView: o, userEvent: s }), !0;
  } else
    return !1;
}
function S2e(t, e, n) {
  let r, a = t.state, i = a.selection.main;
  if (e.from >= i.from && e.to <= i.to && e.to - e.from >= (i.to - i.from) / 3 && (!n || n.main.empty && n.main.from == e.from + e.insert.length) && t.inputState.composing < 0) {
    let s = i.from < e.from ? a.sliceDoc(i.from, e.from) : "", u = i.to > e.to ? a.sliceDoc(e.to, i.to) : "";
    r = a.replaceSelection(t.state.toText(s + e.insert.sliceString(0, void 0, t.state.lineBreak) + u));
  } else {
    let s = a.changes(e), u = n && n.main.to <= s.newLength ? n.main : void 0;
    if (a.selection.ranges.length > 1 && t.inputState.composing >= 0 && e.to <= i.to && e.to >= i.to - 10) {
      let f = t.state.sliceDoc(e.from, e.to), p, m = n && uie(t, n.main.head);
      if (m) {
        let w = e.insert.length - (e.to - e.from);
        p = { from: m.from, to: m.to - w };
      } else
        p = t.state.doc.lineAt(i.head);
      let v = i.to - e.to, O = i.to - i.from;
      r = a.changeByRange((w) => {
        if (w.from == i.from && w.to == i.to)
          return { changes: s, range: u || w.map(s) };
        let _ = w.to - v, C = _ - f.length;
        if (w.to - w.from != O || t.state.sliceDoc(C, _) != f || // Unfortunately, there's no way to make multiple
        // changes in the same node work without aborting
        // composition, so cursors in the composition range are
        // ignored.
        w.to >= p.from && w.from <= p.to)
          return { range: w };
        let A = a.changes({ from: C, to: _, insert: e.insert }), N = w.to - i.to;
        return {
          changes: A,
          range: u ? ft.range(Math.max(0, u.anchor + N), Math.max(0, u.head + N)) : w.map(A)
        };
      });
    } else
      r = {
        changes: s,
        selection: u && a.selection.replaceRange(u)
      };
  }
  let o = "input.type";
  return (t.composing || t.inputState.compositionPendingChange && t.inputState.compositionEndedAt > Date.now() - 50) && (t.inputState.compositionPendingChange = !1, o += ".compose", t.inputState.compositionFirstChange && (o += ".start", t.inputState.compositionFirstChange = !1)), a.update(r, { userEvent: o, scrollIntoView: !0 });
}
function w2e(t, e, n, r) {
  let a = Math.min(t.length, e.length), i = 0;
  for (; i < a && t.charCodeAt(i) == e.charCodeAt(i); )
    i++;
  if (i == a && t.length == e.length)
    return null;
  let o = t.length, s = e.length;
  for (; o > 0 && s > 0 && t.charCodeAt(o - 1) == e.charCodeAt(s - 1); )
    o--, s--;
  if (r == "end") {
    let u = Math.max(0, i - Math.min(o, s));
    n -= o + u - i;
  }
  if (o < i && t.length < e.length) {
    let u = n <= i && n >= o ? i - n : 0;
    i -= u, s = i + (s - o), o = i;
  } else if (s < i) {
    let u = n <= i && n >= s ? i - n : 0;
    i -= u, o = i + (o - s), s = i;
  }
  return { from: i, toA: o, toB: s };
}
function T2e(t) {
  let e = [];
  if (t.root.activeElement != t.contentDOM)
    return e;
  let { anchorNode: n, anchorOffset: r, focusNode: a, focusOffset: i } = t.observer.selectionRange;
  return n && (e.push(new YX(n, r)), (a != n || i != r) && e.push(new YX(a, i))), e;
}
function _2e(t, e) {
  if (t.length == 0)
    return null;
  let n = t[0].pos, r = t.length == 2 ? t[1].pos : n;
  return n > -1 && r > -1 ? ft.single(n + e, r + e) : null;
}
const C2e = {
  childList: !0,
  characterData: !0,
  subtree: !0,
  attributes: !0,
  characterDataOldValue: !0
}, s3 = vn.ie && vn.ie_version <= 11;
class x2e {
  constructor(e) {
    this.view = e, this.active = !1, this.selectionRange = new cNe(), this.selectionChanged = !1, this.delayedFlush = -1, this.resizeTimeout = -1, this.queue = [], this.delayedAndroidKey = null, this.flushingAndroidKey = -1, this.lastChange = 0, this.scrollTargets = [], this.intersection = null, this.resizeScroll = null, this.intersecting = !1, this.gapIntersection = null, this.gaps = [], this.printQuery = null, this.parentCheck = -1, this.dom = e.contentDOM, this.observer = new MutationObserver((n) => {
      for (let r of n)
        this.queue.push(r);
      (vn.ie && vn.ie_version <= 11 || vn.ios && e.composing) && n.some((r) => r.type == "childList" && r.removedNodes.length || r.type == "characterData" && r.oldValue.length > r.target.nodeValue.length) ? this.flushSoon() : this.flush();
    }), s3 && (this.onCharData = (n) => {
      this.queue.push({
        target: n.target,
        type: "characterData",
        oldValue: n.prevValue
      }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this), this.onResize = this.onResize.bind(this), this.onPrint = this.onPrint.bind(this), this.onScroll = this.onScroll.bind(this), window.matchMedia && (this.printQuery = window.matchMedia("print")), typeof ResizeObserver == "function" && (this.resizeScroll = new ResizeObserver(() => {
      var n;
      ((n = this.view.docView) === null || n === void 0 ? void 0 : n.lastUpdate) < Date.now() - 75 && this.onResize();
    }), this.resizeScroll.observe(e.scrollDOM)), this.addWindowListeners(this.win = e.win), this.start(), typeof IntersectionObserver == "function" && (this.intersection = new IntersectionObserver((n) => {
      this.parentCheck < 0 && (this.parentCheck = setTimeout(this.listenForScroll.bind(this), 1e3)), n.length > 0 && n[n.length - 1].intersectionRatio > 0 != this.intersecting && (this.intersecting = !this.intersecting, this.intersecting != this.view.inView && this.onScrollChanged(document.createEvent("Event")));
    }, { threshold: [0, 1e-3] }), this.intersection.observe(this.dom), this.gapIntersection = new IntersectionObserver((n) => {
      n.length > 0 && n[n.length - 1].intersectionRatio > 0 && this.onScrollChanged(document.createEvent("Event"));
    }, {})), this.listenForScroll(), this.readSelectionRange();
  }
  onScrollChanged(e) {
    this.view.inputState.runHandlers("scroll", e), this.intersecting && this.view.measure();
  }
  onScroll(e) {
    this.intersecting && this.flush(!1), this.onScrollChanged(e);
  }
  onResize() {
    this.resizeTimeout < 0 && (this.resizeTimeout = setTimeout(() => {
      this.resizeTimeout = -1, this.view.requestMeasure();
    }, 50));
  }
  onPrint(e) {
    e.type == "change" && !e.matches || (this.view.viewState.printing = !0, this.view.measure(), setTimeout(() => {
      this.view.viewState.printing = !1, this.view.requestMeasure();
    }, 500));
  }
  updateGaps(e) {
    if (this.gapIntersection && (e.length != this.gaps.length || this.gaps.some((n, r) => n != e[r]))) {
      this.gapIntersection.disconnect();
      for (let n of e)
        this.gapIntersection.observe(n);
      this.gaps = e;
    }
  }
  onSelectionChange(e) {
    let n = this.selectionChanged;
    if (!this.readSelectionRange() || this.delayedAndroidKey)
      return;
    let { view: r } = this, a = this.selectionRange;
    if (r.state.facet(vD) ? r.root.activeElement != this.dom : !Sk(r.dom, a))
      return;
    let i = a.anchorNode && r.docView.nearest(a.anchorNode);
    if (i && i.ignoreEvent(e)) {
      n || (this.selectionChanged = !1);
      return;
    }
    (vn.ie && vn.ie_version <= 11 || vn.android && vn.chrome) && !r.state.selection.main.empty && // (Selection.isCollapsed isn't reliable on IE)
    a.focusNode && sT(a.focusNode, a.focusOffset, a.anchorNode, a.anchorOffset) ? this.flushSoon() : this.flush(!1);
  }
  readSelectionRange() {
    let { view: e } = this, n = rI(e.root);
    if (!n)
      return !1;
    let r = vn.safari && e.root.nodeType == 11 && oNe(this.dom.ownerDocument) == this.dom && A2e(this.view, n) || n;
    if (!r || this.selectionRange.eq(r))
      return !1;
    let a = Sk(this.dom, r);
    return a && !this.selectionChanged && e.inputState.lastFocusTime > Date.now() - 200 && e.inputState.lastTouchTime < Date.now() - 300 && dNe(this.dom, r) ? (this.view.inputState.lastFocusTime = 0, e.docView.updateSelection(), !1) : (this.selectionRange.setRange(r), a && (this.selectionChanged = !0), !0);
  }
  setSelectionRange(e, n) {
    this.selectionRange.set(e.node, e.offset, n.node, n.offset), this.selectionChanged = !1;
  }
  clearSelectionRange() {
    this.selectionRange.set(null, 0, null, 0);
  }
  listenForScroll() {
    this.parentCheck = -1;
    let e = 0, n = null;
    for (let r = this.dom; r; )
      if (r.nodeType == 1)
        !n && e < this.scrollTargets.length && this.scrollTargets[e] == r ? e++ : n || (n = this.scrollTargets.slice(0, e)), n && n.push(r), r = r.assignedSlot || r.parentNode;
      else if (r.nodeType == 11)
        r = r.host;
      else
        break;
    if (e < this.scrollTargets.length && !n && (n = this.scrollTargets.slice(0, e)), n) {
      for (let r of this.scrollTargets)
        r.removeEventListener("scroll", this.onScroll);
      for (let r of this.scrollTargets = n)
        r.addEventListener("scroll", this.onScroll);
    }
  }
  ignore(e) {
    if (!this.active)
      return e();
    try {
      return this.stop(), e();
    } finally {
      this.start(), this.clear();
    }
  }
  start() {
    this.active || (this.observer.observe(this.dom, C2e), s3 && this.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.active = !0);
  }
  stop() {
    this.active && (this.active = !1, this.observer.disconnect(), s3 && this.dom.removeEventListener("DOMCharacterDataModified", this.onCharData));
  }
  // Throw away any pending changes
  clear() {
    this.processRecords(), this.queue.length = 0, this.selectionChanged = !1;
  }
  // Chrome Android, especially in combination with GBoard, not only
  // doesn't reliably fire regular key events, but also often
  // surrounds the effect of enter or backspace with a bunch of
  // composition events that, when interrupted, cause text duplication
  // or other kinds of corruption. This hack makes the editor back off
  // from handling DOM changes for a moment when such a key is
  // detected (via beforeinput or keydown), and then tries to flush
  // them or, if that has no effect, dispatches the given key.
  delayAndroidKey(e, n) {
    var r;
    if (!this.delayedAndroidKey) {
      let a = () => {
        let i = this.delayedAndroidKey;
        i && (this.clearDelayedAndroidKey(), this.view.inputState.lastKeyCode = i.keyCode, this.view.inputState.lastKeyTime = Date.now(), !this.flush() && i.force && AE(this.dom, i.key, i.keyCode));
      };
      this.flushingAndroidKey = this.view.win.requestAnimationFrame(a);
    }
    (!this.delayedAndroidKey || e == "Enter") && (this.delayedAndroidKey = {
      key: e,
      keyCode: n,
      // Only run the key handler when no changes are detected if
      // this isn't coming right after another change, in which case
      // it is probably part of a weird chain of updates, and should
      // be ignored if it returns the DOM to its previous state.
      force: this.lastChange < Date.now() - 50 || !!(!((r = this.delayedAndroidKey) === null || r === void 0) && r.force)
    });
  }
  clearDelayedAndroidKey() {
    this.win.cancelAnimationFrame(this.flushingAndroidKey), this.delayedAndroidKey = null, this.flushingAndroidKey = -1;
  }
  flushSoon() {
    this.delayedFlush < 0 && (this.delayedFlush = this.view.win.requestAnimationFrame(() => {
      this.delayedFlush = -1, this.flush();
    }));
  }
  forceFlush() {
    this.delayedFlush >= 0 && (this.view.win.cancelAnimationFrame(this.delayedFlush), this.delayedFlush = -1), this.flush();
  }
  pendingRecords() {
    for (let e of this.observer.takeRecords())
      this.queue.push(e);
    return this.queue;
  }
  processRecords() {
    let e = this.pendingRecords();
    e.length && (this.queue = []);
    let n = -1, r = -1, a = !1;
    for (let i of e) {
      let o = this.readMutation(i);
      o && (o.typeOver && (a = !0), n == -1 ? { from: n, to: r } = o : (n = Math.min(o.from, n), r = Math.max(o.to, r)));
    }
    return { from: n, to: r, typeOver: a };
  }
  readChange() {
    let { from: e, to: n, typeOver: r } = this.processRecords(), a = this.selectionChanged && Sk(this.dom, this.selectionRange);
    if (e < 0 && !a)
      return null;
    e > -1 && (this.lastChange = Date.now()), this.view.inputState.lastFocusTime = 0, this.selectionChanged = !1;
    let i = new E2e(this.view, e, n, r);
    return this.view.docView.domChanged = { newSel: i.newSel ? i.newSel.main : null }, i;
  }
  // Apply pending changes, if any
  flush(e = !0) {
    if (this.delayedFlush >= 0 || this.delayedAndroidKey)
      return !1;
    e && this.readSelectionRange();
    let n = this.readChange();
    if (!n)
      return this.view.requestMeasure(), !1;
    let r = this.view.state, a = Tie(this.view, n);
    return this.view.state == r && this.view.update([]), a;
  }
  readMutation(e) {
    let n = this.view.docView.nearest(e.target);
    if (!n || n.ignoreMutation(e))
      return null;
    if (n.markDirty(e.type == "attributes"), e.type == "attributes" && (n.flags |= 4), e.type == "childList") {
      let r = ZX(n, e.previousSibling || e.target.previousSibling, -1), a = ZX(n, e.nextSibling || e.target.nextSibling, 1);
      return {
        from: r ? n.posAfter(r) : n.posAtStart,
        to: a ? n.posBefore(a) : n.posAtEnd,
        typeOver: !1
      };
    } else
      return e.type == "characterData" ? { from: n.posAtStart, to: n.posAtEnd, typeOver: e.target.nodeValue == e.oldValue } : null;
  }
  setWindow(e) {
    e != this.win && (this.removeWindowListeners(this.win), this.win = e, this.addWindowListeners(this.win));
  }
  addWindowListeners(e) {
    e.addEventListener("resize", this.onResize), this.printQuery ? this.printQuery.addEventListener("change", this.onPrint) : e.addEventListener("beforeprint", this.onPrint), e.addEventListener("scroll", this.onScroll), e.document.addEventListener("selectionchange", this.onSelectionChange);
  }
  removeWindowListeners(e) {
    e.removeEventListener("scroll", this.onScroll), e.removeEventListener("resize", this.onResize), this.printQuery ? this.printQuery.removeEventListener("change", this.onPrint) : e.removeEventListener("beforeprint", this.onPrint), e.document.removeEventListener("selectionchange", this.onSelectionChange);
  }
  destroy() {
    var e, n, r;
    this.stop(), (e = this.intersection) === null || e === void 0 || e.disconnect(), (n = this.gapIntersection) === null || n === void 0 || n.disconnect(), (r = this.resizeScroll) === null || r === void 0 || r.disconnect();
    for (let a of this.scrollTargets)
      a.removeEventListener("scroll", this.onScroll);
    this.removeWindowListeners(this.win), clearTimeout(this.parentCheck), clearTimeout(this.resizeTimeout), this.win.cancelAnimationFrame(this.delayedFlush), this.win.cancelAnimationFrame(this.flushingAndroidKey);
  }
}
function ZX(t, e, n) {
  for (; e; ) {
    let r = Va.get(e);
    if (r && r.parent == t)
      return r;
    let a = e.parentNode;
    e = a != t.dom ? a : n > 0 ? e.nextSibling : e.previousSibling;
  }
  return null;
}
function XX(t, e) {
  let n = e.startContainer, r = e.startOffset, a = e.endContainer, i = e.endOffset, o = t.docView.domAtPos(t.state.selection.main.anchor);
  return sT(o.node, o.offset, a, i) && ([n, r, a, i] = [a, i, n, r]), { anchorNode: n, anchorOffset: r, focusNode: a, focusOffset: i };
}
function A2e(t, e) {
  if (e.getComposedRanges) {
    let a = e.getComposedRanges(t.root)[0];
    if (a)
      return XX(t, a);
  }
  let n = null;
  function r(a) {
    a.preventDefault(), a.stopImmediatePropagation(), n = a.getTargetRanges()[0];
  }
  return t.contentDOM.addEventListener("beforeinput", r, !0), t.dom.ownerDocument.execCommand("indent"), t.contentDOM.removeEventListener("beforeinput", r, !0), n ? XX(t, n) : null;
}
class qt {
  /**
  The current editor state.
  */
  get state() {
    return this.viewState.state;
  }
  /**
  To be able to display large documents without consuming too much
  memory or overloading the browser, CodeMirror only draws the
  code that is visible (plus a margin around it) to the DOM. This
  property tells you the extent of the current drawn viewport, in
  document positions.
  */
  get viewport() {
    return this.viewState.viewport;
  }
  /**
  When there are, for example, large collapsed ranges in the
  viewport, its size can be a lot bigger than the actual visible
  content. Thus, if you are doing something like styling the
  content in the viewport, it is preferable to only do so for
  these ranges, which are the subset of the viewport that is
  actually drawn.
  */
  get visibleRanges() {
    return this.viewState.visibleRanges;
  }
  /**
  Returns false when the editor is entirely scrolled out of view
  or otherwise hidden.
  */
  get inView() {
    return this.viewState.inView;
  }
  /**
  Indicates whether the user is currently composing text via
  [IME](https://en.wikipedia.org/wiki/Input_method), and at least
  one change has been made in the current composition.
  */
  get composing() {
    return this.inputState.composing > 0;
  }
  /**
  Indicates whether the user is currently in composing state. Note
  that on some platforms, like Android, this will be the case a
  lot, since just putting the cursor on a word starts a
  composition there.
  */
  get compositionStarted() {
    return this.inputState.composing >= 0;
  }
  /**
  The document or shadow root that the view lives in.
  */
  get root() {
    return this._root;
  }
  /**
  @internal
  */
  get win() {
    return this.dom.ownerDocument.defaultView || window;
  }
  /**
  Construct a new view. You'll want to either provide a `parent`
  option, or put `view.dom` into your document after creating a
  view, so that the user can see the editor.
  */
  constructor(e = {}) {
    this.plugins = [], this.pluginMap = /* @__PURE__ */ new Map(), this.editorAttrs = {}, this.contentAttrs = {}, this.bidiCache = [], this.destroyed = !1, this.updateState = 2, this.measureScheduled = -1, this.measureRequests = [], this.contentDOM = document.createElement("div"), this.scrollDOM = document.createElement("div"), this.scrollDOM.tabIndex = -1, this.scrollDOM.className = "cm-scroller", this.scrollDOM.appendChild(this.contentDOM), this.announceDOM = document.createElement("div"), this.announceDOM.className = "cm-announced", this.announceDOM.setAttribute("aria-live", "polite"), this.dom = document.createElement("div"), this.dom.appendChild(this.announceDOM), this.dom.appendChild(this.scrollDOM), e.parent && e.parent.appendChild(this.dom);
    let { dispatch: n } = e;
    this.dispatchTransactions = e.dispatchTransactions || n && ((r) => r.forEach((a) => n(a, this))) || ((r) => this.update(r)), this.dispatch = this.dispatch.bind(this), this._root = e.root || fNe(e.parent) || document, this.viewState = new GX(e.state || zr.create(e)), e.scrollTo && e.scrollTo.is(zx) && (this.viewState.scrollTarget = e.scrollTo.value.clip(this.viewState.state)), this.plugins = this.state.facet(Mw).map((r) => new r3(r));
    for (let r of this.plugins)
      r.update(this);
    this.observer = new x2e(this), this.inputState = new WNe(this), this.inputState.ensureHandlers(this.plugins), this.docView = new AX(this), this.mountStyles(), this.updateAttrs(), this.updateState = 0, this.requestMeasure();
  }
  dispatch(...e) {
    let n = e.length == 1 && e[0] instanceof No ? e : e.length == 1 && Array.isArray(e[0]) ? e[0] : [this.state.update(...e)];
    this.dispatchTransactions(n, this);
  }
  /**
  Update the view for the given array of transactions. This will
  update the visible document and selection to match the state
  produced by the transactions, and notify view plugins of the
  change. You should usually call
  [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead, which uses this
  as a primitive.
  */
  update(e) {
    if (this.updateState != 0)
      throw new Error("Calls to EditorView.update are not allowed while an update is in progress");
    let n = !1, r = !1, a, i = this.state;
    for (let v of e) {
      if (v.startState != i)
        throw new RangeError("Trying to update state with a transaction that doesn't start from the previous state.");
      i = v.state;
    }
    if (this.destroyed) {
      this.viewState.state = i;
      return;
    }
    let o = this.hasFocus, s = 0, u = null;
    e.some((v) => v.annotation(bie)) ? (this.inputState.notifiedFocused = o, s = 1) : o != this.inputState.notifiedFocused && (this.inputState.notifiedFocused = o, u = vie(i, o), u || (s = 1));
    let f = this.observer.delayedAndroidKey, p = null;
    if (f ? (this.observer.clearDelayedAndroidKey(), p = this.observer.readChange(), (p && !this.state.doc.eq(i.doc) || !this.state.selection.eq(i.selection)) && (p = null)) : this.observer.clear(), i.facet(zr.phrases) != this.state.facet(zr.phrases))
      return this.setState(i);
    a = iI.create(this, i, e), a.flags |= s;
    let m = this.viewState.scrollTarget;
    try {
      this.updateState = 2;
      for (let v of e) {
        if (m && (m = m.map(v.changes)), v.scrollIntoView) {
          let { main: O } = v.state.selection;
          m = new kE(O.empty ? O : ft.cursor(O.head, O.head > O.anchor ? -1 : 1));
        }
        for (let O of v.effects)
          O.is(zx) && (m = O.value.clip(this.state));
      }
      this.viewState.update(a, m), this.bidiCache = oI.update(this.bidiCache, a.changes), a.empty || (this.updatePlugins(a), this.inputState.update(a)), n = this.docView.update(a), this.state.facet(Fw) != this.styleModules && this.mountStyles(), r = this.updateAttrs(), this.showAnnouncements(e), this.docView.updateSelection(n, e.some((v) => v.isUserEvent("select.pointer")));
    } finally {
      this.updateState = 0;
    }
    if (a.startState.facet(Vx) != a.state.facet(Vx) && (this.viewState.mustMeasureContent = !0), (n || r || m || this.viewState.mustEnforceCursorAssoc || this.viewState.mustMeasureContent) && this.requestMeasure(), n && this.docViewUpdate(), !a.empty)
      for (let v of this.state.facet(O4))
        try {
          v(a);
        } catch (O) {
          Ku(this.state, O, "update listener");
        }
    (u || p) && Promise.resolve().then(() => {
      u && this.state == u.startState && this.dispatch(u), p && !Tie(this, p) && f.force && AE(this.contentDOM, f.key, f.keyCode);
    });
  }
  /**
  Reset the view to the given state. (This will cause the entire
  document to be redrawn and all view plugins to be reinitialized,
  so you should probably only use it when the new state isn't
  derived from the old state. Otherwise, use
  [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead.)
  */
  setState(e) {
    if (this.updateState != 0)
      throw new Error("Calls to EditorView.setState are not allowed while an update is in progress");
    if (this.destroyed) {
      this.viewState.state = e;
      return;
    }
    this.updateState = 2;
    let n = this.hasFocus;
    try {
      for (let r of this.plugins)
        r.destroy(this);
      this.viewState = new GX(e), this.plugins = e.facet(Mw).map((r) => new r3(r)), this.pluginMap.clear();
      for (let r of this.plugins)
        r.update(this);
      this.docView.destroy(), this.docView = new AX(this), this.inputState.ensureHandlers(this.plugins), this.mountStyles(), this.updateAttrs(), this.bidiCache = [];
    } finally {
      this.updateState = 0;
    }
    n && this.focus(), this.requestMeasure();
  }
  updatePlugins(e) {
    let n = e.startState.facet(Mw), r = e.state.facet(Mw);
    if (n != r) {
      let a = [];
      for (let i of r) {
        let o = n.indexOf(i);
        if (o < 0)
          a.push(new r3(i));
        else {
          let s = this.plugins[o];
          s.mustUpdate = e, a.push(s);
        }
      }
      for (let i of this.plugins)
        i.mustUpdate != e && i.destroy(this);
      this.plugins = a, this.pluginMap.clear();
    } else
      for (let a of this.plugins)
        a.mustUpdate = e;
    for (let a = 0; a < this.plugins.length; a++)
      this.plugins[a].update(this);
    n != r && this.inputState.ensureHandlers(this.plugins);
  }
  docViewUpdate() {
    for (let e of this.plugins) {
      let n = e.value;
      if (n && n.docViewUpdate)
        try {
          n.docViewUpdate(this);
        } catch (r) {
          Ku(this.state, r, "doc view update listener");
        }
    }
  }
  /**
  @internal
  */
  measure(e = !0) {
    if (this.destroyed)
      return;
    if (this.measureScheduled > -1 && this.win.cancelAnimationFrame(this.measureScheduled), this.observer.delayedAndroidKey) {
      this.measureScheduled = -1, this.requestMeasure();
      return;
    }
    this.measureScheduled = 0, e && this.observer.forceFlush();
    let n = null, r = this.scrollDOM, a = r.scrollTop * this.scaleY, { scrollAnchorPos: i, scrollAnchorHeight: o } = this.viewState;
    Math.abs(a - this.viewState.scrollTop) > 1 && (o = -1), this.viewState.scrollAnchorHeight = -1;
    try {
      for (let s = 0; ; s++) {
        if (o < 0)
          if (Dae(r))
            i = -1, o = this.viewState.heightMap.height;
          else {
            let O = this.viewState.scrollAnchorAt(a);
            i = O.from, o = O.top;
          }
        this.updateState = 1;
        let u = this.viewState.measure(this);
        if (!u && !this.measureRequests.length && this.viewState.scrollTarget == null)
          break;
        if (s > 5) {
          console.warn(this.measureRequests.length ? "Measure loop restarted more than 5 times" : "Viewport failed to stabilize");
          break;
        }
        let f = [];
        u & 4 || ([this.measureRequests, f] = [f, this.measureRequests]);
        let p = f.map((O) => {
          try {
            return O.read(this);
          } catch (w) {
            return Ku(this.state, w), qX;
          }
        }), m = iI.create(this, this.state, []), v = !1;
        m.flags |= u, n ? n.flags |= u : n = m, this.updateState = 2, m.empty || (this.updatePlugins(m), this.inputState.update(m), this.updateAttrs(), v = this.docView.update(m), v && this.docViewUpdate());
        for (let O = 0; O < f.length; O++)
          if (p[O] != qX)
            try {
              let w = f[O];
              w.write && w.write(p[O], this);
            } catch (w) {
              Ku(this.state, w);
            }
        if (v && this.docView.updateSelection(!0), !m.viewportChanged && this.measureRequests.length == 0) {
          if (this.viewState.editorHeight)
            if (this.viewState.scrollTarget) {
              this.docView.scrollIntoView(this.viewState.scrollTarget), this.viewState.scrollTarget = null, o = -1;
              continue;
            } else {
              let w = (i < 0 ? this.viewState.heightMap.height : this.viewState.lineBlockAt(i).top) - o;
              if (w > 1 || w < -1) {
                a = a + w, r.scrollTop = a / this.scaleY, o = -1;
                continue;
              }
            }
          break;
        }
      }
    } finally {
      this.updateState = 0, this.measureScheduled = -1;
    }
    if (n && !n.empty)
      for (let s of this.state.facet(O4))
        s(n);
  }
  /**
  Get the CSS classes for the currently active editor themes.
  */
  get themeClasses() {
    return _4 + " " + (this.state.facet(T4) ? Sie : Eie) + " " + this.state.facet(Vx);
  }
  updateAttrs() {
    let e = KX(this, aie, {
      class: "cm-editor" + (this.hasFocus ? " cm-focused " : " ") + this.themeClasses
    }), n = {
      spellcheck: "false",
      autocorrect: "off",
      autocapitalize: "off",
      translate: "no",
      contenteditable: this.state.facet(vD) ? "true" : "false",
      class: "cm-content",
      style: `${vn.tabSize}: ${this.state.tabSize}`,
      role: "textbox",
      "aria-multiline": "true"
    };
    this.state.readOnly && (n["aria-readonly"] = "true"), KX(this, QU, n);
    let r = this.observer.ignore(() => {
      let a = m4(this.contentDOM, this.contentAttrs, n), i = m4(this.dom, this.editorAttrs, e);
      return a || i;
    });
    return this.editorAttrs = e, this.contentAttrs = n, r;
  }
  showAnnouncements(e) {
    let n = !0;
    for (let r of e)
      for (let a of r.effects)
        if (a.is(qt.announce)) {
          n && (this.announceDOM.textContent = ""), n = !1;
          let i = this.announceDOM.appendChild(document.createElement("div"));
          i.textContent = a.value;
        }
  }
  mountStyles() {
    this.styleModules = this.state.facet(Fw);
    let e = this.state.facet(qt.cspNonce);
    ev.mount(this.root, this.styleModules.concat(v2e).reverse(), e ? { nonce: e } : void 0);
  }
  readMeasured() {
    if (this.updateState == 2)
      throw new Error("Reading the editor layout isn't allowed during an update");
    this.updateState == 0 && this.measureScheduled > -1 && this.measure(!1);
  }
  /**
  Schedule a layout measurement, optionally providing callbacks to
  do custom DOM measuring followed by a DOM write phase. Using
  this is preferable reading DOM layout directly from, for
  example, an event handler, because it'll make sure measuring and
  drawing done by other components is synchronized, avoiding
  unnecessary DOM layout computations.
  */
  requestMeasure(e) {
    if (this.measureScheduled < 0 && (this.measureScheduled = this.win.requestAnimationFrame(() => this.measure())), e) {
      if (this.measureRequests.indexOf(e) > -1)
        return;
      if (e.key != null) {
        for (let n = 0; n < this.measureRequests.length; n++)
          if (this.measureRequests[n].key === e.key) {
            this.measureRequests[n] = e;
            return;
          }
      }
      this.measureRequests.push(e);
    }
  }
  /**
  Get the value of a specific plugin, if present. Note that
  plugins that crash can be dropped from a view, so even when you
  know you registered a given plugin, it is recommended to check
  the return value of this method.
  */
  plugin(e) {
    let n = this.pluginMap.get(e);
    return (n === void 0 || n && n.spec != e) && this.pluginMap.set(e, n = this.plugins.find((r) => r.spec == e) || null), n && n.update(this).value;
  }
  /**
  The top position of the document, in screen coordinates. This
  may be negative when the editor is scrolled down. Points
  directly to the top of the first line, not above the padding.
  */
  get documentTop() {
    return this.contentDOM.getBoundingClientRect().top + this.viewState.paddingTop;
  }
  /**
  Reports the padding above and below the document.
  */
  get documentPadding() {
    return { top: this.viewState.paddingTop, bottom: this.viewState.paddingBottom };
  }
  /**
  If the editor is transformed with CSS, this provides the scale
  along the X axis. Otherwise, it will just be 1. Note that
  transforms other than translation and scaling are not supported.
  */
  get scaleX() {
    return this.viewState.scaleX;
  }
  /**
  Provide the CSS transformed scale along the Y axis.
  */
  get scaleY() {
    return this.viewState.scaleY;
  }
  /**
  Find the text line or block widget at the given vertical
  position (which is interpreted as relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop)).
  */
  elementAtHeight(e) {
    return this.readMeasured(), this.viewState.elementAtHeight(e);
  }
  /**
  Find the line block (see
  [`lineBlockAt`](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) at the given
  height, again interpreted relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop).
  */
  lineBlockAtHeight(e) {
    return this.readMeasured(), this.viewState.lineBlockAtHeight(e);
  }
  /**
  Get the extent and vertical position of all [line
  blocks](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) in the viewport. Positions
  are relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop);
  */
  get viewportLineBlocks() {
    return this.viewState.viewportLines;
  }
  /**
  Find the line block around the given document position. A line
  block is a range delimited on both sides by either a
  non-[hidden](https://codemirror.net/6/docs/ref/#view.Decoration^replace) line breaks, or the
  start/end of the document. It will usually just hold a line of
  text, but may be broken into multiple textblocks by block
  widgets.
  */
  lineBlockAt(e) {
    return this.viewState.lineBlockAt(e);
  }
  /**
  The editor's total content height.
  */
  get contentHeight() {
    return this.viewState.contentHeight;
  }
  /**
  Move a cursor position by [grapheme
  cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak). `forward` determines whether
  the motion is away from the line start, or towards it. In
  bidirectional text, the line is traversed in visual order, using
  the editor's [text direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection).
  When the start position was the last one on the line, the
  returned position will be across the line break. If there is no
  further line, the original position is returned.
  
  By default, this method moves over a single cluster. The
  optional `by` argument can be used to move across more. It will
  be called with the first cluster as argument, and should return
  a predicate that determines, for each subsequent cluster,
  whether it should also be moved over.
  */
  moveByChar(e, n, r) {
    return i3(this, e, PX(this, e, n, r));
  }
  /**
  Move a cursor position across the next group of either
  [letters](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) or non-letter
  non-whitespace characters.
  */
  moveByGroup(e, n) {
    return i3(this, e, PX(this, e, n, (r) => zNe(this, e.head, r)));
  }
  /**
  Get the cursor position visually at the start or end of a line.
  Note that this may differ from the _logical_ position at its
  start or end (which is simply at `line.from`/`line.to`) if text
  at the start or end goes against the line's base text direction.
  */
  visualLineSide(e, n) {
    let r = this.bidiSpans(e), a = this.textDirectionAt(e.from), i = r[n ? r.length - 1 : 0];
    return ft.cursor(i.side(n, a) + e.from, i.forward(!n, a) ? 1 : -1);
  }
  /**
  Move to the next line boundary in the given direction. If
  `includeWrap` is true, line wrapping is on, and there is a
  further wrap point on the current line, the wrap point will be
  returned. Otherwise this function will return the start or end
  of the line.
  */
  moveToLineBoundary(e, n, r = !0) {
    return UNe(this, e, n, r);
  }
  /**
  Move a cursor position vertically. When `distance` isn't given,
  it defaults to moving to the next line (including wrapped
  lines). Otherwise, `distance` should provide a positive distance
  in pixels.
  
  When `start` has a
  [`goalColumn`](https://codemirror.net/6/docs/ref/#state.SelectionRange.goalColumn), the vertical
  motion will use that as a target horizontal position. Otherwise,
  the cursor's own horizontal position is used. The returned
  cursor will have its goal column set to whichever column was
  used.
  */
  moveVertically(e, n, r) {
    return i3(this, e, HNe(this, e, n, r));
  }
  /**
  Find the DOM parent node and offset (child offset if `node` is
  an element, character offset when it is a text node) at the
  given document position.
  
  Note that for positions that aren't currently in
  `visibleRanges`, the resulting DOM position isn't necessarily
  meaningful (it may just point before or after a placeholder
  element).
  */
  domAtPos(e) {
    return this.docView.domAtPos(e);
  }
  /**
  Find the document position at the given DOM node. Can be useful
  for associating positions with DOM events. Will raise an error
  when `node` isn't part of the editor content.
  */
  posAtDOM(e, n = 0) {
    return this.docView.posFromDOM(e, n);
  }
  posAtCoords(e, n = !0) {
    return this.readMeasured(), cie(this, e, n);
  }
  /**
  Get the screen coordinates at the given document position.
  `side` determines whether the coordinates are based on the
  element before (-1) or after (1) the position (if no element is
  available on the given side, the method will transparently use
  another strategy to get reasonable coordinates).
  */
  coordsAtPos(e, n = 1) {
    this.readMeasured();
    let r = this.docView.coordsAt(e, n);
    if (!r || r.left == r.right)
      return r;
    let a = this.state.doc.lineAt(e), i = this.bidiSpans(a), o = i[jb.find(i, e - a.from, -1, n)];
    return gD(r, o.dir == hi.LTR == n > 0);
  }
  /**
  Return the rectangle around a given character. If `pos` does not
  point in front of a character that is in the viewport and
  rendered (i.e. not replaced, not a line break), this will return
  null. For space characters that are a line wrap point, this will
  return the position before the line break.
  */
  coordsForChar(e) {
    return this.readMeasured(), this.docView.coordsForChar(e);
  }
  /**
  The default width of a character in the editor. May not
  accurately reflect the width of all characters (given variable
  width fonts or styling of invididual ranges).
  */
  get defaultCharacterWidth() {
    return this.viewState.heightOracle.charWidth;
  }
  /**
  The default height of a line in the editor. May not be accurate
  for all lines.
  */
  get defaultLineHeight() {
    return this.viewState.heightOracle.lineHeight;
  }
  /**
  The text direction
  ([`direction`](https://developer.mozilla.org/en-US/docs/Web/CSS/direction)
  CSS property) of the editor's content element.
  */
  get textDirection() {
    return this.viewState.defaultTextDirection;
  }
  /**
  Find the text direction of the block at the given position, as
  assigned by CSS. If
  [`perLineTextDirection`](https://codemirror.net/6/docs/ref/#view.EditorView^perLineTextDirection)
  isn't enabled, or the given position is outside of the viewport,
  this will always return the same as
  [`textDirection`](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection). Note that
  this may trigger a DOM layout.
  */
  textDirectionAt(e) {
    return !this.state.facet(tie) || e < this.viewport.from || e > this.viewport.to ? this.textDirection : (this.readMeasured(), this.docView.textDirectionAt(e));
  }
  /**
  Whether this editor [wraps lines](https://codemirror.net/6/docs/ref/#view.EditorView.lineWrapping)
  (as determined by the
  [`white-space`](https://developer.mozilla.org/en-US/docs/Web/CSS/white-space)
  CSS property of its content element).
  */
  get lineWrapping() {
    return this.viewState.heightOracle.lineWrapping;
  }
  /**
  Returns the bidirectional text structure of the given line
  (which should be in the current document) as an array of span
  objects. The order of these spans matches the [text
  direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection)—if that is
  left-to-right, the leftmost spans come first, otherwise the
  rightmost spans come first.
  */
  bidiSpans(e) {
    if (e.length > k2e)
      return Vae(e.length);
    let n = this.textDirectionAt(e.from), r;
    for (let i of this.bidiCache)
      if (i.from == e.from && i.dir == n && (i.fresh || Gae(i.isolates, r = xX(this, e))))
        return i.order;
    r || (r = xX(this, e));
    let a = TNe(e.text, n, r);
    return this.bidiCache.push(new oI(e.from, e.to, n, r, !0, a)), a;
  }
  /**
  Check whether the editor has focus.
  */
  get hasFocus() {
    var e;
    return (this.dom.ownerDocument.hasFocus() || vn.safari && ((e = this.inputState) === null || e === void 0 ? void 0 : e.lastContextMenu) > Date.now() - 3e4) && this.root.activeElement == this.contentDOM;
  }
  /**
  Put focus on the editor.
  */
  focus() {
    this.observer.ignore(() => {
      Rae(this.contentDOM), this.docView.updateSelection();
    });
  }
  /**
  Update the [root](https://codemirror.net/6/docs/ref/##view.EditorViewConfig.root) in which the editor lives. This is only
  necessary when moving the editor's existing DOM to a new window or shadow root.
  */
  setRoot(e) {
    this._root != e && (this._root = e, this.observer.setWindow((e.nodeType == 9 ? e : e.ownerDocument).defaultView || window), this.mountStyles());
  }
  /**
  Clean up this editor view, removing its element from the
  document, unregistering event handlers, and notifying
  plugins. The view instance can no longer be used after
  calling this.
  */
  destroy() {
    for (let e of this.plugins)
      e.destroy(this);
    this.plugins = [], this.inputState.destroy(), this.docView.destroy(), this.dom.remove(), this.observer.destroy(), this.measureScheduled > -1 && this.win.cancelAnimationFrame(this.measureScheduled), this.destroyed = !0;
  }
  /**
  Returns an effect that can be
  [added](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) to a transaction to
  cause it to scroll the given position or range into view.
  */
  static scrollIntoView(e, n = {}) {
    return zx.of(new kE(typeof e == "number" ? ft.cursor(e) : e, n.y, n.x, n.yMargin, n.xMargin));
  }
  /**
  Return an effect that resets the editor to its current (at the
  time this method was called) scroll position. Note that this
  only affects the editor's own scrollable element, not parents.
  See also
  [`EditorViewConfig.scrollTo`](https://codemirror.net/6/docs/ref/#view.EditorViewConfig.scrollTo).
  
  The effect should be used with a document identical to the one
  it was created for. Failing to do so is not an error, but may
  not scroll to the expected position. You can
  [map](https://codemirror.net/6/docs/ref/#state.StateEffect.map) the effect to account for changes.
  */
  scrollSnapshot() {
    let { scrollTop: e, scrollLeft: n } = this.scrollDOM, r = this.viewState.scrollAnchorAt(e);
    return zx.of(new kE(ft.cursor(r.from), "start", "start", r.top - e, n, !0));
  }
  /**
  Returns an extension that can be used to add DOM event handlers.
  The value should be an object mapping event names to handler
  functions. For any given event, such functions are ordered by
  extension precedence, and the first handler to return true will
  be assumed to have handled that event, and no other handlers or
  built-in behavior will be activated for it. These are registered
  on the [content element](https://codemirror.net/6/docs/ref/#view.EditorView.contentDOM), except
  for `scroll` handlers, which will be called any time the
  editor's [scroll element](https://codemirror.net/6/docs/ref/#view.EditorView.scrollDOM) or one of
  its parent nodes is scrolled.
  */
  static domEventHandlers(e) {
    return Ki.define(() => ({}), { eventHandlers: e });
  }
  /**
  Create an extension that registers DOM event observers. Contrary
  to event [handlers](https://codemirror.net/6/docs/ref/#view.EditorView^domEventHandlers),
  observers can't be prevented from running by a higher-precedence
  handler returning true. They also don't prevent other handlers
  and observers from running when they return true, and should not
  call `preventDefault`.
  */
  static domEventObservers(e) {
    return Ki.define(() => ({}), { eventObservers: e });
  }
  /**
  Create a theme extension. The first argument can be a
  [`style-mod`](https://github.com/marijnh/style-mod#documentation)
  style spec providing the styles for the theme. These will be
  prefixed with a generated class for the style.
  
  Because the selectors will be prefixed with a scope class, rule
  that directly match the editor's [wrapper
  element](https://codemirror.net/6/docs/ref/#view.EditorView.dom)—to which the scope class will be
  added—need to be explicitly differentiated by adding an `&` to
  the selector for that element—for example
  `&.cm-focused`.
  
  When `dark` is set to true, the theme will be marked as dark,
  which will cause the `&dark` rules from [base
  themes](https://codemirror.net/6/docs/ref/#view.EditorView^baseTheme) to be used (as opposed to
  `&light` when a light theme is active).
  */
  static theme(e, n) {
    let r = ev.newName(), a = [Vx.of(r), Fw.of(C4(`.${r}`, e))];
    return n && n.dark && a.push(T4.of(!0)), a;
  }
  /**
  Create an extension that adds styles to the base theme. Like
  with [`theme`](https://codemirror.net/6/docs/ref/#view.EditorView^theme), use `&` to indicate the
  place of the editor wrapper element when directly targeting
  that. You can also use `&dark` or `&light` instead to only
  target editors with a dark or light theme.
  */
  static baseTheme(e) {
    return ig.lowest(Fw.of(C4("." + _4, e, wie)));
  }
  /**
  Retrieve an editor view instance from the view's DOM
  representation.
  */
  static findFromDOM(e) {
    var n;
    let r = e.querySelector(".cm-content"), a = r && Va.get(r) || Va.get(e);
    return ((n = a == null ? void 0 : a.rootView) === null || n === void 0 ? void 0 : n.view) || null;
  }
}
qt.styleModule = Fw;
qt.inputHandler = Jae;
qt.scrollHandler = rie;
qt.focusChangeEffect = eie;
qt.perLineTextDirection = tie;
qt.exceptionSink = Kae;
qt.updateListener = O4;
qt.editable = vD;
qt.mouseSelectionStyle = qae;
qt.dragMovesSelection = Xae;
qt.clickAddsSelectionRange = Zae;
qt.decorations = zT;
qt.outerDecorations = iie;
qt.atomicRanges = jU;
qt.bidiIsolatedRanges = oie;
qt.scrollMargins = sie;
qt.darkTheme = T4;
qt.cspNonce = /* @__PURE__ */ bn.define({ combine: (t) => t.length ? t[0] : "" });
qt.contentAttributes = QU;
qt.editorAttributes = aie;
qt.lineWrapping = /* @__PURE__ */ qt.contentAttributes.of({ class: "cm-lineWrapping" });
qt.announce = /* @__PURE__ */ fr.define();
const k2e = 4096, qX = {};
class oI {
  constructor(e, n, r, a, i, o) {
    this.from = e, this.to = n, this.dir = r, this.isolates = a, this.fresh = i, this.order = o;
  }
  static update(e, n) {
    if (n.empty && !e.some((i) => i.fresh))
      return e;
    let r = [], a = e.length ? e[e.length - 1].dir : hi.LTR;
    for (let i = Math.max(0, e.length - 10); i < e.length; i++) {
      let o = e[i];
      o.dir == a && !n.touchesRange(o.from, o.to) && r.push(new oI(n.mapPos(o.from, 1), n.mapPos(o.to, -1), o.dir, o.isolates, !1, o.order));
    }
    return r;
  }
}
function KX(t, e, n) {
  for (let r = t.state.facet(e), a = r.length - 1; a >= 0; a--) {
    let i = r[a], o = typeof i == "function" ? i(t) : i;
    o && h4(o, n);
  }
  return n;
}
const R2e = vn.mac ? "mac" : vn.windows ? "win" : vn.linux ? "linux" : "key";
function I2e(t, e) {
  const n = t.split(/-(?!$)/);
  let r = n[n.length - 1];
  r == "Space" && (r = " ");
  let a, i, o, s;
  for (let u = 0; u < n.length - 1; ++u) {
    const f = n[u];
    if (/^(cmd|meta|m)$/i.test(f))
      s = !0;
    else if (/^a(lt)?$/i.test(f))
      a = !0;
    else if (/^(c|ctrl|control)$/i.test(f))
      i = !0;
    else if (/^s(hift)?$/i.test(f))
      o = !0;
    else if (/^mod$/i.test(f))
      e == "mac" ? s = !0 : i = !0;
    else
      throw new Error("Unrecognized modifier name: " + f);
  }
  return a && (r = "Alt-" + r), i && (r = "Ctrl-" + r), s && (r = "Meta-" + r), o && (r = "Shift-" + r), r;
}
function Yx(t, e, n) {
  return e.altKey && (t = "Alt-" + t), e.ctrlKey && (t = "Ctrl-" + t), e.metaKey && (t = "Meta-" + t), n !== !1 && e.shiftKey && (t = "Shift-" + t), t;
}
const D2e = /* @__PURE__ */ ig.default(/* @__PURE__ */ qt.domEventHandlers({
  keydown(t, e) {
    return Cie(_ie(e.state), t, e, "editor");
  }
})), l1 = /* @__PURE__ */ bn.define({ enables: D2e }), JX = /* @__PURE__ */ new WeakMap();
function _ie(t) {
  let e = t.facet(l1), n = JX.get(e);
  return n || JX.set(e, n = L2e(e.reduce((r, a) => r.concat(a), []))), n;
}
function N2e(t, e, n) {
  return Cie(_ie(t.state), e, t, n);
}
let Ub = null;
const P2e = 4e3;
function L2e(t, e = R2e) {
  let n = /* @__PURE__ */ Object.create(null), r = /* @__PURE__ */ Object.create(null), a = (o, s) => {
    let u = r[o];
    if (u == null)
      r[o] = s;
    else if (u != s)
      throw new Error("Key binding " + o + " is used both as a regular binding and as a multi-stroke prefix");
  }, i = (o, s, u, f, p) => {
    var m, v;
    let O = n[o] || (n[o] = /* @__PURE__ */ Object.create(null)), w = s.split(/ (?!$)/).map((A) => I2e(A, e));
    for (let A = 1; A < w.length; A++) {
      let N = w.slice(0, A).join(" ");
      a(N, !0), O[N] || (O[N] = {
        preventDefault: !0,
        stopPropagation: !1,
        run: [(P) => {
          let I = Ub = { view: P, prefix: N, scope: o };
          return setTimeout(() => {
            Ub == I && (Ub = null);
          }, P2e), !0;
        }]
      });
    }
    let _ = w.join(" ");
    a(_, !1);
    let C = O[_] || (O[_] = {
      preventDefault: !1,
      stopPropagation: !1,
      run: ((v = (m = O._any) === null || m === void 0 ? void 0 : m.run) === null || v === void 0 ? void 0 : v.slice()) || []
    });
    u && C.run.push(u), f && (C.preventDefault = !0), p && (C.stopPropagation = !0);
  };
  for (let o of t) {
    let s = o.scope ? o.scope.split(" ") : ["editor"];
    if (o.any)
      for (let f of s) {
        let p = n[f] || (n[f] = /* @__PURE__ */ Object.create(null));
        p._any || (p._any = { preventDefault: !1, stopPropagation: !1, run: [] });
        for (let m in p)
          p[m].run.push(o.any);
      }
    let u = o[e] || o.key;
    if (u)
      for (let f of s)
        i(f, u, o.run, o.preventDefault, o.stopPropagation), o.shift && i(f, "Shift-" + u, o.shift, o.preventDefault, o.stopPropagation);
  }
  return n;
}
function Cie(t, e, n, r) {
  let a = iNe(e), i = Ks(a, 0), o = Uf(i) == a.length && a != " ", s = "", u = !1, f = !1, p = !1;
  Ub && Ub.view == n && Ub.scope == r && (s = Ub.prefix + " ", die.indexOf(e.keyCode) < 0 && (f = !0, Ub = null));
  let m = /* @__PURE__ */ new Set(), v = (C) => {
    if (C) {
      for (let A of C.run)
        if (!m.has(A) && (m.add(A), A(n, e)))
          return C.stopPropagation && (p = !0), !0;
      C.preventDefault && (C.stopPropagation && (p = !0), f = !0);
    }
    return !1;
  }, O = t[r], w, _;
  return O && (v(O[s + Yx(a, e, !o)]) ? u = !0 : o && (e.altKey || e.metaKey || e.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
  !(vn.windows && e.ctrlKey && e.altKey) && (w = tv[e.keyCode]) && w != a ? (v(O[s + Yx(w, e, !0)]) || e.shiftKey && (_ = UT[e.keyCode]) != a && _ != w && v(O[s + Yx(_, e, !1)])) && (u = !0) : o && e.shiftKey && v(O[s + Yx(a, e, !0)]) && (u = !0), !u && v(O._any) && (u = !0)), f && (u = !0), u && p && e.stopPropagation(), u;
}
class E_ {
  /**
  Create a marker with the given class and dimensions. If `width`
  is null, the DOM element will get no width style.
  */
  constructor(e, n, r, a, i) {
    this.className = e, this.left = n, this.top = r, this.width = a, this.height = i;
  }
  draw() {
    let e = document.createElement("div");
    return e.className = this.className, this.adjust(e), e;
  }
  update(e, n) {
    return n.className != this.className ? !1 : (this.adjust(e), !0);
  }
  adjust(e) {
    e.style.left = this.left + "px", e.style.top = this.top + "px", this.width != null && (e.style.width = this.width + "px"), e.style.height = this.height + "px";
  }
  eq(e) {
    return this.left == e.left && this.top == e.top && this.width == e.width && this.height == e.height && this.className == e.className;
  }
  /**
  Create a set of rectangles for the given selection range,
  assigning them theclass`className`. Will create a single
  rectangle for empty ranges, and a set of selection-style
  rectangles covering the range's content (in a bidi-aware
  way) for non-empty ones.
  */
  static forRange(e, n, r) {
    if (r.empty) {
      let a = e.coordsAtPos(r.head, r.assoc || 1);
      if (!a)
        return [];
      let i = xie(e);
      return [new E_(n, a.left - i.left, a.top - i.top, null, a.bottom - a.top)];
    } else
      return M2e(e, n, r);
  }
}
function xie(t) {
  let e = t.scrollDOM.getBoundingClientRect();
  return { left: (t.textDirection == hi.LTR ? e.left : e.right - t.scrollDOM.clientWidth * t.scaleX) - t.scrollDOM.scrollLeft * t.scaleX, top: e.top - t.scrollDOM.scrollTop * t.scaleY };
}
function eq(t, e, n) {
  let r = ft.cursor(e);
  return {
    from: Math.max(n.from, t.moveToLineBoundary(r, !1, !0).from),
    to: Math.min(n.to, t.moveToLineBoundary(r, !0, !0).from),
    type: du.Text
  };
}
function M2e(t, e, n) {
  if (n.to <= t.viewport.from || n.from >= t.viewport.to)
    return [];
  let r = Math.max(n.from, t.viewport.from), a = Math.min(n.to, t.viewport.to), i = t.textDirection == hi.LTR, o = t.contentDOM, s = o.getBoundingClientRect(), u = xie(t), f = o.querySelector(".cm-line"), p = f && window.getComputedStyle(f), m = s.left + (p ? parseInt(p.paddingLeft) + Math.min(0, parseInt(p.textIndent)) : 0), v = s.right - (p ? parseInt(p.paddingRight) : 0), O = S4(t, r), w = S4(t, a), _ = O.type == du.Text ? O : null, C = w.type == du.Text ? w : null;
  if (_ && (t.lineWrapping || O.widgetLineBreaks) && (_ = eq(t, r, _)), C && (t.lineWrapping || w.widgetLineBreaks) && (C = eq(t, a, C)), _ && C && _.from == C.from)
    return N(P(n.from, n.to, _));
  {
    let D = _ ? P(n.from, null, _) : I(O, !1), M = C ? P(null, n.to, C) : I(w, !0), H = [];
    return (_ || O).to < (C || w).from - (_ && C ? 1 : 0) || O.widgetLineBreaks > 1 && D.bottom + t.defaultLineHeight / 2 < M.top ? H.push(A(m, D.bottom, v, M.top)) : D.bottom < M.top && t.elementAtHeight((D.bottom + M.top) / 2).type == du.Text && (D.bottom = M.top = (D.bottom + M.top) / 2), N(D).concat(H).concat(N(M));
  }
  function A(D, M, H, Y) {
    return new E_(
      e,
      D - u.left,
      M - u.top - 0.01,
      H - D,
      Y - M + 0.01
      /* C.Epsilon */
    );
  }
  function N({ top: D, bottom: M, horizontal: H }) {
    let Y = [];
    for (let q = 0; q < H.length; q += 2)
      Y.push(A(H[q], D, H[q + 1], M));
    return Y;
  }
  function P(D, M, H) {
    let Y = 1e9, q = -1e9, Q = [];
    function ne(ee, fe, de, ie, le) {
      let ye = t.coordsAtPos(ee, ee == H.to ? -2 : 2), B = t.coordsAtPos(de, de == H.from ? 2 : -2);
      !ye || !B || (Y = Math.min(ye.top, B.top, Y), q = Math.max(ye.bottom, B.bottom, q), le == hi.LTR ? Q.push(i && fe ? m : ye.left, i && ie ? v : B.right) : Q.push(!i && ie ? m : B.left, !i && fe ? v : ye.right));
    }
    let J = D ?? H.from, ue = M ?? H.to;
    for (let ee of t.visibleRanges)
      if (ee.to > J && ee.from < ue)
        for (let fe = Math.max(ee.from, J), de = Math.min(ee.to, ue); ; ) {
          let ie = t.state.doc.lineAt(fe);
          for (let le of t.bidiSpans(ie)) {
            let ye = le.from + ie.from, B = le.to + ie.from;
            if (ye >= de)
              break;
            B > fe && ne(Math.max(ye, fe), D == null && ye <= J, Math.min(B, de), M == null && B >= ue, le.dir);
          }
          if (fe = ie.to + 1, fe >= de)
            break;
        }
    return Q.length == 0 && ne(J, D == null, ue, M == null, t.textDirection), { top: Y, bottom: q, horizontal: Q };
  }
  function I(D, M) {
    let H = s.top + (M ? D.top : D.bottom);
    return { top: H, bottom: H, horizontal: [] };
  }
}
function F2e(t, e) {
  return t.constructor == e.constructor && t.eq(e);
}
class $2e {
  constructor(e, n) {
    this.view = e, this.layer = n, this.drawn = [], this.scaleX = 1, this.scaleY = 1, this.measureReq = { read: this.measure.bind(this), write: this.draw.bind(this) }, this.dom = e.scrollDOM.appendChild(document.createElement("div")), this.dom.classList.add("cm-layer"), n.above && this.dom.classList.add("cm-layer-above"), n.class && this.dom.classList.add(n.class), this.scale(), this.dom.setAttribute("aria-hidden", "true"), this.setOrder(e.state), e.requestMeasure(this.measureReq), n.mount && n.mount(this.dom, e);
  }
  update(e) {
    e.startState.facet(_k) != e.state.facet(_k) && this.setOrder(e.state), (this.layer.update(e, this.dom) || e.geometryChanged) && (this.scale(), e.view.requestMeasure(this.measureReq));
  }
  docViewUpdate(e) {
    this.layer.updateOnDocViewUpdate !== !1 && e.requestMeasure(this.measureReq);
  }
  setOrder(e) {
    let n = 0, r = e.facet(_k);
    for (; n < r.length && r[n] != this.layer; )
      n++;
    this.dom.style.zIndex = String((this.layer.above ? 150 : -1) - n);
  }
  measure() {
    return this.layer.markers(this.view);
  }
  scale() {
    let { scaleX: e, scaleY: n } = this.view;
    (e != this.scaleX || n != this.scaleY) && (this.scaleX = e, this.scaleY = n, this.dom.style.transform = `scale(${1 / e}, ${1 / n})`);
  }
  draw(e) {
    if (e.length != this.drawn.length || e.some((n, r) => !F2e(n, this.drawn[r]))) {
      let n = this.dom.firstChild, r = 0;
      for (let a of e)
        a.update && n && a.constructor && this.drawn[r].constructor && a.update(n, this.drawn[r]) ? (n = n.nextSibling, r++) : this.dom.insertBefore(a.draw(), n);
      for (; n; ) {
        let a = n.nextSibling;
        n.remove(), n = a;
      }
      this.drawn = e;
    }
  }
  destroy() {
    this.layer.destroy && this.layer.destroy(this.dom, this.view), this.dom.remove();
  }
}
const _k = /* @__PURE__ */ bn.define();
function Aie(t) {
  return [
    Ki.define((e) => new $2e(e, t)),
    _k.of(t)
  ];
}
const kie = !vn.ios, HT = /* @__PURE__ */ bn.define({
  combine(t) {
    return Dh(t, {
      cursorBlinkRate: 1200,
      drawRangeCursor: !0
    }, {
      cursorBlinkRate: (e, n) => Math.min(e, n),
      drawRangeCursor: (e, n) => e || n
    });
  }
});
function B2e(t = {}) {
  return [
    HT.of(t),
    U2e,
    z2e,
    H2e,
    nie.of(!0)
  ];
}
function Rie(t) {
  return t.startState.facet(HT) != t.state.facet(HT);
}
const U2e = /* @__PURE__ */ Aie({
  above: !0,
  markers(t) {
    let { state: e } = t, n = e.facet(HT), r = [];
    for (let a of e.selection.ranges) {
      let i = a == e.selection.main;
      if (a.empty ? !i || kie : n.drawRangeCursor) {
        let o = i ? "cm-cursor cm-cursor-primary" : "cm-cursor cm-cursor-secondary", s = a.empty ? a : ft.cursor(a.head, a.head > a.anchor ? -1 : 1);
        for (let u of E_.forRange(t, o, s))
          r.push(u);
      }
    }
    return r;
  },
  update(t, e) {
    t.transactions.some((r) => r.selection) && (e.style.animationName = e.style.animationName == "cm-blink" ? "cm-blink2" : "cm-blink");
    let n = Rie(t);
    return n && tq(t.state, e), t.docChanged || t.selectionSet || n;
  },
  mount(t, e) {
    tq(e.state, t);
  },
  class: "cm-cursorLayer"
});
function tq(t, e) {
  e.style.animationDuration = t.facet(HT).cursorBlinkRate + "ms";
}
const z2e = /* @__PURE__ */ Aie({
  above: !1,
  markers(t) {
    return t.state.selection.ranges.map((e) => e.empty ? [] : E_.forRange(t, "cm-selectionBackground", e)).reduce((e, n) => e.concat(n));
  },
  update(t, e) {
    return t.docChanged || t.selectionSet || t.viewportChanged || Rie(t);
  },
  class: "cm-selectionLayer"
}), x4 = {
  ".cm-line": {
    "& ::selection": { backgroundColor: "transparent !important" },
    "&::selection": { backgroundColor: "transparent !important" }
  }
};
kie && (x4[".cm-line"].caretColor = "transparent !important", x4[".cm-content"] = { caretColor: "transparent !important" });
const H2e = /* @__PURE__ */ ig.highest(/* @__PURE__ */ qt.theme(x4)), Iie = /* @__PURE__ */ fr.define({
  map(t, e) {
    return t == null ? null : e.mapPos(t);
  }
}), Uw = /* @__PURE__ */ Ss.define({
  create() {
    return null;
  },
  update(t, e) {
    return t != null && (t = e.changes.mapPos(t)), e.effects.reduce((n, r) => r.is(Iie) ? r.value : n, t);
  }
}), W2e = /* @__PURE__ */ Ki.fromClass(class {
  constructor(t) {
    this.view = t, this.cursor = null, this.measureReq = { read: this.readPos.bind(this), write: this.drawCursor.bind(this) };
  }
  update(t) {
    var e;
    let n = t.state.field(Uw);
    n == null ? this.cursor != null && ((e = this.cursor) === null || e === void 0 || e.remove(), this.cursor = null) : (this.cursor || (this.cursor = this.view.scrollDOM.appendChild(document.createElement("div")), this.cursor.className = "cm-dropCursor"), (t.startState.field(Uw) != n || t.docChanged || t.geometryChanged) && this.view.requestMeasure(this.measureReq));
  }
  readPos() {
    let { view: t } = this, e = t.state.field(Uw), n = e != null && t.coordsAtPos(e);
    if (!n)
      return null;
    let r = t.scrollDOM.getBoundingClientRect();
    return {
      left: n.left - r.left + t.scrollDOM.scrollLeft * t.scaleX,
      top: n.top - r.top + t.scrollDOM.scrollTop * t.scaleY,
      height: n.bottom - n.top
    };
  }
  drawCursor(t) {
    if (this.cursor) {
      let { scaleX: e, scaleY: n } = this.view;
      t ? (this.cursor.style.left = t.left / e + "px", this.cursor.style.top = t.top / n + "px", this.cursor.style.height = t.height / n + "px") : this.cursor.style.left = "-100000px";
    }
  }
  destroy() {
    this.cursor && this.cursor.remove();
  }
  setDropPos(t) {
    this.view.state.field(Uw) != t && this.view.dispatch({ effects: Iie.of(t) });
  }
}, {
  eventObservers: {
    dragover(t) {
      this.setDropPos(this.view.posAtCoords({ x: t.clientX, y: t.clientY }));
    },
    dragleave(t) {
      (t.target == this.view.contentDOM || !this.view.contentDOM.contains(t.relatedTarget)) && this.setDropPos(null);
    },
    dragend() {
      this.setDropPos(null);
    },
    drop() {
      this.setDropPos(null);
    }
  }
});
function Q2e() {
  return [Uw, W2e];
}
function nq(t, e, n, r, a) {
  e.lastIndex = 0;
  for (let i = t.iterRange(n, r), o = n, s; !i.next().done; o += i.value.length)
    if (!i.lineBreak)
      for (; s = e.exec(i.value); )
        a(o + s.index, s);
}
function j2e(t, e) {
  let n = t.visibleRanges;
  if (n.length == 1 && n[0].from == t.viewport.from && n[0].to == t.viewport.to)
    return n;
  let r = [];
  for (let { from: a, to: i } of n)
    a = Math.max(t.state.doc.lineAt(a).from, a - e), i = Math.min(t.state.doc.lineAt(i).to, i + e), r.length && r[r.length - 1].to >= a ? r[r.length - 1].to = i : r.push({ from: a, to: i });
  return r;
}
class G2e {
  /**
  Create a decorator.
  */
  constructor(e) {
    const { regexp: n, decoration: r, decorate: a, boundary: i, maxLength: o = 1e3 } = e;
    if (!n.global)
      throw new RangeError("The regular expression given to MatchDecorator should have its 'g' flag set");
    if (this.regexp = n, a)
      this.addMatch = (s, u, f, p) => a(p, f, f + s[0].length, s, u);
    else if (typeof r == "function")
      this.addMatch = (s, u, f, p) => {
        let m = r(s, u, f);
        m && p(f, f + s[0].length, m);
      };
    else if (r)
      this.addMatch = (s, u, f, p) => p(f, f + s[0].length, r);
    else
      throw new RangeError("Either 'decorate' or 'decoration' should be provided to MatchDecorator");
    this.boundary = i, this.maxLength = o;
  }
  /**
  Compute the full set of decorations for matches in the given
  view's viewport. You'll want to call this when initializing your
  plugin.
  */
  createDeco(e) {
    let n = new Jb(), r = n.add.bind(n);
    for (let { from: a, to: i } of j2e(e, this.maxLength))
      nq(e.state.doc, this.regexp, a, i, (o, s) => this.addMatch(s, e, o, r));
    return n.finish();
  }
  /**
  Update a set of decorations for a view update. `deco` _must_ be
  the set of decorations produced by _this_ `MatchDecorator` for
  the view state before the update.
  */
  updateDeco(e, n) {
    let r = 1e9, a = -1;
    return e.docChanged && e.changes.iterChanges((i, o, s, u) => {
      u > e.view.viewport.from && s < e.view.viewport.to && (r = Math.min(s, r), a = Math.max(u, a));
    }), e.viewportChanged || a - r > 1e3 ? this.createDeco(e.view) : a > -1 ? this.updateRange(e.view, n.map(e.changes), r, a) : n;
  }
  updateRange(e, n, r, a) {
    for (let i of e.visibleRanges) {
      let o = Math.max(i.from, r), s = Math.min(i.to, a);
      if (s > o) {
        let u = e.state.doc.lineAt(o), f = u.to < s ? e.state.doc.lineAt(s) : u, p = Math.max(i.from, u.from), m = Math.min(i.to, f.to);
        if (this.boundary) {
          for (; o > u.from; o--)
            if (this.boundary.test(u.text[o - 1 - u.from])) {
              p = o;
              break;
            }
          for (; s < f.to; s++)
            if (this.boundary.test(f.text[s - f.from])) {
              m = s;
              break;
            }
        }
        let v = [], O, w = (_, C, A) => v.push(A.range(_, C));
        if (u == f)
          for (this.regexp.lastIndex = p - u.from; (O = this.regexp.exec(u.text)) && O.index < m - u.from; )
            this.addMatch(O, e, O.index + u.from, w);
        else
          nq(e.state.doc, this.regexp, p, m, (_, C) => this.addMatch(C, e, _, w));
        n = n.update({ filterFrom: p, filterTo: m, filter: (_, C) => _ < p || C > m, add: v });
      }
    }
    return n;
  }
}
const A4 = /x/.unicode != null ? "gu" : "g", V2e = /* @__PURE__ */ new RegExp(`[\0-\b
--­؜​‎‏\u2028\u2029‭‮⁦⁧⁩\uFEFF￹-￼]`, A4), Y2e = {
  0: "null",
  7: "bell",
  8: "backspace",
  10: "newline",
  11: "vertical tab",
  13: "carriage return",
  27: "escape",
  8203: "zero width space",
  8204: "zero width non-joiner",
  8205: "zero width joiner",
  8206: "left-to-right mark",
  8207: "right-to-left mark",
  8232: "line separator",
  8237: "left-to-right override",
  8238: "right-to-left override",
  8294: "left-to-right isolate",
  8295: "right-to-left isolate",
  8297: "pop directional isolate",
  8233: "paragraph separator",
  65279: "zero width no-break space",
  65532: "object replacement"
};
let l3 = null;
function Z2e() {
  var t;
  if (l3 == null && typeof document < "u" && document.body) {
    let e = document.body.style;
    l3 = ((t = e.tabSize) !== null && t !== void 0 ? t : e.MozTabSize) != null;
  }
  return l3 || !1;
}
const Ck = /* @__PURE__ */ bn.define({
  combine(t) {
    let e = Dh(t, {
      render: null,
      specialChars: V2e,
      addSpecialChars: null
    });
    return (e.replaceTabs = !Z2e()) && (e.specialChars = new RegExp("	|" + e.specialChars.source, A4)), e.addSpecialChars && (e.specialChars = new RegExp(e.specialChars.source + "|" + e.addSpecialChars.source, A4)), e;
  }
});
function X2e(t = {}) {
  return [Ck.of(t), q2e()];
}
let rq = null;
function q2e() {
  return rq || (rq = Ki.fromClass(class {
    constructor(t) {
      this.view = t, this.decorations = Ln.none, this.decorationCache = /* @__PURE__ */ Object.create(null), this.decorator = this.makeDecorator(t.state.facet(Ck)), this.decorations = this.decorator.createDeco(t);
    }
    makeDecorator(t) {
      return new G2e({
        regexp: t.specialChars,
        decoration: (e, n, r) => {
          let { doc: a } = n.state, i = Ks(e[0], 0);
          if (i == 9) {
            let o = a.lineAt(r), s = n.state.tabSize, u = Xd(o.text, s, r - o.from);
            return Ln.replace({
              widget: new tPe((s - u % s) * this.view.defaultCharacterWidth / this.view.scaleX)
            });
          }
          return this.decorationCache[i] || (this.decorationCache[i] = Ln.replace({ widget: new ePe(t, i) }));
        },
        boundary: t.replaceTabs ? void 0 : /[^]/
      });
    }
    update(t) {
      let e = t.state.facet(Ck);
      t.startState.facet(Ck) != e ? (this.decorator = this.makeDecorator(e), this.decorations = this.decorator.createDeco(t.view)) : this.decorations = this.decorator.updateDeco(t, this.decorations);
    }
  }, {
    decorations: (t) => t.decorations
  }));
}
const K2e = "•";
function J2e(t) {
  return t >= 32 ? K2e : t == 10 ? "␤" : String.fromCharCode(9216 + t);
}
class ePe extends Nh {
  constructor(e, n) {
    super(), this.options = e, this.code = n;
  }
  eq(e) {
    return e.code == this.code;
  }
  toDOM(e) {
    let n = J2e(this.code), r = e.state.phrase("Control character") + " " + (Y2e[this.code] || "0x" + this.code.toString(16)), a = this.options.render && this.options.render(this.code, r, n);
    if (a)
      return a;
    let i = document.createElement("span");
    return i.textContent = n, i.title = r, i.setAttribute("aria-label", r), i.className = "cm-specialChar", i;
  }
  ignoreEvent() {
    return !1;
  }
}
class tPe extends Nh {
  constructor(e) {
    super(), this.width = e;
  }
  eq(e) {
    return e.width == this.width;
  }
  toDOM() {
    let e = document.createElement("span");
    return e.textContent = "	", e.className = "cm-tab", e.style.width = this.width + "px", e;
  }
  ignoreEvent() {
    return !1;
  }
}
function nPe() {
  return aPe;
}
const rPe = /* @__PURE__ */ Ln.line({ class: "cm-activeLine" }), aPe = /* @__PURE__ */ Ki.fromClass(class {
  constructor(t) {
    this.decorations = this.getDeco(t);
  }
  update(t) {
    (t.docChanged || t.selectionSet) && (this.decorations = this.getDeco(t.view));
  }
  getDeco(t) {
    let e = -1, n = [];
    for (let r of t.state.selection.ranges) {
      let a = t.lineBlockAt(r.head);
      a.from > e && (n.push(rPe.range(a.from)), e = a.from);
    }
    return Ln.set(n);
  }
}, {
  decorations: (t) => t.decorations
});
class iPe extends Nh {
  constructor(e) {
    super(), this.content = e;
  }
  toDOM() {
    let e = document.createElement("span");
    return e.className = "cm-placeholder", e.style.pointerEvents = "none", e.appendChild(typeof this.content == "string" ? document.createTextNode(this.content) : this.content), typeof this.content == "string" ? e.setAttribute("aria-label", "placeholder " + this.content) : e.setAttribute("aria-hidden", "true"), e;
  }
  coordsAt(e) {
    let n = e.firstChild ? QE(e.firstChild) : [];
    if (!n.length)
      return null;
    let r = window.getComputedStyle(e.parentNode), a = gD(n[0], r.direction != "rtl"), i = parseInt(r.lineHeight);
    return a.bottom - a.top > i * 1.5 ? { left: a.left, right: a.right, top: a.top, bottom: a.top + i } : a;
  }
  ignoreEvent() {
    return !1;
  }
}
function oPe(t) {
  return Ki.fromClass(class {
    constructor(e) {
      this.view = e, this.placeholder = t ? Ln.set([Ln.widget({ widget: new iPe(t), side: 1 }).range(0)]) : Ln.none;
    }
    get decorations() {
      return this.view.state.doc.length ? Ln.none : this.placeholder;
    }
  }, { decorations: (e) => e.decorations });
}
const k4 = 2e3;
function sPe(t, e, n) {
  let r = Math.min(e.line, n.line), a = Math.max(e.line, n.line), i = [];
  if (e.off > k4 || n.off > k4 || e.col < 0 || n.col < 0) {
    let o = Math.min(e.off, n.off), s = Math.max(e.off, n.off);
    for (let u = r; u <= a; u++) {
      let f = t.doc.line(u);
      f.length <= s && i.push(ft.range(f.from + o, f.to + s));
    }
  } else {
    let o = Math.min(e.col, n.col), s = Math.max(e.col, n.col);
    for (let u = r; u <= a; u++) {
      let f = t.doc.line(u), p = s4(f.text, o, t.tabSize, !0);
      if (p < 0)
        i.push(ft.cursor(f.to));
      else {
        let m = s4(f.text, s, t.tabSize);
        i.push(ft.range(f.from + p, f.from + m));
      }
    }
  }
  return i;
}
function lPe(t, e) {
  let n = t.coordsAtPos(t.viewport.from);
  return n ? Math.round(Math.abs((n.left - e) / t.defaultCharacterWidth)) : -1;
}
function aq(t, e) {
  let n = t.posAtCoords({ x: e.clientX, y: e.clientY }, !1), r = t.state.doc.lineAt(n), a = n - r.from, i = a > k4 ? -1 : a == r.length ? lPe(t, e.clientX) : Xd(r.text, t.state.tabSize, n - r.from);
  return { line: r.number, col: i, off: a };
}
function uPe(t, e) {
  let n = aq(t, e), r = t.state.selection;
  return n ? {
    update(a) {
      if (a.docChanged) {
        let i = a.changes.mapPos(a.startState.doc.line(n.line).from), o = a.state.doc.lineAt(i);
        n = { line: o.number, col: n.col, off: Math.min(n.off, o.length) }, r = r.map(a.changes);
      }
    },
    get(a, i, o) {
      let s = aq(t, a);
      if (!s)
        return r;
      let u = sPe(t.state, n, s);
      return u.length ? o ? ft.create(u.concat(r.ranges)) : ft.create(u) : r;
    }
  } : null;
}
function cPe(t) {
  let e = (t == null ? void 0 : t.eventFilter) || ((n) => n.altKey && n.button == 0);
  return qt.mouseSelectionStyle.of((n, r) => e(r) ? uPe(n, r) : null);
}
const fPe = {
  Alt: [18, (t) => !!t.altKey],
  Control: [17, (t) => !!t.ctrlKey],
  Shift: [16, (t) => !!t.shiftKey],
  Meta: [91, (t) => !!t.metaKey]
}, dPe = { style: "cursor: crosshair" };
function pPe(t = {}) {
  let [e, n] = fPe[t.key || "Alt"], r = Ki.fromClass(class {
    constructor(a) {
      this.view = a, this.isDown = !1;
    }
    set(a) {
      this.isDown != a && (this.isDown = a, this.view.update([]));
    }
  }, {
    eventObservers: {
      keydown(a) {
        this.set(a.keyCode == e || n(a));
      },
      keyup(a) {
        (a.keyCode == e || !n(a)) && this.set(!1);
      },
      mousemove(a) {
        this.set(n(a));
      }
    }
  });
  return [
    r,
    qt.contentAttributes.of((a) => {
      var i;
      return !((i = a.plugin(r)) === null || i === void 0) && i.isDown ? dPe : null;
    })
  ];
}
const Ow = "-10000px";
class Die {
  constructor(e, n, r, a) {
    this.facet = n, this.createTooltipView = r, this.removeTooltipView = a, this.input = e.state.facet(n), this.tooltips = this.input.filter((o) => o);
    let i = null;
    this.tooltipViews = this.tooltips.map((o) => i = r(o, i));
  }
  update(e, n) {
    var r;
    let a = e.state.facet(this.facet), i = a.filter((u) => u);
    if (a === this.input) {
      for (let u of this.tooltipViews)
        u.update && u.update(e);
      return !1;
    }
    let o = [], s = n ? [] : null;
    for (let u = 0; u < i.length; u++) {
      let f = i[u], p = -1;
      if (f) {
        for (let m = 0; m < this.tooltips.length; m++) {
          let v = this.tooltips[m];
          v && v.create == f.create && (p = m);
        }
        if (p < 0)
          o[u] = this.createTooltipView(f, u ? o[u - 1] : null), s && (s[u] = !!f.above);
        else {
          let m = o[u] = this.tooltipViews[p];
          s && (s[u] = n[p]), m.update && m.update(e);
        }
      }
    }
    for (let u of this.tooltipViews)
      o.indexOf(u) < 0 && (this.removeTooltipView(u), (r = u.destroy) === null || r === void 0 || r.call(u));
    return n && (s.forEach((u, f) => n[f] = u), n.length = s.length), this.input = a, this.tooltips = i, this.tooltipViews = o, !0;
  }
}
function hPe(t) {
  let { win: e } = t;
  return { top: 0, left: 0, bottom: e.innerHeight, right: e.innerWidth };
}
const u3 = /* @__PURE__ */ bn.define({
  combine: (t) => {
    var e, n, r;
    return {
      position: vn.ios ? "absolute" : ((e = t.find((a) => a.position)) === null || e === void 0 ? void 0 : e.position) || "fixed",
      parent: ((n = t.find((a) => a.parent)) === null || n === void 0 ? void 0 : n.parent) || null,
      tooltipSpace: ((r = t.find((a) => a.tooltipSpace)) === null || r === void 0 ? void 0 : r.tooltipSpace) || hPe
    };
  }
}), iq = /* @__PURE__ */ new WeakMap(), VU = /* @__PURE__ */ Ki.fromClass(class {
  constructor(t) {
    this.view = t, this.above = [], this.inView = !0, this.madeAbsolute = !1, this.lastTransaction = 0, this.measureTimeout = -1;
    let e = t.state.facet(u3);
    this.position = e.position, this.parent = e.parent, this.classes = t.themeClasses, this.createContainer(), this.measureReq = { read: this.readMeasure.bind(this), write: this.writeMeasure.bind(this), key: this }, this.resizeObserver = typeof ResizeObserver == "function" ? new ResizeObserver(() => this.measureSoon()) : null, this.manager = new Die(t, YU, (n, r) => this.createTooltip(n, r), (n) => {
      this.resizeObserver && this.resizeObserver.unobserve(n.dom), n.dom.remove();
    }), this.above = this.manager.tooltips.map((n) => !!n.above), this.intersectionObserver = typeof IntersectionObserver == "function" ? new IntersectionObserver((n) => {
      Date.now() > this.lastTransaction - 50 && n.length > 0 && n[n.length - 1].intersectionRatio < 1 && this.measureSoon();
    }, { threshold: [1] }) : null, this.observeIntersection(), t.win.addEventListener("resize", this.measureSoon = this.measureSoon.bind(this)), this.maybeMeasure();
  }
  createContainer() {
    this.parent ? (this.container = document.createElement("div"), this.container.style.position = "relative", this.container.className = this.view.themeClasses, this.parent.appendChild(this.container)) : this.container = this.view.dom;
  }
  observeIntersection() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      for (let t of this.manager.tooltipViews)
        this.intersectionObserver.observe(t.dom);
    }
  }
  measureSoon() {
    this.measureTimeout < 0 && (this.measureTimeout = setTimeout(() => {
      this.measureTimeout = -1, this.maybeMeasure();
    }, 50));
  }
  update(t) {
    t.transactions.length && (this.lastTransaction = Date.now());
    let e = this.manager.update(t, this.above);
    e && this.observeIntersection();
    let n = e || t.geometryChanged, r = t.state.facet(u3);
    if (r.position != this.position && !this.madeAbsolute) {
      this.position = r.position;
      for (let a of this.manager.tooltipViews)
        a.dom.style.position = this.position;
      n = !0;
    }
    if (r.parent != this.parent) {
      this.parent && this.container.remove(), this.parent = r.parent, this.createContainer();
      for (let a of this.manager.tooltipViews)
        this.container.appendChild(a.dom);
      n = !0;
    } else
      this.parent && this.view.themeClasses != this.classes && (this.classes = this.container.className = this.view.themeClasses);
    n && this.maybeMeasure();
  }
  createTooltip(t, e) {
    let n = t.create(this.view), r = e ? e.dom : null;
    if (n.dom.classList.add("cm-tooltip"), t.arrow && !n.dom.querySelector(".cm-tooltip > .cm-tooltip-arrow")) {
      let a = document.createElement("div");
      a.className = "cm-tooltip-arrow", n.dom.appendChild(a);
    }
    return n.dom.style.position = this.position, n.dom.style.top = Ow, n.dom.style.left = "0px", this.container.insertBefore(n.dom, r), n.mount && n.mount(this.view), this.resizeObserver && this.resizeObserver.observe(n.dom), n;
  }
  destroy() {
    var t, e, n;
    this.view.win.removeEventListener("resize", this.measureSoon);
    for (let r of this.manager.tooltipViews)
      r.dom.remove(), (t = r.destroy) === null || t === void 0 || t.call(r);
    this.parent && this.container.remove(), (e = this.resizeObserver) === null || e === void 0 || e.disconnect(), (n = this.intersectionObserver) === null || n === void 0 || n.disconnect(), clearTimeout(this.measureTimeout);
  }
  readMeasure() {
    let t = this.view.dom.getBoundingClientRect(), e = 1, n = 1, r = !1;
    if (this.position == "fixed" && this.manager.tooltipViews.length) {
      let { dom: a } = this.manager.tooltipViews[0];
      if (vn.gecko)
        r = a.offsetParent != this.container.ownerDocument.body;
      else if (a.style.top == Ow && a.style.left == "0px") {
        let i = a.getBoundingClientRect();
        r = Math.abs(i.top + 1e4) > 1 || Math.abs(i.left) > 1;
      }
    }
    if (r || this.position == "absolute")
      if (this.parent) {
        let a = this.parent.getBoundingClientRect();
        a.width && a.height && (e = a.width / this.parent.offsetWidth, n = a.height / this.parent.offsetHeight);
      } else
        ({ scaleX: e, scaleY: n } = this.view.viewState);
    return {
      editor: t,
      parent: this.parent ? this.container.getBoundingClientRect() : t,
      pos: this.manager.tooltips.map((a, i) => {
        let o = this.manager.tooltipViews[i];
        return o.getCoords ? o.getCoords(a.pos) : this.view.coordsAtPos(a.pos);
      }),
      size: this.manager.tooltipViews.map(({ dom: a }) => a.getBoundingClientRect()),
      space: this.view.state.facet(u3).tooltipSpace(this.view),
      scaleX: e,
      scaleY: n,
      makeAbsolute: r
    };
  }
  writeMeasure(t) {
    var e;
    if (t.makeAbsolute) {
      this.madeAbsolute = !0, this.position = "absolute";
      for (let s of this.manager.tooltipViews)
        s.dom.style.position = "absolute";
    }
    let { editor: n, space: r, scaleX: a, scaleY: i } = t, o = [];
    for (let s = 0; s < this.manager.tooltips.length; s++) {
      let u = this.manager.tooltips[s], f = this.manager.tooltipViews[s], { dom: p } = f, m = t.pos[s], v = t.size[s];
      if (!m || m.bottom <= Math.max(n.top, r.top) || m.top >= Math.min(n.bottom, r.bottom) || m.right < Math.max(n.left, r.left) - 0.1 || m.left > Math.min(n.right, r.right) + 0.1) {
        p.style.top = Ow;
        continue;
      }
      let O = u.arrow ? f.dom.querySelector(".cm-tooltip-arrow") : null, w = O ? 7 : 0, _ = v.right - v.left, C = (e = iq.get(f)) !== null && e !== void 0 ? e : v.bottom - v.top, A = f.offset || gPe, N = this.view.textDirection == hi.LTR, P = v.width > r.right - r.left ? N ? r.left : r.right - v.width : N ? Math.min(m.left - (O ? 14 : 0) + A.x, r.right - _) : Math.max(r.left, m.left - _ + (O ? 14 : 0) - A.x), I = this.above[s];
      !u.strictSide && (I ? m.top - (v.bottom - v.top) - A.y < r.top : m.bottom + (v.bottom - v.top) + A.y > r.bottom) && I == r.bottom - m.bottom > m.top - r.top && (I = this.above[s] = !I);
      let D = (I ? m.top - r.top : r.bottom - m.bottom) - w;
      if (D < C && f.resize !== !1) {
        if (D < this.view.defaultLineHeight) {
          p.style.top = Ow;
          continue;
        }
        iq.set(f, C), p.style.height = (C = D) / i + "px";
      } else
        p.style.height && (p.style.height = "");
      let M = I ? m.top - C - w - A.y : m.bottom + w + A.y, H = P + _;
      if (f.overlap !== !0)
        for (let Y of o)
          Y.left < H && Y.right > P && Y.top < M + C && Y.bottom > M && (M = I ? Y.top - C - 2 - w : Y.bottom + w + 2);
      if (this.position == "absolute" ? (p.style.top = (M - t.parent.top) / i + "px", p.style.left = (P - t.parent.left) / a + "px") : (p.style.top = M / i + "px", p.style.left = P / a + "px"), O) {
        let Y = m.left + (N ? A.x : -A.x) - (P + 14 - 7);
        O.style.left = Y / a + "px";
      }
      f.overlap !== !0 && o.push({ left: P, top: M, right: H, bottom: M + C }), p.classList.toggle("cm-tooltip-above", I), p.classList.toggle("cm-tooltip-below", !I), f.positioned && f.positioned(t.space);
    }
  }
  maybeMeasure() {
    if (this.manager.tooltips.length && (this.view.inView && this.view.requestMeasure(this.measureReq), this.inView != this.view.inView && (this.inView = this.view.inView, !this.inView)))
      for (let t of this.manager.tooltipViews)
        t.dom.style.top = Ow;
  }
}, {
  eventObservers: {
    scroll() {
      this.maybeMeasure();
    }
  }
}), mPe = /* @__PURE__ */ qt.baseTheme({
  ".cm-tooltip": {
    zIndex: 100,
    boxSizing: "border-box"
  },
  "&light .cm-tooltip": {
    border: "1px solid #bbb",
    backgroundColor: "#f5f5f5"
  },
  "&light .cm-tooltip-section:not(:first-child)": {
    borderTop: "1px solid #bbb"
  },
  "&dark .cm-tooltip": {
    backgroundColor: "#333338",
    color: "white"
  },
  ".cm-tooltip-arrow": {
    height: "7px",
    width: `${7 * 2}px`,
    position: "absolute",
    zIndex: -1,
    overflow: "hidden",
    "&:before, &:after": {
      content: "''",
      position: "absolute",
      width: 0,
      height: 0,
      borderLeft: "7px solid transparent",
      borderRight: "7px solid transparent"
    },
    ".cm-tooltip-above &": {
      bottom: "-7px",
      "&:before": {
        borderTop: "7px solid #bbb"
      },
      "&:after": {
        borderTop: "7px solid #f5f5f5",
        bottom: "1px"
      }
    },
    ".cm-tooltip-below &": {
      top: "-7px",
      "&:before": {
        borderBottom: "7px solid #bbb"
      },
      "&:after": {
        borderBottom: "7px solid #f5f5f5",
        top: "1px"
      }
    }
  },
  "&dark .cm-tooltip .cm-tooltip-arrow": {
    "&:before": {
      borderTopColor: "#333338",
      borderBottomColor: "#333338"
    },
    "&:after": {
      borderTopColor: "transparent",
      borderBottomColor: "transparent"
    }
  }
}), gPe = { x: 0, y: 0 }, YU = /* @__PURE__ */ bn.define({
  enables: [VU, mPe]
}), sI = /* @__PURE__ */ bn.define({
  combine: (t) => t.reduce((e, n) => e.concat(n), [])
});
class yD {
  // Needs to be static so that host tooltip instances always match
  static create(e) {
    return new yD(e);
  }
  constructor(e) {
    this.view = e, this.mounted = !1, this.dom = document.createElement("div"), this.dom.classList.add("cm-tooltip-hover"), this.manager = new Die(e, sI, (n, r) => this.createHostedView(n, r), (n) => n.dom.remove());
  }
  createHostedView(e, n) {
    let r = e.create(this.view);
    return r.dom.classList.add("cm-tooltip-section"), this.dom.insertBefore(r.dom, n ? n.dom.nextSibling : this.dom.firstChild), this.mounted && r.mount && r.mount(this.view), r;
  }
  mount(e) {
    for (let n of this.manager.tooltipViews)
      n.mount && n.mount(e);
    this.mounted = !0;
  }
  positioned(e) {
    for (let n of this.manager.tooltipViews)
      n.positioned && n.positioned(e);
  }
  update(e) {
    this.manager.update(e);
  }
  destroy() {
    var e;
    for (let n of this.manager.tooltipViews)
      (e = n.destroy) === null || e === void 0 || e.call(n);
  }
  passProp(e) {
    let n;
    for (let r of this.manager.tooltipViews) {
      let a = r[e];
      if (a !== void 0) {
        if (n === void 0)
          n = a;
        else if (n !== a)
          return;
      }
    }
    return n;
  }
  get offset() {
    return this.passProp("offset");
  }
  get getCoords() {
    return this.passProp("getCoords");
  }
  get overlap() {
    return this.passProp("overlap");
  }
  get resize() {
    return this.passProp("resize");
  }
}
const bPe = /* @__PURE__ */ YU.compute([sI], (t) => {
  let e = t.facet(sI);
  return e.length === 0 ? null : {
    pos: Math.min(...e.map((n) => n.pos)),
    end: Math.max(...e.map((n) => {
      var r;
      return (r = n.end) !== null && r !== void 0 ? r : n.pos;
    })),
    create: yD.create,
    above: e[0].above,
    arrow: e.some((n) => n.arrow)
  };
});
class vPe {
  constructor(e, n, r, a, i) {
    this.view = e, this.source = n, this.field = r, this.setHover = a, this.hoverTime = i, this.hoverTimeout = -1, this.restartTimeout = -1, this.pending = null, this.lastMove = { x: 0, y: 0, target: e.dom, time: 0 }, this.checkHover = this.checkHover.bind(this), e.dom.addEventListener("mouseleave", this.mouseleave = this.mouseleave.bind(this)), e.dom.addEventListener("mousemove", this.mousemove = this.mousemove.bind(this));
  }
  update() {
    this.pending && (this.pending = null, clearTimeout(this.restartTimeout), this.restartTimeout = setTimeout(() => this.startHover(), 20));
  }
  get active() {
    return this.view.state.field(this.field);
  }
  checkHover() {
    if (this.hoverTimeout = -1, this.active.length)
      return;
    let e = Date.now() - this.lastMove.time;
    e < this.hoverTime ? this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime - e) : this.startHover();
  }
  startHover() {
    clearTimeout(this.restartTimeout);
    let { view: e, lastMove: n } = this, r = e.docView.nearest(n.target);
    if (!r)
      return;
    let a, i = 1;
    if (r instanceof Qb)
      a = r.posAtStart;
    else {
      if (a = e.posAtCoords(n), a == null)
        return;
      let s = e.coordsAtPos(a);
      if (!s || n.y < s.top || n.y > s.bottom || n.x < s.left - e.defaultCharacterWidth || n.x > s.right + e.defaultCharacterWidth)
        return;
      let u = e.bidiSpans(e.state.doc.lineAt(a)).find((p) => p.from <= a && p.to >= a), f = u && u.dir == hi.RTL ? -1 : 1;
      i = n.x < s.left ? -f : f;
    }
    let o = this.source(e, a, i);
    if (o != null && o.then) {
      let s = this.pending = { pos: a };
      o.then((u) => {
        this.pending == s && (this.pending = null, u && !(Array.isArray(u) && !u.length) && e.dispatch({ effects: this.setHover.of(Array.isArray(u) ? u : [u]) }));
      }, (u) => Ku(e.state, u, "hover tooltip"));
    } else
      o && !(Array.isArray(o) && !o.length) && e.dispatch({ effects: this.setHover.of(Array.isArray(o) ? o : [o]) });
  }
  get tooltip() {
    let e = this.view.plugin(VU), n = e ? e.manager.tooltips.findIndex((r) => r.create == yD.create) : -1;
    return n > -1 ? e.manager.tooltipViews[n] : null;
  }
  mousemove(e) {
    var n, r;
    this.lastMove = { x: e.clientX, y: e.clientY, target: e.target, time: Date.now() }, this.hoverTimeout < 0 && (this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime));
    let { active: a, tooltip: i } = this;
    if (a.length && i && !yPe(i.dom, e) || this.pending) {
      let { pos: o } = a[0] || this.pending, s = (r = (n = a[0]) === null || n === void 0 ? void 0 : n.end) !== null && r !== void 0 ? r : o;
      (o == s ? this.view.posAtCoords(this.lastMove) != o : !OPe(this.view, o, s, e.clientX, e.clientY)) && (this.view.dispatch({ effects: this.setHover.of([]) }), this.pending = null);
    }
  }
  mouseleave(e) {
    clearTimeout(this.hoverTimeout), this.hoverTimeout = -1;
    let { active: n } = this;
    if (n.length) {
      let { tooltip: r } = this;
      r && r.dom.contains(e.relatedTarget) ? this.watchTooltipLeave(r.dom) : this.view.dispatch({ effects: this.setHover.of([]) });
    }
  }
  watchTooltipLeave(e) {
    let n = (r) => {
      e.removeEventListener("mouseleave", n), this.active.length && !this.view.dom.contains(r.relatedTarget) && this.view.dispatch({ effects: this.setHover.of([]) });
    };
    e.addEventListener("mouseleave", n);
  }
  destroy() {
    clearTimeout(this.hoverTimeout), this.view.dom.removeEventListener("mouseleave", this.mouseleave), this.view.dom.removeEventListener("mousemove", this.mousemove);
  }
}
const Zx = 4;
function yPe(t, e) {
  let n = t.getBoundingClientRect();
  return e.clientX >= n.left - Zx && e.clientX <= n.right + Zx && e.clientY >= n.top - Zx && e.clientY <= n.bottom + Zx;
}
function OPe(t, e, n, r, a, i) {
  let o = t.scrollDOM.getBoundingClientRect(), s = t.documentTop + t.documentPadding.top + t.contentHeight;
  if (o.left > r || o.right < r || o.top > a || Math.min(o.bottom, s) < a)
    return !1;
  let u = t.posAtCoords({ x: r, y: a }, !1);
  return u >= e && u <= n;
}
function EPe(t, e = {}) {
  let n = fr.define(), r = Ss.define({
    create() {
      return [];
    },
    update(a, i) {
      if (a.length && (e.hideOnChange && (i.docChanged || i.selection) ? a = [] : e.hideOn && (a = a.filter((o) => !e.hideOn(i, o))), i.docChanged)) {
        let o = [];
        for (let s of a) {
          let u = i.changes.mapPos(s.pos, -1, el.TrackDel);
          if (u != null) {
            let f = Object.assign(/* @__PURE__ */ Object.create(null), s);
            f.pos = u, f.end != null && (f.end = i.changes.mapPos(f.end)), o.push(f);
          }
        }
        a = o;
      }
      for (let o of i.effects)
        o.is(n) && (a = o.value), o.is(SPe) && (a = []);
      return a;
    },
    provide: (a) => sI.from(a)
  });
  return [
    r,
    Ki.define((a) => new vPe(
      a,
      t,
      r,
      n,
      e.hoverTime || 300
      /* Hover.Time */
    )),
    bPe
  ];
}
function Nie(t, e) {
  let n = t.plugin(VU);
  if (!n)
    return null;
  let r = n.manager.tooltips.indexOf(e);
  return r < 0 ? null : n.manager.tooltipViews[r];
}
const SPe = /* @__PURE__ */ fr.define(), oq = /* @__PURE__ */ bn.define({
  combine(t) {
    let e, n;
    for (let r of t)
      e = e || r.topContainer, n = n || r.bottomContainer;
    return { topContainer: e, bottomContainer: n };
  }
});
function WT(t, e) {
  let n = t.plugin(Pie), r = n ? n.specs.indexOf(e) : -1;
  return r > -1 ? n.panels[r] : null;
}
const Pie = /* @__PURE__ */ Ki.fromClass(class {
  constructor(t) {
    this.input = t.state.facet(QT), this.specs = this.input.filter((n) => n), this.panels = this.specs.map((n) => n(t));
    let e = t.state.facet(oq);
    this.top = new Xx(t, !0, e.topContainer), this.bottom = new Xx(t, !1, e.bottomContainer), this.top.sync(this.panels.filter((n) => n.top)), this.bottom.sync(this.panels.filter((n) => !n.top));
    for (let n of this.panels)
      n.dom.classList.add("cm-panel"), n.mount && n.mount();
  }
  update(t) {
    let e = t.state.facet(oq);
    this.top.container != e.topContainer && (this.top.sync([]), this.top = new Xx(t.view, !0, e.topContainer)), this.bottom.container != e.bottomContainer && (this.bottom.sync([]), this.bottom = new Xx(t.view, !1, e.bottomContainer)), this.top.syncClasses(), this.bottom.syncClasses();
    let n = t.state.facet(QT);
    if (n != this.input) {
      let r = n.filter((u) => u), a = [], i = [], o = [], s = [];
      for (let u of r) {
        let f = this.specs.indexOf(u), p;
        f < 0 ? (p = u(t.view), s.push(p)) : (p = this.panels[f], p.update && p.update(t)), a.push(p), (p.top ? i : o).push(p);
      }
      this.specs = r, this.panels = a, this.top.sync(i), this.bottom.sync(o);
      for (let u of s)
        u.dom.classList.add("cm-panel"), u.mount && u.mount();
    } else
      for (let r of this.panels)
        r.update && r.update(t);
  }
  destroy() {
    this.top.sync([]), this.bottom.sync([]);
  }
}, {
  provide: (t) => qt.scrollMargins.of((e) => {
    let n = e.plugin(t);
    return n && { top: n.top.scrollMargin(), bottom: n.bottom.scrollMargin() };
  })
});
class Xx {
  constructor(e, n, r) {
    this.view = e, this.top = n, this.container = r, this.dom = void 0, this.classes = "", this.panels = [], this.syncClasses();
  }
  sync(e) {
    for (let n of this.panels)
      n.destroy && e.indexOf(n) < 0 && n.destroy();
    this.panels = e, this.syncDOM();
  }
  syncDOM() {
    if (this.panels.length == 0) {
      this.dom && (this.dom.remove(), this.dom = void 0);
      return;
    }
    if (!this.dom) {
      this.dom = document.createElement("div"), this.dom.className = this.top ? "cm-panels cm-panels-top" : "cm-panels cm-panels-bottom", this.dom.style[this.top ? "top" : "bottom"] = "0";
      let n = this.container || this.view.dom;
      n.insertBefore(this.dom, this.top ? n.firstChild : null);
    }
    let e = this.dom.firstChild;
    for (let n of this.panels)
      if (n.dom.parentNode == this.dom) {
        for (; e != n.dom; )
          e = sq(e);
        e = e.nextSibling;
      } else
        this.dom.insertBefore(n.dom, e);
    for (; e; )
      e = sq(e);
  }
  scrollMargin() {
    return !this.dom || this.container ? 0 : Math.max(0, this.top ? this.dom.getBoundingClientRect().bottom - Math.max(0, this.view.scrollDOM.getBoundingClientRect().top) : Math.min(innerHeight, this.view.scrollDOM.getBoundingClientRect().bottom) - this.dom.getBoundingClientRect().top);
  }
  syncClasses() {
    if (!(!this.container || this.classes == this.view.themeClasses)) {
      for (let e of this.classes.split(" "))
        e && this.container.classList.remove(e);
      for (let e of (this.classes = this.view.themeClasses).split(" "))
        e && this.container.classList.add(e);
    }
  }
}
function sq(t) {
  let e = t.nextSibling;
  return t.remove(), e;
}
const QT = /* @__PURE__ */ bn.define({
  enables: Pie
});
class rg extends c0 {
  /**
  @internal
  */
  compare(e) {
    return this == e || this.constructor == e.constructor && this.eq(e);
  }
  /**
  Compare this marker to another marker of the same type.
  */
  eq(e) {
    return !1;
  }
  /**
  Called if the marker has a `toDOM` method and its representation
  was removed from a gutter.
  */
  destroy(e) {
  }
}
rg.prototype.elementClass = "";
rg.prototype.toDOM = void 0;
rg.prototype.mapMode = el.TrackBefore;
rg.prototype.startSide = rg.prototype.endSide = -1;
rg.prototype.point = !0;
const xk = /* @__PURE__ */ bn.define(), wPe = {
  class: "",
  renderEmptyElements: !1,
  elementStyle: "",
  markers: () => ta.empty,
  lineMarker: () => null,
  widgetMarker: () => null,
  lineMarkerChange: null,
  initialSpacer: null,
  updateSpacer: null,
  domEventHandlers: {}
}, uT = /* @__PURE__ */ bn.define();
function TPe(t) {
  return [Lie(), uT.of(Object.assign(Object.assign({}, wPe), t))];
}
const R4 = /* @__PURE__ */ bn.define({
  combine: (t) => t.some((e) => e)
});
function Lie(t) {
  let e = [
    _Pe
  ];
  return t && t.fixed === !1 && e.push(R4.of(!0)), e;
}
const _Pe = /* @__PURE__ */ Ki.fromClass(class {
  constructor(t) {
    this.view = t, this.prevViewport = t.viewport, this.dom = document.createElement("div"), this.dom.className = "cm-gutters", this.dom.setAttribute("aria-hidden", "true"), this.dom.style.minHeight = this.view.contentHeight / this.view.scaleY + "px", this.gutters = t.state.facet(uT).map((e) => new uq(t, e));
    for (let e of this.gutters)
      this.dom.appendChild(e.dom);
    this.fixed = !t.state.facet(R4), this.fixed && (this.dom.style.position = "sticky"), this.syncGutters(!1), t.scrollDOM.insertBefore(this.dom, t.contentDOM);
  }
  update(t) {
    if (this.updateGutters(t)) {
      let e = this.prevViewport, n = t.view.viewport, r = Math.min(e.to, n.to) - Math.max(e.from, n.from);
      this.syncGutters(r < (n.to - n.from) * 0.8);
    }
    t.geometryChanged && (this.dom.style.minHeight = this.view.contentHeight / this.view.scaleY + "px"), this.view.state.facet(R4) != !this.fixed && (this.fixed = !this.fixed, this.dom.style.position = this.fixed ? "sticky" : ""), this.prevViewport = t.view.viewport;
  }
  syncGutters(t) {
    let e = this.dom.nextSibling;
    t && this.dom.remove();
    let n = ta.iter(this.view.state.facet(xk), this.view.viewport.from), r = [], a = this.gutters.map((i) => new CPe(i, this.view.viewport, -this.view.documentPadding.top));
    for (let i of this.view.viewportLineBlocks)
      if (r.length && (r = []), Array.isArray(i.type)) {
        let o = !0;
        for (let s of i.type)
          if (s.type == du.Text && o) {
            I4(n, r, s.from);
            for (let u of a)
              u.line(this.view, s, r);
            o = !1;
          } else if (s.widget)
            for (let u of a)
              u.widget(this.view, s);
      } else if (i.type == du.Text) {
        I4(n, r, i.from);
        for (let o of a)
          o.line(this.view, i, r);
      } else if (i.widget)
        for (let o of a)
          o.widget(this.view, i);
    for (let i of a)
      i.finish();
    t && this.view.scrollDOM.insertBefore(this.dom, e);
  }
  updateGutters(t) {
    let e = t.startState.facet(uT), n = t.state.facet(uT), r = t.docChanged || t.heightChanged || t.viewportChanged || !ta.eq(t.startState.facet(xk), t.state.facet(xk), t.view.viewport.from, t.view.viewport.to);
    if (e == n)
      for (let a of this.gutters)
        a.update(t) && (r = !0);
    else {
      r = !0;
      let a = [];
      for (let i of n) {
        let o = e.indexOf(i);
        o < 0 ? a.push(new uq(this.view, i)) : (this.gutters[o].update(t), a.push(this.gutters[o]));
      }
      for (let i of this.gutters)
        i.dom.remove(), a.indexOf(i) < 0 && i.destroy();
      for (let i of a)
        this.dom.appendChild(i.dom);
      this.gutters = a;
    }
    return r;
  }
  destroy() {
    for (let t of this.gutters)
      t.destroy();
    this.dom.remove();
  }
}, {
  provide: (t) => qt.scrollMargins.of((e) => {
    let n = e.plugin(t);
    return !n || n.gutters.length == 0 || !n.fixed ? null : e.textDirection == hi.LTR ? { left: n.dom.offsetWidth * e.scaleX } : { right: n.dom.offsetWidth * e.scaleX };
  })
});
function lq(t) {
  return Array.isArray(t) ? t : [t];
}
function I4(t, e, n) {
  for (; t.value && t.from <= n; )
    t.from == n && e.push(t.value), t.next();
}
class CPe {
  constructor(e, n, r) {
    this.gutter = e, this.height = r, this.i = 0, this.cursor = ta.iter(e.markers, n.from);
  }
  addElement(e, n, r) {
    let { gutter: a } = this, i = (n.top - this.height) / e.scaleY, o = n.height / e.scaleY;
    if (this.i == a.elements.length) {
      let s = new Mie(e, o, i, r);
      a.elements.push(s), a.dom.appendChild(s.dom);
    } else
      a.elements[this.i].update(e, o, i, r);
    this.height = n.bottom, this.i++;
  }
  line(e, n, r) {
    let a = [];
    I4(this.cursor, a, n.from), r.length && (a = a.concat(r));
    let i = this.gutter.config.lineMarker(e, n, a);
    i && a.unshift(i);
    let o = this.gutter;
    a.length == 0 && !o.config.renderEmptyElements || this.addElement(e, n, a);
  }
  widget(e, n) {
    let r = this.gutter.config.widgetMarker(e, n.widget, n);
    r && this.addElement(e, n, [r]);
  }
  finish() {
    let e = this.gutter;
    for (; e.elements.length > this.i; ) {
      let n = e.elements.pop();
      e.dom.removeChild(n.dom), n.destroy();
    }
  }
}
class uq {
  constructor(e, n) {
    this.view = e, this.config = n, this.elements = [], this.spacer = null, this.dom = document.createElement("div"), this.dom.className = "cm-gutter" + (this.config.class ? " " + this.config.class : "");
    for (let r in n.domEventHandlers)
      this.dom.addEventListener(r, (a) => {
        let i = a.target, o;
        if (i != this.dom && this.dom.contains(i)) {
          for (; i.parentNode != this.dom; )
            i = i.parentNode;
          let u = i.getBoundingClientRect();
          o = (u.top + u.bottom) / 2;
        } else
          o = a.clientY;
        let s = e.lineBlockAtHeight(o - e.documentTop);
        n.domEventHandlers[r](e, s, a) && a.preventDefault();
      });
    this.markers = lq(n.markers(e)), n.initialSpacer && (this.spacer = new Mie(e, 0, 0, [n.initialSpacer(e)]), this.dom.appendChild(this.spacer.dom), this.spacer.dom.style.cssText += "visibility: hidden; pointer-events: none");
  }
  update(e) {
    let n = this.markers;
    if (this.markers = lq(this.config.markers(e.view)), this.spacer && this.config.updateSpacer) {
      let a = this.config.updateSpacer(this.spacer.markers[0], e);
      a != this.spacer.markers[0] && this.spacer.update(e.view, 0, 0, [a]);
    }
    let r = e.view.viewport;
    return !ta.eq(this.markers, n, r.from, r.to) || (this.config.lineMarkerChange ? this.config.lineMarkerChange(e) : !1);
  }
  destroy() {
    for (let e of this.elements)
      e.destroy();
  }
}
class Mie {
  constructor(e, n, r, a) {
    this.height = -1, this.above = 0, this.markers = [], this.dom = document.createElement("div"), this.dom.className = "cm-gutterElement", this.update(e, n, r, a);
  }
  update(e, n, r, a) {
    this.height != n && (this.height = n, this.dom.style.height = n + "px"), this.above != r && (this.dom.style.marginTop = (this.above = r) ? r + "px" : ""), xPe(this.markers, a) || this.setMarkers(e, a);
  }
  setMarkers(e, n) {
    let r = "cm-gutterElement", a = this.dom.firstChild;
    for (let i = 0, o = 0; ; ) {
      let s = o, u = i < n.length ? n[i++] : null, f = !1;
      if (u) {
        let p = u.elementClass;
        p && (r += " " + p);
        for (let m = o; m < this.markers.length; m++)
          if (this.markers[m].compare(u)) {
            s = m, f = !0;
            break;
          }
      } else
        s = this.markers.length;
      for (; o < s; ) {
        let p = this.markers[o++];
        if (p.toDOM) {
          p.destroy(a);
          let m = a.nextSibling;
          a.remove(), a = m;
        }
      }
      if (!u)
        break;
      u.toDOM && (f ? a = a.nextSibling : this.dom.insertBefore(u.toDOM(e), a)), f && o++;
    }
    this.dom.className = r, this.markers = n;
  }
  destroy() {
    this.setMarkers(null, []);
  }
}
function xPe(t, e) {
  if (t.length != e.length)
    return !1;
  for (let n = 0; n < t.length; n++)
    if (!t[n].compare(e[n]))
      return !1;
  return !0;
}
const APe = /* @__PURE__ */ bn.define(), vE = /* @__PURE__ */ bn.define({
  combine(t) {
    return Dh(t, { formatNumber: String, domEventHandlers: {} }, {
      domEventHandlers(e, n) {
        let r = Object.assign({}, e);
        for (let a in n) {
          let i = r[a], o = n[a];
          r[a] = i ? (s, u, f) => i(s, u, f) || o(s, u, f) : o;
        }
        return r;
      }
    });
  }
});
class c3 extends rg {
  constructor(e) {
    super(), this.number = e;
  }
  eq(e) {
    return this.number == e.number;
  }
  toDOM() {
    return document.createTextNode(this.number);
  }
}
function f3(t, e) {
  return t.state.facet(vE).formatNumber(e, t.state);
}
const kPe = /* @__PURE__ */ uT.compute([vE], (t) => ({
  class: "cm-lineNumbers",
  renderEmptyElements: !1,
  markers(e) {
    return e.state.facet(APe);
  },
  lineMarker(e, n, r) {
    return r.some((a) => a.toDOM) ? null : new c3(f3(e, e.state.doc.lineAt(n.from).number));
  },
  widgetMarker: () => null,
  lineMarkerChange: (e) => e.startState.facet(vE) != e.state.facet(vE),
  initialSpacer(e) {
    return new c3(f3(e, cq(e.state.doc.lines)));
  },
  updateSpacer(e, n) {
    let r = f3(n.view, cq(n.view.state.doc.lines));
    return r == e.number ? e : new c3(r);
  },
  domEventHandlers: t.facet(vE).domEventHandlers
}));
function RPe(t = {}) {
  return [
    vE.of(t),
    Lie(),
    kPe
  ];
}
function cq(t) {
  let e = 9;
  for (; e < t; )
    e = e * 10 + 9;
  return e;
}
const IPe = /* @__PURE__ */ new class extends rg {
  constructor() {
    super(...arguments), this.elementClass = "cm-activeLineGutter";
  }
}(), DPe = /* @__PURE__ */ xk.compute(["selection"], (t) => {
  let e = [], n = -1;
  for (let r of t.selection.ranges) {
    let a = t.doc.lineAt(r.head).from;
    a > n && (n = a, e.push(IPe.range(a)));
  }
  return ta.of(e);
});
function NPe() {
  return DPe;
}
const Fie = 1024;
let PPe = 0;
class zf {
  constructor(e, n) {
    this.from = e, this.to = n;
  }
}
class nr {
  /**
  Create a new node prop type.
  */
  constructor(e = {}) {
    this.id = PPe++, this.perNode = !!e.perNode, this.deserialize = e.deserialize || (() => {
      throw new Error("This node type doesn't define a deserialize function");
    });
  }
  /**
  This is meant to be used with
  [`NodeSet.extend`](#common.NodeSet.extend) or
  [`LRParser.configure`](#lr.ParserConfig.props) to compute
  prop values for each node type in the set. Takes a [match
  object](#common.NodeType^match) or function that returns undefined
  if the node type doesn't get this prop, and the prop's value if
  it does.
  */
  add(e) {
    if (this.perNode)
      throw new RangeError("Can't add per-node props to node types");
    return typeof e != "function" && (e = Po.match(e)), (n) => {
      let r = e(n);
      return r === void 0 ? null : [this, r];
    };
  }
}
nr.closedBy = new nr({ deserialize: (t) => t.split(" ") });
nr.openedBy = new nr({ deserialize: (t) => t.split(" ") });
nr.group = new nr({ deserialize: (t) => t.split(" ") });
nr.isolate = new nr({ deserialize: (t) => {
  if (t && t != "rtl" && t != "ltr" && t != "auto")
    throw new RangeError("Invalid value for isolate: " + t);
  return t || "auto";
} });
nr.contextHash = new nr({ perNode: !0 });
nr.lookAhead = new nr({ perNode: !0 });
nr.mounted = new nr({ perNode: !0 });
class jT {
  constructor(e, n, r) {
    this.tree = e, this.overlay = n, this.parser = r;
  }
  /**
  @internal
  */
  static get(e) {
    return e && e.props && e.props[nr.mounted.id];
  }
}
const LPe = /* @__PURE__ */ Object.create(null);
class Po {
  /**
  @internal
  */
  constructor(e, n, r, a = 0) {
    this.name = e, this.props = n, this.id = r, this.flags = a;
  }
  /**
  Define a node type.
  */
  static define(e) {
    let n = e.props && e.props.length ? /* @__PURE__ */ Object.create(null) : LPe, r = (e.top ? 1 : 0) | (e.skipped ? 2 : 0) | (e.error ? 4 : 0) | (e.name == null ? 8 : 0), a = new Po(e.name || "", n, e.id, r);
    if (e.props) {
      for (let i of e.props)
        if (Array.isArray(i) || (i = i(a)), i) {
          if (i[0].perNode)
            throw new RangeError("Can't store a per-node prop on a node type");
          n[i[0].id] = i[1];
        }
    }
    return a;
  }
  /**
  Retrieves a node prop for this type. Will return `undefined` if
  the prop isn't present on this node.
  */
  prop(e) {
    return this.props[e.id];
  }
  /**
  True when this is the top node of a grammar.
  */
  get isTop() {
    return (this.flags & 1) > 0;
  }
  /**
  True when this node is produced by a skip rule.
  */
  get isSkipped() {
    return (this.flags & 2) > 0;
  }
  /**
  Indicates whether this is an error node.
  */
  get isError() {
    return (this.flags & 4) > 0;
  }
  /**
  When true, this node type doesn't correspond to a user-declared
  named node, for example because it is used to cache repetition.
  */
  get isAnonymous() {
    return (this.flags & 8) > 0;
  }
  /**
  Returns true when this node's name or one of its
  [groups](#common.NodeProp^group) matches the given string.
  */
  is(e) {
    if (typeof e == "string") {
      if (this.name == e)
        return !0;
      let n = this.prop(nr.group);
      return n ? n.indexOf(e) > -1 : !1;
    }
    return this.id == e;
  }
  /**
  Create a function from node types to arbitrary values by
  specifying an object whose property names are node or
  [group](#common.NodeProp^group) names. Often useful with
  [`NodeProp.add`](#common.NodeProp.add). You can put multiple
  names, separated by spaces, in a single property name to map
  multiple node names to a single value.
  */
  static match(e) {
    let n = /* @__PURE__ */ Object.create(null);
    for (let r in e)
      for (let a of r.split(" "))
        n[a] = e[r];
    return (r) => {
      for (let a = r.prop(nr.group), i = -1; i < (a ? a.length : 0); i++) {
        let o = n[i < 0 ? r.name : a[i]];
        if (o)
          return o;
      }
    };
  }
}
Po.none = new Po(
  "",
  /* @__PURE__ */ Object.create(null),
  0,
  8
  /* NodeFlag.Anonymous */
);
class u1 {
  /**
  Create a set with the given types. The `id` property of each
  type should correspond to its position within the array.
  */
  constructor(e) {
    this.types = e;
    for (let n = 0; n < e.length; n++)
      if (e[n].id != n)
        throw new RangeError("Node type ids should correspond to array positions when creating a node set");
  }
  /**
  Create a copy of this set with some node properties added. The
  arguments to this method can be created with
  [`NodeProp.add`](#common.NodeProp.add).
  */
  extend(...e) {
    let n = [];
    for (let r of this.types) {
      let a = null;
      for (let i of e) {
        let o = i(r);
        o && (a || (a = Object.assign({}, r.props)), a[o[0].id] = o[1]);
      }
      n.push(a ? new Po(r.name, a, r.id, r.flags) : r);
    }
    return new u1(n);
  }
}
const qx = /* @__PURE__ */ new WeakMap(), fq = /* @__PURE__ */ new WeakMap();
var ii;
(function(t) {
  t[t.ExcludeBuffers = 1] = "ExcludeBuffers", t[t.IncludeAnonymous = 2] = "IncludeAnonymous", t[t.IgnoreMounts = 4] = "IgnoreMounts", t[t.IgnoreOverlays = 8] = "IgnoreOverlays";
})(ii || (ii = {}));
class Pr {
  /**
  Construct a new tree. See also [`Tree.build`](#common.Tree^build).
  */
  constructor(e, n, r, a, i) {
    if (this.type = e, this.children = n, this.positions = r, this.length = a, this.props = null, i && i.length) {
      this.props = /* @__PURE__ */ Object.create(null);
      for (let [o, s] of i)
        this.props[typeof o == "number" ? o : o.id] = s;
    }
  }
  /**
  @internal
  */
  toString() {
    let e = jT.get(this);
    if (e && !e.overlay)
      return e.tree.toString();
    let n = "";
    for (let r of this.children) {
      let a = r.toString();
      a && (n && (n += ","), n += a);
    }
    return this.type.name ? (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (n.length ? "(" + n + ")" : "") : n;
  }
  /**
  Get a [tree cursor](#common.TreeCursor) positioned at the top of
  the tree. Mode can be used to [control](#common.IterMode) which
  nodes the cursor visits.
  */
  cursor(e = 0) {
    return new lI(this.topNode, e);
  }
  /**
  Get a [tree cursor](#common.TreeCursor) pointing into this tree
  at the given position and side (see
  [`moveTo`](#common.TreeCursor.moveTo).
  */
  cursorAt(e, n = 0, r = 0) {
    let a = qx.get(this) || this.topNode, i = new lI(a);
    return i.moveTo(e, n), qx.set(this, i._tree), i;
  }
  /**
  Get a [syntax node](#common.SyntaxNode) object for the top of the
  tree.
  */
  get topNode() {
    return new Dl(this, 0, 0, null);
  }
  /**
  Get the [syntax node](#common.SyntaxNode) at the given position.
  If `side` is -1, this will move into nodes that end at the
  position. If 1, it'll move into nodes that start at the
  position. With 0, it'll only enter nodes that cover the position
  from both sides.
  
  Note that this will not enter
  [overlays](#common.MountedTree.overlay), and you often want
  [`resolveInner`](#common.Tree.resolveInner) instead.
  */
  resolve(e, n = 0) {
    let r = GT(qx.get(this) || this.topNode, e, n, !1);
    return qx.set(this, r), r;
  }
  /**
  Like [`resolve`](#common.Tree.resolve), but will enter
  [overlaid](#common.MountedTree.overlay) nodes, producing a syntax node
  pointing into the innermost overlaid tree at the given position
  (with parent links going through all parent structure, including
  the host trees).
  */
  resolveInner(e, n = 0) {
    let r = GT(fq.get(this) || this.topNode, e, n, !0);
    return fq.set(this, r), r;
  }
  /**
  In some situations, it can be useful to iterate through all
  nodes around a position, including those in overlays that don't
  directly cover the position. This method gives you an iterator
  that will produce all nodes, from small to big, around the given
  position.
  */
  resolveStack(e, n = 0) {
    return $Pe(this, e, n);
  }
  /**
  Iterate over the tree and its children, calling `enter` for any
  node that touches the `from`/`to` region (if given) before
  running over such a node's children, and `leave` (if given) when
  leaving the node. When `enter` returns `false`, that node will
  not have its children iterated over (or `leave` called).
  */
  iterate(e) {
    let { enter: n, leave: r, from: a = 0, to: i = this.length } = e, o = e.mode || 0, s = (o & ii.IncludeAnonymous) > 0;
    for (let u = this.cursor(o | ii.IncludeAnonymous); ; ) {
      let f = !1;
      if (u.from <= i && u.to >= a && (!s && u.type.isAnonymous || n(u) !== !1)) {
        if (u.firstChild())
          continue;
        f = !0;
      }
      for (; f && r && (s || !u.type.isAnonymous) && r(u), !u.nextSibling(); ) {
        if (!u.parent())
          return;
        f = !0;
      }
    }
  }
  /**
  Get the value of the given [node prop](#common.NodeProp) for this
  node. Works with both per-node and per-type props.
  */
  prop(e) {
    return e.perNode ? this.props ? this.props[e.id] : void 0 : this.type.prop(e);
  }
  /**
  Returns the node's [per-node props](#common.NodeProp.perNode) in a
  format that can be passed to the [`Tree`](#common.Tree)
  constructor.
  */
  get propValues() {
    let e = [];
    if (this.props)
      for (let n in this.props)
        e.push([+n, this.props[n]]);
    return e;
  }
  /**
  Balance the direct children of this tree, producing a copy of
  which may have children grouped into subtrees with type
  [`NodeType.none`](#common.NodeType^none).
  */
  balance(e = {}) {
    return this.children.length <= 8 ? this : qU(Po.none, this.children, this.positions, 0, this.children.length, 0, this.length, (n, r, a) => new Pr(this.type, n, r, a, this.propValues), e.makeTree || ((n, r, a) => new Pr(Po.none, n, r, a)));
  }
  /**
  Build a tree from a postfix-ordered buffer of node information,
  or a cursor over such a buffer.
  */
  static build(e) {
    return BPe(e);
  }
}
Pr.empty = new Pr(Po.none, [], [], 0);
class ZU {
  constructor(e, n) {
    this.buffer = e, this.index = n;
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  get pos() {
    return this.index;
  }
  next() {
    this.index -= 4;
  }
  fork() {
    return new ZU(this.buffer, this.index);
  }
}
class rv {
  /**
  Create a tree buffer.
  */
  constructor(e, n, r) {
    this.buffer = e, this.length = n, this.set = r;
  }
  /**
  @internal
  */
  get type() {
    return Po.none;
  }
  /**
  @internal
  */
  toString() {
    let e = [];
    for (let n = 0; n < this.buffer.length; )
      e.push(this.childString(n)), n = this.buffer[n + 3];
    return e.join(",");
  }
  /**
  @internal
  */
  childString(e) {
    let n = this.buffer[e], r = this.buffer[e + 3], a = this.set.types[n], i = a.name;
    if (/\W/.test(i) && !a.isError && (i = JSON.stringify(i)), e += 4, r == e)
      return i;
    let o = [];
    for (; e < r; )
      o.push(this.childString(e)), e = this.buffer[e + 3];
    return i + "(" + o.join(",") + ")";
  }
  /**
  @internal
  */
  findChild(e, n, r, a, i) {
    let { buffer: o } = this, s = -1;
    for (let u = e; u != n && !($ie(i, a, o[u + 1], o[u + 2]) && (s = u, r > 0)); u = o[u + 3])
      ;
    return s;
  }
  /**
  @internal
  */
  slice(e, n, r) {
    let a = this.buffer, i = new Uint16Array(n - e), o = 0;
    for (let s = e, u = 0; s < n; ) {
      i[u++] = a[s++], i[u++] = a[s++] - r;
      let f = i[u++] = a[s++] - r;
      i[u++] = a[s++] - e, o = Math.max(o, f);
    }
    return new rv(i, o, this.set);
  }
}
function $ie(t, e, n, r) {
  switch (t) {
    case -2:
      return n < e;
    case -1:
      return r >= e && n < e;
    case 0:
      return n < e && r > e;
    case 1:
      return n <= e && r > e;
    case 2:
      return r > e;
    case 4:
      return !0;
  }
}
function GT(t, e, n, r) {
  for (var a; t.from == t.to || (n < 1 ? t.from >= e : t.from > e) || (n > -1 ? t.to <= e : t.to < e); ) {
    let o = !r && t instanceof Dl && t.index < 0 ? null : t.parent;
    if (!o)
      return t;
    t = o;
  }
  let i = r ? 0 : ii.IgnoreOverlays;
  if (r)
    for (let o = t, s = o.parent; s; o = s, s = o.parent)
      o instanceof Dl && o.index < 0 && ((a = s.enter(e, n, i)) === null || a === void 0 ? void 0 : a.from) != o.from && (t = s);
  for (; ; ) {
    let o = t.enter(e, n, i);
    if (!o)
      return t;
    t = o;
  }
}
class Bie {
  cursor(e = 0) {
    return new lI(this, e);
  }
  getChild(e, n = null, r = null) {
    let a = dq(this, e, n, r);
    return a.length ? a[0] : null;
  }
  getChildren(e, n = null, r = null) {
    return dq(this, e, n, r);
  }
  resolve(e, n = 0) {
    return GT(this, e, n, !1);
  }
  resolveInner(e, n = 0) {
    return GT(this, e, n, !0);
  }
  matchContext(e) {
    return D4(this, e);
  }
  enterUnfinishedNodesBefore(e) {
    let n = this.childBefore(e), r = this;
    for (; n; ) {
      let a = n.lastChild;
      if (!a || a.to != n.to)
        break;
      a.type.isError && a.from == a.to ? (r = n, n = a.prevSibling) : n = a;
    }
    return r;
  }
  get node() {
    return this;
  }
  get next() {
    return this.parent;
  }
}
class Dl extends Bie {
  constructor(e, n, r, a) {
    super(), this._tree = e, this.from = n, this.index = r, this._parent = a;
  }
  get type() {
    return this._tree.type;
  }
  get name() {
    return this._tree.type.name;
  }
  get to() {
    return this.from + this._tree.length;
  }
  nextChild(e, n, r, a, i = 0) {
    for (let o = this; ; ) {
      for (let { children: s, positions: u } = o._tree, f = n > 0 ? s.length : -1; e != f; e += n) {
        let p = s[e], m = u[e] + o.from;
        if ($ie(a, r, m, m + p.length)) {
          if (p instanceof rv) {
            if (i & ii.ExcludeBuffers)
              continue;
            let v = p.findChild(0, p.buffer.length, n, r - m, a);
            if (v > -1)
              return new Eh(new MPe(o, p, e, m), null, v);
          } else if (i & ii.IncludeAnonymous || !p.type.isAnonymous || XU(p)) {
            let v;
            if (!(i & ii.IgnoreMounts) && (v = jT.get(p)) && !v.overlay)
              return new Dl(v.tree, m, e, o);
            let O = new Dl(p, m, e, o);
            return i & ii.IncludeAnonymous || !O.type.isAnonymous ? O : O.nextChild(n < 0 ? p.children.length - 1 : 0, n, r, a);
          }
        }
      }
      if (i & ii.IncludeAnonymous || !o.type.isAnonymous || (o.index >= 0 ? e = o.index + n : e = n < 0 ? -1 : o._parent._tree.children.length, o = o._parent, !o))
        return null;
    }
  }
  get firstChild() {
    return this.nextChild(
      0,
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  get lastChild() {
    return this.nextChild(
      this._tree.children.length - 1,
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  childAfter(e) {
    return this.nextChild(
      0,
      1,
      e,
      2
      /* Side.After */
    );
  }
  childBefore(e) {
    return this.nextChild(
      this._tree.children.length - 1,
      -1,
      e,
      -2
      /* Side.Before */
    );
  }
  enter(e, n, r = 0) {
    let a;
    if (!(r & ii.IgnoreOverlays) && (a = jT.get(this._tree)) && a.overlay) {
      let i = e - this.from;
      for (let { from: o, to: s } of a.overlay)
        if ((n > 0 ? o <= i : o < i) && (n < 0 ? s >= i : s > i))
          return new Dl(a.tree, a.overlay[0].from + this.from, -1, this);
    }
    return this.nextChild(0, 1, e, n, r);
  }
  nextSignificantParent() {
    let e = this;
    for (; e.type.isAnonymous && e._parent; )
      e = e._parent;
    return e;
  }
  get parent() {
    return this._parent ? this._parent.nextSignificantParent() : null;
  }
  get nextSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(
      this.index + 1,
      1,
      0,
      4
      /* Side.DontCare */
    ) : null;
  }
  get prevSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(
      this.index - 1,
      -1,
      0,
      4
      /* Side.DontCare */
    ) : null;
  }
  get tree() {
    return this._tree;
  }
  toTree() {
    return this._tree;
  }
  /**
  @internal
  */
  toString() {
    return this._tree.toString();
  }
}
function dq(t, e, n, r) {
  let a = t.cursor(), i = [];
  if (!a.firstChild())
    return i;
  if (n != null) {
    for (let o = !1; !o; )
      if (o = a.type.is(n), !a.nextSibling())
        return i;
  }
  for (; ; ) {
    if (r != null && a.type.is(r))
      return i;
    if (a.type.is(e) && i.push(a.node), !a.nextSibling())
      return r == null ? i : [];
  }
}
function D4(t, e, n = e.length - 1) {
  for (let r = t.parent; n >= 0; r = r.parent) {
    if (!r)
      return !1;
    if (!r.type.isAnonymous) {
      if (e[n] && e[n] != r.name)
        return !1;
      n--;
    }
  }
  return !0;
}
class MPe {
  constructor(e, n, r, a) {
    this.parent = e, this.buffer = n, this.index = r, this.start = a;
  }
}
class Eh extends Bie {
  get name() {
    return this.type.name;
  }
  get from() {
    return this.context.start + this.context.buffer.buffer[this.index + 1];
  }
  get to() {
    return this.context.start + this.context.buffer.buffer[this.index + 2];
  }
  constructor(e, n, r) {
    super(), this.context = e, this._parent = n, this.index = r, this.type = e.buffer.set.types[e.buffer.buffer[r]];
  }
  child(e, n, r) {
    let { buffer: a } = this.context, i = a.findChild(this.index + 4, a.buffer[this.index + 3], e, n - this.context.start, r);
    return i < 0 ? null : new Eh(this.context, this, i);
  }
  get firstChild() {
    return this.child(
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  get lastChild() {
    return this.child(
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  childAfter(e) {
    return this.child(
      1,
      e,
      2
      /* Side.After */
    );
  }
  childBefore(e) {
    return this.child(
      -1,
      e,
      -2
      /* Side.Before */
    );
  }
  enter(e, n, r = 0) {
    if (r & ii.ExcludeBuffers)
      return null;
    let { buffer: a } = this.context, i = a.findChild(this.index + 4, a.buffer[this.index + 3], n > 0 ? 1 : -1, e - this.context.start, n);
    return i < 0 ? null : new Eh(this.context, this, i);
  }
  get parent() {
    return this._parent || this.context.parent.nextSignificantParent();
  }
  externalSibling(e) {
    return this._parent ? null : this.context.parent.nextChild(
      this.context.index + e,
      e,
      0,
      4
      /* Side.DontCare */
    );
  }
  get nextSibling() {
    let { buffer: e } = this.context, n = e.buffer[this.index + 3];
    return n < (this._parent ? e.buffer[this._parent.index + 3] : e.buffer.length) ? new Eh(this.context, this._parent, n) : this.externalSibling(1);
  }
  get prevSibling() {
    let { buffer: e } = this.context, n = this._parent ? this._parent.index + 4 : 0;
    return this.index == n ? this.externalSibling(-1) : new Eh(this.context, this._parent, e.findChild(
      n,
      this.index,
      -1,
      0,
      4
      /* Side.DontCare */
    ));
  }
  get tree() {
    return null;
  }
  toTree() {
    let e = [], n = [], { buffer: r } = this.context, a = this.index + 4, i = r.buffer[this.index + 3];
    if (i > a) {
      let o = r.buffer[this.index + 1];
      e.push(r.slice(a, i, o)), n.push(0);
    }
    return new Pr(this.type, e, n, this.to - this.from);
  }
  /**
  @internal
  */
  toString() {
    return this.context.buffer.childString(this.index);
  }
}
function Uie(t) {
  if (!t.length)
    return null;
  let e = 0, n = t[0];
  for (let i = 1; i < t.length; i++) {
    let o = t[i];
    (o.from > n.from || o.to < n.to) && (n = o, e = i);
  }
  let r = n instanceof Dl && n.index < 0 ? null : n.parent, a = t.slice();
  return r ? a[e] = r : a.splice(e, 1), new FPe(a, n);
}
class FPe {
  constructor(e, n) {
    this.heads = e, this.node = n;
  }
  get next() {
    return Uie(this.heads);
  }
}
function $Pe(t, e, n) {
  let r = t.resolveInner(e, n), a = null;
  for (let i = r instanceof Dl ? r : r.context.parent; i; i = i.parent)
    if (i.index < 0) {
      let o = i.parent;
      (a || (a = [r])).push(o.resolve(e, n)), i = o;
    } else {
      let o = jT.get(i.tree);
      if (o && o.overlay && o.overlay[0].from <= e && o.overlay[o.overlay.length - 1].to >= e) {
        let s = new Dl(o.tree, o.overlay[0].from + i.from, -1, i);
        (a || (a = [r])).push(GT(s, e, n, !1));
      }
    }
  return a ? Uie(a) : r;
}
class lI {
  /**
  Shorthand for `.type.name`.
  */
  get name() {
    return this.type.name;
  }
  /**
  @internal
  */
  constructor(e, n = 0) {
    if (this.mode = n, this.buffer = null, this.stack = [], this.index = 0, this.bufferNode = null, e instanceof Dl)
      this.yieldNode(e);
    else {
      this._tree = e.context.parent, this.buffer = e.context;
      for (let r = e._parent; r; r = r._parent)
        this.stack.unshift(r.index);
      this.bufferNode = e, this.yieldBuf(e.index);
    }
  }
  yieldNode(e) {
    return e ? (this._tree = e, this.type = e.type, this.from = e.from, this.to = e.to, !0) : !1;
  }
  yieldBuf(e, n) {
    this.index = e;
    let { start: r, buffer: a } = this.buffer;
    return this.type = n || a.set.types[a.buffer[e]], this.from = r + a.buffer[e + 1], this.to = r + a.buffer[e + 2], !0;
  }
  /**
  @internal
  */
  yield(e) {
    return e ? e instanceof Dl ? (this.buffer = null, this.yieldNode(e)) : (this.buffer = e.context, this.yieldBuf(e.index, e.type)) : !1;
  }
  /**
  @internal
  */
  toString() {
    return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
  }
  /**
  @internal
  */
  enterChild(e, n, r) {
    if (!this.buffer)
      return this.yield(this._tree.nextChild(e < 0 ? this._tree._tree.children.length - 1 : 0, e, n, r, this.mode));
    let { buffer: a } = this.buffer, i = a.findChild(this.index + 4, a.buffer[this.index + 3], e, n - this.buffer.start, r);
    return i < 0 ? !1 : (this.stack.push(this.index), this.yieldBuf(i));
  }
  /**
  Move the cursor to this node's first child. When this returns
  false, the node has no child, and the cursor has not been moved.
  */
  firstChild() {
    return this.enterChild(
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  /**
  Move the cursor to this node's last child.
  */
  lastChild() {
    return this.enterChild(
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  /**
  Move the cursor to the first child that ends after `pos`.
  */
  childAfter(e) {
    return this.enterChild(
      1,
      e,
      2
      /* Side.After */
    );
  }
  /**
  Move to the last child that starts before `pos`.
  */
  childBefore(e) {
    return this.enterChild(
      -1,
      e,
      -2
      /* Side.Before */
    );
  }
  /**
  Move the cursor to the child around `pos`. If side is -1 the
  child may end at that position, when 1 it may start there. This
  will also enter [overlaid](#common.MountedTree.overlay)
  [mounted](#common.NodeProp^mounted) trees unless `overlays` is
  set to false.
  */
  enter(e, n, r = this.mode) {
    return this.buffer ? r & ii.ExcludeBuffers ? !1 : this.enterChild(1, e, n) : this.yield(this._tree.enter(e, n, r));
  }
  /**
  Move to the node's parent node, if this isn't the top node.
  */
  parent() {
    if (!this.buffer)
      return this.yieldNode(this.mode & ii.IncludeAnonymous ? this._tree._parent : this._tree.parent);
    if (this.stack.length)
      return this.yieldBuf(this.stack.pop());
    let e = this.mode & ii.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
    return this.buffer = null, this.yieldNode(e);
  }
  /**
  @internal
  */
  sibling(e) {
    if (!this.buffer)
      return this._tree._parent ? this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + e, e, 0, 4, this.mode)) : !1;
    let { buffer: n } = this.buffer, r = this.stack.length - 1;
    if (e < 0) {
      let a = r < 0 ? 0 : this.stack[r] + 4;
      if (this.index != a)
        return this.yieldBuf(n.findChild(
          a,
          this.index,
          -1,
          0,
          4
          /* Side.DontCare */
        ));
    } else {
      let a = n.buffer[this.index + 3];
      if (a < (r < 0 ? n.buffer.length : n.buffer[this.stack[r] + 3]))
        return this.yieldBuf(a);
    }
    return r < 0 ? this.yield(this.buffer.parent.nextChild(this.buffer.index + e, e, 0, 4, this.mode)) : !1;
  }
  /**
  Move to this node's next sibling, if any.
  */
  nextSibling() {
    return this.sibling(1);
  }
  /**
  Move to this node's previous sibling, if any.
  */
  prevSibling() {
    return this.sibling(-1);
  }
  atLastNode(e) {
    let n, r, { buffer: a } = this;
    if (a) {
      if (e > 0) {
        if (this.index < a.buffer.buffer.length)
          return !1;
      } else
        for (let i = 0; i < this.index; i++)
          if (a.buffer.buffer[i + 3] < this.index)
            return !1;
      ({ index: n, parent: r } = a);
    } else
      ({ index: n, _parent: r } = this._tree);
    for (; r; { index: n, _parent: r } = r)
      if (n > -1)
        for (let i = n + e, o = e < 0 ? -1 : r._tree.children.length; i != o; i += e) {
          let s = r._tree.children[i];
          if (this.mode & ii.IncludeAnonymous || s instanceof rv || !s.type.isAnonymous || XU(s))
            return !1;
        }
    return !0;
  }
  move(e, n) {
    if (n && this.enterChild(
      e,
      0,
      4
      /* Side.DontCare */
    ))
      return !0;
    for (; ; ) {
      if (this.sibling(e))
        return !0;
      if (this.atLastNode(e) || !this.parent())
        return !1;
    }
  }
  /**
  Move to the next node in a
  [pre-order](https://en.wikipedia.org/wiki/Tree_traversal#Pre-order,_NLR)
  traversal, going from a node to its first child or, if the
  current node is empty or `enter` is false, its next sibling or
  the next sibling of the first parent node that has one.
  */
  next(e = !0) {
    return this.move(1, e);
  }
  /**
  Move to the next node in a last-to-first pre-order traveral. A
  node is followed by its last child or, if it has none, its
  previous sibling or the previous sibling of the first parent
  node that has one.
  */
  prev(e = !0) {
    return this.move(-1, e);
  }
  /**
  Move the cursor to the innermost node that covers `pos`. If
  `side` is -1, it will enter nodes that end at `pos`. If it is 1,
  it will enter nodes that start at `pos`.
  */
  moveTo(e, n = 0) {
    for (; (this.from == this.to || (n < 1 ? this.from >= e : this.from > e) || (n > -1 ? this.to <= e : this.to < e)) && this.parent(); )
      ;
    for (; this.enterChild(1, e, n); )
      ;
    return this;
  }
  /**
  Get a [syntax node](#common.SyntaxNode) at the cursor's current
  position.
  */
  get node() {
    if (!this.buffer)
      return this._tree;
    let e = this.bufferNode, n = null, r = 0;
    if (e && e.context == this.buffer)
      e:
        for (let a = this.index, i = this.stack.length; i >= 0; ) {
          for (let o = e; o; o = o._parent)
            if (o.index == a) {
              if (a == this.index)
                return o;
              n = o, r = i + 1;
              break e;
            }
          a = this.stack[--i];
        }
    for (let a = r; a < this.stack.length; a++)
      n = new Eh(this.buffer, n, this.stack[a]);
    return this.bufferNode = new Eh(this.buffer, n, this.index);
  }
  /**
  Get the [tree](#common.Tree) that represents the current node, if
  any. Will return null when the node is in a [tree
  buffer](#common.TreeBuffer).
  */
  get tree() {
    return this.buffer ? null : this._tree._tree;
  }
  /**
  Iterate over the current node and all its descendants, calling
  `enter` when entering a node and `leave`, if given, when leaving
  one. When `enter` returns `false`, any children of that node are
  skipped, and `leave` isn't called for it.
  */
  iterate(e, n) {
    for (let r = 0; ; ) {
      let a = !1;
      if (this.type.isAnonymous || e(this) !== !1) {
        if (this.firstChild()) {
          r++;
          continue;
        }
        this.type.isAnonymous || (a = !0);
      }
      for (; a && n && n(this), a = this.type.isAnonymous, !this.nextSibling(); ) {
        if (!r)
          return;
        this.parent(), r--, a = !0;
      }
    }
  }
  /**
  Test whether the current node matches a given context—a sequence
  of direct parent node names. Empty strings in the context array
  are treated as wildcards.
  */
  matchContext(e) {
    if (!this.buffer)
      return D4(this.node, e);
    let { buffer: n } = this.buffer, { types: r } = n.set;
    for (let a = e.length - 1, i = this.stack.length - 1; a >= 0; i--) {
      if (i < 0)
        return D4(this.node, e, a);
      let o = r[n.buffer[this.stack[i]]];
      if (!o.isAnonymous) {
        if (e[a] && e[a] != o.name)
          return !1;
        a--;
      }
    }
    return !0;
  }
}
function XU(t) {
  return t.children.some((e) => e instanceof rv || !e.type.isAnonymous || XU(e));
}
function BPe(t) {
  var e;
  let { buffer: n, nodeSet: r, maxBufferLength: a = Fie, reused: i = [], minRepeatType: o = r.types.length } = t, s = Array.isArray(n) ? new ZU(n, n.length) : n, u = r.types, f = 0, p = 0;
  function m(D, M, H, Y, q, Q) {
    let { id: ne, start: J, end: ue, size: ee } = s, fe = p;
    for (; ee < 0; )
      if (s.next(), ee == -1) {
        let B = i[ne];
        H.push(B), Y.push(J - D);
        return;
      } else if (ee == -3) {
        f = ne;
        return;
      } else if (ee == -4) {
        p = ne;
        return;
      } else
        throw new RangeError(`Unrecognized record size: ${ee}`);
    let de = u[ne], ie, le, ye = J - D;
    if (ue - J <= a && (le = C(s.pos - M, q))) {
      let B = new Uint16Array(le.size - le.skip), pe = s.pos - le.size, _e = B.length;
      for (; s.pos > pe; )
        _e = A(le.start, B, _e);
      ie = new rv(B, ue - le.start, r), ye = le.start - D;
    } else {
      let B = s.pos - ee;
      s.next();
      let pe = [], _e = [], Z = ne >= o ? ne : -1, ce = 0, j = ue;
      for (; s.pos > B; )
        Z >= 0 && s.id == Z && s.size >= 0 ? (s.end <= j - a && (w(pe, _e, J, ce, s.end, j, Z, fe), ce = pe.length, j = s.end), s.next()) : Q > 2500 ? v(J, B, pe, _e) : m(J, B, pe, _e, Z, Q + 1);
      if (Z >= 0 && ce > 0 && ce < pe.length && w(pe, _e, J, ce, J, j, Z, fe), pe.reverse(), _e.reverse(), Z > -1 && ce > 0) {
        let K = O(de);
        ie = qU(de, pe, _e, 0, pe.length, 0, ue - J, K, K);
      } else
        ie = _(de, pe, _e, ue - J, fe - ue);
    }
    H.push(ie), Y.push(ye);
  }
  function v(D, M, H, Y) {
    let q = [], Q = 0, ne = -1;
    for (; s.pos > M; ) {
      let { id: J, start: ue, end: ee, size: fe } = s;
      if (fe > 4)
        s.next();
      else {
        if (ne > -1 && ue < ne)
          break;
        ne < 0 && (ne = ee - a), q.push(J, ue, ee), Q++, s.next();
      }
    }
    if (Q) {
      let J = new Uint16Array(Q * 4), ue = q[q.length - 2];
      for (let ee = q.length - 3, fe = 0; ee >= 0; ee -= 3)
        J[fe++] = q[ee], J[fe++] = q[ee + 1] - ue, J[fe++] = q[ee + 2] - ue, J[fe++] = fe;
      H.push(new rv(J, q[2] - ue, r)), Y.push(ue - D);
    }
  }
  function O(D) {
    return (M, H, Y) => {
      let q = 0, Q = M.length - 1, ne, J;
      if (Q >= 0 && (ne = M[Q]) instanceof Pr) {
        if (!Q && ne.type == D && ne.length == Y)
          return ne;
        (J = ne.prop(nr.lookAhead)) && (q = H[Q] + ne.length + J);
      }
      return _(D, M, H, Y, q);
    };
  }
  function w(D, M, H, Y, q, Q, ne, J) {
    let ue = [], ee = [];
    for (; D.length > Y; )
      ue.push(D.pop()), ee.push(M.pop() + H - q);
    D.push(_(r.types[ne], ue, ee, Q - q, J - Q)), M.push(q - H);
  }
  function _(D, M, H, Y, q = 0, Q) {
    if (f) {
      let ne = [nr.contextHash, f];
      Q = Q ? [ne].concat(Q) : [ne];
    }
    if (q > 25) {
      let ne = [nr.lookAhead, q];
      Q = Q ? [ne].concat(Q) : [ne];
    }
    return new Pr(D, M, H, Y, Q);
  }
  function C(D, M) {
    let H = s.fork(), Y = 0, q = 0, Q = 0, ne = H.end - a, J = { size: 0, start: 0, skip: 0 };
    e:
      for (let ue = H.pos - D; H.pos > ue; ) {
        let ee = H.size;
        if (H.id == M && ee >= 0) {
          J.size = Y, J.start = q, J.skip = Q, Q += 4, Y += 4, H.next();
          continue;
        }
        let fe = H.pos - ee;
        if (ee < 0 || fe < ue || H.start < ne)
          break;
        let de = H.id >= o ? 4 : 0, ie = H.start;
        for (H.next(); H.pos > fe; ) {
          if (H.size < 0)
            if (H.size == -3)
              de += 4;
            else
              break e;
          else
            H.id >= o && (de += 4);
          H.next();
        }
        q = ie, Y += ee, Q += de;
      }
    return (M < 0 || Y == D) && (J.size = Y, J.start = q, J.skip = Q), J.size > 4 ? J : void 0;
  }
  function A(D, M, H) {
    let { id: Y, start: q, end: Q, size: ne } = s;
    if (s.next(), ne >= 0 && Y < o) {
      let J = H;
      if (ne > 4) {
        let ue = s.pos - (ne - 4);
        for (; s.pos > ue; )
          H = A(D, M, H);
      }
      M[--H] = J, M[--H] = Q - D, M[--H] = q - D, M[--H] = Y;
    } else
      ne == -3 ? f = Y : ne == -4 && (p = Y);
    return H;
  }
  let N = [], P = [];
  for (; s.pos > 0; )
    m(t.start || 0, t.bufferStart || 0, N, P, -1, 0);
  let I = (e = t.length) !== null && e !== void 0 ? e : N.length ? P[0] + N[0].length : 0;
  return new Pr(u[t.topID], N.reverse(), P.reverse(), I);
}
const pq = /* @__PURE__ */ new WeakMap();
function Ak(t, e) {
  if (!t.isAnonymous || e instanceof rv || e.type != t)
    return 1;
  let n = pq.get(e);
  if (n == null) {
    n = 1;
    for (let r of e.children) {
      if (r.type != t || !(r instanceof Pr)) {
        n = 1;
        break;
      }
      n += Ak(t, r);
    }
    pq.set(e, n);
  }
  return n;
}
function qU(t, e, n, r, a, i, o, s, u) {
  let f = 0;
  for (let w = r; w < a; w++)
    f += Ak(t, e[w]);
  let p = Math.ceil(
    f * 1.5 / 8
    /* Balance.BranchFactor */
  ), m = [], v = [];
  function O(w, _, C, A, N) {
    for (let P = C; P < A; ) {
      let I = P, D = _[P], M = Ak(t, w[P]);
      for (P++; P < A; P++) {
        let H = Ak(t, w[P]);
        if (M + H >= p)
          break;
        M += H;
      }
      if (P == I + 1) {
        if (M > p) {
          let H = w[I];
          O(H.children, H.positions, 0, H.children.length, _[I] + N);
          continue;
        }
        m.push(w[I]);
      } else {
        let H = _[P - 1] + w[P - 1].length - D;
        m.push(qU(t, w, _, I, P, D, H, null, u));
      }
      v.push(D + N - i);
    }
  }
  return O(e, n, r, a, 0), (s || u)(m, v, o);
}
class zie {
  constructor() {
    this.map = /* @__PURE__ */ new WeakMap();
  }
  setBuffer(e, n, r) {
    let a = this.map.get(e);
    a || this.map.set(e, a = /* @__PURE__ */ new Map()), a.set(n, r);
  }
  getBuffer(e, n) {
    let r = this.map.get(e);
    return r && r.get(n);
  }
  /**
  Set the value for this syntax node.
  */
  set(e, n) {
    e instanceof Eh ? this.setBuffer(e.context.buffer, e.index, n) : e instanceof Dl && this.map.set(e.tree, n);
  }
  /**
  Retrieve value for this syntax node, if it exists in the map.
  */
  get(e) {
    return e instanceof Eh ? this.getBuffer(e.context.buffer, e.index) : e instanceof Dl ? this.map.get(e.tree) : void 0;
  }
  /**
  Set the value for the node that a cursor currently points to.
  */
  cursorSet(e, n) {
    e.buffer ? this.setBuffer(e.buffer.buffer, e.index, n) : this.map.set(e.tree, n);
  }
  /**
  Retrieve the value for the node that a cursor currently points
  to.
  */
  cursorGet(e) {
    return e.buffer ? this.getBuffer(e.buffer.buffer, e.index) : this.map.get(e.tree);
  }
}
class Km {
  /**
  Construct a tree fragment. You'll usually want to use
  [`addTree`](#common.TreeFragment^addTree) and
  [`applyChanges`](#common.TreeFragment^applyChanges) instead of
  calling this directly.
  */
  constructor(e, n, r, a, i = !1, o = !1) {
    this.from = e, this.to = n, this.tree = r, this.offset = a, this.open = (i ? 1 : 0) | (o ? 2 : 0);
  }
  /**
  Whether the start of the fragment represents the start of a
  parse, or the end of a change. (In the second case, it may not
  be safe to reuse some nodes at the start, depending on the
  parsing algorithm.)
  */
  get openStart() {
    return (this.open & 1) > 0;
  }
  /**
  Whether the end of the fragment represents the end of a
  full-document parse, or the start of a change.
  */
  get openEnd() {
    return (this.open & 2) > 0;
  }
  /**
  Create a set of fragments from a freshly parsed tree, or update
  an existing set of fragments by replacing the ones that overlap
  with a tree with content from the new tree. When `partial` is
  true, the parse is treated as incomplete, and the resulting
  fragment has [`openEnd`](#common.TreeFragment.openEnd) set to
  true.
  */
  static addTree(e, n = [], r = !1) {
    let a = [new Km(0, e.length, e, 0, !1, r)];
    for (let i of n)
      i.to > e.length && a.push(i);
    return a;
  }
  /**
  Apply a set of edits to an array of fragments, removing or
  splitting fragments as necessary to remove edited ranges, and
  adjusting offsets for fragments that moved.
  */
  static applyChanges(e, n, r = 128) {
    if (!n.length)
      return e;
    let a = [], i = 1, o = e.length ? e[0] : null;
    for (let s = 0, u = 0, f = 0; ; s++) {
      let p = s < n.length ? n[s] : null, m = p ? p.fromA : 1e9;
      if (m - u >= r)
        for (; o && o.from < m; ) {
          let v = o;
          if (u >= v.from || m <= v.to || f) {
            let O = Math.max(v.from, u) - f, w = Math.min(v.to, m) - f;
            v = O >= w ? null : new Km(O, w, v.tree, v.offset + f, s > 0, !!p);
          }
          if (v && a.push(v), o.to > m)
            break;
          o = i < e.length ? e[i++] : null;
        }
      if (!p)
        break;
      u = p.toA, f = p.toA - p.toB;
    }
    return a;
  }
}
let OD = class {
  /**
  Start a parse, returning a [partial parse](#common.PartialParse)
  object. [`fragments`](#common.TreeFragment) can be passed in to
  make the parse incremental.
  
  By default, the entire input is parsed. You can pass `ranges`,
  which should be a sorted array of non-empty, non-overlapping
  ranges, to parse only those ranges. The tree returned in that
  case will start at `ranges[0].from`.
  */
  startParse(e, n, r) {
    return typeof e == "string" && (e = new UPe(e)), r = r ? r.length ? r.map((a) => new zf(a.from, a.to)) : [new zf(0, 0)] : [new zf(0, e.length)], this.createParse(e, n || [], r);
  }
  /**
  Run a full parse, returning the resulting tree.
  */
  parse(e, n, r) {
    let a = this.startParse(e, n, r);
    for (; ; ) {
      let i = a.advance();
      if (i)
        return i;
    }
  }
};
class UPe {
  constructor(e) {
    this.string = e;
  }
  get length() {
    return this.string.length;
  }
  chunk(e) {
    return this.string.slice(e);
  }
  get lineChunks() {
    return !1;
  }
  read(e, n) {
    return this.string.slice(e, n);
  }
}
function Hie(t) {
  return (e, n, r, a) => new HPe(e, t, n, r, a);
}
class hq {
  constructor(e, n, r, a, i) {
    this.parser = e, this.parse = n, this.overlay = r, this.target = a, this.from = i;
  }
}
function mq(t) {
  if (!t.length || t.some((e) => e.from >= e.to))
    throw new RangeError("Invalid inner parse ranges given: " + JSON.stringify(t));
}
class zPe {
  constructor(e, n, r, a, i, o, s) {
    this.parser = e, this.predicate = n, this.mounts = r, this.index = a, this.start = i, this.target = o, this.prev = s, this.depth = 0, this.ranges = [];
  }
}
const N4 = new nr({ perNode: !0 });
class HPe {
  constructor(e, n, r, a, i) {
    this.nest = n, this.input = r, this.fragments = a, this.ranges = i, this.inner = [], this.innerDone = 0, this.baseTree = null, this.stoppedAt = null, this.baseParse = e;
  }
  advance() {
    if (this.baseParse) {
      let r = this.baseParse.advance();
      if (!r)
        return null;
      if (this.baseParse = null, this.baseTree = r, this.startInner(), this.stoppedAt != null)
        for (let a of this.inner)
          a.parse.stopAt(this.stoppedAt);
    }
    if (this.innerDone == this.inner.length) {
      let r = this.baseTree;
      return this.stoppedAt != null && (r = new Pr(r.type, r.children, r.positions, r.length, r.propValues.concat([[N4, this.stoppedAt]]))), r;
    }
    let e = this.inner[this.innerDone], n = e.parse.advance();
    if (n) {
      this.innerDone++;
      let r = Object.assign(/* @__PURE__ */ Object.create(null), e.target.props);
      r[nr.mounted.id] = new jT(n, e.overlay, e.parser), e.target.props = r;
    }
    return null;
  }
  get parsedPos() {
    if (this.baseParse)
      return 0;
    let e = this.input.length;
    for (let n = this.innerDone; n < this.inner.length; n++)
      this.inner[n].from < e && (e = Math.min(e, this.inner[n].parse.parsedPos));
    return e;
  }
  stopAt(e) {
    if (this.stoppedAt = e, this.baseParse)
      this.baseParse.stopAt(e);
    else
      for (let n = this.innerDone; n < this.inner.length; n++)
        this.inner[n].parse.stopAt(e);
  }
  startInner() {
    let e = new jPe(this.fragments), n = null, r = null, a = new lI(new Dl(this.baseTree, this.ranges[0].from, 0, null), ii.IncludeAnonymous | ii.IgnoreMounts);
    e:
      for (let i, o; ; ) {
        let s = !0, u;
        if (this.stoppedAt != null && a.from >= this.stoppedAt)
          s = !1;
        else if (e.hasNode(a)) {
          if (n) {
            let f = n.mounts.find((p) => p.frag.from <= a.from && p.frag.to >= a.to && p.mount.overlay);
            if (f)
              for (let p of f.mount.overlay) {
                let m = p.from + f.pos, v = p.to + f.pos;
                m >= a.from && v <= a.to && !n.ranges.some((O) => O.from < v && O.to > m) && n.ranges.push({ from: m, to: v });
              }
          }
          s = !1;
        } else if (r && (o = WPe(r.ranges, a.from, a.to)))
          s = o != 2;
        else if (!a.type.isAnonymous && (i = this.nest(a, this.input)) && (a.from < a.to || !i.overlay)) {
          a.tree || QPe(a);
          let f = e.findMounts(a.from, i.parser);
          if (typeof i.overlay == "function")
            n = new zPe(i.parser, i.overlay, f, this.inner.length, a.from, a.tree, n);
          else {
            let p = vq(this.ranges, i.overlay || (a.from < a.to ? [new zf(a.from, a.to)] : []));
            p.length && mq(p), (p.length || !i.overlay) && this.inner.push(new hq(i.parser, p.length ? i.parser.startParse(this.input, yq(f, p), p) : i.parser.startParse(""), i.overlay ? i.overlay.map((m) => new zf(m.from - a.from, m.to - a.from)) : null, a.tree, p.length ? p[0].from : a.from)), i.overlay ? p.length && (r = { ranges: p, depth: 0, prev: r }) : s = !1;
          }
        } else
          n && (u = n.predicate(a)) && (u === !0 && (u = new zf(a.from, a.to)), u.from < u.to && n.ranges.push(u));
        if (s && a.firstChild())
          n && n.depth++, r && r.depth++;
        else
          for (; !a.nextSibling(); ) {
            if (!a.parent())
              break e;
            if (n && !--n.depth) {
              let f = vq(this.ranges, n.ranges);
              f.length && (mq(f), this.inner.splice(n.index, 0, new hq(n.parser, n.parser.startParse(this.input, yq(n.mounts, f), f), n.ranges.map((p) => new zf(p.from - n.start, p.to - n.start)), n.target, f[0].from))), n = n.prev;
            }
            r && !--r.depth && (r = r.prev);
          }
      }
  }
}
function WPe(t, e, n) {
  for (let r of t) {
    if (r.from >= n)
      break;
    if (r.to > e)
      return r.from <= e && r.to >= n ? 2 : 1;
  }
  return 0;
}
function gq(t, e, n, r, a, i) {
  if (e < n) {
    let o = t.buffer[e + 1];
    r.push(t.slice(e, n, o)), a.push(o - i);
  }
}
function QPe(t) {
  let { node: e } = t, n = [], r = e.context.buffer;
  do
    n.push(t.index), t.parent();
  while (!t.tree);
  let a = t.tree, i = a.children.indexOf(r), o = a.children[i], s = o.buffer, u = [i];
  function f(p, m, v, O, w, _) {
    let C = n[_], A = [], N = [];
    gq(o, p, C, A, N, O);
    let P = s[C + 1], I = s[C + 2];
    u.push(A.length);
    let D = _ ? f(C + 4, s[C + 3], o.set.types[s[C]], P, I - P, _ - 1) : e.toTree();
    return A.push(D), N.push(P - O), gq(o, s[C + 3], m, A, N, O), new Pr(v, A, N, w);
  }
  a.children[i] = f(0, s.length, Po.none, 0, o.length, n.length - 1);
  for (let p of u) {
    let m = t.tree.children[p], v = t.tree.positions[p];
    t.yield(new Dl(m, v + t.from, p, t._tree));
  }
}
class bq {
  constructor(e, n) {
    this.offset = n, this.done = !1, this.cursor = e.cursor(ii.IncludeAnonymous | ii.IgnoreMounts);
  }
  // Move to the first node (in pre-order) that starts at or after `pos`.
  moveTo(e) {
    let { cursor: n } = this, r = e - this.offset;
    for (; !this.done && n.from < r; )
      n.to >= e && n.enter(r, 1, ii.IgnoreOverlays | ii.ExcludeBuffers) || n.next(!1) || (this.done = !0);
  }
  hasNode(e) {
    if (this.moveTo(e.from), !this.done && this.cursor.from + this.offset == e.from && this.cursor.tree)
      for (let n = this.cursor.tree; ; ) {
        if (n == e.tree)
          return !0;
        if (n.children.length && n.positions[0] == 0 && n.children[0] instanceof Pr)
          n = n.children[0];
        else
          break;
      }
    return !1;
  }
}
let jPe = class {
  constructor(e) {
    var n;
    if (this.fragments = e, this.curTo = 0, this.fragI = 0, e.length) {
      let r = this.curFrag = e[0];
      this.curTo = (n = r.tree.prop(N4)) !== null && n !== void 0 ? n : r.to, this.inner = new bq(r.tree, -r.offset);
    } else
      this.curFrag = this.inner = null;
  }
  hasNode(e) {
    for (; this.curFrag && e.from >= this.curTo; )
      this.nextFrag();
    return this.curFrag && this.curFrag.from <= e.from && this.curTo >= e.to && this.inner.hasNode(e);
  }
  nextFrag() {
    var e;
    if (this.fragI++, this.fragI == this.fragments.length)
      this.curFrag = this.inner = null;
    else {
      let n = this.curFrag = this.fragments[this.fragI];
      this.curTo = (e = n.tree.prop(N4)) !== null && e !== void 0 ? e : n.to, this.inner = new bq(n.tree, -n.offset);
    }
  }
  findMounts(e, n) {
    var r;
    let a = [];
    if (this.inner) {
      this.inner.cursor.moveTo(e, 1);
      for (let i = this.inner.cursor.node; i; i = i.parent) {
        let o = (r = i.tree) === null || r === void 0 ? void 0 : r.prop(nr.mounted);
        if (o && o.parser == n)
          for (let s = this.fragI; s < this.fragments.length; s++) {
            let u = this.fragments[s];
            if (u.from >= i.to)
              break;
            u.tree == this.curFrag.tree && a.push({
              frag: u,
              pos: i.from - u.offset,
              mount: o
            });
          }
      }
    }
    return a;
  }
};
function vq(t, e) {
  let n = null, r = e;
  for (let a = 1, i = 0; a < t.length; a++) {
    let o = t[a - 1].to, s = t[a].from;
    for (; i < r.length; i++) {
      let u = r[i];
      if (u.from >= s)
        break;
      u.to <= o || (n || (r = n = e.slice()), u.from < o ? (n[i] = new zf(u.from, o), u.to > s && n.splice(i + 1, 0, new zf(s, u.to))) : u.to > s ? n[i--] = new zf(s, u.to) : n.splice(i--, 1));
    }
  }
  return r;
}
function GPe(t, e, n, r) {
  let a = 0, i = 0, o = !1, s = !1, u = -1e9, f = [];
  for (; ; ) {
    let p = a == t.length ? 1e9 : o ? t[a].to : t[a].from, m = i == e.length ? 1e9 : s ? e[i].to : e[i].from;
    if (o != s) {
      let v = Math.max(u, n), O = Math.min(p, m, r);
      v < O && f.push(new zf(v, O));
    }
    if (u = Math.min(p, m), u == 1e9)
      break;
    p == u && (o ? (o = !1, a++) : o = !0), m == u && (s ? (s = !1, i++) : s = !0);
  }
  return f;
}
function yq(t, e) {
  let n = [];
  for (let { pos: r, mount: a, frag: i } of t) {
    let o = r + (a.overlay ? a.overlay[0].from : 0), s = o + a.tree.length, u = Math.max(i.from, o), f = Math.min(i.to, s);
    if (a.overlay) {
      let p = a.overlay.map((v) => new zf(v.from + r, v.to + r)), m = GPe(e, p, u, f);
      for (let v = 0, O = u; ; v++) {
        let w = v == m.length, _ = w ? f : m[v].from;
        if (_ > O && n.push(new Km(O, _, a.tree, -o, i.from >= O || i.openStart, i.to <= _ || i.openEnd)), w)
          break;
        O = m[v].to;
      }
    } else
      n.push(new Km(u, f, a.tree, -o, i.from >= o || i.openStart, i.to <= s || i.openEnd));
  }
  return n;
}
let VPe = 0;
class zd {
  /**
  @internal
  */
  constructor(e, n, r) {
    this.set = e, this.base = n, this.modified = r, this.id = VPe++;
  }
  /**
  Define a new tag. If `parent` is given, the tag is treated as a
  sub-tag of that parent, and
  [highlighters](#highlight.tagHighlighter) that don't mention
  this tag will try to fall back to the parent tag (or grandparent
  tag, etc).
  */
  static define(e) {
    if (e != null && e.base)
      throw new Error("Can not derive from a modified tag");
    let n = new zd([], null, []);
    if (n.set.push(n), e)
      for (let r of e.set)
        n.set.push(r);
    return n;
  }
  /**
  Define a tag _modifier_, which is a function that, given a tag,
  will return a tag that is a subtag of the original. Applying the
  same modifier to a twice tag will return the same value (`m1(t1)
  == m1(t1)`) and applying multiple modifiers will, regardless or
  order, produce the same tag (`m1(m2(t1)) == m2(m1(t1))`).
  
  When multiple modifiers are applied to a given base tag, each
  smaller set of modifiers is registered as a parent, so that for
  example `m1(m2(m3(t1)))` is a subtype of `m1(m2(t1))`,
  `m1(m3(t1)`, and so on.
  */
  static defineModifier() {
    let e = new uI();
    return (n) => n.modified.indexOf(e) > -1 ? n : uI.get(n.base || n, n.modified.concat(e).sort((r, a) => r.id - a.id));
  }
}
let YPe = 0;
class uI {
  constructor() {
    this.instances = [], this.id = YPe++;
  }
  static get(e, n) {
    if (!n.length)
      return e;
    let r = n[0].instances.find((s) => s.base == e && ZPe(n, s.modified));
    if (r)
      return r;
    let a = [], i = new zd(a, e, n);
    for (let s of n)
      s.instances.push(i);
    let o = XPe(n);
    for (let s of e.set)
      if (!s.modified.length)
        for (let u of o)
          a.push(uI.get(s, u));
    return i;
  }
}
function ZPe(t, e) {
  return t.length == e.length && t.every((n, r) => n == e[r]);
}
function XPe(t) {
  let e = [[]];
  for (let n = 0; n < t.length; n++)
    for (let r = 0, a = e.length; r < a; r++)
      e.push(e[r].concat(t[n]));
  return e.sort((n, r) => r.length - n.length);
}
function c1(t) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let n in t) {
    let r = t[n];
    Array.isArray(r) || (r = [r]);
    for (let a of n.split(" "))
      if (a) {
        let i = [], o = 2, s = a;
        for (let m = 0; ; ) {
          if (s == "..." && m > 0 && m + 3 == a.length) {
            o = 1;
            break;
          }
          let v = /^"(?:[^"\\]|\\.)*?"|[^\/!]+/.exec(s);
          if (!v)
            throw new RangeError("Invalid path: " + a);
          if (i.push(v[0] == "*" ? "" : v[0][0] == '"' ? JSON.parse(v[0]) : v[0]), m += v[0].length, m == a.length)
            break;
          let O = a[m++];
          if (m == a.length && O == "!") {
            o = 0;
            break;
          }
          if (O != "/")
            throw new RangeError("Invalid path: " + a);
          s = a.slice(m);
        }
        let u = i.length - 1, f = i[u];
        if (!f)
          throw new RangeError("Invalid path: " + a);
        let p = new cI(r, o, u > 0 ? i.slice(0, u) : null);
        e[f] = p.sort(e[f]);
      }
  }
  return Wie.add(e);
}
const Wie = new nr();
class cI {
  constructor(e, n, r, a) {
    this.tags = e, this.mode = n, this.context = r, this.next = a;
  }
  get opaque() {
    return this.mode == 0;
  }
  get inherit() {
    return this.mode == 1;
  }
  sort(e) {
    return !e || e.depth < this.depth ? (this.next = e, this) : (e.next = this.sort(e.next), e);
  }
  get depth() {
    return this.context ? this.context.length : 0;
  }
}
cI.empty = new cI([], 2, null);
function Qie(t, e) {
  let n = /* @__PURE__ */ Object.create(null);
  for (let i of t)
    if (!Array.isArray(i.tag))
      n[i.tag.id] = i.class;
    else
      for (let o of i.tag)
        n[o.id] = i.class;
  let { scope: r, all: a = null } = e || {};
  return {
    style: (i) => {
      let o = a;
      for (let s of i)
        for (let u of s.set) {
          let f = n[u.id];
          if (f) {
            o = o ? o + " " + f : f;
            break;
          }
        }
      return o;
    },
    scope: r
  };
}
function qPe(t, e) {
  let n = null;
  for (let r of t) {
    let a = r.style(e);
    a && (n = n ? n + " " + a : a);
  }
  return n;
}
function KPe(t, e, n, r = 0, a = t.length) {
  let i = new JPe(r, Array.isArray(e) ? e : [e], n);
  i.highlightRange(t.cursor(), r, a, "", i.highlighters), i.flush(a);
}
class JPe {
  constructor(e, n, r) {
    this.at = e, this.highlighters = n, this.span = r, this.class = "";
  }
  startSpan(e, n) {
    n != this.class && (this.flush(e), e > this.at && (this.at = e), this.class = n);
  }
  flush(e) {
    e > this.at && this.class && this.span(this.at, e, this.class);
  }
  highlightRange(e, n, r, a, i) {
    let { type: o, from: s, to: u } = e;
    if (s >= r || u <= n)
      return;
    o.isTop && (i = this.highlighters.filter((O) => !O.scope || O.scope(o)));
    let f = a, p = eLe(e) || cI.empty, m = qPe(i, p.tags);
    if (m && (f && (f += " "), f += m, p.mode == 1 && (a += (a ? " " : "") + m)), this.startSpan(Math.max(n, s), f), p.opaque)
      return;
    let v = e.tree && e.tree.prop(nr.mounted);
    if (v && v.overlay) {
      let O = e.node.enter(v.overlay[0].from + s, 1), w = this.highlighters.filter((C) => !C.scope || C.scope(v.tree.type)), _ = e.firstChild();
      for (let C = 0, A = s; ; C++) {
        let N = C < v.overlay.length ? v.overlay[C] : null, P = N ? N.from + s : u, I = Math.max(n, A), D = Math.min(r, P);
        if (I < D && _)
          for (; e.from < D && (this.highlightRange(e, I, D, a, i), this.startSpan(Math.min(D, e.to), f), !(e.to >= P || !e.nextSibling())); )
            ;
        if (!N || P > r)
          break;
        A = N.to + s, A > n && (this.highlightRange(O.cursor(), Math.max(n, N.from + s), Math.min(r, A), "", w), this.startSpan(Math.min(r, A), f));
      }
      _ && e.parent();
    } else if (e.firstChild()) {
      v && (a = "");
      do
        if (!(e.to <= n)) {
          if (e.from >= r)
            break;
          this.highlightRange(e, n, r, a, i), this.startSpan(Math.min(r, e.to), f);
        }
      while (e.nextSibling());
      e.parent();
    }
  }
}
function eLe(t) {
  let e = t.type.prop(Wie);
  for (; e && e.context && !t.matchContext(e.context); )
    e = e.next;
  return e || null;
}
const Xt = zd.define, Kx = Xt(), Mb = Xt(), Oq = Xt(Mb), Eq = Xt(Mb), Fb = Xt(), Jx = Xt(Fb), d3 = Xt(Fb), dh = Xt(), zy = Xt(dh), ch = Xt(), fh = Xt(), P4 = Xt(), Ew = Xt(P4), eA = Xt(), ge = {
  /**
  A comment.
  */
  comment: Kx,
  /**
  A line [comment](#highlight.tags.comment).
  */
  lineComment: Xt(Kx),
  /**
  A block [comment](#highlight.tags.comment).
  */
  blockComment: Xt(Kx),
  /**
  A documentation [comment](#highlight.tags.comment).
  */
  docComment: Xt(Kx),
  /**
  Any kind of identifier.
  */
  name: Mb,
  /**
  The [name](#highlight.tags.name) of a variable.
  */
  variableName: Xt(Mb),
  /**
  A type [name](#highlight.tags.name).
  */
  typeName: Oq,
  /**
  A tag name (subtag of [`typeName`](#highlight.tags.typeName)).
  */
  tagName: Xt(Oq),
  /**
  A property or field [name](#highlight.tags.name).
  */
  propertyName: Eq,
  /**
  An attribute name (subtag of [`propertyName`](#highlight.tags.propertyName)).
  */
  attributeName: Xt(Eq),
  /**
  The [name](#highlight.tags.name) of a class.
  */
  className: Xt(Mb),
  /**
  A label [name](#highlight.tags.name).
  */
  labelName: Xt(Mb),
  /**
  A namespace [name](#highlight.tags.name).
  */
  namespace: Xt(Mb),
  /**
  The [name](#highlight.tags.name) of a macro.
  */
  macroName: Xt(Mb),
  /**
  A literal value.
  */
  literal: Fb,
  /**
  A string [literal](#highlight.tags.literal).
  */
  string: Jx,
  /**
  A documentation [string](#highlight.tags.string).
  */
  docString: Xt(Jx),
  /**
  A character literal (subtag of [string](#highlight.tags.string)).
  */
  character: Xt(Jx),
  /**
  An attribute value (subtag of [string](#highlight.tags.string)).
  */
  attributeValue: Xt(Jx),
  /**
  A number [literal](#highlight.tags.literal).
  */
  number: d3,
  /**
  An integer [number](#highlight.tags.number) literal.
  */
  integer: Xt(d3),
  /**
  A floating-point [number](#highlight.tags.number) literal.
  */
  float: Xt(d3),
  /**
  A boolean [literal](#highlight.tags.literal).
  */
  bool: Xt(Fb),
  /**
  Regular expression [literal](#highlight.tags.literal).
  */
  regexp: Xt(Fb),
  /**
  An escape [literal](#highlight.tags.literal), for example a
  backslash escape in a string.
  */
  escape: Xt(Fb),
  /**
  A color [literal](#highlight.tags.literal).
  */
  color: Xt(Fb),
  /**
  A URL [literal](#highlight.tags.literal).
  */
  url: Xt(Fb),
  /**
  A language keyword.
  */
  keyword: ch,
  /**
  The [keyword](#highlight.tags.keyword) for the self or this
  object.
  */
  self: Xt(ch),
  /**
  The [keyword](#highlight.tags.keyword) for null.
  */
  null: Xt(ch),
  /**
  A [keyword](#highlight.tags.keyword) denoting some atomic value.
  */
  atom: Xt(ch),
  /**
  A [keyword](#highlight.tags.keyword) that represents a unit.
  */
  unit: Xt(ch),
  /**
  A modifier [keyword](#highlight.tags.keyword).
  */
  modifier: Xt(ch),
  /**
  A [keyword](#highlight.tags.keyword) that acts as an operator.
  */
  operatorKeyword: Xt(ch),
  /**
  A control-flow related [keyword](#highlight.tags.keyword).
  */
  controlKeyword: Xt(ch),
  /**
  A [keyword](#highlight.tags.keyword) that defines something.
  */
  definitionKeyword: Xt(ch),
  /**
  A [keyword](#highlight.tags.keyword) related to defining or
  interfacing with modules.
  */
  moduleKeyword: Xt(ch),
  /**
  An operator.
  */
  operator: fh,
  /**
  An [operator](#highlight.tags.operator) that dereferences something.
  */
  derefOperator: Xt(fh),
  /**
  Arithmetic-related [operator](#highlight.tags.operator).
  */
  arithmeticOperator: Xt(fh),
  /**
  Logical [operator](#highlight.tags.operator).
  */
  logicOperator: Xt(fh),
  /**
  Bit [operator](#highlight.tags.operator).
  */
  bitwiseOperator: Xt(fh),
  /**
  Comparison [operator](#highlight.tags.operator).
  */
  compareOperator: Xt(fh),
  /**
  [Operator](#highlight.tags.operator) that updates its operand.
  */
  updateOperator: Xt(fh),
  /**
  [Operator](#highlight.tags.operator) that defines something.
  */
  definitionOperator: Xt(fh),
  /**
  Type-related [operator](#highlight.tags.operator).
  */
  typeOperator: Xt(fh),
  /**
  Control-flow [operator](#highlight.tags.operator).
  */
  controlOperator: Xt(fh),
  /**
  Program or markup punctuation.
  */
  punctuation: P4,
  /**
  [Punctuation](#highlight.tags.punctuation) that separates
  things.
  */
  separator: Xt(P4),
  /**
  Bracket-style [punctuation](#highlight.tags.punctuation).
  */
  bracket: Ew,
  /**
  Angle [brackets](#highlight.tags.bracket) (usually `<` and `>`
  tokens).
  */
  angleBracket: Xt(Ew),
  /**
  Square [brackets](#highlight.tags.bracket) (usually `[` and `]`
  tokens).
  */
  squareBracket: Xt(Ew),
  /**
  Parentheses (usually `(` and `)` tokens). Subtag of
  [bracket](#highlight.tags.bracket).
  */
  paren: Xt(Ew),
  /**
  Braces (usually `{` and `}` tokens). Subtag of
  [bracket](#highlight.tags.bracket).
  */
  brace: Xt(Ew),
  /**
  Content, for example plain text in XML or markup documents.
  */
  content: dh,
  /**
  [Content](#highlight.tags.content) that represents a heading.
  */
  heading: zy,
  /**
  A level 1 [heading](#highlight.tags.heading).
  */
  heading1: Xt(zy),
  /**
  A level 2 [heading](#highlight.tags.heading).
  */
  heading2: Xt(zy),
  /**
  A level 3 [heading](#highlight.tags.heading).
  */
  heading3: Xt(zy),
  /**
  A level 4 [heading](#highlight.tags.heading).
  */
  heading4: Xt(zy),
  /**
  A level 5 [heading](#highlight.tags.heading).
  */
  heading5: Xt(zy),
  /**
  A level 6 [heading](#highlight.tags.heading).
  */
  heading6: Xt(zy),
  /**
  A prose separator (such as a horizontal rule).
  */
  contentSeparator: Xt(dh),
  /**
  [Content](#highlight.tags.content) that represents a list.
  */
  list: Xt(dh),
  /**
  [Content](#highlight.tags.content) that represents a quote.
  */
  quote: Xt(dh),
  /**
  [Content](#highlight.tags.content) that is emphasized.
  */
  emphasis: Xt(dh),
  /**
  [Content](#highlight.tags.content) that is styled strong.
  */
  strong: Xt(dh),
  /**
  [Content](#highlight.tags.content) that is part of a link.
  */
  link: Xt(dh),
  /**
  [Content](#highlight.tags.content) that is styled as code or
  monospace.
  */
  monospace: Xt(dh),
  /**
  [Content](#highlight.tags.content) that has a strike-through
  style.
  */
  strikethrough: Xt(dh),
  /**
  Inserted text in a change-tracking format.
  */
  inserted: Xt(),
  /**
  Deleted text.
  */
  deleted: Xt(),
  /**
  Changed text.
  */
  changed: Xt(),
  /**
  An invalid or unsyntactic element.
  */
  invalid: Xt(),
  /**
  Metadata or meta-instruction.
  */
  meta: eA,
  /**
  [Metadata](#highlight.tags.meta) that applies to the entire
  document.
  */
  documentMeta: Xt(eA),
  /**
  [Metadata](#highlight.tags.meta) that annotates or adds
  attributes to a given syntactic element.
  */
  annotation: Xt(eA),
  /**
  Processing instruction or preprocessor directive. Subtag of
  [meta](#highlight.tags.meta).
  */
  processingInstruction: Xt(eA),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates that a
  given element is being defined. Expected to be used with the
  various [name](#highlight.tags.name) tags.
  */
  definition: zd.defineModifier(),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates that
  something is constant. Mostly expected to be used with
  [variable names](#highlight.tags.variableName).
  */
  constant: zd.defineModifier(),
  /**
  [Modifier](#highlight.Tag^defineModifier) used to indicate that
  a [variable](#highlight.tags.variableName) or [property
  name](#highlight.tags.propertyName) is being called or defined
  as a function.
  */
  function: zd.defineModifier(),
  /**
  [Modifier](#highlight.Tag^defineModifier) that can be applied to
  [names](#highlight.tags.name) to indicate that they belong to
  the language's standard environment.
  */
  standard: zd.defineModifier(),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates a given
  [names](#highlight.tags.name) is local to some scope.
  */
  local: zd.defineModifier(),
  /**
  A generic variant [modifier](#highlight.Tag^defineModifier) that
  can be used to tag language-specific alternative variants of
  some common tag. It is recommended for themes to define special
  forms of at least the [string](#highlight.tags.string) and
  [variable name](#highlight.tags.variableName) tags, since those
  come up a lot.
  */
  special: zd.defineModifier()
};
Qie([
  { tag: ge.link, class: "tok-link" },
  { tag: ge.heading, class: "tok-heading" },
  { tag: ge.emphasis, class: "tok-emphasis" },
  { tag: ge.strong, class: "tok-strong" },
  { tag: ge.keyword, class: "tok-keyword" },
  { tag: ge.atom, class: "tok-atom" },
  { tag: ge.bool, class: "tok-bool" },
  { tag: ge.url, class: "tok-url" },
  { tag: ge.labelName, class: "tok-labelName" },
  { tag: ge.inserted, class: "tok-inserted" },
  { tag: ge.deleted, class: "tok-deleted" },
  { tag: ge.literal, class: "tok-literal" },
  { tag: ge.string, class: "tok-string" },
  { tag: ge.number, class: "tok-number" },
  { tag: [ge.regexp, ge.escape, ge.special(ge.string)], class: "tok-string2" },
  { tag: ge.variableName, class: "tok-variableName" },
  { tag: ge.local(ge.variableName), class: "tok-variableName tok-local" },
  { tag: ge.definition(ge.variableName), class: "tok-variableName tok-definition" },
  { tag: ge.special(ge.variableName), class: "tok-variableName2" },
  { tag: ge.definition(ge.propertyName), class: "tok-propertyName tok-definition" },
  { tag: ge.typeName, class: "tok-typeName" },
  { tag: ge.namespace, class: "tok-namespace" },
  { tag: ge.className, class: "tok-className" },
  { tag: ge.macroName, class: "tok-macroName" },
  { tag: ge.propertyName, class: "tok-propertyName" },
  { tag: ge.operator, class: "tok-operator" },
  { tag: ge.comment, class: "tok-comment" },
  { tag: ge.meta, class: "tok-meta" },
  { tag: ge.invalid, class: "tok-invalid" },
  { tag: ge.punctuation, class: "tok-punctuation" }
]);
var p3;
const Gb = /* @__PURE__ */ new nr();
function ED(t) {
  return bn.define({
    combine: t ? (e) => e.concat(t) : void 0
  });
}
const KU = /* @__PURE__ */ new nr();
class Bc {
  /**
  Construct a language object. If you need to invoke this
  directly, first define a data facet with
  [`defineLanguageFacet`](https://codemirror.net/6/docs/ref/#language.defineLanguageFacet), and then
  configure your parser to [attach](https://codemirror.net/6/docs/ref/#language.languageDataProp) it
  to the language's outer syntax node.
  */
  constructor(e, n, r = [], a = "") {
    this.data = e, this.name = a, zr.prototype.hasOwnProperty("tree") || Object.defineProperty(zr.prototype, "tree", { get() {
      return $a(this);
    } }), this.parser = n, this.extension = [
      av.of(this),
      zr.languageData.of((i, o, s) => {
        let u = Sq(i, o, s), f = u.type.prop(Gb);
        if (!f)
          return [];
        let p = i.facet(f), m = u.type.prop(KU);
        if (m) {
          let v = u.resolve(o - u.from, s);
          for (let O of m)
            if (O.test(v, i)) {
              let w = i.facet(O.facet);
              return O.type == "replace" ? w : w.concat(p);
            }
        }
        return p;
      })
    ].concat(r);
  }
  /**
  Query whether this language is active at the given position.
  */
  isActiveAt(e, n, r = -1) {
    return Sq(e, n, r).type.prop(Gb) == this.data;
  }
  /**
  Find the document regions that were parsed using this language.
  The returned regions will _include_ any nested languages rooted
  in this language, when those exist.
  */
  findRegions(e) {
    let n = e.facet(av);
    if ((n == null ? void 0 : n.data) == this.data)
      return [{ from: 0, to: e.doc.length }];
    if (!n || !n.allowsNesting)
      return [];
    let r = [], a = (i, o) => {
      if (i.prop(Gb) == this.data) {
        r.push({ from: o, to: o + i.length });
        return;
      }
      let s = i.prop(nr.mounted);
      if (s) {
        if (s.tree.prop(Gb) == this.data) {
          if (s.overlay)
            for (let u of s.overlay)
              r.push({ from: u.from + o, to: u.to + o });
          else
            r.push({ from: o, to: o + i.length });
          return;
        } else if (s.overlay) {
          let u = r.length;
          if (a(s.tree, s.overlay[0].from + o), r.length > u)
            return;
        }
      }
      for (let u = 0; u < i.children.length; u++) {
        let f = i.children[u];
        f instanceof Pr && a(f, i.positions[u] + o);
      }
    };
    return a($a(e), 0), r;
  }
  /**
  Indicates whether this language allows nested languages. The
  default implementation returns true.
  */
  get allowsNesting() {
    return !0;
  }
}
Bc.setState = /* @__PURE__ */ fr.define();
function Sq(t, e, n) {
  let r = t.facet(av), a = $a(t).topNode;
  if (!r || r.allowsNesting)
    for (let i = a; i; i = i.enter(e, n, ii.ExcludeBuffers))
      i.type.isTop && (a = i);
  return a;
}
class VE extends Bc {
  constructor(e, n, r) {
    super(e, n, [], r), this.parser = n;
  }
  /**
  Define a language from a parser.
  */
  static define(e) {
    let n = ED(e.languageData);
    return new VE(n, e.parser.configure({
      props: [Gb.add((r) => r.isTop ? n : void 0)]
    }), e.name);
  }
  /**
  Create a new instance of this language with a reconfigured
  version of its parser and optionally a new name.
  */
  configure(e, n) {
    return new VE(this.data, this.parser.configure(e), n || this.name);
  }
  get allowsNesting() {
    return this.parser.hasWrappers();
  }
}
function $a(t) {
  let e = t.field(Bc.state, !1);
  return e ? e.tree : Pr.empty;
}
class tLe {
  /**
  Create an input object for the given document.
  */
  constructor(e) {
    this.doc = e, this.cursorPos = 0, this.string = "", this.cursor = e.iter();
  }
  get length() {
    return this.doc.length;
  }
  syncTo(e) {
    return this.string = this.cursor.next(e - this.cursorPos).value, this.cursorPos = e + this.string.length, this.cursorPos - this.string.length;
  }
  chunk(e) {
    return this.syncTo(e), this.string;
  }
  get lineChunks() {
    return !0;
  }
  read(e, n) {
    let r = this.cursorPos - this.string.length;
    return e < r || n >= this.cursorPos ? this.doc.sliceString(e, n) : this.string.slice(e - r, n - r);
  }
}
let Sw = null;
class h0 {
  constructor(e, n, r = [], a, i, o, s, u) {
    this.parser = e, this.state = n, this.fragments = r, this.tree = a, this.treeLen = i, this.viewport = o, this.skipped = s, this.scheduleOn = u, this.parse = null, this.tempSkipped = [];
  }
  /**
  @internal
  */
  static create(e, n, r) {
    return new h0(e, n, [], Pr.empty, 0, r, [], null);
  }
  startParse() {
    return this.parser.startParse(new tLe(this.state.doc), this.fragments);
  }
  /**
  @internal
  */
  work(e, n) {
    return n != null && n >= this.state.doc.length && (n = void 0), this.tree != Pr.empty && this.isDone(n ?? this.state.doc.length) ? (this.takeTree(), !0) : this.withContext(() => {
      var r;
      if (typeof e == "number") {
        let a = Date.now() + e;
        e = () => Date.now() > a;
      }
      for (this.parse || (this.parse = this.startParse()), n != null && (this.parse.stoppedAt == null || this.parse.stoppedAt > n) && n < this.state.doc.length && this.parse.stopAt(n); ; ) {
        let a = this.parse.advance();
        if (a)
          if (this.fragments = this.withoutTempSkipped(Km.addTree(a, this.fragments, this.parse.stoppedAt != null)), this.treeLen = (r = this.parse.stoppedAt) !== null && r !== void 0 ? r : this.state.doc.length, this.tree = a, this.parse = null, this.treeLen < (n ?? this.state.doc.length))
            this.parse = this.startParse();
          else
            return !0;
        if (e())
          return !1;
      }
    });
  }
  /**
  @internal
  */
  takeTree() {
    let e, n;
    this.parse && (e = this.parse.parsedPos) >= this.treeLen && ((this.parse.stoppedAt == null || this.parse.stoppedAt > e) && this.parse.stopAt(e), this.withContext(() => {
      for (; !(n = this.parse.advance()); )
        ;
    }), this.treeLen = e, this.tree = n, this.fragments = this.withoutTempSkipped(Km.addTree(this.tree, this.fragments, !0)), this.parse = null);
  }
  withContext(e) {
    let n = Sw;
    Sw = this;
    try {
      return e();
    } finally {
      Sw = n;
    }
  }
  withoutTempSkipped(e) {
    for (let n; n = this.tempSkipped.pop(); )
      e = wq(e, n.from, n.to);
    return e;
  }
  /**
  @internal
  */
  changes(e, n) {
    let { fragments: r, tree: a, treeLen: i, viewport: o, skipped: s } = this;
    if (this.takeTree(), !e.empty) {
      let u = [];
      if (e.iterChangedRanges((f, p, m, v) => u.push({ fromA: f, toA: p, fromB: m, toB: v })), r = Km.applyChanges(r, u), a = Pr.empty, i = 0, o = { from: e.mapPos(o.from, -1), to: e.mapPos(o.to, 1) }, this.skipped.length) {
        s = [];
        for (let f of this.skipped) {
          let p = e.mapPos(f.from, 1), m = e.mapPos(f.to, -1);
          p < m && s.push({ from: p, to: m });
        }
      }
    }
    return new h0(this.parser, n, r, a, i, o, s, this.scheduleOn);
  }
  /**
  @internal
  */
  updateViewport(e) {
    if (this.viewport.from == e.from && this.viewport.to == e.to)
      return !1;
    this.viewport = e;
    let n = this.skipped.length;
    for (let r = 0; r < this.skipped.length; r++) {
      let { from: a, to: i } = this.skipped[r];
      a < e.to && i > e.from && (this.fragments = wq(this.fragments, a, i), this.skipped.splice(r--, 1));
    }
    return this.skipped.length >= n ? !1 : (this.reset(), !0);
  }
  /**
  @internal
  */
  reset() {
    this.parse && (this.takeTree(), this.parse = null);
  }
  /**
  Notify the parse scheduler that the given region was skipped
  because it wasn't in view, and the parse should be restarted
  when it comes into view.
  */
  skipUntilInView(e, n) {
    this.skipped.push({ from: e, to: n });
  }
  /**
  Returns a parser intended to be used as placeholder when
  asynchronously loading a nested parser. It'll skip its input and
  mark it as not-really-parsed, so that the next update will parse
  it again.
  
  When `until` is given, a reparse will be scheduled when that
  promise resolves.
  */
  static getSkippingParser(e) {
    return new class extends OD {
      createParse(n, r, a) {
        let i = a[0].from, o = a[a.length - 1].to;
        return {
          parsedPos: i,
          advance() {
            let u = Sw;
            if (u) {
              for (let f of a)
                u.tempSkipped.push(f);
              e && (u.scheduleOn = u.scheduleOn ? Promise.all([u.scheduleOn, e]) : e);
            }
            return this.parsedPos = o, new Pr(Po.none, [], [], o - i);
          },
          stoppedAt: null,
          stopAt() {
          }
        };
      }
    }();
  }
  /**
  @internal
  */
  isDone(e) {
    e = Math.min(e, this.state.doc.length);
    let n = this.fragments;
    return this.treeLen >= e && n.length && n[0].from == 0 && n[0].to >= e;
  }
  /**
  Get the context for the current parse, or `null` if no editor
  parse is in progress.
  */
  static get() {
    return Sw;
  }
}
function wq(t, e, n) {
  return Km.applyChanges(t, [{ fromA: e, toA: n, fromB: e, toB: n }]);
}
class YE {
  constructor(e) {
    this.context = e, this.tree = e.tree;
  }
  apply(e) {
    if (!e.docChanged && this.tree == this.context.tree)
      return this;
    let n = this.context.changes(e.changes, e.state), r = this.context.treeLen == e.startState.doc.length ? void 0 : Math.max(e.changes.mapPos(this.context.treeLen), n.viewport.to);
    return n.work(20, r) || n.takeTree(), new YE(n);
  }
  static init(e) {
    let n = Math.min(3e3, e.doc.length), r = h0.create(e.facet(av).parser, e, { from: 0, to: n });
    return r.work(20, n) || r.takeTree(), new YE(r);
  }
}
Bc.state = /* @__PURE__ */ Ss.define({
  create: YE.init,
  update(t, e) {
    for (let n of e.effects)
      if (n.is(Bc.setState))
        return n.value;
    return e.startState.facet(av) != e.state.facet(av) ? YE.init(e.state) : t.apply(e);
  }
});
let jie = (t) => {
  let e = setTimeout(
    () => t(),
    500
    /* Work.MaxPause */
  );
  return () => clearTimeout(e);
};
typeof requestIdleCallback < "u" && (jie = (t) => {
  let e = -1, n = setTimeout(
    () => {
      e = requestIdleCallback(t, {
        timeout: 500 - 100
        /* Work.MinPause */
      });
    },
    100
    /* Work.MinPause */
  );
  return () => e < 0 ? clearTimeout(n) : cancelIdleCallback(e);
});
const h3 = typeof navigator < "u" && (!((p3 = navigator.scheduling) === null || p3 === void 0) && p3.isInputPending) ? () => navigator.scheduling.isInputPending() : null, nLe = /* @__PURE__ */ Ki.fromClass(class {
  constructor(e) {
    this.view = e, this.working = null, this.workScheduled = 0, this.chunkEnd = -1, this.chunkBudget = -1, this.work = this.work.bind(this), this.scheduleWork();
  }
  update(e) {
    let n = this.view.state.field(Bc.state).context;
    (n.updateViewport(e.view.viewport) || this.view.viewport.to > n.treeLen) && this.scheduleWork(), (e.docChanged || e.selectionSet) && (this.view.hasFocus && (this.chunkBudget += 50), this.scheduleWork()), this.checkAsyncSchedule(n);
  }
  scheduleWork() {
    if (this.working)
      return;
    let { state: e } = this.view, n = e.field(Bc.state);
    (n.tree != n.context.tree || !n.context.isDone(e.doc.length)) && (this.working = jie(this.work));
  }
  work(e) {
    this.working = null;
    let n = Date.now();
    if (this.chunkEnd < n && (this.chunkEnd < 0 || this.view.hasFocus) && (this.chunkEnd = n + 3e4, this.chunkBudget = 3e3), this.chunkBudget <= 0)
      return;
    let { state: r, viewport: { to: a } } = this.view, i = r.field(Bc.state);
    if (i.tree == i.context.tree && i.context.isDone(
      a + 1e5
      /* Work.MaxParseAhead */
    ))
      return;
    let o = Date.now() + Math.min(this.chunkBudget, 100, e && !h3 ? Math.max(25, e.timeRemaining() - 5) : 1e9), s = i.context.treeLen < a && r.doc.length > a + 1e3, u = i.context.work(() => h3 && h3() || Date.now() > o, a + (s ? 0 : 1e5));
    this.chunkBudget -= Date.now() - n, (u || this.chunkBudget <= 0) && (i.context.takeTree(), this.view.dispatch({ effects: Bc.setState.of(new YE(i.context)) })), this.chunkBudget > 0 && !(u && !s) && this.scheduleWork(), this.checkAsyncSchedule(i.context);
  }
  checkAsyncSchedule(e) {
    e.scheduleOn && (this.workScheduled++, e.scheduleOn.then(() => this.scheduleWork()).catch((n) => Ku(this.view.state, n)).then(() => this.workScheduled--), e.scheduleOn = null);
  }
  destroy() {
    this.working && this.working();
  }
  isWorking() {
    return !!(this.working || this.workScheduled > 0);
  }
}, {
  eventHandlers: { focus() {
    this.scheduleWork();
  } }
}), av = /* @__PURE__ */ bn.define({
  combine(t) {
    return t.length ? t[0] : null;
  },
  enables: (t) => [
    Bc.state,
    nLe,
    qt.contentAttributes.compute([t], (e) => {
      let n = e.facet(t);
      return n && n.name ? { "data-language": n.name } : {};
    })
  ]
});
class ZE {
  /**
  Create a language support object.
  */
  constructor(e, n = []) {
    this.language = e, this.support = n, this.extension = [e, n];
  }
}
class at {
  constructor(e, n, r, a, i, o = void 0) {
    this.name = e, this.alias = n, this.extensions = r, this.filename = a, this.loadFunc = i, this.support = o, this.loading = null;
  }
  /**
  Start loading the the language. Will return a promise that
  resolves to a [`LanguageSupport`](https://codemirror.net/6/docs/ref/#language.LanguageSupport)
  object when the language successfully loads.
  */
  load() {
    return this.loading || (this.loading = this.loadFunc().then((e) => this.support = e, (e) => {
      throw this.loading = null, e;
    }));
  }
  /**
  Create a language description.
  */
  static of(e) {
    let { load: n, support: r } = e;
    if (!n) {
      if (!r)
        throw new RangeError("Must pass either 'load' or 'support' to LanguageDescription.of");
      n = () => Promise.resolve(r);
    }
    return new at(e.name, (e.alias || []).concat(e.name).map((a) => a.toLowerCase()), e.extensions || [], e.filename, n, r);
  }
  /**
  Look for a language in the given array of descriptions that
  matches the filename. Will first match
  [`filename`](https://codemirror.net/6/docs/ref/#language.LanguageDescription.filename) patterns,
  and then [extensions](https://codemirror.net/6/docs/ref/#language.LanguageDescription.extensions),
  and return the first language that matches.
  */
  static matchFilename(e, n) {
    for (let a of e)
      if (a.filename && a.filename.test(n))
        return a;
    let r = /\.([^.]+)$/.exec(n);
    if (r) {
      for (let a of e)
        if (a.extensions.indexOf(r[1]) > -1)
          return a;
    }
    return null;
  }
  /**
  Look for a language whose name or alias matches the the given
  name (case-insensitively). If `fuzzy` is true, and no direct
  matchs is found, this'll also search for a language whose name
  or alias occurs in the string (for names shorter than three
  characters, only when surrounded by non-word characters).
  */
  static matchLanguageName(e, n, r = !0) {
    n = n.toLowerCase();
    for (let a of e)
      if (a.alias.some((i) => i == n))
        return a;
    if (r)
      for (let a of e)
        for (let i of a.alias) {
          let o = n.indexOf(i);
          if (o > -1 && (i.length > 2 || !/\w/.test(n[o - 1]) && !/\w/.test(n[o + i.length])))
            return a;
        }
    return null;
  }
}
const Gie = /* @__PURE__ */ bn.define(), f1 = /* @__PURE__ */ bn.define({
  combine: (t) => {
    if (!t.length)
      return "  ";
    let e = t[0];
    if (!e || /\S/.test(e) || Array.from(e).some((n) => n != e[0]))
      throw new Error("Invalid indent unit: " + JSON.stringify(t[0]));
    return e;
  }
});
function m0(t) {
  let e = t.facet(f1);
  return e.charCodeAt(0) == 9 ? t.tabSize * e.length : e.length;
}
function VT(t, e) {
  let n = "", r = t.tabSize, a = t.facet(f1)[0];
  if (a == "	") {
    for (; e >= r; )
      n += "	", e -= r;
    a = " ";
  }
  for (let i = 0; i < e; i++)
    n += a;
  return n;
}
function JU(t, e) {
  t instanceof zr && (t = new SD(t));
  for (let r of t.state.facet(Gie)) {
    let a = r(t, e);
    if (a !== void 0)
      return a;
  }
  let n = $a(t.state);
  return n.length >= e ? rLe(t, n, e) : null;
}
class SD {
  /**
  Create an indent context.
  */
  constructor(e, n = {}) {
    this.state = e, this.options = n, this.unit = m0(e);
  }
  /**
  Get a description of the line at the given position, taking
  [simulated line
  breaks](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
  into account. If there is such a break at `pos`, the `bias`
  argument determines whether the part of the line line before or
  after the break is used.
  */
  lineAt(e, n = 1) {
    let r = this.state.doc.lineAt(e), { simulateBreak: a, simulateDoubleBreak: i } = this.options;
    return a != null && a >= r.from && a <= r.to ? i && a == e ? { text: "", from: e } : (n < 0 ? a < e : a <= e) ? { text: r.text.slice(a - r.from), from: a } : { text: r.text.slice(0, a - r.from), from: r.from } : r;
  }
  /**
  Get the text directly after `pos`, either the entire line
  or the next 100 characters, whichever is shorter.
  */
  textAfterPos(e, n = 1) {
    if (this.options.simulateDoubleBreak && e == this.options.simulateBreak)
      return "";
    let { text: r, from: a } = this.lineAt(e, n);
    return r.slice(e - a, Math.min(r.length, e + 100 - a));
  }
  /**
  Find the column for the given position.
  */
  column(e, n = 1) {
    let { text: r, from: a } = this.lineAt(e, n), i = this.countColumn(r, e - a), o = this.options.overrideIndentation ? this.options.overrideIndentation(a) : -1;
    return o > -1 && (i += o - this.countColumn(r, r.search(/\S|$/))), i;
  }
  /**
  Find the column position (taking tabs into account) of the given
  position in the given string.
  */
  countColumn(e, n = e.length) {
    return Xd(e, this.state.tabSize, n);
  }
  /**
  Find the indentation column of the line at the given point.
  */
  lineIndent(e, n = 1) {
    let { text: r, from: a } = this.lineAt(e, n), i = this.options.overrideIndentation;
    if (i) {
      let o = i(a);
      if (o > -1)
        return o;
    }
    return this.countColumn(r, r.search(/\S|$/));
  }
  /**
  Returns the [simulated line
  break](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
  for this context, if any.
  */
  get simulatedBreak() {
    return this.options.simulateBreak || null;
  }
}
const S_ = /* @__PURE__ */ new nr();
function rLe(t, e, n) {
  let r = e.resolveStack(n), a = r.node.enterUnfinishedNodesBefore(n);
  if (a != r.node) {
    let i = [];
    for (let o = a; o != r.node; o = o.parent)
      i.push(o);
    for (let o = i.length - 1; o >= 0; o--)
      r = { node: i[o], next: r };
  }
  return Vie(r, t, n);
}
function Vie(t, e, n) {
  for (let r = t; r; r = r.next) {
    let a = iLe(r.node);
    if (a)
      return a(e6.create(e, n, r));
  }
  return 0;
}
function aLe(t) {
  return t.pos == t.options.simulateBreak && t.options.simulateDoubleBreak;
}
function iLe(t) {
  let e = t.type.prop(S_);
  if (e)
    return e;
  let n = t.firstChild, r;
  if (n && (r = n.type.prop(nr.closedBy))) {
    let a = t.lastChild, i = a && r.indexOf(a.name) > -1;
    return (o) => Yie(o, !0, 1, void 0, i && !aLe(o) ? a.from : void 0);
  }
  return t.parent == null ? oLe : null;
}
function oLe() {
  return 0;
}
class e6 extends SD {
  constructor(e, n, r) {
    super(e.state, e.options), this.base = e, this.pos = n, this.context = r;
  }
  /**
  The syntax tree node to which the indentation strategy
  applies.
  */
  get node() {
    return this.context.node;
  }
  /**
  @internal
  */
  static create(e, n, r) {
    return new e6(e, n, r);
  }
  /**
  Get the text directly after `this.pos`, either the entire line
  or the next 100 characters, whichever is shorter.
  */
  get textAfter() {
    return this.textAfterPos(this.pos);
  }
  /**
  Get the indentation at the reference line for `this.node`, which
  is the line on which it starts, unless there is a node that is
  _not_ a parent of this node covering the start of that line. If
  so, the line at the start of that node is tried, again skipping
  on if it is covered by another such node.
  */
  get baseIndent() {
    return this.baseIndentFor(this.node);
  }
  /**
  Get the indentation for the reference line of the given node
  (see [`baseIndent`](https://codemirror.net/6/docs/ref/#language.TreeIndentContext.baseIndent)).
  */
  baseIndentFor(e) {
    let n = this.state.doc.lineAt(e.from);
    for (; ; ) {
      let r = e.resolve(n.from);
      for (; r.parent && r.parent.from == r.from; )
        r = r.parent;
      if (sLe(r, e))
        break;
      n = this.state.doc.lineAt(r.from);
    }
    return this.lineIndent(n.from);
  }
  /**
  Continue looking for indentations in the node's parent nodes,
  and return the result of that.
  */
  continue() {
    return Vie(this.context.next, this.base, this.pos);
  }
}
function sLe(t, e) {
  for (let n = e; n; n = n.parent)
    if (t == n)
      return !0;
  return !1;
}
function lLe(t) {
  let e = t.node, n = e.childAfter(e.from), r = e.lastChild;
  if (!n)
    return null;
  let a = t.options.simulateBreak, i = t.state.doc.lineAt(n.from), o = a == null || a <= i.from ? i.to : Math.min(i.to, a);
  for (let s = n.to; ; ) {
    let u = e.childAfter(s);
    if (!u || u == r)
      return null;
    if (!u.type.isSkipped)
      return u.from < o ? n : null;
    s = u.to;
  }
}
function uLe({ closing: t, align: e = !0, units: n = 1 }) {
  return (r) => Yie(r, e, n, t);
}
function Yie(t, e, n, r, a) {
  let i = t.textAfter, o = i.match(/^\s*/)[0].length, s = r && i.slice(o, o + r.length) == r || a == t.pos + o, u = e ? lLe(t) : null;
  return u ? s ? t.column(u.from) : t.column(u.to) : t.baseIndent + (s ? 0 : t.unit * n);
}
const cLe = (t) => t.baseIndent;
function kk({ except: t, units: e = 1 } = {}) {
  return (n) => {
    let r = t && t.test(n.textAfter);
    return n.baseIndent + (r ? 0 : e * n.unit);
  };
}
const fLe = 200;
function dLe() {
  return zr.transactionFilter.of((t) => {
    if (!t.docChanged || !t.isUserEvent("input.type") && !t.isUserEvent("input.complete"))
      return t;
    let e = t.startState.languageDataAt("indentOnInput", t.startState.selection.main.head);
    if (!e.length)
      return t;
    let n = t.newDoc, { head: r } = t.newSelection.main, a = n.lineAt(r);
    if (r > a.from + fLe)
      return t;
    let i = n.sliceString(a.from, r);
    if (!e.some((f) => f.test(i)))
      return t;
    let { state: o } = t, s = -1, u = [];
    for (let { head: f } of o.selection.ranges) {
      let p = o.doc.lineAt(f);
      if (p.from == s)
        continue;
      s = p.from;
      let m = JU(o, p.from);
      if (m == null)
        continue;
      let v = /^\s*/.exec(p.text)[0], O = VT(o, m);
      v != O && u.push({ from: p.from, to: p.from + v.length, insert: O });
    }
    return u.length ? [t, { changes: u, sequential: !0 }] : t;
  });
}
const Zie = /* @__PURE__ */ bn.define(), d1 = /* @__PURE__ */ new nr();
function Xie(t) {
  let e = t.firstChild, n = t.lastChild;
  return e && e.to < n.from ? { from: e.to, to: n.type.isError ? t.to : n.from } : null;
}
function pLe(t, e, n) {
  let r = $a(t);
  if (r.length < n)
    return null;
  let a = r.resolveStack(n, 1), i = null;
  for (let o = a; o; o = o.next) {
    let s = o.node;
    if (s.to <= n || s.from > n)
      continue;
    if (i && s.from < e)
      break;
    let u = s.type.prop(d1);
    if (u && (s.to < r.length - 50 || r.length == t.doc.length || !hLe(s))) {
      let f = u(s, t);
      f && f.from <= n && f.from >= e && f.to > n && (i = f);
    }
  }
  return i;
}
function hLe(t) {
  let e = t.lastChild;
  return e && e.to == t.to && e.type.isError;
}
function fI(t, e, n) {
  for (let r of t.facet(Zie)) {
    let a = r(t, e, n);
    if (a)
      return a;
  }
  return pLe(t, e, n);
}
function qie(t, e) {
  let n = e.mapPos(t.from, 1), r = e.mapPos(t.to, -1);
  return n >= r ? void 0 : { from: n, to: r };
}
const wD = /* @__PURE__ */ fr.define({ map: qie }), w_ = /* @__PURE__ */ fr.define({ map: qie });
function Kie(t) {
  let e = [];
  for (let { head: n } of t.state.selection.ranges)
    e.some((r) => r.from <= n && r.to >= n) || e.push(t.lineBlockAt(n));
  return e;
}
const g0 = /* @__PURE__ */ Ss.define({
  create() {
    return Ln.none;
  },
  update(t, e) {
    t = t.map(e.changes);
    for (let n of e.effects)
      if (n.is(wD) && !mLe(t, n.value.from, n.value.to)) {
        let { preparePlaceholder: r } = e.state.facet(t6), a = r ? Ln.replace({ widget: new SLe(r(e.state, n.value)) }) : Tq;
        t = t.update({ add: [a.range(n.value.from, n.value.to)] });
      } else
        n.is(w_) && (t = t.update({
          filter: (r, a) => n.value.from != r || n.value.to != a,
          filterFrom: n.value.from,
          filterTo: n.value.to
        }));
    if (e.selection) {
      let n = !1, { head: r } = e.selection.main;
      t.between(r, r, (a, i) => {
        a < r && i > r && (n = !0);
      }), n && (t = t.update({
        filterFrom: r,
        filterTo: r,
        filter: (a, i) => i <= r || a >= r
      }));
    }
    return t;
  },
  provide: (t) => qt.decorations.from(t),
  toJSON(t, e) {
    let n = [];
    return t.between(0, e.doc.length, (r, a) => {
      n.push(r, a);
    }), n;
  },
  fromJSON(t) {
    if (!Array.isArray(t) || t.length % 2)
      throw new RangeError("Invalid JSON for fold state");
    let e = [];
    for (let n = 0; n < t.length; ) {
      let r = t[n++], a = t[n++];
      if (typeof r != "number" || typeof a != "number")
        throw new RangeError("Invalid JSON for fold state");
      e.push(Tq.range(r, a));
    }
    return Ln.set(e, !0);
  }
});
function dI(t, e, n) {
  var r;
  let a = null;
  return (r = t.field(g0, !1)) === null || r === void 0 || r.between(e, n, (i, o) => {
    (!a || a.from > i) && (a = { from: i, to: o });
  }), a;
}
function mLe(t, e, n) {
  let r = !1;
  return t.between(e, e, (a, i) => {
    a == e && i == n && (r = !0);
  }), r;
}
function Jie(t, e) {
  return t.field(g0, !1) ? e : e.concat(fr.appendConfig.of(toe()));
}
const gLe = (t) => {
  for (let e of Kie(t)) {
    let n = fI(t.state, e.from, e.to);
    if (n)
      return t.dispatch({ effects: Jie(t.state, [wD.of(n), eoe(t, n)]) }), !0;
  }
  return !1;
}, bLe = (t) => {
  if (!t.state.field(g0, !1))
    return !1;
  let e = [];
  for (let n of Kie(t)) {
    let r = dI(t.state, n.from, n.to);
    r && e.push(w_.of(r), eoe(t, r, !1));
  }
  return e.length && t.dispatch({ effects: e }), e.length > 0;
};
function eoe(t, e, n = !0) {
  let r = t.state.doc.lineAt(e.from).number, a = t.state.doc.lineAt(e.to).number;
  return qt.announce.of(`${t.state.phrase(n ? "Folded lines" : "Unfolded lines")} ${r} ${t.state.phrase("to")} ${a}.`);
}
const vLe = (t) => {
  let { state: e } = t, n = [];
  for (let r = 0; r < e.doc.length; ) {
    let a = t.lineBlockAt(r), i = fI(e, a.from, a.to);
    i && n.push(wD.of(i)), r = (i ? t.lineBlockAt(i.to) : a).to + 1;
  }
  return n.length && t.dispatch({ effects: Jie(t.state, n) }), !!n.length;
}, yLe = (t) => {
  let e = t.state.field(g0, !1);
  if (!e || !e.size)
    return !1;
  let n = [];
  return e.between(0, t.state.doc.length, (r, a) => {
    n.push(w_.of({ from: r, to: a }));
  }), t.dispatch({ effects: n }), !0;
}, OLe = [
  { key: "Ctrl-Shift-[", mac: "Cmd-Alt-[", run: gLe },
  { key: "Ctrl-Shift-]", mac: "Cmd-Alt-]", run: bLe },
  { key: "Ctrl-Alt-[", run: vLe },
  { key: "Ctrl-Alt-]", run: yLe }
], ELe = {
  placeholderDOM: null,
  preparePlaceholder: null,
  placeholderText: "…"
}, t6 = /* @__PURE__ */ bn.define({
  combine(t) {
    return Dh(t, ELe);
  }
});
function toe(t) {
  let e = [g0, _Le];
  return t && e.push(t6.of(t)), e;
}
function noe(t, e) {
  let { state: n } = t, r = n.facet(t6), a = (o) => {
    let s = t.lineBlockAt(t.posAtDOM(o.target)), u = dI(t.state, s.from, s.to);
    u && t.dispatch({ effects: w_.of(u) }), o.preventDefault();
  };
  if (r.placeholderDOM)
    return r.placeholderDOM(t, a, e);
  let i = document.createElement("span");
  return i.textContent = r.placeholderText, i.setAttribute("aria-label", n.phrase("folded code")), i.title = n.phrase("unfold"), i.className = "cm-foldPlaceholder", i.onclick = a, i;
}
const Tq = /* @__PURE__ */ Ln.replace({ widget: /* @__PURE__ */ new class extends Nh {
  toDOM(t) {
    return noe(t, null);
  }
}() });
class SLe extends Nh {
  constructor(e) {
    super(), this.value = e;
  }
  eq(e) {
    return this.value == e.value;
  }
  toDOM(e) {
    return noe(e, this.value);
  }
}
const wLe = {
  openText: "⌄",
  closedText: "›",
  markerDOM: null,
  domEventHandlers: {},
  foldingChanged: () => !1
};
class m3 extends rg {
  constructor(e, n) {
    super(), this.config = e, this.open = n;
  }
  eq(e) {
    return this.config == e.config && this.open == e.open;
  }
  toDOM(e) {
    if (this.config.markerDOM)
      return this.config.markerDOM(this.open);
    let n = document.createElement("span");
    return n.textContent = this.open ? this.config.openText : this.config.closedText, n.title = e.state.phrase(this.open ? "Fold line" : "Unfold line"), n;
  }
}
function TLe(t = {}) {
  let e = Object.assign(Object.assign({}, wLe), t), n = new m3(e, !0), r = new m3(e, !1), a = Ki.fromClass(class {
    constructor(o) {
      this.from = o.viewport.from, this.markers = this.buildMarkers(o);
    }
    update(o) {
      (o.docChanged || o.viewportChanged || o.startState.facet(av) != o.state.facet(av) || o.startState.field(g0, !1) != o.state.field(g0, !1) || $a(o.startState) != $a(o.state) || e.foldingChanged(o)) && (this.markers = this.buildMarkers(o.view));
    }
    buildMarkers(o) {
      let s = new Jb();
      for (let u of o.viewportLineBlocks) {
        let f = dI(o.state, u.from, u.to) ? r : fI(o.state, u.from, u.to) ? n : null;
        f && s.add(u.from, u.from, f);
      }
      return s.finish();
    }
  }), { domEventHandlers: i } = e;
  return [
    a,
    TPe({
      class: "cm-foldGutter",
      markers(o) {
        var s;
        return ((s = o.plugin(a)) === null || s === void 0 ? void 0 : s.markers) || ta.empty;
      },
      initialSpacer() {
        return new m3(e, !1);
      },
      domEventHandlers: Object.assign(Object.assign({}, i), { click: (o, s, u) => {
        if (i.click && i.click(o, s, u))
          return !0;
        let f = dI(o.state, s.from, s.to);
        if (f)
          return o.dispatch({ effects: w_.of(f) }), !0;
        let p = fI(o.state, s.from, s.to);
        return p ? (o.dispatch({ effects: wD.of(p) }), !0) : !1;
      } })
    }),
    toe()
  ];
}
const _Le = /* @__PURE__ */ qt.baseTheme({
  ".cm-foldPlaceholder": {
    backgroundColor: "#eee",
    border: "1px solid #ddd",
    color: "#888",
    borderRadius: ".2em",
    margin: "0 1px",
    padding: "0 1px",
    cursor: "pointer"
  },
  ".cm-foldGutter span": {
    padding: "0 1px",
    cursor: "pointer"
  }
});
class p1 {
  constructor(e, n) {
    this.specs = e;
    let r;
    function a(s) {
      let u = ev.newName();
      return (r || (r = /* @__PURE__ */ Object.create(null)))["." + u] = s, u;
    }
    const i = typeof n.all == "string" ? n.all : n.all ? a(n.all) : void 0, o = n.scope;
    this.scope = o instanceof Bc ? (s) => s.prop(Gb) == o.data : o ? (s) => s == o : void 0, this.style = Qie(e.map((s) => ({
      tag: s.tag,
      class: s.class || a(Object.assign({}, s, { tag: null }))
    })), {
      all: i
    }).style, this.module = r ? new ev(r) : null, this.themeType = n.themeType;
  }
  /**
  Create a highlighter style that associates the given styles to
  the given tags. The specs must be objects that hold a style tag
  or array of tags in their `tag` property, and either a single
  `class` property providing a static CSS class (for highlighter
  that rely on external styling), or a
  [`style-mod`](https://github.com/marijnh/style-mod#documentation)-style
  set of CSS properties (which define the styling for those tags).
  
  The CSS rules created for a highlighter will be emitted in the
  order of the spec's properties. That means that for elements that
  have multiple tags associated with them, styles defined further
  down in the list will have a higher CSS precedence than styles
  defined earlier.
  */
  static define(e, n) {
    return new p1(e, n || {});
  }
}
const L4 = /* @__PURE__ */ bn.define(), roe = /* @__PURE__ */ bn.define({
  combine(t) {
    return t.length ? [t[0]] : null;
  }
});
function g3(t) {
  let e = t.facet(L4);
  return e.length ? e : t.facet(roe);
}
function n6(t, e) {
  let n = [xLe], r;
  return t instanceof p1 && (t.module && n.push(qt.styleModule.of(t.module)), r = t.themeType), e != null && e.fallback ? n.push(roe.of(t)) : r ? n.push(L4.computeN([qt.darkTheme], (a) => a.facet(qt.darkTheme) == (r == "dark") ? [t] : [])) : n.push(L4.of(t)), n;
}
class CLe {
  constructor(e) {
    this.markCache = /* @__PURE__ */ Object.create(null), this.tree = $a(e.state), this.decorations = this.buildDeco(e, g3(e.state)), this.decoratedTo = e.viewport.to;
  }
  update(e) {
    let n = $a(e.state), r = g3(e.state), a = r != g3(e.startState), { viewport: i } = e.view, o = e.changes.mapPos(this.decoratedTo, 1);
    n.length < i.to && !a && n.type == this.tree.type && o >= i.to ? (this.decorations = this.decorations.map(e.changes), this.decoratedTo = o) : (n != this.tree || e.viewportChanged || a) && (this.tree = n, this.decorations = this.buildDeco(e.view, r), this.decoratedTo = i.to);
  }
  buildDeco(e, n) {
    if (!n || !this.tree.length)
      return Ln.none;
    let r = new Jb();
    for (let { from: a, to: i } of e.visibleRanges)
      KPe(this.tree, n, (o, s, u) => {
        r.add(o, s, this.markCache[u] || (this.markCache[u] = Ln.mark({ class: u })));
      }, a, i);
    return r.finish();
  }
}
const xLe = /* @__PURE__ */ ig.high(/* @__PURE__ */ Ki.fromClass(CLe, {
  decorations: (t) => t.decorations
})), ALe = /* @__PURE__ */ p1.define([
  {
    tag: ge.meta,
    color: "#404740"
  },
  {
    tag: ge.link,
    textDecoration: "underline"
  },
  {
    tag: ge.heading,
    textDecoration: "underline",
    fontWeight: "bold"
  },
  {
    tag: ge.emphasis,
    fontStyle: "italic"
  },
  {
    tag: ge.strong,
    fontWeight: "bold"
  },
  {
    tag: ge.strikethrough,
    textDecoration: "line-through"
  },
  {
    tag: ge.keyword,
    color: "#708"
  },
  {
    tag: [ge.atom, ge.bool, ge.url, ge.contentSeparator, ge.labelName],
    color: "#219"
  },
  {
    tag: [ge.literal, ge.inserted],
    color: "#164"
  },
  {
    tag: [ge.string, ge.deleted],
    color: "#a11"
  },
  {
    tag: [ge.regexp, ge.escape, /* @__PURE__ */ ge.special(ge.string)],
    color: "#e40"
  },
  {
    tag: /* @__PURE__ */ ge.definition(ge.variableName),
    color: "#00f"
  },
  {
    tag: /* @__PURE__ */ ge.local(ge.variableName),
    color: "#30a"
  },
  {
    tag: [ge.typeName, ge.namespace],
    color: "#085"
  },
  {
    tag: ge.className,
    color: "#167"
  },
  {
    tag: [/* @__PURE__ */ ge.special(ge.variableName), ge.macroName],
    color: "#256"
  },
  {
    tag: /* @__PURE__ */ ge.definition(ge.propertyName),
    color: "#00c"
  },
  {
    tag: ge.comment,
    color: "#940"
  },
  {
    tag: ge.invalid,
    color: "#f00"
  }
]), kLe = /* @__PURE__ */ qt.baseTheme({
  "&.cm-focused .cm-matchingBracket": { backgroundColor: "#328c8252" },
  "&.cm-focused .cm-nonmatchingBracket": { backgroundColor: "#bb555544" }
}), aoe = 1e4, ioe = "()[]{}", ooe = /* @__PURE__ */ bn.define({
  combine(t) {
    return Dh(t, {
      afterCursor: !0,
      brackets: ioe,
      maxScanDistance: aoe,
      renderMatch: DLe
    });
  }
}), RLe = /* @__PURE__ */ Ln.mark({ class: "cm-matchingBracket" }), ILe = /* @__PURE__ */ Ln.mark({ class: "cm-nonmatchingBracket" });
function DLe(t) {
  let e = [], n = t.matched ? RLe : ILe;
  return e.push(n.range(t.start.from, t.start.to)), t.end && e.push(n.range(t.end.from, t.end.to)), e;
}
const NLe = /* @__PURE__ */ Ss.define({
  create() {
    return Ln.none;
  },
  update(t, e) {
    if (!e.docChanged && !e.selection)
      return t;
    let n = [], r = e.state.facet(ooe);
    for (let a of e.state.selection.ranges) {
      if (!a.empty)
        continue;
      let i = Sh(e.state, a.head, -1, r) || a.head > 0 && Sh(e.state, a.head - 1, 1, r) || r.afterCursor && (Sh(e.state, a.head, 1, r) || a.head < e.state.doc.length && Sh(e.state, a.head + 1, -1, r));
      i && (n = n.concat(r.renderMatch(i, e.state)));
    }
    return Ln.set(n, !0);
  },
  provide: (t) => qt.decorations.from(t)
}), PLe = [
  NLe,
  kLe
];
function LLe(t = {}) {
  return [ooe.of(t), PLe];
}
const soe = /* @__PURE__ */ new nr();
function M4(t, e, n) {
  let r = t.prop(e < 0 ? nr.openedBy : nr.closedBy);
  if (r)
    return r;
  if (t.name.length == 1) {
    let a = n.indexOf(t.name);
    if (a > -1 && a % 2 == (e < 0 ? 1 : 0))
      return [n[a + e]];
  }
  return null;
}
function F4(t) {
  let e = t.type.prop(soe);
  return e ? e(t.node) : t;
}
function Sh(t, e, n, r = {}) {
  let a = r.maxScanDistance || aoe, i = r.brackets || ioe, o = $a(t), s = o.resolveInner(e, n);
  for (let u = s; u; u = u.parent) {
    let f = M4(u.type, n, i);
    if (f && u.from < u.to) {
      let p = F4(u);
      if (p && (n > 0 ? e >= p.from && e < p.to : e > p.from && e <= p.to))
        return MLe(t, e, n, u, p, f, i);
    }
  }
  return FLe(t, e, n, o, s.type, a, i);
}
function MLe(t, e, n, r, a, i, o) {
  let s = r.parent, u = { from: a.from, to: a.to }, f = 0, p = s == null ? void 0 : s.cursor();
  if (p && (n < 0 ? p.childBefore(r.from) : p.childAfter(r.to)))
    do
      if (n < 0 ? p.to <= r.from : p.from >= r.to) {
        if (f == 0 && i.indexOf(p.type.name) > -1 && p.from < p.to) {
          let m = F4(p);
          return { start: u, end: m ? { from: m.from, to: m.to } : void 0, matched: !0 };
        } else if (M4(p.type, n, o))
          f++;
        else if (M4(p.type, -n, o)) {
          if (f == 0) {
            let m = F4(p);
            return {
              start: u,
              end: m && m.from < m.to ? { from: m.from, to: m.to } : void 0,
              matched: !1
            };
          }
          f--;
        }
      }
    while (n < 0 ? p.prevSibling() : p.nextSibling());
  return { start: u, matched: !1 };
}
function FLe(t, e, n, r, a, i, o) {
  let s = n < 0 ? t.sliceDoc(e - 1, e) : t.sliceDoc(e, e + 1), u = o.indexOf(s);
  if (u < 0 || u % 2 == 0 != n > 0)
    return null;
  let f = { from: n < 0 ? e - 1 : e, to: n > 0 ? e + 1 : e }, p = t.doc.iterRange(e, n > 0 ? t.doc.length : 0), m = 0;
  for (let v = 0; !p.next().done && v <= i; ) {
    let O = p.value;
    n < 0 && (v += O.length);
    let w = e + v * n;
    for (let _ = n > 0 ? 0 : O.length - 1, C = n > 0 ? O.length : -1; _ != C; _ += n) {
      let A = o.indexOf(O[_]);
      if (!(A < 0 || r.resolveInner(w + _, 1).type != a))
        if (A % 2 == 0 == n > 0)
          m++;
        else {
          if (m == 1)
            return { start: f, end: { from: w + _, to: w + _ + 1 }, matched: A >> 1 == u >> 1 };
          m--;
        }
    }
    n > 0 && (v += O.length);
  }
  return p.done ? { start: f, matched: !1 } : null;
}
function _q(t, e, n, r = 0, a = 0) {
  e == null && (e = t.search(/[^\s\u00a0]/), e == -1 && (e = t.length));
  let i = a;
  for (let o = r; o < e; o++)
    t.charCodeAt(o) == 9 ? i += n - i % n : i++;
  return i;
}
class loe {
  /**
  Create a stream.
  */
  constructor(e, n, r, a) {
    this.string = e, this.tabSize = n, this.indentUnit = r, this.overrideIndent = a, this.pos = 0, this.start = 0, this.lastColumnPos = 0, this.lastColumnValue = 0;
  }
  /**
  True if we are at the end of the line.
  */
  eol() {
    return this.pos >= this.string.length;
  }
  /**
  True if we are at the start of the line.
  */
  sol() {
    return this.pos == 0;
  }
  /**
  Get the next code unit after the current position, or undefined
  if we're at the end of the line.
  */
  peek() {
    return this.string.charAt(this.pos) || void 0;
  }
  /**
  Read the next code unit and advance `this.pos`.
  */
  next() {
    if (this.pos < this.string.length)
      return this.string.charAt(this.pos++);
  }
  /**
  Match the next character against the given string, regular
  expression, or predicate. Consume and return it if it matches.
  */
  eat(e) {
    let n = this.string.charAt(this.pos), r;
    if (typeof e == "string" ? r = n == e : r = n && (e instanceof RegExp ? e.test(n) : e(n)), r)
      return ++this.pos, n;
  }
  /**
  Continue matching characters that match the given string,
  regular expression, or predicate function. Return true if any
  characters were consumed.
  */
  eatWhile(e) {
    let n = this.pos;
    for (; this.eat(e); )
      ;
    return this.pos > n;
  }
  /**
  Consume whitespace ahead of `this.pos`. Return true if any was
  found.
  */
  eatSpace() {
    let e = this.pos;
    for (; /[\s\u00a0]/.test(this.string.charAt(this.pos)); )
      ++this.pos;
    return this.pos > e;
  }
  /**
  Move to the end of the line.
  */
  skipToEnd() {
    this.pos = this.string.length;
  }
  /**
  Move to directly before the given character, if found on the
  current line.
  */
  skipTo(e) {
    let n = this.string.indexOf(e, this.pos);
    if (n > -1)
      return this.pos = n, !0;
  }
  /**
  Move back `n` characters.
  */
  backUp(e) {
    this.pos -= e;
  }
  /**
  Get the column position at `this.pos`.
  */
  column() {
    return this.lastColumnPos < this.start && (this.lastColumnValue = _q(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue), this.lastColumnPos = this.start), this.lastColumnValue;
  }
  /**
  Get the indentation column of the current line.
  */
  indentation() {
    var e;
    return (e = this.overrideIndent) !== null && e !== void 0 ? e : _q(this.string, null, this.tabSize);
  }
  /**
  Match the input against the given string or regular expression
  (which should start with a `^`). Return true or the regexp match
  if it matches.
  
  Unless `consume` is set to `false`, this will move `this.pos`
  past the matched text.
  
  When matching a string `caseInsensitive` can be set to true to
  make the match case-insensitive.
  */
  match(e, n, r) {
    if (typeof e == "string") {
      let a = (o) => r ? o.toLowerCase() : o, i = this.string.substr(this.pos, e.length);
      return a(i) == a(e) ? (n !== !1 && (this.pos += e.length), !0) : null;
    } else {
      let a = this.string.slice(this.pos).match(e);
      return a && a.index > 0 ? null : (a && n !== !1 && (this.pos += a[0].length), a);
    }
  }
  /**
  Get the current token.
  */
  current() {
    return this.string.slice(this.start, this.pos);
  }
}
function $Le(t) {
  return {
    name: t.name || "",
    token: t.token,
    blankLine: t.blankLine || (() => {
    }),
    startState: t.startState || (() => !0),
    copyState: t.copyState || BLe,
    indent: t.indent || (() => null),
    languageData: t.languageData || {},
    tokenTable: t.tokenTable || i6
  };
}
function BLe(t) {
  if (typeof t != "object")
    return t;
  let e = {};
  for (let n in t) {
    let r = t[n];
    e[n] = r instanceof Array ? r.slice() : r;
  }
  return e;
}
const Cq = /* @__PURE__ */ new WeakMap();
class r6 extends Bc {
  constructor(e) {
    let n = ED(e.languageData), r = $Le(e), a, i = new class extends OD {
      createParse(o, s, u) {
        return new zLe(a, o, s, u);
      }
    }();
    super(n, i, [Gie.of((o, s) => this.getIndent(o, s))], e.name), this.topNode = QLe(n), a = this, this.streamParser = r, this.stateAfter = new nr({ perNode: !0 }), this.tokenTable = e.tokenTable ? new doe(r.tokenTable) : WLe;
  }
  /**
  Define a stream language.
  */
  static define(e) {
    return new r6(e);
  }
  getIndent(e, n) {
    let r = $a(e.state), a = r.resolve(n);
    for (; a && a.type != this.topNode; )
      a = a.parent;
    if (!a)
      return null;
    let i, { overrideIndentation: o } = e.options;
    o && (i = Cq.get(e.state), i != null && i < n - 1e4 && (i = void 0));
    let s = a6(this, r, 0, a.from, i ?? n), u, f;
    if (s ? (f = s.state, u = s.pos + 1) : (f = this.streamParser.startState(e.unit), u = 0), n - u > 1e4)
      return null;
    for (; u < n; ) {
      let m = e.state.doc.lineAt(u), v = Math.min(n, m.to);
      if (m.length) {
        let O = o ? o(m.from) : -1, w = new loe(m.text, e.state.tabSize, e.unit, O < 0 ? void 0 : O);
        for (; w.pos < v - m.from; )
          coe(this.streamParser.token, w, f);
      } else
        this.streamParser.blankLine(f, e.unit);
      if (v == n)
        break;
      u = m.to + 1;
    }
    let p = e.lineAt(n);
    return o && i == null && Cq.set(e.state, p.from), this.streamParser.indent(f, /^\s*(.*)/.exec(p.text)[1], e);
  }
  get allowsNesting() {
    return !1;
  }
}
function a6(t, e, n, r, a) {
  let i = n >= r && n + e.length <= a && e.prop(t.stateAfter);
  if (i)
    return { state: t.streamParser.copyState(i), pos: n + e.length };
  for (let o = e.children.length - 1; o >= 0; o--) {
    let s = e.children[o], u = n + e.positions[o], f = s instanceof Pr && u < a && a6(t, s, u, r, a);
    if (f)
      return f;
  }
  return null;
}
function uoe(t, e, n, r, a) {
  if (a && n <= 0 && r >= e.length)
    return e;
  !a && e.type == t.topNode && (a = !0);
  for (let i = e.children.length - 1; i >= 0; i--) {
    let o = e.positions[i], s = e.children[i], u;
    if (o < r && s instanceof Pr) {
      if (!(u = uoe(t, s, n - o, r - o, a)))
        break;
      return a ? new Pr(e.type, e.children.slice(0, i).concat(u), e.positions.slice(0, i + 1), o + u.length) : u;
    }
  }
  return null;
}
function ULe(t, e, n, r) {
  for (let a of e) {
    let i = a.from + (a.openStart ? 25 : 0), o = a.to - (a.openEnd ? 25 : 0), s = i <= n && o > n && a6(t, a.tree, 0 - a.offset, n, o), u;
    if (s && (u = uoe(t, a.tree, n + a.offset, s.pos + a.offset, !1)))
      return { state: s.state, tree: u };
  }
  return { state: t.streamParser.startState(r ? m0(r) : 4), tree: Pr.empty };
}
let zLe = class {
  constructor(e, n, r, a) {
    this.lang = e, this.input = n, this.fragments = r, this.ranges = a, this.stoppedAt = null, this.chunks = [], this.chunkPos = [], this.chunk = [], this.chunkReused = void 0, this.rangeIndex = 0, this.to = a[a.length - 1].to;
    let i = h0.get(), o = a[0].from, { state: s, tree: u } = ULe(e, r, o, i == null ? void 0 : i.state);
    this.state = s, this.parsedPos = this.chunkStart = o + u.length;
    for (let f = 0; f < u.children.length; f++)
      this.chunks.push(u.children[f]), this.chunkPos.push(u.positions[f]);
    i && this.parsedPos < i.viewport.from - 1e5 && (this.state = this.lang.streamParser.startState(m0(i.state)), i.skipUntilInView(this.parsedPos, i.viewport.from), this.parsedPos = i.viewport.from), this.moveRangeIndex();
  }
  advance() {
    let e = h0.get(), n = this.stoppedAt == null ? this.to : Math.min(this.to, this.stoppedAt), r = Math.min(
      n,
      this.chunkStart + 2048
      /* C.ChunkSize */
    );
    for (e && (r = Math.min(r, e.viewport.to)); this.parsedPos < r; )
      this.parseLine(e);
    return this.chunkStart < this.parsedPos && this.finishChunk(), this.parsedPos >= n ? this.finish() : e && this.parsedPos >= e.viewport.to ? (e.skipUntilInView(this.parsedPos, n), this.finish()) : null;
  }
  stopAt(e) {
    this.stoppedAt = e;
  }
  lineAfter(e) {
    let n = this.input.chunk(e);
    if (this.input.lineChunks)
      n == `
` && (n = "");
    else {
      let r = n.indexOf(`
`);
      r > -1 && (n = n.slice(0, r));
    }
    return e + n.length <= this.to ? n : n.slice(0, this.to - e);
  }
  nextLine() {
    let e = this.parsedPos, n = this.lineAfter(e), r = e + n.length;
    for (let a = this.rangeIndex; ; ) {
      let i = this.ranges[a].to;
      if (i >= r || (n = n.slice(0, i - (r - n.length)), a++, a == this.ranges.length))
        break;
      let o = this.ranges[a].from, s = this.lineAfter(o);
      n += s, r = o + s.length;
    }
    return { line: n, end: r };
  }
  skipGapsTo(e, n, r) {
    for (; ; ) {
      let a = this.ranges[this.rangeIndex].to, i = e + n;
      if (r > 0 ? a > i : a >= i)
        break;
      let o = this.ranges[++this.rangeIndex].from;
      n += o - a;
    }
    return n;
  }
  moveRangeIndex() {
    for (; this.ranges[this.rangeIndex].to < this.parsedPos; )
      this.rangeIndex++;
  }
  emitToken(e, n, r, a, i) {
    if (this.ranges.length > 1) {
      i = this.skipGapsTo(n, i, 1), n += i;
      let o = this.chunk.length;
      i = this.skipGapsTo(r, i, -1), r += i, a += this.chunk.length - o;
    }
    return this.chunk.push(e, n, r, a), i;
  }
  parseLine(e) {
    let { line: n, end: r } = this.nextLine(), a = 0, { streamParser: i } = this.lang, o = new loe(n, e ? e.state.tabSize : 4, e ? m0(e.state) : 2);
    if (o.eol())
      i.blankLine(this.state, o.indentUnit);
    else
      for (; !o.eol(); ) {
        let s = coe(i.token, o, this.state);
        if (s && (a = this.emitToken(this.lang.tokenTable.resolve(s), this.parsedPos + o.start, this.parsedPos + o.pos, 4, a)), o.start > 1e4)
          break;
      }
    this.parsedPos = r, this.moveRangeIndex(), this.parsedPos < this.to && this.parsedPos++;
  }
  finishChunk() {
    let e = Pr.build({
      buffer: this.chunk,
      start: this.chunkStart,
      length: this.parsedPos - this.chunkStart,
      nodeSet: HLe,
      topID: 0,
      maxBufferLength: 2048,
      reused: this.chunkReused
    });
    e = new Pr(e.type, e.children, e.positions, e.length, [[this.lang.stateAfter, this.lang.streamParser.copyState(this.state)]]), this.chunks.push(e), this.chunkPos.push(this.chunkStart - this.ranges[0].from), this.chunk = [], this.chunkReused = void 0, this.chunkStart = this.parsedPos;
  }
  finish() {
    return new Pr(this.lang.topNode, this.chunks, this.chunkPos, this.parsedPos - this.ranges[0].from).balance();
  }
};
function coe(t, e, n) {
  e.start = e.pos;
  for (let r = 0; r < 10; r++) {
    let a = t(e, n);
    if (e.pos > e.start)
      return a;
  }
  throw new Error("Stream parser failed to advance stream.");
}
const i6 = /* @__PURE__ */ Object.create(null), YT = [Po.none], HLe = /* @__PURE__ */ new u1(YT), xq = [], Aq = /* @__PURE__ */ Object.create(null), foe = /* @__PURE__ */ Object.create(null);
for (let [t, e] of [
  ["variable", "variableName"],
  ["variable-2", "variableName.special"],
  ["string-2", "string.special"],
  ["def", "variableName.definition"],
  ["tag", "tagName"],
  ["attribute", "attributeName"],
  ["type", "typeName"],
  ["builtin", "variableName.standard"],
  ["qualifier", "modifier"],
  ["error", "invalid"],
  ["header", "heading"],
  ["property", "propertyName"]
])
  foe[t] = /* @__PURE__ */ poe(i6, e);
class doe {
  constructor(e) {
    this.extra = e, this.table = Object.assign(/* @__PURE__ */ Object.create(null), foe);
  }
  resolve(e) {
    return e ? this.table[e] || (this.table[e] = poe(this.extra, e)) : 0;
  }
}
const WLe = /* @__PURE__ */ new doe(i6);
function b3(t, e) {
  xq.indexOf(t) > -1 || (xq.push(t), console.warn(e));
}
function poe(t, e) {
  let n = [];
  for (let s of e.split(" ")) {
    let u = [];
    for (let f of s.split(".")) {
      let p = t[f] || ge[f];
      p ? typeof p == "function" ? u.length ? u = u.map(p) : b3(f, `Modifier ${f} used at start of tag`) : u.length ? b3(f, `Tag ${f} used as modifier`) : u = Array.isArray(p) ? p : [p] : b3(f, `Unknown highlighting tag ${f}`);
    }
    for (let f of u)
      n.push(f);
  }
  if (!n.length)
    return 0;
  let r = e.replace(/ /g, "_"), a = r + " " + n.map((s) => s.id), i = Aq[a];
  if (i)
    return i.id;
  let o = Aq[a] = Po.define({
    id: YT.length,
    name: r,
    props: [c1({ [r]: n })]
  });
  return YT.push(o), o.id;
}
function QLe(t) {
  let e = Po.define({ id: YT.length, name: "Document", props: [Gb.add(() => t)], top: !0 });
  return YT.push(e), e;
}
hi.RTL, hi.LTR;
class o6 {
  /**
  Create a new completion context. (Mostly useful for testing
  completion sources—in the editor, the extension will create
  these for you.)
  */
  constructor(e, n, r) {
    this.state = e, this.pos = n, this.explicit = r, this.abortListeners = [];
  }
  /**
  Get the extent, content, and (if there is a token) type of the
  token before `this.pos`.
  */
  tokenBefore(e) {
    let n = $a(this.state).resolveInner(this.pos, -1);
    for (; n && e.indexOf(n.name) < 0; )
      n = n.parent;
    return n ? {
      from: n.from,
      to: this.pos,
      text: this.state.sliceDoc(n.from, this.pos),
      type: n.type
    } : null;
  }
  /**
  Get the match of the given expression directly before the
  cursor.
  */
  matchBefore(e) {
    let n = this.state.doc.lineAt(this.pos), r = Math.max(n.from, this.pos - 250), a = n.text.slice(r - n.from, this.pos - n.from), i = a.search(moe(e, !1));
    return i < 0 ? null : { from: r + i, to: this.pos, text: a.slice(i) };
  }
  /**
  Yields true when the query has been aborted. Can be useful in
  asynchronous queries to avoid doing work that will be ignored.
  */
  get aborted() {
    return this.abortListeners == null;
  }
  /**
  Allows you to register abort handlers, which will be called when
  the query is
  [aborted](https://codemirror.net/6/docs/ref/#autocomplete.CompletionContext.aborted).
  */
  addEventListener(e, n) {
    e == "abort" && this.abortListeners && this.abortListeners.push(n);
  }
}
function kq(t) {
  let e = Object.keys(t).join(""), n = /\w/.test(e);
  return n && (e = e.replace(/\w/g, "")), `[${n ? "\\w" : ""}${e.replace(/[^\w\s]/g, "\\$&")}]`;
}
function jLe(t) {
  let e = /* @__PURE__ */ Object.create(null), n = /* @__PURE__ */ Object.create(null);
  for (let { label: a } of t) {
    e[a[0]] = !0;
    for (let i = 1; i < a.length; i++)
      n[a[i]] = !0;
  }
  let r = kq(e) + kq(n) + "*$";
  return [new RegExp("^" + r), new RegExp(r)];
}
function hoe(t) {
  let e = t.map((a) => typeof a == "string" ? { label: a } : a), [n, r] = e.every((a) => /^\w+$/.test(a.label)) ? [/\w*$/, /\w+$/] : jLe(e);
  return (a) => {
    let i = a.matchBefore(r);
    return i || a.explicit ? { from: i ? i.from : a.pos, options: e, validFor: n } : null;
  };
}
function GLe(t, e) {
  return (n) => {
    for (let r = $a(n.state).resolveInner(n.pos, -1); r; r = r.parent) {
      if (t.indexOf(r.name) > -1)
        return null;
      if (r.type.isTop)
        break;
    }
    return e(n);
  };
}
class Rq {
  constructor(e, n, r, a) {
    this.completion = e, this.source = n, this.match = r, this.score = a;
  }
}
function Yb(t) {
  return t.selection.main.from;
}
function moe(t, e) {
  var n;
  let { source: r } = t, a = e && r[0] != "^", i = r[r.length - 1] != "$";
  return !a && !i ? t : new RegExp(`${a ? "^" : ""}(?:${r})${i ? "$" : ""}`, (n = t.flags) !== null && n !== void 0 ? n : t.ignoreCase ? "i" : "");
}
const s6 = /* @__PURE__ */ Ih.define();
function VLe(t, e, n, r) {
  let { main: a } = t.selection, i = n - a.from, o = r - a.from;
  return Object.assign(Object.assign({}, t.changeByRange((s) => s != a && n != r && t.sliceDoc(s.from + i, s.from + o) != t.sliceDoc(n, r) ? { range: s } : {
    changes: { from: s.from + i, to: r == a.from ? s.to : s.from + o, insert: e },
    range: ft.cursor(s.from + i + e.length)
  })), { scrollIntoView: !0, userEvent: "input.complete" });
}
const Iq = /* @__PURE__ */ new WeakMap();
function YLe(t) {
  if (!Array.isArray(t))
    return t;
  let e = Iq.get(t);
  return e || Iq.set(t, e = hoe(t)), e;
}
const pI = /* @__PURE__ */ fr.define(), ZT = /* @__PURE__ */ fr.define();
class ZLe {
  constructor(e) {
    this.pattern = e, this.chars = [], this.folded = [], this.any = [], this.precise = [], this.byWord = [], this.score = 0, this.matched = [];
    for (let n = 0; n < e.length; ) {
      let r = Ks(e, n), a = Uf(r);
      this.chars.push(r);
      let i = e.slice(n, n + a), o = i.toUpperCase();
      this.folded.push(Ks(o == i ? i.toLowerCase() : o, 0)), n += a;
    }
    this.astral = e.length != this.chars.length;
  }
  ret(e, n) {
    return this.score = e, this.matched = n, this;
  }
  // Matches a given word (completion) against the pattern (input).
  // Will return a boolean indicating whether there was a match and,
  // on success, set `this.score` to the score, `this.matched` to an
  // array of `from, to` pairs indicating the matched parts of `word`.
  //
  // The score is a number that is more negative the worse the match
  // is. See `Penalty` above.
  match(e) {
    if (this.pattern.length == 0)
      return this.ret(-100, []);
    if (e.length < this.pattern.length)
      return null;
    let { chars: n, folded: r, any: a, precise: i, byWord: o } = this;
    if (n.length == 1) {
      let N = Ks(e, 0), P = Uf(N), I = P == e.length ? 0 : -100;
      if (N != n[0])
        if (N == r[0])
          I += -200;
        else
          return null;
      return this.ret(I, [0, P]);
    }
    let s = e.indexOf(this.pattern);
    if (s == 0)
      return this.ret(e.length == this.pattern.length ? 0 : -100, [0, this.pattern.length]);
    let u = n.length, f = 0;
    if (s < 0) {
      for (let N = 0, P = Math.min(e.length, 200); N < P && f < u; ) {
        let I = Ks(e, N);
        (I == n[f] || I == r[f]) && (a[f++] = N), N += Uf(I);
      }
      if (f < u)
        return null;
    }
    let p = 0, m = 0, v = !1, O = 0, w = -1, _ = -1, C = /[a-z]/.test(e), A = !0;
    for (let N = 0, P = Math.min(e.length, 200), I = 0; N < P && m < u; ) {
      let D = Ks(e, N);
      s < 0 && (p < u && D == n[p] && (i[p++] = N), O < u && (D == n[O] || D == r[O] ? (O == 0 && (w = N), _ = N + 1, O++) : O = 0));
      let M, H = D < 255 ? D >= 48 && D <= 57 || D >= 97 && D <= 122 ? 2 : D >= 65 && D <= 90 ? 1 : 0 : (M = FU(D)) != M.toLowerCase() ? 1 : M != M.toUpperCase() ? 2 : 0;
      (!N || H == 1 && C || I == 0 && H != 0) && (n[m] == D || r[m] == D && (v = !0) ? o[m++] = N : o.length && (A = !1)), I = H, N += Uf(D);
    }
    return m == u && o[0] == 0 && A ? this.result(-100 + (v ? -200 : 0), o, e) : O == u && w == 0 ? this.ret(-200 - e.length + (_ == e.length ? 0 : -100), [0, _]) : s > -1 ? this.ret(-700 - e.length, [s, s + this.pattern.length]) : O == u ? this.ret(-200 + -700 - e.length, [w, _]) : m == u ? this.result(-100 + (v ? -200 : 0) + -700 + (A ? 0 : -1100), o, e) : n.length == 2 ? null : this.result((a[0] ? -700 : 0) + -200 + -1100, a, e);
  }
  result(e, n, r) {
    let a = [], i = 0;
    for (let o of n) {
      let s = o + (this.astral ? Uf(Ks(r, o)) : 1);
      i && a[i - 1] == o ? a[i - 1] = s : (a[i++] = o, a[i++] = s);
    }
    return this.ret(e - r.length, a);
  }
}
class XLe {
  constructor(e) {
    this.pattern = e, this.matched = [], this.score = 0, this.folded = e.toLowerCase();
  }
  match(e) {
    if (e.length < this.pattern.length)
      return null;
    let n = e.slice(0, this.pattern.length), r = n == this.pattern ? 0 : n.toLowerCase() == this.folded ? -200 : null;
    return r == null ? null : (this.matched = [0, n.length], this.score = r + (e.length == this.pattern.length ? 0 : -100), this);
  }
}
const tl = /* @__PURE__ */ bn.define({
  combine(t) {
    return Dh(t, {
      activateOnTyping: !0,
      activateOnCompletion: () => !1,
      activateOnTypingDelay: 100,
      selectOnOpen: !0,
      override: null,
      closeOnBlur: !0,
      maxRenderedOptions: 100,
      defaultKeymap: !0,
      tooltipClass: () => "",
      optionClass: () => "",
      aboveCursor: !1,
      icons: !0,
      addToOptions: [],
      positionInfo: qLe,
      filterStrict: !1,
      compareCompletions: (e, n) => e.label.localeCompare(n.label),
      interactionDelay: 75,
      updateSyncTime: 100
    }, {
      defaultKeymap: (e, n) => e && n,
      closeOnBlur: (e, n) => e && n,
      icons: (e, n) => e && n,
      tooltipClass: (e, n) => (r) => Dq(e(r), n(r)),
      optionClass: (e, n) => (r) => Dq(e(r), n(r)),
      addToOptions: (e, n) => e.concat(n),
      filterStrict: (e, n) => e || n
    });
  }
});
function Dq(t, e) {
  return t ? e ? t + " " + e : t : e;
}
function qLe(t, e, n, r, a, i) {
  let o = t.textDirection == hi.RTL, s = o, u = !1, f = "top", p, m, v = e.left - a.left, O = a.right - e.right, w = r.right - r.left, _ = r.bottom - r.top;
  if (s && v < Math.min(w, O) ? s = !1 : !s && O < Math.min(w, v) && (s = !0), w <= (s ? v : O))
    p = Math.max(a.top, Math.min(n.top, a.bottom - _)) - e.top, m = Math.min(400, s ? v : O);
  else {
    u = !0, m = Math.min(
      400,
      (o ? e.right : a.right - e.left) - 30
      /* Info.Margin */
    );
    let N = a.bottom - e.bottom;
    N >= _ || N > e.top ? p = n.bottom - e.top : (f = "bottom", p = e.bottom - n.top);
  }
  let C = (e.bottom - e.top) / i.offsetHeight, A = (e.right - e.left) / i.offsetWidth;
  return {
    style: `${f}: ${p / C}px; max-width: ${m / A}px`,
    class: "cm-completionInfo-" + (u ? o ? "left-narrow" : "right-narrow" : s ? "left" : "right")
  };
}
function KLe(t) {
  let e = t.addToOptions.slice();
  return t.icons && e.push({
    render(n) {
      let r = document.createElement("div");
      return r.classList.add("cm-completionIcon"), n.type && r.classList.add(...n.type.split(/\s+/g).map((a) => "cm-completionIcon-" + a)), r.setAttribute("aria-hidden", "true"), r;
    },
    position: 20
  }), e.push({
    render(n, r, a, i) {
      let o = document.createElement("span");
      o.className = "cm-completionLabel";
      let s = n.displayLabel || n.label, u = 0;
      for (let f = 0; f < i.length; ) {
        let p = i[f++], m = i[f++];
        p > u && o.appendChild(document.createTextNode(s.slice(u, p)));
        let v = o.appendChild(document.createElement("span"));
        v.appendChild(document.createTextNode(s.slice(p, m))), v.className = "cm-completionMatchedText", u = m;
      }
      return u < s.length && o.appendChild(document.createTextNode(s.slice(u))), o;
    },
    position: 50
  }, {
    render(n) {
      if (!n.detail)
        return null;
      let r = document.createElement("span");
      return r.className = "cm-completionDetail", r.textContent = n.detail, r;
    },
    position: 80
  }), e.sort((n, r) => n.position - r.position).map((n) => n.render);
}
function v3(t, e, n) {
  if (t <= n)
    return { from: 0, to: t };
  if (e < 0 && (e = 0), e <= t >> 1) {
    let a = Math.floor(e / n);
    return { from: a * n, to: (a + 1) * n };
  }
  let r = Math.floor((t - e) / n);
  return { from: t - (r + 1) * n, to: t - r * n };
}
class JLe {
  constructor(e, n, r) {
    this.view = e, this.stateField = n, this.applyCompletion = r, this.info = null, this.infoDestroy = null, this.placeInfoReq = {
      read: () => this.measureInfo(),
      write: (u) => this.placeInfo(u),
      key: this
    }, this.space = null, this.currentClass = "";
    let a = e.state.field(n), { options: i, selected: o } = a.open, s = e.state.facet(tl);
    this.optionContent = KLe(s), this.optionClass = s.optionClass, this.tooltipClass = s.tooltipClass, this.range = v3(i.length, o, s.maxRenderedOptions), this.dom = document.createElement("div"), this.dom.className = "cm-tooltip-autocomplete", this.updateTooltipClass(e.state), this.dom.addEventListener("mousedown", (u) => {
      let { options: f } = e.state.field(n).open;
      for (let p = u.target, m; p && p != this.dom; p = p.parentNode)
        if (p.nodeName == "LI" && (m = /-(\d+)$/.exec(p.id)) && +m[1] < f.length) {
          this.applyCompletion(e, f[+m[1]]), u.preventDefault();
          return;
        }
    }), this.dom.addEventListener("focusout", (u) => {
      let f = e.state.field(this.stateField, !1);
      f && f.tooltip && e.state.facet(tl).closeOnBlur && u.relatedTarget != e.contentDOM && e.dispatch({ effects: ZT.of(null) });
    }), this.showOptions(i, a.id);
  }
  mount() {
    this.updateSel();
  }
  showOptions(e, n) {
    this.list && this.list.remove(), this.list = this.dom.appendChild(this.createListBox(e, n, this.range)), this.list.addEventListener("scroll", () => {
      this.info && this.view.requestMeasure(this.placeInfoReq);
    });
  }
  update(e) {
    var n;
    let r = e.state.field(this.stateField), a = e.startState.field(this.stateField);
    if (this.updateTooltipClass(e.state), r != a) {
      let { options: i, selected: o, disabled: s } = r.open;
      (!a.open || a.open.options != i) && (this.range = v3(i.length, o, e.state.facet(tl).maxRenderedOptions), this.showOptions(i, r.id)), this.updateSel(), s != ((n = a.open) === null || n === void 0 ? void 0 : n.disabled) && this.dom.classList.toggle("cm-tooltip-autocomplete-disabled", !!s);
    }
  }
  updateTooltipClass(e) {
    let n = this.tooltipClass(e);
    if (n != this.currentClass) {
      for (let r of this.currentClass.split(" "))
        r && this.dom.classList.remove(r);
      for (let r of n.split(" "))
        r && this.dom.classList.add(r);
      this.currentClass = n;
    }
  }
  positioned(e) {
    this.space = e, this.info && this.view.requestMeasure(this.placeInfoReq);
  }
  updateSel() {
    let e = this.view.state.field(this.stateField), n = e.open;
    if ((n.selected > -1 && n.selected < this.range.from || n.selected >= this.range.to) && (this.range = v3(n.options.length, n.selected, this.view.state.facet(tl).maxRenderedOptions), this.showOptions(n.options, e.id)), this.updateSelectedOption(n.selected)) {
      this.destroyInfo();
      let { completion: r } = n.options[n.selected], { info: a } = r;
      if (!a)
        return;
      let i = typeof a == "string" ? document.createTextNode(a) : a(r);
      if (!i)
        return;
      "then" in i ? i.then((o) => {
        o && this.view.state.field(this.stateField, !1) == e && this.addInfoPane(o, r);
      }).catch((o) => Ku(this.view.state, o, "completion info")) : this.addInfoPane(i, r);
    }
  }
  addInfoPane(e, n) {
    this.destroyInfo();
    let r = this.info = document.createElement("div");
    if (r.className = "cm-tooltip cm-completionInfo", e.nodeType != null)
      r.appendChild(e), this.infoDestroy = null;
    else {
      let { dom: a, destroy: i } = e;
      r.appendChild(a), this.infoDestroy = i || null;
    }
    this.dom.appendChild(r), this.view.requestMeasure(this.placeInfoReq);
  }
  updateSelectedOption(e) {
    let n = null;
    for (let r = this.list.firstChild, a = this.range.from; r; r = r.nextSibling, a++)
      r.nodeName != "LI" || !r.id ? a-- : a == e ? r.hasAttribute("aria-selected") || (r.setAttribute("aria-selected", "true"), n = r) : r.hasAttribute("aria-selected") && r.removeAttribute("aria-selected");
    return n && tMe(this.list, n), n;
  }
  measureInfo() {
    let e = this.dom.querySelector("[aria-selected]");
    if (!e || !this.info)
      return null;
    let n = this.dom.getBoundingClientRect(), r = this.info.getBoundingClientRect(), a = e.getBoundingClientRect(), i = this.space;
    if (!i) {
      let o = this.dom.ownerDocument.defaultView || window;
      i = { left: 0, top: 0, right: o.innerWidth, bottom: o.innerHeight };
    }
    return a.top > Math.min(i.bottom, n.bottom) - 10 || a.bottom < Math.max(i.top, n.top) + 10 ? null : this.view.state.facet(tl).positionInfo(this.view, n, a, r, i, this.dom);
  }
  placeInfo(e) {
    this.info && (e ? (e.style && (this.info.style.cssText = e.style), this.info.className = "cm-tooltip cm-completionInfo " + (e.class || "")) : this.info.style.cssText = "top: -1e6px");
  }
  createListBox(e, n, r) {
    const a = document.createElement("ul");
    a.id = n, a.setAttribute("role", "listbox"), a.setAttribute("aria-expanded", "true"), a.setAttribute("aria-label", this.view.state.phrase("Completions"));
    let i = null;
    for (let o = r.from; o < r.to; o++) {
      let { completion: s, match: u } = e[o], { section: f } = s;
      if (f) {
        let v = typeof f == "string" ? f : f.name;
        if (v != i && (o > r.from || r.from == 0))
          if (i = v, typeof f != "string" && f.header)
            a.appendChild(f.header(f));
          else {
            let O = a.appendChild(document.createElement("completion-section"));
            O.textContent = v;
          }
      }
      const p = a.appendChild(document.createElement("li"));
      p.id = n + "-" + o, p.setAttribute("role", "option");
      let m = this.optionClass(s);
      m && (p.className = m);
      for (let v of this.optionContent) {
        let O = v(s, this.view.state, this.view, u);
        O && p.appendChild(O);
      }
    }
    return r.from && a.classList.add("cm-completionListIncompleteTop"), r.to < e.length && a.classList.add("cm-completionListIncompleteBottom"), a;
  }
  destroyInfo() {
    this.info && (this.infoDestroy && this.infoDestroy(), this.info.remove(), this.info = null);
  }
  destroy() {
    this.destroyInfo();
  }
}
function eMe(t, e) {
  return (n) => new JLe(n, t, e);
}
function tMe(t, e) {
  let n = t.getBoundingClientRect(), r = e.getBoundingClientRect(), a = n.height / t.offsetHeight;
  r.top < n.top ? t.scrollTop -= (n.top - r.top) / a : r.bottom > n.bottom && (t.scrollTop += (r.bottom - n.bottom) / a);
}
function Nq(t) {
  return (t.boost || 0) * 100 + (t.apply ? 10 : 0) + (t.info ? 5 : 0) + (t.type ? 1 : 0);
}
function nMe(t, e) {
  let n = [], r = null, a = (f) => {
    n.push(f);
    let { section: p } = f.completion;
    if (p) {
      r || (r = []);
      let m = typeof p == "string" ? p : p.name;
      r.some((v) => v.name == m) || r.push(typeof p == "string" ? { name: m } : p);
    }
  }, i = e.facet(tl);
  for (let f of t)
    if (f.hasResult()) {
      let p = f.result.getMatch;
      if (f.result.filter === !1)
        for (let m of f.result.options)
          a(new Rq(m, f.source, p ? p(m) : [], 1e9 - n.length));
      else {
        let m = e.sliceDoc(f.from, f.to), v, O = i.filterStrict ? new XLe(m) : new ZLe(m);
        for (let w of f.result.options)
          if (v = O.match(w.label)) {
            let _ = w.displayLabel ? p ? p(w, v.matched) : [] : v.matched;
            a(new Rq(w, f.source, _, v.score + (w.boost || 0)));
          }
      }
    }
  if (r) {
    let f = /* @__PURE__ */ Object.create(null), p = 0, m = (v, O) => {
      var w, _;
      return ((w = v.rank) !== null && w !== void 0 ? w : 1e9) - ((_ = O.rank) !== null && _ !== void 0 ? _ : 1e9) || (v.name < O.name ? -1 : 1);
    };
    for (let v of r.sort(m))
      p -= 1e5, f[v.name] = p;
    for (let v of n) {
      let { section: O } = v.completion;
      O && (v.score += f[typeof O == "string" ? O : O.name]);
    }
  }
  let o = [], s = null, u = i.compareCompletions;
  for (let f of n.sort((p, m) => m.score - p.score || u(p.completion, m.completion))) {
    let p = f.completion;
    !s || s.label != p.label || s.detail != p.detail || s.type != null && p.type != null && s.type != p.type || s.apply != p.apply || s.boost != p.boost ? o.push(f) : Nq(f.completion) > Nq(s) && (o[o.length - 1] = f), s = f.completion;
  }
  return o;
}
class yE {
  constructor(e, n, r, a, i, o) {
    this.options = e, this.attrs = n, this.tooltip = r, this.timestamp = a, this.selected = i, this.disabled = o;
  }
  setSelected(e, n) {
    return e == this.selected || e >= this.options.length ? this : new yE(this.options, Pq(n, e), this.tooltip, this.timestamp, e, this.disabled);
  }
  static build(e, n, r, a, i) {
    let o = nMe(e, n);
    if (!o.length)
      return a && e.some(
        (u) => u.state == 1
        /* State.Pending */
      ) ? new yE(a.options, a.attrs, a.tooltip, a.timestamp, a.selected, !0) : null;
    let s = n.facet(tl).selectOnOpen ? 0 : -1;
    if (a && a.selected != s && a.selected != -1) {
      let u = a.options[a.selected].completion;
      for (let f = 0; f < o.length; f++)
        if (o[f].completion == u) {
          s = f;
          break;
        }
    }
    return new yE(o, Pq(r, s), {
      pos: e.reduce((u, f) => f.hasResult() ? Math.min(u, f.from) : u, 1e8),
      create: sMe,
      above: i.aboveCursor
    }, a ? a.timestamp : Date.now(), s, !1);
  }
  map(e) {
    return new yE(this.options, this.attrs, Object.assign(Object.assign({}, this.tooltip), { pos: e.mapPos(this.tooltip.pos) }), this.timestamp, this.selected, this.disabled);
  }
}
class hI {
  constructor(e, n, r) {
    this.active = e, this.id = n, this.open = r;
  }
  static start() {
    return new hI(iMe, "cm-ac-" + Math.floor(Math.random() * 2e6).toString(36), null);
  }
  update(e) {
    let { state: n } = e, r = n.facet(tl), i = (r.override || n.languageDataAt("autocomplete", Yb(n)).map(YLe)).map((s) => (this.active.find((f) => f.source == s) || new su(
      s,
      this.active.some(
        (f) => f.state != 0
        /* State.Inactive */
      ) ? 1 : 0
      /* State.Inactive */
    )).update(e, r));
    i.length == this.active.length && i.every((s, u) => s == this.active[u]) && (i = this.active);
    let o = this.open;
    o && e.docChanged && (o = o.map(e.changes)), e.selection || i.some((s) => s.hasResult() && e.changes.touchesRange(s.from, s.to)) || !rMe(i, this.active) ? o = yE.build(i, n, this.id, o, r) : o && o.disabled && !i.some(
      (s) => s.state == 1
      /* State.Pending */
    ) && (o = null), !o && i.every(
      (s) => s.state != 1
      /* State.Pending */
    ) && i.some((s) => s.hasResult()) && (i = i.map((s) => s.hasResult() ? new su(
      s.source,
      0
      /* State.Inactive */
    ) : s));
    for (let s of e.effects)
      s.is(boe) && (o = o && o.setSelected(s.value, this.id));
    return i == this.active && o == this.open ? this : new hI(i, this.id, o);
  }
  get tooltip() {
    return this.open ? this.open.tooltip : null;
  }
  get attrs() {
    return this.open ? this.open.attrs : aMe;
  }
}
function rMe(t, e) {
  if (t == e)
    return !0;
  for (let n = 0, r = 0; ; ) {
    for (; n < t.length && !t[n].hasResult; )
      n++;
    for (; r < e.length && !e[r].hasResult; )
      r++;
    let a = n == t.length, i = r == e.length;
    if (a || i)
      return a == i;
    if (t[n++].result != e[r++].result)
      return !1;
  }
}
const aMe = {
  "aria-autocomplete": "list"
};
function Pq(t, e) {
  let n = {
    "aria-autocomplete": "list",
    "aria-haspopup": "listbox",
    "aria-controls": t
  };
  return e > -1 && (n["aria-activedescendant"] = t + "-" + e), n;
}
const iMe = [];
function $4(t, e) {
  if (t.isUserEvent("input.complete")) {
    let n = t.annotation(s6);
    if (n && e.activateOnCompletion(n))
      return "input";
  }
  return t.isUserEvent("input.type") ? "input" : t.isUserEvent("delete.backward") ? "delete" : null;
}
class su {
  constructor(e, n, r = -1) {
    this.source = e, this.state = n, this.explicitPos = r;
  }
  hasResult() {
    return !1;
  }
  update(e, n) {
    let r = $4(e, n), a = this;
    r ? a = a.handleUserEvent(e, r, n) : e.docChanged ? a = a.handleChange(e) : e.selection && a.state != 0 && (a = new su(
      a.source,
      0
      /* State.Inactive */
    ));
    for (let i of e.effects)
      if (i.is(pI))
        a = new su(a.source, 1, i.value ? Yb(e.state) : -1);
      else if (i.is(ZT))
        a = new su(
          a.source,
          0
          /* State.Inactive */
        );
      else if (i.is(goe))
        for (let o of i.value)
          o.source == a.source && (a = o);
    return a;
  }
  handleUserEvent(e, n, r) {
    return n == "delete" || !r.activateOnTyping ? this.map(e.changes) : new su(
      this.source,
      1
      /* State.Pending */
    );
  }
  handleChange(e) {
    return e.changes.touchesRange(Yb(e.startState)) ? new su(
      this.source,
      0
      /* State.Inactive */
    ) : this.map(e.changes);
  }
  map(e) {
    return e.empty || this.explicitPos < 0 ? this : new su(this.source, this.state, e.mapPos(this.explicitPos));
  }
}
class RE extends su {
  constructor(e, n, r, a, i) {
    super(e, 2, n), this.result = r, this.from = a, this.to = i;
  }
  hasResult() {
    return !0;
  }
  handleUserEvent(e, n, r) {
    var a;
    let i = this.result;
    i.map && !e.changes.empty && (i = i.map(i, e.changes));
    let o = e.changes.mapPos(this.from), s = e.changes.mapPos(this.to, 1), u = Yb(e.state);
    if ((this.explicitPos < 0 ? u <= o : u < this.from) || u > s || !i || n == "delete" && Yb(e.startState) == this.from)
      return new su(
        this.source,
        n == "input" && r.activateOnTyping ? 1 : 0
        /* State.Inactive */
      );
    let f = this.explicitPos < 0 ? -1 : e.changes.mapPos(this.explicitPos);
    return oMe(i.validFor, e.state, o, s) ? new RE(this.source, f, i, o, s) : i.update && (i = i.update(i, o, s, new o6(e.state, u, f >= 0))) ? new RE(this.source, f, i, i.from, (a = i.to) !== null && a !== void 0 ? a : Yb(e.state)) : new su(this.source, 1, f);
  }
  handleChange(e) {
    return e.changes.touchesRange(this.from, this.to) ? new su(
      this.source,
      0
      /* State.Inactive */
    ) : this.map(e.changes);
  }
  map(e) {
    return e.empty ? this : (this.result.map ? this.result.map(this.result, e) : this.result) ? new RE(this.source, this.explicitPos < 0 ? -1 : e.mapPos(this.explicitPos), this.result, e.mapPos(this.from), e.mapPos(this.to, 1)) : new su(
      this.source,
      0
      /* State.Inactive */
    );
  }
}
function oMe(t, e, n, r) {
  if (!t)
    return !1;
  let a = e.sliceDoc(n, r);
  return typeof t == "function" ? t(a, n, r, e) : moe(t, !0).test(a);
}
const goe = /* @__PURE__ */ fr.define({
  map(t, e) {
    return t.map((n) => n.map(e));
  }
}), boe = /* @__PURE__ */ fr.define(), qu = /* @__PURE__ */ Ss.define({
  create() {
    return hI.start();
  },
  update(t, e) {
    return t.update(e);
  },
  provide: (t) => [
    YU.from(t, (e) => e.tooltip),
    qt.contentAttributes.from(t, (e) => e.attrs)
  ]
});
function l6(t, e) {
  const n = e.completion.apply || e.completion.label;
  let r = t.state.field(qu).active.find((a) => a.source == e.source);
  return r instanceof RE ? (typeof n == "string" ? t.dispatch(Object.assign(Object.assign({}, VLe(t.state, n, r.from, r.to)), { annotations: s6.of(e.completion) })) : n(t, e.completion, r.from, r.to), !0) : !1;
}
const sMe = /* @__PURE__ */ eMe(qu, l6);
function tA(t, e = "option") {
  return (n) => {
    let r = n.state.field(qu, !1);
    if (!r || !r.open || r.open.disabled || Date.now() - r.open.timestamp < n.state.facet(tl).interactionDelay)
      return !1;
    let a = 1, i;
    e == "page" && (i = Nie(n, r.open.tooltip)) && (a = Math.max(2, Math.floor(i.dom.offsetHeight / i.dom.querySelector("li").offsetHeight) - 1));
    let { length: o } = r.open.options, s = r.open.selected > -1 ? r.open.selected + a * (t ? 1 : -1) : t ? 0 : o - 1;
    return s < 0 ? s = e == "page" ? 0 : o - 1 : s >= o && (s = e == "page" ? o - 1 : 0), n.dispatch({ effects: boe.of(s) }), !0;
  };
}
const lMe = (t) => {
  let e = t.state.field(qu, !1);
  return t.state.readOnly || !e || !e.open || e.open.selected < 0 || e.open.disabled || Date.now() - e.open.timestamp < t.state.facet(tl).interactionDelay ? !1 : l6(t, e.open.options[e.open.selected]);
}, uMe = (t) => t.state.field(qu, !1) ? (t.dispatch({ effects: pI.of(!0) }), !0) : !1, cMe = (t) => {
  let e = t.state.field(qu, !1);
  return !e || !e.active.some(
    (n) => n.state != 0
    /* State.Inactive */
  ) ? !1 : (t.dispatch({ effects: ZT.of(null) }), !0);
};
class fMe {
  constructor(e, n) {
    this.active = e, this.context = n, this.time = Date.now(), this.updates = [], this.done = void 0;
  }
}
const dMe = 50, pMe = 1e3, hMe = /* @__PURE__ */ Ki.fromClass(class {
  constructor(t) {
    this.view = t, this.debounceUpdate = -1, this.running = [], this.debounceAccept = -1, this.pendingStart = !1, this.composing = 0;
    for (let e of t.state.field(qu).active)
      e.state == 1 && this.startQuery(e);
  }
  update(t) {
    let e = t.state.field(qu), n = t.state.facet(tl);
    if (!t.selectionSet && !t.docChanged && t.startState.field(qu) == e)
      return;
    let r = t.transactions.some((i) => (i.selection || i.docChanged) && !$4(i, n));
    for (let i = 0; i < this.running.length; i++) {
      let o = this.running[i];
      if (r || o.updates.length + t.transactions.length > dMe && Date.now() - o.time > pMe) {
        for (let s of o.context.abortListeners)
          try {
            s();
          } catch (u) {
            Ku(this.view.state, u);
          }
        o.context.abortListeners = null, this.running.splice(i--, 1);
      } else
        o.updates.push(...t.transactions);
    }
    this.debounceUpdate > -1 && clearTimeout(this.debounceUpdate), t.transactions.some((i) => i.effects.some((o) => o.is(pI))) && (this.pendingStart = !0);
    let a = this.pendingStart ? 50 : n.activateOnTypingDelay;
    if (this.debounceUpdate = e.active.some((i) => i.state == 1 && !this.running.some((o) => o.active.source == i.source)) ? setTimeout(() => this.startUpdate(), a) : -1, this.composing != 0)
      for (let i of t.transactions)
        $4(i, n) == "input" ? this.composing = 2 : this.composing == 2 && i.selection && (this.composing = 3);
  }
  startUpdate() {
    this.debounceUpdate = -1, this.pendingStart = !1;
    let { state: t } = this.view, e = t.field(qu);
    for (let n of e.active)
      n.state == 1 && !this.running.some((r) => r.active.source == n.source) && this.startQuery(n);
  }
  startQuery(t) {
    let { state: e } = this.view, n = Yb(e), r = new o6(e, n, t.explicitPos == n), a = new fMe(t, r);
    this.running.push(a), Promise.resolve(t.source(r)).then((i) => {
      a.context.aborted || (a.done = i || null, this.scheduleAccept());
    }, (i) => {
      this.view.dispatch({ effects: ZT.of(null) }), Ku(this.view.state, i);
    });
  }
  scheduleAccept() {
    this.running.every((t) => t.done !== void 0) ? this.accept() : this.debounceAccept < 0 && (this.debounceAccept = setTimeout(() => this.accept(), this.view.state.facet(tl).updateSyncTime));
  }
  // For each finished query in this.running, try to create a result
  // or, if appropriate, restart the query.
  accept() {
    var t;
    this.debounceAccept > -1 && clearTimeout(this.debounceAccept), this.debounceAccept = -1;
    let e = [], n = this.view.state.facet(tl);
    for (let r = 0; r < this.running.length; r++) {
      let a = this.running[r];
      if (a.done === void 0)
        continue;
      if (this.running.splice(r--, 1), a.done) {
        let o = new RE(a.active.source, a.active.explicitPos, a.done, a.done.from, (t = a.done.to) !== null && t !== void 0 ? t : Yb(a.updates.length ? a.updates[0].startState : this.view.state));
        for (let s of a.updates)
          o = o.update(s, n);
        if (o.hasResult()) {
          e.push(o);
          continue;
        }
      }
      let i = this.view.state.field(qu).active.find((o) => o.source == a.active.source);
      if (i && i.state == 1)
        if (a.done == null) {
          let o = new su(
            a.active.source,
            0
            /* State.Inactive */
          );
          for (let s of a.updates)
            o = o.update(s, n);
          o.state != 1 && e.push(o);
        } else
          this.startQuery(i);
    }
    e.length && this.view.dispatch({ effects: goe.of(e) });
  }
}, {
  eventHandlers: {
    blur(t) {
      let e = this.view.state.field(qu, !1);
      if (e && e.tooltip && this.view.state.facet(tl).closeOnBlur) {
        let n = e.open && Nie(this.view, e.open.tooltip);
        (!n || !n.dom.contains(t.relatedTarget)) && setTimeout(() => this.view.dispatch({ effects: ZT.of(null) }), 10);
      }
    },
    compositionstart() {
      this.composing = 1;
    },
    compositionend() {
      this.composing == 3 && setTimeout(() => this.view.dispatch({ effects: pI.of(!1) }), 20), this.composing = 0;
    }
  }
}), mMe = typeof navigator == "object" && /* @__PURE__ */ /Win/.test(navigator.platform), gMe = /* @__PURE__ */ ig.highest(/* @__PURE__ */ qt.domEventHandlers({
  keydown(t, e) {
    let n = e.state.field(qu, !1);
    if (!n || !n.open || n.open.disabled || n.open.selected < 0 || t.key.length > 1 || t.ctrlKey && !(mMe && t.altKey) || t.metaKey)
      return !1;
    let r = n.open.options[n.open.selected], a = n.active.find((o) => o.source == r.source), i = r.completion.commitCharacters || a.result.commitCharacters;
    return i && i.indexOf(t.key) > -1 && l6(e, r), !1;
  }
})), voe = /* @__PURE__ */ qt.baseTheme({
  ".cm-tooltip.cm-tooltip-autocomplete": {
    "& > ul": {
      fontFamily: "monospace",
      whiteSpace: "nowrap",
      overflow: "hidden auto",
      maxWidth_fallback: "700px",
      maxWidth: "min(700px, 95vw)",
      minWidth: "250px",
      maxHeight: "10em",
      height: "100%",
      listStyle: "none",
      margin: 0,
      padding: 0,
      "& > li, & > completion-section": {
        padding: "1px 3px",
        lineHeight: 1.2
      },
      "& > li": {
        overflowX: "hidden",
        textOverflow: "ellipsis",
        cursor: "pointer"
      },
      "& > completion-section": {
        display: "list-item",
        borderBottom: "1px solid silver",
        paddingLeft: "0.5em",
        opacity: 0.7
      }
    }
  },
  "&light .cm-tooltip-autocomplete ul li[aria-selected]": {
    background: "#17c",
    color: "white"
  },
  "&light .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
    background: "#777"
  },
  "&dark .cm-tooltip-autocomplete ul li[aria-selected]": {
    background: "#347",
    color: "white"
  },
  "&dark .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
    background: "#444"
  },
  ".cm-completionListIncompleteTop:before, .cm-completionListIncompleteBottom:after": {
    content: '"···"',
    opacity: 0.5,
    display: "block",
    textAlign: "center"
  },
  ".cm-tooltip.cm-completionInfo": {
    position: "absolute",
    padding: "3px 9px",
    width: "max-content",
    maxWidth: "400px",
    boxSizing: "border-box"
  },
  ".cm-completionInfo.cm-completionInfo-left": { right: "100%" },
  ".cm-completionInfo.cm-completionInfo-right": { left: "100%" },
  ".cm-completionInfo.cm-completionInfo-left-narrow": { right: "30px" },
  ".cm-completionInfo.cm-completionInfo-right-narrow": { left: "30px" },
  "&light .cm-snippetField": { backgroundColor: "#00000022" },
  "&dark .cm-snippetField": { backgroundColor: "#ffffff22" },
  ".cm-snippetFieldPosition": {
    verticalAlign: "text-top",
    width: 0,
    height: "1.15em",
    display: "inline-block",
    margin: "0 -0.7px -.7em",
    borderLeft: "1.4px dotted #888"
  },
  ".cm-completionMatchedText": {
    textDecoration: "underline"
  },
  ".cm-completionDetail": {
    marginLeft: "0.5em",
    fontStyle: "italic"
  },
  ".cm-completionIcon": {
    fontSize: "90%",
    width: ".8em",
    display: "inline-block",
    textAlign: "center",
    paddingRight: ".6em",
    opacity: "0.6",
    boxSizing: "content-box"
  },
  ".cm-completionIcon-function, .cm-completionIcon-method": {
    "&:after": { content: "'ƒ'" }
  },
  ".cm-completionIcon-class": {
    "&:after": { content: "'○'" }
  },
  ".cm-completionIcon-interface": {
    "&:after": { content: "'◌'" }
  },
  ".cm-completionIcon-variable": {
    "&:after": { content: "'𝑥'" }
  },
  ".cm-completionIcon-constant": {
    "&:after": { content: "'𝐶'" }
  },
  ".cm-completionIcon-type": {
    "&:after": { content: "'𝑡'" }
  },
  ".cm-completionIcon-enum": {
    "&:after": { content: "'∪'" }
  },
  ".cm-completionIcon-property": {
    "&:after": { content: "'□'" }
  },
  ".cm-completionIcon-keyword": {
    "&:after": { content: "'🔑︎'" }
    // Disable emoji rendering
  },
  ".cm-completionIcon-namespace": {
    "&:after": { content: "'▢'" }
  },
  ".cm-completionIcon-text": {
    "&:after": { content: "'abc'", fontSize: "50%", verticalAlign: "middle" }
  }
});
class bMe {
  constructor(e, n, r, a) {
    this.field = e, this.line = n, this.from = r, this.to = a;
  }
}
class u6 {
  constructor(e, n, r) {
    this.field = e, this.from = n, this.to = r;
  }
  map(e) {
    let n = e.mapPos(this.from, -1, el.TrackDel), r = e.mapPos(this.to, 1, el.TrackDel);
    return n == null || r == null ? null : new u6(this.field, n, r);
  }
}
class c6 {
  constructor(e, n) {
    this.lines = e, this.fieldPositions = n;
  }
  instantiate(e, n) {
    let r = [], a = [n], i = e.doc.lineAt(n), o = /^\s*/.exec(i.text)[0];
    for (let u of this.lines) {
      if (r.length) {
        let f = o, p = /^\t*/.exec(u)[0].length;
        for (let m = 0; m < p; m++)
          f += e.facet(f1);
        a.push(n + f.length - p), u = f + u.slice(p);
      }
      r.push(u), n += u.length + 1;
    }
    let s = this.fieldPositions.map((u) => new u6(u.field, a[u.line] + u.from, a[u.line] + u.to));
    return { text: r, ranges: s };
  }
  static parse(e) {
    let n = [], r = [], a = [], i;
    for (let o of e.split(/\r\n?|\n/)) {
      for (; i = /[#$]\{(?:(\d+)(?::([^}]*))?|([^}]*))\}/.exec(o); ) {
        let s = i[1] ? +i[1] : null, u = i[2] || i[3] || "", f = -1;
        for (let p = 0; p < n.length; p++)
          (s != null ? n[p].seq == s : u && n[p].name == u) && (f = p);
        if (f < 0) {
          let p = 0;
          for (; p < n.length && (s == null || n[p].seq != null && n[p].seq < s); )
            p++;
          n.splice(p, 0, { seq: s, name: u }), f = p;
          for (let m of a)
            m.field >= f && m.field++;
        }
        a.push(new bMe(f, r.length, i.index, i.index + u.length)), o = o.slice(0, i.index) + u + o.slice(i.index + i[0].length);
      }
      for (let s; s = /\\([{}])/.exec(o); ) {
        o = o.slice(0, s.index) + s[1] + o.slice(s.index + s[0].length);
        for (let u of a)
          u.line == r.length && u.from > s.index && (u.from--, u.to--);
      }
      r.push(o);
    }
    return new c6(r, a);
  }
}
let vMe = /* @__PURE__ */ Ln.widget({ widget: /* @__PURE__ */ new class extends Nh {
  toDOM() {
    let t = document.createElement("span");
    return t.className = "cm-snippetFieldPosition", t;
  }
  ignoreEvent() {
    return !1;
  }
}() }), yMe = /* @__PURE__ */ Ln.mark({ class: "cm-snippetField" });
class h1 {
  constructor(e, n) {
    this.ranges = e, this.active = n, this.deco = Ln.set(e.map((r) => (r.from == r.to ? vMe : yMe).range(r.from, r.to)));
  }
  map(e) {
    let n = [];
    for (let r of this.ranges) {
      let a = r.map(e);
      if (!a)
        return null;
      n.push(a);
    }
    return new h1(n, this.active);
  }
  selectionInsideField(e) {
    return e.ranges.every((n) => this.ranges.some((r) => r.field == this.active && r.from <= n.from && r.to >= n.to));
  }
}
const T_ = /* @__PURE__ */ fr.define({
  map(t, e) {
    return t && t.map(e);
  }
}), OMe = /* @__PURE__ */ fr.define(), XT = /* @__PURE__ */ Ss.define({
  create() {
    return null;
  },
  update(t, e) {
    for (let n of e.effects) {
      if (n.is(T_))
        return n.value;
      if (n.is(OMe) && t)
        return new h1(t.ranges, n.value);
    }
    return t && e.docChanged && (t = t.map(e.changes)), t && e.selection && !t.selectionInsideField(e.selection) && (t = null), t;
  },
  provide: (t) => qt.decorations.from(t, (e) => e ? e.deco : Ln.none)
});
function f6(t, e) {
  return ft.create(t.filter((n) => n.field == e).map((n) => ft.range(n.from, n.to)));
}
function EMe(t) {
  let e = c6.parse(t);
  return (n, r, a, i) => {
    let { text: o, ranges: s } = e.instantiate(n.state, a), u = {
      changes: { from: a, to: i, insert: la.of(o) },
      scrollIntoView: !0,
      annotations: r ? [s6.of(r), No.userEvent.of("input.complete")] : void 0
    };
    if (s.length && (u.selection = f6(s, 0)), s.some((f) => f.field > 0)) {
      let f = new h1(s, 0), p = u.effects = [T_.of(f)];
      n.state.field(XT, !1) === void 0 && p.push(fr.appendConfig.of([XT, CMe, xMe, voe]));
    }
    n.dispatch(n.state.update(u));
  };
}
function yoe(t) {
  return ({ state: e, dispatch: n }) => {
    let r = e.field(XT, !1);
    if (!r || t < 0 && r.active == 0)
      return !1;
    let a = r.active + t, i = t > 0 && !r.ranges.some((o) => o.field == a + t);
    return n(e.update({
      selection: f6(r.ranges, a),
      effects: T_.of(i ? null : new h1(r.ranges, a)),
      scrollIntoView: !0
    })), !0;
  };
}
const SMe = ({ state: t, dispatch: e }) => t.field(XT, !1) ? (e(t.update({ effects: T_.of(null) })), !0) : !1, wMe = /* @__PURE__ */ yoe(1), TMe = /* @__PURE__ */ yoe(-1), _Me = [
  { key: "Tab", run: wMe, shift: TMe },
  { key: "Escape", run: SMe }
], Lq = /* @__PURE__ */ bn.define({
  combine(t) {
    return t.length ? t[0] : _Me;
  }
}), CMe = /* @__PURE__ */ ig.highest(/* @__PURE__ */ l1.compute([Lq], (t) => t.facet(Lq)));
function Xu(t, e) {
  return Object.assign(Object.assign({}, e), { apply: EMe(t) });
}
const xMe = /* @__PURE__ */ qt.domEventHandlers({
  mousedown(t, e) {
    let n = e.state.field(XT, !1), r;
    if (!n || (r = e.posAtCoords({ x: t.clientX, y: t.clientY })) == null)
      return !1;
    let a = n.ranges.find((i) => i.from <= r && i.to >= r);
    return !a || a.field == n.active ? !1 : (e.dispatch({
      selection: f6(n.ranges, a.field),
      effects: T_.of(n.ranges.some((i) => i.field > a.field) ? new h1(n.ranges, a.field) : null),
      scrollIntoView: !0
    }), !0);
  }
}), qT = {
  brackets: ["(", "[", "{", "'", '"'],
  before: ")]}:;>",
  stringPrefixes: []
}, Jy = /* @__PURE__ */ fr.define({
  map(t, e) {
    let n = e.mapPos(t, -1, el.TrackAfter);
    return n ?? void 0;
  }
}), d6 = /* @__PURE__ */ new class extends c0 {
}();
d6.startSide = 1;
d6.endSide = -1;
const Ooe = /* @__PURE__ */ Ss.define({
  create() {
    return ta.empty;
  },
  update(t, e) {
    if (t = t.map(e.changes), e.selection) {
      let n = e.state.doc.lineAt(e.selection.main.head);
      t = t.update({ filter: (r) => r >= n.from && r <= n.to });
    }
    for (let n of e.effects)
      n.is(Jy) && (t = t.update({ add: [d6.range(n.value, n.value + 1)] }));
    return t;
  }
});
function AMe() {
  return [RMe, Ooe];
}
const y3 = "()[]{}<>";
function Eoe(t) {
  for (let e = 0; e < y3.length; e += 2)
    if (y3.charCodeAt(e) == t)
      return y3.charAt(e + 1);
  return FU(t < 128 ? t : t + 1);
}
function Soe(t, e) {
  return t.languageDataAt("closeBrackets", e)[0] || qT;
}
const kMe = typeof navigator == "object" && /* @__PURE__ */ /Android\b/.test(navigator.userAgent), RMe = /* @__PURE__ */ qt.inputHandler.of((t, e, n, r) => {
  if ((kMe ? t.composing : t.compositionStarted) || t.state.readOnly)
    return !1;
  let a = t.state.selection.main;
  if (r.length > 2 || r.length == 2 && Uf(Ks(r, 0)) == 1 || e != a.from || n != a.to)
    return !1;
  let i = NMe(t.state, r);
  return i ? (t.dispatch(i), !0) : !1;
}), IMe = ({ state: t, dispatch: e }) => {
  if (t.readOnly)
    return !1;
  let r = Soe(t, t.selection.main.head).brackets || qT.brackets, a = null, i = t.changeByRange((o) => {
    if (o.empty) {
      let s = PMe(t.doc, o.head);
      for (let u of r)
        if (u == s && TD(t.doc, o.head) == Eoe(Ks(u, 0)))
          return {
            changes: { from: o.head - u.length, to: o.head + u.length },
            range: ft.cursor(o.head - u.length)
          };
    }
    return { range: a = o };
  });
  return a || e(t.update(i, { scrollIntoView: !0, userEvent: "delete.backward" })), !a;
}, DMe = [
  { key: "Backspace", run: IMe }
];
function NMe(t, e) {
  let n = Soe(t, t.selection.main.head), r = n.brackets || qT.brackets;
  for (let a of r) {
    let i = Eoe(Ks(a, 0));
    if (e == a)
      return i == a ? FMe(t, a, r.indexOf(a + a + a) > -1, n) : LMe(t, a, i, n.before || qT.before);
    if (e == i && woe(t, t.selection.main.from))
      return MMe(t, a, i);
  }
  return null;
}
function woe(t, e) {
  let n = !1;
  return t.field(Ooe).between(0, t.doc.length, (r) => {
    r == e && (n = !0);
  }), n;
}
function TD(t, e) {
  let n = t.sliceString(e, e + 2);
  return n.slice(0, Uf(Ks(n, 0)));
}
function PMe(t, e) {
  let n = t.sliceString(e - 2, e);
  return Uf(Ks(n, 0)) == n.length ? n : n.slice(1);
}
function LMe(t, e, n, r) {
  let a = null, i = t.changeByRange((o) => {
    if (!o.empty)
      return {
        changes: [{ insert: e, from: o.from }, { insert: n, from: o.to }],
        effects: Jy.of(o.to + e.length),
        range: ft.range(o.anchor + e.length, o.head + e.length)
      };
    let s = TD(t.doc, o.head);
    return !s || /\s/.test(s) || r.indexOf(s) > -1 ? {
      changes: { insert: e + n, from: o.head },
      effects: Jy.of(o.head + e.length),
      range: ft.cursor(o.head + e.length)
    } : { range: a = o };
  });
  return a ? null : t.update(i, {
    scrollIntoView: !0,
    userEvent: "input.type"
  });
}
function MMe(t, e, n) {
  let r = null, a = t.changeByRange((i) => i.empty && TD(t.doc, i.head) == n ? {
    changes: { from: i.head, to: i.head + n.length, insert: n },
    range: ft.cursor(i.head + n.length)
  } : r = { range: i });
  return r ? null : t.update(a, {
    scrollIntoView: !0,
    userEvent: "input.type"
  });
}
function FMe(t, e, n, r) {
  let a = r.stringPrefixes || qT.stringPrefixes, i = null, o = t.changeByRange((s) => {
    if (!s.empty)
      return {
        changes: [{ insert: e, from: s.from }, { insert: e, from: s.to }],
        effects: Jy.of(s.to + e.length),
        range: ft.range(s.anchor + e.length, s.head + e.length)
      };
    let u = s.head, f = TD(t.doc, u), p;
    if (f == e) {
      if (Mq(t, u))
        return {
          changes: { insert: e + e, from: u },
          effects: Jy.of(u + e.length),
          range: ft.cursor(u + e.length)
        };
      if (woe(t, u)) {
        let v = n && t.sliceDoc(u, u + e.length * 3) == e + e + e ? e + e + e : e;
        return {
          changes: { from: u, to: u + v.length, insert: v },
          range: ft.cursor(u + v.length)
        };
      }
    } else {
      if (n && t.sliceDoc(u - 2 * e.length, u) == e + e && (p = Fq(t, u - 2 * e.length, a)) > -1 && Mq(t, p))
        return {
          changes: { insert: e + e + e + e, from: u },
          effects: Jy.of(u + e.length),
          range: ft.cursor(u + e.length)
        };
      if (t.charCategorizer(u)(f) != Si.Word && Fq(t, u, a) > -1 && !$Me(t, u, e, a))
        return {
          changes: { insert: e + e, from: u },
          effects: Jy.of(u + e.length),
          range: ft.cursor(u + e.length)
        };
    }
    return { range: i = s };
  });
  return i ? null : t.update(o, {
    scrollIntoView: !0,
    userEvent: "input.type"
  });
}
function Mq(t, e) {
  let n = $a(t).resolveInner(e + 1);
  return n.parent && n.from == e;
}
function $Me(t, e, n, r) {
  let a = $a(t).resolveInner(e, -1), i = r.reduce((o, s) => Math.max(o, s.length), 0);
  for (let o = 0; o < 5; o++) {
    let s = t.sliceDoc(a.from, Math.min(a.to, a.from + n.length + i)), u = s.indexOf(n);
    if (!u || u > -1 && r.indexOf(s.slice(0, u)) > -1) {
      let p = a.firstChild;
      for (; p && p.from == a.from && p.to - p.from > n.length + u; ) {
        if (t.sliceDoc(p.to - n.length, p.to) == n)
          return !1;
        p = p.firstChild;
      }
      return !0;
    }
    let f = a.to == e && a.parent;
    if (!f)
      break;
    a = f;
  }
  return !1;
}
function Fq(t, e, n) {
  let r = t.charCategorizer(e);
  if (r(t.sliceDoc(e - 1, e)) != Si.Word)
    return e;
  for (let a of n) {
    let i = e - a.length;
    if (t.sliceDoc(i, e) == a && r(t.sliceDoc(i - 1, i)) != Si.Word)
      return i;
  }
  return -1;
}
function BMe(t = {}) {
  return [
    gMe,
    qu,
    tl.of(t),
    hMe,
    UMe,
    voe
  ];
}
const Toe = [
  { key: "Ctrl-Space", run: uMe },
  { key: "Escape", run: cMe },
  { key: "ArrowDown", run: /* @__PURE__ */ tA(!0) },
  { key: "ArrowUp", run: /* @__PURE__ */ tA(!1) },
  { key: "PageDown", run: /* @__PURE__ */ tA(!0, "page") },
  { key: "PageUp", run: /* @__PURE__ */ tA(!1, "page") },
  { key: "Enter", run: lMe }
], UMe = /* @__PURE__ */ ig.highest(/* @__PURE__ */ l1.computeN([tl], (t) => t.facet(tl).defaultKeymap ? [Toe] : []));
class mI {
  static create(e, n, r, a, i) {
    let o = a + (a << 8) + e + (n << 4) | 0;
    return new mI(e, n, r, o, i, [], []);
  }
  constructor(e, n, r, a, i, o, s) {
    this.type = e, this.value = n, this.from = r, this.hash = a, this.end = i, this.children = o, this.positions = s, this.hashProp = [[nr.contextHash, a]];
  }
  addChild(e, n) {
    e.prop(nr.contextHash) != this.hash && (e = new Pr(e.type, e.children, e.positions, e.length, this.hashProp)), this.children.push(e), this.positions.push(n);
  }
  toTree(e, n = this.end) {
    let r = this.children.length - 1;
    return r >= 0 && (n = Math.max(n, this.positions[r] + this.children[r].length + this.from)), new Pr(e.types[this.type], this.children, this.positions, n - this.from).balance({
      makeTree: (a, i, o) => new Pr(Po.none, a, i, o, this.hashProp)
    });
  }
}
var Wt;
(function(t) {
  t[t.Document = 1] = "Document", t[t.CodeBlock = 2] = "CodeBlock", t[t.FencedCode = 3] = "FencedCode", t[t.Blockquote = 4] = "Blockquote", t[t.HorizontalRule = 5] = "HorizontalRule", t[t.BulletList = 6] = "BulletList", t[t.OrderedList = 7] = "OrderedList", t[t.ListItem = 8] = "ListItem", t[t.ATXHeading1 = 9] = "ATXHeading1", t[t.ATXHeading2 = 10] = "ATXHeading2", t[t.ATXHeading3 = 11] = "ATXHeading3", t[t.ATXHeading4 = 12] = "ATXHeading4", t[t.ATXHeading5 = 13] = "ATXHeading5", t[t.ATXHeading6 = 14] = "ATXHeading6", t[t.SetextHeading1 = 15] = "SetextHeading1", t[t.SetextHeading2 = 16] = "SetextHeading2", t[t.HTMLBlock = 17] = "HTMLBlock", t[t.LinkReference = 18] = "LinkReference", t[t.Paragraph = 19] = "Paragraph", t[t.CommentBlock = 20] = "CommentBlock", t[t.ProcessingInstructionBlock = 21] = "ProcessingInstructionBlock", t[t.Escape = 22] = "Escape", t[t.Entity = 23] = "Entity", t[t.HardBreak = 24] = "HardBreak", t[t.Emphasis = 25] = "Emphasis", t[t.StrongEmphasis = 26] = "StrongEmphasis", t[t.Link = 27] = "Link", t[t.Image = 28] = "Image", t[t.InlineCode = 29] = "InlineCode", t[t.HTMLTag = 30] = "HTMLTag", t[t.Comment = 31] = "Comment", t[t.ProcessingInstruction = 32] = "ProcessingInstruction", t[t.Autolink = 33] = "Autolink", t[t.HeaderMark = 34] = "HeaderMark", t[t.QuoteMark = 35] = "QuoteMark", t[t.ListMark = 36] = "ListMark", t[t.LinkMark = 37] = "LinkMark", t[t.EmphasisMark = 38] = "EmphasisMark", t[t.CodeMark = 39] = "CodeMark", t[t.CodeText = 40] = "CodeText", t[t.CodeInfo = 41] = "CodeInfo", t[t.LinkTitle = 42] = "LinkTitle", t[t.LinkLabel = 43] = "LinkLabel", t[t.URL = 44] = "URL";
})(Wt || (Wt = {}));
class zMe {
  /// @internal
  constructor(e, n) {
    this.start = e, this.content = n, this.marks = [], this.parsers = [];
  }
}
class HMe {
  constructor() {
    this.text = "", this.baseIndent = 0, this.basePos = 0, this.depth = 0, this.markers = [], this.pos = 0, this.indent = 0, this.next = -1;
  }
  /// @internal
  forward() {
    this.basePos > this.pos && this.forwardInner();
  }
  /// @internal
  forwardInner() {
    let e = this.skipSpace(this.basePos);
    this.indent = this.countIndent(e, this.pos, this.indent), this.pos = e, this.next = e == this.text.length ? -1 : this.text.charCodeAt(e);
  }
  /// Skip whitespace after the given position, return the position of
  /// the next non-space character or the end of the line if there's
  /// only space after `from`.
  skipSpace(e) {
    return cT(this.text, e);
  }
  /// @internal
  reset(e) {
    for (this.text = e, this.baseIndent = this.basePos = this.pos = this.indent = 0, this.forwardInner(), this.depth = 1; this.markers.length; )
      this.markers.pop();
  }
  /// Move the line's base position forward to the given position.
  /// This should only be called by composite [block
  /// parsers](#BlockParser.parse) or [markup skipping
  /// functions](#NodeSpec.composite).
  moveBase(e) {
    this.basePos = e, this.baseIndent = this.countIndent(e, this.pos, this.indent);
  }
  /// Move the line's base position forward to the given _column_.
  moveBaseColumn(e) {
    this.baseIndent = e, this.basePos = this.findColumn(e);
  }
  /// Store a composite-block-level marker. Should be called from
  /// [markup skipping functions](#NodeSpec.composite) when they
  /// consume any non-whitespace characters.
  addMarker(e) {
    this.markers.push(e);
  }
  /// Find the column position at `to`, optionally starting at a given
  /// position and column.
  countIndent(e, n = 0, r = 0) {
    for (let a = n; a < e; a++)
      r += this.text.charCodeAt(a) == 9 ? 4 - r % 4 : 1;
    return r;
  }
  /// Find the position corresponding to the given column.
  findColumn(e) {
    let n = 0;
    for (let r = 0; n < this.text.length && r < e; n++)
      r += this.text.charCodeAt(n) == 9 ? 4 - r % 4 : 1;
    return n;
  }
  /// @internal
  scrub() {
    if (!this.baseIndent)
      return this.text;
    let e = "";
    for (let n = 0; n < this.basePos; n++)
      e += " ";
    return e + this.text.slice(this.basePos);
  }
}
function $q(t, e, n) {
  if (n.pos == n.text.length || t != e.block && n.indent >= e.stack[n.depth + 1].value + n.baseIndent)
    return !0;
  if (n.indent >= n.baseIndent + 4)
    return !1;
  let r = (t.type == Wt.OrderedList ? m6 : h6)(n, e, !1);
  return r > 0 && (t.type != Wt.BulletList || p6(n, e, !1) < 0) && n.text.charCodeAt(n.pos + r - 1) == t.value;
}
const _oe = {
  [Wt.Blockquote](t, e, n) {
    return n.next != 62 ? !1 : (n.markers.push(qr(Wt.QuoteMark, e.lineStart + n.pos, e.lineStart + n.pos + 1)), n.moveBase(n.pos + (Jf(n.text.charCodeAt(n.pos + 1)) ? 2 : 1)), t.end = e.lineStart + n.text.length, !0);
  },
  [Wt.ListItem](t, e, n) {
    return n.indent < n.baseIndent + t.value && n.next > -1 ? !1 : (n.moveBaseColumn(n.baseIndent + t.value), !0);
  },
  [Wt.OrderedList]: $q,
  [Wt.BulletList]: $q,
  [Wt.Document]() {
    return !0;
  }
};
function Jf(t) {
  return t == 32 || t == 9 || t == 10 || t == 13;
}
function cT(t, e = 0) {
  for (; e < t.length && Jf(t.charCodeAt(e)); )
    e++;
  return e;
}
function Bq(t, e, n) {
  for (; e > n && Jf(t.charCodeAt(e - 1)); )
    e--;
  return e;
}
function Coe(t) {
  if (t.next != 96 && t.next != 126)
    return -1;
  let e = t.pos + 1;
  for (; e < t.text.length && t.text.charCodeAt(e) == t.next; )
    e++;
  if (e < t.pos + 3)
    return -1;
  if (t.next == 96) {
    for (let n = e; n < t.text.length; n++)
      if (t.text.charCodeAt(n) == 96)
        return -1;
  }
  return e;
}
function xoe(t) {
  return t.next != 62 ? -1 : t.text.charCodeAt(t.pos + 1) == 32 ? 2 : 1;
}
function p6(t, e, n) {
  if (t.next != 42 && t.next != 45 && t.next != 95)
    return -1;
  let r = 1;
  for (let a = t.pos + 1; a < t.text.length; a++) {
    let i = t.text.charCodeAt(a);
    if (i == t.next)
      r++;
    else if (!Jf(i))
      return -1;
  }
  return n && t.next == 45 && Roe(t) > -1 && t.depth == e.stack.length || r < 3 ? -1 : 1;
}
function Aoe(t, e) {
  for (let n = t.stack.length - 1; n >= 0; n--)
    if (t.stack[n].type == e)
      return !0;
  return !1;
}
function h6(t, e, n) {
  return (t.next == 45 || t.next == 43 || t.next == 42) && (t.pos == t.text.length - 1 || Jf(t.text.charCodeAt(t.pos + 1))) && (!n || Aoe(e, Wt.BulletList) || t.skipSpace(t.pos + 2) < t.text.length) ? 1 : -1;
}
function m6(t, e, n) {
  let r = t.pos, a = t.next;
  for (; a >= 48 && a <= 57; ) {
    r++;
    if (r == t.text.length)
      return -1;
    a = t.text.charCodeAt(r);
  }
  return r == t.pos || r > t.pos + 9 || a != 46 && a != 41 || r < t.text.length - 1 && !Jf(t.text.charCodeAt(r + 1)) || n && !Aoe(e, Wt.OrderedList) && (t.skipSpace(r + 1) == t.text.length || r > t.pos + 1 || t.next != 49) ? -1 : r + 1 - t.pos;
}
function koe(t) {
  if (t.next != 35)
    return -1;
  let e = t.pos + 1;
  for (; e < t.text.length && t.text.charCodeAt(e) == 35; )
    e++;
  if (e < t.text.length && t.text.charCodeAt(e) != 32)
    return -1;
  let n = e - t.pos;
  return n > 6 ? -1 : n;
}
function Roe(t) {
  if (t.next != 45 && t.next != 61 || t.indent >= t.baseIndent + 4)
    return -1;
  let e = t.pos + 1;
  for (; e < t.text.length && t.text.charCodeAt(e) == t.next; )
    e++;
  let n = e;
  for (; e < t.text.length && Jf(t.text.charCodeAt(e)); )
    e++;
  return e == t.text.length ? n : -1;
}
const B4 = /^[ \t]*$/, Ioe = /-->/, Doe = /\?>/, U4 = [
  [/^<(?:script|pre|style)(?:\s|>|$)/i, /<\/(?:script|pre|style)>/i],
  [/^\s*<!--/, Ioe],
  [/^\s*<\?/, Doe],
  [/^\s*<![A-Z]/, />/],
  [/^\s*<!\[CDATA\[/, /\]\]>/],
  [/^\s*<\/?(?:address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h1|h2|h3|h4|h5|h6|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul)(?:\s|\/?>|$)/i, B4],
  [/^\s*(?:<\/[a-z][\w-]*\s*>|<[a-z][\w-]*(\s+[a-z:_][\w-.]*(?:\s*=\s*(?:[^\s"'=<>`]+|'[^']*'|"[^"]*"))?)*\s*>)\s*$/i, B4]
];
function Noe(t, e, n) {
  if (t.next != 60)
    return -1;
  let r = t.text.slice(t.pos);
  for (let a = 0, i = U4.length - (n ? 1 : 0); a < i; a++)
    if (U4[a][0].test(r))
      return a;
  return -1;
}
function Uq(t, e) {
  let n = t.countIndent(e, t.pos, t.indent), r = t.countIndent(t.skipSpace(e), e, n);
  return r >= n + 5 ? n + 1 : r;
}
function Hy(t, e, n) {
  let r = t.length - 1;
  r >= 0 && t[r].to == e && t[r].type == Wt.CodeText ? t[r].to = n : t.push(qr(Wt.CodeText, e, n));
}
const nA = {
  LinkReference: void 0,
  IndentedCode(t, e) {
    let n = e.baseIndent + 4;
    if (e.indent < n)
      return !1;
    let r = e.findColumn(n), a = t.lineStart + r, i = t.lineStart + e.text.length, o = [], s = [];
    for (Hy(o, a, i); t.nextLine() && e.depth >= t.stack.length; )
      if (e.pos == e.text.length) {
        Hy(s, t.lineStart - 1, t.lineStart);
        for (let u of e.markers)
          s.push(u);
      } else {
        if (e.indent < n)
          break;
        {
          if (s.length) {
            for (let f of s)
              f.type == Wt.CodeText ? Hy(o, f.from, f.to) : o.push(f);
            s = [];
          }
          Hy(o, t.lineStart - 1, t.lineStart);
          for (let f of e.markers)
            o.push(f);
          i = t.lineStart + e.text.length;
          let u = t.lineStart + e.findColumn(e.baseIndent + 4);
          u < i && Hy(o, u, i);
        }
      }
    return s.length && (s = s.filter((u) => u.type != Wt.CodeText), s.length && (e.markers = s.concat(e.markers))), t.addNode(t.buffer.writeElements(o, -a).finish(Wt.CodeBlock, i - a), a), !0;
  },
  FencedCode(t, e) {
    let n = Coe(e);
    if (n < 0)
      return !1;
    let r = t.lineStart + e.pos, a = e.next, i = n - e.pos, o = e.skipSpace(n), s = Bq(e.text, e.text.length, o), u = [qr(Wt.CodeMark, r, r + i)];
    o < s && u.push(qr(Wt.CodeInfo, t.lineStart + o, t.lineStart + s));
    for (let f = !0; t.nextLine() && e.depth >= t.stack.length; f = !1) {
      let p = e.pos;
      if (e.indent - e.baseIndent < 4)
        for (; p < e.text.length && e.text.charCodeAt(p) == a; )
          p++;
      if (p - e.pos >= i && e.skipSpace(p) == e.text.length) {
        for (let m of e.markers)
          u.push(m);
        u.push(qr(Wt.CodeMark, t.lineStart + e.pos, t.lineStart + p)), t.nextLine();
        break;
      } else {
        f || Hy(u, t.lineStart - 1, t.lineStart);
        for (let O of e.markers)
          u.push(O);
        let m = t.lineStart + e.basePos, v = t.lineStart + e.text.length;
        m < v && Hy(u, m, v);
      }
    }
    return t.addNode(t.buffer.writeElements(u, -r).finish(Wt.FencedCode, t.prevLineEnd() - r), r), !0;
  },
  Blockquote(t, e) {
    let n = xoe(e);
    return n < 0 ? !1 : (t.startContext(Wt.Blockquote, e.pos), t.addNode(Wt.QuoteMark, t.lineStart + e.pos, t.lineStart + e.pos + 1), e.moveBase(e.pos + n), null);
  },
  HorizontalRule(t, e) {
    if (p6(e, t, !1) < 0)
      return !1;
    let n = t.lineStart + e.pos;
    return t.nextLine(), t.addNode(Wt.HorizontalRule, n), !0;
  },
  BulletList(t, e) {
    let n = h6(e, t, !1);
    if (n < 0)
      return !1;
    t.block.type != Wt.BulletList && t.startContext(Wt.BulletList, e.basePos, e.next);
    let r = Uq(e, e.pos + 1);
    return t.startContext(Wt.ListItem, e.basePos, r - e.baseIndent), t.addNode(Wt.ListMark, t.lineStart + e.pos, t.lineStart + e.pos + n), e.moveBaseColumn(r), null;
  },
  OrderedList(t, e) {
    let n = m6(e, t, !1);
    if (n < 0)
      return !1;
    t.block.type != Wt.OrderedList && t.startContext(Wt.OrderedList, e.basePos, e.text.charCodeAt(e.pos + n - 1));
    let r = Uq(e, e.pos + n);
    return t.startContext(Wt.ListItem, e.basePos, r - e.baseIndent), t.addNode(Wt.ListMark, t.lineStart + e.pos, t.lineStart + e.pos + n), e.moveBaseColumn(r), null;
  },
  ATXHeading(t, e) {
    let n = koe(e);
    if (n < 0)
      return !1;
    let r = e.pos, a = t.lineStart + r, i = Bq(e.text, e.text.length, r), o = i;
    for (; o > r && e.text.charCodeAt(o - 1) == e.next; )
      o--;
    (o == i || o == r || !Jf(e.text.charCodeAt(o - 1))) && (o = e.text.length);
    let s = t.buffer.write(Wt.HeaderMark, 0, n).writeElements(t.parser.parseInline(e.text.slice(r + n + 1, o), a + n + 1), -a);
    o < e.text.length && s.write(Wt.HeaderMark, o - r, i - r);
    let u = s.finish(Wt.ATXHeading1 - 1 + n, e.text.length - r);
    return t.nextLine(), t.addNode(u, a), !0;
  },
  HTMLBlock(t, e) {
    let n = Noe(e, t, !1);
    if (n < 0)
      return !1;
    let r = t.lineStart + e.pos, a = U4[n][1], i = [], o = a != B4;
    for (; !a.test(e.text) && t.nextLine(); ) {
      if (e.depth < t.stack.length) {
        o = !1;
        break;
      }
      for (let f of e.markers)
        i.push(f);
    }
    o && t.nextLine();
    let s = a == Ioe ? Wt.CommentBlock : a == Doe ? Wt.ProcessingInstructionBlock : Wt.HTMLBlock, u = t.prevLineEnd();
    return t.addNode(t.buffer.writeElements(i, -r).finish(s, u - r), r), !0;
  },
  SetextHeading: void 0
  // Specifies relative precedence for block-continue function
};
class WMe {
  constructor(e) {
    this.stage = 0, this.elts = [], this.pos = 0, this.start = e.start, this.advance(e.content);
  }
  nextLine(e, n, r) {
    if (this.stage == -1)
      return !1;
    let a = r.content + `
` + n.scrub(), i = this.advance(a);
    return i > -1 && i < a.length ? this.complete(e, r, i) : !1;
  }
  finish(e, n) {
    return (this.stage == 2 || this.stage == 3) && cT(n.content, this.pos) == n.content.length ? this.complete(e, n, n.content.length) : !1;
  }
  complete(e, n, r) {
    return e.addLeafElement(n, qr(Wt.LinkReference, this.start, this.start + r, this.elts)), !0;
  }
  nextStage(e) {
    return e ? (this.pos = e.to - this.start, this.elts.push(e), this.stage++, !0) : (e === !1 && (this.stage = -1), !1);
  }
  advance(e) {
    for (; ; ) {
      if (this.stage == -1)
        return -1;
      if (this.stage == 0) {
        if (!this.nextStage(Hoe(e, this.pos, this.start, !0)))
          return -1;
        if (e.charCodeAt(this.pos) != 58)
          return this.stage = -1;
        this.elts.push(qr(Wt.LinkMark, this.pos + this.start, this.pos + this.start + 1)), this.pos++;
      } else if (this.stage == 1) {
        if (!this.nextStage(Uoe(e, cT(e, this.pos), this.start)))
          return -1;
      } else if (this.stage == 2) {
        let n = cT(e, this.pos), r = 0;
        if (n > this.pos) {
          let a = zoe(e, n, this.start);
          if (a) {
            let i = O3(e, a.to - this.start);
            i > 0 && (this.nextStage(a), r = i);
          }
        }
        return r || (r = O3(e, this.pos)), r > 0 && r < e.length ? r : -1;
      } else
        return O3(e, this.pos);
    }
  }
}
function O3(t, e) {
  for (; e < t.length; e++) {
    let n = t.charCodeAt(e);
    if (n == 10)
      break;
    if (!Jf(n))
      return -1;
  }
  return e;
}
class QMe {
  nextLine(e, n, r) {
    let a = n.depth < e.stack.length ? -1 : Roe(n), i = n.next;
    if (a < 0)
      return !1;
    let o = qr(Wt.HeaderMark, e.lineStart + n.pos, e.lineStart + a);
    return e.nextLine(), e.addLeafElement(r, qr(i == 61 ? Wt.SetextHeading1 : Wt.SetextHeading2, r.start, e.prevLineEnd(), [
      ...e.parser.parseInline(r.content, r.start),
      o
    ])), !0;
  }
  finish() {
    return !1;
  }
}
const jMe = {
  LinkReference(t, e) {
    return e.content.charCodeAt(0) == 91 ? new WMe(e) : null;
  },
  SetextHeading() {
    return new QMe();
  }
}, GMe = [
  (t, e) => koe(e) >= 0,
  (t, e) => Coe(e) >= 0,
  (t, e) => xoe(e) >= 0,
  (t, e) => h6(e, t, !0) >= 0,
  (t, e) => m6(e, t, !0) >= 0,
  (t, e) => p6(e, t, !0) >= 0,
  (t, e) => Noe(e, t, !0) >= 0
], VMe = { text: "", end: 0 };
class YMe {
  /// @internal
  constructor(e, n, r, a) {
    this.parser = e, this.input = n, this.ranges = a, this.line = new HMe(), this.atEnd = !1, this.reusePlaceholders = /* @__PURE__ */ new Map(), this.stoppedAt = null, this.rangeI = 0, this.to = a[a.length - 1].to, this.lineStart = this.absoluteLineStart = this.absoluteLineEnd = a[0].from, this.block = mI.create(Wt.Document, 0, this.lineStart, 0, 0), this.stack = [this.block], this.fragments = r.length ? new KMe(r, n) : null, this.readLine();
  }
  get parsedPos() {
    return this.absoluteLineStart;
  }
  advance() {
    if (this.stoppedAt != null && this.absoluteLineStart > this.stoppedAt)
      return this.finish();
    let { line: e } = this;
    for (; ; ) {
      for (let r = 0; ; ) {
        let a = e.depth < this.stack.length ? this.stack[this.stack.length - 1] : null;
        for (; r < e.markers.length && (!a || e.markers[r].from < a.end); ) {
          let i = e.markers[r++];
          this.addNode(i.type, i.from, i.to);
        }
        if (!a)
          break;
        this.finishContext();
      }
      if (e.pos < e.text.length)
        break;
      if (!this.nextLine())
        return this.finish();
    }
    if (this.fragments && this.reuseFragment(e.basePos))
      return null;
    e:
      for (; ; ) {
        for (let r of this.parser.blockParsers)
          if (r) {
            let a = r(this, e);
            if (a != !1) {
              if (a == !0)
                return null;
              e.forward();
              continue e;
            }
          }
        break;
      }
    let n = new zMe(this.lineStart + e.pos, e.text.slice(e.pos));
    for (let r of this.parser.leafBlockParsers)
      if (r) {
        let a = r(this, n);
        a && n.parsers.push(a);
      }
    e:
      for (; this.nextLine() && e.pos != e.text.length; ) {
        if (e.indent < e.baseIndent + 4) {
          for (let r of this.parser.endLeafBlock)
            if (r(this, e, n))
              break e;
        }
        for (let r of n.parsers)
          if (r.nextLine(this, e, n))
            return null;
        n.content += `
` + e.scrub();
        for (let r of e.markers)
          n.marks.push(r);
      }
    return this.finishLeaf(n), null;
  }
  stopAt(e) {
    if (this.stoppedAt != null && this.stoppedAt < e)
      throw new RangeError("Can't move stoppedAt forward");
    this.stoppedAt = e;
  }
  reuseFragment(e) {
    if (!this.fragments.moveTo(this.absoluteLineStart + e, this.absoluteLineStart) || !this.fragments.matches(this.block.hash))
      return !1;
    let n = this.fragments.takeNodes(this);
    return n ? (this.absoluteLineStart += n, this.lineStart = Woe(this.absoluteLineStart, this.ranges), this.moveRangeI(), this.absoluteLineStart < this.to ? (this.lineStart++, this.absoluteLineStart++, this.readLine()) : (this.atEnd = !0, this.readLine()), !0) : !1;
  }
  /// The number of parent blocks surrounding the current block.
  get depth() {
    return this.stack.length;
  }
  /// Get the type of the parent block at the given depth. When no
  /// depth is passed, return the type of the innermost parent.
  parentType(e = this.depth - 1) {
    return this.parser.nodeSet.types[this.stack[e].type];
  }
  /// Move to the next input line. This should only be called by
  /// (non-composite) [block parsers](#BlockParser.parse) that consume
  /// the line directly, or leaf block parser
  /// [`nextLine`](#LeafBlockParser.nextLine) methods when they
  /// consume the current line (and return true).
  nextLine() {
    return this.lineStart += this.line.text.length, this.absoluteLineEnd >= this.to ? (this.absoluteLineStart = this.absoluteLineEnd, this.atEnd = !0, this.readLine(), !1) : (this.lineStart++, this.absoluteLineStart = this.absoluteLineEnd + 1, this.moveRangeI(), this.readLine(), !0);
  }
  moveRangeI() {
    for (; this.rangeI < this.ranges.length - 1 && this.absoluteLineStart >= this.ranges[this.rangeI].to; )
      this.rangeI++, this.absoluteLineStart = Math.max(this.absoluteLineStart, this.ranges[this.rangeI].from);
  }
  /// @internal
  scanLine(e) {
    let n = VMe;
    if (n.end = e, e >= this.to)
      n.text = "";
    else if (n.text = this.lineChunkAt(e), n.end += n.text.length, this.ranges.length > 1) {
      let r = this.absoluteLineStart, a = this.rangeI;
      for (; this.ranges[a].to < n.end; ) {
        a++;
        let i = this.ranges[a].from, o = this.lineChunkAt(i);
        n.end = i + o.length, n.text = n.text.slice(0, this.ranges[a - 1].to - r) + o, r = n.end - n.text.length;
      }
    }
    return n;
  }
  /// @internal
  readLine() {
    let { line: e } = this, { text: n, end: r } = this.scanLine(this.absoluteLineStart);
    for (this.absoluteLineEnd = r, e.reset(n); e.depth < this.stack.length; e.depth++) {
      let a = this.stack[e.depth], i = this.parser.skipContextMarkup[a.type];
      if (!i)
        throw new Error("Unhandled block context " + Wt[a.type]);
      if (!i(a, this, e))
        break;
      e.forward();
    }
  }
  lineChunkAt(e) {
    let n = this.input.chunk(e), r;
    if (this.input.lineChunks)
      r = n == `
` ? "" : n;
    else {
      let a = n.indexOf(`
`);
      r = a < 0 ? n : n.slice(0, a);
    }
    return e + r.length > this.to ? r.slice(0, this.to - e) : r;
  }
  /// The end position of the previous line.
  prevLineEnd() {
    return this.atEnd ? this.lineStart : this.lineStart - 1;
  }
  /// @internal
  startContext(e, n, r = 0) {
    this.block = mI.create(e, r, this.lineStart + n, this.block.hash, this.lineStart + this.line.text.length), this.stack.push(this.block);
  }
  /// Start a composite block. Should only be called from [block
  /// parser functions](#BlockParser.parse) that return null.
  startComposite(e, n, r = 0) {
    this.startContext(this.parser.getNodeType(e), n, r);
  }
  /// @internal
  addNode(e, n, r) {
    typeof e == "number" && (e = new Pr(this.parser.nodeSet.types[e], XE, XE, (r ?? this.prevLineEnd()) - n)), this.block.addChild(e, n - this.block.from);
  }
  /// Add a block element. Can be called by [block
  /// parsers](#BlockParser.parse).
  addElement(e) {
    this.block.addChild(e.toTree(this.parser.nodeSet), e.from - this.block.from);
  }
  /// Add a block element from a [leaf parser](#LeafBlockParser). This
  /// makes sure any extra composite block markup (such as blockquote
  /// markers) inside the block are also added to the syntax tree.
  addLeafElement(e, n) {
    this.addNode(this.buffer.writeElements(W4(n.children, e.marks), -n.from).finish(n.type, n.to - n.from), n.from);
  }
  /// @internal
  finishContext() {
    let e = this.stack.pop(), n = this.stack[this.stack.length - 1];
    n.addChild(e.toTree(this.parser.nodeSet), e.from - n.from), this.block = n;
  }
  finish() {
    for (; this.stack.length > 1; )
      this.finishContext();
    return this.addGaps(this.block.toTree(this.parser.nodeSet, this.lineStart));
  }
  addGaps(e) {
    return this.ranges.length > 1 ? Poe(this.ranges, 0, e.topNode, this.ranges[0].from, this.reusePlaceholders) : e;
  }
  /// @internal
  finishLeaf(e) {
    for (let r of e.parsers)
      if (r.finish(this, e))
        return;
    let n = W4(this.parser.parseInline(e.content, e.start), e.marks);
    this.addNode(this.buffer.writeElements(n, -e.start).finish(Wt.Paragraph, e.content.length), e.start);
  }
  elt(e, n, r, a) {
    return typeof e == "string" ? qr(this.parser.getNodeType(e), n, r, a) : new Foe(e, n);
  }
  /// @internal
  get buffer() {
    return new Moe(this.parser.nodeSet);
  }
}
function Poe(t, e, n, r, a) {
  let i = t[e].to, o = [], s = [], u = n.from + r;
  function f(p, m) {
    for (; m ? p >= i : p > i; ) {
      let v = t[e + 1].from - i;
      r += v, p += v, e++, i = t[e].to;
    }
  }
  for (let p = n.firstChild; p; p = p.nextSibling) {
    f(p.from + r, !0);
    let m = p.from + r, v, O = a.get(p.tree);
    O ? v = O : p.to + r > i ? (v = Poe(t, e, p, r, a), f(p.to + r, !1)) : v = p.toTree(), o.push(v), s.push(m - u);
  }
  return f(n.to + r, !1), new Pr(n.type, o, s, n.to + r - u, n.tree ? n.tree.propValues : void 0);
}
class _D extends OD {
  /// @internal
  constructor(e, n, r, a, i, o, s, u, f) {
    super(), this.nodeSet = e, this.blockParsers = n, this.leafBlockParsers = r, this.blockNames = a, this.endLeafBlock = i, this.skipContextMarkup = o, this.inlineParsers = s, this.inlineNames = u, this.wrappers = f, this.nodeTypes = /* @__PURE__ */ Object.create(null);
    for (let p of e.types)
      this.nodeTypes[p.name] = p.id;
  }
  createParse(e, n, r) {
    let a = new YMe(this, e, n, r);
    for (let i of this.wrappers)
      a = i(a, e, n, r);
    return a;
  }
  /// Reconfigure the parser.
  configure(e) {
    let n = z4(e);
    if (!n)
      return this;
    let { nodeSet: r, skipContextMarkup: a } = this, i = this.blockParsers.slice(), o = this.leafBlockParsers.slice(), s = this.blockNames.slice(), u = this.inlineParsers.slice(), f = this.inlineNames.slice(), p = this.endLeafBlock.slice(), m = this.wrappers;
    if (ww(n.defineNodes)) {
      a = Object.assign({}, a);
      let v = r.types.slice(), O;
      for (let w of n.defineNodes) {
        let { name: _, block: C, composite: A, style: N } = typeof w == "string" ? { name: w } : w;
        if (v.some((D) => D.name == _))
          continue;
        A && (a[v.length] = (D, M, H) => A(M, H, D.value));
        let P = v.length, I = A ? ["Block", "BlockContext"] : C ? P >= Wt.ATXHeading1 && P <= Wt.SetextHeading2 ? ["Block", "LeafBlock", "Heading"] : ["Block", "LeafBlock"] : void 0;
        v.push(Po.define({
          id: P,
          name: _,
          props: I && [[nr.group, I]]
        })), N && (O || (O = {}), Array.isArray(N) || N instanceof zd ? O[_] = N : Object.assign(O, N));
      }
      r = new u1(v), O && (r = r.extend(c1(O)));
    }
    if (ww(n.props) && (r = r.extend(...n.props)), ww(n.remove))
      for (let v of n.remove) {
        let O = this.blockNames.indexOf(v), w = this.inlineNames.indexOf(v);
        O > -1 && (i[O] = o[O] = void 0), w > -1 && (u[w] = void 0);
      }
    if (ww(n.parseBlock))
      for (let v of n.parseBlock) {
        let O = s.indexOf(v.name);
        if (O > -1)
          i[O] = v.parse, o[O] = v.leaf;
        else {
          let w = v.before ? rA(s, v.before) : v.after ? rA(s, v.after) + 1 : s.length - 1;
          i.splice(w, 0, v.parse), o.splice(w, 0, v.leaf), s.splice(w, 0, v.name);
        }
        v.endLeaf && p.push(v.endLeaf);
      }
    if (ww(n.parseInline))
      for (let v of n.parseInline) {
        let O = f.indexOf(v.name);
        if (O > -1)
          u[O] = v.parse;
        else {
          let w = v.before ? rA(f, v.before) : v.after ? rA(f, v.after) + 1 : f.length - 1;
          u.splice(w, 0, v.parse), f.splice(w, 0, v.name);
        }
      }
    return n.wrap && (m = m.concat(n.wrap)), new _D(r, i, o, s, p, a, u, f, m);
  }
  /// @internal
  getNodeType(e) {
    let n = this.nodeTypes[e];
    if (n == null)
      throw new RangeError(`Unknown node type '${e}'`);
    return n;
  }
  /// Parse the given piece of inline text at the given offset,
  /// returning an array of [`Element`](#Element) objects representing
  /// the inline content.
  parseInline(e, n) {
    let r = new XMe(this, e, n);
    e:
      for (let a = n; a < r.end; ) {
        let i = r.char(a);
        for (let o of this.inlineParsers)
          if (o) {
            let s = o(r, i, a);
            if (s >= 0) {
              a = s;
              continue e;
            }
          }
        a++;
      }
    return r.resolveMarkers(0);
  }
}
function ww(t) {
  return t != null && t.length > 0;
}
function z4(t) {
  if (!Array.isArray(t))
    return t;
  if (t.length == 0)
    return null;
  let e = z4(t[0]);
  if (t.length == 1)
    return e;
  let n = z4(t.slice(1));
  if (!n || !e)
    return e || n;
  let r = (o, s) => (o || XE).concat(s || XE), a = e.wrap, i = n.wrap;
  return {
    props: r(e.props, n.props),
    defineNodes: r(e.defineNodes, n.defineNodes),
    parseBlock: r(e.parseBlock, n.parseBlock),
    parseInline: r(e.parseInline, n.parseInline),
    remove: r(e.remove, n.remove),
    wrap: a ? i ? (o, s, u, f) => a(i(o, s, u, f), s, u, f) : a : i
  };
}
function rA(t, e) {
  let n = t.indexOf(e);
  if (n < 0)
    throw new RangeError(`Position specified relative to unknown parser ${e}`);
  return n;
}
let Loe = [Po.none];
for (let t = 1, e; e = Wt[t]; t++)
  Loe[t] = Po.define({
    id: t,
    name: e,
    props: t >= Wt.Escape ? [] : [[nr.group, t in _oe ? ["Block", "BlockContext"] : ["Block", "LeafBlock"]]],
    top: e == "Document"
  });
const XE = [];
class Moe {
  constructor(e) {
    this.nodeSet = e, this.content = [], this.nodes = [];
  }
  write(e, n, r, a = 0) {
    return this.content.push(e, n, r, 4 + a * 4), this;
  }
  writeElements(e, n = 0) {
    for (let r of e)
      r.writeTo(this, n);
    return this;
  }
  finish(e, n) {
    return Pr.build({
      buffer: this.content,
      nodeSet: this.nodeSet,
      reused: this.nodes,
      topID: e,
      length: n
    });
  }
}
let KT = class {
  /// @internal
  constructor(e, n, r, a = XE) {
    this.type = e, this.from = n, this.to = r, this.children = a;
  }
  /// @internal
  writeTo(e, n) {
    let r = e.content.length;
    e.writeElements(this.children, n), e.content.push(this.type, this.from + n, this.to + n, e.content.length + 4 - r);
  }
  /// @internal
  toTree(e) {
    return new Moe(e).writeElements(this.children, -this.from).finish(this.type, this.to - this.from);
  }
};
class Foe {
  constructor(e, n) {
    this.tree = e, this.from = n;
  }
  get to() {
    return this.from + this.tree.length;
  }
  get type() {
    return this.tree.type.id;
  }
  get children() {
    return XE;
  }
  writeTo(e, n) {
    e.nodes.push(this.tree), e.content.push(e.nodes.length - 1, this.from + n, this.to + n, -1);
  }
  toTree() {
    return this.tree;
  }
}
function qr(t, e, n, r) {
  return new KT(t, e, n, r);
}
const $oe = { resolve: "Emphasis", mark: "EmphasisMark" }, Boe = { resolve: "Emphasis", mark: "EmphasisMark" }, uE = {}, H4 = {};
class Ff {
  constructor(e, n, r, a) {
    this.type = e, this.from = n, this.to = r, this.side = a;
  }
}
const zq = "!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~";
let JT = /[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~\xA1\u2010-\u2027]/;
try {
  JT = new RegExp("[\\p{Pc}|\\p{Pd}|\\p{Pe}|\\p{Pf}|\\p{Pi}|\\p{Po}|\\p{Ps}]", "u");
} catch {
}
const E3 = {
  Escape(t, e, n) {
    if (e != 92 || n == t.end - 1)
      return -1;
    let r = t.char(n + 1);
    for (let a = 0; a < zq.length; a++)
      if (zq.charCodeAt(a) == r)
        return t.append(qr(Wt.Escape, n, n + 2));
    return -1;
  },
  Entity(t, e, n) {
    if (e != 38)
      return -1;
    let r = /^(?:#\d+|#x[a-f\d]+|\w+);/i.exec(t.slice(n + 1, n + 31));
    return r ? t.append(qr(Wt.Entity, n, n + 1 + r[0].length)) : -1;
  },
  InlineCode(t, e, n) {
    if (e != 96 || n && t.char(n - 1) == 96)
      return -1;
    let r = n + 1;
    for (; r < t.end && t.char(r) == 96; )
      r++;
    let a = r - n, i = 0;
    for (; r < t.end; r++)
      if (t.char(r) == 96) {
        if (i++, i == a && t.char(r + 1) != 96)
          return t.append(qr(Wt.InlineCode, n, r + 1, [
            qr(Wt.CodeMark, n, n + a),
            qr(Wt.CodeMark, r + 1 - a, r + 1)
          ]));
      } else
        i = 0;
    return -1;
  },
  HTMLTag(t, e, n) {
    if (e != 60 || n == t.end - 1)
      return -1;
    let r = t.slice(n + 1, t.end), a = /^(?:[a-z][-\w+.]+:[^\s>]+|[a-z\d.!#$%&'*+/=?^_`{|}~-]+@[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?(?:\.[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?)*)>/i.exec(r);
    if (a)
      return t.append(qr(Wt.Autolink, n, n + 1 + a[0].length, [
        qr(Wt.LinkMark, n, n + 1),
        // url[0] includes the closing bracket, so exclude it from this slice
        qr(Wt.URL, n + 1, n + a[0].length),
        qr(Wt.LinkMark, n + a[0].length, n + 1 + a[0].length)
      ]));
    let i = /^!--[^>](?:-[^-]|[^-])*?-->/i.exec(r);
    if (i)
      return t.append(qr(Wt.Comment, n, n + 1 + i[0].length));
    let o = /^\?[^]*?\?>/.exec(r);
    if (o)
      return t.append(qr(Wt.ProcessingInstruction, n, n + 1 + o[0].length));
    let s = /^(?:![A-Z][^]*?>|!\[CDATA\[[^]*?\]\]>|\/\s*[a-zA-Z][\w-]*\s*>|\s*[a-zA-Z][\w-]*(\s+[a-zA-Z:_][\w-.:]*(?:\s*=\s*(?:[^\s"'=<>`]+|'[^']*'|"[^"]*"))?)*\s*(\/\s*)?>)/.exec(r);
    return s ? t.append(qr(Wt.HTMLTag, n, n + 1 + s[0].length)) : -1;
  },
  Emphasis(t, e, n) {
    if (e != 95 && e != 42)
      return -1;
    let r = n + 1;
    for (; t.char(r) == e; )
      r++;
    let a = t.slice(n - 1, n), i = t.slice(r, r + 1), o = JT.test(a), s = JT.test(i), u = /\s|^$/.test(a), f = /\s|^$/.test(i), p = !f && (!s || u || o), m = !u && (!o || f || s), v = p && (e == 42 || !m || o), O = m && (e == 42 || !p || s);
    return t.append(new Ff(e == 95 ? $oe : Boe, n, r, (v ? 1 : 0) | (O ? 2 : 0)));
  },
  HardBreak(t, e, n) {
    if (e == 92 && t.char(n + 1) == 10)
      return t.append(qr(Wt.HardBreak, n, n + 2));
    if (e == 32) {
      let r = n + 1;
      for (; t.char(r) == 32; )
        r++;
      if (t.char(r) == 10 && r >= n + 2)
        return t.append(qr(Wt.HardBreak, n, r + 1));
    }
    return -1;
  },
  Link(t, e, n) {
    return e == 91 ? t.append(new Ff(
      uE,
      n,
      n + 1,
      1
      /* Mark.Open */
    )) : -1;
  },
  Image(t, e, n) {
    return e == 33 && t.char(n + 1) == 91 ? t.append(new Ff(
      H4,
      n,
      n + 2,
      1
      /* Mark.Open */
    )) : -1;
  },
  LinkEnd(t, e, n) {
    if (e != 93)
      return -1;
    for (let r = t.parts.length - 1; r >= 0; r--) {
      let a = t.parts[r];
      if (a instanceof Ff && (a.type == uE || a.type == H4)) {
        if (!a.side || t.skipSpace(a.to) == n && !/[(\[]/.test(t.slice(n + 1, n + 2)))
          return t.parts[r] = null, -1;
        let i = t.takeContent(r), o = t.parts[r] = ZMe(t, i, a.type == uE ? Wt.Link : Wt.Image, a.from, n + 1);
        if (a.type == uE)
          for (let s = 0; s < r; s++) {
            let u = t.parts[s];
            u instanceof Ff && u.type == uE && (u.side = 0);
          }
        return o.to;
      }
    }
    return -1;
  }
};
function ZMe(t, e, n, r, a) {
  let { text: i } = t, o = t.char(a), s = a;
  if (e.unshift(qr(Wt.LinkMark, r, r + (n == Wt.Image ? 2 : 1))), e.push(qr(Wt.LinkMark, a - 1, a)), o == 40) {
    let u = t.skipSpace(a + 1), f = Uoe(i, u - t.offset, t.offset), p;
    f && (u = t.skipSpace(f.to), u != f.to && (p = zoe(i, u - t.offset, t.offset), p && (u = t.skipSpace(p.to)))), t.char(u) == 41 && (e.push(qr(Wt.LinkMark, a, a + 1)), s = u + 1, f && e.push(f), p && e.push(p), e.push(qr(Wt.LinkMark, u, s)));
  } else if (o == 91) {
    let u = Hoe(i, a - t.offset, t.offset, !1);
    u && (e.push(u), s = u.to);
  }
  return qr(n, r, s, e);
}
function Uoe(t, e, n) {
  if (t.charCodeAt(e) == 60) {
    for (let a = e + 1; a < t.length; a++) {
      let i = t.charCodeAt(a);
      if (i == 62)
        return qr(Wt.URL, e + n, a + 1 + n);
      if (i == 60 || i == 10)
        return !1;
    }
    return null;
  } else {
    let a = 0, i = e;
    for (let o = !1; i < t.length; i++) {
      let s = t.charCodeAt(i);
      if (Jf(s))
        break;
      if (o)
        o = !1;
      else if (s == 40)
        a++;
      else if (s == 41) {
        if (!a)
          break;
        a--;
      } else
        s == 92 && (o = !0);
    }
    return i > e ? qr(Wt.URL, e + n, i + n) : i == t.length ? null : !1;
  }
}
function zoe(t, e, n) {
  let r = t.charCodeAt(e);
  if (r != 39 && r != 34 && r != 40)
    return !1;
  let a = r == 40 ? 41 : r;
  for (let i = e + 1, o = !1; i < t.length; i++) {
    let s = t.charCodeAt(i);
    if (o)
      o = !1;
    else {
      if (s == a)
        return qr(Wt.LinkTitle, e + n, i + 1 + n);
      s == 92 && (o = !0);
    }
  }
  return null;
}
function Hoe(t, e, n, r) {
  for (let a = !1, i = e + 1, o = Math.min(t.length, i + 999); i < o; i++) {
    let s = t.charCodeAt(i);
    if (a)
      a = !1;
    else {
      if (s == 93)
        return r ? !1 : qr(Wt.LinkLabel, e + n, i + 1 + n);
      if (r && !Jf(s) && (r = !1), s == 91)
        return !1;
      s == 92 && (a = !0);
    }
  }
  return null;
}
class XMe {
  /// @internal
  constructor(e, n, r) {
    this.parser = e, this.text = n, this.offset = r, this.parts = [];
  }
  /// Get the character code at the given (document-relative)
  /// position.
  char(e) {
    return e >= this.end ? -1 : this.text.charCodeAt(e - this.offset);
  }
  /// The position of the end of this inline section.
  get end() {
    return this.offset + this.text.length;
  }
  /// Get a substring of this inline section. Again uses
  /// document-relative positions.
  slice(e, n) {
    return this.text.slice(e - this.offset, n - this.offset);
  }
  /// @internal
  append(e) {
    return this.parts.push(e), e.to;
  }
  /// Add a [delimiter](#DelimiterType) at this given position. `open`
  /// and `close` indicate whether this delimiter is opening, closing,
  /// or both. Returns the end of the delimiter, for convenient
  /// returning from [parse functions](#InlineParser.parse).
  addDelimiter(e, n, r, a, i) {
    return this.append(new Ff(e, n, r, (a ? 1 : 0) | (i ? 2 : 0)));
  }
  /// Returns true when there is an unmatched link or image opening
  /// token before the current position.
  get hasOpenLink() {
    for (let e = this.parts.length - 1; e >= 0; e--) {
      let n = this.parts[e];
      if (n instanceof Ff && (n.type == uE || n.type == H4))
        return !0;
    }
    return !1;
  }
  /// Add an inline element. Returns the end of the element.
  addElement(e) {
    return this.append(e);
  }
  /// Resolve markers between this.parts.length and from, wrapping matched markers in the
  /// appropriate node and updating the content of this.parts. @internal
  resolveMarkers(e) {
    for (let r = e; r < this.parts.length; r++) {
      let a = this.parts[r];
      if (!(a instanceof Ff && a.type.resolve && a.side & 2))
        continue;
      let i = a.type == $oe || a.type == Boe, o = a.to - a.from, s, u = r - 1;
      for (; u >= e; u--) {
        let _ = this.parts[u];
        if (_ instanceof Ff && _.side & 1 && _.type == a.type && // Ignore emphasis delimiters where the character count doesn't match
        !(i && (a.side & 1 || _.side & 2) && (_.to - _.from + o) % 3 == 0 && ((_.to - _.from) % 3 || o % 3))) {
          s = _;
          break;
        }
      }
      if (!s)
        continue;
      let f = a.type.resolve, p = [], m = s.from, v = a.to;
      if (i) {
        let _ = Math.min(2, s.to - s.from, o);
        m = s.to - _, v = a.from + _, f = _ == 1 ? "Emphasis" : "StrongEmphasis";
      }
      s.type.mark && p.push(this.elt(s.type.mark, m, s.to));
      for (let _ = u + 1; _ < r; _++)
        this.parts[_] instanceof KT && p.push(this.parts[_]), this.parts[_] = null;
      a.type.mark && p.push(this.elt(a.type.mark, a.from, v));
      let O = this.elt(f, m, v, p);
      this.parts[u] = i && s.from != m ? new Ff(s.type, s.from, m, s.side) : null, (this.parts[r] = i && a.to != v ? new Ff(a.type, v, a.to, a.side) : null) ? this.parts.splice(r, 0, O) : this.parts[r] = O;
    }
    let n = [];
    for (let r = e; r < this.parts.length; r++) {
      let a = this.parts[r];
      a instanceof KT && n.push(a);
    }
    return n;
  }
  /// Find an opening delimiter of the given type. Returns `null` if
  /// no delimiter is found, or an index that can be passed to
  /// [`takeContent`](#InlineContext.takeContent) otherwise.
  findOpeningDelimiter(e) {
    for (let n = this.parts.length - 1; n >= 0; n--) {
      let r = this.parts[n];
      if (r instanceof Ff && r.type == e)
        return n;
    }
    return null;
  }
  /// Remove all inline elements and delimiters starting from the
  /// given index (which you should get from
  /// [`findOpeningDelimiter`](#InlineContext.findOpeningDelimiter),
  /// resolve delimiters inside of them, and return them as an array
  /// of elements.
  takeContent(e) {
    let n = this.resolveMarkers(e);
    return this.parts.length = e, n;
  }
  /// Skip space after the given (document) position, returning either
  /// the position of the next non-space character or the end of the
  /// section.
  skipSpace(e) {
    return cT(this.text, e - this.offset) + this.offset;
  }
  elt(e, n, r, a) {
    return typeof e == "string" ? qr(this.parser.getNodeType(e), n, r, a) : new Foe(e, n);
  }
}
function W4(t, e) {
  if (!e.length)
    return t;
  if (!t.length)
    return e;
  let n = t.slice(), r = 0;
  for (let a of e) {
    for (; r < n.length && n[r].to < a.to; )
      r++;
    if (r < n.length && n[r].from < a.from) {
      let i = n[r];
      i instanceof KT && (n[r] = new KT(i.type, i.from, i.to, W4(i.children, [a])));
    } else
      n.splice(r++, 0, a);
  }
  return n;
}
const qMe = [Wt.CodeBlock, Wt.ListItem, Wt.OrderedList, Wt.BulletList];
let KMe = class {
  constructor(e, n) {
    this.fragments = e, this.input = n, this.i = 0, this.fragment = null, this.fragmentEnd = -1, this.cursor = null, e.length && (this.fragment = e[this.i++]);
  }
  nextFragment() {
    this.fragment = this.i < this.fragments.length ? this.fragments[this.i++] : null, this.cursor = null, this.fragmentEnd = -1;
  }
  moveTo(e, n) {
    for (; this.fragment && this.fragment.to <= e; )
      this.nextFragment();
    if (!this.fragment || this.fragment.from > (e ? e - 1 : 0))
      return !1;
    if (this.fragmentEnd < 0) {
      let i = this.fragment.to;
      for (; i > 0 && this.input.read(i - 1, i) != `
`; )
        i--;
      this.fragmentEnd = i ? i - 1 : 0;
    }
    let r = this.cursor;
    r || (r = this.cursor = this.fragment.tree.cursor(), r.firstChild());
    let a = e + this.fragment.offset;
    for (; r.to <= a; )
      if (!r.parent())
        return !1;
    for (; ; ) {
      if (r.from >= a)
        return this.fragment.from <= n;
      if (!r.childAfter(a))
        return !1;
    }
  }
  matches(e) {
    let n = this.cursor.tree;
    return n && n.prop(nr.contextHash) == e;
  }
  takeNodes(e) {
    let n = this.cursor, r = this.fragment.offset, a = this.fragmentEnd - (this.fragment.openEnd ? 1 : 0), i = e.absoluteLineStart, o = i, s = e.block.children.length, u = o, f = s;
    for (; ; ) {
      if (n.to - r > a) {
        if (n.type.isAnonymous && n.firstChild())
          continue;
        break;
      }
      let p = Woe(n.from - r, e.ranges);
      if (n.to - r <= e.ranges[e.rangeI].to)
        e.addNode(n.tree, p);
      else {
        let m = new Pr(e.parser.nodeSet.types[Wt.Paragraph], [], [], 0, e.block.hashProp);
        e.reusePlaceholders.set(m, n.tree), e.addNode(m, p);
      }
      if (n.type.is("Block") && (qMe.indexOf(n.type.id) < 0 ? (o = n.to - r, s = e.block.children.length) : (o = u, s = f, u = n.to - r, f = e.block.children.length)), !n.nextSibling())
        break;
    }
    for (; e.block.children.length > s; )
      e.block.children.pop(), e.block.positions.pop();
    return o - i;
  }
};
function Woe(t, e) {
  let n = t;
  for (let r = 1; r < e.length; r++) {
    let a = e[r - 1].to, i = e[r].from;
    a < t && (n -= i - a);
  }
  return n;
}
const JMe = c1({
  "Blockquote/...": ge.quote,
  HorizontalRule: ge.contentSeparator,
  "ATXHeading1/... SetextHeading1/...": ge.heading1,
  "ATXHeading2/... SetextHeading2/...": ge.heading2,
  "ATXHeading3/...": ge.heading3,
  "ATXHeading4/...": ge.heading4,
  "ATXHeading5/...": ge.heading5,
  "ATXHeading6/...": ge.heading6,
  "Comment CommentBlock": ge.comment,
  Escape: ge.escape,
  Entity: ge.character,
  "Emphasis/...": ge.emphasis,
  "StrongEmphasis/...": ge.strong,
  "Link/... Image/...": ge.link,
  "OrderedList/... BulletList/...": ge.list,
  "BlockQuote/...": ge.quote,
  "InlineCode CodeText": ge.monospace,
  "URL Autolink": ge.url,
  "HeaderMark HardBreak QuoteMark ListMark LinkMark EmphasisMark CodeMark": ge.processingInstruction,
  "CodeInfo LinkLabel": ge.labelName,
  LinkTitle: ge.string,
  Paragraph: ge.content
}), e3e = new _D(new u1(Loe).extend(JMe), Object.keys(nA).map((t) => nA[t]), Object.keys(nA).map((t) => jMe[t]), Object.keys(nA), GMe, _oe, Object.keys(E3).map((t) => E3[t]), Object.keys(E3), []);
function t3e(t, e, n) {
  let r = [];
  for (let a = t.firstChild, i = e; ; a = a.nextSibling) {
    let o = a ? a.from : n;
    if (o > i && r.push({ from: i, to: o }), !a)
      break;
    i = a.to;
  }
  return r;
}
function n3e(t) {
  let { codeParser: e, htmlParser: n } = t;
  return { wrap: Hie((a, i) => {
    let o = a.type.id;
    if (e && (o == Wt.CodeBlock || o == Wt.FencedCode)) {
      let s = "";
      if (o == Wt.FencedCode) {
        let f = a.node.getChild(Wt.CodeInfo);
        f && (s = i.read(f.from, f.to));
      }
      let u = e(s);
      if (u)
        return { parser: u, overlay: (f) => f.type.id == Wt.CodeText };
    } else if (n && (o == Wt.HTMLBlock || o == Wt.HTMLTag))
      return { parser: n, overlay: t3e(a.node, a.from, a.to) };
    return null;
  }) };
}
const r3e = { resolve: "Strikethrough", mark: "StrikethroughMark" }, a3e = {
  defineNodes: [{
    name: "Strikethrough",
    style: { "Strikethrough/...": ge.strikethrough }
  }, {
    name: "StrikethroughMark",
    style: ge.processingInstruction
  }],
  parseInline: [{
    name: "Strikethrough",
    parse(t, e, n) {
      if (e != 126 || t.char(n + 1) != 126 || t.char(n + 2) == 126)
        return -1;
      let r = t.slice(n - 1, n), a = t.slice(n + 2, n + 3), i = /\s|^$/.test(r), o = /\s|^$/.test(a), s = JT.test(r), u = JT.test(a);
      return t.addDelimiter(r3e, n, n + 2, !o && (!u || i || s), !i && (!s || o || u));
    },
    after: "Emphasis"
  }]
};
function fT(t, e, n = 0, r, a = 0) {
  let i = 0, o = !0, s = -1, u = -1, f = !1, p = () => {
    r.push(t.elt("TableCell", a + s, a + u, t.parser.parseInline(e.slice(s, u), a + s)));
  };
  for (let m = n; m < e.length; m++) {
    let v = e.charCodeAt(m);
    v == 124 && !f ? ((!o || s > -1) && i++, o = !1, r && (s > -1 && p(), r.push(t.elt("TableDelimiter", m + a, m + a + 1))), s = u = -1) : (f || v != 32 && v != 9) && (s < 0 && (s = m), u = m + 1), f = !f && v == 92;
  }
  return s > -1 && (i++, r && p()), i;
}
function Hq(t, e) {
  for (let n = e; n < t.length; n++) {
    let r = t.charCodeAt(n);
    if (r == 124)
      return !0;
    r == 92 && n++;
  }
  return !1;
}
const Qoe = /^\|?(\s*:?-+:?\s*\|)+(\s*:?-+:?\s*)?$/;
class Wq {
  constructor() {
    this.rows = null;
  }
  nextLine(e, n, r) {
    if (this.rows == null) {
      this.rows = !1;
      let a;
      if ((n.next == 45 || n.next == 58 || n.next == 124) && Qoe.test(a = n.text.slice(n.pos))) {
        let i = [];
        fT(e, r.content, 0, i, r.start) == fT(e, a, n.pos) && (this.rows = [
          e.elt("TableHeader", r.start, r.start + r.content.length, i),
          e.elt("TableDelimiter", e.lineStart + n.pos, e.lineStart + n.text.length)
        ]);
      }
    } else if (this.rows) {
      let a = [];
      fT(e, n.text, n.pos, a, e.lineStart), this.rows.push(e.elt("TableRow", e.lineStart + n.pos, e.lineStart + n.text.length, a));
    }
    return !1;
  }
  finish(e, n) {
    return this.rows ? (e.addLeafElement(n, e.elt("Table", n.start, n.start + n.content.length, this.rows)), !0) : !1;
  }
}
const i3e = {
  defineNodes: [
    { name: "Table", block: !0 },
    { name: "TableHeader", style: { "TableHeader/...": ge.heading } },
    "TableRow",
    { name: "TableCell", style: ge.content },
    { name: "TableDelimiter", style: ge.processingInstruction }
  ],
  parseBlock: [{
    name: "Table",
    leaf(t, e) {
      return Hq(e.content, 0) ? new Wq() : null;
    },
    endLeaf(t, e, n) {
      if (n.parsers.some((a) => a instanceof Wq) || !Hq(e.text, e.basePos))
        return !1;
      let r = t.scanLine(t.absoluteLineEnd + 1).text;
      return Qoe.test(r) && fT(t, e.text, e.basePos) == fT(t, r, e.basePos);
    },
    before: "SetextHeading"
  }]
};
class o3e {
  nextLine() {
    return !1;
  }
  finish(e, n) {
    return e.addLeafElement(n, e.elt("Task", n.start, n.start + n.content.length, [
      e.elt("TaskMarker", n.start, n.start + 3),
      ...e.parser.parseInline(n.content.slice(3), n.start + 3)
    ])), !0;
  }
}
const s3e = {
  defineNodes: [
    { name: "Task", block: !0, style: ge.list },
    { name: "TaskMarker", style: ge.atom }
  ],
  parseBlock: [{
    name: "TaskList",
    leaf(t, e) {
      return /^\[[ xX]\][ \t]/.test(e.content) && t.parentType().name == "ListItem" ? new o3e() : null;
    },
    after: "SetextHeading"
  }]
}, Qq = /(www\.)|(https?:\/\/)|([\w.+-]+@)|(mailto:|xmpp:)/gy, jq = /[\w-]+(\.[\w-]+)+(\/[^\s<]*)?/gy, l3e = /[\w-]+\.[\w-]+($|\/)/, Gq = /[\w.+-]+@[\w-]+(\.[\w.-]+)+/gy, Vq = /\/[a-zA-Z\d@.]+/gy;
function Yq(t, e, n, r) {
  let a = 0;
  for (let i = e; i < n; i++)
    t[i] == r && a++;
  return a;
}
function u3e(t, e) {
  jq.lastIndex = e;
  let n = jq.exec(t);
  if (!n || l3e.exec(n[0])[0].indexOf("_") > -1)
    return -1;
  let r = e + n[0].length;
  for (; ; ) {
    let a = t[r - 1], i;
    if (/[?!.,:*_~]/.test(a) || a == ")" && Yq(t, e, r, ")") > Yq(t, e, r, "("))
      r--;
    else if (a == ";" && (i = /&(?:#\d+|#x[a-f\d]+|\w+);$/.exec(t.slice(e, r))))
      r = e + i.index;
    else
      break;
  }
  return r;
}
function Zq(t, e) {
  Gq.lastIndex = e;
  let n = Gq.exec(t);
  if (!n)
    return -1;
  let r = n[0][n[0].length - 1];
  return r == "_" || r == "-" ? -1 : e + n[0].length - (r == "." ? 1 : 0);
}
const c3e = {
  parseInline: [{
    name: "Autolink",
    parse(t, e, n) {
      let r = n - t.offset;
      Qq.lastIndex = r;
      let a = Qq.exec(t.text), i = -1;
      if (!a)
        return -1;
      if (a[1] || a[2]) {
        if (i = u3e(t.text, r + a[0].length), i > -1 && t.hasOpenLink) {
          let o = /([^\[\]]|\[[^\]]*\])*/.exec(t.text.slice(r, i));
          i = r + o[0].length;
        }
      } else
        a[3] ? i = Zq(t.text, r) : (i = Zq(t.text, r + a[0].length), i > -1 && a[0] == "xmpp:" && (Vq.lastIndex = i, a = Vq.exec(t.text), a && (i = a.index + a[0].length)));
      return i < 0 ? -1 : (t.addElement(t.elt("URL", n, i + t.offset)), i + t.offset);
    }
  }]
}, f3e = [i3e, s3e, a3e, c3e];
function joe(t, e, n) {
  return (r, a, i) => {
    if (a != t || r.char(i + 1) == t)
      return -1;
    let o = [r.elt(n, i, i + 1)];
    for (let s = i + 1; s < r.end; s++) {
      let u = r.char(s);
      if (u == t)
        return r.addElement(r.elt(e, i, s + 1, o.concat(r.elt(n, s, s + 1))));
      if (u == 92 && o.push(r.elt("Escape", s, s++ + 2)), Jf(u))
        break;
    }
    return -1;
  };
}
const d3e = {
  defineNodes: [
    { name: "Superscript", style: ge.special(ge.content) },
    { name: "SuperscriptMark", style: ge.processingInstruction }
  ],
  parseInline: [{
    name: "Superscript",
    parse: joe(94, "Superscript", "SuperscriptMark")
  }]
}, p3e = {
  defineNodes: [
    { name: "Subscript", style: ge.special(ge.content) },
    { name: "SubscriptMark", style: ge.processingInstruction }
  ],
  parseInline: [{
    name: "Subscript",
    parse: joe(126, "Subscript", "SubscriptMark")
  }]
}, h3e = {
  defineNodes: [{ name: "Emoji", style: ge.character }],
  parseInline: [{
    name: "Emoji",
    parse(t, e, n) {
      let r;
      return e != 58 || !(r = /^[a-zA-Z_0-9]+:/.exec(t.slice(n + 1, t.end))) ? -1 : t.addElement(t.elt("Emoji", n, n + 1 + r[0].length));
    }
  }]
};
class gI {
  /**
  @internal
  */
  constructor(e, n, r, a, i, o, s, u, f, p = 0, m) {
    this.p = e, this.stack = n, this.state = r, this.reducePos = a, this.pos = i, this.score = o, this.buffer = s, this.bufferBase = u, this.curContext = f, this.lookAhead = p, this.parent = m;
  }
  /**
  @internal
  */
  toString() {
    return `[${this.stack.filter((e, n) => n % 3 == 0).concat(this.state)}]@${this.pos}${this.score ? "!" + this.score : ""}`;
  }
  // Start an empty stack
  /**
  @internal
  */
  static start(e, n, r = 0) {
    let a = e.parser.context;
    return new gI(e, [], n, r, r, 0, [], 0, a ? new Xq(a, a.start) : null, 0, null);
  }
  /**
  The stack's current [context](#lr.ContextTracker) value, if
  any. Its type will depend on the context tracker's type
  parameter, or it will be `null` if there is no context
  tracker.
  */
  get context() {
    return this.curContext ? this.curContext.context : null;
  }
  // Push a state onto the stack, tracking its start position as well
  // as the buffer base at that point.
  /**
  @internal
  */
  pushState(e, n) {
    this.stack.push(this.state, n, this.bufferBase + this.buffer.length), this.state = e;
  }
  // Apply a reduce action
  /**
  @internal
  */
  reduce(e) {
    var n;
    let r = e >> 19, a = e & 65535, { parser: i } = this.p, o = i.dynamicPrecedence(a);
    if (o && (this.score += o), r == 0) {
      this.pushState(i.getGoto(this.state, a, !0), this.reducePos), a < i.minRepeatTerm && this.storeNode(a, this.reducePos, this.reducePos, 4, !0), this.reduceContext(a, this.reducePos);
      return;
    }
    let s = this.stack.length - (r - 1) * 3 - (e & 262144 ? 6 : 0), u = s ? this.stack[s - 2] : this.p.ranges[0].from, f = this.reducePos - u;
    f >= 2e3 && !(!((n = this.p.parser.nodeSet.types[a]) === null || n === void 0) && n.isAnonymous) && (u == this.p.lastBigReductionStart ? (this.p.bigReductionCount++, this.p.lastBigReductionSize = f) : this.p.lastBigReductionSize < f && (this.p.bigReductionCount = 1, this.p.lastBigReductionStart = u, this.p.lastBigReductionSize = f));
    let p = s ? this.stack[s - 1] : 0, m = this.bufferBase + this.buffer.length - p;
    if (a < i.minRepeatTerm || e & 131072) {
      let v = i.stateFlag(
        this.state,
        1
        /* StateFlag.Skipped */
      ) ? this.pos : this.reducePos;
      this.storeNode(a, u, v, m + 4, !0);
    }
    if (e & 262144)
      this.state = this.stack[s];
    else {
      let v = this.stack[s - 3];
      this.state = i.getGoto(v, a, !0);
    }
    for (; this.stack.length > s; )
      this.stack.pop();
    this.reduceContext(a, u);
  }
  // Shift a value into the buffer
  /**
  @internal
  */
  storeNode(e, n, r, a = 4, i = !1) {
    if (e == 0 && (!this.stack.length || this.stack[this.stack.length - 1] < this.buffer.length + this.bufferBase)) {
      let o = this, s = this.buffer.length;
      if (s == 0 && o.parent && (s = o.bufferBase - o.parent.bufferBase, o = o.parent), s > 0 && o.buffer[s - 4] == 0 && o.buffer[s - 1] > -1) {
        if (n == r)
          return;
        if (o.buffer[s - 2] >= n) {
          o.buffer[s - 2] = r;
          return;
        }
      }
    }
    if (!i || this.pos == r)
      this.buffer.push(e, n, r, a);
    else {
      let o = this.buffer.length;
      if (o > 0 && this.buffer[o - 4] != 0)
        for (; o > 0 && this.buffer[o - 2] > r; )
          this.buffer[o] = this.buffer[o - 4], this.buffer[o + 1] = this.buffer[o - 3], this.buffer[o + 2] = this.buffer[o - 2], this.buffer[o + 3] = this.buffer[o - 1], o -= 4, a > 4 && (a -= 4);
      this.buffer[o] = e, this.buffer[o + 1] = n, this.buffer[o + 2] = r, this.buffer[o + 3] = a;
    }
  }
  // Apply a shift action
  /**
  @internal
  */
  shift(e, n, r, a) {
    if (e & 131072)
      this.pushState(e & 65535, this.pos);
    else if (e & 262144)
      this.pos = a, this.shiftContext(n, r), n <= this.p.parser.maxNode && this.buffer.push(n, r, a, 4);
    else {
      let i = e, { parser: o } = this.p;
      (a > this.pos || n <= o.maxNode) && (this.pos = a, o.stateFlag(
        i,
        1
        /* StateFlag.Skipped */
      ) || (this.reducePos = a)), this.pushState(i, r), this.shiftContext(n, r), n <= o.maxNode && this.buffer.push(n, r, a, 4);
    }
  }
  // Apply an action
  /**
  @internal
  */
  apply(e, n, r, a) {
    e & 65536 ? this.reduce(e) : this.shift(e, n, r, a);
  }
  // Add a prebuilt (reused) node into the buffer.
  /**
  @internal
  */
  useNode(e, n) {
    let r = this.p.reused.length - 1;
    (r < 0 || this.p.reused[r] != e) && (this.p.reused.push(e), r++);
    let a = this.pos;
    this.reducePos = this.pos = a + e.length, this.pushState(n, a), this.buffer.push(
      r,
      a,
      this.reducePos,
      -1
      /* size == -1 means this is a reused value */
    ), this.curContext && this.updateContext(this.curContext.tracker.reuse(this.curContext.context, e, this, this.p.stream.reset(this.pos - e.length)));
  }
  // Split the stack. Due to the buffer sharing and the fact
  // that `this.stack` tends to stay quite shallow, this isn't very
  // expensive.
  /**
  @internal
  */
  split() {
    let e = this, n = e.buffer.length;
    for (; n > 0 && e.buffer[n - 2] > e.reducePos; )
      n -= 4;
    let r = e.buffer.slice(n), a = e.bufferBase + n;
    for (; e && a == e.bufferBase; )
      e = e.parent;
    return new gI(this.p, this.stack.slice(), this.state, this.reducePos, this.pos, this.score, r, a, this.curContext, this.lookAhead, e);
  }
  // Try to recover from an error by 'deleting' (ignoring) one token.
  /**
  @internal
  */
  recoverByDelete(e, n) {
    let r = e <= this.p.parser.maxNode;
    r && this.storeNode(e, this.pos, n, 4), this.storeNode(0, this.pos, n, r ? 8 : 4), this.pos = this.reducePos = n, this.score -= 190;
  }
  /**
  Check if the given term would be able to be shifted (optionally
  after some reductions) on this stack. This can be useful for
  external tokenizers that want to make sure they only provide a
  given token when it applies.
  */
  canShift(e) {
    for (let n = new m3e(this); ; ) {
      let r = this.p.parser.stateSlot(
        n.state,
        4
        /* ParseState.DefaultReduce */
      ) || this.p.parser.hasAction(n.state, e);
      if (r == 0)
        return !1;
      if (!(r & 65536))
        return !0;
      n.reduce(r);
    }
  }
  // Apply up to Recover.MaxNext recovery actions that conceptually
  // inserts some missing token or rule.
  /**
  @internal
  */
  recoverByInsert(e) {
    if (this.stack.length >= 300)
      return [];
    let n = this.p.parser.nextStates(this.state);
    if (n.length > 8 || this.stack.length >= 120) {
      let a = [];
      for (let i = 0, o; i < n.length; i += 2)
        (o = n[i + 1]) != this.state && this.p.parser.hasAction(o, e) && a.push(n[i], o);
      if (this.stack.length < 120)
        for (let i = 0; a.length < 8 && i < n.length; i += 2) {
          let o = n[i + 1];
          a.some((s, u) => u & 1 && s == o) || a.push(n[i], o);
        }
      n = a;
    }
    let r = [];
    for (let a = 0; a < n.length && r.length < 4; a += 2) {
      let i = n[a + 1];
      if (i == this.state)
        continue;
      let o = this.split();
      o.pushState(i, this.pos), o.storeNode(0, o.pos, o.pos, 4, !0), o.shiftContext(n[a], this.pos), o.reducePos = this.pos, o.score -= 200, r.push(o);
    }
    return r;
  }
  // Force a reduce, if possible. Return false if that can't
  // be done.
  /**
  @internal
  */
  forceReduce() {
    let { parser: e } = this.p, n = e.stateSlot(
      this.state,
      5
      /* ParseState.ForcedReduce */
    );
    if (!(n & 65536))
      return !1;
    if (!e.validAction(this.state, n)) {
      let r = n >> 19, a = n & 65535, i = this.stack.length - r * 3;
      if (i < 0 || e.getGoto(this.stack[i], a, !1) < 0) {
        let o = this.findForcedReduction();
        if (o == null)
          return !1;
        n = o;
      }
      this.storeNode(0, this.pos, this.pos, 4, !0), this.score -= 100;
    }
    return this.reducePos = this.pos, this.reduce(n), !0;
  }
  /**
  Try to scan through the automaton to find some kind of reduction
  that can be applied. Used when the regular ForcedReduce field
  isn't a valid action. @internal
  */
  findForcedReduction() {
    let { parser: e } = this.p, n = [], r = (a, i) => {
      if (!n.includes(a))
        return n.push(a), e.allActions(a, (o) => {
          if (!(o & 393216))
            if (o & 65536) {
              let s = (o >> 19) - i;
              if (s > 1) {
                let u = o & 65535, f = this.stack.length - s * 3;
                if (f >= 0 && e.getGoto(this.stack[f], u, !1) >= 0)
                  return s << 19 | 65536 | u;
              }
            } else {
              let s = r(o, i + 1);
              if (s != null)
                return s;
            }
        });
    };
    return r(this.state, 0);
  }
  /**
  @internal
  */
  forceAll() {
    for (; !this.p.parser.stateFlag(
      this.state,
      2
      /* StateFlag.Accepting */
    ); )
      if (!this.forceReduce()) {
        this.storeNode(0, this.pos, this.pos, 4, !0);
        break;
      }
    return this;
  }
  /**
  Check whether this state has no further actions (assumed to be a direct descendant of the
  top state, since any other states must be able to continue
  somehow). @internal
  */
  get deadEnd() {
    if (this.stack.length != 3)
      return !1;
    let { parser: e } = this.p;
    return e.data[e.stateSlot(
      this.state,
      1
      /* ParseState.Actions */
    )] == 65535 && !e.stateSlot(
      this.state,
      4
      /* ParseState.DefaultReduce */
    );
  }
  /**
  Restart the stack (put it back in its start state). Only safe
  when this.stack.length == 3 (state is directly below the top
  state). @internal
  */
  restart() {
    this.storeNode(0, this.pos, this.pos, 4, !0), this.state = this.stack[0], this.stack.length = 0;
  }
  /**
  @internal
  */
  sameState(e) {
    if (this.state != e.state || this.stack.length != e.stack.length)
      return !1;
    for (let n = 0; n < this.stack.length; n += 3)
      if (this.stack[n] != e.stack[n])
        return !1;
    return !0;
  }
  /**
  Get the parser used by this stack.
  */
  get parser() {
    return this.p.parser;
  }
  /**
  Test whether a given dialect (by numeric ID, as exported from
  the terms file) is enabled.
  */
  dialectEnabled(e) {
    return this.p.parser.dialect.flags[e];
  }
  shiftContext(e, n) {
    this.curContext && this.updateContext(this.curContext.tracker.shift(this.curContext.context, e, this, this.p.stream.reset(n)));
  }
  reduceContext(e, n) {
    this.curContext && this.updateContext(this.curContext.tracker.reduce(this.curContext.context, e, this, this.p.stream.reset(n)));
  }
  /**
  @internal
  */
  emitContext() {
    let e = this.buffer.length - 1;
    (e < 0 || this.buffer[e] != -3) && this.buffer.push(this.curContext.hash, this.pos, this.pos, -3);
  }
  /**
  @internal
  */
  emitLookAhead() {
    let e = this.buffer.length - 1;
    (e < 0 || this.buffer[e] != -4) && this.buffer.push(this.lookAhead, this.pos, this.pos, -4);
  }
  updateContext(e) {
    if (e != this.curContext.context) {
      let n = new Xq(this.curContext.tracker, e);
      n.hash != this.curContext.hash && this.emitContext(), this.curContext = n;
    }
  }
  /**
  @internal
  */
  setLookAhead(e) {
    e > this.lookAhead && (this.emitLookAhead(), this.lookAhead = e);
  }
  /**
  @internal
  */
  close() {
    this.curContext && this.curContext.tracker.strict && this.emitContext(), this.lookAhead > 0 && this.emitLookAhead();
  }
}
class Xq {
  constructor(e, n) {
    this.tracker = e, this.context = n, this.hash = e.strict ? e.hash(n) : 0;
  }
}
class m3e {
  constructor(e) {
    this.start = e, this.state = e.state, this.stack = e.stack, this.base = this.stack.length;
  }
  reduce(e) {
    let n = e & 65535, r = e >> 19;
    r == 0 ? (this.stack == this.start.stack && (this.stack = this.stack.slice()), this.stack.push(this.state, 0, 0), this.base += 3) : this.base -= (r - 1) * 3;
    let a = this.start.p.parser.getGoto(this.stack[this.base - 3], n, !0);
    this.state = a;
  }
}
class bI {
  constructor(e, n, r) {
    this.stack = e, this.pos = n, this.index = r, this.buffer = e.buffer, this.index == 0 && this.maybeNext();
  }
  static create(e, n = e.bufferBase + e.buffer.length) {
    return new bI(e, n, n - e.bufferBase);
  }
  maybeNext() {
    let e = this.stack.parent;
    e != null && (this.index = this.stack.bufferBase - e.bufferBase, this.stack = e, this.buffer = e.buffer);
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  next() {
    this.index -= 4, this.pos -= 4, this.index == 0 && this.maybeNext();
  }
  fork() {
    return new bI(this.stack, this.pos, this.index);
  }
}
function zw(t, e = Uint16Array) {
  if (typeof t != "string")
    return t;
  let n = null;
  for (let r = 0, a = 0; r < t.length; ) {
    let i = 0;
    for (; ; ) {
      let o = t.charCodeAt(r++), s = !1;
      if (o == 126) {
        i = 65535;
        break;
      }
      o >= 92 && o--, o >= 34 && o--;
      let u = o - 32;
      if (u >= 46 && (u -= 46, s = !0), i += u, s)
        break;
      i *= 46;
    }
    n ? n[a++] = i : n = new e(i);
  }
  return n;
}
class Rk {
  constructor() {
    this.start = -1, this.value = -1, this.end = -1, this.extended = -1, this.lookAhead = 0, this.mask = 0, this.context = 0;
  }
}
const qq = new Rk();
class g3e {
  /**
  @internal
  */
  constructor(e, n) {
    this.input = e, this.ranges = n, this.chunk = "", this.chunkOff = 0, this.chunk2 = "", this.chunk2Pos = 0, this.next = -1, this.token = qq, this.rangeIndex = 0, this.pos = this.chunkPos = n[0].from, this.range = n[0], this.end = n[n.length - 1].to, this.readNext();
  }
  /**
  @internal
  */
  resolveOffset(e, n) {
    let r = this.range, a = this.rangeIndex, i = this.pos + e;
    for (; i < r.from; ) {
      if (!a)
        return null;
      let o = this.ranges[--a];
      i -= r.from - o.to, r = o;
    }
    for (; n < 0 ? i > r.to : i >= r.to; ) {
      if (a == this.ranges.length - 1)
        return null;
      let o = this.ranges[++a];
      i += o.from - r.to, r = o;
    }
    return i;
  }
  /**
  @internal
  */
  clipPos(e) {
    if (e >= this.range.from && e < this.range.to)
      return e;
    for (let n of this.ranges)
      if (n.to > e)
        return Math.max(e, n.from);
    return this.end;
  }
  /**
  Look at a code unit near the stream position. `.peek(0)` equals
  `.next`, `.peek(-1)` gives you the previous character, and so
  on.
  
  Note that looking around during tokenizing creates dependencies
  on potentially far-away content, which may reduce the
  effectiveness incremental parsing—when looking forward—or even
  cause invalid reparses when looking backward more than 25 code
  units, since the library does not track lookbehind.
  */
  peek(e) {
    let n = this.chunkOff + e, r, a;
    if (n >= 0 && n < this.chunk.length)
      r = this.pos + e, a = this.chunk.charCodeAt(n);
    else {
      let i = this.resolveOffset(e, 1);
      if (i == null)
        return -1;
      if (r = i, r >= this.chunk2Pos && r < this.chunk2Pos + this.chunk2.length)
        a = this.chunk2.charCodeAt(r - this.chunk2Pos);
      else {
        let o = this.rangeIndex, s = this.range;
        for (; s.to <= r; )
          s = this.ranges[++o];
        this.chunk2 = this.input.chunk(this.chunk2Pos = r), r + this.chunk2.length > s.to && (this.chunk2 = this.chunk2.slice(0, s.to - r)), a = this.chunk2.charCodeAt(0);
      }
    }
    return r >= this.token.lookAhead && (this.token.lookAhead = r + 1), a;
  }
  /**
  Accept a token. By default, the end of the token is set to the
  current stream position, but you can pass an offset (relative to
  the stream position) to change that.
  */
  acceptToken(e, n = 0) {
    let r = n ? this.resolveOffset(n, -1) : this.pos;
    if (r == null || r < this.token.start)
      throw new RangeError("Token end out of bounds");
    this.token.value = e, this.token.end = r;
  }
  /**
  Accept a token ending at a specific given position.
  */
  acceptTokenTo(e, n) {
    this.token.value = e, this.token.end = n;
  }
  getChunk() {
    if (this.pos >= this.chunk2Pos && this.pos < this.chunk2Pos + this.chunk2.length) {
      let { chunk: e, chunkPos: n } = this;
      this.chunk = this.chunk2, this.chunkPos = this.chunk2Pos, this.chunk2 = e, this.chunk2Pos = n, this.chunkOff = this.pos - this.chunkPos;
    } else {
      this.chunk2 = this.chunk, this.chunk2Pos = this.chunkPos;
      let e = this.input.chunk(this.pos), n = this.pos + e.length;
      this.chunk = n > this.range.to ? e.slice(0, this.range.to - this.pos) : e, this.chunkPos = this.pos, this.chunkOff = 0;
    }
  }
  readNext() {
    return this.chunkOff >= this.chunk.length && (this.getChunk(), this.chunkOff == this.chunk.length) ? this.next = -1 : this.next = this.chunk.charCodeAt(this.chunkOff);
  }
  /**
  Move the stream forward N (defaults to 1) code units. Returns
  the new value of [`next`](#lr.InputStream.next).
  */
  advance(e = 1) {
    for (this.chunkOff += e; this.pos + e >= this.range.to; ) {
      if (this.rangeIndex == this.ranges.length - 1)
        return this.setDone();
      e -= this.range.to - this.pos, this.range = this.ranges[++this.rangeIndex], this.pos = this.range.from;
    }
    return this.pos += e, this.pos >= this.token.lookAhead && (this.token.lookAhead = this.pos + 1), this.readNext();
  }
  setDone() {
    return this.pos = this.chunkPos = this.end, this.range = this.ranges[this.rangeIndex = this.ranges.length - 1], this.chunk = "", this.next = -1;
  }
  /**
  @internal
  */
  reset(e, n) {
    if (n ? (this.token = n, n.start = e, n.lookAhead = e + 1, n.value = n.extended = -1) : this.token = qq, this.pos != e) {
      if (this.pos = e, e == this.end)
        return this.setDone(), this;
      for (; e < this.range.from; )
        this.range = this.ranges[--this.rangeIndex];
      for (; e >= this.range.to; )
        this.range = this.ranges[++this.rangeIndex];
      e >= this.chunkPos && e < this.chunkPos + this.chunk.length ? this.chunkOff = e - this.chunkPos : (this.chunk = "", this.chunkOff = 0), this.readNext();
    }
    return this;
  }
  /**
  @internal
  */
  read(e, n) {
    if (e >= this.chunkPos && n <= this.chunkPos + this.chunk.length)
      return this.chunk.slice(e - this.chunkPos, n - this.chunkPos);
    if (e >= this.chunk2Pos && n <= this.chunk2Pos + this.chunk2.length)
      return this.chunk2.slice(e - this.chunk2Pos, n - this.chunk2Pos);
    if (e >= this.range.from && n <= this.range.to)
      return this.input.read(e, n);
    let r = "";
    for (let a of this.ranges) {
      if (a.from >= n)
        break;
      a.to > e && (r += this.input.read(Math.max(a.from, e), Math.min(a.to, n)));
    }
    return r;
  }
}
class IE {
  constructor(e, n) {
    this.data = e, this.id = n;
  }
  token(e, n) {
    let { parser: r } = n.p;
    Goe(this.data, e, n, this.id, r.data, r.tokenPrecTable);
  }
}
IE.prototype.contextual = IE.prototype.fallback = IE.prototype.extend = !1;
class vI {
  constructor(e, n, r) {
    this.precTable = n, this.elseToken = r, this.data = typeof e == "string" ? zw(e) : e;
  }
  token(e, n) {
    let r = e.pos, a = 0;
    for (; ; ) {
      let i = e.next < 0, o = e.resolveOffset(1, 1);
      if (Goe(this.data, e, n, 0, this.data, this.precTable), e.token.value > -1)
        break;
      if (this.elseToken == null)
        return;
      if (i || a++, o == null)
        break;
      e.reset(o, e.token);
    }
    a && (e.reset(r, e.token), e.acceptToken(this.elseToken, a));
  }
}
vI.prototype.contextual = IE.prototype.fallback = IE.prototype.extend = !1;
class Jd {
  /**
  Create a tokenizer. The first argument is the function that,
  given an input stream, scans for the types of tokens it
  recognizes at the stream's position, and calls
  [`acceptToken`](#lr.InputStream.acceptToken) when it finds
  one.
  */
  constructor(e, n = {}) {
    this.token = e, this.contextual = !!n.contextual, this.fallback = !!n.fallback, this.extend = !!n.extend;
  }
}
function Goe(t, e, n, r, a, i) {
  let o = 0, s = 1 << r, { dialect: u } = n.p.parser;
  e:
    for (; s & t[o]; ) {
      let f = t[o + 1];
      for (let O = o + 3; O < f; O += 2)
        if ((t[O + 1] & s) > 0) {
          let w = t[O];
          if (u.allows(w) && (e.token.value == -1 || e.token.value == w || b3e(w, e.token.value, a, i))) {
            e.acceptToken(w);
            break;
          }
        }
      let p = e.next, m = 0, v = t[o + 2];
      if (e.next < 0 && v > m && t[f + v * 3 - 3] == 65535) {
        o = t[f + v * 3 - 1];
        continue e;
      }
      for (; m < v; ) {
        let O = m + v >> 1, w = f + O + (O << 1), _ = t[w], C = t[w + 1] || 65536;
        if (p < _)
          v = O;
        else if (p >= C)
          m = O + 1;
        else {
          o = t[w + 2], e.advance();
          continue e;
        }
      }
      break;
    }
}
function Kq(t, e, n) {
  for (let r = e, a; (a = t[r]) != 65535; r++)
    if (a == n)
      return r - e;
  return -1;
}
function b3e(t, e, n, r) {
  let a = Kq(n, r, e);
  return a < 0 || Kq(n, r, t) < a;
}
const Rc = typeof process < "u" && process.env && /\bparse\b/.test(process.env.LOG);
let S3 = null;
function Jq(t, e, n) {
  let r = t.cursor(ii.IncludeAnonymous);
  for (r.moveTo(e); ; )
    if (!(n < 0 ? r.childBefore(e) : r.childAfter(e)))
      for (; ; ) {
        if ((n < 0 ? r.to < e : r.from > e) && !r.type.isError)
          return n < 0 ? Math.max(0, Math.min(
            r.to - 1,
            e - 25
            /* Safety.Margin */
          )) : Math.min(t.length, Math.max(
            r.from + 1,
            e + 25
            /* Safety.Margin */
          ));
        if (n < 0 ? r.prevSibling() : r.nextSibling())
          break;
        if (!r.parent())
          return n < 0 ? 0 : t.length;
      }
}
class v3e {
  constructor(e, n) {
    this.fragments = e, this.nodeSet = n, this.i = 0, this.fragment = null, this.safeFrom = -1, this.safeTo = -1, this.trees = [], this.start = [], this.index = [], this.nextFragment();
  }
  nextFragment() {
    let e = this.fragment = this.i == this.fragments.length ? null : this.fragments[this.i++];
    if (e) {
      for (this.safeFrom = e.openStart ? Jq(e.tree, e.from + e.offset, 1) - e.offset : e.from, this.safeTo = e.openEnd ? Jq(e.tree, e.to + e.offset, -1) - e.offset : e.to; this.trees.length; )
        this.trees.pop(), this.start.pop(), this.index.pop();
      this.trees.push(e.tree), this.start.push(-e.offset), this.index.push(0), this.nextStart = this.safeFrom;
    } else
      this.nextStart = 1e9;
  }
  // `pos` must be >= any previously given `pos` for this cursor
  nodeAt(e) {
    if (e < this.nextStart)
      return null;
    for (; this.fragment && this.safeTo <= e; )
      this.nextFragment();
    if (!this.fragment)
      return null;
    for (; ; ) {
      let n = this.trees.length - 1;
      if (n < 0)
        return this.nextFragment(), null;
      let r = this.trees[n], a = this.index[n];
      if (a == r.children.length) {
        this.trees.pop(), this.start.pop(), this.index.pop();
        continue;
      }
      let i = r.children[a], o = this.start[n] + r.positions[a];
      if (o > e)
        return this.nextStart = o, null;
      if (i instanceof Pr) {
        if (o == e) {
          if (o < this.safeFrom)
            return null;
          let s = o + i.length;
          if (s <= this.safeTo) {
            let u = i.prop(nr.lookAhead);
            if (!u || s + u < this.fragment.to)
              return i;
          }
        }
        this.index[n]++, o + i.length >= Math.max(this.safeFrom, e) && (this.trees.push(i), this.start.push(o), this.index.push(0));
      } else
        this.index[n]++, this.nextStart = o + i.length;
    }
  }
}
class y3e {
  constructor(e, n) {
    this.stream = n, this.tokens = [], this.mainToken = null, this.actions = [], this.tokens = e.tokenizers.map((r) => new Rk());
  }
  getActions(e) {
    let n = 0, r = null, { parser: a } = e.p, { tokenizers: i } = a, o = a.stateSlot(
      e.state,
      3
      /* ParseState.TokenizerMask */
    ), s = e.curContext ? e.curContext.hash : 0, u = 0;
    for (let f = 0; f < i.length; f++) {
      if (!(1 << f & o))
        continue;
      let p = i[f], m = this.tokens[f];
      if (!(r && !p.fallback) && ((p.contextual || m.start != e.pos || m.mask != o || m.context != s) && (this.updateCachedToken(m, p, e), m.mask = o, m.context = s), m.lookAhead > m.end + 25 && (u = Math.max(m.lookAhead, u)), m.value != 0)) {
        let v = n;
        if (m.extended > -1 && (n = this.addActions(e, m.extended, m.end, n)), n = this.addActions(e, m.value, m.end, n), !p.extend && (r = m, n > v))
          break;
      }
    }
    for (; this.actions.length > n; )
      this.actions.pop();
    return u && e.setLookAhead(u), !r && e.pos == this.stream.end && (r = new Rk(), r.value = e.p.parser.eofTerm, r.start = r.end = e.pos, n = this.addActions(e, r.value, r.end, n)), this.mainToken = r, this.actions;
  }
  getMainToken(e) {
    if (this.mainToken)
      return this.mainToken;
    let n = new Rk(), { pos: r, p: a } = e;
    return n.start = r, n.end = Math.min(r + 1, a.stream.end), n.value = r == a.stream.end ? a.parser.eofTerm : 0, n;
  }
  updateCachedToken(e, n, r) {
    let a = this.stream.clipPos(r.pos);
    if (n.token(this.stream.reset(a, e), r), e.value > -1) {
      let { parser: i } = r.p;
      for (let o = 0; o < i.specialized.length; o++)
        if (i.specialized[o] == e.value) {
          let s = i.specializers[o](this.stream.read(e.start, e.end), r);
          if (s >= 0 && r.p.parser.dialect.allows(s >> 1)) {
            s & 1 ? e.extended = s >> 1 : e.value = s >> 1;
            break;
          }
        }
    } else
      e.value = 0, e.end = this.stream.clipPos(a + 1);
  }
  putAction(e, n, r, a) {
    for (let i = 0; i < a; i += 3)
      if (this.actions[i] == e)
        return a;
    return this.actions[a++] = e, this.actions[a++] = n, this.actions[a++] = r, a;
  }
  addActions(e, n, r, a) {
    let { state: i } = e, { parser: o } = e.p, { data: s } = o;
    for (let u = 0; u < 2; u++)
      for (let f = o.stateSlot(
        i,
        u ? 2 : 1
        /* ParseState.Actions */
      ); ; f += 3) {
        if (s[f] == 65535)
          if (s[f + 1] == 1)
            f = qm(s, f + 2);
          else {
            a == 0 && s[f + 1] == 2 && (a = this.putAction(qm(s, f + 2), n, r, a));
            break;
          }
        s[f] == n && (a = this.putAction(qm(s, f + 1), n, r, a));
      }
    return a;
  }
}
class O3e {
  constructor(e, n, r, a) {
    this.parser = e, this.input = n, this.ranges = a, this.recovering = 0, this.nextStackID = 9812, this.minStackPos = 0, this.reused = [], this.stoppedAt = null, this.lastBigReductionStart = -1, this.lastBigReductionSize = 0, this.bigReductionCount = 0, this.stream = new g3e(n, a), this.tokens = new y3e(e, this.stream), this.topTerm = e.top[1];
    let { from: i } = a[0];
    this.stacks = [gI.start(this, e.top[0], i)], this.fragments = r.length && this.stream.end - i > e.bufferLength * 4 ? new v3e(r, e.nodeSet) : null;
  }
  get parsedPos() {
    return this.minStackPos;
  }
  // Move the parser forward. This will process all parse stacks at
  // `this.pos` and try to advance them to a further position. If no
  // stack for such a position is found, it'll start error-recovery.
  //
  // When the parse is finished, this will return a syntax tree. When
  // not, it returns `null`.
  advance() {
    let e = this.stacks, n = this.minStackPos, r = this.stacks = [], a, i;
    if (this.bigReductionCount > 300 && e.length == 1) {
      let [o] = e;
      for (; o.forceReduce() && o.stack.length && o.stack[o.stack.length - 2] >= this.lastBigReductionStart; )
        ;
      this.bigReductionCount = this.lastBigReductionSize = 0;
    }
    for (let o = 0; o < e.length; o++) {
      let s = e[o];
      for (; ; ) {
        if (this.tokens.mainToken = null, s.pos > n)
          r.push(s);
        else {
          if (this.advanceStack(s, r, e))
            continue;
          {
            a || (a = [], i = []), a.push(s);
            let u = this.tokens.getMainToken(s);
            i.push(u.value, u.end);
          }
        }
        break;
      }
    }
    if (!r.length) {
      let o = a && S3e(a);
      if (o)
        return Rc && console.log("Finish with " + this.stackID(o)), this.stackToTree(o);
      if (this.parser.strict)
        throw Rc && a && console.log("Stuck with token " + (this.tokens.mainToken ? this.parser.getName(this.tokens.mainToken.value) : "none")), new SyntaxError("No parse at " + n);
      this.recovering || (this.recovering = 5);
    }
    if (this.recovering && a) {
      let o = this.stoppedAt != null && a[0].pos > this.stoppedAt ? a[0] : this.runRecovery(a, i, r);
      if (o)
        return Rc && console.log("Force-finish " + this.stackID(o)), this.stackToTree(o.forceAll());
    }
    if (this.recovering) {
      let o = this.recovering == 1 ? 1 : this.recovering * 3;
      if (r.length > o)
        for (r.sort((s, u) => u.score - s.score); r.length > o; )
          r.pop();
      r.some((s) => s.reducePos > n) && this.recovering--;
    } else if (r.length > 1) {
      e:
        for (let o = 0; o < r.length - 1; o++) {
          let s = r[o];
          for (let u = o + 1; u < r.length; u++) {
            let f = r[u];
            if (s.sameState(f) || s.buffer.length > 500 && f.buffer.length > 500)
              if ((s.score - f.score || s.buffer.length - f.buffer.length) > 0)
                r.splice(u--, 1);
              else {
                r.splice(o--, 1);
                continue e;
              }
          }
        }
      r.length > 12 && r.splice(
        12,
        r.length - 12
        /* Rec.MaxStackCount */
      );
    }
    this.minStackPos = r[0].pos;
    for (let o = 1; o < r.length; o++)
      r[o].pos < this.minStackPos && (this.minStackPos = r[o].pos);
    return null;
  }
  stopAt(e) {
    if (this.stoppedAt != null && this.stoppedAt < e)
      throw new RangeError("Can't move stoppedAt forward");
    this.stoppedAt = e;
  }
  // Returns an updated version of the given stack, or null if the
  // stack can't advance normally. When `split` and `stacks` are
  // given, stacks split off by ambiguous operations will be pushed to
  // `split`, or added to `stacks` if they move `pos` forward.
  advanceStack(e, n, r) {
    let a = e.pos, { parser: i } = this, o = Rc ? this.stackID(e) + " -> " : "";
    if (this.stoppedAt != null && a > this.stoppedAt)
      return e.forceReduce() ? e : null;
    if (this.fragments) {
      let f = e.curContext && e.curContext.tracker.strict, p = f ? e.curContext.hash : 0;
      for (let m = this.fragments.nodeAt(a); m; ) {
        let v = this.parser.nodeSet.types[m.type.id] == m.type ? i.getGoto(e.state, m.type.id) : -1;
        if (v > -1 && m.length && (!f || (m.prop(nr.contextHash) || 0) == p))
          return e.useNode(m, v), Rc && console.log(o + this.stackID(e) + ` (via reuse of ${i.getName(m.type.id)})`), !0;
        if (!(m instanceof Pr) || m.children.length == 0 || m.positions[0] > 0)
          break;
        let O = m.children[0];
        if (O instanceof Pr && m.positions[0] == 0)
          m = O;
        else
          break;
      }
    }
    let s = i.stateSlot(
      e.state,
      4
      /* ParseState.DefaultReduce */
    );
    if (s > 0)
      return e.reduce(s), Rc && console.log(o + this.stackID(e) + ` (via always-reduce ${i.getName(
        s & 65535
        /* Action.ValueMask */
      )})`), !0;
    if (e.stack.length >= 8400)
      for (; e.stack.length > 6e3 && e.forceReduce(); )
        ;
    let u = this.tokens.getActions(e);
    for (let f = 0; f < u.length; ) {
      let p = u[f++], m = u[f++], v = u[f++], O = f == u.length || !r, w = O ? e : e.split(), _ = this.tokens.mainToken;
      if (w.apply(p, m, _ ? _.start : w.pos, v), Rc && console.log(o + this.stackID(w) + ` (via ${p & 65536 ? `reduce of ${i.getName(
        p & 65535
        /* Action.ValueMask */
      )}` : "shift"} for ${i.getName(m)} @ ${a}${w == e ? "" : ", split"})`), O)
        return !0;
      w.pos > a ? n.push(w) : r.push(w);
    }
    return !1;
  }
  // Advance a given stack forward as far as it will go. Returns the
  // (possibly updated) stack if it got stuck, or null if it moved
  // forward and was given to `pushStackDedup`.
  advanceFully(e, n) {
    let r = e.pos;
    for (; ; ) {
      if (!this.advanceStack(e, null, null))
        return !1;
      if (e.pos > r)
        return eK(e, n), !0;
    }
  }
  runRecovery(e, n, r) {
    let a = null, i = !1;
    for (let o = 0; o < e.length; o++) {
      let s = e[o], u = n[o << 1], f = n[(o << 1) + 1], p = Rc ? this.stackID(s) + " -> " : "";
      if (s.deadEnd && (i || (i = !0, s.restart(), Rc && console.log(p + this.stackID(s) + " (restarted)"), this.advanceFully(s, r))))
        continue;
      let m = s.split(), v = p;
      for (let O = 0; m.forceReduce() && O < 10 && (Rc && console.log(v + this.stackID(m) + " (via force-reduce)"), !this.advanceFully(m, r)); O++)
        Rc && (v = this.stackID(m) + " -> ");
      for (let O of s.recoverByInsert(u))
        Rc && console.log(p + this.stackID(O) + " (via recover-insert)"), this.advanceFully(O, r);
      this.stream.end > s.pos ? (f == s.pos && (f++, u = 0), s.recoverByDelete(u, f), Rc && console.log(p + this.stackID(s) + ` (via recover-delete ${this.parser.getName(u)})`), eK(s, r)) : (!a || a.score < s.score) && (a = s);
    }
    return a;
  }
  // Convert the stack's buffer to a syntax tree.
  stackToTree(e) {
    return e.close(), Pr.build({
      buffer: bI.create(e),
      nodeSet: this.parser.nodeSet,
      topID: this.topTerm,
      maxBufferLength: this.parser.bufferLength,
      reused: this.reused,
      start: this.ranges[0].from,
      length: e.pos - this.ranges[0].from,
      minRepeatType: this.parser.minRepeatTerm
    });
  }
  stackID(e) {
    let n = (S3 || (S3 = /* @__PURE__ */ new WeakMap())).get(e);
    return n || S3.set(e, n = String.fromCodePoint(this.nextStackID++)), n + e;
  }
}
function eK(t, e) {
  for (let n = 0; n < e.length; n++) {
    let r = e[n];
    if (r.pos == t.pos && r.sameState(t)) {
      e[n].score < t.score && (e[n] = t);
      return;
    }
  }
  e.push(t);
}
class E3e {
  constructor(e, n, r) {
    this.source = e, this.flags = n, this.disabled = r;
  }
  allows(e) {
    return !this.disabled || this.disabled[e] == 0;
  }
}
const w3 = (t) => t;
class Voe {
  /**
  Define a context tracker.
  */
  constructor(e) {
    this.start = e.start, this.shift = e.shift || w3, this.reduce = e.reduce || w3, this.reuse = e.reuse || w3, this.hash = e.hash || (() => 0), this.strict = e.strict !== !1;
  }
}
class qE extends OD {
  /**
  @internal
  */
  constructor(e) {
    if (super(), this.wrappers = [], e.version != 14)
      throw new RangeError(`Parser version (${e.version}) doesn't match runtime version (14)`);
    let n = e.nodeNames.split(" ");
    this.minRepeatTerm = n.length;
    for (let s = 0; s < e.repeatNodeCount; s++)
      n.push("");
    let r = Object.keys(e.topRules).map((s) => e.topRules[s][1]), a = [];
    for (let s = 0; s < n.length; s++)
      a.push([]);
    function i(s, u, f) {
      a[s].push([u, u.deserialize(String(f))]);
    }
    if (e.nodeProps)
      for (let s of e.nodeProps) {
        let u = s[0];
        typeof u == "string" && (u = nr[u]);
        for (let f = 1; f < s.length; ) {
          let p = s[f++];
          if (p >= 0)
            i(p, u, s[f++]);
          else {
            let m = s[f + -p];
            for (let v = -p; v > 0; v--)
              i(s[f++], u, m);
            f++;
          }
        }
      }
    this.nodeSet = new u1(n.map((s, u) => Po.define({
      name: u >= this.minRepeatTerm ? void 0 : s,
      id: u,
      props: a[u],
      top: r.indexOf(u) > -1,
      error: u == 0,
      skipped: e.skippedNodes && e.skippedNodes.indexOf(u) > -1
    }))), e.propSources && (this.nodeSet = this.nodeSet.extend(...e.propSources)), this.strict = !1, this.bufferLength = Fie;
    let o = zw(e.tokenData);
    this.context = e.context, this.specializerSpecs = e.specialized || [], this.specialized = new Uint16Array(this.specializerSpecs.length);
    for (let s = 0; s < this.specializerSpecs.length; s++)
      this.specialized[s] = this.specializerSpecs[s].term;
    this.specializers = this.specializerSpecs.map(tK), this.states = zw(e.states, Uint32Array), this.data = zw(e.stateData), this.goto = zw(e.goto), this.maxTerm = e.maxTerm, this.tokenizers = e.tokenizers.map((s) => typeof s == "number" ? new IE(o, s) : s), this.topRules = e.topRules, this.dialects = e.dialects || {}, this.dynamicPrecedences = e.dynamicPrecedences || null, this.tokenPrecTable = e.tokenPrec, this.termNames = e.termNames || null, this.maxNode = this.nodeSet.types.length - 1, this.dialect = this.parseDialect(), this.top = this.topRules[Object.keys(this.topRules)[0]];
  }
  createParse(e, n, r) {
    let a = new O3e(this, e, n, r);
    for (let i of this.wrappers)
      a = i(a, e, n, r);
    return a;
  }
  /**
  Get a goto table entry @internal
  */
  getGoto(e, n, r = !1) {
    let a = this.goto;
    if (n >= a[0])
      return -1;
    for (let i = a[n + 1]; ; ) {
      let o = a[i++], s = o & 1, u = a[i++];
      if (s && r)
        return u;
      for (let f = i + (o >> 1); i < f; i++)
        if (a[i] == e)
          return u;
      if (s)
        return -1;
    }
  }
  /**
  Check if this state has an action for a given terminal @internal
  */
  hasAction(e, n) {
    let r = this.data;
    for (let a = 0; a < 2; a++)
      for (let i = this.stateSlot(
        e,
        a ? 2 : 1
        /* ParseState.Actions */
      ), o; ; i += 3) {
        if ((o = r[i]) == 65535)
          if (r[i + 1] == 1)
            o = r[i = qm(r, i + 2)];
          else {
            if (r[i + 1] == 2)
              return qm(r, i + 2);
            break;
          }
        if (o == n || o == 0)
          return qm(r, i + 1);
      }
    return 0;
  }
  /**
  @internal
  */
  stateSlot(e, n) {
    return this.states[e * 6 + n];
  }
  /**
  @internal
  */
  stateFlag(e, n) {
    return (this.stateSlot(
      e,
      0
      /* ParseState.Flags */
    ) & n) > 0;
  }
  /**
  @internal
  */
  validAction(e, n) {
    return !!this.allActions(e, (r) => r == n ? !0 : null);
  }
  /**
  @internal
  */
  allActions(e, n) {
    let r = this.stateSlot(
      e,
      4
      /* ParseState.DefaultReduce */
    ), a = r ? n(r) : void 0;
    for (let i = this.stateSlot(
      e,
      1
      /* ParseState.Actions */
    ); a == null; i += 3) {
      if (this.data[i] == 65535)
        if (this.data[i + 1] == 1)
          i = qm(this.data, i + 2);
        else
          break;
      a = n(qm(this.data, i + 1));
    }
    return a;
  }
  /**
  Get the states that can follow this one through shift actions or
  goto jumps. @internal
  */
  nextStates(e) {
    let n = [];
    for (let r = this.stateSlot(
      e,
      1
      /* ParseState.Actions */
    ); ; r += 3) {
      if (this.data[r] == 65535)
        if (this.data[r + 1] == 1)
          r = qm(this.data, r + 2);
        else
          break;
      if (!(this.data[r + 2] & 1)) {
        let a = this.data[r + 1];
        n.some((i, o) => o & 1 && i == a) || n.push(this.data[r], a);
      }
    }
    return n;
  }
  /**
  Configure the parser. Returns a new parser instance that has the
  given settings modified. Settings not provided in `config` are
  kept from the original parser.
  */
  configure(e) {
    let n = Object.assign(Object.create(qE.prototype), this);
    if (e.props && (n.nodeSet = this.nodeSet.extend(...e.props)), e.top) {
      let r = this.topRules[e.top];
      if (!r)
        throw new RangeError(`Invalid top rule name ${e.top}`);
      n.top = r;
    }
    return e.tokenizers && (n.tokenizers = this.tokenizers.map((r) => {
      let a = e.tokenizers.find((i) => i.from == r);
      return a ? a.to : r;
    })), e.specializers && (n.specializers = this.specializers.slice(), n.specializerSpecs = this.specializerSpecs.map((r, a) => {
      let i = e.specializers.find((s) => s.from == r.external);
      if (!i)
        return r;
      let o = Object.assign(Object.assign({}, r), { external: i.to });
      return n.specializers[a] = tK(o), o;
    })), e.contextTracker && (n.context = e.contextTracker), e.dialect && (n.dialect = this.parseDialect(e.dialect)), e.strict != null && (n.strict = e.strict), e.wrap && (n.wrappers = n.wrappers.concat(e.wrap)), e.bufferLength != null && (n.bufferLength = e.bufferLength), n;
  }
  /**
  Tells you whether any [parse wrappers](#lr.ParserConfig.wrap)
  are registered for this parser.
  */
  hasWrappers() {
    return this.wrappers.length > 0;
  }
  /**
  Returns the name associated with a given term. This will only
  work for all terms when the parser was generated with the
  `--names` option. By default, only the names of tagged terms are
  stored.
  */
  getName(e) {
    return this.termNames ? this.termNames[e] : String(e <= this.maxNode && this.nodeSet.types[e].name || e);
  }
  /**
  The eof term id is always allocated directly after the node
  types. @internal
  */
  get eofTerm() {
    return this.maxNode + 1;
  }
  /**
  The type of top node produced by the parser.
  */
  get topNode() {
    return this.nodeSet.types[this.top[1]];
  }
  /**
  @internal
  */
  dynamicPrecedence(e) {
    let n = this.dynamicPrecedences;
    return n == null ? 0 : n[e] || 0;
  }
  /**
  @internal
  */
  parseDialect(e) {
    let n = Object.keys(this.dialects), r = n.map(() => !1);
    if (e)
      for (let i of e.split(" ")) {
        let o = n.indexOf(i);
        o >= 0 && (r[o] = !0);
      }
    let a = null;
    for (let i = 0; i < n.length; i++)
      if (!r[i])
        for (let o = this.dialects[n[i]], s; (s = this.data[o++]) != 65535; )
          (a || (a = new Uint8Array(this.maxTerm + 1)))[s] = 1;
    return new E3e(e, r, a);
  }
  /**
  Used by the output of the parser generator. Not available to
  user code. @hide
  */
  static deserialize(e) {
    return new qE(e);
  }
}
function qm(t, e) {
  return t[e] | t[e + 1] << 16;
}
function S3e(t) {
  let e = null;
  for (let n of t) {
    let r = n.p.stoppedAt;
    (n.pos == n.p.stream.end || r != null && n.pos > r) && n.p.parser.stateFlag(
      n.state,
      2
      /* StateFlag.Accepting */
    ) && (!e || e.score < n.score) && (e = n);
  }
  return e;
}
function tK(t) {
  if (t.external) {
    let e = t.extend ? 1 : 0;
    return (n, r) => t.external(n, r) << 1 | e;
  }
  return t.get;
}
const w3e = 54, T3e = 1, _3e = 55, C3e = 2, x3e = 56, A3e = 3, nK = 4, k3e = 5, yI = 6, Yoe = 7, Zoe = 8, Xoe = 9, qoe = 10, R3e = 11, I3e = 12, D3e = 13, T3 = 57, N3e = 14, rK = 58, Koe = 20, P3e = 22, Joe = 23, L3e = 24, Q4 = 26, ese = 27, M3e = 28, F3e = 31, $3e = 34, B3e = 36, U3e = 37, z3e = 0, H3e = 1, W3e = {
  area: !0,
  base: !0,
  br: !0,
  col: !0,
  command: !0,
  embed: !0,
  frame: !0,
  hr: !0,
  img: !0,
  input: !0,
  keygen: !0,
  link: !0,
  meta: !0,
  param: !0,
  source: !0,
  track: !0,
  wbr: !0,
  menuitem: !0
}, Q3e = {
  dd: !0,
  li: !0,
  optgroup: !0,
  option: !0,
  p: !0,
  rp: !0,
  rt: !0,
  tbody: !0,
  td: !0,
  tfoot: !0,
  th: !0,
  tr: !0
}, aK = {
  dd: { dd: !0, dt: !0 },
  dt: { dd: !0, dt: !0 },
  li: { li: !0 },
  option: { option: !0, optgroup: !0 },
  optgroup: { optgroup: !0 },
  p: {
    address: !0,
    article: !0,
    aside: !0,
    blockquote: !0,
    dir: !0,
    div: !0,
    dl: !0,
    fieldset: !0,
    footer: !0,
    form: !0,
    h1: !0,
    h2: !0,
    h3: !0,
    h4: !0,
    h5: !0,
    h6: !0,
    header: !0,
    hgroup: !0,
    hr: !0,
    menu: !0,
    nav: !0,
    ol: !0,
    p: !0,
    pre: !0,
    section: !0,
    table: !0,
    ul: !0
  },
  rp: { rp: !0, rt: !0 },
  rt: { rp: !0, rt: !0 },
  tbody: { tbody: !0, tfoot: !0 },
  td: { td: !0, th: !0 },
  tfoot: { tbody: !0 },
  th: { td: !0, th: !0 },
  thead: { tbody: !0, tfoot: !0 },
  tr: { tr: !0 }
};
function j3e(t) {
  return t == 45 || t == 46 || t == 58 || t >= 65 && t <= 90 || t == 95 || t >= 97 && t <= 122 || t >= 161;
}
function tse(t) {
  return t == 9 || t == 10 || t == 13 || t == 32;
}
let iK = null, oK = null, sK = 0;
function j4(t, e) {
  let n = t.pos + e;
  if (sK == n && oK == t)
    return iK;
  let r = t.peek(e);
  for (; tse(r); )
    r = t.peek(++e);
  let a = "";
  for (; j3e(r); )
    a += String.fromCharCode(r), r = t.peek(++e);
  return oK = t, sK = n, iK = a ? a.toLowerCase() : r == G3e || r == V3e ? void 0 : null;
}
const nse = 60, OI = 62, g6 = 47, G3e = 63, V3e = 33, Y3e = 45;
function lK(t, e) {
  this.name = t, this.parent = e, this.hash = e ? e.hash : 0;
  for (let n = 0; n < t.length; n++)
    this.hash += (this.hash << 4) + t.charCodeAt(n) + (t.charCodeAt(n) << 8);
}
const Z3e = [yI, qoe, Yoe, Zoe, Xoe], X3e = new Voe({
  start: null,
  shift(t, e, n, r) {
    return Z3e.indexOf(e) > -1 ? new lK(j4(r, 1) || "", t) : t;
  },
  reduce(t, e) {
    return e == Koe && t ? t.parent : t;
  },
  reuse(t, e, n, r) {
    let a = e.type.id;
    return a == yI || a == B3e ? new lK(j4(r, 1) || "", t) : t;
  },
  hash(t) {
    return t ? t.hash : 0;
  },
  strict: !1
}), q3e = new Jd((t, e) => {
  if (t.next != nse) {
    t.next < 0 && e.context && t.acceptToken(T3);
    return;
  }
  t.advance();
  let n = t.next == g6;
  n && t.advance();
  let r = j4(t, 0);
  if (r === void 0)
    return;
  if (!r)
    return t.acceptToken(n ? N3e : yI);
  let a = e.context ? e.context.name : null;
  if (n) {
    if (r == a)
      return t.acceptToken(R3e);
    if (a && Q3e[a])
      return t.acceptToken(T3, -2);
    if (e.dialectEnabled(z3e))
      return t.acceptToken(I3e);
    for (let i = e.context; i; i = i.parent)
      if (i.name == r)
        return;
    t.acceptToken(D3e);
  } else {
    if (r == "script")
      return t.acceptToken(Yoe);
    if (r == "style")
      return t.acceptToken(Zoe);
    if (r == "textarea")
      return t.acceptToken(Xoe);
    if (W3e.hasOwnProperty(r))
      return t.acceptToken(qoe);
    a && aK[a] && aK[a][r] ? t.acceptToken(T3, -1) : t.acceptToken(yI);
  }
}, { contextual: !0 }), K3e = new Jd((t) => {
  for (let e = 0, n = 0; ; n++) {
    if (t.next < 0) {
      n && t.acceptToken(rK);
      break;
    }
    if (t.next == Y3e)
      e++;
    else if (t.next == OI && e >= 2) {
      n >= 3 && t.acceptToken(rK, -2);
      break;
    } else
      e = 0;
    t.advance();
  }
});
function J3e(t) {
  for (; t; t = t.parent)
    if (t.name == "svg" || t.name == "math")
      return !0;
  return !1;
}
const eFe = new Jd((t, e) => {
  if (t.next == g6 && t.peek(1) == OI) {
    let n = e.dialectEnabled(H3e) || J3e(e.context);
    t.acceptToken(n ? k3e : nK, 2);
  } else
    t.next == OI && t.acceptToken(nK, 1);
});
function b6(t, e, n) {
  let r = 2 + t.length;
  return new Jd((a) => {
    for (let i = 0, o = 0, s = 0; ; s++) {
      if (a.next < 0) {
        s && a.acceptToken(e);
        break;
      }
      if (i == 0 && a.next == nse || i == 1 && a.next == g6 || i >= 2 && i < r && a.next == t.charCodeAt(i - 2))
        i++, o++;
      else if ((i == 2 || i == r) && tse(a.next))
        o++;
      else if (i == r && a.next == OI) {
        s > o ? a.acceptToken(e, -o) : a.acceptToken(n, -(o - 2));
        break;
      } else if ((a.next == 10 || a.next == 13) && s) {
        a.acceptToken(e, 1);
        break;
      } else
        i = o = 0;
      a.advance();
    }
  });
}
const tFe = b6("script", w3e, T3e), nFe = b6("style", _3e, C3e), rFe = b6("textarea", x3e, A3e), aFe = c1({
  "Text RawText": ge.content,
  "StartTag StartCloseTag SelfClosingEndTag EndTag": ge.angleBracket,
  TagName: ge.tagName,
  "MismatchedCloseTag/TagName": [ge.tagName, ge.invalid],
  AttributeName: ge.attributeName,
  "AttributeValue UnquotedAttributeValue": ge.attributeValue,
  Is: ge.definitionOperator,
  "EntityReference CharacterReference": ge.character,
  Comment: ge.blockComment,
  ProcessingInst: ge.processingInstruction,
  DoctypeDecl: ge.documentMeta
}), iFe = qE.deserialize({
  version: 14,
  states: ",xOVO!rOOO!WQ#tO'#CqO!]Q#tO'#CzO!bQ#tO'#C}O!gQ#tO'#DQO!lQ#tO'#DSO!qOaO'#CpO!|ObO'#CpO#XOdO'#CpO$eO!rO'#CpOOO`'#Cp'#CpO$lO$fO'#DTO$tQ#tO'#DVO$yQ#tO'#DWOOO`'#Dk'#DkOOO`'#DY'#DYQVO!rOOO%OQ&rO,59]O%ZQ&rO,59fO%fQ&rO,59iO%qQ&rO,59lO%|Q&rO,59nOOOa'#D^'#D^O&XOaO'#CxO&dOaO,59[OOOb'#D_'#D_O&lObO'#C{O&wObO,59[OOOd'#D`'#D`O'POdO'#DOO'[OdO,59[OOO`'#Da'#DaO'dO!rO,59[O'kQ#tO'#DROOO`,59[,59[OOOp'#Db'#DbO'pO$fO,59oOOO`,59o,59oO'xQ#|O,59qO'}Q#|O,59rOOO`-E7W-E7WO(SQ&rO'#CsOOQW'#DZ'#DZO(bQ&rO1G.wOOOa1G.w1G.wOOO`1G/Y1G/YO(mQ&rO1G/QOOOb1G/Q1G/QO(xQ&rO1G/TOOOd1G/T1G/TO)TQ&rO1G/WOOO`1G/W1G/WO)`Q&rO1G/YOOOa-E7[-E7[O)kQ#tO'#CyOOO`1G.v1G.vOOOb-E7]-E7]O)pQ#tO'#C|OOOd-E7^-E7^O)uQ#tO'#DPOOO`-E7_-E7_O)zQ#|O,59mOOOp-E7`-E7`OOO`1G/Z1G/ZOOO`1G/]1G/]OOO`1G/^1G/^O*PQ,UO,59_OOQW-E7X-E7XOOOa7+$c7+$cOOO`7+$t7+$tOOOb7+$l7+$lOOOd7+$o7+$oOOO`7+$r7+$rO*[Q#|O,59eO*aQ#|O,59hO*fQ#|O,59kOOO`1G/X1G/XO*kO7[O'#CvO*|OMhO'#CvOOQW1G.y1G.yOOO`1G/P1G/POOO`1G/S1G/SOOO`1G/V1G/VOOOO'#D['#D[O+_O7[O,59bOOQW,59b,59bOOOO'#D]'#D]O+pOMhO,59bOOOO-E7Y-E7YOOQW1G.|1G.|OOOO-E7Z-E7Z",
  stateData: ",]~O!^OS~OUSOVPOWQOXROYTO[]O][O^^O`^Oa^Ob^Oc^Ox^O{_O!dZO~OfaO~OfbO~OfcO~OfdO~OfeO~O!WfOPlP!ZlP~O!XiOQoP!ZoP~O!YlORrP!ZrP~OUSOVPOWQOXROYTOZqO[]O][O^^O`^Oa^Ob^Oc^Ox^O!dZO~O!ZrO~P#dO![sO!euO~OfvO~OfwO~OS|OT}OhyO~OS!POT}OhyO~OS!ROT}OhyO~OS!TOT}OhyO~OS}OT}OhyO~O!WfOPlX!ZlX~OP!WO!Z!XO~O!XiOQoX!ZoX~OQ!ZO!Z!XO~O!YlORrX!ZrX~OR!]O!Z!XO~O!Z!XO~P#dOf!_O~O![sO!e!aO~OS!bO~OS!cO~Oi!dOSgXTgXhgX~OS!fOT!gOhyO~OS!hOT!gOhyO~OS!iOT!gOhyO~OS!jOT!gOhyO~OS!gOT!gOhyO~Of!kO~Of!lO~Of!mO~OS!nO~Ok!qO!`!oO!b!pO~OS!rO~OS!sO~OS!tO~Oa!uOb!uOc!uO!`!wO!a!uO~Oa!xOb!xOc!xO!b!wO!c!xO~Oa!uOb!uOc!uO!`!{O!a!uO~Oa!xOb!xOc!xO!b!{O!c!xO~OT~bac!dx{!d~",
  goto: "%p!`PPPPPPPPPPPPPPPPPPPP!a!gP!mPP!yP!|#P#S#Y#]#`#f#i#l#r#x!aP!a!aP$O$U$l$r$x%O%U%[%bPPPPPPPP%hX^OX`pXUOX`pezabcde{!O!Q!S!UR!q!dRhUR!XhXVOX`pRkVR!XkXWOX`pRnWR!XnXXOX`pQrXR!XpXYOX`pQ`ORx`Q{aQ!ObQ!QcQ!SdQ!UeZ!e{!O!Q!S!UQ!v!oR!z!vQ!y!pR!|!yQgUR!VgQjVR!YjQmWR![mQpXR!^pQtZR!`tS_O`ToXp",
  nodeNames: "⚠ StartCloseTag StartCloseTag StartCloseTag EndTag SelfClosingEndTag StartTag StartTag StartTag StartTag StartTag StartCloseTag StartCloseTag StartCloseTag IncompleteCloseTag Document Text EntityReference CharacterReference InvalidEntity Element OpenTag TagName Attribute AttributeName Is AttributeValue UnquotedAttributeValue ScriptText CloseTag OpenTag StyleText CloseTag OpenTag TextareaText CloseTag OpenTag CloseTag SelfClosingTag Comment ProcessingInst MismatchedCloseTag CloseTag DoctypeDecl",
  maxTerm: 67,
  context: X3e,
  nodeProps: [
    ["closedBy", -10, 1, 2, 3, 7, 8, 9, 10, 11, 12, 13, "EndTag", 6, "EndTag SelfClosingEndTag", -4, 21, 30, 33, 36, "CloseTag"],
    ["openedBy", 4, "StartTag StartCloseTag", 5, "StartTag", -4, 29, 32, 35, 37, "OpenTag"],
    ["group", -9, 14, 17, 18, 19, 20, 39, 40, 41, 42, "Entity", 16, "Entity TextContent", -3, 28, 31, 34, "TextContent Entity"],
    ["isolate", -11, 21, 29, 30, 32, 33, 35, 36, 37, 38, 41, 42, "ltr", -3, 26, 27, 39, ""]
  ],
  propSources: [aFe],
  skippedNodes: [0],
  repeatNodeCount: 9,
  tokenData: "!<p!aR!YOX$qXY,QYZ,QZ[$q[]&X]^,Q^p$qpq,Qqr-_rs3_sv-_vw3}wxHYx}-_}!OH{!O!P-_!P!Q$q!Q![-_![!]Mz!]!^-_!^!_!$S!_!`!;x!`!a&X!a!c-_!c!}Mz!}#R-_#R#SMz#S#T1k#T#oMz#o#s-_#s$f$q$f%W-_%W%oMz%o%p-_%p&aMz&a&b-_&b1pMz1p4U-_4U4dMz4d4e-_4e$ISMz$IS$I`-_$I`$IbMz$Ib$Kh-_$Kh%#tMz%#t&/x-_&/x&EtMz&Et&FV-_&FV;'SMz;'S;:j!#|;:j;=`3X<%l?&r-_?&r?AhMz?Ah?BY$q?BY?MnMz?MnO$q!Z$|c`PkW!a`!cpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr$qrs&}sv$qvw+Pwx(tx!^$q!^!_*V!_!a&X!a#S$q#S#T&X#T;'S$q;'S;=`+z<%lO$q!R&bX`P!a`!cpOr&Xrs&}sv&Xwx(tx!^&X!^!_*V!_;'S&X;'S;=`*y<%lO&Xq'UV`P!cpOv&}wx'kx!^&}!^!_(V!_;'S&};'S;=`(n<%lO&}P'pT`POv'kw!^'k!_;'S'k;'S;=`(P<%lO'kP(SP;=`<%l'kp([S!cpOv(Vx;'S(V;'S;=`(h<%lO(Vp(kP;=`<%l(Vq(qP;=`<%l&}a({W`P!a`Or(trs'ksv(tw!^(t!^!_)e!_;'S(t;'S;=`*P<%lO(t`)jT!a`Or)esv)ew;'S)e;'S;=`)y<%lO)e`)|P;=`<%l)ea*SP;=`<%l(t!Q*^V!a`!cpOr*Vrs(Vsv*Vwx)ex;'S*V;'S;=`*s<%lO*V!Q*vP;=`<%l*V!R*|P;=`<%l&XW+UYkWOX+PZ[+P^p+Pqr+Psw+Px!^+P!a#S+P#T;'S+P;'S;=`+t<%lO+PW+wP;=`<%l+P!Z+}P;=`<%l$q!a,]``P!a`!cp!^^OX&XXY,QYZ,QZ]&X]^,Q^p&Xpq,Qqr&Xrs&}sv&Xwx(tx!^&X!^!_*V!_;'S&X;'S;=`*y<%lO&X!_-ljhS`PkW!a`!cpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr-_rs&}sv-_vw/^wx(tx!P-_!P!Q$q!Q!^-_!^!_*V!_!a&X!a#S-_#S#T1k#T#s-_#s$f$q$f;'S-_;'S;=`3X<%l?Ah-_?Ah?BY$q?BY?Mn-_?MnO$q[/ebhSkWOX+PZ[+P^p+Pqr/^sw/^x!P/^!P!Q+P!Q!^/^!a#S/^#S#T0m#T#s/^#s$f+P$f;'S/^;'S;=`1e<%l?Ah/^?Ah?BY+P?BY?Mn/^?MnO+PS0rXhSqr0msw0mx!P0m!Q!^0m!a#s0m$f;'S0m;'S;=`1_<%l?Ah0m?BY?Mn0mS1bP;=`<%l0m[1hP;=`<%l/^!V1vchS`P!a`!cpOq&Xqr1krs&}sv1kvw0mwx(tx!P1k!P!Q&X!Q!^1k!^!_*V!_!a&X!a#s1k#s$f&X$f;'S1k;'S;=`3R<%l?Ah1k?Ah?BY&X?BY?Mn1k?MnO&X!V3UP;=`<%l1k!_3[P;=`<%l-_!Z3hV!`h`P!cpOv&}wx'kx!^&}!^!_(V!_;'S&};'S;=`(n<%lO&}!_4WihSkWc!ROX5uXZ7SZ[5u[^7S^p5uqr8trs7Sst>]tw8twx7Sx!P8t!P!Q5u!Q!]8t!]!^/^!^!a7S!a#S8t#S#T;{#T#s8t#s$f5u$f;'S8t;'S;=`>V<%l?Ah8t?Ah?BY5u?BY?Mn8t?MnO5u!Z5zbkWOX5uXZ7SZ[5u[^7S^p5uqr5urs7Sst+Ptw5uwx7Sx!]5u!]!^7w!^!a7S!a#S5u#S#T7S#T;'S5u;'S;=`8n<%lO5u!R7VVOp7Sqs7St!]7S!]!^7l!^;'S7S;'S;=`7q<%lO7S!R7qOa!R!R7tP;=`<%l7S!Z8OYkWa!ROX+PZ[+P^p+Pqr+Psw+Px!^+P!a#S+P#T;'S+P;'S;=`+t<%lO+P!Z8qP;=`<%l5u!_8{ihSkWOX5uXZ7SZ[5u[^7S^p5uqr8trs7Sst/^tw8twx7Sx!P8t!P!Q5u!Q!]8t!]!^:j!^!a7S!a#S8t#S#T;{#T#s8t#s$f5u$f;'S8t;'S;=`>V<%l?Ah8t?Ah?BY5u?BY?Mn8t?MnO5u!_:sbhSkWa!ROX+PZ[+P^p+Pqr/^sw/^x!P/^!P!Q+P!Q!^/^!a#S/^#S#T0m#T#s/^#s$f+P$f;'S/^;'S;=`1e<%l?Ah/^?Ah?BY+P?BY?Mn/^?MnO+P!V<QchSOp7Sqr;{rs7Sst0mtw;{wx7Sx!P;{!P!Q7S!Q!];{!]!^=]!^!a7S!a#s;{#s$f7S$f;'S;{;'S;=`>P<%l?Ah;{?Ah?BY7S?BY?Mn;{?MnO7S!V=dXhSa!Rqr0msw0mx!P0m!Q!^0m!a#s0m$f;'S0m;'S;=`1_<%l?Ah0m?BY?Mn0m!V>SP;=`<%l;{!_>YP;=`<%l8t!_>dhhSkWOX@OXZAYZ[@O[^AY^p@OqrBwrsAYswBwwxAYx!PBw!P!Q@O!Q!]Bw!]!^/^!^!aAY!a#SBw#S#TE{#T#sBw#s$f@O$f;'SBw;'S;=`HS<%l?AhBw?Ah?BY@O?BY?MnBw?MnO@O!Z@TakWOX@OXZAYZ[@O[^AY^p@Oqr@OrsAYsw@OwxAYx!]@O!]!^Az!^!aAY!a#S@O#S#TAY#T;'S@O;'S;=`Bq<%lO@O!RA]UOpAYq!]AY!]!^Ao!^;'SAY;'S;=`At<%lOAY!RAtOb!R!RAwP;=`<%lAY!ZBRYkWb!ROX+PZ[+P^p+Pqr+Psw+Px!^+P!a#S+P#T;'S+P;'S;=`+t<%lO+P!ZBtP;=`<%l@O!_COhhSkWOX@OXZAYZ[@O[^AY^p@OqrBwrsAYswBwwxAYx!PBw!P!Q@O!Q!]Bw!]!^Dj!^!aAY!a#SBw#S#TE{#T#sBw#s$f@O$f;'SBw;'S;=`HS<%l?AhBw?Ah?BY@O?BY?MnBw?MnO@O!_DsbhSkWb!ROX+PZ[+P^p+Pqr/^sw/^x!P/^!P!Q+P!Q!^/^!a#S/^#S#T0m#T#s/^#s$f+P$f;'S/^;'S;=`1e<%l?Ah/^?Ah?BY+P?BY?Mn/^?MnO+P!VFQbhSOpAYqrE{rsAYswE{wxAYx!PE{!P!QAY!Q!]E{!]!^GY!^!aAY!a#sE{#s$fAY$f;'SE{;'S;=`G|<%l?AhE{?Ah?BYAY?BY?MnE{?MnOAY!VGaXhSb!Rqr0msw0mx!P0m!Q!^0m!a#s0m$f;'S0m;'S;=`1_<%l?Ah0m?BY?Mn0m!VHPP;=`<%lE{!_HVP;=`<%lBw!ZHcW!bx`P!a`Or(trs'ksv(tw!^(t!^!_)e!_;'S(t;'S;=`*P<%lO(t!aIYlhS`PkW!a`!cpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr-_rs&}sv-_vw/^wx(tx}-_}!OKQ!O!P-_!P!Q$q!Q!^-_!^!_*V!_!a&X!a#S-_#S#T1k#T#s-_#s$f$q$f;'S-_;'S;=`3X<%l?Ah-_?Ah?BY$q?BY?Mn-_?MnO$q!aK_khS`PkW!a`!cpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr-_rs&}sv-_vw/^wx(tx!P-_!P!Q$q!Q!^-_!^!_*V!_!`&X!`!aMS!a#S-_#S#T1k#T#s-_#s$f$q$f;'S-_;'S;=`3X<%l?Ah-_?Ah?BY$q?BY?Mn-_?MnO$q!TM_X`P!a`!cp!eQOr&Xrs&}sv&Xwx(tx!^&X!^!_*V!_;'S&X;'S;=`*y<%lO&X!aNZ!ZhSfQ`PkW!a`!cpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr-_rs&}sv-_vw/^wx(tx}-_}!OMz!O!PMz!P!Q$q!Q![Mz![!]Mz!]!^-_!^!_*V!_!a&X!a!c-_!c!}Mz!}#R-_#R#SMz#S#T1k#T#oMz#o#s-_#s$f$q$f$}-_$}%OMz%O%W-_%W%oMz%o%p-_%p&aMz&a&b-_&b1pMz1p4UMz4U4dMz4d4e-_4e$ISMz$IS$I`-_$I`$IbMz$Ib$Je-_$Je$JgMz$Jg$Kh-_$Kh%#tMz%#t&/x-_&/x&EtMz&Et&FV-_&FV;'SMz;'S;:j!#|;:j;=`3X<%l?&r-_?&r?AhMz?Ah?BY$q?BY?MnMz?MnO$q!a!$PP;=`<%lMz!R!$ZY!a`!cpOq*Vqr!$yrs(Vsv*Vwx)ex!a*V!a!b!4t!b;'S*V;'S;=`*s<%lO*V!R!%Q]!a`!cpOr*Vrs(Vsv*Vwx)ex}*V}!O!%y!O!f*V!f!g!']!g#W*V#W#X!0`#X;'S*V;'S;=`*s<%lO*V!R!&QX!a`!cpOr*Vrs(Vsv*Vwx)ex}*V}!O!&m!O;'S*V;'S;=`*s<%lO*V!R!&vV!a`!cp!dPOr*Vrs(Vsv*Vwx)ex;'S*V;'S;=`*s<%lO*V!R!'dX!a`!cpOr*Vrs(Vsv*Vwx)ex!q*V!q!r!(P!r;'S*V;'S;=`*s<%lO*V!R!(WX!a`!cpOr*Vrs(Vsv*Vwx)ex!e*V!e!f!(s!f;'S*V;'S;=`*s<%lO*V!R!(zX!a`!cpOr*Vrs(Vsv*Vwx)ex!v*V!v!w!)g!w;'S*V;'S;=`*s<%lO*V!R!)nX!a`!cpOr*Vrs(Vsv*Vwx)ex!{*V!{!|!*Z!|;'S*V;'S;=`*s<%lO*V!R!*bX!a`!cpOr*Vrs(Vsv*Vwx)ex!r*V!r!s!*}!s;'S*V;'S;=`*s<%lO*V!R!+UX!a`!cpOr*Vrs(Vsv*Vwx)ex!g*V!g!h!+q!h;'S*V;'S;=`*s<%lO*V!R!+xY!a`!cpOr!+qrs!,hsv!+qvw!-Swx!.[x!`!+q!`!a!/j!a;'S!+q;'S;=`!0Y<%lO!+qq!,mV!cpOv!,hvx!-Sx!`!,h!`!a!-q!a;'S!,h;'S;=`!.U<%lO!,hP!-VTO!`!-S!`!a!-f!a;'S!-S;'S;=`!-k<%lO!-SP!-kO{PP!-nP;=`<%l!-Sq!-xS!cp{POv(Vx;'S(V;'S;=`(h<%lO(Vq!.XP;=`<%l!,ha!.aX!a`Or!.[rs!-Ssv!.[vw!-Sw!`!.[!`!a!.|!a;'S!.[;'S;=`!/d<%lO!.[a!/TT!a`{POr)esv)ew;'S)e;'S;=`)y<%lO)ea!/gP;=`<%l!.[!R!/sV!a`!cp{POr*Vrs(Vsv*Vwx)ex;'S*V;'S;=`*s<%lO*V!R!0]P;=`<%l!+q!R!0gX!a`!cpOr*Vrs(Vsv*Vwx)ex#c*V#c#d!1S#d;'S*V;'S;=`*s<%lO*V!R!1ZX!a`!cpOr*Vrs(Vsv*Vwx)ex#V*V#V#W!1v#W;'S*V;'S;=`*s<%lO*V!R!1}X!a`!cpOr*Vrs(Vsv*Vwx)ex#h*V#h#i!2j#i;'S*V;'S;=`*s<%lO*V!R!2qX!a`!cpOr*Vrs(Vsv*Vwx)ex#m*V#m#n!3^#n;'S*V;'S;=`*s<%lO*V!R!3eX!a`!cpOr*Vrs(Vsv*Vwx)ex#d*V#d#e!4Q#e;'S*V;'S;=`*s<%lO*V!R!4XX!a`!cpOr*Vrs(Vsv*Vwx)ex#X*V#X#Y!+q#Y;'S*V;'S;=`*s<%lO*V!R!4{Y!a`!cpOr!4trs!5ksv!4tvw!6Vwx!8]x!a!4t!a!b!:]!b;'S!4t;'S;=`!;r<%lO!4tq!5pV!cpOv!5kvx!6Vx!a!5k!a!b!7W!b;'S!5k;'S;=`!8V<%lO!5kP!6YTO!a!6V!a!b!6i!b;'S!6V;'S;=`!7Q<%lO!6VP!6lTO!`!6V!`!a!6{!a;'S!6V;'S;=`!7Q<%lO!6VP!7QOxPP!7TP;=`<%l!6Vq!7]V!cpOv!5kvx!6Vx!`!5k!`!a!7r!a;'S!5k;'S;=`!8V<%lO!5kq!7yS!cpxPOv(Vx;'S(V;'S;=`(h<%lO(Vq!8YP;=`<%l!5ka!8bX!a`Or!8]rs!6Vsv!8]vw!6Vw!a!8]!a!b!8}!b;'S!8];'S;=`!:V<%lO!8]a!9SX!a`Or!8]rs!6Vsv!8]vw!6Vw!`!8]!`!a!9o!a;'S!8];'S;=`!:V<%lO!8]a!9vT!a`xPOr)esv)ew;'S)e;'S;=`)y<%lO)ea!:YP;=`<%l!8]!R!:dY!a`!cpOr!4trs!5ksv!4tvw!6Vwx!8]x!`!4t!`!a!;S!a;'S!4t;'S;=`!;r<%lO!4t!R!;]V!a`!cpxPOr*Vrs(Vsv*Vwx)ex;'S*V;'S;=`*s<%lO*V!R!;uP;=`<%l!4t!V!<TXiS`P!a`!cpOr&Xrs&}sv&Xwx(tx!^&X!^!_*V!_;'S&X;'S;=`*y<%lO&X",
  tokenizers: [tFe, nFe, rFe, eFe, q3e, K3e, 0, 1, 2, 3, 4, 5],
  topRules: { Document: [0, 15] },
  dialects: { noMatch: 0, selfClosing: 509 },
  tokenPrec: 511
});
function rse(t, e) {
  let n = /* @__PURE__ */ Object.create(null);
  for (let r of t.getChildren(Joe)) {
    let a = r.getChild(L3e), i = r.getChild(Q4) || r.getChild(ese);
    a && (n[e.read(a.from, a.to)] = i ? i.type.id == Q4 ? e.read(i.from + 1, i.to - 1) : e.read(i.from, i.to) : "");
  }
  return n;
}
function uK(t, e) {
  let n = t.getChild(P3e);
  return n ? e.read(n.from, n.to) : " ";
}
function _3(t, e, n) {
  let r;
  for (let a of n)
    if (!a.attrs || a.attrs(r || (r = rse(t.node.parent.firstChild, e))))
      return { parser: a.parser };
  return null;
}
function ase(t = [], e = []) {
  let n = [], r = [], a = [], i = [];
  for (let s of t)
    (s.tag == "script" ? n : s.tag == "style" ? r : s.tag == "textarea" ? a : i).push(s);
  let o = e.length ? /* @__PURE__ */ Object.create(null) : null;
  for (let s of e)
    (o[s.name] || (o[s.name] = [])).push(s);
  return Hie((s, u) => {
    let f = s.type.id;
    if (f == M3e)
      return _3(s, u, n);
    if (f == F3e)
      return _3(s, u, r);
    if (f == $3e)
      return _3(s, u, a);
    if (f == Koe && i.length) {
      let p = s.node, m = p.firstChild, v = m && uK(m, u), O;
      if (v) {
        for (let w of i)
          if (w.tag == v && (!w.attrs || w.attrs(O || (O = rse(p, u))))) {
            let _ = p.lastChild, C = _.type.id == U3e ? _.from : p.to;
            if (C > m.to)
              return { parser: w.parser, overlay: [{ from: m.to, to: C }] };
          }
      }
    }
    if (o && f == Joe) {
      let p = s.node, m;
      if (m = p.firstChild) {
        let v = o[u.read(m.from, m.to)];
        if (v)
          for (let O of v) {
            if (O.tagName && O.tagName != uK(p.parent, u))
              continue;
            let w = p.lastChild;
            if (w.type.id == Q4) {
              let _ = w.from + 1, C = w.lastChild, A = w.to - (C && C.isError ? 0 : 1);
              if (A > _)
                return { parser: O.parser, overlay: [{ from: _, to: A }] };
            } else if (w.type.id == ese)
              return { parser: O.parser, overlay: [{ from: w.from, to: w.to }] };
          }
      }
    }
    return null;
  });
}
const oFe = 99, cK = 1, sFe = 100, lFe = 101, fK = 2, ise = [
  9,
  10,
  11,
  12,
  13,
  32,
  133,
  160,
  5760,
  8192,
  8193,
  8194,
  8195,
  8196,
  8197,
  8198,
  8199,
  8200,
  8201,
  8202,
  8232,
  8233,
  8239,
  8287,
  12288
], uFe = 58, cFe = 40, ose = 95, fFe = 91, Ik = 45, dFe = 46, pFe = 35, hFe = 37, mFe = 38, gFe = 92, bFe = 10;
function e_(t) {
  return t >= 65 && t <= 90 || t >= 97 && t <= 122 || t >= 161;
}
function sse(t) {
  return t >= 48 && t <= 57;
}
const vFe = new Jd((t, e) => {
  for (let n = !1, r = 0, a = 0; ; a++) {
    let { next: i } = t;
    if (e_(i) || i == Ik || i == ose || n && sse(i))
      !n && (i != Ik || a > 0) && (n = !0), r === a && i == Ik && r++, t.advance();
    else if (i == gFe && t.peek(1) != bFe)
      t.advance(), t.next > -1 && t.advance(), n = !0;
    else {
      n && t.acceptToken(i == cFe ? sFe : r == 2 && e.canShift(fK) ? fK : lFe);
      break;
    }
  }
}), yFe = new Jd((t) => {
  if (ise.includes(t.peek(-1))) {
    let { next: e } = t;
    (e_(e) || e == ose || e == pFe || e == dFe || e == fFe || e == uFe && e_(t.peek(1)) || e == Ik || e == mFe) && t.acceptToken(oFe);
  }
}), OFe = new Jd((t) => {
  if (!ise.includes(t.peek(-1))) {
    let { next: e } = t;
    if (e == hFe && (t.advance(), t.acceptToken(cK)), e_(e)) {
      do
        t.advance();
      while (e_(t.next) || sse(t.next));
      t.acceptToken(cK);
    }
  }
}), EFe = c1({
  "AtKeyword import charset namespace keyframes media supports": ge.definitionKeyword,
  "from to selector": ge.keyword,
  NamespaceName: ge.namespace,
  KeyframeName: ge.labelName,
  KeyframeRangeName: ge.operatorKeyword,
  TagName: ge.tagName,
  ClassName: ge.className,
  PseudoClassName: ge.constant(ge.className),
  IdName: ge.labelName,
  "FeatureName PropertyName": ge.propertyName,
  AttributeName: ge.attributeName,
  NumberLiteral: ge.number,
  KeywordQuery: ge.keyword,
  UnaryQueryOp: ge.operatorKeyword,
  "CallTag ValueName": ge.atom,
  VariableName: ge.variableName,
  Callee: ge.operatorKeyword,
  Unit: ge.unit,
  "UniversalSelector NestingSelector": ge.definitionOperator,
  MatchOp: ge.compareOperator,
  "ChildOp SiblingOp, LogicOp": ge.logicOperator,
  BinOp: ge.arithmeticOperator,
  Important: ge.modifier,
  Comment: ge.blockComment,
  ColorLiteral: ge.color,
  "ParenthesizedContent StringLiteral": ge.string,
  ":": ge.punctuation,
  "PseudoOp #": ge.derefOperator,
  "; ,": ge.separator,
  "( )": ge.paren,
  "[ ]": ge.squareBracket,
  "{ }": ge.brace
}), SFe = { __proto__: null, lang: 32, "nth-child": 32, "nth-last-child": 32, "nth-of-type": 32, "nth-last-of-type": 32, dir: 32, "host-context": 32, url: 60, "url-prefix": 60, domain: 60, regexp: 60, selector: 138 }, wFe = { __proto__: null, "@import": 118, "@media": 142, "@charset": 146, "@namespace": 150, "@keyframes": 156, "@supports": 168 }, TFe = { __proto__: null, not: 132, only: 132 }, _Fe = qE.deserialize({
  version: 14,
  states: ":^QYQ[OOO#_Q[OOP#fOWOOOOQP'#Cd'#CdOOQP'#Cc'#CcO#kQ[O'#CfO$_QXO'#CaO$fQ[O'#ChO$qQ[O'#DTO$vQ[O'#DWOOQP'#Em'#EmO${QdO'#DgO%jQ[O'#DtO${QdO'#DvO%{Q[O'#DxO&WQ[O'#D{O&`Q[O'#ERO&nQ[O'#ETOOQS'#El'#ElOOQS'#EW'#EWQYQ[OOO&uQXO'#CdO'jQWO'#DcO'oQWO'#EsO'zQ[O'#EsQOQWOOP(UO#tO'#C_POOO)C@[)C@[OOQP'#Cg'#CgOOQP,59Q,59QO#kQ[O,59QO(aQ[O'#E[O({QWO,58{O)TQ[O,59SO$qQ[O,59oO$vQ[O,59rO(aQ[O,59uO(aQ[O,59wO(aQ[O,59xO)`Q[O'#DbOOQS,58{,58{OOQP'#Ck'#CkOOQO'#DR'#DROOQP,59S,59SO)gQWO,59SO)lQWO,59SOOQP'#DV'#DVOOQP,59o,59oOOQO'#DX'#DXO)qQ`O,59rOOQS'#Cp'#CpO${QdO'#CqO)yQvO'#CsO+ZQtO,5:ROOQO'#Cx'#CxO)lQWO'#CwO+oQWO'#CyO+tQ[O'#DOOOQS'#Ep'#EpOOQO'#Dj'#DjO+|Q[O'#DqO,[QWO'#EtO&`Q[O'#DoO,jQWO'#DrOOQO'#Eu'#EuO)OQWO,5:`O,oQpO,5:bOOQS'#Dz'#DzO,wQWO,5:dO,|Q[O,5:dOOQO'#D}'#D}O-UQWO,5:gO-ZQWO,5:mO-cQWO,5:oOOQS-E8U-E8UO${QdO,59}O-kQ[O'#E^O-xQWO,5;_O-xQWO,5;_POOO'#EV'#EVP.TO#tO,58yPOOO,58y,58yOOQP1G.l1G.lO.zQXO,5:vOOQO-E8Y-E8YOOQS1G.g1G.gOOQP1G.n1G.nO)gQWO1G.nO)lQWO1G.nOOQP1G/Z1G/ZO/XQ`O1G/^O/rQXO1G/aO0YQXO1G/cO0pQXO1G/dO1WQWO,59|O1]Q[O'#DSO1dQdO'#CoOOQP1G/^1G/^O${QdO1G/^O1kQpO,59]OOQS,59_,59_O${QdO,59aO1sQWO1G/mOOQS,59c,59cO1xQ!bO,59eOOQS'#DP'#DPOOQS'#EY'#EYO2QQ[O,59jOOQS,59j,59jO2YQWO'#DjO2eQWO,5:VO2jQWO,5:]O&`Q[O,5:XO&`Q[O'#E_O2rQWO,5;`O2}QWO,5:ZO(aQ[O,5:^OOQS1G/z1G/zOOQS1G/|1G/|OOQS1G0O1G0OO3`QWO1G0OO3eQdO'#EOOOQS1G0R1G0ROOQS1G0X1G0XOOQS1G0Z1G0ZO3pQtO1G/iOOQO,5:x,5:xO4WQ[O,5:xOOQO-E8[-E8[O4eQWO1G0yPOOO-E8T-E8TPOOO1G.e1G.eOOQP7+$Y7+$YOOQP7+$x7+$xO${QdO7+$xOOQS1G/h1G/hO4pQXO'#ErO4wQWO,59nO4|QtO'#EXO5tQdO'#EoO6OQWO,59ZO6TQpO7+$xOOQS1G.w1G.wOOQS1G.{1G.{OOQS7+%X7+%XO6]QWO1G/POOQS-E8W-E8WOOQS1G/U1G/UO${QdO1G/qOOQO1G/w1G/wOOQO1G/s1G/sO6bQWO,5:yOOQO-E8]-E8]O6pQXO1G/xOOQS7+%j7+%jO6wQYO'#CsOOQO'#EQ'#EQO7SQ`O'#EPOOQO'#EP'#EPO7_QWO'#E`O7gQdO,5:jOOQS,5:j,5:jO7rQtO'#E]O${QdO'#E]O8sQdO7+%TOOQO7+%T7+%TOOQO1G0d1G0dO9WQpO<<HdO9`QWO,5;^OOQP1G/Y1G/YOOQS-E8V-E8VO${QdO'#EZO9hQWO,5;ZOOQT1G.u1G.uOOQP<<Hd<<HdOOQS7+$k7+$kO9pQdO7+%]OOQO7+%d7+%dOOQO,5:k,5:kO3hQdO'#EaO7_QWO,5:zOOQS,5:z,5:zOOQS-E8^-E8^OOQS1G0U1G0UO9wQtO,5:wOOQS-E8Z-E8ZOOQO<<Ho<<HoOOQPAN>OAN>OO:xQdO,5:uOOQO-E8X-E8XOOQO<<Hw<<HwOOQO,5:{,5:{OOQO-E8_-E8_OOQS1G0f1G0f",
  stateData: ";[~O#ZOS#[QQ~OUYOXYO]VO^VOqXOxWO![aO!]ZO!i[O!k]O!m^O!p_O!v`O#XRO#bTO~OQfOUYOXYO]VO^VOqXOxWO![aO!]ZO!i[O!k]O!m^O!p_O!v`O#XeO#bTO~O#U#gP~P!ZO#[jO~O#XlO~O]qO^qOqsOtoOxrO!OtO!RvO#VuO#bnO~O!TwO~P#pO`}O#WzO#XyO~O#X!OO~O#X!QO~OQ![Ob!TOf![Oh![On!YOq!ZO#W!WO#X!SO#e!UO~Ob!^O!d!`O!g!aO#X!]O!T#hP~Oh!fOn!YO#X!eO~Oh!hO#X!hO~Ob!^O!d!`O!g!aO#X!]O~O!Y#hP~P%jO]WX]!WX^WXqWXtWXxWX!OWX!RWX!TWX#VWX#bWX~O]!mO~O!Y!nO#U#gX!S#gX~O#U#gX!S#gX~P!ZO#]!qO#^!qO#_!sO~OUYOXYO]VO^VOqXOxWO#XRO#bTO~OtoO!TwO~O`!zO#WzO#XyO~O!S#gP~P!ZOb#RO~Ob#SO~Op#TO|#UO~OP#WObgXjgX!YgX!dgX!ggX#XgXagXQgXfgXhgXngXqgXtgX!XgX#UgX#WgX#egXpgX!SgX~Ob!^Oj#XO!d!`O!g!aO#X!]O!Y#hP~Ob#[O~Op#`O#X#]O~Ob!^O!d!`O!g!aO#X#aO~Ot#eO!b#dO!T#hX!Y#hX~Ob#hO~Oj#XO!Y#jO~O!Y#kO~Oh#lOn!YO~O!T#mO~O!TwO!b#dO~O!TwO!Y#pO~O!Y#QX#U#QX!S#QX~P!ZO!Y!nO#U#ga!S#ga~O#]!qO#^!qO#_#wO~O]qO^qOqsOxrO!OtO!RvO#VuO#bnO~Ot#Oa!T#Oaa#Oa~P.`Op#yO|#zO~O]qO^qOqsOxrO#bnO~Ot}i!O}i!R}i!T}i#V}ia}i~P/aOt!Pi!O!Pi!R!Pi!T!Pi#V!Pia!Pi~P/aOt!Qi!O!Qi!R!Qi!T!Qi#V!Qia!Qi~P/aO!S#{O~Oa#fP~P(aOa#cP~P${Oa$SOj#XO~O!Y$UO~Oh$VOo$VO~Op$XO#X#]O~O]!`Xa!^X!b!^X~O]$YO~Oa$ZO!b#dO~Ot#eO!T#ha!Y#ha~O!b#dOt!ca!T!ca!Y!caa!ca~O!Y$`O~O!S$gO#X$bO#e$aO~Oj#XOt$iO!X$kO!Y!Vi#U!Vi!S!Vi~P${O!Y#Qa#U#Qa!S#Qa~P!ZO!Y!nO#U#gi!S#gi~Oa#fX~P#pOa$oO~Oj#XOQ!{Xa!{Xb!{Xf!{Xh!{Xn!{Xq!{Xt!{X#W!{X#X!{X#e!{X~Ot$qOa#cX~P${Oa$sO~Oj#XOp$tO~Oa$uO~O!b#dOt#Ra!T#Ra!Y#Ra~Oa$wO~P.`OP#WOtgX!TgX~O#e$aOt!sX!T!sX~Ot$yO!TwO~O!S$}O#X$bO#e$aO~Oj#XOQ#PXb#PXf#PXh#PXn#PXq#PXt#PX!X#PX!Y#PX#U#PX#W#PX#X#PX#e#PX!S#PX~Ot$iO!X%QO!Y!Vq#U!Vq!S!Vq~P${Oj#XOp%RO~OtoOa#fa~Ot$qOa#ca~Oa%UO~P${Oj#XOQ#Pab#Paf#Pah#Pan#Paq#Pat#Pa!X#Pa!Y#Pa#U#Pa#W#Pa#X#Pa#e#Pa!S#Pa~Oa!}at!}a~P${O#Zo#[#ej!R#e~",
  goto: "-g#jPPP#kP#nP#w$WP#w$g#wPP$mPPP$s$|$|P%`P$|P$|%z&^PPPP$|&vP&z'Q#wP'W#w'^P#wP#w#wPPP'd'y(WPP#nPP(_(_(i(_P(_P(_(_P#nP#nP#nP(l#nP(o(r(u(|#nP#nP)R)X)h)v)|*S*^*d*n*t*zPPPPPPPPPP+Q+ZP+v+yP,o,r,x-RRkQ_bOPdhw!n#skYOPdhotuvw!n#R#h#skSOPdhotuvw!n#R#h#sQmTR!tnQ{VR!xqQ!x}Q#Z!XR#x!zq![Z]!T!m#S#U#X#q#z$P$Y$i$j$q$v%Sp![Z]!T!m#S#U#X#q#z$P$Y$i$j$q$v%SU$d#m$f$yR$x$cq!XZ]!T!m#S#U#X#q#z$P$Y$i$j$q$v%Sp![Z]!T!m#S#U#X#q#z$P$Y$i$j$q$v%SQ!f^R#l!gT#^!Z#_Q|VR!yqQ!x|R#x!yQ!PWR!{rQ!RXR!|sQxUQ!wpQ#i!cQ#o!jQ#p!kQ${$eR%X$zSgPwQ!phQ#r!nR$l#sZfPhw!n#sa!b[`a!V!^!`#d#eR#b!^R!g^R!i_R#n!iS$e#m$fR%V$yV$c#m$f$yQ!rjR#v!rQdOShPwU!ldh#sR#s!nQ$P#SU$p$P$v%SQ$v$YR%S$qQ#_!ZR$W#_Q$r$PR%T$rQpUS!vp$nR$n#|Q$j#qR%P$jQ!ogS#t!o#uR#u!pQ#f!_R$^#fQ$f#mR$|$fQ$z$eR%W$z_cOPdhw!n#s^UOPdhw!n#sQ!uoQ!}tQ#OuQ#PvQ#|#RR$_#hR$Q#SQ!VZQ!d]Q#V!TQ#q!m[$O#S$P$Y$q$v%SQ$R#UQ$T#XS$h#q$jQ$m#zR%O$iR#}#RQiPR#QwQ!c[Q!kaR#Y!VU!_[a!VQ!j`Q#c!^Q#g!`Q$[#dR$]#e",
  nodeNames: "⚠ Unit VariableName Comment StyleSheet RuleSet UniversalSelector TagSelector TagName NestingSelector ClassSelector ClassName PseudoClassSelector : :: PseudoClassName PseudoClassName ) ( ArgList ValueName ParenthesizedValue ColorLiteral NumberLiteral StringLiteral BinaryExpression BinOp CallExpression Callee CallLiteral CallTag ParenthesizedContent ] [ LineNames LineName , PseudoClassName ArgList IdSelector # IdName AttributeSelector AttributeName MatchOp ChildSelector ChildOp DescendantSelector SiblingSelector SiblingOp } { Block Declaration PropertyName Important ; ImportStatement AtKeyword import KeywordQuery FeatureQuery FeatureName BinaryQuery LogicOp UnaryQuery UnaryQueryOp ParenthesizedQuery SelectorQuery selector MediaStatement media CharsetStatement charset NamespaceStatement namespace NamespaceName KeyframesStatement keyframes KeyframeName KeyframeList KeyframeSelector KeyframeRangeName SupportsStatement supports AtRule Styles",
  maxTerm: 117,
  nodeProps: [
    ["isolate", -2, 3, 24, ""],
    ["openedBy", 17, "(", 32, "[", 50, "{"],
    ["closedBy", 18, ")", 33, "]", 51, "}"]
  ],
  propSources: [EFe],
  skippedNodes: [0, 3, 87],
  repeatNodeCount: 11,
  tokenData: "J^~R!^OX$}X^%u^p$}pq%uqr)Xrs.Rst/utu6duv$}vw7^wx7oxy9^yz9oz{9t{|:_|}?Q}!O?c!O!P@Q!P!Q@i!Q![Ab![!]B]!]!^CX!^!_$}!_!`Cj!`!aC{!a!b$}!b!cDw!c!}$}!}#OFa#O#P$}#P#QFr#Q#R6d#R#T$}#T#UGT#U#c$}#c#dHf#d#o$}#o#pH{#p#q6d#q#rI^#r#sIo#s#y$}#y#z%u#z$f$}$f$g%u$g#BY$}#BY#BZ%u#BZ$IS$}$IS$I_%u$I_$I|$}$I|$JO%u$JO$JT$}$JT$JU%u$JU$KV$}$KV$KW%u$KW&FU$}&FU&FV%u&FV;'S$};'S;=`JW<%lO$}`%QSOy%^z;'S%^;'S;=`%o<%lO%^`%cSo`Oy%^z;'S%^;'S;=`%o<%lO%^`%rP;=`<%l%^~%zh#Z~OX%^X^'f^p%^pq'fqy%^z#y%^#y#z'f#z$f%^$f$g'f$g#BY%^#BY#BZ'f#BZ$IS%^$IS$I_'f$I_$I|%^$I|$JO'f$JO$JT%^$JT$JU'f$JU$KV%^$KV$KW'f$KW&FU%^&FU&FV'f&FV;'S%^;'S;=`%o<%lO%^~'mh#Z~o`OX%^X^'f^p%^pq'fqy%^z#y%^#y#z'f#z$f%^$f$g'f$g#BY%^#BY#BZ'f#BZ$IS%^$IS$I_'f$I_$I|%^$I|$JO'f$JO$JT%^$JT$JU'f$JU$KV%^$KV$KW'f$KW&FU%^&FU&FV'f&FV;'S%^;'S;=`%o<%lO%^l)[UOy%^z#]%^#]#^)n#^;'S%^;'S;=`%o<%lO%^l)sUo`Oy%^z#a%^#a#b*V#b;'S%^;'S;=`%o<%lO%^l*[Uo`Oy%^z#d%^#d#e*n#e;'S%^;'S;=`%o<%lO%^l*sUo`Oy%^z#c%^#c#d+V#d;'S%^;'S;=`%o<%lO%^l+[Uo`Oy%^z#f%^#f#g+n#g;'S%^;'S;=`%o<%lO%^l+sUo`Oy%^z#h%^#h#i,V#i;'S%^;'S;=`%o<%lO%^l,[Uo`Oy%^z#T%^#T#U,n#U;'S%^;'S;=`%o<%lO%^l,sUo`Oy%^z#b%^#b#c-V#c;'S%^;'S;=`%o<%lO%^l-[Uo`Oy%^z#h%^#h#i-n#i;'S%^;'S;=`%o<%lO%^l-uS!X[o`Oy%^z;'S%^;'S;=`%o<%lO%^~.UWOY.RZr.Rrs.ns#O.R#O#P.s#P;'S.R;'S;=`/o<%lO.R~.sOh~~.vRO;'S.R;'S;=`/P;=`O.R~/SXOY.RZr.Rrs.ns#O.R#O#P.s#P;'S.R;'S;=`/o;=`<%l.R<%lO.R~/rP;=`<%l.Rn/zYxQOy%^z!Q%^!Q![0j![!c%^!c!i0j!i#T%^#T#Z0j#Z;'S%^;'S;=`%o<%lO%^l0oYo`Oy%^z!Q%^!Q![1_![!c%^!c!i1_!i#T%^#T#Z1_#Z;'S%^;'S;=`%o<%lO%^l1dYo`Oy%^z!Q%^!Q![2S![!c%^!c!i2S!i#T%^#T#Z2S#Z;'S%^;'S;=`%o<%lO%^l2ZYf[o`Oy%^z!Q%^!Q![2y![!c%^!c!i2y!i#T%^#T#Z2y#Z;'S%^;'S;=`%o<%lO%^l3QYf[o`Oy%^z!Q%^!Q![3p![!c%^!c!i3p!i#T%^#T#Z3p#Z;'S%^;'S;=`%o<%lO%^l3uYo`Oy%^z!Q%^!Q![4e![!c%^!c!i4e!i#T%^#T#Z4e#Z;'S%^;'S;=`%o<%lO%^l4lYf[o`Oy%^z!Q%^!Q![5[![!c%^!c!i5[!i#T%^#T#Z5[#Z;'S%^;'S;=`%o<%lO%^l5aYo`Oy%^z!Q%^!Q![6P![!c%^!c!i6P!i#T%^#T#Z6P#Z;'S%^;'S;=`%o<%lO%^l6WSf[o`Oy%^z;'S%^;'S;=`%o<%lO%^d6gUOy%^z!_%^!_!`6y!`;'S%^;'S;=`%o<%lO%^d7QS|So`Oy%^z;'S%^;'S;=`%o<%lO%^b7cSXQOy%^z;'S%^;'S;=`%o<%lO%^~7rWOY7oZw7owx.nx#O7o#O#P8[#P;'S7o;'S;=`9W<%lO7o~8_RO;'S7o;'S;=`8h;=`O7o~8kXOY7oZw7owx.nx#O7o#O#P8[#P;'S7o;'S;=`9W;=`<%l7o<%lO7o~9ZP;=`<%l7on9cSb^Oy%^z;'S%^;'S;=`%o<%lO%^~9tOa~n9{UUQjWOy%^z!_%^!_!`6y!`;'S%^;'S;=`%o<%lO%^n:fWjW!RQOy%^z!O%^!O!P;O!P!Q%^!Q![>T![;'S%^;'S;=`%o<%lO%^l;TUo`Oy%^z!Q%^!Q![;g![;'S%^;'S;=`%o<%lO%^l;nYo`#e[Oy%^z!Q%^!Q![;g![!g%^!g!h<^!h#X%^#X#Y<^#Y;'S%^;'S;=`%o<%lO%^l<cYo`Oy%^z{%^{|=R|}%^}!O=R!O!Q%^!Q![=j![;'S%^;'S;=`%o<%lO%^l=WUo`Oy%^z!Q%^!Q![=j![;'S%^;'S;=`%o<%lO%^l=qUo`#e[Oy%^z!Q%^!Q![=j![;'S%^;'S;=`%o<%lO%^l>[[o`#e[Oy%^z!O%^!O!P;g!P!Q%^!Q![>T![!g%^!g!h<^!h#X%^#X#Y<^#Y;'S%^;'S;=`%o<%lO%^n?VSt^Oy%^z;'S%^;'S;=`%o<%lO%^l?hWjWOy%^z!O%^!O!P;O!P!Q%^!Q![>T![;'S%^;'S;=`%o<%lO%^n@VU#bQOy%^z!Q%^!Q![;g![;'S%^;'S;=`%o<%lO%^~@nTjWOy%^z{@}{;'S%^;'S;=`%o<%lO%^~AUSo`#[~Oy%^z;'S%^;'S;=`%o<%lO%^lAg[#e[Oy%^z!O%^!O!P;g!P!Q%^!Q![>T![!g%^!g!h<^!h#X%^#X#Y<^#Y;'S%^;'S;=`%o<%lO%^bBbU]QOy%^z![%^![!]Bt!];'S%^;'S;=`%o<%lO%^bB{S^Qo`Oy%^z;'S%^;'S;=`%o<%lO%^nC^S!Y^Oy%^z;'S%^;'S;=`%o<%lO%^dCoS|SOy%^z;'S%^;'S;=`%o<%lO%^bDQU!OQOy%^z!`%^!`!aDd!a;'S%^;'S;=`%o<%lO%^bDkS!OQo`Oy%^z;'S%^;'S;=`%o<%lO%^bDzWOy%^z!c%^!c!}Ed!}#T%^#T#oEd#o;'S%^;'S;=`%o<%lO%^bEk[![Qo`Oy%^z}%^}!OEd!O!Q%^!Q![Ed![!c%^!c!}Ed!}#T%^#T#oEd#o;'S%^;'S;=`%o<%lO%^nFfSq^Oy%^z;'S%^;'S;=`%o<%lO%^nFwSp^Oy%^z;'S%^;'S;=`%o<%lO%^bGWUOy%^z#b%^#b#cGj#c;'S%^;'S;=`%o<%lO%^bGoUo`Oy%^z#W%^#W#XHR#X;'S%^;'S;=`%o<%lO%^bHYS!bQo`Oy%^z;'S%^;'S;=`%o<%lO%^bHiUOy%^z#f%^#f#gHR#g;'S%^;'S;=`%o<%lO%^fIQS!TUOy%^z;'S%^;'S;=`%o<%lO%^nIcS!S^Oy%^z;'S%^;'S;=`%o<%lO%^fItU!RQOy%^z!_%^!_!`6y!`;'S%^;'S;=`%o<%lO%^`JZP;=`<%l$}",
  tokenizers: [yFe, OFe, vFe, 1, 2, 3, 4, new vI("m~RRYZ[z{a~~g~aO#^~~dP!P!Qg~lO#_~~", 28, 105)],
  topRules: { StyleSheet: [0, 4], Styles: [1, 86] },
  specialized: [{ term: 100, get: (t) => SFe[t] || -1 }, { term: 58, get: (t) => wFe[t] || -1 }, { term: 101, get: (t) => TFe[t] || -1 }],
  tokenPrec: 1200
});
let C3 = null;
function x3() {
  if (!C3 && typeof document == "object" && document.body) {
    let { style: t } = document.body, e = [], n = /* @__PURE__ */ new Set();
    for (let r in t)
      r != "cssText" && r != "cssFloat" && typeof t[r] == "string" && (/[A-Z]/.test(r) && (r = r.replace(/[A-Z]/g, (a) => "-" + a.toLowerCase())), n.has(r) || (e.push(r), n.add(r)));
    C3 = e.sort().map((r) => ({ type: "property", label: r }));
  }
  return C3 || [];
}
const dK = /* @__PURE__ */ [
  "active",
  "after",
  "any-link",
  "autofill",
  "backdrop",
  "before",
  "checked",
  "cue",
  "default",
  "defined",
  "disabled",
  "empty",
  "enabled",
  "file-selector-button",
  "first",
  "first-child",
  "first-letter",
  "first-line",
  "first-of-type",
  "focus",
  "focus-visible",
  "focus-within",
  "fullscreen",
  "has",
  "host",
  "host-context",
  "hover",
  "in-range",
  "indeterminate",
  "invalid",
  "is",
  "lang",
  "last-child",
  "last-of-type",
  "left",
  "link",
  "marker",
  "modal",
  "not",
  "nth-child",
  "nth-last-child",
  "nth-last-of-type",
  "nth-of-type",
  "only-child",
  "only-of-type",
  "optional",
  "out-of-range",
  "part",
  "placeholder",
  "placeholder-shown",
  "read-only",
  "read-write",
  "required",
  "right",
  "root",
  "scope",
  "selection",
  "slotted",
  "target",
  "target-text",
  "valid",
  "visited",
  "where"
].map((t) => ({ type: "class", label: t })), pK = /* @__PURE__ */ [
  "above",
  "absolute",
  "activeborder",
  "additive",
  "activecaption",
  "after-white-space",
  "ahead",
  "alias",
  "all",
  "all-scroll",
  "alphabetic",
  "alternate",
  "always",
  "antialiased",
  "appworkspace",
  "asterisks",
  "attr",
  "auto",
  "auto-flow",
  "avoid",
  "avoid-column",
  "avoid-page",
  "avoid-region",
  "axis-pan",
  "background",
  "backwards",
  "baseline",
  "below",
  "bidi-override",
  "blink",
  "block",
  "block-axis",
  "bold",
  "bolder",
  "border",
  "border-box",
  "both",
  "bottom",
  "break",
  "break-all",
  "break-word",
  "bullets",
  "button",
  "button-bevel",
  "buttonface",
  "buttonhighlight",
  "buttonshadow",
  "buttontext",
  "calc",
  "capitalize",
  "caps-lock-indicator",
  "caption",
  "captiontext",
  "caret",
  "cell",
  "center",
  "checkbox",
  "circle",
  "cjk-decimal",
  "clear",
  "clip",
  "close-quote",
  "col-resize",
  "collapse",
  "color",
  "color-burn",
  "color-dodge",
  "column",
  "column-reverse",
  "compact",
  "condensed",
  "contain",
  "content",
  "contents",
  "content-box",
  "context-menu",
  "continuous",
  "copy",
  "counter",
  "counters",
  "cover",
  "crop",
  "cross",
  "crosshair",
  "currentcolor",
  "cursive",
  "cyclic",
  "darken",
  "dashed",
  "decimal",
  "decimal-leading-zero",
  "default",
  "default-button",
  "dense",
  "destination-atop",
  "destination-in",
  "destination-out",
  "destination-over",
  "difference",
  "disc",
  "discard",
  "disclosure-closed",
  "disclosure-open",
  "document",
  "dot-dash",
  "dot-dot-dash",
  "dotted",
  "double",
  "down",
  "e-resize",
  "ease",
  "ease-in",
  "ease-in-out",
  "ease-out",
  "element",
  "ellipse",
  "ellipsis",
  "embed",
  "end",
  "ethiopic-abegede-gez",
  "ethiopic-halehame-aa-er",
  "ethiopic-halehame-gez",
  "ew-resize",
  "exclusion",
  "expanded",
  "extends",
  "extra-condensed",
  "extra-expanded",
  "fantasy",
  "fast",
  "fill",
  "fill-box",
  "fixed",
  "flat",
  "flex",
  "flex-end",
  "flex-start",
  "footnotes",
  "forwards",
  "from",
  "geometricPrecision",
  "graytext",
  "grid",
  "groove",
  "hand",
  "hard-light",
  "help",
  "hidden",
  "hide",
  "higher",
  "highlight",
  "highlighttext",
  "horizontal",
  "hsl",
  "hsla",
  "hue",
  "icon",
  "ignore",
  "inactiveborder",
  "inactivecaption",
  "inactivecaptiontext",
  "infinite",
  "infobackground",
  "infotext",
  "inherit",
  "initial",
  "inline",
  "inline-axis",
  "inline-block",
  "inline-flex",
  "inline-grid",
  "inline-table",
  "inset",
  "inside",
  "intrinsic",
  "invert",
  "italic",
  "justify",
  "keep-all",
  "landscape",
  "large",
  "larger",
  "left",
  "level",
  "lighter",
  "lighten",
  "line-through",
  "linear",
  "linear-gradient",
  "lines",
  "list-item",
  "listbox",
  "listitem",
  "local",
  "logical",
  "loud",
  "lower",
  "lower-hexadecimal",
  "lower-latin",
  "lower-norwegian",
  "lowercase",
  "ltr",
  "luminosity",
  "manipulation",
  "match",
  "matrix",
  "matrix3d",
  "medium",
  "menu",
  "menutext",
  "message-box",
  "middle",
  "min-intrinsic",
  "mix",
  "monospace",
  "move",
  "multiple",
  "multiple_mask_images",
  "multiply",
  "n-resize",
  "narrower",
  "ne-resize",
  "nesw-resize",
  "no-close-quote",
  "no-drop",
  "no-open-quote",
  "no-repeat",
  "none",
  "normal",
  "not-allowed",
  "nowrap",
  "ns-resize",
  "numbers",
  "numeric",
  "nw-resize",
  "nwse-resize",
  "oblique",
  "opacity",
  "open-quote",
  "optimizeLegibility",
  "optimizeSpeed",
  "outset",
  "outside",
  "outside-shape",
  "overlay",
  "overline",
  "padding",
  "padding-box",
  "painted",
  "page",
  "paused",
  "perspective",
  "pinch-zoom",
  "plus-darker",
  "plus-lighter",
  "pointer",
  "polygon",
  "portrait",
  "pre",
  "pre-line",
  "pre-wrap",
  "preserve-3d",
  "progress",
  "push-button",
  "radial-gradient",
  "radio",
  "read-only",
  "read-write",
  "read-write-plaintext-only",
  "rectangle",
  "region",
  "relative",
  "repeat",
  "repeating-linear-gradient",
  "repeating-radial-gradient",
  "repeat-x",
  "repeat-y",
  "reset",
  "reverse",
  "rgb",
  "rgba",
  "ridge",
  "right",
  "rotate",
  "rotate3d",
  "rotateX",
  "rotateY",
  "rotateZ",
  "round",
  "row",
  "row-resize",
  "row-reverse",
  "rtl",
  "run-in",
  "running",
  "s-resize",
  "sans-serif",
  "saturation",
  "scale",
  "scale3d",
  "scaleX",
  "scaleY",
  "scaleZ",
  "screen",
  "scroll",
  "scrollbar",
  "scroll-position",
  "se-resize",
  "self-start",
  "self-end",
  "semi-condensed",
  "semi-expanded",
  "separate",
  "serif",
  "show",
  "single",
  "skew",
  "skewX",
  "skewY",
  "skip-white-space",
  "slide",
  "slider-horizontal",
  "slider-vertical",
  "sliderthumb-horizontal",
  "sliderthumb-vertical",
  "slow",
  "small",
  "small-caps",
  "small-caption",
  "smaller",
  "soft-light",
  "solid",
  "source-atop",
  "source-in",
  "source-out",
  "source-over",
  "space",
  "space-around",
  "space-between",
  "space-evenly",
  "spell-out",
  "square",
  "start",
  "static",
  "status-bar",
  "stretch",
  "stroke",
  "stroke-box",
  "sub",
  "subpixel-antialiased",
  "svg_masks",
  "super",
  "sw-resize",
  "symbolic",
  "symbols",
  "system-ui",
  "table",
  "table-caption",
  "table-cell",
  "table-column",
  "table-column-group",
  "table-footer-group",
  "table-header-group",
  "table-row",
  "table-row-group",
  "text",
  "text-bottom",
  "text-top",
  "textarea",
  "textfield",
  "thick",
  "thin",
  "threeddarkshadow",
  "threedface",
  "threedhighlight",
  "threedlightshadow",
  "threedshadow",
  "to",
  "top",
  "transform",
  "translate",
  "translate3d",
  "translateX",
  "translateY",
  "translateZ",
  "transparent",
  "ultra-condensed",
  "ultra-expanded",
  "underline",
  "unidirectional-pan",
  "unset",
  "up",
  "upper-latin",
  "uppercase",
  "url",
  "var",
  "vertical",
  "vertical-text",
  "view-box",
  "visible",
  "visibleFill",
  "visiblePainted",
  "visibleStroke",
  "visual",
  "w-resize",
  "wait",
  "wave",
  "wider",
  "window",
  "windowframe",
  "windowtext",
  "words",
  "wrap",
  "wrap-reverse",
  "x-large",
  "x-small",
  "xor",
  "xx-large",
  "xx-small"
].map((t) => ({ type: "keyword", label: t })).concat(/* @__PURE__ */ [
  "aliceblue",
  "antiquewhite",
  "aqua",
  "aquamarine",
  "azure",
  "beige",
  "bisque",
  "black",
  "blanchedalmond",
  "blue",
  "blueviolet",
  "brown",
  "burlywood",
  "cadetblue",
  "chartreuse",
  "chocolate",
  "coral",
  "cornflowerblue",
  "cornsilk",
  "crimson",
  "cyan",
  "darkblue",
  "darkcyan",
  "darkgoldenrod",
  "darkgray",
  "darkgreen",
  "darkkhaki",
  "darkmagenta",
  "darkolivegreen",
  "darkorange",
  "darkorchid",
  "darkred",
  "darksalmon",
  "darkseagreen",
  "darkslateblue",
  "darkslategray",
  "darkturquoise",
  "darkviolet",
  "deeppink",
  "deepskyblue",
  "dimgray",
  "dodgerblue",
  "firebrick",
  "floralwhite",
  "forestgreen",
  "fuchsia",
  "gainsboro",
  "ghostwhite",
  "gold",
  "goldenrod",
  "gray",
  "grey",
  "green",
  "greenyellow",
  "honeydew",
  "hotpink",
  "indianred",
  "indigo",
  "ivory",
  "khaki",
  "lavender",
  "lavenderblush",
  "lawngreen",
  "lemonchiffon",
  "lightblue",
  "lightcoral",
  "lightcyan",
  "lightgoldenrodyellow",
  "lightgray",
  "lightgreen",
  "lightpink",
  "lightsalmon",
  "lightseagreen",
  "lightskyblue",
  "lightslategray",
  "lightsteelblue",
  "lightyellow",
  "lime",
  "limegreen",
  "linen",
  "magenta",
  "maroon",
  "mediumaquamarine",
  "mediumblue",
  "mediumorchid",
  "mediumpurple",
  "mediumseagreen",
  "mediumslateblue",
  "mediumspringgreen",
  "mediumturquoise",
  "mediumvioletred",
  "midnightblue",
  "mintcream",
  "mistyrose",
  "moccasin",
  "navajowhite",
  "navy",
  "oldlace",
  "olive",
  "olivedrab",
  "orange",
  "orangered",
  "orchid",
  "palegoldenrod",
  "palegreen",
  "paleturquoise",
  "palevioletred",
  "papayawhip",
  "peachpuff",
  "peru",
  "pink",
  "plum",
  "powderblue",
  "purple",
  "rebeccapurple",
  "red",
  "rosybrown",
  "royalblue",
  "saddlebrown",
  "salmon",
  "sandybrown",
  "seagreen",
  "seashell",
  "sienna",
  "silver",
  "skyblue",
  "slateblue",
  "slategray",
  "snow",
  "springgreen",
  "steelblue",
  "tan",
  "teal",
  "thistle",
  "tomato",
  "turquoise",
  "violet",
  "wheat",
  "white",
  "whitesmoke",
  "yellow",
  "yellowgreen"
].map((t) => ({ type: "constant", label: t }))), CFe = /* @__PURE__ */ [
  "a",
  "abbr",
  "address",
  "article",
  "aside",
  "b",
  "bdi",
  "bdo",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "figcaption",
  "figure",
  "footer",
  "form",
  "header",
  "hgroup",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "label",
  "legend",
  "li",
  "main",
  "meter",
  "nav",
  "ol",
  "output",
  "p",
  "pre",
  "ruby",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "template",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "tr",
  "u",
  "ul"
].map((t) => ({ type: "type", label: t })), Rb = /^(\w[\w-]*|-\w[\w-]*|)$/, xFe = /^-(-[\w-]*)?$/;
function AFe(t, e) {
  var n;
  if ((t.name == "(" || t.type.isError) && (t = t.parent || t), t.name != "ArgList")
    return !1;
  let r = (n = t.parent) === null || n === void 0 ? void 0 : n.firstChild;
  return (r == null ? void 0 : r.name) != "Callee" ? !1 : e.sliceString(r.from, r.to) == "var";
}
const hK = /* @__PURE__ */ new zie(), kFe = ["Declaration"];
function RFe(t) {
  for (let e = t; ; ) {
    if (e.type.isTop)
      return e;
    if (!(e = e.parent))
      return t;
  }
}
function lse(t, e, n) {
  if (e.to - e.from > 4096) {
    let r = hK.get(e);
    if (r)
      return r;
    let a = [], i = /* @__PURE__ */ new Set(), o = e.cursor(ii.IncludeAnonymous);
    if (o.firstChild())
      do
        for (let s of lse(t, o.node, n))
          i.has(s.label) || (i.add(s.label), a.push(s));
      while (o.nextSibling());
    return hK.set(e, a), a;
  } else {
    let r = [], a = /* @__PURE__ */ new Set();
    return e.cursor().iterate((i) => {
      var o;
      if (n(i) && i.matchContext(kFe) && ((o = i.node.nextSibling) === null || o === void 0 ? void 0 : o.name) == ":") {
        let s = t.sliceString(i.from, i.to);
        a.has(s) || (a.add(s), r.push({ label: s, type: "variable" }));
      }
    }), r;
  }
}
const use = (t) => (e) => {
  let { state: n, pos: r } = e, a = $a(n).resolveInner(r, -1), i = a.type.isError && a.from == a.to - 1 && n.doc.sliceString(a.from, a.to) == "-";
  if (a.name == "PropertyName" || (i || a.name == "TagName") && /^(Block|Styles)$/.test(a.resolve(a.to).name))
    return { from: a.from, options: x3(), validFor: Rb };
  if (a.name == "ValueName")
    return { from: a.from, options: pK, validFor: Rb };
  if (a.name == "PseudoClassName")
    return { from: a.from, options: dK, validFor: Rb };
  if (t(a) || (e.explicit || i) && AFe(a, n.doc))
    return {
      from: t(a) || i ? a.from : r,
      options: lse(n.doc, RFe(a), t),
      validFor: xFe
    };
  if (a.name == "TagName") {
    for (let { parent: u } = a; u; u = u.parent)
      if (u.name == "Block")
        return { from: a.from, options: x3(), validFor: Rb };
    return { from: a.from, options: CFe, validFor: Rb };
  }
  if (!e.explicit)
    return null;
  let o = a.resolve(r), s = o.childBefore(r);
  return s && s.name == ":" && o.name == "PseudoClassSelector" ? { from: r, options: dK, validFor: Rb } : s && s.name == ":" && o.name == "Declaration" || o.name == "ArgList" ? { from: r, options: pK, validFor: Rb } : o.name == "Block" || o.name == "Styles" ? { from: r, options: x3(), validFor: Rb } : null;
}, cse = /* @__PURE__ */ use((t) => t.name == "VariableName"), t_ = /* @__PURE__ */ VE.define({
  name: "css",
  parser: /* @__PURE__ */ _Fe.configure({
    props: [
      /* @__PURE__ */ S_.add({
        Declaration: /* @__PURE__ */ kk()
      }),
      /* @__PURE__ */ d1.add({
        "Block KeyframeList": Xie
      })
    ]
  }),
  languageData: {
    commentTokens: { block: { open: "/*", close: "*/" } },
    indentOnInput: /^\s*\}$/,
    wordChars: "-"
  }
});
function fse() {
  return new ZE(t_, t_.data.of({ autocomplete: cse }));
}
const IFe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  css: fse,
  cssCompletionSource: cse,
  cssLanguage: t_,
  defineCSSCompletionSource: use
}, Symbol.toStringTag, { value: "Module" })), DFe = 312, mK = 1, NFe = 2, PFe = 3, LFe = 4, MFe = 313, FFe = 315, $Fe = 316, BFe = 5, UFe = 6, zFe = 0, G4 = [
  9,
  10,
  11,
  12,
  13,
  32,
  133,
  160,
  5760,
  8192,
  8193,
  8194,
  8195,
  8196,
  8197,
  8198,
  8199,
  8200,
  8201,
  8202,
  8232,
  8233,
  8239,
  8287,
  12288
], dse = 125, HFe = 59, V4 = 47, WFe = 42, QFe = 43, jFe = 45, GFe = 60, VFe = 44, YFe = 63, ZFe = 46, XFe = new Voe({
  start: !1,
  shift(t, e) {
    return e == BFe || e == UFe || e == FFe ? t : e == $Fe;
  },
  strict: !1
}), qFe = new Jd((t, e) => {
  let { next: n } = t;
  (n == dse || n == -1 || e.context) && t.acceptToken(MFe);
}, { contextual: !0, fallback: !0 }), KFe = new Jd((t, e) => {
  let { next: n } = t, r;
  G4.indexOf(n) > -1 || n == V4 && ((r = t.peek(1)) == V4 || r == WFe) || n != dse && n != HFe && n != -1 && !e.context && t.acceptToken(DFe);
}, { contextual: !0 }), JFe = new Jd((t, e) => {
  let { next: n } = t;
  if (n == QFe || n == jFe) {
    if (t.advance(), n == t.next) {
      t.advance();
      let r = !e.context && e.canShift(mK);
      t.acceptToken(r ? mK : NFe);
    }
  } else
    n == YFe && t.peek(1) == ZFe && (t.advance(), t.advance(), (t.next < 48 || t.next > 57) && t.acceptToken(PFe));
}, { contextual: !0 });
function A3(t, e) {
  return t >= 65 && t <= 90 || t >= 97 && t <= 122 || t == 95 || t >= 192 || !e && t >= 48 && t <= 57;
}
const e$e = new Jd((t, e) => {
  if (t.next != GFe || !e.dialectEnabled(zFe) || (t.advance(), t.next == V4))
    return;
  let n = 0;
  for (; G4.indexOf(t.next) > -1; )
    t.advance(), n++;
  if (A3(t.next, !0)) {
    for (t.advance(), n++; A3(t.next, !1); )
      t.advance(), n++;
    for (; G4.indexOf(t.next) > -1; )
      t.advance(), n++;
    if (t.next == VFe)
      return;
    for (let r = 0; ; r++) {
      if (r == 7) {
        if (!A3(t.next, !0))
          return;
        break;
      }
      if (t.next != "extends".charCodeAt(r))
        break;
      t.advance(), n++;
    }
  }
  t.acceptToken(LFe, -n);
}), t$e = c1({
  "get set async static": ge.modifier,
  "for while do if else switch try catch finally return throw break continue default case": ge.controlKeyword,
  "in of await yield void typeof delete instanceof": ge.operatorKeyword,
  "let var const using function class extends": ge.definitionKeyword,
  "import export from": ge.moduleKeyword,
  "with debugger as new": ge.keyword,
  TemplateString: ge.special(ge.string),
  super: ge.atom,
  BooleanLiteral: ge.bool,
  this: ge.self,
  null: ge.null,
  Star: ge.modifier,
  VariableName: ge.variableName,
  "CallExpression/VariableName TaggedTemplateExpression/VariableName": ge.function(ge.variableName),
  VariableDefinition: ge.definition(ge.variableName),
  Label: ge.labelName,
  PropertyName: ge.propertyName,
  PrivatePropertyName: ge.special(ge.propertyName),
  "CallExpression/MemberExpression/PropertyName": ge.function(ge.propertyName),
  "FunctionDeclaration/VariableDefinition": ge.function(ge.definition(ge.variableName)),
  "ClassDeclaration/VariableDefinition": ge.definition(ge.className),
  PropertyDefinition: ge.definition(ge.propertyName),
  PrivatePropertyDefinition: ge.definition(ge.special(ge.propertyName)),
  UpdateOp: ge.updateOperator,
  "LineComment Hashbang": ge.lineComment,
  BlockComment: ge.blockComment,
  Number: ge.number,
  String: ge.string,
  Escape: ge.escape,
  ArithOp: ge.arithmeticOperator,
  LogicOp: ge.logicOperator,
  BitOp: ge.bitwiseOperator,
  CompareOp: ge.compareOperator,
  RegExp: ge.regexp,
  Equals: ge.definitionOperator,
  Arrow: ge.function(ge.punctuation),
  ": Spread": ge.punctuation,
  "( )": ge.paren,
  "[ ]": ge.squareBracket,
  "{ }": ge.brace,
  "InterpolationStart InterpolationEnd": ge.special(ge.brace),
  ".": ge.derefOperator,
  ", ;": ge.separator,
  "@": ge.meta,
  TypeName: ge.typeName,
  TypeDefinition: ge.definition(ge.typeName),
  "type enum interface implements namespace module declare": ge.definitionKeyword,
  "abstract global Privacy readonly override": ge.modifier,
  "is keyof unique infer": ge.operatorKeyword,
  JSXAttributeValue: ge.attributeValue,
  JSXText: ge.content,
  "JSXStartTag JSXStartCloseTag JSXSelfCloseEndTag JSXEndTag": ge.angleBracket,
  "JSXIdentifier JSXNameSpacedName": ge.tagName,
  "JSXAttribute/JSXIdentifier JSXAttribute/JSXNameSpacedName": ge.attributeName,
  "JSXBuiltin/JSXIdentifier": ge.standard(ge.tagName)
}), n$e = { __proto__: null, export: 20, as: 25, from: 33, default: 36, async: 41, function: 42, extends: 54, this: 58, true: 66, false: 66, null: 78, void: 82, typeof: 86, super: 102, new: 136, delete: 148, yield: 157, await: 161, class: 166, public: 229, private: 229, protected: 229, readonly: 231, instanceof: 250, satisfies: 253, in: 254, const: 256, import: 290, keyof: 345, unique: 349, infer: 355, is: 391, abstract: 411, implements: 413, type: 415, let: 418, var: 420, using: 423, interface: 429, enum: 433, namespace: 439, module: 441, declare: 445, global: 449, for: 468, of: 477, while: 480, with: 484, do: 488, if: 492, else: 494, switch: 498, case: 504, try: 510, catch: 514, finally: 518, return: 522, throw: 526, break: 530, continue: 534, debugger: 538 }, r$e = { __proto__: null, async: 123, get: 125, set: 127, declare: 189, public: 191, private: 191, protected: 191, static: 193, abstract: 195, override: 197, readonly: 203, accessor: 205, new: 395 }, a$e = { __proto__: null, "<": 187 }, i$e = qE.deserialize({
  version: 14,
  states: "$=dO%TQ^OOO%[Q^OOO'_Q`OOP(lOWOOO*zQ?NdO'#CiO+RO!bO'#CjO+aO#tO'#CjO+oO!0LbO'#D^O.QQ^O'#DdO.bQ^O'#DoO%[Q^O'#DwO0fQ^O'#EPOOQ?Mr'#EX'#EXO1PQWO'#EUOOQO'#Em'#EmOOQO'#Ih'#IhO1XQWO'#GpO1dQWO'#ElO1iQWO'#ElO3hQ?NdO'#JmO6[Q?NdO'#JnO6uQWO'#F[O6zQ&jO'#FsOOQ?Mr'#Fe'#FeO7VO,YO'#FeO7eQ7[O'#FzO9RQWO'#FyOOQ?Mr'#Jn'#JnOOQ?Mp'#Jm'#JmO9WQWO'#GtOOQU'#KZ'#KZO9cQWO'#IUO9hQ?MxO'#IVOOQU'#JZ'#JZOOQU'#IZ'#IZQ`Q^OOO`Q^OOO9pQMnO'#DsO9wQ^O'#D{O:OQ^O'#D}O9^QWO'#GpO:VQ7[O'#CoO:eQWO'#EkO:pQWO'#EvO:uQ7[O'#FdO;dQWO'#GpOOQO'#K['#K[O;iQWO'#K[O;wQWO'#GxO;wQWO'#GyO;wQWO'#G{O9^QWO'#HOO<nQWO'#HRO>VQWO'#CeO>gQWO'#H_O>oQWO'#HeO>oQWO'#HgO`Q^O'#HiO>oQWO'#HkO>oQWO'#HnO>tQWO'#HtO>yQ?MyO'#HzO%[Q^O'#H|O?UQ?MyO'#IOO?aQ?MyO'#IQO9hQ?MxO'#ISO?lQ?NdO'#CiO@nQ`O'#DiQOQWOOO%[Q^O'#D}OAUQWO'#EQO:VQ7[O'#EkOAaQWO'#EkOAlQpO'#FdOOQU'#Cg'#CgOOQ?Mp'#Dn'#DnOOQ?Mp'#Jq'#JqO%[Q^O'#JqOOQO'#Jt'#JtOOQO'#Id'#IdOBlQ`O'#EdOOQ?Mp'#Ec'#EcOOQ?Mp'#Jx'#JxOChQ?NQO'#EdOCrQ`O'#ETOOQO'#Js'#JsODWQ`O'#JtOEeQ`O'#ETOCrQ`O'#EdPErO#@ItO'#CbPOOO)CDx)CDxOOOO'#I['#I[OE}O!bO,59UOOQ?Mr,59U,59UOOOO'#I]'#I]OF]O#tO,59UO%[Q^O'#D`OOOO'#I_'#I_OFkO!0LbO,59xOOQ?Mr,59x,59xOFyQ^O'#I`OG^QWO'#JoOI]QrO'#JoO+}Q^O'#JoOIdQWO,5:OOIzQWO'#EmOJXQWO'#KOOJdQWO'#J}OJdQWO'#J}OJlQWO,5;ZOJqQWO'#J|OOQ?Mv,5:Z,5:ZOJxQ^O,5:ZOLvQ?NdO,5:cOMgQWO,5:kONQQ?MxO'#J{ONXQWO'#JzO9WQWO'#JzONmQWO'#JzONuQWO,5;YONzQWO'#JzO!#PQrO'#JnOOQ?Mr'#Ci'#CiO%[Q^O'#EPO!#oQrO,5:pOOQQ'#Ju'#JuOOQO-E<f-E<fO9^QWO,5=[O!$VQWO,5=[O!$[Q^O,5;WO!&_Q7[O'#EhO!'xQWO,5;WO!'}Q^O'#DvO!(XQ`O,5;aO!(aQ`O,5;aO%[Q^O,5;aOOQU'#FS'#FSOOQU'#FU'#FUO%[Q^O,5;bO%[Q^O,5;bO%[Q^O,5;bO%[Q^O,5;bO%[Q^O,5;bO%[Q^O,5;bO%[Q^O,5;bO%[Q^O,5;bO%[Q^O,5;bO%[Q^O,5;bO%[Q^O,5;bOOQU'#FY'#FYO!(oQ^O,5;sOOQ?Mr,5;x,5;xOOQ?Mr,5;y,5;yOOQ?Mr,5;{,5;{O%[Q^O'#IlO!*rQ?MxO,5<gO!&_Q7[O,5;bO!+aQ7[O,5;bO!-RQ7[O'#EZO%[Q^O,5;vOOQ?Mr,5;z,5;zO!-YQ&jO'#FiO!.VQ&jO'#KSO!-qQ&jO'#KSO!.^Q&jO'#KSOOQO'#KS'#KSO!.rQ&jO,5<ROOOS,5<_,5<_O!/TQ^O'#FuOOOS'#Ik'#IkO7VO,YO,5<PO!/[Q&jO'#FwOOQ?Mr,5<P,5<PO!/{Q!LQO'#CvOOQ?Mr'#Cz'#CzO!0`QWO'#CzO!0eO!0LbO'#DOO!1RQ7[O,5<dO!1YQWO,5<fO!2uQ$ISO'#GVO!3SQWO'#GWO!3XQWO'#GWO!4wQ$ISO'#G[O!5sQ`O'#G`OOQO'#Gk'#GkO!+hQ7[O'#GjOOQO'#Gm'#GmO!+hQ7[O'#GlO!6fQ!LQO'#JgOOQ?Mr'#Jg'#JgO!6pQWO'#JfO!7OQWO'#JeO!7WQWO'#CuOOQ?Mr'#Cx'#CxOOQ?Mr'#DS'#DSOOQ?Mr'#DU'#DUO1SQWO'#DWO!+hQ7[O'#F}O!+hQ7[O'#GPO!7`QWO'#GRO!7eQWO'#GSO!3XQWO'#GYO!+hQ7[O'#G_O!7jQWO'#EnO!8XQWO,5<eOOQ?Mp'#Cr'#CrO!8aQWO'#EoO!9ZQ`O'#EpOOQ?Mp'#J|'#J|O!9bQ?MxO'#K]O9hQ?MxO,5=`O`Q^O,5>pOOQU'#Jc'#JcOOQU,5>q,5>qOOQU-E<X-E<XO!;aQ?NdO,5:_O!9UQ`O,5:]O!=zQ?NdO,5:gO%[Q^O,5:gO!@bQ?NdO,5:iOOQO,5@v,5@vO!ARQ7[O,5=[O!AaQ?MxO'#JdO9RQWO'#JdO!ArQ?MxO,59ZO!A}Q`O,59ZO!BVQ7[O,59ZO:VQ7[O,59ZO!BbQWO,5;WO!BjQWO'#H^O!COQWO'#K`O%[Q^O,5;|O!9UQ`O,5<OO!CWQWO,5=wO!C]QWO,5=wO!CbQWO,5=wO9hQ?MxO,5=wO;wQWO,5=gOOQO'#Cv'#CvO!CpQ`O,5=dO!CxQ7[O,5=eO!DTQWO,5=gO!DYQpO,5=jO!DbQWO'#K[O>tQWO'#HTO9^QWO'#HVO!DgQWO'#HVO:VQ7[O'#HXO!DlQWO'#HXOOQU,5=m,5=mO!DqQWO'#HYO!ESQWO'#CoO!EXQWO,59PO!EcQWO,59PO!GhQ^O,59POOQU,59P,59PO!GxQ?MxO,59PO%[Q^O,59PO!JTQ^O'#HaOOQU'#Hb'#HbOOQU'#Hc'#HcO`Q^O,5=yO!JkQWO,5=yO`Q^O,5>PO`Q^O,5>RO!JpQWO,5>TO`Q^O,5>VO!JuQWO,5>YO!JzQ^O,5>`OOQU,5>f,5>fO%[Q^O,5>fO9hQ?MxO,5>hOOQU,5>j,5>jO# UQWO,5>jOOQU,5>l,5>lO# UQWO,5>lOOQU,5>n,5>nO# rQ`O'#D[O%[Q^O'#JqO# |Q`O'#JqO#!kQ`O'#DjO#!|Q`O'#DjO#%_Q^O'#DjO#%fQWO'#JpO#%nQWO,5:TO#%sQWO'#EqO#&RQWO'#KPO#&ZQWO,5;[O#&`Q`O'#DjO#&mQ`O'#ESOOQ?Mr,5:l,5:lO%[Q^O,5:lO#&tQWO,5:lO>tQWO,5;VO!A}Q`O,5;VO!BVQ7[O,5;VO:VQ7[O,5;VO#&|QWO,5@]O#'RQ(CYO,5:pOOQO-E<b-E<bO#(XQ?NQO,5;OOCrQ`O,5:oO#(cQ`O,5:oOCrQ`O,5;OO!ArQ?MxO,5:oOOQ?Mp'#Eg'#EgOOQO,5;O,5;OO%[Q^O,5;OO#(pQ?MxO,5;OO#({Q?MxO,5;OO!A}Q`O,5:oOOQO,5;U,5;UO#)ZQ?MxO,5;OPOOO'#IY'#IYP#)oO#@ItO,58|POOO,58|,58|OOOO-E<Y-E<YOOQ?Mr1G.p1G.pOOOO-E<Z-E<ZO#)zQpO,59zOOOO-E<]-E<]OOQ?Mr1G/d1G/dO#*PQrO,5>zO+}Q^O,5>zOOQO,5?Q,5?QO#*ZQ^O'#I`OOQO-E<^-E<^O#*hQWO,5@ZO#*pQrO,5@ZO#*wQWO,5@iOOQ?Mr1G/j1G/jO%[Q^O,5@jO#+PQWO'#IfOOQO-E<d-E<dO#*wQWO,5@iOOQ?Mp1G0u1G0uOOQ?Mv1G/u1G/uOOQ?Mv1G0V1G0VO%[Q^O,5@gO#+eQ?MxO,5@gO#+vQ?MxO,5@gO#+}QWO,5@fO9WQWO,5@fO#,VQWO,5@fO#,eQWO'#IiO#+}QWO,5@fOOQ?Mp1G0t1G0tO!(XQ`O,5:rO!(dQ`O,5:rOOQQ,5:t,5:tO#-VQYO,5:tO#-_Q7[O1G2vO9^QWO1G2vOOQ?Mr1G0r1G0rO#-mQ?NdO1G0rO#.rQ?NbO,5;SOOQ?Mr'#GU'#GUO#/`Q?NdO'#JgO!$[Q^O1G0rO#1hQrO'#JrO%[Q^O'#JrO#1rQWO,5:bOOQ?Mr'#D['#D[OOQ?Mr1G0{1G0{O%[Q^O1G0{OOQ?Mr1G1e1G1eO#1wQWO1G0{O#4]Q?NdO1G0|O#4dQ?NdO1G0|O#6zQ?NdO1G0|O#7RQ?NdO1G0|O#9YQ?NdO1G0|O#9pQ?NdO1G0|O#<gQ?NdO1G0|O#<nQ?NdO1G0|O#?OQ?NdO1G0|O#?]Q?NdO1G0|O#AWQ?NdO1G0|O#DWQ07bO'#CiO#FRQ07bO1G1_O#FYQ07bO'#JnO#FmQ?NdO,5?WOOQ?Mp-E<j-E<jO#GaQ?NdO1G0|OOQ?Mr1G0|1G0|O#IiQ7[O'#JwO#IsQWO,5:uO#IxQ?NdO1G1bO#JlQ&jO,5<VO#JtQ&jO,5<WO#J|Q&jO'#FnO#KeQWO'#FmOOQO'#KT'#KTOOQO'#Ij'#IjO#KjQ&jO1G1mOOQ?Mr1G1m1G1mOOOS1G1x1G1xO#K{Q07bO'#JmO#LVQWO,5<aO!(oQ^O,5<aOOOS-E<i-E<iOOQ?Mr1G1k1G1kO#L[Q`O'#KSOOQ?Mr,5<c,5<cO#LdQ`O,5<cOOQ?Mr,59f,59fO!&_Q7[O'#DQOOOO'#I^'#I^O#LiO!0LbO,59jOOQ?Mr,59j,59jO%[Q^O1G2OO!7eQWO'#InO#LtQ7[O,5<xOOQ?Mr,5<u,5<uO!+hQ7[O'#IqO#MdQ7[O,5=UO!+hQ7[O'#IsO#NVQ7[O,5=WO!&_Q7[O,5=YOOQO1G2Q1G2QO#NaQpO'#CrO#NtQ$ISO'#EoO$ sQ`O'#G`O$!aQpO,5<qO$!hQWO'#KWO9WQWO'#KWO$!vQWO,5<sO!+hQ7[O,5<rO$!{QWO'#GXO$#^QWO,5<rO$#cQpO'#GUO$#pQpO'#KXO$#zQWO'#KXO!&_Q7[O'#KXO$$PQWO,5<vO$$UQ`O'#GaO!5nQ`O'#GaO$$gQWO'#GcO$$lQWO'#GeO!3XQWO'#GhO$$qQ?MxO'#IpO$$|Q`O,5<zOOQ?Mv,5<z,5<zO$%TQ`O'#GaO$%cQ`O'#GbO$%kQ`O'#GbO$%pQ7[O,5=UO$&QQ7[O,5=WOOQ?Mr,5=Z,5=ZO!+hQ7[O,5@QO!+hQ7[O,5@QO$&bQWO'#IuO$&mQWO,5@PO$&uQWO,59aO$'iQ!LSO,59rOOQ?Mr'#Jk'#JkO$([Q7[O,5<iO$(}Q7[O,5<kO@fQWO,5<mOOQ?Mr,5<n,5<nO$)XQWO,5<tO$)^Q7[O,5<yO$)nQWO'#JzO!$[Q^O1G2PO$)sQWO1G2PO9WQWO'#J}O9WQWO'#EqO%[Q^O'#EqO9WQWO'#IwO$)xQ?MxO,5@wOOQU1G2z1G2zOOQU1G4[1G4[OOQ?Mr1G/y1G/yOOQ?Mr1G/w1G/wO$+zQ?NdO1G0ROOQU1G2v1G2vO!&_Q7[O1G2vO%[Q^O1G2vO#-bQWO1G2vO$.OQ7[O'#EhOOQ?Mp,5@O,5@OO$.YQ?MxO,5@OOOQU1G.u1G.uO!ArQ?MxO1G.uO!A}Q`O1G.uO!BVQ7[O1G.uO$.kQWO1G0rO$.pQWO'#CiO$.{QWO'#KaO$/TQWO,5=xO$/YQWO'#KaO$/_QWO'#KaO$/mQWO'#I}O$/{QWO,5@zO$0TQrO1G1hOOQ?Mr1G1j1G1jO9^QWO1G3cO@fQWO1G3cO$0[QWO1G3cO$0aQWO1G3cOOQU1G3c1G3cO!DTQWO1G3RO!&_Q7[O1G3OO$0fQWO1G3OOOQU1G3P1G3PO!&_Q7[O1G3PO$0kQWO1G3PO$0sQ`O'#G}OOQU1G3R1G3RO!5nQ`O'#IyO!DYQpO1G3UOOQU1G3U1G3UOOQU,5=o,5=oO$0{Q7[O,5=qO9^QWO,5=qO$$lQWO,5=sO9RQWO,5=sO!A}Q`O,5=sO!BVQ7[O,5=sO:VQ7[O,5=sO$1ZQWO'#K_O$1fQWO,5=tOOQU1G.k1G.kO$1kQ?MxO1G.kO@fQWO1G.kO$1vQWO1G.kO9hQ?MxO1G.kO$4OQrO,5@|O$4]QWO,5@|O9WQWO,5@|O$4hQ^O,5={O$4oQWO,5={OOQU1G3e1G3eO`Q^O1G3eOOQU1G3k1G3kOOQU1G3m1G3mO>oQWO1G3oO$4tQ^O1G3qO$8xQ^O'#HpOOQU1G3t1G3tO$9VQWO'#HvO>tQWO'#HxOOQU1G3z1G3zO$9_Q^O1G3zO9hQ?MxO1G4QOOQU1G4S1G4SOOQ?Mp'#G]'#G]O9hQ?MxO1G4UO9hQ?MxO1G4WO$=fQWO,5@]O!(oQ^O,5;]O9WQWO,5;]O>tQWO,5:UO!(oQ^O,5:UO!A}Q`O,5:UO$=kQ07bO,5:UOOQO,5;],5;]O$=uQ`O'#IaO$>]QWO,5@[OOQ?Mr1G/o1G/oO$>eQ`O'#IgO$>oQWO,5@kOOQ?Mp1G0v1G0vO#!|Q`O,5:UOOQO'#Ic'#IcO$>wQ`O,5:nOOQ?Mv,5:n,5:nO#&wQWO1G0WOOQ?Mr1G0W1G0WO%[Q^O1G0WOOQ?Mr1G0q1G0qO>tQWO1G0qO!A}Q`O1G0qO!BVQ7[O1G0qOOQ?Mp1G5w1G5wO!ArQ?MxO1G0ZOOQO1G0j1G0jO%[Q^O1G0jO$?OQ?MxO1G0jO$?ZQ?MxO1G0jO!A}Q`O1G0ZOCrQ`O1G0ZO$?iQ?MxO1G0jOOQO1G0Z1G0ZO$?}Q?NdO1G0jPOOO-E<W-E<WPOOO1G.h1G.hOOOO1G/f1G/fO$@XQpO,5<gO$@aQrO1G4fOOQO1G4l1G4lO%[Q^O,5>zO$@kQWO1G5uO$@sQWO1G6TO$@{QrO1G6UO9WQWO,5?QO$AVQ?NdO1G6RO%[Q^O1G6RO$AgQ?MxO1G6RO$AxQWO1G6QO$AxQWO1G6QO9WQWO1G6QO$BQQWO,5?TO9WQWO,5?TOOQO,5?T,5?TO$BfQWO,5?TO$)nQWO,5?TOOQO-E<g-E<gOOQQ1G0^1G0^OOQQ1G0`1G0`O#-YQWO1G0`OOQU7+(b7+(bO!&_Q7[O7+(bO%[Q^O7+(bO$BtQWO7+(bO$CPQ7[O7+(bO$C_Q?NdO,5=UO$EgQ?NdO,5=WO$GoQ?NdO,5=UO$I}Q?NdO,5=WO$L]Q?NdO,59rO$NbQ?NdO,5<iO%!jQ?NdO,5<kO%$rQ?NdO,5<yOOQ?Mr7+&^7+&^O%'QQ?NdO7+&^O%'tQ^O'#IbO%(RQWO,5@^O%(ZQrO,5@^OOQ?Mr1G/|1G/|O%(eQWO7+&gOOQ?Mr7+&g7+&gO%(jQ07bO,5:cO%[Q^O7+&yO%(tQ07bO,5:_O%)RQ07bO,5:gO%)]Q07bO,5:iO%)gQ7[O'#IeO%)qQWO,5@cOOQ?Mr1G0a1G0aOOQO1G1q1G1qOOQO1G1r1G1rO%)yQtO,5<YO!(oQ^O,5<XOOQO-E<h-E<hOOQ?Mr7+'X7+'XOOOS7+'d7+'dOOOS1G1{1G1{O%*UQWO1G1{OOQ?Mr1G1}1G1}O%*ZQpO,59lOOOO-E<[-E<[OOQ?Mr1G/U1G/UO%*bQ?NdO7+'jOOQ?Mr,5?Y,5?YO%+UQpO,5?YOOQ?Mr1G2d1G2dP!&_Q7[O'#InPOQ?Mr-E<l-E<lO%+tQ7[O,5?]OOQ?Mr-E<o-E<oO%,gQ7[O,5?_OOQ?Mr-E<q-E<qO%,qQpO1G2tO%,xQpO'#CrO%-`Q7[O'#J}O%-gQ^O'#EqOOQ?Mr1G2]1G2]O%-qQWO'#ImO%.VQWO,5@rO%.VQWO,5@rO%._QWO,5@rO%.jQWO,5@rOOQO1G2_1G2_O%.xQ7[O1G2^O!+hQ7[O1G2^O%/YQ$ISO'#IoO%/gQWO,5@sO!&_Q7[O,5@sO%/oQpO,5@sOOQ?Mr1G2b1G2bOOQ?Mp,5<{,5<{OOQ?Mp,5<|,5<|O$)nQWO,5<|OCcQWO,5<|O!A}Q`O,5<{OOQO'#Gd'#GdO%/yQWO,5<}OOQ?Mp,5=P,5=PO$)nQWO,5=SOOQO,5?[,5?[OOQO-E<n-E<nOOQ?Mv1G2f1G2fO!5nQ`O,5<{O%0RQWO,5<|O$$gQWO,5<}O!5nQ`O,5<|O!+hQ7[O'#IqO%0uQ7[O1G2pO!+hQ7[O'#IsO%1hQ7[O1G2rO%1rQ7[O1G5lO%1|Q7[O1G5lOOQO,5?a,5?aOOQO-E<s-E<sOOQO1G.{1G.{O!9UQ`O,59tO%[Q^O,59tOOQ?Mr,5<h,5<hO%2ZQWO1G2XO!+hQ7[O1G2`O%2`Q?NdO7+'kOOQ?Mr7+'k7+'kO!$[Q^O7+'kO%3SQWO,5;]OOQ?Mp,5?c,5?cOOQ?Mp-E<u-E<uO%3XQpO'#KYO#&wQWO7+(bO4UQrO7+(bO$BwQWO7+(bO%3cQ?NbO'#CiO%3vQ?NbO,5=QO%4hQWO,5=QOOQ?Mp1G5j1G5jOOQU7+$a7+$aO!ArQ?MxO7+$aO!A}Q`O7+$aO!$[Q^O7+&^O%4mQWO'#I|O%5UQWO,5@{OOQO1G3d1G3dO9^QWO,5@{O%5UQWO,5@{O%5^QWO,5@{OOQO,5?i,5?iOOQO-E<{-E<{OOQ?Mr7+'S7+'SO%5cQWO7+(}O9hQ?MxO7+(}O9^QWO7+(}O@fQWO7+(}OOQU7+(m7+(mO%5hQ?NbO7+(jO!&_Q7[O7+(jO%5rQpO7+(kOOQU7+(k7+(kO!&_Q7[O7+(kO%5yQWO'#K^O%6UQWO,5=iOOQO,5?e,5?eOOQO-E<w-E<wOOQU7+(p7+(pO%7eQ`O'#HWOOQU1G3]1G3]O!&_Q7[O1G3]O%[Q^O1G3]O%7lQWO1G3]O%7wQ7[O1G3]O9hQ?MxO1G3_O$$lQWO1G3_O9RQWO1G3_O!A}Q`O1G3_O!BVQ7[O1G3_O%8VQWO'#I{O%8kQWO,5@yO%8sQ`O,5@yOOQ?Mp1G3`1G3`OOQU7+$V7+$VO@fQWO7+$VO9hQ?MxO7+$VO%9OQWO7+$VO%[Q^O1G6hO%[Q^O1G6iO%9TQ?MxO1G6hO%9_Q^O1G3gO%9fQWO1G3gO%9kQ^O1G3gOOQU7+)P7+)PO9hQ?MxO7+)ZO`Q^O7+)]OOQU'#Kd'#KdOOQU'#JO'#JOO%9rQ^O,5>[OOQU,5>[,5>[O%[Q^O'#HqO%:PQWO'#HsOOQU,5>b,5>bO9WQWO,5>bOOQU,5>d,5>dOOQU7+)f7+)fOOQU7+)l7+)lOOQU7+)p7+)pOOQU7+)r7+)rO%:UQ`O1G5wO%:jQ07bO1G0wO%:tQWO1G0wOOQO1G/p1G/pO%;PQ07bO1G/pO>tQWO1G/pO!(oQ^O'#DjOOQO,5>{,5>{OOQO-E<_-E<_OOQO,5?R,5?ROOQO-E<e-E<eO!A}Q`O1G/pOOQO-E<a-E<aOOQ?Mv1G0Y1G0YOOQ?Mr7+%r7+%rO#&wQWO7+%rOOQ?Mr7+&]7+&]O>tQWO7+&]O!A}Q`O7+&]OOQO7+%u7+%uO$?}Q?NdO7+&UOOQO7+&U7+&UO%[Q^O7+&UO%;ZQ?MxO7+&UO!ArQ?MxO7+%uO!A}Q`O7+%uO%;fQ?MxO7+&UO%;tQ?NdO7++mO%[Q^O7++mO%<UQWO7++lO%<UQWO7++lOOQO1G4o1G4oO9WQWO1G4oO%<^QWO1G4oOOQQ7+%z7+%zO#&wQWO<<K|O4UQrO<<K|O%<lQWO<<K|OOQU<<K|<<K|O!&_Q7[O<<K|O%[Q^O<<K|O%<tQWO<<K|O%=PQ?NdO,5?]O%?XQ?NdO,5?_O%AaQ?NdO1G2^O%CoQ?NdO1G2pO%EwQ?NdO1G2rO%HPQrO,5>|O%[Q^O,5>|OOQO-E<`-E<`O%HZQWO1G5xOOQ?Mr<<JR<<JRO%HcQ07bO1G0rO%JjQ07bO1G0|O%JqQ07bO1G0|O%LrQ07bO1G0|O%LyQ07bO1G0|O%NkQ07bO1G0|O& RQ07bO1G0|O&#cQ07bO1G0|O&#jQ07bO1G0|O&%eQ07bO1G0|O&%rQ07bO1G0|O&'mQ07bO1G0|O&(QQ?NdO<<JeO&)VQ07bO1G0|O&*xQ07bO'#JgO&,{Q07bO1G1bO&-YQ07bO1G0RO&-dQ7[O,5?POOQO-E<c-E<cO!(oQ^O'#FpOOQO'#KU'#KUOOQO1G1t1G1tO&-nQWO1G1sO&-sQ07bO,5?WOOOS7+'g7+'gOOOO1G/W1G/WOOQ?Mr1G4t1G4tO!+hQ7[O7+(`O&0TQrO'#CiO&0_QWO,5?XO9WQWO,5?XOOQO-E<k-E<kO&0mQWO1G6^O&0mQWO1G6^O&0uQWO1G6^O&1QQ7[O7+'xO&1bQpO,5?ZO&1lQWO,5?ZO!&_Q7[O,5?ZOOQO-E<m-E<mO&1qQpO1G6_O&1{QWO1G6_OOQ?Mp1G2h1G2hO$)nQWO1G2hOOQ?Mp1G2g1G2gO&2TQWO1G2iO!&_Q7[O1G2iOOQ?Mp1G2n1G2nO!A}Q`O1G2gOCcQWO1G2hO&2YQWO1G2iO&2bQWO1G2hO&3UQ7[O,5?]OOQ?Mr-E<p-E<pO&3wQ7[O,5?_OOQ?Mr-E<r-E<rO!+hQ7[O7++WOOQ?Mr1G/`1G/`O&4RQWO1G/`OOQ?Mr7+'s7+'sO&4WQ7[O7+'zO&4hQ?NdO<<KVOOQ?Mr<<KV<<KVO&5[QWO1G0wO!&_Q7[O'#IvO&5aQWO,5@tO&7cQrO<<K|O!&_Q7[O1G2lOOQU<<G{<<G{O!ArQ?MxO<<G{O&7jQ?NdO<<IxOOQ?Mr<<Ix<<IxOOQO,5?h,5?hO&8^QWO,5?hO&8cQWO,5?hOOQO-E<z-E<zO&8qQWO1G6gO&8qQWO1G6gO9^QWO1G6gO@fQWO<<LiOOQU<<Li<<LiO&8yQWO<<LiO9hQ?MxO<<LiOOQU<<LU<<LUO%5hQ?NbO<<LUOOQU<<LV<<LVO%5rQpO<<LVO&9OQ`O'#IxO&9ZQWO,5@xO!(oQ^O,5@xOOQU1G3T1G3TO%-gQ^O'#JqOOQO'#Iz'#IzO9hQ?MxO'#IzO&9cQ`O,5=rOOQU,5=r,5=rO&9jQ`O'#EdO&:OQWO7+(wO&:TQWO7+(wOOQU7+(w7+(wO!&_Q7[O7+(wO%[Q^O7+(wO&:]QWO7+(wOOQU7+(y7+(yO9hQ?MxO7+(yO$$lQWO7+(yO9RQWO7+(yO!A}Q`O7+(yO&:hQWO,5?gOOQO-E<y-E<yOOQO'#HZ'#HZO&:sQWO1G6eO9hQ?MxO<<GqOOQU<<Gq<<GqO@fQWO<<GqO&:{QWO7+,SO&;QQWO7+,TO%[Q^O7+,SO%[Q^O7+,TOOQU7+)R7+)RO&;VQWO7+)RO&;[Q^O7+)RO&;cQWO7+)ROOQU<<Lu<<LuOOQU<<Lw<<LwOOQU-E<|-E<|OOQU1G3v1G3vO&;hQWO,5>]OOQU,5>_,5>_O&;mQWO1G3|O9WQWO7+&cO!(oQ^O7+&cOOQO7+%[7+%[O&;rQ07bO1G6UO>tQWO7+%[OOQ?Mr<<I^<<I^OOQ?Mr<<Iw<<IwO>tQWO<<IwOOQO<<Ip<<IpO$?}Q?NdO<<IpO%[Q^O<<IpOOQO<<Ia<<IaO!ArQ?MxO<<IaO&;|Q?MxO<<IpO&<XQ?NdO<= XO&<iQWO<= WOOQO7+*Z7+*ZO9WQWO7+*ZOOQUANAhANAhO&<qQrOANAhO!&_Q7[OANAhO#&wQWOANAhO4UQrOANAhO&<xQWOANAhO%[Q^OANAhO&=QQ?NdO7+'xO&?`Q?NdO,5?]O&AhQ?NdO,5?_O&CpQ?NdO7+'zO&FOQrO1G4hO&FYQ07bO7+&^O&HZQ07bO,5=UO&J_Q07bO,5=WO&JoQ07bO,5=UO&KPQ07bO,5=WO&KaQ07bO,59rO&MdQ07bO,5<iO' dQ07bO,5<kO'#dQ07bO,5<yO'%VQ07bO7+'jO'%dQ07bO7+'kO'%qQWO,5<[OOQO7+'_7+'_O'%vQ7[O<<KzOOQO1G4s1G4sO'%}QWO1G4sO'&YQWO1G4sO'&hQWO7++xO'&hQWO7++xO!&_Q7[O1G4uO'&pQpO1G4uO'&zQWO7++yOOQ?Mp7+(S7+(SO$)nQWO7+(TO''SQpO7+(TOOQ?Mp7+(R7+(RO$)nQWO7+(SO''ZQWO7+(TO!&_Q7[O7+(TOCcQWO7+(SO''`Q7[O<<NrOOQ?Mr7+$z7+$zO''jQpO,5?bOOQO-E<t-E<tO''tQ?NbO7+(WOOQUAN=gAN=gO9^QWO1G5SOOQO1G5S1G5SO'(UQWO1G5SO'(ZQWO7+,RO'(ZQWO7+,RO9hQ?MxOANBTO@fQWOANBTOOQUANBTANBTOOQUANApANApOOQUANAqANAqO'(cQWO,5?dOOQO-E<v-E<vO'(nQ07bO1G6dOOQO,5?f,5?fOOQO-E<x-E<xOOQU1G3^1G3^O%-gQ^O,5<}OOQU<<Lc<<LcO!&_Q7[O<<LcO&:OQWO<<LcO'(xQWO<<LcO%[Q^O<<LcOOQU<<Le<<LeO9hQ?MxO<<LeO$$lQWO<<LeO9RQWO<<LeO')QQ`O1G5RO')]QWO7+,POOQUAN=]AN=]O9hQ?MxOAN=]OOQU<= n<= nOOQU<= o<= oO')eQWO<= nO')jQWO<= oOOQU<<Lm<<LmO')oQWO<<LmO')tQ^O<<LmOOQU1G3w1G3wO>tQWO7+)hO'){QWO<<I}O'*WQ07bO<<I}OOQO<<Hv<<HvOOQ?MrAN?cAN?cOOQOAN?[AN?[O$?}Q?NdOAN?[OOQOAN>{AN>{O%[Q^OAN?[OOQO<<Mu<<MuOOQUG27SG27SO!&_Q7[OG27SO#&wQWOG27SO'*bQrOG27SO4UQrOG27SO'*iQWOG27SO'*qQ07bO<<JeO'+OQ07bO1G2^O',qQ07bO,5?]O'.qQ07bO,5?_O'0qQ07bO1G2pO'2qQ07bO1G2rO'4qQ07bO<<KVO'5OQ07bO<<IxOOQO1G1v1G1vO!+hQ7[OANAfOOQO7+*_7+*_O'5]QWO7+*_O'5hQWO<= dO'5pQpO7+*aOOQ?Mp<<Ko<<KoO$)nQWO<<KoOOQ?Mp<<Kn<<KnO'5zQpO<<KoO$)nQWO<<KnOOQO7+*n7+*nO9^QWO7+*nO'6RQWO<= mOOQUG27oG27oO9hQ?MxOG27oO!(oQ^O1G5OO'6ZQWO7+,OO&:OQWOANA}OOQUANA}ANA}O!&_Q7[OANA}O'6cQWOANA}OOQUANBPANBPO9hQ?MxOANBPO$$lQWOANBPOOQO'#H['#H[OOQO7+*m7+*mOOQUG22wG22wOOQUANEYANEYOOQUANEZANEZOOQUANBXANBXO'6kQWOANBXOOQU<<MS<<MSO!(oQ^OAN?iOOQOG24vG24vO$?}Q?NdOG24vO#&wQWOLD,nOOQULD,nLD,nO!&_Q7[OLD,nO'6pQrOLD,nO'6wQ07bO7+'xO'8jQ07bO,5?]O':jQ07bO,5?_O'<jQ07bO7+'zO'>]Q7[OG27QOOQO<<My<<MyOOQ?MpANAZANAZO$)nQWOANAZOOQ?MpANAYANAYOOQO<<NY<<NYOOQULD-ZLD-ZO'>mQ07bO7+*jOOQUG27iG27iO&:OQWOG27iO!&_Q7[OG27iOOQUG27kG27kO9hQ?MxOG27kOOQUG27sG27sO'>wQ07bOG25TOOQOLD*bLD*bOOQU!$(!Y!$(!YO#&wQWO!$(!YO!&_Q7[O!$(!YO'?RQ?NdOG27QOOQ?MpG26uG26uOOQULD-TLD-TO&:OQWOLD-TOOQULD-VLD-VOOQU!)9Et!)9EtO#&wQWO!)9EtOOQU!$(!o!$(!oOOQU!.K;`!.K;`O'AaQ07bOG27QO!(oQ^O'#DwO1PQWO'#EUO'CSQrO'#JmO'CZQMnO'#DsO'CbQ^O'#D{O'CiQrO'#CiO'FPQrO'#CiO!(oQ^O'#D}O'FaQ^O,5;WO!(oQ^O,5;bO!(oQ^O,5;bO!(oQ^O,5;bO!(oQ^O,5;bO!(oQ^O,5;bO!(oQ^O,5;bO!(oQ^O,5;bO!(oQ^O,5;bO!(oQ^O,5;bO!(oQ^O,5;bO!(oQ^O,5;bO!(oQ^O'#IlO'HdQWO,5<gO'HlQ7[O,5;bO'JVQ7[O,5;bO!(oQ^O,5;vO!&_Q7[O'#GjO'HlQ7[O'#GjO!&_Q7[O'#GlO'HlQ7[O'#GlO1SQWO'#DWO1SQWO'#DWO!&_Q7[O'#F}O'HlQ7[O'#F}O!&_Q7[O'#GPO'HlQ7[O'#GPO!&_Q7[O'#G_O'HlQ7[O'#G_O!(oQ^O,5:gO'J^Q`O'#D[O!(oQ^O,5@jO'FaQ^O1G0rO'JhQ07bO'#CiO!(oQ^O1G2OO!&_Q7[O'#IqO'HlQ7[O'#IqO!&_Q7[O'#IsO'HlQ7[O'#IsO'JrQpO'#CrO!&_Q7[O,5<rO'HlQ7[O,5<rO'FaQ^O1G2PO!(oQ^O7+&yO!&_Q7[O1G2^O'HlQ7[O1G2^O!&_Q7[O'#IqO'HlQ7[O'#IqO!&_Q7[O'#IsO'HlQ7[O'#IsO!&_Q7[O1G2`O'HlQ7[O1G2`O'FaQ^O7+'kO'FaQ^O7+&^O!&_Q7[OANAfO'HlQ7[OANAfO'KVQWO'#ElO'K[QWO'#ElO'KdQWO'#F[O'KiQWO'#EvO'KnQWO'#KOO'KyQWO'#J|O'LUQWO,5;WO'LZQ7[O,5<dO'LbQWO'#GWO'LgQWO'#GWO'LlQWO,5<eO'LtQWO,5;WO'L|Q07bO1G1_O'MTQWO,5<rO'MYQWO,5<rO'M_QWO,5<tO'MdQWO,5<tO'MiQWO1G2PO'MnQWO1G0rO'MsQ7[O<<KzO'MzQ7[O<<KzO7eQ7[O'#FzO9RQWO'#FyOAaQWO'#EkO!(oQ^O,5;sO!3XQWO'#GWO!3XQWO'#GWO!3XQWO'#GYO!3XQWO'#GYO!+hQ7[O7+(`O!+hQ7[O7+(`O%,qQpO1G2tO%,qQpO1G2tO!&_Q7[O,5=YO!&_Q7[O,5=Y",
  stateData: "( O~O'wOS'xOSTOS'yRQ~OPYOQYOSfOY!VOaqOdzOeyOmkOoYOpkOqkOwkOyYO{YO!PWO!TkO!UkO![XO!fuO!iZO!lYO!mYO!nYO!pvO!rwO!uxO!y]O#t!PO$V|O%e}O%g!QO%i!OO%j!OO%k!OO%n!RO%p!SO%s!TO%t!TO%v!UO&S!WO&Y!XO&[!YO&^!ZO&`![O&c!]O&i!^O&o!_O&q!`O&s!aO&u!bO&w!cO(OSO(QTO(TUO([VO(j[O(yiO~OWtO~P`OPYOQYOSfOd!jOe!iOmkOoYOpkOqkOwkOyYO{YO!PWO!TkO!UkO![!eO!fuO!iZO!lYO!mYO!nYO!pvO!r!gO!u!hO$V!kO(O!dO(QTO(TUO([VO(j[O(yiO~Oa!wOp!nO!P!oO!_!yO!`!vO!a!vO!y:lO#Q!pO#R!pO#S!xO#T!pO#U!pO#X!zO#Y!zO(P!lO(QTO(TUO(`!mO(j!sO~O'y!{O~OP]XR]X[]Xa]Xo]X}]X!P]X!Y]X!i]X!m]X#O]X#P]X#]]X#hfX#k]X#l]X#m]X#n]X#o]X#p]X#q]X#r]X#s]X#u]X#w]X#y]X#z]X$P]X'u]X([]X(m]X(t]X(u]X~O!d%PX~P(qO_!}O(Q#PO(R!}O(S#PO~O_#QO(S#PO(T#PO(U#QO~Ou#SO!R#TO(]#TO(^#VO~OPYOQYOSfOd!jOe!iOmkOoYOpkOqkOwkOyYO{YO!PWO!TkO!UkO![!eO!fuO!iZO!lYO!mYO!nYO!pvO!r!gO!u!hO$V!kO(O:pO(QTO(TUO([VO(j[O(yiO~O!X#ZO!Y#WO!V(cP!V(qP~P+}O!Z#cO~P`OPYOQYOSfOd!jOe!iOoYOpkOqkOwkOyYO{YO!PWO!TkO!UkO![!eO!fuO!iZO!lYO!mYO!nYO!pvO!r!gO!u!hO$V!kO(QTO(TUO([VO(j[O(yiO~Om#mO!X#iO!y]O#f#lO#g#iO(O:qO!h(nP~P.iO!i#oO(O#nO~O!u#sO!y]O%e#tO~O#h#uO~O!d#vO#h#uO~OP$]OR#zO[$cOo$QO}#yO!P#{O!Y$`O!i#xO!m$]O#O$SO#k$OO#l$PO#m$PO#n$PO#o$RO#p$SO#q$SO#r$bO#s$SO#u$TO#w$VO#y$XO#z$YO([VO(m$ZO(t#|O(u#}O~Oa(aX'u(aX's(aX!h(aX!V(aX![(aX%f(aX!d(aX~P1qO#P$dO#]$eO$P$eOP(bXR(bX[(bXo(bX}(bX!P(bX!Y(bX!i(bX!m(bX#O(bX#k(bX#l(bX#m(bX#n(bX#o(bX#p(bX#q(bX#r(bX#s(bX#u(bX#w(bX#y(bX#z(bX([(bX(m(bX(t(bX(u(bX![(bX%f(bX~Oa(bX'u(bX's(bX!V(bX!h(bXs(bX!d(bX~P4UO#]$eO~O$[$hO$^$gO$e$mO~OSfO![$nO$h$oO$j$qO~Oh%WOm%XOo$uOp$tOq$tOw%YOy%ZO{%[O!P$|O![$}O!f%aO!i$yO#g%bO$V%_O$r%]O$t%^O$w%`O(O$sO(QTO(TUO([$vO(t%OO(u%QOg(XP~O!i%cO~O!P%fO![%gO(O%eO~O!d%kO~Oa%lO'u%lO~O}%pO~P%[O(P!lO~P%[O%k%tO~P%[Oh%WO!i%cO(O%eO(P!lO~Oe%{O!i%cO(O%eO~O#s$SO~O}&QO![%}O!i&PO%g&TO(O%eO(P!lO(QTO(TUO`)SP~O!u#sO~O%p&VO!P)OX![)OX(O)OX~O(O&WO~O!r&]O#t!PO%g!QO%i!OO%j!OO%k!OO%n!RO%p!SO%s!TO%t!TO~Od&bOe&aO!u&_O%e&`O%x&^O~P;|Od&eOeyO![&dO!r&]O!uxO!y]O#t!PO%e}O%i!OO%j!OO%k!OO%n!RO%p!SO%s!TO%t!TO%v!UO~Ob&hO#]&kO%g&fO(P!lO~P=RO!i&lO!r&pO~O!i#oO~O![XO~Oa%lO't&xO'u%lO~Oa%lO't&{O'u%lO~Oa%lO't&}O'u%lO~O's]X!V]Xs]X!h]X&W]X![]X%f]X!d]X~P(qO!_'[O!`'TO!a'TO(P!lO(QTO(TUO~Op'RO!P'QO!X'UO(`'PO!Z(dP!Z(sP~P@YOk'_O![']O(O%eO~Oe'dO!i%cO(O%eO~O}&QO!i&PO~Op!nO!P!oO!y:lO#Q!pO#R!pO#T!pO#U!pO(P!lO(QTO(TUO(`!mO(j!sO~O!_'jO!`'iO!a'iO#S!pO#X'kO#Y'kO~PAtOa%lOh%WO!d#vO!i%cO'u%lO(m'mO~O!m'qO#]'oO~PCSOp!nO!P!oO(QTO(TUO(`!mO(j!sO~O![XOp(hX!P(hX!_(hX!`(hX!a(hX!y(hX#Q(hX#R(hX#S(hX#T(hX#U(hX#X(hX#Y(hX(P(hX(Q(hX(T(hX(`(hX(j(hX~O!`'iO!a'iO(P!lO~PCrO'z'uO'{'uO'|'wO~O_!}O(Q'yO(R!}O(S'yO~O_#QO(S'yO(T'yO(U#QO~Ou#SO!R#TO(]#TO(^'}O~O!X(PO!V'SX!V'YX!Y'SX!Y'YX~P+}O!Y(RO!V(cX~OP$]OR#zO[$cOo$QO}#yO!P#{O!Y(RO!i#xO!m$]O#O$SO#k$OO#l$PO#m$PO#n$PO#o$RO#p$SO#q$SO#r$bO#s$SO#u$TO#w$VO#y$XO#z$YO([VO(m$ZO(t#|O(u#}O~O!V(cX~PGfO!V(WO~O!V(pX!Y(pX!d(pX!h(pX(m(pX~O#](pX#h#aX!Z(pX~PIiO#](XO!V(rX!Y(rX~O!Y(YO!V(qX~O!V(]O~O#]$eO~PIiO!Z(^O~P`OR#zO}#yO!P#{O!i#xO([VOP!ka[!kao!ka!Y!ka!m!ka#O!ka#k!ka#l!ka#m!ka#n!ka#o!ka#p!ka#q!ka#r!ka#s!ka#u!ka#w!ka#y!ka#z!ka(m!ka(t!ka(u!ka~Oa!ka'u!ka's!ka!V!ka!h!kas!ka![!ka%f!ka!d!ka~PKPO!h(_O~O!d#vO#](`O(m'mO!Y(oXa(oX'u(oX~O!h(oX~PMlO!P%fO![%gO!y]O#f(eO#g(dO(O%eO~O!Y(fO!h(nX~O!h(hO~O!P%fO![%gO#g(dO(O%eO~OP(bXR(bX[(bXo(bX}(bX!P(bX!Y(bX!i(bX!m(bX#O(bX#k(bX#l(bX#m(bX#n(bX#o(bX#p(bX#q(bX#r(bX#s(bX#u(bX#w(bX#y(bX#z(bX([(bX(m(bX(t(bX(u(bX~O!d#vO!h(bX~P! YOR(jO}(iO!i#xO#P$dO!y!xa!P!xa~O!u!xa%e!xa![!xa#f!xa#g!xa(O!xa~P!#ZO!u(nO~OPYOQYOSfOd!jOe!iOmkOoYOpkOqkOwkOyYO{YO!PWO!TkO!UkO![XO!fuO!iZO!lYO!mYO!nYO!pvO!r!gO!u!hO$V!kO(O!dO(QTO(TUO([VO(j[O(yiO~Oh%WOm%XOo$uOp$tOq$tOw%YOy%ZO{;YO!P$|O![$}O!f<jO!i$yO#g;`O$V%_O$r;[O$t;^O$w%`O(O(rO(QTO(TUO([$vO(t%OO(u%QO~O#h(tO~O!X(vO!h(fP~P%[O(`(xO(j[O~O!P(zO!i#xO(`(xO(j[O~OP:kOQ:kOSfOd<fOe!iOmkOo:kOpkOqkOwkOy:kO{:kO!PWO!TkO!UkO![!eO!f:nO!iZO!l:kO!m:kO!n:kO!p:oO!r:rO!u!hO$V!kO(O)YO(QTO(TUO([VO(j[O(y<dO~O!Y$`Oa$oa'u$oa's$oa!h$oa!V$oa![$oa%f$oa!d$oa~O#t)`O~P!&_Oh%WOm%XOo$uOp$tOq$tOw%YOy%ZO{%[O!P$|O![$}O!f%aO!i$yO#g%bO$V%_O$r%]O$t%^O$w%`O(O(rO(QTO(TUO([$vO(t%OO(u%QO~Og(kP~P!+hO})eO!d)dO![$]X$Y$]X$[$]X$^$]X$e$]X~O!d)dO![(vX$Y(vX$[(vX$^(vX$e(vX~O})eO~P!-qO})eO![(vX$Y(vX$[(vX$^(vX$e(vX~O![)gO$Y)kO$[)fO$^)fO$e)lO~O!X)oO~P!(oO$[$hO$^$gO$e)sO~Ok$xX}$xX!P$xX#P$xX(t$xX(u$xX~OgjXg$xXkjX!YjX#]jX~P!/gOp)uO~Ou)vO(])wO(^)yO~Ok*SO}){O!P)|O(t%OO(u%QO~Og)zO~P!0pOg*TO~Oh%WOm%XOo$uOp$tOq$tOw%YOy%ZO{;YO!P*VO![*WO!f<jO!i$yO#g;`O$V%_O$r;[O$t;^O$w%`O(QTO(TUO([$vO(t%OO(u%QO~O!X*ZO(O*UO!h(zP~P!1_O#h*]O~O!i*^O~Oh%WOm%XOo$uOp$tOq$tOw%YOy%ZO{;YO!P$|O![$}O!f<jO!i$yO#g;`O$V%_O$r;[O$t;^O$w%`O(O*`O(QTO(TUO([$vO(t%OO(u%QO~O!X*cO!V({P~P!3^Oo*oO!P*gO!_*mO!`*fO!a*fO!i*^O#X*nO%]*iO(P!lO(`!mO~O!Z*lO~P!5RO#P$dOk(ZX}(ZX!P(ZX(t(ZX(u(ZX!Y(ZX#](ZX~Og(ZX#}(ZX~P!5zOk*tO#]*sOg(YX!Y(YX~O!Y*uOg(XX~O(O&WOg(XP~O!i*|O~O(O(rO~Om+QO!P%fO!X#iO![%gO!y]O#f#lO#g#iO(O%eO!h(nP~O!d#vO#h+RO~O!P%fO!X+TO!Y(YO![%gO(O%eO!V(qP~Op'XO!P+VO!X+UO(QTO(TUO(`(xO~O!Z(sP~P!8uO!Y+WOa)PX'u)PX~OP$]OR#zO[$cOo$QO}#yO!P#{O!i#xO!m$]O#O$SO#k$OO#l$PO#m$PO#n$PO#o$RO#p$SO#q$SO#r$bO#s$SO#u$TO#w$VO#y$XO#z$YO([VO(m$ZO(t#|O(u#}O~Oa!ga!Y!ga'u!ga's!ga!V!ga!h!gas!ga![!ga%f!ga!d!ga~P!9mOR#zO}#yO!P#{O!i#xO([VOP!oa[!oao!oa!Y!oa!m!oa#O!oa#k!oa#l!oa#m!oa#n!oa#o!oa#p!oa#q!oa#r!oa#s!oa#u!oa#w!oa#y!oa#z!oa(m!oa(t!oa(u!oa~Oa!oa'u!oa's!oa!V!oa!h!oas!oa![!oa%f!oa!d!oa~P!<TOR#zO}#yO!P#{O!i#xO([VOP!qa[!qao!qa!Y!qa!m!qa#O!qa#k!qa#l!qa#m!qa#n!qa#o!qa#p!qa#q!qa#r!qa#s!qa#u!qa#w!qa#y!qa#z!qa(m!qa(t!qa(u!qa~Oa!qa'u!qa's!qa!V!qa!h!qas!qa![!qa%f!qa!d!qa~P!>kOh%WOk+aO![']O%f+`O~O!d+cOa(WX![(WX'u(WX!Y(WX~Oa%lO![XO'u%lO~Oh%WO!i%cO~Oh%WO!i%cO(O%eO~O!d#vO#h(tO~Ob+nO%g+oO(O+kO(QTO(TUO!Z)TP~O!Y+pO`)SX~O[+tO~O`+uO~O![%}O(O%eO(P!lO`)SP~Oh%WO#]+zO~Oh%WOk+}O![$}O~O![,PO~O},RO![XO~O%k%tO~O!u,WO~Oe,]O~Ob,^O(O#nO(QTO(TUO!Z)RP~Oe%{O~O%g!QO(O&WO~P=RO[,cO`,bO~OPYOQYOSfOdzOeyOmkOoYOpkOqkOwkOyYO{YO!PWO!TkO!UkO!fuO!iZO!lYO!mYO!nYO!pvO!uxO!y]O%e}O(QTO(TUO([VO(j[O(yiO~O![!eO!r!gO$V!kO(O!dO~P!EkO`,bOa%lO'u%lO~OPYOQYOSfOd!jOe!iOmkOoYOpkOqkOwkOyYO{YO!PWO!TkO!UkO![!eO!fuO!iZO!lYO!mYO!nYO!pvO!u!hO$V!kO(O!dO(QTO(TUO([VO(j[O(yiO~Oa,hO!rwO#t!OO%i!OO%j!OO%k!OO~P!HTO!i&lO~O&Y,nO~O![,pO~O&k,rO&m,sOP&haQ&haS&haY&haa&had&hae&ham&hao&hap&haq&haw&hay&ha{&ha!P&ha!T&ha!U&ha![&ha!f&ha!i&ha!l&ha!m&ha!n&ha!p&ha!r&ha!u&ha!y&ha#t&ha$V&ha%e&ha%g&ha%i&ha%j&ha%k&ha%n&ha%p&ha%s&ha%t&ha%v&ha&S&ha&Y&ha&[&ha&^&ha&`&ha&c&ha&i&ha&o&ha&q&ha&s&ha&u&ha&w&ha's&ha(O&ha(Q&ha(T&ha([&ha(j&ha(y&ha!Z&ha&a&hab&ha&f&ha~O(O,xO~Oh!bX!Y!OX!Z!OX!d!OX!d!bX!i!bX#]!OX~O!Y!bX!Z!bX~P# ZO!d,}O#],|Oh(eX!Y#eX!Y(eX!Z#eX!Z(eX!d(eX!i(eX~Oh%WO!d-PO!i%cO!Y!^X!Z!^X~Op!nO!P!oO(QTO(TUO(`!mO~OP:kOQ:kOSfOd<fOe!iOmkOo:kOpkOqkOwkOy:kO{:kO!PWO!TkO!UkO![!eO!f:nO!iZO!l:kO!m:kO!n:kO!p:oO!r:rO!u!hO$V!kO(QTO(TUO([VO(j[O(y<dO~O(O;fO~P##_O!Y-TO!Z(dX~O!Z-VO~O!d,}O#],|O!Y#eX!Z#eX~O!Y-WO!Z(sX~O!Z-YO~O!`-ZO!a-ZO(P!lO~P#!|O!Z-^O~P'_Ok-aO![']O~O!V-fO~Op!xa!_!xa!`!xa!a!xa#Q!xa#R!xa#S!xa#T!xa#U!xa#X!xa#Y!xa(P!xa(Q!xa(T!xa(`!xa(j!xa~P!#ZO!m-kO#]-iO~PCSO!`-mO!a-mO(P!lO~PCrOa%lO#]-iO'u%lO~Oa%lO!d#vO#]-iO'u%lO~Oa%lO!d#vO!m-kO#]-iO'u%lO(m'mO~O'z'uO'{'uO'|-rO~Os-sO~O!V'Sa!Y'Sa~P!9mO!X-wO!V'SX!Y'SX~P%[O!Y(RO!V(ca~O!V(ca~PGfO!Y(YO!V(qa~O!P%fO!X-{O![%gO(O%eO!V'YX!Y'YX~O#]-}O!Y(oa!h(oaa(oa'u(oa~O!d#vO~P#+eO!Y(fO!h(na~O!P%fO![%gO#g.RO(O%eO~Om.WO!P%fO!X.TO![%gO!y]O#f.VO#g.TO(O%eO!Y']X!h']X~OR.[O!i#xO~Oh%WOk._O![']O%f.^O~Oa#`i!Y#`i'u#`i's#`i!V#`i!h#`is#`i![#`i%f#`i!d#`i~P!9mOk<pO}){O!P)|O(t%OO(u%QO~O#h#[aa#[a#]#[a'u#[a!Y#[a!h#[a![#[a!V#[a~P#.aO#h(ZXP(ZXR(ZX[(ZXa(ZXo(ZX!i(ZX!m(ZX#O(ZX#k(ZX#l(ZX#m(ZX#n(ZX#o(ZX#p(ZX#q(ZX#r(ZX#s(ZX#u(ZX#w(ZX#y(ZX#z(ZX'u(ZX([(ZX(m(ZX!h(ZX!V(ZX's(ZXs(ZX![(ZX%f(ZX!d(ZX~P!5zO!Y.lO!h(fX~P!9mO!h.oO~O!V.qO~OP$]OR#zO}#yO!P#{O!i#xO!m$]O([VO[#jia#jio#ji!Y#ji#O#ji#l#ji#m#ji#n#ji#o#ji#p#ji#q#ji#r#ji#s#ji#u#ji#w#ji#y#ji#z#ji'u#ji(m#ji(t#ji(u#ji's#ji!V#ji!h#jis#ji![#ji%f#ji!d#ji~O#k#ji~P#1|O#k$OO~P#1|OP$]OR#zO}#yO!P#{O!i#xO!m$]O#k$OO#l$PO#m$PO#n$PO([VO[#jia#ji!Y#ji#O#ji#o#ji#p#ji#q#ji#r#ji#s#ji#u#ji#w#ji#y#ji#z#ji'u#ji(m#ji(t#ji(u#ji's#ji!V#ji!h#jis#ji![#ji%f#ji!d#ji~Oo#ji~P#4kOo$QO~P#4kOP$]OR#zOo$QO}#yO!P#{O!i#xO!m$]O#k$OO#l$PO#m$PO#n$PO#o$RO([VOa#ji!Y#ji#u#ji#w#ji#y#ji#z#ji'u#ji(m#ji(t#ji(u#ji's#ji!V#ji!h#jis#ji![#ji%f#ji!d#ji~O[#ji#O#ji#p#ji#q#ji#r#ji#s#ji~P#7YO[$cO#O$SO#p$SO#q$SO#r$bO#s$SO~P#7YOP$]OR#zO[$cOo$QO}#yO!P#{O!i#xO!m$]O#O$SO#k$OO#l$PO#m$PO#n$PO#o$RO#p$SO#q$SO#r$bO#s$SO#u$TO([VO(u#}Oa#ji!Y#ji#y#ji#z#ji'u#ji(m#ji(t#ji's#ji!V#ji!h#jis#ji![#ji%f#ji!d#ji~O#w$VO~P#:WO#w#ji~P#:WOP$]OR#zO[$cOo$QO}#yO!P#{O!i#xO!m$]O#O$SO#k$OO#l$PO#m$PO#n$PO#o$RO#p$SO#q$SO#r$bO#s$SO#u$TO([VOa#ji!Y#ji#y#ji#z#ji'u#ji(m#ji's#ji!V#ji!h#jis#ji![#ji%f#ji!d#ji~O#w#ji(t#ji(u#ji~P#<uO#w$VO(t#|O(u#}O~P#<uOP$]OR#zO[$cOo$QO}#yO!P#{O!i#xO!m$]O#O$SO#k$OO#l$PO#m$PO#n$PO#o$RO#p$SO#q$SO#r$bO#s$SO#u$TO#w$VO#y$XO([VO(t#|O(u#}O~Oa#ji!Y#ji#z#ji'u#ji(m#ji's#ji!V#ji!h#jis#ji![#ji%f#ji!d#ji~P#?jOP]XR]X[]Xo]X}]X!P]X!i]X!m]X#O]X#P]X#]]X#hfX#k]X#l]X#m]X#n]X#o]X#p]X#q]X#r]X#s]X#u]X#w]X#y]X#z]X$P]X([]X(m]X(t]X(u]X!Y]X!Z]X~O#}]X~P#BQOP$]OR#zO[;SOo:vO}#yO!P#{O!i#xO!m$]O#O:xO#k:tO#l:uO#m:uO#n:uO#o:wO#p:xO#q:xO#r;RO#s:xO#u:yO#w:{O#y:}O#z;OO([VO(m$ZO(t#|O(u#}O~O#}.sO~P#D_O#P$dO#];TO$P;TO#}(bX!Z(bX~P! YOa'`a!Y'`a'u'`a's'`a!h'`a!V'`as'`a!['`a%f'`a!d'`a~P!9mOP#jiR#ji[#jia#jio#ji!Y#ji!i#ji!m#ji#O#ji#k#ji#l#ji#m#ji#n#ji#o#ji#p#ji#q#ji#r#ji#s#ji#u#ji#w#ji#y#ji#z#ji'u#ji([#ji(m#ji's#ji!V#ji!h#jis#ji![#ji%f#ji!d#ji~P#.aO!Y.wOg(kX~P!0pOg.yO~Oa$Oi!Y$Oi'u$Oi's$Oi!V$Oi!h$Ois$Oi![$Oi%f$Oi!d$Oi~P!9mO$[.zO$^.zO~O$[.{O$^.{O~O!d)dO#].|O![$bX$Y$bX$[$bX$^$bX$e$bX~O!X.}O~O![)gO$Y/PO$[)fO$^)fO$e/QO~O!Y;PO!Z(aX~P#D_O!Z/RO~O!d)dO$e(vX~O$e/TO~Ou)vO(])wO(^/WO~O!V/[O~P!&_O(t%OOk%^a}%^a!P%^a(u%^a!Y%^a#]%^a~Og%^a#}%^a~P#L{O(u%QOk%`a}%`a!P%`a(t%`a!Y%`a#]%`a~Og%`a#}%`a~P#MnO!YfX!dfX!hfX!h$xX(mfX~P!/gO!X/eO!Y(YO(O/dO!V(qP!V({P~P!1_Oo*oO!_*mO!`*fO!a*fO!i*^O#X*nO%]*iO(P!lO~Op'XO!P/fO!X+UO!Z*lO(QTO(TUO(`;cO!Z(sP~P$ XO!h/gO~P#.aO!Y/hO!d#vO(m'mO!h(zX~O!h/mO~O!P%fO!X*ZO![%gO(O%eO!h(zP~O#h/oO~O!V$xX!Y$xX!d%PX~P!/gO!Y/pO!V({X~P#.aO!d/rO~O!V/tO~Oh%WOo/xO!d#vO!i%cO(m'mO~O(O/zO~O!d+cO~Oa%lO!Y0OO'u%lO~O!Z0QO~P!5RO!`0RO!a0RO(P!lO(`!mO~O!P0TO(`!mO~O#X0UO~Og%^a!Y%^a#]%^a#}%^a~P!0pOg%`a!Y%`a#]%`a#}%`a~P!0pO(O&WOg'iX!Y'iX~O!Y*uOg(Xa~Og0_O~OR0`O}0`O!P0aO#P$dOkza(tza(uza!Yza#]za~Ogza#}za~P$&zO}){O!P)|Ok$qa(t$qa(u$qa!Y$qa#]$qa~Og$qa#}$qa~P$'sO}){O!P)|Ok$sa(t$sa(u$sa!Y$sa#]$sa~Og$sa#}$sa~P$(fO#h0dO~Og%Ra!Y%Ra#]%Ra#}%Ra~P!0pO!d#vO~O#h0gO~O!Y+WOa)Pa'u)Pa~OR#zO}#yO!P#{O!i#xO([VOP!oi[!oio!oi!Y!oi!m!oi#O!oi#k!oi#l!oi#m!oi#n!oi#o!oi#p!oi#q!oi#r!oi#s!oi#u!oi#w!oi#y!oi#z!oi(m!oi(t!oi(u!oi~Oa!oi'u!oi's!oi!V!oi!h!ois!oi![!oi%f!oi!d!oi~P$*TOh%WOo$uOp$tOq$tOw%YOy%ZO{;YO!P$|O![$}O!f<jO!i$yO#g;`O$V%_O$r;[O$t;^O$w%`O(QTO(TUO([$vO(t%OO(u%QO~Om0pO(O0oO~P$,kO!d+cOa(Wa![(Wa'u(Wa!Y(Wa~O#h0vO~O[]X!YfX!ZfX~O!Y0wO!Z)TX~O!Z0yO~O[0zO~Ob0|O(O+kO(QTO(TUO~O![%}O(O%eO`'qX!Y'qX~O!Y+pO`)Sa~O!h1PO~P!9mO[1SO~O`1TO~O#]1WO~Ok1ZO![$}O~O(`(xO!Z)QP~Oh%WOk1dO![1aO%f1cO~O[1nO!Y1lO!Z)RX~O!Z1oO~O`1qOa%lO'u%lO~O(O#nO(QTO(TUO~O#P$dO#]$eO$P$eOP(bXR(bX[(bXo(bX}(bX!P(bX!Y(bX!i(bX!m(bX#O(bX#k(bX#l(bX#m(bX#n(bX#o(bX#p(bX#q(bX#r(bX#u(bX#w(bX#y(bX#z(bX([(bX(m(bX(t(bX(u(bX~O#s1tO&W1uOa(bX~P$2RO#]$eO#s1tO&W1uO~Oa1wO~P%[Oa1yO~O&a1|OP&_iQ&_iS&_iY&_ia&_id&_ie&_im&_io&_ip&_iq&_iw&_iy&_i{&_i!P&_i!T&_i!U&_i![&_i!f&_i!i&_i!l&_i!m&_i!n&_i!p&_i!r&_i!u&_i!y&_i#t&_i$V&_i%e&_i%g&_i%i&_i%j&_i%k&_i%n&_i%p&_i%s&_i%t&_i%v&_i&S&_i&Y&_i&[&_i&^&_i&`&_i&c&_i&i&_i&o&_i&q&_i&s&_i&u&_i&w&_i's&_i(O&_i(Q&_i(T&_i([&_i(j&_i(y&_i!Z&_ib&_i&f&_i~Ob2SO!Z2QO&f2RO~P`O![XO!i2UO~O&m,sOP&hiQ&hiS&hiY&hia&hid&hie&him&hio&hip&hiq&hiw&hiy&hi{&hi!P&hi!T&hi!U&hi![&hi!f&hi!i&hi!l&hi!m&hi!n&hi!p&hi!r&hi!u&hi!y&hi#t&hi$V&hi%e&hi%g&hi%i&hi%j&hi%k&hi%n&hi%p&hi%s&hi%t&hi%v&hi&S&hi&Y&hi&[&hi&^&hi&`&hi&c&hi&i&hi&o&hi&q&hi&s&hi&u&hi&w&hi's&hi(O&hi(Q&hi(T&hi([&hi(j&hi(y&hi!Z&hi&a&hib&hi&f&hi~O!V2[O~O!Y!^a!Z!^a~P#D_Op!nO!P!oO!X2bO(`!mO!Y'TX!Z'TX~P@YO!Y-TO!Z(da~O!Y'ZX!Z'ZX~P!8uO!Y-WO!Z(sa~O!Z2iO~P'_Oa%lO#]2rO'u%lO~Oa%lO!d#vO#]2rO'u%lO~Oa%lO!d#vO!m2vO#]2rO'u%lO(m'mO~Oa%lO'u%lO~P!9mO!Y$`Os$oa~O!V'Si!Y'Si~P!9mO!Y(RO!V(ci~O!Y(YO!V(qi~O!V(ri!Y(ri~P!9mO!Y(oi!h(oia(oi'u(oi~P!9mO#]2xO!Y(oi!h(oia(oi'u(oi~O!Y(fO!h(ni~O!P%fO![%gO!y]O#f2}O#g2|O(O%eO~O!P%fO![%gO#g2|O(O%eO~Ok3UO![']O%f3TO~Oh%WOk3UO![']O%f3TO~O#h%^aP%^aR%^a[%^aa%^ao%^a!i%^a!m%^a#O%^a#k%^a#l%^a#m%^a#n%^a#o%^a#p%^a#q%^a#r%^a#s%^a#u%^a#w%^a#y%^a#z%^a'u%^a([%^a(m%^a!h%^a!V%^a's%^as%^a![%^a%f%^a!d%^a~P#L{O#h%`aP%`aR%`a[%`aa%`ao%`a!i%`a!m%`a#O%`a#k%`a#l%`a#m%`a#n%`a#o%`a#p%`a#q%`a#r%`a#s%`a#u%`a#w%`a#y%`a#z%`a'u%`a([%`a(m%`a!h%`a!V%`a's%`as%`a![%`a%f%`a!d%`a~P#MnO#h%^aP%^aR%^a[%^aa%^ao%^a!Y%^a!i%^a!m%^a#O%^a#k%^a#l%^a#m%^a#n%^a#o%^a#p%^a#q%^a#r%^a#s%^a#u%^a#w%^a#y%^a#z%^a'u%^a([%^a(m%^a!h%^a!V%^a's%^a#]%^as%^a![%^a%f%^a!d%^a~P#.aO#h%`aP%`aR%`a[%`aa%`ao%`a!Y%`a!i%`a!m%`a#O%`a#k%`a#l%`a#m%`a#n%`a#o%`a#p%`a#q%`a#r%`a#s%`a#u%`a#w%`a#y%`a#z%`a'u%`a([%`a(m%`a!h%`a!V%`a's%`a#]%`as%`a![%`a%f%`a!d%`a~P#.aO#hzaPza[zaazaoza!iza!mza#Oza#kza#lza#mza#nza#oza#pza#qza#rza#sza#uza#wza#yza#zza'uza([za(mza!hza!Vza'szasza![za%fza!dza~P$&zO#h$qaP$qaR$qa[$qaa$qao$qa!i$qa!m$qa#O$qa#k$qa#l$qa#m$qa#n$qa#o$qa#p$qa#q$qa#r$qa#s$qa#u$qa#w$qa#y$qa#z$qa'u$qa([$qa(m$qa!h$qa!V$qa's$qas$qa![$qa%f$qa!d$qa~P$'sO#h$saP$saR$sa[$saa$sao$sa!i$sa!m$sa#O$sa#k$sa#l$sa#m$sa#n$sa#o$sa#p$sa#q$sa#r$sa#s$sa#u$sa#w$sa#y$sa#z$sa'u$sa([$sa(m$sa!h$sa!V$sa's$sas$sa![$sa%f$sa!d$sa~P$(fO#h%RaP%RaR%Ra[%Raa%Rao%Ra!Y%Ra!i%Ra!m%Ra#O%Ra#k%Ra#l%Ra#m%Ra#n%Ra#o%Ra#p%Ra#q%Ra#r%Ra#s%Ra#u%Ra#w%Ra#y%Ra#z%Ra'u%Ra([%Ra(m%Ra!h%Ra!V%Ra's%Ra#]%Ras%Ra![%Ra%f%Ra!d%Ra~P#.aOa#`q!Y#`q'u#`q's#`q!V#`q!h#`qs#`q![#`q%f#`q!d#`q~P!9mO!X3^O!Y'UX!h'UX~P%[O!Y.lO!h(fa~O!Y.lO!h(fa~P!9mO!V3aO~O#}!ka!Z!ka~PKPO#}!ga!Y!ga!Z!ga~P#D_O#}!oa!Z!oa~P!<TO#}!qa!Z!qa~P!>kOg'XX!Y'XX~P!+hO!Y.wOg(ka~OSfO![3uO$c3vO~O!Z3zO~Os3{O~P#.aOa$lq!Y$lq'u$lq's$lq!V$lq!h$lqs$lq![$lq%f$lq!d$lq~P!9mO!V3|O~P#.aO}){O!P)|O(u%QOk'ea(t'ea!Y'ea#]'ea~Og'ea#}'ea~P%+]O}){O!P)|Ok'ga(t'ga(u'ga!Y'ga#]'ga~Og'ga#}'ga~P%,OO(m$ZO~P#.aO!VfX!V$xX!YfX!Y$xX!d%PX#]fX~P!/gO(O;lO~P!1_OmkO(O4OO~P.iO!P%fO!X4QO![%gO(O%eO!Y'aX!h'aX~O!Y/hO!h(za~O!Y/hO!d#vO!h(za~O!Y/hO!d#vO(m'mO!h(za~Og$zi!Y$zi#]$zi#}$zi~P!0pO!X4YO!V'cX!Y'cX~P!3^O!Y/pO!V({a~O!Y/pO!V({a~P#.aO!d#vO#s4bO~Oo4eO!d#vO(m'mO~O(t%OOk%^i}%^i!P%^i(u%^i!Y%^i#]%^i~Og%^i#}%^i~P%0^O(u%QOk%`i}%`i!P%`i(t%`i!Y%`i#]%`i~Og%`i#}%`i~P%1POg(Yi!Y(Yi~P!0pO#]4lOg(Yi!Y(Yi~P!0pO!h4oO~Oa$mq!Y$mq'u$mq's$mq!V$mq!h$mqs$mq![$mq%f$mq!d$mq~P!9mO!V4sO~O!Y4tO![(|X~P#.aOa$xX![$xX%Z]X'u$xX!Y$xX~P!/gO%Z4wOalXklX}lX!PlX![lX'ulX(tlX(ulX!YlX~O%Z4wO~Ob4}O%g5OO(O+kO(QTO(TUO!Y'pX!Z'pX~O!Y0wO!Z)Ta~O[5SO~O`5TO~Oa%lO'u%lO~P#.aO![$}O~P#.aO!Y5]O#]5_O!Z)QX~O!Z5`O~Op!nO!P5aO!_!yO!`!vO!a!vO!y:lO#Q!pO#R!pO#S!pO#T!pO#U!pO#X5fO#Y!zO(P!lO(QTO(TUO(`!mO(j!sO~O!Z5eO~P%6ZOk5kO![1aO%f5jO~Oh%WOk5kO![1aO%f5jO~Ob5rO(O#nO(QTO(TUO!Y'oX!Z'oX~O!Y1lO!Z)Ra~O(QTO(TUO(`5tO~O`5xO~O#s5{O&W5|O~PMlO!h5}O~P%[Oa6PO~Oa6PO~P%[Ob2SO!Z6UO&f2RO~P`O!d6WO~O!d6YOh(ei!Y(ei!Z(ei!d(ei!i(ei~O!Y#ei!Z#ei~P#D_O#]6ZO!Y#ei!Z#ei~O!Y!^i!Z!^i~P#D_Oa%lO#]6dO'u%lO~Oa%lO!d#vO#]6dO'u%lO~O!Y(oq!h(oqa(oq'u(oq~P!9mO!Y(fO!h(nq~O!P%fO![%gO#g6kO(O%eO~O![']O%f6nO~Ok6rO![']O%f6nO~O#h'eaP'eaR'ea['eaa'eao'ea!i'ea!m'ea#O'ea#k'ea#l'ea#m'ea#n'ea#o'ea#p'ea#q'ea#r'ea#s'ea#u'ea#w'ea#y'ea#z'ea'u'ea(['ea(m'ea!h'ea!V'ea's'eas'ea!['ea%f'ea!d'ea~P%+]O#h'gaP'gaR'ga['gaa'gao'ga!i'ga!m'ga#O'ga#k'ga#l'ga#m'ga#n'ga#o'ga#p'ga#q'ga#r'ga#s'ga#u'ga#w'ga#y'ga#z'ga'u'ga(['ga(m'ga!h'ga!V'ga's'gas'ga!['ga%f'ga!d'ga~P%,OO#h$ziP$ziR$zi[$zia$zio$zi!Y$zi!i$zi!m$zi#O$zi#k$zi#l$zi#m$zi#n$zi#o$zi#p$zi#q$zi#r$zi#s$zi#u$zi#w$zi#y$zi#z$zi'u$zi([$zi(m$zi!h$zi!V$zi's$zi#]$zis$zi![$zi%f$zi!d$zi~P#.aO#h%^iP%^iR%^i[%^ia%^io%^i!i%^i!m%^i#O%^i#k%^i#l%^i#m%^i#n%^i#o%^i#p%^i#q%^i#r%^i#s%^i#u%^i#w%^i#y%^i#z%^i'u%^i([%^i(m%^i!h%^i!V%^i's%^is%^i![%^i%f%^i!d%^i~P%0^O#h%`iP%`iR%`i[%`ia%`io%`i!i%`i!m%`i#O%`i#k%`i#l%`i#m%`i#n%`i#o%`i#p%`i#q%`i#r%`i#s%`i#u%`i#w%`i#y%`i#z%`i'u%`i([%`i(m%`i!h%`i!V%`i's%`is%`i![%`i%f%`i!d%`i~P%1PO!Y'Ua!h'Ua~P!9mO!Y.lO!h(fi~O#}#`i!Y#`i!Z#`i~P#D_OP$]OR#zO}#yO!P#{O!i#xO!m$]O([VO[#jio#ji#O#ji#l#ji#m#ji#n#ji#o#ji#p#ji#q#ji#r#ji#s#ji#u#ji#w#ji#y#ji#z#ji#}#ji(m#ji(t#ji(u#ji!Y#ji!Z#ji~O#k#ji~P%HpO#k:tO~P%HpOP$]OR#zO}#yO!P#{O!i#xO!m$]O#k:tO#l:uO#m:uO#n:uO([VO[#ji#O#ji#o#ji#p#ji#q#ji#r#ji#s#ji#u#ji#w#ji#y#ji#z#ji#}#ji(m#ji(t#ji(u#ji!Y#ji!Z#ji~Oo#ji~P%JxOo:vO~P%JxOP$]OR#zOo:vO}#yO!P#{O!i#xO!m$]O#k:tO#l:uO#m:uO#n:uO#o:wO([VO#u#ji#w#ji#y#ji#z#ji#}#ji(m#ji(t#ji(u#ji!Y#ji!Z#ji~O[#ji#O#ji#p#ji#q#ji#r#ji#s#ji~P%MQO[;SO#O:xO#p:xO#q:xO#r;RO#s:xO~P%MQOP$]OR#zO[;SOo:vO}#yO!P#{O!i#xO!m$]O#O:xO#k:tO#l:uO#m:uO#n:uO#o:wO#p:xO#q:xO#r;RO#s:xO#u:yO([VO(u#}O#y#ji#z#ji#}#ji(m#ji(t#ji!Y#ji!Z#ji~O#w:{O~P& iO#w#ji~P& iOP$]OR#zO[;SOo:vO}#yO!P#{O!i#xO!m$]O#O:xO#k:tO#l:uO#m:uO#n:uO#o:wO#p:xO#q:xO#r;RO#s:xO#u:yO([VO#y#ji#z#ji#}#ji(m#ji!Y#ji!Z#ji~O#w#ji(t#ji(u#ji~P&#qO#w:{O(t#|O(u#}O~P&#qOP$]OR#zO[;SOo:vO}#yO!P#{O!i#xO!m$]O#O:xO#k:tO#l:uO#m:uO#n:uO#o:wO#p:xO#q:xO#r;RO#s:xO#u:yO#w:{O#y:}O([VO(t#|O(u#}O~O#z#ji#}#ji(m#ji!Y#ji!Z#ji~P&&POa#{y!Y#{y'u#{y's#{y!V#{y!h#{ys#{y![#{y%f#{y!d#{y~P!9mOk<qO}){O!P)|O(t%OO(u%QO~OP#jiR#ji[#jio#ji!i#ji!m#ji#O#ji#k#ji#l#ji#m#ji#n#ji#o#ji#p#ji#q#ji#r#ji#s#ji#u#ji#w#ji#y#ji#z#ji#}#ji([#ji(m#ji!Y#ji!Z#ji~P&(tO#P$dOP(ZXR(ZX[(ZXk(ZXo(ZX}(ZX!P(ZX!i(ZX!m(ZX#O(ZX#k(ZX#l(ZX#m(ZX#n(ZX#o(ZX#p(ZX#q(ZX#r(ZX#s(ZX#u(ZX#w(ZX#y(ZX#z(ZX#}(ZX([(ZX(m(ZX(t(ZX(u(ZX!Y(ZX!Z(ZX~O#}$Oi!Y$Oi!Z$Oi~P#D_O#}!oi!Z!oi~P$*TOg'Xa!Y'Xa~P!0pO!Z7UO~O!Y'`a!Z'`a~P#D_OP]XR]X[]Xo]X}]X!P]X!V]X!Y]X!i]X!m]X#O]X#P]X#]]X#hfX#k]X#l]X#m]X#n]X#o]X#p]X#q]X#r]X#s]X#u]X#w]X#y]X#z]X$P]X([]X(m]X(t]X(u]X~O!d%WX#s%WX~P&-}O!d#vO(m'mO!Y'aa!h'aa~O!Y/hO!h(zi~O!Y/hO!d#vO!h(zi~Og$zq!Y$zq#]$zq#}$zq~P!0pO!V'ca!Y'ca~P#.aO!d7]O~O!Y/pO!V({i~P#.aO!Y/pO!V({i~O!V7aO~O!d#vO#s7fO~Oo7gO!d#vO(m'mO~O}){O!P)|O(u%QOk'fa(t'fa!Y'fa#]'fa~Og'fa#}'fa~P&2mO}){O!P)|Ok'ha(t'ha(u'ha!Y'ha#]'ha~Og'ha#}'ha~P&3`O!V7iO~Og$|q!Y$|q#]$|q#}$|q~P!0pOa$my!Y$my'u$my's$my!V$my!h$mys$my![$my%f$my!d$my~P!9mO!d6YO~O!Y4tO![(|a~O![']OP$SaR$Sa[$Sao$Sa}$Sa!P$Sa!Y$Sa!i$Sa!m$Sa#O$Sa#k$Sa#l$Sa#m$Sa#n$Sa#o$Sa#p$Sa#q$Sa#r$Sa#s$Sa#u$Sa#w$Sa#y$Sa#z$Sa([$Sa(m$Sa(t$Sa(u$Sa~O%f6nO~P&5iOa#`y!Y#`y'u#`y's#`y!V#`y!h#`ys#`y![#`y%f#`y!d#`y~P!9mO[7nO~Ob7pO(O+kO(QTO(TUO~O!Y0wO!Z)Ti~O`7tO~O(`(xO!Y'lX!Z'lX~O!Y5]O!Z)Qa~O!Z7}O~P%6ZOp!nO!P8OO(QTO(TUO(`!mO(j!sO~O![1aO~O![1aO%f8QO~Ok8TO![1aO%f8QO~O[8YO!Y'oa!Z'oa~O!Y1lO!Z)Ri~O!h8^O~O!h8_O~O!h8bO~O!h8bO~P%[Oa8dO~O!d8eO~O!h8fO~O!Y(ri!Z(ri~P#D_Oa%lO#]8nO'u%lO~O!Y(oy!h(oya(oy'u(oy~P!9mO!Y(fO!h(ny~O%f8qO~P&5iO![']O%f8qO~O#h$zqP$zqR$zq[$zqa$zqo$zq!Y$zq!i$zq!m$zq#O$zq#k$zq#l$zq#m$zq#n$zq#o$zq#p$zq#q$zq#r$zq#s$zq#u$zq#w$zq#y$zq#z$zq'u$zq([$zq(m$zq!h$zq!V$zq's$zq#]$zqs$zq![$zq%f$zq!d$zq~P#.aO#h'faP'faR'fa['faa'fao'fa!i'fa!m'fa#O'fa#k'fa#l'fa#m'fa#n'fa#o'fa#p'fa#q'fa#r'fa#s'fa#u'fa#w'fa#y'fa#z'fa'u'fa(['fa(m'fa!h'fa!V'fa's'fas'fa!['fa%f'fa!d'fa~P&2mO#h'haP'haR'ha['haa'hao'ha!i'ha!m'ha#O'ha#k'ha#l'ha#m'ha#n'ha#o'ha#p'ha#q'ha#r'ha#s'ha#u'ha#w'ha#y'ha#z'ha'u'ha(['ha(m'ha!h'ha!V'ha's'has'ha!['ha%f'ha!d'ha~P&3`O#h$|qP$|qR$|q[$|qa$|qo$|q!Y$|q!i$|q!m$|q#O$|q#k$|q#l$|q#m$|q#n$|q#o$|q#p$|q#q$|q#r$|q#s$|q#u$|q#w$|q#y$|q#z$|q'u$|q([$|q(m$|q!h$|q!V$|q's$|q#]$|qs$|q![$|q%f$|q!d$|q~P#.aO!Y'Ui!h'Ui~P!9mO#}#`q!Y#`q!Z#`q~P#D_O(t%OOP%^aR%^a[%^ao%^a!i%^a!m%^a#O%^a#k%^a#l%^a#m%^a#n%^a#o%^a#p%^a#q%^a#r%^a#s%^a#u%^a#w%^a#y%^a#z%^a#}%^a([%^a(m%^a!Y%^a!Z%^a~Ok%^a}%^a!P%^a(u%^a~P&FgO(u%QOP%`aR%`a[%`ao%`a!i%`a!m%`a#O%`a#k%`a#l%`a#m%`a#n%`a#o%`a#p%`a#q%`a#r%`a#s%`a#u%`a#w%`a#y%`a#z%`a#}%`a([%`a(m%`a!Y%`a!Z%`a~Ok%`a}%`a!P%`a(t%`a~P&HkOk<qO}){O!P)|O(u%QO~P&FgOk<qO}){O!P)|O(t%OO~P&HkOR0`O}0`O!P0aO#P$dOPza[zakzaoza!iza!mza#Oza#kza#lza#mza#nza#oza#pza#qza#rza#sza#uza#wza#yza#zza#}za([za(mza(tza(uza!Yza!Zza~O}){O!P)|OP$qaR$qa[$qak$qao$qa!i$qa!m$qa#O$qa#k$qa#l$qa#m$qa#n$qa#o$qa#p$qa#q$qa#r$qa#s$qa#u$qa#w$qa#y$qa#z$qa#}$qa([$qa(m$qa(t$qa(u$qa!Y$qa!Z$qa~O}){O!P)|OP$saR$sa[$sak$sao$sa!i$sa!m$sa#O$sa#k$sa#l$sa#m$sa#n$sa#o$sa#p$sa#q$sa#r$sa#s$sa#u$sa#w$sa#y$sa#z$sa#}$sa([$sa(m$sa(t$sa(u$sa!Y$sa!Z$sa~OP%RaR%Ra[%Rao%Ra!i%Ra!m%Ra#O%Ra#k%Ra#l%Ra#m%Ra#n%Ra#o%Ra#p%Ra#q%Ra#r%Ra#s%Ra#u%Ra#w%Ra#y%Ra#z%Ra#}%Ra([%Ra(m%Ra!Y%Ra!Z%Ra~P&(tO#}$lq!Y$lq!Z$lq~P#D_O#}$mq!Y$mq!Z$mq~P#D_O!Z9OO~O#}9PO~P!0pO!d#vO!Y'ai!h'ai~O!d#vO(m'mO!Y'ai!h'ai~O!Y/hO!h(zq~O!V'ci!Y'ci~P#.aO!Y/pO!V({q~O!V9VO~P#.aO!V9VO~Og(Yy!Y(Yy~P!0pO!Y'ja!['ja~P#.aOa%Yq![%Yq'u%Yq!Y%Yq~P#.aO[9[O~O!Y0wO!Z)Tq~O#]9`O!Y'la!Z'la~O!Y5]O!Z)Qi~P#D_O![1aO%f9dO~O(QTO(TUO(`9iO~O!Y1lO!Z)Rq~O!h9lO~O!h9mO~O!h9nO~O!h9nO~P%[O#]9qO!Y#ey!Z#ey~O!Y#ey!Z#ey~P#D_O%f9vO~P&5iO![']O%f9vO~O#}#{y!Y#{y!Z#{y~P#D_OP$ziR$zi[$zio$zi!i$zi!m$zi#O$zi#k$zi#l$zi#m$zi#n$zi#o$zi#p$zi#q$zi#r$zi#s$zi#u$zi#w$zi#y$zi#z$zi#}$zi([$zi(m$zi!Y$zi!Z$zi~P&(tO}){O!P)|O(u%QOP'eaR'ea['eak'eao'ea!i'ea!m'ea#O'ea#k'ea#l'ea#m'ea#n'ea#o'ea#p'ea#q'ea#r'ea#s'ea#u'ea#w'ea#y'ea#z'ea#}'ea(['ea(m'ea(t'ea!Y'ea!Z'ea~O}){O!P)|OP'gaR'ga['gak'gao'ga!i'ga!m'ga#O'ga#k'ga#l'ga#m'ga#n'ga#o'ga#p'ga#q'ga#r'ga#s'ga#u'ga#w'ga#y'ga#z'ga#}'ga(['ga(m'ga(t'ga(u'ga!Y'ga!Z'ga~O(t%OOP%^iR%^i[%^ik%^io%^i}%^i!P%^i!i%^i!m%^i#O%^i#k%^i#l%^i#m%^i#n%^i#o%^i#p%^i#q%^i#r%^i#s%^i#u%^i#w%^i#y%^i#z%^i#}%^i([%^i(m%^i(u%^i!Y%^i!Z%^i~O(u%QOP%`iR%`i[%`ik%`io%`i}%`i!P%`i!i%`i!m%`i#O%`i#k%`i#l%`i#m%`i#n%`i#o%`i#p%`i#q%`i#r%`i#s%`i#u%`i#w%`i#y%`i#z%`i#}%`i([%`i(m%`i(t%`i!Y%`i!Z%`i~O#}$my!Y$my!Z$my~P#D_O#}#`y!Y#`y!Z#`y~P#D_O!d#vO!Y'aq!h'aq~O!Y/hO!h(zy~O!V'cq!Y'cq~P#.aO!V:PO~P#.aO!Y0wO!Z)Ty~O!Y5]O!Z)Qq~O![1aO%f:WO~O!h:ZO~O%f:`O~P&5iOP$zqR$zq[$zqo$zq!i$zq!m$zq#O$zq#k$zq#l$zq#m$zq#n$zq#o$zq#p$zq#q$zq#r$zq#s$zq#u$zq#w$zq#y$zq#z$zq#}$zq([$zq(m$zq!Y$zq!Z$zq~P&(tO}){O!P)|O(u%QOP'faR'fa['fak'fao'fa!i'fa!m'fa#O'fa#k'fa#l'fa#m'fa#n'fa#o'fa#p'fa#q'fa#r'fa#s'fa#u'fa#w'fa#y'fa#z'fa#}'fa(['fa(m'fa(t'fa!Y'fa!Z'fa~O}){O!P)|OP'haR'ha['hak'hao'ha!i'ha!m'ha#O'ha#k'ha#l'ha#m'ha#n'ha#o'ha#p'ha#q'ha#r'ha#s'ha#u'ha#w'ha#y'ha#z'ha#}'ha(['ha(m'ha(t'ha(u'ha!Y'ha!Z'ha~OP$|qR$|q[$|qo$|q!i$|q!m$|q#O$|q#k$|q#l$|q#m$|q#n$|q#o$|q#p$|q#q$|q#r$|q#s$|q#u$|q#w$|q#y$|q#z$|q#}$|q([$|q(m$|q!Y$|q!Z$|q~P&(tOg%b!Z!Y%b!Z#]%b!Z#}%b!Z~P!0pO!Y'lq!Z'lq~P#D_O!Y#e!Z!Z#e!Z~P#D_O#h%b!ZP%b!ZR%b!Z[%b!Za%b!Zo%b!Z!Y%b!Z!i%b!Z!m%b!Z#O%b!Z#k%b!Z#l%b!Z#m%b!Z#n%b!Z#o%b!Z#p%b!Z#q%b!Z#r%b!Z#s%b!Z#u%b!Z#w%b!Z#y%b!Z#z%b!Z'u%b!Z([%b!Z(m%b!Z!h%b!Z!V%b!Z's%b!Z#]%b!Zs%b!Z![%b!Z%f%b!Z!d%b!Z~P#.aOP%b!ZR%b!Z[%b!Zo%b!Z!i%b!Z!m%b!Z#O%b!Z#k%b!Z#l%b!Z#m%b!Z#n%b!Z#o%b!Z#p%b!Z#q%b!Z#r%b!Z#s%b!Z#u%b!Z#w%b!Z#y%b!Z#z%b!Z#}%b!Z([%b!Z(m%b!Z!Y%b!Z!Z%b!Z~P&(tOs(aX~P1qO}%pO~P!(oO(P!lO~P!(oO!VfX!YfX#]fX~P&-}OP]XR]X[]Xo]X}]X!P]X!Y]X!YfX!i]X!m]X#O]X#P]X#]]X#]fX#hfX#k]X#l]X#m]X#n]X#o]X#p]X#q]X#r]X#s]X#u]X#w]X#y]X#z]X$P]X([]X(m]X(t]X(u]X~O!dfX!h]X!hfX(mfX~P'CvOP:kOQ:kOSfOd<fOe!iOmkOo:kOpkOqkOwkOy:kO{:kO!PWO!TkO!UkO![XO!f:nO!iZO!l:kO!m:kO!n:kO!p:oO!r:rO!u!hO$V!kO(O)YO(QTO(TUO([VO(j[O(y<dO~O!Y;PO!Z$oa~Oh%WOm%XOo$uOp$tOq$tOw%YOy%ZO{;ZO!P$|O![$}O!f<kO!i$yO#g;aO$V%_O$r;]O$t;_O$w%`O(O(rO(QTO(TUO([$vO(t%OO(u%QO~O#t)`O~P'HlOo!bX(m!bX~P# ZO!Z]X!ZfX~P'CvO!VfX!V$xX!YfX!Y$xX#]fX~P!/gO#h:sO~O!d#vO#h:sO~O#];TO~O#s:xO~O#];dO!Y(rX!Z(rX~O#];TO!Y(pX!Z(pX~O#h;eO~Og;gO~P!0pO#h;mO~O#h;nO~O!d#vO#h;oO~O!d#vO#h;eO~O#};pO~P#D_O#h;qO~O#h;rO~O#h;wO~O#h;xO~O#h;yO~O#h;zO~O#};{O~P!0pO#};|O~P!0pO#P#Q#R#T#U#X#f#g#r(y$r$t$w%Z%e%f%g%n%p%s%t%v%x~'yT#l!U'w(P#mp#k#no}'x$['x(O$^(`~",
  goto: "$2y)XPPPPPP)YPP)]P)nP+O/PPPPP5wPP6_PP<U?kP@OP@OPPP@OPBOP@OP@OP@OPBSPBXPBvPGoPPPGsPPPPGsJuPPPJ{KwPGsPGsPPNVGsPPPGsPGsP!!^GsP!%s!&x!'RP!'u!'y!'u!+VPPPPPPP!+v!&xPP!,W!-QP!/tGsGs!/y!3U!7l!7l!;jPPP!;rGsPPPPPPPPPPP!?QP!@_PPGs!ApPGsPGsGsGsGsGsPGs!CSP!F]P!IbP!If!Ip!It!ItP!FYP!Ix!IxP!L}P!MRGsGs!MX#!]BS@OP@OP@O@OP##i@O@O#%s@O#(c@O#*g@O@O#+V#-c#-c#-h#-q#-c#-zP#-cP@O#.d@O#2T@O@O5wPPP#5zPPP#6e#6eP#6eP#6{#6ePP#7RP#6xP#6x#7f#6x#8Q#8W5t)]#8Z)]P#8b#8b#8bP)]P)]P)]P)]PP)]P#8h#8kP#8k)]P#8oP#8rP)]P)]P)]P)]P)]P)])]PP#8x#9O#9Z#9a#9g#9m#9s#:R#:X#:c#:i#:s#:y#;Z#;a#<R#<e#<k#<q#=P#=f#?T#?c#?j#AO#A^#Bx#CW#C^#Cd#Cj#Ct#Cz#DQ#D[#Dn#DtPPPPPPPPPP#DzPPPPPPP#Eo#Hv#JV#J^#JfPPP$ lP$ u$$m$+V$+Y$+]$+x$+{$,S$,[P$,b$,eP$-R$-V$-}$/]$/b$/xPP$/}$0T$0XP$0[$0`$0d$1Y$1q$2Y$2^$2a$2d$2j$2m$2q$2uR!|RoqOXst!Z#d%k&o&q&r&t,k,p1|2PY!vQ']-]1a5dQ%rvQ%zyQ&R|Q&g!VS'T!e-TQ'c!iS'i!r!yU*f$}*W*kQ+i%{Q+v&TQ,[&aQ-Z'[Q-e'dQ-m'jQ0R*mQ1k,]R;b:o%QdOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Y$`$e%k%r&P&h&k&o&q&r&t&x'Q'_'o(P(R(X(`(t(v(z)z+R+V,h,k,p-a-i-w-}.l.s/f0a0g0v1d1t1u1w1y1|2P2R2r2x3^5a5k5{5|6P6d8O8T8d8nS#q]:l!r)[$[$n'U)o,|-P.}2b3u5_6Z9`9q:k:n:o:r:s:t:u:v:w:x:y:z:{:|:};O;P;T;b;d;e;g;o;p;y;z<gU*y%[;Y;ZQ+n%}Q,^&dQ,e&lQ0m+aQ0q+cQ0|+oQ1s,cQ3Q._Q4}0wQ5r1lQ6p3UQ7p5OR8t6r'OkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Y$[$`$e$n%k%r&P&h&k&l&o&q&r&t&x'Q'U'_'o(P(R(X(`(t(v(z)o)z+R+V+a,h,k,p,|-P-a-i-w-}._.l.s.}/f0a0g0v1d1t1u1w1y1|2P2R2b2r2x3U3^3u5_5a5k5{5|6P6Z6d6r8O8T8d8n9`9q:k:n:o:r:s:t:u:v:w:x:y:z:{:|:};O;P;T;b;d;e;g;o;p;y;z<gt!nQ!r!v!y!z'T'[']'i'j'k-T-Z-]-m1a5d5f$z$ti#v$b$c$d$y$|%P%R%]%^%b)v)|*O*Q*S*V*]*c*s*t+`+c+z+}.^.w/]/e/o/p/r0V0X0d1W1Z1c3T3}4Y4b4l4t4w5j6n7]7f8Q8q9P9d9v:W:`;R;S;U;V;W;X;[;];^;_;`;a;h;i;j;k;m;n;q;r;s;t;u;v;w;x;{;|<d<l<m<p<qQ&U|Q'R!eU'X%g*W-WQ+n%}Q,^&dQ0c*|Q0|+oQ1R+uQ1r,bQ1s,cQ4}0wQ5W1TQ5r1lQ5u1nQ5v1qQ7p5OQ7s5TQ8]5xQ9_7tR9j8YrnOXst!V!Z#d%k&f&o&q&r&t,k,p1|2PR,`&h&x^OPXYstuvwz!Z!`!g!j!o#S#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Y$[$`$e$n%k%r&P&h&k&l&o&q&r&t&x'Q'_'o(R(X(`(t(v(z)o)z+R+V+a,h,k,p,|-P-a-i-w-}._.l.s.}/f0a0g0v1d1t1u1w1y1|2P2R2b2r2x3U3^3u5_5a5k5{5|6P6Z6d6r8O8T8d8n9`9q:k:n:o:r:s:t:u:v:w:x:y:z:{:|:};O;P;T;b;d;e;g;o;p;y;z<f<g[#]WZ#W#Z'U(P!b%hm#h#i#l$y%c%f(Y(d(e(f*V*Z*^+T+U+W,g,}-{.R.S.T.V/e/h2U2|2}4Q6Y6kQ%uxQ%yyS&O|&TQ&[!TQ'`!hQ'b!iQ(m#sS+h%z%{Q+l%}Q,V&_Q,Z&aS-d'c'dQ.a(nQ0u+iQ0{+oQ0}+pQ1Q+tQ1f,WS1j,[,]Q2n-eQ4|0wQ5Q0zQ5V1SQ5q1kQ7o5OQ7r5SQ9Z7nR:R9[!O${i$d%P%R%]%^%b*O*Q*]*s*t.w/o0V0X0d3}4l9P<d<l<m!S%wy!i!u%y%z%{'S'b'c'd'h'r*e+h+i-Q-d-e-l/y0u2g2n2u4dQ+b%uQ+{&XQ,O&YQ,Y&aQ.`(mQ1e,VU1i,Z,[,]Q3V.aQ5l1fS5p1j1kQ8X5q#[<h#v$b$c$y$|)v)|*S*V*c+`+c+z+}.^/]/e/p/r1W1Z1c3T4Y4b4t4w5j6n7]7f8Q8q9d9v:W:`;U;W;[;^;`;h;j;m;q;s;u;w;{<p<qo<i;R;S;V;X;];_;a;i;k;n;r;t;v;x;|W%Ui%W*u<dS&X!Q&fQ&Y!RQ&Z!SR+y&V${%Ti#v$b$c$d$y$|%P%R%]%^%b)v)|*O*Q*S*V*]*c*s*t+`+c+z+}.^.w/]/e/o/p/r0V0X0d1W1Z1c3T3}4Y4b4l4t4w5j6n7]7f8Q8q9P9d9v:W:`;R;S;U;V;W;X;[;];^;_;`;a;h;i;j;k;m;n;q;r;s;t;u;v;w;x;{;|<d<l<m<p<qT)w$v)xV*y%[;Y;ZW'X!e%g*W-WS(y#y#zQ+]%pQ+s&QS.Y(i(jQ1[,PQ4m0`R7x5]'OkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Y$[$`$e$n%k%r&P&h&k&l&o&q&r&t&x'Q'U'_'o(P(R(X(`(t(v(z)o)z+R+V+a,h,k,p,|-P-a-i-w-}._.l.s.}/f0a0g0v1d1t1u1w1y1|2P2R2b2r2x3U3^3u5_5a5k5{5|6P6Z6d6r8O8T8d8n9`9q:k:n:o:r:s:t:u:v:w:x:y:z:{:|:};O;P;T;b;d;e;g;o;p;y;z<g$i$_c#Y#e%o%q%s(O(U(p(u(})O)P)Q)R)S)T)U)V)W)X)Z)])c)m+^+r-R-p-u-z-|.k.n.r.t.u.v/X0e2]2`2p2w3]3b3c3d3e3f3g3h3i3j3k3l3m3n3q3r3y4q4z6]6c6h6w6x7R7S7z8h8l8v8|8}9s:T:[:m<ZT#TV#U'PkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Y$[$`$e$n%k%r&P&h&k&l&o&q&r&t&x'Q'U'_'o(P(R(X(`(t(v(z)o)z+R+V+a,h,k,p,|-P-a-i-w-}._.l.s.}/f0a0g0v1d1t1u1w1y1|2P2R2b2r2x3U3^3u5_5a5k5{5|6P6Z6d6r8O8T8d8n9`9q:k:n:o:r:s:t:u:v:w:x:y:z:{:|:};O;P;T;b;d;e;g;o;p;y;z<gQ'V!eR2c-Tv!nQ!e!r!v!y!z'T'[']'i'j'k-T-Z-]-m1a5d5fU*e$}*W*kS/y*f*mQ0S*nQ1^,RQ4d0RR4g0UnqOXst!Z#d%k&o&q&r&t,k,p1|2PQ&v!^Q's!xS(o#u:sQ+f%xQ,T&[Q,U&^Q-b'aQ-o'lS.j(t;eS0f+R;oQ0s+gQ1`,SQ2T,rQ2V,sQ2_-OQ2l-cQ2o-gS4r0g;yQ4x0tS4{0v;zQ6[2aQ6`2mQ6e2tQ7m4yQ8i6^Q8j6aQ8m6fR9p8f$d$^c#Y#e%q%s(O(U(p(u(})O)P)Q)R)S)T)U)V)W)X)Z)])c)m+^+r-R-p-u-z-|.k.n.r.u.v/X0e2]2`2p2w3]3b3c3d3e3f3g3h3i3j3k3l3m3n3q3r3y4q4z6]6c6h6w6x7R7S7z8h8l8v8|8}9s:T:[:m<ZS(k#p'fQ({#zS+[%o.tS.Z(j(lR3O.['OkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Y$[$`$e$n%k%r&P&h&k&l&o&q&r&t&x'Q'U'_'o(P(R(X(`(t(v(z)o)z+R+V+a,h,k,p,|-P-a-i-w-}._.l.s.}/f0a0g0v1d1t1u1w1y1|2P2R2b2r2x3U3^3u5_5a5k5{5|6P6Z6d6r8O8T8d8n9`9q:k:n:o:r:s:t:u:v:w:x:y:z:{:|:};O;P;T;b;d;e;g;o;p;y;z<gS#q]:lQ&q!XQ&r!YQ&t![Q&u!]R1{,nQ'^!hQ+_%uQ-`'`S.](m+bQ2j-_W3S.`.a0l0nQ6_2kW6l3P3R3V4vU8p6m6o6qU9u8r8s8uS:^9t9wQ:f:_R:i:gU!wQ']-]T5b1a5d!Q_OXZ`st!V!Z#d#h%c%k&f&h&o&q&r&t(f,k,p.S1|2P]!pQ!r']-]1a5dT#q]:l%[{OPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Y$`$e%k%r&P&h&k&l&o&q&r&t&x'Q'_'o(P(R(X(`(t(v(z)z+R+V+a,h,k,p-a-i-w-}._.l.s/f0a0g0v1d1t1u1w1y1|2P2R2r2x3U3^5a5k5{5|6P6d6r8O8T8d8nS(y#y#zS.Y(i(j!s<Q$[$n'U)o,|-P.}2b3u5_6Z9`9q:k:n:o:r:s:t:u:v:w:x:y:z:{:|:};O;P;T;b;d;e;g;o;p;y;z<gU$fd)[,eS(l#p'fU*r%S(s3pU0b*x.f6}Q4v0mQ6m3QQ8s6pR9w8tm!tQ!r!v!y!z']'i'j'k-]-m1a5d5fQ'q!uS(b#g1vS-k'h'tQ/k*YQ/w*eQ2v-nQ4U/lS4_/x0SQ7X4PS7d4e4gQ9R7YR9Y7gQ#wbQ'p!uS(a#g1vS(c#m+QQ+S%dQ+d%vQ+j%|U-j'h'q'tQ.O(bQ/j*YQ/v*eQ/|*hQ0r+eQ1g,XS2s-k-nQ2{.WS4T/k/lS4^/w0SQ4a/{Q4c/}Q5n1hQ6g2vQ7W4PQ7[4US7`4_4gQ7e4fQ8V5oS9Q7X7YQ9U7aQ9W7dQ9g8WQ9}9RQ:O9VQ:Q9YQ:Y9hQ:b:PQ<T<OQ<`<XR<a<YV!wQ']-]%[aOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Y$`$e%k%r&P&h&k&l&o&q&r&t&x'Q'_'o(P(R(X(`(t(v(z)z+R+V+a,h,k,p-a-i-w-}._.l.s/f0a0g0v1d1t1u1w1y1|2P2R2r2x3U3^5a5k5{5|6P6d6r8O8T8d8nS#wz!j!r;}$[$n'U)o,|-P.}2b3u5_6Z9`9q:k:n:o:r:s:t:u:v:w:x:y:z:{:|:};O;P;T;b;d;e;g;o;p;y;z<gR<T<f%[bOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Y$`$e%k%r&P&h&k&l&o&q&r&t&x'Q'_'o(P(R(X(`(t(v(z)z+R+V+a,h,k,p-a-i-w-}._.l.s/f0a0g0v1d1t1u1w1y1|2P2R2r2x3U3^5a5k5{5|6P6d6r8O8T8d8nQ%dj!S%vy!i!u%y%z%{'S'b'c'd'h'r*e+h+i-Q-d-e-l/y0u2g2n2u4dS%|z!jQ+e%wQ,X&aW1h,Y,Z,[,]U5o1i1j1kS8W5p5qQ9h8X!r<O$[$n'U)o,|-P.}2b3u5_6Z9`9q:k:n:o:r:s:t:u:v:w:x:y:z:{:|:};O;P;T;b;d;e;g;o;p;y;z<gQ<X<eR<Y<f%OeOPXYstuvw!Z!`!g!o#S#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Y$`$e%k%r&P&h&k&o&q&r&t&x'Q'_'o(R(X(`(t(v(z)z+R+V+a,h,k,p-a-i-w-}._.l.s/f0a0g0v1d1t1u1w1y1|2P2R2r2x3U3^5a5k5{5|6P6d6r8O8T8d8nY#bWZ#W#Z(P!b%hm#h#i#l$y%c%f(Y(d(e(f*V*Z*^+T+U+W,g,}-{.R.S.T.V/e/h2U2|2}4Q6Y6kQ,f&l!p<P$[$n)o,|-P.}2b3u5_6Z9`9q:k:n:o:r:s:t:u:v:w:x:y:z:{:|:};O;P;T;b;d;e;g;o;p;y;z<gR<S'UU'Y!e%g*WR2e-W%QdOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Y$`$e%k%r&P&h&k&o&q&r&t&x'Q'_'o(P(R(X(`(t(v(z)z+R+V,h,k,p-a-i-w-}.l.s/f0a0g0v1d1t1u1w1y1|2P2R2r2x3^5a5k5{5|6P6d8O8T8d8n!r)[$[$n'U)o,|-P.}2b3u5_6Z9`9q:k:n:o:r:s:t:u:v:w:x:y:z:{:|:};O;P;T;b;d;e;g;o;p;y;z<gQ,e&lQ0m+aQ3Q._Q6p3UR8t6r!b$Uc#Y%o(O(U(p(u)W)X)])c+r-p-u-z-|.k.n/X0e2p2w3]3n4q4z6c6h6w8l9s:m!P:z)Z)m-R.t2]2`3b3l3m3q3y6]6x7R7S7z8h8v8|8}:T:[<Z!f$Wc#Y%o(O(U(p(u)T)U)W)X)])c+r-p-u-z-|.k.n/X0e2p2w3]3n4q4z6c6h6w8l9s:m!T:|)Z)m-R.t2]2`3b3i3j3l3m3q3y6]6x7R7S7z8h8v8|8}:T:[<Z!^$[c#Y%o(O(U(p(u)])c+r-p-u-z-|.k.n/X0e2p2w3]3n4q4z6c6h6w8l9s:mQ3}/cz<g)Z)m-R.t2]2`3b3q3y6]6x7R7S7z8h8v8|8}:T:[<ZQ<l<nR<m<o'OkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Y$[$`$e$n%k%r&P&h&k&l&o&q&r&t&x'Q'U'_'o(P(R(X(`(t(v(z)o)z+R+V+a,h,k,p,|-P-a-i-w-}._.l.s.}/f0a0g0v1d1t1u1w1y1|2P2R2b2r2x3U3^3u5_5a5k5{5|6P6Z6d6r8O8T8d8n9`9q:k:n:o:r:s:t:u:v:w:x:y:z:{:|:};O;P;T;b;d;e;g;o;p;y;z<gS$oh$pR3v.|'VgOPWXYZhstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Y$[$`$e$n$p%k%r&P&h&k&l&o&q&r&t&x'Q'U'_'o(P(R(X(`(t(v(z)o)z+R+V+a,h,k,p,|-P-a-i-w-}._.l.s.|.}/f0a0g0v1d1t1u1w1y1|2P2R2b2r2x3U3^3u5_5a5k5{5|6P6Z6d6r8O8T8d8n9`9q:k:n:o:r:s:t:u:v:w:x:y:z:{:|:};O;P;T;b;d;e;g;o;p;y;z<gT$kf$qQ$ifS)f$l)jR)r$qT$jf$qT)h$l)j'VhOPWXYZhstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Y$[$`$e$n$p%k%r&P&h&k&l&o&q&r&t&x'Q'U'_'o(P(R(X(`(t(v(z)o)z+R+V+a,h,k,p,|-P-a-i-w-}._.l.s.|.}/f0a0g0v1d1t1u1w1y1|2P2R2b2r2x3U3^3u5_5a5k5{5|6P6Z6d6r8O8T8d8n9`9q:k:n:o:r:s:t:u:v:w:x:y:z:{:|:};O;P;T;b;d;e;g;o;p;y;z<gT$oh$pQ$rhR)q$p%[jOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Y$`$e%k%r&P&h&k&l&o&q&r&t&x'Q'_'o(P(R(X(`(t(v(z)z+R+V+a,h,k,p-a-i-w-}._.l.s/f0a0g0v1d1t1u1w1y1|2P2R2r2x3U3^5a5k5{5|6P6d6r8O8T8d8n!s<e$[$n'U)o,|-P.}2b3u5_6Z9`9q:k:n:o:r:s:t:u:v:w:x:y:z:{:|:};O;P;T;b;d;e;g;o;p;y;z<g#elOPXZst!Z!`!o#S#d#o#{$n%k&h&k&l&o&q&r&t&x'Q'_(z)o+V+a,h,k,p-a._.}/f0a1d1t1u1w1y1|2P2R3U3u5a5k5{5|6P6r8O8T8d!O%Si$d%P%R%]%^%b*O*Q*]*s*t.w/o0V0X0d3}4l9P<d<l<m#[(s#v$b$c$y$|)v)|*S*V*c+`+c+z+}.^/]/e/p/r1W1Z1c3T4Y4b4t4w5j6n7]7f8Q8q9d9v:W:`;U;W;[;^;`;h;j;m;q;s;u;w;{<p<qQ*}%`Q/Y){o3p;R;S;V;X;];_;a;i;k;n;r;t;v;x;|!O$zi$d%P%R%]%^%b*O*Q*]*s*t.w/o0V0X0d3}4l9P<d<l<mQ*_${U*h$}*W*kQ+O%aQ/}*i#[<V#v$b$c$y$|)v)|*S*V*c+`+c+z+}.^/]/e/p/r1W1Z1c3T4Y4b4t4w5j6n7]7f8Q8q9d9v:W:`;U;W;[;^;`;h;j;m;q;s;u;w;{<p<qn<W;R;S;V;X;];_;a;i;k;n;r;t;v;x;|Q<[<hQ<]<iQ<^<jR<_<k!O%Si$d%P%R%]%^%b*O*Q*]*s*t.w/o0V0X0d3}4l9P<d<l<m#[(s#v$b$c$y$|)v)|*S*V*c+`+c+z+}.^/]/e/p/r1W1Z1c3T4Y4b4t4w5j6n7]7f8Q8q9d9v:W:`;U;W;[;^;`;h;j;m;q;s;u;w;{<p<qo3p;R;S;V;X;];_;a;i;k;n;r;t;v;x;|noOXst!Z#d%k&o&q&r&t,k,p1|2PS*b$|*VQ,y&{Q,z&}R4X/p$z%Ti#v$b$c$d$y$|%P%R%]%^%b)v)|*O*Q*S*V*]*c*s*t+`+c+z+}.^.w/]/e/o/p/r0V0X0d1W1Z1c3T3}4Y4b4l4t4w5j6n7]7f8Q8q9P9d9v:W:`;R;S;U;V;W;X;[;];^;_;`;a;h;i;j;k;m;n;q;r;s;t;u;v;w;x;{;|<d<l<m<p<qQ+|&YQ1Y,OQ5Z1XR7w5[V*j$}*W*kU*j$}*W*kT5c1a5dU/{*g/f5aT4f0T8OQ+d%vQ/|*hQ0r+eQ1g,XQ5n1hQ8V5oQ9g8WR:Y9h!O%Pi$d%P%R%]%^%b*O*Q*]*s*t.w/o0V0X0d3}4l9P<d<l<mr*O$w)a*P*q+P/n0Z0[3s4V4p7V7h9|<U<b<cS0V*p0W#[;U#v$b$c$y$|)v)|*S*V*c+`+c+z+}.^/]/e/p/r1W1Z1c3T4Y4b4t4w5j6n7]7f8Q8q9d9v:W:`;U;W;[;^;`;h;j;m;q;s;u;w;{<p<qn;V;R;S;V;X;];_;a;i;k;n;r;t;v;x;|!^;h(q)_*X*a.b.e.i/U/Z/c/s0k1V1X3Y4W4[5Y5[6s6v7^7b7j7l9T9X:a<n<o`;i3o6y6|7Q8w9x9{:jS;s.d3ZT;t6{8z!O%Ri$d%P%R%]%^%b*O*Q*]*s*t.w/o0V0X0d3}4l9P<d<l<mv*Q$w)a*R*p+P/_/n0Z0[3s4V4h4p7V7h9|<U<b<cS0X*q0Y#[;W#v$b$c$y$|)v)|*S*V*c+`+c+z+}.^/]/e/p/r1W1Z1c3T4Y4b4t4w5j6n7]7f8Q8q9d9v:W:`;U;W;[;^;`;h;j;m;q;s;u;w;{<p<qn;X;R;S;V;X;];_;a;i;k;n;r;t;v;x;|!b;j(q)_*X*a.c.d.i/U/Z/c/s0k1V1X3W3Y4W4[5Y5[6s6t6v7^7b7j7l9T9X:a<n<od;k3o6z6{7Q8w8x9x9y9{:jS;u.e3[T;v6|8{rnOXst!V!Z#d%k&f&o&q&r&t,k,p1|2PQ&c!UR,h&lrnOXst!V!Z#d%k&f&o&q&r&t,k,p1|2PR&c!UQ,Q&ZR1U+ysnOXst!V!Z#d%k&f&o&q&r&t,k,p1|2PQ1b,VS5i1e1fU8P5g5h5lS9c8R8SS:U9b9eQ:c:VR:h:dQ&j!VR,a&fR5u1nS&O|&TR0}+pQ&o!WR,k&pR,q&uT1},p2PR,u&vQ,t&vR2W,uQ'v!{R-q'vSsOtQ#dXT%ns#dQ#OTR'x#OQ#RUR'z#RQ)x$vR/V)xQ#UVR'|#UQ#XWU(S#X(T-xQ(T#YR-x(UQ-U'VR2d-UQ.m(uS3_.m3`R3`.nQ-]']R2h-]Y!rQ']-]1a5dR'g!rQ.x)aR3t.xU#_W%f*VU(Z#_([-yQ([#`R-y(VQ-X'YR2f-Xt`OXst!V!Z#d%k&f&h&o&q&r&t,k,p1|2PS#hZ%cU#r`#h.SR.S(fQ(g#jQ.P(cW.X(g.P2y6iQ2y.QR6i2zQ)j$lR/O)jQ$phR)p$pQ$acU)^$a-t;QQ-t:mR;Q)mQ/i*YW4R/i4S7Z9SU4S/j/k/lS7Z4T4UR9S7[$X)}$w(q)_)a*X*a*p*q*z*{+P.d.e.g.h.i/U/Z/_/a/c/n/s0Z0[0k1V1X3W3X3Y3o3s4V4W4[4h4j4p5Y5[6s6t6u6v6{6|7O7P7Q7V7^7b7h7j7l8w8x8y9T9X9x9y9z9{9|:a:j<U<b<c<n<oQ/q*aU4Z/q4]7_Q4]/sR7_4[S*k$}*WR0P*kr*P$w)a*p*q+P/n0Z0[3s4V4p7V7h9|<U<b<c!^.b(q)_*X*a.d.e.i/U/Z/c/s0k1V1X3Y4W4[5Y5[6s6v7^7b7j7l9T9X:a<n<oU/`*P.b6ya6y3o6{6|7Q8w9x9{:jQ0W*pQ3Z.dU4i0W3Z8zR8z6{v*R$w)a*p*q+P/_/n0Z0[3s4V4h4p7V7h9|<U<b<c!b.c(q)_*X*a.d.e.i/U/Z/c/s0k1V1X3W3Y4W4[5Y5[6s6t6v7^7b7j7l9T9X:a<n<oU/b*R.c6ze6z3o6{6|7Q8w8x9x9y9{:jQ0Y*qQ3[.eU4k0Y3[8{R8{6|Q*v%VR0^*vQ4u0kR7k4uQ+X%iR0j+XQ5^1[S7y5^9aR9a7zQ,S&[R1_,SQ5d1aR7|5dQ1m,^S5s1m8ZR8Z5uQ0x+lW5P0x5R7q9]Q5R0{Q7q5QR9]7rQ+q&OR1O+qQ2P,pR6T2PYrOXst#dQ&s!ZQ+Z%kQ,j&oQ,l&qQ,m&rQ,o&tQ1z,kS1},p2PR6S1|Q%mpQ&w!_Q&z!aQ&|!bQ'O!cQ'n!uQ+Y%jQ+f%xQ+x&UQ,`&jQ,w&yW-h'h'p'q'tQ-o'lQ0O*jQ0s+gS1p,a,dQ2X,vQ2Y,yQ2Z,zQ2o-gW2q-j-k-n-pQ4x0tQ5U1RQ5X1VQ5m1gQ5w1rQ6R1{U6b2p2s2vQ6e2tQ7m4yQ7u5WQ7v5YQ7{5cQ8U5nQ8[5vS8k6c6gQ8m6fQ9^7sQ9f8VQ9k8]Q9r8lQ:S9_Q:X9gQ:]9sR:e:YQ%xyQ'a!iQ'l!uU+g%y%z%{Q-O'SU-c'b'c'dS-g'h'rQ/u*eS0t+h+iQ2a-QS2m-d-eQ2t-lQ4`/yQ4y0uQ6^2gQ6a2nQ6f2uR7c4dS$xi<dR*w%WU%Vi%W<dR0]*uQ$wiS(q#v+cS)_$b$cQ)a$dQ*X$yS*a$|*VQ*p%PQ*q%RQ*z%]Q*{%^Q+P%bQ.d;UQ.e;WQ.g;[Q.h;^Q.i;`Q/U)vS/Z)|/]Q/_*OQ/a*QQ/c*SQ/n*]S/s*c/eQ0Z*sQ0[*th0k+`.^1c3T5j6n8Q8q9d9v:W:`Q1V+zQ1X+}Q3W;hQ3X;jQ3Y;mS3o;R;SQ3s.wQ4V/oQ4W/pQ4[/rQ4h0VQ4j0XQ4p0dQ5Y1WQ5[1ZQ6s;qQ6t;sQ6u;uQ6v;wQ6{;VQ6|;XQ7O;]Q7P;_Q7Q;aQ7V3}Q7^4YQ7b4bQ7h4lQ7j4tQ7l4wQ8w;nQ8x;iQ8y;kQ9T7]Q9X7fQ9x;rQ9y;tQ9z;vQ9{;xQ9|9PQ:a;{Q:j;|Q<U<dQ<b<lQ<c<mQ<n<pR<o<qQ*x%[Q.f;YR6};ZnpOXst!Z#d%k&o&q&r&t,k,p1|2PQ!fPS#fZ#oQ&y!`U'e!o5a8OQ'{#SQ(|#{Q)n$nS,d&h&kQ,i&lQ,v&xQ,{'QQ-_'_Q.p(zQ/S)oS0h+V/fQ0n+aQ1x,hQ2k-aQ3R._Q3x.}Q4n0aQ5h1dQ5y1tQ5z1uQ6O1wQ6Q1yQ6V2RQ6q3UQ7T3uQ8S5kQ8`5{Q8a5|Q8c6PQ8u6rQ9e8TR9o8d#YcOPXZst!Z!`!o#d#o#{%k&h&k&l&o&q&r&t&x'Q'_(z+V+a,h,k,p-a._/f0a1d1t1u1w1y1|2P2R3U5a5k5{5|6P6r8O8T8dQ#YWQ#eYQ%ouQ%qvS%sw!gS(O#W(RQ(U#ZQ(p#uQ(u#xQ(}$OQ)O$PQ)P$QQ)Q$RQ)R$SQ)S$TQ)T$UQ)U$VQ)V$WQ)W$XQ)X$YQ)Z$[Q)]$`Q)c$eW)m$n)o.}3uQ+^%rQ+r&PS-R'U2bQ-p'oS-u(P-wQ-z(XQ-|(`Q.k(tQ.n(vQ.r:kQ.t:nQ.u:oQ.v:rQ/X)zQ0e+RQ2],|Q2`-PQ2p-iQ2w-}Q3].lQ3b:sQ3c:tQ3d:uQ3e:vQ3f:wQ3g:xQ3h:yQ3i:zQ3j:{Q3k:|Q3l:}Q3m;OQ3n.sQ3q;TQ3r;bQ3y;PQ4q0gQ4z0vQ6];dQ6c2rQ6h2xQ6w3^Q6x;eQ7R;gQ7S;oQ7z5_Q8h6ZQ8l6dQ8v;pQ8|;yQ8};zQ9s8nQ:T9`Q:[9qQ:m#SR<Z<gR#[WR'W!el!tQ!r!v!y!z']'i'j'k-]-m1a5d5fS'S!e-TS-Q'T'[R2g-ZR(w#xQ!fQT-[']-]]!qQ!r']-]1a5dQ#p]R'f:lR)b$dY!uQ']-]1a5dQ'h!rS'r!v!yS't!z5fS-l'i'jQ-n'kR2u-mT#kZ%cS#jZ%cS%im,gU(c#h#i#lS.Q(d(eQ.U(fQ0i+WQ2z.RU2{.S.T.VS6j2|2}R8o6kd#^W#W#Z%f(P(Y*V+T-{/er#gZm#h#i#l%c(d(e(f+W.R.S.T.V2|2}6kS*Y$y*^Q/l*ZQ1v,gQ2^,}Q4P/hQ6X2UQ7Y4QQ8g6YT<R'U+UV#aW%f*VU#`W%f*VS(Q#W(YU(V#Z+T/eS-S'U+UT-v(P-{V'Z!e%g*WQ$lfR)t$qT)i$l)jR3w.|T*[$y*^T*d$|*VQ0l+`Q3P.^Q5g1cQ6o3TQ8R5jQ8r6nQ9b8QQ9t8qQ:V9dQ:_9vQ:d:WR:g:`nqOXst!Z#d%k&o&q&r&t,k,p1|2PQ&i!VR,`&ftmOXst!U!V!Z#d%k&f&o&q&r&t,k,p1|2PR,g&lT%jm,gR1],PR,_&dQ&S|R+w&TR+m%}T&m!W&pT&n!W&pT2O,p2P",
  nodeNames: "⚠ ArithOp ArithOp ?. JSXStartTag LineComment BlockComment Script Hashbang ExportDeclaration export Star as VariableName String Escape from ; default FunctionDeclaration async function VariableDefinition > < TypeParamList TypeDefinition extends ThisType this LiteralType ArithOp Number BooleanLiteral TemplateType InterpolationEnd Interpolation InterpolationStart NullType null VoidType void TypeofType typeof MemberExpression . PropertyName [ TemplateString Escape Interpolation super RegExp ] ArrayExpression Spread , } { ObjectExpression Property async get set PropertyDefinition Block : NewTarget new NewExpression ) ( ArgList UnaryExpression delete LogicOp BitOp YieldExpression yield AwaitExpression await ParenthesizedExpression ClassExpression class ClassBody MethodDeclaration Decorator @ MemberExpression PrivatePropertyName CallExpression TypeArgList CompareOp < declare Privacy static abstract override PrivatePropertyDefinition PropertyDeclaration readonly accessor Optional TypeAnnotation Equals StaticBlock FunctionExpression ArrowFunction ParamList ParamList ArrayPattern ObjectPattern PatternProperty Privacy readonly Arrow MemberExpression BinaryExpression ArithOp ArithOp ArithOp ArithOp BitOp CompareOp instanceof satisfies in const CompareOp BitOp BitOp BitOp LogicOp LogicOp ConditionalExpression LogicOp LogicOp AssignmentExpression UpdateOp PostfixExpression CallExpression InstantiationExpression TaggedTemplateExpression DynamicImport import ImportMeta JSXElement JSXSelfCloseEndTag JSXSelfClosingTag JSXIdentifier JSXBuiltin JSXIdentifier JSXNamespacedName JSXMemberExpression JSXSpreadAttribute JSXAttribute JSXAttributeValue JSXEscape JSXEndTag JSXOpenTag JSXFragmentTag JSXText JSXEscape JSXStartCloseTag JSXCloseTag PrefixCast ArrowFunction TypeParamList SequenceExpression InstantiationExpression KeyofType keyof UniqueType unique ImportType InferredType infer TypeName ParenthesizedType FunctionSignature ParamList NewSignature IndexedType TupleType Label ArrayType ReadonlyType ObjectType MethodType PropertyType IndexSignature PropertyDefinition CallSignature TypePredicate is NewSignature new UnionType LogicOp IntersectionType LogicOp ConditionalType ParameterizedType ClassDeclaration abstract implements type VariableDeclaration let var using TypeAliasDeclaration InterfaceDeclaration interface EnumDeclaration enum EnumBody NamespaceDeclaration namespace module AmbientDeclaration declare GlobalDeclaration global ClassDeclaration ClassBody AmbientFunctionDeclaration ExportGroup VariableName VariableName ImportDeclaration ImportGroup ForStatement for ForSpec ForInSpec ForOfSpec of WhileStatement while WithStatement with DoStatement do IfStatement if else SwitchStatement switch SwitchBody CaseLabel case DefaultLabel TryStatement try CatchClause catch FinallyClause finally ReturnStatement return ThrowStatement throw BreakStatement break ContinueStatement continue DebuggerStatement debugger LabeledStatement ExpressionStatement SingleExpression SingleClassItem",
  maxTerm: 376,
  context: XFe,
  nodeProps: [
    ["isolate", -8, 5, 6, 14, 34, 36, 48, 50, 52, ""],
    ["group", -26, 9, 17, 19, 65, 204, 208, 212, 213, 215, 218, 221, 231, 233, 239, 241, 243, 245, 248, 254, 260, 262, 264, 266, 268, 270, 271, "Statement", -34, 13, 14, 29, 32, 33, 39, 48, 51, 52, 54, 59, 67, 69, 73, 77, 79, 81, 82, 107, 108, 117, 118, 135, 138, 140, 141, 142, 143, 144, 146, 147, 166, 167, 169, "Expression", -23, 28, 30, 34, 38, 40, 42, 171, 173, 175, 176, 178, 179, 180, 182, 183, 184, 186, 187, 188, 198, 200, 202, 203, "Type", -3, 85, 100, 106, "ClassItem"],
    ["openedBy", 23, "<", 35, "InterpolationStart", 53, "[", 57, "{", 70, "(", 159, "JSXStartCloseTag"],
    ["closedBy", 24, ">", 37, "InterpolationEnd", 47, "]", 58, "}", 71, ")", 164, "JSXEndTag"]
  ],
  propSources: [t$e],
  skippedNodes: [0, 5, 6, 274],
  repeatNodeCount: 37,
  tokenData: "$Fq07[R!bOX%ZXY+gYZ-yZ[+g[]%Z]^.c^p%Zpq+gqr/mrs3cst:_tuEruvJSvwLkwx! Yxy!'iyz!(sz{!)}{|!,q|}!.O}!O!,q!O!P!/Y!P!Q!9j!Q!R#:O!R![#<_![!]#I_!]!^#Jk!^!_#Ku!_!`$![!`!a$$v!a!b$*T!b!c$,r!c!}Er!}#O$-|#O#P$/W#P#Q$4o#Q#R$5y#R#SEr#S#T$7W#T#o$8b#o#p$<r#p#q$=h#q#r$>x#r#s$@U#s$f%Z$f$g+g$g#BYEr#BY#BZ$A`#BZ$ISEr$IS$I_$A`$I_$I|Er$I|$I}$Dk$I}$JO$Dk$JO$JTEr$JT$JU$A`$JU$KVEr$KV$KW$A`$KW&FUEr&FU&FV$A`&FV;'SEr;'S;=`I|<%l?HTEr?HT?HU$A`?HUOEr(n%d_$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z&j&hT$h&jO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c&j&zP;=`<%l&c'|'U]$h&j(U!bOY&}YZ&cZw&}wx&cx!^&}!^!_'}!_#O&}#O#P&c#P#o&}#o#p'}#p;'S&};'S;=`(l<%lO&}!b(SU(U!bOY'}Zw'}x#O'}#P;'S'};'S;=`(f<%lO'}!b(iP;=`<%l'}'|(oP;=`<%l&}'[(y]$h&j(RpOY(rYZ&cZr(rrs&cs!^(r!^!_)r!_#O(r#O#P&c#P#o(r#o#p)r#p;'S(r;'S;=`*a<%lO(rp)wU(RpOY)rZr)rs#O)r#P;'S)r;'S;=`*Z<%lO)rp*^P;=`<%l)r'[*dP;=`<%l(r#S*nX(Rp(U!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g#S+^P;=`<%l*g(n+dP;=`<%l%Z07[+rq$h&j(Rp(U!b'w0/lOX%ZXY+gYZ&cZ[+g[p%Zpq+gqr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p$f%Z$f$g+g$g#BY%Z#BY#BZ+g#BZ$IS%Z$IS$I_+g$I_$JT%Z$JT$JU+g$JU$KV%Z$KV$KW+g$KW&FU%Z&FU&FV+g&FV;'S%Z;'S;=`+a<%l?HT%Z?HT?HU+g?HUO%Z07[.ST(S#S$h&j'x0/lO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c07[.n_$h&j(Rp(U!b'x0/lOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z)3p/x`$h&j!m),Q(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`0z!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW1V`#u(Ch$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`2X!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW2d_#u(Ch$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'At3l_(Q':f$h&j(U!bOY4kYZ5qZr4krs7nsw4kwx5qx!^4k!^!_8p!_#O4k#O#P5q#P#o4k#o#p8p#p;'S4k;'S;=`:X<%lO4k(^4r_$h&j(U!bOY4kYZ5qZr4krs7nsw4kwx5qx!^4k!^!_8p!_#O4k#O#P5q#P#o4k#o#p8p#p;'S4k;'S;=`:X<%lO4k&z5vX$h&jOr5qrs6cs!^5q!^!_6y!_#o5q#o#p6y#p;'S5q;'S;=`7h<%lO5q&z6jT$c`$h&jO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c`6|TOr6yrs7]s;'S6y;'S;=`7b<%lO6y`7bO$c``7eP;=`<%l6y&z7kP;=`<%l5q(^7w]$c`$h&j(U!bOY&}YZ&cZw&}wx&cx!^&}!^!_'}!_#O&}#O#P&c#P#o&}#o#p'}#p;'S&};'S;=`(l<%lO&}!r8uZ(U!bOY8pYZ6yZr8prs9hsw8pwx6yx#O8p#O#P6y#P;'S8p;'S;=`:R<%lO8p!r9oU$c`(U!bOY'}Zw'}x#O'}#P;'S'};'S;=`(f<%lO'}!r:UP;=`<%l8p(^:[P;=`<%l4k%9[:hh$h&j(Rp(U!bOY%ZYZ&cZq%Zqr<Srs&}st%ZtuCruw%Zwx(rx!^%Z!^!_*g!_!c%Z!c!}Cr!}#O%Z#O#P&c#P#R%Z#R#SCr#S#T%Z#T#oCr#o#p*g#p$g%Z$g;'SCr;'S;=`El<%lOCr(r<__WS$h&j(Rp(U!bOY<SYZ&cZr<Srs=^sw<Swx@nx!^<S!^!_Bm!_#O<S#O#P>`#P#o<S#o#pBm#p;'S<S;'S;=`Cl<%lO<S(Q=g]WS$h&j(U!bOY=^YZ&cZw=^wx>`x!^=^!^!_?q!_#O=^#O#P>`#P#o=^#o#p?q#p;'S=^;'S;=`@h<%lO=^&n>gXWS$h&jOY>`YZ&cZ!^>`!^!_?S!_#o>`#o#p?S#p;'S>`;'S;=`?k<%lO>`S?XSWSOY?SZ;'S?S;'S;=`?e<%lO?SS?hP;=`<%l?S&n?nP;=`<%l>`!f?xWWS(U!bOY?qZw?qwx?Sx#O?q#O#P?S#P;'S?q;'S;=`@b<%lO?q!f@eP;=`<%l?q(Q@kP;=`<%l=^'`@w]WS$h&j(RpOY@nYZ&cZr@nrs>`s!^@n!^!_Ap!_#O@n#O#P>`#P#o@n#o#pAp#p;'S@n;'S;=`Bg<%lO@ntAwWWS(RpOYApZrAprs?Ss#OAp#O#P?S#P;'SAp;'S;=`Ba<%lOAptBdP;=`<%lAp'`BjP;=`<%l@n#WBvYWS(Rp(U!bOYBmZrBmrs?qswBmwxApx#OBm#O#P?S#P;'SBm;'S;=`Cf<%lOBm#WCiP;=`<%lBm(rCoP;=`<%l<S%9[C}i$h&j(j%1l(Rp(U!bOY%ZYZ&cZr%Zrs&}st%ZtuCruw%Zwx(rx!Q%Z!Q![Cr![!^%Z!^!_*g!_!c%Z!c!}Cr!}#O%Z#O#P&c#P#R%Z#R#SCr#S#T%Z#T#oCr#o#p*g#p$g%Z$g;'SCr;'S;=`El<%lOCr%9[EoP;=`<%lCr07[FRk$h&j(Rp(U!b$[#t(O,2j(`$I[OY%ZYZ&cZr%Zrs&}st%ZtuEruw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Er![!^%Z!^!_*g!_!c%Z!c!}Er!}#O%Z#O#P&c#P#R%Z#R#SEr#S#T%Z#T#oEr#o#p*g#p$g%Z$g;'SEr;'S;=`I|<%lOEr+dHRk$h&j(Rp(U!b$[#tOY%ZYZ&cZr%Zrs&}st%ZtuGvuw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Gv![!^%Z!^!_*g!_!c%Z!c!}Gv!}#O%Z#O#P&c#P#R%Z#R#SGv#S#T%Z#T#oGv#o#p*g#p$g%Z$g;'SGv;'S;=`Iv<%lOGv+dIyP;=`<%lGv07[JPP;=`<%lEr(KWJ_`$h&j(Rp(U!b#m(ChOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KWKl_$h&j$P(Ch(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z,#xLva(u+JY$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sv%ZvwM{wx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KWNW`$h&j#y(Ch(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'At! c_(T';W$h&j(RpOY!!bYZ!#hZr!!brs!#hsw!!bwx!$xx!^!!b!^!_!%z!_#O!!b#O#P!#h#P#o!!b#o#p!%z#p;'S!!b;'S;=`!'c<%lO!!b'l!!i_$h&j(RpOY!!bYZ!#hZr!!brs!#hsw!!bwx!$xx!^!!b!^!_!%z!_#O!!b#O#P!#h#P#o!!b#o#p!%z#p;'S!!b;'S;=`!'c<%lO!!b&z!#mX$h&jOw!#hwx6cx!^!#h!^!_!$Y!_#o!#h#o#p!$Y#p;'S!#h;'S;=`!$r<%lO!#h`!$]TOw!$Ywx7]x;'S!$Y;'S;=`!$l<%lO!$Y`!$oP;=`<%l!$Y&z!$uP;=`<%l!#h'l!%R]$c`$h&j(RpOY(rYZ&cZr(rrs&cs!^(r!^!_)r!_#O(r#O#P&c#P#o(r#o#p)r#p;'S(r;'S;=`*a<%lO(r!Q!&PZ(RpOY!%zYZ!$YZr!%zrs!$Ysw!%zwx!&rx#O!%z#O#P!$Y#P;'S!%z;'S;=`!']<%lO!%z!Q!&yU$c`(RpOY)rZr)rs#O)r#P;'S)r;'S;=`*Z<%lO)r!Q!'`P;=`<%l!%z'l!'fP;=`<%l!!b/5|!'t_!i/.^$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z#&U!)O_!h!Lf$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z-!n!*[b$h&j(Rp(U!b(P%&f#n(ChOY%ZYZ&cZr%Zrs&}sw%Zwx(rxz%Zz{!+d{!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW!+o`$h&j(Rp(U!b#k(ChOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z+;x!,|`$h&j(Rp(U!bo+4YOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z,$U!.Z_!Y+Jf$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z07[!/ec$h&j(Rp(U!b}.2^OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!0p!P!Q%Z!Q![!3Y![!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z#%|!0ya$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!2O!P!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z#%|!2Z_!X!L^$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad!3eg$h&j(Rp(U!bp'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![!3Y![!^%Z!^!_*g!_!g%Z!g!h!4|!h#O%Z#O#P&c#P#R%Z#R#S!3Y#S#X%Z#X#Y!4|#Y#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad!5Vg$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx{%Z{|!6n|}%Z}!O!6n!O!Q%Z!Q![!8S![!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S!8S#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad!6wc$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![!8S![!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S!8S#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad!8_c$h&j(Rp(U!bp'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![!8S![!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S!8S#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z07[!9uf$h&j(Rp(U!b#l(ChOY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcxz!;Zz{#-}{!P!;Z!P!Q#/d!Q!^!;Z!^!_#(i!_!`#7S!`!a#8i!a!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;Z?O!;fb$h&j(Rp(U!b!U7`OY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcx!P!;Z!P!Q#&`!Q!^!;Z!^!_#(i!_!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;Z>^!<w`$h&j(U!b!U7`OY!<nYZ&cZw!<nwx!=yx!P!<n!P!Q!Eq!Q!^!<n!^!_!Gr!_!}!<n!}#O!KS#O#P!Dy#P#o!<n#o#p!Gr#p;'S!<n;'S;=`!L]<%lO!<n<z!>Q^$h&j!U7`OY!=yYZ&cZ!P!=y!P!Q!>|!Q!^!=y!^!_!@c!_!}!=y!}#O!CW#O#P!Dy#P#o!=y#o#p!@c#p;'S!=y;'S;=`!Ek<%lO!=y<z!?Td$h&j!U7`O!^&c!_#W&c#W#X!>|#X#Z&c#Z#[!>|#[#]&c#]#^!>|#^#a&c#a#b!>|#b#g&c#g#h!>|#h#i&c#i#j!>|#j#k!>|#k#m&c#m#n!>|#n#o&c#p;'S&c;'S;=`&w<%lO&c7`!@hX!U7`OY!@cZ!P!@c!P!Q!AT!Q!}!@c!}#O!Ar#O#P!Bq#P;'S!@c;'S;=`!CQ<%lO!@c7`!AYW!U7`#W#X!AT#Z#[!AT#]#^!AT#a#b!AT#g#h!AT#i#j!AT#j#k!AT#m#n!AT7`!AuVOY!ArZ#O!Ar#O#P!B[#P#Q!@c#Q;'S!Ar;'S;=`!Bk<%lO!Ar7`!B_SOY!ArZ;'S!Ar;'S;=`!Bk<%lO!Ar7`!BnP;=`<%l!Ar7`!BtSOY!@cZ;'S!@c;'S;=`!CQ<%lO!@c7`!CTP;=`<%l!@c<z!C][$h&jOY!CWYZ&cZ!^!CW!^!_!Ar!_#O!CW#O#P!DR#P#Q!=y#Q#o!CW#o#p!Ar#p;'S!CW;'S;=`!Ds<%lO!CW<z!DWX$h&jOY!CWYZ&cZ!^!CW!^!_!Ar!_#o!CW#o#p!Ar#p;'S!CW;'S;=`!Ds<%lO!CW<z!DvP;=`<%l!CW<z!EOX$h&jOY!=yYZ&cZ!^!=y!^!_!@c!_#o!=y#o#p!@c#p;'S!=y;'S;=`!Ek<%lO!=y<z!EnP;=`<%l!=y>^!Ezl$h&j(U!b!U7`OY&}YZ&cZw&}wx&cx!^&}!^!_'}!_#O&}#O#P&c#P#W&}#W#X!Eq#X#Z&}#Z#[!Eq#[#]&}#]#^!Eq#^#a&}#a#b!Eq#b#g&}#g#h!Eq#h#i&}#i#j!Eq#j#k!Eq#k#m&}#m#n!Eq#n#o&}#o#p'}#p;'S&};'S;=`(l<%lO&}8r!GyZ(U!b!U7`OY!GrZw!Grwx!@cx!P!Gr!P!Q!Hl!Q!}!Gr!}#O!JU#O#P!Bq#P;'S!Gr;'S;=`!J|<%lO!Gr8r!Hse(U!b!U7`OY'}Zw'}x#O'}#P#W'}#W#X!Hl#X#Z'}#Z#[!Hl#[#]'}#]#^!Hl#^#a'}#a#b!Hl#b#g'}#g#h!Hl#h#i'}#i#j!Hl#j#k!Hl#k#m'}#m#n!Hl#n;'S'};'S;=`(f<%lO'}8r!JZX(U!bOY!JUZw!JUwx!Arx#O!JU#O#P!B[#P#Q!Gr#Q;'S!JU;'S;=`!Jv<%lO!JU8r!JyP;=`<%l!JU8r!KPP;=`<%l!Gr>^!KZ^$h&j(U!bOY!KSYZ&cZw!KSwx!CWx!^!KS!^!_!JU!_#O!KS#O#P!DR#P#Q!<n#Q#o!KS#o#p!JU#p;'S!KS;'S;=`!LV<%lO!KS>^!LYP;=`<%l!KS>^!L`P;=`<%l!<n=l!Ll`$h&j(Rp!U7`OY!LcYZ&cZr!Lcrs!=ys!P!Lc!P!Q!Mn!Q!^!Lc!^!_# o!_!}!Lc!}#O#%P#O#P!Dy#P#o!Lc#o#p# o#p;'S!Lc;'S;=`#&Y<%lO!Lc=l!Mwl$h&j(Rp!U7`OY(rYZ&cZr(rrs&cs!^(r!^!_)r!_#O(r#O#P&c#P#W(r#W#X!Mn#X#Z(r#Z#[!Mn#[#](r#]#^!Mn#^#a(r#a#b!Mn#b#g(r#g#h!Mn#h#i(r#i#j!Mn#j#k!Mn#k#m(r#m#n!Mn#n#o(r#o#p)r#p;'S(r;'S;=`*a<%lO(r8Q# vZ(Rp!U7`OY# oZr# ors!@cs!P# o!P!Q#!i!Q!}# o!}#O#$R#O#P!Bq#P;'S# o;'S;=`#$y<%lO# o8Q#!pe(Rp!U7`OY)rZr)rs#O)r#P#W)r#W#X#!i#X#Z)r#Z#[#!i#[#])r#]#^#!i#^#a)r#a#b#!i#b#g)r#g#h#!i#h#i)r#i#j#!i#j#k#!i#k#m)r#m#n#!i#n;'S)r;'S;=`*Z<%lO)r8Q#$WX(RpOY#$RZr#$Rrs!Ars#O#$R#O#P!B[#P#Q# o#Q;'S#$R;'S;=`#$s<%lO#$R8Q#$vP;=`<%l#$R8Q#$|P;=`<%l# o=l#%W^$h&j(RpOY#%PYZ&cZr#%Prs!CWs!^#%P!^!_#$R!_#O#%P#O#P!DR#P#Q!Lc#Q#o#%P#o#p#$R#p;'S#%P;'S;=`#&S<%lO#%P=l#&VP;=`<%l#%P=l#&]P;=`<%l!Lc?O#&kn$h&j(Rp(U!b!U7`OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#W%Z#W#X#&`#X#Z%Z#Z#[#&`#[#]%Z#]#^#&`#^#a%Z#a#b#&`#b#g%Z#g#h#&`#h#i%Z#i#j#&`#j#k#&`#k#m%Z#m#n#&`#n#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z9d#(r](Rp(U!b!U7`OY#(iZr#(irs!Grsw#(iwx# ox!P#(i!P!Q#)k!Q!}#(i!}#O#+`#O#P!Bq#P;'S#(i;'S;=`#,`<%lO#(i9d#)th(Rp(U!b!U7`OY*gZr*grs'}sw*gwx)rx#O*g#P#W*g#W#X#)k#X#Z*g#Z#[#)k#[#]*g#]#^#)k#^#a*g#a#b#)k#b#g*g#g#h#)k#h#i*g#i#j#)k#j#k#)k#k#m*g#m#n#)k#n;'S*g;'S;=`+Z<%lO*g9d#+gZ(Rp(U!bOY#+`Zr#+`rs!JUsw#+`wx#$Rx#O#+`#O#P!B[#P#Q#(i#Q;'S#+`;'S;=`#,Y<%lO#+`9d#,]P;=`<%l#+`9d#,cP;=`<%l#(i?O#,o`$h&j(Rp(U!bOY#,fYZ&cZr#,frs!KSsw#,fwx#%Px!^#,f!^!_#+`!_#O#,f#O#P!DR#P#Q!;Z#Q#o#,f#o#p#+`#p;'S#,f;'S;=`#-q<%lO#,f?O#-tP;=`<%l#,f?O#-zP;=`<%l!;Z07[#.[b$h&j(Rp(U!b'y0/l!U7`OY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcx!P!;Z!P!Q#&`!Q!^!;Z!^!_#(i!_!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;Z07[#/o_$h&j(Rp(U!bT0/lOY#/dYZ&cZr#/drs#0nsw#/dwx#4Ox!^#/d!^!_#5}!_#O#/d#O#P#1p#P#o#/d#o#p#5}#p;'S#/d;'S;=`#6|<%lO#/d06j#0w]$h&j(U!bT0/lOY#0nYZ&cZw#0nwx#1px!^#0n!^!_#3R!_#O#0n#O#P#1p#P#o#0n#o#p#3R#p;'S#0n;'S;=`#3x<%lO#0n05W#1wX$h&jT0/lOY#1pYZ&cZ!^#1p!^!_#2d!_#o#1p#o#p#2d#p;'S#1p;'S;=`#2{<%lO#1p0/l#2iST0/lOY#2dZ;'S#2d;'S;=`#2u<%lO#2d0/l#2xP;=`<%l#2d05W#3OP;=`<%l#1p01O#3YW(U!bT0/lOY#3RZw#3Rwx#2dx#O#3R#O#P#2d#P;'S#3R;'S;=`#3r<%lO#3R01O#3uP;=`<%l#3R06j#3{P;=`<%l#0n05x#4X]$h&j(RpT0/lOY#4OYZ&cZr#4Ors#1ps!^#4O!^!_#5Q!_#O#4O#O#P#1p#P#o#4O#o#p#5Q#p;'S#4O;'S;=`#5w<%lO#4O00^#5XW(RpT0/lOY#5QZr#5Qrs#2ds#O#5Q#O#P#2d#P;'S#5Q;'S;=`#5q<%lO#5Q00^#5tP;=`<%l#5Q05x#5zP;=`<%l#4O01p#6WY(Rp(U!bT0/lOY#5}Zr#5}rs#3Rsw#5}wx#5Qx#O#5}#O#P#2d#P;'S#5};'S;=`#6v<%lO#5}01p#6yP;=`<%l#5}07[#7PP;=`<%l#/d)3h#7ab$h&j$P(Ch(Rp(U!b!U7`OY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcx!P!;Z!P!Q#&`!Q!^!;Z!^!_#(i!_!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;ZAt#8vb$Y#t$h&j(Rp(U!b!U7`OY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcx!P!;Z!P!Q#&`!Q!^!;Z!^!_#(i!_!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;Z'Ad#:Zp$h&j(Rp(U!bp'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!3Y!P!Q%Z!Q![#<_![!^%Z!^!_*g!_!g%Z!g!h!4|!h#O%Z#O#P&c#P#R%Z#R#S#<_#S#U%Z#U#V#?i#V#X%Z#X#Y!4|#Y#b%Z#b#c#>_#c#d#Bq#d#l%Z#l#m#Es#m#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#<jk$h&j(Rp(U!bp'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!3Y!P!Q%Z!Q![#<_![!^%Z!^!_*g!_!g%Z!g!h!4|!h#O%Z#O#P&c#P#R%Z#R#S#<_#S#X%Z#X#Y!4|#Y#b%Z#b#c#>_#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#>j_$h&j(Rp(U!bp'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#?rd$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!R#AQ!R!S#AQ!S!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#AQ#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#A]f$h&j(Rp(U!bp'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!R#AQ!R!S#AQ!S!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#AQ#S#b%Z#b#c#>_#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#Bzc$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!Y#DV!Y!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#DV#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#Dbe$h&j(Rp(U!bp'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!Y#DV!Y!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#DV#S#b%Z#b#c#>_#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#E|g$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![#Ge![!^%Z!^!_*g!_!c%Z!c!i#Ge!i#O%Z#O#P&c#P#R%Z#R#S#Ge#S#T%Z#T#Z#Ge#Z#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#Gpi$h&j(Rp(U!bp'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![#Ge![!^%Z!^!_*g!_!c%Z!c!i#Ge!i#O%Z#O#P&c#P#R%Z#R#S#Ge#S#T%Z#T#Z#Ge#Z#b%Z#b#c#>_#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z*)x#Il_!d$b$h&j#})Lv(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z)[#Jv_al$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z04f#LS^h#)`#O-<U(Rp(U!b(y7`OY*gZr*grs'}sw*gwx)rx!P*g!P!Q#MO!Q!^*g!^!_#Mt!_!`$ f!`#O*g#P;'S*g;'S;=`+Z<%lO*g(n#MXX$j&j(Rp(U!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g(El#M}Z#o(Ch(Rp(U!bOY*gZr*grs'}sw*gwx)rx!_*g!_!`#Np!`#O*g#P;'S*g;'S;=`+Z<%lO*g(El#NyX$P(Ch(Rp(U!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g(El$ oX#p(Ch(Rp(U!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g*)x$!ga#]*!Y$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`0z!`!a$#l!a#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(K[$#w_#h(Cl$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z*)x$%Vag!*r#p(Ch$e#|$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`$&[!`!a$'f!a#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$&g_#p(Ch$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$'qa#o(Ch$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`!a$(v!a#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$)R`#o(Ch$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(Kd$*`a(m(Ct$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!a%Z!a!b$+e!b#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$+p`$h&j#z(Ch(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#`$,}_!y$Ip$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z04f$.X_!P0,v$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(n$/]Z$h&jO!^$0O!^!_$0f!_#i$0O#i#j$0k#j#l$0O#l#m$2^#m#o$0O#o#p$0f#p;'S$0O;'S;=`$4i<%lO$0O(n$0VT_#S$h&jO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c#S$0kO_#S(n$0p[$h&jO!Q&c!Q![$1f![!^&c!_!c&c!c!i$1f!i#T&c#T#Z$1f#Z#o&c#o#p$3|#p;'S&c;'S;=`&w<%lO&c(n$1kZ$h&jO!Q&c!Q![$2^![!^&c!_!c&c!c!i$2^!i#T&c#T#Z$2^#Z#o&c#p;'S&c;'S;=`&w<%lO&c(n$2cZ$h&jO!Q&c!Q![$3U![!^&c!_!c&c!c!i$3U!i#T&c#T#Z$3U#Z#o&c#p;'S&c;'S;=`&w<%lO&c(n$3ZZ$h&jO!Q&c!Q![$0O![!^&c!_!c&c!c!i$0O!i#T&c#T#Z$0O#Z#o&c#p;'S&c;'S;=`&w<%lO&c#S$4PR!Q![$4Y!c!i$4Y#T#Z$4Y#S$4]S!Q![$4Y!c!i$4Y#T#Z$4Y#q#r$0f(n$4lP;=`<%l$0O#1[$4z_!V#)l$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$6U`#w(Ch$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z+;p$7c_$h&j(Rp(U!b([+4QOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z07[$8qk$h&j(Rp(U!b(O,2j$^#t(`$I[OY%ZYZ&cZr%Zrs&}st%Ztu$8buw%Zwx(rx}%Z}!O$:f!O!Q%Z!Q![$8b![!^%Z!^!_*g!_!c%Z!c!}$8b!}#O%Z#O#P&c#P#R%Z#R#S$8b#S#T%Z#T#o$8b#o#p*g#p$g%Z$g;'S$8b;'S;=`$<l<%lO$8b+d$:qk$h&j(Rp(U!b$^#tOY%ZYZ&cZr%Zrs&}st%Ztu$:fuw%Zwx(rx}%Z}!O$:f!O!Q%Z!Q![$:f![!^%Z!^!_*g!_!c%Z!c!}$:f!}#O%Z#O#P&c#P#R%Z#R#S$:f#S#T%Z#T#o$:f#o#p*g#p$g%Z$g;'S$:f;'S;=`$<f<%lO$:f+d$<iP;=`<%l$:f07[$<oP;=`<%l$8b#Jf$<{X![#Hb(Rp(U!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g,#x$=sa(t+JY$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p#q$+e#q;'S%Z;'S;=`+a<%lO%Z(Kd$?V_!Z(Cds`$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z?O$@a_!n7`$h&j(Rp(U!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z07[$Aq|$h&j(Rp(U!b'w0/l$[#t(O,2j(`$I[OX%ZXY+gYZ&cZ[+g[p%Zpq+gqr%Zrs&}st%ZtuEruw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Er![!^%Z!^!_*g!_!c%Z!c!}Er!}#O%Z#O#P&c#P#R%Z#R#SEr#S#T%Z#T#oEr#o#p*g#p$f%Z$f$g+g$g#BYEr#BY#BZ$A`#BZ$ISEr$IS$I_$A`$I_$JTEr$JT$JU$A`$JU$KVEr$KV$KW$A`$KW&FUEr&FU&FV$A`&FV;'SEr;'S;=`I|<%l?HTEr?HT?HU$A`?HUOEr07[$D|k$h&j(Rp(U!b'x0/l$[#t(O,2j(`$I[OY%ZYZ&cZr%Zrs&}st%ZtuEruw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Er![!^%Z!^!_*g!_!c%Z!c!}Er!}#O%Z#O#P&c#P#R%Z#R#SEr#S#T%Z#T#oEr#o#p*g#p$g%Z$g;'SEr;'S;=`I|<%lOEr",
  tokenizers: [KFe, JFe, e$e, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, qFe, new vI("$S~RRtu[#O#Pg#S#T#|~_P#o#pb~gOu~~jVO#i!P#i#j!U#j#l!P#l#m!q#m;'S!P;'S;=`#v<%lO!P~!UO!R~~!XS!Q![!e!c!i!e#T#Z!e#o#p#Z~!hR!Q![!q!c!i!q#T#Z!q~!tR!Q![!}!c!i!}#T#Z!}~#QR!Q![!P!c!i!P#T#Z!P~#^R!Q![#g!c!i#g#T#Z#g~#jS!Q![#g!c!i#g#T#Z#g#q#r!P~#yP;=`<%l!P~$RO(^~~", 141, 335), new vI("j~RQYZXz{^~^O'{~~aP!P!Qd~iO'|~~", 25, 318)],
  topRules: { Script: [0, 7], SingleExpression: [1, 272], SingleClassItem: [2, 273] },
  dialects: { jsx: 0, ts: 14769 },
  dynamicPrecedences: { 77: 1, 79: 1, 91: 1, 167: 1, 196: 1 },
  specialized: [{ term: 322, get: (t) => n$e[t] || -1 }, { term: 338, get: (t) => r$e[t] || -1 }, { term: 92, get: (t) => a$e[t] || -1 }],
  tokenPrec: 14793
}), v6 = [
  /* @__PURE__ */ Xu("function ${name}(${params}) {\n	${}\n}", {
    label: "function",
    detail: "definition",
    type: "keyword"
  }),
  /* @__PURE__ */ Xu("for (let ${index} = 0; ${index} < ${bound}; ${index}++) {\n	${}\n}", {
    label: "for",
    detail: "loop",
    type: "keyword"
  }),
  /* @__PURE__ */ Xu("for (let ${name} of ${collection}) {\n	${}\n}", {
    label: "for",
    detail: "of loop",
    type: "keyword"
  }),
  /* @__PURE__ */ Xu("do {\n	${}\n} while (${})", {
    label: "do",
    detail: "loop",
    type: "keyword"
  }),
  /* @__PURE__ */ Xu("while (${}) {\n	${}\n}", {
    label: "while",
    detail: "loop",
    type: "keyword"
  }),
  /* @__PURE__ */ Xu(`try {
	\${}
} catch (\${error}) {
	\${}
}`, {
    label: "try",
    detail: "/ catch block",
    type: "keyword"
  }),
  /* @__PURE__ */ Xu("if (${}) {\n	${}\n}", {
    label: "if",
    detail: "block",
    type: "keyword"
  }),
  /* @__PURE__ */ Xu(`if (\${}) {
	\${}
} else {
	\${}
}`, {
    label: "if",
    detail: "/ else block",
    type: "keyword"
  }),
  /* @__PURE__ */ Xu(`class \${name} {
	constructor(\${params}) {
		\${}
	}
}`, {
    label: "class",
    detail: "definition",
    type: "keyword"
  }),
  /* @__PURE__ */ Xu('import {${names}} from "${module}"\n${}', {
    label: "import",
    detail: "named",
    type: "keyword"
  }),
  /* @__PURE__ */ Xu('import ${name} from "${module}"\n${}', {
    label: "import",
    detail: "default",
    type: "keyword"
  })
], pse = /* @__PURE__ */ v6.concat([
  /* @__PURE__ */ Xu("interface ${name} {\n	${}\n}", {
    label: "interface",
    detail: "definition",
    type: "keyword"
  }),
  /* @__PURE__ */ Xu("type ${name} = ${type}", {
    label: "type",
    detail: "definition",
    type: "keyword"
  }),
  /* @__PURE__ */ Xu("enum ${name} {\n	${}\n}", {
    label: "enum",
    detail: "definition",
    type: "keyword"
  })
]), gK = /* @__PURE__ */ new zie(), hse = /* @__PURE__ */ new Set([
  "Script",
  "Block",
  "FunctionExpression",
  "FunctionDeclaration",
  "ArrowFunction",
  "MethodDeclaration",
  "ForStatement"
]);
function Tw(t) {
  return (e, n) => {
    let r = e.node.getChild("VariableDefinition");
    return r && n(r, t), !0;
  };
}
const o$e = ["FunctionDeclaration"], s$e = {
  FunctionDeclaration: /* @__PURE__ */ Tw("function"),
  ClassDeclaration: /* @__PURE__ */ Tw("class"),
  ClassExpression: () => !0,
  EnumDeclaration: /* @__PURE__ */ Tw("constant"),
  TypeAliasDeclaration: /* @__PURE__ */ Tw("type"),
  NamespaceDeclaration: /* @__PURE__ */ Tw("namespace"),
  VariableDefinition(t, e) {
    t.matchContext(o$e) || e(t, "variable");
  },
  TypeDefinition(t, e) {
    e(t, "type");
  },
  __proto__: null
};
function mse(t, e) {
  let n = gK.get(e);
  if (n)
    return n;
  let r = [], a = !0;
  function i(o, s) {
    let u = t.sliceString(o.from, o.to);
    r.push({ label: u, type: s });
  }
  return e.cursor(ii.IncludeAnonymous).iterate((o) => {
    if (a)
      a = !1;
    else if (o.name) {
      let s = s$e[o.name];
      if (s && s(o, i) || hse.has(o.name))
        return !1;
    } else if (o.to - o.from > 8192) {
      for (let s of mse(t, o.node))
        r.push(s);
      return !1;
    }
  }), gK.set(e, r), r;
}
const EI = /^[\w$\xa1-\uffff][\w$\d\xa1-\uffff]*$/, y6 = [
  "TemplateString",
  "String",
  "RegExp",
  "LineComment",
  "BlockComment",
  "VariableDefinition",
  "TypeDefinition",
  "Label",
  "PropertyDefinition",
  "PropertyName",
  "PrivatePropertyDefinition",
  "PrivatePropertyName",
  ".",
  "?."
];
function gse(t) {
  let e = $a(t.state).resolveInner(t.pos, -1);
  if (y6.indexOf(e.name) > -1)
    return null;
  let n = e.name == "VariableName" || e.to - e.from < 20 && EI.test(t.state.sliceDoc(e.from, e.to));
  if (!n && !t.explicit)
    return null;
  let r = [];
  for (let a = e; a; a = a.parent)
    hse.has(a.name) && (r = r.concat(mse(t.state.doc, a)));
  return {
    options: r,
    from: n ? e.from : t.pos,
    validFor: EI
  };
}
function k3(t, e, n) {
  var r;
  let a = [];
  for (; ; ) {
    let i = e.firstChild, o;
    if ((i == null ? void 0 : i.name) == "VariableName")
      return a.push(t(i)), { path: a.reverse(), name: n };
    if ((i == null ? void 0 : i.name) == "MemberExpression" && ((r = o = i.lastChild) === null || r === void 0 ? void 0 : r.name) == "PropertyName")
      a.push(t(o)), e = i;
    else
      return null;
  }
}
function bse(t) {
  let e = (r) => t.state.doc.sliceString(r.from, r.to), n = $a(t.state).resolveInner(t.pos, -1);
  return n.name == "PropertyName" ? k3(e, n.parent, e(n)) : (n.name == "." || n.name == "?.") && n.parent.name == "MemberExpression" ? k3(e, n.parent, "") : y6.indexOf(n.name) > -1 ? null : n.name == "VariableName" || n.to - n.from < 20 && EI.test(e(n)) ? { path: [], name: e(n) } : n.name == "MemberExpression" ? k3(e, n, "") : t.explicit ? { path: [], name: "" } : null;
}
function l$e(t, e) {
  let n = [], r = /* @__PURE__ */ new Set();
  for (let a = 0; ; a++) {
    for (let o of (Object.getOwnPropertyNames || Object.keys)(t)) {
      if (!/^[a-zA-Z_$\xaa-\uffdc][\w$\xaa-\uffdc]*$/.test(o) || r.has(o))
        continue;
      r.add(o);
      let s;
      try {
        s = t[o];
      } catch {
        continue;
      }
      n.push({
        label: o,
        type: typeof s == "function" ? /^[A-Z]/.test(o) ? "class" : e ? "function" : "method" : e ? "variable" : "property",
        boost: -a
      });
    }
    let i = Object.getPrototypeOf(t);
    if (!i)
      return n;
    t = i;
  }
}
function u$e(t) {
  let e = /* @__PURE__ */ new Map();
  return (n) => {
    let r = bse(n);
    if (!r)
      return null;
    let a = t;
    for (let o of r.path)
      if (a = a[o], !a)
        return null;
    let i = e.get(a);
    return i || e.set(a, i = l$e(a, !r.path.length)), {
      from: n.pos - r.name.length,
      options: i,
      validFor: EI
    };
  };
}
const Gf = /* @__PURE__ */ VE.define({
  name: "javascript",
  parser: /* @__PURE__ */ i$e.configure({
    props: [
      /* @__PURE__ */ S_.add({
        IfStatement: /* @__PURE__ */ kk({ except: /^\s*({|else\b)/ }),
        TryStatement: /* @__PURE__ */ kk({ except: /^\s*({|catch\b|finally\b)/ }),
        LabeledStatement: cLe,
        SwitchBody: (t) => {
          let e = t.textAfter, n = /^\s*\}/.test(e), r = /^\s*(case|default)\b/.test(e);
          return t.baseIndent + (n ? 0 : r ? 1 : 2) * t.unit;
        },
        Block: /* @__PURE__ */ uLe({ closing: "}" }),
        ArrowFunction: (t) => t.baseIndent + t.unit,
        "TemplateString BlockComment": () => null,
        "Statement Property": /* @__PURE__ */ kk({ except: /^{/ }),
        JSXElement(t) {
          let e = /^\s*<\//.test(t.textAfter);
          return t.lineIndent(t.node.from) + (e ? 0 : t.unit);
        },
        JSXEscape(t) {
          let e = /\s*\}/.test(t.textAfter);
          return t.lineIndent(t.node.from) + (e ? 0 : t.unit);
        },
        "JSXOpenTag JSXSelfClosingTag"(t) {
          return t.column(t.node.from) + t.unit;
        }
      }),
      /* @__PURE__ */ d1.add({
        "Block ClassBody SwitchBody EnumBody ObjectExpression ArrayExpression ObjectType": Xie,
        BlockComment(t) {
          return { from: t.from + 2, to: t.to - 2 };
        }
      })
    ]
  }),
  languageData: {
    closeBrackets: { brackets: ["(", "[", "{", "'", '"', "`"] },
    commentTokens: { line: "//", block: { open: "/*", close: "*/" } },
    indentOnInput: /^\s*(?:case |default:|\{|\}|<\/)$/,
    wordChars: "$"
  }
}), vse = {
  test: (t) => /^JSX/.test(t.name),
  facet: /* @__PURE__ */ ED({ commentTokens: { block: { open: "{/*", close: "*/}" } } })
}, O6 = /* @__PURE__ */ Gf.configure({ dialect: "ts" }, "typescript"), E6 = /* @__PURE__ */ Gf.configure({
  dialect: "jsx",
  props: [/* @__PURE__ */ KU.add((t) => t.isTop ? [vse] : void 0)]
}), S6 = /* @__PURE__ */ Gf.configure({
  dialect: "jsx ts",
  props: [/* @__PURE__ */ KU.add((t) => t.isTop ? [vse] : void 0)]
}, "typescript");
let yse = (t) => ({ label: t, type: "keyword" });
const Ose = /* @__PURE__ */ "break case const continue default delete export extends false finally in instanceof let new return static super switch this throw true typeof var yield".split(" ").map(yse), c$e = /* @__PURE__ */ Ose.concat(/* @__PURE__ */ ["declare", "implements", "private", "protected", "public"].map(yse));
function Ese(t = {}) {
  let e = t.jsx ? t.typescript ? S6 : E6 : t.typescript ? O6 : Gf, n = t.typescript ? pse.concat(c$e) : v6.concat(Ose);
  return new ZE(e, [
    Gf.data.of({
      autocomplete: GLe(y6, hoe(n))
    }),
    Gf.data.of({
      autocomplete: gse
    }),
    t.jsx ? Sse : []
  ]);
}
function f$e(t) {
  for (; ; ) {
    if (t.name == "JSXOpenTag" || t.name == "JSXSelfClosingTag" || t.name == "JSXFragmentTag")
      return t;
    if (t.name == "JSXEscape" || !t.parent)
      return null;
    t = t.parent;
  }
}
function bK(t, e, n = t.length) {
  for (let r = e == null ? void 0 : e.firstChild; r; r = r.nextSibling)
    if (r.name == "JSXIdentifier" || r.name == "JSXBuiltin" || r.name == "JSXNamespacedName" || r.name == "JSXMemberExpression")
      return t.sliceString(r.from, Math.min(r.to, n));
  return "";
}
const d$e = typeof navigator == "object" && /* @__PURE__ */ /Android\b/.test(navigator.userAgent), Sse = /* @__PURE__ */ qt.inputHandler.of((t, e, n, r, a) => {
  if ((d$e ? t.composing : t.compositionStarted) || t.state.readOnly || e != n || r != ">" && r != "/" || !Gf.isActiveAt(t.state, e, -1))
    return !1;
  let i = a(), { state: o } = i, s = o.changeByRange((u) => {
    var f;
    let { head: p } = u, m = $a(o).resolveInner(p - 1, -1), v;
    if (m.name == "JSXStartTag" && (m = m.parent), !(o.doc.sliceString(p - 1, p) != r || m.name == "JSXAttributeValue" && m.to > p)) {
      if (r == ">" && m.name == "JSXFragmentTag")
        return { range: u, changes: { from: p, insert: "</>" } };
      if (r == "/" && m.name == "JSXStartCloseTag") {
        let O = m.parent, w = O.parent;
        if (w && O.from == p - 2 && ((v = bK(o.doc, w.firstChild, p)) || ((f = w.firstChild) === null || f === void 0 ? void 0 : f.name) == "JSXFragmentTag")) {
          let _ = `${v}>`;
          return { range: ft.cursor(p + _.length, -1), changes: { from: p, insert: _ } };
        }
      } else if (r == ">") {
        let O = f$e(m);
        if (O && O.name == "JSXOpenTag" && !/^\/?>|^<\//.test(o.doc.sliceString(p, p + 2)) && (v = bK(o.doc, O, p)))
          return { range: u, changes: { from: p, insert: `</${v}>` } };
      }
    }
    return { range: u };
  });
  return s.changes.empty ? !1 : (t.dispatch([
    i,
    o.update(s, { userEvent: "input.complete", scrollIntoView: !0 })
  ]), !0);
});
function p$e(t, e) {
  return e || (e = {
    parserOptions: { ecmaVersion: 2019, sourceType: "module" },
    env: { browser: !0, node: !0, es6: !0, es2015: !0, es2017: !0, es2020: !0 },
    rules: {}
  }, t.getRules().forEach((n, r) => {
    n.meta.docs.recommended && (e.rules[r] = 2);
  })), (n) => {
    let { state: r } = n, a = [];
    for (let { from: i, to: o } of Gf.findRegions(r)) {
      let s = r.doc.lineAt(i), u = { line: s.number - 1, col: i - s.from, pos: i };
      for (let f of t.verify(r.sliceDoc(i, o), e))
        a.push(h$e(f, r.doc, u));
    }
    return a;
  };
}
function vK(t, e, n, r) {
  return n.line(t + r.line).from + e + (t == 1 ? r.col - 1 : -1);
}
function h$e(t, e, n) {
  let r = vK(t.line, t.column, e, n), a = {
    from: r,
    to: t.endLine != null && t.endColumn != 1 ? vK(t.endLine, t.endColumn, e, n) : r,
    message: t.message,
    source: t.ruleId ? "eslint:" + t.ruleId : "eslint",
    severity: t.severity == 1 ? "warning" : "error"
  };
  if (t.fix) {
    let { range: i, text: o } = t.fix, s = i[0] + n.pos - r, u = i[1] + n.pos - r;
    a.actions = [{
      name: "fix",
      apply(f, p) {
        f.dispatch({ changes: { from: p + s, to: p + u, insert: o }, scrollIntoView: !0 });
      }
    }];
  }
  return a;
}
const aA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  autoCloseTags: Sse,
  completionPath: bse,
  esLint: p$e,
  javascript: Ese,
  javascriptLanguage: Gf,
  jsxLanguage: E6,
  localCompletionSource: gse,
  scopeCompletionSource: u$e,
  snippets: v6,
  tsxLanguage: S6,
  typescriptLanguage: O6,
  typescriptSnippets: pse
}, Symbol.toStringTag, { value: "Module" })), _w = ["_blank", "_self", "_top", "_parent"], R3 = ["ascii", "utf-8", "utf-16", "latin1", "latin1"], I3 = ["get", "post", "put", "delete"], D3 = ["application/x-www-form-urlencoded", "multipart/form-data", "text/plain"], Ic = ["true", "false"], An = {}, m$e = {
  a: {
    attrs: {
      href: null,
      ping: null,
      type: null,
      media: null,
      target: _w,
      hreflang: null
    }
  },
  abbr: An,
  address: An,
  area: {
    attrs: {
      alt: null,
      coords: null,
      href: null,
      target: null,
      ping: null,
      media: null,
      hreflang: null,
      type: null,
      shape: ["default", "rect", "circle", "poly"]
    }
  },
  article: An,
  aside: An,
  audio: {
    attrs: {
      src: null,
      mediagroup: null,
      crossorigin: ["anonymous", "use-credentials"],
      preload: ["none", "metadata", "auto"],
      autoplay: ["autoplay"],
      loop: ["loop"],
      controls: ["controls"]
    }
  },
  b: An,
  base: { attrs: { href: null, target: _w } },
  bdi: An,
  bdo: An,
  blockquote: { attrs: { cite: null } },
  body: An,
  br: An,
  button: {
    attrs: {
      form: null,
      formaction: null,
      name: null,
      value: null,
      autofocus: ["autofocus"],
      disabled: ["autofocus"],
      formenctype: D3,
      formmethod: I3,
      formnovalidate: ["novalidate"],
      formtarget: _w,
      type: ["submit", "reset", "button"]
    }
  },
  canvas: { attrs: { width: null, height: null } },
  caption: An,
  center: An,
  cite: An,
  code: An,
  col: { attrs: { span: null } },
  colgroup: { attrs: { span: null } },
  command: {
    attrs: {
      type: ["command", "checkbox", "radio"],
      label: null,
      icon: null,
      radiogroup: null,
      command: null,
      title: null,
      disabled: ["disabled"],
      checked: ["checked"]
    }
  },
  data: { attrs: { value: null } },
  datagrid: { attrs: { disabled: ["disabled"], multiple: ["multiple"] } },
  datalist: { attrs: { data: null } },
  dd: An,
  del: { attrs: { cite: null, datetime: null } },
  details: { attrs: { open: ["open"] } },
  dfn: An,
  div: An,
  dl: An,
  dt: An,
  em: An,
  embed: { attrs: { src: null, type: null, width: null, height: null } },
  eventsource: { attrs: { src: null } },
  fieldset: { attrs: { disabled: ["disabled"], form: null, name: null } },
  figcaption: An,
  figure: An,
  footer: An,
  form: {
    attrs: {
      action: null,
      name: null,
      "accept-charset": R3,
      autocomplete: ["on", "off"],
      enctype: D3,
      method: I3,
      novalidate: ["novalidate"],
      target: _w
    }
  },
  h1: An,
  h2: An,
  h3: An,
  h4: An,
  h5: An,
  h6: An,
  head: {
    children: ["title", "base", "link", "style", "meta", "script", "noscript", "command"]
  },
  header: An,
  hgroup: An,
  hr: An,
  html: {
    attrs: { manifest: null }
  },
  i: An,
  iframe: {
    attrs: {
      src: null,
      srcdoc: null,
      name: null,
      width: null,
      height: null,
      sandbox: ["allow-top-navigation", "allow-same-origin", "allow-forms", "allow-scripts"],
      seamless: ["seamless"]
    }
  },
  img: {
    attrs: {
      alt: null,
      src: null,
      ismap: null,
      usemap: null,
      width: null,
      height: null,
      crossorigin: ["anonymous", "use-credentials"]
    }
  },
  input: {
    attrs: {
      alt: null,
      dirname: null,
      form: null,
      formaction: null,
      height: null,
      list: null,
      max: null,
      maxlength: null,
      min: null,
      name: null,
      pattern: null,
      placeholder: null,
      size: null,
      src: null,
      step: null,
      value: null,
      width: null,
      accept: ["audio/*", "video/*", "image/*"],
      autocomplete: ["on", "off"],
      autofocus: ["autofocus"],
      checked: ["checked"],
      disabled: ["disabled"],
      formenctype: D3,
      formmethod: I3,
      formnovalidate: ["novalidate"],
      formtarget: _w,
      multiple: ["multiple"],
      readonly: ["readonly"],
      required: ["required"],
      type: [
        "hidden",
        "text",
        "search",
        "tel",
        "url",
        "email",
        "password",
        "datetime",
        "date",
        "month",
        "week",
        "time",
        "datetime-local",
        "number",
        "range",
        "color",
        "checkbox",
        "radio",
        "file",
        "submit",
        "image",
        "reset",
        "button"
      ]
    }
  },
  ins: { attrs: { cite: null, datetime: null } },
  kbd: An,
  keygen: {
    attrs: {
      challenge: null,
      form: null,
      name: null,
      autofocus: ["autofocus"],
      disabled: ["disabled"],
      keytype: ["RSA"]
    }
  },
  label: { attrs: { for: null, form: null } },
  legend: An,
  li: { attrs: { value: null } },
  link: {
    attrs: {
      href: null,
      type: null,
      hreflang: null,
      media: null,
      sizes: ["all", "16x16", "16x16 32x32", "16x16 32x32 64x64"]
    }
  },
  map: { attrs: { name: null } },
  mark: An,
  menu: { attrs: { label: null, type: ["list", "context", "toolbar"] } },
  meta: {
    attrs: {
      content: null,
      charset: R3,
      name: ["viewport", "application-name", "author", "description", "generator", "keywords"],
      "http-equiv": ["content-language", "content-type", "default-style", "refresh"]
    }
  },
  meter: { attrs: { value: null, min: null, low: null, high: null, max: null, optimum: null } },
  nav: An,
  noscript: An,
  object: {
    attrs: {
      data: null,
      type: null,
      name: null,
      usemap: null,
      form: null,
      width: null,
      height: null,
      typemustmatch: ["typemustmatch"]
    }
  },
  ol: {
    attrs: { reversed: ["reversed"], start: null, type: ["1", "a", "A", "i", "I"] },
    children: ["li", "script", "template", "ul", "ol"]
  },
  optgroup: { attrs: { disabled: ["disabled"], label: null } },
  option: { attrs: { disabled: ["disabled"], label: null, selected: ["selected"], value: null } },
  output: { attrs: { for: null, form: null, name: null } },
  p: An,
  param: { attrs: { name: null, value: null } },
  pre: An,
  progress: { attrs: { value: null, max: null } },
  q: { attrs: { cite: null } },
  rp: An,
  rt: An,
  ruby: An,
  samp: An,
  script: {
    attrs: {
      type: ["text/javascript"],
      src: null,
      async: ["async"],
      defer: ["defer"],
      charset: R3
    }
  },
  section: An,
  select: {
    attrs: {
      form: null,
      name: null,
      size: null,
      autofocus: ["autofocus"],
      disabled: ["disabled"],
      multiple: ["multiple"]
    }
  },
  slot: { attrs: { name: null } },
  small: An,
  source: { attrs: { src: null, type: null, media: null } },
  span: An,
  strong: An,
  style: {
    attrs: {
      type: ["text/css"],
      media: null,
      scoped: null
    }
  },
  sub: An,
  summary: An,
  sup: An,
  table: An,
  tbody: An,
  td: { attrs: { colspan: null, rowspan: null, headers: null } },
  template: An,
  textarea: {
    attrs: {
      dirname: null,
      form: null,
      maxlength: null,
      name: null,
      placeholder: null,
      rows: null,
      cols: null,
      autofocus: ["autofocus"],
      disabled: ["disabled"],
      readonly: ["readonly"],
      required: ["required"],
      wrap: ["soft", "hard"]
    }
  },
  tfoot: An,
  th: { attrs: { colspan: null, rowspan: null, headers: null, scope: ["row", "col", "rowgroup", "colgroup"] } },
  thead: An,
  time: { attrs: { datetime: null } },
  title: An,
  tr: An,
  track: {
    attrs: {
      src: null,
      label: null,
      default: null,
      kind: ["subtitles", "captions", "descriptions", "chapters", "metadata"],
      srclang: null
    }
  },
  ul: { children: ["li", "script", "template", "ul", "ol"] },
  var: An,
  video: {
    attrs: {
      src: null,
      poster: null,
      width: null,
      height: null,
      crossorigin: ["anonymous", "use-credentials"],
      preload: ["auto", "metadata", "none"],
      autoplay: ["autoplay"],
      mediagroup: ["movie"],
      muted: ["muted"],
      controls: ["controls"]
    }
  },
  wbr: An
}, wse = {
  accesskey: null,
  class: null,
  contenteditable: Ic,
  contextmenu: null,
  dir: ["ltr", "rtl", "auto"],
  draggable: ["true", "false", "auto"],
  dropzone: ["copy", "move", "link", "string:", "file:"],
  hidden: ["hidden"],
  id: null,
  inert: ["inert"],
  itemid: null,
  itemprop: null,
  itemref: null,
  itemscope: ["itemscope"],
  itemtype: null,
  lang: ["ar", "bn", "de", "en-GB", "en-US", "es", "fr", "hi", "id", "ja", "pa", "pt", "ru", "tr", "zh"],
  spellcheck: Ic,
  autocorrect: Ic,
  autocapitalize: Ic,
  style: null,
  tabindex: null,
  title: null,
  translate: ["yes", "no"],
  rel: ["stylesheet", "alternate", "author", "bookmark", "help", "license", "next", "nofollow", "noreferrer", "prefetch", "prev", "search", "tag"],
  role: /* @__PURE__ */ "alert application article banner button cell checkbox complementary contentinfo dialog document feed figure form grid gridcell heading img list listbox listitem main navigation region row rowgroup search switch tab table tabpanel textbox timer".split(" "),
  "aria-activedescendant": null,
  "aria-atomic": Ic,
  "aria-autocomplete": ["inline", "list", "both", "none"],
  "aria-busy": Ic,
  "aria-checked": ["true", "false", "mixed", "undefined"],
  "aria-controls": null,
  "aria-describedby": null,
  "aria-disabled": Ic,
  "aria-dropeffect": null,
  "aria-expanded": ["true", "false", "undefined"],
  "aria-flowto": null,
  "aria-grabbed": ["true", "false", "undefined"],
  "aria-haspopup": Ic,
  "aria-hidden": Ic,
  "aria-invalid": ["true", "false", "grammar", "spelling"],
  "aria-label": null,
  "aria-labelledby": null,
  "aria-level": null,
  "aria-live": ["off", "polite", "assertive"],
  "aria-multiline": Ic,
  "aria-multiselectable": Ic,
  "aria-owns": null,
  "aria-posinset": null,
  "aria-pressed": ["true", "false", "mixed", "undefined"],
  "aria-readonly": Ic,
  "aria-relevant": null,
  "aria-required": Ic,
  "aria-selected": ["true", "false", "undefined"],
  "aria-setsize": null,
  "aria-sort": ["ascending", "descending", "none", "other"],
  "aria-valuemax": null,
  "aria-valuemin": null,
  "aria-valuenow": null,
  "aria-valuetext": null
}, Tse = /* @__PURE__ */ "beforeunload copy cut dragstart dragover dragleave dragenter dragend drag paste focus blur change click load mousedown mouseenter mouseleave mouseup keydown keyup resize scroll unload".split(" ").map((t) => "on" + t);
for (let t of Tse)
  wse[t] = null;
let n_ = class {
  constructor(e, n) {
    this.tags = Object.assign(Object.assign({}, m$e), e), this.globalAttrs = Object.assign(Object.assign({}, wse), n), this.allTags = Object.keys(this.tags), this.globalAttrNames = Object.keys(this.globalAttrs);
  }
};
n_.default = /* @__PURE__ */ new n_();
function KE(t, e, n = t.length) {
  if (!e)
    return "";
  let r = e.firstChild, a = r && r.getChild("TagName");
  return a ? t.sliceString(a.from, Math.min(a.to, n)) : "";
}
function JE(t, e = !1) {
  for (; t; t = t.parent)
    if (t.name == "Element")
      if (e)
        e = !1;
      else
        return t;
  return null;
}
function _se(t, e, n) {
  let r = n.tags[KE(t, JE(e))];
  return (r == null ? void 0 : r.children) || n.allTags;
}
function w6(t, e) {
  let n = [];
  for (let r = JE(e); r && !r.type.isTop; r = JE(r.parent)) {
    let a = KE(t, r);
    if (a && r.lastChild.name == "CloseTag")
      break;
    a && n.indexOf(a) < 0 && (e.name == "EndTag" || e.from >= r.firstChild.to) && n.push(a);
  }
  return n;
}
const Cse = /^[:\-\.\w\u00b7-\uffff]*$/;
function yK(t, e, n, r, a) {
  let i = /\s*>/.test(t.sliceDoc(a, a + 5)) ? "" : ">", o = JE(n, !0);
  return {
    from: r,
    to: a,
    options: _se(t.doc, o, e).map((s) => ({ label: s, type: "type" })).concat(w6(t.doc, n).map((s, u) => ({
      label: "/" + s,
      apply: "/" + s + i,
      type: "type",
      boost: 99 - u
    }))),
    validFor: /^\/?[:\-\.\w\u00b7-\uffff]*$/
  };
}
function OK(t, e, n, r) {
  let a = /\s*>/.test(t.sliceDoc(r, r + 5)) ? "" : ">";
  return {
    from: n,
    to: r,
    options: w6(t.doc, e).map((i, o) => ({ label: i, apply: i + a, type: "type", boost: 99 - o })),
    validFor: Cse
  };
}
function g$e(t, e, n, r) {
  let a = [], i = 0;
  for (let o of _se(t.doc, n, e))
    a.push({ label: "<" + o, type: "type" });
  for (let o of w6(t.doc, n))
    a.push({ label: "</" + o + ">", type: "type", boost: 99 - i++ });
  return { from: r, to: r, options: a, validFor: /^<\/?[:\-\.\w\u00b7-\uffff]*$/ };
}
function b$e(t, e, n, r, a) {
  let i = JE(n), o = i ? e.tags[KE(t.doc, i)] : null, s = o && o.attrs ? Object.keys(o.attrs) : [], u = o && o.globalAttrs === !1 ? s : s.length ? s.concat(e.globalAttrNames) : e.globalAttrNames;
  return {
    from: r,
    to: a,
    options: u.map((f) => ({ label: f, type: "property" })),
    validFor: Cse
  };
}
function v$e(t, e, n, r, a) {
  var i;
  let o = (i = n.parent) === null || i === void 0 ? void 0 : i.getChild("AttributeName"), s = [], u;
  if (o) {
    let f = t.sliceDoc(o.from, o.to), p = e.globalAttrs[f];
    if (!p) {
      let m = JE(n), v = m ? e.tags[KE(t.doc, m)] : null;
      p = (v == null ? void 0 : v.attrs) && v.attrs[f];
    }
    if (p) {
      let m = t.sliceDoc(r, a).toLowerCase(), v = '"', O = '"';
      /^['"]/.test(m) ? (u = m[0] == '"' ? /^[^"]*$/ : /^[^']*$/, v = "", O = t.sliceDoc(a, a + 1) == m[0] ? "" : m[0], m = m.slice(1), r++) : u = /^[^\s<>='"]*$/;
      for (let w of p)
        s.push({ label: w, apply: v + w + O, type: "constant" });
    }
  }
  return { from: r, to: a, options: s, validFor: u };
}
function xse(t, e) {
  let { state: n, pos: r } = e, a = $a(n).resolveInner(r, -1), i = a.resolve(r);
  for (let o = r, s; i == a && (s = a.childBefore(o)); ) {
    let u = s.lastChild;
    if (!u || !u.type.isError || u.from < u.to)
      break;
    i = a = s, o = u.from;
  }
  return a.name == "TagName" ? a.parent && /CloseTag$/.test(a.parent.name) ? OK(n, a, a.from, r) : yK(n, t, a, a.from, r) : a.name == "StartTag" ? yK(n, t, a, r, r) : a.name == "StartCloseTag" || a.name == "IncompleteCloseTag" ? OK(n, a, r, r) : a.name == "OpenTag" || a.name == "SelfClosingTag" || a.name == "AttributeName" ? b$e(n, t, a, a.name == "AttributeName" ? a.from : r, r) : a.name == "Is" || a.name == "AttributeValue" || a.name == "UnquotedAttributeValue" ? v$e(n, t, a, a.name == "Is" ? r : a.from, r) : e.explicit && (i.name == "Element" || i.name == "Text" || i.name == "Document") ? g$e(n, t, a, r) : null;
}
function Ase(t) {
  return xse(n_.default, t);
}
function kse(t) {
  let { extraTags: e, extraGlobalAttributes: n } = t, r = n || e ? new n_(e, n) : n_.default;
  return (a) => xse(r, a);
}
const y$e = /* @__PURE__ */ Gf.parser.configure({ top: "SingleExpression" }), Rse = [
  {
    tag: "script",
    attrs: (t) => t.type == "text/typescript" || t.lang == "ts",
    parser: O6.parser
  },
  {
    tag: "script",
    attrs: (t) => t.type == "text/babel" || t.type == "text/jsx",
    parser: E6.parser
  },
  {
    tag: "script",
    attrs: (t) => t.type == "text/typescript-jsx",
    parser: S6.parser
  },
  {
    tag: "script",
    attrs(t) {
      return /^(importmap|speculationrules|application\/(.+\+)?json)$/i.test(t.type);
    },
    parser: y$e
  },
  {
    tag: "script",
    attrs(t) {
      return !t.type || /^(?:text|application)\/(?:x-)?(?:java|ecma)script$|^module$|^$/i.test(t.type);
    },
    parser: Gf.parser
  },
  {
    tag: "style",
    attrs(t) {
      return (!t.lang || t.lang == "css") && (!t.type || /^(text\/)?(x-)?(stylesheet|css)$/i.test(t.type));
    },
    parser: t_.parser
  }
], Ise = /* @__PURE__ */ [
  {
    name: "style",
    parser: /* @__PURE__ */ t_.parser.configure({ top: "Styles" })
  }
].concat(/* @__PURE__ */ Tse.map((t) => ({ name: t, parser: Gf.parser }))), T6 = /* @__PURE__ */ VE.define({
  name: "html",
  parser: /* @__PURE__ */ iFe.configure({
    props: [
      /* @__PURE__ */ S_.add({
        Element(t) {
          let e = /^(\s*)(<\/)?/.exec(t.textAfter);
          return t.node.to <= t.pos + e[0].length ? t.continue() : t.lineIndent(t.node.from) + (e[2] ? 0 : t.unit);
        },
        "OpenTag CloseTag SelfClosingTag"(t) {
          return t.column(t.node.from) + t.unit;
        },
        Document(t) {
          if (t.pos + /\s*/.exec(t.textAfter)[0].length < t.node.to)
            return t.continue();
          let e = null, n;
          for (let r = t.node; ; ) {
            let a = r.lastChild;
            if (!a || a.name != "Element" || a.to != r.to)
              break;
            e = r = a;
          }
          return e && !((n = e.lastChild) && (n.name == "CloseTag" || n.name == "SelfClosingTag")) ? t.lineIndent(e.from) + t.unit : null;
        }
      }),
      /* @__PURE__ */ d1.add({
        Element(t) {
          let e = t.firstChild, n = t.lastChild;
          return !e || e.name != "OpenTag" ? null : { from: e.to, to: n.name == "CloseTag" ? n.from : t.to };
        }
      }),
      /* @__PURE__ */ soe.add({
        "OpenTag CloseTag": (t) => t.getChild("TagName")
      })
    ]
  }),
  languageData: {
    commentTokens: { block: { open: "<!--", close: "-->" } },
    indentOnInput: /^\s*<\/\w+\W$/,
    wordChars: "-._"
  }
}), dT = /* @__PURE__ */ T6.configure({
  wrap: /* @__PURE__ */ ase(Rse, Ise)
});
function Dse(t = {}) {
  let e = "", n;
  t.matchClosingTags === !1 && (e = "noMatch"), t.selfClosingTags === !0 && (e = (e ? e + " " : "") + "selfClosing"), (t.nestedLanguages && t.nestedLanguages.length || t.nestedAttributes && t.nestedAttributes.length) && (n = ase((t.nestedLanguages || []).concat(Rse), (t.nestedAttributes || []).concat(Ise)));
  let r = n ? T6.configure({ wrap: n, dialect: e }) : e ? dT.configure({ dialect: e }) : dT;
  return new ZE(r, [
    dT.data.of({ autocomplete: kse(t) }),
    t.autoCloseTags !== !1 ? Nse : [],
    Ese().support,
    fse().support
  ]);
}
const EK = /* @__PURE__ */ new Set(/* @__PURE__ */ "area base br col command embed frame hr img input keygen link meta param source track wbr menuitem".split(" ")), Nse = /* @__PURE__ */ qt.inputHandler.of((t, e, n, r, a) => {
  if (t.composing || t.state.readOnly || e != n || r != ">" && r != "/" || !dT.isActiveAt(t.state, e, -1))
    return !1;
  let i = a(), { state: o } = i, s = o.changeByRange((u) => {
    var f, p, m;
    let v = o.doc.sliceString(u.from - 1, u.to) == r, { head: O } = u, w = $a(o).resolveInner(O, -1), _;
    if (v && r == ">" && w.name == "EndTag") {
      let C = w.parent;
      if (((p = (f = C.parent) === null || f === void 0 ? void 0 : f.lastChild) === null || p === void 0 ? void 0 : p.name) != "CloseTag" && (_ = KE(o.doc, C.parent, O)) && !EK.has(_)) {
        let A = O + (o.doc.sliceString(O, O + 1) === ">" ? 1 : 0), N = `</${_}>`;
        return { range: u, changes: { from: O, to: A, insert: N } };
      }
    } else if (v && r == "/" && w.name == "IncompleteCloseTag") {
      let C = w.parent;
      if (w.from == O - 2 && ((m = C.lastChild) === null || m === void 0 ? void 0 : m.name) != "CloseTag" && (_ = KE(o.doc, C, O)) && !EK.has(_)) {
        let A = O + (o.doc.sliceString(O, O + 1) === ">" ? 1 : 0), N = `${_}>`;
        return {
          range: ft.cursor(O + N.length, -1),
          changes: { from: O, to: A, insert: N }
        };
      }
    }
    return { range: u };
  });
  return s.changes.empty ? !1 : (t.dispatch([
    i,
    o.update(s, {
      userEvent: "input.complete",
      scrollIntoView: !0
    })
  ]), !0);
}), O$e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  autoCloseTags: Nse,
  html: Dse,
  htmlCompletionSource: Ase,
  htmlCompletionSourceWith: kse,
  htmlLanguage: dT,
  htmlPlain: T6
}, Symbol.toStringTag, { value: "Module" })), Pse = /* @__PURE__ */ ED({ commentTokens: { block: { open: "<!--", close: "-->" } } }), Lse = /* @__PURE__ */ new nr(), Mse = /* @__PURE__ */ e3e.configure({
  props: [
    /* @__PURE__ */ d1.add((t) => !t.is("Block") || t.is("Document") || Y4(t) != null || E$e(t) ? void 0 : (e, n) => ({ from: n.doc.lineAt(e.from).to, to: e.to })),
    /* @__PURE__ */ Lse.add(Y4),
    /* @__PURE__ */ S_.add({
      Document: () => null
    }),
    /* @__PURE__ */ Gb.add({
      Document: Pse
    })
  ]
});
function Y4(t) {
  let e = /^(?:ATX|Setext)Heading(\d)$/.exec(t.name);
  return e ? +e[1] : void 0;
}
function E$e(t) {
  return t.name == "OrderedList" || t.name == "BulletList";
}
function S$e(t, e) {
  let n = t;
  for (; ; ) {
    let r = n.nextSibling, a;
    if (!r || (a = Y4(r.type)) != null && a <= e)
      break;
    n = r;
  }
  return n.to;
}
const w$e = /* @__PURE__ */ Zie.of((t, e, n) => {
  for (let r = $a(t).resolveInner(n, -1); r && !(r.from < e); r = r.parent) {
    let a = r.type.prop(Lse);
    if (a == null)
      continue;
    let i = S$e(r, a);
    if (i > n)
      return { from: n, to: i };
  }
  return null;
});
function _6(t) {
  return new Bc(Pse, t, [w$e], "markdown");
}
const Fse = /* @__PURE__ */ _6(Mse), T$e = /* @__PURE__ */ Mse.configure([f3e, p3e, d3e, h3e, {
  props: [
    /* @__PURE__ */ d1.add({
      Table: (t, e) => ({ from: e.doc.lineAt(t.from).to, to: t.to })
    })
  ]
}]), CD = /* @__PURE__ */ _6(T$e);
function _$e(t, e) {
  return (n) => {
    if (n && t) {
      let r = null;
      if (n = /\S*/.exec(n)[0], typeof t == "function" ? r = t(n) : r = at.matchLanguageName(t, n, !0), r instanceof at)
        return r.support ? r.support.language.parser : h0.getSkippingParser(r.load());
      if (r)
        return r.parser;
    }
    return e ? e.parser : null;
  };
}
class iA {
  constructor(e, n, r, a, i, o, s) {
    this.node = e, this.from = n, this.to = r, this.spaceBefore = a, this.spaceAfter = i, this.type = o, this.item = s;
  }
  blank(e, n = !0) {
    let r = this.spaceBefore + (this.node.name == "Blockquote" ? ">" : "");
    if (e != null) {
      for (; r.length < e; )
        r += " ";
      return r;
    } else {
      for (let a = this.to - this.from - r.length - this.spaceAfter.length; a > 0; a--)
        r += " ";
      return r + (n ? this.spaceAfter : "");
    }
  }
  marker(e, n) {
    let r = this.node.name == "OrderedList" ? String(+Bse(this.item, e)[2] + n) : "";
    return this.spaceBefore + r + this.type + this.spaceAfter;
  }
}
function $se(t, e) {
  let n = [];
  for (let a = t; a && a.name != "Document"; a = a.parent)
    (a.name == "ListItem" || a.name == "Blockquote" || a.name == "FencedCode") && n.push(a);
  let r = [];
  for (let a = n.length - 1; a >= 0; a--) {
    let i = n[a], o, s = e.lineAt(i.from), u = i.from - s.from;
    if (i.name == "FencedCode")
      r.push(new iA(i, u, u, "", "", "", null));
    else if (i.name == "Blockquote" && (o = /^ *>( ?)/.exec(s.text.slice(u))))
      r.push(new iA(i, u, u + o[0].length, "", o[1], ">", null));
    else if (i.name == "ListItem" && i.parent.name == "OrderedList" && (o = /^( *)\d+([.)])( *)/.exec(s.text.slice(u)))) {
      let f = o[3], p = o[0].length;
      f.length >= 4 && (f = f.slice(0, f.length - 4), p -= 4), r.push(new iA(i.parent, u, u + p, o[1], f, o[2], i));
    } else if (i.name == "ListItem" && i.parent.name == "BulletList" && (o = /^( *)([-+*])( {1,4}\[[ xX]\])?( +)/.exec(s.text.slice(u)))) {
      let f = o[4], p = o[0].length;
      f.length > 4 && (f = f.slice(0, f.length - 4), p -= 4);
      let m = o[2];
      o[3] && (m += o[3].replace(/[xX]/, " ")), r.push(new iA(i.parent, u, u + p, o[1], f, m, i));
    }
  }
  return r;
}
function Bse(t, e) {
  return /^(\s*)(\d+)(?=[.)])/.exec(e.sliceString(t.from, t.from + 10));
}
function N3(t, e, n, r = 0) {
  for (let a = -1, i = t; ; ) {
    if (i.name == "ListItem") {
      let s = Bse(i, e), u = +s[2];
      if (a >= 0) {
        if (u != a + 1)
          return;
        n.push({ from: i.from + s[1].length, to: i.from + s[0].length, insert: String(a + 2 + r) });
      }
      a = u;
    }
    let o = i.nextSibling;
    if (!o)
      break;
    i = o;
  }
}
function C6(t, e) {
  let n = /^[ \t]*/.exec(t)[0].length;
  if (!n || e.facet(f1) != "	")
    return t;
  let r = Xd(t, 4, n), a = "";
  for (let i = r; i > 0; )
    i >= 4 ? (a += "	", i -= 4) : (a += " ", i--);
  return a + t.slice(n);
}
const Use = ({ state: t, dispatch: e }) => {
  let n = $a(t), { doc: r } = t, a = null, i = t.changeByRange((o) => {
    if (!o.empty || !CD.isActiveAt(t, o.from))
      return a = { range: o };
    let s = o.from, u = r.lineAt(s), f = $se(n.resolveInner(s, -1), r);
    for (; f.length && f[f.length - 1].from > s - u.from; )
      f.pop();
    if (!f.length)
      return a = { range: o };
    let p = f[f.length - 1];
    if (p.to - p.spaceAfter.length > s - u.from)
      return a = { range: o };
    let m = s >= p.to - p.spaceAfter.length && !/\S/.test(u.text.slice(p.to));
    if (p.item && m) {
      let C = p.node.firstChild, A = p.node.getChild("ListItem", "ListItem");
      if (C.to >= s || A && A.to < s || u.from > 0 && !/[^\s>]/.test(r.lineAt(u.from - 1).text)) {
        let N = f.length > 1 ? f[f.length - 2] : null, P, I = "";
        N && N.item ? (P = u.from + N.from, I = N.marker(r, 1)) : P = u.from + (N ? N.to : 0);
        let D = [{ from: P, to: s, insert: I }];
        return p.node.name == "OrderedList" && N3(p.item, r, D, -2), N && N.node.name == "OrderedList" && N3(N.item, r, D), { range: ft.cursor(P + I.length), changes: D };
      } else {
        let N = wK(f, t, u);
        return {
          range: ft.cursor(s + N.length + 1),
          changes: { from: u.from, insert: N + t.lineBreak }
        };
      }
    }
    if (p.node.name == "Blockquote" && m && u.from) {
      let C = r.lineAt(u.from - 1), A = />\s*$/.exec(C.text);
      if (A && A.index == p.from) {
        let N = t.changes([
          { from: C.from + A.index, to: C.to },
          { from: u.from + p.from, to: u.to }
        ]);
        return { range: o.map(N), changes: N };
      }
    }
    let v = [];
    p.node.name == "OrderedList" && N3(p.item, r, v);
    let O = p.item && p.item.from < u.from, w = "";
    if (!O || /^[\s\d.)\-+*>]*/.exec(u.text)[0].length >= p.to)
      for (let C = 0, A = f.length - 1; C <= A; C++)
        w += C == A && !O ? f[C].marker(r, 1) : f[C].blank(C < A ? Xd(u.text, 4, f[C + 1].from) - w.length : null);
    let _ = s;
    for (; _ > u.from && /\s/.test(u.text.charAt(_ - u.from - 1)); )
      _--;
    return w = C6(w, t), C$e(p.node, t.doc) && (w = wK(f, t, u) + t.lineBreak + w), v.push({ from: _, to: s, insert: t.lineBreak + w }), { range: ft.cursor(_ + w.length + 1), changes: v };
  });
  return a ? !1 : (e(t.update(i, { scrollIntoView: !0, userEvent: "input" })), !0);
};
function SK(t) {
  return t.name == "QuoteMark" || t.name == "ListMark";
}
function C$e(t, e) {
  if (t.name != "OrderedList" && t.name != "BulletList")
    return !1;
  let n = t.firstChild, r = t.getChild("ListItem", "ListItem");
  if (!r)
    return !1;
  let a = e.lineAt(n.to), i = e.lineAt(r.from), o = /^[\s>]*$/.test(a.text);
  return a.number + (o ? 0 : 1) < i.number;
}
function wK(t, e, n) {
  let r = "";
  for (let a = 0, i = t.length - 2; a <= i; a++)
    r += t[a].blank(a < i ? Xd(n.text, 4, t[a + 1].from) - r.length : null, a < i);
  return C6(r, e);
}
function x$e(t, e) {
  let n = t.resolveInner(e, -1), r = e;
  SK(n) && (r = n.from, n = n.parent);
  for (let a; a = n.childBefore(r); )
    if (SK(a))
      r = a.from;
    else if (a.name == "OrderedList" || a.name == "BulletList")
      n = a.lastChild, r = n.to;
    else
      break;
  return n;
}
const zse = ({ state: t, dispatch: e }) => {
  let n = $a(t), r = null, a = t.changeByRange((i) => {
    let o = i.from, { doc: s } = t;
    if (i.empty && CD.isActiveAt(t, i.from)) {
      let u = s.lineAt(o), f = $se(x$e(n, o), s);
      if (f.length) {
        let p = f[f.length - 1], m = p.to - p.spaceAfter.length + (p.spaceAfter ? 1 : 0);
        if (o - u.from > m && !/\S/.test(u.text.slice(m, o - u.from)))
          return {
            range: ft.cursor(u.from + m),
            changes: { from: u.from + m, to: o }
          };
        if (o - u.from == m && // Only apply this if we're on the line that has the
        // construct's syntax, or there's only indentation in the
        // target range
        (!p.item || u.from <= p.item.from || !/\S/.test(u.text.slice(0, p.to)))) {
          let v = u.from + p.from;
          if (p.item && p.node.from < p.item.from && /\S/.test(u.text.slice(p.from, p.to))) {
            let O = p.blank(Xd(u.text, 4, p.to) - Xd(u.text, 4, p.from));
            return v == u.from && (O = C6(O, t)), {
              range: ft.cursor(v + O.length),
              changes: { from: v, to: u.from + p.to, insert: O }
            };
          }
          if (v < o)
            return { range: ft.cursor(v), changes: { from: v, to: o } };
        }
      }
    }
    return r = { range: i };
  });
  return r ? !1 : (e(t.update(a, { scrollIntoView: !0, userEvent: "delete" })), !0);
}, Hse = [
  { key: "Enter", run: Use },
  { key: "Backspace", run: zse }
], Z4 = /* @__PURE__ */ Dse({ matchClosingTags: !1 });
function Wse(t = {}) {
  let { codeLanguages: e, defaultCodeLanguage: n, addKeymap: r = !0, base: { parser: a } = Fse, completeHTMLTags: i = !0 } = t;
  if (!(a instanceof _D))
    throw new RangeError("Base parser provided to `markdown` should be a Markdown parser");
  let o = t.extensions ? [t.extensions] : [], s = [Z4.support], u;
  n instanceof ZE ? (s.push(n.support), u = n.language) : n && (u = n);
  let f = e || u ? _$e(e, u) : void 0;
  o.push(n3e({ codeParser: f, htmlParser: Z4.language.parser })), r && s.push(ig.high(l1.of(Hse)));
  let p = _6(a.configure(o));
  return i && s.push(p.data.of({ autocomplete: A$e })), new ZE(p, s);
}
function A$e(t) {
  let { state: e, pos: n } = t, r = /<[:\-\.\w\u00b7-\uffff]*$/.exec(e.sliceDoc(n - 25, n));
  if (!r)
    return null;
  let a = $a(e).resolveInner(n, -1);
  for (; a && !a.type.isTop; ) {
    if (a.name == "CodeBlock" || a.name == "FencedCode" || a.name == "ProcessingInstructionBlock" || a.name == "CommentBlock" || a.name == "Link" || a.name == "Image")
      return null;
    a = a.parent;
  }
  return {
    from: n - r[0].length,
    to: n,
    options: k$e(),
    validFor: /^<[:\-\.\w\u00b7-\uffff]*$/
  };
}
let P3 = null;
function k$e() {
  if (P3)
    return P3;
  let t = Ase(new o6(zr.create({ extensions: Z4 }), 0, !0));
  return P3 = t ? t.options : [];
}
const R$e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  commonmarkLanguage: Fse,
  deleteMarkupBackward: zse,
  insertNewlineContinueMarkup: Use,
  markdown: Wse,
  markdownKeymap: Hse,
  markdownLanguage: CD
}, Symbol.toStringTag, { value: "Module" }));
function Ct(t) {
  return new ZE(r6.define(t));
}
function Ib(t) {
  return import("./index-c5276150.mjs").then((e) => e.sql({ dialect: e[t] }));
}
const I$e = [
  // New-style language modes
  /* @__PURE__ */ at.of({
    name: "C",
    extensions: ["c", "h", "ino"],
    load() {
      return import("./index-e57a9b4e.mjs").then((t) => t.cpp());
    }
  }),
  /* @__PURE__ */ at.of({
    name: "C++",
    alias: ["cpp"],
    extensions: ["cpp", "c++", "cc", "cxx", "hpp", "h++", "hh", "hxx"],
    load() {
      return import("./index-e57a9b4e.mjs").then((t) => t.cpp());
    }
  }),
  /* @__PURE__ */ at.of({
    name: "CQL",
    alias: ["cassandra"],
    extensions: ["cql"],
    load() {
      return Ib("Cassandra");
    }
  }),
  /* @__PURE__ */ at.of({
    name: "CSS",
    extensions: ["css"],
    load() {
      return Promise.resolve().then(() => IFe).then((t) => t.css());
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Go",
    extensions: ["go"],
    load() {
      return import("./index-5bcfed8b.mjs").then((t) => t.go());
    }
  }),
  /* @__PURE__ */ at.of({
    name: "HTML",
    alias: ["xhtml"],
    extensions: ["html", "htm", "handlebars", "hbs"],
    load() {
      return Promise.resolve().then(() => O$e).then((t) => t.html());
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Java",
    extensions: ["java"],
    load() {
      return import("./index-21072a0a.mjs").then((t) => t.java());
    }
  }),
  /* @__PURE__ */ at.of({
    name: "JavaScript",
    alias: ["ecmascript", "js", "node"],
    extensions: ["js", "mjs", "cjs"],
    load() {
      return Promise.resolve().then(() => aA).then((t) => t.javascript());
    }
  }),
  /* @__PURE__ */ at.of({
    name: "JSON",
    alias: ["json5"],
    extensions: ["json", "map"],
    load() {
      return import("./index-29b5bded.mjs").then((t) => t.json());
    }
  }),
  /* @__PURE__ */ at.of({
    name: "JSX",
    extensions: ["jsx"],
    load() {
      return Promise.resolve().then(() => aA).then((t) => t.javascript({ jsx: !0 }));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "LESS",
    extensions: ["less"],
    load() {
      return import("./index-84e159b1.mjs").then((t) => t.less());
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Liquid",
    extensions: ["liquid"],
    load() {
      return import("./index-72f6f4f5.mjs").then((t) => t.liquid());
    }
  }),
  /* @__PURE__ */ at.of({
    name: "MariaDB SQL",
    load() {
      return Ib("MariaSQL");
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Markdown",
    extensions: ["md", "markdown", "mkd"],
    load() {
      return Promise.resolve().then(() => R$e).then((t) => t.markdown());
    }
  }),
  /* @__PURE__ */ at.of({
    name: "MS SQL",
    load() {
      return Ib("MSSQL");
    }
  }),
  /* @__PURE__ */ at.of({
    name: "MySQL",
    load() {
      return Ib("MySQL");
    }
  }),
  /* @__PURE__ */ at.of({
    name: "PHP",
    extensions: ["php", "php3", "php4", "php5", "php7", "phtml"],
    load() {
      return import("./index-e8f63991.mjs").then((t) => t.php());
    }
  }),
  /* @__PURE__ */ at.of({
    name: "PLSQL",
    extensions: ["pls"],
    load() {
      return Ib("PLSQL");
    }
  }),
  /* @__PURE__ */ at.of({
    name: "PostgreSQL",
    load() {
      return Ib("PostgreSQL");
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Python",
    extensions: ["BUILD", "bzl", "py", "pyw"],
    filename: /^(BUCK|BUILD)$/,
    load() {
      return import("./index-5b8d3c9a.mjs").then((t) => t.python());
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Rust",
    extensions: ["rs"],
    load() {
      return import("./index-ef5995bb.mjs").then((t) => t.rust());
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Sass",
    extensions: ["sass"],
    load() {
      return import("./index-7fc6a0b7.mjs").then((t) => t.sass({ indented: !0 }));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "SCSS",
    extensions: ["scss"],
    load() {
      return import("./index-7fc6a0b7.mjs").then((t) => t.sass());
    }
  }),
  /* @__PURE__ */ at.of({
    name: "SQL",
    extensions: ["sql"],
    load() {
      return Ib("StandardSQL");
    }
  }),
  /* @__PURE__ */ at.of({
    name: "SQLite",
    load() {
      return Ib("SQLite");
    }
  }),
  /* @__PURE__ */ at.of({
    name: "TSX",
    extensions: ["tsx"],
    load() {
      return Promise.resolve().then(() => aA).then((t) => t.javascript({ jsx: !0, typescript: !0 }));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "TypeScript",
    alias: ["ts"],
    extensions: ["ts", "mts", "cts"],
    load() {
      return Promise.resolve().then(() => aA).then((t) => t.javascript({ typescript: !0 }));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "WebAssembly",
    extensions: ["wat", "wast"],
    load() {
      return import("./index-a5a0cad8.mjs").then((t) => t.wast());
    }
  }),
  /* @__PURE__ */ at.of({
    name: "XML",
    alias: ["rss", "wsdl", "xsd"],
    extensions: ["xml", "xsl", "xsd", "svg"],
    load() {
      return import("./index-d241a7b0.mjs").then((t) => t.xml());
    }
  }),
  /* @__PURE__ */ at.of({
    name: "YAML",
    alias: ["yml"],
    extensions: ["yaml", "yml"],
    load() {
      return import("./index-e4bd32d9.mjs").then((t) => t.yaml());
    }
  }),
  // Legacy modes ported from CodeMirror 5
  /* @__PURE__ */ at.of({
    name: "APL",
    extensions: ["dyalog", "apl"],
    load() {
      return import("./apl-a780528f.mjs").then((t) => Ct(t.apl));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "PGP",
    alias: ["asciiarmor"],
    extensions: ["asc", "pgp", "sig"],
    load() {
      return import("./asciiarmor-18f349f9.mjs").then((t) => Ct(t.asciiArmor));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "ASN.1",
    extensions: ["asn", "asn1"],
    load() {
      return import("./asn1-65d0271f.mjs").then((t) => Ct(t.asn1({})));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Asterisk",
    filename: /^extensions\.conf$/i,
    load() {
      return import("./asterisk-e5025292.mjs").then((t) => Ct(t.asterisk));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Brainfuck",
    extensions: ["b", "bf"],
    load() {
      return import("./brainfuck-f1cdb019.mjs").then((t) => Ct(t.brainfuck));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Cobol",
    extensions: ["cob", "cpy"],
    load() {
      return import("./cobol-5b6fbaca.mjs").then((t) => Ct(t.cobol));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "C#",
    alias: ["csharp", "cs"],
    extensions: ["cs"],
    load() {
      return import("./clike-8ee4c30b.mjs").then((t) => Ct(t.csharp));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Clojure",
    extensions: ["clj", "cljc", "cljx"],
    load() {
      return import("./clojure-769fc78a.mjs").then((t) => Ct(t.clojure));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "ClojureScript",
    extensions: ["cljs"],
    load() {
      return import("./clojure-769fc78a.mjs").then((t) => Ct(t.clojure));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Closure Stylesheets (GSS)",
    extensions: ["gss"],
    load() {
      return import("./css-e7bb015c.mjs").then((t) => Ct(t.gss));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "CMake",
    extensions: ["cmake", "cmake.in"],
    filename: /^CMakeLists\.txt$/,
    load() {
      return import("./cmake-f52f23b8.mjs").then((t) => Ct(t.cmake));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "CoffeeScript",
    alias: ["coffee", "coffee-script"],
    extensions: ["coffee"],
    load() {
      return import("./coffeescript-725251ba.mjs").then((t) => Ct(t.coffeeScript));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Common Lisp",
    alias: ["lisp"],
    extensions: ["cl", "lisp", "el"],
    load() {
      return import("./commonlisp-785eb96c.mjs").then((t) => Ct(t.commonLisp));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Cypher",
    extensions: ["cyp", "cypher"],
    load() {
      return import("./cypher-607085b9.mjs").then((t) => Ct(t.cypher));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Cython",
    extensions: ["pyx", "pxd", "pxi"],
    load() {
      return import("./python-b789a754.mjs").then((t) => Ct(t.cython));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Crystal",
    extensions: ["cr"],
    load() {
      return import("./crystal-6ee61259.mjs").then((t) => Ct(t.crystal));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "D",
    extensions: ["d"],
    load() {
      return import("./d-d5c94470.mjs").then((t) => Ct(t.d));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Dart",
    extensions: ["dart"],
    load() {
      return import("./clike-8ee4c30b.mjs").then((t) => Ct(t.dart));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "diff",
    extensions: ["diff", "patch"],
    load() {
      return import("./diff-d541b54f.mjs").then((t) => Ct(t.diff));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Dockerfile",
    filename: /^Dockerfile$/,
    load() {
      return import("./dockerfile-c85a08c9.mjs").then((t) => Ct(t.dockerFile));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "DTD",
    extensions: ["dtd"],
    load() {
      return import("./dtd-62ee9356.mjs").then((t) => Ct(t.dtd));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Dylan",
    extensions: ["dylan", "dyl", "intr"],
    load() {
      return import("./dylan-e0001418.mjs").then((t) => Ct(t.dylan));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "EBNF",
    load() {
      return import("./ebnf-8dec0ed6.mjs").then((t) => Ct(t.ebnf));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "ECL",
    extensions: ["ecl"],
    load() {
      return import("./ecl-6ec41acc.mjs").then((t) => Ct(t.ecl));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "edn",
    extensions: ["edn"],
    load() {
      return import("./clojure-769fc78a.mjs").then((t) => Ct(t.clojure));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Eiffel",
    extensions: ["e"],
    load() {
      return import("./eiffel-4415bc0a.mjs").then((t) => Ct(t.eiffel));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Elm",
    extensions: ["elm"],
    load() {
      return import("./elm-00569ddc.mjs").then((t) => Ct(t.elm));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Erlang",
    extensions: ["erl"],
    load() {
      return import("./erlang-d3d22587.mjs").then((t) => Ct(t.erlang));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Esper",
    load() {
      return import("./sql-ef4d3ec0.mjs").then((t) => Ct(t.esper));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Factor",
    extensions: ["factor"],
    load() {
      return import("./factor-c373dc77.mjs").then((t) => Ct(t.factor));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "FCL",
    load() {
      return import("./fcl-68560482.mjs").then((t) => Ct(t.fcl));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Forth",
    extensions: ["forth", "fth", "4th"],
    load() {
      return import("./forth-871ea0f9.mjs").then((t) => Ct(t.forth));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Fortran",
    extensions: ["f", "for", "f77", "f90", "f95"],
    load() {
      return import("./fortran-6f03432b.mjs").then((t) => Ct(t.fortran));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "F#",
    alias: ["fsharp"],
    extensions: ["fs"],
    load() {
      return import("./mllike-e88b4217.mjs").then((t) => Ct(t.fSharp));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Gas",
    extensions: ["s"],
    load() {
      return import("./gas-1ad274cc.mjs").then((t) => Ct(t.gas));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Gherkin",
    extensions: ["feature"],
    load() {
      return import("./gherkin-bf14489a.mjs").then((t) => Ct(t.gherkin));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Groovy",
    extensions: ["groovy", "gradle"],
    filename: /^Jenkinsfile$/,
    load() {
      return import("./groovy-3d769a14.mjs").then((t) => Ct(t.groovy));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Haskell",
    extensions: ["hs"],
    load() {
      return import("./haskell-fc4d11ef.mjs").then((t) => Ct(t.haskell));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Haxe",
    extensions: ["hx"],
    load() {
      return import("./haxe-bc796a15.mjs").then((t) => Ct(t.haxe));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "HXML",
    extensions: ["hxml"],
    load() {
      return import("./haxe-bc796a15.mjs").then((t) => Ct(t.hxml));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "HTTP",
    load() {
      return import("./http-74fe0d95.mjs").then((t) => Ct(t.http));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "IDL",
    extensions: ["pro"],
    load() {
      return import("./idl-98114389.mjs").then((t) => Ct(t.idl));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "JSON-LD",
    alias: ["jsonld"],
    extensions: ["jsonld"],
    load() {
      return import("./javascript-95f8162e.mjs").then((t) => Ct(t.jsonld));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Jinja2",
    extensions: ["j2", "jinja", "jinja2"],
    load() {
      return import("./jinja2-65a75b3c.mjs").then((t) => Ct(t.jinja2));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Julia",
    extensions: ["jl"],
    load() {
      return import("./julia-f52f860d.mjs").then((t) => Ct(t.julia));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Kotlin",
    extensions: ["kt", "kts"],
    load() {
      return import("./clike-8ee4c30b.mjs").then((t) => Ct(t.kotlin));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "LiveScript",
    alias: ["ls"],
    extensions: ["ls"],
    load() {
      return import("./livescript-eeffe448.mjs").then((t) => Ct(t.liveScript));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Lua",
    extensions: ["lua"],
    load() {
      return import("./lua-c0714f11.mjs").then((t) => Ct(t.lua));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "mIRC",
    extensions: ["mrc"],
    load() {
      return import("./mirc-b61a3996.mjs").then((t) => Ct(t.mirc));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Mathematica",
    extensions: ["m", "nb", "wl", "wls"],
    load() {
      return import("./mathematica-8e570fb9.mjs").then((t) => Ct(t.mathematica));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Modelica",
    extensions: ["mo"],
    load() {
      return import("./modelica-55f725ae.mjs").then((t) => Ct(t.modelica));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "MUMPS",
    extensions: ["mps"],
    load() {
      return import("./mumps-1c492d9c.mjs").then((t) => Ct(t.mumps));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Mbox",
    extensions: ["mbox"],
    load() {
      return import("./mbox-41bcbc42.mjs").then((t) => Ct(t.mbox));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Nginx",
    filename: /nginx.*\.conf$/i,
    load() {
      return import("./nginx-e7540410.mjs").then((t) => Ct(t.nginx));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "NSIS",
    extensions: ["nsh", "nsi"],
    load() {
      return import("./nsis-5029ecdc.mjs").then((t) => Ct(t.nsis));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "NTriples",
    extensions: ["nt", "nq"],
    load() {
      return import("./ntriples-d2a2e1d3.mjs").then((t) => Ct(t.ntriples));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Objective-C",
    alias: ["objective-c", "objc"],
    extensions: ["m"],
    load() {
      return import("./clike-8ee4c30b.mjs").then((t) => Ct(t.objectiveC));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Objective-C++",
    alias: ["objective-c++", "objc++"],
    extensions: ["mm"],
    load() {
      return import("./clike-8ee4c30b.mjs").then((t) => Ct(t.objectiveCpp));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "OCaml",
    extensions: ["ml", "mli", "mll", "mly"],
    load() {
      return import("./mllike-e88b4217.mjs").then((t) => Ct(t.oCaml));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Octave",
    extensions: ["m"],
    load() {
      return import("./octave-bade68c3.mjs").then((t) => Ct(t.octave));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Oz",
    extensions: ["oz"],
    load() {
      return import("./oz-afc7eedb.mjs").then((t) => Ct(t.oz));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Pascal",
    extensions: ["p", "pas"],
    load() {
      return import("./pascal-0300f150.mjs").then((t) => Ct(t.pascal));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Perl",
    extensions: ["pl", "pm"],
    load() {
      return import("./perl-6ddddb58.mjs").then((t) => Ct(t.perl));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Pig",
    extensions: ["pig"],
    load() {
      return import("./pig-e5687f65.mjs").then((t) => Ct(t.pig));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "PowerShell",
    extensions: ["ps1", "psd1", "psm1"],
    load() {
      return import("./powershell-4c7ae0ce.mjs").then((t) => Ct(t.powerShell));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Properties files",
    alias: ["ini", "properties"],
    extensions: ["properties", "ini", "in"],
    load() {
      return import("./properties-6788b3b8.mjs").then((t) => Ct(t.properties));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "ProtoBuf",
    extensions: ["proto"],
    load() {
      return import("./protobuf-fedcbef9.mjs").then((t) => Ct(t.protobuf));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Pug",
    alias: ["jade"],
    extensions: ["pug", "jade"],
    load() {
      return import("./pug-5ff4ab8d.mjs").then((t) => Ct(t.pug));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Puppet",
    extensions: ["pp"],
    load() {
      return import("./puppet-605fda1c.mjs").then((t) => Ct(t.puppet));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Q",
    extensions: ["q"],
    load() {
      return import("./q-7aa6d582.mjs").then((t) => Ct(t.q));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "R",
    alias: ["rscript"],
    extensions: ["r", "R"],
    load() {
      return import("./r-1df568be.mjs").then((t) => Ct(t.r));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "RPM Changes",
    load() {
      return import("./rpm-6e3d5c1b.mjs").then((t) => Ct(t.rpmChanges));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "RPM Spec",
    extensions: ["spec"],
    load() {
      return import("./rpm-6e3d5c1b.mjs").then((t) => Ct(t.rpmSpec));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Ruby",
    alias: ["jruby", "macruby", "rake", "rb", "rbx"],
    extensions: ["rb"],
    filename: /^(Gemfile|Rakefile)$/,
    load() {
      return import("./ruby-c7f4923e.mjs").then((t) => Ct(t.ruby));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "SAS",
    extensions: ["sas"],
    load() {
      return import("./sas-17c7086f.mjs").then((t) => Ct(t.sas));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Scala",
    extensions: ["scala"],
    load() {
      return import("./clike-8ee4c30b.mjs").then((t) => Ct(t.scala));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Scheme",
    extensions: ["scm", "ss"],
    load() {
      return import("./scheme-fc595cf2.mjs").then((t) => Ct(t.scheme));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Shell",
    alias: ["bash", "sh", "zsh"],
    extensions: ["sh", "ksh", "bash"],
    filename: /^PKGBUILD$/,
    load() {
      return import("./shell-9b920301.mjs").then((t) => Ct(t.shell));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Sieve",
    extensions: ["siv", "sieve"],
    load() {
      return import("./sieve-c86ba6dc.mjs").then((t) => Ct(t.sieve));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Smalltalk",
    extensions: ["st"],
    load() {
      return import("./smalltalk-79e92d8c.mjs").then((t) => Ct(t.smalltalk));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Solr",
    load() {
      return import("./solr-2c4f5849.mjs").then((t) => Ct(t.solr));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "SML",
    extensions: ["sml", "sig", "fun", "smackspec"],
    load() {
      return import("./mllike-e88b4217.mjs").then((t) => Ct(t.sml));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "SPARQL",
    alias: ["sparul"],
    extensions: ["rq", "sparql"],
    load() {
      return import("./sparql-6b97103d.mjs").then((t) => Ct(t.sparql));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Spreadsheet",
    alias: ["excel", "formula"],
    load() {
      return import("./spreadsheet-873fe0b1.mjs").then((t) => Ct(t.spreadsheet));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Squirrel",
    extensions: ["nut"],
    load() {
      return import("./clike-8ee4c30b.mjs").then((t) => Ct(t.squirrel));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Stylus",
    extensions: ["styl"],
    load() {
      return import("./stylus-d9926379.mjs").then((t) => Ct(t.stylus));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Swift",
    extensions: ["swift"],
    load() {
      return import("./swift-9938ab95.mjs").then((t) => Ct(t.swift));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "sTeX",
    load() {
      return import("./stex-6916d1f8.mjs").then((t) => Ct(t.stex));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "LaTeX",
    alias: ["tex"],
    extensions: ["text", "ltx", "tex"],
    load() {
      return import("./stex-6916d1f8.mjs").then((t) => Ct(t.stex));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "SystemVerilog",
    extensions: ["v", "sv", "svh"],
    load() {
      return import("./verilog-79c60a12.mjs").then((t) => Ct(t.verilog));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Tcl",
    extensions: ["tcl"],
    load() {
      return import("./tcl-de02911d.mjs").then((t) => Ct(t.tcl));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Textile",
    extensions: ["textile"],
    load() {
      return import("./textile-1b51b4b1.mjs").then((t) => Ct(t.textile));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "TiddlyWiki",
    load() {
      return import("./tiddlywiki-03844604.mjs").then((t) => Ct(t.tiddlyWiki));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Tiki wiki",
    load() {
      return import("./tiki-d4db407b.mjs").then((t) => Ct(t.tiki));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "TOML",
    extensions: ["toml"],
    load() {
      return import("./toml-7c7c8348.mjs").then((t) => Ct(t.toml));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Troff",
    extensions: ["1", "2", "3", "4", "5", "6", "7", "8", "9"],
    load() {
      return import("./troff-b18aef3a.mjs").then((t) => Ct(t.troff));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "TTCN",
    extensions: ["ttcn", "ttcn3", "ttcnpp"],
    load() {
      return import("./ttcn-cd24cf75.mjs").then((t) => Ct(t.ttcn));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "TTCN_CFG",
    extensions: ["cfg"],
    load() {
      return import("./ttcn-cfg-d749c379.mjs").then((t) => Ct(t.ttcnCfg));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Turtle",
    extensions: ["ttl"],
    load() {
      return import("./turtle-0d123deb.mjs").then((t) => Ct(t.turtle));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Web IDL",
    extensions: ["webidl"],
    load() {
      return import("./webidl-ad11950c.mjs").then((t) => Ct(t.webIDL));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "VB.NET",
    extensions: ["vb"],
    load() {
      return import("./vb-a42d06b3.mjs").then((t) => Ct(t.vb));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "VBScript",
    extensions: ["vbs"],
    load() {
      return import("./vbscript-8ec812cc.mjs").then((t) => Ct(t.vbScript));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Velocity",
    extensions: ["vtl"],
    load() {
      return import("./velocity-18376aeb.mjs").then((t) => Ct(t.velocity));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Verilog",
    extensions: ["v"],
    load() {
      return import("./verilog-79c60a12.mjs").then((t) => Ct(t.verilog));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "VHDL",
    extensions: ["vhd", "vhdl"],
    load() {
      return import("./vhdl-c5117f8e.mjs").then((t) => Ct(t.vhdl));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "XQuery",
    extensions: ["xy", "xquery"],
    load() {
      return import("./xquery-f6f4869c.mjs").then((t) => Ct(t.xQuery));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Yacas",
    extensions: ["ys"],
    load() {
      return import("./yacas-397c6ff4.mjs").then((t) => Ct(t.yacas));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Z80",
    extensions: ["z80"],
    load() {
      return import("./z80-f77616b6.mjs").then((t) => Ct(t.z80));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "MscGen",
    extensions: ["mscgen", "mscin", "msc"],
    load() {
      return import("./mscgen-fbad4dd4.mjs").then((t) => Ct(t.mscgen));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Xù",
    extensions: ["xu"],
    load() {
      return import("./mscgen-fbad4dd4.mjs").then((t) => Ct(t.xu));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "MsGenny",
    extensions: ["msgenny"],
    load() {
      return import("./mscgen-fbad4dd4.mjs").then((t) => Ct(t.msgenny));
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Vue",
    extensions: ["vue"],
    load() {
      return import("./index-67af5fac.mjs").then((t) => t.vue());
    }
  }),
  /* @__PURE__ */ at.of({
    name: "Angular Template",
    load() {
      return import("./index-3f224943.mjs").then((t) => t.angular());
    }
  })
];
function D$e(t) {
  var {
    type: e = "scroll",
    events: n,
    props: r
  } = t;
  return Ki.fromClass(class {
    constructor(a) {
      if (this.dom = void 0, this.view = void 0, this.view = a, e === "dom" ? this.dom = a.dom : e === "content" ? this.dom = a.contentDOM : this.dom = a.scrollDOM, this.dom && r) {
        var i = Object.keys(r);
        i.forEach((o) => {
          this.dom[o] = r[o];
        });
      }
      Object.keys(n || {}).forEach((o) => {
        n && n[o] && this.dom && this.dom.addEventListener(o, n[o]);
      });
    }
    destroy() {
      Object.keys(n || {}).forEach((a) => {
        n && n[a] && this.dom && this.dom.removeEventListener(a, n[a]);
      });
    }
  });
}
function N$e(t) {
  return D$e({
    type: "scroll",
    events: t
  });
}
const P$e = (t) => {
  let { state: e } = t, n = e.doc.lineAt(e.selection.main.from), r = A6(t.state, n.from);
  return r.line ? L$e(t) : r.block ? F$e(t) : !1;
};
function x6(t, e) {
  return ({ state: n, dispatch: r }) => {
    if (n.readOnly)
      return !1;
    let a = t(e, n);
    return a ? (r(n.update(a)), !0) : !1;
  };
}
const L$e = /* @__PURE__ */ x6(
  U$e,
  0
  /* CommentOption.Toggle */
), M$e = /* @__PURE__ */ x6(
  Qse,
  0
  /* CommentOption.Toggle */
), F$e = /* @__PURE__ */ x6(
  (t, e) => Qse(t, e, B$e(e)),
  0
  /* CommentOption.Toggle */
);
function A6(t, e) {
  let n = t.languageDataAt("commentTokens", e);
  return n.length ? n[0] : {};
}
const Cw = 50;
function $$e(t, { open: e, close: n }, r, a) {
  let i = t.sliceDoc(r - Cw, r), o = t.sliceDoc(a, a + Cw), s = /\s*$/.exec(i)[0].length, u = /^\s*/.exec(o)[0].length, f = i.length - s;
  if (i.slice(f - e.length, f) == e && o.slice(u, u + n.length) == n)
    return {
      open: { pos: r - s, margin: s && 1 },
      close: { pos: a + u, margin: u && 1 }
    };
  let p, m;
  a - r <= 2 * Cw ? p = m = t.sliceDoc(r, a) : (p = t.sliceDoc(r, r + Cw), m = t.sliceDoc(a - Cw, a));
  let v = /^\s*/.exec(p)[0].length, O = /\s*$/.exec(m)[0].length, w = m.length - O - n.length;
  return p.slice(v, v + e.length) == e && m.slice(w, w + n.length) == n ? {
    open: {
      pos: r + v + e.length,
      margin: /\s/.test(p.charAt(v + e.length)) ? 1 : 0
    },
    close: {
      pos: a - O - n.length,
      margin: /\s/.test(m.charAt(w - 1)) ? 1 : 0
    }
  } : null;
}
function B$e(t) {
  let e = [];
  for (let n of t.selection.ranges) {
    let r = t.doc.lineAt(n.from), a = n.to <= r.to ? r : t.doc.lineAt(n.to), i = e.length - 1;
    i >= 0 && e[i].to > r.from ? e[i].to = a.to : e.push({ from: r.from + /^\s*/.exec(r.text)[0].length, to: a.to });
  }
  return e;
}
function Qse(t, e, n = e.selection.ranges) {
  let r = n.map((i) => A6(e, i.from).block);
  if (!r.every((i) => i))
    return null;
  let a = n.map((i, o) => $$e(e, r[o], i.from, i.to));
  if (t != 2 && !a.every((i) => i))
    return { changes: e.changes(n.map((i, o) => a[o] ? [] : [{ from: i.from, insert: r[o].open + " " }, { from: i.to, insert: " " + r[o].close }])) };
  if (t != 1 && a.some((i) => i)) {
    let i = [];
    for (let o = 0, s; o < a.length; o++)
      if (s = a[o]) {
        let u = r[o], { open: f, close: p } = s;
        i.push({ from: f.pos - u.open.length, to: f.pos + f.margin }, { from: p.pos - p.margin, to: p.pos + u.close.length });
      }
    return { changes: i };
  }
  return null;
}
function U$e(t, e, n = e.selection.ranges) {
  let r = [], a = -1;
  for (let { from: i, to: o } of n) {
    let s = r.length, u = 1e9, f = A6(e, i).line;
    if (f) {
      for (let p = i; p <= o; ) {
        let m = e.doc.lineAt(p);
        if (m.from > a && (i == o || o > m.from)) {
          a = m.from;
          let v = /^\s*/.exec(m.text)[0].length, O = v == m.length, w = m.text.slice(v, v + f.length) == f ? v : -1;
          v < m.text.length && v < u && (u = v), r.push({ line: m, comment: w, token: f, indent: v, empty: O, single: !1 });
        }
        p = m.to + 1;
      }
      if (u < 1e9)
        for (let p = s; p < r.length; p++)
          r[p].indent < r[p].line.text.length && (r[p].indent = u);
      r.length == s + 1 && (r[s].single = !0);
    }
  }
  if (t != 2 && r.some((i) => i.comment < 0 && (!i.empty || i.single))) {
    let i = [];
    for (let { line: s, token: u, indent: f, empty: p, single: m } of r)
      (m || !p) && i.push({ from: s.from + f, insert: u + " " });
    let o = e.changes(i);
    return { changes: o, selection: e.selection.map(o, 1) };
  } else if (t != 1 && r.some((i) => i.comment >= 0)) {
    let i = [];
    for (let { line: o, comment: s, token: u } of r)
      if (s >= 0) {
        let f = o.from + s, p = f + u.length;
        o.text[p - o.from] == " " && p++, i.push({ from: f, to: p });
      }
    return { changes: i };
  }
  return null;
}
const X4 = /* @__PURE__ */ Ih.define(), z$e = /* @__PURE__ */ Ih.define(), H$e = /* @__PURE__ */ bn.define(), jse = /* @__PURE__ */ bn.define({
  combine(t) {
    return Dh(t, {
      minDepth: 100,
      newGroupDelay: 500,
      joinToEvent: (e, n) => n
    }, {
      minDepth: Math.max,
      newGroupDelay: Math.min,
      joinToEvent: (e, n) => (r, a) => e(r, a) || n(r, a)
    });
  }
}), Gse = /* @__PURE__ */ Ss.define({
  create() {
    return wh.empty;
  },
  update(t, e) {
    let n = e.state.facet(jse), r = e.annotation(X4);
    if (r) {
      let u = Ju.fromTransaction(e, r.selection), f = r.side, p = f == 0 ? t.undone : t.done;
      return u ? p = wI(p, p.length, n.minDepth, u) : p = Yse(p, e.startState.selection), new wh(f == 0 ? r.rest : p, f == 0 ? p : r.rest);
    }
    let a = e.annotation(z$e);
    if ((a == "full" || a == "before") && (t = t.isolate()), e.annotation(No.addToHistory) === !1)
      return e.changes.empty ? t : t.addMapping(e.changes.desc);
    let i = Ju.fromTransaction(e), o = e.annotation(No.time), s = e.annotation(No.userEvent);
    return i ? t = t.addChanges(i, o, s, n, e) : e.selection && (t = t.addSelection(e.startState.selection, o, s, n.newGroupDelay)), (a == "full" || a == "after") && (t = t.isolate()), t;
  },
  toJSON(t) {
    return { done: t.done.map((e) => e.toJSON()), undone: t.undone.map((e) => e.toJSON()) };
  },
  fromJSON(t) {
    return new wh(t.done.map(Ju.fromJSON), t.undone.map(Ju.fromJSON));
  }
});
function W$e(t = {}) {
  return [
    Gse,
    jse.of(t),
    qt.domEventHandlers({
      beforeinput(e, n) {
        let r = e.inputType == "historyUndo" ? k6 : e.inputType == "historyRedo" ? SI : null;
        return r ? (e.preventDefault(), r(n)) : !1;
      }
    })
  ];
}
function xD(t, e) {
  return function({ state: n, dispatch: r }) {
    if (!e && n.readOnly)
      return !1;
    let a = n.field(Gse, !1);
    if (!a)
      return !1;
    let i = a.pop(t, n, e);
    return i ? (r(i), !0) : !1;
  };
}
const k6 = /* @__PURE__ */ xD(0, !1), SI = /* @__PURE__ */ xD(1, !1), Q$e = /* @__PURE__ */ xD(0, !0), j$e = /* @__PURE__ */ xD(1, !0);
class Ju {
  constructor(e, n, r, a, i) {
    this.changes = e, this.effects = n, this.mapped = r, this.startSelection = a, this.selectionsAfter = i;
  }
  setSelAfter(e) {
    return new Ju(this.changes, this.effects, this.mapped, this.startSelection, e);
  }
  toJSON() {
    var e, n, r;
    return {
      changes: (e = this.changes) === null || e === void 0 ? void 0 : e.toJSON(),
      mapped: (n = this.mapped) === null || n === void 0 ? void 0 : n.toJSON(),
      startSelection: (r = this.startSelection) === null || r === void 0 ? void 0 : r.toJSON(),
      selectionsAfter: this.selectionsAfter.map((a) => a.toJSON())
    };
  }
  static fromJSON(e) {
    return new Ju(e.changes && Ko.fromJSON(e.changes), [], e.mapped && Ch.fromJSON(e.mapped), e.startSelection && ft.fromJSON(e.startSelection), e.selectionsAfter.map(ft.fromJSON));
  }
  // This does not check `addToHistory` and such, it assumes the
  // transaction needs to be converted to an item. Returns null when
  // there are no changes or effects in the transaction.
  static fromTransaction(e, n) {
    let r = Hf;
    for (let a of e.startState.facet(H$e)) {
      let i = a(e);
      i.length && (r = r.concat(i));
    }
    return !r.length && e.changes.empty ? null : new Ju(e.changes.invert(e.startState.doc), r, void 0, n || e.startState.selection, Hf);
  }
  static selection(e) {
    return new Ju(void 0, Hf, void 0, void 0, e);
  }
}
function wI(t, e, n, r) {
  let a = e + 1 > n + 20 ? e - n - 1 : 0, i = t.slice(a, e);
  return i.push(r), i;
}
function G$e(t, e) {
  let n = [], r = !1;
  return t.iterChangedRanges((a, i) => n.push(a, i)), e.iterChangedRanges((a, i, o, s) => {
    for (let u = 0; u < n.length; ) {
      let f = n[u++], p = n[u++];
      s >= f && o <= p && (r = !0);
    }
  }), r;
}
function V$e(t, e) {
  return t.ranges.length == e.ranges.length && t.ranges.filter((n, r) => n.empty != e.ranges[r].empty).length === 0;
}
function Vse(t, e) {
  return t.length ? e.length ? t.concat(e) : t : e;
}
const Hf = [], Y$e = 200;
function Yse(t, e) {
  if (t.length) {
    let n = t[t.length - 1], r = n.selectionsAfter.slice(Math.max(0, n.selectionsAfter.length - Y$e));
    return r.length && r[r.length - 1].eq(e) ? t : (r.push(e), wI(t, t.length - 1, 1e9, n.setSelAfter(r)));
  } else
    return [Ju.selection([e])];
}
function Z$e(t) {
  let e = t[t.length - 1], n = t.slice();
  return n[t.length - 1] = e.setSelAfter(e.selectionsAfter.slice(0, e.selectionsAfter.length - 1)), n;
}
function L3(t, e) {
  if (!t.length)
    return t;
  let n = t.length, r = Hf;
  for (; n; ) {
    let a = X$e(t[n - 1], e, r);
    if (a.changes && !a.changes.empty || a.effects.length) {
      let i = t.slice(0, n);
      return i[n - 1] = a, i;
    } else
      e = a.mapped, n--, r = a.selectionsAfter;
  }
  return r.length ? [Ju.selection(r)] : Hf;
}
function X$e(t, e, n) {
  let r = Vse(t.selectionsAfter.length ? t.selectionsAfter.map((s) => s.map(e)) : Hf, n);
  if (!t.changes)
    return Ju.selection(r);
  let a = t.changes.map(e), i = e.mapDesc(t.changes, !0), o = t.mapped ? t.mapped.composeDesc(i) : i;
  return new Ju(a, fr.mapEffects(t.effects, e), o, t.startSelection.map(i), r);
}
const q$e = /^(input\.type|delete)($|\.)/;
class wh {
  constructor(e, n, r = 0, a = void 0) {
    this.done = e, this.undone = n, this.prevTime = r, this.prevUserEvent = a;
  }
  isolate() {
    return this.prevTime ? new wh(this.done, this.undone) : this;
  }
  addChanges(e, n, r, a, i) {
    let o = this.done, s = o[o.length - 1];
    return s && s.changes && !s.changes.empty && e.changes && (!r || q$e.test(r)) && (!s.selectionsAfter.length && n - this.prevTime < a.newGroupDelay && a.joinToEvent(i, G$e(s.changes, e.changes)) || // For compose (but not compose.start) events, always join with previous event
    r == "input.type.compose") ? o = wI(o, o.length - 1, a.minDepth, new Ju(e.changes.compose(s.changes), Vse(e.effects, s.effects), s.mapped, s.startSelection, Hf)) : o = wI(o, o.length, a.minDepth, e), new wh(o, Hf, n, r);
  }
  addSelection(e, n, r, a) {
    let i = this.done.length ? this.done[this.done.length - 1].selectionsAfter : Hf;
    return i.length > 0 && n - this.prevTime < a && r == this.prevUserEvent && r && /^select($|\.)/.test(r) && V$e(i[i.length - 1], e) ? this : new wh(Yse(this.done, e), this.undone, n, r);
  }
  addMapping(e) {
    return new wh(L3(this.done, e), L3(this.undone, e), this.prevTime, this.prevUserEvent);
  }
  pop(e, n, r) {
    let a = e == 0 ? this.done : this.undone;
    if (a.length == 0)
      return null;
    let i = a[a.length - 1], o = i.selectionsAfter[0] || n.selection;
    if (r && i.selectionsAfter.length)
      return n.update({
        selection: i.selectionsAfter[i.selectionsAfter.length - 1],
        annotations: X4.of({ side: e, rest: Z$e(a), selection: o }),
        userEvent: e == 0 ? "select.undo" : "select.redo",
        scrollIntoView: !0
      });
    if (i.changes) {
      let s = a.length == 1 ? Hf : a.slice(0, a.length - 1);
      return i.mapped && (s = L3(s, i.mapped)), n.update({
        changes: i.changes,
        selection: i.startSelection,
        effects: i.effects,
        annotations: X4.of({ side: e, rest: s, selection: o }),
        filter: !1,
        userEvent: e == 0 ? "undo" : "redo",
        scrollIntoView: !0
      });
    } else
      return null;
  }
}
wh.empty = /* @__PURE__ */ new wh(Hf, Hf);
const K$e = [
  { key: "Mod-z", run: k6, preventDefault: !0 },
  { key: "Mod-y", mac: "Mod-Shift-z", run: SI, preventDefault: !0 },
  { linux: "Ctrl-Shift-z", run: SI, preventDefault: !0 },
  { key: "Mod-u", run: Q$e, preventDefault: !0 },
  { key: "Alt-u", mac: "Mod-Shift-u", run: j$e, preventDefault: !0 }
];
function m1(t, e) {
  return ft.create(t.ranges.map(e), t.mainIndex);
}
function Ph(t, e) {
  return t.update({ selection: e, scrollIntoView: !0, userEvent: "select" });
}
function ep({ state: t, dispatch: e }, n) {
  let r = m1(t.selection, n);
  return r.eq(t.selection, !0) ? !1 : (e(Ph(t, r)), !0);
}
function AD(t, e) {
  return ft.cursor(e ? t.to : t.from);
}
function Zse(t, e) {
  return ep(t, (n) => n.empty ? t.moveByChar(n, e) : AD(n, e));
}
function Ll(t) {
  return t.textDirectionAt(t.state.selection.main.head) == hi.LTR;
}
const Xse = (t) => Zse(t, !Ll(t)), qse = (t) => Zse(t, Ll(t));
function Kse(t, e) {
  return ep(t, (n) => n.empty ? t.moveByGroup(n, e) : AD(n, e));
}
const J$e = (t) => Kse(t, !Ll(t)), eBe = (t) => Kse(t, Ll(t));
function tBe(t, e, n) {
  if (e.type.prop(n))
    return !0;
  let r = e.to - e.from;
  return r && (r > 2 || /[^\s,.;:]/.test(t.sliceDoc(e.from, e.to))) || e.firstChild;
}
function kD(t, e, n) {
  let r = $a(t).resolveInner(e.head), a = n ? nr.closedBy : nr.openedBy;
  for (let u = e.head; ; ) {
    let f = n ? r.childAfter(u) : r.childBefore(u);
    if (!f)
      break;
    tBe(t, f, a) ? r = f : u = n ? f.to : f.from;
  }
  let i = r.type.prop(a), o, s;
  return i && (o = n ? Sh(t, r.from, 1) : Sh(t, r.to, -1)) && o.matched ? s = n ? o.end.to : o.end.from : s = n ? r.to : r.from, ft.cursor(s, n ? -1 : 1);
}
const nBe = (t) => ep(t, (e) => kD(t.state, e, !Ll(t))), rBe = (t) => ep(t, (e) => kD(t.state, e, Ll(t)));
function Jse(t, e) {
  return ep(t, (n) => {
    if (!n.empty)
      return AD(n, e);
    let r = t.moveVertically(n, e);
    return r.head != n.head ? r : t.moveToLineBoundary(n, e);
  });
}
const ele = (t) => Jse(t, !1), tle = (t) => Jse(t, !0);
function nle(t) {
  let e = t.scrollDOM.clientHeight < t.scrollDOM.scrollHeight - 2, n = 0, r = 0, a;
  if (e) {
    for (let i of t.state.facet(qt.scrollMargins)) {
      let o = i(t);
      o != null && o.top && (n = Math.max(o == null ? void 0 : o.top, n)), o != null && o.bottom && (r = Math.max(o == null ? void 0 : o.bottom, r));
    }
    a = t.scrollDOM.clientHeight - n - r;
  } else
    a = (t.dom.ownerDocument.defaultView || window).innerHeight;
  return {
    marginTop: n,
    marginBottom: r,
    selfScroll: e,
    height: Math.max(t.defaultLineHeight, a - 5)
  };
}
function rle(t, e) {
  let n = nle(t), { state: r } = t, a = m1(r.selection, (o) => o.empty ? t.moveVertically(o, e, n.height) : AD(o, e));
  if (a.eq(r.selection))
    return !1;
  let i;
  if (n.selfScroll) {
    let o = t.coordsAtPos(r.selection.main.head), s = t.scrollDOM.getBoundingClientRect(), u = s.top + n.marginTop, f = s.bottom - n.marginBottom;
    o && o.top > u && o.bottom < f && (i = qt.scrollIntoView(a.main.head, { y: "start", yMargin: o.top - u }));
  }
  return t.dispatch(Ph(r, a), { effects: i }), !0;
}
const TK = (t) => rle(t, !1), q4 = (t) => rle(t, !0);
function dv(t, e, n) {
  let r = t.lineBlockAt(e.head), a = t.moveToLineBoundary(e, n);
  if (a.head == e.head && a.head != (n ? r.to : r.from) && (a = t.moveToLineBoundary(e, n, !1)), !n && a.head == r.from && r.length) {
    let i = /^\s*/.exec(t.state.sliceDoc(r.from, Math.min(r.from + 100, r.to)))[0].length;
    i && e.head != r.from + i && (a = ft.cursor(r.from + i));
  }
  return a;
}
const aBe = (t) => ep(t, (e) => dv(t, e, !0)), iBe = (t) => ep(t, (e) => dv(t, e, !1)), oBe = (t) => ep(t, (e) => dv(t, e, !Ll(t))), sBe = (t) => ep(t, (e) => dv(t, e, Ll(t))), lBe = (t) => ep(t, (e) => ft.cursor(t.lineBlockAt(e.head).from, 1)), uBe = (t) => ep(t, (e) => ft.cursor(t.lineBlockAt(e.head).to, -1));
function cBe(t, e, n) {
  let r = !1, a = m1(t.selection, (i) => {
    let o = Sh(t, i.head, -1) || Sh(t, i.head, 1) || i.head > 0 && Sh(t, i.head - 1, 1) || i.head < t.doc.length && Sh(t, i.head + 1, -1);
    if (!o || !o.end)
      return i;
    r = !0;
    let s = o.start.from == i.head ? o.end.to : o.end.from;
    return n ? ft.range(i.anchor, s) : ft.cursor(s);
  });
  return r ? (e(Ph(t, a)), !0) : !1;
}
const fBe = ({ state: t, dispatch: e }) => cBe(t, e, !1);
function ed(t, e) {
  let n = m1(t.state.selection, (r) => {
    let a = e(r);
    return ft.range(r.anchor, a.head, a.goalColumn, a.bidiLevel || void 0);
  });
  return n.eq(t.state.selection) ? !1 : (t.dispatch(Ph(t.state, n)), !0);
}
function ale(t, e) {
  return ed(t, (n) => t.moveByChar(n, e));
}
const ile = (t) => ale(t, !Ll(t)), ole = (t) => ale(t, Ll(t));
function sle(t, e) {
  return ed(t, (n) => t.moveByGroup(n, e));
}
const dBe = (t) => sle(t, !Ll(t)), pBe = (t) => sle(t, Ll(t)), hBe = (t) => ed(t, (e) => kD(t.state, e, !Ll(t))), mBe = (t) => ed(t, (e) => kD(t.state, e, Ll(t)));
function lle(t, e) {
  return ed(t, (n) => t.moveVertically(n, e));
}
const ule = (t) => lle(t, !1), cle = (t) => lle(t, !0);
function fle(t, e) {
  return ed(t, (n) => t.moveVertically(n, e, nle(t).height));
}
const _K = (t) => fle(t, !1), CK = (t) => fle(t, !0), gBe = (t) => ed(t, (e) => dv(t, e, !0)), bBe = (t) => ed(t, (e) => dv(t, e, !1)), vBe = (t) => ed(t, (e) => dv(t, e, !Ll(t))), yBe = (t) => ed(t, (e) => dv(t, e, Ll(t))), OBe = (t) => ed(t, (e) => ft.cursor(t.lineBlockAt(e.head).from)), EBe = (t) => ed(t, (e) => ft.cursor(t.lineBlockAt(e.head).to)), xK = ({ state: t, dispatch: e }) => (e(Ph(t, { anchor: 0 })), !0), AK = ({ state: t, dispatch: e }) => (e(Ph(t, { anchor: t.doc.length })), !0), kK = ({ state: t, dispatch: e }) => (e(Ph(t, { anchor: t.selection.main.anchor, head: 0 })), !0), RK = ({ state: t, dispatch: e }) => (e(Ph(t, { anchor: t.selection.main.anchor, head: t.doc.length })), !0), SBe = ({ state: t, dispatch: e }) => (e(t.update({ selection: { anchor: 0, head: t.doc.length }, userEvent: "select" })), !0), wBe = ({ state: t, dispatch: e }) => {
  let n = RD(t).map(({ from: r, to: a }) => ft.range(r, Math.min(a + 1, t.doc.length)));
  return e(t.update({ selection: ft.create(n), userEvent: "select" })), !0;
}, TBe = ({ state: t, dispatch: e }) => {
  let n = m1(t.selection, (r) => {
    var a;
    let i = $a(t).resolveStack(r.from, 1);
    for (let o = i; o; o = o.next) {
      let { node: s } = o;
      if ((s.from < r.from && s.to >= r.to || s.to > r.to && s.from <= r.from) && (!((a = s.parent) === null || a === void 0) && a.parent))
        return ft.range(s.to, s.from);
    }
    return r;
  });
  return e(Ph(t, n)), !0;
}, _Be = ({ state: t, dispatch: e }) => {
  let n = t.selection, r = null;
  return n.ranges.length > 1 ? r = ft.create([n.main]) : n.main.empty || (r = ft.create([ft.cursor(n.main.head)])), r ? (e(Ph(t, r)), !0) : !1;
};
function __(t, e) {
  if (t.state.readOnly)
    return !1;
  let n = "delete.selection", { state: r } = t, a = r.changeByRange((i) => {
    let { from: o, to: s } = i;
    if (o == s) {
      let u = e(i);
      u < o ? (n = "delete.backward", u = oA(t, u, !1)) : u > o && (n = "delete.forward", u = oA(t, u, !0)), o = Math.min(o, u), s = Math.max(s, u);
    } else
      o = oA(t, o, !1), s = oA(t, s, !0);
    return o == s ? { range: i } : { changes: { from: o, to: s }, range: ft.cursor(o, o < i.head ? -1 : 1) };
  });
  return a.changes.empty ? !1 : (t.dispatch(r.update(a, {
    scrollIntoView: !0,
    userEvent: n,
    effects: n == "delete.selection" ? qt.announce.of(r.phrase("Selection deleted")) : void 0
  })), !0);
}
function oA(t, e, n) {
  if (t instanceof qt)
    for (let r of t.state.facet(qt.atomicRanges).map((a) => a(t)))
      r.between(e, e, (a, i) => {
        a < e && i > e && (e = n ? i : a);
      });
  return e;
}
const dle = (t, e, n) => __(t, (r) => {
  let a = r.from, { state: i } = t, o = i.doc.lineAt(a), s, u;
  if (n && !e && a > o.from && a < o.from + 200 && !/[^ \t]/.test(s = o.text.slice(0, a - o.from))) {
    if (s[s.length - 1] == "	")
      return a - 1;
    let f = Xd(s, i.tabSize), p = f % m0(i) || m0(i);
    for (let m = 0; m < p && s[s.length - 1 - m] == " "; m++)
      a--;
    u = a;
  } else
    u = nl(o.text, a - o.from, e, e) + o.from, u == a && o.number != (e ? i.doc.lines : 1) ? u += e ? 1 : -1 : !e && /[\ufe00-\ufe0f]/.test(o.text.slice(u - o.from, a - o.from)) && (u = nl(o.text, u - o.from, !1, !1) + o.from);
  return u;
}), K4 = (t) => dle(t, !1, !0), ple = (t) => dle(t, !0, !1), hle = (t, e) => __(t, (n) => {
  let r = n.head, { state: a } = t, i = a.doc.lineAt(r), o = a.charCategorizer(r);
  for (let s = null; ; ) {
    if (r == (e ? i.to : i.from)) {
      r == n.head && i.number != (e ? a.doc.lines : 1) && (r += e ? 1 : -1);
      break;
    }
    let u = nl(i.text, r - i.from, e) + i.from, f = i.text.slice(Math.min(r, u) - i.from, Math.max(r, u) - i.from), p = o(f);
    if (s != null && p != s)
      break;
    (f != " " || r != n.head) && (s = p), r = u;
  }
  return r;
}), mle = (t) => hle(t, !1), CBe = (t) => hle(t, !0), xBe = (t) => __(t, (e) => {
  let n = t.lineBlockAt(e.head).to;
  return e.head < n ? n : Math.min(t.state.doc.length, e.head + 1);
}), ABe = (t) => __(t, (e) => {
  let n = t.moveToLineBoundary(e, !1).head;
  return e.head > n ? n : Math.max(0, e.head - 1);
}), kBe = (t) => __(t, (e) => {
  let n = t.moveToLineBoundary(e, !0).head;
  return e.head < n ? n : Math.min(t.state.doc.length, e.head + 1);
}), RBe = ({ state: t, dispatch: e }) => {
  if (t.readOnly)
    return !1;
  let n = t.changeByRange((r) => ({
    changes: { from: r.from, to: r.to, insert: la.of(["", ""]) },
    range: ft.cursor(r.from)
  }));
  return e(t.update(n, { scrollIntoView: !0, userEvent: "input" })), !0;
}, IBe = ({ state: t, dispatch: e }) => {
  if (t.readOnly)
    return !1;
  let n = t.changeByRange((r) => {
    if (!r.empty || r.from == 0 || r.from == t.doc.length)
      return { range: r };
    let a = r.from, i = t.doc.lineAt(a), o = a == i.from ? a - 1 : nl(i.text, a - i.from, !1) + i.from, s = a == i.to ? a + 1 : nl(i.text, a - i.from, !0) + i.from;
    return {
      changes: { from: o, to: s, insert: t.doc.slice(a, s).append(t.doc.slice(o, a)) },
      range: ft.cursor(s)
    };
  });
  return n.changes.empty ? !1 : (e(t.update(n, { scrollIntoView: !0, userEvent: "move.character" })), !0);
};
function RD(t) {
  let e = [], n = -1;
  for (let r of t.selection.ranges) {
    let a = t.doc.lineAt(r.from), i = t.doc.lineAt(r.to);
    if (!r.empty && r.to == i.from && (i = t.doc.lineAt(r.to - 1)), n >= a.number) {
      let o = e[e.length - 1];
      o.to = i.to, o.ranges.push(r);
    } else
      e.push({ from: a.from, to: i.to, ranges: [r] });
    n = i.number + 1;
  }
  return e;
}
function gle(t, e, n) {
  if (t.readOnly)
    return !1;
  let r = [], a = [];
  for (let i of RD(t)) {
    if (n ? i.to == t.doc.length : i.from == 0)
      continue;
    let o = t.doc.lineAt(n ? i.to + 1 : i.from - 1), s = o.length + 1;
    if (n) {
      r.push({ from: i.to, to: o.to }, { from: i.from, insert: o.text + t.lineBreak });
      for (let u of i.ranges)
        a.push(ft.range(Math.min(t.doc.length, u.anchor + s), Math.min(t.doc.length, u.head + s)));
    } else {
      r.push({ from: o.from, to: i.from }, { from: i.to, insert: t.lineBreak + o.text });
      for (let u of i.ranges)
        a.push(ft.range(u.anchor - s, u.head - s));
    }
  }
  return r.length ? (e(t.update({
    changes: r,
    scrollIntoView: !0,
    selection: ft.create(a, t.selection.mainIndex),
    userEvent: "move.line"
  })), !0) : !1;
}
const DBe = ({ state: t, dispatch: e }) => gle(t, e, !1), NBe = ({ state: t, dispatch: e }) => gle(t, e, !0);
function ble(t, e, n) {
  if (t.readOnly)
    return !1;
  let r = [];
  for (let a of RD(t))
    n ? r.push({ from: a.from, insert: t.doc.slice(a.from, a.to) + t.lineBreak }) : r.push({ from: a.to, insert: t.lineBreak + t.doc.slice(a.from, a.to) });
  return e(t.update({ changes: r, scrollIntoView: !0, userEvent: "input.copyline" })), !0;
}
const PBe = ({ state: t, dispatch: e }) => ble(t, e, !1), LBe = ({ state: t, dispatch: e }) => ble(t, e, !0), MBe = (t) => {
  if (t.state.readOnly)
    return !1;
  let { state: e } = t, n = e.changes(RD(e).map(({ from: a, to: i }) => (a > 0 ? a-- : i < e.doc.length && i++, { from: a, to: i }))), r = m1(e.selection, (a) => {
    let i;
    if (t.lineWrapping) {
      let o = t.lineBlockAt(a.head), s = t.coordsAtPos(a.head, a.assoc || 1);
      s && (i = o.bottom + t.documentTop - s.bottom + t.defaultLineHeight / 2);
    }
    return t.moveVertically(a, !0, i);
  }).map(n);
  return t.dispatch({ changes: n, selection: r, scrollIntoView: !0, userEvent: "delete.line" }), !0;
};
function FBe(t, e) {
  if (/\(\)|\[\]|\{\}/.test(t.sliceDoc(e - 1, e + 1)))
    return { from: e, to: e };
  let n = $a(t).resolveInner(e), r = n.childBefore(e), a = n.childAfter(e), i;
  return r && a && r.to <= e && a.from >= e && (i = r.type.prop(nr.closedBy)) && i.indexOf(a.name) > -1 && t.doc.lineAt(r.to).from == t.doc.lineAt(a.from).from && !/\S/.test(t.sliceDoc(r.to, a.from)) ? { from: r.to, to: a.from } : null;
}
const $Be = /* @__PURE__ */ vle(!1), BBe = /* @__PURE__ */ vle(!0);
function vle(t) {
  return ({ state: e, dispatch: n }) => {
    if (e.readOnly)
      return !1;
    let r = e.changeByRange((a) => {
      let { from: i, to: o } = a, s = e.doc.lineAt(i), u = !t && i == o && FBe(e, i);
      t && (i = o = (o <= s.to ? s : e.doc.lineAt(o)).to);
      let f = new SD(e, { simulateBreak: i, simulateDoubleBreak: !!u }), p = JU(f, i);
      for (p == null && (p = Xd(/^\s*/.exec(e.doc.lineAt(i).text)[0], e.tabSize)); o < s.to && /\s/.test(s.text[o - s.from]); )
        o++;
      u ? { from: i, to: o } = u : i > s.from && i < s.from + 100 && !/\S/.test(s.text.slice(0, i)) && (i = s.from);
      let m = ["", VT(e, p)];
      return u && m.push(VT(e, f.lineIndent(s.from, -1))), {
        changes: { from: i, to: o, insert: la.of(m) },
        range: ft.cursor(i + 1 + m[1].length)
      };
    });
    return n(e.update(r, { scrollIntoView: !0, userEvent: "input" })), !0;
  };
}
function R6(t, e) {
  let n = -1;
  return t.changeByRange((r) => {
    let a = [];
    for (let o = r.from; o <= r.to; ) {
      let s = t.doc.lineAt(o);
      s.number > n && (r.empty || r.to > s.from) && (e(s, a, r), n = s.number), o = s.to + 1;
    }
    let i = t.changes(a);
    return {
      changes: a,
      range: ft.range(i.mapPos(r.anchor, 1), i.mapPos(r.head, 1))
    };
  });
}
const UBe = ({ state: t, dispatch: e }) => {
  if (t.readOnly)
    return !1;
  let n = /* @__PURE__ */ Object.create(null), r = new SD(t, { overrideIndentation: (i) => {
    let o = n[i];
    return o ?? -1;
  } }), a = R6(t, (i, o, s) => {
    let u = JU(r, i.from);
    if (u == null)
      return;
    /\S/.test(i.text) || (u = 0);
    let f = /^\s*/.exec(i.text)[0], p = VT(t, u);
    (f != p || s.from < i.from + f.length) && (n[i.from] = u, o.push({ from: i.from, to: i.from + f.length, insert: p }));
  });
  return a.changes.empty || e(t.update(a, { userEvent: "indent" })), !0;
}, yle = ({ state: t, dispatch: e }) => t.readOnly ? !1 : (e(t.update(R6(t, (n, r) => {
  r.push({ from: n.from, insert: t.facet(f1) });
}), { userEvent: "input.indent" })), !0), Ole = ({ state: t, dispatch: e }) => t.readOnly ? !1 : (e(t.update(R6(t, (n, r) => {
  let a = /^\s*/.exec(n.text)[0];
  if (!a)
    return;
  let i = Xd(a, t.tabSize), o = 0, s = VT(t, Math.max(0, i - m0(t)));
  for (; o < a.length && o < s.length && a.charCodeAt(o) == s.charCodeAt(o); )
    o++;
  r.push({ from: n.from + o, to: n.from + a.length, insert: s.slice(o) });
}), { userEvent: "delete.dedent" })), !0), zBe = [
  { key: "Ctrl-b", run: Xse, shift: ile, preventDefault: !0 },
  { key: "Ctrl-f", run: qse, shift: ole },
  { key: "Ctrl-p", run: ele, shift: ule },
  { key: "Ctrl-n", run: tle, shift: cle },
  { key: "Ctrl-a", run: lBe, shift: OBe },
  { key: "Ctrl-e", run: uBe, shift: EBe },
  { key: "Ctrl-d", run: ple },
  { key: "Ctrl-h", run: K4 },
  { key: "Ctrl-k", run: xBe },
  { key: "Ctrl-Alt-h", run: mle },
  { key: "Ctrl-o", run: RBe },
  { key: "Ctrl-t", run: IBe },
  { key: "Ctrl-v", run: q4 }
], HBe = /* @__PURE__ */ [
  { key: "ArrowLeft", run: Xse, shift: ile, preventDefault: !0 },
  { key: "Mod-ArrowLeft", mac: "Alt-ArrowLeft", run: J$e, shift: dBe, preventDefault: !0 },
  { mac: "Cmd-ArrowLeft", run: oBe, shift: vBe, preventDefault: !0 },
  { key: "ArrowRight", run: qse, shift: ole, preventDefault: !0 },
  { key: "Mod-ArrowRight", mac: "Alt-ArrowRight", run: eBe, shift: pBe, preventDefault: !0 },
  { mac: "Cmd-ArrowRight", run: sBe, shift: yBe, preventDefault: !0 },
  { key: "ArrowUp", run: ele, shift: ule, preventDefault: !0 },
  { mac: "Cmd-ArrowUp", run: xK, shift: kK },
  { mac: "Ctrl-ArrowUp", run: TK, shift: _K },
  { key: "ArrowDown", run: tle, shift: cle, preventDefault: !0 },
  { mac: "Cmd-ArrowDown", run: AK, shift: RK },
  { mac: "Ctrl-ArrowDown", run: q4, shift: CK },
  { key: "PageUp", run: TK, shift: _K },
  { key: "PageDown", run: q4, shift: CK },
  { key: "Home", run: iBe, shift: bBe, preventDefault: !0 },
  { key: "Mod-Home", run: xK, shift: kK },
  { key: "End", run: aBe, shift: gBe, preventDefault: !0 },
  { key: "Mod-End", run: AK, shift: RK },
  { key: "Enter", run: $Be },
  { key: "Mod-a", run: SBe },
  { key: "Backspace", run: K4, shift: K4 },
  { key: "Delete", run: ple },
  { key: "Mod-Backspace", mac: "Alt-Backspace", run: mle },
  { key: "Mod-Delete", mac: "Alt-Delete", run: CBe },
  { mac: "Mod-Backspace", run: ABe },
  { mac: "Mod-Delete", run: kBe }
].concat(/* @__PURE__ */ zBe.map((t) => ({ mac: t.key, run: t.run, shift: t.shift }))), WBe = /* @__PURE__ */ [
  { key: "Alt-ArrowLeft", mac: "Ctrl-ArrowLeft", run: nBe, shift: hBe },
  { key: "Alt-ArrowRight", mac: "Ctrl-ArrowRight", run: rBe, shift: mBe },
  { key: "Alt-ArrowUp", run: DBe },
  { key: "Shift-Alt-ArrowUp", run: PBe },
  { key: "Alt-ArrowDown", run: NBe },
  { key: "Shift-Alt-ArrowDown", run: LBe },
  { key: "Escape", run: _Be },
  { key: "Mod-Enter", run: BBe },
  { key: "Alt-l", mac: "Ctrl-l", run: wBe },
  { key: "Mod-i", run: TBe, preventDefault: !0 },
  { key: "Mod-[", run: Ole },
  { key: "Mod-]", run: yle },
  { key: "Mod-Alt-\\", run: UBe },
  { key: "Shift-Mod-k", run: MBe },
  { key: "Shift-Mod-\\", run: fBe },
  { key: "Mod-/", run: P$e },
  { key: "Alt-A", run: M$e }
].concat(HBe), QBe = { key: "Tab", run: yle, shift: Ole };
function ai() {
  var t = arguments[0];
  typeof t == "string" && (t = document.createElement(t));
  var e = 1, n = arguments[1];
  if (n && typeof n == "object" && n.nodeType == null && !Array.isArray(n)) {
    for (var r in n)
      if (Object.prototype.hasOwnProperty.call(n, r)) {
        var a = n[r];
        typeof a == "string" ? t.setAttribute(r, a) : a != null && (t[r] = a);
      }
    e++;
  }
  for (; e < arguments.length; e++)
    Ele(t, arguments[e]);
  return t;
}
function Ele(t, e) {
  if (typeof e == "string")
    t.appendChild(document.createTextNode(e));
  else if (e != null)
    if (e.nodeType != null)
      t.appendChild(e);
    else if (Array.isArray(e))
      for (var n = 0; n < e.length; n++)
        Ele(t, e[n]);
    else
      throw new RangeError("Unsupported child node: " + e);
}
const IK = typeof String.prototype.normalize == "function" ? (t) => t.normalize("NFKD") : (t) => t;
class e1 {
  /**
  Create a text cursor. The query is the search string, `from` to
  `to` provides the region to search.
  
  When `normalize` is given, it will be called, on both the query
  string and the content it is matched against, before comparing.
  You can, for example, create a case-insensitive search by
  passing `s => s.toLowerCase()`.
  
  Text is always normalized with
  [`.normalize("NFKD")`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/normalize)
  (when supported).
  */
  constructor(e, n, r = 0, a = e.length, i, o) {
    this.test = o, this.value = { from: 0, to: 0 }, this.done = !1, this.matches = [], this.buffer = "", this.bufferPos = 0, this.iter = e.iterRange(r, a), this.bufferStart = r, this.normalize = i ? (s) => i(IK(s)) : IK, this.query = this.normalize(n);
  }
  peek() {
    if (this.bufferPos == this.buffer.length) {
      if (this.bufferStart += this.buffer.length, this.iter.next(), this.iter.done)
        return -1;
      this.bufferPos = 0, this.buffer = this.iter.value;
    }
    return Ks(this.buffer, this.bufferPos);
  }
  /**
  Look for the next match. Updates the iterator's
  [`value`](https://codemirror.net/6/docs/ref/#search.SearchCursor.value) and
  [`done`](https://codemirror.net/6/docs/ref/#search.SearchCursor.done) properties. Should be called
  at least once before using the cursor.
  */
  next() {
    for (; this.matches.length; )
      this.matches.pop();
    return this.nextOverlapping();
  }
  /**
  The `next` method will ignore matches that partially overlap a
  previous match. This method behaves like `next`, but includes
  such matches.
  */
  nextOverlapping() {
    for (; ; ) {
      let e = this.peek();
      if (e < 0)
        return this.done = !0, this;
      let n = FU(e), r = this.bufferStart + this.bufferPos;
      this.bufferPos += Uf(e);
      let a = this.normalize(n);
      for (let i = 0, o = r; ; i++) {
        let s = a.charCodeAt(i), u = this.match(s, o, this.bufferPos + this.bufferStart);
        if (i == a.length - 1) {
          if (u)
            return this.value = u, this;
          break;
        }
        o == r && i < n.length && n.charCodeAt(i) == s && o++;
      }
    }
  }
  match(e, n, r) {
    let a = null;
    for (let i = 0; i < this.matches.length; i += 2) {
      let o = this.matches[i], s = !1;
      this.query.charCodeAt(o) == e && (o == this.query.length - 1 ? a = { from: this.matches[i + 1], to: r } : (this.matches[i]++, s = !0)), s || (this.matches.splice(i, 2), i -= 2);
    }
    return this.query.charCodeAt(0) == e && (this.query.length == 1 ? a = { from: n, to: r } : this.matches.push(1, n)), a && this.test && !this.test(a.from, a.to, this.buffer, this.bufferStart) && (a = null), a;
  }
}
typeof Symbol < "u" && (e1.prototype[Symbol.iterator] = function() {
  return this;
});
const Sle = { from: -1, to: -1, match: /* @__PURE__ */ /.*/.exec("") }, I6 = "gm" + (/x/.unicode == null ? "" : "u");
class wle {
  /**
  Create a cursor that will search the given range in the given
  document. `query` should be the raw pattern (as you'd pass it to
  `new RegExp`).
  */
  constructor(e, n, r, a = 0, i = e.length) {
    if (this.text = e, this.to = i, this.curLine = "", this.done = !1, this.value = Sle, /\\[sWDnr]|\n|\r|\[\^/.test(n))
      return new Tle(e, n, r, a, i);
    this.re = new RegExp(n, I6 + (r != null && r.ignoreCase ? "i" : "")), this.test = r == null ? void 0 : r.test, this.iter = e.iter();
    let o = e.lineAt(a);
    this.curLineStart = o.from, this.matchPos = TI(e, a), this.getLine(this.curLineStart);
  }
  getLine(e) {
    this.iter.next(e), this.iter.lineBreak ? this.curLine = "" : (this.curLine = this.iter.value, this.curLineStart + this.curLine.length > this.to && (this.curLine = this.curLine.slice(0, this.to - this.curLineStart)), this.iter.next());
  }
  nextLine() {
    this.curLineStart = this.curLineStart + this.curLine.length + 1, this.curLineStart > this.to ? this.curLine = "" : this.getLine(0);
  }
  /**
  Move to the next match, if there is one.
  */
  next() {
    for (let e = this.matchPos - this.curLineStart; ; ) {
      this.re.lastIndex = e;
      let n = this.matchPos <= this.to && this.re.exec(this.curLine);
      if (n) {
        let r = this.curLineStart + n.index, a = r + n[0].length;
        if (this.matchPos = TI(this.text, a + (r == a ? 1 : 0)), r == this.curLineStart + this.curLine.length && this.nextLine(), (r < a || r > this.value.to) && (!this.test || this.test(r, a, n)))
          return this.value = { from: r, to: a, match: n }, this;
        e = this.matchPos - this.curLineStart;
      } else if (this.curLineStart + this.curLine.length < this.to)
        this.nextLine(), e = 0;
      else
        return this.done = !0, this;
    }
  }
}
const M3 = /* @__PURE__ */ new WeakMap();
class DE {
  constructor(e, n) {
    this.from = e, this.text = n;
  }
  get to() {
    return this.from + this.text.length;
  }
  static get(e, n, r) {
    let a = M3.get(e);
    if (!a || a.from >= r || a.to <= n) {
      let s = new DE(n, e.sliceString(n, r));
      return M3.set(e, s), s;
    }
    if (a.from == n && a.to == r)
      return a;
    let { text: i, from: o } = a;
    return o > n && (i = e.sliceString(n, o) + i, o = n), a.to < r && (i += e.sliceString(a.to, r)), M3.set(e, new DE(o, i)), new DE(n, i.slice(n - o, r - o));
  }
}
class Tle {
  constructor(e, n, r, a, i) {
    this.text = e, this.to = i, this.done = !1, this.value = Sle, this.matchPos = TI(e, a), this.re = new RegExp(n, I6 + (r != null && r.ignoreCase ? "i" : "")), this.test = r == null ? void 0 : r.test, this.flat = DE.get(e, a, this.chunkEnd(
      a + 5e3
      /* Chunk.Base */
    ));
  }
  chunkEnd(e) {
    return e >= this.to ? this.to : this.text.lineAt(e).to;
  }
  next() {
    for (; ; ) {
      let e = this.re.lastIndex = this.matchPos - this.flat.from, n = this.re.exec(this.flat.text);
      if (n && !n[0] && n.index == e && (this.re.lastIndex = e + 1, n = this.re.exec(this.flat.text)), n) {
        let r = this.flat.from + n.index, a = r + n[0].length;
        if ((this.flat.to >= this.to || n.index + n[0].length <= this.flat.text.length - 10) && (!this.test || this.test(r, a, n)))
          return this.value = { from: r, to: a, match: n }, this.matchPos = TI(this.text, a + (r == a ? 1 : 0)), this;
      }
      if (this.flat.to == this.to)
        return this.done = !0, this;
      this.flat = DE.get(this.text, this.flat.from, this.chunkEnd(this.flat.from + this.flat.text.length * 2));
    }
  }
}
typeof Symbol < "u" && (wle.prototype[Symbol.iterator] = Tle.prototype[Symbol.iterator] = function() {
  return this;
});
function jBe(t) {
  try {
    return new RegExp(t, I6), !0;
  } catch {
    return !1;
  }
}
function TI(t, e) {
  if (e >= t.length)
    return e;
  let n = t.lineAt(e), r;
  for (; e < n.to && (r = n.text.charCodeAt(e - n.from)) >= 56320 && r < 57344; )
    e++;
  return e;
}
function J4(t) {
  let e = String(t.state.doc.lineAt(t.state.selection.main.head).number), n = ai("input", { class: "cm-textfield", name: "line", value: e }), r = ai("form", {
    class: "cm-gotoLine",
    onkeydown: (i) => {
      i.keyCode == 27 ? (i.preventDefault(), t.dispatch({ effects: _I.of(!1) }), t.focus()) : i.keyCode == 13 && (i.preventDefault(), a());
    },
    onsubmit: (i) => {
      i.preventDefault(), a();
    }
  }, ai("label", t.state.phrase("Go to line"), ": ", n), " ", ai("button", { class: "cm-button", type: "submit" }, t.state.phrase("go")));
  function a() {
    let i = /^([+-])?(\d+)?(:\d+)?(%)?$/.exec(n.value);
    if (!i)
      return;
    let { state: o } = t, s = o.doc.lineAt(o.selection.main.head), [, u, f, p, m] = i, v = p ? +p.slice(1) : 0, O = f ? +f : s.number;
    if (f && m) {
      let C = O / 100;
      u && (C = C * (u == "-" ? -1 : 1) + s.number / o.doc.lines), O = Math.round(o.doc.lines * C);
    } else
      f && u && (O = O * (u == "-" ? -1 : 1) + s.number);
    let w = o.doc.line(Math.max(1, Math.min(o.doc.lines, O))), _ = ft.cursor(w.from + Math.max(0, Math.min(v, w.length)));
    t.dispatch({
      effects: [_I.of(!1), qt.scrollIntoView(_.from, { y: "center" })],
      selection: _
    }), t.focus();
  }
  return { dom: r };
}
const _I = /* @__PURE__ */ fr.define(), DK = /* @__PURE__ */ Ss.define({
  create() {
    return !0;
  },
  update(t, e) {
    for (let n of e.effects)
      n.is(_I) && (t = n.value);
    return t;
  },
  provide: (t) => QT.from(t, (e) => e ? J4 : null)
}), GBe = (t) => {
  let e = WT(t, J4);
  if (!e) {
    let n = [_I.of(!0)];
    t.state.field(DK, !1) == null && n.push(fr.appendConfig.of([DK, VBe])), t.dispatch({ effects: n }), e = WT(t, J4);
  }
  return e && e.dom.querySelector("input").select(), !0;
}, VBe = /* @__PURE__ */ qt.baseTheme({
  ".cm-panel.cm-gotoLine": {
    padding: "2px 6px 4px",
    "& label": { fontSize: "80%" }
  }
}), YBe = {
  highlightWordAroundCursor: !1,
  minSelectionLength: 1,
  maxMatches: 100,
  wholeWords: !1
}, _le = /* @__PURE__ */ bn.define({
  combine(t) {
    return Dh(t, YBe, {
      highlightWordAroundCursor: (e, n) => e || n,
      minSelectionLength: Math.min,
      maxMatches: Math.min
    });
  }
});
function ZBe(t) {
  let e = [e4e, JBe];
  return t && e.push(_le.of(t)), e;
}
const XBe = /* @__PURE__ */ Ln.mark({ class: "cm-selectionMatch" }), qBe = /* @__PURE__ */ Ln.mark({ class: "cm-selectionMatch cm-selectionMatch-main" });
function NK(t, e, n, r) {
  return (n == 0 || t(e.sliceDoc(n - 1, n)) != Si.Word) && (r == e.doc.length || t(e.sliceDoc(r, r + 1)) != Si.Word);
}
function KBe(t, e, n, r) {
  return t(e.sliceDoc(n, n + 1)) == Si.Word && t(e.sliceDoc(r - 1, r)) == Si.Word;
}
const JBe = /* @__PURE__ */ Ki.fromClass(class {
  constructor(t) {
    this.decorations = this.getDeco(t);
  }
  update(t) {
    (t.selectionSet || t.docChanged || t.viewportChanged) && (this.decorations = this.getDeco(t.view));
  }
  getDeco(t) {
    let e = t.state.facet(_le), { state: n } = t, r = n.selection;
    if (r.ranges.length > 1)
      return Ln.none;
    let a = r.main, i, o = null;
    if (a.empty) {
      if (!e.highlightWordAroundCursor)
        return Ln.none;
      let u = n.wordAt(a.head);
      if (!u)
        return Ln.none;
      o = n.charCategorizer(a.head), i = n.sliceDoc(u.from, u.to);
    } else {
      let u = a.to - a.from;
      if (u < e.minSelectionLength || u > 200)
        return Ln.none;
      if (e.wholeWords) {
        if (i = n.sliceDoc(a.from, a.to), o = n.charCategorizer(a.head), !(NK(o, n, a.from, a.to) && KBe(o, n, a.from, a.to)))
          return Ln.none;
      } else if (i = n.sliceDoc(a.from, a.to), !i)
        return Ln.none;
    }
    let s = [];
    for (let u of t.visibleRanges) {
      let f = new e1(n.doc, i, u.from, u.to);
      for (; !f.next().done; ) {
        let { from: p, to: m } = f.value;
        if ((!o || NK(o, n, p, m)) && (a.empty && p <= a.from && m >= a.to ? s.push(qBe.range(p, m)) : (p >= a.to || m <= a.from) && s.push(XBe.range(p, m)), s.length > e.maxMatches))
          return Ln.none;
      }
    }
    return Ln.set(s);
  }
}, {
  decorations: (t) => t.decorations
}), e4e = /* @__PURE__ */ qt.baseTheme({
  ".cm-selectionMatch": { backgroundColor: "#99ff7780" },
  ".cm-searchMatch .cm-selectionMatch": { backgroundColor: "transparent" }
}), t4e = ({ state: t, dispatch: e }) => {
  let { selection: n } = t, r = ft.create(n.ranges.map((a) => t.wordAt(a.head) || ft.cursor(a.head)), n.mainIndex);
  return r.eq(n) ? !1 : (e(t.update({ selection: r })), !0);
};
function n4e(t, e) {
  let { main: n, ranges: r } = t.selection, a = t.wordAt(n.head), i = a && a.from == n.from && a.to == n.to;
  for (let o = !1, s = new e1(t.doc, e, r[r.length - 1].to); ; )
    if (s.next(), s.done) {
      if (o)
        return null;
      s = new e1(t.doc, e, 0, Math.max(0, r[r.length - 1].from - 1)), o = !0;
    } else {
      if (o && r.some((u) => u.from == s.value.from))
        continue;
      if (i) {
        let u = t.wordAt(s.value.from);
        if (!u || u.from != s.value.from || u.to != s.value.to)
          continue;
      }
      return s.value;
    }
}
const r4e = ({ state: t, dispatch: e }) => {
  let { ranges: n } = t.selection;
  if (n.some((i) => i.from === i.to))
    return t4e({ state: t, dispatch: e });
  let r = t.sliceDoc(n[0].from, n[0].to);
  if (t.selection.ranges.some((i) => t.sliceDoc(i.from, i.to) != r))
    return !1;
  let a = n4e(t, r);
  return a ? (e(t.update({
    selection: t.selection.addRange(ft.range(a.from, a.to), !1),
    effects: qt.scrollIntoView(a.to)
  })), !0) : !1;
}, g1 = /* @__PURE__ */ bn.define({
  combine(t) {
    return Dh(t, {
      top: !1,
      caseSensitive: !1,
      literal: !1,
      regexp: !1,
      wholeWord: !1,
      createPanel: (e) => new m4e(e),
      scrollToMatch: (e) => qt.scrollIntoView(e)
    });
  }
});
class Cle {
  /**
  Create a query object.
  */
  constructor(e) {
    this.search = e.search, this.caseSensitive = !!e.caseSensitive, this.literal = !!e.literal, this.regexp = !!e.regexp, this.replace = e.replace || "", this.valid = !!this.search && (!this.regexp || jBe(this.search)), this.unquoted = this.unquote(this.search), this.wholeWord = !!e.wholeWord;
  }
  /**
  @internal
  */
  unquote(e) {
    return this.literal ? e : e.replace(/\\([nrt\\])/g, (n, r) => r == "n" ? `
` : r == "r" ? "\r" : r == "t" ? "	" : "\\");
  }
  /**
  Compare this query to another query.
  */
  eq(e) {
    return this.search == e.search && this.replace == e.replace && this.caseSensitive == e.caseSensitive && this.regexp == e.regexp && this.wholeWord == e.wholeWord;
  }
  /**
  @internal
  */
  create() {
    return this.regexp ? new s4e(this) : new i4e(this);
  }
  /**
  Get a search cursor for this query, searching through the given
  range in the given state.
  */
  getCursor(e, n = 0, r) {
    let a = e.doc ? e : zr.create({ doc: e });
    return r == null && (r = a.doc.length), this.regexp ? fE(this, a, n, r) : cE(this, a, n, r);
  }
}
class xle {
  constructor(e) {
    this.spec = e;
  }
}
function cE(t, e, n, r) {
  return new e1(e.doc, t.unquoted, n, r, t.caseSensitive ? void 0 : (a) => a.toLowerCase(), t.wholeWord ? a4e(e.doc, e.charCategorizer(e.selection.main.head)) : void 0);
}
function a4e(t, e) {
  return (n, r, a, i) => ((i > n || i + a.length < r) && (i = Math.max(0, n - 2), a = t.sliceString(i, Math.min(t.length, r + 2))), (e(CI(a, n - i)) != Si.Word || e(xI(a, n - i)) != Si.Word) && (e(xI(a, r - i)) != Si.Word || e(CI(a, r - i)) != Si.Word));
}
class i4e extends xle {
  constructor(e) {
    super(e);
  }
  nextMatch(e, n, r) {
    let a = cE(this.spec, e, r, e.doc.length).nextOverlapping();
    return a.done && (a = cE(this.spec, e, 0, n).nextOverlapping()), a.done ? null : a.value;
  }
  // Searching in reverse is, rather than implementing an inverted search
  // cursor, done by scanning chunk after chunk forward.
  prevMatchInRange(e, n, r) {
    for (let a = r; ; ) {
      let i = Math.max(n, a - 1e4 - this.spec.unquoted.length), o = cE(this.spec, e, i, a), s = null;
      for (; !o.nextOverlapping().done; )
        s = o.value;
      if (s)
        return s;
      if (i == n)
        return null;
      a -= 1e4;
    }
  }
  prevMatch(e, n, r) {
    return this.prevMatchInRange(e, 0, n) || this.prevMatchInRange(e, r, e.doc.length);
  }
  getReplacement(e) {
    return this.spec.unquote(this.spec.replace);
  }
  matchAll(e, n) {
    let r = cE(this.spec, e, 0, e.doc.length), a = [];
    for (; !r.next().done; ) {
      if (a.length >= n)
        return null;
      a.push(r.value);
    }
    return a;
  }
  highlight(e, n, r, a) {
    let i = cE(this.spec, e, Math.max(0, n - this.spec.unquoted.length), Math.min(r + this.spec.unquoted.length, e.doc.length));
    for (; !i.next().done; )
      a(i.value.from, i.value.to);
  }
}
function fE(t, e, n, r) {
  return new wle(e.doc, t.search, {
    ignoreCase: !t.caseSensitive,
    test: t.wholeWord ? o4e(e.charCategorizer(e.selection.main.head)) : void 0
  }, n, r);
}
function CI(t, e) {
  return t.slice(nl(t, e, !1), e);
}
function xI(t, e) {
  return t.slice(e, nl(t, e));
}
function o4e(t) {
  return (e, n, r) => !r[0].length || (t(CI(r.input, r.index)) != Si.Word || t(xI(r.input, r.index)) != Si.Word) && (t(xI(r.input, r.index + r[0].length)) != Si.Word || t(CI(r.input, r.index + r[0].length)) != Si.Word);
}
class s4e extends xle {
  nextMatch(e, n, r) {
    let a = fE(this.spec, e, r, e.doc.length).next();
    return a.done && (a = fE(this.spec, e, 0, n).next()), a.done ? null : a.value;
  }
  prevMatchInRange(e, n, r) {
    for (let a = 1; ; a++) {
      let i = Math.max(
        n,
        r - a * 1e4
        /* FindPrev.ChunkSize */
      ), o = fE(this.spec, e, i, r), s = null;
      for (; !o.next().done; )
        s = o.value;
      if (s && (i == n || s.from > i + 10))
        return s;
      if (i == n)
        return null;
    }
  }
  prevMatch(e, n, r) {
    return this.prevMatchInRange(e, 0, n) || this.prevMatchInRange(e, r, e.doc.length);
  }
  getReplacement(e) {
    return this.spec.unquote(this.spec.replace).replace(/\$([$&\d+])/g, (n, r) => r == "$" ? "$" : r == "&" ? e.match[0] : r != "0" && +r < e.match.length ? e.match[r] : n);
  }
  matchAll(e, n) {
    let r = fE(this.spec, e, 0, e.doc.length), a = [];
    for (; !r.next().done; ) {
      if (a.length >= n)
        return null;
      a.push(r.value);
    }
    return a;
  }
  highlight(e, n, r, a) {
    let i = fE(this.spec, e, Math.max(
      0,
      n - 250
      /* RegExp.HighlightMargin */
    ), Math.min(r + 250, e.doc.length));
    for (; !i.next().done; )
      a(i.value.from, i.value.to);
  }
}
const r_ = /* @__PURE__ */ fr.define(), D6 = /* @__PURE__ */ fr.define(), Zb = /* @__PURE__ */ Ss.define({
  create(t) {
    return new F3(e5(t).create(), null);
  },
  update(t, e) {
    for (let n of e.effects)
      n.is(r_) ? t = new F3(n.value.create(), t.panel) : n.is(D6) && (t = new F3(t.query, n.value ? N6 : null));
    return t;
  },
  provide: (t) => QT.from(t, (e) => e.panel)
});
class F3 {
  constructor(e, n) {
    this.query = e, this.panel = n;
  }
}
const l4e = /* @__PURE__ */ Ln.mark({ class: "cm-searchMatch" }), u4e = /* @__PURE__ */ Ln.mark({ class: "cm-searchMatch cm-searchMatch-selected" }), c4e = /* @__PURE__ */ Ki.fromClass(class {
  constructor(t) {
    this.view = t, this.decorations = this.highlight(t.state.field(Zb));
  }
  update(t) {
    let e = t.state.field(Zb);
    (e != t.startState.field(Zb) || t.docChanged || t.selectionSet || t.viewportChanged) && (this.decorations = this.highlight(e));
  }
  highlight({ query: t, panel: e }) {
    if (!e || !t.spec.valid)
      return Ln.none;
    let { view: n } = this, r = new Jb();
    for (let a = 0, i = n.visibleRanges, o = i.length; a < o; a++) {
      let { from: s, to: u } = i[a];
      for (; a < o - 1 && u > i[a + 1].from - 2 * 250; )
        u = i[++a].to;
      t.highlight(n.state, s, u, (f, p) => {
        let m = n.state.selection.ranges.some((v) => v.from == f && v.to == p);
        r.add(f, p, m ? u4e : l4e);
      });
    }
    return r.finish();
  }
}, {
  decorations: (t) => t.decorations
});
function C_(t) {
  return (e) => {
    let n = e.state.field(Zb, !1);
    return n && n.query.spec.valid ? t(e, n) : Rle(e);
  };
}
const AI = /* @__PURE__ */ C_((t, { query: e }) => {
  let { to: n } = t.state.selection.main, r = e.nextMatch(t.state, n, n);
  if (!r)
    return !1;
  let a = ft.single(r.from, r.to), i = t.state.facet(g1);
  return t.dispatch({
    selection: a,
    effects: [P6(t, r), i.scrollToMatch(a.main, t)],
    userEvent: "select.search"
  }), kle(t), !0;
}), kI = /* @__PURE__ */ C_((t, { query: e }) => {
  let { state: n } = t, { from: r } = n.selection.main, a = e.prevMatch(n, r, r);
  if (!a)
    return !1;
  let i = ft.single(a.from, a.to), o = t.state.facet(g1);
  return t.dispatch({
    selection: i,
    effects: [P6(t, a), o.scrollToMatch(i.main, t)],
    userEvent: "select.search"
  }), kle(t), !0;
}), f4e = /* @__PURE__ */ C_((t, { query: e }) => {
  let n = e.matchAll(t.state, 1e3);
  return !n || !n.length ? !1 : (t.dispatch({
    selection: ft.create(n.map((r) => ft.range(r.from, r.to))),
    userEvent: "select.search.matches"
  }), !0);
}), d4e = ({ state: t, dispatch: e }) => {
  let n = t.selection;
  if (n.ranges.length > 1 || n.main.empty)
    return !1;
  let { from: r, to: a } = n.main, i = [], o = 0;
  for (let s = new e1(t.doc, t.sliceDoc(r, a)); !s.next().done; ) {
    if (i.length > 1e3)
      return !1;
    s.value.from == r && (o = i.length), i.push(ft.range(s.value.from, s.value.to));
  }
  return e(t.update({
    selection: ft.create(i, o),
    userEvent: "select.search.matches"
  })), !0;
}, PK = /* @__PURE__ */ C_((t, { query: e }) => {
  let { state: n } = t, { from: r, to: a } = n.selection.main;
  if (n.readOnly)
    return !1;
  let i = e.nextMatch(n, r, r);
  if (!i)
    return !1;
  let o = [], s, u, f = [];
  if (i.from == r && i.to == a && (u = n.toText(e.getReplacement(i)), o.push({ from: i.from, to: i.to, insert: u }), i = e.nextMatch(n, i.from, i.to), f.push(qt.announce.of(n.phrase("replaced match on line $", n.doc.lineAt(r).number) + "."))), i) {
    let p = o.length == 0 || o[0].from >= i.to ? 0 : i.to - i.from - u.length;
    s = ft.single(i.from - p, i.to - p), f.push(P6(t, i)), f.push(n.facet(g1).scrollToMatch(s.main, t));
  }
  return t.dispatch({
    changes: o,
    selection: s,
    effects: f,
    userEvent: "input.replace"
  }), !0;
}), p4e = /* @__PURE__ */ C_((t, { query: e }) => {
  if (t.state.readOnly)
    return !1;
  let n = e.matchAll(t.state, 1e9).map((a) => {
    let { from: i, to: o } = a;
    return { from: i, to: o, insert: e.getReplacement(a) };
  });
  if (!n.length)
    return !1;
  let r = t.state.phrase("replaced $ matches", n.length) + ".";
  return t.dispatch({
    changes: n,
    effects: qt.announce.of(r),
    userEvent: "input.replace.all"
  }), !0;
});
function N6(t) {
  return t.state.facet(g1).createPanel(t);
}
function e5(t, e) {
  var n, r, a, i, o;
  let s = t.selection.main, u = s.empty || s.to > s.from + 100 ? "" : t.sliceDoc(s.from, s.to);
  if (e && !u)
    return e;
  let f = t.facet(g1);
  return new Cle({
    search: ((n = e == null ? void 0 : e.literal) !== null && n !== void 0 ? n : f.literal) ? u : u.replace(/\n/g, "\\n"),
    caseSensitive: (r = e == null ? void 0 : e.caseSensitive) !== null && r !== void 0 ? r : f.caseSensitive,
    literal: (a = e == null ? void 0 : e.literal) !== null && a !== void 0 ? a : f.literal,
    regexp: (i = e == null ? void 0 : e.regexp) !== null && i !== void 0 ? i : f.regexp,
    wholeWord: (o = e == null ? void 0 : e.wholeWord) !== null && o !== void 0 ? o : f.wholeWord
  });
}
function Ale(t) {
  let e = WT(t, N6);
  return e && e.dom.querySelector("[main-field]");
}
function kle(t) {
  let e = Ale(t);
  e && e == t.root.activeElement && e.select();
}
const Rle = (t) => {
  let e = t.state.field(Zb, !1);
  if (e && e.panel) {
    let n = Ale(t);
    if (n && n != t.root.activeElement) {
      let r = e5(t.state, e.query.spec);
      r.valid && t.dispatch({ effects: r_.of(r) }), n.focus(), n.select();
    }
  } else
    t.dispatch({ effects: [
      D6.of(!0),
      e ? r_.of(e5(t.state, e.query.spec)) : fr.appendConfig.of(b4e)
    ] });
  return !0;
}, Ile = (t) => {
  let e = t.state.field(Zb, !1);
  if (!e || !e.panel)
    return !1;
  let n = WT(t, N6);
  return n && n.dom.contains(t.root.activeElement) && t.focus(), t.dispatch({ effects: D6.of(!1) }), !0;
}, h4e = [
  { key: "Mod-f", run: Rle, scope: "editor search-panel" },
  { key: "F3", run: AI, shift: kI, scope: "editor search-panel", preventDefault: !0 },
  { key: "Mod-g", run: AI, shift: kI, scope: "editor search-panel", preventDefault: !0 },
  { key: "Escape", run: Ile, scope: "editor search-panel" },
  { key: "Mod-Shift-l", run: d4e },
  { key: "Mod-Alt-g", run: GBe },
  { key: "Mod-d", run: r4e, preventDefault: !0 }
];
class m4e {
  constructor(e) {
    this.view = e;
    let n = this.query = e.state.field(Zb).query.spec;
    this.commit = this.commit.bind(this), this.searchField = ai("input", {
      value: n.search,
      placeholder: Dc(e, "Find"),
      "aria-label": Dc(e, "Find"),
      class: "cm-textfield",
      name: "search",
      form: "",
      "main-field": "true",
      onchange: this.commit,
      onkeyup: this.commit
    }), this.replaceField = ai("input", {
      value: n.replace,
      placeholder: Dc(e, "Replace"),
      "aria-label": Dc(e, "Replace"),
      class: "cm-textfield",
      name: "replace",
      form: "",
      onchange: this.commit,
      onkeyup: this.commit
    }), this.caseField = ai("input", {
      type: "checkbox",
      name: "case",
      form: "",
      checked: n.caseSensitive,
      onchange: this.commit
    }), this.reField = ai("input", {
      type: "checkbox",
      name: "re",
      form: "",
      checked: n.regexp,
      onchange: this.commit
    }), this.wordField = ai("input", {
      type: "checkbox",
      name: "word",
      form: "",
      checked: n.wholeWord,
      onchange: this.commit
    });
    function r(a, i, o) {
      return ai("button", { class: "cm-button", name: a, onclick: i, type: "button" }, o);
    }
    this.dom = ai("div", { onkeydown: (a) => this.keydown(a), class: "cm-search" }, [
      this.searchField,
      r("next", () => AI(e), [Dc(e, "next")]),
      r("prev", () => kI(e), [Dc(e, "previous")]),
      r("select", () => f4e(e), [Dc(e, "all")]),
      ai("label", null, [this.caseField, Dc(e, "match case")]),
      ai("label", null, [this.reField, Dc(e, "regexp")]),
      ai("label", null, [this.wordField, Dc(e, "by word")]),
      ...e.state.readOnly ? [] : [
        ai("br"),
        this.replaceField,
        r("replace", () => PK(e), [Dc(e, "replace")]),
        r("replaceAll", () => p4e(e), [Dc(e, "replace all")])
      ],
      ai("button", {
        name: "close",
        onclick: () => Ile(e),
        "aria-label": Dc(e, "close"),
        type: "button"
      }, ["×"])
    ]);
  }
  commit() {
    let e = new Cle({
      search: this.searchField.value,
      caseSensitive: this.caseField.checked,
      regexp: this.reField.checked,
      wholeWord: this.wordField.checked,
      replace: this.replaceField.value
    });
    e.eq(this.query) || (this.query = e, this.view.dispatch({ effects: r_.of(e) }));
  }
  keydown(e) {
    N2e(this.view, e, "search-panel") ? e.preventDefault() : e.keyCode == 13 && e.target == this.searchField ? (e.preventDefault(), (e.shiftKey ? kI : AI)(this.view)) : e.keyCode == 13 && e.target == this.replaceField && (e.preventDefault(), PK(this.view));
  }
  update(e) {
    for (let n of e.transactions)
      for (let r of n.effects)
        r.is(r_) && !r.value.eq(this.query) && this.setQuery(r.value);
  }
  setQuery(e) {
    this.query = e, this.searchField.value = e.search, this.replaceField.value = e.replace, this.caseField.checked = e.caseSensitive, this.reField.checked = e.regexp, this.wordField.checked = e.wholeWord;
  }
  mount() {
    this.searchField.select();
  }
  get pos() {
    return 80;
  }
  get top() {
    return this.view.state.facet(g1).top;
  }
}
function Dc(t, e) {
  return t.state.phrase(e);
}
const sA = 30, lA = /[\s\.,:;?!]/;
function P6(t, { from: e, to: n }) {
  let r = t.state.doc.lineAt(e), a = t.state.doc.lineAt(n).to, i = Math.max(r.from, e - sA), o = Math.min(a, n + sA), s = t.state.sliceDoc(i, o);
  if (i != r.from) {
    for (let u = 0; u < sA; u++)
      if (!lA.test(s[u + 1]) && lA.test(s[u])) {
        s = s.slice(u);
        break;
      }
  }
  if (o != a) {
    for (let u = s.length - 1; u > s.length - sA; u--)
      if (!lA.test(s[u - 1]) && lA.test(s[u])) {
        s = s.slice(0, u);
        break;
      }
  }
  return qt.announce.of(`${t.state.phrase("current match")}. ${s} ${t.state.phrase("on line")} ${r.number}.`);
}
const g4e = /* @__PURE__ */ qt.baseTheme({
  ".cm-panel.cm-search": {
    padding: "2px 6px 4px",
    position: "relative",
    "& [name=close]": {
      position: "absolute",
      top: "0",
      right: "4px",
      backgroundColor: "inherit",
      border: "none",
      font: "inherit",
      padding: 0,
      margin: 0
    },
    "& input, & button, & label": {
      margin: ".2em .6em .2em 0"
    },
    "& input[type=checkbox]": {
      marginRight: ".2em"
    },
    "& label": {
      fontSize: "80%",
      whiteSpace: "pre"
    }
  },
  "&light .cm-searchMatch": { backgroundColor: "#ffff0054" },
  "&dark .cm-searchMatch": { backgroundColor: "#00ffff8a" },
  "&light .cm-searchMatch-selected": { backgroundColor: "#ff6a0054" },
  "&dark .cm-searchMatch-selected": { backgroundColor: "#ff00ff8a" }
}), b4e = [
  Zb,
  /* @__PURE__ */ ig.low(c4e),
  g4e
];
class v4e {
  constructor(e, n, r) {
    this.from = e, this.to = n, this.diagnostic = r;
  }
}
class Zy {
  constructor(e, n, r) {
    this.diagnostics = e, this.panel = n, this.selected = r;
  }
  static init(e, n, r) {
    let a = e, i = r.facet(M6).markerFilter;
    i && (a = i(a, r));
    let o = Ln.set(a.map((s) => s.from == s.to || s.from == s.to - 1 && r.doc.lineAt(s.from).to == s.from ? Ln.widget({
      widget: new x4e(s),
      diagnostic: s
    }).range(s.from) : Ln.mark({
      attributes: { class: "cm-lintRange cm-lintRange-" + s.severity + (s.markClass ? " " + s.markClass : "") },
      diagnostic: s,
      inclusive: !0
    }).range(s.from, s.to)), !0);
    return new Zy(o, n, t1(o));
  }
}
function t1(t, e = null, n = 0) {
  let r = null;
  return t.between(n, 1e9, (a, i, { spec: o }) => {
    if (!(e && o.diagnostic != e))
      return r = new v4e(a, i, o.diagnostic), !1;
  }), r;
}
function y4e(t, e) {
  let n = e.pos, r = e.end || n, a = t.state.facet(M6).hideOn(t, n, r);
  if (a != null)
    return a;
  let i = t.startState.doc.lineAt(e.pos);
  return !!(t.effects.some((o) => o.is(Dle)) || t.changes.touchesRange(i.from, Math.max(i.to, r)));
}
function O4e(t, e) {
  return t.field(Uc, !1) ? e : e.concat(fr.appendConfig.of(R4e));
}
const Dle = /* @__PURE__ */ fr.define(), L6 = /* @__PURE__ */ fr.define(), Nle = /* @__PURE__ */ fr.define(), Uc = /* @__PURE__ */ Ss.define({
  create() {
    return new Zy(Ln.none, null, null);
  },
  update(t, e) {
    if (e.docChanged) {
      let n = t.diagnostics.map(e.changes), r = null;
      if (t.selected) {
        let a = e.changes.mapPos(t.selected.from, 1);
        r = t1(n, t.selected.diagnostic, a) || t1(n, null, a);
      }
      t = new Zy(n, t.panel, r);
    }
    for (let n of e.effects)
      n.is(Dle) ? t = Zy.init(n.value, t.panel, e.state) : n.is(L6) ? t = new Zy(t.diagnostics, n.value ? ID.open : null, t.selected) : n.is(Nle) && (t = new Zy(t.diagnostics, t.panel, n.value));
    return t;
  },
  provide: (t) => [
    QT.from(t, (e) => e.panel),
    qt.decorations.from(t, (e) => e.diagnostics)
  ]
}), E4e = /* @__PURE__ */ Ln.mark({ class: "cm-lintRange cm-lintRange-active", inclusive: !0 });
function S4e(t, e, n) {
  let { diagnostics: r } = t.state.field(Uc), a = [], i = 2e8, o = 0;
  r.between(e - (n < 0 ? 1 : 0), e + (n > 0 ? 1 : 0), (u, f, { spec: p }) => {
    e >= u && e <= f && (u == f || (e > u || n > 0) && (e < f || n < 0)) && (a.push(p.diagnostic), i = Math.min(u, i), o = Math.max(f, o));
  });
  let s = t.state.facet(M6).tooltipFilter;
  return s && (a = s(a, t.state)), a.length ? {
    pos: i,
    end: o,
    above: t.state.doc.lineAt(i).to < o,
    create() {
      return { dom: w4e(t, a) };
    }
  } : null;
}
function w4e(t, e) {
  return ai("ul", { class: "cm-tooltip-lint" }, e.map((n) => Lle(t, n, !1)));
}
const T4e = (t) => {
  let e = t.state.field(Uc, !1);
  (!e || !e.panel) && t.dispatch({ effects: O4e(t.state, [L6.of(!0)]) });
  let n = WT(t, ID.open);
  return n && n.dom.querySelector(".cm-panel-lint ul").focus(), !0;
}, LK = (t) => {
  let e = t.state.field(Uc, !1);
  return !e || !e.panel ? !1 : (t.dispatch({ effects: L6.of(!1) }), !0);
}, _4e = (t) => {
  let e = t.state.field(Uc, !1);
  if (!e)
    return !1;
  let n = t.state.selection.main, r = e.diagnostics.iter(n.to + 1);
  return !r.value && (r = e.diagnostics.iter(0), !r.value || r.from == n.from && r.to == n.to) ? !1 : (t.dispatch({ selection: { anchor: r.from, head: r.to }, scrollIntoView: !0 }), !0);
}, C4e = [
  { key: "Mod-Shift-m", run: T4e, preventDefault: !0 },
  { key: "F8", run: _4e }
], M6 = /* @__PURE__ */ bn.define({
  combine(t) {
    return Object.assign({ sources: t.map((e) => e.source).filter((e) => e != null) }, Dh(t.map((e) => e.config), {
      delay: 750,
      markerFilter: null,
      tooltipFilter: null,
      needsRefresh: null,
      hideOn: () => null
    }, {
      needsRefresh: (e, n) => e ? n ? (r) => e(r) || n(r) : e : n
    }));
  }
});
function Ple(t) {
  let e = [];
  if (t)
    e:
      for (let { name: n } of t) {
        for (let r = 0; r < n.length; r++) {
          let a = n[r];
          if (/[a-zA-Z]/.test(a) && !e.some((i) => i.toLowerCase() == a.toLowerCase())) {
            e.push(a);
            continue e;
          }
        }
        e.push("");
      }
  return e;
}
function Lle(t, e, n) {
  var r;
  let a = n ? Ple(e.actions) : [];
  return ai("li", { class: "cm-diagnostic cm-diagnostic-" + e.severity }, ai("span", { class: "cm-diagnosticText" }, e.renderMessage ? e.renderMessage(t) : e.message), (r = e.actions) === null || r === void 0 ? void 0 : r.map((i, o) => {
    let s = !1, u = (v) => {
      if (v.preventDefault(), s)
        return;
      s = !0;
      let O = t1(t.state.field(Uc).diagnostics, e);
      O && i.apply(t, O.from, O.to);
    }, { name: f } = i, p = a[o] ? f.indexOf(a[o]) : -1, m = p < 0 ? f : [
      f.slice(0, p),
      ai("u", f.slice(p, p + 1)),
      f.slice(p + 1)
    ];
    return ai("button", {
      type: "button",
      class: "cm-diagnosticAction",
      onclick: u,
      onmousedown: u,
      "aria-label": ` Action: ${f}${p < 0 ? "" : ` (access key "${a[o]})"`}.`
    }, m);
  }), e.source && ai("div", { class: "cm-diagnosticSource" }, e.source));
}
class x4e extends Nh {
  constructor(e) {
    super(), this.diagnostic = e;
  }
  eq(e) {
    return e.diagnostic == this.diagnostic;
  }
  toDOM() {
    return ai("span", { class: "cm-lintPoint cm-lintPoint-" + this.diagnostic.severity });
  }
}
class MK {
  constructor(e, n) {
    this.diagnostic = n, this.id = "item_" + Math.floor(Math.random() * 4294967295).toString(16), this.dom = Lle(e, n, !0), this.dom.id = this.id, this.dom.setAttribute("role", "option");
  }
}
class ID {
  constructor(e) {
    this.view = e, this.items = [];
    let n = (a) => {
      if (a.keyCode == 27)
        LK(this.view), this.view.focus();
      else if (a.keyCode == 38 || a.keyCode == 33)
        this.moveSelection((this.selectedIndex - 1 + this.items.length) % this.items.length);
      else if (a.keyCode == 40 || a.keyCode == 34)
        this.moveSelection((this.selectedIndex + 1) % this.items.length);
      else if (a.keyCode == 36)
        this.moveSelection(0);
      else if (a.keyCode == 35)
        this.moveSelection(this.items.length - 1);
      else if (a.keyCode == 13)
        this.view.focus();
      else if (a.keyCode >= 65 && a.keyCode <= 90 && this.selectedIndex >= 0) {
        let { diagnostic: i } = this.items[this.selectedIndex], o = Ple(i.actions);
        for (let s = 0; s < o.length; s++)
          if (o[s].toUpperCase().charCodeAt(0) == a.keyCode) {
            let u = t1(this.view.state.field(Uc).diagnostics, i);
            u && i.actions[s].apply(e, u.from, u.to);
          }
      } else
        return;
      a.preventDefault();
    }, r = (a) => {
      for (let i = 0; i < this.items.length; i++)
        this.items[i].dom.contains(a.target) && this.moveSelection(i);
    };
    this.list = ai("ul", {
      tabIndex: 0,
      role: "listbox",
      "aria-label": this.view.state.phrase("Diagnostics"),
      onkeydown: n,
      onclick: r
    }), this.dom = ai("div", { class: "cm-panel-lint" }, this.list, ai("button", {
      type: "button",
      name: "close",
      "aria-label": this.view.state.phrase("close"),
      onclick: () => LK(this.view)
    }, "×")), this.update();
  }
  get selectedIndex() {
    let e = this.view.state.field(Uc).selected;
    if (!e)
      return -1;
    for (let n = 0; n < this.items.length; n++)
      if (this.items[n].diagnostic == e.diagnostic)
        return n;
    return -1;
  }
  update() {
    let { diagnostics: e, selected: n } = this.view.state.field(Uc), r = 0, a = !1, i = null;
    for (e.between(0, this.view.state.doc.length, (o, s, { spec: u }) => {
      let f = -1, p;
      for (let m = r; m < this.items.length; m++)
        if (this.items[m].diagnostic == u.diagnostic) {
          f = m;
          break;
        }
      f < 0 ? (p = new MK(this.view, u.diagnostic), this.items.splice(r, 0, p), a = !0) : (p = this.items[f], f > r && (this.items.splice(r, f - r), a = !0)), n && p.diagnostic == n.diagnostic ? p.dom.hasAttribute("aria-selected") || (p.dom.setAttribute("aria-selected", "true"), i = p) : p.dom.hasAttribute("aria-selected") && p.dom.removeAttribute("aria-selected"), r++;
    }); r < this.items.length && !(this.items.length == 1 && this.items[0].diagnostic.from < 0); )
      a = !0, this.items.pop();
    this.items.length == 0 && (this.items.push(new MK(this.view, {
      from: -1,
      to: -1,
      severity: "info",
      message: this.view.state.phrase("No diagnostics")
    })), a = !0), i ? (this.list.setAttribute("aria-activedescendant", i.id), this.view.requestMeasure({
      key: this,
      read: () => ({ sel: i.dom.getBoundingClientRect(), panel: this.list.getBoundingClientRect() }),
      write: ({ sel: o, panel: s }) => {
        let u = s.height / this.list.offsetHeight;
        o.top < s.top ? this.list.scrollTop -= (s.top - o.top) / u : o.bottom > s.bottom && (this.list.scrollTop += (o.bottom - s.bottom) / u);
      }
    })) : this.selectedIndex < 0 && this.list.removeAttribute("aria-activedescendant"), a && this.sync();
  }
  sync() {
    let e = this.list.firstChild;
    function n() {
      let r = e;
      e = r.nextSibling, r.remove();
    }
    for (let r of this.items)
      if (r.dom.parentNode == this.list) {
        for (; e != r.dom; )
          n();
        e = r.dom.nextSibling;
      } else
        this.list.insertBefore(r.dom, e);
    for (; e; )
      n();
  }
  moveSelection(e) {
    if (this.selectedIndex < 0)
      return;
    let n = this.view.state.field(Uc), r = t1(n.diagnostics, this.items[e].diagnostic);
    r && this.view.dispatch({
      selection: { anchor: r.from, head: r.to },
      scrollIntoView: !0,
      effects: Nle.of(r)
    });
  }
  static open(e) {
    return new ID(e);
  }
}
function A4e(t, e = 'viewBox="0 0 40 40"') {
  return `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" ${e}>${encodeURIComponent(t)}</svg>')`;
}
function uA(t) {
  return A4e(`<path d="m0 2.5 l2 -1.5 l1 0 l2 1.5 l1 0" stroke="${t}" fill="none" stroke-width=".7"/>`, 'width="6" height="3"');
}
const k4e = /* @__PURE__ */ qt.baseTheme({
  ".cm-diagnostic": {
    padding: "3px 6px 3px 8px",
    marginLeft: "-1px",
    display: "block",
    whiteSpace: "pre-wrap"
  },
  ".cm-diagnostic-error": { borderLeft: "5px solid #d11" },
  ".cm-diagnostic-warning": { borderLeft: "5px solid orange" },
  ".cm-diagnostic-info": { borderLeft: "5px solid #999" },
  ".cm-diagnostic-hint": { borderLeft: "5px solid #66d" },
  ".cm-diagnosticAction": {
    font: "inherit",
    border: "none",
    padding: "2px 4px",
    backgroundColor: "#444",
    color: "white",
    borderRadius: "3px",
    marginLeft: "8px",
    cursor: "pointer"
  },
  ".cm-diagnosticSource": {
    fontSize: "70%",
    opacity: 0.7
  },
  ".cm-lintRange": {
    backgroundPosition: "left bottom",
    backgroundRepeat: "repeat-x",
    paddingBottom: "0.7px"
  },
  ".cm-lintRange-error": { backgroundImage: /* @__PURE__ */ uA("#d11") },
  ".cm-lintRange-warning": { backgroundImage: /* @__PURE__ */ uA("orange") },
  ".cm-lintRange-info": { backgroundImage: /* @__PURE__ */ uA("#999") },
  ".cm-lintRange-hint": { backgroundImage: /* @__PURE__ */ uA("#66d") },
  ".cm-lintRange-active": { backgroundColor: "#ffdd9980" },
  ".cm-tooltip-lint": {
    padding: 0,
    margin: 0
  },
  ".cm-lintPoint": {
    position: "relative",
    "&:after": {
      content: '""',
      position: "absolute",
      bottom: 0,
      left: "-2px",
      borderLeft: "3px solid transparent",
      borderRight: "3px solid transparent",
      borderBottom: "4px solid #d11"
    }
  },
  ".cm-lintPoint-warning": {
    "&:after": { borderBottomColor: "orange" }
  },
  ".cm-lintPoint-info": {
    "&:after": { borderBottomColor: "#999" }
  },
  ".cm-lintPoint-hint": {
    "&:after": { borderBottomColor: "#66d" }
  },
  ".cm-panel.cm-panel-lint": {
    position: "relative",
    "& ul": {
      maxHeight: "100px",
      overflowY: "auto",
      "& [aria-selected]": {
        backgroundColor: "#ddd",
        "& u": { textDecoration: "underline" }
      },
      "&:focus [aria-selected]": {
        background_fallback: "#bdf",
        backgroundColor: "Highlight",
        color_fallback: "white",
        color: "HighlightText"
      },
      "& u": { textDecoration: "none" },
      padding: 0,
      margin: 0
    },
    "& [name=close]": {
      position: "absolute",
      top: "0",
      right: "2px",
      background: "inherit",
      border: "none",
      font: "inherit",
      padding: 0,
      margin: 0
    }
  }
}), R4e = [
  Uc,
  /* @__PURE__ */ qt.decorations.compute([Uc], (t) => {
    let { selected: e, panel: n } = t.field(Uc);
    return !e || !n || e.from == e.to ? Ln.none : Ln.set([
      E4e.range(e.from, e.to)
    ]);
  }),
  /* @__PURE__ */ EPe(S4e, { hideOn: y4e }),
  k4e
];
var FK = function(e) {
  e === void 0 && (e = {});
  var {
    crosshairCursor: n = !1
  } = e, r = [];
  e.closeBracketsKeymap !== !1 && (r = r.concat(DMe)), e.defaultKeymap !== !1 && (r = r.concat(WBe)), e.searchKeymap !== !1 && (r = r.concat(h4e)), e.historyKeymap !== !1 && (r = r.concat(K$e)), e.foldKeymap !== !1 && (r = r.concat(OLe)), e.completionKeymap !== !1 && (r = r.concat(Toe)), e.lintKeymap !== !1 && (r = r.concat(C4e));
  var a = [];
  return e.lineNumbers !== !1 && a.push(RPe()), e.highlightActiveLineGutter !== !1 && a.push(NPe()), e.highlightSpecialChars !== !1 && a.push(X2e()), e.history !== !1 && a.push(W$e()), e.foldGutter !== !1 && a.push(TLe()), e.drawSelection !== !1 && a.push(B2e()), e.dropCursor !== !1 && a.push(Q2e()), e.allowMultipleSelections !== !1 && a.push(zr.allowMultipleSelections.of(!0)), e.indentOnInput !== !1 && a.push(dLe()), e.syntaxHighlighting !== !1 && a.push(n6(ALe, {
    fallback: !0
  })), e.bracketMatching !== !1 && a.push(LLe()), e.closeBrackets !== !1 && a.push(AMe()), e.autocompletion !== !1 && a.push(BMe()), e.rectangularSelection !== !1 && a.push(cPe()), n !== !1 && a.push(pPe()), e.highlightActiveLine !== !1 && a.push(nPe()), e.highlightSelectionMatches !== !1 && a.push(ZBe()), e.tabSize && typeof e.tabSize == "number" && a.push(f1.of(" ".repeat(e.tabSize))), a.concat([l1.of(r.flat())]).filter(Boolean);
};
const I4e = "#e5c07b", $K = "#e06c75", D4e = "#56b6c2", N4e = "#ffffff", Dk = "#abb2bf", t5 = "#7d8799", P4e = "#61afef", L4e = "#98c379", BK = "#d19a66", M4e = "#c678dd", F4e = "#21252b", UK = "#2c313a", zK = "#282c34", $3 = "#353a42", $4e = "#3E4451", HK = "#528bff", B4e = /* @__PURE__ */ qt.theme({
  "&": {
    color: Dk,
    backgroundColor: zK
  },
  ".cm-content": {
    caretColor: HK
  },
  ".cm-cursor, .cm-dropCursor": { borderLeftColor: HK },
  "&.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground, .cm-selectionBackground, .cm-content ::selection": { backgroundColor: $4e },
  ".cm-panels": { backgroundColor: F4e, color: Dk },
  ".cm-panels.cm-panels-top": { borderBottom: "2px solid black" },
  ".cm-panels.cm-panels-bottom": { borderTop: "2px solid black" },
  ".cm-searchMatch": {
    backgroundColor: "#72a1ff59",
    outline: "1px solid #457dff"
  },
  ".cm-searchMatch.cm-searchMatch-selected": {
    backgroundColor: "#6199ff2f"
  },
  ".cm-activeLine": { backgroundColor: "#6699ff0b" },
  ".cm-selectionMatch": { backgroundColor: "#aafe661a" },
  "&.cm-focused .cm-matchingBracket, &.cm-focused .cm-nonmatchingBracket": {
    backgroundColor: "#bad0f847"
  },
  ".cm-gutters": {
    backgroundColor: zK,
    color: t5,
    border: "none"
  },
  ".cm-activeLineGutter": {
    backgroundColor: UK
  },
  ".cm-foldPlaceholder": {
    backgroundColor: "transparent",
    border: "none",
    color: "#ddd"
  },
  ".cm-tooltip": {
    border: "none",
    backgroundColor: $3
  },
  ".cm-tooltip .cm-tooltip-arrow:before": {
    borderTopColor: "transparent",
    borderBottomColor: "transparent"
  },
  ".cm-tooltip .cm-tooltip-arrow:after": {
    borderTopColor: $3,
    borderBottomColor: $3
  },
  ".cm-tooltip-autocomplete": {
    "& > ul > li[aria-selected]": {
      backgroundColor: UK,
      color: Dk
    }
  }
}, { dark: !0 }), U4e = /* @__PURE__ */ p1.define([
  {
    tag: ge.keyword,
    color: M4e
  },
  {
    tag: [ge.name, ge.deleted, ge.character, ge.propertyName, ge.macroName],
    color: $K
  },
  {
    tag: [/* @__PURE__ */ ge.function(ge.variableName), ge.labelName],
    color: P4e
  },
  {
    tag: [ge.color, /* @__PURE__ */ ge.constant(ge.name), /* @__PURE__ */ ge.standard(ge.name)],
    color: BK
  },
  {
    tag: [/* @__PURE__ */ ge.definition(ge.name), ge.separator],
    color: Dk
  },
  {
    tag: [ge.typeName, ge.className, ge.number, ge.changed, ge.annotation, ge.modifier, ge.self, ge.namespace],
    color: I4e
  },
  {
    tag: [ge.operator, ge.operatorKeyword, ge.url, ge.escape, ge.regexp, ge.link, /* @__PURE__ */ ge.special(ge.string)],
    color: D4e
  },
  {
    tag: [ge.meta, ge.comment],
    color: t5
  },
  {
    tag: ge.strong,
    fontWeight: "bold"
  },
  {
    tag: ge.emphasis,
    fontStyle: "italic"
  },
  {
    tag: ge.strikethrough,
    textDecoration: "line-through"
  },
  {
    tag: ge.link,
    color: t5,
    textDecoration: "underline"
  },
  {
    tag: ge.heading,
    fontWeight: "bold",
    color: $K
  },
  {
    tag: [ge.atom, ge.bool, /* @__PURE__ */ ge.special(ge.variableName)],
    color: BK
  },
  {
    tag: [ge.processingInstruction, ge.string, ge.inserted],
    color: L4e
  },
  {
    tag: ge.invalid,
    color: N4e
  }
]), z4e = [B4e, /* @__PURE__ */ n6(U4e)];
var H4e = qt.theme({
  "&": {
    backgroundColor: "#fff"
  }
}, {
  dark: !1
}), W4e = function(e) {
  e === void 0 && (e = {});
  var {
    indentWithTab: n = !0,
    editable: r = !0,
    readOnly: a = !1,
    theme: i = "light",
    placeholder: o = "",
    basicSetup: s = !0
  } = e, u = [];
  switch (n && u.unshift(l1.of([QBe])), s && (typeof s == "boolean" ? u.unshift(FK()) : u.unshift(FK(s))), o && u.unshift(oPe(o)), i) {
    case "light":
      u.push(H4e);
      break;
    case "dark":
      u.push(z4e);
      break;
    case "none":
      break;
    default:
      u.push(i);
      break;
  }
  return r === !1 && u.push(qt.editable.of(!1)), a && u.push(zr.readOnly.of(!0)), [...u];
}, Q4e = (t) => ({
  line: t.state.doc.lineAt(t.state.selection.main.from),
  lineCount: t.state.doc.lines,
  lineBreak: t.state.lineBreak,
  length: t.state.doc.length,
  readOnly: t.state.readOnly,
  tabSize: t.state.tabSize,
  selection: t.state.selection,
  selectionAsSingle: t.state.selection.asSingle().main,
  ranges: t.state.selection.ranges,
  selectionCode: t.state.sliceDoc(t.state.selection.main.from, t.state.selection.main.to),
  selections: t.state.selection.ranges.map((e) => t.state.sliceDoc(e.from, e.to)),
  selectedText: t.state.selection.ranges.some((e) => !e.empty)
}), WK = Ih.define(), j4e = [];
function G4e(t) {
  var {
    value: e,
    selection: n,
    onChange: r,
    onStatistics: a,
    onCreateEditor: i,
    onUpdate: o,
    extensions: s = j4e,
    autoFocus: u,
    theme: f = "light",
    height: p = null,
    minHeight: m = null,
    maxHeight: v = null,
    width: O = null,
    minWidth: w = null,
    maxWidth: _ = null,
    placeholder: C = "",
    editable: A = !0,
    readOnly: N = !1,
    indentWithTab: P = !0,
    basicSetup: I = !0,
    root: D,
    initialState: M
  } = t, [H, Y] = kn(), [q, Q] = kn(), [ne, J] = kn(), ue = qt.theme({
    "&": {
      height: p,
      minHeight: m,
      maxHeight: v,
      width: O,
      minWidth: w,
      maxWidth: _
    },
    "& .cm-scroller": {
      height: "100% !important"
    }
  }), ee = qt.updateListener.of((ie) => {
    if (ie.docChanged && typeof r == "function" && // Fix echoing of the remote changes:
    // If transaction is market as remote we don't have to call `onChange` handler again
    !ie.transactions.some((B) => B.annotation(WK))) {
      var le = ie.state.doc, ye = le.toString();
      r(ye, ie);
    }
    a && a(Q4e(ie));
  }), fe = W4e({
    theme: f,
    editable: A,
    readOnly: N,
    placeholder: C,
    indentWithTab: P,
    basicSetup: I
  }), de = [ee, ue, ...fe];
  return o && typeof o == "function" && de.push(qt.updateListener.of(o)), de = de.concat(s), Vn(() => {
    if (H && !ne) {
      var ie = {
        doc: e,
        selection: n,
        extensions: de
      }, le = M ? zr.fromJSON(M.json, ie, M.fields) : zr.create(ie);
      if (J(le), !q) {
        var ye = new qt({
          state: le,
          parent: H,
          root: D
        });
        Q(ye), i && i(ye, le);
      }
    }
    return () => {
      q && (J(void 0), Q(void 0));
    };
  }, [H, ne]), Vn(() => Y(t.container), [t.container]), Vn(() => () => {
    q && (q.destroy(), Q(void 0));
  }, [q]), Vn(() => {
    u && q && q.focus();
  }, [u, q]), Vn(() => {
    q && q.dispatch({
      effects: fr.reconfigure.of(de)
    });
  }, [f, s, p, m, v, O, w, _, C, A, N, P, I, r, o]), Vn(() => {
    if (e !== void 0) {
      var ie = q ? q.state.doc.toString() : "";
      q && e !== ie && q.dispatch({
        changes: {
          from: 0,
          to: ie.length,
          insert: e || ""
        },
        annotations: [WK.of(!0)]
      });
    }
  }, [e, q]), {
    state: ne,
    setState: J,
    view: q,
    setView: Q,
    container: H,
    setContainer: Y
  };
}
var V4e = ["className", "value", "selection", "extensions", "onChange", "onStatistics", "onCreateEditor", "onUpdate", "autoFocus", "theme", "height", "minHeight", "maxHeight", "width", "minWidth", "maxWidth", "basicSetup", "placeholder", "indentWithTab", "editable", "readOnly", "root", "initialState"], Mle = /* @__PURE__ */ bs((t, e) => {
  var {
    className: n,
    value: r = "",
    selection: a,
    extensions: i = [],
    onChange: o,
    onStatistics: s,
    onCreateEditor: u,
    onUpdate: f,
    autoFocus: p,
    theme: m = "light",
    height: v,
    minHeight: O,
    maxHeight: w,
    width: _,
    minWidth: C,
    maxWidth: A,
    basicSetup: N,
    placeholder: P,
    indentWithTab: I,
    editable: D,
    readOnly: M,
    root: H,
    initialState: Y
  } = t, q = qb(t, V4e), Q = dr(null), {
    state: ne,
    view: J,
    container: ue
  } = G4e({
    container: Q.current,
    root: H,
    value: r,
    autoFocus: p,
    theme: m,
    height: v,
    minHeight: O,
    maxHeight: w,
    width: _,
    minWidth: C,
    maxWidth: A,
    basicSetup: N,
    placeholder: P,
    indentWithTab: I,
    editable: D,
    readOnly: M,
    selection: a,
    onChange: o,
    onStatistics: s,
    onCreateEditor: u,
    onUpdate: f,
    extensions: i,
    initialState: Y
  });
  if (Nl(e, () => ({
    editor: Q.current,
    state: ne,
    view: J
  }), [Q, ue, ne, J]), typeof r != "string")
    throw new Error("value must be typeof string but got " + typeof r);
  var ee = typeof m == "string" ? "cm-theme-" + m : "cm-theme";
  return /* @__PURE__ */ Ne.jsx("div", rn({
    ref: Q,
    className: "" + ee + (n ? " " + n : "")
  }, q));
});
Mle.displayName = "CodeMirror";
const Fle = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(t) {
    if (t == null)
      return q4e;
    if (typeof t == "function")
      return DD(t);
    if (typeof t == "object")
      return Array.isArray(t) ? Y4e(t) : Z4e(t);
    if (typeof t == "string")
      return X4e(t);
    throw new Error("Expected function, string, or object as test");
  }
);
function Y4e(t) {
  const e = [];
  let n = -1;
  for (; ++n < t.length; )
    e[n] = Fle(t[n]);
  return DD(r);
  function r(...a) {
    let i = -1;
    for (; ++i < e.length; )
      if (e[i].apply(this, a))
        return !0;
    return !1;
  }
}
function Z4e(t) {
  const e = (
    /** @type {Record<string, unknown>} */
    t
  );
  return DD(n);
  function n(r) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let i;
    for (i in t)
      if (a[i] !== e[i])
        return !1;
    return !0;
  }
}
function X4e(t) {
  return DD(e);
  function e(n) {
    return n && n.type === t;
  }
}
function DD(t) {
  return e;
  function e(n, r, a) {
    return !!(K4e(n) && t.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      a || void 0
    ));
  }
}
function q4e() {
  return !0;
}
function K4e(t) {
  return t !== null && typeof t == "object" && "type" in t;
}
const $le = [], J4e = !0, QK = !1, e5e = "skip";
function t5e(t, e, n, r) {
  let a;
  typeof e == "function" && typeof n != "function" ? (r = n, n = e) : a = e;
  const i = Fle(a), o = r ? -1 : 1;
  s(t, void 0, [])();
  function s(u, f, p) {
    const m = (
      /** @type {Record<string, unknown>} */
      u && typeof u == "object" ? u : {}
    );
    if (typeof m.type == "string") {
      const O = (
        // `hast`
        typeof m.tagName == "string" ? m.tagName : (
          // `xast`
          typeof m.name == "string" ? m.name : void 0
        )
      );
      Object.defineProperty(v, "name", {
        value: "node (" + (u.type + (O ? "<" + O + ">" : "")) + ")"
      });
    }
    return v;
    function v() {
      let O = $le, w, _, C;
      if ((!e || i(u, f, p[p.length - 1] || void 0)) && (O = n5e(n(u, p)), O[0] === QK))
        return O;
      if ("children" in u && u.children) {
        const A = (
          /** @type {UnistParent} */
          u
        );
        if (A.children && O[0] !== e5e)
          for (_ = (r ? A.children.length : -1) + o, C = p.concat(A); _ > -1 && _ < A.children.length; ) {
            const N = A.children[_];
            if (w = s(N, _, C)(), w[0] === QK)
              return w;
            _ = typeof w[1] == "number" ? w[1] : _ + o;
          }
      }
      return O;
    }
  }
}
function n5e(t) {
  return Array.isArray(t) ? t : typeof t == "number" ? [J4e, t] : t == null ? $le : [t];
}
function r5e(t, e, n, r) {
  let a, i, o;
  typeof e == "function" && typeof n != "function" ? (i = void 0, o = e, a = n) : (i = e, o = n, a = r), t5e(t, i, s, a);
  function s(u, f) {
    const p = f[f.length - 1], m = p ? p.children.indexOf(u) : void 0;
    return o(u, m, p);
  }
}
function OE(t) {
  return "children" in t ? Ble(t) : "value" in t ? t.value : "";
}
function a5e(t) {
  return t.type === "text" ? t.value : "children" in t ? Ble(t) : "";
}
function Ble(t) {
  let e = -1;
  const n = [];
  for (; ++e < t.children.length; )
    n[e] = a5e(t.children[e]);
  return n.join("");
}
const Ule = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(t) {
    if (t == null)
      return l5e;
    if (typeof t == "function")
      return ND(t);
    if (typeof t == "object")
      return Array.isArray(t) ? i5e(t) : o5e(t);
    if (typeof t == "string")
      return s5e(t);
    throw new Error("Expected function, string, or object as test");
  }
);
function i5e(t) {
  const e = [];
  let n = -1;
  for (; ++n < t.length; )
    e[n] = Ule(t[n]);
  return ND(r);
  function r(...a) {
    let i = -1;
    for (; ++i < e.length; )
      if (e[i].apply(this, a))
        return !0;
    return !1;
  }
}
function o5e(t) {
  const e = (
    /** @type {Record<string, unknown>} */
    t
  );
  return ND(n);
  function n(r) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let i;
    for (i in t)
      if (a[i] !== e[i])
        return !1;
    return !0;
  }
}
function s5e(t) {
  return ND(e);
  function e(n) {
    return n && n.type === t;
  }
}
function ND(t) {
  return e;
  function e(n, r, a) {
    return !!(u5e(n) && t.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      a || void 0
    ));
  }
}
function l5e() {
  return !0;
}
function u5e(t) {
  return t !== null && typeof t == "object" && "type" in t;
}
const c5e = {}.hasOwnProperty;
function f5e(t, e, n) {
  const r = Ule(n || e), a = e && typeof e == "object" && "cascade" in e ? (
    /** @type {boolean | null | undefined} */
    e.cascade
  ) : void 0, i = a ?? !0;
  return o(t);
  function o(s, u, f) {
    const p = [];
    if (!r(s, u, f))
      return;
    if (d5e(s)) {
      let O = -1;
      for (; ++O < s.children.length; ) {
        const w = o(s.children[O], O, s);
        w && p.push(w);
      }
      if (i && s.children.length > 0 && p.length === 0)
        return;
    }
    const m = {};
    let v;
    for (v in s)
      c5e.call(s, v) && (m[v] = v === "children" ? p : s[v]);
    return m;
  }
}
function d5e(t) {
  return "children" in t && t.children !== void 0;
}
var n5 = { exports: {} };
(function(t, e) {
  function n(r) {
    let a = [], i;
    for (let o of r.split(",").map((s) => s.trim()))
      if (/^-?\d+$/.test(o))
        a.push(parseInt(o, 10));
      else if (i = o.match(/^(-?\d+)(-|\.\.\.?|\u2025|\u2026|\u22EF)(-?\d+)$/)) {
        let [s, u, f, p] = i;
        if (u && p) {
          u = parseInt(u), p = parseInt(p);
          const m = u < p ? 1 : -1;
          (f === "-" || f === ".." || f === "‥") && (p += m);
          for (let v = u; v !== p; v += m)
            a.push(v);
        }
      }
    return a;
  }
  e.default = n, t.exports = n;
})(n5, n5.exports);
var p5e = n5.exports;
const h5e = /* @__PURE__ */ Pl(p5e);
Lr.displayName = "clike";
Lr.aliases = [];
function Lr(t) {
  t.languages.clike = {
    comment: [
      {
        pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
        lookbehind: !0,
        greedy: !0
      },
      {
        pattern: /(^|[^\\:])\/\/.*/,
        lookbehind: !0,
        greedy: !0
      }
    ],
    string: {
      pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
      greedy: !0
    },
    "class-name": {
      pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
      lookbehind: !0,
      inside: {
        punctuation: /[.\\]/
      }
    },
    keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
    boolean: /\b(?:false|true)\b/,
    function: /\b\w+(?=\()/,
    number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
    punctuation: /[{}[\];(),.:]/
  };
}
tp.displayName = "c";
tp.aliases = [];
function tp(t) {
  t.register(Lr), t.languages.c = t.languages.extend("clike", {
    comment: {
      pattern: /\/\/(?:[^\r\n\\]|\\(?:\r\n?|\n|(?![\r\n])))*|\/\*[\s\S]*?(?:\*\/|$)/,
      greedy: !0
    },
    string: {
      // https://en.cppreference.com/w/c/language/string_literal
      pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
      greedy: !0
    },
    "class-name": {
      pattern: /(\b(?:enum|struct)\s+(?:__attribute__\s*\(\([\s\S]*?\)\)\s*)?)\w+|\b[a-z]\w*_t\b/,
      lookbehind: !0
    },
    keyword: /\b(?:_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|__attribute__|asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|inline|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|typeof|union|unsigned|void|volatile|while)\b/,
    function: /\b[a-z_]\w*(?=\s*\()/i,
    number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i,
    operator: />>=?|<<=?|->|([-+&|:])\1|[?:~]|[-+*/%&|^!=<>]=?/
  }), t.languages.insertBefore("c", "string", {
    char: {
      // https://en.cppreference.com/w/c/language/character_constant
      pattern: /'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n]){0,32}'/,
      greedy: !0
    }
  }), t.languages.insertBefore("c", "string", {
    macro: {
      // allow for multiline macro definitions
      // spaces after the # character compile fine with gcc
      pattern: /(^[\t ]*)#\s*[a-z](?:[^\r\n\\/]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|\\(?:\r\n|[\s\S]))*/im,
      lookbehind: !0,
      greedy: !0,
      alias: "property",
      inside: {
        string: [
          {
            // highlight the path of the include statement as a string
            pattern: /^(#\s*include\s*)<[^>]+>/,
            lookbehind: !0
          },
          t.languages.c.string
        ],
        char: t.languages.c.char,
        comment: t.languages.c.comment,
        "macro-name": [
          {
            pattern: /(^#\s*define\s+)\w+\b(?!\()/i,
            lookbehind: !0
          },
          {
            pattern: /(^#\s*define\s+)\w+\b(?=\()/i,
            lookbehind: !0,
            alias: "function"
          }
        ],
        // highlight macro directives as keywords
        directive: {
          pattern: /^(#\s*)[a-z]+/,
          lookbehind: !0,
          alias: "keyword"
        },
        "directive-hash": /^#/,
        punctuation: /##|\\(?=[\r\n])/,
        expression: {
          pattern: /\S[\s\S]*/,
          inside: t.languages.c
        }
      }
    }
  }), t.languages.insertBefore("c", "function", {
    // highlight predefined macros as constants
    constant: /\b(?:EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|__DATE__|__FILE__|__LINE__|__TIMESTAMP__|__TIME__|__func__|stderr|stdin|stdout)\b/
  }), delete t.languages.c.boolean;
}
x0.displayName = "cpp";
x0.aliases = [];
function x0(t) {
  t.register(tp), function(e) {
    var n = /\b(?:alignas|alignof|asm|auto|bool|break|case|catch|char|char16_t|char32_t|char8_t|class|co_await|co_return|co_yield|compl|concept|const|const_cast|consteval|constexpr|constinit|continue|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|final|float|for|friend|goto|if|import|inline|int|int16_t|int32_t|int64_t|int8_t|long|module|mutable|namespace|new|noexcept|nullptr|operator|override|private|protected|public|register|reinterpret_cast|requires|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|uint16_t|uint32_t|uint64_t|uint8_t|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/, r = /\b(?!<keyword>)\w+(?:\s*\.\s*\w+)*\b/.source.replace(
      /<keyword>/g,
      function() {
        return n.source;
      }
    );
    e.languages.cpp = e.languages.extend("c", {
      "class-name": [
        {
          pattern: RegExp(
            /(\b(?:class|concept|enum|struct|typename)\s+)(?!<keyword>)\w+/.source.replace(
              /<keyword>/g,
              function() {
                return n.source;
              }
            )
          ),
          lookbehind: !0
        },
        // This is intended to capture the class name of method implementations like:
        //   void foo::bar() const {}
        // However! The `foo` in the above example could also be a namespace, so we only capture the class name if
        // it starts with an uppercase letter. This approximation should give decent results.
        /\b[A-Z]\w*(?=\s*::\s*\w+\s*\()/,
        // This will capture the class name before destructors like:
        //   Foo::~Foo() {}
        /\b[A-Z_]\w*(?=\s*::\s*~\w+\s*\()/i,
        // This also intends to capture the class name of method implementations but here the class has template
        // parameters, so it can't be a namespace (until C++ adds generic namespaces).
        /\b\w+(?=\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>\s*::\s*\w+\s*\()/
      ],
      keyword: n,
      number: {
        pattern: /(?:\b0b[01']+|\b0x(?:[\da-f']+(?:\.[\da-f']*)?|\.[\da-f']+)(?:p[+-]?[\d']+)?|(?:\b[\d']+(?:\.[\d']*)?|\B\.[\d']+)(?:e[+-]?[\d']+)?)[ful]{0,4}/i,
        greedy: !0
      },
      operator: />>=?|<<=?|->|--|\+\+|&&|\|\||[?:~]|<=>|[-+*/%&|^!=<>]=?|\b(?:and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/,
      boolean: /\b(?:false|true)\b/
    }), e.languages.insertBefore("cpp", "string", {
      module: {
        // https://en.cppreference.com/w/cpp/language/modules
        pattern: RegExp(
          /(\b(?:import|module)\s+)/.source + "(?:" + // header-name
          /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|<[^<>\r\n]*>/.source + "|" + // module name or partition or both
          /<mod-name>(?:\s*:\s*<mod-name>)?|:\s*<mod-name>/.source.replace(
            /<mod-name>/g,
            function() {
              return r;
            }
          ) + ")"
        ),
        lookbehind: !0,
        greedy: !0,
        inside: {
          string: /^[<"][\s\S]+/,
          operator: /:/,
          punctuation: /\./
        }
      },
      "raw-string": {
        pattern: /R"([^()\\ ]{0,16})\([\s\S]*?\)\1"/,
        alias: "string",
        greedy: !0
      }
    }), e.languages.insertBefore("cpp", "keyword", {
      "generic-function": {
        pattern: /\b(?!operator\b)[a-z_]\w*\s*<(?:[^<>]|<[^<>]*>)*>(?=\s*\()/i,
        inside: {
          function: /^\w+/,
          generic: {
            pattern: /<[\s\S]+/,
            alias: "class-name",
            inside: e.languages.cpp
          }
        }
      }
    }), e.languages.insertBefore("cpp", "operator", {
      "double-colon": {
        pattern: /::/,
        alias: "punctuation"
      }
    }), e.languages.insertBefore("cpp", "class-name", {
      // the base clause is an optional list of parent classes
      // https://en.cppreference.com/w/cpp/language/class
      "base-clause": {
        pattern: /(\b(?:class|struct)\s+\w+\s*:\s*)[^;{}"'\s]+(?:\s+[^;{}"'\s]+)*(?=\s*[;{])/,
        lookbehind: !0,
        greedy: !0,
        inside: e.languages.extend("cpp", {})
      }
    }), e.languages.insertBefore(
      "inside",
      "double-colon",
      {
        // All untokenized words that are not namespaces should be class names
        "class-name": /\b[a-z_]\w*\b(?!\s*::)/i
      },
      e.languages.cpp["base-clause"]
    );
  }(t);
}
PD.displayName = "arduino";
PD.aliases = ["ino"];
function PD(t) {
  t.register(x0), t.languages.arduino = t.languages.extend("cpp", {
    keyword: /\b(?:String|array|bool|boolean|break|byte|case|catch|continue|default|do|double|else|finally|for|function|goto|if|in|instanceof|int|integer|long|loop|new|null|return|setup|string|switch|throw|try|void|while|word)\b/,
    constant: /\b(?:ANALOG_MESSAGE|DEFAULT|DIGITAL_MESSAGE|EXTERNAL|FIRMATA_STRING|HIGH|INPUT|INPUT_PULLUP|INTERNAL|INTERNAL1V1|INTERNAL2V56|LED_BUILTIN|LOW|OUTPUT|REPORT_ANALOG|REPORT_DIGITAL|SET_PIN_MODE|SYSEX_START|SYSTEM_RESET)\b/,
    builtin: /\b(?:Audio|BSSID|Bridge|Client|Console|EEPROM|Esplora|EsploraTFT|Ethernet|EthernetClient|EthernetServer|EthernetUDP|File|FileIO|FileSystem|Firmata|GPRS|GSM|GSMBand|GSMClient|GSMModem|GSMPIN|GSMScanner|GSMServer|GSMVoiceCall|GSM_SMS|HttpClient|IPAddress|IRread|Keyboard|KeyboardController|LiquidCrystal|LiquidCrystal_I2C|Mailbox|Mouse|MouseController|PImage|Process|RSSI|RobotControl|RobotMotor|SD|SPI|SSID|Scheduler|Serial|Server|Servo|SoftwareSerial|Stepper|Stream|TFT|Task|USBHost|WiFi|WiFiClient|WiFiServer|WiFiUDP|Wire|YunClient|YunServer|abs|addParameter|analogRead|analogReadResolution|analogReference|analogWrite|analogWriteResolution|answerCall|attach|attachGPRS|attachInterrupt|attached|autoscroll|available|background|beep|begin|beginPacket|beginSD|beginSMS|beginSpeaker|beginTFT|beginTransmission|beginWrite|bit|bitClear|bitRead|bitSet|bitWrite|blink|blinkVersion|buffer|changePIN|checkPIN|checkPUK|checkReg|circle|cityNameRead|cityNameWrite|clear|clearScreen|click|close|compassRead|config|connect|connected|constrain|cos|countryNameRead|countryNameWrite|createChar|cursor|debugPrint|delay|delayMicroseconds|detach|detachInterrupt|digitalRead|digitalWrite|disconnect|display|displayLogos|drawBMP|drawCompass|encryptionType|end|endPacket|endSMS|endTransmission|endWrite|exists|exitValue|fill|find|findUntil|flush|gatewayIP|get|getAsynchronously|getBand|getButton|getCurrentCarrier|getIMEI|getKey|getModifiers|getOemKey|getPINUsed|getResult|getSignalStrength|getSocket|getVoiceCallStatus|getXChange|getYChange|hangCall|height|highByte|home|image|interrupts|isActionDone|isDirectory|isListening|isPIN|isPressed|isValid|keyPressed|keyReleased|keyboardRead|knobRead|leftToRight|line|lineFollowConfig|listen|listenOnLocalhost|loadImage|localIP|lowByte|macAddress|maintain|map|max|messageAvailable|micros|millis|min|mkdir|motorsStop|motorsWrite|mouseDragged|mouseMoved|mousePressed|mouseReleased|move|noAutoscroll|noBlink|noBuffer|noCursor|noDisplay|noFill|noInterrupts|noListenOnLocalhost|noStroke|noTone|onReceive|onRequest|open|openNextFile|overflow|parseCommand|parseFloat|parseInt|parsePacket|pauseMode|peek|pinMode|playFile|playMelody|point|pointTo|position|pow|prepare|press|print|printFirmwareVersion|printVersion|println|process|processInput|pulseIn|put|random|randomSeed|read|readAccelerometer|readBlue|readButton|readBytes|readBytesUntil|readGreen|readJoystickButton|readJoystickSwitch|readJoystickX|readJoystickY|readLightSensor|readMessage|readMicrophone|readNetworks|readRed|readSlider|readString|readStringUntil|readTemperature|ready|rect|release|releaseAll|remoteIP|remoteNumber|remotePort|remove|requestFrom|retrieveCallingNumber|rewindDirectory|rightToLeft|rmdir|robotNameRead|robotNameWrite|run|runAsynchronously|runShellCommand|runShellCommandAsynchronously|running|scanNetworks|scrollDisplayLeft|scrollDisplayRight|seek|sendAnalog|sendDigitalPortPair|sendDigitalPorts|sendString|sendSysex|serialEvent|setBand|setBitOrder|setClockDivider|setCursor|setDNS|setDataMode|setFirmwareVersion|setMode|setPINUsed|setSpeed|setTextSize|setTimeout|shiftIn|shiftOut|shutdown|sin|size|sqrt|startLoop|step|stop|stroke|subnetMask|switchPIN|tan|tempoWrite|text|tone|transfer|tuneWrite|turn|updateIR|userNameRead|userNameWrite|voiceCall|waitContinue|width|write|writeBlue|writeGreen|writeJSON|writeMessage|writeMicroseconds|writeRGB|writeRed|yield)\b/
  }), t.languages.ino = t.languages.arduino;
}
x_.displayName = "bash";
x_.aliases = ["sh", "shell"];
function x_(t) {
  (function(e) {
    var n = "\\b(?:BASH|BASHOPTS|BASH_ALIASES|BASH_ARGC|BASH_ARGV|BASH_CMDS|BASH_COMPLETION_COMPAT_DIR|BASH_LINENO|BASH_REMATCH|BASH_SOURCE|BASH_VERSINFO|BASH_VERSION|COLORTERM|COLUMNS|COMP_WORDBREAKS|DBUS_SESSION_BUS_ADDRESS|DEFAULTS_PATH|DESKTOP_SESSION|DIRSTACK|DISPLAY|EUID|GDMSESSION|GDM_LANG|GNOME_KEYRING_CONTROL|GNOME_KEYRING_PID|GPG_AGENT_INFO|GROUPS|HISTCONTROL|HISTFILE|HISTFILESIZE|HISTSIZE|HOME|HOSTNAME|HOSTTYPE|IFS|INSTANCE|JOB|LANG|LANGUAGE|LC_ADDRESS|LC_ALL|LC_IDENTIFICATION|LC_MEASUREMENT|LC_MONETARY|LC_NAME|LC_NUMERIC|LC_PAPER|LC_TELEPHONE|LC_TIME|LESSCLOSE|LESSOPEN|LINES|LOGNAME|LS_COLORS|MACHTYPE|MAILCHECK|MANDATORY_PATH|NO_AT_BRIDGE|OLDPWD|OPTERR|OPTIND|ORBIT_SOCKETDIR|OSTYPE|PAPERSIZE|PATH|PIPESTATUS|PPID|PS1|PS2|PS3|PS4|PWD|RANDOM|REPLY|SECONDS|SELINUX_INIT|SESSION|SESSIONTYPE|SESSION_MANAGER|SHELL|SHELLOPTS|SHLVL|SSH_AUTH_SOCK|TERM|UID|UPSTART_EVENTS|UPSTART_INSTANCE|UPSTART_JOB|UPSTART_SESSION|USER|WINDOWID|XAUTHORITY|XDG_CONFIG_DIRS|XDG_CURRENT_DESKTOP|XDG_DATA_DIRS|XDG_GREETER_DATA_DIR|XDG_MENU_PREFIX|XDG_RUNTIME_DIR|XDG_SEAT|XDG_SEAT_PATH|XDG_SESSION_DESKTOP|XDG_SESSION_ID|XDG_SESSION_PATH|XDG_SESSION_TYPE|XDG_VTNR|XMODIFIERS)\\b", r = {
      pattern: /(^(["']?)\w+\2)[ \t]+\S.*/,
      lookbehind: !0,
      alias: "punctuation",
      // this looks reasonably well in all themes
      inside: null
      // see below
    }, a = {
      bash: r,
      environment: {
        pattern: RegExp("\\$" + n),
        alias: "constant"
      },
      variable: [
        // [0]: Arithmetic Environment
        {
          pattern: /\$?\(\([\s\S]+?\)\)/,
          greedy: !0,
          inside: {
            // If there is a $ sign at the beginning highlight $(( and )) as variable
            variable: [
              {
                pattern: /(^\$\(\([\s\S]+)\)\)/,
                lookbehind: !0
              },
              /^\$\(\(/
            ],
            number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
            // Operators according to https://www.gnu.org/software/bash/manual/bashref.html#Shell-Arithmetic
            operator: /--|\+\+|\*\*=?|<<=?|>>=?|&&|\|\||[=!+\-*/%<>^&|]=?|[?~:]/,
            // If there is no $ sign at the beginning highlight (( and )) as punctuation
            punctuation: /\(\(?|\)\)?|,|;/
          }
        },
        // [1]: Command Substitution
        {
          pattern: /\$\((?:\([^)]+\)|[^()])+\)|`[^`]+`/,
          greedy: !0,
          inside: {
            variable: /^\$\(|^`|\)$|`$/
          }
        },
        // [2]: Brace expansion
        {
          pattern: /\$\{[^}]+\}/,
          greedy: !0,
          inside: {
            operator: /:[-=?+]?|[!\/]|##?|%%?|\^\^?|,,?/,
            punctuation: /[\[\]]/,
            environment: {
              pattern: RegExp("(\\{)" + n),
              lookbehind: !0,
              alias: "constant"
            }
          }
        },
        /\$(?:\w+|[#?*!@$])/
      ],
      // Escape sequences from echo and printf's manuals, and escaped quotes.
      entity: /\\(?:[abceEfnrtv\\"]|O?[0-7]{1,3}|U[0-9a-fA-F]{8}|u[0-9a-fA-F]{4}|x[0-9a-fA-F]{1,2})/
    };
    e.languages.bash = {
      shebang: {
        pattern: /^#!\s*\/.*/,
        alias: "important"
      },
      comment: {
        pattern: /(^|[^"{\\$])#.*/,
        lookbehind: !0
      },
      "function-name": [
        // a) function foo {
        // b) foo() {
        // c) function foo() {
        // but not “foo {”
        {
          // a) and c)
          pattern: /(\bfunction\s+)[\w-]+(?=(?:\s*\(?:\s*\))?\s*\{)/,
          lookbehind: !0,
          alias: "function"
        },
        {
          // b)
          pattern: /\b[\w-]+(?=\s*\(\s*\)\s*\{)/,
          alias: "function"
        }
      ],
      // Highlight variable names as variables in for and select beginnings.
      "for-or-select": {
        pattern: /(\b(?:for|select)\s+)\w+(?=\s+in\s)/,
        alias: "variable",
        lookbehind: !0
      },
      // Highlight variable names as variables in the left-hand part
      // of assignments (“=” and “+=”).
      "assign-left": {
        pattern: /(^|[\s;|&]|[<>]\()\w+(?:\.\w+)*(?=\+?=)/,
        inside: {
          environment: {
            pattern: RegExp("(^|[\\s;|&]|[<>]\\()" + n),
            lookbehind: !0,
            alias: "constant"
          }
        },
        alias: "variable",
        lookbehind: !0
      },
      // Highlight parameter names as variables
      parameter: {
        pattern: /(^|\s)-{1,2}(?:\w+:[+-]?)?\w+(?:\.\w+)*(?=[=\s]|$)/,
        alias: "variable",
        lookbehind: !0
      },
      string: [
        // Support for Here-documents https://en.wikipedia.org/wiki/Here_document
        {
          pattern: /((?:^|[^<])<<-?\s*)(\w+)\s[\s\S]*?(?:\r?\n|\r)\2/,
          lookbehind: !0,
          greedy: !0,
          inside: a
        },
        // Here-document with quotes around the tag
        // → No expansion (so no “inside”).
        {
          pattern: /((?:^|[^<])<<-?\s*)(["'])(\w+)\2\s[\s\S]*?(?:\r?\n|\r)\3/,
          lookbehind: !0,
          greedy: !0,
          inside: {
            bash: r
          }
        },
        // “Normal” string
        {
          // https://www.gnu.org/software/bash/manual/html_node/Double-Quotes.html
          pattern: /(^|[^\\](?:\\\\)*)"(?:\\[\s\S]|\$\([^)]+\)|\$(?!\()|`[^`]+`|[^"\\`$])*"/,
          lookbehind: !0,
          greedy: !0,
          inside: a
        },
        {
          // https://www.gnu.org/software/bash/manual/html_node/Single-Quotes.html
          pattern: /(^|[^$\\])'[^']*'/,
          lookbehind: !0,
          greedy: !0
        },
        {
          // https://www.gnu.org/software/bash/manual/html_node/ANSI_002dC-Quoting.html
          pattern: /\$'(?:[^'\\]|\\[\s\S])*'/,
          greedy: !0,
          inside: {
            entity: a.entity
          }
        }
      ],
      environment: {
        pattern: RegExp("\\$?" + n),
        alias: "constant"
      },
      variable: a.variable,
      function: {
        pattern: /(^|[\s;|&]|[<>]\()(?:add|apropos|apt|apt-cache|apt-get|aptitude|aspell|automysqlbackup|awk|basename|bash|bc|bconsole|bg|bzip2|cal|cargo|cat|cfdisk|chgrp|chkconfig|chmod|chown|chroot|cksum|clear|cmp|column|comm|composer|cp|cron|crontab|csplit|curl|cut|date|dc|dd|ddrescue|debootstrap|df|diff|diff3|dig|dir|dircolors|dirname|dirs|dmesg|docker|docker-compose|du|egrep|eject|env|ethtool|expand|expect|expr|fdformat|fdisk|fg|fgrep|file|find|fmt|fold|format|free|fsck|ftp|fuser|gawk|git|gparted|grep|groupadd|groupdel|groupmod|groups|grub-mkconfig|gzip|halt|head|hg|history|host|hostname|htop|iconv|id|ifconfig|ifdown|ifup|import|install|ip|java|jobs|join|kill|killall|less|link|ln|locate|logname|logrotate|look|lpc|lpr|lprint|lprintd|lprintq|lprm|ls|lsof|lynx|make|man|mc|mdadm|mkconfig|mkdir|mke2fs|mkfifo|mkfs|mkisofs|mknod|mkswap|mmv|more|most|mount|mtools|mtr|mutt|mv|nano|nc|netstat|nice|nl|node|nohup|notify-send|npm|nslookup|op|open|parted|passwd|paste|pathchk|ping|pkill|pnpm|podman|podman-compose|popd|pr|printcap|printenv|ps|pushd|pv|quota|quotacheck|quotactl|ram|rar|rcp|reboot|remsync|rename|renice|rev|rm|rmdir|rpm|rsync|scp|screen|sdiff|sed|sendmail|seq|service|sftp|sh|shellcheck|shuf|shutdown|sleep|slocate|sort|split|ssh|stat|strace|su|sudo|sum|suspend|swapon|sync|sysctl|tac|tail|tar|tee|time|timeout|top|touch|tr|traceroute|tsort|tty|umount|uname|unexpand|uniq|units|unrar|unshar|unzip|update-grub|uptime|useradd|userdel|usermod|users|uudecode|uuencode|v|vcpkg|vdir|vi|vim|virsh|vmstat|wait|watch|wc|wget|whereis|which|who|whoami|write|xargs|xdg-open|yarn|yes|zenity|zip|zsh|zypper)(?=$|[)\s;|&])/,
        lookbehind: !0
      },
      keyword: {
        pattern: /(^|[\s;|&]|[<>]\()(?:case|do|done|elif|else|esac|fi|for|function|if|in|select|then|until|while)(?=$|[)\s;|&])/,
        lookbehind: !0
      },
      // https://www.gnu.org/software/bash/manual/html_node/Shell-Builtin-Commands.html
      builtin: {
        pattern: /(^|[\s;|&]|[<>]\()(?:\.|:|alias|bind|break|builtin|caller|cd|command|continue|declare|echo|enable|eval|exec|exit|export|getopts|hash|help|let|local|logout|mapfile|printf|pwd|read|readarray|readonly|return|set|shift|shopt|source|test|times|trap|type|typeset|ulimit|umask|unalias|unset)(?=$|[)\s;|&])/,
        lookbehind: !0,
        // Alias added to make those easier to distinguish from strings.
        alias: "class-name"
      },
      boolean: {
        pattern: /(^|[\s;|&]|[<>]\()(?:false|true)(?=$|[)\s;|&])/,
        lookbehind: !0
      },
      "file-descriptor": {
        pattern: /\B&\d\b/,
        alias: "important"
      },
      operator: {
        // Lots of redirections here, but not just that.
        pattern: /\d?<>|>\||\+=|=[=~]?|!=?|<<[<-]?|[&\d]?>>|\d[<>]&?|[<>][&=]?|&[>&]?|\|[&|]?/,
        inside: {
          "file-descriptor": {
            pattern: /^\d/,
            alias: "important"
          }
        }
      },
      punctuation: /\$?\(\(?|\)\)?|\.\.|[{}[\];\\]/,
      number: {
        pattern: /(^|\s)(?:[1-9]\d*|0)(?:[.,]\d+)?\b/,
        lookbehind: !0
      }
    }, r.inside = e.languages.bash;
    for (var i = [
      "comment",
      "function-name",
      "for-or-select",
      "assign-left",
      "parameter",
      "string",
      "environment",
      "function",
      "keyword",
      "builtin",
      "boolean",
      "file-descriptor",
      "operator",
      "punctuation",
      "number"
    ], o = a.variable[1].inside, s = 0; s < i.length; s++)
      o[i[s]] = e.languages.bash[i[s]];
    e.languages.sh = e.languages.bash, e.languages.shell = e.languages.bash;
  })(t);
}
A0.displayName = "csharp";
A0.aliases = ["cs", "dotnet"];
function A0(t) {
  t.register(Lr), function(e) {
    function n(B, pe) {
      return B.replace(/<<(\d+)>>/g, function(_e, Z) {
        return "(?:" + pe[+Z] + ")";
      });
    }
    function r(B, pe, _e) {
      return RegExp(n(B, pe), _e || "");
    }
    function a(B, pe) {
      for (var _e = 0; _e < pe; _e++)
        B = B.replace(/<<self>>/g, function() {
          return "(?:" + B + ")";
        });
      return B.replace(/<<self>>/g, "[^\\s\\S]");
    }
    var i = {
      // keywords which represent a return or variable type
      type: "bool byte char decimal double dynamic float int long object sbyte short string uint ulong ushort var void",
      // keywords which are used to declare a type
      typeDeclaration: "class enum interface record struct",
      // contextual keywords
      // ("var" and "dynamic" are missing because they are used like types)
      contextual: "add alias and ascending async await by descending from(?=\\s*(?:\\w|$)) get global group into init(?=\\s*;) join let nameof not notnull on or orderby partial remove select set unmanaged value when where with(?=\\s*{)",
      // all other keywords
      other: "abstract as base break case catch checked const continue default delegate do else event explicit extern finally fixed for foreach goto if implicit in internal is lock namespace new null operator out override params private protected public readonly ref return sealed sizeof stackalloc static switch this throw try typeof unchecked unsafe using virtual volatile while yield"
    };
    function o(B) {
      return "\\b(?:" + B.trim().replace(/ /g, "|") + ")\\b";
    }
    var s = o(
      i.typeDeclaration
    ), u = RegExp(
      o(
        i.type + " " + i.typeDeclaration + " " + i.contextual + " " + i.other
      )
    ), f = o(
      i.typeDeclaration + " " + i.contextual + " " + i.other
    ), p = o(
      i.type + " " + i.typeDeclaration + " " + i.other
    ), m = a(/<(?:[^<>;=+\-*/%&|^]|<<self>>)*>/.source, 2), v = a(/\((?:[^()]|<<self>>)*\)/.source, 2), O = /@?\b[A-Za-z_]\w*\b/.source, w = n(/<<0>>(?:\s*<<1>>)?/.source, [O, m]), _ = n(/(?!<<0>>)<<1>>(?:\s*\.\s*<<1>>)*/.source, [
      f,
      w
    ]), C = /\[\s*(?:,\s*)*\]/.source, A = n(
      /<<0>>(?:\s*(?:\?\s*)?<<1>>)*(?:\s*\?)?/.source,
      [_, C]
    ), N = n(
      /[^,()<>[\];=+\-*/%&|^]|<<0>>|<<1>>|<<2>>/.source,
      [m, v, C]
    ), P = n(/\(<<0>>+(?:,<<0>>+)+\)/.source, [N]), I = n(
      /(?:<<0>>|<<1>>)(?:\s*(?:\?\s*)?<<2>>)*(?:\s*\?)?/.source,
      [P, _, C]
    ), D = {
      keyword: u,
      punctuation: /[<>()?,.:[\]]/
    }, M = /'(?:[^\r\n'\\]|\\.|\\[Uux][\da-fA-F]{1,8})'/.source, H = /"(?:\\.|[^\\"\r\n])*"/.source, Y = /@"(?:""|\\[\s\S]|[^\\"])*"(?!")/.source;
    e.languages.csharp = e.languages.extend("clike", {
      string: [
        {
          pattern: r(/(^|[^$\\])<<0>>/.source, [Y]),
          lookbehind: !0,
          greedy: !0
        },
        {
          pattern: r(/(^|[^@$\\])<<0>>/.source, [H]),
          lookbehind: !0,
          greedy: !0
        }
      ],
      "class-name": [
        {
          // Using static
          // using static System.Math;
          pattern: r(/(\busing\s+static\s+)<<0>>(?=\s*;)/.source, [
            _
          ]),
          lookbehind: !0,
          inside: D
        },
        {
          // Using alias (type)
          // using Project = PC.MyCompany.Project;
          pattern: r(/(\busing\s+<<0>>\s*=\s*)<<1>>(?=\s*;)/.source, [
            O,
            I
          ]),
          lookbehind: !0,
          inside: D
        },
        {
          // Using alias (alias)
          // using Project = PC.MyCompany.Project;
          pattern: r(/(\busing\s+)<<0>>(?=\s*=)/.source, [O]),
          lookbehind: !0
        },
        {
          // Type declarations
          // class Foo<A, B>
          // interface Foo<out A, B>
          pattern: r(/(\b<<0>>\s+)<<1>>/.source, [
            s,
            w
          ]),
          lookbehind: !0,
          inside: D
        },
        {
          // Single catch exception declaration
          // catch(Foo)
          // (things like catch(Foo e) is covered by variable declaration)
          pattern: r(/(\bcatch\s*\(\s*)<<0>>/.source, [_]),
          lookbehind: !0,
          inside: D
        },
        {
          // Name of the type parameter of generic constraints
          // where Foo : class
          pattern: r(/(\bwhere\s+)<<0>>/.source, [O]),
          lookbehind: !0
        },
        {
          // Casts and checks via as and is.
          // as Foo<A>, is Bar<B>
          // (things like if(a is Foo b) is covered by variable declaration)
          pattern: r(/(\b(?:is(?:\s+not)?|as)\s+)<<0>>/.source, [
            A
          ]),
          lookbehind: !0,
          inside: D
        },
        {
          // Variable, field and parameter declaration
          // (Foo bar, Bar baz, Foo[,,] bay, Foo<Bar, FooBar<Bar>> bax)
          pattern: r(
            /\b<<0>>(?=\s+(?!<<1>>|with\s*\{)<<2>>(?:\s*[=,;:{)\]]|\s+(?:in|when)\b))/.source,
            [I, p, O]
          ),
          inside: D
        }
      ],
      keyword: u,
      // https://docs.microsoft.com/en-us/dotnet/csharp/language-reference/language-specification/lexical-structure#literals
      number: /(?:\b0(?:x[\da-f_]*[\da-f]|b[01_]*[01])|(?:\B\.\d+(?:_+\d+)*|\b\d+(?:_+\d+)*(?:\.\d+(?:_+\d+)*)?)(?:e[-+]?\d+(?:_+\d+)*)?)(?:[dflmu]|lu|ul)?\b/i,
      operator: />>=?|<<=?|[-=]>|([-+&|])\1|~|\?\?=?|[-+*/%&|^!=<>]=?/,
      punctuation: /\?\.?|::|[{}[\];(),.:]/
    }), e.languages.insertBefore("csharp", "number", {
      range: {
        pattern: /\.\./,
        alias: "operator"
      }
    }), e.languages.insertBefore("csharp", "punctuation", {
      "named-parameter": {
        pattern: r(/([(,]\s*)<<0>>(?=\s*:)/.source, [O]),
        lookbehind: !0,
        alias: "punctuation"
      }
    }), e.languages.insertBefore("csharp", "class-name", {
      namespace: {
        // namespace Foo.Bar {}
        // using Foo.Bar;
        pattern: r(
          /(\b(?:namespace|using)\s+)<<0>>(?:\s*\.\s*<<0>>)*(?=\s*[;{])/.source,
          [O]
        ),
        lookbehind: !0,
        inside: {
          punctuation: /\./
        }
      },
      "type-expression": {
        // default(Foo), typeof(Foo<Bar>), sizeof(int)
        pattern: r(
          /(\b(?:default|sizeof|typeof)\s*\(\s*(?!\s))(?:[^()\s]|\s(?!\s)|<<0>>)*(?=\s*\))/.source,
          [v]
        ),
        lookbehind: !0,
        alias: "class-name",
        inside: D
      },
      "return-type": {
        // Foo<Bar> ForBar(); Foo IFoo.Bar() => 0
        // int this[int index] => 0; T IReadOnlyList<T>.this[int index] => this[index];
        // int Foo => 0; int Foo { get; set } = 0;
        pattern: r(
          /<<0>>(?=\s+(?:<<1>>\s*(?:=>|[({]|\.\s*this\s*\[)|this\s*\[))/.source,
          [I, _]
        ),
        inside: D,
        alias: "class-name"
      },
      "constructor-invocation": {
        // new List<Foo<Bar[]>> { }
        pattern: r(/(\bnew\s+)<<0>>(?=\s*[[({])/.source, [I]),
        lookbehind: !0,
        inside: D,
        alias: "class-name"
      },
      /*'explicit-implementation': {
      // int IFoo<Foo>.Bar => 0; void IFoo<Foo<Foo>>.Foo<T>();
      pattern: replace(/\b<<0>>(?=\.<<1>>)/, className, methodOrPropertyDeclaration),
      inside: classNameInside,
      alias: 'class-name'
      },*/
      "generic-method": {
        // foo<Bar>()
        pattern: r(/<<0>>\s*<<1>>(?=\s*\()/.source, [O, m]),
        inside: {
          function: r(/^<<0>>/.source, [O]),
          generic: {
            pattern: RegExp(m),
            alias: "class-name",
            inside: D
          }
        }
      },
      "type-list": {
        // The list of types inherited or of generic constraints
        // class Foo<F> : Bar, IList<FooBar>
        // where F : Bar, IList<int>
        pattern: r(
          /\b((?:<<0>>\s+<<1>>|record\s+<<1>>\s*<<5>>|where\s+<<2>>)\s*:\s*)(?:<<3>>|<<4>>|<<1>>\s*<<5>>|<<6>>)(?:\s*,\s*(?:<<3>>|<<4>>|<<6>>))*(?=\s*(?:where|[{;]|=>|$))/.source,
          [
            s,
            w,
            O,
            I,
            u.source,
            v,
            /\bnew\s*\(\s*\)/.source
          ]
        ),
        lookbehind: !0,
        inside: {
          "record-arguments": {
            pattern: r(/(^(?!new\s*\()<<0>>\s*)<<1>>/.source, [
              w,
              v
            ]),
            lookbehind: !0,
            greedy: !0,
            inside: e.languages.csharp
          },
          keyword: u,
          "class-name": {
            pattern: RegExp(I),
            greedy: !0,
            inside: D
          },
          punctuation: /[,()]/
        }
      },
      preprocessor: {
        pattern: /(^[\t ]*)#.*/m,
        lookbehind: !0,
        alias: "property",
        inside: {
          // highlight preprocessor directives as keywords
          directive: {
            pattern: /(#)\b(?:define|elif|else|endif|endregion|error|if|line|nullable|pragma|region|undef|warning)\b/,
            lookbehind: !0,
            alias: "keyword"
          }
        }
      }
    });
    var q = H + "|" + M, Q = n(
      /\/(?![*/])|\/\/[^\r\n]*[\r\n]|\/\*(?:[^*]|\*(?!\/))*\*\/|<<0>>/.source,
      [q]
    ), ne = a(
      n(/[^"'/()]|<<0>>|\(<<self>>*\)/.source, [
        Q
      ]),
      2
    ), J = /\b(?:assembly|event|field|method|module|param|property|return|type)\b/.source, ue = n(/<<0>>(?:\s*\(<<1>>*\))?/.source, [
      _,
      ne
    ]);
    e.languages.insertBefore("csharp", "class-name", {
      attribute: {
        // Attributes
        // [Foo], [Foo(1), Bar(2, Prop = "foo")], [return: Foo(1), Bar(2)], [assembly: Foo(Bar)]
        pattern: r(
          /((?:^|[^\s\w>)?])\s*\[\s*)(?:<<0>>\s*:\s*)?<<1>>(?:\s*,\s*<<1>>)*(?=\s*\])/.source,
          [J, ue]
        ),
        lookbehind: !0,
        greedy: !0,
        inside: {
          target: {
            pattern: r(/^<<0>>(?=\s*:)/.source, [J]),
            alias: "keyword"
          },
          "attribute-arguments": {
            pattern: r(/\(<<0>>*\)/.source, [ne]),
            inside: e.languages.csharp
          },
          "class-name": {
            pattern: RegExp(_),
            inside: {
              punctuation: /\./
            }
          },
          punctuation: /[:,]/
        }
      }
    });
    var ee = /:[^}\r\n]+/.source, fe = a(
      n(/[^"'/()]|<<0>>|\(<<self>>*\)/.source, [
        Q
      ]),
      2
    ), de = n(/\{(?!\{)(?:(?![}:])<<0>>)*<<1>>?\}/.source, [
      fe,
      ee
    ]), ie = a(
      n(
        /[^"'/()]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|<<0>>|\(<<self>>*\)/.source,
        [q]
      ),
      2
    ), le = n(/\{(?!\{)(?:(?![}:])<<0>>)*<<1>>?\}/.source, [
      ie,
      ee
    ]);
    function ye(B, pe) {
      return {
        interpolation: {
          pattern: r(/((?:^|[^{])(?:\{\{)*)<<0>>/.source, [B]),
          lookbehind: !0,
          inside: {
            "format-string": {
              pattern: r(/(^\{(?:(?![}:])<<0>>)*)<<1>>(?=\}$)/.source, [
                pe,
                ee
              ]),
              lookbehind: !0,
              inside: {
                punctuation: /^:/
              }
            },
            punctuation: /^\{|\}$/,
            expression: {
              pattern: /[\s\S]+/,
              alias: "language-csharp",
              inside: e.languages.csharp
            }
          }
        },
        string: /[\s\S]+/
      };
    }
    e.languages.insertBefore("csharp", "string", {
      "interpolation-string": [
        {
          pattern: r(
            /(^|[^\\])(?:\$@|@\$)"(?:""|\\[\s\S]|\{\{|<<0>>|[^\\{"])*"/.source,
            [de]
          ),
          lookbehind: !0,
          greedy: !0,
          inside: ye(de, fe)
        },
        {
          pattern: r(/(^|[^@\\])\$"(?:\\.|\{\{|<<0>>|[^\\"{])*"/.source, [
            le
          ]),
          lookbehind: !0,
          greedy: !0,
          inside: ye(le, ie)
        }
      ],
      char: {
        pattern: RegExp(M),
        greedy: !0
      }
    }), e.languages.dotnet = e.languages.cs = e.languages.csharp;
  }(t);
}
ws.displayName = "markup";
ws.aliases = ["atom", "html", "mathml", "rss", "ssml", "svg", "xml"];
function ws(t) {
  t.languages.markup = {
    comment: {
      pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
      greedy: !0
    },
    prolog: {
      pattern: /<\?[\s\S]+?\?>/,
      greedy: !0
    },
    doctype: {
      // https://www.w3.org/TR/xml/#NT-doctypedecl
      pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
      greedy: !0,
      inside: {
        "internal-subset": {
          pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
          lookbehind: !0,
          greedy: !0,
          inside: null
          // see below
        },
        string: {
          pattern: /"[^"]*"|'[^']*'/,
          greedy: !0
        },
        punctuation: /^<!|>$|[[\]]/,
        "doctype-tag": /^DOCTYPE/i,
        name: /[^\s<>'"]+/
      }
    },
    cdata: {
      pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
      greedy: !0
    },
    tag: {
      pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
      greedy: !0,
      inside: {
        tag: {
          pattern: /^<\/?[^\s>\/]+/,
          inside: {
            punctuation: /^<\/?/,
            namespace: /^[^\s>\/:]+:/
          }
        },
        "special-attr": [],
        "attr-value": {
          pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
          inside: {
            punctuation: [
              {
                pattern: /^=/,
                alias: "attr-equals"
              },
              {
                pattern: /^(\s*)["']|["']$/,
                lookbehind: !0
              }
            ]
          }
        },
        punctuation: /\/?>/,
        "attr-name": {
          pattern: /[^\s>\/]+/,
          inside: {
            namespace: /^[^\s>\/:]+:/
          }
        }
      }
    },
    entity: [
      {
        pattern: /&[\da-z]{1,8};/i,
        alias: "named-entity"
      },
      /&#x?[\da-f]{1,8};/i
    ]
  }, t.languages.markup.tag.inside["attr-value"].inside.entity = t.languages.markup.entity, t.languages.markup.doctype.inside["internal-subset"].inside = t.languages.markup, t.hooks.add("wrap", function(e) {
    e.type === "entity" && (e.attributes.title = e.content.value.replace(/&amp;/, "&"));
  }), Object.defineProperty(t.languages.markup.tag, "addInlined", {
    /**
     * Adds an inlined language to markup.
     *
     * An example of an inlined language is CSS with `<style>` tags.
     *
     * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
     * case insensitive.
     * @param {string} lang The language key.
     * @example
     * addInlined('style', 'css');
     */
    value: function(n, r) {
      var a = {};
      a["language-" + r] = {
        pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
        lookbehind: !0,
        inside: t.languages[r]
      }, a.cdata = /^<!\[CDATA\[|\]\]>$/i;
      var i = {
        "included-cdata": {
          pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
          inside: a
        }
      };
      i["language-" + r] = {
        pattern: /[\s\S]+/,
        inside: t.languages[r]
      };
      var o = {};
      o[n] = {
        pattern: RegExp(
          /(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(
            /__/g,
            function() {
              return n;
            }
          ),
          "i"
        ),
        lookbehind: !0,
        greedy: !0,
        inside: i
      }, t.languages.insertBefore("markup", "cdata", o);
    }
  }), Object.defineProperty(t.languages.markup.tag, "addAttribute", {
    /**
     * Adds an pattern to highlight languages embedded in HTML attributes.
     *
     * An example of an inlined language is CSS with `style` attributes.
     *
     * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
     * case insensitive.
     * @param {string} lang The language key.
     * @example
     * addAttribute('style', 'css');
     */
    value: function(e, n) {
      t.languages.markup.tag.inside["special-attr"].push({
        pattern: RegExp(
          /(^|["'\s])/.source + "(?:" + e + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source,
          "i"
        ),
        lookbehind: !0,
        inside: {
          "attr-name": /^[^\s=]+/,
          "attr-value": {
            pattern: /=[\s\S]+/,
            inside: {
              value: {
                pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                lookbehind: !0,
                alias: [n, "language-" + n],
                inside: t.languages[n]
              },
              punctuation: [
                {
                  pattern: /^=/,
                  alias: "attr-equals"
                },
                /"|'/
              ]
            }
          }
        }
      });
    }
  }), t.languages.html = t.languages.markup, t.languages.mathml = t.languages.markup, t.languages.svg = t.languages.markup, t.languages.xml = t.languages.extend("markup", {}), t.languages.ssml = t.languages.xml, t.languages.atom = t.languages.xml, t.languages.rss = t.languages.xml;
}
pv.displayName = "css";
pv.aliases = [];
function pv(t) {
  (function(e) {
    var n = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
    e.languages.css = {
      comment: /\/\*[\s\S]*?\*\//,
      atrule: {
        pattern: RegExp(
          "@[\\w-](?:" + /[^;{\s"']|\s+(?!\s)/.source + "|" + n.source + ")*?" + /(?:;|(?=\s*\{))/.source
        ),
        inside: {
          rule: /^@[\w-]+/,
          "selector-function-argument": {
            pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
            lookbehind: !0,
            alias: "selector"
          },
          keyword: {
            pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
            lookbehind: !0
          }
          // See rest below
        }
      },
      url: {
        // https://drafts.csswg.org/css-values-3/#urls
        pattern: RegExp(
          "\\burl\\((?:" + n.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)",
          "i"
        ),
        greedy: !0,
        inside: {
          function: /^url/i,
          punctuation: /^\(|\)$/,
          string: {
            pattern: RegExp("^" + n.source + "$"),
            alias: "url"
          }
        }
      },
      selector: {
        pattern: RegExp(
          `(^|[{}\\s])[^{}\\s](?:[^{};"'\\s]|\\s+(?![\\s{])|` + n.source + ")*(?=\\s*\\{)"
        ),
        lookbehind: !0
      },
      string: {
        pattern: n,
        greedy: !0
      },
      property: {
        pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
        lookbehind: !0
      },
      important: /!important\b/i,
      function: {
        pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
        lookbehind: !0
      },
      punctuation: /[(){};:,]/
    }, e.languages.css.atrule.inside.rest = e.languages.css;
    var r = e.languages.markup;
    r && (r.tag.addInlined("style", "css"), r.tag.addAttribute("style", "css"));
  })(t);
}
LD.displayName = "diff";
LD.aliases = [];
function LD(t) {
  (function(e) {
    e.languages.diff = {
      coord: [
        // Match all kinds of coord lines (prefixed by "+++", "---" or "***").
        /^(?:\*{3}|-{3}|\+{3}).*$/m,
        // Match "@@ ... @@" coord lines in unified diff.
        /^@@.*@@$/m,
        // Match coord lines in normal diff (starts with a number).
        /^\d.*$/m
      ]
      // deleted, inserted, unchanged, diff
    };
    var n = {
      "deleted-sign": "-",
      "deleted-arrow": "<",
      "inserted-sign": "+",
      "inserted-arrow": ">",
      unchanged: " ",
      diff: "!"
    };
    Object.keys(n).forEach(function(r) {
      var a = n[r], i = [];
      /^\w+$/.test(r) || i.push(/\w+/.exec(r)[0]), r === "diff" && i.push("bold"), e.languages.diff[r] = {
        pattern: RegExp(
          "^(?:[" + a + `].*(?:\r
?|
|(?![\\s\\S])))+`,
          "m"
        ),
        alias: i,
        inside: {
          line: {
            pattern: /(.)(?=[\s\S]).*(?:\r\n?|\n)?/,
            lookbehind: !0
          },
          prefix: {
            pattern: /[\s\S]/,
            alias: /\w+/.exec(r)[0]
          }
        }
      };
    }), Object.defineProperty(e.languages.diff, "PREFIXES", {
      value: n
    });
  })(t);
}
MD.displayName = "go";
MD.aliases = [];
function MD(t) {
  t.register(Lr), t.languages.go = t.languages.extend("clike", {
    string: {
      pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"|`[^`]*`/,
      lookbehind: !0,
      greedy: !0
    },
    keyword: /\b(?:break|case|chan|const|continue|default|defer|else|fallthrough|for|func|go(?:to)?|if|import|interface|map|package|range|return|select|struct|switch|type|var)\b/,
    boolean: /\b(?:_|false|iota|nil|true)\b/,
    number: [
      // binary and octal integers
      /\b0(?:b[01_]+|o[0-7_]+)i?\b/i,
      // hexadecimal integers and floats
      /\b0x(?:[a-f\d_]+(?:\.[a-f\d_]*)?|\.[a-f\d_]+)(?:p[+-]?\d+(?:_\d+)*)?i?(?!\w)/i,
      // decimal integers and floats
      /(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?[\d_]+)?i?(?!\w)/i
    ],
    operator: /[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\./,
    builtin: /\b(?:append|bool|byte|cap|close|complex|complex(?:64|128)|copy|delete|error|float(?:32|64)|u?int(?:8|16|32|64)?|imag|len|make|new|panic|print(?:ln)?|real|recover|rune|string|uintptr)\b/
  }), t.languages.insertBefore("go", "string", {
    char: {
      pattern: /'(?:\\.|[^'\\\r\n]){0,10}'/,
      greedy: !0
    }
  }), delete t.languages.go["class-name"];
}
FD.displayName = "ini";
FD.aliases = [];
function FD(t) {
  t.languages.ini = {
    /**
     * The component mimics the behavior of the Win32 API parser.
     *
     * @see {@link https://github.com/PrismJS/prism/issues/2775#issuecomment-787477723}
     */
    comment: {
      pattern: /(^[ \f\t\v]*)[#;][^\n\r]*/m,
      lookbehind: !0
    },
    section: {
      pattern: /(^[ \f\t\v]*)\[[^\n\r\]]*\]?/m,
      lookbehind: !0,
      inside: {
        "section-name": {
          pattern: /(^\[[ \f\t\v]*)[^ \f\t\v\]]+(?:[ \f\t\v]+[^ \f\t\v\]]+)*/,
          lookbehind: !0,
          alias: "selector"
        },
        punctuation: /\[|\]/
      }
    },
    key: {
      pattern: /(^[ \f\t\v]*)[^ \f\n\r\t\v=]+(?:[ \f\t\v]+[^ \f\n\r\t\v=]+)*(?=[ \f\t\v]*=)/m,
      lookbehind: !0,
      alias: "attr-name"
    },
    value: {
      pattern: /(=[ \f\t\v]*)[^ \f\n\r\t\v]+(?:[ \f\t\v]+[^ \f\n\r\t\v]+)*/,
      lookbehind: !0,
      alias: "attr-value",
      inside: {
        "inner-value": {
          pattern: /^("|').+(?=\1$)/,
          lookbehind: !0
        }
      }
    },
    punctuation: /=/
  };
}
k0.displayName = "java";
k0.aliases = [];
function k0(t) {
  t.register(Lr), function(e) {
    var n = /\b(?:abstract|assert|boolean|break|byte|case|catch|char|class|const|continue|default|do|double|else|enum|exports|extends|final|finally|float|for|goto|if|implements|import|instanceof|int|interface|long|module|native|new|non-sealed|null|open|opens|package|permits|private|protected|provides|public|record(?!\s*[(){}[\]<>=%~.:,;?+\-*/&|^])|requires|return|sealed|short|static|strictfp|super|switch|synchronized|this|throw|throws|to|transient|transitive|try|uses|var|void|volatile|while|with|yield)\b/, r = /(?:[a-z]\w*\s*\.\s*)*(?:[A-Z]\w*\s*\.\s*)*/.source, a = {
      pattern: RegExp(
        /(^|[^\w.])/.source + r + /[A-Z](?:[\d_A-Z]*[a-z]\w*)?\b/.source
      ),
      lookbehind: !0,
      inside: {
        namespace: {
          pattern: /^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/,
          inside: {
            punctuation: /\./
          }
        },
        punctuation: /\./
      }
    };
    e.languages.java = e.languages.extend("clike", {
      string: {
        pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"/,
        lookbehind: !0,
        greedy: !0
      },
      "class-name": [
        a,
        {
          // variables, parameters, and constructor references
          // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
          pattern: RegExp(
            /(^|[^\w.])/.source + r + /[A-Z]\w*(?=\s+\w+\s*[;,=()]|\s*(?:\[[\s,]*\]\s*)?::\s*new\b)/.source
          ),
          lookbehind: !0,
          inside: a.inside
        },
        {
          // class names based on keyword
          // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
          pattern: RegExp(
            /(\b(?:class|enum|extends|implements|instanceof|interface|new|record|throws)\s+)/.source + r + /[A-Z]\w*\b/.source
          ),
          lookbehind: !0,
          inside: a.inside
        }
      ],
      keyword: n,
      function: [
        e.languages.clike.function,
        {
          pattern: /(::\s*)[a-z_]\w*/,
          lookbehind: !0
        }
      ],
      number: /\b0b[01][01_]*L?\b|\b0x(?:\.[\da-f_p+-]+|[\da-f_]+(?:\.[\da-f_p+-]+)?)\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfl]?/i,
      operator: {
        pattern: /(^|[^.])(?:<<=?|>>>?=?|->|--|\+\+|&&|\|\||::|[?:~]|[-+*/%&|^!=<>]=?)/m,
        lookbehind: !0
      },
      constant: /\b[A-Z][A-Z_\d]+\b/
    }), e.languages.insertBefore("java", "string", {
      "triple-quoted-string": {
        // http://openjdk.java.net/jeps/355#Description
        pattern: /"""[ \t]*[\r\n](?:(?:"|"")?(?:\\.|[^"\\]))*"""/,
        greedy: !0,
        alias: "string"
      },
      char: {
        pattern: /'(?:\\.|[^'\\\r\n]){1,6}'/,
        greedy: !0
      }
    }), e.languages.insertBefore("java", "class-name", {
      annotation: {
        pattern: /(^|[^.])@\w+(?:\s*\.\s*\w+)*/,
        lookbehind: !0,
        alias: "punctuation"
      },
      generics: {
        pattern: /<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&))*>)*>)*>)*>/,
        inside: {
          "class-name": a,
          keyword: n,
          punctuation: /[<>(),.:]/,
          operator: /[?&|]/
        }
      },
      import: [
        {
          pattern: RegExp(
            /(\bimport\s+)/.source + r + /(?:[A-Z]\w*|\*)(?=\s*;)/.source
          ),
          lookbehind: !0,
          inside: {
            namespace: a.inside.namespace,
            punctuation: /\./,
            operator: /\*/,
            "class-name": /\w+/
          }
        },
        {
          pattern: RegExp(
            /(\bimport\s+static\s+)/.source + r + /(?:\w+|\*)(?=\s*;)/.source
          ),
          lookbehind: !0,
          alias: "static",
          inside: {
            namespace: a.inside.namespace,
            static: /\b\w+$/,
            punctuation: /\./,
            operator: /\*/,
            "class-name": /\w+/
          }
        }
      ],
      namespace: {
        pattern: RegExp(
          /(\b(?:exports|import(?:\s+static)?|module|open|opens|package|provides|requires|to|transitive|uses|with)\s+)(?!<keyword>)[a-z]\w*(?:\.[a-z]\w*)*\.?/.source.replace(
            /<keyword>/g,
            function() {
              return n.source;
            }
          )
        ),
        lookbehind: !0,
        inside: {
          punctuation: /\./
        }
      }
    });
  }(t);
}
$D.displayName = "regex";
$D.aliases = [];
function $D(t) {
  (function(e) {
    var n = {
      pattern: /\\[\\(){}[\]^$+*?|.]/,
      alias: "escape"
    }, r = /\\(?:x[\da-fA-F]{2}|u[\da-fA-F]{4}|u\{[\da-fA-F]+\}|0[0-7]{0,2}|[123][0-7]{2}|c[a-zA-Z]|.)/, a = {
      pattern: /\.|\\[wsd]|\\p\{[^{}]+\}/i,
      alias: "class-name"
    }, i = {
      pattern: /\\[wsd]|\\p\{[^{}]+\}/i,
      alias: "class-name"
    }, o = "(?:[^\\\\-]|" + r.source + ")", s = RegExp(o + "-" + o), u = {
      pattern: /(<|')[^<>']+(?=[>']$)/,
      lookbehind: !0,
      alias: "variable"
    };
    e.languages.regex = {
      "char-class": {
        pattern: /((?:^|[^\\])(?:\\\\)*)\[(?:[^\\\]]|\\[\s\S])*\]/,
        lookbehind: !0,
        inside: {
          "char-class-negation": {
            pattern: /(^\[)\^/,
            lookbehind: !0,
            alias: "operator"
          },
          "char-class-punctuation": {
            pattern: /^\[|\]$/,
            alias: "punctuation"
          },
          range: {
            pattern: s,
            inside: {
              escape: r,
              "range-punctuation": {
                pattern: /-/,
                alias: "operator"
              }
            }
          },
          "special-escape": n,
          "char-set": i,
          escape: r
        }
      },
      "special-escape": n,
      "char-set": a,
      backreference: [
        {
          // a backreference which is not an octal escape
          pattern: /\\(?![123][0-7]{2})[1-9]/,
          alias: "keyword"
        },
        {
          pattern: /\\k<[^<>']+>/,
          alias: "keyword",
          inside: {
            "group-name": u
          }
        }
      ],
      anchor: {
        pattern: /[$^]|\\[ABbGZz]/,
        alias: "function"
      },
      escape: r,
      group: [
        {
          // https://docs.oracle.com/javase/10/docs/api/java/util/regex/Pattern.html
          // https://docs.microsoft.com/en-us/dotnet/standard/base-types/regular-expression-language-quick-reference?view=netframework-4.7.2#grouping-constructs
          // (), (?<name>), (?'name'), (?>), (?:), (?=), (?!), (?<=), (?<!), (?is-m), (?i-m:)
          pattern: /\((?:\?(?:<[^<>']+>|'[^<>']+'|[>:]|<?[=!]|[idmnsuxU]+(?:-[idmnsuxU]+)?:?))?/,
          alias: "punctuation",
          inside: {
            "group-name": u
          }
        },
        {
          pattern: /\)/,
          alias: "punctuation"
        }
      ],
      quantifier: {
        pattern: /(?:[+*?]|\{\d+(?:,\d*)?\})[?+]?/,
        alias: "number"
      },
      alternation: {
        pattern: /\|/,
        alias: "keyword"
      }
    };
  })(t);
}
rl.displayName = "javascript";
rl.aliases = ["js"];
function rl(t) {
  t.register(Lr), t.languages.javascript = t.languages.extend("clike", {
    "class-name": [
      t.languages.clike["class-name"],
      {
        pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
        lookbehind: !0
      }
    ],
    keyword: [
      {
        pattern: /((?:^|\})\s*)catch\b/,
        lookbehind: !0
      },
      {
        pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
        lookbehind: !0
      }
    ],
    // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
    function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    number: {
      pattern: RegExp(
        /(^|[^\w$])/.source + "(?:" + // constant
        (/NaN|Infinity/.source + "|" + // binary integer
        /0[bB][01]+(?:_[01]+)*n?/.source + "|" + // octal integer
        /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + // hexadecimal integer
        /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + // decimal bigint
        /\d+(?:_\d+)*n/.source + "|" + // decimal number (integer or float) but no bigint
        /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ")" + /(?![\w$])/.source
      ),
      lookbehind: !0
    },
    operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
  }), t.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/, t.languages.insertBefore("javascript", "keyword", {
    regex: {
      pattern: RegExp(
        // lookbehind
        // eslint-disable-next-line regexp/no-dupe-characters-character-class
        /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + // Regex pattern:
        // There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
        // classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
        // with the only syntax, so we have to define 2 different regex patterns.
        /\//.source + "(?:" + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + "|" + // `v` flag syntax. This supports 3 levels of nested character classes.
        /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ")" + // lookahead
        /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source
      ),
      lookbehind: !0,
      greedy: !0,
      inside: {
        "regex-source": {
          pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
          lookbehind: !0,
          alias: "language-regex",
          inside: t.languages.regex
        },
        "regex-delimiter": /^\/|\/$/,
        "regex-flags": /^[a-z]+$/
      }
    },
    // This must be declared before keyword because we use "function" inside the look-forward
    "function-variable": {
      pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
      alias: "function"
    },
    parameter: [
      {
        pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
        lookbehind: !0,
        inside: t.languages.javascript
      },
      {
        pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
        lookbehind: !0,
        inside: t.languages.javascript
      },
      {
        pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
        lookbehind: !0,
        inside: t.languages.javascript
      },
      {
        pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
        lookbehind: !0,
        inside: t.languages.javascript
      }
    ],
    constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
  }), t.languages.insertBefore("javascript", "string", {
    hashbang: {
      pattern: /^#!.*/,
      greedy: !0,
      alias: "comment"
    },
    "template-string": {
      pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
      greedy: !0,
      inside: {
        "template-punctuation": {
          pattern: /^`|`$/,
          alias: "string"
        },
        interpolation: {
          pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
          lookbehind: !0,
          inside: {
            "interpolation-punctuation": {
              pattern: /^\$\{|\}$/,
              alias: "punctuation"
            },
            rest: t.languages.javascript
          }
        },
        string: /[\s\S]+/
      }
    },
    "string-property": {
      pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
      lookbehind: !0,
      greedy: !0,
      alias: "property"
    }
  }), t.languages.insertBefore("javascript", "operator", {
    "literal-property": {
      pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
      lookbehind: !0,
      alias: "property"
    }
  }), t.languages.markup && (t.languages.markup.tag.addInlined("script", "javascript"), t.languages.markup.tag.addAttribute(
    /on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source,
    "javascript"
  )), t.languages.js = t.languages.javascript;
}
b1.displayName = "json";
b1.aliases = ["webmanifest"];
function b1(t) {
  t.languages.json = {
    property: {
      pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/,
      lookbehind: !0,
      greedy: !0
    },
    string: {
      pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,
      lookbehind: !0,
      greedy: !0
    },
    comment: {
      pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
      greedy: !0
    },
    number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
    punctuation: /[{}[\],]/,
    operator: /:/,
    boolean: /\b(?:false|true)\b/,
    null: {
      pattern: /\bnull\b/,
      alias: "keyword"
    }
  }, t.languages.webmanifest = t.languages.json;
}
BD.displayName = "kotlin";
BD.aliases = ["kt", "kts"];
function BD(t) {
  t.register(Lr), function(e) {
    e.languages.kotlin = e.languages.extend("clike", {
      keyword: {
        // The lookbehind prevents wrong highlighting of e.g. kotlin.properties.get
        pattern: /(^|[^.])\b(?:abstract|actual|annotation|as|break|by|catch|class|companion|const|constructor|continue|crossinline|data|do|dynamic|else|enum|expect|external|final|finally|for|fun|get|if|import|in|infix|init|inline|inner|interface|internal|is|lateinit|noinline|null|object|open|operator|out|override|package|private|protected|public|reified|return|sealed|set|super|suspend|tailrec|this|throw|to|try|typealias|val|var|vararg|when|where|while)\b/,
        lookbehind: !0
      },
      function: [
        {
          pattern: /(?:`[^\r\n`]+`|\b\w+)(?=\s*\()/,
          greedy: !0
        },
        {
          pattern: /(\.)(?:`[^\r\n`]+`|\w+)(?=\s*\{)/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      number: /\b(?:0[xX][\da-fA-F]+(?:_[\da-fA-F]+)*|0[bB][01]+(?:_[01]+)*|\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?(?:[eE][+-]?\d+(?:_\d+)*)?[fFL]?)\b/,
      operator: /\+[+=]?|-[-=>]?|==?=?|!(?:!|==?)?|[\/*%<>]=?|[?:]:?|\.\.|&&|\|\||\b(?:and|inv|or|shl|shr|ushr|xor)\b/
    }), delete e.languages.kotlin["class-name"];
    var n = {
      "interpolation-punctuation": {
        pattern: /^\$\{?|\}$/,
        alias: "punctuation"
      },
      expression: {
        pattern: /[\s\S]+/,
        inside: e.languages.kotlin
      }
    };
    e.languages.insertBefore("kotlin", "string", {
      // https://kotlinlang.org/spec/expressions.html#string-interpolation-expressions
      "string-literal": [
        {
          pattern: /"""(?:[^$]|\$(?:(?!\{)|\{[^{}]*\}))*?"""/,
          alias: "multiline",
          inside: {
            interpolation: {
              pattern: /\$(?:[a-z_]\w*|\{[^{}]*\})/i,
              inside: n
            },
            string: /[\s\S]+/
          }
        },
        {
          pattern: /"(?:[^"\\\r\n$]|\\.|\$(?:(?!\{)|\{[^{}]*\}))*"/,
          alias: "singleline",
          inside: {
            interpolation: {
              pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:[a-z_]\w*|\{[^{}]*\})/i,
              lookbehind: !0,
              inside: n
            },
            string: /[\s\S]+/
          }
        }
      ],
      char: {
        // https://kotlinlang.org/spec/expressions.html#character-literals
        pattern: /'(?:[^'\\\r\n]|\\(?:.|u[a-fA-F0-9]{0,4}))'/,
        greedy: !0
      }
    }), delete e.languages.kotlin.string, e.languages.insertBefore("kotlin", "keyword", {
      annotation: {
        pattern: /\B@(?:\w+:)?(?:[A-Z]\w*|\[[^\]]+\])/,
        alias: "builtin"
      }
    }), e.languages.insertBefore("kotlin", "function", {
      label: {
        pattern: /\b\w+@|@\w+\b/,
        alias: "symbol"
      }
    }), e.languages.kt = e.languages.kotlin, e.languages.kts = e.languages.kotlin;
  }(t);
}
UD.displayName = "less";
UD.aliases = [];
function UD(t) {
  t.register(pv), t.languages.less = t.languages.extend("css", {
    comment: [
      /\/\*[\s\S]*?\*\//,
      {
        pattern: /(^|[^\\])\/\/.*/,
        lookbehind: !0
      }
    ],
    atrule: {
      pattern: /@[\w-](?:\((?:[^(){}]|\([^(){}]*\))*\)|[^(){};\s]|\s+(?!\s))*?(?=\s*\{)/,
      inside: {
        punctuation: /[:()]/
      }
    },
    // selectors and mixins are considered the same
    selector: {
      pattern: /(?:@\{[\w-]+\}|[^{};\s@])(?:@\{[\w-]+\}|\((?:[^(){}]|\([^(){}]*\))*\)|[^(){};@\s]|\s+(?!\s))*?(?=\s*\{)/,
      inside: {
        // mixin parameters
        variable: /@+[\w-]+/
      }
    },
    property: /(?:@\{[\w-]+\}|[\w-])+(?:\+_?)?(?=\s*:)/,
    operator: /[+\-*\/]/
  }), t.languages.insertBefore("less", "property", {
    variable: [
      // Variable declaration (the colon must be consumed!)
      {
        pattern: /@[\w-]+\s*:/,
        inside: {
          punctuation: /:/
        }
      },
      // Variable usage
      /@@?[\w-]+/
    ],
    "mixin-usage": {
      pattern: /([{;]\s*)[.#](?!\d)[\w-].*?(?=[(;])/,
      lookbehind: !0,
      alias: "function"
    }
  });
}
A_.displayName = "lua";
A_.aliases = [];
function A_(t) {
  t.languages.lua = {
    comment: /^#!.+|--(?:\[(=*)\[[\s\S]*?\]\1\]|.*)/m,
    // \z may be used to skip the following space
    string: {
      pattern: /(["'])(?:(?!\1)[^\\\r\n]|\\z(?:\r\n|\s)|\\(?:\r\n|[^z]))*\1|\[(=*)\[[\s\S]*?\]\2\]/,
      greedy: !0
    },
    number: /\b0x[a-f\d]+(?:\.[a-f\d]*)?(?:p[+-]?\d+)?\b|\b\d+(?:\.\B|(?:\.\d*)?(?:e[+-]?\d+)?\b)|\B\.\d+(?:e[+-]?\d+)?\b/i,
    keyword: /\b(?:and|break|do|else|elseif|end|false|for|function|goto|if|in|local|nil|not|or|repeat|return|then|true|until|while)\b/,
    function: /(?!\d)\w+(?=\s*(?:[({]))/,
    operator: [
      /[-+*%^&|#]|\/\/?|<[<=]?|>[>=]?|[=~]=?/,
      {
        // Match ".." but don't break "..."
        pattern: /(^|[^.])\.\.(?!\.)/,
        lookbehind: !0
      }
    ],
    punctuation: /[\[\](){},;]|\.+|:+/
  };
}
zD.displayName = "makefile";
zD.aliases = [];
function zD(t) {
  t.languages.makefile = {
    comment: {
      pattern: /(^|[^\\])#(?:\\(?:\r\n|[\s\S])|[^\\\r\n])*/,
      lookbehind: !0
    },
    string: {
      pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
      greedy: !0
    },
    "builtin-target": {
      pattern: /\.[A-Z][^:#=\s]+(?=\s*:(?!=))/,
      alias: "builtin"
    },
    target: {
      pattern: /^(?:[^:=\s]|[ \t]+(?![\s:]))+(?=\s*:(?!=))/m,
      alias: "symbol",
      inside: {
        variable: /\$+(?:(?!\$)[^(){}:#=\s]+|(?=[({]))/
      }
    },
    variable: /\$+(?:(?!\$)[^(){}:#=\s]+|\([@*%<^+?][DF]\)|(?=[({]))/,
    // Directives
    keyword: /-include\b|\b(?:define|else|endef|endif|export|ifn?def|ifn?eq|include|override|private|sinclude|undefine|unexport|vpath)\b/,
    function: {
      pattern: /(\()(?:abspath|addsuffix|and|basename|call|dir|error|eval|file|filter(?:-out)?|findstring|firstword|flavor|foreach|guile|if|info|join|lastword|load|notdir|or|origin|patsubst|realpath|shell|sort|strip|subst|suffix|value|warning|wildcard|word(?:list|s)?)(?=[ \t])/,
      lookbehind: !0
    },
    operator: /(?:::|[?:+!])?=|[|@]/,
    punctuation: /[:;(){}]/
  };
}
k_.displayName = "yaml";
k_.aliases = ["yml"];
function k_(t) {
  (function(e) {
    var n = /[*&][^\s[\]{},]+/, r = /!(?:<[\w\-%#;/?:@&=+$,.!~*'()[\]]+>|(?:[a-zA-Z\d-]*!)?[\w\-%#;/?:@&=+$.~*'()]+)?/, a = "(?:" + r.source + "(?:[ 	]+" + n.source + ")?|" + n.source + "(?:[ 	]+" + r.source + ")?)", i = /(?:[^\s\x00-\x08\x0e-\x1f!"#%&'*,\-:>?@[\]`{|}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]|[?:-]<PLAIN>)(?:[ \t]*(?:(?![#:])<PLAIN>|:<PLAIN>))*/.source.replace(
      /<PLAIN>/g,
      function() {
        return /[^\s\x00-\x08\x0e-\x1f,[\]{}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]/.source;
      }
    ), o = /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'/.source;
    function s(u, f) {
      f = (f || "").replace(/m/g, "") + "m";
      var p = /([:\-,[{]\s*(?:\s<<prop>>[ \t]+)?)(?:<<value>>)(?=[ \t]*(?:$|,|\]|\}|(?:[\r\n]\s*)?#))/.source.replace(/<<prop>>/g, function() {
        return a;
      }).replace(/<<value>>/g, function() {
        return u;
      });
      return RegExp(p, f);
    }
    e.languages.yaml = {
      scalar: {
        pattern: RegExp(
          /([\-:]\s*(?:\s<<prop>>[ \t]+)?[|>])[ \t]*(?:((?:\r?\n|\r)[ \t]+)\S[^\r\n]*(?:\2[^\r\n]+)*)/.source.replace(
            /<<prop>>/g,
            function() {
              return a;
            }
          )
        ),
        lookbehind: !0,
        alias: "string"
      },
      comment: /#.*/,
      key: {
        pattern: RegExp(
          /((?:^|[:\-,[{\r\n?])[ \t]*(?:<<prop>>[ \t]+)?)<<key>>(?=\s*:\s)/.source.replace(/<<prop>>/g, function() {
            return a;
          }).replace(/<<key>>/g, function() {
            return "(?:" + i + "|" + o + ")";
          })
        ),
        lookbehind: !0,
        greedy: !0,
        alias: "atrule"
      },
      directive: {
        pattern: /(^[ \t]*)%.+/m,
        lookbehind: !0,
        alias: "important"
      },
      datetime: {
        pattern: s(
          /\d{4}-\d\d?-\d\d?(?:[tT]|[ \t]+)\d\d?:\d{2}:\d{2}(?:\.\d*)?(?:[ \t]*(?:Z|[-+]\d\d?(?::\d{2})?))?|\d{4}-\d{2}-\d{2}|\d\d?:\d{2}(?::\d{2}(?:\.\d*)?)?/.source
        ),
        lookbehind: !0,
        alias: "number"
      },
      boolean: {
        pattern: s(/false|true/.source, "i"),
        lookbehind: !0,
        alias: "important"
      },
      null: {
        pattern: s(/null|~/.source, "i"),
        lookbehind: !0,
        alias: "important"
      },
      string: {
        pattern: s(o),
        lookbehind: !0,
        greedy: !0
      },
      number: {
        pattern: s(
          /[+-]?(?:0x[\da-f]+|0o[0-7]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|\.inf|\.nan)/.source,
          "i"
        ),
        lookbehind: !0
      },
      tag: r,
      important: n,
      punctuation: /---|[:[\]{}\-,|>?]|\.\.\./
    }, e.languages.yml = e.languages.yaml;
  })(t);
}
HD.displayName = "markdown";
HD.aliases = ["md"];
function HD(t) {
  t.register(ws), function(e) {
    var n = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;
    function r(s) {
      return s = s.replace(/<inner>/g, function() {
        return n;
      }), RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + "(?:" + s + ")");
    }
    var a = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source, i = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(
      /__/g,
      function() {
        return a;
      }
    ), o = /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source;
    e.languages.markdown = e.languages.extend("markup", {}), e.languages.insertBefore("markdown", "prolog", {
      "front-matter-block": {
        pattern: /(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          punctuation: /^---|---$/,
          "front-matter": {
            pattern: /\S+(?:\s+\S+)*/,
            alias: ["yaml", "language-yaml"],
            inside: e.languages.yaml
          }
        }
      },
      blockquote: {
        // > ...
        pattern: /^>(?:[\t ]*>)*/m,
        alias: "punctuation"
      },
      table: {
        pattern: RegExp(
          "^" + i + o + "(?:" + i + ")*",
          "m"
        ),
        inside: {
          "table-data-rows": {
            pattern: RegExp(
              "^(" + i + o + ")(?:" + i + ")*$"
            ),
            lookbehind: !0,
            inside: {
              "table-data": {
                pattern: RegExp(a),
                inside: e.languages.markdown
              },
              punctuation: /\|/
            }
          },
          "table-line": {
            pattern: RegExp("^(" + i + ")" + o + "$"),
            lookbehind: !0,
            inside: {
              punctuation: /\||:?-{3,}:?/
            }
          },
          "table-header-row": {
            pattern: RegExp("^" + i + "$"),
            inside: {
              "table-header": {
                pattern: RegExp(a),
                alias: "important",
                inside: e.languages.markdown
              },
              punctuation: /\|/
            }
          }
        }
      },
      code: [
        {
          // Prefixed by 4 spaces or 1 tab and preceded by an empty line
          pattern: /((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/,
          lookbehind: !0,
          alias: "keyword"
        },
        {
          // ```optional language
          // code block
          // ```
          pattern: /^```[\s\S]*?^```$/m,
          greedy: !0,
          inside: {
            "code-block": {
              pattern: /^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m,
              lookbehind: !0
            },
            "code-language": {
              pattern: /^(```).+/,
              lookbehind: !0
            },
            punctuation: /```/
          }
        }
      ],
      title: [
        {
          // title 1
          // =======
          // title 2
          // -------
          pattern: /\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m,
          alias: "important",
          inside: {
            punctuation: /==+$|--+$/
          }
        },
        {
          // # title 1
          // ###### title 6
          pattern: /(^\s*)#.+/m,
          lookbehind: !0,
          alias: "important",
          inside: {
            punctuation: /^#+|#+$/
          }
        }
      ],
      hr: {
        // ***
        // ---
        // * * *
        // -----------
        pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m,
        lookbehind: !0,
        alias: "punctuation"
      },
      list: {
        // * item
        // + item
        // - item
        // 1. item
        pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m,
        lookbehind: !0,
        alias: "punctuation"
      },
      "url-reference": {
        // [id]: http://example.com "Optional title"
        // [id]: http://example.com 'Optional title'
        // [id]: http://example.com (Optional title)
        // [id]: <http://example.com> "Optional title"
        pattern: /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/,
        inside: {
          variable: {
            pattern: /^(!?\[)[^\]]+/,
            lookbehind: !0
          },
          string: /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/,
          punctuation: /^[\[\]!:]|[<>]/
        },
        alias: "url"
      },
      bold: {
        // **strong**
        // __strong__
        // allow one nested instance of italic text using the same delimiter
        pattern: r(
          /\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source
        ),
        lookbehind: !0,
        greedy: !0,
        inside: {
          content: {
            pattern: /(^..)[\s\S]+(?=..$)/,
            lookbehind: !0,
            inside: {}
            // see below
          },
          punctuation: /\*\*|__/
        }
      },
      italic: {
        // *em*
        // _em_
        // allow one nested instance of bold text using the same delimiter
        pattern: r(
          /\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source
        ),
        lookbehind: !0,
        greedy: !0,
        inside: {
          content: {
            pattern: /(^.)[\s\S]+(?=.$)/,
            lookbehind: !0,
            inside: {}
            // see below
          },
          punctuation: /[*_]/
        }
      },
      strike: {
        // ~~strike through~~
        // ~strike~
        // eslint-disable-next-line regexp/strict
        pattern: r(/(~~?)(?:(?!~)<inner>)+\2/.source),
        lookbehind: !0,
        greedy: !0,
        inside: {
          content: {
            pattern: /(^~~?)[\s\S]+(?=\1$)/,
            lookbehind: !0,
            inside: {}
            // see below
          },
          punctuation: /~~?/
        }
      },
      "code-snippet": {
        // `code`
        // ``code``
        pattern: /(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/,
        lookbehind: !0,
        greedy: !0,
        alias: ["code", "keyword"]
      },
      url: {
        // [example](http://example.com "Optional title")
        // [example][id]
        // [example] [id]
        pattern: r(
          /!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source
        ),
        lookbehind: !0,
        greedy: !0,
        inside: {
          operator: /^!/,
          content: {
            pattern: /(^\[)[^\]]+(?=\])/,
            lookbehind: !0,
            inside: {}
            // see below
          },
          variable: {
            pattern: /(^\][ \t]?\[)[^\]]+(?=\]$)/,
            lookbehind: !0
          },
          url: {
            pattern: /(^\]\()[^\s)]+/,
            lookbehind: !0
          },
          string: {
            pattern: /(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/,
            lookbehind: !0
          }
        }
      }
    }), ["url", "bold", "italic", "strike"].forEach(function(s) {
      ["url", "bold", "italic", "strike", "code-snippet"].forEach(function(u) {
        s !== u && (e.languages.markdown[s].inside.content.inside[u] = e.languages.markdown[u]);
      });
    }), e.hooks.add("after-tokenize", function(s) {
      if (s.language !== "markdown" && s.language !== "md")
        return;
      function u(f) {
        if (!(!f || typeof f == "string"))
          for (var p = 0, m = f.length; p < m; p++) {
            var v = f[p];
            if (v.type !== "code") {
              u(v.content);
              continue;
            }
            var O = v.content[1], w = v.content[3];
            if (O && w && O.type === "code-language" && w.type === "code-block" && typeof O.content == "string") {
              var _ = O.content.replace(/\b#/g, "sharp").replace(/\b\+\+/g, "pp");
              _ = (/[a-z][\w-]*/i.exec(_) || [""])[0].toLowerCase();
              var C = "language-" + _;
              w.alias ? typeof w.alias == "string" ? w.alias = [w.alias, C] : w.alias.push(C) : w.alias = [C];
            }
          }
      }
      u(s.tokens);
    }), e.hooks.add("wrap", function(s) {
      if (s.type === "code-block") {
        for (var u = "", f = 0, p = s.classes.length; f < p; f++) {
          var m = s.classes[f], v = /language-(.+)/.exec(m);
          if (v) {
            u = v[1];
            break;
          }
        }
        var O = e.languages[u];
        if (O)
          s.content = e.highlight(s.content.value, O, u);
        else if (u && u !== "none" && e.plugins.autoloader) {
          var w = "md-" + (/* @__PURE__ */ new Date()).valueOf() + "-" + Math.floor(Math.random() * 1e16);
          s.attributes.id = w, e.plugins.autoloader.loadLanguages(u, function() {
            var _ = document.getElementById(w);
            _ && (_.innerHTML = e.highlight(
              _.textContent,
              e.languages[u],
              u
            ));
          });
        }
      }
    }), RegExp(e.languages.markup.tag.pattern.source, "gi"), e.languages.md = e.languages.markdown;
  }(t);
}
WD.displayName = "objectivec";
WD.aliases = ["objc"];
function WD(t) {
  t.register(tp), t.languages.objectivec = t.languages.extend("c", {
    string: {
      pattern: /@?"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
      greedy: !0
    },
    keyword: /\b(?:asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|in|inline|int|long|register|return|self|short|signed|sizeof|static|struct|super|switch|typedef|typeof|union|unsigned|void|volatile|while)\b|(?:@interface|@end|@implementation|@protocol|@class|@public|@protected|@private|@property|@try|@catch|@finally|@throw|@synthesize|@dynamic|@selector)\b/,
    operator: /-[->]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|\|?|[~^%?*\/@]/
  }), delete t.languages.objectivec["class-name"], t.languages.objc = t.languages.objectivec;
}
QD.displayName = "perl";
QD.aliases = [];
function QD(t) {
  (function(e) {
    var n = /(?:\((?:[^()\\]|\\[\s\S])*\)|\{(?:[^{}\\]|\\[\s\S])*\}|\[(?:[^[\]\\]|\\[\s\S])*\]|<(?:[^<>\\]|\\[\s\S])*>)/.source;
    e.languages.perl = {
      comment: [
        {
          // POD
          pattern: /(^\s*)=\w[\s\S]*?=cut.*/m,
          lookbehind: !0,
          greedy: !0
        },
        {
          pattern: /(^|[^\\$])#.*/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      // TODO Could be nice to handle Heredoc too.
      string: [
        {
          pattern: RegExp(
            /\b(?:q|qq|qw|qx)(?![a-zA-Z0-9])\s*/.source + "(?:" + [
              // q/.../
              /([^a-zA-Z0-9\s{(\[<])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source,
              // q a...a
              // eslint-disable-next-line regexp/strict
              /([a-zA-Z0-9])(?:(?!\2)[^\\]|\\[\s\S])*\2/.source,
              // q(...)
              // q{...}
              // q[...]
              // q<...>
              n
            ].join("|") + ")"
          ),
          greedy: !0
        },
        // "...", `...`
        {
          pattern: /("|`)(?:(?!\1)[^\\]|\\[\s\S])*\1/,
          greedy: !0
        },
        // '...'
        // FIXME Multi-line single-quoted strings are not supported as they would break variables containing '
        {
          pattern: /'(?:[^'\\\r\n]|\\.)*'/,
          greedy: !0
        }
      ],
      regex: [
        {
          pattern: RegExp(
            /\b(?:m|qr)(?![a-zA-Z0-9])\s*/.source + "(?:" + [
              // m/.../
              /([^a-zA-Z0-9\s{(\[<])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source,
              // m a...a
              // eslint-disable-next-line regexp/strict
              /([a-zA-Z0-9])(?:(?!\2)[^\\]|\\[\s\S])*\2/.source,
              // m(...)
              // m{...}
              // m[...]
              // m<...>
              n
            ].join("|") + ")" + /[msixpodualngc]*/.source
          ),
          greedy: !0
        },
        // The lookbehinds prevent -s from breaking
        {
          pattern: RegExp(
            /(^|[^-])\b(?:s|tr|y)(?![a-zA-Z0-9])\s*/.source + "(?:" + [
              // s/.../.../
              // eslint-disable-next-line regexp/strict
              /([^a-zA-Z0-9\s{(\[<])(?:(?!\2)[^\\]|\\[\s\S])*\2(?:(?!\2)[^\\]|\\[\s\S])*\2/.source,
              // s a...a...a
              // eslint-disable-next-line regexp/strict
              /([a-zA-Z0-9])(?:(?!\3)[^\\]|\\[\s\S])*\3(?:(?!\3)[^\\]|\\[\s\S])*\3/.source,
              // s(...)(...)
              // s{...}{...}
              // s[...][...]
              // s<...><...>
              // s(...)[...]
              n + /\s*/.source + n
            ].join("|") + ")" + /[msixpodualngcer]*/.source
          ),
          lookbehind: !0,
          greedy: !0
        },
        // /.../
        // The look-ahead tries to prevent two divisions on
        // the same line from being highlighted as regex.
        // This does not support multi-line regex.
        {
          pattern: /\/(?:[^\/\\\r\n]|\\.)*\/[msixpodualngc]*(?=\s*(?:$|[\r\n,.;})&|\-+*~<>!?^]|(?:and|cmp|eq|ge|gt|le|lt|ne|not|or|x|xor)\b))/,
          greedy: !0
        }
      ],
      // FIXME Not sure about the handling of ::, ', and #
      variable: [
        // ${^POSTMATCH}
        /[&*$@%]\{\^[A-Z]+\}/,
        // $^V
        /[&*$@%]\^[A-Z_]/,
        // ${...}
        /[&*$@%]#?(?=\{)/,
        // $foo
        /[&*$@%]#?(?:(?:::)*'?(?!\d)[\w$]+(?![\w$]))+(?:::)*/,
        // $1
        /[&*$@%]\d+/,
        // $_, @_, %!
        // The negative lookahead prevents from breaking the %= operator
        /(?!%=)[$@%][!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~]/
      ],
      filehandle: {
        // <>, <FOO>, _
        pattern: /<(?![<=])\S*?>|\b_\b/,
        alias: "symbol"
      },
      "v-string": {
        // v1.2, 1.2.3
        pattern: /v\d+(?:\.\d+)*|\d+(?:\.\d+){2,}/,
        alias: "string"
      },
      function: {
        pattern: /(\bsub[ \t]+)\w+/,
        lookbehind: !0
      },
      keyword: /\b(?:any|break|continue|default|delete|die|do|else|elsif|eval|for|foreach|given|goto|if|last|local|my|next|our|package|print|redo|require|return|say|state|sub|switch|undef|unless|until|use|when|while)\b/,
      number: /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)\b/,
      operator: /-[rwxoRWXOezsfdlpSbctugkTBMAC]\b|\+[+=]?|-[-=>]?|\*\*?=?|\/\/?=?|=[=~>]?|~[~=]?|\|\|?=?|&&?=?|<(?:=>?|<=?)?|>>?=?|![~=]?|[%^]=?|\.(?:=|\.\.?)?|[\\?]|\bx(?:=|\b)|\b(?:and|cmp|eq|ge|gt|le|lt|ne|not|or|xor)\b/,
      punctuation: /[{}[\];(),:]/
    };
  })(t);
}
al.displayName = "markup-templating";
al.aliases = [];
function al(t) {
  t.register(ws), function(e) {
    function n(r, a) {
      return "___" + r.toUpperCase() + a + "___";
    }
    Object.defineProperties(e.languages["markup-templating"] = {}, {
      buildPlaceholders: {
        /**
         * Tokenize all inline templating expressions matching `placeholderPattern`.
         *
         * If `replaceFilter` is provided, only matches of `placeholderPattern` for which `replaceFilter` returns
         * `true` will be replaced.
         *
         * @param {object} env The environment of the `before-tokenize` hook.
         * @param {string} language The language id.
         * @param {RegExp} placeholderPattern The matches of this pattern will be replaced by placeholders.
         * @param {(match: string) => boolean} [replaceFilter]
         */
        value: function(r, a, i, o) {
          if (r.language === a) {
            var s = r.tokenStack = [];
            r.code = r.code.replace(i, function(u) {
              if (typeof o == "function" && !o(u))
                return u;
              for (var f = s.length, p; r.code.indexOf(p = n(a, f)) !== -1; )
                ++f;
              return s[f] = u, p;
            }), r.grammar = e.languages.markup;
          }
        }
      },
      tokenizePlaceholders: {
        /**
         * Replace placeholders with proper tokens after tokenizing.
         *
         * @param {object} env The environment of the `after-tokenize` hook.
         * @param {string} language The language id.
         */
        value: function(r, a) {
          if (r.language !== a || !r.tokenStack)
            return;
          r.grammar = e.languages[a];
          var i = 0, o = Object.keys(r.tokenStack);
          function s(u) {
            for (var f = 0; f < u.length && !(i >= o.length); f++) {
              var p = u[f];
              if (typeof p == "string" || p.content && typeof p.content == "string") {
                var m = o[i], v = r.tokenStack[m], O = typeof p == "string" ? p : p.content, w = n(a, m), _ = O.indexOf(w);
                if (_ > -1) {
                  ++i;
                  var C = O.substring(0, _), A = new e.Token(
                    a,
                    e.tokenize(v, r.grammar),
                    "language-" + a,
                    v
                  ), N = O.substring(_ + w.length), P = [];
                  C && P.push.apply(P, s([C])), P.push(A), N && P.push.apply(P, s([N])), typeof p == "string" ? u.splice.apply(u, [f, 1].concat(P)) : p.content = P;
                }
              } else
                p.content && s(p.content);
            }
            return u;
          }
          s(r.tokens);
        }
      }
    });
  }(t);
}
R0.displayName = "php";
R0.aliases = [];
function R0(t) {
  t.register(al), function(e) {
    var n = /\/\*[\s\S]*?\*\/|\/\/.*|#(?!\[).*/, r = [
      {
        pattern: /\b(?:false|true)\b/i,
        alias: "boolean"
      },
      {
        pattern: /(::\s*)\b[a-z_]\w*\b(?!\s*\()/i,
        greedy: !0,
        lookbehind: !0
      },
      {
        pattern: /(\b(?:case|const)\s+)\b[a-z_]\w*(?=\s*[;=])/i,
        greedy: !0,
        lookbehind: !0
      },
      /\b(?:null)\b/i,
      /\b[A-Z_][A-Z0-9_]*\b(?!\s*\()/
    ], a = /\b0b[01]+(?:_[01]+)*\b|\b0o[0-7]+(?:_[0-7]+)*\b|\b0x[\da-f]+(?:_[\da-f]+)*\b|(?:\b\d+(?:_\d+)*\.?(?:\d+(?:_\d+)*)?|\B\.\d+)(?:e[+-]?\d+)?/i, i = /<?=>|\?\?=?|\.{3}|\??->|[!=]=?=?|::|\*\*=?|--|\+\+|&&|\|\||<<|>>|[?~]|[/^|%*&<>.+-]=?/, o = /[{}\[\](),:;]/;
    e.languages.php = {
      delimiter: {
        pattern: /\?>$|^<\?(?:php(?=\s)|=)?/i,
        alias: "important"
      },
      comment: n,
      variable: /\$+(?:\w+\b|(?=\{))/,
      package: {
        pattern: /(namespace\s+|use\s+(?:function\s+)?)(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
        lookbehind: !0,
        inside: {
          punctuation: /\\/
        }
      },
      "class-name-definition": {
        pattern: /(\b(?:class|enum|interface|trait)\s+)\b[a-z_]\w*(?!\\)\b/i,
        lookbehind: !0,
        alias: "class-name"
      },
      "function-definition": {
        pattern: /(\bfunction\s+)[a-z_]\w*(?=\s*\()/i,
        lookbehind: !0,
        alias: "function"
      },
      keyword: [
        {
          pattern: /(\(\s*)\b(?:array|bool|boolean|float|int|integer|object|string)\b(?=\s*\))/i,
          alias: "type-casting",
          greedy: !0,
          lookbehind: !0
        },
        {
          pattern: /([(,?]\s*)\b(?:array(?!\s*\()|bool|callable|(?:false|null)(?=\s*\|)|float|int|iterable|mixed|object|self|static|string)\b(?=\s*\$)/i,
          alias: "type-hint",
          greedy: !0,
          lookbehind: !0
        },
        {
          pattern: /(\)\s*:\s*(?:\?\s*)?)\b(?:array(?!\s*\()|bool|callable|(?:false|null)(?=\s*\|)|float|int|iterable|mixed|never|object|self|static|string|void)\b/i,
          alias: "return-type",
          greedy: !0,
          lookbehind: !0
        },
        {
          pattern: /\b(?:array(?!\s*\()|bool|float|int|iterable|mixed|object|string|void)\b/i,
          alias: "type-declaration",
          greedy: !0
        },
        {
          pattern: /(\|\s*)(?:false|null)\b|\b(?:false|null)(?=\s*\|)/i,
          alias: "type-declaration",
          greedy: !0,
          lookbehind: !0
        },
        {
          pattern: /\b(?:parent|self|static)(?=\s*::)/i,
          alias: "static-context",
          greedy: !0
        },
        {
          // yield from
          pattern: /(\byield\s+)from\b/i,
          lookbehind: !0
        },
        // `class` is always a keyword unlike other keywords
        /\bclass\b/i,
        {
          // https://www.php.net/manual/en/reserved.keywords.php
          //
          // keywords cannot be preceded by "->"
          // the complex lookbehind means `(?<!(?:->|::)\s*)`
          pattern: /((?:^|[^\s>:]|(?:^|[^-])>|(?:^|[^:]):)\s*)\b(?:abstract|and|array|as|break|callable|case|catch|clone|const|continue|declare|default|die|do|echo|else|elseif|empty|enddeclare|endfor|endforeach|endif|endswitch|endwhile|enum|eval|exit|extends|final|finally|fn|for|foreach|function|global|goto|if|implements|include|include_once|instanceof|insteadof|interface|isset|list|match|namespace|never|new|or|parent|print|private|protected|public|readonly|require|require_once|return|self|static|switch|throw|trait|try|unset|use|var|while|xor|yield|__halt_compiler)\b/i,
          lookbehind: !0
        }
      ],
      "argument-name": {
        pattern: /([(,]\s*)\b[a-z_]\w*(?=\s*:(?!:))/i,
        lookbehind: !0
      },
      "class-name": [
        {
          pattern: /(\b(?:extends|implements|instanceof|new(?!\s+self|\s+static))\s+|\bcatch\s*\()\b[a-z_]\w*(?!\\)\b/i,
          greedy: !0,
          lookbehind: !0
        },
        {
          pattern: /(\|\s*)\b[a-z_]\w*(?!\\)\b/i,
          greedy: !0,
          lookbehind: !0
        },
        {
          pattern: /\b[a-z_]\w*(?!\\)\b(?=\s*\|)/i,
          greedy: !0
        },
        {
          pattern: /(\|\s*)(?:\\?\b[a-z_]\w*)+\b/i,
          alias: "class-name-fully-qualified",
          greedy: !0,
          lookbehind: !0,
          inside: {
            punctuation: /\\/
          }
        },
        {
          pattern: /(?:\\?\b[a-z_]\w*)+\b(?=\s*\|)/i,
          alias: "class-name-fully-qualified",
          greedy: !0,
          inside: {
            punctuation: /\\/
          }
        },
        {
          pattern: /(\b(?:extends|implements|instanceof|new(?!\s+self\b|\s+static\b))\s+|\bcatch\s*\()(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
          alias: "class-name-fully-qualified",
          greedy: !0,
          lookbehind: !0,
          inside: {
            punctuation: /\\/
          }
        },
        {
          pattern: /\b[a-z_]\w*(?=\s*\$)/i,
          alias: "type-declaration",
          greedy: !0
        },
        {
          pattern: /(?:\\?\b[a-z_]\w*)+(?=\s*\$)/i,
          alias: ["class-name-fully-qualified", "type-declaration"],
          greedy: !0,
          inside: {
            punctuation: /\\/
          }
        },
        {
          pattern: /\b[a-z_]\w*(?=\s*::)/i,
          alias: "static-context",
          greedy: !0
        },
        {
          pattern: /(?:\\?\b[a-z_]\w*)+(?=\s*::)/i,
          alias: ["class-name-fully-qualified", "static-context"],
          greedy: !0,
          inside: {
            punctuation: /\\/
          }
        },
        {
          pattern: /([(,?]\s*)[a-z_]\w*(?=\s*\$)/i,
          alias: "type-hint",
          greedy: !0,
          lookbehind: !0
        },
        {
          pattern: /([(,?]\s*)(?:\\?\b[a-z_]\w*)+(?=\s*\$)/i,
          alias: ["class-name-fully-qualified", "type-hint"],
          greedy: !0,
          lookbehind: !0,
          inside: {
            punctuation: /\\/
          }
        },
        {
          pattern: /(\)\s*:\s*(?:\?\s*)?)\b[a-z_]\w*(?!\\)\b/i,
          alias: "return-type",
          greedy: !0,
          lookbehind: !0
        },
        {
          pattern: /(\)\s*:\s*(?:\?\s*)?)(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
          alias: ["class-name-fully-qualified", "return-type"],
          greedy: !0,
          lookbehind: !0,
          inside: {
            punctuation: /\\/
          }
        }
      ],
      constant: r,
      function: {
        pattern: /(^|[^\\\w])\\?[a-z_](?:[\w\\]*\w)?(?=\s*\()/i,
        lookbehind: !0,
        inside: {
          punctuation: /\\/
        }
      },
      property: {
        pattern: /(->\s*)\w+/,
        lookbehind: !0
      },
      number: a,
      operator: i,
      punctuation: o
    };
    var s = {
      pattern: /\{\$(?:\{(?:\{[^{}]+\}|[^{}]+)\}|[^{}])+\}|(^|[^\\{])\$+(?:\w+(?:\[[^\r\n\[\]]+\]|->\w+)?)/,
      lookbehind: !0,
      inside: e.languages.php
    }, u = [
      {
        pattern: /<<<'([^']+)'[\r\n](?:.*[\r\n])*?\1;/,
        alias: "nowdoc-string",
        greedy: !0,
        inside: {
          delimiter: {
            pattern: /^<<<'[^']+'|[a-z_]\w*;$/i,
            alias: "symbol",
            inside: {
              punctuation: /^<<<'?|[';]$/
            }
          }
        }
      },
      {
        pattern: /<<<(?:"([^"]+)"[\r\n](?:.*[\r\n])*?\1;|([a-z_]\w*)[\r\n](?:.*[\r\n])*?\2;)/i,
        alias: "heredoc-string",
        greedy: !0,
        inside: {
          delimiter: {
            pattern: /^<<<(?:"[^"]+"|[a-z_]\w*)|[a-z_]\w*;$/i,
            alias: "symbol",
            inside: {
              punctuation: /^<<<"?|[";]$/
            }
          },
          interpolation: s
        }
      },
      {
        pattern: /`(?:\\[\s\S]|[^\\`])*`/,
        alias: "backtick-quoted-string",
        greedy: !0
      },
      {
        pattern: /'(?:\\[\s\S]|[^\\'])*'/,
        alias: "single-quoted-string",
        greedy: !0
      },
      {
        pattern: /"(?:\\[\s\S]|[^\\"])*"/,
        alias: "double-quoted-string",
        greedy: !0,
        inside: {
          interpolation: s
        }
      }
    ];
    e.languages.insertBefore("php", "variable", {
      string: u,
      attribute: {
        pattern: /#\[(?:[^"'\/#]|\/(?![*/])|\/\/.*$|#(?!\[).*$|\/\*(?:[^*]|\*(?!\/))*\*\/|"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*')+\](?=\s*[a-z$#])/im,
        greedy: !0,
        inside: {
          "attribute-content": {
            pattern: /^(#\[)[\s\S]+(?=\]$)/,
            lookbehind: !0,
            // inside can appear subset of php
            inside: {
              comment: n,
              string: u,
              "attribute-class-name": [
                {
                  pattern: /([^:]|^)\b[a-z_]\w*(?!\\)\b/i,
                  alias: "class-name",
                  greedy: !0,
                  lookbehind: !0
                },
                {
                  pattern: /([^:]|^)(?:\\?\b[a-z_]\w*)+/i,
                  alias: ["class-name", "class-name-fully-qualified"],
                  greedy: !0,
                  lookbehind: !0,
                  inside: {
                    punctuation: /\\/
                  }
                }
              ],
              constant: r,
              number: a,
              operator: i,
              punctuation: o
            }
          },
          delimiter: {
            pattern: /^#\[|\]$/,
            alias: "punctuation"
          }
        }
      }
    }), e.hooks.add("before-tokenize", function(f) {
      if (/<\?/.test(f.code)) {
        var p = /<\?(?:[^"'/#]|\/(?![*/])|("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|(?:\/\/|#(?!\[))(?:[^?\n\r]|\?(?!>))*(?=$|\?>|[\r\n])|#\[|\/\*(?:[^*]|\*(?!\/))*(?:\*\/|$))*?(?:\?>|$)/g;
        e.languages["markup-templating"].buildPlaceholders(
          f,
          "php",
          p
        );
      }
    }), e.hooks.add("after-tokenize", function(f) {
      e.languages["markup-templating"].tokenizePlaceholders(f, "php");
    });
  }(t);
}
R_.displayName = "python";
R_.aliases = ["py"];
function R_(t) {
  t.languages.python = {
    comment: {
      pattern: /(^|[^\\])#.*/,
      lookbehind: !0,
      greedy: !0
    },
    "string-interpolation": {
      pattern: /(?:f|fr|rf)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i,
      greedy: !0,
      inside: {
        interpolation: {
          // "{" <expression> <optional "!s", "!r", or "!a"> <optional ":" format specifier> "}"
          pattern: /((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/,
          lookbehind: !0,
          inside: {
            "format-spec": {
              pattern: /(:)[^:(){}]+(?=\}$)/,
              lookbehind: !0
            },
            "conversion-option": {
              pattern: /![sra](?=[:}]$)/,
              alias: "punctuation"
            },
            rest: null
          }
        },
        string: /[\s\S]+/
      }
    },
    "triple-quoted-string": {
      pattern: /(?:[rub]|br|rb)?("""|''')[\s\S]*?\1/i,
      greedy: !0,
      alias: "string"
    },
    string: {
      pattern: /(?:[rub]|br|rb)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i,
      greedy: !0
    },
    function: {
      pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,
      lookbehind: !0
    },
    "class-name": {
      pattern: /(\bclass\s+)\w+/i,
      lookbehind: !0
    },
    decorator: {
      pattern: /(^[\t ]*)@\w+(?:\.\w+)*/m,
      lookbehind: !0,
      alias: ["annotation", "punctuation"],
      inside: {
        punctuation: /\./
      }
    },
    keyword: /\b(?:_(?=\s*:)|and|as|assert|async|await|break|case|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|match|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/,
    builtin: /\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/,
    boolean: /\b(?:False|None|True)\b/,
    number: /\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?(?!\w)/i,
    operator: /[-+%=]=?|!=|:=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
    punctuation: /[{}[\];(),.:]/
  }, t.languages.python["string-interpolation"].inside.interpolation.inside.rest = t.languages.python, t.languages.py = t.languages.python;
}
jD.displayName = "r";
jD.aliases = [];
function jD(t) {
  t.languages.r = {
    comment: /#.*/,
    string: {
      pattern: /(['"])(?:\\.|(?!\1)[^\\\r\n])*\1/,
      greedy: !0
    },
    "percent-operator": {
      // Includes user-defined operators
      // and %%, %*%, %/%, %in%, %o%, %x%
      pattern: /%[^%\s]*%/,
      alias: "operator"
    },
    boolean: /\b(?:FALSE|TRUE)\b/,
    ellipsis: /\.\.(?:\.|\d+)/,
    number: [
      /\b(?:Inf|NaN)\b/,
      /(?:\b0x[\dA-Fa-f]+(?:\.\d*)?|\b\d+(?:\.\d*)?|\B\.\d+)(?:[EePp][+-]?\d+)?[iL]?/
    ],
    keyword: /\b(?:NA|NA_character_|NA_complex_|NA_integer_|NA_real_|NULL|break|else|for|function|if|in|next|repeat|while)\b/,
    operator: /->?>?|<(?:=|<?-)?|[>=!]=?|::?|&&?|\|\|?|[+*\/^$@~]/,
    punctuation: /[(){}\[\],;]/
  };
}
I0.displayName = "ruby";
I0.aliases = ["rb"];
function I0(t) {
  t.register(Lr), function(e) {
    e.languages.ruby = e.languages.extend("clike", {
      comment: {
        pattern: /#.*|^=begin\s[\s\S]*?^=end/m,
        greedy: !0
      },
      "class-name": {
        pattern: /(\b(?:class|module)\s+|\bcatch\s+\()[\w.\\]+|\b[A-Z_]\w*(?=\s*\.\s*new\b)/,
        lookbehind: !0,
        inside: {
          punctuation: /[.\\]/
        }
      },
      keyword: /\b(?:BEGIN|END|alias|and|begin|break|case|class|def|define_method|defined|do|each|else|elsif|end|ensure|extend|for|if|in|include|module|new|next|nil|not|or|prepend|private|protected|public|raise|redo|require|rescue|retry|return|self|super|then|throw|undef|unless|until|when|while|yield)\b/,
      operator: /\.{2,3}|&\.|===|<?=>|[!=]?~|(?:&&|\|\||<<|>>|\*\*|[+\-*/%<>!^&|=])=?|[?:]/,
      punctuation: /[(){}[\].,;]/
    }), e.languages.insertBefore("ruby", "operator", {
      "double-colon": {
        pattern: /::/,
        alias: "punctuation"
      }
    });
    var n = {
      pattern: /((?:^|[^\\])(?:\\{2})*)#\{(?:[^{}]|\{[^{}]*\})*\}/,
      lookbehind: !0,
      inside: {
        content: {
          pattern: /^(#\{)[\s\S]+(?=\}$)/,
          lookbehind: !0,
          inside: e.languages.ruby
        },
        delimiter: {
          pattern: /^#\{|\}$/,
          alias: "punctuation"
        }
      }
    };
    delete e.languages.ruby.function;
    var r = "(?:" + [
      /([^a-zA-Z0-9\s{(\[<=])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source,
      /\((?:[^()\\]|\\[\s\S]|\((?:[^()\\]|\\[\s\S])*\))*\)/.source,
      /\{(?:[^{}\\]|\\[\s\S]|\{(?:[^{}\\]|\\[\s\S])*\})*\}/.source,
      /\[(?:[^\[\]\\]|\\[\s\S]|\[(?:[^\[\]\\]|\\[\s\S])*\])*\]/.source,
      /<(?:[^<>\\]|\\[\s\S]|<(?:[^<>\\]|\\[\s\S])*>)*>/.source
    ].join("|") + ")", a = /(?:"(?:\\.|[^"\\\r\n])*"|(?:\b[a-zA-Z_]\w*|[^\s\0-\x7F]+)[?!]?|\$.)/.source;
    e.languages.insertBefore("ruby", "keyword", {
      "regex-literal": [
        {
          pattern: RegExp(
            /%r/.source + r + /[egimnosux]{0,6}/.source
          ),
          greedy: !0,
          inside: {
            interpolation: n,
            regex: /[\s\S]+/
          }
        },
        {
          pattern: /(^|[^/])\/(?!\/)(?:\[[^\r\n\]]+\]|\\.|[^[/\\\r\n])+\/[egimnosux]{0,6}(?=\s*(?:$|[\r\n,.;})#]))/,
          lookbehind: !0,
          greedy: !0,
          inside: {
            interpolation: n,
            regex: /[\s\S]+/
          }
        }
      ],
      variable: /[@$]+[a-zA-Z_]\w*(?:[?!]|\b)/,
      symbol: [
        {
          pattern: RegExp(/(^|[^:]):/.source + a),
          lookbehind: !0,
          greedy: !0
        },
        {
          pattern: RegExp(
            /([\r\n{(,][ \t]*)/.source + a + /(?=:(?!:))/.source
          ),
          lookbehind: !0,
          greedy: !0
        }
      ],
      "method-definition": {
        pattern: /(\bdef\s+)\w+(?:\s*\.\s*\w+)?/,
        lookbehind: !0,
        inside: {
          function: /\b\w+$/,
          keyword: /^self\b/,
          "class-name": /^\w+/,
          punctuation: /\./
        }
      }
    }), e.languages.insertBefore("ruby", "string", {
      "string-literal": [
        {
          pattern: RegExp(/%[qQiIwWs]?/.source + r),
          greedy: !0,
          inside: {
            interpolation: n,
            string: /[\s\S]+/
          }
        },
        {
          pattern: /("|')(?:#\{[^}]+\}|#(?!\{)|\\(?:\r\n|[\s\S])|(?!\1)[^\\#\r\n])*\1/,
          greedy: !0,
          inside: {
            interpolation: n,
            string: /[\s\S]+/
          }
        },
        {
          pattern: /<<[-~]?([a-z_]\w*)[\r\n](?:.*[\r\n])*?[\t ]*\1/i,
          alias: "heredoc-string",
          greedy: !0,
          inside: {
            delimiter: {
              pattern: /^<<[-~]?[a-z_]\w*|\b[a-z_]\w*$/i,
              inside: {
                symbol: /\b\w+/,
                punctuation: /^<<[-~]?/
              }
            },
            interpolation: n,
            string: /[\s\S]+/
          }
        },
        {
          pattern: /<<[-~]?'([a-z_]\w*)'[\r\n](?:.*[\r\n])*?[\t ]*\1/i,
          alias: "heredoc-string",
          greedy: !0,
          inside: {
            delimiter: {
              pattern: /^<<[-~]?'[a-z_]\w*'|\b[a-z_]\w*$/i,
              inside: {
                symbol: /\b\w+/,
                punctuation: /^<<[-~]?'|'$/
              }
            },
            string: /[\s\S]+/
          }
        }
      ],
      "command-literal": [
        {
          pattern: RegExp(/%x/.source + r),
          greedy: !0,
          inside: {
            interpolation: n,
            command: {
              pattern: /[\s\S]+/,
              alias: "string"
            }
          }
        },
        {
          pattern: /`(?:#\{[^}]+\}|#(?!\{)|\\(?:\r\n|[\s\S])|[^\\`#\r\n])*`/,
          greedy: !0,
          inside: {
            interpolation: n,
            command: {
              pattern: /[\s\S]+/,
              alias: "string"
            }
          }
        }
      ]
    }), delete e.languages.ruby.string, e.languages.insertBefore("ruby", "number", {
      builtin: /\b(?:Array|Bignum|Binding|Class|Continuation|Dir|Exception|FalseClass|File|Fixnum|Float|Hash|IO|Integer|MatchData|Method|Module|NilClass|Numeric|Object|Proc|Range|Regexp|Stat|String|Struct|Symbol|TMS|Thread|ThreadGroup|Time|TrueClass)\b/,
      constant: /\b[A-Z][A-Z0-9_]*(?:[?!]|\b)/
    }), e.languages.rb = e.languages.ruby;
  }(t);
}
GD.displayName = "rust";
GD.aliases = [];
function GD(t) {
  (function(e) {
    for (var n = /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\//.source, r = 0; r < 2; r++)
      n = n.replace(/<self>/g, function() {
        return n;
      });
    n = n.replace(/<self>/g, function() {
      return /[^\s\S]/.source;
    }), e.languages.rust = {
      comment: [
        {
          pattern: RegExp(/(^|[^\\])/.source + n),
          lookbehind: !0,
          greedy: !0
        },
        {
          pattern: /(^|[^\\:])\/\/.*/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      string: {
        pattern: /b?"(?:\\[\s\S]|[^\\"])*"|b?r(#*)"(?:[^"]|"(?!\1))*"\1/,
        greedy: !0
      },
      char: {
        pattern: /b?'(?:\\(?:x[0-7][\da-fA-F]|u\{(?:[\da-fA-F]_*){1,6}\}|.)|[^\\\r\n\t'])'/,
        greedy: !0
      },
      attribute: {
        pattern: /#!?\[(?:[^\[\]"]|"(?:\\[\s\S]|[^\\"])*")*\]/,
        greedy: !0,
        alias: "attr-name",
        inside: {
          string: null
          // see below
        }
      },
      // Closure params should not be confused with bitwise OR |
      "closure-params": {
        pattern: /([=(,:]\s*|\bmove\s*)\|[^|]*\||\|[^|]*\|(?=\s*(?:\{|->))/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          "closure-punctuation": {
            pattern: /^\||\|$/,
            alias: "punctuation"
          },
          rest: null
          // see below
        }
      },
      "lifetime-annotation": {
        pattern: /'\w+/,
        alias: "symbol"
      },
      "fragment-specifier": {
        pattern: /(\$\w+:)[a-z]+/,
        lookbehind: !0,
        alias: "punctuation"
      },
      variable: /\$\w+/,
      "function-definition": {
        pattern: /(\bfn\s+)\w+/,
        lookbehind: !0,
        alias: "function"
      },
      "type-definition": {
        pattern: /(\b(?:enum|struct|trait|type|union)\s+)\w+/,
        lookbehind: !0,
        alias: "class-name"
      },
      "module-declaration": [
        {
          pattern: /(\b(?:crate|mod)\s+)[a-z][a-z_\d]*/,
          lookbehind: !0,
          alias: "namespace"
        },
        {
          pattern: /(\b(?:crate|self|super)\s*)::\s*[a-z][a-z_\d]*\b(?:\s*::(?:\s*[a-z][a-z_\d]*\s*::)*)?/,
          lookbehind: !0,
          alias: "namespace",
          inside: {
            punctuation: /::/
          }
        }
      ],
      keyword: [
        // https://github.com/rust-lang/reference/blob/master/src/keywords.md
        /\b(?:Self|abstract|as|async|await|become|box|break|const|continue|crate|do|dyn|else|enum|extern|final|fn|for|if|impl|in|let|loop|macro|match|mod|move|mut|override|priv|pub|ref|return|self|static|struct|super|trait|try|type|typeof|union|unsafe|unsized|use|virtual|where|while|yield)\b/,
        // primitives and str
        // https://doc.rust-lang.org/stable/rust-by-example/primitives.html
        /\b(?:bool|char|f(?:32|64)|[ui](?:8|16|32|64|128|size)|str)\b/
      ],
      // functions can technically start with an upper-case letter, but this will introduce a lot of false positives
      // and Rust's naming conventions recommend snake_case anyway.
      // https://doc.rust-lang.org/1.0.0/style/style/naming/README.html
      function: /\b[a-z_]\w*(?=\s*(?:::\s*<|\())/,
      macro: {
        pattern: /\b\w+!/,
        alias: "property"
      },
      constant: /\b[A-Z_][A-Z_\d]+\b/,
      "class-name": /\b[A-Z]\w*\b/,
      namespace: {
        pattern: /(?:\b[a-z][a-z_\d]*\s*::\s*)*\b[a-z][a-z_\d]*\s*::(?!\s*<)/,
        inside: {
          punctuation: /::/
        }
      },
      // Hex, oct, bin, dec numbers with visual separators and type suffix
      number: /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0o[0-7](?:_?[0-7])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)(?:_?(?:f32|f64|[iu](?:8|16|32|64|size)?))?\b/,
      boolean: /\b(?:false|true)\b/,
      punctuation: /->|\.\.=|\.{1,3}|::|[{}[\];(),:]/,
      operator: /[-+*\/%!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?=?|[@?]/
    }, e.languages.rust["closure-params"].inside.rest = e.languages.rust, e.languages.rust.attribute.inside.string = e.languages.rust.string;
  })(t);
}
VD.displayName = "sass";
VD.aliases = [];
function VD(t) {
  t.register(pv), function(e) {
    e.languages.sass = e.languages.extend("css", {
      // Sass comments don't need to be closed, only indented
      comment: {
        pattern: /^([ \t]*)\/[\/*].*(?:(?:\r?\n|\r)\1[ \t].+)*/m,
        lookbehind: !0,
        greedy: !0
      }
    }), e.languages.insertBefore("sass", "atrule", {
      // We want to consume the whole line
      "atrule-line": {
        // Includes support for = and + shortcuts
        pattern: /^(?:[ \t]*)[@+=].+/m,
        greedy: !0,
        inside: {
          atrule: /(?:@[\w-]+|[+=])/
        }
      }
    }), delete e.languages.sass.atrule;
    var n = /\$[-\w]+|#\{\$[-\w]+\}/, r = [
      /[+*\/%]|[=!]=|<=?|>=?|\b(?:and|not|or)\b/,
      {
        pattern: /(\s)-(?=\s)/,
        lookbehind: !0
      }
    ];
    e.languages.insertBefore("sass", "property", {
      // We want to consume the whole line
      "variable-line": {
        pattern: /^[ \t]*\$.+/m,
        greedy: !0,
        inside: {
          punctuation: /:/,
          variable: n,
          operator: r
        }
      },
      // We want to consume the whole line
      "property-line": {
        pattern: /^[ \t]*(?:[^:\s]+ *:.*|:[^:\s].*)/m,
        greedy: !0,
        inside: {
          property: [
            /[^:\s]+(?=\s*:)/,
            {
              pattern: /(:)[^:\s]+/,
              lookbehind: !0
            }
          ],
          punctuation: /:/,
          variable: n,
          operator: r,
          important: e.languages.sass.important
        }
      }
    }), delete e.languages.sass.property, delete e.languages.sass.important, e.languages.insertBefore("sass", "punctuation", {
      selector: {
        pattern: /^([ \t]*)\S(?:,[^,\r\n]+|[^,\r\n]*)(?:,[^,\r\n]+)*(?:,(?:\r?\n|\r)\1[ \t]+\S(?:,[^,\r\n]+|[^,\r\n]*)(?:,[^,\r\n]+)*)*/m,
        lookbehind: !0,
        greedy: !0
      }
    });
  }(t);
}
YD.displayName = "scss";
YD.aliases = [];
function YD(t) {
  t.register(pv), t.languages.scss = t.languages.extend("css", {
    comment: {
      pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
      lookbehind: !0
    },
    atrule: {
      pattern: /@[\w-](?:\([^()]+\)|[^()\s]|\s+(?!\s))*?(?=\s+[{;])/,
      inside: {
        rule: /@[\w-]+/
        // See rest below
      }
    },
    // url, compassified
    url: /(?:[-a-z]+-)?url(?=\()/i,
    // CSS selector regex is not appropriate for Sass
    // since there can be lot more things (var, @ directive, nesting..)
    // a selector must start at the end of a property or after a brace (end of other rules or nesting)
    // it can contain some characters that aren't used for defining rules or end of selector, & (parent selector), or interpolated variable
    // the end of a selector is found when there is no rules in it ( {} or {\s}) or if there is a property (because an interpolated var
    // can "pass" as a selector- e.g: proper#{$erty})
    // this one was hard to do, so please be careful if you edit this one :)
    selector: {
      // Initial look-ahead is used to prevent matching of blank selectors
      pattern: /(?=\S)[^@;{}()]?(?:[^@;{}()\s]|\s+(?!\s)|#\{\$[-\w]+\})+(?=\s*\{(?:\}|\s|[^}][^:{}]*[:{][^}]))/,
      inside: {
        parent: {
          pattern: /&/,
          alias: "important"
        },
        placeholder: /%[-\w]+/,
        variable: /\$[-\w]+|#\{\$[-\w]+\}/
      }
    },
    property: {
      pattern: /(?:[-\w]|\$[-\w]|#\{\$[-\w]+\})+(?=\s*:)/,
      inside: {
        variable: /\$[-\w]+|#\{\$[-\w]+\}/
      }
    }
  }), t.languages.insertBefore("scss", "atrule", {
    keyword: [
      /@(?:content|debug|each|else(?: if)?|extend|for|forward|function|if|import|include|mixin|return|use|warn|while)\b/i,
      {
        pattern: /( )(?:from|through)(?= )/,
        lookbehind: !0
      }
    ]
  }), t.languages.insertBefore("scss", "important", {
    // var and interpolated vars
    variable: /\$[-\w]+|#\{\$[-\w]+\}/
  }), t.languages.insertBefore("scss", "function", {
    "module-modifier": {
      pattern: /\b(?:as|hide|show|with)\b/i,
      alias: "keyword"
    },
    placeholder: {
      pattern: /%[-\w]+/,
      alias: "selector"
    },
    statement: {
      pattern: /\B!(?:default|optional)\b/i,
      alias: "keyword"
    },
    boolean: /\b(?:false|true)\b/,
    null: {
      pattern: /\bnull\b/,
      alias: "keyword"
    },
    operator: {
      pattern: /(\s)(?:[-+*\/%]|[=!]=|<=?|>=?|and|not|or)(?=\s)/,
      lookbehind: !0
    }
  }), t.languages.scss.atrule.inside.rest = t.languages.scss;
}
v1.displayName = "sql";
v1.aliases = [];
function v1(t) {
  t.languages.sql = {
    comment: {
      pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
      lookbehind: !0
    },
    variable: [
      {
        pattern: /@(["'`])(?:\\[\s\S]|(?!\1)[^\\])+\1/,
        greedy: !0
      },
      /@[\w.$]+/
    ],
    string: {
      pattern: /(^|[^@\\])("|')(?:\\[\s\S]|(?!\2)[^\\]|\2\2)*\2/,
      greedy: !0,
      lookbehind: !0
    },
    identifier: {
      pattern: /(^|[^@\\])`(?:\\[\s\S]|[^`\\]|``)*`/,
      greedy: !0,
      lookbehind: !0,
      inside: {
        punctuation: /^`|`$/
      }
    },
    function: /\b(?:AVG|COUNT|FIRST|FORMAT|LAST|LCASE|LEN|MAX|MID|MIN|MOD|NOW|ROUND|SUM|UCASE)(?=\s*\()/i,
    // Should we highlight user defined functions too?
    keyword: /\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:COL|_INSERT)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURN(?:ING|S)?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)\b/i,
    boolean: /\b(?:FALSE|NULL|TRUE)\b/i,
    number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
    operator: /[-+*\/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?|\b(?:AND|BETWEEN|DIV|ILIKE|IN|IS|LIKE|NOT|OR|REGEXP|RLIKE|SOUNDS LIKE|XOR)\b/i,
    punctuation: /[;[\]()`,.]/
  };
}
ZD.displayName = "swift";
ZD.aliases = [];
function ZD(t) {
  t.languages.swift = {
    comment: {
      // Nested comments are supported up to 2 levels
      pattern: /(^|[^\\:])(?:\/\/.*|\/\*(?:[^/*]|\/(?!\*)|\*(?!\/)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\/)/,
      lookbehind: !0,
      greedy: !0
    },
    "string-literal": [
      // https://docs.swift.org/swift-book/LanguageGuide/StringsAndCharacters.html
      {
        pattern: RegExp(
          /(^|[^"#])/.source + "(?:" + // single-line string
          /"(?:\\(?:\((?:[^()]|\([^()]*\))*\)|\r\n|[^(])|[^\\\r\n"])*"/.source + "|" + // multi-line string
          /"""(?:\\(?:\((?:[^()]|\([^()]*\))*\)|[^(])|[^\\"]|"(?!""))*"""/.source + ")" + /(?!["#])/.source
        ),
        lookbehind: !0,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /(\\\()(?:[^()]|\([^()]*\))*(?=\))/,
            lookbehind: !0,
            inside: null
            // see below
          },
          "interpolation-punctuation": {
            pattern: /^\)|\\\($/,
            alias: "punctuation"
          },
          punctuation: /\\(?=[\r\n])/,
          string: /[\s\S]+/
        }
      },
      {
        pattern: RegExp(
          /(^|[^"#])(#+)/.source + "(?:" + // single-line string
          /"(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|\r\n|[^#])|[^\\\r\n])*?"/.source + "|" + // multi-line string
          /"""(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|[^#])|[^\\])*?"""/.source + ")\\2"
        ),
        lookbehind: !0,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /(\\#+\()(?:[^()]|\([^()]*\))*(?=\))/,
            lookbehind: !0,
            inside: null
            // see below
          },
          "interpolation-punctuation": {
            pattern: /^\)|\\#+\($/,
            alias: "punctuation"
          },
          string: /[\s\S]+/
        }
      }
    ],
    directive: {
      // directives with conditions
      pattern: RegExp(
        /#/.source + "(?:" + (/(?:elseif|if)\b/.source + "(?:[ 	]*" + // This regex is a little complex. It's equivalent to this:
        //   (?:![ \t]*)?(?:\b\w+\b(?:[ \t]*<round>)?|<round>)(?:[ \t]*(?:&&|\|\|))?
        // where <round> is a general parentheses expression.
        /(?:![ \t]*)?(?:\b\w+\b(?:[ \t]*\((?:[^()]|\([^()]*\))*\))?|\((?:[^()]|\([^()]*\))*\))(?:[ \t]*(?:&&|\|\|))?/.source + ")+") + "|" + /(?:else|endif)\b/.source + ")"
      ),
      alias: "property",
      inside: {
        "directive-name": /^#\w+/,
        boolean: /\b(?:false|true)\b/,
        number: /\b\d+(?:\.\d+)*\b/,
        operator: /!|&&|\|\||[<>]=?/,
        punctuation: /[(),]/
      }
    },
    literal: {
      pattern: /#(?:colorLiteral|column|dsohandle|file(?:ID|Literal|Path)?|function|imageLiteral|line)\b/,
      alias: "constant"
    },
    "other-directive": {
      pattern: /#\w+\b/,
      alias: "property"
    },
    attribute: {
      pattern: /@\w+/,
      alias: "atrule"
    },
    "function-definition": {
      pattern: /(\bfunc\s+)\w+/,
      lookbehind: !0,
      alias: "function"
    },
    label: {
      // https://docs.swift.org/swift-book/LanguageGuide/ControlFlow.html#ID141
      pattern: /\b(break|continue)\s+\w+|\b[a-zA-Z_]\w*(?=\s*:\s*(?:for|repeat|while)\b)/,
      lookbehind: !0,
      alias: "important"
    },
    keyword: /\b(?:Any|Protocol|Self|Type|actor|as|assignment|associatedtype|associativity|async|await|break|case|catch|class|continue|convenience|default|defer|deinit|didSet|do|dynamic|else|enum|extension|fallthrough|fileprivate|final|for|func|get|guard|higherThan|if|import|in|indirect|infix|init|inout|internal|is|isolated|lazy|left|let|lowerThan|mutating|none|nonisolated|nonmutating|open|operator|optional|override|postfix|precedencegroup|prefix|private|protocol|public|repeat|required|rethrows|return|right|safe|self|set|some|static|struct|subscript|super|switch|throw|throws|try|typealias|unowned|unsafe|var|weak|where|while|willSet)\b/,
    boolean: /\b(?:false|true)\b/,
    nil: {
      pattern: /\bnil\b/,
      alias: "constant"
    },
    "short-argument": /\$\d+\b/,
    omit: {
      pattern: /\b_\b/,
      alias: "keyword"
    },
    number: /\b(?:[\d_]+(?:\.[\de_]+)?|0x[a-f0-9_]+(?:\.[a-f0-9p_]+)?|0b[01_]+|0o[0-7_]+)\b/i,
    // A class name must start with an upper-case letter and be either 1 letter long or contain a lower-case letter.
    "class-name": /\b[A-Z](?:[A-Z_\d]*[a-z]\w*)?\b/,
    function: /\b[a-z_]\w*(?=\s*\()/i,
    constant: /\b(?:[A-Z_]{2,}|k[A-Z][A-Za-z_]+)\b/,
    // Operators are generic in Swift. Developers can even create new operators (e.g. +++).
    // https://docs.swift.org/swift-book/ReferenceManual/zzSummaryOfTheGrammar.html#ID481
    // This regex only supports ASCII operators.
    operator: /[-+*/%=!<>&|^~?]+|\.[.\-+*/%=!<>&|^~?]+/,
    punctuation: /[{}[\]();,.:\\]/
  }, t.languages.swift["string-literal"].forEach(function(e) {
    e.inside.interpolation.inside = t.languages.swift;
  });
}
y1.displayName = "typescript";
y1.aliases = ["ts"];
function y1(t) {
  t.register(rl), function(e) {
    e.languages.typescript = e.languages.extend("javascript", {
      "class-name": {
        pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,
        lookbehind: !0,
        greedy: !0,
        inside: null
        // see below
      },
      builtin: /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/
    }), e.languages.typescript.keyword.push(
      /\b(?:abstract|declare|is|keyof|readonly|require)\b/,
      // keywords that have to be followed by an identifier
      /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/,
      // This is for `import type *, {}`
      /\btype\b(?=\s*(?:[\{*]|$))/
    ), delete e.languages.typescript.parameter, delete e.languages.typescript["literal-property"];
    var n = e.languages.extend("typescript", {});
    delete n["class-name"], e.languages.typescript["class-name"].inside = n, e.languages.insertBefore("typescript", "function", {
      decorator: {
        pattern: /@[$\w\xA0-\uFFFF]+/,
        inside: {
          at: {
            pattern: /^@/,
            alias: "operator"
          },
          function: /^[\s\S]+/
        }
      },
      "generic-function": {
        // e.g. foo<T extends "bar" | "baz">( ...
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,
        greedy: !0,
        inside: {
          function: /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,
          generic: {
            pattern: /<[\s\S]+/,
            // everything after the first <
            alias: "class-name",
            inside: n
          }
        }
      }
    }), e.languages.ts = e.languages.typescript;
  }(t);
}
I_.displayName = "basic";
I_.aliases = [];
function I_(t) {
  t.languages.basic = {
    comment: {
      pattern: /(?:!|REM\b).+/i,
      inside: {
        keyword: /^REM/i
      }
    },
    string: {
      pattern: /"(?:""|[!#$%&'()*,\/:;<=>?^\w +\-.])*"/,
      greedy: !0
    },
    number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
    keyword: /\b(?:AS|BEEP|BLOAD|BSAVE|CALL(?: ABSOLUTE)?|CASE|CHAIN|CHDIR|CLEAR|CLOSE|CLS|COM|COMMON|CONST|DATA|DECLARE|DEF(?: FN| SEG|DBL|INT|LNG|SNG|STR)|DIM|DO|DOUBLE|ELSE|ELSEIF|END|ENVIRON|ERASE|ERROR|EXIT|FIELD|FILES|FOR|FUNCTION|GET|GOSUB|GOTO|IF|INPUT|INTEGER|IOCTL|KEY|KILL|LINE INPUT|LOCATE|LOCK|LONG|LOOP|LSET|MKDIR|NAME|NEXT|OFF|ON(?: COM| ERROR| KEY| TIMER)?|OPEN|OPTION BASE|OUT|POKE|PUT|READ|REDIM|REM|RESTORE|RESUME|RETURN|RMDIR|RSET|RUN|SELECT CASE|SHARED|SHELL|SINGLE|SLEEP|STATIC|STEP|STOP|STRING|SUB|SWAP|SYSTEM|THEN|TIMER|TO|TROFF|TRON|TYPE|UNLOCK|UNTIL|USING|VIEW PRINT|WAIT|WEND|WHILE|WRITE)(?:\$|\b)/i,
    function: /\b(?:ABS|ACCESS|ACOS|ANGLE|AREA|ARITHMETIC|ARRAY|ASIN|ASK|AT|ATN|BASE|BEGIN|BREAK|CAUSE|CEIL|CHR|CLIP|COLLATE|COLOR|CON|COS|COSH|COT|CSC|DATE|DATUM|DEBUG|DECIMAL|DEF|DEG|DEGREES|DELETE|DET|DEVICE|DISPLAY|DOT|ELAPSED|EPS|ERASABLE|EXLINE|EXP|EXTERNAL|EXTYPE|FILETYPE|FIXED|FP|GO|GRAPH|HANDLER|IDN|IMAGE|IN|INT|INTERNAL|IP|IS|KEYED|LBOUND|LCASE|LEFT|LEN|LENGTH|LET|LINE|LINES|LOG|LOG10|LOG2|LTRIM|MARGIN|MAT|MAX|MAXNUM|MID|MIN|MISSING|MOD|NATIVE|NUL|NUMERIC|OF|OPTION|ORD|ORGANIZATION|OUTIN|OUTPUT|PI|POINT|POINTER|POINTS|POS|PRINT|PROGRAM|PROMPT|RAD|RADIANS|RANDOMIZE|RECORD|RECSIZE|RECTYPE|RELATIVE|REMAINDER|REPEAT|REST|RETRY|REWRITE|RIGHT|RND|ROUND|RTRIM|SAME|SEC|SELECT|SEQUENTIAL|SET|SETTER|SGN|SIN|SINH|SIZE|SKIP|SQR|STANDARD|STATUS|STR|STREAM|STYLE|TAB|TAN|TANH|TEMPLATE|TEXT|THERE|TIME|TIMEOUT|TRACE|TRANSFORM|TRUNCATE|UBOUND|UCASE|USE|VAL|VARIABLE|VIEWPORT|WHEN|WINDOW|WITH|ZER|ZONEWIDTH)(?:\$|\b)/i,
    operator: /<[=>]?|>=?|[+\-*\/^=&]|\b(?:AND|EQV|IMP|NOT|OR|XOR)\b/i,
    punctuation: /[,;:()]/
  };
}
D_.displayName = "vbnet";
D_.aliases = [];
function D_(t) {
  t.register(I_), t.languages.vbnet = t.languages.extend("basic", {
    comment: [
      {
        pattern: /(?:!|REM\b).+/i,
        inside: {
          keyword: /^REM/i
        }
      },
      {
        pattern: /(^|[^\\:])'.*/,
        lookbehind: !0,
        greedy: !0
      }
    ],
    string: {
      pattern: /(^|[^"])"(?:""|[^"])*"(?!")/,
      lookbehind: !0,
      greedy: !0
    },
    keyword: /(?:\b(?:ADDHANDLER|ADDRESSOF|ALIAS|AND|ANDALSO|AS|BEEP|BLOAD|BOOLEAN|BSAVE|BYREF|BYTE|BYVAL|CALL(?: ABSOLUTE)?|CASE|CATCH|CBOOL|CBYTE|CCHAR|CDATE|CDBL|CDEC|CHAIN|CHAR|CHDIR|CINT|CLASS|CLEAR|CLNG|CLOSE|CLS|COBJ|COM|COMMON|CONST|CONTINUE|CSBYTE|CSHORT|CSNG|CSTR|CTYPE|CUINT|CULNG|CUSHORT|DATA|DATE|DECIMAL|DECLARE|DEF(?: FN| SEG|DBL|INT|LNG|SNG|STR)|DEFAULT|DELEGATE|DIM|DIRECTCAST|DO|DOUBLE|ELSE|ELSEIF|END|ENUM|ENVIRON|ERASE|ERROR|EVENT|EXIT|FALSE|FIELD|FILES|FINALLY|FOR(?: EACH)?|FRIEND|FUNCTION|GET|GETTYPE|GETXMLNAMESPACE|GLOBAL|GOSUB|GOTO|HANDLES|IF|IMPLEMENTS|IMPORTS|IN|INHERITS|INPUT|INTEGER|INTERFACE|IOCTL|IS|ISNOT|KEY|KILL|LET|LIB|LIKE|LINE INPUT|LOCATE|LOCK|LONG|LOOP|LSET|ME|MKDIR|MOD|MODULE|MUSTINHERIT|MUSTOVERRIDE|MYBASE|MYCLASS|NAME|NAMESPACE|NARROWING|NEW|NEXT|NOT|NOTHING|NOTINHERITABLE|NOTOVERRIDABLE|OBJECT|OF|OFF|ON(?: COM| ERROR| KEY| TIMER)?|OPEN|OPERATOR|OPTION(?: BASE)?|OPTIONAL|OR|ORELSE|OUT|OVERLOADS|OVERRIDABLE|OVERRIDES|PARAMARRAY|PARTIAL|POKE|PRIVATE|PROPERTY|PROTECTED|PUBLIC|PUT|RAISEEVENT|READ|READONLY|REDIM|REM|REMOVEHANDLER|RESTORE|RESUME|RETURN|RMDIR|RSET|RUN|SBYTE|SELECT(?: CASE)?|SET|SHADOWS|SHARED|SHELL|SHORT|SINGLE|SLEEP|STATIC|STEP|STOP|STRING|STRUCTURE|SUB|SWAP|SYNCLOCK|SYSTEM|THEN|THROW|TIMER|TO|TROFF|TRON|TRUE|TRY|TRYCAST|TYPE|TYPEOF|UINTEGER|ULONG|UNLOCK|UNTIL|USHORT|USING|VIEW PRINT|WAIT|WEND|WHEN|WHILE|WIDENING|WITH|WITHEVENTS|WRITE|WRITEONLY|XOR)|\B(?:#CONST|#ELSE|#ELSEIF|#END|#IF))(?:\$|\b)/i,
    punctuation: /[,;:(){}]/
  });
}
class N_ {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(e, n, r) {
    this.property = e, this.normal = n, r && (this.space = r);
  }
}
N_.prototype.property = {};
N_.prototype.normal = {};
N_.prototype.space = null;
function zle(t, e) {
  const n = {}, r = {};
  let a = -1;
  for (; ++a < t.length; )
    Object.assign(n, t[a].property), Object.assign(r, t[a].normal);
  return new N_(n, r, e);
}
function b0(t) {
  return t.toLowerCase();
}
class td {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(e, n) {
    this.property = e, this.attribute = n;
  }
}
td.prototype.space = null;
td.prototype.boolean = !1;
td.prototype.booleanish = !1;
td.prototype.overloadedBoolean = !1;
td.prototype.number = !1;
td.prototype.commaSeparated = !1;
td.prototype.spaceSeparated = !1;
td.prototype.commaOrSpaceSeparated = !1;
td.prototype.mustUseProperty = !1;
td.prototype.defined = !1;
let m5e = 0;
const gr = D0(), Ro = D0(), Hle = D0(), $t = D0(), ri = D0(), NE = D0(), Nc = D0();
function D0() {
  return 2 ** ++m5e;
}
const r5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: gr,
  booleanish: Ro,
  commaOrSpaceSeparated: Nc,
  commaSeparated: NE,
  number: $t,
  overloadedBoolean: Hle,
  spaceSeparated: ri
}, Symbol.toStringTag, { value: "Module" })), B3 = Object.keys(r5);
class F6 extends td {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(e, n, r, a) {
    let i = -1;
    if (super(e, n), jK(this, "space", a), typeof r == "number")
      for (; ++i < B3.length; ) {
        const o = B3[i];
        jK(this, B3[i], (r & r5[o]) === r5[o]);
      }
  }
}
F6.prototype.defined = !0;
function jK(t, e, n) {
  n && (t[e] = n);
}
const g5e = {}.hasOwnProperty;
function O1(t) {
  const e = {}, n = {};
  let r;
  for (r in t.properties)
    if (g5e.call(t.properties, r)) {
      const a = t.properties[r], i = new F6(
        r,
        t.transform(t.attributes || {}, r),
        a,
        t.space
      );
      t.mustUseProperty && t.mustUseProperty.includes(r) && (i.mustUseProperty = !0), e[r] = i, n[b0(r)] = r, n[b0(i.attribute)] = r;
    }
  return new N_(e, n, t.space);
}
const Wle = O1({
  space: "xlink",
  transform(t, e) {
    return "xlink:" + e.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), Qle = O1({
  space: "xml",
  transform(t, e) {
    return "xml:" + e.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function jle(t, e) {
  return e in t ? t[e] : e;
}
function Gle(t, e) {
  return jle(t, e.toLowerCase());
}
const Vle = O1({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: Gle,
  properties: { xmlns: null, xmlnsXLink: null }
}), Yle = O1({
  transform(t, e) {
    return e === "role" ? e : "aria-" + e.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: Ro,
    ariaAutoComplete: null,
    ariaBusy: Ro,
    ariaChecked: Ro,
    ariaColCount: $t,
    ariaColIndex: $t,
    ariaColSpan: $t,
    ariaControls: ri,
    ariaCurrent: null,
    ariaDescribedBy: ri,
    ariaDetails: null,
    ariaDisabled: Ro,
    ariaDropEffect: ri,
    ariaErrorMessage: null,
    ariaExpanded: Ro,
    ariaFlowTo: ri,
    ariaGrabbed: Ro,
    ariaHasPopup: null,
    ariaHidden: Ro,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: ri,
    ariaLevel: $t,
    ariaLive: null,
    ariaModal: Ro,
    ariaMultiLine: Ro,
    ariaMultiSelectable: Ro,
    ariaOrientation: null,
    ariaOwns: ri,
    ariaPlaceholder: null,
    ariaPosInSet: $t,
    ariaPressed: Ro,
    ariaReadOnly: Ro,
    ariaRelevant: null,
    ariaRequired: Ro,
    ariaRoleDescription: ri,
    ariaRowCount: $t,
    ariaRowIndex: $t,
    ariaRowSpan: $t,
    ariaSelected: Ro,
    ariaSetSize: $t,
    ariaSort: null,
    ariaValueMax: $t,
    ariaValueMin: $t,
    ariaValueNow: $t,
    ariaValueText: null,
    role: null
  }
}), b5e = O1({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: Gle,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: NE,
    acceptCharset: ri,
    accessKey: ri,
    action: null,
    allow: null,
    allowFullScreen: gr,
    allowPaymentRequest: gr,
    allowUserMedia: gr,
    alt: null,
    as: null,
    async: gr,
    autoCapitalize: null,
    autoComplete: ri,
    autoFocus: gr,
    autoPlay: gr,
    blocking: ri,
    capture: gr,
    charSet: null,
    checked: gr,
    cite: null,
    className: ri,
    cols: $t,
    colSpan: null,
    content: null,
    contentEditable: Ro,
    controls: gr,
    controlsList: ri,
    coords: $t | NE,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: gr,
    defer: gr,
    dir: null,
    dirName: null,
    disabled: gr,
    download: Hle,
    draggable: Ro,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: gr,
    formTarget: null,
    headers: ri,
    height: $t,
    hidden: gr,
    high: $t,
    href: null,
    hrefLang: null,
    htmlFor: ri,
    httpEquiv: ri,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: gr,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: gr,
    itemId: null,
    itemProp: ri,
    itemRef: ri,
    itemScope: gr,
    itemType: ri,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: gr,
    low: $t,
    manifest: null,
    max: null,
    maxLength: $t,
    media: null,
    method: null,
    min: null,
    minLength: $t,
    multiple: gr,
    muted: gr,
    name: null,
    nonce: null,
    noModule: gr,
    noValidate: gr,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: gr,
    optimum: $t,
    pattern: null,
    ping: ri,
    placeholder: null,
    playsInline: gr,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: gr,
    referrerPolicy: null,
    rel: ri,
    required: gr,
    reversed: gr,
    rows: $t,
    rowSpan: $t,
    sandbox: ri,
    scope: null,
    scoped: gr,
    seamless: gr,
    selected: gr,
    shape: null,
    size: $t,
    sizes: null,
    slot: null,
    span: $t,
    spellCheck: Ro,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: $t,
    step: null,
    style: null,
    tabIndex: $t,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: gr,
    useMap: null,
    value: Ro,
    width: $t,
    wrap: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: ri,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: $t,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: $t,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: gr,
    // Lists. Use CSS to reduce space between items instead
    declare: gr,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: $t,
    // `<img>` and `<object>`
    leftMargin: $t,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: $t,
    // `<body>`
    marginWidth: $t,
    // `<body>`
    noResize: gr,
    // `<frame>`
    noHref: gr,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: gr,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: gr,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: $t,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: Ro,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: $t,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: $t,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: gr,
    disableRemotePlayback: gr,
    prefix: null,
    property: null,
    results: $t,
    security: null,
    unselectable: null
  }
}), v5e = O1({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: jle,
  properties: {
    about: Nc,
    accentHeight: $t,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: $t,
    amplitude: $t,
    arabicForm: null,
    ascent: $t,
    attributeName: null,
    attributeType: null,
    azimuth: $t,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: $t,
    by: null,
    calcMode: null,
    capHeight: $t,
    className: ri,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: $t,
    diffuseConstant: $t,
    direction: null,
    display: null,
    dur: null,
    divisor: $t,
    dominantBaseline: null,
    download: gr,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: $t,
    enableBackground: null,
    end: null,
    event: null,
    exponent: $t,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: $t,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: NE,
    g2: NE,
    glyphName: NE,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: $t,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: $t,
    horizOriginX: $t,
    horizOriginY: $t,
    id: null,
    ideographic: $t,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: $t,
    k: $t,
    k1: $t,
    k2: $t,
    k3: $t,
    k4: $t,
    kernelMatrix: Nc,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: $t,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: $t,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: $t,
    overlineThickness: $t,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: $t,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: ri,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: $t,
    pointsAtY: $t,
    pointsAtZ: $t,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: Nc,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: Nc,
    rev: Nc,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: Nc,
    requiredFeatures: Nc,
    requiredFonts: Nc,
    requiredFormats: Nc,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: $t,
    specularExponent: $t,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: $t,
    strikethroughThickness: $t,
    string: null,
    stroke: null,
    strokeDashArray: Nc,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: $t,
    strokeOpacity: $t,
    strokeWidth: null,
    style: null,
    surfaceScale: $t,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: Nc,
    tabIndex: $t,
    tableValues: null,
    target: null,
    targetX: $t,
    targetY: $t,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: Nc,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: $t,
    underlineThickness: $t,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: $t,
    values: null,
    vAlphabetic: $t,
    vMathematical: $t,
    vectorEffect: null,
    vHanging: $t,
    vIdeographic: $t,
    version: null,
    vertAdvY: $t,
    vertOriginX: $t,
    vertOriginY: $t,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: $t,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), y5e = /^data[-\w.:]+$/i, GK = /-[a-z]/g, O5e = /[A-Z]/g;
function E1(t, e) {
  const n = b0(e);
  let r = e, a = td;
  if (n in t.normal)
    return t.property[t.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && y5e.test(e)) {
    if (e.charAt(4) === "-") {
      const i = e.slice(5).replace(GK, S5e);
      r = "data" + i.charAt(0).toUpperCase() + i.slice(1);
    } else {
      const i = e.slice(4);
      if (!GK.test(i)) {
        let o = i.replace(O5e, E5e);
        o.charAt(0) !== "-" && (o = "-" + o), e = "data" + o;
      }
    }
    a = F6;
  }
  return new a(r, e);
}
function E5e(t) {
  return "-" + t.toLowerCase();
}
function S5e(t) {
  return t.charAt(1).toUpperCase();
}
const w5e = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, N0 = zle([Qle, Wle, Vle, Yle, b5e], "html"), og = zle([Qle, Wle, Vle, Yle, v5e], "svg"), VK = /[#.]/g;
function T5e(t, e) {
  const n = t || "", r = {};
  let a = 0, i, o;
  for (; a < n.length; ) {
    VK.lastIndex = a;
    const s = VK.exec(n), u = n.slice(a, s ? s.index : n.length);
    u && (i ? i === "#" ? r.id = u : Array.isArray(r.className) ? r.className.push(u) : r.className = [u] : o = u, a += u.length), s && (i = s[0], a++);
  }
  return {
    type: "element",
    // @ts-expect-error: fine.
    tagName: o || e || "div",
    properties: r,
    children: []
  };
}
function YK(t) {
  const e = String(t || "").trim();
  return e ? e.split(/[ \t\n\r\f]+/g) : [];
}
function a_(t) {
  const e = [], n = String(t || "");
  let r = n.indexOf(","), a = 0, i = !1;
  for (; !i; ) {
    r === -1 && (r = n.length, i = !0);
    const o = n.slice(a, r).trim();
    (o || !i) && e.push(o), a = r + 1, r = n.indexOf(",", a);
  }
  return e;
}
function $6(t, e) {
  const n = e || {};
  return (t[t.length - 1] === "" ? [...t, ""] : t).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
const _5e = /* @__PURE__ */ new Set(["menu", "submit", "reset", "button"]), a5 = {}.hasOwnProperty;
function C5e(t, e, n) {
  const r = n && R5e(n);
  return (
    /**
     * @type {{
     *   (): Root
     *   (selector: null | undefined, ...children: Array<HChild>): Root
     *   (selector: string, properties?: HProperties, ...children: Array<HChild>): Element
     *   (selector: string, ...children: Array<HChild>): Element
     * }}
     */
    /**
     * Hyperscript compatible DSL for creating virtual hast trees.
     *
     * @param {string | null} [selector]
     * @param {HProperties | HChild} [properties]
     * @param {Array<HChild>} children
     * @returns {HResult}
     */
    function(i, o, ...s) {
      let u = -1, f;
      if (i == null)
        f = { type: "root", children: [] }, s.unshift(o);
      else if (f = T5e(i, e), f.tagName = f.tagName.toLowerCase(), r && a5.call(r, f.tagName) && (f.tagName = r[f.tagName]), x5e(o, f.tagName)) {
        let p;
        for (p in o)
          a5.call(o, p) && A5e(t, f.properties, p, o[p]);
      } else
        s.unshift(o);
      for (; ++u < s.length; )
        i5(f.children, s[u]);
      return f.type === "element" && f.tagName === "template" && (f.content = { type: "root", children: f.children }, f.children = []), f;
    }
  );
}
function x5e(t, e) {
  return t == null || typeof t != "object" || Array.isArray(t) ? !1 : e === "input" || !t.type || typeof t.type != "string" ? !0 : "children" in t && Array.isArray(t.children) ? !1 : e === "button" ? _5e.has(t.type.toLowerCase()) : !("value" in t);
}
function A5e(t, e, n, r) {
  const a = E1(t, n);
  let i = -1, o;
  if (r != null) {
    if (typeof r == "number") {
      if (Number.isNaN(r))
        return;
      o = r;
    } else
      typeof r == "boolean" ? o = r : typeof r == "string" ? a.spaceSeparated ? o = YK(r) : a.commaSeparated ? o = a_(r) : a.commaOrSpaceSeparated ? o = YK(a_(r).join(" ")) : o = ZK(a, a.property, r) : Array.isArray(r) ? o = r.concat() : o = a.property === "style" ? k5e(r) : String(r);
    if (Array.isArray(o)) {
      const s = [];
      for (; ++i < o.length; )
        s[i] = ZK(a, a.property, o[i]);
      o = s;
    }
    a.property === "className" && Array.isArray(e.className) && (o = e.className.concat(o)), e[a.property] = o;
  }
}
function i5(t, e) {
  let n = -1;
  if (e != null)
    if (typeof e == "string" || typeof e == "number")
      t.push({ type: "text", value: String(e) });
    else if (Array.isArray(e))
      for (; ++n < e.length; )
        i5(t, e[n]);
    else if (typeof e == "object" && "type" in e)
      e.type === "root" ? i5(t, e.children) : t.push(e);
    else
      throw new Error("Expected node, nodes, or string, got `" + e + "`");
}
function ZK(t, e, n) {
  if (typeof n == "string") {
    if (t.number && n && !Number.isNaN(Number(n)))
      return Number(n);
    if ((t.boolean || t.overloadedBoolean) && (n === "" || b0(n) === b0(e)))
      return !0;
  }
  return n;
}
function k5e(t) {
  const e = [];
  let n;
  for (n in t)
    a5.call(t, n) && e.push([n, t[n]].join(": "));
  return e.join("; ");
}
function R5e(t) {
  const e = {};
  let n = -1;
  for (; ++n < t.length; )
    e[t[n].toLowerCase()] = t[n];
  return e;
}
const I5e = C5e(N0, "div"), D5e = [
  "AElig",
  "AMP",
  "Aacute",
  "Acirc",
  "Agrave",
  "Aring",
  "Atilde",
  "Auml",
  "COPY",
  "Ccedil",
  "ETH",
  "Eacute",
  "Ecirc",
  "Egrave",
  "Euml",
  "GT",
  "Iacute",
  "Icirc",
  "Igrave",
  "Iuml",
  "LT",
  "Ntilde",
  "Oacute",
  "Ocirc",
  "Ograve",
  "Oslash",
  "Otilde",
  "Ouml",
  "QUOT",
  "REG",
  "THORN",
  "Uacute",
  "Ucirc",
  "Ugrave",
  "Uuml",
  "Yacute",
  "aacute",
  "acirc",
  "acute",
  "aelig",
  "agrave",
  "amp",
  "aring",
  "atilde",
  "auml",
  "brvbar",
  "ccedil",
  "cedil",
  "cent",
  "copy",
  "curren",
  "deg",
  "divide",
  "eacute",
  "ecirc",
  "egrave",
  "eth",
  "euml",
  "frac12",
  "frac14",
  "frac34",
  "gt",
  "iacute",
  "icirc",
  "iexcl",
  "igrave",
  "iquest",
  "iuml",
  "laquo",
  "lt",
  "macr",
  "micro",
  "middot",
  "nbsp",
  "not",
  "ntilde",
  "oacute",
  "ocirc",
  "ograve",
  "ordf",
  "ordm",
  "oslash",
  "otilde",
  "ouml",
  "para",
  "plusmn",
  "pound",
  "quot",
  "raquo",
  "reg",
  "sect",
  "shy",
  "sup1",
  "sup2",
  "sup3",
  "szlig",
  "thorn",
  "times",
  "uacute",
  "ucirc",
  "ugrave",
  "uml",
  "uuml",
  "yacute",
  "yen",
  "yuml"
], XK = {
  0: "�",
  128: "€",
  130: "‚",
  131: "ƒ",
  132: "„",
  133: "…",
  134: "†",
  135: "‡",
  136: "ˆ",
  137: "‰",
  138: "Š",
  139: "‹",
  140: "Œ",
  142: "Ž",
  145: "‘",
  146: "’",
  147: "“",
  148: "”",
  149: "•",
  150: "–",
  151: "—",
  152: "˜",
  153: "™",
  154: "š",
  155: "›",
  156: "œ",
  158: "ž",
  159: "Ÿ"
};
function Zle(t) {
  const e = typeof t == "string" ? t.charCodeAt(0) : t;
  return e >= 48 && e <= 57;
}
function N5e(t) {
  const e = typeof t == "string" ? t.charCodeAt(0) : t;
  return e >= 97 && e <= 102 || e >= 65 && e <= 70 || e >= 48 && e <= 57;
}
function P5e(t) {
  const e = typeof t == "string" ? t.charCodeAt(0) : t;
  return e >= 97 && e <= 122 || e >= 65 && e <= 90;
}
function qK(t) {
  return P5e(t) || Zle(t);
}
const KK = document.createElement("i");
function i_(t) {
  const e = "&" + t + ";";
  KK.innerHTML = e;
  const n = KK.textContent;
  return n.charCodeAt(n.length - 1) === 59 && t !== "semi" || n === e ? !1 : n;
}
const tE = String.fromCharCode, L5e = [
  "",
  /* 1: Non terminated (named) */
  "Named character references must be terminated by a semicolon",
  /* 2: Non terminated (numeric) */
  "Numeric character references must be terminated by a semicolon",
  /* 3: Empty (named) */
  "Named character references cannot be empty",
  /* 4: Empty (numeric) */
  "Numeric character references cannot be empty",
  /* 5: Unknown (named) */
  "Named character references must be known",
  /* 6: Disallowed (numeric) */
  "Numeric character references cannot be disallowed",
  /* 7: Prohibited (numeric) */
  "Numeric character references cannot be outside the permissible Unicode range"
];
function M5e(t, e = {}) {
  const n = typeof e.additional == "string" ? e.additional.charCodeAt(0) : e.additional, r = [];
  let a = 0, i = -1, o = "", s, u;
  e.position && ("start" in e.position || "indent" in e.position ? (u = e.position.indent, s = e.position.start) : s = e.position);
  let f = (s ? s.line : 0) || 1, p = (s ? s.column : 0) || 1, m = O(), v;
  for (a--; ++a <= t.length; )
    if (v === 10 && (p = (u ? u[i] : 0) || 1), v = t.charCodeAt(a), v === 38) {
      const C = t.charCodeAt(a + 1);
      if (C === 9 || C === 10 || C === 12 || C === 32 || C === 38 || C === 60 || Number.isNaN(C) || n && C === n) {
        o += tE(v), p++;
        continue;
      }
      const A = a + 1;
      let N = A, P = A, I;
      if (C === 35) {
        P = ++N;
        const J = t.charCodeAt(P);
        J === 88 || J === 120 ? (I = "hexadecimal", P = ++N) : I = "decimal";
      } else
        I = "named";
      let D = "", M = "", H = "";
      const Y = I === "named" ? qK : I === "decimal" ? Zle : N5e;
      for (P--; ++P <= t.length; ) {
        const J = t.charCodeAt(P);
        if (!Y(J))
          break;
        H += tE(J), I === "named" && D5e.includes(H) && (D = H, M = i_(H));
      }
      let q = t.charCodeAt(P) === 59;
      if (q) {
        P++;
        const J = I === "named" ? i_(H) : !1;
        J && (D = H, M = J);
      }
      let Q = 1 + P - A, ne = "";
      if (!(!q && e.nonTerminated === !1))
        if (!H)
          I !== "named" && w(4, Q);
        else if (I === "named") {
          if (q && !M)
            w(5, 1);
          else if (D !== H && (P = N + D.length, Q = 1 + P - N, q = !1), !q) {
            const J = D ? 1 : 3;
            if (e.attribute) {
              const ue = t.charCodeAt(P);
              ue === 61 ? (w(J, Q), M = "") : qK(ue) ? M = "" : w(J, Q);
            } else
              w(J, Q);
          }
          ne = M;
        } else {
          q || w(2, Q);
          let J = Number.parseInt(
            H,
            I === "hexadecimal" ? 16 : 10
          );
          if (F5e(J))
            w(7, Q), ne = tE(
              65533
              /* `�` */
            );
          else if (J in XK)
            w(6, Q), ne = XK[J];
          else {
            let ue = "";
            $5e(J) && w(6, Q), J > 65535 && (J -= 65536, ue += tE(J >>> 10 | 55296), J = 56320 | J & 1023), ne = ue + tE(J);
          }
        }
      if (ne) {
        _(), m = O(), a = P - 1, p += P - A + 1, r.push(ne);
        const J = O();
        J.offset++, e.reference && e.reference.call(
          e.referenceContext,
          ne,
          { start: m, end: J },
          t.slice(A - 1, P)
        ), m = J;
      } else
        H = t.slice(A - 1, P), o += H, p += H.length, a = P - 1;
    } else
      v === 10 && (f++, i++, p = 0), Number.isNaN(v) ? _() : (o += tE(v), p++);
  return r.join("");
  function O() {
    return {
      line: f,
      column: p,
      offset: a + ((s ? s.offset : 0) || 0)
    };
  }
  function w(C, A) {
    let N;
    e.warning && (N = O(), N.column += A, N.offset += A, e.warning.call(
      e.warningContext,
      L5e[C],
      N,
      C
    ));
  }
  function _() {
    o && (r.push(o), e.text && e.text.call(e.textContext, o, {
      start: m,
      end: O()
    }), o = "");
  }
}
function F5e(t) {
  return t >= 55296 && t <= 57343 || t > 1114111;
}
function $5e(t) {
  return t >= 1 && t <= 8 || t === 11 || t >= 13 && t <= 31 || t >= 127 && t <= 159 || t >= 64976 && t <= 65007 || (t & 65535) === 65535 || (t & 65535) === 65534;
}
var B5e = 0, cA = {}, ds = {
  /**
   * A namespace for utility methods.
   *
   * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
   * change or disappear at any time.
   *
   * @namespace
   * @memberof Prism
   */
  util: {
    /**
     * Returns the name of the type of the given value.
     *
     * @param {any} o
     * @returns {string}
     * @example
     * type(null)      === 'Null'
     * type(undefined) === 'Undefined'
     * type(123)       === 'Number'
     * type('foo')     === 'String'
     * type(true)      === 'Boolean'
     * type([1, 2])    === 'Array'
     * type({})        === 'Object'
     * type(String)    === 'Function'
     * type(/abc+/)    === 'RegExp'
     */
    type: function(t) {
      return Object.prototype.toString.call(t).slice(8, -1);
    },
    /**
     * Returns a unique number for the given object. Later calls will still return the same number.
     *
     * @param {Object} obj
     * @returns {number}
     */
    objId: function(t) {
      return t.__id || Object.defineProperty(t, "__id", { value: ++B5e }), t.__id;
    },
    /**
     * Creates a deep clone of the given object.
     *
     * The main intended use of this function is to clone language definitions.
     *
     * @param {T} o
     * @param {Record<number, any>} [visited]
     * @returns {T}
     * @template T
     */
    clone: function t(e, n) {
      n = n || {};
      var r, a;
      switch (ds.util.type(e)) {
        case "Object":
          if (a = ds.util.objId(e), n[a])
            return n[a];
          r = /** @type {Record<string, any>} */
          {}, n[a] = r;
          for (var i in e)
            e.hasOwnProperty(i) && (r[i] = t(e[i], n));
          return (
            /** @type {any} */
            r
          );
        case "Array":
          return a = ds.util.objId(e), n[a] ? n[a] : (r = [], n[a] = r, e.forEach(function(o, s) {
            r[s] = t(o, n);
          }), /** @type {any} */
          r);
        default:
          return e;
      }
    }
  },
  /**
   * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
   *
   * @namespace
   * @memberof Prism
   * @public
   */
  languages: {
    /**
     * The grammar for plain, unformatted text.
     */
    plain: cA,
    plaintext: cA,
    text: cA,
    txt: cA,
    /**
     * Creates a deep copy of the language with the given id and appends the given tokens.
     *
     * If a token in `redef` also appears in the copied language, then the existing token in the copied language
     * will be overwritten at its original position.
     *
     * ## Best practices
     *
     * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
     * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
     * understand the language definition because, normally, the order of tokens matters in Prism grammars.
     *
     * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
     * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
     *
     * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
     * @param {Grammar} redef The new tokens to append.
     * @returns {Grammar} The new language created.
     * @public
     * @example
     * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
     *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
     *     // at its original position
     *     'comment': { ... },
     *     // CSS doesn't have a 'color' token, so this token will be appended
     *     'color': /\b(?:red|green|blue)\b/
     * });
     */
    extend: function(t, e) {
      var n = ds.util.clone(ds.languages[t]);
      for (var r in e)
        n[r] = e[r];
      return n;
    },
    /**
     * Inserts tokens _before_ another token in a language definition or any other grammar.
     *
     * ## Usage
     *
     * This helper method makes it easy to modify existing languages. For example, the CSS language definition
     * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
     * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
     * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
     * this:
     *
     * ```js
     * Prism.languages.markup.style = {
     *     // token
     * };
     * ```
     *
     * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
     * before existing tokens. For the CSS example above, you would use it like this:
     *
     * ```js
     * Prism.languages.insertBefore('markup', 'cdata', {
     *     'style': {
     *         // token
     *     }
     * });
     * ```
     *
     * ## Special cases
     *
     * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
     * will be ignored.
     *
     * This behavior can be used to insert tokens after `before`:
     *
     * ```js
     * Prism.languages.insertBefore('markup', 'comment', {
     *     'comment': Prism.languages.markup.comment,
     *     // tokens after 'comment'
     * });
     * ```
     *
     * ## Limitations
     *
     * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
     * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
     * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
     * deleting properties which is necessary to insert at arbitrary positions.
     *
     * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
     * Instead, it will create a new object and replace all references to the target object with the new one. This
     * can be done without temporarily deleting properties, so the iteration order is well-defined.
     *
     * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
     * you hold the target object in a variable, then the value of the variable will not change.
     *
     * ```js
     * var oldMarkup = Prism.languages.markup;
     * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
     *
     * assert(oldMarkup !== Prism.languages.markup);
     * assert(newMarkup === Prism.languages.markup);
     * ```
     *
     * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
     * object to be modified.
     * @param {string} before The key to insert before.
     * @param {Grammar} insert An object containing the key-value pairs to be inserted.
     * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
     * object to be modified.
     *
     * Defaults to `Prism.languages`.
     * @returns {Grammar} The new grammar object.
     * @public
     */
    insertBefore: function(t, e, n, r) {
      r = r || /** @type {any} */
      ds.languages;
      var a = r[t], i = {};
      for (var o in a)
        if (a.hasOwnProperty(o)) {
          if (o == e)
            for (var s in n)
              n.hasOwnProperty(s) && (i[s] = n[s]);
          n.hasOwnProperty(o) || (i[o] = a[o]);
        }
      var u = r[t];
      return r[t] = i, ds.languages.DFS(ds.languages, function(f, p) {
        p === u && f != t && (this[f] = i);
      }), i;
    },
    // Traverse a language definition with Depth First Search
    DFS: function t(e, n, r, a) {
      a = a || {};
      var i = ds.util.objId;
      for (var o in e)
        if (e.hasOwnProperty(o)) {
          n.call(e, o, e[o], r || o);
          var s = e[o], u = ds.util.type(s);
          u === "Object" && !a[i(s)] ? (a[i(s)] = !0, t(s, n, null, a)) : u === "Array" && !a[i(s)] && (a[i(s)] = !0, t(s, n, o, a));
        }
    }
  },
  plugins: {},
  /**
   * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
   * and the language definitions to use, and returns a string with the HTML produced.
   *
   * The following hooks will be run:
   * 1. `before-tokenize`
   * 2. `after-tokenize`
   * 3. `wrap`: On each {@link Token}.
   *
   * @param {string} text A string with the code to be highlighted.
   * @param {Grammar} grammar An object containing the tokens to use.
   *
   * Usually a language definition like `Prism.languages.markup`.
   * @param {string} language The name of the language definition passed to `grammar`.
   * @returns {string} The highlighted HTML.
   * @memberof Prism
   * @public
   * @example
   * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
   */
  highlight: function(t, e, n) {
    var r = {
      code: t,
      grammar: e,
      language: n
    };
    if (ds.hooks.run("before-tokenize", r), !r.grammar)
      throw new Error('The language "' + r.language + '" has no grammar.');
    return r.tokens = ds.tokenize(r.code, r.grammar), ds.hooks.run("after-tokenize", r), pT.stringify(ds.util.encode(r.tokens), r.language);
  },
  /**
   * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
   * and the language definitions to use, and returns an array with the tokenized code.
   *
   * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
   *
   * This method could be useful in other contexts as well, as a very crude parser.
   *
   * @param {string} text A string with the code to be highlighted.
   * @param {Grammar} grammar An object containing the tokens to use.
   *
   * Usually a language definition like `Prism.languages.markup`.
   * @returns {TokenStream} An array of strings and tokens, a token stream.
   * @memberof Prism
   * @public
   * @example
   * let code = `var foo = 0;`;
   * let tokens = Prism.tokenize(code, Prism.languages.javascript);
   * tokens.forEach(token => {
   *     if (token instanceof Prism.Token && token.type === 'number') {
   *         console.log(`Found numeric literal: ${token.content}`);
   *     }
   * });
   */
  tokenize: function(t, e) {
    var n = e.rest;
    if (n) {
      for (var r in n)
        e[r] = n[r];
      delete e.rest;
    }
    var a = new U5e();
    return Nk(a, a.head, t), Xle(t, a, e, a.head, 0), H5e(a);
  },
  /**
   * @namespace
   * @memberof Prism
   * @public
   */
  hooks: {
    all: {},
    /**
     * Adds the given callback to the list of callbacks for the given hook.
     *
     * The callback will be invoked when the hook it is registered for is run.
     * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
     *
     * One callback function can be registered to multiple hooks and the same hook multiple times.
     *
     * @param {string} name The name of the hook.
     * @param {HookCallback} callback The callback function which is given environment variables.
     * @public
     */
    add: function(t, e) {
      var n = ds.hooks.all;
      n[t] = n[t] || [], n[t].push(e);
    },
    /**
     * Runs a hook invoking all registered callbacks with the given environment variables.
     *
     * Callbacks will be invoked synchronously and in the order in which they were registered.
     *
     * @param {string} name The name of the hook.
     * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
     * @public
     */
    run: function(t, e) {
      var n = ds.hooks.all[t];
      if (!(!n || !n.length))
        for (var r = 0, a; a = n[r++]; )
          a(e);
    }
  },
  Token: pT
};
function pT(t, e, n, r) {
  this.type = t, this.content = e, this.alias = n, this.length = (r || "").length | 0;
}
function JK(t, e, n, r) {
  t.lastIndex = e;
  var a = t.exec(n);
  if (a && r && a[1]) {
    var i = a[1].length;
    a.index += i, a[0] = a[0].slice(i);
  }
  return a;
}
function Xle(t, e, n, r, a, i) {
  for (var o in n)
    if (!(!n.hasOwnProperty(o) || !n[o])) {
      var s = n[o];
      s = Array.isArray(s) ? s : [s];
      for (var u = 0; u < s.length; ++u) {
        if (i && i.cause == o + "," + u)
          return;
        var f = s[u], p = f.inside, m = !!f.lookbehind, v = !!f.greedy, O = f.alias;
        if (v && !f.pattern.global) {
          var w = f.pattern.toString().match(/[imsuy]*$/)[0];
          f.pattern = RegExp(f.pattern.source, w + "g");
        }
        for (var _ = f.pattern || f, C = r.next, A = a; C !== e.tail && !(i && A >= i.reach); A += C.value.length, C = C.next) {
          var N = C.value;
          if (e.length > t.length)
            return;
          if (!(N instanceof pT)) {
            var P = 1, I;
            if (v) {
              if (I = JK(_, A, t, m), !I || I.index >= t.length)
                break;
              var Y = I.index, D = I.index + I[0].length, M = A;
              for (M += C.value.length; Y >= M; )
                C = C.next, M += C.value.length;
              if (M -= C.value.length, A = M, C.value instanceof pT)
                continue;
              for (var H = C; H !== e.tail && (M < D || typeof H.value == "string"); H = H.next)
                P++, M += H.value.length;
              P--, N = t.slice(A, M), I.index -= A;
            } else if (I = JK(_, 0, N, m), !I)
              continue;
            var Y = I.index, q = I[0], Q = N.slice(0, Y), ne = N.slice(Y + q.length), J = A + N.length;
            i && J > i.reach && (i.reach = J);
            var ue = C.prev;
            Q && (ue = Nk(e, ue, Q), A += Q.length), z5e(e, ue, P);
            var ee = new pT(
              o,
              p ? ds.tokenize(q, p) : q,
              O,
              q
            );
            if (C = Nk(e, ue, ee), ne && Nk(e, C, ne), P > 1) {
              var fe = {
                cause: o + "," + u,
                reach: J
              };
              Xle(
                t,
                e,
                n,
                C.prev,
                A,
                fe
              ), i && fe.reach > i.reach && (i.reach = fe.reach);
            }
          }
        }
      }
    }
}
function U5e() {
  var t = { value: null, prev: null, next: null }, e = { value: null, prev: t, next: null };
  t.next = e, this.head = t, this.tail = e, this.length = 0;
}
function Nk(t, e, n) {
  var r = e.next, a = { value: n, prev: e, next: r };
  return e.next = a, r.prev = a, t.length++, a;
}
function z5e(t, e, n) {
  for (var r = e.next, a = 0; a < n && r !== t.tail; a++)
    r = r.next;
  e.next = r, r.prev = e, t.length -= a;
}
function H5e(t) {
  for (var e = [], n = t.head.next; n !== t.tail; )
    e.push(n.value), n = n.next;
  return e;
}
const qle = ds, S1 = {}.hasOwnProperty;
function Kle() {
}
Kle.prototype = qle;
const te = new Kle();
te.highlight = W5e;
te.register = Q5e;
te.alias = j5e;
te.registered = G5e;
te.listLanguages = V5e;
te.util.encode = Y5e;
te.Token.stringify = o5;
function W5e(t, e) {
  if (typeof t != "string")
    throw new TypeError("Expected `string` for `value`, got `" + t + "`");
  let n, r;
  if (e && typeof e == "object")
    n = e;
  else {
    if (r = e, typeof r != "string")
      throw new TypeError("Expected `string` for `name`, got `" + r + "`");
    if (S1.call(te.languages, r))
      n = te.languages[r];
    else
      throw new Error("Unknown language: `" + r + "` is not registered");
  }
  return {
    type: "root",
    // @ts-expect-error: we hacked Prism to accept and return the things we want.
    children: qle.highlight.call(te, t, n, r)
  };
}
function Q5e(t) {
  if (typeof t != "function" || !t.displayName)
    throw new Error("Expected `function` for `syntax`, got `" + t + "`");
  S1.call(te.languages, t.displayName) || t(te);
}
function j5e(t, e) {
  const n = te.languages;
  let r = {};
  typeof t == "string" ? e && (r[t] = e) : r = t;
  let a;
  for (a in r)
    if (S1.call(r, a)) {
      const i = r[a], o = typeof i == "string" ? [i] : i;
      let s = -1;
      for (; ++s < o.length; )
        n[o[s]] = n[a];
    }
}
function G5e(t) {
  if (typeof t != "string")
    throw new TypeError(
      "Expected `string` for `aliasOrLanguage`, got `" + t + "`"
    );
  return S1.call(te.languages, t);
}
function V5e() {
  const t = te.languages, e = [];
  let n;
  for (n in t)
    S1.call(t, n) && typeof t[n] == "object" && e.push(n);
  return e;
}
function o5(t, e) {
  if (typeof t == "string")
    return { type: "text", value: t };
  if (Array.isArray(t)) {
    const r = [];
    let a = -1;
    for (; ++a < t.length; )
      t[a] !== "" && t[a] !== null && t[a] !== void 0 && r.push(o5(t[a], e));
    return r;
  }
  const n = {
    type: t.type,
    content: o5(t.content, e),
    tag: "span",
    classes: ["token", t.type],
    attributes: {},
    language: e
  };
  return t.alias && n.classes.push(
    ...typeof t.alias == "string" ? [t.alias] : t.alias
  ), te.hooks.run("wrap", n), I5e(
    n.tag + "." + n.classes.join("."),
    Z5e(n.attributes),
    n.content
  );
}
function Y5e(t) {
  return t;
}
function Z5e(t) {
  let e;
  for (e in t)
    S1.call(t, e) && (t[e] = M5e(t[e]));
  return t;
}
te.register(Lr);
te.register(tp);
te.register(x0);
te.register(PD);
te.register(x_);
te.register(A0);
te.register(ws);
te.register(pv);
te.register(LD);
te.register(MD);
te.register(FD);
te.register(k0);
te.register($D);
te.register(rl);
te.register(b1);
te.register(BD);
te.register(UD);
te.register(A_);
te.register(zD);
te.register(k_);
te.register(HD);
te.register(WD);
te.register(QD);
te.register(al);
te.register(R0);
te.register(R_);
te.register(jD);
te.register(I0);
te.register(GD);
te.register(VD);
te.register(YD);
te.register(v1);
te.register(ZD);
te.register(y1);
te.register(I_);
te.register(D_);
B6.displayName = "abap";
B6.aliases = [];
function B6(t) {
  t.languages.abap = {
    comment: /^\*.*/m,
    string: /(`|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
    "string-template": {
      pattern: /([|}])(?:\\.|[^\\|{\r\n])*(?=[|{])/,
      lookbehind: !0,
      alias: "string"
    },
    /* End Of Line comments should not interfere with strings when the
    quote character occurs within them. We assume a string being highlighted
    inside an EOL comment is more acceptable than the opposite.
    */
    "eol-comment": {
      pattern: /(^|\s)".*/m,
      lookbehind: !0,
      alias: "comment"
    },
    keyword: {
      pattern: /(\s|\.|^)(?:\*-INPUT|\?TO|ABAP-SOURCE|ABBREVIATED|ABS|ABSTRACT|ACCEPT|ACCEPTING|ACCESSPOLICY|ACCORDING|ACOS|ACTIVATION|ACTUAL|ADD|ADD-CORRESPONDING|ADJACENT|AFTER|ALIAS|ALIASES|ALIGN|ALL|ALLOCATE|ALPHA|ANALYSIS|ANALYZER|AND|ANY|APPEND|APPENDAGE|APPENDING|APPLICATION|ARCHIVE|AREA|ARITHMETIC|AS|ASCENDING|ASIN|ASPECT|ASSERT|ASSIGN|ASSIGNED|ASSIGNING|ASSOCIATION|ASYNCHRONOUS|AT|ATAN|ATTRIBUTES|AUTHORITY|AUTHORITY-CHECK|AVG|BACK|BACKGROUND|BACKUP|BACKWARD|BADI|BASE|BEFORE|BEGIN|BETWEEN|BIG|BINARY|BINDING|BIT|BIT-AND|BIT-NOT|BIT-OR|BIT-XOR|BLACK|BLANK|BLANKS|BLOB|BLOCK|BLOCKS|BLUE|BOUND|BOUNDARIES|BOUNDS|BOXED|BREAK-POINT|BT|BUFFER|BY|BYPASSING|BYTE|BYTE-CA|BYTE-CN|BYTE-CO|BYTE-CS|BYTE-NA|BYTE-NS|BYTE-ORDER|C|CA|CALL|CALLING|CASE|CAST|CASTING|CATCH|CEIL|CENTER|CENTERED|CHAIN|CHAIN-INPUT|CHAIN-REQUEST|CHANGE|CHANGING|CHANNELS|CHAR-TO-HEX|CHARACTER|CHARLEN|CHECK|CHECKBOX|CIRCULAR|CI_|CLASS|CLASS-CODING|CLASS-DATA|CLASS-EVENTS|CLASS-METHODS|CLASS-POOL|CLEANUP|CLEAR|CLIENT|CLOB|CLOCK|CLOSE|CN|CNT|CO|COALESCE|CODE|CODING|COLLECT|COLOR|COLUMN|COLUMNS|COL_BACKGROUND|COL_GROUP|COL_HEADING|COL_KEY|COL_NEGATIVE|COL_NORMAL|COL_POSITIVE|COL_TOTAL|COMMENT|COMMENTS|COMMIT|COMMON|COMMUNICATION|COMPARING|COMPONENT|COMPONENTS|COMPRESSION|COMPUTE|CONCAT|CONCATENATE|COND|CONDENSE|CONDITION|CONNECT|CONNECTION|CONSTANTS|CONTEXT|CONTEXTS|CONTINUE|CONTROL|CONTROLS|CONV|CONVERSION|CONVERT|COPIES|COPY|CORRESPONDING|COS|COSH|COUNT|COUNTRY|COVER|CP|CPI|CREATE|CREATING|CRITICAL|CS|CURRENCY|CURRENCY_CONVERSION|CURRENT|CURSOR|CURSOR-SELECTION|CUSTOMER|CUSTOMER-FUNCTION|DANGEROUS|DATA|DATABASE|DATAINFO|DATASET|DATE|DAYLIGHT|DBMAXLEN|DD\/MM\/YY|DD\/MM\/YYYY|DDMMYY|DEALLOCATE|DECIMALS|DECIMAL_SHIFT|DECLARATIONS|DEEP|DEFAULT|DEFERRED|DEFINE|DEFINING|DEFINITION|DELETE|DELETING|DEMAND|DEPARTMENT|DESCENDING|DESCRIBE|DESTINATION|DETAIL|DIALOG|DIRECTORY|DISCONNECT|DISPLAY|DISPLAY-MODE|DISTANCE|DISTINCT|DIV|DIVIDE|DIVIDE-CORRESPONDING|DIVISION|DO|DUMMY|DUPLICATE|DUPLICATES|DURATION|DURING|DYNAMIC|DYNPRO|E|EACH|EDIT|EDITOR-CALL|ELSE|ELSEIF|EMPTY|ENABLED|ENABLING|ENCODING|END|END-ENHANCEMENT-SECTION|END-LINES|END-OF-DEFINITION|END-OF-FILE|END-OF-PAGE|END-OF-SELECTION|ENDAT|ENDCASE|ENDCATCH|ENDCHAIN|ENDCLASS|ENDDO|ENDENHANCEMENT|ENDEXEC|ENDFOR|ENDFORM|ENDFUNCTION|ENDIAN|ENDIF|ENDING|ENDINTERFACE|ENDLOOP|ENDMETHOD|ENDMODULE|ENDON|ENDPROVIDE|ENDSELECT|ENDTRY|ENDWHILE|ENGINEERING|ENHANCEMENT|ENHANCEMENT-POINT|ENHANCEMENT-SECTION|ENHANCEMENTS|ENTRIES|ENTRY|ENVIRONMENT|EQ|EQUAL|EQUIV|ERRORMESSAGE|ERRORS|ESCAPE|ESCAPING|EVENT|EVENTS|EXACT|EXCEPT|EXCEPTION|EXCEPTION-TABLE|EXCEPTIONS|EXCLUDE|EXCLUDING|EXEC|EXECUTE|EXISTS|EXIT|EXIT-COMMAND|EXP|EXPAND|EXPANDING|EXPIRATION|EXPLICIT|EXPONENT|EXPORT|EXPORTING|EXTEND|EXTENDED|EXTENSION|EXTRACT|FAIL|FETCH|FIELD|FIELD-GROUPS|FIELD-SYMBOL|FIELD-SYMBOLS|FIELDS|FILE|FILTER|FILTER-TABLE|FILTERS|FINAL|FIND|FIRST|FIRST-LINE|FIXED-POINT|FKEQ|FKGE|FLOOR|FLUSH|FONT|FOR|FORM|FORMAT|FORWARD|FOUND|FRAC|FRAME|FRAMES|FREE|FRIENDS|FROM|FUNCTION|FUNCTION-POOL|FUNCTIONALITY|FURTHER|GAPS|GE|GENERATE|GET|GIVING|GKEQ|GKGE|GLOBAL|GRANT|GREATER|GREEN|GROUP|GROUPS|GT|HANDLE|HANDLER|HARMLESS|HASHED|HAVING|HDB|HEAD-LINES|HEADER|HEADERS|HEADING|HELP-ID|HELP-REQUEST|HIDE|HIGH|HINT|HOLD|HOTSPOT|I|ICON|ID|IDENTIFICATION|IDENTIFIER|IDS|IF|IGNORE|IGNORING|IMMEDIATELY|IMPLEMENTATION|IMPLEMENTATIONS|IMPLEMENTED|IMPLICIT|IMPORT|IMPORTING|IN|INACTIVE|INCL|INCLUDE|INCLUDES|INCLUDING|INCREMENT|INDEX|INDEX-LINE|INFOTYPES|INHERITING|INIT|INITIAL|INITIALIZATION|INNER|INOUT|INPUT|INSERT|INSTANCES|INTENSIFIED|INTERFACE|INTERFACE-POOL|INTERFACES|INTERNAL|INTERVALS|INTO|INVERSE|INVERTED-DATE|IS|ISO|ITERATOR|ITNO|JOB|JOIN|KEEP|KEEPING|KERNEL|KEY|KEYS|KEYWORDS|KIND|LANGUAGE|LAST|LATE|LAYOUT|LE|LEADING|LEAVE|LEFT|LEFT-JUSTIFIED|LEFTPLUS|LEFTSPACE|LEGACY|LENGTH|LESS|LET|LEVEL|LEVELS|LIKE|LINE|LINE-COUNT|LINE-SELECTION|LINE-SIZE|LINEFEED|LINES|LIST|LIST-PROCESSING|LISTBOX|LITTLE|LLANG|LOAD|LOAD-OF-PROGRAM|LOB|LOCAL|LOCALE|LOCATOR|LOG|LOG-POINT|LOG10|LOGFILE|LOGICAL|LONG|LOOP|LOW|LOWER|LPAD|LPI|LT|M|MAIL|MAIN|MAJOR-ID|MAPPING|MARGIN|MARK|MASK|MATCH|MATCHCODE|MAX|MAXIMUM|MEDIUM|MEMBERS|MEMORY|MESH|MESSAGE|MESSAGE-ID|MESSAGES|MESSAGING|METHOD|METHODS|MIN|MINIMUM|MINOR-ID|MM\/DD\/YY|MM\/DD\/YYYY|MMDDYY|MOD|MODE|MODIF|MODIFIER|MODIFY|MODULE|MOVE|MOVE-CORRESPONDING|MULTIPLY|MULTIPLY-CORRESPONDING|NA|NAME|NAMETAB|NATIVE|NB|NE|NESTED|NESTING|NEW|NEW-LINE|NEW-PAGE|NEW-SECTION|NEXT|NO|NO-DISPLAY|NO-EXTENSION|NO-GAP|NO-GAPS|NO-GROUPING|NO-HEADING|NO-SCROLLING|NO-SIGN|NO-TITLE|NO-TOPOFPAGE|NO-ZERO|NODE|NODES|NON-UNICODE|NON-UNIQUE|NOT|NP|NS|NULL|NUMBER|NUMOFCHAR|O|OBJECT|OBJECTS|OBLIGATORY|OCCURRENCE|OCCURRENCES|OCCURS|OF|OFF|OFFSET|OLE|ON|ONLY|OPEN|OPTION|OPTIONAL|OPTIONS|OR|ORDER|OTHER|OTHERS|OUT|OUTER|OUTPUT|OUTPUT-LENGTH|OVERFLOW|OVERLAY|PACK|PACKAGE|PAD|PADDING|PAGE|PAGES|PARAMETER|PARAMETER-TABLE|PARAMETERS|PART|PARTIALLY|PATTERN|PERCENTAGE|PERFORM|PERFORMING|PERSON|PF|PF-STATUS|PINK|PLACES|POOL|POSITION|POS_HIGH|POS_LOW|PRAGMAS|PRECOMPILED|PREFERRED|PRESERVING|PRIMARY|PRINT|PRINT-CONTROL|PRIORITY|PRIVATE|PROCEDURE|PROCESS|PROGRAM|PROPERTY|PROTECTED|PROVIDE|PUBLIC|PUSHBUTTON|PUT|QUEUE-ONLY|QUICKINFO|RADIOBUTTON|RAISE|RAISING|RANGE|RANGES|RAW|READ|READ-ONLY|READER|RECEIVE|RECEIVED|RECEIVER|RECEIVING|RED|REDEFINITION|REDUCE|REDUCED|REF|REFERENCE|REFRESH|REGEX|REJECT|REMOTE|RENAMING|REPLACE|REPLACEMENT|REPLACING|REPORT|REQUEST|REQUESTED|RESERVE|RESET|RESOLUTION|RESPECTING|RESPONSIBLE|RESULT|RESULTS|RESUMABLE|RESUME|RETRY|RETURN|RETURNCODE|RETURNING|RIGHT|RIGHT-JUSTIFIED|RIGHTPLUS|RIGHTSPACE|RISK|RMC_COMMUNICATION_FAILURE|RMC_INVALID_STATUS|RMC_SYSTEM_FAILURE|ROLE|ROLLBACK|ROUND|ROWS|RTTI|RUN|SAP|SAP-SPOOL|SAVING|SCALE_PRESERVING|SCALE_PRESERVING_SCIENTIFIC|SCAN|SCIENTIFIC|SCIENTIFIC_WITH_LEADING_ZERO|SCREEN|SCROLL|SCROLL-BOUNDARY|SCROLLING|SEARCH|SECONDARY|SECONDS|SECTION|SELECT|SELECT-OPTIONS|SELECTION|SELECTION-SCREEN|SELECTION-SET|SELECTION-SETS|SELECTION-TABLE|SELECTIONS|SELECTOR|SEND|SEPARATE|SEPARATED|SET|SHARED|SHIFT|SHORT|SHORTDUMP-ID|SIGN|SIGN_AS_POSTFIX|SIMPLE|SIN|SINGLE|SINH|SIZE|SKIP|SKIPPING|SMART|SOME|SORT|SORTABLE|SORTED|SOURCE|SPACE|SPECIFIED|SPLIT|SPOOL|SPOTS|SQL|SQLSCRIPT|SQRT|STABLE|STAMP|STANDARD|START-OF-SELECTION|STARTING|STATE|STATEMENT|STATEMENTS|STATIC|STATICS|STATUSINFO|STEP-LOOP|STOP|STRLEN|STRUCTURE|STRUCTURES|STYLE|SUBKEY|SUBMATCHES|SUBMIT|SUBROUTINE|SUBSCREEN|SUBSTRING|SUBTRACT|SUBTRACT-CORRESPONDING|SUFFIX|SUM|SUMMARY|SUMMING|SUPPLIED|SUPPLY|SUPPRESS|SWITCH|SWITCHSTATES|SYMBOL|SYNCPOINTS|SYNTAX|SYNTAX-CHECK|SYNTAX-TRACE|SYSTEM-CALL|SYSTEM-EXCEPTIONS|SYSTEM-EXIT|TAB|TABBED|TABLE|TABLES|TABLEVIEW|TABSTRIP|TAN|TANH|TARGET|TASK|TASKS|TEST|TESTING|TEXT|TEXTPOOL|THEN|THROW|TIME|TIMES|TIMESTAMP|TIMEZONE|TITLE|TITLE-LINES|TITLEBAR|TO|TOKENIZATION|TOKENS|TOP-LINES|TOP-OF-PAGE|TRACE-FILE|TRACE-TABLE|TRAILING|TRANSACTION|TRANSFER|TRANSFORMATION|TRANSLATE|TRANSPORTING|TRMAC|TRUNC|TRUNCATE|TRUNCATION|TRY|TYPE|TYPE-POOL|TYPE-POOLS|TYPES|ULINE|UNASSIGN|UNDER|UNICODE|UNION|UNIQUE|UNIT|UNIT_CONVERSION|UNIX|UNPACK|UNTIL|UNWIND|UP|UPDATE|UPPER|USER|USER-COMMAND|USING|UTF-8|VALID|VALUE|VALUE-REQUEST|VALUES|VARY|VARYING|VERIFICATION-MESSAGE|VERSION|VIA|VIEW|VISIBLE|WAIT|WARNING|WHEN|WHENEVER|WHERE|WHILE|WIDTH|WINDOW|WINDOWS|WITH|WITH-HEADING|WITH-TITLE|WITHOUT|WORD|WORK|WRITE|WRITER|X|XML|XOR|XSD|XSTRLEN|YELLOW|YES|YYMMDD|Z|ZERO|ZONE)(?![\w-])/i,
      lookbehind: !0
    },
    /* Numbers can be only integers. Decimal or Hex appear only as strings */
    number: /\b\d+\b/,
    /* Operators must always be surrounded by whitespace, they cannot be put
    adjacent to operands.
    */
    operator: {
      pattern: /(\s)(?:\*\*?|<[=>]?|>=?|\?=|[-+\/=])(?=\s)/,
      lookbehind: !0
    },
    "string-operator": {
      pattern: /(\s)&&?(?=\s)/,
      lookbehind: !0,
      /* The official editor highlights */
      alias: "keyword"
    },
    "token-operator": [
      {
        /* Special operators used to access structure components, class methods/attributes, etc. */
        pattern: /(\w)(?:->?|=>|[~|{}])(?=\w)/,
        lookbehind: !0,
        alias: "punctuation"
      },
      {
        /* Special tokens used do delimit string templates */
        pattern: /[|{}]/,
        alias: "punctuation"
      }
    ],
    punctuation: /[,.:()]/
  };
}
U6.displayName = "abnf";
U6.aliases = [];
function U6(t) {
  (function(e) {
    var n = "(?:ALPHA|BIT|CHAR|CR|CRLF|CTL|DIGIT|DQUOTE|HEXDIG|HTAB|LF|LWSP|OCTET|SP|VCHAR|WSP)";
    e.languages.abnf = {
      comment: /;.*/,
      string: {
        pattern: /(?:%[is])?"[^"\n\r]*"/,
        greedy: !0,
        inside: {
          punctuation: /^%[is]/
        }
      },
      range: {
        pattern: /%(?:b[01]+-[01]+|d\d+-\d+|x[A-F\d]+-[A-F\d]+)/i,
        alias: "number"
      },
      terminal: {
        pattern: /%(?:b[01]+(?:\.[01]+)*|d\d+(?:\.\d+)*|x[A-F\d]+(?:\.[A-F\d]+)*)/i,
        alias: "number"
      },
      repetition: {
        pattern: /(^|[^\w-])(?:\d*\*\d*|\d+)/,
        lookbehind: !0,
        alias: "operator"
      },
      definition: {
        pattern: /(^[ \t]*)(?:[a-z][\w-]*|<[^<>\r\n]*>)(?=\s*=)/m,
        lookbehind: !0,
        alias: "keyword",
        inside: {
          punctuation: /<|>/
        }
      },
      "core-rule": {
        pattern: RegExp(
          "(?:(^|[^<\\w-])" + n + "|<" + n + ">)(?![\\w-])",
          "i"
        ),
        lookbehind: !0,
        alias: ["rule", "constant"],
        inside: {
          punctuation: /<|>/
        }
      },
      rule: {
        pattern: /(^|[^<\w-])[a-z][\w-]*|<[^<>\r\n]*>/i,
        lookbehind: !0,
        inside: {
          punctuation: /<|>/
        }
      },
      operator: /=\/?|\//,
      punctuation: /[()\[\]]/
    };
  })(t);
}
z6.displayName = "actionscript";
z6.aliases = [];
function z6(t) {
  t.register(rl), t.languages.actionscript = t.languages.extend("javascript", {
    keyword: /\b(?:as|break|case|catch|class|const|default|delete|do|dynamic|each|else|extends|final|finally|for|function|get|if|implements|import|in|include|instanceof|interface|internal|is|namespace|native|new|null|override|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|use|var|void|while|with)\b/,
    operator: /\+\+|--|(?:[+\-*\/%^]|&&?|\|\|?|<<?|>>?>?|[!=]=?)=?|[~?@]/
  }), t.languages.actionscript["class-name"].alias = "function", delete t.languages.actionscript.parameter, delete t.languages.actionscript["literal-property"], t.languages.markup && t.languages.insertBefore("actionscript", "string", {
    xml: {
      pattern: /(^|[^.])<\/?\w+(?:\s+[^\s>\/=]+=("|')(?:\\[\s\S]|(?!\2)[^\\])*\2)*\s*\/?>/,
      lookbehind: !0,
      inside: t.languages.markup
    }
  });
}
H6.displayName = "ada";
H6.aliases = [];
function H6(t) {
  t.languages.ada = {
    comment: /--.*/,
    string: /"(?:""|[^"\r\f\n])*"/,
    number: [
      {
        pattern: /\b\d(?:_?\d)*#[\dA-F](?:_?[\dA-F])*(?:\.[\dA-F](?:_?[\dA-F])*)?#(?:E[+-]?\d(?:_?\d)*)?/i
      },
      {
        pattern: /\b\d(?:_?\d)*(?:\.\d(?:_?\d)*)?(?:E[+-]?\d(?:_?\d)*)?\b/i
      }
    ],
    attribute: {
      pattern: /\b'\w+/,
      alias: "attr-name"
    },
    keyword: /\b(?:abort|abs|abstract|accept|access|aliased|all|and|array|at|begin|body|case|constant|declare|delay|delta|digits|do|else|elsif|end|entry|exception|exit|for|function|generic|goto|if|in|interface|is|limited|loop|mod|new|not|null|of|or|others|out|overriding|package|pragma|private|procedure|protected|raise|range|record|rem|renames|requeue|return|reverse|select|separate|some|subtype|synchronized|tagged|task|terminate|then|type|until|use|when|while|with|xor)\b/i,
    boolean: /\b(?:false|true)\b/i,
    operator: /<[=>]?|>=?|=>?|:=|\/=?|\*\*?|[&+-]/,
    punctuation: /\.\.?|[,;():]/,
    char: /'.'/,
    variable: /\b[a-z](?:\w)*\b/i
  };
}
W6.displayName = "agda";
W6.aliases = [];
function W6(t) {
  (function(e) {
    e.languages.agda = {
      comment: /\{-[\s\S]*?(?:-\}|$)|--.*/,
      string: {
        pattern: /"(?:\\(?:\r\n|[\s\S])|[^\\\r\n"])*"/,
        greedy: !0
      },
      punctuation: /[(){}⦃⦄.;@]/,
      "class-name": {
        pattern: /((?:data|record) +)\S+/,
        lookbehind: !0
      },
      function: {
        pattern: /(^[ \t]*)(?!\s)[^:\r\n]+(?=:)/m,
        lookbehind: !0
      },
      operator: {
        pattern: /(^\s*|\s)(?:[=|:∀→λ\\?_]|->)(?=\s)/,
        lookbehind: !0
      },
      keyword: /\b(?:Set|abstract|constructor|data|eta-equality|field|forall|hiding|import|in|inductive|infix|infixl|infixr|instance|let|macro|module|mutual|no-eta-equality|open|overlap|pattern|postulate|primitive|private|public|quote|quoteContext|quoteGoal|quoteTerm|record|renaming|rewrite|syntax|tactic|unquote|unquoteDecl|unquoteDef|using|variable|where|with)\b/
    };
  })(t);
}
Q6.displayName = "al";
Q6.aliases = [];
function Q6(t) {
  t.languages.al = {
    comment: /\/\/.*|\/\*[\s\S]*?\*\//,
    string: {
      pattern: /'(?:''|[^'\r\n])*'(?!')|"(?:""|[^"\r\n])*"(?!")/,
      greedy: !0
    },
    function: {
      pattern: /(\b(?:event|procedure|trigger)\s+|(?:^|[^.])\.\s*)[a-z_]\w*(?=\s*\()/i,
      lookbehind: !0
    },
    keyword: [
      // keywords
      /\b(?:array|asserterror|begin|break|case|do|downto|else|end|event|exit|for|foreach|function|if|implements|in|indataset|interface|internal|local|of|procedure|program|protected|repeat|runonclient|securityfiltering|suppressdispose|temporary|then|to|trigger|until|var|while|with|withevents)\b/i,
      // objects and metadata that are used like keywords
      /\b(?:action|actions|addafter|addbefore|addfirst|addlast|area|assembly|chartpart|codeunit|column|controladdin|cuegroup|customizes|dataitem|dataset|dotnet|elements|enum|enumextension|extends|field|fieldattribute|fieldelement|fieldgroup|fieldgroups|fields|filter|fixed|grid|group|key|keys|label|labels|layout|modify|moveafter|movebefore|movefirst|movelast|page|pagecustomization|pageextension|part|profile|query|repeater|report|requestpage|schema|separator|systempart|table|tableelement|tableextension|textattribute|textelement|type|usercontrol|value|xmlport)\b/i
    ],
    number: /\b(?:0x[\da-f]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?)(?:F|LL?|U(?:LL?)?)?\b/i,
    boolean: /\b(?:false|true)\b/i,
    variable: /\b(?:Curr(?:FieldNo|Page|Report)|x?Rec|RequestOptionsPage)\b/,
    "class-name": /\b(?:automation|biginteger|bigtext|blob|boolean|byte|char|clienttype|code|completiontriggererrorlevel|connectiontype|database|dataclassification|datascope|date|dateformula|datetime|decimal|defaultlayout|dialog|dictionary|dotnetassembly|dotnettypedeclaration|duration|errorinfo|errortype|executioncontext|executionmode|fieldclass|fieldref|fieldtype|file|filterpagebuilder|guid|httpclient|httpcontent|httpheaders|httprequestmessage|httpresponsemessage|instream|integer|joker|jsonarray|jsonobject|jsontoken|jsonvalue|keyref|list|moduledependencyinfo|moduleinfo|none|notification|notificationscope|objecttype|option|outstream|pageresult|record|recordid|recordref|reportformat|securityfilter|sessionsettings|tableconnectiontype|tablefilter|testaction|testfield|testfilterfield|testpage|testpermissions|testrequestpage|text|textbuilder|textconst|textencoding|time|transactionmodel|transactiontype|variant|verbosity|version|view|views|webserviceactioncontext|webserviceactionresultcode|xmlattribute|xmlattributecollection|xmlcdata|xmlcomment|xmldeclaration|xmldocument|xmldocumenttype|xmlelement|xmlnamespacemanager|xmlnametable|xmlnode|xmlnodelist|xmlprocessinginstruction|xmlreadoptions|xmltext|xmlwriteoptions)\b/i,
    operator: /\.\.|:[=:]|[-+*/]=?|<>|[<>]=?|=|\b(?:and|div|mod|not|or|xor)\b/i,
    punctuation: /[()\[\]{}:.;,]/
  };
}
j6.displayName = "antlr4";
j6.aliases = ["g4"];
function j6(t) {
  t.languages.antlr4 = {
    comment: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
    string: {
      pattern: /'(?:\\.|[^\\'\r\n])*'/,
      greedy: !0
    },
    "character-class": {
      pattern: /\[(?:\\.|[^\\\]\r\n])*\]/,
      greedy: !0,
      alias: "regex",
      inside: {
        range: {
          pattern: /([^[]|(?:^|[^\\])(?:\\\\)*\\\[)-(?!\])/,
          lookbehind: !0,
          alias: "punctuation"
        },
        escape: /\\(?:u(?:[a-fA-F\d]{4}|\{[a-fA-F\d]+\})|[pP]\{[=\w-]+\}|[^\r\nupP])/,
        punctuation: /[\[\]]/
      }
    },
    action: {
      pattern: /\{(?:[^{}]|\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\})*\}/,
      greedy: !0,
      inside: {
        content: {
          // this might be C, C++, Python, Java, C#, or any other language ANTLR4 compiles to
          pattern: /(\{)[\s\S]+(?=\})/,
          lookbehind: !0
        },
        punctuation: /[{}]/
      }
    },
    command: {
      pattern: /(->\s*(?!\s))(?:\s*(?:,\s*)?\b[a-z]\w*(?:\s*\([^()\r\n]*\))?)+(?=\s*;)/i,
      lookbehind: !0,
      inside: {
        function: /\b\w+(?=\s*(?:[,(]|$))/,
        punctuation: /[,()]/
      }
    },
    annotation: {
      pattern: /@\w+(?:::\w+)*/,
      alias: "keyword"
    },
    label: {
      pattern: /#[ \t]*\w+/,
      alias: "punctuation"
    },
    keyword: /\b(?:catch|channels|finally|fragment|grammar|import|lexer|locals|mode|options|parser|returns|throws|tokens)\b/,
    definition: [
      {
        pattern: /\b[a-z]\w*(?=\s*:)/,
        alias: ["rule", "class-name"]
      },
      {
        pattern: /\b[A-Z]\w*(?=\s*:)/,
        alias: ["token", "constant"]
      }
    ],
    constant: /\b[A-Z][A-Z_]*\b/,
    operator: /\.\.|->|[|~]|[*+?]\??/,
    punctuation: /[;:()=]/
  }, t.languages.g4 = t.languages.antlr4;
}
G6.displayName = "apacheconf";
G6.aliases = [];
function G6(t) {
  t.languages.apacheconf = {
    comment: /#.*/,
    "directive-inline": {
      pattern: /(^[\t ]*)\b(?:AcceptFilter|AcceptPathInfo|AccessFileName|Action|Add(?:Alt|AltByEncoding|AltByType|Charset|DefaultCharset|Description|Encoding|Handler|Icon|IconByEncoding|IconByType|InputFilter|Language|ModuleInfo|OutputFilter|OutputFilterByType|Type)|Alias|AliasMatch|Allow(?:CONNECT|EncodedSlashes|Methods|Override|OverrideList)?|Anonymous(?:_LogEmail|_MustGiveEmail|_NoUserID|_VerifyEmail)?|AsyncRequestWorkerFactor|Auth(?:BasicAuthoritative|BasicFake|BasicProvider|BasicUseDigestAlgorithm|DBDUserPWQuery|DBDUserRealmQuery|DBMGroupFile|DBMType|DBMUserFile|Digest(?:Algorithm|Domain|NonceLifetime|Provider|Qop|ShmemSize)|Form(?:Authoritative|Body|DisableNoStore|FakeBasicAuth|Location|LoginRequiredLocation|LoginSuccessLocation|LogoutLocation|Method|Mimetype|Password|Provider|SitePassphrase|Size|Username)|GroupFile|LDAP(?:AuthorizePrefix|BindAuthoritative|BindDN|BindPassword|CharsetConfig|CompareAsUser|CompareDNOnServer|DereferenceAliases|GroupAttribute|GroupAttributeIsDN|InitialBindAsUser|InitialBindPattern|MaxSubGroupDepth|RemoteUserAttribute|RemoteUserIsDN|SearchAsUser|SubGroupAttribute|SubGroupClass|Url)|Merging|Name|nCache(?:Context|Enable|ProvideFor|SOCache|Timeout)|nzFcgiCheckAuthnProvider|nzFcgiDefineProvider|Type|UserFile|zDBDLoginToReferer|zDBDQuery|zDBDRedirectQuery|zDBMType|zSendForbiddenOnFailure)|BalancerGrowth|BalancerInherit|BalancerMember|BalancerPersist|BrowserMatch|BrowserMatchNoCase|BufferedLogs|BufferSize|Cache(?:DefaultExpire|DetailHeader|DirLength|DirLevels|Disable|Enable|File|Header|IgnoreCacheControl|IgnoreHeaders|IgnoreNoLastMod|IgnoreQueryString|IgnoreURLSessionIdentifiers|KeyBaseURL|LastModifiedFactor|Lock|LockMaxAge|LockPath|MaxExpire|MaxFileSize|MinExpire|MinFileSize|NegotiatedDocs|QuickHandler|ReadSize|ReadTime|Root|Socache(?:MaxSize|MaxTime|MinTime|ReadSize|ReadTime)?|StaleOnError|StoreExpired|StoreNoStore|StorePrivate)|CGIDScriptTimeout|CGIMapExtension|CharsetDefault|CharsetOptions|CharsetSourceEnc|CheckCaseOnly|CheckSpelling|ChrootDir|ContentDigest|CookieDomain|CookieExpires|CookieName|CookieStyle|CookieTracking|CoreDumpDirectory|CustomLog|Dav|DavDepthInfinity|DavGenericLockDB|DavLockDB|DavMinTimeout|DBDExptime|DBDInitSQL|DBDKeep|DBDMax|DBDMin|DBDParams|DBDPersist|DBDPrepareSQL|DBDriver|DefaultIcon|DefaultLanguage|DefaultRuntimeDir|DefaultType|Define|Deflate(?:BufferSize|CompressionLevel|FilterNote|InflateLimitRequestBody|InflateRatio(?:Burst|Limit)|MemLevel|WindowSize)|Deny|DirectoryCheckHandler|DirectoryIndex|DirectoryIndexRedirect|DirectorySlash|DocumentRoot|DTracePrivileges|DumpIOInput|DumpIOOutput|EnableExceptionHook|EnableMMAP|EnableSendfile|Error|ErrorDocument|ErrorLog|ErrorLogFormat|Example|ExpiresActive|ExpiresByType|ExpiresDefault|ExtendedStatus|ExtFilterDefine|ExtFilterOptions|FallbackResource|FileETag|FilterChain|FilterDeclare|FilterProtocol|FilterProvider|FilterTrace|ForceLanguagePriority|ForceType|ForensicLog|GprofDir|GracefulShutdownTimeout|Group|Header|HeaderName|Heartbeat(?:Address|Listen|MaxServers|Storage)|HostnameLookups|IdentityCheck|IdentityCheckTimeout|ImapBase|ImapDefault|ImapMenu|Include|IncludeOptional|Index(?:HeadInsert|Ignore|IgnoreReset|Options|OrderDefault|StyleSheet)|InputSed|ISAPI(?:AppendLogToErrors|AppendLogToQuery|CacheFile|FakeAsync|LogNotSupported|ReadAheadBuffer)|KeepAlive|KeepAliveTimeout|KeptBodySize|LanguagePriority|LDAP(?:CacheEntries|CacheTTL|ConnectionPoolTTL|ConnectionTimeout|LibraryDebug|OpCacheEntries|OpCacheTTL|ReferralHopLimit|Referrals|Retries|RetryDelay|SharedCacheFile|SharedCacheSize|Timeout|TrustedClientCert|TrustedGlobalCert|TrustedMode|VerifyServerCert)|Limit(?:InternalRecursion|Request(?:Body|Fields|FieldSize|Line)|XMLRequestBody)|Listen|ListenBackLog|LoadFile|LoadModule|LogFormat|LogLevel|LogMessage|LuaAuthzProvider|LuaCodeCache|Lua(?:Hook(?:AccessChecker|AuthChecker|CheckUserID|Fixups|InsertFilter|Log|MapToStorage|TranslateName|TypeChecker)|Inherit|InputFilter|MapHandler|OutputFilter|PackageCPath|PackagePath|QuickHandler|Root|Scope)|Max(?:ConnectionsPerChild|KeepAliveRequests|MemFree|RangeOverlaps|RangeReversals|Ranges|RequestWorkers|SpareServers|SpareThreads|Threads)|MergeTrailers|MetaDir|MetaFiles|MetaSuffix|MimeMagicFile|MinSpareServers|MinSpareThreads|MMapFile|ModemStandard|ModMimeUsePathInfo|MultiviewsMatch|Mutex|NameVirtualHost|NoProxy|NWSSLTrustedCerts|NWSSLUpgradeable|Options|Order|OutputSed|PassEnv|PidFile|PrivilegesMode|Protocol|ProtocolEcho|Proxy(?:AddHeaders|BadHeader|Block|Domain|ErrorOverride|ExpressDBMFile|ExpressDBMType|ExpressEnable|FtpDirCharset|FtpEscapeWildcards|FtpListOnWildcard|HTML(?:BufSize|CharsetOut|DocType|Enable|Events|Extended|Fixups|Interp|Links|Meta|StripComments|URLMap)|IOBufferSize|MaxForwards|Pass(?:Inherit|InterpolateEnv|Match|Reverse|ReverseCookieDomain|ReverseCookiePath)?|PreserveHost|ReceiveBufferSize|Remote|RemoteMatch|Requests|SCGIInternalRedirect|SCGISendfile|Set|SourceAddress|Status|Timeout|Via)|ReadmeName|ReceiveBufferSize|Redirect|RedirectMatch|RedirectPermanent|RedirectTemp|ReflectorHeader|RemoteIP(?:Header|InternalProxy|InternalProxyList|ProxiesHeader|TrustedProxy|TrustedProxyList)|RemoveCharset|RemoveEncoding|RemoveHandler|RemoveInputFilter|RemoveLanguage|RemoveOutputFilter|RemoveType|RequestHeader|RequestReadTimeout|Require|Rewrite(?:Base|Cond|Engine|Map|Options|Rule)|RLimitCPU|RLimitMEM|RLimitNPROC|Satisfy|ScoreBoardFile|Script(?:Alias|AliasMatch|InterpreterSource|Log|LogBuffer|LogLength|Sock)?|SecureListen|SeeRequestTail|SendBufferSize|Server(?:Admin|Alias|Limit|Name|Path|Root|Signature|Tokens)|Session(?:Cookie(?:Name|Name2|Remove)|Crypto(?:Cipher|Driver|Passphrase|PassphraseFile)|DBD(?:CookieName|CookieName2|CookieRemove|DeleteLabel|InsertLabel|PerUser|SelectLabel|UpdateLabel)|Env|Exclude|Header|Include|MaxAge)?|SetEnv|SetEnvIf|SetEnvIfExpr|SetEnvIfNoCase|SetHandler|SetInputFilter|SetOutputFilter|SSIEndTag|SSIErrorMsg|SSIETag|SSILastModified|SSILegacyExprParser|SSIStartTag|SSITimeFormat|SSIUndefinedEcho|SSL(?:CACertificateFile|CACertificatePath|CADNRequestFile|CADNRequestPath|CARevocationCheck|CARevocationFile|CARevocationPath|CertificateChainFile|CertificateFile|CertificateKeyFile|CipherSuite|Compression|CryptoDevice|Engine|FIPS|HonorCipherOrder|InsecureRenegotiation|OCSP(?:DefaultResponder|Enable|OverrideResponder|ResponderTimeout|ResponseMaxAge|ResponseTimeSkew|UseRequestNonce)|OpenSSLConfCmd|Options|PassPhraseDialog|Protocol|Proxy(?:CACertificateFile|CACertificatePath|CARevocation(?:Check|File|Path)|CheckPeer(?:CN|Expire|Name)|CipherSuite|Engine|MachineCertificate(?:ChainFile|File|Path)|Protocol|Verify|VerifyDepth)|RandomSeed|RenegBufferSize|Require|RequireSSL|Session(?:Cache|CacheTimeout|TicketKeyFile|Tickets)|SRPUnknownUserSeed|SRPVerifierFile|Stapling(?:Cache|ErrorCacheTimeout|FakeTryLater|ForceURL|ResponderTimeout|ResponseMaxAge|ResponseTimeSkew|ReturnResponderErrors|StandardCacheTimeout)|StrictSNIVHostCheck|UserName|UseStapling|VerifyClient|VerifyDepth)|StartServers|StartThreads|Substitute|Suexec|SuexecUserGroup|ThreadLimit|ThreadsPerChild|ThreadStackSize|TimeOut|TraceEnable|TransferLog|TypesConfig|UnDefine|UndefMacro|UnsetEnv|Use|UseCanonicalName|UseCanonicalPhysicalPort|User|UserDir|VHostCGIMode|VHostCGIPrivs|VHostGroup|VHostPrivs|VHostSecure|VHostUser|Virtual(?:DocumentRoot|ScriptAlias)(?:IP)?|WatchdogInterval|XBitHack|xml2EncAlias|xml2EncDefault|xml2StartParse)\b/im,
      lookbehind: !0,
      alias: "property"
    },
    "directive-block": {
      pattern: /<\/?\b(?:Auth[nz]ProviderAlias|Directory|DirectoryMatch|Else|ElseIf|Files|FilesMatch|If|IfDefine|IfModule|IfVersion|Limit|LimitExcept|Location|LocationMatch|Macro|Proxy|Require(?:All|Any|None)|VirtualHost)\b.*>/i,
      inside: {
        "directive-block": {
          pattern: /^<\/?\w+/,
          inside: {
            punctuation: /^<\/?/
          },
          alias: "tag"
        },
        "directive-block-parameter": {
          pattern: /.*[^>]/,
          inside: {
            punctuation: /:/,
            string: {
              pattern: /("|').*\1/,
              inside: {
                variable: /[$%]\{?(?:\w\.?[-+:]?)+\}?/
              }
            }
          },
          alias: "attr-value"
        },
        punctuation: />/
      },
      alias: "tag"
    },
    "directive-flags": {
      pattern: /\[(?:[\w=],?)+\]/,
      alias: "keyword"
    },
    string: {
      pattern: /("|').*\1/,
      inside: {
        variable: /[$%]\{?(?:\w\.?[-+:]?)+\}?/
      }
    },
    variable: /[$%]\{?(?:\w\.?[-+:]?)+\}?/,
    regex: /\^?.*\$|\^.*\$?/
  };
}
V6.displayName = "apex";
V6.aliases = [];
function V6(t) {
  t.register(Lr), t.register(v1), function(e) {
    var n = /\b(?:(?:after|before)(?=\s+[a-z])|abstract|activate|and|any|array|as|asc|autonomous|begin|bigdecimal|blob|boolean|break|bulk|by|byte|case|cast|catch|char|class|collect|commit|const|continue|currency|date|datetime|decimal|default|delete|desc|do|double|else|end|enum|exception|exit|export|extends|final|finally|float|for|from|get(?=\s*[{};])|global|goto|group|having|hint|if|implements|import|in|inner|insert|instanceof|int|integer|interface|into|join|like|limit|list|long|loop|map|merge|new|not|null|nulls|number|object|of|on|or|outer|override|package|parallel|pragma|private|protected|public|retrieve|return|rollback|select|set|short|sObject|sort|static|string|super|switch|synchronized|system|testmethod|then|this|throw|time|transaction|transient|trigger|try|undelete|update|upsert|using|virtual|void|webservice|when|where|while|(?:inherited|with|without)\s+sharing)\b/i, r = /\b(?:(?=[a-z_]\w*\s*[<\[])|(?!<keyword>))[A-Z_]\w*(?:\s*\.\s*[A-Z_]\w*)*\b(?:\s*(?:\[\s*\]|<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>))*/.source.replace(
      /<keyword>/g,
      function() {
        return n.source;
      }
    );
    function a(o) {
      return RegExp(
        o.replace(/<CLASS-NAME>/g, function() {
          return r;
        }),
        "i"
      );
    }
    var i = {
      keyword: n,
      punctuation: /[()\[\]{};,:.<>]/
    };
    e.languages.apex = {
      comment: e.languages.clike.comment,
      string: e.languages.clike.string,
      sql: {
        pattern: /((?:[=,({:]|\breturn)\s*)\[[^\[\]]*\]/i,
        lookbehind: !0,
        greedy: !0,
        alias: "language-sql",
        inside: e.languages.sql
      },
      annotation: {
        pattern: /@\w+\b/,
        alias: "punctuation"
      },
      "class-name": [
        {
          pattern: a(
            /(\b(?:class|enum|extends|implements|instanceof|interface|new|trigger\s+\w+\s+on)\s+)<CLASS-NAME>/.source
          ),
          lookbehind: !0,
          inside: i
        },
        {
          // cast
          pattern: a(
            /(\(\s*)<CLASS-NAME>(?=\s*\)\s*[\w(])/.source
          ),
          lookbehind: !0,
          inside: i
        },
        {
          // variable/parameter declaration and return types
          pattern: a(/<CLASS-NAME>(?=\s*\w+\s*[;=,(){:])/.source),
          inside: i
        }
      ],
      trigger: {
        pattern: /(\btrigger\s+)\w+\b/i,
        lookbehind: !0,
        alias: "class-name"
      },
      keyword: n,
      function: /\b[a-z_]\w*(?=\s*\()/i,
      boolean: /\b(?:false|true)\b/i,
      number: /(?:\B\.\d+|\b\d+(?:\.\d+|L)?)\b/i,
      operator: /[!=](?:==?)?|\?\.?|&&|\|\||--|\+\+|[-+*/^&|]=?|:|<<?=?|>{1,3}=?/,
      punctuation: /[()\[\]{};,.]/
    };
  }(t);
}
Y6.displayName = "apl";
Y6.aliases = [];
function Y6(t) {
  t.languages.apl = {
    comment: /(?:⍝|#[! ]).*$/m,
    string: {
      pattern: /'(?:[^'\r\n]|'')*'/,
      greedy: !0
    },
    number: /¯?(?:\d*\.?\b\d+(?:e[+¯]?\d+)?|¯|∞)(?:j¯?(?:(?:\d+(?:\.\d+)?|\.\d+)(?:e[+¯]?\d+)?|¯|∞))?/i,
    statement: /:[A-Z][a-z][A-Za-z]*\b/,
    "system-function": {
      pattern: /⎕[A-Z]+/i,
      alias: "function"
    },
    constant: /[⍬⌾#⎕⍞]/,
    function: /[-+×÷⌈⌊∣|⍳⍸?*⍟○!⌹<≤=>≥≠≡≢∊⍷∪∩~∨∧⍱⍲⍴,⍪⌽⊖⍉↑↓⊂⊃⊆⊇⌷⍋⍒⊤⊥⍕⍎⊣⊢⍁⍂≈⍯↗¤→]/,
    "monadic-operator": {
      pattern: /[\\\/⌿⍀¨⍨⌶&∥]/,
      alias: "operator"
    },
    "dyadic-operator": {
      pattern: /[.⍣⍠⍤∘⌸@⌺⍥]/,
      alias: "operator"
    },
    assignment: {
      pattern: /←/,
      alias: "keyword"
    },
    punctuation: /[\[;\]()◇⋄]/,
    dfn: {
      pattern: /[{}⍺⍵⍶⍹∇⍫:]/,
      alias: "builtin"
    }
  };
}
Z6.displayName = "applescript";
Z6.aliases = [];
function Z6(t) {
  t.languages.applescript = {
    comment: [
      // Allow one level of nesting
      /\(\*(?:\(\*(?:[^*]|\*(?!\)))*\*\)|(?!\(\*)[\s\S])*?\*\)/,
      /--.+/,
      /#.+/
    ],
    string: /"(?:\\.|[^"\\\r\n])*"/,
    number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e-?\d+)?\b/i,
    operator: [
      /[&=≠≤≥*+\-\/÷^]|[<>]=?/,
      /\b(?:(?:begin|end|start)s? with|(?:contains?|(?:does not|doesn't) contain)|(?:is|isn't|is not) (?:contained by|in)|(?:(?:is|isn't|is not) )?(?:greater|less) than(?: or equal)?(?: to)?|(?:comes|(?:does not|doesn't) come) (?:after|before)|(?:is|isn't|is not) equal(?: to)?|(?:(?:does not|doesn't) equal|equal to|equals|is not|isn't)|(?:a )?(?:ref(?: to)?|reference to)|(?:and|as|div|mod|not|or))\b/
    ],
    keyword: /\b(?:about|above|after|against|apart from|around|aside from|at|back|before|beginning|behind|below|beneath|beside|between|but|by|considering|continue|copy|does|eighth|else|end|equal|error|every|exit|false|fifth|first|for|fourth|from|front|get|given|global|if|ignoring|in|instead of|into|is|it|its|last|local|me|middle|my|ninth|of|on|onto|out of|over|prop|property|put|repeat|return|returning|second|set|seventh|since|sixth|some|tell|tenth|that|the|then|third|through|thru|timeout|times|to|transaction|true|try|until|where|while|whose|with|without)\b/,
    "class-name": /\b(?:POSIX file|RGB color|alias|application|boolean|centimeters|centimetres|class|constant|cubic centimeters|cubic centimetres|cubic feet|cubic inches|cubic meters|cubic metres|cubic yards|date|degrees Celsius|degrees Fahrenheit|degrees Kelvin|feet|file|gallons|grams|inches|integer|kilograms|kilometers|kilometres|list|liters|litres|meters|metres|miles|number|ounces|pounds|quarts|real|record|reference|script|square feet|square kilometers|square kilometres|square meters|square metres|square miles|square yards|text|yards)\b/,
    punctuation: /[{}():,¬«»《》]/
  };
}
X6.displayName = "aql";
X6.aliases = [];
function X6(t) {
  t.languages.aql = {
    comment: /\/\/.*|\/\*[\s\S]*?\*\//,
    property: {
      pattern: /([{,]\s*)(?:(?!\d)\w+|(["'´`])(?:(?!\2)[^\\\r\n]|\\.)*\2)(?=\s*:)/,
      lookbehind: !0,
      greedy: !0
    },
    string: {
      pattern: /(["'])(?:(?!\1)[^\\\r\n]|\\.)*\1/,
      greedy: !0
    },
    identifier: {
      pattern: /([´`])(?:(?!\1)[^\\\r\n]|\\.)*\1/,
      greedy: !0
    },
    variable: /@@?\w+/,
    keyword: [
      {
        pattern: /(\bWITH\s+)COUNT(?=\s+INTO\b)/i,
        lookbehind: !0
      },
      /\b(?:AGGREGATE|ALL|AND|ANY|ASC|COLLECT|DESC|DISTINCT|FILTER|FOR|GRAPH|IN|INBOUND|INSERT|INTO|K_PATHS|K_SHORTEST_PATHS|LET|LIKE|LIMIT|NONE|NOT|NULL|OR|OUTBOUND|REMOVE|REPLACE|RETURN|SHORTEST_PATH|SORT|UPDATE|UPSERT|WINDOW|WITH)\b/i,
      // pseudo keywords get a lookbehind to avoid false positives
      {
        pattern: /(^|[^\w.[])(?:KEEP|PRUNE|SEARCH|TO)\b/i,
        lookbehind: !0
      },
      {
        pattern: /(^|[^\w.[])(?:CURRENT|NEW|OLD)\b/,
        lookbehind: !0
      },
      {
        pattern: /\bOPTIONS(?=\s*\{)/i
      }
    ],
    function: /\b(?!\d)\w+(?=\s*\()/,
    boolean: /\b(?:false|true)\b/i,
    range: {
      pattern: /\.\./,
      alias: "operator"
    },
    number: [
      /\b0b[01]+/i,
      /\b0x[0-9a-f]+/i,
      /(?:\B\.\d+|\b(?:0|[1-9]\d*)(?:\.\d+)?)(?:e[+-]?\d+)?/i
    ],
    operator: /\*{2,}|[=!]~|[!=<>]=?|&&|\|\||[-+*/%]/,
    punctuation: /::|[?.:,;()[\]{}]/
  };
}
q6.displayName = "arff";
q6.aliases = [];
function q6(t) {
  t.languages.arff = {
    comment: /%.*/,
    string: {
      pattern: /(["'])(?:\\.|(?!\1)[^\\\r\n])*\1/,
      greedy: !0
    },
    keyword: /@(?:attribute|data|end|relation)\b/i,
    number: /\b\d+(?:\.\d+)?\b/,
    punctuation: /[{},]/
  };
}
K6.displayName = "armasm";
K6.aliases = ["arm-asm"];
function K6(t) {
  t.languages.armasm = {
    comment: {
      pattern: /;.*/,
      greedy: !0
    },
    string: {
      pattern: /"(?:[^"\r\n]|"")*"/,
      greedy: !0,
      inside: {
        variable: {
          pattern: /((?:^|[^$])(?:\${2})*)\$\w+/,
          lookbehind: !0
        }
      }
    },
    char: {
      pattern: /'(?:[^'\r\n]{0,4}|'')'/,
      greedy: !0
    },
    "version-symbol": {
      pattern: /\|[\w@]+\|/,
      greedy: !0,
      alias: "property"
    },
    boolean: /\b(?:FALSE|TRUE)\b/,
    directive: {
      pattern: /\b(?:ALIAS|ALIGN|AREA|ARM|ASSERT|ATTR|CN|CODE|CODE16|CODE32|COMMON|CP|DATA|DCB|DCD|DCDO|DCDU|DCFD|DCFDU|DCI|DCQ|DCQU|DCW|DCWU|DN|ELIF|ELSE|END|ENDFUNC|ENDIF|ENDP|ENTRY|EQU|EXPORT|EXPORTAS|EXTERN|FIELD|FILL|FN|FUNCTION|GBLA|GBLL|GBLS|GET|GLOBAL|IF|IMPORT|INCBIN|INCLUDE|INFO|KEEP|LCLA|LCLL|LCLS|LTORG|MACRO|MAP|MEND|MEXIT|NOFP|OPT|PRESERVE8|PROC|QN|READONLY|RELOC|REQUIRE|REQUIRE8|RLIST|ROUT|SETA|SETL|SETS|SN|SPACE|SUBT|THUMB|THUMBX|TTL|WEND|WHILE)\b/,
      alias: "property"
    },
    instruction: {
      pattern: /((?:^|(?:^|[^\\])(?:\r\n?|\n))[ \t]*(?:(?:[A-Z][A-Z0-9_]*[a-z]\w*|[a-z]\w*|\d+)[ \t]+)?)\b[A-Z.]+\b/,
      lookbehind: !0,
      alias: "keyword"
    },
    variable: /\$\w+/,
    number: /(?:\b[2-9]_\d+|(?:\b\d+(?:\.\d+)?|\B\.\d+)(?:e-?\d+)?|\b0(?:[fd]_|x)[0-9a-f]+|&[0-9a-f]+)\b/i,
    register: {
      pattern: /\b(?:r\d|lr)\b/,
      alias: "symbol"
    },
    operator: /<>|<<|>>|&&|\|\||[=!<>/]=?|[+\-*%#?&|^]|:[A-Z]+:/,
    punctuation: /[()[\],]/
  }, t.languages["arm-asm"] = t.languages.armasm;
}
J6.displayName = "arturo";
J6.aliases = ["art"];
function J6(t) {
  (function(e) {
    var n = function(r, a) {
      return {
        pattern: RegExp(
          /\{!/.source + "(?:" + (a || r) + ")" + /$[\s\S]*\}/.source,
          "m"
        ),
        greedy: !0,
        inside: {
          embedded: {
            pattern: /(^\{!\w+\b)[\s\S]+(?=\}$)/,
            lookbehind: !0,
            alias: "language-" + r,
            inside: e.languages[r]
          },
          string: /[\s\S]+/
        }
      };
    };
    e.languages.arturo = {
      comment: {
        pattern: /;.*/,
        greedy: !0
      },
      character: {
        pattern: /`.`/,
        alias: "char",
        greedy: !0
      },
      number: {
        pattern: /\b\d+(?:\.\d+(?:\.\d+(?:-[\w+-]+)?)?)?\b/
      },
      string: {
        pattern: /"(?:[^"\\\r\n]|\\.)*"/,
        greedy: !0
      },
      regex: {
        pattern: /\{\/.*?\/\}/,
        greedy: !0
      },
      "html-string": n("html"),
      "css-string": n("css"),
      "js-string": n("js"),
      "md-string": n("md"),
      "sql-string": n("sql"),
      "sh-string": n("shell", "sh"),
      multistring: {
        pattern: /».*|\{:[\s\S]*?:\}|\{[\s\S]*?\}|^-{6}$[\s\S]*/m,
        alias: "string",
        greedy: !0
      },
      label: {
        pattern: /\w+\b\??:/,
        alias: "property"
      },
      literal: {
        pattern: /'(?:\w+\b\??:?)/,
        alias: "constant"
      },
      type: {
        pattern: /:(?:\w+\b\??:?)/,
        alias: "class-name"
      },
      color: /#\w+/,
      predicate: {
        pattern: /\b(?:all|and|any|ascii|attr|attribute|attributeLabel|binary|block|char|contains|database|date|dictionary|empty|equal|even|every|exists|false|floating|function|greater|greaterOrEqual|if|in|inline|integer|is|key|label|leap|less|lessOrEqual|literal|logical|lower|nand|negative|nor|not|notEqual|null|numeric|odd|or|path|pathLabel|positive|prefix|prime|regex|same|set|some|sorted|standalone|string|subset|suffix|superset|symbol|symbolLiteral|true|try|type|unless|upper|when|whitespace|word|xnor|xor|zero)\?/,
        alias: "keyword"
      },
      "builtin-function": {
        pattern: /\b(?:abs|acos|acosh|acsec|acsech|actan|actanh|add|after|alert|alias|and|angle|append|arg|args|arity|array|as|asec|asech|asin|asinh|atan|atan2|atanh|attr|attrs|average|before|benchmark|blend|break|call|capitalize|case|ceil|chop|clear|clip|close|color|combine|conj|continue|copy|cos|cosh|crc|csec|csech|ctan|ctanh|cursor|darken|dec|decode|define|delete|desaturate|deviation|dialog|dictionary|difference|digest|digits|div|do|download|drop|dup|e|else|empty|encode|ensure|env|escape|execute|exit|exp|extend|extract|factors|fdiv|filter|first|flatten|floor|fold|from|function|gamma|gcd|get|goto|hash|hypot|if|inc|indent|index|infinity|info|input|insert|inspect|intersection|invert|jaro|join|keys|kurtosis|last|let|levenshtein|lighten|list|ln|log|loop|lower|mail|map|match|max|median|min|mod|module|mul|nand|neg|new|nor|normalize|not|now|null|open|or|outdent|pad|palette|panic|path|pause|permissions|permutate|pi|pop|popup|pow|powerset|powmod|prefix|print|prints|process|product|query|random|range|read|relative|remove|rename|render|repeat|replace|request|return|reverse|round|sample|saturate|script|sec|sech|select|serve|set|shl|shr|shuffle|sin|sinh|size|skewness|slice|sort|spin|split|sqrt|squeeze|stack|strip|sub|suffix|sum|switch|symbols|symlink|sys|take|tan|tanh|terminal|terminate|to|truncate|try|type|unclip|union|unique|unless|until|unzip|upper|values|var|variance|volume|webview|while|with|wordwrap|write|xnor|xor|zip)\b/,
        alias: "keyword"
      },
      sugar: {
        pattern: /->|=>|\||::/,
        alias: "operator"
      },
      punctuation: /[()[\],]/,
      symbol: {
        pattern: /<:|-:|ø|@|#|\+|\||\*|\$|---|-|%|\/|\.\.|\^|~|=|<|>|\\/
      },
      boolean: {
        pattern: /\b(?:false|maybe|true)\b/
      }
    }, e.languages.art = e.languages.arturo;
  })(t);
}
e9.displayName = "asciidoc";
e9.aliases = ["adoc"];
function e9(t) {
  (function(e) {
    var n = {
      pattern: /(^[ \t]*)\[(?!\[)(?:(["'$`])(?:(?!\2)[^\\]|\\.)*\2|\[(?:[^\[\]\\]|\\.)*\]|[^\[\]\\"'$`]|\\.)*\]/m,
      lookbehind: !0,
      inside: {
        quoted: {
          pattern: /([$`])(?:(?!\1)[^\\]|\\.)*\1/,
          inside: {
            punctuation: /^[$`]|[$`]$/
          }
        },
        interpreted: {
          pattern: /'(?:[^'\\]|\\.)*'/,
          inside: {
            punctuation: /^'|'$/
            // See rest below
          }
        },
        string: /"(?:[^"\\]|\\.)*"/,
        variable: /\w+(?==)/,
        punctuation: /^\[|\]$|,/,
        operator: /=/,
        // The negative look-ahead prevents blank matches
        "attr-value": /(?!^\s+$).+/
      }
    }, r = e.languages.asciidoc = {
      "comment-block": {
        pattern: /^(\/{4,})$[\s\S]*?^\1/m,
        alias: "comment"
      },
      table: {
        pattern: /^\|={3,}(?:(?:\r?\n|\r(?!\n)).*)*?(?:\r?\n|\r)\|={3,}$/m,
        inside: {
          specifiers: {
            pattern: /(?:(?:(?:\d+(?:\.\d+)?|\.\d+)[+*](?:[<^>](?:\.[<^>])?|\.[<^>])?|[<^>](?:\.[<^>])?|\.[<^>])[a-z]*|[a-z]+)(?=\|)/,
            alias: "attr-value"
          },
          punctuation: {
            pattern: /(^|[^\\])[|!]=*/,
            lookbehind: !0
          }
          // See rest below
        }
      },
      "passthrough-block": {
        pattern: /^(\+{4,})$[\s\S]*?^\1$/m,
        inside: {
          punctuation: /^\++|\++$/
          // See rest below
        }
      },
      // Literal blocks and listing blocks
      "literal-block": {
        pattern: /^(-{4,}|\.{4,})$[\s\S]*?^\1$/m,
        inside: {
          punctuation: /^(?:-+|\.+)|(?:-+|\.+)$/
          // See rest below
        }
      },
      // Sidebar blocks, quote blocks, example blocks and open blocks
      "other-block": {
        pattern: /^(--|\*{4,}|_{4,}|={4,})$[\s\S]*?^\1$/m,
        inside: {
          punctuation: /^(?:-+|\*+|_+|=+)|(?:-+|\*+|_+|=+)$/
          // See rest below
        }
      },
      // list-punctuation and list-label must appear before indented-block
      "list-punctuation": {
        pattern: /(^[ \t]*)(?:-|\*{1,5}|\.{1,5}|(?:[a-z]|\d+)\.|[xvi]+\))(?= )/im,
        lookbehind: !0,
        alias: "punctuation"
      },
      "list-label": {
        pattern: /(^[ \t]*)[a-z\d].+(?::{2,4}|;;)(?=\s)/im,
        lookbehind: !0,
        alias: "symbol"
      },
      "indented-block": {
        pattern: /((\r?\n|\r)\2)([ \t]+)\S.*(?:(?:\r?\n|\r)\3.+)*(?=\2{2}|$)/,
        lookbehind: !0
      },
      comment: /^\/\/.*/m,
      title: {
        pattern: /^.+(?:\r?\n|\r)(?:={3,}|-{3,}|~{3,}|\^{3,}|\+{3,})$|^={1,5} .+|^\.(?![\s.]).*/m,
        alias: "important",
        inside: {
          punctuation: /^(?:\.|=+)|(?:=+|-+|~+|\^+|\++)$/
          // See rest below
        }
      },
      "attribute-entry": {
        pattern: /^:[^:\r\n]+:(?: .*?(?: \+(?:\r?\n|\r).*?)*)?$/m,
        alias: "tag"
      },
      attributes: n,
      hr: {
        pattern: /^'{3,}$/m,
        alias: "punctuation"
      },
      "page-break": {
        pattern: /^<{3,}$/m,
        alias: "punctuation"
      },
      admonition: {
        pattern: /^(?:CAUTION|IMPORTANT|NOTE|TIP|WARNING):/m,
        alias: "keyword"
      },
      callout: [
        {
          pattern: /(^[ \t]*)<?\d*>/m,
          lookbehind: !0,
          alias: "symbol"
        },
        {
          pattern: /<\d+>/,
          alias: "symbol"
        }
      ],
      macro: {
        pattern: /\b[a-z\d][a-z\d-]*::?(?:[^\s\[\]]*\[(?:[^\]\\"']|(["'])(?:(?!\1)[^\\]|\\.)*\1|\\.)*\])/,
        inside: {
          function: /^[a-z\d-]+(?=:)/,
          punctuation: /^::?/,
          attributes: {
            pattern: /(?:\[(?:[^\]\\"']|(["'])(?:(?!\1)[^\\]|\\.)*\1|\\.)*\])/,
            inside: n.inside
          }
        }
      },
      inline: {
        /*
        The initial look-behind prevents the highlighting of escaped quoted text.
        Quoted text can be multi-line but cannot span an empty line.
        All quoted text can have attributes before [foobar, 'foobar', baz="bar"].
        First, we handle the constrained quotes.
        Those must be bounded by non-word chars and cannot have spaces between the delimiter and the first char.
        They are, in order: _emphasis_, ``double quotes'', `single quotes', `monospace`, 'emphasis', *strong*, +monospace+ and #unquoted#
        Then we handle the unconstrained quotes.
        Those do not have the restrictions of the constrained quotes.
        They are, in order: __emphasis__, **strong**, ++monospace++, +++passthrough+++, ##unquoted##, $$passthrough$$, ~subscript~, ^superscript^, {attribute-reference}, [[anchor]], [[[bibliography anchor]]], <<xref>>, (((indexes))) and ((indexes))
        */
        pattern: /(^|[^\\])(?:(?:\B\[(?:[^\]\\"']|(["'])(?:(?!\2)[^\\]|\\.)*\2|\\.)*\])?(?:\b_(?!\s)(?: _|[^_\\\r\n]|\\.)+(?:(?:\r?\n|\r)(?: _|[^_\\\r\n]|\\.)+)*_\b|\B``(?!\s).+?(?:(?:\r?\n|\r).+?)*''\B|\B`(?!\s)(?:[^`'\s]|\s+\S)+['`]\B|\B(['*+#])(?!\s)(?: \3|(?!\3)[^\\\r\n]|\\.)+(?:(?:\r?\n|\r)(?: \3|(?!\3)[^\\\r\n]|\\.)+)*\3\B)|(?:\[(?:[^\]\\"']|(["'])(?:(?!\4)[^\\]|\\.)*\4|\\.)*\])?(?:(__|\*\*|\+\+\+?|##|\$\$|[~^]).+?(?:(?:\r?\n|\r).+?)*\5|\{[^}\r\n]+\}|\[\[\[?.+?(?:(?:\r?\n|\r).+?)*\]?\]\]|<<.+?(?:(?:\r?\n|\r).+?)*>>|\(\(\(?.+?(?:(?:\r?\n|\r).+?)*\)?\)\)))/m,
        lookbehind: !0,
        inside: {
          attributes: n,
          url: {
            pattern: /^(?:\[\[\[?.+?\]?\]\]|<<.+?>>)$/,
            inside: {
              punctuation: /^(?:\[\[\[?|<<)|(?:\]\]\]?|>>)$/
            }
          },
          "attribute-ref": {
            pattern: /^\{.+\}$/,
            inside: {
              variable: {
                pattern: /(^\{)[a-z\d,+_-]+/,
                lookbehind: !0
              },
              operator: /^[=?!#%@$]|!(?=[:}])/,
              punctuation: /^\{|\}$|::?/
            }
          },
          italic: {
            pattern: /^(['_])[\s\S]+\1$/,
            inside: {
              punctuation: /^(?:''?|__?)|(?:''?|__?)$/
            }
          },
          bold: {
            pattern: /^\*[\s\S]+\*$/,
            inside: {
              punctuation: /^\*\*?|\*\*?$/
            }
          },
          punctuation: /^(?:``?|\+{1,3}|##?|\$\$|[~^]|\(\(\(?)|(?:''?|\+{1,3}|##?|\$\$|[~^`]|\)?\)\))$/
        }
      },
      replacement: {
        pattern: /\((?:C|R|TM)\)/,
        alias: "builtin"
      },
      entity: /&#?[\da-z]{1,8};/i,
      "line-continuation": {
        pattern: /(^| )\+$/m,
        lookbehind: !0,
        alias: "punctuation"
      }
    };
    function a(i) {
      i = i.split(" ");
      for (var o = {}, s = 0, u = i.length; s < u; s++)
        o[i[s]] = r[i[s]];
      return o;
    }
    n.inside.interpreted.inside.rest = a(
      "macro inline replacement entity"
    ), r["passthrough-block"].inside.rest = a("macro"), r["literal-block"].inside.rest = a("callout"), r.table.inside.rest = a(
      "comment-block passthrough-block literal-block other-block list-punctuation indented-block comment title attribute-entry attributes hr page-break admonition list-label callout macro inline replacement entity line-continuation"
    ), r["other-block"].inside.rest = a(
      "table list-punctuation indented-block comment attribute-entry attributes hr page-break admonition list-label macro inline replacement entity line-continuation"
    ), r.title.inside.rest = a(
      "macro inline replacement entity"
    ), e.hooks.add("wrap", function(i) {
      i.type === "entity" && (i.attributes.title = i.content.value.replace(/&amp;/, "&"));
    }), e.languages.adoc = e.languages.asciidoc;
  })(t);
}
t9.displayName = "aspnet";
t9.aliases = [];
function t9(t) {
  t.register(A0), t.register(ws), t.languages.aspnet = t.languages.extend("markup", {
    "page-directive": {
      pattern: /<%\s*@.*%>/,
      alias: "tag",
      inside: {
        "page-directive": {
          pattern: /<%\s*@\s*(?:Assembly|Control|Implements|Import|Master(?:Type)?|OutputCache|Page|PreviousPageType|Reference|Register)?|%>/i,
          alias: "tag"
        },
        rest: t.languages.markup.tag.inside
      }
    },
    directive: {
      pattern: /<%.*%>/,
      alias: "tag",
      inside: {
        directive: {
          pattern: /<%\s*?[$=%#:]{0,2}|%>/,
          alias: "tag"
        },
        rest: t.languages.csharp
      }
    }
  }), t.languages.aspnet.tag.pattern = /<(?!%)\/?[^\s>\/]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/, t.languages.insertBefore(
    "inside",
    "punctuation",
    {
      directive: t.languages.aspnet.directive
    },
    t.languages.aspnet.tag.inside["attr-value"]
  ), t.languages.insertBefore("aspnet", "comment", {
    "asp-comment": {
      pattern: /<%--[\s\S]*?--%>/,
      alias: ["asp", "comment"]
    }
  }), t.languages.insertBefore(
    "aspnet",
    t.languages.javascript ? "script" : "tag",
    {
      "asp-script": {
        pattern: /(<script(?=.*runat=['"]?server\b)[^>]*>)[\s\S]*?(?=<\/script>)/i,
        lookbehind: !0,
        alias: ["asp", "script"],
        inside: t.languages.csharp || {}
      }
    }
  );
}
n9.displayName = "asm6502";
n9.aliases = [];
function n9(t) {
  t.languages.asm6502 = {
    comment: /;.*/,
    directive: {
      pattern: /\.\w+(?= )/,
      alias: "property"
    },
    string: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
    "op-code": {
      pattern: /\b(?:ADC|AND|ASL|BCC|BCS|BEQ|BIT|BMI|BNE|BPL|BRK|BVC|BVS|CLC|CLD|CLI|CLV|CMP|CPX|CPY|DEC|DEX|DEY|EOR|INC|INX|INY|JMP|JSR|LDA|LDX|LDY|LSR|NOP|ORA|PHA|PHP|PLA|PLP|ROL|ROR|RTI|RTS|SBC|SEC|SED|SEI|STA|STX|STY|TAX|TAY|TSX|TXA|TXS|TYA|adc|and|asl|bcc|bcs|beq|bit|bmi|bne|bpl|brk|bvc|bvs|clc|cld|cli|clv|cmp|cpx|cpy|dec|dex|dey|eor|inc|inx|iny|jmp|jsr|lda|ldx|ldy|lsr|nop|ora|pha|php|pla|plp|rol|ror|rti|rts|sbc|sec|sed|sei|sta|stx|sty|tax|tay|tsx|txa|txs|tya)\b/,
      alias: "keyword"
    },
    "hex-number": {
      pattern: /#?\$[\da-f]{1,4}\b/i,
      alias: "number"
    },
    "binary-number": {
      pattern: /#?%[01]+\b/,
      alias: "number"
    },
    "decimal-number": {
      pattern: /#?\b\d+\b/,
      alias: "number"
    },
    register: {
      pattern: /\b[xya]\b/i,
      alias: "variable"
    },
    punctuation: /[(),:]/
  };
}
r9.displayName = "asmatmel";
r9.aliases = [];
function r9(t) {
  t.languages.asmatmel = {
    comment: {
      pattern: /;.*/,
      greedy: !0
    },
    string: {
      pattern: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
      greedy: !0
    },
    constant: /\b(?:PORT[A-Z]|DDR[A-Z]|(?:DD|P)[A-Z](?:\d|[0-2]\d|3[01]))\b/,
    directive: {
      pattern: /\.\w+(?= )/,
      alias: "property"
    },
    "r-register": {
      pattern: /\br(?:\d|[12]\d|3[01])\b/,
      alias: "variable"
    },
    "op-code": {
      pattern: /\b(?:ADC|ADD|ADIW|AND|ANDI|ASR|BCLR|BLD|BRBC|BRBS|BRCC|BRCS|BREAK|BREQ|BRGE|BRHC|BRHS|BRID|BRIE|BRLO|BRLT|BRMI|BRNE|BRPL|BRSH|BRTC|BRTS|BRVC|BRVS|BSET|BST|CALL|CBI|CBR|CLC|CLH|CLI|CLN|CLR|CLS|CLT|CLV|CLZ|COM|CP|CPC|CPI|CPSE|DEC|DES|EICALL|EIJMP|ELPM|EOR|FMUL|FMULS|FMULSU|ICALL|IJMP|IN|INC|JMP|LAC|LAS|LAT|LD|LD[A-Za-z0-9]|LPM|LSL|LSR|MOV|MOVW|MUL|MULS|MULSU|NEG|NOP|OR|ORI|OUT|POP|PUSH|RCALL|RET|RETI|RJMP|ROL|ROR|SBC|SBCI|SBI|SBIC|SBIS|SBIW|SBR|SBRC|SBRS|SEC|SEH|SEI|SEN|SER|SES|SET|SEV|SEZ|SLEEP|SPM|ST|ST[A-Z0-9]|SUB|SUBI|SWAP|TST|WDR|XCH|adc|add|adiw|and|andi|asr|bclr|bld|brbc|brbs|brcc|brcs|break|breq|brge|brhc|brhs|brid|brie|brlo|brlt|brmi|brne|brpl|brsh|brtc|brts|brvc|brvs|bset|bst|call|cbi|cbr|clc|clh|cli|cln|clr|cls|clt|clv|clz|com|cp|cpc|cpi|cpse|dec|des|eicall|eijmp|elpm|eor|fmul|fmuls|fmulsu|icall|ijmp|in|inc|jmp|lac|las|lat|ld|ld[a-z0-9]|lpm|lsl|lsr|mov|movw|mul|muls|mulsu|neg|nop|or|ori|out|pop|push|rcall|ret|reti|rjmp|rol|ror|sbc|sbci|sbi|sbic|sbis|sbiw|sbr|sbrc|sbrs|sec|seh|sei|sen|ser|ses|set|sev|sez|sleep|spm|st|st[a-zA-Z0-9]|sub|subi|swap|tst|wdr|xch)\b/,
      alias: "keyword"
    },
    "hex-number": {
      pattern: /#?\$[\da-f]{2,4}\b/i,
      alias: "number"
    },
    "binary-number": {
      pattern: /#?%[01]+\b/,
      alias: "number"
    },
    "decimal-number": {
      pattern: /#?\b\d+\b/,
      alias: "number"
    },
    register: {
      pattern: /\b[acznvshtixy]\b/i,
      alias: "variable"
    },
    operator: />>=?|<<=?|&[&=]?|\|[\|=]?|[-+*/%^!=<>?]=?/,
    punctuation: /[(),:]/
  };
}
a9.displayName = "autohotkey";
a9.aliases = [];
function a9(t) {
  t.languages.autohotkey = {
    comment: [
      {
        pattern: /(^|\s);.*/,
        lookbehind: !0
      },
      {
        pattern: /(^[\t ]*)\/\*(?:[\r\n](?![ \t]*\*\/)|[^\r\n])*(?:[\r\n][ \t]*\*\/)?/m,
        lookbehind: !0,
        greedy: !0
      }
    ],
    tag: {
      // labels
      pattern: /^([ \t]*)[^\s,`":]+(?=:[ \t]*$)/m,
      lookbehind: !0
    },
    string: /"(?:[^"\n\r]|"")*"/,
    variable: /%\w+%/,
    number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
    operator: /\?|\/\/?=?|:=|\|[=|]?|&[=&]?|\+[=+]?|-[=-]?|\*[=*]?|<(?:<=?|>|=)?|>>?=?|[.^!=~]=?|\b(?:AND|NOT|OR)\b/,
    boolean: /\b(?:false|true)\b/,
    command: {
      pattern: /\b(?:AutoTrim|BlockInput|Break|Click|ClipWait|Continue|Control|ControlClick|ControlFocus|ControlGet|ControlGetFocus|ControlGetPos|ControlGetText|ControlMove|ControlSend|ControlSendRaw|ControlSetText|CoordMode|Critical|DetectHiddenText|DetectHiddenWindows|Drive|DriveGet|DriveSpaceFree|EnvAdd|EnvDiv|EnvGet|EnvMult|EnvSet|EnvSub|EnvUpdate|Exit|ExitApp|FileAppend|FileCopy|FileCopyDir|FileCreateDir|FileCreateShortcut|FileDelete|FileEncoding|FileGetAttrib|FileGetShortcut|FileGetSize|FileGetTime|FileGetVersion|FileInstall|FileMove|FileMoveDir|FileRead|FileReadLine|FileRecycle|FileRecycleEmpty|FileRemoveDir|FileSelectFile|FileSelectFolder|FileSetAttrib|FileSetTime|FormatTime|GetKeyState|Gosub|Goto|GroupActivate|GroupAdd|GroupClose|GroupDeactivate|Gui|GuiControl|GuiControlGet|Hotkey|ImageSearch|IniDelete|IniRead|IniWrite|Input|InputBox|KeyWait|ListHotkeys|ListLines|ListVars|Loop|Menu|MouseClick|MouseClickDrag|MouseGetPos|MouseMove|MsgBox|OnExit|OutputDebug|Pause|PixelGetColor|PixelSearch|PostMessage|Process|Progress|Random|RegDelete|RegRead|RegWrite|Reload|Repeat|Return|Run|RunAs|RunWait|Send|SendEvent|SendInput|SendMessage|SendMode|SendPlay|SendRaw|SetBatchLines|SetCapslockState|SetControlDelay|SetDefaultMouseSpeed|SetEnv|SetFormat|SetKeyDelay|SetMouseDelay|SetNumlockState|SetRegView|SetScrollLockState|SetStoreCapslockMode|SetTimer|SetTitleMatchMode|SetWinDelay|SetWorkingDir|Shutdown|Sleep|Sort|SoundBeep|SoundGet|SoundGetWaveVolume|SoundPlay|SoundSet|SoundSetWaveVolume|SplashImage|SplashTextOff|SplashTextOn|SplitPath|StatusBarGetText|StatusBarWait|StringCaseSense|StringGetPos|StringLeft|StringLen|StringLower|StringMid|StringReplace|StringRight|StringSplit|StringTrimLeft|StringTrimRight|StringUpper|Suspend|SysGet|Thread|ToolTip|Transform|TrayTip|URLDownloadToFile|WinActivate|WinActivateBottom|WinClose|WinGet|WinGetActiveStats|WinGetActiveTitle|WinGetClass|WinGetPos|WinGetText|WinGetTitle|WinHide|WinKill|WinMaximize|WinMenuSelectItem|WinMinimize|WinMinimizeAll|WinMinimizeAllUndo|WinMove|WinRestore|WinSet|WinSetTitle|WinShow|WinWait|WinWaitActive|WinWaitClose|WinWaitNotActive)\b/i,
      alias: "selector"
    },
    constant: /\b(?:a_ahkpath|a_ahkversion|a_appdata|a_appdatacommon|a_autotrim|a_batchlines|a_caretx|a_carety|a_computername|a_controldelay|a_cursor|a_dd|a_ddd|a_dddd|a_defaultmousespeed|a_desktop|a_desktopcommon|a_detecthiddentext|a_detecthiddenwindows|a_endchar|a_eventinfo|a_exitreason|a_fileencoding|a_formatfloat|a_formatinteger|a_gui|a_guicontrol|a_guicontrolevent|a_guievent|a_guiheight|a_guiwidth|a_guix|a_guiy|a_hour|a_iconfile|a_iconhidden|a_iconnumber|a_icontip|a_index|a_ipaddress1|a_ipaddress2|a_ipaddress3|a_ipaddress4|a_is64bitos|a_isadmin|a_iscompiled|a_iscritical|a_ispaused|a_issuspended|a_isunicode|a_keydelay|a_language|a_lasterror|a_linefile|a_linenumber|a_loopfield|a_loopfileattrib|a_loopfiledir|a_loopfileext|a_loopfilefullpath|a_loopfilelongpath|a_loopfilename|a_loopfileshortname|a_loopfileshortpath|a_loopfilesize|a_loopfilesizekb|a_loopfilesizemb|a_loopfiletimeaccessed|a_loopfiletimecreated|a_loopfiletimemodified|a_loopreadline|a_loopregkey|a_loopregname|a_loopregsubkey|a_loopregtimemodified|a_loopregtype|a_mday|a_min|a_mm|a_mmm|a_mmmm|a_mon|a_mousedelay|a_msec|a_mydocuments|a_now|a_nowutc|a_numbatchlines|a_ostype|a_osversion|a_priorhotkey|a_priorkey|a_programfiles|a_programs|a_programscommon|a_ptrsize|a_regview|a_screendpi|a_screenheight|a_screenwidth|a_scriptdir|a_scriptfullpath|a_scripthwnd|a_scriptname|a_sec|a_space|a_startmenu|a_startmenucommon|a_startup|a_startupcommon|a_stringcasesense|a_tab|a_temp|a_thisfunc|a_thishotkey|a_thislabel|a_thismenu|a_thismenuitem|a_thismenuitempos|a_tickcount|a_timeidle|a_timeidlephysical|a_timesincepriorhotkey|a_timesincethishotkey|a_titlematchmode|a_titlematchmodespeed|a_username|a_wday|a_windelay|a_windir|a_workingdir|a_yday|a_year|a_yweek|a_yyyy|clipboard|clipboardall|comspec|errorlevel|programfiles)\b/i,
    builtin: /\b(?:abs|acos|asc|asin|atan|ceil|chr|class|comobjactive|comobjarray|comobjconnect|comobjcreate|comobjerror|comobjflags|comobjget|comobjquery|comobjtype|comobjvalue|cos|dllcall|exp|fileexist|Fileopen|floor|format|il_add|il_create|il_destroy|instr|isfunc|islabel|IsObject|ln|log|ltrim|lv_add|lv_delete|lv_deletecol|lv_getcount|lv_getnext|lv_gettext|lv_insert|lv_insertcol|lv_modify|lv_modifycol|lv_setimagelist|mod|numget|numput|onmessage|regexmatch|regexreplace|registercallback|round|rtrim|sb_seticon|sb_setparts|sb_settext|sin|sqrt|strlen|strreplace|strsplit|substr|tan|tv_add|tv_delete|tv_get|tv_getchild|tv_getcount|tv_getnext|tv_getparent|tv_getprev|tv_getselection|tv_gettext|tv_modify|varsetcapacity|winactive|winexist|__Call|__Get|__New|__Set)\b/i,
    symbol: /\b(?:alt|altdown|altup|appskey|backspace|browser_back|browser_favorites|browser_forward|browser_home|browser_refresh|browser_search|browser_stop|bs|capslock|ctrl|ctrlbreak|ctrldown|ctrlup|del|delete|down|end|enter|esc|escape|f1|f10|f11|f12|f13|f14|f15|f16|f17|f18|f19|f2|f20|f21|f22|f23|f24|f3|f4|f5|f6|f7|f8|f9|home|ins|insert|joy1|joy10|joy11|joy12|joy13|joy14|joy15|joy16|joy17|joy18|joy19|joy2|joy20|joy21|joy22|joy23|joy24|joy25|joy26|joy27|joy28|joy29|joy3|joy30|joy31|joy32|joy4|joy5|joy6|joy7|joy8|joy9|joyaxes|joybuttons|joyinfo|joyname|joypov|joyr|joyu|joyv|joyx|joyy|joyz|lalt|launch_app1|launch_app2|launch_mail|launch_media|lbutton|lcontrol|lctrl|left|lshift|lwin|lwindown|lwinup|mbutton|media_next|media_play_pause|media_prev|media_stop|numlock|numpad0|numpad1|numpad2|numpad3|numpad4|numpad5|numpad6|numpad7|numpad8|numpad9|numpadadd|numpadclear|numpaddel|numpaddiv|numpaddot|numpaddown|numpadend|numpadenter|numpadhome|numpadins|numpadleft|numpadmult|numpadpgdn|numpadpgup|numpadright|numpadsub|numpadup|pgdn|pgup|printscreen|ralt|rbutton|rcontrol|rctrl|right|rshift|rwin|rwindown|rwinup|scrolllock|shift|shiftdown|shiftup|space|tab|up|volume_down|volume_mute|volume_up|wheeldown|wheelleft|wheelright|wheelup|xbutton1|xbutton2)\b/i,
    directive: {
      pattern: /#[a-z]+\b/i,
      alias: "important"
    },
    keyword: /\b(?:Abort|AboveNormal|Add|ahk_class|ahk_exe|ahk_group|ahk_id|ahk_pid|All|Alnum|Alpha|AltSubmit|AltTab|AltTabAndMenu|AltTabMenu|AltTabMenuDismiss|AlwaysOnTop|AutoSize|Background|BackgroundTrans|BelowNormal|between|BitAnd|BitNot|BitOr|BitShiftLeft|BitShiftRight|BitXOr|Bold|Border|Button|ByRef|Catch|Checkbox|Checked|CheckedGray|Choose|ChooseString|Close|Color|ComboBox|Contains|ControlList|Count|Date|DateTime|Days|DDL|Default|DeleteAll|Delimiter|Deref|Destroy|Digit|Disable|Disabled|DropDownList|Edit|Eject|Else|Enable|Enabled|Error|Exist|Expand|ExStyle|FileSystem|Finally|First|Flash|Float|FloatFast|Focus|Font|for|global|Grid|Group|GroupBox|GuiClose|GuiContextMenu|GuiDropFiles|GuiEscape|GuiSize|Hdr|Hidden|Hide|High|HKCC|HKCR|HKCU|HKEY_CLASSES_ROOT|HKEY_CURRENT_CONFIG|HKEY_CURRENT_USER|HKEY_LOCAL_MACHINE|HKEY_USERS|HKLM|HKU|Hours|HScroll|Icon|IconSmall|ID|IDLast|If|IfEqual|IfExist|IfGreater|IfGreaterOrEqual|IfInString|IfLess|IfLessOrEqual|IfMsgBox|IfNotEqual|IfNotExist|IfNotInString|IfWinActive|IfWinExist|IfWinNotActive|IfWinNotExist|Ignore|ImageList|in|Integer|IntegerFast|Interrupt|is|italic|Join|Label|LastFound|LastFoundExist|Limit|Lines|List|ListBox|ListView|local|Lock|Logoff|Low|Lower|Lowercase|MainWindow|Margin|Maximize|MaximizeBox|MaxSize|Minimize|MinimizeBox|MinMax|MinSize|Minutes|MonthCal|Mouse|Move|Multi|NA|No|NoActivate|NoDefault|NoHide|NoIcon|NoMainWindow|norm|Normal|NoSort|NoSortHdr|NoStandard|Not|NoTab|NoTimers|Number|Off|Ok|On|OwnDialogs|Owner|Parse|Password|Picture|Pixel|Pos|Pow|Priority|ProcessName|Radio|Range|Read|ReadOnly|Realtime|Redraw|Region|REG_BINARY|REG_DWORD|REG_EXPAND_SZ|REG_MULTI_SZ|REG_SZ|Relative|Rename|Report|Resize|Restore|Retry|RGB|Screen|Seconds|Section|Serial|SetLabel|ShiftAltTab|Show|Single|Slider|SortDesc|Standard|static|Status|StatusBar|StatusCD|strike|Style|Submit|SysMenu|Tab2|TabStop|Text|Theme|Throw|Tile|ToggleCheck|ToggleEnable|ToolWindow|Top|Topmost|TransColor|Transparent|Tray|TreeView|Try|TryAgain|Type|UnCheck|underline|Unicode|Unlock|Until|UpDown|Upper|Uppercase|UseErrorLevel|Vis|VisFirst|Visible|VScroll|Wait|WaitClose|WantCtrlA|WantF2|WantReturn|While|Wrap|Xdigit|xm|xp|xs|Yes|ym|yp|ys)\b/i,
    function: /[^(); \t,\n+*\-=?>:\\\/<&%\[\]]+(?=\()/,
    punctuation: /[{}[\]():,]/
  };
}
i9.displayName = "autoit";
i9.aliases = [];
function i9(t) {
  t.languages.autoit = {
    comment: [
      /;.*/,
      {
        // The multi-line comments delimiters can actually be commented out with ";"
        pattern: /(^[\t ]*)#(?:comments-start|cs)[\s\S]*?^[ \t]*#(?:ce|comments-end)/m,
        lookbehind: !0
      }
    ],
    url: {
      pattern: /(^[\t ]*#include\s+)(?:<[^\r\n>]+>|"[^\r\n"]+")/m,
      lookbehind: !0
    },
    string: {
      pattern: /(["'])(?:\1\1|(?!\1)[^\r\n])*\1/,
      greedy: !0,
      inside: {
        variable: /([%$@])\w+\1/
      }
    },
    directive: {
      pattern: /(^[\t ]*)#[\w-]+/m,
      lookbehind: !0,
      alias: "keyword"
    },
    function: /\b\w+(?=\()/,
    // Variables and macros
    variable: /[$@]\w+/,
    keyword: /\b(?:Case|Const|Continue(?:Case|Loop)|Default|Dim|Do|Else(?:If)?|End(?:Func|If|Select|Switch|With)|Enum|Exit(?:Loop)?|For|Func|Global|If|In|Local|Next|Null|ReDim|Select|Static|Step|Switch|Then|To|Until|Volatile|WEnd|While|With)\b/i,
    number: /\b(?:0x[\da-f]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/i,
    boolean: /\b(?:False|True)\b/i,
    operator: /<[=>]?|[-+*\/=&>]=?|[?^]|\b(?:And|Not|Or)\b/i,
    punctuation: /[\[\]().,:]/
  };
}
o9.displayName = "avisynth";
o9.aliases = ["avs"];
function o9(t) {
  (function(e) {
    function n(f, p) {
      return f.replace(/<<(\d+)>>/g, function(m, v) {
        return p[+v];
      });
    }
    function r(f, p, m) {
      return RegExp(n(f, p), m || "");
    }
    var a = /bool|clip|float|int|string|val/.source, i = [
      // bools
      /is(?:bool|clip|float|int|string)|defined|(?:(?:internal)?function|var)?exists?/.source,
      // control
      /apply|assert|default|eval|import|nop|select|undefined/.source,
      // global
      /opt_(?:allowfloataudio|avipadscanlines|dwchannelmask|enable_(?:b64a|planartopackedrgb|v210|y3_10_10|y3_10_16)|usewaveextensible|vdubplanarhack)|set(?:cachemode|maxcpu|memorymax|planarlegacyalignment|workingdir)/.source,
      // conv
      /hex(?:value)?|value/.source,
      // numeric
      /abs|ceil|continued(?:denominator|numerator)?|exp|floor|fmod|frac|log(?:10)?|max|min|muldiv|pi|pow|rand|round|sign|spline|sqrt/.source,
      // trig
      /a?sinh?|a?cosh?|a?tan[2h]?/.source,
      // bit
      /(?:bit(?:and|not|x?or|[lr]?shift[aslu]?|sh[lr]|sa[lr]|[lr]rotatel?|ro[rl]|te?st|set(?:count)?|cl(?:ea)?r|ch(?:an)?ge?))/.source,
      // runtime
      /average(?:[bgr]|chroma[uv]|luma)|(?:[rgb]|chroma[uv]|luma|rgb|[yuv](?=difference(?:fromprevious|tonext)))difference(?:fromprevious|tonext)?|[yuvrgb]plane(?:median|min|max|minmaxdifference)/.source,
      // script
      /getprocessinfo|logmsg|script(?:dir(?:utf8)?|file(?:utf8)?|name(?:utf8)?)|setlogparams/.source,
      // string
      /chr|(?:fill|find|left|mid|replace|rev|right)str|format|[lu]case|ord|str(?:cmpi?|fromutf8|len|toutf8)|time|trim(?:all|left|right)/.source,
      // version
      /isversionorgreater|version(?:number|string)/.source,
      // helper
      /buildpixeltype|colorspacenametopixeltype/.source,
      // avsplus
      /addautoloaddir|on(?:cpu|cuda)|prefetch|setfiltermtmode/.source
    ].join("|"), o = [
      // content
      /has(?:audio|video)/.source,
      // resolution
      /height|width/.source,
      // framerate
      /frame(?:count|rate)|framerate(?:denominator|numerator)/.source,
      // interlacing
      /getparity|is(?:field|frame)based/.source,
      // color format
      /bitspercomponent|componentsize|hasalpha|is(?:planar(?:rgba?)?|interleaved|rgb(?:24|32|48|64)?|y(?:8|u(?:va?|y2))?|yv(?:12|16|24|411)|420|422|444|packedrgb)|numcomponents|pixeltype/.source,
      // audio
      /audio(?:bits|channels|duration|length(?:[fs]|hi|lo)?|rate)|isaudio(?:float|int)/.source
    ].join("|"), s = [
      // source
      /avi(?:file)?source|directshowsource|image(?:reader|source|sourceanim)|opendmlsource|segmented(?:avisource|directshowsource)|wavsource/.source,
      // color
      /coloryuv|convertbacktoyuy2|convertto(?:RGB(?:24|32|48|64)|(?:planar)?RGBA?|Y8?|YV(?:12|16|24|411)|YUVA?(?:411|420|422|444)|YUY2)|fixluminance|gr[ae]yscale|invert|levels|limiter|mergea?rgb|merge(?:chroma|luma)|rgbadjust|show(?:alpha|blue|green|red)|swapuv|tweak|[uv]toy8?|ytouv/.source,
      // overlay
      /(?:colorkey|reset)mask|layer|mask(?:hs)?|merge|overlay|subtract/.source,
      // geometry
      /addborders|(?:bicubic|bilinear|blackman|gauss|lanczos4|lanczos|point|sinc|spline(?:16|36|64))resize|crop(?:bottom)?|flip(?:horizontal|vertical)|(?:horizontal|vertical)?reduceby2|letterbox|skewrows|turn(?:180|left|right)/.source,
      // pixel
      /blur|fixbrokenchromaupsampling|generalconvolution|(?:spatial|temporal)soften|sharpen/.source,
      // timeline
      /trim|(?:un)?alignedsplice|(?:assume|assumescaled|change|convert)FPS|(?:delete|duplicate)frame|dissolve|fade(?:in|io|out)[02]?|freezeframe|interleave|loop|reverse|select(?:even|odd|(?:range)?every)/.source,
      // interlace
      /assume[bt]ff|assume(?:field|frame)based|bob|complementparity|doubleweave|peculiarblend|pulldown|separate(?:columns|fields|rows)|swapfields|weave(?:columns|rows)?/.source,
      // audio
      /amplify(?:db)?|assumesamplerate|audiodub(?:ex)?|audiotrim|convertaudioto(?:(?:8|16|24|32)bit|float)|converttomono|delayaudio|ensurevbrmp3sync|get(?:left|right)?channel|kill(?:audio|video)|mergechannels|mixaudio|monotostereo|normalize|resampleaudio|ssrc|supereq|timestretch/.source,
      // conditional
      /animate|applyrange|conditional(?:filter|reader|select)|frameevaluate|scriptclip|tcp(?:server|source)|writefile(?:end|if|start)?/.source,
      // export
      /imagewriter/.source,
      // debug
      /blackness|blankclip|colorbars(?:hd)?|compare|dumpfiltergraph|echo|histogram|info|messageclip|preroll|setgraphanalysis|show(?:framenumber|smpte|time)|showfiveversions|stack(?:horizontal|vertical)|subtitle|tone|version/.source
    ].join("|"), u = [i, o, s].join("|");
    e.languages.avisynth = {
      comment: [
        {
          // Matches [* *] nestable block comments, but only supports 1 level of nested comments
          // /\[\*(?:[^\[*]|\[(?!\*)|\*(?!\])|<self>)*\*\]/
          pattern: /(^|[^\\])\[\*(?:[^\[*]|\[(?!\*)|\*(?!\])|\[\*(?:[^\[*]|\[(?!\*)|\*(?!\]))*\*\])*\*\]/,
          lookbehind: !0,
          greedy: !0
        },
        {
          // Matches /* */ block comments
          pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
          lookbehind: !0,
          greedy: !0
        },
        {
          // Matches # comments
          pattern: /(^|[^\\$])#.*/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      // Handle before strings because optional arguments are surrounded by double quotes
      argument: {
        pattern: r(/\b(?:<<0>>)\s+("?)\w+\1/.source, [a], "i"),
        inside: {
          keyword: /^\w+/
        }
      },
      // Optional argument assignment
      "argument-label": {
        pattern: /([,(][\s\\]*)\w+\s*=(?!=)/,
        lookbehind: !0,
        inside: {
          "argument-name": {
            pattern: /^\w+/,
            alias: "punctuation"
          },
          punctuation: /=$/
        }
      },
      string: [
        {
          // triple double-quoted
          pattern: /"""[\s\S]*?"""/,
          greedy: !0
        },
        {
          // single double-quoted
          pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
          greedy: !0,
          inside: {
            constant: {
              // These *are* case-sensitive!
              pattern: /\b(?:DEFAULT_MT_MODE|(?:MAINSCRIPT|PROGRAM|SCRIPT)DIR|(?:MACHINE|USER)_(?:CLASSIC|PLUS)_PLUGINS)\b/
            }
          }
        }
      ],
      // The special "last" variable that takes the value of the last implicitly returned clip
      variable: /\b(?:last)\b/i,
      boolean: /\b(?:false|no|true|yes)\b/i,
      keyword: /\b(?:catch|else|for|function|global|if|return|try|while|__END__)\b/i,
      constant: /\bMT_(?:MULTI_INSTANCE|NICE_FILTER|SERIALIZED|SPECIAL_MT)\b/,
      // AviSynth's internal functions, filters, and properties
      "builtin-function": {
        pattern: r(/\b(?:<<0>>)\b/.source, [u], "i"),
        alias: "function"
      },
      "type-cast": {
        pattern: r(/\b(?:<<0>>)(?=\s*\()/.source, [a], "i"),
        alias: "keyword"
      },
      // External/user-defined filters
      function: {
        pattern: /\b[a-z_]\w*(?=\s*\()|(\.)[a-z_]\w*\b/i,
        lookbehind: !0
      },
      // Matches a \ as the first or last character on a line
      "line-continuation": {
        pattern: /(^[ \t]*)\\|\\(?=[ \t]*$)/m,
        lookbehind: !0,
        alias: "punctuation"
      },
      number: /\B\$(?:[\da-f]{6}|[\da-f]{8})\b|(?:(?:\b|\B-)\d+(?:\.\d*)?\b|\B\.\d+\b)/i,
      operator: /\+\+?|[!=<>]=?|&&|\|\||[?:*/%-]/,
      punctuation: /[{}\[\]();,.]/
    }, e.languages.avs = e.languages.avisynth;
  })(t);
}
s9.displayName = "avro-idl";
s9.aliases = ["avdl"];
function s9(t) {
  t.languages["avro-idl"] = {
    comment: {
      pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
      greedy: !0
    },
    string: {
      pattern: /(^|[^\\])"(?:[^\r\n"\\]|\\.)*"/,
      lookbehind: !0,
      greedy: !0
    },
    annotation: {
      pattern: /@(?:[$\w.-]|`[^\r\n`]+`)+/,
      greedy: !0,
      alias: "function"
    },
    "function-identifier": {
      pattern: /`[^\r\n`]+`(?=\s*\()/,
      greedy: !0,
      alias: "function"
    },
    identifier: {
      pattern: /`[^\r\n`]+`/,
      greedy: !0
    },
    "class-name": {
      pattern: /(\b(?:enum|error|protocol|record|throws)\b\s+)[$\w]+/,
      lookbehind: !0,
      greedy: !0
    },
    keyword: /\b(?:array|boolean|bytes|date|decimal|double|enum|error|false|fixed|float|idl|import|int|local_timestamp_ms|long|map|null|oneway|protocol|record|schema|string|throws|time_ms|timestamp_ms|true|union|uuid|void)\b/,
    function: /\b[a-z_]\w*(?=\s*\()/i,
    number: [
      {
        pattern: /(^|[^\w.])-?(?:(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|0x(?:[a-f0-9]+(?:\.[a-f0-9]*)?|\.[a-f0-9]+)(?:p[+-]?\d+)?)[dfl]?(?![\w.])/i,
        lookbehind: !0
      },
      /-?\b(?:Infinity|NaN)\b/
    ],
    operator: /=/,
    punctuation: /[()\[\]{}<>.:,;-]/
  }, t.languages.avdl = t.languages["avro-idl"];
}
l9.displayName = "awk";
l9.aliases = ["gawk"];
function l9(t) {
  t.languages.awk = {
    hashbang: {
      pattern: /^#!.*/,
      greedy: !0,
      alias: "comment"
    },
    comment: {
      pattern: /#.*/,
      greedy: !0
    },
    string: {
      pattern: /(^|[^\\])"(?:[^\\"\r\n]|\\.)*"/,
      lookbehind: !0,
      greedy: !0
    },
    regex: {
      pattern: /((?:^|[^\w\s)])\s*)\/(?:[^\/\\\r\n]|\\.)*\//,
      lookbehind: !0,
      greedy: !0
    },
    variable: /\$\w+/,
    keyword: /\b(?:BEGIN|BEGINFILE|END|ENDFILE|break|case|continue|default|delete|do|else|exit|for|function|getline|if|in|next|nextfile|printf?|return|switch|while)\b|@(?:include|load)\b/,
    function: /\b[a-z_]\w*(?=\s*\()/i,
    number: /\b(?:\d+(?:\.\d+)?(?:e[+-]?\d+)?|0x[a-fA-F0-9]+)\b/,
    operator: /--|\+\+|!?~|>&|>>|<<|(?:\*\*|[<>!=+\-*/%^])=?|&&|\|[|&]|[?:]/,
    punctuation: /[()[\]{},;]/
  }, t.languages.gawk = t.languages.awk;
}
u9.displayName = "batch";
u9.aliases = [];
function u9(t) {
  (function(e) {
    var n = /%%?[~:\w]+%?|!\S+!/, r = {
      pattern: /\/[a-z?]+(?=[ :]|$):?|-[a-z]\b|--[a-z-]+\b/im,
      alias: "attr-name",
      inside: {
        punctuation: /:/
      }
    }, a = /"(?:[\\"]"|[^"])*"(?!")/, i = /(?:\b|-)\d+\b/;
    e.languages.batch = {
      comment: [
        /^::.*/m,
        {
          pattern: /((?:^|[&(])[ \t]*)rem\b(?:[^^&)\r\n]|\^(?:\r\n|[\s\S]))*/im,
          lookbehind: !0
        }
      ],
      label: {
        pattern: /^:.*/m,
        alias: "property"
      },
      command: [
        {
          // FOR command
          pattern: /((?:^|[&(])[ \t]*)for(?: \/[a-z?](?:[ :](?:"[^"]*"|[^\s"/]\S*))?)* \S+ in \([^)]+\) do/im,
          lookbehind: !0,
          inside: {
            keyword: /\b(?:do|in)\b|^for\b/i,
            string: a,
            parameter: r,
            variable: n,
            number: i,
            punctuation: /[()',]/
          }
        },
        {
          // IF command
          pattern: /((?:^|[&(])[ \t]*)if(?: \/[a-z?](?:[ :](?:"[^"]*"|[^\s"/]\S*))?)* (?:not )?(?:cmdextversion \d+|defined \w+|errorlevel \d+|exist \S+|(?:"[^"]*"|(?!")(?:(?!==)\S)+)?(?:==| (?:equ|geq|gtr|leq|lss|neq) )(?:"[^"]*"|[^\s"]\S*))/im,
          lookbehind: !0,
          inside: {
            keyword: /\b(?:cmdextversion|defined|errorlevel|exist|not)\b|^if\b/i,
            string: a,
            parameter: r,
            variable: n,
            number: i,
            operator: /\^|==|\b(?:equ|geq|gtr|leq|lss|neq)\b/i
          }
        },
        {
          // ELSE command
          pattern: /((?:^|[&()])[ \t]*)else\b/im,
          lookbehind: !0,
          inside: {
            keyword: /^else\b/i
          }
        },
        {
          // SET command
          pattern: /((?:^|[&(])[ \t]*)set(?: \/[a-z](?:[ :](?:"[^"]*"|[^\s"/]\S*))?)* (?:[^^&)\r\n]|\^(?:\r\n|[\s\S]))*/im,
          lookbehind: !0,
          inside: {
            keyword: /^set\b/i,
            string: a,
            parameter: r,
            variable: [n, /\w+(?=(?:[*\/%+\-&^|]|<<|>>)?=)/],
            number: i,
            operator: /[*\/%+\-&^|]=?|<<=?|>>=?|[!~_=]/,
            punctuation: /[()',]/
          }
        },
        {
          // Other commands
          pattern: /((?:^|[&(])[ \t]*@?)\w+\b(?:"(?:[\\"]"|[^"])*"(?!")|[^"^&)\r\n]|\^(?:\r\n|[\s\S]))*/m,
          lookbehind: !0,
          inside: {
            keyword: /^\w+\b/,
            string: a,
            parameter: r,
            label: {
              pattern: /(^\s*):\S+/m,
              lookbehind: !0,
              alias: "property"
            },
            variable: n,
            number: i,
            operator: /\^/
          }
        }
      ],
      operator: /[&@]/,
      punctuation: /[()']/
    };
  })(t);
}
c9.displayName = "bbcode";
c9.aliases = ["shortcode"];
function c9(t) {
  t.languages.bbcode = {
    tag: {
      pattern: /\[\/?[^\s=\]]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'"\]=]+))?(?:\s+[^\s=\]]+\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'"\]=]+))*\s*\]/,
      inside: {
        tag: {
          pattern: /^\[\/?[^\s=\]]+/,
          inside: {
            punctuation: /^\[\/?/
          }
        },
        "attr-value": {
          pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'"\]=]+)/,
          inside: {
            punctuation: [
              /^=/,
              {
                pattern: /^(\s*)["']|["']$/,
                lookbehind: !0
              }
            ]
          }
        },
        punctuation: /\]/,
        "attr-name": /[^\s=\]]+/
      }
    }
  }, t.languages.shortcode = t.languages.bbcode;
}
f9.displayName = "bbj";
f9.aliases = [];
function f9(t) {
  (function(e) {
    e.languages.bbj = {
      comment: {
        pattern: /(^|[^\\:])rem\s+.*/i,
        lookbehind: !0,
        greedy: !0
      },
      string: {
        pattern: /(['"])(?:(?!\1|\\).|\\.)*\1/,
        greedy: !0
      },
      number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
      keyword: /\b(?:abstract|all|argc|begin|bye|callback|case|chn|class|classend|ctl|day|declare|delete|dim|dom|dread|dsz|else|end|endif|err|exitto|extends|fi|field|for|from|gosub|goto|if|implements|interface|interfaceend|iol|iolist|let|list|load|method|methodend|methodret|on|opts|pfx|print|private|process_events|protected|psz|public|read|read_resource|release|remove_callback|repeat|restore|return|rev|seterr|setesc|sqlchn|sqlunt|ssn|start|static|swend|switch|sys|then|tim|unt|until|use|void|wend|where|while)\b/i,
      function: /\b\w+(?=\()/,
      boolean: /\b(?:BBjAPI\.TRUE|BBjAPI\.FALSE)\b/i,
      operator: /<[=>]?|>=?|[+\-*\/^=&]|\b(?:and|not|or|xor)\b/i,
      punctuation: /[.,;:()]/
    };
  })(t);
}
d9.displayName = "bicep";
d9.aliases = [];
function d9(t) {
  t.languages.bicep = {
    comment: [
      {
        // multiline comments eg /* ASDF */
        pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
        lookbehind: !0,
        greedy: !0
      },
      {
        // singleline comments eg // ASDF
        pattern: /(^|[^\\:])\/\/.*/,
        lookbehind: !0,
        greedy: !0
      }
    ],
    property: [
      {
        pattern: /([\r\n][ \t]*)[a-z_]\w*(?=[ \t]*:)/i,
        lookbehind: !0
      },
      {
        pattern: /([\r\n][ \t]*)'(?:\\.|\$(?!\{)|[^'\\\r\n$])*'(?=[ \t]*:)/,
        lookbehind: !0,
        greedy: !0
      }
    ],
    string: [
      {
        pattern: /'''[^'][\s\S]*?'''/,
        greedy: !0
      },
      {
        pattern: /(^|[^\\'])'(?:\\.|\$(?!\{)|[^'\\\r\n$])*'/,
        lookbehind: !0,
        greedy: !0
      }
    ],
    "interpolated-string": {
      pattern: /(^|[^\\'])'(?:\\.|\$(?:(?!\{)|\{[^{}\r\n]*\})|[^'\\\r\n$])*'/,
      lookbehind: !0,
      greedy: !0,
      inside: {
        interpolation: {
          pattern: /\$\{[^{}\r\n]*\}/,
          inside: {
            expression: {
              pattern: /(^\$\{)[\s\S]+(?=\}$)/,
              lookbehind: !0
            },
            punctuation: /^\$\{|\}$/
          }
        },
        string: /[\s\S]+/
      }
    },
    datatype: {
      pattern: /(\b(?:output|param)\b[ \t]+\w+[ \t]+)\w+\b/,
      lookbehind: !0,
      alias: "class-name"
    },
    boolean: /\b(?:false|true)\b/,
    // https://github.com/Azure/bicep/blob/114a3251b4e6e30082a58729f19a8cc4e374ffa6/src/textmate/bicep.tmlanguage#L184
    keyword: /\b(?:existing|for|if|in|module|null|output|param|resource|targetScope|var)\b/,
    decorator: /@\w+\b/,
    function: /\b[a-z_]\w*(?=[ \t]*\()/i,
    number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
    operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/,
    punctuation: /[{}[\];(),.:]/
  }, t.languages.bicep["interpolated-string"].inside.interpolation.inside.expression.inside = t.languages.bicep;
}
p9.displayName = "birb";
p9.aliases = [];
function p9(t) {
  t.register(Lr), t.languages.birb = t.languages.extend("clike", {
    string: {
      pattern: /r?("|')(?:\\.|(?!\1)[^\\])*\1/,
      greedy: !0
    },
    "class-name": [
      /\b[A-Z](?:[\d_]*[a-zA-Z]\w*)?\b/,
      // matches variable and function return types (parameters as well).
      /\b(?:[A-Z]\w*|(?!(?:var|void)\b)[a-z]\w*)(?=\s+\w+\s*[;,=()])/
    ],
    keyword: /\b(?:assert|break|case|class|const|default|else|enum|final|follows|for|grab|if|nest|new|next|noSeeb|return|static|switch|throw|var|void|while)\b/,
    operator: /\+\+|--|&&|\|\||<<=?|>>=?|~(?:\/=?)?|[+\-*\/%&^|=!<>]=?|\?|:/,
    variable: /\b[a-z_]\w*\b/
  }), t.languages.insertBefore("birb", "function", {
    metadata: {
      pattern: /<\w+>/,
      greedy: !0,
      alias: "symbol"
    }
  });
}
h9.displayName = "bison";
h9.aliases = [];
function h9(t) {
  t.register(tp), t.languages.bison = t.languages.extend("c", {}), t.languages.insertBefore("bison", "comment", {
    bison: {
      // This should match all the beginning of the file
      // including the prologue(s), the bison declarations and
      // the grammar rules.
      pattern: /^(?:[^%]|%(?!%))*%%[\s\S]*?%%/,
      inside: {
        c: {
          // Allow for one level of nested braces
          pattern: /%\{[\s\S]*?%\}|\{(?:\{[^}]*\}|[^{}])*\}/,
          inside: {
            delimiter: {
              pattern: /^%?\{|%?\}$/,
              alias: "punctuation"
            },
            "bison-variable": {
              pattern: /[$@](?:<[^\s>]+>)?[\w$]+/,
              alias: "variable",
              inside: {
                punctuation: /<|>/
              }
            },
            rest: t.languages.c
          }
        },
        comment: t.languages.c.comment,
        string: t.languages.c.string,
        property: /\S+(?=:)/,
        keyword: /%\w+/,
        number: {
          pattern: /(^|[^@])\b(?:0x[\da-f]+|\d+)/i,
          lookbehind: !0
        },
        punctuation: /%[%?]|[|:;\[\]<>]/
      }
    }
  });
}
m9.displayName = "bnf";
m9.aliases = ["rbnf"];
function m9(t) {
  t.languages.bnf = {
    string: {
      pattern: /"[^\r\n"]*"|'[^\r\n']*'/
    },
    definition: {
      pattern: /<[^<>\r\n\t]+>(?=\s*::=)/,
      alias: ["rule", "keyword"],
      inside: {
        punctuation: /^<|>$/
      }
    },
    rule: {
      pattern: /<[^<>\r\n\t]+>/,
      inside: {
        punctuation: /^<|>$/
      }
    },
    operator: /::=|[|()[\]{}*+?]|\.{3}/
  }, t.languages.rbnf = t.languages.bnf;
}
g9.displayName = "bqn";
g9.aliases = [];
function g9(t) {
  t.languages.bqn = {
    shebang: {
      pattern: /^#![ \t]*\/.*/,
      alias: "important",
      greedy: !0
    },
    comment: {
      pattern: /#.*/,
      greedy: !0
    },
    "string-literal": {
      pattern: /"(?:[^"]|"")*"/,
      greedy: !0,
      alias: "string"
    },
    "character-literal": {
      pattern: /'(?:[\s\S]|[\uD800-\uDBFF][\uDC00-\uDFFF])'/,
      greedy: !0,
      alias: "char"
    },
    function: /•[\w¯.∞π]+[\w¯.∞π]*/,
    "dot-notation-on-brackets": {
      pattern: /\{(?=.*\}\.)|\}\./,
      alias: "namespace"
    },
    "special-name": {
      pattern: /(?:𝕨|𝕩|𝕗|𝕘|𝕤|𝕣|𝕎|𝕏|𝔽|𝔾|𝕊|_𝕣_|_𝕣)/,
      alias: "keyword"
    },
    "dot-notation-on-name": {
      pattern: /[A-Za-z_][\w¯∞π]*\./,
      alias: "namespace"
    },
    "word-number-scientific": {
      pattern: /\d+(?:\.\d+)?[eE]¯?\d+/,
      alias: "number"
    },
    "word-name": {
      pattern: /[A-Za-z_][\w¯∞π]*/,
      alias: "symbol"
    },
    "word-number": {
      pattern: /[¯∞π]?(?:\d*\.?\b\d+(?:e[+¯]?\d+|E[+¯]?\d+)?|¯|∞|π)(?:j¯?(?:(?:\d+(?:\.\d+)?|\.\d+)(?:e[+¯]?\d+|E[+¯]?\d+)?|¯|∞|π))?/,
      alias: "number"
    },
    "null-literal": {
      pattern: /@/,
      alias: "char"
    },
    "primitive-functions": {
      pattern: /[-+×÷⋆√⌊⌈|¬∧∨<>≠=≤≥≡≢⊣⊢⥊∾≍⋈↑↓↕«»⌽⍉/⍋⍒⊏⊑⊐⊒∊⍷⊔!]/,
      alias: "operator"
    },
    "primitive-1-operators": {
      pattern: /[`˜˘¨⁼⌜´˝˙]/,
      alias: "operator"
    },
    "primitive-2-operators": {
      pattern: /[∘⊸⟜○⌾⎉⚇⍟⊘◶⎊]/,
      alias: "operator"
    },
    punctuation: /[←⇐↩(){}⟨⟩[\]‿·⋄,.;:?]/
  };
}
b9.displayName = "brainfuck";
b9.aliases = [];
function b9(t) {
  t.languages.brainfuck = {
    pointer: {
      pattern: /<|>/,
      alias: "keyword"
    },
    increment: {
      pattern: /\+/,
      alias: "inserted"
    },
    decrement: {
      pattern: /-/,
      alias: "deleted"
    },
    branching: {
      pattern: /\[|\]/,
      alias: "important"
    },
    operator: /[.,]/,
    comment: /\S+/
  };
}
v9.displayName = "brightscript";
v9.aliases = [];
function v9(t) {
  t.languages.brightscript = {
    comment: /(?:\brem|').*/i,
    "directive-statement": {
      pattern: /(^[\t ]*)#(?:const|else(?:[\t ]+if)?|end[\t ]+if|error|if).*/im,
      lookbehind: !0,
      alias: "property",
      inside: {
        "error-message": {
          pattern: /(^#error).+/,
          lookbehind: !0
        },
        directive: {
          pattern: /^#(?:const|else(?:[\t ]+if)?|end[\t ]+if|error|if)/,
          alias: "keyword"
        },
        expression: {
          pattern: /[\s\S]+/,
          inside: null
          // see below
        }
      }
    },
    property: {
      pattern: /([\r\n{,][\t ]*)(?:(?!\d)\w+|"(?:[^"\r\n]|"")*"(?!"))(?=[ \t]*:)/,
      lookbehind: !0,
      greedy: !0
    },
    string: {
      pattern: /"(?:[^"\r\n]|"")*"(?!")/,
      greedy: !0
    },
    "class-name": {
      pattern: /(\bAs[\t ]+)\w+/i,
      lookbehind: !0
    },
    keyword: /\b(?:As|Dim|Each|Else|Elseif|End|Exit|For|Function|Goto|If|In|Print|Return|Step|Stop|Sub|Then|To|While)\b/i,
    boolean: /\b(?:false|true)\b/i,
    function: /\b(?!\d)\w+(?=[\t ]*\()/,
    number: /(?:\b\d+(?:\.\d+)?(?:[ed][+-]\d+)?|&h[a-f\d]+)\b[%&!#]?/i,
    operator: /--|\+\+|>>=?|<<=?|<>|[-+*/\\<>]=?|[:^=?]|\b(?:and|mod|not|or)\b/i,
    punctuation: /[.,;()[\]{}]/,
    constant: /\b(?:LINE_NUM)\b/i
  }, t.languages.brightscript["directive-statement"].inside.expression.inside = t.languages.brightscript;
}
y9.displayName = "bro";
y9.aliases = [];
function y9(t) {
  t.languages.bro = {
    comment: {
      pattern: /(^|[^\\$])#.*/,
      lookbehind: !0,
      inside: {
        italic: /\b(?:FIXME|TODO|XXX)\b/
      }
    },
    string: {
      pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
      greedy: !0
    },
    boolean: /\b[TF]\b/,
    function: {
      pattern: /(\b(?:event|function|hook)[ \t]+)\w+(?:::\w+)?/,
      lookbehind: !0
    },
    builtin: /(?:@(?:load(?:-(?:plugin|sigs))?|unload|prefixes|ifn?def|else|(?:end)?if|DIR|FILENAME))|(?:&?(?:add_func|create_expire|default|delete_func|encrypt|error_handler|expire_func|group|log|mergeable|optional|persistent|priority|raw_output|read_expire|redef|rotate_interval|rotate_size|synchronized|type_column|write_expire))/,
    constant: {
      pattern: /(\bconst[ \t]+)\w+/i,
      lookbehind: !0
    },
    keyword: /\b(?:add|addr|alarm|any|bool|break|const|continue|count|delete|double|else|enum|event|export|file|for|function|global|hook|if|in|int|interval|local|module|next|of|opaque|pattern|port|print|record|return|schedule|set|string|subnet|table|time|timeout|using|vector|when)\b/,
    operator: /--?|\+\+?|!=?=?|<=?|>=?|==?=?|&&|\|\|?|\?|\*|\/|~|\^|%/,
    number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    punctuation: /[{}[\];(),.:]/
  };
}
O9.displayName = "bsl";
O9.aliases = ["oscript"];
function O9(t) {
  t.languages.bsl = {
    comment: /\/\/.*/,
    string: [
      // Строки
      // Strings
      {
        pattern: /"(?:[^"]|"")*"(?!")/,
        greedy: !0
      },
      // Дата и время
      // Date & time
      {
        pattern: /'(?:[^'\r\n\\]|\\.)*'/
      }
    ],
    keyword: [
      {
        // RU
        pattern: /(^|[^\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])(?:пока|для|новый|прервать|попытка|исключение|вызватьисключение|иначе|конецпопытки|неопределено|функция|перем|возврат|конецфункции|если|иначеесли|процедура|конецпроцедуры|тогда|знач|экспорт|конецесли|из|каждого|истина|ложь|по|цикл|конеццикла|выполнить)(?![\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])/i,
        lookbehind: !0
      },
      {
        // EN
        pattern: /\b(?:break|do|each|else|elseif|enddo|endfunction|endif|endprocedure|endtry|except|execute|export|false|for|function|if|in|new|null|procedure|raise|return|then|to|true|try|undefined|val|var|while)\b/i
      }
    ],
    number: {
      pattern: /(^(?=\d)|[^\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])(?:\d+(?:\.\d*)?|\.\d+)(?:E[+-]?\d+)?/i,
      lookbehind: !0
    },
    operator: [
      /[<>+\-*/]=?|[%=]/,
      // RU
      {
        pattern: /(^|[^\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])(?:и|или|не)(?![\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])/i,
        lookbehind: !0
      },
      // EN
      {
        pattern: /\b(?:and|not|or)\b/i
      }
    ],
    punctuation: /\(\.|\.\)|[()\[\]:;,.]/,
    directive: [
      // Теги препроцессора вида &Клиент, &Сервер, ...
      // Preprocessor tags of the type &Client, &Server, ...
      {
        pattern: /^([ \t]*)&.*/m,
        lookbehind: !0,
        greedy: !0,
        alias: "important"
      },
      // Инструкции препроцессора вида:
      // #Если Сервер Тогда
      // ...
      // #КонецЕсли
      // Preprocessor instructions of the form:
      // #If Server Then
      // ...
      // #EndIf
      {
        pattern: /^([ \t]*)#.*/gm,
        lookbehind: !0,
        greedy: !0,
        alias: "important"
      }
    ]
  }, t.languages.oscript = t.languages.bsl;
}
E9.displayName = "cfscript";
E9.aliases = ["cfc"];
function E9(t) {
  t.register(Lr), t.languages.cfscript = t.languages.extend("clike", {
    comment: [
      {
        pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
        lookbehind: !0,
        inside: {
          annotation: {
            pattern: /(?:^|[^.])@[\w\.]+/,
            alias: "punctuation"
          }
        }
      },
      {
        pattern: /(^|[^\\:])\/\/.*/,
        lookbehind: !0,
        greedy: !0
      }
    ],
    keyword: /\b(?:abstract|break|catch|component|continue|default|do|else|extends|final|finally|for|function|if|in|include|package|private|property|public|remote|required|rethrow|return|static|switch|throw|try|var|while|xml)\b(?!\s*=)/,
    operator: [
      /\+\+|--|&&|\|\||::|=>|[!=]==|[-+*/%&|^!=<>]=?|\?(?:\.|:)?|:/,
      /\b(?:and|contains|eq|equal|eqv|gt|gte|imp|is|lt|lte|mod|not|or|xor)\b/
    ],
    scope: {
      pattern: /\b(?:application|arguments|cgi|client|cookie|local|session|super|this|variables)\b/,
      alias: "global"
    },
    type: {
      pattern: /\b(?:any|array|binary|boolean|date|guid|numeric|query|string|struct|uuid|void|xml)\b/,
      alias: "builtin"
    }
  }), t.languages.insertBefore("cfscript", "keyword", {
    // This must be declared before keyword because we use "function" inside the lookahead
    "function-variable": {
      pattern: /[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
      alias: "function"
    }
  }), delete t.languages.cfscript["class-name"], t.languages.cfc = t.languages.cfscript;
}
S9.displayName = "chaiscript";
S9.aliases = [];
function S9(t) {
  t.register(Lr), t.register(x0), t.languages.chaiscript = t.languages.extend("clike", {
    string: {
      pattern: /(^|[^\\])'(?:[^'\\]|\\[\s\S])*'/,
      lookbehind: !0,
      greedy: !0
    },
    "class-name": [
      {
        // e.g. class Rectangle { ... }
        pattern: /(\bclass\s+)\w+/,
        lookbehind: !0
      },
      {
        // e.g. attr Rectangle::height, def Rectangle::area() { ... }
        pattern: /(\b(?:attr|def)\s+)\w+(?=\s*::)/,
        lookbehind: !0
      }
    ],
    keyword: /\b(?:attr|auto|break|case|catch|class|continue|def|default|else|finally|for|fun|global|if|return|switch|this|try|var|while)\b/,
    number: [t.languages.cpp.number, /\b(?:Infinity|NaN)\b/],
    operator: />>=?|<<=?|\|\||&&|:[:=]?|--|\+\+|[=!<>+\-*/%|&^]=?|[?~]|`[^`\r\n]{1,4}`/
  }), t.languages.insertBefore("chaiscript", "operator", {
    "parameter-type": {
      // e.g. def foo(int x, Vector y) {...}
      pattern: /([,(]\s*)\w+(?=\s+\w)/,
      lookbehind: !0,
      alias: "class-name"
    }
  }), t.languages.insertBefore("chaiscript", "string", {
    "string-interpolation": {
      pattern: /(^|[^\\])"(?:[^"$\\]|\\[\s\S]|\$(?!\{)|\$\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\})*"/,
      lookbehind: !0,
      greedy: !0,
      inside: {
        interpolation: {
          pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\}/,
          lookbehind: !0,
          inside: {
            "interpolation-expression": {
              pattern: /(^\$\{)[\s\S]+(?=\}$)/,
              lookbehind: !0,
              inside: t.languages.chaiscript
            },
            "interpolation-punctuation": {
              pattern: /^\$\{|\}$/,
              alias: "punctuation"
            }
          }
        },
        string: /[\s\S]+/
      }
    }
  });
}
w9.displayName = "cil";
w9.aliases = [];
function w9(t) {
  t.languages.cil = {
    comment: /\/\/.*/,
    string: {
      pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
      greedy: !0
    },
    directive: {
      pattern: /(^|\W)\.[a-z]+(?=\s)/,
      lookbehind: !0,
      alias: "class-name"
    },
    // Actually an assembly reference
    variable: /\[[\w\.]+\]/,
    keyword: /\b(?:abstract|ansi|assembly|auto|autochar|beforefieldinit|bool|bstr|byvalstr|catch|char|cil|class|currency|date|decimal|default|enum|error|explicit|extends|extern|famandassem|family|famorassem|final(?:ly)?|float32|float64|hidebysig|u?int(?:8|16|32|64)?|iant|idispatch|implements|import|initonly|instance|interface|iunknown|literal|lpstr|lpstruct|lptstr|lpwstr|managed|method|native(?:Type)?|nested|newslot|object(?:ref)?|pinvokeimpl|private|privatescope|public|reqsecobj|rtspecialname|runtime|sealed|sequential|serializable|specialname|static|string|struct|syschar|tbstr|unicode|unmanagedexp|unsigned|value(?:type)?|variant|virtual|void)\b/,
    function: /\b(?:(?:constrained|no|readonly|tail|unaligned|volatile)\.)?(?:conv\.(?:[iu][1248]?|ovf\.[iu][1248]?(?:\.un)?|r\.un|r4|r8)|ldc\.(?:i4(?:\.\d+|\.[mM]1|\.s)?|i8|r4|r8)|ldelem(?:\.[iu][1248]?|\.r[48]|\.ref|a)?|ldind\.(?:[iu][1248]?|r[48]|ref)|stelem\.?(?:i[1248]?|r[48]|ref)?|stind\.(?:i[1248]?|r[48]|ref)?|end(?:fault|filter|finally)|ldarg(?:\.[0-3s]|a(?:\.s)?)?|ldloc(?:\.\d+|\.s)?|sub(?:\.ovf(?:\.un)?)?|mul(?:\.ovf(?:\.un)?)?|add(?:\.ovf(?:\.un)?)?|stloc(?:\.[0-3s])?|refany(?:type|val)|blt(?:\.un)?(?:\.s)?|ble(?:\.un)?(?:\.s)?|bgt(?:\.un)?(?:\.s)?|bge(?:\.un)?(?:\.s)?|unbox(?:\.any)?|init(?:blk|obj)|call(?:i|virt)?|brfalse(?:\.s)?|bne\.un(?:\.s)?|ldloca(?:\.s)?|brzero(?:\.s)?|brtrue(?:\.s)?|brnull(?:\.s)?|brinst(?:\.s)?|starg(?:\.s)?|leave(?:\.s)?|shr(?:\.un)?|rem(?:\.un)?|div(?:\.un)?|clt(?:\.un)?|alignment|castclass|ldvirtftn|beq(?:\.s)?|ckfinite|ldsflda|ldtoken|localloc|mkrefany|rethrow|cgt\.un|arglist|switch|stsfld|sizeof|newobj|newarr|ldsfld|ldnull|ldflda|isinst|throw|stobj|stfld|ldstr|ldobj|ldlen|ldftn|ldfld|cpobj|cpblk|break|br\.s|xor|shl|ret|pop|not|nop|neg|jmp|dup|cgt|ceq|box|and|or|br)\b/,
    boolean: /\b(?:false|true)\b/,
    number: /\b-?(?:0x[0-9a-f]+|\d+)(?:\.[0-9a-f]+)?\b/i,
    punctuation: /[{}[\];(),:=]|IL_[0-9A-Za-z]+/
  };
}
T9.displayName = "cilkc";
T9.aliases = ["cilk-c"];
function T9(t) {
  t.register(tp), t.languages.cilkc = t.languages.insertBefore("c", "function", {
    "parallel-keyword": {
      pattern: /\bcilk_(?:for|reducer|s(?:cope|pawn|ync))\b/,
      alias: "keyword"
    }
  }), t.languages["cilk-c"] = t.languages.cilkc;
}
_9.displayName = "cilkcpp";
_9.aliases = ["cilk", "cilk-cpp"];
function _9(t) {
  t.register(x0), t.languages.cilkcpp = t.languages.insertBefore("cpp", "function", {
    "parallel-keyword": {
      pattern: /\bcilk_(?:for|reducer|s(?:cope|pawn|ync))\b/,
      alias: "keyword"
    }
  }), t.languages["cilk-cpp"] = t.languages.cilkcpp, t.languages.cilk = t.languages.cilkcpp;
}
C9.displayName = "clojure";
C9.aliases = [];
function C9(t) {
  t.languages.clojure = {
    comment: {
      pattern: /;.*/,
      greedy: !0
    },
    string: {
      pattern: /"(?:[^"\\]|\\.)*"/,
      greedy: !0
    },
    char: /\\\w+/,
    symbol: {
      pattern: /(^|[\s()\[\]{},])::?[\w*+!?'<>=/.-]+/,
      lookbehind: !0
    },
    keyword: {
      pattern: /(\()(?:-|->|->>|\.|\.\.|\*|\/|\+|<|<=|=|==|>|>=|accessor|agent|agent-errors|aget|alength|all-ns|alter|and|append-child|apply|array-map|aset|aset-boolean|aset-byte|aset-char|aset-double|aset-float|aset-int|aset-long|aset-short|assert|assoc|await|await-for|bean|binding|bit-and|bit-not|bit-or|bit-shift-left|bit-shift-right|bit-xor|boolean|branch\?|butlast|byte|cast|char|children|class|clear-agent-errors|comment|commute|comp|comparator|complement|concat|cond|conj|cons|constantly|construct-proxy|contains\?|count|create-ns|create-struct|cycle|dec|declare|def|def-|definline|definterface|defmacro|defmethod|defmulti|defn|defn-|defonce|defproject|defprotocol|defrecord|defstruct|deftype|deref|difference|disj|dissoc|distinct|do|doall|doc|dorun|doseq|dosync|dotimes|doto|double|down|drop|drop-while|edit|end\?|ensure|eval|every\?|false\?|ffirst|file-seq|filter|find|find-doc|find-ns|find-var|first|float|flush|fn|fnseq|for|frest|gensym|get|get-proxy-class|hash-map|hash-set|identical\?|identity|if|if-let|if-not|import|in-ns|inc|index|insert-child|insert-left|insert-right|inspect-table|inspect-tree|instance\?|int|interleave|intersection|into|into-array|iterate|join|key|keys|keyword|keyword\?|last|lazy-cat|lazy-cons|left|lefts|let|line-seq|list|list\*|load|load-file|locking|long|loop|macroexpand|macroexpand-1|make-array|make-node|map|map-invert|map\?|mapcat|max|max-key|memfn|merge|merge-with|meta|min|min-key|monitor-enter|name|namespace|neg\?|new|newline|next|nil\?|node|not|not-any\?|not-every\?|not=|ns|ns-imports|ns-interns|ns-map|ns-name|ns-publics|ns-refers|ns-resolve|ns-unmap|nth|nthrest|or|parse|partial|path|peek|pop|pos\?|pr|pr-str|print|print-str|println|println-str|prn|prn-str|project|proxy|proxy-mappings|quot|quote|rand|rand-int|range|re-find|re-groups|re-matcher|re-matches|re-pattern|re-seq|read|read-line|recur|reduce|ref|ref-set|refer|rem|remove|remove-method|remove-ns|rename|rename-keys|repeat|replace|replicate|resolve|rest|resultset-seq|reverse|rfirst|right|rights|root|rrest|rseq|second|select|select-keys|send|send-off|seq|seq-zip|seq\?|set|set!|short|slurp|some|sort|sort-by|sorted-map|sorted-map-by|sorted-set|special-symbol\?|split-at|split-with|str|string\?|struct|struct-map|subs|subvec|symbol|symbol\?|sync|take|take-nth|take-while|test|throw|time|to-array|to-array-2d|tree-seq|true\?|try|union|up|update-proxy|val|vals|var|var-get|var-set|var\?|vector|vector-zip|vector\?|when|when-first|when-let|when-not|with-local-vars|with-meta|with-open|with-out-str|xml-seq|xml-zip|zero\?|zipmap|zipper)(?=[\s)]|$)/,
      lookbehind: !0
    },
    boolean: /\b(?:false|nil|true)\b/,
    number: {
      pattern: /(^|[^\w$@])(?:\d+(?:[/.]\d+)?(?:e[+-]?\d+)?|0x[a-f0-9]+|[1-9]\d?r[a-z0-9]+)[lmn]?(?![\w$@])/i,
      lookbehind: !0
    },
    function: {
      pattern: /((?:^|[^'])\()[\w*+!?'<>=/.-]+(?=[\s)]|$)/,
      lookbehind: !0
    },
    operator: /[#@^`~]/,
    punctuation: /[{}\[\](),]/
  };
}
x9.displayName = "cmake";
x9.aliases = [];
function x9(t) {
  t.languages.cmake = {
    comment: /#.*/,
    string: {
      pattern: /"(?:[^\\"]|\\.)*"/,
      greedy: !0,
      inside: {
        interpolation: {
          pattern: /\$\{(?:[^{}$]|\$\{[^{}$]*\})*\}/,
          inside: {
            punctuation: /\$\{|\}/,
            variable: /\w+/
          }
        }
      }
    },
    variable: /\b(?:CMAKE_\w+|\w+_(?:(?:BINARY|SOURCE)_DIR|DESCRIPTION|HOMEPAGE_URL|ROOT|VERSION(?:_MAJOR|_MINOR|_PATCH|_TWEAK)?)|(?:ANDROID|APPLE|BORLAND|BUILD_SHARED_LIBS|CACHE|CPACK_(?:ABSOLUTE_DESTINATION_FILES|COMPONENT_INCLUDE_TOPLEVEL_DIRECTORY|ERROR_ON_ABSOLUTE_INSTALL_DESTINATION|INCLUDE_TOPLEVEL_DIRECTORY|INSTALL_DEFAULT_DIRECTORY_PERMISSIONS|INSTALL_SCRIPT|PACKAGING_INSTALL_PREFIX|SET_DESTDIR|WARN_ON_ABSOLUTE_INSTALL_DESTINATION)|CTEST_(?:BINARY_DIRECTORY|BUILD_COMMAND|BUILD_NAME|BZR_COMMAND|BZR_UPDATE_OPTIONS|CHANGE_ID|CHECKOUT_COMMAND|CONFIGURATION_TYPE|CONFIGURE_COMMAND|COVERAGE_COMMAND|COVERAGE_EXTRA_FLAGS|CURL_OPTIONS|CUSTOM_(?:COVERAGE_EXCLUDE|ERROR_EXCEPTION|ERROR_MATCH|ERROR_POST_CONTEXT|ERROR_PRE_CONTEXT|MAXIMUM_FAILED_TEST_OUTPUT_SIZE|MAXIMUM_NUMBER_OF_(?:ERRORS|WARNINGS)|MAXIMUM_PASSED_TEST_OUTPUT_SIZE|MEMCHECK_IGNORE|POST_MEMCHECK|POST_TEST|PRE_MEMCHECK|PRE_TEST|TESTS_IGNORE|WARNING_EXCEPTION|WARNING_MATCH)|CVS_CHECKOUT|CVS_COMMAND|CVS_UPDATE_OPTIONS|DROP_LOCATION|DROP_METHOD|DROP_SITE|DROP_SITE_CDASH|DROP_SITE_PASSWORD|DROP_SITE_USER|EXTRA_COVERAGE_GLOB|GIT_COMMAND|GIT_INIT_SUBMODULES|GIT_UPDATE_CUSTOM|GIT_UPDATE_OPTIONS|HG_COMMAND|HG_UPDATE_OPTIONS|LABELS_FOR_SUBPROJECTS|MEMORYCHECK_(?:COMMAND|COMMAND_OPTIONS|SANITIZER_OPTIONS|SUPPRESSIONS_FILE|TYPE)|NIGHTLY_START_TIME|P4_CLIENT|P4_COMMAND|P4_OPTIONS|P4_UPDATE_OPTIONS|RUN_CURRENT_SCRIPT|SCP_COMMAND|SITE|SOURCE_DIRECTORY|SUBMIT_URL|SVN_COMMAND|SVN_OPTIONS|SVN_UPDATE_OPTIONS|TEST_LOAD|TEST_TIMEOUT|TRIGGER_SITE|UPDATE_COMMAND|UPDATE_OPTIONS|UPDATE_VERSION_ONLY|USE_LAUNCHERS)|CYGWIN|ENV|EXECUTABLE_OUTPUT_PATH|GHS-MULTI|IOS|LIBRARY_OUTPUT_PATH|MINGW|MSVC(?:10|11|12|14|60|70|71|80|90|_IDE|_TOOLSET_VERSION|_VERSION)?|MSYS|PROJECT_NAME|UNIX|WIN32|WINCE|WINDOWS_PHONE|WINDOWS_STORE|XCODE))\b/,
    property: /\b(?:cxx_\w+|(?:ARCHIVE_OUTPUT_(?:DIRECTORY|NAME)|COMPILE_DEFINITIONS|COMPILE_PDB_NAME|COMPILE_PDB_OUTPUT_DIRECTORY|EXCLUDE_FROM_DEFAULT_BUILD|IMPORTED_(?:IMPLIB|LIBNAME|LINK_DEPENDENT_LIBRARIES|LINK_INTERFACE_LANGUAGES|LINK_INTERFACE_LIBRARIES|LINK_INTERFACE_MULTIPLICITY|LOCATION|NO_SONAME|OBJECTS|SONAME)|INTERPROCEDURAL_OPTIMIZATION|LIBRARY_OUTPUT_DIRECTORY|LIBRARY_OUTPUT_NAME|LINK_FLAGS|LINK_INTERFACE_LIBRARIES|LINK_INTERFACE_MULTIPLICITY|LOCATION|MAP_IMPORTED_CONFIG|OSX_ARCHITECTURES|OUTPUT_NAME|PDB_NAME|PDB_OUTPUT_DIRECTORY|RUNTIME_OUTPUT_DIRECTORY|RUNTIME_OUTPUT_NAME|STATIC_LIBRARY_FLAGS|VS_CSHARP|VS_DOTNET_REFERENCEPROP|VS_DOTNET_REFERENCE|VS_GLOBAL_SECTION_POST|VS_GLOBAL_SECTION_PRE|VS_GLOBAL|XCODE_ATTRIBUTE)_\w+|\w+_(?:CLANG_TIDY|COMPILER_LAUNCHER|CPPCHECK|CPPLINT|INCLUDE_WHAT_YOU_USE|OUTPUT_NAME|POSTFIX|VISIBILITY_PRESET)|ABSTRACT|ADDITIONAL_MAKE_CLEAN_FILES|ADVANCED|ALIASED_TARGET|ALLOW_DUPLICATE_CUSTOM_TARGETS|ANDROID_(?:ANT_ADDITIONAL_OPTIONS|API|API_MIN|ARCH|ASSETS_DIRECTORIES|GUI|JAR_DEPENDENCIES|NATIVE_LIB_DEPENDENCIES|NATIVE_LIB_DIRECTORIES|PROCESS_MAX|PROGUARD|PROGUARD_CONFIG_PATH|SECURE_PROPS_PATH|SKIP_ANT_STEP|STL_TYPE)|ARCHIVE_OUTPUT_DIRECTORY|ATTACHED_FILES|ATTACHED_FILES_ON_FAIL|AUTOGEN_(?:BUILD_DIR|ORIGIN_DEPENDS|PARALLEL|SOURCE_GROUP|TARGETS_FOLDER|TARGET_DEPENDS)|AUTOMOC|AUTOMOC_(?:COMPILER_PREDEFINES|DEPEND_FILTERS|EXECUTABLE|MACRO_NAMES|MOC_OPTIONS|SOURCE_GROUP|TARGETS_FOLDER)|AUTORCC|AUTORCC_EXECUTABLE|AUTORCC_OPTIONS|AUTORCC_SOURCE_GROUP|AUTOUIC|AUTOUIC_EXECUTABLE|AUTOUIC_OPTIONS|AUTOUIC_SEARCH_PATHS|BINARY_DIR|BUILDSYSTEM_TARGETS|BUILD_RPATH|BUILD_RPATH_USE_ORIGIN|BUILD_WITH_INSTALL_NAME_DIR|BUILD_WITH_INSTALL_RPATH|BUNDLE|BUNDLE_EXTENSION|CACHE_VARIABLES|CLEAN_NO_CUSTOM|COMMON_LANGUAGE_RUNTIME|COMPATIBLE_INTERFACE_(?:BOOL|NUMBER_MAX|NUMBER_MIN|STRING)|COMPILE_(?:DEFINITIONS|FEATURES|FLAGS|OPTIONS|PDB_NAME|PDB_OUTPUT_DIRECTORY)|COST|CPACK_DESKTOP_SHORTCUTS|CPACK_NEVER_OVERWRITE|CPACK_PERMANENT|CPACK_STARTUP_SHORTCUTS|CPACK_START_MENU_SHORTCUTS|CPACK_WIX_ACL|CROSSCOMPILING_EMULATOR|CUDA_EXTENSIONS|CUDA_PTX_COMPILATION|CUDA_RESOLVE_DEVICE_SYMBOLS|CUDA_SEPARABLE_COMPILATION|CUDA_STANDARD|CUDA_STANDARD_REQUIRED|CXX_EXTENSIONS|CXX_STANDARD|CXX_STANDARD_REQUIRED|C_EXTENSIONS|C_STANDARD|C_STANDARD_REQUIRED|DEBUG_CONFIGURATIONS|DEFINE_SYMBOL|DEFINITIONS|DEPENDS|DEPLOYMENT_ADDITIONAL_FILES|DEPLOYMENT_REMOTE_DIRECTORY|DISABLED|DISABLED_FEATURES|ECLIPSE_EXTRA_CPROJECT_CONTENTS|ECLIPSE_EXTRA_NATURES|ENABLED_FEATURES|ENABLED_LANGUAGES|ENABLE_EXPORTS|ENVIRONMENT|EXCLUDE_FROM_ALL|EXCLUDE_FROM_DEFAULT_BUILD|EXPORT_NAME|EXPORT_PROPERTIES|EXTERNAL_OBJECT|EchoString|FAIL_REGULAR_EXPRESSION|FIND_LIBRARY_USE_LIB32_PATHS|FIND_LIBRARY_USE_LIB64_PATHS|FIND_LIBRARY_USE_LIBX32_PATHS|FIND_LIBRARY_USE_OPENBSD_VERSIONING|FIXTURES_CLEANUP|FIXTURES_REQUIRED|FIXTURES_SETUP|FOLDER|FRAMEWORK|Fortran_FORMAT|Fortran_MODULE_DIRECTORY|GENERATED|GENERATOR_FILE_NAME|GENERATOR_IS_MULTI_CONFIG|GHS_INTEGRITY_APP|GHS_NO_SOURCE_GROUP_FILE|GLOBAL_DEPENDS_DEBUG_MODE|GLOBAL_DEPENDS_NO_CYCLES|GNUtoMS|HAS_CXX|HEADER_FILE_ONLY|HELPSTRING|IMPLICIT_DEPENDS_INCLUDE_TRANSFORM|IMPORTED|IMPORTED_(?:COMMON_LANGUAGE_RUNTIME|CONFIGURATIONS|GLOBAL|IMPLIB|LIBNAME|LINK_DEPENDENT_LIBRARIES|LINK_INTERFACE_(?:LANGUAGES|LIBRARIES|MULTIPLICITY)|LOCATION|NO_SONAME|OBJECTS|SONAME)|IMPORT_PREFIX|IMPORT_SUFFIX|INCLUDE_DIRECTORIES|INCLUDE_REGULAR_EXPRESSION|INSTALL_NAME_DIR|INSTALL_RPATH|INSTALL_RPATH_USE_LINK_PATH|INTERFACE_(?:AUTOUIC_OPTIONS|COMPILE_DEFINITIONS|COMPILE_FEATURES|COMPILE_OPTIONS|INCLUDE_DIRECTORIES|LINK_DEPENDS|LINK_DIRECTORIES|LINK_LIBRARIES|LINK_OPTIONS|POSITION_INDEPENDENT_CODE|SOURCES|SYSTEM_INCLUDE_DIRECTORIES)|INTERPROCEDURAL_OPTIMIZATION|IN_TRY_COMPILE|IOS_INSTALL_COMBINED|JOB_POOLS|JOB_POOL_COMPILE|JOB_POOL_LINK|KEEP_EXTENSION|LABELS|LANGUAGE|LIBRARY_OUTPUT_DIRECTORY|LINKER_LANGUAGE|LINK_(?:DEPENDS|DEPENDS_NO_SHARED|DIRECTORIES|FLAGS|INTERFACE_LIBRARIES|INTERFACE_MULTIPLICITY|LIBRARIES|OPTIONS|SEARCH_END_STATIC|SEARCH_START_STATIC|WHAT_YOU_USE)|LISTFILE_STACK|LOCATION|MACOSX_BUNDLE|MACOSX_BUNDLE_INFO_PLIST|MACOSX_FRAMEWORK_INFO_PLIST|MACOSX_PACKAGE_LOCATION|MACOSX_RPATH|MACROS|MANUALLY_ADDED_DEPENDENCIES|MEASUREMENT|MODIFIED|NAME|NO_SONAME|NO_SYSTEM_FROM_IMPORTED|OBJECT_DEPENDS|OBJECT_OUTPUTS|OSX_ARCHITECTURES|OUTPUT_NAME|PACKAGES_FOUND|PACKAGES_NOT_FOUND|PARENT_DIRECTORY|PASS_REGULAR_EXPRESSION|PDB_NAME|PDB_OUTPUT_DIRECTORY|POSITION_INDEPENDENT_CODE|POST_INSTALL_SCRIPT|PREDEFINED_TARGETS_FOLDER|PREFIX|PRE_INSTALL_SCRIPT|PRIVATE_HEADER|PROCESSORS|PROCESSOR_AFFINITY|PROJECT_LABEL|PUBLIC_HEADER|REPORT_UNDEFINED_PROPERTIES|REQUIRED_FILES|RESOURCE|RESOURCE_LOCK|RULE_LAUNCH_COMPILE|RULE_LAUNCH_CUSTOM|RULE_LAUNCH_LINK|RULE_MESSAGES|RUNTIME_OUTPUT_DIRECTORY|RUN_SERIAL|SKIP_AUTOGEN|SKIP_AUTOMOC|SKIP_AUTORCC|SKIP_AUTOUIC|SKIP_BUILD_RPATH|SKIP_RETURN_CODE|SOURCES|SOURCE_DIR|SOVERSION|STATIC_LIBRARY_FLAGS|STATIC_LIBRARY_OPTIONS|STRINGS|SUBDIRECTORIES|SUFFIX|SYMBOLIC|TARGET_ARCHIVES_MAY_BE_SHARED_LIBS|TARGET_MESSAGES|TARGET_SUPPORTS_SHARED_LIBS|TESTS|TEST_INCLUDE_FILE|TEST_INCLUDE_FILES|TIMEOUT|TIMEOUT_AFTER_MATCH|TYPE|USE_FOLDERS|VALUE|VARIABLES|VERSION|VISIBILITY_INLINES_HIDDEN|VS_(?:CONFIGURATION_TYPE|COPY_TO_OUT_DIR|DEBUGGER_(?:COMMAND|COMMAND_ARGUMENTS|ENVIRONMENT|WORKING_DIRECTORY)|DEPLOYMENT_CONTENT|DEPLOYMENT_LOCATION|DOTNET_REFERENCES|DOTNET_REFERENCES_COPY_LOCAL|INCLUDE_IN_VSIX|IOT_STARTUP_TASK|KEYWORD|RESOURCE_GENERATOR|SCC_AUXPATH|SCC_LOCALPATH|SCC_PROJECTNAME|SCC_PROVIDER|SDK_REFERENCES|SHADER_(?:DISABLE_OPTIMIZATIONS|ENABLE_DEBUG|ENTRYPOINT|FLAGS|MODEL|OBJECT_FILE_NAME|OUTPUT_HEADER_FILE|TYPE|VARIABLE_NAME)|STARTUP_PROJECT|TOOL_OVERRIDE|USER_PROPS|WINRT_COMPONENT|WINRT_EXTENSIONS|WINRT_REFERENCES|XAML_TYPE)|WILL_FAIL|WIN32_EXECUTABLE|WINDOWS_EXPORT_ALL_SYMBOLS|WORKING_DIRECTORY|WRAP_EXCLUDE|XCODE_(?:EMIT_EFFECTIVE_PLATFORM_NAME|EXPLICIT_FILE_TYPE|FILE_ATTRIBUTES|LAST_KNOWN_FILE_TYPE|PRODUCT_TYPE|SCHEME_(?:ADDRESS_SANITIZER|ADDRESS_SANITIZER_USE_AFTER_RETURN|ARGUMENTS|DISABLE_MAIN_THREAD_CHECKER|DYNAMIC_LIBRARY_LOADS|DYNAMIC_LINKER_API_USAGE|ENVIRONMENT|EXECUTABLE|GUARD_MALLOC|MAIN_THREAD_CHECKER_STOP|MALLOC_GUARD_EDGES|MALLOC_SCRIBBLE|MALLOC_STACK|THREAD_SANITIZER(?:_STOP)?|UNDEFINED_BEHAVIOUR_SANITIZER(?:_STOP)?|ZOMBIE_OBJECTS))|XCTEST)\b/,
    keyword: /\b(?:add_compile_definitions|add_compile_options|add_custom_command|add_custom_target|add_definitions|add_dependencies|add_executable|add_library|add_link_options|add_subdirectory|add_test|aux_source_directory|break|build_command|build_name|cmake_host_system_information|cmake_minimum_required|cmake_parse_arguments|cmake_policy|configure_file|continue|create_test_sourcelist|ctest_build|ctest_configure|ctest_coverage|ctest_empty_binary_directory|ctest_memcheck|ctest_read_custom_files|ctest_run_script|ctest_sleep|ctest_start|ctest_submit|ctest_test|ctest_update|ctest_upload|define_property|else|elseif|enable_language|enable_testing|endforeach|endfunction|endif|endmacro|endwhile|exec_program|execute_process|export|export_library_dependencies|file|find_file|find_library|find_package|find_path|find_program|fltk_wrap_ui|foreach|function|get_cmake_property|get_directory_property|get_filename_component|get_property|get_source_file_property|get_target_property|get_test_property|if|include|include_directories|include_external_msproject|include_guard|include_regular_expression|install|install_files|install_programs|install_targets|link_directories|link_libraries|list|load_cache|load_command|macro|make_directory|mark_as_advanced|math|message|option|output_required_files|project|qt_wrap_cpp|qt_wrap_ui|remove|remove_definitions|return|separate_arguments|set|set_directory_properties|set_property|set_source_files_properties|set_target_properties|set_tests_properties|site_name|source_group|string|subdir_depends|subdirs|target_compile_definitions|target_compile_features|target_compile_options|target_include_directories|target_link_directories|target_link_libraries|target_link_options|target_sources|try_compile|try_run|unset|use_mangled_mesa|utility_source|variable_requires|variable_watch|while|write_file)(?=\s*\()\b/,
    boolean: /\b(?:FALSE|OFF|ON|TRUE)\b/,
    namespace: /\b(?:INTERFACE|PRIVATE|PROPERTIES|PUBLIC|SHARED|STATIC|TARGET_OBJECTS)\b/,
    operator: /\b(?:AND|DEFINED|EQUAL|GREATER|LESS|MATCHES|NOT|OR|STREQUAL|STRGREATER|STRLESS|VERSION_EQUAL|VERSION_GREATER|VERSION_LESS)\b/,
    inserted: {
      pattern: /\b\w+::\w+\b/,
      alias: "class-name"
    },
    number: /\b\d+(?:\.\d+)*\b/,
    function: /\b[a-z_]\w*(?=\s*\()\b/i,
    punctuation: /[()>}]|\$[<{]/
  };
}
A9.displayName = "cobol";
A9.aliases = [];
function A9(t) {
  t.languages.cobol = {
    comment: {
      pattern: /\*>.*|(^[ \t]*)\*.*/m,
      lookbehind: !0,
      greedy: !0
    },
    string: {
      pattern: /[xzgn]?(?:"(?:[^\r\n"]|"")*"(?!")|'(?:[^\r\n']|'')*'(?!'))/i,
      greedy: !0
    },
    level: {
      pattern: /(^[ \t]*)\d+\b/m,
      lookbehind: !0,
      greedy: !0,
      alias: "number"
    },
    "class-name": {
      // https://github.com/antlr/grammars-v4/blob/42edd5b687d183b5fa679e858a82297bd27141e7/cobol85/Cobol85.g4#L1015
      pattern: /(\bpic(?:ture)?\s+)(?:(?:[-\w$/,:*+<>]|\.(?!\s|$))(?:\(\d+\))?)+/i,
      lookbehind: !0,
      inside: {
        number: {
          pattern: /(\()\d+/,
          lookbehind: !0
        },
        punctuation: /[()]/
      }
    },
    keyword: {
      pattern: /(^|[^\w-])(?:ABORT|ACCEPT|ACCESS|ADD|ADDRESS|ADVANCING|AFTER|ALIGNED|ALL|ALPHABET|ALPHABETIC|ALPHABETIC-LOWER|ALPHABETIC-UPPER|ALPHANUMERIC|ALPHANUMERIC-EDITED|ALSO|ALTER|ALTERNATE|ANY|ARE|AREA|AREAS|AS|ASCENDING|ASCII|ASSIGN|ASSOCIATED-DATA|ASSOCIATED-DATA-LENGTH|AT|ATTRIBUTE|AUTHOR|AUTO|AUTO-SKIP|BACKGROUND-COLOR|BACKGROUND-COLOUR|BASIS|BEEP|BEFORE|BEGINNING|BELL|BINARY|BIT|BLANK|BLINK|BLOCK|BOTTOM|BOUNDS|BY|BYFUNCTION|BYTITLE|CALL|CANCEL|CAPABLE|CCSVERSION|CD|CF|CH|CHAINING|CHANGED|CHANNEL|CHARACTER|CHARACTERS|CLASS|CLASS-ID|CLOCK-UNITS|CLOSE|CLOSE-DISPOSITION|COBOL|CODE|CODE-SET|COL|COLLATING|COLUMN|COM-REG|COMMA|COMMITMENT|COMMON|COMMUNICATION|COMP|COMP-1|COMP-2|COMP-3|COMP-4|COMP-5|COMPUTATIONAL|COMPUTATIONAL-1|COMPUTATIONAL-2|COMPUTATIONAL-3|COMPUTATIONAL-4|COMPUTATIONAL-5|COMPUTE|CONFIGURATION|CONTAINS|CONTENT|CONTINUE|CONTROL|CONTROL-POINT|CONTROLS|CONVENTION|CONVERTING|COPY|CORR|CORRESPONDING|COUNT|CRUNCH|CURRENCY|CURSOR|DATA|DATA-BASE|DATE|DATE-COMPILED|DATE-WRITTEN|DAY|DAY-OF-WEEK|DBCS|DE|DEBUG-CONTENTS|DEBUG-ITEM|DEBUG-LINE|DEBUG-NAME|DEBUG-SUB-1|DEBUG-SUB-2|DEBUG-SUB-3|DEBUGGING|DECIMAL-POINT|DECLARATIVES|DEFAULT|DEFAULT-DISPLAY|DEFINITION|DELETE|DELIMITED|DELIMITER|DEPENDING|DESCENDING|DESTINATION|DETAIL|DFHRESP|DFHVALUE|DISABLE|DISK|DISPLAY|DISPLAY-1|DIVIDE|DIVISION|DONTCARE|DOUBLE|DOWN|DUPLICATES|DYNAMIC|EBCDIC|EGCS|EGI|ELSE|EMI|EMPTY-CHECK|ENABLE|END|END-ACCEPT|END-ADD|END-CALL|END-COMPUTE|END-DELETE|END-DIVIDE|END-EVALUATE|END-IF|END-MULTIPLY|END-OF-PAGE|END-PERFORM|END-READ|END-RECEIVE|END-RETURN|END-REWRITE|END-SEARCH|END-START|END-STRING|END-SUBTRACT|END-UNSTRING|END-WRITE|ENDING|ENTER|ENTRY|ENTRY-PROCEDURE|ENVIRONMENT|EOL|EOP|EOS|ERASE|ERROR|ESCAPE|ESI|EVALUATE|EVENT|EVERY|EXCEPTION|EXCLUSIVE|EXHIBIT|EXIT|EXPORT|EXTEND|EXTENDED|EXTERNAL|FD|FILE|FILE-CONTROL|FILLER|FINAL|FIRST|FOOTING|FOR|FOREGROUND-COLOR|FOREGROUND-COLOUR|FROM|FULL|FUNCTION|FUNCTION-POINTER|FUNCTIONNAME|GENERATE|GIVING|GLOBAL|GO|GOBACK|GRID|GROUP|HEADING|HIGH-VALUE|HIGH-VALUES|HIGHLIGHT|I-O|I-O-CONTROL|ID|IDENTIFICATION|IF|IMPLICIT|IMPORT|IN|INDEX|INDEXED|INDICATE|INITIAL|INITIALIZE|INITIATE|INPUT|INPUT-OUTPUT|INSPECT|INSTALLATION|INTEGER|INTO|INVALID|INVOKE|IS|JUST|JUSTIFIED|KANJI|KEPT|KEY|KEYBOARD|LABEL|LANGUAGE|LAST|LB|LD|LEADING|LEFT|LEFTLINE|LENGTH|LENGTH-CHECK|LIBACCESS|LIBPARAMETER|LIBRARY|LIMIT|LIMITS|LINAGE|LINAGE-COUNTER|LINE|LINE-COUNTER|LINES|LINKAGE|LIST|LOCAL|LOCAL-STORAGE|LOCK|LONG-DATE|LONG-TIME|LOW-VALUE|LOW-VALUES|LOWER|LOWLIGHT|MEMORY|MERGE|MESSAGE|MMDDYYYY|MODE|MODULES|MORE-LABELS|MOVE|MULTIPLE|MULTIPLY|NAMED|NATIONAL|NATIONAL-EDITED|NATIVE|NEGATIVE|NETWORK|NEXT|NO|NO-ECHO|NULL|NULLS|NUMBER|NUMERIC|NUMERIC-DATE|NUMERIC-EDITED|NUMERIC-TIME|OBJECT-COMPUTER|OCCURS|ODT|OF|OFF|OMITTED|ON|OPEN|OPTIONAL|ORDER|ORDERLY|ORGANIZATION|OTHER|OUTPUT|OVERFLOW|OVERLINE|OWN|PACKED-DECIMAL|PADDING|PAGE|PAGE-COUNTER|PASSWORD|PERFORM|PF|PH|PIC|PICTURE|PLUS|POINTER|PORT|POSITION|POSITIVE|PRINTER|PRINTING|PRIVATE|PROCEDURE|PROCEDURE-POINTER|PROCEDURES|PROCEED|PROCESS|PROGRAM|PROGRAM-ID|PROGRAM-LIBRARY|PROMPT|PURGE|QUEUE|QUOTE|QUOTES|RANDOM|RD|READ|READER|REAL|RECEIVE|RECEIVED|RECORD|RECORDING|RECORDS|RECURSIVE|REDEFINES|REEL|REF|REFERENCE|REFERENCES|RELATIVE|RELEASE|REMAINDER|REMARKS|REMOTE|REMOVAL|REMOVE|RENAMES|REPLACE|REPLACING|REPORT|REPORTING|REPORTS|REQUIRED|RERUN|RESERVE|RESET|RETURN|RETURN-CODE|RETURNING|REVERSE-VIDEO|REVERSED|REWIND|REWRITE|RF|RH|RIGHT|ROUNDED|RUN|SAME|SAVE|SCREEN|SD|SEARCH|SECTION|SECURE|SECURITY|SEGMENT|SEGMENT-LIMIT|SELECT|SEND|SENTENCE|SEPARATE|SEQUENCE|SEQUENTIAL|SET|SHARED|SHAREDBYALL|SHAREDBYRUNUNIT|SHARING|SHIFT-IN|SHIFT-OUT|SHORT-DATE|SIGN|SIZE|SORT|SORT-CONTROL|SORT-CORE-SIZE|SORT-FILE-SIZE|SORT-MERGE|SORT-MESSAGE|SORT-MODE-SIZE|SORT-RETURN|SOURCE|SOURCE-COMPUTER|SPACE|SPACES|SPECIAL-NAMES|STANDARD|STANDARD-1|STANDARD-2|START|STATUS|STOP|STRING|SUB-QUEUE-1|SUB-QUEUE-2|SUB-QUEUE-3|SUBTRACT|SUM|SUPPRESS|SYMBOL|SYMBOLIC|SYNC|SYNCHRONIZED|TABLE|TALLY|TALLYING|TAPE|TASK|TERMINAL|TERMINATE|TEST|TEXT|THEN|THREAD|THREAD-LOCAL|THROUGH|THRU|TIME|TIMER|TIMES|TITLE|TO|TODAYS-DATE|TODAYS-NAME|TOP|TRAILING|TRUNCATED|TYPE|TYPEDEF|UNDERLINE|UNIT|UNSTRING|UNTIL|UP|UPON|USAGE|USE|USING|VALUE|VALUES|VARYING|VIRTUAL|WAIT|WHEN|WHEN-COMPILED|WITH|WORDS|WORKING-STORAGE|WRITE|YEAR|YYYYDDD|YYYYMMDD|ZERO-FILL|ZEROES|ZEROS)(?![\w-])/i,
      lookbehind: !0
    },
    boolean: {
      pattern: /(^|[^\w-])(?:false|true)(?![\w-])/i,
      lookbehind: !0
    },
    number: {
      pattern: /(^|[^\w-])(?:[+-]?(?:(?:\d+(?:[.,]\d+)?|[.,]\d+)(?:e[+-]?\d+)?|zero))(?![\w-])/i,
      lookbehind: !0
    },
    operator: [
      /<>|[<>]=?|[=+*/&]/,
      {
        pattern: /(^|[^\w-])(?:-|and|equal|greater|less|not|or|than)(?![\w-])/i,
        lookbehind: !0
      }
    ],
    punctuation: /[.:,()]/
  };
}
k9.displayName = "coffeescript";
k9.aliases = ["coffee"];
function k9(t) {
  t.register(rl), function(e) {
    var n = /#(?!\{).+/, r = {
      pattern: /#\{[^}]+\}/,
      alias: "variable"
    };
    e.languages.coffeescript = e.languages.extend("javascript", {
      comment: n,
      string: [
        // Strings are multiline
        {
          pattern: /'(?:\\[\s\S]|[^\\'])*'/,
          greedy: !0
        },
        {
          // Strings are multiline
          pattern: /"(?:\\[\s\S]|[^\\"])*"/,
          greedy: !0,
          inside: {
            interpolation: r
          }
        }
      ],
      keyword: /\b(?:and|break|by|catch|class|continue|debugger|delete|do|each|else|extend|extends|false|finally|for|if|in|instanceof|is|isnt|let|loop|namespace|new|no|not|null|of|off|on|or|own|return|super|switch|then|this|throw|true|try|typeof|undefined|unless|until|when|while|window|with|yes|yield)\b/,
      "class-member": {
        pattern: /@(?!\d)\w+/,
        alias: "variable"
      }
    }), e.languages.insertBefore("coffeescript", "comment", {
      "multiline-comment": {
        pattern: /###[\s\S]+?###/,
        alias: "comment"
      },
      // Block regexp can contain comments and interpolation
      "block-regex": {
        pattern: /\/{3}[\s\S]*?\/{3}/,
        alias: "regex",
        inside: {
          comment: n,
          interpolation: r
        }
      }
    }), e.languages.insertBefore("coffeescript", "string", {
      "inline-javascript": {
        pattern: /`(?:\\[\s\S]|[^\\`])*`/,
        inside: {
          delimiter: {
            pattern: /^`|`$/,
            alias: "punctuation"
          },
          script: {
            pattern: /[\s\S]+/,
            alias: "language-javascript",
            inside: e.languages.javascript
          }
        }
      },
      // Block strings
      "multiline-string": [
        {
          pattern: /'''[\s\S]*?'''/,
          greedy: !0,
          alias: "string"
        },
        {
          pattern: /"""[\s\S]*?"""/,
          greedy: !0,
          alias: "string",
          inside: {
            interpolation: r
          }
        }
      ]
    }), e.languages.insertBefore("coffeescript", "keyword", {
      // Object property
      property: /(?!\d)\w+(?=\s*:(?!:))/
    }), delete e.languages.coffeescript["template-string"], e.languages.coffee = e.languages.coffeescript;
  }(t);
}
R9.displayName = "concurnas";
R9.aliases = ["conc"];
function R9(t) {
  t.languages.concurnas = {
    comment: {
      pattern: /(^|[^\\])(?:\/\*[\s\S]*?(?:\*\/|$)|\/\/.*)/,
      lookbehind: !0,
      greedy: !0
    },
    langext: {
      pattern: /\b\w+\s*\|\|[\s\S]+?\|\|/,
      greedy: !0,
      inside: {
        "class-name": /^\w+/,
        string: {
          pattern: /(^\s*\|\|)[\s\S]+(?=\|\|$)/,
          lookbehind: !0
        },
        punctuation: /\|\|/
      }
    },
    function: {
      pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/,
      lookbehind: !0
    },
    keyword: /\b(?:abstract|actor|also|annotation|assert|async|await|bool|boolean|break|byte|case|catch|changed|char|class|closed|constant|continue|def|default|del|double|elif|else|enum|every|extends|false|finally|float|for|from|global|gpudef|gpukernel|if|import|in|init|inject|int|lambda|local|long|loop|match|new|nodefault|null|of|onchange|open|out|override|package|parfor|parforsync|post|pre|private|protected|provide|provider|public|return|shared|short|single|size_t|sizeof|super|sync|this|throw|trait|trans|transient|true|try|typedef|unchecked|using|val|var|void|while|with)\b/,
    boolean: /\b(?:false|true)\b/,
    number: /\b0b[01][01_]*L?\b|\b0x(?:[\da-f_]*\.)?[\da-f_p+-]+\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfls]?/i,
    punctuation: /[{}[\];(),.:]/,
    operator: /<==|>==|=>|->|<-|<>|&==|&<>|\?:?|\.\?|\+\+|--|[-+*/=<>]=?|[!^~]|\b(?:and|as|band|bor|bxor|comp|is|isnot|mod|or)\b=?/,
    annotation: {
      pattern: /@(?:\w+:)?(?:\w+|\[[^\]]+\])?/,
      alias: "builtin"
    }
  }, t.languages.insertBefore("concurnas", "langext", {
    "regex-literal": {
      pattern: /\br("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
      greedy: !0,
      inside: {
        interpolation: {
          pattern: /((?:^|[^\\])(?:\\{2})*)\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
          lookbehind: !0,
          inside: t.languages.concurnas
        },
        regex: /[\s\S]+/
      }
    },
    "string-literal": {
      pattern: /(?:\B|\bs)("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
      greedy: !0,
      inside: {
        interpolation: {
          pattern: /((?:^|[^\\])(?:\\{2})*)\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
          lookbehind: !0,
          inside: t.languages.concurnas
        },
        string: /[\s\S]+/
      }
    }
  }), t.languages.conc = t.languages.concurnas;
}
I9.displayName = "csp";
I9.aliases = [];
function I9(t) {
  (function(e) {
    function n(r) {
      return RegExp(
        /([ \t])/.source + "(?:" + r + ")" + /(?=[\s;]|$)/.source,
        "i"
      );
    }
    e.languages.csp = {
      directive: {
        pattern: /(^|[\s;])(?:base-uri|block-all-mixed-content|(?:child|connect|default|font|frame|img|manifest|media|object|prefetch|script|style|worker)-src|disown-opener|form-action|frame-(?:ancestors|options)|input-protection(?:-(?:clip|selectors))?|navigate-to|plugin-types|policy-uri|referrer|reflected-xss|report-(?:to|uri)|require-sri-for|sandbox|(?:script|style)-src-(?:attr|elem)|upgrade-insecure-requests)(?=[\s;]|$)/i,
        lookbehind: !0,
        alias: "property"
      },
      scheme: {
        pattern: n(/[a-z][a-z0-9.+-]*:/.source),
        lookbehind: !0
      },
      none: {
        pattern: n(/'none'/.source),
        lookbehind: !0,
        alias: "keyword"
      },
      nonce: {
        pattern: n(/'nonce-[-+/\w=]+'/.source),
        lookbehind: !0,
        alias: "number"
      },
      hash: {
        pattern: n(/'sha(?:256|384|512)-[-+/\w=]+'/.source),
        lookbehind: !0,
        alias: "number"
      },
      host: {
        pattern: n(
          /[a-z][a-z0-9.+-]*:\/\/[^\s;,']*/.source + "|" + /\*[^\s;,']*/.source + "|" + /[a-z0-9-]+(?:\.[a-z0-9-]+)+(?::[\d*]+)?(?:\/[^\s;,']*)?/.source
        ),
        lookbehind: !0,
        alias: "url",
        inside: {
          important: /\*/
        }
      },
      keyword: [
        {
          pattern: n(/'unsafe-[a-z-]+'/.source),
          lookbehind: !0,
          alias: "unsafe"
        },
        {
          pattern: n(/'[a-z-]+'/.source),
          lookbehind: !0,
          alias: "safe"
        }
      ],
      punctuation: /;/
    };
  })(t);
}
D9.displayName = "cooklang";
D9.aliases = [];
function D9(t) {
  (function(e) {
    var n = /(?:(?!\s)[\d$+<=a-zA-Z\x80-\uFFFF])+/.source, r = /[^{}@#]+/.source, a = /\{[^}#@]*\}/.source, i = r + a, o = /(?:h|hours|hrs|m|min|minutes)/.source, s = {
      pattern: /\{[^{}]*\}/,
      inside: {
        amount: {
          pattern: /([\{|])[^{}|*%]+/,
          lookbehind: !0,
          alias: "number"
        },
        unit: {
          pattern: /(%)[^}]+/,
          lookbehind: !0,
          alias: "symbol"
        },
        "servings-scaler": {
          pattern: /\*/,
          alias: "operator"
        },
        "servings-alternative-separator": {
          pattern: /\|/,
          alias: "operator"
        },
        "unit-separator": {
          pattern: /(?:%|(\*)%)/,
          lookbehind: !0,
          alias: "operator"
        },
        punctuation: /[{}]/
      }
    };
    e.languages.cooklang = {
      comment: {
        // [- comment -]
        // -- comment
        pattern: /\[-[\s\S]*?-\]|--.*/,
        greedy: !0
      },
      meta: {
        // >> key: value
        pattern: />>.*:.*/,
        inside: {
          property: {
            // key:
            pattern: /(>>\s*)[^\s:](?:[^:]*[^\s:])?/,
            lookbehind: !0
          }
        }
      },
      "cookware-group": {
        // #...{...}, #...
        pattern: new RegExp(
          "#(?:" + i + "|" + n + ")"
        ),
        inside: {
          cookware: {
            pattern: new RegExp("(^#)(?:" + r + ")"),
            lookbehind: !0,
            alias: "variable"
          },
          "cookware-keyword": {
            pattern: /^#/,
            alias: "keyword"
          },
          "quantity-group": {
            pattern: new RegExp(/\{[^{}@#]*\}/),
            inside: {
              quantity: {
                pattern: new RegExp(/(^\{)/.source + r),
                lookbehind: !0,
                alias: "number"
              },
              punctuation: /[{}]/
            }
          }
        }
      },
      "ingredient-group": {
        // @...{...}, @...
        pattern: new RegExp(
          "@(?:" + i + "|" + n + ")"
        ),
        inside: {
          ingredient: {
            pattern: new RegExp("(^@)(?:" + r + ")"),
            lookbehind: !0,
            alias: "variable"
          },
          "ingredient-keyword": {
            pattern: /^@/,
            alias: "keyword"
          },
          "amount-group": s
        }
      },
      "timer-group": {
        // ~timer{...}
        // eslint-disable-next-line regexp/sort-alternatives
        pattern: /~(?!\s)[^@#~{}]*\{[^{}]*\}/,
        inside: {
          timer: {
            pattern: /(^~)[^{]+/,
            lookbehind: !0,
            alias: "variable"
          },
          "duration-group": {
            // {...}
            pattern: /\{[^{}]*\}/,
            inside: {
              punctuation: /[{}]/,
              unit: {
                pattern: new RegExp(
                  /(%\s*)/.source + o + /\b/.source
                ),
                lookbehind: !0,
                alias: "symbol"
              },
              operator: /%/,
              duration: {
                pattern: /\d+/,
                alias: "number"
              }
            }
          },
          "timer-keyword": {
            pattern: /^~/,
            alias: "keyword"
          }
        }
      }
    };
  })(t);
}
N9.displayName = "coq";
N9.aliases = [];
function N9(t) {
  (function(e) {
    for (var n = /\(\*(?:[^(*]|\((?!\*)|\*(?!\))|<self>)*\*\)/.source, r = 0; r < 2; r++)
      n = n.replace(/<self>/g, function() {
        return n;
      });
    n = n.replace(/<self>/g, "[]"), e.languages.coq = {
      comment: RegExp(n),
      string: {
        pattern: /"(?:[^"]|"")*"(?!")/,
        greedy: !0
      },
      attribute: [
        {
          pattern: RegExp(
            /#\[(?:[^\[\]("]|"(?:[^"]|"")*"(?!")|\((?!\*)|<comment>)*\]/.source.replace(
              /<comment>/g,
              function() {
                return n;
              }
            )
          ),
          greedy: !0,
          alias: "attr-name",
          inside: {
            comment: RegExp(n),
            string: {
              pattern: /"(?:[^"]|"")*"(?!")/,
              greedy: !0
            },
            operator: /=/,
            punctuation: /^#\[|\]$|[,()]/
          }
        },
        {
          pattern: /\b(?:Cumulative|Global|Local|Monomorphic|NonCumulative|Polymorphic|Private|Program)\b/,
          alias: "attr-name"
        }
      ],
      keyword: /\b(?:Abort|About|Add|Admit|Admitted|All|Arguments|As|Assumptions|Axiom|Axioms|Back|BackTo|Backtrace|BinOp|BinOpSpec|BinRel|Bind|Blacklist|Canonical|Case|Cd|Check|Class|Classes|Close|CoFixpoint|CoInductive|Coercion|Coercions|Collection|Combined|Compute|Conjecture|Conjectures|Constant|Constants|Constraint|Constructors|Context|Corollary|Create|CstOp|Custom|Cut|Debug|Declare|Defined|Definition|Delimit|Dependencies|Dependent|Derive|Diffs|Drop|Elimination|End|Entry|Equality|Eval|Example|Existential|Existentials|Existing|Export|Extern|Extraction|Fact|Fail|Field|File|Firstorder|Fixpoint|Flags|Focus|From|Funclass|Function|Functional|GC|Generalizable|Goal|Grab|Grammar|Graph|Guarded|Haskell|Heap|Hide|Hint|HintDb|Hints|Hypotheses|Hypothesis|IF|Identity|Immediate|Implicit|Implicits|Import|Include|Induction|Inductive|Infix|Info|Initial|InjTyp|Inline|Inspect|Instance|Instances|Intro|Intros|Inversion|Inversion_clear|JSON|Language|Left|Lemma|Let|Lia|Libraries|Library|Load|LoadPath|Locate|Ltac|Ltac2|ML|Match|Method|Minimality|Module|Modules|Morphism|Next|NoInline|Notation|Number|OCaml|Obligation|Obligations|Opaque|Open|Optimize|Parameter|Parameters|Parametric|Path|Paths|Prenex|Preterm|Primitive|Print|Profile|Projections|Proof|Prop|PropBinOp|PropOp|PropUOp|Property|Proposition|Pwd|Qed|Quit|Rec|Record|Recursive|Redirect|Reduction|Register|Relation|Remark|Remove|Require|Reserved|Reset|Resolve|Restart|Rewrite|Right|Ring|Rings|SProp|Saturate|Save|Scheme|Scope|Scopes|Search|SearchHead|SearchPattern|SearchRewrite|Section|Separate|Set|Setoid|Show|Signatures|Solve|Solver|Sort|Sortclass|Sorted|Spec|Step|Strategies|Strategy|String|Structure|SubClass|Subgraph|SuchThat|Tactic|Term|TestCompile|Theorem|Time|Timeout|To|Transparent|Type|Typeclasses|Types|Typing|UnOp|UnOpSpec|Undelimit|Undo|Unfocus|Unfocused|Unfold|Universe|Universes|Unshelve|Variable|Variables|Variant|Verbose|View|Visibility|Zify|_|apply|as|at|by|cofix|else|end|exists|exists2|fix|for|forall|fun|if|in|let|match|measure|move|removed|return|struct|then|using|wf|where|with)\b/,
      number: /\b(?:0x[a-f0-9][a-f0-9_]*(?:\.[a-f0-9_]+)?(?:p[+-]?\d[\d_]*)?|\d[\d_]*(?:\.[\d_]+)?(?:e[+-]?\d[\d_]*)?)\b/i,
      punct: {
        pattern: /@\{|\{\||\[=|:>/,
        alias: "punctuation"
      },
      operator: /\/\\|\\\/|\.{2,3}|:{1,2}=|\*\*|[-=]>|<(?:->?|[+:=>]|<:)|>(?:=|->)|\|[-|]?|[-!%&*+/<=>?@^~']/,
      punctuation: /\.\(|`\(|@\{|`\{|\{\||\[=|:>|[:.,;(){}\[\]]/
    };
  })(t);
}
P9.displayName = "crystal";
P9.aliases = [];
function P9(t) {
  t.register(I0), function(e) {
    e.languages.crystal = e.languages.extend("ruby", {
      keyword: [
        /\b(?:__DIR__|__END_LINE__|__FILE__|__LINE__|abstract|alias|annotation|as|asm|begin|break|case|class|def|do|else|elsif|end|ensure|enum|extend|for|fun|if|ifdef|include|instance_sizeof|lib|macro|module|next|of|out|pointerof|private|protected|ptr|require|rescue|return|select|self|sizeof|struct|super|then|type|typeof|undef|uninitialized|union|unless|until|when|while|with|yield)\b/,
        {
          pattern: /(\.\s*)(?:is_a|responds_to)\?/,
          lookbehind: !0
        }
      ],
      number: /\b(?:0b[01_]*[01]|0o[0-7_]*[0-7]|0x[\da-fA-F_]*[\da-fA-F]|(?:\d(?:[\d_]*\d)?)(?:\.[\d_]*\d)?(?:[eE][+-]?[\d_]*\d)?)(?:_(?:[uif](?:8|16|32|64))?)?\b/,
      operator: [/->/, e.languages.ruby.operator],
      punctuation: /[(){}[\].,;\\]/
    }), e.languages.insertBefore("crystal", "string-literal", {
      attribute: {
        pattern: /@\[.*?\]/,
        inside: {
          delimiter: {
            pattern: /^@\[|\]$/,
            alias: "punctuation"
          },
          attribute: {
            pattern: /^(\s*)\w+/,
            lookbehind: !0,
            alias: "class-name"
          },
          args: {
            pattern: /\S(?:[\s\S]*\S)?/,
            inside: e.languages.crystal
          }
        }
      },
      expansion: {
        pattern: /\{(?:\{.*?\}|%.*?%)\}/,
        inside: {
          content: {
            pattern: /^(\{.)[\s\S]+(?=.\}$)/,
            lookbehind: !0,
            inside: e.languages.crystal
          },
          delimiter: {
            pattern: /^\{[\{%]|[\}%]\}$/,
            alias: "operator"
          }
        }
      },
      char: {
        pattern: /'(?:[^\\\r\n]{1,2}|\\(?:.|u(?:[A-Fa-f0-9]{1,4}|\{[A-Fa-f0-9]{1,6}\})))'/,
        greedy: !0
      }
    });
  }(t);
}
L9.displayName = "css-extras";
L9.aliases = [];
function L9(t) {
  t.register(pv), function(e) {
    var n = /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/, r;
    e.languages.css.selector = {
      pattern: e.languages.css.selector.pattern,
      lookbehind: !0,
      inside: r = {
        "pseudo-element": /:(?:after|before|first-letter|first-line|selection)|::[-\w]+/,
        "pseudo-class": /:[-\w]+/,
        class: /\.[-\w]+/,
        id: /#[-\w]+/,
        attribute: {
          pattern: RegExp(`\\[(?:[^[\\]"']|` + n.source + ")*\\]"),
          greedy: !0,
          inside: {
            punctuation: /^\[|\]$/,
            "case-sensitivity": {
              pattern: /(\s)[si]$/i,
              lookbehind: !0,
              alias: "keyword"
            },
            namespace: {
              pattern: /^(\s*)(?:(?!\s)[-*\w\xA0-\uFFFF])*\|(?!=)/,
              lookbehind: !0,
              inside: {
                punctuation: /\|$/
              }
            },
            "attr-name": {
              pattern: /^(\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+/,
              lookbehind: !0
            },
            "attr-value": [
              n,
              {
                pattern: /(=\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+(?=\s*$)/,
                lookbehind: !0
              }
            ],
            operator: /[|~*^$]?=/
          }
        },
        "n-th": [
          {
            pattern: /(\(\s*)[+-]?\d*[\dn](?:\s*[+-]\s*\d+)?(?=\s*\))/,
            lookbehind: !0,
            inside: {
              number: /[\dn]+/,
              operator: /[+-]/
            }
          },
          {
            pattern: /(\(\s*)(?:even|odd)(?=\s*\))/i,
            lookbehind: !0
          }
        ],
        combinator: />|\+|~|\|\|/,
        // the `tag` token has been existed and removed.
        // because we can't find a perfect tokenize to match it.
        // if you want to add it, please read https://github.com/PrismJS/prism/pull/2373 first.
        punctuation: /[(),]/
      }
    }, e.languages.css.atrule.inside["selector-function-argument"].inside = r, e.languages.insertBefore("css", "property", {
      variable: {
        pattern: /(^|[^-\w\xA0-\uFFFF])--(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*/i,
        lookbehind: !0
      }
    });
    var a = {
      pattern: /(\b\d+)(?:%|[a-z]+(?![\w-]))/,
      lookbehind: !0
    }, i = {
      pattern: /(^|[^\w.-])-?(?:\d+(?:\.\d+)?|\.\d+)/,
      lookbehind: !0
    };
    e.languages.insertBefore("css", "function", {
      operator: {
        pattern: /(\s)[+\-*\/](?=\s)/,
        lookbehind: !0
      },
      // CAREFUL!
      // Previewers and Inline color use hexcode and color.
      hexcode: {
        pattern: /\B#[\da-f]{3,8}\b/i,
        alias: "color"
      },
      color: [
        {
          pattern: /(^|[^\w-])(?:AliceBlue|AntiqueWhite|Aqua|Aquamarine|Azure|Beige|Bisque|Black|BlanchedAlmond|Blue|BlueViolet|Brown|BurlyWood|CadetBlue|Chartreuse|Chocolate|Coral|CornflowerBlue|Cornsilk|Crimson|Cyan|DarkBlue|DarkCyan|DarkGoldenRod|DarkGr[ae]y|DarkGreen|DarkKhaki|DarkMagenta|DarkOliveGreen|DarkOrange|DarkOrchid|DarkRed|DarkSalmon|DarkSeaGreen|DarkSlateBlue|DarkSlateGr[ae]y|DarkTurquoise|DarkViolet|DeepPink|DeepSkyBlue|DimGr[ae]y|DodgerBlue|FireBrick|FloralWhite|ForestGreen|Fuchsia|Gainsboro|GhostWhite|Gold|GoldenRod|Gr[ae]y|Green|GreenYellow|HoneyDew|HotPink|IndianRed|Indigo|Ivory|Khaki|Lavender|LavenderBlush|LawnGreen|LemonChiffon|LightBlue|LightCoral|LightCyan|LightGoldenRodYellow|LightGr[ae]y|LightGreen|LightPink|LightSalmon|LightSeaGreen|LightSkyBlue|LightSlateGr[ae]y|LightSteelBlue|LightYellow|Lime|LimeGreen|Linen|Magenta|Maroon|MediumAquaMarine|MediumBlue|MediumOrchid|MediumPurple|MediumSeaGreen|MediumSlateBlue|MediumSpringGreen|MediumTurquoise|MediumVioletRed|MidnightBlue|MintCream|MistyRose|Moccasin|NavajoWhite|Navy|OldLace|Olive|OliveDrab|Orange|OrangeRed|Orchid|PaleGoldenRod|PaleGreen|PaleTurquoise|PaleVioletRed|PapayaWhip|PeachPuff|Peru|Pink|Plum|PowderBlue|Purple|RebeccaPurple|Red|RosyBrown|RoyalBlue|SaddleBrown|Salmon|SandyBrown|SeaGreen|SeaShell|Sienna|Silver|SkyBlue|SlateBlue|SlateGr[ae]y|Snow|SpringGreen|SteelBlue|Tan|Teal|Thistle|Tomato|Transparent|Turquoise|Violet|Wheat|White|WhiteSmoke|Yellow|YellowGreen)(?![\w-])/i,
          lookbehind: !0
        },
        {
          pattern: /\b(?:hsl|rgb)\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*\)\B|\b(?:hsl|rgb)a\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*,\s*(?:0|0?\.\d+|1)\s*\)\B/i,
          inside: {
            unit: a,
            number: i,
            function: /[\w-]+(?=\()/,
            punctuation: /[(),]/
          }
        }
      ],
      // it's important that there is no boundary assertion after the hex digits
      entity: /\\[\da-f]{1,8}/i,
      unit: a,
      number: i
    });
  }(t);
}
M9.displayName = "csv";
M9.aliases = [];
function M9(t) {
  t.languages.csv = {
    value: /[^\r\n,"]+|"(?:[^"]|"")*"(?!")/,
    punctuation: /,/
  };
}
F9.displayName = "cue";
F9.aliases = [];
function F9(t) {
  (function(e) {
    var n = /\\(?:(?!\2)|\2(?:[^()\r\n]|\([^()]*\)))/.source, r = /"""(?:[^\\"]|"(?!""\2)|<esc>)*"""/.source + // eslint-disable-next-line regexp/strict
    "|" + /'''(?:[^\\']|'(?!''\2)|<esc>)*'''/.source + // eslint-disable-next-line regexp/strict
    "|" + /"(?:[^\\\r\n"]|"(?!\2)|<esc>)*"/.source + // eslint-disable-next-line regexp/strict
    "|" + /'(?:[^\\\r\n']|'(?!\2)|<esc>)*'/.source, a = "(?:" + r.replace(/<esc>/g, n) + ")";
    e.languages.cue = {
      comment: {
        pattern: /\/\/.*/,
        greedy: !0
      },
      "string-literal": {
        // eslint-disable-next-line regexp/strict
        pattern: RegExp(
          /(^|[^#"'\\])(#*)/.source + a + /(?!["'])\2/.source
        ),
        lookbehind: !0,
        greedy: !0,
        inside: {
          // I'm using dirty hack here. We have to know the number hashes at the start of the string somehow,
          // but we can't look back. So instead, we will use a lookahead, go to the end of the string, and
          // capture the hashes at the end of the string.
          escape: {
            pattern: /(?=[\s\S]*["'](#*)$)\\\1(?:U[a-fA-F0-9]{1,8}|u[a-fA-F0-9]{1,4}|x[a-fA-F0-9]{1,2}|\d{2,3}|[^(])/,
            greedy: !0,
            alias: "string"
          },
          interpolation: {
            pattern: /(?=[\s\S]*["'](#*)$)\\\1\([^()]*\)/,
            greedy: !0,
            inside: {
              punctuation: /^\\#*\(|\)$/,
              expression: {
                pattern: /[\s\S]+/,
                inside: null
              }
            }
          },
          string: /[\s\S]+/
        }
      },
      keyword: {
        pattern: /(^|[^\w$])(?:for|if|import|in|let|null|package)(?![\w$])/,
        lookbehind: !0
      },
      boolean: {
        pattern: /(^|[^\w$])(?:false|true)(?![\w$])/,
        lookbehind: !0
      },
      builtin: {
        pattern: /(^|[^\w$])(?:bool|bytes|float|float(?:32|64)|u?int(?:8|16|32|64|128)?|number|rune|string)(?![\w$])/,
        lookbehind: !0
      },
      attribute: {
        pattern: /@[\w$]+(?=\s*\()/,
        alias: "function"
      },
      function: {
        pattern: /(^|[^\w$])[a-z_$][\w$]*(?=\s*\()/i,
        lookbehind: !0
      },
      number: {
        pattern: /(^|[^\w$.])(?:0b[01]+(?:_[01]+)*|0o[0-7]+(?:_[0-7]+)*|0[xX][0-9A-Fa-f]+(?:_[0-9A-Fa-f]+)*|(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[eE][+-]?\d+(?:_\d+)*)?(?:[KMGTP]i?)?)(?![\w$])/,
        lookbehind: !0
      },
      operator: /\.{3}|_\|_|&&?|\|\|?|[=!]~|[<>=!]=?|[+\-*/?]/,
      punctuation: /[()[\]{},.:]/
    }, e.languages.cue["string-literal"].inside.interpolation.inside.expression.inside = e.languages.cue;
  })(t);
}
$9.displayName = "cypher";
$9.aliases = [];
function $9(t) {
  t.languages.cypher = {
    // https://neo4j.com/docs/cypher-manual/current/syntax/comments/
    comment: /\/\/.*/,
    string: {
      pattern: /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'/,
      greedy: !0
    },
    "class-name": {
      pattern: /(:\s*)(?:\w+|`(?:[^`\\\r\n])*`)(?=\s*[{):])/,
      lookbehind: !0,
      greedy: !0
    },
    relationship: {
      pattern: /(-\[\s*(?:\w+\s*|`(?:[^`\\\r\n])*`\s*)?:\s*|\|\s*:\s*)(?:\w+|`(?:[^`\\\r\n])*`)/,
      lookbehind: !0,
      greedy: !0,
      alias: "property"
    },
    identifier: {
      pattern: /`(?:[^`\\\r\n])*`/,
      greedy: !0
    },
    variable: /\$\w+/,
    // https://neo4j.com/docs/cypher-manual/current/syntax/reserved/
    keyword: /\b(?:ADD|ALL|AND|AS|ASC|ASCENDING|ASSERT|BY|CALL|CASE|COMMIT|CONSTRAINT|CONTAINS|CREATE|CSV|DELETE|DESC|DESCENDING|DETACH|DISTINCT|DO|DROP|ELSE|END|ENDS|EXISTS|FOR|FOREACH|IN|INDEX|IS|JOIN|KEY|LIMIT|LOAD|MANDATORY|MATCH|MERGE|NODE|NOT|OF|ON|OPTIONAL|OR|ORDER(?=\s+BY)|PERIODIC|REMOVE|REQUIRE|RETURN|SCALAR|SCAN|SET|SKIP|START|STARTS|THEN|UNION|UNIQUE|UNWIND|USING|WHEN|WHERE|WITH|XOR|YIELD)\b/i,
    function: /\b\w+\b(?=\s*\()/,
    boolean: /\b(?:false|null|true)\b/i,
    number: /\b(?:0x[\da-fA-F]+|\d+(?:\.\d+)?(?:[eE][+-]?\d+)?)\b/,
    // https://neo4j.com/docs/cypher-manual/current/syntax/operators/
    operator: /:|<--?|--?>?|<>|=~?|[<>]=?|[+*/%^|]|\.\.\.?/,
    punctuation: /[()[\]{},;.]/
  };
}
B9.displayName = "d";
B9.aliases = [];
function B9(t) {
  t.register(Lr), t.languages.d = t.languages.extend("clike", {
    comment: [
      {
        // Shebang
        pattern: /^\s*#!.+/,
        greedy: !0
      },
      {
        pattern: RegExp(
          /(^|[^\\])/.source + "(?:" + [
            // /+ comment +/
            // Allow one level of nesting
            /\/\+(?:\/\+(?:[^+]|\+(?!\/))*\+\/|(?!\/\+)[\s\S])*?\+\//.source,
            // // comment
            /\/\/.*/.source,
            // /* comment */
            /\/\*[\s\S]*?\*\//.source
          ].join("|") + ")"
        ),
        lookbehind: !0,
        greedy: !0
      }
    ],
    string: [
      {
        pattern: RegExp(
          [
            // r"", x""
            /\b[rx]"(?:\\[\s\S]|[^\\"])*"[cwd]?/.source,
            // q"[]", q"()", q"<>", q"{}"
            /\bq"(?:\[[\s\S]*?\]|\([\s\S]*?\)|<[\s\S]*?>|\{[\s\S]*?\})"/.source,
            // q"IDENT
            // ...
            // IDENT"
            /\bq"((?!\d)\w+)$[\s\S]*?^\1"/.source,
            // q"//", q"||", etc.
            // eslint-disable-next-line regexp/strict
            /\bq"(.)[\s\S]*?\2"/.source,
            // eslint-disable-next-line regexp/strict
            /(["`])(?:\\[\s\S]|(?!\3)[^\\])*\3[cwd]?/.source
          ].join("|"),
          "m"
        ),
        greedy: !0
      },
      {
        pattern: /\bq\{(?:\{[^{}]*\}|[^{}])*\}/,
        greedy: !0,
        alias: "token-string"
      }
    ],
    // In order: $, keywords and special tokens, globally defined symbols
    keyword: /\$|\b(?:__(?:(?:DATE|EOF|FILE|FUNCTION|LINE|MODULE|PRETTY_FUNCTION|TIMESTAMP|TIME|VENDOR|VERSION)__|gshared|parameters|traits|vector)|abstract|alias|align|asm|assert|auto|body|bool|break|byte|case|cast|catch|cdouble|cent|cfloat|char|class|const|continue|creal|dchar|debug|default|delegate|delete|deprecated|do|double|dstring|else|enum|export|extern|false|final|finally|float|for|foreach|foreach_reverse|function|goto|idouble|if|ifloat|immutable|import|inout|int|interface|invariant|ireal|lazy|long|macro|mixin|module|new|nothrow|null|out|override|package|pragma|private|protected|ptrdiff_t|public|pure|real|ref|return|scope|shared|short|size_t|static|string|struct|super|switch|synchronized|template|this|throw|true|try|typedef|typeid|typeof|ubyte|ucent|uint|ulong|union|unittest|ushort|version|void|volatile|wchar|while|with|wstring)\b/,
    number: [
      // The lookbehind and the negative look-ahead try to prevent bad highlighting of the .. operator
      // Hexadecimal numbers must be handled separately to avoid problems with exponent "e"
      /\b0x\.?[a-f\d_]+(?:(?!\.\.)\.[a-f\d_]*)?(?:p[+-]?[a-f\d_]+)?[ulfi]{0,4}/i,
      {
        pattern: /((?:\.\.)?)(?:\b0b\.?|\b|\.)\d[\d_]*(?:(?!\.\.)\.[\d_]*)?(?:e[+-]?\d[\d_]*)?[ulfi]{0,4}/i,
        lookbehind: !0
      }
    ],
    operator: /\|[|=]?|&[&=]?|\+[+=]?|-[-=]?|\.?\.\.|=[>=]?|!(?:i[ns]\b|<>?=?|>=?|=)?|\bi[ns]\b|(?:<[<>]?|>>?>?|\^\^|[*\/%^~])=?/
  }), t.languages.insertBefore("d", "string", {
    // Characters
    // 'a', '\\', '\n', '\xFF', '\377', '\uFFFF', '\U0010FFFF', '\quot'
    char: /'(?:\\(?:\W|\w+)|[^\\])'/
  }), t.languages.insertBefore("d", "keyword", {
    property: /\B@\w*/
  }), t.languages.insertBefore("d", "function", {
    register: {
      // Iasm registers
      pattern: /\b(?:[ABCD][LHX]|E?(?:BP|DI|SI|SP)|[BS]PL|[ECSDGF]S|CR[0234]|[DS]IL|DR[012367]|E[ABCD]X|X?MM[0-7]|R(?:1[0-5]|[89])[BWD]?|R[ABCD]X|R[BS]P|R[DS]I|TR[3-7]|XMM(?:1[0-5]|[89])|YMM(?:1[0-5]|\d))\b|\bST(?:\([0-7]\)|\b)/,
      alias: "variable"
    }
  });
}
U9.displayName = "dart";
U9.aliases = [];
function U9(t) {
  t.register(Lr), function(e) {
    var n = [
      /\b(?:async|sync|yield)\*/,
      /\b(?:abstract|assert|async|await|break|case|catch|class|const|continue|covariant|default|deferred|do|dynamic|else|enum|export|extends|extension|external|factory|final|finally|for|get|hide|if|implements|import|in|interface|library|mixin|new|null|on|operator|part|rethrow|return|set|show|static|super|switch|sync|this|throw|try|typedef|var|void|while|with|yield)\b/
    ], r = /(^|[^\w.])(?:[a-z]\w*\s*\.\s*)*(?:[A-Z]\w*\s*\.\s*)*/.source, a = {
      pattern: RegExp(r + /[A-Z](?:[\d_A-Z]*[a-z]\w*)?\b/.source),
      lookbehind: !0,
      inside: {
        namespace: {
          pattern: /^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/,
          inside: {
            punctuation: /\./
          }
        }
      }
    };
    e.languages.dart = e.languages.extend("clike", {
      "class-name": [
        a,
        {
          // variables and parameters
          // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
          pattern: RegExp(
            r + /[A-Z]\w*(?=\s+\w+\s*[;,=()])/.source
          ),
          lookbehind: !0,
          inside: a.inside
        }
      ],
      keyword: n,
      operator: /\bis!|\b(?:as|is)\b|\+\+|--|&&|\|\||<<=?|>>=?|~(?:\/=?)?|[+\-*\/%&^|=!<>]=?|\?/
    }), e.languages.insertBefore("dart", "string", {
      "string-literal": {
        pattern: /r?(?:("""|''')[\s\S]*?\1|(["'])(?:\\.|(?!\2)[^\\\r\n])*\2(?!\2))/,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:\w+|\{(?:[^{}]|\{[^{}]*\})*\})/,
            lookbehind: !0,
            inside: {
              punctuation: /^\$\{?|\}$/,
              expression: {
                pattern: /[\s\S]+/,
                inside: e.languages.dart
              }
            }
          },
          string: /[\s\S]+/
        }
      },
      string: void 0
    }), e.languages.insertBefore("dart", "class-name", {
      metadata: {
        pattern: /@\w+/,
        alias: "function"
      }
    }), e.languages.insertBefore("dart", "class-name", {
      generics: {
        pattern: /<(?:[\w\s,.&?]|<(?:[\w\s,.&?]|<(?:[\w\s,.&?]|<[\w\s,.&?]*>)*>)*>)*>/,
        inside: {
          "class-name": a,
          keyword: n,
          punctuation: /[<>(),.:]/,
          operator: /[?&|]/
        }
      }
    });
  }(t);
}
z9.displayName = "dataweave";
z9.aliases = [];
function z9(t) {
  (function(e) {
    e.languages.dataweave = {
      url: /\b[A-Za-z]+:\/\/[\w/:.?=&-]+|\burn:[\w:.?=&-]+/,
      property: {
        pattern: /(?:\b\w+#)?(?:"(?:\\.|[^\\"\r\n])*"|\b\w+)(?=\s*[:@])/,
        greedy: !0
      },
      string: {
        pattern: /(["'`])(?:\\[\s\S]|(?!\1)[^\\])*\1/,
        greedy: !0
      },
      "mime-type": /\b(?:application|audio|image|multipart|text|video)\/[\w+-]+/,
      date: {
        pattern: /\|[\w:+-]+\|/,
        greedy: !0
      },
      comment: [
        {
          pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
          lookbehind: !0,
          greedy: !0
        },
        {
          pattern: /(^|[^\\:])\/\/.*/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      regex: {
        pattern: /\/(?:[^\\\/\r\n]|\\[^\r\n])+\//,
        greedy: !0
      },
      keyword: /\b(?:and|as|at|case|do|else|fun|if|input|is|match|not|ns|null|or|output|type|unless|update|using|var)\b/,
      function: /\b[A-Z_]\w*(?=\s*\()/i,
      number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
      punctuation: /[{}[\];(),.:@]/,
      operator: /<<|>>|->|[<>~=]=?|!=|--?-?|\+\+?|!|\?/,
      boolean: /\b(?:false|true)\b/
    };
  })(t);
}
H9.displayName = "dax";
H9.aliases = [];
function H9(t) {
  t.languages.dax = {
    comment: {
      pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/).*)/,
      lookbehind: !0
    },
    "data-field": {
      pattern: /'(?:[^']|'')*'(?!')(?:\[[ \w\xA0-\uFFFF]+\])?|\w+\[[ \w\xA0-\uFFFF]+\]/,
      alias: "symbol"
    },
    measure: {
      pattern: /\[[ \w\xA0-\uFFFF]+\]/,
      alias: "constant"
    },
    string: {
      pattern: /"(?:[^"]|"")*"(?!")/,
      greedy: !0
    },
    function: /\b(?:ABS|ACOS|ACOSH|ACOT|ACOTH|ADDCOLUMNS|ADDMISSINGITEMS|ALL|ALLCROSSFILTERED|ALLEXCEPT|ALLNOBLANKROW|ALLSELECTED|AND|APPROXIMATEDISTINCTCOUNT|ASIN|ASINH|ATAN|ATANH|AVERAGE|AVERAGEA|AVERAGEX|BETA\.DIST|BETA\.INV|BLANK|CALCULATE|CALCULATETABLE|CALENDAR|CALENDARAUTO|CEILING|CHISQ\.DIST|CHISQ\.DIST\.RT|CHISQ\.INV|CHISQ\.INV\.RT|CLOSINGBALANCEMONTH|CLOSINGBALANCEQUARTER|CLOSINGBALANCEYEAR|COALESCE|COMBIN|COMBINA|COMBINEVALUES|CONCATENATE|CONCATENATEX|CONFIDENCE\.NORM|CONFIDENCE\.T|CONTAINS|CONTAINSROW|CONTAINSSTRING|CONTAINSSTRINGEXACT|CONVERT|COS|COSH|COT|COTH|COUNT|COUNTA|COUNTAX|COUNTBLANK|COUNTROWS|COUNTX|CROSSFILTER|CROSSJOIN|CURRENCY|CURRENTGROUP|CUSTOMDATA|DATATABLE|DATE|DATEADD|DATEDIFF|DATESBETWEEN|DATESINPERIOD|DATESMTD|DATESQTD|DATESYTD|DATEVALUE|DAY|DEGREES|DETAILROWS|DISTINCT|DISTINCTCOUNT|DISTINCTCOUNTNOBLANK|DIVIDE|EARLIER|EARLIEST|EDATE|ENDOFMONTH|ENDOFQUARTER|ENDOFYEAR|EOMONTH|ERROR|EVEN|EXACT|EXCEPT|EXP|EXPON\.DIST|FACT|FALSE|FILTER|FILTERS|FIND|FIRSTDATE|FIRSTNONBLANK|FIRSTNONBLANKVALUE|FIXED|FLOOR|FORMAT|GCD|GENERATE|GENERATEALL|GENERATESERIES|GEOMEAN|GEOMEANX|GROUPBY|HASONEFILTER|HASONEVALUE|HOUR|IF|IF\.EAGER|IFERROR|IGNORE|INT|INTERSECT|ISBLANK|ISCROSSFILTERED|ISEMPTY|ISERROR|ISEVEN|ISFILTERED|ISINSCOPE|ISLOGICAL|ISNONTEXT|ISNUMBER|ISO\.CEILING|ISODD|ISONORAFTER|ISSELECTEDMEASURE|ISSUBTOTAL|ISTEXT|KEEPFILTERS|KEYWORDMATCH|LASTDATE|LASTNONBLANK|LASTNONBLANKVALUE|LCM|LEFT|LEN|LN|LOG|LOG10|LOOKUPVALUE|LOWER|MAX|MAXA|MAXX|MEDIAN|MEDIANX|MID|MIN|MINA|MINUTE|MINX|MOD|MONTH|MROUND|NATURALINNERJOIN|NATURALLEFTOUTERJOIN|NEXTDAY|NEXTMONTH|NEXTQUARTER|NEXTYEAR|NONVISUAL|NORM\.DIST|NORM\.INV|NORM\.S\.DIST|NORM\.S\.INV|NOT|NOW|ODD|OPENINGBALANCEMONTH|OPENINGBALANCEQUARTER|OPENINGBALANCEYEAR|OR|PARALLELPERIOD|PATH|PATHCONTAINS|PATHITEM|PATHITEMREVERSE|PATHLENGTH|PERCENTILE\.EXC|PERCENTILE\.INC|PERCENTILEX\.EXC|PERCENTILEX\.INC|PERMUT|PI|POISSON\.DIST|POWER|PREVIOUSDAY|PREVIOUSMONTH|PREVIOUSQUARTER|PREVIOUSYEAR|PRODUCT|PRODUCTX|QUARTER|QUOTIENT|RADIANS|RAND|RANDBETWEEN|RANK\.EQ|RANKX|RELATED|RELATEDTABLE|REMOVEFILTERS|REPLACE|REPT|RIGHT|ROLLUP|ROLLUPADDISSUBTOTAL|ROLLUPGROUP|ROLLUPISSUBTOTAL|ROUND|ROUNDDOWN|ROUNDUP|ROW|SAMEPERIODLASTYEAR|SAMPLE|SEARCH|SECOND|SELECTCOLUMNS|SELECTEDMEASURE|SELECTEDMEASUREFORMATSTRING|SELECTEDMEASURENAME|SELECTEDVALUE|SIGN|SIN|SINH|SQRT|SQRTPI|STARTOFMONTH|STARTOFQUARTER|STARTOFYEAR|STDEV\.P|STDEV\.S|STDEVX\.P|STDEVX\.S|SUBSTITUTE|SUBSTITUTEWITHINDEX|SUM|SUMMARIZE|SUMMARIZECOLUMNS|SUMX|SWITCH|T\.DIST|T\.DIST\.2T|T\.DIST\.RT|T\.INV|T\.INV\.2T|TAN|TANH|TIME|TIMEVALUE|TODAY|TOPN|TOPNPERLEVEL|TOPNSKIP|TOTALMTD|TOTALQTD|TOTALYTD|TREATAS|TRIM|TRUE|TRUNC|UNICHAR|UNICODE|UNION|UPPER|USERELATIONSHIP|USERNAME|USEROBJECTID|USERPRINCIPALNAME|UTCNOW|UTCTODAY|VALUE|VALUES|VAR\.P|VAR\.S|VARX\.P|VARX\.S|WEEKDAY|WEEKNUM|XIRR|XNPV|YEAR|YEARFRAC)(?=\s*\()/i,
    keyword: /\b(?:DEFINE|EVALUATE|MEASURE|ORDER\s+BY|RETURN|VAR|START\s+AT|ASC|DESC)\b/i,
    boolean: {
      pattern: /\b(?:FALSE|NULL|TRUE)\b/i,
      alias: "constant"
    },
    number: /\b\d+(?:\.\d*)?|\B\.\d+\b/,
    operator: /:=|[-+*\/=^]|&&?|\|\||<(?:=>?|<|>)?|>[>=]?|\b(?:IN|NOT)\b/i,
    punctuation: /[;\[\](){}`,.]/
  };
}
W9.displayName = "dhall";
W9.aliases = [];
function W9(t) {
  t.languages.dhall = {
    // Multi-line comments can be nested. E.g. {- foo {- bar -} -}
    // The multi-line pattern is essentially this:
    //   \{-(?:[^-{]|-(?!\})|\{(?!-)|<SELF>)*-\}
    comment: /--.*|\{-(?:[^-{]|-(?!\})|\{(?!-)|\{-(?:[^-{]|-(?!\})|\{(?!-))*-\})*-\}/,
    string: {
      pattern: /"(?:[^"\\]|\\.)*"|''(?:[^']|'(?!')|'''|''\$\{)*''(?!'|\$)/,
      greedy: !0,
      inside: {
        interpolation: {
          pattern: /\$\{[^{}]*\}/,
          inside: {
            expression: {
              pattern: /(^\$\{)[\s\S]+(?=\}$)/,
              lookbehind: !0,
              alias: "language-dhall",
              inside: null
              // see blow
            },
            punctuation: /\$\{|\}/
          }
        }
      }
    },
    label: {
      pattern: /`[^`]*`/,
      greedy: !0
    },
    url: {
      // https://github.com/dhall-lang/dhall-lang/blob/5fde8ef1bead6fb4e999d3c1ffe7044cd019d63a/standard/dhall.abnf#L596
      pattern: /\bhttps?:\/\/[\w.:%!$&'*+;=@~-]+(?:\/[\w.:%!$&'*+;=@~-]*)*(?:\?[/?\w.:%!$&'*+;=@~-]*)?/,
      greedy: !0
    },
    env: {
      // https://github.com/dhall-lang/dhall-lang/blob/5fde8ef1bead6fb4e999d3c1ffe7044cd019d63a/standard/dhall.abnf#L661
      pattern: /\benv:(?:(?!\d)\w+|"(?:[^"\\=]|\\.)*")/,
      greedy: !0,
      inside: {
        function: /^env/,
        operator: /^:/,
        variable: /[\s\S]+/
      }
    },
    hash: {
      // https://github.com/dhall-lang/dhall-lang/blob/5fde8ef1bead6fb4e999d3c1ffe7044cd019d63a/standard/dhall.abnf#L725
      pattern: /\bsha256:[\da-fA-F]{64}\b/,
      inside: {
        function: /sha256/,
        operator: /:/,
        number: /[\da-fA-F]{64}/
      }
    },
    // https://github.com/dhall-lang/dhall-lang/blob/5fde8ef1bead6fb4e999d3c1ffe7044cd019d63a/standard/dhall.abnf#L359
    keyword: /\b(?:as|assert|else|forall|if|in|let|merge|missing|then|toMap|using|with)\b|\u2200/,
    builtin: /\b(?:None|Some)\b/,
    boolean: /\b(?:False|True)\b/,
    number: /\bNaN\b|-?\bInfinity\b|[+-]?\b(?:0x[\da-fA-F]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/,
    operator: /\/\\|\/\/\\\\|&&|\|\||===|[!=]=|\/\/|->|\+\+|::|[+*#@=:?<>|\\\u2227\u2a53\u2261\u2afd\u03bb\u2192]/,
    punctuation: /\.\.|[{}\[\](),./]/,
    // we'll just assume that every capital word left is a type name
    "class-name": /\b[A-Z]\w*\b/
  }, t.languages.dhall.string.inside.interpolation.inside.expression.inside = t.languages.dhall;
}
Q9.displayName = "django";
Q9.aliases = ["jinja2"];
function Q9(t) {
  t.register(al), function(e) {
    e.languages.django = {
      comment: /^\{#[\s\S]*?#\}$/,
      tag: {
        pattern: /(^\{%[+-]?\s*)\w+/,
        lookbehind: !0,
        alias: "keyword"
      },
      delimiter: {
        pattern: /^\{[{%][+-]?|[+-]?[}%]\}$/,
        alias: "punctuation"
      },
      string: {
        pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      filter: {
        pattern: /(\|)\w+/,
        lookbehind: !0,
        alias: "function"
      },
      test: {
        pattern: /(\bis\s+(?:not\s+)?)(?!not\b)\w+/,
        lookbehind: !0,
        alias: "function"
      },
      function: /\b[a-z_]\w+(?=\s*\()/i,
      keyword: /\b(?:and|as|by|else|for|if|import|in|is|loop|not|or|recursive|with|without)\b/,
      operator: /[-+%=]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
      number: /\b\d+(?:\.\d+)?\b/,
      boolean: /[Ff]alse|[Nn]one|[Tt]rue/,
      variable: /\b\w+\b/,
      punctuation: /[{}[\](),.:;]/
    };
    var n = /\{\{[\s\S]*?\}\}|\{%[\s\S]*?%\}|\{#[\s\S]*?#\}/g, r = e.languages["markup-templating"];
    e.hooks.add("before-tokenize", function(a) {
      r.buildPlaceholders(a, "django", n);
    }), e.hooks.add("after-tokenize", function(a) {
      r.tokenizePlaceholders(a, "django");
    }), e.languages.jinja2 = e.languages.django, e.hooks.add("before-tokenize", function(a) {
      r.buildPlaceholders(a, "jinja2", n);
    }), e.hooks.add("after-tokenize", function(a) {
      r.tokenizePlaceholders(a, "jinja2");
    });
  }(t);
}
j9.displayName = "dns-zone-file";
j9.aliases = ["dns-zone"];
function j9(t) {
  t.languages["dns-zone-file"] = {
    comment: /;.*/,
    string: {
      pattern: /"(?:\\.|[^"\\\r\n])*"/,
      greedy: !0
    },
    variable: [
      {
        pattern: /(^\$ORIGIN[ \t]+)\S+/m,
        lookbehind: !0
      },
      {
        pattern: /(^|\s)@(?=\s|$)/,
        lookbehind: !0
      }
    ],
    keyword: /^\$(?:INCLUDE|ORIGIN|TTL)(?=\s|$)/m,
    class: {
      // https://tools.ietf.org/html/rfc1035#page-13
      pattern: /(^|\s)(?:CH|CS|HS|IN)(?=\s|$)/,
      lookbehind: !0,
      alias: "keyword"
    },
    type: {
      // https://en.wikipedia.org/wiki/List_of_DNS_record_types
      pattern: /(^|\s)(?:A|A6|AAAA|AFSDB|APL|ATMA|CAA|CDNSKEY|CDS|CERT|CNAME|DHCID|DLV|DNAME|DNSKEY|DS|EID|GID|GPOS|HINFO|HIP|IPSECKEY|ISDN|KEY|KX|LOC|MAILA|MAILB|MB|MD|MF|MG|MINFO|MR|MX|NAPTR|NB|NBSTAT|NIMLOC|NINFO|NS|NSAP|NSAP-PTR|NSEC|NSEC3|NSEC3PARAM|NULL|NXT|OPENPGPKEY|PTR|PX|RKEY|RP|RRSIG|RT|SIG|SINK|SMIMEA|SOA|SPF|SRV|SSHFP|TA|TKEY|TLSA|TSIG|TXT|UID|UINFO|UNSPEC|URI|WKS|X25)(?=\s|$)/,
      lookbehind: !0,
      alias: "keyword"
    },
    punctuation: /[()]/
  }, t.languages["dns-zone"] = t.languages["dns-zone-file"];
}
G9.displayName = "docker";
G9.aliases = ["dockerfile"];
function G9(t) {
  (function(e) {
    var n = /\\[\r\n](?:\s|\\[\r\n]|#.*(?!.))*(?![\s#]|\\[\r\n])/.source, r = /(?:[ \t]+(?![ \t])(?:<SP_BS>)?|<SP_BS>)/.source.replace(
      /<SP_BS>/g,
      function() {
        return n;
      }
    ), a = /"(?:[^"\\\r\n]|\\(?:\r\n|[\s\S]))*"|'(?:[^'\\\r\n]|\\(?:\r\n|[\s\S]))*'/.source, i = /--[\w-]+=(?:<STR>|(?!["'])(?:[^\s\\]|\\.)+)/.source.replace(
      /<STR>/g,
      function() {
        return a;
      }
    ), o = {
      pattern: RegExp(a),
      greedy: !0
    }, s = {
      pattern: /(^[ \t]*)#.*/m,
      lookbehind: !0,
      greedy: !0
    };
    function u(f, p) {
      return f = f.replace(/<OPT>/g, function() {
        return i;
      }).replace(/<SP>/g, function() {
        return r;
      }), RegExp(f, p);
    }
    e.languages.docker = {
      instruction: {
        pattern: /(^[ \t]*)(?:ADD|ARG|CMD|COPY|ENTRYPOINT|ENV|EXPOSE|FROM|HEALTHCHECK|LABEL|MAINTAINER|ONBUILD|RUN|SHELL|STOPSIGNAL|USER|VOLUME|WORKDIR)(?=\s)(?:\\.|[^\r\n\\])*(?:\\$(?:\s|#.*$)*(?![\s#])(?:\\.|[^\r\n\\])*)*/im,
        lookbehind: !0,
        greedy: !0,
        inside: {
          options: {
            pattern: u(
              /(^(?:ONBUILD<SP>)?\w+<SP>)<OPT>(?:<SP><OPT>)*/.source,
              "i"
            ),
            lookbehind: !0,
            greedy: !0,
            inside: {
              property: {
                pattern: /(^|\s)--[\w-]+/,
                lookbehind: !0
              },
              string: [
                o,
                {
                  pattern: /(=)(?!["'])(?:[^\s\\]|\\.)+/,
                  lookbehind: !0
                }
              ],
              operator: /\\$/m,
              punctuation: /=/
            }
          },
          keyword: [
            {
              // https://docs.docker.com/engine/reference/builder/#healthcheck
              pattern: u(
                /(^(?:ONBUILD<SP>)?HEALTHCHECK<SP>(?:<OPT><SP>)*)(?:CMD|NONE)\b/.source,
                "i"
              ),
              lookbehind: !0,
              greedy: !0
            },
            {
              // https://docs.docker.com/engine/reference/builder/#from
              pattern: u(
                /(^(?:ONBUILD<SP>)?FROM<SP>(?:<OPT><SP>)*(?!--)[^ \t\\]+<SP>)AS/.source,
                "i"
              ),
              lookbehind: !0,
              greedy: !0
            },
            {
              // https://docs.docker.com/engine/reference/builder/#onbuild
              pattern: u(/(^ONBUILD<SP>)\w+/.source, "i"),
              lookbehind: !0,
              greedy: !0
            },
            {
              pattern: /^\w+/,
              greedy: !0
            }
          ],
          comment: s,
          string: o,
          variable: /\$(?:\w+|\{[^{}"'\\]*\})/,
          operator: /\\$/m
        }
      },
      comment: s
    }, e.languages.dockerfile = e.languages.docker;
  })(t);
}
V9.displayName = "dot";
V9.aliases = ["gv"];
function V9(t) {
  (function(e) {
    var n = "(?:" + [
      // an identifier
      /[a-zA-Z_\x80-\uFFFF][\w\x80-\uFFFF]*/.source,
      // a number
      /-?(?:\.\d+|\d+(?:\.\d*)?)/.source,
      // a double-quoted string
      /"[^"\\]*(?:\\[\s\S][^"\\]*)*"/.source,
      // HTML-like string
      /<(?:[^<>]|(?!<!--)<(?:[^<>"']|"[^"]*"|'[^']*')+>|<!--(?:[^-]|-(?!->))*-->)*>/.source
    ].join("|") + ")", r = {
      markup: {
        pattern: /(^<)[\s\S]+(?=>$)/,
        lookbehind: !0,
        alias: ["language-markup", "language-html", "language-xml"],
        inside: e.languages.markup
      }
    };
    function a(i, o) {
      return RegExp(
        i.replace(/<ID>/g, function() {
          return n;
        }),
        o
      );
    }
    e.languages.dot = {
      comment: {
        pattern: /\/\/.*|\/\*[\s\S]*?\*\/|^#.*/m,
        greedy: !0
      },
      "graph-name": {
        pattern: a(
          /(\b(?:digraph|graph|subgraph)[ \t\r\n]+)<ID>/.source,
          "i"
        ),
        lookbehind: !0,
        greedy: !0,
        alias: "class-name",
        inside: r
      },
      "attr-value": {
        pattern: a(/(=[ \t\r\n]*)<ID>/.source),
        lookbehind: !0,
        greedy: !0,
        inside: r
      },
      "attr-name": {
        pattern: a(/([\[;, \t\r\n])<ID>(?=[ \t\r\n]*=)/.source),
        lookbehind: !0,
        greedy: !0,
        inside: r
      },
      keyword: /\b(?:digraph|edge|graph|node|strict|subgraph)\b/i,
      "compass-point": {
        pattern: /(:[ \t\r\n]*)(?:[ewc_]|[ns][ew]?)(?![\w\x80-\uFFFF])/,
        lookbehind: !0,
        alias: "builtin"
      },
      node: {
        pattern: a(/(^|[^-.\w\x80-\uFFFF\\])<ID>/.source),
        lookbehind: !0,
        greedy: !0,
        inside: r
      },
      operator: /[=:]|-[->]/,
      punctuation: /[\[\]{};,]/
    }, e.languages.gv = e.languages.dot;
  })(t);
}
Y9.displayName = "ebnf";
Y9.aliases = [];
function Y9(t) {
  t.languages.ebnf = {
    comment: /\(\*[\s\S]*?\*\)/,
    string: {
      pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
      greedy: !0
    },
    special: {
      pattern: /\?[^?\r\n]*\?/,
      greedy: !0,
      alias: "class-name"
    },
    definition: {
      pattern: /^([\t ]*)[a-z]\w*(?:[ \t]+[a-z]\w*)*(?=\s*=)/im,
      lookbehind: !0,
      alias: ["rule", "keyword"]
    },
    rule: /\b[a-z]\w*(?:[ \t]+[a-z]\w*)*\b/i,
    punctuation: /\([:/]|[:/]\)|[.,;()[\]{}]/,
    operator: /[-=|*/!]/
  };
}
Z9.displayName = "editorconfig";
Z9.aliases = [];
function Z9(t) {
  t.languages.editorconfig = {
    // https://editorconfig-specification.readthedocs.io
    comment: /[;#].*/,
    section: {
      pattern: /(^[ \t]*)\[.+\]/m,
      lookbehind: !0,
      alias: "selector",
      inside: {
        regex: /\\\\[\[\]{},!?.*]/,
        // Escape special characters with '\\'
        operator: /[!?]|\.\.|\*{1,2}/,
        punctuation: /[\[\]{},]/
      }
    },
    key: {
      pattern: /(^[ \t]*)[^\s=]+(?=[ \t]*=)/m,
      lookbehind: !0,
      alias: "attr-name"
    },
    value: {
      pattern: /=.*/,
      alias: "attr-value",
      inside: {
        punctuation: /^=/
      }
    }
  };
}
X9.displayName = "eiffel";
X9.aliases = [];
function X9(t) {
  t.languages.eiffel = {
    comment: /--.*/,
    string: [
      // Aligned-verbatim-strings
      {
        pattern: /"([^[]*)\[[\s\S]*?\]\1"/,
        greedy: !0
      },
      // Non-aligned-verbatim-strings
      {
        pattern: /"([^{]*)\{[\s\S]*?\}\1"/,
        greedy: !0
      },
      // Single-line string
      {
        pattern: /"(?:%(?:(?!\n)\s)*\n\s*%|%\S|[^%"\r\n])*"/,
        greedy: !0
      }
    ],
    // normal char | special char | char code
    char: /'(?:%.|[^%'\r\n])+'/,
    keyword: /\b(?:across|agent|alias|all|and|as|assign|attached|attribute|check|class|convert|create|Current|debug|deferred|detachable|do|else|elseif|end|ensure|expanded|export|external|feature|from|frozen|if|implies|inherit|inspect|invariant|like|local|loop|not|note|obsolete|old|once|or|Precursor|redefine|rename|require|rescue|Result|retry|select|separate|some|then|undefine|until|variant|Void|when|xor)\b/i,
    boolean: /\b(?:False|True)\b/i,
    // Convention: class-names are always all upper-case characters
    "class-name": /\b[A-Z][\dA-Z_]*\b/,
    number: [
      // hexa | octal | bin
      /\b0[xcb][\da-f](?:_*[\da-f])*\b/i,
      // Decimal
      /(?:\b\d(?:_*\d)*)?\.(?:(?:\d(?:_*\d)*)?e[+-]?)?\d(?:_*\d)*\b|\b\d(?:_*\d)*\b\.?/i
    ],
    punctuation: /:=|<<|>>|\(\||\|\)|->|\.(?=\w)|[{}[\];(),:?]/,
    operator: /\\\\|\|\.\.\||\.\.|\/[~\/=]?|[><]=?|[-+*^=~]/
  };
}
q9.displayName = "ejs";
q9.aliases = ["eta"];
function q9(t) {
  t.register(rl), t.register(al), function(e) {
    e.languages.ejs = {
      delimiter: {
        pattern: /^<%[-_=]?|[-_]?%>$/,
        alias: "punctuation"
      },
      comment: /^#[\s\S]*/,
      "language-javascript": {
        pattern: /[\s\S]+/,
        inside: e.languages.javascript
      }
    }, e.hooks.add("before-tokenize", function(n) {
      var r = /<%(?!%)[\s\S]+?%>/g;
      e.languages["markup-templating"].buildPlaceholders(
        n,
        "ejs",
        r
      );
    }), e.hooks.add("after-tokenize", function(n) {
      e.languages["markup-templating"].tokenizePlaceholders(n, "ejs");
    }), e.languages.eta = e.languages.ejs;
  }(t);
}
K9.displayName = "elixir";
K9.aliases = [];
function K9(t) {
  t.languages.elixir = {
    doc: {
      pattern: /@(?:doc|moduledoc)\s+(?:("""|''')[\s\S]*?\1|("|')(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2)/,
      inside: {
        attribute: /^@\w+/,
        string: /['"][\s\S]+/
      }
    },
    comment: {
      pattern: /#.*/,
      greedy: !0
    },
    // ~r"""foo""" (multi-line), ~r'''foo''' (multi-line), ~r/foo/, ~r|foo|, ~r"foo", ~r'foo', ~r(foo), ~r[foo], ~r{foo}, ~r<foo>
    regex: {
      pattern: /~[rR](?:("""|''')(?:\\[\s\S]|(?!\1)[^\\])+\1|([\/|"'])(?:\\.|(?!\2)[^\\\r\n])+\2|\((?:\\.|[^\\)\r\n])+\)|\[(?:\\.|[^\\\]\r\n])+\]|\{(?:\\.|[^\\}\r\n])+\}|<(?:\\.|[^\\>\r\n])+>)[uismxfr]*/,
      greedy: !0
    },
    string: [
      {
        // ~s"""foo""" (multi-line), ~s'''foo''' (multi-line), ~s/foo/, ~s|foo|, ~s"foo", ~s'foo', ~s(foo), ~s[foo], ~s{foo} (with interpolation care), ~s<foo>
        pattern: /~[cCsSwW](?:("""|''')(?:\\[\s\S]|(?!\1)[^\\])+\1|([\/|"'])(?:\\.|(?!\2)[^\\\r\n])+\2|\((?:\\.|[^\\)\r\n])+\)|\[(?:\\.|[^\\\]\r\n])+\]|\{(?:\\.|#\{[^}]+\}|#(?!\{)|[^#\\}\r\n])+\}|<(?:\\.|[^\\>\r\n])+>)[csa]?/,
        greedy: !0,
        inside: {
          // See interpolation below
        }
      },
      {
        pattern: /("""|''')[\s\S]*?\1/,
        greedy: !0,
        inside: {
          // See interpolation below
        }
      },
      {
        // Multi-line strings are allowed
        pattern: /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: !0,
        inside: {
          // See interpolation below
        }
      }
    ],
    atom: {
      // Look-behind prevents bad highlighting of the :: operator
      pattern: /(^|[^:]):\w+/,
      lookbehind: !0,
      alias: "symbol"
    },
    module: {
      pattern: /\b[A-Z]\w*\b/,
      alias: "class-name"
    },
    // Look-ahead prevents bad highlighting of the :: operator
    "attr-name": /\b\w+\??:(?!:)/,
    argument: {
      // Look-behind prevents bad highlighting of the && operator
      pattern: /(^|[^&])&\d+/,
      lookbehind: !0,
      alias: "variable"
    },
    attribute: {
      pattern: /@\w+/,
      alias: "variable"
    },
    function: /\b[_a-zA-Z]\w*[?!]?(?:(?=\s*(?:\.\s*)?\()|(?=\/\d))/,
    number: /\b(?:0[box][a-f\d_]+|\d[\d_]*)(?:\.[\d_]+)?(?:e[+-]?[\d_]+)?\b/i,
    keyword: /\b(?:after|alias|and|case|catch|cond|def(?:callback|delegate|exception|impl|macro|module|n|np|p|protocol|struct)?|do|else|end|fn|for|if|import|not|or|quote|raise|require|rescue|try|unless|unquote|use|when)\b/,
    boolean: /\b(?:false|nil|true)\b/,
    operator: [
      /\bin\b|&&?|\|[|>]?|\\\\|::|\.\.\.?|\+\+?|-[->]?|<[-=>]|>=|!==?|\B!|=(?:==?|[>~])?|[*\/^]/,
      {
        // We don't want to match <<
        pattern: /([^<])<(?!<)/,
        lookbehind: !0
      },
      {
        // We don't want to match >>
        pattern: /([^>])>(?!>)/,
        lookbehind: !0
      }
    ],
    punctuation: /<<|>>|[.,%\[\]{}()]/
  }, t.languages.elixir.string.forEach(function(e) {
    e.inside = {
      interpolation: {
        pattern: /#\{[^}]+\}/,
        inside: {
          delimiter: {
            pattern: /^#\{|\}$/,
            alias: "punctuation"
          },
          rest: t.languages.elixir
        }
      }
    };
  });
}
J9.displayName = "elm";
J9.aliases = [];
function J9(t) {
  t.languages.elm = {
    comment: /--.*|\{-[\s\S]*?-\}/,
    char: {
      pattern: /'(?:[^\\'\r\n]|\\(?:[abfnrtv\\']|\d+|x[0-9a-fA-F]+|u\{[0-9a-fA-F]+\}))'/,
      greedy: !0
    },
    string: [
      {
        // Multiline strings are wrapped in triple ". Quotes may appear unescaped.
        pattern: /"""[\s\S]*?"""/,
        greedy: !0
      },
      {
        pattern: /"(?:[^\\"\r\n]|\\.)*"/,
        greedy: !0
      }
    ],
    "import-statement": {
      // The imported or hidden names are not included in this import
      // statement. This is because we want to highlight those exactly like
      // we do for the names in the program.
      pattern: /(^[\t ]*)import\s+[A-Z]\w*(?:\.[A-Z]\w*)*(?:\s+as\s+(?:[A-Z]\w*)(?:\.[A-Z]\w*)*)?(?:\s+exposing\s+)?/m,
      lookbehind: !0,
      inside: {
        keyword: /\b(?:as|exposing|import)\b/
      }
    },
    keyword: /\b(?:alias|as|case|else|exposing|if|in|infixl|infixr|let|module|of|then|type)\b/,
    // These are builtin variables only. Constructors are highlighted later as a constant.
    builtin: /\b(?:abs|acos|always|asin|atan|atan2|ceiling|clamp|compare|cos|curry|degrees|e|flip|floor|fromPolar|identity|isInfinite|isNaN|logBase|max|min|negate|never|not|pi|radians|rem|round|sin|sqrt|tan|toFloat|toPolar|toString|truncate|turns|uncurry|xor)\b/,
    // decimal integers and floating point numbers | hexadecimal integers
    number: /\b(?:\d+(?:\.\d+)?(?:e[+-]?\d+)?|0x[0-9a-f]+)\b/i,
    // Most of this is needed because of the meaning of a single '.'.
    // If it stands alone freely, it is the function composition.
    // It may also be a separator between a module name and an identifier => no
    // operator. If it comes together with other special characters it is an
    // operator too.
    // Valid operator characters in 0.18: +-/*=.$<>:&|^?%#@~!
    // Ref: https://groups.google.com/forum/#!msg/elm-dev/0AHSnDdkSkQ/E0SVU70JEQAJ
    operator: /\s\.\s|[+\-/*=.$<>:&|^?%#@~!]{2,}|[+\-/*=$<>:&|^?%#@~!]/,
    // In Elm, nearly everything is a variable, do not highlight these.
    hvariable: /\b(?:[A-Z]\w*\.)*[a-z]\w*\b/,
    constant: /\b(?:[A-Z]\w*\.)*[A-Z]\w*\b/,
    punctuation: /[{}[\]|(),.:]/
  };
}
ez.displayName = "etlua";
ez.aliases = [];
function ez(t) {
  t.register(A_), t.register(al), function(e) {
    e.languages.etlua = {
      delimiter: {
        pattern: /^<%[-=]?|-?%>$/,
        alias: "punctuation"
      },
      "language-lua": {
        pattern: /[\s\S]+/,
        inside: e.languages.lua
      }
    }, e.hooks.add("before-tokenize", function(n) {
      var r = /<%[\s\S]+?%>/g;
      e.languages["markup-templating"].buildPlaceholders(
        n,
        "etlua",
        r
      );
    }), e.hooks.add("after-tokenize", function(n) {
      e.languages["markup-templating"].tokenizePlaceholders(n, "etlua");
    });
  }(t);
}
tz.displayName = "erb";
tz.aliases = [];
function tz(t) {
  t.register(al), t.register(I0), function(e) {
    e.languages.erb = {
      delimiter: {
        pattern: /^(\s*)<%=?|%>(?=\s*$)/,
        lookbehind: !0,
        alias: "punctuation"
      },
      ruby: {
        pattern: /\s*\S[\s\S]*/,
        alias: "language-ruby",
        inside: e.languages.ruby
      }
    }, e.hooks.add("before-tokenize", function(n) {
      var r = /<%=?(?:[^\r\n]|[\r\n](?!=begin)|[\r\n]=begin\s(?:[^\r\n]|[\r\n](?!=end))*[\r\n]=end)+?%>/g;
      e.languages["markup-templating"].buildPlaceholders(
        n,
        "erb",
        r
      );
    }), e.hooks.add("after-tokenize", function(n) {
      e.languages["markup-templating"].tokenizePlaceholders(n, "erb");
    });
  }(t);
}
nz.displayName = "erlang";
nz.aliases = [];
function nz(t) {
  t.languages.erlang = {
    comment: /%.+/,
    string: {
      pattern: /"(?:\\.|[^\\"\r\n])*"/,
      greedy: !0
    },
    "quoted-function": {
      pattern: /'(?:\\.|[^\\'\r\n])+'(?=\()/,
      alias: "function"
    },
    "quoted-atom": {
      pattern: /'(?:\\.|[^\\'\r\n])+'/,
      alias: "atom"
    },
    boolean: /\b(?:false|true)\b/,
    keyword: /\b(?:after|begin|case|catch|end|fun|if|of|receive|try|when)\b/,
    number: [
      /\$\\?./,
      /\b\d+#[a-z0-9]+/i,
      /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i
    ],
    function: /\b[a-z][\w@]*(?=\()/,
    variable: {
      // Look-behind is used to prevent wrong highlighting of atoms containing "@"
      pattern: /(^|[^@])(?:\b|\?)[A-Z_][\w@]*/,
      lookbehind: !0
    },
    operator: [
      /[=\/<>:]=|=[:\/]=|\+\+?|--?|[=*\/!]|\b(?:and|andalso|band|bnot|bor|bsl|bsr|bxor|div|not|or|orelse|rem|xor)\b/,
      {
        // We don't want to match <<
        pattern: /(^|[^<])<(?!<)/,
        lookbehind: !0
      },
      {
        // We don't want to match >>
        pattern: /(^|[^>])>(?!>)/,
        lookbehind: !0
      }
    ],
    atom: /\b[a-z][\w@]*/,
    punctuation: /[()[\]{}:;,.#|]|<<|>>/
  };
}
rz.displayName = "excel-formula";
rz.aliases = ["xls", "xlsx"];
function rz(t) {
  t.languages["excel-formula"] = {
    comment: {
      pattern: /(\bN\(\s*)"(?:[^"]|"")*"(?=\s*\))/i,
      lookbehind: !0,
      greedy: !0
    },
    string: {
      pattern: /"(?:[^"]|"")*"(?!")/,
      greedy: !0
    },
    reference: {
      // https://www.ablebits.com/office-addins-blog/2015/12/08/excel-reference-another-sheet-workbook/
      // Sales!B2
      // 'Winter sales'!B2
      // [Sales.xlsx]Jan!B2:B5
      // D:\Reports\[Sales.xlsx]Jan!B2:B5
      // '[Sales.xlsx]Jan sales'!B2:B5
      // 'D:\Reports\[Sales.xlsx]Jan sales'!B2:B5
      pattern: /(?:'[^']*'|(?:[^\s()[\]{}<>*?"';,$&]*\[[^^\s()[\]{}<>*?"']+\])?\w+)!/,
      greedy: !0,
      alias: "string",
      inside: {
        operator: /!$/,
        punctuation: /'/,
        sheet: {
          pattern: /[^[\]]+$/,
          alias: "function"
        },
        file: {
          pattern: /\[[^[\]]+\]$/,
          inside: {
            punctuation: /[[\]]/
          }
        },
        path: /[\s\S]+/
      }
    },
    "function-name": {
      pattern: /\b[A-Z]\w*(?=\()/i,
      alias: "builtin"
    },
    range: {
      pattern: /\$?\b(?:[A-Z]+\$?\d+:\$?[A-Z]+\$?\d+|[A-Z]+:\$?[A-Z]+|\d+:\$?\d+)\b/i,
      alias: "selector",
      inside: {
        operator: /:/,
        cell: /\$?[A-Z]+\$?\d+/i,
        column: /\$?[A-Z]+/i,
        row: /\$?\d+/
      }
    },
    cell: {
      // Excel is case insensitive, so the string "foo1" could be either a variable or a cell.
      // To combat this, we match cells case insensitive, if the contain at least one "$", and case sensitive otherwise.
      pattern: /\b[A-Z]+\d+\b|\$[A-Za-z]+\$?\d+\b|\b[A-Za-z]+\$\d+\b/,
      alias: "selector"
    },
    number: /(?:\b\d+(?:\.\d+)?|\B\.\d+)(?:e[+-]?\d+)?\b/i,
    boolean: /\b(?:FALSE|TRUE)\b/i,
    operator: /[-+*/^%=&,]|<[=>]?|>=?/,
    punctuation: /[[\]();{}|]/
  }, t.languages.xlsx = t.languages.xls = t.languages["excel-formula"];
}
az.displayName = "fsharp";
az.aliases = [];
function az(t) {
  t.register(Lr), t.languages.fsharp = t.languages.extend("clike", {
    comment: [
      {
        pattern: /(^|[^\\])\(\*(?!\))[\s\S]*?\*\)/,
        lookbehind: !0,
        greedy: !0
      },
      {
        pattern: /(^|[^\\:])\/\/.*/,
        lookbehind: !0,
        greedy: !0
      }
    ],
    string: {
      pattern: /(?:"""[\s\S]*?"""|@"(?:""|[^"])*"|"(?:\\[\s\S]|[^\\"])*")B?/,
      greedy: !0
    },
    "class-name": {
      pattern: /(\b(?:exception|inherit|interface|new|of|type)\s+|\w\s*:\s*|\s:\??>\s*)[.\w]+\b(?:\s*(?:->|\*)\s*[.\w]+\b)*(?!\s*[:.])/,
      lookbehind: !0,
      inside: {
        operator: /->|\*/,
        punctuation: /\./
      }
    },
    keyword: /\b(?:let|return|use|yield)(?:!\B|\b)|\b(?:abstract|and|as|asr|assert|atomic|base|begin|break|checked|class|component|const|constraint|constructor|continue|default|delegate|do|done|downcast|downto|eager|elif|else|end|event|exception|extern|external|false|finally|fixed|for|fun|function|functor|global|if|in|include|inherit|inline|interface|internal|land|lazy|lor|lsl|lsr|lxor|match|member|method|mixin|mod|module|mutable|namespace|new|not|null|object|of|open|or|override|parallel|private|process|protected|public|pure|rec|sealed|select|sig|static|struct|tailcall|then|to|trait|true|try|type|upcast|val|virtual|void|volatile|when|while|with)\b/,
    number: [
      /\b0x[\da-fA-F]+(?:LF|lf|un)?\b/,
      /\b0b[01]+(?:uy|y)?\b/,
      /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[fm]|e[+-]?\d+)?\b/i,
      /\b\d+(?:[IlLsy]|UL|u[lsy]?)?\b/
    ],
    operator: /([<>~&^])\1\1|([*.:<>&])\2|<-|->|[!=:]=|<?\|{1,3}>?|\??(?:<=|>=|<>|[-+*/%=<>])\??|[!?^&]|~[+~-]|:>|:\?>?/
  }), t.languages.insertBefore("fsharp", "keyword", {
    preprocessor: {
      pattern: /(^[\t ]*)#.*/m,
      lookbehind: !0,
      alias: "property",
      inside: {
        directive: {
          pattern: /(^#)\b(?:else|endif|if|light|line|nowarn)\b/,
          lookbehind: !0,
          alias: "keyword"
        }
      }
    }
  }), t.languages.insertBefore("fsharp", "punctuation", {
    "computation-expression": {
      pattern: /\b[_a-z]\w*(?=\s*\{)/i,
      alias: "keyword"
    }
  }), t.languages.insertBefore("fsharp", "string", {
    annotation: {
      pattern: /\[<.+?>\]/,
      greedy: !0,
      inside: {
        punctuation: /^\[<|>\]$/,
        "class-name": {
          pattern: /^\w+$|(^|;\s*)[A-Z]\w*(?=\()/,
          lookbehind: !0
        },
        "annotation-content": {
          pattern: /[\s\S]+/,
          inside: t.languages.fsharp
        }
      }
    },
    char: {
      pattern: /'(?:[^\\']|\\(?:.|\d{3}|x[a-fA-F\d]{2}|u[a-fA-F\d]{4}|U[a-fA-F\d]{8}))'B?/,
      greedy: !0
    }
  });
}
iz.displayName = "factor";
iz.aliases = [];
function iz(t) {
  (function(e) {
    var n = {
      function: /\b(?:BUGS?|FIX(?:MES?)?|NOTES?|TODOS?|XX+|HACKS?|WARN(?:ING)?|\?{2,}|!{2,})\b/
    }, r = {
      number: /\\[^\s']|%\w/
    }, a = {
      comment: [
        {
          // ! single-line exclamation point comments with whitespace after/around the !
          pattern: /(^|\s)(?:! .*|!$)/,
          lookbehind: !0,
          inside: n
        },
        {
          // /* comment */, /* comment*/
          pattern: /(^|\s)\/\*\s[\s\S]*?\*\/(?=\s|$)/,
          lookbehind: !0,
          greedy: !0,
          inside: n
        },
        {
          // ![[ comment ]] , ![===[ comment]===]
          pattern: /(^|\s)!\[(={0,6})\[\s[\s\S]*?\]\2\](?=\s|$)/,
          lookbehind: !0,
          greedy: !0,
          inside: n
        }
      ],
      number: [
        {
          // basic base 10 integers 9, -9
          pattern: /(^|\s)[+-]?\d+(?=\s|$)/,
          lookbehind: !0
        },
        {
          // base prefix integers 0b010 0o70 0xad 0d10 0XAD -0xa9
          pattern: /(^|\s)[+-]?0(?:b[01]+|o[0-7]+|d\d+|x[\dA-F]+)(?=\s|$)/i,
          lookbehind: !0
        },
        {
          // fractional ratios 1/5 -1/5 and the literal float approximations 1/5. -1/5.
          pattern: /(^|\s)[+-]?\d+\/\d+\.?(?=\s|$)/,
          lookbehind: !0
        },
        {
          // positive mixed numbers 23+1/5 +23+1/5
          pattern: /(^|\s)\+?\d+\+\d+\/\d+(?=\s|$)/,
          lookbehind: !0
        },
        {
          // negative mixed numbers -23-1/5
          pattern: /(^|\s)-\d+-\d+\/\d+(?=\s|$)/,
          lookbehind: !0
        },
        {
          // basic decimal floats -0.01 0. .0 .1 -.1 -1. -12.13 +12.13
          // and scientific notation with base 10 exponents 3e4 3e-4 .3e-4
          pattern: /(^|\s)[+-]?(?:\d*\.\d+|\d+\.\d*|\d+)(?:e[+-]?\d+)?(?=\s|$)/i,
          lookbehind: !0
        },
        {
          // NAN literal syntax NAN: 80000deadbeef, NAN: a
          pattern: /(^|\s)NAN:\s+[\da-fA-F]+(?=\s|$)/,
          lookbehind: !0
        },
        {
          /*
          base prefix floats 0x1.0p3 (8.0) 0b1.010p2 (5.0) 0x1.p1 0b1.11111111p11111...
          "The normalized hex form ±0x1.MMMMMMMMMMMMM[pP]±EEEE allows any floating-point number to be specified precisely.
          The values of MMMMMMMMMMMMM and EEEE map directly to the mantissa and exponent fields of the binary IEEE 754 representation."
          <https://docs.factorcode.org/content/article-syntax-floats.html>
          */
          pattern: /(^|\s)[+-]?0(?:b1\.[01]*|o1\.[0-7]*|d1\.\d*|x1\.[\dA-F]*)p\d+(?=\s|$)/i,
          lookbehind: !0
        }
      ],
      // R/ regexp?\/\\/
      regexp: {
        pattern: /(^|\s)R\/\s(?:\\\S|[^\\/])*\/(?:[idmsr]*|[idmsr]+-[idmsr]+)(?=\s|$)/,
        lookbehind: !0,
        alias: "number",
        inside: {
          variable: /\\\S/,
          keyword: /[+?*\[\]^$(){}.|]/,
          operator: {
            pattern: /(\/)[idmsr]+(?:-[idmsr]+)?/,
            lookbehind: !0
          }
        }
      },
      boolean: {
        pattern: /(^|\s)[tf](?=\s|$)/,
        lookbehind: !0
      },
      // SBUF" asd", URL" ://...", P" /etc/"
      "custom-string": {
        pattern: /(^|\s)[A-Z0-9\-]+"\s(?:\\\S|[^"\\])*"/,
        lookbehind: !0,
        greedy: !0,
        alias: "string",
        inside: {
          number: /\\\S|%\w|\//
        }
      },
      "multiline-string": [
        {
          // STRING: name \n content \n ; -> CONSTANT: name "content" (symbol)
          pattern: /(^|\s)STRING:\s+\S+(?:\n|\r\n).*(?:\n|\r\n)\s*;(?=\s|$)/,
          lookbehind: !0,
          greedy: !0,
          alias: "string",
          inside: {
            number: r.number,
            // trailing semicolon on its own line
            "semicolon-or-setlocal": {
              pattern: /([\r\n][ \t]*);(?=\s|$)/,
              lookbehind: !0,
              alias: "function"
            }
          }
        },
        {
          // HEREDOC: marker \n content \n marker ; -> "content" (immediate)
          pattern: /(^|\s)HEREDOC:\s+\S+(?:\n|\r\n).*(?:\n|\r\n)\s*\S+(?=\s|$)/,
          lookbehind: !0,
          greedy: !0,
          alias: "string",
          inside: r
        },
        {
          // [[ string ]], [==[ string]==]
          pattern: /(^|\s)\[(={0,6})\[\s[\s\S]*?\]\2\](?=\s|$)/,
          lookbehind: !0,
          greedy: !0,
          alias: "string",
          inside: r
        }
      ],
      "special-using": {
        pattern: /(^|\s)USING:(?:\s\S+)*(?=\s+;(?:\s|$))/,
        lookbehind: !0,
        alias: "function",
        inside: {
          // this is essentially a regex for vocab names, which i don't want to specify
          // but the USING: gets picked up as a vocab name
          string: {
            pattern: /(\s)[^:\s]+/,
            lookbehind: !0
          }
        }
      },
      /* this description of stack effect literal syntax is not complete and not as specific as theoretically possible
      trying to do better is more work and regex-computation-time than it's worth though.
      - we'd like to have the "delimiter" parts of the stack effect [ (, --, and ) ] be a different (less-important or comment-like) colour to the stack effect contents
      - we'd like if nested stack effects were treated as such rather than just appearing flat (with `inside`)
      - we'd like if the following variable name conventions were recognised specifically:
      special row variables = ..a b..
      type and stack effect annotations end with a colon = ( quot: ( a: ( -- ) -- b ) -- x ), ( x: number -- )
      word throws unconditional error = *
      any other word-like variable name = a ? q' etc
      https://docs.factorcode.org/content/article-effects.html
      these are pretty complicated to highlight properly without a real parser, and therefore out of scope
      the old pattern, which may be later useful, was: (^|\s)(?:call|execute|eval)?\((?:\s+[^"\r\n\t ]\S*)*?\s+--(?:\s+[^"\n\t ]\S*)*?\s+\)(?=\s|$)
      */
      // current solution is not great
      "stack-effect-delimiter": [
        {
          // opening parenthesis
          pattern: /(^|\s)(?:call|eval|execute)?\((?=\s)/,
          lookbehind: !0,
          alias: "operator"
        },
        {
          // middle --
          pattern: /(\s)--(?=\s)/,
          lookbehind: !0,
          alias: "operator"
        },
        {
          // closing parenthesis
          pattern: /(\s)\)(?=\s|$)/,
          lookbehind: !0,
          alias: "operator"
        }
      ],
      combinators: {
        pattern: null,
        lookbehind: !0,
        alias: "keyword"
      },
      "kernel-builtin": {
        pattern: null,
        lookbehind: !0,
        alias: "variable"
      },
      "sequences-builtin": {
        pattern: null,
        lookbehind: !0,
        alias: "variable"
      },
      "math-builtin": {
        pattern: null,
        lookbehind: !0,
        alias: "variable"
      },
      "constructor-word": {
        // <array> but not <=>
        pattern: /(^|\s)<(?!=+>|-+>)\S+>(?=\s|$)/,
        lookbehind: !0,
        alias: "keyword"
      },
      "other-builtin-syntax": {
        pattern: null,
        lookbehind: !0,
        alias: "operator"
      },
      /*
      full list of supported word naming conventions: (the convention appears outside of the [brackets])
      set-[x]
      change-[x]
      with-[x]
      new-[x]
      >[string]
      [base]>
      [string]>[number]
      +[symbol]+
      [boolean-word]?
      ?[of]
      [slot-reader]>>
      >>[slot-setter]
      [slot-writer]<<
      ([implementation-detail])
      [mutater]!
      [variant]*
      [prettyprint].
      $[help-markup]
      <constructors>, SYNTAX:, etc are supported by their own patterns.
      `with` and `new` from `kernel` are their own builtins.
      see <https://docs.factorcode.org/content/article-conventions.html>
      */
      "conventionally-named-word": {
        pattern: /(^|\s)(?!")(?:(?:change|new|set|with)-\S+|\$\S+|>[^>\s]+|[^:>\s]+>|[^>\s]+>[^>\s]+|\+[^+\s]+\+|[^?\s]+\?|\?[^?\s]+|[^>\s]+>>|>>[^>\s]+|[^<\s]+<<|\([^()\s]+\)|[^!\s]+!|[^*\s]\S*\*|[^.\s]\S*\.)(?=\s|$)/,
        lookbehind: !0,
        alias: "keyword"
      },
      "colon-syntax": {
        pattern: /(^|\s)(?:[A-Z0-9\-]+#?)?:{1,2}\s+(?:;\S+|(?!;)\S+)(?=\s|$)/,
        lookbehind: !0,
        greedy: !0,
        alias: "function"
      },
      "semicolon-or-setlocal": {
        pattern: /(\s)(?:;|:>)(?=\s|$)/,
        lookbehind: !0,
        alias: "function"
      },
      // do not highlight leading } or trailing X{ at the begin/end of the file as it's invalid syntax
      "curly-brace-literal-delimiter": [
        {
          // opening
          pattern: /(^|\s)[a-z]*\{(?=\s)/i,
          lookbehind: !0,
          alias: "operator"
        },
        {
          // closing
          pattern: /(\s)\}(?=\s|$)/,
          lookbehind: !0,
          alias: "operator"
        }
      ],
      // do not highlight leading ] or trailing [ at the begin/end of the file as it's invalid syntax
      "quotation-delimiter": [
        {
          // opening
          pattern: /(^|\s)\[(?=\s)/,
          lookbehind: !0,
          alias: "operator"
        },
        {
          // closing
          pattern: /(\s)\](?=\s|$)/,
          lookbehind: !0,
          alias: "operator"
        }
      ],
      "normal-word": {
        pattern: /(^|\s)[^"\s]\S*(?=\s|$)/,
        lookbehind: !0
      },
      /*
      basic first-class string "a"
      with escaped double-quote "a\""
      escaped backslash "\\"
      and general escapes since Factor has so many "\N"
      syntax that works in the reference implementation that isn't fully
      supported because it's an implementation detail:
      "string 1""string 2" -> 2 strings (works anyway)
      "string"5 -> string, 5
      "string"[ ] -> string, quotation
      { "a"} -> array<string>
      the rest of those examples all properly recognise the string, but not
      the other object (number, quotation, etc)
      this is fine for a regex-only implementation.
      */
      string: {
        pattern: /"(?:\\\S|[^"\\])*"/,
        greedy: !0,
        inside: r
      }
    }, i = function(f) {
      return (f + "").replace(/([.?*+\^$\[\]\\(){}|\-])/g, "\\$1");
    }, o = function(f) {
      return new RegExp("(^|\\s)(?:" + f.map(i).join("|") + ")(?=\\s|$)");
    }, s = {
      "kernel-builtin": [
        "or",
        "2nipd",
        "4drop",
        "tuck",
        "wrapper",
        "nip",
        "wrapper?",
        "callstack>array",
        "die",
        "dupd",
        "callstack",
        "callstack?",
        "3dup",
        "hashcode",
        "pick",
        "4nip",
        "build",
        ">boolean",
        "nipd",
        "clone",
        "5nip",
        "eq?",
        "?",
        "=",
        "swapd",
        "2over",
        "clear",
        "2dup",
        "get-retainstack",
        "not",
        "tuple?",
        "dup",
        "3nipd",
        "call",
        "-rotd",
        "object",
        "drop",
        "assert=",
        "assert?",
        "-rot",
        "execute",
        "boa",
        "get-callstack",
        "curried?",
        "3drop",
        "pickd",
        "overd",
        "over",
        "roll",
        "3nip",
        "swap",
        "and",
        "2nip",
        "rotd",
        "throw",
        "(clone)",
        "hashcode*",
        "spin",
        "reach",
        "4dup",
        "equal?",
        "get-datastack",
        "assert",
        "2drop",
        "<wrapper>",
        "boolean?",
        "identity-hashcode",
        "identity-tuple?",
        "null",
        "composed?",
        "new",
        "5drop",
        "rot",
        "-roll",
        "xor",
        "identity-tuple",
        "boolean"
      ],
      "other-builtin-syntax": [
        // syntax
        "=======",
        "recursive",
        "flushable",
        ">>",
        "<<<<<<",
        "M\\",
        "B",
        "PRIVATE>",
        "\\",
        "======",
        "final",
        "inline",
        "delimiter",
        "deprecated",
        "<PRIVATE",
        ">>>>>>",
        "<<<<<<<",
        "parse-complex",
        "malformed-complex",
        "read-only",
        ">>>>>>>",
        "call-next-method",
        "<<",
        "foldable",
        // literals
        "$",
        "$[",
        "${"
      ],
      "sequences-builtin": [
        "member-eq?",
        "mismatch",
        "append",
        "assert-sequence=",
        "longer",
        "repetition",
        "clone-like",
        "3sequence",
        "assert-sequence?",
        "last-index-from",
        "reversed",
        "index-from",
        "cut*",
        "pad-tail",
        "join-as",
        "remove-eq!",
        "concat-as",
        "but-last",
        "snip",
        "nths",
        "nth",
        "sequence",
        "longest",
        "slice?",
        "<slice>",
        "remove-nth",
        "tail-slice",
        "empty?",
        "tail*",
        "member?",
        "virtual-sequence?",
        "set-length",
        "drop-prefix",
        "iota",
        "unclip",
        "bounds-error?",
        "unclip-last-slice",
        "non-negative-integer-expected",
        "non-negative-integer-expected?",
        "midpoint@",
        "longer?",
        "?set-nth",
        "?first",
        "rest-slice",
        "prepend-as",
        "prepend",
        "fourth",
        "sift",
        "subseq-start",
        "new-sequence",
        "?last",
        "like",
        "first4",
        "1sequence",
        "reverse",
        "slice",
        "virtual@",
        "repetition?",
        "set-last",
        "index",
        "4sequence",
        "max-length",
        "set-second",
        "immutable-sequence",
        "first2",
        "first3",
        "supremum",
        "unclip-slice",
        "suffix!",
        "insert-nth",
        "tail",
        "3append",
        "short",
        "suffix",
        "concat",
        "flip",
        "immutable?",
        "reverse!",
        "2sequence",
        "sum",
        "delete-all",
        "indices",
        "snip-slice",
        "<iota>",
        "check-slice",
        "sequence?",
        "head",
        "append-as",
        "halves",
        "sequence=",
        "collapse-slice",
        "?second",
        "slice-error?",
        "product",
        "bounds-check?",
        "bounds-check",
        "immutable",
        "virtual-exemplar",
        "harvest",
        "remove",
        "pad-head",
        "last",
        "set-fourth",
        "cartesian-product",
        "remove-eq",
        "shorten",
        "shorter",
        "reversed?",
        "shorter?",
        "shortest",
        "head-slice",
        "pop*",
        "tail-slice*",
        "but-last-slice",
        "iota?",
        "append!",
        "cut-slice",
        "new-resizable",
        "head-slice*",
        "sequence-hashcode",
        "pop",
        "set-nth",
        "?nth",
        "second",
        "join",
        "immutable-sequence?",
        "<reversed>",
        "3append-as",
        "virtual-sequence",
        "subseq?",
        "remove-nth!",
        "length",
        "last-index",
        "lengthen",
        "assert-sequence",
        "copy",
        "move",
        "third",
        "first",
        "tail?",
        "set-first",
        "prefix",
        "bounds-error",
        "<repetition>",
        "exchange",
        "surround",
        "cut",
        "min-length",
        "set-third",
        "push-all",
        "head?",
        "subseq-start-from",
        "delete-slice",
        "rest",
        "sum-lengths",
        "head*",
        "infimum",
        "remove!",
        "glue",
        "slice-error",
        "subseq",
        "push",
        "replace-slice",
        "subseq-as",
        "unclip-last"
      ],
      "math-builtin": [
        "number=",
        "next-power-of-2",
        "?1+",
        "fp-special?",
        "imaginary-part",
        "float>bits",
        "number?",
        "fp-infinity?",
        "bignum?",
        "fp-snan?",
        "denominator",
        "gcd",
        "*",
        "+",
        "fp-bitwise=",
        "-",
        "u>=",
        "/",
        ">=",
        "bitand",
        "power-of-2?",
        "log2-expects-positive",
        "neg?",
        "<",
        "log2",
        ">",
        "integer?",
        "number",
        "bits>double",
        "2/",
        "zero?",
        "bits>float",
        "float?",
        "shift",
        "ratio?",
        "rect>",
        "even?",
        "ratio",
        "fp-sign",
        "bitnot",
        ">fixnum",
        "complex?",
        "/i",
        "integer>fixnum",
        "/f",
        "sgn",
        ">bignum",
        "next-float",
        "u<",
        "u>",
        "mod",
        "recip",
        "rational",
        ">float",
        "2^",
        "integer",
        "fixnum?",
        "neg",
        "fixnum",
        "sq",
        "bignum",
        ">rect",
        "bit?",
        "fp-qnan?",
        "simple-gcd",
        "complex",
        "<fp-nan>",
        "real",
        ">fraction",
        "double>bits",
        "bitor",
        "rem",
        "fp-nan-payload",
        "real-part",
        "log2-expects-positive?",
        "prev-float",
        "align",
        "unordered?",
        "float",
        "fp-nan?",
        "abs",
        "bitxor",
        "integer>fixnum-strict",
        "u<=",
        "odd?",
        "<=",
        "/mod",
        ">integer",
        "real?",
        "rational?",
        "numerator"
      ]
      // that's all for now
    };
    Object.keys(s).forEach(function(f) {
      a[f].pattern = o(s[f]);
    });
    var u = [
      // kernel
      "2bi",
      "while",
      "2tri",
      "bi*",
      "4dip",
      "both?",
      "same?",
      "tri@",
      "curry",
      "prepose",
      "3bi",
      "?if",
      "tri*",
      "2keep",
      "3keep",
      "curried",
      "2keepd",
      "when",
      "2bi*",
      "2tri*",
      "4keep",
      "bi@",
      "keepdd",
      "do",
      "unless*",
      "tri-curry",
      "if*",
      "loop",
      "bi-curry*",
      "when*",
      "2bi@",
      "2tri@",
      "with",
      "2with",
      "either?",
      "bi",
      "until",
      "3dip",
      "3curry",
      "tri-curry*",
      "tri-curry@",
      "bi-curry",
      "keepd",
      "compose",
      "2dip",
      "if",
      "3tri",
      "unless",
      "tuple",
      "keep",
      "2curry",
      "tri",
      "most",
      "while*",
      "dip",
      "composed",
      "bi-curry@",
      // sequences
      "find-last-from",
      "trim-head-slice",
      "map-as",
      "each-from",
      "none?",
      "trim-tail",
      "partition",
      "if-empty",
      "accumulate*",
      "reject!",
      "find-from",
      "accumulate-as",
      "collector-for-as",
      "reject",
      "map",
      "map-sum",
      "accumulate!",
      "2each-from",
      "follow",
      "supremum-by",
      "map!",
      "unless-empty",
      "collector",
      "padding",
      "reduce-index",
      "replicate-as",
      "infimum-by",
      "trim-tail-slice",
      "count",
      "find-index",
      "filter",
      "accumulate*!",
      "reject-as",
      "map-integers",
      "map-find",
      "reduce",
      "selector",
      "interleave",
      "2map",
      "filter-as",
      "binary-reduce",
      "map-index-as",
      "find",
      "produce",
      "filter!",
      "replicate",
      "cartesian-map",
      "cartesian-each",
      "find-index-from",
      "map-find-last",
      "3map-as",
      "3map",
      "find-last",
      "selector-as",
      "2map-as",
      "2map-reduce",
      "accumulate",
      "each",
      "each-index",
      "accumulate*-as",
      "when-empty",
      "all?",
      "collector-as",
      "push-either",
      "new-like",
      "collector-for",
      "2selector",
      "push-if",
      "2all?",
      "map-reduce",
      "3each",
      "any?",
      "trim-slice",
      "2reduce",
      "change-nth",
      "produce-as",
      "2each",
      "trim",
      "trim-head",
      "cartesian-find",
      "map-index",
      // math
      "if-zero",
      "each-integer",
      "unless-zero",
      "(find-integer)",
      "when-zero",
      "find-last-integer",
      "(all-integers?)",
      "times",
      "(each-integer)",
      "find-integer",
      "all-integers?",
      // math.combinators
      "unless-negative",
      "if-positive",
      "when-positive",
      "when-negative",
      "unless-positive",
      "if-negative",
      // combinators
      "case",
      "2cleave",
      "cond>quot",
      "case>quot",
      "3cleave",
      "wrong-values",
      "to-fixed-point",
      "alist>quot",
      "cond",
      "cleave",
      "call-effect",
      "recursive-hashcode",
      "spread",
      "deep-spread>quot",
      // combinators.short-circuit
      "2||",
      "0||",
      "n||",
      "0&&",
      "2&&",
      "3||",
      "1||",
      "1&&",
      "n&&",
      "3&&",
      // combinators.smart
      "smart-unless*",
      "keep-inputs",
      "reduce-outputs",
      "smart-when*",
      "cleave>array",
      "smart-with",
      "smart-apply",
      "smart-if",
      "inputs/outputs",
      "output>sequence-n",
      "map-outputs",
      "map-reduce-outputs",
      "dropping",
      "output>array",
      "smart-map-reduce",
      "smart-2map-reduce",
      "output>array-n",
      "nullary",
      "input<sequence",
      "append-outputs",
      "drop-inputs",
      "inputs",
      "smart-2reduce",
      "drop-outputs",
      "smart-reduce",
      "preserving",
      "smart-when",
      "outputs",
      "append-outputs-as",
      "smart-unless",
      "smart-if*",
      "sum-outputs",
      "input<sequence-unsafe",
      "output>sequence"
      // tafn
    ];
    a.combinators.pattern = o(u), e.languages.factor = a;
  })(t);
}
oz.displayName = "false";
oz.aliases = [];
function oz(t) {
  (function(e) {
    e.languages.false = {
      comment: {
        pattern: /\{[^}]*\}/
      },
      string: {
        pattern: /"[^"]*"/,
        greedy: !0
      },
      "character-code": {
        pattern: /'(?:[^\r]|\r\n?)/,
        alias: "number"
      },
      "assembler-code": {
        pattern: /\d+`/,
        alias: "important"
      },
      number: /\d+/,
      operator: /[-!#$%&'*+,./:;=>?@\\^_`|~ßø]/,
      punctuation: /\[|\]/,
      variable: /[a-z]/,
      "non-standard": {
        pattern: /[()<BDO®]/,
        alias: "bold"
      }
    };
  })(t);
}
sz.displayName = "firestore-security-rules";
sz.aliases = [];
function sz(t) {
  t.register(Lr), t.languages["firestore-security-rules"] = t.languages.extend(
    "clike",
    {
      comment: /\/\/.*/,
      keyword: /\b(?:allow|function|if|match|null|return|rules_version|service)\b/,
      operator: /&&|\|\||[<>!=]=?|[-+*/%]|\b(?:in|is)\b/
    }
  ), delete t.languages["firestore-security-rules"]["class-name"], t.languages.insertBefore("firestore-security-rules", "keyword", {
    path: {
      pattern: /(^|[\s(),])(?:\/(?:[\w\xA0-\uFFFF]+|\{[\w\xA0-\uFFFF]+(?:=\*\*)?\}|\$\([\w\xA0-\uFFFF.]+\)))+/,
      lookbehind: !0,
      greedy: !0,
      inside: {
        variable: {
          pattern: /\{[\w\xA0-\uFFFF]+(?:=\*\*)?\}|\$\([\w\xA0-\uFFFF.]+\)/,
          inside: {
            operator: /=/,
            keyword: /\*\*/,
            punctuation: /[.$(){}]/
          }
        },
        punctuation: /\//
      }
    },
    method: {
      // to make the pattern shorter, the actual method names are omitted
      pattern: /(\ballow\s+)[a-z]+(?:\s*,\s*[a-z]+)*(?=\s*[:;])/,
      lookbehind: !0,
      alias: "builtin",
      inside: {
        punctuation: /,/
      }
    }
  });
}
lz.displayName = "flow";
lz.aliases = [];
function lz(t) {
  t.register(rl), function(e) {
    e.languages.flow = e.languages.extend("javascript", {}), e.languages.insertBefore("flow", "keyword", {
      type: [
        {
          pattern: /\b(?:[Bb]oolean|Function|[Nn]umber|[Ss]tring|[Ss]ymbol|any|mixed|null|void)\b/,
          alias: "class-name"
        }
      ]
    }), e.languages.flow["function-variable"].pattern = /(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=\s*(?:function\b|(?:\([^()]*\)(?:\s*:\s*\w+)?|(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/i, delete e.languages.flow.parameter, e.languages.insertBefore("flow", "operator", {
      "flow-punctuation": {
        pattern: /\{\||\|\}/,
        alias: "punctuation"
      }
    }), Array.isArray(e.languages.flow.keyword) || (e.languages.flow.keyword = [e.languages.flow.keyword]), e.languages.flow.keyword.unshift(
      {
        pattern: /(^|[^$]\b)(?:Class|declare|opaque|type)\b(?!\$)/,
        lookbehind: !0
      },
      {
        pattern: /(^|[^$]\B)\$(?:Diff|Enum|Exact|Keys|ObjMap|PropertyType|Record|Shape|Subtype|Supertype|await)\b(?!\$)/,
        lookbehind: !0
      }
    );
  }(t);
}
uz.displayName = "fortran";
uz.aliases = [];
function uz(t) {
  t.languages.fortran = {
    "quoted-number": {
      pattern: /[BOZ](['"])[A-F0-9]+\1/i,
      alias: "number"
    },
    string: {
      pattern: /(?:\b\w+_)?(['"])(?:\1\1|&(?:\r\n?|\n)(?:[ \t]*!.*(?:\r\n?|\n)|(?![ \t]*!))|(?!\1).)*(?:\1|&)/,
      inside: {
        comment: {
          pattern: /(&(?:\r\n?|\n)\s*)!.*/,
          lookbehind: !0
        }
      }
    },
    comment: {
      pattern: /!.*/,
      greedy: !0
    },
    boolean: /\.(?:FALSE|TRUE)\.(?:_\w+)?/i,
    number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[ED][+-]?\d+)?(?:_\w+)?/i,
    keyword: [
      // Types
      /\b(?:CHARACTER|COMPLEX|DOUBLE ?PRECISION|INTEGER|LOGICAL|REAL)\b/i,
      // END statements
      /\b(?:END ?)?(?:BLOCK ?DATA|DO|FILE|FORALL|FUNCTION|IF|INTERFACE|MODULE(?! PROCEDURE)|PROGRAM|SELECT|SUBROUTINE|TYPE|WHERE)\b/i,
      // Statements
      /\b(?:ALLOCATABLE|ALLOCATE|BACKSPACE|CALL|CASE|CLOSE|COMMON|CONTAINS|CONTINUE|CYCLE|DATA|DEALLOCATE|DIMENSION|DO|END|EQUIVALENCE|EXIT|EXTERNAL|FORMAT|GO ?TO|IMPLICIT(?: NONE)?|INQUIRE|INTENT|INTRINSIC|MODULE PROCEDURE|NAMELIST|NULLIFY|OPEN|OPTIONAL|PARAMETER|POINTER|PRINT|PRIVATE|PUBLIC|READ|RETURN|REWIND|SAVE|SELECT|STOP|TARGET|WHILE|WRITE)\b/i,
      // Others
      /\b(?:ASSIGNMENT|DEFAULT|ELEMENTAL|ELSE|ELSEIF|ELSEWHERE|ENTRY|IN|INCLUDE|INOUT|KIND|NULL|ONLY|OPERATOR|OUT|PURE|RECURSIVE|RESULT|SEQUENCE|STAT|THEN|USE)\b/i
    ],
    operator: [
      /\*\*|\/\/|=>|[=\/]=|[<>]=?|::|[+\-*=%]|\.[A-Z]+\./i,
      {
        // Use lookbehind to prevent confusion with (/ /)
        pattern: /(^|(?!\().)\/(?!\))/,
        lookbehind: !0
      }
    ],
    punctuation: /\(\/|\/\)|[(),;:&]/
  };
}
cz.displayName = "ftl";
cz.aliases = [];
function cz(t) {
  t.register(al), function(e) {
    for (var n = /[^<()"']|\((?:<expr>)*\)|<(?!#--)|<#--(?:[^-]|-(?!->))*-->|"(?:[^\\"]|\\.)*"|'(?:[^\\']|\\.)*'/.source, r = 0; r < 2; r++)
      n = n.replace(/<expr>/g, function() {
        return n;
      });
    n = n.replace(/<expr>/g, /[^\s\S]/.source);
    var a = {
      comment: /<#--[\s\S]*?-->/,
      string: [
        {
          // raw string
          pattern: /\br("|')(?:(?!\1)[^\\]|\\.)*\1/,
          greedy: !0
        },
        {
          pattern: RegExp(
            /("|')(?:(?!\1|\$\{)[^\\]|\\.|\$\{(?:(?!\})(?:<expr>))*\})*\1/.source.replace(
              /<expr>/g,
              function() {
                return n;
              }
            )
          ),
          greedy: !0,
          inside: {
            interpolation: {
              pattern: RegExp(
                /((?:^|[^\\])(?:\\\\)*)\$\{(?:(?!\})(?:<expr>))*\}/.source.replace(
                  /<expr>/g,
                  function() {
                    return n;
                  }
                )
              ),
              lookbehind: !0,
              inside: {
                "interpolation-punctuation": {
                  pattern: /^\$\{|\}$/,
                  alias: "punctuation"
                },
                rest: null
              }
            }
          }
        }
      ],
      keyword: /\b(?:as)\b/,
      boolean: /\b(?:false|true)\b/,
      "builtin-function": {
        pattern: /((?:^|[^?])\?\s*)\w+/,
        lookbehind: !0,
        alias: "function"
      },
      function: /\b\w+(?=\s*\()/,
      number: /\b\d+(?:\.\d+)?\b/,
      operator: /\.\.[<*!]?|->|--|\+\+|&&|\|\||\?{1,2}|[-+*/%!=<>]=?|\b(?:gt|gte|lt|lte)\b/,
      punctuation: /[,;.:()[\]{}]/
    };
    a.string[1].inside.interpolation.inside.rest = a, e.languages.ftl = {
      "ftl-comment": {
        // the pattern is shortened to be more efficient
        pattern: /^<#--[\s\S]*/,
        alias: "comment"
      },
      "ftl-directive": {
        pattern: /^<[\s\S]+>$/,
        inside: {
          directive: {
            pattern: /(^<\/?)[#@][a-z]\w*/i,
            lookbehind: !0,
            alias: "keyword"
          },
          punctuation: /^<\/?|\/?>$/,
          content: {
            pattern: /\s*\S[\s\S]*/,
            alias: "ftl",
            inside: a
          }
        }
      },
      "ftl-interpolation": {
        pattern: /^\$\{[\s\S]*\}$/,
        inside: {
          punctuation: /^\$\{|\}$/,
          content: {
            pattern: /\s*\S[\s\S]*/,
            alias: "ftl",
            inside: a
          }
        }
      }
    }, e.hooks.add("before-tokenize", function(i) {
      var o = RegExp(
        /<#--[\s\S]*?-->|<\/?[#@][a-zA-Z](?:<expr>)*?>|\$\{(?:<expr>)*?\}/.source.replace(
          /<expr>/g,
          function() {
            return n;
          }
        ),
        "gi"
      );
      e.languages["markup-templating"].buildPlaceholders(
        i,
        "ftl",
        o
      );
    }), e.hooks.add("after-tokenize", function(i) {
      e.languages["markup-templating"].tokenizePlaceholders(i, "ftl");
    });
  }(t);
}
fz.displayName = "gml";
fz.aliases = ["gamemakerlanguage"];
function fz(t) {
  t.register(Lr), t.languages.gamemakerlanguage = t.languages.gml = t.languages.extend("clike", {
    keyword: /\b(?:break|case|continue|default|do|else|enum|exit|for|globalvar|if|repeat|return|switch|until|var|while)\b/,
    number: /(?:\b0x[\da-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ulf]{0,4}/i,
    operator: /--|\+\+|[-+%/=]=?|!=|\*\*?=?|<[<=>]?|>[=>]?|&&?|\^\^?|\|\|?|~|\b(?:and|at|not|or|with|xor)\b/,
    constant: /\b(?:GM_build_date|GM_version|action_(?:continue|restart|reverse|stop)|all|gamespeed_(?:fps|microseconds)|global|local|noone|other|pi|pointer_(?:invalid|null)|self|timezone_(?:local|utc)|undefined|ev_(?:create|destroy|step|alarm|keyboard|mouse|collision|other|draw|draw_(?:begin|end|post|pre)|keypress|keyrelease|trigger|(?:left|middle|no|right)_button|(?:left|middle|right)_press|(?:left|middle|right)_release|mouse_(?:enter|leave|wheel_down|wheel_up)|global_(?:left|middle|right)_button|global_(?:left|middle|right)_press|global_(?:left|middle|right)_release|joystick(?:1|2)_(?:button1|button2|button3|button4|button5|button6|button7|button8|down|left|right|up)|outside|boundary|game_start|game_end|room_start|room_end|no_more_lives|animation_end|end_of_path|no_more_health|user\d|gui|gui_begin|gui_end|step_(?:begin|end|normal))|vk_(?:alt|anykey|backspace|control|delete|down|end|enter|escape|home|insert|left|nokey|pagedown|pageup|pause|printscreen|return|right|shift|space|tab|up|f\d|numpad\d|add|decimal|divide|lalt|lcontrol|lshift|multiply|ralt|rcontrol|rshift|subtract)|achievement_(?:filter_(?:all_players|favorites_only|friends_only)|friends_info|info|leaderboard_info|our_info|pic_loaded|show_(?:achievement|bank|friend_picker|leaderboard|profile|purchase_prompt|ui)|type_challenge|type_score_challenge)|asset_(?:font|object|path|room|script|shader|sound|sprite|tiles|timeline|unknown)|audio_(?:3d|falloff_(?:exponent_distance|exponent_distance_clamped|inverse_distance|inverse_distance_clamped|linear_distance|linear_distance_clamped|none)|mono|new_system|old_system|stereo)|bm_(?:add|complex|dest_alpha|dest_color|dest_colour|inv_dest_alpha|inv_dest_color|inv_dest_colour|inv_src_alpha|inv_src_color|inv_src_colour|max|normal|one|src_alpha|src_alpha_sat|src_color|src_colour|subtract|zero)|browser_(?:chrome|firefox|ie|ie_mobile|not_a_browser|opera|safari|safari_mobile|tizen|unknown|windows_store)|buffer_(?:bool|f16|f32|f64|fast|fixed|generalerror|grow|invalidtype|network|outofbounds|outofspace|s16|s32|s8|seek_end|seek_relative|seek_start|string|text|u16|u32|u64|u8|vbuffer|wrap)|c_(?:aqua|black|blue|dkgray|fuchsia|gray|green|lime|ltgray|maroon|navy|olive|orange|purple|red|silver|teal|white|yellow)|cmpfunc_(?:always|equal|greater|greaterequal|less|lessequal|never|notequal)|cr_(?:appstart|arrow|beam|cross|default|drag|handpoint|hourglass|none|size_all|size_nesw|size_ns|size_nwse|size_we|uparrow)|cull_(?:clockwise|counterclockwise|noculling)|device_(?:emulator|tablet)|device_ios_(?:ipad|ipad_retina|iphone|iphone5|iphone6|iphone6plus|iphone_retina|unknown)|display_(?:landscape|landscape_flipped|portrait|portrait_flipped)|dll_(?:cdecl|cdel|stdcall)|ds_type_(?:grid|list|map|priority|queue|stack)|ef_(?:cloud|ellipse|explosion|firework|flare|rain|ring|smoke|smokeup|snow|spark|star)|fa_(?:archive|bottom|center|directory|hidden|left|middle|readonly|right|sysfile|top|volumeid)|fb_login_(?:default|fallback_to_webview|forcing_safari|forcing_webview|no_fallback_to_webview|use_system_account)|iap_(?:available|canceled|ev_consume|ev_product|ev_purchase|ev_restore|ev_storeload|failed|purchased|refunded|status_available|status_loading|status_processing|status_restoring|status_unavailable|status_uninitialised|storeload_failed|storeload_ok|unavailable)|leaderboard_type_(?:number|time_mins_secs)|lighttype_(?:dir|point)|matrix_(?:projection|view|world)|mb_(?:any|left|middle|none|right)|network_(?:config_(?:connect_timeout|disable_reliable_udp|enable_reliable_udp|use_non_blocking_socket)|socket_(?:bluetooth|tcp|udp)|type_(?:connect|data|disconnect|non_blocking_connect))|of_challenge_(?:lose|tie|win)|os_(?:android|ios|linux|macosx|ps3|ps4|psvita|unknown|uwp|win32|win8native|windows|winphone|xboxone)|phy_debug_render_(?:aabb|collision_pairs|coms|core_shapes|joints|obb|shapes)|phy_joint_(?:anchor_1_x|anchor_1_y|anchor_2_x|anchor_2_y|angle|angle_limits|damping_ratio|frequency|length_1|length_2|lower_angle_limit|max_force|max_length|max_motor_force|max_motor_torque|max_torque|motor_force|motor_speed|motor_torque|reaction_force_x|reaction_force_y|reaction_torque|speed|translation|upper_angle_limit)|phy_particle_data_flag_(?:category|color|colour|position|typeflags|velocity)|phy_particle_flag_(?:colormixing|colourmixing|elastic|powder|spring|tensile|viscous|wall|water|zombie)|phy_particle_group_flag_(?:rigid|solid)|pr_(?:linelist|linestrip|pointlist|trianglefan|trianglelist|trianglestrip)|ps_(?:distr|shape)_(?:diamond|ellipse|gaussian|invgaussian|line|linear|rectangle)|pt_shape_(?:circle|cloud|disk|explosion|flare|line|pixel|ring|smoke|snow|spark|sphere|square|star)|ty_(?:real|string)|gp_(?:face\d|axislh|axislv|axisrh|axisrv|padd|padl|padr|padu|select|shoulderl|shoulderlb|shoulderr|shoulderrb|start|stickl|stickr)|lb_disp_(?:none|numeric|time_ms|time_sec)|lb_sort_(?:ascending|descending|none)|ov_(?:achievements|community|friends|gamegroup|players|settings)|ugc_(?:filetype_(?:community|microtrans)|list_(?:Favorited|Followed|Published|Subscribed|UsedOrPlayed|VotedDown|VotedOn|VotedUp|WillVoteLater)|match_(?:AllGuides|Artwork|Collections|ControllerBindings|IntegratedGuides|Items|Items_Mtx|Items_ReadyToUse|Screenshots|UsableInGame|Videos|WebGuides)|query_(?:AcceptedForGameRankedByAcceptanceDate|CreatedByFriendsRankedByPublicationDate|FavoritedByFriendsRankedByPublicationDate|NotYetRated)|query_RankedBy(?:NumTimesReported|PublicationDate|TextSearch|TotalVotesAsc|Trend|Vote|VotesUp)|result_success|sortorder_CreationOrder(?:Asc|Desc)|sortorder_(?:ForModeration|LastUpdatedDesc|SubscriptionDateDesc|TitleAsc|VoteScoreDesc)|visibility_(?:friends_only|private|public))|vertex_usage_(?:binormal|blendindices|blendweight|color|colour|depth|fog|normal|position|psize|sample|tangent|texcoord|textcoord)|vertex_type_(?:float\d|color|colour|ubyte4)|input_type|layerelementtype_(?:background|instance|oldtilemap|particlesystem|sprite|tile|tilemap|undefined)|se_(?:chorus|compressor|echo|equalizer|flanger|gargle|none|reverb)|text_type|tile_(?:flip|index_mask|mirror|rotate)|(?:obj|rm|scr|spr)\w+)\b/,
    variable: /\b(?:alarm|application_surface|async_load|background_(?:alpha|blend|color|colour|foreground|height|hspeed|htiled|index|showcolor|showcolour|visible|vspeed|vtiled|width|x|xscale|y|yscale)|bbox_(?:bottom|left|right|top)|browser_(?:height|width)|caption_(?:health|lives|score)|current_(?:day|hour|minute|month|second|time|weekday|year)|cursor_sprite|debug_mode|delta_time|direction|display_aa|error_(?:last|occurred)|event_(?:action|number|object|type)|fps|fps_real|friction|game_(?:display|project|save)_(?:id|name)|gamemaker_(?:pro|registered|version)|gravity|gravity_direction|(?:h|v)speed|health|iap_data|id|image_(?:alpha|angle|blend|depth|index|number|speed|xscale|yscale)|instance_(?:count|id)|keyboard_(?:key|lastchar|lastkey|string)|layer|lives|mask_index|mouse_(?:button|lastbutton|x|y)|object_index|os_(?:browser|device|type|version)|path_(?:endaction|index|orientation|position|positionprevious|scale|speed)|persistent|phy_(?:rotation|(?:col_normal|collision|com|linear_velocity|position|speed)_(?:x|y)|angular_(?:damping|velocity)|position_(?:x|y)previous|speed|linear_damping|bullet|fixed_rotation|active|mass|inertia|dynamic|kinematic|sleeping|collision_points)|pointer_(?:invalid|null)|room|room_(?:caption|first|height|last|persistent|speed|width)|score|secure_mode|show_(?:health|lives|score)|solid|speed|sprite_(?:height|index|width|xoffset|yoffset)|temp_directory|timeline_(?:index|loop|position|running|speed)|transition_(?:color|kind|steps)|undefined|view_(?:angle|current|enabled|(?:h|v)(?:border|speed)|(?:h|w|x|y)port|(?:h|w|x|y)view|object|surface_id|visible)|visible|webgl_enabled|working_directory|(?:x|y)(?:previous|start)|x|y|argument(?:_relitive|_count|\d)|argument|global|local|other|self)\b/
  });
}
dz.displayName = "gap";
dz.aliases = [];
function dz(t) {
  t.languages.gap = {
    shell: {
      pattern: /^gap>[\s\S]*?(?=^gap>|$(?![\s\S]))/m,
      greedy: !0,
      inside: {
        gap: {
          pattern: /^(gap>).+(?:(?:\r(?:\n|(?!\n))|\n)>.*)*/,
          lookbehind: !0,
          inside: null
          // see below
        },
        punctuation: /^gap>/
      }
    },
    comment: {
      pattern: /#.*/,
      greedy: !0
    },
    string: {
      pattern: /(^|[^\\'"])(?:'(?:[^\r\n\\']|\\.){1,10}'|"(?:[^\r\n\\"]|\\.)*"(?!")|"""[\s\S]*?""")/,
      lookbehind: !0,
      greedy: !0,
      inside: {
        continuation: {
          pattern: /([\r\n])>/,
          lookbehind: !0,
          alias: "punctuation"
        }
      }
    },
    keyword: /\b(?:Assert|Info|IsBound|QUIT|TryNextMethod|Unbind|and|atomic|break|continue|do|elif|else|end|fi|for|function|if|in|local|mod|not|od|or|quit|readonly|readwrite|rec|repeat|return|then|until|while)\b/,
    boolean: /\b(?:false|true)\b/,
    function: /\b[a-z_]\w*(?=\s*\()/i,
    number: {
      pattern: /(^|[^\w.]|\.\.)(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?(?:_[a-z]?)?(?=$|[^\w.]|\.\.)/,
      lookbehind: !0
    },
    continuation: {
      pattern: /([\r\n])>/,
      lookbehind: !0,
      alias: "punctuation"
    },
    operator: /->|[-+*/^~=!]|<>|[<>]=?|:=|\.\./,
    punctuation: /[()[\]{},;.:]/
  }, t.languages.gap.shell.inside.gap.inside = t.languages.gap;
}
pz.displayName = "gcode";
pz.aliases = [];
function pz(t) {
  t.languages.gcode = {
    comment: /;.*|\B\(.*?\)\B/,
    string: {
      pattern: /"(?:""|[^"])*"/,
      greedy: !0
    },
    keyword: /\b[GM]\d+(?:\.\d+)?\b/,
    property: /\b[A-Z]/,
    checksum: {
      pattern: /(\*)\d+/,
      lookbehind: !0,
      alias: "number"
    },
    // T0:0:0
    punctuation: /[:*]/
  };
}
hz.displayName = "gdscript";
hz.aliases = [];
function hz(t) {
  t.languages.gdscript = {
    comment: /#.*/,
    string: {
      pattern: /@?(?:("|')(?:(?!\1)[^\n\\]|\\[\s\S])*\1(?!"|')|"""(?:[^\\]|\\[\s\S])*?""")/,
      greedy: !0
    },
    "class-name": {
      // class_name Foo, extends Bar, class InnerClass
      // export(int) var baz, export(int, 0) var i
      // as Node
      // const FOO: int = 9, var bar: bool = true
      // func add(reference: Item, amount: int) -> Item:
      pattern: /(^(?:class|class_name|extends)[ \t]+|^export\([ \t]*|\bas[ \t]+|(?:\b(?:const|var)[ \t]|[,(])[ \t]*\w+[ \t]*:[ \t]*|->[ \t]*)[a-zA-Z_]\w*/m,
      lookbehind: !0
    },
    keyword: /\b(?:and|as|assert|break|breakpoint|class|class_name|const|continue|elif|else|enum|export|extends|for|func|if|in|is|master|mastersync|match|not|null|onready|or|pass|preload|puppet|puppetsync|remote|remotesync|return|self|setget|signal|static|tool|var|while|yield)\b/,
    function: /\b[a-z_]\w*(?=[ \t]*\()/i,
    variable: /\$\w+/,
    number: [
      /\b0b[01_]+\b|\b0x[\da-fA-F_]+\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.[\d_]+)(?:e[+-]?[\d_]+)?\b/,
      /\b(?:INF|NAN|PI|TAU)\b/
    ],
    constant: /\b[A-Z][A-Z_\d]*\b/,
    boolean: /\b(?:false|true)\b/,
    operator: /->|:=|&&|\|\||<<|>>|[-+*/%&|!<>=]=?|[~^]/,
    punctuation: /[.:,;()[\]{}]/
  };
}
mz.displayName = "gedcom";
mz.aliases = [];
function mz(t) {
  t.languages.gedcom = {
    "line-value": {
      // Preceded by level, optional pointer, and tag
      pattern: /(^[\t ]*\d+ +(?:@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@ +)?\w+ ).+/m,
      lookbehind: !0,
      inside: {
        pointer: {
          pattern: /^@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@$/,
          alias: "variable"
        }
      }
    },
    record: {
      // Preceded by level and optional pointer
      pattern: /(^[\t ]*\d+ +(?:@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@ +)?)\w+/m,
      lookbehind: !0,
      alias: "tag"
    },
    level: {
      pattern: /(^[\t ]*)\d+/m,
      lookbehind: !0,
      alias: "number"
    },
    pointer: {
      pattern: /@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@/,
      alias: "variable"
    }
  };
}
gz.displayName = "gettext";
gz.aliases = ["po"];
function gz(t) {
  t.languages.gettext = {
    comment: [
      {
        pattern: /# .*/,
        greedy: !0,
        alias: "translator-comment"
      },
      {
        pattern: /#\..*/,
        greedy: !0,
        alias: "extracted-comment"
      },
      {
        pattern: /#:.*/,
        greedy: !0,
        alias: "reference-comment"
      },
      {
        pattern: /#,.*/,
        greedy: !0,
        alias: "flag-comment"
      },
      {
        pattern: /#\|.*/,
        greedy: !0,
        alias: "previously-untranslated-comment"
      },
      {
        pattern: /#.*/,
        greedy: !0
      }
    ],
    string: {
      pattern: /(^|[^\\])"(?:[^"\\]|\\.)*"/,
      lookbehind: !0,
      greedy: !0
    },
    keyword: /^msg(?:ctxt|id|id_plural|str)\b/m,
    number: /\b\d+\b/,
    punctuation: /[\[\]]/
  }, t.languages.po = t.languages.gettext;
}
bz.displayName = "gherkin";
bz.aliases = [];
function bz(t) {
  (function(e) {
    var n = /(?:\r?\n|\r)[ \t]*\|.+\|(?:(?!\|).)*/.source;
    e.languages.gherkin = {
      pystring: {
        pattern: /("""|''')[\s\S]+?\1/,
        alias: "string"
      },
      comment: {
        pattern: /(^[ \t]*)#.*/m,
        lookbehind: !0
      },
      tag: {
        pattern: /(^[ \t]*)@\S*/m,
        lookbehind: !0
      },
      feature: {
        pattern: /((?:^|\r?\n|\r)[ \t]*)(?:Ability|Ahoy matey!|Arwedd|Aspekt|Besigheid Behoefte|Business Need|Caracteristica|Característica|Egenskab|Egenskap|Eiginleiki|Feature|Fīča|Fitur|Fonctionnalité|Fonksyonalite|Funcionalidade|Funcionalitat|Functionalitate|Funcţionalitate|Funcționalitate|Functionaliteit|Fungsi|Funkcia|Funkcija|Funkcionalitāte|Funkcionalnost|Funkcja|Funksie|Funktionalität|Funktionalitéit|Funzionalità|Hwaet|Hwæt|Jellemző|Karakteristik|Lastnost|Mak|Mogucnost|laH|Mogućnost|Moznosti|Možnosti|OH HAI|Omadus|Ominaisuus|Osobina|Özellik|Potrzeba biznesowa|perbogh|poQbogh malja'|Požadavek|Požiadavka|Pretty much|Qap|Qu'meH 'ut|Savybė|Tính năng|Trajto|Vermoë|Vlastnosť|Właściwość|Značilnost|Δυνατότητα|Λειτουργία|Могућност|Мөмкинлек|Особина|Свойство|Үзенчәлеклелек|Функционал|Функционалност|Функция|Функціонал|תכונה|خاصية|خصوصیت|صلاحیت|کاروبار کی ضرورت|وِیژگی|रूप लेख|ਖਾਸੀਅਤ|ਨਕਸ਼ ਨੁਹਾਰ|ਮੁਹਾਂਦਰਾ|గుణము|ಹೆಚ್ಚಳ|ความต้องการทางธุรกิจ|ความสามารถ|โครงหลัก|기능|フィーチャ|功能|機能):(?:[^:\r\n]+(?:\r?\n|\r|$))*/,
        lookbehind: !0,
        inside: {
          important: {
            pattern: /(:)[^\r\n]+/,
            lookbehind: !0
          },
          keyword: /[^:\r\n]+:/
        }
      },
      scenario: {
        pattern: /(^[ \t]*)(?:Abstract Scenario|Abstrakt Scenario|Achtergrond|Aer|Ær|Agtergrond|All y'all|Antecedentes|Antecedents|Atburðarás|Atburðarásir|Awww, look mate|B4|Background|Baggrund|Bakgrund|Bakgrunn|Bakgrunnur|Beispiele|Beispiller|Bối cảnh|Cefndir|Cenario|Cenário|Cenario de Fundo|Cenário de Fundo|Cenarios|Cenários|Contesto|Context|Contexte|Contexto|Conto|Contoh|Contone|Dæmi|Dasar|Dead men tell no tales|Delineacao do Cenario|Delineação do Cenário|Dis is what went down|Dữ liệu|Dyagram Senaryo|Dyagram senaryo|Egzanp|Ejemplos|Eksempler|Ekzemploj|Enghreifftiau|Esbozo do escenario|Escenari|Escenario|Esempi|Esquema de l'escenari|Esquema del escenario|Esquema do Cenario|Esquema do Cenário|EXAMPLZ|Examples|Exempel|Exemple|Exemples|Exemplos|First off|Fono|Forgatókönyv|Forgatókönyv vázlat|Fundo|Geçmiş|Grundlage|Hannergrond|ghantoH|Háttér|Heave to|Istorik|Juhtumid|Keadaan|Khung kịch bản|Khung tình huống|Kịch bản|Koncept|Konsep skenario|Kontèks|Kontekst|Kontekstas|Konteksts|Kontext|Konturo de la scenaro|Latar Belakang|lut chovnatlh|lut|lutmey|Lýsing Atburðarásar|Lýsing Dæma|MISHUN SRSLY|MISHUN|Menggariskan Senario|mo'|Náčrt Scenára|Náčrt Scénáře|Náčrt Scenáru|Oris scenarija|Örnekler|Osnova|Osnova Scenára|Osnova scénáře|Osnutek|Ozadje|Paraugs|Pavyzdžiai|Példák|Piemēri|Plan du scénario|Plan du Scénario|Plan Senaryo|Plan senaryo|Plang vum Szenario|Pozadí|Pozadie|Pozadina|Príklady|Příklady|Primer|Primeri|Primjeri|Przykłady|Raamstsenaarium|Reckon it's like|Rerefons|Scenár|Scénář|Scenarie|Scenarij|Scenarijai|Scenarijaus šablonas|Scenariji|Scenārijs|Scenārijs pēc parauga|Scenarijus|Scenario|Scénario|Scenario Amlinellol|Scenario Outline|Scenario Template|Scenariomal|Scenariomall|Scenarios|Scenariu|Scenariusz|Scenaro|Schema dello scenario|Se ðe|Se the|Se þe|Senario|Senaryo Deskripsyon|Senaryo deskripsyon|Senaryo|Senaryo taslağı|Shiver me timbers|Situācija|Situai|Situasie Uiteensetting|Situasie|Skenario konsep|Skenario|Skica|Structura scenariu|Structură scenariu|Struktura scenarija|Stsenaarium|Swa hwaer swa|Swa|Swa hwær swa|Szablon scenariusza|Szenario|Szenariogrundriss|Tapaukset|Tapaus|Tapausaihio|Taust|Tausta|Template Keadaan|Template Senario|Template Situai|The thing of it is|Tình huống|Variantai|Voorbeelde|Voorbeelden|Wharrimean is|Yo-ho-ho|You'll wanna|Założenia|Παραδείγματα|Περιγραφή Σεναρίου|Σενάρια|Σενάριο|Υπόβαθρο|Кереш|Контекст|Концепт|Мисаллар|Мисоллар|Основа|Передумова|Позадина|Предистория|Предыстория|Приклади|Пример|Примери|Примеры|Рамка на сценарий|Скица|Структура сценарија|Структура сценария|Структура сценарію|Сценарий|Сценарий структураси|Сценарийның төзелеше|Сценарији|Сценарио|Сценарій|Тарих|Үрнәкләр|דוגמאות|רקע|תבנית תרחיש|תרחיש|الخلفية|الگوی سناریو|امثلة|پس منظر|زمینه|سناریو|سيناريو|سيناريو مخطط|مثالیں|منظر نامے کا خاکہ|منظرنامہ|نمونه ها|उदाहरण|परिदृश्य|परिदृश्य रूपरेखा|पृष्ठभूमि|ਉਦਾਹਰਨਾਂ|ਪਟਕਥਾ|ਪਟਕਥਾ ਢਾਂਚਾ|ਪਟਕਥਾ ਰੂਪ ਰੇਖਾ|ਪਿਛੋਕੜ|ఉదాహరణలు|కథనం|నేపథ్యం|సన్నివేశం|ಉದಾಹರಣೆಗಳು|ಕಥಾಸಾರಾಂಶ|ವಿವರಣೆ|ಹಿನ್ನೆಲೆ|โครงสร้างของเหตุการณ์|ชุดของตัวอย่าง|ชุดของเหตุการณ์|แนวคิด|สรุปเหตุการณ์|เหตุการณ์|배경|시나리오|시나리오 개요|예|サンプル|シナリオ|シナリオアウトライン|シナリオテンプレ|シナリオテンプレート|テンプレ|例|例子|剧本|剧本大纲|劇本|劇本大綱|场景|场景大纲|場景|場景大綱|背景):[^:\r\n]*/m,
        lookbehind: !0,
        inside: {
          important: {
            pattern: /(:)[^\r\n]*/,
            lookbehind: !0
          },
          keyword: /[^:\r\n]+:/
        }
      },
      "table-body": {
        // Look-behind is used to skip the table head, which has the same format as any table row
        pattern: RegExp("(" + n + ")(?:" + n + ")+"),
        lookbehind: !0,
        inside: {
          outline: {
            pattern: /<[^>]+>/,
            alias: "variable"
          },
          td: {
            pattern: /\s*[^\s|][^|]*/,
            alias: "string"
          },
          punctuation: /\|/
        }
      },
      "table-head": {
        pattern: RegExp(n),
        inside: {
          th: {
            pattern: /\s*[^\s|][^|]*/,
            alias: "variable"
          },
          punctuation: /\|/
        }
      },
      atrule: {
        pattern: /(^[ \t]+)(?:'a|'ach|'ej|7|a|A také|A taktiež|A tiež|A zároveň|Aber|Ac|Adott|Akkor|Ak|Aleshores|Ale|Ali|Allora|Alors|Als|Ama|Amennyiben|Amikor|Ampak|an|AN|Ananging|And y'all|And|Angenommen|Anrhegedig a|An|Apabila|Atès|Atesa|Atunci|Avast!|Aye|A|awer|Bagi|Banjur|Bet|Biết|Blimey!|Buh|But at the end of the day I reckon|But y'all|But|BUT|Cal|Când|Cand|Cando|Ce|Cuando|Če|Ða ðe|Ða|Dadas|Dada|Dados|Dado|DaH ghu' bejlu'|dann|Dann|Dano|Dan|Dar|Dat fiind|Data|Date fiind|Date|Dati fiind|Dati|Daţi fiind|Dați fiind|DEN|Dato|De|Den youse gotta|Dengan|Diberi|Diyelim ki|Donada|Donat|Donitaĵo|Do|Dun|Duota|Ðurh|Eeldades|Ef|Eğer ki|Entao|Então|Entón|E|En|Entonces|Epi|És|Etant donnée|Etant donné|Et|Étant données|Étant donnée|Étant donné|Etant données|Etant donnés|Étant donnés|Fakat|Gangway!|Gdy|Gegeben seien|Gegeben sei|Gegeven|Gegewe|ghu' noblu'|Gitt|Given y'all|Given|Givet|Givun|Ha|Cho|I CAN HAZ|In|Ir|It's just unbelievable|I|Ja|Jeśli|Jeżeli|Kad|Kada|Kadar|Kai|Kaj|Když|Keď|Kemudian|Ketika|Khi|Kiedy|Ko|Kuid|Kui|Kun|Lan|latlh|Le sa a|Let go and haul|Le|Lè sa a|Lè|Logo|Lorsqu'<|Lorsque|mä|Maar|Mais|Mając|Ma|Majd|Maka|Manawa|Mas|Men|Menawa|Mutta|Nalika|Nalikaning|Nanging|Når|När|Nato|Nhưng|Niin|Njuk|O zaman|Och|Og|Oletetaan|Ond|Onda|Oraz|Pak|Pero|Però|Podano|Pokiaľ|Pokud|Potem|Potom|Privzeto|Pryd|Quan|Quand|Quando|qaSDI'|Så|Sed|Se|Siis|Sipoze ke|Sipoze Ke|Sipoze|Si|Şi|Și|Soit|Stel|Tada|Tad|Takrat|Tak|Tapi|Ter|Tetapi|Tha the|Tha|Then y'all|Then|Thì|Thurh|Toda|Too right|Un|Und|ugeholl|Và|vaj|Vendar|Ve|wann|Wanneer|WEN|Wenn|When y'all|When|Wtedy|Wun|Y'know|Yeah nah|Yna|Youse know like when|Youse know when youse got|Y|Za predpokladu|Za předpokladu|Zadan|Zadani|Zadano|Zadate|Zadato|Zakładając|Zaradi|Zatati|Þa þe|Þa|Þá|Þegar|Þurh|Αλλά|Δεδομένου|Και|Όταν|Τότε|А також|Агар|Але|Али|Аммо|А|Әгәр|Әйтик|Әмма|Бирок|Ва|Вә|Дадено|Дано|Допустим|Если|Задате|Задати|Задато|И|І|К тому же|Када|Кад|Когато|Когда|Коли|Ләкин|Лекин|Нәтиҗәдә|Нехай|Но|Онда|Припустимо, що|Припустимо|Пусть|Также|Та|Тогда|Тоді|То|Унда|Һәм|Якщо|אבל|אזי|אז|בהינתן|וגם|כאשר|آنگاه|اذاً|اگر|اما|اور|با فرض|بالفرض|بفرض|پھر|تب|ثم|جب|عندما|فرض کیا|لكن|لیکن|متى|هنگامی|و|अगर|और|कदा|किन्तु|चूंकि|जब|तथा|तदा|तब|परन्तु|पर|यदि|ਅਤੇ|ਜਦੋਂ|ਜਿਵੇਂ ਕਿ|ਜੇਕਰ|ਤਦ|ਪਰ|అప్పుడు|ఈ పరిస్థితిలో|కాని|చెప్పబడినది|మరియు|ಆದರೆ|ನಂತರ|ನೀಡಿದ|ಮತ್ತು|ಸ್ಥಿತಿಯನ್ನು|กำหนดให้|ดังนั้น|แต่|เมื่อ|และ|그러면<|그리고<|단<|만약<|만일<|먼저<|조건<|하지만<|かつ<|しかし<|ただし<|ならば<|もし<|並且<|但し<|但是<|假如<|假定<|假設<|假设<|前提<|同时<|同時<|并且<|当<|當<|而且<|那么<|那麼<)(?=[ \t])/m,
        lookbehind: !0
      },
      string: {
        pattern: /"(?:\\.|[^"\\\r\n])*"|'(?:\\.|[^'\\\r\n])*'/,
        inside: {
          outline: {
            pattern: /<[^>]+>/,
            alias: "variable"
          }
        }
      },
      outline: {
        pattern: /<[^>]+>/,
        alias: "variable"
      }
    };
  })(t);
}
vz.displayName = "git";
vz.aliases = [];
function vz(t) {
  t.languages.git = {
    /*
     * A simple one line comment like in a git status command
     * For instance:
     * $ git status
     * # On branch infinite-scroll
     * # Your branch and 'origin/sharedBranches/frontendTeam/infinite-scroll' have diverged,
     * # and have 1 and 2 different commits each, respectively.
     * nothing to commit (working directory clean)
     */
    comment: /^#.*/m,
    /*
     * Regexp to match the changed lines in a git diff output. Check the example below.
     */
    deleted: /^[-–].*/m,
    inserted: /^\+.*/m,
    /*
     * a string (double and simple quote)
     */
    string: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
    /*
     * a git command. It starts with a random prompt finishing by a $, then "git" then some other parameters
     * For instance:
     * $ git add file.txt
     */
    command: {
      pattern: /^.*\$ git .*$/m,
      inside: {
        /*
         * A git command can contain a parameter starting by a single or a double dash followed by a string
         * For instance:
         * $ git diff --cached
         * $ git log -p
         */
        parameter: /\s--?\w+/
      }
    },
    /*
     * Coordinates displayed in a git diff command
     * For instance:
     * $ git diff
     * diff --git file.txt file.txt
     * index 6214953..1d54a52 100644
     * --- file.txt
     * +++ file.txt
     * @@ -1 +1,2 @@
     * -Here's my tetx file
     * +Here's my text file
     * +And this is the second line
     */
    coord: /^@@.*@@$/m,
    /*
     * Match a "commit [SHA1]" line in a git log output.
     * For instance:
     * $ git log
     * commit a11a14ef7e26f2ca62d4b35eac455ce636d0dc09
     * Author: lgiraudel
     * Date:   Mon Feb 17 11:18:34 2014 +0100
     *
     *     Add of a new line
     */
    "commit-sha1": /^commit \w{40}$/m
  };
}
yz.displayName = "glsl";
yz.aliases = [];
function yz(t) {
  t.register(tp), t.languages.glsl = t.languages.extend("c", {
    keyword: /\b(?:active|asm|atomic_uint|attribute|[ibdu]?vec[234]|bool|break|buffer|case|cast|centroid|class|coherent|common|const|continue|d?mat[234](?:x[234])?|default|discard|do|double|else|enum|extern|external|false|filter|fixed|flat|float|for|fvec[234]|goto|half|highp|hvec[234]|[iu]?sampler2DMS(?:Array)?|[iu]?sampler2DRect|[iu]?samplerBuffer|[iu]?samplerCube|[iu]?samplerCubeArray|[iu]?sampler[123]D|[iu]?sampler[12]DArray|[iu]?image2DMS(?:Array)?|[iu]?image2DRect|[iu]?imageBuffer|[iu]?imageCube|[iu]?imageCubeArray|[iu]?image[123]D|[iu]?image[12]DArray|if|in|inline|inout|input|int|interface|invariant|layout|long|lowp|mediump|namespace|noinline|noperspective|out|output|partition|patch|precise|precision|public|readonly|resource|restrict|return|sample|sampler[12]DArrayShadow|sampler[12]DShadow|sampler2DRectShadow|sampler3DRect|samplerCubeArrayShadow|samplerCubeShadow|shared|short|sizeof|smooth|static|struct|subroutine|superp|switch|template|this|true|typedef|uint|uniform|union|unsigned|using|varying|void|volatile|while|writeonly)\b/
  });
}
Oz.displayName = "gn";
Oz.aliases = ["gni"];
function Oz(t) {
  t.languages.gn = {
    comment: {
      pattern: /#.*/,
      greedy: !0
    },
    "string-literal": {
      pattern: /(^|[^\\"])"(?:[^\r\n"\\]|\\.)*"/,
      lookbehind: !0,
      greedy: !0,
      inside: {
        interpolation: {
          pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:\{[\s\S]*?\}|[a-zA-Z_]\w*|0x[a-fA-F0-9]{2})/,
          lookbehind: !0,
          inside: {
            number: /^\$0x[\s\S]{2}$/,
            variable: /^\$\w+$/,
            "interpolation-punctuation": {
              pattern: /^\$\{|\}$/,
              alias: "punctuation"
            },
            expression: {
              pattern: /[\s\S]+/,
              inside: null
              // see below
            }
          }
        },
        string: /[\s\S]+/
      }
    },
    keyword: /\b(?:else|if)\b/,
    boolean: /\b(?:false|true)\b/,
    "builtin-function": {
      // a few functions get special highlighting to improve readability
      pattern: /\b(?:assert|defined|foreach|import|pool|print|template|tool|toolchain)(?=\s*\()/i,
      alias: "keyword"
    },
    function: /\b[a-z_]\w*(?=\s*\()/i,
    constant: /\b(?:current_cpu|current_os|current_toolchain|default_toolchain|host_cpu|host_os|root_build_dir|root_gen_dir|root_out_dir|target_cpu|target_gen_dir|target_os|target_out_dir)\b/,
    number: /-?\b\d+\b/,
    operator: /[-+!=<>]=?|&&|\|\|/,
    punctuation: /[(){}[\],.]/
  }, t.languages.gn["string-literal"].inside.interpolation.inside.expression.inside = t.languages.gn, t.languages.gni = t.languages.gn;
}
Ez.displayName = "linker-script";
Ez.aliases = ["ld"];
function Ez(t) {
  t.languages["linker-script"] = {
    comment: {
      pattern: /(^|\s)\/\*[\s\S]*?(?:$|\*\/)/,
      lookbehind: !0,
      greedy: !0
    },
    identifier: {
      pattern: /"[^"\r\n]*"/,
      greedy: !0
    },
    "location-counter": {
      pattern: /\B\.\B/,
      alias: "important"
    },
    section: {
      pattern: /(^|[^\w*])\.\w+\b/,
      lookbehind: !0,
      alias: "keyword"
    },
    function: /\b[A-Z][A-Z_]*(?=\s*\()/,
    number: /\b(?:0[xX][a-fA-F0-9]+|\d+)[KM]?\b/,
    operator: />>=?|<<=?|->|\+\+|--|&&|\|\||::|[?:~]|[-+*/%&|^!=<>]=?/,
    punctuation: /[(){},;]/
  }, t.languages.ld = t.languages["linker-script"];
}
Sz.displayName = "go-module";
Sz.aliases = ["go-mod"];
function Sz(t) {
  t.languages["go-mod"] = t.languages["go-module"] = {
    comment: {
      pattern: /\/\/.*/,
      greedy: !0
    },
    version: {
      pattern: /(^|[\s()[\],])v\d+\.\d+\.\d+(?:[+-][-+.\w]*)?(?![^\s()[\],])/,
      lookbehind: !0,
      alias: "number"
    },
    "go-version": {
      pattern: /((?:^|\s)go\s+)\d+(?:\.\d+){1,2}/,
      lookbehind: !0,
      alias: "number"
    },
    keyword: {
      pattern: /^([ \t]*)(?:exclude|go|module|replace|require|retract)\b/m,
      lookbehind: !0
    },
    operator: /=>/,
    punctuation: /[()[\],]/
  };
}
wz.displayName = "gradle";
wz.aliases = [];
function wz(t) {
  t.register(Lr), function(e) {
    var n = {
      pattern: /((?:^|[^\\$])(?:\\{2})*)\$(?:\w+|\{[^{}]*\})/,
      lookbehind: !0,
      inside: {
        "interpolation-punctuation": {
          pattern: /^\$\{?|\}$/,
          alias: "punctuation"
        },
        expression: {
          pattern: /[\s\S]+/,
          inside: null
        }
      }
    };
    e.languages.gradle = e.languages.extend("clike", {
      string: {
        pattern: /'''(?:[^\\]|\\[\s\S])*?'''|'(?:\\.|[^\\'\r\n])*'/,
        greedy: !0
      },
      keyword: /\b(?:apply|def|dependencies|else|if|implementation|import|plugin|plugins|project|repositories|repository|sourceSets|tasks|val)\b/,
      number: /\b(?:0b[01_]+|0x[\da-f_]+(?:\.[\da-f_p\-]+)?|[\d_]+(?:\.[\d_]+)?(?:e[+-]?\d+)?)[glidf]?\b/i,
      operator: {
        pattern: /(^|[^.])(?:~|==?~?|\?[.:]?|\*(?:[.=]|\*=?)?|\.[@&]|\.\.<|\.\.(?!\.)|-[-=>]?|\+[+=]?|!=?|<(?:<=?|=>?)?|>(?:>>?=?|=)?|&[&=]?|\|[|=]?|\/=?|\^=?|%=?)/,
        lookbehind: !0
      },
      punctuation: /\.+|[{}[\];(),:$]/
    }), e.languages.insertBefore("gradle", "string", {
      shebang: {
        pattern: /#!.+/,
        alias: "comment",
        greedy: !0
      },
      "interpolation-string": {
        pattern: /"""(?:[^\\]|\\[\s\S])*?"""|(["/])(?:\\.|(?!\1)[^\\\r\n])*\1|\$\/(?:[^/$]|\$(?:[/$]|(?![/$]))|\/(?!\$))*\/\$/,
        greedy: !0,
        inside: {
          interpolation: n,
          string: /[\s\S]+/
        }
      }
    }), e.languages.insertBefore("gradle", "punctuation", {
      "spock-block": /\b(?:and|cleanup|expect|given|setup|then|when|where):/
    }), e.languages.insertBefore("gradle", "function", {
      annotation: {
        pattern: /(^|[^.])@\w+/,
        lookbehind: !0,
        alias: "punctuation"
      }
    }), n.inside.expression.inside = e.languages.gradle;
  }(t);
}
Tz.displayName = "graphql";
Tz.aliases = [];
function Tz(t) {
  t.languages.graphql = {
    comment: /#.*/,
    description: {
      pattern: /(?:"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*")(?=\s*[a-z_])/i,
      greedy: !0,
      alias: "string",
      inside: {
        "language-markdown": {
          pattern: /(^"(?:"")?)(?!\1)[\s\S]+(?=\1$)/,
          lookbehind: !0,
          inside: t.languages.markdown
        }
      }
    },
    string: {
      pattern: /"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*"/,
      greedy: !0
    },
    number: /(?:\B-|\b)\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
    boolean: /\b(?:false|true)\b/,
    variable: /\$[a-z_]\w*/i,
    directive: {
      pattern: /@[a-z_]\w*/i,
      alias: "function"
    },
    "attr-name": {
      pattern: /\b[a-z_]\w*(?=\s*(?:\((?:[^()"]|"(?:\\.|[^\\"\r\n])*")*\))?:)/i,
      greedy: !0
    },
    "atom-input": {
      pattern: /\b[A-Z]\w*Input\b/,
      alias: "class-name"
    },
    scalar: /\b(?:Boolean|Float|ID|Int|String)\b/,
    constant: /\b[A-Z][A-Z_\d]*\b/,
    "class-name": {
      pattern: /(\b(?:enum|implements|interface|on|scalar|type|union)\s+|&\s*|:\s*|\[)[A-Z_]\w*/,
      lookbehind: !0
    },
    fragment: {
      pattern: /(\bfragment\s+|\.{3}\s*(?!on\b))[a-zA-Z_]\w*/,
      lookbehind: !0,
      alias: "function"
    },
    "definition-mutation": {
      pattern: /(\bmutation\s+)[a-zA-Z_]\w*/,
      lookbehind: !0,
      alias: "function"
    },
    "definition-query": {
      pattern: /(\bquery\s+)[a-zA-Z_]\w*/,
      lookbehind: !0,
      alias: "function"
    },
    keyword: /\b(?:directive|enum|extend|fragment|implements|input|interface|mutation|on|query|repeatable|scalar|schema|subscription|type|union)\b/,
    operator: /[!=|&]|\.{3}/,
    "property-query": /\w+(?=\s*\()/,
    object: /\w+(?=\s*\{)/,
    punctuation: /[!(){}\[\]:=,]/,
    property: /\w+/
  }, t.hooks.add("after-tokenize", function(n) {
    if (n.language !== "graphql")
      return;
    var r = n.tokens.filter(function(C) {
      return typeof C != "string" && C.type !== "comment" && C.type !== "scalar";
    }), a = 0;
    function i(C) {
      return r[a + C];
    }
    function o(C, A) {
      A = A || 0;
      for (var N = 0; N < C.length; N++) {
        var P = i(N + A);
        if (!P || P.type !== C[N])
          return !1;
      }
      return !0;
    }
    function s(C, A) {
      for (var N = 1, P = a; P < r.length; P++) {
        var I = r[P], D = I.content;
        if (I.type === "punctuation" && typeof D == "string") {
          if (C.test(D))
            N++;
          else if (A.test(D) && (N--, N === 0))
            return P;
        }
      }
      return -1;
    }
    function u(C, A) {
      var N = C.alias;
      N ? Array.isArray(N) || (C.alias = N = [N]) : C.alias = N = [], N.push(A);
    }
    for (; a < r.length; ) {
      var f = r[a++];
      if (f.type === "keyword" && f.content === "mutation") {
        var p = [];
        if (o(["definition-mutation", "punctuation"]) && i(1).content === "(") {
          a += 2;
          var m = s(/^\($/, /^\)$/);
          if (m === -1)
            continue;
          for (; a < m; a++) {
            var v = i(0);
            v.type === "variable" && (u(v, "variable-input"), p.push(v.content));
          }
          a = m + 1;
        }
        if (o(["punctuation", "property-query"]) && i(0).content === "{" && (a++, u(i(0), "property-mutation"), p.length > 0)) {
          var O = s(/^\{$/, /^\}$/);
          if (O === -1)
            continue;
          for (var w = a; w < O; w++) {
            var _ = r[w];
            _.type === "variable" && p.indexOf(_.content) >= 0 && u(_, "variable-input");
          }
        }
      }
    }
  });
}
_z.displayName = "groovy";
_z.aliases = [];
function _z(t) {
  t.register(Lr), function(e) {
    var n = {
      pattern: /((?:^|[^\\$])(?:\\{2})*)\$(?:\w+|\{[^{}]*\})/,
      lookbehind: !0,
      inside: {
        "interpolation-punctuation": {
          pattern: /^\$\{?|\}$/,
          alias: "punctuation"
        },
        expression: {
          pattern: /[\s\S]+/,
          inside: null
          // see below
        }
      }
    };
    e.languages.groovy = e.languages.extend("clike", {
      string: {
        // https://groovy-lang.org/syntax.html#_dollar_slashy_string
        pattern: /'''(?:[^\\]|\\[\s\S])*?'''|'(?:\\.|[^\\'\r\n])*'/,
        greedy: !0
      },
      keyword: /\b(?:abstract|as|assert|boolean|break|byte|case|catch|char|class|const|continue|def|default|do|double|else|enum|extends|final|finally|float|for|goto|if|implements|import|in|instanceof|int|interface|long|native|new|package|private|protected|public|return|short|static|strictfp|super|switch|synchronized|this|throw|throws|trait|transient|try|void|volatile|while)\b/,
      number: /\b(?:0b[01_]+|0x[\da-f_]+(?:\.[\da-f_p\-]+)?|[\d_]+(?:\.[\d_]+)?(?:e[+-]?\d+)?)[glidf]?\b/i,
      operator: {
        pattern: /(^|[^.])(?:~|==?~?|\?[.:]?|\*(?:[.=]|\*=?)?|\.[@&]|\.\.<|\.\.(?!\.)|-[-=>]?|\+[+=]?|!=?|<(?:<=?|=>?)?|>(?:>>?=?|=)?|&[&=]?|\|[|=]?|\/=?|\^=?|%=?)/,
        lookbehind: !0
      },
      punctuation: /\.+|[{}[\];(),:$]/
    }), e.languages.insertBefore("groovy", "string", {
      shebang: {
        pattern: /#!.+/,
        alias: "comment",
        greedy: !0
      },
      "interpolation-string": {
        // TODO: Slash strings (e.g. /foo/) can contain line breaks but this will cause a lot of trouble with
        // simple division (see JS regex), so find a fix maybe?
        pattern: /"""(?:[^\\]|\\[\s\S])*?"""|(["/])(?:\\.|(?!\1)[^\\\r\n])*\1|\$\/(?:[^/$]|\$(?:[/$]|(?![/$]))|\/(?!\$))*\/\$/,
        greedy: !0,
        inside: {
          interpolation: n,
          string: /[\s\S]+/
        }
      }
    }), e.languages.insertBefore("groovy", "punctuation", {
      "spock-block": /\b(?:and|cleanup|expect|given|setup|then|when|where):/
    }), e.languages.insertBefore("groovy", "function", {
      annotation: {
        pattern: /(^|[^.])@\w+/,
        lookbehind: !0,
        alias: "punctuation"
      }
    }), n.inside.expression.inside = e.languages.groovy;
  }(t);
}
Cz.displayName = "textile";
Cz.aliases = [];
function Cz(t) {
  t.register(ws), function(e) {
    var n = /\([^|()\n]+\)|\[[^\]\n]+\]|\{[^}\n]+\}/.source, r = /\)|\((?![^|()\n]+\))/.source;
    function a(m, v) {
      return RegExp(
        m.replace(/<MOD>/g, function() {
          return "(?:" + n + ")";
        }).replace(/<PAR>/g, function() {
          return "(?:" + r + ")";
        }),
        v || ""
      );
    }
    var i = {
      css: {
        pattern: /\{[^{}]+\}/,
        inside: {
          rest: e.languages.css
        }
      },
      "class-id": {
        pattern: /(\()[^()]+(?=\))/,
        lookbehind: !0,
        alias: "attr-value"
      },
      lang: {
        pattern: /(\[)[^\[\]]+(?=\])/,
        lookbehind: !0,
        alias: "attr-value"
      },
      // Anything else is punctuation (the first pattern is for row/col spans inside tables)
      punctuation: /[\\\/]\d+|\S/
    }, o = e.languages.textile = e.languages.extend("markup", {
      phrase: {
        pattern: /(^|\r|\n)\S[\s\S]*?(?=$|\r?\n\r?\n|\r\r)/,
        lookbehind: !0,
        inside: {
          // h1. Header 1
          "block-tag": {
            pattern: a(/^[a-z]\w*(?:<MOD>|<PAR>|[<>=])*\./.source),
            inside: {
              modifier: {
                pattern: a(
                  /(^[a-z]\w*)(?:<MOD>|<PAR>|[<>=])+(?=\.)/.source
                ),
                lookbehind: !0,
                inside: i
              },
              tag: /^[a-z]\w*/,
              punctuation: /\.$/
            }
          },
          // # List item
          // * List item
          list: {
            pattern: a(/^[*#]+<MOD>*\s+\S.*/.source, "m"),
            inside: {
              modifier: {
                pattern: a(/(^[*#]+)<MOD>+/.source),
                lookbehind: !0,
                inside: i
              },
              punctuation: /^[*#]+/
            }
          },
          // | cell | cell | cell |
          table: {
            // Modifiers can be applied to the row: {color:red}.|1|2|3|
            // or the cell: |{color:red}.1|2|3|
            pattern: a(
              /^(?:(?:<MOD>|<PAR>|[<>=^~])+\.\s*)?(?:\|(?:(?:<MOD>|<PAR>|[<>=^~_]|[\\/]\d+)+\.|(?!(?:<MOD>|<PAR>|[<>=^~_]|[\\/]\d+)+\.))[^|]*)+\|/.source,
              "m"
            ),
            inside: {
              modifier: {
                // Modifiers for rows after the first one are
                // preceded by a pipe and a line feed
                pattern: a(
                  /(^|\|(?:\r?\n|\r)?)(?:<MOD>|<PAR>|[<>=^~_]|[\\/]\d+)+(?=\.)/.source
                ),
                lookbehind: !0,
                inside: i
              },
              punctuation: /\||^\./
            }
          },
          inline: {
            // eslint-disable-next-line regexp/no-super-linear-backtracking
            pattern: a(
              /(^|[^a-zA-Z\d])(\*\*|__|\?\?|[*_%@+\-^~])<MOD>*.+?\2(?![a-zA-Z\d])/.source
            ),
            lookbehind: !0,
            inside: {
              // Note: superscripts and subscripts are not handled specifically
              // *bold*, **bold**
              bold: {
                // eslint-disable-next-line regexp/no-super-linear-backtracking
                pattern: a(/(^(\*\*?)<MOD>*).+?(?=\2)/.source),
                lookbehind: !0
              },
              // _italic_, __italic__
              italic: {
                // eslint-disable-next-line regexp/no-super-linear-backtracking
                pattern: a(/(^(__?)<MOD>*).+?(?=\2)/.source),
                lookbehind: !0
              },
              // ??cite??
              cite: {
                // eslint-disable-next-line regexp/no-super-linear-backtracking
                pattern: a(/(^\?\?<MOD>*).+?(?=\?\?)/.source),
                lookbehind: !0,
                alias: "string"
              },
              // @code@
              code: {
                // eslint-disable-next-line regexp/no-super-linear-backtracking
                pattern: a(/(^@<MOD>*).+?(?=@)/.source),
                lookbehind: !0,
                alias: "keyword"
              },
              // +inserted+
              inserted: {
                // eslint-disable-next-line regexp/no-super-linear-backtracking
                pattern: a(/(^\+<MOD>*).+?(?=\+)/.source),
                lookbehind: !0
              },
              // -deleted-
              deleted: {
                // eslint-disable-next-line regexp/no-super-linear-backtracking
                pattern: a(/(^-<MOD>*).+?(?=-)/.source),
                lookbehind: !0
              },
              // %span%
              span: {
                // eslint-disable-next-line regexp/no-super-linear-backtracking
                pattern: a(/(^%<MOD>*).+?(?=%)/.source),
                lookbehind: !0
              },
              modifier: {
                pattern: a(
                  /(^\*\*|__|\?\?|[*_%@+\-^~])<MOD>+/.source
                ),
                lookbehind: !0,
                inside: i
              },
              punctuation: /[*_%?@+\-^~]+/
            }
          },
          // [alias]http://example.com
          "link-ref": {
            pattern: /^\[[^\]]+\]\S+$/m,
            inside: {
              string: {
                pattern: /(^\[)[^\]]+(?=\])/,
                lookbehind: !0
              },
              url: {
                pattern: /(^\])\S+$/,
                lookbehind: !0
              },
              punctuation: /[\[\]]/
            }
          },
          // "text":http://example.com
          // "text":link-ref
          link: {
            // eslint-disable-next-line regexp/no-super-linear-backtracking
            pattern: a(
              /"<MOD>*[^"]+":.+?(?=[^\w/]?(?:\s|$))/.source
            ),
            inside: {
              text: {
                // eslint-disable-next-line regexp/no-super-linear-backtracking
                pattern: a(/(^"<MOD>*)[^"]+(?=")/.source),
                lookbehind: !0
              },
              modifier: {
                pattern: a(/(^")<MOD>+/.source),
                lookbehind: !0,
                inside: i
              },
              url: {
                pattern: /(:).+/,
                lookbehind: !0
              },
              punctuation: /[":]/
            }
          },
          // !image.jpg!
          // !image.jpg(Title)!:http://example.com
          image: {
            pattern: a(
              /!(?:<MOD>|<PAR>|[<>=])*(?![<>=])[^!\s()]+(?:\([^)]+\))?!(?::.+?(?=[^\w/]?(?:\s|$)))?/.source
            ),
            inside: {
              source: {
                pattern: a(
                  /(^!(?:<MOD>|<PAR>|[<>=])*)(?![<>=])[^!\s()]+(?:\([^)]+\))?(?=!)/.source
                ),
                lookbehind: !0,
                alias: "url"
              },
              modifier: {
                pattern: a(/(^!)(?:<MOD>|<PAR>|[<>=])+/.source),
                lookbehind: !0,
                inside: i
              },
              url: {
                pattern: /(:).+/,
                lookbehind: !0
              },
              punctuation: /[!:]/
            }
          },
          // Footnote[1]
          footnote: {
            pattern: /\b\[\d+\]/,
            alias: "comment",
            inside: {
              punctuation: /\[|\]/
            }
          },
          // CSS(Cascading Style Sheet)
          acronym: {
            pattern: /\b[A-Z\d]+\([^)]+\)/,
            inside: {
              comment: {
                pattern: /(\()[^()]+(?=\))/,
                lookbehind: !0
              },
              punctuation: /[()]/
            }
          },
          // Prism(C)
          mark: {
            pattern: /\b\((?:C|R|TM)\)/,
            alias: "comment",
            inside: {
              punctuation: /[()]/
            }
          }
        }
      }
    }), s = o.phrase.inside, u = {
      inline: s.inline,
      link: s.link,
      image: s.image,
      footnote: s.footnote,
      acronym: s.acronym,
      mark: s.mark
    };
    o.tag.pattern = /<\/?(?!\d)[a-z0-9]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/i;
    var f = s.inline.inside;
    f.bold.inside = u, f.italic.inside = u, f.inserted.inside = u, f.deleted.inside = u, f.span.inside = u;
    var p = s.table.inside;
    p.inline = u.inline, p.link = u.link, p.image = u.image, p.footnote = u.footnote, p.acronym = u.acronym, p.mark = u.mark;
  }(t);
}
xz.displayName = "haml";
xz.aliases = [];
function xz(t) {
  t.register(I0), function(e) {
    e.languages.haml = {
      // Multiline stuff should appear before the rest
      "multiline-comment": {
        pattern: /((?:^|\r?\n|\r)([\t ]*))(?:\/|-#).*(?:(?:\r?\n|\r)\2[\t ].+)*/,
        lookbehind: !0,
        alias: "comment"
      },
      "multiline-code": [
        {
          pattern: /((?:^|\r?\n|\r)([\t ]*)(?:[~-]|[&!]?=)).*,[\t ]*(?:(?:\r?\n|\r)\2[\t ].*,[\t ]*)*(?:(?:\r?\n|\r)\2[\t ].+)/,
          lookbehind: !0,
          inside: e.languages.ruby
        },
        {
          pattern: /((?:^|\r?\n|\r)([\t ]*)(?:[~-]|[&!]?=)).*\|[\t ]*(?:(?:\r?\n|\r)\2[\t ].*\|[\t ]*)*/,
          lookbehind: !0,
          inside: e.languages.ruby
        }
      ],
      // See at the end of the file for known filters
      filter: {
        pattern: /((?:^|\r?\n|\r)([\t ]*)):[\w-]+(?:(?:\r?\n|\r)(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/,
        lookbehind: !0,
        inside: {
          "filter-name": {
            pattern: /^:[\w-]+/,
            alias: "symbol"
          }
        }
      },
      markup: {
        pattern: /((?:^|\r?\n|\r)[\t ]*)<.+/,
        lookbehind: !0,
        inside: e.languages.markup
      },
      doctype: {
        pattern: /((?:^|\r?\n|\r)[\t ]*)!!!(?: .+)?/,
        lookbehind: !0
      },
      tag: {
        // Allows for one nested group of braces
        pattern: /((?:^|\r?\n|\r)[\t ]*)[%.#][\w\-#.]*[\w\-](?:\([^)]+\)|\{(?:\{[^}]+\}|[^{}])+\}|\[[^\]]+\])*[\/<>]*/,
        lookbehind: !0,
        inside: {
          attributes: [
            {
              // Lookbehind tries to prevent interpolations from breaking it all
              // Allows for one nested group of braces
              pattern: /(^|[^#])\{(?:\{[^}]+\}|[^{}])+\}/,
              lookbehind: !0,
              inside: e.languages.ruby
            },
            {
              pattern: /\([^)]+\)/,
              inside: {
                "attr-value": {
                  pattern: /(=\s*)(?:"(?:\\.|[^\\"\r\n])*"|[^)\s]+)/,
                  lookbehind: !0
                },
                "attr-name": /[\w:-]+(?=\s*!?=|\s*[,)])/,
                punctuation: /[=(),]/
              }
            },
            {
              pattern: /\[[^\]]+\]/,
              inside: e.languages.ruby
            }
          ],
          punctuation: /[<>]/
        }
      },
      code: {
        pattern: /((?:^|\r?\n|\r)[\t ]*(?:[~-]|[&!]?=)).+/,
        lookbehind: !0,
        inside: e.languages.ruby
      },
      // Interpolations in plain text
      interpolation: {
        pattern: /#\{[^}]+\}/,
        inside: {
          delimiter: {
            pattern: /^#\{|\}$/,
            alias: "punctuation"
          },
          ruby: {
            pattern: /[\s\S]+/,
            inside: e.languages.ruby
          }
        }
      },
      punctuation: {
        pattern: /((?:^|\r?\n|\r)[\t ]*)[~=\-&!]+/,
        lookbehind: !0
      }
    };
    for (var n = "((?:^|\\r?\\n|\\r)([\\t ]*)):{{filter_name}}(?:(?:\\r?\\n|\\r)(?:\\2[\\t ].+|\\s*?(?=\\r?\\n|\\r)))+", r = [
      "css",
      {
        filter: "coffee",
        language: "coffeescript"
      },
      "erb",
      "javascript",
      "less",
      "markdown",
      "ruby",
      "scss",
      "textile"
    ], a = {}, i = 0, o = r.length; i < o; i++) {
      var s = r[i];
      s = typeof s == "string" ? {
        filter: s,
        language: s
      } : s, e.languages[s.language] && (a["filter-" + s.filter] = {
        pattern: RegExp(
          n.replace("{{filter_name}}", function() {
            return s.filter;
          })
        ),
        lookbehind: !0,
        inside: {
          "filter-name": {
            pattern: /^:[\w-]+/,
            alias: "symbol"
          },
          text: {
            pattern: /[\s\S]+/,
            alias: [s.language, "language-" + s.language],
            inside: e.languages[s.language]
          }
        }
      });
    }
    e.languages.insertBefore("haml", "filter", a);
  }(t);
}
Az.displayName = "handlebars";
Az.aliases = ["hbs", "mustache"];
function Az(t) {
  t.register(al), function(e) {
    e.languages.handlebars = {
      comment: /\{\{![\s\S]*?\}\}/,
      delimiter: {
        pattern: /^\{\{\{?|\}\}\}?$/,
        alias: "punctuation"
      },
      string: /(["'])(?:\\.|(?!\1)[^\\\r\n])*\1/,
      number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][+-]?\d+)?/,
      boolean: /\b(?:false|true)\b/,
      block: {
        pattern: /^(\s*(?:~\s*)?)[#\/]\S+?(?=\s*(?:~\s*)?$|\s)/,
        lookbehind: !0,
        alias: "keyword"
      },
      brackets: {
        pattern: /\[[^\]]+\]/,
        inside: {
          punctuation: /\[|\]/,
          variable: /[\s\S]+/
        }
      },
      punctuation: /[!"#%&':()*+,.\/;<=>@\[\\\]^`{|}~]/,
      variable: /[^!"#%&'()*+,\/;<=>@\[\\\]^`{|}~\s]+/
    }, e.hooks.add("before-tokenize", function(n) {
      var r = /\{\{\{[\s\S]+?\}\}\}|\{\{[\s\S]+?\}\}/g;
      e.languages["markup-templating"].buildPlaceholders(
        n,
        "handlebars",
        r
      );
    }), e.hooks.add("after-tokenize", function(n) {
      e.languages["markup-templating"].tokenizePlaceholders(
        n,
        "handlebars"
      );
    }), e.languages.hbs = e.languages.handlebars, e.languages.mustache = e.languages.handlebars;
  }(t);
}
P_.displayName = "haskell";
P_.aliases = ["hs"];
function P_(t) {
  t.languages.haskell = {
    comment: {
      pattern: /(^|[^-!#$%*+=?&@|~.:<>^\\\/])(?:--(?:(?=.)[^-!#$%*+=?&@|~.:<>^\\\/].*|$)|\{-[\s\S]*?-\})/m,
      lookbehind: !0
    },
    char: {
      pattern: /'(?:[^\\']|\\(?:[abfnrtv\\"'&]|\^[A-Z@[\]^_]|ACK|BEL|BS|CAN|CR|DC1|DC2|DC3|DC4|DEL|DLE|EM|ENQ|EOT|ESC|ETB|ETX|FF|FS|GS|HT|LF|NAK|NUL|RS|SI|SO|SOH|SP|STX|SUB|SYN|US|VT|\d+|o[0-7]+|x[0-9a-fA-F]+))'/,
      alias: "string"
    },
    string: {
      pattern: /"(?:[^\\"]|\\(?:\S|\s+\\))*"/,
      greedy: !0
    },
    keyword: /\b(?:case|class|data|deriving|do|else|if|in|infixl|infixr|instance|let|module|newtype|of|primitive|then|type|where)\b/,
    "import-statement": {
      // The imported or hidden names are not included in this import
      // statement. This is because we want to highlight those exactly like
      // we do for the names in the program.
      pattern: /(^[\t ]*)import\s+(?:qualified\s+)?(?:[A-Z][\w']*)(?:\.[A-Z][\w']*)*(?:\s+as\s+(?:[A-Z][\w']*)(?:\.[A-Z][\w']*)*)?(?:\s+hiding\b)?/m,
      lookbehind: !0,
      inside: {
        keyword: /\b(?:as|hiding|import|qualified)\b/,
        punctuation: /\./
      }
    },
    // These are builtin variables only. Constructors are highlighted later as a constant.
    builtin: /\b(?:abs|acos|acosh|all|and|any|appendFile|approxRational|asTypeOf|asin|asinh|atan|atan2|atanh|basicIORun|break|catch|ceiling|chr|compare|concat|concatMap|const|cos|cosh|curry|cycle|decodeFloat|denominator|digitToInt|div|divMod|drop|dropWhile|either|elem|encodeFloat|enumFrom|enumFromThen|enumFromThenTo|enumFromTo|error|even|exp|exponent|fail|filter|flip|floatDigits|floatRadix|floatRange|floor|fmap|foldl|foldl1|foldr|foldr1|fromDouble|fromEnum|fromInt|fromInteger|fromIntegral|fromRational|fst|gcd|getChar|getContents|getLine|group|head|id|inRange|index|init|intToDigit|interact|ioError|isAlpha|isAlphaNum|isAscii|isControl|isDenormalized|isDigit|isHexDigit|isIEEE|isInfinite|isLower|isNaN|isNegativeZero|isOctDigit|isPrint|isSpace|isUpper|iterate|last|lcm|length|lex|lexDigits|lexLitChar|lines|log|logBase|lookup|map|mapM|mapM_|max|maxBound|maximum|maybe|min|minBound|minimum|mod|negate|not|notElem|null|numerator|odd|or|ord|otherwise|pack|pi|pred|primExitWith|print|product|properFraction|putChar|putStr|putStrLn|quot|quotRem|range|rangeSize|read|readDec|readFile|readFloat|readHex|readIO|readInt|readList|readLitChar|readLn|readOct|readParen|readSigned|reads|readsPrec|realToFrac|recip|rem|repeat|replicate|return|reverse|round|scaleFloat|scanl|scanl1|scanr|scanr1|seq|sequence|sequence_|show|showChar|showInt|showList|showLitChar|showParen|showSigned|showString|shows|showsPrec|significand|signum|sin|sinh|snd|sort|span|splitAt|sqrt|subtract|succ|sum|tail|take|takeWhile|tan|tanh|threadToIOResult|toEnum|toInt|toInteger|toLower|toRational|toUpper|truncate|uncurry|undefined|unlines|until|unwords|unzip|unzip3|userError|words|writeFile|zip|zip3|zipWith|zipWith3)\b/,
    // decimal integers and floating point numbers | octal integers | hexadecimal integers
    number: /\b(?:\d+(?:\.\d+)?(?:e[+-]?\d+)?|0o[0-7]+|0x[0-9a-f]+)\b/i,
    operator: [
      {
        // infix operator
        pattern: /`(?:[A-Z][\w']*\.)*[_a-z][\w']*`/,
        greedy: !0
      },
      {
        // function composition
        pattern: /(\s)\.(?=\s)/,
        lookbehind: !0
      },
      // Most of this is needed because of the meaning of a single '.'.
      // If it stands alone freely, it is the function composition.
      // It may also be a separator between a module name and an identifier => no
      // operator. If it comes together with other special characters it is an
      // operator too.
      //
      // This regex means: /[-!#$%*+=?&@|~.:<>^\\\/]+/ without /\./.
      /[-!#$%*+=?&@|~:<>^\\\/][-!#$%*+=?&@|~.:<>^\\\/]*|\.[-!#$%*+=?&@|~.:<>^\\\/]+/
    ],
    // In Haskell, nearly everything is a variable, do not highlight these.
    hvariable: {
      pattern: /\b(?:[A-Z][\w']*\.)*[_a-z][\w']*/,
      inside: {
        punctuation: /\./
      }
    },
    constant: {
      pattern: /\b(?:[A-Z][\w']*\.)*[A-Z][\w']*/,
      inside: {
        punctuation: /\./
      }
    },
    punctuation: /[{}[\];(),.:]/
  }, t.languages.hs = t.languages.haskell;
}
kz.displayName = "haxe";
kz.aliases = [];
function kz(t) {
  t.register(Lr), t.languages.haxe = t.languages.extend("clike", {
    string: {
      // Strings can be multi-line
      pattern: /"(?:[^"\\]|\\[\s\S])*"/,
      greedy: !0
    },
    "class-name": [
      {
        pattern: /(\b(?:abstract|class|enum|extends|implements|interface|new|typedef)\s+)[A-Z_]\w*/,
        lookbehind: !0
      },
      // based on naming convention
      /\b[A-Z]\w*/
    ],
    // The final look-ahead prevents highlighting of keywords if expressions such as "haxe.macro.Expr"
    keyword: /\bthis\b|\b(?:abstract|as|break|case|cast|catch|class|continue|default|do|dynamic|else|enum|extends|extern|final|for|from|function|if|implements|import|in|inline|interface|macro|new|null|operator|overload|override|package|private|public|return|static|super|switch|throw|to|try|typedef|untyped|using|var|while)(?!\.)\b/,
    function: {
      pattern: /\b[a-z_]\w*(?=\s*(?:<[^<>]*>\s*)?\()/i,
      greedy: !0
    },
    operator: /\.{3}|\+\+|--|&&|\|\||->|=>|(?:<<?|>{1,3}|[-+*/%!=&|^])=?|[?:~]/
  }), t.languages.insertBefore("haxe", "string", {
    "string-interpolation": {
      pattern: /'(?:[^'\\]|\\[\s\S])*'/,
      greedy: !0,
      inside: {
        interpolation: {
          pattern: /(^|[^\\])\$(?:\w+|\{[^{}]+\})/,
          lookbehind: !0,
          inside: {
            "interpolation-punctuation": {
              pattern: /^\$\{?|\}$/,
              alias: "punctuation"
            },
            expression: {
              pattern: /[\s\S]+/,
              inside: t.languages.haxe
            }
          }
        },
        string: /[\s\S]+/
      }
    }
  }), t.languages.insertBefore("haxe", "class-name", {
    regex: {
      pattern: /~\/(?:[^\/\\\r\n]|\\.)+\/[a-z]*/,
      greedy: !0,
      inside: {
        "regex-flags": /\b[a-z]+$/,
        "regex-source": {
          pattern: /^(~\/)[\s\S]+(?=\/$)/,
          lookbehind: !0,
          alias: "language-regex",
          inside: t.languages.regex
        },
        "regex-delimiter": /^~\/|\/$/
      }
    }
  }), t.languages.insertBefore("haxe", "keyword", {
    preprocessor: {
      pattern: /#(?:else|elseif|end|if)\b.*/,
      alias: "property"
    },
    metadata: {
      pattern: /@:?[\w.]+/,
      alias: "symbol"
    },
    reification: {
      pattern: /\$(?:\w+|(?=\{))/,
      alias: "important"
    }
  });
}
Rz.displayName = "hcl";
Rz.aliases = [];
function Rz(t) {
  t.languages.hcl = {
    comment: /(?:\/\/|#).*|\/\*[\s\S]*?(?:\*\/|$)/,
    heredoc: {
      pattern: /<<-?(\w+\b)[\s\S]*?^[ \t]*\1/m,
      greedy: !0,
      alias: "string"
    },
    keyword: [
      {
        pattern: /(?:data|resource)\s+(?:"(?:\\[\s\S]|[^\\"])*")(?=\s+"[\w-]+"\s+\{)/i,
        inside: {
          type: {
            pattern: /(resource|data|\s+)(?:"(?:\\[\s\S]|[^\\"])*")/i,
            lookbehind: !0,
            alias: "variable"
          }
        }
      },
      {
        pattern: /(?:backend|module|output|provider|provisioner|variable)\s+(?:[\w-]+|"(?:\\[\s\S]|[^\\"])*")\s+(?=\{)/i,
        inside: {
          type: {
            pattern: /(backend|module|output|provider|provisioner|variable)\s+(?:[\w-]+|"(?:\\[\s\S]|[^\\"])*")\s+/i,
            lookbehind: !0,
            alias: "variable"
          }
        }
      },
      /[\w-]+(?=\s+\{)/
    ],
    property: [/[-\w\.]+(?=\s*=(?!=))/, /"(?:\\[\s\S]|[^\\"])+"(?=\s*[:=])/],
    string: {
      pattern: /"(?:[^\\$"]|\\[\s\S]|\$(?:(?=")|\$+(?!\$)|[^"${])|\$\{(?:[^{}"]|"(?:[^\\"]|\\[\s\S])*")*\})*"/,
      greedy: !0,
      inside: {
        interpolation: {
          pattern: /(^|[^$])\$\{(?:[^{}"]|"(?:[^\\"]|\\[\s\S])*")*\}/,
          lookbehind: !0,
          inside: {
            type: {
              pattern: /(\b(?:count|data|local|module|path|self|terraform|var)\b\.)[\w\*]+/i,
              lookbehind: !0,
              alias: "variable"
            },
            keyword: /\b(?:count|data|local|module|path|self|terraform|var)\b/i,
            function: /\w+(?=\()/,
            string: {
              pattern: /"(?:\\[\s\S]|[^\\"])*"/,
              greedy: !0
            },
            number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?(?:e[+-]?\d+)?/i,
            punctuation: /[!\$#%&'()*+,.\/;<=>@\[\\\]^`{|}~?:]/
          }
        }
      }
    },
    number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?(?:e[+-]?\d+)?/i,
    boolean: /\b(?:false|true)\b/i,
    punctuation: /[=\[\]{}]/
  };
}
Iz.displayName = "hlsl";
Iz.aliases = [];
function Iz(t) {
  t.register(tp), t.languages.hlsl = t.languages.extend("c", {
    // Regarding keywords and class names:
    // The list of all keywords was split into 'keyword' and 'class-name' tokens based on whether they are capitalized.
    // https://docs.microsoft.com/en-us/windows/win32/direct3dhlsl/dx-graphics-hlsl-appendix-keywords
    // https://docs.microsoft.com/en-us/windows/win32/direct3dhlsl/dx-graphics-hlsl-appendix-reserved-words
    "class-name": [
      t.languages.c["class-name"],
      /\b(?:AppendStructuredBuffer|BlendState|Buffer|ByteAddressBuffer|CompileShader|ComputeShader|ConsumeStructuredBuffer|DepthStencilState|DepthStencilView|DomainShader|GeometryShader|Hullshader|InputPatch|LineStream|OutputPatch|PixelShader|PointStream|RWBuffer|RWByteAddressBuffer|RWStructuredBuffer|RWTexture(?:1D|1DArray|2D|2DArray|3D)|RasterizerState|RenderTargetView|SamplerComparisonState|SamplerState|StructuredBuffer|Texture(?:1D|1DArray|2D|2DArray|2DMS|2DMSArray|3D|Cube|CubeArray)|TriangleStream|VertexShader)\b/
    ],
    keyword: [
      // HLSL keyword
      /\b(?:asm|asm_fragment|auto|break|case|catch|cbuffer|centroid|char|class|column_major|compile|compile_fragment|const|const_cast|continue|default|delete|discard|do|dynamic_cast|else|enum|explicit|export|extern|for|friend|fxgroup|goto|groupshared|if|in|inline|inout|interface|line|lineadj|linear|long|matrix|mutable|namespace|new|nointerpolation|noperspective|operator|out|packoffset|pass|pixelfragment|point|precise|private|protected|public|register|reinterpret_cast|return|row_major|sample|sampler|shared|short|signed|sizeof|snorm|stateblock|stateblock_state|static|static_cast|string|struct|switch|tbuffer|technique|technique10|technique11|template|texture|this|throw|triangle|triangleadj|try|typedef|typename|uniform|union|unorm|unsigned|using|vector|vertexfragment|virtual|void|volatile|while)\b/,
      // scalar, vector, and matrix types
      /\b(?:bool|double|dword|float|half|int|min(?:10float|12int|16(?:float|int|uint))|uint)(?:[1-4](?:x[1-4])?)?\b/
    ],
    // https://docs.microsoft.com/en-us/windows/win32/direct3dhlsl/dx-graphics-hlsl-appendix-grammar#floating-point-numbers
    number: /(?:(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[eE][+-]?\d+)?|\b0x[\da-fA-F]+)[fFhHlLuU]?\b/,
    boolean: /\b(?:false|true)\b/
  });
}
Dz.displayName = "hoon";
Dz.aliases = [];
function Dz(t) {
  t.languages.hoon = {
    comment: {
      pattern: /::.*/,
      greedy: !0
    },
    string: {
      pattern: /"(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*'/,
      greedy: !0
    },
    constant: /%(?:\.[ny]|[\w-]+)/,
    "class-name": /@(?:[a-z0-9-]*[a-z0-9])?|\*/i,
    function: /(?:\+[-+] {2})?(?:[a-z](?:[a-z0-9-]*[a-z0-9])?)/,
    keyword: /\.[\^\+\*=\?]|![><:\.=\?!]|=[>|:,\.\-\^<+;/~\*\?]|\?[>|:\.\-\^<\+&~=@!]|\|[\$_%:\.\-\^~\*=@\?]|\+[|\$\+\*]|:[_\-\^\+~\*]|%[_:\.\-\^\+~\*=]|\^[|:\.\-\+&~\*=\?]|\$[|_%:<>\-\^&~@=\?]|;[:<\+;\/~\*=]|~[>|\$_%<\+\/&=\?!]|--|==/
  };
}
Nz.displayName = "hpkp";
Nz.aliases = [];
function Nz(t) {
  t.languages.hpkp = {
    directive: {
      pattern: /\b(?:includeSubDomains|max-age|pin-sha256|preload|report-to|report-uri|strict)(?=[\s;=]|$)/i,
      alias: "property"
    },
    operator: /=/,
    punctuation: /;/
  };
}
Pz.displayName = "hsts";
Pz.aliases = [];
function Pz(t) {
  t.languages.hsts = {
    directive: {
      pattern: /\b(?:includeSubDomains|max-age|preload)(?=[\s;=]|$)/i,
      alias: "property"
    },
    operator: /=/,
    punctuation: /;/
  };
}
Lz.displayName = "uri";
Lz.aliases = ["url"];
function Lz(t) {
  t.languages.uri = {
    scheme: {
      pattern: /^[a-z][a-z0-9+.-]*:/im,
      greedy: !0,
      inside: {
        "scheme-delimiter": /:$/
      }
    },
    fragment: {
      pattern: /#[\w\-.~!$&'()*+,;=%:@/?]*/,
      inside: {
        "fragment-delimiter": /^#/
      }
    },
    query: {
      pattern: /\?[\w\-.~!$&'()*+,;=%:@/?]*/,
      inside: {
        "query-delimiter": {
          pattern: /^\?/,
          greedy: !0
        },
        "pair-delimiter": /[&;]/,
        pair: {
          pattern: /^[^=][\s\S]*/,
          inside: {
            key: /^[^=]+/,
            value: {
              pattern: /(^=)[\s\S]+/,
              lookbehind: !0
            }
          }
        }
      }
    },
    authority: {
      pattern: RegExp(
        /^\/\//.source + // [ userinfo "@" ]
        /(?:[\w\-.~!$&'()*+,;=%:]*@)?/.source + // host
        ("(?:" + // IP-literal
        /\[(?:[0-9a-fA-F:.]{2,48}|v[0-9a-fA-F]+\.[\w\-.~!$&'()*+,;=]+)\]/.source + "|" + // IPv4address or registered name
        /[\w\-.~!$&'()*+,;=%]*/.source + ")") + // [ ":" port ]
        /(?::\d*)?/.source,
        "m"
      ),
      inside: {
        "authority-delimiter": /^\/\//,
        "user-info-segment": {
          pattern: /^[\w\-.~!$&'()*+,;=%:]*@/,
          inside: {
            "user-info-delimiter": /@$/,
            "user-info": /^[\w\-.~!$&'()*+,;=%:]+/
          }
        },
        "port-segment": {
          pattern: /:\d*$/,
          inside: {
            "port-delimiter": /^:/,
            port: /^\d+/
          }
        },
        host: {
          pattern: /[\s\S]+/,
          inside: {
            "ip-literal": {
              pattern: /^\[[\s\S]+\]$/,
              inside: {
                "ip-literal-delimiter": /^\[|\]$/,
                "ipv-future": /^v[\s\S]+/,
                "ipv6-address": /^[\s\S]+/
              }
            },
            "ipv4-address": /^(?:(?:[03-9]\d?|[12]\d{0,2})\.){3}(?:[03-9]\d?|[12]\d{0,2})$/
          }
        }
      }
    },
    path: {
      pattern: /^[\w\-.~!$&'()*+,;=%:@/]+/m,
      inside: {
        "path-separator": /\//
      }
    }
  }, t.languages.url = t.languages.uri;
}
Mz.displayName = "http";
Mz.aliases = [];
function Mz(t) {
  (function(e) {
    function n(p) {
      return RegExp("(^(?:" + p + "):[ 	]*(?![ 	]))[^]+", "i");
    }
    e.languages.http = {
      "request-line": {
        pattern: /^(?:CONNECT|DELETE|GET|HEAD|OPTIONS|PATCH|POST|PRI|PUT|SEARCH|TRACE)\s(?:https?:\/\/|\/)\S*\sHTTP\/[\d.]+/m,
        inside: {
          // HTTP Method
          method: {
            pattern: /^[A-Z]+\b/,
            alias: "property"
          },
          // Request Target e.g. http://example.com, /path/to/file
          "request-target": {
            pattern: /^(\s)(?:https?:\/\/|\/)\S*(?=\s)/,
            lookbehind: !0,
            alias: "url",
            inside: e.languages.uri
          },
          // HTTP Version
          "http-version": {
            pattern: /^(\s)HTTP\/[\d.]+/,
            lookbehind: !0,
            alias: "property"
          }
        }
      },
      "response-status": {
        pattern: /^HTTP\/[\d.]+ \d+ .+/m,
        inside: {
          // HTTP Version
          "http-version": {
            pattern: /^HTTP\/[\d.]+/,
            alias: "property"
          },
          // Status Code
          "status-code": {
            pattern: /^(\s)\d+(?=\s)/,
            lookbehind: !0,
            alias: "number"
          },
          // Reason Phrase
          "reason-phrase": {
            pattern: /^(\s).+/,
            lookbehind: !0,
            alias: "string"
          }
        }
      },
      header: {
        pattern: /^[\w-]+:.+(?:(?:\r\n?|\n)[ \t].+)*/m,
        inside: {
          "header-value": [
            {
              pattern: n(/Content-Security-Policy/.source),
              lookbehind: !0,
              alias: ["csp", "languages-csp"],
              inside: e.languages.csp
            },
            {
              pattern: n(/Public-Key-Pins(?:-Report-Only)?/.source),
              lookbehind: !0,
              alias: ["hpkp", "languages-hpkp"],
              inside: e.languages.hpkp
            },
            {
              pattern: n(/Strict-Transport-Security/.source),
              lookbehind: !0,
              alias: ["hsts", "languages-hsts"],
              inside: e.languages.hsts
            },
            {
              pattern: n(/[^:]+/.source),
              lookbehind: !0
            }
          ],
          "header-name": {
            pattern: /^[^:]+/,
            alias: "keyword"
          },
          punctuation: /^:/
        }
      }
    };
    var r = e.languages, a = {
      "application/javascript": r.javascript,
      "application/json": r.json || r.javascript,
      "application/xml": r.xml,
      "text/xml": r.xml,
      "text/html": r.html,
      "text/css": r.css,
      "text/plain": r.plain
    }, i = {
      "application/json": !0,
      "application/xml": !0
    };
    function o(p) {
      var m = p.replace(/^[a-z]+\//, ""), v = "\\w+/(?:[\\w.-]+\\+)+" + m + "(?![+\\w.-])";
      return "(?:" + p + "|" + v + ")";
    }
    var s;
    for (var u in a)
      if (a[u]) {
        s = s || {};
        var f = i[u] ? o(u) : u;
        s[u.replace(/\//g, "-")] = {
          pattern: RegExp(
            "(" + /content-type:\s*/.source + f + /(?:(?:\r\n?|\n)[\w-].*)*(?:\r(?:\n|(?!\n))|\n)/.source + ")" + // This is a little interesting:
            // The HTTP format spec required 1 empty line before the body to make everything unambiguous.
            // However, when writing code by hand (e.g. to display on a website) people can forget about this,
            // so we want to be liberal here. We will allow the empty line to be omitted if the first line of
            // the body does not start with a [\w-] character (as headers do).
            /[^ \t\w-][\s\S]*/.source,
            "i"
          ),
          lookbehind: !0,
          inside: a[u]
        };
      }
    s && e.languages.insertBefore("http", "header", s);
  })(t);
}
Fz.displayName = "ichigojam";
Fz.aliases = [];
function Fz(t) {
  t.languages.ichigojam = {
    comment: /(?:\B'|REM)(?:[^\n\r]*)/i,
    string: {
      pattern: /"(?:""|[!#$%&'()*,\/:;<=>?^\w +\-.])*"/,
      greedy: !0
    },
    number: /\B#[0-9A-F]+|\B`[01]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
    keyword: /\b(?:BEEP|BPS|CASE|CLEAR|CLK|CLO|CLP|CLS|CLT|CLV|CONT|COPY|ELSE|END|FILE|FILES|FOR|GOSUB|GOTO|GSB|IF|INPUT|KBD|LED|LET|LIST|LOAD|LOCATE|LRUN|NEW|NEXT|OUT|PLAY|POKE|PRINT|PWM|REM|RENUM|RESET|RETURN|RIGHT|RTN|RUN|SAVE|SCROLL|SLEEP|SRND|STEP|STOP|SUB|TEMPO|THEN|TO|UART|VIDEO|WAIT)(?:\$|\b)/i,
    function: /\b(?:ABS|ANA|ASC|BIN|BTN|DEC|END|FREE|HELP|HEX|I2CR|I2CW|IN|INKEY|LEN|LINE|PEEK|RND|SCR|SOUND|STR|TICK|USR|VER|VPEEK|ZER)(?:\$|\b)/i,
    label: /(?:\B@\S+)/,
    operator: /<[=>]?|>=?|\|\||&&|[+\-*\/=|&^~!]|\b(?:AND|NOT|OR)\b/i,
    punctuation: /[\[,;:()\]]/
  };
}
$z.displayName = "icon";
$z.aliases = [];
function $z(t) {
  t.languages.icon = {
    comment: /#.*/,
    string: {
      pattern: /(["'])(?:(?!\1)[^\\\r\n_]|\\.|_(?!\1)(?:\r\n|[\s\S]))*\1/,
      greedy: !0
    },
    number: /\b(?:\d+r[a-z\d]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b|\.\d+\b/i,
    "builtin-keyword": {
      pattern: /&(?:allocated|ascii|clock|collections|cset|current|date|dateline|digits|dump|e|error(?:number|text|value)?|errout|fail|features|file|host|input|lcase|letters|level|line|main|null|output|phi|pi|pos|progname|random|regions|source|storage|subject|time|trace|ucase|version)\b/,
      alias: "variable"
    },
    directive: {
      pattern: /\$\w+/,
      alias: "builtin"
    },
    keyword: /\b(?:break|by|case|create|default|do|else|end|every|fail|global|if|initial|invocable|link|local|next|not|of|procedure|record|repeat|return|static|suspend|then|to|until|while)\b/,
    function: /\b(?!\d)\w+(?=\s*[({]|\s*!\s*\[)/,
    operator: /[+-]:(?!=)|(?:[\/?@^%&]|\+\+?|--?|==?=?|~==?=?|\*\*?|\|\|\|?|<(?:->?|<?=?)|>>?=?)(?::=)?|:(?:=:?)?|[!.\\|~]/,
    punctuation: /[\[\](){},;]/
  };
}
Bz.displayName = "icu-message-format";
Bz.aliases = [];
function Bz(t) {
  (function(e) {
    function n(u, f) {
      return f <= 0 ? /[]/.source : u.replace(/<SELF>/g, function() {
        return n(u, f - 1);
      });
    }
    var r = /'[{}:=,](?:[^']|'')*'(?!')/, a = {
      pattern: /''/,
      greedy: !0,
      alias: "operator"
    }, i = {
      pattern: r,
      greedy: !0,
      inside: {
        escape: a
      }
    }, o = n(
      /\{(?:[^{}']|'(?![{},'])|''|<STR>|<SELF>)*\}/.source.replace(
        /<STR>/g,
        function() {
          return r.source;
        }
      ),
      8
    ), s = {
      pattern: RegExp(o),
      inside: {
        message: {
          pattern: /^(\{)[\s\S]+(?=\}$)/,
          lookbehind: !0,
          inside: null
          // see below
        },
        "message-delimiter": {
          pattern: /./,
          alias: "punctuation"
        }
      }
    };
    e.languages["icu-message-format"] = {
      argument: {
        pattern: RegExp(o),
        greedy: !0,
        inside: {
          content: {
            pattern: /^(\{)[\s\S]+(?=\}$)/,
            lookbehind: !0,
            inside: {
              "argument-name": {
                pattern: /^(\s*)[^{}:=,\s]+/,
                lookbehind: !0
              },
              "choice-style": {
                // https://unicode-org.github.io/icu-docs/apidoc/released/icu4c/classicu_1_1ChoiceFormat.html#details
                pattern: /^(\s*,\s*choice\s*,\s*)\S(?:[\s\S]*\S)?/,
                lookbehind: !0,
                inside: {
                  punctuation: /\|/,
                  range: {
                    pattern: /^(\s*)[+-]?(?:\d+(?:\.\d*)?|\u221e)\s*[<#\u2264]/,
                    lookbehind: !0,
                    inside: {
                      operator: /[<#\u2264]/,
                      number: /\S+/
                    }
                  },
                  rest: null
                  // see below
                }
              },
              "plural-style": {
                // https://unicode-org.github.io/icu-docs/apidoc/released/icu4j/com/ibm/icu/text/PluralFormat.html#:~:text=Patterns%20and%20Their%20Interpretation
                pattern: /^(\s*,\s*(?:plural|selectordinal)\s*,\s*)\S(?:[\s\S]*\S)?/,
                lookbehind: !0,
                inside: {
                  offset: /^offset:\s*\d+/,
                  "nested-message": s,
                  selector: {
                    pattern: /=\d+|[^{}:=,\s]+/,
                    inside: {
                      keyword: /^(?:few|many|one|other|two|zero)$/
                    }
                  }
                }
              },
              "select-style": {
                // https://unicode-org.github.io/icu-docs/apidoc/released/icu4j/com/ibm/icu/text/SelectFormat.html#:~:text=Patterns%20and%20Their%20Interpretation
                pattern: /^(\s*,\s*select\s*,\s*)\S(?:[\s\S]*\S)?/,
                lookbehind: !0,
                inside: {
                  "nested-message": s,
                  selector: {
                    pattern: /[^{}:=,\s]+/,
                    inside: {
                      keyword: /^other$/
                    }
                  }
                }
              },
              keyword: /\b(?:choice|plural|select|selectordinal)\b/,
              "arg-type": {
                pattern: /\b(?:date|duration|number|ordinal|spellout|time)\b/,
                alias: "keyword"
              },
              "arg-skeleton": {
                pattern: /(,\s*)::[^{}:=,\s]+/,
                lookbehind: !0
              },
              "arg-style": {
                pattern: /(,\s*)(?:currency|full|integer|long|medium|percent|short)(?=\s*$)/,
                lookbehind: !0
              },
              "arg-style-text": {
                pattern: RegExp(
                  /(^\s*,\s*(?=\S))/.source + n(/(?:[^{}']|'[^']*'|\{(?:<SELF>)?\})+/.source, 8) + "$"
                ),
                lookbehind: !0,
                alias: "string"
              },
              punctuation: /,/
            }
          },
          "argument-delimiter": {
            pattern: /./,
            alias: "operator"
          }
        }
      },
      escape: a,
      string: i
    }, s.inside.message.inside = e.languages["icu-message-format"], e.languages["icu-message-format"].argument.inside.content.inside["choice-style"].inside.rest = e.languages["icu-message-format"];
  })(t);
}
Uz.displayName = "idris";
Uz.aliases = ["idr"];
function Uz(t) {
  t.register(P_), t.languages.idris = t.languages.extend("haskell", {
    comment: {
      pattern: /(?:(?:--|\|\|\|).*$|\{-[\s\S]*?-\})/m
    },
    keyword: /\b(?:Type|case|class|codata|constructor|corecord|data|do|dsl|else|export|if|implementation|implicit|import|impossible|in|infix|infixl|infixr|instance|interface|let|module|mutual|namespace|of|parameters|partial|postulate|private|proof|public|quoteGoal|record|rewrite|syntax|then|total|using|where|with)\b/,
    builtin: void 0
  }), t.languages.insertBefore("idris", "keyword", {
    "import-statement": {
      pattern: /(^\s*import\s+)(?:[A-Z][\w']*)(?:\.[A-Z][\w']*)*/m,
      lookbehind: !0,
      inside: {
        punctuation: /\./
      }
    }
  }), t.languages.idr = t.languages.idris;
}
zz.displayName = "ignore";
zz.aliases = ["gitignore", "hgignore", "npmignore"];
function zz(t) {
  (function(e) {
    e.languages.ignore = {
      // https://git-scm.com/docs/gitignore
      comment: /^#.*/m,
      entry: {
        pattern: /\S(?:.*(?:(?:\\ )|\S))?/,
        alias: "string",
        inside: {
          operator: /^!|\*\*?|\?/,
          regex: {
            pattern: /(^|[^\\])\[[^\[\]]*\]/,
            lookbehind: !0
          },
          punctuation: /\//
        }
      }
    }, e.languages.gitignore = e.languages.ignore, e.languages.hgignore = e.languages.ignore, e.languages.npmignore = e.languages.ignore;
  })(t);
}
Hz.displayName = "inform7";
Hz.aliases = [];
function Hz(t) {
  t.languages.inform7 = {
    string: {
      pattern: /"[^"]*"/,
      inside: {
        substitution: {
          pattern: /\[[^\[\]]+\]/,
          inside: {
            delimiter: {
              pattern: /\[|\]/,
              alias: "punctuation"
            }
            // See rest below
          }
        }
      }
    },
    comment: {
      pattern: /\[[^\[\]]+\]/,
      greedy: !0
    },
    title: {
      pattern: /^[ \t]*(?:book|chapter|part(?! of)|section|table|volume)\b.+/im,
      alias: "important"
    },
    number: {
      pattern: /(^|[^-])(?:\b\d+(?:\.\d+)?(?:\^\d+)?(?:(?!\d)\w+)?|\b(?:eight|eleven|five|four|nine|one|seven|six|ten|three|twelve|two))\b(?!-)/i,
      lookbehind: !0
    },
    verb: {
      pattern: /(^|[^-])\b(?:answering|applying to|are|asking|attacking|be(?:ing)?|burning|buying|called|carries|carry(?! out)|carrying|climbing|closing|conceal(?:ing|s)?|consulting|contain(?:ing|s)?|cutting|drinking|dropping|eating|enclos(?:es?|ing)|entering|examining|exiting|getting|giving|going|ha(?:s|ve|ving)|hold(?:ing|s)?|impl(?:ies|y)|incorporat(?:es?|ing)|inserting|is|jumping|kissing|listening|locking|looking|mean(?:ing|s)?|opening|provid(?:es?|ing)|pulling|pushing|putting|relat(?:es?|ing)|removing|searching|see(?:ing|s)?|setting|showing|singing|sleeping|smelling|squeezing|support(?:ing|s)?|swearing|switching|taking|tasting|telling|thinking|throwing|touching|turning|tying|unlock(?:ing|s)?|var(?:ies|y|ying)|waiting|waking|waving|wear(?:ing|s)?)\b(?!-)/i,
      lookbehind: !0,
      alias: "operator"
    },
    keyword: {
      pattern: /(^|[^-])\b(?:after|before|carry out|check|continue the action|definition(?= *:)|do nothing|else|end (?:if|the story|unless)|every turn|if|include|instead(?: of)?|let|move|no|now|otherwise|repeat|report|resume the story|rule for|running through|say(?:ing)?|stop the action|test|try(?:ing)?|understand|unless|use|when|while|yes)\b(?!-)/i,
      lookbehind: !0
    },
    property: {
      pattern: /(^|[^-])\b(?:adjacent(?! to)|carried|closed|concealed|contained|dark|described|edible|empty|enclosed|enterable|even|female|fixed in place|full|handled|held|improper-named|incorporated|inedible|invisible|lighted|lit|lock(?:able|ed)|male|marked for listing|mentioned|negative|neuter|non-(?:empty|full|recurring)|odd|opaque|open(?:able)?|plural-named|portable|positive|privately-named|proper-named|provided|publically-named|pushable between rooms|recurring|related|rubbing|scenery|seen|singular-named|supported|swinging|switch(?:able|ed(?: off| on)?)|touch(?:able|ed)|transparent|unconcealed|undescribed|unlit|unlocked|unmarked for listing|unmentioned|unopenable|untouchable|unvisited|variable|visible|visited|wearable|worn)\b(?!-)/i,
      lookbehind: !0,
      alias: "symbol"
    },
    position: {
      pattern: /(^|[^-])\b(?:above|adjacent to|back side of|below|between|down|east|everywhere|front side|here|in|inside(?: from)?|north(?:east|west)?|nowhere|on(?: top of)?|other side|outside(?: from)?|parts? of|regionally in|south(?:east|west)?|through|up|west|within)\b(?!-)/i,
      lookbehind: !0,
      alias: "keyword"
    },
    type: {
      pattern: /(^|[^-])\b(?:actions?|activit(?:ies|y)|actors?|animals?|backdrops?|containers?|devices?|directions?|doors?|holders?|kinds?|lists?|m[ae]n|nobody|nothing|nouns?|numbers?|objects?|people|persons?|player(?:'s holdall)?|regions?|relations?|rooms?|rule(?:book)?s?|scenes?|someone|something|supporters?|tables?|texts?|things?|time|vehicles?|wom[ae]n)\b(?!-)/i,
      lookbehind: !0,
      alias: "variable"
    },
    punctuation: /[.,:;(){}]/
  }, t.languages.inform7.string.inside.substitution.inside.rest = t.languages.inform7, t.languages.inform7.string.inside.substitution.inside.rest.text = {
    pattern: /\S(?:\s*\S)*/,
    alias: "comment"
  };
}
Wz.displayName = "io";
Wz.aliases = [];
function Wz(t) {
  t.languages.io = {
    comment: {
      pattern: /(^|[^\\])(?:\/\*[\s\S]*?(?:\*\/|$)|\/\/.*|#.*)/,
      lookbehind: !0,
      greedy: !0
    },
    "triple-quoted-string": {
      pattern: /"""(?:\\[\s\S]|(?!""")[^\\])*"""/,
      greedy: !0,
      alias: "string"
    },
    string: {
      pattern: /"(?:\\.|[^\\\r\n"])*"/,
      greedy: !0
    },
    keyword: /\b(?:activate|activeCoroCount|asString|block|break|call|catch|clone|collectGarbage|compileString|continue|do|doFile|doMessage|doString|else|elseif|exit|for|foreach|forward|getEnvironmentVariable|getSlot|hasSlot|if|ifFalse|ifNil|ifNilEval|ifTrue|isActive|isNil|isResumable|list|message|method|parent|pass|pause|perform|performWithArgList|print|println|proto|raise|raiseResumable|removeSlot|resend|resume|schedulerSleepSeconds|self|sender|setSchedulerSleepSeconds|setSlot|shallowCopy|slotNames|super|system|then|thisBlock|thisContext|try|type|uniqueId|updateSlot|wait|while|write|yield)\b/,
    builtin: /\b(?:Array|AudioDevice|AudioMixer|BigNum|Block|Box|Buffer|CFunction|CGI|Color|Curses|DBM|DNSResolver|DOConnection|DOProxy|DOServer|Date|Directory|Duration|DynLib|Error|Exception|FFT|File|Fnmatch|Font|Future|GL|GLE|GLScissor|GLU|GLUCylinder|GLUQuadric|GLUSphere|GLUT|Host|Image|Importer|LinkList|List|Lobby|Locals|MD5|MP3Decoder|MP3Encoder|Map|Message|Movie|Notification|Number|Object|OpenGL|Point|Protos|Random|Regex|SGML|SGMLElement|SGMLParser|SQLite|Sequence|Server|ShowMessage|SleepyCat|SleepyCatCursor|Socket|SocketManager|Sound|Soup|Store|String|Tree|UDPSender|UPDReceiver|URL|User|Warning|WeakLink)\b/,
    boolean: /\b(?:false|nil|true)\b/,
    number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e-?\d+)?/i,
    operator: /[=!*/%+\-^&|]=|>>?=?|<<?=?|:?:?=|\+\+?|--?|\*\*?|\/\/?|%|\|\|?|&&?|\b(?:and|not|or|return)\b|@@?|\?\??|\.\./,
    punctuation: /[{}[\];(),.:]/
  };
}
Qz.displayName = "j";
Qz.aliases = [];
function Qz(t) {
  t.languages.j = {
    comment: {
      pattern: /\bNB\..*/,
      greedy: !0
    },
    string: {
      pattern: /'(?:''|[^'\r\n])*'/,
      greedy: !0
    },
    keyword: /\b(?:(?:CR|LF|adverb|conjunction|def|define|dyad|monad|noun|verb)\b|(?:assert|break|case|catch[dt]?|continue|do|else|elseif|end|fcase|for|for_\w+|goto_\w+|if|label_\w+|return|select|throw|try|while|whilst)\.)/,
    verb: {
      // Negative look-ahead prevents bad highlighting
      // of ^: ;. =. =: !. !:
      pattern: /(?!\^:|;\.|[=!][.:])(?:\{(?:\.|::?)?|p(?:\.\.?|:)|[=!\]]|[<>+*\-%$|,#][.:]?|[?^]\.?|[;\[]:?|[~}"i][.:]|[ACeEIjLor]\.|(?:[_\/\\qsux]|_?\d):)/,
      alias: "keyword"
    },
    number: /\b_?(?:(?!\d:)\d+(?:\.\d+)?(?:(?:ad|ar|[ejpx])_?\d+(?:\.\d+)?)*(?:b_?[\da-z]+(?:\.[\da-z]+)?)?|_\b(?!\.))/,
    adverb: {
      pattern: /[~}]|[\/\\]\.?|[bfM]\.|t[.:]/,
      alias: "builtin"
    },
    operator: /[=a][.:]|_\./,
    conjunction: {
      pattern: /&(?:\.:?|:)?|[.:@][.:]?|[!D][.:]|[;dHT]\.|`:?|[\^LS]:|"/,
      alias: "variable"
    },
    punctuation: /[()]/
  };
}
w1.displayName = "javadoclike";
w1.aliases = [];
function w1(t) {
  (function(e) {
    var n = e.languages.javadoclike = {
      parameter: {
        pattern: /(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*@(?:arg|arguments|param)\s+)\w+/m,
        lookbehind: !0
      },
      keyword: {
        // keywords are the first word in a line preceded be an `@` or surrounded by curly braces.
        // @word, {@word}
        pattern: /(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*|\{)@[a-z][a-zA-Z-]+\b/m,
        lookbehind: !0
      },
      punctuation: /[{}]/
    };
    function r(i, o) {
      var s = "doc-comment", u = e.languages[i];
      if (u) {
        var f = u[s];
        if (!f) {
          var p = {};
          p[s] = {
            pattern: /(^|[^\\])\/\*\*[^/][\s\S]*?(?:\*\/|$)/,
            lookbehind: !0,
            alias: "comment"
          }, u = e.languages.insertBefore(i, "comment", p), f = u[s];
        }
        if (f instanceof RegExp && (f = u[s] = {
          pattern: f
        }), Array.isArray(f))
          for (var m = 0, v = f.length; m < v; m++)
            f[m] instanceof RegExp && (f[m] = {
              pattern: f[m]
            }), o(f[m]);
        else
          o(f);
      }
    }
    function a(i, o) {
      typeof i == "string" && (i = [i]), i.forEach(function(s) {
        r(s, function(u) {
          u.inside || (u.inside = {}), u.inside.rest = o;
        });
      });
    }
    Object.defineProperty(n, "addSupport", {
      value: a
    }), n.addSupport(["java", "javascript", "php"], n);
  })(t);
}
jz.displayName = "scala";
jz.aliases = [];
function jz(t) {
  t.register(k0), t.languages.scala = t.languages.extend("java", {
    "triple-quoted-string": {
      pattern: /"""[\s\S]*?"""/,
      greedy: !0,
      alias: "string"
    },
    string: {
      pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
      greedy: !0
    },
    keyword: /<-|=>|\b(?:abstract|case|catch|class|def|derives|do|else|enum|extends|extension|final|finally|for|forSome|given|if|implicit|import|infix|inline|lazy|match|new|null|object|opaque|open|override|package|private|protected|return|sealed|self|super|this|throw|trait|transparent|try|type|using|val|var|while|with|yield)\b/,
    number: /\b0x(?:[\da-f]*\.)?[\da-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e\d+)?[dfl]?/i,
    builtin: /\b(?:Any|AnyRef|AnyVal|Boolean|Byte|Char|Double|Float|Int|Long|Nothing|Short|String|Unit)\b/,
    symbol: /'[^\d\s\\]\w*/
  }), t.languages.insertBefore("scala", "triple-quoted-string", {
    "string-interpolation": {
      pattern: /\b[a-z]\w*(?:"""(?:[^$]|\$(?:[^{]|\{(?:[^{}]|\{[^{}]*\})*\}))*?"""|"(?:[^$"\r\n]|\$(?:[^{]|\{(?:[^{}]|\{[^{}]*\})*\}))*")/i,
      greedy: !0,
      inside: {
        id: {
          pattern: /^\w+/,
          greedy: !0,
          alias: "function"
        },
        escape: {
          pattern: /\\\$"|\$[$"]/,
          greedy: !0,
          alias: "symbol"
        },
        interpolation: {
          pattern: /\$(?:\w+|\{(?:[^{}]|\{[^{}]*\})*\})/,
          greedy: !0,
          inside: {
            punctuation: /^\$\{?|\}$/,
            expression: {
              pattern: /[\s\S]+/,
              inside: t.languages.scala
            }
          }
        },
        string: /[\s\S]+/
      }
    }
  }), delete t.languages.scala["class-name"], delete t.languages.scala.function, delete t.languages.scala.constant;
}
Gz.displayName = "javadoc";
Gz.aliases = [];
function Gz(t) {
  t.register(k0), t.register(w1), t.register(ws), function(e) {
    var n = /(^(?:[\t ]*(?:\*\s*)*))[^*\s].*$/m, r = /#\s*\w+(?:\s*\([^()]*\))?/.source, a = /(?:\b[a-zA-Z]\w+\s*\.\s*)*\b[A-Z]\w*(?:\s*<mem>)?|<mem>/.source.replace(
      /<mem>/g,
      function() {
        return r;
      }
    );
    e.languages.javadoc = e.languages.extend("javadoclike", {}), e.languages.insertBefore("javadoc", "keyword", {
      reference: {
        pattern: RegExp(
          /(@(?:exception|link|linkplain|see|throws|value)\s+(?:\*\s*)?)/.source + "(?:" + a + ")"
        ),
        lookbehind: !0,
        inside: {
          function: {
            pattern: /(#\s*)\w+(?=\s*\()/,
            lookbehind: !0
          },
          field: {
            pattern: /(#\s*)\w+/,
            lookbehind: !0
          },
          namespace: {
            pattern: /\b(?:[a-z]\w*\s*\.\s*)+/,
            inside: {
              punctuation: /\./
            }
          },
          "class-name": /\b[A-Z]\w*/,
          keyword: e.languages.java.keyword,
          punctuation: /[#()[\],.]/
        }
      },
      "class-name": {
        // @param <T> the first generic type parameter
        pattern: /(@param\s+)<[A-Z]\w*>/,
        lookbehind: !0,
        inside: {
          punctuation: /[.<>]/
        }
      },
      "code-section": [
        {
          pattern: /(\{@code\s+(?!\s))(?:[^\s{}]|\s+(?![\s}])|\{(?:[^{}]|\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\})*\})+(?=\s*\})/,
          lookbehind: !0,
          inside: {
            code: {
              // there can't be any HTML inside of {@code} tags
              pattern: n,
              lookbehind: !0,
              inside: e.languages.java,
              alias: "language-java"
            }
          }
        },
        {
          pattern: /(<(code|pre|tt)>(?!<code>)\s*)\S(?:\S|\s+\S)*?(?=\s*<\/\2>)/,
          lookbehind: !0,
          inside: {
            line: {
              pattern: n,
              lookbehind: !0,
              inside: {
                // highlight HTML tags and entities
                tag: e.languages.markup.tag,
                entity: e.languages.markup.entity,
                code: {
                  // everything else is Java code
                  pattern: /.+/,
                  inside: e.languages.java,
                  alias: "language-java"
                }
              }
            }
          }
        }
      ],
      tag: e.languages.markup.tag,
      entity: e.languages.markup.entity
    }), e.languages.javadoclike.addSupport("java", e.languages.javadoc);
  }(t);
}
Vz.displayName = "javastacktrace";
Vz.aliases = [];
function Vz(t) {
  t.languages.javastacktrace = {
    // java.sql.SQLException: Violation of unique constraint MY_ENTITY_UK_1: duplicate value(s) for column(s) MY_COLUMN in statement [...]
    // Caused by: java.sql.SQLException: Violation of unique constraint MY_ENTITY_UK_1: duplicate value(s) for column(s) MY_COLUMN in statement [...]
    // Caused by: com.example.myproject.MyProjectServletException
    // Caused by: MidLevelException: LowLevelException
    // Suppressed: Resource$CloseFailException: Resource ID = 0
    summary: {
      pattern: /^([\t ]*)(?:(?:Caused by:|Suppressed:|Exception in thread "[^"]*")[\t ]+)?[\w$.]+(?::.*)?$/m,
      lookbehind: !0,
      inside: {
        keyword: {
          pattern: /^([\t ]*)(?:(?:Caused by|Suppressed)(?=:)|Exception in thread)/m,
          lookbehind: !0
        },
        // the current thread if the summary starts with 'Exception in thread'
        string: {
          pattern: /^(\s*)"[^"]*"/,
          lookbehind: !0
        },
        exceptions: {
          pattern: /^(:?\s*)[\w$.]+(?=:|$)/,
          lookbehind: !0,
          inside: {
            "class-name": /[\w$]+$/,
            namespace: /\b[a-z]\w*\b/,
            punctuation: /\./
          }
        },
        message: {
          pattern: /(:\s*)\S.*/,
          lookbehind: !0,
          alias: "string"
        },
        punctuation: /:/
      }
    },
    // at org.mortbay.jetty.servlet.ServletHandler$CachedChain.doFilter(ServletHandler.java:1166)
    // at org.hsqldb.jdbc.Util.throwError(Unknown Source) here could be some notes
    // at java.base/java.lang.Class.forName0(Native Method)
    // at Util.<init>(Unknown Source)
    // at com.foo.loader/foo@9.0/com.foo.Main.run(Main.java:101)
    // at com.foo.loader//com.foo.bar.App.run(App.java:12)
    // at acme@2.1/org.acme.Lib.test(Lib.java:80)
    // at MyClass.mash(MyClass.java:9)
    //
    // More information:
    // https://docs.oracle.com/en/java/javase/13/docs/api/java.base/java/lang/StackTraceElement.html#toString()
    //
    // A valid Java module name is defined as:
    //   "A module name consists of one or more Java identifiers (§3.8) separated by "." tokens."
    // https://docs.oracle.com/javase/specs/jls/se9/html/jls-6.html#jls-ModuleName
    //
    // A Java module version is defined by this class:
    // https://docs.oracle.com/javase/9/docs/api/java/lang/module/ModuleDescriptor.Version.html
    // This is the implementation of the `parse` method in JDK13:
    // https://github.com/matcdac/jdk/blob/2305df71d1b7710266ae0956d73927a225132c0f/src/java.base/share/classes/java/lang/module/ModuleDescriptor.java#L1108
    // However, to keep this simple, a version will be matched by the pattern /@[\w$.+-]*/.
    "stack-frame": {
      pattern: /^([\t ]*)at (?:[\w$./]|@[\w$.+-]*\/)+(?:<init>)?\([^()]*\)/m,
      lookbehind: !0,
      inside: {
        keyword: {
          pattern: /^(\s*)at(?= )/,
          lookbehind: !0
        },
        source: [
          // (Main.java:15)
          // (Main.scala:15)
          {
            pattern: /(\()\w+\.\w+:\d+(?=\))/,
            lookbehind: !0,
            inside: {
              file: /^\w+\.\w+/,
              punctuation: /:/,
              "line-number": {
                pattern: /\b\d+\b/,
                alias: "number"
              }
            }
          },
          // (Unknown Source)
          // (Native Method)
          // (...something...)
          {
            pattern: /(\()[^()]*(?=\))/,
            lookbehind: !0,
            inside: {
              keyword: /^(?:Native Method|Unknown Source)$/
            }
          }
        ],
        "class-name": /[\w$]+(?=\.(?:<init>|[\w$]+)\()/,
        function: /(?:<init>|[\w$]+)(?=\()/,
        "class-loader": {
          pattern: /(\s)[a-z]\w*(?:\.[a-z]\w*)*(?=\/[\w@$.]*\/)/,
          lookbehind: !0,
          alias: "namespace",
          inside: {
            punctuation: /\./
          }
        },
        module: {
          pattern: /([\s/])[a-z]\w*(?:\.[a-z]\w*)*(?:@[\w$.+-]*)?(?=\/)/,
          lookbehind: !0,
          inside: {
            version: {
              pattern: /(@)[\s\S]+/,
              lookbehind: !0,
              alias: "number"
            },
            punctuation: /[@.]/
          }
        },
        namespace: {
          pattern: /(?:\b[a-z]\w*\.)+/,
          inside: {
            punctuation: /\./
          }
        },
        punctuation: /[()/.]/
      }
    },
    // ... 32 more
    // ... 32 common frames omitted
    more: {
      pattern: /^([\t ]*)\.{3} \d+ [a-z]+(?: [a-z]+)*/m,
      lookbehind: !0,
      inside: {
        punctuation: /\.{3}/,
        number: /\d+/,
        keyword: /\b[a-z]+(?: [a-z]+)*\b/
      }
    }
  };
}
Yz.displayName = "jexl";
Yz.aliases = [];
function Yz(t) {
  t.languages.jexl = {
    string: /(["'])(?:\\[\s\S]|(?!\1)[^\\])*\1/,
    transform: {
      pattern: /(\|\s*)[a-zA-Zа-яА-Я_\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$][\wа-яА-Я\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$]*/,
      alias: "function",
      lookbehind: !0
    },
    function: /[a-zA-Zа-яА-Я_\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$][\wа-яА-Я\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$]*\s*(?=\()/,
    number: /\b\d+(?:\.\d+)?\b|\B\.\d+\b/,
    operator: /[<>!]=?|-|\+|&&|==|\|\|?|\/\/?|[?:*^%]/,
    boolean: /\b(?:false|true)\b/,
    keyword: /\bin\b/,
    punctuation: /[{}[\](),.]/
  };
}
Zz.displayName = "jolie";
Zz.aliases = [];
function Zz(t) {
  t.register(Lr), t.languages.jolie = t.languages.extend("clike", {
    string: {
      pattern: /(^|[^\\])"(?:\\[\s\S]|[^"\\])*"/,
      lookbehind: !0,
      greedy: !0
    },
    "class-name": {
      pattern: /((?:\b(?:as|courier|embed|in|inputPort|outputPort|service)\b|@)[ \t]*)\w+/,
      lookbehind: !0
    },
    keyword: /\b(?:as|cH|comp|concurrent|constants|courier|cset|csets|default|define|else|embed|embedded|execution|exit|extender|for|foreach|forward|from|global|if|import|in|include|init|inputPort|install|instanceof|interface|is_defined|linkIn|linkOut|main|new|nullProcess|outputPort|over|private|provide|public|scope|sequential|service|single|spawn|synchronized|this|throw|throws|type|undef|until|while|with)\b/,
    function: /\b[a-z_]\w*(?=[ \t]*[@(])/i,
    number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?l?/i,
    operator: /-[-=>]?|\+[+=]?|<[<=]?|[>=*!]=?|&&|\|\||[?\/%^@|]/,
    punctuation: /[()[\]{},;.:]/,
    builtin: /\b(?:Byte|any|bool|char|double|enum|float|int|length|long|ranges|regex|string|undefined|void)\b/
  }), t.languages.insertBefore("jolie", "keyword", {
    aggregates: {
      pattern: /(\bAggregates\s*:\s*)(?:\w+(?:\s+with\s+\w+)?\s*,\s*)*\w+(?:\s+with\s+\w+)?/,
      lookbehind: !0,
      inside: {
        keyword: /\bwith\b/,
        "class-name": /\w+/,
        punctuation: /,/
      }
    },
    redirects: {
      pattern: /(\bRedirects\s*:\s*)(?:\w+\s*=>\s*\w+\s*,\s*)*(?:\w+\s*=>\s*\w+)/,
      lookbehind: !0,
      inside: {
        punctuation: /,/,
        "class-name": /\w+/,
        operator: /=>/
      }
    },
    property: {
      pattern: /\b(?:Aggregates|[Ii]nterfaces|Java|Javascript|Jolie|[Ll]ocation|OneWay|[Pp]rotocol|Redirects|RequestResponse)\b(?=[ \t]*:)/
    }
  });
}
Xz.displayName = "jq";
Xz.aliases = [];
function Xz(t) {
  (function(e) {
    var n = /\\\((?:[^()]|\([^()]*\))*\)/.source, r = RegExp(
      /(^|[^\\])"(?:[^"\r\n\\]|\\[^\r\n(]|__)*"/.source.replace(
        /__/g,
        function() {
          return n;
        }
      )
    ), a = {
      interpolation: {
        pattern: RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + n),
        lookbehind: !0,
        inside: {
          content: {
            pattern: /^(\\\()[\s\S]+(?=\)$)/,
            lookbehind: !0,
            inside: null
            // see below
          },
          punctuation: /^\\\(|\)$/
        }
      }
    }, i = e.languages.jq = {
      comment: /#.*/,
      property: {
        pattern: RegExp(r.source + /(?=\s*:(?!:))/.source),
        lookbehind: !0,
        greedy: !0,
        inside: a
      },
      string: {
        pattern: r,
        lookbehind: !0,
        greedy: !0,
        inside: a
      },
      function: {
        pattern: /(\bdef\s+)[a-z_]\w+/i,
        lookbehind: !0
      },
      variable: /\B\$\w+/,
      "property-literal": {
        pattern: /\b[a-z_]\w*(?=\s*:(?!:))/i,
        alias: "property"
      },
      keyword: /\b(?:as|break|catch|def|elif|else|end|foreach|if|import|include|label|module|modulemeta|null|reduce|then|try|while)\b/,
      boolean: /\b(?:false|true)\b/,
      number: /(?:\b\d+\.|\B\.)?\b\d+(?:[eE][+-]?\d+)?\b/,
      operator: [
        {
          pattern: /\|=?/,
          alias: "pipe"
        },
        /\.\.|[!=<>]?=|\?\/\/|\/\/=?|[-+*/%]=?|[<>?]|\b(?:and|not|or)\b/
      ],
      "c-style-function": {
        pattern: /\b[a-z_]\w*(?=\s*\()/i,
        alias: "function"
      },
      punctuation: /::|[()\[\]{},:;]|\.(?=\s*[\[\w$])/,
      dot: {
        pattern: /\./,
        alias: "important"
      }
    };
    a.interpolation.inside.content.inside = i;
  })(t);
}
qz.displayName = "js-templates";
qz.aliases = [];
function qz(t) {
  t.register(rl), function(e) {
    var n = e.languages.javascript["template-string"], r = n.pattern.source, a = n.inside.interpolation, i = a.inside["interpolation-punctuation"], o = a.pattern.source;
    function s(w, _) {
      if (e.languages[w])
        return {
          pattern: RegExp("((?:" + _ + ")\\s*)" + r),
          lookbehind: !0,
          greedy: !0,
          inside: {
            "template-punctuation": {
              pattern: /^`|`$/,
              alias: "string"
            },
            "embedded-code": {
              pattern: /[\s\S]+/,
              alias: w
            }
          }
        };
    }
    e.languages.javascript["template-string"] = [
      // styled-jsx:
      //   css`a { color: #25F; }`
      // styled-components:
      //   styled.h1`color: red;`
      s(
        "css",
        /\b(?:styled(?:\([^)]*\))?(?:\s*\.\s*\w+(?:\([^)]*\))*)*|css(?:\s*\.\s*(?:global|resolve))?|createGlobalStyle|keyframes)/.source
      ),
      // html`<p></p>`
      // div.innerHTML = `<p></p>`
      s("html", /\bhtml|\.\s*(?:inner|outer)HTML\s*\+?=/.source),
      // svg`<path fill="#fff" d="M55.37 ..."/>`
      s("svg", /\bsvg/.source),
      // md`# h1`, markdown`## h2`
      s("markdown", /\b(?:markdown|md)/.source),
      // gql`...`, graphql`...`, graphql.experimental`...`
      s(
        "graphql",
        /\b(?:gql|graphql(?:\s*\.\s*experimental)?)/.source
      ),
      // sql`...`
      s("sql", /\bsql/.source),
      // vanilla template string
      n
    ].filter(Boolean);
    function u(w, _) {
      return "___" + _.toUpperCase() + "_" + w + "___";
    }
    function f(w, _, C) {
      var A = {
        code: w,
        grammar: _,
        language: C
      };
      return e.hooks.run("before-tokenize", A), A.tokens = e.tokenize(A.code, A.grammar), e.hooks.run("after-tokenize", A), A.tokens;
    }
    function p(w) {
      var _ = {};
      _["interpolation-punctuation"] = i;
      var C = e.tokenize(w, _);
      if (C.length === 3) {
        var A = [1, 1];
        A.push.apply(
          A,
          f(C[1], e.languages.javascript, "javascript")
        ), C.splice.apply(C, A);
      }
      return new e.Token(
        "interpolation",
        C,
        a.alias,
        w
      );
    }
    function m(w, _, C) {
      var A = e.tokenize(w, {
        interpolation: {
          pattern: RegExp(o),
          lookbehind: !0
        }
      }), N = 0, P = {}, I = A.map(function(Y) {
        if (typeof Y == "string")
          return Y;
        for (var q = Y.content, Q; w.indexOf(
          Q = u(N++, C)
        ) !== -1; )
          ;
        return P[Q] = q, Q;
      }).join(""), D = f(I, _, C), M = Object.keys(P);
      N = 0;
      function H(Y) {
        for (var q = 0; q < Y.length; q++) {
          if (N >= M.length)
            return;
          var Q = Y[q];
          if (typeof Q == "string" || typeof Q.content == "string") {
            var ne = M[N], J = typeof Q == "string" ? Q : (
              /** @type {string} */
              Q.content
            ), ue = J.indexOf(ne);
            if (ue !== -1) {
              ++N;
              var ee = J.substring(0, ue), fe = p(
                P[ne]
              ), de = J.substring(ue + ne.length), ie = [];
              if (ee && ie.push(ee), ie.push(fe), de) {
                var le = [de];
                H(le), ie.push.apply(ie, le);
              }
              typeof Q == "string" ? (Y.splice.apply(Y, [q, 1].concat(ie)), q += ie.length - 1) : Q.content = ie;
            }
          } else {
            var ye = Q.content;
            Array.isArray(ye) ? H(ye) : H([ye]);
          }
        }
      }
      return H(D), new e.Token(
        C,
        D,
        "language-" + C,
        w
      );
    }
    var v = {
      javascript: !0,
      js: !0,
      typescript: !0,
      ts: !0,
      jsx: !0,
      tsx: !0
    };
    e.hooks.add("after-tokenize", function(w) {
      if (!(w.language in v))
        return;
      function _(C) {
        for (var A = 0, N = C.length; A < N; A++) {
          var P = C[A];
          if (typeof P != "string") {
            var I = P.content;
            if (!Array.isArray(I)) {
              typeof I != "string" && _([I]);
              continue;
            }
            if (P.type === "template-string") {
              var D = I[1];
              if (I.length === 3 && typeof D != "string" && D.type === "embedded-code") {
                var M = O(D), H = D.alias, Y = Array.isArray(H) ? H[0] : H, q = e.languages[Y];
                if (!q)
                  continue;
                I[1] = m(M, q, Y);
              }
            } else
              _(I);
          }
        }
      }
      _(w.tokens);
    });
    function O(w) {
      return typeof w == "string" ? w : Array.isArray(w) ? w.map(O).join("") : O(w.content);
    }
  }(t);
}
Kz.displayName = "jsdoc";
Kz.aliases = [];
function Kz(t) {
  t.register(w1), t.register(rl), t.register(y1), function(e) {
    var n = e.languages.javascript, r = /\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})+\}/.source, a = "(@(?:arg|argument|param|property)\\s+(?:" + r + "\\s+)?)";
    e.languages.jsdoc = e.languages.extend("javadoclike", {
      parameter: {
        // @param {string} foo - foo bar
        pattern: RegExp(
          a + /(?:(?!\s)[$\w\xA0-\uFFFF.])+(?=\s|$)/.source
        ),
        lookbehind: !0,
        inside: {
          punctuation: /\./
        }
      }
    }), e.languages.insertBefore("jsdoc", "keyword", {
      "optional-parameter": {
        // @param {string} [baz.foo="bar"] foo bar
        pattern: RegExp(
          a + /\[(?:(?!\s)[$\w\xA0-\uFFFF.])+(?:=[^[\]]+)?\](?=\s|$)/.source
        ),
        lookbehind: !0,
        inside: {
          parameter: {
            pattern: /(^\[)[$\w\xA0-\uFFFF\.]+/,
            lookbehind: !0,
            inside: {
              punctuation: /\./
            }
          },
          code: {
            pattern: /(=)[\s\S]*(?=\]$)/,
            lookbehind: !0,
            inside: n,
            alias: "language-javascript"
          },
          punctuation: /[=[\]]/
        }
      },
      "class-name": [
        {
          pattern: RegExp(
            /(@(?:augments|class|extends|interface|memberof!?|template|this|typedef)\s+(?:<TYPE>\s+)?)[A-Z]\w*(?:\.[A-Z]\w*)*/.source.replace(
              /<TYPE>/g,
              function() {
                return r;
              }
            )
          ),
          lookbehind: !0,
          inside: {
            punctuation: /\./
          }
        },
        {
          pattern: RegExp("(@[a-z]+\\s+)" + r),
          lookbehind: !0,
          inside: {
            string: n.string,
            number: n.number,
            boolean: n.boolean,
            keyword: e.languages.typescript.keyword,
            operator: /=>|\.\.\.|[&|?:*]/,
            punctuation: /[.,;=<>{}()[\]]/
          }
        }
      ],
      example: {
        pattern: /(@example\s+(?!\s))(?:[^@\s]|\s+(?!\s))+?(?=\s*(?:\*\s*)?(?:@\w|\*\/))/,
        lookbehind: !0,
        inside: {
          code: {
            pattern: /^([\t ]*(?:\*\s*)?)\S.*$/m,
            lookbehind: !0,
            inside: n,
            alias: "language-javascript"
          }
        }
      }
    }), e.languages.javadoclike.addSupport("javascript", e.languages.jsdoc);
  }(t);
}
Jz.displayName = "n4js";
Jz.aliases = ["n4jsd"];
function Jz(t) {
  t.register(rl), t.languages.n4js = t.languages.extend("javascript", {
    // Keywords from N4JS language spec: https://numberfour.github.io/n4js/spec/N4JSSpec.html
    keyword: /\b(?:Array|any|boolean|break|case|catch|class|const|constructor|continue|debugger|declare|default|delete|do|else|enum|export|extends|false|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|module|new|null|number|package|private|protected|public|return|set|static|string|super|switch|this|throw|true|try|typeof|var|void|while|with|yield)\b/
  }), t.languages.insertBefore("n4js", "constant", {
    // Annotations in N4JS spec: https://numberfour.github.io/n4js/spec/N4JSSpec.html#_annotations
    annotation: {
      pattern: /@+\w+/,
      alias: "operator"
    }
  }), t.languages.n4jsd = t.languages.n4js;
}
e8.displayName = "js-extras";
e8.aliases = [];
function e8(t) {
  t.register(rl), function(e) {
    e.languages.insertBefore("javascript", "function-variable", {
      "method-variable": {
        pattern: RegExp(
          "(\\.\\s*)" + e.languages.javascript["function-variable"].pattern.source
        ),
        lookbehind: !0,
        alias: ["function-variable", "method", "function", "property-access"]
      }
    }), e.languages.insertBefore("javascript", "function", {
      method: {
        pattern: RegExp(
          "(\\.\\s*)" + e.languages.javascript.function.source
        ),
        lookbehind: !0,
        alias: ["function", "property-access"]
      }
    }), e.languages.insertBefore("javascript", "constant", {
      "known-class-name": [
        {
          // standard built-ins
          // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects
          pattern: /\b(?:(?:Float(?:32|64)|(?:Int|Uint)(?:8|16|32)|Uint8Clamped)?Array|ArrayBuffer|BigInt|Boolean|DataView|Date|Error|Function|Intl|JSON|(?:Weak)?(?:Map|Set)|Math|Number|Object|Promise|Proxy|Reflect|RegExp|String|Symbol|WebAssembly)\b/,
          alias: "class-name"
        },
        {
          // errors
          pattern: /\b(?:[A-Z]\w*)Error\b/,
          alias: "class-name"
        }
      ]
    });
    function n(u, f) {
      return RegExp(
        u.replace(/<ID>/g, function() {
          return /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/.source;
        }),
        f
      );
    }
    e.languages.insertBefore("javascript", "keyword", {
      imports: {
        // https://tc39.es/ecma262/#sec-imports
        pattern: n(
          /(\bimport\b\s*)(?:<ID>(?:\s*,\s*(?:\*\s*as\s+<ID>|\{[^{}]*\}))?|\*\s*as\s+<ID>|\{[^{}]*\})(?=\s*\bfrom\b)/.source
        ),
        lookbehind: !0,
        inside: e.languages.javascript
      },
      exports: {
        // https://tc39.es/ecma262/#sec-exports
        pattern: n(
          /(\bexport\b\s*)(?:\*(?:\s*as\s+<ID>)?(?=\s*\bfrom\b)|\{[^{}]*\})/.source
        ),
        lookbehind: !0,
        inside: e.languages.javascript
      }
    }), e.languages.javascript.keyword.unshift(
      {
        pattern: /\b(?:as|default|export|from|import)\b/,
        alias: "module"
      },
      {
        pattern: /\b(?:await|break|catch|continue|do|else|finally|for|if|return|switch|throw|try|while|yield)\b/,
        alias: "control-flow"
      },
      {
        pattern: /\bnull\b/,
        alias: ["null", "nil"]
      },
      {
        pattern: /\bundefined\b/,
        alias: "nil"
      }
    ), e.languages.insertBefore("javascript", "operator", {
      spread: {
        pattern: /\.{3}/,
        alias: "operator"
      },
      arrow: {
        pattern: /=>/,
        alias: "operator"
      }
    }), e.languages.insertBefore("javascript", "punctuation", {
      "property-access": {
        pattern: n(/(\.\s*)#?<ID>/.source),
        lookbehind: !0
      },
      "maybe-class-name": {
        pattern: /(^|[^$\w\xA0-\uFFFF])[A-Z][$\w\xA0-\uFFFF]+/,
        lookbehind: !0
      },
      dom: {
        // this contains only a few commonly used DOM variables
        pattern: /\b(?:document|(?:local|session)Storage|location|navigator|performance|window)\b/,
        alias: "variable"
      },
      console: {
        pattern: /\bconsole(?=\s*\.)/,
        alias: "class-name"
      }
    });
    for (var r = [
      "function",
      "function-variable",
      "method",
      "method-variable",
      "property-access"
    ], a = 0; a < r.length; a++) {
      var i = r[a], o = e.languages.javascript[i];
      e.util.type(o) === "RegExp" && (o = e.languages.javascript[i] = {
        pattern: o
      });
      var s = o.inside || {};
      o.inside = s, s["maybe-class-name"] = /^[A-Z][\s\S]*/;
    }
  }(t);
}
t8.displayName = "json5";
t8.aliases = [];
function t8(t) {
  t.register(b1), function(e) {
    var n = /("|')(?:\\(?:\r\n?|\n|.)|(?!\1)[^\\\r\n])*\1/;
    e.languages.json5 = e.languages.extend("json", {
      property: [
        {
          pattern: RegExp(n.source + "(?=\\s*:)"),
          greedy: !0
        },
        {
          pattern: /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/,
          alias: "unquoted"
        }
      ],
      string: {
        pattern: n,
        greedy: !0
      },
      number: /[+-]?\b(?:NaN|Infinity|0x[a-fA-F\d]+)\b|[+-]?(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[eE][+-]?\d+\b)?/
    });
  }(t);
}
n8.displayName = "jsonp";
n8.aliases = [];
function n8(t) {
  t.register(b1), t.languages.jsonp = t.languages.extend("json", {
    punctuation: /[{}[\]();,.]/
  }), t.languages.insertBefore("jsonp", "punctuation", {
    function: /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*\()/
  });
}
r8.displayName = "jsstacktrace";
r8.aliases = [];
function r8(t) {
  t.languages.jsstacktrace = {
    "error-message": {
      pattern: /^\S.*/m,
      alias: "string"
    },
    "stack-frame": {
      pattern: /(^[ \t]+)at[ \t].*/m,
      lookbehind: !0,
      inside: {
        "not-my-code": {
          pattern: /^at[ \t]+(?!\s)(?:node\.js|<unknown>|.*(?:node_modules|\(<anonymous>\)|\(<unknown>|<anonymous>$|\(internal\/|\(node\.js)).*/m,
          alias: "comment"
        },
        filename: {
          pattern: /(\bat\s+(?!\s)|\()(?:[a-zA-Z]:)?[^():]+(?=:)/,
          lookbehind: !0,
          alias: "url"
        },
        function: {
          pattern: /(\bat\s+(?:new\s+)?)(?!\s)[_$a-zA-Z\xA0-\uFFFF<][.$\w\xA0-\uFFFF<>]*/,
          lookbehind: !0,
          inside: {
            punctuation: /\./
          }
        },
        punctuation: /[()]/,
        keyword: /\b(?:at|new)\b/,
        alias: {
          pattern: /\[(?:as\s+)?(?!\s)[_$a-zA-Z\xA0-\uFFFF][$\w\xA0-\uFFFF]*\]/,
          alias: "variable"
        },
        "line-number": {
          pattern: /:\d+(?::\d+)?\b/,
          alias: "number",
          inside: {
            punctuation: /:/
          }
        }
      }
    }
  };
}
a8.displayName = "julia";
a8.aliases = [];
function a8(t) {
  t.languages.julia = {
    comment: {
      // support one level of nested comments
      // https://github.com/JuliaLang/julia/pull/6128
      pattern: /(^|[^\\])(?:#=(?:[^#=]|=(?!#)|#(?!=)|#=(?:[^#=]|=(?!#)|#(?!=))*=#)*=#|#.*)/,
      lookbehind: !0
    },
    regex: {
      // https://docs.julialang.org/en/v1/manual/strings/#Regular-Expressions-1
      pattern: /r"(?:\\.|[^"\\\r\n])*"[imsx]{0,4}/,
      greedy: !0
    },
    string: {
      // https://docs.julialang.org/en/v1/manual/strings/#String-Basics-1
      // https://docs.julialang.org/en/v1/manual/strings/#non-standard-string-literals-1
      // https://docs.julialang.org/en/v1/manual/running-external-programs/#Running-External-Programs-1
      pattern: /"""[\s\S]+?"""|(?:\b\w+)?"(?:\\.|[^"\\\r\n])*"|`(?:[^\\`\r\n]|\\.)*`/,
      greedy: !0
    },
    char: {
      // https://docs.julialang.org/en/v1/manual/strings/#man-characters-1
      pattern: /(^|[^\w'])'(?:\\[^\r\n][^'\r\n]*|[^\\\r\n])'/,
      lookbehind: !0,
      greedy: !0
    },
    keyword: /\b(?:abstract|baremodule|begin|bitstype|break|catch|ccall|const|continue|do|else|elseif|end|export|finally|for|function|global|if|immutable|import|importall|in|let|local|macro|module|print|println|quote|return|struct|try|type|typealias|using|while)\b/,
    boolean: /\b(?:false|true)\b/,
    number: /(?:\b(?=\d)|\B(?=\.))(?:0[box])?(?:[\da-f]+(?:_[\da-f]+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[efp][+-]?\d+(?:_\d+)*)?j?/i,
    // https://docs.julialang.org/en/v1/manual/mathematical-operations/
    // https://docs.julialang.org/en/v1/manual/mathematical-operations/#Operator-Precedence-and-Associativity-1
    operator: /&&|\|\||[-+*^%÷⊻&$\\]=?|\/[\/=]?|!=?=?|\|[=>]?|<(?:<=?|[=:|])?|>(?:=|>>?=?)?|==?=?|[~≠≤≥'√∛]/,
    punctuation: /::?|[{}[\]();,.?]/,
    // https://docs.julialang.org/en/v1/base/numbers/#Base.im
    constant: /\b(?:(?:Inf|NaN)(?:16|32|64)?|im|pi)\b|[πℯ]/
  };
}
i8.displayName = "keepalived";
i8.aliases = [];
function i8(t) {
  t.languages.keepalived = {
    comment: {
      pattern: /[#!].*/,
      greedy: !0
    },
    string: {
      pattern: /(^|[^\\])(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/,
      lookbehind: !0,
      greedy: !0
    },
    // support IPv4, IPv6, subnet mask
    ip: {
      pattern: RegExp(
        /\b(?:(?:(?:[\da-f]{1,4}:){7}[\da-f]{1,4}|(?:[\da-f]{1,4}:){6}:[\da-f]{1,4}|(?:[\da-f]{1,4}:){5}:(?:[\da-f]{1,4}:)?[\da-f]{1,4}|(?:[\da-f]{1,4}:){4}:(?:[\da-f]{1,4}:){0,2}[\da-f]{1,4}|(?:[\da-f]{1,4}:){3}:(?:[\da-f]{1,4}:){0,3}[\da-f]{1,4}|(?:[\da-f]{1,4}:){2}:(?:[\da-f]{1,4}:){0,4}[\da-f]{1,4}|(?:[\da-f]{1,4}:){6}<ipv4>|(?:[\da-f]{1,4}:){0,5}:<ipv4>|::(?:[\da-f]{1,4}:){0,5}<ipv4>|[\da-f]{1,4}::(?:[\da-f]{1,4}:){0,5}[\da-f]{1,4}|::(?:[\da-f]{1,4}:){0,6}[\da-f]{1,4}|(?:[\da-f]{1,4}:){1,7}:)(?:\/\d{1,3})?|<ipv4>(?:\/\d{1,2})?)\b/.source.replace(
          /<ipv4>/g,
          function() {
            return /(?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)\.){3}(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d))/.source;
          }
        ),
        "i"
      ),
      alias: "number"
    },
    // support *nix / Windows, directory / file
    path: {
      pattern: /(\s)\/(?:[^\/\s]+\/)*[^\/\s]*|\b[a-zA-Z]:\\(?:[^\\\s]+\\)*[^\\\s]*/,
      lookbehind: !0,
      alias: "string"
    },
    variable: /\$\{?\w+\}?/,
    email: {
      pattern: /[\w-]+@[\w-]+(?:\.[\w-]{2,3}){1,2}/,
      alias: "string"
    },
    "conditional-configuration": {
      pattern: /@\^?[\w-]+/,
      alias: "variable"
    },
    operator: /=/,
    property: /\b(?:BFD_CHECK|DNS_CHECK|FILE_CHECK|HTTP_GET|MISC_CHECK|NAME|PING_CHECK|SCRIPTS|SMTP_CHECK|SSL|SSL_GET|TCP_CHECK|UDP_CHECK|accept|advert_int|alpha|auth_pass|auth_type|authentication|bfd_cpu_affinity|bfd_instance|bfd_no_swap|bfd_priority|bfd_process_name|bfd_rlimit_rttime|bfd_rt_priority|bind_if|bind_port|bindto|ca|certificate|check_unicast_src|checker|checker_cpu_affinity|checker_log_all_failures|checker_no_swap|checker_priority|checker_rlimit_rttime|checker_rt_priority|child_wait_time|connect_ip|connect_port|connect_timeout|dbus_service_name|debug|default_interface|delay|delay_before_retry|delay_loop|digest|dont_track_primary|dynamic|dynamic_interfaces|enable_(?:dbus|script_security|sni|snmp_checker|snmp_rfc|snmp_rfcv2|snmp_rfcv3|snmp_vrrp|traps)|end|fall|fast_recovery|file|flag-[123]|fork_delay|full_command|fwmark|garp_group|garp_interval|garp_lower_prio_delay|garp_lower_prio_repeat|garp_master_delay|garp_master_refresh|garp_master_refresh_repeat|garp_master_repeat|global_defs|global_tracking|gna_interval|group|ha_suspend|hashed|helo_name|higher_prio_send_advert|hoplimit|http_protocol|hysteresis|idle_tx|include|inhibit_on_failure|init_fail|init_file|instance|interface|interfaces|interval|ip_family|ipvs_process_name|keepalived.conf|kernel_rx_buf_size|key|linkbeat_interfaces|linkbeat_use_polling|log_all_failures|log_unknown_vrids|lower_prio_no_advert|lthreshold|lvs_flush|lvs_flush_onstop|lvs_method|lvs_netlink_cmd_rcv_bufs|lvs_netlink_cmd_rcv_bufs_force|lvs_netlink_monitor_rcv_bufs|lvs_netlink_monitor_rcv_bufs_force|lvs_notify_fifo|lvs_notify_fifo_script|lvs_sched|lvs_sync_daemon|max_auto_priority|max_hops|mcast_src_ip|mh-fallback|mh-port|min_auto_priority_delay|min_rx|min_tx|misc_dynamic|misc_path|misc_timeout|multiplier|name|namespace_with_ipsets|native_ipv6|neighbor_ip|net_namespace|net_namespace_ipvs|nftables|nftables_counters|nftables_ifindex|nftables_priority|no_accept|no_checker_emails|no_email_faults|nopreempt|notification_email|notification_email_from|notify|notify_backup|notify_deleted|notify_down|notify_fault|notify_fifo|notify_fifo_script|notify_master|notify_master_rx_lower_pri|notify_priority_changes|notify_stop|notify_up|old_unicast_checksum|omega|ops|param_match|passive|password|path|persistence_engine|persistence_granularity|persistence_timeout|preempt|preempt_delay|priority|process|process_monitor_rcv_bufs|process_monitor_rcv_bufs_force|process_name|process_names|promote_secondaries|protocol|proxy_arp|proxy_arp_pvlan|quorum|quorum_down|quorum_max|quorum_up|random_seed|real_server|regex|regex_max_offset|regex_min_offset|regex_no_match|regex_options|regex_stack|reload_repeat|reload_time_file|require_reply|retry|rise|router_id|rs_init_notifies|script|script_user|sh-fallback|sh-port|shutdown_script|shutdown_script_timeout|skip_check_adv_addr|smtp_alert|smtp_alert_checker|smtp_alert_vrrp|smtp_connect_timeout|smtp_helo_name|smtp_server|snmp_socket|sorry_server|sorry_server_inhibit|sorry_server_lvs_method|source_ip|start|startup_script|startup_script_timeout|state|static_ipaddress|static_routes|static_rules|status_code|step|strict_mode|sync_group_tracking_weight|terminate_delay|timeout|track_bfd|track_file|track_group|track_interface|track_process|track_script|track_src_ip|ttl|type|umask|unicast_peer|unicast_src_ip|unicast_ttl|url|use_ipvlan|use_pid_dir|use_vmac|user|uthreshold|val[123]|version|virtual_ipaddress|virtual_ipaddress_excluded|virtual_router_id|virtual_routes|virtual_rules|virtual_server|virtual_server_group|virtualhost|vmac_xmit_base|vrrp|vrrp_(?:check_unicast_src|cpu_affinity|garp_interval|garp_lower_prio_delay|garp_lower_prio_repeat|garp_master_delay|garp_master_refresh|garp_master_refresh_repeat|garp_master_repeat|gna_interval|higher_prio_send_advert|instance|ipsets|iptables|lower_prio_no_advert|mcast_group4|mcast_group6|min_garp|netlink_cmd_rcv_bufs|netlink_cmd_rcv_bufs_force|netlink_monitor_rcv_bufs|netlink_monitor_rcv_bufs_force|no_swap|notify_fifo|notify_fifo_script|notify_priority_changes|priority|process_name|rlimit_rttime|rt_priority|rx_bufs_multiplier|rx_bufs_policy|script|skip_check_adv_addr|startup_delay|strict|sync_group|track_process|version)|warmup|weight)\b/,
    constant: /\b(?:A|AAAA|AH|BACKUP|CNAME|DR|MASTER|MX|NAT|NS|PASS|SCTP|SOA|TCP|TUN|TXT|UDP|dh|fo|lblc|lblcr|lc|mh|nq|ovf|rr|sed|sh|wlc|wrr)\b/,
    number: {
      pattern: /(^|[^\w.-])-?\d+(?:\.\d+)?/,
      lookbehind: !0
    },
    boolean: /\b(?:false|no|off|on|true|yes)\b/,
    punctuation: /[\{\}]/
  };
}
o8.displayName = "keyman";
o8.aliases = [];
function o8(t) {
  t.languages.keyman = {
    comment: {
      pattern: /\bc .*/i,
      greedy: !0
    },
    string: {
      pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
      greedy: !0
    },
    "virtual-key": {
      pattern: /\[\s*(?:(?:ALT|CAPS|CTRL|LALT|LCTRL|NCAPS|RALT|RCTRL|SHIFT)\s+)*(?:[TKU]_[\w?]+|[A-E]\d\d?|"[^"\r\n]*"|'[^'\r\n]*')\s*\]/i,
      greedy: !0,
      alias: "function"
      // alias for styles
    },
    // https://help.keyman.com/developer/language/guide/headers
    "header-keyword": {
      pattern: /&\w+/,
      alias: "bold"
      // alias for styles
    },
    "header-statement": {
      pattern: /\b(?:bitmap|bitmaps|caps always off|caps on only|copyright|hotkey|language|layout|message|name|shift frees caps|version)\b/i,
      alias: "bold"
      // alias for styles
    },
    "rule-keyword": {
      pattern: /\b(?:any|baselayout|beep|call|context|deadkey|dk|if|index|layer|notany|nul|outs|platform|reset|return|save|set|store|use)\b/i,
      alias: "keyword"
    },
    "structural-keyword": {
      pattern: /\b(?:ansi|begin|group|match|newcontext|nomatch|postkeystroke|readonly|unicode|using keys)\b/i,
      alias: "keyword"
    },
    "compile-target": {
      pattern: /\$(?:keyman|keymanonly|keymanweb|kmfl|weaver):/i,
      alias: "property"
    },
    // U+####, x###, d### characters and numbers
    number: /\b(?:U\+[\dA-F]+|d\d+|x[\da-f]+|\d+)\b/i,
    operator: /[+>\\$]|\.\./,
    punctuation: /[()=,]/
  };
}
s8.displayName = "kumir";
s8.aliases = ["kum"];
function s8(t) {
  (function(e) {
    var n = /\s\x00-\x1f\x22-\x2f\x3a-\x3f\x5b-\x5e\x60\x7b-\x7e/.source;
    function r(a, i) {
      return RegExp(a.replace(/<nonId>/g, n), i);
    }
    e.languages.kumir = {
      comment: {
        pattern: /\|.*/
      },
      prolog: {
        pattern: /#.*/,
        greedy: !0
      },
      string: {
        pattern: /"[^\n\r"]*"|'[^\n\r']*'/,
        greedy: !0
      },
      boolean: {
        pattern: r(/(^|[<nonId>])(?:да|нет)(?=[<nonId>]|$)/.source),
        lookbehind: !0
      },
      "operator-word": {
        pattern: r(/(^|[<nonId>])(?:и|или|не)(?=[<nonId>]|$)/.source),
        lookbehind: !0,
        alias: "keyword"
      },
      "system-variable": {
        pattern: r(/(^|[<nonId>])знач(?=[<nonId>]|$)/.source),
        lookbehind: !0,
        alias: "keyword"
      },
      type: [
        {
          pattern: r(
            /(^|[<nonId>])(?:вещ|лит|лог|сим|цел)(?:\x20*таб)?(?=[<nonId>]|$)/.source
          ),
          lookbehind: !0,
          alias: "builtin"
        },
        {
          pattern: r(
            /(^|[<nonId>])(?:компл|сканкод|файл|цвет)(?=[<nonId>]|$)/.source
          ),
          lookbehind: !0,
          alias: "important"
        }
      ],
      /**
       * Should be performed after searching for type names because of "таб".
       * "таб" is a reserved word, but never used without a preceding type name.
       * "НАЗНАЧИТЬ", "Фввод", and "Фвывод" are not reserved words.
       */
      keyword: {
        pattern: r(
          /(^|[<nonId>])(?:алг|арг(?:\x20*рез)?|ввод|ВКЛЮЧИТЬ|вс[её]|выбор|вывод|выход|дано|для|до|дс|если|иначе|исп|использовать|кон(?:(?:\x20+|_)исп)?|кц(?:(?:\x20+|_)при)?|надо|нач|нс|нц|от|пауза|пока|при|раза?|рез|стоп|таб|то|утв|шаг)(?=[<nonId>]|$)/.source
        ),
        lookbehind: !0
      },
      /** Should be performed after searching for reserved words. */
      name: {
        // eslint-disable-next-line regexp/no-super-linear-backtracking
        pattern: r(
          /(^|[<nonId>])[^\d<nonId>][^<nonId>]*(?:\x20+[^<nonId>]+)*(?=[<nonId>]|$)/.source
        ),
        lookbehind: !0
      },
      /** Should be performed after searching for names. */
      number: {
        pattern: r(
          /(^|[<nonId>])(?:\B\$[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)(?=[<nonId>]|$)/.source,
          "i"
        ),
        lookbehind: !0
      },
      /** Should be performed after searching for words. */
      punctuation: /:=|[(),:;\[\]]/,
      /**
       * Should be performed after searching for
       * - numeric constants (because of "+" and "-");
       * - punctuation marks (because of ":=" and "=").
       */
      "operator-char": {
        pattern: /\*\*?|<[=>]?|>=?|[-+/=]/,
        alias: "operator"
      }
    }, e.languages.kum = e.languages.kumir;
  })(t);
}
l8.displayName = "kusto";
l8.aliases = [];
function l8(t) {
  t.languages.kusto = {
    comment: {
      pattern: /\/\/.*/,
      greedy: !0
    },
    string: {
      pattern: /```[\s\S]*?```|[hH]?(?:"(?:[^\r\n\\"]|\\.)*"|'(?:[^\r\n\\']|\\.)*'|@(?:"[^\r\n"]*"|'[^\r\n']*'))/,
      greedy: !0
    },
    verb: {
      pattern: /(\|\s*)[a-z][\w-]*/i,
      lookbehind: !0,
      alias: "keyword"
    },
    command: {
      pattern: /\.[a-z][a-z\d-]*\b/,
      alias: "keyword"
    },
    "class-name": /\b(?:bool|datetime|decimal|dynamic|guid|int|long|real|string|timespan)\b/,
    keyword: /\b(?:access|alias|and|anti|as|asc|auto|between|by|(?:contains|(?:ends|starts)with|has(?:perfix|suffix)?)(?:_cs)?|database|declare|desc|external|from|fullouter|has_all|in|ingestion|inline|inner|innerunique|into|(?:left|right)(?:anti(?:semi)?|inner|outer|semi)?|let|like|local|not|of|on|or|pattern|print|query_parameters|range|restrict|schema|set|step|table|tables|to|view|where|with|matches\s+regex|nulls\s+(?:first|last))(?![\w-])/,
    boolean: /\b(?:false|null|true)\b/,
    function: /\b[a-z_]\w*(?=\s*\()/,
    datetime: [
      {
        // RFC 822 + RFC 850
        pattern: /\b(?:(?:Fri|Friday|Mon|Monday|Sat|Saturday|Sun|Sunday|Thu|Thursday|Tue|Tuesday|Wed|Wednesday)\s*,\s*)?\d{1,2}(?:\s+|-)(?:Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep)(?:\s+|-)\d{2}\s+\d{2}:\d{2}(?::\d{2})?(?:\s*(?:\b(?:[A-Z]|(?:[ECMT][DS]|GM|U)T)|[+-]\d{4}))?\b/,
        alias: "number"
      },
      {
        // ISO 8601
        pattern: /[+-]?\b(?:\d{4}-\d{2}-\d{2}(?:[ T]\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?)?|\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?)Z?/,
        alias: "number"
      }
    ],
    number: /\b(?:0x[0-9A-Fa-f]+|\d+(?:\.\d+)?(?:[Ee][+-]?\d+)?)(?:(?:min|sec|[mnµ]s|[dhms]|microsecond|tick)\b)?|[+-]?\binf\b/,
    operator: /=>|[!=]~|[!=<>]=?|[-+*/%|]|\.\./,
    punctuation: /[()\[\]{},;.:]/
  };
}
u8.displayName = "latex";
u8.aliases = ["context", "tex"];
function u8(t) {
  (function(e) {
    var n = /\\(?:[^a-z()[\]]|[a-z*]+)/i, r = {
      "equation-command": {
        pattern: n,
        alias: "regex"
      }
    };
    e.languages.latex = {
      comment: /%.*/,
      // the verbatim environment prints whitespace to the document
      cdata: {
        pattern: /(\\begin\{((?:lstlisting|verbatim)\*?)\})[\s\S]*?(?=\\end\{\2\})/,
        lookbehind: !0
      },
      /*
       * equations can be between $$ $$ or $ $ or \( \) or \[ \]
       * (all are multiline)
       */
      equation: [
        {
          pattern: /\$\$(?:\\[\s\S]|[^\\$])+\$\$|\$(?:\\[\s\S]|[^\\$])+\$|\\\([\s\S]*?\\\)|\\\[[\s\S]*?\\\]/,
          inside: r,
          alias: "string"
        },
        {
          pattern: /(\\begin\{((?:align|eqnarray|equation|gather|math|multline)\*?)\})[\s\S]*?(?=\\end\{\2\})/,
          lookbehind: !0,
          inside: r,
          alias: "string"
        }
      ],
      /*
       * arguments which are keywords or references are highlighted
       * as keywords
       */
      keyword: {
        pattern: /(\\(?:begin|cite|documentclass|end|label|ref|usepackage)(?:\[[^\]]+\])?\{)[^}]+(?=\})/,
        lookbehind: !0
      },
      url: {
        pattern: /(\\url\{)[^}]+(?=\})/,
        lookbehind: !0
      },
      /*
       * section or chapter headlines are highlighted as bold so that
       * they stand out more
       */
      headline: {
        pattern: /(\\(?:chapter|frametitle|paragraph|part|section|subparagraph|subsection|subsubparagraph|subsubsection|subsubsubparagraph)\*?(?:\[[^\]]+\])?\{)[^}]+(?=\})/,
        lookbehind: !0,
        alias: "class-name"
      },
      function: {
        pattern: n,
        alias: "selector"
      },
      punctuation: /[[\]{}&]/
    }, e.languages.tex = e.languages.latex, e.languages.context = e.languages.latex;
  })(t);
}
c8.displayName = "latte";
c8.aliases = [];
function c8(t) {
  t.register(Lr), t.register(al), t.register(R0), function(e) {
    e.languages.latte = {
      comment: /^\{\*[\s\S]*/,
      "latte-tag": {
        // https://latte.nette.org/en/tags
        pattern: /(^\{(?:\/(?=[a-z]))?)(?:[=_]|[a-z]\w*\b(?!\())/i,
        lookbehind: !0,
        alias: "important"
      },
      delimiter: {
        pattern: /^\{\/?|\}$/,
        alias: "punctuation"
      },
      php: {
        pattern: /\S(?:[\s\S]*\S)?/,
        alias: "language-php",
        inside: e.languages.php
      }
    };
    var n = e.languages.extend("markup", {});
    e.languages.insertBefore(
      "inside",
      "attr-value",
      {
        "n-attr": {
          pattern: /n:[\w-]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+))?/,
          inside: {
            "attr-name": {
              pattern: /^[^\s=]+/,
              alias: "important"
            },
            "attr-value": {
              pattern: /=[\s\S]+/,
              inside: {
                punctuation: [
                  /^=/,
                  {
                    pattern: /^(\s*)["']|["']$/,
                    lookbehind: !0
                  }
                ],
                php: {
                  pattern: /\S(?:[\s\S]*\S)?/,
                  inside: e.languages.php
                }
              }
            }
          }
        }
      },
      n.tag
    ), e.hooks.add("before-tokenize", function(r) {
      if (r.language === "latte") {
        var a = /\{\*[\s\S]*?\*\}|\{[^'"\s{}*](?:[^"'/{}]|\/(?![*/])|("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|\/\*(?:[^*]|\*(?!\/))*\*\/)*\}/g;
        e.languages["markup-templating"].buildPlaceholders(
          r,
          "latte",
          a
        ), r.grammar = n;
      }
    }), e.hooks.add("after-tokenize", function(r) {
      e.languages["markup-templating"].tokenizePlaceholders(r, "latte");
    });
  }(t);
}
L_.displayName = "scheme";
L_.aliases = [];
function L_(t) {
  (function(e) {
    e.languages.scheme = {
      // this supports "normal" single-line comments:
      //   ; comment
      // and (potentially nested) multiline comments:
      //   #| comment #| nested |# still comment |#
      // (only 1 level of nesting is supported)
      comment: /;.*|#;\s*(?:\((?:[^()]|\([^()]*\))*\)|\[(?:[^\[\]]|\[[^\[\]]*\])*\])|#\|(?:[^#|]|#(?!\|)|\|(?!#)|#\|(?:[^#|]|#(?!\|)|\|(?!#))*\|#)*\|#/,
      string: {
        pattern: /"(?:[^"\\]|\\.)*"/,
        greedy: !0
      },
      symbol: {
        pattern: /'[^()\[\]#'\s]+/,
        greedy: !0
      },
      char: {
        pattern: /#\\(?:[ux][a-fA-F\d]+\b|[-a-zA-Z]+\b|[\uD800-\uDBFF][\uDC00-\uDFFF]|\S)/,
        greedy: !0
      },
      "lambda-parameter": [
        // https://www.cs.cmu.edu/Groups/AI/html/r4rs/r4rs_6.html#SEC30
        {
          pattern: /((?:^|[^'`#])[(\[]lambda\s+)(?:[^|()\[\]'\s]+|\|(?:[^\\|]|\\.)*\|)/,
          lookbehind: !0
        },
        {
          pattern: /((?:^|[^'`#])[(\[]lambda\s+[(\[])[^()\[\]']+/,
          lookbehind: !0
        }
      ],
      keyword: {
        pattern: /((?:^|[^'`#])[(\[])(?:begin|case(?:-lambda)?|cond(?:-expand)?|define(?:-library|-macro|-record-type|-syntax|-values)?|defmacro|delay(?:-force)?|do|else|except|export|guard|if|import|include(?:-ci|-library-declarations)?|lambda|let(?:rec)?(?:-syntax|-values|\*)?|let\*-values|only|parameterize|prefix|(?:quasi-?)?quote|rename|set!|syntax-(?:case|rules)|unless|unquote(?:-splicing)?|when)(?=[()\[\]\s]|$)/,
        lookbehind: !0
      },
      builtin: {
        // all functions of the base library of R7RS plus some of built-ins of R5Rs
        pattern: /((?:^|[^'`#])[(\[])(?:abs|and|append|apply|assoc|ass[qv]|binary-port\?|boolean=?\?|bytevector(?:-append|-copy|-copy!|-length|-u8-ref|-u8-set!|\?)?|caar|cadr|call-with-(?:current-continuation|port|values)|call\/cc|car|cdar|cddr|cdr|ceiling|char(?:->integer|-ready\?|\?|<\?|<=\?|=\?|>\?|>=\?)|close-(?:input-port|output-port|port)|complex\?|cons|current-(?:error|input|output)-port|denominator|dynamic-wind|eof-object\??|eq\?|equal\?|eqv\?|error|error-object(?:-irritants|-message|\?)|eval|even\?|exact(?:-integer-sqrt|-integer\?|\?)?|expt|features|file-error\?|floor(?:-quotient|-remainder|\/)?|flush-output-port|for-each|gcd|get-output-(?:bytevector|string)|inexact\??|input-port(?:-open\?|\?)|integer(?:->char|\?)|lcm|length|list(?:->string|->vector|-copy|-ref|-set!|-tail|\?)?|make-(?:bytevector|list|parameter|string|vector)|map|max|member|memq|memv|min|modulo|negative\?|newline|not|null\?|number(?:->string|\?)|numerator|odd\?|open-(?:input|output)-(?:bytevector|string)|or|output-port(?:-open\?|\?)|pair\?|peek-char|peek-u8|port\?|positive\?|procedure\?|quotient|raise|raise-continuable|rational\?|rationalize|read-(?:bytevector|bytevector!|char|error\?|line|string|u8)|real\?|remainder|reverse|round|set-c[ad]r!|square|string(?:->list|->number|->symbol|->utf8|->vector|-append|-copy|-copy!|-fill!|-for-each|-length|-map|-ref|-set!|\?|<\?|<=\?|=\?|>\?|>=\?)?|substring|symbol(?:->string|\?|=\?)|syntax-error|textual-port\?|truncate(?:-quotient|-remainder|\/)?|u8-ready\?|utf8->string|values|vector(?:->list|->string|-append|-copy|-copy!|-fill!|-for-each|-length|-map|-ref|-set!|\?)?|with-exception-handler|write-(?:bytevector|char|string|u8)|zero\?)(?=[()\[\]\s]|$)/,
        lookbehind: !0
      },
      operator: {
        pattern: /((?:^|[^'`#])[(\[])(?:[-+*%/]|[<>]=?|=>?)(?=[()\[\]\s]|$)/,
        lookbehind: !0
      },
      number: {
        // The number pattern from [the R7RS spec](https://small.r7rs.org/attachment/r7rs.pdf).
        //
        // <number>      := <num 2>|<num 8>|<num 10>|<num 16>
        // <num R>       := <prefix R><complex R>
        // <complex R>   := <real R>(?:@<real R>|<imaginary R>)?|<imaginary R>
        // <imaginary R> := [+-](?:<ureal R>|(?:inf|nan)\.0)?i
        // <real R>      := [+-]?<ureal R>|[+-](?:inf|nan)\.0
        // <ureal R>     := <uint R>(?:\/<uint R>)?
        //                | <decimal R>
        //
        // <decimal 10>  := (?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?
        // <uint R>      := <digit R>+
        // <prefix R>    := <radix R>(?:#[ei])?|(?:#[ei])?<radix R>
        // <radix 2>     := #b
        // <radix 8>     := #o
        // <radix 10>    := (?:#d)?
        // <radix 16>    := #x
        // <digit 2>     := [01]
        // <digit 8>     := [0-7]
        // <digit 10>    := \d
        // <digit 16>    := [0-9a-f]
        //
        // The problem with this grammar is that the resulting regex is way to complex, so we simplify by grouping all
        // non-decimal bases together. This results in a decimal (dec) and combined binary, octal, and hexadecimal (box)
        // pattern:
        pattern: RegExp(
          n({
            "<ureal dec>": /\d+(?:\/\d+)|(?:\d+(?:\.\d*)?|\.\d+)(?:[esfdl][+-]?\d+)?/.source,
            "<real dec>": /[+-]?<ureal dec>|[+-](?:inf|nan)\.0/.source,
            "<imaginary dec>": /[+-](?:<ureal dec>|(?:inf|nan)\.0)?i/.source,
            "<complex dec>": /<real dec>(?:@<real dec>|<imaginary dec>)?|<imaginary dec>/.source,
            "<num dec>": /(?:#d(?:#[ei])?|#[ei](?:#d)?)?<complex dec>/.source,
            "<ureal box>": /[0-9a-f]+(?:\/[0-9a-f]+)?/.source,
            "<real box>": /[+-]?<ureal box>|[+-](?:inf|nan)\.0/.source,
            "<imaginary box>": /[+-](?:<ureal box>|(?:inf|nan)\.0)?i/.source,
            "<complex box>": /<real box>(?:@<real box>|<imaginary box>)?|<imaginary box>/.source,
            "<num box>": /#[box](?:#[ei])?|(?:#[ei])?#[box]<complex box>/.source,
            "<number>": /(^|[()\[\]\s])(?:<num dec>|<num box>)(?=[()\[\]\s]|$)/.source
          }),
          "i"
        ),
        lookbehind: !0
      },
      boolean: {
        pattern: /(^|[()\[\]\s])#(?:[ft]|false|true)(?=[()\[\]\s]|$)/,
        lookbehind: !0
      },
      function: {
        pattern: /((?:^|[^'`#])[(\[])(?:[^|()\[\]'\s]+|\|(?:[^\\|]|\\.)*\|)(?=[()\[\]\s]|$)/,
        lookbehind: !0
      },
      identifier: {
        pattern: /(^|[()\[\]\s])\|(?:[^\\|]|\\.)*\|(?=[()\[\]\s]|$)/,
        lookbehind: !0,
        greedy: !0
      },
      punctuation: /[()\[\]']/
    };
    function n(r) {
      for (var a in r)
        r[a] = r[a].replace(/<[\w\s]+>/g, function(i) {
          return "(?:" + r[i].trim() + ")";
        });
      return r[a];
    }
  })(t);
}
f8.displayName = "lilypond";
f8.aliases = ["ly"];
function f8(t) {
  t.register(L_), function(e) {
    for (var n = /\((?:[^();"#\\]|\\[\s\S]|;.*(?!.)|"(?:[^"\\]|\\.)*"|#(?:\{(?:(?!#\})[\s\S])*#\}|[^{])|<expr>)*\)/.source, r = 5, a = 0; a < r; a++)
      n = n.replace(/<expr>/g, function() {
        return n;
      });
    n = n.replace(/<expr>/g, /[^\s\S]/.source);
    var i = e.languages.lilypond = {
      comment: /%(?:(?!\{).*|\{[\s\S]*?%\})/,
      "embedded-scheme": {
        pattern: RegExp(
          /(^|[=\s])#(?:"(?:[^"\\]|\\.)*"|[^\s()"]*(?:[^\s()]|<expr>))/.source.replace(
            /<expr>/g,
            function() {
              return n;
            }
          ),
          "m"
        ),
        lookbehind: !0,
        greedy: !0,
        inside: {
          scheme: {
            pattern: /^(#)[\s\S]+$/,
            lookbehind: !0,
            alias: "language-scheme",
            inside: {
              "embedded-lilypond": {
                pattern: /#\{[\s\S]*?#\}/,
                greedy: !0,
                inside: {
                  punctuation: /^#\{|#\}$/,
                  lilypond: {
                    pattern: /[\s\S]+/,
                    alias: "language-lilypond",
                    inside: null
                    // see below
                  }
                }
              },
              rest: e.languages.scheme
            }
          },
          punctuation: /#/
        }
      },
      string: {
        pattern: /"(?:[^"\\]|\\.)*"/,
        greedy: !0
      },
      "class-name": {
        pattern: /(\\new\s+)[\w-]+/,
        lookbehind: !0
      },
      keyword: {
        pattern: /\\[a-z][-\w]*/i,
        inside: {
          punctuation: /^\\/
        }
      },
      operator: /[=|]|<<|>>/,
      punctuation: {
        pattern: /(^|[a-z\d])(?:'+|,+|[_^]?-[_^]?(?:[-+^!>._]|(?=\d))|[_^]\.?|[.!])|[{}()[\]<>^~]|\\[()[\]<>\\!]|--|__/,
        lookbehind: !0
      },
      number: /\b\d+(?:\/\d+)?\b/
    };
    i["embedded-scheme"].inside.scheme.inside["embedded-lilypond"].inside.lilypond.inside = i, e.languages.ly = i;
  }(t);
}
d8.displayName = "liquid";
d8.aliases = [];
function d8(t) {
  t.register(al), t.languages.liquid = {
    comment: {
      pattern: /(^\{%\s*comment\s*%\})[\s\S]+(?=\{%\s*endcomment\s*%\}$)/,
      lookbehind: !0
    },
    delimiter: {
      pattern: /^\{(?:\{\{|[%\{])-?|-?(?:\}\}|[%\}])\}$/,
      alias: "punctuation"
    },
    string: {
      pattern: /"[^"]*"|'[^']*'/,
      greedy: !0
    },
    keyword: /\b(?:as|assign|break|(?:end)?(?:capture|case|comment|for|form|if|paginate|raw|style|tablerow|unless)|continue|cycle|decrement|echo|else|elsif|in|include|increment|limit|liquid|offset|range|render|reversed|section|when|with)\b/,
    object: /\b(?:address|all_country_option_tags|article|block|blog|cart|checkout|collection|color|country|country_option_tags|currency|current_page|current_tags|customer|customer_address|date|discount_allocation|discount_application|external_video|filter|filter_value|font|forloop|fulfillment|generic_file|gift_card|group|handle|image|line_item|link|linklist|localization|location|measurement|media|metafield|model|model_source|order|page|page_description|page_image|page_title|part|policy|product|product_option|recommendations|request|robots|routes|rule|script|search|selling_plan|selling_plan_allocation|selling_plan_group|shipping_method|shop|shop_locale|sitemap|store_availability|tax_line|template|theme|transaction|unit_price_measurement|user_agent|variant|video|video_source)\b/,
    function: [
      {
        pattern: /(\|\s*)\w+/,
        lookbehind: !0,
        alias: "filter"
      },
      {
        // array functions
        pattern: /(\.\s*)(?:first|last|size)/,
        lookbehind: !0
      }
    ],
    boolean: /\b(?:false|nil|true)\b/,
    range: {
      pattern: /\.\./,
      alias: "operator"
    },
    // https://github.com/Shopify/liquid/blob/698f5e0d967423e013f6169d9111bd969bd78337/lib/liquid/lexer.rb#L21
    number: /\b\d+(?:\.\d+)?\b/,
    operator: /[!=]=|<>|[<>]=?|[|?:=-]|\b(?:and|contains(?=\s)|or)\b/,
    punctuation: /[.,\[\]()]/,
    empty: {
      pattern: /\bempty\b/,
      alias: "keyword"
    }
  }, t.hooks.add("before-tokenize", function(e) {
    var n = /\{%\s*comment\s*%\}[\s\S]*?\{%\s*endcomment\s*%\}|\{(?:%[\s\S]*?%|\{\{[\s\S]*?\}\}|\{[\s\S]*?\})\}/g, r = !1;
    t.languages["markup-templating"].buildPlaceholders(
      e,
      "liquid",
      n,
      function(a) {
        var i = /^\{%-?\s*(\w+)/.exec(a);
        if (i) {
          var o = i[1];
          if (o === "raw" && !r)
            return r = !0, !0;
          if (o === "endraw")
            return r = !1, !0;
        }
        return !r;
      }
    );
  }), t.hooks.add("after-tokenize", function(e) {
    t.languages["markup-templating"].tokenizePlaceholders(e, "liquid");
  });
}
p8.displayName = "lisp";
p8.aliases = ["elisp", "emacs", "emacs-lisp"];
function p8(t) {
  (function(e) {
    function n(w) {
      return RegExp(/(\()/.source + "(?:" + w + ")" + /(?=[\s\)])/.source);
    }
    function r(w) {
      return RegExp(
        /([\s([])/.source + "(?:" + w + ")" + /(?=[\s)])/.source
      );
    }
    var a = /(?!\d)[-+*/~!@$%^=<>{}\w]+/.source, i = "&" + a, o = "(\\()", s = "(?=\\))", u = "(?=\\s)", f = /(?:[^()]|\((?:[^()]|\((?:[^()]|\((?:[^()]|\((?:[^()]|\([^()]*\))*\))*\))*\))*\))*/.source, p = {
      // Three or four semicolons are considered a heading.
      // See https://www.gnu.org/software/emacs/manual/html_node/elisp/Comment-Tips.html
      heading: {
        pattern: /;;;.*/,
        alias: ["comment", "title"]
      },
      comment: /;.*/,
      string: {
        pattern: /"(?:[^"\\]|\\.)*"/,
        greedy: !0,
        inside: {
          argument: /[-A-Z]+(?=[.,\s])/,
          symbol: RegExp("`" + a + "'")
        }
      },
      "quoted-symbol": {
        pattern: RegExp("#?'" + a),
        alias: ["variable", "symbol"]
      },
      "lisp-property": {
        pattern: RegExp(":" + a),
        alias: "property"
      },
      splice: {
        pattern: RegExp(",@?" + a),
        alias: ["symbol", "variable"]
      },
      keyword: [
        {
          pattern: RegExp(
            o + "(?:and|(?:cl-)?letf|cl-loop|cond|cons|error|if|(?:lexical-)?let\\*?|message|not|null|or|provide|require|setq|unless|use-package|when|while)" + u
          ),
          lookbehind: !0
        },
        {
          pattern: RegExp(
            o + "(?:append|by|collect|concat|do|finally|for|in|return)" + u
          ),
          lookbehind: !0
        }
      ],
      declare: {
        pattern: n(/declare/.source),
        lookbehind: !0,
        alias: "keyword"
      },
      interactive: {
        pattern: n(/interactive/.source),
        lookbehind: !0,
        alias: "keyword"
      },
      boolean: {
        pattern: r(/nil|t/.source),
        lookbehind: !0
      },
      number: {
        pattern: r(/[-+]?\d+(?:\.\d*)?/.source),
        lookbehind: !0
      },
      defvar: {
        pattern: RegExp(o + "def(?:const|custom|group|var)\\s+" + a),
        lookbehind: !0,
        inside: {
          keyword: /^def[a-z]+/,
          variable: RegExp(a)
        }
      },
      defun: {
        pattern: RegExp(
          o + /(?:cl-)?(?:defmacro|defun\*?)\s+/.source + a + /\s+\(/.source + f + /\)/.source
        ),
        lookbehind: !0,
        greedy: !0,
        inside: {
          keyword: /^(?:cl-)?def\S+/,
          // See below, this property needs to be defined later so that it can
          // reference the language object.
          arguments: null,
          function: {
            pattern: RegExp("(^\\s)" + a),
            lookbehind: !0
          },
          punctuation: /[()]/
        }
      },
      lambda: {
        pattern: RegExp(
          o + "lambda\\s+\\(\\s*(?:&?" + a + "(?:\\s+&?" + a + ")*\\s*)?\\)"
        ),
        lookbehind: !0,
        greedy: !0,
        inside: {
          keyword: /^lambda/,
          // See below, this property needs to be defined later so that it can
          // reference the language object.
          arguments: null,
          punctuation: /[()]/
        }
      },
      car: {
        pattern: RegExp(o + a),
        lookbehind: !0
      },
      punctuation: [
        // open paren, brackets, and close paren
        /(?:['`,]?\(|[)\[\]])/,
        // cons
        {
          pattern: /(\s)\.(?=\s)/,
          lookbehind: !0
        }
      ]
    }, m = {
      "lisp-marker": RegExp(i),
      varform: {
        pattern: RegExp(
          /\(/.source + a + /\s+(?=\S)/.source + f + /\)/.source
        ),
        inside: p
      },
      argument: {
        pattern: RegExp(/(^|[\s(])/.source + a),
        lookbehind: !0,
        alias: "variable"
      },
      rest: p
    }, v = "\\S+(?:\\s+\\S+)*", O = {
      pattern: RegExp(o + f + s),
      lookbehind: !0,
      inside: {
        "rest-vars": {
          pattern: RegExp("&(?:body|rest)\\s+" + v),
          inside: m
        },
        "other-marker-vars": {
          pattern: RegExp("&(?:aux|optional)\\s+" + v),
          inside: m
        },
        keys: {
          pattern: RegExp("&key\\s+" + v + "(?:\\s+&allow-other-keys)?"),
          inside: m
        },
        argument: {
          pattern: RegExp(a),
          alias: "variable"
        },
        punctuation: /[()]/
      }
    };
    p.lambda.inside.arguments = O, p.defun.inside.arguments = e.util.clone(O), p.defun.inside.arguments.inside.sublist = O, e.languages.lisp = p, e.languages.elisp = p, e.languages.emacs = p, e.languages["emacs-lisp"] = p;
  })(t);
}
h8.displayName = "livescript";
h8.aliases = [];
function h8(t) {
  t.languages.livescript = {
    comment: [
      {
        pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
        lookbehind: !0
      },
      {
        pattern: /(^|[^\\])#.*/,
        lookbehind: !0
      }
    ],
    "interpolated-string": {
      /* Look-behind and look-ahead prevents wrong behavior of the greedy pattern
       * forcing it to match """-quoted string when it would otherwise match "-quoted first. */
      pattern: /(^|[^"])("""|")(?:\\[\s\S]|(?!\2)[^\\])*\2(?!")/,
      lookbehind: !0,
      greedy: !0,
      inside: {
        variable: {
          pattern: /(^|[^\\])#[a-z_](?:-?[a-z]|[\d_])*/m,
          lookbehind: !0
        },
        interpolation: {
          pattern: /(^|[^\\])#\{[^}]+\}/m,
          lookbehind: !0,
          inside: {
            "interpolation-punctuation": {
              pattern: /^#\{|\}$/,
              alias: "variable"
            }
            // See rest below
          }
        },
        string: /[\s\S]+/
      }
    },
    string: [
      {
        pattern: /('''|')(?:\\[\s\S]|(?!\1)[^\\])*\1/,
        greedy: !0
      },
      {
        pattern: /<\[[\s\S]*?\]>/,
        greedy: !0
      },
      /\\[^\s,;\])}]+/
    ],
    regex: [
      {
        pattern: /\/\/(?:\[[^\r\n\]]*\]|\\.|(?!\/\/)[^\\\[])+\/\/[gimyu]{0,5}/,
        greedy: !0,
        inside: {
          comment: {
            pattern: /(^|[^\\])#.*/,
            lookbehind: !0
          }
        }
      },
      {
        pattern: /\/(?:\[[^\r\n\]]*\]|\\.|[^/\\\r\n\[])+\/[gimyu]{0,5}/,
        greedy: !0
      }
    ],
    keyword: {
      pattern: /(^|(?!-).)\b(?:break|case|catch|class|const|continue|default|do|else|extends|fallthrough|finally|for(?: ever)?|function|if|implements|it|let|loop|new|null|otherwise|own|return|super|switch|that|then|this|throw|try|unless|until|var|void|when|while|yield)(?!-)\b/m,
      lookbehind: !0
    },
    "keyword-operator": {
      pattern: /(^|[^-])\b(?:(?:delete|require|typeof)!|(?:and|by|delete|export|from|import(?: all)?|in|instanceof|is(?: not|nt)?|not|of|or|til|to|typeof|with|xor)(?!-)\b)/m,
      lookbehind: !0,
      alias: "operator"
    },
    boolean: {
      pattern: /(^|[^-])\b(?:false|no|off|on|true|yes)(?!-)\b/m,
      lookbehind: !0
    },
    argument: {
      // Don't match .&. nor &&
      pattern: /(^|(?!\.&\.)[^&])&(?!&)\d*/m,
      lookbehind: !0,
      alias: "variable"
    },
    number: /\b(?:\d+~[\da-z]+|\d[\d_]*(?:\.\d[\d_]*)?(?:[a-z]\w*)?)/i,
    identifier: /[a-z_](?:-?[a-z]|[\d_])*/i,
    operator: [
      // Spaced .
      {
        pattern: /( )\.(?= )/,
        lookbehind: !0
      },
      // Full list, in order:
      // .= .~ .. ...
      // .&. .^. .<<. .>>. .>>>.
      // := :: ::=
      // &&
      // || |>
      // < << <<< <<<<
      // <- <-- <-! <--!
      // <~ <~~ <~! <~~!
      // <| <= <?
      // > >> >= >?
      // - -- -> -->
      // + ++
      // @ @@
      // % %%
      // * **
      // ! != !~=
      // !~> !~~>
      // !-> !-->
      // ~ ~> ~~> ~=
      // = ==
      // ^ ^^
      // / ?
      /\.(?:[=~]|\.\.?)|\.(?:[&|^]|<<|>>>?)\.|:(?:=|:=?)|&&|\|[|>]|<(?:<<?<?|--?!?|~~?!?|[|=?])?|>[>=?]?|-(?:->?|>)?|\+\+?|@@?|%%?|\*\*?|!(?:~?=|--?>|~?~>)?|~(?:~?>|=)?|==?|\^\^?|[\/?]/
    ],
    punctuation: /[(){}\[\]|.,:;`]/
  }, t.languages.livescript["interpolated-string"].inside.interpolation.inside.rest = t.languages.livescript;
}
m8.displayName = "llvm";
m8.aliases = [];
function m8(t) {
  (function(e) {
    e.languages.llvm = {
      comment: /;.*/,
      string: {
        pattern: /"[^"]*"/,
        greedy: !0
      },
      boolean: /\b(?:false|true)\b/,
      variable: /[%@!#](?:(?!\d)(?:[-$.\w]|\\[a-f\d]{2})+|\d+)/i,
      label: /(?!\d)(?:[-$.\w]|\\[a-f\d]{2})+:/i,
      type: {
        pattern: /\b(?:double|float|fp128|half|i[1-9]\d*|label|metadata|ppc_fp128|token|void|x86_fp80|x86_mmx)\b/,
        alias: "class-name"
      },
      keyword: /\b[a-z_][a-z_0-9]*\b/,
      number: /[+-]?\b\d+(?:\.\d+)?(?:[eE][+-]?\d+)?\b|\b0x[\dA-Fa-f]+\b|\b0xK[\dA-Fa-f]{20}\b|\b0x[ML][\dA-Fa-f]{32}\b|\b0xH[\dA-Fa-f]{4}\b/,
      punctuation: /[{}[\];(),.!*=<>]/
    };
  })(t);
}
g8.displayName = "log";
g8.aliases = [];
function g8(t) {
  t.languages.log = {
    string: {
      // Single-quoted strings must not be confused with plain text. E.g. Can't isn't Susan's Chris' toy
      pattern: /"(?:[^"\\\r\n]|\\.)*"|'(?![st] | \w)(?:[^'\\\r\n]|\\.)*'/,
      greedy: !0
    },
    exception: {
      pattern: /(^|[^\w.])[a-z][\w.]*(?:Error|Exception):.*(?:(?:\r\n?|\n)[ \t]*(?:at[ \t].+|\.{3}.*|Caused by:.*))+(?:(?:\r\n?|\n)[ \t]*\.\.\. .*)?/,
      lookbehind: !0,
      greedy: !0,
      alias: ["javastacktrace", "language-javastacktrace"],
      inside: t.languages.javastacktrace || {
        keyword: /\bat\b/,
        function: /[a-z_][\w$]*(?=\()/,
        punctuation: /[.:()]/
      }
    },
    level: [
      {
        pattern: /\b(?:ALERT|CRIT|CRITICAL|EMERG|EMERGENCY|ERR|ERROR|FAILURE|FATAL|SEVERE)\b/,
        alias: ["error", "important"]
      },
      {
        pattern: /\b(?:WARN|WARNING|WRN)\b/,
        alias: ["warning", "important"]
      },
      {
        pattern: /\b(?:DISPLAY|INF|INFO|NOTICE|STATUS)\b/,
        alias: ["info", "keyword"]
      },
      {
        pattern: /\b(?:DBG|DEBUG|FINE)\b/,
        alias: ["debug", "keyword"]
      },
      {
        pattern: /\b(?:FINER|FINEST|TRACE|TRC|VERBOSE|VRB)\b/,
        alias: ["trace", "comment"]
      }
    ],
    property: {
      pattern: /((?:^|[\]|])[ \t]*)[a-z_](?:[\w-]|\b\/\b)*(?:[. ]\(?\w(?:[\w-]|\b\/\b)*\)?)*:(?=\s)/im,
      lookbehind: !0
    },
    separator: {
      pattern: /(^|[^-+])-{3,}|={3,}|\*{3,}|- - /m,
      lookbehind: !0,
      alias: "comment"
    },
    url: /\b(?:file|ftp|https?):\/\/[^\s|,;'"]*[^\s|,;'">.]/,
    email: {
      pattern: /(^|\s)[-\w+.]+@[a-z][a-z0-9-]*(?:\.[a-z][a-z0-9-]*)+(?=\s)/,
      lookbehind: !0,
      alias: "url"
    },
    "ip-address": {
      pattern: /\b(?:\d{1,3}(?:\.\d{1,3}){3})\b/,
      alias: "constant"
    },
    "mac-address": {
      pattern: /\b[a-f0-9]{2}(?::[a-f0-9]{2}){5}\b/i,
      alias: "constant"
    },
    domain: {
      pattern: /(^|\s)[a-z][a-z0-9-]*(?:\.[a-z][a-z0-9-]*)*\.[a-z][a-z0-9-]+(?=\s)/,
      lookbehind: !0,
      alias: "constant"
    },
    uuid: {
      pattern: /\b[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\b/i,
      alias: "constant"
    },
    hash: {
      pattern: /\b(?:[a-f0-9]{32}){1,2}\b/i,
      alias: "constant"
    },
    "file-path": {
      pattern: /\b[a-z]:[\\/][^\s|,;:(){}\[\]"']+|(^|[\s:\[\](>|])\.{0,2}\/\w[^\s|,;:(){}\[\]"']*/i,
      lookbehind: !0,
      greedy: !0,
      alias: "string"
    },
    date: {
      pattern: RegExp(
        /\b\d{4}[-/]\d{2}[-/]\d{2}(?:T(?=\d{1,2}:)|(?=\s\d{1,2}:))/.source + "|" + /\b\d{1,4}[-/ ](?:\d{1,2}|Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep)[-/ ]\d{2,4}T?\b/.source + "|" + /\b(?:(?:Fri|Mon|Sat|Sun|Thu|Tue|Wed)(?:\s{1,2}(?:Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep))?|Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep)\s{1,2}\d{1,2}\b/.source,
        "i"
      ),
      alias: "number"
    },
    time: {
      pattern: /\b\d{1,2}:\d{1,2}:\d{1,2}(?:[.,:]\d+)?(?:\s?[+-]\d{2}:?\d{2}|Z)?\b/,
      alias: "number"
    },
    boolean: /\b(?:false|null|true)\b/i,
    number: {
      pattern: /(^|[^.\w])(?:0x[a-f0-9]+|0o[0-7]+|0b[01]+|v?\d[\da-f]*(?:\.\d+)*(?:e[+-]?\d+)?[a-z]{0,3}\b)\b(?!\.\w)/i,
      lookbehind: !0
    },
    operator: /[;:?<=>~/@!$%&+\-|^(){}*#]/,
    punctuation: /[\[\].,]/
  };
}
b8.displayName = "lolcode";
b8.aliases = [];
function b8(t) {
  t.languages.lolcode = {
    comment: [/\bOBTW\s[\s\S]*?\sTLDR\b/, /\bBTW.+/],
    string: {
      pattern: /"(?::.|[^":])*"/,
      inside: {
        variable: /:\{[^}]+\}/,
        symbol: [/:\([a-f\d]+\)/i, /:\[[^\]]+\]/, /:[)>o":]/]
      },
      greedy: !0
    },
    number: /(?:\B-)?(?:\b\d+(?:\.\d*)?|\B\.\d+)/,
    symbol: {
      pattern: /(^|\s)(?:A )?(?:BUKKIT|NOOB|NUMBAR|NUMBR|TROOF|YARN)(?=\s|,|$)/,
      lookbehind: !0,
      inside: {
        keyword: /A(?=\s)/
      }
    },
    label: {
      pattern: /((?:^|\s)(?:IM IN YR|IM OUTTA YR) )[a-zA-Z]\w*/,
      lookbehind: !0,
      alias: "string"
    },
    function: {
      pattern: /((?:^|\s)(?:HOW IZ I|I IZ|IZ) )[a-zA-Z]\w*/,
      lookbehind: !0
    },
    keyword: [
      {
        pattern: /(^|\s)(?:AN|FOUND YR|GIMMEH|GTFO|HAI|HAS A|HOW IZ I|I HAS A|I IZ|IF U SAY SO|IM IN YR|IM OUTTA YR|IS NOW(?: A)?|ITZ(?: A)?|IZ|KTHX|KTHXBYE|LIEK(?: A)?|MAEK|MEBBE|MKAY|NERFIN|NO WAI|O HAI IM|O RLY\?|OIC|OMG|OMGWTF|R|SMOOSH|SRS|TIL|UPPIN|VISIBLE|WILE|WTF\?|YA RLY|YR)(?=\s|,|$)/,
        lookbehind: !0
      },
      /'Z(?=\s|,|$)/
    ],
    boolean: {
      pattern: /(^|\s)(?:FAIL|WIN)(?=\s|,|$)/,
      lookbehind: !0
    },
    variable: {
      pattern: /(^|\s)IT(?=\s|,|$)/,
      lookbehind: !0
    },
    operator: {
      pattern: /(^|\s)(?:NOT|BOTH SAEM|DIFFRINT|(?:ALL|ANY|BIGGR|BOTH|DIFF|EITHER|MOD|PRODUKT|QUOSHUNT|SMALLR|SUM|WON) OF)(?=\s|,|$)/,
      lookbehind: !0
    },
    punctuation: /\.{3}|…|,|!/
  };
}
v8.displayName = "magma";
v8.aliases = [];
function v8(t) {
  t.languages.magma = {
    output: {
      pattern: /^(>.*(?:\r(?:\n|(?!\n))|\n))(?!>)(?:.+|(?:\r(?:\n|(?!\n))|\n)(?!>).*)(?:(?:\r(?:\n|(?!\n))|\n)(?!>).*)*/m,
      lookbehind: !0,
      greedy: !0
    },
    comment: {
      pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
      greedy: !0
    },
    string: {
      pattern: /(^|[^\\"])"(?:[^\r\n\\"]|\\.)*"/,
      lookbehind: !0,
      greedy: !0
    },
    // http://magma.maths.usyd.edu.au/magma/handbook/text/82
    keyword: /\b(?:_|adj|and|assert|assert2|assert3|assigned|break|by|case|cat|catch|clear|cmpeq|cmpne|continue|declare|default|delete|diff|div|do|elif|else|end|eq|error|eval|exists|exit|for|forall|forward|fprintf|freeze|function|ge|gt|if|iload|import|in|intrinsic|is|join|le|load|local|lt|meet|mod|ne|not|notadj|notin|notsubset|or|print|printf|procedure|quit|random|read|readi|repeat|require|requirege|requirerange|restore|return|save|sdiff|select|subset|then|time|to|try|until|vprint|vprintf|vtime|when|where|while|xor)\b/,
    boolean: /\b(?:false|true)\b/,
    generator: {
      pattern: /\b[a-z_]\w*(?=\s*<)/i,
      alias: "class-name"
    },
    function: /\b[a-z_]\w*(?=\s*\()/i,
    number: {
      pattern: /(^|[^\w.]|\.\.)(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?(?:_[a-z]?)?(?=$|[^\w.]|\.\.)/,
      lookbehind: !0
    },
    operator: /->|[-+*/^~!|#=]|:=|\.\./,
    punctuation: /[()[\]{}<>,;.:]/
  };
}
XD.displayName = "mata";
XD.aliases = [];
function XD(t) {
  (function(e) {
    var n = /\b(?:(?:col|row)?vector|matrix|scalar)\b/.source, r = /\bvoid\b|<org>|\b(?:complex|numeric|pointer(?:\s*\([^()]*\))?|real|string|(?:class|struct)\s+\w+|transmorphic)(?:\s*<org>)?/.source.replace(
      /<org>/g,
      n
    );
    e.languages.mata = {
      comment: {
        pattern: /\/\/.*|\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\//,
        greedy: !0
      },
      string: {
        pattern: /"[^"\r\n]*"|[‘`']".*?"[’`']/,
        greedy: !0
      },
      "class-name": {
        pattern: /(\b(?:class|extends|struct)\s+)\w+(?=\s*(?:\{|\bextends\b))/,
        lookbehind: !0
      },
      type: {
        pattern: RegExp(r),
        alias: "class-name",
        inside: {
          punctuation: /[()]/,
          keyword: /\b(?:class|function|struct|void)\b/
        }
      },
      keyword: /\b(?:break|class|continue|do|else|end|extends|external|final|for|function|goto|if|pragma|private|protected|public|return|static|struct|unset|unused|version|virtual|while)\b/,
      constant: /\bNULL\b/,
      number: {
        pattern: /(^|[^\w.])(?:\d+(?:\.\d+)?(?:e[+-]?\d+)?|\d[a-f0-9]*(?:\.[a-f0-9]+)?x[+-]?\d+)i?(?![\w.])/i,
        lookbehind: !0
      },
      missing: {
        pattern: /(^|[^\w.])(?:\.[a-z]?)(?![\w.])/,
        lookbehind: !0,
        alias: "symbol"
      },
      function: /\b[a-z_]\w*(?=\s*\()/i,
      operator: /\.\.|\+\+|--|&&|\|\||:?(?:[!=<>]=|[+\-*/^<>&|:])|[!?=\\#’`']/,
      punctuation: /[()[\]{},;.]/
    };
  })(t);
}
y8.displayName = "matlab";
y8.aliases = [];
function y8(t) {
  t.languages.matlab = {
    comment: [/%\{[\s\S]*?\}%/, /%.+/],
    string: {
      pattern: /\B'(?:''|[^'\r\n])*'/,
      greedy: !0
    },
    // FIXME We could handle imaginary numbers as a whole
    number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[eE][+-]?\d+)?(?:[ij])?|\b[ij]\b/,
    keyword: /\b(?:NaN|break|case|catch|continue|else|elseif|end|for|function|if|inf|otherwise|parfor|pause|pi|return|switch|try|while)\b/,
    function: /\b(?!\d)\w+(?=\s*\()/,
    operator: /\.?[*^\/\\']|[+\-:@]|[<>=~]=?|&&?|\|\|?/,
    punctuation: /\.{3}|[.,;\[\](){}!]/
  };
}
O8.displayName = "maxscript";
O8.aliases = [];
function O8(t) {
  (function(e) {
    var n = /\b(?:about|and|animate|as|at|attributes|by|case|catch|collect|continue|coordsys|do|else|exit|fn|for|from|function|global|if|in|local|macroscript|mapped|max|not|of|off|on|or|parameters|persistent|plugin|rcmenu|return|rollout|set|struct|then|throw|to|tool|try|undo|utility|when|where|while|with)\b/i;
    e.languages.maxscript = {
      comment: {
        pattern: /\/\*[\s\S]*?(?:\*\/|$)|--.*/,
        greedy: !0
      },
      string: {
        pattern: /(^|[^"\\@])(?:"(?:[^"\\]|\\[\s\S])*"|@"[^"]*")/,
        lookbehind: !0,
        greedy: !0
      },
      path: {
        pattern: /\$(?:[\w/\\.*?]|'[^']*')*/,
        greedy: !0,
        alias: "string"
      },
      "function-call": {
        pattern: RegExp(
          "((?:" + // start of line
          (/^/.source + "|" + // operators and other language constructs
          /[;=<>+\-*/^({\[]/.source + "|" + // keywords as part of statements
          /\b(?:and|by|case|catch|collect|do|else|if|in|not|or|return|then|to|try|where|while|with)\b/.source) + ")[ 	]*)(?!" + n.source + ")" + /[a-z_]\w*\b/.source + "(?=[ 	]*(?:" + // variable
          ("(?!" + n.source + ")" + /[a-z_]/.source + "|" + // number
          /\d|-\.?\d/.source + "|" + // other expressions or literals
          /[({'"$@#?]/.source) + "))",
          "im"
        ),
        lookbehind: !0,
        greedy: !0,
        alias: "function"
      },
      "function-definition": {
        pattern: /(\b(?:fn|function)\s+)\w+\b/i,
        lookbehind: !0,
        alias: "function"
      },
      argument: {
        pattern: /\b[a-z_]\w*(?=:)/i,
        alias: "attr-name"
      },
      keyword: n,
      boolean: /\b(?:false|true)\b/,
      time: {
        pattern: /(^|[^\w.])(?:(?:(?:\d+(?:\.\d*)?|\.\d+)(?:[eEdD][+-]\d+|[LP])?[msft])+|\d+:\d+(?:\.\d*)?)(?![\w.:])/,
        lookbehind: !0,
        alias: "number"
      },
      number: [
        {
          pattern: /(^|[^\w.])(?:(?:\d+(?:\.\d*)?|\.\d+)(?:[eEdD][+-]\d+|[LP])?|0x[a-fA-F0-9]+)(?![\w.:])/,
          lookbehind: !0
        },
        /\b(?:e|pi)\b/
      ],
      constant: /\b(?:dontcollect|ok|silentValue|undefined|unsupplied)\b/,
      color: {
        pattern: /\b(?:black|blue|brown|gray|green|orange|red|white|yellow)\b/i,
        alias: "constant"
      },
      operator: /[-+*/<>=!]=?|[&^?]|#(?!\()/,
      punctuation: /[()\[\]{}.:,;]|#(?=\()|\\$/m
    };
  })(t);
}
E8.displayName = "mel";
E8.aliases = [];
function E8(t) {
  t.languages.mel = {
    comment: {
      pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
      greedy: !0
    },
    code: {
      pattern: /`(?:\\.|[^\\`])*`/,
      greedy: !0,
      alias: "italic",
      inside: {
        delimiter: {
          pattern: /^`|`$/,
          alias: "punctuation"
        },
        statement: {
          pattern: /[\s\S]+/,
          inside: null
          // see below
        }
      }
    },
    string: {
      pattern: /"(?:\\.|[^\\"\r\n])*"/,
      greedy: !0
    },
    variable: /\$\w+/,
    number: /\b0x[\da-fA-F]+\b|\b\d+(?:\.\d*)?|\B\.\d+/,
    flag: {
      pattern: /-[^\d\W]\w*/,
      alias: "operator"
    },
    keyword: /\b(?:break|case|continue|default|do|else|float|for|global|if|in|int|matrix|proc|return|string|switch|vector|while)\b/,
    function: {
      pattern: /((?:^|[{;])[ \t]*)[a-z_]\w*\b(?!\s*(?:\.(?!\.)|[[{=]))|\b[a-z_]\w*(?=[ \t]*\()/im,
      lookbehind: !0,
      greedy: !0
    },
    "tensor-punctuation": {
      pattern: /<<|>>/,
      alias: "punctuation"
    },
    operator: /\+[+=]?|-[-=]?|&&|\|\||[<>]=?|[*\/!=]=?|[%^]/,
    punctuation: /[.,:;?\[\](){}]/
  }, t.languages.mel.code.inside.statement.inside = t.languages.mel;
}
S8.displayName = "mermaid";
S8.aliases = [];
function S8(t) {
  t.languages.mermaid = {
    comment: {
      pattern: /%%.*/,
      greedy: !0
    },
    style: {
      pattern: /^([ \t]*(?:classDef|linkStyle|style)[ \t]+[\w$-]+[ \t]+)\w.*[^\s;]/m,
      lookbehind: !0,
      inside: {
        property: /\b\w[\w-]*(?=[ \t]*:)/,
        operator: /:/,
        punctuation: /,/
      }
    },
    "inter-arrow-label": {
      pattern: /([^<>ox.=-])(?:-[-.]|==)(?![<>ox.=-])[ \t]*(?:"[^"\r\n]*"|[^\s".=-](?:[^\r\n.=-]*[^\s.=-])?)[ \t]*(?:\.+->?|--+[->]|==+[=>])(?![<>ox.=-])/,
      lookbehind: !0,
      greedy: !0,
      inside: {
        arrow: {
          pattern: /(?:\.+->?|--+[->]|==+[=>])$/,
          alias: "operator"
        },
        label: {
          pattern: /^([\s\S]{2}[ \t]*)\S(?:[\s\S]*\S)?/,
          lookbehind: !0,
          alias: "property"
        },
        "arrow-head": {
          pattern: /^\S+/,
          alias: ["arrow", "operator"]
        }
      }
    },
    arrow: [
      // This might look complex but it really isn't.
      // There are many possible arrows (see tests) and it's impossible to fit all of them into one pattern. The
      // problem is that we only have one lookbehind per pattern. However, we cannot disallow too many arrow
      // characters in the one lookbehind because that would create too many false negatives. So we have to split the
      // arrows into different patterns.
      {
        // ER diagram
        pattern: /(^|[^{}|o.-])[|}][|o](?:--|\.\.)[|o][|{](?![{}|o.-])/,
        lookbehind: !0,
        alias: "operator"
      },
      {
        // flow chart
        // (?:==+|--+|-\.*-)
        pattern: /(^|[^<>ox.=-])(?:[<ox](?:==+|--+|-\.*-)[>ox]?|(?:==+|--+|-\.*-)[>ox]|===+|---+|-\.+-)(?![<>ox.=-])/,
        lookbehind: !0,
        alias: "operator"
      },
      {
        // sequence diagram
        pattern: /(^|[^<>()x-])(?:--?(?:>>|[x>)])(?![<>()x])|(?:<<|[x<(])--?(?!-))/,
        lookbehind: !0,
        alias: "operator"
      },
      {
        // class diagram
        pattern: /(^|[^<>|*o.-])(?:[*o]--|--[*o]|<\|?(?:--|\.\.)|(?:--|\.\.)\|?>|--|\.\.)(?![<>|*o.-])/,
        lookbehind: !0,
        alias: "operator"
      }
    ],
    label: {
      pattern: /(^|[^|<])\|(?:[^\r\n"|]|"[^"\r\n]*")+\|/,
      lookbehind: !0,
      greedy: !0,
      alias: "property"
    },
    text: {
      pattern: /(?:[(\[{]+|\b>)(?:[^\r\n"()\[\]{}]|"[^"\r\n]*")+(?:[)\]}]+|>)/,
      alias: "string"
    },
    string: {
      pattern: /"[^"\r\n]*"/,
      greedy: !0
    },
    annotation: {
      pattern: /<<(?:abstract|choice|enumeration|fork|interface|join|service)>>|\[\[(?:choice|fork|join)\]\]/i,
      alias: "important"
    },
    keyword: [
      // This language has both case-sensitive and case-insensitive keywords
      {
        pattern: /(^[ \t]*)(?:action|callback|class|classDef|classDiagram|click|direction|erDiagram|flowchart|gantt|gitGraph|graph|journey|link|linkStyle|pie|requirementDiagram|sequenceDiagram|stateDiagram|stateDiagram-v2|style|subgraph)(?![\w$-])/m,
        lookbehind: !0,
        greedy: !0
      },
      {
        pattern: /(^[ \t]*)(?:activate|alt|and|as|autonumber|deactivate|else|end(?:[ \t]+note)?|loop|opt|par|participant|rect|state|note[ \t]+(?:over|(?:left|right)[ \t]+of))(?![\w$-])/im,
        lookbehind: !0,
        greedy: !0
      }
    ],
    entity: /#[a-z0-9]+;/,
    operator: {
      pattern: /(\w[ \t]*)&(?=[ \t]*\w)|:::|:/,
      lookbehind: !0
    },
    punctuation: /[(){};]/
  };
}
w8.displayName = "metafont";
w8.aliases = [];
function w8(t) {
  t.languages.metafont = {
    // Syntax of METAFONT with the added (public) elements of PlainMETAFONT. Except for internal quantities they are expected to be rarely redefined. Freely inspired by the syntax of Christophe Grandsire for the Crimson Editor.
    comment: {
      pattern: /%.*/,
      greedy: !0
    },
    string: {
      pattern: /"[^\r\n"]*"/,
      greedy: !0
    },
    number: /\d*\.?\d+/,
    boolean: /\b(?:false|true)\b/,
    punctuation: [
      /[,;()]/,
      {
        pattern: /(^|[^{}])(?:\{|\})(?![{}])/,
        lookbehind: !0
      },
      {
        pattern: /(^|[^[])\[(?!\[)/,
        lookbehind: !0
      },
      {
        pattern: /(^|[^\]])\](?!\])/,
        lookbehind: !0
      }
    ],
    constant: [
      {
        pattern: /(^|[^!?])\?\?\?(?![!?])/,
        lookbehind: !0
      },
      {
        pattern: /(^|[^/*\\])(?:\\|\\\\)(?![/*\\])/,
        lookbehind: !0
      },
      /\b(?:_|blankpicture|bp|cc|cm|dd|ditto|down|eps|epsilon|fullcircle|halfcircle|identity|in|infinity|left|mm|nullpen|nullpicture|origin|pc|penrazor|penspeck|pensquare|penstroke|proof|pt|quartercircle|relax|right|smoke|unitpixel|unitsquare|up)\b/
    ],
    quantity: {
      pattern: /\b(?:autorounding|blacker|boundarychar|charcode|chardp|chardx|chardy|charext|charht|charic|charwd|currentwindow|day|designsize|displaying|fillin|fontmaking|granularity|hppp|join_radius|month|o_correction|pausing|pen_(?:bot|lft|rt|top)|pixels_per_inch|proofing|showstopping|smoothing|time|tolerance|tracingcapsules|tracingchoices|tracingcommands|tracingedges|tracingequations|tracingmacros|tracingonline|tracingoutput|tracingpens|tracingrestores|tracingspecs|tracingstats|tracingtitles|turningcheck|vppp|warningcheck|xoffset|year|yoffset)\b/,
      alias: "keyword"
    },
    command: {
      pattern: /\b(?:addto|batchmode|charlist|cull|display|errhelp|errmessage|errorstopmode|everyjob|extensible|fontdimen|headerbyte|inner|interim|let|ligtable|message|newinternal|nonstopmode|numspecial|openwindow|outer|randomseed|save|scrollmode|shipout|show|showdependencies|showstats|showtoken|showvariable|special)\b/,
      alias: "builtin"
    },
    operator: [
      {
        pattern: /(^|[^>=<:|])(?:<|<=|=|=:|\|=:|\|=:>|=:\|>|=:\||\|=:\||\|=:\|>|\|=:\|>>|>|>=|:|:=|<>|::|\|\|:)(?![>=<:|])/,
        lookbehind: !0
      },
      {
        pattern: /(^|[^+-])(?:\+|\+\+|-{1,3}|\+-\+)(?![+-])/,
        lookbehind: !0
      },
      {
        pattern: /(^|[^/*\\])(?:\*|\*\*|\/)(?![/*\\])/,
        lookbehind: !0
      },
      {
        pattern: /(^|[^.])(?:\.{2,3})(?!\.)/,
        lookbehind: !0
      },
      {
        pattern: /(^|[^@#&$])&(?![@#&$])/,
        lookbehind: !0
      },
      /\b(?:and|not|or)\b/
    ],
    macro: {
      pattern: /\b(?:abs|beginchar|bot|byte|capsule_def|ceiling|change_width|clear_pen_memory|clearit|clearpen|clearxy|counterclockwise|cullit|cutdraw|cutoff|decr|define_blacker_pixels|define_corrected_pixels|define_good_x_pixels|define_good_y_pixels|define_horizontal_corrected_pixels|define_pixels|define_whole_blacker_pixels|define_whole_pixels|define_whole_vertical_blacker_pixels|define_whole_vertical_pixels|dir|direction|directionpoint|div|dotprod|downto|draw|drawdot|endchar|erase|fill|filldraw|fix_units|flex|font_coding_scheme|font_extra_space|font_identifier|font_normal_shrink|font_normal_space|font_normal_stretch|font_quad|font_size|font_slant|font_x_height|gfcorners|gobble|gobbled|good\.(?:bot|lft|rt|top|x|y)|grayfont|hide|hround|imagerules|incr|interact|interpath|intersectionpoint|inverse|italcorr|killtext|labelfont|labels|lft|loggingall|lowres_fix|makegrid|makelabel(?:\.(?:bot|lft|rt|top)(?:\.nodot)?)?|max|min|mod|mode_def|mode_setup|nodisplays|notransforms|numtok|openit|penlabels|penpos|pickup|proofoffset|proofrule|proofrulethickness|range|reflectedabout|rotatedabout|rotatedaround|round|rt|savepen|screenchars|screenrule|screenstrokes|shipit|showit|slantfont|softjoin|solve|stop|superellipse|tensepath|thru|titlefont|top|tracingall|tracingnone|undraw|undrawdot|unfill|unfilldraw|upto|vround)\b/,
      alias: "function"
    },
    builtin: /\b(?:ASCII|angle|char|cosd|decimal|directiontime|floor|hex|intersectiontimes|jobname|known|length|makepath|makepen|mexp|mlog|normaldeviate|oct|odd|pencircle|penoffset|point|postcontrol|precontrol|reverse|rotated|sind|sqrt|str|subpath|substring|totalweight|turningnumber|uniformdeviate|unknown|xpart|xxpart|xypart|ypart|yxpart|yypart)\b/,
    keyword: /\b(?:also|at|atleast|begingroup|charexists|contour|controls|curl|cycle|def|delimiters|doublepath|dropping|dump|else|elseif|end|enddef|endfor|endgroup|endinput|exitif|exitunless|expandafter|fi|for|forever|forsuffixes|from|if|input|inwindow|keeping|kern|of|primarydef|quote|readstring|scaled|scantokens|secondarydef|shifted|skipto|slanted|step|tension|tertiarydef|to|transformed|until|vardef|withpen|withweight|xscaled|yscaled|zscaled)\b/,
    type: {
      pattern: /\b(?:boolean|expr|numeric|pair|path|pen|picture|primary|secondary|string|suffix|tertiary|text|transform)\b/,
      alias: "property"
    },
    variable: {
      pattern: /(^|[^@#&$])(?:@#|#@|#|@)(?![@#&$])|\b(?:aspect_ratio|currentpen|currentpicture|currenttransform|d|extra_beginchar|extra_endchar|extra_setup|h|localfont|mag|mode|screen_cols|screen_rows|w|whatever|x|y|z)\b/,
      lookbehind: !0
    }
  };
}
T8.displayName = "mizar";
T8.aliases = [];
function T8(t) {
  t.languages.mizar = {
    comment: /::.+/,
    keyword: /@proof\b|\b(?:according|aggregate|all|and|antonym|are|as|associativity|assume|asymmetry|attr|be|begin|being|by|canceled|case|cases|clusters?|coherence|commutativity|compatibility|connectedness|consider|consistency|constructors|contradiction|correctness|def|deffunc|define|definitions?|defpred|do|does|end|environ|equals|ex|exactly|existence|for|from|func|given|hence|hereby|holds|idempotence|identity|iff?|implies|involutiveness|irreflexivity|is|it|let|means|mode|non|not|notations?|now|of|or|otherwise|over|per|pred|prefix|projectivity|proof|provided|qua|reconsider|redefine|reduce|reducibility|reflexivity|registrations?|requirements|reserve|sch|schemes?|section|selector|set|sethood|st|struct|such|suppose|symmetry|synonym|take|that|the|then|theorems?|thesis|thus|to|transitivity|uniqueness|vocabular(?:ies|y)|when|where|with|wrt)\b/,
    parameter: {
      pattern: /\$(?:10|\d)/,
      alias: "variable"
    },
    variable: /\b\w+(?=:)/,
    number: /(?:\b|-)\d+\b/,
    operator: /\.\.\.|->|&|\.?=/,
    punctuation: /\(#|#\)|[,:;\[\](){}]/
  };
}
_8.displayName = "mongodb";
_8.aliases = [];
function _8(t) {
  t.register(rl), function(e) {
    var n = [
      // query and projection
      "$eq",
      "$gt",
      "$gte",
      "$in",
      "$lt",
      "$lte",
      "$ne",
      "$nin",
      "$and",
      "$not",
      "$nor",
      "$or",
      "$exists",
      "$type",
      "$expr",
      "$jsonSchema",
      "$mod",
      "$regex",
      "$text",
      "$where",
      "$geoIntersects",
      "$geoWithin",
      "$near",
      "$nearSphere",
      "$all",
      "$elemMatch",
      "$size",
      "$bitsAllClear",
      "$bitsAllSet",
      "$bitsAnyClear",
      "$bitsAnySet",
      "$comment",
      "$elemMatch",
      "$meta",
      "$slice",
      // update
      "$currentDate",
      "$inc",
      "$min",
      "$max",
      "$mul",
      "$rename",
      "$set",
      "$setOnInsert",
      "$unset",
      "$addToSet",
      "$pop",
      "$pull",
      "$push",
      "$pullAll",
      "$each",
      "$position",
      "$slice",
      "$sort",
      "$bit",
      // aggregation pipeline stages
      "$addFields",
      "$bucket",
      "$bucketAuto",
      "$collStats",
      "$count",
      "$currentOp",
      "$facet",
      "$geoNear",
      "$graphLookup",
      "$group",
      "$indexStats",
      "$limit",
      "$listLocalSessions",
      "$listSessions",
      "$lookup",
      "$match",
      "$merge",
      "$out",
      "$planCacheStats",
      "$project",
      "$redact",
      "$replaceRoot",
      "$replaceWith",
      "$sample",
      "$set",
      "$skip",
      "$sort",
      "$sortByCount",
      "$unionWith",
      "$unset",
      "$unwind",
      "$setWindowFields",
      // aggregation pipeline operators
      "$abs",
      "$accumulator",
      "$acos",
      "$acosh",
      "$add",
      "$addToSet",
      "$allElementsTrue",
      "$and",
      "$anyElementTrue",
      "$arrayElemAt",
      "$arrayToObject",
      "$asin",
      "$asinh",
      "$atan",
      "$atan2",
      "$atanh",
      "$avg",
      "$binarySize",
      "$bsonSize",
      "$ceil",
      "$cmp",
      "$concat",
      "$concatArrays",
      "$cond",
      "$convert",
      "$cos",
      "$dateFromParts",
      "$dateToParts",
      "$dateFromString",
      "$dateToString",
      "$dayOfMonth",
      "$dayOfWeek",
      "$dayOfYear",
      "$degreesToRadians",
      "$divide",
      "$eq",
      "$exp",
      "$filter",
      "$first",
      "$floor",
      "$function",
      "$gt",
      "$gte",
      "$hour",
      "$ifNull",
      "$in",
      "$indexOfArray",
      "$indexOfBytes",
      "$indexOfCP",
      "$isArray",
      "$isNumber",
      "$isoDayOfWeek",
      "$isoWeek",
      "$isoWeekYear",
      "$last",
      "$last",
      "$let",
      "$literal",
      "$ln",
      "$log",
      "$log10",
      "$lt",
      "$lte",
      "$ltrim",
      "$map",
      "$max",
      "$mergeObjects",
      "$meta",
      "$min",
      "$millisecond",
      "$minute",
      "$mod",
      "$month",
      "$multiply",
      "$ne",
      "$not",
      "$objectToArray",
      "$or",
      "$pow",
      "$push",
      "$radiansToDegrees",
      "$range",
      "$reduce",
      "$regexFind",
      "$regexFindAll",
      "$regexMatch",
      "$replaceOne",
      "$replaceAll",
      "$reverseArray",
      "$round",
      "$rtrim",
      "$second",
      "$setDifference",
      "$setEquals",
      "$setIntersection",
      "$setIsSubset",
      "$setUnion",
      "$size",
      "$sin",
      "$slice",
      "$split",
      "$sqrt",
      "$stdDevPop",
      "$stdDevSamp",
      "$strcasecmp",
      "$strLenBytes",
      "$strLenCP",
      "$substr",
      "$substrBytes",
      "$substrCP",
      "$subtract",
      "$sum",
      "$switch",
      "$tan",
      "$toBool",
      "$toDate",
      "$toDecimal",
      "$toDouble",
      "$toInt",
      "$toLong",
      "$toObjectId",
      "$toString",
      "$toLower",
      "$toUpper",
      "$trim",
      "$trunc",
      "$type",
      "$week",
      "$year",
      "$zip",
      "$count",
      "$dateAdd",
      "$dateDiff",
      "$dateSubtract",
      "$dateTrunc",
      "$getField",
      "$rand",
      "$sampleRate",
      "$setField",
      "$unsetField",
      // aggregation pipeline query modifiers
      "$comment",
      "$explain",
      "$hint",
      "$max",
      "$maxTimeMS",
      "$min",
      "$orderby",
      "$query",
      "$returnKey",
      "$showDiskLoc",
      "$natural"
    ], r = [
      "ObjectId",
      "Code",
      "BinData",
      "DBRef",
      "Timestamp",
      "NumberLong",
      "NumberDecimal",
      "MaxKey",
      "MinKey",
      "RegExp",
      "ISODate",
      "UUID"
    ];
    n = n.map(function(i) {
      return i.replace("$", "\\$");
    });
    var a = "(?:" + n.join("|") + ")\\b";
    e.languages.mongodb = e.languages.extend("javascript", {}), e.languages.insertBefore("mongodb", "string", {
      property: {
        pattern: /(?:(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)(?=\s*:)/,
        greedy: !0,
        inside: {
          keyword: RegExp(`^(['"])?` + a + "(?:\\1)?$")
        }
      }
    }), e.languages.mongodb.string.inside = {
      url: {
        // url pattern
        pattern: /https?:\/\/[-\w@:%.+~#=]{1,256}\.[a-z0-9()]{1,6}\b[-\w()@:%+.~#?&/=]*/i,
        greedy: !0
      },
      entity: {
        // ipv4
        pattern: /\b(?:(?:[01]?\d\d?|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d\d?|2[0-4]\d|25[0-5])\b/,
        greedy: !0
      }
    }, e.languages.insertBefore("mongodb", "constant", {
      builtin: {
        pattern: RegExp("\\b(?:" + r.join("|") + ")\\b"),
        alias: "keyword"
      }
    });
  }(t);
}
C8.displayName = "monkey";
C8.aliases = [];
function C8(t) {
  t.languages.monkey = {
    comment: {
      pattern: /^#Rem\s[\s\S]*?^#End|'.+/im,
      greedy: !0
    },
    string: {
      pattern: /"[^"\r\n]*"/,
      greedy: !0
    },
    preprocessor: {
      pattern: /(^[ \t]*)#.+/m,
      lookbehind: !0,
      greedy: !0,
      alias: "property"
    },
    function: /\b\w+(?=\()/,
    "type-char": {
      pattern: /\b[?%#$]/,
      alias: "class-name"
    },
    number: {
      pattern: /((?:\.\.)?)(?:(?:\b|\B-\.?|\B\.)\d+(?:(?!\.\.)\.\d*)?|\$[\da-f]+)/i,
      lookbehind: !0
    },
    keyword: /\b(?:Abstract|Array|Bool|Case|Catch|Class|Const|Continue|Default|Eachin|Else|ElseIf|End|EndIf|Exit|Extends|Extern|False|Field|Final|Float|For|Forever|Function|Global|If|Implements|Import|Inline|Int|Interface|Local|Method|Module|New|Next|Null|Object|Private|Property|Public|Repeat|Return|Select|Self|Step|Strict|String|Super|Then|Throw|To|True|Try|Until|Void|Wend|While)\b/i,
    operator: /\.\.|<[=>]?|>=?|:?=|(?:[+\-*\/&~|]|\b(?:Mod|Shl|Shr)\b)=?|\b(?:And|Not|Or)\b/i,
    punctuation: /[.,:;()\[\]]/
  };
}
x8.displayName = "moonscript";
x8.aliases = ["moon"];
function x8(t) {
  t.languages.moonscript = {
    comment: /--.*/,
    string: [
      {
        pattern: /'[^']*'|\[(=*)\[[\s\S]*?\]\1\]/,
        greedy: !0
      },
      {
        pattern: /"[^"]*"/,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /#\{[^{}]*\}/,
            inside: {
              moonscript: {
                pattern: /(^#\{)[\s\S]+(?=\})/,
                lookbehind: !0,
                inside: null
                // see beow
              },
              "interpolation-punctuation": {
                pattern: /#\{|\}/,
                alias: "punctuation"
              }
            }
          }
        }
      }
    ],
    "class-name": [
      {
        pattern: /(\b(?:class|extends)[ \t]+)\w+/,
        lookbehind: !0
      },
      // class-like names start with a capital letter
      /\b[A-Z]\w*/
    ],
    keyword: /\b(?:class|continue|do|else|elseif|export|extends|for|from|if|import|in|local|nil|return|self|super|switch|then|unless|using|when|while|with)\b/,
    variable: /@@?\w*/,
    property: {
      pattern: /\b(?!\d)\w+(?=:)|(:)(?!\d)\w+/,
      lookbehind: !0
    },
    function: {
      pattern: /\b(?:_G|_VERSION|assert|collectgarbage|coroutine\.(?:create|resume|running|status|wrap|yield)|debug\.(?:debug|getfenv|gethook|getinfo|getlocal|getmetatable|getregistry|getupvalue|setfenv|sethook|setlocal|setmetatable|setupvalue|traceback)|dofile|error|getfenv|getmetatable|io\.(?:close|flush|input|lines|open|output|popen|read|stderr|stdin|stdout|tmpfile|type|write)|ipairs|load|loadfile|loadstring|math\.(?:abs|acos|asin|atan|atan2|ceil|cos|cosh|deg|exp|floor|fmod|frexp|ldexp|log|log10|max|min|modf|pi|pow|rad|random|randomseed|sin|sinh|sqrt|tan|tanh)|module|next|os\.(?:clock|date|difftime|execute|exit|getenv|remove|rename|setlocale|time|tmpname)|package\.(?:cpath|loaded|loadlib|path|preload|seeall)|pairs|pcall|print|rawequal|rawget|rawset|require|select|setfenv|setmetatable|string\.(?:byte|char|dump|find|format|gmatch|gsub|len|lower|match|rep|reverse|sub|upper)|table\.(?:concat|insert|maxn|remove|sort)|tonumber|tostring|type|unpack|xpcall)\b/,
      inside: {
        punctuation: /\./
      }
    },
    boolean: /\b(?:false|true)\b/,
    number: /(?:\B\.\d+|\b\d+\.\d+|\b\d+(?=[eE]))(?:[eE][-+]?\d+)?\b|\b(?:0x[a-fA-F\d]+|\d+)(?:U?LL)?\b/,
    operator: /\.{3}|[-=]>|~=|(?:[-+*/%<>!=]|\.\.)=?|[:#^]|\b(?:and|or)\b=?|\b(?:not)\b/,
    punctuation: /[.,()[\]{}\\]/
  }, t.languages.moonscript.string[1].inside.interpolation.inside.moonscript.inside = t.languages.moonscript, t.languages.moon = t.languages.moonscript;
}
A8.displayName = "n1ql";
A8.aliases = [];
function A8(t) {
  t.languages.n1ql = {
    comment: {
      pattern: /\/\*[\s\S]*?(?:$|\*\/)|--.*/,
      greedy: !0
    },
    string: {
      pattern: /(["'])(?:\\[\s\S]|(?!\1)[^\\]|\1\1)*\1/,
      greedy: !0
    },
    identifier: {
      pattern: /`(?:\\[\s\S]|[^\\`]|``)*`/,
      greedy: !0
    },
    parameter: /\$[\w.]+/,
    // https://docs.couchbase.com/server/current/n1ql/n1ql-language-reference/reservedwords.html#n1ql-reserved-words
    keyword: /\b(?:ADVISE|ALL|ALTER|ANALYZE|AS|ASC|AT|BEGIN|BINARY|BOOLEAN|BREAK|BUCKET|BUILD|BY|CALL|CAST|CLUSTER|COLLATE|COLLECTION|COMMIT|COMMITTED|CONNECT|CONTINUE|CORRELATE|CORRELATED|COVER|CREATE|CURRENT|DATABASE|DATASET|DATASTORE|DECLARE|DECREMENT|DELETE|DERIVED|DESC|DESCRIBE|DISTINCT|DO|DROP|EACH|ELEMENT|EXCEPT|EXCLUDE|EXECUTE|EXPLAIN|FETCH|FILTER|FLATTEN|FLUSH|FOLLOWING|FOR|FORCE|FROM|FTS|FUNCTION|GOLANG|GRANT|GROUP|GROUPS|GSI|HASH|HAVING|IF|IGNORE|ILIKE|INCLUDE|INCREMENT|INDEX|INFER|INLINE|INNER|INSERT|INTERSECT|INTO|IS|ISOLATION|JAVASCRIPT|JOIN|KEY|KEYS|KEYSPACE|KNOWN|LANGUAGE|LAST|LEFT|LET|LETTING|LEVEL|LIMIT|LSM|MAP|MAPPING|MATCHED|MATERIALIZED|MERGE|MINUS|MISSING|NAMESPACE|NEST|NL|NO|NTH_VALUE|NULL|NULLS|NUMBER|OBJECT|OFFSET|ON|OPTION|OPTIONS|ORDER|OTHERS|OUTER|OVER|PARSE|PARTITION|PASSWORD|PATH|POOL|PRECEDING|PREPARE|PRIMARY|PRIVATE|PRIVILEGE|PROBE|PROCEDURE|PUBLIC|RANGE|RAW|REALM|REDUCE|RENAME|RESPECT|RETURN|RETURNING|REVOKE|RIGHT|ROLE|ROLLBACK|ROW|ROWS|SATISFIES|SAVEPOINT|SCHEMA|SCOPE|SELECT|SELF|SEMI|SET|SHOW|SOME|START|STATISTICS|STRING|SYSTEM|TIES|TO|TRAN|TRANSACTION|TRIGGER|TRUNCATE|UNBOUNDED|UNDER|UNION|UNIQUE|UNKNOWN|UNNEST|UNSET|UPDATE|UPSERT|USE|USER|USING|VALIDATE|VALUE|VALUES|VIA|VIEW|WHERE|WHILE|WINDOW|WITH|WORK|XOR)\b/i,
    function: /\b[a-z_]\w*(?=\s*\()/i,
    boolean: /\b(?:FALSE|TRUE)\b/i,
    number: /(?:\b\d+\.|\B\.)\d+e[+\-]?\d+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
    operator: /[-+*\/%]|!=|==?|\|\||<[>=]?|>=?|\b(?:AND|ANY|ARRAY|BETWEEN|CASE|ELSE|END|EVERY|EXISTS|FIRST|IN|LIKE|NOT|OR|THEN|VALUED|WHEN|WITHIN)\b/i,
    punctuation: /[;[\](),.{}:]/
  };
}
k8.displayName = "nand2tetris-hdl";
k8.aliases = [];
function k8(t) {
  t.languages["nand2tetris-hdl"] = {
    comment: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
    keyword: /\b(?:BUILTIN|CHIP|CLOCKED|IN|OUT|PARTS)\b/,
    boolean: /\b(?:false|true)\b/,
    function: /\b[A-Za-z][A-Za-z0-9]*(?=\()/,
    number: /\b\d+\b/,
    operator: /=|\.\./,
    punctuation: /[{}[\];(),:]/
  };
}
R8.displayName = "naniscript";
R8.aliases = ["nani"];
function R8(t) {
  (function(e) {
    var n = /\{[^\r\n\[\]{}]*\}/, r = {
      "quoted-string": {
        pattern: /"(?:[^"\\]|\\.)*"/,
        alias: "operator"
      },
      "command-param-id": {
        pattern: /(\s)\w+:/,
        lookbehind: !0,
        alias: "property"
      },
      "command-param-value": [
        {
          pattern: n,
          alias: "selector"
        },
        {
          pattern: /([\t ])\S+/,
          lookbehind: !0,
          greedy: !0,
          alias: "operator"
        },
        {
          pattern: /\S(?:.*\S)?/,
          alias: "operator"
        }
      ]
    };
    e.languages.naniscript = {
      // ; ...
      comment: {
        pattern: /^([\t ]*);.*/m,
        lookbehind: !0
      },
      // > ...
      // Define is a control line starting with '>' followed by a word, a space and a text.
      define: {
        pattern: /^>.+/m,
        alias: "tag",
        inside: {
          value: {
            pattern: /(^>\w+[\t ]+)(?!\s)[^{}\r\n]+/,
            lookbehind: !0,
            alias: "operator"
          },
          key: {
            pattern: /(^>)\w+/,
            lookbehind: !0
          }
        }
      },
      // # ...
      label: {
        pattern: /^([\t ]*)#[\t ]*\w+[\t ]*$/m,
        lookbehind: !0,
        alias: "regex"
      },
      command: {
        pattern: /^([\t ]*)@\w+(?=[\t ]|$).*/m,
        lookbehind: !0,
        alias: "function",
        inside: {
          "command-name": /^@\w+/,
          expression: {
            pattern: n,
            greedy: !0,
            alias: "selector"
          },
          "command-params": {
            pattern: /\s*\S[\s\S]*/,
            inside: r
          }
        }
      },
      // Generic is any line that doesn't start with operators: ;>#@
      "generic-text": {
        pattern: /(^[ \t]*)[^#@>;\s].*/m,
        lookbehind: !0,
        alias: "punctuation",
        inside: {
          // \{ ... \} ... \[ ... \] ... \"
          "escaped-char": /\\[{}\[\]"]/,
          expression: {
            pattern: n,
            greedy: !0,
            alias: "selector"
          },
          "inline-command": {
            pattern: /\[[\t ]*\w[^\r\n\[\]]*\]/,
            greedy: !0,
            alias: "function",
            inside: {
              "command-params": {
                pattern: /(^\[[\t ]*\w+\b)[\s\S]+(?=\]$)/,
                lookbehind: !0,
                inside: r
              },
              "command-param-name": {
                pattern: /^(\[[\t ]*)\w+/,
                lookbehind: !0,
                alias: "name"
              },
              "start-stop-char": /[\[\]]/
            }
          }
        }
      }
    }, e.languages.nani = e.languages.naniscript, e.hooks.add("after-tokenize", function(o) {
      var s = o.tokens;
      s.forEach(function(u) {
        if (typeof u != "string" && u.type === "generic-text") {
          var f = i(u);
          a(f) || (u.type = "bad-line", u.content = f);
        }
      });
    });
    function a(o) {
      for (var s = "[]{}", u = [], f = 0; f < o.length; f++) {
        var p = o[f], m = s.indexOf(p);
        if (m !== -1) {
          if (m % 2 === 0)
            u.push(m + 1);
          else if (u.pop() !== m)
            return !1;
        }
      }
      return u.length === 0;
    }
    function i(o) {
      return typeof o == "string" ? o : Array.isArray(o) ? o.map(i).join("") : i(o.content);
    }
  })(t);
}
I8.displayName = "nasm";
I8.aliases = [];
function I8(t) {
  t.languages.nasm = {
    comment: /;.*$/m,
    string: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
    label: {
      pattern: /(^\s*)[A-Za-z._?$][\w.?$@~#]*:/m,
      lookbehind: !0,
      alias: "function"
    },
    keyword: [
      /\[?BITS (?:16|32|64)\]?/,
      {
        pattern: /(^\s*)section\s*[a-z.]+:?/im,
        lookbehind: !0
      },
      /(?:extern|global)[^;\r\n]*/i,
      /(?:CPU|DEFAULT|FLOAT).*$/m
    ],
    register: {
      pattern: /\b(?:st\d|[xyz]mm\d\d?|[cdt]r\d|r\d\d?[bwd]?|[er]?[abcd]x|[abcd][hl]|[er]?(?:bp|di|si|sp)|[cdefgs]s)\b/i,
      alias: "variable"
    },
    number: /(?:\b|(?=\$))(?:0[hx](?:\.[\da-f]+|[\da-f]+(?:\.[\da-f]+)?)(?:p[+-]?\d+)?|\d[\da-f]+[hx]|\$\d[\da-f]*|0[oq][0-7]+|[0-7]+[oq]|0[by][01]+|[01]+[by]|0[dt]\d+|(?:\d+(?:\.\d+)?|\.\d+)(?:\.?e[+-]?\d+)?[dt]?)\b/i,
    operator: /[\[\]*+\-\/%<>=&|$!]/
  };
}
D8.displayName = "neon";
D8.aliases = [];
function D8(t) {
  t.languages.neon = {
    comment: {
      pattern: /#.*/,
      greedy: !0
    },
    datetime: {
      pattern: /(^|[[{(=:,\s])\d\d\d\d-\d\d?-\d\d?(?:(?:[Tt]| +)\d\d?:\d\d:\d\d(?:\.\d*)? *(?:Z|[-+]\d\d?(?::?\d\d)?)?)?(?=$|[\]}),\s])/,
      lookbehind: !0,
      alias: "number"
    },
    key: {
      pattern: /(^|[[{(,\s])[^,:=[\]{}()'"\s]+(?=\s*:(?:$|[\]}),\s])|\s*=)/,
      lookbehind: !0,
      alias: "property"
    },
    number: {
      pattern: /(^|[[{(=:,\s])[+-]?(?:0x[\da-fA-F]+|0o[0-7]+|0b[01]+|(?:\d+(?:\.\d*)?|\.?\d+)(?:[eE][+-]?\d+)?)(?=$|[\]}),:=\s])/,
      lookbehind: !0
    },
    boolean: {
      pattern: /(^|[[{(=:,\s])(?:false|no|true|yes)(?=$|[\]}),:=\s])/i,
      lookbehind: !0
    },
    null: {
      pattern: /(^|[[{(=:,\s])(?:null)(?=$|[\]}),:=\s])/i,
      lookbehind: !0,
      alias: "keyword"
    },
    string: {
      pattern: /(^|[[{(=:,\s])(?:('''|""")\r?\n(?:(?:[^\r\n]|\r?\n(?![\t ]*\2))*\r?\n)?[\t ]*\2|'[^'\r\n]*'|"(?:\\.|[^\\"\r\n])*")/,
      lookbehind: !0,
      greedy: !0
    },
    literal: {
      pattern: /(^|[[{(=:,\s])(?:[^#"',:=[\]{}()\s`-]|[:-][^"',=[\]{}()\s])(?:[^,:=\]})(\s]|:(?![\s,\]})]|$)|[ \t]+[^#,:=\]})(\s])*/,
      lookbehind: !0,
      alias: "string"
    },
    punctuation: /[,:=[\]{}()-]/
  };
}
N8.displayName = "nevod";
N8.aliases = [];
function N8(t) {
  t.languages.nevod = {
    comment: /\/\/.*|(?:\/\*[\s\S]*?(?:\*\/|$))/,
    string: {
      pattern: /(?:"(?:""|[^"])*"(?!")|'(?:''|[^'])*'(?!'))!?\*?/,
      greedy: !0,
      inside: {
        "string-attrs": /!$|!\*$|\*$/
      }
    },
    namespace: {
      pattern: /(@namespace\s+)[a-zA-Z0-9\-.]+(?=\s*\{)/,
      lookbehind: !0
    },
    pattern: {
      pattern: /(@pattern\s+)?#?[a-zA-Z0-9\-.]+(?:\s*\(\s*(?:~\s*)?[a-zA-Z0-9\-.]+\s*(?:,\s*(?:~\s*)?[a-zA-Z0-9\-.]*)*\))?(?=\s*=)/,
      lookbehind: !0,
      inside: {
        "pattern-name": {
          pattern: /^#?[a-zA-Z0-9\-.]+/,
          alias: "class-name"
        },
        fields: {
          pattern: /\(.*\)/,
          inside: {
            "field-name": {
              pattern: /[a-zA-Z0-9\-.]+/,
              alias: "variable"
            },
            punctuation: /[,()]/,
            operator: {
              pattern: /~/,
              alias: "field-hidden-mark"
            }
          }
        }
      }
    },
    search: {
      pattern: /(@search\s+|#)[a-zA-Z0-9\-.]+(?:\.\*)?(?=\s*;)/,
      alias: "function",
      lookbehind: !0
    },
    keyword: /@(?:having|inside|namespace|outside|pattern|require|search|where)\b/,
    "standard-pattern": {
      pattern: /\b(?:Alpha|AlphaNum|Any|Blank|End|LineBreak|Num|NumAlpha|Punct|Space|Start|Symbol|Word|WordBreak)\b(?:\([a-zA-Z0-9\-.,\s+]*\))?/,
      inside: {
        "standard-pattern-name": {
          pattern: /^[a-zA-Z0-9\-.]+/,
          alias: "builtin"
        },
        quantifier: {
          pattern: /\b\d+(?:\s*\+|\s*-\s*\d+)?(?!\w)/,
          alias: "number"
        },
        "standard-pattern-attr": {
          pattern: /[a-zA-Z0-9\-.]+/,
          alias: "builtin"
        },
        punctuation: /[,()]/
      }
    },
    quantifier: {
      pattern: /\b\d+(?:\s*\+|\s*-\s*\d+)?(?!\w)/,
      alias: "number"
    },
    operator: [
      {
        pattern: /=/,
        alias: "pattern-def"
      },
      {
        pattern: /&/,
        alias: "conjunction"
      },
      {
        pattern: /~/,
        alias: "exception"
      },
      {
        pattern: /\?/,
        alias: "optionality"
      },
      {
        pattern: /[[\]]/,
        alias: "repetition"
      },
      {
        pattern: /[{}]/,
        alias: "variation"
      },
      {
        pattern: /[+_]/,
        alias: "sequence"
      },
      {
        pattern: /\.{2,3}/,
        alias: "span"
      }
    ],
    "field-capture": [
      {
        pattern: /([a-zA-Z0-9\-.]+\s*\()\s*[a-zA-Z0-9\-.]+\s*:\s*[a-zA-Z0-9\-.]+(?:\s*,\s*[a-zA-Z0-9\-.]+\s*:\s*[a-zA-Z0-9\-.]+)*(?=\s*\))/,
        lookbehind: !0,
        inside: {
          "field-name": {
            pattern: /[a-zA-Z0-9\-.]+/,
            alias: "variable"
          },
          colon: /:/
        }
      },
      {
        pattern: /[a-zA-Z0-9\-.]+\s*:/,
        inside: {
          "field-name": {
            pattern: /[a-zA-Z0-9\-.]+/,
            alias: "variable"
          },
          colon: /:/
        }
      }
    ],
    punctuation: /[:;,()]/,
    name: /[a-zA-Z0-9\-.]+/
  };
}
P8.displayName = "nginx";
P8.aliases = [];
function P8(t) {
  (function(e) {
    var n = /\$(?:\w[a-z\d]*(?:_[^\x00-\x1F\s"'\\()$]*)?|\{[^}\s"'\\]+\})/i;
    e.languages.nginx = {
      comment: {
        pattern: /(^|[\s{};])#.*/,
        lookbehind: !0,
        greedy: !0
      },
      directive: {
        pattern: /(^|\s)\w(?:[^;{}"'\\\s]|\\.|"(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*'|\s+(?:#.*(?!.)|(?![#\s])))*?(?=\s*[;{])/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          string: {
            pattern: /((?:^|[^\\])(?:\\\\)*)(?:"(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*')/,
            lookbehind: !0,
            greedy: !0,
            inside: {
              escape: {
                pattern: /\\["'\\nrt]/,
                alias: "entity"
              },
              variable: n
            }
          },
          comment: {
            pattern: /(\s)#.*/,
            lookbehind: !0,
            greedy: !0
          },
          keyword: {
            pattern: /^\S+/,
            greedy: !0
          },
          // other patterns
          boolean: {
            pattern: /(\s)(?:off|on)(?!\S)/,
            lookbehind: !0
          },
          number: {
            pattern: /(\s)\d+[a-z]*(?!\S)/i,
            lookbehind: !0
          },
          variable: n
        }
      },
      punctuation: /[{};]/
    };
  })(t);
}
L8.displayName = "nim";
L8.aliases = [];
function L8(t) {
  t.languages.nim = {
    comment: {
      pattern: /#.*/,
      greedy: !0
    },
    string: {
      // Double-quoted strings can be prefixed by an identifier (Generalized raw string literals)
      pattern: /(?:\b(?!\d)(?:\w|\\x[89a-fA-F][0-9a-fA-F])+)?(?:"""[\s\S]*?"""(?!")|"(?:\\[\s\S]|""|[^"\\])*")/,
      greedy: !0
    },
    char: {
      // Character literals are handled specifically to prevent issues with numeric type suffixes
      pattern: /'(?:\\(?:\d+|x[\da-fA-F]{0,2}|.)|[^'])'/,
      greedy: !0
    },
    function: {
      pattern: /(?:(?!\d)(?:\w|\\x[89a-fA-F][0-9a-fA-F])+|`[^`\r\n]+`)\*?(?:\[[^\]]+\])?(?=\s*\()/,
      greedy: !0,
      inside: {
        operator: /\*$/
      }
    },
    // We don't want to highlight operators (and anything really) inside backticks
    identifier: {
      pattern: /`[^`\r\n]+`/,
      greedy: !0,
      inside: {
        punctuation: /`/
      }
    },
    // The negative look ahead prevents wrong highlighting of the .. operator
    number: /\b(?:0[xXoObB][\da-fA-F_]+|\d[\d_]*(?:(?!\.\.)\.[\d_]*)?(?:[eE][+-]?\d[\d_]*)?)(?:'?[iuf]\d*)?/,
    keyword: /\b(?:addr|as|asm|atomic|bind|block|break|case|cast|concept|const|continue|converter|defer|discard|distinct|do|elif|else|end|enum|except|export|finally|for|from|func|generic|if|import|include|interface|iterator|let|macro|method|mixin|nil|object|out|proc|ptr|raise|ref|return|static|template|try|tuple|type|using|var|when|while|with|without|yield)\b/,
    operator: {
      // Look behind and look ahead prevent wrong highlighting of punctuations [. .] {. .} (. .)
      // but allow the slice operator .. to take precedence over them
      // One can define his own operators in Nim so all combination of operators might be an operator.
      pattern: /(^|[({\[](?=\.\.)|(?![({\[]\.).)(?:(?:[=+\-*\/<>@$~&%|!?^:\\]|\.\.|\.(?![)}\]]))+|\b(?:and|div|in|is|isnot|mod|not|notin|of|or|shl|shr|xor)\b)/m,
      lookbehind: !0
    },
    punctuation: /[({\[]\.|\.[)}\]]|[`(){}\[\],:]/
  };
}
M8.displayName = "nix";
M8.aliases = [];
function M8(t) {
  t.languages.nix = {
    comment: {
      pattern: /\/\*[\s\S]*?\*\/|#.*/,
      greedy: !0
    },
    string: {
      pattern: /"(?:[^"\\]|\\[\s\S])*"|''(?:(?!'')[\s\S]|''(?:'|\\|\$\{))*''/,
      greedy: !0,
      inside: {
        interpolation: {
          // The lookbehind ensures the ${} is not preceded by \ or ''
          pattern: /(^|(?:^|(?!'').)[^\\])\$\{(?:[^{}]|\{[^}]*\})*\}/,
          lookbehind: !0,
          inside: null
          // see below
        }
      }
    },
    url: [
      /\b(?:[a-z]{3,7}:\/\/)[\w\-+%~\/.:#=?&]+/,
      {
        pattern: /([^\/])(?:[\w\-+%~.:#=?&]*(?!\/\/)[\w\-+%~\/.:#=?&])?(?!\/\/)\/[\w\-+%~\/.:#=?&]*/,
        lookbehind: !0
      }
    ],
    antiquotation: {
      pattern: /\$(?=\{)/,
      alias: "important"
    },
    number: /\b\d+\b/,
    keyword: /\b(?:assert|builtins|else|if|in|inherit|let|null|or|then|with)\b/,
    function: /\b(?:abort|add|all|any|attrNames|attrValues|baseNameOf|compareVersions|concatLists|currentSystem|deepSeq|derivation|dirOf|div|elem(?:At)?|fetch(?:Tarball|url)|filter(?:Source)?|fromJSON|genList|getAttr|getEnv|hasAttr|hashString|head|import|intersectAttrs|is(?:Attrs|Bool|Function|Int|List|Null|String)|length|lessThan|listToAttrs|map|mul|parseDrvName|pathExists|read(?:Dir|File)|removeAttrs|replaceStrings|seq|sort|stringLength|sub(?:string)?|tail|throw|to(?:File|JSON|Path|String|XML)|trace|typeOf)\b|\bfoldl'\B/,
    boolean: /\b(?:false|true)\b/,
    operator: /[=!<>]=?|\+\+?|\|\||&&|\/\/|->?|[?@]/,
    punctuation: /[{}()[\].,:;]/
  }, t.languages.nix.string.inside.interpolation.inside = t.languages.nix;
}
F8.displayName = "nsis";
F8.aliases = [];
function F8(t) {
  t.languages.nsis = {
    comment: {
      pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|[#;].*)/,
      lookbehind: !0,
      greedy: !0
    },
    string: {
      pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
      greedy: !0
    },
    keyword: {
      pattern: /(^[\t ]*)(?:Abort|Add(?:BrandingImage|Size)|AdvSplash|Allow(?:RootDirInstall|SkipFiles)|AutoCloseWindow|BG(?:Font|Gradient|Image)|Banner|BrandingText|BringToFront|CRCCheck|Call(?:InstDLL)?|Caption|ChangeUI|CheckBitmap|ClearErrors|CompletedText|ComponentText|CopyFiles|Create(?:Directory|Font|ShortCut)|Delete(?:INISec|INIStr|RegKey|RegValue)?|Detail(?:Print|sButtonText)|Dialer|Dir(?:Text|Var|Verify)|EnableWindow|Enum(?:RegKey|RegValue)|Exch|Exec(?:Shell(?:Wait)?|Wait)?|ExpandEnvStrings|File(?:BufSize|Close|ErrorText|Open|Read|ReadByte|ReadUTF16LE|ReadWord|Seek|Write|WriteByte|WriteUTF16LE|WriteWord)?|Find(?:Close|First|Next|Window)|FlushINI|Get(?:CurInstType|CurrentAddress|DLLVersion(?:Local)?|DlgItem|ErrorLevel|FileTime(?:Local)?|FullPathName|Function(?:Address|End)?|InstDirError|KnownFolderPath|LabelAddress|TempFileName|WinVer)|Goto|HideWindow|Icon|If(?:Abort|Errors|FileExists|RebootFlag|RtlLanguage|ShellVarContextAll|Silent)|InitPluginsDir|InstProgressFlags|Inst(?:Type(?:GetText|SetText)?)|Install(?:ButtonText|Colors|Dir(?:RegKey)?)|Int(?:64|Ptr)?CmpU?|Int(?:64)?Fmt|Int(?:Ptr)?Op|IsWindow|Lang(?:DLL|String)|License(?:BkColor|Data|ForceSelection|LangString|Text)|LoadLanguageFile|LockWindow|Log(?:Set|Text)|Manifest(?:DPIAware|SupportedOS)|Math|MessageBox|MiscButtonText|NSISdl|Name|Nop|OutFile|PE(?:DllCharacteristics|SubsysVer)|Page(?:Callbacks)?|Pop|Push|Quit|RMDir|Read(?:EnvStr|INIStr|RegDWORD|RegStr)|Reboot|RegDLL|Rename|RequestExecutionLevel|ReserveFile|Return|SearchPath|Section(?:End|GetFlags|GetInstTypes|GetSize|GetText|Group|In|SetFlags|SetInstTypes|SetSize|SetText)?|SendMessage|Set(?:AutoClose|BrandingImage|Compress|Compressor(?:DictSize)?|CtlColors|CurInstType|DatablockOptimize|DateSave|Details(?:Print|View)|ErrorLevel|Errors|FileAttributes|Font|OutPath|Overwrite|PluginUnload|RebootFlag|RegView|ShellVarContext|Silent)|Show(?:InstDetails|UninstDetails|Window)|Silent(?:Install|UnInstall)|Sleep|SpaceTexts|Splash|StartMenu|Str(?:CmpS?|Cpy|Len)|SubCaption|System|Target|UnRegDLL|Unicode|UninstPage|Uninstall(?:ButtonText|Caption|Icon|SubCaption|Text)|UserInfo|VI(?:AddVersionKey|FileVersion|ProductVersion)|VPatch|Var|WindowIcon|Write(?:INIStr|Reg(?:Bin|DWORD|ExpandStr|MultiStr|None|Str)|Uninstaller)|XPStyle|ns(?:Dialogs|Exec))\b/m,
      lookbehind: !0
    },
    property: /\b(?:ARCHIVE|FILE_(?:ATTRIBUTE_ARCHIVE|ATTRIBUTE_NORMAL|ATTRIBUTE_OFFLINE|ATTRIBUTE_READONLY|ATTRIBUTE_SYSTEM|ATTRIBUTE_TEMPORARY)|HK(?:(?:CR|CU|LM)(?:32|64)?|DD|PD|U)|HKEY_(?:CLASSES_ROOT|CURRENT_CONFIG|CURRENT_USER|DYN_DATA|LOCAL_MACHINE|PERFORMANCE_DATA|USERS)|ID(?:ABORT|CANCEL|IGNORE|NO|OK|RETRY|YES)|MB_(?:ABORTRETRYIGNORE|DEFBUTTON1|DEFBUTTON2|DEFBUTTON3|DEFBUTTON4|ICONEXCLAMATION|ICONINFORMATION|ICONQUESTION|ICONSTOP|OK|OKCANCEL|RETRYCANCEL|RIGHT|RTLREADING|SETFOREGROUND|TOPMOST|USERICON|YESNO)|NORMAL|OFFLINE|READONLY|SHCTX|SHELL_CONTEXT|SYSTEM|TEMPORARY|admin|all|auto|both|colored|false|force|hide|highest|lastused|leave|listonly|none|normal|notset|off|on|open|print|show|silent|silentlog|smooth|textonly|true|user)\b/,
    constant: /\$\{[!\w\.:\^-]+\}|\$\([!\w\.:\^-]+\)/,
    variable: /\$\w[\w\.]*/,
    number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
    operator: /--?|\+\+?|<=?|>=?|==?=?|&&?|\|\|?|[?*\/~^%]/,
    punctuation: /[{}[\];(),.:]/,
    important: {
      pattern: /(^[\t ]*)!(?:addincludedir|addplugindir|appendfile|cd|define|delfile|echo|else|endif|error|execute|finalize|getdllversion|gettlbversion|if|ifdef|ifmacrodef|ifmacrondef|ifndef|include|insertmacro|macro|macroend|makensis|packhdr|pragma|searchparse|searchreplace|system|tempfile|undef|verbose|warning)\b/im,
      lookbehind: !0
    }
  };
}
$8.displayName = "ocaml";
$8.aliases = [];
function $8(t) {
  t.languages.ocaml = {
    comment: {
      pattern: /\(\*[\s\S]*?\*\)/,
      greedy: !0
    },
    char: {
      pattern: /'(?:[^\\\r\n']|\\(?:.|[ox]?[0-9a-f]{1,3}))'/i,
      greedy: !0
    },
    string: [
      {
        pattern: /"(?:\\(?:[\s\S]|\r\n)|[^\\\r\n"])*"/,
        greedy: !0
      },
      {
        pattern: /\{([a-z_]*)\|[\s\S]*?\|\1\}/,
        greedy: !0
      }
    ],
    number: [
      // binary and octal
      /\b(?:0b[01][01_]*|0o[0-7][0-7_]*)\b/i,
      // hexadecimal
      /\b0x[a-f0-9][a-f0-9_]*(?:\.[a-f0-9_]*)?(?:p[+-]?\d[\d_]*)?(?!\w)/i,
      // decimal
      /\b\d[\d_]*(?:\.[\d_]*)?(?:e[+-]?\d[\d_]*)?(?!\w)/i
    ],
    directive: {
      pattern: /\B#\w+/,
      alias: "property"
    },
    label: {
      pattern: /\B~\w+/,
      alias: "property"
    },
    "type-variable": {
      pattern: /\B'\w+/,
      alias: "function"
    },
    variant: {
      pattern: /`\w+/,
      alias: "symbol"
    },
    // For the list of keywords and operators,
    // see: http://caml.inria.fr/pub/docs/manual-ocaml/lex.html#sec84
    keyword: /\b(?:as|assert|begin|class|constraint|do|done|downto|else|end|exception|external|for|fun|function|functor|if|in|include|inherit|initializer|lazy|let|match|method|module|mutable|new|nonrec|object|of|open|private|rec|sig|struct|then|to|try|type|val|value|virtual|when|where|while|with)\b/,
    boolean: /\b(?:false|true)\b/,
    "operator-like-punctuation": {
      pattern: /\[[<>|]|[>|]\]|\{<|>\}/,
      alias: "punctuation"
    },
    // Custom operators are allowed
    operator: /\.[.~]|:[=>]|[=<>@^|&+\-*\/$%!?~][!$%&*+\-.\/:<=>?@^|~]*|\b(?:and|asr|land|lor|lsl|lsr|lxor|mod|or)\b/,
    punctuation: /;;|::|[(){}\[\].,:;#]|\b_\b/
  };
}
B8.displayName = "odin";
B8.aliases = [];
function B8(t) {
  (function(e) {
    var n = /\\(?:["'\\abefnrtv]|0[0-7]{2}|U[\dA-Fa-f]{6}|u[\dA-Fa-f]{4}|x[\dA-Fa-f]{2})/;
    e.languages.odin = {
      /**
       * The current implementation supports only 1 level of nesting.
       *
       * @author Michael Schmidt
       * @author edukisto
       */
      comment: [
        {
          pattern: /\/\*(?:[^/*]|\/(?!\*)|\*(?!\/)|\/\*(?:\*(?!\/)|[^*])*(?:\*\/|$))*(?:\*\/|$)/,
          greedy: !0
        },
        {
          pattern: /#![^\n\r]*/,
          greedy: !0
        },
        {
          pattern: /\/\/[^\n\r]*/,
          greedy: !0
        }
      ],
      /**
       * Should be found before strings because of '"'"- and '`'`-like sequences.
       */
      char: {
        pattern: /'(?:\\(?:.|[0Uux][0-9A-Fa-f]{1,6})|[^\n\r'\\])'/,
        greedy: !0,
        inside: {
          symbol: n
        }
      },
      string: [
        {
          pattern: /`[^`]*`/,
          greedy: !0
        },
        {
          pattern: /"(?:\\.|[^\n\r"\\])*"/,
          greedy: !0,
          inside: {
            symbol: n
          }
        }
      ],
      directive: {
        pattern: /#\w+/,
        alias: "property"
      },
      number: /\b0(?:b[01_]+|d[\d_]+|h_*(?:(?:(?:[\dA-Fa-f]_*){8}){1,2}|(?:[\dA-Fa-f]_*){4})|o[0-7_]+|x[\dA-F_a-f]+|z[\dAB_ab]+)\b|(?:\b\d+(?:\.(?!\.)\d*)?|\B\.\d+)(?:[Ee][+-]?\d*)?[ijk]?(?!\w)/,
      discard: {
        pattern: /\b_\b/,
        alias: "keyword"
      },
      "procedure-definition": {
        pattern: /\b\w+(?=[ \t]*(?::\s*){2}proc\b)/,
        alias: "function"
      },
      keyword: /\b(?:asm|auto_cast|bit_set|break|case|cast|context|continue|defer|distinct|do|dynamic|else|enum|fallthrough|for|foreign|if|import|in|map|matrix|not_in|or_else|or_return|package|proc|return|struct|switch|transmute|typeid|union|using|when|where)\b/,
      /**
       * false, nil, true can be used as procedure names. "_" and keywords can't.
       */
      "procedure-name": {
        pattern: /\b\w+(?=[ \t]*\()/,
        alias: "function"
      },
      boolean: /\b(?:false|nil|true)\b/,
      "constant-parameter-sign": {
        pattern: /\$/,
        alias: "important"
      },
      undefined: {
        pattern: /---/,
        alias: "operator"
      },
      arrow: {
        pattern: /->/,
        alias: "punctuation"
      },
      operator: /\+\+|--|\.\.[<=]?|(?:&~|[-!*+/=~]|[%&<>|]{1,2})=?|[?^]/,
      punctuation: /[(),.:;@\[\]{}]/
    };
  })(t);
}
U8.displayName = "opencl";
U8.aliases = [];
function U8(t) {
  t.register(tp), function(e) {
    e.languages.opencl = e.languages.extend("c", {
      // Extracted from the official specs (2.0) and http://streamcomputing.eu/downloads/?opencl.lang (opencl-keywords, opencl-types) and http://sourceforge.net/tracker/?func=detail&aid=2957794&group_id=95717&atid=612384 (Words2, partly Words3)
      keyword: /\b(?:(?:__)?(?:constant|global|kernel|local|private|read_only|read_write|write_only)|__attribute__|auto|(?:bool|u?(?:char|int|long|short)|half|quad)(?:2|3|4|8|16)?|break|case|complex|const|continue|(?:double|float)(?:16(?:x(?:1|2|4|8|16))?|1x(?:1|2|4|8|16)|2(?:x(?:1|2|4|8|16))?|3|4(?:x(?:1|2|4|8|16))?|8(?:x(?:1|2|4|8|16))?)?|default|do|else|enum|extern|for|goto|if|imaginary|inline|packed|pipe|register|restrict|return|signed|sizeof|static|struct|switch|typedef|uniform|union|unsigned|void|volatile|while)\b/,
      // Extracted from http://streamcomputing.eu/downloads/?opencl.lang (opencl-const)
      // Math Constants: https://www.khronos.org/registry/OpenCL/sdk/2.1/docs/man/xhtml/mathConstants.html
      // Macros and Limits: https://www.khronos.org/registry/OpenCL/sdk/2.1/docs/man/xhtml/macroLimits.html
      number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[fuhl]{0,4}/i,
      boolean: /\b(?:false|true)\b/,
      "constant-opencl-kernel": {
        pattern: /\b(?:CHAR_(?:BIT|MAX|MIN)|CLK_(?:ADDRESS_(?:CLAMP(?:_TO_EDGE)?|NONE|REPEAT)|FILTER_(?:LINEAR|NEAREST)|(?:GLOBAL|LOCAL)_MEM_FENCE|NORMALIZED_COORDS_(?:FALSE|TRUE))|CL_(?:BGRA|(?:HALF_)?FLOAT|INTENSITY|LUMINANCE|A?R?G?B?[Ax]?|(?:(?:UN)?SIGNED|[US]NORM)_(?:INT(?:8|16|32))|UNORM_(?:INT_101010|SHORT_(?:555|565)))|(?:DBL|FLT|HALF)_(?:DIG|EPSILON|(?:MAX|MIN)(?:(?:_10)?_EXP)?|MANT_DIG)|FLT_RADIX|HUGE_VALF?|(?:INT|LONG|SCHAR|SHRT)_(?:MAX|MIN)|INFINITY|MAXFLOAT|M_(?:[12]_PI|2_SQRTPI|E|LN(?:2|10)|LOG(?:2|10)E?|PI(?:_[24])?|SQRT(?:1_2|2))(?:_F|_H)?|NAN|(?:UCHAR|UINT|ULONG|USHRT)_MAX)\b/,
        alias: "constant"
      }
    }), e.languages.insertBefore("opencl", "class-name", {
      // https://www.khronos.org/registry/OpenCL/sdk/2.1/docs/man/xhtml/scalarDataTypes.html
      // https://www.khronos.org/registry/OpenCL/sdk/2.1/docs/man/xhtml/otherDataTypes.html
      "builtin-type": {
        pattern: /\b(?:_cl_(?:command_queue|context|device_id|event|kernel|mem|platform_id|program|sampler)|cl_(?:image_format|mem_fence_flags)|clk_event_t|event_t|image(?:1d_(?:array_|buffer_)?t|2d_(?:array_(?:depth_|msaa_depth_|msaa_)?|depth_|msaa_depth_|msaa_)?t|3d_t)|intptr_t|ndrange_t|ptrdiff_t|queue_t|reserve_id_t|sampler_t|size_t|uintptr_t)\b/,
        alias: "keyword"
      }
    });
    var n = {
      // Extracted from http://streamcomputing.eu/downloads/?opencl_host.lang (opencl-types and opencl-host)
      "type-opencl-host": {
        pattern: /\b(?:cl_(?:GLenum|GLint|GLuin|addressing_mode|bitfield|bool|buffer_create_type|build_status|channel_(?:order|type)|(?:u?(?:char|int|long|short)|double|float)(?:2|3|4|8|16)?|command_(?:queue(?:_info|_properties)?|type)|context(?:_info|_properties)?|device_(?:exec_capabilities|fp_config|id|info|local_mem_type|mem_cache_type|type)|(?:event|sampler)(?:_info)?|filter_mode|half|image_info|kernel(?:_info|_work_group_info)?|map_flags|mem(?:_flags|_info|_object_type)?|platform_(?:id|info)|profiling_info|program(?:_build_info|_info)?))\b/,
        alias: "keyword"
      },
      "boolean-opencl-host": {
        pattern: /\bCL_(?:FALSE|TRUE)\b/,
        alias: "boolean"
      },
      // Extracted from cl.h (2.0) and http://streamcomputing.eu/downloads/?opencl_host.lang (opencl-const)
      "constant-opencl-host": {
        pattern: /\bCL_(?:A|ABGR|ADDRESS_(?:CLAMP(?:_TO_EDGE)?|MIRRORED_REPEAT|NONE|REPEAT)|ARGB|BGRA|BLOCKING|BUFFER_CREATE_TYPE_REGION|BUILD_(?:ERROR|IN_PROGRESS|NONE|PROGRAM_FAILURE|SUCCESS)|COMMAND_(?:ACQUIRE_GL_OBJECTS|BARRIER|COPY_(?:BUFFER(?:_RECT|_TO_IMAGE)?|IMAGE(?:_TO_BUFFER)?)|FILL_(?:BUFFER|IMAGE)|MAP(?:_BUFFER|_IMAGE)|MARKER|MIGRATE(?:_SVM)?_MEM_OBJECTS|NATIVE_KERNEL|NDRANGE_KERNEL|READ_(?:BUFFER(?:_RECT)?|IMAGE)|RELEASE_GL_OBJECTS|SVM_(?:FREE|MAP|MEMCPY|MEMFILL|UNMAP)|TASK|UNMAP_MEM_OBJECT|USER|WRITE_(?:BUFFER(?:_RECT)?|IMAGE))|COMPILER_NOT_AVAILABLE|COMPILE_PROGRAM_FAILURE|COMPLETE|CONTEXT_(?:DEVICES|INTEROP_USER_SYNC|NUM_DEVICES|PLATFORM|PROPERTIES|REFERENCE_COUNT)|DEPTH(?:_STENCIL)?|DEVICE_(?:ADDRESS_BITS|AFFINITY_DOMAIN_(?:L[1-4]_CACHE|NEXT_PARTITIONABLE|NUMA)|AVAILABLE|BUILT_IN_KERNELS|COMPILER_AVAILABLE|DOUBLE_FP_CONFIG|ENDIAN_LITTLE|ERROR_CORRECTION_SUPPORT|EXECUTION_CAPABILITIES|EXTENSIONS|GLOBAL_(?:MEM_(?:CACHELINE_SIZE|CACHE_SIZE|CACHE_TYPE|SIZE)|VARIABLE_PREFERRED_TOTAL_SIZE)|HOST_UNIFIED_MEMORY|IL_VERSION|IMAGE(?:2D_MAX_(?:HEIGHT|WIDTH)|3D_MAX_(?:DEPTH|HEIGHT|WIDTH)|_BASE_ADDRESS_ALIGNMENT|_MAX_ARRAY_SIZE|_MAX_BUFFER_SIZE|_PITCH_ALIGNMENT|_SUPPORT)|LINKER_AVAILABLE|LOCAL_MEM_SIZE|LOCAL_MEM_TYPE|MAX_(?:CLOCK_FREQUENCY|COMPUTE_UNITS|CONSTANT_ARGS|CONSTANT_BUFFER_SIZE|GLOBAL_VARIABLE_SIZE|MEM_ALLOC_SIZE|NUM_SUB_GROUPS|ON_DEVICE_(?:EVENTS|QUEUES)|PARAMETER_SIZE|PIPE_ARGS|READ_IMAGE_ARGS|READ_WRITE_IMAGE_ARGS|SAMPLERS|WORK_GROUP_SIZE|WORK_ITEM_DIMENSIONS|WORK_ITEM_SIZES|WRITE_IMAGE_ARGS)|MEM_BASE_ADDR_ALIGN|MIN_DATA_TYPE_ALIGN_SIZE|NAME|NATIVE_VECTOR_WIDTH_(?:CHAR|DOUBLE|FLOAT|HALF|INT|LONG|SHORT)|NOT_(?:AVAILABLE|FOUND)|OPENCL_C_VERSION|PARENT_DEVICE|PARTITION_(?:AFFINITY_DOMAIN|BY_AFFINITY_DOMAIN|BY_COUNTS|BY_COUNTS_LIST_END|EQUALLY|FAILED|MAX_SUB_DEVICES|PROPERTIES|TYPE)|PIPE_MAX_(?:ACTIVE_RESERVATIONS|PACKET_SIZE)|PLATFORM|PREFERRED_(?:GLOBAL_ATOMIC_ALIGNMENT|INTEROP_USER_SYNC|LOCAL_ATOMIC_ALIGNMENT|PLATFORM_ATOMIC_ALIGNMENT|VECTOR_WIDTH_(?:CHAR|DOUBLE|FLOAT|HALF|INT|LONG|SHORT))|PRINTF_BUFFER_SIZE|PROFILE|PROFILING_TIMER_RESOLUTION|QUEUE_(?:ON_(?:DEVICE_(?:MAX_SIZE|PREFERRED_SIZE|PROPERTIES)|HOST_PROPERTIES)|PROPERTIES)|REFERENCE_COUNT|SINGLE_FP_CONFIG|SUB_GROUP_INDEPENDENT_FORWARD_PROGRESS|SVM_(?:ATOMICS|CAPABILITIES|COARSE_GRAIN_BUFFER|FINE_GRAIN_BUFFER|FINE_GRAIN_SYSTEM)|TYPE(?:_ACCELERATOR|_ALL|_CPU|_CUSTOM|_DEFAULT|_GPU)?|VENDOR(?:_ID)?|VERSION)|DRIVER_VERSION|EVENT_(?:COMMAND_(?:EXECUTION_STATUS|QUEUE|TYPE)|CONTEXT|REFERENCE_COUNT)|EXEC_(?:KERNEL|NATIVE_KERNEL|STATUS_ERROR_FOR_EVENTS_IN_WAIT_LIST)|FILTER_(?:LINEAR|NEAREST)|FLOAT|FP_(?:CORRECTLY_ROUNDED_DIVIDE_SQRT|DENORM|FMA|INF_NAN|ROUND_TO_INF|ROUND_TO_NEAREST|ROUND_TO_ZERO|SOFT_FLOAT)|GLOBAL|HALF_FLOAT|IMAGE_(?:ARRAY_SIZE|BUFFER|DEPTH|ELEMENT_SIZE|FORMAT|FORMAT_MISMATCH|FORMAT_NOT_SUPPORTED|HEIGHT|NUM_MIP_LEVELS|NUM_SAMPLES|ROW_PITCH|SLICE_PITCH|WIDTH)|INTENSITY|INVALID_(?:ARG_INDEX|ARG_SIZE|ARG_VALUE|BINARY|BUFFER_SIZE|BUILD_OPTIONS|COMMAND_QUEUE|COMPILER_OPTIONS|CONTEXT|DEVICE|DEVICE_PARTITION_COUNT|DEVICE_QUEUE|DEVICE_TYPE|EVENT|EVENT_WAIT_LIST|GLOBAL_OFFSET|GLOBAL_WORK_SIZE|GL_OBJECT|HOST_PTR|IMAGE_DESCRIPTOR|IMAGE_FORMAT_DESCRIPTOR|IMAGE_SIZE|KERNEL|KERNEL_ARGS|KERNEL_DEFINITION|KERNEL_NAME|LINKER_OPTIONS|MEM_OBJECT|MIP_LEVEL|OPERATION|PIPE_SIZE|PLATFORM|PROGRAM|PROGRAM_EXECUTABLE|PROPERTY|QUEUE_PROPERTIES|SAMPLER|VALUE|WORK_DIMENSION|WORK_GROUP_SIZE|WORK_ITEM_SIZE)|KERNEL_(?:ARG_(?:ACCESS_(?:NONE|QUALIFIER|READ_ONLY|READ_WRITE|WRITE_ONLY)|ADDRESS_(?:CONSTANT|GLOBAL|LOCAL|PRIVATE|QUALIFIER)|INFO_NOT_AVAILABLE|NAME|TYPE_(?:CONST|NAME|NONE|PIPE|QUALIFIER|RESTRICT|VOLATILE))|ATTRIBUTES|COMPILE_NUM_SUB_GROUPS|COMPILE_WORK_GROUP_SIZE|CONTEXT|EXEC_INFO_SVM_FINE_GRAIN_SYSTEM|EXEC_INFO_SVM_PTRS|FUNCTION_NAME|GLOBAL_WORK_SIZE|LOCAL_MEM_SIZE|LOCAL_SIZE_FOR_SUB_GROUP_COUNT|MAX_NUM_SUB_GROUPS|MAX_SUB_GROUP_SIZE_FOR_NDRANGE|NUM_ARGS|PREFERRED_WORK_GROUP_SIZE_MULTIPLE|PRIVATE_MEM_SIZE|PROGRAM|REFERENCE_COUNT|SUB_GROUP_COUNT_FOR_NDRANGE|WORK_GROUP_SIZE)|LINKER_NOT_AVAILABLE|LINK_PROGRAM_FAILURE|LOCAL|LUMINANCE|MAP_(?:FAILURE|READ|WRITE|WRITE_INVALIDATE_REGION)|MEM_(?:ALLOC_HOST_PTR|ASSOCIATED_MEMOBJECT|CONTEXT|COPY_HOST_PTR|COPY_OVERLAP|FLAGS|HOST_NO_ACCESS|HOST_PTR|HOST_READ_ONLY|HOST_WRITE_ONLY|KERNEL_READ_AND_WRITE|MAP_COUNT|OBJECT_(?:ALLOCATION_FAILURE|BUFFER|IMAGE1D|IMAGE1D_ARRAY|IMAGE1D_BUFFER|IMAGE2D|IMAGE2D_ARRAY|IMAGE3D|PIPE)|OFFSET|READ_ONLY|READ_WRITE|REFERENCE_COUNT|SIZE|SVM_ATOMICS|SVM_FINE_GRAIN_BUFFER|TYPE|USES_SVM_POINTER|USE_HOST_PTR|WRITE_ONLY)|MIGRATE_MEM_OBJECT_(?:CONTENT_UNDEFINED|HOST)|MISALIGNED_SUB_BUFFER_OFFSET|NONE|NON_BLOCKING|OUT_OF_(?:HOST_MEMORY|RESOURCES)|PIPE_(?:MAX_PACKETS|PACKET_SIZE)|PLATFORM_(?:EXTENSIONS|HOST_TIMER_RESOLUTION|NAME|PROFILE|VENDOR|VERSION)|PROFILING_(?:COMMAND_(?:COMPLETE|END|QUEUED|START|SUBMIT)|INFO_NOT_AVAILABLE)|PROGRAM_(?:BINARIES|BINARY_SIZES|BINARY_TYPE(?:_COMPILED_OBJECT|_EXECUTABLE|_LIBRARY|_NONE)?|BUILD_(?:GLOBAL_VARIABLE_TOTAL_SIZE|LOG|OPTIONS|STATUS)|CONTEXT|DEVICES|IL|KERNEL_NAMES|NUM_DEVICES|NUM_KERNELS|REFERENCE_COUNT|SOURCE)|QUEUED|QUEUE_(?:CONTEXT|DEVICE|DEVICE_DEFAULT|ON_DEVICE|ON_DEVICE_DEFAULT|OUT_OF_ORDER_EXEC_MODE_ENABLE|PROFILING_ENABLE|PROPERTIES|REFERENCE_COUNT|SIZE)|R|RA|READ_(?:ONLY|WRITE)_CACHE|RG|RGB|RGBA|RGBx|RGx|RUNNING|Rx|SAMPLER_(?:ADDRESSING_MODE|CONTEXT|FILTER_MODE|LOD_MAX|LOD_MIN|MIP_FILTER_MODE|NORMALIZED_COORDS|REFERENCE_COUNT)|(?:UN)?SIGNED_INT(?:8|16|32)|SNORM_INT(?:8|16)|SUBMITTED|SUCCESS|UNORM_INT(?:8|16|24|_101010|_101010_2)|UNORM_SHORT_(?:555|565)|VERSION_(?:1_0|1_1|1_2|2_0|2_1)|sBGRA|sRGB|sRGBA|sRGBx)\b/,
        alias: "constant"
      },
      // Extracted from cl.h (2.0) and http://streamcomputing.eu/downloads/?opencl_host.lang (opencl-host)
      "function-opencl-host": {
        pattern: /\bcl(?:BuildProgram|CloneKernel|CompileProgram|Create(?:Buffer|CommandQueue(?:WithProperties)?|Context|ContextFromType|Image|Image2D|Image3D|Kernel|KernelsInProgram|Pipe|ProgramWith(?:Binary|BuiltInKernels|IL|Source)|Sampler|SamplerWithProperties|SubBuffer|SubDevices|UserEvent)|Enqueue(?:(?:Barrier|Marker)(?:WithWaitList)?|Copy(?:Buffer(?:Rect|ToImage)?|Image(?:ToBuffer)?)|(?:Fill|Map)(?:Buffer|Image)|MigrateMemObjects|NDRangeKernel|NativeKernel|(?:Read|Write)(?:Buffer(?:Rect)?|Image)|SVM(?:Free|Map|MemFill|Memcpy|MigrateMem|Unmap)|Task|UnmapMemObject|WaitForEvents)|Finish|Flush|Get(?:CommandQueueInfo|ContextInfo|Device(?:AndHostTimer|IDs|Info)|Event(?:Profiling)?Info|ExtensionFunctionAddress(?:ForPlatform)?|HostTimer|ImageInfo|Kernel(?:ArgInfo|Info|SubGroupInfo|WorkGroupInfo)|MemObjectInfo|PipeInfo|Platform(?:IDs|Info)|Program(?:Build)?Info|SamplerInfo|SupportedImageFormats)|LinkProgram|(?:Release|Retain)(?:CommandQueue|Context|Device|Event|Kernel|MemObject|Program|Sampler)|SVM(?:Alloc|Free)|Set(?:CommandQueueProperty|DefaultDeviceCommandQueue|EventCallback|Kernel|Kernel(?:Arg(?:SVMPointer)?|ExecInfo)|MemObjectDestructorCallback|UserEventStatus)|Unload(?:Platform)?Compiler|WaitForEvents)\b/,
        alias: "function"
      }
    };
    e.languages.insertBefore("c", "keyword", n), e.languages.cpp && (n["type-opencl-host-cpp"] = {
      pattern: /\b(?:Buffer|BufferGL|BufferRenderGL|CommandQueue|Context|Device|DeviceCommandQueue|EnqueueArgs|Event|Image|Image1D|Image1DArray|Image1DBuffer|Image2D|Image2DArray|Image2DGL|Image3D|Image3DGL|ImageFormat|ImageGL|Kernel|KernelFunctor|LocalSpaceArg|Memory|NDRange|Pipe|Platform|Program|SVMAllocator|SVMTraitAtomic|SVMTraitCoarse|SVMTraitFine|SVMTraitReadOnly|SVMTraitReadWrite|SVMTraitWriteOnly|Sampler|UserEvent)\b/,
      alias: "keyword"
    }, e.languages.insertBefore("cpp", "keyword", n));
  }(t);
}
z8.displayName = "openqasm";
z8.aliases = ["qasm"];
function z8(t) {
  t.languages.openqasm = {
    comment: /\/\*[\s\S]*?\*\/|\/\/.*/,
    string: {
      pattern: /"[^"\r\n\t]*"|'[^'\r\n\t]*'/,
      greedy: !0
    },
    keyword: /\b(?:CX|OPENQASM|U|barrier|boxas|boxto|break|const|continue|ctrl|def|defcal|defcalgrammar|delay|else|end|for|gate|gphase|if|in|include|inv|kernel|lengthof|let|measure|pow|reset|return|rotary|stretchinf|while)\b|#pragma\b/,
    "class-name": /\b(?:angle|bit|bool|creg|fixed|float|int|length|qreg|qubit|stretch|uint)\b/,
    function: /\b(?:cos|exp|ln|popcount|rotl|rotr|sin|sqrt|tan)\b(?=\s*\()/,
    constant: /\b(?:euler|pi|tau)\b|π|𝜏|ℇ/,
    number: {
      pattern: /(^|[^.\w$])(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?(?:dt|ns|us|µs|ms|s)?/i,
      lookbehind: !0
    },
    operator: /->|>>=?|<<=?|&&|\|\||\+\+|--|[!=<>&|~^+\-*/%]=?|@/,
    punctuation: /[(){}\[\];,:.]/
  }, t.languages.qasm = t.languages.openqasm;
}
H8.displayName = "oz";
H8.aliases = [];
function H8(t) {
  t.languages.oz = {
    comment: {
      pattern: /\/\*[\s\S]*?\*\/|%.*/,
      greedy: !0
    },
    string: {
      pattern: /"(?:[^"\\]|\\[\s\S])*"/,
      greedy: !0
    },
    atom: {
      pattern: /'(?:[^'\\]|\\[\s\S])*'/,
      greedy: !0,
      alias: "builtin"
    },
    keyword: /\$|\[\]|\b(?:_|at|attr|case|catch|choice|class|cond|declare|define|dis|else(?:case|if)?|end|export|fail|false|feat|finally|from|fun|functor|if|import|in|local|lock|meth|nil|not|of|or|prepare|proc|prop|raise|require|self|skip|then|thread|true|try|unit)\b/,
    function: [
      /\b[a-z][A-Za-z\d]*(?=\()/,
      {
        pattern: /(\{)[A-Z][A-Za-z\d]*\b/,
        lookbehind: !0
      }
    ],
    number: /\b(?:0[bx][\da-f]+|\d+(?:\.\d*)?(?:e~?\d+)?)\b|&(?:[^\\]|\\(?:\d{3}|.))/i,
    variable: /`(?:[^`\\]|\\.)+`/,
    "attr-name": /\b\w+(?=[ \t]*:(?![:=]))/,
    operator: /:(?:=|::?)|<[-:=]?|=(?:=|<?:?)|>=?:?|\\=:?|!!?|[|#+\-*\/,~^@]|\b(?:andthen|div|mod|orelse)\b/,
    punctuation: /[\[\](){}.:;?]/
  };
}
W8.displayName = "parigp";
W8.aliases = [];
function W8(t) {
  t.languages.parigp = {
    comment: /\/\*[\s\S]*?\*\/|\\\\.*/,
    string: {
      pattern: /"(?:[^"\\\r\n]|\\.)*"/,
      greedy: !0
    },
    // PARI/GP does not care about white spaces at all
    // so let's process the keywords to build an appropriate regexp
    // (e.g. "b *r *e *a *k", etc.)
    keyword: function() {
      var e = [
        "breakpoint",
        "break",
        "dbg_down",
        "dbg_err",
        "dbg_up",
        "dbg_x",
        "forcomposite",
        "fordiv",
        "forell",
        "forpart",
        "forprime",
        "forstep",
        "forsubgroup",
        "forvec",
        "for",
        "iferr",
        "if",
        "local",
        "my",
        "next",
        "return",
        "until",
        "while"
      ];
      return e = e.map(function(n) {
        return n.split("").join(" *");
      }).join("|"), RegExp("\\b(?:" + e + ")\\b");
    }(),
    function: /\b\w(?:[\w ]*\w)?(?= *\()/,
    number: {
      // The lookbehind and the negative lookahead prevent from breaking the .. operator
      pattern: /((?:\. *\. *)?)(?:\b\d(?: *\d)*(?: *(?!\. *\.)\.(?: *\d)*)?|\. *\d(?: *\d)*)(?: *e *(?:[+-] *)?\d(?: *\d)*)?/i,
      lookbehind: !0
    },
    operator: /\. *\.|[*\/!](?: *=)?|%(?: *=|(?: *#)?(?: *')*)?|\+(?: *[+=])?|-(?: *[-=>])?|<(?: *>|(?: *<)?(?: *=)?)?|>(?: *>)?(?: *=)?|=(?: *=){0,2}|\\(?: *\/)?(?: *=)?|&(?: *&)?|\| *\||['#~^]/,
    punctuation: /[\[\]{}().,:;|]/
  };
}
Q8.displayName = "parser";
Q8.aliases = [];
function Q8(t) {
  t.register(ws), function(e) {
    var n = e.languages.parser = e.languages.extend("markup", {
      keyword: {
        pattern: /(^|[^^])(?:\^(?:case|eval|for|if|switch|throw)\b|@(?:BASE|CLASS|GET(?:_DEFAULT)?|OPTIONS|SET_DEFAULT|USE)\b)/,
        lookbehind: !0
      },
      variable: {
        pattern: /(^|[^^])\B\$(?:\w+|(?=[.{]))(?:(?:\.|::?)\w+)*(?:\.|::?)?/,
        lookbehind: !0,
        inside: {
          punctuation: /\.|:+/
        }
      },
      function: {
        pattern: /(^|[^^])\B[@^]\w+(?:(?:\.|::?)\w+)*(?:\.|::?)?/,
        lookbehind: !0,
        inside: {
          keyword: {
            pattern: /(^@)(?:GET_|SET_)/,
            lookbehind: !0
          },
          punctuation: /\.|:+/
        }
      },
      escape: {
        pattern: /\^(?:[$^;@()\[\]{}"':]|#[a-f\d]*)/i,
        alias: "builtin"
      },
      punctuation: /[\[\](){};]/
    });
    n = e.languages.insertBefore("parser", "keyword", {
      "parser-comment": {
        pattern: /(\s)#.*/,
        lookbehind: !0,
        alias: "comment"
      },
      expression: {
        // Allow for 3 levels of depth
        pattern: /(^|[^^])\((?:[^()]|\((?:[^()]|\((?:[^()])*\))*\))*\)/,
        greedy: !0,
        lookbehind: !0,
        inside: {
          string: {
            pattern: /(^|[^^])(["'])(?:(?!\2)[^^]|\^[\s\S])*\2/,
            lookbehind: !0
          },
          keyword: n.keyword,
          variable: n.variable,
          function: n.function,
          boolean: /\b(?:false|true)\b/,
          number: /\b(?:0x[a-f\d]+|\d+(?:\.\d*)?(?:e[+-]?\d+)?)\b/i,
          escape: n.escape,
          operator: /[~+*\/\\%]|!(?:\|\|?|=)?|&&?|\|\|?|==|<[<=]?|>[>=]?|-[fd]?|\b(?:def|eq|ge|gt|in|is|le|lt|ne)\b/,
          punctuation: n.punctuation
        }
      }
    }), e.languages.insertBefore(
      "inside",
      "punctuation",
      {
        expression: n.expression,
        keyword: n.keyword,
        variable: n.variable,
        function: n.function,
        escape: n.escape,
        "parser-punctuation": {
          pattern: n.punctuation,
          alias: "punctuation"
        }
      },
      n.tag.inside["attr-value"]
    );
  }(t);
}
j8.displayName = "pascal";
j8.aliases = ["objectpascal"];
function j8(t) {
  t.languages.pascal = {
    directive: {
      pattern: /\{\$[\s\S]*?\}/,
      greedy: !0,
      alias: ["marco", "property"]
    },
    comment: {
      pattern: /\(\*[\s\S]*?\*\)|\{[\s\S]*?\}|\/\/.*/,
      greedy: !0
    },
    string: {
      pattern: /(?:'(?:''|[^'\r\n])*'(?!')|#[&$%]?[a-f\d]+)+|\^[a-z]/i,
      greedy: !0
    },
    asm: {
      pattern: /(\basm\b)[\s\S]+?(?=\bend\s*[;[])/i,
      lookbehind: !0,
      greedy: !0,
      inside: null
      // see below
    },
    keyword: [
      {
        // Turbo Pascal
        pattern: /(^|[^&])\b(?:absolute|array|asm|begin|case|const|constructor|destructor|do|downto|else|end|file|for|function|goto|if|implementation|inherited|inline|interface|label|nil|object|of|operator|packed|procedure|program|record|reintroduce|repeat|self|set|string|then|to|type|unit|until|uses|var|while|with)\b/i,
        lookbehind: !0
      },
      {
        // Free Pascal
        pattern: /(^|[^&])\b(?:dispose|exit|false|new|true)\b/i,
        lookbehind: !0
      },
      {
        // Object Pascal
        pattern: /(^|[^&])\b(?:class|dispinterface|except|exports|finalization|finally|initialization|inline|library|on|out|packed|property|raise|resourcestring|threadvar|try)\b/i,
        lookbehind: !0
      },
      {
        // Modifiers
        pattern: /(^|[^&])\b(?:absolute|abstract|alias|assembler|bitpacked|break|cdecl|continue|cppdecl|cvar|default|deprecated|dynamic|enumerator|experimental|export|external|far|far16|forward|generic|helper|implements|index|interrupt|iochecks|local|message|name|near|nodefault|noreturn|nostackframe|oldfpccall|otherwise|overload|override|pascal|platform|private|protected|public|published|read|register|reintroduce|result|safecall|saveregisters|softfloat|specialize|static|stdcall|stored|strict|unaligned|unimplemented|varargs|virtual|write)\b/i,
        lookbehind: !0
      }
    ],
    number: [
      // Hexadecimal, octal and binary
      /(?:[&%]\d+|\$[a-f\d]+)/i,
      // Decimal
      /\b\d+(?:\.\d+)?(?:e[+-]?\d+)?/i
    ],
    operator: [
      /\.\.|\*\*|:=|<[<=>]?|>[>=]?|[+\-*\/]=?|[@^=]/,
      {
        pattern: /(^|[^&])\b(?:and|as|div|exclude|in|include|is|mod|not|or|shl|shr|xor)\b/,
        lookbehind: !0
      }
    ],
    punctuation: /\(\.|\.\)|[()\[\]:;,.]/
  }, t.languages.pascal.asm.inside = t.languages.extend("pascal", {
    asm: void 0,
    keyword: void 0,
    operator: void 0
  }), t.languages.objectpascal = t.languages.pascal;
}
G8.displayName = "pascaligo";
G8.aliases = [];
function G8(t) {
  (function(e) {
    var n = /\((?:[^()]|\((?:[^()]|\([^()]*\))*\))*\)/.source, r = /(?:\b\w+(?:<braces>)?|<braces>)/.source.replace(
      /<braces>/g,
      function() {
        return n;
      }
    ), a = e.languages.pascaligo = {
      comment: /\(\*[\s\S]+?\*\)|\/\/.*/,
      string: {
        pattern: /(["'`])(?:\\[\s\S]|(?!\1)[^\\])*\1|\^[a-z]/i,
        greedy: !0
      },
      "class-name": [
        {
          pattern: RegExp(
            /(\btype\s+\w+\s+is\s+)<type>/.source.replace(
              /<type>/g,
              function() {
                return r;
              }
            ),
            "i"
          ),
          lookbehind: !0,
          inside: null
          // see below
        },
        {
          pattern: RegExp(
            /<type>(?=\s+is\b)/.source.replace(/<type>/g, function() {
              return r;
            }),
            "i"
          ),
          inside: null
          // see below
        },
        {
          pattern: RegExp(
            /(:\s*)<type>/.source.replace(/<type>/g, function() {
              return r;
            })
          ),
          lookbehind: !0,
          inside: null
          // see below
        }
      ],
      keyword: {
        pattern: /(^|[^&])\b(?:begin|block|case|const|else|end|fail|for|from|function|if|is|nil|of|remove|return|skip|then|type|var|while|with)\b/i,
        lookbehind: !0
      },
      boolean: {
        pattern: /(^|[^&])\b(?:False|True)\b/i,
        lookbehind: !0
      },
      builtin: {
        pattern: /(^|[^&])\b(?:bool|int|list|map|nat|record|string|unit)\b/i,
        lookbehind: !0
      },
      function: /\b\w+(?=\s*\()/,
      number: [
        // Hexadecimal, octal and binary
        /%[01]+|&[0-7]+|\$[a-f\d]+/i,
        // Decimal
        /\b\d+(?:\.\d+)?(?:e[+-]?\d+)?(?:mtz|n)?/i
      ],
      operator: /->|=\/=|\.\.|\*\*|:=|<[<=>]?|>[>=]?|[+\-*\/]=?|[@^=|]|\b(?:and|mod|or)\b/,
      punctuation: /\(\.|\.\)|[()\[\]:;,.{}]/
    }, i = [
      "comment",
      "keyword",
      "builtin",
      "operator",
      "punctuation"
    ].reduce(function(o, s) {
      return o[s] = a[s], o;
    }, {});
    a["class-name"].forEach(function(o) {
      o.inside = i;
    });
  })(t);
}
V8.displayName = "psl";
V8.aliases = [];
function V8(t) {
  t.languages.psl = {
    comment: {
      pattern: /#.*/,
      greedy: !0
    },
    string: {
      pattern: /"(?:\\.|[^\\"])*"/,
      greedy: !0,
      inside: {
        symbol: /\\[ntrbA-Z"\\]/
      }
    },
    "heredoc-string": {
      pattern: /<<<([a-zA-Z_]\w*)[\r\n](?:.*[\r\n])*?\1\b/,
      alias: "string",
      greedy: !0
    },
    keyword: /\b(?:__multi|__single|case|default|do|else|elsif|exit|export|for|foreach|function|if|last|line|local|next|requires|return|switch|until|while|word)\b/,
    constant: /\b(?:ALARM|CHART_ADD_GRAPH|CHART_DELETE_GRAPH|CHART_DESTROY|CHART_LOAD|CHART_PRINT|EOF|OFFLINE|OK|PSL_PROF_LOG|R_CHECK_HORIZ|R_CHECK_VERT|R_CLICKER|R_COLUMN|R_FRAME|R_ICON|R_LABEL|R_LABEL_CENTER|R_LIST_MULTIPLE|R_LIST_MULTIPLE_ND|R_LIST_SINGLE|R_LIST_SINGLE_ND|R_MENU|R_POPUP|R_POPUP_SCROLLED|R_RADIO_HORIZ|R_RADIO_VERT|R_ROW|R_SCALE_HORIZ|R_SCALE_VERT|R_SEP_HORIZ|R_SEP_VERT|R_SPINNER|R_TEXT_FIELD|R_TEXT_FIELD_LABEL|R_TOGGLE|TRIM_LEADING|TRIM_LEADING_AND_TRAILING|TRIM_REDUNDANT|TRIM_TRAILING|VOID|WARN)\b/,
    boolean: /\b(?:FALSE|False|NO|No|TRUE|True|YES|Yes|false|no|true|yes)\b/,
    variable: /\b(?:PslDebug|errno|exit_status)\b/,
    builtin: {
      pattern: /\b(?:PslExecute|PslFunctionCall|PslFunctionExists|PslSetOptions|_snmp_debug|acos|add_diary|annotate|annotate_get|ascii_to_ebcdic|asctime|asin|atan|atexit|batch_set|blackout|cat|ceil|chan_exists|change_state|close|code_cvt|cond_signal|cond_wait|console_type|convert_base|convert_date|convert_locale_date|cos|cosh|create|date|dcget_text|destroy|destroy_lock|dget_text|difference|dump_hist|ebcdic_to_ascii|encrypt|event_archive|event_catalog_get|event_check|event_query|event_range_manage|event_range_query|event_report|event_schedule|event_trigger|event_trigger2|execute|exists|exp|fabs|file|floor|fmod|fopen|fseek|ftell|full_discovery|get|get_chan_info|get_ranges|get_text|get_vars|getenv|gethostinfo|getpid|getpname|grep|history|history_get_retention|in_transition|index|int|internal|intersection|is_var|isnumber|join|kill|length|lines|lock|lock_info|log|log10|loge|matchline|msg_check|msg_get_format|msg_get_severity|msg_printf|msg_sprintf|ntharg|nthargf|nthline|nthlinef|num_bytes|num_consoles|pconfig|popen|poplines|pow|print|printf|proc_exists|process|random|read|readln|refresh_parameters|remote_check|remote_close|remote_event_query|remote_event_trigger|remote_file_send|remote_open|remove|replace|rindex|sec_check_priv|sec_store_get|sec_store_set|set|set_alarm_ranges|set_locale|share|sin|sinh|sleep|snmp_agent_config|snmp_agent_start|snmp_agent_stop|snmp_close|snmp_config|snmp_get|snmp_get_next|snmp_h_get|snmp_h_get_next|snmp_h_set|snmp_open|snmp_set|snmp_trap_ignore|snmp_trap_listen|snmp_trap_raise_std_trap|snmp_trap_receive|snmp_trap_register_im|snmp_trap_send|snmp_walk|sopen|sort|splitline|sprintf|sqrt|srandom|str_repeat|strcasecmp|subset|substr|system|tail|tan|tanh|text_domain|time|tmpnam|tolower|toupper|trace_psl_process|trim|union|unique|unlock|unset|va_arg|va_start|write)\b/,
      alias: "builtin-function"
    },
    "foreach-variable": {
      pattern: /(\bforeach\s+(?:(?:\w+\b|"(?:\\.|[^\\"])*")\s+){0,2})[_a-zA-Z]\w*(?=\s*\()/,
      lookbehind: !0,
      greedy: !0
    },
    function: /\b[_a-z]\w*\b(?=\s*\()/i,
    number: /\b(?:0x[0-9a-f]+|\d+(?:\.\d+)?)\b/i,
    operator: /--|\+\+|&&=?|\|\|=?|<<=?|>>=?|[=!]~|[-+*/%&|^!=<>]=?|\.|[:?]/,
    punctuation: /[(){}\[\];,]/
  };
}
Y8.displayName = "pcaxis";
Y8.aliases = ["px"];
function Y8(t) {
  t.languages.pcaxis = {
    string: /"[^"]*"/,
    keyword: {
      pattern: /((?:^|;)\s*)[-A-Z\d]+(?:\s*\[[-\w]+\])?(?:\s*\("[^"]*"(?:,\s*"[^"]*")*\))?(?=\s*=)/,
      lookbehind: !0,
      greedy: !0,
      inside: {
        keyword: /^[-A-Z\d]+/,
        language: {
          pattern: /^(\s*)\[[-\w]+\]/,
          lookbehind: !0,
          inside: {
            punctuation: /^\[|\]$/,
            property: /[-\w]+/
          }
        },
        "sub-key": {
          pattern: /^(\s*)\S[\s\S]*/,
          lookbehind: !0,
          inside: {
            parameter: {
              pattern: /"[^"]*"/,
              alias: "property"
            },
            punctuation: /^\(|\)$|,/
          }
        }
      }
    },
    operator: /=/,
    tlist: {
      pattern: /TLIST\s*\(\s*\w+(?:(?:\s*,\s*"[^"]*")+|\s*,\s*"[^"]*"-"[^"]*")?\s*\)/,
      greedy: !0,
      inside: {
        function: /^TLIST/,
        property: {
          pattern: /^(\s*\(\s*)\w+/,
          lookbehind: !0
        },
        string: /"[^"]*"/,
        punctuation: /[(),]/,
        operator: /-/
      }
    },
    punctuation: /[;,]/,
    number: {
      pattern: /(^|\s)\d+(?:\.\d+)?(?!\S)/,
      lookbehind: !0
    },
    boolean: /NO|YES/
  }, t.languages.px = t.languages.pcaxis;
}
Z8.displayName = "peoplecode";
Z8.aliases = ["pcode"];
function Z8(t) {
  t.languages.peoplecode = {
    comment: RegExp(
      [
        // C-style multiline comments
        /\/\*[\s\S]*?\*\//.source,
        // REM comments
        /\bREM[^;]*;/.source,
        // Nested <* *> comments
        /<\*(?:[^<*]|\*(?!>)|<(?!\*)|<\*(?:(?!\*>)[\s\S])*\*>)*\*>/.source,
        // /+ +/ comments
        /\/\+[\s\S]*?\+\//.source
      ].join("|")
    ),
    string: {
      pattern: /'(?:''|[^'\r\n])*'(?!')|"(?:""|[^"\r\n])*"(?!")/,
      greedy: !0
    },
    variable: /%\w+/,
    "function-definition": {
      pattern: /((?:^|[^\w-])(?:function|method)\s+)\w+/i,
      lookbehind: !0,
      alias: "function"
    },
    "class-name": {
      pattern: /((?:^|[^-\w])(?:as|catch|class|component|create|extends|global|implements|instance|local|of|property|returns)\s+)\w+(?::\w+)*/i,
      lookbehind: !0,
      inside: {
        punctuation: /:/
      }
    },
    keyword: /\b(?:abstract|alias|as|catch|class|component|constant|create|declare|else|end-(?:class|evaluate|for|function|get|if|method|set|try|while)|evaluate|extends|for|function|get|global|if|implements|import|instance|library|local|method|null|of|out|peopleCode|private|program|property|protected|readonly|ref|repeat|returns?|set|step|then|throw|to|try|until|value|when(?:-other)?|while)\b/i,
    "operator-keyword": {
      pattern: /\b(?:and|not|or)\b/i,
      alias: "operator"
    },
    function: /[_a-z]\w*(?=\s*\()/i,
    boolean: /\b(?:false|true)\b/i,
    number: /\b\d+(?:\.\d+)?\b/,
    operator: /<>|[<>]=?|!=|\*\*|[-+*/|=@]/,
    punctuation: /[:.;,()[\]]/
  }, t.languages.pcode = t.languages.peoplecode;
}
X8.displayName = "phpdoc";
X8.aliases = [];
function X8(t) {
  t.register(w1), t.register(R0), function(e) {
    var n = /(?:\b[a-zA-Z]\w*|[|\\[\]])+/.source;
    e.languages.phpdoc = e.languages.extend("javadoclike", {
      parameter: {
        pattern: RegExp(
          "(@(?:global|param|property(?:-read|-write)?|var)\\s+(?:" + n + "\\s+)?)\\$\\w+"
        ),
        lookbehind: !0
      }
    }), e.languages.insertBefore("phpdoc", "keyword", {
      "class-name": [
        {
          pattern: RegExp(
            "(@(?:global|package|param|property(?:-read|-write)?|return|subpackage|throws|var)\\s+)" + n
          ),
          lookbehind: !0,
          inside: {
            keyword: /\b(?:array|bool|boolean|callback|double|false|float|int|integer|mixed|null|object|resource|self|string|true|void)\b/,
            punctuation: /[|\\[\]()]/
          }
        }
      ]
    }), e.languages.javadoclike.addSupport("php", e.languages.phpdoc);
  }(t);
}
q8.displayName = "php-extras";
q8.aliases = [];
function q8(t) {
  t.register(R0), t.languages.insertBefore("php", "variable", {
    this: {
      pattern: /\$this\b/,
      alias: "keyword"
    },
    global: /\$(?:GLOBALS|HTTP_RAW_POST_DATA|_(?:COOKIE|ENV|FILES|GET|POST|REQUEST|SERVER|SESSION)|argc|argv|http_response_header|php_errormsg)\b/,
    scope: {
      pattern: /\b[\w\\]+::/,
      inside: {
        keyword: /\b(?:parent|self|static)\b/,
        punctuation: /::|\\/
      }
    }
  });
}
K8.displayName = "plant-uml";
K8.aliases = ["plantuml"];
function K8(t) {
  (function(e) {
    var n = /\$\w+|%[a-z]+%/, r = /\[[^[\]]*\]/.source, a = /(?:[drlu]|do|down|le|left|ri|right|up)/.source, i = "(?:-+" + a + "-+|\\.+" + a + "\\.+|-+(?:" + r + "-*)?|" + r + "-+|\\.+(?:" + r + "\\.*)?|" + r + "\\.+)", o = /(?:<{1,2}|\/{1,2}|\\{1,2}|<\||[#*^+}xo])/.source, s = /(?:>{1,2}|\/{1,2}|\\{1,2}|\|>|[#*^+{xo])/.source, u = /[[?]?[ox]?/.source, f = /[ox]?[\]?]?/.source, p = u + "(?:" + i + s + "|" + o + i + "(?:" + s + ")?)" + f;
    e.languages["plant-uml"] = {
      comment: {
        pattern: /(^[ \t]*)(?:'.*|\/'[\s\S]*?'\/)/m,
        lookbehind: !0,
        greedy: !0
      },
      preprocessor: {
        pattern: /(^[ \t]*)!.*/m,
        lookbehind: !0,
        greedy: !0,
        alias: "property",
        inside: {
          variable: n
        }
      },
      delimiter: {
        pattern: /(^[ \t]*)@(?:end|start)uml\b/m,
        lookbehind: !0,
        greedy: !0,
        alias: "punctuation"
      },
      arrow: {
        pattern: RegExp(
          /(^|[^-.<>?|\\[\]ox])/.source + p + /(?![-.<>?|\\\]ox])/.source
        ),
        lookbehind: !0,
        greedy: !0,
        alias: "operator",
        inside: {
          expression: {
            pattern: /(\[)[^[\]]+(?=\])/,
            lookbehind: !0,
            inside: null
            // see below
          },
          punctuation: /\[(?=$|\])|^\]/
        }
      },
      string: {
        pattern: /"[^"]*"/,
        greedy: !0
      },
      text: {
        pattern: /(\[[ \t]*[\r\n]+(?![\r\n]))[^\]]*(?=\])/,
        lookbehind: !0,
        greedy: !0,
        alias: "string"
      },
      keyword: [
        {
          pattern: /^([ \t]*)(?:abstract\s+class|end\s+(?:box|fork|group|merge|note|ref|split|title)|(?:fork|split)(?:\s+again)?|activate|actor|agent|alt|annotation|artifact|autoactivate|autonumber|backward|binary|boundary|box|break|caption|card|case|circle|class|clock|cloud|collections|component|concise|control|create|critical|database|deactivate|destroy|detach|diamond|else|elseif|end|end[hr]note|endif|endswitch|endwhile|entity|enum|file|folder|footer|frame|group|[hr]?note|header|hexagon|hide|if|interface|label|legend|loop|map|namespace|network|newpage|node|nwdiag|object|opt|package|page|par|participant|person|queue|rectangle|ref|remove|repeat|restore|return|robust|scale|set|show|skinparam|stack|start|state|stop|storage|switch|title|together|usecase|usecase\/|while)(?=\s|$)/m,
          lookbehind: !0,
          greedy: !0
        },
        /\b(?:elseif|equals|not|while)(?=\s*\()/,
        /\b(?:as|is|then)\b/
      ],
      divider: {
        pattern: /^==.+==$/m,
        greedy: !0,
        alias: "important"
      },
      time: {
        pattern: /@(?:\d+(?:[:/]\d+){2}|[+-]?\d+|:[a-z]\w*(?:[+-]\d+)?)\b/i,
        greedy: !0,
        alias: "number"
      },
      color: {
        pattern: /#(?:[a-z_]+|[a-fA-F0-9]+)\b/,
        alias: "symbol"
      },
      variable: n,
      punctuation: /[:,;()[\]{}]|\.{3}/
    }, e.languages["plant-uml"].arrow.inside.expression.inside = e.languages["plant-uml"], e.languages.plantuml = e.languages["plant-uml"];
  })(t);
}
J8.displayName = "plsql";
J8.aliases = [];
function J8(t) {
  t.register(v1), t.languages.plsql = t.languages.extend("sql", {
    comment: {
      pattern: /\/\*[\s\S]*?\*\/|--.*/,
      greedy: !0
    },
    // https://docs.oracle.com/en/database/oracle/oracle-database/21/lnpls/plsql-reserved-words-keywords.html
    keyword: /\b(?:A|ACCESSIBLE|ADD|AGENT|AGGREGATE|ALL|ALTER|AND|ANY|ARRAY|AS|ASC|AT|ATTRIBUTE|AUTHID|AVG|BEGIN|BETWEEN|BFILE_BASE|BINARY|BLOB_BASE|BLOCK|BODY|BOTH|BOUND|BULK|BY|BYTE|C|CALL|CALLING|CASCADE|CASE|CHAR|CHARACTER|CHARSET|CHARSETFORM|CHARSETID|CHAR_BASE|CHECK|CLOB_BASE|CLONE|CLOSE|CLUSTER|CLUSTERS|COLAUTH|COLLECT|COLUMNS|COMMENT|COMMIT|COMMITTED|COMPILED|COMPRESS|CONNECT|CONSTANT|CONSTRUCTOR|CONTEXT|CONTINUE|CONVERT|COUNT|CRASH|CREATE|CREDENTIAL|CURRENT|CURSOR|CUSTOMDATUM|DANGLING|DATA|DATE|DATE_BASE|DAY|DECLARE|DEFAULT|DEFINE|DELETE|DESC|DETERMINISTIC|DIRECTORY|DISTINCT|DOUBLE|DROP|DURATION|ELEMENT|ELSE|ELSIF|EMPTY|END|ESCAPE|EXCEPT|EXCEPTION|EXCEPTIONS|EXCLUSIVE|EXECUTE|EXISTS|EXIT|EXTERNAL|FETCH|FINAL|FIRST|FIXED|FLOAT|FOR|FORALL|FORCE|FROM|FUNCTION|GENERAL|GOTO|GRANT|GROUP|HASH|HAVING|HEAP|HIDDEN|HOUR|IDENTIFIED|IF|IMMEDIATE|IMMUTABLE|IN|INCLUDING|INDEX|INDEXES|INDICATOR|INDICES|INFINITE|INSERT|INSTANTIABLE|INT|INTERFACE|INTERSECT|INTERVAL|INTO|INVALIDATE|IS|ISOLATION|JAVA|LANGUAGE|LARGE|LEADING|LENGTH|LEVEL|LIBRARY|LIKE|LIKE2|LIKE4|LIKEC|LIMIT|LIMITED|LOCAL|LOCK|LONG|LOOP|MAP|MAX|MAXLEN|MEMBER|MERGE|MIN|MINUS|MINUTE|MOD|MODE|MODIFY|MONTH|MULTISET|MUTABLE|NAME|NAN|NATIONAL|NATIVE|NCHAR|NEW|NOCOMPRESS|NOCOPY|NOT|NOWAIT|NULL|NUMBER_BASE|OBJECT|OCICOLL|OCIDATE|OCIDATETIME|OCIDURATION|OCIINTERVAL|OCILOBLOCATOR|OCINUMBER|OCIRAW|OCIREF|OCIREFCURSOR|OCIROWID|OCISTRING|OCITYPE|OF|OLD|ON|ONLY|OPAQUE|OPEN|OPERATOR|OPTION|OR|ORACLE|ORADATA|ORDER|ORGANIZATION|ORLANY|ORLVARY|OTHERS|OUT|OVERLAPS|OVERRIDING|PACKAGE|PARALLEL_ENABLE|PARAMETER|PARAMETERS|PARENT|PARTITION|PASCAL|PERSISTABLE|PIPE|PIPELINED|PLUGGABLE|POLYMORPHIC|PRAGMA|PRECISION|PRIOR|PRIVATE|PROCEDURE|PUBLIC|RAISE|RANGE|RAW|READ|RECORD|REF|REFERENCE|RELIES_ON|REM|REMAINDER|RENAME|RESOURCE|RESULT|RESULT_CACHE|RETURN|RETURNING|REVERSE|REVOKE|ROLLBACK|ROW|SAMPLE|SAVE|SAVEPOINT|SB1|SB2|SB4|SECOND|SEGMENT|SELECT|SELF|SEPARATE|SEQUENCE|SERIALIZABLE|SET|SHARE|SHORT|SIZE|SIZE_T|SOME|SPARSE|SQL|SQLCODE|SQLDATA|SQLNAME|SQLSTATE|STANDARD|START|STATIC|STDDEV|STORED|STRING|STRUCT|STYLE|SUBMULTISET|SUBPARTITION|SUBSTITUTABLE|SUBTYPE|SUM|SYNONYM|TABAUTH|TABLE|TDO|THE|THEN|TIME|TIMESTAMP|TIMEZONE_ABBR|TIMEZONE_HOUR|TIMEZONE_MINUTE|TIMEZONE_REGION|TO|TRAILING|TRANSACTION|TRANSACTIONAL|TRUSTED|TYPE|UB1|UB2|UB4|UNDER|UNION|UNIQUE|UNPLUG|UNSIGNED|UNTRUSTED|UPDATE|USE|USING|VALIST|VALUE|VALUES|VARIABLE|VARIANCE|VARRAY|VARYING|VIEW|VIEWS|VOID|WHEN|WHERE|WHILE|WITH|WORK|WRAPPED|WRITE|YEAR|ZONE)\b/i,
    // https://docs.oracle.com/en/database/oracle/oracle-database/21/lnpls/plsql-language-fundamentals.html#GUID-96A42F7C-7A71-4B90-8255-CA9C8BD9722E
    operator: /:=?|=>|[<>^~!]=|\.\.|\|\||\*\*|[-+*/%<>=@]/
  }), t.languages.insertBefore("plsql", "operator", {
    label: {
      pattern: /<<\s*\w+\s*>>/,
      alias: "symbol"
    }
  });
}
eH.displayName = "powerquery";
eH.aliases = ["mscript", "pq"];
function eH(t) {
  t.languages.powerquery = {
    comment: {
      pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
      lookbehind: !0,
      greedy: !0
    },
    "quoted-identifier": {
      pattern: /#"(?:[^"\r\n]|"")*"(?!")/,
      greedy: !0
    },
    string: {
      pattern: /(?:#!)?"(?:[^"\r\n]|"")*"(?!")/,
      greedy: !0
    },
    constant: [
      /\bDay\.(?:Friday|Monday|Saturday|Sunday|Thursday|Tuesday|Wednesday)\b/,
      /\bTraceLevel\.(?:Critical|Error|Information|Verbose|Warning)\b/,
      /\bOccurrence\.(?:All|First|Last)\b/,
      /\bOrder\.(?:Ascending|Descending)\b/,
      /\bRoundingMode\.(?:AwayFromZero|Down|ToEven|TowardZero|Up)\b/,
      /\bMissingField\.(?:Error|Ignore|UseNull)\b/,
      /\bQuoteStyle\.(?:Csv|None)\b/,
      /\bJoinKind\.(?:FullOuter|Inner|LeftAnti|LeftOuter|RightAnti|RightOuter)\b/,
      /\bGroupKind\.(?:Global|Local)\b/,
      /\bExtraValues\.(?:Error|Ignore|List)\b/,
      /\bJoinAlgorithm\.(?:Dynamic|LeftHash|LeftIndex|PairwiseHash|RightHash|RightIndex|SortMerge)\b/,
      /\bJoinSide\.(?:Left|Right)\b/,
      /\bPrecision\.(?:Decimal|Double)\b/,
      /\bRelativePosition\.From(?:End|Start)\b/,
      /\bTextEncoding\.(?:Ascii|BigEndianUnicode|Unicode|Utf16|Utf8|Windows)\b/,
      /\b(?:Any|Binary|Date|DateTime|DateTimeZone|Duration|Function|Int16|Int32|Int64|Int8|List|Logical|None|Number|Record|Table|Text|Time)\.Type\b/,
      /\bnull\b/
    ],
    boolean: /\b(?:false|true)\b/,
    keyword: /\b(?:and|as|each|else|error|if|in|is|let|meta|not|nullable|optional|or|otherwise|section|shared|then|try|type)\b|#(?:binary|date|datetime|datetimezone|duration|infinity|nan|sections|shared|table|time)\b/,
    function: {
      pattern: /(^|[^#\w.])[a-z_][\w.]*(?=\s*\()/i,
      lookbehind: !0
    },
    "data-type": {
      pattern: /\b(?:any|anynonnull|binary|date|datetime|datetimezone|duration|function|list|logical|none|number|record|table|text|time)\b/,
      alias: "class-name"
    },
    number: {
      pattern: /\b0x[\da-f]+\b|(?:[+-]?(?:\b\d+\.)?\b\d+|[+-]\.\d+|(^|[^.])\B\.\d+)(?:e[+-]?\d+)?\b/i,
      lookbehind: !0
    },
    operator: /[-+*\/&?@^]|<(?:=>?|>)?|>=?|=>?|\.\.\.?/,
    punctuation: /[,;\[\](){}]/
  }, t.languages.pq = t.languages.powerquery, t.languages.mscript = t.languages.powerquery;
}
tH.displayName = "powershell";
tH.aliases = [];
function tH(t) {
  (function(e) {
    var n = e.languages.powershell = {
      comment: [
        {
          pattern: /(^|[^`])<#[\s\S]*?#>/,
          lookbehind: !0
        },
        {
          pattern: /(^|[^`])#.*/,
          lookbehind: !0
        }
      ],
      string: [
        {
          pattern: /"(?:`[\s\S]|[^`"])*"/,
          greedy: !0,
          inside: null
          // see below
        },
        {
          pattern: /'(?:[^']|'')*'/,
          greedy: !0
        }
      ],
      // Matches name spaces as well as casts, attribute decorators. Force starting with letter to avoid matching array indices
      // Supports two levels of nested brackets (e.g. `[OutputType([System.Collections.Generic.List[int]])]`)
      namespace: /\[[a-z](?:\[(?:\[[^\]]*\]|[^\[\]])*\]|[^\[\]])*\]/i,
      boolean: /\$(?:false|true)\b/i,
      variable: /\$\w+\b/,
      // Cmdlets and aliases. Aliases should come last, otherwise "write" gets preferred over "write-host" for example
      // Get-Command | ?{ $_.ModuleName -match "Microsoft.PowerShell.(Util|Core|Management)" }
      // Get-Alias | ?{ $_.ReferencedCommand.Module.Name -match "Microsoft.PowerShell.(Util|Core|Management)" }
      function: [
        /\b(?:Add|Approve|Assert|Backup|Block|Checkpoint|Clear|Close|Compare|Complete|Compress|Confirm|Connect|Convert|ConvertFrom|ConvertTo|Copy|Debug|Deny|Disable|Disconnect|Dismount|Edit|Enable|Enter|Exit|Expand|Export|Find|ForEach|Format|Get|Grant|Group|Hide|Import|Initialize|Install|Invoke|Join|Limit|Lock|Measure|Merge|Move|New|Open|Optimize|Out|Ping|Pop|Protect|Publish|Push|Read|Receive|Redo|Register|Remove|Rename|Repair|Request|Reset|Resize|Resolve|Restart|Restore|Resume|Revoke|Save|Search|Select|Send|Set|Show|Skip|Sort|Split|Start|Step|Stop|Submit|Suspend|Switch|Sync|Tee|Test|Trace|Unblock|Undo|Uninstall|Unlock|Unprotect|Unpublish|Unregister|Update|Use|Wait|Watch|Where|Write)-[a-z]+\b/i,
        /\b(?:ac|cat|chdir|clc|cli|clp|clv|compare|copy|cp|cpi|cpp|cvpa|dbp|del|diff|dir|ebp|echo|epal|epcsv|epsn|erase|fc|fl|ft|fw|gal|gbp|gc|gci|gcs|gdr|gi|gl|gm|gp|gps|group|gsv|gu|gv|gwmi|iex|ii|ipal|ipcsv|ipsn|irm|iwmi|iwr|kill|lp|ls|measure|mi|mount|move|mp|mv|nal|ndr|ni|nv|ogv|popd|ps|pushd|pwd|rbp|rd|rdr|ren|ri|rm|rmdir|rni|rnp|rp|rv|rvpa|rwmi|sal|saps|sasv|sbp|sc|select|set|shcm|si|sl|sleep|sls|sort|sp|spps|spsv|start|sv|swmi|tee|trcm|type|write)\b/i
      ],
      // per http://technet.microsoft.com/en-us/library/hh847744.aspx
      keyword: /\b(?:Begin|Break|Catch|Class|Continue|Data|Define|Do|DynamicParam|Else|ElseIf|End|Exit|Filter|Finally|For|ForEach|From|Function|If|InlineScript|Parallel|Param|Process|Return|Sequence|Switch|Throw|Trap|Try|Until|Using|Var|While|Workflow)\b/i,
      operator: {
        pattern: /(^|\W)(?:!|-(?:b?(?:and|x?or)|as|(?:Not)?(?:Contains|In|Like|Match)|eq|ge|gt|is(?:Not)?|Join|le|lt|ne|not|Replace|sh[lr])\b|-[-=]?|\+[+=]?|[*\/%]=?)/i,
        lookbehind: !0
      },
      punctuation: /[|{}[\];(),.]/
    };
    n.string[0].inside = {
      function: {
        // Allow for one level of nesting
        pattern: /(^|[^`])\$\((?:\$\([^\r\n()]*\)|(?!\$\()[^\r\n)])*\)/,
        lookbehind: !0,
        inside: n
      },
      boolean: n.boolean,
      variable: n.variable
    };
  })(t);
}
nH.displayName = "processing";
nH.aliases = [];
function nH(t) {
  t.register(Lr), t.languages.processing = t.languages.extend("clike", {
    keyword: /\b(?:break|case|catch|class|continue|default|else|extends|final|for|if|implements|import|new|null|private|public|return|static|super|switch|this|try|void|while)\b/,
    // Spaces are allowed between function name and parenthesis
    function: /\b\w+(?=\s*\()/,
    operator: /<[<=]?|>[>=]?|&&?|\|\|?|[%?]|[!=+\-*\/]=?/
  }), t.languages.insertBefore("processing", "number", {
    // Special case: XML is a type
    constant: /\b(?!XML\b)[A-Z][A-Z\d_]+\b/,
    type: {
      pattern: /\b(?:boolean|byte|char|color|double|float|int|[A-Z]\w*)\b/,
      alias: "class-name"
    }
  });
}
rH.displayName = "prolog";
rH.aliases = [];
function rH(t) {
  t.languages.prolog = {
    // Syntax depends on the implementation
    comment: {
      pattern: /\/\*[\s\S]*?\*\/|%.*/,
      greedy: !0
    },
    // Depending on the implementation, strings may allow escaped newlines and quote-escape
    string: {
      pattern: /(["'])(?:\1\1|\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1(?!\1)/,
      greedy: !0
    },
    builtin: /\b(?:fx|fy|xf[xy]?|yfx?)\b/,
    // FIXME: Should we list all null-ary predicates (not followed by a parenthesis) like halt, trace, etc.?
    function: /\b[a-z]\w*(?:(?=\()|\/\d+)/,
    number: /\b\d+(?:\.\d*)?/,
    // Custom operators are allowed
    operator: /[:\\=><\-?*@\/;+^|!$.]+|\b(?:is|mod|not|xor)\b/,
    punctuation: /[(){}\[\],]/
  };
}
aH.displayName = "promql";
aH.aliases = [];
function aH(t) {
  (function(e) {
    var n = [
      "sum",
      "min",
      "max",
      "avg",
      "group",
      "stddev",
      "stdvar",
      "count",
      "count_values",
      "bottomk",
      "topk",
      "quantile"
    ], r = [
      "on",
      "ignoring",
      "group_right",
      "group_left",
      "by",
      "without"
    ], a = ["offset"], i = n.concat(r, a);
    e.languages.promql = {
      comment: {
        pattern: /(^[ \t]*)#.*/m,
        lookbehind: !0
      },
      "vector-match": {
        // Match the comma-separated label lists inside vector matching:
        pattern: new RegExp(
          "((?:" + r.join("|") + ")\\s*)\\([^)]*\\)"
        ),
        lookbehind: !0,
        inside: {
          "label-key": {
            pattern: /\b[^,]+\b/,
            alias: "attr-name"
          },
          punctuation: /[(),]/
        }
      },
      "context-labels": {
        pattern: /\{[^{}]*\}/,
        inside: {
          "label-key": {
            pattern: /\b[a-z_]\w*(?=\s*(?:=|![=~]))/,
            alias: "attr-name"
          },
          "label-value": {
            pattern: /(["'`])(?:\\[\s\S]|(?!\1)[^\\])*\1/,
            greedy: !0,
            alias: "attr-value"
          },
          punctuation: /\{|\}|=~?|![=~]|,/
        }
      },
      "context-range": [
        {
          pattern: /\[[\w\s:]+\]/,
          // [1m]
          inside: {
            punctuation: /\[|\]|:/,
            "range-duration": {
              pattern: /\b(?:\d+(?:[smhdwy]|ms))+\b/i,
              alias: "number"
            }
          }
        },
        {
          pattern: /(\boffset\s+)\w+/,
          // offset 1m
          lookbehind: !0,
          inside: {
            "range-duration": {
              pattern: /\b(?:\d+(?:[smhdwy]|ms))+\b/i,
              alias: "number"
            }
          }
        }
      ],
      keyword: new RegExp("\\b(?:" + i.join("|") + ")\\b", "i"),
      function: /\b[a-z_]\w*(?=\s*\()/i,
      number: /[-+]?(?:(?:\b\d+(?:\.\d+)?|\B\.\d+)(?:e[-+]?\d+)?\b|\b(?:0x[0-9a-f]+|nan|inf)\b)/i,
      operator: /[\^*/%+-]|==|!=|<=|<|>=|>|\b(?:and|or|unless)\b/i,
      punctuation: /[{};()`,.[\]]/
    };
  })(t);
}
iH.displayName = "properties";
iH.aliases = [];
function iH(t) {
  t.languages.properties = {
    comment: /^[ \t]*[#!].*$/m,
    value: {
      pattern: /(^[ \t]*(?:\\(?:\r\n|[\s\S])|[^\\\s:=])+(?: *[=:] *(?! )| ))(?:\\(?:\r\n|[\s\S])|[^\\\r\n])+/m,
      lookbehind: !0,
      alias: "attr-value"
    },
    key: {
      pattern: /^[ \t]*(?:\\(?:\r\n|[\s\S])|[^\\\s:=])+(?= *[=:]| )/m,
      alias: "attr-name"
    },
    punctuation: /[=:]/
  };
}
oH.displayName = "protobuf";
oH.aliases = [];
function oH(t) {
  t.register(Lr), function(e) {
    var n = /\b(?:bool|bytes|double|s?fixed(?:32|64)|float|[su]?int(?:32|64)|string)\b/;
    e.languages.protobuf = e.languages.extend("clike", {
      "class-name": [
        {
          pattern: /(\b(?:enum|extend|message|service)\s+)[A-Za-z_]\w*(?=\s*\{)/,
          lookbehind: !0
        },
        {
          pattern: /(\b(?:rpc\s+\w+|returns)\s*\(\s*(?:stream\s+)?)\.?[A-Za-z_]\w*(?:\.[A-Za-z_]\w*)*(?=\s*\))/,
          lookbehind: !0
        }
      ],
      keyword: /\b(?:enum|extend|extensions|import|message|oneof|option|optional|package|public|repeated|required|reserved|returns|rpc(?=\s+\w)|service|stream|syntax|to)\b(?!\s*=\s*\d)/,
      function: /\b[a-z_]\w*(?=\s*\()/i
    }), e.languages.insertBefore("protobuf", "operator", {
      map: {
        pattern: /\bmap<\s*[\w.]+\s*,\s*[\w.]+\s*>(?=\s+[a-z_]\w*\s*[=;])/i,
        alias: "class-name",
        inside: {
          punctuation: /[<>.,]/,
          builtin: n
        }
      },
      builtin: n,
      "positional-class-name": {
        pattern: /(?:\b|\B\.)[a-z_]\w*(?:\.[a-z_]\w*)*(?=\s+[a-z_]\w*\s*[=;])/i,
        alias: "class-name",
        inside: {
          punctuation: /\./
        }
      },
      annotation: {
        pattern: /(\[\s*)[a-z_]\w*(?=\s*=)/i,
        lookbehind: !0
      }
    });
  }(t);
}
sH.displayName = "stylus";
sH.aliases = [];
function sH(t) {
  (function(e) {
    var n = {
      pattern: /(\b\d+)(?:%|[a-z]+)/,
      lookbehind: !0
    }, r = {
      pattern: /(^|[^\w.-])-?(?:\d+(?:\.\d+)?|\.\d+)/,
      lookbehind: !0
    }, a = {
      comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
        lookbehind: !0
      },
      url: {
        pattern: /\burl\((["']?).*?\1\)/i,
        greedy: !0
      },
      string: {
        pattern: /("|')(?:(?!\1)[^\\\r\n]|\\(?:\r\n|[\s\S]))*\1/,
        greedy: !0
      },
      interpolation: null,
      // See below
      func: null,
      // See below
      important: /\B!(?:important|optional)\b/i,
      keyword: {
        pattern: /(^|\s+)(?:(?:else|for|if|return|unless)(?=\s|$)|@[\w-]+)/,
        lookbehind: !0
      },
      hexcode: /#[\da-f]{3,6}/i,
      color: [
        /\b(?:AliceBlue|AntiqueWhite|Aqua|Aquamarine|Azure|Beige|Bisque|Black|BlanchedAlmond|Blue|BlueViolet|Brown|BurlyWood|CadetBlue|Chartreuse|Chocolate|Coral|CornflowerBlue|Cornsilk|Crimson|Cyan|DarkBlue|DarkCyan|DarkGoldenRod|DarkGr[ae]y|DarkGreen|DarkKhaki|DarkMagenta|DarkOliveGreen|DarkOrange|DarkOrchid|DarkRed|DarkSalmon|DarkSeaGreen|DarkSlateBlue|DarkSlateGr[ae]y|DarkTurquoise|DarkViolet|DeepPink|DeepSkyBlue|DimGr[ae]y|DodgerBlue|FireBrick|FloralWhite|ForestGreen|Fuchsia|Gainsboro|GhostWhite|Gold|GoldenRod|Gr[ae]y|Green|GreenYellow|HoneyDew|HotPink|IndianRed|Indigo|Ivory|Khaki|Lavender|LavenderBlush|LawnGreen|LemonChiffon|LightBlue|LightCoral|LightCyan|LightGoldenRodYellow|LightGr[ae]y|LightGreen|LightPink|LightSalmon|LightSeaGreen|LightSkyBlue|LightSlateGr[ae]y|LightSteelBlue|LightYellow|Lime|LimeGreen|Linen|Magenta|Maroon|MediumAquaMarine|MediumBlue|MediumOrchid|MediumPurple|MediumSeaGreen|MediumSlateBlue|MediumSpringGreen|MediumTurquoise|MediumVioletRed|MidnightBlue|MintCream|MistyRose|Moccasin|NavajoWhite|Navy|OldLace|Olive|OliveDrab|Orange|OrangeRed|Orchid|PaleGoldenRod|PaleGreen|PaleTurquoise|PaleVioletRed|PapayaWhip|PeachPuff|Peru|Pink|Plum|PowderBlue|Purple|Red|RosyBrown|RoyalBlue|SaddleBrown|Salmon|SandyBrown|SeaGreen|SeaShell|Sienna|Silver|SkyBlue|SlateBlue|SlateGr[ae]y|Snow|SpringGreen|SteelBlue|Tan|Teal|Thistle|Tomato|Transparent|Turquoise|Violet|Wheat|White|WhiteSmoke|Yellow|YellowGreen)\b/i,
        {
          pattern: /\b(?:hsl|rgb)\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*\)\B|\b(?:hsl|rgb)a\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*,\s*(?:0|0?\.\d+|1)\s*\)\B/i,
          inside: {
            unit: n,
            number: r,
            function: /[\w-]+(?=\()/,
            punctuation: /[(),]/
          }
        }
      ],
      entity: /\\[\da-f]{1,8}/i,
      unit: n,
      boolean: /\b(?:false|true)\b/,
      operator: [
        // We want non-word chars around "-" because it is
        // accepted in property names.
        /~|[+!\/%<>?=]=?|[-:]=|\*[*=]?|\.{2,3}|&&|\|\||\B-\B|\b(?:and|in|is(?: a| defined| not|nt)?|not|or)\b/
      ],
      number: r,
      punctuation: /[{}()\[\];:,]/
    };
    a.interpolation = {
      pattern: /\{[^\r\n}:]+\}/,
      alias: "variable",
      inside: {
        delimiter: {
          pattern: /^\{|\}$/,
          alias: "punctuation"
        },
        rest: a
      }
    }, a.func = {
      pattern: /[\w-]+\([^)]*\).*/,
      inside: {
        function: /^[^(]+/,
        rest: a
      }
    }, e.languages.stylus = {
      "atrule-declaration": {
        pattern: /(^[ \t]*)@.+/m,
        lookbehind: !0,
        inside: {
          atrule: /^@[\w-]+/,
          rest: a
        }
      },
      "variable-declaration": {
        pattern: /(^[ \t]*)[\w$-]+\s*.?=[ \t]*(?:\{[^{}]*\}|\S.*|$)/m,
        lookbehind: !0,
        inside: {
          variable: /^\S+/,
          rest: a
        }
      },
      statement: {
        pattern: /(^[ \t]*)(?:else|for|if|return|unless)[ \t].+/m,
        lookbehind: !0,
        inside: {
          keyword: /^\S+/,
          rest: a
        }
      },
      // A property/value pair cannot end with a comma or a brace
      // It cannot have indented content unless it ended with a semicolon
      "property-declaration": {
        pattern: /((?:^|\{)([ \t]*))(?:[\w-]|\{[^}\r\n]+\})+(?:\s*:\s*|[ \t]+)(?!\s)[^{\r\n]*(?:;|[^{\r\n,]$(?!(?:\r?\n|\r)(?:\{|\2[ \t])))/m,
        lookbehind: !0,
        inside: {
          property: {
            pattern: /^[^\s:]+/,
            inside: {
              interpolation: a.interpolation
            }
          },
          rest: a
        }
      },
      // A selector can contain parentheses only as part of a pseudo-element
      // It can span multiple lines.
      // It must end with a comma or an accolade or have indented content.
      selector: {
        pattern: /(^[ \t]*)(?:(?=\S)(?:[^{}\r\n:()]|::?[\w-]+(?:\([^)\r\n]*\)|(?![\w-]))|\{[^}\r\n]+\})+)(?:(?:\r?\n|\r)(?:\1(?:(?=\S)(?:[^{}\r\n:()]|::?[\w-]+(?:\([^)\r\n]*\)|(?![\w-]))|\{[^}\r\n]+\})+)))*(?:,$|\{|(?=(?:\r?\n|\r)(?:\{|\1[ \t])))/m,
        lookbehind: !0,
        inside: {
          interpolation: a.interpolation,
          comment: a.comment,
          punctuation: /[{},]/
        }
      },
      func: a.func,
      string: a.string,
      comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
        lookbehind: !0,
        greedy: !0
      },
      interpolation: a.interpolation,
      punctuation: /[{}()\[\];:.]/
    };
  })(t);
}
lH.displayName = "twig";
lH.aliases = [];
function lH(t) {
  t.register(al), t.languages.twig = {
    comment: /^\{#[\s\S]*?#\}$/,
    "tag-name": {
      pattern: /(^\{%-?\s*)\w+/,
      lookbehind: !0,
      alias: "keyword"
    },
    delimiter: {
      pattern: /^\{[{%]-?|-?[%}]\}$/,
      alias: "punctuation"
    },
    string: {
      pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
      inside: {
        punctuation: /^['"]|['"]$/
      }
    },
    keyword: /\b(?:even|if|odd)\b/,
    boolean: /\b(?:false|null|true)\b/,
    number: /\b0x[\dA-Fa-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][-+]?\d+)?/,
    operator: [
      {
        pattern: /(\s)(?:and|b-and|b-or|b-xor|ends with|in|is|matches|not|or|same as|starts with)(?=\s)/,
        lookbehind: !0
      },
      /[=<>]=?|!=|\*\*?|\/\/?|\?:?|[-+~%|]/
    ],
    punctuation: /[()\[\]{}:.,]/
  }, t.hooks.add("before-tokenize", function(e) {
    if (e.language === "twig") {
      var n = /\{(?:#[\s\S]*?#|%[\s\S]*?%|\{[\s\S]*?\})\}/g;
      t.languages["markup-templating"].buildPlaceholders(e, "twig", n);
    }
  }), t.hooks.add("after-tokenize", function(e) {
    t.languages["markup-templating"].tokenizePlaceholders(e, "twig");
  });
}
uH.displayName = "pug";
uH.aliases = [];
function uH(t) {
  t.register(rl), t.register(ws), function(e) {
    e.languages.pug = {
      // Multiline stuff should appear before the rest
      // This handles both single-line and multi-line comments
      comment: {
        pattern: /(^([\t ]*))\/\/.*(?:(?:\r?\n|\r)\2[\t ].+)*/m,
        lookbehind: !0
      },
      // All the tag-related part is in lookbehind
      // so that it can be highlighted by the "tag" pattern
      "multiline-script": {
        pattern: /(^([\t ]*)script\b.*\.[\t ]*)(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/m,
        lookbehind: !0,
        inside: e.languages.javascript
      },
      // See at the end of the file for known filters
      filter: {
        pattern: /(^([\t ]*)):.+(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/m,
        lookbehind: !0,
        inside: {
          "filter-name": {
            pattern: /^:[\w-]+/,
            alias: "variable"
          },
          text: /\S[\s\S]*/
        }
      },
      "multiline-plain-text": {
        pattern: /(^([\t ]*)[\w\-#.]+\.[\t ]*)(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/m,
        lookbehind: !0
      },
      markup: {
        pattern: /(^[\t ]*)<.+/m,
        lookbehind: !0,
        inside: e.languages.markup
      },
      doctype: {
        pattern: /((?:^|\n)[\t ]*)doctype(?: .+)?/,
        lookbehind: !0
      },
      // This handle all conditional and loop keywords
      "flow-control": {
        pattern: /(^[\t ]*)(?:case|default|each|else|if|unless|when|while)\b(?: .+)?/m,
        lookbehind: !0,
        inside: {
          each: {
            pattern: /^each .+? in\b/,
            inside: {
              keyword: /\b(?:each|in)\b/,
              punctuation: /,/
            }
          },
          branch: {
            pattern: /^(?:case|default|else|if|unless|when|while)\b/,
            alias: "keyword"
          },
          rest: e.languages.javascript
        }
      },
      keyword: {
        pattern: /(^[\t ]*)(?:append|block|extends|include|prepend)\b.+/m,
        lookbehind: !0
      },
      mixin: [
        // Declaration
        {
          pattern: /(^[\t ]*)mixin .+/m,
          lookbehind: !0,
          inside: {
            keyword: /^mixin/,
            function: /\w+(?=\s*\(|\s*$)/,
            punctuation: /[(),.]/
          }
        },
        // Usage
        {
          pattern: /(^[\t ]*)\+.+/m,
          lookbehind: !0,
          inside: {
            name: {
              pattern: /^\+\w+/,
              alias: "function"
            },
            rest: e.languages.javascript
          }
        }
      ],
      script: {
        pattern: /(^[\t ]*script(?:(?:&[^(]+)?\([^)]+\))*[\t ]).+/m,
        lookbehind: !0,
        inside: e.languages.javascript
      },
      "plain-text": {
        pattern: /(^[\t ]*(?!-)[\w\-#.]*[\w\-](?:(?:&[^(]+)?\([^)]+\))*\/?[\t ]).+/m,
        lookbehind: !0
      },
      tag: {
        pattern: /(^[\t ]*)(?!-)[\w\-#.]*[\w\-](?:(?:&[^(]+)?\([^)]+\))*\/?:?/m,
        lookbehind: !0,
        inside: {
          attributes: [
            {
              pattern: /&[^(]+\([^)]+\)/,
              inside: e.languages.javascript
            },
            {
              pattern: /\([^)]+\)/,
              inside: {
                "attr-value": {
                  pattern: /(=\s*(?!\s))(?:\{[^}]*\}|[^,)\r\n]+)/,
                  lookbehind: !0,
                  inside: e.languages.javascript
                },
                "attr-name": /[\w-]+(?=\s*!?=|\s*[,)])/,
                punctuation: /[!=(),]+/
              }
            }
          ],
          punctuation: /:/,
          "attr-id": /#[\w\-]+/,
          "attr-class": /\.[\w\-]+/
        }
      },
      code: [
        {
          pattern: /(^[\t ]*(?:-|!?=)).+/m,
          lookbehind: !0,
          inside: e.languages.javascript
        }
      ],
      punctuation: /[.\-!=|]+/
    };
    for (var n = /(^([\t ]*)):<filter_name>(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/.source, r = [
      {
        filter: "atpl",
        language: "twig"
      },
      {
        filter: "coffee",
        language: "coffeescript"
      },
      "ejs",
      "handlebars",
      "less",
      "livescript",
      "markdown",
      {
        filter: "sass",
        language: "scss"
      },
      "stylus"
    ], a = {}, i = 0, o = r.length; i < o; i++) {
      var s = r[i];
      s = typeof s == "string" ? {
        filter: s,
        language: s
      } : s, e.languages[s.language] && (a["filter-" + s.filter] = {
        pattern: RegExp(
          n.replace("<filter_name>", function() {
            return s.filter;
          }),
          "m"
        ),
        lookbehind: !0,
        inside: {
          "filter-name": {
            pattern: /^:[\w-]+/,
            alias: "variable"
          },
          text: {
            pattern: /\S[\s\S]*/,
            alias: [s.language, "language-" + s.language],
            inside: e.languages[s.language]
          }
        }
      });
    }
    e.languages.insertBefore("pug", "filter", a);
  }(t);
}
cH.displayName = "puppet";
cH.aliases = [];
function cH(t) {
  (function(e) {
    e.languages.puppet = {
      heredoc: [
        // Matches the content of a quoted heredoc string (subject to interpolation)
        {
          pattern: /(@\("([^"\r\n\/):]+)"(?:\/[nrts$uL]*)?\).*(?:\r?\n|\r))(?:.*(?:\r?\n|\r(?!\n)))*?[ \t]*(?:\|[ \t]*)?(?:-[ \t]*)?\2/,
          lookbehind: !0,
          alias: "string",
          inside: {
            // Matches the end tag
            punctuation: /(?=\S).*\S(?= *$)/
            // See interpolation below
          }
        },
        // Matches the content of an unquoted heredoc string (no interpolation)
        {
          pattern: /(@\(([^"\r\n\/):]+)(?:\/[nrts$uL]*)?\).*(?:\r?\n|\r))(?:.*(?:\r?\n|\r(?!\n)))*?[ \t]*(?:\|[ \t]*)?(?:-[ \t]*)?\2/,
          lookbehind: !0,
          greedy: !0,
          alias: "string",
          inside: {
            // Matches the end tag
            punctuation: /(?=\S).*\S(?= *$)/
          }
        },
        // Matches the start tag of heredoc strings
        {
          pattern: /@\("?(?:[^"\r\n\/):]+)"?(?:\/[nrts$uL]*)?\)/,
          alias: "string",
          inside: {
            punctuation: {
              pattern: /(\().+?(?=\))/,
              lookbehind: !0
            }
          }
        }
      ],
      "multiline-comment": {
        pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
        lookbehind: !0,
        greedy: !0,
        alias: "comment"
      },
      regex: {
        // Must be prefixed with the keyword "node" or a non-word char
        pattern: /((?:\bnode\s+|[~=\(\[\{,]\s*|[=+]>\s*|^\s*))\/(?:[^\/\\]|\\[\s\S])+\/(?:[imx]+\b|\B)/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          // Extended regexes must have the x flag. They can contain single-line comments.
          "extended-regex": {
            pattern: /^\/(?:[^\/\\]|\\[\s\S])+\/[im]*x[im]*$/,
            inside: {
              comment: /#.*/
            }
          }
        }
      },
      comment: {
        pattern: /(^|[^\\])#.*/,
        lookbehind: !0,
        greedy: !0
      },
      string: {
        // Allow for one nested level of double quotes inside interpolation
        pattern: /(["'])(?:\$\{(?:[^'"}]|(["'])(?:(?!\2)[^\\]|\\[\s\S])*\2)+\}|\$(?!\{)|(?!\1)[^\\$]|\\[\s\S])*\1/,
        greedy: !0,
        inside: {
          "double-quoted": {
            pattern: /^"[\s\S]*"$/,
            inside: {
              // See interpolation below
            }
          }
        }
      },
      variable: {
        pattern: /\$(?:::)?\w+(?:::\w+)*/,
        inside: {
          punctuation: /::/
        }
      },
      "attr-name": /(?:\b\w+|\*)(?=\s*=>)/,
      function: [
        {
          pattern: /(\.)(?!\d)\w+/,
          lookbehind: !0
        },
        /\b(?:contain|debug|err|fail|include|info|notice|realize|require|tag|warning)\b|\b(?!\d)\w+(?=\()/
      ],
      number: /\b(?:0x[a-f\d]+|\d+(?:\.\d+)?(?:e-?\d+)?)\b/i,
      boolean: /\b(?:false|true)\b/,
      // Includes words reserved for future use
      keyword: /\b(?:application|attr|case|class|consumes|default|define|else|elsif|function|if|import|inherits|node|private|produces|type|undef|unless)\b/,
      datatype: {
        pattern: /\b(?:Any|Array|Boolean|Callable|Catalogentry|Class|Collection|Data|Default|Enum|Float|Hash|Integer|NotUndef|Numeric|Optional|Pattern|Regexp|Resource|Runtime|Scalar|String|Struct|Tuple|Type|Undef|Variant)\b/,
        alias: "symbol"
      },
      operator: /=[=~>]?|![=~]?|<(?:<\|?|[=~|-])?|>[>=]?|->?|~>|\|>?>?|[*\/%+?]|\b(?:and|in|or)\b/,
      punctuation: /[\[\]{}().,;]|:+/
    };
    var n = [
      {
        // Allow for one nested level of braces inside interpolation
        pattern: /(^|[^\\])\$\{(?:[^'"{}]|\{[^}]*\}|(["'])(?:(?!\2)[^\\]|\\[\s\S])*\2)+\}/,
        lookbehind: !0,
        inside: {
          "short-variable": {
            // Negative look-ahead prevent wrong highlighting of functions
            pattern: /(^\$\{)(?!\w+\()(?:::)?\w+(?:::\w+)*/,
            lookbehind: !0,
            alias: "variable",
            inside: {
              punctuation: /::/
            }
          },
          delimiter: {
            pattern: /^\$/,
            alias: "variable"
          },
          rest: e.languages.puppet
        }
      },
      {
        pattern: /(^|[^\\])\$(?:::)?\w+(?:::\w+)*/,
        lookbehind: !0,
        alias: "variable",
        inside: {
          punctuation: /::/
        }
      }
    ];
    e.languages.puppet.heredoc[0].inside.interpolation = n, e.languages.puppet.string.inside["double-quoted"].inside.interpolation = n;
  })(t);
}
fH.displayName = "pure";
fH.aliases = [];
function fH(t) {
  (function(e) {
    e.languages.pure = {
      comment: [
        {
          pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
          lookbehind: !0
        },
        {
          pattern: /(^|[^\\:])\/\/.*/,
          lookbehind: !0
        },
        /#!.+/
      ],
      "inline-lang": {
        pattern: /%<[\s\S]+?%>/,
        greedy: !0,
        inside: {
          lang: {
            pattern: /(^%< *)-\*-.+?-\*-/,
            lookbehind: !0,
            alias: "comment"
          },
          delimiter: {
            pattern: /^%<.*|%>$/,
            alias: "punctuation"
          }
        }
      },
      string: {
        pattern: /"(?:\\.|[^"\\\r\n])*"/,
        greedy: !0
      },
      number: {
        // The look-behind prevents wrong highlighting of the .. operator
        pattern: /((?:\.\.)?)(?:\b(?:inf|nan)\b|\b0x[\da-f]+|(?:\b(?:0b)?\d+(?:\.\d+)?|\B\.\d+)(?:e[+-]?\d+)?L?)/i,
        lookbehind: !0
      },
      keyword: /\b(?:NULL|ans|break|bt|case|catch|cd|clear|const|def|del|dump|else|end|exit|extern|false|force|help|if|infix[lr]?|interface|let|ls|mem|namespace|nonfix|of|otherwise|outfix|override|postfix|prefix|private|public|pwd|quit|run|save|show|stats|then|throw|trace|true|type|underride|using|when|with)\b/,
      function: /\b(?:abs|add_(?:addr|constdef|(?:fundef|interface|macdef|typedef)(?:_at)?|vardef)|all|any|applp?|arity|bigintp?|blob(?:_crc|_size|p)?|boolp?|byte_c?string(?:_pointer)?|byte_(?:matrix|pointer)|calloc|cat|catmap|ceil|char[ps]?|check_ptrtag|chr|clear_sentry|clearsym|closurep?|cmatrixp?|cols?|colcat(?:map)?|colmap|colrev|colvector(?:p|seq)?|complex(?:_float_(?:matrix|pointer)|_matrix(?:_view)?|_pointer|p)?|conj|cookedp?|cst|cstring(?:_(?:dup|list|vector))?|curry3?|cyclen?|del_(?:constdef|fundef|interface|macdef|typedef|vardef)|delete|diag(?:mat)?|dim|dmatrixp?|do|double(?:_matrix(?:_view)?|_pointer|p)?|dowith3?|drop|dropwhile|eval(?:cmd)?|exactp|filter|fix|fixity|flip|float(?:_matrix|_pointer)|floor|fold[lr]1?|frac|free|funp?|functionp?|gcd|get(?:_(?:byte|constdef|double|float|fundef|int(?:64)?|interface(?:_typedef)?|long|macdef|pointer|ptrtag|sentry|short|string|typedef|vardef))?|globsym|hash|head|id|im|imatrixp?|index|inexactp|infp|init|insert|int(?:_matrix(?:_view)?|_pointer|p)?|int64_(?:matrix|pointer)|integerp?|iteraten?|iterwhile|join|keys?|lambdap?|last(?:err(?:pos)?)?|lcd|list[2p]?|listmap|make_ptrtag|malloc|map|matcat|matrixp?|max|member|min|nanp|nargs|nmatrixp?|null|numberp?|ord|pack(?:ed)?|pointer(?:_cast|_tag|_type|p)?|pow|pred|ptrtag|put(?:_(?:byte|double|float|int(?:64)?|long|pointer|short|string))?|rationalp?|re|realp?|realloc|recordp?|redim|reduce(?:_with)?|refp?|repeatn?|reverse|rlistp?|round|rows?|rowcat(?:map)?|rowmap|rowrev|rowvector(?:p|seq)?|same|scan[lr]1?|sentry|sgn|short_(?:matrix|pointer)|slice|smatrixp?|sort|split|str|strcat|stream|stride|string(?:_(?:dup|list|vector)|p)?|subdiag(?:mat)?|submat|subseq2?|substr|succ|supdiag(?:mat)?|symbolp?|tail|take|takewhile|thunkp?|transpose|trunc|tuplep?|typep|ubyte|uint(?:64)?|ulong|uncurry3?|unref|unzip3?|update|ushort|vals?|varp?|vector(?:p|seq)?|void|zip3?|zipwith3?)\b/,
      special: {
        pattern: /\b__[a-z]+__\b/i,
        alias: "builtin"
      },
      // Any combination of operator chars can be an operator
      // eslint-disable-next-line no-misleading-character-class
      operator: /(?:[!"#$%&'*+,\-.\/:<=>?@\\^`|~\u00a1-\u00bf\u00d7-\u00f7\u20d0-\u2bff]|\b_+\b)+|\b(?:and|div|mod|not|or)\b/,
      // FIXME: How can we prevent | and , to be highlighted as operator when they are used alone?
      punctuation: /[(){}\[\];,|]/
    };
    var n = [
      "c",
      {
        lang: "c++",
        alias: "cpp"
      },
      "fortran"
    ], r = /%< *-\*- *<lang>\d* *-\*-[\s\S]+?%>/.source;
    n.forEach(function(a) {
      var i = a;
      if (typeof a != "string" && (i = a.alias, a = a.lang), e.languages[i]) {
        var o = {};
        o["inline-lang-" + i] = {
          pattern: RegExp(
            r.replace(
              "<lang>",
              a.replace(/([.+*?\/\\(){}\[\]])/g, "\\$1")
            ),
            "i"
          ),
          inside: e.util.clone(e.languages.pure["inline-lang"].inside)
        }, o["inline-lang-" + i].inside.rest = e.util.clone(
          e.languages[i]
        ), e.languages.insertBefore("pure", "inline-lang", o);
      }
    }), e.languages.c && (e.languages.pure["inline-lang"].inside.rest = e.util.clone(
      e.languages.c
    ));
  })(t);
}
dH.displayName = "purebasic";
dH.aliases = ["pbfasm"];
function dH(t) {
  t.register(Lr), t.languages.purebasic = t.languages.extend("clike", {
    comment: /;.*/,
    keyword: /\b(?:align|and|as|break|calldebugger|case|compilercase|compilerdefault|compilerelse|compilerelseif|compilerendif|compilerendselect|compilererror|compilerif|compilerselect|continue|data|datasection|debug|debuglevel|declare|declarec|declarecdll|declaredll|declaremodule|default|define|dim|disableasm|disabledebugger|disableexplicit|else|elseif|enableasm|enabledebugger|enableexplicit|end|enddatasection|enddeclaremodule|endenumeration|endif|endimport|endinterface|endmacro|endmodule|endprocedure|endselect|endstructure|endstructureunion|endwith|enumeration|extends|fakereturn|for|foreach|forever|global|gosub|goto|if|import|importc|includebinary|includefile|includepath|interface|macro|module|newlist|newmap|next|not|or|procedure|procedurec|procedurecdll|proceduredll|procedurereturn|protected|prototype|prototypec|read|redim|repeat|restore|return|runtime|select|shared|static|step|structure|structureunion|swap|threaded|to|until|wend|while|with|xincludefile|xor)\b/i,
    function: /\b\w+(?:\.\w+)?\s*(?=\()/,
    number: /(?:\$[\da-f]+|\b-?(?:\d+(?:\.\d+)?|\.\d+)(?:e[+-]?\d+)?)\b/i,
    operator: /(?:@\*?|\?|\*)\w+\$?|-[>-]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|?\||[~^%?*/@]/
  }), t.languages.insertBefore("purebasic", "keyword", {
    tag: /#\w+\$?/,
    asm: {
      pattern: /(^[\t ]*)!.*/m,
      lookbehind: !0,
      alias: "tag",
      inside: {
        comment: /;.*/,
        string: {
          pattern: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
          greedy: !0
        },
        // Anonymous label references, i.e.: jmp @b
        "label-reference-anonymous": {
          pattern: /(!\s*j[a-z]+\s+)@[fb]/i,
          lookbehind: !0,
          alias: "fasm-label"
        },
        // Named label reference, i.e.: jne label1
        "label-reference-addressed": {
          pattern: /(!\s*j[a-z]+\s+)[A-Z._?$@][\w.?$@~#]*/i,
          lookbehind: !0,
          alias: "fasm-label"
        },
        keyword: [
          /\b(?:extern|global)\b[^;\r\n]*/i,
          /\b(?:CPU|DEFAULT|FLOAT)\b.*/
        ],
        function: {
          pattern: /^([\t ]*!\s*)[\da-z]+(?=\s|$)/im,
          lookbehind: !0
        },
        "function-inline": {
          pattern: /(:\s*)[\da-z]+(?=\s)/i,
          lookbehind: !0,
          alias: "function"
        },
        label: {
          pattern: /^([\t ]*!\s*)[A-Za-z._?$@][\w.?$@~#]*(?=:)/m,
          lookbehind: !0,
          alias: "fasm-label"
        },
        register: /\b(?:st\d|[xyz]mm\d\d?|[cdt]r\d|r\d\d?[bwd]?|[er]?[abcd]x|[abcd][hl]|[er]?(?:bp|di|si|sp)|[cdefgs]s|mm\d+)\b/i,
        number: /(?:\b|-|(?=\$))(?:0[hx](?:[\da-f]*\.)?[\da-f]+(?:p[+-]?\d+)?|\d[\da-f]+[hx]|\$\d[\da-f]*|0[oq][0-7]+|[0-7]+[oq]|0[by][01]+|[01]+[by]|0[dt]\d+|(?:\d+(?:\.\d+)?|\.\d+)(?:\.?e[+-]?\d+)?[dt]?)\b/i,
        operator: /[\[\]*+\-/%<>=&|$!,.:]/
      }
    }
  }), delete t.languages.purebasic["class-name"], delete t.languages.purebasic.boolean, t.languages.pbfasm = t.languages.purebasic;
}
pH.displayName = "purescript";
pH.aliases = ["purs"];
function pH(t) {
  t.register(P_), t.languages.purescript = t.languages.extend("haskell", {
    keyword: /\b(?:ado|case|class|data|derive|do|else|forall|if|in|infixl|infixr|instance|let|module|newtype|of|primitive|then|type|where)\b|∀/,
    "import-statement": {
      // The imported or hidden names are not included in this import
      // statement. This is because we want to highlight those exactly like
      // we do for the names in the program.
      pattern: /(^[\t ]*)import\s+[A-Z][\w']*(?:\.[A-Z][\w']*)*(?:\s+as\s+[A-Z][\w']*(?:\.[A-Z][\w']*)*)?(?:\s+hiding\b)?/m,
      lookbehind: !0,
      inside: {
        keyword: /\b(?:as|hiding|import)\b/,
        punctuation: /\./
      }
    },
    // These are builtin functions only. Constructors are highlighted later as a constant.
    builtin: /\b(?:absurd|add|ap|append|apply|between|bind|bottom|clamp|compare|comparing|compose|conj|const|degree|discard|disj|div|eq|flap|flip|gcd|identity|ifM|join|lcm|liftA1|liftM1|map|max|mempty|min|mod|mul|negate|not|notEq|one|otherwise|recip|show|sub|top|unit|unless|unlessM|void|when|whenM|zero)\b/,
    operator: [
      // Infix operators
      t.languages.haskell.operator[0],
      // ASCII operators
      t.languages.haskell.operator[2],
      // All UTF16 Unicode operator symbols
      // This regex is equivalent to /(?=[\x80-\uFFFF])[\p{gc=Math_Symbol}\p{gc=Currency_Symbol}\p{Modifier_Symbol}\p{Other_Symbol}]/u
      // See https://github.com/PrismJS/prism/issues/3006 for more details.
      /[\xa2-\xa6\xa8\xa9\xac\xae-\xb1\xb4\xb8\xd7\xf7\u02c2-\u02c5\u02d2-\u02df\u02e5-\u02eb\u02ed\u02ef-\u02ff\u0375\u0384\u0385\u03f6\u0482\u058d-\u058f\u0606-\u0608\u060b\u060e\u060f\u06de\u06e9\u06fd\u06fe\u07f6\u07fe\u07ff\u09f2\u09f3\u09fa\u09fb\u0af1\u0b70\u0bf3-\u0bfa\u0c7f\u0d4f\u0d79\u0e3f\u0f01-\u0f03\u0f13\u0f15-\u0f17\u0f1a-\u0f1f\u0f34\u0f36\u0f38\u0fbe-\u0fc5\u0fc7-\u0fcc\u0fce\u0fcf\u0fd5-\u0fd8\u109e\u109f\u1390-\u1399\u166d\u17db\u1940\u19de-\u19ff\u1b61-\u1b6a\u1b74-\u1b7c\u1fbd\u1fbf-\u1fc1\u1fcd-\u1fcf\u1fdd-\u1fdf\u1fed-\u1fef\u1ffd\u1ffe\u2044\u2052\u207a-\u207c\u208a-\u208c\u20a0-\u20bf\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211e-\u2123\u2125\u2127\u2129\u212e\u213a\u213b\u2140-\u2144\u214a-\u214d\u214f\u218a\u218b\u2190-\u2307\u230c-\u2328\u232b-\u2426\u2440-\u244a\u249c-\u24e9\u2500-\u2767\u2794-\u27c4\u27c7-\u27e5\u27f0-\u2982\u2999-\u29d7\u29dc-\u29fb\u29fe-\u2b73\u2b76-\u2b95\u2b97-\u2bff\u2ce5-\u2cea\u2e50\u2e51\u2e80-\u2e99\u2e9b-\u2ef3\u2f00-\u2fd5\u2ff0-\u2ffb\u3004\u3012\u3013\u3020\u3036\u3037\u303e\u303f\u309b\u309c\u3190\u3191\u3196-\u319f\u31c0-\u31e3\u3200-\u321e\u322a-\u3247\u3250\u3260-\u327f\u328a-\u32b0\u32c0-\u33ff\u4dc0-\u4dff\ua490-\ua4c6\ua700-\ua716\ua720\ua721\ua789\ua78a\ua828-\ua82b\ua836-\ua839\uaa77-\uaa79\uab5b\uab6a\uab6b\ufb29\ufbb2-\ufbc1\ufdfc\ufdfd\ufe62\ufe64-\ufe66\ufe69\uff04\uff0b\uff1c-\uff1e\uff3e\uff40\uff5c\uff5e\uffe0-\uffe6\uffe8-\uffee\ufffc\ufffd]/
    ]
  }), t.languages.purs = t.languages.purescript;
}
hH.displayName = "qsharp";
hH.aliases = ["qs"];
function hH(t) {
  t.register(Lr), function(e) {
    function n(O, w) {
      return O.replace(/<<(\d+)>>/g, function(_, C) {
        return "(?:" + w[+C] + ")";
      });
    }
    function r(O, w, _) {
      return RegExp(n(O, w), _ || "");
    }
    function a(O, w) {
      for (var _ = 0; _ < w; _++)
        O = O.replace(/<<self>>/g, function() {
          return "(?:" + O + ")";
        });
      return O.replace(/<<self>>/g, "[^\\s\\S]");
    }
    var i = {
      // keywords which represent a return or variable type
      type: "Adj BigInt Bool Ctl Double false Int One Pauli PauliI PauliX PauliY PauliZ Qubit Range Result String true Unit Zero",
      // all other keywords
      other: "Adjoint adjoint apply as auto body borrow borrowing Controlled controlled distribute elif else fail fixup for function if in internal intrinsic invert is let mutable namespace new newtype open operation repeat return self set until use using while within"
    };
    function o(O) {
      return "\\b(?:" + O.trim().replace(/ /g, "|") + ")\\b";
    }
    var s = RegExp(
      o(i.type + " " + i.other)
    ), u = /\b[A-Za-z_]\w*\b/.source, f = n(/<<0>>(?:\s*\.\s*<<0>>)*/.source, [u]), p = {
      keyword: s,
      punctuation: /[<>()?,.:[\]]/
    }, m = /"(?:\\.|[^\\"])*"/.source;
    e.languages.qsharp = e.languages.extend("clike", {
      comment: /\/\/.*/,
      string: [
        {
          pattern: r(/(^|[^$\\])<<0>>/.source, [m]),
          lookbehind: !0,
          greedy: !0
        }
      ],
      "class-name": [
        {
          // open Microsoft.Quantum.Canon;
          // open Microsoft.Quantum.Canon as CN;
          pattern: r(/(\b(?:as|open)\s+)<<0>>(?=\s*(?:;|as\b))/.source, [
            f
          ]),
          lookbehind: !0,
          inside: p
        },
        {
          // namespace Quantum.App1;
          pattern: r(/(\bnamespace\s+)<<0>>(?=\s*\{)/.source, [f]),
          lookbehind: !0,
          inside: p
        }
      ],
      keyword: s,
      number: /(?:\b0(?:x[\da-f]+|b[01]+|o[0-7]+)|(?:\B\.\d+|\b\d+(?:\.\d*)?)(?:e[-+]?\d+)?)l?\b/i,
      operator: /\band=|\bor=|\band\b|\bnot\b|\bor\b|<[-=]|[-=]>|>>>=?|<<<=?|\^\^\^=?|\|\|\|=?|&&&=?|w\/=?|~~~|[*\/+\-^=!%]=?/,
      punctuation: /::|[{}[\];(),.:]/
    }), e.languages.insertBefore("qsharp", "number", {
      range: {
        pattern: /\.\./,
        alias: "operator"
      }
    });
    var v = a(
      n(/\{(?:[^"{}]|<<0>>|<<self>>)*\}/.source, [m]),
      2
    );
    e.languages.insertBefore("qsharp", "string", {
      "interpolation-string": {
        pattern: r(/\$"(?:\\.|<<0>>|[^\\"{])*"/.source, [v]),
        greedy: !0,
        inside: {
          interpolation: {
            pattern: r(/((?:^|[^\\])(?:\\\\)*)<<0>>/.source, [
              v
            ]),
            lookbehind: !0,
            inside: {
              punctuation: /^\{|\}$/,
              expression: {
                pattern: /[\s\S]+/,
                alias: "language-qsharp",
                inside: e.languages.qsharp
              }
            }
          },
          string: /[\s\S]+/
        }
      }
    });
  }(t), t.languages.qs = t.languages.qsharp;
}
mH.displayName = "q";
mH.aliases = [];
function mH(t) {
  t.languages.q = {
    string: /"(?:\\.|[^"\\\r\n])*"/,
    comment: [
      // From http://code.kx.com/wiki/Reference/Slash:
      // When / is following a space (or a right parenthesis, bracket, or brace), it is ignored with the rest of the line.
      {
        pattern: /([\t )\]}])\/.*/,
        lookbehind: !0,
        greedy: !0
      },
      // From http://code.kx.com/wiki/Reference/Slash:
      // A line which has / as its first character and contains at least one other non-whitespace character is a whole-line comment and is ignored entirely.
      // A / on a line by itself begins a multiline comment which is terminated by the next \ on a line by itself.
      // If a / is not matched by a \, the multiline comment is unterminated and continues to end of file.
      // The / and \ must be the first char on the line, but may be followed by any amount of whitespace.
      {
        pattern: /(^|\r?\n|\r)\/[\t ]*(?:(?:\r?\n|\r)(?:.*(?:\r?\n|\r(?!\n)))*?(?:\\(?=[\t ]*(?:\r?\n|\r))|$)|\S.*)/,
        lookbehind: !0,
        greedy: !0
      },
      // From http://code.kx.com/wiki/Reference/Slash:
      // A \ on a line by itself with no preceding matching / will comment to end of file.
      {
        pattern: /^\\[\t ]*(?:\r?\n|\r)[\s\S]+/m,
        greedy: !0
      },
      {
        pattern: /^#!.+/m,
        greedy: !0
      }
    ],
    symbol: /`(?::\S+|[\w.]*)/,
    datetime: {
      pattern: /0N[mdzuvt]|0W[dtz]|\d{4}\.\d\d(?:m|\.\d\d(?:T(?:\d\d(?::\d\d(?::\d\d(?:[.:]\d\d\d)?)?)?)?)?[dz]?)|\d\d:\d\d(?::\d\d(?:[.:]\d\d\d)?)?[uvt]?/,
      alias: "number"
    },
    // The negative look-ahead prevents bad highlighting
    // of verbs 0: and 1:
    number: /\b(?![01]:)(?:0N[hje]?|0W[hj]?|0[wn]|0x[\da-fA-F]+|\d+(?:\.\d*)?(?:e[+-]?\d+)?[hjfeb]?)/,
    keyword: /\\\w+\b|\b(?:abs|acos|aj0?|all|and|any|asc|asin|asof|atan|attr|avgs?|binr?|by|ceiling|cols|cor|cos|count|cov|cross|csv|cut|delete|deltas|desc|dev|differ|distinct|div|do|dsave|ej|enlist|eval|except|exec|exit|exp|fby|fills|first|fkeys|flip|floor|from|get|getenv|group|gtime|hclose|hcount|hdel|hopen|hsym|iasc|identity|idesc|if|ij|in|insert|inter|inv|keys?|last|like|list|ljf?|load|log|lower|lsq|ltime|ltrim|mavg|maxs?|mcount|md5|mdev|med|meta|mins?|mmax|mmin|mmu|mod|msum|neg|next|not|null|or|over|parse|peach|pj|plist|prds?|prev|prior|rand|rank|ratios|raze|read0|read1|reciprocal|reval|reverse|rload|rotate|rsave|rtrim|save|scan|scov|sdev|select|set|setenv|show|signum|sin|sqrt|ssr?|string|sublist|sums?|sv|svar|system|tables|tan|til|trim|txf|type|uj|ungroup|union|update|upper|upsert|value|var|views?|vs|wavg|where|while|within|wj1?|wsum|ww|xasc|xbar|xcols?|xdesc|xexp|xgroup|xkey|xlog|xprev|xrank)\b/,
    adverb: {
      pattern: /['\/\\]:?|\beach\b/,
      alias: "function"
    },
    verb: {
      pattern: /(?:\B\.\B|\b[01]:|<[=>]?|>=?|[:+\-*%,!?~=|$&#@^]):?|\b_\b:?/,
      alias: "operator"
    },
    punctuation: /[(){}\[\];.]/
  };
}
gH.displayName = "qml";
gH.aliases = [];
function gH(t) {
  t.register(rl), function(e) {
    for (var n = /"(?:\\.|[^\\"\r\n])*"|'(?:\\.|[^\\'\r\n])*'/.source, r = /\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))*\*\//.source, a = /(?:[^\\()[\]{}"'/]|<string>|\/(?![*/])|<comment>|\(<expr>*\)|\[<expr>*\]|\{<expr>*\}|\\[\s\S])/.source.replace(/<string>/g, function() {
      return n;
    }).replace(/<comment>/g, function() {
      return r;
    }), i = 0; i < 2; i++)
      a = a.replace(/<expr>/g, function() {
        return a;
      });
    a = a.replace(/<expr>/g, "[^\\s\\S]"), e.languages.qml = {
      comment: {
        pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
        greedy: !0
      },
      "javascript-function": {
        pattern: RegExp(
          /((?:^|;)[ \t]*)function\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*\(<js>*\)\s*\{<js>*\}/.source.replace(
            /<js>/g,
            function() {
              return a;
            }
          ),
          "m"
        ),
        lookbehind: !0,
        greedy: !0,
        alias: "language-javascript",
        inside: e.languages.javascript
      },
      "class-name": {
        pattern: /((?:^|[:;])[ \t]*)(?!\d)\w+(?=[ \t]*\{|[ \t]+on\b)/m,
        lookbehind: !0
      },
      property: [
        {
          pattern: /((?:^|[;{])[ \t]*)(?!\d)\w+(?:\.\w+)*(?=[ \t]*:)/m,
          lookbehind: !0
        },
        {
          pattern: /((?:^|[;{])[ \t]*)property[ \t]+(?!\d)\w+(?:\.\w+)*[ \t]+(?!\d)\w+(?:\.\w+)*(?=[ \t]*:)/m,
          lookbehind: !0,
          inside: {
            keyword: /^property/,
            property: /\w+(?:\.\w+)*/
          }
        }
      ],
      "javascript-expression": {
        pattern: RegExp(
          /(:[ \t]*)(?![\s;}[])(?:(?!$|[;}])<js>)+/.source.replace(
            /<js>/g,
            function() {
              return a;
            }
          ),
          "m"
        ),
        lookbehind: !0,
        greedy: !0,
        alias: "language-javascript",
        inside: e.languages.javascript
      },
      string: {
        pattern: /"(?:\\.|[^\\"\r\n])*"/,
        greedy: !0
      },
      keyword: /\b(?:as|import|on)\b/,
      punctuation: /[{}[\]:;,]/
    };
  }(t);
}
bH.displayName = "qore";
bH.aliases = [];
function bH(t) {
  t.register(Lr), t.languages.qore = t.languages.extend("clike", {
    comment: {
      pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:\/\/|#).*)/,
      lookbehind: !0
    },
    // Overridden to allow unescaped multi-line strings
    string: {
      pattern: /("|')(?:\\[\s\S]|(?!\1)[^\\])*\1/,
      greedy: !0
    },
    keyword: /\b(?:abstract|any|assert|binary|bool|boolean|break|byte|case|catch|char|class|code|const|continue|data|default|do|double|else|enum|extends|final|finally|float|for|goto|hash|if|implements|import|inherits|instanceof|int|interface|long|my|native|new|nothing|null|object|our|own|private|reference|rethrow|return|short|soft(?:bool|date|float|int|list|number|string)|static|strictfp|string|sub|super|switch|synchronized|this|throw|throws|transient|try|void|volatile|while)\b/,
    boolean: /\b(?:false|true)\b/i,
    function: /\$?\b(?!\d)\w+(?=\()/,
    number: /\b(?:0b[01]+|0x(?:[\da-f]*\.)?[\da-fp\-]+|(?:\d+(?:\.\d+)?|\.\d+)(?:e\d+)?[df]|(?:\d+(?:\.\d+)?|\.\d+))\b/i,
    operator: {
      pattern: /(^|[^.])(?:\+[+=]?|-[-=]?|[!=](?:==?|~)?|>>?=?|<(?:=>?|<=?)?|&[&=]?|\|[|=]?|[*\/%^]=?|[~?])/,
      lookbehind: !0
    },
    variable: /\$(?!\d)\w+\b/
  });
}
vH.displayName = "racket";
vH.aliases = ["rkt"];
function vH(t) {
  t.register(L_), t.languages.racket = t.languages.extend("scheme", {
    "lambda-parameter": {
      // the racket lambda syntax is a lot more complex, so we won't even attempt to capture it.
      // this will just prevent false positives of the `function` pattern
      pattern: /([(\[]lambda\s+[(\[])[^()\[\]'\s]+/,
      lookbehind: !0
    }
  }), t.languages.insertBefore("racket", "string", {
    lang: {
      pattern: /^#lang.+/m,
      greedy: !0,
      alias: "keyword"
    }
  }), t.languages.rkt = t.languages.racket;
}
yH.displayName = "cshtml";
yH.aliases = ["razor"];
function yH(t) {
  t.register(A0), t.register(ws), function(e) {
    var n = /\/(?![/*])|\/\/.*[\r\n]|\/\*[^*]*(?:\*(?!\/)[^*]*)*\*\//.source, r = /@(?!")|"(?:[^\r\n\\"]|\\.)*"|@"(?:[^\\"]|""|\\[\s\S])*"(?!")/.source + "|" + /'(?:(?:[^\r\n'\\]|\\.|\\[Uux][\da-fA-F]{1,8})'|(?=[^\\](?!')))/.source;
    function a(N, P) {
      for (var I = 0; I < P; I++)
        N = N.replace(/<self>/g, function() {
          return "(?:" + N + ")";
        });
      return N.replace(/<self>/g, "[^\\s\\S]").replace(/<str>/g, "(?:" + r + ")").replace(/<comment>/g, "(?:" + n + ")");
    }
    var i = a(/\((?:[^()'"@/]|<str>|<comment>|<self>)*\)/.source, 2), o = a(/\[(?:[^\[\]'"@/]|<str>|<comment>|<self>)*\]/.source, 1), s = a(/\{(?:[^{}'"@/]|<str>|<comment>|<self>)*\}/.source, 2), u = a(/<(?:[^<>'"@/]|<comment>|<self>)*>/.source, 1), f = /@/.source + /(?:await\b\s*)?/.source + "(?:" + /(?!await\b)\w+\b/.source + "|" + i + ")(?:" + /[?!]?\.\w+\b/.source + "|(?:" + u + ")?" + i + "|" + o + ")*" + /(?![?!\.(\[]|<(?!\/))/.source, p = /@(?![\w()])/.source + "|" + f, m = "(?:" + /"[^"@]*"|'[^'@]*'|[^\s'"@>=]+(?=[\s>])/.source + `|["'][^"'@]*(?:(?:` + p + `)[^"'@]*)+["'])`, v = /(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*<tagAttrValue>|(?=[\s/>])))+)?/.source.replace(
      /<tagAttrValue>/,
      m
    ), O = /(?!\d)[^\s>\/=$<%]+/.source + v + /\s*\/?>/.source, w = /\B@?/.source + "(?:" + /<([a-zA-Z][\w:]*)/.source + v + /\s*>/.source + "(?:" + (/[^<]/.source + "|" + // all tags that are not the start tag
    // eslint-disable-next-line regexp/strict
    /<\/?(?!\1\b)/.source + O + "|" + // nested start tag
    a(
      // eslint-disable-next-line regexp/strict
      /<\1/.source + v + /\s*>/.source + "(?:" + (/[^<]/.source + "|" + // all tags that are not the start tag
      // eslint-disable-next-line regexp/strict
      /<\/?(?!\1\b)/.source + O + "|<self>") + ")*" + // eslint-disable-next-line regexp/strict
      /<\/\1\s*>/.source,
      2
    )) + ")*" + // eslint-disable-next-line regexp/strict
    /<\/\1\s*>/.source + "|" + /</.source + O + ")";
    e.languages.cshtml = e.languages.extend("markup", {});
    var _ = e.languages.insertBefore(
      "csharp",
      "string",
      {
        html: {
          pattern: RegExp(w),
          greedy: !0,
          inside: e.languages.cshtml
        }
      },
      {
        csharp: e.languages.extend("csharp", {})
      }
    ), C = {
      pattern: /\S[\s\S]*/,
      alias: "language-csharp",
      inside: _
    }, A = {
      pattern: RegExp(/(^|[^@])/.source + f),
      lookbehind: !0,
      greedy: !0,
      alias: "variable",
      inside: {
        keyword: /^@/,
        csharp: C
      }
    };
    e.languages.cshtml.tag.pattern = RegExp(/<\/?/.source + O), e.languages.cshtml.tag.inside["attr-value"].pattern = RegExp(
      /=\s*/.source + m
    ), e.languages.insertBefore(
      "inside",
      "punctuation",
      {
        value: A
      },
      e.languages.cshtml.tag.inside["attr-value"]
    ), e.languages.insertBefore("cshtml", "prolog", {
      "razor-comment": {
        pattern: /@\*[\s\S]*?\*@/,
        greedy: !0,
        alias: "comment"
      },
      block: {
        pattern: RegExp(
          /(^|[^@])@/.source + "(?:" + [
            // @{ ... }
            s,
            // @code{ ... }
            /(?:code|functions)\s*/.source + s,
            // @for (...) { ... }
            /(?:for|foreach|lock|switch|using|while)\s*/.source + i + /\s*/.source + s,
            // @do { ... } while (...);
            /do\s*/.source + s + /\s*while\s*/.source + i + /(?:\s*;)?/.source,
            // @try { ... } catch (...) { ... } finally { ... }
            /try\s*/.source + s + /\s*catch\s*/.source + i + /\s*/.source + s + /\s*finally\s*/.source + s,
            // @if (...) {...} else if (...) {...} else {...}
            /if\s*/.source + i + /\s*/.source + s + "(?:" + /\s*else/.source + "(?:" + /\s+if\s*/.source + i + ")?" + /\s*/.source + s + ")*",
            // @helper Ident(params) { ... }
            /helper\s+\w+\s*/.source + i + /\s*/.source + s
          ].join("|") + ")"
        ),
        lookbehind: !0,
        greedy: !0,
        inside: {
          keyword: /^@\w*/,
          csharp: C
        }
      },
      directive: {
        pattern: /^([ \t]*)@(?:addTagHelper|attribute|implements|inherits|inject|layout|model|namespace|page|preservewhitespace|removeTagHelper|section|tagHelperPrefix|using)(?=\s).*/m,
        lookbehind: !0,
        greedy: !0,
        inside: {
          keyword: /^@\w+/,
          csharp: C
        }
      },
      value: A,
      "delegate-operator": {
        pattern: /(^|[^@])@(?=<)/,
        lookbehind: !0,
        alias: "operator"
      }
    }), e.languages.razor = e.languages.cshtml;
  }(t);
}
qD.displayName = "jsx";
qD.aliases = [];
function qD(t) {
  t.register(rl), t.register(ws), function(e) {
    var n = e.util.clone(e.languages.javascript), r = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source, a = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source, i = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;
    function o(f, p) {
      return f = f.replace(/<S>/g, function() {
        return r;
      }).replace(/<BRACES>/g, function() {
        return a;
      }).replace(/<SPREAD>/g, function() {
        return i;
      }), RegExp(f, p);
    }
    i = o(i).source, e.languages.jsx = e.languages.extend("markup", n), e.languages.jsx.tag.pattern = o(
      /<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source
    ), e.languages.jsx.tag.inside.tag.pattern = /^<\/?[^\s>\/]*/, e.languages.jsx.tag.inside["attr-value"].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/, e.languages.jsx.tag.inside.tag.inside["class-name"] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/, e.languages.jsx.tag.inside.comment = n.comment, e.languages.insertBefore(
      "inside",
      "attr-name",
      {
        spread: {
          pattern: o(/<SPREAD>/.source),
          inside: e.languages.jsx
        }
      },
      e.languages.jsx.tag
    ), e.languages.insertBefore(
      "inside",
      "special-attr",
      {
        script: {
          // Allow for two levels of nesting
          pattern: o(/=<BRACES>/.source),
          alias: "language-javascript",
          inside: {
            "script-punctuation": {
              pattern: /^=(?=\{)/,
              alias: "punctuation"
            },
            rest: e.languages.jsx
          }
        }
      },
      e.languages.jsx.tag
    );
    var s = function(f) {
      return f ? typeof f == "string" ? f : typeof f.content == "string" ? f.content : f.content.map(s).join("") : "";
    }, u = function(f) {
      for (var p = [], m = 0; m < f.length; m++) {
        var v = f[m], O = !1;
        if (typeof v != "string" && (v.type === "tag" && v.content[0] && v.content[0].type === "tag" ? v.content[0].content[0].content === "</" ? p.length > 0 && p[p.length - 1].tagName === s(v.content[0].content[1]) && p.pop() : v.content[v.content.length - 1].content === "/>" || p.push({
          tagName: s(v.content[0].content[1]),
          openedBraces: 0
        }) : p.length > 0 && v.type === "punctuation" && v.content === "{" ? p[p.length - 1].openedBraces++ : p.length > 0 && p[p.length - 1].openedBraces > 0 && v.type === "punctuation" && v.content === "}" ? p[p.length - 1].openedBraces-- : O = !0), (O || typeof v == "string") && p.length > 0 && p[p.length - 1].openedBraces === 0) {
          var w = s(v);
          m < f.length - 1 && (typeof f[m + 1] == "string" || f[m + 1].type === "plain-text") && (w += s(f[m + 1]), f.splice(m + 1, 1)), m > 0 && (typeof f[m - 1] == "string" || f[m - 1].type === "plain-text") && (w = s(f[m - 1]) + w, f.splice(m - 1, 1), m--), f[m] = new e.Token(
            "plain-text",
            w,
            null,
            w
          );
        }
        v.content && typeof v.content != "string" && u(v.content);
      }
    };
    e.hooks.add("after-tokenize", function(f) {
      f.language !== "jsx" && f.language !== "tsx" || u(f.tokens);
    });
  }(t);
}
OH.displayName = "tsx";
OH.aliases = [];
function OH(t) {
  t.register(qD), t.register(y1), function(e) {
    var n = e.util.clone(e.languages.typescript);
    e.languages.tsx = e.languages.extend("jsx", n), delete e.languages.tsx.parameter, delete e.languages.tsx["literal-property"];
    var r = e.languages.tsx.tag;
    r.pattern = RegExp(
      /(^|[^\w$]|(?=<\/))/.source + "(?:" + r.pattern.source + ")",
      r.pattern.flags
    ), r.lookbehind = !0;
  }(t);
}
EH.displayName = "reason";
EH.aliases = [];
function EH(t) {
  t.register(Lr), t.languages.reason = t.languages.extend("clike", {
    string: {
      pattern: /"(?:\\(?:\r\n|[\s\S])|[^\\\r\n"])*"/,
      greedy: !0
    },
    // 'class-name' must be matched *after* 'constructor' defined below
    "class-name": /\b[A-Z]\w*/,
    keyword: /\b(?:and|as|assert|begin|class|constraint|do|done|downto|else|end|exception|external|for|fun|function|functor|if|in|include|inherit|initializer|lazy|let|method|module|mutable|new|nonrec|object|of|open|or|private|rec|sig|struct|switch|then|to|try|type|val|virtual|when|while|with)\b/,
    operator: /\.{3}|:[:=]|\|>|->|=(?:==?|>)?|<=?|>=?|[|^?'#!~`]|[+\-*\/]\.?|\b(?:asr|land|lor|lsl|lsr|lxor|mod)\b/
  }), t.languages.insertBefore("reason", "class-name", {
    char: {
      pattern: /'(?:\\x[\da-f]{2}|\\o[0-3][0-7][0-7]|\\\d{3}|\\.|[^'\\\r\n])'/,
      greedy: !0
    },
    // Negative look-ahead prevents from matching things like String.capitalize
    constructor: /\b[A-Z]\w*\b(?!\s*\.)/,
    label: {
      pattern: /\b[a-z]\w*(?=::)/,
      alias: "symbol"
    }
  }), delete t.languages.reason.function;
}
SH.displayName = "rego";
SH.aliases = [];
function SH(t) {
  t.languages.rego = {
    comment: /#.*/,
    property: {
      pattern: /(^|[^\\.])(?:"(?:\\.|[^\\"\r\n])*"|`[^`]*`|\b[a-z_]\w*\b)(?=\s*:(?!=))/i,
      lookbehind: !0,
      greedy: !0
    },
    string: {
      pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"|`[^`]*`/,
      lookbehind: !0,
      greedy: !0
    },
    keyword: /\b(?:as|default|else|import|not|null|package|set(?=\s*\()|some|with)\b/,
    boolean: /\b(?:false|true)\b/,
    function: {
      pattern: /\b[a-z_]\w*\b(?:\s*\.\s*\b[a-z_]\w*\b)*(?=\s*\()/i,
      inside: {
        namespace: /\b\w+\b(?=\s*\.)/,
        punctuation: /\./
      }
    },
    number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
    operator: /[-+*/%|&]|[<>:=]=?|!=|\b_\b/,
    punctuation: /[,;.\[\]{}()]/
  };
}
wH.displayName = "renpy";
wH.aliases = ["rpy"];
function wH(t) {
  t.languages.renpy = {
    comment: {
      pattern: /(^|[^\\])#.+/,
      lookbehind: !0
    },
    string: {
      pattern: /("""|''')[\s\S]+?\1|("|')(?:\\.|(?!\2)[^\\])*\2|(?:^#?(?:(?:[0-9a-fA-F]){3}|[0-9a-fA-F]{6})$)/m,
      greedy: !0
    },
    function: /\b[a-z_]\w*(?=\()/i,
    property: /\b(?:Update|UpdateVersion|action|activate_sound|adv_nvl_transition|after_load_transition|align|alpha|alt|anchor|antialias|area|auto|background|bar_invert|bar_resizing|bar_vertical|black_color|bold|bottom_bar|bottom_gutter|bottom_margin|bottom_padding|box_reverse|box_wrap|can_update|caret|child|color|crop|default_afm_enable|default_afm_time|default_fullscreen|default_text_cps|developer|directory_name|drag_handle|drag_joined|drag_name|drag_raise|draggable|dragged|drop_shadow|drop_shadow_color|droppable|dropped|easein|easeout|edgescroll|end_game_transition|end_splash_transition|enter_replay_transition|enter_sound|enter_transition|enter_yesno_transition|executable_name|exit_replay_transition|exit_sound|exit_transition|exit_yesno_transition|fadein|fadeout|first_indent|first_spacing|fit_first|focus|focus_mask|font|foreground|game_main_transition|get_installed_packages|google_play_key|google_play_salt|ground|has_music|has_sound|has_voice|height|help|hinting|hover|hover_background|hover_color|hover_sound|hovered|hyperlink_functions|idle|idle_color|image_style|include_update|insensitive|insensitive_background|insensitive_color|inside|intra_transition|italic|justify|kerning|keyboard_focus|language|layer_clipping|layers|layout|left_bar|left_gutter|left_margin|left_padding|length|line_leading|line_overlap_split|line_spacing|linear|main_game_transition|main_menu_music|maximum|min_width|minimum|minwidth|modal|mouse|mousewheel|name|narrator_menu|newline_indent|nvl_adv_transition|offset|order_reverse|outlines|overlay_functions|pos|position|prefix|radius|range|rest_indent|right_bar|right_gutter|right_margin|right_padding|rotate|rotate_pad|ruby_style|sample_sound|save_directory|say_attribute_transition|screen_height|screen_width|scrollbars|selected_hover|selected_hover_color|selected_idle|selected_idle_color|selected_insensitive|show_side_image|show_two_window|side_spacing|side_xpos|side_ypos|size|size_group|slow_cps|slow_cps_multiplier|spacing|strikethrough|subpixel|text_align|text_style|text_xpos|text_y_fudge|text_ypos|thumb|thumb_offset|thumb_shadow|thumbnail_height|thumbnail_width|time|top_bar|top_gutter|top_margin|top_padding|translations|underline|unscrollable|update|value|version|version_name|version_tuple|vertical|width|window_hide_transition|window_icon|window_left_padding|window_show_transition|window_title|windows_icon|xadjustment|xalign|xanchor|xanchoraround|xaround|xcenter|xfill|xinitial|xmargin|xmaximum|xminimum|xoffset|xofsset|xpadding|xpos|xsize|xzoom|yadjustment|yalign|yanchor|yanchoraround|yaround|ycenter|yfill|yinitial|ymargin|ymaximum|yminimum|yoffset|ypadding|ypos|ysize|ysizexysize|yzoom|zoom|zorder)\b/,
    tag: /\b(?:bar|block|button|buttoscreenn|drag|draggroup|fixed|frame|grid|[hv]box|hotbar|hotspot|image|imagebutton|imagemap|input|key|label|menu|mm_menu_frame|mousearea|nvl|parallel|screen|self|side|tag|text|textbutton|timer|vbar|viewport|window)\b|\$/,
    keyword: /\b(?:None|add|adjustment|alignaround|allow|angle|animation|around|as|assert|behind|box_layout|break|build|cache|call|center|changed|child_size|choice|circles|class|clear|clicked|clipping|clockwise|config|contains|continue|corner1|corner2|counterclockwise|def|default|define|del|delay|disabled|disabled_text|dissolve|elif|else|event|except|exclude|exec|expression|fade|finally|for|from|function|global|gm_root|has|hide|id|if|import|in|init|is|jump|knot|lambda|left|less_rounded|mm_root|movie|music|null|on|onlayer|pass|pause|persistent|play|print|python|queue|raise|random|renpy|repeat|return|right|rounded_window|scene|scope|set|show|slow|slow_abortable|slow_done|sound|stop|store|style|style_group|substitute|suffix|theme|transform|transform_anchor|transpose|try|ui|unhovered|updater|use|voice|while|widget|widget_hover|widget_selected|widget_text|yield)\b/,
    boolean: /\b(?:[Ff]alse|[Tt]rue)\b/,
    number: /(?:\b(?:0[bo])?(?:(?:\d|0x[\da-f])[\da-f]*(?:\.\d*)?)|\B\.\d+)(?:e[+-]?\d+)?j?/i,
    operator: /[-+%=]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]|\b(?:and|at|not|or|with)\b/,
    punctuation: /[{}[\];(),.:]/
  }, t.languages.rpy = t.languages.renpy;
}
TH.displayName = "rescript";
TH.aliases = ["res"];
function TH(t) {
  t.languages.rescript = {
    comment: {
      pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
      greedy: !0
    },
    char: {
      pattern: /'(?:[^\r\n\\]|\\(?:.|\w+))'/,
      greedy: !0
    },
    string: {
      pattern: /"(?:\\(?:\r\n|[\s\S])|[^\\\r\n"])*"/,
      greedy: !0
    },
    "class-name": /\b[A-Z]\w*|@[a-z.]*|#[A-Za-z]\w*|#\d/,
    function: {
      pattern: /[a-zA-Z]\w*(?=\()|(\.)[a-z]\w*/,
      lookbehind: !0
    },
    number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i,
    boolean: /\b(?:false|true)\b/,
    "attr-value": /[A-Za-z]\w*(?==)/,
    constant: {
      pattern: /(\btype\s+)[a-z]\w*/,
      lookbehind: !0
    },
    tag: {
      pattern: /(<)[a-z]\w*|(?:<\/)[a-z]\w*/,
      lookbehind: !0,
      inside: {
        operator: /<|>|\//
      }
    },
    keyword: /\b(?:and|as|assert|begin|bool|class|constraint|do|done|downto|else|end|exception|external|float|for|fun|function|if|in|include|inherit|initializer|int|lazy|let|method|module|mutable|new|nonrec|object|of|open|or|private|rec|string|switch|then|to|try|type|when|while|with)\b/,
    operator: /\.{3}|:[:=]?|\|>|->|=(?:==?|>)?|<=?|>=?|[|^?'#!~`]|[+\-*\/]\.?|\b(?:asr|land|lor|lsl|lsr|lxor|mod)\b/,
    punctuation: /[(){}[\],;.]/
  }, t.languages.insertBefore("rescript", "string", {
    "template-string": {
      pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
      greedy: !0,
      inside: {
        "template-punctuation": {
          pattern: /^`|`$/,
          alias: "string"
        },
        interpolation: {
          pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
          lookbehind: !0,
          inside: {
            "interpolation-punctuation": {
              pattern: /^\$\{|\}$/,
              alias: "tag"
            },
            rest: t.languages.rescript
          }
        },
        string: /[\s\S]+/
      }
    }
  }), t.languages.res = t.languages.rescript;
}
_H.displayName = "rest";
_H.aliases = [];
function _H(t) {
  t.languages.rest = {
    table: [
      {
        pattern: /(^[\t ]*)(?:\+[=-]+)+\+(?:\r?\n|\r)(?:\1[+|].+[+|](?:\r?\n|\r))+\1(?:\+[=-]+)+\+/m,
        lookbehind: !0,
        inside: {
          punctuation: /\||(?:\+[=-]+)+\+/
        }
      },
      {
        pattern: /(^[\t ]*)=+ [ =]*=(?:(?:\r?\n|\r)\1.+)+(?:\r?\n|\r)\1=+ [ =]*=(?=(?:\r?\n|\r){2}|\s*$)/m,
        lookbehind: !0,
        inside: {
          punctuation: /[=-]+/
        }
      }
    ],
    // Directive-like patterns
    "substitution-def": {
      pattern: /(^[\t ]*\.\. )\|(?:[^|\s](?:[^|]*[^|\s])?)\| [^:]+::/m,
      lookbehind: !0,
      inside: {
        substitution: {
          pattern: /^\|(?:[^|\s]|[^|\s][^|]*[^|\s])\|/,
          alias: "attr-value",
          inside: {
            punctuation: /^\||\|$/
          }
        },
        directive: {
          pattern: /( )(?! )[^:]+::/,
          lookbehind: !0,
          alias: "function",
          inside: {
            punctuation: /::$/
          }
        }
      }
    },
    "link-target": [
      {
        pattern: /(^[\t ]*\.\. )\[[^\]]+\]/m,
        lookbehind: !0,
        alias: "string",
        inside: {
          punctuation: /^\[|\]$/
        }
      },
      {
        pattern: /(^[\t ]*\.\. )_(?:`[^`]+`|(?:[^:\\]|\\.)+):/m,
        lookbehind: !0,
        alias: "string",
        inside: {
          punctuation: /^_|:$/
        }
      }
    ],
    directive: {
      pattern: /(^[\t ]*\.\. )[^:]+::/m,
      lookbehind: !0,
      alias: "function",
      inside: {
        punctuation: /::$/
      }
    },
    comment: {
      // The two alternatives try to prevent highlighting of blank comments
      pattern: /(^[\t ]*\.\.)(?:(?: .+)?(?:(?:\r?\n|\r).+)+| .+)(?=(?:\r?\n|\r){2}|$)/m,
      lookbehind: !0
    },
    title: [
      // Overlined and underlined
      {
        pattern: /^(([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\2+)(?:\r?\n|\r).+(?:\r?\n|\r)\1$/m,
        inside: {
          punctuation: /^[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]+|[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]+$/,
          important: /.+/
        }
      },
      // Underlined only
      {
        pattern: /(^|(?:\r?\n|\r){2}).+(?:\r?\n|\r)([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\2+(?=\r?\n|\r|$)/,
        lookbehind: !0,
        inside: {
          punctuation: /[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]+$/,
          important: /.+/
        }
      }
    ],
    hr: {
      pattern: /((?:\r?\n|\r){2})([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\2{3,}(?=(?:\r?\n|\r){2})/,
      lookbehind: !0,
      alias: "punctuation"
    },
    field: {
      pattern: /(^[\t ]*):[^:\r\n]+:(?= )/m,
      lookbehind: !0,
      alias: "attr-name"
    },
    "command-line-option": {
      pattern: /(^[\t ]*)(?:[+-][a-z\d]|(?:--|\/)[a-z\d-]+)(?:[ =](?:[a-z][\w-]*|<[^<>]+>))?(?:, (?:[+-][a-z\d]|(?:--|\/)[a-z\d-]+)(?:[ =](?:[a-z][\w-]*|<[^<>]+>))?)*(?=(?:\r?\n|\r)? {2,}\S)/im,
      lookbehind: !0,
      alias: "symbol"
    },
    "literal-block": {
      pattern: /::(?:\r?\n|\r){2}([ \t]+)(?![ \t]).+(?:(?:\r?\n|\r)\1.+)*/,
      inside: {
        "literal-block-punctuation": {
          pattern: /^::/,
          alias: "punctuation"
        }
      }
    },
    "quoted-literal-block": {
      pattern: /::(?:\r?\n|\r){2}([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]).*(?:(?:\r?\n|\r)\1.*)*/,
      inside: {
        "literal-block-punctuation": {
          pattern: /^(?:::|([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\1*)/m,
          alias: "punctuation"
        }
      }
    },
    "list-bullet": {
      pattern: /(^[\t ]*)(?:[*+\-•‣⁃]|\(?(?:\d+|[a-z]|[ivxdclm]+)\)|(?:\d+|[a-z]|[ivxdclm]+)\.)(?= )/im,
      lookbehind: !0,
      alias: "punctuation"
    },
    "doctest-block": {
      pattern: /(^[\t ]*)>>> .+(?:(?:\r?\n|\r).+)*/m,
      lookbehind: !0,
      inside: {
        punctuation: /^>>>/
      }
    },
    inline: [
      {
        pattern: /(^|[\s\-:\/'"<(\[{])(?::[^:]+:`.*?`|`.*?`:[^:]+:|(\*\*?|``?|\|)(?!\s)(?:(?!\2).)*\S\2(?=[\s\-.,:;!?\\\/'")\]}]|$))/m,
        lookbehind: !0,
        inside: {
          bold: {
            pattern: /(^\*\*).+(?=\*\*$)/,
            lookbehind: !0
          },
          italic: {
            pattern: /(^\*).+(?=\*$)/,
            lookbehind: !0
          },
          "inline-literal": {
            pattern: /(^``).+(?=``$)/,
            lookbehind: !0,
            alias: "symbol"
          },
          role: {
            pattern: /^:[^:]+:|:[^:]+:$/,
            alias: "function",
            inside: {
              punctuation: /^:|:$/
            }
          },
          "interpreted-text": {
            pattern: /(^`).+(?=`$)/,
            lookbehind: !0,
            alias: "attr-value"
          },
          substitution: {
            pattern: /(^\|).+(?=\|$)/,
            lookbehind: !0,
            alias: "attr-value"
          },
          punctuation: /\*\*?|``?|\|/
        }
      }
    ],
    link: [
      {
        pattern: /\[[^\[\]]+\]_(?=[\s\-.,:;!?\\\/'")\]}]|$)/,
        alias: "string",
        inside: {
          punctuation: /^\[|\]_$/
        }
      },
      {
        pattern: /(?:\b[a-z\d]+(?:[_.:+][a-z\d]+)*_?_|`[^`]+`_?_|_`[^`]+`)(?=[\s\-.,:;!?\\\/'")\]}]|$)/i,
        alias: "string",
        inside: {
          punctuation: /^_?`|`$|`?_?_$/
        }
      }
    ],
    // Line block start,
    // quote attribution,
    // explicit markup start,
    // and anonymous hyperlink target shortcut (__)
    punctuation: {
      pattern: /(^[\t ]*)(?:\|(?= |$)|(?:---?|—|\.\.|__)(?= )|\.\.$)/m,
      lookbehind: !0
    }
  };
}
CH.displayName = "rip";
CH.aliases = [];
function CH(t) {
  t.languages.rip = {
    comment: {
      pattern: /#.*/,
      greedy: !0
    },
    char: {
      pattern: /\B`[^\s`'",.:;#\/\\()<>\[\]{}]\b/,
      greedy: !0
    },
    string: {
      pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
      greedy: !0
    },
    regex: {
      pattern: /(^|[^/])\/(?!\/)(?:\[[^\n\r\]]*\]|\\.|[^/\\\r\n\[])+\/(?=\s*(?:$|[\r\n,.;})]))/,
      lookbehind: !0,
      greedy: !0
    },
    keyword: /(?:=>|->)|\b(?:case|catch|class|else|exit|finally|if|raise|return|switch|try)\b/,
    builtin: /@|\bSystem\b/,
    boolean: /\b(?:false|true)\b/,
    date: /\b\d{4}-\d{2}-\d{2}\b/,
    time: /\b\d{2}:\d{2}:\d{2}\b/,
    datetime: /\b\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\b/,
    symbol: /:[^\d\s`'",.:;#\/\\()<>\[\]{}][^\s`'",.:;#\/\\()<>\[\]{}]*/,
    number: /[+-]?\b(?:\d+\.\d+|\d+)\b/,
    punctuation: /(?:\.{2,3})|[`,.:;=\/\\()<>\[\]{}]/,
    reference: /[^\d\s`'",.:;#\/\\()<>\[\]{}][^\s`'",.:;#\/\\()<>\[\]{}]*/
  };
}
xH.displayName = "roboconf";
xH.aliases = [];
function xH(t) {
  t.languages.roboconf = {
    comment: /#.*/,
    keyword: {
      pattern: /(^|\s)(?:(?:external|import)\b|(?:facet|instance of)(?=[ \t]+[\w-]+[ \t]*\{))/,
      lookbehind: !0
    },
    component: {
      pattern: /[\w-]+(?=[ \t]*\{)/,
      alias: "variable"
    },
    property: /[\w.-]+(?=[ \t]*:)/,
    value: {
      pattern: /(=[ \t]*(?![ \t]))[^,;]+/,
      lookbehind: !0,
      alias: "attr-value"
    },
    optional: {
      pattern: /\(optional\)/,
      alias: "builtin"
    },
    wildcard: {
      pattern: /(\.)\*/,
      lookbehind: !0,
      alias: "operator"
    },
    punctuation: /[{},.;:=]/
  };
}
AH.displayName = "robotframework";
AH.aliases = ["robot"];
function AH(t) {
  (function(e) {
    var n = {
      pattern: /(^[ \t]*| {2}|\t)#.*/m,
      lookbehind: !0,
      greedy: !0
    }, r = {
      pattern: /((?:^|[^\\])(?:\\{2})*)[$@&%]\{(?:[^{}\r\n]|\{[^{}\r\n]*\})*\}/,
      lookbehind: !0,
      inside: {
        punctuation: /^[$@&%]\{|\}$/
      }
    };
    function a(u, f) {
      var p = {};
      p["section-header"] = {
        pattern: /^ ?\*{3}.+?\*{3}/,
        alias: "keyword"
      };
      for (var m in f)
        p[m] = f[m];
      return p.tag = {
        pattern: /([\r\n](?: {2}|\t)[ \t]*)\[[-\w]+\]/,
        lookbehind: !0,
        inside: {
          punctuation: /\[|\]/
        }
      }, p.variable = r, p.comment = n, {
        pattern: RegExp(
          /^ ?\*{3}[ \t]*<name>[ \t]*\*{3}(?:.|[\r\n](?!\*{3}))*/.source.replace(
            /<name>/g,
            function() {
              return u;
            }
          ),
          "im"
        ),
        alias: "section",
        inside: p
      };
    }
    var i = {
      pattern: /(\[Documentation\](?: {2}|\t)[ \t]*)(?![ \t]|#)(?:.|(?:\r\n?|\n)[ \t]*\.{3})+/,
      lookbehind: !0,
      alias: "string"
    }, o = {
      pattern: /([\r\n] ?)(?!#)(?:\S(?:[ \t]\S)*)+/,
      lookbehind: !0,
      alias: "function",
      inside: {
        variable: r
      }
    }, s = {
      pattern: /([\r\n](?: {2}|\t)[ \t]*)(?!\[|\.{3}|#)(?:\S(?:[ \t]\S)*)+/,
      lookbehind: !0,
      inside: {
        variable: r
      }
    };
    e.languages.robotframework = {
      settings: a("Settings", {
        documentation: {
          pattern: /([\r\n] ?Documentation(?: {2}|\t)[ \t]*)(?![ \t]|#)(?:.|(?:\r\n?|\n)[ \t]*\.{3})+/,
          lookbehind: !0,
          alias: "string"
        },
        property: {
          pattern: /([\r\n] ?)(?!\.{3}|#)(?:\S(?:[ \t]\S)*)+/,
          lookbehind: !0
        }
      }),
      variables: a("Variables"),
      "test-cases": a("Test Cases", {
        "test-name": o,
        documentation: i,
        property: s
      }),
      keywords: a("Keywords", {
        "keyword-name": o,
        documentation: i,
        property: s
      }),
      tasks: a("Tasks", {
        "task-name": o,
        documentation: i,
        property: s
      }),
      comment: n
    }, e.languages.robot = e.languages.robotframework;
  })(t);
}
kH.displayName = "sas";
kH.aliases = [];
function kH(t) {
  (function(e) {
    var n = /(?:"(?:""|[^"])*"(?!")|'(?:''|[^'])*'(?!'))/.source, r = /\b(?:\d[\da-f]*x|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/i, a = {
      pattern: RegExp(n + "[bx]"),
      alias: "number"
    }, i = {
      pattern: /&[a-z_]\w*/i
    }, o = {
      pattern: /((?:^|\s|=|\())%(?:ABORT|BY|CMS|COPY|DISPLAY|DO|ELSE|END|EVAL|GLOBAL|GO|GOTO|IF|INC|INCLUDE|INDEX|INPUT|KTRIM|LENGTH|LET|LIST|LOCAL|PUT|QKTRIM|QSCAN|QSUBSTR|QSYSFUNC|QUPCASE|RETURN|RUN|SCAN|SUBSTR|SUPERQ|SYMDEL|SYMEXIST|SYMGLOBL|SYMLOCAL|SYSCALL|SYSEVALF|SYSEXEC|SYSFUNC|SYSGET|SYSRPUT|THEN|TO|TSO|UNQUOTE|UNTIL|UPCASE|WHILE|WINDOW)\b/i,
      lookbehind: !0,
      alias: "keyword"
    }, s = {
      pattern: /(^|\s)(?:proc\s+\w+|data(?!=)|quit|run)\b/i,
      alias: "keyword",
      lookbehind: !0
    }, u = [
      /\/\*[\s\S]*?\*\//,
      {
        pattern: /(^[ \t]*|;\s*)\*[^;]*;/m,
        lookbehind: !0
      }
    ], f = {
      pattern: RegExp(n),
      greedy: !0
    }, p = /[$%@.(){}\[\];,\\]/, m = {
      pattern: /%?\b\w+(?=\()/,
      alias: "keyword"
    }, v = {
      function: m,
      "arg-value": {
        pattern: /(=\s*)[A-Z\.]+/i,
        lookbehind: !0
      },
      operator: /=/,
      "macro-variable": i,
      arg: {
        pattern: /[A-Z]+/i,
        alias: "keyword"
      },
      number: r,
      "numeric-constant": a,
      punctuation: p,
      string: f
    }, O = {
      pattern: /\b(?:format|put)\b=?[\w'$.]+/i,
      inside: {
        keyword: /^(?:format|put)(?==)/i,
        equals: /=/,
        format: {
          pattern: /(?:\w|\$\d)+\.\d?/,
          alias: "number"
        }
      }
    }, w = {
      pattern: /\b(?:format|put)\s+[\w']+(?:\s+[$.\w]+)+(?=;)/i,
      inside: {
        keyword: /^(?:format|put)/i,
        format: {
          pattern: /[\w$]+\.\d?/,
          alias: "number"
        }
      }
    }, _ = {
      pattern: /((?:^|\s)=?)(?:catname|checkpoint execute_always|dm|endsas|filename|footnote|%include|libname|%list|lock|missing|options|page|resetline|%run|sasfile|skip|sysecho|title\d?)\b/i,
      lookbehind: !0,
      alias: "keyword"
    }, C = {
      pattern: /(^|\s)(?:submit(?:\s+(?:load|norun|parseonly))?|endsubmit)\b/i,
      lookbehind: !0,
      alias: "keyword"
    }, A = /aStore|accessControl|aggregation|audio|autotune|bayesianNetClassifier|bioMedImage|boolRule|builtins|cardinality|cdm|clustering|conditionalRandomFields|configuration|copula|countreg|dataDiscovery|dataPreprocess|dataSciencePilot|dataStep|decisionTree|deduplication|deepLearn|deepNeural|deepRnn|ds2|ecm|entityRes|espCluster|explainModel|factmac|fastKnn|fcmpact|fedSql|freqTab|gVarCluster|gam|gleam|graphSemiSupLearn|hiddenMarkovModel|hyperGroup|ica|image|iml|kernalPca|langModel|ldaTopic|loadStreams|mbc|mixed|mlTools|modelPublishing|network|neuralNet|nmf|nonParametricBayes|nonlinear|optNetwork|optimization|panel|pca|percentile|phreg|pls|qkb|qlim|quantreg|recommend|regression|reinforcementLearn|robustPca|ruleMining|sampling|sandwich|sccasl|search(?:Analytics)?|sentimentAnalysis|sequence|session(?:Prop)?|severity|simSystem|simple|smartData|sparkEmbeddedProcess|sparseML|spatialreg|spc|stabilityMonitoring|svDataDescription|svm|table|text(?:Filters|Frequency|Mining|Parse|Rule(?:Develop|Score)|Topic|Util)|timeData|transpose|tsInfo|tsReconcile|uniTimeSeries|varReduce/.source, N = {
      pattern: RegExp(
        /(^|\s)(?:action\s+)?(?:<act>)\.[a-z]+\b[^;]+/.source.replace(
          /<act>/g,
          function() {
            return A;
          }
        ),
        "i"
      ),
      lookbehind: !0,
      inside: {
        keyword: RegExp(
          /(?:<act>)\.[a-z]+\b/.source.replace(/<act>/g, function() {
            return A;
          }),
          "i"
        ),
        action: {
          pattern: /(?:action)/i,
          alias: "keyword"
        },
        comment: u,
        function: m,
        "arg-value": v["arg-value"],
        operator: v.operator,
        argument: v.arg,
        number: r,
        "numeric-constant": a,
        punctuation: p,
        string: f
      }
    }, P = {
      pattern: /((?:^|\s)=?)(?:after|analysis|and|array|barchart|barwidth|begingraph|by|call|cas|cbarline|cfill|class(?:lev)?|close|column|computed?|contains|continue|data(?==)|define|delete|describe|document|do\s+over|do|dol|drop|dul|else|end(?:comp|source)?|entryTitle|eval(?:uate)?|exec(?:ute)?|exit|file(?:name)?|fill(?:attrs)?|flist|fnc|function(?:list)?|global|goto|group(?:by)?|headline|headskip|histogram|if|infile|keep|keylabel|keyword|label|layout|leave|legendlabel|length|libname|loadactionset|merge|midpoints|_?null_|name|noobs|nowd|ods|options|or|otherwise|out(?:put)?|over(?:lay)?|plot|print|put|raise|ranexp|rannor|rbreak|retain|return|select|session|sessref|set|source|statgraph|sum|summarize|table|temp|terminate|then\s+do|then|title\d?|to|var|when|where|xaxisopts|y2axisopts|yaxisopts)\b/i,
      lookbehind: !0
    };
    e.languages.sas = {
      datalines: {
        pattern: /^([ \t]*)(?:cards|(?:data)?lines);[\s\S]+?^[ \t]*;/im,
        lookbehind: !0,
        alias: "string",
        inside: {
          keyword: {
            pattern: /^(?:cards|(?:data)?lines)/i
          },
          punctuation: /;/
        }
      },
      "proc-sql": {
        pattern: /(^proc\s+(?:fed)?sql(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|data|quit|run);|(?![\s\S]))/im,
        lookbehind: !0,
        inside: {
          sql: {
            pattern: RegExp(
              /^[ \t]*(?:select|alter\s+table|(?:create|describe|drop)\s+(?:index|table(?:\s+constraints)?|view)|create\s+unique\s+index|insert\s+into|update)(?:<str>|[^;"'])+;/.source.replace(
                /<str>/g,
                function() {
                  return n;
                }
              ),
              "im"
            ),
            alias: "language-sql",
            inside: e.languages.sql
          },
          "global-statements": _,
          "sql-statements": {
            pattern: /(^|\s)(?:disconnect\s+from|begin|commit|exec(?:ute)?|reset|rollback|validate)\b/i,
            lookbehind: !0,
            alias: "keyword"
          },
          number: r,
          "numeric-constant": a,
          punctuation: p,
          string: f
        }
      },
      "proc-groovy": {
        pattern: /(^proc\s+groovy(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|data|quit|run);|(?![\s\S]))/im,
        lookbehind: !0,
        inside: {
          comment: u,
          groovy: {
            pattern: RegExp(
              /(^[ \t]*submit(?:\s+(?:load|norun|parseonly))?)(?:<str>|[^"'])+?(?=endsubmit;)/.source.replace(
                /<str>/g,
                function() {
                  return n;
                }
              ),
              "im"
            ),
            lookbehind: !0,
            alias: "language-groovy",
            inside: e.languages.groovy
          },
          keyword: P,
          "submit-statement": C,
          "global-statements": _,
          number: r,
          "numeric-constant": a,
          punctuation: p,
          string: f
        }
      },
      "proc-lua": {
        pattern: /(^proc\s+lua(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|data|quit|run);|(?![\s\S]))/im,
        lookbehind: !0,
        inside: {
          comment: u,
          lua: {
            pattern: RegExp(
              /(^[ \t]*submit(?:\s+(?:load|norun|parseonly))?)(?:<str>|[^"'])+?(?=endsubmit;)/.source.replace(
                /<str>/g,
                function() {
                  return n;
                }
              ),
              "im"
            ),
            lookbehind: !0,
            alias: "language-lua",
            inside: e.languages.lua
          },
          keyword: P,
          "submit-statement": C,
          "global-statements": _,
          number: r,
          "numeric-constant": a,
          punctuation: p,
          string: f
        }
      },
      "proc-cas": {
        pattern: /(^proc\s+cas(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|quit|data);|(?![\s\S]))/im,
        lookbehind: !0,
        inside: {
          comment: u,
          "statement-var": {
            pattern: /((?:^|\s)=?)saveresult\s[^;]+/im,
            lookbehind: !0,
            inside: {
              statement: {
                pattern: /^saveresult\s+\S+/i,
                inside: {
                  keyword: /^(?:saveresult)/i
                }
              },
              rest: v
            }
          },
          "cas-actions": N,
          statement: {
            pattern: /((?:^|\s)=?)(?:default|(?:un)?set|on|output|upload)[^;]+/im,
            lookbehind: !0,
            inside: v
          },
          step: s,
          keyword: P,
          function: m,
          format: O,
          altformat: w,
          "global-statements": _,
          number: r,
          "numeric-constant": a,
          punctuation: p,
          string: f
        }
      },
      "proc-args": {
        pattern: RegExp(
          /(^proc\s+\w+\s+)(?!\s)(?:[^;"']|<str>)+;/.source.replace(
            /<str>/g,
            function() {
              return n;
            }
          ),
          "im"
        ),
        lookbehind: !0,
        inside: v
      },
      /*Special keywords within macros*/
      "macro-keyword": o,
      "macro-variable": i,
      "macro-string-functions": {
        pattern: /((?:^|\s|=))%(?:BQUOTE|NRBQUOTE|NRQUOTE|NRSTR|QUOTE|STR)\(.*?(?:[^%]\))/i,
        lookbehind: !0,
        inside: {
          function: {
            pattern: /%(?:BQUOTE|NRBQUOTE|NRQUOTE|NRSTR|QUOTE|STR)/i,
            alias: "keyword"
          },
          "macro-keyword": o,
          "macro-variable": i,
          "escaped-char": {
            pattern: /%['"()<>=¬^~;,#]/
          },
          punctuation: p
        }
      },
      "macro-declaration": {
        pattern: /^%macro[^;]+(?=;)/im,
        inside: {
          keyword: /%macro/i
        }
      },
      "macro-end": {
        pattern: /^%mend[^;]+(?=;)/im,
        inside: {
          keyword: /%mend/i
        }
      },
      /*%_zscore(headcir, _lhc, _mhc, _shc, headcz, headcpct, _Fheadcz); */
      macro: {
        pattern: /%_\w+(?=\()/,
        alias: "keyword"
      },
      input: {
        pattern: /\binput\s[-\w\s/*.$&]+;/i,
        inside: {
          input: {
            alias: "keyword",
            pattern: /^input/i
          },
          comment: u,
          number: r,
          "numeric-constant": a
        }
      },
      "options-args": {
        pattern: /(^options)[-'"|/\\<>*+=:()\w\s]*(?=;)/im,
        lookbehind: !0,
        inside: v
      },
      "cas-actions": N,
      comment: u,
      function: m,
      format: O,
      altformat: w,
      "numeric-constant": a,
      datetime: {
        // '1jan2013'd, '9:25:19pm't, '18jan2003:9:27:05am'dt
        pattern: RegExp(n + "(?:dt?|t)"),
        alias: "number"
      },
      string: f,
      step: s,
      keyword: P,
      // In SAS Studio syntax highlighting, these operators are styled like keywords
      "operator-keyword": {
        pattern: /\b(?:eq|ge|gt|in|le|lt|ne|not)\b/i,
        alias: "operator"
      },
      // Decimal (1.2e23), hexadecimal (0c1x)
      number: r,
      operator: /\*\*?|\|\|?|!!?|¦¦?|<[>=]?|>[<=]?|[-+\/=&]|[~¬^]=?/,
      punctuation: p
    };
  })(t);
}
RH.displayName = "shell-session";
RH.aliases = ["sh-session", "shellsession"];
function RH(t) {
  t.register(x_), function(e) {
    var n = [
      // normal string
      /"(?:\\[\s\S]|\$\([^)]+\)|\$(?!\()|`[^`]+`|[^"\\`$])*"/.source,
      /'[^']*'/.source,
      /\$'(?:[^'\\]|\\[\s\S])*'/.source,
      // here doc
      // 2 capturing groups
      /<<-?\s*(["']?)(\w+)\1\s[\s\S]*?[\r\n]\2/.source
    ].join("|");
    e.languages["shell-session"] = {
      command: {
        pattern: RegExp(
          // user info
          /^/.source + "(?:" + // <user> ":" ( <path> )?
          (/[^\s@:$#%*!/\\]+@[^\r\n@:$#%*!/\\]+(?::[^\0-\x1F$#%*?"<>:;|]+)?/.source + "|" + // <path>
          // Since the path pattern is quite general, we will require it to start with a special character to
          // prevent false positives.
          /[/~.][^\0-\x1F$#%*?"<>@:;|]*/.source) + ")?" + // shell symbol
          /[$#%](?=\s)/.source + // bash command
          /(?:[^\\\r\n \t'"<$]|[ \t](?:(?!#)|#.*$)|\\(?:[^\r]|\r\n?)|\$(?!')|<(?!<)|<<str>>)+/.source.replace(
            /<<str>>/g,
            function() {
              return n;
            }
          ),
          "m"
        ),
        greedy: !0,
        inside: {
          info: {
            // foo@bar:~/files$ exit
            // foo@bar$ exit
            // ~/files$ exit
            pattern: /^[^#$%]+/,
            alias: "punctuation",
            inside: {
              user: /^[^\s@:$#%*!/\\]+@[^\r\n@:$#%*!/\\]+/,
              punctuation: /:/,
              path: /[\s\S]+/
            }
          },
          bash: {
            pattern: /(^[$#%]\s*)\S[\s\S]*/,
            lookbehind: !0,
            alias: "language-bash",
            inside: e.languages.bash
          },
          "shell-symbol": {
            pattern: /^[$#%]/,
            alias: "important"
          }
        }
      },
      output: /.(?:.*(?:[\r\n]|.$))*/
    }, e.languages["sh-session"] = e.languages.shellsession = e.languages["shell-session"];
  }(t);
}
IH.displayName = "smali";
IH.aliases = [];
function IH(t) {
  t.languages.smali = {
    comment: /#.*/,
    string: {
      pattern: /"(?:[^\r\n\\"]|\\.)*"|'(?:[^\r\n\\']|\\(?:.|u[\da-fA-F]{4}))'/,
      greedy: !0
    },
    "class-name": {
      pattern: /(^|[^L])L(?:(?:\w+|`[^`\r\n]*`)\/)*(?:[\w$]+|`[^`\r\n]*`)(?=\s*;)/,
      lookbehind: !0,
      inside: {
        "class-name": {
          pattern: /(^L|\/)(?:[\w$]+|`[^`\r\n]*`)$/,
          lookbehind: !0
        },
        namespace: {
          pattern: /^(L)(?:(?:\w+|`[^`\r\n]*`)\/)+/,
          lookbehind: !0,
          inside: {
            punctuation: /\//
          }
        },
        builtin: /^L/
      }
    },
    builtin: [
      {
        // Reference: https://github.com/JesusFreke/smali/wiki/TypesMethodsAndFields#types
        pattern: /([();\[])[BCDFIJSVZ]+/,
        lookbehind: !0
      },
      {
        // e.g. .field mWifiOnUid:I
        pattern: /([\w$>]:)[BCDFIJSVZ]/,
        lookbehind: !0
      }
    ],
    keyword: [
      {
        pattern: /(\.end\s+)[\w-]+/,
        lookbehind: !0
      },
      {
        pattern: /(^|[^\w.-])\.(?!\d)[\w-]+/,
        lookbehind: !0
      },
      {
        pattern: /(^|[^\w.-])(?:abstract|annotation|bridge|constructor|enum|final|interface|private|protected|public|runtime|static|synthetic|system|transient)(?![\w.-])/,
        lookbehind: !0
      }
    ],
    function: {
      pattern: /(^|[^\w.-])(?:\w+|<[\w$-]+>)(?=\()/,
      lookbehind: !0
    },
    field: {
      pattern: /[\w$]+(?=:)/,
      alias: "variable"
    },
    register: {
      pattern: /(^|[^\w.-])[vp]\d(?![\w.-])/,
      lookbehind: !0,
      alias: "variable"
    },
    boolean: {
      pattern: /(^|[^\w.-])(?:false|true)(?![\w.-])/,
      lookbehind: !0
    },
    number: {
      pattern: /(^|[^/\w.-])-?(?:NAN|INFINITY|0x(?:[\dA-F]+(?:\.[\dA-F]*)?|\.[\dA-F]+)(?:p[+-]?[\dA-F]+)?|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?)[dflst]?(?![\w.-])/i,
      lookbehind: !0
    },
    label: {
      pattern: /(:)\w+/,
      lookbehind: !0,
      alias: "property"
    },
    operator: /->|\.\.|[\[=]/,
    punctuation: /[{}(),;:]/
  };
}
DH.displayName = "smalltalk";
DH.aliases = [];
function DH(t) {
  t.languages.smalltalk = {
    comment: {
      pattern: /"(?:""|[^"])*"/,
      greedy: !0
    },
    char: {
      pattern: /\$./,
      greedy: !0
    },
    string: {
      pattern: /'(?:''|[^'])*'/,
      greedy: !0
    },
    symbol: /#[\da-z]+|#(?:-|([+\/\\*~<>=@%|&?!])\1?)|#(?=\()/i,
    "block-arguments": {
      pattern: /(\[\s*):[^\[|]*\|/,
      lookbehind: !0,
      inside: {
        variable: /:[\da-z]+/i,
        punctuation: /\|/
      }
    },
    "temporary-variables": {
      pattern: /\|[^|]+\|/,
      inside: {
        variable: /[\da-z]+/i,
        punctuation: /\|/
      }
    },
    keyword: /\b(?:new|nil|self|super)\b/,
    boolean: /\b(?:false|true)\b/,
    number: [
      /\d+r-?[\dA-Z]+(?:\.[\dA-Z]+)?(?:e-?\d+)?/,
      /\b\d+(?:\.\d+)?(?:e-?\d+)?/
    ],
    operator: /[<=]=?|:=|~[~=]|\/\/?|\\\\|>[>=]?|[!^+\-*&|,@]/,
    punctuation: /[.;:?\[\](){}]/
  };
}
NH.displayName = "smarty";
NH.aliases = [];
function NH(t) {
  t.register(al), function(e) {
    e.languages.smarty = {
      comment: {
        pattern: /^\{\*[\s\S]*?\*\}/,
        greedy: !0
      },
      "embedded-php": {
        pattern: /^\{php\}[\s\S]*?\{\/php\}/,
        greedy: !0,
        inside: {
          smarty: {
            pattern: /^\{php\}|\{\/php\}$/,
            inside: null
            // see below
          },
          php: {
            pattern: /[\s\S]+/,
            alias: "language-php",
            inside: e.languages.php
          }
        }
      },
      string: [
        {
          pattern: /"(?:\\.|[^"\\\r\n])*"/,
          greedy: !0,
          inside: {
            interpolation: {
              pattern: /\{[^{}]*\}|`[^`]*`/,
              inside: {
                "interpolation-punctuation": {
                  pattern: /^[{`]|[`}]$/,
                  alias: "punctuation"
                },
                expression: {
                  pattern: /[\s\S]+/,
                  inside: null
                  // see below
                }
              }
            },
            variable: /\$\w+/
          }
        },
        {
          pattern: /'(?:\\.|[^'\\\r\n])*'/,
          greedy: !0
        }
      ],
      keyword: {
        pattern: /(^\{\/?)[a-z_]\w*\b(?!\()/i,
        lookbehind: !0,
        greedy: !0
      },
      delimiter: {
        pattern: /^\{\/?|\}$/,
        greedy: !0,
        alias: "punctuation"
      },
      number: /\b0x[\dA-Fa-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][-+]?\d+)?/,
      variable: [
        /\$(?!\d)\w+/,
        /#(?!\d)\w+#/,
        {
          pattern: /(\.|->|\w\s*=)(?!\d)\w+\b(?!\()/,
          lookbehind: !0
        },
        {
          pattern: /(\[)(?!\d)\w+(?=\])/,
          lookbehind: !0
        }
      ],
      function: {
        pattern: /(\|\s*)@?[a-z_]\w*|\b[a-z_]\w*(?=\()/i,
        lookbehind: !0
      },
      "attr-name": /\b[a-z_]\w*(?=\s*=)/i,
      boolean: /\b(?:false|no|off|on|true|yes)\b/,
      punctuation: /[\[\](){}.,:`]|->/,
      operator: [
        /[+\-*\/%]|==?=?|[!<>]=?|&&|\|\|?/,
        /\bis\s+(?:not\s+)?(?:div|even|odd)(?:\s+by)?\b/,
        /\b(?:and|eq|gt?e|gt|lt?e|lt|mod|neq?|not|or)\b/
      ]
    }, e.languages.smarty["embedded-php"].inside.smarty.inside = e.languages.smarty, e.languages.smarty.string[0].inside.interpolation.inside.expression.inside = e.languages.smarty;
    var n = /"(?:\\.|[^"\\\r\n])*"|'(?:\\.|[^'\\\r\n])*'/, r = RegExp(
      // comments
      /\{\*[\s\S]*?\*\}/.source + "|" + // php tags
      /\{php\}[\s\S]*?\{\/php\}/.source + "|" + // smarty blocks
      /\{(?:[^{}"']|<str>|\{(?:[^{}"']|<str>|\{(?:[^{}"']|<str>)*\})*\})*\}/.source.replace(
        /<str>/g,
        function() {
          return n.source;
        }
      ),
      "g"
    );
    e.hooks.add("before-tokenize", function(a) {
      var i = "{literal}", o = "{/literal}", s = !1;
      e.languages["markup-templating"].buildPlaceholders(
        a,
        "smarty",
        r,
        function(u) {
          return u === o && (s = !1), s ? !1 : (u === i && (s = !0), !0);
        }
      );
    }), e.hooks.add("after-tokenize", function(a) {
      e.languages["markup-templating"].tokenizePlaceholders(a, "smarty");
    });
  }(t);
}
PH.displayName = "sml";
PH.aliases = ["smlnj"];
function PH(t) {
  (function(e) {
    var n = /\b(?:abstype|and|andalso|as|case|datatype|do|else|end|eqtype|exception|fn|fun|functor|handle|if|in|include|infix|infixr|let|local|nonfix|of|op|open|orelse|raise|rec|sharing|sig|signature|struct|structure|then|type|val|where|while|with|withtype)\b/i;
    e.languages.sml = {
      // allow one level of nesting
      comment: /\(\*(?:[^*(]|\*(?!\))|\((?!\*)|\(\*(?:[^*(]|\*(?!\))|\((?!\*))*\*\))*\*\)/,
      string: {
        pattern: /#?"(?:[^"\\]|\\.)*"/,
        greedy: !0
      },
      "class-name": [
        {
          // This is only an approximation since the real grammar is context-free
          //
          // Why the main loop so complex?
          // The main loop is approximately the same as /(?:\s*(?:[*,]|->)\s*<TERMINAL>)*/ which is, obviously, a lot
          // simpler. The difference is that if a comma is the last iteration of the loop, then the terminal must be
          // followed by a long identifier.
          pattern: RegExp(
            /((?:^|[^:]):\s*)<TERMINAL>(?:\s*(?:(?:\*|->)\s*<TERMINAL>|,\s*<TERMINAL>(?:(?=<NOT-LAST>)|(?!<NOT-LAST>)\s+<LONG-ID>)))*/.source.replace(/<NOT-LAST>/g, function() {
              return /\s*(?:[*,]|->)/.source;
            }).replace(/<TERMINAL>/g, function() {
              return /(?:'[\w']*|<LONG-ID>|\((?:[^()]|\([^()]*\))*\)|\{(?:[^{}]|\{[^{}]*\})*\})(?:\s+<LONG-ID>)*/.source;
            }).replace(/<LONG-ID>/g, function() {
              return /(?!<KEYWORD>)[a-z\d_][\w'.]*/.source;
            }).replace(/<KEYWORD>/g, function() {
              return n.source;
            }),
            "i"
          ),
          lookbehind: !0,
          greedy: !0,
          inside: null
          // see below
        },
        {
          pattern: /((?:^|[^\w'])(?:datatype|exception|functor|signature|structure|type)\s+)[a-z_][\w'.]*/i,
          lookbehind: !0
        }
      ],
      function: {
        pattern: /((?:^|[^\w'])fun\s+)[a-z_][\w'.]*/i,
        lookbehind: !0
      },
      keyword: n,
      variable: {
        pattern: /(^|[^\w'])'[\w']*/,
        lookbehind: !0
      },
      number: /~?\b(?:\d+(?:\.\d+)?(?:e~?\d+)?|0x[\da-f]+)\b/i,
      word: {
        pattern: /\b0w(?:\d+|x[\da-f]+)\b/i,
        alias: "constant"
      },
      boolean: /\b(?:false|true)\b/i,
      operator: /\.\.\.|:[>=:]|=>?|->|[<>]=?|[!+\-*/^#|@~]/,
      punctuation: /[(){}\[\].:,;]/
    }, e.languages.sml["class-name"][0].inside = e.languages.sml, e.languages.smlnj = e.languages.sml;
  })(t);
}
LH.displayName = "solidity";
LH.aliases = ["sol"];
function LH(t) {
  t.register(Lr), t.languages.solidity = t.languages.extend("clike", {
    "class-name": {
      pattern: /(\b(?:contract|enum|interface|library|new|struct|using)\s+)(?!\d)[\w$]+/,
      lookbehind: !0
    },
    keyword: /\b(?:_|anonymous|as|assembly|assert|break|calldata|case|constant|constructor|continue|contract|default|delete|do|else|emit|enum|event|external|for|from|function|if|import|indexed|inherited|interface|internal|is|let|library|mapping|memory|modifier|new|payable|pragma|private|public|pure|require|returns?|revert|selfdestruct|solidity|storage|struct|suicide|switch|this|throw|using|var|view|while)\b/,
    operator: /=>|->|:=|=:|\*\*|\+\+|--|\|\||&&|<<=?|>>=?|[-+*/%^&|<>!=]=?|[~?]/
  }), t.languages.insertBefore("solidity", "keyword", {
    builtin: /\b(?:address|bool|byte|u?int(?:8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?|string|bytes(?:[1-9]|[12]\d|3[0-2])?)\b/
  }), t.languages.insertBefore("solidity", "number", {
    version: {
      pattern: /([<>]=?|\^)\d+\.\d+\.\d+\b/,
      lookbehind: !0,
      alias: "number"
    }
  }), t.languages.sol = t.languages.solidity;
}
MH.displayName = "solution-file";
MH.aliases = ["sln"];
function MH(t) {
  (function(e) {
    var n = {
      // https://en.wikipedia.org/wiki/Universally_unique_identifier#Format
      pattern: /\{[\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12}\}/i,
      alias: "constant",
      inside: {
        punctuation: /[{}]/
      }
    };
    e.languages["solution-file"] = {
      comment: {
        pattern: /#.*/,
        greedy: !0
      },
      string: {
        pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
        greedy: !0,
        inside: {
          guid: n
        }
      },
      object: {
        // Foo
        //   Bar("abs") = 9
        //   EndBar
        //   Prop = TRUE
        // EndFoo
        pattern: /^([ \t]*)(?:([A-Z]\w*)\b(?=.*(?:\r\n?|\n)(?:\1[ \t].*(?:\r\n?|\n))*\1End\2(?=[ \t]*$))|End[A-Z]\w*(?=[ \t]*$))/m,
        lookbehind: !0,
        greedy: !0,
        alias: "keyword"
      },
      property: {
        pattern: /^([ \t]*)(?!\s)[^\r\n"#=()]*[^\s"#=()](?=\s*=)/m,
        lookbehind: !0,
        inside: {
          guid: n
        }
      },
      guid: n,
      number: /\b\d+(?:\.\d+)*\b/,
      boolean: /\b(?:FALSE|TRUE)\b/,
      operator: /=/,
      punctuation: /[(),]/
    }, e.languages.sln = e.languages["solution-file"];
  })(t);
}
FH.displayName = "soy";
FH.aliases = [];
function FH(t) {
  t.register(al), function(e) {
    var n = /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/, r = /\b\d+(?:\.\d+)?(?:[eE][+-]?\d+)?\b|\b0x[\dA-F]+\b/;
    e.languages.soy = {
      comment: [
        /\/\*[\s\S]*?\*\//,
        {
          pattern: /(\s)\/\/.*/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      "command-arg": {
        pattern: /(\{+\/?\s*(?:alias|call|delcall|delpackage|deltemplate|namespace|template)\s+)\.?[\w.]+/,
        lookbehind: !0,
        alias: "string",
        inside: {
          punctuation: /\./
        }
      },
      parameter: {
        pattern: /(\{+\/?\s*@?param\??\s+)\.?[\w.]+/,
        lookbehind: !0,
        alias: "variable"
      },
      keyword: [
        {
          pattern: /(\{+\/?[^\S\r\n]*)(?:\\[nrt]|alias|call|case|css|default|delcall|delpackage|deltemplate|else(?:if)?|fallbackmsg|for(?:each)?|if(?:empty)?|lb|let|literal|msg|namespace|nil|@?param\??|rb|sp|switch|template|xid)/,
          lookbehind: !0
        },
        /\b(?:any|as|attributes|bool|css|float|html|in|int|js|list|map|null|number|string|uri)\b/
      ],
      delimiter: {
        pattern: /^\{+\/?|\/?\}+$/,
        alias: "punctuation"
      },
      property: /\w+(?==)/,
      variable: {
        pattern: /\$[^\W\d]\w*(?:\??(?:\.\w+|\[[^\]]+\]))*/,
        inside: {
          string: {
            pattern: n,
            greedy: !0
          },
          number: r,
          punctuation: /[\[\].?]/
        }
      },
      string: {
        pattern: n,
        greedy: !0
      },
      function: [
        /\w+(?=\()/,
        {
          pattern: /(\|[^\S\r\n]*)\w+/,
          lookbehind: !0
        }
      ],
      boolean: /\b(?:false|true)\b/,
      number: r,
      operator: /\?:?|<=?|>=?|==?|!=|[+*/%-]|\b(?:and|not|or)\b/,
      punctuation: /[{}()\[\]|.,:]/
    }, e.hooks.add("before-tokenize", function(a) {
      var i = /\{\{.+?\}\}|\{.+?\}|\s\/\/.*|\/\*[\s\S]*?\*\//g, o = "{literal}", s = "{/literal}", u = !1;
      e.languages["markup-templating"].buildPlaceholders(
        a,
        "soy",
        i,
        function(f) {
          return f === s && (u = !1), u ? !1 : (f === o && (u = !0), !0);
        }
      );
    }), e.hooks.add("after-tokenize", function(a) {
      e.languages["markup-templating"].tokenizePlaceholders(a, "soy");
    });
  }(t);
}
KD.displayName = "turtle";
KD.aliases = ["trig"];
function KD(t) {
  t.languages.turtle = {
    comment: {
      pattern: /#.*/,
      greedy: !0
    },
    "multiline-string": {
      pattern: /"""(?:(?:""?)?(?:[^"\\]|\\.))*"""|'''(?:(?:''?)?(?:[^'\\]|\\.))*'''/,
      greedy: !0,
      alias: "string",
      inside: {
        comment: /#.*/
      }
    },
    string: {
      pattern: /"(?:[^\\"\r\n]|\\.)*"|'(?:[^\\'\r\n]|\\.)*'/,
      greedy: !0
    },
    url: {
      pattern: /<(?:[^\x00-\x20<>"{}|^`\\]|\\(?:u[\da-fA-F]{4}|U[\da-fA-F]{8}))*>/,
      greedy: !0,
      inside: {
        punctuation: /[<>]/
      }
    },
    function: {
      pattern: /(?:(?![-.\d\xB7])[-.\w\xB7\xC0-\uFFFD]+)?:(?:(?![-.])(?:[-.:\w\xC0-\uFFFD]|%[\da-f]{2}|\\.)+)?/i,
      inside: {
        "local-name": {
          pattern: /([^:]*:)[\s\S]+/,
          lookbehind: !0
        },
        prefix: {
          pattern: /[\s\S]+/,
          inside: {
            punctuation: /:/
          }
        }
      }
    },
    number: /[+-]?\b\d+(?:\.\d*)?(?:e[+-]?\d+)?/i,
    punctuation: /[{}.,;()[\]]|\^\^/,
    boolean: /\b(?:false|true)\b/,
    keyword: [/(?:\ba|@prefix|@base)\b|=/, /\b(?:base|graph|prefix)\b/i],
    tag: {
      pattern: /@[a-z]+(?:-[a-z\d]+)*/i,
      inside: {
        punctuation: /@/
      }
    }
  }, t.languages.trig = t.languages.turtle;
}
$H.displayName = "sparql";
$H.aliases = ["rq"];
function $H(t) {
  t.register(KD), t.languages.sparql = t.languages.extend("turtle", {
    boolean: /\b(?:false|true)\b/i,
    variable: {
      pattern: /[?$]\w+/,
      greedy: !0
    }
  }), t.languages.insertBefore("sparql", "punctuation", {
    keyword: [
      /\b(?:A|ADD|ALL|AS|ASC|ASK|BNODE|BY|CLEAR|CONSTRUCT|COPY|CREATE|DATA|DEFAULT|DELETE|DESC|DESCRIBE|DISTINCT|DROP|EXISTS|FILTER|FROM|GROUP|HAVING|INSERT|INTO|LIMIT|LOAD|MINUS|MOVE|NAMED|NOT|NOW|OFFSET|OPTIONAL|ORDER|RAND|REDUCED|SELECT|SEPARATOR|SERVICE|SILENT|STRUUID|UNION|USING|UUID|VALUES|WHERE)\b/i,
      /\b(?:ABS|AVG|BIND|BOUND|CEIL|COALESCE|CONCAT|CONTAINS|COUNT|DATATYPE|DAY|ENCODE_FOR_URI|FLOOR|GROUP_CONCAT|HOURS|IF|IRI|isBLANK|isIRI|isLITERAL|isNUMERIC|isURI|LANG|LANGMATCHES|LCASE|MAX|MD5|MIN|MINUTES|MONTH|REGEX|REPLACE|ROUND|sameTerm|SAMPLE|SECONDS|SHA1|SHA256|SHA384|SHA512|STR|STRAFTER|STRBEFORE|STRDT|STRENDS|STRLANG|STRLEN|STRSTARTS|SUBSTR|SUM|TIMEZONE|TZ|UCASE|URI|YEAR)\b(?=\s*\()/i,
      /\b(?:BASE|GRAPH|PREFIX)\b/i
    ]
  }), t.languages.rq = t.languages.sparql;
}
BH.displayName = "splunk-spl";
BH.aliases = [];
function BH(t) {
  t.languages["splunk-spl"] = {
    comment: /`comment\("(?:\\.|[^\\"])*"\)`/,
    string: {
      pattern: /"(?:\\.|[^\\"])*"/,
      greedy: !0
    },
    // https://docs.splunk.com/Documentation/Splunk/7.3.0/SearchReference/ListOfSearchCommands
    keyword: /\b(?:abstract|accum|addcoltotals|addinfo|addtotals|analyzefields|anomalies|anomalousvalue|anomalydetection|append|appendcols|appendcsv|appendlookup|appendpipe|arules|associate|audit|autoregress|bin|bucket|bucketdir|chart|cluster|cofilter|collect|concurrency|contingency|convert|correlate|datamodel|dbinspect|dedup|delete|delta|diff|erex|eval|eventcount|eventstats|extract|fieldformat|fields|fieldsummary|filldown|fillnull|findtypes|folderize|foreach|format|from|gauge|gentimes|geom|geomfilter|geostats|head|highlight|history|iconify|input|inputcsv|inputlookup|iplocation|join|kmeans|kv|kvform|loadjob|localize|localop|lookup|makecontinuous|makemv|makeresults|map|mcollect|metadata|metasearch|meventcollect|mstats|multikv|multisearch|mvcombine|mvexpand|nomv|outlier|outputcsv|outputlookup|outputtext|overlap|pivot|predict|rangemap|rare|regex|relevancy|reltime|rename|replace|rest|return|reverse|rex|rtorder|run|savedsearch|script|scrub|search|searchtxn|selfjoin|sendemail|set|setfields|sichart|sirare|sistats|sitimechart|sitop|sort|spath|stats|strcat|streamstats|table|tags|tail|timechart|timewrap|top|transaction|transpose|trendline|tscollect|tstats|typeahead|typelearner|typer|union|uniq|untable|where|x11|xmlkv|xmlunescape|xpath|xyseries)\b/i,
    "operator-word": {
      pattern: /\b(?:and|as|by|not|or|xor)\b/i,
      alias: "operator"
    },
    function: /\b\w+(?=\s*\()/,
    property: /\b\w+(?=\s*=(?!=))/,
    date: {
      // MM/DD/YYYY(:HH:MM:SS)?
      pattern: /\b\d{1,2}\/\d{1,2}\/\d{1,4}(?:(?::\d{1,2}){3})?\b/,
      alias: "number"
    },
    number: /\b\d+(?:\.\d+)?\b/,
    boolean: /\b(?:f|false|t|true)\b/i,
    operator: /[<>=]=?|[-+*/%|]/,
    punctuation: /[()[\],]/
  };
}
UH.displayName = "sqf";
UH.aliases = [];
function UH(t) {
  t.register(Lr), t.languages.sqf = t.languages.extend("clike", {
    string: {
      pattern: /"(?:(?:"")?[^"])*"(?!")|'(?:[^'])*'/,
      greedy: !0
    },
    keyword: /\b(?:breakOut|breakTo|call|case|catch|default|do|echo|else|execFSM|execVM|exitWith|for|forEach|forEachMember|forEachMemberAgent|forEachMemberTeam|from|goto|if|nil|preprocessFile|preprocessFileLineNumbers|private|scopeName|spawn|step|switch|then|throw|to|try|while|with)\b/i,
    boolean: /\b(?:false|true)\b/i,
    function: /\b(?:abs|accTime|acos|action|actionIDs|actionKeys|actionKeysImages|actionKeysNames|actionKeysNamesArray|actionName|actionParams|activateAddons|activatedAddons|activateKey|add3DENConnection|add3DENEventHandler|add3DENLayer|addAction|addBackpack|addBackpackCargo|addBackpackCargoGlobal|addBackpackGlobal|addCamShake|addCuratorAddons|addCuratorCameraArea|addCuratorEditableObjects|addCuratorEditingArea|addCuratorPoints|addEditorObject|addEventHandler|addForce|addForceGeneratorRTD|addGoggles|addGroupIcon|addHandgunItem|addHeadgear|addItem|addItemCargo|addItemCargoGlobal|addItemPool|addItemToBackpack|addItemToUniform|addItemToVest|addLiveStats|addMagazine|addMagazineAmmoCargo|addMagazineCargo|addMagazineCargoGlobal|addMagazineGlobal|addMagazinePool|addMagazines|addMagazineTurret|addMenu|addMenuItem|addMissionEventHandler|addMPEventHandler|addMusicEventHandler|addOwnedMine|addPlayerScores|addPrimaryWeaponItem|addPublicVariableEventHandler|addRating|addResources|addScore|addScoreSide|addSecondaryWeaponItem|addSwitchableUnit|addTeamMember|addToRemainsCollector|addTorque|addUniform|addVehicle|addVest|addWaypoint|addWeapon|addWeaponCargo|addWeaponCargoGlobal|addWeaponGlobal|addWeaponItem|addWeaponPool|addWeaponTurret|admin|agent|agents|AGLToASL|aimedAtTarget|aimPos|airDensityCurveRTD|airDensityRTD|airplaneThrottle|airportSide|AISFinishHeal|alive|all3DENEntities|allAirports|allControls|allCurators|allCutLayers|allDead|allDeadMen|allDisplays|allGroups|allMapMarkers|allMines|allMissionObjects|allow3DMode|allowCrewInImmobile|allowCuratorLogicIgnoreAreas|allowDamage|allowDammage|allowFileOperations|allowFleeing|allowGetIn|allowSprint|allPlayers|allSimpleObjects|allSites|allTurrets|allUnits|allUnitsUAV|allVariables|ammo|ammoOnPylon|animate|animateBay|animateDoor|animatePylon|animateSource|animationNames|animationPhase|animationSourcePhase|animationState|append|apply|armoryPoints|arrayIntersect|asin|ASLToAGL|ASLToATL|assert|assignAsCargo|assignAsCargoIndex|assignAsCommander|assignAsDriver|assignAsGunner|assignAsTurret|assignCurator|assignedCargo|assignedCommander|assignedDriver|assignedGunner|assignedItems|assignedTarget|assignedTeam|assignedVehicle|assignedVehicleRole|assignItem|assignTeam|assignToAirport|atan|atan2|atg|ATLToASL|attachedObject|attachedObjects|attachedTo|attachObject|attachTo|attackEnabled|backpack|backpackCargo|backpackContainer|backpackItems|backpackMagazines|backpackSpaceFor|behaviour|benchmark|binocular|blufor|boundingBox|boundingBoxReal|boundingCenter|briefingName|buildingExit|buildingPos|buldozer_EnableRoadDiag|buldozer_IsEnabledRoadDiag|buldozer_LoadNewRoads|buldozer_reloadOperMap|buttonAction|buttonSetAction|cadetMode|callExtension|camCommand|camCommit|camCommitPrepared|camCommitted|camConstuctionSetParams|camCreate|camDestroy|cameraEffect|cameraEffectEnableHUD|cameraInterest|cameraOn|cameraView|campaignConfigFile|camPreload|camPreloaded|camPrepareBank|camPrepareDir|camPrepareDive|camPrepareFocus|camPrepareFov|camPrepareFovRange|camPreparePos|camPrepareRelPos|camPrepareTarget|camSetBank|camSetDir|camSetDive|camSetFocus|camSetFov|camSetFovRange|camSetPos|camSetRelPos|camSetTarget|camTarget|camUseNVG|canAdd|canAddItemToBackpack|canAddItemToUniform|canAddItemToVest|cancelSimpleTaskDestination|canFire|canMove|canSlingLoad|canStand|canSuspend|canTriggerDynamicSimulation|canUnloadInCombat|canVehicleCargo|captive|captiveNum|cbChecked|cbSetChecked|ceil|channelEnabled|cheatsEnabled|checkAIFeature|checkVisibility|civilian|className|clear3DENAttribute|clear3DENInventory|clearAllItemsFromBackpack|clearBackpackCargo|clearBackpackCargoGlobal|clearForcesRTD|clearGroupIcons|clearItemCargo|clearItemCargoGlobal|clearItemPool|clearMagazineCargo|clearMagazineCargoGlobal|clearMagazinePool|clearOverlay|clearRadio|clearVehicleInit|clearWeaponCargo|clearWeaponCargoGlobal|clearWeaponPool|clientOwner|closeDialog|closeDisplay|closeOverlay|collapseObjectTree|collect3DENHistory|collectiveRTD|combatMode|commandArtilleryFire|commandChat|commander|commandFire|commandFollow|commandFSM|commandGetOut|commandingMenu|commandMove|commandRadio|commandStop|commandSuppressiveFire|commandTarget|commandWatch|comment|commitOverlay|compile|compileFinal|completedFSM|composeText|configClasses|configFile|configHierarchy|configName|configNull|configProperties|configSourceAddonList|configSourceMod|configSourceModList|confirmSensorTarget|connectTerminalToUAV|controlNull|controlsGroupCtrl|copyFromClipboard|copyToClipboard|copyWaypoints|cos|count|countEnemy|countFriendly|countSide|countType|countUnknown|create3DENComposition|create3DENEntity|createAgent|createCenter|createDialog|createDiaryLink|createDiaryRecord|createDiarySubject|createDisplay|createGearDialog|createGroup|createGuardedPoint|createLocation|createMarker|createMarkerLocal|createMenu|createMine|createMissionDisplay|createMPCampaignDisplay|createSimpleObject|createSimpleTask|createSite|createSoundSource|createTask|createTeam|createTrigger|createUnit|createVehicle|createVehicleCrew|createVehicleLocal|crew|ctAddHeader|ctAddRow|ctClear|ctCurSel|ctData|ctFindHeaderRows|ctFindRowHeader|ctHeaderControls|ctHeaderCount|ctRemoveHeaders|ctRemoveRows|ctrlActivate|ctrlAddEventHandler|ctrlAngle|ctrlAutoScrollDelay|ctrlAutoScrollRewind|ctrlAutoScrollSpeed|ctrlChecked|ctrlClassName|ctrlCommit|ctrlCommitted|ctrlCreate|ctrlDelete|ctrlEnable|ctrlEnabled|ctrlFade|ctrlHTMLLoaded|ctrlIDC|ctrlIDD|ctrlMapAnimAdd|ctrlMapAnimClear|ctrlMapAnimCommit|ctrlMapAnimDone|ctrlMapCursor|ctrlMapMouseOver|ctrlMapScale|ctrlMapScreenToWorld|ctrlMapWorldToScreen|ctrlModel|ctrlModelDirAndUp|ctrlModelScale|ctrlParent|ctrlParentControlsGroup|ctrlPosition|ctrlRemoveAllEventHandlers|ctrlRemoveEventHandler|ctrlScale|ctrlSetActiveColor|ctrlSetAngle|ctrlSetAutoScrollDelay|ctrlSetAutoScrollRewind|ctrlSetAutoScrollSpeed|ctrlSetBackgroundColor|ctrlSetChecked|ctrlSetDisabledColor|ctrlSetEventHandler|ctrlSetFade|ctrlSetFocus|ctrlSetFont|ctrlSetFontH1|ctrlSetFontH1B|ctrlSetFontH2|ctrlSetFontH2B|ctrlSetFontH3|ctrlSetFontH3B|ctrlSetFontH4|ctrlSetFontH4B|ctrlSetFontH5|ctrlSetFontH5B|ctrlSetFontH6|ctrlSetFontH6B|ctrlSetFontHeight|ctrlSetFontHeightH1|ctrlSetFontHeightH2|ctrlSetFontHeightH3|ctrlSetFontHeightH4|ctrlSetFontHeightH5|ctrlSetFontHeightH6|ctrlSetFontHeightSecondary|ctrlSetFontP|ctrlSetFontPB|ctrlSetFontSecondary|ctrlSetForegroundColor|ctrlSetModel|ctrlSetModelDirAndUp|ctrlSetModelScale|ctrlSetPixelPrecision|ctrlSetPosition|ctrlSetScale|ctrlSetStructuredText|ctrlSetText|ctrlSetTextColor|ctrlSetTextColorSecondary|ctrlSetTextSecondary|ctrlSetTooltip|ctrlSetTooltipColorBox|ctrlSetTooltipColorShade|ctrlSetTooltipColorText|ctrlShow|ctrlShown|ctrlText|ctrlTextHeight|ctrlTextSecondary|ctrlTextWidth|ctrlType|ctrlVisible|ctRowControls|ctRowCount|ctSetCurSel|ctSetData|ctSetHeaderTemplate|ctSetRowTemplate|ctSetValue|ctValue|curatorAddons|curatorCamera|curatorCameraArea|curatorCameraAreaCeiling|curatorCoef|curatorEditableObjects|curatorEditingArea|curatorEditingAreaType|curatorMouseOver|curatorPoints|curatorRegisteredObjects|curatorSelected|curatorWaypointCost|current3DENOperation|currentChannel|currentCommand|currentMagazine|currentMagazineDetail|currentMagazineDetailTurret|currentMagazineTurret|currentMuzzle|currentNamespace|currentTask|currentTasks|currentThrowable|currentVisionMode|currentWaypoint|currentWeapon|currentWeaponMode|currentWeaponTurret|currentZeroing|cursorObject|cursorTarget|customChat|customRadio|cutFadeOut|cutObj|cutRsc|cutText|damage|date|dateToNumber|daytime|deActivateKey|debriefingText|debugFSM|debugLog|deg|delete3DENEntities|deleteAt|deleteCenter|deleteCollection|deleteEditorObject|deleteGroup|deleteGroupWhenEmpty|deleteIdentity|deleteLocation|deleteMarker|deleteMarkerLocal|deleteRange|deleteResources|deleteSite|deleteStatus|deleteTeam|deleteVehicle|deleteVehicleCrew|deleteWaypoint|detach|detectedMines|diag_activeMissionFSMs|diag_activeScripts|diag_activeSQFScripts|diag_activeSQSScripts|diag_captureFrame|diag_captureFrameToFile|diag_captureSlowFrame|diag_codePerformance|diag_drawMode|diag_dynamicSimulationEnd|diag_enable|diag_enabled|diag_fps|diag_fpsMin|diag_frameNo|diag_lightNewLoad|diag_list|diag_log|diag_logSlowFrame|diag_mergeConfigFile|diag_recordTurretLimits|diag_setLightNew|diag_tickTime|diag_toggle|dialog|diarySubjectExists|didJIP|didJIPOwner|difficulty|difficultyEnabled|difficultyEnabledRTD|difficultyOption|direction|directSay|disableAI|disableCollisionWith|disableConversation|disableDebriefingStats|disableMapIndicators|disableNVGEquipment|disableRemoteSensors|disableSerialization|disableTIEquipment|disableUAVConnectability|disableUserInput|displayAddEventHandler|displayCtrl|displayNull|displayParent|displayRemoveAllEventHandlers|displayRemoveEventHandler|displaySetEventHandler|dissolveTeam|distance|distance2D|distanceSqr|distributionRegion|do3DENAction|doArtilleryFire|doFire|doFollow|doFSM|doGetOut|doMove|doorPhase|doStop|doSuppressiveFire|doTarget|doWatch|drawArrow|drawEllipse|drawIcon|drawIcon3D|drawLine|drawLine3D|drawLink|drawLocation|drawPolygon|drawRectangle|drawTriangle|driver|drop|dynamicSimulationDistance|dynamicSimulationDistanceCoef|dynamicSimulationEnabled|dynamicSimulationSystemEnabled|east|edit3DENMissionAttributes|editObject|editorSetEventHandler|effectiveCommander|emptyPositions|enableAI|enableAIFeature|enableAimPrecision|enableAttack|enableAudioFeature|enableAutoStartUpRTD|enableAutoTrimRTD|enableCamShake|enableCaustics|enableChannel|enableCollisionWith|enableCopilot|enableDebriefingStats|enableDiagLegend|enableDynamicSimulation|enableDynamicSimulationSystem|enableEndDialog|enableEngineArtillery|enableEnvironment|enableFatigue|enableGunLights|enableInfoPanelComponent|enableIRLasers|enableMimics|enablePersonTurret|enableRadio|enableReload|enableRopeAttach|enableSatNormalOnDetail|enableSaving|enableSentences|enableSimulation|enableSimulationGlobal|enableStamina|enableStressDamage|enableTeamSwitch|enableTraffic|enableUAVConnectability|enableUAVWaypoints|enableVehicleCargo|enableVehicleSensor|enableWeaponDisassembly|endl|endLoadingScreen|endMission|engineOn|enginesIsOnRTD|enginesPowerRTD|enginesRpmRTD|enginesTorqueRTD|entities|environmentEnabled|estimatedEndServerTime|estimatedTimeLeft|evalObjectArgument|everyBackpack|everyContainer|exec|execEditorScript|exp|expectedDestination|exportJIPMessages|eyeDirection|eyePos|face|faction|fadeMusic|fadeRadio|fadeSound|fadeSpeech|failMission|fillWeaponsFromPool|find|findCover|findDisplay|findEditorObject|findEmptyPosition|findEmptyPositionReady|findIf|findNearestEnemy|finishMissionInit|finite|fire|fireAtTarget|firstBackpack|flag|flagAnimationPhase|flagOwner|flagSide|flagTexture|fleeing|floor|flyInHeight|flyInHeightASL|fog|fogForecast|fogParams|forceAddUniform|forceAtPositionRTD|forcedMap|forceEnd|forceFlagTexture|forceFollowRoad|forceGeneratorRTD|forceMap|forceRespawn|forceSpeed|forceWalk|forceWeaponFire|forceWeatherChange|forgetTarget|format|formation|formationDirection|formationLeader|formationMembers|formationPosition|formationTask|formatText|formLeader|freeLook|fromEditor|fuel|fullCrew|gearIDCAmmoCount|gearSlotAmmoCount|gearSlotData|get3DENActionState|get3DENAttribute|get3DENCamera|get3DENConnections|get3DENEntity|get3DENEntityID|get3DENGrid|get3DENIconsVisible|get3DENLayerEntities|get3DENLinesVisible|get3DENMissionAttribute|get3DENMouseOver|get3DENSelected|getAimingCoef|getAllEnvSoundControllers|getAllHitPointsDamage|getAllOwnedMines|getAllSoundControllers|getAmmoCargo|getAnimAimPrecision|getAnimSpeedCoef|getArray|getArtilleryAmmo|getArtilleryComputerSettings|getArtilleryETA|getAssignedCuratorLogic|getAssignedCuratorUnit|getBackpackCargo|getBleedingRemaining|getBurningValue|getCameraViewDirection|getCargoIndex|getCenterOfMass|getClientState|getClientStateNumber|getCompatiblePylonMagazines|getConnectedUAV|getContainerMaxLoad|getCursorObjectParams|getCustomAimCoef|getDammage|getDescription|getDir|getDirVisual|getDLCAssetsUsage|getDLCAssetsUsageByName|getDLCs|getDLCUsageTime|getEditorCamera|getEditorMode|getEditorObjectScope|getElevationOffset|getEngineTargetRpmRTD|getEnvSoundController|getFatigue|getFieldManualStartPage|getForcedFlagTexture|getFriend|getFSMVariable|getFuelCargo|getGroupIcon|getGroupIconParams|getGroupIcons|getHideFrom|getHit|getHitIndex|getHitPointDamage|getItemCargo|getMagazineCargo|getMarkerColor|getMarkerPos|getMarkerSize|getMarkerType|getMass|getMissionConfig|getMissionConfigValue|getMissionDLCs|getMissionLayerEntities|getMissionLayers|getModelInfo|getMousePosition|getMusicPlayedTime|getNumber|getObjectArgument|getObjectChildren|getObjectDLC|getObjectMaterials|getObjectProxy|getObjectTextures|getObjectType|getObjectViewDistance|getOxygenRemaining|getPersonUsedDLCs|getPilotCameraDirection|getPilotCameraPosition|getPilotCameraRotation|getPilotCameraTarget|getPlateNumber|getPlayerChannel|getPlayerScores|getPlayerUID|getPlayerUIDOld|getPos|getPosASL|getPosASLVisual|getPosASLW|getPosATL|getPosATLVisual|getPosVisual|getPosWorld|getPylonMagazines|getRelDir|getRelPos|getRemoteSensorsDisabled|getRepairCargo|getResolution|getRotorBrakeRTD|getShadowDistance|getShotParents|getSlingLoad|getSoundController|getSoundControllerResult|getSpeed|getStamina|getStatValue|getSuppression|getTerrainGrid|getTerrainHeightASL|getText|getTotalDLCUsageTime|getTrimOffsetRTD|getUnitLoadout|getUnitTrait|getUserMFDText|getUserMFDValue|getVariable|getVehicleCargo|getWeaponCargo|getWeaponSway|getWingsOrientationRTD|getWingsPositionRTD|getWPPos|glanceAt|globalChat|globalRadio|goggles|group|groupChat|groupFromNetId|groupIconSelectable|groupIconsVisible|groupId|groupOwner|groupRadio|groupSelectedUnits|groupSelectUnit|grpNull|gunner|gusts|halt|handgunItems|handgunMagazine|handgunWeapon|handsHit|hasInterface|hasPilotCamera|hasWeapon|hcAllGroups|hcGroupParams|hcLeader|hcRemoveAllGroups|hcRemoveGroup|hcSelected|hcSelectGroup|hcSetGroup|hcShowBar|hcShownBar|headgear|hideBody|hideObject|hideObjectGlobal|hideSelection|hint|hintC|hintCadet|hintSilent|hmd|hostMission|htmlLoad|HUDMovementLevels|humidity|image|importAllGroups|importance|in|inArea|inAreaArray|incapacitatedState|independent|inflame|inflamed|infoPanel|infoPanelComponentEnabled|infoPanelComponents|infoPanels|inGameUISetEventHandler|inheritsFrom|initAmbientLife|inPolygon|inputAction|inRangeOfArtillery|insertEditorObject|intersect|is3DEN|is3DENMultiplayer|isAbleToBreathe|isAgent|isAimPrecisionEnabled|isArray|isAutoHoverOn|isAutonomous|isAutoStartUpEnabledRTD|isAutotest|isAutoTrimOnRTD|isBleeding|isBurning|isClass|isCollisionLightOn|isCopilotEnabled|isDamageAllowed|isDedicated|isDLCAvailable|isEngineOn|isEqualTo|isEqualType|isEqualTypeAll|isEqualTypeAny|isEqualTypeArray|isEqualTypeParams|isFilePatchingEnabled|isFlashlightOn|isFlatEmpty|isForcedWalk|isFormationLeader|isGroupDeletedWhenEmpty|isHidden|isInRemainsCollector|isInstructorFigureEnabled|isIRLaserOn|isKeyActive|isKindOf|isLaserOn|isLightOn|isLocalized|isManualFire|isMarkedForCollection|isMultiplayer|isMultiplayerSolo|isNil|isNull|isNumber|isObjectHidden|isObjectRTD|isOnRoad|isPipEnabled|isPlayer|isRealTime|isRemoteExecuted|isRemoteExecutedJIP|isServer|isShowing3DIcons|isSimpleObject|isSprintAllowed|isStaminaEnabled|isSteamMission|isStreamFriendlyUIEnabled|isStressDamageEnabled|isText|isTouchingGround|isTurnedOut|isTutHintsEnabled|isUAVConnectable|isUAVConnected|isUIContext|isUniformAllowed|isVehicleCargo|isVehicleRadarOn|isVehicleSensorEnabled|isWalking|isWeaponDeployed|isWeaponRested|itemCargo|items|itemsWithMagazines|join|joinAs|joinAsSilent|joinSilent|joinString|kbAddDatabase|kbAddDatabaseTargets|kbAddTopic|kbHasTopic|kbReact|kbRemoveTopic|kbTell|kbWasSaid|keyImage|keyName|knowsAbout|land|landAt|landResult|language|laserTarget|lbAdd|lbClear|lbColor|lbColorRight|lbCurSel|lbData|lbDelete|lbIsSelected|lbPicture|lbPictureRight|lbSelection|lbSetColor|lbSetColorRight|lbSetCurSel|lbSetData|lbSetPicture|lbSetPictureColor|lbSetPictureColorDisabled|lbSetPictureColorSelected|lbSetPictureRight|lbSetPictureRightColor|lbSetPictureRightColorDisabled|lbSetPictureRightColorSelected|lbSetSelectColor|lbSetSelectColorRight|lbSetSelected|lbSetText|lbSetTextRight|lbSetTooltip|lbSetValue|lbSize|lbSort|lbSortByValue|lbText|lbTextRight|lbValue|leader|leaderboardDeInit|leaderboardGetRows|leaderboardInit|leaderboardRequestRowsFriends|leaderboardRequestRowsGlobal|leaderboardRequestRowsGlobalAroundUser|leaderboardsRequestUploadScore|leaderboardsRequestUploadScoreKeepBest|leaderboardState|leaveVehicle|libraryCredits|libraryDisclaimers|lifeState|lightAttachObject|lightDetachObject|lightIsOn|lightnings|limitSpeed|linearConversion|lineBreak|lineIntersects|lineIntersectsObjs|lineIntersectsSurfaces|lineIntersectsWith|linkItem|list|listObjects|listRemoteTargets|listVehicleSensors|ln|lnbAddArray|lnbAddColumn|lnbAddRow|lnbClear|lnbColor|lnbColorRight|lnbCurSelRow|lnbData|lnbDeleteColumn|lnbDeleteRow|lnbGetColumnsPosition|lnbPicture|lnbPictureRight|lnbSetColor|lnbSetColorRight|lnbSetColumnsPos|lnbSetCurSelRow|lnbSetData|lnbSetPicture|lnbSetPictureColor|lnbSetPictureColorRight|lnbSetPictureColorSelected|lnbSetPictureColorSelectedRight|lnbSetPictureRight|lnbSetText|lnbSetTextRight|lnbSetValue|lnbSize|lnbSort|lnbSortByValue|lnbText|lnbTextRight|lnbValue|load|loadAbs|loadBackpack|loadFile|loadGame|loadIdentity|loadMagazine|loadOverlay|loadStatus|loadUniform|loadVest|local|localize|locationNull|locationPosition|lock|lockCameraTo|lockCargo|lockDriver|locked|lockedCargo|lockedDriver|lockedTurret|lockIdentity|lockTurret|lockWP|log|logEntities|logNetwork|logNetworkTerminate|lookAt|lookAtPos|magazineCargo|magazines|magazinesAllTurrets|magazinesAmmo|magazinesAmmoCargo|magazinesAmmoFull|magazinesDetail|magazinesDetailBackpack|magazinesDetailUniform|magazinesDetailVest|magazinesTurret|magazineTurretAmmo|mapAnimAdd|mapAnimClear|mapAnimCommit|mapAnimDone|mapCenterOnCamera|mapGridPosition|markAsFinishedOnSteam|markerAlpha|markerBrush|markerColor|markerDir|markerPos|markerShape|markerSize|markerText|markerType|max|members|menuAction|menuAdd|menuChecked|menuClear|menuCollapse|menuData|menuDelete|menuEnable|menuEnabled|menuExpand|menuHover|menuPicture|menuSetAction|menuSetCheck|menuSetData|menuSetPicture|menuSetValue|menuShortcut|menuShortcutText|menuSize|menuSort|menuText|menuURL|menuValue|min|mineActive|mineDetectedBy|missionConfigFile|missionDifficulty|missionName|missionNamespace|missionStart|missionVersion|modelToWorld|modelToWorldVisual|modelToWorldVisualWorld|modelToWorldWorld|modParams|moonIntensity|moonPhase|morale|move|move3DENCamera|moveInAny|moveInCargo|moveInCommander|moveInDriver|moveInGunner|moveInTurret|moveObjectToEnd|moveOut|moveTime|moveTo|moveToCompleted|moveToFailed|musicVolume|name|nameSound|nearEntities|nearestBuilding|nearestLocation|nearestLocations|nearestLocationWithDubbing|nearestObject|nearestObjects|nearestTerrainObjects|nearObjects|nearObjectsReady|nearRoads|nearSupplies|nearTargets|needReload|netId|netObjNull|newOverlay|nextMenuItemIndex|nextWeatherChange|nMenuItems|numberOfEnginesRTD|numberToDate|objectCurators|objectFromNetId|objectParent|objNull|objStatus|onBriefingGear|onBriefingGroup|onBriefingNotes|onBriefingPlan|onBriefingTeamSwitch|onCommandModeChanged|onDoubleClick|onEachFrame|onGroupIconClick|onGroupIconOverEnter|onGroupIconOverLeave|onHCGroupSelectionChanged|onMapSingleClick|onPlayerConnected|onPlayerDisconnected|onPreloadFinished|onPreloadStarted|onShowNewObject|onTeamSwitch|openCuratorInterface|openDLCPage|openDSInterface|openMap|openSteamApp|openYoutubeVideo|opfor|orderGetIn|overcast|overcastForecast|owner|param|params|parseNumber|parseSimpleArray|parseText|parsingNamespace|particlesQuality|pi|pickWeaponPool|pitch|pixelGrid|pixelGridBase|pixelGridNoUIScale|pixelH|pixelW|playableSlotsNumber|playableUnits|playAction|playActionNow|player|playerRespawnTime|playerSide|playersNumber|playGesture|playMission|playMove|playMoveNow|playMusic|playScriptedMission|playSound|playSound3D|position|positionCameraToWorld|posScreenToWorld|posWorldToScreen|ppEffectAdjust|ppEffectCommit|ppEffectCommitted|ppEffectCreate|ppEffectDestroy|ppEffectEnable|ppEffectEnabled|ppEffectForceInNVG|precision|preloadCamera|preloadObject|preloadSound|preloadTitleObj|preloadTitleRsc|primaryWeapon|primaryWeaponItems|primaryWeaponMagazine|priority|processDiaryLink|processInitCommands|productVersion|profileName|profileNamespace|profileNameSteam|progressLoadingScreen|progressPosition|progressSetPosition|publicVariable|publicVariableClient|publicVariableServer|pushBack|pushBackUnique|putWeaponPool|queryItemsPool|queryMagazinePool|queryWeaponPool|rad|radioChannelAdd|radioChannelCreate|radioChannelRemove|radioChannelSetCallSign|radioChannelSetLabel|radioVolume|rain|rainbow|random|rank|rankId|rating|rectangular|registeredTasks|registerTask|reload|reloadEnabled|remoteControl|remoteExec|remoteExecCall|remoteExecutedOwner|remove3DENConnection|remove3DENEventHandler|remove3DENLayer|removeAction|removeAll3DENEventHandlers|removeAllActions|removeAllAssignedItems|removeAllContainers|removeAllCuratorAddons|removeAllCuratorCameraAreas|removeAllCuratorEditingAreas|removeAllEventHandlers|removeAllHandgunItems|removeAllItems|removeAllItemsWithMagazines|removeAllMissionEventHandlers|removeAllMPEventHandlers|removeAllMusicEventHandlers|removeAllOwnedMines|removeAllPrimaryWeaponItems|removeAllWeapons|removeBackpack|removeBackpackGlobal|removeCuratorAddons|removeCuratorCameraArea|removeCuratorEditableObjects|removeCuratorEditingArea|removeDrawIcon|removeDrawLinks|removeEventHandler|removeFromRemainsCollector|removeGoggles|removeGroupIcon|removeHandgunItem|removeHeadgear|removeItem|removeItemFromBackpack|removeItemFromUniform|removeItemFromVest|removeItems|removeMagazine|removeMagazineGlobal|removeMagazines|removeMagazinesTurret|removeMagazineTurret|removeMenuItem|removeMissionEventHandler|removeMPEventHandler|removeMusicEventHandler|removeOwnedMine|removePrimaryWeaponItem|removeSecondaryWeaponItem|removeSimpleTask|removeSwitchableUnit|removeTeamMember|removeUniform|removeVest|removeWeapon|removeWeaponAttachmentCargo|removeWeaponCargo|removeWeaponGlobal|removeWeaponTurret|reportRemoteTarget|requiredVersion|resetCamShake|resetSubgroupDirection|resistance|resize|resources|respawnVehicle|restartEditorCamera|reveal|revealMine|reverse|reversedMouseY|roadAt|roadsConnectedTo|roleDescription|ropeAttachedObjects|ropeAttachedTo|ropeAttachEnabled|ropeAttachTo|ropeCreate|ropeCut|ropeDestroy|ropeDetach|ropeEndPosition|ropeLength|ropes|ropeUnwind|ropeUnwound|rotorsForcesRTD|rotorsRpmRTD|round|runInitScript|safeZoneH|safeZoneW|safeZoneWAbs|safeZoneX|safeZoneXAbs|safeZoneY|save3DENInventory|saveGame|saveIdentity|saveJoysticks|saveOverlay|saveProfileNamespace|saveStatus|saveVar|savingEnabled|say|say2D|say3D|score|scoreSide|screenshot|screenToWorld|scriptDone|scriptName|scriptNull|scudState|secondaryWeapon|secondaryWeaponItems|secondaryWeaponMagazine|select|selectBestPlaces|selectDiarySubject|selectedEditorObjects|selectEditorObject|selectionNames|selectionPosition|selectLeader|selectMax|selectMin|selectNoPlayer|selectPlayer|selectRandom|selectRandomWeighted|selectWeapon|selectWeaponTurret|sendAUMessage|sendSimpleCommand|sendTask|sendTaskResult|sendUDPMessage|serverCommand|serverCommandAvailable|serverCommandExecutable|serverName|serverTime|set|set3DENAttribute|set3DENAttributes|set3DENGrid|set3DENIconsVisible|set3DENLayer|set3DENLinesVisible|set3DENLogicType|set3DENMissionAttribute|set3DENMissionAttributes|set3DENModelsVisible|set3DENObjectType|set3DENSelected|setAccTime|setActualCollectiveRTD|setAirplaneThrottle|setAirportSide|setAmmo|setAmmoCargo|setAmmoOnPylon|setAnimSpeedCoef|setAperture|setApertureNew|setArmoryPoints|setAttributes|setAutonomous|setBehaviour|setBleedingRemaining|setBrakesRTD|setCameraInterest|setCamShakeDefParams|setCamShakeParams|setCamUseTI|setCaptive|setCenterOfMass|setCollisionLight|setCombatMode|setCompassOscillation|setConvoySeparation|setCuratorCameraAreaCeiling|setCuratorCoef|setCuratorEditingAreaType|setCuratorWaypointCost|setCurrentChannel|setCurrentTask|setCurrentWaypoint|setCustomAimCoef|setCustomWeightRTD|setDamage|setDammage|setDate|setDebriefingText|setDefaultCamera|setDestination|setDetailMapBlendPars|setDir|setDirection|setDrawIcon|setDriveOnPath|setDropInterval|setDynamicSimulationDistance|setDynamicSimulationDistanceCoef|setEditorMode|setEditorObjectScope|setEffectCondition|setEngineRpmRTD|setFace|setFaceAnimation|setFatigue|setFeatureType|setFlagAnimationPhase|setFlagOwner|setFlagSide|setFlagTexture|setFog|setForceGeneratorRTD|setFormation|setFormationTask|setFormDir|setFriend|setFromEditor|setFSMVariable|setFuel|setFuelCargo|setGroupIcon|setGroupIconParams|setGroupIconsSelectable|setGroupIconsVisible|setGroupId|setGroupIdGlobal|setGroupOwner|setGusts|setHideBehind|setHit|setHitIndex|setHitPointDamage|setHorizonParallaxCoef|setHUDMovementLevels|setIdentity|setImportance|setInfoPanel|setLeader|setLightAmbient|setLightAttenuation|setLightBrightness|setLightColor|setLightDayLight|setLightFlareMaxDistance|setLightFlareSize|setLightIntensity|setLightnings|setLightUseFlare|setLocalWindParams|setMagazineTurretAmmo|setMarkerAlpha|setMarkerAlphaLocal|setMarkerBrush|setMarkerBrushLocal|setMarkerColor|setMarkerColorLocal|setMarkerDir|setMarkerDirLocal|setMarkerPos|setMarkerPosLocal|setMarkerShape|setMarkerShapeLocal|setMarkerSize|setMarkerSizeLocal|setMarkerText|setMarkerTextLocal|setMarkerType|setMarkerTypeLocal|setMass|setMimic|setMousePosition|setMusicEffect|setMusicEventHandler|setName|setNameSound|setObjectArguments|setObjectMaterial|setObjectMaterialGlobal|setObjectProxy|setObjectTexture|setObjectTextureGlobal|setObjectViewDistance|setOvercast|setOwner|setOxygenRemaining|setParticleCircle|setParticleClass|setParticleFire|setParticleParams|setParticleRandom|setPilotCameraDirection|setPilotCameraRotation|setPilotCameraTarget|setPilotLight|setPiPEffect|setPitch|setPlateNumber|setPlayable|setPlayerRespawnTime|setPos|setPosASL|setPosASL2|setPosASLW|setPosATL|setPosition|setPosWorld|setPylonLoadOut|setPylonsPriority|setRadioMsg|setRain|setRainbow|setRandomLip|setRank|setRectangular|setRepairCargo|setRotorBrakeRTD|setShadowDistance|setShotParents|setSide|setSimpleTaskAlwaysVisible|setSimpleTaskCustomData|setSimpleTaskDescription|setSimpleTaskDestination|setSimpleTaskTarget|setSimpleTaskType|setSimulWeatherLayers|setSize|setSkill|setSlingLoad|setSoundEffect|setSpeaker|setSpeech|setSpeedMode|setStamina|setStaminaScheme|setStatValue|setSuppression|setSystemOfUnits|setTargetAge|setTaskMarkerOffset|setTaskResult|setTaskState|setTerrainGrid|setText|setTimeMultiplier|setTitleEffect|setToneMapping|setToneMappingParams|setTrafficDensity|setTrafficDistance|setTrafficGap|setTrafficSpeed|setTriggerActivation|setTriggerArea|setTriggerStatements|setTriggerText|setTriggerTimeout|setTriggerType|setType|setUnconscious|setUnitAbility|setUnitLoadout|setUnitPos|setUnitPosWeak|setUnitRank|setUnitRecoilCoefficient|setUnitTrait|setUnloadInCombat|setUserActionText|setUserMFDText|setUserMFDValue|setVariable|setVectorDir|setVectorDirAndUp|setVectorUp|setVehicleAmmo|setVehicleAmmoDef|setVehicleArmor|setVehicleCargo|setVehicleId|setVehicleInit|setVehicleLock|setVehiclePosition|setVehicleRadar|setVehicleReceiveRemoteTargets|setVehicleReportOwnPosition|setVehicleReportRemoteTargets|setVehicleTIPars|setVehicleVarName|setVelocity|setVelocityModelSpace|setVelocityTransformation|setViewDistance|setVisibleIfTreeCollapsed|setWantedRpmRTD|setWaves|setWaypointBehaviour|setWaypointCombatMode|setWaypointCompletionRadius|setWaypointDescription|setWaypointForceBehaviour|setWaypointFormation|setWaypointHousePosition|setWaypointLoiterRadius|setWaypointLoiterType|setWaypointName|setWaypointPosition|setWaypointScript|setWaypointSpeed|setWaypointStatements|setWaypointTimeout|setWaypointType|setWaypointVisible|setWeaponReloadingTime|setWind|setWindDir|setWindForce|setWindStr|setWingForceScaleRTD|setWPPos|show3DIcons|showChat|showCinemaBorder|showCommandingMenu|showCompass|showCuratorCompass|showGPS|showHUD|showLegend|showMap|shownArtilleryComputer|shownChat|shownCompass|shownCuratorCompass|showNewEditorObject|shownGPS|shownHUD|shownMap|shownPad|shownRadio|shownScoretable|shownUAVFeed|shownWarrant|shownWatch|showPad|showRadio|showScoretable|showSubtitles|showUAVFeed|showWarrant|showWatch|showWaypoint|showWaypoints|side|sideAmbientLife|sideChat|sideEmpty|sideEnemy|sideFriendly|sideLogic|sideRadio|sideUnknown|simpleTasks|simulationEnabled|simulCloudDensity|simulCloudOcclusion|simulInClouds|simulWeatherSync|sin|size|sizeOf|skill|skillFinal|skipTime|sleep|sliderPosition|sliderRange|sliderSetPosition|sliderSetRange|sliderSetSpeed|sliderSpeed|slingLoadAssistantShown|soldierMagazines|someAmmo|sort|soundVolume|speaker|speed|speedMode|splitString|sqrt|squadParams|stance|startLoadingScreen|stop|stopEngineRTD|stopped|str|sunOrMoon|supportInfo|suppressFor|surfaceIsWater|surfaceNormal|surfaceType|swimInDepth|switchableUnits|switchAction|switchCamera|switchGesture|switchLight|switchMove|synchronizedObjects|synchronizedTriggers|synchronizedWaypoints|synchronizeObjectsAdd|synchronizeObjectsRemove|synchronizeTrigger|synchronizeWaypoint|systemChat|systemOfUnits|tan|targetKnowledge|targets|targetsAggregate|targetsQuery|taskAlwaysVisible|taskChildren|taskCompleted|taskCustomData|taskDescription|taskDestination|taskHint|taskMarkerOffset|taskNull|taskParent|taskResult|taskState|taskType|teamMember|teamMemberNull|teamName|teams|teamSwitch|teamSwitchEnabled|teamType|terminate|terrainIntersect|terrainIntersectASL|terrainIntersectAtASL|text|textLog|textLogFormat|tg|time|timeMultiplier|titleCut|titleFadeOut|titleObj|titleRsc|titleText|toArray|toFixed|toLower|toString|toUpper|triggerActivated|triggerActivation|triggerArea|triggerAttachedVehicle|triggerAttachObject|triggerAttachVehicle|triggerDynamicSimulation|triggerStatements|triggerText|triggerTimeout|triggerTimeoutCurrent|triggerType|turretLocal|turretOwner|turretUnit|tvAdd|tvClear|tvCollapse|tvCollapseAll|tvCount|tvCurSel|tvData|tvDelete|tvExpand|tvExpandAll|tvPicture|tvPictureRight|tvSetColor|tvSetCurSel|tvSetData|tvSetPicture|tvSetPictureColor|tvSetPictureColorDisabled|tvSetPictureColorSelected|tvSetPictureRight|tvSetPictureRightColor|tvSetPictureRightColorDisabled|tvSetPictureRightColorSelected|tvSetSelectColor|tvSetText|tvSetTooltip|tvSetValue|tvSort|tvSortByValue|tvText|tvTooltip|tvValue|type|typeName|typeOf|UAVControl|uiNamespace|uiSleep|unassignCurator|unassignItem|unassignTeam|unassignVehicle|underwater|uniform|uniformContainer|uniformItems|uniformMagazines|unitAddons|unitAimPosition|unitAimPositionVisual|unitBackpack|unitIsUAV|unitPos|unitReady|unitRecoilCoefficient|units|unitsBelowHeight|unlinkItem|unlockAchievement|unregisterTask|updateDrawIcon|updateMenuItem|updateObjectTree|useAIOperMapObstructionTest|useAISteeringComponent|useAudioTimeForMoves|userInputDisabled|vectorAdd|vectorCos|vectorCrossProduct|vectorDiff|vectorDir|vectorDirVisual|vectorDistance|vectorDistanceSqr|vectorDotProduct|vectorFromTo|vectorMagnitude|vectorMagnitudeSqr|vectorModelToWorld|vectorModelToWorldVisual|vectorMultiply|vectorNormalized|vectorUp|vectorUpVisual|vectorWorldToModel|vectorWorldToModelVisual|vehicle|vehicleCargoEnabled|vehicleChat|vehicleRadio|vehicleReceiveRemoteTargets|vehicleReportOwnPosition|vehicleReportRemoteTargets|vehicles|vehicleVarName|velocity|velocityModelSpace|verifySignature|vest|vestContainer|vestItems|vestMagazines|viewDistance|visibleCompass|visibleGPS|visibleMap|visiblePosition|visiblePositionASL|visibleScoretable|visibleWatch|waitUntil|waves|waypointAttachedObject|waypointAttachedVehicle|waypointAttachObject|waypointAttachVehicle|waypointBehaviour|waypointCombatMode|waypointCompletionRadius|waypointDescription|waypointForceBehaviour|waypointFormation|waypointHousePosition|waypointLoiterRadius|waypointLoiterType|waypointName|waypointPosition|waypoints|waypointScript|waypointsEnabledUAV|waypointShow|waypointSpeed|waypointStatements|waypointTimeout|waypointTimeoutCurrent|waypointType|waypointVisible|weaponAccessories|weaponAccessoriesCargo|weaponCargo|weaponDirection|weaponInertia|weaponLowered|weapons|weaponsItems|weaponsItemsCargo|weaponState|weaponsTurret|weightRTD|west|WFSideText|wind|windDir|windRTD|windStr|wingsForcesRTD|worldName|worldSize|worldToModel|worldToModelVisual|worldToScreen)\b/i,
    number: /(?:\$|\b0x)[\da-f]+\b|(?:\B\.\d+|\b\d+(?:\.\d+)?)(?:e[+-]?\d+)?\b/i,
    operator: /##|>>|&&|\|\||[!=<>]=?|[-+*/%#^]|\b(?:and|mod|not|or)\b/i,
    "magic-variable": {
      pattern: /\b(?:this|thisList|thisTrigger|_exception|_fnc_scriptName|_fnc_scriptNameParent|_forEachIndex|_this|_thisEventHandler|_thisFSM|_thisScript|_x)\b/i,
      alias: "keyword"
    },
    constant: /\bDIK(?:_[a-z\d]+)+\b/i
  }), t.languages.insertBefore("sqf", "string", {
    macro: {
      pattern: /(^[ \t]*)#[a-z](?:[^\r\n\\]|\\(?:\r\n|[\s\S]))*/im,
      lookbehind: !0,
      greedy: !0,
      alias: "property",
      inside: {
        directive: {
          pattern: /#[a-z]+\b/i,
          alias: "keyword"
        },
        comment: t.languages.sqf.comment
      }
    }
  }), delete t.languages.sqf["class-name"];
}
zH.displayName = "squirrel";
zH.aliases = [];
function zH(t) {
  t.register(Lr), t.languages.squirrel = t.languages.extend("clike", {
    comment: [
      t.languages.clike.comment[0],
      {
        pattern: /(^|[^\\:])(?:\/\/|#).*/,
        lookbehind: !0,
        greedy: !0
      }
    ],
    string: {
      pattern: /(^|[^\\"'@])(?:@"(?:[^"]|"")*"(?!")|"(?:[^\\\r\n"]|\\.)*")/,
      lookbehind: !0,
      greedy: !0
    },
    "class-name": {
      pattern: /(\b(?:class|enum|extends|instanceof)\s+)\w+(?:\.\w+)*/,
      lookbehind: !0,
      inside: {
        punctuation: /\./
      }
    },
    keyword: /\b(?:__FILE__|__LINE__|base|break|case|catch|class|clone|const|constructor|continue|default|delete|else|enum|extends|for|foreach|function|if|in|instanceof|local|null|resume|return|static|switch|this|throw|try|typeof|while|yield)\b/,
    number: /\b(?:0x[0-9a-fA-F]+|\d+(?:\.(?:\d+|[eE][+-]?\d+))?)\b/,
    operator: /\+\+|--|<=>|<[-<]|>>>?|&&?|\|\|?|[-+*/%!=<>]=?|[~^]|::?/,
    punctuation: /[(){}\[\],;.]/
  }), t.languages.insertBefore("squirrel", "string", {
    char: {
      pattern: /(^|[^\\"'])'(?:[^\\']|\\(?:[xuU][0-9a-fA-F]{0,8}|[\s\S]))'/,
      lookbehind: !0,
      greedy: !0
    }
  }), t.languages.insertBefore("squirrel", "operator", {
    "attribute-punctuation": {
      pattern: /<\/|\/>/,
      alias: "important"
    },
    lambda: {
      pattern: /@(?=\()/,
      alias: "operator"
    }
  });
}
HH.displayName = "stan";
HH.aliases = [];
function HH(t) {
  (function(e) {
    var n = /\b(?:algebra_solver|algebra_solver_newton|integrate_1d|integrate_ode|integrate_ode_bdf|integrate_ode_rk45|map_rect|ode_(?:adams|bdf|ckrk|rk45)(?:_tol)?|ode_adjoint_tol_ctl|reduce_sum|reduce_sum_static)\b/;
    e.languages.stan = {
      comment: /\/\/.*|\/\*[\s\S]*?\*\/|#(?!include).*/,
      string: {
        // String literals can contain spaces and any printable ASCII characters except for " and \
        // https://mc-stan.org/docs/2_24/reference-manual/print-statements-section.html#string-literals
        pattern: /"[\x20\x21\x23-\x5B\x5D-\x7E]*"/,
        greedy: !0
      },
      directive: {
        pattern: /^([ \t]*)#include\b.*/m,
        lookbehind: !0,
        alias: "property"
      },
      "function-arg": {
        pattern: RegExp(
          "(" + n.source + /\s*\(\s*/.source + ")" + /[a-zA-Z]\w*/.source
        ),
        lookbehind: !0,
        alias: "function"
      },
      constraint: {
        pattern: /(\b(?:int|matrix|real|row_vector|vector)\s*)<[^<>]*>/,
        lookbehind: !0,
        inside: {
          expression: {
            pattern: /(=\s*)\S(?:\S|\s+(?!\s))*?(?=\s*(?:>$|,\s*\w+\s*=))/,
            lookbehind: !0,
            inside: null
            // see below
          },
          property: /\b[a-z]\w*(?=\s*=)/i,
          operator: /=/,
          punctuation: /^<|>$|,/
        }
      },
      keyword: [
        {
          pattern: /\bdata(?=\s*\{)|\b(?:functions|generated|model|parameters|quantities|transformed)\b/,
          alias: "program-block"
        },
        /\b(?:array|break|cholesky_factor_corr|cholesky_factor_cov|complex|continue|corr_matrix|cov_matrix|data|else|for|if|in|increment_log_prob|int|matrix|ordered|positive_ordered|print|real|reject|return|row_vector|simplex|target|unit_vector|vector|void|while)\b/,
        // these are functions that are known to take another function as their first argument.
        n
      ],
      function: /\b[a-z]\w*(?=\s*\()/i,
      number: /(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:E[+-]?\d+(?:_\d+)*)?i?(?!\w)/i,
      boolean: /\b(?:false|true)\b/,
      operator: /<-|\.[*/]=?|\|\|?|&&|[!=<>+\-*/]=?|['^%~?:]/,
      punctuation: /[()\[\]{},;]/
    }, e.languages.stan.constraint.inside.expression.inside = e.languages.stan;
  })(t);
}
WH.displayName = "stata";
WH.aliases = [];
function WH(t) {
  t.register(k0), t.register(XD), t.register(R_), t.languages.stata = {
    comment: [
      {
        pattern: /(^[ \t]*)\*.*/m,
        lookbehind: !0,
        greedy: !0
      },
      {
        pattern: /(^|\s)\/\/.*|\/\*[\s\S]*?\*\//,
        lookbehind: !0,
        greedy: !0
      }
    ],
    "string-literal": {
      pattern: /"[^"\r\n]*"|[‘`']".*?"[’`']/,
      greedy: !0,
      inside: {
        interpolation: {
          pattern: /\$\{[^{}]*\}|[‘`']\w[^’`'\r\n]*[’`']/,
          inside: {
            punctuation: /^\$\{|\}$/,
            expression: {
              pattern: /[\s\S]+/,
              inside: null
              // see below
            }
          }
        },
        string: /[\s\S]+/
      }
    },
    mata: {
      pattern: /(^[ \t]*mata[ \t]*:)[\s\S]+?(?=^end\b)/m,
      lookbehind: !0,
      greedy: !0,
      alias: "language-mata",
      inside: t.languages.mata
    },
    java: {
      pattern: /(^[ \t]*java[ \t]*:)[\s\S]+?(?=^end\b)/m,
      lookbehind: !0,
      greedy: !0,
      alias: "language-java",
      inside: t.languages.java
    },
    python: {
      pattern: /(^[ \t]*python[ \t]*:)[\s\S]+?(?=^end\b)/m,
      lookbehind: !0,
      greedy: !0,
      alias: "language-python",
      inside: t.languages.python
    },
    command: {
      pattern: /(^[ \t]*(?:\.[ \t]+)?(?:(?:bayes|bootstrap|by|bysort|capture|collect|fmm|fp|frame|jackknife|mfp|mi|nestreg|noisily|permute|quietly|rolling|simulate|statsby|stepwise|svy|version|xi)\b[^:\r\n]*:[ \t]*|(?:capture|noisily|quietly|version)[ \t]+)?)[a-zA-Z]\w*/m,
      lookbehind: !0,
      greedy: !0,
      alias: "keyword"
    },
    variable: /\$\w+|[‘`']\w[^’`'\r\n]*[’`']/,
    keyword: /\b(?:bayes|bootstrap|by|bysort|capture|clear|collect|fmm|fp|frame|if|in|jackknife|mi[ \t]+estimate|mfp|nestreg|noisily|of|permute|quietly|rolling|simulate|sort|statsby|stepwise|svy|varlist|version|xi)\b/,
    boolean: /\b(?:off|on)\b/,
    number: /\b\d+(?:\.\d+)?\b|\B\.\d+/,
    function: /\b[a-z_]\w*(?=\()/i,
    operator: /\+\+|--|##?|[<>!=~]=?|[+\-*^&|/]/,
    punctuation: /[(){}[\],:]/
  }, t.languages.stata["string-literal"].inside.interpolation.inside.expression.inside = t.languages.stata;
}
QH.displayName = "iecst";
QH.aliases = [];
function QH(t) {
  t.languages.iecst = {
    comment: [
      {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?(?:\*\/|$)|\(\*[\s\S]*?(?:\*\)|$)|\{[\s\S]*?(?:\}|$))/,
        lookbehind: !0,
        greedy: !0
      },
      {
        pattern: /(^|[^\\:])\/\/.*/,
        lookbehind: !0,
        greedy: !0
      }
    ],
    string: {
      pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
      greedy: !0
    },
    keyword: [
      /\b(?:END_)?(?:PROGRAM|CONFIGURATION|INTERFACE|FUNCTION_BLOCK|FUNCTION|ACTION|TRANSITION|TYPE|STRUCT|(?:INITIAL_)?STEP|NAMESPACE|LIBRARY|CHANNEL|FOLDER|RESOURCE|VAR_(?:ACCESS|CONFIG|EXTERNAL|GLOBAL|INPUT|IN_OUT|OUTPUT|TEMP)|VAR|METHOD|PROPERTY)\b/i,
      /\b(?:AT|BY|(?:END_)?(?:CASE|FOR|IF|REPEAT|WHILE)|CONSTANT|CONTINUE|DO|ELSE|ELSIF|EXIT|EXTENDS|FROM|GET|GOTO|IMPLEMENTS|JMP|NON_RETAIN|OF|PRIVATE|PROTECTED|PUBLIC|RETAIN|RETURN|SET|TASK|THEN|TO|UNTIL|USING|WITH|__CATCH|__ENDTRY|__FINALLY|__TRY)\b/
    ],
    "class-name": /\b(?:ANY|ARRAY|BOOL|BYTE|U?(?:D|L|S)?INT|(?:D|L)?WORD|DATE(?:_AND_TIME)?|DT|L?REAL|POINTER|STRING|TIME(?:_OF_DAY)?|TOD)\b/,
    address: {
      pattern: /%[IQM][XBWDL][\d.]*|%[IQ][\d.]*/,
      alias: "symbol"
    },
    number: /\b(?:16#[\da-f]+|2#[01_]+|0x[\da-f]+)\b|\b(?:D|DT|T|TOD)#[\d_shmd:]*|\b[A-Z]*#[\d.,_]*|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    boolean: /\b(?:FALSE|NULL|TRUE)\b/,
    operator: /S?R?:?=>?|&&?|\*\*?|<[=>]?|>=?|[-:^/+#]|\b(?:AND|EQ|EXPT|GE|GT|LE|LT|MOD|NE|NOT|OR|XOR)\b/,
    function: /\b[a-z_]\w*(?=\s*\()/i,
    punctuation: /[()[\].,;]/
  };
}
jH.displayName = "supercollider";
jH.aliases = ["sclang"];
function jH(t) {
  t.languages.supercollider = {
    comment: {
      pattern: /\/\/.*|\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\//,
      greedy: !0
    },
    string: {
      pattern: /(^|[^\\])"(?:[^"\\]|\\[\s\S])*"/,
      lookbehind: !0,
      greedy: !0
    },
    char: {
      pattern: /\$(?:[^\\\r\n]|\\.)/,
      greedy: !0
    },
    symbol: {
      pattern: /(^|[^\\])'(?:[^'\\]|\\[\s\S])*'|\\\w+/,
      lookbehind: !0,
      greedy: !0
    },
    keyword: /\b(?:_|arg|classvar|const|nil|var|while)\b/,
    boolean: /\b(?:false|true)\b/,
    label: {
      pattern: /\b[a-z_]\w*(?=\s*:)/,
      alias: "property"
    },
    number: /\b(?:inf|pi|0x[0-9a-fA-F]+|\d+(?:\.\d+)?(?:[eE][+-]?\d+)?(?:pi)?|\d+r[0-9a-zA-Z]+(?:\.[0-9a-zA-Z]+)?|\d+[sb]{1,4}\d*)\b/,
    "class-name": /\b[A-Z]\w*\b/,
    operator: /\.{2,3}|#(?![[{])|&&|[!=]==?|\+>>|\+{1,3}|-[->]|=>|>>|\?\?|@\|?@|\|(?:@|[!=]=)?\||!\?|<[!=>]|\*{1,2}|<{2,3}\*?|[-!%&/<>?@|=`]/,
    punctuation: /[{}()[\].:,;]|#[[{]/
  }, t.languages.sclang = t.languages.supercollider;
}
GH.displayName = "systemd";
GH.aliases = [];
function GH(t) {
  (function(e) {
    var n = {
      pattern: /^[;#].*/m,
      greedy: !0
    }, r = /"(?:[^\r\n"\\]|\\(?:[^\r]|\r\n?))*"(?!\S)/.source;
    e.languages.systemd = {
      comment: n,
      section: {
        pattern: /^\[[^\n\r\[\]]*\](?=[ \t]*$)/m,
        greedy: !0,
        inside: {
          punctuation: /^\[|\]$/,
          "section-name": {
            pattern: /[\s\S]+/,
            alias: "selector"
          }
        }
      },
      key: {
        pattern: /^[^\s=]+(?=[ \t]*=)/m,
        greedy: !0,
        alias: "attr-name"
      },
      value: {
        // This pattern is quite complex because of two properties:
        //  1) Quotes (strings) must be preceded by a space. Since we can't use lookbehinds, we have to "resolve"
        //     the lookbehind. You will see this in the main loop where spaces are handled separately.
        //  2) Line continuations.
        //     After line continuations, empty lines and comments are ignored so we have to consume them.
        pattern: RegExp(
          /(=[ \t]*(?!\s))/.source + // the value either starts with quotes or not
          "(?:" + r + `|(?=[^"\r
]))(?:` + (/[^\s\\]/.source + // handle spaces separately because of quotes
          '|[ 	]+(?:(?![ 	"])|' + r + ")|" + /\\[\r\n]+(?:[#;].*[\r\n]+)*(?![#;])/.source) + ")*"
        ),
        lookbehind: !0,
        greedy: !0,
        alias: "attr-value",
        inside: {
          comment: n,
          quoted: {
            pattern: RegExp(/(^|\s)/.source + r),
            lookbehind: !0,
            greedy: !0
          },
          punctuation: /\\$/m,
          boolean: {
            pattern: /^(?:false|no|off|on|true|yes)$/,
            greedy: !0
          }
        }
      },
      punctuation: /=/
    };
  })(t);
}
M_.displayName = "t4-templating";
M_.aliases = [];
function M_(t) {
  (function(e) {
    function n(a, i, o) {
      return {
        pattern: RegExp("<#" + a + "[\\s\\S]*?#>"),
        alias: "block",
        inside: {
          delimiter: {
            pattern: RegExp("^<#" + a + "|#>$"),
            alias: "important"
          },
          content: {
            pattern: /[\s\S]+/,
            inside: i,
            alias: o
          }
        }
      };
    }
    function r(a) {
      var i = e.languages[a], o = "language-" + a;
      return {
        block: {
          pattern: /<#[\s\S]+?#>/,
          inside: {
            directive: n("@", {
              "attr-value": {
                pattern: /=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+)/,
                inside: {
                  punctuation: /^=|^["']|["']$/
                }
              },
              keyword: /\b\w+(?=\s)/,
              "attr-name": /\b\w+/
            }),
            expression: n("=", i, o),
            "class-feature": n("\\+", i, o),
            standard: n("", i, o)
          }
        }
      };
    }
    e.languages["t4-templating"] = Object.defineProperty({}, "createT4", {
      value: r
    });
  })(t);
}
VH.displayName = "t4-cs";
VH.aliases = ["t4"];
function VH(t) {
  t.register(A0), t.register(M_), t.languages.t4 = t.languages["t4-cs"] = t.languages["t4-templating"].createT4("csharp");
}
YH.displayName = "t4-vb";
YH.aliases = [];
function YH(t) {
  t.register(M_), t.register(D_), t.languages["t4-vb"] = t.languages["t4-templating"].createT4("vbnet");
}
ZH.displayName = "tap";
ZH.aliases = [];
function ZH(t) {
  t.register(k_), t.languages.tap = {
    fail: /not ok[^#{\n\r]*/,
    pass: /ok[^#{\n\r]*/,
    pragma: /pragma [+-][a-z]+/,
    bailout: /bail out!.*/i,
    version: /TAP version \d+/i,
    plan: /\b\d+\.\.\d+(?: +#.*)?/,
    subtest: {
      pattern: /# Subtest(?:: .*)?/,
      greedy: !0
    },
    punctuation: /[{}]/,
    directive: /#.*/,
    yamlish: {
      pattern: /(^[ \t]*)---[\s\S]*?[\r\n][ \t]*\.\.\.$/m,
      lookbehind: !0,
      inside: t.languages.yaml,
      alias: "language-yaml"
    }
  };
}
XH.displayName = "tcl";
XH.aliases = [];
function XH(t) {
  t.languages.tcl = {
    comment: {
      pattern: /(^|[^\\])#.*/,
      lookbehind: !0
    },
    string: {
      pattern: /"(?:[^"\\\r\n]|\\(?:\r\n|[\s\S]))*"/,
      greedy: !0
    },
    variable: [
      {
        pattern: /(\$)(?:::)?(?:[a-zA-Z0-9]+::)*\w+/,
        lookbehind: !0
      },
      {
        pattern: /(\$)\{[^}]+\}/,
        lookbehind: !0
      },
      {
        pattern: /(^[\t ]*set[ \t]+)(?:::)?(?:[a-zA-Z0-9]+::)*\w+/m,
        lookbehind: !0
      }
    ],
    function: {
      pattern: /(^[\t ]*proc[ \t]+)\S+/m,
      lookbehind: !0
    },
    builtin: [
      {
        pattern: /(^[\t ]*)(?:break|class|continue|error|eval|exit|for|foreach|if|proc|return|switch|while)\b/m,
        lookbehind: !0
      },
      /\b(?:else|elseif)\b/
    ],
    scope: {
      pattern: /(^[\t ]*)(?:global|upvar|variable)\b/m,
      lookbehind: !0,
      alias: "constant"
    },
    keyword: {
      pattern: /(^[\t ]*|\[)(?:Safe_Base|Tcl|after|append|apply|array|auto_(?:execok|import|load|mkindex|qualify|reset)|automkindex_old|bgerror|binary|catch|cd|chan|clock|close|concat|dde|dict|encoding|eof|exec|expr|fblocked|fconfigure|fcopy|file(?:event|name)?|flush|gets|glob|history|http|incr|info|interp|join|lappend|lassign|lindex|linsert|list|llength|load|lrange|lrepeat|lreplace|lreverse|lsearch|lset|lsort|math(?:func|op)|memory|msgcat|namespace|open|package|parray|pid|pkg_mkIndex|platform|puts|pwd|re_syntax|read|refchan|regexp|registry|regsub|rename|scan|seek|set|socket|source|split|string|subst|tcl(?:_endOfWord|_findLibrary|startOf(?:Next|Previous)Word|test|vars|wordBreak(?:After|Before))|tell|time|tm|trace|unknown|unload|unset|update|uplevel|vwait)\b/m,
      lookbehind: !0
    },
    operator: /!=?|\*\*?|==|&&?|\|\|?|<[=<]?|>[=>]?|[-+~\/%?^]|\b(?:eq|in|ne|ni)\b/,
    punctuation: /[{}()\[\]]/
  };
}
qH.displayName = "tt2";
qH.aliases = [];
function qH(t) {
  t.register(Lr), t.register(al), function(e) {
    e.languages.tt2 = e.languages.extend("clike", {
      comment: /#.*|\[%#[\s\S]*?%\]/,
      keyword: /\b(?:BLOCK|CALL|CASE|CATCH|CLEAR|DEBUG|DEFAULT|ELSE|ELSIF|END|FILTER|FINAL|FOREACH|GET|IF|IN|INCLUDE|INSERT|LAST|MACRO|META|NEXT|PERL|PROCESS|RAWPERL|RETURN|SET|STOP|SWITCH|TAGS|THROW|TRY|UNLESS|USE|WHILE|WRAPPER)\b/,
      punctuation: /[[\]{},()]/
    }), e.languages.insertBefore("tt2", "number", {
      operator: /=[>=]?|!=?|<=?|>=?|&&|\|\|?|\b(?:and|not|or)\b/,
      variable: {
        pattern: /\b[a-z]\w*(?:\s*\.\s*(?:\d+|\$?[a-z]\w*))*\b/i
      }
    }), e.languages.insertBefore("tt2", "keyword", {
      delimiter: {
        pattern: /^(?:\[%|%%)-?|-?%\]$/,
        alias: "punctuation"
      }
    }), e.languages.insertBefore("tt2", "string", {
      "single-quoted-string": {
        pattern: /'[^\\']*(?:\\[\s\S][^\\']*)*'/,
        greedy: !0,
        alias: "string"
      },
      "double-quoted-string": {
        pattern: /"[^\\"]*(?:\\[\s\S][^\\"]*)*"/,
        greedy: !0,
        alias: "string",
        inside: {
          variable: {
            pattern: /\$(?:[a-z]\w*(?:\.(?:\d+|\$?[a-z]\w*))*)/i
          }
        }
      }
    }), delete e.languages.tt2.string, e.hooks.add("before-tokenize", function(n) {
      var r = /\[%[\s\S]+?%\]/g;
      e.languages["markup-templating"].buildPlaceholders(
        n,
        "tt2",
        r
      );
    }), e.hooks.add("after-tokenize", function(n) {
      e.languages["markup-templating"].tokenizePlaceholders(n, "tt2");
    });
  }(t);
}
KH.displayName = "toml";
KH.aliases = [];
function KH(t) {
  (function(e) {
    var n = /(?:[\w-]+|'[^'\n\r]*'|"(?:\\.|[^\\"\r\n])*")/.source;
    function r(a) {
      return a.replace(/__/g, function() {
        return n;
      });
    }
    e.languages.toml = {
      comment: {
        pattern: /#.*/,
        greedy: !0
      },
      table: {
        pattern: RegExp(
          r(
            /(^[\t ]*\[\s*(?:\[\s*)?)__(?:\s*\.\s*__)*(?=\s*\])/.source
          ),
          "m"
        ),
        lookbehind: !0,
        greedy: !0,
        alias: "class-name"
      },
      key: {
        pattern: RegExp(
          r(/(^[\t ]*|[{,]\s*)__(?:\s*\.\s*__)*(?=\s*=)/.source),
          "m"
        ),
        lookbehind: !0,
        greedy: !0,
        alias: "property"
      },
      string: {
        pattern: /"""(?:\\[\s\S]|[^\\])*?"""|'''[\s\S]*?'''|'[^'\n\r]*'|"(?:\\.|[^\\"\r\n])*"/,
        greedy: !0
      },
      date: [
        {
          // Offset Date-Time, Local Date-Time, Local Date
          pattern: /\b\d{4}-\d{2}-\d{2}(?:[T\s]\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?)?\b/i,
          alias: "number"
        },
        {
          // Local Time
          pattern: /\b\d{2}:\d{2}:\d{2}(?:\.\d+)?\b/,
          alias: "number"
        }
      ],
      number: /(?:\b0(?:x[\da-zA-Z]+(?:_[\da-zA-Z]+)*|o[0-7]+(?:_[0-7]+)*|b[10]+(?:_[10]+)*))\b|[-+]?\b\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?(?:[eE][+-]?\d+(?:_\d+)*)?\b|[-+]?\b(?:inf|nan)\b/,
      boolean: /\b(?:false|true)\b/,
      punctuation: /[.,=[\]{}]/
    };
  })(t);
}
JH.displayName = "tremor";
JH.aliases = ["trickle", "troy"];
function JH(t) {
  (function(e) {
    e.languages.tremor = {
      comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
        lookbehind: !0
      },
      "interpolated-string": null,
      // see below
      extractor: {
        pattern: /\b[a-z_]\w*\|(?:[^\r\n\\|]|\\(?:\r\n|[\s\S]))*\|/i,
        greedy: !0,
        inside: {
          regex: {
            pattern: /(^re)\|[\s\S]+/,
            lookbehind: !0
          },
          function: /^\w+/,
          value: /\|[\s\S]+/
        }
      },
      identifier: {
        pattern: /`[^`]*`/,
        greedy: !0
      },
      function: /\b[a-z_]\w*(?=\s*(?:::\s*<|\())\b/,
      keyword: /\b(?:args|as|by|case|config|connect|connector|const|copy|create|default|define|deploy|drop|each|emit|end|erase|event|flow|fn|for|from|group|having|insert|into|intrinsic|let|links|match|merge|mod|move|of|operator|patch|pipeline|recur|script|select|set|sliding|state|stream|to|tumbling|update|use|when|where|window|with)\b/,
      boolean: /\b(?:false|null|true)\b/i,
      number: /\b(?:0b[01_]*|0x[0-9a-fA-F_]*|\d[\d_]*(?:\.\d[\d_]*)?(?:[Ee][+-]?[\d_]+)?)\b/,
      "pattern-punctuation": {
        pattern: /%(?=[({[])/,
        alias: "punctuation"
      },
      operator: /[-+*\/%~!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?>?=?|(?:absent|and|not|or|present|xor)\b/,
      punctuation: /::|[;\[\]()\{\},.:]/
    };
    var n = /#\{(?:[^"{}]|\{[^{}]*\}|"(?:[^"\\\r\n]|\\(?:\r\n|[\s\S]))*")*\}/.source;
    e.languages.tremor["interpolated-string"] = {
      pattern: RegExp(
        /(^|[^\\])/.source + '(?:"""(?:' + /[^"\\#]|\\[\s\S]|"(?!"")|#(?!\{)/.source + "|" + n + ')*"""|"(?:' + /[^"\\\r\n#]|\\(?:\r\n|[\s\S])|#(?!\{)/.source + "|" + n + ')*")'
      ),
      lookbehind: !0,
      greedy: !0,
      inside: {
        interpolation: {
          pattern: RegExp(n),
          inside: {
            punctuation: /^#\{|\}$/,
            expression: {
              pattern: /[\s\S]+/,
              inside: e.languages.tremor
            }
          }
        },
        string: /[\s\S]+/
      }
    }, e.languages.troy = e.languages.tremor, e.languages.trickle = e.languages.tremor;
  })(t);
}
e7.displayName = "typoscript";
e7.aliases = ["tsconfig"];
function e7(t) {
  (function(e) {
    var n = /\b(?:ACT|ACTIFSUB|CARRAY|CASE|CLEARGIF|COA|COA_INT|CONSTANTS|CONTENT|CUR|EDITPANEL|EFFECT|EXT|FILE|FLUIDTEMPLATE|FORM|FRAME|FRAMESET|GIFBUILDER|GMENU|GMENU_FOLDOUT|GMENU_LAYERS|GP|HMENU|HRULER|HTML|IENV|IFSUB|IMAGE|IMGMENU|IMGMENUITEM|IMGTEXT|IMG_RESOURCE|INCLUDE_TYPOSCRIPT|JSMENU|JSMENUITEM|LLL|LOAD_REGISTER|NO|PAGE|RECORDS|RESTORE_REGISTER|TEMPLATE|TEXT|TMENU|TMENUITEM|TMENU_LAYERS|USER|USER_INT|_GIFBUILDER|global|globalString|globalVar)\b/;
    e.languages.typoscript = {
      comment: [
        {
          // multiline comments /* */
          pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
          lookbehind: !0
        },
        {
          // double-slash comments - ignored when backslashes or colon is found in front
          // also ignored whenever directly after an equal-sign, because it would probably be an url without protocol
          pattern: /(^|[^\\:= \t]|(?:^|[^= \t])[ \t]+)\/\/.*/,
          lookbehind: !0,
          greedy: !0
        },
        {
          // hash comments - ignored when leading quote is found for hex colors in strings
          pattern: /(^|[^"'])#.*/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      function: [
        {
          // old include style
          pattern: /<INCLUDE_TYPOSCRIPT:\s*source\s*=\s*(?:"[^"\r\n]*"|'[^'\r\n]*')\s*>/,
          inside: {
            string: {
              pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
              inside: {
                keyword: n
              }
            },
            keyword: {
              pattern: /INCLUDE_TYPOSCRIPT/
            }
          }
        },
        {
          // new include style
          pattern: /@import\s*(?:"[^"\r\n]*"|'[^'\r\n]*')/,
          inside: {
            string: /"[^"\r\n]*"|'[^'\r\n]*'/
          }
        }
      ],
      string: {
        pattern: /^([^=]*=[< ]?)(?:(?!\]\n).)*/,
        lookbehind: !0,
        inside: {
          function: /\{\$.*\}/,
          // constants include
          keyword: n,
          number: /^\d+$/,
          punctuation: /[,|:]/
        }
      },
      keyword: n,
      number: {
        // special highlighting for indexes of arrays in tags
        pattern: /\b\d+\s*[.{=]/,
        inside: {
          operator: /[.{=]/
        }
      },
      tag: {
        pattern: /\.?[-\w\\]+\.?/,
        inside: {
          punctuation: /\./
        }
      },
      punctuation: /[{}[\];(),.:|]/,
      operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/
    }, e.languages.tsconfig = e.languages.typoscript;
  })(t);
}
t7.displayName = "unrealscript";
t7.aliases = ["uc", "uscript"];
function t7(t) {
  t.languages.unrealscript = {
    comment: /\/\/.*|\/\*[\s\S]*?\*\//,
    string: {
      pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
      greedy: !0
    },
    category: {
      pattern: /(\b(?:(?:autoexpand|hide|show)categories|var)\s*\()[^()]+(?=\))/,
      lookbehind: !0,
      greedy: !0,
      alias: "property"
    },
    metadata: {
      pattern: /(\w\s*)<\s*\w+\s*=[^<>|=\r\n]+(?:\|\s*\w+\s*=[^<>|=\r\n]+)*>/,
      lookbehind: !0,
      greedy: !0,
      inside: {
        property: /\b\w+(?=\s*=)/,
        operator: /=/,
        punctuation: /[<>|]/
      }
    },
    macro: {
      pattern: /`\w+/,
      alias: "property"
    },
    "class-name": {
      pattern: /(\b(?:class|enum|extends|interface|state(?:\(\))?|struct|within)\s+)\w+/,
      lookbehind: !0
    },
    keyword: /\b(?:abstract|actor|array|auto|autoexpandcategories|bool|break|byte|case|class|classgroup|client|coerce|collapsecategories|config|const|continue|default|defaultproperties|delegate|dependson|deprecated|do|dontcollapsecategories|editconst|editinlinenew|else|enum|event|exec|export|extends|final|float|for|forcescriptorder|foreach|function|goto|guid|hidecategories|hidedropdown|if|ignores|implements|inherits|input|int|interface|iterator|latent|local|material|name|native|nativereplication|noexport|nontransient|noteditinlinenew|notplaceable|operator|optional|out|pawn|perobjectconfig|perobjectlocalized|placeable|postoperator|preoperator|private|protected|reliable|replication|return|server|showcategories|simulated|singular|state|static|string|struct|structdefault|structdefaultproperties|switch|texture|transient|travel|unreliable|until|var|vector|while|within)\b/,
    function: /\b[a-z_]\w*(?=\s*\()/i,
    boolean: /\b(?:false|true)\b/,
    number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    // https://docs.unrealengine.com/udk/Three/UnrealScriptExpressions.html
    operator: />>|<<|--|\+\+|\*\*|[-+*/~!=<>$@]=?|&&?|\|\|?|\^\^?|[?:%]|\b(?:ClockwiseFrom|Cross|Dot)\b/,
    punctuation: /[()[\]{};,.]/
  }, t.languages.uc = t.languages.uscript = t.languages.unrealscript;
}
n7.displayName = "uorazor";
n7.aliases = [];
function n7(t) {
  t.languages.uorazor = {
    "comment-hash": {
      pattern: /#.*/,
      alias: "comment",
      greedy: !0
    },
    "comment-slash": {
      pattern: /\/\/.*/,
      alias: "comment",
      greedy: !0
    },
    string: {
      pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
      inside: {
        punctuation: /^['"]|['"]$/
      },
      greedy: !0
    },
    "source-layers": {
      pattern: /\b(?:arms|backpack|blue|bracelet|cancel|clear|cloak|criminal|earrings|enemy|facialhair|friend|friendly|gloves|gray|grey|ground|hair|head|innerlegs|innertorso|innocent|lefthand|middletorso|murderer|neck|nonfriendly|onehandedsecondary|outerlegs|outertorso|pants|red|righthand|ring|self|shirt|shoes|talisman|waist)\b/i,
      alias: "function"
    },
    "source-commands": {
      pattern: /\b(?:alliance|attack|cast|clearall|clearignore|clearjournal|clearlist|clearsysmsg|createlist|createtimer|dclick|dclicktype|dclickvar|dress|dressconfig|drop|droprelloc|emote|getlabel|guild|gumpclose|gumpresponse|hotkey|ignore|lasttarget|lift|lifttype|menu|menuresponse|msg|org|organize|organizer|overhead|pause|poplist|potion|promptresponse|pushlist|removelist|removetimer|rename|restock|say|scav|scavenger|script|setability|setlasttarget|setskill|settimer|setvar|sysmsg|target|targetloc|targetrelloc|targettype|undress|unignore|unsetvar|useobject|useonce|useskill|usetype|virtue|wait|waitforgump|waitformenu|waitforprompt|waitforstat|waitforsysmsg|waitfortarget|walk|wfsysmsg|wft|whisper|yell)\b/,
      alias: "function"
    },
    "tag-name": {
      pattern: /(^\{%-?\s*)\w+/,
      lookbehind: !0,
      alias: "keyword"
    },
    delimiter: {
      pattern: /^\{[{%]-?|-?[%}]\}$/,
      alias: "punctuation"
    },
    function: /\b(?:atlist|close|closest|count|counter|counttype|dead|dex|diffhits|diffmana|diffstam|diffweight|find|findbuff|finddebuff|findlayer|findtype|findtypelist|followers|gumpexists|hidden|hits|hp|hue|human|humanoid|ingump|inlist|insysmessage|insysmsg|int|invul|lhandempty|list|listexists|mana|maxhits|maxhp|maxmana|maxstam|maxweight|monster|mounted|name|next|noto|paralyzed|poisoned|position|prev|previous|queued|rand|random|rhandempty|skill|stam|str|targetexists|timer|timerexists|varexist|warmode|weight)\b/,
    keyword: /\b(?:and|as|break|continue|else|elseif|endfor|endif|endwhile|for|if|loop|not|or|replay|stop|while)\b/,
    boolean: /\b(?:false|null|true)\b/,
    number: /\b0x[\dA-Fa-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][-+]?\d+)?/,
    operator: [
      {
        pattern: /(\s)(?:and|b-and|b-or|b-xor|ends with|in|is|matches|not|or|same as|starts with)(?=\s)/,
        lookbehind: !0
      },
      /[=<>]=?|!=|\*\*?|\/\/?|\?:?|[-+~%|]/
    ],
    punctuation: /[()\[\]{}:.,]/
  };
}
r7.displayName = "v";
r7.aliases = [];
function r7(t) {
  t.register(Lr), function(e) {
    var n = {
      pattern: /[\s\S]+/,
      inside: null
    };
    e.languages.v = e.languages.extend("clike", {
      string: {
        pattern: /r?(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        alias: "quoted-string",
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:\{[^{}]*\}|\w+(?:\.\w+(?:\([^\(\)]*\))?|\[[^\[\]]+\])*)/,
            lookbehind: !0,
            inside: {
              "interpolation-variable": {
                pattern: /^\$\w[\s\S]*$/,
                alias: "variable"
              },
              "interpolation-punctuation": {
                pattern: /^\$\{|\}$/,
                alias: "punctuation"
              },
              "interpolation-expression": n
            }
          }
        }
      },
      "class-name": {
        pattern: /(\b(?:enum|interface|struct|type)\s+)(?:C\.)?\w+/,
        lookbehind: !0
      },
      keyword: /(?:\b(?:__global|as|asm|assert|atomic|break|chan|const|continue|defer|else|embed|enum|fn|for|go(?:to)?|if|import|in|interface|is|lock|match|module|mut|none|or|pub|return|rlock|select|shared|sizeof|static|struct|type(?:of)?|union|unsafe)|\$(?:else|for|if)|#(?:flag|include))\b/,
      number: /\b(?:0x[a-f\d]+(?:_[a-f\d]+)*|0b[01]+(?:_[01]+)*|0o[0-7]+(?:_[0-7]+)*|\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?)\b/i,
      operator: /~|\?|[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\.?/,
      builtin: /\b(?:any(?:_float|_int)?|bool|byte(?:ptr)?|charptr|f(?:32|64)|i(?:8|16|64|128|nt)|rune|size_t|string|u(?:16|32|64|128)|voidptr)\b/
    }), n.inside = e.languages.v, e.languages.insertBefore("v", "string", {
      char: {
        pattern: /`(?:\\`|\\?[^`]{1,2})`/,
        // using {1,2} instead of `u` flag for compatibility
        alias: "rune"
      }
    }), e.languages.insertBefore("v", "operator", {
      attribute: {
        pattern: /(^[\t ]*)\[(?:deprecated|direct_array_access|flag|inline|live|ref_only|typedef|unsafe_fn|windows_stdcall)\]/m,
        lookbehind: !0,
        alias: "annotation",
        inside: {
          punctuation: /[\[\]]/,
          keyword: /\w+/
        }
      },
      generic: {
        pattern: /<\w+>(?=\s*[\)\{])/,
        inside: {
          punctuation: /[<>]/,
          "class-name": /\w+/
        }
      }
    }), e.languages.insertBefore("v", "function", {
      "generic-function": {
        // e.g. foo<T>( ...
        pattern: /\b\w+\s*<\w+>(?=\()/,
        inside: {
          function: /^\w+/,
          generic: {
            pattern: /<\w+>/,
            inside: e.languages.v.generic.inside
          }
        }
      }
    });
  }(t);
}
a7.displayName = "vala";
a7.aliases = [];
function a7(t) {
  t.register(Lr), t.languages.vala = t.languages.extend("clike", {
    // Classes copied from prism-csharp
    "class-name": [
      {
        // (Foo bar, Bar baz)
        pattern: /\b[A-Z]\w*(?:\.\w+)*\b(?=(?:\?\s+|\*?\s+\*?)\w)/,
        inside: {
          punctuation: /\./
        }
      },
      {
        // [Foo]
        pattern: /(\[)[A-Z]\w*(?:\.\w+)*\b/,
        lookbehind: !0,
        inside: {
          punctuation: /\./
        }
      },
      {
        // class Foo : Bar
        pattern: /(\b(?:class|interface)\s+[A-Z]\w*(?:\.\w+)*\s*:\s*)[A-Z]\w*(?:\.\w+)*\b/,
        lookbehind: !0,
        inside: {
          punctuation: /\./
        }
      },
      {
        // class Foo
        pattern: /((?:\b(?:class|enum|interface|new|struct)\s+)|(?:catch\s+\())[A-Z]\w*(?:\.\w+)*\b/,
        lookbehind: !0,
        inside: {
          punctuation: /\./
        }
      }
    ],
    keyword: /\b(?:abstract|as|assert|async|base|bool|break|case|catch|char|class|const|construct|continue|default|delegate|delete|do|double|dynamic|else|ensures|enum|errordomain|extern|finally|float|for|foreach|get|if|in|inline|int|int16|int32|int64|int8|interface|internal|is|lock|long|namespace|new|null|out|override|owned|params|private|protected|public|ref|requires|return|set|short|signal|sizeof|size_t|ssize_t|static|string|struct|switch|this|throw|throws|try|typeof|uchar|uint|uint16|uint32|uint64|uint8|ulong|unichar|unowned|ushort|using|value|var|virtual|void|volatile|weak|while|yield)\b/i,
    function: /\b\w+(?=\s*\()/,
    number: /(?:\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)(?:f|u?l?)?/i,
    operator: /\+\+|--|&&|\|\||<<=?|>>=?|=>|->|~|[+\-*\/%&^|=!<>]=?|\?\??|\.\.\./,
    punctuation: /[{}[\];(),.:]/,
    constant: /\b[A-Z0-9_]+\b/
  }), t.languages.insertBefore("vala", "string", {
    "raw-string": {
      pattern: /"""[\s\S]*?"""/,
      greedy: !0,
      alias: "string"
    },
    "template-string": {
      pattern: /@"[\s\S]*?"/,
      greedy: !0,
      inside: {
        interpolation: {
          pattern: /\$(?:\([^)]*\)|[a-zA-Z]\w*)/,
          inside: {
            delimiter: {
              pattern: /^\$\(?|\)$/,
              alias: "punctuation"
            },
            rest: t.languages.vala
          }
        },
        string: /[\s\S]+/
      }
    }
  }), t.languages.insertBefore("vala", "keyword", {
    regex: {
      pattern: /\/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[imsx]{0,4}(?=\s*(?:$|[\r\n,.;})\]]))/,
      greedy: !0,
      inside: {
        "regex-source": {
          pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
          lookbehind: !0,
          alias: "language-regex",
          inside: t.languages.regex
        },
        "regex-delimiter": /^\//,
        "regex-flags": /^[a-z]+$/
      }
    }
  });
}
i7.displayName = "velocity";
i7.aliases = [];
function i7(t) {
  t.register(ws), function(e) {
    e.languages.velocity = e.languages.extend("markup", {});
    var n = {
      variable: {
        pattern: /(^|[^\\](?:\\\\)*)\$!?(?:[a-z][\w-]*(?:\([^)]*\))?(?:\.[a-z][\w-]*(?:\([^)]*\))?|\[[^\]]+\])*|\{[^}]+\})/i,
        lookbehind: !0,
        inside: {}
        // See below
      },
      string: {
        pattern: /"[^"]*"|'[^']*'/,
        greedy: !0
      },
      number: /\b\d+\b/,
      boolean: /\b(?:false|true)\b/,
      operator: /[=!<>]=?|[+*/%-]|&&|\|\||\.\.|\b(?:eq|g[et]|l[et]|n(?:e|ot))\b/,
      punctuation: /[(){}[\]:,.]/
    };
    n.variable.inside = {
      string: n.string,
      function: {
        pattern: /([^\w-])[a-z][\w-]*(?=\()/,
        lookbehind: !0
      },
      number: n.number,
      boolean: n.boolean,
      punctuation: n.punctuation
    }, e.languages.insertBefore("velocity", "comment", {
      unparsed: {
        pattern: /(^|[^\\])#\[\[[\s\S]*?\]\]#/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          punctuation: /^#\[\[|\]\]#$/
        }
      },
      "velocity-comment": [
        {
          pattern: /(^|[^\\])#\*[\s\S]*?\*#/,
          lookbehind: !0,
          greedy: !0,
          alias: "comment"
        },
        {
          pattern: /(^|[^\\])##.*/,
          lookbehind: !0,
          greedy: !0,
          alias: "comment"
        }
      ],
      directive: {
        pattern: /(^|[^\\](?:\\\\)*)#@?(?:[a-z][\w-]*|\{[a-z][\w-]*\})(?:\s*\((?:[^()]|\([^()]*\))*\))?/i,
        lookbehind: !0,
        inside: {
          keyword: {
            pattern: /^#@?(?:[a-z][\w-]*|\{[a-z][\w-]*\})|\bin\b/,
            inside: {
              punctuation: /[{}]/
            }
          },
          rest: n
        }
      },
      variable: n.variable
    }), e.languages.velocity.tag.inside["attr-value"].inside.rest = e.languages.velocity;
  }(t);
}
o7.displayName = "verilog";
o7.aliases = [];
function o7(t) {
  t.languages.verilog = {
    comment: {
      pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
      greedy: !0
    },
    string: {
      pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
      greedy: !0
    },
    "kernel-function": {
      // support for any kernel function (ex: $display())
      pattern: /\B\$\w+\b/,
      alias: "property"
    },
    // support for user defined constants (ex: `define)
    constant: /\B`\w+\b/,
    function: /\b\w+(?=\()/,
    // support for verilog and system verilog keywords
    keyword: /\b(?:alias|and|assert|assign|assume|automatic|before|begin|bind|bins|binsof|bit|break|buf|bufif0|bufif1|byte|case|casex|casez|cell|chandle|class|clocking|cmos|config|const|constraint|context|continue|cover|covergroup|coverpoint|cross|deassign|default|defparam|design|disable|dist|do|edge|else|end|endcase|endclass|endclocking|endconfig|endfunction|endgenerate|endgroup|endinterface|endmodule|endpackage|endprimitive|endprogram|endproperty|endsequence|endspecify|endtable|endtask|enum|event|expect|export|extends|extern|final|first_match|for|force|foreach|forever|fork|forkjoin|function|generate|genvar|highz0|highz1|if|iff|ifnone|ignore_bins|illegal_bins|import|incdir|include|initial|inout|input|inside|instance|int|integer|interface|intersect|join|join_any|join_none|large|liblist|library|local|localparam|logic|longint|macromodule|matches|medium|modport|module|nand|negedge|new|nmos|nor|noshowcancelled|not|notif0|notif1|null|or|output|package|packed|parameter|pmos|posedge|primitive|priority|program|property|protected|pull0|pull1|pulldown|pullup|pulsestyle_ondetect|pulsestyle_onevent|pure|rand|randc|randcase|randsequence|rcmos|real|realtime|ref|reg|release|repeat|return|rnmos|rpmos|rtran|rtranif0|rtranif1|scalared|sequence|shortint|shortreal|showcancelled|signed|small|solve|specify|specparam|static|string|strong0|strong1|struct|super|supply0|supply1|table|tagged|task|this|throughout|time|timeprecision|timeunit|tran|tranif0|tranif1|tri|tri0|tri1|triand|trior|trireg|type|typedef|union|unique|unsigned|use|uwire|var|vectored|virtual|void|wait|wait_order|wand|weak0|weak1|while|wildcard|wire|with|within|wor|xnor|xor)\b/,
    // bold highlighting for all verilog and system verilog logic blocks
    important: /\b(?:always|always_comb|always_ff|always_latch)\b(?: *@)?/,
    // support for time ticks, vectors, and real numbers
    number: /\B##?\d+|(?:\b\d+)?'[odbh] ?[\da-fzx_?]+|\b(?:\d*[._])?\d+(?:e[-+]?\d+)?/i,
    operator: /[-+{}^~%*\/?=!<>&|]+/,
    punctuation: /[[\];(),.:]/
  };
}
s7.displayName = "vhdl";
s7.aliases = [];
function s7(t) {
  t.languages.vhdl = {
    comment: /--.+/,
    // support for all logic vectors
    "vhdl-vectors": {
      pattern: /\b[oxb]"[\da-f_]+"|"[01uxzwlh-]+"/i,
      alias: "number"
    },
    // support for operator overloading included
    "quoted-function": {
      pattern: /"\S+?"(?=\()/,
      alias: "function"
    },
    string: /"(?:[^\\"\r\n]|\\(?:\r\n|[\s\S]))*"/,
    attribute: {
      pattern: /\b'\w+/,
      alias: "attr-name"
    },
    // support for predefined attributes included
    keyword: /\b(?:access|after|alias|all|architecture|array|assert|attribute|begin|block|body|buffer|bus|case|component|configuration|constant|disconnect|downto|else|elsif|end|entity|exit|file|for|function|generate|generic|group|guarded|if|impure|in|inertial|inout|is|label|library|linkage|literal|loop|map|new|next|null|of|on|open|others|out|package|port|postponed|private|procedure|process|pure|range|record|register|reject|report|return|select|severity|shared|signal|subtype|then|to|transport|type|unaffected|units|until|use|variable|view|wait|when|while|with)\b/i,
    boolean: /\b(?:false|true)\b/i,
    function: /\w+(?=\()/,
    // decimal, based, physical, and exponential numbers supported
    number: /'[01uxzwlh-]'|\b(?:\d+#[\da-f_.]+#|\d[\d_.]*)(?:e[-+]?\d+)?/i,
    operator: /[<>]=?|:=|[-+*/&=]|\b(?:abs|and|mod|nand|nor|not|or|rem|rol|ror|sla|sll|sra|srl|xnor|xor)\b/i,
    punctuation: /[{}[\];(),.:]/
  };
}
l7.displayName = "vim";
l7.aliases = [];
function l7(t) {
  t.languages.vim = {
    string: /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\r\n]|'')*'/,
    comment: /".*/,
    function: /\b\w+(?=\()/,
    keyword: /\b(?:N|Next|P|Print|X|XMLent|XMLns|ab|abbreviate|abc|abclear|abo|aboveleft|al|all|ar|arga|argadd|argd|argdelete|argdo|arge|argedit|argg|argglobal|argl|arglocal|args|argu|argument|as|ascii|b|bN|bNext|ba|bad|badd|ball|bd|bdelete|be|bel|belowright|bf|bfirst|bl|blast|bm|bmodified|bn|bnext|bo|botright|bp|bprevious|br|brea|break|breaka|breakadd|breakd|breakdel|breakl|breaklist|brewind|bro|browse|bufdo|buffer|buffers|bun|bunload|bw|bwipeout|c|cN|cNext|cNfcNfile|ca|cabbrev|cabc|cabclear|cad|caddb|caddbuffer|caddexpr|caddf|caddfile|cal|call|cat|catch|cb|cbuffer|cc|ccl|cclose|cd|ce|center|cex|cexpr|cf|cfile|cfir|cfirst|cg|cgetb|cgetbuffer|cgete|cgetexpr|cgetfile|change|changes|chd|chdir|che|checkpath|checkt|checktime|cl|cla|clast|clist|clo|close|cmapc|cmapclear|cn|cnew|cnewer|cnext|cnf|cnfile|cnorea|cnoreabbrev|co|col|colder|colo|colorscheme|comc|comclear|comp|compiler|con|conf|confirm|continue|cope|copen|copy|cp|cpf|cpfile|cprevious|cq|cquit|cr|crewind|cu|cuna|cunabbrev|cunmap|cw|cwindow|d|debugg|debuggreedy|delc|delcommand|delete|delf|delfunction|delm|delmarks|di|diffg|diffget|diffoff|diffpatch|diffpu|diffput|diffsplit|diffthis|diffu|diffupdate|dig|digraphs|display|dj|djump|dl|dlist|dr|drop|ds|dsearch|dsp|dsplit|e|earlier|echoe|echoerr|echom|echomsg|echon|edit|el|else|elsei|elseif|em|emenu|en|endf|endfo|endfor|endfun|endfunction|endif|endt|endtry|endw|endwhile|ene|enew|ex|exi|exit|exu|exusage|f|file|files|filetype|fin|fina|finally|find|fini|finish|fir|first|fix|fixdel|fo|fold|foldc|foldclose|foldd|folddoc|folddoclosed|folddoopen|foldo|foldopen|for|fu|fun|function|go|goto|gr|grep|grepa|grepadd|h|ha|hardcopy|help|helpf|helpfind|helpg|helpgrep|helpt|helptags|hid|hide|his|history|ia|iabbrev|iabc|iabclear|if|ij|ijump|il|ilist|imapc|imapclear|in|inorea|inoreabbrev|isearch|isp|isplit|iu|iuna|iunabbrev|iunmap|j|join|ju|jumps|k|kee|keepalt|keepj|keepjumps|keepmarks|l|lN|lNext|lNf|lNfile|la|lad|laddb|laddbuffer|laddexpr|laddf|laddfile|lan|language|last|later|lb|lbuffer|lc|lcd|lch|lchdir|lcl|lclose|left|lefta|leftabove|let|lex|lexpr|lf|lfile|lfir|lfirst|lg|lgetb|lgetbuffer|lgete|lgetexpr|lgetfile|lgr|lgrep|lgrepa|lgrepadd|lh|lhelpgrep|list|ll|lla|llast|lli|llist|lm|lmak|lmake|lmap|lmapc|lmapclear|ln|lne|lnew|lnewer|lnext|lnf|lnfile|lnoremap|lo|loadview|loc|lockmarks|lockv|lockvar|lol|lolder|lop|lopen|lp|lpf|lpfile|lprevious|lr|lrewind|ls|lt|ltag|lu|lunmap|lv|lvimgrep|lvimgrepa|lvimgrepadd|lw|lwindow|m|ma|mak|make|mark|marks|mat|match|menut|menutranslate|mk|mkexrc|mks|mksession|mksp|mkspell|mkv|mkvie|mkview|mkvimrc|mod|mode|move|mz|mzf|mzfile|mzscheme|n|nbkey|new|next|nmapc|nmapclear|noh|nohlsearch|norea|noreabbrev|nu|number|nun|nunmap|o|omapc|omapclear|on|only|open|opt|options|ou|ounmap|p|pc|pclose|pe|ped|pedit|perl|perld|perldo|po|pop|popu|popup|pp|ppop|pre|preserve|prev|previous|print|prof|profd|profdel|profile|promptf|promptfind|promptr|promptrepl|ps|psearch|ptN|ptNext|pta|ptag|ptf|ptfirst|ptj|ptjump|ptl|ptlast|ptn|ptnext|ptp|ptprevious|ptr|ptrewind|pts|ptselect|pu|put|pw|pwd|py|pyf|pyfile|python|q|qa|qall|quit|quita|quitall|r|read|rec|recover|red|redi|redir|redo|redr|redraw|redraws|redrawstatus|reg|registers|res|resize|ret|retab|retu|return|rew|rewind|ri|right|rightb|rightbelow|ru|rub|ruby|rubyd|rubydo|rubyf|rubyfile|runtime|rv|rviminfo|sN|sNext|sa|sal|sall|san|sandbox|sargument|sav|saveas|sb|sbN|sbNext|sba|sball|sbf|sbfirst|sbl|sblast|sbm|sbmodified|sbn|sbnext|sbp|sbprevious|sbr|sbrewind|sbuffer|scrip|scripte|scriptencoding|scriptnames|se|set|setf|setfiletype|setg|setglobal|setl|setlocal|sf|sfind|sfir|sfirst|sh|shell|sign|sil|silent|sim|simalt|sl|sla|slast|sleep|sm|smagic|smap|smapc|smapclear|sme|smenu|sn|snext|sni|sniff|sno|snomagic|snor|snoremap|snoreme|snoremenu|so|sor|sort|source|sp|spe|spelld|spelldump|spellgood|spelli|spellinfo|spellr|spellrepall|spellu|spellundo|spellw|spellwrong|split|spr|sprevious|sre|srewind|st|sta|stag|star|startg|startgreplace|startinsert|startr|startreplace|stj|stjump|stop|stopi|stopinsert|sts|stselect|sun|sunhide|sunm|sunmap|sus|suspend|sv|sview|syncbind|t|tN|tNext|ta|tab|tabN|tabNext|tabc|tabclose|tabd|tabdo|tabe|tabedit|tabf|tabfind|tabfir|tabfirst|tabl|tablast|tabm|tabmove|tabn|tabnew|tabnext|tabo|tabonly|tabp|tabprevious|tabr|tabrewind|tabs|tag|tags|tc|tcl|tcld|tcldo|tclf|tclfile|te|tearoff|tf|tfirst|th|throw|tj|tjump|tl|tlast|tm|tmenu|tn|tnext|to|topleft|tp|tprevious|tr|trewind|try|ts|tselect|tu|tunmenu|u|una|unabbreviate|undo|undoj|undojoin|undol|undolist|unh|unhide|unlet|unlo|unlockvar|unm|unmap|up|update|ve|verb|verbose|version|vert|vertical|vi|vie|view|vim|vimgrep|vimgrepa|vimgrepadd|visual|viu|viusage|vmapc|vmapclear|vne|vnew|vs|vsplit|vu|vunmap|w|wN|wNext|wa|wall|wh|while|win|winc|wincmd|windo|winp|winpos|winsize|wn|wnext|wp|wprevious|wq|wqa|wqall|write|ws|wsverb|wv|wviminfo|x|xa|xall|xit|xm|xmap|xmapc|xmapclear|xme|xmenu|xn|xnoremap|xnoreme|xnoremenu|xu|xunmap|y|yank)\b/,
    builtin: /\b(?:acd|ai|akm|aleph|allowrevins|altkeymap|ambiwidth|ambw|anti|antialias|arab|arabic|arabicshape|ari|arshape|autochdir|autocmd|autoindent|autoread|autowrite|autowriteall|aw|awa|background|backspace|backup|backupcopy|backupdir|backupext|backupskip|balloondelay|ballooneval|balloonexpr|bdir|bdlay|beval|bex|bexpr|bg|bh|bin|binary|biosk|bioskey|bk|bkc|bomb|breakat|brk|browsedir|bs|bsdir|bsk|bt|bufhidden|buflisted|buftype|casemap|ccv|cdpath|cedit|cfu|ch|charconvert|ci|cin|cindent|cink|cinkeys|cino|cinoptions|cinw|cinwords|clipboard|cmdheight|cmdwinheight|cmp|cms|columns|com|comments|commentstring|compatible|complete|completefunc|completeopt|consk|conskey|copyindent|cot|cpo|cpoptions|cpt|cscopepathcomp|cscopeprg|cscopequickfix|cscopetag|cscopetagorder|cscopeverbose|cspc|csprg|csqf|cst|csto|csverb|cuc|cul|cursorcolumn|cursorline|cwh|debug|deco|def|define|delcombine|dex|dg|dict|dictionary|diff|diffexpr|diffopt|digraph|dip|dir|directory|dy|ea|ead|eadirection|eb|ed|edcompatible|ef|efm|ei|ek|enc|encoding|endofline|eol|ep|equalalways|equalprg|errorbells|errorfile|errorformat|esckeys|et|eventignore|expandtab|exrc|fcl|fcs|fdc|fde|fdi|fdl|fdls|fdm|fdn|fdo|fdt|fen|fenc|fencs|fex|ff|ffs|fileencoding|fileencodings|fileformat|fileformats|fillchars|fk|fkmap|flp|fml|fmr|foldcolumn|foldenable|foldexpr|foldignore|foldlevel|foldlevelstart|foldmarker|foldmethod|foldminlines|foldnestmax|foldtext|formatexpr|formatlistpat|formatoptions|formatprg|fp|fs|fsync|ft|gcr|gd|gdefault|gfm|gfn|gfs|gfw|ghr|gp|grepformat|grepprg|gtl|gtt|guicursor|guifont|guifontset|guifontwide|guiheadroom|guioptions|guipty|guitablabel|guitabtooltip|helpfile|helpheight|helplang|hf|hh|hi|hidden|highlight|hk|hkmap|hkmapp|hkp|hl|hlg|hls|hlsearch|ic|icon|iconstring|ignorecase|im|imactivatekey|imak|imc|imcmdline|imd|imdisable|imi|iminsert|ims|imsearch|inc|include|includeexpr|incsearch|inde|indentexpr|indentkeys|indk|inex|inf|infercase|insertmode|invacd|invai|invakm|invallowrevins|invaltkeymap|invanti|invantialias|invar|invarab|invarabic|invarabicshape|invari|invarshape|invautochdir|invautoindent|invautoread|invautowrite|invautowriteall|invaw|invawa|invbackup|invballooneval|invbeval|invbin|invbinary|invbiosk|invbioskey|invbk|invbl|invbomb|invbuflisted|invcf|invci|invcin|invcindent|invcompatible|invconfirm|invconsk|invconskey|invcopyindent|invcp|invcscopetag|invcscopeverbose|invcst|invcsverb|invcuc|invcul|invcursorcolumn|invcursorline|invdeco|invdelcombine|invdg|invdiff|invdigraph|invdisable|invea|inveb|inved|invedcompatible|invek|invendofline|inveol|invequalalways|inverrorbells|invesckeys|invet|invex|invexpandtab|invexrc|invfen|invfk|invfkmap|invfoldenable|invgd|invgdefault|invguipty|invhid|invhidden|invhk|invhkmap|invhkmapp|invhkp|invhls|invhlsearch|invic|invicon|invignorecase|invim|invimc|invimcmdline|invimd|invincsearch|invinf|invinfercase|invinsertmode|invis|invjoinspaces|invjs|invlazyredraw|invlbr|invlinebreak|invlisp|invlist|invloadplugins|invlpl|invlz|invma|invmacatsui|invmagic|invmh|invml|invmod|invmodeline|invmodifiable|invmodified|invmore|invmousef|invmousefocus|invmousehide|invnu|invnumber|invodev|invopendevice|invpaste|invpi|invpreserveindent|invpreviewwindow|invprompt|invpvw|invreadonly|invremap|invrestorescreen|invrevins|invri|invrightleft|invrightleftcmd|invrl|invrlc|invro|invrs|invru|invruler|invsb|invsc|invscb|invscrollbind|invscs|invsecure|invsft|invshellslash|invshelltemp|invshiftround|invshortname|invshowcmd|invshowfulltag|invshowmatch|invshowmode|invsi|invsm|invsmartcase|invsmartindent|invsmarttab|invsmd|invsn|invsol|invspell|invsplitbelow|invsplitright|invspr|invsr|invssl|invsta|invstartofline|invstmp|invswapfile|invswf|invta|invtagbsearch|invtagrelative|invtagstack|invtbi|invtbidi|invtbs|invtermbidi|invterse|invtextauto|invtextmode|invtf|invtgst|invtildeop|invtimeout|invtitle|invto|invtop|invtr|invttimeout|invttybuiltin|invttyfast|invtx|invvb|invvisualbell|invwa|invwarn|invwb|invweirdinvert|invwfh|invwfw|invwildmenu|invwinfixheight|invwinfixwidth|invwiv|invwmnu|invwrap|invwrapscan|invwrite|invwriteany|invwritebackup|invws|isf|isfname|isi|isident|isk|iskeyword|isprint|joinspaces|js|key|keymap|keymodel|keywordprg|km|kmp|kp|langmap|langmenu|laststatus|lazyredraw|lbr|lcs|linebreak|lines|linespace|lisp|lispwords|listchars|loadplugins|lpl|lsp|lz|macatsui|magic|makeef|makeprg|matchpairs|matchtime|maxcombine|maxfuncdepth|maxmapdepth|maxmem|maxmempattern|maxmemtot|mco|mef|menuitems|mfd|mh|mis|mkspellmem|ml|mls|mm|mmd|mmp|mmt|modeline|modelines|modifiable|modified|more|mouse|mousef|mousefocus|mousehide|mousem|mousemodel|mouses|mouseshape|mouset|mousetime|mp|mps|msm|mzq|mzquantum|nf|noacd|noai|noakm|noallowrevins|noaltkeymap|noanti|noantialias|noar|noarab|noarabic|noarabicshape|noari|noarshape|noautochdir|noautoindent|noautoread|noautowrite|noautowriteall|noaw|noawa|nobackup|noballooneval|nobeval|nobin|nobinary|nobiosk|nobioskey|nobk|nobl|nobomb|nobuflisted|nocf|noci|nocin|nocindent|nocompatible|noconfirm|noconsk|noconskey|nocopyindent|nocp|nocscopetag|nocscopeverbose|nocst|nocsverb|nocuc|nocul|nocursorcolumn|nocursorline|nodeco|nodelcombine|nodg|nodiff|nodigraph|nodisable|noea|noeb|noed|noedcompatible|noek|noendofline|noeol|noequalalways|noerrorbells|noesckeys|noet|noex|noexpandtab|noexrc|nofen|nofk|nofkmap|nofoldenable|nogd|nogdefault|noguipty|nohid|nohidden|nohk|nohkmap|nohkmapp|nohkp|nohls|noic|noicon|noignorecase|noim|noimc|noimcmdline|noimd|noincsearch|noinf|noinfercase|noinsertmode|nois|nojoinspaces|nojs|nolazyredraw|nolbr|nolinebreak|nolisp|nolist|noloadplugins|nolpl|nolz|noma|nomacatsui|nomagic|nomh|noml|nomod|nomodeline|nomodifiable|nomodified|nomore|nomousef|nomousefocus|nomousehide|nonu|nonumber|noodev|noopendevice|nopaste|nopi|nopreserveindent|nopreviewwindow|noprompt|nopvw|noreadonly|noremap|norestorescreen|norevins|nori|norightleft|norightleftcmd|norl|norlc|noro|nors|noru|noruler|nosb|nosc|noscb|noscrollbind|noscs|nosecure|nosft|noshellslash|noshelltemp|noshiftround|noshortname|noshowcmd|noshowfulltag|noshowmatch|noshowmode|nosi|nosm|nosmartcase|nosmartindent|nosmarttab|nosmd|nosn|nosol|nospell|nosplitbelow|nosplitright|nospr|nosr|nossl|nosta|nostartofline|nostmp|noswapfile|noswf|nota|notagbsearch|notagrelative|notagstack|notbi|notbidi|notbs|notermbidi|noterse|notextauto|notextmode|notf|notgst|notildeop|notimeout|notitle|noto|notop|notr|nottimeout|nottybuiltin|nottyfast|notx|novb|novisualbell|nowa|nowarn|nowb|noweirdinvert|nowfh|nowfw|nowildmenu|nowinfixheight|nowinfixwidth|nowiv|nowmnu|nowrap|nowrapscan|nowrite|nowriteany|nowritebackup|nows|nrformats|numberwidth|nuw|odev|oft|ofu|omnifunc|opendevice|operatorfunc|opfunc|osfiletype|pa|para|paragraphs|paste|pastetoggle|patchexpr|patchmode|path|pdev|penc|pex|pexpr|pfn|ph|pheader|pi|pm|pmbcs|pmbfn|popt|preserveindent|previewheight|previewwindow|printdevice|printencoding|printexpr|printfont|printheader|printmbcharset|printmbfont|printoptions|prompt|pt|pumheight|pvh|pvw|qe|quoteescape|readonly|remap|report|restorescreen|revins|rightleft|rightleftcmd|rl|rlc|ro|rs|rtp|ruf|ruler|rulerformat|runtimepath|sbo|sc|scb|scr|scroll|scrollbind|scrolljump|scrolloff|scrollopt|scs|sect|sections|secure|sel|selection|selectmode|sessionoptions|sft|shcf|shellcmdflag|shellpipe|shellquote|shellredir|shellslash|shelltemp|shelltype|shellxquote|shiftround|shiftwidth|shm|shortmess|shortname|showbreak|showcmd|showfulltag|showmatch|showmode|showtabline|shq|si|sidescroll|sidescrolloff|siso|sj|slm|smartcase|smartindent|smarttab|smc|smd|softtabstop|sol|spc|spell|spellcapcheck|spellfile|spelllang|spellsuggest|spf|spl|splitbelow|splitright|sps|sr|srr|ss|ssl|ssop|stal|startofline|statusline|stl|stmp|su|sua|suffixes|suffixesadd|sw|swapfile|swapsync|swb|swf|switchbuf|sws|sxq|syn|synmaxcol|syntax|t_AB|t_AF|t_AL|t_CS|t_CV|t_Ce|t_Co|t_Cs|t_DL|t_EI|t_F1|t_F2|t_F3|t_F4|t_F5|t_F6|t_F7|t_F8|t_F9|t_IE|t_IS|t_K1|t_K3|t_K4|t_K5|t_K6|t_K7|t_K8|t_K9|t_KA|t_KB|t_KC|t_KD|t_KE|t_KF|t_KG|t_KH|t_KI|t_KJ|t_KK|t_KL|t_RI|t_RV|t_SI|t_Sb|t_Sf|t_WP|t_WS|t_ZH|t_ZR|t_al|t_bc|t_cd|t_ce|t_cl|t_cm|t_cs|t_da|t_db|t_dl|t_fs|t_k1|t_k2|t_k3|t_k4|t_k5|t_k6|t_k7|t_k8|t_k9|t_kB|t_kD|t_kI|t_kN|t_kP|t_kb|t_kd|t_ke|t_kh|t_kl|t_kr|t_ks|t_ku|t_le|t_mb|t_md|t_me|t_mr|t_ms|t_nd|t_op|t_se|t_so|t_sr|t_te|t_ti|t_ts|t_ue|t_us|t_ut|t_vb|t_ve|t_vi|t_vs|t_xs|tabline|tabpagemax|tabstop|tagbsearch|taglength|tagrelative|tagstack|tal|tb|tbi|tbidi|tbis|tbs|tenc|term|termbidi|termencoding|terse|textauto|textmode|textwidth|tgst|thesaurus|tildeop|timeout|timeoutlen|title|titlelen|titleold|titlestring|toolbar|toolbariconsize|top|tpm|tsl|tsr|ttimeout|ttimeoutlen|ttm|tty|ttybuiltin|ttyfast|ttym|ttymouse|ttyscroll|ttytype|tw|tx|uc|ul|undolevels|updatecount|updatetime|ut|vb|vbs|vdir|verbosefile|vfile|viewdir|viewoptions|viminfo|virtualedit|visualbell|vop|wak|warn|wb|wc|wcm|wd|weirdinvert|wfh|wfw|whichwrap|wi|wig|wildchar|wildcharm|wildignore|wildmenu|wildmode|wildoptions|wim|winaltkeys|window|winfixheight|winfixwidth|winheight|winminheight|winminwidth|winwidth|wiv|wiw|wm|wmh|wmnu|wmw|wop|wrap|wrapmargin|wrapscan|writeany|writebackup|writedelay|ww)\b/,
    number: /\b(?:0x[\da-f]+|\d+(?:\.\d+)?)\b/i,
    operator: /\|\||&&|[-+.]=?|[=!](?:[=~][#?]?)?|[<>]=?[#?]?|[*\/%?]|\b(?:is(?:not)?)\b/,
    punctuation: /[{}[\](),;:]/
  };
}
u7.displayName = "visual-basic";
u7.aliases = ["vb", "vba"];
function u7(t) {
  t.languages["visual-basic"] = {
    comment: {
      pattern: /(?:['‘’]|REM\b)(?:[^\r\n_]|_(?:\r\n?|\n)?)*/i,
      inside: {
        keyword: /^REM/i
      }
    },
    directive: {
      pattern: /#(?:Const|Else|ElseIf|End|ExternalChecksum|ExternalSource|If|Region)(?:\b_[ \t]*(?:\r\n?|\n)|.)+/i,
      alias: "property",
      greedy: !0
    },
    string: {
      pattern: /\$?["“”](?:["“”]{2}|[^"“”])*["“”]C?/i,
      greedy: !0
    },
    date: {
      pattern: /#[ \t]*(?:\d+([/-])\d+\1\d+(?:[ \t]+(?:\d+[ \t]*(?:AM|PM)|\d+:\d+(?::\d+)?(?:[ \t]*(?:AM|PM))?))?|\d+[ \t]*(?:AM|PM)|\d+:\d+(?::\d+)?(?:[ \t]*(?:AM|PM))?)[ \t]*#/i,
      alias: "number"
    },
    number: /(?:(?:\b\d+(?:\.\d+)?|\.\d+)(?:E[+-]?\d+)?|&[HO][\dA-F]+)(?:[FRD]|U?[ILS])?/i,
    boolean: /\b(?:False|Nothing|True)\b/i,
    keyword: /\b(?:AddHandler|AddressOf|Alias|And(?:Also)?|As|Boolean|ByRef|Byte|ByVal|Call|Case|Catch|C(?:Bool|Byte|Char|Date|Dbl|Dec|Int|Lng|Obj|SByte|Short|Sng|Str|Type|UInt|ULng|UShort)|Char|Class|Const|Continue|Currency|Date|Decimal|Declare|Default|Delegate|Dim|DirectCast|Do|Double|Each|Else(?:If)?|End(?:If)?|Enum|Erase|Error|Event|Exit|Finally|For|Friend|Function|Get(?:Type|XMLNamespace)?|Global|GoSub|GoTo|Handles|If|Implements|Imports|In|Inherits|Integer|Interface|Is|IsNot|Let|Lib|Like|Long|Loop|Me|Mod|Module|Must(?:Inherit|Override)|My(?:Base|Class)|Namespace|Narrowing|New|Next|Not(?:Inheritable|Overridable)?|Object|Of|On|Operator|Option(?:al)?|Or(?:Else)?|Out|Overloads|Overridable|Overrides|ParamArray|Partial|Private|Property|Protected|Public|RaiseEvent|ReadOnly|ReDim|RemoveHandler|Resume|Return|SByte|Select|Set|Shadows|Shared|short|Single|Static|Step|Stop|String|Structure|Sub|SyncLock|Then|Throw|To|Try|TryCast|Type|TypeOf|U(?:Integer|Long|Short)|Until|Using|Variant|Wend|When|While|Widening|With(?:Events)?|WriteOnly|Xor)\b/i,
    operator: /[+\-*/\\^<=>&#@$%!]|\b_(?=[ \t]*[\r\n])/,
    punctuation: /[{}().,:?]/
  }, t.languages.vb = t.languages["visual-basic"], t.languages.vba = t.languages["visual-basic"];
}
c7.displayName = "warpscript";
c7.aliases = [];
function c7(t) {
  t.languages.warpscript = {
    comment: /#.*|\/\/.*|\/\*[\s\S]*?\*\//,
    string: {
      pattern: /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'|<'(?:[^\\']|'(?!>)|\\.)*'>/,
      greedy: !0
    },
    variable: /\$\S+/,
    macro: {
      pattern: /@\S+/,
      alias: "property"
    },
    // WarpScript doesn't have any keywords, these are all functions under the control category
    // https://www.warp10.io/tags/control
    keyword: /\b(?:BREAK|CHECKMACRO|CONTINUE|CUDF|DEFINED|DEFINEDMACRO|EVAL|FAIL|FOR|FOREACH|FORSTEP|IFT|IFTE|MSGFAIL|NRETURN|RETHROW|RETURN|SWITCH|TRY|UDF|UNTIL|WHILE)\b/,
    number: /[+-]?\b(?:NaN|Infinity|\d+(?:\.\d*)?(?:[Ee][+-]?\d+)?|0x[\da-fA-F]+|0b[01]+)\b/,
    boolean: /\b(?:F|T|false|true)\b/,
    punctuation: /<%|%>|[{}[\]()]/,
    // Some operators from the "operators" category
    // https://www.warp10.io/tags/operators
    operator: /==|&&?|\|\|?|\*\*?|>>>?|<<|[<>!~]=?|[-/%^]|\+!?|\b(?:AND|NOT|OR)\b/
  };
}
f7.displayName = "wasm";
f7.aliases = [];
function f7(t) {
  t.languages.wasm = {
    comment: [
      /\(;[\s\S]*?;\)/,
      {
        pattern: /;;.*/,
        greedy: !0
      }
    ],
    string: {
      pattern: /"(?:\\[\s\S]|[^"\\])*"/,
      greedy: !0
    },
    keyword: [
      {
        pattern: /\b(?:align|offset)=/,
        inside: {
          operator: /=/
        }
      },
      {
        pattern: /\b(?:(?:f32|f64|i32|i64)(?:\.(?:abs|add|and|ceil|clz|const|convert_[su]\/i(?:32|64)|copysign|ctz|demote\/f64|div(?:_[su])?|eqz?|extend_[su]\/i32|floor|ge(?:_[su])?|gt(?:_[su])?|le(?:_[su])?|load(?:(?:8|16|32)_[su])?|lt(?:_[su])?|max|min|mul|neg?|nearest|or|popcnt|promote\/f32|reinterpret\/[fi](?:32|64)|rem_[su]|rot[lr]|shl|shr_[su]|sqrt|store(?:8|16|32)?|sub|trunc(?:_[su]\/f(?:32|64))?|wrap\/i64|xor))?|memory\.(?:grow|size))\b/,
        inside: {
          punctuation: /\./
        }
      },
      /\b(?:anyfunc|block|br(?:_if|_table)?|call(?:_indirect)?|data|drop|elem|else|end|export|func|get_(?:global|local)|global|if|import|local|loop|memory|module|mut|nop|offset|param|result|return|select|set_(?:global|local)|start|table|tee_local|then|type|unreachable)\b/
    ],
    variable: /\$[\w!#$%&'*+\-./:<=>?@\\^`|~]+/,
    number: /[+-]?\b(?:\d(?:_?\d)*(?:\.\d(?:_?\d)*)?(?:[eE][+-]?\d(?:_?\d)*)?|0x[\da-fA-F](?:_?[\da-fA-F])*(?:\.[\da-fA-F](?:_?[\da-fA-D])*)?(?:[pP][+-]?\d(?:_?\d)*)?)\b|\binf\b|\bnan(?::0x[\da-fA-F](?:_?[\da-fA-D])*)?\b/,
    punctuation: /[()]/
  };
}
d7.displayName = "web-idl";
d7.aliases = ["webidl"];
function d7(t) {
  (function(e) {
    var n = /(?:\B-|\b_|\b)[A-Za-z][\w-]*(?![\w-])/.source, r = "(?:" + /\b(?:unsigned\s+)?long\s+long(?![\w-])/.source + "|" + /\b(?:unrestricted|unsigned)\s+[a-z]+(?![\w-])/.source + "|" + /(?!(?:unrestricted|unsigned)\b)/.source + n + /(?:\s*<(?:[^<>]|<[^<>]*>)*>)?/.source + ")" + /(?:\s*\?)?/.source, a = {};
    e.languages["web-idl"] = {
      comment: {
        pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
        greedy: !0
      },
      string: {
        pattern: /"[^"]*"/,
        greedy: !0
      },
      namespace: {
        pattern: RegExp(/(\bnamespace\s+)/.source + n),
        lookbehind: !0
      },
      "class-name": [
        {
          pattern: /(^|[^\w-])(?:iterable|maplike|setlike)\s*<(?:[^<>]|<[^<>]*>)*>/,
          lookbehind: !0,
          inside: a
        },
        {
          pattern: RegExp(
            /(\b(?:attribute|const|deleter|getter|optional|setter)\s+)/.source + r
          ),
          lookbehind: !0,
          inside: a
        },
        {
          // callback return type
          pattern: RegExp(
            "(" + /\bcallback\s+/.source + n + /\s*=\s*/.source + ")" + r
          ),
          lookbehind: !0,
          inside: a
        },
        {
          // typedef
          pattern: RegExp(/(\btypedef\b\s*)/.source + r),
          lookbehind: !0,
          inside: a
        },
        {
          pattern: RegExp(
            /(\b(?:callback|dictionary|enum|interface(?:\s+mixin)?)\s+)(?!(?:interface|mixin)\b)/.source + n
          ),
          lookbehind: !0
        },
        {
          // inheritance
          pattern: RegExp(/(:\s*)/.source + n),
          lookbehind: !0
        },
        // includes and implements
        RegExp(n + /(?=\s+(?:implements|includes)\b)/.source),
        {
          pattern: RegExp(/(\b(?:implements|includes)\s+)/.source + n),
          lookbehind: !0
        },
        {
          // function return type, parameter types, and dictionary members
          pattern: RegExp(
            r + "(?=" + /\s*(?:\.{3}\s*)?/.source + n + /\s*[(),;=]/.source + ")"
          ),
          inside: a
        }
      ],
      builtin: /\b(?:ArrayBuffer|BigInt64Array|BigUint64Array|ByteString|DOMString|DataView|Float32Array|Float64Array|FrozenArray|Int16Array|Int32Array|Int8Array|ObservableArray|Promise|USVString|Uint16Array|Uint32Array|Uint8Array|Uint8ClampedArray)\b/,
      keyword: [
        /\b(?:async|attribute|callback|const|constructor|deleter|dictionary|enum|getter|implements|includes|inherit|interface|mixin|namespace|null|optional|or|partial|readonly|required|setter|static|stringifier|typedef|unrestricted)\b/,
        // type keywords
        /\b(?:any|bigint|boolean|byte|double|float|iterable|long|maplike|object|octet|record|sequence|setlike|short|symbol|undefined|unsigned|void)\b/
      ],
      boolean: /\b(?:false|true)\b/,
      number: {
        pattern: /(^|[^\w-])-?(?:0x[0-9a-f]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|NaN|Infinity)(?![\w-])/i,
        lookbehind: !0
      },
      operator: /\.{3}|[=:?<>-]/,
      punctuation: /[(){}[\].,;]/
    };
    for (var i in e.languages["web-idl"])
      i !== "class-name" && (a[i] = e.languages["web-idl"][i]);
    e.languages.webidl = e.languages["web-idl"];
  })(t);
}
p7.displayName = "wgsl";
p7.aliases = [];
function p7(t) {
  t.languages.wgsl = {
    comment: {
      pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
      greedy: !0
    },
    "builtin-attribute": {
      pattern: /(@)builtin\(.*?\)/,
      lookbehind: !0,
      inside: {
        attribute: {
          pattern: /^builtin/,
          alias: "attr-name"
        },
        punctuation: /[(),]/,
        "built-in-values": {
          pattern: /\b(?:frag_depth|front_facing|global_invocation_id|instance_index|local_invocation_id|local_invocation_index|num_workgroups|position|sample_index|sample_mask|vertex_index|workgroup_id)\b/,
          alias: "attr-value"
        }
      }
    },
    attributes: {
      pattern: /(@)(?:align|binding|compute|const|fragment|group|id|interpolate|invariant|location|size|vertex|workgroup_size)/i,
      lookbehind: !0,
      alias: "attr-name"
    },
    functions: {
      pattern: /\b(fn\s+)[_a-zA-Z]\w*(?=[(<])/,
      lookbehind: !0,
      alias: "function"
    },
    keyword: /\b(?:bitcast|break|case|const|continue|continuing|default|discard|else|enable|fallthrough|fn|for|function|if|let|loop|private|return|storage|struct|switch|type|uniform|var|while|workgroup)\b/,
    builtin: /\b(?:abs|acos|acosh|all|any|array|asin|asinh|atan|atan2|atanh|atomic|atomicAdd|atomicAnd|atomicCompareExchangeWeak|atomicExchange|atomicLoad|atomicMax|atomicMin|atomicOr|atomicStore|atomicSub|atomicXor|bool|ceil|clamp|cos|cosh|countLeadingZeros|countOneBits|countTrailingZeros|cross|degrees|determinant|distance|dot|dpdx|dpdxCoarse|dpdxFine|dpdy|dpdyCoarse|dpdyFine|exp|exp2|extractBits|f32|f64|faceForward|firstLeadingBit|floor|fma|fract|frexp|fwidth|fwidthCoarse|fwidthFine|i32|i64|insertBits|inverseSqrt|ldexp|length|log|log2|mat[2-4]x[2-4]|max|min|mix|modf|normalize|override|pack2x16float|pack2x16snorm|pack2x16unorm|pack4x8snorm|pack4x8unorm|pow|ptr|quantizeToF16|radians|reflect|refract|reverseBits|round|sampler|sampler_comparison|select|shiftLeft|shiftRight|sign|sin|sinh|smoothstep|sqrt|staticAssert|step|storageBarrier|tan|tanh|textureDimensions|textureGather|textureGatherCompare|textureLoad|textureNumLayers|textureNumLevels|textureNumSamples|textureSample|textureSampleBias|textureSampleCompare|textureSampleCompareLevel|textureSampleGrad|textureSampleLevel|textureStore|texture_1d|texture_2d|texture_2d_array|texture_3d|texture_cube|texture_cube_array|texture_depth_2d|texture_depth_2d_array|texture_depth_cube|texture_depth_cube_array|texture_depth_multisampled_2d|texture_multisampled_2d|texture_storage_1d|texture_storage_2d|texture_storage_2d_array|texture_storage_3d|transpose|trunc|u32|u64|unpack2x16float|unpack2x16snorm|unpack2x16unorm|unpack4x8snorm|unpack4x8unorm|vec[2-4]|workgroupBarrier)\b/,
    "function-calls": {
      pattern: /\b[_a-z]\w*(?=\()/i,
      alias: "function"
    },
    "class-name": /\b(?:[A-Z][A-Za-z0-9]*)\b/,
    "bool-literal": {
      pattern: /\b(?:false|true)\b/,
      alias: "boolean"
    },
    "hex-int-literal": {
      pattern: /\b0[xX][0-9a-fA-F]+[iu]?\b(?![.pP])/,
      alias: "number"
    },
    "hex-float-literal": {
      pattern: /\b0[xX][0-9a-fA-F]*(?:\.[0-9a-fA-F]*)?(?:[pP][+-]?\d+[fh]?)?/,
      alias: "number"
    },
    "decimal-float-literal": [
      {
        pattern: /\d*\.\d+(?:[eE](?:\+|-)?\d+)?[fh]?/,
        alias: "number"
      },
      {
        pattern: /\d+\.\d*(?:[eE](?:\+|-)?\d+)?[fh]?/,
        alias: "number"
      },
      {
        pattern: /\d+[eE](?:\+|-)?\d+[fh]?/,
        alias: "number"
      },
      {
        pattern: /\b\d+[fh]\b/,
        alias: "number"
      }
    ],
    "int-literal": {
      pattern: /\b\d+[iu]?\b/,
      alias: "number"
    },
    operator: [
      {
        pattern: /(?:\^|~|\|(?!\|)|\|\||&&|<<|>>|!)(?!=)/
      },
      {
        pattern: /&(?![&=])/
      },
      {
        pattern: /(?:\+=|-=|\*=|\/=|%=|\^=|&=|\|=|<<=|>>=)/
      },
      {
        pattern: /(^|[^<>=!])=(?![=>])/,
        lookbehind: !0
      },
      {
        pattern: /(?:==|!=|<=|\+\+|--|(^|[^=])>=)/,
        lookbehind: !0
      },
      {
        pattern: /(?:(?:[+%]|(?:\*(?!\w)))(?!=))|(?:-(?!>))|(?:\/(?!\/))/
      },
      {
        pattern: /->/
      }
    ],
    punctuation: /[@(){}[\],;<>:.]/
  };
}
h7.displayName = "wiki";
h7.aliases = [];
function h7(t) {
  t.register(ws), t.languages.wiki = t.languages.extend("markup", {
    "block-comment": {
      pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
      lookbehind: !0,
      alias: "comment"
    },
    heading: {
      pattern: /^(=+)[^=\r\n].*?\1/m,
      inside: {
        punctuation: /^=+|=+$/,
        important: /.+/
      }
    },
    emphasis: {
      // TODO Multi-line
      pattern: /('{2,5}).+?\1/,
      inside: {
        "bold-italic": {
          pattern: /(''''').+?(?=\1)/,
          lookbehind: !0,
          alias: ["bold", "italic"]
        },
        bold: {
          pattern: /(''')[^'](?:.*?[^'])?(?=\1)/,
          lookbehind: !0
        },
        italic: {
          pattern: /('')[^'](?:.*?[^'])?(?=\1)/,
          lookbehind: !0
        },
        punctuation: /^''+|''+$/
      }
    },
    hr: {
      pattern: /^-{4,}/m,
      alias: "punctuation"
    },
    url: [
      /ISBN +(?:97[89][ -]?)?(?:\d[ -]?){9}[\dx]\b|(?:PMID|RFC) +\d+/i,
      /\[\[.+?\]\]|\[.+?\]/
    ],
    variable: [
      /__[A-Z]+__/,
      // FIXME Nested structures should be handled
      // {{formatnum:{{#expr:{{{3}}}}}}}
      /\{{3}.+?\}{3}/,
      /\{\{.+?\}\}/
    ],
    symbol: [/^#redirect/im, /~{3,5}/],
    // Handle table attrs:
    // {|
    // ! style="text-align:left;"| Item
    // |}
    "table-tag": {
      pattern: /((?:^|[|!])[|!])[^|\r\n]+\|(?!\|)/m,
      lookbehind: !0,
      inside: {
        "table-bar": {
          pattern: /\|$/,
          alias: "punctuation"
        },
        rest: t.languages.markup.tag.inside
      }
    },
    punctuation: /^(?:\{\||\|\}|\|-|[*#:;!|])|\|\||!!/m
  }), t.languages.insertBefore("wiki", "tag", {
    // Prevent highlighting inside <nowiki>, <source> and <pre> tags
    nowiki: {
      pattern: /<(nowiki|pre|source)\b[^>]*>[\s\S]*?<\/\1>/i,
      inside: {
        tag: {
          pattern: /<(?:nowiki|pre|source)\b[^>]*>|<\/(?:nowiki|pre|source)>/i,
          inside: t.languages.markup.tag.inside
        }
      }
    }
  });
}
m7.displayName = "wolfram";
m7.aliases = ["mathematica", "nb", "wl"];
function m7(t) {
  t.languages.wolfram = {
    comment: (
      // Allow one level of nesting - note: regex taken from applescipt
      /\(\*(?:\(\*(?:[^*]|\*(?!\)))*\*\)|(?!\(\*)[\s\S])*?\*\)/
    ),
    string: {
      pattern: /"(?:\\.|[^"\\\r\n])*"/,
      greedy: !0
    },
    keyword: /\b(?:Abs|AbsArg|Accuracy|Block|Do|For|Function|If|Manipulate|Module|Nest|NestList|None|Return|Switch|Table|Which|While)\b/,
    context: {
      pattern: /\b\w+`+\w*/,
      alias: "class-name"
    },
    blank: {
      pattern: /\b\w+_\b/,
      alias: "regex"
    },
    "global-variable": {
      pattern: /\$\w+/,
      alias: "variable"
    },
    boolean: /\b(?:False|True)\b/,
    number: /(?:\b(?=\d)|\B(?=\.))(?:0[bo])?(?:(?:\d|0x[\da-f])[\da-f]*(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?j?\b/i,
    operator: /\/\.|;|=\.|\^=|\^:=|:=|<<|>>|<\||\|>|:>|\|->|->|<-|@@@|@@|@|\/@|=!=|===|==|=|\+|-|\[\/-+%=\]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
    punctuation: /[{}[\];(),.:]/
  }, t.languages.mathematica = t.languages.wolfram, t.languages.wl = t.languages.wolfram, t.languages.nb = t.languages.wolfram;
}
g7.displayName = "wren";
g7.aliases = [];
function g7(t) {
  t.languages.wren = {
    // Multiline comments in Wren can have nested multiline comments
    // Comments: // and /* */
    comment: [
      {
        // support 3 levels of nesting
        // regex: \/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\/
        pattern: /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|\/\*(?:[^*/]|\*(?!\/)|\/(?!\*))*\*\/)*\*\/)*\*\//,
        greedy: !0
      },
      {
        pattern: /(^|[^\\:])\/\/.*/,
        lookbehind: !0,
        greedy: !0
      }
    ],
    // Triple quoted strings are multiline but cannot have interpolation (raw strings)
    // Based on prism-python.js
    "triple-quoted-string": {
      pattern: /"""[\s\S]*?"""/,
      greedy: !0,
      alias: "string"
    },
    // see below
    "string-literal": null,
    // #!/usr/bin/env wren on the first line
    hashbang: {
      pattern: /^#!\/.+/,
      greedy: !0,
      alias: "comment"
    },
    // Attributes are special keywords to add meta data to classes
    attribute: {
      // #! attributes are stored in class properties
      // #!myvar = true
      // #attributes are not stored and dismissed at compilation
      pattern: /#!?[ \t\u3000]*\w+/,
      alias: "keyword"
    },
    "class-name": [
      {
        // class definition
        // class Meta {}
        pattern: /(\bclass\s+)\w+/,
        lookbehind: !0
      },
      // A class must always start with an uppercase.
      // File.read
      /\b[A-Z][a-z\d_]*\b/
    ],
    // A constant can be a variable, class, property or method. Just named in all uppercase letters
    constant: /\b[A-Z][A-Z\d_]*\b/,
    null: {
      pattern: /\bnull\b/,
      alias: "keyword"
    },
    keyword: /\b(?:as|break|class|construct|continue|else|for|foreign|if|import|in|is|return|static|super|this|var|while)\b/,
    boolean: /\b(?:false|true)\b/,
    number: /\b(?:0x[\da-f]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/i,
    // Functions can be Class.method()
    function: /\b[a-z_]\w*(?=\s*[({])/i,
    operator: /<<|>>|[=!<>]=?|&&|\|\||[-+*/%~^&|?:]|\.{2,3}/,
    punctuation: /[\[\](){}.,;]/
  }, t.languages.wren["string-literal"] = {
    // A single quote string is multiline and can have interpolation (similar to JS backticks ``)
    pattern: /(^|[^\\"])"(?:[^\\"%]|\\[\s\S]|%(?!\()|%\((?:[^()]|\((?:[^()]|\([^)]*\))*\))*\))*"/,
    lookbehind: !0,
    greedy: !0,
    inside: {
      interpolation: {
        // "%(interpolation)"
        pattern: /((?:^|[^\\])(?:\\{2})*)%\((?:[^()]|\((?:[^()]|\([^)]*\))*\))*\)/,
        lookbehind: !0,
        inside: {
          expression: {
            pattern: /^(%\()[\s\S]+(?=\)$)/,
            lookbehind: !0,
            inside: t.languages.wren
          },
          "interpolation-punctuation": {
            pattern: /^%\(|\)$/,
            alias: "punctuation"
          }
        }
      },
      string: /[\s\S]+/
    }
  };
}
b7.displayName = "xeora";
b7.aliases = ["xeoracube"];
function b7(t) {
  t.register(ws), function(e) {
    e.languages.xeora = e.languages.extend("markup", {
      constant: {
        pattern: /\$(?:DomainContents|PageRenderDuration)\$/,
        inside: {
          punctuation: {
            pattern: /\$/
          }
        }
      },
      variable: {
        pattern: /\$@?(?:#+|[-+*~=^])?[\w.]+\$/,
        inside: {
          punctuation: {
            pattern: /[$.]/
          },
          operator: {
            pattern: /#+|[-+*~=^@]/
          }
        }
      },
      "function-inline": {
        pattern: /\$F:[-\w.]+\?[-\w.]+(?:,(?:(?:@[-#]*\w+\.[\w+.]\.*)*\|)*(?:(?:[\w+]|[-#*.~^]+[\w+]|=\S)(?:[^$=]|=+[^=])*=*|(?:@[-#]*\w+\.[\w+.]\.*)+(?:(?:[\w+]|[-#*~^][-#*.~^]*[\w+]|=\S)(?:[^$=]|=+[^=])*=*)?)?)?\$/,
        inside: {
          variable: {
            pattern: /(?:[,|])@?(?:#+|[-+*~=^])?[\w.]+/,
            inside: {
              punctuation: {
                pattern: /[,.|]/
              },
              operator: {
                pattern: /#+|[-+*~=^@]/
              }
            }
          },
          punctuation: {
            pattern: /\$\w:|[$:?.,|]/
          }
        },
        alias: "function"
      },
      "function-block": {
        pattern: /\$XF:\{[-\w.]+\?[-\w.]+(?:,(?:(?:@[-#]*\w+\.[\w+.]\.*)*\|)*(?:(?:[\w+]|[-#*.~^]+[\w+]|=\S)(?:[^$=]|=+[^=])*=*|(?:@[-#]*\w+\.[\w+.]\.*)+(?:(?:[\w+]|[-#*~^][-#*.~^]*[\w+]|=\S)(?:[^$=]|=+[^=])*=*)?)?)?\}:XF\$/,
        inside: {
          punctuation: {
            pattern: /[$:{}?.,|]/
          }
        },
        alias: "function"
      },
      "directive-inline": {
        pattern: /\$\w(?:#\d+\+?)?(?:\[[-\w.]+\])?:[-\/\w.]+\$/,
        inside: {
          punctuation: {
            pattern: /\$(?:\w:|C(?:\[|#\d))?|[:{[\]]/,
            inside: {
              tag: {
                pattern: /#\d/
              }
            }
          }
        },
        alias: "function"
      },
      "directive-block-open": {
        pattern: /\$\w+:\{|\$\w(?:#\d+\+?)?(?:\[[-\w.]+\])?:[-\w.]+:\{(?:![A-Z]+)?/,
        inside: {
          punctuation: {
            pattern: /\$(?:\w:|C(?:\[|#\d))?|[:{[\]]/,
            inside: {
              tag: {
                pattern: /#\d/
              }
            }
          },
          attribute: {
            pattern: /![A-Z]+$/,
            inside: {
              punctuation: {
                pattern: /!/
              }
            },
            alias: "keyword"
          }
        },
        alias: "function"
      },
      "directive-block-separator": {
        pattern: /\}:[-\w.]+:\{/,
        inside: {
          punctuation: {
            pattern: /[:{}]/
          }
        },
        alias: "function"
      },
      "directive-block-close": {
        pattern: /\}:[-\w.]+\$/,
        inside: {
          punctuation: {
            pattern: /[:{}$]/
          }
        },
        alias: "function"
      }
    }), e.languages.insertBefore(
      "inside",
      "punctuation",
      {
        variable: e.languages.xeora["function-inline"].inside.variable
      },
      e.languages.xeora["function-block"]
    ), e.languages.xeoracube = e.languages.xeora;
  }(t);
}
v7.displayName = "xml-doc";
v7.aliases = [];
function v7(t) {
  t.register(ws), function(e) {
    function n(o, s) {
      e.languages[o] && e.languages.insertBefore(o, "comment", {
        "doc-comment": s
      });
    }
    var r = e.languages.markup.tag, a = {
      pattern: /\/\/\/.*/,
      greedy: !0,
      alias: "comment",
      inside: {
        tag: r
      }
    }, i = {
      pattern: /'''.*/,
      greedy: !0,
      alias: "comment",
      inside: {
        tag: r
      }
    };
    n("csharp", a), n("fsharp", a), n("vbnet", i);
  }(t);
}
y7.displayName = "xojo";
y7.aliases = [];
function y7(t) {
  t.languages.xojo = {
    comment: {
      pattern: /(?:'|\/\/|Rem\b).+/i,
      greedy: !0
    },
    string: {
      pattern: /"(?:""|[^"])*"/,
      greedy: !0
    },
    number: [/(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i, /&[bchou][a-z\d]+/i],
    directive: {
      pattern: /#(?:Else|ElseIf|Endif|If|Pragma)\b/i,
      alias: "property"
    },
    keyword: /\b(?:AddHandler|App|Array|As(?:signs)?|Auto|Boolean|Break|By(?:Ref|Val)|Byte|Call|Case|Catch|CFStringRef|CGFloat|Class|Color|Const|Continue|CString|Currency|CurrentMethodName|Declare|Delegate|Dim|Do(?:uble|wnTo)?|Each|Else(?:If)?|End|Enumeration|Event|Exception|Exit|Extends|False|Finally|For|Function|Get|GetTypeInfo|Global|GOTO|If|Implements|In|Inherits|Int(?:8|16|32|64|eger|erface)?|Lib|Loop|Me|Module|Next|Nil|Object|Optional|OSType|ParamArray|Private|Property|Protected|PString|Ptr|Raise(?:Event)?|ReDim|RemoveHandler|Return|Select(?:or)?|Self|Set|Shared|Short|Single|Soft|Static|Step|String|Sub|Super|Text|Then|To|True|Try|Ubound|UInt(?:8|16|32|64|eger)?|Until|Using|Var(?:iant)?|Wend|While|WindowPtr|WString)\b/i,
    operator: /<[=>]?|>=?|[+\-*\/\\^=]|\b(?:AddressOf|And|Ctype|IsA?|Mod|New|Not|Or|WeakAddressOf|Xor)\b/i,
    punctuation: /[.,;:()]/
  };
}
O7.displayName = "xquery";
O7.aliases = [];
function O7(t) {
  t.register(ws), function(e) {
    e.languages.xquery = e.languages.extend("markup", {
      "xquery-comment": {
        pattern: /\(:[\s\S]*?:\)/,
        greedy: !0,
        alias: "comment"
      },
      string: {
        pattern: /(["'])(?:\1\1|(?!\1)[\s\S])*\1/,
        greedy: !0
      },
      extension: {
        pattern: /\(#.+?#\)/,
        alias: "symbol"
      },
      variable: /\$[-\w:]+/,
      axis: {
        pattern: /(^|[^-])(?:ancestor(?:-or-self)?|attribute|child|descendant(?:-or-self)?|following(?:-sibling)?|parent|preceding(?:-sibling)?|self)(?=::)/,
        lookbehind: !0,
        alias: "operator"
      },
      "keyword-operator": {
        pattern: /(^|[^:-])\b(?:and|castable as|div|eq|except|ge|gt|idiv|instance of|intersect|is|le|lt|mod|ne|or|union)\b(?=$|[^:-])/,
        lookbehind: !0,
        alias: "operator"
      },
      keyword: {
        pattern: /(^|[^:-])\b(?:as|ascending|at|base-uri|boundary-space|case|cast as|collation|construction|copy-namespaces|declare|default|descending|else|empty (?:greatest|least)|encoding|every|external|for|function|if|import|in|inherit|lax|let|map|module|namespace|no-inherit|no-preserve|option|order(?: by|ed|ing)?|preserve|return|satisfies|schema|some|stable|strict|strip|then|to|treat as|typeswitch|unordered|validate|variable|version|where|xquery)\b(?=$|[^:-])/,
        lookbehind: !0
      },
      function: /[\w-]+(?::[\w-]+)*(?=\s*\()/,
      "xquery-element": {
        pattern: /(element\s+)[\w-]+(?::[\w-]+)*/,
        lookbehind: !0,
        alias: "tag"
      },
      "xquery-attribute": {
        pattern: /(attribute\s+)[\w-]+(?::[\w-]+)*/,
        lookbehind: !0,
        alias: "attr-name"
      },
      builtin: {
        pattern: /(^|[^:-])\b(?:attribute|comment|document|element|processing-instruction|text|xs:(?:ENTITIES|ENTITY|ID|IDREFS?|NCName|NMTOKENS?|NOTATION|Name|QName|anyAtomicType|anyType|anyURI|base64Binary|boolean|byte|date|dateTime|dayTimeDuration|decimal|double|duration|float|gDay|gMonth|gMonthDay|gYear|gYearMonth|hexBinary|int|integer|language|long|negativeInteger|nonNegativeInteger|nonPositiveInteger|normalizedString|positiveInteger|short|string|time|token|unsigned(?:Byte|Int|Long|Short)|untyped(?:Atomic)?|yearMonthDuration))\b(?=$|[^:-])/,
        lookbehind: !0
      },
      number: /\b\d+(?:\.\d+)?(?:E[+-]?\d+)?/,
      operator: [
        /[+*=?|@]|\.\.?|:=|!=|<[=<]?|>[=>]?/,
        {
          pattern: /(\s)-(?=\s)/,
          lookbehind: !0
        }
      ],
      punctuation: /[[\](){},;:/]/
    }), e.languages.xquery.tag.pattern = /<\/?(?!\d)[^\s>\/=$<%]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|\{(?!\{)(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])+\}|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/, e.languages.xquery.tag.inside["attr-value"].pattern = /=(?:("|')(?:\\[\s\S]|\{(?!\{)(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])+\}|(?!\1)[^\\])*\1|[^\s'">=]+)/, e.languages.xquery.tag.inside["attr-value"].inside.punctuation = /^="|"$/, e.languages.xquery.tag.inside["attr-value"].inside.expression = {
      // Allow for two levels of nesting
      pattern: /\{(?!\{)(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])+\}/,
      inside: e.languages.xquery,
      alias: "language-xquery"
    };
    var n = function(a) {
      return typeof a == "string" ? a : typeof a.content == "string" ? a.content : a.content.map(n).join("");
    }, r = function(a) {
      for (var i = [], o = 0; o < a.length; o++) {
        var s = a[o], u = !1;
        if (typeof s != "string" && (s.type === "tag" && s.content[0] && s.content[0].type === "tag" ? s.content[0].content[0].content === "</" ? i.length > 0 && i[i.length - 1].tagName === n(s.content[0].content[1]) && i.pop() : s.content[s.content.length - 1].content === "/>" || i.push({
          tagName: n(s.content[0].content[1]),
          openedBraces: 0
        }) : i.length > 0 && s.type === "punctuation" && s.content === "{" && // Ignore `{{`
        (!a[o + 1] || a[o + 1].type !== "punctuation" || a[o + 1].content !== "{") && (!a[o - 1] || a[o - 1].type !== "plain-text" || a[o - 1].content !== "{") ? i[i.length - 1].openedBraces++ : i.length > 0 && i[i.length - 1].openedBraces > 0 && s.type === "punctuation" && s.content === "}" ? i[i.length - 1].openedBraces-- : s.type !== "comment" && (u = !0)), (u || typeof s == "string") && i.length > 0 && i[i.length - 1].openedBraces === 0) {
          var f = n(s);
          o < a.length - 1 && (typeof a[o + 1] == "string" || a[o + 1].type === "plain-text") && (f += n(a[o + 1]), a.splice(o + 1, 1)), o > 0 && (typeof a[o - 1] == "string" || a[o - 1].type === "plain-text") && (f = n(a[o - 1]) + f, a.splice(o - 1, 1), o--), /^\s+$/.test(f) ? a[o] = f : a[o] = new e.Token(
            "plain-text",
            f,
            null,
            f
          );
        }
        s.content && typeof s.content != "string" && r(s.content);
      }
    };
    e.hooks.add("after-tokenize", function(a) {
      a.language === "xquery" && r(a.tokens);
    });
  }(t);
}
E7.displayName = "yang";
E7.aliases = [];
function E7(t) {
  t.languages.yang = {
    // https://tools.ietf.org/html/rfc6020#page-34
    // http://www.yang-central.org/twiki/bin/view/Main/YangExamples
    comment: /\/\*[\s\S]*?\*\/|\/\/.*/,
    string: {
      pattern: /"(?:[^\\"]|\\.)*"|'[^']*'/,
      greedy: !0
    },
    keyword: {
      pattern: /(^|[{};\r\n][ \t]*)[a-z_][\w.-]*/i,
      lookbehind: !0
    },
    namespace: {
      pattern: /(\s)[a-z_][\w.-]*(?=:)/i,
      lookbehind: !0
    },
    boolean: /\b(?:false|true)\b/,
    operator: /\+/,
    punctuation: /[{};:]/
  };
}
S7.displayName = "zig";
S7.aliases = [];
function S7(t) {
  (function(e) {
    function n(f) {
      return function() {
        return f;
      };
    }
    var r = /\b(?:align|allowzero|and|anyframe|anytype|asm|async|await|break|cancel|catch|comptime|const|continue|defer|else|enum|errdefer|error|export|extern|fn|for|if|inline|linksection|nakedcc|noalias|nosuspend|null|or|orelse|packed|promise|pub|resume|return|stdcallcc|struct|suspend|switch|test|threadlocal|try|undefined|union|unreachable|usingnamespace|var|volatile|while)\b/, a = "\\b(?!" + r.source + ")(?!\\d)\\w+\\b", i = /align\s*\((?:[^()]|\([^()]*\))*\)/.source, o = /(?:\?|\bpromise->|(?:\[[^[\]]*\]|\*(?!\*)|\*\*)(?:\s*<ALIGN>|\s*const\b|\s*volatile\b|\s*allowzero\b)*)/.source.replace(
      /<ALIGN>/g,
      n(i)
    ), s = /(?:\bpromise\b|(?:\berror\.)?<ID>(?:\.<ID>)*(?!\s+<ID>))/.source.replace(
      /<ID>/g,
      n(a)
    ), u = "(?!\\s)(?:!?\\s*(?:" + o + "\\s*)*" + s + ")+";
    e.languages.zig = {
      comment: [
        {
          pattern: /\/\/[/!].*/,
          alias: "doc-comment"
        },
        /\/{2}.*/
      ],
      string: [
        {
          // "string" and c"string"
          pattern: /(^|[^\\@])c?"(?:[^"\\\r\n]|\\.)*"/,
          lookbehind: !0,
          greedy: !0
        },
        {
          // multiline strings and c-strings
          pattern: /([\r\n])([ \t]+c?\\{2}).*(?:(?:\r\n?|\n)\2.*)*/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      char: {
        // characters 'a', '\n', '\xFF', '\u{10FFFF}'
        pattern: /(^|[^\\])'(?:[^'\\\r\n]|[\uD800-\uDFFF]{2}|\\(?:.|x[a-fA-F\d]{2}|u\{[a-fA-F\d]{1,6}\}))'/,
        lookbehind: !0,
        greedy: !0
      },
      builtin: /\B@(?!\d)\w+(?=\s*\()/,
      label: {
        pattern: /(\b(?:break|continue)\s*:\s*)\w+\b|\b(?!\d)\w+\b(?=\s*:\s*(?:\{|while\b))/,
        lookbehind: !0
      },
      "class-name": [
        // const Foo = struct {};
        /\b(?!\d)\w+(?=\s*=\s*(?:(?:extern|packed)\s+)?(?:enum|struct|union)\s*[({])/,
        {
          // const x: i32 = 9;
          // var x: Bar;
          // fn foo(x: bool, y: f32) void {}
          pattern: RegExp(
            /(:\s*)<TYPE>(?=\s*(?:<ALIGN>\s*)?[=;,)])|<TYPE>(?=\s*(?:<ALIGN>\s*)?\{)/.source.replace(/<TYPE>/g, n(u)).replace(/<ALIGN>/g, n(i))
          ),
          lookbehind: !0,
          inside: null
          // see below
        },
        {
          // extern fn foo(x: f64) f64; (optional alignment)
          pattern: RegExp(
            /(\)\s*)<TYPE>(?=\s*(?:<ALIGN>\s*)?;)/.source.replace(/<TYPE>/g, n(u)).replace(/<ALIGN>/g, n(i))
          ),
          lookbehind: !0,
          inside: null
          // see below
        }
      ],
      "builtin-type": {
        pattern: /\b(?:anyerror|bool|c_u?(?:int|long|longlong|short)|c_longdouble|c_void|comptime_(?:float|int)|f(?:16|32|64|128)|[iu](?:8|16|32|64|128|size)|noreturn|type|void)\b/,
        alias: "keyword"
      },
      keyword: r,
      function: /\b(?!\d)\w+(?=\s*\()/,
      number: /\b(?:0b[01]+|0o[0-7]+|0x[a-fA-F\d]+(?:\.[a-fA-F\d]*)?(?:[pP][+-]?[a-fA-F\d]+)?|\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)\b/,
      boolean: /\b(?:false|true)\b/,
      operator: /\.[*?]|\.{2,3}|[-=]>|\*\*|\+\+|\|\||(?:<<|>>|[-+*]%|[-+*/%^&|<>!=])=?|[?~]/,
      punctuation: /[.:,;(){}[\]]/
    }, e.languages.zig["class-name"].forEach(function(f) {
      f.inside === null && (f.inside = e.languages.zig);
    });
  })(t);
}
te.register(ws);
te.register(pv);
te.register(Lr);
te.register($D);
te.register(rl);
te.register(B6);
te.register(U6);
te.register(z6);
te.register(H6);
te.register(W6);
te.register(Q6);
te.register(j6);
te.register(G6);
te.register(v1);
te.register(V6);
te.register(Y6);
te.register(Z6);
te.register(X6);
te.register(tp);
te.register(x0);
te.register(PD);
te.register(q6);
te.register(K6);
te.register(x_);
te.register(k_);
te.register(HD);
te.register(J6);
te.register(e9);
te.register(A0);
te.register(t9);
te.register(n9);
te.register(r9);
te.register(a9);
te.register(i9);
te.register(o9);
te.register(s9);
te.register(l9);
te.register(I_);
te.register(u9);
te.register(c9);
te.register(f9);
te.register(d9);
te.register(p9);
te.register(h9);
te.register(m9);
te.register(g9);
te.register(b9);
te.register(v9);
te.register(y9);
te.register(O9);
te.register(E9);
te.register(S9);
te.register(w9);
te.register(T9);
te.register(_9);
te.register(C9);
te.register(x9);
te.register(A9);
te.register(k9);
te.register(R9);
te.register(I9);
te.register(D9);
te.register(N9);
te.register(I0);
te.register(P9);
te.register(L9);
te.register(M9);
te.register(F9);
te.register($9);
te.register(B9);
te.register(U9);
te.register(z9);
te.register(H9);
te.register(W9);
te.register(LD);
te.register(al);
te.register(Q9);
te.register(j9);
te.register(G9);
te.register(V9);
te.register(Y9);
te.register(Z9);
te.register(X9);
te.register(q9);
te.register(K9);
te.register(J9);
te.register(A_);
te.register(ez);
te.register(tz);
te.register(nz);
te.register(rz);
te.register(az);
te.register(iz);
te.register(oz);
te.register(sz);
te.register(lz);
te.register(uz);
te.register(cz);
te.register(fz);
te.register(dz);
te.register(pz);
te.register(hz);
te.register(mz);
te.register(gz);
te.register(bz);
te.register(vz);
te.register(yz);
te.register(Oz);
te.register(Ez);
te.register(MD);
te.register(Sz);
te.register(wz);
te.register(Tz);
te.register(_z);
te.register(UD);
te.register(YD);
te.register(Cz);
te.register(xz);
te.register(Az);
te.register(P_);
te.register(kz);
te.register(Rz);
te.register(Iz);
te.register(Dz);
te.register(Nz);
te.register(Pz);
te.register(b1);
te.register(Lz);
te.register(Mz);
te.register(Fz);
te.register($z);
te.register(Bz);
te.register(Uz);
te.register(zz);
te.register(Hz);
te.register(FD);
te.register(Wz);
te.register(Qz);
te.register(k0);
te.register(R0);
te.register(w1);
te.register(jz);
te.register(Gz);
te.register(Vz);
te.register(Yz);
te.register(Zz);
te.register(Xz);
te.register(qz);
te.register(y1);
te.register(Kz);
te.register(Jz);
te.register(e8);
te.register(t8);
te.register(n8);
te.register(r8);
te.register(a8);
te.register(i8);
te.register(o8);
te.register(BD);
te.register(s8);
te.register(l8);
te.register(u8);
te.register(c8);
te.register(L_);
te.register(f8);
te.register(d8);
te.register(p8);
te.register(h8);
te.register(m8);
te.register(g8);
te.register(b8);
te.register(v8);
te.register(zD);
te.register(XD);
te.register(y8);
te.register(O8);
te.register(E8);
te.register(S8);
te.register(w8);
te.register(T8);
te.register(_8);
te.register(C8);
te.register(x8);
te.register(A8);
te.register(k8);
te.register(R8);
te.register(I8);
te.register(D8);
te.register(N8);
te.register(P8);
te.register(L8);
te.register(M8);
te.register(F8);
te.register(WD);
te.register($8);
te.register(B8);
te.register(U8);
te.register(z8);
te.register(H8);
te.register(W8);
te.register(Q8);
te.register(j8);
te.register(G8);
te.register(V8);
te.register(Y8);
te.register(Z8);
te.register(QD);
te.register(X8);
te.register(q8);
te.register(K8);
te.register(J8);
te.register(eH);
te.register(tH);
te.register(nH);
te.register(rH);
te.register(aH);
te.register(iH);
te.register(oH);
te.register(sH);
te.register(lH);
te.register(uH);
te.register(cH);
te.register(fH);
te.register(dH);
te.register(pH);
te.register(R_);
te.register(hH);
te.register(mH);
te.register(gH);
te.register(bH);
te.register(jD);
te.register(vH);
te.register(yH);
te.register(qD);
te.register(OH);
te.register(EH);
te.register(SH);
te.register(wH);
te.register(TH);
te.register(_H);
te.register(CH);
te.register(xH);
te.register(AH);
te.register(GD);
te.register(kH);
te.register(VD);
te.register(RH);
te.register(IH);
te.register(DH);
te.register(NH);
te.register(PH);
te.register(LH);
te.register(MH);
te.register(FH);
te.register(KD);
te.register($H);
te.register(BH);
te.register(UH);
te.register(zH);
te.register(HH);
te.register(WH);
te.register(QH);
te.register(jH);
te.register(ZD);
te.register(GH);
te.register(M_);
te.register(VH);
te.register(D_);
te.register(YH);
te.register(ZH);
te.register(XH);
te.register(qH);
te.register(KH);
te.register(JH);
te.register(e7);
te.register(t7);
te.register(n7);
te.register(r7);
te.register(a7);
te.register(i7);
te.register(o7);
te.register(s7);
te.register(l7);
te.register(u7);
te.register(c7);
te.register(f7);
te.register(d7);
te.register(p7);
te.register(h7);
te.register(m7);
te.register(g7);
te.register(b7);
te.register(v7);
te.register(y7);
te.register(O7);
te.register(E7);
te.register(S7);
function s5() {
  s5 = function(a, i) {
    return new n(a, void 0, i);
  };
  var t = RegExp.prototype, e = /* @__PURE__ */ new WeakMap();
  function n(a, i, o) {
    var s = new RegExp(a, i);
    return e.set(s, o || e.get(a)), RI(s, n.prototype);
  }
  function r(a, i) {
    var o = e.get(i);
    return Object.keys(o).reduce(function(s, u) {
      var f = o[u];
      if (typeof f == "number")
        s[u] = a[f];
      else {
        for (var p = 0; a[f[p]] === void 0 && p + 1 < f.length; )
          p++;
        s[u] = a[f[p]];
      }
      return s;
    }, /* @__PURE__ */ Object.create(null));
  }
  return function(a, i) {
    if (typeof i != "function" && i !== null)
      throw new TypeError("Super expression must either be null or a function");
    a.prototype = Object.create(i && i.prototype, { constructor: { value: a, writable: !0, configurable: !0 } }), Object.defineProperty(a, "prototype", { writable: !1 }), i && RI(a, i);
  }(n, RegExp), n.prototype.exec = function(a) {
    var i = t.exec.call(this, a);
    if (i) {
      i.groups = r(i, this);
      var o = i.indices;
      o && (o.groups = r(o, this));
    }
    return i;
  }, n.prototype[Symbol.replace] = function(a, i) {
    if (typeof i == "string") {
      var o = e.get(this);
      return t[Symbol.replace].call(this, a, i.replace(/\$<([^>]+)>/g, function(u, f) {
        var p = o[f];
        return "$" + (Array.isArray(p) ? p.join("$") : p);
      }));
    }
    if (typeof i == "function") {
      var s = this;
      return t[Symbol.replace].call(this, a, function() {
        var u = arguments;
        return typeof u[u.length - 1] != "object" && (u = [].slice.call(u)).push(r(u, s)), i.apply(this, u);
      });
    }
    return t[Symbol.replace].call(this, a, i);
  }, s5.apply(this, arguments);
}
function RI(t, e) {
  return RI = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, RI(t, e);
}
function eJ(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function U3(t, e) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n)
    return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = function(a, i) {
    if (a) {
      if (typeof a == "string")
        return eJ(a, i);
      var o = Object.prototype.toString.call(a).slice(8, -1);
      return o === "Object" && a.constructor && (o = a.constructor.name), o === "Map" || o === "Set" ? Array.from(a) : o === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? eJ(a, i) : void 0;
    }
  }(t)) || e && t && typeof t.length == "number") {
    n && (t = n);
    var r = 0;
    return function() {
      return r >= t.length ? { done: !0 } : { done: !1, value: t[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var X5e = function(t) {
  return function(e) {
    return e === void 0 && (e = {}), function(r, a) {
      if (a && !r.registered(a))
        throw new Error('The default language "' + a + '" is not registered with refractor.');
    }(t, e.defaultLanguage), function(r) {
      r5e(r, "element", n);
    };
    function n(r, a, i) {
      var o, s;
      if (i && i.tagName === "pre" && r.tagName === "code") {
        var u = (r == null || (o = r.data) == null ? void 0 : o.meta) || (r == null || (s = r.properties) == null ? void 0 : s.metastring) || "";
        r.properties.className ? typeof r.properties.className == "boolean" ? r.properties.className = [] : Array.isArray(r.properties.className) || (r.properties.className = [r.properties.className]) : r.properties.className = [];
        var f, p, m = function(D) {
          for (var M, H = U3(D.properties.className); !(M = H()).done; ) {
            var Y = M.value;
            if (Y.slice(0, 9) === "language-")
              return Y.slice(9).toLowerCase();
          }
          return null;
        }(r);
        if (!m && e.defaultLanguage && r.properties.className.push("language-" + (m = e.defaultLanguage)), r.properties.className.push("code-highlight"), m)
          try {
            var v, O;
            O = (v = m) != null && v.includes("diff-") ? m.split("-")[1] : m, f = t.highlight(OE(r), O), i.properties.className = (i.properties.className || []).concat("language-" + O);
          } catch (D) {
            if (!e.ignoreMissing || !/Unknown language/.test(D.message))
              throw D;
            f = r;
          }
        else
          f = r;
        f.children = (p = 1, function D(M) {
          return M.reduce(function(H, Y) {
            if (Y.type === "text") {
              var q = Y.value, Q = (q.match(/\n/g) || "").length;
              if (Q === 0)
                Y.position = { start: { line: p, column: 1 }, end: { line: p, column: 1 } }, H.push(Y);
              else
                for (var ne, J = q.split(`
`), ue = U3(J.entries()); !(ne = ue()).done; ) {
                  var ee = ne.value, fe = ee[0], de = ee[1];
                  H.push({ type: "text", value: fe === J.length - 1 ? de : de + `
`, position: { start: { line: p + fe, column: 1 }, end: { line: p + fe, column: 1 } } });
                }
              return p += Q, H;
            }
            if (Object.prototype.hasOwnProperty.call(Y, "children")) {
              var ie = p;
              return Y.children = D(Y.children), H.push(Y), Y.position = { start: { line: ie, column: 1 }, end: { line: p, column: 1 } }, H;
            }
            return H.push(Y), H;
          }, []);
        })(f.children), f.position = f.children.length > 0 ? { start: { line: f.children[0].position.start.line, column: 0 }, end: { line: f.children[f.children.length - 1].position.end.line, column: 0 } } : { start: { line: 0, column: 0 }, end: { line: 0, column: 0 } };
        for (var w, _ = function(D) {
          var M = /{([\d,-]+)}/, H = D.split(",").map(function(Q) {
            return Q.trim();
          }).join();
          if (M.test(H)) {
            var Y = M.exec(H)[1], q = h5e(Y);
            return function(Q) {
              return q.includes(Q + 1);
            };
          }
          return function() {
            return !1;
          };
        }(u), C = function(D) {
          var M = /* @__PURE__ */ s5(/showLineNumbers=(\d+)/i, { lines: 1 });
          if (M.test(D)) {
            var H = M.exec(D);
            return Number(H.groups.lines);
          }
          return 1;
        }(u), A = function(D) {
          for (var M = new Array(D), H = 0; H < D; H++)
            M[H] = { type: "element", tagName: "span", properties: { className: [] }, children: [] };
          return M;
        }(f.position.end.line), N = ["showlinenumbers=false", 'showlinenumbers="false"', "showlinenumbers={false}"], P = function() {
          var D, M, H = w.value, Y = H[0], q = H[1];
          q.properties.className = ["code-line"];
          var Q = f5e(f, function(ne) {
            return ne.position.start.line <= Y + 1 && ne.position.end.line >= Y + 1;
          });
          q.children = Q.children, !u.toLowerCase().includes("showLineNumbers".toLowerCase()) && !e.showLineNumbers || N.some(function(ne) {
            return u.toLowerCase().includes(ne);
          }) || (q.properties.line = [(Y + C).toString()], q.properties.className.push("line-number")), _(Y) && q.properties.className.push("highlight-line"), (m === "diff" || (D = m) != null && D.includes("diff-")) && OE(q).substring(0, 1) === "-" ? q.properties.className.push("deleted") : (m === "diff" || (M = m) != null && M.includes("diff-")) && OE(q).substring(0, 1) === "+" && q.properties.className.push("inserted");
        }, I = U3(A.entries()); !(w = I()).done; )
          P();
        A.length > 0 && OE(A[A.length - 1]).trim() === "" && A.pop(), r.children = A;
      }
    }
  };
}, q5e = X5e(te);
const Jle = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(t) {
    if (t == null)
      return tUe;
    if (typeof t == "function")
      return JD(t);
    if (typeof t == "object")
      return Array.isArray(t) ? K5e(t) : J5e(t);
    if (typeof t == "string")
      return eUe(t);
    throw new Error("Expected function, string, or object as test");
  }
);
function K5e(t) {
  const e = [];
  let n = -1;
  for (; ++n < t.length; )
    e[n] = Jle(t[n]);
  return JD(r);
  function r(...a) {
    let i = -1;
    for (; ++i < e.length; )
      if (e[i].apply(this, a))
        return !0;
    return !1;
  }
}
function J5e(t) {
  const e = (
    /** @type {Record<string, unknown>} */
    t
  );
  return JD(n);
  function n(r) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let i;
    for (i in t)
      if (a[i] !== e[i])
        return !1;
    return !0;
  }
}
function eUe(t) {
  return JD(e);
  function e(n) {
    return n && n.type === t;
  }
}
function JD(t) {
  return e;
  function e(n, r, a) {
    return !!(nUe(n) && t.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      a || void 0
    ));
  }
}
function tUe() {
  return !0;
}
function nUe(t) {
  return t !== null && typeof t == "object" && "type" in t;
}
const eue = [], rUe = !0, tJ = !1, aUe = "skip";
function iUe(t, e, n, r) {
  let a;
  typeof e == "function" && typeof n != "function" ? (r = n, n = e) : a = e;
  const i = Jle(a), o = r ? -1 : 1;
  s(t, void 0, [])();
  function s(u, f, p) {
    const m = (
      /** @type {Record<string, unknown>} */
      u && typeof u == "object" ? u : {}
    );
    if (typeof m.type == "string") {
      const O = (
        // `hast`
        typeof m.tagName == "string" ? m.tagName : (
          // `xast`
          typeof m.name == "string" ? m.name : void 0
        )
      );
      Object.defineProperty(v, "name", {
        value: "node (" + (u.type + (O ? "<" + O + ">" : "")) + ")"
      });
    }
    return v;
    function v() {
      let O = eue, w, _, C;
      if ((!e || i(u, f, p[p.length - 1] || void 0)) && (O = oUe(n(u, p)), O[0] === tJ))
        return O;
      if ("children" in u && u.children) {
        const A = (
          /** @type {UnistParent} */
          u
        );
        if (A.children && O[0] !== aUe)
          for (_ = (r ? A.children.length : -1) + o, C = p.concat(A); _ > -1 && _ < A.children.length; ) {
            const N = A.children[_];
            if (w = s(N, _, C)(), w[0] === tJ)
              return w;
            _ = typeof w[1] == "number" ? w[1] : _ + o;
          }
      }
      return O;
    }
  }
}
function oUe(t) {
  return Array.isArray(t) ? t : typeof t == "number" ? [rUe, t] : t == null ? eue : [t];
}
function nJ(t, e, n, r) {
  let a, i, o;
  typeof e == "function" && typeof n != "function" ? (i = void 0, o = e, a = n) : (i = e, o = n, a = r), iUe(t, i, s, a);
  function s(u, f) {
    const p = f[f.length - 1], m = p ? p.children.indexOf(u) : void 0;
    return o(u, m, p);
  }
}
var Pk = {}, l5 = {};
function sUe(t, e) {
  for (var n = e, r = 0; r < t.length; r++) {
    var a = r === t.length - 1, i = t.charAt(r), o = n[i] || (n[i] = { chars: {} });
    a && (o.self = t), n = o.chars;
  }
}
function rJ(t) {
  if (t.length === 0)
    return Pk;
  for (var e = {}, n = 0, r = t; n < r.length; n++) {
    var a = r[n];
    sUe(a, e);
  }
  return e;
}
function lUe(t) {
  if (t.length === 0)
    return l5;
  for (var e = {}, n = 0, r = t; n < r.length; n++) {
    var a = r[n];
    e[a] = !0;
  }
  return e;
}
var fA = {}, aJ = {
  type: "String",
  optional: !0
};
function uUe(t) {
  var e = {
    type: "NoArgument",
    optional: !1
  };
  function n(o) {
    if (e.type && e.type !== o && e.type !== "NoArgument")
      throw new Error('Conflicting pseudo-class argument type: "'.concat(e.type, '" vs "').concat(o, '".'));
    e.type = o;
  }
  for (var r = 0, a = t; r < a.length; r++) {
    var i = a[r];
    i === "NoArgument" && (e.optional = !0), i === "Formula" && n("Formula"), i === "FormulaOfSelector" && (n("Formula"), e.ofSelector = !0), i === "String" && n("String"), i === "Selector" && n("Selector");
  }
  return e;
}
function cUe(t) {
  for (var e = {}, n = 0, r = Object.keys(t); n < r.length; n++) {
    var a = r[n], i = t[a];
    if (i)
      for (var o = 0, s = i; o < s.length; o++) {
        var u = s[o];
        (e[u] || (e[u] = [])).push(a);
      }
  }
  return e;
}
function iJ(t) {
  for (var e = cUe(t), n = {}, r = 0, a = Object.keys(e); r < a.length; r++) {
    var i = a[r], o = e[i];
    o && (n[i] = uUe(o));
  }
  return n;
}
var II = globalThis && globalThis.__assign || function() {
  return II = Object.assign || function(t) {
    for (var e, n = 1, r = arguments.length; n < r; n++) {
      e = arguments[n];
      for (var a in e)
        Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
    }
    return t;
  }, II.apply(this, arguments);
}, fUe = {}, u5 = { wildcard: !0 };
function dUe(t) {
  return t ? typeof t == "boolean" ? u5 : t : fUe;
}
function pUe(t, e) {
  return function(n, r) {
    return e(t(n), t(r));
  };
}
function hUe(t) {
  return function(e, n) {
    var r = t(e, n);
    if (!r)
      throw new Error("Syntax definition cannot be null or undefined.");
    return r;
  };
}
function oJ(t, e) {
  return function(n, r) {
    return r === !0 ? t : e(n === !0 ? t : n, r);
  };
}
function nE(t) {
  return function(e, n) {
    if (!n || !e)
      return n;
    if (typeof n != "object" || n === null)
      throw new Error("Unexpected syntax definition extension type: ".concat(n, "."));
    for (var r = II({}, e), a = 0, i = Object.entries(n); a < i.length; a++) {
      var o = i[a], s = o[0], u = o[1], f = t[s];
      r[s] = f(e[s], u);
    }
    return r;
  };
}
function Vm(t, e) {
  return e !== void 0 ? e : t;
}
function z3(t, e) {
  return e ? t ? t.concat(e) : e : t;
}
function sJ(t, e) {
  if (!e)
    return t;
  if (!t)
    return e;
  for (var n = II({}, t), r = 0, a = Object.entries(e); r < a.length; r++) {
    var i = a[r], o = i[0], s = i[1];
    if (!s) {
      delete n[o];
      continue;
    }
    var u = t[o];
    if (!u) {
      n[o] = s;
      continue;
    }
    n[o] = u.concat(s);
  }
  return n;
}
var F_ = hUe(nE({
  baseSyntax: Vm,
  tag: oJ(u5, nE({
    wildcard: Vm
  })),
  ids: Vm,
  classNames: Vm,
  namespace: oJ(u5, nE({
    wildcard: Vm
  })),
  combinators: z3,
  attributes: nE({
    operators: z3,
    caseSensitivityModifiers: z3,
    unknownCaseSensitivityModifiers: Vm
  }),
  pseudoClasses: nE({
    unknown: Vm,
    definitions: sJ
  }),
  pseudoElements: nE({
    unknown: Vm,
    notation: Vm,
    definitions: pUe(function(t) {
      return Array.isArray(t) ? { NoArgument: t } : t;
    }, sJ)
  })
})), tue = {
  tag: {},
  ids: !0,
  classNames: !0,
  combinators: [],
  pseudoElements: {
    unknown: "reject",
    notation: "singleColon",
    definitions: ["first-letter", "first-line"]
  },
  pseudoClasses: {
    unknown: "reject",
    definitions: {
      NoArgument: ["link", "visited", "active"]
    }
  }
}, nue = F_(tue, {
  tag: { wildcard: !0 },
  combinators: [">", "+"],
  attributes: {
    unknownCaseSensitivityModifiers: "reject",
    operators: ["=", "~=", "|="]
  },
  pseudoElements: {
    definitions: ["before", "after"]
  },
  pseudoClasses: {
    unknown: "reject",
    definitions: {
      NoArgument: ["hover", "focus", "first-child"],
      String: ["lang"]
    }
  }
}), c5 = F_(nue, {
  namespace: {
    wildcard: !0
  },
  combinators: ["~"],
  attributes: {
    operators: ["^=", "$=", "*="]
  },
  pseudoElements: {
    notation: "both"
  },
  pseudoClasses: {
    definitions: {
      NoArgument: [
        "root",
        "last-child",
        "first-of-type",
        "last-of-type",
        "only-child",
        "only-of-type",
        "empty",
        "target",
        "enabled",
        "disabled",
        "checked",
        "indeterminate"
      ],
      Formula: ["nth-child", "nth-last-child", "nth-of-type", "nth-last-of-type"],
      Selector: ["not"]
    }
  }
}), f5 = F_(c5, {
  combinators: ["||"],
  attributes: {
    caseSensitivityModifiers: ["i", "I", "s", "S"]
  },
  pseudoClasses: {
    definitions: {
      NoArgument: [
        "any-link",
        "local-link",
        "target-within",
        "scope",
        "current",
        "past",
        "future",
        "focus-within",
        "focus-visible",
        "read-write",
        "read-only",
        "placeholder-shown",
        "default",
        "valid",
        "invalid",
        "in-range",
        "out-of-range",
        "required",
        "optional",
        "blank",
        "user-invalid"
      ],
      Formula: ["nth-col", "nth-last-col"],
      String: ["dir"],
      FormulaOfSelector: ["nth-child", "nth-last-child"],
      Selector: ["current", "is", "where", "has"]
    }
  }
}), mUe = F_(f5, {
  pseudoElements: {
    unknown: "accept"
  },
  pseudoClasses: {
    unknown: "accept"
  },
  attributes: {
    unknownCaseSensitivityModifiers: "accept"
  }
}), lJ = {
  css1: tue,
  css2: nue,
  css3: c5,
  "selectors-3": c5,
  "selectors-4": f5,
  latest: f5,
  progressive: mUe
};
function xw(t) {
  return t >= "a" && t <= "z" || t >= "A" && t <= "Z" || t === "-" || t === "_" || t === "\\" || t >= " ";
}
function uJ(t) {
  return t >= "a" && t <= "z" || t >= "A" && t <= "Z" || t >= "0" && t <= "9" || t === "-" || t === "_" || t >= " ";
}
function Aw(t) {
  return t >= "a" && t <= "f" || t >= "A" && t <= "F" || t >= "0" && t <= "9";
}
var gUe = {
  " ": !0,
  "	": !0,
  "\n": !0,
  "\r": !0,
  "\f": !0
}, bUe = {
  '"': !0,
  "'": !0
}, H3 = {
  0: !0,
  1: !0,
  2: !0,
  3: !0,
  4: !0,
  5: !0,
  6: !0,
  7: !0,
  8: !0,
  9: !0
}, vUe = 6, W3 = "css-selector-parser parse error: ";
function yUe(t) {
  t === void 0 && (t = {});
  var e = t.syntax, n = e === void 0 ? "latest" : e, r = t.substitutes, a = t.strict, i = a === void 0 ? !0 : a, o = typeof n == "object" ? n : lJ[n];
  o.baseSyntax && (o = F_(lJ[o.baseSyntax], o));
  var s = o.tag ? [!0, !!dUe(o.tag).wildcard] : [!1, !1], u = s[0], f = s[1], p = !!o.ids, m = !!o.classNames, v = !!o.namespace, O = o.namespace && (o.namespace === !0 || o.namespace.wildcard === !0);
  if (v && !u)
    throw new Error("".concat(W3, "Namespaces cannot be enabled while tags are disabled."));
  var w = !!r, _ = o.combinators ? rJ(o.combinators) : Pk, C = o.attributes ? [
    !0,
    o.attributes.operators ? rJ(o.attributes.operators) : Pk,
    o.attributes.caseSensitivityModifiers ? lUe(o.attributes.caseSensitivityModifiers) : l5,
    o.attributes.unknownCaseSensitivityModifiers === "accept"
  ] : [!1, Pk, l5, !1], A = C[0], N = C[1], P = C[2], I = C[3], D = I || Object.keys(P).length > 0, M = o.pseudoClasses ? [
    !0,
    o.pseudoClasses.definitions ? iJ(o.pseudoClasses.definitions) : fA,
    o.pseudoClasses.unknown === "accept"
  ] : [!1, fA, !1], H = M[0], Y = M[1], q = M[2], Q = o.pseudoElements ? [
    !0,
    o.pseudoElements.notation === "singleColon" || o.pseudoElements.notation === "both",
    !o.pseudoElements.notation || o.pseudoElements.notation === "doubleColon" || o.pseudoElements.notation === "both",
    o.pseudoElements.definitions ? iJ(Array.isArray(o.pseudoElements.definitions) ? { NoArgument: o.pseudoElements.definitions } : o.pseudoElements.definitions) : fA,
    o.pseudoElements.unknown === "accept"
  ] : [!1, !1, !1, fA, !1], ne = Q[0], J = Q[1], ue = Q[2], ee = Q[3], fe = Q[4], de = "", ie = de.length, le = 0, ye = "", B = function(Ie) {
    return ye === Ie;
  }, pe = function() {
    return B("*") || xw(ye);
  }, _e = function(Ie) {
    le = Ie, ye = de.charAt(le);
  }, Z = function() {
    le++, ye = de.charAt(le);
  }, ce = function() {
    var Ie = ye;
    return le++, ye = de.charAt(le), Ie;
  };
  function j(Ie) {
    var it = Math.min(ie - 1, le), zt = new Error("".concat(W3).concat(Ie, " Pos: ").concat(it, "."));
    throw zt.position = it, zt.name = "ParserError", zt;
  }
  function K(Ie, it) {
    if (!Ie)
      return j(it);
  }
  var Ee = function() {
    K(le < ie, "Unexpected end of input.");
  }, he = function() {
    return le >= ie;
  }, Ae = function(Ie) {
    K(le < ie, 'Expected "'.concat(Ie, '" but end of input reached.')), K(ye === Ie, 'Expected "'.concat(Ie, '" but "').concat(ye, '" found.')), le++, ye = de.charAt(le);
  };
  function Te(Ie) {
    var it = je(Ie, le);
    if (it)
      return le += it.length, ye = de.charAt(le), it;
  }
  function je(Ie, it) {
    var zt = de.charAt(it), Ht = Ie[zt];
    if (Ht) {
      var bt = je(Ht.chars, it + 1);
      if (bt)
        return bt;
      if (Ht.self)
        return Ht.self;
    }
  }
  function we() {
    for (var Ie = ce(), it = 1; Aw(ye) && it < vUe; )
      Ie += ce(), it++;
    return Re(), String.fromCharCode(parseInt(Ie, 16));
  }
  function lt(Ie) {
    var it = "";
    for (Ae(Ie); le < ie; ) {
      if (B(Ie))
        return Z(), it;
      B("\\") ? (Z(), B(Ie) ? (it += Ie, Z()) : ye === `
` || ye === "\f" ? Z() : ye === "\r" ? (Z(), B(`
`) && Z()) : Aw(ye) ? it += we() : (it += ye, Z())) : (it += ye, Z());
    }
    return it;
  }
  function st() {
    if (!xw(ye))
      return null;
    for (var Ie = ""; B("-"); )
      Ie += ye, Z();
    for (Ie === "-" && !uJ(ye) && !B("\\") && j("Identifiers cannot consist of a single hyphen."), i && Ie.length >= 2 && j("Identifiers cannot start with two hyphens with strict mode on."), H3[ye] && j("Identifiers cannot start with hyphens followed by digits."); le < ie; )
      if (uJ(ye))
        Ie += ce();
      else if (B("\\"))
        Z(), Ee(), Aw(ye) ? Ie += we() : Ie += ce();
      else
        break;
    return Ie;
  }
  function Oe() {
    for (var Ie = ""; le < ie && !B(")"); )
      if (B("\\")) {
        if (Z(), he() && !i)
          return (Ie + "\\").trim();
        Ee(), Aw(ye) ? Ie += we() : Ie += ce();
      } else
        Ie += ce();
    return Ie.trim();
  }
  function Re() {
    if (ye === " " || ye === "	" || ye === "\f" || ye === `
`) {
      Z();
      return;
    }
    ye === "\r" && Z(), ye === `
` && Z();
  }
  function Be() {
    for (; gUe[ye]; )
      Z();
  }
  function mt(Ie) {
    Ie === void 0 && (Ie = !1), Be();
    for (var it = [Ve(Ie)]; B(","); )
      Z(), Be(), it.push(Ve(Ie));
    return {
      type: "Selector",
      rules: it
    };
  }
  function Tt() {
    Ae("["), Be();
    var Ie;
    if (B("|")) {
      K(v, "Namespaces are not enabled."), Z();
      var it = st();
      K(it, "Expected attribute name."), Ie = {
        type: "Attribute",
        name: it,
        namespace: { type: "NoNamespace" }
      };
    } else if (B("*")) {
      K(v, "Namespaces are not enabled."), K(O, "Wildcard namespace is not enabled."), Z(), Ae("|");
      var zt = st();
      K(zt, "Expected attribute name."), Ie = {
        type: "Attribute",
        name: zt,
        namespace: { type: "WildcardNamespace" }
      };
    } else {
      var Ht = st();
      if (K(Ht, "Expected attribute name."), Ie = {
        type: "Attribute",
        name: Ht
      }, B("|")) {
        var bt = le;
        if (Z(), xw(ye)) {
          K(v, "Namespaces are not enabled.");
          var Mt = st();
          K(Mt, "Expected attribute name."), Ie = {
            type: "Attribute",
            name: Mt,
            namespace: { type: "NamespaceName", name: Ht }
          };
        } else
          _e(bt);
      }
    }
    if (K(Ie.name, "Expected attribute name."), Be(), he() && !i)
      return Ie;
    if (B("]"))
      Z();
    else {
      if (Ie.operator = Te(N), K(Ie.operator, "Expected a valid attribute selector operator."), Be(), Ee(), bUe[ye])
        Ie.value = {
          type: "String",
          value: lt(ye)
        };
      else if (w && B("$")) {
        Z();
        var ln = st();
        K(ln, "Expected substitute name."), Ie.value = {
          type: "Substitution",
          name: ln
        };
      } else {
        var ze = st();
        K(ze, "Expected attribute value."), Ie.value = {
          type: "String",
          value: ze
        };
      }
      if (Be(), he() && !i)
        return Ie;
      if (!B("]")) {
        var gt = st();
        if (K(gt, "Expected end of attribute selector."), Ie.caseSensitivityModifier = gt, K(D, "Attribute case sensitivity modifiers are not enabled."), K(I || P[Ie.caseSensitivityModifier], "Unknown attribute case sensitivity modifier."), Be(), he() && !i)
          return Ie;
      }
      Ae("]");
    }
    return Ie;
  }
  function ut() {
    for (var Ie = ""; H3[ye]; )
      Ie += ce();
    return K(Ie !== "", "Formula parse error."), parseInt(Ie);
  }
  var wt = function() {
    return B("-") || B("+") || H3[ye];
  };
  function Yt() {
    if (B("e") || B("o")) {
      var Ie = st();
      if (Ie === "even")
        return Be(), [2, 0];
      if (Ie === "odd")
        return Be(), [2, 1];
    }
    var it = null, zt = 1;
    if (B("-") && (Z(), zt = -1), wt() && (B("+") && Z(), it = ut(), !B("\\") && !B("n")))
      return [0, it * zt];
    it === null && (it = 1), it *= zt;
    var Ht;
    if (B("\\") ? (Z(), Aw(ye) ? Ht = we() : Ht = ce()) : Ht = ce(), K(Ht === "n", 'Formula parse error: expected "n".'), Be(), B("+") || B("-")) {
      var bt = B("+") ? 1 : -1;
      return Z(), Be(), [it, bt * ut()];
    } else
      return [it, 0];
  }
  function Rt(Ie, it, zt) {
    var Ht;
    if (B("(")) {
      if (Z(), Be(), w && B("$")) {
        Z();
        var bt = st();
        K(bt, "Expected substitute name."), Ht = {
          type: "Substitution",
          name: bt
        };
      } else if (zt.type === "String")
        Ht = {
          type: "String",
          value: Oe()
        }, K(Ht.value, "Expected ".concat(it, " argument value."));
      else if (zt.type === "Selector")
        Ht = mt(!0);
      else if (zt.type === "Formula") {
        var Mt = Yt(), ln = Mt[0], ze = Mt[1];
        if (Ht = {
          type: "Formula",
          a: ln,
          b: ze
        }, zt.ofSelector && (Be(), B("o") || B("\\"))) {
          var gt = st();
          K(gt === "of", "Formula of selector parse error."), Be(), Ht = {
            type: "FormulaOfSelector",
            a: ln,
            b: ze,
            selector: Ve()
          };
        }
      } else
        return j("Invalid ".concat(it, " signature."));
      if (Be(), he() && !i)
        return Ht;
      Ae(")");
    } else
      K(zt.optional, "Argument is required for ".concat(it, ' "').concat(Ie, '".'));
    return Ht;
  }
  function Ut() {
    if (B("*"))
      return K(f, "Wildcard tag name is not enabled."), Z(), { type: "WildcardTag" };
    if (xw(ye)) {
      K(u, "Tag names are not enabled.");
      var Ie = st();
      return K(Ie, "Expected tag name."), {
        type: "TagName",
        name: Ie
      };
    } else
      return j("Expected tag name.");
  }
  function He() {
    if (B("*")) {
      var Ie = le;
      if (Z(), !B("|") || (Z(), !pe()))
        return _e(Ie), Ut();
      K(v, "Namespaces are not enabled."), K(O, "Wildcard namespace is not enabled.");
      var it = Ut();
      return it.namespace = { type: "WildcardNamespace" }, it;
    } else if (B("|")) {
      K(v, "Namespaces are not enabled."), Z();
      var it = Ut();
      return it.namespace = { type: "NoNamespace" }, it;
    } else if (xw(ye)) {
      var zt = st();
      if (K(zt, "Expected tag name."), !B("|"))
        return K(u, "Tag names are not enabled."), {
          type: "TagName",
          name: zt
        };
      var Ie = le;
      if (Z(), !pe())
        return _e(Ie), {
          type: "TagName",
          name: zt
        };
      K(v, "Namespaces are not enabled.");
      var it = Ut();
      return it.namespace = { type: "NamespaceName", name: zt }, it;
    } else
      return j("Expected tag name.");
  }
  function Ve(Ie) {
    var it, zt;
    Ie === void 0 && (Ie = !1);
    var Ht = { type: "Rule", items: [] };
    if (Ie) {
      var bt = Te(_);
      bt && (Ht.combinator = bt, Be());
    }
    for (; le < ie; )
      if (pe())
        K(Ht.items.length === 0, "Unexpected tag/namespace start."), Ht.items.push(He());
      else if (B("|")) {
        var Mt = le;
        if (Z(), pe())
          K(Ht.items.length === 0, "Unexpected tag/namespace start."), _e(Mt), Ht.items.push(He());
        else {
          _e(Mt);
          break;
        }
      } else if (B(".")) {
        K(m, "Class names are not enabled."), Z();
        var ln = st();
        K(ln, "Expected class name."), Ht.items.push({ type: "ClassName", name: ln });
      } else if (B("#")) {
        K(p, "IDs are not enabled."), Z();
        var ze = st();
        K(ze, "Expected ID name."), Ht.items.push({ type: "Id", name: ze });
      } else if (B("["))
        K(A, "Attributes are not enabled."), Ht.items.push(Tt());
      else if (B(":")) {
        var gt = !1, Bt = !1;
        Z(), B(":") && (K(ne, "Pseudo elements are not enabled."), K(ue, "Pseudo elements double colon notation is not enabled."), gt = !0, Z());
        var Qt = st();
        if (K(gt || Qt, "Expected pseudo-class name."), K(!gt || Qt, "Expected pseudo-element name."), K(Qt, "Expected pseudo-class name."), K(!gt || fe || Object.prototype.hasOwnProperty.call(ee, Qt), 'Unknown pseudo-element "'.concat(Qt, '".')), Bt = ne && (gt || !gt && J && Object.prototype.hasOwnProperty.call(ee, Qt)), Bt) {
          var En = (it = ee[Qt]) !== null && it !== void 0 ? it : fe && aJ, Mn = {
            type: "PseudoElement",
            name: Qt
          }, br = Rt(Qt, "pseudo-element", En);
          br && (K(br.type !== "Formula" && br.type !== "FormulaOfSelector", "Pseudo-elements cannot have formula argument."), Mn.argument = br), Ht.items.push(Mn);
        } else {
          K(H, "Pseudo-classes are not enabled.");
          var En = (zt = Y[Qt]) !== null && zt !== void 0 ? zt : q && aJ;
          K(En, 'Unknown pseudo-class: "'.concat(Qt, '".'));
          var br = Rt(Qt, "pseudo-class", En), sr = {
            type: "PseudoClass",
            name: Qt
          };
          br && (sr.argument = br), Ht.items.push(sr);
        }
      } else
        break;
    if (Ht.items.length === 0)
      return he() ? j("Expected rule but end of input reached.") : j('Expected rule but "'.concat(ye, '" found.'));
    if (Be(), !he() && !B(",") && !B(")")) {
      var bt = Te(_);
      Be(), Ht.nestedRule = Ve(), Ht.nestedRule.combinator = bt;
    }
    return Ht;
  }
  return function(Ie) {
    if (typeof Ie != "string")
      throw new Error("".concat(W3, "Expected string input."));
    return de = Ie, ie = de.length, le = 0, ye = de.charAt(0), mt();
  };
}
var Xo = globalThis && globalThis.__assign || function() {
  return Xo = Object.assign || function(t) {
    for (var e, n = 1, r = arguments.length; n < r; n++) {
      e = arguments[n];
      for (var a in e)
        Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
    }
    return t;
  }, Xo.apply(this, arguments);
};
function xl(t) {
  return function(e, n) {
    var r;
    return r = {}, r[e] = function(a) {
      return Xo({ type: t }, a);
    }, r[n] = function(a) {
      return typeof a == "object" && a !== null && a.type === t;
    }, r;
  };
}
Xo(Xo(Xo(Xo(Xo(Xo(Xo(Xo(Xo(Xo(Xo(Xo(Xo(Xo(Xo(Xo({}, xl("Selector")("selector", "isSelector")), xl("Rule")("rule", "isRule")), xl("TagName")("tagName", "isTagName")), xl("Id")("id", "isId")), xl("ClassName")("className", "isClassName")), xl("WildcardTag")("wildcardTag", "isWildcardTag")), xl("NamespaceName")("namespaceName", "isNamespaceName")), xl("WildcardNamespace")("wildcardNamespace", "isWildcardNamespace")), xl("NoNamespace")("noNamespace", "isNoNamespace")), xl("Attribute")("attribute", "isAttribute")), xl("PseudoClass")("pseudoClass", "isPseudoClass")), xl("PseudoElement")("pseudoElement", "isPseudoElement")), xl("String")("string", "isString")), xl("Formula")("formula", "isFormula")), xl("FormulaOfSelector")("formulaOfSelector", "isFormulaOfSelector")), xl("Substitution")("substitution", "isSubstitution"));
const OUe = yUe({ syntax: "selectors-4" });
function EUe(t) {
  if (typeof t != "string")
    throw new TypeError("Expected `string` as selector, not `" + t + "`");
  return OUe(t);
}
const rue = "֑-߿יִ-﷽ﹰ-ﻼ", aue = "A-Za-zÀ-ÖØ-öø-ʸ̀-֐ࠀ-῿‎Ⰰ-﬜︀-﹯﻽-￿", SUe = new RegExp("^[^" + aue + "]*[" + rue + "]"), wUe = new RegExp("^[^" + rue + "]*[" + aue + "]");
function TUe(t) {
  const e = String(t || "");
  return SUe.test(e) ? "rtl" : wUe.test(e) ? "ltr" : "neutral";
}
const iue = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(t) {
    if (t == null)
      return AUe;
    if (typeof t == "function")
      return eN(t);
    if (typeof t == "object")
      return Array.isArray(t) ? _Ue(t) : CUe(t);
    if (typeof t == "string")
      return xUe(t);
    throw new Error("Expected function, string, or object as test");
  }
);
function _Ue(t) {
  const e = [];
  let n = -1;
  for (; ++n < t.length; )
    e[n] = iue(t[n]);
  return eN(r);
  function r(...a) {
    let i = -1;
    for (; ++i < e.length; )
      if (e[i].apply(this, a))
        return !0;
    return !1;
  }
}
function CUe(t) {
  const e = (
    /** @type {Record<string, unknown>} */
    t
  );
  return eN(n);
  function n(r) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let i;
    for (i in t)
      if (a[i] !== e[i])
        return !1;
    return !0;
  }
}
function xUe(t) {
  return eN(e);
  function e(n) {
    return n && n.type === t;
  }
}
function eN(t) {
  return e;
  function e(n, r, a) {
    return !!(kUe(n) && t.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      a || void 0
    ));
  }
}
function AUe() {
  return !0;
}
function kUe(t) {
  return t !== null && typeof t == "object" && "type" in t;
}
const oue = [], RUe = !0, d5 = !1, sue = "skip";
function IUe(t, e, n, r) {
  let a;
  typeof e == "function" && typeof n != "function" ? (r = n, n = e) : a = e;
  const i = iue(a), o = r ? -1 : 1;
  s(t, void 0, [])();
  function s(u, f, p) {
    const m = (
      /** @type {Record<string, unknown>} */
      u && typeof u == "object" ? u : {}
    );
    if (typeof m.type == "string") {
      const O = (
        // `hast`
        typeof m.tagName == "string" ? m.tagName : (
          // `xast`
          typeof m.name == "string" ? m.name : void 0
        )
      );
      Object.defineProperty(v, "name", {
        value: "node (" + (u.type + (O ? "<" + O + ">" : "")) + ")"
      });
    }
    return v;
    function v() {
      let O = oue, w, _, C;
      if ((!e || i(u, f, p[p.length - 1] || void 0)) && (O = DUe(n(u, p)), O[0] === d5))
        return O;
      if ("children" in u && u.children) {
        const A = (
          /** @type {UnistParent} */
          u
        );
        if (A.children && O[0] !== sue)
          for (_ = (r ? A.children.length : -1) + o, C = p.concat(A); _ > -1 && _ < A.children.length; ) {
            const N = A.children[_];
            if (w = s(N, _, C)(), w[0] === d5)
              return w;
            _ = typeof w[1] == "number" ? w[1] : _ + o;
          }
      }
      return O;
    }
  }
}
function DUe(t) {
  return Array.isArray(t) ? t : typeof t == "number" ? [RUe, t] : t == null ? oue : [t];
}
function NUe(t, e, n, r) {
  let a, i, o;
  typeof e == "function" && typeof n != "function" ? (i = void 0, o = e, a = n) : (i = e, o = n, a = r), IUe(t, i, s, a);
  function s(u, f) {
    const p = f[f.length - 1], m = p ? p.children.indexOf(u) : void 0;
    return o(u, m, p);
  }
}
function PUe(t, e) {
  const n = t.schema, r = t.language, a = t.direction, i = t.editableOrEditingHost;
  let o;
  if (e.type === "element") {
    const f = e.properties.xmlLang || e.properties.lang, p = e.properties.type || "text", m = cJ(e);
    f != null && (t.language = String(f)), n && n.space === "html" ? (e.properties.contentEditable === "true" && (t.editableOrEditingHost = !0), e.tagName === "svg" && (t.schema = og), m === "rtl" ? o = m : /* Explicit `[dir=ltr]`. */ m === "ltr" || // HTML with an invalid or no `[dir]`.
    m !== "auto" && e.tagName === "html" || // `input[type=tel]` with an invalid or no `[dir]`.
    m !== "auto" && e.tagName === "input" && p === "tel" ? o = "ltr" : (m === "auto" || e.tagName === "bdi") && (e.tagName === "textarea" ? o = Q3(OE(e)) : e.tagName === "input" && (p === "email" || p === "search" || p === "tel" || p === "text") ? o = e.properties.value ? Q3(String(e.properties.value)) : "ltr" : NUe(e, u)), o && (t.direction = o)) : t.editableOrEditingHost && (t.editableOrEditingHost = !1);
  }
  return s;
  function s() {
    t.schema = n, t.language = r, t.direction = a, t.editableOrEditingHost = i;
  }
  function u(f) {
    if (f.type === "text")
      return o = Q3(f.value), o ? d5 : void 0;
    if (f !== e && f.type === "element" && (f.tagName === "bdi" || f.tagName === "script" || f.tagName === "style" || f.tagName === "textare" || cJ(f)))
      return sue;
  }
}
function Q3(t) {
  const e = TUe(t);
  return e === "neutral" ? void 0 : e;
}
function cJ(t) {
  const e = t.type === "element" && typeof t.properties.dir == "string" ? t.properties.dir.toLowerCase() : void 0;
  return e === "auto" || e === "ltr" || e === "rtl" ? e : void 0;
}
function LUe(t) {
  const e = String(t || "").trim();
  return e ? e.split(/[ \t\n\r\f]+/g) : [];
}
function MUe(t) {
  return t.join(" ").trim();
}
function FUe(t, e, n) {
  const r = E1(n, t.name), a = e.properties[r.property];
  let i = $Ue(a, r);
  if (!t.value)
    return i !== void 0;
  t.value.type;
  let o = t.value.value;
  if (t.caseSensitivityModifier === "i" && (o = o.toLowerCase(), i && (i = i.toLowerCase())), i !== void 0)
    switch (t.operator) {
      case "=":
        return o === i;
      case "$=":
        return o === i.slice(-o.length);
      case "*=":
        return i.includes(o);
      case "^=":
        return o === i.slice(0, o.length);
      case "|=":
        return o === i || o === i.slice(0, o.length) && i.charAt(o.length) === "-";
      case "~=":
        return (
          // For all other values (including comma-separated lists), return whether this
          // is an exact match.
          o === i || // If this is a space-separated list, and the query is contained in it, return
          // true.
          LUe(i).includes(o)
        );
    }
  return !1;
}
function $Ue(t, e) {
  if (t != null)
    if (typeof t == "boolean") {
      if (t)
        return e.attribute;
    } else if (Array.isArray(t)) {
      if (t.length > 0)
        return (e.commaSeparated ? $6 : MUe)(t);
    } else
      return String(t);
}
const BUe = [];
function UUe(t, e) {
  return /** @type {Readonly<Array<string>>} */ (e.properties.className || BUe).includes(t.name);
}
function zUe(t, e) {
  return e.properties.id === t.name;
}
function HUe(t, e) {
  return t.name === e.tagName;
}
function WUe(t, e) {
  return function(n, r) {
    let a = fJ(n, "tag");
    const i = fJ(
      r ?? "*",
      "range"
    ), o = [];
    let s = -1;
    for (; ++s < i.length; ) {
      const u = i[s].toLowerCase();
      if (!e && u === "*")
        continue;
      let f = -1;
      const p = [];
      for (; ++f < a.length; )
        if (t(a[f].toLowerCase(), u)) {
          if (!e)
            return (
              /** @type {IsFilter extends true ? Tags : Tag|undefined} */
              a[f]
            );
          o.push(a[f]);
        } else
          p.push(a[f]);
      a = p;
    }
    return (
      /** @type {IsFilter extends true ? Tags : Tag|undefined} */
      e ? o : void 0
    );
  };
}
const QUe = WUe(function(t, e) {
  const n = t.split("-"), r = e.split("-");
  let a = 0, i = 0;
  if (r[i] !== "*" && n[a] !== r[i])
    return !1;
  for (a++, i++; i < r.length; ) {
    if (r[i] === "*") {
      i++;
      continue;
    }
    if (!n[a])
      return !1;
    if (n[a] === r[i]) {
      a++, i++;
      continue;
    }
    if (n[a].length === 1)
      return !1;
    a++;
  }
  return !0;
}, !0);
function fJ(t, e) {
  const n = t && typeof t == "string" ? [t] : t;
  if (!n || typeof n != "object" || !("length" in n))
    throw new Error(
      "Invalid " + e + " `" + n + "`, expected non-empty string"
    );
  return n;
}
const jUe = {}.hasOwnProperty;
function v0(t, e) {
  const n = t.type === "element" && jUe.call(t.properties, e) && t.properties[e];
  return n != null && n !== !1;
}
const GUe = /[ \t\n\f\r]/g;
function lue(t) {
  return typeof t == "object" ? t.type === "text" ? dJ(t.value) : !1 : dJ(t);
}
function dJ(t) {
  return t.replace(GUe, "") === "";
}
const VUe = /* @__PURE__ */ new Set([9, 10, 12, 13, 32]), pJ = "0".charCodeAt(0), YUe = "9".charCodeAt(0);
function ZUe(t) {
  if (t = t.trim().toLowerCase(), t === "even")
    return [2, 0];
  if (t === "odd")
    return [2, 1];
  let e = 0, n = 0, r = i(), a = o();
  if (e < t.length && t.charAt(e) === "n" && (e++, n = r * (a ?? 1), s(), e < t.length ? (r = i(), s(), a = o()) : r = a = 0), a === null || e < t.length)
    throw new Error(`n-th rule couldn't be parsed ('${t}')`);
  return [n, r * a];
  function i() {
    return t.charAt(e) === "-" ? (e++, -1) : (t.charAt(e) === "+" && e++, 1);
  }
  function o() {
    const u = e;
    let f = 0;
    for (; e < t.length && t.charCodeAt(e) >= pJ && t.charCodeAt(e) <= YUe; )
      f = f * 10 + (t.charCodeAt(e) - pJ), e++;
    return e === u ? null : f;
  }
  function s() {
    for (; e < t.length && VUe.has(t.charCodeAt(e)); )
      e++;
  }
}
var XUe = {
  trueFunc: function() {
    return !0;
  },
  falseFunc: function() {
    return !1;
  }
};
const hJ = /* @__PURE__ */ Pl(XUe);
function qUe(t) {
  const e = t[0], n = t[1] - 1;
  if (n < 0 && e <= 0)
    return hJ.falseFunc;
  if (e === -1)
    return (i) => i <= n;
  if (e === 0)
    return (i) => i === n;
  if (e === 1)
    return n < 0 ? hJ.trueFunc : (i) => i >= n;
  const r = Math.abs(e), a = (n % r + r) % r;
  return e > 1 ? (i) => i >= n && i % r === a : (i) => i <= n && i % r === a;
}
function mJ(t) {
  return qUe(ZUe(t));
}
const gJ = {}.hasOwnProperty;
function w7(t, e) {
  const n = e || {};
  function r(a, ...i) {
    let o = r.invalid;
    const s = r.handlers;
    if (a && gJ.call(a, t)) {
      const u = String(a[t]);
      o = gJ.call(s, u) ? s[u] : r.unknown;
    }
    if (o)
      return o.call(this, a, ...i);
  }
  return r.handlers = n.handlers || {}, r.invalid = n.invalid, r.unknown = n.unknown, r;
}
const KUe = mJ.default || mJ, JUe = w7("name", {
  handlers: {
    "any-link": e6e,
    blank: t6e,
    checked: n6e,
    dir: r6e,
    disabled: uue,
    empty: a6e,
    enabled: i6e,
    "first-child": o6e,
    "first-of-type": s6e,
    has: l6e,
    is: cue,
    lang: c6e,
    "last-child": f6e,
    "last-of-type": d6e,
    not: p6e,
    "nth-child": h6e,
    "nth-last-child": m6e,
    "nth-last-of-type": g6e,
    "nth-of-type": b6e,
    "only-child": v6e,
    "only-of-type": y6e,
    optional: O6e,
    "read-only": E6e,
    "read-write": fue,
    required: due,
    root: S6e,
    scope: w6e
  },
  invalid: u6e,
  unknown: T6e
});
function e6e(t, e) {
  return (e.tagName === "a" || e.tagName === "area" || e.tagName === "link") && v0(e, "href");
}
function Lh(t, e) {
  if (t.shallow)
    throw new Error("Cannot use `:" + e.name + "` without parent");
}
function t6e(t, e) {
  return !pue(e, n);
  function n(r) {
    return r.type === "element" || r.type === "text" && !lue(r);
  }
}
function n6e(t, e) {
  return e.tagName === "input" || e.tagName === "menuitem" ? !!((e.properties.type === "checkbox" || e.properties.type === "radio") && v0(e, "checked")) : e.tagName === "option" ? v0(e, "selected") : !1;
}
function r6e(t, e, n, r, a) {
  return t.argument, t.argument.type, a.direction === t.argument.value;
}
function uue(t, e) {
  return (e.tagName === "button" || e.tagName === "input" || e.tagName === "select" || e.tagName === "textarea" || e.tagName === "optgroup" || e.tagName === "option" || e.tagName === "menuitem" || e.tagName === "fieldset") && v0(e, "disabled");
}
function a6e(t, e) {
  return !pue(e, n);
  function n(r) {
    return r.type === "element" || r.type === "text";
  }
}
function i6e(t, e) {
  return !uue(t, e);
}
function o6e(t, e, n, r, a) {
  return Lh(a, t), a.elementIndex === 0;
}
function s6e(t, e, n, r, a) {
  return Lh(a, t), a.typeIndex === 0;
}
function tN(t) {
  let e = t._cachedFn;
  if (!e) {
    const n = t.argument;
    if (n.type !== "Formula")
      throw new Error(
        "Expected `nth` formula, such as `even` or `2n+1` (`of` is not yet supported)"
      );
    e = KUe(n.a + "n+" + n.b), t._cachedFn = e;
  }
  return e;
}
function l6e(t, e, n, r, a) {
  t.argument, t.argument.type;
  const i = {
    ...a,
    // Not found yet.
    found: !1,
    // One result is enough.
    one: !0,
    results: [],
    rootQuery: t.argument,
    scopeElements: [e],
    // Do walk deep.
    shallow: !1
  };
  return T7(i, { type: "root", children: e.children }), i.results.length > 0;
}
function u6e() {
}
function cue(t, e, n, r, a) {
  t.argument, t.argument.type;
  const i = {
    ...a,
    // Not found yet.
    found: !1,
    // One result is enough.
    one: !0,
    results: [],
    rootQuery: t.argument,
    scopeElements: [e],
    // Do walk deep.
    shallow: !1
  };
  return T7(i, e), i.results[0] === e;
}
function c6e(t, e, n, r, a) {
  return t.argument, t.argument.type, a.language !== "" && a.language !== void 0 && QUe(a.language, a_(t.argument.value)).length > 0;
}
function f6e(t, e, n, r, a) {
  return Lh(a, t), !!(a.elementCount && a.elementIndex === a.elementCount - 1);
}
function d6e(t, e, n, r, a) {
  return Lh(a, t), typeof a.typeIndex == "number" && typeof a.typeCount == "number" && a.typeIndex === a.typeCount - 1;
}
function p6e(t, e, n, r, a) {
  return !cue(t, e, n, r, a);
}
function h6e(t, e, n, r, a) {
  const i = tN(t);
  return Lh(a, t), typeof a.elementIndex == "number" && i(a.elementIndex);
}
function m6e(t, e, n, r, a) {
  const i = tN(t);
  return Lh(a, t), !!(typeof a.elementCount == "number" && typeof a.elementIndex == "number" && i(a.elementCount - a.elementIndex - 1));
}
function g6e(t, e, n, r, a) {
  const i = tN(t);
  return Lh(a, t), typeof a.typeCount == "number" && typeof a.typeIndex == "number" && i(a.typeCount - 1 - a.typeIndex);
}
function b6e(t, e, n, r, a) {
  const i = tN(t);
  return Lh(a, t), typeof a.typeIndex == "number" && i(a.typeIndex);
}
function v6e(t, e, n, r, a) {
  return Lh(a, t), a.elementCount === 1;
}
function y6e(t, e, n, r, a) {
  return Lh(a, t), a.typeCount === 1;
}
function O6e(t, e) {
  return !due(t, e);
}
function E6e(t, e, n, r, a) {
  return !fue(t, e, n, r, a);
}
function fue(t, e, n, r, a) {
  return e.tagName === "input" || e.tagName === "textarea" ? !v0(e, "readOnly") && !v0(e, "disabled") : !!a.editableOrEditingHost;
}
function due(t, e) {
  return (e.tagName === "input" || e.tagName === "textarea" || e.tagName === "select") && v0(e, "required");
}
function S6e(t, e, n, r, a) {
  return !!((!r || r.type === "root") && a.schema && (a.schema.space === "html" || a.schema.space === "svg") && (e.tagName === "html" || e.tagName === "svg"));
}
function w6e(t, e, n, r, a) {
  return a.scopeElements.includes(e);
}
function pue(t, e) {
  const n = t.children;
  let r = -1;
  for (; ++r < n.length; )
    if (e(n[r]))
      return !0;
  return !1;
}
function T6e(t) {
  const e = (
    /** @type {AstPseudoClass} */
    t
  );
  throw new Error("Unknown pseudo-selector `" + e.name + "`");
}
function _6e(t, e, n, r, a) {
  for (const i of t.items)
    if (i.type === "Attribute") {
      if (!FUe(i, e, a.schema))
        return !1;
    } else if (i.type === "Id") {
      if (!zUe(i, e))
        return !1;
    } else if (i.type === "ClassName") {
      if (!UUe(i, e))
        return !1;
    } else if (i.type === "PseudoClass") {
      if (!JUe(i, e, n, r, a))
        return !1;
    } else {
      if (i.type === "PseudoElement")
        throw new Error("Invalid selector: `::" + i.name + "`");
      if (i.type === "TagName" && !HUe(i, e))
        return !1;
    }
  return !0;
}
const C6e = [];
function T7(t, e) {
  e && hue(t, [], e, void 0, void 0, e);
}
function j3(t, e, n) {
  const r = t[e];
  r ? r.push(n) : t[e] = [n];
}
function x6e(t, e, n, r) {
  const a = Lk(e.descendant, e.directChild);
  let i, o = -1;
  const s = { count: 0, types: /* @__PURE__ */ new Map() }, u = { count: 0, types: /* @__PURE__ */ new Map() };
  for (; ++o < n.children.length; )
    bJ(s, n.children[o]);
  for (o = -1; ++o < n.children.length; ) {
    const f = n.children[o], p = f.type === "element" ? f.tagName.toUpperCase() : void 0;
    if (t.elementIndex = u.count, t.typeIndex = p && u.types.get(p) || 0, t.elementCount = s.count, t.typeCount = p ? s.types.get(p) : 0, "children" in f) {
      const m = Lk(a, i), v = hue(
        t,
        m,
        n.children[o],
        o,
        n,
        r
      );
      i = Lk(v.generalSibling, v.adjacentSibling);
    }
    if (t.one && t.found)
      break;
    bJ(u, n.children[o]);
  }
}
function A6e(t, e, n, r, a) {
  const i = {
    adjacentSibling: void 0,
    descendant: void 0,
    directChild: void 0,
    generalSibling: void 0
  };
  let o = -1;
  for (; ++o < e.length; ) {
    const s = e[o];
    if (t.one && t.found)
      break;
    if (t.shallow && s.nestedRule)
      throw new Error("Expected selector without nesting");
    if (_6e(s, n, r, a, t)) {
      const u = s.nestedRule;
      if (u) {
        const f = u.combinator === "+" ? "adjacentSibling" : u.combinator === "~" ? "generalSibling" : u.combinator === ">" ? "directChild" : "descendant";
        j3(i, f, u);
      } else
        t.found = !0, t.results.includes(n) || t.results.push(n);
    }
    s.combinator === void 0 ? j3(i, "descendant", s) : s.combinator === "~" && j3(i, "generalSibling", s);
  }
  return i;
}
function Lk(t, e) {
  return t && e && t.length > 0 && e.length > 0 ? [...t, ...e] : t && t.length > 0 ? t : e && e.length > 0 ? e : C6e;
}
function bJ(t, e) {
  if (e.type === "element") {
    const n = e.tagName.toUpperCase(), r = (t.types.get(n) || 0) + 1;
    t.count++, t.types.set(n, r);
  }
}
function hue(t, e, n, r, a, i) {
  let o = {
    adjacentSibling: void 0,
    descendant: void 0,
    directChild: void 0,
    generalSibling: void 0
  };
  const s = PUe(t, n);
  if (n.type === "element") {
    let u = t.rootQuery.rules;
    a && a !== i && (u = t.rootQuery.rules.filter(
      (f) => f.combinator === void 0 || f.combinator === ">" && a === i
    )), o = A6e(
      t,
      // Try the root rules for this element too.
      Lk(e, u),
      n,
      r,
      a
    );
  }
  return "children" in n && !t.shallow && !(t.one && t.found) && x6e(t, o, n, i), s(), o;
}
function k6e(t, e, n) {
  const r = R6e(t, e, n);
  return T7(r, e || void 0), r.results;
}
function R6e(t, e, n) {
  return {
    direction: "ltr",
    editableOrEditingHost: !1,
    elementCount: void 0,
    elementIndex: void 0,
    found: !1,
    language: void 0,
    one: !1,
    // State of the query.
    results: [],
    rootQuery: EUe(t),
    schema: n === "svg" ? og : N0,
    scopeElements: e ? e.type === "root" ? e.children : [e] : [],
    shallow: !1,
    typeIndex: void 0,
    typeCount: void 0
  };
}
const mue = (t = [], e = "") => (t.forEach((n) => {
  n.type === "text" ? e += n.value : n.type === "element" && n.children && Array.isArray(n.children) && (e += mue(n.children));
}), e), I6e = (t) => {
  const { selector: e, rewrite: n } = t || {};
  return (r) => {
    if (!(!n || typeof n != "function")) {
      if (e && typeof e == "string") {
        const a = k6e(e, r);
        a && a.length > 0 && nJ(r, a, (i, o, s) => {
          n(i, o, s);
        });
        return;
      }
      nJ(r, (a, i, o) => {
        n(a, i, o);
      });
    }
  };
}, D6e = I6e, gue = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(t) {
    if (t == null)
      return M6e;
    if (typeof t == "function")
      return nN(t);
    if (typeof t == "object")
      return Array.isArray(t) ? N6e(t) : P6e(t);
    if (typeof t == "string")
      return L6e(t);
    throw new Error("Expected function, string, or object as test");
  }
);
function N6e(t) {
  const e = [];
  let n = -1;
  for (; ++n < t.length; )
    e[n] = gue(t[n]);
  return nN(r);
  function r(...a) {
    let i = -1;
    for (; ++i < e.length; )
      if (e[i].apply(this, a))
        return !0;
    return !1;
  }
}
function P6e(t) {
  const e = (
    /** @type {Record<string, unknown>} */
    t
  );
  return nN(n);
  function n(r) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let i;
    for (i in t)
      if (a[i] !== e[i])
        return !1;
    return !0;
  }
}
function L6e(t) {
  return nN(e);
  function e(n) {
    return n && n.type === t;
  }
}
function nN(t) {
  return e;
  function e(n, r, a) {
    return !!(F6e(n) && t.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      a || void 0
    ));
  }
}
function M6e() {
  return !0;
}
function F6e(t) {
  return t !== null && typeof t == "object" && "type" in t;
}
const bue = [], $6e = !0, vJ = !1, B6e = "skip";
function U6e(t, e, n, r) {
  let a;
  typeof e == "function" && typeof n != "function" ? (r = n, n = e) : a = e;
  const i = gue(a), o = r ? -1 : 1;
  s(t, void 0, [])();
  function s(u, f, p) {
    const m = (
      /** @type {Record<string, unknown>} */
      u && typeof u == "object" ? u : {}
    );
    if (typeof m.type == "string") {
      const O = (
        // `hast`
        typeof m.tagName == "string" ? m.tagName : (
          // `xast`
          typeof m.name == "string" ? m.name : void 0
        )
      );
      Object.defineProperty(v, "name", {
        value: "node (" + (u.type + (O ? "<" + O + ">" : "")) + ")"
      });
    }
    return v;
    function v() {
      let O = bue, w, _, C;
      if ((!e || i(u, f, p[p.length - 1] || void 0)) && (O = z6e(n(u, p)), O[0] === vJ))
        return O;
      if ("children" in u && u.children) {
        const A = (
          /** @type {UnistParent} */
          u
        );
        if (A.children && O[0] !== B6e)
          for (_ = (r ? A.children.length : -1) + o, C = p.concat(A); _ > -1 && _ < A.children.length; ) {
            const N = A.children[_];
            if (w = s(N, _, C)(), w[0] === vJ)
              return w;
            _ = typeof w[1] == "number" ? w[1] : _ + o;
          }
      }
      return O;
    }
  }
}
function z6e(t) {
  return Array.isArray(t) ? t : typeof t == "number" ? [$6e, t] : t == null ? bue : [t];
}
function H6e(t, e, n, r) {
  let a, i, o;
  typeof e == "function" && typeof n != "function" ? (i = void 0, o = e, a = n) : (i = e, o = n, a = r), U6e(t, i, s, a);
  function s(u, f) {
    const p = f[f.length - 1], m = p ? p.children.indexOf(u) : void 0;
    return o(u, m, p);
  }
}
const W6e = (t = "") => (t.match(/([^?=&]+)(=([^&]*))/g) || []).reduce((e, n) => (e[n.slice(0, n.indexOf("="))] = n.slice(n.indexOf("=") + 1), e), {}), Q6e = (t = [], e) => {
  let n = e;
  for (; n > -1; ) {
    if (n--, !t[n])
      return;
    if (t[n] && t[n].value && t[n].value.replace(/(\n|\s)/g, "") !== "" || t[n].type !== "text")
      return !/^rehype:/.test(t[n].value) || t[n].type !== "comment" ? void 0 : t[n];
  }
}, vue = (t = [], e, n, r) => {
  let a = e;
  for (; a < t.length; )
    if (a++, n) {
      const i = t[a];
      if (i && i.value && i.value.replace(/(\n|\s)/g, "") !== "" || t[a] && t[a].type === "element")
        return i.tagName === n ? i : void 0;
    } else {
      const i = t[a];
      if (!i || i.type === "element" || i.type === "text" && i.value.replace(/(\n|\s)/g, "") !== "")
        return;
      if (i.type && /^(comment|raw)$/ig.test(i.type))
        return i.value && !/^rehype:/.test(i.value.replace(/^(\s+)?<!--(.*?)-->/, "$2") || "") ? void 0 : r ? vue(t, a, "pre", r) ? void 0 : (i.value = (i.value || "").replace(/^(\n|\s)+/, ""), i) : (i.value = (i.value || "").replace(/^(\n|\s)+/, ""), i);
    }
}, yJ = ({ value: t = "" }) => {
  const e = W6e(t.replace(/^<!--(.*?)-->/, "$1").replace(/^rehype:/, ""));
  return Object.keys(e).forEach((n) => {
    e[n] === "true" && (e[n] = !0), e[n] === "false" && (e[n] = !1), typeof e[n] == "string" && !/^0/.test(e[n]) && !isNaN(+e[n]) && (e[n] = +e[n]);
  }), e;
}, OJ = (t, e, n) => n === "string" ? { ...t, "data-config": JSON.stringify({ ...e, rehyp: !0 }) } : n === "attr" ? { ...t, ...e } : { ...t, "data-config": { ...e, rehyp: !0 } }, j6e = (t = {}) => {
  const { properties: e = "data", codeBlockParames: n = !0 } = t;
  return (r) => {
    H6e(r, "element", (a, i, o) => {
      if (n && a.tagName === "pre" && a && Array.isArray(a.children) && o && Array.isArray(o.children) && o.children.length > 1) {
        const s = a.children[0];
        if (s && s.tagName === "code" && typeof i == "number") {
          const u = Q6e(o.children, i);
          if (u) {
            const f = yJ(u);
            Object.keys(f).length > 0 && (a.properties = { ...a.properties, "data-type": "rehyp" }, s.properties = OJ(s.properties, f, e));
          }
        }
      }
      if (/^(em|strong|b|a|i|p|pre|kbd|blockquote|h(1|2|3|4|5|6)|code|table|img|del|ul|ol)$/.test(a.tagName) && o && Array.isArray(o.children) && typeof i == "number") {
        const s = vue(o.children, i, "", n);
        if (s) {
          const u = yJ(s);
          Object.keys(u).length > 0 && (a.properties = OJ(a.properties, u, e));
        }
      }
    });
  };
}, G6e = j6e, yue = -1, rN = 0, DI = 1, NI = 2, _7 = 3, C7 = 4, x7 = 5, A7 = 6, Oue = 7, Eue = 8, EJ = typeof self == "object" ? self : globalThis, V6e = (t, e) => {
  const n = (a, i) => (t.set(i, a), a), r = (a) => {
    if (t.has(a))
      return t.get(a);
    const [i, o] = e[a];
    switch (i) {
      case rN:
      case yue:
        return n(o, a);
      case DI: {
        const s = n([], a);
        for (const u of o)
          s.push(r(u));
        return s;
      }
      case NI: {
        const s = n({}, a);
        for (const [u, f] of o)
          s[r(u)] = r(f);
        return s;
      }
      case _7:
        return n(new Date(o), a);
      case C7: {
        const { source: s, flags: u } = o;
        return n(new RegExp(s, u), a);
      }
      case x7: {
        const s = n(/* @__PURE__ */ new Map(), a);
        for (const [u, f] of o)
          s.set(r(u), r(f));
        return s;
      }
      case A7: {
        const s = n(/* @__PURE__ */ new Set(), a);
        for (const u of o)
          s.add(r(u));
        return s;
      }
      case Oue: {
        const { name: s, message: u } = o;
        return n(new EJ[s](u), a);
      }
      case Eue:
        return n(BigInt(o), a);
      case "BigInt":
        return n(Object(BigInt(o)), a);
    }
    return n(new EJ[i](o), a);
  };
  return r;
}, SJ = (t) => V6e(/* @__PURE__ */ new Map(), t)(0), rE = "", { toString: Y6e } = {}, { keys: Z6e } = Object, kw = (t) => {
  const e = typeof t;
  if (e !== "object" || !t)
    return [rN, e];
  const n = Y6e.call(t).slice(8, -1);
  switch (n) {
    case "Array":
      return [DI, rE];
    case "Object":
      return [NI, rE];
    case "Date":
      return [_7, rE];
    case "RegExp":
      return [C7, rE];
    case "Map":
      return [x7, rE];
    case "Set":
      return [A7, rE];
  }
  return n.includes("Array") ? [DI, n] : n.includes("Error") ? [Oue, n] : [NI, n];
}, dA = ([t, e]) => t === rN && (e === "function" || e === "symbol"), X6e = (t, e, n, r) => {
  const a = (o, s) => {
    const u = r.push(o) - 1;
    return n.set(s, u), u;
  }, i = (o) => {
    if (n.has(o))
      return n.get(o);
    let [s, u] = kw(o);
    switch (s) {
      case rN: {
        let p = o;
        switch (u) {
          case "bigint":
            s = Eue, p = o.toString();
            break;
          case "function":
          case "symbol":
            if (t)
              throw new TypeError("unable to serialize " + u);
            p = null;
            break;
          case "undefined":
            return a([yue], o);
        }
        return a([s, p], o);
      }
      case DI: {
        if (u)
          return a([u, [...o]], o);
        const p = [], m = a([s, p], o);
        for (const v of o)
          p.push(i(v));
        return m;
      }
      case NI: {
        if (u)
          switch (u) {
            case "BigInt":
              return a([u, o.toString()], o);
            case "Boolean":
            case "Number":
            case "String":
              return a([u, o.valueOf()], o);
          }
        if (e && "toJSON" in o)
          return i(o.toJSON());
        const p = [], m = a([s, p], o);
        for (const v of Z6e(o))
          (t || !dA(kw(o[v]))) && p.push([i(v), i(o[v])]);
        return m;
      }
      case _7:
        return a([s, o.toISOString()], o);
      case C7: {
        const { source: p, flags: m } = o;
        return a([s, { source: p, flags: m }], o);
      }
      case x7: {
        const p = [], m = a([s, p], o);
        for (const [v, O] of o)
          (t || !(dA(kw(v)) || dA(kw(O)))) && p.push([i(v), i(O)]);
        return m;
      }
      case A7: {
        const p = [], m = a([s, p], o);
        for (const v of o)
          (t || !dA(kw(v))) && p.push(i(v));
        return m;
      }
    }
    const { message: f } = o;
    return a([s, { name: u, message: f }], o);
  };
  return i;
}, wJ = (t, { json: e, lossy: n } = {}) => {
  const r = [];
  return X6e(!(e || n), !!e, /* @__PURE__ */ new Map(), r)(t), r;
}, y0 = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (t, e) => e && ("json" in e || "lossy" in e) ? SJ(wJ(t, e)) : structuredClone(t)
) : (t, e) => SJ(wJ(t, e)), TJ = /[#.]/g;
function q6e(t, e) {
  const n = t || "", r = {};
  let a = 0, i, o;
  for (; a < n.length; ) {
    TJ.lastIndex = a;
    const s = TJ.exec(n), u = n.slice(a, s ? s.index : n.length);
    u && (i ? i === "#" ? r.id = u : Array.isArray(r.className) ? r.className.push(u) : r.className = [u] : o = u, a += u.length), s && (i = s[0], a++);
  }
  return {
    type: "element",
    // @ts-expect-error: tag name is parsed.
    tagName: o || e || "div",
    properties: r,
    children: []
  };
}
function _J(t) {
  const e = String(t || "").trim();
  return e ? e.split(/[ \t\n\r\f]+/g) : [];
}
const K6e = /* @__PURE__ */ new Set(["button", "menu", "reset", "submit"]), p5 = {}.hasOwnProperty;
function Sue(t, e, n) {
  const r = n && n9e(n);
  function a(i, o, ...s) {
    let u = -1, f;
    if (i == null) {
      f = { type: "root", children: [] };
      const p = (
        /** @type {Child} */
        o
      );
      s.unshift(p);
    } else if (f = q6e(i, e), f.tagName = f.tagName.toLowerCase(), r && p5.call(r, f.tagName) && (f.tagName = r[f.tagName]), J6e(o, f.tagName)) {
      let p;
      for (p in o)
        p5.call(o, p) && e9e(t, f.properties, p, o[p]);
    } else
      s.unshift(o);
    for (; ++u < s.length; )
      h5(f.children, s[u]);
    return f.type === "element" && f.tagName === "template" && (f.content = { type: "root", children: f.children }, f.children = []), f;
  }
  return a;
}
function J6e(t, e) {
  return t == null || typeof t != "object" || Array.isArray(t) ? !1 : e === "input" || !t.type || typeof t.type != "string" ? !0 : "children" in t && Array.isArray(t.children) ? !1 : e === "button" ? K6e.has(t.type.toLowerCase()) : !("value" in t);
}
function e9e(t, e, n, r) {
  const a = E1(t, n);
  let i = -1, o;
  if (r != null) {
    if (typeof r == "number") {
      if (Number.isNaN(r))
        return;
      o = r;
    } else
      typeof r == "boolean" ? o = r : typeof r == "string" ? a.spaceSeparated ? o = _J(r) : a.commaSeparated ? o = a_(r) : a.commaOrSpaceSeparated ? o = _J(a_(r).join(" ")) : o = CJ(a, a.property, r) : Array.isArray(r) ? o = r.concat() : o = a.property === "style" ? t9e(r) : String(r);
    if (Array.isArray(o)) {
      const s = [];
      for (; ++i < o.length; ) {
        const u = (
          /** @type {number | string} */
          CJ(a, a.property, o[i])
        );
        s[i] = u;
      }
      o = s;
    }
    if (a.property === "className" && Array.isArray(e.className)) {
      const s = (
        /** @type {number | string} */
        o
      );
      o = e.className.concat(s);
    }
    e[a.property] = o;
  }
}
function h5(t, e) {
  let n = -1;
  if (e != null)
    if (typeof e == "string" || typeof e == "number")
      t.push({ type: "text", value: String(e) });
    else if (Array.isArray(e))
      for (; ++n < e.length; )
        h5(t, e[n]);
    else if (typeof e == "object" && "type" in e)
      e.type === "root" ? h5(t, e.children) : t.push(e);
    else
      throw new Error("Expected node, nodes, or string, got `" + e + "`");
}
function CJ(t, e, n) {
  if (typeof n == "string") {
    if (t.number && n && !Number.isNaN(Number(n)))
      return Number(n);
    if ((t.boolean || t.overloadedBoolean) && (n === "" || b0(n) === b0(e)))
      return !0;
  }
  return n;
}
function t9e(t) {
  const e = [];
  let n;
  for (n in t)
    p5.call(t, n) && e.push([n, t[n]].join(": "));
  return e.join("; ");
}
function n9e(t) {
  const e = {};
  let n = -1;
  for (; ++n < t.length; )
    e[t[n].toLowerCase()] = t[n];
  return e;
}
const r9e = [
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "solidColor",
  "textArea",
  "textPath"
], a9e = Sue(N0, "div"), i9e = Sue(og, "g", r9e), G3 = /\r?\n|\r/g;
function o9e(t) {
  const e = String(t), n = [];
  for (G3.lastIndex = 0; G3.test(e); )
    n.push(G3.lastIndex);
  return n.push(e.length + 1), { toPoint: r, toOffset: a };
  function r(i) {
    let o = -1;
    if (typeof i == "number" && i > -1 && i < n[n.length - 1]) {
      for (; ++o < n.length; )
        if (n[o] > i)
          return {
            line: o + 1,
            column: i - (o > 0 ? n[o - 1] : 0) + 1,
            offset: i
          };
    }
  }
  function a(i) {
    const o = i && i.line, s = i && i.column;
    if (typeof o == "number" && typeof s == "number" && !Number.isNaN(o) && !Number.isNaN(s) && o - 1 in n) {
      const u = (n[o - 2] || 0) + s - 1 || 0;
      if (u > -1 && u < n[n.length - 1])
        return u;
    }
  }
}
const e0 = {
  html: "http://www.w3.org/1999/xhtml",
  mathml: "http://www.w3.org/1998/Math/MathML",
  svg: "http://www.w3.org/2000/svg",
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
}, wue = {}.hasOwnProperty, s9e = Object.prototype;
function l9e(t, e) {
  const n = e || {};
  return k7(
    {
      file: n.file || void 0,
      location: !1,
      schema: n.space === "svg" ? og : N0,
      verbose: n.verbose || !1
    },
    t
  );
}
function k7(t, e) {
  let n;
  switch (e.nodeName) {
    case "#comment": {
      const r = (
        /** @type {P5Comment} */
        e
      );
      return n = { type: "comment", value: r.data }, Mk(t, r, n), n;
    }
    case "#document":
    case "#document-fragment": {
      const r = (
        /** @type {P5Document | P5DocumentFragment} */
        e
      ), a = "mode" in r ? r.mode === "quirks" || r.mode === "limited-quirks" : !1;
      if (n = {
        type: "root",
        children: Tue(t, e.childNodes),
        data: { quirksMode: a }
      }, t.file && t.location) {
        const i = String(t.file), o = o9e(i), s = o.toPoint(0), u = o.toPoint(i.length);
        n.position = { start: s, end: u };
      }
      return n;
    }
    case "#documentType": {
      const r = (
        /** @type {P5DocumentType} */
        e
      );
      return n = { type: "doctype" }, Mk(t, r, n), n;
    }
    case "#text": {
      const r = (
        /** @type {P5Text} */
        e
      );
      return n = { type: "text", value: r.value }, Mk(t, r, n), n;
    }
    default:
      return n = u9e(
        t,
        /** @type {P5Element} */
        e
      ), n;
  }
}
function Tue(t, e) {
  let n = -1;
  const r = [];
  for (; ++n < e.length; ) {
    const a = (
      /** @type {RootContent} */
      k7(t, e[n])
    );
    r.push(a);
  }
  return r;
}
function u9e(t, e) {
  const n = t.schema;
  t.schema = e.namespaceURI === e0.svg ? og : N0;
  let r = -1;
  const a = {};
  for (; ++r < e.attrs.length; ) {
    const s = e.attrs[r], u = (s.prefix ? s.prefix + ":" : "") + s.name;
    wue.call(s9e, u) || (a[u] = s.value);
  }
  const o = (t.schema.space === "svg" ? i9e : a9e)(e.tagName, a, Tue(t, e.childNodes));
  if (Mk(t, e, o), o.tagName === "template") {
    const s = (
      /** @type {P5Template} */
      e
    ), u = s.sourceCodeLocation, f = u && u.startTag && EE(u.startTag), p = u && u.endTag && EE(u.endTag), m = (
      /** @type {Root} */
      k7(t, s.content)
    );
    f && p && t.file && (m.position = { start: f.end, end: p.start }), o.content = m;
  }
  return t.schema = n, o;
}
function Mk(t, e, n) {
  if ("sourceCodeLocation" in e && e.sourceCodeLocation && t.file) {
    const r = c9e(t, n, e.sourceCodeLocation);
    r && (t.location = !0, n.position = r);
  }
}
function c9e(t, e, n) {
  const r = EE(n);
  if (e.type === "element") {
    const a = e.children[e.children.length - 1];
    if (r && !n.endTag && a && a.position && a.position.end && (r.end = Object.assign({}, a.position.end)), t.verbose) {
      const i = {};
      let o;
      if (n.attrs)
        for (o in n.attrs)
          wue.call(n.attrs, o) && (i[E1(t.schema, o).property] = EE(
            n.attrs[o]
          ));
      n.startTag;
      const s = EE(n.startTag), u = n.endTag ? EE(n.endTag) : void 0, f = { opening: s };
      u && (f.closing = u), f.properties = i, e.data = { position: f };
    }
  }
  return r;
}
function EE(t) {
  const e = xJ({
    line: t.startLine,
    column: t.startCol,
    offset: t.startOffset
  }), n = xJ({
    line: t.endLine,
    column: t.endCol,
    offset: t.endOffset
  });
  return e || n ? { start: e, end: n } : void 0;
}
function xJ(t) {
  return t.line && t.column ? t : void 0;
}
function f9e(t) {
  return t.join(" ").trim();
}
const d9e = {}, p9e = {}.hasOwnProperty, _ue = w7("type", { handlers: { root: m9e, element: O9e, text: v9e, comment: y9e, doctype: b9e } });
function h9e(t, e) {
  const r = (e || d9e).space;
  return _ue(t, r === "svg" ? og : N0);
}
function m9e(t, e) {
  const n = {
    nodeName: "#document",
    // @ts-expect-error: `parse5` uses enums, which are actually strings.
    mode: (t.data || {}).quirksMode ? "quirks" : "no-quirks",
    childNodes: []
  };
  return n.childNodes = R7(t.children, n, e), T1(t, n), n;
}
function g9e(t, e) {
  const n = { nodeName: "#document-fragment", childNodes: [] };
  return n.childNodes = R7(t.children, n, e), T1(t, n), n;
}
function b9e(t) {
  const e = {
    nodeName: "#documentType",
    name: "html",
    publicId: "",
    systemId: "",
    parentNode: null
  };
  return T1(t, e), e;
}
function v9e(t) {
  const e = {
    nodeName: "#text",
    value: t.value,
    parentNode: null
  };
  return T1(t, e), e;
}
function y9e(t) {
  const e = {
    nodeName: "#comment",
    data: t.value,
    parentNode: null
  };
  return T1(t, e), e;
}
function O9e(t, e) {
  const n = e;
  let r = n;
  t.type === "element" && t.tagName.toLowerCase() === "svg" && n.space === "html" && (r = og);
  const a = [];
  let i;
  if (t.properties) {
    for (i in t.properties)
      if (i !== "children" && p9e.call(t.properties, i)) {
        const u = E9e(
          r,
          i,
          t.properties[i]
        );
        u && a.push(u);
      }
  }
  const o = r.space, s = {
    nodeName: t.tagName,
    tagName: t.tagName,
    attrs: a,
    // @ts-expect-error: `parse5` types are wrong.
    namespaceURI: e0[o],
    childNodes: [],
    parentNode: null
  };
  return s.childNodes = R7(t.children, s, r), T1(t, s), t.tagName === "template" && t.content && (s.content = g9e(t.content, r)), s;
}
function E9e(t, e, n) {
  const r = E1(t, e);
  if (n === !1 || n === null || n === void 0 || typeof n == "number" && Number.isNaN(n) || !n && r.boolean)
    return;
  Array.isArray(n) && (n = r.commaSeparated ? $6(n) : f9e(n));
  const a = {
    name: r.attribute,
    value: n === !0 ? "" : String(n)
  };
  if (r.space && r.space !== "html" && r.space !== "svg") {
    const i = a.name.indexOf(":");
    i < 0 ? a.prefix = "" : (a.name = a.name.slice(i + 1), a.prefix = r.attribute.slice(0, i)), a.namespace = e0[r.space];
  }
  return a;
}
function R7(t, e, n) {
  let r = -1;
  const a = [];
  if (t)
    for (; ++r < t.length; ) {
      const i = _ue(t[r], n);
      i.parentNode = e, a.push(i);
    }
  return a;
}
function T1(t, e) {
  const n = t.position;
  n && n.start && n.end && (n.start.offset, n.end.offset, e.sourceCodeLocation = {
    startLine: n.start.line,
    startCol: n.start.column,
    startOffset: n.start.offset,
    endLine: n.end.line,
    endCol: n.end.column,
    endOffset: n.end.offset
  });
}
const S9e = [
  "area",
  "base",
  "basefont",
  "bgsound",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "image",
  "img",
  "input",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
], w9e = /* @__PURE__ */ new Set([
  65534,
  65535,
  131070,
  131071,
  196606,
  196607,
  262142,
  262143,
  327678,
  327679,
  393214,
  393215,
  458750,
  458751,
  524286,
  524287,
  589822,
  589823,
  655358,
  655359,
  720894,
  720895,
  786430,
  786431,
  851966,
  851967,
  917502,
  917503,
  983038,
  983039,
  1048574,
  1048575,
  1114110,
  1114111
]), Oi = "�";
var se;
(function(t) {
  t[t.EOF = -1] = "EOF", t[t.NULL = 0] = "NULL", t[t.TABULATION = 9] = "TABULATION", t[t.CARRIAGE_RETURN = 13] = "CARRIAGE_RETURN", t[t.LINE_FEED = 10] = "LINE_FEED", t[t.FORM_FEED = 12] = "FORM_FEED", t[t.SPACE = 32] = "SPACE", t[t.EXCLAMATION_MARK = 33] = "EXCLAMATION_MARK", t[t.QUOTATION_MARK = 34] = "QUOTATION_MARK", t[t.NUMBER_SIGN = 35] = "NUMBER_SIGN", t[t.AMPERSAND = 38] = "AMPERSAND", t[t.APOSTROPHE = 39] = "APOSTROPHE", t[t.HYPHEN_MINUS = 45] = "HYPHEN_MINUS", t[t.SOLIDUS = 47] = "SOLIDUS", t[t.DIGIT_0 = 48] = "DIGIT_0", t[t.DIGIT_9 = 57] = "DIGIT_9", t[t.SEMICOLON = 59] = "SEMICOLON", t[t.LESS_THAN_SIGN = 60] = "LESS_THAN_SIGN", t[t.EQUALS_SIGN = 61] = "EQUALS_SIGN", t[t.GREATER_THAN_SIGN = 62] = "GREATER_THAN_SIGN", t[t.QUESTION_MARK = 63] = "QUESTION_MARK", t[t.LATIN_CAPITAL_A = 65] = "LATIN_CAPITAL_A", t[t.LATIN_CAPITAL_F = 70] = "LATIN_CAPITAL_F", t[t.LATIN_CAPITAL_X = 88] = "LATIN_CAPITAL_X", t[t.LATIN_CAPITAL_Z = 90] = "LATIN_CAPITAL_Z", t[t.RIGHT_SQUARE_BRACKET = 93] = "RIGHT_SQUARE_BRACKET", t[t.GRAVE_ACCENT = 96] = "GRAVE_ACCENT", t[t.LATIN_SMALL_A = 97] = "LATIN_SMALL_A", t[t.LATIN_SMALL_F = 102] = "LATIN_SMALL_F", t[t.LATIN_SMALL_X = 120] = "LATIN_SMALL_X", t[t.LATIN_SMALL_Z = 122] = "LATIN_SMALL_Z", t[t.REPLACEMENT_CHARACTER = 65533] = "REPLACEMENT_CHARACTER";
})(se = se || (se = {}));
const Vu = {
  DASH_DASH: "--",
  CDATA_START: "[CDATA[",
  DOCTYPE: "doctype",
  SCRIPT: "script",
  PUBLIC: "public",
  SYSTEM: "system"
};
function Cue(t) {
  return t >= 55296 && t <= 57343;
}
function T9e(t) {
  return t >= 56320 && t <= 57343;
}
function _9e(t, e) {
  return (t - 55296) * 1024 + 9216 + e;
}
function xue(t) {
  return t !== 32 && t !== 10 && t !== 13 && t !== 9 && t !== 12 && t >= 1 && t <= 31 || t >= 127 && t <= 159;
}
function Aue(t) {
  return t >= 64976 && t <= 65007 || w9e.has(t);
}
var ot;
(function(t) {
  t.controlCharacterInInputStream = "control-character-in-input-stream", t.noncharacterInInputStream = "noncharacter-in-input-stream", t.surrogateInInputStream = "surrogate-in-input-stream", t.nonVoidHtmlElementStartTagWithTrailingSolidus = "non-void-html-element-start-tag-with-trailing-solidus", t.endTagWithAttributes = "end-tag-with-attributes", t.endTagWithTrailingSolidus = "end-tag-with-trailing-solidus", t.unexpectedSolidusInTag = "unexpected-solidus-in-tag", t.unexpectedNullCharacter = "unexpected-null-character", t.unexpectedQuestionMarkInsteadOfTagName = "unexpected-question-mark-instead-of-tag-name", t.invalidFirstCharacterOfTagName = "invalid-first-character-of-tag-name", t.unexpectedEqualsSignBeforeAttributeName = "unexpected-equals-sign-before-attribute-name", t.missingEndTagName = "missing-end-tag-name", t.unexpectedCharacterInAttributeName = "unexpected-character-in-attribute-name", t.unknownNamedCharacterReference = "unknown-named-character-reference", t.missingSemicolonAfterCharacterReference = "missing-semicolon-after-character-reference", t.unexpectedCharacterAfterDoctypeSystemIdentifier = "unexpected-character-after-doctype-system-identifier", t.unexpectedCharacterInUnquotedAttributeValue = "unexpected-character-in-unquoted-attribute-value", t.eofBeforeTagName = "eof-before-tag-name", t.eofInTag = "eof-in-tag", t.missingAttributeValue = "missing-attribute-value", t.missingWhitespaceBetweenAttributes = "missing-whitespace-between-attributes", t.missingWhitespaceAfterDoctypePublicKeyword = "missing-whitespace-after-doctype-public-keyword", t.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers = "missing-whitespace-between-doctype-public-and-system-identifiers", t.missingWhitespaceAfterDoctypeSystemKeyword = "missing-whitespace-after-doctype-system-keyword", t.missingQuoteBeforeDoctypePublicIdentifier = "missing-quote-before-doctype-public-identifier", t.missingQuoteBeforeDoctypeSystemIdentifier = "missing-quote-before-doctype-system-identifier", t.missingDoctypePublicIdentifier = "missing-doctype-public-identifier", t.missingDoctypeSystemIdentifier = "missing-doctype-system-identifier", t.abruptDoctypePublicIdentifier = "abrupt-doctype-public-identifier", t.abruptDoctypeSystemIdentifier = "abrupt-doctype-system-identifier", t.cdataInHtmlContent = "cdata-in-html-content", t.incorrectlyOpenedComment = "incorrectly-opened-comment", t.eofInScriptHtmlCommentLikeText = "eof-in-script-html-comment-like-text", t.eofInDoctype = "eof-in-doctype", t.nestedComment = "nested-comment", t.abruptClosingOfEmptyComment = "abrupt-closing-of-empty-comment", t.eofInComment = "eof-in-comment", t.incorrectlyClosedComment = "incorrectly-closed-comment", t.eofInCdata = "eof-in-cdata", t.absenceOfDigitsInNumericCharacterReference = "absence-of-digits-in-numeric-character-reference", t.nullCharacterReference = "null-character-reference", t.surrogateCharacterReference = "surrogate-character-reference", t.characterReferenceOutsideUnicodeRange = "character-reference-outside-unicode-range", t.controlCharacterReference = "control-character-reference", t.noncharacterCharacterReference = "noncharacter-character-reference", t.missingWhitespaceBeforeDoctypeName = "missing-whitespace-before-doctype-name", t.missingDoctypeName = "missing-doctype-name", t.invalidCharacterSequenceAfterDoctypeName = "invalid-character-sequence-after-doctype-name", t.duplicateAttribute = "duplicate-attribute", t.nonConformingDoctype = "non-conforming-doctype", t.missingDoctype = "missing-doctype", t.misplacedDoctype = "misplaced-doctype", t.endTagWithoutMatchingOpenElement = "end-tag-without-matching-open-element", t.closingOfElementWithOpenChildElements = "closing-of-element-with-open-child-elements", t.disallowedContentInNoscriptInHead = "disallowed-content-in-noscript-in-head", t.openElementsLeftAfterEof = "open-elements-left-after-eof", t.abandonedHeadElementChild = "abandoned-head-element-child", t.misplacedStartTagForHeadElement = "misplaced-start-tag-for-head-element", t.nestedNoscriptInHead = "nested-noscript-in-head", t.eofInElementThatCanContainOnlyText = "eof-in-element-that-can-contain-only-text";
})(ot = ot || (ot = {}));
const C9e = 65536;
class x9e {
  constructor(e) {
    this.handler = e, this.html = "", this.pos = -1, this.lastGapPos = -2, this.gapStack = [], this.skipNextNewLine = !1, this.lastChunkWritten = !1, this.endOfChunkHit = !1, this.bufferWaterline = C9e, this.isEol = !1, this.lineStartPos = 0, this.droppedBufferSize = 0, this.line = 1, this.lastErrOffset = -1;
  }
  /** The column on the current line. If we just saw a gap (eg. a surrogate pair), return the index before. */
  get col() {
    return this.pos - this.lineStartPos + +(this.lastGapPos !== this.pos);
  }
  get offset() {
    return this.droppedBufferSize + this.pos;
  }
  getError(e) {
    const { line: n, col: r, offset: a } = this;
    return {
      code: e,
      startLine: n,
      endLine: n,
      startCol: r,
      endCol: r,
      startOffset: a,
      endOffset: a
    };
  }
  _err(e) {
    this.handler.onParseError && this.lastErrOffset !== this.offset && (this.lastErrOffset = this.offset, this.handler.onParseError(this.getError(e)));
  }
  _addGap() {
    this.gapStack.push(this.lastGapPos), this.lastGapPos = this.pos;
  }
  _processSurrogate(e) {
    if (this.pos !== this.html.length - 1) {
      const n = this.html.charCodeAt(this.pos + 1);
      if (T9e(n))
        return this.pos++, this._addGap(), _9e(e, n);
    } else if (!this.lastChunkWritten)
      return this.endOfChunkHit = !0, se.EOF;
    return this._err(ot.surrogateInInputStream), e;
  }
  willDropParsedChunk() {
    return this.pos > this.bufferWaterline;
  }
  dropParsedChunk() {
    this.willDropParsedChunk() && (this.html = this.html.substring(this.pos), this.lineStartPos -= this.pos, this.droppedBufferSize += this.pos, this.pos = 0, this.lastGapPos = -2, this.gapStack.length = 0);
  }
  write(e, n) {
    this.html.length > 0 ? this.html += e : this.html = e, this.endOfChunkHit = !1, this.lastChunkWritten = n;
  }
  insertHtmlAtCurrentPos(e) {
    this.html = this.html.substring(0, this.pos + 1) + e + this.html.substring(this.pos + 1), this.endOfChunkHit = !1;
  }
  startsWith(e, n) {
    if (this.pos + e.length > this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, !1;
    if (n)
      return this.html.startsWith(e, this.pos);
    for (let r = 0; r < e.length; r++)
      if ((this.html.charCodeAt(this.pos + r) | 32) !== e.charCodeAt(r))
        return !1;
    return !0;
  }
  peek(e) {
    const n = this.pos + e;
    if (n >= this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, se.EOF;
    const r = this.html.charCodeAt(n);
    return r === se.CARRIAGE_RETURN ? se.LINE_FEED : r;
  }
  advance() {
    if (this.pos++, this.isEol && (this.isEol = !1, this.line++, this.lineStartPos = this.pos), this.pos >= this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, se.EOF;
    let e = this.html.charCodeAt(this.pos);
    return e === se.CARRIAGE_RETURN ? (this.isEol = !0, this.skipNextNewLine = !0, se.LINE_FEED) : e === se.LINE_FEED && (this.isEol = !0, this.skipNextNewLine) ? (this.line--, this.skipNextNewLine = !1, this._addGap(), this.advance()) : (this.skipNextNewLine = !1, Cue(e) && (e = this._processSurrogate(e)), this.handler.onParseError === null || e > 31 && e < 127 || e === se.LINE_FEED || e === se.CARRIAGE_RETURN || e > 159 && e < 64976 || this._checkForProblematicCharacters(e), e);
  }
  _checkForProblematicCharacters(e) {
    xue(e) ? this._err(ot.controlCharacterInInputStream) : Aue(e) && this._err(ot.noncharacterInInputStream);
  }
  retreat(e) {
    for (this.pos -= e; this.pos < this.lastGapPos; )
      this.lastGapPos = this.gapStack.pop(), this.pos--;
    this.isEol = !1;
  }
}
var Tr;
(function(t) {
  t[t.CHARACTER = 0] = "CHARACTER", t[t.NULL_CHARACTER = 1] = "NULL_CHARACTER", t[t.WHITESPACE_CHARACTER = 2] = "WHITESPACE_CHARACTER", t[t.START_TAG = 3] = "START_TAG", t[t.END_TAG = 4] = "END_TAG", t[t.COMMENT = 5] = "COMMENT", t[t.DOCTYPE = 6] = "DOCTYPE", t[t.EOF = 7] = "EOF", t[t.HIBERNATION = 8] = "HIBERNATION";
})(Tr = Tr || (Tr = {}));
function kue(t, e) {
  for (let n = t.attrs.length - 1; n >= 0; n--)
    if (t.attrs[n].name === e)
      return t.attrs[n].value;
  return null;
}
const Pb = new Uint16Array(
  // prettier-ignore
  'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map((t) => t.charCodeAt(0))
), A9e = new Uint16Array(
  // prettier-ignore
  "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map((t) => t.charCodeAt(0))
);
var V3;
const k9e = /* @__PURE__ */ new Map([
  [0, 65533],
  // C1 Unicode control character reference replacements
  [128, 8364],
  [130, 8218],
  [131, 402],
  [132, 8222],
  [133, 8230],
  [134, 8224],
  [135, 8225],
  [136, 710],
  [137, 8240],
  [138, 352],
  [139, 8249],
  [140, 338],
  [142, 381],
  [145, 8216],
  [146, 8217],
  [147, 8220],
  [148, 8221],
  [149, 8226],
  [150, 8211],
  [151, 8212],
  [152, 732],
  [153, 8482],
  [154, 353],
  [155, 8250],
  [156, 339],
  [158, 382],
  [159, 376]
]), R9e = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
  (V3 = String.fromCodePoint) !== null && V3 !== void 0 ? V3 : function(t) {
    let e = "";
    return t > 65535 && (t -= 65536, e += String.fromCharCode(t >>> 10 & 1023 | 55296), t = 56320 | t & 1023), e += String.fromCharCode(t), e;
  }
);
function I9e(t) {
  var e;
  return t >= 55296 && t <= 57343 || t > 1114111 ? 65533 : (e = k9e.get(t)) !== null && e !== void 0 ? e : t;
}
var gs;
(function(t) {
  t[t.NUM = 35] = "NUM", t[t.SEMI = 59] = "SEMI", t[t.EQUALS = 61] = "EQUALS", t[t.ZERO = 48] = "ZERO", t[t.NINE = 57] = "NINE", t[t.LOWER_A = 97] = "LOWER_A", t[t.LOWER_F = 102] = "LOWER_F", t[t.LOWER_X = 120] = "LOWER_X", t[t.LOWER_Z = 122] = "LOWER_Z", t[t.UPPER_A = 65] = "UPPER_A", t[t.UPPER_F = 70] = "UPPER_F", t[t.UPPER_Z = 90] = "UPPER_Z";
})(gs || (gs = {}));
const D9e = 32;
var Th;
(function(t) {
  t[t.VALUE_LENGTH = 49152] = "VALUE_LENGTH", t[t.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", t[t.JUMP_TABLE = 127] = "JUMP_TABLE";
})(Th || (Th = {}));
function m5(t) {
  return t >= gs.ZERO && t <= gs.NINE;
}
function N9e(t) {
  return t >= gs.UPPER_A && t <= gs.UPPER_F || t >= gs.LOWER_A && t <= gs.LOWER_F;
}
function P9e(t) {
  return t >= gs.UPPER_A && t <= gs.UPPER_Z || t >= gs.LOWER_A && t <= gs.LOWER_Z || m5(t);
}
function L9e(t) {
  return t === gs.EQUALS || P9e(t);
}
var ps;
(function(t) {
  t[t.EntityStart = 0] = "EntityStart", t[t.NumericStart = 1] = "NumericStart", t[t.NumericDecimal = 2] = "NumericDecimal", t[t.NumericHex = 3] = "NumericHex", t[t.NamedEntity = 4] = "NamedEntity";
})(ps || (ps = {}));
var Xy;
(function(t) {
  t[t.Legacy = 0] = "Legacy", t[t.Strict = 1] = "Strict", t[t.Attribute = 2] = "Attribute";
})(Xy || (Xy = {}));
class M9e {
  constructor(e, n, r) {
    this.decodeTree = e, this.emitCodePoint = n, this.errors = r, this.state = ps.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = Xy.Strict;
  }
  /** Resets the instance to make it reusable. */
  startEntity(e) {
    this.decodeMode = e, this.state = ps.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
  }
  /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   *
   * @param string The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  write(e, n) {
    switch (this.state) {
      case ps.EntityStart:
        return e.charCodeAt(n) === gs.NUM ? (this.state = ps.NumericStart, this.consumed += 1, this.stateNumericStart(e, n + 1)) : (this.state = ps.NamedEntity, this.stateNamedEntity(e, n));
      case ps.NumericStart:
        return this.stateNumericStart(e, n);
      case ps.NumericDecimal:
        return this.stateNumericDecimal(e, n);
      case ps.NumericHex:
        return this.stateNumericHex(e, n);
      case ps.NamedEntity:
        return this.stateNamedEntity(e, n);
    }
  }
  /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericStart(e, n) {
    return n >= e.length ? -1 : (e.charCodeAt(n) | D9e) === gs.LOWER_X ? (this.state = ps.NumericHex, this.consumed += 1, this.stateNumericHex(e, n + 1)) : (this.state = ps.NumericDecimal, this.stateNumericDecimal(e, n));
  }
  addToNumericResult(e, n, r, a) {
    if (n !== r) {
      const i = r - n;
      this.result = this.result * Math.pow(a, i) + parseInt(e.substr(n, i), a), this.consumed += i;
    }
  }
  /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericHex(e, n) {
    const r = n;
    for (; n < e.length; ) {
      const a = e.charCodeAt(n);
      if (m5(a) || N9e(a))
        n += 1;
      else
        return this.addToNumericResult(e, r, n, 16), this.emitNumericEntity(a, 3);
    }
    return this.addToNumericResult(e, r, n, 16), -1;
  }
  /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericDecimal(e, n) {
    const r = n;
    for (; n < e.length; ) {
      const a = e.charCodeAt(n);
      if (m5(a))
        n += 1;
      else
        return this.addToNumericResult(e, r, n, 10), this.emitNumericEntity(a, 2);
    }
    return this.addToNumericResult(e, r, n, 10), -1;
  }
  /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   *
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */
  emitNumericEntity(e, n) {
    var r;
    if (this.consumed <= n)
      return (r = this.errors) === null || r === void 0 || r.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
    if (e === gs.SEMI)
      this.consumed += 1;
    else if (this.decodeMode === Xy.Strict)
      return 0;
    return this.emitCodePoint(I9e(this.result), this.consumed), this.errors && (e !== gs.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
  }
  /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNamedEntity(e, n) {
    const { decodeTree: r } = this;
    let a = r[this.treeIndex], i = (a & Th.VALUE_LENGTH) >> 14;
    for (; n < e.length; n++, this.excess++) {
      const o = e.charCodeAt(n);
      if (this.treeIndex = Iue(r, a, this.treeIndex + Math.max(1, i), o), this.treeIndex < 0)
        return this.result === 0 || // If we are parsing an attribute
        this.decodeMode === Xy.Attribute && // We shouldn't have consumed any characters after the entity,
        (i === 0 || // And there should be no invalid characters.
        L9e(o)) ? 0 : this.emitNotTerminatedNamedEntity();
      if (a = r[this.treeIndex], i = (a & Th.VALUE_LENGTH) >> 14, i !== 0) {
        if (o === gs.SEMI)
          return this.emitNamedEntityData(this.treeIndex, i, this.consumed + this.excess);
        this.decodeMode !== Xy.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
      }
    }
    return -1;
  }
  /**
   * Emit a named entity that was not terminated with a semicolon.
   *
   * @returns The number of characters consumed.
   */
  emitNotTerminatedNamedEntity() {
    var e;
    const { result: n, decodeTree: r } = this, a = (r[n] & Th.VALUE_LENGTH) >> 14;
    return this.emitNamedEntityData(n, a, this.consumed), (e = this.errors) === null || e === void 0 || e.missingSemicolonAfterCharacterReference(), this.consumed;
  }
  /**
   * Emit a named entity.
   *
   * @param result The index of the entity in the decode tree.
   * @param valueLength The number of bytes in the entity.
   * @param consumed The number of characters consumed.
   *
   * @returns The number of characters consumed.
   */
  emitNamedEntityData(e, n, r) {
    const { decodeTree: a } = this;
    return this.emitCodePoint(n === 1 ? a[e] & ~Th.VALUE_LENGTH : a[e + 1], r), n === 3 && this.emitCodePoint(a[e + 2], r), r;
  }
  /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   *
   * @returns The number of characters consumed.
   */
  end() {
    var e;
    switch (this.state) {
      case ps.NamedEntity:
        return this.result !== 0 && (this.decodeMode !== Xy.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      case ps.NumericDecimal:
        return this.emitNumericEntity(0, 2);
      case ps.NumericHex:
        return this.emitNumericEntity(0, 3);
      case ps.NumericStart:
        return (e = this.errors) === null || e === void 0 || e.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      case ps.EntityStart:
        return 0;
    }
  }
}
function Rue(t) {
  let e = "";
  const n = new M9e(t, (r) => e += R9e(r));
  return function(a, i) {
    let o = 0, s = 0;
    for (; (s = a.indexOf("&", s)) >= 0; ) {
      e += a.slice(o, s), n.startEntity(i);
      const f = n.write(
        a,
        // Skip the "&"
        s + 1
      );
      if (f < 0) {
        o = s + n.end();
        break;
      }
      o = s + f, s = f === 0 ? o + 1 : o;
    }
    const u = e + a.slice(o);
    return e = "", u;
  };
}
function Iue(t, e, n, r) {
  const a = (e & Th.BRANCH_LENGTH) >> 7, i = e & Th.JUMP_TABLE;
  if (a === 0)
    return i !== 0 && r === i ? n : -1;
  if (i) {
    const u = r - i;
    return u < 0 || u >= a ? -1 : t[n + u] - 1;
  }
  let o = n, s = o + a - 1;
  for (; o <= s; ) {
    const u = o + s >>> 1, f = t[u];
    if (f < r)
      o = u + 1;
    else if (f > r)
      s = u - 1;
    else
      return t[u + a];
  }
  return -1;
}
Rue(Pb);
Rue(A9e);
var vt;
(function(t) {
  t.HTML = "http://www.w3.org/1999/xhtml", t.MATHML = "http://www.w3.org/1998/Math/MathML", t.SVG = "http://www.w3.org/2000/svg", t.XLINK = "http://www.w3.org/1999/xlink", t.XML = "http://www.w3.org/XML/1998/namespace", t.XMLNS = "http://www.w3.org/2000/xmlns/";
})(vt = vt || (vt = {}));
var Xb;
(function(t) {
  t.TYPE = "type", t.ACTION = "action", t.ENCODING = "encoding", t.PROMPT = "prompt", t.NAME = "name", t.COLOR = "color", t.FACE = "face", t.SIZE = "size";
})(Xb = Xb || (Xb = {}));
var Lc;
(function(t) {
  t.NO_QUIRKS = "no-quirks", t.QUIRKS = "quirks", t.LIMITED_QUIRKS = "limited-quirks";
})(Lc = Lc || (Lc = {}));
var Je;
(function(t) {
  t.A = "a", t.ADDRESS = "address", t.ANNOTATION_XML = "annotation-xml", t.APPLET = "applet", t.AREA = "area", t.ARTICLE = "article", t.ASIDE = "aside", t.B = "b", t.BASE = "base", t.BASEFONT = "basefont", t.BGSOUND = "bgsound", t.BIG = "big", t.BLOCKQUOTE = "blockquote", t.BODY = "body", t.BR = "br", t.BUTTON = "button", t.CAPTION = "caption", t.CENTER = "center", t.CODE = "code", t.COL = "col", t.COLGROUP = "colgroup", t.DD = "dd", t.DESC = "desc", t.DETAILS = "details", t.DIALOG = "dialog", t.DIR = "dir", t.DIV = "div", t.DL = "dl", t.DT = "dt", t.EM = "em", t.EMBED = "embed", t.FIELDSET = "fieldset", t.FIGCAPTION = "figcaption", t.FIGURE = "figure", t.FONT = "font", t.FOOTER = "footer", t.FOREIGN_OBJECT = "foreignObject", t.FORM = "form", t.FRAME = "frame", t.FRAMESET = "frameset", t.H1 = "h1", t.H2 = "h2", t.H3 = "h3", t.H4 = "h4", t.H5 = "h5", t.H6 = "h6", t.HEAD = "head", t.HEADER = "header", t.HGROUP = "hgroup", t.HR = "hr", t.HTML = "html", t.I = "i", t.IMG = "img", t.IMAGE = "image", t.INPUT = "input", t.IFRAME = "iframe", t.KEYGEN = "keygen", t.LABEL = "label", t.LI = "li", t.LINK = "link", t.LISTING = "listing", t.MAIN = "main", t.MALIGNMARK = "malignmark", t.MARQUEE = "marquee", t.MATH = "math", t.MENU = "menu", t.META = "meta", t.MGLYPH = "mglyph", t.MI = "mi", t.MO = "mo", t.MN = "mn", t.MS = "ms", t.MTEXT = "mtext", t.NAV = "nav", t.NOBR = "nobr", t.NOFRAMES = "noframes", t.NOEMBED = "noembed", t.NOSCRIPT = "noscript", t.OBJECT = "object", t.OL = "ol", t.OPTGROUP = "optgroup", t.OPTION = "option", t.P = "p", t.PARAM = "param", t.PLAINTEXT = "plaintext", t.PRE = "pre", t.RB = "rb", t.RP = "rp", t.RT = "rt", t.RTC = "rtc", t.RUBY = "ruby", t.S = "s", t.SCRIPT = "script", t.SECTION = "section", t.SELECT = "select", t.SOURCE = "source", t.SMALL = "small", t.SPAN = "span", t.STRIKE = "strike", t.STRONG = "strong", t.STYLE = "style", t.SUB = "sub", t.SUMMARY = "summary", t.SUP = "sup", t.TABLE = "table", t.TBODY = "tbody", t.TEMPLATE = "template", t.TEXTAREA = "textarea", t.TFOOT = "tfoot", t.TD = "td", t.TH = "th", t.THEAD = "thead", t.TITLE = "title", t.TR = "tr", t.TRACK = "track", t.TT = "tt", t.U = "u", t.UL = "ul", t.SVG = "svg", t.VAR = "var", t.WBR = "wbr", t.XMP = "xmp";
})(Je = Je || (Je = {}));
var L;
(function(t) {
  t[t.UNKNOWN = 0] = "UNKNOWN", t[t.A = 1] = "A", t[t.ADDRESS = 2] = "ADDRESS", t[t.ANNOTATION_XML = 3] = "ANNOTATION_XML", t[t.APPLET = 4] = "APPLET", t[t.AREA = 5] = "AREA", t[t.ARTICLE = 6] = "ARTICLE", t[t.ASIDE = 7] = "ASIDE", t[t.B = 8] = "B", t[t.BASE = 9] = "BASE", t[t.BASEFONT = 10] = "BASEFONT", t[t.BGSOUND = 11] = "BGSOUND", t[t.BIG = 12] = "BIG", t[t.BLOCKQUOTE = 13] = "BLOCKQUOTE", t[t.BODY = 14] = "BODY", t[t.BR = 15] = "BR", t[t.BUTTON = 16] = "BUTTON", t[t.CAPTION = 17] = "CAPTION", t[t.CENTER = 18] = "CENTER", t[t.CODE = 19] = "CODE", t[t.COL = 20] = "COL", t[t.COLGROUP = 21] = "COLGROUP", t[t.DD = 22] = "DD", t[t.DESC = 23] = "DESC", t[t.DETAILS = 24] = "DETAILS", t[t.DIALOG = 25] = "DIALOG", t[t.DIR = 26] = "DIR", t[t.DIV = 27] = "DIV", t[t.DL = 28] = "DL", t[t.DT = 29] = "DT", t[t.EM = 30] = "EM", t[t.EMBED = 31] = "EMBED", t[t.FIELDSET = 32] = "FIELDSET", t[t.FIGCAPTION = 33] = "FIGCAPTION", t[t.FIGURE = 34] = "FIGURE", t[t.FONT = 35] = "FONT", t[t.FOOTER = 36] = "FOOTER", t[t.FOREIGN_OBJECT = 37] = "FOREIGN_OBJECT", t[t.FORM = 38] = "FORM", t[t.FRAME = 39] = "FRAME", t[t.FRAMESET = 40] = "FRAMESET", t[t.H1 = 41] = "H1", t[t.H2 = 42] = "H2", t[t.H3 = 43] = "H3", t[t.H4 = 44] = "H4", t[t.H5 = 45] = "H5", t[t.H6 = 46] = "H6", t[t.HEAD = 47] = "HEAD", t[t.HEADER = 48] = "HEADER", t[t.HGROUP = 49] = "HGROUP", t[t.HR = 50] = "HR", t[t.HTML = 51] = "HTML", t[t.I = 52] = "I", t[t.IMG = 53] = "IMG", t[t.IMAGE = 54] = "IMAGE", t[t.INPUT = 55] = "INPUT", t[t.IFRAME = 56] = "IFRAME", t[t.KEYGEN = 57] = "KEYGEN", t[t.LABEL = 58] = "LABEL", t[t.LI = 59] = "LI", t[t.LINK = 60] = "LINK", t[t.LISTING = 61] = "LISTING", t[t.MAIN = 62] = "MAIN", t[t.MALIGNMARK = 63] = "MALIGNMARK", t[t.MARQUEE = 64] = "MARQUEE", t[t.MATH = 65] = "MATH", t[t.MENU = 66] = "MENU", t[t.META = 67] = "META", t[t.MGLYPH = 68] = "MGLYPH", t[t.MI = 69] = "MI", t[t.MO = 70] = "MO", t[t.MN = 71] = "MN", t[t.MS = 72] = "MS", t[t.MTEXT = 73] = "MTEXT", t[t.NAV = 74] = "NAV", t[t.NOBR = 75] = "NOBR", t[t.NOFRAMES = 76] = "NOFRAMES", t[t.NOEMBED = 77] = "NOEMBED", t[t.NOSCRIPT = 78] = "NOSCRIPT", t[t.OBJECT = 79] = "OBJECT", t[t.OL = 80] = "OL", t[t.OPTGROUP = 81] = "OPTGROUP", t[t.OPTION = 82] = "OPTION", t[t.P = 83] = "P", t[t.PARAM = 84] = "PARAM", t[t.PLAINTEXT = 85] = "PLAINTEXT", t[t.PRE = 86] = "PRE", t[t.RB = 87] = "RB", t[t.RP = 88] = "RP", t[t.RT = 89] = "RT", t[t.RTC = 90] = "RTC", t[t.RUBY = 91] = "RUBY", t[t.S = 92] = "S", t[t.SCRIPT = 93] = "SCRIPT", t[t.SECTION = 94] = "SECTION", t[t.SELECT = 95] = "SELECT", t[t.SOURCE = 96] = "SOURCE", t[t.SMALL = 97] = "SMALL", t[t.SPAN = 98] = "SPAN", t[t.STRIKE = 99] = "STRIKE", t[t.STRONG = 100] = "STRONG", t[t.STYLE = 101] = "STYLE", t[t.SUB = 102] = "SUB", t[t.SUMMARY = 103] = "SUMMARY", t[t.SUP = 104] = "SUP", t[t.TABLE = 105] = "TABLE", t[t.TBODY = 106] = "TBODY", t[t.TEMPLATE = 107] = "TEMPLATE", t[t.TEXTAREA = 108] = "TEXTAREA", t[t.TFOOT = 109] = "TFOOT", t[t.TD = 110] = "TD", t[t.TH = 111] = "TH", t[t.THEAD = 112] = "THEAD", t[t.TITLE = 113] = "TITLE", t[t.TR = 114] = "TR", t[t.TRACK = 115] = "TRACK", t[t.TT = 116] = "TT", t[t.U = 117] = "U", t[t.UL = 118] = "UL", t[t.SVG = 119] = "SVG", t[t.VAR = 120] = "VAR", t[t.WBR = 121] = "WBR", t[t.XMP = 122] = "XMP";
})(L = L || (L = {}));
const F9e = /* @__PURE__ */ new Map([
  [Je.A, L.A],
  [Je.ADDRESS, L.ADDRESS],
  [Je.ANNOTATION_XML, L.ANNOTATION_XML],
  [Je.APPLET, L.APPLET],
  [Je.AREA, L.AREA],
  [Je.ARTICLE, L.ARTICLE],
  [Je.ASIDE, L.ASIDE],
  [Je.B, L.B],
  [Je.BASE, L.BASE],
  [Je.BASEFONT, L.BASEFONT],
  [Je.BGSOUND, L.BGSOUND],
  [Je.BIG, L.BIG],
  [Je.BLOCKQUOTE, L.BLOCKQUOTE],
  [Je.BODY, L.BODY],
  [Je.BR, L.BR],
  [Je.BUTTON, L.BUTTON],
  [Je.CAPTION, L.CAPTION],
  [Je.CENTER, L.CENTER],
  [Je.CODE, L.CODE],
  [Je.COL, L.COL],
  [Je.COLGROUP, L.COLGROUP],
  [Je.DD, L.DD],
  [Je.DESC, L.DESC],
  [Je.DETAILS, L.DETAILS],
  [Je.DIALOG, L.DIALOG],
  [Je.DIR, L.DIR],
  [Je.DIV, L.DIV],
  [Je.DL, L.DL],
  [Je.DT, L.DT],
  [Je.EM, L.EM],
  [Je.EMBED, L.EMBED],
  [Je.FIELDSET, L.FIELDSET],
  [Je.FIGCAPTION, L.FIGCAPTION],
  [Je.FIGURE, L.FIGURE],
  [Je.FONT, L.FONT],
  [Je.FOOTER, L.FOOTER],
  [Je.FOREIGN_OBJECT, L.FOREIGN_OBJECT],
  [Je.FORM, L.FORM],
  [Je.FRAME, L.FRAME],
  [Je.FRAMESET, L.FRAMESET],
  [Je.H1, L.H1],
  [Je.H2, L.H2],
  [Je.H3, L.H3],
  [Je.H4, L.H4],
  [Je.H5, L.H5],
  [Je.H6, L.H6],
  [Je.HEAD, L.HEAD],
  [Je.HEADER, L.HEADER],
  [Je.HGROUP, L.HGROUP],
  [Je.HR, L.HR],
  [Je.HTML, L.HTML],
  [Je.I, L.I],
  [Je.IMG, L.IMG],
  [Je.IMAGE, L.IMAGE],
  [Je.INPUT, L.INPUT],
  [Je.IFRAME, L.IFRAME],
  [Je.KEYGEN, L.KEYGEN],
  [Je.LABEL, L.LABEL],
  [Je.LI, L.LI],
  [Je.LINK, L.LINK],
  [Je.LISTING, L.LISTING],
  [Je.MAIN, L.MAIN],
  [Je.MALIGNMARK, L.MALIGNMARK],
  [Je.MARQUEE, L.MARQUEE],
  [Je.MATH, L.MATH],
  [Je.MENU, L.MENU],
  [Je.META, L.META],
  [Je.MGLYPH, L.MGLYPH],
  [Je.MI, L.MI],
  [Je.MO, L.MO],
  [Je.MN, L.MN],
  [Je.MS, L.MS],
  [Je.MTEXT, L.MTEXT],
  [Je.NAV, L.NAV],
  [Je.NOBR, L.NOBR],
  [Je.NOFRAMES, L.NOFRAMES],
  [Je.NOEMBED, L.NOEMBED],
  [Je.NOSCRIPT, L.NOSCRIPT],
  [Je.OBJECT, L.OBJECT],
  [Je.OL, L.OL],
  [Je.OPTGROUP, L.OPTGROUP],
  [Je.OPTION, L.OPTION],
  [Je.P, L.P],
  [Je.PARAM, L.PARAM],
  [Je.PLAINTEXT, L.PLAINTEXT],
  [Je.PRE, L.PRE],
  [Je.RB, L.RB],
  [Je.RP, L.RP],
  [Je.RT, L.RT],
  [Je.RTC, L.RTC],
  [Je.RUBY, L.RUBY],
  [Je.S, L.S],
  [Je.SCRIPT, L.SCRIPT],
  [Je.SECTION, L.SECTION],
  [Je.SELECT, L.SELECT],
  [Je.SOURCE, L.SOURCE],
  [Je.SMALL, L.SMALL],
  [Je.SPAN, L.SPAN],
  [Je.STRIKE, L.STRIKE],
  [Je.STRONG, L.STRONG],
  [Je.STYLE, L.STYLE],
  [Je.SUB, L.SUB],
  [Je.SUMMARY, L.SUMMARY],
  [Je.SUP, L.SUP],
  [Je.TABLE, L.TABLE],
  [Je.TBODY, L.TBODY],
  [Je.TEMPLATE, L.TEMPLATE],
  [Je.TEXTAREA, L.TEXTAREA],
  [Je.TFOOT, L.TFOOT],
  [Je.TD, L.TD],
  [Je.TH, L.TH],
  [Je.THEAD, L.THEAD],
  [Je.TITLE, L.TITLE],
  [Je.TR, L.TR],
  [Je.TRACK, L.TRACK],
  [Je.TT, L.TT],
  [Je.U, L.U],
  [Je.UL, L.UL],
  [Je.SVG, L.SVG],
  [Je.VAR, L.VAR],
  [Je.WBR, L.WBR],
  [Je.XMP, L.XMP]
]);
function _1(t) {
  var e;
  return (e = F9e.get(t)) !== null && e !== void 0 ? e : L.UNKNOWN;
}
const Pt = L, $9e = {
  [vt.HTML]: /* @__PURE__ */ new Set([
    Pt.ADDRESS,
    Pt.APPLET,
    Pt.AREA,
    Pt.ARTICLE,
    Pt.ASIDE,
    Pt.BASE,
    Pt.BASEFONT,
    Pt.BGSOUND,
    Pt.BLOCKQUOTE,
    Pt.BODY,
    Pt.BR,
    Pt.BUTTON,
    Pt.CAPTION,
    Pt.CENTER,
    Pt.COL,
    Pt.COLGROUP,
    Pt.DD,
    Pt.DETAILS,
    Pt.DIR,
    Pt.DIV,
    Pt.DL,
    Pt.DT,
    Pt.EMBED,
    Pt.FIELDSET,
    Pt.FIGCAPTION,
    Pt.FIGURE,
    Pt.FOOTER,
    Pt.FORM,
    Pt.FRAME,
    Pt.FRAMESET,
    Pt.H1,
    Pt.H2,
    Pt.H3,
    Pt.H4,
    Pt.H5,
    Pt.H6,
    Pt.HEAD,
    Pt.HEADER,
    Pt.HGROUP,
    Pt.HR,
    Pt.HTML,
    Pt.IFRAME,
    Pt.IMG,
    Pt.INPUT,
    Pt.LI,
    Pt.LINK,
    Pt.LISTING,
    Pt.MAIN,
    Pt.MARQUEE,
    Pt.MENU,
    Pt.META,
    Pt.NAV,
    Pt.NOEMBED,
    Pt.NOFRAMES,
    Pt.NOSCRIPT,
    Pt.OBJECT,
    Pt.OL,
    Pt.P,
    Pt.PARAM,
    Pt.PLAINTEXT,
    Pt.PRE,
    Pt.SCRIPT,
    Pt.SECTION,
    Pt.SELECT,
    Pt.SOURCE,
    Pt.STYLE,
    Pt.SUMMARY,
    Pt.TABLE,
    Pt.TBODY,
    Pt.TD,
    Pt.TEMPLATE,
    Pt.TEXTAREA,
    Pt.TFOOT,
    Pt.TH,
    Pt.THEAD,
    Pt.TITLE,
    Pt.TR,
    Pt.TRACK,
    Pt.UL,
    Pt.WBR,
    Pt.XMP
  ]),
  [vt.MATHML]: /* @__PURE__ */ new Set([Pt.MI, Pt.MO, Pt.MN, Pt.MS, Pt.MTEXT, Pt.ANNOTATION_XML]),
  [vt.SVG]: /* @__PURE__ */ new Set([Pt.TITLE, Pt.FOREIGN_OBJECT, Pt.DESC]),
  [vt.XLINK]: /* @__PURE__ */ new Set(),
  [vt.XML]: /* @__PURE__ */ new Set(),
  [vt.XMLNS]: /* @__PURE__ */ new Set()
};
function Due(t) {
  return t === Pt.H1 || t === Pt.H2 || t === Pt.H3 || t === Pt.H4 || t === Pt.H5 || t === Pt.H6;
}
Je.STYLE, Je.SCRIPT, Je.XMP, Je.IFRAME, Je.NOEMBED, Je.NOFRAMES, Je.PLAINTEXT;
const B9e = /* @__PURE__ */ new Map([
  [128, 8364],
  [130, 8218],
  [131, 402],
  [132, 8222],
  [133, 8230],
  [134, 8224],
  [135, 8225],
  [136, 710],
  [137, 8240],
  [138, 352],
  [139, 8249],
  [140, 338],
  [142, 381],
  [145, 8216],
  [146, 8217],
  [147, 8220],
  [148, 8221],
  [149, 8226],
  [150, 8211],
  [151, 8212],
  [152, 732],
  [153, 8482],
  [154, 353],
  [155, 8250],
  [156, 339],
  [158, 382],
  [159, 376]
]);
var be;
(function(t) {
  t[t.DATA = 0] = "DATA", t[t.RCDATA = 1] = "RCDATA", t[t.RAWTEXT = 2] = "RAWTEXT", t[t.SCRIPT_DATA = 3] = "SCRIPT_DATA", t[t.PLAINTEXT = 4] = "PLAINTEXT", t[t.TAG_OPEN = 5] = "TAG_OPEN", t[t.END_TAG_OPEN = 6] = "END_TAG_OPEN", t[t.TAG_NAME = 7] = "TAG_NAME", t[t.RCDATA_LESS_THAN_SIGN = 8] = "RCDATA_LESS_THAN_SIGN", t[t.RCDATA_END_TAG_OPEN = 9] = "RCDATA_END_TAG_OPEN", t[t.RCDATA_END_TAG_NAME = 10] = "RCDATA_END_TAG_NAME", t[t.RAWTEXT_LESS_THAN_SIGN = 11] = "RAWTEXT_LESS_THAN_SIGN", t[t.RAWTEXT_END_TAG_OPEN = 12] = "RAWTEXT_END_TAG_OPEN", t[t.RAWTEXT_END_TAG_NAME = 13] = "RAWTEXT_END_TAG_NAME", t[t.SCRIPT_DATA_LESS_THAN_SIGN = 14] = "SCRIPT_DATA_LESS_THAN_SIGN", t[t.SCRIPT_DATA_END_TAG_OPEN = 15] = "SCRIPT_DATA_END_TAG_OPEN", t[t.SCRIPT_DATA_END_TAG_NAME = 16] = "SCRIPT_DATA_END_TAG_NAME", t[t.SCRIPT_DATA_ESCAPE_START = 17] = "SCRIPT_DATA_ESCAPE_START", t[t.SCRIPT_DATA_ESCAPE_START_DASH = 18] = "SCRIPT_DATA_ESCAPE_START_DASH", t[t.SCRIPT_DATA_ESCAPED = 19] = "SCRIPT_DATA_ESCAPED", t[t.SCRIPT_DATA_ESCAPED_DASH = 20] = "SCRIPT_DATA_ESCAPED_DASH", t[t.SCRIPT_DATA_ESCAPED_DASH_DASH = 21] = "SCRIPT_DATA_ESCAPED_DASH_DASH", t[t.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN = 22] = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN", t[t.SCRIPT_DATA_ESCAPED_END_TAG_OPEN = 23] = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN", t[t.SCRIPT_DATA_ESCAPED_END_TAG_NAME = 24] = "SCRIPT_DATA_ESCAPED_END_TAG_NAME", t[t.SCRIPT_DATA_DOUBLE_ESCAPE_START = 25] = "SCRIPT_DATA_DOUBLE_ESCAPE_START", t[t.SCRIPT_DATA_DOUBLE_ESCAPED = 26] = "SCRIPT_DATA_DOUBLE_ESCAPED", t[t.SCRIPT_DATA_DOUBLE_ESCAPED_DASH = 27] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH", t[t.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH = 28] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH", t[t.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN = 29] = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN", t[t.SCRIPT_DATA_DOUBLE_ESCAPE_END = 30] = "SCRIPT_DATA_DOUBLE_ESCAPE_END", t[t.BEFORE_ATTRIBUTE_NAME = 31] = "BEFORE_ATTRIBUTE_NAME", t[t.ATTRIBUTE_NAME = 32] = "ATTRIBUTE_NAME", t[t.AFTER_ATTRIBUTE_NAME = 33] = "AFTER_ATTRIBUTE_NAME", t[t.BEFORE_ATTRIBUTE_VALUE = 34] = "BEFORE_ATTRIBUTE_VALUE", t[t.ATTRIBUTE_VALUE_DOUBLE_QUOTED = 35] = "ATTRIBUTE_VALUE_DOUBLE_QUOTED", t[t.ATTRIBUTE_VALUE_SINGLE_QUOTED = 36] = "ATTRIBUTE_VALUE_SINGLE_QUOTED", t[t.ATTRIBUTE_VALUE_UNQUOTED = 37] = "ATTRIBUTE_VALUE_UNQUOTED", t[t.AFTER_ATTRIBUTE_VALUE_QUOTED = 38] = "AFTER_ATTRIBUTE_VALUE_QUOTED", t[t.SELF_CLOSING_START_TAG = 39] = "SELF_CLOSING_START_TAG", t[t.BOGUS_COMMENT = 40] = "BOGUS_COMMENT", t[t.MARKUP_DECLARATION_OPEN = 41] = "MARKUP_DECLARATION_OPEN", t[t.COMMENT_START = 42] = "COMMENT_START", t[t.COMMENT_START_DASH = 43] = "COMMENT_START_DASH", t[t.COMMENT = 44] = "COMMENT", t[t.COMMENT_LESS_THAN_SIGN = 45] = "COMMENT_LESS_THAN_SIGN", t[t.COMMENT_LESS_THAN_SIGN_BANG = 46] = "COMMENT_LESS_THAN_SIGN_BANG", t[t.COMMENT_LESS_THAN_SIGN_BANG_DASH = 47] = "COMMENT_LESS_THAN_SIGN_BANG_DASH", t[t.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH = 48] = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH", t[t.COMMENT_END_DASH = 49] = "COMMENT_END_DASH", t[t.COMMENT_END = 50] = "COMMENT_END", t[t.COMMENT_END_BANG = 51] = "COMMENT_END_BANG", t[t.DOCTYPE = 52] = "DOCTYPE", t[t.BEFORE_DOCTYPE_NAME = 53] = "BEFORE_DOCTYPE_NAME", t[t.DOCTYPE_NAME = 54] = "DOCTYPE_NAME", t[t.AFTER_DOCTYPE_NAME = 55] = "AFTER_DOCTYPE_NAME", t[t.AFTER_DOCTYPE_PUBLIC_KEYWORD = 56] = "AFTER_DOCTYPE_PUBLIC_KEYWORD", t[t.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER = 57] = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER", t[t.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED = 58] = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED", t[t.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED = 59] = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED", t[t.AFTER_DOCTYPE_PUBLIC_IDENTIFIER = 60] = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER", t[t.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS = 61] = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS", t[t.AFTER_DOCTYPE_SYSTEM_KEYWORD = 62] = "AFTER_DOCTYPE_SYSTEM_KEYWORD", t[t.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER = 63] = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER", t[t.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED = 64] = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED", t[t.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED = 65] = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED", t[t.AFTER_DOCTYPE_SYSTEM_IDENTIFIER = 66] = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER", t[t.BOGUS_DOCTYPE = 67] = "BOGUS_DOCTYPE", t[t.CDATA_SECTION = 68] = "CDATA_SECTION", t[t.CDATA_SECTION_BRACKET = 69] = "CDATA_SECTION_BRACKET", t[t.CDATA_SECTION_END = 70] = "CDATA_SECTION_END", t[t.CHARACTER_REFERENCE = 71] = "CHARACTER_REFERENCE", t[t.NAMED_CHARACTER_REFERENCE = 72] = "NAMED_CHARACTER_REFERENCE", t[t.AMBIGUOUS_AMPERSAND = 73] = "AMBIGUOUS_AMPERSAND", t[t.NUMERIC_CHARACTER_REFERENCE = 74] = "NUMERIC_CHARACTER_REFERENCE", t[t.HEXADEMICAL_CHARACTER_REFERENCE_START = 75] = "HEXADEMICAL_CHARACTER_REFERENCE_START", t[t.HEXADEMICAL_CHARACTER_REFERENCE = 76] = "HEXADEMICAL_CHARACTER_REFERENCE", t[t.DECIMAL_CHARACTER_REFERENCE = 77] = "DECIMAL_CHARACTER_REFERENCE", t[t.NUMERIC_CHARACTER_REFERENCE_END = 78] = "NUMERIC_CHARACTER_REFERENCE_END";
})(be || (be = {}));
const uo = {
  DATA: be.DATA,
  RCDATA: be.RCDATA,
  RAWTEXT: be.RAWTEXT,
  SCRIPT_DATA: be.SCRIPT_DATA,
  PLAINTEXT: be.PLAINTEXT,
  CDATA_SECTION: be.CDATA_SECTION
};
function hT(t) {
  return t >= se.DIGIT_0 && t <= se.DIGIT_9;
}
function Hw(t) {
  return t >= se.LATIN_CAPITAL_A && t <= se.LATIN_CAPITAL_Z;
}
function U9e(t) {
  return t >= se.LATIN_SMALL_A && t <= se.LATIN_SMALL_Z;
}
function Lb(t) {
  return U9e(t) || Hw(t);
}
function g5(t) {
  return Lb(t) || hT(t);
}
function Nue(t) {
  return t >= se.LATIN_CAPITAL_A && t <= se.LATIN_CAPITAL_F;
}
function Pue(t) {
  return t >= se.LATIN_SMALL_A && t <= se.LATIN_SMALL_F;
}
function z9e(t) {
  return hT(t) || Nue(t) || Pue(t);
}
function pA(t) {
  return t + 32;
}
function Lue(t) {
  return t === se.SPACE || t === se.LINE_FEED || t === se.TABULATION || t === se.FORM_FEED;
}
function H9e(t) {
  return t === se.EQUALS_SIGN || g5(t);
}
function AJ(t) {
  return Lue(t) || t === se.SOLIDUS || t === se.GREATER_THAN_SIGN;
}
class W9e {
  constructor(e, n) {
    this.options = e, this.handler = n, this.paused = !1, this.inLoop = !1, this.inForeignNode = !1, this.lastStartTagName = "", this.active = !1, this.state = be.DATA, this.returnState = be.DATA, this.charRefCode = -1, this.consumedAfterSnapshot = -1, this.currentCharacterToken = null, this.currentToken = null, this.currentAttr = { name: "", value: "" }, this.preprocessor = new x9e(n), this.currentLocation = this.getCurrentLocation(-1);
  }
  //Errors
  _err(e) {
    var n, r;
    (r = (n = this.handler).onParseError) === null || r === void 0 || r.call(n, this.preprocessor.getError(e));
  }
  // NOTE: `offset` may never run across line boundaries.
  getCurrentLocation(e) {
    return this.options.sourceCodeLocationInfo ? {
      startLine: this.preprocessor.line,
      startCol: this.preprocessor.col - e,
      startOffset: this.preprocessor.offset - e,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    } : null;
  }
  _runParsingLoop() {
    if (!this.inLoop) {
      for (this.inLoop = !0; this.active && !this.paused; ) {
        this.consumedAfterSnapshot = 0;
        const e = this._consume();
        this._ensureHibernation() || this._callState(e);
      }
      this.inLoop = !1;
    }
  }
  //API
  pause() {
    this.paused = !0;
  }
  resume(e) {
    if (!this.paused)
      throw new Error("Parser was already resumed");
    this.paused = !1, !this.inLoop && (this._runParsingLoop(), this.paused || e == null || e());
  }
  write(e, n, r) {
    this.active = !0, this.preprocessor.write(e, n), this._runParsingLoop(), this.paused || r == null || r();
  }
  insertHtmlAtCurrentPos(e) {
    this.active = !0, this.preprocessor.insertHtmlAtCurrentPos(e), this._runParsingLoop();
  }
  //Hibernation
  _ensureHibernation() {
    return this.preprocessor.endOfChunkHit ? (this._unconsume(this.consumedAfterSnapshot), this.active = !1, !0) : !1;
  }
  //Consumption
  _consume() {
    return this.consumedAfterSnapshot++, this.preprocessor.advance();
  }
  _unconsume(e) {
    this.consumedAfterSnapshot -= e, this.preprocessor.retreat(e);
  }
  _reconsumeInState(e, n) {
    this.state = e, this._callState(n);
  }
  _advanceBy(e) {
    this.consumedAfterSnapshot += e;
    for (let n = 0; n < e; n++)
      this.preprocessor.advance();
  }
  _consumeSequenceIfMatch(e, n) {
    return this.preprocessor.startsWith(e, n) ? (this._advanceBy(e.length - 1), !0) : !1;
  }
  //Token creation
  _createStartTagToken() {
    this.currentToken = {
      type: Tr.START_TAG,
      tagName: "",
      tagID: L.UNKNOWN,
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: [],
      location: this.getCurrentLocation(1)
    };
  }
  _createEndTagToken() {
    this.currentToken = {
      type: Tr.END_TAG,
      tagName: "",
      tagID: L.UNKNOWN,
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: [],
      location: this.getCurrentLocation(2)
    };
  }
  _createCommentToken(e) {
    this.currentToken = {
      type: Tr.COMMENT,
      data: "",
      location: this.getCurrentLocation(e)
    };
  }
  _createDoctypeToken(e) {
    this.currentToken = {
      type: Tr.DOCTYPE,
      name: e,
      forceQuirks: !1,
      publicId: null,
      systemId: null,
      location: this.currentLocation
    };
  }
  _createCharacterToken(e, n) {
    this.currentCharacterToken = {
      type: e,
      chars: n,
      location: this.currentLocation
    };
  }
  //Tag attributes
  _createAttr(e) {
    this.currentAttr = {
      name: e,
      value: ""
    }, this.currentLocation = this.getCurrentLocation(0);
  }
  _leaveAttrName() {
    var e, n;
    const r = this.currentToken;
    if (kue(r, this.currentAttr.name) === null) {
      if (r.attrs.push(this.currentAttr), r.location && this.currentLocation) {
        const a = (e = (n = r.location).attrs) !== null && e !== void 0 ? e : n.attrs = /* @__PURE__ */ Object.create(null);
        a[this.currentAttr.name] = this.currentLocation, this._leaveAttrValue();
      }
    } else
      this._err(ot.duplicateAttribute);
  }
  _leaveAttrValue() {
    this.currentLocation && (this.currentLocation.endLine = this.preprocessor.line, this.currentLocation.endCol = this.preprocessor.col, this.currentLocation.endOffset = this.preprocessor.offset);
  }
  //Token emission
  prepareToken(e) {
    this._emitCurrentCharacterToken(e.location), this.currentToken = null, e.location && (e.location.endLine = this.preprocessor.line, e.location.endCol = this.preprocessor.col + 1, e.location.endOffset = this.preprocessor.offset + 1), this.currentLocation = this.getCurrentLocation(-1);
  }
  emitCurrentTagToken() {
    const e = this.currentToken;
    this.prepareToken(e), e.tagID = _1(e.tagName), e.type === Tr.START_TAG ? (this.lastStartTagName = e.tagName, this.handler.onStartTag(e)) : (e.attrs.length > 0 && this._err(ot.endTagWithAttributes), e.selfClosing && this._err(ot.endTagWithTrailingSolidus), this.handler.onEndTag(e)), this.preprocessor.dropParsedChunk();
  }
  emitCurrentComment(e) {
    this.prepareToken(e), this.handler.onComment(e), this.preprocessor.dropParsedChunk();
  }
  emitCurrentDoctype(e) {
    this.prepareToken(e), this.handler.onDoctype(e), this.preprocessor.dropParsedChunk();
  }
  _emitCurrentCharacterToken(e) {
    if (this.currentCharacterToken) {
      switch (e && this.currentCharacterToken.location && (this.currentCharacterToken.location.endLine = e.startLine, this.currentCharacterToken.location.endCol = e.startCol, this.currentCharacterToken.location.endOffset = e.startOffset), this.currentCharacterToken.type) {
        case Tr.CHARACTER: {
          this.handler.onCharacter(this.currentCharacterToken);
          break;
        }
        case Tr.NULL_CHARACTER: {
          this.handler.onNullCharacter(this.currentCharacterToken);
          break;
        }
        case Tr.WHITESPACE_CHARACTER: {
          this.handler.onWhitespaceCharacter(this.currentCharacterToken);
          break;
        }
      }
      this.currentCharacterToken = null;
    }
  }
  _emitEOFToken() {
    const e = this.getCurrentLocation(0);
    e && (e.endLine = e.startLine, e.endCol = e.startCol, e.endOffset = e.startOffset), this._emitCurrentCharacterToken(e), this.handler.onEof({ type: Tr.EOF, location: e }), this.active = !1;
  }
  //Characters emission
  //OPTIMIZATION: specification uses only one type of character tokens (one token per character).
  //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
  //If we have a sequence of characters that belong to the same group, the parser can process it
  //as a single solid character token.
  //So, there are 3 types of character tokens in parse5:
  //1)TokenType.NULL_CHARACTER - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
  //2)TokenType.WHITESPACE_CHARACTER - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
  //3)TokenType.CHARACTER - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
  _appendCharToCurrentCharacterToken(e, n) {
    if (this.currentCharacterToken)
      if (this.currentCharacterToken.type !== e)
        this.currentLocation = this.getCurrentLocation(0), this._emitCurrentCharacterToken(this.currentLocation), this.preprocessor.dropParsedChunk();
      else {
        this.currentCharacterToken.chars += n;
        return;
      }
    this._createCharacterToken(e, n);
  }
  _emitCodePoint(e) {
    const n = Lue(e) ? Tr.WHITESPACE_CHARACTER : e === se.NULL ? Tr.NULL_CHARACTER : Tr.CHARACTER;
    this._appendCharToCurrentCharacterToken(n, String.fromCodePoint(e));
  }
  //NOTE: used when we emit characters explicitly.
  //This is always for non-whitespace and non-null characters, which allows us to avoid additional checks.
  _emitChars(e) {
    this._appendCharToCurrentCharacterToken(Tr.CHARACTER, e);
  }
  // Character reference helpers
  _matchNamedCharacterReference(e) {
    let n = null, r = 0, a = !1;
    for (let i = 0, o = Pb[0]; i >= 0 && (i = Iue(Pb, o, i + 1, e), !(i < 0)); e = this._consume()) {
      r += 1, o = Pb[i];
      const s = o & Th.VALUE_LENGTH;
      if (s) {
        const u = (s >> 14) - 1;
        if (e !== se.SEMICOLON && this._isCharacterReferenceInAttribute() && H9e(this.preprocessor.peek(1)) ? (n = [se.AMPERSAND], i += u) : (n = u === 0 ? [Pb[i] & ~Th.VALUE_LENGTH] : u === 1 ? [Pb[++i]] : [Pb[++i], Pb[++i]], r = 0, a = e !== se.SEMICOLON), u === 0) {
          this._consume();
          break;
        }
      }
    }
    return this._unconsume(r), a && !this.preprocessor.endOfChunkHit && this._err(ot.missingSemicolonAfterCharacterReference), this._unconsume(1), n;
  }
  _isCharacterReferenceInAttribute() {
    return this.returnState === be.ATTRIBUTE_VALUE_DOUBLE_QUOTED || this.returnState === be.ATTRIBUTE_VALUE_SINGLE_QUOTED || this.returnState === be.ATTRIBUTE_VALUE_UNQUOTED;
  }
  _flushCodePointConsumedAsCharacterReference(e) {
    this._isCharacterReferenceInAttribute() ? this.currentAttr.value += String.fromCodePoint(e) : this._emitCodePoint(e);
  }
  // Calling states this way turns out to be much faster than any other approach.
  _callState(e) {
    switch (this.state) {
      case be.DATA: {
        this._stateData(e);
        break;
      }
      case be.RCDATA: {
        this._stateRcdata(e);
        break;
      }
      case be.RAWTEXT: {
        this._stateRawtext(e);
        break;
      }
      case be.SCRIPT_DATA: {
        this._stateScriptData(e);
        break;
      }
      case be.PLAINTEXT: {
        this._statePlaintext(e);
        break;
      }
      case be.TAG_OPEN: {
        this._stateTagOpen(e);
        break;
      }
      case be.END_TAG_OPEN: {
        this._stateEndTagOpen(e);
        break;
      }
      case be.TAG_NAME: {
        this._stateTagName(e);
        break;
      }
      case be.RCDATA_LESS_THAN_SIGN: {
        this._stateRcdataLessThanSign(e);
        break;
      }
      case be.RCDATA_END_TAG_OPEN: {
        this._stateRcdataEndTagOpen(e);
        break;
      }
      case be.RCDATA_END_TAG_NAME: {
        this._stateRcdataEndTagName(e);
        break;
      }
      case be.RAWTEXT_LESS_THAN_SIGN: {
        this._stateRawtextLessThanSign(e);
        break;
      }
      case be.RAWTEXT_END_TAG_OPEN: {
        this._stateRawtextEndTagOpen(e);
        break;
      }
      case be.RAWTEXT_END_TAG_NAME: {
        this._stateRawtextEndTagName(e);
        break;
      }
      case be.SCRIPT_DATA_LESS_THAN_SIGN: {
        this._stateScriptDataLessThanSign(e);
        break;
      }
      case be.SCRIPT_DATA_END_TAG_OPEN: {
        this._stateScriptDataEndTagOpen(e);
        break;
      }
      case be.SCRIPT_DATA_END_TAG_NAME: {
        this._stateScriptDataEndTagName(e);
        break;
      }
      case be.SCRIPT_DATA_ESCAPE_START: {
        this._stateScriptDataEscapeStart(e);
        break;
      }
      case be.SCRIPT_DATA_ESCAPE_START_DASH: {
        this._stateScriptDataEscapeStartDash(e);
        break;
      }
      case be.SCRIPT_DATA_ESCAPED: {
        this._stateScriptDataEscaped(e);
        break;
      }
      case be.SCRIPT_DATA_ESCAPED_DASH: {
        this._stateScriptDataEscapedDash(e);
        break;
      }
      case be.SCRIPT_DATA_ESCAPED_DASH_DASH: {
        this._stateScriptDataEscapedDashDash(e);
        break;
      }
      case be.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN: {
        this._stateScriptDataEscapedLessThanSign(e);
        break;
      }
      case be.SCRIPT_DATA_ESCAPED_END_TAG_OPEN: {
        this._stateScriptDataEscapedEndTagOpen(e);
        break;
      }
      case be.SCRIPT_DATA_ESCAPED_END_TAG_NAME: {
        this._stateScriptDataEscapedEndTagName(e);
        break;
      }
      case be.SCRIPT_DATA_DOUBLE_ESCAPE_START: {
        this._stateScriptDataDoubleEscapeStart(e);
        break;
      }
      case be.SCRIPT_DATA_DOUBLE_ESCAPED: {
        this._stateScriptDataDoubleEscaped(e);
        break;
      }
      case be.SCRIPT_DATA_DOUBLE_ESCAPED_DASH: {
        this._stateScriptDataDoubleEscapedDash(e);
        break;
      }
      case be.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH: {
        this._stateScriptDataDoubleEscapedDashDash(e);
        break;
      }
      case be.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN: {
        this._stateScriptDataDoubleEscapedLessThanSign(e);
        break;
      }
      case be.SCRIPT_DATA_DOUBLE_ESCAPE_END: {
        this._stateScriptDataDoubleEscapeEnd(e);
        break;
      }
      case be.BEFORE_ATTRIBUTE_NAME: {
        this._stateBeforeAttributeName(e);
        break;
      }
      case be.ATTRIBUTE_NAME: {
        this._stateAttributeName(e);
        break;
      }
      case be.AFTER_ATTRIBUTE_NAME: {
        this._stateAfterAttributeName(e);
        break;
      }
      case be.BEFORE_ATTRIBUTE_VALUE: {
        this._stateBeforeAttributeValue(e);
        break;
      }
      case be.ATTRIBUTE_VALUE_DOUBLE_QUOTED: {
        this._stateAttributeValueDoubleQuoted(e);
        break;
      }
      case be.ATTRIBUTE_VALUE_SINGLE_QUOTED: {
        this._stateAttributeValueSingleQuoted(e);
        break;
      }
      case be.ATTRIBUTE_VALUE_UNQUOTED: {
        this._stateAttributeValueUnquoted(e);
        break;
      }
      case be.AFTER_ATTRIBUTE_VALUE_QUOTED: {
        this._stateAfterAttributeValueQuoted(e);
        break;
      }
      case be.SELF_CLOSING_START_TAG: {
        this._stateSelfClosingStartTag(e);
        break;
      }
      case be.BOGUS_COMMENT: {
        this._stateBogusComment(e);
        break;
      }
      case be.MARKUP_DECLARATION_OPEN: {
        this._stateMarkupDeclarationOpen(e);
        break;
      }
      case be.COMMENT_START: {
        this._stateCommentStart(e);
        break;
      }
      case be.COMMENT_START_DASH: {
        this._stateCommentStartDash(e);
        break;
      }
      case be.COMMENT: {
        this._stateComment(e);
        break;
      }
      case be.COMMENT_LESS_THAN_SIGN: {
        this._stateCommentLessThanSign(e);
        break;
      }
      case be.COMMENT_LESS_THAN_SIGN_BANG: {
        this._stateCommentLessThanSignBang(e);
        break;
      }
      case be.COMMENT_LESS_THAN_SIGN_BANG_DASH: {
        this._stateCommentLessThanSignBangDash(e);
        break;
      }
      case be.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH: {
        this._stateCommentLessThanSignBangDashDash(e);
        break;
      }
      case be.COMMENT_END_DASH: {
        this._stateCommentEndDash(e);
        break;
      }
      case be.COMMENT_END: {
        this._stateCommentEnd(e);
        break;
      }
      case be.COMMENT_END_BANG: {
        this._stateCommentEndBang(e);
        break;
      }
      case be.DOCTYPE: {
        this._stateDoctype(e);
        break;
      }
      case be.BEFORE_DOCTYPE_NAME: {
        this._stateBeforeDoctypeName(e);
        break;
      }
      case be.DOCTYPE_NAME: {
        this._stateDoctypeName(e);
        break;
      }
      case be.AFTER_DOCTYPE_NAME: {
        this._stateAfterDoctypeName(e);
        break;
      }
      case be.AFTER_DOCTYPE_PUBLIC_KEYWORD: {
        this._stateAfterDoctypePublicKeyword(e);
        break;
      }
      case be.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER: {
        this._stateBeforeDoctypePublicIdentifier(e);
        break;
      }
      case be.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED: {
        this._stateDoctypePublicIdentifierDoubleQuoted(e);
        break;
      }
      case be.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED: {
        this._stateDoctypePublicIdentifierSingleQuoted(e);
        break;
      }
      case be.AFTER_DOCTYPE_PUBLIC_IDENTIFIER: {
        this._stateAfterDoctypePublicIdentifier(e);
        break;
      }
      case be.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS: {
        this._stateBetweenDoctypePublicAndSystemIdentifiers(e);
        break;
      }
      case be.AFTER_DOCTYPE_SYSTEM_KEYWORD: {
        this._stateAfterDoctypeSystemKeyword(e);
        break;
      }
      case be.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER: {
        this._stateBeforeDoctypeSystemIdentifier(e);
        break;
      }
      case be.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED: {
        this._stateDoctypeSystemIdentifierDoubleQuoted(e);
        break;
      }
      case be.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED: {
        this._stateDoctypeSystemIdentifierSingleQuoted(e);
        break;
      }
      case be.AFTER_DOCTYPE_SYSTEM_IDENTIFIER: {
        this._stateAfterDoctypeSystemIdentifier(e);
        break;
      }
      case be.BOGUS_DOCTYPE: {
        this._stateBogusDoctype(e);
        break;
      }
      case be.CDATA_SECTION: {
        this._stateCdataSection(e);
        break;
      }
      case be.CDATA_SECTION_BRACKET: {
        this._stateCdataSectionBracket(e);
        break;
      }
      case be.CDATA_SECTION_END: {
        this._stateCdataSectionEnd(e);
        break;
      }
      case be.CHARACTER_REFERENCE: {
        this._stateCharacterReference(e);
        break;
      }
      case be.NAMED_CHARACTER_REFERENCE: {
        this._stateNamedCharacterReference(e);
        break;
      }
      case be.AMBIGUOUS_AMPERSAND: {
        this._stateAmbiguousAmpersand(e);
        break;
      }
      case be.NUMERIC_CHARACTER_REFERENCE: {
        this._stateNumericCharacterReference(e);
        break;
      }
      case be.HEXADEMICAL_CHARACTER_REFERENCE_START: {
        this._stateHexademicalCharacterReferenceStart(e);
        break;
      }
      case be.HEXADEMICAL_CHARACTER_REFERENCE: {
        this._stateHexademicalCharacterReference(e);
        break;
      }
      case be.DECIMAL_CHARACTER_REFERENCE: {
        this._stateDecimalCharacterReference(e);
        break;
      }
      case be.NUMERIC_CHARACTER_REFERENCE_END: {
        this._stateNumericCharacterReferenceEnd(e);
        break;
      }
      default:
        throw new Error("Unknown state");
    }
  }
  // State machine
  // Data state
  //------------------------------------------------------------------
  _stateData(e) {
    switch (e) {
      case se.LESS_THAN_SIGN: {
        this.state = be.TAG_OPEN;
        break;
      }
      case se.AMPERSAND: {
        this.returnState = be.DATA, this.state = be.CHARACTER_REFERENCE;
        break;
      }
      case se.NULL: {
        this._err(ot.unexpectedNullCharacter), this._emitCodePoint(e);
        break;
      }
      case se.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(e);
    }
  }
  //  RCDATA state
  //------------------------------------------------------------------
  _stateRcdata(e) {
    switch (e) {
      case se.AMPERSAND: {
        this.returnState = be.RCDATA, this.state = be.CHARACTER_REFERENCE;
        break;
      }
      case se.LESS_THAN_SIGN: {
        this.state = be.RCDATA_LESS_THAN_SIGN;
        break;
      }
      case se.NULL: {
        this._err(ot.unexpectedNullCharacter), this._emitChars(Oi);
        break;
      }
      case se.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(e);
    }
  }
  // RAWTEXT state
  //------------------------------------------------------------------
  _stateRawtext(e) {
    switch (e) {
      case se.LESS_THAN_SIGN: {
        this.state = be.RAWTEXT_LESS_THAN_SIGN;
        break;
      }
      case se.NULL: {
        this._err(ot.unexpectedNullCharacter), this._emitChars(Oi);
        break;
      }
      case se.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(e);
    }
  }
  // Script data state
  //------------------------------------------------------------------
  _stateScriptData(e) {
    switch (e) {
      case se.LESS_THAN_SIGN: {
        this.state = be.SCRIPT_DATA_LESS_THAN_SIGN;
        break;
      }
      case se.NULL: {
        this._err(ot.unexpectedNullCharacter), this._emitChars(Oi);
        break;
      }
      case se.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(e);
    }
  }
  // PLAINTEXT state
  //------------------------------------------------------------------
  _statePlaintext(e) {
    switch (e) {
      case se.NULL: {
        this._err(ot.unexpectedNullCharacter), this._emitChars(Oi);
        break;
      }
      case se.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(e);
    }
  }
  // Tag open state
  //------------------------------------------------------------------
  _stateTagOpen(e) {
    if (Lb(e))
      this._createStartTagToken(), this.state = be.TAG_NAME, this._stateTagName(e);
    else
      switch (e) {
        case se.EXCLAMATION_MARK: {
          this.state = be.MARKUP_DECLARATION_OPEN;
          break;
        }
        case se.SOLIDUS: {
          this.state = be.END_TAG_OPEN;
          break;
        }
        case se.QUESTION_MARK: {
          this._err(ot.unexpectedQuestionMarkInsteadOfTagName), this._createCommentToken(1), this.state = be.BOGUS_COMMENT, this._stateBogusComment(e);
          break;
        }
        case se.EOF: {
          this._err(ot.eofBeforeTagName), this._emitChars("<"), this._emitEOFToken();
          break;
        }
        default:
          this._err(ot.invalidFirstCharacterOfTagName), this._emitChars("<"), this.state = be.DATA, this._stateData(e);
      }
  }
  // End tag open state
  //------------------------------------------------------------------
  _stateEndTagOpen(e) {
    if (Lb(e))
      this._createEndTagToken(), this.state = be.TAG_NAME, this._stateTagName(e);
    else
      switch (e) {
        case se.GREATER_THAN_SIGN: {
          this._err(ot.missingEndTagName), this.state = be.DATA;
          break;
        }
        case se.EOF: {
          this._err(ot.eofBeforeTagName), this._emitChars("</"), this._emitEOFToken();
          break;
        }
        default:
          this._err(ot.invalidFirstCharacterOfTagName), this._createCommentToken(2), this.state = be.BOGUS_COMMENT, this._stateBogusComment(e);
      }
  }
  // Tag name state
  //------------------------------------------------------------------
  _stateTagName(e) {
    const n = this.currentToken;
    switch (e) {
      case se.SPACE:
      case se.LINE_FEED:
      case se.TABULATION:
      case se.FORM_FEED: {
        this.state = be.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case se.SOLIDUS: {
        this.state = be.SELF_CLOSING_START_TAG;
        break;
      }
      case se.GREATER_THAN_SIGN: {
        this.state = be.DATA, this.emitCurrentTagToken();
        break;
      }
      case se.NULL: {
        this._err(ot.unexpectedNullCharacter), n.tagName += Oi;
        break;
      }
      case se.EOF: {
        this._err(ot.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        n.tagName += String.fromCodePoint(Hw(e) ? pA(e) : e);
    }
  }
  // RCDATA less-than sign state
  //------------------------------------------------------------------
  _stateRcdataLessThanSign(e) {
    e === se.SOLIDUS ? this.state = be.RCDATA_END_TAG_OPEN : (this._emitChars("<"), this.state = be.RCDATA, this._stateRcdata(e));
  }
  // RCDATA end tag open state
  //------------------------------------------------------------------
  _stateRcdataEndTagOpen(e) {
    Lb(e) ? (this.state = be.RCDATA_END_TAG_NAME, this._stateRcdataEndTagName(e)) : (this._emitChars("</"), this.state = be.RCDATA, this._stateRcdata(e));
  }
  handleSpecialEndTag(e) {
    if (!this.preprocessor.startsWith(this.lastStartTagName, !1))
      return !this._ensureHibernation();
    this._createEndTagToken();
    const n = this.currentToken;
    switch (n.tagName = this.lastStartTagName, this.preprocessor.peek(this.lastStartTagName.length)) {
      case se.SPACE:
      case se.LINE_FEED:
      case se.TABULATION:
      case se.FORM_FEED:
        return this._advanceBy(this.lastStartTagName.length), this.state = be.BEFORE_ATTRIBUTE_NAME, !1;
      case se.SOLIDUS:
        return this._advanceBy(this.lastStartTagName.length), this.state = be.SELF_CLOSING_START_TAG, !1;
      case se.GREATER_THAN_SIGN:
        return this._advanceBy(this.lastStartTagName.length), this.emitCurrentTagToken(), this.state = be.DATA, !1;
      default:
        return !this._ensureHibernation();
    }
  }
  // RCDATA end tag name state
  //------------------------------------------------------------------
  _stateRcdataEndTagName(e) {
    this.handleSpecialEndTag(e) && (this._emitChars("</"), this.state = be.RCDATA, this._stateRcdata(e));
  }
  // RAWTEXT less-than sign state
  //------------------------------------------------------------------
  _stateRawtextLessThanSign(e) {
    e === se.SOLIDUS ? this.state = be.RAWTEXT_END_TAG_OPEN : (this._emitChars("<"), this.state = be.RAWTEXT, this._stateRawtext(e));
  }
  // RAWTEXT end tag open state
  //------------------------------------------------------------------
  _stateRawtextEndTagOpen(e) {
    Lb(e) ? (this.state = be.RAWTEXT_END_TAG_NAME, this._stateRawtextEndTagName(e)) : (this._emitChars("</"), this.state = be.RAWTEXT, this._stateRawtext(e));
  }
  // RAWTEXT end tag name state
  //------------------------------------------------------------------
  _stateRawtextEndTagName(e) {
    this.handleSpecialEndTag(e) && (this._emitChars("</"), this.state = be.RAWTEXT, this._stateRawtext(e));
  }
  // Script data less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataLessThanSign(e) {
    switch (e) {
      case se.SOLIDUS: {
        this.state = be.SCRIPT_DATA_END_TAG_OPEN;
        break;
      }
      case se.EXCLAMATION_MARK: {
        this.state = be.SCRIPT_DATA_ESCAPE_START, this._emitChars("<!");
        break;
      }
      default:
        this._emitChars("<"), this.state = be.SCRIPT_DATA, this._stateScriptData(e);
    }
  }
  // Script data end tag open state
  //------------------------------------------------------------------
  _stateScriptDataEndTagOpen(e) {
    Lb(e) ? (this.state = be.SCRIPT_DATA_END_TAG_NAME, this._stateScriptDataEndTagName(e)) : (this._emitChars("</"), this.state = be.SCRIPT_DATA, this._stateScriptData(e));
  }
  // Script data end tag name state
  //------------------------------------------------------------------
  _stateScriptDataEndTagName(e) {
    this.handleSpecialEndTag(e) && (this._emitChars("</"), this.state = be.SCRIPT_DATA, this._stateScriptData(e));
  }
  // Script data escape start state
  //------------------------------------------------------------------
  _stateScriptDataEscapeStart(e) {
    e === se.HYPHEN_MINUS ? (this.state = be.SCRIPT_DATA_ESCAPE_START_DASH, this._emitChars("-")) : (this.state = be.SCRIPT_DATA, this._stateScriptData(e));
  }
  // Script data escape start dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapeStartDash(e) {
    e === se.HYPHEN_MINUS ? (this.state = be.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-")) : (this.state = be.SCRIPT_DATA, this._stateScriptData(e));
  }
  // Script data escaped state
  //------------------------------------------------------------------
  _stateScriptDataEscaped(e) {
    switch (e) {
      case se.HYPHEN_MINUS: {
        this.state = be.SCRIPT_DATA_ESCAPED_DASH, this._emitChars("-");
        break;
      }
      case se.LESS_THAN_SIGN: {
        this.state = be.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case se.NULL: {
        this._err(ot.unexpectedNullCharacter), this._emitChars(Oi);
        break;
      }
      case se.EOF: {
        this._err(ot.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(e);
    }
  }
  // Script data escaped dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapedDash(e) {
    switch (e) {
      case se.HYPHEN_MINUS: {
        this.state = be.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-");
        break;
      }
      case se.LESS_THAN_SIGN: {
        this.state = be.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case se.NULL: {
        this._err(ot.unexpectedNullCharacter), this.state = be.SCRIPT_DATA_ESCAPED, this._emitChars(Oi);
        break;
      }
      case se.EOF: {
        this._err(ot.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = be.SCRIPT_DATA_ESCAPED, this._emitCodePoint(e);
    }
  }
  // Script data escaped dash dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapedDashDash(e) {
    switch (e) {
      case se.HYPHEN_MINUS: {
        this._emitChars("-");
        break;
      }
      case se.LESS_THAN_SIGN: {
        this.state = be.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case se.GREATER_THAN_SIGN: {
        this.state = be.SCRIPT_DATA, this._emitChars(">");
        break;
      }
      case se.NULL: {
        this._err(ot.unexpectedNullCharacter), this.state = be.SCRIPT_DATA_ESCAPED, this._emitChars(Oi);
        break;
      }
      case se.EOF: {
        this._err(ot.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = be.SCRIPT_DATA_ESCAPED, this._emitCodePoint(e);
    }
  }
  // Script data escaped less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataEscapedLessThanSign(e) {
    e === se.SOLIDUS ? this.state = be.SCRIPT_DATA_ESCAPED_END_TAG_OPEN : Lb(e) ? (this._emitChars("<"), this.state = be.SCRIPT_DATA_DOUBLE_ESCAPE_START, this._stateScriptDataDoubleEscapeStart(e)) : (this._emitChars("<"), this.state = be.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(e));
  }
  // Script data escaped end tag open state
  //------------------------------------------------------------------
  _stateScriptDataEscapedEndTagOpen(e) {
    Lb(e) ? (this.state = be.SCRIPT_DATA_ESCAPED_END_TAG_NAME, this._stateScriptDataEscapedEndTagName(e)) : (this._emitChars("</"), this.state = be.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(e));
  }
  // Script data escaped end tag name state
  //------------------------------------------------------------------
  _stateScriptDataEscapedEndTagName(e) {
    this.handleSpecialEndTag(e) && (this._emitChars("</"), this.state = be.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(e));
  }
  // Script data double escape start state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapeStart(e) {
    if (this.preprocessor.startsWith(Vu.SCRIPT, !1) && AJ(this.preprocessor.peek(Vu.SCRIPT.length))) {
      this._emitCodePoint(e);
      for (let n = 0; n < Vu.SCRIPT.length; n++)
        this._emitCodePoint(this._consume());
      this.state = be.SCRIPT_DATA_DOUBLE_ESCAPED;
    } else
      this._ensureHibernation() || (this.state = be.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(e));
  }
  // Script data double escaped state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscaped(e) {
    switch (e) {
      case se.HYPHEN_MINUS: {
        this.state = be.SCRIPT_DATA_DOUBLE_ESCAPED_DASH, this._emitChars("-");
        break;
      }
      case se.LESS_THAN_SIGN: {
        this.state = be.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case se.NULL: {
        this._err(ot.unexpectedNullCharacter), this._emitChars(Oi);
        break;
      }
      case se.EOF: {
        this._err(ot.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(e);
    }
  }
  // Script data double escaped dash state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedDash(e) {
    switch (e) {
      case se.HYPHEN_MINUS: {
        this.state = be.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH, this._emitChars("-");
        break;
      }
      case se.LESS_THAN_SIGN: {
        this.state = be.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case se.NULL: {
        this._err(ot.unexpectedNullCharacter), this.state = be.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(Oi);
        break;
      }
      case se.EOF: {
        this._err(ot.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = be.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(e);
    }
  }
  // Script data double escaped dash dash state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedDashDash(e) {
    switch (e) {
      case se.HYPHEN_MINUS: {
        this._emitChars("-");
        break;
      }
      case se.LESS_THAN_SIGN: {
        this.state = be.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case se.GREATER_THAN_SIGN: {
        this.state = be.SCRIPT_DATA, this._emitChars(">");
        break;
      }
      case se.NULL: {
        this._err(ot.unexpectedNullCharacter), this.state = be.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(Oi);
        break;
      }
      case se.EOF: {
        this._err(ot.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = be.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(e);
    }
  }
  // Script data double escaped less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedLessThanSign(e) {
    e === se.SOLIDUS ? (this.state = be.SCRIPT_DATA_DOUBLE_ESCAPE_END, this._emitChars("/")) : (this.state = be.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(e));
  }
  // Script data double escape end state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapeEnd(e) {
    if (this.preprocessor.startsWith(Vu.SCRIPT, !1) && AJ(this.preprocessor.peek(Vu.SCRIPT.length))) {
      this._emitCodePoint(e);
      for (let n = 0; n < Vu.SCRIPT.length; n++)
        this._emitCodePoint(this._consume());
      this.state = be.SCRIPT_DATA_ESCAPED;
    } else
      this._ensureHibernation() || (this.state = be.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(e));
  }
  // Before attribute name state
  //------------------------------------------------------------------
  _stateBeforeAttributeName(e) {
    switch (e) {
      case se.SPACE:
      case se.LINE_FEED:
      case se.TABULATION:
      case se.FORM_FEED:
        break;
      case se.SOLIDUS:
      case se.GREATER_THAN_SIGN:
      case se.EOF: {
        this.state = be.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(e);
        break;
      }
      case se.EQUALS_SIGN: {
        this._err(ot.unexpectedEqualsSignBeforeAttributeName), this._createAttr("="), this.state = be.ATTRIBUTE_NAME;
        break;
      }
      default:
        this._createAttr(""), this.state = be.ATTRIBUTE_NAME, this._stateAttributeName(e);
    }
  }
  // Attribute name state
  //------------------------------------------------------------------
  _stateAttributeName(e) {
    switch (e) {
      case se.SPACE:
      case se.LINE_FEED:
      case se.TABULATION:
      case se.FORM_FEED:
      case se.SOLIDUS:
      case se.GREATER_THAN_SIGN:
      case se.EOF: {
        this._leaveAttrName(), this.state = be.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(e);
        break;
      }
      case se.EQUALS_SIGN: {
        this._leaveAttrName(), this.state = be.BEFORE_ATTRIBUTE_VALUE;
        break;
      }
      case se.QUOTATION_MARK:
      case se.APOSTROPHE:
      case se.LESS_THAN_SIGN: {
        this._err(ot.unexpectedCharacterInAttributeName), this.currentAttr.name += String.fromCodePoint(e);
        break;
      }
      case se.NULL: {
        this._err(ot.unexpectedNullCharacter), this.currentAttr.name += Oi;
        break;
      }
      default:
        this.currentAttr.name += String.fromCodePoint(Hw(e) ? pA(e) : e);
    }
  }
  // After attribute name state
  //------------------------------------------------------------------
  _stateAfterAttributeName(e) {
    switch (e) {
      case se.SPACE:
      case se.LINE_FEED:
      case se.TABULATION:
      case se.FORM_FEED:
        break;
      case se.SOLIDUS: {
        this.state = be.SELF_CLOSING_START_TAG;
        break;
      }
      case se.EQUALS_SIGN: {
        this.state = be.BEFORE_ATTRIBUTE_VALUE;
        break;
      }
      case se.GREATER_THAN_SIGN: {
        this.state = be.DATA, this.emitCurrentTagToken();
        break;
      }
      case se.EOF: {
        this._err(ot.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._createAttr(""), this.state = be.ATTRIBUTE_NAME, this._stateAttributeName(e);
    }
  }
  // Before attribute value state
  //------------------------------------------------------------------
  _stateBeforeAttributeValue(e) {
    switch (e) {
      case se.SPACE:
      case se.LINE_FEED:
      case se.TABULATION:
      case se.FORM_FEED:
        break;
      case se.QUOTATION_MARK: {
        this.state = be.ATTRIBUTE_VALUE_DOUBLE_QUOTED;
        break;
      }
      case se.APOSTROPHE: {
        this.state = be.ATTRIBUTE_VALUE_SINGLE_QUOTED;
        break;
      }
      case se.GREATER_THAN_SIGN: {
        this._err(ot.missingAttributeValue), this.state = be.DATA, this.emitCurrentTagToken();
        break;
      }
      default:
        this.state = be.ATTRIBUTE_VALUE_UNQUOTED, this._stateAttributeValueUnquoted(e);
    }
  }
  // Attribute value (double-quoted) state
  //------------------------------------------------------------------
  _stateAttributeValueDoubleQuoted(e) {
    switch (e) {
      case se.QUOTATION_MARK: {
        this.state = be.AFTER_ATTRIBUTE_VALUE_QUOTED;
        break;
      }
      case se.AMPERSAND: {
        this.returnState = be.ATTRIBUTE_VALUE_DOUBLE_QUOTED, this.state = be.CHARACTER_REFERENCE;
        break;
      }
      case se.NULL: {
        this._err(ot.unexpectedNullCharacter), this.currentAttr.value += Oi;
        break;
      }
      case se.EOF: {
        this._err(ot.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(e);
    }
  }
  // Attribute value (single-quoted) state
  //------------------------------------------------------------------
  _stateAttributeValueSingleQuoted(e) {
    switch (e) {
      case se.APOSTROPHE: {
        this.state = be.AFTER_ATTRIBUTE_VALUE_QUOTED;
        break;
      }
      case se.AMPERSAND: {
        this.returnState = be.ATTRIBUTE_VALUE_SINGLE_QUOTED, this.state = be.CHARACTER_REFERENCE;
        break;
      }
      case se.NULL: {
        this._err(ot.unexpectedNullCharacter), this.currentAttr.value += Oi;
        break;
      }
      case se.EOF: {
        this._err(ot.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(e);
    }
  }
  // Attribute value (unquoted) state
  //------------------------------------------------------------------
  _stateAttributeValueUnquoted(e) {
    switch (e) {
      case se.SPACE:
      case se.LINE_FEED:
      case se.TABULATION:
      case se.FORM_FEED: {
        this._leaveAttrValue(), this.state = be.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case se.AMPERSAND: {
        this.returnState = be.ATTRIBUTE_VALUE_UNQUOTED, this.state = be.CHARACTER_REFERENCE;
        break;
      }
      case se.GREATER_THAN_SIGN: {
        this._leaveAttrValue(), this.state = be.DATA, this.emitCurrentTagToken();
        break;
      }
      case se.NULL: {
        this._err(ot.unexpectedNullCharacter), this.currentAttr.value += Oi;
        break;
      }
      case se.QUOTATION_MARK:
      case se.APOSTROPHE:
      case se.LESS_THAN_SIGN:
      case se.EQUALS_SIGN:
      case se.GRAVE_ACCENT: {
        this._err(ot.unexpectedCharacterInUnquotedAttributeValue), this.currentAttr.value += String.fromCodePoint(e);
        break;
      }
      case se.EOF: {
        this._err(ot.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(e);
    }
  }
  // After attribute value (quoted) state
  //------------------------------------------------------------------
  _stateAfterAttributeValueQuoted(e) {
    switch (e) {
      case se.SPACE:
      case se.LINE_FEED:
      case se.TABULATION:
      case se.FORM_FEED: {
        this._leaveAttrValue(), this.state = be.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case se.SOLIDUS: {
        this._leaveAttrValue(), this.state = be.SELF_CLOSING_START_TAG;
        break;
      }
      case se.GREATER_THAN_SIGN: {
        this._leaveAttrValue(), this.state = be.DATA, this.emitCurrentTagToken();
        break;
      }
      case se.EOF: {
        this._err(ot.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._err(ot.missingWhitespaceBetweenAttributes), this.state = be.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(e);
    }
  }
  // Self-closing start tag state
  //------------------------------------------------------------------
  _stateSelfClosingStartTag(e) {
    switch (e) {
      case se.GREATER_THAN_SIGN: {
        const n = this.currentToken;
        n.selfClosing = !0, this.state = be.DATA, this.emitCurrentTagToken();
        break;
      }
      case se.EOF: {
        this._err(ot.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._err(ot.unexpectedSolidusInTag), this.state = be.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(e);
    }
  }
  // Bogus comment state
  //------------------------------------------------------------------
  _stateBogusComment(e) {
    const n = this.currentToken;
    switch (e) {
      case se.GREATER_THAN_SIGN: {
        this.state = be.DATA, this.emitCurrentComment(n);
        break;
      }
      case se.EOF: {
        this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      case se.NULL: {
        this._err(ot.unexpectedNullCharacter), n.data += Oi;
        break;
      }
      default:
        n.data += String.fromCodePoint(e);
    }
  }
  // Markup declaration open state
  //------------------------------------------------------------------
  _stateMarkupDeclarationOpen(e) {
    this._consumeSequenceIfMatch(Vu.DASH_DASH, !0) ? (this._createCommentToken(Vu.DASH_DASH.length + 1), this.state = be.COMMENT_START) : this._consumeSequenceIfMatch(Vu.DOCTYPE, !1) ? (this.currentLocation = this.getCurrentLocation(Vu.DOCTYPE.length + 1), this.state = be.DOCTYPE) : this._consumeSequenceIfMatch(Vu.CDATA_START, !0) ? this.inForeignNode ? this.state = be.CDATA_SECTION : (this._err(ot.cdataInHtmlContent), this._createCommentToken(Vu.CDATA_START.length + 1), this.currentToken.data = "[CDATA[", this.state = be.BOGUS_COMMENT) : this._ensureHibernation() || (this._err(ot.incorrectlyOpenedComment), this._createCommentToken(2), this.state = be.BOGUS_COMMENT, this._stateBogusComment(e));
  }
  // Comment start state
  //------------------------------------------------------------------
  _stateCommentStart(e) {
    switch (e) {
      case se.HYPHEN_MINUS: {
        this.state = be.COMMENT_START_DASH;
        break;
      }
      case se.GREATER_THAN_SIGN: {
        this._err(ot.abruptClosingOfEmptyComment), this.state = be.DATA;
        const n = this.currentToken;
        this.emitCurrentComment(n);
        break;
      }
      default:
        this.state = be.COMMENT, this._stateComment(e);
    }
  }
  // Comment start dash state
  //------------------------------------------------------------------
  _stateCommentStartDash(e) {
    const n = this.currentToken;
    switch (e) {
      case se.HYPHEN_MINUS: {
        this.state = be.COMMENT_END;
        break;
      }
      case se.GREATER_THAN_SIGN: {
        this._err(ot.abruptClosingOfEmptyComment), this.state = be.DATA, this.emitCurrentComment(n);
        break;
      }
      case se.EOF: {
        this._err(ot.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += "-", this.state = be.COMMENT, this._stateComment(e);
    }
  }
  // Comment state
  //------------------------------------------------------------------
  _stateComment(e) {
    const n = this.currentToken;
    switch (e) {
      case se.HYPHEN_MINUS: {
        this.state = be.COMMENT_END_DASH;
        break;
      }
      case se.LESS_THAN_SIGN: {
        n.data += "<", this.state = be.COMMENT_LESS_THAN_SIGN;
        break;
      }
      case se.NULL: {
        this._err(ot.unexpectedNullCharacter), n.data += Oi;
        break;
      }
      case se.EOF: {
        this._err(ot.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += String.fromCodePoint(e);
    }
  }
  // Comment less-than sign state
  //------------------------------------------------------------------
  _stateCommentLessThanSign(e) {
    const n = this.currentToken;
    switch (e) {
      case se.EXCLAMATION_MARK: {
        n.data += "!", this.state = be.COMMENT_LESS_THAN_SIGN_BANG;
        break;
      }
      case se.LESS_THAN_SIGN: {
        n.data += "<";
        break;
      }
      default:
        this.state = be.COMMENT, this._stateComment(e);
    }
  }
  // Comment less-than sign bang state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBang(e) {
    e === se.HYPHEN_MINUS ? this.state = be.COMMENT_LESS_THAN_SIGN_BANG_DASH : (this.state = be.COMMENT, this._stateComment(e));
  }
  // Comment less-than sign bang dash state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBangDash(e) {
    e === se.HYPHEN_MINUS ? this.state = be.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH : (this.state = be.COMMENT_END_DASH, this._stateCommentEndDash(e));
  }
  // Comment less-than sign bang dash dash state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBangDashDash(e) {
    e !== se.GREATER_THAN_SIGN && e !== se.EOF && this._err(ot.nestedComment), this.state = be.COMMENT_END, this._stateCommentEnd(e);
  }
  // Comment end dash state
  //------------------------------------------------------------------
  _stateCommentEndDash(e) {
    const n = this.currentToken;
    switch (e) {
      case se.HYPHEN_MINUS: {
        this.state = be.COMMENT_END;
        break;
      }
      case se.EOF: {
        this._err(ot.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += "-", this.state = be.COMMENT, this._stateComment(e);
    }
  }
  // Comment end state
  //------------------------------------------------------------------
  _stateCommentEnd(e) {
    const n = this.currentToken;
    switch (e) {
      case se.GREATER_THAN_SIGN: {
        this.state = be.DATA, this.emitCurrentComment(n);
        break;
      }
      case se.EXCLAMATION_MARK: {
        this.state = be.COMMENT_END_BANG;
        break;
      }
      case se.HYPHEN_MINUS: {
        n.data += "-";
        break;
      }
      case se.EOF: {
        this._err(ot.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += "--", this.state = be.COMMENT, this._stateComment(e);
    }
  }
  // Comment end bang state
  //------------------------------------------------------------------
  _stateCommentEndBang(e) {
    const n = this.currentToken;
    switch (e) {
      case se.HYPHEN_MINUS: {
        n.data += "--!", this.state = be.COMMENT_END_DASH;
        break;
      }
      case se.GREATER_THAN_SIGN: {
        this._err(ot.incorrectlyClosedComment), this.state = be.DATA, this.emitCurrentComment(n);
        break;
      }
      case se.EOF: {
        this._err(ot.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += "--!", this.state = be.COMMENT, this._stateComment(e);
    }
  }
  // DOCTYPE state
  //------------------------------------------------------------------
  _stateDoctype(e) {
    switch (e) {
      case se.SPACE:
      case se.LINE_FEED:
      case se.TABULATION:
      case se.FORM_FEED: {
        this.state = be.BEFORE_DOCTYPE_NAME;
        break;
      }
      case se.GREATER_THAN_SIGN: {
        this.state = be.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(e);
        break;
      }
      case se.EOF: {
        this._err(ot.eofInDoctype), this._createDoctypeToken(null);
        const n = this.currentToken;
        n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(ot.missingWhitespaceBeforeDoctypeName), this.state = be.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(e);
    }
  }
  // Before DOCTYPE name state
  //------------------------------------------------------------------
  _stateBeforeDoctypeName(e) {
    if (Hw(e))
      this._createDoctypeToken(String.fromCharCode(pA(e))), this.state = be.DOCTYPE_NAME;
    else
      switch (e) {
        case se.SPACE:
        case se.LINE_FEED:
        case se.TABULATION:
        case se.FORM_FEED:
          break;
        case se.NULL: {
          this._err(ot.unexpectedNullCharacter), this._createDoctypeToken(Oi), this.state = be.DOCTYPE_NAME;
          break;
        }
        case se.GREATER_THAN_SIGN: {
          this._err(ot.missingDoctypeName), this._createDoctypeToken(null);
          const n = this.currentToken;
          n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = be.DATA;
          break;
        }
        case se.EOF: {
          this._err(ot.eofInDoctype), this._createDoctypeToken(null);
          const n = this.currentToken;
          n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
        default:
          this._createDoctypeToken(String.fromCodePoint(e)), this.state = be.DOCTYPE_NAME;
      }
  }
  // DOCTYPE name state
  //------------------------------------------------------------------
  _stateDoctypeName(e) {
    const n = this.currentToken;
    switch (e) {
      case se.SPACE:
      case se.LINE_FEED:
      case se.TABULATION:
      case se.FORM_FEED: {
        this.state = be.AFTER_DOCTYPE_NAME;
        break;
      }
      case se.GREATER_THAN_SIGN: {
        this.state = be.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case se.NULL: {
        this._err(ot.unexpectedNullCharacter), n.name += Oi;
        break;
      }
      case se.EOF: {
        this._err(ot.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.name += String.fromCodePoint(Hw(e) ? pA(e) : e);
    }
  }
  // After DOCTYPE name state
  //------------------------------------------------------------------
  _stateAfterDoctypeName(e) {
    const n = this.currentToken;
    switch (e) {
      case se.SPACE:
      case se.LINE_FEED:
      case se.TABULATION:
      case se.FORM_FEED:
        break;
      case se.GREATER_THAN_SIGN: {
        this.state = be.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case se.EOF: {
        this._err(ot.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._consumeSequenceIfMatch(Vu.PUBLIC, !1) ? this.state = be.AFTER_DOCTYPE_PUBLIC_KEYWORD : this._consumeSequenceIfMatch(Vu.SYSTEM, !1) ? this.state = be.AFTER_DOCTYPE_SYSTEM_KEYWORD : this._ensureHibernation() || (this._err(ot.invalidCharacterSequenceAfterDoctypeName), n.forceQuirks = !0, this.state = be.BOGUS_DOCTYPE, this._stateBogusDoctype(e));
    }
  }
  // After DOCTYPE public keyword state
  //------------------------------------------------------------------
  _stateAfterDoctypePublicKeyword(e) {
    const n = this.currentToken;
    switch (e) {
      case se.SPACE:
      case se.LINE_FEED:
      case se.TABULATION:
      case se.FORM_FEED: {
        this.state = be.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case se.QUOTATION_MARK: {
        this._err(ot.missingWhitespaceAfterDoctypePublicKeyword), n.publicId = "", this.state = be.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case se.APOSTROPHE: {
        this._err(ot.missingWhitespaceAfterDoctypePublicKeyword), n.publicId = "", this.state = be.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case se.GREATER_THAN_SIGN: {
        this._err(ot.missingDoctypePublicIdentifier), n.forceQuirks = !0, this.state = be.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case se.EOF: {
        this._err(ot.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(ot.missingQuoteBeforeDoctypePublicIdentifier), n.forceQuirks = !0, this.state = be.BOGUS_DOCTYPE, this._stateBogusDoctype(e);
    }
  }
  // Before DOCTYPE public identifier state
  //------------------------------------------------------------------
  _stateBeforeDoctypePublicIdentifier(e) {
    const n = this.currentToken;
    switch (e) {
      case se.SPACE:
      case se.LINE_FEED:
      case se.TABULATION:
      case se.FORM_FEED:
        break;
      case se.QUOTATION_MARK: {
        n.publicId = "", this.state = be.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case se.APOSTROPHE: {
        n.publicId = "", this.state = be.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case se.GREATER_THAN_SIGN: {
        this._err(ot.missingDoctypePublicIdentifier), n.forceQuirks = !0, this.state = be.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case se.EOF: {
        this._err(ot.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(ot.missingQuoteBeforeDoctypePublicIdentifier), n.forceQuirks = !0, this.state = be.BOGUS_DOCTYPE, this._stateBogusDoctype(e);
    }
  }
  // DOCTYPE public identifier (double-quoted) state
  //------------------------------------------------------------------
  _stateDoctypePublicIdentifierDoubleQuoted(e) {
    const n = this.currentToken;
    switch (e) {
      case se.QUOTATION_MARK: {
        this.state = be.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case se.NULL: {
        this._err(ot.unexpectedNullCharacter), n.publicId += Oi;
        break;
      }
      case se.GREATER_THAN_SIGN: {
        this._err(ot.abruptDoctypePublicIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = be.DATA;
        break;
      }
      case se.EOF: {
        this._err(ot.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.publicId += String.fromCodePoint(e);
    }
  }
  // DOCTYPE public identifier (single-quoted) state
  //------------------------------------------------------------------
  _stateDoctypePublicIdentifierSingleQuoted(e) {
    const n = this.currentToken;
    switch (e) {
      case se.APOSTROPHE: {
        this.state = be.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case se.NULL: {
        this._err(ot.unexpectedNullCharacter), n.publicId += Oi;
        break;
      }
      case se.GREATER_THAN_SIGN: {
        this._err(ot.abruptDoctypePublicIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = be.DATA;
        break;
      }
      case se.EOF: {
        this._err(ot.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.publicId += String.fromCodePoint(e);
    }
  }
  // After DOCTYPE public identifier state
  //------------------------------------------------------------------
  _stateAfterDoctypePublicIdentifier(e) {
    const n = this.currentToken;
    switch (e) {
      case se.SPACE:
      case se.LINE_FEED:
      case se.TABULATION:
      case se.FORM_FEED: {
        this.state = be.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS;
        break;
      }
      case se.GREATER_THAN_SIGN: {
        this.state = be.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case se.QUOTATION_MARK: {
        this._err(ot.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), n.systemId = "", this.state = be.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case se.APOSTROPHE: {
        this._err(ot.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), n.systemId = "", this.state = be.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case se.EOF: {
        this._err(ot.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(ot.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = be.BOGUS_DOCTYPE, this._stateBogusDoctype(e);
    }
  }
  // Between DOCTYPE public and system identifiers state
  //------------------------------------------------------------------
  _stateBetweenDoctypePublicAndSystemIdentifiers(e) {
    const n = this.currentToken;
    switch (e) {
      case se.SPACE:
      case se.LINE_FEED:
      case se.TABULATION:
      case se.FORM_FEED:
        break;
      case se.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(n), this.state = be.DATA;
        break;
      }
      case se.QUOTATION_MARK: {
        n.systemId = "", this.state = be.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case se.APOSTROPHE: {
        n.systemId = "", this.state = be.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case se.EOF: {
        this._err(ot.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(ot.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = be.BOGUS_DOCTYPE, this._stateBogusDoctype(e);
    }
  }
  // After DOCTYPE system keyword state
  //------------------------------------------------------------------
  _stateAfterDoctypeSystemKeyword(e) {
    const n = this.currentToken;
    switch (e) {
      case se.SPACE:
      case se.LINE_FEED:
      case se.TABULATION:
      case se.FORM_FEED: {
        this.state = be.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case se.QUOTATION_MARK: {
        this._err(ot.missingWhitespaceAfterDoctypeSystemKeyword), n.systemId = "", this.state = be.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case se.APOSTROPHE: {
        this._err(ot.missingWhitespaceAfterDoctypeSystemKeyword), n.systemId = "", this.state = be.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case se.GREATER_THAN_SIGN: {
        this._err(ot.missingDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = be.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case se.EOF: {
        this._err(ot.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(ot.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = be.BOGUS_DOCTYPE, this._stateBogusDoctype(e);
    }
  }
  // Before DOCTYPE system identifier state
  //------------------------------------------------------------------
  _stateBeforeDoctypeSystemIdentifier(e) {
    const n = this.currentToken;
    switch (e) {
      case se.SPACE:
      case se.LINE_FEED:
      case se.TABULATION:
      case se.FORM_FEED:
        break;
      case se.QUOTATION_MARK: {
        n.systemId = "", this.state = be.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case se.APOSTROPHE: {
        n.systemId = "", this.state = be.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case se.GREATER_THAN_SIGN: {
        this._err(ot.missingDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = be.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case se.EOF: {
        this._err(ot.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(ot.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = be.BOGUS_DOCTYPE, this._stateBogusDoctype(e);
    }
  }
  // DOCTYPE system identifier (double-quoted) state
  //------------------------------------------------------------------
  _stateDoctypeSystemIdentifierDoubleQuoted(e) {
    const n = this.currentToken;
    switch (e) {
      case se.QUOTATION_MARK: {
        this.state = be.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case se.NULL: {
        this._err(ot.unexpectedNullCharacter), n.systemId += Oi;
        break;
      }
      case se.GREATER_THAN_SIGN: {
        this._err(ot.abruptDoctypeSystemIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = be.DATA;
        break;
      }
      case se.EOF: {
        this._err(ot.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.systemId += String.fromCodePoint(e);
    }
  }
  // DOCTYPE system identifier (single-quoted) state
  //------------------------------------------------------------------
  _stateDoctypeSystemIdentifierSingleQuoted(e) {
    const n = this.currentToken;
    switch (e) {
      case se.APOSTROPHE: {
        this.state = be.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case se.NULL: {
        this._err(ot.unexpectedNullCharacter), n.systemId += Oi;
        break;
      }
      case se.GREATER_THAN_SIGN: {
        this._err(ot.abruptDoctypeSystemIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = be.DATA;
        break;
      }
      case se.EOF: {
        this._err(ot.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.systemId += String.fromCodePoint(e);
    }
  }
  // After DOCTYPE system identifier state
  //------------------------------------------------------------------
  _stateAfterDoctypeSystemIdentifier(e) {
    const n = this.currentToken;
    switch (e) {
      case se.SPACE:
      case se.LINE_FEED:
      case se.TABULATION:
      case se.FORM_FEED:
        break;
      case se.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(n), this.state = be.DATA;
        break;
      }
      case se.EOF: {
        this._err(ot.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(ot.unexpectedCharacterAfterDoctypeSystemIdentifier), this.state = be.BOGUS_DOCTYPE, this._stateBogusDoctype(e);
    }
  }
  // Bogus DOCTYPE state
  //------------------------------------------------------------------
  _stateBogusDoctype(e) {
    const n = this.currentToken;
    switch (e) {
      case se.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(n), this.state = be.DATA;
        break;
      }
      case se.NULL: {
        this._err(ot.unexpectedNullCharacter);
        break;
      }
      case se.EOF: {
        this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
    }
  }
  // CDATA section state
  //------------------------------------------------------------------
  _stateCdataSection(e) {
    switch (e) {
      case se.RIGHT_SQUARE_BRACKET: {
        this.state = be.CDATA_SECTION_BRACKET;
        break;
      }
      case se.EOF: {
        this._err(ot.eofInCdata), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(e);
    }
  }
  // CDATA section bracket state
  //------------------------------------------------------------------
  _stateCdataSectionBracket(e) {
    e === se.RIGHT_SQUARE_BRACKET ? this.state = be.CDATA_SECTION_END : (this._emitChars("]"), this.state = be.CDATA_SECTION, this._stateCdataSection(e));
  }
  // CDATA section end state
  //------------------------------------------------------------------
  _stateCdataSectionEnd(e) {
    switch (e) {
      case se.GREATER_THAN_SIGN: {
        this.state = be.DATA;
        break;
      }
      case se.RIGHT_SQUARE_BRACKET: {
        this._emitChars("]");
        break;
      }
      default:
        this._emitChars("]]"), this.state = be.CDATA_SECTION, this._stateCdataSection(e);
    }
  }
  // Character reference state
  //------------------------------------------------------------------
  _stateCharacterReference(e) {
    e === se.NUMBER_SIGN ? this.state = be.NUMERIC_CHARACTER_REFERENCE : g5(e) ? (this.state = be.NAMED_CHARACTER_REFERENCE, this._stateNamedCharacterReference(e)) : (this._flushCodePointConsumedAsCharacterReference(se.AMPERSAND), this._reconsumeInState(this.returnState, e));
  }
  // Named character reference state
  //------------------------------------------------------------------
  _stateNamedCharacterReference(e) {
    const n = this._matchNamedCharacterReference(e);
    if (!this._ensureHibernation())
      if (n) {
        for (let r = 0; r < n.length; r++)
          this._flushCodePointConsumedAsCharacterReference(n[r]);
        this.state = this.returnState;
      } else
        this._flushCodePointConsumedAsCharacterReference(se.AMPERSAND), this.state = be.AMBIGUOUS_AMPERSAND;
  }
  // Ambiguos ampersand state
  //------------------------------------------------------------------
  _stateAmbiguousAmpersand(e) {
    g5(e) ? this._flushCodePointConsumedAsCharacterReference(e) : (e === se.SEMICOLON && this._err(ot.unknownNamedCharacterReference), this._reconsumeInState(this.returnState, e));
  }
  // Numeric character reference state
  //------------------------------------------------------------------
  _stateNumericCharacterReference(e) {
    this.charRefCode = 0, e === se.LATIN_SMALL_X || e === se.LATIN_CAPITAL_X ? this.state = be.HEXADEMICAL_CHARACTER_REFERENCE_START : hT(e) ? (this.state = be.DECIMAL_CHARACTER_REFERENCE, this._stateDecimalCharacterReference(e)) : (this._err(ot.absenceOfDigitsInNumericCharacterReference), this._flushCodePointConsumedAsCharacterReference(se.AMPERSAND), this._flushCodePointConsumedAsCharacterReference(se.NUMBER_SIGN), this._reconsumeInState(this.returnState, e));
  }
  // Hexademical character reference start state
  //------------------------------------------------------------------
  _stateHexademicalCharacterReferenceStart(e) {
    z9e(e) ? (this.state = be.HEXADEMICAL_CHARACTER_REFERENCE, this._stateHexademicalCharacterReference(e)) : (this._err(ot.absenceOfDigitsInNumericCharacterReference), this._flushCodePointConsumedAsCharacterReference(se.AMPERSAND), this._flushCodePointConsumedAsCharacterReference(se.NUMBER_SIGN), this._unconsume(2), this.state = this.returnState);
  }
  // Hexademical character reference state
  //------------------------------------------------------------------
  _stateHexademicalCharacterReference(e) {
    Nue(e) ? this.charRefCode = this.charRefCode * 16 + e - 55 : Pue(e) ? this.charRefCode = this.charRefCode * 16 + e - 87 : hT(e) ? this.charRefCode = this.charRefCode * 16 + e - 48 : e === se.SEMICOLON ? this.state = be.NUMERIC_CHARACTER_REFERENCE_END : (this._err(ot.missingSemicolonAfterCharacterReference), this.state = be.NUMERIC_CHARACTER_REFERENCE_END, this._stateNumericCharacterReferenceEnd(e));
  }
  // Decimal character reference state
  //------------------------------------------------------------------
  _stateDecimalCharacterReference(e) {
    hT(e) ? this.charRefCode = this.charRefCode * 10 + e - 48 : e === se.SEMICOLON ? this.state = be.NUMERIC_CHARACTER_REFERENCE_END : (this._err(ot.missingSemicolonAfterCharacterReference), this.state = be.NUMERIC_CHARACTER_REFERENCE_END, this._stateNumericCharacterReferenceEnd(e));
  }
  // Numeric character reference end state
  //------------------------------------------------------------------
  _stateNumericCharacterReferenceEnd(e) {
    if (this.charRefCode === se.NULL)
      this._err(ot.nullCharacterReference), this.charRefCode = se.REPLACEMENT_CHARACTER;
    else if (this.charRefCode > 1114111)
      this._err(ot.characterReferenceOutsideUnicodeRange), this.charRefCode = se.REPLACEMENT_CHARACTER;
    else if (Cue(this.charRefCode))
      this._err(ot.surrogateCharacterReference), this.charRefCode = se.REPLACEMENT_CHARACTER;
    else if (Aue(this.charRefCode))
      this._err(ot.noncharacterCharacterReference);
    else if (xue(this.charRefCode) || this.charRefCode === se.CARRIAGE_RETURN) {
      this._err(ot.controlCharacterReference);
      const n = B9e.get(this.charRefCode);
      n !== void 0 && (this.charRefCode = n);
    }
    this._flushCodePointConsumedAsCharacterReference(this.charRefCode), this._reconsumeInState(this.returnState, e);
  }
}
const Mue = /* @__PURE__ */ new Set([L.DD, L.DT, L.LI, L.OPTGROUP, L.OPTION, L.P, L.RB, L.RP, L.RT, L.RTC]), kJ = /* @__PURE__ */ new Set([
  ...Mue,
  L.CAPTION,
  L.COLGROUP,
  L.TBODY,
  L.TD,
  L.TFOOT,
  L.TH,
  L.THEAD,
  L.TR
]), hA = /* @__PURE__ */ new Map([
  [L.APPLET, vt.HTML],
  [L.CAPTION, vt.HTML],
  [L.HTML, vt.HTML],
  [L.MARQUEE, vt.HTML],
  [L.OBJECT, vt.HTML],
  [L.TABLE, vt.HTML],
  [L.TD, vt.HTML],
  [L.TEMPLATE, vt.HTML],
  [L.TH, vt.HTML],
  [L.ANNOTATION_XML, vt.MATHML],
  [L.MI, vt.MATHML],
  [L.MN, vt.MATHML],
  [L.MO, vt.MATHML],
  [L.MS, vt.MATHML],
  [L.MTEXT, vt.MATHML],
  [L.DESC, vt.SVG],
  [L.FOREIGN_OBJECT, vt.SVG],
  [L.TITLE, vt.SVG]
]), Q9e = [L.H1, L.H2, L.H3, L.H4, L.H5, L.H6], j9e = [L.TR, L.TEMPLATE, L.HTML], G9e = [L.TBODY, L.TFOOT, L.THEAD, L.TEMPLATE, L.HTML], V9e = [L.TABLE, L.TEMPLATE, L.HTML], Y9e = [L.TD, L.TH];
class Z9e {
  get currentTmplContentOrNode() {
    return this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : this.current;
  }
  constructor(e, n, r) {
    this.treeAdapter = n, this.handler = r, this.items = [], this.tagIDs = [], this.stackTop = -1, this.tmplCount = 0, this.currentTagId = L.UNKNOWN, this.current = e;
  }
  //Index of element
  _indexOf(e) {
    return this.items.lastIndexOf(e, this.stackTop);
  }
  //Update current element
  _isInTemplate() {
    return this.currentTagId === L.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === vt.HTML;
  }
  _updateCurrentElement() {
    this.current = this.items[this.stackTop], this.currentTagId = this.tagIDs[this.stackTop];
  }
  //Mutations
  push(e, n) {
    this.stackTop++, this.items[this.stackTop] = e, this.current = e, this.tagIDs[this.stackTop] = n, this.currentTagId = n, this._isInTemplate() && this.tmplCount++, this.handler.onItemPush(e, n, !0);
  }
  pop() {
    const e = this.current;
    this.tmplCount > 0 && this._isInTemplate() && this.tmplCount--, this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(e, !0);
  }
  replace(e, n) {
    const r = this._indexOf(e);
    this.items[r] = n, r === this.stackTop && (this.current = n);
  }
  insertAfter(e, n, r) {
    const a = this._indexOf(e) + 1;
    this.items.splice(a, 0, n), this.tagIDs.splice(a, 0, r), this.stackTop++, a === this.stackTop && this._updateCurrentElement(), this.handler.onItemPush(this.current, this.currentTagId, a === this.stackTop);
  }
  popUntilTagNamePopped(e) {
    let n = this.stackTop + 1;
    do
      n = this.tagIDs.lastIndexOf(e, n - 1);
    while (n > 0 && this.treeAdapter.getNamespaceURI(this.items[n]) !== vt.HTML);
    this.shortenToLength(n < 0 ? 0 : n);
  }
  shortenToLength(e) {
    for (; this.stackTop >= e; ) {
      const n = this.current;
      this.tmplCount > 0 && this._isInTemplate() && (this.tmplCount -= 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(n, this.stackTop < e);
    }
  }
  popUntilElementPopped(e) {
    const n = this._indexOf(e);
    this.shortenToLength(n < 0 ? 0 : n);
  }
  popUntilPopped(e, n) {
    const r = this._indexOfTagNames(e, n);
    this.shortenToLength(r < 0 ? 0 : r);
  }
  popUntilNumberedHeaderPopped() {
    this.popUntilPopped(Q9e, vt.HTML);
  }
  popUntilTableCellPopped() {
    this.popUntilPopped(Y9e, vt.HTML);
  }
  popAllUpToHtmlElement() {
    this.tmplCount = 0, this.shortenToLength(1);
  }
  _indexOfTagNames(e, n) {
    for (let r = this.stackTop; r >= 0; r--)
      if (e.includes(this.tagIDs[r]) && this.treeAdapter.getNamespaceURI(this.items[r]) === n)
        return r;
    return -1;
  }
  clearBackTo(e, n) {
    const r = this._indexOfTagNames(e, n);
    this.shortenToLength(r + 1);
  }
  clearBackToTableContext() {
    this.clearBackTo(V9e, vt.HTML);
  }
  clearBackToTableBodyContext() {
    this.clearBackTo(G9e, vt.HTML);
  }
  clearBackToTableRowContext() {
    this.clearBackTo(j9e, vt.HTML);
  }
  remove(e) {
    const n = this._indexOf(e);
    n >= 0 && (n === this.stackTop ? this.pop() : (this.items.splice(n, 1), this.tagIDs.splice(n, 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(e, !1)));
  }
  //Search
  tryPeekProperlyNestedBodyElement() {
    return this.stackTop >= 1 && this.tagIDs[1] === L.BODY ? this.items[1] : null;
  }
  contains(e) {
    return this._indexOf(e) > -1;
  }
  getCommonAncestor(e) {
    const n = this._indexOf(e) - 1;
    return n >= 0 ? this.items[n] : null;
  }
  isRootHtmlElementCurrent() {
    return this.stackTop === 0 && this.tagIDs[0] === L.HTML;
  }
  //Element in scope
  hasInScope(e) {
    for (let n = this.stackTop; n >= 0; n--) {
      const r = this.tagIDs[n], a = this.treeAdapter.getNamespaceURI(this.items[n]);
      if (r === e && a === vt.HTML)
        return !0;
      if (hA.get(r) === a)
        return !1;
    }
    return !0;
  }
  hasNumberedHeaderInScope() {
    for (let e = this.stackTop; e >= 0; e--) {
      const n = this.tagIDs[e], r = this.treeAdapter.getNamespaceURI(this.items[e]);
      if (Due(n) && r === vt.HTML)
        return !0;
      if (hA.get(n) === r)
        return !1;
    }
    return !0;
  }
  hasInListItemScope(e) {
    for (let n = this.stackTop; n >= 0; n--) {
      const r = this.tagIDs[n], a = this.treeAdapter.getNamespaceURI(this.items[n]);
      if (r === e && a === vt.HTML)
        return !0;
      if ((r === L.UL || r === L.OL) && a === vt.HTML || hA.get(r) === a)
        return !1;
    }
    return !0;
  }
  hasInButtonScope(e) {
    for (let n = this.stackTop; n >= 0; n--) {
      const r = this.tagIDs[n], a = this.treeAdapter.getNamespaceURI(this.items[n]);
      if (r === e && a === vt.HTML)
        return !0;
      if (r === L.BUTTON && a === vt.HTML || hA.get(r) === a)
        return !1;
    }
    return !0;
  }
  hasInTableScope(e) {
    for (let n = this.stackTop; n >= 0; n--) {
      const r = this.tagIDs[n];
      if (this.treeAdapter.getNamespaceURI(this.items[n]) === vt.HTML) {
        if (r === e)
          return !0;
        if (r === L.TABLE || r === L.TEMPLATE || r === L.HTML)
          return !1;
      }
    }
    return !0;
  }
  hasTableBodyContextInTableScope() {
    for (let e = this.stackTop; e >= 0; e--) {
      const n = this.tagIDs[e];
      if (this.treeAdapter.getNamespaceURI(this.items[e]) === vt.HTML) {
        if (n === L.TBODY || n === L.THEAD || n === L.TFOOT)
          return !0;
        if (n === L.TABLE || n === L.HTML)
          return !1;
      }
    }
    return !0;
  }
  hasInSelectScope(e) {
    for (let n = this.stackTop; n >= 0; n--) {
      const r = this.tagIDs[n];
      if (this.treeAdapter.getNamespaceURI(this.items[n]) === vt.HTML) {
        if (r === e)
          return !0;
        if (r !== L.OPTION && r !== L.OPTGROUP)
          return !1;
      }
    }
    return !0;
  }
  //Implied end tags
  generateImpliedEndTags() {
    for (; Mue.has(this.currentTagId); )
      this.pop();
  }
  generateImpliedEndTagsThoroughly() {
    for (; kJ.has(this.currentTagId); )
      this.pop();
  }
  generateImpliedEndTagsWithExclusion(e) {
    for (; this.currentTagId !== e && kJ.has(this.currentTagId); )
      this.pop();
  }
}
const Y3 = 3;
var Hd;
(function(t) {
  t[t.Marker = 0] = "Marker", t[t.Element = 1] = "Element";
})(Hd = Hd || (Hd = {}));
const RJ = { type: Hd.Marker };
class X9e {
  constructor(e) {
    this.treeAdapter = e, this.entries = [], this.bookmark = null;
  }
  //Noah Ark's condition
  //OPTIMIZATION: at first we try to find possible candidates for exclusion using
  //lightweight heuristics without thorough attributes check.
  _getNoahArkConditionCandidates(e, n) {
    const r = [], a = n.length, i = this.treeAdapter.getTagName(e), o = this.treeAdapter.getNamespaceURI(e);
    for (let s = 0; s < this.entries.length; s++) {
      const u = this.entries[s];
      if (u.type === Hd.Marker)
        break;
      const { element: f } = u;
      if (this.treeAdapter.getTagName(f) === i && this.treeAdapter.getNamespaceURI(f) === o) {
        const p = this.treeAdapter.getAttrList(f);
        p.length === a && r.push({ idx: s, attrs: p });
      }
    }
    return r;
  }
  _ensureNoahArkCondition(e) {
    if (this.entries.length < Y3)
      return;
    const n = this.treeAdapter.getAttrList(e), r = this._getNoahArkConditionCandidates(e, n);
    if (r.length < Y3)
      return;
    const a = new Map(n.map((o) => [o.name, o.value]));
    let i = 0;
    for (let o = 0; o < r.length; o++) {
      const s = r[o];
      s.attrs.every((u) => a.get(u.name) === u.value) && (i += 1, i >= Y3 && this.entries.splice(s.idx, 1));
    }
  }
  //Mutations
  insertMarker() {
    this.entries.unshift(RJ);
  }
  pushElement(e, n) {
    this._ensureNoahArkCondition(e), this.entries.unshift({
      type: Hd.Element,
      element: e,
      token: n
    });
  }
  insertElementAfterBookmark(e, n) {
    const r = this.entries.indexOf(this.bookmark);
    this.entries.splice(r, 0, {
      type: Hd.Element,
      element: e,
      token: n
    });
  }
  removeEntry(e) {
    const n = this.entries.indexOf(e);
    n >= 0 && this.entries.splice(n, 1);
  }
  /**
   * Clears the list of formatting elements up to the last marker.
   *
   * @see https://html.spec.whatwg.org/multipage/parsing.html#clear-the-list-of-active-formatting-elements-up-to-the-last-marker
   */
  clearToLastMarker() {
    const e = this.entries.indexOf(RJ);
    e >= 0 ? this.entries.splice(0, e + 1) : this.entries.length = 0;
  }
  //Search
  getElementEntryInScopeWithTagName(e) {
    const n = this.entries.find((r) => r.type === Hd.Marker || this.treeAdapter.getTagName(r.element) === e);
    return n && n.type === Hd.Element ? n : null;
  }
  getElementEntry(e) {
    return this.entries.find((n) => n.type === Hd.Element && n.element === e);
  }
}
function IJ(t) {
  return {
    nodeName: "#text",
    value: t,
    parentNode: null
  };
}
const dE = {
  //Node construction
  createDocument() {
    return {
      nodeName: "#document",
      mode: Lc.NO_QUIRKS,
      childNodes: []
    };
  },
  createDocumentFragment() {
    return {
      nodeName: "#document-fragment",
      childNodes: []
    };
  },
  createElement(t, e, n) {
    return {
      nodeName: t,
      tagName: t,
      attrs: n,
      namespaceURI: e,
      childNodes: [],
      parentNode: null
    };
  },
  createCommentNode(t) {
    return {
      nodeName: "#comment",
      data: t,
      parentNode: null
    };
  },
  //Tree mutation
  appendChild(t, e) {
    t.childNodes.push(e), e.parentNode = t;
  },
  insertBefore(t, e, n) {
    const r = t.childNodes.indexOf(n);
    t.childNodes.splice(r, 0, e), e.parentNode = t;
  },
  setTemplateContent(t, e) {
    t.content = e;
  },
  getTemplateContent(t) {
    return t.content;
  },
  setDocumentType(t, e, n, r) {
    const a = t.childNodes.find((i) => i.nodeName === "#documentType");
    if (a)
      a.name = e, a.publicId = n, a.systemId = r;
    else {
      const i = {
        nodeName: "#documentType",
        name: e,
        publicId: n,
        systemId: r,
        parentNode: null
      };
      dE.appendChild(t, i);
    }
  },
  setDocumentMode(t, e) {
    t.mode = e;
  },
  getDocumentMode(t) {
    return t.mode;
  },
  detachNode(t) {
    if (t.parentNode) {
      const e = t.parentNode.childNodes.indexOf(t);
      t.parentNode.childNodes.splice(e, 1), t.parentNode = null;
    }
  },
  insertText(t, e) {
    if (t.childNodes.length > 0) {
      const n = t.childNodes[t.childNodes.length - 1];
      if (dE.isTextNode(n)) {
        n.value += e;
        return;
      }
    }
    dE.appendChild(t, IJ(e));
  },
  insertTextBefore(t, e, n) {
    const r = t.childNodes[t.childNodes.indexOf(n) - 1];
    r && dE.isTextNode(r) ? r.value += e : dE.insertBefore(t, IJ(e), n);
  },
  adoptAttributes(t, e) {
    const n = new Set(t.attrs.map((r) => r.name));
    for (let r = 0; r < e.length; r++)
      n.has(e[r].name) || t.attrs.push(e[r]);
  },
  //Tree traversing
  getFirstChild(t) {
    return t.childNodes[0];
  },
  getChildNodes(t) {
    return t.childNodes;
  },
  getParentNode(t) {
    return t.parentNode;
  },
  getAttrList(t) {
    return t.attrs;
  },
  //Node data
  getTagName(t) {
    return t.tagName;
  },
  getNamespaceURI(t) {
    return t.namespaceURI;
  },
  getTextNodeContent(t) {
    return t.value;
  },
  getCommentNodeContent(t) {
    return t.data;
  },
  getDocumentTypeNodeName(t) {
    return t.name;
  },
  getDocumentTypeNodePublicId(t) {
    return t.publicId;
  },
  getDocumentTypeNodeSystemId(t) {
    return t.systemId;
  },
  //Node types
  isTextNode(t) {
    return t.nodeName === "#text";
  },
  isCommentNode(t) {
    return t.nodeName === "#comment";
  },
  isDocumentTypeNode(t) {
    return t.nodeName === "#documentType";
  },
  isElementNode(t) {
    return Object.prototype.hasOwnProperty.call(t, "tagName");
  },
  // Source code location
  setNodeSourceCodeLocation(t, e) {
    t.sourceCodeLocation = e;
  },
  getNodeSourceCodeLocation(t) {
    return t.sourceCodeLocation;
  },
  updateNodeSourceCodeLocation(t, e) {
    t.sourceCodeLocation = { ...t.sourceCodeLocation, ...e };
  }
}, Fue = "html", q9e = "about:legacy-compat", K9e = "http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd", $ue = [
  "+//silmaril//dtd html pro v0r11 19970101//",
  "-//as//dtd html 3.0 aswedit + extensions//",
  "-//advasoft ltd//dtd html 3.0 aswedit + extensions//",
  "-//ietf//dtd html 2.0 level 1//",
  "-//ietf//dtd html 2.0 level 2//",
  "-//ietf//dtd html 2.0 strict level 1//",
  "-//ietf//dtd html 2.0 strict level 2//",
  "-//ietf//dtd html 2.0 strict//",
  "-//ietf//dtd html 2.0//",
  "-//ietf//dtd html 2.1e//",
  "-//ietf//dtd html 3.0//",
  "-//ietf//dtd html 3.2 final//",
  "-//ietf//dtd html 3.2//",
  "-//ietf//dtd html 3//",
  "-//ietf//dtd html level 0//",
  "-//ietf//dtd html level 1//",
  "-//ietf//dtd html level 2//",
  "-//ietf//dtd html level 3//",
  "-//ietf//dtd html strict level 0//",
  "-//ietf//dtd html strict level 1//",
  "-//ietf//dtd html strict level 2//",
  "-//ietf//dtd html strict level 3//",
  "-//ietf//dtd html strict//",
  "-//ietf//dtd html//",
  "-//metrius//dtd metrius presentational//",
  "-//microsoft//dtd internet explorer 2.0 html strict//",
  "-//microsoft//dtd internet explorer 2.0 html//",
  "-//microsoft//dtd internet explorer 2.0 tables//",
  "-//microsoft//dtd internet explorer 3.0 html strict//",
  "-//microsoft//dtd internet explorer 3.0 html//",
  "-//microsoft//dtd internet explorer 3.0 tables//",
  "-//netscape comm. corp.//dtd html//",
  "-//netscape comm. corp.//dtd strict html//",
  "-//o'reilly and associates//dtd html 2.0//",
  "-//o'reilly and associates//dtd html extended 1.0//",
  "-//o'reilly and associates//dtd html extended relaxed 1.0//",
  "-//sq//dtd html 2.0 hotmetal + extensions//",
  "-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//",
  "-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//",
  "-//spyglass//dtd html 2.0 extended//",
  "-//sun microsystems corp.//dtd hotjava html//",
  "-//sun microsystems corp.//dtd hotjava strict html//",
  "-//w3c//dtd html 3 1995-03-24//",
  "-//w3c//dtd html 3.2 draft//",
  "-//w3c//dtd html 3.2 final//",
  "-//w3c//dtd html 3.2//",
  "-//w3c//dtd html 3.2s draft//",
  "-//w3c//dtd html 4.0 frameset//",
  "-//w3c//dtd html 4.0 transitional//",
  "-//w3c//dtd html experimental 19960712//",
  "-//w3c//dtd html experimental 970421//",
  "-//w3c//dtd w3 html//",
  "-//w3o//dtd w3 html 3.0//",
  "-//webtechs//dtd mozilla html 2.0//",
  "-//webtechs//dtd mozilla html//"
], J9e = [
  ...$ue,
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
], eze = /* @__PURE__ */ new Set([
  "-//w3o//dtd w3 html strict 3.0//en//",
  "-/w3c/dtd html 4.0 transitional/en",
  "html"
]), Bue = ["-//w3c//dtd xhtml 1.0 frameset//", "-//w3c//dtd xhtml 1.0 transitional//"], tze = [
  ...Bue,
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
];
function DJ(t, e) {
  return e.some((n) => t.startsWith(n));
}
function nze(t) {
  return t.name === Fue && t.publicId === null && (t.systemId === null || t.systemId === q9e);
}
function rze(t) {
  if (t.name !== Fue)
    return Lc.QUIRKS;
  const { systemId: e } = t;
  if (e && e.toLowerCase() === K9e)
    return Lc.QUIRKS;
  let { publicId: n } = t;
  if (n !== null) {
    if (n = n.toLowerCase(), eze.has(n))
      return Lc.QUIRKS;
    let r = e === null ? J9e : $ue;
    if (DJ(n, r))
      return Lc.QUIRKS;
    if (r = e === null ? Bue : tze, DJ(n, r))
      return Lc.LIMITED_QUIRKS;
  }
  return Lc.NO_QUIRKS;
}
const NJ = {
  TEXT_HTML: "text/html",
  APPLICATION_XML: "application/xhtml+xml"
}, aze = "definitionurl", ize = "definitionURL", oze = new Map([
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map((t) => [t.toLowerCase(), t])), sze = /* @__PURE__ */ new Map([
  ["xlink:actuate", { prefix: "xlink", name: "actuate", namespace: vt.XLINK }],
  ["xlink:arcrole", { prefix: "xlink", name: "arcrole", namespace: vt.XLINK }],
  ["xlink:href", { prefix: "xlink", name: "href", namespace: vt.XLINK }],
  ["xlink:role", { prefix: "xlink", name: "role", namespace: vt.XLINK }],
  ["xlink:show", { prefix: "xlink", name: "show", namespace: vt.XLINK }],
  ["xlink:title", { prefix: "xlink", name: "title", namespace: vt.XLINK }],
  ["xlink:type", { prefix: "xlink", name: "type", namespace: vt.XLINK }],
  ["xml:base", { prefix: "xml", name: "base", namespace: vt.XML }],
  ["xml:lang", { prefix: "xml", name: "lang", namespace: vt.XML }],
  ["xml:space", { prefix: "xml", name: "space", namespace: vt.XML }],
  ["xmlns", { prefix: "", name: "xmlns", namespace: vt.XMLNS }],
  ["xmlns:xlink", { prefix: "xmlns", name: "xlink", namespace: vt.XMLNS }]
]), lze = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map((t) => [t.toLowerCase(), t])), uze = /* @__PURE__ */ new Set([
  L.B,
  L.BIG,
  L.BLOCKQUOTE,
  L.BODY,
  L.BR,
  L.CENTER,
  L.CODE,
  L.DD,
  L.DIV,
  L.DL,
  L.DT,
  L.EM,
  L.EMBED,
  L.H1,
  L.H2,
  L.H3,
  L.H4,
  L.H5,
  L.H6,
  L.HEAD,
  L.HR,
  L.I,
  L.IMG,
  L.LI,
  L.LISTING,
  L.MENU,
  L.META,
  L.NOBR,
  L.OL,
  L.P,
  L.PRE,
  L.RUBY,
  L.S,
  L.SMALL,
  L.SPAN,
  L.STRONG,
  L.STRIKE,
  L.SUB,
  L.SUP,
  L.TABLE,
  L.TT,
  L.U,
  L.UL,
  L.VAR
]);
function cze(t) {
  const e = t.tagID;
  return e === L.FONT && t.attrs.some(({ name: r }) => r === Xb.COLOR || r === Xb.SIZE || r === Xb.FACE) || uze.has(e);
}
function Uue(t) {
  for (let e = 0; e < t.attrs.length; e++)
    if (t.attrs[e].name === aze) {
      t.attrs[e].name = ize;
      break;
    }
}
function zue(t) {
  for (let e = 0; e < t.attrs.length; e++) {
    const n = oze.get(t.attrs[e].name);
    n != null && (t.attrs[e].name = n);
  }
}
function I7(t) {
  for (let e = 0; e < t.attrs.length; e++) {
    const n = sze.get(t.attrs[e].name);
    n && (t.attrs[e].prefix = n.prefix, t.attrs[e].name = n.name, t.attrs[e].namespace = n.namespace);
  }
}
function fze(t) {
  const e = lze.get(t.tagName);
  e != null && (t.tagName = e, t.tagID = _1(t.tagName));
}
function dze(t, e) {
  return e === vt.MATHML && (t === L.MI || t === L.MO || t === L.MN || t === L.MS || t === L.MTEXT);
}
function pze(t, e, n) {
  if (e === vt.MATHML && t === L.ANNOTATION_XML) {
    for (let r = 0; r < n.length; r++)
      if (n[r].name === Xb.ENCODING) {
        const a = n[r].value.toLowerCase();
        return a === NJ.TEXT_HTML || a === NJ.APPLICATION_XML;
      }
  }
  return e === vt.SVG && (t === L.FOREIGN_OBJECT || t === L.DESC || t === L.TITLE);
}
function hze(t, e, n, r) {
  return (!r || r === vt.HTML) && pze(t, e, n) || (!r || r === vt.MATHML) && dze(t, e);
}
const mze = "hidden", gze = 8, bze = 3;
var ke;
(function(t) {
  t[t.INITIAL = 0] = "INITIAL", t[t.BEFORE_HTML = 1] = "BEFORE_HTML", t[t.BEFORE_HEAD = 2] = "BEFORE_HEAD", t[t.IN_HEAD = 3] = "IN_HEAD", t[t.IN_HEAD_NO_SCRIPT = 4] = "IN_HEAD_NO_SCRIPT", t[t.AFTER_HEAD = 5] = "AFTER_HEAD", t[t.IN_BODY = 6] = "IN_BODY", t[t.TEXT = 7] = "TEXT", t[t.IN_TABLE = 8] = "IN_TABLE", t[t.IN_TABLE_TEXT = 9] = "IN_TABLE_TEXT", t[t.IN_CAPTION = 10] = "IN_CAPTION", t[t.IN_COLUMN_GROUP = 11] = "IN_COLUMN_GROUP", t[t.IN_TABLE_BODY = 12] = "IN_TABLE_BODY", t[t.IN_ROW = 13] = "IN_ROW", t[t.IN_CELL = 14] = "IN_CELL", t[t.IN_SELECT = 15] = "IN_SELECT", t[t.IN_SELECT_IN_TABLE = 16] = "IN_SELECT_IN_TABLE", t[t.IN_TEMPLATE = 17] = "IN_TEMPLATE", t[t.AFTER_BODY = 18] = "AFTER_BODY", t[t.IN_FRAMESET = 19] = "IN_FRAMESET", t[t.AFTER_FRAMESET = 20] = "AFTER_FRAMESET", t[t.AFTER_AFTER_BODY = 21] = "AFTER_AFTER_BODY", t[t.AFTER_AFTER_FRAMESET = 22] = "AFTER_AFTER_FRAMESET";
})(ke || (ke = {}));
const vze = {
  startLine: -1,
  startCol: -1,
  startOffset: -1,
  endLine: -1,
  endCol: -1,
  endOffset: -1
}, Hue = /* @__PURE__ */ new Set([L.TABLE, L.TBODY, L.TFOOT, L.THEAD, L.TR]), PJ = {
  scriptingEnabled: !0,
  sourceCodeLocationInfo: !1,
  treeAdapter: dE,
  onParseError: null
};
class LJ {
  constructor(e, n, r = null, a = null) {
    this.fragmentContext = r, this.scriptHandler = a, this.currentToken = null, this.stopped = !1, this.insertionMode = ke.INITIAL, this.originalInsertionMode = ke.INITIAL, this.headElement = null, this.formElement = null, this.currentNotInHTML = !1, this.tmplInsertionModeStack = [], this.pendingCharacterTokens = [], this.hasNonWhitespacePendingCharacterToken = !1, this.framesetOk = !0, this.skipNextNewLine = !1, this.fosterParentingEnabled = !1, this.options = {
      ...PJ,
      ...e
    }, this.treeAdapter = this.options.treeAdapter, this.onParseError = this.options.onParseError, this.onParseError && (this.options.sourceCodeLocationInfo = !0), this.document = n ?? this.treeAdapter.createDocument(), this.tokenizer = new W9e(this.options, this), this.activeFormattingElements = new X9e(this.treeAdapter), this.fragmentContextID = r ? _1(this.treeAdapter.getTagName(r)) : L.UNKNOWN, this._setContextModes(r ?? this.document, this.fragmentContextID), this.openElements = new Z9e(this.document, this.treeAdapter, this);
  }
  // API
  static parse(e, n) {
    const r = new this(n);
    return r.tokenizer.write(e, !0), r.document;
  }
  static getFragmentParser(e, n) {
    const r = {
      ...PJ,
      ...n
    };
    e ?? (e = r.treeAdapter.createElement(Je.TEMPLATE, vt.HTML, []));
    const a = r.treeAdapter.createElement("documentmock", vt.HTML, []), i = new this(r, a, e);
    return i.fragmentContextID === L.TEMPLATE && i.tmplInsertionModeStack.unshift(ke.IN_TEMPLATE), i._initTokenizerForFragmentParsing(), i._insertFakeRootElement(), i._resetInsertionMode(), i._findFormInFragmentContext(), i;
  }
  getFragment() {
    const e = this.treeAdapter.getFirstChild(this.document), n = this.treeAdapter.createDocumentFragment();
    return this._adoptNodes(e, n), n;
  }
  //Errors
  _err(e, n, r) {
    var a;
    if (!this.onParseError)
      return;
    const i = (a = e.location) !== null && a !== void 0 ? a : vze, o = {
      code: n,
      startLine: i.startLine,
      startCol: i.startCol,
      startOffset: i.startOffset,
      endLine: r ? i.startLine : i.endLine,
      endCol: r ? i.startCol : i.endCol,
      endOffset: r ? i.startOffset : i.endOffset
    };
    this.onParseError(o);
  }
  //Stack events
  onItemPush(e, n, r) {
    var a, i;
    (i = (a = this.treeAdapter).onItemPush) === null || i === void 0 || i.call(a, e), r && this.openElements.stackTop > 0 && this._setContextModes(e, n);
  }
  onItemPop(e, n) {
    var r, a;
    if (this.options.sourceCodeLocationInfo && this._setEndLocation(e, this.currentToken), (a = (r = this.treeAdapter).onItemPop) === null || a === void 0 || a.call(r, e, this.openElements.current), n) {
      let i, o;
      this.openElements.stackTop === 0 && this.fragmentContext ? (i = this.fragmentContext, o = this.fragmentContextID) : { current: i, currentTagId: o } = this.openElements, this._setContextModes(i, o);
    }
  }
  _setContextModes(e, n) {
    const r = e === this.document || this.treeAdapter.getNamespaceURI(e) === vt.HTML;
    this.currentNotInHTML = !r, this.tokenizer.inForeignNode = !r && !this._isIntegrationPoint(n, e);
  }
  _switchToTextParsing(e, n) {
    this._insertElement(e, vt.HTML), this.tokenizer.state = n, this.originalInsertionMode = this.insertionMode, this.insertionMode = ke.TEXT;
  }
  switchToPlaintextParsing() {
    this.insertionMode = ke.TEXT, this.originalInsertionMode = ke.IN_BODY, this.tokenizer.state = uo.PLAINTEXT;
  }
  //Fragment parsing
  _getAdjustedCurrentElement() {
    return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
  }
  _findFormInFragmentContext() {
    let e = this.fragmentContext;
    for (; e; ) {
      if (this.treeAdapter.getTagName(e) === Je.FORM) {
        this.formElement = e;
        break;
      }
      e = this.treeAdapter.getParentNode(e);
    }
  }
  _initTokenizerForFragmentParsing() {
    if (!(!this.fragmentContext || this.treeAdapter.getNamespaceURI(this.fragmentContext) !== vt.HTML))
      switch (this.fragmentContextID) {
        case L.TITLE:
        case L.TEXTAREA: {
          this.tokenizer.state = uo.RCDATA;
          break;
        }
        case L.STYLE:
        case L.XMP:
        case L.IFRAME:
        case L.NOEMBED:
        case L.NOFRAMES:
        case L.NOSCRIPT: {
          this.tokenizer.state = uo.RAWTEXT;
          break;
        }
        case L.SCRIPT: {
          this.tokenizer.state = uo.SCRIPT_DATA;
          break;
        }
        case L.PLAINTEXT: {
          this.tokenizer.state = uo.PLAINTEXT;
          break;
        }
      }
  }
  //Tree mutation
  _setDocumentType(e) {
    const n = e.name || "", r = e.publicId || "", a = e.systemId || "";
    if (this.treeAdapter.setDocumentType(this.document, n, r, a), e.location) {
      const o = this.treeAdapter.getChildNodes(this.document).find((s) => this.treeAdapter.isDocumentTypeNode(s));
      o && this.treeAdapter.setNodeSourceCodeLocation(o, e.location);
    }
  }
  _attachElementToTree(e, n) {
    if (this.options.sourceCodeLocationInfo) {
      const r = n && {
        ...n,
        startTag: n
      };
      this.treeAdapter.setNodeSourceCodeLocation(e, r);
    }
    if (this._shouldFosterParentOnInsertion())
      this._fosterParentElement(e);
    else {
      const r = this.openElements.currentTmplContentOrNode;
      this.treeAdapter.appendChild(r, e);
    }
  }
  _appendElement(e, n) {
    const r = this.treeAdapter.createElement(e.tagName, n, e.attrs);
    this._attachElementToTree(r, e.location);
  }
  _insertElement(e, n) {
    const r = this.treeAdapter.createElement(e.tagName, n, e.attrs);
    this._attachElementToTree(r, e.location), this.openElements.push(r, e.tagID);
  }
  _insertFakeElement(e, n) {
    const r = this.treeAdapter.createElement(e, vt.HTML, []);
    this._attachElementToTree(r, null), this.openElements.push(r, n);
  }
  _insertTemplate(e) {
    const n = this.treeAdapter.createElement(e.tagName, vt.HTML, e.attrs), r = this.treeAdapter.createDocumentFragment();
    this.treeAdapter.setTemplateContent(n, r), this._attachElementToTree(n, e.location), this.openElements.push(n, e.tagID), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(r, null);
  }
  _insertFakeRootElement() {
    const e = this.treeAdapter.createElement(Je.HTML, vt.HTML, []);
    this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(e, null), this.treeAdapter.appendChild(this.openElements.current, e), this.openElements.push(e, L.HTML);
  }
  _appendCommentNode(e, n) {
    const r = this.treeAdapter.createCommentNode(e.data);
    this.treeAdapter.appendChild(n, r), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(r, e.location);
  }
  _insertCharacters(e) {
    let n, r;
    if (this._shouldFosterParentOnInsertion() ? ({ parent: n, beforeElement: r } = this._findFosterParentingLocation(), r ? this.treeAdapter.insertTextBefore(n, e.chars, r) : this.treeAdapter.insertText(n, e.chars)) : (n = this.openElements.currentTmplContentOrNode, this.treeAdapter.insertText(n, e.chars)), !e.location)
      return;
    const a = this.treeAdapter.getChildNodes(n), i = r ? a.lastIndexOf(r) : a.length, o = a[i - 1];
    if (this.treeAdapter.getNodeSourceCodeLocation(o)) {
      const { endLine: u, endCol: f, endOffset: p } = e.location;
      this.treeAdapter.updateNodeSourceCodeLocation(o, { endLine: u, endCol: f, endOffset: p });
    } else
      this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(o, e.location);
  }
  _adoptNodes(e, n) {
    for (let r = this.treeAdapter.getFirstChild(e); r; r = this.treeAdapter.getFirstChild(e))
      this.treeAdapter.detachNode(r), this.treeAdapter.appendChild(n, r);
  }
  _setEndLocation(e, n) {
    if (this.treeAdapter.getNodeSourceCodeLocation(e) && n.location) {
      const r = n.location, a = this.treeAdapter.getTagName(e), i = (
        // NOTE: For cases like <p> <p> </p> - First 'p' closes without a closing
        // tag and for cases like <td> <p> </td> - 'p' closes without a closing tag.
        n.type === Tr.END_TAG && a === n.tagName ? {
          endTag: { ...r },
          endLine: r.endLine,
          endCol: r.endCol,
          endOffset: r.endOffset
        } : {
          endLine: r.startLine,
          endCol: r.startCol,
          endOffset: r.startOffset
        }
      );
      this.treeAdapter.updateNodeSourceCodeLocation(e, i);
    }
  }
  //Token processing
  shouldProcessStartTagTokenInForeignContent(e) {
    if (!this.currentNotInHTML)
      return !1;
    let n, r;
    return this.openElements.stackTop === 0 && this.fragmentContext ? (n = this.fragmentContext, r = this.fragmentContextID) : { current: n, currentTagId: r } = this.openElements, e.tagID === L.SVG && this.treeAdapter.getTagName(n) === Je.ANNOTATION_XML && this.treeAdapter.getNamespaceURI(n) === vt.MATHML ? !1 : (
      // Check that `current` is not an integration point for HTML or MathML elements.
      this.tokenizer.inForeignNode || // If it _is_ an integration point, then we might have to check that it is not an HTML
      // integration point.
      (e.tagID === L.MGLYPH || e.tagID === L.MALIGNMARK) && !this._isIntegrationPoint(r, n, vt.HTML)
    );
  }
  _processToken(e) {
    switch (e.type) {
      case Tr.CHARACTER: {
        this.onCharacter(e);
        break;
      }
      case Tr.NULL_CHARACTER: {
        this.onNullCharacter(e);
        break;
      }
      case Tr.COMMENT: {
        this.onComment(e);
        break;
      }
      case Tr.DOCTYPE: {
        this.onDoctype(e);
        break;
      }
      case Tr.START_TAG: {
        this._processStartTag(e);
        break;
      }
      case Tr.END_TAG: {
        this.onEndTag(e);
        break;
      }
      case Tr.EOF: {
        this.onEof(e);
        break;
      }
      case Tr.WHITESPACE_CHARACTER: {
        this.onWhitespaceCharacter(e);
        break;
      }
    }
  }
  //Integration points
  _isIntegrationPoint(e, n, r) {
    const a = this.treeAdapter.getNamespaceURI(n), i = this.treeAdapter.getAttrList(n);
    return hze(e, a, i, r);
  }
  //Active formatting elements reconstruction
  _reconstructActiveFormattingElements() {
    const e = this.activeFormattingElements.entries.length;
    if (e) {
      const n = this.activeFormattingElements.entries.findIndex((a) => a.type === Hd.Marker || this.openElements.contains(a.element)), r = n < 0 ? e - 1 : n - 1;
      for (let a = r; a >= 0; a--) {
        const i = this.activeFormattingElements.entries[a];
        this._insertElement(i.token, this.treeAdapter.getNamespaceURI(i.element)), i.element = this.openElements.current;
      }
    }
  }
  //Close elements
  _closeTableCell() {
    this.openElements.generateImpliedEndTags(), this.openElements.popUntilTableCellPopped(), this.activeFormattingElements.clearToLastMarker(), this.insertionMode = ke.IN_ROW;
  }
  _closePElement() {
    this.openElements.generateImpliedEndTagsWithExclusion(L.P), this.openElements.popUntilTagNamePopped(L.P);
  }
  //Insertion modes
  _resetInsertionMode() {
    for (let e = this.openElements.stackTop; e >= 0; e--)
      switch (e === 0 && this.fragmentContext ? this.fragmentContextID : this.openElements.tagIDs[e]) {
        case L.TR: {
          this.insertionMode = ke.IN_ROW;
          return;
        }
        case L.TBODY:
        case L.THEAD:
        case L.TFOOT: {
          this.insertionMode = ke.IN_TABLE_BODY;
          return;
        }
        case L.CAPTION: {
          this.insertionMode = ke.IN_CAPTION;
          return;
        }
        case L.COLGROUP: {
          this.insertionMode = ke.IN_COLUMN_GROUP;
          return;
        }
        case L.TABLE: {
          this.insertionMode = ke.IN_TABLE;
          return;
        }
        case L.BODY: {
          this.insertionMode = ke.IN_BODY;
          return;
        }
        case L.FRAMESET: {
          this.insertionMode = ke.IN_FRAMESET;
          return;
        }
        case L.SELECT: {
          this._resetInsertionModeForSelect(e);
          return;
        }
        case L.TEMPLATE: {
          this.insertionMode = this.tmplInsertionModeStack[0];
          return;
        }
        case L.HTML: {
          this.insertionMode = this.headElement ? ke.AFTER_HEAD : ke.BEFORE_HEAD;
          return;
        }
        case L.TD:
        case L.TH: {
          if (e > 0) {
            this.insertionMode = ke.IN_CELL;
            return;
          }
          break;
        }
        case L.HEAD: {
          if (e > 0) {
            this.insertionMode = ke.IN_HEAD;
            return;
          }
          break;
        }
      }
    this.insertionMode = ke.IN_BODY;
  }
  _resetInsertionModeForSelect(e) {
    if (e > 0)
      for (let n = e - 1; n > 0; n--) {
        const r = this.openElements.tagIDs[n];
        if (r === L.TEMPLATE)
          break;
        if (r === L.TABLE) {
          this.insertionMode = ke.IN_SELECT_IN_TABLE;
          return;
        }
      }
    this.insertionMode = ke.IN_SELECT;
  }
  //Foster parenting
  _isElementCausesFosterParenting(e) {
    return Hue.has(e);
  }
  _shouldFosterParentOnInsertion() {
    return this.fosterParentingEnabled && this._isElementCausesFosterParenting(this.openElements.currentTagId);
  }
  _findFosterParentingLocation() {
    for (let e = this.openElements.stackTop; e >= 0; e--) {
      const n = this.openElements.items[e];
      switch (this.openElements.tagIDs[e]) {
        case L.TEMPLATE: {
          if (this.treeAdapter.getNamespaceURI(n) === vt.HTML)
            return { parent: this.treeAdapter.getTemplateContent(n), beforeElement: null };
          break;
        }
        case L.TABLE: {
          const r = this.treeAdapter.getParentNode(n);
          return r ? { parent: r, beforeElement: n } : { parent: this.openElements.items[e - 1], beforeElement: null };
        }
      }
    }
    return { parent: this.openElements.items[0], beforeElement: null };
  }
  _fosterParentElement(e) {
    const n = this._findFosterParentingLocation();
    n.beforeElement ? this.treeAdapter.insertBefore(n.parent, e, n.beforeElement) : this.treeAdapter.appendChild(n.parent, e);
  }
  //Special elements
  _isSpecialElement(e, n) {
    const r = this.treeAdapter.getNamespaceURI(e);
    return $9e[r].has(n);
  }
  onCharacter(e) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      Y8e(this, e);
      return;
    }
    switch (this.insertionMode) {
      case ke.INITIAL: {
        Rw(this, e);
        break;
      }
      case ke.BEFORE_HTML: {
        mT(this, e);
        break;
      }
      case ke.BEFORE_HEAD: {
        gT(this, e);
        break;
      }
      case ke.IN_HEAD: {
        bT(this, e);
        break;
      }
      case ke.IN_HEAD_NO_SCRIPT: {
        vT(this, e);
        break;
      }
      case ke.AFTER_HEAD: {
        yT(this, e);
        break;
      }
      case ke.IN_BODY:
      case ke.IN_CAPTION:
      case ke.IN_CELL:
      case ke.IN_TEMPLATE: {
        Que(this, e);
        break;
      }
      case ke.TEXT:
      case ke.IN_SELECT:
      case ke.IN_SELECT_IN_TABLE: {
        this._insertCharacters(e);
        break;
      }
      case ke.IN_TABLE:
      case ke.IN_TABLE_BODY:
      case ke.IN_ROW: {
        Z3(this, e);
        break;
      }
      case ke.IN_TABLE_TEXT: {
        Xue(this, e);
        break;
      }
      case ke.IN_COLUMN_GROUP: {
        PI(this, e);
        break;
      }
      case ke.AFTER_BODY: {
        LI(this, e);
        break;
      }
      case ke.AFTER_AFTER_BODY: {
        Fk(this, e);
        break;
      }
    }
  }
  onNullCharacter(e) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      V8e(this, e);
      return;
    }
    switch (this.insertionMode) {
      case ke.INITIAL: {
        Rw(this, e);
        break;
      }
      case ke.BEFORE_HTML: {
        mT(this, e);
        break;
      }
      case ke.BEFORE_HEAD: {
        gT(this, e);
        break;
      }
      case ke.IN_HEAD: {
        bT(this, e);
        break;
      }
      case ke.IN_HEAD_NO_SCRIPT: {
        vT(this, e);
        break;
      }
      case ke.AFTER_HEAD: {
        yT(this, e);
        break;
      }
      case ke.TEXT: {
        this._insertCharacters(e);
        break;
      }
      case ke.IN_TABLE:
      case ke.IN_TABLE_BODY:
      case ke.IN_ROW: {
        Z3(this, e);
        break;
      }
      case ke.IN_COLUMN_GROUP: {
        PI(this, e);
        break;
      }
      case ke.AFTER_BODY: {
        LI(this, e);
        break;
      }
      case ke.AFTER_AFTER_BODY: {
        Fk(this, e);
        break;
      }
    }
  }
  onComment(e) {
    if (this.skipNextNewLine = !1, this.currentNotInHTML) {
      b5(this, e);
      return;
    }
    switch (this.insertionMode) {
      case ke.INITIAL:
      case ke.BEFORE_HTML:
      case ke.BEFORE_HEAD:
      case ke.IN_HEAD:
      case ke.IN_HEAD_NO_SCRIPT:
      case ke.AFTER_HEAD:
      case ke.IN_BODY:
      case ke.IN_TABLE:
      case ke.IN_CAPTION:
      case ke.IN_COLUMN_GROUP:
      case ke.IN_TABLE_BODY:
      case ke.IN_ROW:
      case ke.IN_CELL:
      case ke.IN_SELECT:
      case ke.IN_SELECT_IN_TABLE:
      case ke.IN_TEMPLATE:
      case ke.IN_FRAMESET:
      case ke.AFTER_FRAMESET: {
        b5(this, e);
        break;
      }
      case ke.IN_TABLE_TEXT: {
        Iw(this, e);
        break;
      }
      case ke.AFTER_BODY: {
        _ze(this, e);
        break;
      }
      case ke.AFTER_AFTER_BODY:
      case ke.AFTER_AFTER_FRAMESET: {
        Cze(this, e);
        break;
      }
    }
  }
  onDoctype(e) {
    switch (this.skipNextNewLine = !1, this.insertionMode) {
      case ke.INITIAL: {
        xze(this, e);
        break;
      }
      case ke.BEFORE_HEAD:
      case ke.IN_HEAD:
      case ke.IN_HEAD_NO_SCRIPT:
      case ke.AFTER_HEAD: {
        this._err(e, ot.misplacedDoctype);
        break;
      }
      case ke.IN_TABLE_TEXT: {
        Iw(this, e);
        break;
      }
    }
  }
  onStartTag(e) {
    this.skipNextNewLine = !1, this.currentToken = e, this._processStartTag(e), e.selfClosing && !e.ackSelfClosing && this._err(e, ot.nonVoidHtmlElementStartTagWithTrailingSolidus);
  }
  /**
   * Processes a given start tag.
   *
   * `onStartTag` checks if a self-closing tag was recognized. When a token
   * is moved inbetween multiple insertion modes, this check for self-closing
   * could lead to false positives. To avoid this, `_processStartTag` is used
   * for nested calls.
   *
   * @param token The token to process.
   */
  _processStartTag(e) {
    this.shouldProcessStartTagTokenInForeignContent(e) ? Z8e(this, e) : this._startTagOutsideForeignContent(e);
  }
  _startTagOutsideForeignContent(e) {
    switch (this.insertionMode) {
      case ke.INITIAL: {
        Rw(this, e);
        break;
      }
      case ke.BEFORE_HTML: {
        Aze(this, e);
        break;
      }
      case ke.BEFORE_HEAD: {
        Rze(this, e);
        break;
      }
      case ke.IN_HEAD: {
        np(this, e);
        break;
      }
      case ke.IN_HEAD_NO_SCRIPT: {
        Nze(this, e);
        break;
      }
      case ke.AFTER_HEAD: {
        Lze(this, e);
        break;
      }
      case ke.IN_BODY: {
        Ml(this, e);
        break;
      }
      case ke.IN_TABLE: {
        n1(this, e);
        break;
      }
      case ke.IN_TABLE_TEXT: {
        Iw(this, e);
        break;
      }
      case ke.IN_CAPTION: {
        I8e(this, e);
        break;
      }
      case ke.IN_COLUMN_GROUP: {
        P7(this, e);
        break;
      }
      case ke.IN_TABLE_BODY: {
        oN(this, e);
        break;
      }
      case ke.IN_ROW: {
        sN(this, e);
        break;
      }
      case ke.IN_CELL: {
        P8e(this, e);
        break;
      }
      case ke.IN_SELECT: {
        Jue(this, e);
        break;
      }
      case ke.IN_SELECT_IN_TABLE: {
        M8e(this, e);
        break;
      }
      case ke.IN_TEMPLATE: {
        $8e(this, e);
        break;
      }
      case ke.AFTER_BODY: {
        U8e(this, e);
        break;
      }
      case ke.IN_FRAMESET: {
        z8e(this, e);
        break;
      }
      case ke.AFTER_FRAMESET: {
        W8e(this, e);
        break;
      }
      case ke.AFTER_AFTER_BODY: {
        j8e(this, e);
        break;
      }
      case ke.AFTER_AFTER_FRAMESET: {
        G8e(this, e);
        break;
      }
    }
  }
  onEndTag(e) {
    this.skipNextNewLine = !1, this.currentToken = e, this.currentNotInHTML ? X8e(this, e) : this._endTagOutsideForeignContent(e);
  }
  _endTagOutsideForeignContent(e) {
    switch (this.insertionMode) {
      case ke.INITIAL: {
        Rw(this, e);
        break;
      }
      case ke.BEFORE_HTML: {
        kze(this, e);
        break;
      }
      case ke.BEFORE_HEAD: {
        Ize(this, e);
        break;
      }
      case ke.IN_HEAD: {
        Dze(this, e);
        break;
      }
      case ke.IN_HEAD_NO_SCRIPT: {
        Pze(this, e);
        break;
      }
      case ke.AFTER_HEAD: {
        Mze(this, e);
        break;
      }
      case ke.IN_BODY: {
        iN(this, e);
        break;
      }
      case ke.TEXT: {
        E8e(this, e);
        break;
      }
      case ke.IN_TABLE: {
        o_(this, e);
        break;
      }
      case ke.IN_TABLE_TEXT: {
        Iw(this, e);
        break;
      }
      case ke.IN_CAPTION: {
        D8e(this, e);
        break;
      }
      case ke.IN_COLUMN_GROUP: {
        N8e(this, e);
        break;
      }
      case ke.IN_TABLE_BODY: {
        v5(this, e);
        break;
      }
      case ke.IN_ROW: {
        Kue(this, e);
        break;
      }
      case ke.IN_CELL: {
        L8e(this, e);
        break;
      }
      case ke.IN_SELECT: {
        ece(this, e);
        break;
      }
      case ke.IN_SELECT_IN_TABLE: {
        F8e(this, e);
        break;
      }
      case ke.IN_TEMPLATE: {
        B8e(this, e);
        break;
      }
      case ke.AFTER_BODY: {
        nce(this, e);
        break;
      }
      case ke.IN_FRAMESET: {
        H8e(this, e);
        break;
      }
      case ke.AFTER_FRAMESET: {
        Q8e(this, e);
        break;
      }
      case ke.AFTER_AFTER_BODY: {
        Fk(this, e);
        break;
      }
    }
  }
  onEof(e) {
    switch (this.insertionMode) {
      case ke.INITIAL: {
        Rw(this, e);
        break;
      }
      case ke.BEFORE_HTML: {
        mT(this, e);
        break;
      }
      case ke.BEFORE_HEAD: {
        gT(this, e);
        break;
      }
      case ke.IN_HEAD: {
        bT(this, e);
        break;
      }
      case ke.IN_HEAD_NO_SCRIPT: {
        vT(this, e);
        break;
      }
      case ke.AFTER_HEAD: {
        yT(this, e);
        break;
      }
      case ke.IN_BODY:
      case ke.IN_TABLE:
      case ke.IN_CAPTION:
      case ke.IN_COLUMN_GROUP:
      case ke.IN_TABLE_BODY:
      case ke.IN_ROW:
      case ke.IN_CELL:
      case ke.IN_SELECT:
      case ke.IN_SELECT_IN_TABLE: {
        Yue(this, e);
        break;
      }
      case ke.TEXT: {
        S8e(this, e);
        break;
      }
      case ke.IN_TABLE_TEXT: {
        Iw(this, e);
        break;
      }
      case ke.IN_TEMPLATE: {
        tce(this, e);
        break;
      }
      case ke.AFTER_BODY:
      case ke.IN_FRAMESET:
      case ke.AFTER_FRAMESET:
      case ke.AFTER_AFTER_BODY:
      case ke.AFTER_AFTER_FRAMESET: {
        N7(this, e);
        break;
      }
    }
  }
  onWhitespaceCharacter(e) {
    if (this.skipNextNewLine && (this.skipNextNewLine = !1, e.chars.charCodeAt(0) === se.LINE_FEED)) {
      if (e.chars.length === 1)
        return;
      e.chars = e.chars.substr(1);
    }
    if (this.tokenizer.inForeignNode) {
      this._insertCharacters(e);
      return;
    }
    switch (this.insertionMode) {
      case ke.IN_HEAD:
      case ke.IN_HEAD_NO_SCRIPT:
      case ke.AFTER_HEAD:
      case ke.TEXT:
      case ke.IN_COLUMN_GROUP:
      case ke.IN_SELECT:
      case ke.IN_SELECT_IN_TABLE:
      case ke.IN_FRAMESET:
      case ke.AFTER_FRAMESET: {
        this._insertCharacters(e);
        break;
      }
      case ke.IN_BODY:
      case ke.IN_CAPTION:
      case ke.IN_CELL:
      case ke.IN_TEMPLATE:
      case ke.AFTER_BODY:
      case ke.AFTER_AFTER_BODY:
      case ke.AFTER_AFTER_FRAMESET: {
        Wue(this, e);
        break;
      }
      case ke.IN_TABLE:
      case ke.IN_TABLE_BODY:
      case ke.IN_ROW: {
        Z3(this, e);
        break;
      }
      case ke.IN_TABLE_TEXT: {
        Zue(this, e);
        break;
      }
    }
  }
}
function yze(t, e) {
  let n = t.activeFormattingElements.getElementEntryInScopeWithTagName(e.tagName);
  return n ? t.openElements.contains(n.element) ? t.openElements.hasInScope(e.tagID) || (n = null) : (t.activeFormattingElements.removeEntry(n), n = null) : Vue(t, e), n;
}
function Oze(t, e) {
  let n = null, r = t.openElements.stackTop;
  for (; r >= 0; r--) {
    const a = t.openElements.items[r];
    if (a === e.element)
      break;
    t._isSpecialElement(a, t.openElements.tagIDs[r]) && (n = a);
  }
  return n || (t.openElements.shortenToLength(r < 0 ? 0 : r), t.activeFormattingElements.removeEntry(e)), n;
}
function Eze(t, e, n) {
  let r = e, a = t.openElements.getCommonAncestor(e);
  for (let i = 0, o = a; o !== n; i++, o = a) {
    a = t.openElements.getCommonAncestor(o);
    const s = t.activeFormattingElements.getElementEntry(o), u = s && i >= bze;
    !s || u ? (u && t.activeFormattingElements.removeEntry(s), t.openElements.remove(o)) : (o = Sze(t, s), r === e && (t.activeFormattingElements.bookmark = s), t.treeAdapter.detachNode(r), t.treeAdapter.appendChild(o, r), r = o);
  }
  return r;
}
function Sze(t, e) {
  const n = t.treeAdapter.getNamespaceURI(e.element), r = t.treeAdapter.createElement(e.token.tagName, n, e.token.attrs);
  return t.openElements.replace(e.element, r), e.element = r, r;
}
function wze(t, e, n) {
  const r = t.treeAdapter.getTagName(e), a = _1(r);
  if (t._isElementCausesFosterParenting(a))
    t._fosterParentElement(n);
  else {
    const i = t.treeAdapter.getNamespaceURI(e);
    a === L.TEMPLATE && i === vt.HTML && (e = t.treeAdapter.getTemplateContent(e)), t.treeAdapter.appendChild(e, n);
  }
}
function Tze(t, e, n) {
  const r = t.treeAdapter.getNamespaceURI(n.element), { token: a } = n, i = t.treeAdapter.createElement(a.tagName, r, a.attrs);
  t._adoptNodes(e, i), t.treeAdapter.appendChild(e, i), t.activeFormattingElements.insertElementAfterBookmark(i, a), t.activeFormattingElements.removeEntry(n), t.openElements.remove(n.element), t.openElements.insertAfter(e, i, a.tagID);
}
function D7(t, e) {
  for (let n = 0; n < gze; n++) {
    const r = yze(t, e);
    if (!r)
      break;
    const a = Oze(t, r);
    if (!a)
      break;
    t.activeFormattingElements.bookmark = r;
    const i = Eze(t, a, r.element), o = t.openElements.getCommonAncestor(r.element);
    t.treeAdapter.detachNode(i), o && wze(t, o, i), Tze(t, a, r);
  }
}
function b5(t, e) {
  t._appendCommentNode(e, t.openElements.currentTmplContentOrNode);
}
function _ze(t, e) {
  t._appendCommentNode(e, t.openElements.items[0]);
}
function Cze(t, e) {
  t._appendCommentNode(e, t.document);
}
function N7(t, e) {
  if (t.stopped = !0, e.location) {
    const n = t.fragmentContext ? 0 : 2;
    for (let r = t.openElements.stackTop; r >= n; r--)
      t._setEndLocation(t.openElements.items[r], e);
    if (!t.fragmentContext && t.openElements.stackTop >= 0) {
      const r = t.openElements.items[0], a = t.treeAdapter.getNodeSourceCodeLocation(r);
      if (a && !a.endTag && (t._setEndLocation(r, e), t.openElements.stackTop >= 1)) {
        const i = t.openElements.items[1], o = t.treeAdapter.getNodeSourceCodeLocation(i);
        o && !o.endTag && t._setEndLocation(i, e);
      }
    }
  }
}
function xze(t, e) {
  t._setDocumentType(e);
  const n = e.forceQuirks ? Lc.QUIRKS : rze(e);
  nze(e) || t._err(e, ot.nonConformingDoctype), t.treeAdapter.setDocumentMode(t.document, n), t.insertionMode = ke.BEFORE_HTML;
}
function Rw(t, e) {
  t._err(e, ot.missingDoctype, !0), t.treeAdapter.setDocumentMode(t.document, Lc.QUIRKS), t.insertionMode = ke.BEFORE_HTML, t._processToken(e);
}
function Aze(t, e) {
  e.tagID === L.HTML ? (t._insertElement(e, vt.HTML), t.insertionMode = ke.BEFORE_HEAD) : mT(t, e);
}
function kze(t, e) {
  const n = e.tagID;
  (n === L.HTML || n === L.HEAD || n === L.BODY || n === L.BR) && mT(t, e);
}
function mT(t, e) {
  t._insertFakeRootElement(), t.insertionMode = ke.BEFORE_HEAD, t._processToken(e);
}
function Rze(t, e) {
  switch (e.tagID) {
    case L.HTML: {
      Ml(t, e);
      break;
    }
    case L.HEAD: {
      t._insertElement(e, vt.HTML), t.headElement = t.openElements.current, t.insertionMode = ke.IN_HEAD;
      break;
    }
    default:
      gT(t, e);
  }
}
function Ize(t, e) {
  const n = e.tagID;
  n === L.HEAD || n === L.BODY || n === L.HTML || n === L.BR ? gT(t, e) : t._err(e, ot.endTagWithoutMatchingOpenElement);
}
function gT(t, e) {
  t._insertFakeElement(Je.HEAD, L.HEAD), t.headElement = t.openElements.current, t.insertionMode = ke.IN_HEAD, t._processToken(e);
}
function np(t, e) {
  switch (e.tagID) {
    case L.HTML: {
      Ml(t, e);
      break;
    }
    case L.BASE:
    case L.BASEFONT:
    case L.BGSOUND:
    case L.LINK:
    case L.META: {
      t._appendElement(e, vt.HTML), e.ackSelfClosing = !0;
      break;
    }
    case L.TITLE: {
      t._switchToTextParsing(e, uo.RCDATA);
      break;
    }
    case L.NOSCRIPT: {
      t.options.scriptingEnabled ? t._switchToTextParsing(e, uo.RAWTEXT) : (t._insertElement(e, vt.HTML), t.insertionMode = ke.IN_HEAD_NO_SCRIPT);
      break;
    }
    case L.NOFRAMES:
    case L.STYLE: {
      t._switchToTextParsing(e, uo.RAWTEXT);
      break;
    }
    case L.SCRIPT: {
      t._switchToTextParsing(e, uo.SCRIPT_DATA);
      break;
    }
    case L.TEMPLATE: {
      t._insertTemplate(e), t.activeFormattingElements.insertMarker(), t.framesetOk = !1, t.insertionMode = ke.IN_TEMPLATE, t.tmplInsertionModeStack.unshift(ke.IN_TEMPLATE);
      break;
    }
    case L.HEAD: {
      t._err(e, ot.misplacedStartTagForHeadElement);
      break;
    }
    default:
      bT(t, e);
  }
}
function Dze(t, e) {
  switch (e.tagID) {
    case L.HEAD: {
      t.openElements.pop(), t.insertionMode = ke.AFTER_HEAD;
      break;
    }
    case L.BODY:
    case L.BR:
    case L.HTML: {
      bT(t, e);
      break;
    }
    case L.TEMPLATE: {
      P0(t, e);
      break;
    }
    default:
      t._err(e, ot.endTagWithoutMatchingOpenElement);
  }
}
function P0(t, e) {
  t.openElements.tmplCount > 0 ? (t.openElements.generateImpliedEndTagsThoroughly(), t.openElements.currentTagId !== L.TEMPLATE && t._err(e, ot.closingOfElementWithOpenChildElements), t.openElements.popUntilTagNamePopped(L.TEMPLATE), t.activeFormattingElements.clearToLastMarker(), t.tmplInsertionModeStack.shift(), t._resetInsertionMode()) : t._err(e, ot.endTagWithoutMatchingOpenElement);
}
function bT(t, e) {
  t.openElements.pop(), t.insertionMode = ke.AFTER_HEAD, t._processToken(e);
}
function Nze(t, e) {
  switch (e.tagID) {
    case L.HTML: {
      Ml(t, e);
      break;
    }
    case L.BASEFONT:
    case L.BGSOUND:
    case L.HEAD:
    case L.LINK:
    case L.META:
    case L.NOFRAMES:
    case L.STYLE: {
      np(t, e);
      break;
    }
    case L.NOSCRIPT: {
      t._err(e, ot.nestedNoscriptInHead);
      break;
    }
    default:
      vT(t, e);
  }
}
function Pze(t, e) {
  switch (e.tagID) {
    case L.NOSCRIPT: {
      t.openElements.pop(), t.insertionMode = ke.IN_HEAD;
      break;
    }
    case L.BR: {
      vT(t, e);
      break;
    }
    default:
      t._err(e, ot.endTagWithoutMatchingOpenElement);
  }
}
function vT(t, e) {
  const n = e.type === Tr.EOF ? ot.openElementsLeftAfterEof : ot.disallowedContentInNoscriptInHead;
  t._err(e, n), t.openElements.pop(), t.insertionMode = ke.IN_HEAD, t._processToken(e);
}
function Lze(t, e) {
  switch (e.tagID) {
    case L.HTML: {
      Ml(t, e);
      break;
    }
    case L.BODY: {
      t._insertElement(e, vt.HTML), t.framesetOk = !1, t.insertionMode = ke.IN_BODY;
      break;
    }
    case L.FRAMESET: {
      t._insertElement(e, vt.HTML), t.insertionMode = ke.IN_FRAMESET;
      break;
    }
    case L.BASE:
    case L.BASEFONT:
    case L.BGSOUND:
    case L.LINK:
    case L.META:
    case L.NOFRAMES:
    case L.SCRIPT:
    case L.STYLE:
    case L.TEMPLATE:
    case L.TITLE: {
      t._err(e, ot.abandonedHeadElementChild), t.openElements.push(t.headElement, L.HEAD), np(t, e), t.openElements.remove(t.headElement);
      break;
    }
    case L.HEAD: {
      t._err(e, ot.misplacedStartTagForHeadElement);
      break;
    }
    default:
      yT(t, e);
  }
}
function Mze(t, e) {
  switch (e.tagID) {
    case L.BODY:
    case L.HTML:
    case L.BR: {
      yT(t, e);
      break;
    }
    case L.TEMPLATE: {
      P0(t, e);
      break;
    }
    default:
      t._err(e, ot.endTagWithoutMatchingOpenElement);
  }
}
function yT(t, e) {
  t._insertFakeElement(Je.BODY, L.BODY), t.insertionMode = ke.IN_BODY, aN(t, e);
}
function aN(t, e) {
  switch (e.type) {
    case Tr.CHARACTER: {
      Que(t, e);
      break;
    }
    case Tr.WHITESPACE_CHARACTER: {
      Wue(t, e);
      break;
    }
    case Tr.COMMENT: {
      b5(t, e);
      break;
    }
    case Tr.START_TAG: {
      Ml(t, e);
      break;
    }
    case Tr.END_TAG: {
      iN(t, e);
      break;
    }
    case Tr.EOF: {
      Yue(t, e);
      break;
    }
  }
}
function Wue(t, e) {
  t._reconstructActiveFormattingElements(), t._insertCharacters(e);
}
function Que(t, e) {
  t._reconstructActiveFormattingElements(), t._insertCharacters(e), t.framesetOk = !1;
}
function Fze(t, e) {
  t.openElements.tmplCount === 0 && t.treeAdapter.adoptAttributes(t.openElements.items[0], e.attrs);
}
function $ze(t, e) {
  const n = t.openElements.tryPeekProperlyNestedBodyElement();
  n && t.openElements.tmplCount === 0 && (t.framesetOk = !1, t.treeAdapter.adoptAttributes(n, e.attrs));
}
function Bze(t, e) {
  const n = t.openElements.tryPeekProperlyNestedBodyElement();
  t.framesetOk && n && (t.treeAdapter.detachNode(n), t.openElements.popAllUpToHtmlElement(), t._insertElement(e, vt.HTML), t.insertionMode = ke.IN_FRAMESET);
}
function Uze(t, e) {
  t.openElements.hasInButtonScope(L.P) && t._closePElement(), t._insertElement(e, vt.HTML);
}
function zze(t, e) {
  t.openElements.hasInButtonScope(L.P) && t._closePElement(), Due(t.openElements.currentTagId) && t.openElements.pop(), t._insertElement(e, vt.HTML);
}
function Hze(t, e) {
  t.openElements.hasInButtonScope(L.P) && t._closePElement(), t._insertElement(e, vt.HTML), t.skipNextNewLine = !0, t.framesetOk = !1;
}
function Wze(t, e) {
  const n = t.openElements.tmplCount > 0;
  (!t.formElement || n) && (t.openElements.hasInButtonScope(L.P) && t._closePElement(), t._insertElement(e, vt.HTML), n || (t.formElement = t.openElements.current));
}
function Qze(t, e) {
  t.framesetOk = !1;
  const n = e.tagID;
  for (let r = t.openElements.stackTop; r >= 0; r--) {
    const a = t.openElements.tagIDs[r];
    if (n === L.LI && a === L.LI || (n === L.DD || n === L.DT) && (a === L.DD || a === L.DT)) {
      t.openElements.generateImpliedEndTagsWithExclusion(a), t.openElements.popUntilTagNamePopped(a);
      break;
    }
    if (a !== L.ADDRESS && a !== L.DIV && a !== L.P && t._isSpecialElement(t.openElements.items[r], a))
      break;
  }
  t.openElements.hasInButtonScope(L.P) && t._closePElement(), t._insertElement(e, vt.HTML);
}
function jze(t, e) {
  t.openElements.hasInButtonScope(L.P) && t._closePElement(), t._insertElement(e, vt.HTML), t.tokenizer.state = uo.PLAINTEXT;
}
function Gze(t, e) {
  t.openElements.hasInScope(L.BUTTON) && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilTagNamePopped(L.BUTTON)), t._reconstructActiveFormattingElements(), t._insertElement(e, vt.HTML), t.framesetOk = !1;
}
function Vze(t, e) {
  const n = t.activeFormattingElements.getElementEntryInScopeWithTagName(Je.A);
  n && (D7(t, e), t.openElements.remove(n.element), t.activeFormattingElements.removeEntry(n)), t._reconstructActiveFormattingElements(), t._insertElement(e, vt.HTML), t.activeFormattingElements.pushElement(t.openElements.current, e);
}
function Yze(t, e) {
  t._reconstructActiveFormattingElements(), t._insertElement(e, vt.HTML), t.activeFormattingElements.pushElement(t.openElements.current, e);
}
function Zze(t, e) {
  t._reconstructActiveFormattingElements(), t.openElements.hasInScope(L.NOBR) && (D7(t, e), t._reconstructActiveFormattingElements()), t._insertElement(e, vt.HTML), t.activeFormattingElements.pushElement(t.openElements.current, e);
}
function Xze(t, e) {
  t._reconstructActiveFormattingElements(), t._insertElement(e, vt.HTML), t.activeFormattingElements.insertMarker(), t.framesetOk = !1;
}
function qze(t, e) {
  t.treeAdapter.getDocumentMode(t.document) !== Lc.QUIRKS && t.openElements.hasInButtonScope(L.P) && t._closePElement(), t._insertElement(e, vt.HTML), t.framesetOk = !1, t.insertionMode = ke.IN_TABLE;
}
function jue(t, e) {
  t._reconstructActiveFormattingElements(), t._appendElement(e, vt.HTML), t.framesetOk = !1, e.ackSelfClosing = !0;
}
function Gue(t) {
  const e = kue(t, Xb.TYPE);
  return e != null && e.toLowerCase() === mze;
}
function Kze(t, e) {
  t._reconstructActiveFormattingElements(), t._appendElement(e, vt.HTML), Gue(e) || (t.framesetOk = !1), e.ackSelfClosing = !0;
}
function Jze(t, e) {
  t._appendElement(e, vt.HTML), e.ackSelfClosing = !0;
}
function e8e(t, e) {
  t.openElements.hasInButtonScope(L.P) && t._closePElement(), t._appendElement(e, vt.HTML), t.framesetOk = !1, e.ackSelfClosing = !0;
}
function t8e(t, e) {
  e.tagName = Je.IMG, e.tagID = L.IMG, jue(t, e);
}
function n8e(t, e) {
  t._insertElement(e, vt.HTML), t.skipNextNewLine = !0, t.tokenizer.state = uo.RCDATA, t.originalInsertionMode = t.insertionMode, t.framesetOk = !1, t.insertionMode = ke.TEXT;
}
function r8e(t, e) {
  t.openElements.hasInButtonScope(L.P) && t._closePElement(), t._reconstructActiveFormattingElements(), t.framesetOk = !1, t._switchToTextParsing(e, uo.RAWTEXT);
}
function a8e(t, e) {
  t.framesetOk = !1, t._switchToTextParsing(e, uo.RAWTEXT);
}
function MJ(t, e) {
  t._switchToTextParsing(e, uo.RAWTEXT);
}
function i8e(t, e) {
  t._reconstructActiveFormattingElements(), t._insertElement(e, vt.HTML), t.framesetOk = !1, t.insertionMode = t.insertionMode === ke.IN_TABLE || t.insertionMode === ke.IN_CAPTION || t.insertionMode === ke.IN_TABLE_BODY || t.insertionMode === ke.IN_ROW || t.insertionMode === ke.IN_CELL ? ke.IN_SELECT_IN_TABLE : ke.IN_SELECT;
}
function o8e(t, e) {
  t.openElements.currentTagId === L.OPTION && t.openElements.pop(), t._reconstructActiveFormattingElements(), t._insertElement(e, vt.HTML);
}
function s8e(t, e) {
  t.openElements.hasInScope(L.RUBY) && t.openElements.generateImpliedEndTags(), t._insertElement(e, vt.HTML);
}
function l8e(t, e) {
  t.openElements.hasInScope(L.RUBY) && t.openElements.generateImpliedEndTagsWithExclusion(L.RTC), t._insertElement(e, vt.HTML);
}
function u8e(t, e) {
  t._reconstructActiveFormattingElements(), Uue(e), I7(e), e.selfClosing ? t._appendElement(e, vt.MATHML) : t._insertElement(e, vt.MATHML), e.ackSelfClosing = !0;
}
function c8e(t, e) {
  t._reconstructActiveFormattingElements(), zue(e), I7(e), e.selfClosing ? t._appendElement(e, vt.SVG) : t._insertElement(e, vt.SVG), e.ackSelfClosing = !0;
}
function FJ(t, e) {
  t._reconstructActiveFormattingElements(), t._insertElement(e, vt.HTML);
}
function Ml(t, e) {
  switch (e.tagID) {
    case L.I:
    case L.S:
    case L.B:
    case L.U:
    case L.EM:
    case L.TT:
    case L.BIG:
    case L.CODE:
    case L.FONT:
    case L.SMALL:
    case L.STRIKE:
    case L.STRONG: {
      Yze(t, e);
      break;
    }
    case L.A: {
      Vze(t, e);
      break;
    }
    case L.H1:
    case L.H2:
    case L.H3:
    case L.H4:
    case L.H5:
    case L.H6: {
      zze(t, e);
      break;
    }
    case L.P:
    case L.DL:
    case L.OL:
    case L.UL:
    case L.DIV:
    case L.DIR:
    case L.NAV:
    case L.MAIN:
    case L.MENU:
    case L.ASIDE:
    case L.CENTER:
    case L.FIGURE:
    case L.FOOTER:
    case L.HEADER:
    case L.HGROUP:
    case L.DIALOG:
    case L.DETAILS:
    case L.ADDRESS:
    case L.ARTICLE:
    case L.SECTION:
    case L.SUMMARY:
    case L.FIELDSET:
    case L.BLOCKQUOTE:
    case L.FIGCAPTION: {
      Uze(t, e);
      break;
    }
    case L.LI:
    case L.DD:
    case L.DT: {
      Qze(t, e);
      break;
    }
    case L.BR:
    case L.IMG:
    case L.WBR:
    case L.AREA:
    case L.EMBED:
    case L.KEYGEN: {
      jue(t, e);
      break;
    }
    case L.HR: {
      e8e(t, e);
      break;
    }
    case L.RB:
    case L.RTC: {
      s8e(t, e);
      break;
    }
    case L.RT:
    case L.RP: {
      l8e(t, e);
      break;
    }
    case L.PRE:
    case L.LISTING: {
      Hze(t, e);
      break;
    }
    case L.XMP: {
      r8e(t, e);
      break;
    }
    case L.SVG: {
      c8e(t, e);
      break;
    }
    case L.HTML: {
      Fze(t, e);
      break;
    }
    case L.BASE:
    case L.LINK:
    case L.META:
    case L.STYLE:
    case L.TITLE:
    case L.SCRIPT:
    case L.BGSOUND:
    case L.BASEFONT:
    case L.TEMPLATE: {
      np(t, e);
      break;
    }
    case L.BODY: {
      $ze(t, e);
      break;
    }
    case L.FORM: {
      Wze(t, e);
      break;
    }
    case L.NOBR: {
      Zze(t, e);
      break;
    }
    case L.MATH: {
      u8e(t, e);
      break;
    }
    case L.TABLE: {
      qze(t, e);
      break;
    }
    case L.INPUT: {
      Kze(t, e);
      break;
    }
    case L.PARAM:
    case L.TRACK:
    case L.SOURCE: {
      Jze(t, e);
      break;
    }
    case L.IMAGE: {
      t8e(t, e);
      break;
    }
    case L.BUTTON: {
      Gze(t, e);
      break;
    }
    case L.APPLET:
    case L.OBJECT:
    case L.MARQUEE: {
      Xze(t, e);
      break;
    }
    case L.IFRAME: {
      a8e(t, e);
      break;
    }
    case L.SELECT: {
      i8e(t, e);
      break;
    }
    case L.OPTION:
    case L.OPTGROUP: {
      o8e(t, e);
      break;
    }
    case L.NOEMBED: {
      MJ(t, e);
      break;
    }
    case L.FRAMESET: {
      Bze(t, e);
      break;
    }
    case L.TEXTAREA: {
      n8e(t, e);
      break;
    }
    case L.NOSCRIPT: {
      t.options.scriptingEnabled ? MJ(t, e) : FJ(t, e);
      break;
    }
    case L.PLAINTEXT: {
      jze(t, e);
      break;
    }
    case L.COL:
    case L.TH:
    case L.TD:
    case L.TR:
    case L.HEAD:
    case L.FRAME:
    case L.TBODY:
    case L.TFOOT:
    case L.THEAD:
    case L.CAPTION:
    case L.COLGROUP:
      break;
    default:
      FJ(t, e);
  }
}
function f8e(t, e) {
  if (t.openElements.hasInScope(L.BODY) && (t.insertionMode = ke.AFTER_BODY, t.options.sourceCodeLocationInfo)) {
    const n = t.openElements.tryPeekProperlyNestedBodyElement();
    n && t._setEndLocation(n, e);
  }
}
function d8e(t, e) {
  t.openElements.hasInScope(L.BODY) && (t.insertionMode = ke.AFTER_BODY, nce(t, e));
}
function p8e(t, e) {
  const n = e.tagID;
  t.openElements.hasInScope(n) && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilTagNamePopped(n));
}
function h8e(t) {
  const e = t.openElements.tmplCount > 0, { formElement: n } = t;
  e || (t.formElement = null), (n || e) && t.openElements.hasInScope(L.FORM) && (t.openElements.generateImpliedEndTags(), e ? t.openElements.popUntilTagNamePopped(L.FORM) : n && t.openElements.remove(n));
}
function m8e(t) {
  t.openElements.hasInButtonScope(L.P) || t._insertFakeElement(Je.P, L.P), t._closePElement();
}
function g8e(t) {
  t.openElements.hasInListItemScope(L.LI) && (t.openElements.generateImpliedEndTagsWithExclusion(L.LI), t.openElements.popUntilTagNamePopped(L.LI));
}
function b8e(t, e) {
  const n = e.tagID;
  t.openElements.hasInScope(n) && (t.openElements.generateImpliedEndTagsWithExclusion(n), t.openElements.popUntilTagNamePopped(n));
}
function v8e(t) {
  t.openElements.hasNumberedHeaderInScope() && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilNumberedHeaderPopped());
}
function y8e(t, e) {
  const n = e.tagID;
  t.openElements.hasInScope(n) && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilTagNamePopped(n), t.activeFormattingElements.clearToLastMarker());
}
function O8e(t) {
  t._reconstructActiveFormattingElements(), t._insertFakeElement(Je.BR, L.BR), t.openElements.pop(), t.framesetOk = !1;
}
function Vue(t, e) {
  const n = e.tagName, r = e.tagID;
  for (let a = t.openElements.stackTop; a > 0; a--) {
    const i = t.openElements.items[a], o = t.openElements.tagIDs[a];
    if (r === o && (r !== L.UNKNOWN || t.treeAdapter.getTagName(i) === n)) {
      t.openElements.generateImpliedEndTagsWithExclusion(r), t.openElements.stackTop >= a && t.openElements.shortenToLength(a);
      break;
    }
    if (t._isSpecialElement(i, o))
      break;
  }
}
function iN(t, e) {
  switch (e.tagID) {
    case L.A:
    case L.B:
    case L.I:
    case L.S:
    case L.U:
    case L.EM:
    case L.TT:
    case L.BIG:
    case L.CODE:
    case L.FONT:
    case L.NOBR:
    case L.SMALL:
    case L.STRIKE:
    case L.STRONG: {
      D7(t, e);
      break;
    }
    case L.P: {
      m8e(t);
      break;
    }
    case L.DL:
    case L.UL:
    case L.OL:
    case L.DIR:
    case L.DIV:
    case L.NAV:
    case L.PRE:
    case L.MAIN:
    case L.MENU:
    case L.ASIDE:
    case L.BUTTON:
    case L.CENTER:
    case L.FIGURE:
    case L.FOOTER:
    case L.HEADER:
    case L.HGROUP:
    case L.DIALOG:
    case L.ADDRESS:
    case L.ARTICLE:
    case L.DETAILS:
    case L.SECTION:
    case L.SUMMARY:
    case L.LISTING:
    case L.FIELDSET:
    case L.BLOCKQUOTE:
    case L.FIGCAPTION: {
      p8e(t, e);
      break;
    }
    case L.LI: {
      g8e(t);
      break;
    }
    case L.DD:
    case L.DT: {
      b8e(t, e);
      break;
    }
    case L.H1:
    case L.H2:
    case L.H3:
    case L.H4:
    case L.H5:
    case L.H6: {
      v8e(t);
      break;
    }
    case L.BR: {
      O8e(t);
      break;
    }
    case L.BODY: {
      f8e(t, e);
      break;
    }
    case L.HTML: {
      d8e(t, e);
      break;
    }
    case L.FORM: {
      h8e(t);
      break;
    }
    case L.APPLET:
    case L.OBJECT:
    case L.MARQUEE: {
      y8e(t, e);
      break;
    }
    case L.TEMPLATE: {
      P0(t, e);
      break;
    }
    default:
      Vue(t, e);
  }
}
function Yue(t, e) {
  t.tmplInsertionModeStack.length > 0 ? tce(t, e) : N7(t, e);
}
function E8e(t, e) {
  var n;
  e.tagID === L.SCRIPT && ((n = t.scriptHandler) === null || n === void 0 || n.call(t, t.openElements.current)), t.openElements.pop(), t.insertionMode = t.originalInsertionMode;
}
function S8e(t, e) {
  t._err(e, ot.eofInElementThatCanContainOnlyText), t.openElements.pop(), t.insertionMode = t.originalInsertionMode, t.onEof(e);
}
function Z3(t, e) {
  if (Hue.has(t.openElements.currentTagId))
    switch (t.pendingCharacterTokens.length = 0, t.hasNonWhitespacePendingCharacterToken = !1, t.originalInsertionMode = t.insertionMode, t.insertionMode = ke.IN_TABLE_TEXT, e.type) {
      case Tr.CHARACTER: {
        Xue(t, e);
        break;
      }
      case Tr.WHITESPACE_CHARACTER: {
        Zue(t, e);
        break;
      }
    }
  else
    $_(t, e);
}
function w8e(t, e) {
  t.openElements.clearBackToTableContext(), t.activeFormattingElements.insertMarker(), t._insertElement(e, vt.HTML), t.insertionMode = ke.IN_CAPTION;
}
function T8e(t, e) {
  t.openElements.clearBackToTableContext(), t._insertElement(e, vt.HTML), t.insertionMode = ke.IN_COLUMN_GROUP;
}
function _8e(t, e) {
  t.openElements.clearBackToTableContext(), t._insertFakeElement(Je.COLGROUP, L.COLGROUP), t.insertionMode = ke.IN_COLUMN_GROUP, P7(t, e);
}
function C8e(t, e) {
  t.openElements.clearBackToTableContext(), t._insertElement(e, vt.HTML), t.insertionMode = ke.IN_TABLE_BODY;
}
function x8e(t, e) {
  t.openElements.clearBackToTableContext(), t._insertFakeElement(Je.TBODY, L.TBODY), t.insertionMode = ke.IN_TABLE_BODY, oN(t, e);
}
function A8e(t, e) {
  t.openElements.hasInTableScope(L.TABLE) && (t.openElements.popUntilTagNamePopped(L.TABLE), t._resetInsertionMode(), t._processStartTag(e));
}
function k8e(t, e) {
  Gue(e) ? t._appendElement(e, vt.HTML) : $_(t, e), e.ackSelfClosing = !0;
}
function R8e(t, e) {
  !t.formElement && t.openElements.tmplCount === 0 && (t._insertElement(e, vt.HTML), t.formElement = t.openElements.current, t.openElements.pop());
}
function n1(t, e) {
  switch (e.tagID) {
    case L.TD:
    case L.TH:
    case L.TR: {
      x8e(t, e);
      break;
    }
    case L.STYLE:
    case L.SCRIPT:
    case L.TEMPLATE: {
      np(t, e);
      break;
    }
    case L.COL: {
      _8e(t, e);
      break;
    }
    case L.FORM: {
      R8e(t, e);
      break;
    }
    case L.TABLE: {
      A8e(t, e);
      break;
    }
    case L.TBODY:
    case L.TFOOT:
    case L.THEAD: {
      C8e(t, e);
      break;
    }
    case L.INPUT: {
      k8e(t, e);
      break;
    }
    case L.CAPTION: {
      w8e(t, e);
      break;
    }
    case L.COLGROUP: {
      T8e(t, e);
      break;
    }
    default:
      $_(t, e);
  }
}
function o_(t, e) {
  switch (e.tagID) {
    case L.TABLE: {
      t.openElements.hasInTableScope(L.TABLE) && (t.openElements.popUntilTagNamePopped(L.TABLE), t._resetInsertionMode());
      break;
    }
    case L.TEMPLATE: {
      P0(t, e);
      break;
    }
    case L.BODY:
    case L.CAPTION:
    case L.COL:
    case L.COLGROUP:
    case L.HTML:
    case L.TBODY:
    case L.TD:
    case L.TFOOT:
    case L.TH:
    case L.THEAD:
    case L.TR:
      break;
    default:
      $_(t, e);
  }
}
function $_(t, e) {
  const n = t.fosterParentingEnabled;
  t.fosterParentingEnabled = !0, aN(t, e), t.fosterParentingEnabled = n;
}
function Zue(t, e) {
  t.pendingCharacterTokens.push(e);
}
function Xue(t, e) {
  t.pendingCharacterTokens.push(e), t.hasNonWhitespacePendingCharacterToken = !0;
}
function Iw(t, e) {
  let n = 0;
  if (t.hasNonWhitespacePendingCharacterToken)
    for (; n < t.pendingCharacterTokens.length; n++)
      $_(t, t.pendingCharacterTokens[n]);
  else
    for (; n < t.pendingCharacterTokens.length; n++)
      t._insertCharacters(t.pendingCharacterTokens[n]);
  t.insertionMode = t.originalInsertionMode, t._processToken(e);
}
const que = /* @__PURE__ */ new Set([L.CAPTION, L.COL, L.COLGROUP, L.TBODY, L.TD, L.TFOOT, L.TH, L.THEAD, L.TR]);
function I8e(t, e) {
  const n = e.tagID;
  que.has(n) ? t.openElements.hasInTableScope(L.CAPTION) && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilTagNamePopped(L.CAPTION), t.activeFormattingElements.clearToLastMarker(), t.insertionMode = ke.IN_TABLE, n1(t, e)) : Ml(t, e);
}
function D8e(t, e) {
  const n = e.tagID;
  switch (n) {
    case L.CAPTION:
    case L.TABLE: {
      t.openElements.hasInTableScope(L.CAPTION) && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilTagNamePopped(L.CAPTION), t.activeFormattingElements.clearToLastMarker(), t.insertionMode = ke.IN_TABLE, n === L.TABLE && o_(t, e));
      break;
    }
    case L.BODY:
    case L.COL:
    case L.COLGROUP:
    case L.HTML:
    case L.TBODY:
    case L.TD:
    case L.TFOOT:
    case L.TH:
    case L.THEAD:
    case L.TR:
      break;
    default:
      iN(t, e);
  }
}
function P7(t, e) {
  switch (e.tagID) {
    case L.HTML: {
      Ml(t, e);
      break;
    }
    case L.COL: {
      t._appendElement(e, vt.HTML), e.ackSelfClosing = !0;
      break;
    }
    case L.TEMPLATE: {
      np(t, e);
      break;
    }
    default:
      PI(t, e);
  }
}
function N8e(t, e) {
  switch (e.tagID) {
    case L.COLGROUP: {
      t.openElements.currentTagId === L.COLGROUP && (t.openElements.pop(), t.insertionMode = ke.IN_TABLE);
      break;
    }
    case L.TEMPLATE: {
      P0(t, e);
      break;
    }
    case L.COL:
      break;
    default:
      PI(t, e);
  }
}
function PI(t, e) {
  t.openElements.currentTagId === L.COLGROUP && (t.openElements.pop(), t.insertionMode = ke.IN_TABLE, t._processToken(e));
}
function oN(t, e) {
  switch (e.tagID) {
    case L.TR: {
      t.openElements.clearBackToTableBodyContext(), t._insertElement(e, vt.HTML), t.insertionMode = ke.IN_ROW;
      break;
    }
    case L.TH:
    case L.TD: {
      t.openElements.clearBackToTableBodyContext(), t._insertFakeElement(Je.TR, L.TR), t.insertionMode = ke.IN_ROW, sN(t, e);
      break;
    }
    case L.CAPTION:
    case L.COL:
    case L.COLGROUP:
    case L.TBODY:
    case L.TFOOT:
    case L.THEAD: {
      t.openElements.hasTableBodyContextInTableScope() && (t.openElements.clearBackToTableBodyContext(), t.openElements.pop(), t.insertionMode = ke.IN_TABLE, n1(t, e));
      break;
    }
    default:
      n1(t, e);
  }
}
function v5(t, e) {
  const n = e.tagID;
  switch (e.tagID) {
    case L.TBODY:
    case L.TFOOT:
    case L.THEAD: {
      t.openElements.hasInTableScope(n) && (t.openElements.clearBackToTableBodyContext(), t.openElements.pop(), t.insertionMode = ke.IN_TABLE);
      break;
    }
    case L.TABLE: {
      t.openElements.hasTableBodyContextInTableScope() && (t.openElements.clearBackToTableBodyContext(), t.openElements.pop(), t.insertionMode = ke.IN_TABLE, o_(t, e));
      break;
    }
    case L.BODY:
    case L.CAPTION:
    case L.COL:
    case L.COLGROUP:
    case L.HTML:
    case L.TD:
    case L.TH:
    case L.TR:
      break;
    default:
      o_(t, e);
  }
}
function sN(t, e) {
  switch (e.tagID) {
    case L.TH:
    case L.TD: {
      t.openElements.clearBackToTableRowContext(), t._insertElement(e, vt.HTML), t.insertionMode = ke.IN_CELL, t.activeFormattingElements.insertMarker();
      break;
    }
    case L.CAPTION:
    case L.COL:
    case L.COLGROUP:
    case L.TBODY:
    case L.TFOOT:
    case L.THEAD:
    case L.TR: {
      t.openElements.hasInTableScope(L.TR) && (t.openElements.clearBackToTableRowContext(), t.openElements.pop(), t.insertionMode = ke.IN_TABLE_BODY, oN(t, e));
      break;
    }
    default:
      n1(t, e);
  }
}
function Kue(t, e) {
  switch (e.tagID) {
    case L.TR: {
      t.openElements.hasInTableScope(L.TR) && (t.openElements.clearBackToTableRowContext(), t.openElements.pop(), t.insertionMode = ke.IN_TABLE_BODY);
      break;
    }
    case L.TABLE: {
      t.openElements.hasInTableScope(L.TR) && (t.openElements.clearBackToTableRowContext(), t.openElements.pop(), t.insertionMode = ke.IN_TABLE_BODY, v5(t, e));
      break;
    }
    case L.TBODY:
    case L.TFOOT:
    case L.THEAD: {
      (t.openElements.hasInTableScope(e.tagID) || t.openElements.hasInTableScope(L.TR)) && (t.openElements.clearBackToTableRowContext(), t.openElements.pop(), t.insertionMode = ke.IN_TABLE_BODY, v5(t, e));
      break;
    }
    case L.BODY:
    case L.CAPTION:
    case L.COL:
    case L.COLGROUP:
    case L.HTML:
    case L.TD:
    case L.TH:
      break;
    default:
      o_(t, e);
  }
}
function P8e(t, e) {
  const n = e.tagID;
  que.has(n) ? (t.openElements.hasInTableScope(L.TD) || t.openElements.hasInTableScope(L.TH)) && (t._closeTableCell(), sN(t, e)) : Ml(t, e);
}
function L8e(t, e) {
  const n = e.tagID;
  switch (n) {
    case L.TD:
    case L.TH: {
      t.openElements.hasInTableScope(n) && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilTagNamePopped(n), t.activeFormattingElements.clearToLastMarker(), t.insertionMode = ke.IN_ROW);
      break;
    }
    case L.TABLE:
    case L.TBODY:
    case L.TFOOT:
    case L.THEAD:
    case L.TR: {
      t.openElements.hasInTableScope(n) && (t._closeTableCell(), Kue(t, e));
      break;
    }
    case L.BODY:
    case L.CAPTION:
    case L.COL:
    case L.COLGROUP:
    case L.HTML:
      break;
    default:
      iN(t, e);
  }
}
function Jue(t, e) {
  switch (e.tagID) {
    case L.HTML: {
      Ml(t, e);
      break;
    }
    case L.OPTION: {
      t.openElements.currentTagId === L.OPTION && t.openElements.pop(), t._insertElement(e, vt.HTML);
      break;
    }
    case L.OPTGROUP: {
      t.openElements.currentTagId === L.OPTION && t.openElements.pop(), t.openElements.currentTagId === L.OPTGROUP && t.openElements.pop(), t._insertElement(e, vt.HTML);
      break;
    }
    case L.INPUT:
    case L.KEYGEN:
    case L.TEXTAREA:
    case L.SELECT: {
      t.openElements.hasInSelectScope(L.SELECT) && (t.openElements.popUntilTagNamePopped(L.SELECT), t._resetInsertionMode(), e.tagID !== L.SELECT && t._processStartTag(e));
      break;
    }
    case L.SCRIPT:
    case L.TEMPLATE: {
      np(t, e);
      break;
    }
  }
}
function ece(t, e) {
  switch (e.tagID) {
    case L.OPTGROUP: {
      t.openElements.stackTop > 0 && t.openElements.currentTagId === L.OPTION && t.openElements.tagIDs[t.openElements.stackTop - 1] === L.OPTGROUP && t.openElements.pop(), t.openElements.currentTagId === L.OPTGROUP && t.openElements.pop();
      break;
    }
    case L.OPTION: {
      t.openElements.currentTagId === L.OPTION && t.openElements.pop();
      break;
    }
    case L.SELECT: {
      t.openElements.hasInSelectScope(L.SELECT) && (t.openElements.popUntilTagNamePopped(L.SELECT), t._resetInsertionMode());
      break;
    }
    case L.TEMPLATE: {
      P0(t, e);
      break;
    }
  }
}
function M8e(t, e) {
  const n = e.tagID;
  n === L.CAPTION || n === L.TABLE || n === L.TBODY || n === L.TFOOT || n === L.THEAD || n === L.TR || n === L.TD || n === L.TH ? (t.openElements.popUntilTagNamePopped(L.SELECT), t._resetInsertionMode(), t._processStartTag(e)) : Jue(t, e);
}
function F8e(t, e) {
  const n = e.tagID;
  n === L.CAPTION || n === L.TABLE || n === L.TBODY || n === L.TFOOT || n === L.THEAD || n === L.TR || n === L.TD || n === L.TH ? t.openElements.hasInTableScope(n) && (t.openElements.popUntilTagNamePopped(L.SELECT), t._resetInsertionMode(), t.onEndTag(e)) : ece(t, e);
}
function $8e(t, e) {
  switch (e.tagID) {
    case L.BASE:
    case L.BASEFONT:
    case L.BGSOUND:
    case L.LINK:
    case L.META:
    case L.NOFRAMES:
    case L.SCRIPT:
    case L.STYLE:
    case L.TEMPLATE:
    case L.TITLE: {
      np(t, e);
      break;
    }
    case L.CAPTION:
    case L.COLGROUP:
    case L.TBODY:
    case L.TFOOT:
    case L.THEAD: {
      t.tmplInsertionModeStack[0] = ke.IN_TABLE, t.insertionMode = ke.IN_TABLE, n1(t, e);
      break;
    }
    case L.COL: {
      t.tmplInsertionModeStack[0] = ke.IN_COLUMN_GROUP, t.insertionMode = ke.IN_COLUMN_GROUP, P7(t, e);
      break;
    }
    case L.TR: {
      t.tmplInsertionModeStack[0] = ke.IN_TABLE_BODY, t.insertionMode = ke.IN_TABLE_BODY, oN(t, e);
      break;
    }
    case L.TD:
    case L.TH: {
      t.tmplInsertionModeStack[0] = ke.IN_ROW, t.insertionMode = ke.IN_ROW, sN(t, e);
      break;
    }
    default:
      t.tmplInsertionModeStack[0] = ke.IN_BODY, t.insertionMode = ke.IN_BODY, Ml(t, e);
  }
}
function B8e(t, e) {
  e.tagID === L.TEMPLATE && P0(t, e);
}
function tce(t, e) {
  t.openElements.tmplCount > 0 ? (t.openElements.popUntilTagNamePopped(L.TEMPLATE), t.activeFormattingElements.clearToLastMarker(), t.tmplInsertionModeStack.shift(), t._resetInsertionMode(), t.onEof(e)) : N7(t, e);
}
function U8e(t, e) {
  e.tagID === L.HTML ? Ml(t, e) : LI(t, e);
}
function nce(t, e) {
  var n;
  if (e.tagID === L.HTML) {
    if (t.fragmentContext || (t.insertionMode = ke.AFTER_AFTER_BODY), t.options.sourceCodeLocationInfo && t.openElements.tagIDs[0] === L.HTML) {
      t._setEndLocation(t.openElements.items[0], e);
      const r = t.openElements.items[1];
      r && !(!((n = t.treeAdapter.getNodeSourceCodeLocation(r)) === null || n === void 0) && n.endTag) && t._setEndLocation(r, e);
    }
  } else
    LI(t, e);
}
function LI(t, e) {
  t.insertionMode = ke.IN_BODY, aN(t, e);
}
function z8e(t, e) {
  switch (e.tagID) {
    case L.HTML: {
      Ml(t, e);
      break;
    }
    case L.FRAMESET: {
      t._insertElement(e, vt.HTML);
      break;
    }
    case L.FRAME: {
      t._appendElement(e, vt.HTML), e.ackSelfClosing = !0;
      break;
    }
    case L.NOFRAMES: {
      np(t, e);
      break;
    }
  }
}
function H8e(t, e) {
  e.tagID === L.FRAMESET && !t.openElements.isRootHtmlElementCurrent() && (t.openElements.pop(), !t.fragmentContext && t.openElements.currentTagId !== L.FRAMESET && (t.insertionMode = ke.AFTER_FRAMESET));
}
function W8e(t, e) {
  switch (e.tagID) {
    case L.HTML: {
      Ml(t, e);
      break;
    }
    case L.NOFRAMES: {
      np(t, e);
      break;
    }
  }
}
function Q8e(t, e) {
  e.tagID === L.HTML && (t.insertionMode = ke.AFTER_AFTER_FRAMESET);
}
function j8e(t, e) {
  e.tagID === L.HTML ? Ml(t, e) : Fk(t, e);
}
function Fk(t, e) {
  t.insertionMode = ke.IN_BODY, aN(t, e);
}
function G8e(t, e) {
  switch (e.tagID) {
    case L.HTML: {
      Ml(t, e);
      break;
    }
    case L.NOFRAMES: {
      np(t, e);
      break;
    }
  }
}
function V8e(t, e) {
  e.chars = Oi, t._insertCharacters(e);
}
function Y8e(t, e) {
  t._insertCharacters(e), t.framesetOk = !1;
}
function rce(t) {
  for (; t.treeAdapter.getNamespaceURI(t.openElements.current) !== vt.HTML && !t._isIntegrationPoint(t.openElements.currentTagId, t.openElements.current); )
    t.openElements.pop();
}
function Z8e(t, e) {
  if (cze(e))
    rce(t), t._startTagOutsideForeignContent(e);
  else {
    const n = t._getAdjustedCurrentElement(), r = t.treeAdapter.getNamespaceURI(n);
    r === vt.MATHML ? Uue(e) : r === vt.SVG && (fze(e), zue(e)), I7(e), e.selfClosing ? t._appendElement(e, r) : t._insertElement(e, r), e.ackSelfClosing = !0;
  }
}
function X8e(t, e) {
  if (e.tagID === L.P || e.tagID === L.BR) {
    rce(t), t._endTagOutsideForeignContent(e);
    return;
  }
  for (let n = t.openElements.stackTop; n > 0; n--) {
    const r = t.openElements.items[n];
    if (t.treeAdapter.getNamespaceURI(r) === vt.HTML) {
      t._endTagOutsideForeignContent(e);
      break;
    }
    const a = t.treeAdapter.getTagName(r);
    if (a.toLowerCase() === e.tagName) {
      e.tagName = a, t.openElements.shortenToLength(n);
      break;
    }
  }
}
Je.AREA, Je.BASE, Je.BASEFONT, Je.BGSOUND, Je.BR, Je.COL, Je.EMBED, Je.FRAME, Je.HR, Je.IMG, Je.INPUT, Je.KEYGEN, Je.LINK, Je.META, Je.PARAM, Je.SOURCE, Je.TRACK, Je.WBR;
const lN = ace("end"), Mh = ace("start");
function ace(t) {
  return e;
  function e(n) {
    const r = n && n.position && n.position[t] || {};
    if (typeof r.line == "number" && r.line > 0 && typeof r.column == "number" && r.column > 0)
      return {
        line: r.line,
        column: r.column,
        offset: typeof r.offset == "number" && r.offset > -1 ? r.offset : void 0
      };
  }
}
function q8e(t) {
  const e = Mh(t), n = lN(t);
  if (e && n)
    return { start: e, end: n };
}
const ice = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(t) {
    if (t == null)
      return tHe;
    if (typeof t == "function")
      return uN(t);
    if (typeof t == "object")
      return Array.isArray(t) ? K8e(t) : J8e(t);
    if (typeof t == "string")
      return eHe(t);
    throw new Error("Expected function, string, or object as test");
  }
);
function K8e(t) {
  const e = [];
  let n = -1;
  for (; ++n < t.length; )
    e[n] = ice(t[n]);
  return uN(r);
  function r(...a) {
    let i = -1;
    for (; ++i < e.length; )
      if (e[i].apply(this, a))
        return !0;
    return !1;
  }
}
function J8e(t) {
  const e = (
    /** @type {Record<string, unknown>} */
    t
  );
  return uN(n);
  function n(r) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let i;
    for (i in t)
      if (a[i] !== e[i])
        return !1;
    return !0;
  }
}
function eHe(t) {
  return uN(e);
  function e(n) {
    return n && n.type === t;
  }
}
function uN(t) {
  return e;
  function e(n, r, a) {
    return !!(nHe(n) && t.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      a || void 0
    ));
  }
}
function tHe() {
  return !0;
}
function nHe(t) {
  return t !== null && typeof t == "object" && "type" in t;
}
const oce = [], rHe = !0, $J = !1, aHe = "skip";
function iHe(t, e, n, r) {
  let a;
  typeof e == "function" && typeof n != "function" ? (r = n, n = e) : a = e;
  const i = ice(a), o = r ? -1 : 1;
  s(t, void 0, [])();
  function s(u, f, p) {
    const m = (
      /** @type {Record<string, unknown>} */
      u && typeof u == "object" ? u : {}
    );
    if (typeof m.type == "string") {
      const O = (
        // `hast`
        typeof m.tagName == "string" ? m.tagName : (
          // `xast`
          typeof m.name == "string" ? m.name : void 0
        )
      );
      Object.defineProperty(v, "name", {
        value: "node (" + (u.type + (O ? "<" + O + ">" : "")) + ")"
      });
    }
    return v;
    function v() {
      let O = oce, w, _, C;
      if ((!e || i(u, f, p[p.length - 1] || void 0)) && (O = oHe(n(u, p)), O[0] === $J))
        return O;
      if ("children" in u && u.children) {
        const A = (
          /** @type {UnistParent} */
          u
        );
        if (A.children && O[0] !== aHe)
          for (_ = (r ? A.children.length : -1) + o, C = p.concat(A); _ > -1 && _ < A.children.length; ) {
            const N = A.children[_];
            if (w = s(N, _, C)(), w[0] === $J)
              return w;
            _ = typeof w[1] == "number" ? w[1] : _ + o;
          }
      }
      return O;
    }
  }
}
function oHe(t) {
  return Array.isArray(t) ? t : typeof t == "number" ? [rHe, t] : t == null ? oce : [t];
}
function sHe(t, e, n, r) {
  let a, i, o;
  typeof e == "function" && typeof n != "function" ? (i = void 0, o = e, a = n) : (i = e, o = n, a = r), iHe(t, i, s, a);
  function s(u, f) {
    const p = f[f.length - 1], m = p ? p.children.indexOf(u) : void 0;
    return o(u, m, p);
  }
}
const lHe = /* @__PURE__ */ new Set([
  "mdxFlowExpression",
  "mdxJsxFlowElement",
  "mdxJsxTextElement",
  "mdxTextExpression",
  "mdxjsEsm"
]), BJ = { sourceCodeLocationInfo: !0, scriptingEnabled: !1 };
function sce(t, e) {
  const n = vHe(t), r = w7("type", {
    handlers: { root: uHe, element: cHe, text: fHe, comment: uce, doctype: dHe, raw: hHe },
    unknown: mHe
  }), a = {
    parser: n ? new LJ(BJ) : LJ.getFragmentParser(void 0, BJ),
    handle(s) {
      r(s, a);
    },
    stitches: !1,
    options: e || {}
  };
  r(t, a), C1(a, Mh());
  const i = n ? a.parser.document : a.parser.getFragment(), o = l9e(i, {
    // To do: support `space`?
    file: a.options.file
  });
  return a.stitches && sHe(o, "comment", function(s, u, f) {
    const p = (
      /** @type {Stitch} */
      /** @type {unknown} */
      s
    );
    if (p.value.stitch && f && u !== void 0) {
      const m = f.children;
      return m[u] = p.value.stitch, u;
    }
  }), o.type === "root" && o.children.length === 1 && o.children[0].type === t.type ? o.children[0] : o;
}
function lce(t, e) {
  let n = -1;
  if (t)
    for (; ++n < t.length; )
      e.handle(t[n]);
}
function uHe(t, e) {
  lce(t.children, e);
}
function cHe(t, e) {
  gHe(t, e), lce(t.children, e), bHe(t, e);
}
function fHe(t, e) {
  const n = {
    type: Tr.CHARACTER,
    chars: t.value,
    location: B_(t)
  };
  C1(e, Mh(t)), e.parser.currentToken = n, e.parser._processToken(e.parser.currentToken);
}
function dHe(t, e) {
  const n = {
    type: Tr.DOCTYPE,
    name: "html",
    forceQuirks: !1,
    publicId: "",
    systemId: "",
    location: B_(t)
  };
  C1(e, Mh(t)), e.parser.currentToken = n, e.parser._processToken(e.parser.currentToken);
}
function pHe(t, e) {
  e.stitches = !0;
  const n = yHe(t);
  if ("children" in t && "children" in n) {
    const r = (
      /** @type {Root} */
      sce({ type: "root", children: t.children }, e.options)
    );
    n.children = r.children;
  }
  uce({ type: "comment", value: { stitch: n } }, e);
}
function uce(t, e) {
  const n = t.value, r = {
    type: Tr.COMMENT,
    data: n,
    location: B_(t)
  };
  C1(e, Mh(t)), e.parser.currentToken = r, e.parser._processToken(e.parser.currentToken);
}
function hHe(t, e) {
  if (e.parser.tokenizer.preprocessor.html = "", e.parser.tokenizer.preprocessor.pos = -1, e.parser.tokenizer.preprocessor.lastGapPos = -2, e.parser.tokenizer.preprocessor.gapStack = [], e.parser.tokenizer.preprocessor.skipNextNewLine = !1, e.parser.tokenizer.preprocessor.lastChunkWritten = !1, e.parser.tokenizer.preprocessor.endOfChunkHit = !1, e.parser.tokenizer.preprocessor.isEol = !1, cce(e, Mh(t)), e.parser.tokenizer.write(t.value, !1), e.parser.tokenizer._runParsingLoop(), e.parser.tokenizer.state === 72 || e.parser.tokenizer.state === 78) {
    e.parser.tokenizer.preprocessor.lastChunkWritten = !0;
    const n = e.parser.tokenizer._consume();
    e.parser.tokenizer._callState(n);
  }
}
function mHe(t, e) {
  const n = (
    /** @type {Nodes} */
    t
  );
  if (e.options.passThrough && e.options.passThrough.includes(n.type))
    pHe(n, e);
  else {
    let r = "";
    throw lHe.has(n.type) && (r = ". It looks like you are using MDX nodes with `hast-util-raw` (or `rehype-raw`). If you use this because you are using remark or rehype plugins that inject `'html'` nodes, then please raise an issue with that plugin, as its a bad and slow idea. If you use this because you are using markdown syntax, then you have to configure this utility (or plugin) to pass through these nodes (see `passThrough` in docs), but you can also migrate to use the MDX syntax"), new Error("Cannot compile `" + n.type + "` node" + r);
  }
}
function C1(t, e) {
  cce(t, e);
  const n = t.parser.tokenizer.currentCharacterToken;
  n && n.location && (n.location.endLine = t.parser.tokenizer.preprocessor.line, n.location.endCol = t.parser.tokenizer.preprocessor.col + 1, n.location.endOffset = t.parser.tokenizer.preprocessor.offset + 1, t.parser.currentToken = n, t.parser._processToken(t.parser.currentToken)), t.parser.tokenizer.paused = !1, t.parser.tokenizer.inLoop = !1, t.parser.tokenizer.active = !1, t.parser.tokenizer.returnState = uo.DATA, t.parser.tokenizer.charRefCode = -1, t.parser.tokenizer.consumedAfterSnapshot = -1, t.parser.tokenizer.currentLocation = null, t.parser.tokenizer.currentCharacterToken = null, t.parser.tokenizer.currentToken = null, t.parser.tokenizer.currentAttr = { name: "", value: "" };
}
function cce(t, e) {
  if (e && e.offset !== void 0) {
    const n = {
      startLine: e.line,
      startCol: e.column,
      startOffset: e.offset,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    };
    t.parser.tokenizer.preprocessor.lineStartPos = -e.column + 1, t.parser.tokenizer.preprocessor.droppedBufferSize = e.offset, t.parser.tokenizer.preprocessor.line = e.line, t.parser.tokenizer.currentLocation = n;
  }
}
function gHe(t, e) {
  if (e.parser.tokenizer.state === uo.PLAINTEXT)
    return;
  C1(e, Mh(t));
  const n = e.parser.openElements.current;
  let r = "namespaceURI" in n ? n.namespaceURI : e0.html;
  r === e0.html && t.tagName === "svg" && (r = e0.svg);
  const a = h9e(
    // Shallow clone to not delve into `children`: we only need the attributes.
    { ...t, children: [] },
    { space: r === e0.svg ? "svg" : "html" }
  ), i = "attrs" in a ? a.attrs : [], o = {
    type: Tr.START_TAG,
    tagName: t.tagName,
    tagID: _1(t.tagName),
    // We always send start and end tags.
    selfClosing: !1,
    ackSelfClosing: !1,
    attrs: i,
    location: B_(t)
  };
  e.parser.currentToken = o, e.parser._processToken(e.parser.currentToken), e.parser.tokenizer.lastStartTagName = t.tagName;
}
function bHe(t, e) {
  if (!e.parser.tokenizer.inForeignNode && S9e.includes(t.tagName) || e.parser.tokenizer.state === uo.PLAINTEXT)
    return;
  C1(e, lN(t));
  const n = {
    type: Tr.END_TAG,
    tagName: t.tagName,
    tagID: _1(t.tagName),
    selfClosing: !1,
    ackSelfClosing: !1,
    attrs: [],
    location: B_(t)
  };
  e.parser.currentToken = n, e.parser._processToken(e.parser.currentToken), // Current element is closed.
  n.tagName === e.parser.tokenizer.lastStartTagName && // `<textarea>` and `<title>`
  (e.parser.tokenizer.state === uo.RCDATA || // `<iframe>`, `<noembed>`, `<style>`, `<xmp>`
  e.parser.tokenizer.state === uo.RAWTEXT || // `<script>`
  e.parser.tokenizer.state === uo.SCRIPT_DATA) && (e.parser.tokenizer.state = uo.DATA);
}
function vHe(t) {
  const e = t.type === "root" ? t.children[0] : t;
  return !!(e && (e.type === "doctype" || e.type === "element" && e.tagName === "html"));
}
function B_(t) {
  const e = Mh(t) || {
    line: void 0,
    column: void 0,
    offset: void 0
  }, n = lN(t) || {
    line: void 0,
    column: void 0,
    offset: void 0
  };
  return {
    startLine: e.line,
    startCol: e.column,
    startOffset: e.offset,
    endLine: n.line,
    endCol: n.column,
    endOffset: n.offset
  };
}
function yHe(t) {
  return "children" in t ? y0({ ...t, children: [] }) : y0(t);
}
function fce(t) {
  return function(e, n) {
    return (
      /** @type {Root} */
      sce(e, { ...t, file: n })
    );
  };
}
function OHe(t) {
  return t.join(" ").trim();
}
var L7 = { exports: {} }, UJ = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, EHe = /\n/g, SHe = /^\s*/, wHe = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, THe = /^:\s*/, _He = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, CHe = /^[;\s]*/, xHe = /^\s+|\s+$/g, AHe = `
`, zJ = "/", HJ = "*", qy = "", kHe = "comment", RHe = "declaration", IHe = function(t, e) {
  if (typeof t != "string")
    throw new TypeError("First argument must be a string");
  if (!t)
    return [];
  e = e || {};
  var n = 1, r = 1;
  function a(w) {
    var _ = w.match(EHe);
    _ && (n += _.length);
    var C = w.lastIndexOf(AHe);
    r = ~C ? w.length - C : r + w.length;
  }
  function i() {
    var w = { line: n, column: r };
    return function(_) {
      return _.position = new o(w), f(), _;
    };
  }
  function o(w) {
    this.start = w, this.end = { line: n, column: r }, this.source = e.source;
  }
  o.prototype.content = t;
  function s(w) {
    var _ = new Error(
      e.source + ":" + n + ":" + r + ": " + w
    );
    if (_.reason = w, _.filename = e.source, _.line = n, _.column = r, _.source = t, !e.silent)
      throw _;
  }
  function u(w) {
    var _ = w.exec(t);
    if (_) {
      var C = _[0];
      return a(C), t = t.slice(C.length), _;
    }
  }
  function f() {
    u(SHe);
  }
  function p(w) {
    var _;
    for (w = w || []; _ = m(); )
      _ !== !1 && w.push(_);
    return w;
  }
  function m() {
    var w = i();
    if (!(zJ != t.charAt(0) || HJ != t.charAt(1))) {
      for (var _ = 2; qy != t.charAt(_) && (HJ != t.charAt(_) || zJ != t.charAt(_ + 1)); )
        ++_;
      if (_ += 2, qy === t.charAt(_ - 1))
        return s("End of comment missing");
      var C = t.slice(2, _ - 2);
      return r += 2, a(C), t = t.slice(_), r += 2, w({
        type: kHe,
        comment: C
      });
    }
  }
  function v() {
    var w = i(), _ = u(wHe);
    if (_) {
      if (m(), !u(THe))
        return s("property missing ':'");
      var C = u(_He), A = w({
        type: RHe,
        property: WJ(_[0].replace(UJ, qy)),
        value: C ? WJ(C[0].replace(UJ, qy)) : qy
      });
      return u(CHe), A;
    }
  }
  function O() {
    var w = [];
    p(w);
    for (var _; _ = v(); )
      _ !== !1 && (w.push(_), p(w));
    return w;
  }
  return f(), O();
};
function WJ(t) {
  return t ? t.replace(xHe, qy) : qy;
}
var DHe = IHe;
function dce(t, e) {
  var n = null;
  if (!t || typeof t != "string")
    return n;
  for (var r, a = DHe(t), i = typeof e == "function", o, s, u = 0, f = a.length; u < f; u++)
    r = a[u], o = r.property, s = r.value, i ? e(o, s, r) : s && (n || (n = {}), n[o] = s);
  return n;
}
L7.exports = dce;
L7.exports.default = dce;
var NHe = L7.exports;
const PHe = /* @__PURE__ */ Pl(NHe);
function OT(t) {
  return !t || typeof t != "object" ? "" : "position" in t || "type" in t ? QJ(t.position) : "start" in t || "end" in t ? QJ(t) : "line" in t || "column" in t ? y5(t) : "";
}
function y5(t) {
  return jJ(t && t.line) + ":" + jJ(t && t.column);
}
function QJ(t) {
  return y5(t && t.start) + "-" + y5(t && t.end);
}
function jJ(t) {
  return t && typeof t == "number" ? t : 1;
}
class mu extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(e, n, r) {
    super(), typeof n == "string" && (r = n, n = void 0);
    let a = "", i = {}, o = !1;
    if (n && ("line" in n && "column" in n ? i = { place: n } : "start" in n && "end" in n ? i = { place: n } : "type" in n ? i = {
      ancestors: [n],
      place: n.position
    } : i = { ...n }), typeof e == "string" ? a = e : !i.cause && e && (o = !0, a = e.message, i.cause = e), !i.ruleId && !i.source && typeof r == "string") {
      const u = r.indexOf(":");
      u === -1 ? i.ruleId = r : (i.source = r.slice(0, u), i.ruleId = r.slice(u + 1));
    }
    if (!i.place && i.ancestors && i.ancestors) {
      const u = i.ancestors[i.ancestors.length - 1];
      u && (i.place = u.position);
    }
    const s = i.place && "start" in i.place ? i.place.start : i.place;
    this.ancestors = i.ancestors || void 0, this.cause = i.cause || void 0, this.column = s ? s.column : void 0, this.fatal = void 0, this.file, this.message = a, this.line = s ? s.line : void 0, this.name = OT(i.place) || "1:1", this.place = i.place || void 0, this.reason = this.message, this.ruleId = i.ruleId || void 0, this.source = i.source || void 0, this.stack = o && i.cause && typeof i.cause.stack == "string" ? i.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
mu.prototype.file = "";
mu.prototype.name = "";
mu.prototype.reason = "";
mu.prototype.message = "";
mu.prototype.stack = "";
mu.prototype.column = void 0;
mu.prototype.line = void 0;
mu.prototype.ancestors = void 0;
mu.prototype.cause = void 0;
mu.prototype.fatal = void 0;
mu.prototype.place = void 0;
mu.prototype.ruleId = void 0;
mu.prototype.source = void 0;
const M7 = {}.hasOwnProperty, LHe = /* @__PURE__ */ new Map(), MHe = /[A-Z]/g, FHe = /-([a-z])/g, $He = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), BHe = /* @__PURE__ */ new Set(["td", "th"]);
function UHe(t, e) {
  if (!e || e.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const n = e.filePath || void 0;
  let r;
  if (e.development) {
    if (typeof e.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    r = HHe(n, e.jsxDEV);
  } else {
    if (typeof e.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof e.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    r = zHe(n, e.jsx, e.jsxs);
  }
  const a = {
    Fragment: e.Fragment,
    ancestors: [],
    components: e.components || {},
    create: r,
    elementAttributeNameCase: e.elementAttributeNameCase || "react",
    filePath: n,
    ignoreInvalidStyle: e.ignoreInvalidStyle || !1,
    passKeys: e.passKeys !== !1,
    passNode: e.passNode || !1,
    schema: e.space === "svg" ? og : N0,
    stylePropertyNameCase: e.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: e.tableCellAlignToStyle !== !1
  }, i = pce(a, t, void 0);
  return i && typeof i != "string" ? i : a.create(
    t,
    a.Fragment,
    { children: i || void 0 },
    void 0
  );
}
function pce(t, e, n) {
  if (e.type === "element" || e.type === "root") {
    const r = t.schema;
    let a = r;
    e.type === "element" && e.tagName.toLowerCase() === "svg" && r.space === "html" && (a = og, t.schema = a), t.ancestors.push(e);
    let i = WHe(t, e);
    const o = QHe(t, t.ancestors);
    let s = t.Fragment;
    if (t.ancestors.pop(), e.type === "element")
      if (i && $He.has(e.tagName) && (i = i.filter(function(u) {
        return typeof u == "string" ? !lue(u) : !0;
      })), M7.call(t.components, e.tagName)) {
        const u = (
          /** @type {keyof JSX.IntrinsicElements} */
          e.tagName
        );
        s = t.components[u], typeof s != "string" && s !== t.Fragment && t.passNode && (o.node = e);
      } else
        s = e.tagName;
    if (i.length > 0) {
      const u = i.length > 1 ? i : i[0];
      u && (o.children = u);
    }
    return t.schema = r, t.create(e, s, o, n);
  }
  if (e.type === "text")
    return e.value;
}
function zHe(t, e, n) {
  return r;
  function r(a, i, o, s) {
    const f = Array.isArray(o.children) ? n : e;
    return s ? f(i, o, s) : f(i, o);
  }
}
function HHe(t, e) {
  return n;
  function n(r, a, i, o) {
    const s = Array.isArray(i.children), u = Mh(r);
    return e(
      a,
      i,
      o,
      s,
      {
        columnNumber: u ? u.column - 1 : void 0,
        fileName: t,
        lineNumber: u ? u.line : void 0
      },
      void 0
    );
  }
}
function WHe(t, e) {
  const n = [];
  let r = -1;
  const a = t.passKeys ? /* @__PURE__ */ new Map() : LHe;
  for (; ++r < e.children.length; ) {
    const i = e.children[r];
    let o;
    if (t.passKeys && i.type === "element") {
      const u = a.get(i.tagName) || 0;
      o = i.tagName + "-" + u, a.set(i.tagName, u + 1);
    }
    const s = pce(t, i, o);
    s !== void 0 && n.push(s);
  }
  return n;
}
function QHe(t, e) {
  const n = e[e.length - 1], r = {};
  let a;
  if ("properties" in n && n.properties) {
    let i;
    for (a in n.properties)
      if (a !== "children" && M7.call(n.properties, a)) {
        const o = jHe(
          t,
          e,
          a,
          n.properties[a]
        );
        if (o) {
          const [s, u] = o;
          t.tableCellAlignToStyle && s === "align" && typeof u == "string" && BHe.has(n.tagName) ? i = u : r[s] = u;
        }
      }
    if (i) {
      const o = (
        /** @type {Style} */
        r.style || (r.style = {})
      );
      o[t.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = i;
    }
  }
  return r;
}
function jHe(t, e, n, r) {
  const a = E1(t.schema, n);
  if (!(r == null || typeof r == "number" && Number.isNaN(r))) {
    if (Array.isArray(r) && (r = a.commaSeparated ? $6(r) : OHe(r)), a.property === "style") {
      let i = typeof r == "object" ? r : GHe(t, e, String(r));
      return t.stylePropertyNameCase === "css" && (i = VHe(i)), ["style", i];
    }
    return [
      t.elementAttributeNameCase === "react" && a.space ? w5e[a.property] || a.property : a.attribute,
      r
    ];
  }
}
function GHe(t, e, n) {
  const r = {};
  try {
    PHe(n, a);
  } catch (i) {
    if (!t.ignoreInvalidStyle) {
      const o = (
        /** @type {Error} */
        i
      ), s = new mu("Cannot parse `style` attribute", {
        ancestors: e,
        cause: o,
        source: "hast-util-to-jsx-runtime",
        ruleId: "style"
      });
      throw s.file = t.filePath || void 0, s.url = "https://github.com/syntax-tree/hast-util-to-jsx-runtime#cannot-parse-style-attribute", s;
    }
  }
  return r;
  function a(i, o) {
    let s = i;
    s.slice(0, 2) !== "--" && (s.slice(0, 4) === "-ms-" && (s = "ms-" + s.slice(4)), s = s.replace(FHe, ZHe)), r[s] = o;
  }
}
function VHe(t) {
  const e = {};
  let n;
  for (n in t)
    M7.call(t, n) && (e[YHe(n)] = t[n]);
  return e;
}
function YHe(t) {
  let e = t.replace(MHe, XHe);
  return e.slice(0, 3) === "ms-" && (e = "-" + e), e;
}
function ZHe(t, e) {
  return e.toUpperCase();
}
function XHe(t) {
  return "-" + t.toLowerCase();
}
const X3 = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, qHe = {};
function KHe(t, e) {
  const n = e || qHe, r = typeof n.includeImageAlt == "boolean" ? n.includeImageAlt : !0, a = typeof n.includeHtml == "boolean" ? n.includeHtml : !0;
  return hce(t, r, a);
}
function hce(t, e, n) {
  if (JHe(t)) {
    if ("value" in t)
      return t.type === "html" && !n ? "" : t.value;
    if (e && "alt" in t && t.alt)
      return t.alt;
    if ("children" in t)
      return GJ(t.children, e, n);
  }
  return Array.isArray(t) ? GJ(t, e, n) : "";
}
function GJ(t, e, n) {
  const r = [];
  let a = -1;
  for (; ++a < t.length; )
    r[a] = hce(t[a], e, n);
  return r.join("");
}
function JHe(t) {
  return !!(t && typeof t == "object");
}
function Wc(t, e, n, r) {
  const a = t.length;
  let i = 0, o;
  if (e < 0 ? e = -e > a ? 0 : a + e : e = e > a ? a : e, n = n > 0 ? n : 0, r.length < 1e4)
    o = Array.from(r), o.unshift(e, n), t.splice(...o);
  else
    for (n && t.splice(e, n); i < r.length; )
      o = r.slice(i, i + 1e4), o.unshift(e, 0), t.splice(...o), i += 1e4, e += 1e4;
}
function $f(t, e) {
  return t.length > 0 ? (Wc(t, t.length, 0, e), t) : e;
}
const VJ = {}.hasOwnProperty;
function mce(t) {
  const e = {};
  let n = -1;
  for (; ++n < t.length; )
    e7e(e, t[n]);
  return e;
}
function e7e(t, e) {
  let n;
  for (n in e) {
    const a = (VJ.call(t, n) ? t[n] : void 0) || (t[n] = {}), i = e[n];
    let o;
    if (i)
      for (o in i) {
        VJ.call(a, o) || (a[o] = []);
        const s = i[o];
        t7e(
          // @ts-expect-error Looks like a list.
          a[o],
          Array.isArray(s) ? s : s ? [s] : []
        );
      }
  }
}
function t7e(t, e) {
  let n = -1;
  const r = [];
  for (; ++n < e.length; )
    (e[n].add === "after" ? t : r).push(e[n]);
  Wc(t, 0, 0, r);
}
function gce(t, e) {
  const n = Number.parseInt(t, e);
  return (
    // C0 except for HT, LF, FF, CR, space.
    n < 9 || n === 11 || n > 13 && n < 32 || // Control character (DEL) of C0, and C1 controls.
    n > 126 && n < 160 || // Lone high surrogates and low surrogates.
    n > 55295 && n < 57344 || // Noncharacters.
    n > 64975 && n < 65008 || (n & 65535) === 65535 || (n & 65535) === 65534 || // Out of range
    n > 1114111 ? "�" : String.fromCharCode(n)
  );
}
function Vd(t) {
  return t.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const n7e = hv(/\p{P}/u), cu = hv(/[A-Za-z]/), Il = hv(/[\dA-Za-z]/), r7e = hv(/[#-'*+\--9=?A-Z^-~]/);
function MI(t) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    t !== null && (t < 32 || t === 127)
  );
}
const O5 = hv(/\d/), a7e = hv(/[\dA-Fa-f]/), bce = hv(/[!-/:-@[-`{-~]/);
function Gn(t) {
  return t !== null && t < -2;
}
function Ya(t) {
  return t !== null && (t < 0 || t === 32);
}
function Nr(t) {
  return t === -2 || t === -1 || t === 32;
}
function cN(t) {
  return bce(t) || n7e(t);
}
const O0 = hv(/\s/);
function hv(t) {
  return e;
  function e(n) {
    return n !== null && n > -1 && t.test(String.fromCharCode(n));
  }
}
function x1(t) {
  const e = [];
  let n = -1, r = 0, a = 0;
  for (; ++n < t.length; ) {
    const i = t.charCodeAt(n);
    let o = "";
    if (i === 37 && Il(t.charCodeAt(n + 1)) && Il(t.charCodeAt(n + 2)))
      a = 2;
    else if (i < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(i)) || (o = String.fromCharCode(i));
    else if (i > 55295 && i < 57344) {
      const s = t.charCodeAt(n + 1);
      i < 56320 && s > 56319 && s < 57344 ? (o = String.fromCharCode(i, s), a = 1) : o = "�";
    } else
      o = String.fromCharCode(i);
    o && (e.push(t.slice(r, n), encodeURIComponent(o)), r = n + a + 1, o = ""), a && (n += a, a = 0);
  }
  return e.join("") + t.slice(r);
}
function Kr(t, e, n, r) {
  const a = r ? r - 1 : Number.POSITIVE_INFINITY;
  let i = 0;
  return o;
  function o(u) {
    return Nr(u) ? (t.enter(n), s(u)) : e(u);
  }
  function s(u) {
    return Nr(u) && i++ < a ? (t.consume(u), s) : (t.exit(n), e(u));
  }
}
const i7e = {
  tokenize: o7e
};
function o7e(t) {
  const e = t.attempt(
    this.parser.constructs.contentInitial,
    r,
    a
  );
  let n;
  return e;
  function r(s) {
    if (s === null) {
      t.consume(s);
      return;
    }
    return t.enter("lineEnding"), t.consume(s), t.exit("lineEnding"), Kr(t, e, "linePrefix");
  }
  function a(s) {
    return t.enter("paragraph"), i(s);
  }
  function i(s) {
    const u = t.enter("chunkText", {
      contentType: "text",
      previous: n
    });
    return n && (n.next = u), n = u, o(s);
  }
  function o(s) {
    if (s === null) {
      t.exit("chunkText"), t.exit("paragraph"), t.consume(s);
      return;
    }
    return Gn(s) ? (t.consume(s), t.exit("chunkText"), i) : (t.consume(s), o);
  }
}
const s7e = {
  tokenize: l7e
}, YJ = {
  tokenize: u7e
};
function l7e(t) {
  const e = this, n = [];
  let r = 0, a, i, o;
  return s;
  function s(P) {
    if (r < n.length) {
      const I = n[r];
      return e.containerState = I[1], t.attempt(
        I[0].continuation,
        u,
        f
      )(P);
    }
    return f(P);
  }
  function u(P) {
    if (r++, e.containerState._closeFlow) {
      e.containerState._closeFlow = void 0, a && N();
      const I = e.events.length;
      let D = I, M;
      for (; D--; )
        if (e.events[D][0] === "exit" && e.events[D][1].type === "chunkFlow") {
          M = e.events[D][1].end;
          break;
        }
      A(r);
      let H = I;
      for (; H < e.events.length; )
        e.events[H][1].end = Object.assign({}, M), H++;
      return Wc(
        e.events,
        D + 1,
        0,
        e.events.slice(I)
      ), e.events.length = H, f(P);
    }
    return s(P);
  }
  function f(P) {
    if (r === n.length) {
      if (!a)
        return v(P);
      if (a.currentConstruct && a.currentConstruct.concrete)
        return w(P);
      e.interrupt = !!(a.currentConstruct && !a._gfmTableDynamicInterruptHack);
    }
    return e.containerState = {}, t.check(
      YJ,
      p,
      m
    )(P);
  }
  function p(P) {
    return a && N(), A(r), v(P);
  }
  function m(P) {
    return e.parser.lazy[e.now().line] = r !== n.length, o = e.now().offset, w(P);
  }
  function v(P) {
    return e.containerState = {}, t.attempt(
      YJ,
      O,
      w
    )(P);
  }
  function O(P) {
    return r++, n.push([e.currentConstruct, e.containerState]), v(P);
  }
  function w(P) {
    if (P === null) {
      a && N(), A(0), t.consume(P);
      return;
    }
    return a = a || e.parser.flow(e.now()), t.enter("chunkFlow", {
      contentType: "flow",
      previous: i,
      _tokenizer: a
    }), _(P);
  }
  function _(P) {
    if (P === null) {
      C(t.exit("chunkFlow"), !0), A(0), t.consume(P);
      return;
    }
    return Gn(P) ? (t.consume(P), C(t.exit("chunkFlow")), r = 0, e.interrupt = void 0, s) : (t.consume(P), _);
  }
  function C(P, I) {
    const D = e.sliceStream(P);
    if (I && D.push(null), P.previous = i, i && (i.next = P), i = P, a.defineSkip(P.start), a.write(D), e.parser.lazy[P.start.line]) {
      let M = a.events.length;
      for (; M--; )
        if (
          // The token starts before the line ending…
          a.events[M][1].start.offset < o && // …and either is not ended yet…
          (!a.events[M][1].end || // …or ends after it.
          a.events[M][1].end.offset > o)
        )
          return;
      const H = e.events.length;
      let Y = H, q, Q;
      for (; Y--; )
        if (e.events[Y][0] === "exit" && e.events[Y][1].type === "chunkFlow") {
          if (q) {
            Q = e.events[Y][1].end;
            break;
          }
          q = !0;
        }
      for (A(r), M = H; M < e.events.length; )
        e.events[M][1].end = Object.assign({}, Q), M++;
      Wc(
        e.events,
        Y + 1,
        0,
        e.events.slice(H)
      ), e.events.length = M;
    }
  }
  function A(P) {
    let I = n.length;
    for (; I-- > P; ) {
      const D = n[I];
      e.containerState = D[1], D[0].exit.call(e, t);
    }
    n.length = P;
  }
  function N() {
    a.write([null]), i = void 0, a = void 0, e.containerState._closeFlow = void 0;
  }
}
function u7e(t, e, n) {
  return Kr(
    t,
    t.attempt(this.parser.constructs.document, e, n),
    "linePrefix",
    this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
  );
}
function FI(t) {
  if (t === null || Ya(t) || O0(t))
    return 1;
  if (cN(t))
    return 2;
}
function fN(t, e, n) {
  const r = [];
  let a = -1;
  for (; ++a < t.length; ) {
    const i = t[a].resolveAll;
    i && !r.includes(i) && (e = i(e, n), r.push(i));
  }
  return e;
}
const E5 = {
  name: "attention",
  tokenize: f7e,
  resolveAll: c7e
};
function c7e(t, e) {
  let n = -1, r, a, i, o, s, u, f, p;
  for (; ++n < t.length; )
    if (t[n][0] === "enter" && t[n][1].type === "attentionSequence" && t[n][1]._close) {
      for (r = n; r--; )
        if (t[r][0] === "exit" && t[r][1].type === "attentionSequence" && t[r][1]._open && // If the markers are the same:
        e.sliceSerialize(t[r][1]).charCodeAt(0) === e.sliceSerialize(t[n][1]).charCodeAt(0)) {
          if ((t[r][1]._close || t[n][1]._open) && (t[n][1].end.offset - t[n][1].start.offset) % 3 && !((t[r][1].end.offset - t[r][1].start.offset + t[n][1].end.offset - t[n][1].start.offset) % 3))
            continue;
          u = t[r][1].end.offset - t[r][1].start.offset > 1 && t[n][1].end.offset - t[n][1].start.offset > 1 ? 2 : 1;
          const m = Object.assign({}, t[r][1].end), v = Object.assign({}, t[n][1].start);
          ZJ(m, -u), ZJ(v, u), o = {
            type: u > 1 ? "strongSequence" : "emphasisSequence",
            start: m,
            end: Object.assign({}, t[r][1].end)
          }, s = {
            type: u > 1 ? "strongSequence" : "emphasisSequence",
            start: Object.assign({}, t[n][1].start),
            end: v
          }, i = {
            type: u > 1 ? "strongText" : "emphasisText",
            start: Object.assign({}, t[r][1].end),
            end: Object.assign({}, t[n][1].start)
          }, a = {
            type: u > 1 ? "strong" : "emphasis",
            start: Object.assign({}, o.start),
            end: Object.assign({}, s.end)
          }, t[r][1].end = Object.assign({}, o.start), t[n][1].start = Object.assign({}, s.end), f = [], t[r][1].end.offset - t[r][1].start.offset && (f = $f(f, [
            ["enter", t[r][1], e],
            ["exit", t[r][1], e]
          ])), f = $f(f, [
            ["enter", a, e],
            ["enter", o, e],
            ["exit", o, e],
            ["enter", i, e]
          ]), f = $f(
            f,
            fN(
              e.parser.constructs.insideSpan.null,
              t.slice(r + 1, n),
              e
            )
          ), f = $f(f, [
            ["exit", i, e],
            ["enter", s, e],
            ["exit", s, e],
            ["exit", a, e]
          ]), t[n][1].end.offset - t[n][1].start.offset ? (p = 2, f = $f(f, [
            ["enter", t[n][1], e],
            ["exit", t[n][1], e]
          ])) : p = 0, Wc(t, r - 1, n - r + 3, f), n = r + f.length - p - 2;
          break;
        }
    }
  for (n = -1; ++n < t.length; )
    t[n][1].type === "attentionSequence" && (t[n][1].type = "data");
  return t;
}
function f7e(t, e) {
  const n = this.parser.constructs.attentionMarkers.null, r = this.previous, a = FI(r);
  let i;
  return o;
  function o(u) {
    return i = u, t.enter("attentionSequence"), s(u);
  }
  function s(u) {
    if (u === i)
      return t.consume(u), s;
    const f = t.exit("attentionSequence"), p = FI(u), m = !p || p === 2 && a || n.includes(u), v = !a || a === 2 && p || n.includes(r);
    return f._open = !!(i === 42 ? m : m && (a || !v)), f._close = !!(i === 42 ? v : v && (p || !m)), e(u);
  }
}
function ZJ(t, e) {
  t.column += e, t.offset += e, t._bufferIndex += e;
}
const d7e = {
  name: "autolink",
  tokenize: p7e
};
function p7e(t, e, n) {
  let r = 0;
  return a;
  function a(O) {
    return t.enter("autolink"), t.enter("autolinkMarker"), t.consume(O), t.exit("autolinkMarker"), t.enter("autolinkProtocol"), i;
  }
  function i(O) {
    return cu(O) ? (t.consume(O), o) : f(O);
  }
  function o(O) {
    return O === 43 || O === 45 || O === 46 || Il(O) ? (r = 1, s(O)) : f(O);
  }
  function s(O) {
    return O === 58 ? (t.consume(O), r = 0, u) : (O === 43 || O === 45 || O === 46 || Il(O)) && r++ < 32 ? (t.consume(O), s) : (r = 0, f(O));
  }
  function u(O) {
    return O === 62 ? (t.exit("autolinkProtocol"), t.enter("autolinkMarker"), t.consume(O), t.exit("autolinkMarker"), t.exit("autolink"), e) : O === null || O === 32 || O === 60 || MI(O) ? n(O) : (t.consume(O), u);
  }
  function f(O) {
    return O === 64 ? (t.consume(O), p) : r7e(O) ? (t.consume(O), f) : n(O);
  }
  function p(O) {
    return Il(O) ? m(O) : n(O);
  }
  function m(O) {
    return O === 46 ? (t.consume(O), r = 0, p) : O === 62 ? (t.exit("autolinkProtocol").type = "autolinkEmail", t.enter("autolinkMarker"), t.consume(O), t.exit("autolinkMarker"), t.exit("autolink"), e) : v(O);
  }
  function v(O) {
    if ((O === 45 || Il(O)) && r++ < 63) {
      const w = O === 45 ? v : m;
      return t.consume(O), w;
    }
    return n(O);
  }
}
const U_ = {
  tokenize: h7e,
  partial: !0
};
function h7e(t, e, n) {
  return r;
  function r(i) {
    return Nr(i) ? Kr(t, a, "linePrefix")(i) : a(i);
  }
  function a(i) {
    return i === null || Gn(i) ? e(i) : n(i);
  }
}
const vce = {
  name: "blockQuote",
  tokenize: m7e,
  continuation: {
    tokenize: g7e
  },
  exit: b7e
};
function m7e(t, e, n) {
  const r = this;
  return a;
  function a(o) {
    if (o === 62) {
      const s = r.containerState;
      return s.open || (t.enter("blockQuote", {
        _container: !0
      }), s.open = !0), t.enter("blockQuotePrefix"), t.enter("blockQuoteMarker"), t.consume(o), t.exit("blockQuoteMarker"), i;
    }
    return n(o);
  }
  function i(o) {
    return Nr(o) ? (t.enter("blockQuotePrefixWhitespace"), t.consume(o), t.exit("blockQuotePrefixWhitespace"), t.exit("blockQuotePrefix"), e) : (t.exit("blockQuotePrefix"), e(o));
  }
}
function g7e(t, e, n) {
  const r = this;
  return a;
  function a(o) {
    return Nr(o) ? Kr(
      t,
      i,
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(o) : i(o);
  }
  function i(o) {
    return t.attempt(vce, e, n)(o);
  }
}
function b7e(t) {
  t.exit("blockQuote");
}
const yce = {
  name: "characterEscape",
  tokenize: v7e
};
function v7e(t, e, n) {
  return r;
  function r(i) {
    return t.enter("characterEscape"), t.enter("escapeMarker"), t.consume(i), t.exit("escapeMarker"), a;
  }
  function a(i) {
    return bce(i) ? (t.enter("characterEscapeValue"), t.consume(i), t.exit("characterEscapeValue"), t.exit("characterEscape"), e) : n(i);
  }
}
const Oce = {
  name: "characterReference",
  tokenize: y7e
};
function y7e(t, e, n) {
  const r = this;
  let a = 0, i, o;
  return s;
  function s(m) {
    return t.enter("characterReference"), t.enter("characterReferenceMarker"), t.consume(m), t.exit("characterReferenceMarker"), u;
  }
  function u(m) {
    return m === 35 ? (t.enter("characterReferenceMarkerNumeric"), t.consume(m), t.exit("characterReferenceMarkerNumeric"), f) : (t.enter("characterReferenceValue"), i = 31, o = Il, p(m));
  }
  function f(m) {
    return m === 88 || m === 120 ? (t.enter("characterReferenceMarkerHexadecimal"), t.consume(m), t.exit("characterReferenceMarkerHexadecimal"), t.enter("characterReferenceValue"), i = 6, o = a7e, p) : (t.enter("characterReferenceValue"), i = 7, o = O5, p(m));
  }
  function p(m) {
    if (m === 59 && a) {
      const v = t.exit("characterReferenceValue");
      return o === Il && !i_(r.sliceSerialize(v)) ? n(m) : (t.enter("characterReferenceMarker"), t.consume(m), t.exit("characterReferenceMarker"), t.exit("characterReference"), e);
    }
    return o(m) && a++ < i ? (t.consume(m), p) : n(m);
  }
}
const XJ = {
  tokenize: E7e,
  partial: !0
}, qJ = {
  name: "codeFenced",
  tokenize: O7e,
  concrete: !0
};
function O7e(t, e, n) {
  const r = this, a = {
    tokenize: D,
    partial: !0
  };
  let i = 0, o = 0, s;
  return u;
  function u(M) {
    return f(M);
  }
  function f(M) {
    const H = r.events[r.events.length - 1];
    return i = H && H[1].type === "linePrefix" ? H[2].sliceSerialize(H[1], !0).length : 0, s = M, t.enter("codeFenced"), t.enter("codeFencedFence"), t.enter("codeFencedFenceSequence"), p(M);
  }
  function p(M) {
    return M === s ? (o++, t.consume(M), p) : o < 3 ? n(M) : (t.exit("codeFencedFenceSequence"), Nr(M) ? Kr(t, m, "whitespace")(M) : m(M));
  }
  function m(M) {
    return M === null || Gn(M) ? (t.exit("codeFencedFence"), r.interrupt ? e(M) : t.check(XJ, _, I)(M)) : (t.enter("codeFencedFenceInfo"), t.enter("chunkString", {
      contentType: "string"
    }), v(M));
  }
  function v(M) {
    return M === null || Gn(M) ? (t.exit("chunkString"), t.exit("codeFencedFenceInfo"), m(M)) : Nr(M) ? (t.exit("chunkString"), t.exit("codeFencedFenceInfo"), Kr(t, O, "whitespace")(M)) : M === 96 && M === s ? n(M) : (t.consume(M), v);
  }
  function O(M) {
    return M === null || Gn(M) ? m(M) : (t.enter("codeFencedFenceMeta"), t.enter("chunkString", {
      contentType: "string"
    }), w(M));
  }
  function w(M) {
    return M === null || Gn(M) ? (t.exit("chunkString"), t.exit("codeFencedFenceMeta"), m(M)) : M === 96 && M === s ? n(M) : (t.consume(M), w);
  }
  function _(M) {
    return t.attempt(a, I, C)(M);
  }
  function C(M) {
    return t.enter("lineEnding"), t.consume(M), t.exit("lineEnding"), A;
  }
  function A(M) {
    return i > 0 && Nr(M) ? Kr(
      t,
      N,
      "linePrefix",
      i + 1
    )(M) : N(M);
  }
  function N(M) {
    return M === null || Gn(M) ? t.check(XJ, _, I)(M) : (t.enter("codeFlowValue"), P(M));
  }
  function P(M) {
    return M === null || Gn(M) ? (t.exit("codeFlowValue"), N(M)) : (t.consume(M), P);
  }
  function I(M) {
    return t.exit("codeFenced"), e(M);
  }
  function D(M, H, Y) {
    let q = 0;
    return Q;
    function Q(fe) {
      return M.enter("lineEnding"), M.consume(fe), M.exit("lineEnding"), ne;
    }
    function ne(fe) {
      return M.enter("codeFencedFence"), Nr(fe) ? Kr(
        M,
        J,
        "linePrefix",
        r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
      )(fe) : J(fe);
    }
    function J(fe) {
      return fe === s ? (M.enter("codeFencedFenceSequence"), ue(fe)) : Y(fe);
    }
    function ue(fe) {
      return fe === s ? (q++, M.consume(fe), ue) : q >= o ? (M.exit("codeFencedFenceSequence"), Nr(fe) ? Kr(M, ee, "whitespace")(fe) : ee(fe)) : Y(fe);
    }
    function ee(fe) {
      return fe === null || Gn(fe) ? (M.exit("codeFencedFence"), H(fe)) : Y(fe);
    }
  }
}
function E7e(t, e, n) {
  const r = this;
  return a;
  function a(o) {
    return o === null ? n(o) : (t.enter("lineEnding"), t.consume(o), t.exit("lineEnding"), i);
  }
  function i(o) {
    return r.parser.lazy[r.now().line] ? n(o) : e(o);
  }
}
const q3 = {
  name: "codeIndented",
  tokenize: w7e
}, S7e = {
  tokenize: T7e,
  partial: !0
};
function w7e(t, e, n) {
  const r = this;
  return a;
  function a(f) {
    return t.enter("codeIndented"), Kr(t, i, "linePrefix", 4 + 1)(f);
  }
  function i(f) {
    const p = r.events[r.events.length - 1];
    return p && p[1].type === "linePrefix" && p[2].sliceSerialize(p[1], !0).length >= 4 ? o(f) : n(f);
  }
  function o(f) {
    return f === null ? u(f) : Gn(f) ? t.attempt(S7e, o, u)(f) : (t.enter("codeFlowValue"), s(f));
  }
  function s(f) {
    return f === null || Gn(f) ? (t.exit("codeFlowValue"), o(f)) : (t.consume(f), s);
  }
  function u(f) {
    return t.exit("codeIndented"), e(f);
  }
}
function T7e(t, e, n) {
  const r = this;
  return a;
  function a(o) {
    return r.parser.lazy[r.now().line] ? n(o) : Gn(o) ? (t.enter("lineEnding"), t.consume(o), t.exit("lineEnding"), a) : Kr(t, i, "linePrefix", 4 + 1)(o);
  }
  function i(o) {
    const s = r.events[r.events.length - 1];
    return s && s[1].type === "linePrefix" && s[2].sliceSerialize(s[1], !0).length >= 4 ? e(o) : Gn(o) ? a(o) : n(o);
  }
}
const _7e = {
  name: "codeText",
  tokenize: A7e,
  resolve: C7e,
  previous: x7e
};
function C7e(t) {
  let e = t.length - 4, n = 3, r, a;
  if ((t[n][1].type === "lineEnding" || t[n][1].type === "space") && (t[e][1].type === "lineEnding" || t[e][1].type === "space")) {
    for (r = n; ++r < e; )
      if (t[r][1].type === "codeTextData") {
        t[n][1].type = "codeTextPadding", t[e][1].type = "codeTextPadding", n += 2, e -= 2;
        break;
      }
  }
  for (r = n - 1, e++; ++r <= e; )
    a === void 0 ? r !== e && t[r][1].type !== "lineEnding" && (a = r) : (r === e || t[r][1].type === "lineEnding") && (t[a][1].type = "codeTextData", r !== a + 2 && (t[a][1].end = t[r - 1][1].end, t.splice(a + 2, r - a - 2), e -= r - a - 2, r = a + 2), a = void 0);
  return t;
}
function x7e(t) {
  return t !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function A7e(t, e, n) {
  let r = 0, a, i;
  return o;
  function o(m) {
    return t.enter("codeText"), t.enter("codeTextSequence"), s(m);
  }
  function s(m) {
    return m === 96 ? (t.consume(m), r++, s) : (t.exit("codeTextSequence"), u(m));
  }
  function u(m) {
    return m === null ? n(m) : m === 32 ? (t.enter("space"), t.consume(m), t.exit("space"), u) : m === 96 ? (i = t.enter("codeTextSequence"), a = 0, p(m)) : Gn(m) ? (t.enter("lineEnding"), t.consume(m), t.exit("lineEnding"), u) : (t.enter("codeTextData"), f(m));
  }
  function f(m) {
    return m === null || m === 32 || m === 96 || Gn(m) ? (t.exit("codeTextData"), u(m)) : (t.consume(m), f);
  }
  function p(m) {
    return m === 96 ? (t.consume(m), a++, p) : a === r ? (t.exit("codeTextSequence"), t.exit("codeText"), e(m)) : (i.type = "codeTextData", f(m));
  }
}
function Ece(t) {
  const e = {};
  let n = -1, r, a, i, o, s, u, f;
  for (; ++n < t.length; ) {
    for (; n in e; )
      n = e[n];
    if (r = t[n], n && r[1].type === "chunkFlow" && t[n - 1][1].type === "listItemPrefix" && (u = r[1]._tokenizer.events, i = 0, i < u.length && u[i][1].type === "lineEndingBlank" && (i += 2), i < u.length && u[i][1].type === "content"))
      for (; ++i < u.length && u[i][1].type !== "content"; )
        u[i][1].type === "chunkText" && (u[i][1]._isInFirstContentOfListItem = !0, i++);
    if (r[0] === "enter")
      r[1].contentType && (Object.assign(e, k7e(t, n)), n = e[n], f = !0);
    else if (r[1]._container) {
      for (i = n, a = void 0; i-- && (o = t[i], o[1].type === "lineEnding" || o[1].type === "lineEndingBlank"); )
        o[0] === "enter" && (a && (t[a][1].type = "lineEndingBlank"), o[1].type = "lineEnding", a = i);
      a && (r[1].end = Object.assign({}, t[a][1].start), s = t.slice(a, n), s.unshift(r), Wc(t, a, n - a + 1, s));
    }
  }
  return !f;
}
function k7e(t, e) {
  const n = t[e][1], r = t[e][2];
  let a = e - 1;
  const i = [], o = n._tokenizer || r.parser[n.contentType](n.start), s = o.events, u = [], f = {};
  let p, m, v = -1, O = n, w = 0, _ = 0;
  const C = [_];
  for (; O; ) {
    for (; t[++a][1] !== O; )
      ;
    i.push(a), O._tokenizer || (p = r.sliceStream(O), O.next || p.push(null), m && o.defineSkip(O.start), O._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = !0), o.write(p), O._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = void 0)), m = O, O = O.next;
  }
  for (O = n; ++v < s.length; )
    // Find a void token that includes a break.
    s[v][0] === "exit" && s[v - 1][0] === "enter" && s[v][1].type === s[v - 1][1].type && s[v][1].start.line !== s[v][1].end.line && (_ = v + 1, C.push(_), O._tokenizer = void 0, O.previous = void 0, O = O.next);
  for (o.events = [], O ? (O._tokenizer = void 0, O.previous = void 0) : C.pop(), v = C.length; v--; ) {
    const A = s.slice(C[v], C[v + 1]), N = i.pop();
    u.unshift([N, N + A.length - 1]), Wc(t, N, 2, A);
  }
  for (v = -1; ++v < u.length; )
    f[w + u[v][0]] = w + u[v][1], w += u[v][1] - u[v][0] - 1;
  return f;
}
const R7e = {
  tokenize: N7e,
  resolve: D7e
}, I7e = {
  tokenize: P7e,
  partial: !0
};
function D7e(t) {
  return Ece(t), t;
}
function N7e(t, e) {
  let n;
  return r;
  function r(s) {
    return t.enter("content"), n = t.enter("chunkContent", {
      contentType: "content"
    }), a(s);
  }
  function a(s) {
    return s === null ? i(s) : Gn(s) ? t.check(
      I7e,
      o,
      i
    )(s) : (t.consume(s), a);
  }
  function i(s) {
    return t.exit("chunkContent"), t.exit("content"), e(s);
  }
  function o(s) {
    return t.consume(s), t.exit("chunkContent"), n.next = t.enter("chunkContent", {
      contentType: "content",
      previous: n
    }), n = n.next, a;
  }
}
function P7e(t, e, n) {
  const r = this;
  return a;
  function a(o) {
    return t.exit("chunkContent"), t.enter("lineEnding"), t.consume(o), t.exit("lineEnding"), Kr(t, i, "linePrefix");
  }
  function i(o) {
    if (o === null || Gn(o))
      return n(o);
    const s = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && s && s[1].type === "linePrefix" && s[2].sliceSerialize(s[1], !0).length >= 4 ? e(o) : t.interrupt(r.parser.constructs.flow, n, e)(o);
  }
}
function Sce(t, e, n, r, a, i, o, s, u) {
  const f = u || Number.POSITIVE_INFINITY;
  let p = 0;
  return m;
  function m(A) {
    return A === 60 ? (t.enter(r), t.enter(a), t.enter(i), t.consume(A), t.exit(i), v) : A === null || A === 32 || A === 41 || MI(A) ? n(A) : (t.enter(r), t.enter(o), t.enter(s), t.enter("chunkString", {
      contentType: "string"
    }), _(A));
  }
  function v(A) {
    return A === 62 ? (t.enter(i), t.consume(A), t.exit(i), t.exit(a), t.exit(r), e) : (t.enter(s), t.enter("chunkString", {
      contentType: "string"
    }), O(A));
  }
  function O(A) {
    return A === 62 ? (t.exit("chunkString"), t.exit(s), v(A)) : A === null || A === 60 || Gn(A) ? n(A) : (t.consume(A), A === 92 ? w : O);
  }
  function w(A) {
    return A === 60 || A === 62 || A === 92 ? (t.consume(A), O) : O(A);
  }
  function _(A) {
    return !p && (A === null || A === 41 || Ya(A)) ? (t.exit("chunkString"), t.exit(s), t.exit(o), t.exit(r), e(A)) : p < f && A === 40 ? (t.consume(A), p++, _) : A === 41 ? (t.consume(A), p--, _) : A === null || A === 32 || A === 40 || MI(A) ? n(A) : (t.consume(A), A === 92 ? C : _);
  }
  function C(A) {
    return A === 40 || A === 41 || A === 92 ? (t.consume(A), _) : _(A);
  }
}
function wce(t, e, n, r, a, i) {
  const o = this;
  let s = 0, u;
  return f;
  function f(O) {
    return t.enter(r), t.enter(a), t.consume(O), t.exit(a), t.enter(i), p;
  }
  function p(O) {
    return s > 999 || O === null || O === 91 || O === 93 && !u || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    O === 94 && !s && "_hiddenFootnoteSupport" in o.parser.constructs ? n(O) : O === 93 ? (t.exit(i), t.enter(a), t.consume(O), t.exit(a), t.exit(r), e) : Gn(O) ? (t.enter("lineEnding"), t.consume(O), t.exit("lineEnding"), p) : (t.enter("chunkString", {
      contentType: "string"
    }), m(O));
  }
  function m(O) {
    return O === null || O === 91 || O === 93 || Gn(O) || s++ > 999 ? (t.exit("chunkString"), p(O)) : (t.consume(O), u || (u = !Nr(O)), O === 92 ? v : m);
  }
  function v(O) {
    return O === 91 || O === 92 || O === 93 ? (t.consume(O), s++, m) : m(O);
  }
}
function Tce(t, e, n, r, a, i) {
  let o;
  return s;
  function s(v) {
    return v === 34 || v === 39 || v === 40 ? (t.enter(r), t.enter(a), t.consume(v), t.exit(a), o = v === 40 ? 41 : v, u) : n(v);
  }
  function u(v) {
    return v === o ? (t.enter(a), t.consume(v), t.exit(a), t.exit(r), e) : (t.enter(i), f(v));
  }
  function f(v) {
    return v === o ? (t.exit(i), u(o)) : v === null ? n(v) : Gn(v) ? (t.enter("lineEnding"), t.consume(v), t.exit("lineEnding"), Kr(t, f, "linePrefix")) : (t.enter("chunkString", {
      contentType: "string"
    }), p(v));
  }
  function p(v) {
    return v === o || v === null || Gn(v) ? (t.exit("chunkString"), f(v)) : (t.consume(v), v === 92 ? m : p);
  }
  function m(v) {
    return v === o || v === 92 ? (t.consume(v), p) : p(v);
  }
}
function ET(t, e) {
  let n;
  return r;
  function r(a) {
    return Gn(a) ? (t.enter("lineEnding"), t.consume(a), t.exit("lineEnding"), n = !0, r) : Nr(a) ? Kr(
      t,
      r,
      n ? "linePrefix" : "lineSuffix"
    )(a) : e(a);
  }
}
const L7e = {
  name: "definition",
  tokenize: F7e
}, M7e = {
  tokenize: $7e,
  partial: !0
};
function F7e(t, e, n) {
  const r = this;
  let a;
  return i;
  function i(O) {
    return t.enter("definition"), o(O);
  }
  function o(O) {
    return wce.call(
      r,
      t,
      s,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(O);
  }
  function s(O) {
    return a = Vd(
      r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)
    ), O === 58 ? (t.enter("definitionMarker"), t.consume(O), t.exit("definitionMarker"), u) : n(O);
  }
  function u(O) {
    return Ya(O) ? ET(t, f)(O) : f(O);
  }
  function f(O) {
    return Sce(
      t,
      p,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(O);
  }
  function p(O) {
    return t.attempt(M7e, m, m)(O);
  }
  function m(O) {
    return Nr(O) ? Kr(t, v, "whitespace")(O) : v(O);
  }
  function v(O) {
    return O === null || Gn(O) ? (t.exit("definition"), r.parser.defined.push(a), e(O)) : n(O);
  }
}
function $7e(t, e, n) {
  return r;
  function r(s) {
    return Ya(s) ? ET(t, a)(s) : n(s);
  }
  function a(s) {
    return Tce(
      t,
      i,
      n,
      "definitionTitle",
      "definitionTitleMarker",
      "definitionTitleString"
    )(s);
  }
  function i(s) {
    return Nr(s) ? Kr(t, o, "whitespace")(s) : o(s);
  }
  function o(s) {
    return s === null || Gn(s) ? e(s) : n(s);
  }
}
const B7e = {
  name: "hardBreakEscape",
  tokenize: U7e
};
function U7e(t, e, n) {
  return r;
  function r(i) {
    return t.enter("hardBreakEscape"), t.consume(i), a;
  }
  function a(i) {
    return Gn(i) ? (t.exit("hardBreakEscape"), e(i)) : n(i);
  }
}
const z7e = {
  name: "headingAtx",
  tokenize: W7e,
  resolve: H7e
};
function H7e(t, e) {
  let n = t.length - 2, r = 3, a, i;
  return t[r][1].type === "whitespace" && (r += 2), n - 2 > r && t[n][1].type === "whitespace" && (n -= 2), t[n][1].type === "atxHeadingSequence" && (r === n - 1 || n - 4 > r && t[n - 2][1].type === "whitespace") && (n -= r + 1 === n ? 2 : 4), n > r && (a = {
    type: "atxHeadingText",
    start: t[r][1].start,
    end: t[n][1].end
  }, i = {
    type: "chunkText",
    start: t[r][1].start,
    end: t[n][1].end,
    contentType: "text"
  }, Wc(t, r, n - r + 1, [
    ["enter", a, e],
    ["enter", i, e],
    ["exit", i, e],
    ["exit", a, e]
  ])), t;
}
function W7e(t, e, n) {
  let r = 0;
  return a;
  function a(p) {
    return t.enter("atxHeading"), i(p);
  }
  function i(p) {
    return t.enter("atxHeadingSequence"), o(p);
  }
  function o(p) {
    return p === 35 && r++ < 6 ? (t.consume(p), o) : p === null || Ya(p) ? (t.exit("atxHeadingSequence"), s(p)) : n(p);
  }
  function s(p) {
    return p === 35 ? (t.enter("atxHeadingSequence"), u(p)) : p === null || Gn(p) ? (t.exit("atxHeading"), e(p)) : Nr(p) ? Kr(t, s, "whitespace")(p) : (t.enter("atxHeadingText"), f(p));
  }
  function u(p) {
    return p === 35 ? (t.consume(p), u) : (t.exit("atxHeadingSequence"), s(p));
  }
  function f(p) {
    return p === null || p === 35 || Ya(p) ? (t.exit("atxHeadingText"), s(p)) : (t.consume(p), f);
  }
}
const Q7e = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], KJ = ["pre", "script", "style", "textarea"], j7e = {
  name: "htmlFlow",
  tokenize: Z7e,
  resolveTo: Y7e,
  concrete: !0
}, G7e = {
  tokenize: q7e,
  partial: !0
}, V7e = {
  tokenize: X7e,
  partial: !0
};
function Y7e(t) {
  let e = t.length;
  for (; e-- && !(t[e][0] === "enter" && t[e][1].type === "htmlFlow"); )
    ;
  return e > 1 && t[e - 2][1].type === "linePrefix" && (t[e][1].start = t[e - 2][1].start, t[e + 1][1].start = t[e - 2][1].start, t.splice(e - 2, 2)), t;
}
function Z7e(t, e, n) {
  const r = this;
  let a, i, o, s, u;
  return f;
  function f(Z) {
    return p(Z);
  }
  function p(Z) {
    return t.enter("htmlFlow"), t.enter("htmlFlowData"), t.consume(Z), m;
  }
  function m(Z) {
    return Z === 33 ? (t.consume(Z), v) : Z === 47 ? (t.consume(Z), i = !0, _) : Z === 63 ? (t.consume(Z), a = 3, r.interrupt ? e : B) : cu(Z) ? (t.consume(Z), o = String.fromCharCode(Z), C) : n(Z);
  }
  function v(Z) {
    return Z === 45 ? (t.consume(Z), a = 2, O) : Z === 91 ? (t.consume(Z), a = 5, s = 0, w) : cu(Z) ? (t.consume(Z), a = 4, r.interrupt ? e : B) : n(Z);
  }
  function O(Z) {
    return Z === 45 ? (t.consume(Z), r.interrupt ? e : B) : n(Z);
  }
  function w(Z) {
    const ce = "CDATA[";
    return Z === ce.charCodeAt(s++) ? (t.consume(Z), s === ce.length ? r.interrupt ? e : J : w) : n(Z);
  }
  function _(Z) {
    return cu(Z) ? (t.consume(Z), o = String.fromCharCode(Z), C) : n(Z);
  }
  function C(Z) {
    if (Z === null || Z === 47 || Z === 62 || Ya(Z)) {
      const ce = Z === 47, j = o.toLowerCase();
      return !ce && !i && KJ.includes(j) ? (a = 1, r.interrupt ? e(Z) : J(Z)) : Q7e.includes(o.toLowerCase()) ? (a = 6, ce ? (t.consume(Z), A) : r.interrupt ? e(Z) : J(Z)) : (a = 7, r.interrupt && !r.parser.lazy[r.now().line] ? n(Z) : i ? N(Z) : P(Z));
    }
    return Z === 45 || Il(Z) ? (t.consume(Z), o += String.fromCharCode(Z), C) : n(Z);
  }
  function A(Z) {
    return Z === 62 ? (t.consume(Z), r.interrupt ? e : J) : n(Z);
  }
  function N(Z) {
    return Nr(Z) ? (t.consume(Z), N) : Q(Z);
  }
  function P(Z) {
    return Z === 47 ? (t.consume(Z), Q) : Z === 58 || Z === 95 || cu(Z) ? (t.consume(Z), I) : Nr(Z) ? (t.consume(Z), P) : Q(Z);
  }
  function I(Z) {
    return Z === 45 || Z === 46 || Z === 58 || Z === 95 || Il(Z) ? (t.consume(Z), I) : D(Z);
  }
  function D(Z) {
    return Z === 61 ? (t.consume(Z), M) : Nr(Z) ? (t.consume(Z), D) : P(Z);
  }
  function M(Z) {
    return Z === null || Z === 60 || Z === 61 || Z === 62 || Z === 96 ? n(Z) : Z === 34 || Z === 39 ? (t.consume(Z), u = Z, H) : Nr(Z) ? (t.consume(Z), M) : Y(Z);
  }
  function H(Z) {
    return Z === u ? (t.consume(Z), u = null, q) : Z === null || Gn(Z) ? n(Z) : (t.consume(Z), H);
  }
  function Y(Z) {
    return Z === null || Z === 34 || Z === 39 || Z === 47 || Z === 60 || Z === 61 || Z === 62 || Z === 96 || Ya(Z) ? D(Z) : (t.consume(Z), Y);
  }
  function q(Z) {
    return Z === 47 || Z === 62 || Nr(Z) ? P(Z) : n(Z);
  }
  function Q(Z) {
    return Z === 62 ? (t.consume(Z), ne) : n(Z);
  }
  function ne(Z) {
    return Z === null || Gn(Z) ? J(Z) : Nr(Z) ? (t.consume(Z), ne) : n(Z);
  }
  function J(Z) {
    return Z === 45 && a === 2 ? (t.consume(Z), de) : Z === 60 && a === 1 ? (t.consume(Z), ie) : Z === 62 && a === 4 ? (t.consume(Z), pe) : Z === 63 && a === 3 ? (t.consume(Z), B) : Z === 93 && a === 5 ? (t.consume(Z), ye) : Gn(Z) && (a === 6 || a === 7) ? (t.exit("htmlFlowData"), t.check(
      G7e,
      _e,
      ue
    )(Z)) : Z === null || Gn(Z) ? (t.exit("htmlFlowData"), ue(Z)) : (t.consume(Z), J);
  }
  function ue(Z) {
    return t.check(
      V7e,
      ee,
      _e
    )(Z);
  }
  function ee(Z) {
    return t.enter("lineEnding"), t.consume(Z), t.exit("lineEnding"), fe;
  }
  function fe(Z) {
    return Z === null || Gn(Z) ? ue(Z) : (t.enter("htmlFlowData"), J(Z));
  }
  function de(Z) {
    return Z === 45 ? (t.consume(Z), B) : J(Z);
  }
  function ie(Z) {
    return Z === 47 ? (t.consume(Z), o = "", le) : J(Z);
  }
  function le(Z) {
    if (Z === 62) {
      const ce = o.toLowerCase();
      return KJ.includes(ce) ? (t.consume(Z), pe) : J(Z);
    }
    return cu(Z) && o.length < 8 ? (t.consume(Z), o += String.fromCharCode(Z), le) : J(Z);
  }
  function ye(Z) {
    return Z === 93 ? (t.consume(Z), B) : J(Z);
  }
  function B(Z) {
    return Z === 62 ? (t.consume(Z), pe) : Z === 45 && a === 2 ? (t.consume(Z), B) : J(Z);
  }
  function pe(Z) {
    return Z === null || Gn(Z) ? (t.exit("htmlFlowData"), _e(Z)) : (t.consume(Z), pe);
  }
  function _e(Z) {
    return t.exit("htmlFlow"), e(Z);
  }
}
function X7e(t, e, n) {
  const r = this;
  return a;
  function a(o) {
    return Gn(o) ? (t.enter("lineEnding"), t.consume(o), t.exit("lineEnding"), i) : n(o);
  }
  function i(o) {
    return r.parser.lazy[r.now().line] ? n(o) : e(o);
  }
}
function q7e(t, e, n) {
  return r;
  function r(a) {
    return t.enter("lineEnding"), t.consume(a), t.exit("lineEnding"), t.attempt(U_, e, n);
  }
}
const K7e = {
  name: "htmlText",
  tokenize: J7e
};
function J7e(t, e, n) {
  const r = this;
  let a, i, o;
  return s;
  function s(B) {
    return t.enter("htmlText"), t.enter("htmlTextData"), t.consume(B), u;
  }
  function u(B) {
    return B === 33 ? (t.consume(B), f) : B === 47 ? (t.consume(B), D) : B === 63 ? (t.consume(B), P) : cu(B) ? (t.consume(B), Y) : n(B);
  }
  function f(B) {
    return B === 45 ? (t.consume(B), p) : B === 91 ? (t.consume(B), i = 0, w) : cu(B) ? (t.consume(B), N) : n(B);
  }
  function p(B) {
    return B === 45 ? (t.consume(B), O) : n(B);
  }
  function m(B) {
    return B === null ? n(B) : B === 45 ? (t.consume(B), v) : Gn(B) ? (o = m, ie(B)) : (t.consume(B), m);
  }
  function v(B) {
    return B === 45 ? (t.consume(B), O) : m(B);
  }
  function O(B) {
    return B === 62 ? de(B) : B === 45 ? v(B) : m(B);
  }
  function w(B) {
    const pe = "CDATA[";
    return B === pe.charCodeAt(i++) ? (t.consume(B), i === pe.length ? _ : w) : n(B);
  }
  function _(B) {
    return B === null ? n(B) : B === 93 ? (t.consume(B), C) : Gn(B) ? (o = _, ie(B)) : (t.consume(B), _);
  }
  function C(B) {
    return B === 93 ? (t.consume(B), A) : _(B);
  }
  function A(B) {
    return B === 62 ? de(B) : B === 93 ? (t.consume(B), A) : _(B);
  }
  function N(B) {
    return B === null || B === 62 ? de(B) : Gn(B) ? (o = N, ie(B)) : (t.consume(B), N);
  }
  function P(B) {
    return B === null ? n(B) : B === 63 ? (t.consume(B), I) : Gn(B) ? (o = P, ie(B)) : (t.consume(B), P);
  }
  function I(B) {
    return B === 62 ? de(B) : P(B);
  }
  function D(B) {
    return cu(B) ? (t.consume(B), M) : n(B);
  }
  function M(B) {
    return B === 45 || Il(B) ? (t.consume(B), M) : H(B);
  }
  function H(B) {
    return Gn(B) ? (o = H, ie(B)) : Nr(B) ? (t.consume(B), H) : de(B);
  }
  function Y(B) {
    return B === 45 || Il(B) ? (t.consume(B), Y) : B === 47 || B === 62 || Ya(B) ? q(B) : n(B);
  }
  function q(B) {
    return B === 47 ? (t.consume(B), de) : B === 58 || B === 95 || cu(B) ? (t.consume(B), Q) : Gn(B) ? (o = q, ie(B)) : Nr(B) ? (t.consume(B), q) : de(B);
  }
  function Q(B) {
    return B === 45 || B === 46 || B === 58 || B === 95 || Il(B) ? (t.consume(B), Q) : ne(B);
  }
  function ne(B) {
    return B === 61 ? (t.consume(B), J) : Gn(B) ? (o = ne, ie(B)) : Nr(B) ? (t.consume(B), ne) : q(B);
  }
  function J(B) {
    return B === null || B === 60 || B === 61 || B === 62 || B === 96 ? n(B) : B === 34 || B === 39 ? (t.consume(B), a = B, ue) : Gn(B) ? (o = J, ie(B)) : Nr(B) ? (t.consume(B), J) : (t.consume(B), ee);
  }
  function ue(B) {
    return B === a ? (t.consume(B), a = void 0, fe) : B === null ? n(B) : Gn(B) ? (o = ue, ie(B)) : (t.consume(B), ue);
  }
  function ee(B) {
    return B === null || B === 34 || B === 39 || B === 60 || B === 61 || B === 96 ? n(B) : B === 47 || B === 62 || Ya(B) ? q(B) : (t.consume(B), ee);
  }
  function fe(B) {
    return B === 47 || B === 62 || Ya(B) ? q(B) : n(B);
  }
  function de(B) {
    return B === 62 ? (t.consume(B), t.exit("htmlTextData"), t.exit("htmlText"), e) : n(B);
  }
  function ie(B) {
    return t.exit("htmlTextData"), t.enter("lineEnding"), t.consume(B), t.exit("lineEnding"), le;
  }
  function le(B) {
    return Nr(B) ? Kr(
      t,
      ye,
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(B) : ye(B);
  }
  function ye(B) {
    return t.enter("htmlTextData"), o(B);
  }
}
const F7 = {
  name: "labelEnd",
  tokenize: iWe,
  resolveTo: aWe,
  resolveAll: rWe
}, eWe = {
  tokenize: oWe
}, tWe = {
  tokenize: sWe
}, nWe = {
  tokenize: lWe
};
function rWe(t) {
  let e = -1;
  for (; ++e < t.length; ) {
    const n = t[e][1];
    (n.type === "labelImage" || n.type === "labelLink" || n.type === "labelEnd") && (t.splice(e + 1, n.type === "labelImage" ? 4 : 2), n.type = "data", e++);
  }
  return t;
}
function aWe(t, e) {
  let n = t.length, r = 0, a, i, o, s;
  for (; n--; )
    if (a = t[n][1], i) {
      if (a.type === "link" || a.type === "labelLink" && a._inactive)
        break;
      t[n][0] === "enter" && a.type === "labelLink" && (a._inactive = !0);
    } else if (o) {
      if (t[n][0] === "enter" && (a.type === "labelImage" || a.type === "labelLink") && !a._balanced && (i = n, a.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else
      a.type === "labelEnd" && (o = n);
  const u = {
    type: t[i][1].type === "labelLink" ? "link" : "image",
    start: Object.assign({}, t[i][1].start),
    end: Object.assign({}, t[t.length - 1][1].end)
  }, f = {
    type: "label",
    start: Object.assign({}, t[i][1].start),
    end: Object.assign({}, t[o][1].end)
  }, p = {
    type: "labelText",
    start: Object.assign({}, t[i + r + 2][1].end),
    end: Object.assign({}, t[o - 2][1].start)
  };
  return s = [
    ["enter", u, e],
    ["enter", f, e]
  ], s = $f(s, t.slice(i + 1, i + r + 3)), s = $f(s, [["enter", p, e]]), s = $f(
    s,
    fN(
      e.parser.constructs.insideSpan.null,
      t.slice(i + r + 4, o - 3),
      e
    )
  ), s = $f(s, [
    ["exit", p, e],
    t[o - 2],
    t[o - 1],
    ["exit", f, e]
  ]), s = $f(s, t.slice(o + 1)), s = $f(s, [["exit", u, e]]), Wc(t, i, t.length, s), t;
}
function iWe(t, e, n) {
  const r = this;
  let a = r.events.length, i, o;
  for (; a--; )
    if ((r.events[a][1].type === "labelImage" || r.events[a][1].type === "labelLink") && !r.events[a][1]._balanced) {
      i = r.events[a][1];
      break;
    }
  return s;
  function s(v) {
    return i ? i._inactive ? m(v) : (o = r.parser.defined.includes(
      Vd(
        r.sliceSerialize({
          start: i.end,
          end: r.now()
        })
      )
    ), t.enter("labelEnd"), t.enter("labelMarker"), t.consume(v), t.exit("labelMarker"), t.exit("labelEnd"), u) : n(v);
  }
  function u(v) {
    return v === 40 ? t.attempt(
      eWe,
      p,
      o ? p : m
    )(v) : v === 91 ? t.attempt(
      tWe,
      p,
      o ? f : m
    )(v) : o ? p(v) : m(v);
  }
  function f(v) {
    return t.attempt(
      nWe,
      p,
      m
    )(v);
  }
  function p(v) {
    return e(v);
  }
  function m(v) {
    return i._balanced = !0, n(v);
  }
}
function oWe(t, e, n) {
  return r;
  function r(m) {
    return t.enter("resource"), t.enter("resourceMarker"), t.consume(m), t.exit("resourceMarker"), a;
  }
  function a(m) {
    return Ya(m) ? ET(t, i)(m) : i(m);
  }
  function i(m) {
    return m === 41 ? p(m) : Sce(
      t,
      o,
      s,
      "resourceDestination",
      "resourceDestinationLiteral",
      "resourceDestinationLiteralMarker",
      "resourceDestinationRaw",
      "resourceDestinationString",
      32
    )(m);
  }
  function o(m) {
    return Ya(m) ? ET(t, u)(m) : p(m);
  }
  function s(m) {
    return n(m);
  }
  function u(m) {
    return m === 34 || m === 39 || m === 40 ? Tce(
      t,
      f,
      n,
      "resourceTitle",
      "resourceTitleMarker",
      "resourceTitleString"
    )(m) : p(m);
  }
  function f(m) {
    return Ya(m) ? ET(t, p)(m) : p(m);
  }
  function p(m) {
    return m === 41 ? (t.enter("resourceMarker"), t.consume(m), t.exit("resourceMarker"), t.exit("resource"), e) : n(m);
  }
}
function sWe(t, e, n) {
  const r = this;
  return a;
  function a(s) {
    return wce.call(
      r,
      t,
      i,
      o,
      "reference",
      "referenceMarker",
      "referenceString"
    )(s);
  }
  function i(s) {
    return r.parser.defined.includes(
      Vd(
        r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)
      )
    ) ? e(s) : n(s);
  }
  function o(s) {
    return n(s);
  }
}
function lWe(t, e, n) {
  return r;
  function r(i) {
    return t.enter("reference"), t.enter("referenceMarker"), t.consume(i), t.exit("referenceMarker"), a;
  }
  function a(i) {
    return i === 93 ? (t.enter("referenceMarker"), t.consume(i), t.exit("referenceMarker"), t.exit("reference"), e) : n(i);
  }
}
const uWe = {
  name: "labelStartImage",
  tokenize: cWe,
  resolveAll: F7.resolveAll
};
function cWe(t, e, n) {
  const r = this;
  return a;
  function a(s) {
    return t.enter("labelImage"), t.enter("labelImageMarker"), t.consume(s), t.exit("labelImageMarker"), i;
  }
  function i(s) {
    return s === 91 ? (t.enter("labelMarker"), t.consume(s), t.exit("labelMarker"), t.exit("labelImage"), o) : n(s);
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(s) : e(s);
  }
}
const fWe = {
  name: "labelStartLink",
  tokenize: dWe,
  resolveAll: F7.resolveAll
};
function dWe(t, e, n) {
  const r = this;
  return a;
  function a(o) {
    return t.enter("labelLink"), t.enter("labelMarker"), t.consume(o), t.exit("labelMarker"), t.exit("labelLink"), i;
  }
  function i(o) {
    return o === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(o) : e(o);
  }
}
const K3 = {
  name: "lineEnding",
  tokenize: pWe
};
function pWe(t, e) {
  return n;
  function n(r) {
    return t.enter("lineEnding"), t.consume(r), t.exit("lineEnding"), Kr(t, e, "linePrefix");
  }
}
const $k = {
  name: "thematicBreak",
  tokenize: hWe
};
function hWe(t, e, n) {
  let r = 0, a;
  return i;
  function i(f) {
    return t.enter("thematicBreak"), o(f);
  }
  function o(f) {
    return a = f, s(f);
  }
  function s(f) {
    return f === a ? (t.enter("thematicBreakSequence"), u(f)) : r >= 3 && (f === null || Gn(f)) ? (t.exit("thematicBreak"), e(f)) : n(f);
  }
  function u(f) {
    return f === a ? (t.consume(f), r++, u) : (t.exit("thematicBreakSequence"), Nr(f) ? Kr(t, s, "whitespace")(f) : s(f));
  }
}
const Zu = {
  name: "list",
  tokenize: bWe,
  continuation: {
    tokenize: vWe
  },
  exit: OWe
}, mWe = {
  tokenize: EWe,
  partial: !0
}, gWe = {
  tokenize: yWe,
  partial: !0
};
function bWe(t, e, n) {
  const r = this, a = r.events[r.events.length - 1];
  let i = a && a[1].type === "linePrefix" ? a[2].sliceSerialize(a[1], !0).length : 0, o = 0;
  return s;
  function s(O) {
    const w = r.containerState.type || (O === 42 || O === 43 || O === 45 ? "listUnordered" : "listOrdered");
    if (w === "listUnordered" ? !r.containerState.marker || O === r.containerState.marker : O5(O)) {
      if (r.containerState.type || (r.containerState.type = w, t.enter(w, {
        _container: !0
      })), w === "listUnordered")
        return t.enter("listItemPrefix"), O === 42 || O === 45 ? t.check($k, n, f)(O) : f(O);
      if (!r.interrupt || O === 49)
        return t.enter("listItemPrefix"), t.enter("listItemValue"), u(O);
    }
    return n(O);
  }
  function u(O) {
    return O5(O) && ++o < 10 ? (t.consume(O), u) : (!r.interrupt || o < 2) && (r.containerState.marker ? O === r.containerState.marker : O === 41 || O === 46) ? (t.exit("listItemValue"), f(O)) : n(O);
  }
  function f(O) {
    return t.enter("listItemMarker"), t.consume(O), t.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || O, t.check(
      U_,
      // Can’t be empty when interrupting.
      r.interrupt ? n : p,
      t.attempt(
        mWe,
        v,
        m
      )
    );
  }
  function p(O) {
    return r.containerState.initialBlankLine = !0, i++, v(O);
  }
  function m(O) {
    return Nr(O) ? (t.enter("listItemPrefixWhitespace"), t.consume(O), t.exit("listItemPrefixWhitespace"), v) : n(O);
  }
  function v(O) {
    return r.containerState.size = i + r.sliceSerialize(t.exit("listItemPrefix"), !0).length, e(O);
  }
}
function vWe(t, e, n) {
  const r = this;
  return r.containerState._closeFlow = void 0, t.check(U_, a, i);
  function a(s) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, Kr(
      t,
      e,
      "listItemIndent",
      r.containerState.size + 1
    )(s);
  }
  function i(s) {
    return r.containerState.furtherBlankLines || !Nr(s) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, o(s)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, t.attempt(gWe, e, o)(s));
  }
  function o(s) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, Kr(
      t,
      t.attempt(Zu, e, n),
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(s);
  }
}
function yWe(t, e, n) {
  const r = this;
  return Kr(
    t,
    a,
    "listItemIndent",
    r.containerState.size + 1
  );
  function a(i) {
    const o = r.events[r.events.length - 1];
    return o && o[1].type === "listItemIndent" && o[2].sliceSerialize(o[1], !0).length === r.containerState.size ? e(i) : n(i);
  }
}
function OWe(t) {
  t.exit(this.containerState.type);
}
function EWe(t, e, n) {
  const r = this;
  return Kr(
    t,
    a,
    "listItemPrefixWhitespace",
    r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4 + 1
  );
  function a(i) {
    const o = r.events[r.events.length - 1];
    return !Nr(i) && o && o[1].type === "listItemPrefixWhitespace" ? e(i) : n(i);
  }
}
const JJ = {
  name: "setextUnderline",
  tokenize: wWe,
  resolveTo: SWe
};
function SWe(t, e) {
  let n = t.length, r, a, i;
  for (; n--; )
    if (t[n][0] === "enter") {
      if (t[n][1].type === "content") {
        r = n;
        break;
      }
      t[n][1].type === "paragraph" && (a = n);
    } else
      t[n][1].type === "content" && t.splice(n, 1), !i && t[n][1].type === "definition" && (i = n);
  const o = {
    type: "setextHeading",
    start: Object.assign({}, t[a][1].start),
    end: Object.assign({}, t[t.length - 1][1].end)
  };
  return t[a][1].type = "setextHeadingText", i ? (t.splice(a, 0, ["enter", o, e]), t.splice(i + 1, 0, ["exit", t[r][1], e]), t[r][1].end = Object.assign({}, t[i][1].end)) : t[r][1] = o, t.push(["exit", o, e]), t;
}
function wWe(t, e, n) {
  const r = this;
  let a;
  return i;
  function i(f) {
    let p = r.events.length, m;
    for (; p--; )
      if (r.events[p][1].type !== "lineEnding" && r.events[p][1].type !== "linePrefix" && r.events[p][1].type !== "content") {
        m = r.events[p][1].type === "paragraph";
        break;
      }
    return !r.parser.lazy[r.now().line] && (r.interrupt || m) ? (t.enter("setextHeadingLine"), a = f, o(f)) : n(f);
  }
  function o(f) {
    return t.enter("setextHeadingLineSequence"), s(f);
  }
  function s(f) {
    return f === a ? (t.consume(f), s) : (t.exit("setextHeadingLineSequence"), Nr(f) ? Kr(t, u, "lineSuffix")(f) : u(f));
  }
  function u(f) {
    return f === null || Gn(f) ? (t.exit("setextHeadingLine"), e(f)) : n(f);
  }
}
const TWe = {
  tokenize: _We
};
function _We(t) {
  const e = this, n = t.attempt(
    // Try to parse a blank line.
    U_,
    r,
    // Try to parse initial flow (essentially, only code).
    t.attempt(
      this.parser.constructs.flowInitial,
      a,
      Kr(
        t,
        t.attempt(
          this.parser.constructs.flow,
          a,
          t.attempt(R7e, a)
        ),
        "linePrefix"
      )
    )
  );
  return n;
  function r(i) {
    if (i === null) {
      t.consume(i);
      return;
    }
    return t.enter("lineEndingBlank"), t.consume(i), t.exit("lineEndingBlank"), e.currentConstruct = void 0, n;
  }
  function a(i) {
    if (i === null) {
      t.consume(i);
      return;
    }
    return t.enter("lineEnding"), t.consume(i), t.exit("lineEnding"), e.currentConstruct = void 0, n;
  }
}
const CWe = {
  resolveAll: Cce()
}, xWe = _ce("string"), AWe = _ce("text");
function _ce(t) {
  return {
    tokenize: e,
    resolveAll: Cce(
      t === "text" ? kWe : void 0
    )
  };
  function e(n) {
    const r = this, a = this.parser.constructs[t], i = n.attempt(a, o, s);
    return o;
    function o(p) {
      return f(p) ? i(p) : s(p);
    }
    function s(p) {
      if (p === null) {
        n.consume(p);
        return;
      }
      return n.enter("data"), n.consume(p), u;
    }
    function u(p) {
      return f(p) ? (n.exit("data"), i(p)) : (n.consume(p), u);
    }
    function f(p) {
      if (p === null)
        return !0;
      const m = a[p];
      let v = -1;
      if (m)
        for (; ++v < m.length; ) {
          const O = m[v];
          if (!O.previous || O.previous.call(r, r.previous))
            return !0;
        }
      return !1;
    }
  }
}
function Cce(t) {
  return e;
  function e(n, r) {
    let a = -1, i;
    for (; ++a <= n.length; )
      i === void 0 ? n[a] && n[a][1].type === "data" && (i = a, a++) : (!n[a] || n[a][1].type !== "data") && (a !== i + 2 && (n[i][1].end = n[a - 1][1].end, n.splice(i + 2, a - i - 2), a = i + 2), i = void 0);
    return t ? t(n, r) : n;
  }
}
function kWe(t, e) {
  let n = 0;
  for (; ++n <= t.length; )
    if ((n === t.length || t[n][1].type === "lineEnding") && t[n - 1][1].type === "data") {
      const r = t[n - 1][1], a = e.sliceStream(r);
      let i = a.length, o = -1, s = 0, u;
      for (; i--; ) {
        const f = a[i];
        if (typeof f == "string") {
          for (o = f.length; f.charCodeAt(o - 1) === 32; )
            s++, o--;
          if (o)
            break;
          o = -1;
        } else if (f === -2)
          u = !0, s++;
        else if (f !== -1) {
          i++;
          break;
        }
      }
      if (s) {
        const f = {
          type: n === t.length || u || s < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            line: r.end.line,
            column: r.end.column - s,
            offset: r.end.offset - s,
            _index: r.start._index + i,
            _bufferIndex: i ? o : r.start._bufferIndex + o
          },
          end: Object.assign({}, r.end)
        };
        r.end = Object.assign({}, f.start), r.start.offset === r.end.offset ? Object.assign(r, f) : (t.splice(
          n,
          0,
          ["enter", f, e],
          ["exit", f, e]
        ), n += 2);
      }
      n++;
    }
  return t;
}
function RWe(t, e, n) {
  let r = Object.assign(
    n ? Object.assign({}, n) : {
      line: 1,
      column: 1,
      offset: 0
    },
    {
      _index: 0,
      _bufferIndex: -1
    }
  );
  const a = {}, i = [];
  let o = [], s = [];
  const u = {
    consume: N,
    enter: P,
    exit: I,
    attempt: H(D),
    check: H(M),
    interrupt: H(M, {
      interrupt: !0
    })
  }, f = {
    previous: null,
    code: null,
    containerState: {},
    events: [],
    parser: t,
    sliceStream: O,
    sliceSerialize: v,
    now: w,
    defineSkip: _,
    write: m
  };
  let p = e.tokenize.call(f, u);
  return e.resolveAll && i.push(e), f;
  function m(ne) {
    return o = $f(o, ne), C(), o[o.length - 1] !== null ? [] : (Y(e, 0), f.events = fN(i, f.events, f), f.events);
  }
  function v(ne, J) {
    return DWe(O(ne), J);
  }
  function O(ne) {
    return IWe(o, ne);
  }
  function w() {
    const { line: ne, column: J, offset: ue, _index: ee, _bufferIndex: fe } = r;
    return {
      line: ne,
      column: J,
      offset: ue,
      _index: ee,
      _bufferIndex: fe
    };
  }
  function _(ne) {
    a[ne.line] = ne.column, Q();
  }
  function C() {
    let ne;
    for (; r._index < o.length; ) {
      const J = o[r._index];
      if (typeof J == "string")
        for (ne = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === ne && r._bufferIndex < J.length; )
          A(J.charCodeAt(r._bufferIndex));
      else
        A(J);
    }
  }
  function A(ne) {
    p = p(ne);
  }
  function N(ne) {
    Gn(ne) ? (r.line++, r.column = 1, r.offset += ne === -3 ? 2 : 1, Q()) : ne !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === o[r._index].length && (r._bufferIndex = -1, r._index++)), f.previous = ne;
  }
  function P(ne, J) {
    const ue = J || {};
    return ue.type = ne, ue.start = w(), f.events.push(["enter", ue, f]), s.push(ue), ue;
  }
  function I(ne) {
    const J = s.pop();
    return J.end = w(), f.events.push(["exit", J, f]), J;
  }
  function D(ne, J) {
    Y(ne, J.from);
  }
  function M(ne, J) {
    J.restore();
  }
  function H(ne, J) {
    return ue;
    function ue(ee, fe, de) {
      let ie, le, ye, B;
      return Array.isArray(ee) ? _e(ee) : "tokenize" in ee ? (
        // @ts-expect-error Looks like a construct.
        _e([ee])
      ) : pe(ee);
      function pe(K) {
        return Ee;
        function Ee(he) {
          const Ae = he !== null && K[he], Te = he !== null && K.null, je = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(Ae) ? Ae : Ae ? [Ae] : [],
            ...Array.isArray(Te) ? Te : Te ? [Te] : []
          ];
          return _e(je)(he);
        }
      }
      function _e(K) {
        return ie = K, le = 0, K.length === 0 ? de : Z(K[le]);
      }
      function Z(K) {
        return Ee;
        function Ee(he) {
          return B = q(), ye = K, K.partial || (f.currentConstruct = K), K.name && f.parser.constructs.disable.null.includes(K.name) ? j() : K.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            J ? Object.assign(Object.create(f), J) : f,
            u,
            ce,
            j
          )(he);
        }
      }
      function ce(K) {
        return ne(ye, B), fe;
      }
      function j(K) {
        return B.restore(), ++le < ie.length ? Z(ie[le]) : de;
      }
    }
  }
  function Y(ne, J) {
    ne.resolveAll && !i.includes(ne) && i.push(ne), ne.resolve && Wc(
      f.events,
      J,
      f.events.length - J,
      ne.resolve(f.events.slice(J), f)
    ), ne.resolveTo && (f.events = ne.resolveTo(f.events, f));
  }
  function q() {
    const ne = w(), J = f.previous, ue = f.currentConstruct, ee = f.events.length, fe = Array.from(s);
    return {
      restore: de,
      from: ee
    };
    function de() {
      r = ne, f.previous = J, f.currentConstruct = ue, f.events.length = ee, s = fe, Q();
    }
  }
  function Q() {
    r.line in a && r.column < 2 && (r.column = a[r.line], r.offset += a[r.line] - 1);
  }
}
function IWe(t, e) {
  const n = e.start._index, r = e.start._bufferIndex, a = e.end._index, i = e.end._bufferIndex;
  let o;
  if (n === a)
    o = [t[n].slice(r, i)];
  else {
    if (o = t.slice(n, a), r > -1) {
      const s = o[0];
      typeof s == "string" ? o[0] = s.slice(r) : o.shift();
    }
    i > 0 && o.push(t[a].slice(0, i));
  }
  return o;
}
function DWe(t, e) {
  let n = -1;
  const r = [];
  let a;
  for (; ++n < t.length; ) {
    const i = t[n];
    let o;
    if (typeof i == "string")
      o = i;
    else
      switch (i) {
        case -5: {
          o = "\r";
          break;
        }
        case -4: {
          o = `
`;
          break;
        }
        case -3: {
          o = `\r
`;
          break;
        }
        case -2: {
          o = e ? " " : "	";
          break;
        }
        case -1: {
          if (!e && a)
            continue;
          o = " ";
          break;
        }
        default:
          o = String.fromCharCode(i);
      }
    a = i === -2, r.push(o);
  }
  return r.join("");
}
const NWe = {
  42: Zu,
  43: Zu,
  45: Zu,
  48: Zu,
  49: Zu,
  50: Zu,
  51: Zu,
  52: Zu,
  53: Zu,
  54: Zu,
  55: Zu,
  56: Zu,
  57: Zu,
  62: vce
}, PWe = {
  91: L7e
}, LWe = {
  [-2]: q3,
  [-1]: q3,
  32: q3
}, MWe = {
  35: z7e,
  42: $k,
  45: [JJ, $k],
  60: j7e,
  61: JJ,
  95: $k,
  96: qJ,
  126: qJ
}, FWe = {
  38: Oce,
  92: yce
}, $We = {
  [-5]: K3,
  [-4]: K3,
  [-3]: K3,
  33: uWe,
  38: Oce,
  42: E5,
  60: [d7e, K7e],
  91: fWe,
  92: [B7e, yce],
  93: F7,
  95: E5,
  96: _7e
}, BWe = {
  null: [E5, CWe]
}, UWe = {
  null: [42, 95]
}, zWe = {
  null: []
}, HWe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: UWe,
  contentInitial: PWe,
  disable: zWe,
  document: NWe,
  flow: MWe,
  flowInitial: LWe,
  insideSpan: BWe,
  string: FWe,
  text: $We
}, Symbol.toStringTag, { value: "Module" }));
function WWe(t) {
  const n = (
    /** @type {FullNormalizedExtension} */
    mce([HWe, ...(t || {}).extensions || []])
  ), r = {
    defined: [],
    lazy: {},
    constructs: n,
    content: a(i7e),
    document: a(s7e),
    flow: a(TWe),
    string: a(xWe),
    text: a(AWe)
  };
  return r;
  function a(i) {
    return o;
    function o(s) {
      return RWe(r, i, s);
    }
  }
}
function QWe(t) {
  for (; !Ece(t); )
    ;
  return t;
}
const eee = /[\0\t\n\r]/g;
function jWe() {
  let t = 1, e = "", n = !0, r;
  return a;
  function a(i, o, s) {
    const u = [];
    let f, p, m, v, O;
    for (i = e + (typeof i == "string" ? i.toString() : new TextDecoder(o || void 0).decode(i)), m = 0, e = "", n && (i.charCodeAt(0) === 65279 && m++, n = void 0); m < i.length; ) {
      if (eee.lastIndex = m, f = eee.exec(i), v = f && f.index !== void 0 ? f.index : i.length, O = i.charCodeAt(v), !f) {
        e = i.slice(m);
        break;
      }
      if (O === 10 && m === v && r)
        u.push(-3), r = void 0;
      else
        switch (r && (u.push(-5), r = void 0), m < v && (u.push(i.slice(m, v)), t += v - m), O) {
          case 0: {
            u.push(65533), t++;
            break;
          }
          case 9: {
            for (p = Math.ceil(t / 4) * 4, u.push(-2); t++ < p; )
              u.push(-1);
            break;
          }
          case 10: {
            u.push(-4), t = 1;
            break;
          }
          default:
            r = !0, t = 1;
        }
      m = v + 1;
    }
    return s && (r && u.push(-5), e && u.push(e), u.push(null)), u;
  }
}
const GWe = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function VWe(t) {
  return t.replace(GWe, YWe);
}
function YWe(t, e, n) {
  if (e)
    return e;
  if (n.charCodeAt(0) === 35) {
    const a = n.charCodeAt(1), i = a === 120 || a === 88;
    return gce(n.slice(i ? 2 : 1), i ? 16 : 10);
  }
  return i_(n) || t;
}
const xce = {}.hasOwnProperty;
function ZWe(t, e, n) {
  return typeof e != "string" && (n = e, e = void 0), XWe(n)(
    QWe(
      WWe(n).document().write(jWe()(t, e, !0))
    )
  );
}
function XWe(t) {
  const e = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: i(mt),
      autolinkProtocol: q,
      autolinkEmail: q,
      atxHeading: i(st),
      blockQuote: i(Ae),
      characterEscape: q,
      characterReference: q,
      codeFenced: i(Te),
      codeFencedFenceInfo: o,
      codeFencedFenceMeta: o,
      codeIndented: i(Te, o),
      codeText: i(je, o),
      codeTextData: q,
      data: q,
      codeFlowValue: q,
      definition: i(we),
      definitionDestinationString: o,
      definitionLabelString: o,
      definitionTitleString: o,
      emphasis: i(lt),
      hardBreakEscape: i(Oe),
      hardBreakTrailing: i(Oe),
      htmlFlow: i(Re, o),
      htmlFlowData: q,
      htmlText: i(Re, o),
      htmlTextData: q,
      image: i(Be),
      label: o,
      link: i(mt),
      listItem: i(ut),
      listItemValue: v,
      listOrdered: i(Tt, m),
      listUnordered: i(Tt),
      paragraph: i(wt),
      reference: Z,
      referenceString: o,
      resourceDestinationString: o,
      resourceTitleString: o,
      setextHeading: i(st),
      strong: i(Yt),
      thematicBreak: i(Ut)
    },
    exit: {
      atxHeading: u(),
      atxHeadingSequence: D,
      autolink: u(),
      autolinkEmail: he,
      autolinkProtocol: Ee,
      blockQuote: u(),
      characterEscapeValue: Q,
      characterReferenceMarkerHexadecimal: j,
      characterReferenceMarkerNumeric: j,
      characterReferenceValue: K,
      codeFenced: u(C),
      codeFencedFence: _,
      codeFencedFenceInfo: O,
      codeFencedFenceMeta: w,
      codeFlowValue: Q,
      codeIndented: u(A),
      codeText: u(fe),
      codeTextData: Q,
      data: Q,
      definition: u(),
      definitionDestinationString: I,
      definitionLabelString: N,
      definitionTitleString: P,
      emphasis: u(),
      hardBreakEscape: u(J),
      hardBreakTrailing: u(J),
      htmlFlow: u(ue),
      htmlFlowData: Q,
      htmlText: u(ee),
      htmlTextData: Q,
      image: u(ie),
      label: ye,
      labelText: le,
      lineEnding: ne,
      link: u(de),
      listItem: u(),
      listOrdered: u(),
      listUnordered: u(),
      paragraph: u(),
      referenceString: ce,
      resourceDestinationString: B,
      resourceTitleString: pe,
      resource: _e,
      setextHeading: u(Y),
      setextHeadingLineSequence: H,
      setextHeadingText: M,
      strong: u(),
      thematicBreak: u()
    }
  };
  Ace(e, (t || {}).mdastExtensions || []);
  const n = {};
  return r;
  function r(He) {
    let Ve = {
      type: "root",
      children: []
    };
    const Ie = {
      stack: [Ve],
      tokenStack: [],
      config: e,
      enter: s,
      exit: f,
      buffer: o,
      resume: p,
      data: n
    }, it = [];
    let zt = -1;
    for (; ++zt < He.length; )
      if (He[zt][1].type === "listOrdered" || He[zt][1].type === "listUnordered")
        if (He[zt][0] === "enter")
          it.push(zt);
        else {
          const Ht = it.pop();
          zt = a(He, Ht, zt);
        }
    for (zt = -1; ++zt < He.length; ) {
      const Ht = e[He[zt][0]];
      xce.call(Ht, He[zt][1].type) && Ht[He[zt][1].type].call(
        Object.assign(
          {
            sliceSerialize: He[zt][2].sliceSerialize
          },
          Ie
        ),
        He[zt][1]
      );
    }
    if (Ie.tokenStack.length > 0) {
      const Ht = Ie.tokenStack[Ie.tokenStack.length - 1];
      (Ht[1] || tee).call(Ie, void 0, Ht[0]);
    }
    for (Ve.position = {
      start: Db(
        He.length > 0 ? He[0][1].start : {
          line: 1,
          column: 1,
          offset: 0
        }
      ),
      end: Db(
        He.length > 0 ? He[He.length - 2][1].end : {
          line: 1,
          column: 1,
          offset: 0
        }
      )
    }, zt = -1; ++zt < e.transforms.length; )
      Ve = e.transforms[zt](Ve) || Ve;
    return Ve;
  }
  function a(He, Ve, Ie) {
    let it = Ve - 1, zt = -1, Ht = !1, bt, Mt, ln, ze;
    for (; ++it <= Ie; ) {
      const gt = He[it];
      switch (gt[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          gt[0] === "enter" ? zt++ : zt--, ze = void 0;
          break;
        }
        case "lineEndingBlank": {
          gt[0] === "enter" && (bt && !ze && !zt && !ln && (ln = it), ze = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          ze = void 0;
      }
      if (!zt && gt[0] === "enter" && gt[1].type === "listItemPrefix" || zt === -1 && gt[0] === "exit" && (gt[1].type === "listUnordered" || gt[1].type === "listOrdered")) {
        if (bt) {
          let Bt = it;
          for (Mt = void 0; Bt--; ) {
            const Qt = He[Bt];
            if (Qt[1].type === "lineEnding" || Qt[1].type === "lineEndingBlank") {
              if (Qt[0] === "exit")
                continue;
              Mt && (He[Mt][1].type = "lineEndingBlank", Ht = !0), Qt[1].type = "lineEnding", Mt = Bt;
            } else if (!(Qt[1].type === "linePrefix" || Qt[1].type === "blockQuotePrefix" || Qt[1].type === "blockQuotePrefixWhitespace" || Qt[1].type === "blockQuoteMarker" || Qt[1].type === "listItemIndent"))
              break;
          }
          ln && (!Mt || ln < Mt) && (bt._spread = !0), bt.end = Object.assign(
            {},
            Mt ? He[Mt][1].start : gt[1].end
          ), He.splice(Mt || it, 0, ["exit", bt, gt[2]]), it++, Ie++;
        }
        if (gt[1].type === "listItemPrefix") {
          const Bt = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, gt[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          bt = Bt, He.splice(it, 0, ["enter", Bt, gt[2]]), it++, Ie++, ln = void 0, ze = !0;
        }
      }
    }
    return He[Ve][1]._spread = Ht, Ie;
  }
  function i(He, Ve) {
    return Ie;
    function Ie(it) {
      s.call(this, He(it), it), Ve && Ve.call(this, it);
    }
  }
  function o() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function s(He, Ve, Ie) {
    this.stack[this.stack.length - 1].children.push(He), this.stack.push(He), this.tokenStack.push([Ve, Ie]), He.position = {
      start: Db(Ve.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function u(He) {
    return Ve;
    function Ve(Ie) {
      He && He.call(this, Ie), f.call(this, Ie);
    }
  }
  function f(He, Ve) {
    const Ie = this.stack.pop(), it = this.tokenStack.pop();
    if (it)
      it[0].type !== He.type && (Ve ? Ve.call(this, He, it[0]) : (it[1] || tee).call(this, He, it[0]));
    else
      throw new Error(
        "Cannot close `" + He.type + "` (" + OT({
          start: He.start,
          end: He.end
        }) + "): it’s not open"
      );
    Ie.position.end = Db(He.end);
  }
  function p() {
    return KHe(this.stack.pop());
  }
  function m() {
    this.data.expectingFirstListItemValue = !0;
  }
  function v(He) {
    if (this.data.expectingFirstListItemValue) {
      const Ve = this.stack[this.stack.length - 2];
      Ve.start = Number.parseInt(this.sliceSerialize(He), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function O() {
    const He = this.resume(), Ve = this.stack[this.stack.length - 1];
    Ve.lang = He;
  }
  function w() {
    const He = this.resume(), Ve = this.stack[this.stack.length - 1];
    Ve.meta = He;
  }
  function _() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function C() {
    const He = this.resume(), Ve = this.stack[this.stack.length - 1];
    Ve.value = He.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function A() {
    const He = this.resume(), Ve = this.stack[this.stack.length - 1];
    Ve.value = He.replace(/(\r?\n|\r)$/g, "");
  }
  function N(He) {
    const Ve = this.resume(), Ie = this.stack[this.stack.length - 1];
    Ie.label = Ve, Ie.identifier = Vd(
      this.sliceSerialize(He)
    ).toLowerCase();
  }
  function P() {
    const He = this.resume(), Ve = this.stack[this.stack.length - 1];
    Ve.title = He;
  }
  function I() {
    const He = this.resume(), Ve = this.stack[this.stack.length - 1];
    Ve.url = He;
  }
  function D(He) {
    const Ve = this.stack[this.stack.length - 1];
    if (!Ve.depth) {
      const Ie = this.sliceSerialize(He).length;
      Ve.depth = Ie;
    }
  }
  function M() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function H(He) {
    const Ve = this.stack[this.stack.length - 1];
    Ve.depth = this.sliceSerialize(He).codePointAt(0) === 61 ? 1 : 2;
  }
  function Y() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function q(He) {
    const Ie = this.stack[this.stack.length - 1].children;
    let it = Ie[Ie.length - 1];
    (!it || it.type !== "text") && (it = Rt(), it.position = {
      start: Db(He.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, Ie.push(it)), this.stack.push(it);
  }
  function Q(He) {
    const Ve = this.stack.pop();
    Ve.value += this.sliceSerialize(He), Ve.position.end = Db(He.end);
  }
  function ne(He) {
    const Ve = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const Ie = Ve.children[Ve.children.length - 1];
      Ie.position.end = Db(He.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && e.canContainEols.includes(Ve.type) && (q.call(this, He), Q.call(this, He));
  }
  function J() {
    this.data.atHardBreak = !0;
  }
  function ue() {
    const He = this.resume(), Ve = this.stack[this.stack.length - 1];
    Ve.value = He;
  }
  function ee() {
    const He = this.resume(), Ve = this.stack[this.stack.length - 1];
    Ve.value = He;
  }
  function fe() {
    const He = this.resume(), Ve = this.stack[this.stack.length - 1];
    Ve.value = He;
  }
  function de() {
    const He = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const Ve = this.data.referenceType || "shortcut";
      He.type += "Reference", He.referenceType = Ve, delete He.url, delete He.title;
    } else
      delete He.identifier, delete He.label;
    this.data.referenceType = void 0;
  }
  function ie() {
    const He = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const Ve = this.data.referenceType || "shortcut";
      He.type += "Reference", He.referenceType = Ve, delete He.url, delete He.title;
    } else
      delete He.identifier, delete He.label;
    this.data.referenceType = void 0;
  }
  function le(He) {
    const Ve = this.sliceSerialize(He), Ie = this.stack[this.stack.length - 2];
    Ie.label = VWe(Ve), Ie.identifier = Vd(Ve).toLowerCase();
  }
  function ye() {
    const He = this.stack[this.stack.length - 1], Ve = this.resume(), Ie = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, Ie.type === "link") {
      const it = He.children;
      Ie.children = it;
    } else
      Ie.alt = Ve;
  }
  function B() {
    const He = this.resume(), Ve = this.stack[this.stack.length - 1];
    Ve.url = He;
  }
  function pe() {
    const He = this.resume(), Ve = this.stack[this.stack.length - 1];
    Ve.title = He;
  }
  function _e() {
    this.data.inReference = void 0;
  }
  function Z() {
    this.data.referenceType = "collapsed";
  }
  function ce(He) {
    const Ve = this.resume(), Ie = this.stack[this.stack.length - 1];
    Ie.label = Ve, Ie.identifier = Vd(
      this.sliceSerialize(He)
    ).toLowerCase(), this.data.referenceType = "full";
  }
  function j(He) {
    this.data.characterReferenceType = He.type;
  }
  function K(He) {
    const Ve = this.sliceSerialize(He), Ie = this.data.characterReferenceType;
    let it;
    Ie ? (it = gce(
      Ve,
      Ie === "characterReferenceMarkerNumeric" ? 10 : 16
    ), this.data.characterReferenceType = void 0) : it = i_(Ve);
    const zt = this.stack.pop();
    zt.value += it, zt.position.end = Db(He.end);
  }
  function Ee(He) {
    Q.call(this, He);
    const Ve = this.stack[this.stack.length - 1];
    Ve.url = this.sliceSerialize(He);
  }
  function he(He) {
    Q.call(this, He);
    const Ve = this.stack[this.stack.length - 1];
    Ve.url = "mailto:" + this.sliceSerialize(He);
  }
  function Ae() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function Te() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function je() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function we() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function lt() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function st() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function Oe() {
    return {
      type: "break"
    };
  }
  function Re() {
    return {
      type: "html",
      value: ""
    };
  }
  function Be() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function mt() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function Tt(He) {
    return {
      type: "list",
      ordered: He.type === "listOrdered",
      start: null,
      spread: He._spread,
      children: []
    };
  }
  function ut(He) {
    return {
      type: "listItem",
      spread: He._spread,
      checked: null,
      children: []
    };
  }
  function wt() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function Yt() {
    return {
      type: "strong",
      children: []
    };
  }
  function Rt() {
    return {
      type: "text",
      value: ""
    };
  }
  function Ut() {
    return {
      type: "thematicBreak"
    };
  }
}
function Db(t) {
  return {
    line: t.line,
    column: t.column,
    offset: t.offset
  };
}
function Ace(t, e) {
  let n = -1;
  for (; ++n < e.length; ) {
    const r = e[n];
    Array.isArray(r) ? Ace(t, r) : qWe(t, r);
  }
}
function qWe(t, e) {
  let n;
  for (n in e)
    if (xce.call(e, n))
      switch (n) {
        case "canContainEols": {
          const r = e[n];
          r && t[n].push(...r);
          break;
        }
        case "transforms": {
          const r = e[n];
          r && t[n].push(...r);
          break;
        }
        case "enter":
        case "exit": {
          const r = e[n];
          r && Object.assign(t[n], r);
          break;
        }
      }
}
function tee(t, e) {
  throw t ? new Error(
    "Cannot close `" + t.type + "` (" + OT({
      start: t.start,
      end: t.end
    }) + "): a different token (`" + e.type + "`, " + OT({
      start: e.start,
      end: e.end
    }) + ") is open"
  ) : new Error(
    "Cannot close document, a token (`" + e.type + "`, " + OT({
      start: e.start,
      end: e.end
    }) + ") is still open"
  );
}
function KWe(t) {
  const e = this;
  e.parser = n;
  function n(r) {
    return ZWe(r, {
      ...e.data("settings"),
      ...t,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: e.data("micromarkExtensions") || [],
      mdastExtensions: e.data("fromMarkdownExtensions") || []
    });
  }
}
function JWe(t, e) {
  const n = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: t.wrap(t.all(e), !0)
  };
  return t.patch(e, n), t.applyData(e, n);
}
function eQe(t, e) {
  const n = { type: "element", tagName: "br", properties: {}, children: [] };
  return t.patch(e, n), [t.applyData(e, n), { type: "text", value: `
` }];
}
function tQe(t, e) {
  const n = e.value ? e.value + `
` : "", r = {};
  e.lang && (r.className = ["language-" + e.lang]);
  let a = {
    type: "element",
    tagName: "code",
    properties: r,
    children: [{ type: "text", value: n }]
  };
  return e.meta && (a.data = { meta: e.meta }), t.patch(e, a), a = t.applyData(e, a), a = { type: "element", tagName: "pre", properties: {}, children: [a] }, t.patch(e, a), a;
}
function nQe(t, e) {
  const n = {
    type: "element",
    tagName: "del",
    properties: {},
    children: t.all(e)
  };
  return t.patch(e, n), t.applyData(e, n);
}
function rQe(t, e) {
  const n = {
    type: "element",
    tagName: "em",
    properties: {},
    children: t.all(e)
  };
  return t.patch(e, n), t.applyData(e, n);
}
function aQe(t, e) {
  const n = typeof t.options.clobberPrefix == "string" ? t.options.clobberPrefix : "user-content-", r = String(e.identifier).toUpperCase(), a = x1(r.toLowerCase()), i = t.footnoteOrder.indexOf(r);
  let o, s = t.footnoteCounts.get(r);
  s === void 0 ? (s = 0, t.footnoteOrder.push(r), o = t.footnoteOrder.length) : o = i + 1, s += 1, t.footnoteCounts.set(r, s);
  const u = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + n + "fn-" + a,
      id: n + "fnref-" + a + (s > 1 ? "-" + s : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(o) }]
  };
  t.patch(e, u);
  const f = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [u]
  };
  return t.patch(e, f), t.applyData(e, f);
}
function iQe(t, e) {
  const n = {
    type: "element",
    tagName: "h" + e.depth,
    properties: {},
    children: t.all(e)
  };
  return t.patch(e, n), t.applyData(e, n);
}
function oQe(t, e) {
  if (t.options.allowDangerousHtml) {
    const n = { type: "raw", value: e.value };
    return t.patch(e, n), t.applyData(e, n);
  }
}
function kce(t, e) {
  const n = e.referenceType;
  let r = "]";
  if (n === "collapsed" ? r += "[]" : n === "full" && (r += "[" + (e.label || e.identifier) + "]"), e.type === "imageReference")
    return [{ type: "text", value: "![" + e.alt + r }];
  const a = t.all(e), i = a[0];
  i && i.type === "text" ? i.value = "[" + i.value : a.unshift({ type: "text", value: "[" });
  const o = a[a.length - 1];
  return o && o.type === "text" ? o.value += r : a.push({ type: "text", value: r }), a;
}
function sQe(t, e) {
  const n = String(e.identifier).toUpperCase(), r = t.definitionById.get(n);
  if (!r)
    return kce(t, e);
  const a = { src: x1(r.url || ""), alt: e.alt };
  r.title !== null && r.title !== void 0 && (a.title = r.title);
  const i = { type: "element", tagName: "img", properties: a, children: [] };
  return t.patch(e, i), t.applyData(e, i);
}
function lQe(t, e) {
  const n = { src: x1(e.url) };
  e.alt !== null && e.alt !== void 0 && (n.alt = e.alt), e.title !== null && e.title !== void 0 && (n.title = e.title);
  const r = { type: "element", tagName: "img", properties: n, children: [] };
  return t.patch(e, r), t.applyData(e, r);
}
function uQe(t, e) {
  const n = { type: "text", value: e.value.replace(/\r?\n|\r/g, " ") };
  t.patch(e, n);
  const r = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [n]
  };
  return t.patch(e, r), t.applyData(e, r);
}
function cQe(t, e) {
  const n = String(e.identifier).toUpperCase(), r = t.definitionById.get(n);
  if (!r)
    return kce(t, e);
  const a = { href: x1(r.url || "") };
  r.title !== null && r.title !== void 0 && (a.title = r.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: a,
    children: t.all(e)
  };
  return t.patch(e, i), t.applyData(e, i);
}
function fQe(t, e) {
  const n = { href: x1(e.url) };
  e.title !== null && e.title !== void 0 && (n.title = e.title);
  const r = {
    type: "element",
    tagName: "a",
    properties: n,
    children: t.all(e)
  };
  return t.patch(e, r), t.applyData(e, r);
}
function dQe(t, e, n) {
  const r = t.all(e), a = n ? pQe(n) : Rce(e), i = {}, o = [];
  if (typeof e.checked == "boolean") {
    const p = r[0];
    let m;
    p && p.type === "element" && p.tagName === "p" ? m = p : (m = { type: "element", tagName: "p", properties: {}, children: [] }, r.unshift(m)), m.children.length > 0 && m.children.unshift({ type: "text", value: " " }), m.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: e.checked, disabled: !0 },
      children: []
    }), i.className = ["task-list-item"];
  }
  let s = -1;
  for (; ++s < r.length; ) {
    const p = r[s];
    (a || s !== 0 || p.type !== "element" || p.tagName !== "p") && o.push({ type: "text", value: `
` }), p.type === "element" && p.tagName === "p" && !a ? o.push(...p.children) : o.push(p);
  }
  const u = r[r.length - 1];
  u && (a || u.type !== "element" || u.tagName !== "p") && o.push({ type: "text", value: `
` });
  const f = { type: "element", tagName: "li", properties: i, children: o };
  return t.patch(e, f), t.applyData(e, f);
}
function pQe(t) {
  let e = !1;
  if (t.type === "list") {
    e = t.spread || !1;
    const n = t.children;
    let r = -1;
    for (; !e && ++r < n.length; )
      e = Rce(n[r]);
  }
  return e;
}
function Rce(t) {
  const e = t.spread;
  return e ?? t.children.length > 1;
}
function hQe(t, e) {
  const n = {}, r = t.all(e);
  let a = -1;
  for (typeof e.start == "number" && e.start !== 1 && (n.start = e.start); ++a < r.length; ) {
    const o = r[a];
    if (o.type === "element" && o.tagName === "li" && o.properties && Array.isArray(o.properties.className) && o.properties.className.includes("task-list-item")) {
      n.className = ["contains-task-list"];
      break;
    }
  }
  const i = {
    type: "element",
    tagName: e.ordered ? "ol" : "ul",
    properties: n,
    children: t.wrap(r, !0)
  };
  return t.patch(e, i), t.applyData(e, i);
}
function mQe(t, e) {
  const n = {
    type: "element",
    tagName: "p",
    properties: {},
    children: t.all(e)
  };
  return t.patch(e, n), t.applyData(e, n);
}
function gQe(t, e) {
  const n = { type: "root", children: t.wrap(t.all(e)) };
  return t.patch(e, n), t.applyData(e, n);
}
function bQe(t, e) {
  const n = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: t.all(e)
  };
  return t.patch(e, n), t.applyData(e, n);
}
function vQe(t, e) {
  const n = t.all(e), r = n.shift(), a = [];
  if (r) {
    const o = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: t.wrap([r], !0)
    };
    t.patch(e.children[0], o), a.push(o);
  }
  if (n.length > 0) {
    const o = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: t.wrap(n, !0)
    }, s = Mh(e.children[1]), u = lN(e.children[e.children.length - 1]);
    s && u && (o.position = { start: s, end: u }), a.push(o);
  }
  const i = {
    type: "element",
    tagName: "table",
    properties: {},
    children: t.wrap(a, !0)
  };
  return t.patch(e, i), t.applyData(e, i);
}
function yQe(t, e, n) {
  const r = n ? n.children : void 0, i = (r ? r.indexOf(e) : 1) === 0 ? "th" : "td", o = n && n.type === "table" ? n.align : void 0, s = o ? o.length : e.children.length;
  let u = -1;
  const f = [];
  for (; ++u < s; ) {
    const m = e.children[u], v = {}, O = o ? o[u] : void 0;
    O && (v.align = O);
    let w = { type: "element", tagName: i, properties: v, children: [] };
    m && (w.children = t.all(m), t.patch(m, w), w = t.applyData(m, w)), f.push(w);
  }
  const p = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: t.wrap(f, !0)
  };
  return t.patch(e, p), t.applyData(e, p);
}
function OQe(t, e) {
  const n = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: t.all(e)
  };
  return t.patch(e, n), t.applyData(e, n);
}
const nee = 9, ree = 32;
function EQe(t) {
  const e = String(t), n = /\r?\n|\r/g;
  let r = n.exec(e), a = 0;
  const i = [];
  for (; r; )
    i.push(
      aee(e.slice(a, r.index), a > 0, !0),
      r[0]
    ), a = r.index + r[0].length, r = n.exec(e);
  return i.push(aee(e.slice(a), a > 0, !1)), i.join("");
}
function aee(t, e, n) {
  let r = 0, a = t.length;
  if (e) {
    let i = t.codePointAt(r);
    for (; i === nee || i === ree; )
      r++, i = t.codePointAt(r);
  }
  if (n) {
    let i = t.codePointAt(a - 1);
    for (; i === nee || i === ree; )
      a--, i = t.codePointAt(a - 1);
  }
  return a > r ? t.slice(r, a) : "";
}
function SQe(t, e) {
  const n = { type: "text", value: EQe(String(e.value)) };
  return t.patch(e, n), t.applyData(e, n);
}
function wQe(t, e) {
  const n = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return t.patch(e, n), t.applyData(e, n);
}
const TQe = {
  blockquote: JWe,
  break: eQe,
  code: tQe,
  delete: nQe,
  emphasis: rQe,
  footnoteReference: aQe,
  heading: iQe,
  html: oQe,
  imageReference: sQe,
  image: lQe,
  inlineCode: uQe,
  linkReference: cQe,
  link: fQe,
  listItem: dQe,
  list: hQe,
  paragraph: mQe,
  // @ts-expect-error: root is different, but hard to type.
  root: gQe,
  strong: bQe,
  table: vQe,
  tableCell: OQe,
  tableRow: yQe,
  text: SQe,
  thematicBreak: wQe,
  toml: mA,
  yaml: mA,
  definition: mA,
  footnoteDefinition: mA
};
function mA() {
}
function _Qe(t, e) {
  const n = [{ type: "text", value: "↩" }];
  return e > 1 && n.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(e) }]
  }), n;
}
function CQe(t, e) {
  return "Back to reference " + (t + 1) + (e > 1 ? "-" + e : "");
}
function xQe(t) {
  const e = typeof t.options.clobberPrefix == "string" ? t.options.clobberPrefix : "user-content-", n = t.options.footnoteBackContent || _Qe, r = t.options.footnoteBackLabel || CQe, a = t.options.footnoteLabel || "Footnotes", i = t.options.footnoteLabelTagName || "h2", o = t.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, s = [];
  let u = -1;
  for (; ++u < t.footnoteOrder.length; ) {
    const f = t.footnoteById.get(t.footnoteOrder[u]);
    if (!f)
      continue;
    const p = t.all(f), m = String(f.identifier).toUpperCase(), v = x1(m.toLowerCase());
    let O = 0;
    const w = [], _ = t.footnoteCounts.get(m);
    for (; _ !== void 0 && ++O <= _; ) {
      w.length > 0 && w.push({ type: "text", value: " " });
      let N = typeof n == "string" ? n : n(u, O);
      typeof N == "string" && (N = { type: "text", value: N }), w.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + e + "fnref-" + v + (O > 1 ? "-" + O : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof r == "string" ? r : r(u, O),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(N) ? N : [N]
      });
    }
    const C = p[p.length - 1];
    if (C && C.type === "element" && C.tagName === "p") {
      const N = C.children[C.children.length - 1];
      N && N.type === "text" ? N.value += " " : C.children.push({ type: "text", value: " " }), C.children.push(...w);
    } else
      p.push(...w);
    const A = {
      type: "element",
      tagName: "li",
      properties: { id: e + "fn-" + v },
      children: t.wrap(p, !0)
    };
    t.patch(f, A), s.push(A);
  }
  if (s.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: i,
          properties: {
            ...y0(o),
            id: "footnote-label"
          },
          children: [{ type: "text", value: a }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: t.wrap(s, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const Ice = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(t) {
    if (t == null)
      return IQe;
    if (typeof t == "function")
      return dN(t);
    if (typeof t == "object")
      return Array.isArray(t) ? AQe(t) : kQe(t);
    if (typeof t == "string")
      return RQe(t);
    throw new Error("Expected function, string, or object as test");
  }
);
function AQe(t) {
  const e = [];
  let n = -1;
  for (; ++n < t.length; )
    e[n] = Ice(t[n]);
  return dN(r);
  function r(...a) {
    let i = -1;
    for (; ++i < e.length; )
      if (e[i].apply(this, a))
        return !0;
    return !1;
  }
}
function kQe(t) {
  const e = (
    /** @type {Record<string, unknown>} */
    t
  );
  return dN(n);
  function n(r) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let i;
    for (i in t)
      if (a[i] !== e[i])
        return !1;
    return !0;
  }
}
function RQe(t) {
  return dN(e);
  function e(n) {
    return n && n.type === t;
  }
}
function dN(t) {
  return e;
  function e(n, r, a) {
    return !!(DQe(n) && t.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      a || void 0
    ));
  }
}
function IQe() {
  return !0;
}
function DQe(t) {
  return t !== null && typeof t == "object" && "type" in t;
}
const Dce = [], NQe = !0, iee = !1, PQe = "skip";
function LQe(t, e, n, r) {
  let a;
  typeof e == "function" && typeof n != "function" ? (r = n, n = e) : a = e;
  const i = Ice(a), o = r ? -1 : 1;
  s(t, void 0, [])();
  function s(u, f, p) {
    const m = (
      /** @type {Record<string, unknown>} */
      u && typeof u == "object" ? u : {}
    );
    if (typeof m.type == "string") {
      const O = (
        // `hast`
        typeof m.tagName == "string" ? m.tagName : (
          // `xast`
          typeof m.name == "string" ? m.name : void 0
        )
      );
      Object.defineProperty(v, "name", {
        value: "node (" + (u.type + (O ? "<" + O + ">" : "")) + ")"
      });
    }
    return v;
    function v() {
      let O = Dce, w, _, C;
      if ((!e || i(u, f, p[p.length - 1] || void 0)) && (O = MQe(n(u, p)), O[0] === iee))
        return O;
      if ("children" in u && u.children) {
        const A = (
          /** @type {UnistParent} */
          u
        );
        if (A.children && O[0] !== PQe)
          for (_ = (r ? A.children.length : -1) + o, C = p.concat(A); _ > -1 && _ < A.children.length; ) {
            const N = A.children[_];
            if (w = s(N, _, C)(), w[0] === iee)
              return w;
            _ = typeof w[1] == "number" ? w[1] : _ + o;
          }
      }
      return O;
    }
  }
}
function MQe(t) {
  return Array.isArray(t) ? t : typeof t == "number" ? [NQe, t] : t == null ? Dce : [t];
}
function FQe(t, e, n, r) {
  let a, i, o;
  typeof e == "function" && typeof n != "function" ? (i = void 0, o = e, a = n) : (i = e, o = n, a = r), LQe(t, i, s, a);
  function s(u, f) {
    const p = f[f.length - 1], m = p ? p.children.indexOf(u) : void 0;
    return o(u, m, p);
  }
}
const S5 = {}.hasOwnProperty, $Qe = {};
function BQe(t, e) {
  const n = e || $Qe, r = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), o = { ...TQe, ...n.handlers }, s = {
    all: f,
    applyData: zQe,
    definitionById: r,
    footnoteById: a,
    footnoteCounts: i,
    footnoteOrder: [],
    handlers: o,
    one: u,
    options: n,
    patch: UQe,
    wrap: WQe
  };
  return FQe(t, function(p) {
    if (p.type === "definition" || p.type === "footnoteDefinition") {
      const m = p.type === "definition" ? r : a, v = String(p.identifier).toUpperCase();
      m.has(v) || m.set(v, p);
    }
  }), s;
  function u(p, m) {
    const v = p.type, O = s.handlers[v];
    if (S5.call(s.handlers, v) && O)
      return O(s, p, m);
    if (s.options.passThrough && s.options.passThrough.includes(v)) {
      if ("children" in p) {
        const { children: _, ...C } = p, A = y0(C);
        return A.children = s.all(p), A;
      }
      return y0(p);
    }
    return (s.options.unknownHandler || HQe)(s, p, m);
  }
  function f(p) {
    const m = [];
    if ("children" in p) {
      const v = p.children;
      let O = -1;
      for (; ++O < v.length; ) {
        const w = s.one(v[O], p);
        if (w) {
          if (O && v[O - 1].type === "break" && (!Array.isArray(w) && w.type === "text" && (w.value = oee(w.value)), !Array.isArray(w) && w.type === "element")) {
            const _ = w.children[0];
            _ && _.type === "text" && (_.value = oee(_.value));
          }
          Array.isArray(w) ? m.push(...w) : m.push(w);
        }
      }
    }
    return m;
  }
}
function UQe(t, e) {
  t.position && (e.position = q8e(t));
}
function zQe(t, e) {
  let n = e;
  if (t && t.data) {
    const r = t.data.hName, a = t.data.hChildren, i = t.data.hProperties;
    if (typeof r == "string")
      if (n.type === "element")
        n.tagName = r;
      else {
        const o = "children" in n ? n.children : [n];
        n = { type: "element", tagName: r, properties: {}, children: o };
      }
    n.type === "element" && i && Object.assign(n.properties, y0(i)), "children" in n && n.children && a !== null && a !== void 0 && (n.children = a);
  }
  return n;
}
function HQe(t, e) {
  const n = e.data || {}, r = "value" in e && !(S5.call(n, "hProperties") || S5.call(n, "hChildren")) ? { type: "text", value: e.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: t.all(e)
  };
  return t.patch(e, r), t.applyData(e, r);
}
function WQe(t, e) {
  const n = [];
  let r = -1;
  for (e && n.push({ type: "text", value: `
` }); ++r < t.length; )
    r && n.push({ type: "text", value: `
` }), n.push(t[r]);
  return e && t.length > 0 && n.push({ type: "text", value: `
` }), n;
}
function oee(t) {
  let e = 0, n = t.charCodeAt(e);
  for (; n === 9 || n === 32; )
    e++, n = t.charCodeAt(e);
  return t.slice(e);
}
function see(t, e) {
  const n = BQe(t, e), r = n.one(t, void 0), a = xQe(n), i = Array.isArray(r) ? { type: "root", children: r } : r || { type: "root", children: [] };
  return a && i.children.push({ type: "text", value: `
` }, a), i;
}
function QQe(t, e) {
  return t && "run" in t ? async function(n, r) {
    const a = (
      /** @type {HastRoot} */
      see(n, e)
    );
    await t.run(a, r);
  } : function(n) {
    return (
      /** @type {HastRoot} */
      see(n, e || t)
    );
  };
}
function lee(t) {
  if (t)
    throw t;
}
var Bk = Object.prototype.hasOwnProperty, Nce = Object.prototype.toString, uee = Object.defineProperty, cee = Object.getOwnPropertyDescriptor, fee = function(e) {
  return typeof Array.isArray == "function" ? Array.isArray(e) : Nce.call(e) === "[object Array]";
}, dee = function(e) {
  if (!e || Nce.call(e) !== "[object Object]")
    return !1;
  var n = Bk.call(e, "constructor"), r = e.constructor && e.constructor.prototype && Bk.call(e.constructor.prototype, "isPrototypeOf");
  if (e.constructor && !n && !r)
    return !1;
  var a;
  for (a in e)
    ;
  return typeof a > "u" || Bk.call(e, a);
}, pee = function(e, n) {
  uee && n.name === "__proto__" ? uee(e, n.name, {
    enumerable: !0,
    configurable: !0,
    value: n.newValue,
    writable: !0
  }) : e[n.name] = n.newValue;
}, hee = function(e, n) {
  if (n === "__proto__")
    if (Bk.call(e, n)) {
      if (cee)
        return cee(e, n).value;
    } else
      return;
  return e[n];
}, jQe = function t() {
  var e, n, r, a, i, o, s = arguments[0], u = 1, f = arguments.length, p = !1;
  for (typeof s == "boolean" && (p = s, s = arguments[1] || {}, u = 2), (s == null || typeof s != "object" && typeof s != "function") && (s = {}); u < f; ++u)
    if (e = arguments[u], e != null)
      for (n in e)
        r = hee(s, n), a = hee(e, n), s !== a && (p && a && (dee(a) || (i = fee(a))) ? (i ? (i = !1, o = r && fee(r) ? r : []) : o = r && dee(r) ? r : {}, pee(s, { name: n, newValue: t(p, o, a) })) : typeof a < "u" && pee(s, { name: n, newValue: a }));
  return s;
};
const J3 = /* @__PURE__ */ Pl(jQe);
function w5(t) {
  if (typeof t != "object" || t === null)
    return !1;
  const e = Object.getPrototypeOf(t);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Symbol.toStringTag in t) && !(Symbol.iterator in t);
}
function GQe() {
  const t = [], e = { run: n, use: r };
  return e;
  function n(...a) {
    let i = -1;
    const o = a.pop();
    if (typeof o != "function")
      throw new TypeError("Expected function as last argument, not " + o);
    s(null, ...a);
    function s(u, ...f) {
      const p = t[++i];
      let m = -1;
      if (u) {
        o(u);
        return;
      }
      for (; ++m < a.length; )
        (f[m] === null || f[m] === void 0) && (f[m] = a[m]);
      a = f, p ? VQe(p, s)(...f) : o(null, ...f);
    }
  }
  function r(a) {
    if (typeof a != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + a
      );
    return t.push(a), e;
  }
}
function VQe(t, e) {
  let n;
  return r;
  function r(...o) {
    const s = t.length > o.length;
    let u;
    s && o.push(a);
    try {
      u = t.apply(this, o);
    } catch (f) {
      const p = (
        /** @type {Error} */
        f
      );
      if (s && n)
        throw p;
      return a(p);
    }
    s || (u instanceof Promise ? u.then(i, a) : u instanceof Error ? a(u) : i(u));
  }
  function a(o, ...s) {
    n || (n = !0, e(o, ...s));
  }
  function i(o) {
    a(null, o);
  }
}
const ph = { basename: YQe, dirname: ZQe, extname: XQe, join: qQe, sep: "/" };
function YQe(t, e) {
  if (e !== void 0 && typeof e != "string")
    throw new TypeError('"ext" argument must be a string');
  z_(t);
  let n = 0, r = -1, a = t.length, i;
  if (e === void 0 || e.length === 0 || e.length > t.length) {
    for (; a--; )
      if (t.codePointAt(a) === 47) {
        if (i) {
          n = a + 1;
          break;
        }
      } else
        r < 0 && (i = !0, r = a + 1);
    return r < 0 ? "" : t.slice(n, r);
  }
  if (e === t)
    return "";
  let o = -1, s = e.length - 1;
  for (; a--; )
    if (t.codePointAt(a) === 47) {
      if (i) {
        n = a + 1;
        break;
      }
    } else
      o < 0 && (i = !0, o = a + 1), s > -1 && (t.codePointAt(a) === e.codePointAt(s--) ? s < 0 && (r = a) : (s = -1, r = o));
  return n === r ? r = o : r < 0 && (r = t.length), t.slice(n, r);
}
function ZQe(t) {
  if (z_(t), t.length === 0)
    return ".";
  let e = -1, n = t.length, r;
  for (; --n; )
    if (t.codePointAt(n) === 47) {
      if (r) {
        e = n;
        break;
      }
    } else
      r || (r = !0);
  return e < 0 ? t.codePointAt(0) === 47 ? "/" : "." : e === 1 && t.codePointAt(0) === 47 ? "//" : t.slice(0, e);
}
function XQe(t) {
  z_(t);
  let e = t.length, n = -1, r = 0, a = -1, i = 0, o;
  for (; e--; ) {
    const s = t.codePointAt(e);
    if (s === 47) {
      if (o) {
        r = e + 1;
        break;
      }
      continue;
    }
    n < 0 && (o = !0, n = e + 1), s === 46 ? a < 0 ? a = e : i !== 1 && (i = 1) : a > -1 && (i = -1);
  }
  return a < 0 || n < 0 || // We saw a non-dot character immediately before the dot.
  i === 0 || // The (right-most) trimmed path component is exactly `..`.
  i === 1 && a === n - 1 && a === r + 1 ? "" : t.slice(a, n);
}
function qQe(...t) {
  let e = -1, n;
  for (; ++e < t.length; )
    z_(t[e]), t[e] && (n = n === void 0 ? t[e] : n + "/" + t[e]);
  return n === void 0 ? "." : KQe(n);
}
function KQe(t) {
  z_(t);
  const e = t.codePointAt(0) === 47;
  let n = JQe(t, !e);
  return n.length === 0 && !e && (n = "."), n.length > 0 && t.codePointAt(t.length - 1) === 47 && (n += "/"), e ? "/" + n : n;
}
function JQe(t, e) {
  let n = "", r = 0, a = -1, i = 0, o = -1, s, u;
  for (; ++o <= t.length; ) {
    if (o < t.length)
      s = t.codePointAt(o);
    else {
      if (s === 47)
        break;
      s = 47;
    }
    if (s === 47) {
      if (!(a === o - 1 || i === 1))
        if (a !== o - 1 && i === 2) {
          if (n.length < 2 || r !== 2 || n.codePointAt(n.length - 1) !== 46 || n.codePointAt(n.length - 2) !== 46) {
            if (n.length > 2) {
              if (u = n.lastIndexOf("/"), u !== n.length - 1) {
                u < 0 ? (n = "", r = 0) : (n = n.slice(0, u), r = n.length - 1 - n.lastIndexOf("/")), a = o, i = 0;
                continue;
              }
            } else if (n.length > 0) {
              n = "", r = 0, a = o, i = 0;
              continue;
            }
          }
          e && (n = n.length > 0 ? n + "/.." : "..", r = 2);
        } else
          n.length > 0 ? n += "/" + t.slice(a + 1, o) : n = t.slice(a + 1, o), r = o - a - 1;
      a = o, i = 0;
    } else
      s === 46 && i > -1 ? i++ : i = -1;
  }
  return n;
}
function z_(t) {
  if (typeof t != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(t)
    );
}
const eje = { cwd: tje };
function tje() {
  return "/";
}
function T5(t) {
  return !!(t !== null && typeof t == "object" && "href" in t && t.href && "protocol" in t && t.protocol && // @ts-expect-error: indexing is fine.
  t.auth === void 0);
}
function nje(t) {
  if (typeof t == "string")
    t = new URL(t);
  else if (!T5(t)) {
    const e = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + t + "`"
    );
    throw e.code = "ERR_INVALID_ARG_TYPE", e;
  }
  if (t.protocol !== "file:") {
    const e = new TypeError("The URL must be of scheme file");
    throw e.code = "ERR_INVALID_URL_SCHEME", e;
  }
  return rje(t);
}
function rje(t) {
  if (t.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const e = t.pathname;
  let n = -1;
  for (; ++n < e.length; )
    if (e.codePointAt(n) === 37 && e.codePointAt(n + 1) === 50) {
      const r = e.codePointAt(n + 2);
      if (r === 70 || r === 102) {
        const a = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw a.code = "ERR_INVALID_FILE_URL_PATH", a;
      }
    }
  return decodeURIComponent(e);
}
const eF = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class Pce {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(e) {
    let n;
    e ? T5(e) ? n = { path: e } : typeof e == "string" || aje(e) ? n = { value: e } : n = e : n = {}, this.cwd = eje.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let r = -1;
    for (; ++r < eF.length; ) {
      const i = eF[r];
      i in n && n[i] !== void 0 && n[i] !== null && (this[i] = i === "history" ? [...n[i]] : n[i]);
    }
    let a;
    for (a in n)
      eF.includes(a) || (this[a] = n[a]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? ph.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(e) {
    nF(e, "basename"), tF(e, "basename"), this.path = ph.join(this.dirname || "", e);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? ph.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(e) {
    mee(this.basename, "dirname"), this.path = ph.join(e || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? ph.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(e) {
    if (tF(e, "extname"), mee(this.dirname, "extname"), e) {
      if (e.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (e.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = ph.join(this.dirname, this.stem + (e || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(e) {
    T5(e) && (e = nje(e)), nF(e, "path"), this.path !== e && this.history.push(e);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? ph.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(e) {
    nF(e, "stem"), tF(e, "stem"), this.path = ph.join(this.dirname || "", e + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(e, n, r) {
    const a = this.message(e, n, r);
    throw a.fatal = !0, a;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(e, n, r) {
    const a = this.message(e, n, r);
    return a.fatal = void 0, a;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(e, n, r) {
    const a = new mu(
      // @ts-expect-error: the overloads are fine.
      e,
      n,
      r
    );
    return this.path && (a.name = this.path + ":" + a.name, a.file = this.path), a.fatal = !1, this.messages.push(a), a;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(e) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(e || void 0).decode(this.value);
  }
}
function tF(t, e) {
  if (t && t.includes(ph.sep))
    throw new Error(
      "`" + e + "` cannot be a path: did not expect `" + ph.sep + "`"
    );
}
function nF(t, e) {
  if (!t)
    throw new Error("`" + e + "` cannot be empty");
}
function mee(t, e) {
  if (!t)
    throw new Error("Setting `" + e + "` requires `path` to be set too");
}
function aje(t) {
  return !!(t && typeof t == "object" && "byteLength" in t && "byteOffset" in t);
}
const ije = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  function(t) {
    const r = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), a = r[t], i = function() {
      return a.apply(i, arguments);
    };
    Object.setPrototypeOf(i, r);
    const o = Object.getOwnPropertyNames(a);
    for (const s of o) {
      const u = Object.getOwnPropertyDescriptor(a, s);
      u && Object.defineProperty(i, s, u);
    }
    return i;
  }
), oje = {}.hasOwnProperty;
class $7 extends ije {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = GQe();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@link Processor `Processor`}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const e = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new $7()
    );
    let n = -1;
    for (; ++n < this.attachers.length; ) {
      const r = this.attachers[n];
      e.use(...r);
    }
    return e.data(J3(!0, {}, this.namespace)), e;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > 👉 **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > 👉 **Note**: to register custom data in TypeScript, augment the
   * > {@link Data `Data`} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(e, n) {
    return typeof e == "string" ? arguments.length === 2 ? (iF("data", this.frozen), this.namespace[e] = n, this) : oje.call(this.namespace, e) && this.namespace[e] || void 0 : e ? (iF("data", this.frozen), this.namespace = e, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const e = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [n, ...r] = this.attachers[this.freezeIndex];
      if (r[0] === !1)
        continue;
      r[0] === !0 && (r[0] = void 0);
      const a = n.call(e, ...r);
      typeof a == "function" && this.transformers.use(a);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > 👉 **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(e) {
    this.freeze();
    const n = gA(e), r = this.parser || this.Parser;
    return rF("parse", r), r(String(n), n);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > 👉 **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > 👉 **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@link CompileResultMap `CompileResultMap`}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(e, n) {
    const r = this;
    return this.freeze(), rF("process", this.parser || this.Parser), aF("process", this.compiler || this.Compiler), n ? a(void 0, n) : new Promise(a);
    function a(i, o) {
      const s = gA(e), u = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        r.parse(s)
      );
      r.run(u, s, function(p, m, v) {
        if (p || !m || !v)
          return f(p);
        const O = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          m
        ), w = r.stringify(O, v);
        uje(w) ? v.value = w : v.result = w, f(
          p,
          /** @type {VFileWithOutput<CompileResult>} */
          v
        );
      });
      function f(p, m) {
        p || !m ? o(p) : i ? i(m) : n(void 0, m);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > 👉 **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > 👉 **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@link CompileResultMap `CompileResultMap`}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(e) {
    let n = !1, r;
    return this.freeze(), rF("processSync", this.parser || this.Parser), aF("processSync", this.compiler || this.Compiler), this.process(e, a), bee("processSync", "process", n), r;
    function a(i, o) {
      n = !0, lee(i), r = o;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > 👉 **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(e, n, r) {
    gee(e), this.freeze();
    const a = this.transformers;
    return !r && typeof n == "function" && (r = n, n = void 0), r ? i(void 0, r) : new Promise(i);
    function i(o, s) {
      const u = gA(n);
      a.run(e, u, f);
      function f(p, m, v) {
        const O = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          m || e
        );
        p ? s(p) : o ? o(O) : r(void 0, O, v);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > 👉 **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(e, n) {
    let r = !1, a;
    return this.run(e, n, i), bee("runSync", "run", r), a;
    function i(o, s) {
      lee(o), a = s, r = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > 👉 **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > 👉 **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@link CompileResultMap `CompileResultMap`}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(e, n) {
    this.freeze();
    const r = gA(n), a = this.compiler || this.Compiler;
    return aF("stringify", a), gee(e), a(e, r);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > 👉 **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(e, ...n) {
    const r = this.attachers, a = this.namespace;
    if (iF("use", this.frozen), e != null)
      if (typeof e == "function")
        u(e, n);
      else if (typeof e == "object")
        Array.isArray(e) ? s(e) : o(e);
      else
        throw new TypeError("Expected usable value, not `" + e + "`");
    return this;
    function i(f) {
      if (typeof f == "function")
        u(f, []);
      else if (typeof f == "object")
        if (Array.isArray(f)) {
          const [p, ...m] = (
            /** @type {PluginTuple<Array<unknown>>} */
            f
          );
          u(p, m);
        } else
          o(f);
      else
        throw new TypeError("Expected usable value, not `" + f + "`");
    }
    function o(f) {
      if (!("plugins" in f) && !("settings" in f))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      s(f.plugins), f.settings && (a.settings = J3(!0, a.settings, f.settings));
    }
    function s(f) {
      let p = -1;
      if (f != null)
        if (Array.isArray(f))
          for (; ++p < f.length; ) {
            const m = f[p];
            i(m);
          }
        else
          throw new TypeError("Expected a list of plugins, not `" + f + "`");
    }
    function u(f, p) {
      let m = -1, v = -1;
      for (; ++m < r.length; )
        if (r[m][0] === f) {
          v = m;
          break;
        }
      if (v === -1)
        r.push([f, ...p]);
      else if (p.length > 0) {
        let [O, ...w] = p;
        const _ = r[v][1];
        w5(_) && w5(O) && (O = J3(!0, _, O)), r[v] = [f, O, ...w];
      }
    }
  }
}
const sje = new $7().freeze();
function rF(t, e) {
  if (typeof e != "function")
    throw new TypeError("Cannot `" + t + "` without `parser`");
}
function aF(t, e) {
  if (typeof e != "function")
    throw new TypeError("Cannot `" + t + "` without `compiler`");
}
function iF(t, e) {
  if (e)
    throw new Error(
      "Cannot call `" + t + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function gee(t) {
  if (!w5(t) || typeof t.type != "string")
    throw new TypeError("Expected node, got `" + t + "`");
}
function bee(t, e, n) {
  if (!n)
    throw new Error(
      "`" + t + "` finished async. Use `" + e + "` instead"
    );
}
function gA(t) {
  return lje(t) ? t : new Pce(t);
}
function lje(t) {
  return !!(t && typeof t == "object" && "message" in t && "messages" in t);
}
function uje(t) {
  return typeof t == "string" || cje(t);
}
function cje(t) {
  return !!(t && typeof t == "object" && "byteLength" in t && "byteOffset" in t);
}
const Lce = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(t) {
    if (t == null)
      return hje;
    if (typeof t == "function")
      return pN(t);
    if (typeof t == "object")
      return Array.isArray(t) ? fje(t) : dje(t);
    if (typeof t == "string")
      return pje(t);
    throw new Error("Expected function, string, or object as test");
  }
);
function fje(t) {
  const e = [];
  let n = -1;
  for (; ++n < t.length; )
    e[n] = Lce(t[n]);
  return pN(r);
  function r(...a) {
    let i = -1;
    for (; ++i < e.length; )
      if (e[i].apply(this, a))
        return !0;
    return !1;
  }
}
function dje(t) {
  const e = (
    /** @type {Record<string, unknown>} */
    t
  );
  return pN(n);
  function n(r) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let i;
    for (i in t)
      if (a[i] !== e[i])
        return !1;
    return !0;
  }
}
function pje(t) {
  return pN(e);
  function e(n) {
    return n && n.type === t;
  }
}
function pN(t) {
  return e;
  function e(n, r, a) {
    return !!(mje(n) && t.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      a || void 0
    ));
  }
}
function hje() {
  return !0;
}
function mje(t) {
  return t !== null && typeof t == "object" && "type" in t;
}
const Mce = [], gje = !0, vee = !1, bje = "skip";
function vje(t, e, n, r) {
  let a;
  typeof e == "function" && typeof n != "function" ? (r = n, n = e) : a = e;
  const i = Lce(a), o = r ? -1 : 1;
  s(t, void 0, [])();
  function s(u, f, p) {
    const m = (
      /** @type {Record<string, unknown>} */
      u && typeof u == "object" ? u : {}
    );
    if (typeof m.type == "string") {
      const O = (
        // `hast`
        typeof m.tagName == "string" ? m.tagName : (
          // `xast`
          typeof m.name == "string" ? m.name : void 0
        )
      );
      Object.defineProperty(v, "name", {
        value: "node (" + (u.type + (O ? "<" + O + ">" : "")) + ")"
      });
    }
    return v;
    function v() {
      let O = Mce, w, _, C;
      if ((!e || i(u, f, p[p.length - 1] || void 0)) && (O = yje(n(u, p)), O[0] === vee))
        return O;
      if ("children" in u && u.children) {
        const A = (
          /** @type {UnistParent} */
          u
        );
        if (A.children && O[0] !== bje)
          for (_ = (r ? A.children.length : -1) + o, C = p.concat(A); _ > -1 && _ < A.children.length; ) {
            const N = A.children[_];
            if (w = s(N, _, C)(), w[0] === vee)
              return w;
            _ = typeof w[1] == "number" ? w[1] : _ + o;
          }
      }
      return O;
    }
  }
}
function yje(t) {
  return Array.isArray(t) ? t : typeof t == "number" ? [gje, t] : t == null ? Mce : [t];
}
function Oje(t, e, n, r) {
  let a, i, o;
  typeof e == "function" && typeof n != "function" ? (i = void 0, o = e, a = n) : (i = e, o = n, a = r), vje(t, i, s, a);
  function s(u, f) {
    const p = f[f.length - 1], m = p ? p.children.indexOf(u) : void 0;
    return o(u, m, p);
  }
}
const Eje = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", yee = [], Oee = { allowDangerousHtml: !0 }, Sje = /^(https?|ircs?|mailto|xmpp)$/i, wje = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function Tje(t) {
  const e = t.allowedElements, n = t.allowElement, r = t.children || "", a = t.className, i = t.components, o = t.disallowedElements, s = t.rehypePlugins || yee, u = t.remarkPlugins || yee, f = t.remarkRehypeOptions ? { ...t.remarkRehypeOptions, ...Oee } : Oee, p = t.skipHtml, m = t.unwrapDisallowed, v = t.urlTransform || _je, O = sje().use(KWe).use(u).use(QQe, f).use(s), w = new Pce();
  typeof r == "string" && (w.value = r);
  for (const N of wje)
    Object.hasOwn(t, N.from) && ("" + N.from + (N.to ? "use `" + N.to + "` instead" : "remove it") + Eje + N.id, void 0);
  const _ = O.parse(w);
  let C = O.runSync(_, w);
  return a && (C = {
    type: "element",
    tagName: "div",
    properties: { className: a },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      C.type === "root" ? C.children : [C]
    )
  }), Oje(C, A), UHe(C, {
    Fragment: Ne.Fragment,
    components: i,
    ignoreInvalidStyle: !0,
    jsx: Ne.jsx,
    jsxs: Ne.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function A(N, P, I) {
    if (N.type === "raw" && I && typeof P == "number")
      return p ? I.children.splice(P, 1) : I.children[P] = { type: "text", value: N.value }, P;
    if (N.type === "element") {
      let D;
      for (D in X3)
        if (Object.hasOwn(X3, D) && Object.hasOwn(N.properties, D)) {
          const M = N.properties[D], H = X3[D];
          (H === null || H.includes(N.tagName)) && (N.properties[D] = v(String(M || ""), D, N));
        }
    }
    if (N.type === "element") {
      let D = e ? !e.includes(N.tagName) : o ? o.includes(N.tagName) : !1;
      if (!D && n && typeof P == "number" && (D = !n(N, P, I)), D && I && typeof P == "number")
        return m && N.children ? I.children.splice(P, 1, ...N.children) : I.children.splice(P, 1), P;
    }
  }
}
function _je(t) {
  const e = t.indexOf(":"), n = t.indexOf("?"), r = t.indexOf("#"), a = t.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    e < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    a > -1 && e > a || n > -1 && e > n || r > -1 && e > r || // It is a protocol, it should be allowed.
    Sje.test(t.slice(0, e)) ? t : ""
  );
}
function Eee(t, e) {
  const n = String(t);
  if (typeof e != "string")
    throw new TypeError("Expected character");
  let r = 0, a = n.indexOf(e);
  for (; a !== -1; )
    r++, a = n.indexOf(e, a + e.length);
  return r;
}
function Cje(t) {
  if (typeof t != "string")
    throw new TypeError("Expected a string");
  return t.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
const B7 = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(t) {
    if (t == null)
      return Rje;
    if (typeof t == "function")
      return hN(t);
    if (typeof t == "object")
      return Array.isArray(t) ? xje(t) : Aje(t);
    if (typeof t == "string")
      return kje(t);
    throw new Error("Expected function, string, or object as test");
  }
);
function xje(t) {
  const e = [];
  let n = -1;
  for (; ++n < t.length; )
    e[n] = B7(t[n]);
  return hN(r);
  function r(...a) {
    let i = -1;
    for (; ++i < e.length; )
      if (e[i].apply(this, a))
        return !0;
    return !1;
  }
}
function Aje(t) {
  const e = (
    /** @type {Record<string, unknown>} */
    t
  );
  return hN(n);
  function n(r) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let i;
    for (i in t)
      if (a[i] !== e[i])
        return !1;
    return !0;
  }
}
function kje(t) {
  return hN(e);
  function e(n) {
    return n && n.type === t;
  }
}
function hN(t) {
  return e;
  function e(n, r, a) {
    return !!(Ije(n) && t.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      a || void 0
    ));
  }
}
function Rje() {
  return !0;
}
function Ije(t) {
  return t !== null && typeof t == "object" && "type" in t;
}
const Fce = [], Dje = !0, See = !1, Nje = "skip";
function Pje(t, e, n, r) {
  let a;
  typeof e == "function" && typeof n != "function" ? (r = n, n = e) : a = e;
  const i = B7(a), o = r ? -1 : 1;
  s(t, void 0, [])();
  function s(u, f, p) {
    const m = (
      /** @type {Record<string, unknown>} */
      u && typeof u == "object" ? u : {}
    );
    if (typeof m.type == "string") {
      const O = (
        // `hast`
        typeof m.tagName == "string" ? m.tagName : (
          // `xast`
          typeof m.name == "string" ? m.name : void 0
        )
      );
      Object.defineProperty(v, "name", {
        value: "node (" + (u.type + (O ? "<" + O + ">" : "")) + ")"
      });
    }
    return v;
    function v() {
      let O = Fce, w, _, C;
      if ((!e || i(u, f, p[p.length - 1] || void 0)) && (O = Lje(n(u, p)), O[0] === See))
        return O;
      if ("children" in u && u.children) {
        const A = (
          /** @type {UnistParent} */
          u
        );
        if (A.children && O[0] !== Nje)
          for (_ = (r ? A.children.length : -1) + o, C = p.concat(A); _ > -1 && _ < A.children.length; ) {
            const N = A.children[_];
            if (w = s(N, _, C)(), w[0] === See)
              return w;
            _ = typeof w[1] == "number" ? w[1] : _ + o;
          }
      }
      return O;
    }
  }
}
function Lje(t) {
  return Array.isArray(t) ? t : typeof t == "number" ? [Dje, t] : t == null ? Fce : [t];
}
function Mje(t, e, n) {
  const a = B7((n || {}).ignore || []), i = Fje(e);
  let o = -1;
  for (; ++o < i.length; )
    Pje(t, "text", s);
  function s(f, p) {
    let m = -1, v;
    for (; ++m < p.length; ) {
      const O = p[m], w = v ? v.children : void 0;
      if (a(
        O,
        w ? w.indexOf(O) : void 0,
        v
      ))
        return;
      v = O;
    }
    if (v)
      return u(f, p);
  }
  function u(f, p) {
    const m = p[p.length - 1], v = i[o][0], O = i[o][1];
    let w = 0;
    const C = m.children.indexOf(f);
    let A = !1, N = [];
    v.lastIndex = 0;
    let P = v.exec(f.value);
    for (; P; ) {
      const I = P.index, D = {
        index: P.index,
        input: P.input,
        stack: [...p, f]
      };
      let M = O(...P, D);
      if (typeof M == "string" && (M = M.length > 0 ? { type: "text", value: M } : void 0), M === !1 ? v.lastIndex = I + 1 : (w !== I && N.push({
        type: "text",
        value: f.value.slice(w, I)
      }), Array.isArray(M) ? N.push(...M) : M && N.push(M), w = I + P[0].length, A = !0), !v.global)
        break;
      P = v.exec(f.value);
    }
    return A ? (w < f.value.length && N.push({ type: "text", value: f.value.slice(w) }), m.children.splice(C, 1, ...N)) : N = [f], C + N.length;
  }
}
function Fje(t) {
  const e = [];
  if (!Array.isArray(t))
    throw new TypeError("Expected find and replace tuple or list of tuples");
  const n = !t[0] || Array.isArray(t[0]) ? t : [t];
  let r = -1;
  for (; ++r < n.length; ) {
    const a = n[r];
    e.push([$je(a[0]), Bje(a[1])]);
  }
  return e;
}
function $je(t) {
  return typeof t == "string" ? new RegExp(Cje(t), "g") : t;
}
function Bje(t) {
  return typeof t == "function" ? t : function() {
    return t;
  };
}
const oF = "phrasing", sF = ["autolink", "link", "image", "label"];
function Uje() {
  return {
    transforms: [Vje],
    enter: {
      literalAutolink: Hje,
      literalAutolinkEmail: lF,
      literalAutolinkHttp: lF,
      literalAutolinkWww: lF
    },
    exit: {
      literalAutolink: Gje,
      literalAutolinkEmail: jje,
      literalAutolinkHttp: Wje,
      literalAutolinkWww: Qje
    }
  };
}
function zje() {
  return {
    unsafe: [
      {
        character: "@",
        before: "[+\\-.\\w]",
        after: "[\\-.\\w]",
        inConstruct: oF,
        notInConstruct: sF
      },
      {
        character: ".",
        before: "[Ww]",
        after: "[\\-.\\w]",
        inConstruct: oF,
        notInConstruct: sF
      },
      {
        character: ":",
        before: "[ps]",
        after: "\\/",
        inConstruct: oF,
        notInConstruct: sF
      }
    ]
  };
}
function Hje(t) {
  this.enter({ type: "link", title: null, url: "", children: [] }, t);
}
function lF(t) {
  this.config.enter.autolinkProtocol.call(this, t);
}
function Wje(t) {
  this.config.exit.autolinkProtocol.call(this, t);
}
function Qje(t) {
  this.config.exit.data.call(this, t);
  const e = this.stack[this.stack.length - 1];
  e.type, e.url = "http://" + this.sliceSerialize(t);
}
function jje(t) {
  this.config.exit.autolinkEmail.call(this, t);
}
function Gje(t) {
  this.exit(t);
}
function Vje(t) {
  Mje(
    t,
    [
      [/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, Yje],
      [/([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/g, Zje]
    ],
    { ignore: ["link", "linkReference"] }
  );
}
function Yje(t, e, n, r, a) {
  let i = "";
  if (!$ce(a) || (/^w/i.test(e) && (n = e + n, e = "", i = "http://"), !Xje(n)))
    return !1;
  const o = qje(n + r);
  if (!o[0])
    return !1;
  const s = {
    type: "link",
    title: null,
    url: i + e + o[0],
    children: [{ type: "text", value: e + o[0] }]
  };
  return o[1] ? [s, { type: "text", value: o[1] }] : s;
}
function Zje(t, e, n, r) {
  return (
    // Not an expected previous character.
    !$ce(r, !0) || // Label ends in not allowed character.
    /[-\d_]$/.test(n) ? !1 : {
      type: "link",
      title: null,
      url: "mailto:" + e + "@" + n,
      children: [{ type: "text", value: e + "@" + n }]
    }
  );
}
function Xje(t) {
  const e = t.split(".");
  return !(e.length < 2 || e[e.length - 1] && (/_/.test(e[e.length - 1]) || !/[a-zA-Z\d]/.test(e[e.length - 1])) || e[e.length - 2] && (/_/.test(e[e.length - 2]) || !/[a-zA-Z\d]/.test(e[e.length - 2])));
}
function qje(t) {
  const e = /[!"&'),.:;<>?\]}]+$/.exec(t);
  if (!e)
    return [t, void 0];
  t = t.slice(0, e.index);
  let n = e[0], r = n.indexOf(")");
  const a = Eee(t, "(");
  let i = Eee(t, ")");
  for (; r !== -1 && a > i; )
    t += n.slice(0, r + 1), n = n.slice(r + 1), r = n.indexOf(")"), i++;
  return [t, n];
}
function $ce(t, e) {
  const n = t.input.charCodeAt(t.index - 1);
  return (t.index === 0 || O0(n) || cN(n)) && (!e || n !== 47);
}
Bce.peek = lGe;
function Kje() {
  return {
    enter: {
      gfmFootnoteDefinition: eGe,
      gfmFootnoteDefinitionLabelString: tGe,
      gfmFootnoteCall: aGe,
      gfmFootnoteCallString: iGe
    },
    exit: {
      gfmFootnoteDefinition: rGe,
      gfmFootnoteDefinitionLabelString: nGe,
      gfmFootnoteCall: sGe,
      gfmFootnoteCallString: oGe
    }
  };
}
function Jje() {
  return {
    // This is on by default already.
    unsafe: [{ character: "[", inConstruct: ["phrasing", "label", "reference"] }],
    handlers: { footnoteDefinition: uGe, footnoteReference: Bce }
  };
}
function eGe(t) {
  this.enter(
    { type: "footnoteDefinition", identifier: "", label: "", children: [] },
    t
  );
}
function tGe() {
  this.buffer();
}
function nGe(t) {
  const e = this.resume(), n = this.stack[this.stack.length - 1];
  n.type, n.label = e, n.identifier = Vd(
    this.sliceSerialize(t)
  ).toLowerCase();
}
function rGe(t) {
  this.exit(t);
}
function aGe(t) {
  this.enter({ type: "footnoteReference", identifier: "", label: "" }, t);
}
function iGe() {
  this.buffer();
}
function oGe(t) {
  const e = this.resume(), n = this.stack[this.stack.length - 1];
  n.type, n.label = e, n.identifier = Vd(
    this.sliceSerialize(t)
  ).toLowerCase();
}
function sGe(t) {
  this.exit(t);
}
function Bce(t, e, n, r) {
  const a = n.createTracker(r);
  let i = a.move("[^");
  const o = n.enter("footnoteReference"), s = n.enter("reference");
  return i += a.move(
    n.safe(n.associationId(t), {
      ...a.current(),
      before: i,
      after: "]"
    })
  ), s(), o(), i += a.move("]"), i;
}
function lGe() {
  return "[";
}
function uGe(t, e, n, r) {
  const a = n.createTracker(r);
  let i = a.move("[^");
  const o = n.enter("footnoteDefinition"), s = n.enter("label");
  return i += a.move(
    n.safe(n.associationId(t), {
      ...a.current(),
      before: i,
      after: "]"
    })
  ), s(), i += a.move(
    "]:" + (t.children && t.children.length > 0 ? " " : "")
  ), a.shift(4), i += a.move(
    n.indentLines(n.containerFlow(t, a.current()), cGe)
  ), o(), i;
}
function cGe(t, e, n) {
  return e === 0 ? t : (n ? "" : "    ") + t;
}
const fGe = [
  "autolink",
  "destinationLiteral",
  "destinationRaw",
  "reference",
  "titleQuote",
  "titleApostrophe"
];
Uce.peek = gGe;
function dGe() {
  return {
    canContainEols: ["delete"],
    enter: { strikethrough: hGe },
    exit: { strikethrough: mGe }
  };
}
function pGe() {
  return {
    unsafe: [
      {
        character: "~",
        inConstruct: "phrasing",
        notInConstruct: fGe
      }
    ],
    handlers: { delete: Uce }
  };
}
function hGe(t) {
  this.enter({ type: "delete", children: [] }, t);
}
function mGe(t) {
  this.exit(t);
}
function Uce(t, e, n, r) {
  const a = n.createTracker(r), i = n.enter("strikethrough");
  let o = a.move("~~");
  return o += n.containerPhrasing(t, {
    ...a.current(),
    before: o,
    after: "~"
  }), o += a.move("~~"), i(), o;
}
function gGe() {
  return "~";
}
function bGe(t, e = {}) {
  const n = (e.align || []).concat(), r = e.stringLength || yGe, a = [], i = [], o = [], s = [];
  let u = 0, f = -1;
  for (; ++f < t.length; ) {
    const w = [], _ = [];
    let C = -1;
    for (t[f].length > u && (u = t[f].length); ++C < t[f].length; ) {
      const A = vGe(t[f][C]);
      if (e.alignDelimiters !== !1) {
        const N = r(A);
        _[C] = N, (s[C] === void 0 || N > s[C]) && (s[C] = N);
      }
      w.push(A);
    }
    i[f] = w, o[f] = _;
  }
  let p = -1;
  if (typeof n == "object" && "length" in n)
    for (; ++p < u; )
      a[p] = wee(n[p]);
  else {
    const w = wee(n);
    for (; ++p < u; )
      a[p] = w;
  }
  p = -1;
  const m = [], v = [];
  for (; ++p < u; ) {
    const w = a[p];
    let _ = "", C = "";
    w === 99 ? (_ = ":", C = ":") : w === 108 ? _ = ":" : w === 114 && (C = ":");
    let A = e.alignDelimiters === !1 ? 1 : Math.max(
      1,
      s[p] - _.length - C.length
    );
    const N = _ + "-".repeat(A) + C;
    e.alignDelimiters !== !1 && (A = _.length + A + C.length, A > s[p] && (s[p] = A), v[p] = A), m[p] = N;
  }
  i.splice(1, 0, m), o.splice(1, 0, v), f = -1;
  const O = [];
  for (; ++f < i.length; ) {
    const w = i[f], _ = o[f];
    p = -1;
    const C = [];
    for (; ++p < u; ) {
      const A = w[p] || "";
      let N = "", P = "";
      if (e.alignDelimiters !== !1) {
        const I = s[p] - (_[p] || 0), D = a[p];
        D === 114 ? N = " ".repeat(I) : D === 99 ? I % 2 ? (N = " ".repeat(I / 2 + 0.5), P = " ".repeat(I / 2 - 0.5)) : (N = " ".repeat(I / 2), P = N) : P = " ".repeat(I);
      }
      e.delimiterStart !== !1 && !p && C.push("|"), e.padding !== !1 && // Don’t add the opening space if we’re not aligning and the cell is
      // empty: there will be a closing space.
      !(e.alignDelimiters === !1 && A === "") && (e.delimiterStart !== !1 || p) && C.push(" "), e.alignDelimiters !== !1 && C.push(N), C.push(A), e.alignDelimiters !== !1 && C.push(P), e.padding !== !1 && C.push(" "), (e.delimiterEnd !== !1 || p !== u - 1) && C.push("|");
    }
    O.push(
      e.delimiterEnd === !1 ? C.join("").replace(/ +$/, "") : C.join("")
    );
  }
  return O.join(`
`);
}
function vGe(t) {
  return t == null ? "" : String(t);
}
function yGe(t) {
  return t.length;
}
function wee(t) {
  const e = typeof t == "string" ? t.codePointAt(0) : 0;
  return e === 67 || e === 99 ? 99 : e === 76 || e === 108 ? 108 : e === 82 || e === 114 ? 114 : 0;
}
function OGe(t, e, n, r) {
  const a = n.enter("blockquote"), i = n.createTracker(r);
  i.move("> "), i.shift(2);
  const o = n.indentLines(
    n.containerFlow(t, i.current()),
    EGe
  );
  return a(), o;
}
function EGe(t, e, n) {
  return ">" + (n ? "" : " ") + t;
}
function SGe(t, e) {
  return Tee(t, e.inConstruct, !0) && !Tee(t, e.notInConstruct, !1);
}
function Tee(t, e, n) {
  if (typeof e == "string" && (e = [e]), !e || e.length === 0)
    return n;
  let r = -1;
  for (; ++r < e.length; )
    if (t.includes(e[r]))
      return !0;
  return !1;
}
function _ee(t, e, n, r) {
  let a = -1;
  for (; ++a < n.unsafe.length; )
    if (n.unsafe[a].character === `
` && SGe(n.stack, n.unsafe[a]))
      return /[ \t]/.test(r.before) ? "" : " ";
  return `\\
`;
}
function wGe(t, e) {
  const n = String(t);
  let r = n.indexOf(e), a = r, i = 0, o = 0;
  if (typeof e != "string")
    throw new TypeError("Expected substring");
  for (; r !== -1; )
    r === a ? ++i > o && (o = i) : i = 1, a = r + e.length, r = n.indexOf(e, a);
  return o;
}
function TGe(t, e) {
  return !!(e.options.fences === !1 && t.value && // If there’s no info…
  !t.lang && // And there’s a non-whitespace character…
  /[^ \r\n]/.test(t.value) && // And the value doesn’t start or end in a blank…
  !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(t.value));
}
function _Ge(t) {
  const e = t.options.fence || "`";
  if (e !== "`" && e !== "~")
    throw new Error(
      "Cannot serialize code with `" + e + "` for `options.fence`, expected `` ` `` or `~`"
    );
  return e;
}
function CGe(t, e, n, r) {
  const a = _Ge(n), i = t.value || "", o = a === "`" ? "GraveAccent" : "Tilde";
  if (TGe(t, n)) {
    const m = n.enter("codeIndented"), v = n.indentLines(i, xGe);
    return m(), v;
  }
  const s = n.createTracker(r), u = a.repeat(Math.max(wGe(i, a) + 1, 3)), f = n.enter("codeFenced");
  let p = s.move(u);
  if (t.lang) {
    const m = n.enter(`codeFencedLang${o}`);
    p += s.move(
      n.safe(t.lang, {
        before: p,
        after: " ",
        encode: ["`"],
        ...s.current()
      })
    ), m();
  }
  if (t.lang && t.meta) {
    const m = n.enter(`codeFencedMeta${o}`);
    p += s.move(" "), p += s.move(
      n.safe(t.meta, {
        before: p,
        after: `
`,
        encode: ["`"],
        ...s.current()
      })
    ), m();
  }
  return p += s.move(`
`), i && (p += s.move(i + `
`)), p += s.move(u), f(), p;
}
function xGe(t, e, n) {
  return (n ? "" : "    ") + t;
}
function U7(t) {
  const e = t.options.quote || '"';
  if (e !== '"' && e !== "'")
    throw new Error(
      "Cannot serialize title with `" + e + "` for `options.quote`, expected `\"`, or `'`"
    );
  return e;
}
function AGe(t, e, n, r) {
  const a = U7(n), i = a === '"' ? "Quote" : "Apostrophe", o = n.enter("definition");
  let s = n.enter("label");
  const u = n.createTracker(r);
  let f = u.move("[");
  return f += u.move(
    n.safe(n.associationId(t), {
      before: f,
      after: "]",
      ...u.current()
    })
  ), f += u.move("]: "), s(), // If there’s no url, or…
  !t.url || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(t.url) ? (s = n.enter("destinationLiteral"), f += u.move("<"), f += u.move(
    n.safe(t.url, { before: f, after: ">", ...u.current() })
  ), f += u.move(">")) : (s = n.enter("destinationRaw"), f += u.move(
    n.safe(t.url, {
      before: f,
      after: t.title ? " " : `
`,
      ...u.current()
    })
  )), s(), t.title && (s = n.enter(`title${i}`), f += u.move(" " + a), f += u.move(
    n.safe(t.title, {
      before: f,
      after: a,
      ...u.current()
    })
  ), f += u.move(a), s()), o(), f;
}
function kGe(t) {
  const e = t.options.emphasis || "*";
  if (e !== "*" && e !== "_")
    throw new Error(
      "Cannot serialize emphasis with `" + e + "` for `options.emphasis`, expected `*`, or `_`"
    );
  return e;
}
zce.peek = RGe;
function zce(t, e, n, r) {
  const a = kGe(n), i = n.enter("emphasis"), o = n.createTracker(r);
  let s = o.move(a);
  return s += o.move(
    n.containerPhrasing(t, {
      before: s,
      after: a,
      ...o.current()
    })
  ), s += o.move(a), i(), s;
}
function RGe(t, e, n) {
  return n.options.emphasis || "*";
}
const Hce = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(t) {
    if (t == null)
      return PGe;
    if (typeof t == "function")
      return mN(t);
    if (typeof t == "object")
      return Array.isArray(t) ? IGe(t) : DGe(t);
    if (typeof t == "string")
      return NGe(t);
    throw new Error("Expected function, string, or object as test");
  }
);
function IGe(t) {
  const e = [];
  let n = -1;
  for (; ++n < t.length; )
    e[n] = Hce(t[n]);
  return mN(r);
  function r(...a) {
    let i = -1;
    for (; ++i < e.length; )
      if (e[i].apply(this, a))
        return !0;
    return !1;
  }
}
function DGe(t) {
  const e = (
    /** @type {Record<string, unknown>} */
    t
  );
  return mN(n);
  function n(r) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let i;
    for (i in t)
      if (a[i] !== e[i])
        return !1;
    return !0;
  }
}
function NGe(t) {
  return mN(e);
  function e(n) {
    return n && n.type === t;
  }
}
function mN(t) {
  return e;
  function e(n, r, a) {
    return !!(LGe(n) && t.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      a || void 0
    ));
  }
}
function PGe() {
  return !0;
}
function LGe(t) {
  return t !== null && typeof t == "object" && "type" in t;
}
const Wce = [], MGe = !0, _5 = !1, FGe = "skip";
function $Ge(t, e, n, r) {
  let a;
  typeof e == "function" && typeof n != "function" ? (r = n, n = e) : a = e;
  const i = Hce(a), o = r ? -1 : 1;
  s(t, void 0, [])();
  function s(u, f, p) {
    const m = (
      /** @type {Record<string, unknown>} */
      u && typeof u == "object" ? u : {}
    );
    if (typeof m.type == "string") {
      const O = (
        // `hast`
        typeof m.tagName == "string" ? m.tagName : (
          // `xast`
          typeof m.name == "string" ? m.name : void 0
        )
      );
      Object.defineProperty(v, "name", {
        value: "node (" + (u.type + (O ? "<" + O + ">" : "")) + ")"
      });
    }
    return v;
    function v() {
      let O = Wce, w, _, C;
      if ((!e || i(u, f, p[p.length - 1] || void 0)) && (O = BGe(n(u, p)), O[0] === _5))
        return O;
      if ("children" in u && u.children) {
        const A = (
          /** @type {UnistParent} */
          u
        );
        if (A.children && O[0] !== FGe)
          for (_ = (r ? A.children.length : -1) + o, C = p.concat(A); _ > -1 && _ < A.children.length; ) {
            const N = A.children[_];
            if (w = s(N, _, C)(), w[0] === _5)
              return w;
            _ = typeof w[1] == "number" ? w[1] : _ + o;
          }
      }
      return O;
    }
  }
}
function BGe(t) {
  return Array.isArray(t) ? t : typeof t == "number" ? [MGe, t] : t == null ? Wce : [t];
}
function UGe(t, e, n, r) {
  let a, i, o;
  typeof e == "function" && typeof n != "function" ? (i = void 0, o = e, a = n) : (i = e, o = n, a = r), $Ge(t, i, s, a);
  function s(u, f) {
    const p = f[f.length - 1], m = p ? p.children.indexOf(u) : void 0;
    return o(u, m, p);
  }
}
const zGe = {};
function Qce(t, e) {
  const n = e || zGe, r = typeof n.includeImageAlt == "boolean" ? n.includeImageAlt : !0, a = typeof n.includeHtml == "boolean" ? n.includeHtml : !0;
  return jce(t, r, a);
}
function jce(t, e, n) {
  if (HGe(t)) {
    if ("value" in t)
      return t.type === "html" && !n ? "" : t.value;
    if (e && "alt" in t && t.alt)
      return t.alt;
    if ("children" in t)
      return Cee(t.children, e, n);
  }
  return Array.isArray(t) ? Cee(t, e, n) : "";
}
function Cee(t, e, n) {
  const r = [];
  let a = -1;
  for (; ++a < t.length; )
    r[a] = jce(t[a], e, n);
  return r.join("");
}
function HGe(t) {
  return !!(t && typeof t == "object");
}
function WGe(t, e) {
  let n = !1;
  return UGe(t, function(r) {
    if ("value" in r && /\r?\n|\r/.test(r.value) || r.type === "break")
      return n = !0, _5;
  }), !!((!t.depth || t.depth < 3) && Qce(t) && (e.options.setext || n));
}
function QGe(t, e, n, r) {
  const a = Math.max(Math.min(6, t.depth || 1), 1), i = n.createTracker(r);
  if (WGe(t, n)) {
    const p = n.enter("headingSetext"), m = n.enter("phrasing"), v = n.containerPhrasing(t, {
      ...i.current(),
      before: `
`,
      after: `
`
    });
    return m(), p(), v + `
` + (a === 1 ? "=" : "-").repeat(
      // The whole size…
      v.length - // Minus the position of the character after the last EOL (or
      // 0 if there is none)…
      (Math.max(v.lastIndexOf("\r"), v.lastIndexOf(`
`)) + 1)
    );
  }
  const o = "#".repeat(a), s = n.enter("headingAtx"), u = n.enter("phrasing");
  i.move(o + " ");
  let f = n.containerPhrasing(t, {
    before: "# ",
    after: `
`,
    ...i.current()
  });
  return /^[\t ]/.test(f) && (f = "&#x" + f.charCodeAt(0).toString(16).toUpperCase() + ";" + f.slice(1)), f = f ? o + " " + f : o, n.options.closeAtx && (f += " " + o), u(), s(), f;
}
Gce.peek = jGe;
function Gce(t) {
  return t.value || "";
}
function jGe() {
  return "<";
}
Vce.peek = GGe;
function Vce(t, e, n, r) {
  const a = U7(n), i = a === '"' ? "Quote" : "Apostrophe", o = n.enter("image");
  let s = n.enter("label");
  const u = n.createTracker(r);
  let f = u.move("![");
  return f += u.move(
    n.safe(t.alt, { before: f, after: "]", ...u.current() })
  ), f += u.move("]("), s(), // If there’s no url but there is a title…
  !t.url && t.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(t.url) ? (s = n.enter("destinationLiteral"), f += u.move("<"), f += u.move(
    n.safe(t.url, { before: f, after: ">", ...u.current() })
  ), f += u.move(">")) : (s = n.enter("destinationRaw"), f += u.move(
    n.safe(t.url, {
      before: f,
      after: t.title ? " " : ")",
      ...u.current()
    })
  )), s(), t.title && (s = n.enter(`title${i}`), f += u.move(" " + a), f += u.move(
    n.safe(t.title, {
      before: f,
      after: a,
      ...u.current()
    })
  ), f += u.move(a), s()), f += u.move(")"), o(), f;
}
function GGe() {
  return "!";
}
Yce.peek = VGe;
function Yce(t, e, n, r) {
  const a = t.referenceType, i = n.enter("imageReference");
  let o = n.enter("label");
  const s = n.createTracker(r);
  let u = s.move("![");
  const f = n.safe(t.alt, {
    before: u,
    after: "]",
    ...s.current()
  });
  u += s.move(f + "]["), o();
  const p = n.stack;
  n.stack = [], o = n.enter("reference");
  const m = n.safe(n.associationId(t), {
    before: u,
    after: "]",
    ...s.current()
  });
  return o(), n.stack = p, i(), a === "full" || !f || f !== m ? u += s.move(m + "]") : a === "shortcut" ? u = u.slice(0, -1) : u += s.move("]"), u;
}
function VGe() {
  return "!";
}
Zce.peek = YGe;
function Zce(t, e, n) {
  let r = t.value || "", a = "`", i = -1;
  for (; new RegExp("(^|[^`])" + a + "([^`]|$)").test(r); )
    a += "`";
  for (/[^ \r\n]/.test(r) && (/^[ \r\n]/.test(r) && /[ \r\n]$/.test(r) || /^`|`$/.test(r)) && (r = " " + r + " "); ++i < n.unsafe.length; ) {
    const o = n.unsafe[i], s = n.compilePattern(o);
    let u;
    if (o.atBreak)
      for (; u = s.exec(r); ) {
        let f = u.index;
        r.charCodeAt(f) === 10 && r.charCodeAt(f - 1) === 13 && f--, r = r.slice(0, f) + " " + r.slice(u.index + 1);
      }
  }
  return a + r + a;
}
function YGe() {
  return "`";
}
function Xce(t, e) {
  const n = Qce(t);
  return !!(!e.options.resourceLink && // If there’s a url…
  t.url && // And there’s a no title…
  !t.title && // And the content of `node` is a single text node…
  t.children && t.children.length === 1 && t.children[0].type === "text" && // And if the url is the same as the content…
  (n === t.url || "mailto:" + n === t.url) && // And that starts w/ a protocol…
  /^[a-z][a-z+.-]+:/i.test(t.url) && // And that doesn’t contain ASCII control codes (character escapes and
  // references don’t work), space, or angle brackets…
  !/[\0- <>\u007F]/.test(t.url));
}
qce.peek = ZGe;
function qce(t, e, n, r) {
  const a = U7(n), i = a === '"' ? "Quote" : "Apostrophe", o = n.createTracker(r);
  let s, u;
  if (Xce(t, n)) {
    const p = n.stack;
    n.stack = [], s = n.enter("autolink");
    let m = o.move("<");
    return m += o.move(
      n.containerPhrasing(t, {
        before: m,
        after: ">",
        ...o.current()
      })
    ), m += o.move(">"), s(), n.stack = p, m;
  }
  s = n.enter("link"), u = n.enter("label");
  let f = o.move("[");
  return f += o.move(
    n.containerPhrasing(t, {
      before: f,
      after: "](",
      ...o.current()
    })
  ), f += o.move("]("), u(), // If there’s no url but there is a title…
  !t.url && t.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(t.url) ? (u = n.enter("destinationLiteral"), f += o.move("<"), f += o.move(
    n.safe(t.url, { before: f, after: ">", ...o.current() })
  ), f += o.move(">")) : (u = n.enter("destinationRaw"), f += o.move(
    n.safe(t.url, {
      before: f,
      after: t.title ? " " : ")",
      ...o.current()
    })
  )), u(), t.title && (u = n.enter(`title${i}`), f += o.move(" " + a), f += o.move(
    n.safe(t.title, {
      before: f,
      after: a,
      ...o.current()
    })
  ), f += o.move(a), u()), f += o.move(")"), s(), f;
}
function ZGe(t, e, n) {
  return Xce(t, n) ? "<" : "[";
}
Kce.peek = XGe;
function Kce(t, e, n, r) {
  const a = t.referenceType, i = n.enter("linkReference");
  let o = n.enter("label");
  const s = n.createTracker(r);
  let u = s.move("[");
  const f = n.containerPhrasing(t, {
    before: u,
    after: "]",
    ...s.current()
  });
  u += s.move(f + "]["), o();
  const p = n.stack;
  n.stack = [], o = n.enter("reference");
  const m = n.safe(n.associationId(t), {
    before: u,
    after: "]",
    ...s.current()
  });
  return o(), n.stack = p, i(), a === "full" || !f || f !== m ? u += s.move(m + "]") : a === "shortcut" ? u = u.slice(0, -1) : u += s.move("]"), u;
}
function XGe() {
  return "[";
}
function z7(t) {
  const e = t.options.bullet || "*";
  if (e !== "*" && e !== "+" && e !== "-")
    throw new Error(
      "Cannot serialize items with `" + e + "` for `options.bullet`, expected `*`, `+`, or `-`"
    );
  return e;
}
function qGe(t) {
  const e = z7(t), n = t.options.bulletOther;
  if (!n)
    return e === "*" ? "-" : "*";
  if (n !== "*" && n !== "+" && n !== "-")
    throw new Error(
      "Cannot serialize items with `" + n + "` for `options.bulletOther`, expected `*`, `+`, or `-`"
    );
  if (n === e)
    throw new Error(
      "Expected `bullet` (`" + e + "`) and `bulletOther` (`" + n + "`) to be different"
    );
  return n;
}
function KGe(t) {
  const e = t.options.bulletOrdered || ".";
  if (e !== "." && e !== ")")
    throw new Error(
      "Cannot serialize items with `" + e + "` for `options.bulletOrdered`, expected `.` or `)`"
    );
  return e;
}
function Jce(t) {
  const e = t.options.rule || "*";
  if (e !== "*" && e !== "-" && e !== "_")
    throw new Error(
      "Cannot serialize rules with `" + e + "` for `options.rule`, expected `*`, `-`, or `_`"
    );
  return e;
}
function JGe(t, e, n, r) {
  const a = n.enter("list"), i = n.bulletCurrent;
  let o = t.ordered ? KGe(n) : z7(n);
  const s = t.ordered ? o === "." ? ")" : "." : qGe(n);
  let u = e && n.bulletLastUsed ? o === n.bulletLastUsed : !1;
  if (!t.ordered) {
    const p = t.children ? t.children[0] : void 0;
    if (
      // Bullet could be used as a thematic break marker:
      (o === "*" || o === "-") && // Empty first list item:
      p && (!p.children || !p.children[0]) && // Directly in two other list items:
      n.stack[n.stack.length - 1] === "list" && n.stack[n.stack.length - 2] === "listItem" && n.stack[n.stack.length - 3] === "list" && n.stack[n.stack.length - 4] === "listItem" && // That are each the first child.
      n.indexStack[n.indexStack.length - 1] === 0 && n.indexStack[n.indexStack.length - 2] === 0 && n.indexStack[n.indexStack.length - 3] === 0 && (u = !0), Jce(n) === o && p
    ) {
      let m = -1;
      for (; ++m < t.children.length; ) {
        const v = t.children[m];
        if (v && v.type === "listItem" && v.children && v.children[0] && v.children[0].type === "thematicBreak") {
          u = !0;
          break;
        }
      }
    }
  }
  u && (o = s), n.bulletCurrent = o;
  const f = n.containerFlow(t, r);
  return n.bulletLastUsed = o, n.bulletCurrent = i, a(), f;
}
function eVe(t) {
  const e = t.options.listItemIndent || "one";
  if (e !== "tab" && e !== "one" && e !== "mixed")
    throw new Error(
      "Cannot serialize items with `" + e + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`"
    );
  return e;
}
function tVe(t, e, n, r) {
  const a = eVe(n);
  let i = n.bulletCurrent || z7(n);
  e && e.type === "list" && e.ordered && (i = (typeof e.start == "number" && e.start > -1 ? e.start : 1) + (n.options.incrementListMarker === !1 ? 0 : e.children.indexOf(t)) + i);
  let o = i.length + 1;
  (a === "tab" || a === "mixed" && (e && e.type === "list" && e.spread || t.spread)) && (o = Math.ceil(o / 4) * 4);
  const s = n.createTracker(r);
  s.move(i + " ".repeat(o - i.length)), s.shift(o);
  const u = n.enter("listItem"), f = n.indentLines(
    n.containerFlow(t, s.current()),
    p
  );
  return u(), f;
  function p(m, v, O) {
    return v ? (O ? "" : " ".repeat(o)) + m : (O ? i : i + " ".repeat(o - i.length)) + m;
  }
}
function nVe(t, e, n, r) {
  const a = n.enter("paragraph"), i = n.enter("phrasing"), o = n.containerPhrasing(t, r);
  return i(), a(), o;
}
const efe = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(t) {
    if (t == null)
      return oVe;
    if (typeof t == "function")
      return gN(t);
    if (typeof t == "object")
      return Array.isArray(t) ? rVe(t) : aVe(t);
    if (typeof t == "string")
      return iVe(t);
    throw new Error("Expected function, string, or object as test");
  }
);
function rVe(t) {
  const e = [];
  let n = -1;
  for (; ++n < t.length; )
    e[n] = efe(t[n]);
  return gN(r);
  function r(...a) {
    let i = -1;
    for (; ++i < e.length; )
      if (e[i].apply(this, a))
        return !0;
    return !1;
  }
}
function aVe(t) {
  const e = (
    /** @type {Record<string, unknown>} */
    t
  );
  return gN(n);
  function n(r) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let i;
    for (i in t)
      if (a[i] !== e[i])
        return !1;
    return !0;
  }
}
function iVe(t) {
  return gN(e);
  function e(n) {
    return n && n.type === t;
  }
}
function gN(t) {
  return e;
  function e(n, r, a) {
    return !!(sVe(n) && t.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      a || void 0
    ));
  }
}
function oVe() {
  return !0;
}
function sVe(t) {
  return t !== null && typeof t == "object" && "type" in t;
}
const lVe = (
  /** @type {(node?: unknown) => node is Exclude<PhrasingContent, Html>} */
  efe([
    "break",
    "delete",
    "emphasis",
    // To do: next major: removed since footnotes were added to GFM.
    "footnote",
    "footnoteReference",
    "image",
    "imageReference",
    "inlineCode",
    // Enabled by `mdast-util-math`:
    "inlineMath",
    "link",
    "linkReference",
    // Enabled by `mdast-util-mdx`:
    "mdxJsxTextElement",
    // Enabled by `mdast-util-mdx`:
    "mdxTextExpression",
    "strong",
    "text",
    // Enabled by `mdast-util-directive`:
    "textDirective"
  ])
);
function uVe(t, e, n, r) {
  return (t.children.some(function(o) {
    return lVe(o);
  }) ? n.containerPhrasing : n.containerFlow).call(n, t, r);
}
function cVe(t) {
  const e = t.options.strong || "*";
  if (e !== "*" && e !== "_")
    throw new Error(
      "Cannot serialize strong with `" + e + "` for `options.strong`, expected `*`, or `_`"
    );
  return e;
}
tfe.peek = fVe;
function tfe(t, e, n, r) {
  const a = cVe(n), i = n.enter("strong"), o = n.createTracker(r);
  let s = o.move(a + a);
  return s += o.move(
    n.containerPhrasing(t, {
      before: s,
      after: a,
      ...o.current()
    })
  ), s += o.move(a + a), i(), s;
}
function fVe(t, e, n) {
  return n.options.strong || "*";
}
function dVe(t, e, n, r) {
  return n.safe(t.value, r);
}
function pVe(t) {
  const e = t.options.ruleRepetition || 3;
  if (e < 3)
    throw new Error(
      "Cannot serialize rules with repetition `" + e + "` for `options.ruleRepetition`, expected `3` or more"
    );
  return e;
}
function hVe(t, e, n) {
  const r = (Jce(n) + (n.options.ruleSpaces ? " " : "")).repeat(pVe(n));
  return n.options.ruleSpaces ? r.slice(0, -1) : r;
}
const nfe = {
  blockquote: OGe,
  break: _ee,
  code: CGe,
  definition: AGe,
  emphasis: zce,
  hardBreak: _ee,
  heading: QGe,
  html: Gce,
  image: Vce,
  imageReference: Yce,
  inlineCode: Zce,
  link: qce,
  linkReference: Kce,
  list: JGe,
  listItem: tVe,
  paragraph: nVe,
  root: uVe,
  strong: tfe,
  text: dVe,
  thematicBreak: hVe
};
function mVe() {
  return {
    enter: {
      table: gVe,
      tableData: xee,
      tableHeader: xee,
      tableRow: vVe
    },
    exit: {
      codeText: yVe,
      table: bVe,
      tableData: uF,
      tableHeader: uF,
      tableRow: uF
    }
  };
}
function gVe(t) {
  const e = t._align;
  this.enter(
    {
      type: "table",
      align: e.map(function(n) {
        return n === "none" ? null : n;
      }),
      children: []
    },
    t
  ), this.data.inTable = !0;
}
function bVe(t) {
  this.exit(t), this.data.inTable = void 0;
}
function vVe(t) {
  this.enter({ type: "tableRow", children: [] }, t);
}
function uF(t) {
  this.exit(t);
}
function xee(t) {
  this.enter({ type: "tableCell", children: [] }, t);
}
function yVe(t) {
  let e = this.resume();
  this.data.inTable && (e = e.replace(/\\([\\|])/g, OVe));
  const n = this.stack[this.stack.length - 1];
  n.type, n.value = e, this.exit(t);
}
function OVe(t, e) {
  return e === "|" ? e : t;
}
function EVe(t) {
  const e = t || {}, n = e.tableCellPadding, r = e.tablePipeAlign, a = e.stringLength, i = n ? " " : "|";
  return {
    unsafe: [
      { character: "\r", inConstruct: "tableCell" },
      { character: `
`, inConstruct: "tableCell" },
      // A pipe, when followed by a tab or space (padding), or a dash or colon
      // (unpadded delimiter row), could result in a table.
      { atBreak: !0, character: "|", after: "[	 :-]" },
      // A pipe in a cell must be encoded.
      { character: "|", inConstruct: "tableCell" },
      // A colon must be followed by a dash, in which case it could start a
      // delimiter row.
      { atBreak: !0, character: ":", after: "-" },
      // A delimiter row can also start with a dash, when followed by more
      // dashes, a colon, or a pipe.
      // This is a stricter version than the built in check for lists, thematic
      // breaks, and setex heading underlines though:
      // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
      { atBreak: !0, character: "-", after: "[:|-]" }
    ],
    handlers: {
      inlineCode: v,
      table: o,
      tableCell: u,
      tableRow: s
    }
  };
  function o(O, w, _, C) {
    return f(p(O, _, C), O.align);
  }
  function s(O, w, _, C) {
    const A = m(O, _, C), N = f([A]);
    return N.slice(0, N.indexOf(`
`));
  }
  function u(O, w, _, C) {
    const A = _.enter("tableCell"), N = _.enter("phrasing"), P = _.containerPhrasing(O, {
      ...C,
      before: i,
      after: i
    });
    return N(), A(), P;
  }
  function f(O, w) {
    return bGe(O, {
      align: w,
      // @ts-expect-error: `markdown-table` types should support `null`.
      alignDelimiters: r,
      // @ts-expect-error: `markdown-table` types should support `null`.
      padding: n,
      // @ts-expect-error: `markdown-table` types should support `null`.
      stringLength: a
    });
  }
  function p(O, w, _) {
    const C = O.children;
    let A = -1;
    const N = [], P = w.enter("table");
    for (; ++A < C.length; )
      N[A] = m(C[A], w, _);
    return P(), N;
  }
  function m(O, w, _) {
    const C = O.children;
    let A = -1;
    const N = [], P = w.enter("tableRow");
    for (; ++A < C.length; )
      N[A] = u(C[A], O, w, _);
    return P(), N;
  }
  function v(O, w, _) {
    let C = nfe.inlineCode(O, w, _);
    return _.stack.includes("tableCell") && (C = C.replace(/\|/g, "\\$&")), C;
  }
}
function SVe() {
  return {
    exit: {
      taskListCheckValueChecked: Aee,
      taskListCheckValueUnchecked: Aee,
      paragraph: TVe
    }
  };
}
function wVe() {
  return {
    unsafe: [{ atBreak: !0, character: "-", after: "[:|-]" }],
    handlers: { listItem: _Ve }
  };
}
function Aee(t) {
  const e = this.stack[this.stack.length - 2];
  e.type, e.checked = t.type === "taskListCheckValueChecked";
}
function TVe(t) {
  const e = this.stack[this.stack.length - 2];
  if (e && e.type === "listItem" && typeof e.checked == "boolean") {
    const n = this.stack[this.stack.length - 1];
    n.type;
    const r = n.children[0];
    if (r && r.type === "text") {
      const a = e.children;
      let i = -1, o;
      for (; ++i < a.length; ) {
        const s = a[i];
        if (s.type === "paragraph") {
          o = s;
          break;
        }
      }
      o === n && (r.value = r.value.slice(1), r.value.length === 0 ? n.children.shift() : n.position && r.position && typeof r.position.start.offset == "number" && (r.position.start.column++, r.position.start.offset++, n.position.start = Object.assign({}, r.position.start)));
    }
  }
  this.exit(t);
}
function _Ve(t, e, n, r) {
  const a = t.children[0], i = typeof t.checked == "boolean" && a && a.type === "paragraph", o = "[" + (t.checked ? "x" : " ") + "] ", s = n.createTracker(r);
  i && s.move(o);
  let u = nfe.listItem(t, e, n, {
    ...r,
    ...s.current()
  });
  return i && (u = u.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, f)), u;
  function f(p) {
    return p + o;
  }
}
function CVe() {
  return [
    Uje(),
    Kje(),
    dGe(),
    mVe(),
    SVe()
  ];
}
function xVe(t) {
  return {
    extensions: [
      zje(),
      Jje(),
      pGe(),
      EVe(t),
      wVe()
    ]
  };
}
const AVe = {
  tokenize: PVe,
  partial: !0
}, rfe = {
  tokenize: LVe,
  partial: !0
}, afe = {
  tokenize: MVe,
  partial: !0
}, ife = {
  tokenize: FVe,
  partial: !0
}, kVe = {
  tokenize: $Ve,
  partial: !0
}, ofe = {
  tokenize: DVe,
  previous: lfe
}, sfe = {
  tokenize: NVe,
  previous: ufe
}, sg = {
  tokenize: IVe,
  previous: cfe
}, Fh = {};
function RVe() {
  return {
    text: Fh
  };
}
let Wy = 48;
for (; Wy < 123; )
  Fh[Wy] = sg, Wy++, Wy === 58 ? Wy = 65 : Wy === 91 && (Wy = 97);
Fh[43] = sg;
Fh[45] = sg;
Fh[46] = sg;
Fh[95] = sg;
Fh[72] = [sg, sfe];
Fh[104] = [sg, sfe];
Fh[87] = [sg, ofe];
Fh[119] = [sg, ofe];
function IVe(t, e, n) {
  const r = this;
  let a, i;
  return o;
  function o(m) {
    return !C5(m) || !cfe.call(r, r.previous) || H7(r.events) ? n(m) : (t.enter("literalAutolink"), t.enter("literalAutolinkEmail"), s(m));
  }
  function s(m) {
    return C5(m) ? (t.consume(m), s) : m === 64 ? (t.consume(m), u) : n(m);
  }
  function u(m) {
    return m === 46 ? t.check(
      kVe,
      p,
      f
    )(m) : m === 45 || m === 95 || Il(m) ? (i = !0, t.consume(m), u) : p(m);
  }
  function f(m) {
    return t.consume(m), a = !0, u;
  }
  function p(m) {
    return i && a && cu(r.previous) ? (t.exit("literalAutolinkEmail"), t.exit("literalAutolink"), e(m)) : n(m);
  }
}
function DVe(t, e, n) {
  const r = this;
  return a;
  function a(o) {
    return o !== 87 && o !== 119 || !lfe.call(r, r.previous) || H7(r.events) ? n(o) : (t.enter("literalAutolink"), t.enter("literalAutolinkWww"), t.check(
      AVe,
      t.attempt(rfe, t.attempt(afe, i), n),
      n
    )(o));
  }
  function i(o) {
    return t.exit("literalAutolinkWww"), t.exit("literalAutolink"), e(o);
  }
}
function NVe(t, e, n) {
  const r = this;
  let a = "", i = !1;
  return o;
  function o(m) {
    return (m === 72 || m === 104) && ufe.call(r, r.previous) && !H7(r.events) ? (t.enter("literalAutolink"), t.enter("literalAutolinkHttp"), a += String.fromCodePoint(m), t.consume(m), s) : n(m);
  }
  function s(m) {
    if (cu(m) && a.length < 5)
      return a += String.fromCodePoint(m), t.consume(m), s;
    if (m === 58) {
      const v = a.toLowerCase();
      if (v === "http" || v === "https")
        return t.consume(m), u;
    }
    return n(m);
  }
  function u(m) {
    return m === 47 ? (t.consume(m), i ? f : (i = !0, u)) : n(m);
  }
  function f(m) {
    return m === null || MI(m) || Ya(m) || O0(m) || cN(m) ? n(m) : t.attempt(rfe, t.attempt(afe, p), n)(m);
  }
  function p(m) {
    return t.exit("literalAutolinkHttp"), t.exit("literalAutolink"), e(m);
  }
}
function PVe(t, e, n) {
  let r = 0;
  return a;
  function a(o) {
    return (o === 87 || o === 119) && r < 3 ? (r++, t.consume(o), a) : o === 46 && r === 3 ? (t.consume(o), i) : n(o);
  }
  function i(o) {
    return o === null ? n(o) : e(o);
  }
}
function LVe(t, e, n) {
  let r, a, i;
  return o;
  function o(f) {
    return f === 46 || f === 95 ? t.check(ife, u, s)(f) : f === null || Ya(f) || O0(f) || f !== 45 && cN(f) ? u(f) : (i = !0, t.consume(f), o);
  }
  function s(f) {
    return f === 95 ? r = !0 : (a = r, r = void 0), t.consume(f), o;
  }
  function u(f) {
    return a || r || !i ? n(f) : e(f);
  }
}
function MVe(t, e) {
  let n = 0, r = 0;
  return a;
  function a(o) {
    return o === 40 ? (n++, t.consume(o), a) : o === 41 && r < n ? i(o) : o === 33 || o === 34 || o === 38 || o === 39 || o === 41 || o === 42 || o === 44 || o === 46 || o === 58 || o === 59 || o === 60 || o === 63 || o === 93 || o === 95 || o === 126 ? t.check(ife, e, i)(o) : o === null || Ya(o) || O0(o) ? e(o) : (t.consume(o), a);
  }
  function i(o) {
    return o === 41 && r++, t.consume(o), a;
  }
}
function FVe(t, e, n) {
  return r;
  function r(s) {
    return s === 33 || s === 34 || s === 39 || s === 41 || s === 42 || s === 44 || s === 46 || s === 58 || s === 59 || s === 63 || s === 95 || s === 126 ? (t.consume(s), r) : s === 38 ? (t.consume(s), i) : s === 93 ? (t.consume(s), a) : (
      // `<` is an end.
      s === 60 || // So is whitespace.
      s === null || Ya(s) || O0(s) ? e(s) : n(s)
    );
  }
  function a(s) {
    return s === null || s === 40 || s === 91 || Ya(s) || O0(s) ? e(s) : r(s);
  }
  function i(s) {
    return cu(s) ? o(s) : n(s);
  }
  function o(s) {
    return s === 59 ? (t.consume(s), r) : cu(s) ? (t.consume(s), o) : n(s);
  }
}
function $Ve(t, e, n) {
  return r;
  function r(i) {
    return t.consume(i), a;
  }
  function a(i) {
    return Il(i) ? n(i) : e(i);
  }
}
function lfe(t) {
  return t === null || t === 40 || t === 42 || t === 95 || t === 91 || t === 93 || t === 126 || Ya(t);
}
function ufe(t) {
  return !cu(t);
}
function cfe(t) {
  return !(t === 47 || C5(t));
}
function C5(t) {
  return t === 43 || t === 45 || t === 46 || t === 95 || Il(t);
}
function H7(t) {
  let e = t.length, n = !1;
  for (; e--; ) {
    const r = t[e][1];
    if ((r.type === "labelLink" || r.type === "labelImage") && !r._balanced) {
      n = !0;
      break;
    }
    if (r._gfmAutolinkLiteralWalkedInto) {
      n = !1;
      break;
    }
  }
  return t.length > 0 && !n && (t[t.length - 1][1]._gfmAutolinkLiteralWalkedInto = !0), n;
}
const BVe = {
  tokenize: VVe,
  partial: !0
};
function UVe() {
  return {
    document: {
      91: {
        tokenize: QVe,
        continuation: {
          tokenize: jVe
        },
        exit: GVe
      }
    },
    text: {
      91: {
        tokenize: WVe
      },
      93: {
        add: "after",
        tokenize: zVe,
        resolveTo: HVe
      }
    }
  };
}
function zVe(t, e, n) {
  const r = this;
  let a = r.events.length;
  const i = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let o;
  for (; a--; ) {
    const u = r.events[a][1];
    if (u.type === "labelImage") {
      o = u;
      break;
    }
    if (u.type === "gfmFootnoteCall" || u.type === "labelLink" || u.type === "label" || u.type === "image" || u.type === "link")
      break;
  }
  return s;
  function s(u) {
    if (!o || !o._balanced)
      return n(u);
    const f = Vd(
      r.sliceSerialize({
        start: o.end,
        end: r.now()
      })
    );
    return f.codePointAt(0) !== 94 || !i.includes(f.slice(1)) ? n(u) : (t.enter("gfmFootnoteCallLabelMarker"), t.consume(u), t.exit("gfmFootnoteCallLabelMarker"), e(u));
  }
}
function HVe(t, e) {
  let n = t.length;
  for (; n--; )
    if (t[n][1].type === "labelImage" && t[n][0] === "enter") {
      t[n][1];
      break;
    }
  t[n + 1][1].type = "data", t[n + 3][1].type = "gfmFootnoteCallLabelMarker";
  const r = {
    type: "gfmFootnoteCall",
    start: Object.assign({}, t[n + 3][1].start),
    end: Object.assign({}, t[t.length - 1][1].end)
  }, a = {
    type: "gfmFootnoteCallMarker",
    start: Object.assign({}, t[n + 3][1].end),
    end: Object.assign({}, t[n + 3][1].end)
  };
  a.end.column++, a.end.offset++, a.end._bufferIndex++;
  const i = {
    type: "gfmFootnoteCallString",
    start: Object.assign({}, a.end),
    end: Object.assign({}, t[t.length - 1][1].start)
  }, o = {
    type: "chunkString",
    contentType: "string",
    start: Object.assign({}, i.start),
    end: Object.assign({}, i.end)
  }, s = [
    // Take the `labelImageMarker` (now `data`, the `!`)
    t[n + 1],
    t[n + 2],
    ["enter", r, e],
    // The `[`
    t[n + 3],
    t[n + 4],
    // The `^`.
    ["enter", a, e],
    ["exit", a, e],
    // Everything in between.
    ["enter", i, e],
    ["enter", o, e],
    ["exit", o, e],
    ["exit", i, e],
    // The ending (`]`, properly parsed and labelled).
    t[t.length - 2],
    t[t.length - 1],
    ["exit", r, e]
  ];
  return t.splice(n, t.length - n + 1, ...s), t;
}
function WVe(t, e, n) {
  const r = this, a = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let i = 0, o;
  return s;
  function s(m) {
    return t.enter("gfmFootnoteCall"), t.enter("gfmFootnoteCallLabelMarker"), t.consume(m), t.exit("gfmFootnoteCallLabelMarker"), u;
  }
  function u(m) {
    return m !== 94 ? n(m) : (t.enter("gfmFootnoteCallMarker"), t.consume(m), t.exit("gfmFootnoteCallMarker"), t.enter("gfmFootnoteCallString"), t.enter("chunkString").contentType = "string", f);
  }
  function f(m) {
    if (
      // Too long.
      i > 999 || // Closing brace with nothing.
      m === 93 && !o || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      m === null || m === 91 || Ya(m)
    )
      return n(m);
    if (m === 93) {
      t.exit("chunkString");
      const v = t.exit("gfmFootnoteCallString");
      return a.includes(Vd(r.sliceSerialize(v))) ? (t.enter("gfmFootnoteCallLabelMarker"), t.consume(m), t.exit("gfmFootnoteCallLabelMarker"), t.exit("gfmFootnoteCall"), e) : n(m);
    }
    return Ya(m) || (o = !0), i++, t.consume(m), m === 92 ? p : f;
  }
  function p(m) {
    return m === 91 || m === 92 || m === 93 ? (t.consume(m), i++, f) : f(m);
  }
}
function QVe(t, e, n) {
  const r = this, a = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let i, o = 0, s;
  return u;
  function u(w) {
    return t.enter("gfmFootnoteDefinition")._container = !0, t.enter("gfmFootnoteDefinitionLabel"), t.enter("gfmFootnoteDefinitionLabelMarker"), t.consume(w), t.exit("gfmFootnoteDefinitionLabelMarker"), f;
  }
  function f(w) {
    return w === 94 ? (t.enter("gfmFootnoteDefinitionMarker"), t.consume(w), t.exit("gfmFootnoteDefinitionMarker"), t.enter("gfmFootnoteDefinitionLabelString"), t.enter("chunkString").contentType = "string", p) : n(w);
  }
  function p(w) {
    if (
      // Too long.
      o > 999 || // Closing brace with nothing.
      w === 93 && !s || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      w === null || w === 91 || Ya(w)
    )
      return n(w);
    if (w === 93) {
      t.exit("chunkString");
      const _ = t.exit("gfmFootnoteDefinitionLabelString");
      return i = Vd(r.sliceSerialize(_)), t.enter("gfmFootnoteDefinitionLabelMarker"), t.consume(w), t.exit("gfmFootnoteDefinitionLabelMarker"), t.exit("gfmFootnoteDefinitionLabel"), v;
    }
    return Ya(w) || (s = !0), o++, t.consume(w), w === 92 ? m : p;
  }
  function m(w) {
    return w === 91 || w === 92 || w === 93 ? (t.consume(w), o++, p) : p(w);
  }
  function v(w) {
    return w === 58 ? (t.enter("definitionMarker"), t.consume(w), t.exit("definitionMarker"), a.includes(i) || a.push(i), Kr(
      t,
      O,
      "gfmFootnoteDefinitionWhitespace"
    )) : n(w);
  }
  function O(w) {
    return e(w);
  }
}
function jVe(t, e, n) {
  return t.check(U_, e, t.attempt(BVe, e, n));
}
function GVe(t) {
  t.exit("gfmFootnoteDefinition");
}
function VVe(t, e, n) {
  const r = this;
  return Kr(
    t,
    a,
    "gfmFootnoteDefinitionIndent",
    4 + 1
  );
  function a(i) {
    const o = r.events[r.events.length - 1];
    return o && o[1].type === "gfmFootnoteDefinitionIndent" && o[2].sliceSerialize(o[1], !0).length === 4 ? e(i) : n(i);
  }
}
function YVe(t) {
  let n = (t || {}).singleTilde;
  const r = {
    tokenize: i,
    resolveAll: a
  };
  return n == null && (n = !0), {
    text: {
      126: r
    },
    insideSpan: {
      null: [r]
    },
    attentionMarkers: {
      null: [126]
    }
  };
  function a(o, s) {
    let u = -1;
    for (; ++u < o.length; )
      if (o[u][0] === "enter" && o[u][1].type === "strikethroughSequenceTemporary" && o[u][1]._close) {
        let f = u;
        for (; f--; )
          if (o[f][0] === "exit" && o[f][1].type === "strikethroughSequenceTemporary" && o[f][1]._open && // If the sizes are the same:
          o[u][1].end.offset - o[u][1].start.offset === o[f][1].end.offset - o[f][1].start.offset) {
            o[u][1].type = "strikethroughSequence", o[f][1].type = "strikethroughSequence";
            const p = {
              type: "strikethrough",
              start: Object.assign({}, o[f][1].start),
              end: Object.assign({}, o[u][1].end)
            }, m = {
              type: "strikethroughText",
              start: Object.assign({}, o[f][1].end),
              end: Object.assign({}, o[u][1].start)
            }, v = [
              ["enter", p, s],
              ["enter", o[f][1], s],
              ["exit", o[f][1], s],
              ["enter", m, s]
            ], O = s.parser.constructs.insideSpan.null;
            O && Wc(
              v,
              v.length,
              0,
              fN(O, o.slice(f + 1, u), s)
            ), Wc(v, v.length, 0, [
              ["exit", m, s],
              ["enter", o[u][1], s],
              ["exit", o[u][1], s],
              ["exit", p, s]
            ]), Wc(o, f - 1, u - f + 3, v), u = f + v.length - 2;
            break;
          }
      }
    for (u = -1; ++u < o.length; )
      o[u][1].type === "strikethroughSequenceTemporary" && (o[u][1].type = "data");
    return o;
  }
  function i(o, s, u) {
    const f = this.previous, p = this.events;
    let m = 0;
    return v;
    function v(w) {
      return f === 126 && p[p.length - 1][1].type !== "characterEscape" ? u(w) : (o.enter("strikethroughSequenceTemporary"), O(w));
    }
    function O(w) {
      const _ = FI(f);
      if (w === 126)
        return m > 1 ? u(w) : (o.consume(w), m++, O);
      if (m < 2 && !n)
        return u(w);
      const C = o.exit("strikethroughSequenceTemporary"), A = FI(w);
      return C._open = !A || A === 2 && !!_, C._close = !_ || _ === 2 && !!A, s(w);
    }
  }
}
class ZVe {
  /**
   * Create a new edit map.
   */
  constructor() {
    this.map = [];
  }
  /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {undefined}
   */
  add(e, n, r) {
    XVe(this, e, n, r);
  }
  // To do: add this when moving to `micromark`.
  // /**
  //  * Create an edit: but insert `add` before existing additions.
  //  *
  //  * @param {number} index
  //  * @param {number} remove
  //  * @param {Array<Event>} add
  //  * @returns {undefined}
  //  */
  // addBefore(index, remove, add) {
  //   addImpl(this, index, remove, add, true)
  // }
  /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {undefined}
   */
  consume(e) {
    if (this.map.sort(function(i, o) {
      return i[0] - o[0];
    }), this.map.length === 0)
      return;
    let n = this.map.length;
    const r = [];
    for (; n > 0; )
      n -= 1, r.push(
        e.slice(this.map[n][0] + this.map[n][1]),
        this.map[n][2]
      ), e.length = this.map[n][0];
    r.push([...e]), e.length = 0;
    let a = r.pop();
    for (; a; )
      e.push(...a), a = r.pop();
    this.map.length = 0;
  }
}
function XVe(t, e, n, r) {
  let a = 0;
  if (!(n === 0 && r.length === 0)) {
    for (; a < t.map.length; ) {
      if (t.map[a][0] === e) {
        t.map[a][1] += n, t.map[a][2].push(...r);
        return;
      }
      a += 1;
    }
    t.map.push([e, n, r]);
  }
}
function qVe(t, e) {
  let n = !1;
  const r = [];
  for (; e < t.length; ) {
    const a = t[e];
    if (n) {
      if (a[0] === "enter")
        a[1].type === "tableContent" && r.push(
          t[e + 1][1].type === "tableDelimiterMarker" ? "left" : "none"
        );
      else if (a[1].type === "tableContent") {
        if (t[e - 1][1].type === "tableDelimiterMarker") {
          const i = r.length - 1;
          r[i] = r[i] === "left" ? "center" : "right";
        }
      } else if (a[1].type === "tableDelimiterRow")
        break;
    } else
      a[0] === "enter" && a[1].type === "tableDelimiterRow" && (n = !0);
    e += 1;
  }
  return r;
}
function KVe() {
  return {
    flow: {
      null: {
        tokenize: JVe,
        resolveAll: eYe
      }
    }
  };
}
function JVe(t, e, n) {
  const r = this;
  let a = 0, i = 0, o;
  return s;
  function s(Q) {
    let ne = r.events.length - 1;
    for (; ne > -1; ) {
      const ee = r.events[ne][1].type;
      if (ee === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
      ee === "linePrefix")
        ne--;
      else
        break;
    }
    const J = ne > -1 ? r.events[ne][1].type : null, ue = J === "tableHead" || J === "tableRow" ? M : u;
    return ue === M && r.parser.lazy[r.now().line] ? n(Q) : ue(Q);
  }
  function u(Q) {
    return t.enter("tableHead"), t.enter("tableRow"), f(Q);
  }
  function f(Q) {
    return Q === 124 || (o = !0, i += 1), p(Q);
  }
  function p(Q) {
    return Q === null ? n(Q) : Gn(Q) ? i > 1 ? (i = 0, r.interrupt = !0, t.exit("tableRow"), t.enter("lineEnding"), t.consume(Q), t.exit("lineEnding"), O) : n(Q) : Nr(Q) ? Kr(t, p, "whitespace")(Q) : (i += 1, o && (o = !1, a += 1), Q === 124 ? (t.enter("tableCellDivider"), t.consume(Q), t.exit("tableCellDivider"), o = !0, p) : (t.enter("data"), m(Q)));
  }
  function m(Q) {
    return Q === null || Q === 124 || Ya(Q) ? (t.exit("data"), p(Q)) : (t.consume(Q), Q === 92 ? v : m);
  }
  function v(Q) {
    return Q === 92 || Q === 124 ? (t.consume(Q), m) : m(Q);
  }
  function O(Q) {
    return r.interrupt = !1, r.parser.lazy[r.now().line] ? n(Q) : (t.enter("tableDelimiterRow"), o = !1, Nr(Q) ? Kr(
      t,
      w,
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(Q) : w(Q));
  }
  function w(Q) {
    return Q === 45 || Q === 58 ? C(Q) : Q === 124 ? (o = !0, t.enter("tableCellDivider"), t.consume(Q), t.exit("tableCellDivider"), _) : D(Q);
  }
  function _(Q) {
    return Nr(Q) ? Kr(t, C, "whitespace")(Q) : C(Q);
  }
  function C(Q) {
    return Q === 58 ? (i += 1, o = !0, t.enter("tableDelimiterMarker"), t.consume(Q), t.exit("tableDelimiterMarker"), A) : Q === 45 ? (i += 1, A(Q)) : Q === null || Gn(Q) ? I(Q) : D(Q);
  }
  function A(Q) {
    return Q === 45 ? (t.enter("tableDelimiterFiller"), N(Q)) : D(Q);
  }
  function N(Q) {
    return Q === 45 ? (t.consume(Q), N) : Q === 58 ? (o = !0, t.exit("tableDelimiterFiller"), t.enter("tableDelimiterMarker"), t.consume(Q), t.exit("tableDelimiterMarker"), P) : (t.exit("tableDelimiterFiller"), P(Q));
  }
  function P(Q) {
    return Nr(Q) ? Kr(t, I, "whitespace")(Q) : I(Q);
  }
  function I(Q) {
    return Q === 124 ? w(Q) : Q === null || Gn(Q) ? !o || a !== i ? D(Q) : (t.exit("tableDelimiterRow"), t.exit("tableHead"), e(Q)) : D(Q);
  }
  function D(Q) {
    return n(Q);
  }
  function M(Q) {
    return t.enter("tableRow"), H(Q);
  }
  function H(Q) {
    return Q === 124 ? (t.enter("tableCellDivider"), t.consume(Q), t.exit("tableCellDivider"), H) : Q === null || Gn(Q) ? (t.exit("tableRow"), e(Q)) : Nr(Q) ? Kr(t, H, "whitespace")(Q) : (t.enter("data"), Y(Q));
  }
  function Y(Q) {
    return Q === null || Q === 124 || Ya(Q) ? (t.exit("data"), H(Q)) : (t.consume(Q), Q === 92 ? q : Y);
  }
  function q(Q) {
    return Q === 92 || Q === 124 ? (t.consume(Q), Y) : Y(Q);
  }
}
function eYe(t, e) {
  let n = -1, r = !0, a = 0, i = [0, 0, 0, 0], o = [0, 0, 0, 0], s = !1, u = 0, f, p, m;
  const v = new ZVe();
  for (; ++n < t.length; ) {
    const O = t[n], w = O[1];
    O[0] === "enter" ? w.type === "tableHead" ? (s = !1, u !== 0 && (kee(v, e, u, f, p), p = void 0, u = 0), f = {
      type: "table",
      start: Object.assign({}, w.start),
      // Note: correct end is set later.
      end: Object.assign({}, w.end)
    }, v.add(n, 0, [["enter", f, e]])) : w.type === "tableRow" || w.type === "tableDelimiterRow" ? (r = !0, m = void 0, i = [0, 0, 0, 0], o = [0, n + 1, 0, 0], s && (s = !1, p = {
      type: "tableBody",
      start: Object.assign({}, w.start),
      // Note: correct end is set later.
      end: Object.assign({}, w.end)
    }, v.add(n, 0, [["enter", p, e]])), a = w.type === "tableDelimiterRow" ? 2 : p ? 3 : 1) : a && (w.type === "data" || w.type === "tableDelimiterMarker" || w.type === "tableDelimiterFiller") ? (r = !1, o[2] === 0 && (i[1] !== 0 && (o[0] = o[1], m = bA(
      v,
      e,
      i,
      a,
      void 0,
      m
    ), i = [0, 0, 0, 0]), o[2] = n)) : w.type === "tableCellDivider" && (r ? r = !1 : (i[1] !== 0 && (o[0] = o[1], m = bA(
      v,
      e,
      i,
      a,
      void 0,
      m
    )), i = o, o = [i[1], n, 0, 0])) : w.type === "tableHead" ? (s = !0, u = n) : w.type === "tableRow" || w.type === "tableDelimiterRow" ? (u = n, i[1] !== 0 ? (o[0] = o[1], m = bA(
      v,
      e,
      i,
      a,
      n,
      m
    )) : o[1] !== 0 && (m = bA(v, e, o, a, n, m)), a = 0) : a && (w.type === "data" || w.type === "tableDelimiterMarker" || w.type === "tableDelimiterFiller") && (o[3] = n);
  }
  for (u !== 0 && kee(v, e, u, f, p), v.consume(e.events), n = -1; ++n < e.events.length; ) {
    const O = e.events[n];
    O[0] === "enter" && O[1].type === "table" && (O[1]._align = qVe(e.events, n));
  }
  return t;
}
function bA(t, e, n, r, a, i) {
  const o = r === 1 ? "tableHeader" : r === 2 ? "tableDelimiter" : "tableData", s = "tableContent";
  n[0] !== 0 && (i.end = Object.assign({}, pE(e.events, n[0])), t.add(n[0], 0, [["exit", i, e]]));
  const u = pE(e.events, n[1]);
  if (i = {
    type: o,
    start: Object.assign({}, u),
    // Note: correct end is set later.
    end: Object.assign({}, u)
  }, t.add(n[1], 0, [["enter", i, e]]), n[2] !== 0) {
    const f = pE(e.events, n[2]), p = pE(e.events, n[3]), m = {
      type: s,
      start: Object.assign({}, f),
      end: Object.assign({}, p)
    };
    if (t.add(n[2], 0, [["enter", m, e]]), r !== 2) {
      const v = e.events[n[2]], O = e.events[n[3]];
      if (v[1].end = Object.assign({}, O[1].end), v[1].type = "chunkText", v[1].contentType = "text", n[3] > n[2] + 1) {
        const w = n[2] + 1, _ = n[3] - n[2] - 1;
        t.add(w, _, []);
      }
    }
    t.add(n[3] + 1, 0, [["exit", m, e]]);
  }
  return a !== void 0 && (i.end = Object.assign({}, pE(e.events, a)), t.add(a, 0, [["exit", i, e]]), i = void 0), i;
}
function kee(t, e, n, r, a) {
  const i = [], o = pE(e.events, n);
  a && (a.end = Object.assign({}, o), i.push(["exit", a, e])), r.end = Object.assign({}, o), i.push(["exit", r, e]), t.add(n + 1, 0, i);
}
function pE(t, e) {
  const n = t[e], r = n[0] === "enter" ? "start" : "end";
  return n[1][r];
}
const tYe = {
  tokenize: rYe
};
function nYe() {
  return {
    text: {
      91: tYe
    }
  };
}
function rYe(t, e, n) {
  const r = this;
  return a;
  function a(u) {
    return (
      // Exit if there’s stuff before.
      r.previous !== null || // Exit if not in the first content that is the first child of a list
      // item.
      !r._gfmTasklistFirstContentOfListItem ? n(u) : (t.enter("taskListCheck"), t.enter("taskListCheckMarker"), t.consume(u), t.exit("taskListCheckMarker"), i)
    );
  }
  function i(u) {
    return Ya(u) ? (t.enter("taskListCheckValueUnchecked"), t.consume(u), t.exit("taskListCheckValueUnchecked"), o) : u === 88 || u === 120 ? (t.enter("taskListCheckValueChecked"), t.consume(u), t.exit("taskListCheckValueChecked"), o) : n(u);
  }
  function o(u) {
    return u === 93 ? (t.enter("taskListCheckMarker"), t.consume(u), t.exit("taskListCheckMarker"), t.exit("taskListCheck"), s) : n(u);
  }
  function s(u) {
    return Gn(u) ? e(u) : Nr(u) ? t.check(
      {
        tokenize: aYe
      },
      e,
      n
    )(u) : n(u);
  }
}
function aYe(t, e, n) {
  return Kr(t, r, "whitespace");
  function r(a) {
    return a === null ? n(a) : e(a);
  }
}
function iYe(t) {
  return mce([
    RVe(),
    UVe(),
    YVe(t),
    KVe(),
    nYe()
  ]);
}
const oYe = {};
function sYe(t) {
  const e = (
    /** @type {Processor} */
    this
  ), n = t || oYe, r = e.data(), a = r.micromarkExtensions || (r.micromarkExtensions = []), i = r.fromMarkdownExtensions || (r.fromMarkdownExtensions = []), o = r.toMarkdownExtensions || (r.toMarkdownExtensions = []);
  a.push(iYe(n)), i.push(CVe()), o.push(xVe(n));
}
const ffe = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(t) {
    if (t == null)
      return fYe;
    if (typeof t == "function")
      return bN(t);
    if (typeof t == "object")
      return Array.isArray(t) ? lYe(t) : uYe(t);
    if (typeof t == "string")
      return cYe(t);
    throw new Error("Expected function, string, or object as test");
  }
);
function lYe(t) {
  const e = [];
  let n = -1;
  for (; ++n < t.length; )
    e[n] = ffe(t[n]);
  return bN(r);
  function r(...a) {
    let i = -1;
    for (; ++i < e.length; )
      if (e[i].apply(this, a))
        return !0;
    return !1;
  }
}
function uYe(t) {
  const e = (
    /** @type {Record<string, unknown>} */
    t
  );
  return bN(n);
  function n(r) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let i;
    for (i in t)
      if (a[i] !== e[i])
        return !1;
    return !0;
  }
}
function cYe(t) {
  return bN(e);
  function e(n) {
    return n && n.type === t;
  }
}
function bN(t) {
  return e;
  function e(n, r, a) {
    return !!(dYe(n) && t.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      a || void 0
    ));
  }
}
function fYe() {
  return !0;
}
function dYe(t) {
  return t !== null && typeof t == "object" && "type" in t;
}
const dfe = [], pYe = !0, Ree = !1, hYe = "skip";
function mYe(t, e, n, r) {
  let a;
  typeof e == "function" && typeof n != "function" ? (r = n, n = e) : a = e;
  const i = ffe(a), o = r ? -1 : 1;
  s(t, void 0, [])();
  function s(u, f, p) {
    const m = (
      /** @type {Record<string, unknown>} */
      u && typeof u == "object" ? u : {}
    );
    if (typeof m.type == "string") {
      const O = (
        // `hast`
        typeof m.tagName == "string" ? m.tagName : (
          // `xast`
          typeof m.name == "string" ? m.name : void 0
        )
      );
      Object.defineProperty(v, "name", {
        value: "node (" + (u.type + (O ? "<" + O + ">" : "")) + ")"
      });
    }
    return v;
    function v() {
      let O = dfe, w, _, C;
      if ((!e || i(u, f, p[p.length - 1] || void 0)) && (O = gYe(n(u, p)), O[0] === Ree))
        return O;
      if ("children" in u && u.children) {
        const A = (
          /** @type {UnistParent} */
          u
        );
        if (A.children && O[0] !== hYe)
          for (_ = (r ? A.children.length : -1) + o, C = p.concat(A); _ > -1 && _ < A.children.length; ) {
            const N = A.children[_];
            if (w = s(N, _, C)(), w[0] === Ree)
              return w;
            _ = typeof w[1] == "number" ? w[1] : _ + o;
          }
      }
      return O;
    }
  }
}
function gYe(t) {
  return Array.isArray(t) ? t : typeof t == "number" ? [pYe, t] : t == null ? dfe : [t];
}
function bYe(t, e, n, r) {
  let a, i, o;
  typeof e == "function" && typeof n != "function" ? (i = void 0, o = e, a = n) : (i = e, o = n, a = r), mYe(t, i, s, a);
  function s(u, f) {
    const p = f[f.length - 1], m = p ? p.children.indexOf(u) : void 0;
    return o(u, m, p);
  }
}
const vYe = /^\[!(NOTE|TIP|IMPORTANT|WARNING|CAUTION)\]/i, yYe = /^\[!(NOTE|TIP|IMPORTANT|WARNING|CAUTION)(\/.*)?\]/i, OYe = ({ legacyTitle: t = !1 } = {}) => (e) => {
  bYe(e, "blockquote", (n, r, a) => {
    let i = "", o = "", s = !0, u = n.children.map((f) => {
      if (s && f.type === "paragraph") {
        const p = f.children[0], m = p.type === "text" ? p.value : "", v = t ? yYe : vYe, O = m.match(v);
        if (O && (s = !1, i = O[1].toLocaleLowerCase(), o = t && O[2] || i.toLocaleUpperCase(), m.includes(`
`) && (f.children[0] = {
          type: "text",
          value: m.replace(v, "").replace(/^\n+/, "")
        }), !m.includes(`
`))) {
          const w = [];
          f.children.forEach((_, C) => {
            C != 0 && (C == 1 && _.type === "break" || w.push(_));
          }), f.children = [...w];
        }
      }
      return f;
    });
    i && (n.data = {
      hName: "div",
      hProperties: {
        class: `markdown-alert markdown-alert-${i}`,
        dir: "auto"
      }
    }, u.unshift({
      type: "paragraph",
      children: [
        EYe(i),
        {
          type: "text",
          value: o.replace(/^\//, "")
        }
      ],
      data: {
        hProperties: {
          class: "markdown-alert-title",
          dir: "auto"
        }
      }
    })), n.children = [...u];
  });
};
function EYe(t) {
  let e = SYe[t] ?? "";
  return {
    type: "emphasis",
    data: {
      hName: "svg",
      hProperties: {
        class: "octicon",
        viewBox: "0 0 16 16",
        width: "16",
        height: "16",
        ariaHidden: "true"
      }
    },
    children: [
      {
        type: "emphasis",
        data: {
          hName: "path",
          hProperties: {
            d: e
          }
        },
        children: []
      }
    ]
  };
}
const SYe = {
  note: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8-6.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM6.5 7.75A.75.75 0 0 1 7.25 7h1a.75.75 0 0 1 .75.75v2.75h.25a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1 0-1.5h.25v-2h-.25a.75.75 0 0 1-.75-.75ZM8 6a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z",
  tip: "M8 1.5c-2.363 0-4 1.69-4 3.75 0 .984.424 1.625.984 2.304l.214.253c.223.264.47.556.673.848.284.411.537.896.621 1.49a.75.75 0 0 1-1.484.211c-.04-.282-.163-.547-.37-.847a8.456 8.456 0 0 0-.542-.68c-.084-.1-.173-.205-.268-.32C3.201 7.75 2.5 6.766 2.5 5.25 2.5 2.31 4.863 0 8 0s5.5 2.31 5.5 5.25c0 1.516-.701 2.5-1.328 3.259-.095.115-.184.22-.268.319-.207.245-.383.453-.541.681-.208.3-.33.565-.37.847a.751.751 0 0 1-1.485-.212c.084-.593.337-1.078.621-1.489.203-.292.45-.584.673-.848.075-.088.147-.173.213-.253.561-.679.985-1.32.985-2.304 0-2.06-1.637-3.75-4-3.75ZM5.75 12h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5ZM6 15.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z",
  important: "M0 1.75C0 .784.784 0 1.75 0h12.5C15.216 0 16 .784 16 1.75v9.5A1.75 1.75 0 0 1 14.25 13H8.06l-2.573 2.573A1.458 1.458 0 0 1 3 14.543V13H1.75A1.75 1.75 0 0 1 0 11.25Zm1.75-.25a.25.25 0 0 0-.25.25v9.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v2.19l2.72-2.72a.749.749 0 0 1 .53-.22h6.5a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25Zm7 2.25v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 1.5 0ZM9 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
  warning: "M6.457 1.047c.659-1.234 2.427-1.234 3.086 0l6.082 11.378A1.75 1.75 0 0 1 14.082 15H1.918a1.75 1.75 0 0 1-1.543-2.575Zm1.763.707a.25.25 0 0 0-.44 0L1.698 13.132a.25.25 0 0 0 .22.368h12.164a.25.25 0 0 0 .22-.368Zm.53 3.996v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 1.5 0ZM9 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
  caution: "M4.47.22A.749.749 0 0 1 5 0h6c.199 0 .389.079.53.22l4.25 4.25c.141.14.22.331.22.53v6a.749.749 0 0 1-.22.53l-4.25 4.25A.749.749 0 0 1 11 16H5a.749.749 0 0 1-.53-.22L.22 11.53A.749.749 0 0 1 0 11V5c0-.199.079-.389.22-.53Zm.84 1.28L1.5 5.31v5.38l3.81 3.81h5.38l3.81-3.81V5.31L10.69 1.5ZM8 4a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 8 4Zm0 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
};
function wYe(t, e) {
  if (typeof document > "u")
    return;
  const n = document.createElement("textarea");
  n.value = t, n.setAttribute("readonly", ""), n.style = {
    position: "absolute",
    left: "-9999px"
  }, document.body.appendChild(n);
  const r = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : !1;
  n.select();
  let a = !1;
  try {
    a = !!document.execCommand("copy");
  } catch {
    a = !1;
  }
  document.body.removeChild(n), r && document.getSelection && (document.getSelection().removeAllRanges(), document.getSelection().addRange(r)), e && e(a);
}
function pfe(t) {
  if (!t)
    return null;
  var e = t;
  return e.dataset.code && e.classList.contains("copied") ? e : e.parentElement ? pfe(e.parentElement) : null;
}
function TYe(t) {
  var e = (n) => {
    var r = pfe(n.target);
    r && (r.classList.add("active"), wYe(r.dataset.code, function() {
      setTimeout(() => {
        r.classList.remove("active");
      }, 2e3);
    }));
  };
  Vn(() => {
    var n, r;
    return (n = t.current) == null || n.removeEventListener("click", e, !1), (r = t.current) == null || r.addEventListener("click", e, !1), () => {
      var a;
      (a = t.current) == null || a.removeEventListener("click", e, !1);
    };
  }, [t]);
}
var _Ye = ["prefixCls", "className", "source", "style", "disableCopy", "skipHtml", "onScroll", "onMouseOver", "pluginsFilter", "rehypeRewrite", "wrapperElement", "warpperElement", "urlTransform"], CYe = (t) => t;
const xYe = /* @__PURE__ */ Ge.forwardRef((t, e) => {
  var {
    prefixCls: n = "wmde-markdown wmde-markdown-color",
    className: r,
    source: a,
    style: i,
    disableCopy: o = !1,
    skipHtml: s = !0,
    onScroll: u,
    onMouseOver: f,
    pluginsFilter: p,
    wrapperElement: m = {},
    warpperElement: v = {},
    urlTransform: O
  } = t, w = qb(t, _Ye), _ = Ge.useRef(null);
  Nl(e, () => rn({}, t, {
    mdp: _
  }), [_, t]);
  var C = (n || "") + " " + (r || "");
  TYe(_);
  var A = [...w.rehypePlugins || []], N = {
    allowElement: (D, M, H) => w.allowElement ? w.allowElement(D, M, H) : /^[A-Za-z0-9]+$/.test(D.tagName)
  };
  s && A.push(fce);
  var P = [OYe, ...w.remarkPlugins || [], sYe], I = rn({}, v, m);
  return /* @__PURE__ */ Ne.jsx("div", rn({
    ref: _,
    onScroll: u,
    onMouseOver: f
  }, I, {
    className: C,
    style: i,
    children: /* @__PURE__ */ Ne.jsx(Tje, rn({}, N, w, {
      skipHtml: s,
      urlTransform: O || CYe,
      rehypePlugins: p ? p("rehype", A) : A,
      remarkPlugins: p ? p("remark", P) : P,
      children: a || ""
    }))
  }));
}), hfe = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(t) {
    if (t == null)
      return IYe;
    if (typeof t == "function")
      return vN(t);
    if (typeof t == "object")
      return Array.isArray(t) ? AYe(t) : kYe(t);
    if (typeof t == "string")
      return RYe(t);
    throw new Error("Expected function, string, or object as test");
  }
);
function AYe(t) {
  const e = [];
  let n = -1;
  for (; ++n < t.length; )
    e[n] = hfe(t[n]);
  return vN(r);
  function r(...a) {
    let i = -1;
    for (; ++i < e.length; )
      if (e[i].apply(this, a))
        return !0;
    return !1;
  }
}
function kYe(t) {
  const e = (
    /** @type {Record<string, unknown>} */
    t
  );
  return vN(n);
  function n(r) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let i;
    for (i in t)
      if (a[i] !== e[i])
        return !1;
    return !0;
  }
}
function RYe(t) {
  return vN(e);
  function e(n) {
    return n && n.type === t;
  }
}
function vN(t) {
  return e;
  function e(n, r, a) {
    return !!(DYe(n) && t.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      a || void 0
    ));
  }
}
function IYe() {
  return !0;
}
function DYe(t) {
  return t !== null && typeof t == "object" && "type" in t;
}
const mfe = [], NYe = !0, Iee = !1, PYe = "skip";
function LYe(t, e, n, r) {
  let a;
  typeof e == "function" && typeof n != "function" ? (r = n, n = e) : a = e;
  const i = hfe(a), o = r ? -1 : 1;
  s(t, void 0, [])();
  function s(u, f, p) {
    const m = (
      /** @type {Record<string, unknown>} */
      u && typeof u == "object" ? u : {}
    );
    if (typeof m.type == "string") {
      const O = (
        // `hast`
        typeof m.tagName == "string" ? m.tagName : (
          // `xast`
          typeof m.name == "string" ? m.name : void 0
        )
      );
      Object.defineProperty(v, "name", {
        value: "node (" + (u.type + (O ? "<" + O + ">" : "")) + ")"
      });
    }
    return v;
    function v() {
      let O = mfe, w, _, C;
      if ((!e || i(u, f, p[p.length - 1] || void 0)) && (O = MYe(n(u, p)), O[0] === Iee))
        return O;
      if ("children" in u && u.children) {
        const A = (
          /** @type {UnistParent} */
          u
        );
        if (A.children && O[0] !== PYe)
          for (_ = (r ? A.children.length : -1) + o, C = p.concat(A); _ > -1 && _ < A.children.length; ) {
            const N = A.children[_];
            if (w = s(N, _, C)(), w[0] === Iee)
              return w;
            _ = typeof w[1] == "number" ? w[1] : _ + o;
          }
      }
      return O;
    }
  }
}
function MYe(t) {
  return Array.isArray(t) ? t : typeof t == "number" ? [NYe, t] : t == null ? mfe : [t];
}
function gfe(t, e, n, r) {
  let a, i, o;
  typeof e == "function" && typeof n != "function" ? (i = void 0, o = e, a = n) : (i = e, o = n, a = r), LYe(t, i, s, a);
  function s(u, f) {
    const p = f[f.length - 1], m = p ? p.children.indexOf(u) : void 0;
    return o(u, m, p);
  }
}
var FYe = function(e) {
  return (n) => {
    gfe(n, (r) => {
      r.type === "element" && r.tagName === "code" && r.data && r.data.meta && (r.properties = rn({}, r.properties, {
        "data-meta": String(r.data.meta)
      }));
    });
  };
}, $Ye = function(e) {
  return (n) => {
    gfe(n, (r) => {
      r.type === "element" && r.tagName === "code" && r.properties && r.properties.dataMeta && (r.data || (r.data = {}), r.data.meta = r.properties.dataMeta, delete r.properties.dataMeta);
    });
  };
};
const BYe = /[\0-\x1F!-,\.\/:-@\[-\^`\{-\xA9\xAB-\xB4\xB6-\xB9\xBB-\xBF\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0378\u0379\u037E\u0380-\u0385\u0387\u038B\u038D\u03A2\u03F6\u0482\u0530\u0557\u0558\u055A-\u055F\u0589-\u0590\u05BE\u05C0\u05C3\u05C6\u05C8-\u05CF\u05EB-\u05EE\u05F3-\u060F\u061B-\u061F\u066A-\u066D\u06D4\u06DD\u06DE\u06E9\u06FD\u06FE\u0700-\u070F\u074B\u074C\u07B2-\u07BF\u07F6-\u07F9\u07FB\u07FC\u07FE\u07FF\u082E-\u083F\u085C-\u085F\u086B-\u089F\u08B5\u08C8-\u08D2\u08E2\u0964\u0965\u0970\u0984\u098D\u098E\u0991\u0992\u09A9\u09B1\u09B3-\u09B5\u09BA\u09BB\u09C5\u09C6\u09C9\u09CA\u09CF-\u09D6\u09D8-\u09DB\u09DE\u09E4\u09E5\u09F2-\u09FB\u09FD\u09FF\u0A00\u0A04\u0A0B-\u0A0E\u0A11\u0A12\u0A29\u0A31\u0A34\u0A37\u0A3A\u0A3B\u0A3D\u0A43-\u0A46\u0A49\u0A4A\u0A4E-\u0A50\u0A52-\u0A58\u0A5D\u0A5F-\u0A65\u0A76-\u0A80\u0A84\u0A8E\u0A92\u0AA9\u0AB1\u0AB4\u0ABA\u0ABB\u0AC6\u0ACA\u0ACE\u0ACF\u0AD1-\u0ADF\u0AE4\u0AE5\u0AF0-\u0AF8\u0B00\u0B04\u0B0D\u0B0E\u0B11\u0B12\u0B29\u0B31\u0B34\u0B3A\u0B3B\u0B45\u0B46\u0B49\u0B4A\u0B4E-\u0B54\u0B58-\u0B5B\u0B5E\u0B64\u0B65\u0B70\u0B72-\u0B81\u0B84\u0B8B-\u0B8D\u0B91\u0B96-\u0B98\u0B9B\u0B9D\u0BA0-\u0BA2\u0BA5-\u0BA7\u0BAB-\u0BAD\u0BBA-\u0BBD\u0BC3-\u0BC5\u0BC9\u0BCE\u0BCF\u0BD1-\u0BD6\u0BD8-\u0BE5\u0BF0-\u0BFF\u0C0D\u0C11\u0C29\u0C3A-\u0C3C\u0C45\u0C49\u0C4E-\u0C54\u0C57\u0C5B-\u0C5F\u0C64\u0C65\u0C70-\u0C7F\u0C84\u0C8D\u0C91\u0CA9\u0CB4\u0CBA\u0CBB\u0CC5\u0CC9\u0CCE-\u0CD4\u0CD7-\u0CDD\u0CDF\u0CE4\u0CE5\u0CF0\u0CF3-\u0CFF\u0D0D\u0D11\u0D45\u0D49\u0D4F-\u0D53\u0D58-\u0D5E\u0D64\u0D65\u0D70-\u0D79\u0D80\u0D84\u0D97-\u0D99\u0DB2\u0DBC\u0DBE\u0DBF\u0DC7-\u0DC9\u0DCB-\u0DCE\u0DD5\u0DD7\u0DE0-\u0DE5\u0DF0\u0DF1\u0DF4-\u0E00\u0E3B-\u0E3F\u0E4F\u0E5A-\u0E80\u0E83\u0E85\u0E8B\u0EA4\u0EA6\u0EBE\u0EBF\u0EC5\u0EC7\u0ECE\u0ECF\u0EDA\u0EDB\u0EE0-\u0EFF\u0F01-\u0F17\u0F1A-\u0F1F\u0F2A-\u0F34\u0F36\u0F38\u0F3A-\u0F3D\u0F48\u0F6D-\u0F70\u0F85\u0F98\u0FBD-\u0FC5\u0FC7-\u0FFF\u104A-\u104F\u109E\u109F\u10C6\u10C8-\u10CC\u10CE\u10CF\u10FB\u1249\u124E\u124F\u1257\u1259\u125E\u125F\u1289\u128E\u128F\u12B1\u12B6\u12B7\u12BF\u12C1\u12C6\u12C7\u12D7\u1311\u1316\u1317\u135B\u135C\u1360-\u137F\u1390-\u139F\u13F6\u13F7\u13FE-\u1400\u166D\u166E\u1680\u169B-\u169F\u16EB-\u16ED\u16F9-\u16FF\u170D\u1715-\u171F\u1735-\u173F\u1754-\u175F\u176D\u1771\u1774-\u177F\u17D4-\u17D6\u17D8-\u17DB\u17DE\u17DF\u17EA-\u180A\u180E\u180F\u181A-\u181F\u1879-\u187F\u18AB-\u18AF\u18F6-\u18FF\u191F\u192C-\u192F\u193C-\u1945\u196E\u196F\u1975-\u197F\u19AC-\u19AF\u19CA-\u19CF\u19DA-\u19FF\u1A1C-\u1A1F\u1A5F\u1A7D\u1A7E\u1A8A-\u1A8F\u1A9A-\u1AA6\u1AA8-\u1AAF\u1AC1-\u1AFF\u1B4C-\u1B4F\u1B5A-\u1B6A\u1B74-\u1B7F\u1BF4-\u1BFF\u1C38-\u1C3F\u1C4A-\u1C4C\u1C7E\u1C7F\u1C89-\u1C8F\u1CBB\u1CBC\u1CC0-\u1CCF\u1CD3\u1CFB-\u1CFF\u1DFA\u1F16\u1F17\u1F1E\u1F1F\u1F46\u1F47\u1F4E\u1F4F\u1F58\u1F5A\u1F5C\u1F5E\u1F7E\u1F7F\u1FB5\u1FBD\u1FBF-\u1FC1\u1FC5\u1FCD-\u1FCF\u1FD4\u1FD5\u1FDC-\u1FDF\u1FED-\u1FF1\u1FF5\u1FFD-\u203E\u2041-\u2053\u2055-\u2070\u2072-\u207E\u2080-\u208F\u209D-\u20CF\u20F1-\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F-\u215F\u2189-\u24B5\u24EA-\u2BFF\u2C2F\u2C5F\u2CE5-\u2CEA\u2CF4-\u2CFF\u2D26\u2D28-\u2D2C\u2D2E\u2D2F\u2D68-\u2D6E\u2D70-\u2D7E\u2D97-\u2D9F\u2DA7\u2DAF\u2DB7\u2DBF\u2DC7\u2DCF\u2DD7\u2DDF\u2E00-\u2E2E\u2E30-\u3004\u3008-\u3020\u3030\u3036\u3037\u303D-\u3040\u3097\u3098\u309B\u309C\u30A0\u30FB\u3100-\u3104\u3130\u318F-\u319F\u31C0-\u31EF\u3200-\u33FF\u4DC0-\u4DFF\u9FFD-\u9FFF\uA48D-\uA4CF\uA4FE\uA4FF\uA60D-\uA60F\uA62C-\uA63F\uA673\uA67E\uA6F2-\uA716\uA720\uA721\uA789\uA78A\uA7C0\uA7C1\uA7CB-\uA7F4\uA828-\uA82B\uA82D-\uA83F\uA874-\uA87F\uA8C6-\uA8CF\uA8DA-\uA8DF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA954-\uA95F\uA97D-\uA97F\uA9C1-\uA9CE\uA9DA-\uA9DF\uA9FF\uAA37-\uAA3F\uAA4E\uAA4F\uAA5A-\uAA5F\uAA77-\uAA79\uAAC3-\uAADA\uAADE\uAADF\uAAF0\uAAF1\uAAF7-\uAB00\uAB07\uAB08\uAB0F\uAB10\uAB17-\uAB1F\uAB27\uAB2F\uAB5B\uAB6A-\uAB6F\uABEB\uABEE\uABEF\uABFA-\uABFF\uD7A4-\uD7AF\uD7C7-\uD7CA\uD7FC-\uD7FF\uE000-\uF8FF\uFA6E\uFA6F\uFADA-\uFAFF\uFB07-\uFB12\uFB18-\uFB1C\uFB29\uFB37\uFB3D\uFB3F\uFB42\uFB45\uFBB2-\uFBD2\uFD3E-\uFD4F\uFD90\uFD91\uFDC8-\uFDEF\uFDFC-\uFDFF\uFE10-\uFE1F\uFE30-\uFE32\uFE35-\uFE4C\uFE50-\uFE6F\uFE75\uFEFD-\uFF0F\uFF1A-\uFF20\uFF3B-\uFF3E\uFF40\uFF5B-\uFF65\uFFBF-\uFFC1\uFFC8\uFFC9\uFFD0\uFFD1\uFFD8\uFFD9\uFFDD-\uFFFF]|\uD800[\uDC0C\uDC27\uDC3B\uDC3E\uDC4E\uDC4F\uDC5E-\uDC7F\uDCFB-\uDD3F\uDD75-\uDDFC\uDDFE-\uDE7F\uDE9D-\uDE9F\uDED1-\uDEDF\uDEE1-\uDEFF\uDF20-\uDF2C\uDF4B-\uDF4F\uDF7B-\uDF7F\uDF9E\uDF9F\uDFC4-\uDFC7\uDFD0\uDFD6-\uDFFF]|\uD801[\uDC9E\uDC9F\uDCAA-\uDCAF\uDCD4-\uDCD7\uDCFC-\uDCFF\uDD28-\uDD2F\uDD64-\uDDFF\uDF37-\uDF3F\uDF56-\uDF5F\uDF68-\uDFFF]|\uD802[\uDC06\uDC07\uDC09\uDC36\uDC39-\uDC3B\uDC3D\uDC3E\uDC56-\uDC5F\uDC77-\uDC7F\uDC9F-\uDCDF\uDCF3\uDCF6-\uDCFF\uDD16-\uDD1F\uDD3A-\uDD7F\uDDB8-\uDDBD\uDDC0-\uDDFF\uDE04\uDE07-\uDE0B\uDE14\uDE18\uDE36\uDE37\uDE3B-\uDE3E\uDE40-\uDE5F\uDE7D-\uDE7F\uDE9D-\uDEBF\uDEC8\uDEE7-\uDEFF\uDF36-\uDF3F\uDF56-\uDF5F\uDF73-\uDF7F\uDF92-\uDFFF]|\uD803[\uDC49-\uDC7F\uDCB3-\uDCBF\uDCF3-\uDCFF\uDD28-\uDD2F\uDD3A-\uDE7F\uDEAA\uDEAD-\uDEAF\uDEB2-\uDEFF\uDF1D-\uDF26\uDF28-\uDF2F\uDF51-\uDFAF\uDFC5-\uDFDF\uDFF7-\uDFFF]|\uD804[\uDC47-\uDC65\uDC70-\uDC7E\uDCBB-\uDCCF\uDCE9-\uDCEF\uDCFA-\uDCFF\uDD35\uDD40-\uDD43\uDD48-\uDD4F\uDD74\uDD75\uDD77-\uDD7F\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDFF\uDE12\uDE38-\uDE3D\uDE3F-\uDE7F\uDE87\uDE89\uDE8E\uDE9E\uDEA9-\uDEAF\uDEEB-\uDEEF\uDEFA-\uDEFF\uDF04\uDF0D\uDF0E\uDF11\uDF12\uDF29\uDF31\uDF34\uDF3A\uDF45\uDF46\uDF49\uDF4A\uDF4E\uDF4F\uDF51-\uDF56\uDF58-\uDF5C\uDF64\uDF65\uDF6D-\uDF6F\uDF75-\uDFFF]|\uD805[\uDC4B-\uDC4F\uDC5A-\uDC5D\uDC62-\uDC7F\uDCC6\uDCC8-\uDCCF\uDCDA-\uDD7F\uDDB6\uDDB7\uDDC1-\uDDD7\uDDDE-\uDDFF\uDE41-\uDE43\uDE45-\uDE4F\uDE5A-\uDE7F\uDEB9-\uDEBF\uDECA-\uDEFF\uDF1B\uDF1C\uDF2C-\uDF2F\uDF3A-\uDFFF]|\uD806[\uDC3B-\uDC9F\uDCEA-\uDCFE\uDD07\uDD08\uDD0A\uDD0B\uDD14\uDD17\uDD36\uDD39\uDD3A\uDD44-\uDD4F\uDD5A-\uDD9F\uDDA8\uDDA9\uDDD8\uDDD9\uDDE2\uDDE5-\uDDFF\uDE3F-\uDE46\uDE48-\uDE4F\uDE9A-\uDE9C\uDE9E-\uDEBF\uDEF9-\uDFFF]|\uD807[\uDC09\uDC37\uDC41-\uDC4F\uDC5A-\uDC71\uDC90\uDC91\uDCA8\uDCB7-\uDCFF\uDD07\uDD0A\uDD37-\uDD39\uDD3B\uDD3E\uDD48-\uDD4F\uDD5A-\uDD5F\uDD66\uDD69\uDD8F\uDD92\uDD99-\uDD9F\uDDAA-\uDEDF\uDEF7-\uDFAF\uDFB1-\uDFFF]|\uD808[\uDF9A-\uDFFF]|\uD809[\uDC6F-\uDC7F\uDD44-\uDFFF]|[\uD80A\uD80B\uD80E-\uD810\uD812-\uD819\uD824-\uD82B\uD82D\uD82E\uD830-\uD833\uD837\uD839\uD83D\uD83F\uD87B-\uD87D\uD87F\uD885-\uDB3F\uDB41-\uDBFF][\uDC00-\uDFFF]|\uD80D[\uDC2F-\uDFFF]|\uD811[\uDE47-\uDFFF]|\uD81A[\uDE39-\uDE3F\uDE5F\uDE6A-\uDECF\uDEEE\uDEEF\uDEF5-\uDEFF\uDF37-\uDF3F\uDF44-\uDF4F\uDF5A-\uDF62\uDF78-\uDF7C\uDF90-\uDFFF]|\uD81B[\uDC00-\uDE3F\uDE80-\uDEFF\uDF4B-\uDF4E\uDF88-\uDF8E\uDFA0-\uDFDF\uDFE2\uDFE5-\uDFEF\uDFF2-\uDFFF]|\uD821[\uDFF8-\uDFFF]|\uD823[\uDCD6-\uDCFF\uDD09-\uDFFF]|\uD82C[\uDD1F-\uDD4F\uDD53-\uDD63\uDD68-\uDD6F\uDEFC-\uDFFF]|\uD82F[\uDC6B-\uDC6F\uDC7D-\uDC7F\uDC89-\uDC8F\uDC9A-\uDC9C\uDC9F-\uDFFF]|\uD834[\uDC00-\uDD64\uDD6A-\uDD6C\uDD73-\uDD7A\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDE41\uDE45-\uDFFF]|\uD835[\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3\uDFCC\uDFCD]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85-\uDE9A\uDEA0\uDEB0-\uDFFF]|\uD838[\uDC07\uDC19\uDC1A\uDC22\uDC25\uDC2B-\uDCFF\uDD2D-\uDD2F\uDD3E\uDD3F\uDD4A-\uDD4D\uDD4F-\uDEBF\uDEFA-\uDFFF]|\uD83A[\uDCC5-\uDCCF\uDCD7-\uDCFF\uDD4C-\uDD4F\uDD5A-\uDFFF]|\uD83B[\uDC00-\uDDFF\uDE04\uDE20\uDE23\uDE25\uDE26\uDE28\uDE33\uDE38\uDE3A\uDE3C-\uDE41\uDE43-\uDE46\uDE48\uDE4A\uDE4C\uDE50\uDE53\uDE55\uDE56\uDE58\uDE5A\uDE5C\uDE5E\uDE60\uDE63\uDE65\uDE66\uDE6B\uDE73\uDE78\uDE7D\uDE7F\uDE8A\uDE9C-\uDEA0\uDEA4\uDEAA\uDEBC-\uDFFF]|\uD83C[\uDC00-\uDD2F\uDD4A-\uDD4F\uDD6A-\uDD6F\uDD8A-\uDFFF]|\uD83E[\uDC00-\uDFEF\uDFFA-\uDFFF]|\uD869[\uDEDE-\uDEFF]|\uD86D[\uDF35-\uDF3F]|\uD86E[\uDC1E\uDC1F]|\uD873[\uDEA2-\uDEAF]|\uD87A[\uDFE1-\uDFFF]|\uD87E[\uDE1E-\uDFFF]|\uD884[\uDF4B-\uDFFF]|\uDB40[\uDC00-\uDCFF\uDDF0-\uDFFF]/g, UYe = Object.hasOwnProperty;
class zYe {
  /**
   * Create a new slug class.
   */
  constructor() {
    this.occurrences, this.reset();
  }
  /**
   * Generate a unique slug.
  *
  * Tracks previously generated slugs: repeated calls with the same value
  * will result in different slugs.
  * Use the `slug` function to get same slugs.
   *
   * @param  {string} value
   *   String of text to slugify
   * @param  {boolean} [maintainCase=false]
   *   Keep the current case, otherwise make all lowercase
   * @return {string}
   *   A unique slug string
   */
  slug(e, n) {
    const r = this;
    let a = HYe(e, n === !0);
    const i = a;
    for (; UYe.call(r.occurrences, a); )
      r.occurrences[i]++, a = i + "-" + r.occurrences[i];
    return r.occurrences[a] = 0, a;
  }
  /**
   * Reset - Forget all previous slugs
   *
   * @return void
   */
  reset() {
    this.occurrences = /* @__PURE__ */ Object.create(null);
  }
}
function HYe(t, e) {
  return typeof t != "string" ? "" : (e || (t = t.toLowerCase()), t.replace(BYe, "").replace(/ /g, "-"));
}
function bfe(t) {
  const e = t.type === "element" ? t.tagName.toLowerCase() : "", n = e.length === 2 && e.charCodeAt(0) === 104 ? e.charCodeAt(1) : 0;
  return n > 48 && n < 55 ? n - 48 : void 0;
}
const vfe = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(t) {
    if (t == null)
      return GYe;
    if (typeof t == "function")
      return yN(t);
    if (typeof t == "object")
      return Array.isArray(t) ? WYe(t) : QYe(t);
    if (typeof t == "string")
      return jYe(t);
    throw new Error("Expected function, string, or object as test");
  }
);
function WYe(t) {
  const e = [];
  let n = -1;
  for (; ++n < t.length; )
    e[n] = vfe(t[n]);
  return yN(r);
  function r(...a) {
    let i = -1;
    for (; ++i < e.length; )
      if (e[i].apply(this, a))
        return !0;
    return !1;
  }
}
function QYe(t) {
  const e = (
    /** @type {Record<string, unknown>} */
    t
  );
  return yN(n);
  function n(r) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let i;
    for (i in t)
      if (a[i] !== e[i])
        return !1;
    return !0;
  }
}
function jYe(t) {
  return yN(e);
  function e(n) {
    return n && n.type === t;
  }
}
function yN(t) {
  return e;
  function e(n, r, a) {
    return !!(VYe(n) && t.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      a || void 0
    ));
  }
}
function GYe() {
  return !0;
}
function VYe(t) {
  return t !== null && typeof t == "object" && "type" in t;
}
const yfe = [], YYe = !0, Dee = !1, ZYe = "skip";
function XYe(t, e, n, r) {
  let a;
  typeof e == "function" && typeof n != "function" ? (r = n, n = e) : a = e;
  const i = vfe(a), o = r ? -1 : 1;
  s(t, void 0, [])();
  function s(u, f, p) {
    const m = (
      /** @type {Record<string, unknown>} */
      u && typeof u == "object" ? u : {}
    );
    if (typeof m.type == "string") {
      const O = (
        // `hast`
        typeof m.tagName == "string" ? m.tagName : (
          // `xast`
          typeof m.name == "string" ? m.name : void 0
        )
      );
      Object.defineProperty(v, "name", {
        value: "node (" + (u.type + (O ? "<" + O + ">" : "")) + ")"
      });
    }
    return v;
    function v() {
      let O = yfe, w, _, C;
      if ((!e || i(u, f, p[p.length - 1] || void 0)) && (O = qYe(n(u, p)), O[0] === Dee))
        return O;
      if ("children" in u && u.children) {
        const A = (
          /** @type {UnistParent} */
          u
        );
        if (A.children && O[0] !== ZYe)
          for (_ = (r ? A.children.length : -1) + o, C = p.concat(A); _ > -1 && _ < A.children.length; ) {
            const N = A.children[_];
            if (w = s(N, _, C)(), w[0] === Dee)
              return w;
            _ = typeof w[1] == "number" ? w[1] : _ + o;
          }
      }
      return O;
    }
  }
}
function qYe(t) {
  return Array.isArray(t) ? t : typeof t == "number" ? [YYe, t] : t == null ? yfe : [t];
}
function KYe(t, e, n, r) {
  let a, i, o;
  typeof e == "function" && typeof n != "function" ? (i = void 0, o = e, a = n) : (i = e, o = n, a = r), XYe(t, i, s, a);
  function s(u, f) {
    const p = f[f.length - 1], m = p ? p.children.indexOf(u) : void 0;
    return o(u, m, p);
  }
}
const JYe = {}, Nee = new zYe();
function eZe(t) {
  const n = (t || JYe).prefix || "";
  return function(r) {
    Nee.reset(), KYe(r, "element", function(a) {
      bfe(a) && !a.properties.id && (a.properties.id = n + Nee.slug(OE(a)));
    });
  };
}
const Ofe = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends TestFunction>(test: Condition) => (element: unknown, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => element is Element & Predicate<Condition, Element>) &
   *   (<Condition extends string>(test: Condition) => (element: unknown, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => element is Element & {tagName: Condition}) &
   *   ((test?: null | undefined) => (element?: unknown, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => element is Element) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test | null | undefined} [test]
   * @returns {Check}
   */
  function(t) {
    if (t == null)
      return rZe;
    if (typeof t == "string")
      return nZe(t);
    if (typeof t == "object")
      return tZe(t);
    if (typeof t == "function")
      return W7(t);
    throw new Error("Expected function, string, or array as `test`");
  }
);
function tZe(t) {
  const e = [];
  let n = -1;
  for (; ++n < t.length; )
    e[n] = Ofe(t[n]);
  return W7(r);
  function r(...a) {
    let i = -1;
    for (; ++i < e.length; )
      if (e[i].apply(this, a))
        return !0;
    return !1;
  }
}
function nZe(t) {
  return W7(e);
  function e(n) {
    return n.tagName === t;
  }
}
function W7(t) {
  return e;
  function e(n, r, a) {
    return !!(aZe(n) && t.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      a || void 0
    ));
  }
}
function rZe(t) {
  return !!(t && typeof t == "object" && "type" in t && t.type === "element" && "tagName" in t && typeof t.tagName == "string");
}
function aZe(t) {
  return t !== null && typeof t == "object" && "type" in t && "tagName" in t;
}
const Efe = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(t) {
    if (t == null)
      return lZe;
    if (typeof t == "function")
      return ON(t);
    if (typeof t == "object")
      return Array.isArray(t) ? iZe(t) : oZe(t);
    if (typeof t == "string")
      return sZe(t);
    throw new Error("Expected function, string, or object as test");
  }
);
function iZe(t) {
  const e = [];
  let n = -1;
  for (; ++n < t.length; )
    e[n] = Efe(t[n]);
  return ON(r);
  function r(...a) {
    let i = -1;
    for (; ++i < e.length; )
      if (e[i].apply(this, a))
        return !0;
    return !1;
  }
}
function oZe(t) {
  const e = (
    /** @type {Record<string, unknown>} */
    t
  );
  return ON(n);
  function n(r) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let i;
    for (i in t)
      if (a[i] !== e[i])
        return !1;
    return !0;
  }
}
function sZe(t) {
  return ON(e);
  function e(n) {
    return n && n.type === t;
  }
}
function ON(t) {
  return e;
  function e(n, r, a) {
    return !!(uZe(n) && t.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      a || void 0
    ));
  }
}
function lZe() {
  return !0;
}
function uZe(t) {
  return t !== null && typeof t == "object" && "type" in t;
}
const Sfe = [], cZe = !0, Pee = !1, Uk = "skip";
function fZe(t, e, n, r) {
  let a;
  typeof e == "function" && typeof n != "function" ? (r = n, n = e) : a = e;
  const i = Efe(a), o = r ? -1 : 1;
  s(t, void 0, [])();
  function s(u, f, p) {
    const m = (
      /** @type {Record<string, unknown>} */
      u && typeof u == "object" ? u : {}
    );
    if (typeof m.type == "string") {
      const O = (
        // `hast`
        typeof m.tagName == "string" ? m.tagName : (
          // `xast`
          typeof m.name == "string" ? m.name : void 0
        )
      );
      Object.defineProperty(v, "name", {
        value: "node (" + (u.type + (O ? "<" + O + ">" : "")) + ")"
      });
    }
    return v;
    function v() {
      let O = Sfe, w, _, C;
      if ((!e || i(u, f, p[p.length - 1] || void 0)) && (O = dZe(n(u, p)), O[0] === Pee))
        return O;
      if ("children" in u && u.children) {
        const A = (
          /** @type {UnistParent} */
          u
        );
        if (A.children && O[0] !== Uk)
          for (_ = (r ? A.children.length : -1) + o, C = p.concat(A); _ > -1 && _ < A.children.length; ) {
            const N = A.children[_];
            if (w = s(N, _, C)(), w[0] === Pee)
              return w;
            _ = typeof w[1] == "number" ? w[1] : _ + o;
          }
      }
      return O;
    }
  }
}
function dZe(t) {
  return Array.isArray(t) ? t : typeof t == "number" ? [cZe, t] : t == null ? Sfe : [t];
}
function pZe(t, e, n, r) {
  let a, i, o;
  typeof e == "function" && typeof n != "function" ? (i = void 0, o = e, a = n) : (i = e, o = n, a = r), fZe(t, i, s, a);
  function s(u, f) {
    const p = f[f.length - 1], m = p ? p.children.indexOf(u) : void 0;
    return o(u, m, p);
  }
}
const Lee = {
  type: "element",
  tagName: "span",
  properties: { className: ["icon", "icon-link"] },
  children: []
}, hZe = {};
function mZe(t) {
  const e = t || hZe;
  let n = e.properties;
  const r = e.headingProperties, a = e.behavior || "prepend", i = e.content, o = e.group, s = Ofe(e.test);
  let u;
  return a === "after" || a === "before" ? u = p : a === "wrap" ? u = m : (u = f, n || (n = { ariaHidden: "true", tabIndex: -1 })), function(v) {
    pZe(v, "element", function(O, w, _) {
      if (bfe(O) && O.properties.id && s(O, w, _))
        return Object.assign(O.properties, vA(r, O)), u(O, w, _);
    });
  };
  function f(v) {
    const O = Mee(i || Lee, v);
    return v.children[a === "prepend" ? "unshift" : "push"](
      cF(v, vA(n, v), O)
    ), [Uk];
  }
  function p(v, O, w) {
    if (typeof O != "number" || !w)
      return;
    const _ = Mee(i || Lee, v), C = cF(v, vA(n, v), _);
    let A = a === "before" ? [C, v] : [v, C];
    if (o) {
      const N = wfe(o, v);
      N && !Array.isArray(N) && N.type === "element" && (N.children = A, A = [N]);
    }
    return w.children.splice(O, 1, ...A), [Uk, O + A.length];
  }
  function m(v) {
    let O = v.children, w = [];
    return typeof i == "function" ? (O = [], w = i(v)) : i && (w = Q7(i)), v.children = [
      cF(
        v,
        vA(n, v),
        Array.isArray(w) ? [...O, ...w] : [...O, w]
      )
    ], [Uk];
  }
}
function Q7(t) {
  return (
    /** @type {Cloneable<T>} */
    y0(t)
  );
}
function cF(t, e, n) {
  return {
    type: "element",
    tagName: "a",
    properties: { ...e, href: "#" + t.properties.id },
    children: n
  };
}
function Mee(t, e) {
  const n = wfe(t, e);
  return Array.isArray(n) ? n : [n];
}
function wfe(t, e) {
  return typeof t == "function" ? t(e) : Q7(t);
}
function vA(t, e) {
  return typeof t == "function" ? t(e) : t ? Q7(t) : {};
}
const Tfe = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(t) {
    if (t == null)
      return yZe;
    if (typeof t == "function")
      return EN(t);
    if (typeof t == "object")
      return Array.isArray(t) ? gZe(t) : bZe(t);
    if (typeof t == "string")
      return vZe(t);
    throw new Error("Expected function, string, or object as test");
  }
);
function gZe(t) {
  const e = [];
  let n = -1;
  for (; ++n < t.length; )
    e[n] = Tfe(t[n]);
  return EN(r);
  function r(...a) {
    let i = -1;
    for (; ++i < e.length; )
      if (e[i].apply(this, a))
        return !0;
    return !1;
  }
}
function bZe(t) {
  const e = (
    /** @type {Record<string, unknown>} */
    t
  );
  return EN(n);
  function n(r) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let i;
    for (i in t)
      if (a[i] !== e[i])
        return !1;
    return !0;
  }
}
function vZe(t) {
  return EN(e);
  function e(n) {
    return n && n.type === t;
  }
}
function EN(t) {
  return e;
  function e(n, r, a) {
    return !!(OZe(n) && t.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      a || void 0
    ));
  }
}
function yZe() {
  return !0;
}
function OZe(t) {
  return t !== null && typeof t == "object" && "type" in t;
}
const _fe = [], EZe = !0, Fee = !1, SZe = "skip";
function wZe(t, e, n, r) {
  let a;
  typeof e == "function" && typeof n != "function" ? (r = n, n = e) : a = e;
  const i = Tfe(a), o = r ? -1 : 1;
  s(t, void 0, [])();
  function s(u, f, p) {
    const m = (
      /** @type {Record<string, unknown>} */
      u && typeof u == "object" ? u : {}
    );
    if (typeof m.type == "string") {
      const O = (
        // `hast`
        typeof m.tagName == "string" ? m.tagName : (
          // `xast`
          typeof m.name == "string" ? m.name : void 0
        )
      );
      Object.defineProperty(v, "name", {
        value: "node (" + (u.type + (O ? "<" + O + ">" : "")) + ")"
      });
    }
    return v;
    function v() {
      let O = _fe, w, _, C;
      if ((!e || i(u, f, p[p.length - 1] || void 0)) && (O = TZe(n(u, p)), O[0] === Fee))
        return O;
      if ("children" in u && u.children) {
        const A = (
          /** @type {UnistParent} */
          u
        );
        if (A.children && O[0] !== SZe)
          for (_ = (r ? A.children.length : -1) + o, C = p.concat(A); _ > -1 && _ < A.children.length; ) {
            const N = A.children[_];
            if (w = s(N, _, C)(), w[0] === Fee)
              return w;
            _ = typeof w[1] == "number" ? w[1] : _ + o;
          }
      }
      return O;
    }
  }
}
function TZe(t) {
  return Array.isArray(t) ? t : typeof t == "number" ? [EZe, t] : t == null ? _fe : [t];
}
function _Ze(t, e, n, r) {
  let a, i, o;
  typeof e == "function" && typeof n != "function" ? (i = void 0, o = e, a = n) : (i = e, o = n, a = r), wZe(t, i, s, a);
  function s(u, f) {
    const p = f[f.length - 1], m = p ? p.children.indexOf(u) : void 0;
    return o(u, m, p);
  }
}
const CZe = (t = {}) => {
  const { openDelimiter: e = "rehype:ignore:start", closeDelimiter: n = "rehype:ignore:end" } = t;
  return (r) => {
    _Ze(r, (a, i, o) => {
      if (a.type === "element" || a.type === "root") {
        let s = !1;
        a.children = a.children.filter((u) => {
          if (u.type === "raw" || u.type === "comment") {
            let f = (u.value || "").trim();
            if (f = f.replace(/^<!--(.*?)-->/, "$1"), f === e)
              return s = !0, !1;
            if (f === n)
              return s = !1, !1;
          }
          return !s;
        });
      }
    });
  };
}, xZe = CZe;
var AZe = {
  type: "element",
  tagName: "svg",
  properties: {
    className: "octicon octicon-link",
    viewBox: "0 0 16 16",
    version: "1.1",
    width: "16",
    height: "16",
    ariaHidden: "true"
  },
  children: [{
    type: "element",
    tagName: "path",
    children: [],
    properties: {
      fillRule: "evenodd",
      d: "M7.775 3.275a.75.75 0 001.06 1.06l1.25-1.25a2 2 0 112.83 2.83l-2.5 2.5a2 2 0 01-2.83 0 .75.75 0 00-1.06 1.06 3.5 3.5 0 004.95 0l2.5-2.5a3.5 3.5 0 00-4.95-4.95l-1.25 1.25zm-4.69 9.64a2 2 0 010-2.83l2.5-2.5a2 2 0 012.83 0 .75.75 0 001.06-1.06 3.5 3.5 0 00-4.95 0l-2.5 2.5a3.5 3.5 0 004.95 4.95l1.25-1.25a.75.75 0 00-1.06-1.06l-1.25 1.25a2 2 0 01-2.83 0z"
    }
  }]
};
function kZe(t) {
  return t === void 0 && (t = ""), {
    type: "element",
    tagName: "div",
    properties: {
      class: "copied",
      "data-code": t
    },
    children: [{
      type: "element",
      tagName: "svg",
      properties: {
        className: "octicon-copy",
        ariaHidden: "true",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        height: 12,
        width: 12
      },
      children: [{
        type: "element",
        tagName: "path",
        properties: {
          fillRule: "evenodd",
          d: "M0 6.75C0 5.784.784 5 1.75 5h1.5a.75.75 0 010 1.5h-1.5a.25.25 0 00-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 00.25-.25v-1.5a.75.75 0 011.5 0v1.5A1.75 1.75 0 019.25 16h-7.5A1.75 1.75 0 010 14.25v-7.5z"
        },
        children: []
      }, {
        type: "element",
        tagName: "path",
        properties: {
          fillRule: "evenodd",
          d: "M5 1.75C5 .784 5.784 0 6.75 0h7.5C15.216 0 16 .784 16 1.75v7.5A1.75 1.75 0 0114.25 11h-7.5A1.75 1.75 0 015 9.25v-7.5zm1.75-.25a.25.25 0 00-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 00.25-.25v-7.5a.25.25 0 00-.25-.25h-7.5z"
        },
        children: []
      }]
    }, {
      type: "element",
      tagName: "svg",
      properties: {
        className: "octicon-check",
        ariaHidden: "true",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        height: 12,
        width: 12
      },
      children: [{
        type: "element",
        tagName: "path",
        properties: {
          fillRule: "evenodd",
          d: "M13.78 4.22a.75.75 0 010 1.06l-7.25 7.25a.75.75 0 01-1.06 0L2.22 9.28a.75.75 0 011.06-1.06L6 10.94l6.72-6.72a.75.75 0 011.06 0z"
        },
        children: []
      }]
    }]
  };
}
var RZe = (t, e) => (n, r, a) => {
  if (n.type === "element" && a && a.type === "root" && /h(1|2|3|4|5|6)/.test(n.tagName)) {
    var i = n.children && n.children[0];
    i && i.properties && i.properties.ariaHidden === "true" && (i.properties = rn({
      class: "anchor"
    }, i.properties), i.children = [AZe]);
  }
  if (n.type === "element" && n.tagName === "pre" && !t) {
    var o = mue(n.children);
    n.children.push(kZe(o));
  }
  e && e(n, r === null ? void 0 : r, a === null ? void 0 : a);
}, IZe = [eZe, mZe, xZe];
const Cfe = /* @__PURE__ */ Ge.forwardRef((t, e) => {
  var n, r = [FYe, fce, $Ye, ...IZe, [D6e, {
    rewrite: RZe((n = t.disableCopy) != null ? n : !1, t.rehypeRewrite)
  }], [G6e, {
    properties: "attr"
  }], ...t.rehypePlugins || [], [q5e, {
    ignoreMissing: !0
  }]];
  return /* @__PURE__ */ Ne.jsx(xYe, rn({}, t, {
    rehypePlugins: r,
    ref: e
  }));
});
var DZe = {
  name: "bold",
  keyCommand: "bold",
  button: {
    "aria-label": "Add bold text"
  },
  icon: /* @__PURE__ */ Ne.jsx("svg", {
    width: "13",
    height: "13",
    viewBox: "0 0 384 512",
    children: /* @__PURE__ */ Ne.jsx("path", {
      fill: "currentColor",
      d: "M304.793 243.891c33.639-18.537 53.657-54.16 53.657-95.693 0-48.236-26.25-87.626-68.626-104.179C265.138 34.01 240.849 32 209.661 32H24c-8.837 0-16 7.163-16 16v33.049c0 8.837 7.163 16 16 16h33.113v318.53H24c-8.837 0-16 7.163-16 16V464c0 8.837 7.163 16 16 16h195.69c24.203 0 44.834-1.289 66.866-7.584C337.52 457.193 376 410.647 376 350.014c0-52.168-26.573-91.684-71.207-106.123zM142.217 100.809h67.444c16.294 0 27.536 2.019 37.525 6.717 15.828 8.479 24.906 26.502 24.906 49.446 0 35.029-20.32 56.79-53.029 56.79h-76.846V100.809zm112.642 305.475c-10.14 4.056-22.677 4.907-31.409 4.907h-81.233V281.943h84.367c39.645 0 63.057 25.38 63.057 63.057.001 28.425-13.66 52.483-34.782 61.284z"
    })
  }),
  execute: (t) => {
    var {
      state: e,
      view: n
    } = t;
    !e || !n || n.dispatch(n.state.changeByRange((r) => ({
      changes: [{
        from: r.from,
        insert: "**"
      }, {
        from: r.to,
        insert: "**"
      }],
      range: ft.range(r.from + 2, r.to + 2)
    })));
  }
}, NZe = {
  name: "code",
  keyCommand: "code",
  button: {
    "aria-label": "Insert code"
  },
  icon: /* @__PURE__ */ Ne.jsxs("svg", {
    viewBox: "0 0 48 48",
    fill: "none",
    height: "15",
    width: "15",
    children: [/* @__PURE__ */ Ne.jsx("path", {
      d: "M16 13 4 25.432 16 37m16-24 12 12.432L32 37",
      stroke: "currentColor",
      strokeWidth: "5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ Ne.jsx("path", {
      d: "m28 4-7 40",
      stroke: "currentColor",
      strokeWidth: "5",
      strokeLinecap: "round"
    })]
  }),
  execute: (t) => {
    var {
      state: e,
      view: n
    } = t;
    !e || !n || n.dispatch(n.state.changeByRange((r) => ({
      changes: [{
        from: r.from,
        insert: "`"
      }, {
        from: r.to,
        insert: "`"
      }],
      range: ft.range(r.from + 1, r.to + 1)
    })));
  }
}, PZe = {
  name: "codeBlock",
  keyCommand: "codeBlock",
  button: {
    "aria-label": "Insert Code Block"
  },
  icon: /* @__PURE__ */ Ne.jsxs("svg", {
    viewBox: "0 0 48 48",
    fill: "none",
    height: "15",
    width: "15",
    children: [/* @__PURE__ */ Ne.jsx("path", {
      d: "M21 6H9a3 3 0 0 0-3 3v22a3 3 0 0 0 3 3h30a3 3 0 0 0 3-3V21M24 34v8",
      stroke: "currentColor",
      strokeWidth: "5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ Ne.jsx("path", {
      d: "m32 6-4 4 4 4m6-8 4 4-4 4M14 42h20",
      stroke: "currentColor",
      strokeWidth: "5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }),
  execute: (t) => {
    var {
      state: e,
      view: n
    } = t;
    if (!(!e || !n)) {
      var r = n.state.selection.main, a = n.state.sliceDoc(n.state.selection.main.from, n.state.selection.main.to);
      n.dispatch({
        changes: {
          from: r.from,
          to: r.to,
          insert: "```js\n" + a + "\n```"
        },
        selection: ft.range(r.from + 3, r.from + 5)
      });
    }
  }
}, LZe = {
  name: "italic",
  keyCommand: "italic",
  button: {
    "aria-label": "Add italic text"
  },
  icon: /* @__PURE__ */ Ne.jsx("svg", {
    width: "13",
    height: "13",
    viewBox: "0 0 320 512",
    children: /* @__PURE__ */ Ne.jsx("path", {
      fill: "currentColor",
      d: "M204.758 416h-33.849l62.092-320h40.725a16 16 0 0 0 15.704-12.937l6.242-32C297.599 41.184 290.034 32 279.968 32H120.235a16 16 0 0 0-15.704 12.937l-6.242 32C96.362 86.816 103.927 96 113.993 96h33.846l-62.09 320H46.278a16 16 0 0 0-15.704 12.935l-6.245 32C22.402 470.815 29.967 480 40.034 480h158.479a16 16 0 0 0 15.704-12.935l6.245-32c1.927-9.88-5.638-19.065-15.704-19.065z"
    })
  }),
  execute: (t) => {
    var {
      state: e,
      view: n
    } = t;
    !e || !n || n.dispatch(n.state.changeByRange((r) => ({
      changes: [{
        from: r.from,
        insert: "*"
      }, {
        from: r.to,
        insert: "*"
      }],
      range: ft.range(r.from + 1, r.to + 1)
    })));
  }
}, MZe = {
  name: "header",
  keyCommand: "header",
  button: {
    "aria-label": "Add header text"
  },
  icon: /* @__PURE__ */ Ne.jsx("svg", {
    fill: "currentColor",
    viewBox: "0 0 448 512",
    height: "13",
    width: "13",
    children: /* @__PURE__ */ Ne.jsx("path", {
      d: "M448 448c0 17.69-14.33 32-32 32h-96c-17.67 0-32-14.31-32-32s14.33-32 32-32h16V272H112v144h16c17.67 0 32 14.31 32 32s-14.33 32-32 32H32c-17.67 0-32-14.31-32-32s14.33-32 32-32h16V96H32C14.33 96 0 81.69 0 64s14.33-32 32-32h96c17.67 0 32 14.31 32 32s-14.33 32-32 32h-16v112h224V96h-16c-17.67 0-32-14.31-32-32s14.33-32 32-32h96c17.67 0 32 14.31 32 32s-14.33 32-32 32h-16v320h16c17.7 0 32 14.3 32 32z"
    })
  }),
  execute: (t) => {
    var {
      state: e,
      view: n
    } = t;
    if (!(!e || !n)) {
      var r = n.state.doc.lineAt(n.state.selection.main.from), a = "#", i = r.text.match(/^#+/);
      if (i && i[0]) {
        var o = i[0];
        o.length < 6 && (a = o + "#");
      }
      a.length > 6 && (a = "#");
      var s = r.text.replace(/^#+/, "");
      n.dispatch({
        changes: {
          from: r.from,
          to: r.to,
          insert: a + " " + s
        },
        // selection: EditorSelection.range(lineInfo.from + mark.length, lineInfo.to),
        selection: {
          anchor: r.from + a.length + 1
        }
      });
    }
  }
}, FZe = {
  name: "strike",
  keyCommand: "strike",
  button: {
    "aria-label": "Add strike text"
  },
  icon: /* @__PURE__ */ Ne.jsx("svg", {
    fill: "currentColor",
    viewBox: "0 0 512 512",
    height: "14",
    width: "14",
    children: /* @__PURE__ */ Ne.jsx("path", {
      d: "M332.2 319.9c17.22 12.17 22.33 26.51 18.61 48.21-3.031 17.59-10.88 29.34-24.72 36.99-35.44 19.75-108.5 11.96-186-19.68-16.34-6.686-35.03 1.156-41.72 17.53s1.188 35.05 17.53 41.71c31.75 12.93 95.69 35.37 157.6 35.37 29.62 0 58.81-5.156 83.72-18.96 30.81-17.09 50.44-45.46 56.72-82.11 3.998-23.27 2.168-42.58-3.488-59.05H332.2zm155.8-80-176.5-.03c-15.85-5.614-31.83-10.34-46.7-14.62-85.47-24.62-110.9-39.05-103.7-81.33 2.5-14.53 10.16-25.96 22.72-34.03 20.47-13.15 64.06-23.84 155.4.343 17.09 4.53 34.59-5.654 39.13-22.74 4.531-17.09-5.656-34.59-22.75-39.12-91.31-24.18-160.7-21.62-206.3 7.654C121.8 73.72 103.6 101.1 98.09 133.1c-8.83 51.4 9.81 84.2 39.11 106.8H24c-13.25 0-24 10.75-24 23.1 0 13.25 10.75 23.1 24 23.1h464c13.25 0 24-10.75 24-23.1 0-12.3-10.7-23.1-24-23.1z"
    })
  }),
  execute: (t) => {
    var {
      state: e,
      view: n
    } = t;
    !e || !n || n.dispatch(n.state.changeByRange((r) => ({
      changes: [{
        from: r.from,
        insert: "~~"
      }, {
        from: r.to,
        insert: "~~"
      }],
      range: ft.range(r.from + 2, r.to + 2)
    })));
  }
}, $Ze = {
  name: "underline",
  keyCommand: "underline",
  button: {
    "aria-label": "Add underline text"
  },
  icon: /* @__PURE__ */ Ne.jsx("svg", {
    fill: "currentColor",
    viewBox: "0 0 448 512",
    height: "13",
    width: "13",
    children: /* @__PURE__ */ Ne.jsx("path", {
      d: "M416 448H32c-17.69 0-32 14.31-32 32s14.31 32 32 32h384c17.69 0 32-14.31 32-32s-14.3-32-32-32zM48 64.01h16v160c0 88.22 71.78 159.1 160 159.1s160-71.78 160-159.1v-160h16c17.69 0 32-14.32 32-32S417.69.91 400 .91l-96-.005c-17.69 0-32 14.32-32 32s14.31 32 32 32h16v160c0 52.94-43.06 95.1-96 95.1S128 276.1 128 224V64h16c17.69 0 32-14.31 32-32S161.69 0 144 0L48 .005c-17.69 0-32 14.31-32 31.1S30.31 64.01 48 64.01z"
    })
  }),
  execute: (t) => {
    var {
      state: e,
      view: n
    } = t;
    !e || !n || n.dispatch(n.state.changeByRange((r) => ({
      changes: [{
        from: r.from,
        insert: "<u>"
      }, {
        from: r.to,
        insert: "</u>"
      }],
      range: ft.range(r.from + 3, r.to + 3)
    })));
  }
}, BZe = {
  name: "olist",
  keyCommand: "olist",
  button: {
    "aria-label": "Add olist text"
  },
  icon: /* @__PURE__ */ Ne.jsx("svg", {
    viewBox: "0 0 576 512",
    height: "14",
    width: "14",
    children: /* @__PURE__ */ Ne.jsx("path", {
      fill: "currentColor",
      d: "M55.1 56.04c0-13.26 11.64-24 24-24h32c14.2 0 24 10.74 24 24V176h16c14.2 0 24 10.8 24 24 0 13.3-9.8 24-24 24h-80c-12.36 0-24-10.7-24-24 0-13.2 11.64-24 24-24h16V80.04h-8c-12.36 0-24-10.75-24-24zm63.6 285.16c-6.6-7.4-18.3-6.9-24.05 1.2l-11.12 15.5c-7.7 10.8-22.69 13.3-33.48 5.6-10.79-7.7-13.28-22.7-5.58-33.4l11.12-15.6c23.74-33.3 72.31-35.7 99.21-4.9 21.3 23.5 20.8 60.9-1.1 84.7L118.8 432H152c13.3 0 24 10.7 24 24s-10.7 24-24 24H64c-9.53 0-18.16-5.6-21.98-14.4-3.83-8.7-2.12-18.9 4.34-25.9l72.04-78c5.3-5.8 5.4-14.6.3-20.5zM512 64c17.7 0 32 14.33 32 32 0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32 0-17.67 14.3-32 32-32h256zm0 160c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32s14.3-32 32-32h256zm0 160c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32s14.3-32 32-32h256z"
    })
  }),
  execute: (t) => {
    var {
      state: e,
      view: n
    } = t;
    if (!(!e || !n)) {
      var r = n.state.doc.lineAt(n.state.selection.main.from), a = "1. ", i = r.text.match(/^\1\./);
      i && i[0] && (a = ""), n.dispatch({
        changes: {
          from: r.from,
          to: r.to,
          insert: "" + a + r.text
        },
        // selection: EditorSelection.range(lineInfo.from + mark.length, lineInfo.to),
        selection: {
          anchor: n.state.selection.main.from + a.length
        }
      });
    }
  }
}, UZe = {
  name: "ulist",
  keyCommand: "ulist",
  button: {
    "aria-label": "Add ulist text"
  },
  icon: /* @__PURE__ */ Ne.jsx("svg", {
    viewBox: "0 0 512 512",
    height: "14",
    width: "14",
    children: /* @__PURE__ */ Ne.jsx("path", {
      fill: "currentColor",
      d: "M88 48c13.3 0 24 10.75 24 24v48c0 13.3-10.7 24-24 24H40c-13.25 0-24-10.7-24-24V72c0-13.25 10.75-24 24-24h48zm392 16c17.7 0 32 14.33 32 32 0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32 0-17.67 14.3-32 32-32h288zm0 160c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32h288zm0 160c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32h288zM16 232c0-13.3 10.75-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H40c-13.25 0-24-10.7-24-24v-48zm72 136c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H40c-13.25 0-24-10.7-24-24v-48c0-13.3 10.75-24 24-24h48z"
    })
  }),
  execute: (t) => {
    var {
      state: e,
      view: n
    } = t;
    if (!(!e || !n)) {
      var r = n.state.doc.lineAt(n.state.selection.main.from), a = "- ", i = r.text.match(/^-/);
      i && i[0] && (a = ""), n.dispatch({
        changes: {
          from: r.from,
          to: r.to,
          insert: "" + a + r.text
        },
        // selection: EditorSelection.range(lineInfo.from + mark.length, lineInfo.to),
        selection: {
          anchor: n.state.selection.main.from + a.length
        }
      });
    }
  }
}, zZe = {
  name: "quote",
  keyCommand: "quote",
  button: {
    "aria-label": "Add quote text"
  },
  icon: /* @__PURE__ */ Ne.jsx("svg", {
    fill: "currentColor",
    viewBox: "0 0 448 512",
    height: "15",
    width: "15",
    children: /* @__PURE__ */ Ne.jsx("path", {
      d: "M96 96c-53.02 0-96 42.1-96 96s42.98 96 96 96c11.28 0 21.95-2.305 32-5.879V288c0 35.3-28.7 64-64 64-17.67 0-32 14.33-32 32s14.33 32 32 32c70.58 0 128-57.42 128-128v-96c0-53.9-43-96-96-96zm352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96 42.98 96 96 96c11.28 0 21.95-2.305 32-5.879V288c0 35.3-28.7 64-64 64-17.67 0-32 14.33-32 32s14.33 32 32 32c70.58 0 128-57.42 128-128v-96z"
    })
  }),
  execute: (t) => {
    var {
      state: e,
      view: n
    } = t;
    if (!(!e || !n)) {
      var r = n.state.doc.lineAt(n.state.selection.main.from), a = "> ", i = r.text.match(/^>\s/);
      i && i[0] && (a = ""), n.dispatch({
        changes: {
          from: r.from,
          to: r.to,
          insert: "" + a + r.text
        },
        // selection: EditorSelection.range(lineInfo.from + mark.length, lineInfo.to),
        selection: {
          anchor: n.state.selection.main.from + a.length
        }
      });
    }
  }
}, HZe = {
  name: "link",
  keyCommand: "link",
  button: {
    "aria-label": "Add link text"
  },
  icon: /* @__PURE__ */ Ne.jsx("svg", {
    fill: "currentColor",
    viewBox: "0 0 640 512",
    height: "16",
    width: "16",
    children: /* @__PURE__ */ Ne.jsx("path", {
      d: "M172.5 131.1c55.6-55.59 148-55.59 203.6 0 50 50 57.4 129.7 16.3 187.2l-1.1 1.6c-10.3 14.3-30.3 17.7-44.6 7.4-14.4-10.3-17.8-30.3-7.5-44.6l1.1-1.6c22.9-32.1 19.3-76-8.6-103.9-31.4-31.4-82.5-31.4-114 0L105.5 289.5c-31.51 30.6-31.51 82.5 0 114 27.8 27.9 71.8 31.5 103.8 8.6l1.6-2c14.4-9.4 34.4-6.1 44.6 8.3 10.3 14.4 7 34.4-7.4 44.7l-1.6 1.1c-58.4 41.1-136.3 34.5-186.29-15.4-56.469-56.5-56.469-148.1 0-204.5L172.5 131.1zm295 248.9c-56.5 56.5-148 56.5-204.5 0-50-50-56.5-128.8-15.4-186.3l1.1-1.6c9.4-14.3 29.4-17.7 44.6-7.4 14.4 9.4 17.8 29.4 7.5 44.6l-1.1 1.6c-22.9 31.2-19.3 76 8.6 103.9 31.4 31.4 82.5 31.4 114 0l112.2-112.3c31.5-31.5 31.5-83.4 0-114-27.8-27.87-71.8-31.51-103.8-8.6l-1.6 1.1c-14.4 10.3-34.4 6.1-44.6-7.42-10.3-14.38-7-34.37 7.4-44.64l1.6-1.12C451 6.731 529.8 13.25 579.8 63.24c56.5 56.46 56.5 148.06 0 204.46L467.5 380z"
    })
  }),
  execute: (t) => {
    var {
      state: e,
      view: n
    } = t;
    if (!(!e || !n) && !(!e || !n)) {
      var r = n.state.selection.main, a = n.state.sliceDoc(n.state.selection.main.from, n.state.selection.main.to);
      n.dispatch({
        changes: {
          from: r.from,
          to: r.to,
          insert: "[" + a + "]()"
        },
        selection: ft.range(r.from + 3 + a.length, r.to + 3)
        // selection: { anchor: main.from + 4 },
      });
    }
  }
}, WZe = {
  name: "todo",
  keyCommand: "todo",
  button: {
    "aria-label": "Add todo List"
  },
  icon: /* @__PURE__ */ Ne.jsx("svg", {
    viewBox: "0 0 48 48",
    fill: "none",
    height: "15",
    width: "15",
    children: /* @__PURE__ */ Ne.jsx("path", {
      d: "m5 10 3 3 6-6M5 24l3 3 6-6M5 38l3 3 6-6m7-11h22M21 38h22M21 10h22",
      stroke: "currentColor",
      strokeWidth: "5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  }),
  execute: (t) => {
    var {
      state: e,
      view: n
    } = t;
    if (!(!e || !n)) {
      var r = n.state.doc.lineAt(n.state.selection.main.from), a = "- [ ]  ", i = r.text.match(/^-\s\[\s\]\s/);
      i && i[0] && (a = ""), n.dispatch({
        changes: {
          from: r.from,
          to: r.to,
          insert: "" + a + r.text
        },
        // selection: EditorSelection.range(lineInfo.from + mark.length, lineInfo.to),
        selection: {
          anchor: n.state.selection.main.from + a.length
        }
      });
    }
  }
}, QZe = {
  name: "image",
  keyCommand: "image",
  button: {
    "aria-label": "Add image text"
  },
  icon: /* @__PURE__ */ Ne.jsx("svg", {
    fill: "currentColor",
    viewBox: "0 0 16 16",
    height: "14",
    width: "14",
    children: /* @__PURE__ */ Ne.jsx("path", {
      fillRule: "evenodd",
      d: "M1.75 2.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h.94a.76.76 0 0 1 .03-.03l6.077-6.078a1.75 1.75 0 0 1 2.412-.06L14.5 10.31V2.75a.25.25 0 0 0-.25-.25H1.75zm12.5 11H4.81l5.048-5.047a.25.25 0 0 1 .344-.009l4.298 3.889v.917a.25.25 0 0 1-.25.25zm1.75-.25V2.75A1.75 1.75 0 0 0 14.25 1H1.75A1.75 1.75 0 0 0 0 2.75v10.5C0 14.216.784 15 1.75 15h12.5A1.75 1.75 0 0 0 16 13.25zM5.5 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zM7 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"
    })
  }),
  execute: (t) => {
    var {
      state: e,
      view: n
    } = t;
    if (!(!e || !n)) {
      var r = n.state.selection.main, a = n.state.sliceDoc(n.state.selection.main.from, n.state.selection.main.to);
      n.dispatch({
        changes: {
          from: r.from,
          to: r.to,
          insert: "![](" + a + ")"
        },
        selection: ft.range(r.from + 4, r.to + 4)
        // selection: { anchor: main.from + 4 },
      });
    }
  }
}, jZe = {
  name: "redo",
  keyCommand: "redo",
  button: {
    "aria-label": "redo text"
  },
  icon: /* @__PURE__ */ Ne.jsx("svg", {
    viewBox: "0 0 512 512",
    height: "14",
    width: "14",
    children: /* @__PURE__ */ Ne.jsx("path", {
      fill: "currentColor",
      d: "M58.79,439.13A16,16,0,0,1,48,424c0-73.1,14.68-131.56,43.65-173.77,35-51,90.21-78.46,164.35-81.87V88a16,16,0,0,1,27.05-11.57l176,168a16,16,0,0,1,0,23.14l-176,168A16,16,0,0,1,256,424V344.23c-45,1.36-79,8.65-106.07,22.64-29.25,15.12-50.46,37.71-73.32,67a16,16,0,0,1-17.82,5.28Z"
    })
  }),
  execute: (t) => {
    var {
      state: e,
      view: n
    } = t;
    !e || !n || SI(n);
  }
}, GZe = {
  name: "undo",
  keyCommand: "undo",
  button: {
    "aria-label": "undo text"
  },
  icon: /* @__PURE__ */ Ne.jsx("svg", {
    viewBox: "0 0 512 512",
    height: "14",
    width: "14",
    children: /* @__PURE__ */ Ne.jsx("path", {
      fill: "currentColor",
      d: "M448,440a16,16,0,0,1-12.61-6.15c-22.86-29.27-44.07-51.86-73.32-67C335,352.88,301,345.59,256,344.23V424A16,16,0,0,1,229,435.57l-176-168a16,16,0,0,1,0-23.14l176-168A16,16,0,0,1,256,88v80.36c74.14,3.41,129.38,30.91,164.35,81.87C449.32,292.44,464,350.9,464,424a16,16,0,0,1-16,16Z"
    })
  }),
  execute: (t) => {
    var {
      state: e,
      view: n
    } = t;
    !e || !n || k6(n);
  }
}, VZe = ["editorProps", "command", "onClick"], YZe = (t) => {
  var {
    editorProps: e,
    command: n,
    onClick: r
  } = t, a = qb(t, VZe), i = dr(0), [o, s] = kn(!1), u = dr(o), f = (v) => {
    var O;
    for (var w of v) {
      var _;
      i.current || (i.current = w.target.clientHeight), (_ = e.editor) != null && (_ = _.current) != null && (_ = _.view) != null && _.dom && (u.current ? e.editor.current.view.dom.style.height = w.target.clientHeight + "px" : e.editor.current.view.dom.removeAttribute("style"));
    }
    (O = p.current) == null || O.disconnect(), p.current = void 0;
  }, p = dr(new ResizeObserver(f));
  Vn(() => {
    if (p.current || (p.current = new ResizeObserver(f)), e.containerEditor && e.containerEditor.current && e.containerEditor.current.parentElement && p.current) {
      var v = e.containerEditor.current.parentElement;
      p.current.observe(v);
    }
    return () => {
      p.current && (p.current.disconnect(), p.current = void 0);
    };
  }, [e.containerEditor, f, e.editor, o, p]), Vn(() => {
    if (document && e && e.container && e.container.current && e.editor) {
      var v = e.container.current;
      document.body.style.overflow = o ? "hidden" : "initial", o ? document.body.classList.add(e.prefixCls + "-fullscreen") : document.body.classList.remove(e.prefixCls + "-fullscreen"), v && o ? (v.style.zIndex = "999", v.style.position = "fixed", v.style.top = "0px", v.style.bottom = "0px", v.style.left = "0px", v.style.right = "0px") : v && (v.style.position = "initial", v.style.top = "initial", v.style.bottom = "initial", v.style.left = "initial", v.style.right = "initial");
    }
  }, [o, e]);
  var m = (v) => {
    var O = !o;
    u.current = O, s(O), r == null || r(v, O);
  };
  return /* @__PURE__ */ Ne.jsx("button", rn({}, a, {
    onClick: m,
    type: "button",
    className: o ? "active" : "",
    children: n.icon
  }));
}, xfe = {
  name: "fullscreen",
  keyCommand: "fullscreen",
  button: (t, e, n) => /* @__PURE__ */ Ne.jsx(YZe, {
    command: t,
    editorProps: rn({}, e, n)
  }),
  icon: /* @__PURE__ */ Ne.jsx("svg", {
    fill: "currentColor",
    viewBox: "0 0 448 512",
    height: "15",
    width: "15",
    children: /* @__PURE__ */ Ne.jsx("path", {
      d: "M128 32H32C14.31 32 0 46.31 0 64v96c0 17.69 14.31 32 32 32s32-14.31 32-32V96h64c17.69 0 32-14.31 32-32s-14.3-32-32-32zm288 0h-96c-17.69 0-32 14.31-32 32s14.31 32 32 32h64v64c0 17.69 14.31 32 32 32s32-14.31 32-32V64c0-17.69-14.3-32-32-32zM128 416H64v-64c0-17.69-14.31-32-32-32S0 334.31 0 352v96c0 17.69 14.31 32 32 32h96c17.69 0 32-14.31 32-32s-14.3-32-32-32zm288-96c-17.69 0-32 14.31-32 32v64h-64c-17.69 0-32 14.31-32 32s14.31 32 32 32h96c17.69 0 32-14.31 32-32v-96c0-17.7-14.3-32-32-32z"
    })
  })
}, ZZe = (t) => {
  var {
    editorProps: e
  } = t, {
    containerEditor: n,
    preview: r,
    previewWidth: a = "50%",
    enablePreview: i = !0
  } = e, [o, s] = kn(t.editorProps.visible);
  if (Vn(() => s(t.editorProps.visible), [t.editorProps.visible]), Vn(() => {
    if (r.current) {
      var f = r.current;
      r && (f.style.borderBottomRightRadius = "3px"), f && o ? (f.style.width = a, f.style.overflow = "auto", a !== "100%" && (f.style.borderLeft = "1px solid var(--color-border-muted)"), f.style.padding = "20px", n.current && (n.current.style.width = "calc(100% - " + a + ")")) : f && (f.style.width = "0%", f.style.overflow = "hidden", f.style.borderLeft = "0px", f.style.padding = "0", n.current && (n.current.style.width = "100%"));
    }
  }, [o, n, r, a]), !!i) {
    var u = () => {
      e.onPreviewMode && e.onPreviewMode(!o), s(!o);
    };
    return /* @__PURE__ */ Ne.jsx("button", {
      onClick: u,
      type: "button",
      className: o ? "active" : "",
      children: t.command.icon
    });
  }
}, Afe = {
  name: "preview",
  keyCommand: "preview",
  button: (t, e, n) => /* @__PURE__ */ Ne.jsx(ZZe, {
    command: t,
    editorProps: rn({}, e, n)
  }),
  icon: /* @__PURE__ */ Ne.jsx("svg", {
    fill: "currentColor",
    viewBox: "0 0 576 512",
    height: "16",
    width: "16",
    children: /* @__PURE__ */ Ne.jsx("path", {
      d: "M279.6 160.4c2.8-.3 5.6-.4 8.4-.4 53 0 96 42.1 96 96 0 53-43 96-96 96-53.9 0-96-43-96-96 0-2.8.1-5.6.4-8.4 9.3 4.5 20.1 8.4 31.6 8.4 35.3 0 64-28.7 64-64 0-11.5-3.9-22.3-8.4-31.6zm201-47.8c46.8 43.4 78.1 94.5 92.9 131.1 3.3 7.9 3.3 16.7 0 24.6-14.8 35.7-46.1 86.8-92.9 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.58-80.6C48.62 355.1 17.34 304 2.461 268.3a31.967 31.967 0 0 1 0-24.6C17.34 207.1 48.62 156 95.42 112.6 142.5 68.84 207.2 32 288 32c80.8 0 145.5 36.84 192.6 80.6zM288 112c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"
    })
  })
}, x5 = {
  undo: GZe,
  redo: jZe,
  bold: DZe,
  italic: LZe,
  header: MZe,
  strike: FZe,
  underline: $Ze,
  quote: zZe,
  olist: BZe,
  ulist: UZe,
  todo: WZe,
  link: HZe,
  image: QZe,
  code: NZe,
  codeBlock: PZe,
  fullscreen: xfe,
  preview: Afe
}, XZe = () => Object.keys(x5).filter((t) => !/^(fullscreen|preview)/.test(t)).map((t) => x5[t]), qZe = () => [Afe, xfe];
var KZe = ["prefixCls", "className", "onClick", "toolbars", "editor", "mode", "preview", "container", "containerEditor", "editorProps"];
function $ee(t) {
  var {
    prefixCls: e = "md-editor",
    className: n,
    toolbars: r = [],
    editor: a,
    mode: i,
    preview: o,
    container: s,
    containerEditor: u,
    editorProps: f = {}
  } = t, p = qb(t, KZe);
  if (!r || r.length === 0)
    return null;
  function m(v) {
    v && a && a && v(a.current);
  }
  return f.prefixCls = e, /* @__PURE__ */ Ne.jsx("div", rn({
    className: e + "-toolbar " + (n || "") + " " + (i ? e + "-toolbar-mode" : "")
  }, p, {
    children: [...r].map((v, O) => {
      var w = {
        type: "button"
      }, _ = typeof v == "string" ? x5[v] : v;
      if (!_)
        return null;
      if (w.children = _.icon, w.onClick = () => m(_.execute), _.button && typeof _.button == "object") {
        var C = _.button;
        Object.keys(C).forEach((A) => {
          w[A] = C[A];
        });
      } else if (typeof _.button == "function")
        return /* @__PURE__ */ Ge.cloneElement(_.button(_, f, {
          preview: o,
          container: s,
          containerEditor: u,
          editor: a,
          editorProps: f
        }), {
          key: O
        });
      return /* @__PURE__ */ fu("button", rn({}, w, {
        key: O
      }));
    })
  }));
}
var JZe = (t) => {
  var {
    theme: e,
    settings: n = {},
    styles: r = []
  } = t, a = {
    ".cm-gutters": {}
  }, i = {};
  n.background && (i.backgroundColor = n.background), n.backgroundImage && (i.backgroundImage = n.backgroundImage), n.foreground && (i.color = n.foreground), n.fontSize && (i.fontSize = n.fontSize), (n.background || n.foreground) && (a["&"] = i), n.fontFamily && (a["&.cm-editor .cm-scroller"] = {
    fontFamily: n.fontFamily
  }), n.gutterBackground && (a[".cm-gutters"].backgroundColor = n.gutterBackground), n.gutterForeground && (a[".cm-gutters"].color = n.gutterForeground), n.gutterBorder && (a[".cm-gutters"].borderRightColor = n.gutterBorder), n.caret && (a[".cm-content"] = {
    caretColor: n.caret
  }, a[".cm-cursor, .cm-dropCursor"] = {
    borderLeftColor: n.caret
  });
  var o = {};
  n.gutterActiveForeground && (o.color = n.gutterActiveForeground), n.lineHighlight && (a[".cm-activeLine"] = {
    backgroundColor: n.lineHighlight
  }, o.backgroundColor = n.lineHighlight), a[".cm-activeLineGutter"] = o, n.selection && (a["&.cm-focused .cm-selectionBackground, & .cm-line::selection, & .cm-selectionLayer .cm-selectionBackground, .cm-content ::selection"] = {
    background: n.selection + " !important"
  }), n.selectionMatch && (a["& .cm-selectionMatch"] = {
    backgroundColor: n.selectionMatch
  });
  var s = qt.theme(a, {
    dark: e === "dark"
  }), u = p1.define(r), f = [s, n6(u)];
  return f;
}, eXe = JZe({
  theme: "light",
  settings: {
    background: "var(--color-canvas-subtle)",
    foreground: "var(--color-fg-default)",
    caret: "var(--color-fg-default)",
    selection: "var(--color-border-default)",
    selectionMatch: "var(--color-border-muted)",
    lineHighlight: "var(--color-neutral-muted)",
    gutterBackground: "var(--color-canvas-subtle)",
    gutterForeground: "var(--color-fg-muted)",
    gutterBorder: "var(--color-border-muted)"
  },
  styles: [{
    tag: ge.comment,
    color: "var(--color-prettylights-syntax-comment)"
  }, {
    tag: ge.variableName,
    color: "var(--color-prettylights-syntax-variable)"
  }, {
    tag: [ge.string, ge.special(ge.brace)],
    color: "var(--color-prettylights-syntax-entity)"
  }, {
    tag: ge.number,
    color: "var(--color-prettylights-syntax-variable)"
  }, {
    tag: [ge.bool, ge.null],
    color: "var(--color-prettylights-syntax-entity)"
  }, {
    tag: ge.keyword,
    color: "var(--color-prettylights-syntax-keyword)",
    fontWeight: "bold"
  }, {
    tag: ge.string,
    color: "var(--color-prettylights-syntax-string)"
  }, {
    tag: ge.operator,
    color: "var(--color-accent-emphasis)"
  }, {
    tag: ge.deleted,
    color: "var(--color-prettylights-syntax-markup-deleted-bg)"
  }, {
    tag: ge.deleted,
    color: "red"
  }, {
    tag: ge.className,
    color: "var(--color-prettylights-syntax-variable)"
  }, {
    tag: ge.definition(ge.typeName),
    color: "var(--color-prettylights-syntax-entity)"
  }, {
    tag: ge.typeName,
    color: "var(--color-prettylights-syntax-entity)"
  }, {
    tag: ge.list,
    color: "var(--color-prettylights-syntax-markup-list)"
  }, {
    tag: ge.heading,
    color: "var(--color-prettylights-syntax-markup-heading)",
    fontWeight: "bold"
  }, {
    tag: ge.regexp,
    color: "var(--color-prettylights-syntax-string-regexp)"
  }, {
    tag: ge.literal,
    color: "var(--color-prettylights-syntax-markup-italic)"
  }, {
    tag: ge.link,
    color: "var(--color-prettylights-syntax-constant-other-reference-link)",
    textDecoration: "underline"
  }, {
    tag: ge.angleBracket,
    color: "var(--color-fg-default)"
  }, {
    tag: ge.tagName,
    color: "var(--color-prettylights-syntax-entity-tag)"
  }, {
    tag: ge.attributeName,
    color: "var(--color-prettylights-syntax-constant)"
  }]
});
var tXe = ["prefixCls", "className", "onChange", "toolbars", "toolbarsMode", "toolbarsFilter", "visible", "renderPreview", "visibleEditor", "hideToolbar", "showToolbar", "toolbarBottom", "enableScroll", "enablePreview", "previewProps", "extensions", "previewWidth", "reExtensions", "onPreviewMode"], nXe = qt.theme({
  "&.cm-editor, & .cm-scroller": {
    borderBottomRightRadius: "3px",
    borderBottomLeftRadius: "3px"
  }
}), kfe = /* @__PURE__ */ Ge.forwardRef(rXe);
kfe.Markdown = Cfe;
function rXe(t, e) {
  var {
    prefixCls: n = "md-editor",
    className: r,
    onChange: a,
    toolbars: i = XZe(),
    toolbarsMode: o = qZe(),
    toolbarsFilter: s,
    visible: u = !0,
    renderPreview: f,
    visibleEditor: p = !0,
    hideToolbar: m,
    showToolbar: v = !0,
    toolbarBottom: O = !1,
    enableScroll: w = !0,
    enablePreview: _ = !0,
    previewProps: C = {},
    extensions: A = [],
    previewWidth: N = "50%",
    reExtensions: P
  } = t, I = qb(t, tXe), [D, M] = kn(t.value || ""), H = dr(null), Y = dr(null), q = dr(null), Q = dr(null), ne = dr("editor");
  Nl(e, () => ({
    editor: H,
    preview: Q
  }), [H]);
  var J = {
    prefixCls: n,
    preview: Q,
    editor: H,
    container: Y,
    containerEditor: q,
    editorProps: rn({}, t, {
      previewWidth: N
    })
  }, ue = typeof I.height == "number" ? I.height + "px" : I.height, ee = t.value;
  Vn(() => M(ee ?? ""), [ee]);
  var fe = Ei((Te) => {
    if (w) {
      var je = Te.target, we = je.scrollTop / je.scrollHeight;
      if (ne.current === "editor" && Q.current) {
        var lt, st = ((lt = Q.current) == null ? void 0 : lt.scrollHeight) || 0;
        Q.current.scrollTop = st * we;
      } else if (H.current && H.current.view) {
        var Oe = H.current.view.scrollDOM, Re = H.current.view.scrollDOM.scrollHeight || 0;
        Oe.scrollTop = Re * we;
      }
    }
  }, [w]), de = () => ne.current = "preview", ie = () => ne.current = "editor";
  Vn(() => {
    var Te = Q.current;
    return Te && w && (Te.addEventListener("mouseover", de, !1), Te.addEventListener("mouseleave", ie, !1), Te.addEventListener("scroll", fe, !1)), () => {
      Te && w && (Te.removeEventListener("mouseover", de), Te.removeEventListener("mouseleave", de), Te.addEventListener("mouseleave", fe, !1));
    };
  }, [Q, w, fe]);
  var le = N$e({
    scroll: fe
  }), ye = P || [Wse({
    base: CD,
    codeLanguages: I$e
  }), nXe, ...A];
  w && ye.push(le);
  var B = n + "-preview", pe = [n, "wmde-markdown-var", r].filter(Boolean).join(" ");
  C.source = D;
  var _e = (Te, je) => {
    M(Te), a && a(Te, je);
  }, Z = /* @__PURE__ */ Ne.jsxs("div", {
    className: n + "-content",
    style: {
      height: I.height
    },
    children: [/* @__PURE__ */ Ne.jsx("div", {
      className: n + "-content-editor",
      ref: q,
      children: p && /* @__PURE__ */ Ne.jsx(Mle, rn({
        theme: eXe
      }, I, {
        className: n + "-inner",
        extensions: ye,
        height: ue,
        ref: H,
        onChange: _e
      }))
    }), _ && /* @__PURE__ */ Ne.jsx("div", {
      className: B,
      ref: Q,
      children: f ? f(C, !!u) : /* @__PURE__ */ Ne.jsx(Cfe, rn({}, C, {
        "data-visible": !!u
      }))
    })]
  }), ce = [n && n + "-toolbar-warp", n && O && n + "-toolbar-bottom"].filter(Boolean).join(" "), j = s ? i.filter(s) : i, K = s ? o.filter(s) : o, Ee = m ?? v, he = Ee && /* @__PURE__ */ Ne.jsxs("div", {
    className: ce,
    children: [/* @__PURE__ */ Ne.jsx($ee, rn({}, J, {
      toolbars: j
    })), /* @__PURE__ */ Ne.jsx($ee, rn({}, J, {
      toolbars: K,
      mode: !0
    }))]
  }), Ae = O ? /* @__PURE__ */ Ne.jsxs(r0, {
    children: [Z, he]
  }) : /* @__PURE__ */ Ne.jsxs(r0, {
    children: [he, Z]
  });
  return /* @__PURE__ */ Ne.jsx("div", {
    className: pe,
    ref: Y,
    children: Ae
  });
}
const aE = "byz-tip-icon", aXe = ({
  tippyProps: t,
  type: e = "info",
  theme: n = "dark",
  children: r,
  tip: a = r,
  tipMarkdown: i,
  className: o,
  onClick: s,
  tipTrigger: u = "hover",
  preventDefaultClickEvent: f = u === "click",
  tipLocation: p = (t == null ? void 0 : t.placement) ?? "bottom",
  tipDelay: m = 200,
  interactive: v,
  ...O
}) => {
  const w = u === "click" ? "click" : "mouseenter focus";
  function _(C) {
    f && (C.stopPropagation(), C.preventDefault());
  }
  return /* @__PURE__ */ Ne.jsx(
    r1,
    {
      ...t,
      theme: n,
      className: `${aE}__tip-note`,
      placement: p,
      maxWidth: "350px",
      content: a ?? /* @__PURE__ */ Ne.jsx(Ne.Fragment, { children: /* @__PURE__ */ Ne.jsx(
        kfe.Markdown,
        {
          className: pn(aE, o, {
            [`${aE}__markdown-note--${n}`]: n
          }),
          source: i
        }
      ) }),
      trigger: w,
      delay: m,
      offset: [0, 10],
      interactive: v,
      children: /* @__PURE__ */ Ne.jsx(
        "i",
        {
          className: pn(aE, o, {
            [`${aE}--${e}`]: e,
            [`${aE}--${e}-${n}`]: e && n
          }),
          ...O,
          onClick: _
        }
      )
    }
  );
};
aXe.displayName = "ByzzerTipIcon";
const yA = "byz-inline-select";
function iXe({
  className: t,
  value: e,
  options: n,
  name: r,
  onChange: a,
  ...i
}) {
  const o = n[0].value ?? n[0], [s, u] = kn(e ?? o), [f, p] = kn([]), [m, v] = kn(), [O, w] = kn(), _ = dr(null), C = (m == null ? void 0 : m.inlineDisplay) ?? (m == null ? void 0 : m.display);
  Vn(() => {
    const N = Bee(f, s);
    v(N);
  }, [s]), Vn(() => {
    const N = oXe(n), P = Bee(N, s);
    v(P), p(N);
  }, [n]), Vn(() => {
    u(e ?? o);
  }, [e]);
  function A(N) {
    const P = N.value ?? N;
    O == null || O.hide(), a ? a({
      name: r,
      value: P,
      option: N
    }) : u(P);
  }
  return /* @__PURE__ */ Ne.jsx(Ne.Fragment, { children: /* @__PURE__ */ Ne.jsx(
    r1,
    {
      placement: "bottom",
      interactive: !0,
      trigger: "click",
      reference: _,
      offset: [0, 0],
      arrow: !1,
      hideOnClick: !0,
      className: pn(`${yA}__tip`),
      appendTo: document.body,
      onShow: w,
      animation: !1,
      content: /* @__PURE__ */ Ne.jsx("div", { className: `${yA}__options`, children: f.map((N) => /* @__PURE__ */ Ne.jsx(
        "div",
        {
          className: `${yA}__option`,
          onClick: () => A(N),
          children: N.display
        },
        N.value ?? N
      )) }),
      children: /* @__PURE__ */ Ne.jsx("div", { className: pn(yA, t), ...i, children: C })
    }
  ) });
}
iXe.displayName = "ByzzerInlineSelect";
function oXe(t = []) {
  return t.map((e) => ({
    display: e.display ?? e,
    inlineDisplay: e.inlineDisplay ?? e.display ?? e,
    value: e.value ?? e
  }));
}
function Bee(t, e) {
  return t.find((n) => n.value === e) ?? t[0];
}
const sXe = "byz-tip-icon", lXe = ({
  type: t = "info",
  theme: e = "dark",
  children: n,
  tip: r = n,
  className: a,
  onClick: i,
  tipTrigger: o = "hover",
  preventDefaultClickEvent: s = o === "click",
  tipLocation: u = "bottom",
  tipDelay: f = 200,
  disabled: p,
  ...m
}) => {
  const v = o === "click" ? "click" : "mouseenter focus";
  return /* @__PURE__ */ Ne.jsx(
    r1,
    {
      theme: e,
      className: `${sXe}__tip-note`,
      placement: u,
      content: r,
      trigger: v,
      delay: f,
      offset: [0, 10],
      disabled: p,
      children: /* @__PURE__ */ Ne.jsx("div", { children: n })
    }
  );
};
lXe.displayName = "ByzzerMessagePopUp";
const SN = Ge.createContext(void 0);
SN.displayName = "ByzzerRadioGroupContext";
function uXe() {
  return Ge.useContext(SN) ?? { setValue: () => {
  } };
}
function HXe({
  value: t,
  children: e
}) {
  return /* @__PURE__ */ Ne.jsx(SN.Provider, { value: t, children: e });
}
const Nb = "byz-radio";
function cXe({
  onChange: t,
  name: e,
  checked: n,
  className: r,
  disabled: a,
  value: i,
  labelPlacement: o = "right",
  children: s,
  label: u = s,
  radioRef: f,
  ...p
}) {
  const { value: m, setValue: v } = uXe(), [O, w] = kn(n ?? !1);
  dr(Vee()), Vn(() => {
    w(n ?? !1);
  }, [n]), Vn(() => {
    m !== void 0 && w(m === i);
  }, [m]);
  function _(C) {
    C.target.checked && v(i), t ? t({
      value: i,
      name: e,
      sourceEvent: C,
      checked: C.target.checked
    }) : w(C.target.checked);
  }
  return Nl(f, () => ({
    value: i,
    checked: O
  }), [O]), /* @__PURE__ */ Ne.jsxs("label", { className: pn(Nb, r, {
    [`${Nb}--label-${o}`]: o,
    [`${Nb}--disabled`]: a
  }), ...p, children: [
    /* @__PURE__ */ Ne.jsx(
      "input",
      {
        type: "radio",
        onChange: _,
        checked: O,
        className: `${Nb}__input`,
        disabled: a,
        value: i
      }
    ),
    /* @__PURE__ */ Ne.jsx("div", { className: pn(`${Nb}__toggle`, {
      [`${Nb}__toggle--disabled`]: a
    }) }),
    u !== void 0 && /* @__PURE__ */ Ne.jsx("div", { className: pn(`${Nb}__label`, {
      [`${Nb}__label--disabled`]: a
    }), children: u })
  ] });
}
cXe.displayName = "ByzzerRadio";
function fXe({
  children: t,
  onChange: e,
  name: n,
  value: r
}) {
  const [a, i] = kn({
    value: r,
    setValue(o) {
      e == null || e({
        name: n,
        value: o
      }), i((s) => ({
        ...s,
        value: o
      }));
    }
  });
  return Vn(() => {
    i((o) => ({
      ...o,
      value: r
    }));
  }, [r]), /* @__PURE__ */ Ne.jsx(SN.Provider, { value: a, children: t });
}
fXe.displayName = "ByzzerRadioGroup";
const Uee = "byz-popup";
function dXe({
  className: t,
  name: e,
  content: n,
  linkText: r,
  showPopup: a,
  ...i
}) {
  const [o, s] = kn(), u = dr(null);
  return /* @__PURE__ */ Ne.jsx(Ne.Fragment, { children: /* @__PURE__ */ Ne.jsx(
    r1,
    {
      placement: "auto",
      interactive: !1,
      trigger: "click",
      reference: u,
      offset: [0, 0],
      arrow: !1,
      hideOnClick: !0,
      allowHTML: !0,
      className: pn(`${Uee}__tip`),
      appendTo: document.body,
      onShow: s,
      animation: !1,
      content: n,
      visible: a,
      children: /* @__PURE__ */ Ne.jsx("div", { className: pn(Uee, t), ...i, children: r })
    }
  ) });
}
dXe.displayName = "ByzzerPopup";
var Rfe = { exports: {} };
/*!
 * Signature Pad v2.3.2
 * https://github.com/szimek/signature_pad
 *
 * Copyright 2017 Szymon Nowak
 * Released under the MIT license
 *
 * The main idea and some parts of the code (e.g. drawing variable width Bézier curve) are taken from:
 * http://corner.squareup.com/2012/07/smoother-signatures.html
 *
 * Implementation of interpolation using cubic Bézier curves is taken from:
 * http://benknowscode.wordpress.com/2012/09/14/path-interpolation-using-cubic-bezier-and-control-point-estimation-in-javascript
 *
 * Algorithm for approximated length of a Bézier curve is taken from:
 * http://www.lemoda.net/maths/bezier-length/index.html
 *
 */
function E0(t, e, n) {
  this.x = t, this.y = e, this.time = n || (/* @__PURE__ */ new Date()).getTime();
}
E0.prototype.velocityFrom = function(t) {
  return this.time !== t.time ? this.distanceTo(t) / (this.time - t.time) : 1;
};
E0.prototype.distanceTo = function(t) {
  return Math.sqrt(Math.pow(this.x - t.x, 2) + Math.pow(this.y - t.y, 2));
};
E0.prototype.equals = function(t) {
  return this.x === t.x && this.y === t.y && this.time === t.time;
};
function j7(t, e, n, r) {
  this.startPoint = t, this.control1 = e, this.control2 = n, this.endPoint = r;
}
j7.prototype.length = function() {
  for (var t = 10, e = 0, n = void 0, r = void 0, a = 0; a <= t; a += 1) {
    var i = a / t, o = this._point(i, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x), s = this._point(i, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
    if (a > 0) {
      var u = o - n, f = s - r;
      e += Math.sqrt(u * u + f * f);
    }
    n = o, r = s;
  }
  return e;
};
j7.prototype._point = function(t, e, n, r, a) {
  return e * (1 - t) * (1 - t) * (1 - t) + 3 * n * (1 - t) * (1 - t) * t + 3 * r * (1 - t) * t * t + a * t * t * t;
};
function pXe(t, e, n) {
  var r, a, i, o = null, s = 0;
  n || (n = {});
  var u = function() {
    s = n.leading === !1 ? 0 : Date.now(), o = null, i = t.apply(r, a), o || (r = a = null);
  };
  return function() {
    var f = Date.now();
    !s && n.leading === !1 && (s = f);
    var p = e - (f - s);
    return r = this, a = arguments, p <= 0 || p > e ? (o && (clearTimeout(o), o = null), s = f, i = t.apply(r, a), o || (r = a = null)) : !o && n.trailing !== !1 && (o = setTimeout(u, p)), i;
  };
}
function Za(t, e) {
  var n = this, r = e || {};
  this.velocityFilterWeight = r.velocityFilterWeight || 0.7, this.minWidth = r.minWidth || 0.5, this.maxWidth = r.maxWidth || 2.5, this.throttle = "throttle" in r ? r.throttle : 16, this.minDistance = "minDistance" in r ? r.minDistance : 5, this.throttle ? this._strokeMoveUpdate = pXe(Za.prototype._strokeUpdate, this.throttle) : this._strokeMoveUpdate = Za.prototype._strokeUpdate, this.dotSize = r.dotSize || function() {
    return (this.minWidth + this.maxWidth) / 2;
  }, this.penColor = r.penColor || "black", this.backgroundColor = r.backgroundColor || "rgba(0,0,0,0)", this.onBegin = r.onBegin, this.onEnd = r.onEnd, this._canvas = t, this._ctx = t.getContext("2d"), this.clear(), this._handleMouseDown = function(a) {
    a.which === 1 && (n._mouseButtonDown = !0, n._strokeBegin(a));
  }, this._handleMouseMove = function(a) {
    n._mouseButtonDown && n._strokeMoveUpdate(a);
  }, this._handleMouseUp = function(a) {
    a.which === 1 && n._mouseButtonDown && (n._mouseButtonDown = !1, n._strokeEnd(a));
  }, this._handleTouchStart = function(a) {
    if (a.targetTouches.length === 1) {
      var i = a.changedTouches[0];
      n._strokeBegin(i);
    }
  }, this._handleTouchMove = function(a) {
    a.preventDefault();
    var i = a.targetTouches[0];
    n._strokeMoveUpdate(i);
  }, this._handleTouchEnd = function(a) {
    var i = a.target === n._canvas;
    i && (a.preventDefault(), n._strokeEnd(a));
  }, this.on();
}
Za.prototype.clear = function() {
  var t = this._ctx, e = this._canvas;
  t.fillStyle = this.backgroundColor, t.clearRect(0, 0, e.width, e.height), t.fillRect(0, 0, e.width, e.height), this._data = [], this._reset(), this._isEmpty = !0;
};
Za.prototype.fromDataURL = function(t) {
  var e = this, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = new Image(), a = n.ratio || window.devicePixelRatio || 1, i = n.width || this._canvas.width / a, o = n.height || this._canvas.height / a;
  this._reset(), r.src = t, r.onload = function() {
    e._ctx.drawImage(r, 0, 0, i, o);
  }, this._isEmpty = !1;
};
Za.prototype.toDataURL = function(t) {
  var e;
  switch (t) {
    case "image/svg+xml":
      return this._toSVG();
    default:
      for (var n = arguments.length, r = Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++)
        r[a - 1] = arguments[a];
      return (e = this._canvas).toDataURL.apply(e, [t].concat(r));
  }
};
Za.prototype.on = function() {
  this._handleMouseEvents(), this._handleTouchEvents();
};
Za.prototype.off = function() {
  this._canvas.removeEventListener("mousedown", this._handleMouseDown), this._canvas.removeEventListener("mousemove", this._handleMouseMove), document.removeEventListener("mouseup", this._handleMouseUp), this._canvas.removeEventListener("touchstart", this._handleTouchStart), this._canvas.removeEventListener("touchmove", this._handleTouchMove), this._canvas.removeEventListener("touchend", this._handleTouchEnd);
};
Za.prototype.isEmpty = function() {
  return this._isEmpty;
};
Za.prototype._strokeBegin = function(t) {
  this._data.push([]), this._reset(), this._strokeUpdate(t), typeof this.onBegin == "function" && this.onBegin(t);
};
Za.prototype._strokeUpdate = function(t) {
  var e = t.clientX, n = t.clientY, r = this._createPoint(e, n), a = this._data[this._data.length - 1], i = a && a[a.length - 1], o = i && r.distanceTo(i) < this.minDistance;
  if (!(i && o)) {
    var s = this._addPoint(r), u = s.curve, f = s.widths;
    u && f && this._drawCurve(u, f.start, f.end), this._data[this._data.length - 1].push({
      x: r.x,
      y: r.y,
      time: r.time,
      color: this.penColor
    });
  }
};
Za.prototype._strokeEnd = function(t) {
  var e = this.points.length > 2, n = this.points[0];
  if (!e && n && this._drawDot(n), n) {
    var r = this._data[this._data.length - 1], a = r[r.length - 1];
    n.equals(a) || r.push({
      x: n.x,
      y: n.y,
      time: n.time,
      color: this.penColor
    });
  }
  typeof this.onEnd == "function" && this.onEnd(t);
};
Za.prototype._handleMouseEvents = function() {
  this._mouseButtonDown = !1, this._canvas.addEventListener("mousedown", this._handleMouseDown), this._canvas.addEventListener("mousemove", this._handleMouseMove), document.addEventListener("mouseup", this._handleMouseUp);
};
Za.prototype._handleTouchEvents = function() {
  this._canvas.style.msTouchAction = "none", this._canvas.style.touchAction = "none", this._canvas.addEventListener("touchstart", this._handleTouchStart), this._canvas.addEventListener("touchmove", this._handleTouchMove), this._canvas.addEventListener("touchend", this._handleTouchEnd);
};
Za.prototype._reset = function() {
  this.points = [], this._lastVelocity = 0, this._lastWidth = (this.minWidth + this.maxWidth) / 2, this._ctx.fillStyle = this.penColor;
};
Za.prototype._createPoint = function(t, e, n) {
  var r = this._canvas.getBoundingClientRect();
  return new E0(t - r.left, e - r.top, n || (/* @__PURE__ */ new Date()).getTime());
};
Za.prototype._addPoint = function(t) {
  var e = this.points, n = void 0;
  if (e.push(t), e.length > 2) {
    e.length === 3 && e.unshift(e[0]), n = this._calculateCurveControlPoints(e[0], e[1], e[2]);
    var r = n.c2;
    n = this._calculateCurveControlPoints(e[1], e[2], e[3]);
    var a = n.c1, i = new j7(e[1], r, a, e[2]), o = this._calculateCurveWidths(i);
    return e.shift(), { curve: i, widths: o };
  }
  return {};
};
Za.prototype._calculateCurveControlPoints = function(t, e, n) {
  var r = t.x - e.x, a = t.y - e.y, i = e.x - n.x, o = e.y - n.y, s = { x: (t.x + e.x) / 2, y: (t.y + e.y) / 2 }, u = { x: (e.x + n.x) / 2, y: (e.y + n.y) / 2 }, f = Math.sqrt(r * r + a * a), p = Math.sqrt(i * i + o * o), m = s.x - u.x, v = s.y - u.y, O = p / (f + p), w = { x: u.x + m * O, y: u.y + v * O }, _ = e.x - w.x, C = e.y - w.y;
  return {
    c1: new E0(s.x + _, s.y + C),
    c2: new E0(u.x + _, u.y + C)
  };
};
Za.prototype._calculateCurveWidths = function(t) {
  var e = t.startPoint, n = t.endPoint, r = { start: null, end: null }, a = this.velocityFilterWeight * n.velocityFrom(e) + (1 - this.velocityFilterWeight) * this._lastVelocity, i = this._strokeWidth(a);
  return r.start = this._lastWidth, r.end = i, this._lastVelocity = a, this._lastWidth = i, r;
};
Za.prototype._strokeWidth = function(t) {
  return Math.max(this.maxWidth / (t + 1), this.minWidth);
};
Za.prototype._drawPoint = function(t, e, n) {
  var r = this._ctx;
  r.moveTo(t, e), r.arc(t, e, n, 0, 2 * Math.PI, !1), this._isEmpty = !1;
};
Za.prototype._drawCurve = function(t, e, n) {
  var r = this._ctx, a = n - e, i = Math.floor(t.length());
  r.beginPath();
  for (var o = 0; o < i; o += 1) {
    var s = o / i, u = s * s, f = u * s, p = 1 - s, m = p * p, v = m * p, O = v * t.startPoint.x;
    O += 3 * m * s * t.control1.x, O += 3 * p * u * t.control2.x, O += f * t.endPoint.x;
    var w = v * t.startPoint.y;
    w += 3 * m * s * t.control1.y, w += 3 * p * u * t.control2.y, w += f * t.endPoint.y;
    var _ = e + f * a;
    this._drawPoint(O, w, _);
  }
  r.closePath(), r.fill();
};
Za.prototype._drawDot = function(t) {
  var e = this._ctx, n = typeof this.dotSize == "function" ? this.dotSize() : this.dotSize;
  e.beginPath(), this._drawPoint(t.x, t.y, n), e.closePath(), e.fill();
};
Za.prototype._fromData = function(t, e, n) {
  for (var r = 0; r < t.length; r += 1) {
    var a = t[r];
    if (a.length > 1)
      for (var i = 0; i < a.length; i += 1) {
        var o = a[i], s = new E0(o.x, o.y, o.time), u = o.color;
        if (i === 0)
          this.penColor = u, this._reset(), this._addPoint(s);
        else if (i !== a.length - 1) {
          var f = this._addPoint(s), p = f.curve, m = f.widths;
          p && m && e(p, m, u);
        }
      }
    else {
      this._reset();
      var v = a[0];
      n(v);
    }
  }
};
Za.prototype._toSVG = function() {
  var t = this, e = this._data, n = this._canvas, r = Math.max(window.devicePixelRatio || 1, 1), a = 0, i = 0, o = n.width / r, s = n.height / r, u = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  u.setAttributeNS(null, "width", n.width), u.setAttributeNS(null, "height", n.height), this._fromData(e, function(A, N, P) {
    var I = document.createElement("path");
    if (!isNaN(A.control1.x) && !isNaN(A.control1.y) && !isNaN(A.control2.x) && !isNaN(A.control2.y)) {
      var D = "M " + A.startPoint.x.toFixed(3) + "," + A.startPoint.y.toFixed(3) + " " + ("C " + A.control1.x.toFixed(3) + "," + A.control1.y.toFixed(3) + " ") + (A.control2.x.toFixed(3) + "," + A.control2.y.toFixed(3) + " ") + (A.endPoint.x.toFixed(3) + "," + A.endPoint.y.toFixed(3));
      I.setAttribute("d", D), I.setAttribute("stroke-width", (N.end * 2.25).toFixed(3)), I.setAttribute("stroke", P), I.setAttribute("fill", "none"), I.setAttribute("stroke-linecap", "round"), u.appendChild(I);
    }
  }, function(A) {
    var N = document.createElement("circle"), P = typeof t.dotSize == "function" ? t.dotSize() : t.dotSize;
    N.setAttribute("r", P), N.setAttribute("cx", A.x), N.setAttribute("cy", A.y), N.setAttribute("fill", A.color), u.appendChild(N);
  });
  var f = "data:image/svg+xml;base64,", p = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"' + (' viewBox="' + a + " " + i + " " + o + " " + s + '"') + (' width="' + o + '"') + (' height="' + s + '"') + ">", m = u.innerHTML;
  if (m === void 0) {
    var v = document.createElement("dummy"), O = u.childNodes;
    v.innerHTML = "";
    for (var w = 0; w < O.length; w += 1)
      v.appendChild(O[w].cloneNode(!0));
    m = v.innerHTML;
  }
  var _ = "</svg>", C = p + m + _;
  return f + btoa(C);
};
Za.prototype.fromData = function(t) {
  var e = this;
  this.clear(), this._fromData(t, function(n, r) {
    return e._drawCurve(n, r.start, r.end);
  }, function(n) {
    return e._drawDot(n);
  }), this._data = t;
};
Za.prototype.toData = function() {
  return this._data;
};
const hXe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Za
}, Symbol.toStringTag, { value: "Module" })), mXe = /* @__PURE__ */ na(hXe);
var fF = { exports: {} }, zee;
function gXe() {
  return zee || (zee = 1, function(t, e) {
    (function(n, r) {
      t.exports = r();
    })($b, function() {
      return function(n) {
        function r(i) {
          if (a[i])
            return a[i].exports;
          var o = a[i] = { exports: {}, id: i, loaded: !1 };
          return n[i].call(o.exports, o, o.exports, r), o.loaded = !0, o.exports;
        }
        var a = {};
        return r.m = n, r.c = a, r.p = "", r(0);
      }([function(n, r) {
        function a(f) {
          var p = f.getContext("2d"), m = f.width, v = f.height, O = p.getImageData(0, 0, m, v).data, w = s(!0, m, v, O), _ = s(!1, m, v, O), C = u(!0, m, v, O), A = u(!1, m, v, O), N = A - C + 1, P = _ - w + 1, I = p.getImageData(C, w, N, P);
          return f.width = N, f.height = P, p.clearRect(0, 0, N, P), p.putImageData(I, 0, 0), f;
        }
        function i(f, p, m, v) {
          return { red: v[4 * (m * p + f)], green: v[4 * (m * p + f) + 1], blue: v[4 * (m * p + f) + 2], alpha: v[4 * (m * p + f) + 3] };
        }
        function o(f, p, m, v) {
          return i(f, p, m, v).alpha;
        }
        function s(f, p, m, v) {
          for (var O = f ? 1 : -1, w = f ? 0 : m - 1, _ = w; f ? _ < m : _ > -1; _ += O)
            for (var C = 0; C < p; C++)
              if (o(C, _, p, v))
                return _;
          return null;
        }
        function u(f, p, m, v) {
          for (var O = f ? 1 : -1, w = f ? 0 : p - 1, _ = w; f ? _ < p : _ > -1; _ += O)
            for (var C = 0; C < m; C++)
              if (o(_, C, p, v))
                return _;
          return null;
        }
        Object.defineProperty(r, "__esModule", { value: !0 }), r.default = a;
      }]);
    });
  }(fF)), fF.exports;
}
(function(t, e) {
  (function(n, r) {
    t.exports = r(qf(), Ge, mXe, gXe());
  })($b, function(n, r, a, i) {
    return function(o) {
      function s(f) {
        if (u[f])
          return u[f].exports;
        var p = u[f] = { exports: {}, id: f, loaded: !1 };
        return o[f].call(p.exports, p, p.exports, s), p.loaded = !0, p.exports;
      }
      var u = {};
      return s.m = o, s.c = u, s.p = "", s(0);
    }([function(o, s, u) {
      function f(q) {
        return q && q.__esModule ? q : { default: q };
      }
      function p(q, Q) {
        var ne = {};
        for (var J in q)
          Q.indexOf(J) >= 0 || Object.prototype.hasOwnProperty.call(q, J) && (ne[J] = q[J]);
        return ne;
      }
      function m(q, Q) {
        if (!(q instanceof Q))
          throw new TypeError("Cannot call a class as a function");
      }
      function v(q, Q) {
        if (!q)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !Q || typeof Q != "object" && typeof Q != "function" ? q : Q;
      }
      function O(q, Q) {
        if (typeof Q != "function" && Q !== null)
          throw new TypeError("Super expression must either be null or a function, not " + typeof Q);
        q.prototype = Object.create(Q && Q.prototype, { constructor: { value: q, enumerable: !1, writable: !0, configurable: !0 } }), Q && (Object.setPrototypeOf ? Object.setPrototypeOf(q, Q) : q.__proto__ = Q);
      }
      Object.defineProperty(s, "__esModule", { value: !0 });
      var w = Object.assign || function(q) {
        for (var Q = 1; Q < arguments.length; Q++) {
          var ne = arguments[Q];
          for (var J in ne)
            Object.prototype.hasOwnProperty.call(ne, J) && (q[J] = ne[J]);
        }
        return q;
      }, _ = function() {
        function q(Q, ne) {
          for (var J = 0; J < ne.length; J++) {
            var ue = ne[J];
            ue.enumerable = ue.enumerable || !1, ue.configurable = !0, "value" in ue && (ue.writable = !0), Object.defineProperty(Q, ue.key, ue);
          }
        }
        return function(Q, ne, J) {
          return ne && q(Q.prototype, ne), J && q(Q, J), Q;
        };
      }(), C = u(1), A = f(C), N = u(2), P = f(N), I = u(3), D = f(I), M = u(4), H = f(M), Y = function(q) {
        function Q() {
          var ne, J, ue, ee;
          m(this, Q);
          for (var fe = arguments.length, de = Array(fe), ie = 0; ie < fe; ie++)
            de[ie] = arguments[ie];
          return J = ue = v(this, (ne = Q.__proto__ || Object.getPrototypeOf(Q)).call.apply(ne, [this].concat(de))), ue._sigPad = null, ue._excludeOurProps = function() {
            var le = ue.props, ye = (le.canvasProps, le.clearOnResize, p(le, ["canvasProps", "clearOnResize"]));
            return ye;
          }, ue.getCanvas = function() {
            return ue._canvas;
          }, ue.getTrimmedCanvas = function() {
            var le = document.createElement("canvas");
            return le.width = ue._canvas.width, le.height = ue._canvas.height, le.getContext("2d").drawImage(ue._canvas, 0, 0), (0, H.default)(le);
          }, ue.getSignaturePad = function() {
            return ue._sigPad;
          }, ue._checkClearOnResize = function() {
            ue.props.clearOnResize && ue._resizeCanvas();
          }, ue._resizeCanvas = function() {
            var le = ue.props.canvasProps || {}, ye = le.width, B = le.height;
            if (!ye || !B) {
              var pe = ue._canvas, _e = Math.max(window.devicePixelRatio || 1, 1);
              ye || (pe.width = pe.offsetWidth * _e), B || (pe.height = pe.offsetHeight * _e), pe.getContext("2d").scale(_e, _e), ue.clear();
            }
          }, ue.on = function() {
            return window.addEventListener("resize", ue._checkClearOnResize), ue._sigPad.on();
          }, ue.off = function() {
            return window.removeEventListener("resize", ue._checkClearOnResize), ue._sigPad.off();
          }, ue.clear = function() {
            return ue._sigPad.clear();
          }, ue.isEmpty = function() {
            return ue._sigPad.isEmpty();
          }, ue.fromDataURL = function(le, ye) {
            return ue._sigPad.fromDataURL(le, ye);
          }, ue.toDataURL = function(le, ye) {
            return ue._sigPad.toDataURL(le, ye);
          }, ue.fromData = function(le) {
            return ue._sigPad.fromData(le);
          }, ue.toData = function() {
            return ue._sigPad.toData();
          }, ee = J, v(ue, ee);
        }
        return O(Q, q), _(Q, [{ key: "componentDidMount", value: function() {
          this._sigPad = new D.default(this._canvas, this._excludeOurProps()), this._resizeCanvas(), this.on();
        } }, { key: "componentWillUnmount", value: function() {
          this.off();
        } }, { key: "componentDidUpdate", value: function() {
          Object.assign(this._sigPad, this._excludeOurProps());
        } }, { key: "render", value: function() {
          var ne = this, J = this.props.canvasProps;
          return P.default.createElement("canvas", w({ ref: function(ue) {
            ne._canvas = ue;
          } }, J));
        } }]), Q;
      }(N.Component);
      Y.propTypes = { velocityFilterWeight: A.default.number, minWidth: A.default.number, maxWidth: A.default.number, minDistance: A.default.number, dotSize: A.default.oneOfType([A.default.number, A.default.func]), penColor: A.default.string, throttle: A.default.number, onEnd: A.default.func, onBegin: A.default.func, canvasProps: A.default.object, clearOnResize: A.default.bool }, Y.defaultProps = { clearOnResize: !0 }, s.default = Y;
    }, function(o, s) {
      o.exports = n;
    }, function(o, s) {
      o.exports = r;
    }, function(o, s) {
      o.exports = a;
    }, function(o, s) {
      o.exports = i;
    }]);
  });
})(Rfe);
var bXe = Rfe.exports;
const vXe = /* @__PURE__ */ Pl(bXe), Hee = "byzzer-doodle", WXe = ({
  width: t,
  height: e,
  ...n
}) => {
  const [r, a] = kn(null), i = dr({}), o = () => {
    a(null), i.current.clear();
  }, s = () => {
    a(i.current.getTrimmedCanvas().toDataURL("image/png"));
  };
  return Vn(() => {
  }, [r]), /* @__PURE__ */ Ne.jsxs("div", { className: Hee, style: { width: t, height: e }, children: [
    /* @__PURE__ */ Ne.jsx(
      vXe,
      {
        ref: i,
        canvasProps: { width: t, height: e }
      }
    ),
    /* @__PURE__ */ Ne.jsxs("div", { className: `${Hee}__button-group`, children: [
      /* @__PURE__ */ Ne.jsx("button", { onClick: s, children: "Save" }),
      /* @__PURE__ */ Ne.jsx("button", { onClick: o, children: "Clear" })
    ] })
  ] });
};
export {
  lXe as $,
  a1 as A,
  wXe as B,
  Voe as C,
  TXe as D,
  Jd as E,
  k5 as F,
  BI as G,
  A5 as H,
  ii as I,
  xbe as J,
  _Xe as K,
  VE as L,
  xXe as M,
  zie as N,
  AXe as O,
  kXe as P,
  RXe as Q,
  IXe as R,
  DXe as S,
  i1 as T,
  wE as U,
  Bne as V,
  $5 as W,
  $De as X,
  BDe as Y,
  aXe as Z,
  iXe as _,
  ZE as a,
  B1e as a0,
  cXe as a1,
  fXe as a2,
  SN as a3,
  uXe as a4,
  HXe as a5,
  dXe as a6,
  WXe as a7,
  KI as a8,
  CXe as a9,
  Ane as aa,
  h$ as ab,
  DEe as ac,
  kne as ad,
  BE as ae,
  NEe as af,
  Vw as ag,
  qE as b,
  kk as c,
  GLe as d,
  hoe as e,
  d1 as f,
  $a as g,
  cLe as h,
  S_ as i,
  uLe as j,
  Xie as k,
  vI as l,
  Xu as m,
  use as n,
  qt as o,
  ft as p,
  Dse as q,
  Hie as r,
  c1 as s,
  ge as t,
  soe as u,
  Gf as v,
  R5 as w,
  S0 as x,
  Dme as y,
  ov as z
};
//# sourceMappingURL=index-f3ce9617.mjs.map
